import * as React from "react";
import React__default, { useContext, useMemo as useMemo$1, forwardRef, Component, createContext, useState, Suspense, memo, useRef, useCallback, useEffect, Fragment, PureComponent, isValidElement, useId, lazy, useLayoutEffect as useLayoutEffect$1, Profiler as Profiler$1, version, createRef, useSyncExternalStore, cloneElement } from "react";
import ReactDOM, { unstable_batchedUpdates, flushSync } from "react-dom";
function _mergeNamespaces(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    const IA = gA[AA];
    if (typeof IA != "string" && !Array.isArray(IA)) {
      for (const BA in IA)
        if (BA !== "default" && !(BA in CA)) {
          const QA = Object.getOwnPropertyDescriptor(IA, BA);
          QA && Object.defineProperty(CA, BA, QA.get ? QA : {
            enumerable: !0,
            get: () => IA[BA]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(CA, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(CA) {
  return CA && CA.__esModule && Object.prototype.hasOwnProperty.call(CA, "default") ? CA.default : CA;
}
function getAugmentedNamespace(CA) {
  if (Object.prototype.hasOwnProperty.call(CA, "__esModule")) return CA;
  var gA = CA.default;
  if (typeof gA == "function") {
    var AA = function IA() {
      var BA = !1;
      try {
        BA = this instanceof IA;
      } catch {
      }
      return BA ? Reflect.construct(gA, arguments, this.constructor) : gA.apply(this, arguments);
    };
    AA.prototype = gA.prototype;
  } else AA = {};
  return Object.defineProperty(AA, "__esModule", { value: !0 }), Object.keys(CA).forEach(function(IA) {
    var BA = Object.getOwnPropertyDescriptor(CA, IA);
    Object.defineProperty(AA, IA, BA.get ? BA : {
      enumerable: !0,
      get: function() {
        return CA[IA];
      }
    });
  }), AA;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var CA = React__default, gA = /* @__PURE__ */ Symbol.for("react.element"), AA = /* @__PURE__ */ Symbol.for("react.fragment"), IA = Object.prototype.hasOwnProperty, BA = CA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, QA = { key: !0, ref: !0, __self: !0, __source: !0 };
  function EA(iA, oA, cA) {
    var tA, eA = {}, aA = null, GA = null;
    cA !== void 0 && (aA = "" + cA), oA.key !== void 0 && (aA = "" + oA.key), oA.ref !== void 0 && (GA = oA.ref);
    for (tA in oA) IA.call(oA, tA) && !QA.hasOwnProperty(tA) && (eA[tA] = oA[tA]);
    if (iA && iA.defaultProps) for (tA in oA = iA.defaultProps, oA) eA[tA] === void 0 && (eA[tA] = oA[tA]);
    return { $$typeof: gA, type: iA, key: aA, ref: GA, props: eA, _owner: BA.current };
  }
  return reactJsxRuntime_production_min.Fragment = AA, reactJsxRuntime_production_min.jsx = EA, reactJsxRuntime_production_min.jsxs = EA, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var CA = React__default, gA = /* @__PURE__ */ Symbol.for("react.element"), AA = /* @__PURE__ */ Symbol.for("react.portal"), IA = /* @__PURE__ */ Symbol.for("react.fragment"), BA = /* @__PURE__ */ Symbol.for("react.strict_mode"), QA = /* @__PURE__ */ Symbol.for("react.profiler"), EA = /* @__PURE__ */ Symbol.for("react.provider"), iA = /* @__PURE__ */ Symbol.for("react.context"), oA = /* @__PURE__ */ Symbol.for("react.forward_ref"), cA = /* @__PURE__ */ Symbol.for("react.suspense"), tA = /* @__PURE__ */ Symbol.for("react.suspense_list"), eA = /* @__PURE__ */ Symbol.for("react.memo"), aA = /* @__PURE__ */ Symbol.for("react.lazy"), GA = /* @__PURE__ */ Symbol.for("react.offscreen"), lA = Symbol.iterator, nA = "@@iterator";
    function DA(MA) {
      if (MA === null || typeof MA != "object")
        return null;
      var jA = lA && MA[lA] || MA[nA];
      return typeof jA == "function" ? jA : null;
    }
    var hA = CA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function wA(MA) {
      {
        for (var jA = arguments.length, BI = new Array(jA > 1 ? jA - 1 : 0), aI = 1; aI < jA; aI++)
          BI[aI - 1] = arguments[aI];
        sA("error", MA, BI);
      }
    }
    function sA(MA, jA, BI) {
      {
        var aI = hA.ReactDebugCurrentFrame, dI = aI.getStackAddendum();
        dI !== "" && (jA += "%s", BI = BI.concat([dI]));
        var RI = BI.map(function(NI) {
          return String(NI);
        });
        RI.unshift("Warning: " + jA), Function.prototype.apply.call(console[MA], console, RI);
      }
    }
    var NA = !1, rA = !1, yA = !1, bA = !1, RA = !1, FA;
    FA = /* @__PURE__ */ Symbol.for("react.module.reference");
    function dA(MA) {
      return !!(typeof MA == "string" || typeof MA == "function" || MA === IA || MA === QA || RA || MA === BA || MA === cA || MA === tA || bA || MA === GA || NA || rA || yA || typeof MA == "object" && MA !== null && (MA.$$typeof === aA || MA.$$typeof === eA || MA.$$typeof === EA || MA.$$typeof === iA || MA.$$typeof === oA || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      MA.$$typeof === FA || MA.getModuleId !== void 0));
    }
    function kA(MA, jA, BI) {
      var aI = MA.displayName;
      if (aI)
        return aI;
      var dI = jA.displayName || jA.name || "";
      return dI !== "" ? BI + "(" + dI + ")" : BI;
    }
    function pA(MA) {
      return MA.displayName || "Context";
    }
    function YA(MA) {
      if (MA == null)
        return null;
      if (typeof MA.tag == "number" && wA("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof MA == "function")
        return MA.displayName || MA.name || null;
      if (typeof MA == "string")
        return MA;
      switch (MA) {
        case IA:
          return "Fragment";
        case AA:
          return "Portal";
        case QA:
          return "Profiler";
        case BA:
          return "StrictMode";
        case cA:
          return "Suspense";
        case tA:
          return "SuspenseList";
      }
      if (typeof MA == "object")
        switch (MA.$$typeof) {
          case iA:
            var jA = MA;
            return pA(jA) + ".Consumer";
          case EA:
            var BI = MA;
            return pA(BI._context) + ".Provider";
          case oA:
            return kA(MA, MA.render, "ForwardRef");
          case eA:
            var aI = MA.displayName || null;
            return aI !== null ? aI : YA(MA.type) || "Memo";
          case aA: {
            var dI = MA, RI = dI._payload, NI = dI._init;
            try {
              return YA(NI(RI));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var SA = Object.assign, JA = 0, UA, fA, zA, _A, uA, HA, TA;
    function ZA() {
    }
    ZA.__reactDisabledLog = !0;
    function AI() {
      {
        if (JA === 0) {
          UA = console.log, fA = console.info, zA = console.warn, _A = console.error, uA = console.group, HA = console.groupCollapsed, TA = console.groupEnd;
          var MA = {
            configurable: !0,
            enumerable: !0,
            value: ZA,
            writable: !0
          };
          Object.defineProperties(console, {
            info: MA,
            log: MA,
            warn: MA,
            error: MA,
            group: MA,
            groupCollapsed: MA,
            groupEnd: MA
          });
        }
        JA++;
      }
    }
    function QI() {
      {
        if (JA--, JA === 0) {
          var MA = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: SA({}, MA, {
              value: UA
            }),
            info: SA({}, MA, {
              value: fA
            }),
            warn: SA({}, MA, {
              value: zA
            }),
            error: SA({}, MA, {
              value: _A
            }),
            group: SA({}, MA, {
              value: uA
            }),
            groupCollapsed: SA({}, MA, {
              value: HA
            }),
            groupEnd: SA({}, MA, {
              value: TA
            })
          });
        }
        JA < 0 && wA("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var LA = hA.ReactCurrentDispatcher, PA;
    function XA(MA, jA, BI) {
      {
        if (PA === void 0)
          try {
            throw Error();
          } catch (dI) {
            var aI = dI.stack.trim().match(/\n( *(at )?)/);
            PA = aI && aI[1] || "";
          }
        return `
` + PA + MA;
      }
    }
    var EI = !1, CI;
    {
      var II = typeof WeakMap == "function" ? WeakMap : Map;
      CI = new II();
    }
    function vA(MA, jA) {
      if (!MA || EI)
        return "";
      {
        var BI = CI.get(MA);
        if (BI !== void 0)
          return BI;
      }
      var aI;
      EI = !0;
      var dI = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var RI;
      RI = LA.current, LA.current = null, AI();
      try {
        if (jA) {
          var NI = function() {
            throw Error();
          };
          if (Object.defineProperty(NI.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(NI, []);
            } catch (KI) {
              aI = KI;
            }
            Reflect.construct(MA, [], NI);
          } else {
            try {
              NI.call();
            } catch (KI) {
              aI = KI;
            }
            MA.call(NI.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (KI) {
            aI = KI;
          }
          MA();
        }
      } catch (KI) {
        if (KI && aI && typeof KI.stack == "string") {
          for (var sI = KI.stack.split(`
`), LI = aI.stack.split(`
`), ZI = sI.length - 1, MI = LI.length - 1; ZI >= 1 && MI >= 0 && sI[ZI] !== LI[MI]; )
            MI--;
          for (; ZI >= 1 && MI >= 0; ZI--, MI--)
            if (sI[ZI] !== LI[MI]) {
              if (ZI !== 1 || MI !== 1)
                do
                  if (ZI--, MI--, MI < 0 || sI[ZI] !== LI[MI]) {
                    var VI = `
` + sI[ZI].replace(" at new ", " at ");
                    return MA.displayName && VI.includes("<anonymous>") && (VI = VI.replace("<anonymous>", MA.displayName)), typeof MA == "function" && CI.set(MA, VI), VI;
                  }
                while (ZI >= 1 && MI >= 0);
              break;
            }
        }
      } finally {
        EI = !1, LA.current = RI, QI(), Error.prepareStackTrace = dI;
      }
      var Ag = MA ? MA.displayName || MA.name : "", OI = Ag ? XA(Ag) : "";
      return typeof MA == "function" && CI.set(MA, OI), OI;
    }
    function wI(MA, jA, BI) {
      return vA(MA, !1);
    }
    function $A(MA) {
      var jA = MA.prototype;
      return !!(jA && jA.isReactComponent);
    }
    function YI(MA, jA, BI) {
      if (MA == null)
        return "";
      if (typeof MA == "function")
        return vA(MA, $A(MA));
      if (typeof MA == "string")
        return XA(MA);
      switch (MA) {
        case cA:
          return XA("Suspense");
        case tA:
          return XA("SuspenseList");
      }
      if (typeof MA == "object")
        switch (MA.$$typeof) {
          case oA:
            return wI(MA.render);
          case eA:
            return YI(MA.type, jA, BI);
          case aA: {
            var aI = MA, dI = aI._payload, RI = aI._init;
            try {
              return YI(RI(dI), jA, BI);
            } catch {
            }
          }
        }
      return "";
    }
    var FI = Object.prototype.hasOwnProperty, nI = {}, uI = hA.ReactDebugCurrentFrame;
    function hI(MA) {
      if (MA) {
        var jA = MA._owner, BI = YI(MA.type, MA._source, jA ? jA.type : null);
        uI.setExtraStackFrame(BI);
      } else
        uI.setExtraStackFrame(null);
    }
    function bI(MA, jA, BI, aI, dI) {
      {
        var RI = Function.call.bind(FI);
        for (var NI in MA)
          if (RI(MA, NI)) {
            var sI = void 0;
            try {
              if (typeof MA[NI] != "function") {
                var LI = Error((aI || "React class") + ": " + BI + " type `" + NI + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof MA[NI] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw LI.name = "Invariant Violation", LI;
              }
              sI = MA[NI](jA, NI, aI, BI, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ZI) {
              sI = ZI;
            }
            sI && !(sI instanceof Error) && (hI(dI), wA("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", aI || "React class", BI, NI, typeof sI), hI(null)), sI instanceof Error && !(sI.message in nI) && (nI[sI.message] = !0, hI(dI), wA("Failed %s type: %s", BI, sI.message), hI(null));
          }
      }
    }
    var HI = Array.isArray;
    function UI(MA) {
      return HI(MA);
    }
    function pI(MA) {
      {
        var jA = typeof Symbol == "function" && Symbol.toStringTag, BI = jA && MA[Symbol.toStringTag] || MA.constructor.name || "Object";
        return BI;
      }
    }
    function mI(MA) {
      try {
        return rI(MA), !1;
      } catch {
        return !0;
      }
    }
    function rI(MA) {
      return "" + MA;
    }
    function KA(MA) {
      if (mI(MA))
        return wA("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pI(MA)), rI(MA);
    }
    var OA = hA.ReactCurrentOwner, iI = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tI, GI;
    function oI(MA) {
      if (FI.call(MA, "ref")) {
        var jA = Object.getOwnPropertyDescriptor(MA, "ref").get;
        if (jA && jA.isReactWarning)
          return !1;
      }
      return MA.ref !== void 0;
    }
    function eI(MA) {
      if (FI.call(MA, "key")) {
        var jA = Object.getOwnPropertyDescriptor(MA, "key").get;
        if (jA && jA.isReactWarning)
          return !1;
      }
      return MA.key !== void 0;
    }
    function gI(MA, jA) {
      typeof MA.ref == "string" && OA.current;
    }
    function mA(MA, jA) {
      {
        var BI = function() {
          tI || (tI = !0, wA("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", jA));
        };
        BI.isReactWarning = !0, Object.defineProperty(MA, "key", {
          get: BI,
          configurable: !0
        });
      }
    }
    function WA(MA, jA) {
      {
        var BI = function() {
          GI || (GI = !0, wA("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", jA));
        };
        BI.isReactWarning = !0, Object.defineProperty(MA, "ref", {
          get: BI,
          configurable: !0
        });
      }
    }
    var xA = function(MA, jA, BI, aI, dI, RI, NI) {
      var sI = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: gA,
        // Built-in properties that belong on the element
        type: MA,
        key: jA,
        ref: BI,
        props: NI,
        // Record the component responsible for creating this element.
        _owner: RI
      };
      return sI._store = {}, Object.defineProperty(sI._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(sI, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: aI
      }), Object.defineProperty(sI, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: dI
      }), Object.freeze && (Object.freeze(sI.props), Object.freeze(sI)), sI;
    };
    function qA(MA, jA, BI, aI, dI) {
      {
        var RI, NI = {}, sI = null, LI = null;
        BI !== void 0 && (KA(BI), sI = "" + BI), eI(jA) && (KA(jA.key), sI = "" + jA.key), oI(jA) && (LI = jA.ref, gI(jA, dI));
        for (RI in jA)
          FI.call(jA, RI) && !iI.hasOwnProperty(RI) && (NI[RI] = jA[RI]);
        if (MA && MA.defaultProps) {
          var ZI = MA.defaultProps;
          for (RI in ZI)
            NI[RI] === void 0 && (NI[RI] = ZI[RI]);
        }
        if (sI || LI) {
          var MI = typeof MA == "function" ? MA.displayName || MA.name || "Unknown" : MA;
          sI && mA(NI, MI), LI && WA(NI, MI);
        }
        return xA(MA, sI, LI, dI, aI, OA.current, NI);
      }
    }
    var VA = hA.ReactCurrentOwner, cI = hA.ReactDebugCurrentFrame;
    function DI(MA) {
      if (MA) {
        var jA = MA._owner, BI = YI(MA.type, MA._source, jA ? jA.type : null);
        cI.setExtraStackFrame(BI);
      } else
        cI.setExtraStackFrame(null);
    }
    var JI;
    JI = !1;
    function kI(MA) {
      return typeof MA == "object" && MA !== null && MA.$$typeof === gA;
    }
    function fI() {
      {
        if (VA.current) {
          var MA = YA(VA.current.type);
          if (MA)
            return `

Check the render method of \`` + MA + "`.";
        }
        return "";
      }
    }
    function _I(MA) {
      return "";
    }
    var qI = {};
    function Dg(MA) {
      {
        var jA = fI();
        if (!jA) {
          var BI = typeof MA == "string" ? MA : MA.displayName || MA.name;
          BI && (jA = `

Check the top-level render call using <` + BI + ">.");
        }
        return jA;
      }
    }
    function vI(MA, jA) {
      {
        if (!MA._store || MA._store.validated || MA.key != null)
          return;
        MA._store.validated = !0;
        var BI = Dg(jA);
        if (qI[BI])
          return;
        qI[BI] = !0;
        var aI = "";
        MA && MA._owner && MA._owner !== VA.current && (aI = " It was passed a child from " + YA(MA._owner.type) + "."), DI(MA), wA('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', BI, aI), DI(null);
      }
    }
    function wg(MA, jA) {
      {
        if (typeof MA != "object")
          return;
        if (UI(MA))
          for (var BI = 0; BI < MA.length; BI++) {
            var aI = MA[BI];
            kI(aI) && vI(aI, jA);
          }
        else if (kI(MA))
          MA._store && (MA._store.validated = !0);
        else if (MA) {
          var dI = DA(MA);
          if (typeof dI == "function" && dI !== MA.entries)
            for (var RI = dI.call(MA), NI; !(NI = RI.next()).done; )
              kI(NI.value) && vI(NI.value, jA);
        }
      }
    }
    function sg(MA) {
      {
        var jA = MA.type;
        if (jA == null || typeof jA == "string")
          return;
        var BI;
        if (typeof jA == "function")
          BI = jA.propTypes;
        else if (typeof jA == "object" && (jA.$$typeof === oA || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        jA.$$typeof === eA))
          BI = jA.propTypes;
        else
          return;
        if (BI) {
          var aI = YA(jA);
          bI(BI, MA.props, "prop", aI, MA);
        } else if (jA.PropTypes !== void 0 && !JI) {
          JI = !0;
          var dI = YA(jA);
          wA("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", dI || "Unknown");
        }
        typeof jA.getDefaultProps == "function" && !jA.getDefaultProps.isReactClassApproved && wA("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Eg(MA) {
      {
        for (var jA = Object.keys(MA.props), BI = 0; BI < jA.length; BI++) {
          var aI = jA[BI];
          if (aI !== "children" && aI !== "key") {
            DI(MA), wA("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", aI), DI(null);
            break;
          }
        }
        MA.ref !== null && (DI(MA), wA("Invalid attribute `ref` supplied to `React.Fragment`."), DI(null));
      }
    }
    var hg = {};
    function ig(MA, jA, BI, aI, dI, RI) {
      {
        var NI = dA(MA);
        if (!NI) {
          var sI = "";
          (MA === void 0 || typeof MA == "object" && MA !== null && Object.keys(MA).length === 0) && (sI += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var LI = _I();
          LI ? sI += LI : sI += fI();
          var ZI;
          MA === null ? ZI = "null" : UI(MA) ? ZI = "array" : MA !== void 0 && MA.$$typeof === gA ? (ZI = "<" + (YA(MA.type) || "Unknown") + " />", sI = " Did you accidentally export a JSX literal instead of a component?") : ZI = typeof MA, wA("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ZI, sI);
        }
        var MI = qA(MA, jA, BI, dI, RI);
        if (MI == null)
          return MI;
        if (NI) {
          var VI = jA.children;
          if (VI !== void 0)
            if (aI)
              if (UI(VI)) {
                for (var Ag = 0; Ag < VI.length; Ag++)
                  wg(VI[Ag], MA);
                Object.freeze && Object.freeze(VI);
              } else
                wA("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wg(VI, MA);
        }
        if (FI.call(jA, "key")) {
          var OI = YA(MA), KI = Object.keys(jA).filter(function(Sg) {
            return Sg !== "key";
          }), rg = KI.length > 0 ? "{key: someKey, " + KI.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!hg[OI + rg]) {
            var Zg = KI.length > 0 ? "{" + KI.join(": ..., ") + ": ...}" : "{}";
            wA(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rg, OI, Zg, OI), hg[OI + rg] = !0;
          }
        }
        return MA === IA ? Eg(MI) : sg(MI), MI;
      }
    }
    function lI(MA, jA, BI) {
      return ig(MA, jA, BI, !0);
    }
    function yI(MA, jA, BI) {
      return ig(MA, jA, BI, !1);
    }
    var SI = yI, xI = lI;
    reactJsxRuntime_development.Fragment = IA, reactJsxRuntime_development.jsx = SI, reactJsxRuntime_development.jsxs = xI;
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), loglevel$1 = { exports: {} }, loglevel = loglevel$1.exports, hasRequiredLoglevel;
function requireLoglevel() {
  return hasRequiredLoglevel || (hasRequiredLoglevel = 1, (function(CA) {
    (function(gA, AA) {
      CA.exports ? CA.exports = AA() : gA.log = AA();
    })(loglevel, function() {
      var gA = function() {
      }, AA = "undefined", IA = typeof window !== AA && typeof window.navigator !== AA && /Trident\/|MSIE /.test(window.navigator.userAgent), BA = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], QA = {}, EA = null;
      function iA(nA, DA) {
        var hA = nA[DA];
        if (typeof hA.bind == "function")
          return hA.bind(nA);
        try {
          return Function.prototype.bind.call(hA, nA);
        } catch {
          return function() {
            return Function.prototype.apply.apply(hA, [nA, arguments]);
          };
        }
      }
      function oA() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function cA(nA) {
        return nA === "debug" && (nA = "log"), typeof console === AA ? !1 : nA === "trace" && IA ? oA : console[nA] !== void 0 ? iA(console, nA) : console.log !== void 0 ? iA(console, "log") : gA;
      }
      function tA() {
        for (var nA = this.getLevel(), DA = 0; DA < BA.length; DA++) {
          var hA = BA[DA];
          this[hA] = DA < nA ? gA : this.methodFactory(hA, nA, this.name);
        }
        if (this.log = this.debug, typeof console === AA && nA < this.levels.SILENT)
          return "No console available for logging";
      }
      function eA(nA) {
        return function() {
          typeof console !== AA && (tA.call(this), this[nA].apply(this, arguments));
        };
      }
      function aA(nA, DA, hA) {
        return cA(nA) || eA.apply(this, arguments);
      }
      function GA(nA, DA) {
        var hA = this, wA, sA, NA, rA = "loglevel";
        typeof nA == "string" ? rA += ":" + nA : typeof nA == "symbol" && (rA = void 0);
        function yA(kA) {
          var pA = (BA[kA] || "silent").toUpperCase();
          if (!(typeof window === AA || !rA)) {
            try {
              window.localStorage[rA] = pA;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(rA) + "=" + pA + ";";
            } catch {
            }
          }
        }
        function bA() {
          var kA;
          if (!(typeof window === AA || !rA)) {
            try {
              kA = window.localStorage[rA];
            } catch {
            }
            if (typeof kA === AA)
              try {
                var pA = window.document.cookie, YA = encodeURIComponent(rA), SA = pA.indexOf(YA + "=");
                SA !== -1 && (kA = /^([^;]+)/.exec(
                  pA.slice(SA + YA.length + 1)
                )[1]);
              } catch {
              }
            return hA.levels[kA] === void 0 && (kA = void 0), kA;
          }
        }
        function RA() {
          if (!(typeof window === AA || !rA)) {
            try {
              window.localStorage.removeItem(rA);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(rA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function FA(kA) {
          var pA = kA;
          if (typeof pA == "string" && hA.levels[pA.toUpperCase()] !== void 0 && (pA = hA.levels[pA.toUpperCase()]), typeof pA == "number" && pA >= 0 && pA <= hA.levels.SILENT)
            return pA;
          throw new TypeError("log.setLevel() called with invalid level: " + kA);
        }
        hA.name = nA, hA.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, hA.methodFactory = DA || aA, hA.getLevel = function() {
          return NA ?? sA ?? wA;
        }, hA.setLevel = function(kA, pA) {
          return NA = FA(kA), pA !== !1 && yA(NA), tA.call(hA);
        }, hA.setDefaultLevel = function(kA) {
          sA = FA(kA), bA() || hA.setLevel(kA, !1);
        }, hA.resetLevel = function() {
          NA = null, RA(), tA.call(hA);
        }, hA.enableAll = function(kA) {
          hA.setLevel(hA.levels.TRACE, kA);
        }, hA.disableAll = function(kA) {
          hA.setLevel(hA.levels.SILENT, kA);
        }, hA.rebuild = function() {
          if (EA !== hA && (wA = FA(EA.getLevel())), tA.call(hA), EA === hA)
            for (var kA in QA)
              QA[kA].rebuild();
        }, wA = FA(
          EA ? EA.getLevel() : "WARN"
        );
        var dA = bA();
        dA != null && (NA = FA(dA)), tA.call(hA);
      }
      EA = new GA(), EA.getLogger = function(DA) {
        if (typeof DA != "symbol" && typeof DA != "string" || DA === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var hA = QA[DA];
        return hA || (hA = QA[DA] = new GA(
          DA,
          EA.methodFactory
        )), hA;
      };
      var lA = typeof window !== AA ? window.log : void 0;
      return EA.noConflict = function() {
        return typeof window !== AA && window.log === EA && (window.log = lA), EA;
      }, EA.getLoggers = function() {
        return QA;
      }, EA.default = EA, EA;
    });
  })(loglevel$1)), loglevel$1.exports;
}
var loglevelExports = requireLoglevel();
const log = /* @__PURE__ */ getDefaultExportFromCjs(loglevelExports), StliteKernelContext = React__default.createContext(void 0), Provider$2 = StliteKernelContext.Provider;
function StliteKernelProvider(CA) {
  const {
    children: gA,
    kernel: AA
  } = CA, IA = useMemo$1(() => ({
    kernel: AA
  }), [AA]);
  return jsxRuntimeExports.jsx(Provider$2, {
    value: IA,
    children: gA
  });
}
function useStliteKernel() {
  const CA = useContext(StliteKernelContext);
  if (CA == null)
    throw new Error("useStliteKernel() must be inside <StliteKernelProvider />");
  return CA.kernel;
}
function sheetForTag(CA) {
  if (CA.sheet)
    return CA.sheet;
  for (var gA = 0; gA < document.styleSheets.length; gA++)
    if (document.styleSheets[gA].ownerNode === CA)
      return document.styleSheets[gA];
}
function createStyleElement(CA) {
  var gA = document.createElement("style");
  return gA.setAttribute("data-emotion", CA.key), CA.nonce !== void 0 && gA.setAttribute("nonce", CA.nonce), gA.appendChild(document.createTextNode("")), gA.setAttribute("data-s", ""), gA;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function CA(AA) {
    var IA = this;
    this._insertTag = function(BA) {
      var QA;
      IA.tags.length === 0 ? IA.insertionPoint ? QA = IA.insertionPoint.nextSibling : IA.prepend ? QA = IA.container.firstChild : QA = IA.before : QA = IA.tags[IA.tags.length - 1].nextSibling, IA.container.insertBefore(BA, QA), IA.tags.push(BA);
    }, this.isSpeedy = AA.speedy === void 0 ? !0 : AA.speedy, this.tags = [], this.ctr = 0, this.nonce = AA.nonce, this.key = AA.key, this.container = AA.container, this.prepend = AA.prepend, this.insertionPoint = AA.insertionPoint, this.before = null;
  }
  var gA = CA.prototype;
  return gA.hydrate = function(IA) {
    IA.forEach(this._insertTag);
  }, gA.insert = function(IA) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var BA = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var QA = sheetForTag(BA);
      try {
        QA.insertRule(IA, QA.cssRules.length);
      } catch {
      }
    } else
      BA.appendChild(document.createTextNode(IA));
    this.ctr++;
  }, gA.flush = function() {
    this.tags.forEach(function(IA) {
      var BA;
      return (BA = IA.parentNode) == null ? void 0 : BA.removeChild(IA);
    }), this.tags = [], this.ctr = 0;
  }, CA;
})(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$1 = Object.assign;
function hash$1(CA, gA) {
  return charat(CA, 0) ^ 45 ? (((gA << 2 ^ charat(CA, 0)) << 2 ^ charat(CA, 1)) << 2 ^ charat(CA, 2)) << 2 ^ charat(CA, 3) : 0;
}
function trim(CA) {
  return CA.trim();
}
function match(CA, gA) {
  return (CA = gA.exec(CA)) ? CA[0] : CA;
}
function replace$1(CA, gA, AA) {
  return CA.replace(gA, AA);
}
function indexof(CA, gA) {
  return CA.indexOf(gA);
}
function charat(CA, gA) {
  return CA.charCodeAt(gA) | 0;
}
function substr(CA, gA, AA) {
  return CA.slice(gA, AA);
}
function strlen(CA) {
  return CA.length;
}
function sizeof(CA) {
  return CA.length;
}
function append(CA, gA) {
  return gA.push(CA), CA;
}
function combine(CA, gA) {
  return CA.map(gA).join("");
}
var line = 1, column = 1, length = 0, position$3 = 0, character = 0, characters = "";
function node$1(CA, gA, AA, IA, BA, QA, EA) {
  return { value: CA, root: gA, parent: AA, type: IA, props: BA, children: QA, line, column, length: EA, return: "" };
}
function copy(CA, gA) {
  return assign$1(node$1("", null, null, "", null, null, 0), CA, { length: -CA.length }, gA);
}
function char() {
  return character;
}
function prev() {
  return character = position$3 > 0 ? charat(characters, --position$3) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position$3 < length ? charat(characters, position$3++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek$1() {
  return charat(characters, position$3);
}
function caret() {
  return position$3;
}
function slice(CA, gA) {
  return substr(characters, CA, gA);
}
function token$1(CA) {
  switch (CA) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(CA) {
  return line = column = 1, length = strlen(characters = CA), position$3 = 0, [];
}
function dealloc(CA) {
  return characters = "", CA;
}
function delimit(CA) {
  return trim(slice(position$3 - 1, delimiter(CA === 91 ? CA + 2 : CA === 40 ? CA + 1 : CA)));
}
function whitespace$1(CA) {
  for (; (character = peek$1()) && character < 33; )
    next();
  return token$1(CA) > 2 || token$1(character) > 3 ? "" : " ";
}
function escaping(CA, gA) {
  for (; --gA && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(CA, caret() + (gA < 6 && peek$1() == 32 && next() == 32));
}
function delimiter(CA) {
  for (; next(); )
    switch (character) {
      // ] ) " '
      case CA:
        return position$3;
      // " '
      case 34:
      case 39:
        CA !== 34 && CA !== 39 && delimiter(character);
        break;
      // (
      case 40:
        CA === 41 && delimiter(CA);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position$3;
}
function commenter(CA, gA) {
  for (; next() && CA + character !== 57; )
    if (CA + character === 84 && peek$1() === 47)
      break;
  return "/*" + slice(gA, position$3 - 1) + "*" + from(CA === 47 ? CA : next());
}
function identifier(CA) {
  for (; !token$1(peek$1()); )
    next();
  return slice(CA, position$3);
}
function compile(CA) {
  return dealloc(parse$4("", null, null, null, [""], CA = alloc(CA), 0, [0], CA));
}
function parse$4(CA, gA, AA, IA, BA, QA, EA, iA, oA) {
  for (var cA = 0, tA = 0, eA = EA, aA = 0, GA = 0, lA = 0, nA = 1, DA = 1, hA = 1, wA = 0, sA = "", NA = BA, rA = QA, yA = IA, bA = sA; DA; )
    switch (lA = wA, wA = next()) {
      // (
      case 40:
        if (lA != 108 && charat(bA, eA - 1) == 58) {
          indexof(bA += replace$1(delimit(wA), "&", "&\f"), "&\f") != -1 && (hA = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        bA += delimit(wA);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        bA += whitespace$1(lA);
        break;
      // \
      case 92:
        bA += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$1()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), gA, AA), oA);
            break;
          default:
            bA += "/";
        }
        break;
      // {
      case 123 * nA:
        iA[cA++] = strlen(bA) * hA;
      // } ; \0
      case 125 * nA:
      case 59:
      case 0:
        switch (wA) {
          // \0 }
          case 0:
          case 125:
            DA = 0;
          // ;
          case 59 + tA:
            hA == -1 && (bA = replace$1(bA, /\f/g, "")), GA > 0 && strlen(bA) - eA && append(GA > 32 ? declaration(bA + ";", IA, AA, eA - 1) : declaration(replace$1(bA, " ", "") + ";", IA, AA, eA - 2), oA);
            break;
          // @ ;
          case 59:
            bA += ";";
          // { rule/at-rule
          default:
            if (append(yA = ruleset(bA, gA, AA, cA, tA, BA, iA, sA, NA = [], rA = [], eA), QA), wA === 123)
              if (tA === 0)
                parse$4(bA, gA, yA, yA, NA, QA, eA, iA, rA);
              else
                switch (aA === 99 && charat(bA, 3) === 110 ? 100 : aA) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$4(CA, yA, yA, IA && append(ruleset(CA, yA, yA, 0, 0, BA, iA, sA, BA, NA = [], eA), rA), BA, rA, eA, iA, IA ? NA : rA);
                    break;
                  default:
                    parse$4(bA, yA, yA, yA, [""], rA, 0, iA, rA);
                }
        }
        cA = tA = GA = 0, nA = hA = 1, sA = bA = "", eA = EA;
        break;
      // :
      case 58:
        eA = 1 + strlen(bA), GA = lA;
      default:
        if (nA < 1) {
          if (wA == 123)
            --nA;
          else if (wA == 125 && nA++ == 0 && prev() == 125)
            continue;
        }
        switch (bA += from(wA), wA * nA) {
          // &
          case 38:
            hA = tA > 0 ? 1 : (bA += "\f", -1);
            break;
          // ,
          case 44:
            iA[cA++] = (strlen(bA) - 1) * hA, hA = 1;
            break;
          // @
          case 64:
            peek$1() === 45 && (bA += delimit(next())), aA = peek$1(), tA = eA = strlen(sA = bA += identifier(caret())), wA++;
            break;
          // -
          case 45:
            lA === 45 && strlen(bA) == 2 && (nA = 0);
        }
    }
  return QA;
}
function ruleset(CA, gA, AA, IA, BA, QA, EA, iA, oA, cA, tA) {
  for (var eA = BA - 1, aA = BA === 0 ? QA : [""], GA = sizeof(aA), lA = 0, nA = 0, DA = 0; lA < IA; ++lA)
    for (var hA = 0, wA = substr(CA, eA + 1, eA = abs(nA = EA[lA])), sA = CA; hA < GA; ++hA)
      (sA = trim(nA > 0 ? aA[hA] + " " + wA : replace$1(wA, /&\f/g, aA[hA]))) && (oA[DA++] = sA);
  return node$1(CA, gA, AA, BA === 0 ? RULESET : iA, oA, cA, tA);
}
function comment(CA, gA, AA) {
  return node$1(CA, gA, AA, COMMENT, from(char()), substr(CA, 2, -2), 0);
}
function declaration(CA, gA, AA, IA) {
  return node$1(CA, gA, AA, DECLARATION, substr(CA, 0, IA), substr(CA, IA + 1, -1), IA);
}
function serialize$2(CA, gA) {
  for (var AA = "", IA = sizeof(CA), BA = 0; BA < IA; BA++)
    AA += gA(CA[BA], BA, CA, gA) || "";
  return AA;
}
function stringify$3(CA, gA, AA, IA) {
  switch (CA.type) {
    case LAYER:
      if (CA.children.length) break;
    case IMPORT:
    case DECLARATION:
      return CA.return = CA.return || CA.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return CA.return = CA.value + "{" + serialize$2(CA.children, IA) + "}";
    case RULESET:
      CA.value = CA.props.join(",");
  }
  return strlen(AA = serialize$2(CA.children, IA)) ? CA.return = CA.value + "{" + AA + "}" : "";
}
function middleware(CA) {
  var gA = sizeof(CA);
  return function(AA, IA, BA, QA) {
    for (var EA = "", iA = 0; iA < gA; iA++)
      EA += CA[iA](AA, IA, BA, QA) || "";
    return EA;
  };
}
function rulesheet(CA) {
  return function(gA) {
    gA.root || (gA = gA.return) && CA(gA);
  };
}
var weakMemoize = function(gA) {
  var AA = /* @__PURE__ */ new WeakMap();
  return function(IA) {
    if (AA.has(IA))
      return AA.get(IA);
    var BA = gA(IA);
    return AA.set(IA, BA), BA;
  };
};
function memoize$1(CA) {
  var gA = /* @__PURE__ */ Object.create(null);
  return function(AA) {
    return gA[AA] === void 0 && (gA[AA] = CA(AA)), gA[AA];
  };
}
var identifierWithPointTracking = function(gA, AA, IA) {
  for (var BA = 0, QA = 0; BA = QA, QA = peek$1(), BA === 38 && QA === 12 && (AA[IA] = 1), !token$1(QA); )
    next();
  return slice(gA, position$3);
}, toRules = function(gA, AA) {
  var IA = -1, BA = 44;
  do
    switch (token$1(BA)) {
      case 0:
        BA === 38 && peek$1() === 12 && (AA[IA] = 1), gA[IA] += identifierWithPointTracking(position$3 - 1, AA, IA);
        break;
      case 2:
        gA[IA] += delimit(BA);
        break;
      case 4:
        if (BA === 44) {
          gA[++IA] = peek$1() === 58 ? "&\f" : "", AA[IA] = gA[IA].length;
          break;
        }
      // fallthrough
      default:
        gA[IA] += from(BA);
    }
  while (BA = next());
  return gA;
}, getRules = function(gA, AA) {
  return dealloc(toRules(alloc(gA), AA));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(gA) {
  if (!(gA.type !== "rule" || !gA.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  gA.length < 1)) {
    for (var AA = gA.value, IA = gA.parent, BA = gA.column === IA.column && gA.line === IA.line; IA.type !== "rule"; )
      if (IA = IA.parent, !IA) return;
    if (!(gA.props.length === 1 && AA.charCodeAt(0) !== 58 && !fixedElements.get(IA)) && !BA) {
      fixedElements.set(gA, !0);
      for (var QA = [], EA = getRules(AA, QA), iA = IA.props, oA = 0, cA = 0; oA < EA.length; oA++)
        for (var tA = 0; tA < iA.length; tA++, cA++)
          gA.props[cA] = QA[oA] ? EA[oA].replace(/&\f/g, iA[tA]) : iA[tA] + " " + EA[oA];
    }
  }
}, removeLabel = function(gA) {
  if (gA.type === "decl") {
    var AA = gA.value;
    // charcode for l
    AA.charCodeAt(0) === 108 && // charcode for b
    AA.charCodeAt(2) === 98 && (gA.return = "", gA.value = "");
  }
};
function prefix$1(CA, gA) {
  switch (hash$1(CA, gA)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + CA + CA;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + CA + CA;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + CA + MOZ + CA + MS + CA + CA;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + CA + MS + CA + CA;
    // order
    case 6165:
      return WEBKIT + CA + MS + "flex-" + CA + CA;
    // align-items
    case 5187:
      return WEBKIT + CA + replace$1(CA, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + CA;
    // align-self
    case 5443:
      return WEBKIT + CA + MS + "flex-item-" + replace$1(CA, /flex-|-self/, "") + CA;
    // align-content
    case 4675:
      return WEBKIT + CA + MS + "flex-line-pack" + replace$1(CA, /align-content|flex-|-self/, "") + CA;
    // flex-shrink
    case 5548:
      return WEBKIT + CA + MS + replace$1(CA, "shrink", "negative") + CA;
    // flex-basis
    case 5292:
      return WEBKIT + CA + MS + replace$1(CA, "basis", "preferred-size") + CA;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace$1(CA, "-grow", "") + WEBKIT + CA + MS + replace$1(CA, "grow", "positive") + CA;
    // transition
    case 4554:
      return WEBKIT + replace$1(CA, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + CA;
    // cursor
    case 6187:
      return replace$1(replace$1(replace$1(CA, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), CA, "") + CA;
    // background, background-image
    case 5495:
    case 3959:
      return replace$1(CA, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace$1(replace$1(CA, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + CA + CA;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(CA, /(.+)-inline(.+)/, WEBKIT + "$1$2") + CA;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(CA) - 1 - gA > 6) switch (charat(CA, gA + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(CA, gA + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$1(CA, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(CA, gA + 3) == 108 ? "$3" : "$2-$3")) + CA;
        // (s)tretch
        case 115:
          return ~indexof(CA, "stretch") ? prefix$1(replace$1(CA, "stretch", "fill-available"), gA) + CA : CA;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(CA, gA + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(CA, strlen(CA) - 3 - (~indexof(CA, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$1(CA, ":", ":" + WEBKIT) + CA;
        // (inline-)?fl(e)x
        case 101:
          return replace$1(CA, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(CA, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + CA;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(CA, gA + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + CA + MS + replace$1(CA, /[svh]\w+-[tblr]{2}/, "tb") + CA;
        // vertical-r(l)
        case 108:
          return WEBKIT + CA + MS + replace$1(CA, /[svh]\w+-[tblr]{2}/, "tb-rl") + CA;
        // horizontal(-)tb
        case 45:
          return WEBKIT + CA + MS + replace$1(CA, /[svh]\w+-[tblr]{2}/, "lr") + CA;
      }
      return WEBKIT + CA + MS + CA + CA;
  }
  return CA;
}
var prefixer = function(gA, AA, IA, BA) {
  if (gA.length > -1 && !gA.return) switch (gA.type) {
    case DECLARATION:
      gA.return = prefix$1(gA.value, gA.length);
      break;
    case KEYFRAMES:
      return serialize$2([copy(gA, {
        value: replace$1(gA.value, "@", "@" + WEBKIT)
      })], BA);
    case RULESET:
      if (gA.length) return combine(gA.props, function(QA) {
        switch (match(QA, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize$2([copy(gA, {
              props: [replace$1(QA, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], BA);
          // :placeholder
          case "::placeholder":
            return serialize$2([copy(gA, {
              props: [replace$1(QA, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy(gA, {
              props: [replace$1(QA, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy(gA, {
              props: [replace$1(QA, /:(plac\w+)/, MS + "input-$1")]
            })], BA);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function(gA) {
  var AA = gA.key;
  if (AA === "css") {
    var IA = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(IA, function(nA) {
      var DA = nA.getAttribute("data-emotion");
      DA.indexOf(" ") !== -1 && (document.head.appendChild(nA), nA.setAttribute("data-s", ""));
    });
  }
  var BA = gA.stylisPlugins || defaultStylisPlugins, QA = {}, EA, iA = [];
  EA = gA.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + AA + ' "]'),
    function(nA) {
      for (var DA = nA.getAttribute("data-emotion").split(" "), hA = 1; hA < DA.length; hA++)
        QA[DA[hA]] = !0;
      iA.push(nA);
    }
  );
  var oA, cA = [compat, removeLabel];
  {
    var tA, eA = [stringify$3, rulesheet(function(nA) {
      tA.insert(nA);
    })], aA = middleware(cA.concat(BA, eA)), GA = function(DA) {
      return serialize$2(compile(DA), aA);
    };
    oA = function(DA, hA, wA, sA) {
      tA = wA, GA(DA ? DA + "{" + hA.styles + "}" : hA.styles), sA && (lA.inserted[hA.name] = !0);
    };
  }
  var lA = {
    key: AA,
    sheet: new StyleSheet({
      key: AA,
      container: EA,
      nonce: gA.nonce,
      speedy: gA.speedy,
      prepend: gA.prepend,
      insertionPoint: gA.insertionPoint
    }),
    nonce: gA.nonce,
    inserted: QA,
    registered: {},
    insert: oA
  };
  return lA.sheet.hydrate(iA), lA;
};
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA) ({}).hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$m.apply(null, arguments);
}
var reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var CA = typeof Symbol == "function" && Symbol.for, gA = CA ? /* @__PURE__ */ Symbol.for("react.element") : 60103, AA = CA ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, IA = CA ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, BA = CA ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, QA = CA ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, EA = CA ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, iA = CA ? /* @__PURE__ */ Symbol.for("react.context") : 60110, oA = CA ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, cA = CA ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, tA = CA ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, eA = CA ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, aA = CA ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, GA = CA ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, lA = CA ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, nA = CA ? /* @__PURE__ */ Symbol.for("react.block") : 60121, DA = CA ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, hA = CA ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, wA = CA ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function sA(rA) {
    if (typeof rA == "object" && rA !== null) {
      var yA = rA.$$typeof;
      switch (yA) {
        case gA:
          switch (rA = rA.type, rA) {
            case oA:
            case cA:
            case IA:
            case QA:
            case BA:
            case eA:
              return rA;
            default:
              switch (rA = rA && rA.$$typeof, rA) {
                case iA:
                case tA:
                case lA:
                case GA:
                case EA:
                  return rA;
                default:
                  return yA;
              }
          }
        case AA:
          return yA;
      }
    }
  }
  function NA(rA) {
    return sA(rA) === cA;
  }
  return reactIs_production_min$1.AsyncMode = oA, reactIs_production_min$1.ConcurrentMode = cA, reactIs_production_min$1.ContextConsumer = iA, reactIs_production_min$1.ContextProvider = EA, reactIs_production_min$1.Element = gA, reactIs_production_min$1.ForwardRef = tA, reactIs_production_min$1.Fragment = IA, reactIs_production_min$1.Lazy = lA, reactIs_production_min$1.Memo = GA, reactIs_production_min$1.Portal = AA, reactIs_production_min$1.Profiler = QA, reactIs_production_min$1.StrictMode = BA, reactIs_production_min$1.Suspense = eA, reactIs_production_min$1.isAsyncMode = function(rA) {
    return NA(rA) || sA(rA) === oA;
  }, reactIs_production_min$1.isConcurrentMode = NA, reactIs_production_min$1.isContextConsumer = function(rA) {
    return sA(rA) === iA;
  }, reactIs_production_min$1.isContextProvider = function(rA) {
    return sA(rA) === EA;
  }, reactIs_production_min$1.isElement = function(rA) {
    return typeof rA == "object" && rA !== null && rA.$$typeof === gA;
  }, reactIs_production_min$1.isForwardRef = function(rA) {
    return sA(rA) === tA;
  }, reactIs_production_min$1.isFragment = function(rA) {
    return sA(rA) === IA;
  }, reactIs_production_min$1.isLazy = function(rA) {
    return sA(rA) === lA;
  }, reactIs_production_min$1.isMemo = function(rA) {
    return sA(rA) === GA;
  }, reactIs_production_min$1.isPortal = function(rA) {
    return sA(rA) === AA;
  }, reactIs_production_min$1.isProfiler = function(rA) {
    return sA(rA) === QA;
  }, reactIs_production_min$1.isStrictMode = function(rA) {
    return sA(rA) === BA;
  }, reactIs_production_min$1.isSuspense = function(rA) {
    return sA(rA) === eA;
  }, reactIs_production_min$1.isValidElementType = function(rA) {
    return typeof rA == "string" || typeof rA == "function" || rA === IA || rA === cA || rA === QA || rA === BA || rA === eA || rA === aA || typeof rA == "object" && rA !== null && (rA.$$typeof === lA || rA.$$typeof === GA || rA.$$typeof === EA || rA.$$typeof === iA || rA.$$typeof === tA || rA.$$typeof === DA || rA.$$typeof === hA || rA.$$typeof === wA || rA.$$typeof === nA);
  }, reactIs_production_min$1.typeOf = sA, reactIs_production_min$1;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var CA = typeof Symbol == "function" && Symbol.for, gA = CA ? /* @__PURE__ */ Symbol.for("react.element") : 60103, AA = CA ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, IA = CA ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, BA = CA ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, QA = CA ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, EA = CA ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, iA = CA ? /* @__PURE__ */ Symbol.for("react.context") : 60110, oA = CA ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, cA = CA ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, tA = CA ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, eA = CA ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, aA = CA ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, GA = CA ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, lA = CA ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, nA = CA ? /* @__PURE__ */ Symbol.for("react.block") : 60121, DA = CA ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, hA = CA ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, wA = CA ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function sA(vA) {
      return typeof vA == "string" || typeof vA == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      vA === IA || vA === cA || vA === QA || vA === BA || vA === eA || vA === aA || typeof vA == "object" && vA !== null && (vA.$$typeof === lA || vA.$$typeof === GA || vA.$$typeof === EA || vA.$$typeof === iA || vA.$$typeof === tA || vA.$$typeof === DA || vA.$$typeof === hA || vA.$$typeof === wA || vA.$$typeof === nA);
    }
    function NA(vA) {
      if (typeof vA == "object" && vA !== null) {
        var wI = vA.$$typeof;
        switch (wI) {
          case gA:
            var $A = vA.type;
            switch ($A) {
              case oA:
              case cA:
              case IA:
              case QA:
              case BA:
              case eA:
                return $A;
              default:
                var YI = $A && $A.$$typeof;
                switch (YI) {
                  case iA:
                  case tA:
                  case lA:
                  case GA:
                  case EA:
                    return YI;
                  default:
                    return wI;
                }
            }
          case AA:
            return wI;
        }
      }
    }
    var rA = oA, yA = cA, bA = iA, RA = EA, FA = gA, dA = tA, kA = IA, pA = lA, YA = GA, SA = AA, JA = QA, UA = BA, fA = eA, zA = !1;
    function _A(vA) {
      return zA || (zA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), uA(vA) || NA(vA) === oA;
    }
    function uA(vA) {
      return NA(vA) === cA;
    }
    function HA(vA) {
      return NA(vA) === iA;
    }
    function TA(vA) {
      return NA(vA) === EA;
    }
    function ZA(vA) {
      return typeof vA == "object" && vA !== null && vA.$$typeof === gA;
    }
    function AI(vA) {
      return NA(vA) === tA;
    }
    function QI(vA) {
      return NA(vA) === IA;
    }
    function LA(vA) {
      return NA(vA) === lA;
    }
    function PA(vA) {
      return NA(vA) === GA;
    }
    function XA(vA) {
      return NA(vA) === AA;
    }
    function EI(vA) {
      return NA(vA) === QA;
    }
    function CI(vA) {
      return NA(vA) === BA;
    }
    function II(vA) {
      return NA(vA) === eA;
    }
    reactIs_development$1.AsyncMode = rA, reactIs_development$1.ConcurrentMode = yA, reactIs_development$1.ContextConsumer = bA, reactIs_development$1.ContextProvider = RA, reactIs_development$1.Element = FA, reactIs_development$1.ForwardRef = dA, reactIs_development$1.Fragment = kA, reactIs_development$1.Lazy = pA, reactIs_development$1.Memo = YA, reactIs_development$1.Portal = SA, reactIs_development$1.Profiler = JA, reactIs_development$1.StrictMode = UA, reactIs_development$1.Suspense = fA, reactIs_development$1.isAsyncMode = _A, reactIs_development$1.isConcurrentMode = uA, reactIs_development$1.isContextConsumer = HA, reactIs_development$1.isContextProvider = TA, reactIs_development$1.isElement = ZA, reactIs_development$1.isForwardRef = AI, reactIs_development$1.isFragment = QI, reactIs_development$1.isLazy = LA, reactIs_development$1.isMemo = PA, reactIs_development$1.isPortal = XA, reactIs_development$1.isProfiler = EI, reactIs_development$1.isStrictMode = CI, reactIs_development$1.isSuspense = II, reactIs_development$1.isValidElementType = sA, reactIs_development$1.typeOf = NA;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var hoistNonReactStatics_cjs, hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var CA = requireReactIs$1(), gA = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, AA = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, IA = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, BA = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, QA = {};
  QA[CA.ForwardRef] = IA, QA[CA.Memo] = BA;
  function EA(lA) {
    return CA.isMemo(lA) ? BA : QA[lA.$$typeof] || gA;
  }
  var iA = Object.defineProperty, oA = Object.getOwnPropertyNames, cA = Object.getOwnPropertySymbols, tA = Object.getOwnPropertyDescriptor, eA = Object.getPrototypeOf, aA = Object.prototype;
  function GA(lA, nA, DA) {
    if (typeof nA != "string") {
      if (aA) {
        var hA = eA(nA);
        hA && hA !== aA && GA(lA, hA, DA);
      }
      var wA = oA(nA);
      cA && (wA = wA.concat(cA(nA)));
      for (var sA = EA(lA), NA = EA(nA), rA = 0; rA < wA.length; ++rA) {
        var yA = wA[rA];
        if (!AA[yA] && !(DA && DA[yA]) && !(NA && NA[yA]) && !(sA && sA[yA])) {
          var bA = tA(nA, yA);
          try {
            iA(lA, yA, bA);
          } catch {
          }
        }
      }
    }
    return lA;
  }
  return hoistNonReactStatics_cjs = GA, hoistNonReactStatics_cjs;
}
var hoistNonReactStatics_cjsExports = requireHoistNonReactStatics_cjs();
const hoistNonReactStatics = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjsExports);
var isBrowser$2 = !0;
function getRegisteredStyles(CA, gA, AA) {
  var IA = "";
  return AA.split(" ").forEach(function(BA) {
    CA[BA] !== void 0 ? gA.push(CA[BA] + ";") : BA && (IA += BA + " ");
  }), IA;
}
var registerStyles = function(gA, AA, IA) {
  var BA = gA.key + "-" + AA.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (IA === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$2 === !1) && gA.registered[BA] === void 0 && (gA.registered[BA] = AA.styles);
}, insertStyles = function(gA, AA, IA) {
  registerStyles(gA, AA, IA);
  var BA = gA.key + "-" + AA.name;
  if (gA.inserted[AA.name] === void 0) {
    var QA = AA;
    do
      gA.insert(AA === QA ? "." + BA : "", QA, gA.sheet, !0), QA = QA.next;
    while (QA !== void 0);
  }
};
function murmur2(CA) {
  for (var gA = 0, AA, IA = 0, BA = CA.length; BA >= 4; ++IA, BA -= 4)
    AA = CA.charCodeAt(IA) & 255 | (CA.charCodeAt(++IA) & 255) << 8 | (CA.charCodeAt(++IA) & 255) << 16 | (CA.charCodeAt(++IA) & 255) << 24, AA = /* Math.imul(k, m): */
    (AA & 65535) * 1540483477 + ((AA >>> 16) * 59797 << 16), AA ^= /* k >>> r: */
    AA >>> 24, gA = /* Math.imul(k, m): */
    (AA & 65535) * 1540483477 + ((AA >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (gA & 65535) * 1540483477 + ((gA >>> 16) * 59797 << 16);
  switch (BA) {
    case 3:
      gA ^= (CA.charCodeAt(IA + 2) & 255) << 16;
    case 2:
      gA ^= (CA.charCodeAt(IA + 1) & 255) << 8;
    case 1:
      gA ^= CA.charCodeAt(IA) & 255, gA = /* Math.imul(h, m): */
      (gA & 65535) * 1540483477 + ((gA >>> 16) * 59797 << 16);
  }
  return gA ^= gA >>> 13, gA = /* Math.imul(h, m): */
  (gA & 65535) * 1540483477 + ((gA >>> 16) * 59797 << 16), ((gA ^ gA >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(gA) {
  return gA.charCodeAt(1) === 45;
}, isProcessableValue = function(gA) {
  return gA != null && typeof gA != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(CA) {
  return isCustomProperty(CA) ? CA : CA.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(gA, AA) {
  switch (gA) {
    case "animation":
    case "animationName":
      if (typeof AA == "string")
        return AA.replace(animationRegex, function(IA, BA, QA) {
          return cursor$1 = {
            name: BA,
            styles: QA,
            next: cursor$1
          }, BA;
        });
  }
  return unitlessKeys[gA] !== 1 && !isCustomProperty(gA) && typeof AA == "number" && AA !== 0 ? AA + "px" : AA;
};
function handleInterpolation(CA, gA, AA) {
  if (AA == null)
    return "";
  var IA = AA;
  if (IA.__emotion_styles !== void 0)
    return IA;
  switch (typeof AA) {
    case "boolean":
      return "";
    case "object": {
      var BA = AA;
      if (BA.anim === 1)
        return cursor$1 = {
          name: BA.name,
          styles: BA.styles,
          next: cursor$1
        }, BA.name;
      var QA = AA;
      if (QA.styles !== void 0) {
        var EA = QA.next;
        if (EA !== void 0)
          for (; EA !== void 0; )
            cursor$1 = {
              name: EA.name,
              styles: EA.styles,
              next: cursor$1
            }, EA = EA.next;
        var iA = QA.styles + ";";
        return iA;
      }
      return createStringFromObject(CA, gA, AA);
    }
    case "function": {
      if (CA !== void 0) {
        var oA = cursor$1, cA = AA(CA);
        return cursor$1 = oA, handleInterpolation(CA, gA, cA);
      }
      break;
    }
  }
  var tA = AA;
  if (gA == null)
    return tA;
  var eA = gA[tA];
  return eA !== void 0 ? eA : tA;
}
function createStringFromObject(CA, gA, AA) {
  var IA = "";
  if (Array.isArray(AA))
    for (var BA = 0; BA < AA.length; BA++)
      IA += handleInterpolation(CA, gA, AA[BA]) + ";";
  else
    for (var QA in AA) {
      var EA = AA[QA];
      if (typeof EA != "object") {
        var iA = EA;
        gA != null && gA[iA] !== void 0 ? IA += QA + "{" + gA[iA] + "}" : isProcessableValue(iA) && (IA += processStyleName(QA) + ":" + processStyleValue(QA, iA) + ";");
      } else if (Array.isArray(EA) && typeof EA[0] == "string" && (gA == null || gA[EA[0]] === void 0))
        for (var oA = 0; oA < EA.length; oA++)
          isProcessableValue(EA[oA]) && (IA += processStyleName(QA) + ":" + processStyleValue(QA, EA[oA]) + ";");
      else {
        var cA = handleInterpolation(CA, gA, EA);
        switch (QA) {
          case "animation":
          case "animationName": {
            IA += processStyleName(QA) + ":" + cA + ";";
            break;
          }
          default:
            IA += QA + "{" + cA + "}";
        }
      }
    }
  return IA;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor$1;
function serializeStyles(CA, gA, AA) {
  if (CA.length === 1 && typeof CA[0] == "object" && CA[0] !== null && CA[0].styles !== void 0)
    return CA[0];
  var IA = !0, BA = "";
  cursor$1 = void 0;
  var QA = CA[0];
  if (QA == null || QA.raw === void 0)
    IA = !1, BA += handleInterpolation(AA, gA, QA);
  else {
    var EA = QA;
    BA += EA[0];
  }
  for (var iA = 1; iA < CA.length; iA++)
    if (BA += handleInterpolation(AA, gA, CA[iA]), IA) {
      var oA = QA;
      BA += oA[iA];
    }
  labelPattern.lastIndex = 0;
  for (var cA = "", tA; (tA = labelPattern.exec(BA)) !== null; )
    cA += "-" + tA[1];
  var eA = murmur2(BA) + cA;
  return {
    name: eA,
    styles: BA,
    next: cursor$1
  };
}
var syncFallback = function(gA) {
  return gA();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
), CacheProvider = EmotionCacheContext.Provider, withEmotionCache = function(gA) {
  return /* @__PURE__ */ forwardRef(function(AA, IA) {
    var BA = useContext(EmotionCacheContext);
    return gA(AA, BA, IA);
  });
}, ThemeContext$2 = /* @__PURE__ */ React.createContext({}), useTheme = function() {
  return React.useContext(ThemeContext$2);
}, getTheme = function(gA, AA) {
  if (typeof AA == "function") {
    var IA = AA(gA);
    return IA;
  }
  return _extends$m({}, gA, AA);
}, createCacheWithTheme = /* @__PURE__ */ weakMemoize(function(CA) {
  return weakMemoize(function(gA) {
    return getTheme(CA, gA);
  });
}), ThemeProvider$2 = function(gA) {
  var AA = React.useContext(ThemeContext$2);
  return gA.theme !== AA && (AA = createCacheWithTheme(AA)(gA.theme)), /* @__PURE__ */ React.createElement(ThemeContext$2.Provider, {
    value: AA
  }, gA.children);
}, hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(gA, AA) {
  var IA = {};
  for (var BA in AA)
    hasOwn.call(AA, BA) && (IA[BA] = AA[BA]);
  return IA[typePropName] = gA, IA;
}, Insertion$2 = function(gA) {
  var AA = gA.cache, IA = gA.serialized, BA = gA.isStringTag;
  return registerStyles(AA, IA, BA), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(AA, IA, BA);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(CA, gA, AA) {
  var IA = CA.css;
  typeof IA == "string" && gA.registered[IA] !== void 0 && (IA = gA.registered[IA]);
  var BA = CA[typePropName], QA = [IA], EA = "";
  typeof CA.className == "string" ? EA = getRegisteredStyles(gA.registered, QA, CA.className) : CA.className != null && (EA = CA.className + " ");
  var iA = serializeStyles(QA, void 0, React.useContext(ThemeContext$2));
  EA += gA.key + "-" + iA.name;
  var oA = {};
  for (var cA in CA)
    hasOwn.call(CA, cA) && cA !== "css" && cA !== typePropName && (oA[cA] = CA[cA]);
  return oA.className = EA, AA && (oA.ref = AA), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
    cache: gA,
    serialized: iA,
    isStringTag: typeof BA == "string"
  }), /* @__PURE__ */ React.createElement(BA, oA));
}), Emotion$1 = Emotion, jsx = function(gA, AA) {
  var IA = arguments;
  if (AA == null || !hasOwn.call(AA, "css"))
    return React.createElement.apply(void 0, IA);
  var BA = IA.length, QA = new Array(BA);
  QA[0] = Emotion$1, QA[1] = createEmotionProps(gA, AA);
  for (var EA = 2; EA < BA; EA++)
    QA[EA] = IA[EA];
  return React.createElement.apply(null, QA);
};
(function(CA) {
  var gA;
  gA || (gA = CA.JSX || (CA.JSX = {}));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(CA, gA) {
  var AA = CA.styles, IA = serializeStyles([AA], void 0, React.useContext(ThemeContext$2)), BA = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var QA = gA.key + "-global", EA = new gA.sheet.constructor({
      key: QA,
      nonce: gA.sheet.nonce,
      container: gA.sheet.container,
      speedy: gA.sheet.isSpeedy
    }), iA = !1, oA = document.querySelector('style[data-emotion="' + QA + " " + IA.name + '"]');
    return gA.sheet.tags.length && (EA.before = gA.sheet.tags[0]), oA !== null && (iA = !0, oA.setAttribute("data-emotion", QA), EA.hydrate([oA])), BA.current = [EA, iA], function() {
      EA.flush();
    };
  }, [gA]), useInsertionEffectWithLayoutFallback(function() {
    var QA = BA.current, EA = QA[0], iA = QA[1];
    if (iA) {
      QA[1] = !1;
      return;
    }
    if (IA.next !== void 0 && insertStyles(gA, IA.next, !0), EA.tags.length) {
      var oA = EA.tags[EA.tags.length - 1].nextElementSibling;
      EA.before = oA, EA.flush();
    }
    gA.insert("", IA, EA, !1);
  }, [gA, IA.name]), null;
});
function css() {
  for (var CA = arguments.length, gA = new Array(CA), AA = 0; AA < CA; AA++)
    gA[AA] = arguments[AA];
  return serializeStyles(gA);
}
function keyframes() {
  var CA = css.apply(void 0, arguments), gA = "animation-" + CA.name;
  return {
    name: gA,
    styles: "@keyframes " + gA + "{" + CA.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var classnames$1 = function CA(gA) {
  for (var AA = gA.length, IA = 0, BA = ""; IA < AA; IA++) {
    var QA = gA[IA];
    if (QA != null) {
      var EA = void 0;
      switch (typeof QA) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(QA))
            EA = CA(QA);
          else {
            EA = "";
            for (var iA in QA)
              QA[iA] && iA && (EA && (EA += " "), EA += iA);
          }
          break;
        }
        default:
          EA = QA;
      }
      EA && (BA && (BA += " "), BA += EA);
    }
  }
  return BA;
};
function merge$2(CA, gA, AA) {
  var IA = [], BA = getRegisteredStyles(CA, IA, AA);
  return IA.length < 2 ? AA : BA + gA(IA);
}
var Insertion$1 = function(gA) {
  var AA = gA.cache, IA = gA.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var BA = 0; BA < IA.length; BA++)
      insertStyles(AA, IA[BA], !1);
  }), null;
}, ClassNames = /* @__PURE__ */ withEmotionCache(function(CA, gA) {
  var AA = [], IA = function() {
    for (var oA = arguments.length, cA = new Array(oA), tA = 0; tA < oA; tA++)
      cA[tA] = arguments[tA];
    var eA = serializeStyles(cA, gA.registered);
    return AA.push(eA), registerStyles(gA, eA, !1), gA.key + "-" + eA.name;
  }, BA = function() {
    for (var oA = arguments.length, cA = new Array(oA), tA = 0; tA < oA; tA++)
      cA[tA] = arguments[tA];
    return merge$2(gA.registered, IA, classnames$1(cA));
  }, QA = {
    css: IA,
    cx: BA,
    theme: React.useContext(ThemeContext$2)
  }, EA = CA.children(QA);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: gA,
    serializedArr: AA
  }), EA);
});
const FontFaceDeclaration = ({
  fontFaces: CA
}) => {
  const gA = CA.map((AA) => {
    const {
      family: IA,
      weight: BA,
      weightRange: QA,
      url: EA,
      style: iA,
      unicodeRange: oA
    } = AA, cA = QA || BA;
    return `
      @font-face {
        font-family: ${IA};
        src: url(${EA}) format("woff2");
        font-display: swap;
        ${iA ? `font-style: ${iA};` : ""}
        ${cA ? `font-weight: ${cA};` : ""}
        ${oA ? `unicode-range: ${oA};` : ""}
      }
    `;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: /* @__PURE__ */ css(gA, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FontFaceDeclaration;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") });
};
var reactFastCompare, hasRequiredReactFastCompare;
function requireReactFastCompare() {
  if (hasRequiredReactFastCompare) return reactFastCompare;
  hasRequiredReactFastCompare = 1;
  var CA = typeof Element < "u", gA = typeof Map == "function", AA = typeof Set == "function", IA = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function BA(QA, EA) {
    if (QA === EA) return !0;
    if (QA && EA && typeof QA == "object" && typeof EA == "object") {
      if (QA.constructor !== EA.constructor) return !1;
      var iA, oA, cA;
      if (Array.isArray(QA)) {
        if (iA = QA.length, iA != EA.length) return !1;
        for (oA = iA; oA-- !== 0; )
          if (!BA(QA[oA], EA[oA])) return !1;
        return !0;
      }
      var tA;
      if (gA && QA instanceof Map && EA instanceof Map) {
        if (QA.size !== EA.size) return !1;
        for (tA = QA.entries(); !(oA = tA.next()).done; )
          if (!EA.has(oA.value[0])) return !1;
        for (tA = QA.entries(); !(oA = tA.next()).done; )
          if (!BA(oA.value[1], EA.get(oA.value[0]))) return !1;
        return !0;
      }
      if (AA && QA instanceof Set && EA instanceof Set) {
        if (QA.size !== EA.size) return !1;
        for (tA = QA.entries(); !(oA = tA.next()).done; )
          if (!EA.has(oA.value[0])) return !1;
        return !0;
      }
      if (IA && ArrayBuffer.isView(QA) && ArrayBuffer.isView(EA)) {
        if (iA = QA.length, iA != EA.length) return !1;
        for (oA = iA; oA-- !== 0; )
          if (QA[oA] !== EA[oA]) return !1;
        return !0;
      }
      if (QA.constructor === RegExp) return QA.source === EA.source && QA.flags === EA.flags;
      if (QA.valueOf !== Object.prototype.valueOf && typeof QA.valueOf == "function" && typeof EA.valueOf == "function") return QA.valueOf() === EA.valueOf();
      if (QA.toString !== Object.prototype.toString && typeof QA.toString == "function" && typeof EA.toString == "function") return QA.toString() === EA.toString();
      if (cA = Object.keys(QA), iA = cA.length, iA !== Object.keys(EA).length) return !1;
      for (oA = iA; oA-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(EA, cA[oA])) return !1;
      if (CA && QA instanceof Element) return !1;
      for (oA = iA; oA-- !== 0; )
        if (!((cA[oA] === "_owner" || cA[oA] === "__v" || cA[oA] === "__o") && QA.$$typeof) && !BA(QA[cA[oA]], EA[cA[oA]]))
          return !1;
      return !0;
    }
    return QA !== QA && EA !== EA;
  }
  return reactFastCompare = function(EA, iA) {
    try {
      return BA(EA, iA);
    } catch (oA) {
      if ((oA.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw oA;
    }
  }, reactFastCompare;
}
var reactFastCompareExports = requireReactFastCompare();
const fastCompare = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompareExports);
var browser, hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  var CA = function(gA, AA, IA, BA, QA, EA, iA, oA) {
    if (process.env.NODE_ENV !== "production" && AA === void 0)
      throw new Error("invariant requires an error message argument");
    if (!gA) {
      var cA;
      if (AA === void 0)
        cA = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var tA = [IA, BA, QA, EA, iA, oA], eA = 0;
        cA = new Error(
          AA.replace(/%s/g, function() {
            return tA[eA++];
          })
        ), cA.name = "Invariant Violation";
      }
      throw cA.framesToPop = 1, cA;
    }
  };
  return browser = CA, browser;
}
var browserExports = requireBrowser();
const invariant = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var shallowequal, hasRequiredShallowequal;
function requireShallowequal() {
  return hasRequiredShallowequal || (hasRequiredShallowequal = 1, shallowequal = function(gA, AA, IA, BA) {
    var QA = IA ? IA.call(BA, gA, AA) : void 0;
    if (QA !== void 0)
      return !!QA;
    if (gA === AA)
      return !0;
    if (typeof gA != "object" || !gA || typeof AA != "object" || !AA)
      return !1;
    var EA = Object.keys(gA), iA = Object.keys(AA);
    if (EA.length !== iA.length)
      return !1;
    for (var oA = Object.prototype.hasOwnProperty.bind(AA), cA = 0; cA < EA.length; cA++) {
      var tA = EA[cA];
      if (!oA(tA))
        return !1;
      var eA = gA[tA], aA = AA[tA];
      if (QA = IA ? IA.call(BA, eA, aA, tA) : void 0, QA === !1 || QA === void 0 && eA !== aA)
        return !1;
    }
    return !0;
  }), shallowequal;
}
var shallowequalExports = requireShallowequal();
const shallowEqual = /* @__PURE__ */ getDefaultExportFromCjs(shallowequalExports);
var TAG_NAMES = /* @__PURE__ */ ((CA) => (CA.BASE = "base", CA.BODY = "body", CA.HEAD = "head", CA.HTML = "html", CA.LINK = "link", CA.META = "meta", CA.NOSCRIPT = "noscript", CA.SCRIPT = "script", CA.STYLE = "style", CA.TITLE = "title", CA.FRAGMENT = "Symbol(react.fragment)", CA))(TAG_NAMES || {}), SEO_PRIORITY_TAGS = {
  link: { rel: ["amphtml", "canonical", "alternate"] },
  script: { type: ["application/ld+json"] },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: [
      "og:type",
      "og:title",
      "og:url",
      "og:image",
      "og:image:alt",
      "og:description",
      "twitter:url",
      "twitter:title",
      "twitter:description",
      "twitter:image",
      "twitter:image:alt",
      "twitter:card",
      "twitter:site"
    ]
  }
}, VALID_TAG_NAMES = Object.values(TAG_NAMES), REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
}, HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(
  (CA, [gA, AA]) => (CA[AA] = gA, CA),
  {}
), HELMET_ATTRIBUTE = "data-rh", HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
}, getInnermostProperty = (CA, gA) => {
  for (let AA = CA.length - 1; AA >= 0; AA -= 1) {
    const IA = CA[AA];
    if (Object.prototype.hasOwnProperty.call(IA, gA))
      return IA[gA];
  }
  return null;
}, getTitleFromPropsList = (CA) => {
  let gA = getInnermostProperty(
    CA,
    "title"
    /* TITLE */
  );
  const AA = getInnermostProperty(CA, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(gA) && (gA = gA.join("")), AA && gA)
    return AA.replace(/%s/g, () => gA);
  const IA = getInnermostProperty(CA, HELMET_PROPS.DEFAULT_TITLE);
  return gA || IA || void 0;
}, getOnChangeClientState = (CA) => getInnermostProperty(CA, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (() => {
}), getAttributesFromPropsList = (CA, gA) => gA.filter((AA) => typeof AA[CA] < "u").map((AA) => AA[CA]).reduce((AA, IA) => ({ ...AA, ...IA }), {}), getBaseTagFromPropsList = (CA, gA) => gA.filter((AA) => typeof AA.base < "u").map((AA) => AA.base).reverse().reduce((AA, IA) => {
  if (!AA.length) {
    const BA = Object.keys(IA);
    for (let QA = 0; QA < BA.length; QA += 1) {
      const iA = BA[QA].toLowerCase();
      if (CA.indexOf(iA) !== -1 && IA[iA])
        return AA.concat(IA);
    }
  }
  return AA;
}, []), warn = (CA) => console && typeof console.warn == "function" && console.warn(CA), getTagsFromPropsList = (CA, gA, AA) => {
  const IA = {};
  return AA.filter((BA) => Array.isArray(BA[CA]) ? !0 : (typeof BA[CA] < "u" && warn(
    `Helmet: ${CA} should be of type "Array". Instead found type "${typeof BA[CA]}"`
  ), !1)).map((BA) => BA[CA]).reverse().reduce((BA, QA) => {
    const EA = {};
    QA.filter((oA) => {
      let cA;
      const tA = Object.keys(oA);
      for (let aA = 0; aA < tA.length; aA += 1) {
        const GA = tA[aA], lA = GA.toLowerCase();
        gA.indexOf(lA) !== -1 && !(cA === "rel" && oA[cA].toLowerCase() === "canonical") && !(lA === "rel" && oA[lA].toLowerCase() === "stylesheet") && (cA = lA), gA.indexOf(GA) !== -1 && (GA === "innerHTML" || GA === "cssText" || GA === "itemprop") && (cA = GA);
      }
      if (!cA || !oA[cA])
        return !1;
      const eA = oA[cA].toLowerCase();
      return IA[cA] || (IA[cA] = {}), EA[cA] || (EA[cA] = {}), IA[cA][eA] ? !1 : (EA[cA][eA] = !0, !0);
    }).reverse().forEach((oA) => BA.push(oA));
    const iA = Object.keys(EA);
    for (let oA = 0; oA < iA.length; oA += 1) {
      const cA = iA[oA], tA = {
        ...IA[cA],
        ...EA[cA]
      };
      IA[cA] = tA;
    }
    return BA;
  }, []).reverse();
}, getAnyTrueFromPropsList = (CA, gA) => {
  if (Array.isArray(CA) && CA.length) {
    for (let AA = 0; AA < CA.length; AA += 1)
      if (CA[AA][gA])
        return !0;
  }
  return !1;
}, reducePropsToState$1 = (CA) => ({
  baseTag: getBaseTagFromPropsList([
    "href"
    /* HREF */
  ], CA),
  bodyAttributes: getAttributesFromPropsList("bodyAttributes", CA),
  defer: getInnermostProperty(CA, HELMET_PROPS.DEFER),
  encode: getInnermostProperty(CA, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
  htmlAttributes: getAttributesFromPropsList("htmlAttributes", CA),
  linkTags: getTagsFromPropsList(
    "link",
    [
      "rel",
      "href"
      /* HREF */
    ],
    CA
  ),
  metaTags: getTagsFromPropsList(
    "meta",
    [
      "name",
      "charset",
      "http-equiv",
      "property",
      "itemprop"
      /* ITEM_PROP */
    ],
    CA
  ),
  noscriptTags: getTagsFromPropsList("noscript", [
    "innerHTML"
    /* INNER_HTML */
  ], CA),
  onChangeClientState: getOnChangeClientState(CA),
  scriptTags: getTagsFromPropsList(
    "script",
    [
      "src",
      "innerHTML"
      /* INNER_HTML */
    ],
    CA
  ),
  styleTags: getTagsFromPropsList("style", [
    "cssText"
    /* CSS_TEXT */
  ], CA),
  title: getTitleFromPropsList(CA),
  titleAttributes: getAttributesFromPropsList("titleAttributes", CA),
  prioritizeSeoTags: getAnyTrueFromPropsList(CA, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
}), flattenArray = (CA) => Array.isArray(CA) ? CA.join("") : CA, checkIfPropsMatch = (CA, gA) => {
  const AA = Object.keys(CA);
  for (let IA = 0; IA < AA.length; IA += 1)
    if (gA[AA[IA]] && gA[AA[IA]].includes(CA[AA[IA]]))
      return !0;
  return !1;
}, prioritizer = (CA, gA) => Array.isArray(CA) ? CA.reduce(
  (AA, IA) => (checkIfPropsMatch(IA, gA) ? AA.priority.push(IA) : AA.default.push(IA), AA),
  { priority: [], default: [] }
) : { default: CA, priority: [] }, without = (CA, gA) => ({
  ...CA,
  [gA]: void 0
}), SELF_CLOSING_TAGS = [
  "noscript",
  "script",
  "style"
  /* STYLE */
], encodeSpecialCharacters = (CA, gA = !0) => gA === !1 ? String(CA) : String(CA).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;"), generateElementAttributesAsString = (CA) => Object.keys(CA).reduce((gA, AA) => {
  const IA = typeof CA[AA] < "u" ? `${AA}="${CA[AA]}"` : `${AA}`;
  return gA ? `${gA} ${IA}` : IA;
}, ""), generateTitleAsString = (CA, gA, AA, IA) => {
  const BA = generateElementAttributesAsString(AA), QA = flattenArray(gA);
  return BA ? `<${CA} ${HELMET_ATTRIBUTE}="true" ${BA}>${encodeSpecialCharacters(
    QA,
    IA
  )}</${CA}>` : `<${CA} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(
    QA,
    IA
  )}</${CA}>`;
}, generateTagsAsString = (CA, gA, AA = !0) => gA.reduce((IA, BA) => {
  const QA = BA, EA = Object.keys(QA).filter(
    (cA) => !(cA === "innerHTML" || cA === "cssText")
  ).reduce((cA, tA) => {
    const eA = typeof QA[tA] > "u" ? tA : `${tA}="${encodeSpecialCharacters(QA[tA], AA)}"`;
    return cA ? `${cA} ${eA}` : eA;
  }, ""), iA = QA.innerHTML || QA.cssText || "", oA = SELF_CLOSING_TAGS.indexOf(CA) === -1;
  return `${IA}<${CA} ${HELMET_ATTRIBUTE}="true" ${EA}${oA ? "/>" : `>${iA}</${CA}>`}`;
}, ""), convertElementAttributesToReactProps = (CA, gA = {}) => Object.keys(CA).reduce((AA, IA) => {
  const BA = REACT_TAG_MAP[IA];
  return AA[BA || IA] = CA[IA], AA;
}, gA), generateTitleAsReactComponent = (CA, gA, AA) => {
  const IA = {
    key: gA,
    [HELMET_ATTRIBUTE]: !0
  }, BA = convertElementAttributesToReactProps(AA, IA);
  return [React__default.createElement("title", BA, gA)];
}, generateTagsAsReactComponent = (CA, gA) => gA.map((AA, IA) => {
  const BA = {
    key: IA,
    [HELMET_ATTRIBUTE]: !0
  };
  return Object.keys(AA).forEach((QA) => {
    const iA = REACT_TAG_MAP[QA] || QA;
    if (iA === "innerHTML" || iA === "cssText") {
      const oA = AA.innerHTML || AA.cssText;
      BA.dangerouslySetInnerHTML = { __html: oA };
    } else
      BA[iA] = AA[QA];
  }), React__default.createElement(CA, BA);
}), getMethodsForTag = (CA, gA, AA = !0) => {
  switch (CA) {
    case "title":
      return {
        toComponent: () => generateTitleAsReactComponent(CA, gA.title, gA.titleAttributes),
        toString: () => generateTitleAsString(CA, gA.title, gA.titleAttributes, AA)
      };
    case "bodyAttributes":
    case "htmlAttributes":
      return {
        toComponent: () => convertElementAttributesToReactProps(gA),
        toString: () => generateElementAttributesAsString(gA)
      };
    default:
      return {
        toComponent: () => generateTagsAsReactComponent(CA, gA),
        toString: () => generateTagsAsString(CA, gA, AA)
      };
  }
}, getPriorityMethods = ({ metaTags: CA, linkTags: gA, scriptTags: AA, encode: IA }) => {
  const BA = prioritizer(CA, SEO_PRIORITY_TAGS.meta), QA = prioritizer(gA, SEO_PRIORITY_TAGS.link), EA = prioritizer(AA, SEO_PRIORITY_TAGS.script);
  return {
    priorityMethods: {
      toComponent: () => [
        ...generateTagsAsReactComponent("meta", BA.priority),
        ...generateTagsAsReactComponent("link", QA.priority),
        ...generateTagsAsReactComponent("script", EA.priority)
      ],
      toString: () => (
        // generate all the tags as strings and concatenate them
        `${getMethodsForTag("meta", BA.priority, IA)} ${getMethodsForTag(
          "link",
          QA.priority,
          IA
        )} ${getMethodsForTag("script", EA.priority, IA)}`
      )
    },
    metaTags: BA.default,
    linkTags: QA.default,
    scriptTags: EA.default
  };
}, mapStateOnServer = (CA) => {
  const {
    baseTag: gA,
    bodyAttributes: AA,
    encode: IA = !0,
    htmlAttributes: BA,
    noscriptTags: QA,
    styleTags: EA,
    title: iA = "",
    titleAttributes: oA,
    prioritizeSeoTags: cA
  } = CA;
  let { linkTags: tA, metaTags: eA, scriptTags: aA } = CA, GA = {
    toComponent: () => [],
    toString: () => ""
  };
  return cA && ({ priorityMethods: GA, linkTags: tA, metaTags: eA, scriptTags: aA } = getPriorityMethods(CA)), {
    priority: GA,
    base: getMethodsForTag("base", gA, IA),
    bodyAttributes: getMethodsForTag("bodyAttributes", AA, IA),
    htmlAttributes: getMethodsForTag("htmlAttributes", BA, IA),
    link: getMethodsForTag("link", tA, IA),
    meta: getMethodsForTag("meta", eA, IA),
    noscript: getMethodsForTag("noscript", QA, IA),
    script: getMethodsForTag("script", aA, IA),
    style: getMethodsForTag("style", EA, IA),
    title: getMethodsForTag("title", { title: iA, titleAttributes: oA }, IA)
  };
}, server_default = mapStateOnServer, instances = [], isDocument = !!(typeof window < "u" && window.document && window.document.createElement), HelmetData = class {
  instances = [];
  canUseDOM = isDocument;
  context;
  value = {
    setHelmet: (CA) => {
      this.context.helmet = CA;
    },
    helmetInstances: {
      get: () => this.canUseDOM ? instances : this.instances,
      add: (CA) => {
        (this.canUseDOM ? instances : this.instances).push(CA);
      },
      remove: (CA) => {
        const gA = (this.canUseDOM ? instances : this.instances).indexOf(CA);
        (this.canUseDOM ? instances : this.instances).splice(gA, 1);
      }
    }
  };
  constructor(CA, gA) {
    this.context = CA, this.canUseDOM = gA || !1, gA || (CA.helmet = server_default({
      baseTag: [],
      bodyAttributes: {},
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    }));
  }
}, major = parseInt(React__default.version.split(".")[0], 10), isReact19 = major >= 19, defaultValue = {}, Context = React__default.createContext(defaultValue), HelmetProvider = class ug extends Component {
  static canUseDOM = isDocument;
  helmetData;
  constructor(gA) {
    super(gA), isReact19 ? this.helmetData = null : this.helmetData = new HelmetData(this.props.context || {}, ug.canUseDOM);
  }
  render() {
    return isReact19 ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, this.props.children) : /* @__PURE__ */ React__default.createElement(Context.Provider, { value: this.helmetData.value }, this.props.children);
  }
}, updateTags = (CA, gA) => {
  const AA = document.head || document.querySelector(
    "head"
    /* HEAD */
  ), IA = AA.querySelectorAll(`${CA}[${HELMET_ATTRIBUTE}]`), BA = [].slice.call(IA), QA = [];
  let EA;
  return gA && gA.length && gA.forEach((iA) => {
    const oA = document.createElement(CA);
    for (const cA in iA)
      if (Object.prototype.hasOwnProperty.call(iA, cA))
        if (cA === "innerHTML")
          oA.innerHTML = iA.innerHTML;
        else if (cA === "cssText") {
          const tA = iA.cssText;
          oA.appendChild(document.createTextNode(tA));
        } else {
          const tA = cA, eA = typeof iA[tA] > "u" ? "" : iA[tA];
          oA.setAttribute(cA, eA);
        }
    oA.setAttribute(HELMET_ATTRIBUTE, "true"), BA.some((cA, tA) => (EA = tA, oA.isEqualNode(cA))) ? BA.splice(EA, 1) : QA.push(oA);
  }), BA.forEach((iA) => iA.parentNode?.removeChild(iA)), QA.forEach((iA) => AA.appendChild(iA)), {
    oldTags: BA,
    newTags: QA
  };
}, updateAttributes = (CA, gA) => {
  const AA = document.getElementsByTagName(CA)[0];
  if (!AA)
    return;
  const IA = AA.getAttribute(HELMET_ATTRIBUTE), BA = IA ? IA.split(",") : [], QA = [...BA], EA = Object.keys(gA);
  for (const iA of EA) {
    const oA = gA[iA] || "";
    AA.getAttribute(iA) !== oA && AA.setAttribute(iA, oA), BA.indexOf(iA) === -1 && BA.push(iA);
    const cA = QA.indexOf(iA);
    cA !== -1 && QA.splice(cA, 1);
  }
  for (let iA = QA.length - 1; iA >= 0; iA -= 1)
    AA.removeAttribute(QA[iA]);
  BA.length === QA.length ? AA.removeAttribute(HELMET_ATTRIBUTE) : AA.getAttribute(HELMET_ATTRIBUTE) !== EA.join(",") && AA.setAttribute(HELMET_ATTRIBUTE, EA.join(","));
}, updateTitle = (CA, gA) => {
  typeof CA < "u" && document.title !== CA && (document.title = flattenArray(CA)), updateAttributes("title", gA);
}, commitTagChanges = (CA, gA) => {
  const {
    baseTag: AA,
    bodyAttributes: IA,
    htmlAttributes: BA,
    linkTags: QA,
    metaTags: EA,
    noscriptTags: iA,
    onChangeClientState: oA,
    scriptTags: cA,
    styleTags: tA,
    title: eA,
    titleAttributes: aA
  } = CA;
  updateAttributes("body", IA), updateAttributes("html", BA), updateTitle(eA, aA);
  const GA = {
    baseTag: updateTags("base", AA),
    linkTags: updateTags("link", QA),
    metaTags: updateTags("meta", EA),
    noscriptTags: updateTags("noscript", iA),
    scriptTags: updateTags("script", cA),
    styleTags: updateTags("style", tA)
  }, lA = {}, nA = {};
  Object.keys(GA).forEach((DA) => {
    const { newTags: hA, oldTags: wA } = GA[DA];
    hA.length && (lA[DA] = hA), wA.length && (nA[DA] = GA[DA].oldTags);
  }), gA && gA(), oA(CA, lA, nA);
}, _helmetCallback = null, handleStateChangeOnClient$1 = (CA) => {
  _helmetCallback && cancelAnimationFrame(_helmetCallback), CA.defer ? _helmetCallback = requestAnimationFrame(() => {
    commitTagChanges(CA, () => {
      _helmetCallback = null;
    });
  }) : (commitTagChanges(CA), _helmetCallback = null);
}, client_default = handleStateChangeOnClient$1, HelmetDispatcher = class extends Component {
  rendered = !1;
  shouldComponentUpdate(CA) {
    return !shallowEqual(CA, this.props);
  }
  componentDidUpdate() {
    this.emitChange();
  }
  componentWillUnmount() {
    const { helmetInstances: CA } = this.props.context;
    CA.remove(this), this.emitChange();
  }
  emitChange() {
    const { helmetInstances: CA, setHelmet: gA } = this.props.context;
    let AA = null;
    const IA = reducePropsToState$1(
      CA.get().map((BA) => {
        const { context: QA, ...EA } = BA.props;
        return EA;
      })
    );
    HelmetProvider.canUseDOM ? client_default(IA) : server_default && (AA = server_default(IA)), gA(AA);
  }
  // componentWillMount will be deprecated
  // for SSR, initialize on first render
  // constructor is also unsafe in StrictMode
  init() {
    if (this.rendered)
      return;
    this.rendered = !0;
    const { helmetInstances: CA } = this.props.context;
    CA.add(this), this.emitChange();
  }
  render() {
    return this.init(), null;
  }
}, react19Instances = [], toHtmlAttributes = (CA) => {
  const gA = {};
  for (const AA of Object.keys(CA))
    gA[HTML_TAG_MAP[AA] || AA] = CA[AA];
  return gA;
}, toReactProps = (CA) => {
  const gA = {};
  for (const AA of Object.keys(CA)) {
    const IA = REACT_TAG_MAP[AA];
    gA[IA || AA] = CA[AA];
  }
  return gA;
}, applyAttributes = (CA, gA) => {
  if (!isDocument)
    return;
  const AA = document.getElementsByTagName(CA)[0];
  if (!AA)
    return;
  const IA = "data-rh-managed", BA = AA.getAttribute(IA), QA = BA ? BA.split(",") : [], EA = Object.keys(gA);
  for (const iA of QA)
    EA.includes(iA) || AA.removeAttribute(iA);
  for (const iA of EA) {
    const oA = gA[iA];
    oA == null || oA === !1 ? AA.removeAttribute(iA) : oA === !0 ? AA.setAttribute(iA, "") : AA.setAttribute(iA, String(oA));
  }
  EA.length > 0 ? AA.setAttribute(IA, EA.join(",")) : AA.removeAttribute(IA);
}, syncAllAttributes = () => {
  const CA = {}, gA = {};
  for (const AA of react19Instances) {
    const { htmlAttributes: IA, bodyAttributes: BA } = AA.props;
    IA && Object.assign(CA, toHtmlAttributes(IA)), BA && Object.assign(gA, toHtmlAttributes(BA));
  }
  applyAttributes("html", CA), applyAttributes("body", gA);
}, React19Dispatcher = class extends Component {
  componentDidMount() {
    react19Instances.push(this), syncAllAttributes();
  }
  componentDidUpdate() {
    syncAllAttributes();
  }
  componentWillUnmount() {
    const CA = react19Instances.indexOf(this);
    CA !== -1 && react19Instances.splice(CA, 1), syncAllAttributes();
  }
  resolveTitle() {
    const { title: CA, titleTemplate: gA, defaultTitle: AA } = this.props;
    return CA && gA ? gA.replace(/%s/g, () => Array.isArray(CA) ? CA.join("") : CA) : CA || AA || void 0;
  }
  renderTitle() {
    const CA = this.resolveTitle();
    if (CA === void 0)
      return null;
    const gA = this.props.titleAttributes || {};
    return React__default.createElement("title", toReactProps(gA), CA);
  }
  renderBase() {
    const { base: CA } = this.props;
    return CA ? React__default.createElement("base", toReactProps(CA)) : null;
  }
  renderMeta() {
    const { meta: CA } = this.props;
    return !CA || !Array.isArray(CA) ? null : CA.map(
      (gA, AA) => React__default.createElement("meta", {
        key: AA,
        ...toReactProps(gA)
      })
    );
  }
  renderLink() {
    const { link: CA } = this.props;
    return !CA || !Array.isArray(CA) ? null : CA.map(
      (gA, AA) => React__default.createElement("link", {
        key: AA,
        ...toReactProps(gA)
      })
    );
  }
  renderScript() {
    const { script: CA } = this.props;
    return !CA || !Array.isArray(CA) ? null : CA.map((gA, AA) => {
      const { innerHTML: IA, ...BA } = gA, QA = toReactProps(BA);
      return IA && (QA.dangerouslySetInnerHTML = { __html: IA }), React__default.createElement("script", { key: AA, ...QA });
    });
  }
  renderStyle() {
    const { style: CA } = this.props;
    return !CA || !Array.isArray(CA) ? null : CA.map((gA, AA) => {
      const { cssText: IA, ...BA } = gA, QA = toReactProps(BA);
      return IA && (QA.dangerouslySetInnerHTML = { __html: IA }), React__default.createElement("style", { key: AA, ...QA });
    });
  }
  renderNoscript() {
    const { noscript: CA } = this.props;
    return !CA || !Array.isArray(CA) ? null : CA.map((gA, AA) => {
      const { innerHTML: IA, ...BA } = gA, QA = toReactProps(BA);
      return IA && (QA.dangerouslySetInnerHTML = { __html: IA }), React__default.createElement("noscript", { key: AA, ...QA });
    });
  }
  render() {
    return React__default.createElement(
      React__default.Fragment,
      null,
      this.renderTitle(),
      this.renderBase(),
      this.renderMeta(),
      this.renderLink(),
      this.renderScript(),
      this.renderStyle(),
      this.renderNoscript()
    );
  }
}, Helmet = class extends Component {
  static defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
  };
  shouldComponentUpdate(CA) {
    return !fastCompare(without(this.props, "helmetData"), without(CA, "helmetData"));
  }
  mapNestedChildrenToProps(CA, gA) {
    if (!gA)
      return null;
    switch (CA.type) {
      case "script":
      case "noscript":
        return {
          innerHTML: gA
        };
      case "style":
        return {
          cssText: gA
        };
      default:
        throw new Error(
          `<${CA.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`
        );
    }
  }
  flattenArrayTypeChildren(CA, gA, AA, IA) {
    return {
      ...gA,
      [CA.type]: [
        ...gA[CA.type] || [],
        {
          ...AA,
          ...this.mapNestedChildrenToProps(CA, IA)
        }
      ]
    };
  }
  mapObjectTypeChildren(CA, gA, AA, IA) {
    switch (CA.type) {
      case "title":
        return {
          ...gA,
          [CA.type]: IA,
          titleAttributes: { ...AA }
        };
      case "body":
        return {
          ...gA,
          bodyAttributes: { ...AA }
        };
      case "html":
        return {
          ...gA,
          htmlAttributes: { ...AA }
        };
      default:
        return {
          ...gA,
          [CA.type]: { ...AA }
        };
    }
  }
  mapArrayTypeChildrenToProps(CA, gA) {
    let AA = { ...gA };
    return Object.keys(CA).forEach((IA) => {
      AA = {
        ...AA,
        [IA]: CA[IA]
      };
    }), AA;
  }
  warnOnInvalidChildren(CA, gA) {
    return invariant(
      VALID_TAG_NAMES.some((AA) => CA.type === AA),
      typeof CA.type == "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : `Only elements types ${VALID_TAG_NAMES.join(
        ", "
      )} are allowed. Helmet does not support rendering <${CA.type}> elements. Refer to our API for more information.`
    ), invariant(
      !gA || typeof gA == "string" || Array.isArray(gA) && !gA.some((AA) => typeof AA != "string"),
      `Helmet expects a string as a child of <${CA.type}>. Did you forget to wrap your children in braces? ( <${CA.type}>{\`\`}</${CA.type}> ) Refer to our API for more information.`
    ), !0;
  }
  mapChildrenToProps(CA, gA) {
    let AA = {};
    return React__default.Children.forEach(CA, (IA) => {
      if (!IA || !IA.props)
        return;
      const { children: BA, ...QA } = IA.props, EA = Object.keys(QA).reduce((oA, cA) => (oA[HTML_TAG_MAP[cA] || cA] = QA[cA], oA), {});
      let { type: iA } = IA;
      switch (typeof iA == "symbol" ? iA = iA.toString() : this.warnOnInvalidChildren(IA, BA), iA) {
        case "Symbol(react.fragment)":
          gA = this.mapChildrenToProps(BA, gA);
          break;
        case "link":
        case "meta":
        case "noscript":
        case "script":
        case "style":
          AA = this.flattenArrayTypeChildren(
            IA,
            AA,
            EA,
            BA
          );
          break;
        default:
          gA = this.mapObjectTypeChildren(IA, gA, EA, BA);
          break;
      }
    }), this.mapArrayTypeChildrenToProps(AA, gA);
  }
  render() {
    const { children: CA, ...gA } = this.props;
    let AA = { ...gA }, { helmetData: IA } = gA;
    if (CA && (AA = this.mapChildrenToProps(CA, AA)), IA && !(IA instanceof HelmetData)) {
      const BA = IA;
      IA = new HelmetData(BA.context, !0), delete AA.helmetData;
    }
    return isReact19 ? /* @__PURE__ */ React__default.createElement(React19Dispatcher, { ...AA }) : IA ? /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...AA, context: IA.value }) : /* @__PURE__ */ React__default.createElement(Context.Consumer, null, (BA) => /* @__PURE__ */ React__default.createElement(HelmetDispatcher, { ...AA, context: BA }));
  }
};
const FontSources = ({
  fontSources: CA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Helmet, { children: Object.entries(CA).map(([gA, AA]) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { id: gA, rel: "stylesheet", href: AA }, gA)) });
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let CA, gA;
  const AA = new Promise((IA, BA) => {
    CA = IA, gA = BA;
  });
  return {
    resolve: CA,
    reject: gA,
    promise: AA
  };
});
function getCookie(CA) {
  const gA = document.cookie.match(`\\b${CA}=([^;]*)\\b`);
  return gA ? gA[1] : void 0;
}
function localStorageAvailable() {
  const CA = "testData";
  try {
    const {
      localStorage: gA
    } = window;
    gA.setItem(CA, CA), gA.getItem(CA), gA.removeItem(CA);
  } catch {
    return !1;
  }
  return !0;
}
function isValidAllowedOrigins(CA) {
  return Array.isArray(CA) && CA.length > 0 && CA.every((gA) => typeof gA == "string" && gA.trim().length > 0);
}
function deepClone(CA) {
  return typeof structuredClone == "function" ? structuredClone(CA) : JSON.parse(JSON.stringify(CA));
}
function deepFreeze(CA) {
  return Object.freeze(CA), Array.isArray(CA) ? CA.forEach((gA) => {
    gA !== null && typeof gA == "object" && !Object.isFrozen(gA) && deepFreeze(gA);
  }) : Object.values(CA).forEach((gA) => {
    gA !== null && typeof gA == "object" && !Object.isFrozen(gA) && deepFreeze(gA);
  }), CA;
}
const capturedConfig = (() => {
  const CA = window.__streamlit;
  if (!CA)
    return;
  const gA = deepClone(CA);
  return deepFreeze(gA);
})(), StreamlitConfig = {
  get BACKEND_BASE_URL() {
    return capturedConfig?.BACKEND_BASE_URL;
  },
  get HOST_CONFIG_BASE_URL() {
    return capturedConfig?.HOST_CONFIG_BASE_URL;
  },
  get DOWNLOAD_ASSETS_BASE_URL() {
    return capturedConfig?.DOWNLOAD_ASSETS_BASE_URL;
  },
  get MAIN_PAGE_BASE_URL() {
    return capturedConfig?.MAIN_PAGE_BASE_URL;
  },
  get CUSTOM_COMPONENT_CLIENT_ID() {
    return capturedConfig?.CUSTOM_COMPONENT_CLIENT_ID;
  },
  get LIGHT_THEME() {
    return capturedConfig?.LIGHT_THEME;
  },
  get DARK_THEME() {
    return capturedConfig?.DARK_THEME;
  },
  get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
    return capturedConfig?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
  },
  get HOST_CONFIG() {
    return capturedConfig?.HOST_CONFIG;
  }
};
function notNullOrUndefined(CA) {
  return CA != null;
}
function isNullOrUndefined$1(CA) {
  return CA == null;
}
const isLocalhost = () => window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1", NO_SCRIPT_RUN_ID = "NO_SCRIPT_RUN_ID";
var indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = CA;
  function CA(gA, AA) {
    for (var IA = new Array(arguments.length - 1), BA = 0, QA = 2, EA = !0; QA < arguments.length; )
      IA[BA++] = arguments[QA++];
    return new Promise(function(oA, cA) {
      IA[BA] = function(eA) {
        if (EA)
          if (EA = !1, eA)
            cA(eA);
          else {
            for (var aA = new Array(arguments.length - 1), GA = 0; GA < aA.length; )
              aA[GA++] = arguments[GA];
            oA.apply(null, aA);
          }
      };
      try {
        gA.apply(AA || null, IA);
      } catch (tA) {
        EA && (EA = !1, cA(tA));
      }
    });
  }
  return aspromise;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, (function(CA) {
    var gA = CA;
    gA.length = function(iA) {
      var oA = iA.length;
      if (!oA)
        return 0;
      for (var cA = 0; --oA % 4 > 1 && iA.charAt(oA) === "="; )
        ++cA;
      return Math.ceil(iA.length * 3) / 4 - cA;
    };
    for (var AA = new Array(64), IA = new Array(123), BA = 0; BA < 64; )
      IA[AA[BA] = BA < 26 ? BA + 65 : BA < 52 ? BA + 71 : BA < 62 ? BA - 4 : BA - 59 | 43] = BA++;
    gA.encode = function(iA, oA, cA) {
      for (var tA = null, eA = [], aA = 0, GA = 0, lA; oA < cA; ) {
        var nA = iA[oA++];
        switch (GA) {
          case 0:
            eA[aA++] = AA[nA >> 2], lA = (nA & 3) << 4, GA = 1;
            break;
          case 1:
            eA[aA++] = AA[lA | nA >> 4], lA = (nA & 15) << 2, GA = 2;
            break;
          case 2:
            eA[aA++] = AA[lA | nA >> 6], eA[aA++] = AA[nA & 63], GA = 0;
            break;
        }
        aA > 8191 && ((tA || (tA = [])).push(String.fromCharCode.apply(String, eA)), aA = 0);
      }
      return GA && (eA[aA++] = AA[lA], eA[aA++] = 61, GA === 1 && (eA[aA++] = 61)), tA ? (aA && tA.push(String.fromCharCode.apply(String, eA.slice(0, aA))), tA.join("")) : String.fromCharCode.apply(String, eA.slice(0, aA));
    };
    var QA = "invalid encoding";
    gA.decode = function(iA, oA, cA) {
      for (var tA = cA, eA = 0, aA, GA = 0; GA < iA.length; ) {
        var lA = iA.charCodeAt(GA++);
        if (lA === 61 && eA > 1)
          break;
        if ((lA = IA[lA]) === void 0)
          throw Error(QA);
        switch (eA) {
          case 0:
            aA = lA, eA = 1;
            break;
          case 1:
            oA[cA++] = aA << 2 | (lA & 48) >> 4, aA = lA, eA = 2;
            break;
          case 2:
            oA[cA++] = (aA & 15) << 4 | (lA & 60) >> 2, aA = lA, eA = 3;
            break;
          case 3:
            oA[cA++] = (aA & 3) << 6 | lA, eA = 0;
            break;
        }
      }
      if (eA === 1)
        throw Error(QA);
      return cA - tA;
    }, gA.test = function(iA) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(iA);
    };
  })(base64)), base64;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = CA;
  function CA() {
    this._listeners = {};
  }
  return CA.prototype.on = function(AA, IA, BA) {
    return (this._listeners[AA] || (this._listeners[AA] = [])).push({
      fn: IA,
      ctx: BA || this
    }), this;
  }, CA.prototype.off = function(AA, IA) {
    if (AA === void 0)
      this._listeners = {};
    else if (IA === void 0)
      this._listeners[AA] = [];
    else
      for (var BA = this._listeners[AA], QA = 0; QA < BA.length; )
        BA[QA].fn === IA ? BA.splice(QA, 1) : ++QA;
    return this;
  }, CA.prototype.emit = function(AA) {
    var IA = this._listeners[AA];
    if (IA) {
      for (var BA = [], QA = 1; QA < arguments.length; )
        BA.push(arguments[QA++]);
      for (QA = 0; QA < IA.length; )
        IA[QA].fn.apply(IA[QA++].ctx, BA);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = CA(CA);
  function CA(QA) {
    return typeof Float32Array < "u" ? (function() {
      var EA = new Float32Array([-0]), iA = new Uint8Array(EA.buffer), oA = iA[3] === 128;
      function cA(GA, lA, nA) {
        EA[0] = GA, lA[nA] = iA[0], lA[nA + 1] = iA[1], lA[nA + 2] = iA[2], lA[nA + 3] = iA[3];
      }
      function tA(GA, lA, nA) {
        EA[0] = GA, lA[nA] = iA[3], lA[nA + 1] = iA[2], lA[nA + 2] = iA[1], lA[nA + 3] = iA[0];
      }
      QA.writeFloatLE = oA ? cA : tA, QA.writeFloatBE = oA ? tA : cA;
      function eA(GA, lA) {
        return iA[0] = GA[lA], iA[1] = GA[lA + 1], iA[2] = GA[lA + 2], iA[3] = GA[lA + 3], EA[0];
      }
      function aA(GA, lA) {
        return iA[3] = GA[lA], iA[2] = GA[lA + 1], iA[1] = GA[lA + 2], iA[0] = GA[lA + 3], EA[0];
      }
      QA.readFloatLE = oA ? eA : aA, QA.readFloatBE = oA ? aA : eA;
    })() : (function() {
      function EA(oA, cA, tA, eA) {
        var aA = cA < 0 ? 1 : 0;
        if (aA && (cA = -cA), cA === 0)
          oA(1 / cA > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), tA, eA);
        else if (isNaN(cA))
          oA(2143289344, tA, eA);
        else if (cA > 34028234663852886e22)
          oA((aA << 31 | 2139095040) >>> 0, tA, eA);
        else if (cA < 11754943508222875e-54)
          oA((aA << 31 | Math.round(cA / 1401298464324817e-60)) >>> 0, tA, eA);
        else {
          var GA = Math.floor(Math.log(cA) / Math.LN2), lA = Math.round(cA * Math.pow(2, -GA) * 8388608) & 8388607;
          oA((aA << 31 | GA + 127 << 23 | lA) >>> 0, tA, eA);
        }
      }
      QA.writeFloatLE = EA.bind(null, gA), QA.writeFloatBE = EA.bind(null, AA);
      function iA(oA, cA, tA) {
        var eA = oA(cA, tA), aA = (eA >> 31) * 2 + 1, GA = eA >>> 23 & 255, lA = eA & 8388607;
        return GA === 255 ? lA ? NaN : aA * (1 / 0) : GA === 0 ? aA * 1401298464324817e-60 * lA : aA * Math.pow(2, GA - 150) * (lA + 8388608);
      }
      QA.readFloatLE = iA.bind(null, IA), QA.readFloatBE = iA.bind(null, BA);
    })(), typeof Float64Array < "u" ? (function() {
      var EA = new Float64Array([-0]), iA = new Uint8Array(EA.buffer), oA = iA[7] === 128;
      function cA(GA, lA, nA) {
        EA[0] = GA, lA[nA] = iA[0], lA[nA + 1] = iA[1], lA[nA + 2] = iA[2], lA[nA + 3] = iA[3], lA[nA + 4] = iA[4], lA[nA + 5] = iA[5], lA[nA + 6] = iA[6], lA[nA + 7] = iA[7];
      }
      function tA(GA, lA, nA) {
        EA[0] = GA, lA[nA] = iA[7], lA[nA + 1] = iA[6], lA[nA + 2] = iA[5], lA[nA + 3] = iA[4], lA[nA + 4] = iA[3], lA[nA + 5] = iA[2], lA[nA + 6] = iA[1], lA[nA + 7] = iA[0];
      }
      QA.writeDoubleLE = oA ? cA : tA, QA.writeDoubleBE = oA ? tA : cA;
      function eA(GA, lA) {
        return iA[0] = GA[lA], iA[1] = GA[lA + 1], iA[2] = GA[lA + 2], iA[3] = GA[lA + 3], iA[4] = GA[lA + 4], iA[5] = GA[lA + 5], iA[6] = GA[lA + 6], iA[7] = GA[lA + 7], EA[0];
      }
      function aA(GA, lA) {
        return iA[7] = GA[lA], iA[6] = GA[lA + 1], iA[5] = GA[lA + 2], iA[4] = GA[lA + 3], iA[3] = GA[lA + 4], iA[2] = GA[lA + 5], iA[1] = GA[lA + 6], iA[0] = GA[lA + 7], EA[0];
      }
      QA.readDoubleLE = oA ? eA : aA, QA.readDoubleBE = oA ? aA : eA;
    })() : (function() {
      function EA(oA, cA, tA, eA, aA, GA) {
        var lA = eA < 0 ? 1 : 0;
        if (lA && (eA = -eA), eA === 0)
          oA(0, aA, GA + cA), oA(1 / eA > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), aA, GA + tA);
        else if (isNaN(eA))
          oA(0, aA, GA + cA), oA(2146959360, aA, GA + tA);
        else if (eA > 17976931348623157e292)
          oA(0, aA, GA + cA), oA((lA << 31 | 2146435072) >>> 0, aA, GA + tA);
        else {
          var nA;
          if (eA < 22250738585072014e-324)
            nA = eA / 5e-324, oA(nA >>> 0, aA, GA + cA), oA((lA << 31 | nA / 4294967296) >>> 0, aA, GA + tA);
          else {
            var DA = Math.floor(Math.log(eA) / Math.LN2);
            DA === 1024 && (DA = 1023), nA = eA * Math.pow(2, -DA), oA(nA * 4503599627370496 >>> 0, aA, GA + cA), oA((lA << 31 | DA + 1023 << 20 | nA * 1048576 & 1048575) >>> 0, aA, GA + tA);
          }
        }
      }
      QA.writeDoubleLE = EA.bind(null, gA, 0, 4), QA.writeDoubleBE = EA.bind(null, AA, 4, 0);
      function iA(oA, cA, tA, eA, aA) {
        var GA = oA(eA, aA + cA), lA = oA(eA, aA + tA), nA = (lA >> 31) * 2 + 1, DA = lA >>> 20 & 2047, hA = 4294967296 * (lA & 1048575) + GA;
        return DA === 2047 ? hA ? NaN : nA * (1 / 0) : DA === 0 ? nA * 5e-324 * hA : nA * Math.pow(2, DA - 1075) * (hA + 4503599627370496);
      }
      QA.readDoubleLE = iA.bind(null, IA, 0, 4), QA.readDoubleBE = iA.bind(null, BA, 4, 0);
    })(), QA;
  }
  function gA(QA, EA, iA) {
    EA[iA] = QA & 255, EA[iA + 1] = QA >>> 8 & 255, EA[iA + 2] = QA >>> 16 & 255, EA[iA + 3] = QA >>> 24;
  }
  function AA(QA, EA, iA) {
    EA[iA] = QA >>> 24, EA[iA + 1] = QA >>> 16 & 255, EA[iA + 2] = QA >>> 8 & 255, EA[iA + 3] = QA & 255;
  }
  function IA(QA, EA) {
    return (QA[EA] | QA[EA + 1] << 8 | QA[EA + 2] << 16 | QA[EA + 3] << 24) >>> 0;
  }
  function BA(QA, EA) {
    return (QA[EA] << 24 | QA[EA + 1] << 16 | QA[EA + 2] << 8 | QA[EA + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (CA) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, (function(CA) {
    var gA = CA;
    gA.length = function(IA) {
      for (var BA = 0, QA = 0, EA = 0; EA < IA.length; ++EA)
        QA = IA.charCodeAt(EA), QA < 128 ? BA += 1 : QA < 2048 ? BA += 2 : (QA & 64512) === 55296 && (IA.charCodeAt(EA + 1) & 64512) === 56320 ? (++EA, BA += 4) : BA += 3;
      return BA;
    }, gA.read = function(IA, BA, QA) {
      var EA = QA - BA;
      if (EA < 1)
        return "";
      for (var iA = null, oA = [], cA = 0, tA; BA < QA; )
        tA = IA[BA++], tA < 128 ? oA[cA++] = tA : tA > 191 && tA < 224 ? oA[cA++] = (tA & 31) << 6 | IA[BA++] & 63 : tA > 239 && tA < 365 ? (tA = ((tA & 7) << 18 | (IA[BA++] & 63) << 12 | (IA[BA++] & 63) << 6 | IA[BA++] & 63) - 65536, oA[cA++] = 55296 + (tA >> 10), oA[cA++] = 56320 + (tA & 1023)) : oA[cA++] = (tA & 15) << 12 | (IA[BA++] & 63) << 6 | IA[BA++] & 63, cA > 8191 && ((iA || (iA = [])).push(String.fromCharCode.apply(String, oA)), cA = 0);
      return iA ? (cA && iA.push(String.fromCharCode.apply(String, oA.slice(0, cA))), iA.join("")) : String.fromCharCode.apply(String, oA.slice(0, cA));
    }, gA.write = function(IA, BA, QA) {
      for (var EA = QA, iA, oA, cA = 0; cA < IA.length; ++cA)
        iA = IA.charCodeAt(cA), iA < 128 ? BA[QA++] = iA : iA < 2048 ? (BA[QA++] = iA >> 6 | 192, BA[QA++] = iA & 63 | 128) : (iA & 64512) === 55296 && ((oA = IA.charCodeAt(cA + 1)) & 64512) === 56320 ? (iA = 65536 + ((iA & 1023) << 10) + (oA & 1023), ++cA, BA[QA++] = iA >> 18 | 240, BA[QA++] = iA >> 12 & 63 | 128, BA[QA++] = iA >> 6 & 63 | 128, BA[QA++] = iA & 63 | 128) : (BA[QA++] = iA >> 12 | 224, BA[QA++] = iA >> 6 & 63 | 128, BA[QA++] = iA & 63 | 128);
      return QA - EA;
    };
  })(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = CA;
  function CA(gA, AA, IA) {
    var BA = IA || 8192, QA = BA >>> 1, EA = null, iA = BA;
    return function(cA) {
      if (cA < 1 || cA > QA)
        return gA(cA);
      iA + cA > BA && (EA = gA(BA), iA = 0);
      var tA = AA.call(EA, iA, iA += cA);
      return iA & 7 && (iA = (iA | 7) + 1), tA;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = gA;
  var CA = requireMinimal$1();
  function gA(QA, EA) {
    this.lo = QA >>> 0, this.hi = EA >>> 0;
  }
  var AA = gA.zero = new gA(0, 0);
  AA.toNumber = function() {
    return 0;
  }, AA.zzEncode = AA.zzDecode = function() {
    return this;
  }, AA.length = function() {
    return 1;
  };
  var IA = gA.zeroHash = "\0\0\0\0\0\0\0\0";
  gA.fromNumber = function(EA) {
    if (EA === 0)
      return AA;
    var iA = EA < 0;
    iA && (EA = -EA);
    var oA = EA >>> 0, cA = (EA - oA) / 4294967296 >>> 0;
    return iA && (cA = ~cA >>> 0, oA = ~oA >>> 0, ++oA > 4294967295 && (oA = 0, ++cA > 4294967295 && (cA = 0))), new gA(oA, cA);
  }, gA.from = function(EA) {
    if (typeof EA == "number")
      return gA.fromNumber(EA);
    if (CA.isString(EA))
      if (CA.Long)
        EA = CA.Long.fromString(EA);
      else
        return gA.fromNumber(parseInt(EA, 10));
    return EA.low || EA.high ? new gA(EA.low >>> 0, EA.high >>> 0) : AA;
  }, gA.prototype.toNumber = function(EA) {
    if (!EA && this.hi >>> 31) {
      var iA = ~this.lo + 1 >>> 0, oA = ~this.hi >>> 0;
      return iA || (oA = oA + 1 >>> 0), -(iA + oA * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, gA.prototype.toLong = function(EA) {
    return CA.Long ? new CA.Long(this.lo | 0, this.hi | 0, !!EA) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!EA };
  };
  var BA = String.prototype.charCodeAt;
  return gA.fromHash = function(EA) {
    return EA === IA ? AA : new gA(
      (BA.call(EA, 0) | BA.call(EA, 1) << 8 | BA.call(EA, 2) << 16 | BA.call(EA, 3) << 24) >>> 0,
      (BA.call(EA, 4) | BA.call(EA, 5) << 8 | BA.call(EA, 6) << 16 | BA.call(EA, 7) << 24) >>> 0
    );
  }, gA.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, gA.prototype.zzEncode = function() {
    var EA = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ EA) >>> 0, this.lo = (this.lo << 1 ^ EA) >>> 0, this;
  }, gA.prototype.zzDecode = function() {
    var EA = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ EA) >>> 0, this.hi = (this.hi >>> 1 ^ EA) >>> 0, this;
  }, gA.prototype.length = function() {
    var EA = this.lo, iA = (this.lo >>> 28 | this.hi << 4) >>> 0, oA = this.hi >>> 24;
    return oA === 0 ? iA === 0 ? EA < 16384 ? EA < 128 ? 1 : 2 : EA < 2097152 ? 3 : 4 : iA < 16384 ? iA < 128 ? 5 : 6 : iA < 2097152 ? 7 : 8 : oA < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, (function(CA) {
    var gA = CA;
    gA.asPromise = requireAspromise(), gA.base64 = requireBase64(), gA.EventEmitter = requireEventemitter(), gA.float = requireFloat(), gA.inquire = requireInquire(), gA.utf8 = requireUtf8(), gA.pool = requirePool(), gA.LongBits = requireLongbits(), gA.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), gA.global = gA.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, gA.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), gA.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), gA.isInteger = Number.isInteger || /* istanbul ignore next */
    function(QA) {
      return typeof QA == "number" && isFinite(QA) && Math.floor(QA) === QA;
    }, gA.isString = function(QA) {
      return typeof QA == "string" || QA instanceof String;
    }, gA.isObject = function(QA) {
      return QA && typeof QA == "object";
    }, gA.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    gA.isSet = function(QA, EA) {
      var iA = QA[EA];
      return iA != null && QA.hasOwnProperty(EA) ? typeof iA != "object" || (Array.isArray(iA) ? iA.length : Object.keys(iA).length) > 0 : !1;
    }, gA.Buffer = (function() {
      try {
        var BA = gA.inquire("buffer").Buffer;
        return BA.prototype.utf8Write ? BA : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), gA._Buffer_from = null, gA._Buffer_allocUnsafe = null, gA.newBuffer = function(QA) {
      return typeof QA == "number" ? gA.Buffer ? gA._Buffer_allocUnsafe(QA) : new gA.Array(QA) : gA.Buffer ? gA._Buffer_from(QA) : typeof Uint8Array > "u" ? QA : new Uint8Array(QA);
    }, gA.Array = typeof Uint8Array < "u" ? Uint8Array : Array, gA.Long = /* istanbul ignore next */
    gA.global.dcodeIO && /* istanbul ignore next */
    gA.global.dcodeIO.Long || /* istanbul ignore next */
    gA.global.Long || gA.inquire("long"), gA.key2Re = /^true|false|0|1$/, gA.key32Re = /^-?(?:0|[1-9][0-9]*)$/, gA.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, gA.longToHash = function(QA) {
      return QA ? gA.LongBits.from(QA).toHash() : gA.LongBits.zeroHash;
    }, gA.longFromHash = function(QA, EA) {
      var iA = gA.LongBits.fromHash(QA);
      return gA.Long ? gA.Long.fromBits(iA.lo, iA.hi, EA) : iA.toNumber(!!EA);
    };
    function AA(BA, QA, EA) {
      for (var iA = Object.keys(QA), oA = 0; oA < iA.length; ++oA)
        (BA[iA[oA]] === void 0 || !EA) && (BA[iA[oA]] = QA[iA[oA]]);
      return BA;
    }
    gA.merge = AA, gA.lcFirst = function(QA) {
      return QA.charAt(0).toLowerCase() + QA.substring(1);
    };
    function IA(BA) {
      function QA(EA, iA) {
        if (!(this instanceof QA))
          return new QA(EA, iA);
        Object.defineProperty(this, "message", { get: function() {
          return EA;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, QA) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), iA && AA(this, iA);
      }
      return QA.prototype = Object.create(Error.prototype, {
        constructor: {
          value: QA,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return BA;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), QA;
    }
    gA.newError = IA, gA.ProtocolError = IA("ProtocolError"), gA.oneOfGetter = function(QA) {
      for (var EA = {}, iA = 0; iA < QA.length; ++iA)
        EA[QA[iA]] = 1;
      return function() {
        for (var oA = Object.keys(this), cA = oA.length - 1; cA > -1; --cA)
          if (EA[oA[cA]] === 1 && this[oA[cA]] !== void 0 && this[oA[cA]] !== null)
            return oA[cA];
      };
    }, gA.oneOfSetter = function(QA) {
      return function(EA) {
        for (var iA = 0; iA < QA.length; ++iA)
          QA[iA] !== EA && delete this[QA[iA]];
      };
    }, gA.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, gA._configure = function() {
      var BA = gA.Buffer;
      if (!BA) {
        gA._Buffer_from = gA._Buffer_allocUnsafe = null;
        return;
      }
      gA._Buffer_from = BA.from !== Uint8Array.from && BA.from || /* istanbul ignore next */
      function(EA, iA) {
        return new BA(EA, iA);
      }, gA._Buffer_allocUnsafe = BA.allocUnsafe || /* istanbul ignore next */
      function(EA) {
        return new BA(EA);
      };
    };
  })(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = oA;
  var CA = requireMinimal$1(), gA, AA = CA.LongBits, IA = CA.base64, BA = CA.utf8;
  function QA(DA, hA, wA) {
    this.fn = DA, this.len = hA, this.next = void 0, this.val = wA;
  }
  function EA() {
  }
  function iA(DA) {
    this.head = DA.head, this.tail = DA.tail, this.len = DA.len, this.next = DA.states;
  }
  function oA() {
    this.len = 0, this.head = new QA(EA, 0, 0), this.tail = this.head, this.states = null;
  }
  var cA = function() {
    return CA.Buffer ? function() {
      return (oA.create = function() {
        return new gA();
      })();
    } : function() {
      return new oA();
    };
  };
  oA.create = cA(), oA.alloc = function(hA) {
    return new CA.Array(hA);
  }, CA.Array !== Array && (oA.alloc = CA.pool(oA.alloc, CA.Array.prototype.subarray)), oA.prototype._push = function(hA, wA, sA) {
    return this.tail = this.tail.next = new QA(hA, wA, sA), this.len += wA, this;
  };
  function tA(DA, hA, wA) {
    hA[wA] = DA & 255;
  }
  function eA(DA, hA, wA) {
    for (; DA > 127; )
      hA[wA++] = DA & 127 | 128, DA >>>= 7;
    hA[wA] = DA;
  }
  function aA(DA, hA) {
    this.len = DA, this.next = void 0, this.val = hA;
  }
  aA.prototype = Object.create(QA.prototype), aA.prototype.fn = eA, oA.prototype.uint32 = function(hA) {
    return this.len += (this.tail = this.tail.next = new aA(
      (hA = hA >>> 0) < 128 ? 1 : hA < 16384 ? 2 : hA < 2097152 ? 3 : hA < 268435456 ? 4 : 5,
      hA
    )).len, this;
  }, oA.prototype.int32 = function(hA) {
    return hA < 0 ? this._push(GA, 10, AA.fromNumber(hA)) : this.uint32(hA);
  }, oA.prototype.sint32 = function(hA) {
    return this.uint32((hA << 1 ^ hA >> 31) >>> 0);
  };
  function GA(DA, hA, wA) {
    for (; DA.hi; )
      hA[wA++] = DA.lo & 127 | 128, DA.lo = (DA.lo >>> 7 | DA.hi << 25) >>> 0, DA.hi >>>= 7;
    for (; DA.lo > 127; )
      hA[wA++] = DA.lo & 127 | 128, DA.lo = DA.lo >>> 7;
    hA[wA++] = DA.lo;
  }
  oA.prototype.uint64 = function(hA) {
    var wA = AA.from(hA);
    return this._push(GA, wA.length(), wA);
  }, oA.prototype.int64 = oA.prototype.uint64, oA.prototype.sint64 = function(hA) {
    var wA = AA.from(hA).zzEncode();
    return this._push(GA, wA.length(), wA);
  }, oA.prototype.bool = function(hA) {
    return this._push(tA, 1, hA ? 1 : 0);
  };
  function lA(DA, hA, wA) {
    hA[wA] = DA & 255, hA[wA + 1] = DA >>> 8 & 255, hA[wA + 2] = DA >>> 16 & 255, hA[wA + 3] = DA >>> 24;
  }
  oA.prototype.fixed32 = function(hA) {
    return this._push(lA, 4, hA >>> 0);
  }, oA.prototype.sfixed32 = oA.prototype.fixed32, oA.prototype.fixed64 = function(hA) {
    var wA = AA.from(hA);
    return this._push(lA, 4, wA.lo)._push(lA, 4, wA.hi);
  }, oA.prototype.sfixed64 = oA.prototype.fixed64, oA.prototype.float = function(hA) {
    return this._push(CA.float.writeFloatLE, 4, hA);
  }, oA.prototype.double = function(hA) {
    return this._push(CA.float.writeDoubleLE, 8, hA);
  };
  var nA = CA.Array.prototype.set ? function(hA, wA, sA) {
    wA.set(hA, sA);
  } : function(hA, wA, sA) {
    for (var NA = 0; NA < hA.length; ++NA)
      wA[sA + NA] = hA[NA];
  };
  return oA.prototype.bytes = function(hA) {
    var wA = hA.length >>> 0;
    if (!wA)
      return this._push(tA, 1, 0);
    if (CA.isString(hA)) {
      var sA = oA.alloc(wA = IA.length(hA));
      IA.decode(hA, sA, 0), hA = sA;
    }
    return this.uint32(wA)._push(nA, wA, hA);
  }, oA.prototype.string = function(hA) {
    var wA = BA.length(hA);
    return wA ? this.uint32(wA)._push(BA.write, wA, hA) : this._push(tA, 1, 0);
  }, oA.prototype.fork = function() {
    return this.states = new iA(this), this.head = this.tail = new QA(EA, 0, 0), this.len = 0, this;
  }, oA.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new QA(EA, 0, 0), this.len = 0), this;
  }, oA.prototype.ldelim = function() {
    var hA = this.head, wA = this.tail, sA = this.len;
    return this.reset().uint32(sA), sA && (this.tail.next = hA.next, this.tail = wA, this.len += sA), this;
  }, oA.prototype.finish = function() {
    for (var hA = this.head.next, wA = this.constructor.alloc(this.len), sA = 0; hA; )
      hA.fn(hA.val, wA, sA), sA += hA.len, hA = hA.next;
    return wA;
  }, oA._configure = function(DA) {
    gA = DA, oA.create = cA(), gA._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = AA;
  var CA = requireWriter();
  (AA.prototype = Object.create(CA.prototype)).constructor = AA;
  var gA = requireMinimal$1();
  function AA() {
    CA.call(this);
  }
  AA._configure = function() {
    AA.alloc = gA._Buffer_allocUnsafe, AA.writeBytesBuffer = gA.Buffer && gA.Buffer.prototype instanceof Uint8Array && gA.Buffer.prototype.set.name === "set" ? function(QA, EA, iA) {
      EA.set(QA, iA);
    } : function(QA, EA, iA) {
      if (QA.copy)
        QA.copy(EA, iA, 0, QA.length);
      else for (var oA = 0; oA < QA.length; )
        EA[iA++] = QA[oA++];
    };
  }, AA.prototype.bytes = function(QA) {
    gA.isString(QA) && (QA = gA._Buffer_from(QA, "base64"));
    var EA = QA.length >>> 0;
    return this.uint32(EA), EA && this._push(AA.writeBytesBuffer, EA, QA), this;
  };
  function IA(BA, QA, EA) {
    BA.length < 40 ? gA.utf8.write(BA, QA, EA) : QA.utf8Write ? QA.utf8Write(BA, EA) : QA.write(BA, EA);
  }
  return AA.prototype.string = function(QA) {
    var EA = gA.Buffer.byteLength(QA);
    return this.uint32(EA), EA && this._push(IA, EA, QA), this;
  }, AA._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = QA;
  var CA = requireMinimal$1(), gA, AA = CA.LongBits, IA = CA.utf8;
  function BA(eA, aA) {
    return RangeError("index out of range: " + eA.pos + " + " + (aA || 1) + " > " + eA.len);
  }
  function QA(eA) {
    this.buf = eA, this.pos = 0, this.len = eA.length;
  }
  var EA = typeof Uint8Array < "u" ? function(aA) {
    if (aA instanceof Uint8Array || Array.isArray(aA))
      return new QA(aA);
    throw Error("illegal buffer");
  } : function(aA) {
    if (Array.isArray(aA))
      return new QA(aA);
    throw Error("illegal buffer");
  }, iA = function() {
    return CA.Buffer ? function(GA) {
      return (QA.create = function(nA) {
        return CA.Buffer.isBuffer(nA) ? new gA(nA) : EA(nA);
      })(GA);
    } : EA;
  };
  QA.create = iA(), QA.prototype._slice = CA.Array.prototype.subarray || /* istanbul ignore next */
  CA.Array.prototype.slice, QA.prototype.uint32 = /* @__PURE__ */ (function() {
    var aA = 4294967295;
    return function() {
      if (aA = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (aA = (aA | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (aA = (aA | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (aA = (aA | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (aA = (aA | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return aA;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, BA(this, 10);
      return aA;
    };
  })(), QA.prototype.int32 = function() {
    return this.uint32() | 0;
  }, QA.prototype.sint32 = function() {
    var aA = this.uint32();
    return aA >>> 1 ^ -(aA & 1) | 0;
  };
  function oA() {
    var eA = new AA(0, 0), aA = 0;
    if (this.len - this.pos > 4) {
      for (; aA < 4; ++aA)
        if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << aA * 7) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << 28) >>> 0, eA.hi = (eA.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return eA;
      aA = 0;
    } else {
      for (; aA < 3; ++aA) {
        if (this.pos >= this.len)
          throw BA(this);
        if (eA.lo = (eA.lo | (this.buf[this.pos] & 127) << aA * 7) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      }
      return eA.lo = (eA.lo | (this.buf[this.pos++] & 127) << aA * 7) >>> 0, eA;
    }
    if (this.len - this.pos > 4) {
      for (; aA < 5; ++aA)
        if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << aA * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return eA;
    } else
      for (; aA < 5; ++aA) {
        if (this.pos >= this.len)
          throw BA(this);
        if (eA.hi = (eA.hi | (this.buf[this.pos] & 127) << aA * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return eA;
      }
    throw Error("invalid varint encoding");
  }
  QA.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function cA(eA, aA) {
    return (eA[aA - 4] | eA[aA - 3] << 8 | eA[aA - 2] << 16 | eA[aA - 1] << 24) >>> 0;
  }
  QA.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw BA(this, 4);
    return cA(this.buf, this.pos += 4);
  }, QA.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw BA(this, 4);
    return cA(this.buf, this.pos += 4) | 0;
  };
  function tA() {
    if (this.pos + 8 > this.len)
      throw BA(this, 8);
    return new AA(cA(this.buf, this.pos += 4), cA(this.buf, this.pos += 4));
  }
  return QA.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw BA(this, 4);
    var aA = CA.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, aA;
  }, QA.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw BA(this, 4);
    var aA = CA.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, aA;
  }, QA.prototype.bytes = function() {
    var aA = this.uint32(), GA = this.pos, lA = this.pos + aA;
    if (lA > this.len)
      throw BA(this, aA);
    if (this.pos += aA, Array.isArray(this.buf))
      return this.buf.slice(GA, lA);
    if (GA === lA) {
      var nA = CA.Buffer;
      return nA ? nA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, GA, lA);
  }, QA.prototype.string = function() {
    var aA = this.bytes();
    return IA.read(aA, 0, aA.length);
  }, QA.prototype.skip = function(aA) {
    if (typeof aA == "number") {
      if (this.pos + aA > this.len)
        throw BA(this, aA);
      this.pos += aA;
    } else
      do
        if (this.pos >= this.len)
          throw BA(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, QA.prototype.skipType = function(eA) {
    switch (eA) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (eA = this.uint32() & 7) !== 4; )
          this.skipType(eA);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + eA + " at offset " + this.pos);
    }
    return this;
  }, QA._configure = function(eA) {
    gA = eA, QA.create = iA(), gA._configure();
    var aA = CA.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    CA.merge(QA.prototype, {
      int64: function() {
        return oA.call(this)[aA](!1);
      },
      uint64: function() {
        return oA.call(this)[aA](!0);
      },
      sint64: function() {
        return oA.call(this).zzDecode()[aA](!1);
      },
      fixed64: function() {
        return tA.call(this)[aA](!0);
      },
      sfixed64: function() {
        return tA.call(this)[aA](!1);
      }
    });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = AA;
  var CA = requireReader();
  (AA.prototype = Object.create(CA.prototype)).constructor = AA;
  var gA = requireMinimal$1();
  function AA(IA) {
    CA.call(this, IA);
  }
  return AA._configure = function() {
    gA.Buffer && (AA.prototype._slice = gA.Buffer.prototype.slice);
  }, AA.prototype.string = function() {
    var BA = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + BA, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + BA, this.len));
  }, AA._configure(), reader_buffer;
}
var rpc = {}, service$1, hasRequiredService$1;
function requireService$1() {
  if (hasRequiredService$1) return service$1;
  hasRequiredService$1 = 1, service$1 = gA;
  var CA = requireMinimal$1();
  (gA.prototype = Object.create(CA.EventEmitter.prototype)).constructor = gA;
  function gA(AA, IA, BA) {
    if (typeof AA != "function")
      throw TypeError("rpcImpl must be a function");
    CA.EventEmitter.call(this), this.rpcImpl = AA, this.requestDelimited = !!IA, this.responseDelimited = !!BA;
  }
  return gA.prototype.rpcCall = function AA(IA, BA, QA, EA, iA) {
    if (!EA)
      throw TypeError("request must be specified");
    var oA = this;
    if (!iA)
      return CA.asPromise(AA, oA, IA, BA, QA, EA);
    if (!oA.rpcImpl) {
      setTimeout(function() {
        iA(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return oA.rpcImpl(
        IA,
        BA[oA.requestDelimited ? "encodeDelimited" : "encode"](EA).finish(),
        function(tA, eA) {
          if (tA)
            return oA.emit("error", tA, IA), iA(tA);
          if (eA === null) {
            oA.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!(eA instanceof QA))
            try {
              eA = QA[oA.responseDelimited ? "decodeDelimited" : "decode"](eA);
            } catch (aA) {
              return oA.emit("error", aA, IA), iA(aA);
            }
          return oA.emit("data", eA, IA), iA(null, eA);
        }
      );
    } catch (cA) {
      oA.emit("error", cA, IA), setTimeout(function() {
        iA(cA);
      }, 0);
      return;
    }
  }, gA.prototype.end = function(IA) {
    return this.rpcImpl && (IA || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service$1;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, (function(CA) {
    var gA = CA;
    gA.Service = requireService$1();
  })(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, (function(CA) {
    var gA = CA;
    gA.build = "minimal", gA.Writer = requireWriter(), gA.BufferWriter = requireWriter_buffer(), gA.Reader = requireReader(), gA.BufferReader = requireReader_buffer(), gA.util = requireMinimal$1(), gA.rpc = requireRpc(), gA.roots = requireRoots(), gA.configure = AA;
    function AA() {
      gA.util._configure(), gA.Writer._configure(gA.BufferWriter), gA.Reader._configure(gA.BufferReader);
    }
    AA();
  })(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var minimalExports = requireMinimal();
const $Reader$1 = minimalExports.Reader, $Writer$1 = minimalExports.Writer, $util$1 = minimalExports.util, $root$1 = minimalExports.roots.default || (minimalExports.roots.default = {}), Alert = $root$1.Alert = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.format = 0, CA.prototype.icon = "", CA.prototype.widthConfig = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.body), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(AA.format), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.icon), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Alert();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.body = AA.string();
          break;
        }
        case 2: {
          EA.format = AA.int32();
          break;
        }
        case 3: {
          EA.icon = AA.string();
          break;
        }
        case 4: {
          EA.widthConfig = $root$1.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Alert) return AA;
    let IA = new $root$1.Alert();
    switch (AA.body != null && (IA.body = String(AA.body)), AA.format) {
      default:
        if (typeof AA.format == "number") {
          IA.format = AA.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        IA.format = 0;
        break;
      case "ERROR":
      case 1:
        IA.format = 1;
        break;
      case "WARNING":
      case 2:
        IA.format = 2;
        break;
      case "INFO":
      case 3:
        IA.format = 3;
        break;
      case "SUCCESS":
      case 4:
        IA.format = 4;
        break;
    }
    if (AA.icon != null && (IA.icon = String(AA.icon)), AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      IA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.body = "", BA.format = IA.enums === String ? "UNUSED" : 0, BA.icon = "", BA.widthConfig = null), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.format != null && AA.hasOwnProperty("format") && (BA.format = IA.enums === String ? $root$1.Alert.Format[AA.format] === void 0 ? AA.format : $root$1.Alert.Format[AA.format] : AA.format), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root$1.streamlit.WidthConfig.toObject(AA.widthConfig, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Alert";
  }, CA.Format = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNUSED"] = 0, AA[gA[1] = "ERROR"] = 1, AA[gA[2] = "WARNING"] = 2, AA[gA[3] = "INFO"] = 3, AA[gA[4] = "SUCCESS"] = 4, AA;
  })(), CA;
})(), streamlit = $root$1.streamlit = (() => {
  const CA = {};
  return CA.WidthConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.useStretch = null, gA.prototype.useContent = null, gA.prototype.pixelWidth = null, gA.prototype.remWidth = null;
    let AA;
    return Object.defineProperty(gA.prototype, "widthSpec", { get: $util$1.oneOfGetter(AA = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.useStretch != null && Object.hasOwnProperty.call(BA, "useStretch") && QA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(BA.useStretch), BA.useContent != null && Object.hasOwnProperty.call(BA, "useContent") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(BA.useContent), BA.pixelWidth != null && Object.hasOwnProperty.call(BA, "pixelWidth") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(BA.pixelWidth), BA.remWidth != null && Object.hasOwnProperty.call(BA, "remWidth") && QA.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(BA.remWidth), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.streamlit.WidthConfig();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.useStretch = BA.bool();
            break;
          }
          case 2: {
            oA.useContent = BA.bool();
            break;
          }
          case 3: {
            oA.pixelWidth = BA.uint32();
            break;
          }
          case 4: {
            oA.remWidth = BA.float();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.streamlit.WidthConfig) return BA;
      let QA = new $root$1.streamlit.WidthConfig();
      return BA.useStretch != null && (QA.useStretch = !!BA.useStretch), BA.useContent != null && (QA.useContent = !!BA.useContent), BA.pixelWidth != null && (QA.pixelWidth = BA.pixelWidth >>> 0), BA.remWidth != null && (QA.remWidth = Number(BA.remWidth)), QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return BA.useStretch != null && BA.hasOwnProperty("useStretch") && (EA.useStretch = BA.useStretch, QA.oneofs && (EA.widthSpec = "useStretch")), BA.useContent != null && BA.hasOwnProperty("useContent") && (EA.useContent = BA.useContent, QA.oneofs && (EA.widthSpec = "useContent")), BA.pixelWidth != null && BA.hasOwnProperty("pixelWidth") && (EA.pixelWidth = BA.pixelWidth, QA.oneofs && (EA.widthSpec = "pixelWidth")), BA.remWidth != null && BA.hasOwnProperty("remWidth") && (EA.remWidth = QA.json && !isFinite(BA.remWidth) ? String(BA.remWidth) : BA.remWidth, QA.oneofs && (EA.widthSpec = "remWidth")), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/streamlit.WidthConfig";
    }, gA;
  })(), CA.GapSize = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "GAP_UNDEFINED"] = 0, AA[gA[1] = "SMALL"] = 1, AA[gA[2] = "MEDIUM"] = 2, AA[gA[3] = "LARGE"] = 3, AA[gA[4] = "NONE"] = 4, AA[gA[5] = "XXSMALL"] = 5, AA[gA[6] = "XSMALL"] = 6, AA[gA[7] = "XLARGE"] = 7, AA[gA[8] = "XXLARGE"] = 8, AA;
  })(), CA.GapConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.gapSize = null;
    let AA;
    return Object.defineProperty(gA.prototype, "gapSpec", { get: $util$1.oneOfGetter(AA = ["gapSize"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.gapSize != null && Object.hasOwnProperty.call(BA, "gapSize") && QA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(BA.gapSize), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.streamlit.GapConfig();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        cA >>> 3 === 1 ? oA.gapSize = BA.int32() : BA.skipType(cA & 7);
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.streamlit.GapConfig) return BA;
      let QA = new $root$1.streamlit.GapConfig();
      switch (BA.gapSize) {
        default:
          if (typeof BA.gapSize == "number") {
            QA.gapSize = BA.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          QA.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          QA.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          QA.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          QA.gapSize = 3;
          break;
        case "NONE":
        case 4:
          QA.gapSize = 4;
          break;
        case "XXSMALL":
        case 5:
          QA.gapSize = 5;
          break;
        case "XSMALL":
        case 6:
          QA.gapSize = 6;
          break;
        case "XLARGE":
        case 7:
          QA.gapSize = 7;
          break;
        case "XXLARGE":
        case 8:
          QA.gapSize = 8;
          break;
      }
      return QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return BA.gapSize != null && BA.hasOwnProperty("gapSize") && (EA.gapSize = QA.enums === String ? $root$1.streamlit.GapSize[BA.gapSize] === void 0 ? BA.gapSize : $root$1.streamlit.GapSize[BA.gapSize] : BA.gapSize, QA.oneofs && (EA.gapSpec = "gapSize")), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/streamlit.GapConfig";
    }, gA;
  })(), CA.HeightConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.useStretch = null, gA.prototype.useContent = null, gA.prototype.pixelHeight = null, gA.prototype.remHeight = null;
    let AA;
    return Object.defineProperty(gA.prototype, "heightSpec", { get: $util$1.oneOfGetter(AA = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.useStretch != null && Object.hasOwnProperty.call(BA, "useStretch") && QA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(BA.useStretch), BA.useContent != null && Object.hasOwnProperty.call(BA, "useContent") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(BA.useContent), BA.pixelHeight != null && Object.hasOwnProperty.call(BA, "pixelHeight") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(BA.pixelHeight), BA.remHeight != null && Object.hasOwnProperty.call(BA, "remHeight") && QA.uint32(
        /* id 4, wireType 5 =*/
        37
      ).float(BA.remHeight), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.streamlit.HeightConfig();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.useStretch = BA.bool();
            break;
          }
          case 2: {
            oA.useContent = BA.bool();
            break;
          }
          case 3: {
            oA.pixelHeight = BA.uint32();
            break;
          }
          case 4: {
            oA.remHeight = BA.float();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.streamlit.HeightConfig) return BA;
      let QA = new $root$1.streamlit.HeightConfig();
      return BA.useStretch != null && (QA.useStretch = !!BA.useStretch), BA.useContent != null && (QA.useContent = !!BA.useContent), BA.pixelHeight != null && (QA.pixelHeight = BA.pixelHeight >>> 0), BA.remHeight != null && (QA.remHeight = Number(BA.remHeight)), QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return BA.useStretch != null && BA.hasOwnProperty("useStretch") && (EA.useStretch = BA.useStretch, QA.oneofs && (EA.heightSpec = "useStretch")), BA.useContent != null && BA.hasOwnProperty("useContent") && (EA.useContent = BA.useContent, QA.oneofs && (EA.heightSpec = "useContent")), BA.pixelHeight != null && BA.hasOwnProperty("pixelHeight") && (EA.pixelHeight = BA.pixelHeight, QA.oneofs && (EA.heightSpec = "pixelHeight")), BA.remHeight != null && BA.hasOwnProperty("remHeight") && (EA.remHeight = QA.json && !isFinite(BA.remHeight) ? String(BA.remHeight) : BA.remHeight, QA.oneofs && (EA.heightSpec = "remHeight")), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/streamlit.HeightConfig";
    }, gA;
  })(), CA.ButtonLikeIconPosition = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "LEFT"] = 0, AA[gA[1] = "RIGHT"] = 1, AA;
  })(), CA.SelectWidgetFilterMode = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "FILTER_MODE_FUZZY"] = 0, AA[gA[1] = "FILTER_MODE_CONTAINS"] = 1, AA[gA[2] = "FILTER_MODE_PREFIX"] = 2, AA[gA[3] = "FILTER_MODE_NONE"] = 3, AA;
  })(), CA.TextAlignmentConfig = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.alignment = 0, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA || (BA = $Writer$1.create()), IA.alignment != null && Object.hasOwnProperty.call(IA, "alignment") && BA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(IA.alignment), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.streamlit.TextAlignmentConfig();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? iA.alignment = IA.int32() : IA.skipType(oA & 7);
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.streamlit.TextAlignmentConfig) return IA;
      let BA = new $root$1.streamlit.TextAlignmentConfig();
      switch (IA.alignment) {
        default:
          if (typeof IA.alignment == "number") {
            BA.alignment = IA.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          BA.alignment = 0;
          break;
        case "LEFT":
        case 1:
          BA.alignment = 1;
          break;
        case "CENTER":
        case 2:
          BA.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          BA.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          BA.alignment = 4;
          break;
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      return BA.defaults && (QA.alignment = BA.enums === String ? "UNSPECIFIED" : 0), IA.alignment != null && IA.hasOwnProperty("alignment") && (QA.alignment = BA.enums === String ? $root$1.streamlit.TextAlignmentConfig.Alignment[IA.alignment] === void 0 ? IA.alignment : $root$1.streamlit.TextAlignmentConfig.Alignment[IA.alignment] : IA.alignment), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/streamlit.TextAlignmentConfig";
    }, gA.Alignment = (function() {
      const AA = {}, IA = Object.create(AA);
      return IA[AA[0] = "UNSPECIFIED"] = 0, IA[AA[1] = "LEFT"] = 1, IA[AA[2] = "CENTER"] = 2, IA[AA[3] = "RIGHT"] = 3, IA[AA[4] = "JUSTIFY"] = 4, IA;
    })(), gA;
  })(), CA;
})();
$root$1.AppPage = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.pageScriptHash = "", CA.prototype.pageName = "", CA.prototype.icon = "", CA.prototype.isDefault = !1, CA.prototype.sectionHeader = "", CA.prototype.urlPathname = "", CA.prototype.isHidden = !1, CA.prototype.externalUrl = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_externalUrl", { get: $util$1.oneOfGetter(gA = ["externalUrl"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.pageScriptHash != null && Object.hasOwnProperty.call(IA, "pageScriptHash") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.pageScriptHash), IA.pageName != null && Object.hasOwnProperty.call(IA, "pageName") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.pageName), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.icon), IA.isDefault != null && Object.hasOwnProperty.call(IA, "isDefault") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(IA.isDefault), IA.sectionHeader != null && Object.hasOwnProperty.call(IA, "sectionHeader") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.sectionHeader), IA.urlPathname != null && Object.hasOwnProperty.call(IA, "urlPathname") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.urlPathname), IA.isHidden != null && Object.hasOwnProperty.call(IA, "isHidden") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.isHidden), IA.externalUrl != null && Object.hasOwnProperty.call(IA, "externalUrl") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.externalUrl), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.AppPage();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.pageScriptHash = IA.string();
          break;
        }
        case 2: {
          iA.pageName = IA.string();
          break;
        }
        case 3: {
          iA.icon = IA.string();
          break;
        }
        case 4: {
          iA.isDefault = IA.bool();
          break;
        }
        case 5: {
          iA.sectionHeader = IA.string();
          break;
        }
        case 6: {
          iA.urlPathname = IA.string();
          break;
        }
        case 7: {
          iA.isHidden = IA.bool();
          break;
        }
        case 8: {
          iA.externalUrl = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.AppPage) return IA;
    let BA = new $root$1.AppPage();
    return IA.pageScriptHash != null && (BA.pageScriptHash = String(IA.pageScriptHash)), IA.pageName != null && (BA.pageName = String(IA.pageName)), IA.icon != null && (BA.icon = String(IA.icon)), IA.isDefault != null && (BA.isDefault = !!IA.isDefault), IA.sectionHeader != null && (BA.sectionHeader = String(IA.sectionHeader)), IA.urlPathname != null && (BA.urlPathname = String(IA.urlPathname)), IA.isHidden != null && (BA.isHidden = !!IA.isHidden), IA.externalUrl != null && (BA.externalUrl = String(IA.externalUrl)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.pageScriptHash = "", QA.pageName = "", QA.icon = "", QA.isDefault = !1, QA.sectionHeader = "", QA.urlPathname = "", QA.isHidden = !1), IA.pageScriptHash != null && IA.hasOwnProperty("pageScriptHash") && (QA.pageScriptHash = IA.pageScriptHash), IA.pageName != null && IA.hasOwnProperty("pageName") && (QA.pageName = IA.pageName), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.isDefault != null && IA.hasOwnProperty("isDefault") && (QA.isDefault = IA.isDefault), IA.sectionHeader != null && IA.hasOwnProperty("sectionHeader") && (QA.sectionHeader = IA.sectionHeader), IA.urlPathname != null && IA.hasOwnProperty("urlPathname") && (QA.urlPathname = IA.urlPathname), IA.isHidden != null && IA.hasOwnProperty("isHidden") && (QA.isHidden = IA.isHidden), IA.externalUrl != null && IA.hasOwnProperty("externalUrl") && (QA.externalUrl = IA.externalUrl, BA.oneofs && (QA._externalUrl = "externalUrl")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/AppPage";
  }, CA;
})();
$root$1.ArrowData = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.newBuffer([]), CA.prototype.styler = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.data != null && Object.hasOwnProperty.call(AA, "data") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(AA.data), AA.styler != null && Object.hasOwnProperty.call(AA, "styler") && $root$1.ArrowData.PandasStyler.encode(AA.styler, IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ArrowData();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.data = AA.bytes();
          break;
        }
        case 2: {
          EA.styler = $root$1.ArrowData.PandasStyler.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ArrowData) return AA;
    let IA = new $root$1.ArrowData();
    if (AA.data != null && (typeof AA.data == "string" ? $util$1.base64.decode(AA.data, IA.data = $util$1.newBuffer($util$1.base64.length(AA.data)), 0) : AA.data.length >= 0 && (IA.data = AA.data)), AA.styler != null) {
      if (typeof AA.styler != "object") throw TypeError(".ArrowData.styler: object expected");
      IA.styler = $root$1.ArrowData.PandasStyler.fromObject(AA.styler);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (IA.bytes === String ? BA.data = "" : (BA.data = [], IA.bytes !== Array && (BA.data = $util$1.newBuffer(BA.data))), BA.styler = null), AA.data != null && AA.hasOwnProperty("data") && (BA.data = IA.bytes === String ? $util$1.base64.encode(AA.data, 0, AA.data.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.data) : AA.data), AA.styler != null && AA.hasOwnProperty("styler") && (BA.styler = $root$1.ArrowData.PandasStyler.toObject(AA.styler, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowData";
  }, CA.PandasStyler = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.uuid = "", gA.prototype.caption = "", gA.prototype.styles = "", gA.prototype.displayValues = $util$1.newBuffer([]), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA || (BA = $Writer$1.create()), IA.uuid != null && Object.hasOwnProperty.call(IA, "uuid") && BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(IA.uuid), IA.caption != null && Object.hasOwnProperty.call(IA, "caption") && BA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(IA.caption), IA.styles != null && Object.hasOwnProperty.call(IA, "styles") && BA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(IA.styles), IA.displayValues != null && Object.hasOwnProperty.call(IA, "displayValues") && BA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(IA.displayValues), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ArrowData.PandasStyler();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1: {
            iA.uuid = IA.string();
            break;
          }
          case 2: {
            iA.caption = IA.string();
            break;
          }
          case 3: {
            iA.styles = IA.string();
            break;
          }
          case 4: {
            iA.displayValues = IA.bytes();
            break;
          }
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.ArrowData.PandasStyler) return IA;
      let BA = new $root$1.ArrowData.PandasStyler();
      return IA.uuid != null && (BA.uuid = String(IA.uuid)), IA.caption != null && (BA.caption = String(IA.caption)), IA.styles != null && (BA.styles = String(IA.styles)), IA.displayValues != null && (typeof IA.displayValues == "string" ? $util$1.base64.decode(IA.displayValues, BA.displayValues = $util$1.newBuffer($util$1.base64.length(IA.displayValues)), 0) : IA.displayValues.length >= 0 && (BA.displayValues = IA.displayValues)), BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      return BA.defaults && (QA.uuid = "", QA.caption = "", QA.styles = "", BA.bytes === String ? QA.displayValues = "" : (QA.displayValues = [], BA.bytes !== Array && (QA.displayValues = $util$1.newBuffer(QA.displayValues)))), IA.uuid != null && IA.hasOwnProperty("uuid") && (QA.uuid = IA.uuid), IA.caption != null && IA.hasOwnProperty("caption") && (QA.caption = IA.caption), IA.styles != null && IA.hasOwnProperty("styles") && (QA.styles = IA.styles), IA.displayValues != null && IA.hasOwnProperty("displayValues") && (QA.displayValues = BA.bytes === String ? $util$1.base64.encode(IA.displayValues, 0, IA.displayValues.length) : BA.bytes === Array ? Array.prototype.slice.call(IA.displayValues) : IA.displayValues), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ArrowData.PandasStyler";
    }, gA;
  })(), CA;
})();
$root$1.ArrowNamedDataSet = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.hasName = !1, CA.prototype.data = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.name), AA.data != null && Object.hasOwnProperty.call(AA, "data") && $root$1.ArrowData.encode(AA.data, IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), AA.hasName != null && Object.hasOwnProperty.call(AA, "hasName") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.hasName), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ArrowNamedDataSet();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.name = AA.string();
          break;
        }
        case 3: {
          EA.hasName = AA.bool();
          break;
        }
        case 2: {
          EA.data = $root$1.ArrowData.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ArrowNamedDataSet) return AA;
    let IA = new $root$1.ArrowNamedDataSet();
    if (AA.name != null && (IA.name = String(AA.name)), AA.hasName != null && (IA.hasName = !!AA.hasName), AA.data != null) {
      if (typeof AA.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      IA.data = $root$1.ArrowData.fromObject(AA.data);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.name = "", BA.data = null, BA.hasName = !1), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.data != null && AA.hasOwnProperty("data") && (BA.data = $root$1.ArrowData.toObject(AA.data, IA)), AA.hasName != null && AA.hasOwnProperty("hasName") && (BA.hasName = AA.hasName), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowNamedDataSet";
  }, CA;
})();
$root$1.Audio = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.url = "", CA.prototype.startTime = 0, CA.prototype.endTime = 0, CA.prototype.loop = !1, CA.prototype.autoplay = !1, CA.prototype.id = "", CA.prototype.widthConfig = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_widthConfig", { get: $util$1.oneOfGetter(gA = ["widthConfig"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.startTime != null && Object.hasOwnProperty.call(IA, "startTime") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.startTime), IA.url != null && Object.hasOwnProperty.call(IA, "url") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.url), IA.endTime != null && Object.hasOwnProperty.call(IA, "endTime") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(IA.endTime), IA.loop != null && Object.hasOwnProperty.call(IA, "loop") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.loop), IA.autoplay != null && Object.hasOwnProperty.call(IA, "autoplay") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.autoplay), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(IA.id), IA.widthConfig != null && Object.hasOwnProperty.call(IA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(IA.widthConfig, BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Audio();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 5: {
          iA.url = IA.string();
          break;
        }
        case 3: {
          iA.startTime = IA.int32();
          break;
        }
        case 6: {
          iA.endTime = IA.int32();
          break;
        }
        case 7: {
          iA.loop = IA.bool();
          break;
        }
        case 8: {
          iA.autoplay = IA.bool();
          break;
        }
        case 9: {
          iA.id = IA.string();
          break;
        }
        case 10: {
          iA.widthConfig = $root$1.streamlit.WidthConfig.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Audio) return IA;
    let BA = new $root$1.Audio();
    if (IA.url != null && (BA.url = String(IA.url)), IA.startTime != null && (BA.startTime = IA.startTime | 0), IA.endTime != null && (BA.endTime = IA.endTime | 0), IA.loop != null && (BA.loop = !!IA.loop), IA.autoplay != null && (BA.autoplay = !!IA.autoplay), IA.id != null && (BA.id = String(IA.id)), IA.widthConfig != null) {
      if (typeof IA.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      BA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(IA.widthConfig);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.startTime = 0, QA.url = "", QA.endTime = 0, QA.loop = !1, QA.autoplay = !1, QA.id = ""), IA.startTime != null && IA.hasOwnProperty("startTime") && (QA.startTime = IA.startTime), IA.url != null && IA.hasOwnProperty("url") && (QA.url = IA.url), IA.endTime != null && IA.hasOwnProperty("endTime") && (QA.endTime = IA.endTime), IA.loop != null && IA.hasOwnProperty("loop") && (QA.loop = IA.loop), IA.autoplay != null && IA.hasOwnProperty("autoplay") && (QA.autoplay = IA.autoplay), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.widthConfig != null && IA.hasOwnProperty("widthConfig") && (QA.widthConfig = $root$1.streamlit.WidthConfig.toObject(IA.widthConfig, BA), BA.oneofs && (QA._widthConfig = "widthConfig")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Audio";
  }, CA;
})();
$root$1.AudioInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.sampleRate = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_sampleRate", { get: $util$1.oneOfGetter(gA = ["sampleRate"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.formId), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA.sampleRate != null && Object.hasOwnProperty.call(IA, "sampleRate") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(IA.sampleRate), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.AudioInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.help = IA.string();
          break;
        }
        case 4: {
          iA.formId = IA.string();
          break;
        }
        case 5: {
          iA.disabled = IA.bool();
          break;
        }
        case 6: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 7: {
          iA.sampleRate = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.AudioInput) return IA;
    let BA = new $root$1.AudioInput();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.sampleRate != null && (BA.sampleRate = IA.sampleRate | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.help = "", QA.formId = "", QA.disabled = !1, QA.labelVisibility = null), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.sampleRate != null && IA.hasOwnProperty("sampleRate") && (QA.sampleRate = IA.sampleRate, BA.oneofs && (QA._sampleRate = "sampleRate")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/AudioInput";
  }, CA;
})();
const LabelVisibility = $root$1.LabelVisibility = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.value = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(AA.value), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.LabelVisibility();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.value = AA.int32() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.LabelVisibility) return AA;
    let IA = new $root$1.LabelVisibility();
    switch (AA.value) {
      default:
        if (typeof AA.value == "number") {
          IA.value = AA.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        IA.value = 0;
        break;
      case "HIDDEN":
      case 1:
        IA.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        IA.value = 2;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.value = IA.enums === String ? "VISIBLE" : 0), AA.value != null && AA.hasOwnProperty("value") && (BA.value = IA.enums === String ? $root$1.LabelVisibility.LabelVisibilityOptions[AA.value] === void 0 ? AA.value : $root$1.LabelVisibility.LabelVisibilityOptions[AA.value] : AA.value), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/LabelVisibility";
  }, CA.LabelVisibilityOptions = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "VISIBLE"] = 0, AA[gA[1] = "HIDDEN"] = 1, AA[gA[2] = "COLLAPSED"] = 2, AA;
  })(), CA;
})();
$root$1.AuthRedirect = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.url), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.AuthRedirect();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.url = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.AuthRedirect) return AA;
    let IA = new $root$1.AuthRedirect();
    return AA.url != null && (IA.url = String(AA.url)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.url = ""), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/AuthRedirect";
  }, CA;
})();
$root$1.AutoRerun = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.interval = 0, CA.prototype.fragmentId = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.interval != null && Object.hasOwnProperty.call(AA, "interval") && IA.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(AA.interval), AA.fragmentId != null && Object.hasOwnProperty.call(AA, "fragmentId") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.fragmentId), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.AutoRerun();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.interval = AA.float();
          break;
        }
        case 2: {
          EA.fragmentId = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.AutoRerun) return AA;
    let IA = new $root$1.AutoRerun();
    return AA.interval != null && (IA.interval = Number(AA.interval)), AA.fragmentId != null && (IA.fragmentId = String(AA.fragmentId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.interval = 0, BA.fragmentId = ""), AA.interval != null && AA.hasOwnProperty("interval") && (BA.interval = IA.json && !isFinite(AA.interval) ? String(AA.interval) : AA.interval), AA.fragmentId != null && AA.hasOwnProperty("fragmentId") && (BA.fragmentId = AA.fragmentId), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/AutoRerun";
  }, CA;
})();
const BackMsg = $root$1.BackMsg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.clearCache = null, CA.prototype.setRunOnSave = null, CA.prototype.stopScript = null, CA.prototype.rerunScript = null, CA.prototype.loadGitInfo = null, CA.prototype.debugDisconnectWebsocket = null, CA.prototype.debugShutdownRuntime = null, CA.prototype.fileUrlsRequest = null, CA.prototype.appHeartbeat = null, CA.prototype.deferredFileRequest = null, CA.prototype.debugLastBackmsgId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.clearCache != null && Object.hasOwnProperty.call(IA, "clearCache") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(IA.clearCache), IA.setRunOnSave != null && Object.hasOwnProperty.call(IA, "setRunOnSave") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(IA.setRunOnSave), IA.stopScript != null && Object.hasOwnProperty.call(IA, "stopScript") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.stopScript), IA.rerunScript != null && Object.hasOwnProperty.call(IA, "rerunScript") && $root$1.ClientState.encode(IA.rerunScript, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.loadGitInfo != null && Object.hasOwnProperty.call(IA, "loadGitInfo") && BA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(IA.loadGitInfo), IA.debugLastBackmsgId != null && Object.hasOwnProperty.call(IA, "debugLastBackmsgId") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.debugLastBackmsgId), IA.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(IA, "debugDisconnectWebsocket") && BA.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(IA.debugDisconnectWebsocket), IA.debugShutdownRuntime != null && Object.hasOwnProperty.call(IA, "debugShutdownRuntime") && BA.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(IA.debugShutdownRuntime), IA.fileUrlsRequest != null && Object.hasOwnProperty.call(IA, "fileUrlsRequest") && $root$1.FileURLsRequest.encode(IA.fileUrlsRequest, BA.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), IA.appHeartbeat != null && Object.hasOwnProperty.call(IA, "appHeartbeat") && BA.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(IA.appHeartbeat), IA.deferredFileRequest != null && Object.hasOwnProperty.call(IA, "deferredFileRequest") && $root$1.DeferredFileRequest.encode(IA.deferredFileRequest, BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.BackMsg();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 5: {
          iA.clearCache = IA.bool();
          break;
        }
        case 6: {
          iA.setRunOnSave = IA.bool();
          break;
        }
        case 7: {
          iA.stopScript = IA.bool();
          break;
        }
        case 11: {
          iA.rerunScript = $root$1.ClientState.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.loadGitInfo = IA.bool();
          break;
        }
        case 14: {
          iA.debugDisconnectWebsocket = IA.bool();
          break;
        }
        case 15: {
          iA.debugShutdownRuntime = IA.bool();
          break;
        }
        case 16: {
          iA.fileUrlsRequest = $root$1.FileURLsRequest.decode(IA, IA.uint32());
          break;
        }
        case 17: {
          iA.appHeartbeat = IA.bool();
          break;
        }
        case 18: {
          iA.deferredFileRequest = $root$1.DeferredFileRequest.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.debugLastBackmsgId = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.BackMsg) return IA;
    let BA = new $root$1.BackMsg();
    if (IA.clearCache != null && (BA.clearCache = !!IA.clearCache), IA.setRunOnSave != null && (BA.setRunOnSave = !!IA.setRunOnSave), IA.stopScript != null && (BA.stopScript = !!IA.stopScript), IA.rerunScript != null) {
      if (typeof IA.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      BA.rerunScript = $root$1.ClientState.fromObject(IA.rerunScript);
    }
    if (IA.loadGitInfo != null && (BA.loadGitInfo = !!IA.loadGitInfo), IA.debugDisconnectWebsocket != null && (BA.debugDisconnectWebsocket = !!IA.debugDisconnectWebsocket), IA.debugShutdownRuntime != null && (BA.debugShutdownRuntime = !!IA.debugShutdownRuntime), IA.fileUrlsRequest != null) {
      if (typeof IA.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      BA.fileUrlsRequest = $root$1.FileURLsRequest.fromObject(IA.fileUrlsRequest);
    }
    if (IA.appHeartbeat != null && (BA.appHeartbeat = !!IA.appHeartbeat), IA.deferredFileRequest != null) {
      if (typeof IA.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      BA.deferredFileRequest = $root$1.DeferredFileRequest.fromObject(IA.deferredFileRequest);
    }
    return IA.debugLastBackmsgId != null && (BA.debugLastBackmsgId = String(IA.debugLastBackmsgId)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.debugLastBackmsgId = ""), IA.clearCache != null && IA.hasOwnProperty("clearCache") && (QA.clearCache = IA.clearCache, BA.oneofs && (QA.type = "clearCache")), IA.setRunOnSave != null && IA.hasOwnProperty("setRunOnSave") && (QA.setRunOnSave = IA.setRunOnSave, BA.oneofs && (QA.type = "setRunOnSave")), IA.stopScript != null && IA.hasOwnProperty("stopScript") && (QA.stopScript = IA.stopScript, BA.oneofs && (QA.type = "stopScript")), IA.rerunScript != null && IA.hasOwnProperty("rerunScript") && (QA.rerunScript = $root$1.ClientState.toObject(IA.rerunScript, BA), BA.oneofs && (QA.type = "rerunScript")), IA.loadGitInfo != null && IA.hasOwnProperty("loadGitInfo") && (QA.loadGitInfo = IA.loadGitInfo, BA.oneofs && (QA.type = "loadGitInfo")), IA.debugLastBackmsgId != null && IA.hasOwnProperty("debugLastBackmsgId") && (QA.debugLastBackmsgId = IA.debugLastBackmsgId), IA.debugDisconnectWebsocket != null && IA.hasOwnProperty("debugDisconnectWebsocket") && (QA.debugDisconnectWebsocket = IA.debugDisconnectWebsocket, BA.oneofs && (QA.type = "debugDisconnectWebsocket")), IA.debugShutdownRuntime != null && IA.hasOwnProperty("debugShutdownRuntime") && (QA.debugShutdownRuntime = IA.debugShutdownRuntime, BA.oneofs && (QA.type = "debugShutdownRuntime")), IA.fileUrlsRequest != null && IA.hasOwnProperty("fileUrlsRequest") && (QA.fileUrlsRequest = $root$1.FileURLsRequest.toObject(IA.fileUrlsRequest, BA), BA.oneofs && (QA.type = "fileUrlsRequest")), IA.appHeartbeat != null && IA.hasOwnProperty("appHeartbeat") && (QA.appHeartbeat = IA.appHeartbeat, BA.oneofs && (QA.type = "appHeartbeat")), IA.deferredFileRequest != null && IA.hasOwnProperty("deferredFileRequest") && (QA.deferredFileRequest = $root$1.DeferredFileRequest.toObject(IA.deferredFileRequest, BA), BA.oneofs && (QA.type = "deferredFileRequest")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/BackMsg";
  }, CA;
})();
$root$1.DeferredFileRequest = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.sessionId = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.fileId != null && Object.hasOwnProperty.call(AA, "fileId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.fileId), AA.sessionId != null && Object.hasOwnProperty.call(AA, "sessionId") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.sessionId), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.DeferredFileRequest();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.fileId = AA.string();
          break;
        }
        case 2: {
          EA.sessionId = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.DeferredFileRequest) return AA;
    let IA = new $root$1.DeferredFileRequest();
    return AA.fileId != null && (IA.fileId = String(AA.fileId)), AA.sessionId != null && (IA.sessionId = String(AA.sessionId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.fileId = "", BA.sessionId = ""), AA.fileId != null && AA.hasOwnProperty("fileId") && (BA.fileId = AA.fileId), AA.sessionId != null && AA.hasOwnProperty("sessionId") && (BA.sessionId = AA.sessionId), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DeferredFileRequest";
  }, CA;
})();
$root$1.ContextInfo = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.timezone = null, CA.prototype.timezoneOffset = null, CA.prototype.locale = null, CA.prototype.url = null, CA.prototype.isEmbedded = null, CA.prototype.colorScheme = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_timezone", { get: $util$1.oneOfGetter(gA = ["timezone"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_timezoneOffset", { get: $util$1.oneOfGetter(gA = ["timezoneOffset"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_locale", { get: $util$1.oneOfGetter(gA = ["locale"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_url", { get: $util$1.oneOfGetter(gA = ["url"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_isEmbedded", { get: $util$1.oneOfGetter(gA = ["isEmbedded"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_colorScheme", { get: $util$1.oneOfGetter(gA = ["colorScheme"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.timezone != null && Object.hasOwnProperty.call(IA, "timezone") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.timezone), IA.timezoneOffset != null && Object.hasOwnProperty.call(IA, "timezoneOffset") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(IA.timezoneOffset), IA.locale != null && Object.hasOwnProperty.call(IA, "locale") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.locale), IA.url != null && Object.hasOwnProperty.call(IA, "url") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.url), IA.isEmbedded != null && Object.hasOwnProperty.call(IA, "isEmbedded") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(IA.isEmbedded), IA.colorScheme != null && Object.hasOwnProperty.call(IA, "colorScheme") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.colorScheme), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ContextInfo();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.timezone = IA.string();
          break;
        }
        case 2: {
          iA.timezoneOffset = IA.int32();
          break;
        }
        case 3: {
          iA.locale = IA.string();
          break;
        }
        case 4: {
          iA.url = IA.string();
          break;
        }
        case 5: {
          iA.isEmbedded = IA.bool();
          break;
        }
        case 6: {
          iA.colorScheme = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ContextInfo) return IA;
    let BA = new $root$1.ContextInfo();
    return IA.timezone != null && (BA.timezone = String(IA.timezone)), IA.timezoneOffset != null && (BA.timezoneOffset = IA.timezoneOffset | 0), IA.locale != null && (BA.locale = String(IA.locale)), IA.url != null && (BA.url = String(IA.url)), IA.isEmbedded != null && (BA.isEmbedded = !!IA.isEmbedded), IA.colorScheme != null && (BA.colorScheme = String(IA.colorScheme)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return IA.timezone != null && IA.hasOwnProperty("timezone") && (QA.timezone = IA.timezone, BA.oneofs && (QA._timezone = "timezone")), IA.timezoneOffset != null && IA.hasOwnProperty("timezoneOffset") && (QA.timezoneOffset = IA.timezoneOffset, BA.oneofs && (QA._timezoneOffset = "timezoneOffset")), IA.locale != null && IA.hasOwnProperty("locale") && (QA.locale = IA.locale, BA.oneofs && (QA._locale = "locale")), IA.url != null && IA.hasOwnProperty("url") && (QA.url = IA.url, BA.oneofs && (QA._url = "url")), IA.isEmbedded != null && IA.hasOwnProperty("isEmbedded") && (QA.isEmbedded = IA.isEmbedded, BA.oneofs && (QA._isEmbedded = "isEmbedded")), IA.colorScheme != null && IA.hasOwnProperty("colorScheme") && (QA.colorScheme = IA.colorScheme, BA.oneofs && (QA._colorScheme = "colorScheme")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ContextInfo";
  }, CA;
})();
$root$1.ClientState = (() => {
  function CA(gA) {
    if (this.cachedMessageHashes = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.queryString = "", CA.prototype.widgetStates = null, CA.prototype.pageScriptHash = "", CA.prototype.pageName = "", CA.prototype.fragmentId = "", CA.prototype.isAutoRerun = !1, CA.prototype.cachedMessageHashes = $util$1.emptyArray, CA.prototype.contextInfo = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.queryString != null && Object.hasOwnProperty.call(AA, "queryString") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.queryString), AA.widgetStates != null && Object.hasOwnProperty.call(AA, "widgetStates") && $root$1.WidgetStates.encode(AA.widgetStates, IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.pageScriptHash), AA.pageName != null && Object.hasOwnProperty.call(AA, "pageName") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.pageName), AA.fragmentId != null && Object.hasOwnProperty.call(AA, "fragmentId") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.fragmentId), AA.isAutoRerun != null && Object.hasOwnProperty.call(AA, "isAutoRerun") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.isAutoRerun), AA.cachedMessageHashes != null && AA.cachedMessageHashes.length) for (let BA = 0; BA < AA.cachedMessageHashes.length; ++BA) IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.cachedMessageHashes[BA]);
    return AA.contextInfo != null && Object.hasOwnProperty.call(AA, "contextInfo") && $root$1.ContextInfo.encode(AA.contextInfo, IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ClientState();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.queryString = AA.string();
          break;
        }
        case 2: {
          EA.widgetStates = $root$1.WidgetStates.decode(AA, AA.uint32());
          break;
        }
        case 3: {
          EA.pageScriptHash = AA.string();
          break;
        }
        case 4: {
          EA.pageName = AA.string();
          break;
        }
        case 5: {
          EA.fragmentId = AA.string();
          break;
        }
        case 6: {
          EA.isAutoRerun = AA.bool();
          break;
        }
        case 7: {
          EA.cachedMessageHashes && EA.cachedMessageHashes.length || (EA.cachedMessageHashes = []), EA.cachedMessageHashes.push(AA.string());
          break;
        }
        case 8: {
          EA.contextInfo = $root$1.ContextInfo.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ClientState) return AA;
    let IA = new $root$1.ClientState();
    if (AA.queryString != null && (IA.queryString = String(AA.queryString)), AA.widgetStates != null) {
      if (typeof AA.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      IA.widgetStates = $root$1.WidgetStates.fromObject(AA.widgetStates);
    }
    if (AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.pageName != null && (IA.pageName = String(AA.pageName)), AA.fragmentId != null && (IA.fragmentId = String(AA.fragmentId)), AA.isAutoRerun != null && (IA.isAutoRerun = !!AA.isAutoRerun), AA.cachedMessageHashes) {
      if (!Array.isArray(AA.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      IA.cachedMessageHashes = [];
      for (let BA = 0; BA < AA.cachedMessageHashes.length; ++BA) IA.cachedMessageHashes[BA] = String(AA.cachedMessageHashes[BA]);
    }
    if (AA.contextInfo != null) {
      if (typeof AA.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      IA.contextInfo = $root$1.ContextInfo.fromObject(AA.contextInfo);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.cachedMessageHashes = []), IA.defaults && (BA.queryString = "", BA.widgetStates = null, BA.pageScriptHash = "", BA.pageName = "", BA.fragmentId = "", BA.isAutoRerun = !1, BA.contextInfo = null), AA.queryString != null && AA.hasOwnProperty("queryString") && (BA.queryString = AA.queryString), AA.widgetStates != null && AA.hasOwnProperty("widgetStates") && (BA.widgetStates = $root$1.WidgetStates.toObject(AA.widgetStates, IA)), AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.pageName != null && AA.hasOwnProperty("pageName") && (BA.pageName = AA.pageName), AA.fragmentId != null && AA.hasOwnProperty("fragmentId") && (BA.fragmentId = AA.fragmentId), AA.isAutoRerun != null && AA.hasOwnProperty("isAutoRerun") && (BA.isAutoRerun = AA.isAutoRerun), AA.cachedMessageHashes && AA.cachedMessageHashes.length) {
      BA.cachedMessageHashes = [];
      for (let QA = 0; QA < AA.cachedMessageHashes.length; ++QA) BA.cachedMessageHashes[QA] = AA.cachedMessageHashes[QA];
    }
    return AA.contextInfo != null && AA.hasOwnProperty("contextInfo") && (BA.contextInfo = $root$1.ContextInfo.toObject(AA.contextInfo, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ClientState";
  }, CA;
})();
const WidgetStates = $root$1.WidgetStates = (() => {
  function CA(gA) {
    if (this.widgets = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.widgets = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.widgets != null && AA.widgets.length) for (let BA = 0; BA < AA.widgets.length; ++BA) $root$1.WidgetState.encode(AA.widgets[BA], IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.WidgetStates();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? (EA.widgets && EA.widgets.length || (EA.widgets = []), EA.widgets.push($root$1.WidgetState.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.WidgetStates) return AA;
    let IA = new $root$1.WidgetStates();
    if (AA.widgets) {
      if (!Array.isArray(AA.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      IA.widgets = [];
      for (let BA = 0; BA < AA.widgets.length; ++BA) {
        if (typeof AA.widgets[BA] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        IA.widgets[BA] = $root$1.WidgetState.fromObject(AA.widgets[BA]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.widgets = []), AA.widgets && AA.widgets.length) {
      BA.widgets = [];
      for (let QA = 0; QA < AA.widgets.length; ++QA) BA.widgets[QA] = $root$1.WidgetState.toObject(AA.widgets[QA], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/WidgetStates";
  }, CA;
})(), WidgetState = $root$1.WidgetState = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.triggerValue = null, CA.prototype.boolValue = null, CA.prototype.doubleValue = null, CA.prototype.intValue = null, CA.prototype.stringValue = null, CA.prototype.doubleArrayValue = null, CA.prototype.intArrayValue = null, CA.prototype.stringArrayValue = null, CA.prototype.jsonValue = null, CA.prototype.arrowValue = null, CA.prototype.bytesValue = null, CA.prototype.fileUploaderStateValue = null, CA.prototype.stringTriggerValue = null, CA.prototype.chatInputValue = null, CA.prototype.jsonTriggerValue = null;
  let gA;
  return Object.defineProperty(CA.prototype, "value", { get: $util$1.oneOfGetter(gA = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.triggerValue != null && Object.hasOwnProperty.call(IA, "triggerValue") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(IA.triggerValue), IA.boolValue != null && Object.hasOwnProperty.call(IA, "boolValue") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(IA.boolValue), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(IA.intValue), IA.stringValue != null && Object.hasOwnProperty.call(IA, "stringValue") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.stringValue), IA.doubleArrayValue != null && Object.hasOwnProperty.call(IA, "doubleArrayValue") && $root$1.DoubleArray.encode(IA.doubleArrayValue, BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), IA.intArrayValue != null && Object.hasOwnProperty.call(IA, "intArrayValue") && $root$1.SInt64Array.encode(IA.intArrayValue, BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), IA.stringArrayValue != null && Object.hasOwnProperty.call(IA, "stringArrayValue") && $root$1.StringArray.encode(IA.stringArrayValue, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.jsonValue != null && Object.hasOwnProperty.call(IA, "jsonValue") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.jsonValue), IA.arrowValue != null && Object.hasOwnProperty.call(IA, "arrowValue") && $root$1.ArrowTable.encode(IA.arrowValue, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.bytesValue != null && Object.hasOwnProperty.call(IA, "bytesValue") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(IA.bytesValue), IA.fileUploaderStateValue != null && Object.hasOwnProperty.call(IA, "fileUploaderStateValue") && $root$1.FileUploaderState.encode(IA.fileUploaderStateValue, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), IA.stringTriggerValue != null && Object.hasOwnProperty.call(IA, "stringTriggerValue") && $root$1.StringTriggerValue.encode(IA.stringTriggerValue, BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), IA.chatInputValue != null && Object.hasOwnProperty.call(IA, "chatInputValue") && $root$1.ChatInputValue.encode(IA.chatInputValue, BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), IA.jsonTriggerValue != null && Object.hasOwnProperty.call(IA, "jsonTriggerValue") && BA.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(IA.jsonTriggerValue), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.WidgetState();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.triggerValue = IA.bool();
          break;
        }
        case 3: {
          iA.boolValue = IA.bool();
          break;
        }
        case 4: {
          iA.doubleValue = IA.double();
          break;
        }
        case 5: {
          iA.intValue = IA.sint64();
          break;
        }
        case 6: {
          iA.stringValue = IA.string();
          break;
        }
        case 7: {
          iA.doubleArrayValue = $root$1.DoubleArray.decode(IA, IA.uint32());
          break;
        }
        case 8: {
          iA.intArrayValue = $root$1.SInt64Array.decode(IA, IA.uint32());
          break;
        }
        case 9: {
          iA.stringArrayValue = $root$1.StringArray.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.jsonValue = IA.string();
          break;
        }
        case 11: {
          iA.arrowValue = $root$1.ArrowTable.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.bytesValue = IA.bytes();
          break;
        }
        case 13: {
          iA.fileUploaderStateValue = $root$1.FileUploaderState.decode(IA, IA.uint32());
          break;
        }
        case 14: {
          iA.stringTriggerValue = $root$1.StringTriggerValue.decode(IA, IA.uint32());
          break;
        }
        case 15: {
          iA.chatInputValue = $root$1.ChatInputValue.decode(IA, IA.uint32());
          break;
        }
        case 16: {
          iA.jsonTriggerValue = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.WidgetState) return IA;
    let BA = new $root$1.WidgetState();
    if (IA.id != null && (BA.id = String(IA.id)), IA.triggerValue != null && (BA.triggerValue = !!IA.triggerValue), IA.boolValue != null && (BA.boolValue = !!IA.boolValue), IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util$1.Long ? (BA.intValue = $util$1.Long.fromValue(IA.intValue)).unsigned = !1 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util$1.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber())), IA.stringValue != null && (BA.stringValue = String(IA.stringValue)), IA.doubleArrayValue != null) {
      if (typeof IA.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      BA.doubleArrayValue = $root$1.DoubleArray.fromObject(IA.doubleArrayValue);
    }
    if (IA.intArrayValue != null) {
      if (typeof IA.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      BA.intArrayValue = $root$1.SInt64Array.fromObject(IA.intArrayValue);
    }
    if (IA.stringArrayValue != null) {
      if (typeof IA.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      BA.stringArrayValue = $root$1.StringArray.fromObject(IA.stringArrayValue);
    }
    if (IA.jsonValue != null && (BA.jsonValue = String(IA.jsonValue)), IA.arrowValue != null) {
      if (typeof IA.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      BA.arrowValue = $root$1.ArrowTable.fromObject(IA.arrowValue);
    }
    if (IA.bytesValue != null && (typeof IA.bytesValue == "string" ? $util$1.base64.decode(IA.bytesValue, BA.bytesValue = $util$1.newBuffer($util$1.base64.length(IA.bytesValue)), 0) : IA.bytesValue.length >= 0 && (BA.bytesValue = IA.bytesValue)), IA.fileUploaderStateValue != null) {
      if (typeof IA.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      BA.fileUploaderStateValue = $root$1.FileUploaderState.fromObject(IA.fileUploaderStateValue);
    }
    if (IA.stringTriggerValue != null) {
      if (typeof IA.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      BA.stringTriggerValue = $root$1.StringTriggerValue.fromObject(IA.stringTriggerValue);
    }
    if (IA.chatInputValue != null) {
      if (typeof IA.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      BA.chatInputValue = $root$1.ChatInputValue.fromObject(IA.chatInputValue);
    }
    return IA.jsonTriggerValue != null && (BA.jsonTriggerValue = String(IA.jsonTriggerValue)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = ""), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.triggerValue != null && IA.hasOwnProperty("triggerValue") && (QA.triggerValue = IA.triggerValue, BA.oneofs && (QA.value = "triggerValue")), IA.boolValue != null && IA.hasOwnProperty("boolValue") && (QA.boolValue = IA.boolValue, BA.oneofs && (QA.value = "boolValue")), IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.value = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util$1.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util$1.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber() : IA.intValue, BA.oneofs && (QA.value = "intValue")), IA.stringValue != null && IA.hasOwnProperty("stringValue") && (QA.stringValue = IA.stringValue, BA.oneofs && (QA.value = "stringValue")), IA.doubleArrayValue != null && IA.hasOwnProperty("doubleArrayValue") && (QA.doubleArrayValue = $root$1.DoubleArray.toObject(IA.doubleArrayValue, BA), BA.oneofs && (QA.value = "doubleArrayValue")), IA.intArrayValue != null && IA.hasOwnProperty("intArrayValue") && (QA.intArrayValue = $root$1.SInt64Array.toObject(IA.intArrayValue, BA), BA.oneofs && (QA.value = "intArrayValue")), IA.stringArrayValue != null && IA.hasOwnProperty("stringArrayValue") && (QA.stringArrayValue = $root$1.StringArray.toObject(IA.stringArrayValue, BA), BA.oneofs && (QA.value = "stringArrayValue")), IA.jsonValue != null && IA.hasOwnProperty("jsonValue") && (QA.jsonValue = IA.jsonValue, BA.oneofs && (QA.value = "jsonValue")), IA.arrowValue != null && IA.hasOwnProperty("arrowValue") && (QA.arrowValue = $root$1.ArrowTable.toObject(IA.arrowValue, BA), BA.oneofs && (QA.value = "arrowValue")), IA.bytesValue != null && IA.hasOwnProperty("bytesValue") && (QA.bytesValue = BA.bytes === String ? $util$1.base64.encode(IA.bytesValue, 0, IA.bytesValue.length) : BA.bytes === Array ? Array.prototype.slice.call(IA.bytesValue) : IA.bytesValue, BA.oneofs && (QA.value = "bytesValue")), IA.fileUploaderStateValue != null && IA.hasOwnProperty("fileUploaderStateValue") && (QA.fileUploaderStateValue = $root$1.FileUploaderState.toObject(IA.fileUploaderStateValue, BA), BA.oneofs && (QA.value = "fileUploaderStateValue")), IA.stringTriggerValue != null && IA.hasOwnProperty("stringTriggerValue") && (QA.stringTriggerValue = $root$1.StringTriggerValue.toObject(IA.stringTriggerValue, BA), BA.oneofs && (QA.value = "stringTriggerValue")), IA.chatInputValue != null && IA.hasOwnProperty("chatInputValue") && (QA.chatInputValue = $root$1.ChatInputValue.toObject(IA.chatInputValue, BA), BA.oneofs && (QA.value = "chatInputValue")), IA.jsonTriggerValue != null && IA.hasOwnProperty("jsonTriggerValue") && (QA.jsonTriggerValue = IA.jsonTriggerValue, BA.oneofs && (QA.value = "jsonTriggerValue")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/WidgetState";
  }, CA;
})(), StringArray = $root$1.StringArray = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) for (let BA = 0; BA < AA.data.length; ++BA) IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.data[BA]);
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.StringArray();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? (EA.data && EA.data.length || (EA.data = []), EA.data.push(AA.string())) : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.StringArray) return AA;
    let IA = new $root$1.StringArray();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".StringArray.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) IA.data[BA] = String(AA.data[BA]);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) BA.data[QA] = AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/StringArray";
  }, CA;
})(), DoubleArray = $root$1.DoubleArray = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) {
      IA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let BA = 0; BA < AA.data.length; ++BA) IA.double(AA.data[BA]);
      IA.ldelim();
    }
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.DoubleArray();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          if (EA.data && EA.data.length || (EA.data = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.data.push(AA.double());
          } else EA.data.push(AA.double());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.DoubleArray) return AA;
    let IA = new $root$1.DoubleArray();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".DoubleArray.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) IA.data[BA] = Number(AA.data[BA]);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) BA.data[QA] = IA.json && !isFinite(AA.data[QA]) ? String(AA.data[QA]) : AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DoubleArray";
  }, CA;
})();
$root$1.Int32Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) {
      IA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let BA = 0; BA < AA.data.length; ++BA) IA.int32(AA.data[BA]);
      IA.ldelim();
    }
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Int32Array();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          if (EA.data && EA.data.length || (EA.data = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.data.push(AA.int32());
          } else EA.data.push(AA.int32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Int32Array) return AA;
    let IA = new $root$1.Int32Array();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".Int32Array.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) IA.data[BA] = AA.data[BA] | 0;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) BA.data[QA] = AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Int32Array";
  }, CA;
})();
$root$1.Int64Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) {
      IA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let BA = 0; BA < AA.data.length; ++BA) IA.int64(AA.data[BA]);
      IA.ldelim();
    }
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Int64Array();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          if (EA.data && EA.data.length || (EA.data = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.data.push(AA.int64());
          } else EA.data.push(AA.int64());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Int64Array) return AA;
    let IA = new $root$1.Int64Array();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".Int64Array.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) $util$1.Long ? (IA.data[BA] = $util$1.Long.fromValue(AA.data[BA])).unsigned = !1 : typeof AA.data[BA] == "string" ? IA.data[BA] = parseInt(AA.data[BA], 10) : typeof AA.data[BA] == "number" ? IA.data[BA] = AA.data[BA] : typeof AA.data[BA] == "object" && (IA.data[BA] = new $util$1.LongBits(AA.data[BA].low >>> 0, AA.data[BA].high >>> 0).toNumber());
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) typeof AA.data[QA] == "number" ? BA.data[QA] = IA.longs === String ? String(AA.data[QA]) : AA.data[QA] : BA.data[QA] = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.data[QA]) : IA.longs === Number ? new $util$1.LongBits(AA.data[QA].low >>> 0, AA.data[QA].high >>> 0).toNumber() : AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Int64Array";
  }, CA;
})();
const SInt64Array = $root$1.SInt64Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) {
      IA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let BA = 0; BA < AA.data.length; ++BA) IA.sint64(AA.data[BA]);
      IA.ldelim();
    }
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.SInt64Array();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          if (EA.data && EA.data.length || (EA.data = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.data.push(AA.sint64());
          } else EA.data.push(AA.sint64());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.SInt64Array) return AA;
    let IA = new $root$1.SInt64Array();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".SInt64Array.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) $util$1.Long ? (IA.data[BA] = $util$1.Long.fromValue(AA.data[BA])).unsigned = !1 : typeof AA.data[BA] == "string" ? IA.data[BA] = parseInt(AA.data[BA], 10) : typeof AA.data[BA] == "number" ? IA.data[BA] = AA.data[BA] : typeof AA.data[BA] == "object" && (IA.data[BA] = new $util$1.LongBits(AA.data[BA].low >>> 0, AA.data[BA].high >>> 0).toNumber());
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) typeof AA.data[QA] == "number" ? BA.data[QA] = IA.longs === String ? String(AA.data[QA]) : AA.data[QA] : BA.data[QA] = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.data[QA]) : IA.longs === Number ? new $util$1.LongBits(AA.data[QA].low >>> 0, AA.data[QA].high >>> 0).toNumber() : AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/SInt64Array";
  }, CA;
})();
$root$1.UInt32Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.data != null && AA.data.length) {
      IA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let BA = 0; BA < AA.data.length; ++BA) IA.uint32(AA.data[BA]);
      IA.ldelim();
    }
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.UInt32Array();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          if (EA.data && EA.data.length || (EA.data = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.data.push(AA.uint32());
          } else EA.data.push(AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.UInt32Array) return AA;
    let IA = new $root$1.UInt32Array();
    if (AA.data) {
      if (!Array.isArray(AA.data)) throw TypeError(".UInt32Array.data: array expected");
      IA.data = [];
      for (let BA = 0; BA < AA.data.length; ++BA) IA.data[BA] = AA.data[BA] >>> 0;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.data = []), AA.data && AA.data.length) {
      BA.data = [];
      for (let QA = 0; QA < AA.data.length; ++QA) BA.data[QA] = AA.data[QA];
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/UInt32Array";
  }, CA;
})();
const StringTriggerValue = $root$1.StringTriggerValue = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.data = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_data", { get: $util$1.oneOfGetter(gA = ["data"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.data != null && Object.hasOwnProperty.call(IA, "data") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.data), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.StringTriggerValue();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      oA >>> 3 === 1 ? iA.data = IA.string() : IA.skipType(oA & 7);
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.StringTriggerValue) return IA;
    let BA = new $root$1.StringTriggerValue();
    return IA.data != null && (BA.data = String(IA.data)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return IA.data != null && IA.hasOwnProperty("data") && (QA.data = IA.data, BA.oneofs && (QA._data = "data")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/StringTriggerValue";
  }, CA;
})();
$root$1.FileURLsRequest = (() => {
  function CA(gA) {
    if (this.fileNames = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.requestId = "", CA.prototype.fileNames = $util$1.emptyArray, CA.prototype.sessionId = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.requestId != null && Object.hasOwnProperty.call(AA, "requestId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.requestId), AA.fileNames != null && AA.fileNames.length) for (let BA = 0; BA < AA.fileNames.length; ++BA) IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.fileNames[BA]);
    return AA.sessionId != null && Object.hasOwnProperty.call(AA, "sessionId") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.sessionId), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FileURLsRequest();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.requestId = AA.string();
          break;
        }
        case 2: {
          EA.fileNames && EA.fileNames.length || (EA.fileNames = []), EA.fileNames.push(AA.string());
          break;
        }
        case 3: {
          EA.sessionId = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FileURLsRequest) return AA;
    let IA = new $root$1.FileURLsRequest();
    if (AA.requestId != null && (IA.requestId = String(AA.requestId)), AA.fileNames) {
      if (!Array.isArray(AA.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      IA.fileNames = [];
      for (let BA = 0; BA < AA.fileNames.length; ++BA) IA.fileNames[BA] = String(AA.fileNames[BA]);
    }
    return AA.sessionId != null && (IA.sessionId = String(AA.sessionId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.fileNames = []), IA.defaults && (BA.requestId = "", BA.sessionId = ""), AA.requestId != null && AA.hasOwnProperty("requestId") && (BA.requestId = AA.requestId), AA.fileNames && AA.fileNames.length) {
      BA.fileNames = [];
      for (let QA = 0; QA < AA.fileNames.length; ++QA) BA.fileNames[QA] = AA.fileNames[QA];
    }
    return AA.sessionId != null && AA.hasOwnProperty("sessionId") && (BA.sessionId = AA.sessionId), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FileURLsRequest";
  }, CA;
})();
$root$1.FileURLs = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.uploadUrl = "", CA.prototype.deleteUrl = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.fileId != null && Object.hasOwnProperty.call(AA, "fileId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.fileId), AA.uploadUrl != null && Object.hasOwnProperty.call(AA, "uploadUrl") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.uploadUrl), AA.deleteUrl != null && Object.hasOwnProperty.call(AA, "deleteUrl") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.deleteUrl), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FileURLs();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.fileId = AA.string();
          break;
        }
        case 2: {
          EA.uploadUrl = AA.string();
          break;
        }
        case 3: {
          EA.deleteUrl = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FileURLs) return AA;
    let IA = new $root$1.FileURLs();
    return AA.fileId != null && (IA.fileId = String(AA.fileId)), AA.uploadUrl != null && (IA.uploadUrl = String(AA.uploadUrl)), AA.deleteUrl != null && (IA.deleteUrl = String(AA.deleteUrl)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.fileId = "", BA.uploadUrl = "", BA.deleteUrl = ""), AA.fileId != null && AA.hasOwnProperty("fileId") && (BA.fileId = AA.fileId), AA.uploadUrl != null && AA.hasOwnProperty("uploadUrl") && (BA.uploadUrl = AA.uploadUrl), AA.deleteUrl != null && AA.hasOwnProperty("deleteUrl") && (BA.deleteUrl = AA.deleteUrl), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FileURLs";
  }, CA;
})();
$root$1.FileURLsResponse = (() => {
  function CA(gA) {
    if (this.fileUrls = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.responseId = "", CA.prototype.fileUrls = $util$1.emptyArray, CA.prototype.errorMsg = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.responseId != null && Object.hasOwnProperty.call(AA, "responseId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.responseId), AA.fileUrls != null && AA.fileUrls.length) for (let BA = 0; BA < AA.fileUrls.length; ++BA) $root$1.FileURLs.encode(AA.fileUrls[BA], IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return AA.errorMsg != null && Object.hasOwnProperty.call(AA, "errorMsg") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.errorMsg), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FileURLsResponse();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.responseId = AA.string();
          break;
        }
        case 2: {
          EA.fileUrls && EA.fileUrls.length || (EA.fileUrls = []), EA.fileUrls.push($root$1.FileURLs.decode(AA, AA.uint32()));
          break;
        }
        case 3: {
          EA.errorMsg = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FileURLsResponse) return AA;
    let IA = new $root$1.FileURLsResponse();
    if (AA.responseId != null && (IA.responseId = String(AA.responseId)), AA.fileUrls) {
      if (!Array.isArray(AA.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      IA.fileUrls = [];
      for (let BA = 0; BA < AA.fileUrls.length; ++BA) {
        if (typeof AA.fileUrls[BA] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        IA.fileUrls[BA] = $root$1.FileURLs.fromObject(AA.fileUrls[BA]);
      }
    }
    return AA.errorMsg != null && (IA.errorMsg = String(AA.errorMsg)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.fileUrls = []), IA.defaults && (BA.responseId = "", BA.errorMsg = ""), AA.responseId != null && AA.hasOwnProperty("responseId") && (BA.responseId = AA.responseId), AA.fileUrls && AA.fileUrls.length) {
      BA.fileUrls = [];
      for (let QA = 0; QA < AA.fileUrls.length; ++QA) BA.fileUrls[QA] = $root$1.FileURLs.toObject(AA.fileUrls[QA], IA);
    }
    return AA.errorMsg != null && AA.hasOwnProperty("errorMsg") && (BA.errorMsg = AA.errorMsg), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FileURLsResponse";
  }, CA;
})();
const UploadedFileInfo = $root$1.UploadedFileInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.size = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, CA.prototype.fileId = "", CA.prototype.fileUrls = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.name), AA.size != null && Object.hasOwnProperty.call(AA, "size") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(AA.size), AA.fileId != null && Object.hasOwnProperty.call(AA, "fileId") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.fileId), AA.fileUrls != null && Object.hasOwnProperty.call(AA, "fileUrls") && $root$1.FileURLs.encode(AA.fileUrls, IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.UploadedFileInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 2: {
          EA.name = AA.string();
          break;
        }
        case 3: {
          EA.size = AA.uint64();
          break;
        }
        case 4: {
          EA.fileId = AA.string();
          break;
        }
        case 5: {
          EA.fileUrls = $root$1.FileURLs.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.UploadedFileInfo) return AA;
    let IA = new $root$1.UploadedFileInfo();
    if (AA.name != null && (IA.name = String(AA.name)), AA.size != null && ($util$1.Long ? (IA.size = $util$1.Long.fromValue(AA.size)).unsigned = !0 : typeof AA.size == "string" ? IA.size = parseInt(AA.size, 10) : typeof AA.size == "number" ? IA.size = AA.size : typeof AA.size == "object" && (IA.size = new $util$1.LongBits(AA.size.low >>> 0, AA.size.high >>> 0).toNumber(!0))), AA.fileId != null && (IA.fileId = String(AA.fileId)), AA.fileUrls != null) {
      if (typeof AA.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      IA.fileUrls = $root$1.FileURLs.fromObject(AA.fileUrls);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if (IA.defaults) {
      if (BA.name = "", $util$1.Long) {
        let QA = new $util$1.Long(0, 0, !0);
        BA.size = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.size = IA.longs === String ? "0" : 0;
      BA.fileId = "", BA.fileUrls = null;
    }
    return AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.size != null && AA.hasOwnProperty("size") && (typeof AA.size == "number" ? BA.size = IA.longs === String ? String(AA.size) : AA.size : BA.size = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.size) : IA.longs === Number ? new $util$1.LongBits(AA.size.low >>> 0, AA.size.high >>> 0).toNumber(!0) : AA.size), AA.fileId != null && AA.hasOwnProperty("fileId") && (BA.fileId = AA.fileId), AA.fileUrls != null && AA.hasOwnProperty("fileUrls") && (BA.fileUrls = $root$1.FileURLs.toObject(AA.fileUrls, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/UploadedFileInfo";
  }, CA;
})(), FileUploaderState = $root$1.FileUploaderState = (() => {
  function CA(gA) {
    if (this.uploadedFileInfo = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.uploadedFileInfo = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.uploadedFileInfo != null && AA.uploadedFileInfo.length) for (let BA = 0; BA < AA.uploadedFileInfo.length; ++BA) $root$1.UploadedFileInfo.encode(AA.uploadedFileInfo[BA], IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FileUploaderState();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 2 ? (EA.uploadedFileInfo && EA.uploadedFileInfo.length || (EA.uploadedFileInfo = []), EA.uploadedFileInfo.push($root$1.UploadedFileInfo.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FileUploaderState) return AA;
    let IA = new $root$1.FileUploaderState();
    if (AA.uploadedFileInfo) {
      if (!Array.isArray(AA.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      IA.uploadedFileInfo = [];
      for (let BA = 0; BA < AA.uploadedFileInfo.length; ++BA) {
        if (typeof AA.uploadedFileInfo[BA] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        IA.uploadedFileInfo[BA] = $root$1.UploadedFileInfo.fromObject(AA.uploadedFileInfo[BA]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.uploadedFileInfo = []), AA.uploadedFileInfo && AA.uploadedFileInfo.length) {
      BA.uploadedFileInfo = [];
      for (let QA = 0; QA < AA.uploadedFileInfo.length; ++QA) BA.uploadedFileInfo[QA] = $root$1.UploadedFileInfo.toObject(AA.uploadedFileInfo[QA], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FileUploaderState";
  }, CA;
})(), ChatInputValue = $root$1.ChatInputValue = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.data = null, CA.prototype.fileUploaderState = null, CA.prototype.audioFileInfo = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_data", { get: $util$1.oneOfGetter(gA = ["data"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_fileUploaderState", { get: $util$1.oneOfGetter(gA = ["fileUploaderState"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_audioFileInfo", { get: $util$1.oneOfGetter(gA = ["audioFileInfo"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.data != null && Object.hasOwnProperty.call(IA, "data") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.data), IA.fileUploaderState != null && Object.hasOwnProperty.call(IA, "fileUploaderState") && $root$1.FileUploaderState.encode(IA.fileUploaderState, BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA.audioFileInfo != null && Object.hasOwnProperty.call(IA, "audioFileInfo") && $root$1.UploadedFileInfo.encode(IA.audioFileInfo, BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ChatInputValue();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.data = IA.string();
          break;
        }
        case 2: {
          iA.fileUploaderState = $root$1.FileUploaderState.decode(IA, IA.uint32());
          break;
        }
        case 3: {
          iA.audioFileInfo = $root$1.UploadedFileInfo.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ChatInputValue) return IA;
    let BA = new $root$1.ChatInputValue();
    if (IA.data != null && (BA.data = String(IA.data)), IA.fileUploaderState != null) {
      if (typeof IA.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      BA.fileUploaderState = $root$1.FileUploaderState.fromObject(IA.fileUploaderState);
    }
    if (IA.audioFileInfo != null) {
      if (typeof IA.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      BA.audioFileInfo = $root$1.UploadedFileInfo.fromObject(IA.audioFileInfo);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return IA.data != null && IA.hasOwnProperty("data") && (QA.data = IA.data, BA.oneofs && (QA._data = "data")), IA.fileUploaderState != null && IA.hasOwnProperty("fileUploaderState") && (QA.fileUploaderState = $root$1.FileUploaderState.toObject(IA.fileUploaderState, BA), BA.oneofs && (QA._fileUploaderState = "fileUploaderState")), IA.audioFileInfo != null && IA.hasOwnProperty("audioFileInfo") && (QA.audioFileInfo = $root$1.UploadedFileInfo.toObject(IA.audioFileInfo, BA), BA.oneofs && (QA._audioFileInfo = "audioFileInfo")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ChatInputValue";
  }, CA;
})();
$root$1.ComponentInstance = (() => {
  function CA(AA) {
    if (this.specialArgs = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.jsonArgs = "", CA.prototype.specialArgs = $util$1.emptyArray, CA.prototype.componentName = "", CA.prototype.url = "", CA.prototype.formId = "", CA.prototype.tabIndex = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_tabIndex", { get: $util$1.oneOfGetter(gA = ["tabIndex"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.jsonArgs != null && Object.hasOwnProperty.call(IA, "jsonArgs") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.jsonArgs), IA.specialArgs != null && IA.specialArgs.length) for (let QA = 0; QA < IA.specialArgs.length; ++QA) $root$1.SpecialArg.encode(IA.specialArgs[QA], BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim();
    return IA.componentName != null && Object.hasOwnProperty.call(IA, "componentName") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.componentName), IA.url != null && Object.hasOwnProperty.call(IA, "url") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.url), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.tabIndex != null && Object.hasOwnProperty.call(IA, "tabIndex") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(IA.tabIndex), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ComponentInstance();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.jsonArgs = IA.string();
          break;
        }
        case 3: {
          iA.specialArgs && iA.specialArgs.length || (iA.specialArgs = []), iA.specialArgs.push($root$1.SpecialArg.decode(IA, IA.uint32()));
          break;
        }
        case 4: {
          iA.componentName = IA.string();
          break;
        }
        case 5: {
          iA.url = IA.string();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 7: {
          iA.tabIndex = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ComponentInstance) return IA;
    let BA = new $root$1.ComponentInstance();
    if (IA.id != null && (BA.id = String(IA.id)), IA.jsonArgs != null && (BA.jsonArgs = String(IA.jsonArgs)), IA.specialArgs) {
      if (!Array.isArray(IA.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      BA.specialArgs = [];
      for (let QA = 0; QA < IA.specialArgs.length; ++QA) {
        if (typeof IA.specialArgs[QA] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        BA.specialArgs[QA] = $root$1.SpecialArg.fromObject(IA.specialArgs[QA]);
      }
    }
    return IA.componentName != null && (BA.componentName = String(IA.componentName)), IA.url != null && (BA.url = String(IA.url)), IA.formId != null && (BA.formId = String(IA.formId)), IA.tabIndex != null && (BA.tabIndex = IA.tabIndex | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.specialArgs = []), BA.defaults && (QA.id = "", QA.jsonArgs = "", QA.componentName = "", QA.url = "", QA.formId = ""), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.jsonArgs != null && IA.hasOwnProperty("jsonArgs") && (QA.jsonArgs = IA.jsonArgs), IA.specialArgs && IA.specialArgs.length) {
      QA.specialArgs = [];
      for (let EA = 0; EA < IA.specialArgs.length; ++EA) QA.specialArgs[EA] = $root$1.SpecialArg.toObject(IA.specialArgs[EA], BA);
    }
    return IA.componentName != null && IA.hasOwnProperty("componentName") && (QA.componentName = IA.componentName), IA.url != null && IA.hasOwnProperty("url") && (QA.url = IA.url), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.tabIndex != null && IA.hasOwnProperty("tabIndex") && (QA.tabIndex = IA.tabIndex, BA.oneofs && (QA._tabIndex = "tabIndex")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ComponentInstance";
  }, CA;
})();
$root$1.SpecialArg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.key = "", CA.prototype.arrowDataframe = null, CA.prototype.bytes = null;
  let gA;
  return Object.defineProperty(CA.prototype, "value", { get: $util$1.oneOfGetter(gA = ["arrowDataframe", "bytes"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.key != null && Object.hasOwnProperty.call(IA, "key") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.key), IA.arrowDataframe != null && Object.hasOwnProperty.call(IA, "arrowDataframe") && $root$1.ArrowDataframe.encode(IA.arrowDataframe, BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA.bytes != null && Object.hasOwnProperty.call(IA, "bytes") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(IA.bytes), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.SpecialArg();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.key = IA.string();
          break;
        }
        case 2: {
          iA.arrowDataframe = $root$1.ArrowDataframe.decode(IA, IA.uint32());
          break;
        }
        case 3: {
          iA.bytes = IA.bytes();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.SpecialArg) return IA;
    let BA = new $root$1.SpecialArg();
    if (IA.key != null && (BA.key = String(IA.key)), IA.arrowDataframe != null) {
      if (typeof IA.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      BA.arrowDataframe = $root$1.ArrowDataframe.fromObject(IA.arrowDataframe);
    }
    return IA.bytes != null && (typeof IA.bytes == "string" ? $util$1.base64.decode(IA.bytes, BA.bytes = $util$1.newBuffer($util$1.base64.length(IA.bytes)), 0) : IA.bytes.length >= 0 && (BA.bytes = IA.bytes)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.key = ""), IA.key != null && IA.hasOwnProperty("key") && (QA.key = IA.key), IA.arrowDataframe != null && IA.hasOwnProperty("arrowDataframe") && (QA.arrowDataframe = $root$1.ArrowDataframe.toObject(IA.arrowDataframe, BA), BA.oneofs && (QA.value = "arrowDataframe")), IA.bytes != null && IA.hasOwnProperty("bytes") && (QA.bytes = BA.bytes === String ? $util$1.base64.encode(IA.bytes, 0, IA.bytes.length) : BA.bytes === Array ? Array.prototype.slice.call(IA.bytes) : IA.bytes, BA.oneofs && (QA.value = "bytes")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/SpecialArg";
  }, CA;
})();
const ArrowDataframe = $root$1.ArrowDataframe = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = null, CA.prototype.height = 0, CA.prototype.width = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.data != null && Object.hasOwnProperty.call(AA, "data") && $root$1.ArrowTable.encode(AA.data, IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), AA.height != null && Object.hasOwnProperty.call(AA, "height") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(AA.height), AA.width != null && Object.hasOwnProperty.call(AA, "width") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(AA.width), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ArrowDataframe();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.data = $root$1.ArrowTable.decode(AA, AA.uint32());
          break;
        }
        case 2: {
          EA.height = AA.uint32();
          break;
        }
        case 3: {
          EA.width = AA.uint32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ArrowDataframe) return AA;
    let IA = new $root$1.ArrowDataframe();
    if (AA.data != null) {
      if (typeof AA.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      IA.data = $root$1.ArrowTable.fromObject(AA.data);
    }
    return AA.height != null && (IA.height = AA.height >>> 0), AA.width != null && (IA.width = AA.width >>> 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.data = null, BA.height = 0, BA.width = 0), AA.data != null && AA.hasOwnProperty("data") && (BA.data = $root$1.ArrowTable.toObject(AA.data, IA)), AA.height != null && AA.hasOwnProperty("height") && (BA.height = AA.height), AA.width != null && AA.hasOwnProperty("width") && (BA.width = AA.width), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowDataframe";
  }, CA;
})();
$root$1.ArrowTable = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util$1.newBuffer([]), CA.prototype.index = $util$1.newBuffer([]), CA.prototype.columns = $util$1.newBuffer([]), CA.prototype.styler = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.data != null && Object.hasOwnProperty.call(AA, "data") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(AA.data), AA.index != null && Object.hasOwnProperty.call(AA, "index") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(AA.index), AA.columns != null && Object.hasOwnProperty.call(AA, "columns") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(AA.columns), AA.styler != null && Object.hasOwnProperty.call(AA, "styler") && $root$1.ArrowTableStyler.encode(AA.styler, IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ArrowTable();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.data = AA.bytes();
          break;
        }
        case 2: {
          EA.index = AA.bytes();
          break;
        }
        case 3: {
          EA.columns = AA.bytes();
          break;
        }
        case 5: {
          EA.styler = $root$1.ArrowTableStyler.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ArrowTable) return AA;
    let IA = new $root$1.ArrowTable();
    if (AA.data != null && (typeof AA.data == "string" ? $util$1.base64.decode(AA.data, IA.data = $util$1.newBuffer($util$1.base64.length(AA.data)), 0) : AA.data.length >= 0 && (IA.data = AA.data)), AA.index != null && (typeof AA.index == "string" ? $util$1.base64.decode(AA.index, IA.index = $util$1.newBuffer($util$1.base64.length(AA.index)), 0) : AA.index.length >= 0 && (IA.index = AA.index)), AA.columns != null && (typeof AA.columns == "string" ? $util$1.base64.decode(AA.columns, IA.columns = $util$1.newBuffer($util$1.base64.length(AA.columns)), 0) : AA.columns.length >= 0 && (IA.columns = AA.columns)), AA.styler != null) {
      if (typeof AA.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      IA.styler = $root$1.ArrowTableStyler.fromObject(AA.styler);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (IA.bytes === String ? BA.data = "" : (BA.data = [], IA.bytes !== Array && (BA.data = $util$1.newBuffer(BA.data))), IA.bytes === String ? BA.index = "" : (BA.index = [], IA.bytes !== Array && (BA.index = $util$1.newBuffer(BA.index))), IA.bytes === String ? BA.columns = "" : (BA.columns = [], IA.bytes !== Array && (BA.columns = $util$1.newBuffer(BA.columns))), BA.styler = null), AA.data != null && AA.hasOwnProperty("data") && (BA.data = IA.bytes === String ? $util$1.base64.encode(AA.data, 0, AA.data.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.data) : AA.data), AA.index != null && AA.hasOwnProperty("index") && (BA.index = IA.bytes === String ? $util$1.base64.encode(AA.index, 0, AA.index.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.index) : AA.index), AA.columns != null && AA.hasOwnProperty("columns") && (BA.columns = IA.bytes === String ? $util$1.base64.encode(AA.columns, 0, AA.columns.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.columns) : AA.columns), AA.styler != null && AA.hasOwnProperty("styler") && (BA.styler = $root$1.ArrowTableStyler.toObject(AA.styler, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowTable";
  }, CA;
})();
$root$1.ArrowTableStyler = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.uuid = "", CA.prototype.caption = "", CA.prototype.styles = "", CA.prototype.displayValues = $util$1.newBuffer([]), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.uuid != null && Object.hasOwnProperty.call(AA, "uuid") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.uuid), AA.caption != null && Object.hasOwnProperty.call(AA, "caption") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.caption), AA.styles != null && Object.hasOwnProperty.call(AA, "styles") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.styles), AA.displayValues != null && Object.hasOwnProperty.call(AA, "displayValues") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(AA.displayValues), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ArrowTableStyler();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.uuid = AA.string();
          break;
        }
        case 2: {
          EA.caption = AA.string();
          break;
        }
        case 3: {
          EA.styles = AA.string();
          break;
        }
        case 4: {
          EA.displayValues = AA.bytes();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ArrowTableStyler) return AA;
    let IA = new $root$1.ArrowTableStyler();
    return AA.uuid != null && (IA.uuid = String(AA.uuid)), AA.caption != null && (IA.caption = String(AA.caption)), AA.styles != null && (IA.styles = String(AA.styles)), AA.displayValues != null && (typeof AA.displayValues == "string" ? $util$1.base64.decode(AA.displayValues, IA.displayValues = $util$1.newBuffer($util$1.base64.length(AA.displayValues)), 0) : AA.displayValues.length >= 0 && (IA.displayValues = AA.displayValues)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.uuid = "", BA.caption = "", BA.styles = "", IA.bytes === String ? BA.displayValues = "" : (BA.displayValues = [], IA.bytes !== Array && (BA.displayValues = $util$1.newBuffer(BA.displayValues)))), AA.uuid != null && AA.hasOwnProperty("uuid") && (BA.uuid = AA.uuid), AA.caption != null && AA.hasOwnProperty("caption") && (BA.caption = AA.caption), AA.styles != null && AA.hasOwnProperty("styles") && (BA.styles = AA.styles), AA.displayValues != null && AA.hasOwnProperty("displayValues") && (BA.displayValues = IA.bytes === String ? $util$1.base64.encode(AA.displayValues, 0, AA.displayValues.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.displayValues) : AA.displayValues), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowTableStyler";
  }, CA;
})();
$root$1.Balloons = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.show = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.show != null && Object.hasOwnProperty.call(AA, "show") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.show), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Balloons();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 3 ? EA.show = AA.bool() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Balloons) return AA;
    let IA = new $root$1.Balloons();
    return AA.show != null && (IA.show = !!AA.show), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.show = !1), AA.show != null && AA.hasOwnProperty("show") && (BA.show = AA.show), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Balloons";
  }, CA;
})();
$root$1.MixedData = (() => {
  function CA(gA) {
    if (this.arrowBlobs = {}, gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.json = "", CA.prototype.arrowBlobs = $util$1.emptyObject, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.json != null && Object.hasOwnProperty.call(AA, "json") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.json), AA.arrowBlobs != null && Object.hasOwnProperty.call(AA, "arrowBlobs")) for (let BA = Object.keys(AA.arrowBlobs), QA = 0; QA < BA.length; ++QA)
      IA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork().uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA[QA]), $root$1.ArrowData.encode(AA.arrowBlobs[BA[QA]], IA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim().ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.MixedData(), iA, oA;
    for (; AA.pos < QA; ) {
      let cA = AA.uint32();
      if (cA === BA) break;
      switch (cA >>> 3) {
        case 1: {
          EA.json = AA.string();
          break;
        }
        case 2: {
          EA.arrowBlobs === $util$1.emptyObject && (EA.arrowBlobs = {});
          let tA = AA.uint32() + AA.pos;
          for (iA = "", oA = null; AA.pos < tA; ) {
            let eA = AA.uint32();
            switch (eA >>> 3) {
              case 1:
                iA = AA.string();
                break;
              case 2:
                oA = $root$1.ArrowData.decode(AA, AA.uint32());
                break;
              default:
                AA.skipType(eA & 7);
                break;
            }
          }
          EA.arrowBlobs[iA] = oA;
          break;
        }
        default:
          AA.skipType(cA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.MixedData) return AA;
    let IA = new $root$1.MixedData();
    if (AA.json != null && (IA.json = String(AA.json)), AA.arrowBlobs) {
      if (typeof AA.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      IA.arrowBlobs = {};
      for (let BA = Object.keys(AA.arrowBlobs), QA = 0; QA < BA.length; ++QA) {
        if (typeof AA.arrowBlobs[BA[QA]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        IA.arrowBlobs[BA[QA]] = $root$1.ArrowData.fromObject(AA.arrowBlobs[BA[QA]]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    (IA.objects || IA.defaults) && (BA.arrowBlobs = {}), IA.defaults && (BA.json = ""), AA.json != null && AA.hasOwnProperty("json") && (BA.json = AA.json);
    let QA;
    if (AA.arrowBlobs && (QA = Object.keys(AA.arrowBlobs)).length) {
      BA.arrowBlobs = {};
      for (let EA = 0; EA < QA.length; ++EA) BA.arrowBlobs[QA[EA]] = $root$1.ArrowData.toObject(AA.arrowBlobs[QA[EA]], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/MixedData";
  }, CA;
})();
$root$1.BidiComponent = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.componentName = "", CA.prototype.jsContent = null, CA.prototype.jsSourcePath = null, CA.prototype.formId = "", CA.prototype.htmlContent = null, CA.prototype.cssContent = null, CA.prototype.cssSourcePath = null, CA.prototype.isolateStyles = !1, CA.prototype.json = null, CA.prototype.arrowData = null, CA.prototype.bytes = null, CA.prototype.mixed = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_jsContent", { get: $util$1.oneOfGetter(gA = ["jsContent"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_jsSourcePath", { get: $util$1.oneOfGetter(gA = ["jsSourcePath"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_htmlContent", { get: $util$1.oneOfGetter(gA = ["htmlContent"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_cssContent", { get: $util$1.oneOfGetter(gA = ["cssContent"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_cssSourcePath", { get: $util$1.oneOfGetter(gA = ["cssSourcePath"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "data", { get: $util$1.oneOfGetter(gA = ["json", "arrowData", "bytes", "mixed"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.componentName != null && Object.hasOwnProperty.call(IA, "componentName") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.componentName), IA.jsContent != null && Object.hasOwnProperty.call(IA, "jsContent") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.jsContent), IA.jsSourcePath != null && Object.hasOwnProperty.call(IA, "jsSourcePath") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.jsSourcePath), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.htmlContent != null && Object.hasOwnProperty.call(IA, "htmlContent") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.htmlContent), IA.cssContent != null && Object.hasOwnProperty.call(IA, "cssContent") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.cssContent), IA.cssSourcePath != null && Object.hasOwnProperty.call(IA, "cssSourcePath") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.cssSourcePath), IA.isolateStyles != null && Object.hasOwnProperty.call(IA, "isolateStyles") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.isolateStyles), IA.json != null && Object.hasOwnProperty.call(IA, "json") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.json), IA.arrowData != null && Object.hasOwnProperty.call(IA, "arrowData") && $root$1.ArrowData.encode(IA.arrowData, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.bytes != null && Object.hasOwnProperty.call(IA, "bytes") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(IA.bytes), IA.mixed != null && Object.hasOwnProperty.call(IA, "mixed") && $root$1.MixedData.encode(IA.mixed, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.BidiComponent();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.componentName = IA.string();
          break;
        }
        case 3: {
          iA.jsContent = IA.string();
          break;
        }
        case 4: {
          iA.jsSourcePath = IA.string();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.htmlContent = IA.string();
          break;
        }
        case 7: {
          iA.cssContent = IA.string();
          break;
        }
        case 8: {
          iA.cssSourcePath = IA.string();
          break;
        }
        case 9: {
          iA.isolateStyles = IA.bool();
          break;
        }
        case 10: {
          iA.json = IA.string();
          break;
        }
        case 11: {
          iA.arrowData = $root$1.ArrowData.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.bytes = IA.bytes();
          break;
        }
        case 13: {
          iA.mixed = $root$1.MixedData.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.BidiComponent) return IA;
    let BA = new $root$1.BidiComponent();
    if (IA.id != null && (BA.id = String(IA.id)), IA.componentName != null && (BA.componentName = String(IA.componentName)), IA.jsContent != null && (BA.jsContent = String(IA.jsContent)), IA.jsSourcePath != null && (BA.jsSourcePath = String(IA.jsSourcePath)), IA.formId != null && (BA.formId = String(IA.formId)), IA.htmlContent != null && (BA.htmlContent = String(IA.htmlContent)), IA.cssContent != null && (BA.cssContent = String(IA.cssContent)), IA.cssSourcePath != null && (BA.cssSourcePath = String(IA.cssSourcePath)), IA.isolateStyles != null && (BA.isolateStyles = !!IA.isolateStyles), IA.json != null && (BA.json = String(IA.json)), IA.arrowData != null) {
      if (typeof IA.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      BA.arrowData = $root$1.ArrowData.fromObject(IA.arrowData);
    }
    if (IA.bytes != null && (typeof IA.bytes == "string" ? $util$1.base64.decode(IA.bytes, BA.bytes = $util$1.newBuffer($util$1.base64.length(IA.bytes)), 0) : IA.bytes.length >= 0 && (BA.bytes = IA.bytes)), IA.mixed != null) {
      if (typeof IA.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      BA.mixed = $root$1.MixedData.fromObject(IA.mixed);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.componentName = "", QA.formId = "", QA.isolateStyles = !1), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.componentName != null && IA.hasOwnProperty("componentName") && (QA.componentName = IA.componentName), IA.jsContent != null && IA.hasOwnProperty("jsContent") && (QA.jsContent = IA.jsContent, BA.oneofs && (QA._jsContent = "jsContent")), IA.jsSourcePath != null && IA.hasOwnProperty("jsSourcePath") && (QA.jsSourcePath = IA.jsSourcePath, BA.oneofs && (QA._jsSourcePath = "jsSourcePath")), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.htmlContent != null && IA.hasOwnProperty("htmlContent") && (QA.htmlContent = IA.htmlContent, BA.oneofs && (QA._htmlContent = "htmlContent")), IA.cssContent != null && IA.hasOwnProperty("cssContent") && (QA.cssContent = IA.cssContent, BA.oneofs && (QA._cssContent = "cssContent")), IA.cssSourcePath != null && IA.hasOwnProperty("cssSourcePath") && (QA.cssSourcePath = IA.cssSourcePath, BA.oneofs && (QA._cssSourcePath = "cssSourcePath")), IA.isolateStyles != null && IA.hasOwnProperty("isolateStyles") && (QA.isolateStyles = IA.isolateStyles), IA.json != null && IA.hasOwnProperty("json") && (QA.json = IA.json, BA.oneofs && (QA.data = "json")), IA.arrowData != null && IA.hasOwnProperty("arrowData") && (QA.arrowData = $root$1.ArrowData.toObject(IA.arrowData, BA), BA.oneofs && (QA.data = "arrowData")), IA.bytes != null && IA.hasOwnProperty("bytes") && (QA.bytes = BA.bytes === String ? $util$1.base64.encode(IA.bytes, 0, IA.bytes.length) : BA.bytes === Array ? Array.prototype.slice.call(IA.bytes) : IA.bytes, BA.oneofs && (QA.data = "bytes")), IA.mixed != null && IA.hasOwnProperty("mixed") && (QA.mixed = $root$1.MixedData.toObject(IA.mixed, BA), BA.oneofs && (QA.data = "mixed")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/BidiComponent";
  }, CA;
})();
const Block$1 = $root$1.Block = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.vertical = null, CA.prototype.horizontal = null, CA.prototype.column = null, CA.prototype.expandable = null, CA.prototype.form = null, CA.prototype.tabContainer = null, CA.prototype.tab = null, CA.prototype.chatMessage = null, CA.prototype.popover = null, CA.prototype.dialog = null, CA.prototype.flexContainer = null, CA.prototype.allowEmpty = !1, CA.prototype.id = null, CA.prototype.heightConfig = null, CA.prototype.widthConfig = null, CA.prototype.autoscroll = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_id", { get: $util$1.oneOfGetter(gA = ["id"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_heightConfig", { get: $util$1.oneOfGetter(gA = ["heightConfig"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_widthConfig", { get: $util$1.oneOfGetter(gA = ["widthConfig"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_autoscroll", { get: $util$1.oneOfGetter(gA = ["autoscroll"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.vertical != null && Object.hasOwnProperty.call(IA, "vertical") && $root$1.Block.Vertical.encode(IA.vertical, BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), IA.horizontal != null && Object.hasOwnProperty.call(IA, "horizontal") && $root$1.Block.Horizontal.encode(IA.horizontal, BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA.column != null && Object.hasOwnProperty.call(IA, "column") && $root$1.Block.Column.encode(IA.column, BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), IA.expandable != null && Object.hasOwnProperty.call(IA, "expandable") && $root$1.Block.Expandable.encode(IA.expandable, BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), IA.form != null && Object.hasOwnProperty.call(IA, "form") && $root$1.Block.Form.encode(IA.form, BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA.tabContainer != null && Object.hasOwnProperty.call(IA, "tabContainer") && $root$1.Block.TabContainer.encode(IA.tabContainer, BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA.tab != null && Object.hasOwnProperty.call(IA, "tab") && $root$1.Block.Tab.encode(IA.tab, BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), IA.allowEmpty != null && Object.hasOwnProperty.call(IA, "allowEmpty") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.allowEmpty), IA.chatMessage != null && Object.hasOwnProperty.call(IA, "chatMessage") && $root$1.Block.ChatMessage.encode(IA.chatMessage, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.popover != null && Object.hasOwnProperty.call(IA, "popover") && $root$1.Block.Popover.encode(IA.popover, BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), IA.dialog != null && Object.hasOwnProperty.call(IA, "dialog") && $root$1.Block.Dialog.encode(IA.dialog, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.id), IA.flexContainer != null && Object.hasOwnProperty.call(IA, "flexContainer") && $root$1.Block.FlexContainer.encode(IA.flexContainer, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), IA.heightConfig != null && Object.hasOwnProperty.call(IA, "heightConfig") && $root$1.streamlit.HeightConfig.encode(IA.heightConfig, BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), IA.widthConfig != null && Object.hasOwnProperty.call(IA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(IA.widthConfig, BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), IA.autoscroll != null && Object.hasOwnProperty.call(IA, "autoscroll") && BA.uint32(
      /* id 16, wireType 0 =*/
      128
    ).bool(IA.autoscroll), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Block();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.vertical = $root$1.Block.Vertical.decode(IA, IA.uint32());
          break;
        }
        case 2: {
          iA.horizontal = $root$1.Block.Horizontal.decode(IA, IA.uint32());
          break;
        }
        case 3: {
          iA.column = $root$1.Block.Column.decode(IA, IA.uint32());
          break;
        }
        case 4: {
          iA.expandable = $root$1.Block.Expandable.decode(IA, IA.uint32());
          break;
        }
        case 5: {
          iA.form = $root$1.Block.Form.decode(IA, IA.uint32());
          break;
        }
        case 6: {
          iA.tabContainer = $root$1.Block.TabContainer.decode(IA, IA.uint32());
          break;
        }
        case 7: {
          iA.tab = $root$1.Block.Tab.decode(IA, IA.uint32());
          break;
        }
        case 9: {
          iA.chatMessage = $root$1.Block.ChatMessage.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.popover = $root$1.Block.Popover.decode(IA, IA.uint32());
          break;
        }
        case 11: {
          iA.dialog = $root$1.Block.Dialog.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.flexContainer = $root$1.Block.FlexContainer.decode(IA, IA.uint32());
          break;
        }
        case 8: {
          iA.allowEmpty = IA.bool();
          break;
        }
        case 12: {
          iA.id = IA.string();
          break;
        }
        case 14: {
          iA.heightConfig = $root$1.streamlit.HeightConfig.decode(IA, IA.uint32());
          break;
        }
        case 15: {
          iA.widthConfig = $root$1.streamlit.WidthConfig.decode(IA, IA.uint32());
          break;
        }
        case 16: {
          iA.autoscroll = IA.bool();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Block) return IA;
    let BA = new $root$1.Block();
    if (IA.vertical != null) {
      if (typeof IA.vertical != "object") throw TypeError(".Block.vertical: object expected");
      BA.vertical = $root$1.Block.Vertical.fromObject(IA.vertical);
    }
    if (IA.horizontal != null) {
      if (typeof IA.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      BA.horizontal = $root$1.Block.Horizontal.fromObject(IA.horizontal);
    }
    if (IA.column != null) {
      if (typeof IA.column != "object") throw TypeError(".Block.column: object expected");
      BA.column = $root$1.Block.Column.fromObject(IA.column);
    }
    if (IA.expandable != null) {
      if (typeof IA.expandable != "object") throw TypeError(".Block.expandable: object expected");
      BA.expandable = $root$1.Block.Expandable.fromObject(IA.expandable);
    }
    if (IA.form != null) {
      if (typeof IA.form != "object") throw TypeError(".Block.form: object expected");
      BA.form = $root$1.Block.Form.fromObject(IA.form);
    }
    if (IA.tabContainer != null) {
      if (typeof IA.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      BA.tabContainer = $root$1.Block.TabContainer.fromObject(IA.tabContainer);
    }
    if (IA.tab != null) {
      if (typeof IA.tab != "object") throw TypeError(".Block.tab: object expected");
      BA.tab = $root$1.Block.Tab.fromObject(IA.tab);
    }
    if (IA.chatMessage != null) {
      if (typeof IA.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      BA.chatMessage = $root$1.Block.ChatMessage.fromObject(IA.chatMessage);
    }
    if (IA.popover != null) {
      if (typeof IA.popover != "object") throw TypeError(".Block.popover: object expected");
      BA.popover = $root$1.Block.Popover.fromObject(IA.popover);
    }
    if (IA.dialog != null) {
      if (typeof IA.dialog != "object") throw TypeError(".Block.dialog: object expected");
      BA.dialog = $root$1.Block.Dialog.fromObject(IA.dialog);
    }
    if (IA.flexContainer != null) {
      if (typeof IA.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      BA.flexContainer = $root$1.Block.FlexContainer.fromObject(IA.flexContainer);
    }
    if (IA.allowEmpty != null && (BA.allowEmpty = !!IA.allowEmpty), IA.id != null && (BA.id = String(IA.id)), IA.heightConfig != null) {
      if (typeof IA.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      BA.heightConfig = $root$1.streamlit.HeightConfig.fromObject(IA.heightConfig);
    }
    if (IA.widthConfig != null) {
      if (typeof IA.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      BA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(IA.widthConfig);
    }
    return IA.autoscroll != null && (BA.autoscroll = !!IA.autoscroll), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.allowEmpty = !1), IA.vertical != null && IA.hasOwnProperty("vertical") && (QA.vertical = $root$1.Block.Vertical.toObject(IA.vertical, BA), BA.oneofs && (QA.type = "vertical")), IA.horizontal != null && IA.hasOwnProperty("horizontal") && (QA.horizontal = $root$1.Block.Horizontal.toObject(IA.horizontal, BA), BA.oneofs && (QA.type = "horizontal")), IA.column != null && IA.hasOwnProperty("column") && (QA.column = $root$1.Block.Column.toObject(IA.column, BA), BA.oneofs && (QA.type = "column")), IA.expandable != null && IA.hasOwnProperty("expandable") && (QA.expandable = $root$1.Block.Expandable.toObject(IA.expandable, BA), BA.oneofs && (QA.type = "expandable")), IA.form != null && IA.hasOwnProperty("form") && (QA.form = $root$1.Block.Form.toObject(IA.form, BA), BA.oneofs && (QA.type = "form")), IA.tabContainer != null && IA.hasOwnProperty("tabContainer") && (QA.tabContainer = $root$1.Block.TabContainer.toObject(IA.tabContainer, BA), BA.oneofs && (QA.type = "tabContainer")), IA.tab != null && IA.hasOwnProperty("tab") && (QA.tab = $root$1.Block.Tab.toObject(IA.tab, BA), BA.oneofs && (QA.type = "tab")), IA.allowEmpty != null && IA.hasOwnProperty("allowEmpty") && (QA.allowEmpty = IA.allowEmpty), IA.chatMessage != null && IA.hasOwnProperty("chatMessage") && (QA.chatMessage = $root$1.Block.ChatMessage.toObject(IA.chatMessage, BA), BA.oneofs && (QA.type = "chatMessage")), IA.popover != null && IA.hasOwnProperty("popover") && (QA.popover = $root$1.Block.Popover.toObject(IA.popover, BA), BA.oneofs && (QA.type = "popover")), IA.dialog != null && IA.hasOwnProperty("dialog") && (QA.dialog = $root$1.Block.Dialog.toObject(IA.dialog, BA), BA.oneofs && (QA.type = "dialog")), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id, BA.oneofs && (QA._id = "id")), IA.flexContainer != null && IA.hasOwnProperty("flexContainer") && (QA.flexContainer = $root$1.Block.FlexContainer.toObject(IA.flexContainer, BA), BA.oneofs && (QA.type = "flexContainer")), IA.heightConfig != null && IA.hasOwnProperty("heightConfig") && (QA.heightConfig = $root$1.streamlit.HeightConfig.toObject(IA.heightConfig, BA), BA.oneofs && (QA._heightConfig = "heightConfig")), IA.widthConfig != null && IA.hasOwnProperty("widthConfig") && (QA.widthConfig = $root$1.streamlit.WidthConfig.toObject(IA.widthConfig, BA), BA.oneofs && (QA._widthConfig = "widthConfig")), IA.autoscroll != null && IA.hasOwnProperty("autoscroll") && (QA.autoscroll = IA.autoscroll, BA.oneofs && (QA._autoscroll = "autoscroll")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block";
  }, CA.Vertical = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.border = !1, AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.border != null && Object.hasOwnProperty.call(BA, "border") && QA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(BA.border), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.Vertical();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        cA >>> 3 === 1 ? oA.border = BA.bool() : BA.skipType(cA & 7);
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.Vertical) return BA;
      let QA = new $root$1.Block.Vertical();
      return BA.border != null && (QA.border = !!BA.border), QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.border = !1), BA.border != null && BA.hasOwnProperty("border") && (EA.border = BA.border), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Vertical";
    }, AA;
  })(), CA.Horizontal = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.gap = "", AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.gap != null && Object.hasOwnProperty.call(BA, "gap") && QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA.gap), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.Horizontal();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        cA >>> 3 === 1 ? oA.gap = BA.string() : BA.skipType(cA & 7);
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.Horizontal) return BA;
      let QA = new $root$1.Block.Horizontal();
      return BA.gap != null && (QA.gap = String(BA.gap)), QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.gap = ""), BA.gap != null && BA.hasOwnProperty("gap") && (EA.gap = BA.gap), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Horizontal";
    }, AA;
  })(), CA.FlexContainer = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.border = !1, AA.prototype.gapConfig = null, AA.prototype.scale = 0, AA.prototype.direction = 0, AA.prototype.wrap = !1, AA.prototype.justify = 0, AA.prototype.align = 0, AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.border != null && Object.hasOwnProperty.call(BA, "border") && QA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(BA.border), BA.gapConfig != null && Object.hasOwnProperty.call(BA, "gapConfig") && $root$1.streamlit.GapConfig.encode(BA.gapConfig, QA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), BA.scale != null && Object.hasOwnProperty.call(BA, "scale") && QA.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(BA.scale), BA.direction != null && Object.hasOwnProperty.call(BA, "direction") && QA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(BA.direction), BA.wrap != null && Object.hasOwnProperty.call(BA, "wrap") && QA.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(BA.wrap), BA.justify != null && Object.hasOwnProperty.call(BA, "justify") && QA.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(BA.justify), BA.align != null && Object.hasOwnProperty.call(BA, "align") && QA.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(BA.align), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.FlexContainer();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.border = BA.bool();
            break;
          }
          case 2: {
            oA.gapConfig = $root$1.streamlit.GapConfig.decode(BA, BA.uint32());
            break;
          }
          case 3: {
            oA.scale = BA.float();
            break;
          }
          case 4: {
            oA.direction = BA.int32();
            break;
          }
          case 5: {
            oA.wrap = BA.bool();
            break;
          }
          case 7: {
            oA.justify = BA.int32();
            break;
          }
          case 8: {
            oA.align = BA.int32();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.FlexContainer) return BA;
      let QA = new $root$1.Block.FlexContainer();
      if (BA.border != null && (QA.border = !!BA.border), BA.gapConfig != null) {
        if (typeof BA.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        QA.gapConfig = $root$1.streamlit.GapConfig.fromObject(BA.gapConfig);
      }
      switch (BA.scale != null && (QA.scale = Number(BA.scale)), BA.direction) {
        default:
          if (typeof BA.direction == "number") {
            QA.direction = BA.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          QA.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          QA.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          QA.direction = 2;
          break;
      }
      switch (BA.wrap != null && (QA.wrap = !!BA.wrap), BA.justify) {
        default:
          if (typeof BA.justify == "number") {
            QA.justify = BA.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          QA.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          QA.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          QA.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          QA.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          QA.justify = 4;
          break;
      }
      switch (BA.align) {
        default:
          if (typeof BA.align == "number") {
            QA.align = BA.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          QA.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          QA.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          QA.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          QA.align = 3;
          break;
        case "STRETCH":
        case 4:
          QA.align = 4;
          break;
      }
      return QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.border = !1, EA.gapConfig = null, EA.scale = 0, EA.direction = QA.enums === String ? "DIRECTION_UNDEFINED" : 0, EA.wrap = !1, EA.justify = QA.enums === String ? "JUSTIFY_UNDEFINED" : 0, EA.align = QA.enums === String ? "ALIGN_UNDEFINED" : 0), BA.border != null && BA.hasOwnProperty("border") && (EA.border = BA.border), BA.gapConfig != null && BA.hasOwnProperty("gapConfig") && (EA.gapConfig = $root$1.streamlit.GapConfig.toObject(BA.gapConfig, QA)), BA.scale != null && BA.hasOwnProperty("scale") && (EA.scale = QA.json && !isFinite(BA.scale) ? String(BA.scale) : BA.scale), BA.direction != null && BA.hasOwnProperty("direction") && (EA.direction = QA.enums === String ? $root$1.Block.FlexContainer.Direction[BA.direction] === void 0 ? BA.direction : $root$1.Block.FlexContainer.Direction[BA.direction] : BA.direction), BA.wrap != null && BA.hasOwnProperty("wrap") && (EA.wrap = BA.wrap), BA.justify != null && BA.hasOwnProperty("justify") && (EA.justify = QA.enums === String ? $root$1.Block.FlexContainer.Justify[BA.justify] === void 0 ? BA.justify : $root$1.Block.FlexContainer.Justify[BA.justify] : BA.justify), BA.align != null && BA.hasOwnProperty("align") && (EA.align = QA.enums === String ? $root$1.Block.FlexContainer.Align[BA.align] === void 0 ? BA.align : $root$1.Block.FlexContainer.Align[BA.align] : BA.align), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.FlexContainer";
    }, AA.Direction = (function() {
      const IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "DIRECTION_UNDEFINED"] = 0, BA[IA[1] = "VERTICAL"] = 1, BA[IA[2] = "HORIZONTAL"] = 2, BA;
    })(), AA.Justify = (function() {
      const IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "JUSTIFY_UNDEFINED"] = 0, BA[IA[1] = "JUSTIFY_START"] = 1, BA[IA[2] = "JUSTIFY_END"] = 2, BA[IA[3] = "JUSTIFY_CENTER"] = 3, BA[IA[4] = "SPACE_BETWEEN"] = 4, BA;
    })(), AA.Align = (function() {
      const IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "ALIGN_UNDEFINED"] = 0, BA[IA[1] = "ALIGN_START"] = 1, BA[IA[2] = "ALIGN_END"] = 2, BA[IA[3] = "ALIGN_CENTER"] = 3, BA[IA[4] = "STRETCH"] = 4, BA;
    })(), AA;
  })(), CA.Column = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.weight = 0, AA.prototype.verticalAlignment = 0, AA.prototype.showBorder = !1, AA.prototype.gapConfig = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_gapConfig", { get: $util$1.oneOfGetter(IA = ["gapConfig"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.weight != null && Object.hasOwnProperty.call(QA, "weight") && EA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(QA.weight), QA.verticalAlignment != null && Object.hasOwnProperty.call(QA, "verticalAlignment") && EA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(QA.verticalAlignment), QA.showBorder != null && Object.hasOwnProperty.call(QA, "showBorder") && EA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(QA.showBorder), QA.gapConfig != null && Object.hasOwnProperty.call(QA, "gapConfig") && $root$1.streamlit.GapConfig.encode(QA.gapConfig, EA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.Block.Column();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.weight = QA.double();
            break;
          }
          case 3: {
            cA.verticalAlignment = QA.int32();
            break;
          }
          case 4: {
            cA.showBorder = QA.bool();
            break;
          }
          case 5: {
            cA.gapConfig = $root$1.streamlit.GapConfig.decode(QA, QA.uint32());
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.Block.Column) return QA;
      let EA = new $root$1.Block.Column();
      switch (QA.weight != null && (EA.weight = Number(QA.weight)), QA.verticalAlignment) {
        default:
          if (typeof QA.verticalAlignment == "number") {
            EA.verticalAlignment = QA.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          EA.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          EA.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          EA.verticalAlignment = 2;
          break;
      }
      if (QA.showBorder != null && (EA.showBorder = !!QA.showBorder), QA.gapConfig != null) {
        if (typeof QA.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        EA.gapConfig = $root$1.streamlit.GapConfig.fromObject(QA.gapConfig);
      }
      return EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.weight = 0, iA.verticalAlignment = EA.enums === String ? "TOP" : 0, iA.showBorder = !1), QA.weight != null && QA.hasOwnProperty("weight") && (iA.weight = EA.json && !isFinite(QA.weight) ? String(QA.weight) : QA.weight), QA.verticalAlignment != null && QA.hasOwnProperty("verticalAlignment") && (iA.verticalAlignment = EA.enums === String ? $root$1.Block.Column.VerticalAlignment[QA.verticalAlignment] === void 0 ? QA.verticalAlignment : $root$1.Block.Column.VerticalAlignment[QA.verticalAlignment] : QA.verticalAlignment), QA.showBorder != null && QA.hasOwnProperty("showBorder") && (iA.showBorder = QA.showBorder), QA.gapConfig != null && QA.hasOwnProperty("gapConfig") && (iA.gapConfig = $root$1.streamlit.GapConfig.toObject(QA.gapConfig, EA), EA.oneofs && (iA._gapConfig = "gapConfig")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/Block.Column";
    }, AA.VerticalAlignment = (function() {
      const BA = {}, QA = Object.create(BA);
      return QA[BA[0] = "TOP"] = 0, QA[BA[1] = "CENTER"] = 1, QA[BA[2] = "BOTTOM"] = 2, QA;
    })(), AA;
  })(), CA.Expandable = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.label = "", AA.prototype.expanded = null, AA.prototype.icon = "", AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_expanded", { get: $util$1.oneOfGetter(IA = ["expanded"]), set: $util$1.oneOfSetter(IA) }), Object.defineProperty(AA.prototype, "_id", { get: $util$1.oneOfGetter(IA = ["id"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.label != null && Object.hasOwnProperty.call(QA, "label") && EA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(QA.label), QA.expanded != null && Object.hasOwnProperty.call(QA, "expanded") && EA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(QA.expanded), QA.icon != null && Object.hasOwnProperty.call(QA, "icon") && EA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(QA.icon), QA.id != null && Object.hasOwnProperty.call(QA, "id") && EA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(QA.id), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.Block.Expandable();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.label = QA.string();
            break;
          }
          case 2: {
            cA.expanded = QA.bool();
            break;
          }
          case 3: {
            cA.icon = QA.string();
            break;
          }
          case 4: {
            cA.id = QA.string();
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.Block.Expandable) return QA;
      let EA = new $root$1.Block.Expandable();
      return QA.label != null && (EA.label = String(QA.label)), QA.expanded != null && (EA.expanded = !!QA.expanded), QA.icon != null && (EA.icon = String(QA.icon)), QA.id != null && (EA.id = String(QA.id)), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.label = "", iA.icon = ""), QA.label != null && QA.hasOwnProperty("label") && (iA.label = QA.label), QA.expanded != null && QA.hasOwnProperty("expanded") && (iA.expanded = QA.expanded, EA.oneofs && (iA._expanded = "expanded")), QA.icon != null && QA.hasOwnProperty("icon") && (iA.icon = QA.icon), QA.id != null && QA.hasOwnProperty("id") && (iA.id = QA.id, EA.oneofs && (iA._id = "id")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/Block.Expandable";
    }, AA;
  })(), CA.Dialog = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.title = "", AA.prototype.dismissible = !1, AA.prototype.width = 0, AA.prototype.isOpen = null, AA.prototype.id = "", AA.prototype.icon = "";
    let IA;
    return Object.defineProperty(AA.prototype, "_isOpen", { get: $util$1.oneOfGetter(IA = ["isOpen"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.title != null && Object.hasOwnProperty.call(QA, "title") && EA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(QA.title), QA.dismissible != null && Object.hasOwnProperty.call(QA, "dismissible") && EA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(QA.dismissible), QA.width != null && Object.hasOwnProperty.call(QA, "width") && EA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(QA.width), QA.isOpen != null && Object.hasOwnProperty.call(QA, "isOpen") && EA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(QA.isOpen), QA.id != null && Object.hasOwnProperty.call(QA, "id") && EA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(QA.id), QA.icon != null && Object.hasOwnProperty.call(QA, "icon") && EA.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(QA.icon), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.Block.Dialog();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.title = QA.string();
            break;
          }
          case 2: {
            cA.dismissible = QA.bool();
            break;
          }
          case 3: {
            cA.width = QA.int32();
            break;
          }
          case 4: {
            cA.isOpen = QA.bool();
            break;
          }
          case 5: {
            cA.id = QA.string();
            break;
          }
          case 6: {
            cA.icon = QA.string();
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.Block.Dialog) return QA;
      let EA = new $root$1.Block.Dialog();
      switch (QA.title != null && (EA.title = String(QA.title)), QA.dismissible != null && (EA.dismissible = !!QA.dismissible), QA.width) {
        default:
          if (typeof QA.width == "number") {
            EA.width = QA.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          EA.width = 0;
          break;
        case "LARGE":
        case 1:
          EA.width = 1;
          break;
        case "MEDIUM":
        case 2:
          EA.width = 2;
          break;
      }
      return QA.isOpen != null && (EA.isOpen = !!QA.isOpen), QA.id != null && (EA.id = String(QA.id)), QA.icon != null && (EA.icon = String(QA.icon)), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.title = "", iA.dismissible = !1, iA.width = EA.enums === String ? "SMALL" : 0, iA.id = "", iA.icon = ""), QA.title != null && QA.hasOwnProperty("title") && (iA.title = QA.title), QA.dismissible != null && QA.hasOwnProperty("dismissible") && (iA.dismissible = QA.dismissible), QA.width != null && QA.hasOwnProperty("width") && (iA.width = EA.enums === String ? $root$1.Block.Dialog.DialogWidth[QA.width] === void 0 ? QA.width : $root$1.Block.Dialog.DialogWidth[QA.width] : QA.width), QA.isOpen != null && QA.hasOwnProperty("isOpen") && (iA.isOpen = QA.isOpen, EA.oneofs && (iA._isOpen = "isOpen")), QA.id != null && QA.hasOwnProperty("id") && (iA.id = QA.id), QA.icon != null && QA.hasOwnProperty("icon") && (iA.icon = QA.icon), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/Block.Dialog";
    }, AA.DialogWidth = (function() {
      const BA = {}, QA = Object.create(BA);
      return QA[BA[0] = "SMALL"] = 0, QA[BA[1] = "LARGE"] = 1, QA[BA[2] = "MEDIUM"] = 2, QA;
    })(), AA;
  })(), CA.Form = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.formId = "", AA.prototype.clearOnSubmit = !1, AA.prototype.border = !1, AA.prototype.enterToSubmit = !1, AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.formId != null && Object.hasOwnProperty.call(BA, "formId") && QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA.formId), BA.clearOnSubmit != null && Object.hasOwnProperty.call(BA, "clearOnSubmit") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(BA.clearOnSubmit), BA.border != null && Object.hasOwnProperty.call(BA, "border") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(BA.border), BA.enterToSubmit != null && Object.hasOwnProperty.call(BA, "enterToSubmit") && QA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(BA.enterToSubmit), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.Form();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.formId = BA.string();
            break;
          }
          case 2: {
            oA.clearOnSubmit = BA.bool();
            break;
          }
          case 3: {
            oA.border = BA.bool();
            break;
          }
          case 4: {
            oA.enterToSubmit = BA.bool();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.Form) return BA;
      let QA = new $root$1.Block.Form();
      return BA.formId != null && (QA.formId = String(BA.formId)), BA.clearOnSubmit != null && (QA.clearOnSubmit = !!BA.clearOnSubmit), BA.border != null && (QA.border = !!BA.border), BA.enterToSubmit != null && (QA.enterToSubmit = !!BA.enterToSubmit), QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.formId = "", EA.clearOnSubmit = !1, EA.border = !1, EA.enterToSubmit = !1), BA.formId != null && BA.hasOwnProperty("formId") && (EA.formId = BA.formId), BA.clearOnSubmit != null && BA.hasOwnProperty("clearOnSubmit") && (EA.clearOnSubmit = BA.clearOnSubmit), BA.border != null && BA.hasOwnProperty("border") && (EA.border = BA.border), BA.enterToSubmit != null && BA.hasOwnProperty("enterToSubmit") && (EA.enterToSubmit = BA.enterToSubmit), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Form";
    }, AA;
  })(), CA.TabContainer = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.defaultTabIndex = 0, AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_id", { get: $util$1.oneOfGetter(IA = ["id"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.defaultTabIndex != null && Object.hasOwnProperty.call(QA, "defaultTabIndex") && EA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(QA.defaultTabIndex), QA.id != null && Object.hasOwnProperty.call(QA, "id") && EA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(QA.id), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.Block.TabContainer();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.defaultTabIndex = QA.int32();
            break;
          }
          case 2: {
            cA.id = QA.string();
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.Block.TabContainer) return QA;
      let EA = new $root$1.Block.TabContainer();
      return QA.defaultTabIndex != null && (EA.defaultTabIndex = QA.defaultTabIndex | 0), QA.id != null && (EA.id = String(QA.id)), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.defaultTabIndex = 0), QA.defaultTabIndex != null && QA.hasOwnProperty("defaultTabIndex") && (iA.defaultTabIndex = QA.defaultTabIndex), QA.id != null && QA.hasOwnProperty("id") && (iA.id = QA.id, EA.oneofs && (iA._id = "id")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/Block.TabContainer";
    }, AA;
  })(), CA.Tab = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.label = "", AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.label != null && Object.hasOwnProperty.call(BA, "label") && QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA.label), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.Tab();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        cA >>> 3 === 1 ? oA.label = BA.string() : BA.skipType(cA & 7);
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.Tab) return BA;
      let QA = new $root$1.Block.Tab();
      return BA.label != null && (QA.label = String(BA.label)), QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.label = ""), BA.label != null && BA.hasOwnProperty("label") && (EA.label = BA.label), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Tab";
    }, AA;
  })(), CA.Popover = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.label = "", AA.prototype.help = "", AA.prototype.disabled = !1, AA.prototype.icon = "", AA.prototype.type = "", AA.prototype.open = null, AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_open", { get: $util$1.oneOfGetter(IA = ["open"]), set: $util$1.oneOfSetter(IA) }), Object.defineProperty(AA.prototype, "_id", { get: $util$1.oneOfGetter(IA = ["id"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.label != null && Object.hasOwnProperty.call(QA, "label") && EA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(QA.label), QA.help != null && Object.hasOwnProperty.call(QA, "help") && EA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(QA.help), QA.disabled != null && Object.hasOwnProperty.call(QA, "disabled") && EA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(QA.disabled), QA.icon != null && Object.hasOwnProperty.call(QA, "icon") && EA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(QA.icon), QA.type != null && Object.hasOwnProperty.call(QA, "type") && EA.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(QA.type), QA.open != null && Object.hasOwnProperty.call(QA, "open") && EA.uint32(
        /* id 7, wireType 0 =*/
        56
      ).bool(QA.open), QA.id != null && Object.hasOwnProperty.call(QA, "id") && EA.uint32(
        /* id 8, wireType 2 =*/
        66
      ).string(QA.id), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.Block.Popover();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.label = QA.string();
            break;
          }
          case 3: {
            cA.help = QA.string();
            break;
          }
          case 4: {
            cA.disabled = QA.bool();
            break;
          }
          case 5: {
            cA.icon = QA.string();
            break;
          }
          case 6: {
            cA.type = QA.string();
            break;
          }
          case 7: {
            cA.open = QA.bool();
            break;
          }
          case 8: {
            cA.id = QA.string();
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.Block.Popover) return QA;
      let EA = new $root$1.Block.Popover();
      return QA.label != null && (EA.label = String(QA.label)), QA.help != null && (EA.help = String(QA.help)), QA.disabled != null && (EA.disabled = !!QA.disabled), QA.icon != null && (EA.icon = String(QA.icon)), QA.type != null && (EA.type = String(QA.type)), QA.open != null && (EA.open = !!QA.open), QA.id != null && (EA.id = String(QA.id)), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.label = "", iA.help = "", iA.disabled = !1, iA.icon = "", iA.type = ""), QA.label != null && QA.hasOwnProperty("label") && (iA.label = QA.label), QA.help != null && QA.hasOwnProperty("help") && (iA.help = QA.help), QA.disabled != null && QA.hasOwnProperty("disabled") && (iA.disabled = QA.disabled), QA.icon != null && QA.hasOwnProperty("icon") && (iA.icon = QA.icon), QA.type != null && QA.hasOwnProperty("type") && (iA.type = QA.type), QA.open != null && QA.hasOwnProperty("open") && (iA.open = QA.open, EA.oneofs && (iA._open = "open")), QA.id != null && QA.hasOwnProperty("id") && (iA.id = QA.id, EA.oneofs && (iA._id = "id")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/Block.Popover";
    }, AA;
  })(), CA.ChatMessage = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.name = "", AA.prototype.avatar = "", AA.prototype.avatarType = 0, AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.name != null && Object.hasOwnProperty.call(BA, "name") && QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA.name), BA.avatar != null && Object.hasOwnProperty.call(BA, "avatar") && QA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(BA.avatar), BA.avatarType != null && Object.hasOwnProperty.call(BA, "avatarType") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(BA.avatarType), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.Block.ChatMessage();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.name = BA.string();
            break;
          }
          case 2: {
            oA.avatar = BA.string();
            break;
          }
          case 3: {
            oA.avatarType = BA.int32();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.Block.ChatMessage) return BA;
      let QA = new $root$1.Block.ChatMessage();
      switch (BA.name != null && (QA.name = String(BA.name)), BA.avatar != null && (QA.avatar = String(BA.avatar)), BA.avatarType) {
        default:
          if (typeof BA.avatarType == "number") {
            QA.avatarType = BA.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          QA.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          QA.avatarType = 1;
          break;
        case "ICON":
        case 2:
          QA.avatarType = 2;
          break;
      }
      return QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.name = "", EA.avatar = "", EA.avatarType = QA.enums === String ? "IMAGE" : 0), BA.name != null && BA.hasOwnProperty("name") && (EA.name = BA.name), BA.avatar != null && BA.hasOwnProperty("avatar") && (EA.avatar = BA.avatar), BA.avatarType != null && BA.hasOwnProperty("avatarType") && (EA.avatarType = QA.enums === String ? $root$1.Block.ChatMessage.AvatarType[BA.avatarType] === void 0 ? BA.avatarType : $root$1.Block.ChatMessage.AvatarType[BA.avatarType] : BA.avatarType), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.ChatMessage";
    }, AA.AvatarType = (function() {
      const IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "IMAGE"] = 0, BA[IA[1] = "EMOJI"] = 1, BA[IA[2] = "ICON"] = 2, BA;
    })(), AA;
  })(), CA;
})();
$root$1.Button = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.isFormSubmitter = !1, CA.prototype.type = "", CA.prototype.disabled = !1, CA.prototype.icon = "", CA.prototype.shortcut = "", CA.prototype.iconPosition = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.default), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.formId), AA.isFormSubmitter != null && Object.hasOwnProperty.call(AA, "isFormSubmitter") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.isFormSubmitter), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.type), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(AA.disabled), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.icon), AA.shortcut != null && Object.hasOwnProperty.call(AA, "shortcut") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.shortcut), AA.iconPosition != null && Object.hasOwnProperty.call(AA, "iconPosition") && IA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(AA.iconPosition), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Button();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.id = AA.string();
          break;
        }
        case 2: {
          EA.label = AA.string();
          break;
        }
        case 3: {
          EA.default = AA.bool();
          break;
        }
        case 4: {
          EA.help = AA.string();
          break;
        }
        case 5: {
          EA.formId = AA.string();
          break;
        }
        case 6: {
          EA.isFormSubmitter = AA.bool();
          break;
        }
        case 7: {
          EA.type = AA.string();
          break;
        }
        case 8: {
          EA.disabled = AA.bool();
          break;
        }
        case 10: {
          EA.icon = AA.string();
          break;
        }
        case 11: {
          EA.shortcut = AA.string();
          break;
        }
        case 12: {
          EA.iconPosition = AA.int32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Button) return AA;
    let IA = new $root$1.Button();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = !!AA.default), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.isFormSubmitter != null && (IA.isFormSubmitter = !!AA.isFormSubmitter), AA.type != null && (IA.type = String(AA.type)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.icon != null && (IA.icon = String(AA.icon)), AA.shortcut != null && (IA.shortcut = String(AA.shortcut)), AA.iconPosition) {
      default:
        if (typeof AA.iconPosition == "number") {
          IA.iconPosition = AA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        IA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        IA.iconPosition = 1;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.default = !1, BA.help = "", BA.formId = "", BA.isFormSubmitter = !1, BA.type = "", BA.disabled = !1, BA.icon = "", BA.shortcut = "", BA.iconPosition = IA.enums === String ? "LEFT" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.isFormSubmitter != null && AA.hasOwnProperty("isFormSubmitter") && (BA.isFormSubmitter = AA.isFormSubmitter), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.shortcut != null && AA.hasOwnProperty("shortcut") && (BA.shortcut = AA.shortcut), AA.iconPosition != null && AA.hasOwnProperty("iconPosition") && (BA.iconPosition = IA.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[AA.iconPosition] === void 0 ? AA.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[AA.iconPosition] : AA.iconPosition), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Button";
  }, CA;
})();
const ButtonGroup$1 = $root$1.ButtonGroup = (() => {
  function CA(AA) {
    if (this.options = [], this.default = [], this.rawValues = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.options = $util$1.emptyArray, CA.prototype.default = $util$1.emptyArray, CA.prototype.disabled = !1, CA.prototype.clickMode = 0, CA.prototype.formId = "", CA.prototype.setValue = !1, CA.prototype.style = 0, CA.prototype.label = "", CA.prototype.labelVisibility = null, CA.prototype.help = null, CA.prototype.rawValues = $util$1.emptyArray, CA.prototype.queryParamKey = null, CA.prototype.required = !1;
  let gA;
  return Object.defineProperty(CA.prototype, "_help", { get: $util$1.oneOfGetter(gA = ["help"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.options != null && IA.options.length) for (let QA = 0; QA < IA.options.length; ++QA) $root$1.ButtonGroup.Option.encode(IA.options[QA], BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    if (IA.default != null && IA.default.length) {
      BA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let QA = 0; QA < IA.default.length; ++QA) BA.uint32(IA.default[QA]);
      BA.ldelim();
    }
    if (IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(IA.disabled), IA.clickMode != null && Object.hasOwnProperty.call(IA, "clickMode") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(IA.clickMode), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.setValue), IA.style != null && Object.hasOwnProperty.call(IA, "style") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(IA.style), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.label), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.help), IA.rawValues != null && IA.rawValues.length) for (let QA = 0; QA < IA.rawValues.length; ++QA) BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.rawValues[QA]);
    return IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(IA.queryParamKey), IA.required != null && Object.hasOwnProperty.call(IA, "required") && BA.uint32(
      /* id 16, wireType 0 =*/
      128
    ).bool(IA.required), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ButtonGroup();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.options && iA.options.length || (iA.options = []), iA.options.push($root$1.ButtonGroup.Option.decode(IA, IA.uint32()));
          break;
        }
        case 3: {
          if (iA.default && iA.default.length || (iA.default = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.default.push(IA.uint32());
          } else iA.default.push(IA.uint32());
          break;
        }
        case 4: {
          iA.disabled = IA.bool();
          break;
        }
        case 5: {
          iA.clickMode = IA.int32();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 8: {
          iA.setValue = IA.bool();
          break;
        }
        case 10: {
          iA.style = IA.int32();
          break;
        }
        case 11: {
          iA.label = IA.string();
          break;
        }
        case 12: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.help = IA.string();
          break;
        }
        case 14: {
          iA.rawValues && iA.rawValues.length || (iA.rawValues = []), iA.rawValues.push(IA.string());
          break;
        }
        case 15: {
          iA.queryParamKey = IA.string();
          break;
        }
        case 16: {
          iA.required = IA.bool();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ButtonGroup) return IA;
    let BA = new $root$1.ButtonGroup();
    if (IA.id != null && (BA.id = String(IA.id)), IA.options) {
      if (!Array.isArray(IA.options)) throw TypeError(".ButtonGroup.options: array expected");
      BA.options = [];
      for (let QA = 0; QA < IA.options.length; ++QA) {
        if (typeof IA.options[QA] != "object") throw TypeError(".ButtonGroup.options: object expected");
        BA.options[QA] = $root$1.ButtonGroup.Option.fromObject(IA.options[QA]);
      }
    }
    if (IA.default) {
      if (!Array.isArray(IA.default)) throw TypeError(".ButtonGroup.default: array expected");
      BA.default = [];
      for (let QA = 0; QA < IA.default.length; ++QA) BA.default[QA] = IA.default[QA] >>> 0;
    }
    switch (IA.disabled != null && (BA.disabled = !!IA.disabled), IA.clickMode) {
      default:
        if (typeof IA.clickMode == "number") {
          BA.clickMode = IA.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        BA.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        BA.clickMode = 1;
        break;
    }
    switch (IA.formId != null && (BA.formId = String(IA.formId)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.style) {
      default:
        if (typeof IA.style == "number") {
          BA.style = IA.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        BA.style = 0;
        break;
      case "PILLS":
      case 1:
        BA.style = 1;
        break;
    }
    if (IA.label != null && (BA.label = String(IA.label)), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    if (IA.help != null && (BA.help = String(IA.help)), IA.rawValues) {
      if (!Array.isArray(IA.rawValues)) throw TypeError(".ButtonGroup.rawValues: array expected");
      BA.rawValues = [];
      for (let QA = 0; QA < IA.rawValues.length; ++QA) BA.rawValues[QA] = String(IA.rawValues[QA]);
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), IA.required != null && (BA.required = !!IA.required), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.options = [], QA.default = [], QA.rawValues = []), BA.defaults && (QA.id = "", QA.disabled = !1, QA.clickMode = BA.enums === String ? "SINGLE_SELECT" : 0, QA.formId = "", QA.setValue = !1, QA.style = BA.enums === String ? "SEGMENTED_CONTROL" : 0, QA.label = "", QA.labelVisibility = null, QA.required = !1), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.options && IA.options.length) {
      QA.options = [];
      for (let EA = 0; EA < IA.options.length; ++EA) QA.options[EA] = $root$1.ButtonGroup.Option.toObject(IA.options[EA], BA);
    }
    if (IA.default && IA.default.length) {
      QA.default = [];
      for (let EA = 0; EA < IA.default.length; ++EA) QA.default[EA] = IA.default[EA];
    }
    if (IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.clickMode != null && IA.hasOwnProperty("clickMode") && (QA.clickMode = BA.enums === String ? $root$1.ButtonGroup.ClickMode[IA.clickMode] === void 0 ? IA.clickMode : $root$1.ButtonGroup.ClickMode[IA.clickMode] : IA.clickMode), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.style != null && IA.hasOwnProperty("style") && (QA.style = BA.enums === String ? $root$1.ButtonGroup.Style[IA.style] === void 0 ? IA.style : $root$1.ButtonGroup.Style[IA.style] : IA.style), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help, BA.oneofs && (QA._help = "help")), IA.rawValues && IA.rawValues.length) {
      QA.rawValues = [];
      for (let EA = 0; EA < IA.rawValues.length; ++EA) QA.rawValues[EA] = IA.rawValues[EA];
    }
    return IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), IA.required != null && IA.hasOwnProperty("required") && (QA.required = IA.required), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ButtonGroup";
  }, CA.ClickMode = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SINGLE_SELECT"] = 0, IA[AA[1] = "MULTI_SELECT"] = 1, IA;
  })(), CA.Option = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.content = "", AA.prototype.contentIcon = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_contentIcon", { get: $util$1.oneOfGetter(IA = ["contentIcon"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.content != null && Object.hasOwnProperty.call(QA, "content") && EA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(QA.content), QA.contentIcon != null && Object.hasOwnProperty.call(QA, "contentIcon") && EA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(QA.contentIcon), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.ButtonGroup.Option();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        switch (tA >>> 3) {
          case 1: {
            cA.content = QA.string();
            break;
          }
          case 3: {
            cA.contentIcon = QA.string();
            break;
          }
          default:
            QA.skipType(tA & 7);
            break;
        }
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.ButtonGroup.Option) return QA;
      let EA = new $root$1.ButtonGroup.Option();
      return QA.content != null && (EA.content = String(QA.content)), QA.contentIcon != null && (EA.contentIcon = String(QA.contentIcon)), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return EA.defaults && (iA.content = ""), QA.content != null && QA.hasOwnProperty("content") && (iA.content = QA.content), QA.contentIcon != null && QA.hasOwnProperty("contentIcon") && (iA.contentIcon = QA.contentIcon, EA.oneofs && (iA._contentIcon = "contentIcon")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/ButtonGroup.Option";
    }, AA;
  })(), CA.Style = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SEGMENTED_CONTROL"] = 0, IA[AA[1] = "PILLS"] = 1, IA;
  })(), CA;
})();
$root$1.CameraInput = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.label), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.formId), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root$1.LabelVisibility.encode(AA.labelVisibility, IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.CameraInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.id = AA.string();
          break;
        }
        case 2: {
          EA.label = AA.string();
          break;
        }
        case 3: {
          EA.help = AA.string();
          break;
        }
        case 4: {
          EA.formId = AA.string();
          break;
        }
        case 5: {
          EA.disabled = AA.bool();
          break;
        }
        case 6: {
          EA.labelVisibility = $root$1.LabelVisibility.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.CameraInput) return AA;
    let IA = new $root$1.CameraInput();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      IA.labelVisibility = $root$1.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.disabled = !1, BA.labelVisibility = null), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root$1.LabelVisibility.toObject(AA.labelVisibility, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/CameraInput";
  }, CA;
})();
const ChatInput$1 = $root$1.ChatInput = (() => {
  function CA(AA) {
    if (this.fileType = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.placeholder = "", CA.prototype.maxChars = 0, CA.prototype.disabled = !1, CA.prototype.value = "", CA.prototype.setValue = !1, CA.prototype.default = "", CA.prototype.acceptFile = 0, CA.prototype.fileType = $util$1.emptyArray, CA.prototype.maxUploadSizeMb = 0, CA.prototype.acceptAudio = !1, CA.prototype.audioSampleRate = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_audioSampleRate", { get: $util$1.oneOfGetter(gA = ["audioSampleRate"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.placeholder), IA.maxChars != null && Object.hasOwnProperty.call(IA, "maxChars") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(IA.maxChars), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(IA.disabled), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(IA.setValue), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.default), IA.acceptFile != null && Object.hasOwnProperty.call(IA, "acceptFile") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(IA.acceptFile), IA.fileType != null && IA.fileType.length) for (let QA = 0; QA < IA.fileType.length; ++QA) BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.fileType[QA]);
    return IA.maxUploadSizeMb != null && Object.hasOwnProperty.call(IA, "maxUploadSizeMb") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(IA.maxUploadSizeMb), IA.acceptAudio != null && Object.hasOwnProperty.call(IA, "acceptAudio") && BA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(IA.acceptAudio), IA.audioSampleRate != null && Object.hasOwnProperty.call(IA, "audioSampleRate") && BA.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(IA.audioSampleRate), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ChatInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.placeholder = IA.string();
          break;
        }
        case 3: {
          iA.maxChars = IA.uint32();
          break;
        }
        case 4: {
          iA.disabled = IA.bool();
          break;
        }
        case 5: {
          iA.value = IA.string();
          break;
        }
        case 6: {
          iA.setValue = IA.bool();
          break;
        }
        case 7: {
          iA.default = IA.string();
          break;
        }
        case 9: {
          iA.acceptFile = IA.int32();
          break;
        }
        case 10: {
          iA.fileType && iA.fileType.length || (iA.fileType = []), iA.fileType.push(IA.string());
          break;
        }
        case 11: {
          iA.maxUploadSizeMb = IA.int32();
          break;
        }
        case 12: {
          iA.acceptAudio = IA.bool();
          break;
        }
        case 13: {
          iA.audioSampleRate = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ChatInput) return IA;
    let BA = new $root$1.ChatInput();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.maxChars != null && (BA.maxChars = IA.maxChars >>> 0), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.value != null && (BA.value = String(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.default != null && (BA.default = String(IA.default)), IA.acceptFile) {
      default:
        if (typeof IA.acceptFile == "number") {
          BA.acceptFile = IA.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        BA.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        BA.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        BA.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        BA.acceptFile = 3;
        break;
    }
    if (IA.fileType) {
      if (!Array.isArray(IA.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      BA.fileType = [];
      for (let QA = 0; QA < IA.fileType.length; ++QA) BA.fileType[QA] = String(IA.fileType[QA]);
    }
    return IA.maxUploadSizeMb != null && (BA.maxUploadSizeMb = IA.maxUploadSizeMb | 0), IA.acceptAudio != null && (BA.acceptAudio = !!IA.acceptAudio), IA.audioSampleRate != null && (BA.audioSampleRate = IA.audioSampleRate | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.fileType = []), BA.defaults && (QA.id = "", QA.placeholder = "", QA.maxChars = 0, QA.disabled = !1, QA.value = "", QA.setValue = !1, QA.default = "", QA.acceptFile = BA.enums === String ? "NONE" : 0, QA.maxUploadSizeMb = 0, QA.acceptAudio = !1), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.maxChars != null && IA.hasOwnProperty("maxChars") && (QA.maxChars = IA.maxChars), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default), IA.acceptFile != null && IA.hasOwnProperty("acceptFile") && (QA.acceptFile = BA.enums === String ? $root$1.ChatInput.AcceptFile[IA.acceptFile] === void 0 ? IA.acceptFile : $root$1.ChatInput.AcceptFile[IA.acceptFile] : IA.acceptFile), IA.fileType && IA.fileType.length) {
      QA.fileType = [];
      for (let EA = 0; EA < IA.fileType.length; ++EA) QA.fileType[EA] = IA.fileType[EA];
    }
    return IA.maxUploadSizeMb != null && IA.hasOwnProperty("maxUploadSizeMb") && (QA.maxUploadSizeMb = IA.maxUploadSizeMb), IA.acceptAudio != null && IA.hasOwnProperty("acceptAudio") && (QA.acceptAudio = IA.acceptAudio), IA.audioSampleRate != null && IA.hasOwnProperty("audioSampleRate") && (QA.audioSampleRate = IA.audioSampleRate, BA.oneofs && (QA._audioSampleRate = "audioSampleRate")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ChatInput";
  }, CA.AcceptFile = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "NONE"] = 0, IA[AA[1] = "SINGLE"] = 1, IA[AA[2] = "MULTIPLE"] = 2, IA[AA[3] = "DIRECTORY"] = 3, IA;
  })(), CA;
})(), Checkbox$1 = $root$1.Checkbox = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = !1, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.type = 0, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(IA.default), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(IA.type), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Checkbox();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.bool();
          break;
        }
        case 4: {
          iA.help = IA.string();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.value = IA.bool();
          break;
        }
        case 7: {
          iA.setValue = IA.bool();
          break;
        }
        case 8: {
          iA.disabled = IA.bool();
          break;
        }
        case 9: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.type = IA.int32();
          break;
        }
        case 11: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Checkbox) return IA;
    let BA = new $root$1.Checkbox();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = !!IA.default), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = !!IA.value), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    switch (IA.type) {
      default:
        if (typeof IA.type == "number") {
          BA.type = IA.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        BA.type = 0;
        break;
      case "TOGGLE":
      case 1:
        BA.type = 1;
        break;
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.default = !1, QA.help = "", QA.formId = "", QA.value = !1, QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.type = BA.enums === String ? "DEFAULT" : 0), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.Checkbox.StyleType[IA.type] === void 0 ? IA.type : $root$1.Checkbox.StyleType[IA.type] : IA.type), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Checkbox";
  }, CA.StyleType = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "DEFAULT"] = 0, IA[AA[1] = "TOGGLE"] = 1, IA;
  })(), CA;
})();
$root$1.Code = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.codeText = "", CA.prototype.language = "", CA.prototype.showLineNumbers = !1, CA.prototype.wrapLines = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.codeText != null && Object.hasOwnProperty.call(AA, "codeText") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.codeText), AA.language != null && Object.hasOwnProperty.call(AA, "language") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.language), AA.showLineNumbers != null && Object.hasOwnProperty.call(AA, "showLineNumbers") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.showLineNumbers), AA.wrapLines != null && Object.hasOwnProperty.call(AA, "wrapLines") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(AA.wrapLines), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Code();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.codeText = AA.string();
          break;
        }
        case 2: {
          EA.language = AA.string();
          break;
        }
        case 3: {
          EA.showLineNumbers = AA.bool();
          break;
        }
        case 4: {
          EA.wrapLines = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Code) return AA;
    let IA = new $root$1.Code();
    return AA.codeText != null && (IA.codeText = String(AA.codeText)), AA.language != null && (IA.language = String(AA.language)), AA.showLineNumbers != null && (IA.showLineNumbers = !!AA.showLineNumbers), AA.wrapLines != null && (IA.wrapLines = !!AA.wrapLines), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.codeText = "", BA.language = "", BA.showLineNumbers = !1, BA.wrapLines = !1), AA.codeText != null && AA.hasOwnProperty("codeText") && (BA.codeText = AA.codeText), AA.language != null && AA.hasOwnProperty("language") && (BA.language = AA.language), AA.showLineNumbers != null && AA.hasOwnProperty("showLineNumbers") && (BA.showLineNumbers = AA.showLineNumbers), AA.wrapLines != null && AA.hasOwnProperty("wrapLines") && (BA.wrapLines = AA.wrapLines), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Code";
  }, CA;
})();
$root$1.ColorPicker = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = "", CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ColorPicker();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.string();
          break;
        }
        case 4: {
          iA.help = IA.string();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.value = IA.string();
          break;
        }
        case 7: {
          iA.setValue = IA.bool();
          break;
        }
        case 8: {
          iA.disabled = IA.bool();
          break;
        }
        case 9: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ColorPicker) return IA;
    let BA = new $root$1.ColorPicker();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = String(IA.default)), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = String(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.default = "", QA.help = "", QA.formId = "", QA.value = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ColorPicker";
  }, CA;
})();
const Dataframe = $root$1.Dataframe = (() => {
  function CA(AA) {
    if (this.columnOrder = [], this.selectionMode = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.arrowData = null, CA.prototype.id = "", CA.prototype.columns = "", CA.prototype.editingMode = 0, CA.prototype.disabled = !1, CA.prototype.formId = "", CA.prototype.columnOrder = $util$1.emptyArray, CA.prototype.selectionMode = $util$1.emptyArray, CA.prototype.rowHeight = null, CA.prototype.placeholder = null, CA.prototype.selectionState = null, CA.prototype.selectionDefault = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_rowHeight", { get: $util$1.oneOfGetter(gA = ["rowHeight"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_placeholder", { get: $util$1.oneOfGetter(gA = ["placeholder"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_selectionState", { get: $util$1.oneOfGetter(gA = ["selectionState"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_selectionDefault", { get: $util$1.oneOfGetter(gA = ["selectionDefault"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.arrowData != null && Object.hasOwnProperty.call(IA, "arrowData") && $root$1.ArrowData.encode(IA.arrowData, BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.id), IA.columns != null && Object.hasOwnProperty.call(IA, "columns") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.columns), IA.editingMode != null && Object.hasOwnProperty.call(IA, "editingMode") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(IA.editingMode), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(IA.disabled), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.columnOrder != null && IA.columnOrder.length) for (let QA = 0; QA < IA.columnOrder.length; ++QA) BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.columnOrder[QA]);
    if (IA.selectionMode != null && IA.selectionMode.length) {
      BA.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let QA = 0; QA < IA.selectionMode.length; ++QA) BA.int32(IA.selectionMode[QA]);
      BA.ldelim();
    }
    return IA.rowHeight != null && Object.hasOwnProperty.call(IA, "rowHeight") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).uint32(IA.rowHeight), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.placeholder), IA.selectionState != null && Object.hasOwnProperty.call(IA, "selectionState") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.selectionState), IA.selectionDefault != null && Object.hasOwnProperty.call(IA, "selectionDefault") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.selectionDefault), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Dataframe();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.arrowData = $root$1.ArrowData.decode(IA, IA.uint32());
          break;
        }
        case 2: {
          iA.id = IA.string();
          break;
        }
        case 3: {
          iA.columns = IA.string();
          break;
        }
        case 4: {
          iA.editingMode = IA.int32();
          break;
        }
        case 5: {
          iA.disabled = IA.bool();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 7: {
          iA.columnOrder && iA.columnOrder.length || (iA.columnOrder = []), iA.columnOrder.push(IA.string());
          break;
        }
        case 8: {
          if (iA.selectionMode && iA.selectionMode.length || (iA.selectionMode = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.selectionMode.push(IA.int32());
          } else iA.selectionMode.push(IA.int32());
          break;
        }
        case 9: {
          iA.rowHeight = IA.uint32();
          break;
        }
        case 10: {
          iA.placeholder = IA.string();
          break;
        }
        case 11: {
          iA.selectionState = IA.string();
          break;
        }
        case 12: {
          iA.selectionDefault = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Dataframe) return IA;
    let BA = new $root$1.Dataframe();
    if (IA.arrowData != null) {
      if (typeof IA.arrowData != "object") throw TypeError(".Dataframe.arrowData: object expected");
      BA.arrowData = $root$1.ArrowData.fromObject(IA.arrowData);
    }
    switch (IA.id != null && (BA.id = String(IA.id)), IA.columns != null && (BA.columns = String(IA.columns)), IA.editingMode) {
      default:
        if (typeof IA.editingMode == "number") {
          BA.editingMode = IA.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        BA.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        BA.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        BA.editingMode = 2;
        break;
      case "ADD_ONLY":
      case 3:
        BA.editingMode = 3;
        break;
      case "DELETE_ONLY":
      case 4:
        BA.editingMode = 4;
        break;
    }
    if (IA.disabled != null && (BA.disabled = !!IA.disabled), IA.formId != null && (BA.formId = String(IA.formId)), IA.columnOrder) {
      if (!Array.isArray(IA.columnOrder)) throw TypeError(".Dataframe.columnOrder: array expected");
      BA.columnOrder = [];
      for (let QA = 0; QA < IA.columnOrder.length; ++QA) BA.columnOrder[QA] = String(IA.columnOrder[QA]);
    }
    if (IA.selectionMode) {
      if (!Array.isArray(IA.selectionMode)) throw TypeError(".Dataframe.selectionMode: array expected");
      BA.selectionMode = [];
      for (let QA = 0; QA < IA.selectionMode.length; ++QA) switch (IA.selectionMode[QA]) {
        default:
          if (typeof IA.selectionMode[QA] == "number") {
            BA.selectionMode[QA] = IA.selectionMode[QA];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          BA.selectionMode[QA] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          BA.selectionMode[QA] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          BA.selectionMode[QA] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          BA.selectionMode[QA] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          BA.selectionMode[QA] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          BA.selectionMode[QA] = 5;
          break;
        case "SINGLE_ROW_REQUIRED":
        case 6:
          BA.selectionMode[QA] = 6;
          break;
      }
    }
    return IA.rowHeight != null && (BA.rowHeight = IA.rowHeight >>> 0), IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.selectionState != null && (BA.selectionState = String(IA.selectionState)), IA.selectionDefault != null && (BA.selectionDefault = String(IA.selectionDefault)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.columnOrder = [], QA.selectionMode = []), BA.defaults && (QA.arrowData = null, QA.id = "", QA.columns = "", QA.editingMode = BA.enums === String ? "READ_ONLY" : 0, QA.disabled = !1, QA.formId = ""), IA.arrowData != null && IA.hasOwnProperty("arrowData") && (QA.arrowData = $root$1.ArrowData.toObject(IA.arrowData, BA)), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.columns != null && IA.hasOwnProperty("columns") && (QA.columns = IA.columns), IA.editingMode != null && IA.hasOwnProperty("editingMode") && (QA.editingMode = BA.enums === String ? $root$1.Dataframe.EditingMode[IA.editingMode] === void 0 ? IA.editingMode : $root$1.Dataframe.EditingMode[IA.editingMode] : IA.editingMode), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.columnOrder && IA.columnOrder.length) {
      QA.columnOrder = [];
      for (let EA = 0; EA < IA.columnOrder.length; ++EA) QA.columnOrder[EA] = IA.columnOrder[EA];
    }
    if (IA.selectionMode && IA.selectionMode.length) {
      QA.selectionMode = [];
      for (let EA = 0; EA < IA.selectionMode.length; ++EA) QA.selectionMode[EA] = BA.enums === String ? $root$1.Dataframe.SelectionMode[IA.selectionMode[EA]] === void 0 ? IA.selectionMode[EA] : $root$1.Dataframe.SelectionMode[IA.selectionMode[EA]] : IA.selectionMode[EA];
    }
    return IA.rowHeight != null && IA.hasOwnProperty("rowHeight") && (QA.rowHeight = IA.rowHeight, BA.oneofs && (QA._rowHeight = "rowHeight")), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder, BA.oneofs && (QA._placeholder = "placeholder")), IA.selectionState != null && IA.hasOwnProperty("selectionState") && (QA.selectionState = IA.selectionState, BA.oneofs && (QA._selectionState = "selectionState")), IA.selectionDefault != null && IA.hasOwnProperty("selectionDefault") && (QA.selectionDefault = IA.selectionDefault, BA.oneofs && (QA._selectionDefault = "selectionDefault")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Dataframe";
  }, CA.EditingMode = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "READ_ONLY"] = 0, IA[AA[1] = "FIXED"] = 1, IA[AA[2] = "DYNAMIC"] = 2, IA[AA[3] = "ADD_ONLY"] = 3, IA[AA[4] = "DELETE_ONLY"] = 4, IA;
  })(), CA.SelectionMode = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SINGLE_ROW"] = 0, IA[AA[1] = "MULTI_ROW"] = 1, IA[AA[2] = "SINGLE_COLUMN"] = 2, IA[AA[3] = "MULTI_COLUMN"] = 3, IA[AA[4] = "SINGLE_CELL"] = 4, IA[AA[5] = "MULTI_CELL"] = 5, IA[AA[6] = "SINGLE_ROW_REQUIRED"] = 6, IA;
  })(), CA;
})();
$root$1.DateInput = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util$1.emptyArray, CA.prototype.min = "", CA.prototype.max = "", CA.prototype.isRange = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = $util$1.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.format = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && IA.default.length) for (let QA = 0; QA < IA.default.length; ++QA) BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default[QA]);
    if (IA.min != null && Object.hasOwnProperty.call(IA, "min") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.min), IA.max != null && Object.hasOwnProperty.call(IA, "max") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.max), IA.isRange != null && Object.hasOwnProperty.call(IA, "isRange") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(IA.isRange), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.formId), IA.value != null && IA.value.length) for (let QA = 0; QA < IA.value.length; ++QA) BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(IA.value[QA]);
    return IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), IA.format != null && Object.hasOwnProperty.call(IA, "format") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.format), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.DateInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default && iA.default.length || (iA.default = []), iA.default.push(IA.string());
          break;
        }
        case 4: {
          iA.min = IA.string();
          break;
        }
        case 5: {
          iA.max = IA.string();
          break;
        }
        case 6: {
          iA.isRange = IA.bool();
          break;
        }
        case 7: {
          iA.help = IA.string();
          break;
        }
        case 8: {
          iA.formId = IA.string();
          break;
        }
        case 9: {
          iA.value && iA.value.length || (iA.value = []), iA.value.push(IA.string());
          break;
        }
        case 10: {
          iA.setValue = IA.bool();
          break;
        }
        case 11: {
          iA.disabled = IA.bool();
          break;
        }
        case 12: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.format = IA.string();
          break;
        }
        case 14: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.DateInput) return IA;
    let BA = new $root$1.DateInput();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default) {
      if (!Array.isArray(IA.default)) throw TypeError(".DateInput.default: array expected");
      BA.default = [];
      for (let QA = 0; QA < IA.default.length; ++QA) BA.default[QA] = String(IA.default[QA]);
    }
    if (IA.min != null && (BA.min = String(IA.min)), IA.max != null && (BA.max = String(IA.max)), IA.isRange != null && (BA.isRange = !!IA.isRange), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value) {
      if (!Array.isArray(IA.value)) throw TypeError(".DateInput.value: array expected");
      BA.value = [];
      for (let QA = 0; QA < IA.value.length; ++QA) BA.value[QA] = String(IA.value[QA]);
    }
    if (IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.format != null && (BA.format = String(IA.format)), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.default = [], QA.value = []), BA.defaults && (QA.id = "", QA.label = "", QA.min = "", QA.max = "", QA.isRange = !1, QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.format = ""), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default && IA.default.length) {
      QA.default = [];
      for (let EA = 0; EA < IA.default.length; ++EA) QA.default[EA] = IA.default[EA];
    }
    if (IA.min != null && IA.hasOwnProperty("min") && (QA.min = IA.min), IA.max != null && IA.hasOwnProperty("max") && (QA.max = IA.max), IA.isRange != null && IA.hasOwnProperty("isRange") && (QA.isRange = IA.isRange), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value && IA.value.length) {
      QA.value = [];
      for (let EA = 0; EA < IA.value.length; ++EA) QA.value[EA] = IA.value[EA];
    }
    return IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.format != null && IA.hasOwnProperty("format") && (QA.format = IA.format), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/DateInput";
  }, CA;
})();
$root$1.DateTimeInput = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util$1.emptyArray, CA.prototype.min = "", CA.prototype.max = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = $util$1.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.format = "", CA.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.isRange = !1, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && IA.default.length) for (let QA = 0; QA < IA.default.length; ++QA) BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default[QA]);
    if (IA.min != null && Object.hasOwnProperty.call(IA, "min") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.min), IA.max != null && Object.hasOwnProperty.call(IA, "max") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.max), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.formId), IA.value != null && IA.value.length) for (let QA = 0; QA < IA.value.length; ++QA) BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.value[QA]);
    return IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.format != null && Object.hasOwnProperty.call(IA, "format") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.format), IA.step != null && Object.hasOwnProperty.call(IA, "step") && BA.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int64(IA.step), IA.isRange != null && Object.hasOwnProperty.call(IA, "isRange") && BA.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(IA.isRange), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.DateTimeInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default && iA.default.length || (iA.default = []), iA.default.push(IA.string());
          break;
        }
        case 4: {
          iA.min = IA.string();
          break;
        }
        case 5: {
          iA.max = IA.string();
          break;
        }
        case 6: {
          iA.help = IA.string();
          break;
        }
        case 7: {
          iA.formId = IA.string();
          break;
        }
        case 8: {
          iA.value && iA.value.length || (iA.value = []), iA.value.push(IA.string());
          break;
        }
        case 9: {
          iA.setValue = IA.bool();
          break;
        }
        case 10: {
          iA.disabled = IA.bool();
          break;
        }
        case 11: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.format = IA.string();
          break;
        }
        case 13: {
          iA.step = IA.int64();
          break;
        }
        case 14: {
          iA.isRange = IA.bool();
          break;
        }
        case 15: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.DateTimeInput) return IA;
    let BA = new $root$1.DateTimeInput();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default) {
      if (!Array.isArray(IA.default)) throw TypeError(".DateTimeInput.default: array expected");
      BA.default = [];
      for (let QA = 0; QA < IA.default.length; ++QA) BA.default[QA] = String(IA.default[QA]);
    }
    if (IA.min != null && (BA.min = String(IA.min)), IA.max != null && (BA.max = String(IA.max)), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value) {
      if (!Array.isArray(IA.value)) throw TypeError(".DateTimeInput.value: array expected");
      BA.value = [];
      for (let QA = 0; QA < IA.value.length; ++QA) BA.value[QA] = String(IA.value[QA]);
    }
    if (IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.format != null && (BA.format = String(IA.format)), IA.step != null && ($util$1.Long ? (BA.step = $util$1.Long.fromValue(IA.step)).unsigned = !1 : typeof IA.step == "string" ? BA.step = parseInt(IA.step, 10) : typeof IA.step == "number" ? BA.step = IA.step : typeof IA.step == "object" && (BA.step = new $util$1.LongBits(IA.step.low >>> 0, IA.step.high >>> 0).toNumber())), IA.isRange != null && (BA.isRange = !!IA.isRange), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.default = [], QA.value = []), BA.defaults) {
      if (QA.id = "", QA.label = "", QA.min = "", QA.max = "", QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.format = "", $util$1.Long) {
        let EA = new $util$1.Long(0, 0, !1);
        QA.step = BA.longs === String ? EA.toString() : BA.longs === Number ? EA.toNumber() : EA;
      } else QA.step = BA.longs === String ? "0" : 0;
      QA.isRange = !1;
    }
    if (IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default && IA.default.length) {
      QA.default = [];
      for (let EA = 0; EA < IA.default.length; ++EA) QA.default[EA] = IA.default[EA];
    }
    if (IA.min != null && IA.hasOwnProperty("min") && (QA.min = IA.min), IA.max != null && IA.hasOwnProperty("max") && (QA.max = IA.max), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value && IA.value.length) {
      QA.value = [];
      for (let EA = 0; EA < IA.value.length; ++EA) QA.value[EA] = IA.value[EA];
    }
    return IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.format != null && IA.hasOwnProperty("format") && (QA.format = IA.format), IA.step != null && IA.hasOwnProperty("step") && (typeof IA.step == "number" ? QA.step = BA.longs === String ? String(IA.step) : IA.step : QA.step = BA.longs === String ? $util$1.Long.prototype.toString.call(IA.step) : BA.longs === Number ? new $util$1.LongBits(IA.step.low >>> 0, IA.step.high >>> 0).toNumber() : IA.step), IA.isRange != null && IA.hasOwnProperty("isRange") && (QA.isRange = IA.isRange), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/DateTimeInput";
  }, CA;
})();
const DeckGlJsonChart$1 = $root$1.DeckGlJsonChart = (() => {
  function CA(gA) {
    if (this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.json = "", CA.prototype.tooltip = "", CA.prototype.id = "", CA.prototype.mapboxToken = "", CA.prototype.selectionMode = $util$1.emptyArray, CA.prototype.formId = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.json != null && Object.hasOwnProperty.call(AA, "json") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.json), AA.tooltip != null && Object.hasOwnProperty.call(AA, "tooltip") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.tooltip), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.id), AA.mapboxToken != null && Object.hasOwnProperty.call(AA, "mapboxToken") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.mapboxToken), AA.selectionMode != null && AA.selectionMode.length) {
      IA.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) IA.int32(AA.selectionMode[BA]);
      IA.ldelim();
    }
    return AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.formId), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.DeckGlJsonChart();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.json = AA.string();
          break;
        }
        case 2: {
          EA.tooltip = AA.string();
          break;
        }
        case 5: {
          EA.id = AA.string();
          break;
        }
        case 6: {
          EA.mapboxToken = AA.string();
          break;
        }
        case 9: {
          if (EA.selectionMode && EA.selectionMode.length || (EA.selectionMode = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.selectionMode.push(AA.int32());
          } else EA.selectionMode.push(AA.int32());
          break;
        }
        case 10: {
          EA.formId = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.DeckGlJsonChart) return AA;
    let IA = new $root$1.DeckGlJsonChart();
    if (AA.json != null && (IA.json = String(AA.json)), AA.tooltip != null && (IA.tooltip = String(AA.tooltip)), AA.id != null && (IA.id = String(AA.id)), AA.mapboxToken != null && (IA.mapboxToken = String(AA.mapboxToken)), AA.selectionMode) {
      if (!Array.isArray(AA.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      IA.selectionMode = [];
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) switch (AA.selectionMode[BA]) {
        default:
          if (typeof AA.selectionMode[BA] == "number") {
            IA.selectionMode[BA] = AA.selectionMode[BA];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          IA.selectionMode[BA] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          IA.selectionMode[BA] = 1;
          break;
      }
    }
    return AA.formId != null && (IA.formId = String(AA.formId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.selectionMode = []), IA.defaults && (BA.json = "", BA.tooltip = "", BA.id = "", BA.mapboxToken = "", BA.formId = ""), AA.json != null && AA.hasOwnProperty("json") && (BA.json = AA.json), AA.tooltip != null && AA.hasOwnProperty("tooltip") && (BA.tooltip = AA.tooltip), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.mapboxToken != null && AA.hasOwnProperty("mapboxToken") && (BA.mapboxToken = AA.mapboxToken), AA.selectionMode && AA.selectionMode.length) {
      BA.selectionMode = [];
      for (let QA = 0; QA < AA.selectionMode.length; ++QA) BA.selectionMode[QA] = IA.enums === String ? $root$1.DeckGlJsonChart.SelectionMode[AA.selectionMode[QA]] === void 0 ? AA.selectionMode[QA] : $root$1.DeckGlJsonChart.SelectionMode[AA.selectionMode[QA]] : AA.selectionMode[QA];
    }
    return AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DeckGlJsonChart";
  }, CA.SelectionMode = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "SINGLE_OBJECT"] = 0, AA[gA[1] = "MULTI_OBJECT"] = 1, AA;
  })(), CA;
})();
$root$1.Delta = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.newElement = null, CA.prototype.addBlock = null, CA.prototype.newTransient = null, CA.prototype.arrowAddRows = null, CA.prototype.fragmentId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["newElement", "addBlock", "newTransient", "arrowAddRows"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.newElement != null && Object.hasOwnProperty.call(IA, "newElement") && $root$1.Element.encode(IA.newElement, BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), IA.addBlock != null && Object.hasOwnProperty.call(IA, "addBlock") && $root$1.Block.encode(IA.addBlock, BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA.arrowAddRows != null && Object.hasOwnProperty.call(IA, "arrowAddRows") && $root$1.ArrowNamedDataSet.encode(IA.arrowAddRows, BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), IA.fragmentId != null && Object.hasOwnProperty.call(IA, "fragmentId") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.fragmentId), IA.newTransient != null && Object.hasOwnProperty.call(IA, "newTransient") && $root$1.Transient.encode(IA.newTransient, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Delta();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 3: {
          iA.newElement = $root$1.Element.decode(IA, IA.uint32());
          break;
        }
        case 6: {
          iA.addBlock = $root$1.Block.decode(IA, IA.uint32());
          break;
        }
        case 9: {
          iA.newTransient = $root$1.Transient.decode(IA, IA.uint32());
          break;
        }
        case 7: {
          iA.arrowAddRows = $root$1.ArrowNamedDataSet.decode(IA, IA.uint32());
          break;
        }
        case 8: {
          iA.fragmentId = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Delta) return IA;
    let BA = new $root$1.Delta();
    if (IA.newElement != null) {
      if (typeof IA.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      BA.newElement = $root$1.Element.fromObject(IA.newElement);
    }
    if (IA.addBlock != null) {
      if (typeof IA.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      BA.addBlock = $root$1.Block.fromObject(IA.addBlock);
    }
    if (IA.newTransient != null) {
      if (typeof IA.newTransient != "object") throw TypeError(".Delta.newTransient: object expected");
      BA.newTransient = $root$1.Transient.fromObject(IA.newTransient);
    }
    if (IA.arrowAddRows != null) {
      if (typeof IA.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      BA.arrowAddRows = $root$1.ArrowNamedDataSet.fromObject(IA.arrowAddRows);
    }
    return IA.fragmentId != null && (BA.fragmentId = String(IA.fragmentId)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.fragmentId = ""), IA.newElement != null && IA.hasOwnProperty("newElement") && (QA.newElement = $root$1.Element.toObject(IA.newElement, BA), BA.oneofs && (QA.type = "newElement")), IA.addBlock != null && IA.hasOwnProperty("addBlock") && (QA.addBlock = $root$1.Block.toObject(IA.addBlock, BA), BA.oneofs && (QA.type = "addBlock")), IA.arrowAddRows != null && IA.hasOwnProperty("arrowAddRows") && (QA.arrowAddRows = $root$1.ArrowNamedDataSet.toObject(IA.arrowAddRows, BA), BA.oneofs && (QA.type = "arrowAddRows")), IA.fragmentId != null && IA.hasOwnProperty("fragmentId") && (QA.fragmentId = IA.fragmentId), IA.newTransient != null && IA.hasOwnProperty("newTransient") && (QA.newTransient = $root$1.Transient.toObject(IA.newTransient, BA), BA.oneofs && (QA.type = "newTransient")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Delta";
  }, CA;
})();
const Element$1 = $root$1.Element = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.heightConfig = null, CA.prototype.widthConfig = null, CA.prototype.textAlignmentConfig = null, CA.prototype.alert = null, CA.prototype.dataframe = null, CA.prototype.table = null, CA.prototype.vegaLiteChart = null, CA.prototype.audio = null, CA.prototype.audioInput = null, CA.prototype.balloons = null, CA.prototype.bidiComponent = null, CA.prototype.button = null, CA.prototype.buttonGroup = null, CA.prototype.downloadButton = null, CA.prototype.cameraInput = null, CA.prototype.chatInput = null, CA.prototype.checkbox = null, CA.prototype.colorPicker = null, CA.prototype.componentInstance = null, CA.prototype.dateInput = null, CA.prototype.deckGlJsonChart = null, CA.prototype.helpInfo = null, CA.prototype.empty = null, CA.prototype.exception = null, CA.prototype.favicon = null, CA.prototype.feedback = null, CA.prototype.fileUploader = null, CA.prototype.graphvizChart = null, CA.prototype.html = null, CA.prototype.iframe = null, CA.prototype.imgs = null, CA.prototype.json = null, CA.prototype.linkButton = null, CA.prototype.markdown = null, CA.prototype.metric = null, CA.prototype.multiselect = null, CA.prototype.numberInput = null, CA.prototype.pageLink = null, CA.prototype.plotlyChart = null, CA.prototype.progress = null, CA.prototype.radio = null, CA.prototype.selectbox = null, CA.prototype.skeleton = null, CA.prototype.slider = null, CA.prototype.snow = null, CA.prototype.space = null, CA.prototype.spinner = null, CA.prototype.text = null, CA.prototype.textArea = null, CA.prototype.textInput = null, CA.prototype.timeInput = null, CA.prototype.dateTimeInput = null, CA.prototype.toast = null, CA.prototype.video = null, CA.prototype.heading = null, CA.prototype.code = null, CA.prototype.menuButton = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_heightConfig", { get: $util$1.oneOfGetter(gA = ["heightConfig"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_widthConfig", { get: $util$1.oneOfGetter(gA = ["widthConfig"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_textAlignmentConfig", { get: $util$1.oneOfGetter(gA = ["textAlignmentConfig"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["alert", "dataframe", "table", "vegaLiteChart", "audio", "audioInput", "balloons", "bidiComponent", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dateInput", "deckGlJsonChart", "helpInfo", "empty", "exception", "favicon", "feedback", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "space", "spinner", "text", "textArea", "textInput", "timeInput", "dateTimeInput", "toast", "video", "heading", "code", "menuButton"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.text != null && Object.hasOwnProperty.call(IA, "text") && $root$1.Text.encode(IA.text, BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), IA.empty != null && Object.hasOwnProperty.call(IA, "empty") && $root$1.Empty.encode(IA.empty, BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA.progress != null && Object.hasOwnProperty.call(IA, "progress") && $root$1.Progress.encode(IA.progress, BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA.imgs != null && Object.hasOwnProperty.call(IA, "imgs") && $root$1.ImageList.encode(IA.imgs, BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA.helpInfo != null && Object.hasOwnProperty.call(IA, "helpInfo") && $root$1.Help.encode(IA.helpInfo, BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), IA.exception != null && Object.hasOwnProperty.call(IA, "exception") && $root$1.Exception.encode(IA.exception, BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), IA.balloons != null && Object.hasOwnProperty.call(IA, "balloons") && $root$1.Balloons.encode(IA.balloons, BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), IA.audio != null && Object.hasOwnProperty.call(IA, "audio") && $root$1.Audio.encode(IA.audio, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), IA.video != null && Object.hasOwnProperty.call(IA, "video") && $root$1.Video.encode(IA.video, BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), IA.plotlyChart != null && Object.hasOwnProperty.call(IA, "plotlyChart") && $root$1.PlotlyChart.encode(IA.plotlyChart, BA.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), IA.graphvizChart != null && Object.hasOwnProperty.call(IA, "graphvizChart") && $root$1.GraphVizChart.encode(IA.graphvizChart, BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), IA.button != null && Object.hasOwnProperty.call(IA, "button") && $root$1.Button.encode(IA.button, BA.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), IA.checkbox != null && Object.hasOwnProperty.call(IA, "checkbox") && $root$1.Checkbox.encode(IA.checkbox, BA.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), IA.slider != null && Object.hasOwnProperty.call(IA, "slider") && $root$1.Slider.encode(IA.slider, BA.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), IA.textArea != null && Object.hasOwnProperty.call(IA, "textArea") && $root$1.TextArea.encode(IA.textArea, BA.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), IA.radio != null && Object.hasOwnProperty.call(IA, "radio") && $root$1.Radio.encode(IA.radio, BA.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), IA.textInput != null && Object.hasOwnProperty.call(IA, "textInput") && $root$1.TextInput.encode(IA.textInput, BA.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), IA.selectbox != null && Object.hasOwnProperty.call(IA, "selectbox") && $root$1.Selectbox.encode(IA.selectbox, BA.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), IA.timeInput != null && Object.hasOwnProperty.call(IA, "timeInput") && $root$1.TimeInput.encode(IA.timeInput, BA.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), IA.dateInput != null && Object.hasOwnProperty.call(IA, "dateInput") && $root$1.DateInput.encode(IA.dateInput, BA.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), IA.multiselect != null && Object.hasOwnProperty.call(IA, "multiselect") && $root$1.MultiSelect.encode(IA.multiselect, BA.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), IA.markdown != null && Object.hasOwnProperty.call(IA, "markdown") && $root$1.Markdown.encode(IA.markdown, BA.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), IA.alert != null && Object.hasOwnProperty.call(IA, "alert") && $root$1.Alert.encode(IA.alert, BA.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), IA.json != null && Object.hasOwnProperty.call(IA, "json") && $root$1.Json.encode(IA.json, BA.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), IA.numberInput != null && Object.hasOwnProperty.call(IA, "numberInput") && $root$1.NumberInput.encode(IA.numberInput, BA.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), IA.fileUploader != null && Object.hasOwnProperty.call(IA, "fileUploader") && $root$1.FileUploader.encode(IA.fileUploader, BA.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), IA.deckGlJsonChart != null && Object.hasOwnProperty.call(IA, "deckGlJsonChart") && $root$1.DeckGlJsonChart.encode(IA.deckGlJsonChart, BA.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), IA.colorPicker != null && Object.hasOwnProperty.call(IA, "colorPicker") && $root$1.ColorPicker.encode(IA.colorPicker, BA.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), IA.favicon != null && Object.hasOwnProperty.call(IA, "favicon") && $root$1.Favicon.encode(IA.favicon, BA.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), IA.componentInstance != null && Object.hasOwnProperty.call(IA, "componentInstance") && $root$1.ComponentInstance.encode(IA.componentInstance, BA.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), IA.iframe != null && Object.hasOwnProperty.call(IA, "iframe") && $root$1.IFrame.encode(IA.iframe, BA.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), IA.table != null && Object.hasOwnProperty.call(IA, "table") && $root$1.Table.encode(IA.table, BA.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), IA.dataframe != null && Object.hasOwnProperty.call(IA, "dataframe") && $root$1.Dataframe.encode(IA.dataframe, BA.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), IA.vegaLiteChart != null && Object.hasOwnProperty.call(IA, "vegaLiteChart") && $root$1.VegaLiteChart.encode(IA.vegaLiteChart, BA.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), IA.metric != null && Object.hasOwnProperty.call(IA, "metric") && $root$1.Metric.encode(IA.metric, BA.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), IA.downloadButton != null && Object.hasOwnProperty.call(IA, "downloadButton") && $root$1.DownloadButton.encode(IA.downloadButton, BA.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), IA.spinner != null && Object.hasOwnProperty.call(IA, "spinner") && $root$1.Spinner.encode(IA.spinner, BA.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), IA.cameraInput != null && Object.hasOwnProperty.call(IA, "cameraInput") && $root$1.CameraInput.encode(IA.cameraInput, BA.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), IA.snow != null && Object.hasOwnProperty.call(IA, "snow") && $root$1.Snow.encode(IA.snow, BA.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), IA.heading != null && Object.hasOwnProperty.call(IA, "heading") && $root$1.Heading.encode(IA.heading, BA.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), IA.code != null && Object.hasOwnProperty.call(IA, "code") && $root$1.Code.encode(IA.code, BA.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), IA.chatInput != null && Object.hasOwnProperty.call(IA, "chatInput") && $root$1.ChatInput.encode(IA.chatInput, BA.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), IA.toast != null && Object.hasOwnProperty.call(IA, "toast") && $root$1.Toast.encode(IA.toast, BA.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), IA.linkButton != null && Object.hasOwnProperty.call(IA, "linkButton") && $root$1.LinkButton.encode(IA.linkButton, BA.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), IA.skeleton != null && Object.hasOwnProperty.call(IA, "skeleton") && $root$1.Skeleton.encode(IA.skeleton, BA.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), IA.pageLink != null && Object.hasOwnProperty.call(IA, "pageLink") && $root$1.PageLink.encode(IA.pageLink, BA.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), IA.html != null && Object.hasOwnProperty.call(IA, "html") && $root$1.Html.encode(IA.html, BA.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), IA.buttonGroup != null && Object.hasOwnProperty.call(IA, "buttonGroup") && $root$1.ButtonGroup.encode(IA.buttonGroup, BA.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), IA.audioInput != null && Object.hasOwnProperty.call(IA, "audioInput") && $root$1.AudioInput.encode(IA.audioInput, BA.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), IA.heightConfig != null && Object.hasOwnProperty.call(IA, "heightConfig") && $root$1.streamlit.HeightConfig.encode(IA.heightConfig, BA.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), IA.widthConfig != null && Object.hasOwnProperty.call(IA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(IA.widthConfig, BA.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), IA.bidiComponent != null && Object.hasOwnProperty.call(IA, "bidiComponent") && $root$1.BidiComponent.encode(IA.bidiComponent, BA.uint32(
      /* id 59, wireType 2 =*/
      474
    ).fork()).ldelim(), IA.space != null && Object.hasOwnProperty.call(IA, "space") && $root$1.Space.encode(IA.space, BA.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), IA.textAlignmentConfig != null && Object.hasOwnProperty.call(IA, "textAlignmentConfig") && $root$1.streamlit.TextAlignmentConfig.encode(IA.textAlignmentConfig, BA.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), IA.dateTimeInput != null && Object.hasOwnProperty.call(IA, "dateTimeInput") && $root$1.DateTimeInput.encode(IA.dateTimeInput, BA.uint32(
      /* id 62, wireType 2 =*/
      498
    ).fork()).ldelim(), IA.feedback != null && Object.hasOwnProperty.call(IA, "feedback") && $root$1.Feedback.encode(IA.feedback, BA.uint32(
      /* id 63, wireType 2 =*/
      506
    ).fork()).ldelim(), IA.menuButton != null && Object.hasOwnProperty.call(IA, "menuButton") && $root$1.MenuButton.encode(IA.menuButton, BA.uint32(
      /* id 64, wireType 2 =*/
      514
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Element();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 57: {
          iA.heightConfig = $root$1.streamlit.HeightConfig.decode(IA, IA.uint32());
          break;
        }
        case 58: {
          iA.widthConfig = $root$1.streamlit.WidthConfig.decode(IA, IA.uint32());
          break;
        }
        case 61: {
          iA.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.decode(IA, IA.uint32());
          break;
        }
        case 30: {
          iA.alert = $root$1.Alert.decode(IA, IA.uint32());
          break;
        }
        case 40: {
          iA.dataframe = $root$1.Dataframe.decode(IA, IA.uint32());
          break;
        }
        case 39: {
          iA.table = $root$1.Table.decode(IA, IA.uint32());
          break;
        }
        case 41: {
          iA.vegaLiteChart = $root$1.VegaLiteChart.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.audio = $root$1.Audio.decode(IA, IA.uint32());
          break;
        }
        case 56: {
          iA.audioInput = $root$1.AudioInput.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.balloons = $root$1.Balloons.decode(IA, IA.uint32());
          break;
        }
        case 59: {
          iA.bidiComponent = $root$1.BidiComponent.decode(IA, IA.uint32());
          break;
        }
        case 19: {
          iA.button = $root$1.Button.decode(IA, IA.uint32());
          break;
        }
        case 55: {
          iA.buttonGroup = $root$1.ButtonGroup.decode(IA, IA.uint32());
          break;
        }
        case 43: {
          iA.downloadButton = $root$1.DownloadButton.decode(IA, IA.uint32());
          break;
        }
        case 45: {
          iA.cameraInput = $root$1.CameraInput.decode(IA, IA.uint32());
          break;
        }
        case 49: {
          iA.chatInput = $root$1.ChatInput.decode(IA, IA.uint32());
          break;
        }
        case 20: {
          iA.checkbox = $root$1.Checkbox.decode(IA, IA.uint32());
          break;
        }
        case 35: {
          iA.colorPicker = $root$1.ColorPicker.decode(IA, IA.uint32());
          break;
        }
        case 37: {
          iA.componentInstance = $root$1.ComponentInstance.decode(IA, IA.uint32());
          break;
        }
        case 27: {
          iA.dateInput = $root$1.DateInput.decode(IA, IA.uint32());
          break;
        }
        case 34: {
          iA.deckGlJsonChart = $root$1.DeckGlJsonChart.decode(IA, IA.uint32());
          break;
        }
        case 7: {
          iA.helpInfo = $root$1.Help.decode(IA, IA.uint32());
          break;
        }
        case 2: {
          iA.empty = $root$1.Empty.decode(IA, IA.uint32());
          break;
        }
        case 8: {
          iA.exception = $root$1.Exception.decode(IA, IA.uint32());
          break;
        }
        case 36: {
          iA.favicon = $root$1.Favicon.decode(IA, IA.uint32());
          break;
        }
        case 63: {
          iA.feedback = $root$1.Feedback.decode(IA, IA.uint32());
          break;
        }
        case 33: {
          iA.fileUploader = $root$1.FileUploader.decode(IA, IA.uint32());
          break;
        }
        case 18: {
          iA.graphvizChart = $root$1.GraphVizChart.decode(IA, IA.uint32());
          break;
        }
        case 54: {
          iA.html = $root$1.Html.decode(IA, IA.uint32());
          break;
        }
        case 38: {
          iA.iframe = $root$1.IFrame.decode(IA, IA.uint32());
          break;
        }
        case 6: {
          iA.imgs = $root$1.ImageList.decode(IA, IA.uint32());
          break;
        }
        case 31: {
          iA.json = $root$1.Json.decode(IA, IA.uint32());
          break;
        }
        case 51: {
          iA.linkButton = $root$1.LinkButton.decode(IA, IA.uint32());
          break;
        }
        case 29: {
          iA.markdown = $root$1.Markdown.decode(IA, IA.uint32());
          break;
        }
        case 42: {
          iA.metric = $root$1.Metric.decode(IA, IA.uint32());
          break;
        }
        case 28: {
          iA.multiselect = $root$1.MultiSelect.decode(IA, IA.uint32());
          break;
        }
        case 32: {
          iA.numberInput = $root$1.NumberInput.decode(IA, IA.uint32());
          break;
        }
        case 53: {
          iA.pageLink = $root$1.PageLink.decode(IA, IA.uint32());
          break;
        }
        case 16: {
          iA.plotlyChart = $root$1.PlotlyChart.decode(IA, IA.uint32());
          break;
        }
        case 5: {
          iA.progress = $root$1.Progress.decode(IA, IA.uint32());
          break;
        }
        case 23: {
          iA.radio = $root$1.Radio.decode(IA, IA.uint32());
          break;
        }
        case 25: {
          iA.selectbox = $root$1.Selectbox.decode(IA, IA.uint32());
          break;
        }
        case 52: {
          iA.skeleton = $root$1.Skeleton.decode(IA, IA.uint32());
          break;
        }
        case 21: {
          iA.slider = $root$1.Slider.decode(IA, IA.uint32());
          break;
        }
        case 46: {
          iA.snow = $root$1.Snow.decode(IA, IA.uint32());
          break;
        }
        case 60: {
          iA.space = $root$1.Space.decode(IA, IA.uint32());
          break;
        }
        case 44: {
          iA.spinner = $root$1.Spinner.decode(IA, IA.uint32());
          break;
        }
        case 1: {
          iA.text = $root$1.Text.decode(IA, IA.uint32());
          break;
        }
        case 22: {
          iA.textArea = $root$1.TextArea.decode(IA, IA.uint32());
          break;
        }
        case 24: {
          iA.textInput = $root$1.TextInput.decode(IA, IA.uint32());
          break;
        }
        case 26: {
          iA.timeInput = $root$1.TimeInput.decode(IA, IA.uint32());
          break;
        }
        case 62: {
          iA.dateTimeInput = $root$1.DateTimeInput.decode(IA, IA.uint32());
          break;
        }
        case 50: {
          iA.toast = $root$1.Toast.decode(IA, IA.uint32());
          break;
        }
        case 14: {
          iA.video = $root$1.Video.decode(IA, IA.uint32());
          break;
        }
        case 47: {
          iA.heading = $root$1.Heading.decode(IA, IA.uint32());
          break;
        }
        case 48: {
          iA.code = $root$1.Code.decode(IA, IA.uint32());
          break;
        }
        case 64: {
          iA.menuButton = $root$1.MenuButton.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Element) return IA;
    let BA = new $root$1.Element();
    if (IA.heightConfig != null) {
      if (typeof IA.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      BA.heightConfig = $root$1.streamlit.HeightConfig.fromObject(IA.heightConfig);
    }
    if (IA.widthConfig != null) {
      if (typeof IA.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      BA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(IA.widthConfig);
    }
    if (IA.textAlignmentConfig != null) {
      if (typeof IA.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      BA.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.fromObject(IA.textAlignmentConfig);
    }
    if (IA.alert != null) {
      if (typeof IA.alert != "object") throw TypeError(".Element.alert: object expected");
      BA.alert = $root$1.Alert.fromObject(IA.alert);
    }
    if (IA.dataframe != null) {
      if (typeof IA.dataframe != "object") throw TypeError(".Element.dataframe: object expected");
      BA.dataframe = $root$1.Dataframe.fromObject(IA.dataframe);
    }
    if (IA.table != null) {
      if (typeof IA.table != "object") throw TypeError(".Element.table: object expected");
      BA.table = $root$1.Table.fromObject(IA.table);
    }
    if (IA.vegaLiteChart != null) {
      if (typeof IA.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      BA.vegaLiteChart = $root$1.VegaLiteChart.fromObject(IA.vegaLiteChart);
    }
    if (IA.audio != null) {
      if (typeof IA.audio != "object") throw TypeError(".Element.audio: object expected");
      BA.audio = $root$1.Audio.fromObject(IA.audio);
    }
    if (IA.audioInput != null) {
      if (typeof IA.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      BA.audioInput = $root$1.AudioInput.fromObject(IA.audioInput);
    }
    if (IA.balloons != null) {
      if (typeof IA.balloons != "object") throw TypeError(".Element.balloons: object expected");
      BA.balloons = $root$1.Balloons.fromObject(IA.balloons);
    }
    if (IA.bidiComponent != null) {
      if (typeof IA.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      BA.bidiComponent = $root$1.BidiComponent.fromObject(IA.bidiComponent);
    }
    if (IA.button != null) {
      if (typeof IA.button != "object") throw TypeError(".Element.button: object expected");
      BA.button = $root$1.Button.fromObject(IA.button);
    }
    if (IA.buttonGroup != null) {
      if (typeof IA.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      BA.buttonGroup = $root$1.ButtonGroup.fromObject(IA.buttonGroup);
    }
    if (IA.downloadButton != null) {
      if (typeof IA.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      BA.downloadButton = $root$1.DownloadButton.fromObject(IA.downloadButton);
    }
    if (IA.cameraInput != null) {
      if (typeof IA.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      BA.cameraInput = $root$1.CameraInput.fromObject(IA.cameraInput);
    }
    if (IA.chatInput != null) {
      if (typeof IA.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      BA.chatInput = $root$1.ChatInput.fromObject(IA.chatInput);
    }
    if (IA.checkbox != null) {
      if (typeof IA.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      BA.checkbox = $root$1.Checkbox.fromObject(IA.checkbox);
    }
    if (IA.colorPicker != null) {
      if (typeof IA.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      BA.colorPicker = $root$1.ColorPicker.fromObject(IA.colorPicker);
    }
    if (IA.componentInstance != null) {
      if (typeof IA.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      BA.componentInstance = $root$1.ComponentInstance.fromObject(IA.componentInstance);
    }
    if (IA.dateInput != null) {
      if (typeof IA.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      BA.dateInput = $root$1.DateInput.fromObject(IA.dateInput);
    }
    if (IA.deckGlJsonChart != null) {
      if (typeof IA.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      BA.deckGlJsonChart = $root$1.DeckGlJsonChart.fromObject(IA.deckGlJsonChart);
    }
    if (IA.helpInfo != null) {
      if (typeof IA.helpInfo != "object") throw TypeError(".Element.helpInfo: object expected");
      BA.helpInfo = $root$1.Help.fromObject(IA.helpInfo);
    }
    if (IA.empty != null) {
      if (typeof IA.empty != "object") throw TypeError(".Element.empty: object expected");
      BA.empty = $root$1.Empty.fromObject(IA.empty);
    }
    if (IA.exception != null) {
      if (typeof IA.exception != "object") throw TypeError(".Element.exception: object expected");
      BA.exception = $root$1.Exception.fromObject(IA.exception);
    }
    if (IA.favicon != null) {
      if (typeof IA.favicon != "object") throw TypeError(".Element.favicon: object expected");
      BA.favicon = $root$1.Favicon.fromObject(IA.favicon);
    }
    if (IA.feedback != null) {
      if (typeof IA.feedback != "object") throw TypeError(".Element.feedback: object expected");
      BA.feedback = $root$1.Feedback.fromObject(IA.feedback);
    }
    if (IA.fileUploader != null) {
      if (typeof IA.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      BA.fileUploader = $root$1.FileUploader.fromObject(IA.fileUploader);
    }
    if (IA.graphvizChart != null) {
      if (typeof IA.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      BA.graphvizChart = $root$1.GraphVizChart.fromObject(IA.graphvizChart);
    }
    if (IA.html != null) {
      if (typeof IA.html != "object") throw TypeError(".Element.html: object expected");
      BA.html = $root$1.Html.fromObject(IA.html);
    }
    if (IA.iframe != null) {
      if (typeof IA.iframe != "object") throw TypeError(".Element.iframe: object expected");
      BA.iframe = $root$1.IFrame.fromObject(IA.iframe);
    }
    if (IA.imgs != null) {
      if (typeof IA.imgs != "object") throw TypeError(".Element.imgs: object expected");
      BA.imgs = $root$1.ImageList.fromObject(IA.imgs);
    }
    if (IA.json != null) {
      if (typeof IA.json != "object") throw TypeError(".Element.json: object expected");
      BA.json = $root$1.Json.fromObject(IA.json);
    }
    if (IA.linkButton != null) {
      if (typeof IA.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      BA.linkButton = $root$1.LinkButton.fromObject(IA.linkButton);
    }
    if (IA.markdown != null) {
      if (typeof IA.markdown != "object") throw TypeError(".Element.markdown: object expected");
      BA.markdown = $root$1.Markdown.fromObject(IA.markdown);
    }
    if (IA.metric != null) {
      if (typeof IA.metric != "object") throw TypeError(".Element.metric: object expected");
      BA.metric = $root$1.Metric.fromObject(IA.metric);
    }
    if (IA.multiselect != null) {
      if (typeof IA.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      BA.multiselect = $root$1.MultiSelect.fromObject(IA.multiselect);
    }
    if (IA.numberInput != null) {
      if (typeof IA.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      BA.numberInput = $root$1.NumberInput.fromObject(IA.numberInput);
    }
    if (IA.pageLink != null) {
      if (typeof IA.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      BA.pageLink = $root$1.PageLink.fromObject(IA.pageLink);
    }
    if (IA.plotlyChart != null) {
      if (typeof IA.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      BA.plotlyChart = $root$1.PlotlyChart.fromObject(IA.plotlyChart);
    }
    if (IA.progress != null) {
      if (typeof IA.progress != "object") throw TypeError(".Element.progress: object expected");
      BA.progress = $root$1.Progress.fromObject(IA.progress);
    }
    if (IA.radio != null) {
      if (typeof IA.radio != "object") throw TypeError(".Element.radio: object expected");
      BA.radio = $root$1.Radio.fromObject(IA.radio);
    }
    if (IA.selectbox != null) {
      if (typeof IA.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      BA.selectbox = $root$1.Selectbox.fromObject(IA.selectbox);
    }
    if (IA.skeleton != null) {
      if (typeof IA.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      BA.skeleton = $root$1.Skeleton.fromObject(IA.skeleton);
    }
    if (IA.slider != null) {
      if (typeof IA.slider != "object") throw TypeError(".Element.slider: object expected");
      BA.slider = $root$1.Slider.fromObject(IA.slider);
    }
    if (IA.snow != null) {
      if (typeof IA.snow != "object") throw TypeError(".Element.snow: object expected");
      BA.snow = $root$1.Snow.fromObject(IA.snow);
    }
    if (IA.space != null) {
      if (typeof IA.space != "object") throw TypeError(".Element.space: object expected");
      BA.space = $root$1.Space.fromObject(IA.space);
    }
    if (IA.spinner != null) {
      if (typeof IA.spinner != "object") throw TypeError(".Element.spinner: object expected");
      BA.spinner = $root$1.Spinner.fromObject(IA.spinner);
    }
    if (IA.text != null) {
      if (typeof IA.text != "object") throw TypeError(".Element.text: object expected");
      BA.text = $root$1.Text.fromObject(IA.text);
    }
    if (IA.textArea != null) {
      if (typeof IA.textArea != "object") throw TypeError(".Element.textArea: object expected");
      BA.textArea = $root$1.TextArea.fromObject(IA.textArea);
    }
    if (IA.textInput != null) {
      if (typeof IA.textInput != "object") throw TypeError(".Element.textInput: object expected");
      BA.textInput = $root$1.TextInput.fromObject(IA.textInput);
    }
    if (IA.timeInput != null) {
      if (typeof IA.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      BA.timeInput = $root$1.TimeInput.fromObject(IA.timeInput);
    }
    if (IA.dateTimeInput != null) {
      if (typeof IA.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      BA.dateTimeInput = $root$1.DateTimeInput.fromObject(IA.dateTimeInput);
    }
    if (IA.toast != null) {
      if (typeof IA.toast != "object") throw TypeError(".Element.toast: object expected");
      BA.toast = $root$1.Toast.fromObject(IA.toast);
    }
    if (IA.video != null) {
      if (typeof IA.video != "object") throw TypeError(".Element.video: object expected");
      BA.video = $root$1.Video.fromObject(IA.video);
    }
    if (IA.heading != null) {
      if (typeof IA.heading != "object") throw TypeError(".Element.heading: object expected");
      BA.heading = $root$1.Heading.fromObject(IA.heading);
    }
    if (IA.code != null) {
      if (typeof IA.code != "object") throw TypeError(".Element.code: object expected");
      BA.code = $root$1.Code.fromObject(IA.code);
    }
    if (IA.menuButton != null) {
      if (typeof IA.menuButton != "object") throw TypeError(".Element.menuButton: object expected");
      BA.menuButton = $root$1.MenuButton.fromObject(IA.menuButton);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return IA.text != null && IA.hasOwnProperty("text") && (QA.text = $root$1.Text.toObject(IA.text, BA), BA.oneofs && (QA.type = "text")), IA.empty != null && IA.hasOwnProperty("empty") && (QA.empty = $root$1.Empty.toObject(IA.empty, BA), BA.oneofs && (QA.type = "empty")), IA.progress != null && IA.hasOwnProperty("progress") && (QA.progress = $root$1.Progress.toObject(IA.progress, BA), BA.oneofs && (QA.type = "progress")), IA.imgs != null && IA.hasOwnProperty("imgs") && (QA.imgs = $root$1.ImageList.toObject(IA.imgs, BA), BA.oneofs && (QA.type = "imgs")), IA.helpInfo != null && IA.hasOwnProperty("helpInfo") && (QA.helpInfo = $root$1.Help.toObject(IA.helpInfo, BA), BA.oneofs && (QA.type = "helpInfo")), IA.exception != null && IA.hasOwnProperty("exception") && (QA.exception = $root$1.Exception.toObject(IA.exception, BA), BA.oneofs && (QA.type = "exception")), IA.balloons != null && IA.hasOwnProperty("balloons") && (QA.balloons = $root$1.Balloons.toObject(IA.balloons, BA), BA.oneofs && (QA.type = "balloons")), IA.audio != null && IA.hasOwnProperty("audio") && (QA.audio = $root$1.Audio.toObject(IA.audio, BA), BA.oneofs && (QA.type = "audio")), IA.video != null && IA.hasOwnProperty("video") && (QA.video = $root$1.Video.toObject(IA.video, BA), BA.oneofs && (QA.type = "video")), IA.plotlyChart != null && IA.hasOwnProperty("plotlyChart") && (QA.plotlyChart = $root$1.PlotlyChart.toObject(IA.plotlyChart, BA), BA.oneofs && (QA.type = "plotlyChart")), IA.graphvizChart != null && IA.hasOwnProperty("graphvizChart") && (QA.graphvizChart = $root$1.GraphVizChart.toObject(IA.graphvizChart, BA), BA.oneofs && (QA.type = "graphvizChart")), IA.button != null && IA.hasOwnProperty("button") && (QA.button = $root$1.Button.toObject(IA.button, BA), BA.oneofs && (QA.type = "button")), IA.checkbox != null && IA.hasOwnProperty("checkbox") && (QA.checkbox = $root$1.Checkbox.toObject(IA.checkbox, BA), BA.oneofs && (QA.type = "checkbox")), IA.slider != null && IA.hasOwnProperty("slider") && (QA.slider = $root$1.Slider.toObject(IA.slider, BA), BA.oneofs && (QA.type = "slider")), IA.textArea != null && IA.hasOwnProperty("textArea") && (QA.textArea = $root$1.TextArea.toObject(IA.textArea, BA), BA.oneofs && (QA.type = "textArea")), IA.radio != null && IA.hasOwnProperty("radio") && (QA.radio = $root$1.Radio.toObject(IA.radio, BA), BA.oneofs && (QA.type = "radio")), IA.textInput != null && IA.hasOwnProperty("textInput") && (QA.textInput = $root$1.TextInput.toObject(IA.textInput, BA), BA.oneofs && (QA.type = "textInput")), IA.selectbox != null && IA.hasOwnProperty("selectbox") && (QA.selectbox = $root$1.Selectbox.toObject(IA.selectbox, BA), BA.oneofs && (QA.type = "selectbox")), IA.timeInput != null && IA.hasOwnProperty("timeInput") && (QA.timeInput = $root$1.TimeInput.toObject(IA.timeInput, BA), BA.oneofs && (QA.type = "timeInput")), IA.dateInput != null && IA.hasOwnProperty("dateInput") && (QA.dateInput = $root$1.DateInput.toObject(IA.dateInput, BA), BA.oneofs && (QA.type = "dateInput")), IA.multiselect != null && IA.hasOwnProperty("multiselect") && (QA.multiselect = $root$1.MultiSelect.toObject(IA.multiselect, BA), BA.oneofs && (QA.type = "multiselect")), IA.markdown != null && IA.hasOwnProperty("markdown") && (QA.markdown = $root$1.Markdown.toObject(IA.markdown, BA), BA.oneofs && (QA.type = "markdown")), IA.alert != null && IA.hasOwnProperty("alert") && (QA.alert = $root$1.Alert.toObject(IA.alert, BA), BA.oneofs && (QA.type = "alert")), IA.json != null && IA.hasOwnProperty("json") && (QA.json = $root$1.Json.toObject(IA.json, BA), BA.oneofs && (QA.type = "json")), IA.numberInput != null && IA.hasOwnProperty("numberInput") && (QA.numberInput = $root$1.NumberInput.toObject(IA.numberInput, BA), BA.oneofs && (QA.type = "numberInput")), IA.fileUploader != null && IA.hasOwnProperty("fileUploader") && (QA.fileUploader = $root$1.FileUploader.toObject(IA.fileUploader, BA), BA.oneofs && (QA.type = "fileUploader")), IA.deckGlJsonChart != null && IA.hasOwnProperty("deckGlJsonChart") && (QA.deckGlJsonChart = $root$1.DeckGlJsonChart.toObject(IA.deckGlJsonChart, BA), BA.oneofs && (QA.type = "deckGlJsonChart")), IA.colorPicker != null && IA.hasOwnProperty("colorPicker") && (QA.colorPicker = $root$1.ColorPicker.toObject(IA.colorPicker, BA), BA.oneofs && (QA.type = "colorPicker")), IA.favicon != null && IA.hasOwnProperty("favicon") && (QA.favicon = $root$1.Favicon.toObject(IA.favicon, BA), BA.oneofs && (QA.type = "favicon")), IA.componentInstance != null && IA.hasOwnProperty("componentInstance") && (QA.componentInstance = $root$1.ComponentInstance.toObject(IA.componentInstance, BA), BA.oneofs && (QA.type = "componentInstance")), IA.iframe != null && IA.hasOwnProperty("iframe") && (QA.iframe = $root$1.IFrame.toObject(IA.iframe, BA), BA.oneofs && (QA.type = "iframe")), IA.table != null && IA.hasOwnProperty("table") && (QA.table = $root$1.Table.toObject(IA.table, BA), BA.oneofs && (QA.type = "table")), IA.dataframe != null && IA.hasOwnProperty("dataframe") && (QA.dataframe = $root$1.Dataframe.toObject(IA.dataframe, BA), BA.oneofs && (QA.type = "dataframe")), IA.vegaLiteChart != null && IA.hasOwnProperty("vegaLiteChart") && (QA.vegaLiteChart = $root$1.VegaLiteChart.toObject(IA.vegaLiteChart, BA), BA.oneofs && (QA.type = "vegaLiteChart")), IA.metric != null && IA.hasOwnProperty("metric") && (QA.metric = $root$1.Metric.toObject(IA.metric, BA), BA.oneofs && (QA.type = "metric")), IA.downloadButton != null && IA.hasOwnProperty("downloadButton") && (QA.downloadButton = $root$1.DownloadButton.toObject(IA.downloadButton, BA), BA.oneofs && (QA.type = "downloadButton")), IA.spinner != null && IA.hasOwnProperty("spinner") && (QA.spinner = $root$1.Spinner.toObject(IA.spinner, BA), BA.oneofs && (QA.type = "spinner")), IA.cameraInput != null && IA.hasOwnProperty("cameraInput") && (QA.cameraInput = $root$1.CameraInput.toObject(IA.cameraInput, BA), BA.oneofs && (QA.type = "cameraInput")), IA.snow != null && IA.hasOwnProperty("snow") && (QA.snow = $root$1.Snow.toObject(IA.snow, BA), BA.oneofs && (QA.type = "snow")), IA.heading != null && IA.hasOwnProperty("heading") && (QA.heading = $root$1.Heading.toObject(IA.heading, BA), BA.oneofs && (QA.type = "heading")), IA.code != null && IA.hasOwnProperty("code") && (QA.code = $root$1.Code.toObject(IA.code, BA), BA.oneofs && (QA.type = "code")), IA.chatInput != null && IA.hasOwnProperty("chatInput") && (QA.chatInput = $root$1.ChatInput.toObject(IA.chatInput, BA), BA.oneofs && (QA.type = "chatInput")), IA.toast != null && IA.hasOwnProperty("toast") && (QA.toast = $root$1.Toast.toObject(IA.toast, BA), BA.oneofs && (QA.type = "toast")), IA.linkButton != null && IA.hasOwnProperty("linkButton") && (QA.linkButton = $root$1.LinkButton.toObject(IA.linkButton, BA), BA.oneofs && (QA.type = "linkButton")), IA.skeleton != null && IA.hasOwnProperty("skeleton") && (QA.skeleton = $root$1.Skeleton.toObject(IA.skeleton, BA), BA.oneofs && (QA.type = "skeleton")), IA.pageLink != null && IA.hasOwnProperty("pageLink") && (QA.pageLink = $root$1.PageLink.toObject(IA.pageLink, BA), BA.oneofs && (QA.type = "pageLink")), IA.html != null && IA.hasOwnProperty("html") && (QA.html = $root$1.Html.toObject(IA.html, BA), BA.oneofs && (QA.type = "html")), IA.buttonGroup != null && IA.hasOwnProperty("buttonGroup") && (QA.buttonGroup = $root$1.ButtonGroup.toObject(IA.buttonGroup, BA), BA.oneofs && (QA.type = "buttonGroup")), IA.audioInput != null && IA.hasOwnProperty("audioInput") && (QA.audioInput = $root$1.AudioInput.toObject(IA.audioInput, BA), BA.oneofs && (QA.type = "audioInput")), IA.heightConfig != null && IA.hasOwnProperty("heightConfig") && (QA.heightConfig = $root$1.streamlit.HeightConfig.toObject(IA.heightConfig, BA), BA.oneofs && (QA._heightConfig = "heightConfig")), IA.widthConfig != null && IA.hasOwnProperty("widthConfig") && (QA.widthConfig = $root$1.streamlit.WidthConfig.toObject(IA.widthConfig, BA), BA.oneofs && (QA._widthConfig = "widthConfig")), IA.bidiComponent != null && IA.hasOwnProperty("bidiComponent") && (QA.bidiComponent = $root$1.BidiComponent.toObject(IA.bidiComponent, BA), BA.oneofs && (QA.type = "bidiComponent")), IA.space != null && IA.hasOwnProperty("space") && (QA.space = $root$1.Space.toObject(IA.space, BA), BA.oneofs && (QA.type = "space")), IA.textAlignmentConfig != null && IA.hasOwnProperty("textAlignmentConfig") && (QA.textAlignmentConfig = $root$1.streamlit.TextAlignmentConfig.toObject(IA.textAlignmentConfig, BA), BA.oneofs && (QA._textAlignmentConfig = "textAlignmentConfig")), IA.dateTimeInput != null && IA.hasOwnProperty("dateTimeInput") && (QA.dateTimeInput = $root$1.DateTimeInput.toObject(IA.dateTimeInput, BA), BA.oneofs && (QA.type = "dateTimeInput")), IA.feedback != null && IA.hasOwnProperty("feedback") && (QA.feedback = $root$1.Feedback.toObject(IA.feedback, BA), BA.oneofs && (QA.type = "feedback")), IA.menuButton != null && IA.hasOwnProperty("menuButton") && (QA.menuButton = $root$1.MenuButton.toObject(IA.menuButton, BA), BA.oneofs && (QA.type = "menuButton")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Element";
  }, CA;
})();
$root$1.DownloadButton = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.url = "", CA.prototype.disabled = !1, CA.prototype.useContainerWidth = !1, CA.prototype.type = "", CA.prototype.icon = "", CA.prototype.ignoreRerun = !1, CA.prototype.deferredFileId = null, CA.prototype.shortcut = "", CA.prototype.iconPosition = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_deferredFileId", { get: $util$1.oneOfGetter(gA = ["deferredFileId"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(IA.default), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.url != null && Object.hasOwnProperty.call(IA, "url") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.url), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.disabled), IA.useContainerWidth != null && Object.hasOwnProperty.call(IA, "useContainerWidth") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.useContainerWidth), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(IA.type), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.icon), IA.ignoreRerun != null && Object.hasOwnProperty.call(IA, "ignoreRerun") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.ignoreRerun), IA.deferredFileId != null && Object.hasOwnProperty.call(IA, "deferredFileId") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.deferredFileId), IA.shortcut != null && Object.hasOwnProperty.call(IA, "shortcut") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.shortcut), IA.iconPosition != null && Object.hasOwnProperty.call(IA, "iconPosition") && BA.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(IA.iconPosition), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.DownloadButton();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.bool();
          break;
        }
        case 4: {
          iA.help = IA.string();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.url = IA.string();
          break;
        }
        case 7: {
          iA.disabled = IA.bool();
          break;
        }
        case 8: {
          iA.useContainerWidth = IA.bool();
          break;
        }
        case 9: {
          iA.type = IA.string();
          break;
        }
        case 10: {
          iA.icon = IA.string();
          break;
        }
        case 11: {
          iA.ignoreRerun = IA.bool();
          break;
        }
        case 12: {
          iA.deferredFileId = IA.string();
          break;
        }
        case 13: {
          iA.shortcut = IA.string();
          break;
        }
        case 14: {
          iA.iconPosition = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.DownloadButton) return IA;
    let BA = new $root$1.DownloadButton();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = !!IA.default), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.url != null && (BA.url = String(IA.url)), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.useContainerWidth != null && (BA.useContainerWidth = !!IA.useContainerWidth), IA.type != null && (BA.type = String(IA.type)), IA.icon != null && (BA.icon = String(IA.icon)), IA.ignoreRerun != null && (BA.ignoreRerun = !!IA.ignoreRerun), IA.deferredFileId != null && (BA.deferredFileId = String(IA.deferredFileId)), IA.shortcut != null && (BA.shortcut = String(IA.shortcut)), IA.iconPosition) {
      default:
        if (typeof IA.iconPosition == "number") {
          BA.iconPosition = IA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        BA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        BA.iconPosition = 1;
        break;
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.default = !1, QA.help = "", QA.formId = "", QA.url = "", QA.disabled = !1, QA.useContainerWidth = !1, QA.type = "", QA.icon = "", QA.ignoreRerun = !1, QA.shortcut = "", QA.iconPosition = BA.enums === String ? "LEFT" : 0), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.url != null && IA.hasOwnProperty("url") && (QA.url = IA.url), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.useContainerWidth != null && IA.hasOwnProperty("useContainerWidth") && (QA.useContainerWidth = IA.useContainerWidth), IA.type != null && IA.hasOwnProperty("type") && (QA.type = IA.type), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.ignoreRerun != null && IA.hasOwnProperty("ignoreRerun") && (QA.ignoreRerun = IA.ignoreRerun), IA.deferredFileId != null && IA.hasOwnProperty("deferredFileId") && (QA.deferredFileId = IA.deferredFileId, BA.oneofs && (QA._deferredFileId = "deferredFileId")), IA.shortcut != null && IA.hasOwnProperty("shortcut") && (QA.shortcut = IA.shortcut), IA.iconPosition != null && IA.hasOwnProperty("iconPosition") && (QA.iconPosition = BA.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[IA.iconPosition] === void 0 ? IA.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[IA.iconPosition] : IA.iconPosition), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/DownloadButton";
  }, CA;
})();
$root$1.Empty = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Empty();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    return AA instanceof $root$1.Empty ? AA : new $root$1.Empty();
  }, CA.toObject = function() {
    return {};
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Empty";
  }, CA;
})();
$root$1.Exception = (() => {
  function CA(gA) {
    if (this.stackTrace = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.type = "", CA.prototype.message = "", CA.prototype.messageIsMarkdown = !1, CA.prototype.stackTrace = $util$1.emptyArray, CA.prototype.isWarning = !1, CA.prototype.widthConfig = null, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.type), AA.message != null && Object.hasOwnProperty.call(AA, "message") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.message), AA.stackTrace != null && AA.stackTrace.length) for (let BA = 0; BA < AA.stackTrace.length; ++BA) IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.stackTrace[BA]);
    return AA.messageIsMarkdown != null && Object.hasOwnProperty.call(AA, "messageIsMarkdown") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(AA.messageIsMarkdown), AA.isWarning != null && Object.hasOwnProperty.call(AA, "isWarning") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.isWarning), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Exception();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.type = AA.string();
          break;
        }
        case 2: {
          EA.message = AA.string();
          break;
        }
        case 4: {
          EA.messageIsMarkdown = AA.bool();
          break;
        }
        case 3: {
          EA.stackTrace && EA.stackTrace.length || (EA.stackTrace = []), EA.stackTrace.push(AA.string());
          break;
        }
        case 5: {
          EA.isWarning = AA.bool();
          break;
        }
        case 6: {
          EA.widthConfig = $root$1.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Exception) return AA;
    let IA = new $root$1.Exception();
    if (AA.type != null && (IA.type = String(AA.type)), AA.message != null && (IA.message = String(AA.message)), AA.messageIsMarkdown != null && (IA.messageIsMarkdown = !!AA.messageIsMarkdown), AA.stackTrace) {
      if (!Array.isArray(AA.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      IA.stackTrace = [];
      for (let BA = 0; BA < AA.stackTrace.length; ++BA) IA.stackTrace[BA] = String(AA.stackTrace[BA]);
    }
    if (AA.isWarning != null && (IA.isWarning = !!AA.isWarning), AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      IA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.stackTrace = []), IA.defaults && (BA.type = "", BA.message = "", BA.messageIsMarkdown = !1, BA.isWarning = !1, BA.widthConfig = null), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.message != null && AA.hasOwnProperty("message") && (BA.message = AA.message), AA.stackTrace && AA.stackTrace.length) {
      BA.stackTrace = [];
      for (let QA = 0; QA < AA.stackTrace.length; ++QA) BA.stackTrace[QA] = AA.stackTrace[QA];
    }
    return AA.messageIsMarkdown != null && AA.hasOwnProperty("messageIsMarkdown") && (BA.messageIsMarkdown = AA.messageIsMarkdown), AA.isWarning != null && AA.hasOwnProperty("isWarning") && (BA.isWarning = AA.isWarning), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root$1.streamlit.WidthConfig.toObject(AA.widthConfig, IA)), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Exception";
  }, CA;
})();
$root$1.Favicon = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.url), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Favicon();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.url = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Favicon) return AA;
    let IA = new $root$1.Favicon();
    return AA.url != null && (IA.url = String(AA.url)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.url = ""), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Favicon";
  }, CA;
})();
const Feedback$1 = $root$1.Feedback = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.type = 0, CA.prototype.default = null, CA.prototype.disabled = !1, CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util$1.oneOfGetter(gA = ["value"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(IA.type), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(IA.default), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(IA.disabled), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).uint32(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.setValue), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Feedback();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.type = IA.int32();
          break;
        }
        case 3: {
          iA.default = IA.uint32();
          break;
        }
        case 4: {
          iA.disabled = IA.bool();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.value = IA.uint32();
          break;
        }
        case 7: {
          iA.setValue = IA.bool();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Feedback) return IA;
    let BA = new $root$1.Feedback();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.type) {
      default:
        if (typeof IA.type == "number") {
          BA.type = IA.type;
          break;
        }
        break;
      case "THUMBS":
      case 0:
        BA.type = 0;
        break;
      case "FACES":
      case 1:
        BA.type = 1;
        break;
      case "STARS":
      case 2:
        BA.type = 2;
        break;
    }
    return IA.default != null && (BA.default = IA.default >>> 0), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = IA.value >>> 0), IA.setValue != null && (BA.setValue = !!IA.setValue), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.type = BA.enums === String ? "THUMBS" : 0, QA.disabled = !1, QA.formId = "", QA.setValue = !1), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.Feedback.FeedbackType[IA.type] === void 0 ? IA.type : $root$1.Feedback.FeedbackType[IA.type] : IA.type), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value, BA.oneofs && (QA._value = "value")), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Feedback";
  }, CA.FeedbackType = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "THUMBS"] = 0, IA[AA[1] = "FACES"] = 1, IA[AA[2] = "STARS"] = 2, IA;
  })(), CA;
})();
$root$1.FileUploader = (() => {
  function CA(gA) {
    if (this.type = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.type = $util$1.emptyArray, CA.prototype.maxUploadSizeMb = 0, CA.prototype.multipleFiles = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.acceptDirectory = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.label), AA.type != null && AA.type.length) for (let BA = 0; BA < AA.type.length; ++BA) IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.type[BA]);
    return AA.maxUploadSizeMb != null && Object.hasOwnProperty.call(AA, "maxUploadSizeMb") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(AA.maxUploadSizeMb), AA.multipleFiles != null && Object.hasOwnProperty.call(AA, "multipleFiles") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.multipleFiles), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(AA.formId), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root$1.LabelVisibility.encode(AA.labelVisibility, IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), AA.acceptDirectory != null && Object.hasOwnProperty.call(AA, "acceptDirectory") && IA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(AA.acceptDirectory), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FileUploader();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.id = AA.string();
          break;
        }
        case 2: {
          EA.label = AA.string();
          break;
        }
        case 3: {
          EA.type && EA.type.length || (EA.type = []), EA.type.push(AA.string());
          break;
        }
        case 4: {
          EA.maxUploadSizeMb = AA.int32();
          break;
        }
        case 6: {
          EA.multipleFiles = AA.bool();
          break;
        }
        case 7: {
          EA.help = AA.string();
          break;
        }
        case 8: {
          EA.formId = AA.string();
          break;
        }
        case 9: {
          EA.disabled = AA.bool();
          break;
        }
        case 10: {
          EA.labelVisibility = $root$1.LabelVisibility.decode(AA, AA.uint32());
          break;
        }
        case 11: {
          EA.acceptDirectory = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FileUploader) return AA;
    let IA = new $root$1.FileUploader();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.type) {
      if (!Array.isArray(AA.type)) throw TypeError(".FileUploader.type: array expected");
      IA.type = [];
      for (let BA = 0; BA < AA.type.length; ++BA) IA.type[BA] = String(AA.type[BA]);
    }
    if (AA.maxUploadSizeMb != null && (IA.maxUploadSizeMb = AA.maxUploadSizeMb | 0), AA.multipleFiles != null && (IA.multipleFiles = !!AA.multipleFiles), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      IA.labelVisibility = $root$1.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.acceptDirectory != null && (IA.acceptDirectory = !!AA.acceptDirectory), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.type = []), IA.defaults && (BA.id = "", BA.label = "", BA.maxUploadSizeMb = 0, BA.multipleFiles = !1, BA.help = "", BA.formId = "", BA.disabled = !1, BA.labelVisibility = null, BA.acceptDirectory = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.type && AA.type.length) {
      BA.type = [];
      for (let QA = 0; QA < AA.type.length; ++QA) BA.type[QA] = AA.type[QA];
    }
    return AA.maxUploadSizeMb != null && AA.hasOwnProperty("maxUploadSizeMb") && (BA.maxUploadSizeMb = AA.maxUploadSizeMb), AA.multipleFiles != null && AA.hasOwnProperty("multipleFiles") && (BA.multipleFiles = AA.multipleFiles), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root$1.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.acceptDirectory != null && AA.hasOwnProperty("acceptDirectory") && (BA.acceptDirectory = AA.acceptDirectory), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FileUploader";
  }, CA;
})();
$root$1.GraphVizChart = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.spec = "", CA.prototype.elementId = "", CA.prototype.engine = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.spec != null && Object.hasOwnProperty.call(AA, "spec") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.spec), AA.elementId != null && Object.hasOwnProperty.call(AA, "elementId") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.elementId), AA.engine != null && Object.hasOwnProperty.call(AA, "engine") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.engine), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.GraphVizChart();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.spec = AA.string();
          break;
        }
        case 5: {
          EA.elementId = AA.string();
          break;
        }
        case 6: {
          EA.engine = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.GraphVizChart) return AA;
    let IA = new $root$1.GraphVizChart();
    return AA.spec != null && (IA.spec = String(AA.spec)), AA.elementId != null && (IA.elementId = String(AA.elementId)), AA.engine != null && (IA.engine = String(AA.engine)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.spec = "", BA.elementId = "", BA.engine = ""), AA.spec != null && AA.hasOwnProperty("spec") && (BA.spec = AA.spec), AA.elementId != null && AA.hasOwnProperty("elementId") && (BA.elementId = AA.elementId), AA.engine != null && AA.hasOwnProperty("engine") && (BA.engine = AA.engine), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/GraphVizChart";
  }, CA;
})();
$root$1.Heading = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.tag = "", CA.prototype.anchor = "", CA.prototype.body = "", CA.prototype.help = "", CA.prototype.hideAnchor = !1, CA.prototype.divider = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.tag != null && Object.hasOwnProperty.call(AA, "tag") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.tag), AA.anchor != null && Object.hasOwnProperty.call(AA, "anchor") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.anchor), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.body), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.help), AA.hideAnchor != null && Object.hasOwnProperty.call(AA, "hideAnchor") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.hideAnchor), AA.divider != null && Object.hasOwnProperty.call(AA, "divider") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.divider), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Heading();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.tag = AA.string();
          break;
        }
        case 2: {
          EA.anchor = AA.string();
          break;
        }
        case 3: {
          EA.body = AA.string();
          break;
        }
        case 4: {
          EA.help = AA.string();
          break;
        }
        case 5: {
          EA.hideAnchor = AA.bool();
          break;
        }
        case 6: {
          EA.divider = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Heading) return AA;
    let IA = new $root$1.Heading();
    return AA.tag != null && (IA.tag = String(AA.tag)), AA.anchor != null && (IA.anchor = String(AA.anchor)), AA.body != null && (IA.body = String(AA.body)), AA.help != null && (IA.help = String(AA.help)), AA.hideAnchor != null && (IA.hideAnchor = !!AA.hideAnchor), AA.divider != null && (IA.divider = String(AA.divider)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.tag = "", BA.anchor = "", BA.body = "", BA.help = "", BA.hideAnchor = !1, BA.divider = ""), AA.tag != null && AA.hasOwnProperty("tag") && (BA.tag = AA.tag), AA.anchor != null && AA.hasOwnProperty("anchor") && (BA.anchor = AA.anchor), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.hideAnchor != null && AA.hasOwnProperty("hideAnchor") && (BA.hideAnchor = AA.hideAnchor), AA.divider != null && AA.hasOwnProperty("divider") && (BA.divider = AA.divider), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Heading";
  }, CA;
})();
$root$1.Help = (() => {
  function CA(gA) {
    if (this.members = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.docString = "", CA.prototype.type = "", CA.prototype.name = "", CA.prototype.value = "", CA.prototype.members = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.docString != null && Object.hasOwnProperty.call(AA, "docString") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.docString), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.type), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.name), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.value), AA.members != null && AA.members.length) for (let BA = 0; BA < AA.members.length; ++BA) $root$1.Member.encode(AA.members[BA], IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Help();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 3: {
          EA.docString = AA.string();
          break;
        }
        case 4: {
          EA.type = AA.string();
          break;
        }
        case 6: {
          EA.name = AA.string();
          break;
        }
        case 7: {
          EA.value = AA.string();
          break;
        }
        case 8: {
          EA.members && EA.members.length || (EA.members = []), EA.members.push($root$1.Member.decode(AA, AA.uint32()));
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Help) return AA;
    let IA = new $root$1.Help();
    if (AA.docString != null && (IA.docString = String(AA.docString)), AA.type != null && (IA.type = String(AA.type)), AA.name != null && (IA.name = String(AA.name)), AA.value != null && (IA.value = String(AA.value)), AA.members) {
      if (!Array.isArray(AA.members)) throw TypeError(".Help.members: array expected");
      IA.members = [];
      for (let BA = 0; BA < AA.members.length; ++BA) {
        if (typeof AA.members[BA] != "object") throw TypeError(".Help.members: object expected");
        IA.members[BA] = $root$1.Member.fromObject(AA.members[BA]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.members = []), IA.defaults && (BA.docString = "", BA.type = "", BA.name = "", BA.value = ""), AA.docString != null && AA.hasOwnProperty("docString") && (BA.docString = AA.docString), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), AA.members && AA.members.length) {
      BA.members = [];
      for (let QA = 0; QA < AA.members.length; ++QA) BA.members[QA] = $root$1.Member.toObject(AA.members[QA], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Help";
  }, CA;
})();
$root$1.Member = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.name = "", CA.prototype.type = "", CA.prototype.value = null, CA.prototype.docString = null;
  let gA;
  return Object.defineProperty(CA.prototype, "contents", { get: $util$1.oneOfGetter(gA = ["value", "docString"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.name != null && Object.hasOwnProperty.call(IA, "name") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.name), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.type), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.value), IA.docString != null && Object.hasOwnProperty.call(IA, "docString") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.docString), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Member();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.name = IA.string();
          break;
        }
        case 2: {
          iA.type = IA.string();
          break;
        }
        case 3: {
          iA.value = IA.string();
          break;
        }
        case 4: {
          iA.docString = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Member) return IA;
    let BA = new $root$1.Member();
    return IA.name != null && (BA.name = String(IA.name)), IA.type != null && (BA.type = String(IA.type)), IA.value != null && (BA.value = String(IA.value)), IA.docString != null && (BA.docString = String(IA.docString)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.name = "", QA.type = ""), IA.name != null && IA.hasOwnProperty("name") && (QA.name = IA.name), IA.type != null && IA.hasOwnProperty("type") && (QA.type = IA.type), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value, BA.oneofs && (QA.contents = "value")), IA.docString != null && IA.hasOwnProperty("docString") && (QA.docString = IA.docString, BA.oneofs && (QA.contents = "docString")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Member";
  }, CA;
})();
$root$1.Html = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.unsafeAllowJavascript = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.body), AA.unsafeAllowJavascript != null && Object.hasOwnProperty.call(AA, "unsafeAllowJavascript") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(AA.unsafeAllowJavascript), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Html();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.body = AA.string();
          break;
        }
        case 2: {
          EA.unsafeAllowJavascript = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Html) return AA;
    let IA = new $root$1.Html();
    return AA.body != null && (IA.body = String(AA.body)), AA.unsafeAllowJavascript != null && (IA.unsafeAllowJavascript = !!AA.unsafeAllowJavascript), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.body = "", BA.unsafeAllowJavascript = !1), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.unsafeAllowJavascript != null && AA.hasOwnProperty("unsafeAllowJavascript") && (BA.unsafeAllowJavascript = AA.unsafeAllowJavascript), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Html";
  }, CA;
})();
$root$1.IFrame = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.src = null, CA.prototype.srcdoc = null, CA.prototype.scrolling = !1, CA.prototype.tabIndex = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["src", "srcdoc"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_tabIndex", { get: $util$1.oneOfGetter(gA = ["tabIndex"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.src != null && Object.hasOwnProperty.call(IA, "src") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.src), IA.srcdoc != null && Object.hasOwnProperty.call(IA, "srcdoc") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.srcdoc), IA.scrolling != null && Object.hasOwnProperty.call(IA, "scrolling") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.scrolling), IA.tabIndex != null && Object.hasOwnProperty.call(IA, "tabIndex") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(IA.tabIndex), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.IFrame();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.src = IA.string();
          break;
        }
        case 2: {
          iA.srcdoc = IA.string();
          break;
        }
        case 7: {
          iA.scrolling = IA.bool();
          break;
        }
        case 8: {
          iA.tabIndex = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.IFrame) return IA;
    let BA = new $root$1.IFrame();
    return IA.src != null && (BA.src = String(IA.src)), IA.srcdoc != null && (BA.srcdoc = String(IA.srcdoc)), IA.scrolling != null && (BA.scrolling = !!IA.scrolling), IA.tabIndex != null && (BA.tabIndex = IA.tabIndex | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.scrolling = !1), IA.src != null && IA.hasOwnProperty("src") && (QA.src = IA.src, BA.oneofs && (QA.type = "src")), IA.srcdoc != null && IA.hasOwnProperty("srcdoc") && (QA.srcdoc = IA.srcdoc, BA.oneofs && (QA.type = "srcdoc")), IA.scrolling != null && IA.hasOwnProperty("scrolling") && (QA.scrolling = IA.scrolling), IA.tabIndex != null && IA.hasOwnProperty("tabIndex") && (QA.tabIndex = IA.tabIndex, BA.oneofs && (QA._tabIndex = "tabIndex")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/IFrame";
  }, CA;
})();
$root$1.Image = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.prototype.caption = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.caption != null && Object.hasOwnProperty.call(AA, "caption") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.caption), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.url), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Image();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 3: {
          EA.url = AA.string();
          break;
        }
        case 2: {
          EA.caption = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Image) return AA;
    let IA = new $root$1.Image();
    return AA.url != null && (IA.url = String(AA.url)), AA.caption != null && (IA.caption = String(AA.caption)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.caption = "", BA.url = ""), AA.caption != null && AA.hasOwnProperty("caption") && (BA.caption = AA.caption), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Image";
  }, CA;
})();
$root$1.ImageList = (() => {
  function CA(gA) {
    if (this.imgs = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.imgs = $util$1.emptyArray, CA.prototype.link = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.imgs != null && AA.imgs.length) for (let BA = 0; BA < AA.imgs.length; ++BA) $root$1.Image.encode(AA.imgs[BA], IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return AA.link != null && Object.hasOwnProperty.call(AA, "link") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.link), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ImageList();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.imgs && EA.imgs.length || (EA.imgs = []), EA.imgs.push($root$1.Image.decode(AA, AA.uint32()));
          break;
        }
        case 3: {
          EA.link = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ImageList) return AA;
    let IA = new $root$1.ImageList();
    if (AA.imgs) {
      if (!Array.isArray(AA.imgs)) throw TypeError(".ImageList.imgs: array expected");
      IA.imgs = [];
      for (let BA = 0; BA < AA.imgs.length; ++BA) {
        if (typeof AA.imgs[BA] != "object") throw TypeError(".ImageList.imgs: object expected");
        IA.imgs[BA] = $root$1.Image.fromObject(AA.imgs[BA]);
      }
    }
    return AA.link != null && (IA.link = String(AA.link)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.imgs = []), IA.defaults && (BA.link = ""), AA.imgs && AA.imgs.length) {
      BA.imgs = [];
      for (let QA = 0; QA < AA.imgs.length; ++QA) BA.imgs[QA] = $root$1.Image.toObject(AA.imgs[QA], IA);
    }
    return AA.link != null && AA.hasOwnProperty("link") && (BA.link = AA.link), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ImageList";
  }, CA;
})();
$root$1.Json = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.body = "", CA.prototype.expanded = !1, CA.prototype.maxExpandDepth = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_maxExpandDepth", { get: $util$1.oneOfGetter(gA = ["maxExpandDepth"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.body != null && Object.hasOwnProperty.call(IA, "body") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.body), IA.expanded != null && Object.hasOwnProperty.call(IA, "expanded") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(IA.expanded), IA.maxExpandDepth != null && Object.hasOwnProperty.call(IA, "maxExpandDepth") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.maxExpandDepth), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Json();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.body = IA.string();
          break;
        }
        case 2: {
          iA.expanded = IA.bool();
          break;
        }
        case 3: {
          iA.maxExpandDepth = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Json) return IA;
    let BA = new $root$1.Json();
    return IA.body != null && (BA.body = String(IA.body)), IA.expanded != null && (BA.expanded = !!IA.expanded), IA.maxExpandDepth != null && (BA.maxExpandDepth = IA.maxExpandDepth | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.body = "", QA.expanded = !1), IA.body != null && IA.hasOwnProperty("body") && (QA.body = IA.body), IA.expanded != null && IA.hasOwnProperty("expanded") && (QA.expanded = IA.expanded), IA.maxExpandDepth != null && IA.hasOwnProperty("maxExpandDepth") && (QA.maxExpandDepth = IA.maxExpandDepth, BA.oneofs && (QA._maxExpandDepth = "maxExpandDepth")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Json";
  }, CA;
})();
$root$1.LinkButton = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.url = "", CA.prototype.disabled = !1, CA.prototype.useContainerWidth = !1, CA.prototype.type = "", CA.prototype.icon = "", CA.prototype.shortcut = "", CA.prototype.iconPosition = 0, CA.prototype.ignoreRerun = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.label), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.help), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.url), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(AA.disabled), AA.useContainerWidth != null && Object.hasOwnProperty.call(AA, "useContainerWidth") && IA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(AA.useContainerWidth), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.type), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.icon), AA.shortcut != null && Object.hasOwnProperty.call(AA, "shortcut") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.shortcut), AA.iconPosition != null && Object.hasOwnProperty.call(AA, "iconPosition") && IA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).int32(AA.iconPosition), AA.ignoreRerun != null && Object.hasOwnProperty.call(AA, "ignoreRerun") && IA.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(AA.ignoreRerun), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.LinkButton();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.id = AA.string();
          break;
        }
        case 2: {
          EA.label = AA.string();
          break;
        }
        case 4: {
          EA.help = AA.string();
          break;
        }
        case 6: {
          EA.url = AA.string();
          break;
        }
        case 7: {
          EA.disabled = AA.bool();
          break;
        }
        case 8: {
          EA.useContainerWidth = AA.bool();
          break;
        }
        case 9: {
          EA.type = AA.string();
          break;
        }
        case 10: {
          EA.icon = AA.string();
          break;
        }
        case 11: {
          EA.shortcut = AA.string();
          break;
        }
        case 12: {
          EA.iconPosition = AA.int32();
          break;
        }
        case 13: {
          EA.ignoreRerun = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.LinkButton) return AA;
    let IA = new $root$1.LinkButton();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.help != null && (IA.help = String(AA.help)), AA.url != null && (IA.url = String(AA.url)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.useContainerWidth != null && (IA.useContainerWidth = !!AA.useContainerWidth), AA.type != null && (IA.type = String(AA.type)), AA.icon != null && (IA.icon = String(AA.icon)), AA.shortcut != null && (IA.shortcut = String(AA.shortcut)), AA.iconPosition) {
      default:
        if (typeof AA.iconPosition == "number") {
          IA.iconPosition = AA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        IA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        IA.iconPosition = 1;
        break;
    }
    return AA.ignoreRerun != null && (IA.ignoreRerun = !!AA.ignoreRerun), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.url = "", BA.disabled = !1, BA.useContainerWidth = !1, BA.type = "", BA.icon = "", BA.shortcut = "", BA.iconPosition = IA.enums === String ? "LEFT" : 0, BA.ignoreRerun = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.useContainerWidth != null && AA.hasOwnProperty("useContainerWidth") && (BA.useContainerWidth = AA.useContainerWidth), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.shortcut != null && AA.hasOwnProperty("shortcut") && (BA.shortcut = AA.shortcut), AA.iconPosition != null && AA.hasOwnProperty("iconPosition") && (BA.iconPosition = IA.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[AA.iconPosition] === void 0 ? AA.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[AA.iconPosition] : AA.iconPosition), AA.ignoreRerun != null && AA.hasOwnProperty("ignoreRerun") && (BA.ignoreRerun = AA.ignoreRerun), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/LinkButton";
  }, CA;
})();
const Markdown$3 = $root$1.Markdown = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.allowHtml = !1, CA.prototype.elementType = 0, CA.prototype.help = "", CA.prototype.unterminatedParsing = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.body), AA.allowHtml != null && Object.hasOwnProperty.call(AA, "allowHtml") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(AA.allowHtml), AA.elementType != null && Object.hasOwnProperty.call(AA, "elementType") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(AA.elementType), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.help), AA.unterminatedParsing != null && Object.hasOwnProperty.call(AA, "unterminatedParsing") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.unterminatedParsing), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Markdown();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.body = AA.string();
          break;
        }
        case 2: {
          EA.allowHtml = AA.bool();
          break;
        }
        case 4: {
          EA.elementType = AA.int32();
          break;
        }
        case 5: {
          EA.help = AA.string();
          break;
        }
        case 6: {
          EA.unterminatedParsing = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Markdown) return AA;
    let IA = new $root$1.Markdown();
    switch (AA.body != null && (IA.body = String(AA.body)), AA.allowHtml != null && (IA.allowHtml = !!AA.allowHtml), AA.elementType) {
      default:
        if (typeof AA.elementType == "number") {
          IA.elementType = AA.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        IA.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        IA.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        IA.elementType = 2;
        break;
      case "CODE":
      case 3:
        IA.elementType = 3;
        break;
      case "LATEX":
      case 4:
        IA.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        IA.elementType = 5;
        break;
    }
    return AA.help != null && (IA.help = String(AA.help)), AA.unterminatedParsing != null && (IA.unterminatedParsing = !!AA.unterminatedParsing), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.body = "", BA.allowHtml = !1, BA.elementType = IA.enums === String ? "UNSPECIFIED" : 0, BA.help = "", BA.unterminatedParsing = !1), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.allowHtml != null && AA.hasOwnProperty("allowHtml") && (BA.allowHtml = AA.allowHtml), AA.elementType != null && AA.hasOwnProperty("elementType") && (BA.elementType = IA.enums === String ? $root$1.Markdown.Type[AA.elementType] === void 0 ? AA.elementType : $root$1.Markdown.Type[AA.elementType] : AA.elementType), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.unterminatedParsing != null && AA.hasOwnProperty("unterminatedParsing") && (BA.unterminatedParsing = AA.unterminatedParsing), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Markdown";
  }, CA.Type = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNSPECIFIED"] = 0, AA[gA[1] = "NATIVE"] = 1, AA[gA[2] = "CAPTION"] = 2, AA[gA[3] = "CODE"] = 3, AA[gA[4] = "LATEX"] = 4, AA[gA[5] = "DIVIDER"] = 5, AA;
  })(), CA;
})();
$root$1.MenuButton = (() => {
  function CA(gA) {
    if (this.options = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.options = $util$1.emptyArray, CA.prototype.help = "", CA.prototype.type = "", CA.prototype.disabled = !1, CA.prototype.icon = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.label), AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.options[BA]);
    return AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.help), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.type), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.disabled), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.icon), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.MenuButton();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.id = AA.string();
          break;
        }
        case 2: {
          EA.label = AA.string();
          break;
        }
        case 3: {
          EA.options && EA.options.length || (EA.options = []), EA.options.push(AA.string());
          break;
        }
        case 4: {
          EA.help = AA.string();
          break;
        }
        case 5: {
          EA.type = AA.string();
          break;
        }
        case 6: {
          EA.disabled = AA.bool();
          break;
        }
        case 7: {
          EA.icon = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.MenuButton) return AA;
    let IA = new $root$1.MenuButton();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".MenuButton.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) IA.options[BA] = String(AA.options[BA]);
    }
    return AA.help != null && (IA.help = String(AA.help)), AA.type != null && (IA.type = String(AA.type)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.icon != null && (IA.icon = String(AA.icon)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.options = []), IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.type = "", BA.disabled = !1, BA.icon = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = AA.options[QA];
    }
    return AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/MenuButton";
  }, CA;
})();
const Metric$1 = $root$1.Metric = (() => {
  function CA(gA) {
    if (this.chartData = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.label = "", CA.prototype.body = "", CA.prototype.delta = "", CA.prototype.direction = 0, CA.prototype.color = 0, CA.prototype.help = "", CA.prototype.labelVisibility = null, CA.prototype.showBorder = !1, CA.prototype.chartData = $util$1.emptyArray, CA.prototype.chartType = 0, CA.prototype.format = "", CA.prototype.deltaDescription = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.label), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.body), AA.delta != null && Object.hasOwnProperty.call(AA, "delta") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.delta), AA.direction != null && Object.hasOwnProperty.call(AA, "direction") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(AA.direction), AA.color != null && Object.hasOwnProperty.call(AA, "color") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(AA.color), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.help), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root$1.LabelVisibility.encode(AA.labelVisibility, IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), AA.showBorder != null && Object.hasOwnProperty.call(AA, "showBorder") && IA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(AA.showBorder), AA.chartData != null && AA.chartData.length) {
      IA.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let BA = 0; BA < AA.chartData.length; ++BA) IA.double(AA.chartData[BA]);
      IA.ldelim();
    }
    return AA.chartType != null && Object.hasOwnProperty.call(AA, "chartType") && IA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(AA.chartType), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.format), AA.deltaDescription != null && Object.hasOwnProperty.call(AA, "deltaDescription") && IA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(AA.deltaDescription), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Metric();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.label = AA.string();
          break;
        }
        case 2: {
          EA.body = AA.string();
          break;
        }
        case 3: {
          EA.delta = AA.string();
          break;
        }
        case 4: {
          EA.direction = AA.int32();
          break;
        }
        case 5: {
          EA.color = AA.int32();
          break;
        }
        case 6: {
          EA.help = AA.string();
          break;
        }
        case 7: {
          EA.labelVisibility = $root$1.LabelVisibility.decode(AA, AA.uint32());
          break;
        }
        case 8: {
          EA.showBorder = AA.bool();
          break;
        }
        case 9: {
          if (EA.chartData && EA.chartData.length || (EA.chartData = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.chartData.push(AA.double());
          } else EA.chartData.push(AA.double());
          break;
        }
        case 10: {
          EA.chartType = AA.int32();
          break;
        }
        case 11: {
          EA.format = AA.string();
          break;
        }
        case 12: {
          EA.deltaDescription = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Metric) return AA;
    let IA = new $root$1.Metric();
    switch (AA.label != null && (IA.label = String(AA.label)), AA.body != null && (IA.body = String(AA.body)), AA.delta != null && (IA.delta = String(AA.delta)), AA.direction) {
      default:
        if (typeof AA.direction == "number") {
          IA.direction = AA.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        IA.direction = 0;
        break;
      case "UP":
      case 1:
        IA.direction = 1;
        break;
      case "NONE":
      case 2:
        IA.direction = 2;
        break;
    }
    switch (AA.color) {
      default:
        if (typeof AA.color == "number") {
          IA.color = AA.color;
          break;
        }
        break;
      case "RED":
      case 0:
        IA.color = 0;
        break;
      case "GREEN":
      case 1:
        IA.color = 1;
        break;
      case "GRAY":
      case 2:
        IA.color = 2;
        break;
      case "ORANGE":
      case 3:
        IA.color = 3;
        break;
      case "YELLOW":
      case 4:
        IA.color = 4;
        break;
      case "BLUE":
      case 5:
        IA.color = 5;
        break;
      case "VIOLET":
      case 6:
        IA.color = 6;
        break;
      case "PRIMARY":
      case 7:
        IA.color = 7;
        break;
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      IA.labelVisibility = $root$1.LabelVisibility.fromObject(AA.labelVisibility);
    }
    if (AA.showBorder != null && (IA.showBorder = !!AA.showBorder), AA.chartData) {
      if (!Array.isArray(AA.chartData)) throw TypeError(".Metric.chartData: array expected");
      IA.chartData = [];
      for (let BA = 0; BA < AA.chartData.length; ++BA) IA.chartData[BA] = Number(AA.chartData[BA]);
    }
    switch (AA.chartType) {
      default:
        if (typeof AA.chartType == "number") {
          IA.chartType = AA.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        IA.chartType = 0;
        break;
      case "BAR":
      case 1:
        IA.chartType = 1;
        break;
      case "AREA":
      case 2:
        IA.chartType = 2;
        break;
    }
    return AA.format != null && (IA.format = String(AA.format)), AA.deltaDescription != null && (IA.deltaDescription = String(AA.deltaDescription)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.chartData = []), IA.defaults && (BA.label = "", BA.body = "", BA.delta = "", BA.direction = IA.enums === String ? "DOWN" : 0, BA.color = IA.enums === String ? "RED" : 0, BA.help = "", BA.labelVisibility = null, BA.showBorder = !1, BA.chartType = IA.enums === String ? "LINE" : 0, BA.format = "", BA.deltaDescription = ""), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.delta != null && AA.hasOwnProperty("delta") && (BA.delta = AA.delta), AA.direction != null && AA.hasOwnProperty("direction") && (BA.direction = IA.enums === String ? $root$1.Metric.MetricDirection[AA.direction] === void 0 ? AA.direction : $root$1.Metric.MetricDirection[AA.direction] : AA.direction), AA.color != null && AA.hasOwnProperty("color") && (BA.color = IA.enums === String ? $root$1.Metric.MetricColor[AA.color] === void 0 ? AA.color : $root$1.Metric.MetricColor[AA.color] : AA.color), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root$1.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.showBorder != null && AA.hasOwnProperty("showBorder") && (BA.showBorder = AA.showBorder), AA.chartData && AA.chartData.length) {
      BA.chartData = [];
      for (let QA = 0; QA < AA.chartData.length; ++QA) BA.chartData[QA] = IA.json && !isFinite(AA.chartData[QA]) ? String(AA.chartData[QA]) : AA.chartData[QA];
    }
    return AA.chartType != null && AA.hasOwnProperty("chartType") && (BA.chartType = IA.enums === String ? $root$1.Metric.ChartType[AA.chartType] === void 0 ? AA.chartType : $root$1.Metric.ChartType[AA.chartType] : AA.chartType), AA.format != null && AA.hasOwnProperty("format") && (BA.format = AA.format), AA.deltaDescription != null && AA.hasOwnProperty("deltaDescription") && (BA.deltaDescription = AA.deltaDescription), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Metric";
  }, CA.MetricDirection = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "DOWN"] = 0, AA[gA[1] = "UP"] = 1, AA[gA[2] = "NONE"] = 2, AA;
  })(), CA.MetricColor = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "RED"] = 0, AA[gA[1] = "GREEN"] = 1, AA[gA[2] = "GRAY"] = 2, AA[gA[3] = "ORANGE"] = 3, AA[gA[4] = "YELLOW"] = 4, AA[gA[5] = "BLUE"] = 5, AA[gA[6] = "VIOLET"] = 6, AA[gA[7] = "PRIMARY"] = 7, AA;
  })(), CA.ChartType = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "LINE"] = 0, AA[gA[1] = "BAR"] = 1, AA[gA[2] = "AREA"] = 2, AA;
  })(), CA;
})();
$root$1.MultiSelect = (() => {
  function CA(AA) {
    if (this.default = [], this.options = [], this.rawValues = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util$1.emptyArray, CA.prototype.options = $util$1.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValues = $util$1.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.maxSelections = 0, CA.prototype.placeholder = "", CA.prototype.acceptNewOptions = null, CA.prototype.queryParamKey = null, CA.prototype.filterMode = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(gA = ["acceptNewOptions"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && IA.default.length) {
      BA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let QA = 0; QA < IA.default.length; ++QA) BA.int32(IA.default[QA]);
      BA.ldelim();
    }
    if (IA.options != null && IA.options.length) for (let QA = 0; QA < IA.options.length; ++QA) BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.options[QA]);
    if (IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), IA.maxSelections != null && Object.hasOwnProperty.call(IA, "maxSelections") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(IA.maxSelections), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.placeholder), IA.acceptNewOptions != null && Object.hasOwnProperty.call(IA, "acceptNewOptions") && BA.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(IA.acceptNewOptions), IA.rawValues != null && IA.rawValues.length) for (let QA = 0; QA < IA.rawValues.length; ++QA) BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.rawValues[QA]);
    return IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(IA.queryParamKey), IA.filterMode != null && Object.hasOwnProperty.call(IA, "filterMode") && BA.uint32(
      /* id 16, wireType 0 =*/
      128
    ).int32(IA.filterMode), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.MultiSelect();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          if (iA.default && iA.default.length || (iA.default = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.default.push(IA.int32());
          } else iA.default.push(IA.int32());
          break;
        }
        case 4: {
          iA.options && iA.options.length || (iA.options = []), iA.options.push(IA.string());
          break;
        }
        case 5: {
          iA.help = IA.string();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 14: {
          iA.rawValues && iA.rawValues.length || (iA.rawValues = []), iA.rawValues.push(IA.string());
          break;
        }
        case 8: {
          iA.setValue = IA.bool();
          break;
        }
        case 9: {
          iA.disabled = IA.bool();
          break;
        }
        case 10: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 11: {
          iA.maxSelections = IA.int32();
          break;
        }
        case 12: {
          iA.placeholder = IA.string();
          break;
        }
        case 13: {
          iA.acceptNewOptions = IA.bool();
          break;
        }
        case 15: {
          iA.queryParamKey = IA.string();
          break;
        }
        case 16: {
          iA.filterMode = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.MultiSelect) return IA;
    let BA = new $root$1.MultiSelect();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default) {
      if (!Array.isArray(IA.default)) throw TypeError(".MultiSelect.default: array expected");
      BA.default = [];
      for (let QA = 0; QA < IA.default.length; ++QA) BA.default[QA] = IA.default[QA] | 0;
    }
    if (IA.options) {
      if (!Array.isArray(IA.options)) throw TypeError(".MultiSelect.options: array expected");
      BA.options = [];
      for (let QA = 0; QA < IA.options.length; ++QA) BA.options[QA] = String(IA.options[QA]);
    }
    if (IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.rawValues) {
      if (!Array.isArray(IA.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      BA.rawValues = [];
      for (let QA = 0; QA < IA.rawValues.length; ++QA) BA.rawValues[QA] = String(IA.rawValues[QA]);
    }
    if (IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    switch (IA.maxSelections != null && (BA.maxSelections = IA.maxSelections | 0), IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.acceptNewOptions != null && (BA.acceptNewOptions = !!IA.acceptNewOptions), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), IA.filterMode) {
      default:
        if (typeof IA.filterMode == "number") {
          BA.filterMode = IA.filterMode;
          break;
        }
        break;
      case "FILTER_MODE_FUZZY":
      case 0:
        BA.filterMode = 0;
        break;
      case "FILTER_MODE_CONTAINS":
      case 1:
        BA.filterMode = 1;
        break;
      case "FILTER_MODE_PREFIX":
      case 2:
        BA.filterMode = 2;
        break;
      case "FILTER_MODE_NONE":
      case 3:
        BA.filterMode = 3;
        break;
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.default = [], QA.options = [], QA.rawValues = []), BA.defaults && (QA.id = "", QA.label = "", QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.maxSelections = 0, QA.placeholder = "", QA.filterMode = BA.enums === String ? "FILTER_MODE_FUZZY" : 0), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default && IA.default.length) {
      QA.default = [];
      for (let EA = 0; EA < IA.default.length; ++EA) QA.default[EA] = IA.default[EA];
    }
    if (IA.options && IA.options.length) {
      QA.options = [];
      for (let EA = 0; EA < IA.options.length; ++EA) QA.options[EA] = IA.options[EA];
    }
    if (IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.maxSelections != null && IA.hasOwnProperty("maxSelections") && (QA.maxSelections = IA.maxSelections), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.acceptNewOptions != null && IA.hasOwnProperty("acceptNewOptions") && (QA.acceptNewOptions = IA.acceptNewOptions, BA.oneofs && (QA._acceptNewOptions = "acceptNewOptions")), IA.rawValues && IA.rawValues.length) {
      QA.rawValues = [];
      for (let EA = 0; EA < IA.rawValues.length; ++EA) QA.rawValues[EA] = IA.rawValues[EA];
    }
    return IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), IA.filterMode != null && IA.hasOwnProperty("filterMode") && (QA.filterMode = BA.enums === String ? $root$1.streamlit.SelectWidgetFilterMode[IA.filterMode] === void 0 ? IA.filterMode : $root$1.streamlit.SelectWidgetFilterMode[IA.filterMode] : IA.filterMode), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/MultiSelect";
  }, CA;
})();
const NumberInput$1 = $root$1.NumberInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.formId = "", CA.prototype.format = "", CA.prototype.hasMin = !1, CA.prototype.hasMax = !1, CA.prototype.dataType = 0, CA.prototype.default = null, CA.prototype.step = 0, CA.prototype.min = 0, CA.prototype.max = 0, CA.prototype.help = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.placeholder = "", CA.prototype.icon = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util$1.oneOfGetter(gA = ["value"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.formId), IA.format != null && Object.hasOwnProperty.call(IA, "format") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.format), IA.hasMin != null && Object.hasOwnProperty.call(IA, "hasMin") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.hasMin), IA.hasMax != null && Object.hasOwnProperty.call(IA, "hasMax") && BA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(IA.hasMax), IA.dataType != null && Object.hasOwnProperty.call(IA, "dataType") && BA.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(IA.dataType), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(IA.default), IA.step != null && Object.hasOwnProperty.call(IA, "step") && BA.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(IA.step), IA.min != null && Object.hasOwnProperty.call(IA, "min") && BA.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(IA.min), IA.max != null && Object.hasOwnProperty.call(IA, "max") && BA.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(IA.max), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(IA.help), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(IA.placeholder), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(IA.icon), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.NumberInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.formId = IA.string();
          break;
        }
        case 8: {
          iA.format = IA.string();
          break;
        }
        case 11: {
          iA.hasMin = IA.bool();
          break;
        }
        case 12: {
          iA.hasMax = IA.bool();
          break;
        }
        case 13: {
          iA.dataType = IA.int32();
          break;
        }
        case 14: {
          iA.default = IA.double();
          break;
        }
        case 15: {
          iA.step = IA.double();
          break;
        }
        case 16: {
          iA.min = IA.double();
          break;
        }
        case 17: {
          iA.max = IA.double();
          break;
        }
        case 18: {
          iA.help = IA.string();
          break;
        }
        case 19: {
          iA.value = IA.double();
          break;
        }
        case 20: {
          iA.setValue = IA.bool();
          break;
        }
        case 21: {
          iA.disabled = IA.bool();
          break;
        }
        case 22: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 23: {
          iA.placeholder = IA.string();
          break;
        }
        case 24: {
          iA.icon = IA.string();
          break;
        }
        case 25: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.NumberInput) return IA;
    let BA = new $root$1.NumberInput();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.formId != null && (BA.formId = String(IA.formId)), IA.format != null && (BA.format = String(IA.format)), IA.hasMin != null && (BA.hasMin = !!IA.hasMin), IA.hasMax != null && (BA.hasMax = !!IA.hasMax), IA.dataType) {
      default:
        if (typeof IA.dataType == "number") {
          BA.dataType = IA.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        BA.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        BA.dataType = 1;
        break;
    }
    if (IA.default != null && (BA.default = Number(IA.default)), IA.step != null && (BA.step = Number(IA.step)), IA.min != null && (BA.min = Number(IA.min)), IA.max != null && (BA.max = Number(IA.max)), IA.help != null && (BA.help = String(IA.help)), IA.value != null && (BA.value = Number(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.icon != null && (BA.icon = String(IA.icon)), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.formId = "", QA.format = "", QA.hasMin = !1, QA.hasMax = !1, QA.dataType = BA.enums === String ? "INT" : 0, QA.step = 0, QA.min = 0, QA.max = 0, QA.help = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.placeholder = "", QA.icon = ""), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.format != null && IA.hasOwnProperty("format") && (QA.format = IA.format), IA.hasMin != null && IA.hasOwnProperty("hasMin") && (QA.hasMin = IA.hasMin), IA.hasMax != null && IA.hasOwnProperty("hasMax") && (QA.hasMax = IA.hasMax), IA.dataType != null && IA.hasOwnProperty("dataType") && (QA.dataType = BA.enums === String ? $root$1.NumberInput.DataType[IA.dataType] === void 0 ? IA.dataType : $root$1.NumberInput.DataType[IA.dataType] : IA.dataType), IA.default != null && IA.hasOwnProperty("default") && (QA.default = BA.json && !isFinite(IA.default) ? String(IA.default) : IA.default, BA.oneofs && (QA._default = "default")), IA.step != null && IA.hasOwnProperty("step") && (QA.step = BA.json && !isFinite(IA.step) ? String(IA.step) : IA.step), IA.min != null && IA.hasOwnProperty("min") && (QA.min = BA.json && !isFinite(IA.min) ? String(IA.min) : IA.min), IA.max != null && IA.hasOwnProperty("max") && (QA.max = BA.json && !isFinite(IA.max) ? String(IA.max) : IA.max), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.value != null && IA.hasOwnProperty("value") && (QA.value = BA.json && !isFinite(IA.value) ? String(IA.value) : IA.value, BA.oneofs && (QA._value = "value")), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/NumberInput";
  }, CA.DataType = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "INT"] = 0, IA[AA[1] = "FLOAT"] = 1, IA;
  })(), CA;
})();
$root$1.PageLink = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.page = "", CA.prototype.label = "", CA.prototype.icon = "", CA.prototype.pageScriptHash = "", CA.prototype.help = "", CA.prototype.useContainerWidth = null, CA.prototype.disabled = !1, CA.prototype.external = !1, CA.prototype.queryString = "", CA.prototype.iconPosition = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_useContainerWidth", { get: $util$1.oneOfGetter(gA = ["useContainerWidth"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.page != null && Object.hasOwnProperty.call(IA, "page") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.page), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.icon), IA.pageScriptHash != null && Object.hasOwnProperty.call(IA, "pageScriptHash") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.pageScriptHash), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.help), IA.useContainerWidth != null && Object.hasOwnProperty.call(IA, "useContainerWidth") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(IA.useContainerWidth), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.disabled), IA.external != null && Object.hasOwnProperty.call(IA, "external") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.external), IA.queryString != null && Object.hasOwnProperty.call(IA, "queryString") && BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(IA.queryString), IA.iconPosition != null && Object.hasOwnProperty.call(IA, "iconPosition") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(IA.iconPosition), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.PageLink();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.page = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.icon = IA.string();
          break;
        }
        case 4: {
          iA.pageScriptHash = IA.string();
          break;
        }
        case 5: {
          iA.help = IA.string();
          break;
        }
        case 6: {
          iA.useContainerWidth = IA.bool();
          break;
        }
        case 7: {
          iA.disabled = IA.bool();
          break;
        }
        case 8: {
          iA.external = IA.bool();
          break;
        }
        case 9: {
          iA.queryString = IA.string();
          break;
        }
        case 10: {
          iA.iconPosition = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.PageLink) return IA;
    let BA = new $root$1.PageLink();
    switch (IA.page != null && (BA.page = String(IA.page)), IA.label != null && (BA.label = String(IA.label)), IA.icon != null && (BA.icon = String(IA.icon)), IA.pageScriptHash != null && (BA.pageScriptHash = String(IA.pageScriptHash)), IA.help != null && (BA.help = String(IA.help)), IA.useContainerWidth != null && (BA.useContainerWidth = !!IA.useContainerWidth), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.external != null && (BA.external = !!IA.external), IA.queryString != null && (BA.queryString = String(IA.queryString)), IA.iconPosition) {
      default:
        if (typeof IA.iconPosition == "number") {
          BA.iconPosition = IA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        BA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        BA.iconPosition = 1;
        break;
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.page = "", QA.label = "", QA.icon = "", QA.pageScriptHash = "", QA.help = "", QA.disabled = !1, QA.external = !1, QA.queryString = "", QA.iconPosition = BA.enums === String ? "LEFT" : 0), IA.page != null && IA.hasOwnProperty("page") && (QA.page = IA.page), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.pageScriptHash != null && IA.hasOwnProperty("pageScriptHash") && (QA.pageScriptHash = IA.pageScriptHash), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.useContainerWidth != null && IA.hasOwnProperty("useContainerWidth") && (QA.useContainerWidth = IA.useContainerWidth, BA.oneofs && (QA._useContainerWidth = "useContainerWidth")), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.external != null && IA.hasOwnProperty("external") && (QA.external = IA.external), IA.queryString != null && IA.hasOwnProperty("queryString") && (QA.queryString = IA.queryString), IA.iconPosition != null && IA.hasOwnProperty("iconPosition") && (QA.iconPosition = BA.enums === String ? $root$1.streamlit.ButtonLikeIconPosition[IA.iconPosition] === void 0 ? IA.iconPosition : $root$1.streamlit.ButtonLikeIconPosition[IA.iconPosition] : IA.iconPosition), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/PageLink";
  }, CA;
})();
const PlotlyChart$1 = $root$1.PlotlyChart = (() => {
  function CA(gA) {
    if (this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.theme = "", CA.prototype.id = "", CA.prototype.selectionMode = $util$1.emptyArray, CA.prototype.formId = "", CA.prototype.spec = "", CA.prototype.config = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.theme != null && Object.hasOwnProperty.call(AA, "theme") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.theme), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.id), AA.selectionMode != null && AA.selectionMode.length) {
      IA.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) IA.int32(AA.selectionMode[BA]);
      IA.ldelim();
    }
    return AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.formId), AA.spec != null && Object.hasOwnProperty.call(AA, "spec") && IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.spec), AA.config != null && Object.hasOwnProperty.call(AA, "config") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.config), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.PlotlyChart();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 6: {
          EA.theme = AA.string();
          break;
        }
        case 7: {
          EA.id = AA.string();
          break;
        }
        case 8: {
          if (EA.selectionMode && EA.selectionMode.length || (EA.selectionMode = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.selectionMode.push(AA.int32());
          } else EA.selectionMode.push(AA.int32());
          break;
        }
        case 9: {
          EA.formId = AA.string();
          break;
        }
        case 10: {
          EA.spec = AA.string();
          break;
        }
        case 11: {
          EA.config = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.PlotlyChart) return AA;
    let IA = new $root$1.PlotlyChart();
    if (AA.theme != null && (IA.theme = String(AA.theme)), AA.id != null && (IA.id = String(AA.id)), AA.selectionMode) {
      if (!Array.isArray(AA.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      IA.selectionMode = [];
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) switch (AA.selectionMode[BA]) {
        default:
          if (typeof AA.selectionMode[BA] == "number") {
            IA.selectionMode[BA] = AA.selectionMode[BA];
            break;
          }
        case "POINTS":
        case 0:
          IA.selectionMode[BA] = 0;
          break;
        case "BOX":
        case 1:
          IA.selectionMode[BA] = 1;
          break;
        case "LASSO":
        case 2:
          IA.selectionMode[BA] = 2;
          break;
      }
    }
    return AA.formId != null && (IA.formId = String(AA.formId)), AA.spec != null && (IA.spec = String(AA.spec)), AA.config != null && (IA.config = String(AA.config)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.selectionMode = []), IA.defaults && (BA.theme = "", BA.id = "", BA.formId = "", BA.spec = "", BA.config = ""), AA.theme != null && AA.hasOwnProperty("theme") && (BA.theme = AA.theme), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.selectionMode && AA.selectionMode.length) {
      BA.selectionMode = [];
      for (let QA = 0; QA < AA.selectionMode.length; ++QA) BA.selectionMode[QA] = IA.enums === String ? $root$1.PlotlyChart.SelectionMode[AA.selectionMode[QA]] === void 0 ? AA.selectionMode[QA] : $root$1.PlotlyChart.SelectionMode[AA.selectionMode[QA]] : AA.selectionMode[QA];
    }
    return AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.spec != null && AA.hasOwnProperty("spec") && (BA.spec = AA.spec), AA.config != null && AA.hasOwnProperty("config") && (BA.config = AA.config), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PlotlyChart";
  }, CA.SelectionMode = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "POINTS"] = 0, AA[gA[1] = "BOX"] = 1, AA[gA[2] = "LASSO"] = 2, AA;
  })(), CA;
})();
$root$1.Progress = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.value = 0, CA.prototype.text = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(AA.value), AA.text != null && Object.hasOwnProperty.call(AA, "text") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.text), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Progress();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.value = AA.uint32();
          break;
        }
        case 2: {
          EA.text = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Progress) return AA;
    let IA = new $root$1.Progress();
    return AA.value != null && (IA.value = AA.value >>> 0), AA.text != null && (IA.text = String(AA.text)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.value = 0, BA.text = ""), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), AA.text != null && AA.hasOwnProperty("text") && (BA.text = AA.text), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Progress";
  }, CA;
})();
$root$1.Radio = (() => {
  function CA(AA) {
    if (this.options = [], this.captions = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.options = $util$1.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValue = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.horizontal = !1, CA.prototype.labelVisibility = null, CA.prototype.captions = $util$1.emptyArray, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_rawValue", { get: $util$1.oneOfGetter(gA = ["rawValue"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.default), IA.options != null && IA.options.length) for (let QA = 0; QA < IA.options.length; ++QA) BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.options[QA]);
    if (IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.disabled), IA.horizontal != null && Object.hasOwnProperty.call(IA, "horizontal") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(IA.horizontal), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), IA.captions != null && IA.captions.length) for (let QA = 0; QA < IA.captions.length; ++QA) BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.captions[QA]);
    return IA.rawValue != null && Object.hasOwnProperty.call(IA, "rawValue") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.rawValue), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Radio();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.int32();
          break;
        }
        case 4: {
          iA.options && iA.options.length || (iA.options = []), iA.options.push(IA.string());
          break;
        }
        case 5: {
          iA.help = IA.string();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 13: {
          iA.rawValue = IA.string();
          break;
        }
        case 8: {
          iA.setValue = IA.bool();
          break;
        }
        case 9: {
          iA.disabled = IA.bool();
          break;
        }
        case 10: {
          iA.horizontal = IA.bool();
          break;
        }
        case 11: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.captions && iA.captions.length || (iA.captions = []), iA.captions.push(IA.string());
          break;
        }
        case 14: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Radio) return IA;
    let BA = new $root$1.Radio();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = IA.default | 0), IA.options) {
      if (!Array.isArray(IA.options)) throw TypeError(".Radio.options: array expected");
      BA.options = [];
      for (let QA = 0; QA < IA.options.length; ++QA) BA.options[QA] = String(IA.options[QA]);
    }
    if (IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.rawValue != null && (BA.rawValue = String(IA.rawValue)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.horizontal != null && (BA.horizontal = !!IA.horizontal), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    if (IA.captions) {
      if (!Array.isArray(IA.captions)) throw TypeError(".Radio.captions: array expected");
      BA.captions = [];
      for (let QA = 0; QA < IA.captions.length; ++QA) BA.captions[QA] = String(IA.captions[QA]);
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.options = [], QA.captions = []), BA.defaults && (QA.id = "", QA.label = "", QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.horizontal = !1, QA.labelVisibility = null), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.options && IA.options.length) {
      QA.options = [];
      for (let EA = 0; EA < IA.options.length; ++EA) QA.options[EA] = IA.options[EA];
    }
    if (IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.horizontal != null && IA.hasOwnProperty("horizontal") && (QA.horizontal = IA.horizontal), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.captions && IA.captions.length) {
      QA.captions = [];
      for (let EA = 0; EA < IA.captions.length; ++EA) QA.captions[EA] = IA.captions[EA];
    }
    return IA.rawValue != null && IA.hasOwnProperty("rawValue") && (QA.rawValue = IA.rawValue, BA.oneofs && (QA._rawValue = "rawValue")), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Radio";
  }, CA;
})();
$root$1.Selectbox = (() => {
  function CA(AA) {
    if (this.options = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.options = $util$1.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValue = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.placeholder = "", CA.prototype.acceptNewOptions = null, CA.prototype.queryParamKey = null, CA.prototype.filterMode = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_rawValue", { get: $util$1.oneOfGetter(gA = ["rawValue"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_acceptNewOptions", { get: $util$1.oneOfGetter(gA = ["acceptNewOptions"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.default), IA.options != null && IA.options.length) for (let QA = 0; QA < IA.options.length; ++QA) BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.options[QA]);
    return IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.formId), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.placeholder), IA.acceptNewOptions != null && Object.hasOwnProperty.call(IA, "acceptNewOptions") && BA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(IA.acceptNewOptions), IA.rawValue != null && Object.hasOwnProperty.call(IA, "rawValue") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.rawValue), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.queryParamKey), IA.filterMode != null && Object.hasOwnProperty.call(IA, "filterMode") && BA.uint32(
      /* id 15, wireType 0 =*/
      120
    ).int32(IA.filterMode), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Selectbox();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.int32();
          break;
        }
        case 4: {
          iA.options && iA.options.length || (iA.options = []), iA.options.push(IA.string());
          break;
        }
        case 5: {
          iA.help = IA.string();
          break;
        }
        case 6: {
          iA.formId = IA.string();
          break;
        }
        case 13: {
          iA.rawValue = IA.string();
          break;
        }
        case 8: {
          iA.setValue = IA.bool();
          break;
        }
        case 9: {
          iA.disabled = IA.bool();
          break;
        }
        case 10: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 11: {
          iA.placeholder = IA.string();
          break;
        }
        case 12: {
          iA.acceptNewOptions = IA.bool();
          break;
        }
        case 14: {
          iA.queryParamKey = IA.string();
          break;
        }
        case 15: {
          iA.filterMode = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Selectbox) return IA;
    let BA = new $root$1.Selectbox();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = IA.default | 0), IA.options) {
      if (!Array.isArray(IA.options)) throw TypeError(".Selectbox.options: array expected");
      BA.options = [];
      for (let QA = 0; QA < IA.options.length; ++QA) BA.options[QA] = String(IA.options[QA]);
    }
    if (IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.rawValue != null && (BA.rawValue = String(IA.rawValue)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    switch (IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.acceptNewOptions != null && (BA.acceptNewOptions = !!IA.acceptNewOptions), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), IA.filterMode) {
      default:
        if (typeof IA.filterMode == "number") {
          BA.filterMode = IA.filterMode;
          break;
        }
        break;
      case "FILTER_MODE_FUZZY":
      case 0:
        BA.filterMode = 0;
        break;
      case "FILTER_MODE_CONTAINS":
      case 1:
        BA.filterMode = 1;
        break;
      case "FILTER_MODE_PREFIX":
      case 2:
        BA.filterMode = 2;
        break;
      case "FILTER_MODE_NONE":
      case 3:
        BA.filterMode = 3;
        break;
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.options = []), BA.defaults && (QA.id = "", QA.label = "", QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, QA.placeholder = "", QA.filterMode = BA.enums === String ? "FILTER_MODE_FUZZY" : 0), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.options && IA.options.length) {
      QA.options = [];
      for (let EA = 0; EA < IA.options.length; ++EA) QA.options[EA] = IA.options[EA];
    }
    return IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.acceptNewOptions != null && IA.hasOwnProperty("acceptNewOptions") && (QA.acceptNewOptions = IA.acceptNewOptions, BA.oneofs && (QA._acceptNewOptions = "acceptNewOptions")), IA.rawValue != null && IA.hasOwnProperty("rawValue") && (QA.rawValue = IA.rawValue, BA.oneofs && (QA._rawValue = "rawValue")), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), IA.filterMode != null && IA.hasOwnProperty("filterMode") && (QA.filterMode = BA.enums === String ? $root$1.streamlit.SelectWidgetFilterMode[IA.filterMode] === void 0 ? IA.filterMode : $root$1.streamlit.SelectWidgetFilterMode[IA.filterMode] : IA.filterMode), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Selectbox";
  }, CA;
})();
const Skeleton$1 = $root$1.Skeleton = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.style = 0, CA.prototype.height = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_height", { get: $util$1.oneOfGetter(gA = ["height"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.style != null && Object.hasOwnProperty.call(IA, "style") && BA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(IA.style), IA.height != null && Object.hasOwnProperty.call(IA, "height") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(IA.height), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Skeleton();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.style = IA.int32();
          break;
        }
        case 2: {
          iA.height = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Skeleton) return IA;
    let BA = new $root$1.Skeleton();
    switch (IA.style) {
      default:
        if (typeof IA.style == "number") {
          BA.style = IA.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        BA.style = 0;
        break;
      case "APP":
      case 1:
        BA.style = 1;
        break;
    }
    return IA.height != null && (BA.height = IA.height | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.style = BA.enums === String ? "ELEMENT" : 0), IA.style != null && IA.hasOwnProperty("style") && (QA.style = BA.enums === String ? $root$1.Skeleton.SkeletonStyle[IA.style] === void 0 ? IA.style : $root$1.Skeleton.SkeletonStyle[IA.style] : IA.style), IA.height != null && IA.hasOwnProperty("height") && (QA.height = IA.height, BA.oneofs && (QA._height = "height")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Skeleton";
  }, CA.SkeletonStyle = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "ELEMENT"] = 0, IA[AA[1] = "APP"] = 1, IA;
  })(), CA;
})(), Slider$1 = $root$1.Slider = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], this.options = [], this.rawValue = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.formId = "", CA.prototype.label = "", CA.prototype.format = "", CA.prototype.dataType = 0, CA.prototype.default = $util$1.emptyArray, CA.prototype.min = 0, CA.prototype.max = 0, CA.prototype.step = 0, CA.prototype.value = $util$1.emptyArray, CA.prototype.setValue = !1, CA.prototype.options = $util$1.emptyArray, CA.prototype.help = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.type = 0, CA.prototype.rawValue = $util$1.emptyArray, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.formId), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.label), IA.format != null && Object.hasOwnProperty.call(IA, "format") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.format), IA.dataType != null && Object.hasOwnProperty.call(IA, "dataType") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(IA.dataType), IA.default != null && IA.default.length) {
      BA.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let QA = 0; QA < IA.default.length; ++QA) BA.double(IA.default[QA]);
      BA.ldelim();
    }
    if (IA.min != null && Object.hasOwnProperty.call(IA, "min") && BA.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(IA.min), IA.max != null && Object.hasOwnProperty.call(IA, "max") && BA.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(IA.max), IA.step != null && Object.hasOwnProperty.call(IA, "step") && BA.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(IA.step), IA.value != null && IA.value.length) {
      BA.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let QA = 0; QA < IA.value.length; ++QA) BA.double(IA.value[QA]);
      BA.ldelim();
    }
    if (IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.setValue), IA.options != null && IA.options.length) for (let QA = 0; QA < IA.options.length; ++QA) BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.options[QA]);
    if (IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.help), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(IA.type), IA.rawValue != null && IA.rawValue.length) for (let QA = 0; QA < IA.rawValue.length; ++QA) BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(IA.rawValue[QA]);
    return IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Slider();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.formId = IA.string();
          break;
        }
        case 3: {
          iA.label = IA.string();
          break;
        }
        case 4: {
          iA.format = IA.string();
          break;
        }
        case 5: {
          iA.dataType = IA.int32();
          break;
        }
        case 6: {
          if (iA.default && iA.default.length || (iA.default = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.default.push(IA.double());
          } else iA.default.push(IA.double());
          break;
        }
        case 7: {
          iA.min = IA.double();
          break;
        }
        case 8: {
          iA.max = IA.double();
          break;
        }
        case 9: {
          iA.step = IA.double();
          break;
        }
        case 10: {
          if (iA.value && iA.value.length || (iA.value = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.value.push(IA.double());
          } else iA.value.push(IA.double());
          break;
        }
        case 11: {
          iA.setValue = IA.bool();
          break;
        }
        case 13: {
          iA.options && iA.options.length || (iA.options = []), iA.options.push(IA.string());
          break;
        }
        case 14: {
          iA.help = IA.string();
          break;
        }
        case 15: {
          iA.disabled = IA.bool();
          break;
        }
        case 16: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 17: {
          iA.type = IA.int32();
          break;
        }
        case 18: {
          iA.rawValue && iA.rawValue.length || (iA.rawValue = []), iA.rawValue.push(IA.string());
          break;
        }
        case 19: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Slider) return IA;
    let BA = new $root$1.Slider();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.formId != null && (BA.formId = String(IA.formId)), IA.label != null && (BA.label = String(IA.label)), IA.format != null && (BA.format = String(IA.format)), IA.dataType) {
      default:
        if (typeof IA.dataType == "number") {
          BA.dataType = IA.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        BA.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        BA.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        BA.dataType = 2;
        break;
      case "DATE":
      case 3:
        BA.dataType = 3;
        break;
      case "TIME":
      case 4:
        BA.dataType = 4;
        break;
    }
    if (IA.default) {
      if (!Array.isArray(IA.default)) throw TypeError(".Slider.default: array expected");
      BA.default = [];
      for (let QA = 0; QA < IA.default.length; ++QA) BA.default[QA] = Number(IA.default[QA]);
    }
    if (IA.min != null && (BA.min = Number(IA.min)), IA.max != null && (BA.max = Number(IA.max)), IA.step != null && (BA.step = Number(IA.step)), IA.value) {
      if (!Array.isArray(IA.value)) throw TypeError(".Slider.value: array expected");
      BA.value = [];
      for (let QA = 0; QA < IA.value.length; ++QA) BA.value[QA] = Number(IA.value[QA]);
    }
    if (IA.setValue != null && (BA.setValue = !!IA.setValue), IA.options) {
      if (!Array.isArray(IA.options)) throw TypeError(".Slider.options: array expected");
      BA.options = [];
      for (let QA = 0; QA < IA.options.length; ++QA) BA.options[QA] = String(IA.options[QA]);
    }
    if (IA.help != null && (BA.help = String(IA.help)), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    switch (IA.type) {
      default:
        if (typeof IA.type == "number") {
          BA.type = IA.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        BA.type = 0;
        break;
      case "SLIDER":
      case 1:
        BA.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        BA.type = 2;
        break;
    }
    if (IA.rawValue) {
      if (!Array.isArray(IA.rawValue)) throw TypeError(".Slider.rawValue: array expected");
      BA.rawValue = [];
      for (let QA = 0; QA < IA.rawValue.length; ++QA) BA.rawValue[QA] = String(IA.rawValue[QA]);
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.default = [], QA.value = [], QA.options = [], QA.rawValue = []), BA.defaults && (QA.id = "", QA.formId = "", QA.label = "", QA.format = "", QA.dataType = BA.enums === String ? "INT" : 0, QA.min = 0, QA.max = 0, QA.step = 0, QA.setValue = !1, QA.help = "", QA.disabled = !1, QA.labelVisibility = null, QA.type = BA.enums === String ? "UNSPECIFIED" : 0), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.format != null && IA.hasOwnProperty("format") && (QA.format = IA.format), IA.dataType != null && IA.hasOwnProperty("dataType") && (QA.dataType = BA.enums === String ? $root$1.Slider.DataType[IA.dataType] === void 0 ? IA.dataType : $root$1.Slider.DataType[IA.dataType] : IA.dataType), IA.default && IA.default.length) {
      QA.default = [];
      for (let EA = 0; EA < IA.default.length; ++EA) QA.default[EA] = BA.json && !isFinite(IA.default[EA]) ? String(IA.default[EA]) : IA.default[EA];
    }
    if (IA.min != null && IA.hasOwnProperty("min") && (QA.min = BA.json && !isFinite(IA.min) ? String(IA.min) : IA.min), IA.max != null && IA.hasOwnProperty("max") && (QA.max = BA.json && !isFinite(IA.max) ? String(IA.max) : IA.max), IA.step != null && IA.hasOwnProperty("step") && (QA.step = BA.json && !isFinite(IA.step) ? String(IA.step) : IA.step), IA.value && IA.value.length) {
      QA.value = [];
      for (let EA = 0; EA < IA.value.length; ++EA) QA.value[EA] = BA.json && !isFinite(IA.value[EA]) ? String(IA.value[EA]) : IA.value[EA];
    }
    if (IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.options && IA.options.length) {
      QA.options = [];
      for (let EA = 0; EA < IA.options.length; ++EA) QA.options[EA] = IA.options[EA];
    }
    if (IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.Slider.Type[IA.type] === void 0 ? IA.type : $root$1.Slider.Type[IA.type] : IA.type), IA.rawValue && IA.rawValue.length) {
      QA.rawValue = [];
      for (let EA = 0; EA < IA.rawValue.length; ++EA) QA.rawValue[EA] = IA.rawValue[EA];
    }
    return IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Slider";
  }, CA.DataType = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "INT"] = 0, IA[AA[1] = "FLOAT"] = 1, IA[AA[2] = "DATETIME"] = 2, IA[AA[3] = "DATE"] = 3, IA[AA[4] = "TIME"] = 4, IA;
  })(), CA.Type = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "UNSPECIFIED"] = 0, IA[AA[1] = "SLIDER"] = 1, IA[AA[2] = "SELECT_SLIDER"] = 2, IA;
  })(), CA;
})();
$root$1.Snow = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.show = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.show != null && Object.hasOwnProperty.call(AA, "show") && IA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(AA.show), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Snow();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.show = AA.bool() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Snow) return AA;
    let IA = new $root$1.Snow();
    return AA.show != null && (IA.show = !!AA.show), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.show = !1), AA.show != null && AA.hasOwnProperty("show") && (BA.show = AA.show), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Snow";
  }, CA;
})();
$root$1.Space = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Space();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    return AA instanceof $root$1.Space ? AA : new $root$1.Space();
  }, CA.toObject = function() {
    return {};
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Space";
  }, CA;
})();
$root$1.Spinner = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.text = "", CA.prototype.cache = !1, CA.prototype.showTime = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.text != null && Object.hasOwnProperty.call(AA, "text") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.text), AA.cache != null && Object.hasOwnProperty.call(AA, "cache") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(AA.cache), AA.showTime != null && Object.hasOwnProperty.call(AA, "showTime") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.showTime), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Spinner();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.text = AA.string();
          break;
        }
        case 2: {
          EA.cache = AA.bool();
          break;
        }
        case 3: {
          EA.showTime = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Spinner) return AA;
    let IA = new $root$1.Spinner();
    return AA.text != null && (IA.text = String(AA.text)), AA.cache != null && (IA.cache = !!AA.cache), AA.showTime != null && (IA.showTime = !!AA.showTime), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.text = "", BA.cache = !1, BA.showTime = !1), AA.text != null && AA.hasOwnProperty("text") && (BA.text = AA.text), AA.cache != null && AA.hasOwnProperty("cache") && (BA.cache = AA.cache), AA.showTime != null && AA.hasOwnProperty("showTime") && (BA.showTime = AA.showTime), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Spinner";
  }, CA;
})();
const Table$3 = $root$1.Table = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.arrowData = null, CA.prototype.borderMode = 0, CA.prototype.hideIndex = !1, CA.prototype.hideHeader = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.arrowData != null && Object.hasOwnProperty.call(AA, "arrowData") && $root$1.ArrowData.encode(AA.arrowData, IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), AA.borderMode != null && Object.hasOwnProperty.call(AA, "borderMode") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(AA.borderMode), AA.hideIndex != null && Object.hasOwnProperty.call(AA, "hideIndex") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(AA.hideIndex), AA.hideHeader != null && Object.hasOwnProperty.call(AA, "hideHeader") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(AA.hideHeader), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Table();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.arrowData = $root$1.ArrowData.decode(AA, AA.uint32());
          break;
        }
        case 2: {
          EA.borderMode = AA.int32();
          break;
        }
        case 3: {
          EA.hideIndex = AA.bool();
          break;
        }
        case 4: {
          EA.hideHeader = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Table) return AA;
    let IA = new $root$1.Table();
    if (AA.arrowData != null) {
      if (typeof AA.arrowData != "object") throw TypeError(".Table.arrowData: object expected");
      IA.arrowData = $root$1.ArrowData.fromObject(AA.arrowData);
    }
    switch (AA.borderMode) {
      default:
        if (typeof AA.borderMode == "number") {
          IA.borderMode = AA.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        IA.borderMode = 0;
        break;
      case "NONE":
      case 1:
        IA.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        IA.borderMode = 2;
        break;
    }
    return AA.hideIndex != null && (IA.hideIndex = !!AA.hideIndex), AA.hideHeader != null && (IA.hideHeader = !!AA.hideHeader), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.arrowData = null, BA.borderMode = IA.enums === String ? "ALL" : 0, BA.hideIndex = !1, BA.hideHeader = !1), AA.arrowData != null && AA.hasOwnProperty("arrowData") && (BA.arrowData = $root$1.ArrowData.toObject(AA.arrowData, IA)), AA.borderMode != null && AA.hasOwnProperty("borderMode") && (BA.borderMode = IA.enums === String ? $root$1.Table.BorderMode[AA.borderMode] === void 0 ? AA.borderMode : $root$1.Table.BorderMode[AA.borderMode] : AA.borderMode), AA.hideIndex != null && AA.hasOwnProperty("hideIndex") && (BA.hideIndex = AA.hideIndex), AA.hideHeader != null && AA.hasOwnProperty("hideHeader") && (BA.hideHeader = AA.hideHeader), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Table";
  }, CA.BorderMode = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "ALL"] = 0, AA[gA[1] = "NONE"] = 1, AA[gA[2] = "HORIZONTAL"] = 2, AA;
  })(), CA;
})();
$root$1.Text = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.help = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.body), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.help), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Text();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.body = AA.string();
          break;
        }
        case 2: {
          EA.help = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Text) return AA;
    let IA = new $root$1.Text();
    return AA.body != null && (IA.body = String(AA.body)), AA.help != null && (IA.help = String(AA.help)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.body = "", BA.help = ""), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Text";
  }, CA;
})();
$root$1.TextArea = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.maxChars = 0, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.placeholder = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util$1.oneOfGetter(gA = ["value"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default), IA.maxChars != null && Object.hasOwnProperty.call(IA, "maxChars") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(IA.maxChars), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.setValue), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.placeholder), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.TextArea();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.string();
          break;
        }
        case 5: {
          iA.maxChars = IA.uint32();
          break;
        }
        case 6: {
          iA.help = IA.string();
          break;
        }
        case 7: {
          iA.formId = IA.string();
          break;
        }
        case 8: {
          iA.value = IA.string();
          break;
        }
        case 9: {
          iA.setValue = IA.bool();
          break;
        }
        case 10: {
          iA.placeholder = IA.string();
          break;
        }
        case 11: {
          iA.disabled = IA.bool();
          break;
        }
        case 12: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.TextArea) return IA;
    let BA = new $root$1.TextArea();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = String(IA.default)), IA.maxChars != null && (BA.maxChars = IA.maxChars >>> 0), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = String(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.maxChars = 0, QA.help = "", QA.formId = "", QA.setValue = !1, QA.placeholder = "", QA.disabled = !1, QA.labelVisibility = null), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.maxChars != null && IA.hasOwnProperty("maxChars") && (QA.maxChars = IA.maxChars), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value, BA.oneofs && (QA._value = "value")), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/TextArea";
  }, CA;
})();
const TextInput$1 = $root$1.TextInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.type = 0, CA.prototype.maxChars = 0, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.autocomplete = "", CA.prototype.placeholder = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.icon = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util$1.oneOfGetter(gA = ["value"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(IA.type), IA.maxChars != null && Object.hasOwnProperty.call(IA, "maxChars") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(IA.maxChars), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.setValue), IA.autocomplete != null && Object.hasOwnProperty.call(IA, "autocomplete") && BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(IA.autocomplete), IA.placeholder != null && Object.hasOwnProperty.call(IA, "placeholder") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.placeholder), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.icon), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.TextInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.string();
          break;
        }
        case 4: {
          iA.type = IA.int32();
          break;
        }
        case 5: {
          iA.maxChars = IA.uint32();
          break;
        }
        case 6: {
          iA.help = IA.string();
          break;
        }
        case 7: {
          iA.formId = IA.string();
          break;
        }
        case 8: {
          iA.value = IA.string();
          break;
        }
        case 9: {
          iA.setValue = IA.bool();
          break;
        }
        case 10: {
          iA.autocomplete = IA.string();
          break;
        }
        case 11: {
          iA.placeholder = IA.string();
          break;
        }
        case 12: {
          iA.disabled = IA.bool();
          break;
        }
        case 13: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 14: {
          iA.icon = IA.string();
          break;
        }
        case 15: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.TextInput) return IA;
    let BA = new $root$1.TextInput();
    switch (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = String(IA.default)), IA.type) {
      default:
        if (typeof IA.type == "number") {
          BA.type = IA.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        BA.type = 0;
        break;
      case "PASSWORD":
      case 1:
        BA.type = 1;
        break;
    }
    if (IA.maxChars != null && (BA.maxChars = IA.maxChars >>> 0), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = String(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.autocomplete != null && (BA.autocomplete = String(IA.autocomplete)), IA.placeholder != null && (BA.placeholder = String(IA.placeholder)), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.icon != null && (BA.icon = String(IA.icon)), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.id = "", QA.label = "", QA.type = BA.enums === String ? "DEFAULT" : 0, QA.maxChars = 0, QA.help = "", QA.formId = "", QA.setValue = !1, QA.autocomplete = "", QA.placeholder = "", QA.disabled = !1, QA.labelVisibility = null, QA.icon = ""), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.TextInput.Type[IA.type] === void 0 ? IA.type : $root$1.TextInput.Type[IA.type] : IA.type), IA.maxChars != null && IA.hasOwnProperty("maxChars") && (QA.maxChars = IA.maxChars), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value, BA.oneofs && (QA._value = "value")), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.autocomplete != null && IA.hasOwnProperty("autocomplete") && (QA.autocomplete = IA.autocomplete), IA.placeholder != null && IA.hasOwnProperty("placeholder") && (QA.placeholder = IA.placeholder), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/TextInput";
  }, CA.Type = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "DEFAULT"] = 0, IA[AA[1] = "PASSWORD"] = 1, IA;
  })(), CA;
})();
$root$1.TimeInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.step = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util$1.oneOfGetter(gA = ["default"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util$1.oneOfGetter(gA = ["value"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util$1.oneOfGetter(gA = ["queryParamKey"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.id), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.label), IA.default != null && Object.hasOwnProperty.call(IA, "default") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.default), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.help), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(IA.formId), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.value), IA.setValue != null && Object.hasOwnProperty.call(IA, "setValue") && BA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(IA.setValue), IA.disabled != null && Object.hasOwnProperty.call(IA, "disabled") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(IA.disabled), IA.labelVisibility != null && Object.hasOwnProperty.call(IA, "labelVisibility") && $root$1.LabelVisibility.encode(IA.labelVisibility, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.step != null && Object.hasOwnProperty.call(IA, "step") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(IA.step), IA.queryParamKey != null && Object.hasOwnProperty.call(IA, "queryParamKey") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.queryParamKey), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.TimeInput();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.id = IA.string();
          break;
        }
        case 2: {
          iA.label = IA.string();
          break;
        }
        case 3: {
          iA.default = IA.string();
          break;
        }
        case 4: {
          iA.help = IA.string();
          break;
        }
        case 5: {
          iA.formId = IA.string();
          break;
        }
        case 6: {
          iA.value = IA.string();
          break;
        }
        case 7: {
          iA.setValue = IA.bool();
          break;
        }
        case 8: {
          iA.disabled = IA.bool();
          break;
        }
        case 9: {
          iA.labelVisibility = $root$1.LabelVisibility.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.step = IA.int64();
          break;
        }
        case 11: {
          iA.queryParamKey = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.TimeInput) return IA;
    let BA = new $root$1.TimeInput();
    if (IA.id != null && (BA.id = String(IA.id)), IA.label != null && (BA.label = String(IA.label)), IA.default != null && (BA.default = String(IA.default)), IA.help != null && (BA.help = String(IA.help)), IA.formId != null && (BA.formId = String(IA.formId)), IA.value != null && (BA.value = String(IA.value)), IA.setValue != null && (BA.setValue = !!IA.setValue), IA.disabled != null && (BA.disabled = !!IA.disabled), IA.labelVisibility != null) {
      if (typeof IA.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      BA.labelVisibility = $root$1.LabelVisibility.fromObject(IA.labelVisibility);
    }
    return IA.step != null && ($util$1.Long ? (BA.step = $util$1.Long.fromValue(IA.step)).unsigned = !1 : typeof IA.step == "string" ? BA.step = parseInt(IA.step, 10) : typeof IA.step == "number" ? BA.step = IA.step : typeof IA.step == "object" && (BA.step = new $util$1.LongBits(IA.step.low >>> 0, IA.step.high >>> 0).toNumber())), IA.queryParamKey != null && (BA.queryParamKey = String(IA.queryParamKey)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if (BA.defaults)
      if (QA.id = "", QA.label = "", QA.help = "", QA.formId = "", QA.setValue = !1, QA.disabled = !1, QA.labelVisibility = null, $util$1.Long) {
        let EA = new $util$1.Long(0, 0, !1);
        QA.step = BA.longs === String ? EA.toString() : BA.longs === Number ? EA.toNumber() : EA;
      } else QA.step = BA.longs === String ? "0" : 0;
    return IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), IA.default != null && IA.hasOwnProperty("default") && (QA.default = IA.default, BA.oneofs && (QA._default = "default")), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value, BA.oneofs && (QA._value = "value")), IA.setValue != null && IA.hasOwnProperty("setValue") && (QA.setValue = IA.setValue), IA.disabled != null && IA.hasOwnProperty("disabled") && (QA.disabled = IA.disabled), IA.labelVisibility != null && IA.hasOwnProperty("labelVisibility") && (QA.labelVisibility = $root$1.LabelVisibility.toObject(IA.labelVisibility, BA)), IA.step != null && IA.hasOwnProperty("step") && (typeof IA.step == "number" ? QA.step = BA.longs === String ? String(IA.step) : IA.step : QA.step = BA.longs === String ? $util$1.Long.prototype.toString.call(IA.step) : BA.longs === Number ? new $util$1.LongBits(IA.step.low >>> 0, IA.step.high >>> 0).toNumber() : IA.step), IA.queryParamKey != null && IA.hasOwnProperty("queryParamKey") && (QA.queryParamKey = IA.queryParamKey, BA.oneofs && (QA._queryParamKey = "queryParamKey")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/TimeInput";
  }, CA;
})();
$root$1.Toast = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.body = "", CA.prototype.icon = "", CA.prototype.duration = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_duration", { get: $util$1.oneOfGetter(gA = ["duration"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.body != null && Object.hasOwnProperty.call(IA, "body") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.body), IA.icon != null && Object.hasOwnProperty.call(IA, "icon") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.icon), IA.duration != null && Object.hasOwnProperty.call(IA, "duration") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.duration), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Toast();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.body = IA.string();
          break;
        }
        case 2: {
          iA.icon = IA.string();
          break;
        }
        case 3: {
          iA.duration = IA.int32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Toast) return IA;
    let BA = new $root$1.Toast();
    return IA.body != null && (BA.body = String(IA.body)), IA.icon != null && (BA.icon = String(IA.icon)), IA.duration != null && (BA.duration = IA.duration | 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.body = "", QA.icon = ""), IA.body != null && IA.hasOwnProperty("body") && (QA.body = IA.body), IA.icon != null && IA.hasOwnProperty("icon") && (QA.icon = IA.icon), IA.duration != null && IA.hasOwnProperty("duration") && (QA.duration = IA.duration, BA.oneofs && (QA._duration = "duration")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Toast";
  }, CA;
})();
$root$1.VegaLiteChart = (() => {
  function CA(gA) {
    if (this.datasets = [], this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.spec = "", CA.prototype.data = null, CA.prototype.datasets = $util$1.emptyArray, CA.prototype.useContainerWidth = !1, CA.prototype.theme = "", CA.prototype.id = "", CA.prototype.selectionMode = $util$1.emptyArray, CA.prototype.formId = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.spec != null && Object.hasOwnProperty.call(AA, "spec") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.spec), AA.data != null && Object.hasOwnProperty.call(AA, "data") && $root$1.ArrowData.encode(AA.data, IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), AA.datasets != null && AA.datasets.length) for (let BA = 0; BA < AA.datasets.length; ++BA) $root$1.ArrowNamedDataSet.encode(AA.datasets[BA], IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim();
    if (AA.useContainerWidth != null && Object.hasOwnProperty.call(AA, "useContainerWidth") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.useContainerWidth), AA.theme != null && Object.hasOwnProperty.call(AA, "theme") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.theme), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.id), AA.selectionMode != null && AA.selectionMode.length) for (let BA = 0; BA < AA.selectionMode.length; ++BA) IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(AA.selectionMode[BA]);
    return AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.formId), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.VegaLiteChart();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.spec = AA.string();
          break;
        }
        case 2: {
          EA.data = $root$1.ArrowData.decode(AA, AA.uint32());
          break;
        }
        case 4: {
          EA.datasets && EA.datasets.length || (EA.datasets = []), EA.datasets.push($root$1.ArrowNamedDataSet.decode(AA, AA.uint32()));
          break;
        }
        case 5: {
          EA.useContainerWidth = AA.bool();
          break;
        }
        case 6: {
          EA.theme = AA.string();
          break;
        }
        case 7: {
          EA.id = AA.string();
          break;
        }
        case 8: {
          EA.selectionMode && EA.selectionMode.length || (EA.selectionMode = []), EA.selectionMode.push(AA.string());
          break;
        }
        case 9: {
          EA.formId = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.VegaLiteChart) return AA;
    let IA = new $root$1.VegaLiteChart();
    if (AA.spec != null && (IA.spec = String(AA.spec)), AA.data != null) {
      if (typeof AA.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      IA.data = $root$1.ArrowData.fromObject(AA.data);
    }
    if (AA.datasets) {
      if (!Array.isArray(AA.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      IA.datasets = [];
      for (let BA = 0; BA < AA.datasets.length; ++BA) {
        if (typeof AA.datasets[BA] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        IA.datasets[BA] = $root$1.ArrowNamedDataSet.fromObject(AA.datasets[BA]);
      }
    }
    if (AA.useContainerWidth != null && (IA.useContainerWidth = !!AA.useContainerWidth), AA.theme != null && (IA.theme = String(AA.theme)), AA.id != null && (IA.id = String(AA.id)), AA.selectionMode) {
      if (!Array.isArray(AA.selectionMode)) throw TypeError(".VegaLiteChart.selectionMode: array expected");
      IA.selectionMode = [];
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) IA.selectionMode[BA] = String(AA.selectionMode[BA]);
    }
    return AA.formId != null && (IA.formId = String(AA.formId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.datasets = [], BA.selectionMode = []), IA.defaults && (BA.spec = "", BA.data = null, BA.useContainerWidth = !1, BA.theme = "", BA.id = "", BA.formId = ""), AA.spec != null && AA.hasOwnProperty("spec") && (BA.spec = AA.spec), AA.data != null && AA.hasOwnProperty("data") && (BA.data = $root$1.ArrowData.toObject(AA.data, IA)), AA.datasets && AA.datasets.length) {
      BA.datasets = [];
      for (let QA = 0; QA < AA.datasets.length; ++QA) BA.datasets[QA] = $root$1.ArrowNamedDataSet.toObject(AA.datasets[QA], IA);
    }
    if (AA.useContainerWidth != null && AA.hasOwnProperty("useContainerWidth") && (BA.useContainerWidth = AA.useContainerWidth), AA.theme != null && AA.hasOwnProperty("theme") && (BA.theme = AA.theme), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.selectionMode && AA.selectionMode.length) {
      BA.selectionMode = [];
      for (let QA = 0; QA < AA.selectionMode.length; ++QA) BA.selectionMode[QA] = AA.selectionMode[QA];
    }
    return AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/VegaLiteChart";
  }, CA;
})();
$root$1.SubtitleTrack = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.label = "", CA.prototype.url = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.label), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.url), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.SubtitleTrack();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.label = AA.string();
          break;
        }
        case 2: {
          EA.url = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.SubtitleTrack) return AA;
    let IA = new $root$1.SubtitleTrack();
    return AA.label != null && (IA.label = String(AA.label)), AA.url != null && (IA.url = String(AA.url)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.label = "", BA.url = ""), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/SubtitleTrack";
  }, CA;
})();
const Video$1 = $root$1.Video = (() => {
  function CA(AA) {
    if (this.subtitles = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.url = "", CA.prototype.startTime = 0, CA.prototype.type = 0, CA.prototype.subtitles = $util$1.emptyArray, CA.prototype.endTime = 0, CA.prototype.loop = !1, CA.prototype.autoplay = !1, CA.prototype.muted = !1, CA.prototype.id = "", CA.prototype.widthConfig = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_widthConfig", { get: $util$1.oneOfGetter(gA = ["widthConfig"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.startTime != null && Object.hasOwnProperty.call(IA, "startTime") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.startTime), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(IA.type), IA.url != null && Object.hasOwnProperty.call(IA, "url") && BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(IA.url), IA.subtitles != null && IA.subtitles.length) for (let QA = 0; QA < IA.subtitles.length; ++QA) $root$1.SubtitleTrack.encode(IA.subtitles[QA], BA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim();
    return IA.endTime != null && Object.hasOwnProperty.call(IA, "endTime") && BA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(IA.endTime), IA.loop != null && Object.hasOwnProperty.call(IA, "loop") && BA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(IA.loop), IA.autoplay != null && Object.hasOwnProperty.call(IA, "autoplay") && BA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(IA.autoplay), IA.muted != null && Object.hasOwnProperty.call(IA, "muted") && BA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(IA.muted), IA.id != null && Object.hasOwnProperty.call(IA, "id") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.id), IA.widthConfig != null && Object.hasOwnProperty.call(IA, "widthConfig") && $root$1.streamlit.WidthConfig.encode(IA.widthConfig, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Video();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 6: {
          iA.url = IA.string();
          break;
        }
        case 3: {
          iA.startTime = IA.int32();
          break;
        }
        case 5: {
          iA.type = IA.int32();
          break;
        }
        case 7: {
          iA.subtitles && iA.subtitles.length || (iA.subtitles = []), iA.subtitles.push($root$1.SubtitleTrack.decode(IA, IA.uint32()));
          break;
        }
        case 8: {
          iA.endTime = IA.int32();
          break;
        }
        case 9: {
          iA.loop = IA.bool();
          break;
        }
        case 10: {
          iA.autoplay = IA.bool();
          break;
        }
        case 11: {
          iA.muted = IA.bool();
          break;
        }
        case 12: {
          iA.id = IA.string();
          break;
        }
        case 13: {
          iA.widthConfig = $root$1.streamlit.WidthConfig.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Video) return IA;
    let BA = new $root$1.Video();
    switch (IA.url != null && (BA.url = String(IA.url)), IA.startTime != null && (BA.startTime = IA.startTime | 0), IA.type) {
      default:
        if (typeof IA.type == "number") {
          BA.type = IA.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        BA.type = 0;
        break;
      case "NATIVE":
      case 1:
        BA.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        BA.type = 2;
        break;
    }
    if (IA.subtitles) {
      if (!Array.isArray(IA.subtitles)) throw TypeError(".Video.subtitles: array expected");
      BA.subtitles = [];
      for (let QA = 0; QA < IA.subtitles.length; ++QA) {
        if (typeof IA.subtitles[QA] != "object") throw TypeError(".Video.subtitles: object expected");
        BA.subtitles[QA] = $root$1.SubtitleTrack.fromObject(IA.subtitles[QA]);
      }
    }
    if (IA.endTime != null && (BA.endTime = IA.endTime | 0), IA.loop != null && (BA.loop = !!IA.loop), IA.autoplay != null && (BA.autoplay = !!IA.autoplay), IA.muted != null && (BA.muted = !!IA.muted), IA.id != null && (BA.id = String(IA.id)), IA.widthConfig != null) {
      if (typeof IA.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      BA.widthConfig = $root$1.streamlit.WidthConfig.fromObject(IA.widthConfig);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.subtitles = []), BA.defaults && (QA.startTime = 0, QA.type = BA.enums === String ? "UNUSED" : 0, QA.url = "", QA.endTime = 0, QA.loop = !1, QA.autoplay = !1, QA.muted = !1, QA.id = ""), IA.startTime != null && IA.hasOwnProperty("startTime") && (QA.startTime = IA.startTime), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.Video.Type[IA.type] === void 0 ? IA.type : $root$1.Video.Type[IA.type] : IA.type), IA.url != null && IA.hasOwnProperty("url") && (QA.url = IA.url), IA.subtitles && IA.subtitles.length) {
      QA.subtitles = [];
      for (let EA = 0; EA < IA.subtitles.length; ++EA) QA.subtitles[EA] = $root$1.SubtitleTrack.toObject(IA.subtitles[EA], BA);
    }
    return IA.endTime != null && IA.hasOwnProperty("endTime") && (QA.endTime = IA.endTime), IA.loop != null && IA.hasOwnProperty("loop") && (QA.loop = IA.loop), IA.autoplay != null && IA.hasOwnProperty("autoplay") && (QA.autoplay = IA.autoplay), IA.muted != null && IA.hasOwnProperty("muted") && (QA.muted = IA.muted), IA.id != null && IA.hasOwnProperty("id") && (QA.id = IA.id), IA.widthConfig != null && IA.hasOwnProperty("widthConfig") && (QA.widthConfig = $root$1.streamlit.WidthConfig.toObject(IA.widthConfig, BA), BA.oneofs && (QA._widthConfig = "widthConfig")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Video";
  }, CA.Type = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "UNUSED"] = 0, IA[AA[1] = "NATIVE"] = 1, IA[AA[2] = "YOUTUBE_IFRAME"] = 2, IA;
  })(), CA;
})();
$root$1.Transient = (() => {
  function CA(gA) {
    if (this.elements = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.elements = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.elements != null && AA.elements.length) for (let BA = 0; BA < AA.elements.length; ++BA) $root$1.Element.encode(AA.elements[BA], IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Transient();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? (EA.elements && EA.elements.length || (EA.elements = []), EA.elements.push($root$1.Element.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Transient) return AA;
    let IA = new $root$1.Transient();
    if (AA.elements) {
      if (!Array.isArray(AA.elements)) throw TypeError(".Transient.elements: array expected");
      IA.elements = [];
      for (let BA = 0; BA < AA.elements.length; ++BA) {
        if (typeof AA.elements[BA] != "object") throw TypeError(".Transient.elements: object expected");
        IA.elements[BA] = $root$1.Element.fromObject(AA.elements[BA]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.elements = []), AA.elements && AA.elements.length) {
      BA.elements = [];
      for (let QA = 0; QA < AA.elements.length; ++QA) BA.elements[QA] = $root$1.Element.toObject(AA.elements[QA], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Transient";
  }, CA;
})();
const ForwardMsg = $root$1.ForwardMsg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.hash = "", CA.prototype.metadata = null, CA.prototype.newSession = null, CA.prototype.delta = null, CA.prototype.pageInfoChanged = null, CA.prototype.pageConfigChanged = null, CA.prototype.scriptFinished = null, CA.prototype.gitInfoChanged = null, CA.prototype.pageProfile = null, CA.prototype.sessionStatusChanged = null, CA.prototype.sessionEvent = null, CA.prototype.navigation = null, CA.prototype.pageNotFound = null, CA.prototype.fileUrlsResponse = null, CA.prototype.autoRerun = null, CA.prototype.logo = null, CA.prototype.authRedirect = null, CA.prototype.parentMessage = null, CA.prototype.refHash = null, CA.prototype.deferredFileResponse = null, CA.prototype.heartbeatAck = null, CA.prototype.debugLastBackmsgId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse", "heartbeatAck"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.hash != null && Object.hasOwnProperty.call(IA, "hash") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.hash), IA.metadata != null && Object.hasOwnProperty.call(IA, "metadata") && $root$1.ForwardMsgMetadata.encode(IA.metadata, BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), IA.newSession != null && Object.hasOwnProperty.call(IA, "newSession") && $root$1.NewSession.encode(IA.newSession, BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), IA.delta != null && Object.hasOwnProperty.call(IA, "delta") && $root$1.Delta.encode(IA.delta, BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA.scriptFinished != null && Object.hasOwnProperty.call(IA, "scriptFinished") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(IA.scriptFinished), IA.sessionStatusChanged != null && Object.hasOwnProperty.call(IA, "sessionStatusChanged") && $root$1.SessionStatus.encode(IA.sessionStatusChanged, BA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), IA.sessionEvent != null && Object.hasOwnProperty.call(IA, "sessionEvent") && $root$1.SessionEvent.encode(IA.sessionEvent, BA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), IA.refHash != null && Object.hasOwnProperty.call(IA, "refHash") && BA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(IA.refHash), IA.pageInfoChanged != null && Object.hasOwnProperty.call(IA, "pageInfoChanged") && $root$1.PageInfo.encode(IA.pageInfoChanged, BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), IA.pageConfigChanged != null && Object.hasOwnProperty.call(IA, "pageConfigChanged") && $root$1.PageConfig.encode(IA.pageConfigChanged, BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), IA.gitInfoChanged != null && Object.hasOwnProperty.call(IA, "gitInfoChanged") && $root$1.GitInfo.encode(IA.gitInfoChanged, BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), IA.pageNotFound != null && Object.hasOwnProperty.call(IA, "pageNotFound") && $root$1.PageNotFound.encode(IA.pageNotFound, BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), IA.debugLastBackmsgId != null && Object.hasOwnProperty.call(IA, "debugLastBackmsgId") && BA.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(IA.debugLastBackmsgId), IA.pageProfile != null && Object.hasOwnProperty.call(IA, "pageProfile") && $root$1.PageProfile.encode(IA.pageProfile, BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), IA.fileUrlsResponse != null && Object.hasOwnProperty.call(IA, "fileUrlsResponse") && $root$1.FileURLsResponse.encode(IA.fileUrlsResponse, BA.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), IA.parentMessage != null && Object.hasOwnProperty.call(IA, "parentMessage") && $root$1.ParentMessage.encode(IA.parentMessage, BA.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), IA.autoRerun != null && Object.hasOwnProperty.call(IA, "autoRerun") && $root$1.AutoRerun.encode(IA.autoRerun, BA.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), IA.logo != null && Object.hasOwnProperty.call(IA, "logo") && $root$1.Logo.encode(IA.logo, BA.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), IA.navigation != null && Object.hasOwnProperty.call(IA, "navigation") && $root$1.Navigation.encode(IA.navigation, BA.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), IA.authRedirect != null && Object.hasOwnProperty.call(IA, "authRedirect") && $root$1.AuthRedirect.encode(IA.authRedirect, BA.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), IA.deferredFileResponse != null && Object.hasOwnProperty.call(IA, "deferredFileResponse") && $root$1.DeferredFileResponse.encode(IA.deferredFileResponse, BA.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), IA.heartbeatAck != null && Object.hasOwnProperty.call(IA, "heartbeatAck") && BA.uint32(
      /* id 26, wireType 0 =*/
      208
    ).bool(IA.heartbeatAck), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.ForwardMsg();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.hash = IA.string();
          break;
        }
        case 2: {
          iA.metadata = $root$1.ForwardMsgMetadata.decode(IA, IA.uint32());
          break;
        }
        case 4: {
          iA.newSession = $root$1.NewSession.decode(IA, IA.uint32());
          break;
        }
        case 5: {
          iA.delta = $root$1.Delta.decode(IA, IA.uint32());
          break;
        }
        case 12: {
          iA.pageInfoChanged = $root$1.PageInfo.decode(IA, IA.uint32());
          break;
        }
        case 13: {
          iA.pageConfigChanged = $root$1.PageConfig.decode(IA, IA.uint32());
          break;
        }
        case 6: {
          iA.scriptFinished = IA.int32();
          break;
        }
        case 14: {
          iA.gitInfoChanged = $root$1.GitInfo.decode(IA, IA.uint32());
          break;
        }
        case 18: {
          iA.pageProfile = $root$1.PageProfile.decode(IA, IA.uint32());
          break;
        }
        case 9: {
          iA.sessionStatusChanged = $root$1.SessionStatus.decode(IA, IA.uint32());
          break;
        }
        case 10: {
          iA.sessionEvent = $root$1.SessionEvent.decode(IA, IA.uint32());
          break;
        }
        case 23: {
          iA.navigation = $root$1.Navigation.decode(IA, IA.uint32());
          break;
        }
        case 15: {
          iA.pageNotFound = $root$1.PageNotFound.decode(IA, IA.uint32());
          break;
        }
        case 19: {
          iA.fileUrlsResponse = $root$1.FileURLsResponse.decode(IA, IA.uint32());
          break;
        }
        case 21: {
          iA.autoRerun = $root$1.AutoRerun.decode(IA, IA.uint32());
          break;
        }
        case 22: {
          iA.logo = $root$1.Logo.decode(IA, IA.uint32());
          break;
        }
        case 24: {
          iA.authRedirect = $root$1.AuthRedirect.decode(IA, IA.uint32());
          break;
        }
        case 20: {
          iA.parentMessage = $root$1.ParentMessage.decode(IA, IA.uint32());
          break;
        }
        case 11: {
          iA.refHash = IA.string();
          break;
        }
        case 25: {
          iA.deferredFileResponse = $root$1.DeferredFileResponse.decode(IA, IA.uint32());
          break;
        }
        case 26: {
          iA.heartbeatAck = IA.bool();
          break;
        }
        case 17: {
          iA.debugLastBackmsgId = IA.string();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.ForwardMsg) return IA;
    let BA = new $root$1.ForwardMsg();
    if (IA.hash != null && (BA.hash = String(IA.hash)), IA.metadata != null) {
      if (typeof IA.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      BA.metadata = $root$1.ForwardMsgMetadata.fromObject(IA.metadata);
    }
    if (IA.newSession != null) {
      if (typeof IA.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      BA.newSession = $root$1.NewSession.fromObject(IA.newSession);
    }
    if (IA.delta != null) {
      if (typeof IA.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      BA.delta = $root$1.Delta.fromObject(IA.delta);
    }
    if (IA.pageInfoChanged != null) {
      if (typeof IA.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      BA.pageInfoChanged = $root$1.PageInfo.fromObject(IA.pageInfoChanged);
    }
    if (IA.pageConfigChanged != null) {
      if (typeof IA.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      BA.pageConfigChanged = $root$1.PageConfig.fromObject(IA.pageConfigChanged);
    }
    switch (IA.scriptFinished) {
      default:
        if (typeof IA.scriptFinished == "number") {
          BA.scriptFinished = IA.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        BA.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        BA.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        BA.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        BA.scriptFinished = 3;
        break;
    }
    if (IA.gitInfoChanged != null) {
      if (typeof IA.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      BA.gitInfoChanged = $root$1.GitInfo.fromObject(IA.gitInfoChanged);
    }
    if (IA.pageProfile != null) {
      if (typeof IA.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      BA.pageProfile = $root$1.PageProfile.fromObject(IA.pageProfile);
    }
    if (IA.sessionStatusChanged != null) {
      if (typeof IA.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      BA.sessionStatusChanged = $root$1.SessionStatus.fromObject(IA.sessionStatusChanged);
    }
    if (IA.sessionEvent != null) {
      if (typeof IA.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      BA.sessionEvent = $root$1.SessionEvent.fromObject(IA.sessionEvent);
    }
    if (IA.navigation != null) {
      if (typeof IA.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      BA.navigation = $root$1.Navigation.fromObject(IA.navigation);
    }
    if (IA.pageNotFound != null) {
      if (typeof IA.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      BA.pageNotFound = $root$1.PageNotFound.fromObject(IA.pageNotFound);
    }
    if (IA.fileUrlsResponse != null) {
      if (typeof IA.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      BA.fileUrlsResponse = $root$1.FileURLsResponse.fromObject(IA.fileUrlsResponse);
    }
    if (IA.autoRerun != null) {
      if (typeof IA.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      BA.autoRerun = $root$1.AutoRerun.fromObject(IA.autoRerun);
    }
    if (IA.logo != null) {
      if (typeof IA.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      BA.logo = $root$1.Logo.fromObject(IA.logo);
    }
    if (IA.authRedirect != null) {
      if (typeof IA.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      BA.authRedirect = $root$1.AuthRedirect.fromObject(IA.authRedirect);
    }
    if (IA.parentMessage != null) {
      if (typeof IA.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      BA.parentMessage = $root$1.ParentMessage.fromObject(IA.parentMessage);
    }
    if (IA.refHash != null && (BA.refHash = String(IA.refHash)), IA.deferredFileResponse != null) {
      if (typeof IA.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      BA.deferredFileResponse = $root$1.DeferredFileResponse.fromObject(IA.deferredFileResponse);
    }
    return IA.heartbeatAck != null && (BA.heartbeatAck = !!IA.heartbeatAck), IA.debugLastBackmsgId != null && (BA.debugLastBackmsgId = String(IA.debugLastBackmsgId)), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.hash = "", QA.metadata = null, QA.debugLastBackmsgId = ""), IA.hash != null && IA.hasOwnProperty("hash") && (QA.hash = IA.hash), IA.metadata != null && IA.hasOwnProperty("metadata") && (QA.metadata = $root$1.ForwardMsgMetadata.toObject(IA.metadata, BA)), IA.newSession != null && IA.hasOwnProperty("newSession") && (QA.newSession = $root$1.NewSession.toObject(IA.newSession, BA), BA.oneofs && (QA.type = "newSession")), IA.delta != null && IA.hasOwnProperty("delta") && (QA.delta = $root$1.Delta.toObject(IA.delta, BA), BA.oneofs && (QA.type = "delta")), IA.scriptFinished != null && IA.hasOwnProperty("scriptFinished") && (QA.scriptFinished = BA.enums === String ? $root$1.ForwardMsg.ScriptFinishedStatus[IA.scriptFinished] === void 0 ? IA.scriptFinished : $root$1.ForwardMsg.ScriptFinishedStatus[IA.scriptFinished] : IA.scriptFinished, BA.oneofs && (QA.type = "scriptFinished")), IA.sessionStatusChanged != null && IA.hasOwnProperty("sessionStatusChanged") && (QA.sessionStatusChanged = $root$1.SessionStatus.toObject(IA.sessionStatusChanged, BA), BA.oneofs && (QA.type = "sessionStatusChanged")), IA.sessionEvent != null && IA.hasOwnProperty("sessionEvent") && (QA.sessionEvent = $root$1.SessionEvent.toObject(IA.sessionEvent, BA), BA.oneofs && (QA.type = "sessionEvent")), IA.refHash != null && IA.hasOwnProperty("refHash") && (QA.refHash = IA.refHash, BA.oneofs && (QA.type = "refHash")), IA.pageInfoChanged != null && IA.hasOwnProperty("pageInfoChanged") && (QA.pageInfoChanged = $root$1.PageInfo.toObject(IA.pageInfoChanged, BA), BA.oneofs && (QA.type = "pageInfoChanged")), IA.pageConfigChanged != null && IA.hasOwnProperty("pageConfigChanged") && (QA.pageConfigChanged = $root$1.PageConfig.toObject(IA.pageConfigChanged, BA), BA.oneofs && (QA.type = "pageConfigChanged")), IA.gitInfoChanged != null && IA.hasOwnProperty("gitInfoChanged") && (QA.gitInfoChanged = $root$1.GitInfo.toObject(IA.gitInfoChanged, BA), BA.oneofs && (QA.type = "gitInfoChanged")), IA.pageNotFound != null && IA.hasOwnProperty("pageNotFound") && (QA.pageNotFound = $root$1.PageNotFound.toObject(IA.pageNotFound, BA), BA.oneofs && (QA.type = "pageNotFound")), IA.debugLastBackmsgId != null && IA.hasOwnProperty("debugLastBackmsgId") && (QA.debugLastBackmsgId = IA.debugLastBackmsgId), IA.pageProfile != null && IA.hasOwnProperty("pageProfile") && (QA.pageProfile = $root$1.PageProfile.toObject(IA.pageProfile, BA), BA.oneofs && (QA.type = "pageProfile")), IA.fileUrlsResponse != null && IA.hasOwnProperty("fileUrlsResponse") && (QA.fileUrlsResponse = $root$1.FileURLsResponse.toObject(IA.fileUrlsResponse, BA), BA.oneofs && (QA.type = "fileUrlsResponse")), IA.parentMessage != null && IA.hasOwnProperty("parentMessage") && (QA.parentMessage = $root$1.ParentMessage.toObject(IA.parentMessage, BA), BA.oneofs && (QA.type = "parentMessage")), IA.autoRerun != null && IA.hasOwnProperty("autoRerun") && (QA.autoRerun = $root$1.AutoRerun.toObject(IA.autoRerun, BA), BA.oneofs && (QA.type = "autoRerun")), IA.logo != null && IA.hasOwnProperty("logo") && (QA.logo = $root$1.Logo.toObject(IA.logo, BA), BA.oneofs && (QA.type = "logo")), IA.navigation != null && IA.hasOwnProperty("navigation") && (QA.navigation = $root$1.Navigation.toObject(IA.navigation, BA), BA.oneofs && (QA.type = "navigation")), IA.authRedirect != null && IA.hasOwnProperty("authRedirect") && (QA.authRedirect = $root$1.AuthRedirect.toObject(IA.authRedirect, BA), BA.oneofs && (QA.type = "authRedirect")), IA.deferredFileResponse != null && IA.hasOwnProperty("deferredFileResponse") && (QA.deferredFileResponse = $root$1.DeferredFileResponse.toObject(IA.deferredFileResponse, BA), BA.oneofs && (QA.type = "deferredFileResponse")), IA.heartbeatAck != null && IA.hasOwnProperty("heartbeatAck") && (QA.heartbeatAck = IA.heartbeatAck, BA.oneofs && (QA.type = "heartbeatAck")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/ForwardMsg";
  }, CA.ScriptFinishedStatus = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "FINISHED_SUCCESSFULLY"] = 0, IA[AA[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, IA[AA[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, IA[AA[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, IA;
  })(), CA;
})();
$root$1.DeferredFileResponse = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.url = "", CA.prototype.errorMsg = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.fileId != null && Object.hasOwnProperty.call(AA, "fileId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.fileId), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.url), AA.errorMsg != null && Object.hasOwnProperty.call(AA, "errorMsg") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.errorMsg), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.DeferredFileResponse();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.fileId = AA.string();
          break;
        }
        case 2: {
          EA.url = AA.string();
          break;
        }
        case 3: {
          EA.errorMsg = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.DeferredFileResponse) return AA;
    let IA = new $root$1.DeferredFileResponse();
    return AA.fileId != null && (IA.fileId = String(AA.fileId)), AA.url != null && (IA.url = String(AA.url)), AA.errorMsg != null && (IA.errorMsg = String(AA.errorMsg)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.fileId = "", BA.url = "", BA.errorMsg = ""), AA.fileId != null && AA.hasOwnProperty("fileId") && (BA.fileId = AA.fileId), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.errorMsg != null && AA.hasOwnProperty("errorMsg") && (BA.errorMsg = AA.errorMsg), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DeferredFileResponse";
  }, CA;
})();
const ForwardMsgMetadata = $root$1.ForwardMsgMetadata = (() => {
  function CA(gA) {
    if (this.deltaPath = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.cacheable = !1, CA.prototype.deltaPath = $util$1.emptyArray, CA.prototype.activeScriptHash = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.cacheable != null && Object.hasOwnProperty.call(AA, "cacheable") && IA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(AA.cacheable), AA.deltaPath != null && AA.deltaPath.length) {
      IA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let BA = 0; BA < AA.deltaPath.length; ++BA) IA.uint32(AA.deltaPath[BA]);
      IA.ldelim();
    }
    return AA.activeScriptHash != null && Object.hasOwnProperty.call(AA, "activeScriptHash") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.activeScriptHash), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ForwardMsgMetadata();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.cacheable = AA.bool();
          break;
        }
        case 2: {
          if (EA.deltaPath && EA.deltaPath.length || (EA.deltaPath = []), (iA & 7) === 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.deltaPath.push(AA.uint32());
          } else EA.deltaPath.push(AA.uint32());
          break;
        }
        case 4: {
          EA.activeScriptHash = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ForwardMsgMetadata) return AA;
    let IA = new $root$1.ForwardMsgMetadata();
    if (AA.cacheable != null && (IA.cacheable = !!AA.cacheable), AA.deltaPath) {
      if (!Array.isArray(AA.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      IA.deltaPath = [];
      for (let BA = 0; BA < AA.deltaPath.length; ++BA) IA.deltaPath[BA] = AA.deltaPath[BA] >>> 0;
    }
    return AA.activeScriptHash != null && (IA.activeScriptHash = String(AA.activeScriptHash)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.deltaPath = []), IA.defaults && (BA.cacheable = !1, BA.activeScriptHash = ""), AA.cacheable != null && AA.hasOwnProperty("cacheable") && (BA.cacheable = AA.cacheable), AA.deltaPath && AA.deltaPath.length) {
      BA.deltaPath = [];
      for (let QA = 0; QA < AA.deltaPath.length; ++QA) BA.deltaPath[QA] = AA.deltaPath[QA];
    }
    return AA.activeScriptHash != null && AA.hasOwnProperty("activeScriptHash") && (BA.activeScriptHash = AA.activeScriptHash), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ForwardMsgMetadata";
  }, CA;
})();
$root$1.ForwardMsgList = (() => {
  function CA(gA) {
    if (this.messages = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.messages = $util$1.emptyArray, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.messages != null && AA.messages.length) for (let BA = 0; BA < AA.messages.length; ++BA) $root$1.ForwardMsg.encode(AA.messages[BA], IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    return IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ForwardMsgList();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? (EA.messages && EA.messages.length || (EA.messages = []), EA.messages.push($root$1.ForwardMsg.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ForwardMsgList) return AA;
    let IA = new $root$1.ForwardMsgList();
    if (AA.messages) {
      if (!Array.isArray(AA.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      IA.messages = [];
      for (let BA = 0; BA < AA.messages.length; ++BA) {
        if (typeof AA.messages[BA] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        IA.messages[BA] = $root$1.ForwardMsg.fromObject(AA.messages[BA]);
      }
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.messages = []), AA.messages && AA.messages.length) {
      BA.messages = [];
      for (let QA = 0; QA < AA.messages.length; ++QA) BA.messages[QA] = $root$1.ForwardMsg.toObject(AA.messages[QA], IA);
    }
    return BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ForwardMsgList";
  }, CA;
})();
const GitInfo = $root$1.GitInfo = (() => {
  function CA(gA) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.repository = "", CA.prototype.branch = "", CA.prototype.module = "", CA.prototype.untrackedFiles = $util$1.emptyArray, CA.prototype.uncommittedFiles = $util$1.emptyArray, CA.prototype.state = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.repository != null && Object.hasOwnProperty.call(AA, "repository") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.repository), AA.branch != null && Object.hasOwnProperty.call(AA, "branch") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.branch), AA.module != null && Object.hasOwnProperty.call(AA, "module") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.module), AA.untrackedFiles != null && AA.untrackedFiles.length) for (let BA = 0; BA < AA.untrackedFiles.length; ++BA) IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.untrackedFiles[BA]);
    if (AA.uncommittedFiles != null && AA.uncommittedFiles.length) for (let BA = 0; BA < AA.uncommittedFiles.length; ++BA) IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.uncommittedFiles[BA]);
    return AA.state != null && Object.hasOwnProperty.call(AA, "state") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(AA.state), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.GitInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.repository = AA.string();
          break;
        }
        case 2: {
          EA.branch = AA.string();
          break;
        }
        case 3: {
          EA.module = AA.string();
          break;
        }
        case 4: {
          EA.untrackedFiles && EA.untrackedFiles.length || (EA.untrackedFiles = []), EA.untrackedFiles.push(AA.string());
          break;
        }
        case 5: {
          EA.uncommittedFiles && EA.uncommittedFiles.length || (EA.uncommittedFiles = []), EA.uncommittedFiles.push(AA.string());
          break;
        }
        case 6: {
          EA.state = AA.int32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.GitInfo) return AA;
    let IA = new $root$1.GitInfo();
    if (AA.repository != null && (IA.repository = String(AA.repository)), AA.branch != null && (IA.branch = String(AA.branch)), AA.module != null && (IA.module = String(AA.module)), AA.untrackedFiles) {
      if (!Array.isArray(AA.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      IA.untrackedFiles = [];
      for (let BA = 0; BA < AA.untrackedFiles.length; ++BA) IA.untrackedFiles[BA] = String(AA.untrackedFiles[BA]);
    }
    if (AA.uncommittedFiles) {
      if (!Array.isArray(AA.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      IA.uncommittedFiles = [];
      for (let BA = 0; BA < AA.uncommittedFiles.length; ++BA) IA.uncommittedFiles[BA] = String(AA.uncommittedFiles[BA]);
    }
    switch (AA.state) {
      default:
        if (typeof AA.state == "number") {
          IA.state = AA.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        IA.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        IA.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        IA.state = 2;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.untrackedFiles = [], BA.uncommittedFiles = []), IA.defaults && (BA.repository = "", BA.branch = "", BA.module = "", BA.state = IA.enums === String ? "DEFAULT" : 0), AA.repository != null && AA.hasOwnProperty("repository") && (BA.repository = AA.repository), AA.branch != null && AA.hasOwnProperty("branch") && (BA.branch = AA.branch), AA.module != null && AA.hasOwnProperty("module") && (BA.module = AA.module), AA.untrackedFiles && AA.untrackedFiles.length) {
      BA.untrackedFiles = [];
      for (let QA = 0; QA < AA.untrackedFiles.length; ++QA) BA.untrackedFiles[QA] = AA.untrackedFiles[QA];
    }
    if (AA.uncommittedFiles && AA.uncommittedFiles.length) {
      BA.uncommittedFiles = [];
      for (let QA = 0; QA < AA.uncommittedFiles.length; ++QA) BA.uncommittedFiles[QA] = AA.uncommittedFiles[QA];
    }
    return AA.state != null && AA.hasOwnProperty("state") && (BA.state = IA.enums === String ? $root$1.GitInfo.GitStates[AA.state] === void 0 ? AA.state : $root$1.GitInfo.GitStates[AA.state] : AA.state), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/GitInfo";
  }, CA.GitStates = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "DEFAULT"] = 0, AA[gA[1] = "HEAD_DETACHED"] = 1, AA[gA[2] = "AHEAD_OF_REMOTE"] = 2, AA;
  })(), CA;
})(), Logo = $root$1.Logo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.image = "", CA.prototype.link = "", CA.prototype.iconImage = "", CA.prototype.size = "", CA.prototype.imageType = 0, CA.prototype.iconImageType = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.image != null && Object.hasOwnProperty.call(AA, "image") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.image), AA.link != null && Object.hasOwnProperty.call(AA, "link") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.link), AA.iconImage != null && Object.hasOwnProperty.call(AA, "iconImage") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.iconImage), AA.size != null && Object.hasOwnProperty.call(AA, "size") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.size), AA.imageType != null && Object.hasOwnProperty.call(AA, "imageType") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(AA.imageType), AA.iconImageType != null && Object.hasOwnProperty.call(AA, "iconImageType") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(AA.iconImageType), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Logo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.image = AA.string();
          break;
        }
        case 2: {
          EA.link = AA.string();
          break;
        }
        case 3: {
          EA.iconImage = AA.string();
          break;
        }
        case 4: {
          EA.size = AA.string();
          break;
        }
        case 5: {
          EA.imageType = AA.int32();
          break;
        }
        case 6: {
          EA.iconImageType = AA.int32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Logo) return AA;
    let IA = new $root$1.Logo();
    switch (AA.image != null && (IA.image = String(AA.image)), AA.link != null && (IA.link = String(AA.link)), AA.iconImage != null && (IA.iconImage = String(AA.iconImage)), AA.size != null && (IA.size = String(AA.size)), AA.imageType) {
      default:
        if (typeof AA.imageType == "number") {
          IA.imageType = AA.imageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        IA.imageType = 0;
        break;
      case "EMOJI":
      case 1:
        IA.imageType = 1;
        break;
      case "ICON":
      case 2:
        IA.imageType = 2;
        break;
    }
    switch (AA.iconImageType) {
      default:
        if (typeof AA.iconImageType == "number") {
          IA.iconImageType = AA.iconImageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        IA.iconImageType = 0;
        break;
      case "EMOJI":
      case 1:
        IA.iconImageType = 1;
        break;
      case "ICON":
      case 2:
        IA.iconImageType = 2;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.image = "", BA.link = "", BA.iconImage = "", BA.size = "", BA.imageType = IA.enums === String ? "IMAGE" : 0, BA.iconImageType = IA.enums === String ? "IMAGE" : 0), AA.image != null && AA.hasOwnProperty("image") && (BA.image = AA.image), AA.link != null && AA.hasOwnProperty("link") && (BA.link = AA.link), AA.iconImage != null && AA.hasOwnProperty("iconImage") && (BA.iconImage = AA.iconImage), AA.size != null && AA.hasOwnProperty("size") && (BA.size = AA.size), AA.imageType != null && AA.hasOwnProperty("imageType") && (BA.imageType = IA.enums === String ? $root$1.Logo.ImageType[AA.imageType] === void 0 ? AA.imageType : $root$1.Logo.ImageType[AA.imageType] : AA.imageType), AA.iconImageType != null && AA.hasOwnProperty("iconImageType") && (BA.iconImageType = IA.enums === String ? $root$1.Logo.ImageType[AA.iconImageType] === void 0 ? AA.iconImageType : $root$1.Logo.ImageType[AA.iconImageType] : AA.iconImageType), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Logo";
  }, CA.ImageType = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "IMAGE"] = 0, AA[gA[1] = "EMOJI"] = 1, AA[gA[2] = "ICON"] = 2, AA;
  })(), CA;
})(), Navigation = $root$1.Navigation = (() => {
  function CA(AA) {
    if (this.sections = [], this.appPages = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.sections = $util$1.emptyArray, CA.prototype.appPages = $util$1.emptyArray, CA.prototype.position = 0, CA.prototype.pageScriptHash = "", CA.prototype.expanded = !1, CA.prototype.visibleItems = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_visibleItems", { get: $util$1.oneOfGetter(gA = ["visibleItems"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.sections != null && IA.sections.length) for (let QA = 0; QA < IA.sections.length; ++QA) BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.sections[QA]);
    if (IA.appPages != null && IA.appPages.length) for (let QA = 0; QA < IA.appPages.length; ++QA) $root$1.AppPage.encode(IA.appPages[QA], BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return IA.position != null && Object.hasOwnProperty.call(IA, "position") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.position), IA.pageScriptHash != null && Object.hasOwnProperty.call(IA, "pageScriptHash") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.pageScriptHash), IA.expanded != null && Object.hasOwnProperty.call(IA, "expanded") && BA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(IA.expanded), IA.visibleItems != null && Object.hasOwnProperty.call(IA, "visibleItems") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).uint32(IA.visibleItems), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.Navigation();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.sections && iA.sections.length || (iA.sections = []), iA.sections.push(IA.string());
          break;
        }
        case 2: {
          iA.appPages && iA.appPages.length || (iA.appPages = []), iA.appPages.push($root$1.AppPage.decode(IA, IA.uint32()));
          break;
        }
        case 3: {
          iA.position = IA.int32();
          break;
        }
        case 4: {
          iA.pageScriptHash = IA.string();
          break;
        }
        case 5: {
          iA.expanded = IA.bool();
          break;
        }
        case 6: {
          iA.visibleItems = IA.uint32();
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.Navigation) return IA;
    let BA = new $root$1.Navigation();
    if (IA.sections) {
      if (!Array.isArray(IA.sections)) throw TypeError(".Navigation.sections: array expected");
      BA.sections = [];
      for (let QA = 0; QA < IA.sections.length; ++QA) BA.sections[QA] = String(IA.sections[QA]);
    }
    if (IA.appPages) {
      if (!Array.isArray(IA.appPages)) throw TypeError(".Navigation.appPages: array expected");
      BA.appPages = [];
      for (let QA = 0; QA < IA.appPages.length; ++QA) {
        if (typeof IA.appPages[QA] != "object") throw TypeError(".Navigation.appPages: object expected");
        BA.appPages[QA] = $root$1.AppPage.fromObject(IA.appPages[QA]);
      }
    }
    switch (IA.position) {
      default:
        if (typeof IA.position == "number") {
          BA.position = IA.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        BA.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        BA.position = 1;
        break;
      case "TOP":
      case 2:
        BA.position = 2;
        break;
    }
    return IA.pageScriptHash != null && (BA.pageScriptHash = String(IA.pageScriptHash)), IA.expanded != null && (BA.expanded = !!IA.expanded), IA.visibleItems != null && (BA.visibleItems = IA.visibleItems >>> 0), BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.sections = [], QA.appPages = []), BA.defaults && (QA.position = BA.enums === String ? "HIDDEN" : 0, QA.pageScriptHash = "", QA.expanded = !1), IA.sections && IA.sections.length) {
      QA.sections = [];
      for (let EA = 0; EA < IA.sections.length; ++EA) QA.sections[EA] = IA.sections[EA];
    }
    if (IA.appPages && IA.appPages.length) {
      QA.appPages = [];
      for (let EA = 0; EA < IA.appPages.length; ++EA) QA.appPages[EA] = $root$1.AppPage.toObject(IA.appPages[EA], BA);
    }
    return IA.position != null && IA.hasOwnProperty("position") && (QA.position = BA.enums === String ? $root$1.Navigation.Position[IA.position] === void 0 ? IA.position : $root$1.Navigation.Position[IA.position] : IA.position), IA.pageScriptHash != null && IA.hasOwnProperty("pageScriptHash") && (QA.pageScriptHash = IA.pageScriptHash), IA.expanded != null && IA.hasOwnProperty("expanded") && (QA.expanded = IA.expanded), IA.visibleItems != null && IA.hasOwnProperty("visibleItems") && (QA.visibleItems = IA.visibleItems, BA.oneofs && (QA._visibleItems = "visibleItems")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Navigation";
  }, CA.Position = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "HIDDEN"] = 0, IA[AA[1] = "SIDEBAR"] = 1, IA[AA[2] = "TOP"] = 2, IA;
  })(), CA;
})();
$root$1.NewSession = (() => {
  function CA(gA) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.initialize = null, CA.prototype.scriptRunId = "", CA.prototype.name = "", CA.prototype.mainScriptPath = "", CA.prototype.config = null, CA.prototype.customTheme = null, CA.prototype.appPages = $util$1.emptyArray, CA.prototype.pageScriptHash = "", CA.prototype.fragmentIdsThisRun = $util$1.emptyArray, CA.prototype.mainScriptHash = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.initialize != null && Object.hasOwnProperty.call(AA, "initialize") && $root$1.Initialize.encode(AA.initialize, IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), AA.scriptRunId != null && Object.hasOwnProperty.call(AA, "scriptRunId") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.scriptRunId), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.name), AA.mainScriptPath != null && Object.hasOwnProperty.call(AA, "mainScriptPath") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.mainScriptPath), AA.config != null && Object.hasOwnProperty.call(AA, "config") && $root$1.Config.encode(AA.config, IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), AA.customTheme != null && Object.hasOwnProperty.call(AA, "customTheme") && $root$1.CustomThemeConfig.encode(AA.customTheme, IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), AA.appPages != null && AA.appPages.length) for (let BA = 0; BA < AA.appPages.length; ++BA) $root$1.AppPage.encode(AA.appPages[BA], IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim();
    if (AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.pageScriptHash), AA.fragmentIdsThisRun != null && AA.fragmentIdsThisRun.length) for (let BA = 0; BA < AA.fragmentIdsThisRun.length; ++BA) IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.fragmentIdsThisRun[BA]);
    return AA.mainScriptHash != null && Object.hasOwnProperty.call(AA, "mainScriptHash") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.mainScriptHash), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.NewSession();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.initialize = $root$1.Initialize.decode(AA, AA.uint32());
          break;
        }
        case 2: {
          EA.scriptRunId = AA.string();
          break;
        }
        case 3: {
          EA.name = AA.string();
          break;
        }
        case 4: {
          EA.mainScriptPath = AA.string();
          break;
        }
        case 6: {
          EA.config = $root$1.Config.decode(AA, AA.uint32());
          break;
        }
        case 7: {
          EA.customTheme = $root$1.CustomThemeConfig.decode(AA, AA.uint32());
          break;
        }
        case 8: {
          EA.appPages && EA.appPages.length || (EA.appPages = []), EA.appPages.push($root$1.AppPage.decode(AA, AA.uint32()));
          break;
        }
        case 9: {
          EA.pageScriptHash = AA.string();
          break;
        }
        case 10: {
          EA.fragmentIdsThisRun && EA.fragmentIdsThisRun.length || (EA.fragmentIdsThisRun = []), EA.fragmentIdsThisRun.push(AA.string());
          break;
        }
        case 11: {
          EA.mainScriptHash = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.NewSession) return AA;
    let IA = new $root$1.NewSession();
    if (AA.initialize != null) {
      if (typeof AA.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      IA.initialize = $root$1.Initialize.fromObject(AA.initialize);
    }
    if (AA.scriptRunId != null && (IA.scriptRunId = String(AA.scriptRunId)), AA.name != null && (IA.name = String(AA.name)), AA.mainScriptPath != null && (IA.mainScriptPath = String(AA.mainScriptPath)), AA.config != null) {
      if (typeof AA.config != "object") throw TypeError(".NewSession.config: object expected");
      IA.config = $root$1.Config.fromObject(AA.config);
    }
    if (AA.customTheme != null) {
      if (typeof AA.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      IA.customTheme = $root$1.CustomThemeConfig.fromObject(AA.customTheme);
    }
    if (AA.appPages) {
      if (!Array.isArray(AA.appPages)) throw TypeError(".NewSession.appPages: array expected");
      IA.appPages = [];
      for (let BA = 0; BA < AA.appPages.length; ++BA) {
        if (typeof AA.appPages[BA] != "object") throw TypeError(".NewSession.appPages: object expected");
        IA.appPages[BA] = $root$1.AppPage.fromObject(AA.appPages[BA]);
      }
    }
    if (AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.fragmentIdsThisRun) {
      if (!Array.isArray(AA.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      IA.fragmentIdsThisRun = [];
      for (let BA = 0; BA < AA.fragmentIdsThisRun.length; ++BA) IA.fragmentIdsThisRun[BA] = String(AA.fragmentIdsThisRun[BA]);
    }
    return AA.mainScriptHash != null && (IA.mainScriptHash = String(AA.mainScriptHash)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.appPages = [], BA.fragmentIdsThisRun = []), IA.defaults && (BA.initialize = null, BA.scriptRunId = "", BA.name = "", BA.mainScriptPath = "", BA.config = null, BA.customTheme = null, BA.pageScriptHash = "", BA.mainScriptHash = ""), AA.initialize != null && AA.hasOwnProperty("initialize") && (BA.initialize = $root$1.Initialize.toObject(AA.initialize, IA)), AA.scriptRunId != null && AA.hasOwnProperty("scriptRunId") && (BA.scriptRunId = AA.scriptRunId), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.mainScriptPath != null && AA.hasOwnProperty("mainScriptPath") && (BA.mainScriptPath = AA.mainScriptPath), AA.config != null && AA.hasOwnProperty("config") && (BA.config = $root$1.Config.toObject(AA.config, IA)), AA.customTheme != null && AA.hasOwnProperty("customTheme") && (BA.customTheme = $root$1.CustomThemeConfig.toObject(AA.customTheme, IA)), AA.appPages && AA.appPages.length) {
      BA.appPages = [];
      for (let QA = 0; QA < AA.appPages.length; ++QA) BA.appPages[QA] = $root$1.AppPage.toObject(AA.appPages[QA], IA);
    }
    if (AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.fragmentIdsThisRun && AA.fragmentIdsThisRun.length) {
      BA.fragmentIdsThisRun = [];
      for (let QA = 0; QA < AA.fragmentIdsThisRun.length; ++QA) BA.fragmentIdsThisRun[QA] = AA.fragmentIdsThisRun[QA];
    }
    return AA.mainScriptHash != null && AA.hasOwnProperty("mainScriptHash") && (BA.mainScriptHash = AA.mainScriptHash), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/NewSession";
  }, CA;
})();
$root$1.Initialize = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.userInfo = null, CA.prototype.environmentInfo = null, CA.prototype.sessionStatus = null, CA.prototype.sessionId = "", CA.prototype.isHello = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.userInfo != null && Object.hasOwnProperty.call(AA, "userInfo") && $root$1.UserInfo.encode(AA.userInfo, IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), AA.environmentInfo != null && Object.hasOwnProperty.call(AA, "environmentInfo") && $root$1.EnvironmentInfo.encode(AA.environmentInfo, IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), AA.sessionStatus != null && Object.hasOwnProperty.call(AA, "sessionStatus") && $root$1.SessionStatus.encode(AA.sessionStatus, IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), AA.sessionId != null && Object.hasOwnProperty.call(AA, "sessionId") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.sessionId), AA.isHello != null && Object.hasOwnProperty.call(AA, "isHello") && IA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(AA.isHello), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Initialize();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.userInfo = $root$1.UserInfo.decode(AA, AA.uint32());
          break;
        }
        case 3: {
          EA.environmentInfo = $root$1.EnvironmentInfo.decode(AA, AA.uint32());
          break;
        }
        case 4: {
          EA.sessionStatus = $root$1.SessionStatus.decode(AA, AA.uint32());
          break;
        }
        case 6: {
          EA.sessionId = AA.string();
          break;
        }
        case 7: {
          EA.isHello = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Initialize) return AA;
    let IA = new $root$1.Initialize();
    if (AA.userInfo != null) {
      if (typeof AA.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      IA.userInfo = $root$1.UserInfo.fromObject(AA.userInfo);
    }
    if (AA.environmentInfo != null) {
      if (typeof AA.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      IA.environmentInfo = $root$1.EnvironmentInfo.fromObject(AA.environmentInfo);
    }
    if (AA.sessionStatus != null) {
      if (typeof AA.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      IA.sessionStatus = $root$1.SessionStatus.fromObject(AA.sessionStatus);
    }
    return AA.sessionId != null && (IA.sessionId = String(AA.sessionId)), AA.isHello != null && (IA.isHello = !!AA.isHello), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.userInfo = null, BA.environmentInfo = null, BA.sessionStatus = null, BA.sessionId = "", BA.isHello = !1), AA.userInfo != null && AA.hasOwnProperty("userInfo") && (BA.userInfo = $root$1.UserInfo.toObject(AA.userInfo, IA)), AA.environmentInfo != null && AA.hasOwnProperty("environmentInfo") && (BA.environmentInfo = $root$1.EnvironmentInfo.toObject(AA.environmentInfo, IA)), AA.sessionStatus != null && AA.hasOwnProperty("sessionStatus") && (BA.sessionStatus = $root$1.SessionStatus.toObject(AA.sessionStatus, IA)), AA.sessionId != null && AA.hasOwnProperty("sessionId") && (BA.sessionId = AA.sessionId), AA.isHello != null && AA.hasOwnProperty("isHello") && (BA.isHello = AA.isHello), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Initialize";
  }, CA;
})();
const Config = $root$1.Config = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.gatherUsageStats = !1, CA.prototype.maxCachedMessageAge = 0, CA.prototype.allowRunOnSave = !1, CA.prototype.hideTopBar = !1, CA.prototype.hideSidebarNav = !1, CA.prototype.toolbarMode = 0, CA.prototype.showErrorLinks = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.gatherUsageStats != null && Object.hasOwnProperty.call(AA, "gatherUsageStats") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(AA.gatherUsageStats), AA.maxCachedMessageAge != null && Object.hasOwnProperty.call(AA, "maxCachedMessageAge") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(AA.maxCachedMessageAge), AA.allowRunOnSave != null && Object.hasOwnProperty.call(AA, "allowRunOnSave") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.allowRunOnSave), AA.hideTopBar != null && Object.hasOwnProperty.call(AA, "hideTopBar") && IA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(AA.hideTopBar), AA.hideSidebarNav != null && Object.hasOwnProperty.call(AA, "hideSidebarNav") && IA.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(AA.hideSidebarNav), AA.toolbarMode != null && Object.hasOwnProperty.call(AA, "toolbarMode") && IA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(AA.toolbarMode), AA.showErrorLinks != null && Object.hasOwnProperty.call(AA, "showErrorLinks") && IA.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(AA.showErrorLinks), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Config();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 2: {
          EA.gatherUsageStats = AA.bool();
          break;
        }
        case 3: {
          EA.maxCachedMessageAge = AA.int32();
          break;
        }
        case 5: {
          EA.allowRunOnSave = AA.bool();
          break;
        }
        case 6: {
          EA.hideTopBar = AA.bool();
          break;
        }
        case 7: {
          EA.hideSidebarNav = AA.bool();
          break;
        }
        case 8: {
          EA.toolbarMode = AA.int32();
          break;
        }
        case 9: {
          EA.showErrorLinks = AA.int32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Config) return AA;
    let IA = new $root$1.Config();
    switch (AA.gatherUsageStats != null && (IA.gatherUsageStats = !!AA.gatherUsageStats), AA.maxCachedMessageAge != null && (IA.maxCachedMessageAge = AA.maxCachedMessageAge | 0), AA.allowRunOnSave != null && (IA.allowRunOnSave = !!AA.allowRunOnSave), AA.hideTopBar != null && (IA.hideTopBar = !!AA.hideTopBar), AA.hideSidebarNav != null && (IA.hideSidebarNav = !!AA.hideSidebarNav), AA.toolbarMode) {
      default:
        if (typeof AA.toolbarMode == "number") {
          IA.toolbarMode = AA.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        IA.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        IA.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        IA.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        IA.toolbarMode = 3;
        break;
    }
    switch (AA.showErrorLinks) {
      default:
        if (typeof AA.showErrorLinks == "number") {
          IA.showErrorLinks = AA.showErrorLinks;
          break;
        }
        break;
      case "SHOW_ERROR_LINKS_UNSPECIFIED":
      case 0:
        IA.showErrorLinks = 0;
        break;
      case "SHOW_ERROR_LINKS_AUTO":
      case 1:
        IA.showErrorLinks = 1;
        break;
      case "SHOW_ERROR_LINKS_TRUE":
      case 2:
        IA.showErrorLinks = 2;
        break;
      case "SHOW_ERROR_LINKS_FALSE":
      case 3:
        IA.showErrorLinks = 3;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.gatherUsageStats = !1, BA.maxCachedMessageAge = 0, BA.allowRunOnSave = !1, BA.hideTopBar = !1, BA.hideSidebarNav = !1, BA.toolbarMode = IA.enums === String ? "AUTO" : 0, BA.showErrorLinks = IA.enums === String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0), AA.gatherUsageStats != null && AA.hasOwnProperty("gatherUsageStats") && (BA.gatherUsageStats = AA.gatherUsageStats), AA.maxCachedMessageAge != null && AA.hasOwnProperty("maxCachedMessageAge") && (BA.maxCachedMessageAge = AA.maxCachedMessageAge), AA.allowRunOnSave != null && AA.hasOwnProperty("allowRunOnSave") && (BA.allowRunOnSave = AA.allowRunOnSave), AA.hideTopBar != null && AA.hasOwnProperty("hideTopBar") && (BA.hideTopBar = AA.hideTopBar), AA.hideSidebarNav != null && AA.hasOwnProperty("hideSidebarNav") && (BA.hideSidebarNav = AA.hideSidebarNav), AA.toolbarMode != null && AA.hasOwnProperty("toolbarMode") && (BA.toolbarMode = IA.enums === String ? $root$1.Config.ToolbarMode[AA.toolbarMode] === void 0 ? AA.toolbarMode : $root$1.Config.ToolbarMode[AA.toolbarMode] : AA.toolbarMode), AA.showErrorLinks != null && AA.hasOwnProperty("showErrorLinks") && (BA.showErrorLinks = IA.enums === String ? $root$1.Config.ShowErrorLinks[AA.showErrorLinks] === void 0 ? AA.showErrorLinks : $root$1.Config.ShowErrorLinks[AA.showErrorLinks] : AA.showErrorLinks), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Config";
  }, CA.ToolbarMode = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "AUTO"] = 0, AA[gA[1] = "DEVELOPER"] = 1, AA[gA[2] = "VIEWER"] = 2, AA[gA[3] = "MINIMAL"] = 3, AA;
  })(), CA.ShowErrorLinks = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, AA[gA[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, AA[gA[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, AA[gA[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, AA;
  })(), CA;
})(), CustomThemeConfig = $root$1.CustomThemeConfig = (() => {
  function CA(AA) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.primaryColor = "", CA.prototype.secondaryBackgroundColor = "", CA.prototype.backgroundColor = "", CA.prototype.textColor = "", CA.prototype.base = 0, CA.prototype.headingFont = "", CA.prototype.bodyFont = "", CA.prototype.codeFont = "", CA.prototype.fontFaces = $util$1.emptyArray, CA.prototype.fontSources = $util$1.emptyArray, CA.prototype.baseRadius = null, CA.prototype.buttonRadius = null, CA.prototype.borderColor = null, CA.prototype.dataframeBorderColor = null, CA.prototype.showWidgetBorder = null, CA.prototype.linkColor = null, CA.prototype.linkUnderline = null, CA.prototype.baseFontSize = null, CA.prototype.baseFontWeight = null, CA.prototype.codeFontWeight = null, CA.prototype.codeFontSize = null, CA.prototype.headingFontSizes = $util$1.emptyArray, CA.prototype.headingFontWeights = $util$1.emptyArray, CA.prototype.showSidebarBorder = null, CA.prototype.codeTextColor = null, CA.prototype.codeBackgroundColor = null, CA.prototype.dataframeHeaderBackgroundColor = null, CA.prototype.chartCategoricalColors = $util$1.emptyArray, CA.prototype.chartSequentialColors = $util$1.emptyArray, CA.prototype.chartDivergingColors = $util$1.emptyArray, CA.prototype.redColor = null, CA.prototype.orangeColor = null, CA.prototype.yellowColor = null, CA.prototype.blueColor = null, CA.prototype.greenColor = null, CA.prototype.violetColor = null, CA.prototype.grayColor = null, CA.prototype.redBackgroundColor = null, CA.prototype.orangeBackgroundColor = null, CA.prototype.yellowBackgroundColor = null, CA.prototype.blueBackgroundColor = null, CA.prototype.greenBackgroundColor = null, CA.prototype.violetBackgroundColor = null, CA.prototype.grayBackgroundColor = null, CA.prototype.redTextColor = null, CA.prototype.orangeTextColor = null, CA.prototype.yellowTextColor = null, CA.prototype.blueTextColor = null, CA.prototype.greenTextColor = null, CA.prototype.violetTextColor = null, CA.prototype.grayTextColor = null, CA.prototype.metricValueFontSize = null, CA.prototype.metricValueFontWeight = null, CA.prototype.sidebar = null, CA.prototype.light = null, CA.prototype.dark = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_baseRadius", { get: $util$1.oneOfGetter(gA = ["baseRadius"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_buttonRadius", { get: $util$1.oneOfGetter(gA = ["buttonRadius"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_borderColor", { get: $util$1.oneOfGetter(gA = ["borderColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dataframeBorderColor", { get: $util$1.oneOfGetter(gA = ["dataframeBorderColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_showWidgetBorder", { get: $util$1.oneOfGetter(gA = ["showWidgetBorder"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_linkColor", { get: $util$1.oneOfGetter(gA = ["linkColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_linkUnderline", { get: $util$1.oneOfGetter(gA = ["linkUnderline"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_baseFontSize", { get: $util$1.oneOfGetter(gA = ["baseFontSize"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_baseFontWeight", { get: $util$1.oneOfGetter(gA = ["baseFontWeight"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeFontWeight", { get: $util$1.oneOfGetter(gA = ["codeFontWeight"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeFontSize", { get: $util$1.oneOfGetter(gA = ["codeFontSize"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_showSidebarBorder", { get: $util$1.oneOfGetter(gA = ["showSidebarBorder"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeTextColor", { get: $util$1.oneOfGetter(gA = ["codeTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeBackgroundColor", { get: $util$1.oneOfGetter(gA = ["codeBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dataframeHeaderBackgroundColor", { get: $util$1.oneOfGetter(gA = ["dataframeHeaderBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redColor", { get: $util$1.oneOfGetter(gA = ["redColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeColor", { get: $util$1.oneOfGetter(gA = ["orangeColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowColor", { get: $util$1.oneOfGetter(gA = ["yellowColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueColor", { get: $util$1.oneOfGetter(gA = ["blueColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenColor", { get: $util$1.oneOfGetter(gA = ["greenColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetColor", { get: $util$1.oneOfGetter(gA = ["violetColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayColor", { get: $util$1.oneOfGetter(gA = ["grayColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redBackgroundColor", { get: $util$1.oneOfGetter(gA = ["redBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeBackgroundColor", { get: $util$1.oneOfGetter(gA = ["orangeBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowBackgroundColor", { get: $util$1.oneOfGetter(gA = ["yellowBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueBackgroundColor", { get: $util$1.oneOfGetter(gA = ["blueBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenBackgroundColor", { get: $util$1.oneOfGetter(gA = ["greenBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetBackgroundColor", { get: $util$1.oneOfGetter(gA = ["violetBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayBackgroundColor", { get: $util$1.oneOfGetter(gA = ["grayBackgroundColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redTextColor", { get: $util$1.oneOfGetter(gA = ["redTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeTextColor", { get: $util$1.oneOfGetter(gA = ["orangeTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowTextColor", { get: $util$1.oneOfGetter(gA = ["yellowTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueTextColor", { get: $util$1.oneOfGetter(gA = ["blueTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenTextColor", { get: $util$1.oneOfGetter(gA = ["greenTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetTextColor", { get: $util$1.oneOfGetter(gA = ["violetTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayTextColor", { get: $util$1.oneOfGetter(gA = ["grayTextColor"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_metricValueFontSize", { get: $util$1.oneOfGetter(gA = ["metricValueFontSize"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_metricValueFontWeight", { get: $util$1.oneOfGetter(gA = ["metricValueFontWeight"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_sidebar", { get: $util$1.oneOfGetter(gA = ["sidebar"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_light", { get: $util$1.oneOfGetter(gA = ["light"]), set: $util$1.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dark", { get: $util$1.oneOfGetter(gA = ["dark"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    if (BA || (BA = $Writer$1.create()), IA.primaryColor != null && Object.hasOwnProperty.call(IA, "primaryColor") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.primaryColor), IA.secondaryBackgroundColor != null && Object.hasOwnProperty.call(IA, "secondaryBackgroundColor") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.secondaryBackgroundColor), IA.backgroundColor != null && Object.hasOwnProperty.call(IA, "backgroundColor") && BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(IA.backgroundColor), IA.textColor != null && Object.hasOwnProperty.call(IA, "textColor") && BA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(IA.textColor), IA.base != null && Object.hasOwnProperty.call(IA, "base") && BA.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(IA.base), IA.headingFont != null && Object.hasOwnProperty.call(IA, "headingFont") && BA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(IA.headingFont), IA.bodyFont != null && Object.hasOwnProperty.call(IA, "bodyFont") && BA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(IA.bodyFont), IA.codeFont != null && Object.hasOwnProperty.call(IA, "codeFont") && BA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(IA.codeFont), IA.fontFaces != null && IA.fontFaces.length) for (let QA = 0; QA < IA.fontFaces.length; ++QA) $root$1.FontFace.encode(IA.fontFaces[QA], BA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim();
    if (IA.baseRadius != null && Object.hasOwnProperty.call(IA, "baseRadius") && BA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(IA.baseRadius), IA.borderColor != null && Object.hasOwnProperty.call(IA, "borderColor") && BA.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(IA.borderColor), IA.showWidgetBorder != null && Object.hasOwnProperty.call(IA, "showWidgetBorder") && BA.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(IA.showWidgetBorder), IA.linkColor != null && Object.hasOwnProperty.call(IA, "linkColor") && BA.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(IA.linkColor), IA.baseFontSize != null && Object.hasOwnProperty.call(IA, "baseFontSize") && BA.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(IA.baseFontSize), IA.showSidebarBorder != null && Object.hasOwnProperty.call(IA, "showSidebarBorder") && BA.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(IA.showSidebarBorder), IA.sidebar != null && Object.hasOwnProperty.call(IA, "sidebar") && $root$1.CustomThemeConfig.encode(IA.sidebar, BA.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), IA.codeBackgroundColor != null && Object.hasOwnProperty.call(IA, "codeBackgroundColor") && BA.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(IA.codeBackgroundColor), IA.buttonRadius != null && Object.hasOwnProperty.call(IA, "buttonRadius") && BA.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(IA.buttonRadius), IA.dataframeBorderColor != null && Object.hasOwnProperty.call(IA, "dataframeBorderColor") && BA.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(IA.dataframeBorderColor), IA.codeFontSize != null && Object.hasOwnProperty.call(IA, "codeFontSize") && BA.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(IA.codeFontSize), IA.linkUnderline != null && Object.hasOwnProperty.call(IA, "linkUnderline") && BA.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(IA.linkUnderline), IA.baseFontWeight != null && Object.hasOwnProperty.call(IA, "baseFontWeight") && BA.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(IA.baseFontWeight), IA.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(IA, "dataframeHeaderBackgroundColor") && BA.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(IA.dataframeHeaderBackgroundColor), IA.codeFontWeight != null && Object.hasOwnProperty.call(IA, "codeFontWeight") && BA.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(IA.codeFontWeight), IA.chartCategoricalColors != null && IA.chartCategoricalColors.length) for (let QA = 0; QA < IA.chartCategoricalColors.length; ++QA) BA.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(IA.chartCategoricalColors[QA]);
    if (IA.headingFontWeights != null && IA.headingFontWeights.length) {
      BA.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let QA = 0; QA < IA.headingFontWeights.length; ++QA) BA.int32(IA.headingFontWeights[QA]);
      BA.ldelim();
    }
    if (IA.headingFontSizes != null && IA.headingFontSizes.length) for (let QA = 0; QA < IA.headingFontSizes.length; ++QA) BA.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(IA.headingFontSizes[QA]);
    if (IA.chartSequentialColors != null && IA.chartSequentialColors.length) for (let QA = 0; QA < IA.chartSequentialColors.length; ++QA) BA.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(IA.chartSequentialColors[QA]);
    if (IA.fontSources != null && IA.fontSources.length) for (let QA = 0; QA < IA.fontSources.length; ++QA) $root$1.FontSource.encode(IA.fontSources[QA], BA.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim();
    if (IA.redColor != null && Object.hasOwnProperty.call(IA, "redColor") && BA.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(IA.redColor), IA.orangeColor != null && Object.hasOwnProperty.call(IA, "orangeColor") && BA.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(IA.orangeColor), IA.yellowColor != null && Object.hasOwnProperty.call(IA, "yellowColor") && BA.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(IA.yellowColor), IA.blueColor != null && Object.hasOwnProperty.call(IA, "blueColor") && BA.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(IA.blueColor), IA.greenColor != null && Object.hasOwnProperty.call(IA, "greenColor") && BA.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(IA.greenColor), IA.violetColor != null && Object.hasOwnProperty.call(IA, "violetColor") && BA.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(IA.violetColor), IA.grayColor != null && Object.hasOwnProperty.call(IA, "grayColor") && BA.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(IA.grayColor), IA.redBackgroundColor != null && Object.hasOwnProperty.call(IA, "redBackgroundColor") && BA.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(IA.redBackgroundColor), IA.orangeBackgroundColor != null && Object.hasOwnProperty.call(IA, "orangeBackgroundColor") && BA.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(IA.orangeBackgroundColor), IA.yellowBackgroundColor != null && Object.hasOwnProperty.call(IA, "yellowBackgroundColor") && BA.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(IA.yellowBackgroundColor), IA.blueBackgroundColor != null && Object.hasOwnProperty.call(IA, "blueBackgroundColor") && BA.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(IA.blueBackgroundColor), IA.greenBackgroundColor != null && Object.hasOwnProperty.call(IA, "greenBackgroundColor") && BA.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(IA.greenBackgroundColor), IA.violetBackgroundColor != null && Object.hasOwnProperty.call(IA, "violetBackgroundColor") && BA.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(IA.violetBackgroundColor), IA.grayBackgroundColor != null && Object.hasOwnProperty.call(IA, "grayBackgroundColor") && BA.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(IA.grayBackgroundColor), IA.redTextColor != null && Object.hasOwnProperty.call(IA, "redTextColor") && BA.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(IA.redTextColor), IA.orangeTextColor != null && Object.hasOwnProperty.call(IA, "orangeTextColor") && BA.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(IA.orangeTextColor), IA.yellowTextColor != null && Object.hasOwnProperty.call(IA, "yellowTextColor") && BA.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(IA.yellowTextColor), IA.blueTextColor != null && Object.hasOwnProperty.call(IA, "blueTextColor") && BA.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(IA.blueTextColor), IA.greenTextColor != null && Object.hasOwnProperty.call(IA, "greenTextColor") && BA.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(IA.greenTextColor), IA.violetTextColor != null && Object.hasOwnProperty.call(IA, "violetTextColor") && BA.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(IA.violetTextColor), IA.grayTextColor != null && Object.hasOwnProperty.call(IA, "grayTextColor") && BA.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(IA.grayTextColor), IA.codeTextColor != null && Object.hasOwnProperty.call(IA, "codeTextColor") && BA.uint32(
      /* id 59, wireType 2 =*/
      474
    ).string(IA.codeTextColor), IA.light != null && Object.hasOwnProperty.call(IA, "light") && $root$1.CustomThemeConfig.encode(IA.light, BA.uint32(
      /* id 60, wireType 2 =*/
      482
    ).fork()).ldelim(), IA.dark != null && Object.hasOwnProperty.call(IA, "dark") && $root$1.CustomThemeConfig.encode(IA.dark, BA.uint32(
      /* id 61, wireType 2 =*/
      490
    ).fork()).ldelim(), IA.chartDivergingColors != null && IA.chartDivergingColors.length) for (let QA = 0; QA < IA.chartDivergingColors.length; ++QA) BA.uint32(
      /* id 62, wireType 2 =*/
      498
    ).string(IA.chartDivergingColors[QA]);
    return IA.metricValueFontSize != null && Object.hasOwnProperty.call(IA, "metricValueFontSize") && BA.uint32(
      /* id 64, wireType 2 =*/
      514
    ).string(IA.metricValueFontSize), IA.metricValueFontWeight != null && Object.hasOwnProperty.call(IA, "metricValueFontWeight") && BA.uint32(
      /* id 65, wireType 0 =*/
      520
    ).int32(IA.metricValueFontWeight), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.CustomThemeConfig();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.primaryColor = IA.string();
          break;
        }
        case 2: {
          iA.secondaryBackgroundColor = IA.string();
          break;
        }
        case 3: {
          iA.backgroundColor = IA.string();
          break;
        }
        case 4: {
          iA.textColor = IA.string();
          break;
        }
        case 6: {
          iA.base = IA.int32();
          break;
        }
        case 12: {
          iA.headingFont = IA.string();
          break;
        }
        case 13: {
          iA.bodyFont = IA.string();
          break;
        }
        case 14: {
          iA.codeFont = IA.string();
          break;
        }
        case 15: {
          iA.fontFaces && iA.fontFaces.length || (iA.fontFaces = []), iA.fontFaces.push($root$1.FontFace.decode(IA, IA.uint32()));
          break;
        }
        case 37: {
          iA.fontSources && iA.fontSources.length || (iA.fontSources = []), iA.fontSources.push($root$1.FontSource.decode(IA, IA.uint32()));
          break;
        }
        case 18: {
          iA.baseRadius = IA.string();
          break;
        }
        case 26: {
          iA.buttonRadius = IA.string();
          break;
        }
        case 19: {
          iA.borderColor = IA.string();
          break;
        }
        case 27: {
          iA.dataframeBorderColor = IA.string();
          break;
        }
        case 20: {
          iA.showWidgetBorder = IA.bool();
          break;
        }
        case 21: {
          iA.linkColor = IA.string();
          break;
        }
        case 29: {
          iA.linkUnderline = IA.bool();
          break;
        }
        case 22: {
          iA.baseFontSize = IA.int32();
          break;
        }
        case 30: {
          iA.baseFontWeight = IA.int32();
          break;
        }
        case 32: {
          iA.codeFontWeight = IA.int32();
          break;
        }
        case 28: {
          iA.codeFontSize = IA.string();
          break;
        }
        case 35: {
          iA.headingFontSizes && iA.headingFontSizes.length || (iA.headingFontSizes = []), iA.headingFontSizes.push(IA.string());
          break;
        }
        case 34: {
          if (iA.headingFontWeights && iA.headingFontWeights.length || (iA.headingFontWeights = []), (oA & 7) === 2) {
            let cA = IA.uint32() + IA.pos;
            for (; IA.pos < cA; ) iA.headingFontWeights.push(IA.int32());
          } else iA.headingFontWeights.push(IA.int32());
          break;
        }
        case 23: {
          iA.showSidebarBorder = IA.bool();
          break;
        }
        case 59: {
          iA.codeTextColor = IA.string();
          break;
        }
        case 25: {
          iA.codeBackgroundColor = IA.string();
          break;
        }
        case 31: {
          iA.dataframeHeaderBackgroundColor = IA.string();
          break;
        }
        case 33: {
          iA.chartCategoricalColors && iA.chartCategoricalColors.length || (iA.chartCategoricalColors = []), iA.chartCategoricalColors.push(IA.string());
          break;
        }
        case 36: {
          iA.chartSequentialColors && iA.chartSequentialColors.length || (iA.chartSequentialColors = []), iA.chartSequentialColors.push(IA.string());
          break;
        }
        case 62: {
          iA.chartDivergingColors && iA.chartDivergingColors.length || (iA.chartDivergingColors = []), iA.chartDivergingColors.push(IA.string());
          break;
        }
        case 38: {
          iA.redColor = IA.string();
          break;
        }
        case 39: {
          iA.orangeColor = IA.string();
          break;
        }
        case 40: {
          iA.yellowColor = IA.string();
          break;
        }
        case 41: {
          iA.blueColor = IA.string();
          break;
        }
        case 42: {
          iA.greenColor = IA.string();
          break;
        }
        case 43: {
          iA.violetColor = IA.string();
          break;
        }
        case 44: {
          iA.grayColor = IA.string();
          break;
        }
        case 45: {
          iA.redBackgroundColor = IA.string();
          break;
        }
        case 46: {
          iA.orangeBackgroundColor = IA.string();
          break;
        }
        case 47: {
          iA.yellowBackgroundColor = IA.string();
          break;
        }
        case 48: {
          iA.blueBackgroundColor = IA.string();
          break;
        }
        case 49: {
          iA.greenBackgroundColor = IA.string();
          break;
        }
        case 50: {
          iA.violetBackgroundColor = IA.string();
          break;
        }
        case 51: {
          iA.grayBackgroundColor = IA.string();
          break;
        }
        case 52: {
          iA.redTextColor = IA.string();
          break;
        }
        case 53: {
          iA.orangeTextColor = IA.string();
          break;
        }
        case 54: {
          iA.yellowTextColor = IA.string();
          break;
        }
        case 55: {
          iA.blueTextColor = IA.string();
          break;
        }
        case 56: {
          iA.greenTextColor = IA.string();
          break;
        }
        case 57: {
          iA.violetTextColor = IA.string();
          break;
        }
        case 58: {
          iA.grayTextColor = IA.string();
          break;
        }
        case 64: {
          iA.metricValueFontSize = IA.string();
          break;
        }
        case 65: {
          iA.metricValueFontWeight = IA.int32();
          break;
        }
        case 24: {
          iA.sidebar = $root$1.CustomThemeConfig.decode(IA, IA.uint32());
          break;
        }
        case 60: {
          iA.light = $root$1.CustomThemeConfig.decode(IA, IA.uint32());
          break;
        }
        case 61: {
          iA.dark = $root$1.CustomThemeConfig.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.CustomThemeConfig) return IA;
    let BA = new $root$1.CustomThemeConfig();
    switch (IA.primaryColor != null && (BA.primaryColor = String(IA.primaryColor)), IA.secondaryBackgroundColor != null && (BA.secondaryBackgroundColor = String(IA.secondaryBackgroundColor)), IA.backgroundColor != null && (BA.backgroundColor = String(IA.backgroundColor)), IA.textColor != null && (BA.textColor = String(IA.textColor)), IA.base) {
      default:
        if (typeof IA.base == "number") {
          BA.base = IA.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        BA.base = 0;
        break;
      case "DARK":
      case 1:
        BA.base = 1;
        break;
    }
    if (IA.headingFont != null && (BA.headingFont = String(IA.headingFont)), IA.bodyFont != null && (BA.bodyFont = String(IA.bodyFont)), IA.codeFont != null && (BA.codeFont = String(IA.codeFont)), IA.fontFaces) {
      if (!Array.isArray(IA.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      BA.fontFaces = [];
      for (let QA = 0; QA < IA.fontFaces.length; ++QA) {
        if (typeof IA.fontFaces[QA] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        BA.fontFaces[QA] = $root$1.FontFace.fromObject(IA.fontFaces[QA]);
      }
    }
    if (IA.fontSources) {
      if (!Array.isArray(IA.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      BA.fontSources = [];
      for (let QA = 0; QA < IA.fontSources.length; ++QA) {
        if (typeof IA.fontSources[QA] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        BA.fontSources[QA] = $root$1.FontSource.fromObject(IA.fontSources[QA]);
      }
    }
    if (IA.baseRadius != null && (BA.baseRadius = String(IA.baseRadius)), IA.buttonRadius != null && (BA.buttonRadius = String(IA.buttonRadius)), IA.borderColor != null && (BA.borderColor = String(IA.borderColor)), IA.dataframeBorderColor != null && (BA.dataframeBorderColor = String(IA.dataframeBorderColor)), IA.showWidgetBorder != null && (BA.showWidgetBorder = !!IA.showWidgetBorder), IA.linkColor != null && (BA.linkColor = String(IA.linkColor)), IA.linkUnderline != null && (BA.linkUnderline = !!IA.linkUnderline), IA.baseFontSize != null && (BA.baseFontSize = IA.baseFontSize | 0), IA.baseFontWeight != null && (BA.baseFontWeight = IA.baseFontWeight | 0), IA.codeFontWeight != null && (BA.codeFontWeight = IA.codeFontWeight | 0), IA.codeFontSize != null && (BA.codeFontSize = String(IA.codeFontSize)), IA.headingFontSizes) {
      if (!Array.isArray(IA.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      BA.headingFontSizes = [];
      for (let QA = 0; QA < IA.headingFontSizes.length; ++QA) BA.headingFontSizes[QA] = String(IA.headingFontSizes[QA]);
    }
    if (IA.headingFontWeights) {
      if (!Array.isArray(IA.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      BA.headingFontWeights = [];
      for (let QA = 0; QA < IA.headingFontWeights.length; ++QA) BA.headingFontWeights[QA] = IA.headingFontWeights[QA] | 0;
    }
    if (IA.showSidebarBorder != null && (BA.showSidebarBorder = !!IA.showSidebarBorder), IA.codeTextColor != null && (BA.codeTextColor = String(IA.codeTextColor)), IA.codeBackgroundColor != null && (BA.codeBackgroundColor = String(IA.codeBackgroundColor)), IA.dataframeHeaderBackgroundColor != null && (BA.dataframeHeaderBackgroundColor = String(IA.dataframeHeaderBackgroundColor)), IA.chartCategoricalColors) {
      if (!Array.isArray(IA.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      BA.chartCategoricalColors = [];
      for (let QA = 0; QA < IA.chartCategoricalColors.length; ++QA) BA.chartCategoricalColors[QA] = String(IA.chartCategoricalColors[QA]);
    }
    if (IA.chartSequentialColors) {
      if (!Array.isArray(IA.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      BA.chartSequentialColors = [];
      for (let QA = 0; QA < IA.chartSequentialColors.length; ++QA) BA.chartSequentialColors[QA] = String(IA.chartSequentialColors[QA]);
    }
    if (IA.chartDivergingColors) {
      if (!Array.isArray(IA.chartDivergingColors)) throw TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
      BA.chartDivergingColors = [];
      for (let QA = 0; QA < IA.chartDivergingColors.length; ++QA) BA.chartDivergingColors[QA] = String(IA.chartDivergingColors[QA]);
    }
    if (IA.redColor != null && (BA.redColor = String(IA.redColor)), IA.orangeColor != null && (BA.orangeColor = String(IA.orangeColor)), IA.yellowColor != null && (BA.yellowColor = String(IA.yellowColor)), IA.blueColor != null && (BA.blueColor = String(IA.blueColor)), IA.greenColor != null && (BA.greenColor = String(IA.greenColor)), IA.violetColor != null && (BA.violetColor = String(IA.violetColor)), IA.grayColor != null && (BA.grayColor = String(IA.grayColor)), IA.redBackgroundColor != null && (BA.redBackgroundColor = String(IA.redBackgroundColor)), IA.orangeBackgroundColor != null && (BA.orangeBackgroundColor = String(IA.orangeBackgroundColor)), IA.yellowBackgroundColor != null && (BA.yellowBackgroundColor = String(IA.yellowBackgroundColor)), IA.blueBackgroundColor != null && (BA.blueBackgroundColor = String(IA.blueBackgroundColor)), IA.greenBackgroundColor != null && (BA.greenBackgroundColor = String(IA.greenBackgroundColor)), IA.violetBackgroundColor != null && (BA.violetBackgroundColor = String(IA.violetBackgroundColor)), IA.grayBackgroundColor != null && (BA.grayBackgroundColor = String(IA.grayBackgroundColor)), IA.redTextColor != null && (BA.redTextColor = String(IA.redTextColor)), IA.orangeTextColor != null && (BA.orangeTextColor = String(IA.orangeTextColor)), IA.yellowTextColor != null && (BA.yellowTextColor = String(IA.yellowTextColor)), IA.blueTextColor != null && (BA.blueTextColor = String(IA.blueTextColor)), IA.greenTextColor != null && (BA.greenTextColor = String(IA.greenTextColor)), IA.violetTextColor != null && (BA.violetTextColor = String(IA.violetTextColor)), IA.grayTextColor != null && (BA.grayTextColor = String(IA.grayTextColor)), IA.metricValueFontSize != null && (BA.metricValueFontSize = String(IA.metricValueFontSize)), IA.metricValueFontWeight != null && (BA.metricValueFontWeight = IA.metricValueFontWeight | 0), IA.sidebar != null) {
      if (typeof IA.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      BA.sidebar = $root$1.CustomThemeConfig.fromObject(IA.sidebar);
    }
    if (IA.light != null) {
      if (typeof IA.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      BA.light = $root$1.CustomThemeConfig.fromObject(IA.light);
    }
    if (IA.dark != null) {
      if (typeof IA.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      BA.dark = $root$1.CustomThemeConfig.fromObject(IA.dark);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    if ((BA.arrays || BA.defaults) && (QA.fontFaces = [], QA.chartCategoricalColors = [], QA.headingFontWeights = [], QA.headingFontSizes = [], QA.chartSequentialColors = [], QA.fontSources = [], QA.chartDivergingColors = []), BA.defaults && (QA.primaryColor = "", QA.secondaryBackgroundColor = "", QA.backgroundColor = "", QA.textColor = "", QA.base = BA.enums === String ? "LIGHT" : 0, QA.headingFont = "", QA.bodyFont = "", QA.codeFont = ""), IA.primaryColor != null && IA.hasOwnProperty("primaryColor") && (QA.primaryColor = IA.primaryColor), IA.secondaryBackgroundColor != null && IA.hasOwnProperty("secondaryBackgroundColor") && (QA.secondaryBackgroundColor = IA.secondaryBackgroundColor), IA.backgroundColor != null && IA.hasOwnProperty("backgroundColor") && (QA.backgroundColor = IA.backgroundColor), IA.textColor != null && IA.hasOwnProperty("textColor") && (QA.textColor = IA.textColor), IA.base != null && IA.hasOwnProperty("base") && (QA.base = BA.enums === String ? $root$1.CustomThemeConfig.BaseTheme[IA.base] === void 0 ? IA.base : $root$1.CustomThemeConfig.BaseTheme[IA.base] : IA.base), IA.headingFont != null && IA.hasOwnProperty("headingFont") && (QA.headingFont = IA.headingFont), IA.bodyFont != null && IA.hasOwnProperty("bodyFont") && (QA.bodyFont = IA.bodyFont), IA.codeFont != null && IA.hasOwnProperty("codeFont") && (QA.codeFont = IA.codeFont), IA.fontFaces && IA.fontFaces.length) {
      QA.fontFaces = [];
      for (let EA = 0; EA < IA.fontFaces.length; ++EA) QA.fontFaces[EA] = $root$1.FontFace.toObject(IA.fontFaces[EA], BA);
    }
    if (IA.baseRadius != null && IA.hasOwnProperty("baseRadius") && (QA.baseRadius = IA.baseRadius, BA.oneofs && (QA._baseRadius = "baseRadius")), IA.borderColor != null && IA.hasOwnProperty("borderColor") && (QA.borderColor = IA.borderColor, BA.oneofs && (QA._borderColor = "borderColor")), IA.showWidgetBorder != null && IA.hasOwnProperty("showWidgetBorder") && (QA.showWidgetBorder = IA.showWidgetBorder, BA.oneofs && (QA._showWidgetBorder = "showWidgetBorder")), IA.linkColor != null && IA.hasOwnProperty("linkColor") && (QA.linkColor = IA.linkColor, BA.oneofs && (QA._linkColor = "linkColor")), IA.baseFontSize != null && IA.hasOwnProperty("baseFontSize") && (QA.baseFontSize = IA.baseFontSize, BA.oneofs && (QA._baseFontSize = "baseFontSize")), IA.showSidebarBorder != null && IA.hasOwnProperty("showSidebarBorder") && (QA.showSidebarBorder = IA.showSidebarBorder, BA.oneofs && (QA._showSidebarBorder = "showSidebarBorder")), IA.sidebar != null && IA.hasOwnProperty("sidebar") && (QA.sidebar = $root$1.CustomThemeConfig.toObject(IA.sidebar, BA), BA.oneofs && (QA._sidebar = "sidebar")), IA.codeBackgroundColor != null && IA.hasOwnProperty("codeBackgroundColor") && (QA.codeBackgroundColor = IA.codeBackgroundColor, BA.oneofs && (QA._codeBackgroundColor = "codeBackgroundColor")), IA.buttonRadius != null && IA.hasOwnProperty("buttonRadius") && (QA.buttonRadius = IA.buttonRadius, BA.oneofs && (QA._buttonRadius = "buttonRadius")), IA.dataframeBorderColor != null && IA.hasOwnProperty("dataframeBorderColor") && (QA.dataframeBorderColor = IA.dataframeBorderColor, BA.oneofs && (QA._dataframeBorderColor = "dataframeBorderColor")), IA.codeFontSize != null && IA.hasOwnProperty("codeFontSize") && (QA.codeFontSize = IA.codeFontSize, BA.oneofs && (QA._codeFontSize = "codeFontSize")), IA.linkUnderline != null && IA.hasOwnProperty("linkUnderline") && (QA.linkUnderline = IA.linkUnderline, BA.oneofs && (QA._linkUnderline = "linkUnderline")), IA.baseFontWeight != null && IA.hasOwnProperty("baseFontWeight") && (QA.baseFontWeight = IA.baseFontWeight, BA.oneofs && (QA._baseFontWeight = "baseFontWeight")), IA.dataframeHeaderBackgroundColor != null && IA.hasOwnProperty("dataframeHeaderBackgroundColor") && (QA.dataframeHeaderBackgroundColor = IA.dataframeHeaderBackgroundColor, BA.oneofs && (QA._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), IA.codeFontWeight != null && IA.hasOwnProperty("codeFontWeight") && (QA.codeFontWeight = IA.codeFontWeight, BA.oneofs && (QA._codeFontWeight = "codeFontWeight")), IA.chartCategoricalColors && IA.chartCategoricalColors.length) {
      QA.chartCategoricalColors = [];
      for (let EA = 0; EA < IA.chartCategoricalColors.length; ++EA) QA.chartCategoricalColors[EA] = IA.chartCategoricalColors[EA];
    }
    if (IA.headingFontWeights && IA.headingFontWeights.length) {
      QA.headingFontWeights = [];
      for (let EA = 0; EA < IA.headingFontWeights.length; ++EA) QA.headingFontWeights[EA] = IA.headingFontWeights[EA];
    }
    if (IA.headingFontSizes && IA.headingFontSizes.length) {
      QA.headingFontSizes = [];
      for (let EA = 0; EA < IA.headingFontSizes.length; ++EA) QA.headingFontSizes[EA] = IA.headingFontSizes[EA];
    }
    if (IA.chartSequentialColors && IA.chartSequentialColors.length) {
      QA.chartSequentialColors = [];
      for (let EA = 0; EA < IA.chartSequentialColors.length; ++EA) QA.chartSequentialColors[EA] = IA.chartSequentialColors[EA];
    }
    if (IA.fontSources && IA.fontSources.length) {
      QA.fontSources = [];
      for (let EA = 0; EA < IA.fontSources.length; ++EA) QA.fontSources[EA] = $root$1.FontSource.toObject(IA.fontSources[EA], BA);
    }
    if (IA.redColor != null && IA.hasOwnProperty("redColor") && (QA.redColor = IA.redColor, BA.oneofs && (QA._redColor = "redColor")), IA.orangeColor != null && IA.hasOwnProperty("orangeColor") && (QA.orangeColor = IA.orangeColor, BA.oneofs && (QA._orangeColor = "orangeColor")), IA.yellowColor != null && IA.hasOwnProperty("yellowColor") && (QA.yellowColor = IA.yellowColor, BA.oneofs && (QA._yellowColor = "yellowColor")), IA.blueColor != null && IA.hasOwnProperty("blueColor") && (QA.blueColor = IA.blueColor, BA.oneofs && (QA._blueColor = "blueColor")), IA.greenColor != null && IA.hasOwnProperty("greenColor") && (QA.greenColor = IA.greenColor, BA.oneofs && (QA._greenColor = "greenColor")), IA.violetColor != null && IA.hasOwnProperty("violetColor") && (QA.violetColor = IA.violetColor, BA.oneofs && (QA._violetColor = "violetColor")), IA.grayColor != null && IA.hasOwnProperty("grayColor") && (QA.grayColor = IA.grayColor, BA.oneofs && (QA._grayColor = "grayColor")), IA.redBackgroundColor != null && IA.hasOwnProperty("redBackgroundColor") && (QA.redBackgroundColor = IA.redBackgroundColor, BA.oneofs && (QA._redBackgroundColor = "redBackgroundColor")), IA.orangeBackgroundColor != null && IA.hasOwnProperty("orangeBackgroundColor") && (QA.orangeBackgroundColor = IA.orangeBackgroundColor, BA.oneofs && (QA._orangeBackgroundColor = "orangeBackgroundColor")), IA.yellowBackgroundColor != null && IA.hasOwnProperty("yellowBackgroundColor") && (QA.yellowBackgroundColor = IA.yellowBackgroundColor, BA.oneofs && (QA._yellowBackgroundColor = "yellowBackgroundColor")), IA.blueBackgroundColor != null && IA.hasOwnProperty("blueBackgroundColor") && (QA.blueBackgroundColor = IA.blueBackgroundColor, BA.oneofs && (QA._blueBackgroundColor = "blueBackgroundColor")), IA.greenBackgroundColor != null && IA.hasOwnProperty("greenBackgroundColor") && (QA.greenBackgroundColor = IA.greenBackgroundColor, BA.oneofs && (QA._greenBackgroundColor = "greenBackgroundColor")), IA.violetBackgroundColor != null && IA.hasOwnProperty("violetBackgroundColor") && (QA.violetBackgroundColor = IA.violetBackgroundColor, BA.oneofs && (QA._violetBackgroundColor = "violetBackgroundColor")), IA.grayBackgroundColor != null && IA.hasOwnProperty("grayBackgroundColor") && (QA.grayBackgroundColor = IA.grayBackgroundColor, BA.oneofs && (QA._grayBackgroundColor = "grayBackgroundColor")), IA.redTextColor != null && IA.hasOwnProperty("redTextColor") && (QA.redTextColor = IA.redTextColor, BA.oneofs && (QA._redTextColor = "redTextColor")), IA.orangeTextColor != null && IA.hasOwnProperty("orangeTextColor") && (QA.orangeTextColor = IA.orangeTextColor, BA.oneofs && (QA._orangeTextColor = "orangeTextColor")), IA.yellowTextColor != null && IA.hasOwnProperty("yellowTextColor") && (QA.yellowTextColor = IA.yellowTextColor, BA.oneofs && (QA._yellowTextColor = "yellowTextColor")), IA.blueTextColor != null && IA.hasOwnProperty("blueTextColor") && (QA.blueTextColor = IA.blueTextColor, BA.oneofs && (QA._blueTextColor = "blueTextColor")), IA.greenTextColor != null && IA.hasOwnProperty("greenTextColor") && (QA.greenTextColor = IA.greenTextColor, BA.oneofs && (QA._greenTextColor = "greenTextColor")), IA.violetTextColor != null && IA.hasOwnProperty("violetTextColor") && (QA.violetTextColor = IA.violetTextColor, BA.oneofs && (QA._violetTextColor = "violetTextColor")), IA.grayTextColor != null && IA.hasOwnProperty("grayTextColor") && (QA.grayTextColor = IA.grayTextColor, BA.oneofs && (QA._grayTextColor = "grayTextColor")), IA.codeTextColor != null && IA.hasOwnProperty("codeTextColor") && (QA.codeTextColor = IA.codeTextColor, BA.oneofs && (QA._codeTextColor = "codeTextColor")), IA.light != null && IA.hasOwnProperty("light") && (QA.light = $root$1.CustomThemeConfig.toObject(IA.light, BA), BA.oneofs && (QA._light = "light")), IA.dark != null && IA.hasOwnProperty("dark") && (QA.dark = $root$1.CustomThemeConfig.toObject(IA.dark, BA), BA.oneofs && (QA._dark = "dark")), IA.chartDivergingColors && IA.chartDivergingColors.length) {
      QA.chartDivergingColors = [];
      for (let EA = 0; EA < IA.chartDivergingColors.length; ++EA) QA.chartDivergingColors[EA] = IA.chartDivergingColors[EA];
    }
    return IA.metricValueFontSize != null && IA.hasOwnProperty("metricValueFontSize") && (QA.metricValueFontSize = IA.metricValueFontSize, BA.oneofs && (QA._metricValueFontSize = "metricValueFontSize")), IA.metricValueFontWeight != null && IA.hasOwnProperty("metricValueFontWeight") && (QA.metricValueFontWeight = IA.metricValueFontWeight, BA.oneofs && (QA._metricValueFontWeight = "metricValueFontWeight")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/CustomThemeConfig";
  }, CA.BaseTheme = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "LIGHT"] = 0, IA[AA[1] = "DARK"] = 1, IA;
  })(), CA;
})();
$root$1.FontFace = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.prototype.family = "", CA.prototype.weightRange = "", CA.prototype.style = "", CA.prototype.unicodeRange = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.url), AA.family != null && Object.hasOwnProperty.call(AA, "family") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.family), AA.style != null && Object.hasOwnProperty.call(AA, "style") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.style), AA.weightRange != null && Object.hasOwnProperty.call(AA, "weightRange") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.weightRange), AA.unicodeRange != null && Object.hasOwnProperty.call(AA, "unicodeRange") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.unicodeRange), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FontFace();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.url = AA.string();
          break;
        }
        case 2: {
          EA.family = AA.string();
          break;
        }
        case 5: {
          EA.weightRange = AA.string();
          break;
        }
        case 4: {
          EA.style = AA.string();
          break;
        }
        case 6: {
          EA.unicodeRange = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FontFace) return AA;
    let IA = new $root$1.FontFace();
    return AA.url != null && (IA.url = String(AA.url)), AA.family != null && (IA.family = String(AA.family)), AA.weightRange != null && (IA.weightRange = String(AA.weightRange)), AA.style != null && (IA.style = String(AA.style)), AA.unicodeRange != null && (IA.unicodeRange = String(AA.unicodeRange)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.url = "", BA.family = "", BA.style = "", BA.weightRange = "", BA.unicodeRange = ""), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.family != null && AA.hasOwnProperty("family") && (BA.family = AA.family), AA.style != null && AA.hasOwnProperty("style") && (BA.style = AA.style), AA.weightRange != null && AA.hasOwnProperty("weightRange") && (BA.weightRange = AA.weightRange), AA.unicodeRange != null && AA.hasOwnProperty("unicodeRange") && (BA.unicodeRange = AA.unicodeRange), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FontFace";
  }, CA;
})();
$root$1.FontSource = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.configName = "", CA.prototype.sourceUrl = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.configName != null && Object.hasOwnProperty.call(AA, "configName") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.configName), AA.sourceUrl != null && Object.hasOwnProperty.call(AA, "sourceUrl") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.sourceUrl), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.FontSource();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.configName = AA.string();
          break;
        }
        case 2: {
          EA.sourceUrl = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.FontSource) return AA;
    let IA = new $root$1.FontSource();
    return AA.configName != null && (IA.configName = String(AA.configName)), AA.sourceUrl != null && (IA.sourceUrl = String(AA.sourceUrl)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.configName = "", BA.sourceUrl = ""), AA.configName != null && AA.hasOwnProperty("configName") && (BA.configName = AA.configName), AA.sourceUrl != null && AA.hasOwnProperty("sourceUrl") && (BA.sourceUrl = AA.sourceUrl), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/FontSource";
  }, CA;
})();
$root$1.UserInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.installationId = "", CA.prototype.installationIdV3 = "", CA.prototype.installationIdV4 = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.installationId != null && Object.hasOwnProperty.call(AA, "installationId") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.installationId), AA.installationIdV3 != null && Object.hasOwnProperty.call(AA, "installationIdV3") && IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.installationIdV3), AA.installationIdV4 != null && Object.hasOwnProperty.call(AA, "installationIdV4") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.installationIdV4), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.UserInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.installationId = AA.string();
          break;
        }
        case 5: {
          EA.installationIdV3 = AA.string();
          break;
        }
        case 6: {
          EA.installationIdV4 = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.UserInfo) return AA;
    let IA = new $root$1.UserInfo();
    return AA.installationId != null && (IA.installationId = String(AA.installationId)), AA.installationIdV3 != null && (IA.installationIdV3 = String(AA.installationIdV3)), AA.installationIdV4 != null && (IA.installationIdV4 = String(AA.installationIdV4)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.installationId = "", BA.installationIdV3 = "", BA.installationIdV4 = ""), AA.installationId != null && AA.hasOwnProperty("installationId") && (BA.installationId = AA.installationId), AA.installationIdV3 != null && AA.hasOwnProperty("installationIdV3") && (BA.installationIdV3 = AA.installationIdV3), AA.installationIdV4 != null && AA.hasOwnProperty("installationIdV4") && (BA.installationIdV4 = AA.installationIdV4), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/UserInfo";
  }, CA;
})();
$root$1.EnvironmentInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.streamlitVersion = "", CA.prototype.pythonVersion = "", CA.prototype.serverOs = "", CA.prototype.hasDisplay = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.streamlitVersion != null && Object.hasOwnProperty.call(AA, "streamlitVersion") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.streamlitVersion), AA.pythonVersion != null && Object.hasOwnProperty.call(AA, "pythonVersion") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.pythonVersion), AA.serverOs != null && Object.hasOwnProperty.call(AA, "serverOs") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.serverOs), AA.hasDisplay != null && Object.hasOwnProperty.call(AA, "hasDisplay") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(AA.hasDisplay), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.EnvironmentInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.streamlitVersion = AA.string();
          break;
        }
        case 2: {
          EA.pythonVersion = AA.string();
          break;
        }
        case 3: {
          EA.serverOs = AA.string();
          break;
        }
        case 4: {
          EA.hasDisplay = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.EnvironmentInfo) return AA;
    let IA = new $root$1.EnvironmentInfo();
    return AA.streamlitVersion != null && (IA.streamlitVersion = String(AA.streamlitVersion)), AA.pythonVersion != null && (IA.pythonVersion = String(AA.pythonVersion)), AA.serverOs != null && (IA.serverOs = String(AA.serverOs)), AA.hasDisplay != null && (IA.hasDisplay = !!AA.hasDisplay), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.streamlitVersion = "", BA.pythonVersion = "", BA.serverOs = "", BA.hasDisplay = !1), AA.streamlitVersion != null && AA.hasOwnProperty("streamlitVersion") && (BA.streamlitVersion = AA.streamlitVersion), AA.pythonVersion != null && AA.hasOwnProperty("pythonVersion") && (BA.pythonVersion = AA.pythonVersion), AA.serverOs != null && AA.hasOwnProperty("serverOs") && (BA.serverOs = AA.serverOs), AA.hasDisplay != null && AA.hasOwnProperty("hasDisplay") && (BA.hasDisplay = AA.hasDisplay), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/EnvironmentInfo";
  }, CA;
})();
$root$1.SessionStatus = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.runOnSave = !1, CA.prototype.scriptIsRunning = !1, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.runOnSave != null && Object.hasOwnProperty.call(AA, "runOnSave") && IA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(AA.runOnSave), AA.scriptIsRunning != null && Object.hasOwnProperty.call(AA, "scriptIsRunning") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(AA.scriptIsRunning), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.SessionStatus();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.runOnSave = AA.bool();
          break;
        }
        case 2: {
          EA.scriptIsRunning = AA.bool();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.SessionStatus) return AA;
    let IA = new $root$1.SessionStatus();
    return AA.runOnSave != null && (IA.runOnSave = !!AA.runOnSave), AA.scriptIsRunning != null && (IA.scriptIsRunning = !!AA.scriptIsRunning), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.runOnSave = !1, BA.scriptIsRunning = !1), AA.runOnSave != null && AA.hasOwnProperty("runOnSave") && (BA.runOnSave = AA.runOnSave), AA.scriptIsRunning != null && AA.hasOwnProperty("scriptIsRunning") && (BA.scriptIsRunning = AA.scriptIsRunning), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/SessionStatus";
  }, CA;
})();
const PageConfig = $root$1.PageConfig = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.title = "", CA.prototype.favicon = "", CA.prototype.layout = 0, CA.prototype.initialSidebarState = 0, CA.prototype.menuItems = null, CA.prototype.initialSidebarWidth = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_initialSidebarWidth", { get: $util$1.oneOfGetter(gA = ["initialSidebarWidth"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.title != null && Object.hasOwnProperty.call(IA, "title") && BA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(IA.title), IA.favicon != null && Object.hasOwnProperty.call(IA, "favicon") && BA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(IA.favicon), IA.layout != null && Object.hasOwnProperty.call(IA, "layout") && BA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(IA.layout), IA.initialSidebarState != null && Object.hasOwnProperty.call(IA, "initialSidebarState") && BA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(IA.initialSidebarState), IA.menuItems != null && Object.hasOwnProperty.call(IA, "menuItems") && $root$1.PageConfig.MenuItems.encode(IA.menuItems, BA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), IA.initialSidebarWidth != null && Object.hasOwnProperty.call(IA, "initialSidebarWidth") && $root$1.PageConfig.SidebarWidthConfig.encode(IA.initialSidebarWidth, BA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.PageConfig();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.title = IA.string();
          break;
        }
        case 2: {
          iA.favicon = IA.string();
          break;
        }
        case 3: {
          iA.layout = IA.int32();
          break;
        }
        case 4: {
          iA.initialSidebarState = IA.int32();
          break;
        }
        case 5: {
          iA.menuItems = $root$1.PageConfig.MenuItems.decode(IA, IA.uint32());
          break;
        }
        case 6: {
          iA.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.PageConfig) return IA;
    let BA = new $root$1.PageConfig();
    switch (IA.title != null && (BA.title = String(IA.title)), IA.favicon != null && (BA.favicon = String(IA.favicon)), IA.layout) {
      default:
        if (typeof IA.layout == "number") {
          BA.layout = IA.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        BA.layout = 0;
        break;
      case "WIDE":
      case 1:
        BA.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        BA.layout = 2;
        break;
    }
    switch (IA.initialSidebarState) {
      default:
        if (typeof IA.initialSidebarState == "number") {
          BA.initialSidebarState = IA.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        BA.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        BA.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        BA.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        BA.initialSidebarState = 3;
        break;
    }
    if (IA.menuItems != null) {
      if (typeof IA.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      BA.menuItems = $root$1.PageConfig.MenuItems.fromObject(IA.menuItems);
    }
    if (IA.initialSidebarWidth != null) {
      if (typeof IA.initialSidebarWidth != "object") throw TypeError(".PageConfig.initialSidebarWidth: object expected");
      BA.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.fromObject(IA.initialSidebarWidth);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return BA.defaults && (QA.title = "", QA.favicon = "", QA.layout = BA.enums === String ? "CENTERED" : 0, QA.initialSidebarState = BA.enums === String ? "AUTO" : 0, QA.menuItems = null), IA.title != null && IA.hasOwnProperty("title") && (QA.title = IA.title), IA.favicon != null && IA.hasOwnProperty("favicon") && (QA.favicon = IA.favicon), IA.layout != null && IA.hasOwnProperty("layout") && (QA.layout = BA.enums === String ? $root$1.PageConfig.Layout[IA.layout] === void 0 ? IA.layout : $root$1.PageConfig.Layout[IA.layout] : IA.layout), IA.initialSidebarState != null && IA.hasOwnProperty("initialSidebarState") && (QA.initialSidebarState = BA.enums === String ? $root$1.PageConfig.SidebarState[IA.initialSidebarState] === void 0 ? IA.initialSidebarState : $root$1.PageConfig.SidebarState[IA.initialSidebarState] : IA.initialSidebarState), IA.menuItems != null && IA.hasOwnProperty("menuItems") && (QA.menuItems = $root$1.PageConfig.MenuItems.toObject(IA.menuItems, BA)), IA.initialSidebarWidth != null && IA.hasOwnProperty("initialSidebarWidth") && (QA.initialSidebarWidth = $root$1.PageConfig.SidebarWidthConfig.toObject(IA.initialSidebarWidth, BA), BA.oneofs && (QA._initialSidebarWidth = "initialSidebarWidth")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/PageConfig";
  }, CA.MenuItems = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.getHelpUrl = "", AA.prototype.hideGetHelp = !1, AA.prototype.reportABugUrl = "", AA.prototype.hideReportABug = !1, AA.prototype.aboutSectionMd = "", AA.prototype.clearAboutMd = !1, AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.getHelpUrl != null && Object.hasOwnProperty.call(BA, "getHelpUrl") && QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(BA.getHelpUrl), BA.hideGetHelp != null && Object.hasOwnProperty.call(BA, "hideGetHelp") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(BA.hideGetHelp), BA.reportABugUrl != null && Object.hasOwnProperty.call(BA, "reportABugUrl") && QA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(BA.reportABugUrl), BA.hideReportABug != null && Object.hasOwnProperty.call(BA, "hideReportABug") && QA.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(BA.hideReportABug), BA.aboutSectionMd != null && Object.hasOwnProperty.call(BA, "aboutSectionMd") && QA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(BA.aboutSectionMd), BA.clearAboutMd != null && Object.hasOwnProperty.call(BA, "clearAboutMd") && QA.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(BA.clearAboutMd), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.PageConfig.MenuItems();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.getHelpUrl = BA.string();
            break;
          }
          case 2: {
            oA.hideGetHelp = BA.bool();
            break;
          }
          case 3: {
            oA.reportABugUrl = BA.string();
            break;
          }
          case 4: {
            oA.hideReportABug = BA.bool();
            break;
          }
          case 5: {
            oA.aboutSectionMd = BA.string();
            break;
          }
          case 6: {
            oA.clearAboutMd = BA.bool();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root$1.PageConfig.MenuItems) return BA;
      let QA = new $root$1.PageConfig.MenuItems();
      return BA.getHelpUrl != null && (QA.getHelpUrl = String(BA.getHelpUrl)), BA.hideGetHelp != null && (QA.hideGetHelp = !!BA.hideGetHelp), BA.reportABugUrl != null && (QA.reportABugUrl = String(BA.reportABugUrl)), BA.hideReportABug != null && (QA.hideReportABug = !!BA.hideReportABug), BA.aboutSectionMd != null && (QA.aboutSectionMd = String(BA.aboutSectionMd)), BA.clearAboutMd != null && (QA.clearAboutMd = !!BA.clearAboutMd), QA;
    }, AA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.getHelpUrl = "", EA.hideGetHelp = !1, EA.reportABugUrl = "", EA.hideReportABug = !1, EA.aboutSectionMd = "", EA.clearAboutMd = !1), BA.getHelpUrl != null && BA.hasOwnProperty("getHelpUrl") && (EA.getHelpUrl = BA.getHelpUrl), BA.hideGetHelp != null && BA.hasOwnProperty("hideGetHelp") && (EA.hideGetHelp = BA.hideGetHelp), BA.reportABugUrl != null && BA.hasOwnProperty("reportABugUrl") && (EA.reportABugUrl = BA.reportABugUrl), BA.hideReportABug != null && BA.hasOwnProperty("hideReportABug") && (EA.hideReportABug = BA.hideReportABug), BA.aboutSectionMd != null && BA.hasOwnProperty("aboutSectionMd") && (EA.aboutSectionMd = BA.aboutSectionMd), BA.clearAboutMd != null && BA.hasOwnProperty("clearAboutMd") && (EA.clearAboutMd = BA.clearAboutMd), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/PageConfig.MenuItems";
    }, AA;
  })(), CA.Layout = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "CENTERED"] = 0, IA[AA[1] = "WIDE"] = 1, IA[AA[2] = "LAYOUT_UNSET"] = 2, IA;
  })(), CA.SidebarState = (function() {
    const AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "AUTO"] = 0, IA[AA[1] = "EXPANDED"] = 1, IA[AA[2] = "COLLAPSED"] = 2, IA[AA[3] = "SIDEBAR_UNSET"] = 3, IA;
  })(), CA.SidebarWidthConfig = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.pixelWidth = null;
    let IA;
    return Object.defineProperty(AA.prototype, "widthSpec", { get: $util$1.oneOfGetter(IA = ["pixelWidth"]), set: $util$1.oneOfSetter(IA) }), AA.create = function(QA) {
      return new AA(QA);
    }, AA.encode = function(QA, EA) {
      return EA || (EA = $Writer$1.create()), QA.pixelWidth != null && Object.hasOwnProperty.call(QA, "pixelWidth") && EA.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(QA.pixelWidth), EA;
    }, AA.decode = function(QA, EA, iA) {
      QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
      let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.PageConfig.SidebarWidthConfig();
      for (; QA.pos < oA; ) {
        let tA = QA.uint32();
        if (tA === iA) break;
        tA >>> 3 === 1 ? cA.pixelWidth = QA.uint32() : QA.skipType(tA & 7);
      }
      return cA;
    }, AA.fromObject = function(QA) {
      if (QA instanceof $root$1.PageConfig.SidebarWidthConfig) return QA;
      let EA = new $root$1.PageConfig.SidebarWidthConfig();
      return QA.pixelWidth != null && (EA.pixelWidth = QA.pixelWidth >>> 0), EA;
    }, AA.toObject = function(QA, EA) {
      EA || (EA = {});
      let iA = {};
      return QA.pixelWidth != null && QA.hasOwnProperty("pixelWidth") && (iA.pixelWidth = QA.pixelWidth, EA.oneofs && (iA.widthSpec = "pixelWidth")), iA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, AA.getTypeUrl = function(QA) {
      return QA === void 0 && (QA = "type.googleapis.com"), QA + "/PageConfig.SidebarWidthConfig";
    }, AA;
  })(), CA;
})();
$root$1.PageInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.queryString = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.queryString != null && Object.hasOwnProperty.call(AA, "queryString") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.queryString), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.PageInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.queryString = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.PageInfo) return AA;
    let IA = new $root$1.PageInfo();
    return AA.queryString != null && (IA.queryString = String(AA.queryString)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.queryString = ""), AA.queryString != null && AA.hasOwnProperty("queryString") && (BA.queryString = AA.queryString), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PageInfo";
  }, CA;
})();
$root$1.PageNotFound = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.pageName = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.pageName != null && Object.hasOwnProperty.call(AA, "pageName") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.pageName), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.PageNotFound();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.pageName = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.PageNotFound) return AA;
    let IA = new $root$1.PageNotFound();
    return AA.pageName != null && (IA.pageName = String(AA.pageName)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.pageName = ""), AA.pageName != null && AA.hasOwnProperty("pageName") && (BA.pageName = AA.pageName), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PageNotFound";
  }, CA;
})();
const PageProfile = $root$1.PageProfile = (() => {
  function CA(gA) {
    if (this.commands = [], this.config = [], this.attributions = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.commands = $util$1.emptyArray, CA.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.config = $util$1.emptyArray, CA.prototype.uncaughtException = "", CA.prototype.attributions = $util$1.emptyArray, CA.prototype.os = "", CA.prototype.timezone = "", CA.prototype.headless = !1, CA.prototype.isFragmentRun = !1, CA.prototype.serverMode = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.commands != null && AA.commands.length) for (let BA = 0; BA < AA.commands.length; ++BA) $root$1.Command.encode(AA.commands[BA], IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim();
    if (AA.execTime != null && Object.hasOwnProperty.call(AA, "execTime") && IA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(AA.execTime), AA.prepTime != null && Object.hasOwnProperty.call(AA, "prepTime") && IA.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(AA.prepTime), AA.config != null && AA.config.length) for (let BA = 0; BA < AA.config.length; ++BA) IA.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(AA.config[BA]);
    if (AA.uncaughtException != null && Object.hasOwnProperty.call(AA, "uncaughtException") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.uncaughtException), AA.attributions != null && AA.attributions.length) for (let BA = 0; BA < AA.attributions.length; ++BA) IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.attributions[BA]);
    return AA.os != null && Object.hasOwnProperty.call(AA, "os") && IA.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(AA.os), AA.timezone != null && Object.hasOwnProperty.call(AA, "timezone") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.timezone), AA.headless != null && Object.hasOwnProperty.call(AA, "headless") && IA.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(AA.headless), AA.isFragmentRun != null && Object.hasOwnProperty.call(AA, "isFragmentRun") && IA.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(AA.isFragmentRun), AA.serverMode != null && Object.hasOwnProperty.call(AA, "serverMode") && IA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(AA.serverMode), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.PageProfile();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.commands && EA.commands.length || (EA.commands = []), EA.commands.push($root$1.Command.decode(AA, AA.uint32()));
          break;
        }
        case 2: {
          EA.execTime = AA.int64();
          break;
        }
        case 3: {
          EA.prepTime = AA.int64();
          break;
        }
        case 5: {
          EA.config && EA.config.length || (EA.config = []), EA.config.push(AA.string());
          break;
        }
        case 6: {
          EA.uncaughtException = AA.string();
          break;
        }
        case 7: {
          EA.attributions && EA.attributions.length || (EA.attributions = []), EA.attributions.push(AA.string());
          break;
        }
        case 8: {
          EA.os = AA.string();
          break;
        }
        case 9: {
          EA.timezone = AA.string();
          break;
        }
        case 10: {
          EA.headless = AA.bool();
          break;
        }
        case 11: {
          EA.isFragmentRun = AA.bool();
          break;
        }
        case 12: {
          EA.serverMode = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.PageProfile) return AA;
    let IA = new $root$1.PageProfile();
    if (AA.commands) {
      if (!Array.isArray(AA.commands)) throw TypeError(".PageProfile.commands: array expected");
      IA.commands = [];
      for (let BA = 0; BA < AA.commands.length; ++BA) {
        if (typeof AA.commands[BA] != "object") throw TypeError(".PageProfile.commands: object expected");
        IA.commands[BA] = $root$1.Command.fromObject(AA.commands[BA]);
      }
    }
    if (AA.execTime != null && ($util$1.Long ? (IA.execTime = $util$1.Long.fromValue(AA.execTime)).unsigned = !1 : typeof AA.execTime == "string" ? IA.execTime = parseInt(AA.execTime, 10) : typeof AA.execTime == "number" ? IA.execTime = AA.execTime : typeof AA.execTime == "object" && (IA.execTime = new $util$1.LongBits(AA.execTime.low >>> 0, AA.execTime.high >>> 0).toNumber())), AA.prepTime != null && ($util$1.Long ? (IA.prepTime = $util$1.Long.fromValue(AA.prepTime)).unsigned = !1 : typeof AA.prepTime == "string" ? IA.prepTime = parseInt(AA.prepTime, 10) : typeof AA.prepTime == "number" ? IA.prepTime = AA.prepTime : typeof AA.prepTime == "object" && (IA.prepTime = new $util$1.LongBits(AA.prepTime.low >>> 0, AA.prepTime.high >>> 0).toNumber())), AA.config) {
      if (!Array.isArray(AA.config)) throw TypeError(".PageProfile.config: array expected");
      IA.config = [];
      for (let BA = 0; BA < AA.config.length; ++BA) IA.config[BA] = String(AA.config[BA]);
    }
    if (AA.uncaughtException != null && (IA.uncaughtException = String(AA.uncaughtException)), AA.attributions) {
      if (!Array.isArray(AA.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      IA.attributions = [];
      for (let BA = 0; BA < AA.attributions.length; ++BA) IA.attributions[BA] = String(AA.attributions[BA]);
    }
    return AA.os != null && (IA.os = String(AA.os)), AA.timezone != null && (IA.timezone = String(AA.timezone)), AA.headless != null && (IA.headless = !!AA.headless), AA.isFragmentRun != null && (IA.isFragmentRun = !!AA.isFragmentRun), AA.serverMode != null && (IA.serverMode = String(AA.serverMode)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.commands = [], BA.config = [], BA.attributions = []), IA.defaults) {
      if ($util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.execTime = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.execTime = IA.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.prepTime = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.prepTime = IA.longs === String ? "0" : 0;
      BA.uncaughtException = "", BA.os = "", BA.timezone = "", BA.headless = !1, BA.isFragmentRun = !1, BA.serverMode = "";
    }
    if (AA.commands && AA.commands.length) {
      BA.commands = [];
      for (let QA = 0; QA < AA.commands.length; ++QA) BA.commands[QA] = $root$1.Command.toObject(AA.commands[QA], IA);
    }
    if (AA.execTime != null && AA.hasOwnProperty("execTime") && (typeof AA.execTime == "number" ? BA.execTime = IA.longs === String ? String(AA.execTime) : AA.execTime : BA.execTime = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.execTime) : IA.longs === Number ? new $util$1.LongBits(AA.execTime.low >>> 0, AA.execTime.high >>> 0).toNumber() : AA.execTime), AA.prepTime != null && AA.hasOwnProperty("prepTime") && (typeof AA.prepTime == "number" ? BA.prepTime = IA.longs === String ? String(AA.prepTime) : AA.prepTime : BA.prepTime = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.prepTime) : IA.longs === Number ? new $util$1.LongBits(AA.prepTime.low >>> 0, AA.prepTime.high >>> 0).toNumber() : AA.prepTime), AA.config && AA.config.length) {
      BA.config = [];
      for (let QA = 0; QA < AA.config.length; ++QA) BA.config[QA] = AA.config[QA];
    }
    if (AA.uncaughtException != null && AA.hasOwnProperty("uncaughtException") && (BA.uncaughtException = AA.uncaughtException), AA.attributions && AA.attributions.length) {
      BA.attributions = [];
      for (let QA = 0; QA < AA.attributions.length; ++QA) BA.attributions[QA] = AA.attributions[QA];
    }
    return AA.os != null && AA.hasOwnProperty("os") && (BA.os = AA.os), AA.timezone != null && AA.hasOwnProperty("timezone") && (BA.timezone = AA.timezone), AA.headless != null && AA.hasOwnProperty("headless") && (BA.headless = AA.headless), AA.isFragmentRun != null && AA.hasOwnProperty("isFragmentRun") && (BA.isFragmentRun = AA.isFragmentRun), AA.serverMode != null && AA.hasOwnProperty("serverMode") && (BA.serverMode = AA.serverMode), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PageProfile";
  }, CA;
})();
$root$1.Argument = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.k = "", CA.prototype.t = "", CA.prototype.m = "", CA.prototype.p = 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.k != null && Object.hasOwnProperty.call(AA, "k") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.k), AA.t != null && Object.hasOwnProperty.call(AA, "t") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.t), AA.m != null && Object.hasOwnProperty.call(AA, "m") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.m), AA.p != null && Object.hasOwnProperty.call(AA, "p") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(AA.p), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Argument();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.k = AA.string();
          break;
        }
        case 2: {
          EA.t = AA.string();
          break;
        }
        case 3: {
          EA.m = AA.string();
          break;
        }
        case 5: {
          EA.p = AA.int32();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Argument) return AA;
    let IA = new $root$1.Argument();
    return AA.k != null && (IA.k = String(AA.k)), AA.t != null && (IA.t = String(AA.t)), AA.m != null && (IA.m = String(AA.m)), AA.p != null && (IA.p = AA.p | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.k = "", BA.t = "", BA.m = "", BA.p = 0), AA.k != null && AA.hasOwnProperty("k") && (BA.k = AA.k), AA.t != null && AA.hasOwnProperty("t") && (BA.t = AA.t), AA.m != null && AA.hasOwnProperty("m") && (BA.m = AA.m), AA.p != null && AA.hasOwnProperty("p") && (BA.p = AA.p), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Argument";
  }, CA;
})();
$root$1.Command = (() => {
  function CA(gA) {
    if (this.args = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.args = $util$1.emptyArray, CA.prototype.time = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.name), AA.args != null && AA.args.length) for (let BA = 0; BA < AA.args.length; ++BA) $root$1.Argument.encode(AA.args[BA], IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim();
    return AA.time != null && Object.hasOwnProperty.call(AA, "time") && IA.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(AA.time), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.Command();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.name = AA.string();
          break;
        }
        case 2: {
          EA.args && EA.args.length || (EA.args = []), EA.args.push($root$1.Argument.decode(AA, AA.uint32()));
          break;
        }
        case 4: {
          EA.time = AA.int64();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.Command) return AA;
    let IA = new $root$1.Command();
    if (AA.name != null && (IA.name = String(AA.name)), AA.args) {
      if (!Array.isArray(AA.args)) throw TypeError(".Command.args: array expected");
      IA.args = [];
      for (let BA = 0; BA < AA.args.length; ++BA) {
        if (typeof AA.args[BA] != "object") throw TypeError(".Command.args: object expected");
        IA.args[BA] = $root$1.Argument.fromObject(AA.args[BA]);
      }
    }
    return AA.time != null && ($util$1.Long ? (IA.time = $util$1.Long.fromValue(AA.time)).unsigned = !1 : typeof AA.time == "string" ? IA.time = parseInt(AA.time, 10) : typeof AA.time == "number" ? IA.time = AA.time : typeof AA.time == "object" && (IA.time = new $util$1.LongBits(AA.time.low >>> 0, AA.time.high >>> 0).toNumber())), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.args = []), IA.defaults)
      if (BA.name = "", $util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.time = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.time = IA.longs === String ? "0" : 0;
    if (AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.args && AA.args.length) {
      BA.args = [];
      for (let QA = 0; QA < AA.args.length; ++QA) BA.args[QA] = $root$1.Argument.toObject(AA.args[QA], IA);
    }
    return AA.time != null && AA.hasOwnProperty("time") && (typeof AA.time == "number" ? BA.time = IA.longs === String ? String(AA.time) : AA.time : BA.time = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.time) : IA.longs === Number ? new $util$1.LongBits(AA.time.low >>> 0, AA.time.high >>> 0).toNumber() : AA.time), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Command";
  }, CA;
})();
$root$1.ParentMessage = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.message = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.message != null && Object.hasOwnProperty.call(AA, "message") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.message), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.ParentMessage();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.message = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.ParentMessage) return AA;
    let IA = new $root$1.ParentMessage();
    return AA.message != null && (IA.message = String(AA.message)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.message = ""), AA.message != null && AA.hasOwnProperty("message") && (BA.message = AA.message), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ParentMessage";
  }, CA;
})();
$root$1.SessionEvent = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.scriptChangedOnDisk = null, CA.prototype.scriptWasManuallyStopped = null, CA.prototype.scriptCompilationException = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util$1.oneOfGetter(gA = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util$1.oneOfSetter(gA) }), CA.create = function(IA) {
    return new CA(IA);
  }, CA.encode = function(IA, BA) {
    return BA || (BA = $Writer$1.create()), IA.scriptChangedOnDisk != null && Object.hasOwnProperty.call(IA, "scriptChangedOnDisk") && BA.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(IA.scriptChangedOnDisk), IA.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(IA, "scriptWasManuallyStopped") && BA.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(IA.scriptWasManuallyStopped), IA.scriptCompilationException != null && Object.hasOwnProperty.call(IA, "scriptCompilationException") && $root$1.Exception.encode(IA.scriptCompilationException, BA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), BA;
  }, CA.decode = function(IA, BA, QA) {
    IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
    let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.SessionEvent();
    for (; IA.pos < EA; ) {
      let oA = IA.uint32();
      if (oA === QA) break;
      switch (oA >>> 3) {
        case 1: {
          iA.scriptChangedOnDisk = IA.bool();
          break;
        }
        case 2: {
          iA.scriptWasManuallyStopped = IA.bool();
          break;
        }
        case 3: {
          iA.scriptCompilationException = $root$1.Exception.decode(IA, IA.uint32());
          break;
        }
        default:
          IA.skipType(oA & 7);
          break;
      }
    }
    return iA;
  }, CA.fromObject = function(IA) {
    if (IA instanceof $root$1.SessionEvent) return IA;
    let BA = new $root$1.SessionEvent();
    if (IA.scriptChangedOnDisk != null && (BA.scriptChangedOnDisk = !!IA.scriptChangedOnDisk), IA.scriptWasManuallyStopped != null && (BA.scriptWasManuallyStopped = !!IA.scriptWasManuallyStopped), IA.scriptCompilationException != null) {
      if (typeof IA.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      BA.scriptCompilationException = $root$1.Exception.fromObject(IA.scriptCompilationException);
    }
    return BA;
  }, CA.toObject = function(IA, BA) {
    BA || (BA = {});
    let QA = {};
    return IA.scriptChangedOnDisk != null && IA.hasOwnProperty("scriptChangedOnDisk") && (QA.scriptChangedOnDisk = IA.scriptChangedOnDisk, BA.oneofs && (QA.type = "scriptChangedOnDisk")), IA.scriptWasManuallyStopped != null && IA.hasOwnProperty("scriptWasManuallyStopped") && (QA.scriptWasManuallyStopped = IA.scriptWasManuallyStopped, BA.oneofs && (QA.type = "scriptWasManuallyStopped")), IA.scriptCompilationException != null && IA.hasOwnProperty("scriptCompilationException") && (QA.scriptCompilationException = $root$1.Exception.toObject(IA.scriptCompilationException, BA), BA.oneofs && (QA.type = "scriptCompilationException")), QA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(IA) {
    return IA === void 0 && (IA = "type.googleapis.com"), IA + "/SessionEvent";
  }, CA;
})();
const MetricsEvent = $root$1.MetricsEvent = (() => {
  function CA(gA) {
    if (this.commands = [], this.config = [], this.attributions = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.event = "", CA.prototype.anonymousId = "", CA.prototype.machineIdV3 = "", CA.prototype.machineIdV4 = "", CA.prototype.reportHash = "", CA.prototype.dev = !1, CA.prototype.source = "", CA.prototype.streamlitVersion = "", CA.prototype.isHello = !1, CA.prototype.appId = "", CA.prototype.sessionId = "", CA.prototype.pythonVersion = "", CA.prototype.serverOs = "", CA.prototype.hasDisplay = !1, CA.prototype.isWebdriver = !1, CA.prototype.hostedAt = "", CA.prototype.owner = "", CA.prototype.repo = "", CA.prototype.branch = "", CA.prototype.mainModule = "", CA.prototype.creatorId = "", CA.prototype.contextPageUrl = "", CA.prototype.contextPageTitle = "", CA.prototype.contextPagePath = "", CA.prototype.contextPageReferrer = "", CA.prototype.contextPageSearch = "", CA.prototype.contextLocale = "", CA.prototype.contextUserAgent = "", CA.prototype.label = "", CA.prototype.commands = $util$1.emptyArray, CA.prototype.execTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.prepTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.config = $util$1.emptyArray, CA.prototype.uncaughtException = "", CA.prototype.attributions = $util$1.emptyArray, CA.prototype.os = "", CA.prototype.timezone = "", CA.prototype.headless = !1, CA.prototype.isFragmentRun = !1, CA.prototype.numPages = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.pageScriptHash = "", CA.prototype.activeTheme = "", CA.prototype.totalLoadTime = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, CA.prototype.browserInfo = null, CA.prototype.serverMode = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA || (IA = $Writer$1.create()), AA.event != null && Object.hasOwnProperty.call(AA, "event") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.event), AA.anonymousId != null && Object.hasOwnProperty.call(AA, "anonymousId") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.anonymousId), AA.machineIdV3 != null && Object.hasOwnProperty.call(AA, "machineIdV3") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.machineIdV3), AA.reportHash != null && Object.hasOwnProperty.call(AA, "reportHash") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.reportHash), AA.dev != null && Object.hasOwnProperty.call(AA, "dev") && IA.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(AA.dev), AA.source != null && Object.hasOwnProperty.call(AA, "source") && IA.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(AA.source), AA.streamlitVersion != null && Object.hasOwnProperty.call(AA, "streamlitVersion") && IA.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(AA.streamlitVersion), AA.isHello != null && Object.hasOwnProperty.call(AA, "isHello") && IA.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(AA.isHello), AA.hostedAt != null && Object.hasOwnProperty.call(AA, "hostedAt") && IA.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(AA.hostedAt), AA.owner != null && Object.hasOwnProperty.call(AA, "owner") && IA.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(AA.owner), AA.repo != null && Object.hasOwnProperty.call(AA, "repo") && IA.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(AA.repo), AA.branch != null && Object.hasOwnProperty.call(AA, "branch") && IA.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(AA.branch), AA.mainModule != null && Object.hasOwnProperty.call(AA, "mainModule") && IA.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(AA.mainModule), AA.creatorId != null && Object.hasOwnProperty.call(AA, "creatorId") && IA.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(AA.creatorId), AA.contextPageUrl != null && Object.hasOwnProperty.call(AA, "contextPageUrl") && IA.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(AA.contextPageUrl), AA.contextPageTitle != null && Object.hasOwnProperty.call(AA, "contextPageTitle") && IA.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(AA.contextPageTitle), AA.contextPagePath != null && Object.hasOwnProperty.call(AA, "contextPagePath") && IA.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(AA.contextPagePath), AA.contextPageReferrer != null && Object.hasOwnProperty.call(AA, "contextPageReferrer") && IA.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(AA.contextPageReferrer), AA.contextPageSearch != null && Object.hasOwnProperty.call(AA, "contextPageSearch") && IA.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(AA.contextPageSearch), AA.contextLocale != null && Object.hasOwnProperty.call(AA, "contextLocale") && IA.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(AA.contextLocale), AA.contextUserAgent != null && Object.hasOwnProperty.call(AA, "contextUserAgent") && IA.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(AA.contextUserAgent), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(AA.label), AA.commands != null && AA.commands.length) for (let BA = 0; BA < AA.commands.length; ++BA) $root$1.Command.encode(AA.commands[BA], IA.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim();
    if (AA.execTime != null && Object.hasOwnProperty.call(AA, "execTime") && IA.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(AA.execTime), AA.prepTime != null && Object.hasOwnProperty.call(AA, "prepTime") && IA.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(AA.prepTime), AA.config != null && AA.config.length) for (let BA = 0; BA < AA.config.length; ++BA) IA.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(AA.config[BA]);
    if (AA.uncaughtException != null && Object.hasOwnProperty.call(AA, "uncaughtException") && IA.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(AA.uncaughtException), AA.attributions != null && AA.attributions.length) for (let BA = 0; BA < AA.attributions.length; ++BA) IA.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(AA.attributions[BA]);
    return AA.os != null && Object.hasOwnProperty.call(AA, "os") && IA.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(AA.os), AA.timezone != null && Object.hasOwnProperty.call(AA, "timezone") && IA.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(AA.timezone), AA.headless != null && Object.hasOwnProperty.call(AA, "headless") && IA.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(AA.headless), AA.isFragmentRun != null && Object.hasOwnProperty.call(AA, "isFragmentRun") && IA.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(AA.isFragmentRun), AA.appId != null && Object.hasOwnProperty.call(AA, "appId") && IA.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(AA.appId), AA.numPages != null && Object.hasOwnProperty.call(AA, "numPages") && IA.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(AA.numPages), AA.sessionId != null && Object.hasOwnProperty.call(AA, "sessionId") && IA.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(AA.sessionId), AA.pythonVersion != null && Object.hasOwnProperty.call(AA, "pythonVersion") && IA.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(AA.pythonVersion), AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(AA.pageScriptHash), AA.activeTheme != null && Object.hasOwnProperty.call(AA, "activeTheme") && IA.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(AA.activeTheme), AA.totalLoadTime != null && Object.hasOwnProperty.call(AA, "totalLoadTime") && IA.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(AA.totalLoadTime), AA.browserInfo != null && Object.hasOwnProperty.call(AA, "browserInfo") && $root$1.BrowserInfo.encode(AA.browserInfo, IA.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), AA.machineIdV4 != null && Object.hasOwnProperty.call(AA, "machineIdV4") && IA.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(AA.machineIdV4), AA.serverOs != null && Object.hasOwnProperty.call(AA, "serverOs") && IA.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(AA.serverOs), AA.hasDisplay != null && Object.hasOwnProperty.call(AA, "hasDisplay") && IA.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(AA.hasDisplay), AA.isWebdriver != null && Object.hasOwnProperty.call(AA, "isWebdriver") && IA.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(AA.isWebdriver), AA.serverMode != null && Object.hasOwnProperty.call(AA, "serverMode") && IA.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(AA.serverMode), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.MetricsEvent();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.event = AA.string();
          break;
        }
        case 2: {
          EA.anonymousId = AA.string();
          break;
        }
        case 3: {
          EA.machineIdV3 = AA.string();
          break;
        }
        case 41: {
          EA.machineIdV4 = AA.string();
          break;
        }
        case 4: {
          EA.reportHash = AA.string();
          break;
        }
        case 5: {
          EA.dev = AA.bool();
          break;
        }
        case 6: {
          EA.source = AA.string();
          break;
        }
        case 7: {
          EA.streamlitVersion = AA.string();
          break;
        }
        case 8: {
          EA.isHello = AA.bool();
          break;
        }
        case 33: {
          EA.appId = AA.string();
          break;
        }
        case 35: {
          EA.sessionId = AA.string();
          break;
        }
        case 36: {
          EA.pythonVersion = AA.string();
          break;
        }
        case 42: {
          EA.serverOs = AA.string();
          break;
        }
        case 43: {
          EA.hasDisplay = AA.bool();
          break;
        }
        case 44: {
          EA.isWebdriver = AA.bool();
          break;
        }
        case 9: {
          EA.hostedAt = AA.string();
          break;
        }
        case 10: {
          EA.owner = AA.string();
          break;
        }
        case 11: {
          EA.repo = AA.string();
          break;
        }
        case 12: {
          EA.branch = AA.string();
          break;
        }
        case 13: {
          EA.mainModule = AA.string();
          break;
        }
        case 14: {
          EA.creatorId = AA.string();
          break;
        }
        case 15: {
          EA.contextPageUrl = AA.string();
          break;
        }
        case 16: {
          EA.contextPageTitle = AA.string();
          break;
        }
        case 17: {
          EA.contextPagePath = AA.string();
          break;
        }
        case 18: {
          EA.contextPageReferrer = AA.string();
          break;
        }
        case 19: {
          EA.contextPageSearch = AA.string();
          break;
        }
        case 20: {
          EA.contextLocale = AA.string();
          break;
        }
        case 21: {
          EA.contextUserAgent = AA.string();
          break;
        }
        case 22: {
          EA.label = AA.string();
          break;
        }
        case 23: {
          EA.commands && EA.commands.length || (EA.commands = []), EA.commands.push($root$1.Command.decode(AA, AA.uint32()));
          break;
        }
        case 24: {
          EA.execTime = AA.int64();
          break;
        }
        case 25: {
          EA.prepTime = AA.int64();
          break;
        }
        case 26: {
          EA.config && EA.config.length || (EA.config = []), EA.config.push(AA.string());
          break;
        }
        case 27: {
          EA.uncaughtException = AA.string();
          break;
        }
        case 28: {
          EA.attributions && EA.attributions.length || (EA.attributions = []), EA.attributions.push(AA.string());
          break;
        }
        case 29: {
          EA.os = AA.string();
          break;
        }
        case 30: {
          EA.timezone = AA.string();
          break;
        }
        case 31: {
          EA.headless = AA.bool();
          break;
        }
        case 32: {
          EA.isFragmentRun = AA.bool();
          break;
        }
        case 34: {
          EA.numPages = AA.int64();
          break;
        }
        case 37: {
          EA.pageScriptHash = AA.string();
          break;
        }
        case 38: {
          EA.activeTheme = AA.string();
          break;
        }
        case 39: {
          EA.totalLoadTime = AA.int64();
          break;
        }
        case 40: {
          EA.browserInfo = $root$1.BrowserInfo.decode(AA, AA.uint32());
          break;
        }
        case 45: {
          EA.serverMode = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.MetricsEvent) return AA;
    let IA = new $root$1.MetricsEvent();
    if (AA.event != null && (IA.event = String(AA.event)), AA.anonymousId != null && (IA.anonymousId = String(AA.anonymousId)), AA.machineIdV3 != null && (IA.machineIdV3 = String(AA.machineIdV3)), AA.machineIdV4 != null && (IA.machineIdV4 = String(AA.machineIdV4)), AA.reportHash != null && (IA.reportHash = String(AA.reportHash)), AA.dev != null && (IA.dev = !!AA.dev), AA.source != null && (IA.source = String(AA.source)), AA.streamlitVersion != null && (IA.streamlitVersion = String(AA.streamlitVersion)), AA.isHello != null && (IA.isHello = !!AA.isHello), AA.appId != null && (IA.appId = String(AA.appId)), AA.sessionId != null && (IA.sessionId = String(AA.sessionId)), AA.pythonVersion != null && (IA.pythonVersion = String(AA.pythonVersion)), AA.serverOs != null && (IA.serverOs = String(AA.serverOs)), AA.hasDisplay != null && (IA.hasDisplay = !!AA.hasDisplay), AA.isWebdriver != null && (IA.isWebdriver = !!AA.isWebdriver), AA.hostedAt != null && (IA.hostedAt = String(AA.hostedAt)), AA.owner != null && (IA.owner = String(AA.owner)), AA.repo != null && (IA.repo = String(AA.repo)), AA.branch != null && (IA.branch = String(AA.branch)), AA.mainModule != null && (IA.mainModule = String(AA.mainModule)), AA.creatorId != null && (IA.creatorId = String(AA.creatorId)), AA.contextPageUrl != null && (IA.contextPageUrl = String(AA.contextPageUrl)), AA.contextPageTitle != null && (IA.contextPageTitle = String(AA.contextPageTitle)), AA.contextPagePath != null && (IA.contextPagePath = String(AA.contextPagePath)), AA.contextPageReferrer != null && (IA.contextPageReferrer = String(AA.contextPageReferrer)), AA.contextPageSearch != null && (IA.contextPageSearch = String(AA.contextPageSearch)), AA.contextLocale != null && (IA.contextLocale = String(AA.contextLocale)), AA.contextUserAgent != null && (IA.contextUserAgent = String(AA.contextUserAgent)), AA.label != null && (IA.label = String(AA.label)), AA.commands) {
      if (!Array.isArray(AA.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      IA.commands = [];
      for (let BA = 0; BA < AA.commands.length; ++BA) {
        if (typeof AA.commands[BA] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        IA.commands[BA] = $root$1.Command.fromObject(AA.commands[BA]);
      }
    }
    if (AA.execTime != null && ($util$1.Long ? (IA.execTime = $util$1.Long.fromValue(AA.execTime)).unsigned = !1 : typeof AA.execTime == "string" ? IA.execTime = parseInt(AA.execTime, 10) : typeof AA.execTime == "number" ? IA.execTime = AA.execTime : typeof AA.execTime == "object" && (IA.execTime = new $util$1.LongBits(AA.execTime.low >>> 0, AA.execTime.high >>> 0).toNumber())), AA.prepTime != null && ($util$1.Long ? (IA.prepTime = $util$1.Long.fromValue(AA.prepTime)).unsigned = !1 : typeof AA.prepTime == "string" ? IA.prepTime = parseInt(AA.prepTime, 10) : typeof AA.prepTime == "number" ? IA.prepTime = AA.prepTime : typeof AA.prepTime == "object" && (IA.prepTime = new $util$1.LongBits(AA.prepTime.low >>> 0, AA.prepTime.high >>> 0).toNumber())), AA.config) {
      if (!Array.isArray(AA.config)) throw TypeError(".MetricsEvent.config: array expected");
      IA.config = [];
      for (let BA = 0; BA < AA.config.length; ++BA) IA.config[BA] = String(AA.config[BA]);
    }
    if (AA.uncaughtException != null && (IA.uncaughtException = String(AA.uncaughtException)), AA.attributions) {
      if (!Array.isArray(AA.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      IA.attributions = [];
      for (let BA = 0; BA < AA.attributions.length; ++BA) IA.attributions[BA] = String(AA.attributions[BA]);
    }
    if (AA.os != null && (IA.os = String(AA.os)), AA.timezone != null && (IA.timezone = String(AA.timezone)), AA.headless != null && (IA.headless = !!AA.headless), AA.isFragmentRun != null && (IA.isFragmentRun = !!AA.isFragmentRun), AA.numPages != null && ($util$1.Long ? (IA.numPages = $util$1.Long.fromValue(AA.numPages)).unsigned = !1 : typeof AA.numPages == "string" ? IA.numPages = parseInt(AA.numPages, 10) : typeof AA.numPages == "number" ? IA.numPages = AA.numPages : typeof AA.numPages == "object" && (IA.numPages = new $util$1.LongBits(AA.numPages.low >>> 0, AA.numPages.high >>> 0).toNumber())), AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.activeTheme != null && (IA.activeTheme = String(AA.activeTheme)), AA.totalLoadTime != null && ($util$1.Long ? (IA.totalLoadTime = $util$1.Long.fromValue(AA.totalLoadTime)).unsigned = !1 : typeof AA.totalLoadTime == "string" ? IA.totalLoadTime = parseInt(AA.totalLoadTime, 10) : typeof AA.totalLoadTime == "number" ? IA.totalLoadTime = AA.totalLoadTime : typeof AA.totalLoadTime == "object" && (IA.totalLoadTime = new $util$1.LongBits(AA.totalLoadTime.low >>> 0, AA.totalLoadTime.high >>> 0).toNumber())), AA.browserInfo != null) {
      if (typeof AA.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      IA.browserInfo = $root$1.BrowserInfo.fromObject(AA.browserInfo);
    }
    return AA.serverMode != null && (IA.serverMode = String(AA.serverMode)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.commands = [], BA.config = [], BA.attributions = []), IA.defaults) {
      if (BA.event = "", BA.anonymousId = "", BA.machineIdV3 = "", BA.reportHash = "", BA.dev = !1, BA.source = "", BA.streamlitVersion = "", BA.isHello = !1, BA.hostedAt = "", BA.owner = "", BA.repo = "", BA.branch = "", BA.mainModule = "", BA.creatorId = "", BA.contextPageUrl = "", BA.contextPageTitle = "", BA.contextPagePath = "", BA.contextPageReferrer = "", BA.contextPageSearch = "", BA.contextLocale = "", BA.contextUserAgent = "", BA.label = "", $util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.execTime = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.execTime = IA.longs === String ? "0" : 0;
      if ($util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.prepTime = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.prepTime = IA.longs === String ? "0" : 0;
      if (BA.uncaughtException = "", BA.os = "", BA.timezone = "", BA.headless = !1, BA.isFragmentRun = !1, BA.appId = "", $util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.numPages = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.numPages = IA.longs === String ? "0" : 0;
      if (BA.sessionId = "", BA.pythonVersion = "", BA.pageScriptHash = "", BA.activeTheme = "", $util$1.Long) {
        let QA = new $util$1.Long(0, 0, !1);
        BA.totalLoadTime = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.totalLoadTime = IA.longs === String ? "0" : 0;
      BA.browserInfo = null, BA.machineIdV4 = "", BA.serverOs = "", BA.hasDisplay = !1, BA.isWebdriver = !1, BA.serverMode = "";
    }
    if (AA.event != null && AA.hasOwnProperty("event") && (BA.event = AA.event), AA.anonymousId != null && AA.hasOwnProperty("anonymousId") && (BA.anonymousId = AA.anonymousId), AA.machineIdV3 != null && AA.hasOwnProperty("machineIdV3") && (BA.machineIdV3 = AA.machineIdV3), AA.reportHash != null && AA.hasOwnProperty("reportHash") && (BA.reportHash = AA.reportHash), AA.dev != null && AA.hasOwnProperty("dev") && (BA.dev = AA.dev), AA.source != null && AA.hasOwnProperty("source") && (BA.source = AA.source), AA.streamlitVersion != null && AA.hasOwnProperty("streamlitVersion") && (BA.streamlitVersion = AA.streamlitVersion), AA.isHello != null && AA.hasOwnProperty("isHello") && (BA.isHello = AA.isHello), AA.hostedAt != null && AA.hasOwnProperty("hostedAt") && (BA.hostedAt = AA.hostedAt), AA.owner != null && AA.hasOwnProperty("owner") && (BA.owner = AA.owner), AA.repo != null && AA.hasOwnProperty("repo") && (BA.repo = AA.repo), AA.branch != null && AA.hasOwnProperty("branch") && (BA.branch = AA.branch), AA.mainModule != null && AA.hasOwnProperty("mainModule") && (BA.mainModule = AA.mainModule), AA.creatorId != null && AA.hasOwnProperty("creatorId") && (BA.creatorId = AA.creatorId), AA.contextPageUrl != null && AA.hasOwnProperty("contextPageUrl") && (BA.contextPageUrl = AA.contextPageUrl), AA.contextPageTitle != null && AA.hasOwnProperty("contextPageTitle") && (BA.contextPageTitle = AA.contextPageTitle), AA.contextPagePath != null && AA.hasOwnProperty("contextPagePath") && (BA.contextPagePath = AA.contextPagePath), AA.contextPageReferrer != null && AA.hasOwnProperty("contextPageReferrer") && (BA.contextPageReferrer = AA.contextPageReferrer), AA.contextPageSearch != null && AA.hasOwnProperty("contextPageSearch") && (BA.contextPageSearch = AA.contextPageSearch), AA.contextLocale != null && AA.hasOwnProperty("contextLocale") && (BA.contextLocale = AA.contextLocale), AA.contextUserAgent != null && AA.hasOwnProperty("contextUserAgent") && (BA.contextUserAgent = AA.contextUserAgent), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.commands && AA.commands.length) {
      BA.commands = [];
      for (let QA = 0; QA < AA.commands.length; ++QA) BA.commands[QA] = $root$1.Command.toObject(AA.commands[QA], IA);
    }
    if (AA.execTime != null && AA.hasOwnProperty("execTime") && (typeof AA.execTime == "number" ? BA.execTime = IA.longs === String ? String(AA.execTime) : AA.execTime : BA.execTime = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.execTime) : IA.longs === Number ? new $util$1.LongBits(AA.execTime.low >>> 0, AA.execTime.high >>> 0).toNumber() : AA.execTime), AA.prepTime != null && AA.hasOwnProperty("prepTime") && (typeof AA.prepTime == "number" ? BA.prepTime = IA.longs === String ? String(AA.prepTime) : AA.prepTime : BA.prepTime = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.prepTime) : IA.longs === Number ? new $util$1.LongBits(AA.prepTime.low >>> 0, AA.prepTime.high >>> 0).toNumber() : AA.prepTime), AA.config && AA.config.length) {
      BA.config = [];
      for (let QA = 0; QA < AA.config.length; ++QA) BA.config[QA] = AA.config[QA];
    }
    if (AA.uncaughtException != null && AA.hasOwnProperty("uncaughtException") && (BA.uncaughtException = AA.uncaughtException), AA.attributions && AA.attributions.length) {
      BA.attributions = [];
      for (let QA = 0; QA < AA.attributions.length; ++QA) BA.attributions[QA] = AA.attributions[QA];
    }
    return AA.os != null && AA.hasOwnProperty("os") && (BA.os = AA.os), AA.timezone != null && AA.hasOwnProperty("timezone") && (BA.timezone = AA.timezone), AA.headless != null && AA.hasOwnProperty("headless") && (BA.headless = AA.headless), AA.isFragmentRun != null && AA.hasOwnProperty("isFragmentRun") && (BA.isFragmentRun = AA.isFragmentRun), AA.appId != null && AA.hasOwnProperty("appId") && (BA.appId = AA.appId), AA.numPages != null && AA.hasOwnProperty("numPages") && (typeof AA.numPages == "number" ? BA.numPages = IA.longs === String ? String(AA.numPages) : AA.numPages : BA.numPages = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.numPages) : IA.longs === Number ? new $util$1.LongBits(AA.numPages.low >>> 0, AA.numPages.high >>> 0).toNumber() : AA.numPages), AA.sessionId != null && AA.hasOwnProperty("sessionId") && (BA.sessionId = AA.sessionId), AA.pythonVersion != null && AA.hasOwnProperty("pythonVersion") && (BA.pythonVersion = AA.pythonVersion), AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.activeTheme != null && AA.hasOwnProperty("activeTheme") && (BA.activeTheme = AA.activeTheme), AA.totalLoadTime != null && AA.hasOwnProperty("totalLoadTime") && (typeof AA.totalLoadTime == "number" ? BA.totalLoadTime = IA.longs === String ? String(AA.totalLoadTime) : AA.totalLoadTime : BA.totalLoadTime = IA.longs === String ? $util$1.Long.prototype.toString.call(AA.totalLoadTime) : IA.longs === Number ? new $util$1.LongBits(AA.totalLoadTime.low >>> 0, AA.totalLoadTime.high >>> 0).toNumber() : AA.totalLoadTime), AA.browserInfo != null && AA.hasOwnProperty("browserInfo") && (BA.browserInfo = $root$1.BrowserInfo.toObject(AA.browserInfo, IA)), AA.machineIdV4 != null && AA.hasOwnProperty("machineIdV4") && (BA.machineIdV4 = AA.machineIdV4), AA.serverOs != null && AA.hasOwnProperty("serverOs") && (BA.serverOs = AA.serverOs), AA.hasDisplay != null && AA.hasOwnProperty("hasDisplay") && (BA.hasDisplay = AA.hasDisplay), AA.isWebdriver != null && AA.hasOwnProperty("isWebdriver") && (BA.isWebdriver = AA.isWebdriver), AA.serverMode != null && AA.hasOwnProperty("serverMode") && (BA.serverMode = AA.serverMode), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/MetricsEvent";
  }, CA;
})();
$root$1.BrowserInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.browserName = "", CA.prototype.browserVersion = "", CA.prototype.deviceType = "", CA.prototype.os = "", CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA || (IA = $Writer$1.create()), AA.browserName != null && Object.hasOwnProperty.call(AA, "browserName") && IA.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(AA.browserName), AA.browserVersion != null && Object.hasOwnProperty.call(AA, "browserVersion") && IA.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(AA.browserVersion), AA.deviceType != null && Object.hasOwnProperty.call(AA, "deviceType") && IA.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(AA.deviceType), AA.os != null && Object.hasOwnProperty.call(AA, "os") && IA.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(AA.os), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader$1 || (AA = $Reader$1.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root$1.BrowserInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1: {
          EA.browserName = AA.string();
          break;
        }
        case 2: {
          EA.browserVersion = AA.string();
          break;
        }
        case 3: {
          EA.deviceType = AA.string();
          break;
        }
        case 4: {
          EA.os = AA.string();
          break;
        }
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root$1.BrowserInfo) return AA;
    let IA = new $root$1.BrowserInfo();
    return AA.browserName != null && (IA.browserName = String(AA.browserName)), AA.browserVersion != null && (IA.browserVersion = String(AA.browserVersion)), AA.deviceType != null && (IA.deviceType = String(AA.deviceType)), AA.os != null && (IA.os = String(AA.os)), IA;
  }, CA.toObject = function(AA, IA) {
    IA || (IA = {});
    let BA = {};
    return IA.defaults && (BA.browserName = "", BA.browserVersion = "", BA.deviceType = "", BA.os = ""), AA.browserName != null && AA.hasOwnProperty("browserName") && (BA.browserName = AA.browserName), AA.browserVersion != null && AA.hasOwnProperty("browserVersion") && (BA.browserVersion = AA.browserVersion), AA.deviceType != null && AA.hasOwnProperty("deviceType") && (BA.deviceType = AA.deviceType), AA.os != null && AA.hasOwnProperty("os") && (BA.os = AA.os), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/BrowserInfo";
  }, CA;
})();
$root$1.openmetrics = (() => {
  const CA = {};
  return CA.MetricSet = (function() {
    function gA(AA) {
      if (this.metricFamilies = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.metricFamilies = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.metricFamilies != null && IA.metricFamilies.length) for (let QA = 0; QA < IA.metricFamilies.length; ++QA) $root$1.openmetrics.MetricFamily.encode(IA.metricFamilies[QA], BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.MetricSet();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? (iA.metricFamilies && iA.metricFamilies.length || (iA.metricFamilies = []), iA.metricFamilies.push($root$1.openmetrics.MetricFamily.decode(IA, IA.uint32()))) : IA.skipType(oA & 7);
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.MetricSet) return IA;
      let BA = new $root$1.openmetrics.MetricSet();
      if (IA.metricFamilies) {
        if (!Array.isArray(IA.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        BA.metricFamilies = [];
        for (let QA = 0; QA < IA.metricFamilies.length; ++QA) {
          if (typeof IA.metricFamilies[QA] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          BA.metricFamilies[QA] = $root$1.openmetrics.MetricFamily.fromObject(IA.metricFamilies[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.metricFamilies = []), IA.metricFamilies && IA.metricFamilies.length) {
        QA.metricFamilies = [];
        for (let EA = 0; EA < IA.metricFamilies.length; ++EA) QA.metricFamilies[EA] = $root$1.openmetrics.MetricFamily.toObject(IA.metricFamilies[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.MetricSet";
    }, gA;
  })(), CA.MetricFamily = (function() {
    function gA(AA) {
      if (this.metrics = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.name = "", gA.prototype.type = 0, gA.prototype.unit = "", gA.prototype.help = "", gA.prototype.metrics = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.name != null && Object.hasOwnProperty.call(IA, "name") && BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(IA.name), IA.type != null && Object.hasOwnProperty.call(IA, "type") && BA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(IA.type), IA.unit != null && Object.hasOwnProperty.call(IA, "unit") && BA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(IA.unit), IA.help != null && Object.hasOwnProperty.call(IA, "help") && BA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(IA.help), IA.metrics != null && IA.metrics.length) for (let QA = 0; QA < IA.metrics.length; ++QA) $root$1.Metric.encode(IA.metrics[QA], BA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.MetricFamily();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1: {
            iA.name = IA.string();
            break;
          }
          case 2: {
            iA.type = IA.int32();
            break;
          }
          case 3: {
            iA.unit = IA.string();
            break;
          }
          case 4: {
            iA.help = IA.string();
            break;
          }
          case 5: {
            iA.metrics && iA.metrics.length || (iA.metrics = []), iA.metrics.push($root$1.Metric.decode(IA, IA.uint32()));
            break;
          }
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.MetricFamily) return IA;
      let BA = new $root$1.openmetrics.MetricFamily();
      switch (IA.name != null && (BA.name = String(IA.name)), IA.type) {
        default:
          if (typeof IA.type == "number") {
            BA.type = IA.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          BA.type = 0;
          break;
        case "GAUGE":
        case 1:
          BA.type = 1;
          break;
        case "COUNTER":
        case 2:
          BA.type = 2;
          break;
        case "STATE_SET":
        case 3:
          BA.type = 3;
          break;
        case "INFO":
        case 4:
          BA.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          BA.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          BA.type = 6;
          break;
        case "SUMMARY":
        case 7:
          BA.type = 7;
          break;
      }
      if (IA.unit != null && (BA.unit = String(IA.unit)), IA.help != null && (BA.help = String(IA.help)), IA.metrics) {
        if (!Array.isArray(IA.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        BA.metrics = [];
        for (let QA = 0; QA < IA.metrics.length; ++QA) {
          if (typeof IA.metrics[QA] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          BA.metrics[QA] = $root$1.Metric.fromObject(IA.metrics[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.metrics = []), BA.defaults && (QA.name = "", QA.type = BA.enums === String ? "UNKNOWN" : 0, QA.unit = "", QA.help = ""), IA.name != null && IA.hasOwnProperty("name") && (QA.name = IA.name), IA.type != null && IA.hasOwnProperty("type") && (QA.type = BA.enums === String ? $root$1.openmetrics.MetricType[IA.type] === void 0 ? IA.type : $root$1.openmetrics.MetricType[IA.type] : IA.type), IA.unit != null && IA.hasOwnProperty("unit") && (QA.unit = IA.unit), IA.help != null && IA.hasOwnProperty("help") && (QA.help = IA.help), IA.metrics && IA.metrics.length) {
        QA.metrics = [];
        for (let EA = 0; EA < IA.metrics.length; ++EA) QA.metrics[EA] = $root$1.Metric.toObject(IA.metrics[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.MetricFamily";
    }, gA;
  })(), CA.MetricType = (function() {
    const gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNKNOWN"] = 0, AA[gA[1] = "GAUGE"] = 1, AA[gA[2] = "COUNTER"] = 2, AA[gA[3] = "STATE_SET"] = 3, AA[gA[4] = "INFO"] = 4, AA[gA[5] = "HISTOGRAM"] = 5, AA[gA[6] = "GAUGE_HISTOGRAM"] = 6, AA[gA[7] = "SUMMARY"] = 7, AA;
  })(), CA.Metric = (function() {
    function gA(AA) {
      if (this.labels = [], this.metricPoints = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.labels = $util$1.emptyArray, gA.prototype.metricPoints = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.labels != null && IA.labels.length) for (let QA = 0; QA < IA.labels.length; ++QA) $root$1.openmetrics.Label.encode(IA.labels[QA], BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      if (IA.metricPoints != null && IA.metricPoints.length) for (let QA = 0; QA < IA.metricPoints.length; ++QA) $root$1.openmetrics.MetricPoint.encode(IA.metricPoints[QA], BA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.Metric();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1: {
            iA.labels && iA.labels.length || (iA.labels = []), iA.labels.push($root$1.openmetrics.Label.decode(IA, IA.uint32()));
            break;
          }
          case 2: {
            iA.metricPoints && iA.metricPoints.length || (iA.metricPoints = []), iA.metricPoints.push($root$1.openmetrics.MetricPoint.decode(IA, IA.uint32()));
            break;
          }
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.Metric) return IA;
      let BA = new $root$1.openmetrics.Metric();
      if (IA.labels) {
        if (!Array.isArray(IA.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        BA.labels = [];
        for (let QA = 0; QA < IA.labels.length; ++QA) {
          if (typeof IA.labels[QA] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          BA.labels[QA] = $root$1.openmetrics.Label.fromObject(IA.labels[QA]);
        }
      }
      if (IA.metricPoints) {
        if (!Array.isArray(IA.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        BA.metricPoints = [];
        for (let QA = 0; QA < IA.metricPoints.length; ++QA) {
          if (typeof IA.metricPoints[QA] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          BA.metricPoints[QA] = $root$1.openmetrics.MetricPoint.fromObject(IA.metricPoints[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.labels = [], QA.metricPoints = []), IA.labels && IA.labels.length) {
        QA.labels = [];
        for (let EA = 0; EA < IA.labels.length; ++EA) QA.labels[EA] = $root$1.openmetrics.Label.toObject(IA.labels[EA], BA);
      }
      if (IA.metricPoints && IA.metricPoints.length) {
        QA.metricPoints = [];
        for (let EA = 0; EA < IA.metricPoints.length; ++EA) QA.metricPoints[EA] = $root$1.openmetrics.MetricPoint.toObject(IA.metricPoints[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.Metric";
    }, gA;
  })(), CA.Label = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.name = "", gA.prototype.value = "", gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA || (BA = $Writer$1.create()), IA.name != null && Object.hasOwnProperty.call(IA, "name") && BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(IA.name), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(IA.value), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.Label();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1: {
            iA.name = IA.string();
            break;
          }
          case 2: {
            iA.value = IA.string();
            break;
          }
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.Label) return IA;
      let BA = new $root$1.openmetrics.Label();
      return IA.name != null && (BA.name = String(IA.name)), IA.value != null && (BA.value = String(IA.value)), BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      return BA.defaults && (QA.name = "", QA.value = ""), IA.name != null && IA.hasOwnProperty("name") && (QA.name = IA.name), IA.value != null && IA.hasOwnProperty("value") && (QA.value = IA.value), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.Label";
    }, gA;
  })(), CA.MetricPoint = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.unknownValue = null, gA.prototype.gaugeValue = null, gA.prototype.counterValue = null, gA.prototype.histogramValue = null, gA.prototype.stateSetValue = null, gA.prototype.infoValue = null, gA.prototype.summaryValue = null, gA.prototype.timestamp = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util$1.oneOfGetter(AA = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.unknownValue != null && Object.hasOwnProperty.call(BA, "unknownValue") && $root$1.openmetrics.UnknownValue.encode(BA.unknownValue, QA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), BA.gaugeValue != null && Object.hasOwnProperty.call(BA, "gaugeValue") && $root$1.openmetrics.GaugeValue.encode(BA.gaugeValue, QA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), BA.counterValue != null && Object.hasOwnProperty.call(BA, "counterValue") && $root$1.openmetrics.CounterValue.encode(BA.counterValue, QA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), BA.histogramValue != null && Object.hasOwnProperty.call(BA, "histogramValue") && $root$1.openmetrics.HistogramValue.encode(BA.histogramValue, QA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), BA.stateSetValue != null && Object.hasOwnProperty.call(BA, "stateSetValue") && $root$1.openmetrics.StateSetValue.encode(BA.stateSetValue, QA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), BA.infoValue != null && Object.hasOwnProperty.call(BA, "infoValue") && $root$1.openmetrics.InfoValue.encode(BA.infoValue, QA.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), BA.summaryValue != null && Object.hasOwnProperty.call(BA, "summaryValue") && $root$1.openmetrics.SummaryValue.encode(BA.summaryValue, QA.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), BA.timestamp != null && Object.hasOwnProperty.call(BA, "timestamp") && $root$1.google.protobuf.Timestamp.encode(BA.timestamp, QA.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.MetricPoint();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.unknownValue = $root$1.openmetrics.UnknownValue.decode(BA, BA.uint32());
            break;
          }
          case 2: {
            oA.gaugeValue = $root$1.openmetrics.GaugeValue.decode(BA, BA.uint32());
            break;
          }
          case 3: {
            oA.counterValue = $root$1.openmetrics.CounterValue.decode(BA, BA.uint32());
            break;
          }
          case 4: {
            oA.histogramValue = $root$1.openmetrics.HistogramValue.decode(BA, BA.uint32());
            break;
          }
          case 5: {
            oA.stateSetValue = $root$1.openmetrics.StateSetValue.decode(BA, BA.uint32());
            break;
          }
          case 6: {
            oA.infoValue = $root$1.openmetrics.InfoValue.decode(BA, BA.uint32());
            break;
          }
          case 7: {
            oA.summaryValue = $root$1.openmetrics.SummaryValue.decode(BA, BA.uint32());
            break;
          }
          case 8: {
            oA.timestamp = $root$1.google.protobuf.Timestamp.decode(BA, BA.uint32());
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.MetricPoint) return BA;
      let QA = new $root$1.openmetrics.MetricPoint();
      if (BA.unknownValue != null) {
        if (typeof BA.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        QA.unknownValue = $root$1.openmetrics.UnknownValue.fromObject(BA.unknownValue);
      }
      if (BA.gaugeValue != null) {
        if (typeof BA.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        QA.gaugeValue = $root$1.openmetrics.GaugeValue.fromObject(BA.gaugeValue);
      }
      if (BA.counterValue != null) {
        if (typeof BA.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        QA.counterValue = $root$1.openmetrics.CounterValue.fromObject(BA.counterValue);
      }
      if (BA.histogramValue != null) {
        if (typeof BA.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        QA.histogramValue = $root$1.openmetrics.HistogramValue.fromObject(BA.histogramValue);
      }
      if (BA.stateSetValue != null) {
        if (typeof BA.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        QA.stateSetValue = $root$1.openmetrics.StateSetValue.fromObject(BA.stateSetValue);
      }
      if (BA.infoValue != null) {
        if (typeof BA.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        QA.infoValue = $root$1.openmetrics.InfoValue.fromObject(BA.infoValue);
      }
      if (BA.summaryValue != null) {
        if (typeof BA.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        QA.summaryValue = $root$1.openmetrics.SummaryValue.fromObject(BA.summaryValue);
      }
      if (BA.timestamp != null) {
        if (typeof BA.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        QA.timestamp = $root$1.google.protobuf.Timestamp.fromObject(BA.timestamp);
      }
      return QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.timestamp = null), BA.unknownValue != null && BA.hasOwnProperty("unknownValue") && (EA.unknownValue = $root$1.openmetrics.UnknownValue.toObject(BA.unknownValue, QA), QA.oneofs && (EA.value = "unknownValue")), BA.gaugeValue != null && BA.hasOwnProperty("gaugeValue") && (EA.gaugeValue = $root$1.openmetrics.GaugeValue.toObject(BA.gaugeValue, QA), QA.oneofs && (EA.value = "gaugeValue")), BA.counterValue != null && BA.hasOwnProperty("counterValue") && (EA.counterValue = $root$1.openmetrics.CounterValue.toObject(BA.counterValue, QA), QA.oneofs && (EA.value = "counterValue")), BA.histogramValue != null && BA.hasOwnProperty("histogramValue") && (EA.histogramValue = $root$1.openmetrics.HistogramValue.toObject(BA.histogramValue, QA), QA.oneofs && (EA.value = "histogramValue")), BA.stateSetValue != null && BA.hasOwnProperty("stateSetValue") && (EA.stateSetValue = $root$1.openmetrics.StateSetValue.toObject(BA.stateSetValue, QA), QA.oneofs && (EA.value = "stateSetValue")), BA.infoValue != null && BA.hasOwnProperty("infoValue") && (EA.infoValue = $root$1.openmetrics.InfoValue.toObject(BA.infoValue, QA), QA.oneofs && (EA.value = "infoValue")), BA.summaryValue != null && BA.hasOwnProperty("summaryValue") && (EA.summaryValue = $root$1.openmetrics.SummaryValue.toObject(BA.summaryValue, QA), QA.oneofs && (EA.value = "summaryValue")), BA.timestamp != null && BA.hasOwnProperty("timestamp") && (EA.timestamp = $root$1.google.protobuf.Timestamp.toObject(BA.timestamp, QA)), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.MetricPoint";
    }, gA;
  })(), CA.UnknownValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util$1.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.doubleValue != null && Object.hasOwnProperty.call(BA, "doubleValue") && QA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(BA.doubleValue), BA.intValue != null && Object.hasOwnProperty.call(BA, "intValue") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(BA.intValue), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.UnknownValue();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.doubleValue = BA.double();
            break;
          }
          case 2: {
            oA.intValue = BA.int64();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.UnknownValue) return BA;
      let QA = new $root$1.openmetrics.UnknownValue();
      return BA.doubleValue != null && (QA.doubleValue = Number(BA.doubleValue)), BA.intValue != null && ($util$1.Long ? (QA.intValue = $util$1.Long.fromValue(BA.intValue)).unsigned = !1 : typeof BA.intValue == "string" ? QA.intValue = parseInt(BA.intValue, 10) : typeof BA.intValue == "number" ? QA.intValue = BA.intValue : typeof BA.intValue == "object" && (QA.intValue = new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber())), QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return BA.doubleValue != null && BA.hasOwnProperty("doubleValue") && (EA.doubleValue = QA.json && !isFinite(BA.doubleValue) ? String(BA.doubleValue) : BA.doubleValue, QA.oneofs && (EA.value = "doubleValue")), BA.intValue != null && BA.hasOwnProperty("intValue") && (typeof BA.intValue == "number" ? EA.intValue = QA.longs === String ? String(BA.intValue) : BA.intValue : EA.intValue = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.intValue) : QA.longs === Number ? new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber() : BA.intValue, QA.oneofs && (EA.value = "intValue")), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.UnknownValue";
    }, gA;
  })(), CA.GaugeValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util$1.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.doubleValue != null && Object.hasOwnProperty.call(BA, "doubleValue") && QA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(BA.doubleValue), BA.intValue != null && Object.hasOwnProperty.call(BA, "intValue") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(BA.intValue), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.GaugeValue();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.doubleValue = BA.double();
            break;
          }
          case 2: {
            oA.intValue = BA.int64();
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.GaugeValue) return BA;
      let QA = new $root$1.openmetrics.GaugeValue();
      return BA.doubleValue != null && (QA.doubleValue = Number(BA.doubleValue)), BA.intValue != null && ($util$1.Long ? (QA.intValue = $util$1.Long.fromValue(BA.intValue)).unsigned = !1 : typeof BA.intValue == "string" ? QA.intValue = parseInt(BA.intValue, 10) : typeof BA.intValue == "number" ? QA.intValue = BA.intValue : typeof BA.intValue == "object" && (QA.intValue = new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber())), QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return BA.doubleValue != null && BA.hasOwnProperty("doubleValue") && (EA.doubleValue = QA.json && !isFinite(BA.doubleValue) ? String(BA.doubleValue) : BA.doubleValue, QA.oneofs && (EA.value = "doubleValue")), BA.intValue != null && BA.hasOwnProperty("intValue") && (typeof BA.intValue == "number" ? EA.intValue = QA.longs === String ? String(BA.intValue) : BA.intValue : EA.intValue = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.intValue) : QA.longs === Number ? new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber() : BA.intValue, QA.oneofs && (EA.value = "intValue")), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.GaugeValue";
    }, gA;
  })(), CA.CounterValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.created = null, gA.prototype.exemplar = null;
    let AA;
    return Object.defineProperty(gA.prototype, "total", { get: $util$1.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      return QA || (QA = $Writer$1.create()), BA.doubleValue != null && Object.hasOwnProperty.call(BA, "doubleValue") && QA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(BA.doubleValue), BA.intValue != null && Object.hasOwnProperty.call(BA, "intValue") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(BA.intValue), BA.created != null && Object.hasOwnProperty.call(BA, "created") && $root$1.google.protobuf.Timestamp.encode(BA.created, QA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), BA.exemplar != null && Object.hasOwnProperty.call(BA, "exemplar") && $root$1.openmetrics.Exemplar.encode(BA.exemplar, QA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.CounterValue();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.doubleValue = BA.double();
            break;
          }
          case 2: {
            oA.intValue = BA.uint64();
            break;
          }
          case 3: {
            oA.created = $root$1.google.protobuf.Timestamp.decode(BA, BA.uint32());
            break;
          }
          case 4: {
            oA.exemplar = $root$1.openmetrics.Exemplar.decode(BA, BA.uint32());
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.CounterValue) return BA;
      let QA = new $root$1.openmetrics.CounterValue();
      if (BA.doubleValue != null && (QA.doubleValue = Number(BA.doubleValue)), BA.intValue != null && ($util$1.Long ? (QA.intValue = $util$1.Long.fromValue(BA.intValue)).unsigned = !0 : typeof BA.intValue == "string" ? QA.intValue = parseInt(BA.intValue, 10) : typeof BA.intValue == "number" ? QA.intValue = BA.intValue : typeof BA.intValue == "object" && (QA.intValue = new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber(!0))), BA.created != null) {
        if (typeof BA.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        QA.created = $root$1.google.protobuf.Timestamp.fromObject(BA.created);
      }
      if (BA.exemplar != null) {
        if (typeof BA.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        QA.exemplar = $root$1.openmetrics.Exemplar.fromObject(BA.exemplar);
      }
      return QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      return QA.defaults && (EA.created = null, EA.exemplar = null), BA.doubleValue != null && BA.hasOwnProperty("doubleValue") && (EA.doubleValue = QA.json && !isFinite(BA.doubleValue) ? String(BA.doubleValue) : BA.doubleValue, QA.oneofs && (EA.total = "doubleValue")), BA.intValue != null && BA.hasOwnProperty("intValue") && (typeof BA.intValue == "number" ? EA.intValue = QA.longs === String ? String(BA.intValue) : BA.intValue : EA.intValue = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.intValue) : QA.longs === Number ? new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber(!0) : BA.intValue, QA.oneofs && (EA.total = "intValue")), BA.created != null && BA.hasOwnProperty("created") && (EA.created = $root$1.google.protobuf.Timestamp.toObject(BA.created, QA)), BA.exemplar != null && BA.hasOwnProperty("exemplar") && (EA.exemplar = $root$1.openmetrics.Exemplar.toObject(BA.exemplar, QA)), EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.CounterValue";
    }, gA;
  })(), CA.HistogramValue = (function() {
    function gA(IA) {
      if (this.buckets = [], IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, gA.prototype.created = null, gA.prototype.buckets = $util$1.emptyArray;
    let AA;
    return Object.defineProperty(gA.prototype, "sum", { get: $util$1.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      if (QA || (QA = $Writer$1.create()), BA.doubleValue != null && Object.hasOwnProperty.call(BA, "doubleValue") && QA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(BA.doubleValue), BA.intValue != null && Object.hasOwnProperty.call(BA, "intValue") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(BA.intValue), BA.count != null && Object.hasOwnProperty.call(BA, "count") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(BA.count), BA.created != null && Object.hasOwnProperty.call(BA, "created") && $root$1.google.protobuf.Timestamp.encode(BA.created, QA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), BA.buckets != null && BA.buckets.length) for (let EA = 0; EA < BA.buckets.length; ++EA) $root$1.openmetrics.HistogramValue.Bucket.encode(BA.buckets[EA], QA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.HistogramValue();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.doubleValue = BA.double();
            break;
          }
          case 2: {
            oA.intValue = BA.int64();
            break;
          }
          case 3: {
            oA.count = BA.uint64();
            break;
          }
          case 4: {
            oA.created = $root$1.google.protobuf.Timestamp.decode(BA, BA.uint32());
            break;
          }
          case 5: {
            oA.buckets && oA.buckets.length || (oA.buckets = []), oA.buckets.push($root$1.openmetrics.HistogramValue.Bucket.decode(BA, BA.uint32()));
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.HistogramValue) return BA;
      let QA = new $root$1.openmetrics.HistogramValue();
      if (BA.doubleValue != null && (QA.doubleValue = Number(BA.doubleValue)), BA.intValue != null && ($util$1.Long ? (QA.intValue = $util$1.Long.fromValue(BA.intValue)).unsigned = !1 : typeof BA.intValue == "string" ? QA.intValue = parseInt(BA.intValue, 10) : typeof BA.intValue == "number" ? QA.intValue = BA.intValue : typeof BA.intValue == "object" && (QA.intValue = new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber())), BA.count != null && ($util$1.Long ? (QA.count = $util$1.Long.fromValue(BA.count)).unsigned = !0 : typeof BA.count == "string" ? QA.count = parseInt(BA.count, 10) : typeof BA.count == "number" ? QA.count = BA.count : typeof BA.count == "object" && (QA.count = new $util$1.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0))), BA.created != null) {
        if (typeof BA.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        QA.created = $root$1.google.protobuf.Timestamp.fromObject(BA.created);
      }
      if (BA.buckets) {
        if (!Array.isArray(BA.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        QA.buckets = [];
        for (let EA = 0; EA < BA.buckets.length; ++EA) {
          if (typeof BA.buckets[EA] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          QA.buckets[EA] = $root$1.openmetrics.HistogramValue.Bucket.fromObject(BA.buckets[EA]);
        }
      }
      return QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      if ((QA.arrays || QA.defaults) && (EA.buckets = []), QA.defaults) {
        if ($util$1.Long) {
          let iA = new $util$1.Long(0, 0, !0);
          EA.count = QA.longs === String ? iA.toString() : QA.longs === Number ? iA.toNumber() : iA;
        } else EA.count = QA.longs === String ? "0" : 0;
        EA.created = null;
      }
      if (BA.doubleValue != null && BA.hasOwnProperty("doubleValue") && (EA.doubleValue = QA.json && !isFinite(BA.doubleValue) ? String(BA.doubleValue) : BA.doubleValue, QA.oneofs && (EA.sum = "doubleValue")), BA.intValue != null && BA.hasOwnProperty("intValue") && (typeof BA.intValue == "number" ? EA.intValue = QA.longs === String ? String(BA.intValue) : BA.intValue : EA.intValue = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.intValue) : QA.longs === Number ? new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber() : BA.intValue, QA.oneofs && (EA.sum = "intValue")), BA.count != null && BA.hasOwnProperty("count") && (typeof BA.count == "number" ? EA.count = QA.longs === String ? String(BA.count) : BA.count : EA.count = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.count) : QA.longs === Number ? new $util$1.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0) : BA.count), BA.created != null && BA.hasOwnProperty("created") && (EA.created = $root$1.google.protobuf.Timestamp.toObject(BA.created, QA)), BA.buckets && BA.buckets.length) {
        EA.buckets = [];
        for (let iA = 0; iA < BA.buckets.length; ++iA) EA.buckets[iA] = $root$1.openmetrics.HistogramValue.Bucket.toObject(BA.buckets[iA], QA);
      }
      return EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.HistogramValue";
    }, gA.Bucket = (function() {
      function IA(BA) {
        if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
      }
      return IA.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, IA.prototype.upperBound = 0, IA.prototype.exemplar = null, IA.create = function(QA) {
        return new IA(QA);
      }, IA.encode = function(QA, EA) {
        return EA || (EA = $Writer$1.create()), QA.count != null && Object.hasOwnProperty.call(QA, "count") && EA.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(QA.count), QA.upperBound != null && Object.hasOwnProperty.call(QA, "upperBound") && EA.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(QA.upperBound), QA.exemplar != null && Object.hasOwnProperty.call(QA, "exemplar") && $root$1.openmetrics.Exemplar.encode(QA.exemplar, EA.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), EA;
      }, IA.decode = function(QA, EA, iA) {
        QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
        let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.openmetrics.HistogramValue.Bucket();
        for (; QA.pos < oA; ) {
          let tA = QA.uint32();
          if (tA === iA) break;
          switch (tA >>> 3) {
            case 1: {
              cA.count = QA.uint64();
              break;
            }
            case 2: {
              cA.upperBound = QA.double();
              break;
            }
            case 3: {
              cA.exemplar = $root$1.openmetrics.Exemplar.decode(QA, QA.uint32());
              break;
            }
            default:
              QA.skipType(tA & 7);
              break;
          }
        }
        return cA;
      }, IA.fromObject = function(QA) {
        if (QA instanceof $root$1.openmetrics.HistogramValue.Bucket) return QA;
        let EA = new $root$1.openmetrics.HistogramValue.Bucket();
        if (QA.count != null && ($util$1.Long ? (EA.count = $util$1.Long.fromValue(QA.count)).unsigned = !0 : typeof QA.count == "string" ? EA.count = parseInt(QA.count, 10) : typeof QA.count == "number" ? EA.count = QA.count : typeof QA.count == "object" && (EA.count = new $util$1.LongBits(QA.count.low >>> 0, QA.count.high >>> 0).toNumber(!0))), QA.upperBound != null && (EA.upperBound = Number(QA.upperBound)), QA.exemplar != null) {
          if (typeof QA.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          EA.exemplar = $root$1.openmetrics.Exemplar.fromObject(QA.exemplar);
        }
        return EA;
      }, IA.toObject = function(QA, EA) {
        EA || (EA = {});
        let iA = {};
        if (EA.defaults) {
          if ($util$1.Long) {
            let oA = new $util$1.Long(0, 0, !0);
            iA.count = EA.longs === String ? oA.toString() : EA.longs === Number ? oA.toNumber() : oA;
          } else iA.count = EA.longs === String ? "0" : 0;
          iA.upperBound = 0, iA.exemplar = null;
        }
        return QA.count != null && QA.hasOwnProperty("count") && (typeof QA.count == "number" ? iA.count = EA.longs === String ? String(QA.count) : QA.count : iA.count = EA.longs === String ? $util$1.Long.prototype.toString.call(QA.count) : EA.longs === Number ? new $util$1.LongBits(QA.count.low >>> 0, QA.count.high >>> 0).toNumber(!0) : QA.count), QA.upperBound != null && QA.hasOwnProperty("upperBound") && (iA.upperBound = EA.json && !isFinite(QA.upperBound) ? String(QA.upperBound) : QA.upperBound), QA.exemplar != null && QA.hasOwnProperty("exemplar") && (iA.exemplar = $root$1.openmetrics.Exemplar.toObject(QA.exemplar, EA)), iA;
      }, IA.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, IA.getTypeUrl = function(QA) {
        return QA === void 0 && (QA = "type.googleapis.com"), QA + "/openmetrics.HistogramValue.Bucket";
      }, IA;
    })(), gA;
  })(), CA.Exemplar = (function() {
    function gA(AA) {
      if (this.label = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.value = 0, gA.prototype.timestamp = null, gA.prototype.label = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.value != null && Object.hasOwnProperty.call(IA, "value") && BA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(IA.value), IA.timestamp != null && Object.hasOwnProperty.call(IA, "timestamp") && $root$1.google.protobuf.Timestamp.encode(IA.timestamp, BA.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), IA.label != null && IA.label.length) for (let QA = 0; QA < IA.label.length; ++QA) $root$1.openmetrics.Label.encode(IA.label[QA], BA.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.Exemplar();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1: {
            iA.value = IA.double();
            break;
          }
          case 2: {
            iA.timestamp = $root$1.google.protobuf.Timestamp.decode(IA, IA.uint32());
            break;
          }
          case 3: {
            iA.label && iA.label.length || (iA.label = []), iA.label.push($root$1.openmetrics.Label.decode(IA, IA.uint32()));
            break;
          }
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.Exemplar) return IA;
      let BA = new $root$1.openmetrics.Exemplar();
      if (IA.value != null && (BA.value = Number(IA.value)), IA.timestamp != null) {
        if (typeof IA.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        BA.timestamp = $root$1.google.protobuf.Timestamp.fromObject(IA.timestamp);
      }
      if (IA.label) {
        if (!Array.isArray(IA.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        BA.label = [];
        for (let QA = 0; QA < IA.label.length; ++QA) {
          if (typeof IA.label[QA] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          BA.label[QA] = $root$1.openmetrics.Label.fromObject(IA.label[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.label = []), BA.defaults && (QA.value = 0, QA.timestamp = null), IA.value != null && IA.hasOwnProperty("value") && (QA.value = BA.json && !isFinite(IA.value) ? String(IA.value) : IA.value), IA.timestamp != null && IA.hasOwnProperty("timestamp") && (QA.timestamp = $root$1.google.protobuf.Timestamp.toObject(IA.timestamp, BA)), IA.label && IA.label.length) {
        QA.label = [];
        for (let EA = 0; EA < IA.label.length; ++EA) QA.label[EA] = $root$1.openmetrics.Label.toObject(IA.label[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.Exemplar";
    }, gA;
  })(), CA.StateSetValue = (function() {
    function gA(AA) {
      if (this.states = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.states = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.states != null && IA.states.length) for (let QA = 0; QA < IA.states.length; ++QA) $root$1.openmetrics.StateSetValue.State.encode(IA.states[QA], BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.StateSetValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? (iA.states && iA.states.length || (iA.states = []), iA.states.push($root$1.openmetrics.StateSetValue.State.decode(IA, IA.uint32()))) : IA.skipType(oA & 7);
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.StateSetValue) return IA;
      let BA = new $root$1.openmetrics.StateSetValue();
      if (IA.states) {
        if (!Array.isArray(IA.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        BA.states = [];
        for (let QA = 0; QA < IA.states.length; ++QA) {
          if (typeof IA.states[QA] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          BA.states[QA] = $root$1.openmetrics.StateSetValue.State.fromObject(IA.states[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.states = []), IA.states && IA.states.length) {
        QA.states = [];
        for (let EA = 0; EA < IA.states.length; ++EA) QA.states[EA] = $root$1.openmetrics.StateSetValue.State.toObject(IA.states[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.StateSetValue";
    }, gA.State = (function() {
      function AA(IA) {
        if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
      }
      return AA.prototype.enabled = !1, AA.prototype.name = "", AA.create = function(BA) {
        return new AA(BA);
      }, AA.encode = function(BA, QA) {
        return QA || (QA = $Writer$1.create()), BA.enabled != null && Object.hasOwnProperty.call(BA, "enabled") && QA.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(BA.enabled), BA.name != null && Object.hasOwnProperty.call(BA, "name") && QA.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(BA.name), QA;
      }, AA.decode = function(BA, QA, EA) {
        BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
        let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.StateSetValue.State();
        for (; BA.pos < iA; ) {
          let cA = BA.uint32();
          if (cA === EA) break;
          switch (cA >>> 3) {
            case 1: {
              oA.enabled = BA.bool();
              break;
            }
            case 2: {
              oA.name = BA.string();
              break;
            }
            default:
              BA.skipType(cA & 7);
              break;
          }
        }
        return oA;
      }, AA.fromObject = function(BA) {
        if (BA instanceof $root$1.openmetrics.StateSetValue.State) return BA;
        let QA = new $root$1.openmetrics.StateSetValue.State();
        return BA.enabled != null && (QA.enabled = !!BA.enabled), BA.name != null && (QA.name = String(BA.name)), QA;
      }, AA.toObject = function(BA, QA) {
        QA || (QA = {});
        let EA = {};
        return QA.defaults && (EA.enabled = !1, EA.name = ""), BA.enabled != null && BA.hasOwnProperty("enabled") && (EA.enabled = BA.enabled), BA.name != null && BA.hasOwnProperty("name") && (EA.name = BA.name), EA;
      }, AA.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, AA.getTypeUrl = function(BA) {
        return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.StateSetValue.State";
      }, AA;
    })(), gA;
  })(), CA.InfoValue = (function() {
    function gA(AA) {
      if (this.info = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.info = $util$1.emptyArray, gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA || (BA = $Writer$1.create()), IA.info != null && IA.info.length) for (let QA = 0; QA < IA.info.length; ++QA) $root$1.openmetrics.Label.encode(IA.info[QA], BA.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader$1 || (IA = $Reader$1.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root$1.openmetrics.InfoValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? (iA.info && iA.info.length || (iA.info = []), iA.info.push($root$1.openmetrics.Label.decode(IA, IA.uint32()))) : IA.skipType(oA & 7);
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root$1.openmetrics.InfoValue) return IA;
      let BA = new $root$1.openmetrics.InfoValue();
      if (IA.info) {
        if (!Array.isArray(IA.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        BA.info = [];
        for (let QA = 0; QA < IA.info.length; ++QA) {
          if (typeof IA.info[QA] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          BA.info[QA] = $root$1.openmetrics.Label.fromObject(IA.info[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA || (BA = {});
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.info = []), IA.info && IA.info.length) {
        QA.info = [];
        for (let EA = 0; EA < IA.info.length; ++EA) QA.info[EA] = $root$1.openmetrics.Label.toObject(IA.info[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.InfoValue";
    }, gA;
  })(), CA.SummaryValue = (function() {
    function gA(IA) {
      if (this.quantile = [], IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.count = $util$1.Long ? $util$1.Long.fromBits(0, 0, !0) : 0, gA.prototype.created = null, gA.prototype.quantile = $util$1.emptyArray;
    let AA;
    return Object.defineProperty(gA.prototype, "sum", { get: $util$1.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util$1.oneOfSetter(AA) }), gA.create = function(BA) {
      return new gA(BA);
    }, gA.encode = function(BA, QA) {
      if (QA || (QA = $Writer$1.create()), BA.doubleValue != null && Object.hasOwnProperty.call(BA, "doubleValue") && QA.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(BA.doubleValue), BA.intValue != null && Object.hasOwnProperty.call(BA, "intValue") && QA.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(BA.intValue), BA.count != null && Object.hasOwnProperty.call(BA, "count") && QA.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(BA.count), BA.created != null && Object.hasOwnProperty.call(BA, "created") && $root$1.google.protobuf.Timestamp.encode(BA.created, QA.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), BA.quantile != null && BA.quantile.length) for (let EA = 0; EA < BA.quantile.length; ++EA) $root$1.openmetrics.SummaryValue.Quantile.encode(BA.quantile[EA], QA.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim();
      return QA;
    }, gA.decode = function(BA, QA, EA) {
      BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.openmetrics.SummaryValue();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1: {
            oA.doubleValue = BA.double();
            break;
          }
          case 2: {
            oA.intValue = BA.int64();
            break;
          }
          case 3: {
            oA.count = BA.uint64();
            break;
          }
          case 4: {
            oA.created = $root$1.google.protobuf.Timestamp.decode(BA, BA.uint32());
            break;
          }
          case 5: {
            oA.quantile && oA.quantile.length || (oA.quantile = []), oA.quantile.push($root$1.openmetrics.SummaryValue.Quantile.decode(BA, BA.uint32()));
            break;
          }
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, gA.fromObject = function(BA) {
      if (BA instanceof $root$1.openmetrics.SummaryValue) return BA;
      let QA = new $root$1.openmetrics.SummaryValue();
      if (BA.doubleValue != null && (QA.doubleValue = Number(BA.doubleValue)), BA.intValue != null && ($util$1.Long ? (QA.intValue = $util$1.Long.fromValue(BA.intValue)).unsigned = !1 : typeof BA.intValue == "string" ? QA.intValue = parseInt(BA.intValue, 10) : typeof BA.intValue == "number" ? QA.intValue = BA.intValue : typeof BA.intValue == "object" && (QA.intValue = new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber())), BA.count != null && ($util$1.Long ? (QA.count = $util$1.Long.fromValue(BA.count)).unsigned = !0 : typeof BA.count == "string" ? QA.count = parseInt(BA.count, 10) : typeof BA.count == "number" ? QA.count = BA.count : typeof BA.count == "object" && (QA.count = new $util$1.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0))), BA.created != null) {
        if (typeof BA.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        QA.created = $root$1.google.protobuf.Timestamp.fromObject(BA.created);
      }
      if (BA.quantile) {
        if (!Array.isArray(BA.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        QA.quantile = [];
        for (let EA = 0; EA < BA.quantile.length; ++EA) {
          if (typeof BA.quantile[EA] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          QA.quantile[EA] = $root$1.openmetrics.SummaryValue.Quantile.fromObject(BA.quantile[EA]);
        }
      }
      return QA;
    }, gA.toObject = function(BA, QA) {
      QA || (QA = {});
      let EA = {};
      if ((QA.arrays || QA.defaults) && (EA.quantile = []), QA.defaults) {
        if ($util$1.Long) {
          let iA = new $util$1.Long(0, 0, !0);
          EA.count = QA.longs === String ? iA.toString() : QA.longs === Number ? iA.toNumber() : iA;
        } else EA.count = QA.longs === String ? "0" : 0;
        EA.created = null;
      }
      if (BA.doubleValue != null && BA.hasOwnProperty("doubleValue") && (EA.doubleValue = QA.json && !isFinite(BA.doubleValue) ? String(BA.doubleValue) : BA.doubleValue, QA.oneofs && (EA.sum = "doubleValue")), BA.intValue != null && BA.hasOwnProperty("intValue") && (typeof BA.intValue == "number" ? EA.intValue = QA.longs === String ? String(BA.intValue) : BA.intValue : EA.intValue = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.intValue) : QA.longs === Number ? new $util$1.LongBits(BA.intValue.low >>> 0, BA.intValue.high >>> 0).toNumber() : BA.intValue, QA.oneofs && (EA.sum = "intValue")), BA.count != null && BA.hasOwnProperty("count") && (typeof BA.count == "number" ? EA.count = QA.longs === String ? String(BA.count) : BA.count : EA.count = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.count) : QA.longs === Number ? new $util$1.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0) : BA.count), BA.created != null && BA.hasOwnProperty("created") && (EA.created = $root$1.google.protobuf.Timestamp.toObject(BA.created, QA)), BA.quantile && BA.quantile.length) {
        EA.quantile = [];
        for (let iA = 0; iA < BA.quantile.length; ++iA) EA.quantile[iA] = $root$1.openmetrics.SummaryValue.Quantile.toObject(BA.quantile[iA], QA);
      }
      return EA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, gA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.SummaryValue";
    }, gA.Quantile = (function() {
      function IA(BA) {
        if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
      }
      return IA.prototype.quantile = 0, IA.prototype.value = 0, IA.create = function(QA) {
        return new IA(QA);
      }, IA.encode = function(QA, EA) {
        return EA || (EA = $Writer$1.create()), QA.quantile != null && Object.hasOwnProperty.call(QA, "quantile") && EA.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(QA.quantile), QA.value != null && Object.hasOwnProperty.call(QA, "value") && EA.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(QA.value), EA;
      }, IA.decode = function(QA, EA, iA) {
        QA instanceof $Reader$1 || (QA = $Reader$1.create(QA));
        let oA = EA === void 0 ? QA.len : QA.pos + EA, cA = new $root$1.openmetrics.SummaryValue.Quantile();
        for (; QA.pos < oA; ) {
          let tA = QA.uint32();
          if (tA === iA) break;
          switch (tA >>> 3) {
            case 1: {
              cA.quantile = QA.double();
              break;
            }
            case 2: {
              cA.value = QA.double();
              break;
            }
            default:
              QA.skipType(tA & 7);
              break;
          }
        }
        return cA;
      }, IA.fromObject = function(QA) {
        if (QA instanceof $root$1.openmetrics.SummaryValue.Quantile) return QA;
        let EA = new $root$1.openmetrics.SummaryValue.Quantile();
        return QA.quantile != null && (EA.quantile = Number(QA.quantile)), QA.value != null && (EA.value = Number(QA.value)), EA;
      }, IA.toObject = function(QA, EA) {
        EA || (EA = {});
        let iA = {};
        return EA.defaults && (iA.quantile = 0, iA.value = 0), QA.quantile != null && QA.hasOwnProperty("quantile") && (iA.quantile = EA.json && !isFinite(QA.quantile) ? String(QA.quantile) : QA.quantile), QA.value != null && QA.hasOwnProperty("value") && (iA.value = EA.json && !isFinite(QA.value) ? String(QA.value) : QA.value), iA;
      }, IA.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, IA.getTypeUrl = function(QA) {
        return QA === void 0 && (QA = "type.googleapis.com"), QA + "/openmetrics.SummaryValue.Quantile";
      }, IA;
    })(), gA;
  })(), CA;
})();
$root$1.google = (() => {
  const CA = {};
  return CA.protobuf = (function() {
    const gA = {};
    return gA.Timestamp = (function() {
      function AA(IA) {
        if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
      }
      return AA.prototype.seconds = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, AA.prototype.nanos = 0, AA.create = function(BA) {
        return new AA(BA);
      }, AA.encode = function(BA, QA) {
        return QA || (QA = $Writer$1.create()), BA.seconds != null && Object.hasOwnProperty.call(BA, "seconds") && QA.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(BA.seconds), BA.nanos != null && Object.hasOwnProperty.call(BA, "nanos") && QA.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(BA.nanos), QA;
      }, AA.decode = function(BA, QA, EA) {
        BA instanceof $Reader$1 || (BA = $Reader$1.create(BA));
        let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root$1.google.protobuf.Timestamp();
        for (; BA.pos < iA; ) {
          let cA = BA.uint32();
          if (cA === EA) break;
          switch (cA >>> 3) {
            case 1: {
              oA.seconds = BA.int64();
              break;
            }
            case 2: {
              oA.nanos = BA.int32();
              break;
            }
            default:
              BA.skipType(cA & 7);
              break;
          }
        }
        return oA;
      }, AA.fromObject = function(BA) {
        if (BA instanceof $root$1.google.protobuf.Timestamp) return BA;
        let QA = new $root$1.google.protobuf.Timestamp();
        return BA.seconds != null && ($util$1.Long ? (QA.seconds = $util$1.Long.fromValue(BA.seconds)).unsigned = !1 : typeof BA.seconds == "string" ? QA.seconds = parseInt(BA.seconds, 10) : typeof BA.seconds == "number" ? QA.seconds = BA.seconds : typeof BA.seconds == "object" && (QA.seconds = new $util$1.LongBits(BA.seconds.low >>> 0, BA.seconds.high >>> 0).toNumber())), BA.nanos != null && (QA.nanos = BA.nanos | 0), QA;
      }, AA.toObject = function(BA, QA) {
        QA || (QA = {});
        let EA = {};
        if (QA.defaults) {
          if ($util$1.Long) {
            let iA = new $util$1.Long(0, 0, !1);
            EA.seconds = QA.longs === String ? iA.toString() : QA.longs === Number ? iA.toNumber() : iA;
          } else EA.seconds = QA.longs === String ? "0" : 0;
          EA.nanos = 0;
        }
        return BA.seconds != null && BA.hasOwnProperty("seconds") && (typeof BA.seconds == "number" ? EA.seconds = QA.longs === String ? String(BA.seconds) : BA.seconds : EA.seconds = QA.longs === String ? $util$1.Long.prototype.toString.call(BA.seconds) : QA.longs === Number ? new $util$1.LongBits(BA.seconds.low >>> 0, BA.seconds.high >>> 0).toNumber() : BA.seconds), BA.nanos != null && BA.hasOwnProperty("nanos") && (EA.nanos = BA.nanos), EA;
      }, AA.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, AA.getTypeUrl = function(BA) {
        return BA === void 0 && (BA = "type.googleapis.com"), BA + "/google.protobuf.Timestamp";
      }, AA;
    })(), gA;
  })(), CA;
})();
$root$1.RootContainer = (() => {
  const CA = {}, gA = Object.create(CA);
  return gA[CA[0] = "MAIN"] = 0, gA[CA[1] = "SIDEBAR"] = 1, gA[CA[2] = "EVENT"] = 2, gA[CA[3] = "BOTTOM"] = 3, gA;
})();
function ensureError(CA) {
  return CA instanceof Error ? CA : new Error(`${CA}`);
}
const handlePreserveConsecutiveUppercase = (CA, gA) => (CA = CA.replace(
  new RegExp("((?<![\\p{Uppercase_Letter}\\d])[\\p{Uppercase_Letter}\\d](?![\\p{Uppercase_Letter}\\d]))", "gu"),
  (AA) => AA.toLowerCase()
), CA.replace(
  new RegExp("(?<!\\p{Uppercase_Letter})(\\p{Uppercase_Letter}+)(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
  (AA, IA, BA) => IA + gA + BA.toLowerCase()
));
function decamelize$1(CA, {
  separator: gA = "_",
  preserveConsecutiveUppercase: AA = !1
} = {}) {
  if (!(typeof CA == "string" && typeof gA == "string"))
    throw new TypeError(
      "The `text` and `separator` arguments should be of type `string`"
    );
  if (CA.length < 2)
    return AA ? CA : CA.toLowerCase();
  const IA = `$1${gA}$2`, BA = CA.replace(
    new RegExp("([\\p{Lowercase_Letter}\\d])(\\p{Uppercase_Letter})", "gu"),
    IA
  );
  return AA ? handlePreserveConsecutiveUppercase(BA, gA) : BA.replace(
    new RegExp("(\\p{Uppercase_Letter})(\\p{Uppercase_Letter}\\p{Lowercase_Letter}+)", "gu"),
    IA
  ).toLowerCase();
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$4 = freeGlobal || freeSelf || Function("return this")(), Symbol$1 = root$4.Symbol, objectProto$h = Object.prototype, hasOwnProperty$f = objectProto$h.hasOwnProperty, nativeObjectToString$1 = objectProto$h.toString, symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(CA) {
  var gA = hasOwnProperty$f.call(CA, symToStringTag$1), AA = CA[symToStringTag$1];
  try {
    CA[symToStringTag$1] = void 0;
    var IA = !0;
  } catch {
  }
  var BA = nativeObjectToString$1.call(CA);
  return IA && (gA ? CA[symToStringTag$1] = AA : delete CA[symToStringTag$1]), BA;
}
var objectProto$g = Object.prototype, nativeObjectToString = objectProto$g.toString;
function objectToString(CA) {
  return nativeObjectToString.call(CA);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(CA) {
  return CA == null ? CA === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(CA) ? getRawTag(CA) : objectToString(CA);
}
function isObjectLike(CA) {
  return CA != null && typeof CA == "object";
}
var symbolTag$3 = "[object Symbol]";
function isSymbol(CA) {
  return typeof CA == "symbol" || isObjectLike(CA) && baseGetTag(CA) == symbolTag$3;
}
function arrayMap(CA, gA) {
  for (var AA = -1, IA = CA == null ? 0 : CA.length, BA = Array(IA); ++AA < IA; )
    BA[AA] = gA(CA[AA], AA, CA);
  return BA;
}
var isArray$1 = Array.isArray, symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString(CA) {
  if (typeof CA == "string")
    return CA;
  if (isArray$1(CA))
    return arrayMap(CA, baseToString) + "";
  if (isSymbol(CA))
    return symbolToString ? symbolToString.call(CA) : "";
  var gA = CA + "";
  return gA == "0" && 1 / CA == -1 / 0 ? "-0" : gA;
}
var reWhitespace = /\s/;
function trimmedEndIndex(CA) {
  for (var gA = CA.length; gA-- && reWhitespace.test(CA.charAt(gA)); )
    ;
  return gA;
}
var reTrimStart = /^\s+/;
function baseTrim(CA) {
  return CA && CA.slice(0, trimmedEndIndex(CA) + 1).replace(reTrimStart, "");
}
function isObject$3(CA) {
  var gA = typeof CA;
  return CA != null && (gA == "object" || gA == "function");
}
var NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber(CA) {
  if (typeof CA == "number")
    return CA;
  if (isSymbol(CA))
    return NAN;
  if (isObject$3(CA)) {
    var gA = typeof CA.valueOf == "function" ? CA.valueOf() : CA;
    CA = isObject$3(gA) ? gA + "" : gA;
  }
  if (typeof CA != "string")
    return CA === 0 ? CA : +CA;
  CA = baseTrim(CA);
  var AA = reIsBinary.test(CA);
  return AA || reIsOctal.test(CA) ? freeParseInt(CA.slice(2), AA ? 2 : 8) : reIsBadHex.test(CA) ? NAN : +CA;
}
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(CA) {
  if (!CA)
    return CA === 0 ? CA : 0;
  if (CA = toNumber(CA), CA === INFINITY || CA === -INFINITY) {
    var gA = CA < 0 ? -1 : 1;
    return gA * MAX_INTEGER;
  }
  return CA === CA ? CA : 0;
}
function toInteger(CA) {
  var gA = toFinite(CA), AA = gA % 1;
  return gA === gA ? AA ? gA - AA : gA : 0;
}
function identity(CA) {
  return CA;
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(CA) {
  if (!isObject$3(CA))
    return !1;
  var gA = baseGetTag(CA);
  return gA == funcTag$2 || gA == genTag$1 || gA == asyncTag || gA == proxyTag;
}
var coreJsData = root$4["__core-js_shared__"], maskSrcKey = (function() {
  var CA = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return CA ? "Symbol(src)_1." + CA : "";
})();
function isMasked(CA) {
  return !!maskSrcKey && maskSrcKey in CA;
}
var funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource(CA) {
  if (CA != null) {
    try {
      return funcToString$2.call(CA);
    } catch {
    }
    try {
      return CA + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$f = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$e = objectProto$f.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$e).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(CA) {
  if (!isObject$3(CA) || isMasked(CA))
    return !1;
  var gA = isFunction$4(CA) ? reIsNative : reIsHostCtor;
  return gA.test(toSource(CA));
}
function getValue$1(CA, gA) {
  return CA?.[gA];
}
function getNative(CA, gA) {
  var AA = getValue$1(CA, gA);
  return baseIsNative(AA) ? AA : void 0;
}
var WeakMap$1 = getNative(root$4, "WeakMap"), objectCreate = Object.create, baseCreate = /* @__PURE__ */ (function() {
  function CA() {
  }
  return function(gA) {
    if (!isObject$3(gA))
      return {};
    if (objectCreate)
      return objectCreate(gA);
    CA.prototype = gA;
    var AA = new CA();
    return CA.prototype = void 0, AA;
  };
})();
function apply(CA, gA, AA) {
  switch (AA.length) {
    case 0:
      return CA.call(gA);
    case 1:
      return CA.call(gA, AA[0]);
    case 2:
      return CA.call(gA, AA[0], AA[1]);
    case 3:
      return CA.call(gA, AA[0], AA[1], AA[2]);
  }
  return CA.apply(gA, AA);
}
function copyArray(CA, gA) {
  var AA = -1, IA = CA.length;
  for (gA || (gA = Array(IA)); ++AA < IA; )
    gA[AA] = CA[AA];
  return gA;
}
var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(CA) {
  var gA = 0, AA = 0;
  return function() {
    var IA = nativeNow(), BA = HOT_SPAN - (IA - AA);
    if (AA = IA, BA > 0) {
      if (++gA >= HOT_COUNT)
        return arguments[0];
    } else
      gA = 0;
    return CA.apply(void 0, arguments);
  };
}
function constant(CA) {
  return function() {
    return CA;
  };
}
var defineProperty$1 = (function() {
  try {
    var CA = getNative(Object, "defineProperty");
    return CA({}, "", {}), CA;
  } catch {
  }
})(), baseSetToString = defineProperty$1 ? function(CA, gA) {
  return defineProperty$1(CA, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(gA),
    writable: !0
  });
} : identity, setToString = shortOut(baseSetToString);
function arrayEach(CA, gA) {
  for (var AA = -1, IA = CA == null ? 0 : CA.length; ++AA < IA && gA(CA[AA], AA, CA) !== !1; )
    ;
  return CA;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(CA, gA) {
  var AA = typeof CA;
  return gA = gA ?? MAX_SAFE_INTEGER$1, !!gA && (AA == "number" || AA != "symbol" && reIsUint.test(CA)) && CA > -1 && CA % 1 == 0 && CA < gA;
}
function baseAssignValue(CA, gA, AA) {
  gA == "__proto__" && defineProperty$1 ? defineProperty$1(CA, gA, {
    configurable: !0,
    enumerable: !0,
    value: AA,
    writable: !0
  }) : CA[gA] = AA;
}
function eq(CA, gA) {
  return CA === gA || CA !== CA && gA !== gA;
}
var objectProto$e = Object.prototype, hasOwnProperty$d = objectProto$e.hasOwnProperty;
function assignValue(CA, gA, AA) {
  var IA = CA[gA];
  (!(hasOwnProperty$d.call(CA, gA) && eq(IA, AA)) || AA === void 0 && !(gA in CA)) && baseAssignValue(CA, gA, AA);
}
function copyObject(CA, gA, AA, IA) {
  var BA = !AA;
  AA || (AA = {});
  for (var QA = -1, EA = gA.length; ++QA < EA; ) {
    var iA = gA[QA], oA = void 0;
    oA === void 0 && (oA = CA[iA]), BA ? baseAssignValue(AA, iA, oA) : assignValue(AA, iA, oA);
  }
  return AA;
}
var nativeMax$2 = Math.max;
function overRest(CA, gA, AA) {
  return gA = nativeMax$2(gA === void 0 ? CA.length - 1 : gA, 0), function() {
    for (var IA = arguments, BA = -1, QA = nativeMax$2(IA.length - gA, 0), EA = Array(QA); ++BA < QA; )
      EA[BA] = IA[gA + BA];
    BA = -1;
    for (var iA = Array(gA + 1); ++BA < gA; )
      iA[BA] = IA[BA];
    return iA[gA] = AA(EA), apply(CA, this, iA);
  };
}
function baseRest(CA, gA) {
  return setToString(overRest(CA, gA, identity), CA + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(CA) {
  return typeof CA == "number" && CA > -1 && CA % 1 == 0 && CA <= MAX_SAFE_INTEGER;
}
function isArrayLike(CA) {
  return CA != null && isLength(CA.length) && !isFunction$4(CA);
}
function isIterateeCall(CA, gA, AA) {
  if (!isObject$3(AA))
    return !1;
  var IA = typeof gA;
  return (IA == "number" ? isArrayLike(AA) && isIndex(gA, AA.length) : IA == "string" && gA in AA) ? eq(AA[gA], CA) : !1;
}
function createAssigner(CA) {
  return baseRest(function(gA, AA) {
    var IA = -1, BA = AA.length, QA = BA > 1 ? AA[BA - 1] : void 0, EA = BA > 2 ? AA[2] : void 0;
    for (QA = CA.length > 3 && typeof QA == "function" ? (BA--, QA) : void 0, EA && isIterateeCall(AA[0], AA[1], EA) && (QA = BA < 3 ? void 0 : QA, BA = 1), gA = Object(gA); ++IA < BA; ) {
      var iA = AA[IA];
      iA && CA(gA, iA, IA, QA);
    }
    return gA;
  });
}
var objectProto$d = Object.prototype;
function isPrototype(CA) {
  var gA = CA && CA.constructor, AA = typeof gA == "function" && gA.prototype || objectProto$d;
  return CA === AA;
}
function baseTimes(CA, gA) {
  for (var AA = -1, IA = Array(CA); ++AA < CA; )
    IA[AA] = gA(AA);
  return IA;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(CA) {
  return isObjectLike(CA) && baseGetTag(CA) == argsTag$3;
}
var objectProto$c = Object.prototype, hasOwnProperty$c = objectProto$c.hasOwnProperty, propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable, isArguments = baseIsArguments(/* @__PURE__ */ (function() {
  return arguments;
})()) ? baseIsArguments : function(CA) {
  return isObjectLike(CA) && hasOwnProperty$c.call(CA, "callee") && !propertyIsEnumerable$1.call(CA, "callee");
};
function stubFalse() {
  return !1;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$3 = moduleExports$2 ? root$4.Buffer : void 0, nativeIsBuffer = Buffer$3 ? Buffer$3.isBuffer : void 0, isBuffer = nativeIsBuffer || stubFalse, argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = !0;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = !1;
function baseIsTypedArray(CA) {
  return isObjectLike(CA) && isLength(CA.length) && !!typedArrayTags[baseGetTag(CA)];
}
function baseUnary(CA) {
  return function(gA) {
    return CA(gA);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, freeProcess = moduleExports$1 && freeGlobal.process, nodeUtil = (function() {
  try {
    var CA = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    return CA || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
})(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, objectProto$b = Object.prototype, hasOwnProperty$b = objectProto$b.hasOwnProperty;
function arrayLikeKeys(CA, gA) {
  var AA = isArray$1(CA), IA = !AA && isArguments(CA), BA = !AA && !IA && isBuffer(CA), QA = !AA && !IA && !BA && isTypedArray(CA), EA = AA || IA || BA || QA, iA = EA ? baseTimes(CA.length, String) : [], oA = iA.length;
  for (var cA in CA)
    (gA || hasOwnProperty$b.call(CA, cA)) && !(EA && // Safari 9 has enumerable `arguments.length` in strict mode.
    (cA == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    BA && (cA == "offset" || cA == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    QA && (cA == "buffer" || cA == "byteLength" || cA == "byteOffset") || // Skip index properties.
    isIndex(cA, oA))) && iA.push(cA);
  return iA;
}
function overArg(CA, gA) {
  return function(AA) {
    return CA(gA(AA));
  };
}
var nativeKeys = overArg(Object.keys, Object), objectProto$a = Object.prototype, hasOwnProperty$a = objectProto$a.hasOwnProperty;
function baseKeys(CA) {
  if (!isPrototype(CA))
    return nativeKeys(CA);
  var gA = [];
  for (var AA in Object(CA))
    hasOwnProperty$a.call(CA, AA) && AA != "constructor" && gA.push(AA);
  return gA;
}
function keys$1(CA) {
  return isArrayLike(CA) ? arrayLikeKeys(CA) : baseKeys(CA);
}
function nativeKeysIn(CA) {
  var gA = [];
  if (CA != null)
    for (var AA in Object(CA))
      gA.push(AA);
  return gA;
}
var objectProto$9 = Object.prototype, hasOwnProperty$9 = objectProto$9.hasOwnProperty;
function baseKeysIn(CA) {
  if (!isObject$3(CA))
    return nativeKeysIn(CA);
  var gA = isPrototype(CA), AA = [];
  for (var IA in CA)
    IA == "constructor" && (gA || !hasOwnProperty$9.call(CA, IA)) || AA.push(IA);
  return AA;
}
function keysIn(CA) {
  return isArrayLike(CA) ? arrayLikeKeys(CA, !0) : baseKeysIn(CA);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(CA, gA) {
  if (isArray$1(CA))
    return !1;
  var AA = typeof CA;
  return AA == "number" || AA == "symbol" || AA == "boolean" || CA == null || isSymbol(CA) ? !0 : reIsPlainProp.test(CA) || !reIsDeepProp.test(CA) || gA != null && CA in Object(gA);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}
function hashDelete(CA) {
  var gA = this.has(CA) && delete this.__data__[CA];
  return this.size -= gA ? 1 : 0, gA;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$8 = Object.prototype, hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function hashGet(CA) {
  var gA = this.__data__;
  if (nativeCreate) {
    var AA = gA[CA];
    return AA === HASH_UNDEFINED$2 ? void 0 : AA;
  }
  return hasOwnProperty$8.call(gA, CA) ? gA[CA] : void 0;
}
var objectProto$7 = Object.prototype, hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function hashHas(CA) {
  var gA = this.__data__;
  return nativeCreate ? gA[CA] !== void 0 : hasOwnProperty$7.call(gA, CA);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(CA, gA) {
  var AA = this.__data__;
  return this.size += this.has(CA) ? 0 : 1, AA[CA] = nativeCreate && gA === void 0 ? HASH_UNDEFINED$1 : gA, this;
}
function Hash(CA) {
  var gA = -1, AA = CA == null ? 0 : CA.length;
  for (this.clear(); ++gA < AA; ) {
    var IA = CA[gA];
    this.set(IA[0], IA[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype.delete = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
function assocIndexOf(CA, gA) {
  for (var AA = CA.length; AA--; )
    if (eq(CA[AA][0], gA))
      return AA;
  return -1;
}
var arrayProto = Array.prototype, splice$1 = arrayProto.splice;
function listCacheDelete(CA) {
  var gA = this.__data__, AA = assocIndexOf(gA, CA);
  if (AA < 0)
    return !1;
  var IA = gA.length - 1;
  return AA == IA ? gA.pop() : splice$1.call(gA, AA, 1), --this.size, !0;
}
function listCacheGet(CA) {
  var gA = this.__data__, AA = assocIndexOf(gA, CA);
  return AA < 0 ? void 0 : gA[AA][1];
}
function listCacheHas(CA) {
  return assocIndexOf(this.__data__, CA) > -1;
}
function listCacheSet(CA, gA) {
  var AA = this.__data__, IA = assocIndexOf(AA, CA);
  return IA < 0 ? (++this.size, AA.push([CA, gA])) : AA[IA][1] = gA, this;
}
function ListCache(CA) {
  var gA = -1, AA = CA == null ? 0 : CA.length;
  for (this.clear(); ++gA < AA; ) {
    var IA = CA[gA];
    this.set(IA[0], IA[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype.delete = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$2 = getNative(root$4, "Map");
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache)(),
    string: new Hash()
  };
}
function isKeyable(CA) {
  var gA = typeof CA;
  return gA == "string" || gA == "number" || gA == "symbol" || gA == "boolean" ? CA !== "__proto__" : CA === null;
}
function getMapData(CA, gA) {
  var AA = CA.__data__;
  return isKeyable(gA) ? AA[typeof gA == "string" ? "string" : "hash"] : AA.map;
}
function mapCacheDelete(CA) {
  var gA = getMapData(this, CA).delete(CA);
  return this.size -= gA ? 1 : 0, gA;
}
function mapCacheGet(CA) {
  return getMapData(this, CA).get(CA);
}
function mapCacheHas(CA) {
  return getMapData(this, CA).has(CA);
}
function mapCacheSet(CA, gA) {
  var AA = getMapData(this, CA), IA = AA.size;
  return AA.set(CA, gA), this.size += AA.size == IA ? 0 : 1, this;
}
function MapCache(CA) {
  var gA = -1, AA = CA == null ? 0 : CA.length;
  for (this.clear(); ++gA < AA; ) {
    var IA = CA[gA];
    this.set(IA[0], IA[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype.delete = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(CA, gA) {
  if (typeof CA != "function" || gA != null && typeof gA != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  var AA = function() {
    var IA = arguments, BA = gA ? gA.apply(this, IA) : IA[0], QA = AA.cache;
    if (QA.has(BA))
      return QA.get(BA);
    var EA = CA.apply(this, IA);
    return AA.cache = QA.set(BA, EA) || QA, EA;
  };
  return AA.cache = new (memoize.Cache || MapCache)(), AA;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(CA) {
  var gA = memoize(CA, function(IA) {
    return AA.size === MAX_MEMOIZE_SIZE && AA.clear(), IA;
  }), AA = gA.cache;
  return gA;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(CA) {
  var gA = [];
  return CA.charCodeAt(0) === 46 && gA.push(""), CA.replace(rePropName, function(AA, IA, BA, QA) {
    gA.push(BA ? QA.replace(reEscapeChar, "$1") : IA || AA);
  }), gA;
});
function toString$3(CA) {
  return CA == null ? "" : baseToString(CA);
}
function castPath(CA, gA) {
  return isArray$1(CA) ? CA : isKey(CA, gA) ? [CA] : stringToPath(toString$3(CA));
}
function toKey(CA) {
  if (typeof CA == "string" || isSymbol(CA))
    return CA;
  var gA = CA + "";
  return gA == "0" && 1 / CA == -1 / 0 ? "-0" : gA;
}
function baseGet(CA, gA) {
  gA = castPath(gA, CA);
  for (var AA = 0, IA = gA.length; CA != null && AA < IA; )
    CA = CA[toKey(gA[AA++])];
  return AA && AA == IA ? CA : void 0;
}
function get$1(CA, gA, AA) {
  var IA = CA == null ? void 0 : baseGet(CA, gA);
  return IA === void 0 ? AA : IA;
}
function arrayPush(CA, gA) {
  for (var AA = -1, IA = gA.length, BA = CA.length; ++AA < IA; )
    CA[BA + AA] = gA[AA];
  return CA;
}
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable(CA) {
  return isArray$1(CA) || isArguments(CA) || !!(spreadableSymbol && CA && CA[spreadableSymbol]);
}
function baseFlatten(CA, gA, AA, IA, BA) {
  var QA = -1, EA = CA.length;
  for (AA || (AA = isFlattenable), BA || (BA = []); ++QA < EA; ) {
    var iA = CA[QA];
    AA(iA) ? arrayPush(BA, iA) : BA[BA.length] = iA;
  }
  return BA;
}
function flatten(CA) {
  var gA = CA == null ? 0 : CA.length;
  return gA ? baseFlatten(CA) : [];
}
function flatRest(CA) {
  return setToString(overRest(CA, void 0, flatten), CA + "");
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectTag$3 = "[object Object]", funcProto = Function.prototype, objectProto$6 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$6 = objectProto$6.hasOwnProperty, objectCtorString$1 = funcToString.call(Object);
function isPlainObject$3(CA) {
  if (!isObjectLike(CA) || baseGetTag(CA) != objectTag$3)
    return !1;
  var gA = getPrototype(CA);
  if (gA === null)
    return !0;
  var AA = hasOwnProperty$6.call(gA, "constructor") && gA.constructor;
  return typeof AA == "function" && AA instanceof AA && funcToString.call(AA) == objectCtorString$1;
}
var FUNC_ERROR_TEXT = "Expected a function";
function before(CA, gA) {
  var AA;
  if (typeof gA != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return CA = toInteger(CA), function() {
    return --CA > 0 && (AA = gA.apply(this, arguments)), CA <= 1 && (gA = void 0), AA;
  };
}
function baseSlice(CA, gA, AA) {
  var IA = -1, BA = CA.length;
  gA < 0 && (gA = -gA > BA ? 0 : BA + gA), AA = AA > BA ? BA : AA, AA < 0 && (AA += BA), BA = gA > AA ? 0 : AA - gA >>> 0, gA >>>= 0;
  for (var QA = Array(BA); ++IA < BA; )
    QA[IA] = CA[IA + gA];
  return QA;
}
function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}
function stackDelete(CA) {
  var gA = this.__data__, AA = gA.delete(CA);
  return this.size = gA.size, AA;
}
function stackGet(CA) {
  return this.__data__.get(CA);
}
function stackHas(CA) {
  return this.__data__.has(CA);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(CA, gA) {
  var AA = this.__data__;
  if (AA instanceof ListCache) {
    var IA = AA.__data__;
    if (!Map$2 || IA.length < LARGE_ARRAY_SIZE - 1)
      return IA.push([CA, gA]), this.size = ++AA.size, this;
    AA = this.__data__ = new MapCache(IA);
  }
  return AA.set(CA, gA), this.size = AA.size, this;
}
function Stack(CA) {
  var gA = this.__data__ = new ListCache(CA);
  this.size = gA.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(CA, gA) {
  return CA && copyObject(gA, keys$1(gA), CA);
}
function baseAssignIn(CA, gA) {
  return CA && copyObject(gA, keysIn(gA), CA);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer$2 = moduleExports ? root$4.Buffer : void 0, allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : void 0;
function cloneBuffer(CA, gA) {
  if (gA)
    return CA.slice();
  var AA = CA.length, IA = allocUnsafe ? allocUnsafe(AA) : new CA.constructor(AA);
  return CA.copy(IA), IA;
}
function arrayFilter(CA, gA) {
  for (var AA = -1, IA = CA == null ? 0 : CA.length, BA = 0, QA = []; ++AA < IA; ) {
    var EA = CA[AA];
    gA(EA, AA, CA) && (QA[BA++] = EA);
  }
  return QA;
}
function stubArray() {
  return [];
}
var objectProto$5 = Object.prototype, propertyIsEnumerable = objectProto$5.propertyIsEnumerable, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols$1 ? function(CA) {
  return CA == null ? [] : (CA = Object(CA), arrayFilter(nativeGetSymbols$1(CA), function(gA) {
    return propertyIsEnumerable.call(CA, gA);
  }));
} : stubArray;
function copySymbols(CA, gA) {
  return copyObject(CA, getSymbols(CA), gA);
}
var nativeGetSymbols = Object.getOwnPropertySymbols, getSymbolsIn = nativeGetSymbols ? function(CA) {
  for (var gA = []; CA; )
    arrayPush(gA, getSymbols(CA)), CA = getPrototype(CA);
  return gA;
} : stubArray;
function copySymbolsIn(CA, gA) {
  return copyObject(CA, getSymbolsIn(CA), gA);
}
function baseGetAllKeys(CA, gA, AA) {
  var IA = gA(CA);
  return isArray$1(CA) ? IA : arrayPush(IA, AA(CA));
}
function getAllKeys(CA) {
  return baseGetAllKeys(CA, keys$1, getSymbols);
}
function getAllKeysIn(CA) {
  return baseGetAllKeys(CA, keysIn, getSymbolsIn);
}
var DataView$1 = getNative(root$4, "DataView"), Promise$1 = getNative(root$4, "Promise"), Set$1 = getNative(root$4, "Set"), mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]", dataViewTag$3 = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1), getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$2 && getTag(new Map$2()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function(CA) {
  var gA = baseGetTag(CA), AA = gA == objectTag$2 ? CA.constructor : void 0, IA = AA ? toSource(AA) : "";
  if (IA)
    switch (IA) {
      case dataViewCtorString:
        return dataViewTag$3;
      case mapCtorString:
        return mapTag$4;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag$4;
      case weakMapCtorString:
        return weakMapTag$1;
    }
  return gA;
});
var objectProto$4 = Object.prototype, hasOwnProperty$5 = objectProto$4.hasOwnProperty;
function initCloneArray(CA) {
  var gA = CA.length, AA = new CA.constructor(gA);
  return gA && typeof CA[0] == "string" && hasOwnProperty$5.call(CA, "index") && (AA.index = CA.index, AA.input = CA.input), AA;
}
var Uint8Array$1 = root$4.Uint8Array;
function cloneArrayBuffer(CA) {
  var gA = new CA.constructor(CA.byteLength);
  return new Uint8Array$1(gA).set(new Uint8Array$1(CA)), gA;
}
function cloneDataView(CA, gA) {
  var AA = gA ? cloneArrayBuffer(CA.buffer) : CA.buffer;
  return new CA.constructor(AA, CA.byteOffset, CA.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(CA) {
  var gA = new CA.constructor(CA.source, reFlags.exec(CA));
  return gA.lastIndex = CA.lastIndex, gA;
}
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(CA) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(CA)) : {};
}
function cloneTypedArray(CA, gA) {
  var AA = gA ? cloneArrayBuffer(CA.buffer) : CA.buffer;
  return new CA.constructor(AA, CA.byteOffset, CA.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(CA, gA, AA) {
  var IA = CA.constructor;
  switch (gA) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(CA);
    case boolTag$2:
    case dateTag$2:
      return new IA(+CA);
    case dataViewTag$2:
      return cloneDataView(CA, AA);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(CA, AA);
    case mapTag$3:
      return new IA();
    case numberTag$2:
    case stringTag$2:
      return new IA(CA);
    case regexpTag$2:
      return cloneRegExp(CA);
    case setTag$3:
      return new IA();
    case symbolTag$2:
      return cloneSymbol(CA);
  }
}
function initCloneObject(CA) {
  return typeof CA.constructor == "function" && !isPrototype(CA) ? baseCreate(getPrototype(CA)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(CA) {
  return isObjectLike(CA) && getTag(CA) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap, isMap$1 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap, setTag$2 = "[object Set]";
function baseIsSet(CA) {
  return isObjectLike(CA) && getTag(CA) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet, isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet, CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$2 = 4, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", weakMapTag = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = !0;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = !1;
function baseClone(CA, gA, AA, IA, BA, QA) {
  var EA, iA = gA & CLONE_DEEP_FLAG$2, oA = gA & CLONE_FLAT_FLAG$1, cA = gA & CLONE_SYMBOLS_FLAG$2;
  if (AA && (EA = BA ? AA(CA, IA, BA, QA) : AA(CA)), EA !== void 0)
    return EA;
  if (!isObject$3(CA))
    return CA;
  var tA = isArray$1(CA);
  if (tA) {
    if (EA = initCloneArray(CA), !iA)
      return copyArray(CA, EA);
  } else {
    var eA = getTag(CA), aA = eA == funcTag || eA == genTag;
    if (isBuffer(CA))
      return cloneBuffer(CA, iA);
    if (eA == objectTag$1 || eA == argsTag$1 || aA && !BA) {
      if (EA = oA || aA ? {} : initCloneObject(CA), !iA)
        return oA ? copySymbolsIn(CA, baseAssignIn(EA, CA)) : copySymbols(CA, baseAssign(EA, CA));
    } else {
      if (!cloneableTags[eA])
        return BA ? CA : {};
      EA = initCloneByTag(CA, eA, iA);
    }
  }
  QA || (QA = new Stack());
  var GA = QA.get(CA);
  if (GA)
    return GA;
  QA.set(CA, EA), isSet$1(CA) ? CA.forEach(function(DA) {
    EA.add(baseClone(DA, gA, AA, DA, CA, QA));
  }) : isMap$1(CA) && CA.forEach(function(DA, hA) {
    EA.set(hA, baseClone(DA, gA, AA, hA, CA, QA));
  });
  var lA = cA ? oA ? getAllKeysIn : getAllKeys : oA ? keysIn : keys$1, nA = tA ? void 0 : lA(CA);
  return arrayEach(nA || CA, function(DA, hA) {
    nA && (hA = DA, DA = CA[hA]), assignValue(EA, hA, baseClone(DA, gA, AA, hA, CA, QA));
  }), EA;
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(CA) {
  return baseClone(CA, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(CA) {
  return this.__data__.set(CA, HASH_UNDEFINED), this;
}
function setCacheHas(CA) {
  return this.__data__.has(CA);
}
function SetCache(CA) {
  var gA = -1, AA = CA == null ? 0 : CA.length;
  for (this.__data__ = new MapCache(); ++gA < AA; )
    this.add(CA[gA]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(CA, gA) {
  for (var AA = -1, IA = CA == null ? 0 : CA.length; ++AA < IA; )
    if (gA(CA[AA], AA, CA))
      return !0;
  return !1;
}
function cacheHas(CA, gA) {
  return CA.has(gA);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(CA, gA, AA, IA, BA, QA) {
  var EA = AA & COMPARE_PARTIAL_FLAG$5, iA = CA.length, oA = gA.length;
  if (iA != oA && !(EA && oA > iA))
    return !1;
  var cA = QA.get(CA), tA = QA.get(gA);
  if (cA && tA)
    return cA == gA && tA == CA;
  var eA = -1, aA = !0, GA = AA & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (QA.set(CA, gA), QA.set(gA, CA); ++eA < iA; ) {
    var lA = CA[eA], nA = gA[eA];
    if (IA)
      var DA = EA ? IA(nA, lA, eA, gA, CA, QA) : IA(lA, nA, eA, CA, gA, QA);
    if (DA !== void 0) {
      if (DA)
        continue;
      aA = !1;
      break;
    }
    if (GA) {
      if (!arraySome(gA, function(hA, wA) {
        if (!cacheHas(GA, wA) && (lA === hA || BA(lA, hA, AA, IA, QA)))
          return GA.push(wA);
      })) {
        aA = !1;
        break;
      }
    } else if (!(lA === nA || BA(lA, nA, AA, IA, QA))) {
      aA = !1;
      break;
    }
  }
  return QA.delete(CA), QA.delete(gA), aA;
}
function mapToArray(CA) {
  var gA = -1, AA = Array(CA.size);
  return CA.forEach(function(IA, BA) {
    AA[++gA] = [BA, IA];
  }), AA;
}
function setToArray(CA) {
  var gA = -1, AA = Array(CA.size);
  return CA.forEach(function(IA) {
    AA[++gA] = IA;
  }), AA;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(CA, gA, AA, IA, BA, QA, EA) {
  switch (AA) {
    case dataViewTag:
      if (CA.byteLength != gA.byteLength || CA.byteOffset != gA.byteOffset)
        return !1;
      CA = CA.buffer, gA = gA.buffer;
    case arrayBufferTag:
      return !(CA.byteLength != gA.byteLength || !QA(new Uint8Array$1(CA), new Uint8Array$1(gA)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+CA, +gA);
    case errorTag:
      return CA.name == gA.name && CA.message == gA.message;
    case regexpTag:
    case stringTag:
      return CA == gA + "";
    case mapTag:
      var iA = mapToArray;
    case setTag:
      var oA = IA & COMPARE_PARTIAL_FLAG$4;
      if (iA || (iA = setToArray), CA.size != gA.size && !oA)
        return !1;
      var cA = EA.get(CA);
      if (cA)
        return cA == gA;
      IA |= COMPARE_UNORDERED_FLAG$2, EA.set(CA, gA);
      var tA = equalArrays(iA(CA), iA(gA), IA, BA, QA, EA);
      return EA.delete(CA), tA;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(CA) == symbolValueOf.call(gA);
  }
  return !1;
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function equalObjects(CA, gA, AA, IA, BA, QA) {
  var EA = AA & COMPARE_PARTIAL_FLAG$3, iA = getAllKeys(CA), oA = iA.length, cA = getAllKeys(gA), tA = cA.length;
  if (oA != tA && !EA)
    return !1;
  for (var eA = oA; eA--; ) {
    var aA = iA[eA];
    if (!(EA ? aA in gA : hasOwnProperty$4.call(gA, aA)))
      return !1;
  }
  var GA = QA.get(CA), lA = QA.get(gA);
  if (GA && lA)
    return GA == gA && lA == CA;
  var nA = !0;
  QA.set(CA, gA), QA.set(gA, CA);
  for (var DA = EA; ++eA < oA; ) {
    aA = iA[eA];
    var hA = CA[aA], wA = gA[aA];
    if (IA)
      var sA = EA ? IA(wA, hA, aA, gA, CA, QA) : IA(hA, wA, aA, CA, gA, QA);
    if (!(sA === void 0 ? hA === wA || BA(hA, wA, AA, IA, QA) : sA)) {
      nA = !1;
      break;
    }
    DA || (DA = aA == "constructor");
  }
  if (nA && !DA) {
    var NA = CA.constructor, rA = gA.constructor;
    NA != rA && "constructor" in CA && "constructor" in gA && !(typeof NA == "function" && NA instanceof NA && typeof rA == "function" && rA instanceof rA) && (nA = !1);
  }
  return QA.delete(CA), QA.delete(gA), nA;
}
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep(CA, gA, AA, IA, BA, QA) {
  var EA = isArray$1(CA), iA = isArray$1(gA), oA = EA ? arrayTag : getTag(CA), cA = iA ? arrayTag : getTag(gA);
  oA = oA == argsTag ? objectTag : oA, cA = cA == argsTag ? objectTag : cA;
  var tA = oA == objectTag, eA = cA == objectTag, aA = oA == cA;
  if (aA && isBuffer(CA)) {
    if (!isBuffer(gA))
      return !1;
    EA = !0, tA = !1;
  }
  if (aA && !tA)
    return QA || (QA = new Stack()), EA || isTypedArray(CA) ? equalArrays(CA, gA, AA, IA, BA, QA) : equalByTag(CA, gA, oA, AA, IA, BA, QA);
  if (!(AA & COMPARE_PARTIAL_FLAG$2)) {
    var GA = tA && hasOwnProperty$3.call(CA, "__wrapped__"), lA = eA && hasOwnProperty$3.call(gA, "__wrapped__");
    if (GA || lA) {
      var nA = GA ? CA.value() : CA, DA = lA ? gA.value() : gA;
      return QA || (QA = new Stack()), BA(nA, DA, AA, IA, QA);
    }
  }
  return aA ? (QA || (QA = new Stack()), equalObjects(CA, gA, AA, IA, BA, QA)) : !1;
}
function baseIsEqual(CA, gA, AA, IA, BA) {
  return CA === gA ? !0 : CA == null || gA == null || !isObjectLike(CA) && !isObjectLike(gA) ? CA !== CA && gA !== gA : baseIsEqualDeep(CA, gA, AA, IA, baseIsEqual, BA);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(CA, gA, AA, IA) {
  var BA = AA.length, QA = BA;
  if (CA == null)
    return !QA;
  for (CA = Object(CA); BA--; ) {
    var EA = AA[BA];
    if (EA[2] ? EA[1] !== CA[EA[0]] : !(EA[0] in CA))
      return !1;
  }
  for (; ++BA < QA; ) {
    EA = AA[BA];
    var iA = EA[0], oA = CA[iA], cA = EA[1];
    if (EA[2]) {
      if (oA === void 0 && !(iA in CA))
        return !1;
    } else {
      var tA = new Stack(), eA;
      if (!(eA === void 0 ? baseIsEqual(cA, oA, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, IA, tA) : eA))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(CA) {
  return CA === CA && !isObject$3(CA);
}
function getMatchData(CA) {
  for (var gA = keys$1(CA), AA = gA.length; AA--; ) {
    var IA = gA[AA], BA = CA[IA];
    gA[AA] = [IA, BA, isStrictComparable(BA)];
  }
  return gA;
}
function matchesStrictComparable(CA, gA) {
  return function(AA) {
    return AA == null ? !1 : AA[CA] === gA && (gA !== void 0 || CA in Object(AA));
  };
}
function baseMatches(CA) {
  var gA = getMatchData(CA);
  return gA.length == 1 && gA[0][2] ? matchesStrictComparable(gA[0][0], gA[0][1]) : function(AA) {
    return AA === CA || baseIsMatch(AA, CA, gA);
  };
}
function baseHasIn(CA, gA) {
  return CA != null && gA in Object(CA);
}
function hasPath(CA, gA, AA) {
  gA = castPath(gA, CA);
  for (var IA = -1, BA = gA.length, QA = !1; ++IA < BA; ) {
    var EA = toKey(gA[IA]);
    if (!(QA = CA != null && AA(CA, EA)))
      break;
    CA = CA[EA];
  }
  return QA || ++IA != BA ? QA : (BA = CA == null ? 0 : CA.length, !!BA && isLength(BA) && isIndex(EA, BA) && (isArray$1(CA) || isArguments(CA)));
}
function hasIn(CA, gA) {
  return CA != null && hasPath(CA, gA, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(CA, gA) {
  return isKey(CA) && isStrictComparable(gA) ? matchesStrictComparable(toKey(CA), gA) : function(AA) {
    var IA = get$1(AA, CA);
    return IA === void 0 && IA === gA ? hasIn(AA, CA) : baseIsEqual(gA, IA, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(CA) {
  return function(gA) {
    return gA?.[CA];
  };
}
function basePropertyDeep(CA) {
  return function(gA) {
    return baseGet(gA, CA);
  };
}
function property(CA) {
  return isKey(CA) ? baseProperty(toKey(CA)) : basePropertyDeep(CA);
}
function baseIteratee(CA) {
  return typeof CA == "function" ? CA : CA == null ? identity : typeof CA == "object" ? isArray$1(CA) ? baseMatchesProperty(CA[0], CA[1]) : baseMatches(CA) : property(CA);
}
function arrayAggregator(CA, gA, AA, IA) {
  for (var BA = -1, QA = CA == null ? 0 : CA.length; ++BA < QA; ) {
    var EA = CA[BA];
    gA(IA, EA, AA(EA), CA);
  }
  return IA;
}
function createBaseFor(CA) {
  return function(gA, AA, IA) {
    for (var BA = -1, QA = Object(gA), EA = IA(gA), iA = EA.length; iA--; ) {
      var oA = EA[++BA];
      if (AA(QA[oA], oA, QA) === !1)
        break;
    }
    return gA;
  };
}
var baseFor = createBaseFor();
function baseForOwn(CA, gA) {
  return CA && baseFor(CA, gA, keys$1);
}
function createBaseEach(CA, gA) {
  return function(AA, IA) {
    if (AA == null)
      return AA;
    if (!isArrayLike(AA))
      return CA(AA, IA);
    for (var BA = AA.length, QA = -1, EA = Object(AA); ++QA < BA && IA(EA[QA], QA, EA) !== !1; )
      ;
    return AA;
  };
}
var baseEach = createBaseEach(baseForOwn);
function baseAggregator(CA, gA, AA, IA) {
  return baseEach(CA, function(BA, QA, EA) {
    gA(IA, BA, AA(BA), EA);
  }), IA;
}
function createAggregator(CA, gA) {
  return function(AA, IA) {
    var BA = isArray$1(AA) ? arrayAggregator : baseAggregator, QA = gA ? gA() : {};
    return BA(AA, CA, baseIteratee(IA), QA);
  };
}
function assignMergeValue(CA, gA, AA) {
  (AA !== void 0 && !eq(CA[gA], AA) || AA === void 0 && !(gA in CA)) && baseAssignValue(CA, gA, AA);
}
function isArrayLikeObject(CA) {
  return isObjectLike(CA) && isArrayLike(CA);
}
function safeGet(CA, gA) {
  if (!(gA === "constructor" && typeof CA[gA] == "function") && gA != "__proto__")
    return CA[gA];
}
function toPlainObject(CA) {
  return copyObject(CA, keysIn(CA));
}
function baseMergeDeep(CA, gA, AA, IA, BA, QA, EA) {
  var iA = safeGet(CA, AA), oA = safeGet(gA, AA), cA = EA.get(oA);
  if (cA) {
    assignMergeValue(CA, AA, cA);
    return;
  }
  var tA = QA ? QA(iA, oA, AA + "", CA, gA, EA) : void 0, eA = tA === void 0;
  if (eA) {
    var aA = isArray$1(oA), GA = !aA && isBuffer(oA), lA = !aA && !GA && isTypedArray(oA);
    tA = oA, aA || GA || lA ? isArray$1(iA) ? tA = iA : isArrayLikeObject(iA) ? tA = copyArray(iA) : GA ? (eA = !1, tA = cloneBuffer(oA, !0)) : lA ? (eA = !1, tA = cloneTypedArray(oA, !0)) : tA = [] : isPlainObject$3(oA) || isArguments(oA) ? (tA = iA, isArguments(iA) ? tA = toPlainObject(iA) : (!isObject$3(iA) || isFunction$4(iA)) && (tA = initCloneObject(oA))) : eA = !1;
  }
  eA && (EA.set(oA, tA), BA(tA, oA, IA, QA, EA), EA.delete(oA)), assignMergeValue(CA, AA, tA);
}
function baseMerge(CA, gA, AA, IA, BA) {
  CA !== gA && baseFor(gA, function(QA, EA) {
    if (BA || (BA = new Stack()), isObject$3(QA))
      baseMergeDeep(CA, gA, EA, AA, baseMerge, IA, BA);
    else {
      var iA = IA ? IA(safeGet(CA, EA), QA, EA + "", CA, gA, BA) : void 0;
      iA === void 0 && (iA = QA), assignMergeValue(CA, EA, iA);
    }
  }, keysIn);
}
var mergeWith = createAssigner(function(CA, gA, AA, IA) {
  baseMerge(CA, gA, AA, IA);
});
function last(CA) {
  var gA = CA == null ? 0 : CA.length;
  return gA ? CA[gA - 1] : void 0;
}
var objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty, groupBy = createAggregator(function(CA, gA, AA) {
  hasOwnProperty$2.call(CA, AA) ? CA[AA].push(gA) : baseAssignValue(CA, AA, [gA]);
});
function parent(CA, gA) {
  return gA.length < 2 ? CA : baseGet(CA, baseSlice(gA, 0, -1));
}
function isEqual(CA, gA) {
  return baseIsEqual(CA, gA);
}
var merge$1 = createAssigner(function(CA, gA, AA) {
  baseMerge(CA, gA, AA);
}), objectProto = Object.prototype, hasOwnProperty$1 = objectProto.hasOwnProperty;
function baseUnset(CA, gA) {
  gA = castPath(gA, CA);
  var AA = -1, IA = gA.length;
  if (!IA)
    return !0;
  for (; ++AA < IA; ) {
    var BA = toKey(gA[AA]);
    if (BA === "__proto__" && !hasOwnProperty$1.call(CA, "__proto__") || (BA === "constructor" || BA === "prototype") && AA < IA - 1)
      return !1;
  }
  var QA = parent(CA, gA);
  return QA == null || delete QA[toKey(last(gA))];
}
function customOmitClone(CA) {
  return isPlainObject$3(CA) ? void 0 : CA;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4, omit = flatRest(function(CA, gA) {
  var AA = {};
  if (CA == null)
    return AA;
  var IA = !1;
  gA = arrayMap(gA, function(QA) {
    return QA = castPath(QA, CA), IA || (IA = QA.length > 1), QA;
  }), copyObject(CA, getAllKeysIn(CA), AA), IA && (AA = baseClone(AA, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone));
  for (var BA = gA.length; BA--; )
    baseUnset(AA, gA[BA]);
  return AA;
});
function baseSet(CA, gA, AA, IA) {
  if (!isObject$3(CA))
    return CA;
  gA = castPath(gA, CA);
  for (var BA = -1, QA = gA.length, EA = QA - 1, iA = CA; iA != null && ++BA < QA; ) {
    var oA = toKey(gA[BA]), cA = AA;
    if (oA === "__proto__" || oA === "constructor" || oA === "prototype")
      return CA;
    if (BA != EA) {
      var tA = iA[oA];
      cA = void 0, cA === void 0 && (cA = isObject$3(tA) ? tA : isIndex(gA[BA + 1]) ? [] : {});
    }
    assignValue(iA, oA, cA), iA = iA[oA];
  }
  return CA;
}
function basePickBy(CA, gA, AA) {
  for (var IA = -1, BA = gA.length, QA = {}; ++IA < BA; ) {
    var EA = gA[IA], iA = baseGet(CA, EA);
    AA(iA, EA) && baseSet(QA, castPath(EA, CA), iA);
  }
  return QA;
}
function once$1(CA) {
  return before(2, CA);
}
function basePick(CA, gA) {
  return basePickBy(CA, gA, function(AA, IA) {
    return hasIn(CA, IA);
  });
}
var pick$1 = flatRest(function(CA, gA) {
  return CA == null ? {} : basePick(CA, gA);
}), nativeCeil = Math.ceil, nativeMax$1 = Math.max;
function baseRange(CA, gA, AA, IA) {
  for (var BA = -1, QA = nativeMax$1(nativeCeil((gA - CA) / (AA || 1)), 0), EA = Array(QA); QA--; )
    EA[++BA] = CA, CA += AA;
  return EA;
}
function createRange(CA) {
  return function(gA, AA, IA) {
    return IA && typeof IA != "number" && isIterateeCall(gA, AA, IA) && (AA = IA = void 0), gA = toFinite(gA), AA === void 0 ? (AA = gA, gA = 0) : AA = toFinite(AA), IA = IA === void 0 ? gA < AA ? 1 : -1 : toFinite(IA), baseRange(gA, AA, IA);
  };
}
var range$1 = createRange(), nativeMax = Math.max;
function unzip(CA) {
  if (!(CA && CA.length))
    return [];
  var gA = 0;
  return CA = arrayFilter(CA, function(AA) {
    if (isArrayLikeObject(AA))
      return gA = nativeMax(AA.length, gA), !0;
  }), baseTimes(gA, function(AA) {
    return arrayMap(CA, baseProperty(AA));
  });
}
var zip$1 = baseRest(unzip), cuint = {}, uint32$1 = { exports: {} }, uint32 = uint32$1.exports, hasRequiredUint32;
function requireUint32() {
  return hasRequiredUint32 || (hasRequiredUint32 = 1, (function(CA) {
    (function(gA) {
      AA(Math.pow(36, 5)), AA(Math.pow(16, 7)), AA(Math.pow(10, 9)), AA(Math.pow(2, 30)), AA(36), AA(16), AA(10), AA(2);
      function AA(EA, iA) {
        if (!(this instanceof AA))
          return new AA(EA, iA);
        if (this._low = 0, this._high = 0, this.remainder = null, typeof iA > "u")
          return BA.call(this, EA);
        if (typeof EA == "string")
          return QA.call(this, EA, iA);
        IA.call(this, EA, iA);
      }
      function IA(EA, iA) {
        return this._low = EA | 0, this._high = iA | 0, this;
      }
      AA.prototype.fromBits = IA;
      function BA(EA) {
        return this._low = EA & 65535, this._high = EA >>> 16, this;
      }
      AA.prototype.fromNumber = BA;
      function QA(EA, iA) {
        var oA = parseInt(EA, iA || 10);
        return this._low = oA & 65535, this._high = oA >>> 16, this;
      }
      AA.prototype.fromString = QA, AA.prototype.toNumber = function() {
        return this._high * 65536 + this._low;
      }, AA.prototype.toString = function(EA) {
        return this.toNumber().toString(EA || 10);
      }, AA.prototype.add = function(EA) {
        var iA = this._low + EA._low, oA = iA >>> 16;
        return oA += this._high + EA._high, this._low = iA & 65535, this._high = oA & 65535, this;
      }, AA.prototype.subtract = function(EA) {
        return this.add(EA.clone().negate());
      }, AA.prototype.multiply = function(EA) {
        var iA = this._high, oA = this._low, cA = EA._high, tA = EA._low, eA, aA;
        return aA = oA * tA, eA = aA >>> 16, eA += iA * tA, eA &= 65535, eA += oA * cA, this._low = aA & 65535, this._high = eA & 65535, this;
      }, AA.prototype.div = function(EA) {
        if (EA._low == 0 && EA._high == 0) throw Error("division by zero");
        if (EA._high == 0 && EA._low == 1)
          return this.remainder = new AA(0), this;
        if (EA.gt(this))
          return this.remainder = this.clone(), this._low = 0, this._high = 0, this;
        if (this.eq(EA))
          return this.remainder = new AA(0), this._low = 1, this._high = 0, this;
        for (var iA = EA.clone(), oA = -1; !this.lt(iA); )
          iA.shiftLeft(1, !0), oA++;
        for (this.remainder = this.clone(), this._low = 0, this._high = 0; oA >= 0; oA--)
          iA.shiftRight(1), this.remainder.lt(iA) || (this.remainder.subtract(iA), oA >= 16 ? this._high |= 1 << oA - 16 : this._low |= 1 << oA);
        return this;
      }, AA.prototype.negate = function() {
        var EA = (~this._low & 65535) + 1;
        return this._low = EA & 65535, this._high = ~this._high + (EA >>> 16) & 65535, this;
      }, AA.prototype.equals = AA.prototype.eq = function(EA) {
        return this._low == EA._low && this._high == EA._high;
      }, AA.prototype.greaterThan = AA.prototype.gt = function(EA) {
        return this._high > EA._high ? !0 : this._high < EA._high ? !1 : this._low > EA._low;
      }, AA.prototype.lessThan = AA.prototype.lt = function(EA) {
        return this._high < EA._high ? !0 : this._high > EA._high ? !1 : this._low < EA._low;
      }, AA.prototype.or = function(EA) {
        return this._low |= EA._low, this._high |= EA._high, this;
      }, AA.prototype.and = function(EA) {
        return this._low &= EA._low, this._high &= EA._high, this;
      }, AA.prototype.not = function() {
        return this._low = ~this._low & 65535, this._high = ~this._high & 65535, this;
      }, AA.prototype.xor = function(EA) {
        return this._low ^= EA._low, this._high ^= EA._high, this;
      }, AA.prototype.shiftRight = AA.prototype.shiftr = function(EA) {
        return EA > 16 ? (this._low = this._high >> EA - 16, this._high = 0) : EA == 16 ? (this._low = this._high, this._high = 0) : (this._low = this._low >> EA | this._high << 16 - EA & 65535, this._high >>= EA), this;
      }, AA.prototype.shiftLeft = AA.prototype.shiftl = function(EA, iA) {
        return EA > 16 ? (this._high = this._low << EA - 16, this._low = 0, iA || (this._high &= 65535)) : EA == 16 ? (this._high = this._low, this._low = 0) : (this._high = this._high << EA | this._low >> 16 - EA, this._low = this._low << EA & 65535, iA || (this._high &= 65535)), this;
      }, AA.prototype.rotateLeft = AA.prototype.rotl = function(EA) {
        var iA = this._high << 16 | this._low;
        return iA = iA << EA | iA >>> 32 - EA, this._low = iA & 65535, this._high = iA >>> 16, this;
      }, AA.prototype.rotateRight = AA.prototype.rotr = function(EA) {
        var iA = this._high << 16 | this._low;
        return iA = iA >>> EA | iA << 32 - EA, this._low = iA & 65535, this._high = iA >>> 16, this;
      }, AA.prototype.clone = function() {
        return new AA(this._low, this._high);
      }, CA.exports ? CA.exports = AA : gA.UINT32 = AA;
    })(uint32);
  })(uint32$1)), uint32$1.exports;
}
var uint64$1 = { exports: {} }, uint64 = uint64$1.exports, hasRequiredUint64;
function requireUint64() {
  return hasRequiredUint64 || (hasRequiredUint64 = 1, (function(CA) {
    (function(gA) {
      var AA = {
        16: BA(Math.pow(16, 5)),
        10: BA(Math.pow(10, 5)),
        2: BA(Math.pow(2, 5))
      }, IA = {
        16: BA(16),
        10: BA(10),
        2: BA(2)
      };
      function BA(oA, cA, tA, eA) {
        if (!(this instanceof BA))
          return new BA(oA, cA, tA, eA);
        if (this.remainder = null, typeof oA == "string")
          return iA.call(this, oA, cA);
        if (typeof cA > "u")
          return EA.call(this, oA);
        QA.apply(this, arguments);
      }
      function QA(oA, cA, tA, eA) {
        return typeof tA > "u" ? (this._a00 = oA & 65535, this._a16 = oA >>> 16, this._a32 = cA & 65535, this._a48 = cA >>> 16, this) : (this._a00 = oA | 0, this._a16 = cA | 0, this._a32 = tA | 0, this._a48 = eA | 0, this);
      }
      BA.prototype.fromBits = QA;
      function EA(oA) {
        return this._a00 = oA & 65535, this._a16 = oA >>> 16, this._a32 = 0, this._a48 = 0, this;
      }
      BA.prototype.fromNumber = EA;
      function iA(oA, cA) {
        cA = cA || 10, this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0;
        for (var tA = AA[cA] || new BA(Math.pow(cA, 5)), eA = 0, aA = oA.length; eA < aA; eA += 5) {
          var GA = Math.min(5, aA - eA), lA = parseInt(oA.slice(eA, eA + GA), cA);
          this.multiply(
            GA < 5 ? new BA(Math.pow(cA, GA)) : tA
          ).add(new BA(lA));
        }
        return this;
      }
      BA.prototype.fromString = iA, BA.prototype.toNumber = function() {
        return this._a16 * 65536 + this._a00;
      }, BA.prototype.toString = function(oA) {
        oA = oA || 10;
        var cA = IA[oA] || new BA(oA);
        if (!this.gt(cA)) return this.toNumber().toString(oA);
        for (var tA = this.clone(), eA = new Array(64), aA = 63; aA >= 0 && (tA.div(cA), eA[aA] = tA.remainder.toNumber().toString(oA), !!tA.gt(cA)); aA--)
          ;
        return eA[aA - 1] = tA.toNumber().toString(oA), eA.join("");
      }, BA.prototype.add = function(oA) {
        var cA = this._a00 + oA._a00, tA = cA >>> 16;
        tA += this._a16 + oA._a16;
        var eA = tA >>> 16;
        eA += this._a32 + oA._a32;
        var aA = eA >>> 16;
        return aA += this._a48 + oA._a48, this._a00 = cA & 65535, this._a16 = tA & 65535, this._a32 = eA & 65535, this._a48 = aA & 65535, this;
      }, BA.prototype.subtract = function(oA) {
        return this.add(oA.clone().negate());
      }, BA.prototype.multiply = function(oA) {
        var cA = this._a00, tA = this._a16, eA = this._a32, aA = this._a48, GA = oA._a00, lA = oA._a16, nA = oA._a32, DA = oA._a48, hA = cA * GA, wA = hA >>> 16;
        wA += cA * lA;
        var sA = wA >>> 16;
        wA &= 65535, wA += tA * GA, sA += wA >>> 16, sA += cA * nA;
        var NA = sA >>> 16;
        return sA &= 65535, sA += tA * lA, NA += sA >>> 16, sA &= 65535, sA += eA * GA, NA += sA >>> 16, NA += cA * DA, NA &= 65535, NA += tA * nA, NA &= 65535, NA += eA * lA, NA &= 65535, NA += aA * GA, this._a00 = hA & 65535, this._a16 = wA & 65535, this._a32 = sA & 65535, this._a48 = NA & 65535, this;
      }, BA.prototype.div = function(oA) {
        if (oA._a16 == 0 && oA._a32 == 0 && oA._a48 == 0) {
          if (oA._a00 == 0) throw Error("division by zero");
          if (oA._a00 == 1)
            return this.remainder = new BA(0), this;
        }
        if (oA.gt(this))
          return this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        if (this.eq(oA))
          return this.remainder = new BA(0), this._a00 = 1, this._a16 = 0, this._a32 = 0, this._a48 = 0, this;
        for (var cA = oA.clone(), tA = -1; !this.lt(cA); )
          cA.shiftLeft(1, !0), tA++;
        for (this.remainder = this.clone(), this._a00 = 0, this._a16 = 0, this._a32 = 0, this._a48 = 0; tA >= 0; tA--)
          cA.shiftRight(1), this.remainder.lt(cA) || (this.remainder.subtract(cA), tA >= 48 ? this._a48 |= 1 << tA - 48 : tA >= 32 ? this._a32 |= 1 << tA - 32 : tA >= 16 ? this._a16 |= 1 << tA - 16 : this._a00 |= 1 << tA);
        return this;
      }, BA.prototype.negate = function() {
        var oA = (~this._a00 & 65535) + 1;
        return this._a00 = oA & 65535, oA = (~this._a16 & 65535) + (oA >>> 16), this._a16 = oA & 65535, oA = (~this._a32 & 65535) + (oA >>> 16), this._a32 = oA & 65535, this._a48 = ~this._a48 + (oA >>> 16) & 65535, this;
      }, BA.prototype.equals = BA.prototype.eq = function(oA) {
        return this._a48 == oA._a48 && this._a00 == oA._a00 && this._a32 == oA._a32 && this._a16 == oA._a16;
      }, BA.prototype.greaterThan = BA.prototype.gt = function(oA) {
        return this._a48 > oA._a48 ? !0 : this._a48 < oA._a48 ? !1 : this._a32 > oA._a32 ? !0 : this._a32 < oA._a32 ? !1 : this._a16 > oA._a16 ? !0 : this._a16 < oA._a16 ? !1 : this._a00 > oA._a00;
      }, BA.prototype.lessThan = BA.prototype.lt = function(oA) {
        return this._a48 < oA._a48 ? !0 : this._a48 > oA._a48 ? !1 : this._a32 < oA._a32 ? !0 : this._a32 > oA._a32 ? !1 : this._a16 < oA._a16 ? !0 : this._a16 > oA._a16 ? !1 : this._a00 < oA._a00;
      }, BA.prototype.or = function(oA) {
        return this._a00 |= oA._a00, this._a16 |= oA._a16, this._a32 |= oA._a32, this._a48 |= oA._a48, this;
      }, BA.prototype.and = function(oA) {
        return this._a00 &= oA._a00, this._a16 &= oA._a16, this._a32 &= oA._a32, this._a48 &= oA._a48, this;
      }, BA.prototype.xor = function(oA) {
        return this._a00 ^= oA._a00, this._a16 ^= oA._a16, this._a32 ^= oA._a32, this._a48 ^= oA._a48, this;
      }, BA.prototype.not = function() {
        return this._a00 = ~this._a00 & 65535, this._a16 = ~this._a16 & 65535, this._a32 = ~this._a32 & 65535, this._a48 = ~this._a48 & 65535, this;
      }, BA.prototype.shiftRight = BA.prototype.shiftr = function(oA) {
        return oA %= 64, oA >= 48 ? (this._a00 = this._a48 >> oA - 48, this._a16 = 0, this._a32 = 0, this._a48 = 0) : oA >= 32 ? (oA -= 32, this._a00 = (this._a32 >> oA | this._a48 << 16 - oA) & 65535, this._a16 = this._a48 >> oA & 65535, this._a32 = 0, this._a48 = 0) : oA >= 16 ? (oA -= 16, this._a00 = (this._a16 >> oA | this._a32 << 16 - oA) & 65535, this._a16 = (this._a32 >> oA | this._a48 << 16 - oA) & 65535, this._a32 = this._a48 >> oA & 65535, this._a48 = 0) : (this._a00 = (this._a00 >> oA | this._a16 << 16 - oA) & 65535, this._a16 = (this._a16 >> oA | this._a32 << 16 - oA) & 65535, this._a32 = (this._a32 >> oA | this._a48 << 16 - oA) & 65535, this._a48 = this._a48 >> oA & 65535), this;
      }, BA.prototype.shiftLeft = BA.prototype.shiftl = function(oA, cA) {
        return oA %= 64, oA >= 48 ? (this._a48 = this._a00 << oA - 48, this._a32 = 0, this._a16 = 0, this._a00 = 0) : oA >= 32 ? (oA -= 32, this._a48 = this._a16 << oA | this._a00 >> 16 - oA, this._a32 = this._a00 << oA & 65535, this._a16 = 0, this._a00 = 0) : oA >= 16 ? (oA -= 16, this._a48 = this._a32 << oA | this._a16 >> 16 - oA, this._a32 = (this._a16 << oA | this._a00 >> 16 - oA) & 65535, this._a16 = this._a00 << oA & 65535, this._a00 = 0) : (this._a48 = this._a48 << oA | this._a32 >> 16 - oA, this._a32 = (this._a32 << oA | this._a16 >> 16 - oA) & 65535, this._a16 = (this._a16 << oA | this._a00 >> 16 - oA) & 65535, this._a00 = this._a00 << oA & 65535), cA || (this._a48 &= 65535), this;
      }, BA.prototype.rotateLeft = BA.prototype.rotl = function(oA) {
        if (oA %= 64, oA == 0) return this;
        if (oA >= 32) {
          var cA = this._a00;
          if (this._a00 = this._a32, this._a32 = cA, cA = this._a48, this._a48 = this._a16, this._a16 = cA, oA == 32) return this;
          oA -= 32;
        }
        var tA = this._a48 << 16 | this._a32, eA = this._a16 << 16 | this._a00, aA = tA << oA | eA >>> 32 - oA, GA = eA << oA | tA >>> 32 - oA;
        return this._a00 = GA & 65535, this._a16 = GA >>> 16, this._a32 = aA & 65535, this._a48 = aA >>> 16, this;
      }, BA.prototype.rotateRight = BA.prototype.rotr = function(oA) {
        if (oA %= 64, oA == 0) return this;
        if (oA >= 32) {
          var cA = this._a00;
          if (this._a00 = this._a32, this._a32 = cA, cA = this._a48, this._a48 = this._a16, this._a16 = cA, oA == 32) return this;
          oA -= 32;
        }
        var tA = this._a48 << 16 | this._a32, eA = this._a16 << 16 | this._a00, aA = tA >>> oA | eA << 32 - oA, GA = eA >>> oA | tA << 32 - oA;
        return this._a00 = GA & 65535, this._a16 = GA >>> 16, this._a32 = aA & 65535, this._a48 = aA >>> 16, this;
      }, BA.prototype.clone = function() {
        return new BA(this._a00, this._a16, this._a32, this._a48);
      }, CA.exports ? CA.exports = BA : gA.UINT64 = BA;
    })(uint64);
  })(uint64$1)), uint64$1.exports;
}
var hasRequiredCuint;
function requireCuint() {
  return hasRequiredCuint || (hasRequiredCuint = 1, cuint.UINT32 = requireUint32(), cuint.UINT64 = requireUint64()), cuint;
}
var xxhash$1, hasRequiredXxhash;
function requireXxhash() {
  if (hasRequiredXxhash) return xxhash$1;
  hasRequiredXxhash = 1;
  var CA = requireCuint().UINT32;
  CA.prototype.xxh_update = function(cA, tA) {
    var eA = AA._low, aA = AA._high, GA, lA;
    lA = cA * eA, GA = lA >>> 16, GA += tA * eA, GA &= 65535, GA += cA * aA;
    var nA = this._low + (lA & 65535), DA = nA >>> 16;
    DA += this._high + (GA & 65535);
    var hA = DA << 16 | nA & 65535;
    hA = hA << 13 | hA >>> 19, nA = hA & 65535, DA = hA >>> 16, eA = gA._low, aA = gA._high, lA = nA * eA, GA = lA >>> 16, GA += DA * eA, GA &= 65535, GA += nA * aA, this._low = lA & 65535, this._high = GA & 65535;
  };
  var gA = CA("2654435761"), AA = CA("2246822519"), IA = CA("3266489917"), BA = CA("668265263"), QA = CA("374761393");
  function EA(cA) {
    for (var tA = [], eA = 0, aA = cA.length; eA < aA; eA++) {
      var GA = cA.charCodeAt(eA);
      GA < 128 ? tA.push(GA) : GA < 2048 ? tA.push(
        192 | GA >> 6,
        128 | GA & 63
      ) : GA < 55296 || GA >= 57344 ? tA.push(
        224 | GA >> 12,
        128 | GA >> 6 & 63,
        128 | GA & 63
      ) : (eA++, GA = 65536 + ((GA & 1023) << 10 | cA.charCodeAt(eA) & 1023), tA.push(
        240 | GA >> 18,
        128 | GA >> 12 & 63,
        128 | GA >> 6 & 63,
        128 | GA & 63
      ));
    }
    return new Uint8Array(tA);
  }
  function iA() {
    if (arguments.length == 2)
      return new iA(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof iA))
      return new iA(arguments[0]);
    oA.call(this, arguments[0]);
  }
  function oA(cA) {
    return this.seed = cA instanceof CA ? cA.clone() : CA(cA), this.v1 = this.seed.clone().add(gA).add(AA), this.v2 = this.seed.clone().add(AA), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(gA), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return iA.prototype.init = oA, iA.prototype.update = function(cA) {
    var tA = typeof cA == "string", eA;
    tA && (cA = EA(cA), tA = !1, eA = !0), typeof ArrayBuffer < "u" && cA instanceof ArrayBuffer && (eA = !0, cA = new Uint8Array(cA));
    var aA = 0, GA = cA.length, lA = aA + GA;
    if (GA == 0) return this;
    if (this.total_len += GA, this.memsize == 0 && (tA ? this.memory = "" : eA ? this.memory = new Uint8Array(16) : this.memory = new Buffer(16)), this.memsize + GA < 16)
      return tA ? this.memory += cA : eA ? this.memory.set(cA.subarray(0, GA), this.memsize) : cA.copy(this.memory, this.memsize, 0, GA), this.memsize += GA, this;
    if (this.memsize > 0) {
      tA ? this.memory += cA.slice(0, 16 - this.memsize) : eA ? this.memory.set(cA.subarray(0, 16 - this.memsize), this.memsize) : cA.copy(this.memory, this.memsize, 0, 16 - this.memsize);
      var nA = 0;
      tA ? (this.v1.xxh_update(
        this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
        this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2)
      ), nA += 4, this.v2.xxh_update(
        this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
        this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2)
      ), nA += 4, this.v3.xxh_update(
        this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
        this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2)
      ), nA += 4, this.v4.xxh_update(
        this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
        this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2)
      )) : (this.v1.xxh_update(
        this.memory[nA + 1] << 8 | this.memory[nA],
        this.memory[nA + 3] << 8 | this.memory[nA + 2]
      ), nA += 4, this.v2.xxh_update(
        this.memory[nA + 1] << 8 | this.memory[nA],
        this.memory[nA + 3] << 8 | this.memory[nA + 2]
      ), nA += 4, this.v3.xxh_update(
        this.memory[nA + 1] << 8 | this.memory[nA],
        this.memory[nA + 3] << 8 | this.memory[nA + 2]
      ), nA += 4, this.v4.xxh_update(
        this.memory[nA + 1] << 8 | this.memory[nA],
        this.memory[nA + 3] << 8 | this.memory[nA + 2]
      )), aA += 16 - this.memsize, this.memsize = 0, tA && (this.memory = "");
    }
    if (aA <= lA - 16) {
      var DA = lA - 16;
      do
        tA ? (this.v1.xxh_update(
          cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
          cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2)
        ), aA += 4, this.v2.xxh_update(
          cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
          cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2)
        ), aA += 4, this.v3.xxh_update(
          cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
          cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2)
        ), aA += 4, this.v4.xxh_update(
          cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
          cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2)
        )) : (this.v1.xxh_update(
          cA[aA + 1] << 8 | cA[aA],
          cA[aA + 3] << 8 | cA[aA + 2]
        ), aA += 4, this.v2.xxh_update(
          cA[aA + 1] << 8 | cA[aA],
          cA[aA + 3] << 8 | cA[aA + 2]
        ), aA += 4, this.v3.xxh_update(
          cA[aA + 1] << 8 | cA[aA],
          cA[aA + 3] << 8 | cA[aA + 2]
        ), aA += 4, this.v4.xxh_update(
          cA[aA + 1] << 8 | cA[aA],
          cA[aA + 3] << 8 | cA[aA + 2]
        )), aA += 4;
      while (aA <= DA);
    }
    return aA < lA && (tA ? this.memory += cA.slice(aA) : eA ? this.memory.set(cA.subarray(aA, lA), this.memsize) : cA.copy(this.memory, this.memsize, aA, lA), this.memsize = lA - aA), this;
  }, iA.prototype.digest = function() {
    var cA = this.memory, tA = typeof cA == "string", eA = 0, aA = this.memsize, GA, lA, nA = new CA();
    for (this.total_len >= 16 ? GA = this.v1.rotl(1).add(this.v2.rotl(7).add(this.v3.rotl(12).add(this.v4.rotl(18)))) : GA = this.seed.clone().add(QA), GA.add(nA.fromNumber(this.total_len)); eA <= aA - 4; )
      tA ? nA.fromBits(
        cA.charCodeAt(eA + 1) << 8 | cA.charCodeAt(eA),
        cA.charCodeAt(eA + 3) << 8 | cA.charCodeAt(eA + 2)
      ) : nA.fromBits(
        cA[eA + 1] << 8 | cA[eA],
        cA[eA + 3] << 8 | cA[eA + 2]
      ), GA.add(nA.multiply(IA)).rotl(17).multiply(BA), eA += 4;
    for (; eA < aA; )
      nA.fromBits(tA ? cA.charCodeAt(eA++) : cA[eA++], 0), GA.add(nA.multiply(QA)).rotl(11).multiply(gA);
    return lA = GA.clone().shiftRight(15), GA.xor(lA).multiply(AA), lA = GA.clone().shiftRight(13), GA.xor(lA).multiply(IA), lA = GA.clone().shiftRight(16), GA.xor(lA), this.init(this.seed), GA;
  }, xxhash$1 = iA, xxhash$1;
}
var xxhash64, hasRequiredXxhash64;
function requireXxhash64() {
  if (hasRequiredXxhash64) return xxhash64;
  hasRequiredXxhash64 = 1;
  var CA = requireCuint().UINT64, gA = CA("11400714785074694791"), AA = CA("14029467366897019727"), IA = CA("1609587929392839161"), BA = CA("9650029242287828579"), QA = CA("2870177450012600261");
  function EA(cA) {
    for (var tA = [], eA = 0, aA = cA.length; eA < aA; eA++) {
      var GA = cA.charCodeAt(eA);
      GA < 128 ? tA.push(GA) : GA < 2048 ? tA.push(
        192 | GA >> 6,
        128 | GA & 63
      ) : GA < 55296 || GA >= 57344 ? tA.push(
        224 | GA >> 12,
        128 | GA >> 6 & 63,
        128 | GA & 63
      ) : (eA++, GA = 65536 + ((GA & 1023) << 10 | cA.charCodeAt(eA) & 1023), tA.push(
        240 | GA >> 18,
        128 | GA >> 12 & 63,
        128 | GA >> 6 & 63,
        128 | GA & 63
      ));
    }
    return new Uint8Array(tA);
  }
  function iA() {
    if (arguments.length == 2)
      return new iA(arguments[1]).update(arguments[0]).digest();
    if (!(this instanceof iA))
      return new iA(arguments[0]);
    oA.call(this, arguments[0]);
  }
  function oA(cA) {
    return this.seed = cA instanceof CA ? cA.clone() : CA(cA), this.v1 = this.seed.clone().add(gA).add(AA), this.v2 = this.seed.clone().add(AA), this.v3 = this.seed.clone(), this.v4 = this.seed.clone().subtract(gA), this.total_len = 0, this.memsize = 0, this.memory = null, this;
  }
  return iA.prototype.init = oA, iA.prototype.update = function(cA) {
    var tA = typeof cA == "string", eA;
    tA && (cA = EA(cA), tA = !1, eA = !0), typeof ArrayBuffer < "u" && cA instanceof ArrayBuffer && (eA = !0, cA = new Uint8Array(cA));
    var aA = 0, GA = cA.length, lA = aA + GA;
    if (GA == 0) return this;
    if (this.total_len += GA, this.memsize == 0 && (tA ? this.memory = "" : eA ? this.memory = new Uint8Array(32) : this.memory = new Buffer(32)), this.memsize + GA < 32)
      return tA ? this.memory += cA : eA ? this.memory.set(cA.subarray(0, GA), this.memsize) : cA.copy(this.memory, this.memsize, 0, GA), this.memsize += GA, this;
    if (this.memsize > 0) {
      tA ? this.memory += cA.slice(0, 32 - this.memsize) : eA ? this.memory.set(cA.subarray(0, 32 - this.memsize), this.memsize) : cA.copy(this.memory, this.memsize, 0, 32 - this.memsize);
      var nA = 0;
      if (tA) {
        var DA;
        DA = CA(
          this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
          this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2),
          this.memory.charCodeAt(nA + 5) << 8 | this.memory.charCodeAt(nA + 4),
          this.memory.charCodeAt(nA + 7) << 8 | this.memory.charCodeAt(nA + 6)
        ), this.v1.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
          this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2),
          this.memory.charCodeAt(nA + 5) << 8 | this.memory.charCodeAt(nA + 4),
          this.memory.charCodeAt(nA + 7) << 8 | this.memory.charCodeAt(nA + 6)
        ), this.v2.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
          this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2),
          this.memory.charCodeAt(nA + 5) << 8 | this.memory.charCodeAt(nA + 4),
          this.memory.charCodeAt(nA + 7) << 8 | this.memory.charCodeAt(nA + 6)
        ), this.v3.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory.charCodeAt(nA + 1) << 8 | this.memory.charCodeAt(nA),
          this.memory.charCodeAt(nA + 3) << 8 | this.memory.charCodeAt(nA + 2),
          this.memory.charCodeAt(nA + 5) << 8 | this.memory.charCodeAt(nA + 4),
          this.memory.charCodeAt(nA + 7) << 8 | this.memory.charCodeAt(nA + 6)
        ), this.v4.add(DA.multiply(AA)).rotl(31).multiply(gA);
      } else {
        var DA;
        DA = CA(
          this.memory[nA + 1] << 8 | this.memory[nA],
          this.memory[nA + 3] << 8 | this.memory[nA + 2],
          this.memory[nA + 5] << 8 | this.memory[nA + 4],
          this.memory[nA + 7] << 8 | this.memory[nA + 6]
        ), this.v1.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory[nA + 1] << 8 | this.memory[nA],
          this.memory[nA + 3] << 8 | this.memory[nA + 2],
          this.memory[nA + 5] << 8 | this.memory[nA + 4],
          this.memory[nA + 7] << 8 | this.memory[nA + 6]
        ), this.v2.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory[nA + 1] << 8 | this.memory[nA],
          this.memory[nA + 3] << 8 | this.memory[nA + 2],
          this.memory[nA + 5] << 8 | this.memory[nA + 4],
          this.memory[nA + 7] << 8 | this.memory[nA + 6]
        ), this.v3.add(DA.multiply(AA)).rotl(31).multiply(gA), nA += 8, DA = CA(
          this.memory[nA + 1] << 8 | this.memory[nA],
          this.memory[nA + 3] << 8 | this.memory[nA + 2],
          this.memory[nA + 5] << 8 | this.memory[nA + 4],
          this.memory[nA + 7] << 8 | this.memory[nA + 6]
        ), this.v4.add(DA.multiply(AA)).rotl(31).multiply(gA);
      }
      aA += 32 - this.memsize, this.memsize = 0, tA && (this.memory = "");
    }
    if (aA <= lA - 32) {
      var hA = lA - 32;
      do {
        if (tA) {
          var DA;
          DA = CA(
            cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
            cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2),
            cA.charCodeAt(aA + 5) << 8 | cA.charCodeAt(aA + 4),
            cA.charCodeAt(aA + 7) << 8 | cA.charCodeAt(aA + 6)
          ), this.v1.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
            cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2),
            cA.charCodeAt(aA + 5) << 8 | cA.charCodeAt(aA + 4),
            cA.charCodeAt(aA + 7) << 8 | cA.charCodeAt(aA + 6)
          ), this.v2.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
            cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2),
            cA.charCodeAt(aA + 5) << 8 | cA.charCodeAt(aA + 4),
            cA.charCodeAt(aA + 7) << 8 | cA.charCodeAt(aA + 6)
          ), this.v3.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA.charCodeAt(aA + 1) << 8 | cA.charCodeAt(aA),
            cA.charCodeAt(aA + 3) << 8 | cA.charCodeAt(aA + 2),
            cA.charCodeAt(aA + 5) << 8 | cA.charCodeAt(aA + 4),
            cA.charCodeAt(aA + 7) << 8 | cA.charCodeAt(aA + 6)
          ), this.v4.add(DA.multiply(AA)).rotl(31).multiply(gA);
        } else {
          var DA;
          DA = CA(
            cA[aA + 1] << 8 | cA[aA],
            cA[aA + 3] << 8 | cA[aA + 2],
            cA[aA + 5] << 8 | cA[aA + 4],
            cA[aA + 7] << 8 | cA[aA + 6]
          ), this.v1.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA[aA + 1] << 8 | cA[aA],
            cA[aA + 3] << 8 | cA[aA + 2],
            cA[aA + 5] << 8 | cA[aA + 4],
            cA[aA + 7] << 8 | cA[aA + 6]
          ), this.v2.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA[aA + 1] << 8 | cA[aA],
            cA[aA + 3] << 8 | cA[aA + 2],
            cA[aA + 5] << 8 | cA[aA + 4],
            cA[aA + 7] << 8 | cA[aA + 6]
          ), this.v3.add(DA.multiply(AA)).rotl(31).multiply(gA), aA += 8, DA = CA(
            cA[aA + 1] << 8 | cA[aA],
            cA[aA + 3] << 8 | cA[aA + 2],
            cA[aA + 5] << 8 | cA[aA + 4],
            cA[aA + 7] << 8 | cA[aA + 6]
          ), this.v4.add(DA.multiply(AA)).rotl(31).multiply(gA);
        }
        aA += 8;
      } while (aA <= hA);
    }
    return aA < lA && (tA ? this.memory += cA.slice(aA) : eA ? this.memory.set(cA.subarray(aA, lA), this.memsize) : cA.copy(this.memory, this.memsize, aA, lA), this.memsize = lA - aA), this;
  }, iA.prototype.digest = function() {
    var cA = this.memory, tA = typeof cA == "string", eA = 0, aA = this.memsize, GA, lA, nA = new CA();
    for (this.total_len >= 32 ? (GA = this.v1.clone().rotl(1), GA.add(this.v2.clone().rotl(7)), GA.add(this.v3.clone().rotl(12)), GA.add(this.v4.clone().rotl(18)), GA.xor(this.v1.multiply(AA).rotl(31).multiply(gA)), GA.multiply(gA).add(BA), GA.xor(this.v2.multiply(AA).rotl(31).multiply(gA)), GA.multiply(gA).add(BA), GA.xor(this.v3.multiply(AA).rotl(31).multiply(gA)), GA.multiply(gA).add(BA), GA.xor(this.v4.multiply(AA).rotl(31).multiply(gA)), GA.multiply(gA).add(BA)) : GA = this.seed.clone().add(QA), GA.add(nA.fromNumber(this.total_len)); eA <= aA - 8; )
      tA ? nA.fromBits(
        cA.charCodeAt(eA + 1) << 8 | cA.charCodeAt(eA),
        cA.charCodeAt(eA + 3) << 8 | cA.charCodeAt(eA + 2),
        cA.charCodeAt(eA + 5) << 8 | cA.charCodeAt(eA + 4),
        cA.charCodeAt(eA + 7) << 8 | cA.charCodeAt(eA + 6)
      ) : nA.fromBits(
        cA[eA + 1] << 8 | cA[eA],
        cA[eA + 3] << 8 | cA[eA + 2],
        cA[eA + 5] << 8 | cA[eA + 4],
        cA[eA + 7] << 8 | cA[eA + 6]
      ), nA.multiply(AA).rotl(31).multiply(gA), GA.xor(nA).rotl(27).multiply(gA).add(BA), eA += 8;
    for (eA + 4 <= aA && (tA ? nA.fromBits(
      cA.charCodeAt(eA + 1) << 8 | cA.charCodeAt(eA),
      cA.charCodeAt(eA + 3) << 8 | cA.charCodeAt(eA + 2),
      0,
      0
    ) : nA.fromBits(
      cA[eA + 1] << 8 | cA[eA],
      cA[eA + 3] << 8 | cA[eA + 2],
      0,
      0
    ), GA.xor(nA.multiply(gA)).rotl(23).multiply(AA).add(IA), eA += 4); eA < aA; )
      nA.fromBits(tA ? cA.charCodeAt(eA++) : cA[eA++], 0, 0, 0), GA.xor(nA.multiply(QA)).rotl(11).multiply(gA);
    return lA = GA.clone().shiftRight(33), GA.xor(lA).multiply(AA), lA = GA.clone().shiftRight(29), GA.xor(lA).multiply(IA), lA = GA.clone().shiftRight(32), GA.xor(lA), this.init(this.seed), GA;
  }, xxhash64 = iA, xxhash64;
}
var lib$1, hasRequiredLib$1;
function requireLib$1() {
  return hasRequiredLib$1 || (hasRequiredLib$1 = 1, lib$1 = {
    h32: requireXxhash(),
    h64: requireXxhash64()
  }), lib$1;
}
var libExports$1 = requireLib$1();
const xxhash = /* @__PURE__ */ getDefaultExportFromCjs(libExports$1), assertNever = (CA) => {
  throw new Error(`Reached a branch with non-exhaustive item: ${CA}`);
}, GENERATED_ELEMENT_ID_PREFIX = "$$ID";
function debounce$1(CA, gA) {
  let AA = null;
  return (...IA) => {
    AA && clearTimeout(AA), AA = setTimeout(() => {
      gA(...IA), AA = null;
    }, CA);
  };
}
const EMBED_QUERY_PARAM_KEY = "embed", EMBED_OPTIONS_QUERY_PARAM_KEY = "embed_options", EMBED_SHOW_TOOLBAR = "show_toolbar", EMBED_SHOW_PADDING = "show_padding", EMBED_DISABLE_SCROLLING = "disable_scrolling", EMBED_LIGHT_THEME = "light_theme", EMBED_DARK_THEME = "dark_theme", EMBED_TRUE = "true", EMBED_HIDE_LOADING_SCREEN = "hide_loading_screen", EMBED_SHOW_LOADING_SCREEN_V1 = "show_loading_screen_v1", EMBED_SHOW_LOADING_SCREEN_V2 = "show_loading_screen_v2", EMBED_QUERY_PARAM_VALUES = [EMBED_SHOW_TOOLBAR, EMBED_SHOW_PADDING, EMBED_DISABLE_SCROLLING, EMBED_LIGHT_THEME, EMBED_DARK_THEME, EMBED_HIDE_LOADING_SCREEN, EMBED_SHOW_LOADING_SCREEN_V1, EMBED_SHOW_LOADING_SCREEN_V2, EMBED_TRUE];
var LoadingScreenType = /* @__PURE__ */ ((CA) => (CA[CA.NONE = 0] = "NONE", CA[CA.V1 = 1] = "V1", CA[CA.V2 = 2] = "V2", CA))(LoadingScreenType || {});
function getEmbedUrlParams(CA) {
  const gA = /* @__PURE__ */ new Set();
  return new URLSearchParams(window.location.search).forEach((IA, BA) => {
    BA = BA.toString().toLowerCase(), IA = IA.toString().toLowerCase(), BA === CA && EMBED_QUERY_PARAM_VALUES.includes(IA) && gA.add(IA);
  }), gA;
}
function preserveEmbedQueryParams() {
  if (!isEmbed())
    return "";
  const CA = new URLSearchParams(window.location.search).getAll(EMBED_OPTIONS_QUERY_PARAM_KEY), gA = [];
  return gA.push([EMBED_QUERY_PARAM_KEY, EMBED_TRUE]), CA.forEach((AA) => {
    gA.push([EMBED_OPTIONS_QUERY_PARAM_KEY, AA]);
  }), new URLSearchParams(gA).toString();
}
function getQueryString(CA, gA) {
  return CA !== void 0 ? gA ? CA ? `${gA}&${CA}` : gA : CA : gA;
}
function isEmbed() {
  return getEmbedUrlParams(EMBED_QUERY_PARAM_KEY).has(EMBED_TRUE);
}
function isToolbarDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_TOOLBAR);
}
function isScrollingHidden() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DISABLE_SCROLLING);
}
function isPaddingDisplayed() {
  return isEmbed() && getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_SHOW_PADDING);
}
function isLightThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_LIGHT_THEME);
}
function isDarkThemeInQueryParams() {
  return getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY).has(EMBED_DARK_THEME);
}
function isInChildFrame() {
  return window.parent !== window;
}
function getUrl() {
  let CA;
  try {
    isInChildFrame() && window.top ? CA = window.top.location.href : CA = document.location.href;
  } catch {
    CA = document.location.href;
  }
  const gA = new URL(CA);
  return gA.search = "", gA.hash = "", gA.toString();
}
function getScreencastTimestamp() {
  const CA = /* @__PURE__ */ new Date(), gA = CA.getFullYear(), AA = String(CA.getMonth() + 1).padStart(2, "0"), IA = String(CA.getDate()).padStart(2, "0"), BA = String(CA.getHours()).padStart(2, "0"), QA = String(CA.getMinutes()).padStart(2, "0"), EA = String(CA.getSeconds()).padStart(2, "0");
  return `${gA}-${AA}-${IA}-${BA}-${QA}-${EA}`;
}
function getTimezone$1() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function getTimezoneOffset() {
  return (/* @__PURE__ */ new Date()).getTimezoneOffset();
}
function getLocaleLanguage() {
  return navigator.language;
}
function getLoadingScreenType() {
  const CA = getEmbedUrlParams(EMBED_OPTIONS_QUERY_PARAM_KEY);
  return CA.has(EMBED_HIDE_LOADING_SCREEN) ? 0 : CA.has(EMBED_SHOW_LOADING_SCREEN_V1) ? 1 : 2;
}
function makeElementWithInfoText(CA) {
  return new Element$1({
    alert: {
      body: CA,
      format: Alert.Format.INFO
    }
  });
}
function makeElementWithErrorText(CA) {
  return new Element$1({
    alert: {
      body: CA,
      format: Alert.Format.ERROR
    }
  });
}
function makeAppSkeletonElement() {
  return new Element$1({
    skeleton: {
      style: Skeleton$1.SkeletonStyle.APP
    }
  });
}
function hashString(CA) {
  return xxhash.h32(CA, 3735928559).toString(16);
}
function requireNonNull(CA) {
  if (isNullOrUndefined$1(CA))
    throw new Error("value is null");
  return CA;
}
function notUndefined(CA) {
  return CA !== void 0;
}
function isFromMac() {
  return /Mac/i.test(navigator.platform);
}
function isFromWindows() {
  return /^Win/i.test(navigator.platform);
}
function setCookie(CA, gA, AA) {
  const IA = gA ? AA : /* @__PURE__ */ new Date(), BA = IA ? `expires=${IA.toUTCString()};` : "";
  document.cookie = `${CA}=${gA};${BA}path=/`;
}
function isValidElementId(CA) {
  return CA ? CA.startsWith(GENERATED_ELEMENT_ID_PREFIX) && // There must be at least 3 parts: $$ID-<hash>-<userKey>
  CA.split("-").length >= 3 : !1;
}
function getElementId(CA) {
  const gA = get$1(CA, [requireNonNull(CA.type), "id"]);
  if (gA && isValidElementId(gA))
    return gA;
}
function isValidFormId(CA) {
  return notNullOrUndefined(CA) && CA.length > 0;
}
function isInForm(CA) {
  return isValidFormId(CA.formId);
}
function getSelectPlaceholder(CA, gA, AA, IA = !1) {
  let BA = !1;
  return CA !== "" ? {
    placeholder: CA,
    shouldDisable: BA
  } : (gA.length === 0 ? AA ? CA = IA ? "Add options" : "Add an option" : (CA = "No options to select", BA = !0) : AA ? CA = IA ? "Choose or add options" : "Choose or add an option" : CA = IA ? "Choose options" : "Choose an option", {
    placeholder: CA,
    shouldDisable: BA
  });
}
var LabelVisibilityOptions = /* @__PURE__ */ ((CA) => (CA[CA.Visible = 0] = "Visible", CA[CA.Hidden = 1] = "Hidden", CA[CA.Collapsed = 2] = "Collapsed", CA))(LabelVisibilityOptions || {});
function labelVisibilityProtoValueToEnum(CA) {
  switch (CA) {
    case LabelVisibility.LabelVisibilityOptions.VISIBLE:
      return 0;
    case LabelVisibility.LabelVisibilityOptions.HIDDEN:
      return 1;
    case LabelVisibility.LabelVisibilityOptions.COLLAPSED:
      return 2;
    default:
      return 0;
  }
}
var AcceptFileValue = /* @__PURE__ */ ((CA) => (CA[CA.None = 0] = "None", CA[CA.Single = 1] = "Single", CA[CA.Multiple = 2] = "Multiple", CA[CA.Directory = 3] = "Directory", CA))(AcceptFileValue || {});
function chatInputAcceptFileProtoValueToEnum(CA) {
  switch (CA) {
    case ChatInput$1.AcceptFile.NONE:
      return 0;
    case ChatInput$1.AcceptFile.SINGLE:
      return 1;
    case ChatInput$1.AcceptFile.MULTIPLE:
      return 2;
    case ChatInput$1.AcceptFile.DIRECTORY:
      return 3;
    default:
      return assertNever(CA), 0;
  }
}
function findAnIFrameWithClassName(CA, gA) {
  for (let AA = 0; AA < CA.length; AA++) {
    const IA = CA[AA].contentDocument;
    if (IA && IA.getElementsByClassName(gA).length > 0)
      return CA[AA];
  }
  return null;
}
function canAccessIFrame(CA) {
  try {
    if (CA.contentWindow === null) return !1;
    const AA = (CA.contentDocument || CA.contentWindow.document).body.innerHTML;
    return AA !== null && AA !== "";
  } catch {
    return !1;
  }
}
function getIFrameEnclosingApp(CA) {
  if (!isInChildFrame())
    return null;
  const gA = getEmbeddingIdClassName(CA), AA = 'iframe[title="streamlitApp"]';
  let IA = window.document.querySelectorAll(AA), BA = findAnIFrameWithClassName(IA, gA);
  if (BA && !canAccessIFrame(BA))
    return null;
  if (BA)
    return BA;
  if (window.parent && (IA = window.parent.document.querySelectorAll(AA)), BA = findAnIFrameWithClassName(IA, gA), BA && !canAccessIFrame(BA))
    return null;
  if (BA)
    return BA;
  let QA = window.document.getElementsByTagName("iframe");
  return BA = findAnIFrameWithClassName(QA, gA), BA && !canAccessIFrame(BA) ? null : BA || (window.parent && (QA = window.parent.document.getElementsByTagName("iframe")), BA = findAnIFrameWithClassName(QA, gA), BA && !canAccessIFrame(BA) ? null : BA);
}
function generateUID$2() {
  return Math.floor(Date.now() / 1e3).toString(36) + Math.random().toString(36).slice(-6);
}
function getEmbeddingIdClassName(CA) {
  return `stAppEmbeddingId-${CA}`;
}
function extractPageNameFromPathName(CA, gA) {
  return decodeURIComponent(CA.replace(gA, "").replace(new RegExp("^/?"), "").replace(new RegExp("/$"), ""));
}
function keysToSnakeCase(CA) {
  return Object.keys(CA).reduce((gA, AA) => {
    const IA = decamelize$1(AA, {
      preserveConsecutiveUppercase: !0
    }).replace(".", "_");
    let BA = CA[AA];
    return BA && typeof BA == "object" && !Array.isArray(BA) && (BA = keysToSnakeCase(BA)), Array.isArray(BA) && (BA = BA.map((QA) => QA !== null && typeof QA == "object" ? keysToSnakeCase(QA) : QA)), gA[IA] = BA, gA;
  }, {});
}
const MAX_HASH_LENGTH = 6;
class DebugVisitor {
  constructor(gA = "", AA = !0) {
    this.prefix = gA, this.isLast = AA;
  }
  visitBlockNode(gA) {
    const AA = this.isLast ? "└── " : "├── ", IA = this.prefix + (this.isLast ? "    " : "│   ");
    let BA = `${this.prefix}${AA}BlockNode [${gA.children.length} children]`;
    return gA.scriptRunId !== NO_SCRIPT_RUN_ID && (BA += ` (run: ${gA.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), BA += `
`, gA.children.forEach((QA, EA) => {
      const iA = EA === gA.children.length - 1, oA = new DebugVisitor(IA, iA);
      BA += QA.accept(oA);
    }), BA;
  }
  visitElementNode(gA) {
    const AA = this.isLast ? "└── " : "├── ";
    let IA = `${this.prefix}${AA}ElementNode [${gA.element.type}]`;
    if (gA.element.type === "text" && gA.element.text?.body) {
      const BA = gA.element.text.body.length > 30 ? `${gA.element.text.body.slice(0, 30)}...` : gA.element.text.body;
      IA += ` "${BA}"`;
    }
    return gA.scriptRunId !== NO_SCRIPT_RUN_ID && (IA += ` (run: ${gA.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), gA.fragmentId && (IA += ` (fragment: ${gA.fragmentId.substring(0, MAX_HASH_LENGTH)})`), IA += ` (activeScriptHash: ${gA.activeScriptHash.substring(0, MAX_HASH_LENGTH)})`, IA += `
`, IA;
  }
  visitTransientNode(gA) {
    const AA = this.isLast ? "└── " : "├── ", IA = this.prefix + (this.isLast ? "    " : "│   ");
    let BA = `${this.prefix}${AA}TransientNode [${gA.transientNodes.length} transient]`;
    if (gA.scriptRunId !== NO_SCRIPT_RUN_ID && (BA += ` (run: ${gA.scriptRunId.substring(0, MAX_HASH_LENGTH)})`), BA += `
`, gA.anchor) {
      BA += `${IA}├── anchor:
`;
      const QA = new DebugVisitor(IA + "│   ", !0);
      BA += gA.anchor.accept(QA);
    }
    return gA.transientNodes.length > 0 && (BA += `${IA}└── transient nodes:
`, gA.transientNodes.forEach((QA, EA) => {
      const iA = EA === gA.transientNodes.length - 1, oA = iA ? "└── " : "├── ", cA = IA + "    " + (iA ? "    " : "│   ");
      BA += `${IA}    ${oA}:
`;
      const tA = new DebugVisitor(cA, !0);
      BA += QA.accept(tA);
    })), BA;
  }
  /**
   * Static helper method to generate debug output for any AppNode.
   */
  static generateDebugString(gA, AA = "", IA = !0) {
    const BA = new DebugVisitor(AA, IA);
    return gA.accept(BA);
  }
}
class TransientNode {
  constructor(gA, AA, IA, BA) {
    this.scriptRunId = gA, this.anchor = AA, this.transientNodes = IA ?? [], this.deltaMsgReceivedAt = BA ?? Date.now(), this.fragmentId = void 0, this.activeScriptHash = void 0;
  }
  /**
   * Updates the transient nodes by applying a function to each transient node.
   * If the function returns undefined, the transient node is removed from the list.
   * @param update - A function that takes an ElementNode and returns an ElementNode or undefined.
   * @returns A new array of transient nodes.
   */
  updateTransientNodes(gA) {
    const AA = [];
    return this.transientNodes.forEach((IA) => {
      const BA = gA(IA);
      BA && AA.push(BA);
    }), AA;
  }
  accept(gA) {
    return gA.visitTransientNode(this);
  }
  debug() {
    return this.accept(new DebugVisitor());
  }
  // Combine the information of the node with the updated information
  // of *this* node
  replaceTransientNodeWithSelf(gA) {
    return !this.deltaMsgReceivedAt || !gA.deltaMsgReceivedAt || this.deltaMsgReceivedAt >= gA.deltaMsgReceivedAt ? new TransientNode(this.scriptRunId, this.anchor ?? gA.anchor, this.transientNodes, this.deltaMsgReceivedAt) : gA;
  }
}
class ClearStaleNodeVisitor {
  constructor(gA, AA, IA) {
    this.currentScriptRunId = gA, this.fragmentIdsThisRun = AA ?? [], this.fragmentIdOfBlock = IA;
  }
  get isFragmentRun() {
    return this.fragmentIdsThisRun.length > 0;
  }
  visitBlockNode(gA) {
    let AA = null;
    if (this.isFragmentRun) {
      if (this.fragmentIdOfBlock && gA.scriptRunId !== this.currentScriptRunId)
        return;
      gA.fragmentId && this.fragmentIdsThisRun.includes(gA.fragmentId) && gA.scriptRunId === this.currentScriptRunId && (AA = new ClearStaleNodeVisitor(this.currentScriptRunId, this.fragmentIdsThisRun, gA.fragmentId));
    } else if (gA.scriptRunId !== this.currentScriptRunId)
      return;
    const IA = [];
    let BA = !1;
    return gA.children.forEach((QA) => {
      const EA = QA.accept(AA ?? this);
      EA !== QA && (BA = !0), EA !== void 0 && IA.push(EA);
    }), BA ? new BlockNode(gA.activeScriptHash, IA, gA.deltaBlock, this.currentScriptRunId, gA.fragmentId, gA.deltaMsgReceivedAt) : gA;
  }
  visitElementNode(gA) {
    return this.isFragmentRun && (!gA.fragmentId || !this.fragmentIdOfBlock || gA.scriptRunId === this.currentScriptRunId) || gA.scriptRunId === this.currentScriptRunId ? gA : void 0;
  }
  visitTransientNode(gA) {
    if (gA.scriptRunId === this.currentScriptRunId && gA.transientNodes.length === 0 && gA.anchor)
      return gA.anchor.accept(this);
    const AA = gA.anchor?.accept(this), IA = gA.updateTransientNodes((BA) => BA.accept(this));
    if (!(!AA && IA.length === 0))
      return IA.length === 0 ? AA : new TransientNode(gA.scriptRunId, AA, IA, gA.deltaMsgReceivedAt);
  }
}
class BlockNode {
  constructor(gA, AA, IA, BA, QA, EA) {
    this.activeScriptHash = gA, this.children = AA ?? [], this.deltaBlock = IA ?? new Block$1({}), this.scriptRunId = BA ?? NO_SCRIPT_RUN_ID, this.fragmentId = QA, this.deltaMsgReceivedAt = EA;
  }
  /** True if this Block has no children. */
  get isEmpty() {
    return this.children.length === 0;
  }
  replaceTransientNodeWithSelf(gA) {
    if (gA.scriptRunId !== this.scriptRunId)
      return this;
    if (gA.transientNodes.length === 0)
      return this;
    const AA = gA.updateTransientNodes((IA) => IA.accept(new ClearStaleNodeVisitor(this.scriptRunId)));
    return AA.length === 0 ? this : new TransientNode(this.scriptRunId, this, AA, gA.deltaMsgReceivedAt);
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitBlockNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = blockNode.accept(visitor)
   * console.log(result)
   */
  accept(gA) {
    return gA.visitBlockNode(this);
  }
  /**
   * Returns a string representation of this BlockNode and its children,
   * primarily for debugging or logging purposes.
   *
   * @returns {string} A debug string describing the structure of this BlockNode.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
}
var NOTHING = /* @__PURE__ */ Symbol.for("immer-nothing"), DRAFTABLE = /* @__PURE__ */ Symbol.for("immer-draftable"), DRAFT_STATE = /* @__PURE__ */ Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(CA) {
    return `The plugin for '${CA}' has not been loaded into Immer. To enable the plugin, import and call \`enable${CA}()\` when initializing your application.`;
  },
  function(CA) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${CA}'`;
  },
  "This object has been frozen and should not be mutated",
  function(CA) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + CA;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(CA) {
    return `'current' expects a draft, got: ${CA}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(CA) {
    return `'original' expects a draft, got: ${CA}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(CA, ...gA) {
  if (process.env.NODE_ENV !== "production") {
    const AA = errors[CA], IA = isFunction$3(AA) ? AA.apply(null, gA) : AA;
    throw new Error(`[Immer] ${IA}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${CA}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var O$2 = Object, getPrototypeOf = O$2.getPrototypeOf, CONSTRUCTOR = "constructor", PROTOTYPE = "prototype", CONFIGURABLE = "configurable", ENUMERABLE = "enumerable", WRITABLE = "writable", VALUE = "value", isDraft = (CA) => !!CA && !!CA[DRAFT_STATE];
function isDraftable(CA) {
  return CA ? isPlainObject$2(CA) || isArray(CA) || !!CA[DRAFTABLE] || !!CA[CONSTRUCTOR]?.[DRAFTABLE] || isMap(CA) || isSet(CA) : !1;
}
var objectCtorString = O$2[PROTOTYPE][CONSTRUCTOR].toString(), cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$2(CA) {
  if (!CA || !isObjectish(CA))
    return !1;
  const gA = getPrototypeOf(CA);
  if (gA === null || gA === O$2[PROTOTYPE])
    return !0;
  const AA = O$2.hasOwnProperty.call(gA, CONSTRUCTOR) && gA[CONSTRUCTOR];
  if (AA === Object)
    return !0;
  if (!isFunction$3(AA))
    return !1;
  let IA = cachedCtorStrings.get(AA);
  return IA === void 0 && (IA = Function.toString.call(AA), cachedCtorStrings.set(AA, IA)), IA === objectCtorString;
}
function each$1(CA, gA, AA = !0) {
  getArchtype(CA) === 0 ? (AA ? Reflect.ownKeys(CA) : O$2.keys(CA)).forEach((BA) => {
    gA(BA, CA[BA], CA);
  }) : CA.forEach((IA, BA) => gA(BA, IA, CA));
}
function getArchtype(CA) {
  const gA = CA[DRAFT_STATE];
  return gA ? gA.type_ : isArray(CA) ? 1 : isMap(CA) ? 2 : isSet(CA) ? 3 : 0;
}
var has$1 = (CA, gA, AA = getArchtype(CA)) => AA === 2 ? CA.has(gA) : O$2[PROTOTYPE].hasOwnProperty.call(CA, gA), get = (CA, gA, AA = getArchtype(CA)) => (
  // @ts-ignore
  AA === 2 ? CA.get(gA) : CA[gA]
), set = (CA, gA, AA, IA = getArchtype(CA)) => {
  IA === 2 ? CA.set(gA, AA) : IA === 3 ? CA.add(AA) : CA[gA] = AA;
};
function is(CA, gA) {
  return CA === gA ? CA !== 0 || 1 / CA === 1 / gA : CA !== CA && gA !== gA;
}
var isArray = Array.isArray, isMap = (CA) => CA instanceof Map, isSet = (CA) => CA instanceof Set, isObjectish = (CA) => typeof CA == "object", isFunction$3 = (CA) => typeof CA == "function", isBoolean$1 = (CA) => typeof CA == "boolean";
function isArrayIndex(CA) {
  const gA = +CA;
  return Number.isInteger(gA) && String(gA) === CA;
}
var getProxyDraft = (CA) => isObjectish(CA) ? CA?.[DRAFT_STATE] : null, latest = (CA) => CA.copy_ || CA.base_, getValue = (CA) => {
  const gA = getProxyDraft(CA);
  return gA ? gA.copy_ ?? gA.base_ : CA;
}, getFinalValue = (CA) => CA.modified_ ? CA.copy_ : CA.base_;
function shallowCopy(CA, gA) {
  if (isMap(CA))
    return new Map(CA);
  if (isSet(CA))
    return new Set(CA);
  if (isArray(CA))
    return Array[PROTOTYPE].slice.call(CA);
  const AA = isPlainObject$2(CA);
  if (gA === !0 || gA === "class_only" && !AA) {
    const IA = O$2.getOwnPropertyDescriptors(CA);
    delete IA[DRAFT_STATE];
    let BA = Reflect.ownKeys(IA);
    for (let QA = 0; QA < BA.length; QA++) {
      const EA = BA[QA], iA = IA[EA];
      iA[WRITABLE] === !1 && (iA[WRITABLE] = !0, iA[CONFIGURABLE] = !0), (iA.get || iA.set) && (IA[EA] = {
        [CONFIGURABLE]: !0,
        [WRITABLE]: !0,
        // could live with !!desc.set as well here...
        [ENUMERABLE]: iA[ENUMERABLE],
        [VALUE]: CA[EA]
      });
    }
    return O$2.create(getPrototypeOf(CA), IA);
  } else {
    const IA = getPrototypeOf(CA);
    if (IA !== null && AA)
      return { ...CA };
    const BA = O$2.create(IA);
    return O$2.assign(BA, CA);
  }
}
function freeze(CA, gA = !1) {
  return isFrozen(CA) || isDraft(CA) || !isDraftable(CA) || (getArchtype(CA) > 1 && O$2.defineProperties(CA, {
    set: dontMutateMethodOverride,
    add: dontMutateMethodOverride,
    clear: dontMutateMethodOverride,
    delete: dontMutateMethodOverride
  }), O$2.freeze(CA), gA && each$1(
    CA,
    (AA, IA) => {
      freeze(IA, !0);
    },
    !1
  )), CA;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections
};
function isFrozen(CA) {
  return CA === null || !isObjectish(CA) ? !0 : O$2.isFrozen(CA);
}
var PluginMapSet = "MapSet", PluginPatches = "Patches", PluginArrayMethods = "ArrayMethods", plugins$1 = {};
function getPlugin(CA) {
  const gA = plugins$1[CA];
  return gA || die(0, CA), gA;
}
var isPluginLoaded = (CA) => !!plugins$1[CA];
function loadPlugin(CA, gA) {
  plugins$1[CA] || (plugins$1[CA] = gA);
}
var currentScope, getCurrentScope = () => currentScope, createScope = (CA, gA) => ({
  drafts_: [],
  parent_: CA,
  immer_: gA,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: !0,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
  arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
});
function usePatchesInScope(CA, gA) {
  gA && (CA.patchPlugin_ = getPlugin(PluginPatches), CA.patches_ = [], CA.inversePatches_ = [], CA.patchListener_ = gA);
}
function revokeScope(CA) {
  leaveScope(CA), CA.drafts_.forEach(revokeDraft), CA.drafts_ = null;
}
function leaveScope(CA) {
  CA === currentScope && (currentScope = CA.parent_);
}
var enterScope = (CA) => currentScope = createScope(currentScope, CA);
function revokeDraft(CA) {
  const gA = CA[DRAFT_STATE];
  gA.type_ === 0 || gA.type_ === 1 ? gA.revoke_() : gA.revoked_ = !0;
}
function processResult(CA, gA) {
  gA.unfinalizedDrafts_ = gA.drafts_.length;
  const AA = gA.drafts_[0];
  if (CA !== void 0 && CA !== AA) {
    AA[DRAFT_STATE].modified_ && (revokeScope(gA), die(4)), isDraftable(CA) && (CA = finalize(gA, CA));
    const { patchPlugin_: BA } = gA;
    BA && BA.generateReplacementPatches_(
      AA[DRAFT_STATE].base_,
      CA,
      gA
    );
  } else
    CA = finalize(gA, AA);
  return maybeFreeze(gA, CA, !0), revokeScope(gA), gA.patches_ && gA.patchListener_(gA.patches_, gA.inversePatches_), CA !== NOTHING ? CA : void 0;
}
function finalize(CA, gA) {
  if (isFrozen(gA))
    return gA;
  const AA = gA[DRAFT_STATE];
  if (!AA)
    return handleValue(gA, CA.handledSet_, CA);
  if (!isSameScope(AA, CA))
    return gA;
  if (!AA.modified_)
    return AA.base_;
  if (!AA.finalized_) {
    const { callbacks_: IA } = AA;
    if (IA)
      for (; IA.length > 0; )
        IA.pop()(CA);
    generatePatchesAndFinalize(AA, CA);
  }
  return AA.copy_;
}
function maybeFreeze(CA, gA, AA = !1) {
  !CA.parent_ && CA.immer_.autoFreeze_ && CA.canAutoFreeze_ && freeze(gA, AA);
}
function markStateFinalized(CA) {
  CA.finalized_ = !0, CA.scope_.unfinalizedDrafts_--;
}
var isSameScope = (CA, gA) => CA.scope_ === gA, EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(CA, gA, AA, IA) {
  const BA = latest(CA), QA = CA.type_;
  if (IA !== void 0 && get(BA, IA, QA) === gA) {
    set(BA, IA, AA, QA);
    return;
  }
  if (!CA.draftLocations_) {
    const iA = CA.draftLocations_ = /* @__PURE__ */ new Map();
    each$1(BA, (oA, cA) => {
      if (isDraft(cA)) {
        const tA = iA.get(cA) || [];
        tA.push(oA), iA.set(cA, tA);
      }
    });
  }
  const EA = CA.draftLocations_.get(gA) ?? EMPTY_LOCATIONS_RESULT;
  for (const iA of EA)
    set(BA, iA, AA, QA);
}
function registerChildFinalizationCallback(CA, gA, AA) {
  CA.callbacks_.push(function(BA) {
    const QA = gA;
    if (!QA || !isSameScope(QA, BA))
      return;
    BA.mapSetPlugin_?.fixSetContents(QA);
    const EA = getFinalValue(QA);
    updateDraftInParent(CA, QA.draft_ ?? QA, EA, AA), generatePatchesAndFinalize(QA, BA);
  });
}
function generatePatchesAndFinalize(CA, gA) {
  if (CA.modified_ && !CA.finalized_ && (CA.type_ === 3 || CA.type_ === 1 && CA.allIndicesReassigned_ || (CA.assigned_?.size ?? 0) > 0)) {
    const { patchPlugin_: IA } = gA;
    if (IA) {
      const BA = IA.getPath(CA);
      BA && IA.generatePatches_(CA, BA, gA);
    }
    markStateFinalized(CA);
  }
}
function handleCrossReference(CA, gA, AA) {
  const { scope_: IA } = CA;
  if (isDraft(AA)) {
    const BA = AA[DRAFT_STATE];
    isSameScope(BA, IA) && BA.callbacks_.push(function() {
      prepareCopy(CA);
      const EA = getFinalValue(BA);
      updateDraftInParent(CA, AA, EA, gA);
    });
  } else isDraftable(AA) && CA.callbacks_.push(function() {
    const QA = latest(CA);
    CA.type_ === 3 ? QA.has(AA) && handleValue(AA, IA.handledSet_, IA) : get(QA, gA, CA.type_) === AA && IA.drafts_.length > 1 && (CA.assigned_.get(gA) ?? !1) === !0 && CA.copy_ && handleValue(
      get(CA.copy_, gA, CA.type_),
      IA.handledSet_,
      IA
    );
  });
}
function handleValue(CA, gA, AA) {
  return !AA.immer_.autoFreeze_ && AA.unfinalizedDrafts_ < 1 || isDraft(CA) || gA.has(CA) || !isDraftable(CA) || isFrozen(CA) || (gA.add(CA), each$1(CA, (IA, BA) => {
    if (isDraft(BA)) {
      const QA = BA[DRAFT_STATE];
      if (isSameScope(QA, AA)) {
        const EA = getFinalValue(QA);
        set(CA, IA, EA, CA.type_), markStateFinalized(QA);
      }
    } else isDraftable(BA) && handleValue(BA, gA, AA);
  })), CA;
}
function createProxyProxy(CA, gA) {
  const AA = isArray(CA), IA = {
    type_: AA ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: gA ? gA.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: gA,
    // The base state.
    base_: CA,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let BA = IA, QA = objectTraps;
  AA && (BA = [IA], QA = arrayTraps);
  const { revoke: EA, proxy: iA } = Proxy.revocable(BA, QA);
  return IA.draft_ = iA, IA.revoke_ = EA, [iA, IA];
}
var objectTraps = {
  get(CA, gA) {
    if (gA === DRAFT_STATE)
      return CA;
    let AA = CA.scope_.arrayMethodsPlugin_;
    const IA = CA.type_ === 1 && typeof gA == "string";
    if (IA && AA?.isArrayOperationMethod(gA))
      return AA.createMethodInterceptor(CA, gA);
    const BA = latest(CA);
    if (!has$1(BA, gA, CA.type_))
      return readPropFromProto(CA, BA, gA);
    const QA = BA[gA];
    if (CA.finalized_ || !isDraftable(QA) || IA && CA.operationMethod && AA?.isMutatingArrayMethod(
      CA.operationMethod
    ) && isArrayIndex(gA))
      return QA;
    if (QA === peek(CA.base_, gA)) {
      prepareCopy(CA);
      const EA = CA.type_ === 1 ? +gA : gA, iA = createProxy(CA.scope_, QA, CA, EA);
      return CA.copy_[EA] = iA;
    }
    return QA;
  },
  has(CA, gA) {
    return gA in latest(CA);
  },
  ownKeys(CA) {
    return Reflect.ownKeys(latest(CA));
  },
  set(CA, gA, AA) {
    const IA = getDescriptorFromProto(latest(CA), gA);
    if (IA?.set)
      return IA.set.call(CA.draft_, AA), !0;
    if (!CA.modified_) {
      const BA = peek(latest(CA), gA), QA = BA?.[DRAFT_STATE];
      if (QA && QA.base_ === AA)
        return CA.copy_[gA] = AA, CA.assigned_.set(gA, !1), !0;
      if (is(AA, BA) && (AA !== void 0 || has$1(CA.base_, gA, CA.type_)))
        return !0;
      prepareCopy(CA), markChanged(CA);
    }
    return CA.copy_[gA] === AA && // special case: handle new props with value 'undefined'
    (AA !== void 0 || gA in CA.copy_) || // special case: NaN
    Number.isNaN(AA) && Number.isNaN(CA.copy_[gA]) || (CA.copy_[gA] = AA, CA.assigned_.set(gA, !0), handleCrossReference(CA, gA, AA)), !0;
  },
  deleteProperty(CA, gA) {
    return prepareCopy(CA), peek(CA.base_, gA) !== void 0 || gA in CA.base_ ? (CA.assigned_.set(gA, !1), markChanged(CA)) : CA.assigned_.delete(gA), CA.copy_ && delete CA.copy_[gA], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(CA, gA) {
    const AA = latest(CA), IA = Reflect.getOwnPropertyDescriptor(AA, gA);
    return IA && {
      [WRITABLE]: !0,
      [CONFIGURABLE]: CA.type_ !== 1 || gA !== "length",
      [ENUMERABLE]: IA[ENUMERABLE],
      [VALUE]: AA[gA]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(CA) {
    return getPrototypeOf(CA.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
for (let CA in objectTraps) {
  let gA = objectTraps[CA];
  arrayTraps[CA] = function() {
    const AA = arguments;
    return AA[0] = AA[0][0], gA.apply(this, AA);
  };
}
arrayTraps.deleteProperty = function(CA, gA) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(gA)) && die(13), arrayTraps.set.call(this, CA, gA, void 0);
};
arrayTraps.set = function(CA, gA, AA) {
  return process.env.NODE_ENV !== "production" && gA !== "length" && isNaN(parseInt(gA)) && die(14), objectTraps.set.call(this, CA[0], gA, AA, CA[0]);
};
function peek(CA, gA) {
  const AA = CA[DRAFT_STATE];
  return (AA ? latest(AA) : CA)[gA];
}
function readPropFromProto(CA, gA, AA) {
  const IA = getDescriptorFromProto(gA, AA);
  return IA ? VALUE in IA ? IA[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    IA.get?.call(CA.draft_)
  ) : void 0;
}
function getDescriptorFromProto(CA, gA) {
  if (!(gA in CA))
    return;
  let AA = getPrototypeOf(CA);
  for (; AA; ) {
    const IA = Object.getOwnPropertyDescriptor(AA, gA);
    if (IA)
      return IA;
    AA = getPrototypeOf(AA);
  }
}
function markChanged(CA) {
  CA.modified_ || (CA.modified_ = !0, CA.parent_ && markChanged(CA.parent_));
}
function prepareCopy(CA) {
  CA.copy_ || (CA.assigned_ = /* @__PURE__ */ new Map(), CA.copy_ = shallowCopy(
    CA.base_,
    CA.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2 = class {
  constructor(CA) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (gA, AA, IA) => {
      if (isFunction$3(gA) && !isFunction$3(AA)) {
        const QA = AA;
        AA = gA;
        const EA = this;
        return function(oA = QA, ...cA) {
          return EA.produce(oA, (tA) => AA.call(this, tA, ...cA));
        };
      }
      isFunction$3(AA) || die(6), IA !== void 0 && !isFunction$3(IA) && die(7);
      let BA;
      if (isDraftable(gA)) {
        const QA = enterScope(this), EA = createProxy(QA, gA, void 0);
        let iA = !0;
        try {
          BA = AA(EA), iA = !1;
        } finally {
          iA ? revokeScope(QA) : leaveScope(QA);
        }
        return usePatchesInScope(QA, IA), processResult(BA, QA);
      } else if (!gA || !isObjectish(gA)) {
        if (BA = AA(gA), BA === void 0 && (BA = gA), BA === NOTHING && (BA = void 0), this.autoFreeze_ && freeze(BA, !0), IA) {
          const QA = [], EA = [];
          getPlugin(PluginPatches).generateReplacementPatches_(gA, BA, {
            patches_: QA,
            inversePatches_: EA
          }), IA(QA, EA);
        }
        return BA;
      } else
        die(1, gA);
    }, this.produceWithPatches = (gA, AA) => {
      if (isFunction$3(gA))
        return (EA, ...iA) => this.produceWithPatches(EA, (oA) => gA(oA, ...iA));
      let IA, BA;
      return [this.produce(gA, AA, (EA, iA) => {
        IA = EA, BA = iA;
      }), IA, BA];
    }, isBoolean$1(CA?.autoFreeze) && this.setAutoFreeze(CA.autoFreeze), isBoolean$1(CA?.useStrictShallowCopy) && this.setUseStrictShallowCopy(CA.useStrictShallowCopy), isBoolean$1(CA?.useStrictIteration) && this.setUseStrictIteration(CA.useStrictIteration);
  }
  createDraft(CA) {
    isDraftable(CA) || die(8), isDraft(CA) && (CA = current(CA));
    const gA = enterScope(this), AA = createProxy(gA, CA, void 0);
    return AA[DRAFT_STATE].isManual_ = !0, leaveScope(gA), AA;
  }
  finishDraft(CA, gA) {
    const AA = CA && CA[DRAFT_STATE];
    (!AA || !AA.isManual_) && die(9);
    const { scope_: IA } = AA;
    return usePatchesInScope(IA, gA), processResult(void 0, IA);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(CA) {
    this.autoFreeze_ = CA;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(CA) {
    this.useStrictShallowCopy_ = CA;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(CA) {
    this.useStrictIteration_ = CA;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(CA, gA) {
    let AA;
    for (AA = gA.length - 1; AA >= 0; AA--) {
      const BA = gA[AA];
      if (BA.path.length === 0 && BA.op === "replace") {
        CA = BA.value;
        break;
      }
    }
    AA > -1 && (gA = gA.slice(AA + 1));
    const IA = getPlugin(PluginPatches).applyPatches_;
    return isDraft(CA) ? IA(CA, gA) : this.produce(
      CA,
      (BA) => IA(BA, gA)
    );
  }
};
function createProxy(CA, gA, AA, IA) {
  const [BA, QA] = isMap(gA) ? getPlugin(PluginMapSet).proxyMap_(gA, AA) : isSet(gA) ? getPlugin(PluginMapSet).proxySet_(gA, AA) : createProxyProxy(gA, AA);
  return (AA?.scope_ ?? getCurrentScope()).drafts_.push(BA), QA.callbacks_ = AA?.callbacks_ ?? [], QA.key_ = IA, AA && IA !== void 0 ? registerChildFinalizationCallback(AA, QA, IA) : QA.callbacks_.push(function(oA) {
    oA.mapSetPlugin_?.fixSetContents(QA);
    const { patchPlugin_: cA } = oA;
    QA.modified_ && cA && cA.generatePatches_(QA, [], oA);
  }), BA;
}
function current(CA) {
  return isDraft(CA) || die(10, CA), currentImpl(CA);
}
function currentImpl(CA) {
  if (!isDraftable(CA) || isFrozen(CA))
    return CA;
  const gA = CA[DRAFT_STATE];
  let AA, IA = !0;
  if (gA) {
    if (!gA.modified_)
      return gA.base_;
    gA.finalized_ = !0, AA = shallowCopy(CA, gA.scope_.immer_.useStrictShallowCopy_), IA = gA.scope_.immer_.shouldUseStrictIteration();
  } else
    AA = shallowCopy(CA, !0);
  return each$1(
    AA,
    (BA, QA) => {
      set(AA, BA, currentImpl(QA));
    },
    IA
  ), gA && (gA.finalized_ = !1), AA;
}
function enablePatches() {
  process.env.NODE_ENV !== "production" && errors.push(
    'Sets cannot have "replace" patches.',
    function(lA) {
      return "Unsupported patch operation: " + lA;
    },
    function(lA) {
      return "Cannot apply patch, path doesn't resolve: " + lA;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  function gA(lA, nA = []) {
    if (lA.key_ !== void 0) {
      const DA = lA.parent_.copy_ ?? lA.parent_.base_, hA = getProxyDraft(get(DA, lA.key_)), wA = get(DA, lA.key_);
      if (wA === void 0 || wA !== lA.draft_ && wA !== lA.base_ && wA !== lA.copy_ || hA != null && hA.base_ !== lA.base_)
        return null;
      const sA = lA.parent_.type_ === 3;
      let NA;
      if (sA) {
        const rA = lA.parent_;
        NA = Array.from(rA.drafts_.keys()).indexOf(lA.key_);
      } else
        NA = lA.key_;
      if (!(sA && DA.size > NA || has$1(DA, NA)))
        return null;
      nA.push(NA);
    }
    if (lA.parent_)
      return gA(lA.parent_, nA);
    nA.reverse();
    try {
      AA(lA.copy_, nA);
    } catch {
      return null;
    }
    return nA;
  }
  function AA(lA, nA) {
    let DA = lA;
    for (let hA = 0; hA < nA.length - 1; hA++) {
      const wA = nA[hA];
      if (DA = get(DA, wA), !isObjectish(DA) || DA === null)
        throw new Error(`Cannot resolve path at '${nA.join("/")}'`);
    }
    return DA;
  }
  const IA = "replace", BA = "add", QA = "remove";
  function EA(lA, nA, DA) {
    if (lA.scope_.processedForPatches_.has(lA))
      return;
    lA.scope_.processedForPatches_.add(lA);
    const { patches_: hA, inversePatches_: wA } = DA;
    switch (lA.type_) {
      case 0:
      case 2:
        return oA(
          lA,
          nA,
          hA,
          wA
        );
      case 1:
        return iA(
          lA,
          nA,
          hA,
          wA
        );
      case 3:
        return cA(
          lA,
          nA,
          hA,
          wA
        );
    }
  }
  function iA(lA, nA, DA, hA) {
    let { base_: wA, assigned_: sA } = lA, NA = lA.copy_;
    NA.length < wA.length && ([wA, NA] = [NA, wA], [DA, hA] = [hA, DA]);
    const rA = lA.allIndicesReassigned_ === !0;
    for (let yA = 0; yA < wA.length; yA++) {
      const bA = NA[yA], RA = wA[yA];
      if ((rA || sA?.get(yA.toString())) && bA !== RA) {
        const dA = bA?.[DRAFT_STATE];
        if (dA && dA.modified_)
          continue;
        const kA = nA.concat([yA]);
        DA.push({
          op: IA,
          path: kA,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: GA(bA)
        }), hA.push({
          op: IA,
          path: kA,
          value: GA(RA)
        });
      }
    }
    for (let yA = wA.length; yA < NA.length; yA++) {
      const bA = nA.concat([yA]);
      DA.push({
        op: BA,
        path: bA,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: GA(NA[yA])
      });
    }
    for (let yA = NA.length - 1; wA.length <= yA; --yA) {
      const bA = nA.concat([yA]);
      hA.push({
        op: QA,
        path: bA
      });
    }
  }
  function oA(lA, nA, DA, hA) {
    const { base_: wA, copy_: sA, type_: NA } = lA;
    each$1(lA.assigned_, (rA, yA) => {
      const bA = get(wA, rA, NA), RA = get(sA, rA, NA), FA = yA ? has$1(wA, rA) ? IA : BA : QA;
      if (bA === RA && FA === IA)
        return;
      const dA = nA.concat(rA);
      DA.push(
        FA === QA ? { op: FA, path: dA } : { op: FA, path: dA, value: GA(RA) }
      ), hA.push(
        FA === BA ? { op: QA, path: dA } : FA === QA ? { op: BA, path: dA, value: GA(bA) } : { op: IA, path: dA, value: GA(bA) }
      );
    });
  }
  function cA(lA, nA, DA, hA) {
    let { base_: wA, copy_: sA } = lA, NA = 0;
    wA.forEach((rA) => {
      if (!sA.has(rA)) {
        const yA = nA.concat([NA]);
        DA.push({
          op: QA,
          path: yA,
          value: rA
        }), hA.unshift({
          op: BA,
          path: yA,
          value: rA
        });
      }
      NA++;
    }), NA = 0, sA.forEach((rA) => {
      if (!wA.has(rA)) {
        const yA = nA.concat([NA]);
        DA.push({
          op: BA,
          path: yA,
          value: rA
        }), hA.unshift({
          op: QA,
          path: yA,
          value: rA
        });
      }
      NA++;
    });
  }
  function tA(lA, nA, DA) {
    const { patches_: hA, inversePatches_: wA } = DA;
    hA.push({
      op: IA,
      path: [],
      value: nA === NOTHING ? void 0 : nA
    }), wA.push({
      op: IA,
      path: [],
      value: lA
    });
  }
  function eA(lA, nA) {
    return nA.forEach((DA) => {
      const { path: hA, op: wA } = DA;
      let sA = lA;
      for (let bA = 0; bA < hA.length - 1; bA++) {
        const RA = getArchtype(sA);
        let FA = hA[bA];
        typeof FA != "string" && typeof FA != "number" && (FA = "" + FA), (RA === 0 || RA === 1) && (FA === "__proto__" || FA === CONSTRUCTOR) && die(19), isFunction$3(sA) && FA === PROTOTYPE && die(19), sA = get(sA, FA), isObjectish(sA) || die(18, hA.join("/"));
      }
      const NA = getArchtype(sA), rA = aA(DA.value), yA = hA[hA.length - 1];
      switch (wA) {
        case IA:
          switch (NA) {
            case 2:
              return sA.set(yA, rA);
            case 3:
              die(16);
            default:
              return sA[yA] = rA;
          }
        case BA:
          switch (NA) {
            case 1:
              return yA === "-" ? sA.push(rA) : sA.splice(yA, 0, rA);
            case 2:
              return sA.set(yA, rA);
            case 3:
              return sA.add(rA);
            default:
              return sA[yA] = rA;
          }
        case QA:
          switch (NA) {
            case 1:
              return sA.splice(yA, 1);
            case 2:
              return sA.delete(yA);
            case 3:
              return sA.delete(DA.value);
            default:
              return delete sA[yA];
          }
        default:
          die(17, wA);
      }
    }), lA;
  }
  function aA(lA) {
    if (!isDraftable(lA))
      return lA;
    if (isArray(lA))
      return lA.map(aA);
    if (isMap(lA))
      return new Map(
        Array.from(lA.entries()).map(([DA, hA]) => [DA, aA(hA)])
      );
    if (isSet(lA))
      return new Set(Array.from(lA).map(aA));
    const nA = Object.create(getPrototypeOf(lA));
    for (const DA in lA)
      nA[DA] = aA(lA[DA]);
    return has$1(lA, DRAFTABLE) && (nA[DRAFTABLE] = lA[DRAFTABLE]), nA;
  }
  function GA(lA) {
    return isDraft(lA) ? aA(lA) : lA;
  }
  loadPlugin(PluginPatches, {
    applyPatches_: eA,
    generatePatches_: EA,
    generateReplacementPatches_: tA,
    getPath: gA
  });
}
function enableMapSet() {
  class CA extends Map {
    constructor(cA, tA) {
      super(), this[DRAFT_STATE] = {
        type_: 2,
        parent_: tA,
        scope_: tA ? tA.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        assigned_: void 0,
        base_: cA,
        draft_: this,
        isManual_: !1,
        revoked_: !1,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(cA) {
      return latest(this[DRAFT_STATE]).has(cA);
    }
    set(cA, tA) {
      const eA = this[DRAFT_STATE];
      return EA(eA), (!latest(eA).has(cA) || latest(eA).get(cA) !== tA) && (AA(eA), markChanged(eA), eA.assigned_.set(cA, !0), eA.copy_.set(cA, tA), eA.assigned_.set(cA, !0), handleCrossReference(eA, cA, tA)), this;
    }
    delete(cA) {
      if (!this.has(cA))
        return !1;
      const tA = this[DRAFT_STATE];
      return EA(tA), AA(tA), markChanged(tA), tA.base_.has(cA) ? tA.assigned_.set(cA, !1) : tA.assigned_.delete(cA), tA.copy_.delete(cA), !0;
    }
    clear() {
      const cA = this[DRAFT_STATE];
      EA(cA), latest(cA).size && (AA(cA), markChanged(cA), cA.assigned_ = /* @__PURE__ */ new Map(), each$1(cA.base_, (tA) => {
        cA.assigned_.set(tA, !1);
      }), cA.copy_.clear());
    }
    forEach(cA, tA) {
      const eA = this[DRAFT_STATE];
      latest(eA).forEach((aA, GA, lA) => {
        cA.call(tA, this.get(GA), GA, this);
      });
    }
    get(cA) {
      const tA = this[DRAFT_STATE];
      EA(tA);
      const eA = latest(tA).get(cA);
      if (tA.finalized_ || !isDraftable(eA) || eA !== tA.base_.get(cA))
        return eA;
      const aA = createProxy(tA.scope_, eA, tA, cA);
      return AA(tA), tA.copy_.set(cA, aA), aA;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const cA = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const tA = cA.next();
          return tA.done ? tA : {
            done: !1,
            value: this.get(tA.value)
          };
        }
      };
    }
    entries() {
      const cA = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const tA = cA.next();
          if (tA.done)
            return tA;
          const eA = this.get(tA.value);
          return {
            done: !1,
            value: [tA.value, eA]
          };
        }
      };
    }
    [Symbol.iterator]() {
      return this.entries();
    }
  }
  function gA(oA, cA) {
    const tA = new CA(oA, cA);
    return [tA, tA[DRAFT_STATE]];
  }
  function AA(oA) {
    oA.copy_ || (oA.assigned_ = /* @__PURE__ */ new Map(), oA.copy_ = new Map(oA.base_));
  }
  class IA extends Set {
    constructor(cA, tA) {
      super(), this[DRAFT_STATE] = {
        type_: 3,
        parent_: tA,
        scope_: tA ? tA.scope_ : getCurrentScope(),
        modified_: !1,
        finalized_: !1,
        copy_: void 0,
        base_: cA,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: !1,
        isManual_: !1,
        assigned_: void 0,
        callbacks_: []
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(cA) {
      const tA = this[DRAFT_STATE];
      return EA(tA), tA.copy_ ? !!(tA.copy_.has(cA) || tA.drafts_.has(cA) && tA.copy_.has(tA.drafts_.get(cA))) : tA.base_.has(cA);
    }
    add(cA) {
      const tA = this[DRAFT_STATE];
      return EA(tA), this.has(cA) || (QA(tA), markChanged(tA), tA.copy_.add(cA), handleCrossReference(tA, cA, cA)), this;
    }
    delete(cA) {
      if (!this.has(cA))
        return !1;
      const tA = this[DRAFT_STATE];
      return EA(tA), QA(tA), markChanged(tA), tA.copy_.delete(cA) || (tA.drafts_.has(cA) ? tA.copy_.delete(tA.drafts_.get(cA)) : (
        /* istanbul ignore next */
        !1
      ));
    }
    clear() {
      const cA = this[DRAFT_STATE];
      EA(cA), latest(cA).size && (QA(cA), markChanged(cA), cA.copy_.clear());
    }
    values() {
      const cA = this[DRAFT_STATE];
      return EA(cA), QA(cA), cA.copy_.values();
    }
    entries() {
      const cA = this[DRAFT_STATE];
      return EA(cA), QA(cA), cA.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [Symbol.iterator]() {
      return this.values();
    }
    forEach(cA, tA) {
      const eA = this.values();
      let aA = eA.next();
      for (; !aA.done; )
        cA.call(tA, aA.value, aA.value, this), aA = eA.next();
    }
  }
  function BA(oA, cA) {
    const tA = new IA(oA, cA);
    return [tA, tA[DRAFT_STATE]];
  }
  function QA(oA) {
    oA.copy_ || (oA.copy_ = /* @__PURE__ */ new Set(), oA.base_.forEach((cA) => {
      if (isDraftable(cA)) {
        const tA = createProxy(oA.scope_, cA, oA, cA);
        oA.drafts_.set(cA, tA), oA.copy_.add(tA);
      } else
        oA.copy_.add(cA);
    }));
  }
  function EA(oA) {
    oA.revoked_ && die(3, JSON.stringify(latest(oA)));
  }
  function iA(oA) {
    if (oA.type_ === 3 && oA.copy_) {
      const cA = new Set(oA.copy_);
      oA.copy_.clear(), cA.forEach((tA) => {
        oA.copy_.add(getValue(tA));
      });
    }
  }
  loadPlugin(PluginMapSet, { proxyMap_: gA, proxySet_: BA, fixSetContents: iA });
}
var immer = new Immer2(), produce = immer.produce, __assign$2 = function() {
  return __assign$2 = Object.assign || function(gA) {
    for (var AA, IA = 1, BA = arguments.length; IA < BA; IA++) {
      AA = arguments[IA];
      for (var QA in AA) Object.prototype.hasOwnProperty.call(AA, QA) && (gA[QA] = AA[QA]);
    }
    return gA;
  }, __assign$2.apply(this, arguments);
};
function __awaiter(CA, gA, AA, IA) {
  function BA(QA) {
    return QA instanceof AA ? QA : new AA(function(EA) {
      EA(QA);
    });
  }
  return new (AA || (AA = Promise))(function(QA, EA) {
    function iA(tA) {
      try {
        cA(IA.next(tA));
      } catch (eA) {
        EA(eA);
      }
    }
    function oA(tA) {
      try {
        cA(IA.throw(tA));
      } catch (eA) {
        EA(eA);
      }
    }
    function cA(tA) {
      tA.done ? QA(tA.value) : BA(tA.value).then(iA, oA);
    }
    cA((IA = IA.apply(CA, gA || [])).next());
  });
}
function __values(CA) {
  var gA = typeof Symbol == "function" && Symbol.iterator, AA = gA && CA[gA], IA = 0;
  if (AA) return AA.call(CA);
  if (CA && typeof CA.length == "number") return {
    next: function() {
      return CA && IA >= CA.length && (CA = void 0), { value: CA && CA[IA++], done: !CA };
    }
  };
  throw new TypeError(gA ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(CA) {
  return this instanceof __await ? (this.v = CA, this) : new __await(CA);
}
function __asyncGenerator(CA, gA, AA) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var IA = AA.apply(CA, gA || []), BA, QA = [];
  return BA = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), iA("next"), iA("throw"), iA("return", EA), BA[Symbol.asyncIterator] = function() {
    return this;
  }, BA;
  function EA(GA) {
    return function(lA) {
      return Promise.resolve(lA).then(GA, eA);
    };
  }
  function iA(GA, lA) {
    IA[GA] && (BA[GA] = function(nA) {
      return new Promise(function(DA, hA) {
        QA.push([GA, nA, DA, hA]) > 1 || oA(GA, nA);
      });
    }, lA && (BA[GA] = lA(BA[GA])));
  }
  function oA(GA, lA) {
    try {
      cA(IA[GA](lA));
    } catch (nA) {
      aA(QA[0][3], nA);
    }
  }
  function cA(GA) {
    GA.value instanceof __await ? Promise.resolve(GA.value.v).then(tA, eA) : aA(QA[0][2], GA);
  }
  function tA(GA) {
    oA("next", GA);
  }
  function eA(GA) {
    oA("throw", GA);
  }
  function aA(GA, lA) {
    GA(lA), QA.shift(), QA.length && oA(QA[0][0], QA[0][1]);
  }
}
function __asyncDelegator(CA) {
  var gA, AA;
  return gA = {}, IA("next"), IA("throw", function(BA) {
    throw BA;
  }), IA("return"), gA[Symbol.iterator] = function() {
    return this;
  }, gA;
  function IA(BA, QA) {
    gA[BA] = CA[BA] ? function(EA) {
      return (AA = !AA) ? { value: __await(CA[BA](EA)), done: !1 } : QA ? QA(EA) : EA;
    } : QA;
  }
}
function __asyncValues(CA) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var gA = CA[Symbol.asyncIterator], AA;
  return gA ? gA.call(CA) : (CA = typeof __values == "function" ? __values(CA) : CA[Symbol.iterator](), AA = {}, IA("next"), IA("throw"), IA("return"), AA[Symbol.asyncIterator] = function() {
    return this;
  }, AA);
  function IA(QA) {
    AA[QA] = CA[QA] && function(EA) {
      return new Promise(function(iA, oA) {
        EA = CA[QA](EA), BA(iA, oA, EA.done, EA.value);
      });
    };
  }
  function BA(QA, EA, iA, oA) {
    Promise.resolve(oA).then(function(cA) {
      QA({ value: cA, done: iA });
    }, EA);
  }
}
typeof SuppressedError == "function" && SuppressedError;
const decoder = new TextDecoder("utf-8"), decodeUtf8 = decoder.decode.bind(decoder), encoder = new TextEncoder(), encodeUtf8 = (CA) => encoder.encode(CA), isNumber = (CA) => typeof CA == "number", isBoolean = (CA) => typeof CA == "boolean", isFunction$2 = (CA) => typeof CA == "function", isObject$2 = (CA) => CA != null && Object(CA) === CA, isPromise = (CA) => isObject$2(CA) && isFunction$2(CA.then), isIterable = (CA) => isObject$2(CA) && isFunction$2(CA[Symbol.iterator]), isAsyncIterable$1 = (CA) => isObject$2(CA) && isFunction$2(CA[Symbol.asyncIterator]), isArrowJSON = (CA) => isObject$2(CA) && isObject$2(CA.schema), isIteratorResult = (CA) => isObject$2(CA) && "done" in CA && "value" in CA, isFileHandle = (CA) => isObject$2(CA) && isFunction$2(CA.stat) && isNumber(CA.fd), isFetchResponse = (CA) => isObject$2(CA) && isReadableDOMStream(CA.body), isReadableInterop = (CA) => "_getDOMStream" in CA && "_getNodeStream" in CA, isReadableDOMStream = (CA) => isObject$2(CA) && isFunction$2(CA.cancel) && isFunction$2(CA.getReader) && !isReadableInterop(CA), isReadableNodeStream = (CA) => isObject$2(CA) && isFunction$2(CA.read) && isFunction$2(CA.pipe) && isBoolean(CA.readable) && !isReadableInterop(CA), isFlatbuffersByteBuffer = (CA) => isObject$2(CA) && isFunction$2(CA.clear) && isFunction$2(CA.bytes) && isFunction$2(CA.position) && isFunction$2(CA.setPosition) && isFunction$2(CA.capacity) && isFunction$2(CA.getBufferIdentifier) && isFunction$2(CA.createLong), SharedArrayBuf = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : ArrayBuffer;
function collapseContiguousByteRanges(CA) {
  const gA = CA[0] ? [CA[0]] : [];
  let AA, IA, BA, QA;
  for (let EA, iA, oA = 0, cA = 0, tA = CA.length; ++oA < tA; ) {
    if (EA = gA[cA], iA = CA[oA], !EA || !iA || EA.buffer !== iA.buffer || iA.byteOffset < EA.byteOffset) {
      iA && (gA[++cA] = iA);
      continue;
    }
    if ({ byteOffset: AA, byteLength: BA } = EA, { byteOffset: IA, byteLength: QA } = iA, AA + BA < IA || IA + QA < AA) {
      iA && (gA[++cA] = iA);
      continue;
    }
    gA[cA] = new Uint8Array(EA.buffer, AA, IA - AA + QA);
  }
  return gA;
}
function memcpy(CA, gA, AA = 0, IA = gA.byteLength) {
  const BA = CA.byteLength, QA = new Uint8Array(CA.buffer, CA.byteOffset, BA), EA = new Uint8Array(gA.buffer, gA.byteOffset, Math.min(IA, BA));
  return QA.set(EA, AA), CA;
}
function joinUint8Arrays(CA, gA) {
  const AA = collapseContiguousByteRanges(CA), IA = AA.reduce((tA, eA) => tA + eA.byteLength, 0);
  let BA, QA, EA, iA = 0, oA = -1;
  const cA = Math.min(gA || Number.POSITIVE_INFINITY, IA);
  for (const tA = AA.length; ++oA < tA; ) {
    if (BA = AA[oA], QA = BA.subarray(0, Math.min(BA.length, cA - iA)), cA <= iA + QA.length) {
      QA.length < BA.length ? AA[oA] = BA.subarray(QA.length) : QA.length === BA.length && oA++, EA ? memcpy(EA, QA, iA) : EA = QA;
      break;
    }
    memcpy(EA || (EA = new Uint8Array(cA)), QA, iA), iA += QA.length;
  }
  return [EA || new Uint8Array(0), AA.slice(oA), IA - (EA ? EA.byteLength : 0)];
}
function toArrayBufferView(CA, gA) {
  let AA = isIteratorResult(gA) ? gA.value : gA;
  return AA instanceof CA ? CA === Uint8Array ? new CA(AA.buffer, AA.byteOffset, AA.byteLength) : AA : AA ? (typeof AA == "string" && (AA = encodeUtf8(AA)), AA instanceof ArrayBuffer ? new CA(AA) : AA instanceof SharedArrayBuf ? new CA(AA) : isFlatbuffersByteBuffer(AA) ? toArrayBufferView(CA, AA.bytes()) : ArrayBuffer.isView(AA) ? AA.byteLength <= 0 ? new CA(0) : new CA(AA.buffer, AA.byteOffset, AA.byteLength / CA.BYTES_PER_ELEMENT) : CA.from(AA)) : new CA(0);
}
const toInt8Array = (CA) => toArrayBufferView(Int8Array, CA), toInt16Array = (CA) => toArrayBufferView(Int16Array, CA), toInt32Array = (CA) => toArrayBufferView(Int32Array, CA), toBigInt64Array = (CA) => toArrayBufferView(BigInt64Array, CA), toUint8Array = (CA) => toArrayBufferView(Uint8Array, CA), toUint16Array = (CA) => toArrayBufferView(Uint16Array, CA), toUint32Array = (CA) => toArrayBufferView(Uint32Array, CA), toBigUint64Array = (CA) => toArrayBufferView(BigUint64Array, CA), toFloat32Array = (CA) => toArrayBufferView(Float32Array, CA), toFloat64Array = (CA) => toArrayBufferView(Float64Array, CA), toUint8ClampedArray = (CA) => toArrayBufferView(Uint8ClampedArray, CA), pump$1 = (CA) => (CA.next(), CA);
function* toArrayBufferViewIterator(CA, gA) {
  const AA = function* (BA) {
    yield BA;
  }, IA = typeof gA == "string" || ArrayBuffer.isView(gA) || gA instanceof ArrayBuffer || gA instanceof SharedArrayBuf ? AA(gA) : isIterable(gA) ? gA : AA(gA);
  return yield* pump$1((function* (BA) {
    let QA = null;
    do
      QA = BA.next(yield toArrayBufferView(CA, QA));
    while (!QA.done);
  })(IA[Symbol.iterator]())), new CA();
}
const toInt8ArrayIterator = (CA) => toArrayBufferViewIterator(Int8Array, CA), toInt16ArrayIterator = (CA) => toArrayBufferViewIterator(Int16Array, CA), toInt32ArrayIterator = (CA) => toArrayBufferViewIterator(Int32Array, CA), toUint8ArrayIterator = (CA) => toArrayBufferViewIterator(Uint8Array, CA), toUint16ArrayIterator = (CA) => toArrayBufferViewIterator(Uint16Array, CA), toUint32ArrayIterator = (CA) => toArrayBufferViewIterator(Uint32Array, CA), toFloat32ArrayIterator = (CA) => toArrayBufferViewIterator(Float32Array, CA), toFloat64ArrayIterator = (CA) => toArrayBufferViewIterator(Float64Array, CA), toUint8ClampedArrayIterator = (CA) => toArrayBufferViewIterator(Uint8ClampedArray, CA);
function toArrayBufferViewAsyncIterator(CA, gA) {
  return __asyncGenerator(this, arguments, function* () {
    if (isPromise(gA))
      return yield __await(yield __await(yield* __asyncDelegator(__asyncValues(toArrayBufferViewAsyncIterator(CA, yield __await(gA))))));
    const IA = function(EA) {
      return __asyncGenerator(this, arguments, function* () {
        yield yield __await(yield __await(EA));
      });
    }, BA = function(EA) {
      return __asyncGenerator(this, arguments, function* () {
        yield __await(yield* __asyncDelegator(__asyncValues(pump$1((function* (iA) {
          let oA = null;
          do
            oA = iA.next(yield oA?.value);
          while (!oA.done);
        })(EA[Symbol.iterator]())))));
      });
    }, QA = typeof gA == "string" || ArrayBuffer.isView(gA) || gA instanceof ArrayBuffer || gA instanceof SharedArrayBuf ? IA(gA) : isIterable(gA) ? BA(gA) : isAsyncIterable$1(gA) ? gA : IA(gA);
    return yield __await(
      // otherwise if AsyncIterable, use it
      yield* __asyncDelegator(__asyncValues(pump$1((function(EA) {
        return __asyncGenerator(this, arguments, function* () {
          let iA = null;
          do
            iA = yield __await(EA.next(yield yield __await(toArrayBufferView(CA, iA))));
          while (!iA.done);
        });
      })(QA[Symbol.asyncIterator]()))))
    ), yield __await(new CA());
  });
}
const toInt8ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Int8Array, CA), toInt16ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Int16Array, CA), toInt32ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Int32Array, CA), toUint8ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Uint8Array, CA), toUint16ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Uint16Array, CA), toUint32ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Uint32Array, CA), toFloat32ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Float32Array, CA), toFloat64ArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Float64Array, CA), toUint8ClampedArrayAsyncIterator = (CA) => toArrayBufferViewAsyncIterator(Uint8ClampedArray, CA);
function rebaseValueOffsets(CA, gA, AA) {
  if (CA !== 0) {
    AA = AA.slice(0, gA);
    for (let IA = -1, BA = AA.length; ++IA < BA; )
      AA[IA] += CA;
  }
  return AA.subarray(0, gA);
}
function compareArrayLike(CA, gA) {
  let AA = 0;
  const IA = CA.length;
  if (IA !== gA.length)
    return !1;
  if (IA > 0)
    do
      if (CA[AA] !== gA[AA])
        return !1;
    while (++AA < IA);
  return !0;
}
const util_buffer_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compareArrayLike,
  joinUint8Arrays,
  memcpy,
  rebaseValueOffsets,
  toArrayBufferView,
  toArrayBufferViewAsyncIterator,
  toArrayBufferViewIterator,
  toBigInt64Array,
  toBigUint64Array,
  toFloat32Array,
  toFloat32ArrayAsyncIterator,
  toFloat32ArrayIterator,
  toFloat64Array,
  toFloat64ArrayAsyncIterator,
  toFloat64ArrayIterator,
  toInt16Array,
  toInt16ArrayAsyncIterator,
  toInt16ArrayIterator,
  toInt32Array,
  toInt32ArrayAsyncIterator,
  toInt32ArrayIterator,
  toInt8Array,
  toInt8ArrayAsyncIterator,
  toInt8ArrayIterator,
  toUint16Array,
  toUint16ArrayAsyncIterator,
  toUint16ArrayIterator,
  toUint32Array,
  toUint32ArrayAsyncIterator,
  toUint32ArrayIterator,
  toUint8Array,
  toUint8ArrayAsyncIterator,
  toUint8ArrayIterator,
  toUint8ClampedArray,
  toUint8ClampedArrayAsyncIterator,
  toUint8ClampedArrayIterator
}, Symbol.toStringTag, { value: "Module" })), streamAdapters = {
  fromIterable(CA) {
    return pump(fromIterable(CA));
  },
  fromAsyncIterable(CA) {
    return pump(fromAsyncIterable(CA));
  },
  fromDOMStream(CA) {
    return pump(fromDOMStream(CA));
  },
  fromNodeStream(CA) {
    return pump(fromNodeStream(CA));
  },
  // @ts-ignore
  toDOMStream(CA, gA) {
    throw new Error('"toDOMStream" not available in this environment');
  },
  // @ts-ignore
  toNodeStream(CA, gA) {
    throw new Error('"toNodeStream" not available in this environment');
  }
}, pump = (CA) => (CA.next(), CA);
function* fromIterable(CA) {
  let gA, AA = !1, IA = [], BA, QA, EA, iA = 0;
  function oA() {
    return QA === "peek" ? joinUint8Arrays(IA, EA)[0] : ([BA, IA, iA] = joinUint8Arrays(IA, EA), BA);
  }
  ({ cmd: QA, size: EA } = (yield null) || { cmd: "read", size: 0 });
  const cA = toUint8ArrayIterator(CA)[Symbol.iterator]();
  try {
    do
      if ({ done: gA, value: BA } = Number.isNaN(EA - iA) ? cA.next() : cA.next(EA - iA), !gA && BA.byteLength > 0 && (IA.push(BA), iA += BA.byteLength), gA || EA <= iA)
        do
          ({ cmd: QA, size: EA } = yield oA());
        while (EA < iA);
    while (!gA);
  } catch (tA) {
    AA = !0, typeof cA.throw == "function" && cA.throw(tA);
  } finally {
    AA === !1 && typeof cA.return == "function" && cA.return(null);
  }
  return null;
}
function fromAsyncIterable(CA) {
  return __asyncGenerator(this, arguments, function* () {
    let AA, IA = !1, BA = [], QA, EA, iA, oA = 0;
    function cA() {
      return EA === "peek" ? joinUint8Arrays(BA, iA)[0] : ([QA, BA, oA] = joinUint8Arrays(BA, iA), QA);
    }
    ({ cmd: EA, size: iA } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const tA = toUint8ArrayAsyncIterator(CA)[Symbol.asyncIterator]();
    try {
      do
        if ({ done: AA, value: QA } = Number.isNaN(iA - oA) ? yield __await(tA.next()) : yield __await(tA.next(iA - oA)), !AA && QA.byteLength > 0 && (BA.push(QA), oA += QA.byteLength), AA || iA <= oA)
          do
            ({ cmd: EA, size: iA } = yield yield __await(cA()));
          while (iA < oA);
      while (!AA);
    } catch (eA) {
      IA = !0, typeof tA.throw == "function" && (yield __await(tA.throw(eA)));
    } finally {
      IA === !1 && typeof tA.return == "function" && (yield __await(tA.return(new Uint8Array(0))));
    }
    return yield __await(null);
  });
}
function fromDOMStream(CA) {
  return __asyncGenerator(this, arguments, function* () {
    let AA = !1, IA = !1, BA = [], QA, EA, iA, oA = 0;
    function cA() {
      return EA === "peek" ? joinUint8Arrays(BA, iA)[0] : ([QA, BA, oA] = joinUint8Arrays(BA, iA), QA);
    }
    ({ cmd: EA, size: iA } = (yield yield __await(null)) || { cmd: "read", size: 0 });
    const tA = new AdaptiveByteReader(CA);
    try {
      do
        if ({ done: AA, value: QA } = Number.isNaN(iA - oA) ? yield __await(tA.read()) : yield __await(tA.read(iA - oA)), !AA && QA.byteLength > 0 && (BA.push(toUint8Array(QA)), oA += QA.byteLength), AA || iA <= oA)
          do
            ({ cmd: EA, size: iA } = yield yield __await(cA()));
          while (iA < oA);
      while (!AA);
    } catch (eA) {
      IA = !0, yield __await(tA.cancel(eA));
    } finally {
      IA === !1 ? yield __await(tA.cancel()) : CA.locked && tA.releaseLock();
    }
    return yield __await(null);
  });
}
class AdaptiveByteReader {
  constructor(gA) {
    this.source = gA, this.reader = null, this.reader = this.source.getReader(), this.reader.closed.catch(() => {
    });
  }
  get closed() {
    return this.reader ? this.reader.closed.catch(() => {
    }) : Promise.resolve();
  }
  releaseLock() {
    this.reader && this.reader.releaseLock(), this.reader = null;
  }
  cancel(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      const { reader: AA, source: IA } = this;
      AA && (yield AA.cancel(gA).catch(() => {
      })), IA && IA.locked && this.releaseLock();
    });
  }
  read(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      if (gA === 0)
        return { done: this.reader == null, value: new Uint8Array(0) };
      const AA = yield this.reader.read();
      return !AA.done && (AA.value = toUint8Array(AA)), AA;
    });
  }
}
const onEvent = (CA, gA) => {
  const AA = (BA) => IA([gA, BA]);
  let IA;
  return [gA, AA, new Promise((BA) => (IA = BA) && CA.once(gA, AA))];
};
function fromNodeStream(CA) {
  return __asyncGenerator(this, arguments, function* () {
    const AA = [];
    let IA = "error", BA = !1, QA = null, EA, iA, oA = 0, cA = [], tA;
    function eA() {
      return EA === "peek" ? joinUint8Arrays(cA, iA)[0] : ([tA, cA, oA] = joinUint8Arrays(cA, iA), tA);
    }
    if ({ cmd: EA, size: iA } = (yield yield __await(null)) || { cmd: "read", size: 0 }, CA.isTTY)
      return yield yield __await(new Uint8Array(0)), yield __await(null);
    try {
      AA[0] = onEvent(CA, "end"), AA[1] = onEvent(CA, "error");
      do {
        if (AA[2] = onEvent(CA, "readable"), [IA, QA] = yield __await(Promise.race(AA.map((GA) => GA[2]))), IA === "error")
          break;
        if ((BA = IA === "end") || (Number.isFinite(iA - oA) ? (tA = toUint8Array(CA.read(iA - oA)), tA.byteLength < iA - oA && (tA = toUint8Array(CA.read()))) : tA = toUint8Array(CA.read()), tA.byteLength > 0 && (cA.push(tA), oA += tA.byteLength)), BA || iA <= oA)
          do
            ({ cmd: EA, size: iA } = yield yield __await(eA()));
          while (iA < oA);
      } while (!BA);
    } finally {
      yield __await(aA(AA, IA === "error" ? QA : null));
    }
    return yield __await(null);
    function aA(GA, lA) {
      return tA = cA = null, new Promise((nA, DA) => {
        for (const [hA, wA] of GA)
          CA.off(hA, wA);
        try {
          const hA = CA.destroy;
          hA && hA.call(CA, lA), lA = void 0;
        } catch (hA) {
          lA = hA || lA;
        } finally {
          lA != null ? DA(lA) : nA();
        }
      });
    }
  });
}
var MetadataVersion;
(function(CA) {
  CA[CA.V1 = 0] = "V1", CA[CA.V2 = 1] = "V2", CA[CA.V3 = 2] = "V3", CA[CA.V4 = 3] = "V4", CA[CA.V5 = 4] = "V5";
})(MetadataVersion || (MetadataVersion = {}));
var UnionMode;
(function(CA) {
  CA[CA.Sparse = 0] = "Sparse", CA[CA.Dense = 1] = "Dense";
})(UnionMode || (UnionMode = {}));
var Precision;
(function(CA) {
  CA[CA.HALF = 0] = "HALF", CA[CA.SINGLE = 1] = "SINGLE", CA[CA.DOUBLE = 2] = "DOUBLE";
})(Precision || (Precision = {}));
var DateUnit;
(function(CA) {
  CA[CA.DAY = 0] = "DAY", CA[CA.MILLISECOND = 1] = "MILLISECOND";
})(DateUnit || (DateUnit = {}));
var TimeUnit;
(function(CA) {
  CA[CA.SECOND = 0] = "SECOND", CA[CA.MILLISECOND = 1] = "MILLISECOND", CA[CA.MICROSECOND = 2] = "MICROSECOND", CA[CA.NANOSECOND = 3] = "NANOSECOND";
})(TimeUnit || (TimeUnit = {}));
var IntervalUnit;
(function(CA) {
  CA[CA.YEAR_MONTH = 0] = "YEAR_MONTH", CA[CA.DAY_TIME = 1] = "DAY_TIME", CA[CA.MONTH_DAY_NANO = 2] = "MONTH_DAY_NANO";
})(IntervalUnit || (IntervalUnit = {}));
const SIZEOF_SHORT = 2, SIZEOF_INT = 4, FILE_IDENTIFIER_LENGTH = 4, SIZE_PREFIX_LENGTH = 4, int32 = new Int32Array(2), float32 = new Float32Array(int32.buffer), float64 = new Float64Array(int32.buffer), isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;
var Encoding;
(function(CA) {
  CA[CA.UTF8_BYTES = 1] = "UTF8_BYTES", CA[CA.UTF16_STRING = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));
let ByteBuffer$2 = class Yg {
  /**
   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
   */
  constructor(gA) {
    this.bytes_ = gA, this.position_ = 0, this.text_decoder_ = new TextDecoder();
  }
  /**
   * Create and allocate a new ByteBuffer with a given size.
   */
  static allocate(gA) {
    return new Yg(new Uint8Array(gA));
  }
  clear() {
    this.position_ = 0;
  }
  /**
   * Get the underlying `Uint8Array`.
   */
  bytes() {
    return this.bytes_;
  }
  /**
   * Get the buffer's position.
   */
  position() {
    return this.position_;
  }
  /**
   * Set the buffer's position.
   */
  setPosition(gA) {
    this.position_ = gA;
  }
  /**
   * Get the buffer's capacity.
   */
  capacity() {
    return this.bytes_.length;
  }
  readInt8(gA) {
    return this.readUint8(gA) << 24 >> 24;
  }
  readUint8(gA) {
    return this.bytes_[gA];
  }
  readInt16(gA) {
    return this.readUint16(gA) << 16 >> 16;
  }
  readUint16(gA) {
    return this.bytes_[gA] | this.bytes_[gA + 1] << 8;
  }
  readInt32(gA) {
    return this.bytes_[gA] | this.bytes_[gA + 1] << 8 | this.bytes_[gA + 2] << 16 | this.bytes_[gA + 3] << 24;
  }
  readUint32(gA) {
    return this.readInt32(gA) >>> 0;
  }
  readInt64(gA) {
    return BigInt.asIntN(64, BigInt(this.readUint32(gA)) + (BigInt(this.readUint32(gA + 4)) << BigInt(32)));
  }
  readUint64(gA) {
    return BigInt.asUintN(64, BigInt(this.readUint32(gA)) + (BigInt(this.readUint32(gA + 4)) << BigInt(32)));
  }
  readFloat32(gA) {
    return int32[0] = this.readInt32(gA), float32[0];
  }
  readFloat64(gA) {
    return int32[isLittleEndian ? 0 : 1] = this.readInt32(gA), int32[isLittleEndian ? 1 : 0] = this.readInt32(gA + 4), float64[0];
  }
  writeInt8(gA, AA) {
    this.bytes_[gA] = AA;
  }
  writeUint8(gA, AA) {
    this.bytes_[gA] = AA;
  }
  writeInt16(gA, AA) {
    this.bytes_[gA] = AA, this.bytes_[gA + 1] = AA >> 8;
  }
  writeUint16(gA, AA) {
    this.bytes_[gA] = AA, this.bytes_[gA + 1] = AA >> 8;
  }
  writeInt32(gA, AA) {
    this.bytes_[gA] = AA, this.bytes_[gA + 1] = AA >> 8, this.bytes_[gA + 2] = AA >> 16, this.bytes_[gA + 3] = AA >> 24;
  }
  writeUint32(gA, AA) {
    this.bytes_[gA] = AA, this.bytes_[gA + 1] = AA >> 8, this.bytes_[gA + 2] = AA >> 16, this.bytes_[gA + 3] = AA >> 24;
  }
  writeInt64(gA, AA) {
    this.writeInt32(gA, Number(BigInt.asIntN(32, AA))), this.writeInt32(gA + 4, Number(BigInt.asIntN(32, AA >> BigInt(32))));
  }
  writeUint64(gA, AA) {
    this.writeUint32(gA, Number(BigInt.asUintN(32, AA))), this.writeUint32(gA + 4, Number(BigInt.asUintN(32, AA >> BigInt(32))));
  }
  writeFloat32(gA, AA) {
    float32[0] = AA, this.writeInt32(gA, int32[0]);
  }
  writeFloat64(gA, AA) {
    float64[0] = AA, this.writeInt32(gA, int32[isLittleEndian ? 0 : 1]), this.writeInt32(gA + 4, int32[isLittleEndian ? 1 : 0]);
  }
  /**
   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
   * schema does not include a file_identifier (likely points at padding or the
   * start of a the root vtable).
   */
  getBufferIdentifier() {
    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: ByteBuffer is too short to contain an identifier.");
    let gA = "";
    for (let AA = 0; AA < FILE_IDENTIFIER_LENGTH; AA++)
      gA += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + AA));
    return gA;
  }
  /**
   * Look up a field in the vtable, return an offset into the object, or 0 if the
   * field is not present.
   */
  __offset(gA, AA) {
    const IA = gA - this.readInt32(gA);
    return AA < this.readInt16(IA) ? this.readInt16(IA + AA) : 0;
  }
  /**
   * Initialize any Table-derived type to point to the union at the given offset.
   */
  __union(gA, AA) {
    return gA.bb_pos = AA + this.readInt32(AA), gA.bb = this, gA;
  }
  /**
   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
   * This allocates a new string and converts to wide chars upon each access.
   *
   * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
   * "optionalEncoding" argument. This is useful for avoiding conversion when
   * the data will just be packaged back up in another FlatBuffer later on.
   *
   * @param offset
   * @param opt_encoding Defaults to UTF16_STRING
   */
  __string(gA, AA) {
    gA += this.readInt32(gA);
    const IA = this.readInt32(gA);
    gA += SIZEOF_INT;
    const BA = this.bytes_.subarray(gA, gA + IA);
    return AA === Encoding.UTF8_BYTES ? BA : this.text_decoder_.decode(BA);
  }
  /**
   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
   * if a string then return a new one
   *
   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
   * makes the behaviour of __union_with_string different compared to __union
   */
  __union_with_string(gA, AA) {
    return typeof gA == "string" ? this.__string(AA) : this.__union(gA, AA);
  }
  /**
   * Retrieve the relative offset stored at "offset"
   */
  __indirect(gA) {
    return gA + this.readInt32(gA);
  }
  /**
   * Get the start of data of a vector whose offset is stored at "offset" in this object.
   */
  __vector(gA) {
    return gA + this.readInt32(gA) + SIZEOF_INT;
  }
  /**
   * Get the length of a vector whose offset is stored at "offset" in this object.
   */
  __vector_len(gA) {
    return this.readInt32(gA + this.readInt32(gA));
  }
  __has_identifier(gA) {
    if (gA.length != FILE_IDENTIFIER_LENGTH)
      throw new Error("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
    for (let AA = 0; AA < FILE_IDENTIFIER_LENGTH; AA++)
      if (gA.charCodeAt(AA) != this.readInt8(this.position() + SIZEOF_INT + AA))
        return !1;
    return !0;
  }
  /**
   * A helper function for generating list for obj api
   */
  createScalarList(gA, AA) {
    const IA = [];
    for (let BA = 0; BA < AA; ++BA) {
      const QA = gA(BA);
      QA !== null && IA.push(QA);
    }
    return IA;
  }
  /**
   * A helper function for generating list for obj api
   * @param listAccessor function that accepts an index and return data at that index
   * @param listLength listLength
   * @param res result list
   */
  createObjList(gA, AA) {
    const IA = [];
    for (let BA = 0; BA < AA; ++BA) {
      const QA = gA(BA);
      QA !== null && IA.push(QA.unpack());
    }
    return IA;
  }
}, Builder$2 = class Jg {
  /**
   * Create a FlatBufferBuilder.
   */
  constructor(gA) {
    this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null, this.text_encoder = new TextEncoder();
    let AA;
    gA ? AA = gA : AA = 1024, this.bb = ByteBuffer$2.allocate(AA), this.space = AA;
  }
  clear() {
    this.bb.clear(), this.space = this.bb.capacity(), this.minalign = 1, this.vtable = null, this.vtable_in_use = 0, this.isNested = !1, this.object_start = 0, this.vtables = [], this.vector_num_elems = 0, this.force_defaults = !1, this.string_maps = null;
  }
  /**
   * In order to save space, fields that are set to their default value
   * don't get serialized into the buffer. Forcing defaults provides a
   * way to manually disable this optimization.
   *
   * @param forceDefaults true always serializes default values
   */
  forceDefaults(gA) {
    this.force_defaults = gA;
  }
  /**
   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
   * called finish(). The actual data starts at the ByteBuffer's current position,
   * not necessarily at 0.
   */
  dataBuffer() {
    return this.bb;
  }
  /**
   * Get the bytes representing the FlatBuffer. Only call this after you've
   * called finish().
   */
  asUint8Array() {
    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
  }
  /**
   * Prepare to write an element of `size` after `additional_bytes` have been
   * written, e.g. if you write a string, you need to align such the int length
   * field is aligned to 4 bytes, and the string data follows it directly. If all
   * you need to do is alignment, `additional_bytes` will be 0.
   *
   * @param size This is the of the new element to write
   * @param additional_bytes The padding size
   */
  prep(gA, AA) {
    gA > this.minalign && (this.minalign = gA);
    const IA = ~(this.bb.capacity() - this.space + AA) + 1 & gA - 1;
    for (; this.space < IA + gA + AA; ) {
      const BA = this.bb.capacity();
      this.bb = Jg.growByteBuffer(this.bb), this.space += this.bb.capacity() - BA;
    }
    this.pad(IA);
  }
  pad(gA) {
    for (let AA = 0; AA < gA; AA++)
      this.bb.writeInt8(--this.space, 0);
  }
  writeInt8(gA) {
    this.bb.writeInt8(this.space -= 1, gA);
  }
  writeInt16(gA) {
    this.bb.writeInt16(this.space -= 2, gA);
  }
  writeInt32(gA) {
    this.bb.writeInt32(this.space -= 4, gA);
  }
  writeInt64(gA) {
    this.bb.writeInt64(this.space -= 8, gA);
  }
  writeFloat32(gA) {
    this.bb.writeFloat32(this.space -= 4, gA);
  }
  writeFloat64(gA) {
    this.bb.writeFloat64(this.space -= 8, gA);
  }
  /**
   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int8` to add the buffer.
   */
  addInt8(gA) {
    this.prep(1, 0), this.writeInt8(gA);
  }
  /**
   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int16` to add the buffer.
   */
  addInt16(gA) {
    this.prep(2, 0), this.writeInt16(gA);
  }
  /**
   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int32` to add the buffer.
   */
  addInt32(gA) {
    this.prep(4, 0), this.writeInt32(gA);
  }
  /**
   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `int64` to add the buffer.
   */
  addInt64(gA) {
    this.prep(8, 0), this.writeInt64(gA);
  }
  /**
   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float32` to add the buffer.
   */
  addFloat32(gA) {
    this.prep(4, 0), this.writeFloat32(gA);
  }
  /**
   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
   * @param value The `float64` to add the buffer.
   */
  addFloat64(gA) {
    this.prep(8, 0), this.writeFloat64(gA);
  }
  addFieldInt8(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addInt8(AA), this.slot(gA));
  }
  addFieldInt16(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addInt16(AA), this.slot(gA));
  }
  addFieldInt32(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addInt32(AA), this.slot(gA));
  }
  addFieldInt64(gA, AA, IA) {
    (this.force_defaults || AA !== IA) && (this.addInt64(AA), this.slot(gA));
  }
  addFieldFloat32(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addFloat32(AA), this.slot(gA));
  }
  addFieldFloat64(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addFloat64(AA), this.slot(gA));
  }
  addFieldOffset(gA, AA, IA) {
    (this.force_defaults || AA != IA) && (this.addOffset(AA), this.slot(gA));
  }
  /**
   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
   */
  addFieldStruct(gA, AA, IA) {
    AA != IA && (this.nested(AA), this.slot(gA));
  }
  /**
   * Structures are always stored inline, they need to be created right
   * where they're used.  You'll get this assertion failure if you
   * created it elsewhere.
   */
  nested(gA) {
    if (gA != this.offset())
      throw new TypeError("FlatBuffers: struct must be serialized inline.");
  }
  /**
   * Should not be creating any other object, string or vector
   * while an object is being constructed
   */
  notNested() {
    if (this.isNested)
      throw new TypeError("FlatBuffers: object serialization must not be nested.");
  }
  /**
   * Set the current vtable at `voffset` to the current location in the buffer.
   */
  slot(gA) {
    this.vtable !== null && (this.vtable[gA] = this.offset());
  }
  /**
   * @returns Offset relative to the end of the buffer.
   */
  offset() {
    return this.bb.capacity() - this.space;
  }
  /**
   * Doubles the size of the backing ByteBuffer and copies the old data towards
   * the end of the new buffer (since we build the buffer backwards).
   *
   * @param bb The current buffer with the existing data
   * @returns A new byte buffer with the old data copied
   * to it. The data is located at the end of the buffer.
   *
   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
   * it a uint8Array we need to suppress the type check:
   * @suppress {checkTypes}
   */
  static growByteBuffer(gA) {
    const AA = gA.capacity();
    if (AA & 3221225472)
      throw new Error("FlatBuffers: cannot grow buffer beyond 2 gigabytes.");
    const IA = AA << 1, BA = ByteBuffer$2.allocate(IA);
    return BA.setPosition(IA - AA), BA.bytes().set(gA.bytes(), IA - AA), BA;
  }
  /**
   * Adds on offset, relative to where it will be written.
   *
   * @param offset The offset to add.
   */
  addOffset(gA) {
    this.prep(SIZEOF_INT, 0), this.writeInt32(this.offset() - gA + SIZEOF_INT);
  }
  /**
   * Start encoding a new object in the buffer.  Users will not usually need to
   * call this directly. The FlatBuffers compiler will generate helper methods
   * that call this method internally.
   */
  startObject(gA) {
    this.notNested(), this.vtable == null && (this.vtable = []), this.vtable_in_use = gA;
    for (let AA = 0; AA < gA; AA++)
      this.vtable[AA] = 0;
    this.isNested = !0, this.object_start = this.offset();
  }
  /**
   * Finish off writing the object that is under construction.
   *
   * @returns The offset to the object inside `dataBuffer`
   */
  endObject() {
    if (this.vtable == null || !this.isNested)
      throw new Error("FlatBuffers: endObject called without startObject");
    this.addInt32(0);
    const gA = this.offset();
    let AA = this.vtable_in_use - 1;
    for (; AA >= 0 && this.vtable[AA] == 0; AA--)
      ;
    const IA = AA + 1;
    for (; AA >= 0; AA--)
      this.addInt16(this.vtable[AA] != 0 ? gA - this.vtable[AA] : 0);
    const BA = 2;
    this.addInt16(gA - this.object_start);
    const QA = (IA + BA) * SIZEOF_SHORT;
    this.addInt16(QA);
    let EA = 0;
    const iA = this.space;
    A: for (AA = 0; AA < this.vtables.length; AA++) {
      const oA = this.bb.capacity() - this.vtables[AA];
      if (QA == this.bb.readInt16(oA)) {
        for (let cA = SIZEOF_SHORT; cA < QA; cA += SIZEOF_SHORT)
          if (this.bb.readInt16(iA + cA) != this.bb.readInt16(oA + cA))
            continue A;
        EA = this.vtables[AA];
        break;
      }
    }
    return EA ? (this.space = this.bb.capacity() - gA, this.bb.writeInt32(this.space, EA - gA)) : (this.vtables.push(this.offset()), this.bb.writeInt32(this.bb.capacity() - gA, this.offset() - gA)), this.isNested = !1, gA;
  }
  /**
   * Finalize a buffer, poiting to the given `root_table`.
   */
  finish(gA, AA, IA) {
    const BA = IA ? SIZE_PREFIX_LENGTH : 0;
    if (AA) {
      const QA = AA;
      if (this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + BA), QA.length != FILE_IDENTIFIER_LENGTH)
        throw new TypeError("FlatBuffers: file identifier must be length " + FILE_IDENTIFIER_LENGTH);
      for (let EA = FILE_IDENTIFIER_LENGTH - 1; EA >= 0; EA--)
        this.writeInt8(QA.charCodeAt(EA));
    }
    this.prep(this.minalign, SIZEOF_INT + BA), this.addOffset(gA), BA && this.addInt32(this.bb.capacity() - this.space), this.bb.setPosition(this.space);
  }
  /**
   * Finalize a size prefixed buffer, pointing to the given `root_table`.
   */
  finishSizePrefixed(gA, AA) {
    this.finish(gA, AA, !0);
  }
  /**
   * This checks a required field has been set in a given table that has
   * just been constructed.
   */
  requiredField(gA, AA) {
    const IA = this.bb.capacity() - gA, BA = IA - this.bb.readInt32(IA);
    if (!(AA < this.bb.readInt16(BA) && this.bb.readInt16(BA + AA) != 0))
      throw new TypeError("FlatBuffers: field " + AA + " must be set");
  }
  /**
   * Start a new array/vector of objects.  Users usually will not call
   * this directly. The FlatBuffers compiler will create a start/end
   * method for vector types in generated code.
   *
   * @param elem_size The size of each element in the array
   * @param num_elems The number of elements in the array
   * @param alignment The alignment of the array
   */
  startVector(gA, AA, IA) {
    this.notNested(), this.vector_num_elems = AA, this.prep(SIZEOF_INT, gA * AA), this.prep(IA, gA * AA);
  }
  /**
   * Finish off the creation of an array and all its elements. The array must be
   * created with `startVector`.
   *
   * @returns The offset at which the newly created array
   * starts.
   */
  endVector() {
    return this.writeInt32(this.vector_num_elems), this.offset();
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If the string passed has
   * already been seen, we return the offset of the already written string
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createSharedString(gA) {
    if (!gA)
      return 0;
    if (this.string_maps || (this.string_maps = /* @__PURE__ */ new Map()), this.string_maps.has(gA))
      return this.string_maps.get(gA);
    const AA = this.createString(gA);
    return this.string_maps.set(gA, AA), AA;
  }
  /**
   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
   *
   * @param s The string to encode
   * @return The offset in the buffer where the encoded string starts
   */
  createString(gA) {
    if (gA == null)
      return 0;
    let AA;
    return gA instanceof Uint8Array ? AA = gA : AA = this.text_encoder.encode(gA), this.addInt8(0), this.startVector(1, AA.length, 1), this.bb.setPosition(this.space -= AA.length), this.bb.bytes().set(AA, this.space), this.endVector();
  }
  /**
   * Create a byte vector.
   *
   * @param v The bytes to add
   * @returns The offset in the buffer where the byte vector starts
   */
  createByteVector(gA) {
    return gA == null ? 0 : (this.startVector(1, gA.length, 1), this.bb.setPosition(this.space -= gA.length), this.bb.bytes().set(gA, this.space), this.endVector());
  }
  /**
   * A helper function to pack an object
   *
   * @returns offset of obj
   */
  createObjectOffset(gA) {
    return gA === null ? 0 : typeof gA == "string" ? this.createString(gA) : gA.pack(this);
  }
  /**
   * A helper function to pack a list of object
   *
   * @returns list of offsets of each non null object
   */
  createObjectOffsetList(gA) {
    const AA = [];
    for (let IA = 0; IA < gA.length; ++IA) {
      const BA = gA[IA];
      if (BA !== null)
        AA.push(this.createObjectOffset(BA));
      else
        throw new TypeError("FlatBuffers: Argument for createObjectOffsetList cannot contain null.");
    }
    return AA;
  }
  createStructOffsetList(gA, AA) {
    return AA(this, gA.length), this.createObjectOffsetList(gA.slice().reverse()), this.endVector();
  }
};
var BodyCompressionMethod;
(function(CA) {
  CA[CA.BUFFER = 0] = "BUFFER";
})(BodyCompressionMethod || (BodyCompressionMethod = {}));
var CompressionType;
(function(CA) {
  CA[CA.LZ4_FRAME = 0] = "LZ4_FRAME", CA[CA.ZSTD = 1] = "ZSTD";
})(CompressionType || (CompressionType = {}));
let BodyCompression$1 = class zI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsBodyCompression(gA, AA) {
    return (AA || new zI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsBodyCompression(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new zI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * Compressor library.
   * For LZ4_FRAME, each compressed buffer must consist of a single frame.
   */
  codec() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt8(this.bb_pos + gA) : CompressionType.LZ4_FRAME;
  }
  /**
   * Indicates the way the record batch body was compressed
   */
  method() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.readInt8(this.bb_pos + gA) : BodyCompressionMethod.BUFFER;
  }
  static startBodyCompression(gA) {
    gA.startObject(2);
  }
  static addCodec(gA, AA) {
    gA.addFieldInt8(0, AA, CompressionType.LZ4_FRAME);
  }
  static addMethod(gA, AA) {
    gA.addFieldInt8(1, AA, BodyCompressionMethod.BUFFER);
  }
  static endBodyCompression(gA) {
    return gA.endObject();
  }
  static createBodyCompression(gA, AA, IA) {
    return zI.startBodyCompression(gA), zI.addCodec(gA, AA), zI.addMethod(gA, IA), zI.endBodyCompression(gA);
  }
}, Buffer$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  /**
   * The relative offset into the shared memory page where the bytes for this
   * buffer starts
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The absolute length (in bytes) of the memory buffer. The memory is found
   * from offset (inclusive) to offset + length (non-inclusive). When building
   * messages using the encapsulated IPC message, padding bytes may be written
   * after a buffer, but such padding bytes do not need to be accounted for in
   * the size here.
   */
  length() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createBuffer(gA, AA, IA) {
    return gA.prep(8, 16), gA.writeInt64(BigInt(IA ?? 0)), gA.writeInt64(BigInt(AA ?? 0)), gA.offset();
  }
}, FieldNode$1 = class {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  /**
   * The number of value slots in the Arrow array at this level of a nested
   * tree
   */
  length() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * The number of observed nulls. Fields with null_count == 0 may choose not
   * to write their physical validity bitmap out as a materialized buffer,
   * instead setting the length of the bitmap buffer to 0.
   */
  nullCount() {
    return this.bb.readInt64(this.bb_pos + 8);
  }
  static sizeOf() {
    return 16;
  }
  static createFieldNode(gA, AA, IA) {
    return gA.prep(8, 16), gA.writeInt64(BigInt(IA ?? 0)), gA.writeInt64(BigInt(AA ?? 0)), gA.offset();
  }
}, RecordBatch$3 = class yg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsRecordBatch(gA, AA) {
    return (AA || new yg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsRecordBatch(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new yg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * number of records / rows. The arrays in the batch should all have this
   * length
   */
  length() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt64(this.bb_pos + gA) : BigInt("0");
  }
  /**
   * Nodes correspond to the pre-ordered flattened logical schema
   */
  nodes(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 6);
    return IA ? (AA || new FieldNode$1()).__init(this.bb.__vector(this.bb_pos + IA) + gA * 16, this.bb) : null;
  }
  nodesLength() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  /**
   * Buffers correspond to the pre-ordered flattened buffer tree
   *
   * The number of buffers appended to this list depends on the schema. For
   * example, most primitive arrays will have 2 buffers, 1 for the validity
   * bitmap and 1 for the values. For struct arrays, there will only be a
   * single buffer for the validity (nulls) bitmap
   */
  buffers(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 8);
    return IA ? (AA || new Buffer$1()).__init(this.bb.__vector(this.bb_pos + IA) + gA * 16, this.bb) : null;
  }
  buffersLength() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  /**
   * Optional compression of the message body
   */
  compression(gA) {
    const AA = this.bb.__offset(this.bb_pos, 10);
    return AA ? (gA || new BodyCompression$1()).__init(this.bb.__indirect(this.bb_pos + AA), this.bb) : null;
  }
  static startRecordBatch(gA) {
    gA.startObject(4);
  }
  static addLength(gA, AA) {
    gA.addFieldInt64(0, AA, BigInt("0"));
  }
  static addNodes(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static startNodesVector(gA, AA) {
    gA.startVector(16, AA, 8);
  }
  static addBuffers(gA, AA) {
    gA.addFieldOffset(2, AA, 0);
  }
  static startBuffersVector(gA, AA) {
    gA.startVector(16, AA, 8);
  }
  static addCompression(gA, AA) {
    gA.addFieldOffset(3, AA, 0);
  }
  static endRecordBatch(gA) {
    return gA.endObject();
  }
}, DictionaryBatch$1 = class bg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsDictionaryBatch(gA, AA) {
    return (AA || new bg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsDictionaryBatch(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new bg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  id() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt64(this.bb_pos + gA) : BigInt("0");
  }
  data(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? (gA || new RecordBatch$3()).__init(this.bb.__indirect(this.bb_pos + AA), this.bb) : null;
  }
  /**
   * If isDelta is true the values in the dictionary are to be appended to a
   * dictionary with the indicated id. If isDelta is false this dictionary
   * should replace the existing dictionary.
   */
  isDelta() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? !!this.bb.readInt8(this.bb_pos + gA) : !1;
  }
  static startDictionaryBatch(gA) {
    gA.startObject(3);
  }
  static addId(gA, AA) {
    gA.addFieldInt64(0, AA, BigInt("0"));
  }
  static addData(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static addIsDelta(gA, AA) {
    gA.addFieldInt8(2, +AA, 0);
  }
  static endDictionaryBatch(gA) {
    return gA.endObject();
  }
};
var Endianness;
(function(CA) {
  CA[CA.Little = 0] = "Little", CA[CA.Big = 1] = "Big";
})(Endianness || (Endianness = {}));
var DictionaryKind;
(function(CA) {
  CA[CA.DenseArray = 0] = "DenseArray";
})(DictionaryKind || (DictionaryKind = {}));
class Int {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsInt(gA, AA) {
    return (AA || new Int()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsInt(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Int()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  bitWidth() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 0;
  }
  isSigned() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? !!this.bb.readInt8(this.bb_pos + gA) : !1;
  }
  static startInt(gA) {
    gA.startObject(2);
  }
  static addBitWidth(gA, AA) {
    gA.addFieldInt32(0, AA, 0);
  }
  static addIsSigned(gA, AA) {
    gA.addFieldInt8(1, +AA, 0);
  }
  static endInt(gA) {
    return gA.endObject();
  }
  static createInt(gA, AA, IA) {
    return Int.startInt(gA), Int.addBitWidth(gA, AA), Int.addIsSigned(gA, IA), Int.endInt(gA);
  }
}
class DictionaryEncoding {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsDictionaryEncoding(gA, AA) {
    return (AA || new DictionaryEncoding()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsDictionaryEncoding(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new DictionaryEncoding()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * The known dictionary id in the application where this data is used. In
   * the file or streaming formats, the dictionary ids are found in the
   * DictionaryBatch messages
   */
  id() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt64(this.bb_pos + gA) : BigInt("0");
  }
  /**
   * The dictionary indices are constrained to be non-negative integers. If
   * this field is null, the indices must be signed int32. To maximize
   * cross-language compatibility and performance, implementations are
   * recommended to prefer signed integer types over unsigned integer types
   * and to avoid uint64 indices unless they are required by an application.
   */
  indexType(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? (gA || new Int()).__init(this.bb.__indirect(this.bb_pos + AA), this.bb) : null;
  }
  /**
   * By default, dictionaries are not ordered, or the order does not have
   * semantic meaning. In some statistical, applications, dictionary-encoding
   * is used to represent ordered categorical data, and we provide a way to
   * preserve that metadata here
   */
  isOrdered() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? !!this.bb.readInt8(this.bb_pos + gA) : !1;
  }
  dictionaryKind() {
    const gA = this.bb.__offset(this.bb_pos, 10);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : DictionaryKind.DenseArray;
  }
  static startDictionaryEncoding(gA) {
    gA.startObject(4);
  }
  static addId(gA, AA) {
    gA.addFieldInt64(0, AA, BigInt("0"));
  }
  static addIndexType(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static addIsOrdered(gA, AA) {
    gA.addFieldInt8(2, +AA, 0);
  }
  static addDictionaryKind(gA, AA) {
    gA.addFieldInt16(3, AA, DictionaryKind.DenseArray);
  }
  static endDictionaryEncoding(gA) {
    return gA.endObject();
  }
}
class KeyValue {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsKeyValue(gA, AA) {
    return (AA || new KeyValue()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsKeyValue(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new KeyValue()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  key(gA) {
    const AA = this.bb.__offset(this.bb_pos, 4);
    return AA ? this.bb.__string(this.bb_pos + AA, gA) : null;
  }
  value(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? this.bb.__string(this.bb_pos + AA, gA) : null;
  }
  static startKeyValue(gA) {
    gA.startObject(2);
  }
  static addKey(gA, AA) {
    gA.addFieldOffset(0, AA, 0);
  }
  static addValue(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static endKeyValue(gA) {
    return gA.endObject();
  }
  static createKeyValue(gA, AA, IA) {
    return KeyValue.startKeyValue(gA), KeyValue.addKey(gA, AA), KeyValue.addValue(gA, IA), KeyValue.endKeyValue(gA);
  }
}
let Binary$1 = class og {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsBinary(gA, AA) {
    return (AA || new og()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsBinary(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new og()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startBinary(gA) {
    gA.startObject(0);
  }
  static endBinary(gA) {
    return gA.endObject();
  }
  static createBinary(gA) {
    return og.startBinary(gA), og.endBinary(gA);
  }
}, Bool$1 = class cg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsBool(gA, AA) {
    return (AA || new cg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsBool(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new cg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startBool(gA) {
    gA.startObject(0);
  }
  static endBool(gA) {
    return gA.endObject();
  }
  static createBool(gA) {
    return cg.startBool(gA), cg.endBool(gA);
  }
}, Date$1 = class Ig {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsDate(gA, AA) {
    return (AA || new Ig()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsDate(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Ig()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  unit() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : DateUnit.MILLISECOND;
  }
  static startDate(gA) {
    gA.startObject(1);
  }
  static addUnit(gA, AA) {
    gA.addFieldInt16(0, AA, DateUnit.MILLISECOND);
  }
  static endDate(gA) {
    return gA.endObject();
  }
  static createDate(gA, AA) {
    return Ig.startDate(gA), Ig.addUnit(gA, AA), Ig.endDate(gA);
  }
}, Decimal$1 = class TI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsDecimal(gA, AA) {
    return (AA || new TI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsDecimal(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new TI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * Total number of decimal digits
   */
  precision() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 0;
  }
  /**
   * Number of digits after the decimal point "."
   */
  scale() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 0;
  }
  /**
   * Number of bits per value. The only accepted widths are 128 and 256.
   * We use bitWidth for consistency with Int::bitWidth.
   */
  bitWidth() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 128;
  }
  static startDecimal(gA) {
    gA.startObject(3);
  }
  static addPrecision(gA, AA) {
    gA.addFieldInt32(0, AA, 0);
  }
  static addScale(gA, AA) {
    gA.addFieldInt32(1, AA, 0);
  }
  static addBitWidth(gA, AA) {
    gA.addFieldInt32(2, AA, 128);
  }
  static endDecimal(gA) {
    return gA.endObject();
  }
  static createDecimal(gA, AA, IA, BA) {
    return TI.startDecimal(gA), TI.addPrecision(gA, AA), TI.addScale(gA, IA), TI.addBitWidth(gA, BA), TI.endDecimal(gA);
  }
}, Duration$1 = class gg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsDuration(gA, AA) {
    return (AA || new gg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsDuration(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new gg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  unit() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : TimeUnit.MILLISECOND;
  }
  static startDuration(gA) {
    gA.startObject(1);
  }
  static addUnit(gA, AA) {
    gA.addFieldInt16(0, AA, TimeUnit.MILLISECOND);
  }
  static endDuration(gA) {
    return gA.endObject();
  }
  static createDuration(gA, AA) {
    return gg.startDuration(gA), gg.addUnit(gA, AA), gg.endDuration(gA);
  }
}, FixedSizeBinary$1 = class Cg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsFixedSizeBinary(gA, AA) {
    return (AA || new Cg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsFixedSizeBinary(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Cg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * Number of bytes per value
   */
  byteWidth() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 0;
  }
  static startFixedSizeBinary(gA) {
    gA.startObject(1);
  }
  static addByteWidth(gA, AA) {
    gA.addFieldInt32(0, AA, 0);
  }
  static endFixedSizeBinary(gA) {
    return gA.endObject();
  }
  static createFixedSizeBinary(gA, AA) {
    return Cg.startFixedSizeBinary(gA), Cg.addByteWidth(gA, AA), Cg.endFixedSizeBinary(gA);
  }
}, FixedSizeList$1 = class Bg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsFixedSizeList(gA, AA) {
    return (AA || new Bg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsFixedSizeList(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Bg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * Number of list items per value
   */
  listSize() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 0;
  }
  static startFixedSizeList(gA) {
    gA.startObject(1);
  }
  static addListSize(gA, AA) {
    gA.addFieldInt32(0, AA, 0);
  }
  static endFixedSizeList(gA) {
    return gA.endObject();
  }
  static createFixedSizeList(gA, AA) {
    return Bg.startFixedSizeList(gA), Bg.addListSize(gA, AA), Bg.endFixedSizeList(gA);
  }
};
class FloatingPoint {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsFloatingPoint(gA, AA) {
    return (AA || new FloatingPoint()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsFloatingPoint(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new FloatingPoint()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  precision() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : Precision.HALF;
  }
  static startFloatingPoint(gA) {
    gA.startObject(1);
  }
  static addPrecision(gA, AA) {
    gA.addFieldInt16(0, AA, Precision.HALF);
  }
  static endFloatingPoint(gA) {
    return gA.endObject();
  }
  static createFloatingPoint(gA, AA) {
    return FloatingPoint.startFloatingPoint(gA), FloatingPoint.addPrecision(gA, AA), FloatingPoint.endFloatingPoint(gA);
  }
}
class Interval {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsInterval(gA, AA) {
    return (AA || new Interval()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsInterval(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Interval()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  unit() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : IntervalUnit.YEAR_MONTH;
  }
  static startInterval(gA) {
    gA.startObject(1);
  }
  static addUnit(gA, AA) {
    gA.addFieldInt16(0, AA, IntervalUnit.YEAR_MONTH);
  }
  static endInterval(gA) {
    return gA.endObject();
  }
  static createInterval(gA, AA) {
    return Interval.startInterval(gA), Interval.addUnit(gA, AA), Interval.endInterval(gA);
  }
}
let LargeBinary$1 = class tg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsLargeBinary(gA, AA) {
    return (AA || new tg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsLargeBinary(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new tg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startLargeBinary(gA) {
    gA.startObject(0);
  }
  static endLargeBinary(gA) {
    return gA.endObject();
  }
  static createLargeBinary(gA) {
    return tg.startLargeBinary(gA), tg.endLargeBinary(gA);
  }
}, LargeUtf8$1 = class eg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsLargeUtf8(gA, AA) {
    return (AA || new eg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsLargeUtf8(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new eg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startLargeUtf8(gA) {
    gA.startObject(0);
  }
  static endLargeUtf8(gA) {
    return gA.endObject();
  }
  static createLargeUtf8(gA) {
    return eg.startLargeUtf8(gA), eg.endLargeUtf8(gA);
  }
}, List$1 = class ag {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsList(gA, AA) {
    return (AA || new ag()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsList(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new ag()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startList(gA) {
    gA.startObject(0);
  }
  static endList(gA) {
    return gA.endObject();
  }
  static createList(gA) {
    return ag.startList(gA), ag.endList(gA);
  }
}, Map$1 = class Qg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsMap(gA, AA) {
    return (AA || new Qg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsMap(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Qg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * Set to true if the keys within each value are sorted
   */
  keysSorted() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? !!this.bb.readInt8(this.bb_pos + gA) : !1;
  }
  static startMap(gA) {
    gA.startObject(1);
  }
  static addKeysSorted(gA, AA) {
    gA.addFieldInt8(0, +AA, 0);
  }
  static endMap(gA) {
    return gA.endObject();
  }
  static createMap(gA, AA) {
    return Qg.startMap(gA), Qg.addKeysSorted(gA, AA), Qg.endMap(gA);
  }
}, Null$1 = class Gg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsNull(gA, AA) {
    return (AA || new Gg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsNull(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Gg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startNull(gA) {
    gA.startObject(0);
  }
  static endNull(gA) {
    return gA.endObject();
  }
  static createNull(gA) {
    return Gg.startNull(gA), Gg.endNull(gA);
  }
};
class Struct_ {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsStruct_(gA, AA) {
    return (AA || new Struct_()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsStruct_(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Struct_()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startStruct_(gA) {
    gA.startObject(0);
  }
  static endStruct_(gA) {
    return gA.endObject();
  }
  static createStruct_(gA) {
    return Struct_.startStruct_(gA), Struct_.endStruct_(gA);
  }
}
class Time {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsTime(gA, AA) {
    return (AA || new Time()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsTime(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Time()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  unit() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : TimeUnit.MILLISECOND;
  }
  bitWidth() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.readInt32(this.bb_pos + gA) : 32;
  }
  static startTime(gA) {
    gA.startObject(2);
  }
  static addUnit(gA, AA) {
    gA.addFieldInt16(0, AA, TimeUnit.MILLISECOND);
  }
  static addBitWidth(gA, AA) {
    gA.addFieldInt32(1, AA, 32);
  }
  static endTime(gA) {
    return gA.endObject();
  }
  static createTime(gA, AA, IA) {
    return Time.startTime(gA), Time.addUnit(gA, AA), Time.addBitWidth(gA, IA), Time.endTime(gA);
  }
}
class Timestamp {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsTimestamp(gA, AA) {
    return (AA || new Timestamp()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsTimestamp(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Timestamp()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  unit() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : TimeUnit.SECOND;
  }
  timezone(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? this.bb.__string(this.bb_pos + AA, gA) : null;
  }
  static startTimestamp(gA) {
    gA.startObject(2);
  }
  static addUnit(gA, AA) {
    gA.addFieldInt16(0, AA, TimeUnit.SECOND);
  }
  static addTimezone(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static endTimestamp(gA) {
    return gA.endObject();
  }
  static createTimestamp(gA, AA, IA) {
    return Timestamp.startTimestamp(gA), Timestamp.addUnit(gA, AA), Timestamp.addTimezone(gA, IA), Timestamp.endTimestamp(gA);
  }
}
class Union {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsUnion(gA, AA) {
    return (AA || new Union()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsUnion(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Union()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  mode() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : UnionMode.Sparse;
  }
  typeIds(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? this.bb.readInt32(this.bb.__vector(this.bb_pos + AA) + gA * 4) : 0;
  }
  typeIdsLength() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  typeIdsArray() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? new Int32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + gA), this.bb.__vector_len(this.bb_pos + gA)) : null;
  }
  static startUnion(gA) {
    gA.startObject(2);
  }
  static addMode(gA, AA) {
    gA.addFieldInt16(0, AA, UnionMode.Sparse);
  }
  static addTypeIds(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static createTypeIdsVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addInt32(AA[IA]);
    return gA.endVector();
  }
  static startTypeIdsVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static endUnion(gA) {
    return gA.endObject();
  }
  static createUnion(gA, AA, IA) {
    return Union.startUnion(gA), Union.addMode(gA, AA), Union.addTypeIds(gA, IA), Union.endUnion(gA);
  }
}
let Utf8$1 = class lg {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsUtf8(gA, AA) {
    return (AA || new lg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsUtf8(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new lg()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static startUtf8(gA) {
    gA.startObject(0);
  }
  static endUtf8(gA) {
    return gA.endObject();
  }
  static createUtf8(gA) {
    return lg.startUtf8(gA), lg.endUtf8(gA);
  }
};
var Type$1;
(function(CA) {
  CA[CA.NONE = 0] = "NONE", CA[CA.Null = 1] = "Null", CA[CA.Int = 2] = "Int", CA[CA.FloatingPoint = 3] = "FloatingPoint", CA[CA.Binary = 4] = "Binary", CA[CA.Utf8 = 5] = "Utf8", CA[CA.Bool = 6] = "Bool", CA[CA.Decimal = 7] = "Decimal", CA[CA.Date = 8] = "Date", CA[CA.Time = 9] = "Time", CA[CA.Timestamp = 10] = "Timestamp", CA[CA.Interval = 11] = "Interval", CA[CA.List = 12] = "List", CA[CA.Struct_ = 13] = "Struct_", CA[CA.Union = 14] = "Union", CA[CA.FixedSizeBinary = 15] = "FixedSizeBinary", CA[CA.FixedSizeList = 16] = "FixedSizeList", CA[CA.Map = 17] = "Map", CA[CA.Duration = 18] = "Duration", CA[CA.LargeBinary = 19] = "LargeBinary", CA[CA.LargeUtf8 = 20] = "LargeUtf8", CA[CA.LargeList = 21] = "LargeList", CA[CA.RunEndEncoded = 22] = "RunEndEncoded";
})(Type$1 || (Type$1 = {}));
let Field$1 = class Ng {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsField(gA, AA) {
    return (AA || new Ng()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsField(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Ng()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  name(gA) {
    const AA = this.bb.__offset(this.bb_pos, 4);
    return AA ? this.bb.__string(this.bb_pos + AA, gA) : null;
  }
  /**
   * Whether or not this field can contain nulls. Should be true in general.
   */
  nullable() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? !!this.bb.readInt8(this.bb_pos + gA) : !1;
  }
  typeType() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? this.bb.readUint8(this.bb_pos + gA) : Type$1.NONE;
  }
  /**
   * This is the type of the decoded value if the field is dictionary encoded.
   */
  type(gA) {
    const AA = this.bb.__offset(this.bb_pos, 10);
    return AA ? this.bb.__union(gA, this.bb_pos + AA) : null;
  }
  /**
   * Present only if the field is dictionary encoded.
   */
  dictionary(gA) {
    const AA = this.bb.__offset(this.bb_pos, 12);
    return AA ? (gA || new DictionaryEncoding()).__init(this.bb.__indirect(this.bb_pos + AA), this.bb) : null;
  }
  /**
   * children apply only to nested data types like Struct, List and Union. For
   * primitive types children will have length 0.
   */
  children(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 14);
    return IA ? (AA || new Ng()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  childrenLength() {
    const gA = this.bb.__offset(this.bb_pos, 14);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 16);
    return IA ? (AA || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  customMetadataLength() {
    const gA = this.bb.__offset(this.bb_pos, 16);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  static startField(gA) {
    gA.startObject(7);
  }
  static addName(gA, AA) {
    gA.addFieldOffset(0, AA, 0);
  }
  static addNullable(gA, AA) {
    gA.addFieldInt8(1, +AA, 0);
  }
  static addTypeType(gA, AA) {
    gA.addFieldInt8(2, AA, Type$1.NONE);
  }
  static addType(gA, AA) {
    gA.addFieldOffset(3, AA, 0);
  }
  static addDictionary(gA, AA) {
    gA.addFieldOffset(4, AA, 0);
  }
  static addChildren(gA, AA) {
    gA.addFieldOffset(5, AA, 0);
  }
  static createChildrenVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startChildrenVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static addCustomMetadata(gA, AA) {
    gA.addFieldOffset(6, AA, 0);
  }
  static createCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static endField(gA) {
    return gA.endObject();
  }
}, Schema$3 = class jI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsSchema(gA, AA) {
    return (AA || new jI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsSchema(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new jI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  /**
   * endianness of the buffer
   * it is Little Endian by default
   * if endianness doesn't match the underlying system then the vectors need to be converted
   */
  endianness() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : Endianness.Little;
  }
  fields(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 6);
    return IA ? (AA || new Field$1()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  fieldsLength() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  customMetadata(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 8);
    return IA ? (AA || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  customMetadataLength() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  /**
   * Features used in the stream/file.
   */
  features(gA) {
    const AA = this.bb.__offset(this.bb_pos, 10);
    return AA ? this.bb.readInt64(this.bb.__vector(this.bb_pos + AA) + gA * 8) : BigInt(0);
  }
  featuresLength() {
    const gA = this.bb.__offset(this.bb_pos, 10);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  static startSchema(gA) {
    gA.startObject(4);
  }
  static addEndianness(gA, AA) {
    gA.addFieldInt16(0, AA, Endianness.Little);
  }
  static addFields(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static createFieldsVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startFieldsVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static addCustomMetadata(gA, AA) {
    gA.addFieldOffset(2, AA, 0);
  }
  static createCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static addFeatures(gA, AA) {
    gA.addFieldOffset(3, AA, 0);
  }
  static createFeaturesVector(gA, AA) {
    gA.startVector(8, AA.length, 8);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addInt64(AA[IA]);
    return gA.endVector();
  }
  static startFeaturesVector(gA, AA) {
    gA.startVector(8, AA, 8);
  }
  static endSchema(gA) {
    return gA.endObject();
  }
  static finishSchemaBuffer(gA, AA) {
    gA.finish(AA);
  }
  static finishSizePrefixedSchemaBuffer(gA, AA) {
    gA.finish(AA, void 0, !0);
  }
  static createSchema(gA, AA, IA, BA, QA) {
    return jI.startSchema(gA), jI.addEndianness(gA, AA), jI.addFields(gA, IA), jI.addCustomMetadata(gA, BA), jI.addFeatures(gA, QA), jI.endSchema(gA);
  }
};
var MessageHeader;
(function(CA) {
  CA[CA.NONE = 0] = "NONE", CA[CA.Schema = 1] = "Schema", CA[CA.DictionaryBatch = 2] = "DictionaryBatch", CA[CA.RecordBatch = 3] = "RecordBatch", CA[CA.Tensor = 4] = "Tensor", CA[CA.SparseTensor = 5] = "SparseTensor";
})(MessageHeader || (MessageHeader = {}));
var Type;
(function(CA) {
  CA[CA.NONE = 0] = "NONE", CA[CA.Null = 1] = "Null", CA[CA.Int = 2] = "Int", CA[CA.Float = 3] = "Float", CA[CA.Binary = 4] = "Binary", CA[CA.Utf8 = 5] = "Utf8", CA[CA.Bool = 6] = "Bool", CA[CA.Decimal = 7] = "Decimal", CA[CA.Date = 8] = "Date", CA[CA.Time = 9] = "Time", CA[CA.Timestamp = 10] = "Timestamp", CA[CA.Interval = 11] = "Interval", CA[CA.List = 12] = "List", CA[CA.Struct = 13] = "Struct", CA[CA.Union = 14] = "Union", CA[CA.FixedSizeBinary = 15] = "FixedSizeBinary", CA[CA.FixedSizeList = 16] = "FixedSizeList", CA[CA.Map = 17] = "Map", CA[CA.Duration = 18] = "Duration", CA[CA.LargeBinary = 19] = "LargeBinary", CA[CA.LargeUtf8 = 20] = "LargeUtf8", CA[CA.Dictionary = -1] = "Dictionary", CA[CA.Int8 = -2] = "Int8", CA[CA.Int16 = -3] = "Int16", CA[CA.Int32 = -4] = "Int32", CA[CA.Int64 = -5] = "Int64", CA[CA.Uint8 = -6] = "Uint8", CA[CA.Uint16 = -7] = "Uint16", CA[CA.Uint32 = -8] = "Uint32", CA[CA.Uint64 = -9] = "Uint64", CA[CA.Float16 = -10] = "Float16", CA[CA.Float32 = -11] = "Float32", CA[CA.Float64 = -12] = "Float64", CA[CA.DateDay = -13] = "DateDay", CA[CA.DateMillisecond = -14] = "DateMillisecond", CA[CA.TimestampSecond = -15] = "TimestampSecond", CA[CA.TimestampMillisecond = -16] = "TimestampMillisecond", CA[CA.TimestampMicrosecond = -17] = "TimestampMicrosecond", CA[CA.TimestampNanosecond = -18] = "TimestampNanosecond", CA[CA.TimeSecond = -19] = "TimeSecond", CA[CA.TimeMillisecond = -20] = "TimeMillisecond", CA[CA.TimeMicrosecond = -21] = "TimeMicrosecond", CA[CA.TimeNanosecond = -22] = "TimeNanosecond", CA[CA.DenseUnion = -23] = "DenseUnion", CA[CA.SparseUnion = -24] = "SparseUnion", CA[CA.IntervalDayTime = -25] = "IntervalDayTime", CA[CA.IntervalYearMonth = -26] = "IntervalYearMonth", CA[CA.DurationSecond = -27] = "DurationSecond", CA[CA.DurationMillisecond = -28] = "DurationMillisecond", CA[CA.DurationMicrosecond = -29] = "DurationMicrosecond", CA[CA.DurationNanosecond = -30] = "DurationNanosecond", CA[CA.IntervalMonthDayNano = -31] = "IntervalMonthDayNano";
})(Type || (Type = {}));
var BufferType;
(function(CA) {
  CA[CA.OFFSET = 0] = "OFFSET", CA[CA.DATA = 1] = "DATA", CA[CA.VALIDITY = 2] = "VALIDITY", CA[CA.TYPE = 3] = "TYPE";
})(BufferType || (BufferType = {}));
const undf = void 0;
function valueToString(CA) {
  if (CA === null)
    return "null";
  if (CA === undf)
    return "undefined";
  switch (typeof CA) {
    case "number":
      return `${CA}`;
    case "bigint":
      return `${CA}`;
    case "string":
      return `"${CA}"`;
  }
  return typeof CA[Symbol.toPrimitive] == "function" ? CA[Symbol.toPrimitive]("string") : ArrayBuffer.isView(CA) ? CA instanceof BigInt64Array || CA instanceof BigUint64Array ? `[${[...CA].map((gA) => valueToString(gA))}]` : `[${CA}]` : ArrayBuffer.isView(CA) ? `[${CA}]` : JSON.stringify(CA, (gA, AA) => typeof AA == "bigint" ? `${AA}` : AA);
}
const util_pretty_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  valueToString
}, Symbol.toStringTag, { value: "Module" }));
function bigIntToNumber(CA) {
  if (typeof CA == "bigint" && (CA < Number.MIN_SAFE_INTEGER || CA > Number.MAX_SAFE_INTEGER))
    throw new TypeError(`${CA} is not safe to convert to a number.`);
  return Number(CA);
}
function divideBigInts(CA, gA) {
  return bigIntToNumber(CA / gA) + bigIntToNumber(CA % gA) / bigIntToNumber(gA);
}
const isArrowBigNumSymbol = /* @__PURE__ */ Symbol.for("isArrowBigNum");
function BigNum(CA, ...gA) {
  return gA.length === 0 ? Object.setPrototypeOf(toArrayBufferView(this.TypedArray, CA), this.constructor.prototype) : Object.setPrototypeOf(new this.TypedArray(CA, ...gA), this.constructor.prototype);
}
BigNum.prototype[isArrowBigNumSymbol] = !0;
BigNum.prototype.toJSON = function() {
  return `"${bigNumToString(this)}"`;
};
BigNum.prototype.valueOf = function(CA) {
  return bigNumToNumber(this, CA);
};
BigNum.prototype.toString = function() {
  return bigNumToString(this);
};
BigNum.prototype[Symbol.toPrimitive] = function(CA = "default") {
  switch (CA) {
    case "number":
      return bigNumToNumber(this);
    case "string":
      return bigNumToString(this);
    case "default":
      return bigNumToBigInt(this);
  }
  return bigNumToString(this);
};
function SignedBigNum(...CA) {
  return BigNum.apply(this, CA);
}
function UnsignedBigNum(...CA) {
  return BigNum.apply(this, CA);
}
function DecimalBigNum(...CA) {
  return BigNum.apply(this, CA);
}
Object.setPrototypeOf(SignedBigNum.prototype, Object.create(Int32Array.prototype));
Object.setPrototypeOf(UnsignedBigNum.prototype, Object.create(Uint32Array.prototype));
Object.setPrototypeOf(DecimalBigNum.prototype, Object.create(Uint32Array.prototype));
Object.assign(SignedBigNum.prototype, BigNum.prototype, { constructor: SignedBigNum, signed: !0, TypedArray: Int32Array, BigIntArray: BigInt64Array });
Object.assign(UnsignedBigNum.prototype, BigNum.prototype, { constructor: UnsignedBigNum, signed: !1, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
Object.assign(DecimalBigNum.prototype, BigNum.prototype, { constructor: DecimalBigNum, signed: !0, TypedArray: Uint32Array, BigIntArray: BigUint64Array });
const TWO_TO_THE_64 = BigInt(4294967296) * BigInt(4294967296), TWO_TO_THE_64_MINUS_1 = TWO_TO_THE_64 - BigInt(1);
function bigNumToNumber(CA, gA) {
  const { buffer: AA, byteOffset: IA, byteLength: BA, signed: QA } = CA, EA = new BigUint64Array(AA, IA, BA / 8), iA = QA && EA.at(-1) & BigInt(1) << BigInt(63);
  let oA = BigInt(0), cA = 0;
  if (iA) {
    for (const tA of EA)
      oA |= (tA ^ TWO_TO_THE_64_MINUS_1) * (BigInt(1) << BigInt(64 * cA++));
    oA *= BigInt(-1), oA -= BigInt(1);
  } else
    for (const tA of EA)
      oA |= tA * (BigInt(1) << BigInt(64 * cA++));
  if (typeof gA == "number" && gA > 0) {
    const tA = BigInt("1".padEnd(gA + 1, "0")), eA = oA / tA, aA = iA ? -(oA % tA) : oA % tA, GA = bigIntToNumber(eA), lA = `${aA}`.padStart(gA, "0");
    return +`${iA && GA === 0 ? "-" : ""}${GA}.${lA}`;
  }
  return bigIntToNumber(oA);
}
function bigNumToString(CA) {
  if (CA.byteLength === 8)
    return `${new CA.BigIntArray(CA.buffer, CA.byteOffset, 1)[0]}`;
  if (!CA.signed)
    return unsignedBigNumToString(CA);
  let gA = new Uint16Array(CA.buffer, CA.byteOffset, CA.byteLength / 2);
  if (new Int16Array([gA.at(-1)])[0] >= 0)
    return unsignedBigNumToString(CA);
  gA = gA.slice();
  let IA = 1;
  for (let QA = 0; QA < gA.length; QA++) {
    const EA = gA[QA], iA = ~EA + IA;
    gA[QA] = iA, IA &= EA === 0 ? 1 : 0;
  }
  return `-${unsignedBigNumToString(gA)}`;
}
function bigNumToBigInt(CA) {
  return CA.byteLength === 8 ? new CA.BigIntArray(CA.buffer, CA.byteOffset, 1)[0] : bigNumToString(CA);
}
function unsignedBigNumToString(CA) {
  let gA = "";
  const AA = new Uint32Array(2);
  let IA = new Uint16Array(CA.buffer, CA.byteOffset, CA.byteLength / 2);
  const BA = new Uint32Array((IA = new Uint16Array(IA).reverse()).buffer);
  let QA = -1;
  const EA = IA.length - 1;
  do {
    for (AA[0] = IA[QA = 0]; QA < EA; )
      IA[QA++] = AA[1] = AA[0] / 10, AA[0] = (AA[0] - AA[1] * 10 << 16) + IA[QA];
    IA[QA] = AA[1] = AA[0] / 10, AA[0] = AA[0] - AA[1] * 10, gA = `${AA[0]}${gA}`;
  } while (BA[0] || BA[1] || BA[2] || BA[3]);
  return gA ?? "0";
}
class BN {
  /** @nocollapse */
  static new(gA, AA) {
    switch (AA) {
      case !0:
        return new SignedBigNum(gA);
      case !1:
        return new UnsignedBigNum(gA);
    }
    switch (gA.constructor) {
      case Int8Array:
      case Int16Array:
      case Int32Array:
      case BigInt64Array:
        return new SignedBigNum(gA);
    }
    return gA.byteLength === 16 ? new DecimalBigNum(gA) : new UnsignedBigNum(gA);
  }
  /** @nocollapse */
  static signed(gA) {
    return new SignedBigNum(gA);
  }
  /** @nocollapse */
  static unsigned(gA) {
    return new UnsignedBigNum(gA);
  }
  /** @nocollapse */
  static decimal(gA) {
    return new DecimalBigNum(gA);
  }
  constructor(gA, AA) {
    return BN.new(gA, AA);
  }
}
const util_bn_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BN,
  bigNumToBigInt,
  bigNumToNumber,
  bigNumToString,
  isArrowBigNumSymbol
}, Symbol.toStringTag, { value: "Module" }));
var _a$4, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o$1, _p, _q, _r, _s, _t$1, _u, _v, _w, _x;
class DataType {
  /** @nocollapse */
  static isNull(gA) {
    return gA?.typeId === Type.Null;
  }
  /** @nocollapse */
  static isInt(gA) {
    return gA?.typeId === Type.Int;
  }
  /** @nocollapse */
  static isFloat(gA) {
    return gA?.typeId === Type.Float;
  }
  /** @nocollapse */
  static isBinary(gA) {
    return gA?.typeId === Type.Binary;
  }
  /** @nocollapse */
  static isLargeBinary(gA) {
    return gA?.typeId === Type.LargeBinary;
  }
  /** @nocollapse */
  static isUtf8(gA) {
    return gA?.typeId === Type.Utf8;
  }
  /** @nocollapse */
  static isLargeUtf8(gA) {
    return gA?.typeId === Type.LargeUtf8;
  }
  /** @nocollapse */
  static isBool(gA) {
    return gA?.typeId === Type.Bool;
  }
  /** @nocollapse */
  static isDecimal(gA) {
    return gA?.typeId === Type.Decimal;
  }
  /** @nocollapse */
  static isDate(gA) {
    return gA?.typeId === Type.Date;
  }
  /** @nocollapse */
  static isTime(gA) {
    return gA?.typeId === Type.Time;
  }
  /** @nocollapse */
  static isTimestamp(gA) {
    return gA?.typeId === Type.Timestamp;
  }
  /** @nocollapse */
  static isInterval(gA) {
    return gA?.typeId === Type.Interval;
  }
  /** @nocollapse */
  static isDuration(gA) {
    return gA?.typeId === Type.Duration;
  }
  /** @nocollapse */
  static isList(gA) {
    return gA?.typeId === Type.List;
  }
  /** @nocollapse */
  static isStruct(gA) {
    return gA?.typeId === Type.Struct;
  }
  /** @nocollapse */
  static isUnion(gA) {
    return gA?.typeId === Type.Union;
  }
  /** @nocollapse */
  static isFixedSizeBinary(gA) {
    return gA?.typeId === Type.FixedSizeBinary;
  }
  /** @nocollapse */
  static isFixedSizeList(gA) {
    return gA?.typeId === Type.FixedSizeList;
  }
  /** @nocollapse */
  static isMap(gA) {
    return gA?.typeId === Type.Map;
  }
  /** @nocollapse */
  static isDictionary(gA) {
    return gA?.typeId === Type.Dictionary;
  }
  /** @nocollapse */
  static isDenseUnion(gA) {
    return DataType.isUnion(gA) && gA.mode === UnionMode.Dense;
  }
  /** @nocollapse */
  static isSparseUnion(gA) {
    return DataType.isUnion(gA) && gA.mode === UnionMode.Sparse;
  }
  constructor(gA) {
    this.typeId = gA;
  }
}
_a$4 = Symbol.toStringTag;
DataType[_a$4] = ((CA) => (CA.children = null, CA.ArrayType = Array, CA.OffsetArrayType = Int32Array, CA[Symbol.toStringTag] = "DataType"))(DataType.prototype);
class Null extends DataType {
  constructor() {
    super(Type.Null);
  }
  toString() {
    return "Null";
  }
}
_b = Symbol.toStringTag;
Null[_b] = ((CA) => CA[Symbol.toStringTag] = "Null")(Null.prototype);
class Int_ extends DataType {
  constructor(gA, AA) {
    super(Type.Int), this.isSigned = gA, this.bitWidth = AA;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 8:
        return this.isSigned ? Int8Array : Uint8Array;
      case 16:
        return this.isSigned ? Int16Array : Uint16Array;
      case 32:
        return this.isSigned ? Int32Array : Uint32Array;
      case 64:
        return this.isSigned ? BigInt64Array : BigUint64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `${this.isSigned ? "I" : "Ui"}nt${this.bitWidth}`;
  }
}
_c = Symbol.toStringTag;
Int_[_c] = ((CA) => (CA.isSigned = null, CA.bitWidth = null, CA[Symbol.toStringTag] = "Int"))(Int_.prototype);
class Int32 extends Int_ {
  constructor() {
    super(!0, 32);
  }
  get ArrayType() {
    return Int32Array;
  }
}
Object.defineProperty(Int32.prototype, "ArrayType", { value: Int32Array });
class Float extends DataType {
  constructor(gA) {
    super(Type.Float), this.precision = gA;
  }
  get ArrayType() {
    switch (this.precision) {
      case Precision.HALF:
        return Uint16Array;
      case Precision.SINGLE:
        return Float32Array;
      case Precision.DOUBLE:
        return Float64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
  toString() {
    return `Float${this.precision << 5 || 16}`;
  }
}
_d = Symbol.toStringTag;
Float[_d] = ((CA) => (CA.precision = null, CA[Symbol.toStringTag] = "Float"))(Float.prototype);
class Binary extends DataType {
  constructor() {
    super(Type.Binary);
  }
  toString() {
    return "Binary";
  }
}
_e = Symbol.toStringTag;
Binary[_e] = ((CA) => (CA.ArrayType = Uint8Array, CA[Symbol.toStringTag] = "Binary"))(Binary.prototype);
class LargeBinary extends DataType {
  constructor() {
    super(Type.LargeBinary);
  }
  toString() {
    return "LargeBinary";
  }
}
_f = Symbol.toStringTag;
LargeBinary[_f] = ((CA) => (CA.ArrayType = Uint8Array, CA.OffsetArrayType = BigInt64Array, CA[Symbol.toStringTag] = "LargeBinary"))(LargeBinary.prototype);
class Utf8 extends DataType {
  constructor() {
    super(Type.Utf8);
  }
  toString() {
    return "Utf8";
  }
}
_g = Symbol.toStringTag;
Utf8[_g] = ((CA) => (CA.ArrayType = Uint8Array, CA[Symbol.toStringTag] = "Utf8"))(Utf8.prototype);
class LargeUtf8 extends DataType {
  constructor() {
    super(Type.LargeUtf8);
  }
  toString() {
    return "LargeUtf8";
  }
}
_h = Symbol.toStringTag;
LargeUtf8[_h] = ((CA) => (CA.ArrayType = Uint8Array, CA.OffsetArrayType = BigInt64Array, CA[Symbol.toStringTag] = "LargeUtf8"))(LargeUtf8.prototype);
class Bool extends DataType {
  constructor() {
    super(Type.Bool);
  }
  toString() {
    return "Bool";
  }
}
_j = Symbol.toStringTag;
Bool[_j] = ((CA) => (CA.ArrayType = Uint8Array, CA[Symbol.toStringTag] = "Bool"))(Bool.prototype);
class Decimal extends DataType {
  constructor(gA, AA, IA = 128) {
    super(Type.Decimal), this.scale = gA, this.precision = AA, this.bitWidth = IA;
  }
  toString() {
    return `Decimal[${this.precision}e${this.scale > 0 ? "+" : ""}${this.scale}]`;
  }
}
_k = Symbol.toStringTag;
Decimal[_k] = ((CA) => (CA.scale = null, CA.precision = null, CA.ArrayType = Uint32Array, CA[Symbol.toStringTag] = "Decimal"))(Decimal.prototype);
class Date_ extends DataType {
  constructor(gA) {
    super(Type.Date), this.unit = gA;
  }
  toString() {
    return `Date${(this.unit + 1) * 32}<${DateUnit[this.unit]}>`;
  }
  get ArrayType() {
    return this.unit === DateUnit.DAY ? Int32Array : BigInt64Array;
  }
}
_l = Symbol.toStringTag;
Date_[_l] = ((CA) => (CA.unit = null, CA[Symbol.toStringTag] = "Date"))(Date_.prototype);
class Time_ extends DataType {
  constructor(gA, AA) {
    super(Type.Time), this.unit = gA, this.bitWidth = AA;
  }
  toString() {
    return `Time${this.bitWidth}<${TimeUnit[this.unit]}>`;
  }
  get ArrayType() {
    switch (this.bitWidth) {
      case 32:
        return Int32Array;
      case 64:
        return BigInt64Array;
    }
    throw new Error(`Unrecognized ${this[Symbol.toStringTag]} type`);
  }
}
_m = Symbol.toStringTag;
Time_[_m] = ((CA) => (CA.unit = null, CA.bitWidth = null, CA[Symbol.toStringTag] = "Time"))(Time_.prototype);
class Timestamp_ extends DataType {
  constructor(gA, AA) {
    super(Type.Timestamp), this.unit = gA, this.timezone = AA;
  }
  toString() {
    return `Timestamp<${TimeUnit[this.unit]}${this.timezone ? `, ${this.timezone}` : ""}>`;
  }
}
_o$1 = Symbol.toStringTag;
Timestamp_[_o$1] = ((CA) => (CA.unit = null, CA.timezone = null, CA.ArrayType = BigInt64Array, CA[Symbol.toStringTag] = "Timestamp"))(Timestamp_.prototype);
class Interval_ extends DataType {
  constructor(gA) {
    super(Type.Interval), this.unit = gA;
  }
  toString() {
    return `Interval<${IntervalUnit[this.unit]}>`;
  }
}
_p = Symbol.toStringTag;
Interval_[_p] = ((CA) => (CA.unit = null, CA.ArrayType = Int32Array, CA[Symbol.toStringTag] = "Interval"))(Interval_.prototype);
class Duration extends DataType {
  constructor(gA) {
    super(Type.Duration), this.unit = gA;
  }
  toString() {
    return `Duration<${TimeUnit[this.unit]}>`;
  }
}
_q = Symbol.toStringTag;
Duration[_q] = ((CA) => (CA.unit = null, CA.ArrayType = BigInt64Array, CA[Symbol.toStringTag] = "Duration"))(Duration.prototype);
class List extends DataType {
  constructor(gA) {
    super(Type.List), this.children = [gA];
  }
  toString() {
    return `List<${this.valueType}>`;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
}
_r = Symbol.toStringTag;
List[_r] = ((CA) => (CA.children = null, CA[Symbol.toStringTag] = "List"))(List.prototype);
class Struct extends DataType {
  constructor(gA) {
    super(Type.Struct), this.children = gA;
  }
  toString() {
    return `Struct<{${this.children.map((gA) => `${gA.name}:${gA.type}`).join(", ")}}>`;
  }
}
_s = Symbol.toStringTag;
Struct[_s] = ((CA) => (CA.children = null, CA[Symbol.toStringTag] = "Struct"))(Struct.prototype);
class Union_ extends DataType {
  constructor(gA, AA, IA) {
    super(Type.Union), this.mode = gA, this.children = IA, this.typeIds = AA = Int32Array.from(AA), this.typeIdToChildIndex = AA.reduce((BA, QA, EA) => (BA[QA] = EA) && BA || BA, /* @__PURE__ */ Object.create(null));
  }
  toString() {
    return `${this[Symbol.toStringTag]}<${this.children.map((gA) => `${gA.type}`).join(" | ")}>`;
  }
}
_t$1 = Symbol.toStringTag;
Union_[_t$1] = ((CA) => (CA.mode = null, CA.typeIds = null, CA.children = null, CA.typeIdToChildIndex = null, CA.ArrayType = Int8Array, CA[Symbol.toStringTag] = "Union"))(Union_.prototype);
class FixedSizeBinary extends DataType {
  constructor(gA) {
    super(Type.FixedSizeBinary), this.byteWidth = gA;
  }
  toString() {
    return `FixedSizeBinary[${this.byteWidth}]`;
  }
}
_u = Symbol.toStringTag;
FixedSizeBinary[_u] = ((CA) => (CA.byteWidth = null, CA.ArrayType = Uint8Array, CA[Symbol.toStringTag] = "FixedSizeBinary"))(FixedSizeBinary.prototype);
class FixedSizeList extends DataType {
  constructor(gA, AA) {
    super(Type.FixedSizeList), this.listSize = gA, this.children = [AA];
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get ArrayType() {
    return this.valueType.ArrayType;
  }
  toString() {
    return `FixedSizeList[${this.listSize}]<${this.valueType}>`;
  }
}
_v = Symbol.toStringTag;
FixedSizeList[_v] = ((CA) => (CA.children = null, CA.listSize = null, CA[Symbol.toStringTag] = "FixedSizeList"))(FixedSizeList.prototype);
class Map_ extends DataType {
  constructor(gA, AA = !1) {
    var IA, BA, QA;
    if (super(Type.Map), this.children = [gA], this.keysSorted = AA, gA && (gA.name = "entries", !((IA = gA?.type) === null || IA === void 0) && IA.children)) {
      const EA = (BA = gA?.type) === null || BA === void 0 ? void 0 : BA.children[0];
      EA && (EA.name = "key");
      const iA = (QA = gA?.type) === null || QA === void 0 ? void 0 : QA.children[1];
      iA && (iA.name = "value");
    }
  }
  get keyType() {
    return this.children[0].type.children[0].type;
  }
  get valueType() {
    return this.children[0].type.children[1].type;
  }
  get childType() {
    return this.children[0].type;
  }
  toString() {
    return `Map<{${this.children[0].type.children.map((gA) => `${gA.name}:${gA.type}`).join(", ")}}>`;
  }
}
_w = Symbol.toStringTag;
Map_[_w] = ((CA) => (CA.children = null, CA.keysSorted = null, CA[Symbol.toStringTag] = "Map_"))(Map_.prototype);
const getId$1 = /* @__PURE__ */ ((CA) => () => ++CA)(-1);
class Dictionary extends DataType {
  constructor(gA, AA, IA, BA) {
    super(Type.Dictionary), this.indices = AA, this.dictionary = gA, this.isOrdered = BA || !1, this.id = IA == null ? getId$1() : bigIntToNumber(IA);
  }
  get children() {
    return this.dictionary.children;
  }
  get valueType() {
    return this.dictionary;
  }
  get ArrayType() {
    return this.dictionary.ArrayType;
  }
  toString() {
    return `Dictionary<${this.indices}, ${this.dictionary}>`;
  }
}
_x = Symbol.toStringTag;
Dictionary[_x] = ((CA) => (CA.id = null, CA.indices = null, CA.isOrdered = null, CA.dictionary = null, CA[Symbol.toStringTag] = "Dictionary"))(Dictionary.prototype);
function strideForType(CA) {
  const gA = CA;
  switch (CA.typeId) {
    case Type.Decimal:
      return CA.bitWidth / 32;
    case Type.Interval:
      return gA.unit === IntervalUnit.MONTH_DAY_NANO ? 4 : 1 + gA.unit;
    // case Type.Int: return 1 + +((t as Int_).bitWidth > 32);
    // case Type.Time: return 1 + +((t as Time_).bitWidth > 32);
    case Type.FixedSizeList:
      return gA.listSize;
    case Type.FixedSizeBinary:
      return gA.byteWidth;
    default:
      return 1;
  }
}
class Visitor {
  visitMany(gA, ...AA) {
    return gA.map((IA, BA) => this.visit(IA, ...AA.map((QA) => QA[BA])));
  }
  visit(...gA) {
    return this.getVisitFn(gA[0], !1).apply(this, gA);
  }
  getVisitFn(gA, AA = !0) {
    return getVisitFn(this, gA, AA);
  }
  getVisitFnByTypeId(gA, AA = !0) {
    return getVisitFnByTypeId(this, gA, AA);
  }
  visitNull(gA, ...AA) {
    return null;
  }
  visitBool(gA, ...AA) {
    return null;
  }
  visitInt(gA, ...AA) {
    return null;
  }
  visitFloat(gA, ...AA) {
    return null;
  }
  visitUtf8(gA, ...AA) {
    return null;
  }
  visitLargeUtf8(gA, ...AA) {
    return null;
  }
  visitBinary(gA, ...AA) {
    return null;
  }
  visitLargeBinary(gA, ...AA) {
    return null;
  }
  visitFixedSizeBinary(gA, ...AA) {
    return null;
  }
  visitDate(gA, ...AA) {
    return null;
  }
  visitTimestamp(gA, ...AA) {
    return null;
  }
  visitTime(gA, ...AA) {
    return null;
  }
  visitDecimal(gA, ...AA) {
    return null;
  }
  visitList(gA, ...AA) {
    return null;
  }
  visitStruct(gA, ...AA) {
    return null;
  }
  visitUnion(gA, ...AA) {
    return null;
  }
  visitDictionary(gA, ...AA) {
    return null;
  }
  visitInterval(gA, ...AA) {
    return null;
  }
  visitDuration(gA, ...AA) {
    return null;
  }
  visitFixedSizeList(gA, ...AA) {
    return null;
  }
  visitMap(gA, ...AA) {
    return null;
  }
}
function getVisitFn(CA, gA, AA = !0) {
  return typeof gA == "number" ? getVisitFnByTypeId(CA, gA, AA) : typeof gA == "string" && gA in Type ? getVisitFnByTypeId(CA, Type[gA], AA) : gA && gA instanceof DataType ? getVisitFnByTypeId(CA, inferDType(gA), AA) : gA?.type && gA.type instanceof DataType ? getVisitFnByTypeId(CA, inferDType(gA.type), AA) : getVisitFnByTypeId(CA, Type.NONE, AA);
}
function getVisitFnByTypeId(CA, gA, AA = !0) {
  let IA = null;
  switch (gA) {
    case Type.Null:
      IA = CA.visitNull;
      break;
    case Type.Bool:
      IA = CA.visitBool;
      break;
    case Type.Int:
      IA = CA.visitInt;
      break;
    case Type.Int8:
      IA = CA.visitInt8 || CA.visitInt;
      break;
    case Type.Int16:
      IA = CA.visitInt16 || CA.visitInt;
      break;
    case Type.Int32:
      IA = CA.visitInt32 || CA.visitInt;
      break;
    case Type.Int64:
      IA = CA.visitInt64 || CA.visitInt;
      break;
    case Type.Uint8:
      IA = CA.visitUint8 || CA.visitInt;
      break;
    case Type.Uint16:
      IA = CA.visitUint16 || CA.visitInt;
      break;
    case Type.Uint32:
      IA = CA.visitUint32 || CA.visitInt;
      break;
    case Type.Uint64:
      IA = CA.visitUint64 || CA.visitInt;
      break;
    case Type.Float:
      IA = CA.visitFloat;
      break;
    case Type.Float16:
      IA = CA.visitFloat16 || CA.visitFloat;
      break;
    case Type.Float32:
      IA = CA.visitFloat32 || CA.visitFloat;
      break;
    case Type.Float64:
      IA = CA.visitFloat64 || CA.visitFloat;
      break;
    case Type.Utf8:
      IA = CA.visitUtf8;
      break;
    case Type.LargeUtf8:
      IA = CA.visitLargeUtf8;
      break;
    case Type.Binary:
      IA = CA.visitBinary;
      break;
    case Type.LargeBinary:
      IA = CA.visitLargeBinary;
      break;
    case Type.FixedSizeBinary:
      IA = CA.visitFixedSizeBinary;
      break;
    case Type.Date:
      IA = CA.visitDate;
      break;
    case Type.DateDay:
      IA = CA.visitDateDay || CA.visitDate;
      break;
    case Type.DateMillisecond:
      IA = CA.visitDateMillisecond || CA.visitDate;
      break;
    case Type.Timestamp:
      IA = CA.visitTimestamp;
      break;
    case Type.TimestampSecond:
      IA = CA.visitTimestampSecond || CA.visitTimestamp;
      break;
    case Type.TimestampMillisecond:
      IA = CA.visitTimestampMillisecond || CA.visitTimestamp;
      break;
    case Type.TimestampMicrosecond:
      IA = CA.visitTimestampMicrosecond || CA.visitTimestamp;
      break;
    case Type.TimestampNanosecond:
      IA = CA.visitTimestampNanosecond || CA.visitTimestamp;
      break;
    case Type.Time:
      IA = CA.visitTime;
      break;
    case Type.TimeSecond:
      IA = CA.visitTimeSecond || CA.visitTime;
      break;
    case Type.TimeMillisecond:
      IA = CA.visitTimeMillisecond || CA.visitTime;
      break;
    case Type.TimeMicrosecond:
      IA = CA.visitTimeMicrosecond || CA.visitTime;
      break;
    case Type.TimeNanosecond:
      IA = CA.visitTimeNanosecond || CA.visitTime;
      break;
    case Type.Decimal:
      IA = CA.visitDecimal;
      break;
    case Type.List:
      IA = CA.visitList;
      break;
    case Type.Struct:
      IA = CA.visitStruct;
      break;
    case Type.Union:
      IA = CA.visitUnion;
      break;
    case Type.DenseUnion:
      IA = CA.visitDenseUnion || CA.visitUnion;
      break;
    case Type.SparseUnion:
      IA = CA.visitSparseUnion || CA.visitUnion;
      break;
    case Type.Dictionary:
      IA = CA.visitDictionary;
      break;
    case Type.Interval:
      IA = CA.visitInterval;
      break;
    case Type.IntervalDayTime:
      IA = CA.visitIntervalDayTime || CA.visitInterval;
      break;
    case Type.IntervalYearMonth:
      IA = CA.visitIntervalYearMonth || CA.visitInterval;
      break;
    case Type.IntervalMonthDayNano:
      IA = CA.visitIntervalMonthDayNano || CA.visitInterval;
      break;
    case Type.Duration:
      IA = CA.visitDuration;
      break;
    case Type.DurationSecond:
      IA = CA.visitDurationSecond || CA.visitDuration;
      break;
    case Type.DurationMillisecond:
      IA = CA.visitDurationMillisecond || CA.visitDuration;
      break;
    case Type.DurationMicrosecond:
      IA = CA.visitDurationMicrosecond || CA.visitDuration;
      break;
    case Type.DurationNanosecond:
      IA = CA.visitDurationNanosecond || CA.visitDuration;
      break;
    case Type.FixedSizeList:
      IA = CA.visitFixedSizeList;
      break;
    case Type.Map:
      IA = CA.visitMap;
      break;
  }
  if (typeof IA == "function")
    return IA;
  if (!AA)
    return () => null;
  throw new Error(`Unrecognized type '${Type[gA]}'`);
}
function inferDType(CA) {
  switch (CA.typeId) {
    case Type.Null:
      return Type.Null;
    case Type.Int: {
      const { bitWidth: gA, isSigned: AA } = CA;
      switch (gA) {
        case 8:
          return AA ? Type.Int8 : Type.Uint8;
        case 16:
          return AA ? Type.Int16 : Type.Uint16;
        case 32:
          return AA ? Type.Int32 : Type.Uint32;
        case 64:
          return AA ? Type.Int64 : Type.Uint64;
      }
      return Type.Int;
    }
    case Type.Float:
      switch (CA.precision) {
        case Precision.HALF:
          return Type.Float16;
        case Precision.SINGLE:
          return Type.Float32;
        case Precision.DOUBLE:
          return Type.Float64;
      }
      return Type.Float;
    case Type.Binary:
      return Type.Binary;
    case Type.LargeBinary:
      return Type.LargeBinary;
    case Type.Utf8:
      return Type.Utf8;
    case Type.LargeUtf8:
      return Type.LargeUtf8;
    case Type.Bool:
      return Type.Bool;
    case Type.Decimal:
      return Type.Decimal;
    case Type.Time:
      switch (CA.unit) {
        case TimeUnit.SECOND:
          return Type.TimeSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimeMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimeMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimeNanosecond;
      }
      return Type.Time;
    case Type.Timestamp:
      switch (CA.unit) {
        case TimeUnit.SECOND:
          return Type.TimestampSecond;
        case TimeUnit.MILLISECOND:
          return Type.TimestampMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.TimestampMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.TimestampNanosecond;
      }
      return Type.Timestamp;
    case Type.Date:
      switch (CA.unit) {
        case DateUnit.DAY:
          return Type.DateDay;
        case DateUnit.MILLISECOND:
          return Type.DateMillisecond;
      }
      return Type.Date;
    case Type.Interval:
      switch (CA.unit) {
        case IntervalUnit.DAY_TIME:
          return Type.IntervalDayTime;
        case IntervalUnit.YEAR_MONTH:
          return Type.IntervalYearMonth;
        case IntervalUnit.MONTH_DAY_NANO:
          return Type.IntervalMonthDayNano;
      }
      return Type.Interval;
    case Type.Duration:
      switch (CA.unit) {
        case TimeUnit.SECOND:
          return Type.DurationSecond;
        case TimeUnit.MILLISECOND:
          return Type.DurationMillisecond;
        case TimeUnit.MICROSECOND:
          return Type.DurationMicrosecond;
        case TimeUnit.NANOSECOND:
          return Type.DurationNanosecond;
      }
      return Type.Duration;
    case Type.Map:
      return Type.Map;
    case Type.List:
      return Type.List;
    case Type.Struct:
      return Type.Struct;
    case Type.Union:
      switch (CA.mode) {
        case UnionMode.Dense:
          return Type.DenseUnion;
        case UnionMode.Sparse:
          return Type.SparseUnion;
      }
      return Type.Union;
    case Type.FixedSizeBinary:
      return Type.FixedSizeBinary;
    case Type.FixedSizeList:
      return Type.FixedSizeList;
    case Type.Dictionary:
      return Type.Dictionary;
  }
  throw new Error(`Unrecognized type '${Type[CA.typeId]}'`);
}
Visitor.prototype.visitInt8 = null;
Visitor.prototype.visitInt16 = null;
Visitor.prototype.visitInt32 = null;
Visitor.prototype.visitInt64 = null;
Visitor.prototype.visitUint8 = null;
Visitor.prototype.visitUint16 = null;
Visitor.prototype.visitUint32 = null;
Visitor.prototype.visitUint64 = null;
Visitor.prototype.visitFloat16 = null;
Visitor.prototype.visitFloat32 = null;
Visitor.prototype.visitFloat64 = null;
Visitor.prototype.visitDateDay = null;
Visitor.prototype.visitDateMillisecond = null;
Visitor.prototype.visitTimestampSecond = null;
Visitor.prototype.visitTimestampMillisecond = null;
Visitor.prototype.visitTimestampMicrosecond = null;
Visitor.prototype.visitTimestampNanosecond = null;
Visitor.prototype.visitTimeSecond = null;
Visitor.prototype.visitTimeMillisecond = null;
Visitor.prototype.visitTimeMicrosecond = null;
Visitor.prototype.visitTimeNanosecond = null;
Visitor.prototype.visitDenseUnion = null;
Visitor.prototype.visitSparseUnion = null;
Visitor.prototype.visitIntervalDayTime = null;
Visitor.prototype.visitIntervalYearMonth = null;
Visitor.prototype.visitIntervalMonthDayNano = null;
Visitor.prototype.visitDuration = null;
Visitor.prototype.visitDurationSecond = null;
Visitor.prototype.visitDurationMillisecond = null;
Visitor.prototype.visitDurationMicrosecond = null;
Visitor.prototype.visitDurationNanosecond = null;
const f64 = new Float64Array(1), u32 = new Uint32Array(f64.buffer);
function uint16ToFloat64(CA) {
  const gA = (CA & 31744) >> 10, AA = (CA & 1023) / 1024, IA = Math.pow(-1, (CA & 32768) >> 15);
  switch (gA) {
    case 31:
      return IA * (AA ? Number.NaN : 1 / 0);
    case 0:
      return IA * (AA ? 6103515625e-14 * AA : 0);
  }
  return IA * Math.pow(2, gA - 15) * (1 + AA);
}
function float64ToUint16(CA) {
  if (CA !== CA)
    return 32256;
  f64[0] = CA;
  const gA = (u32[1] & 2147483648) >> 16 & 65535;
  let AA = u32[1] & 2146435072, IA = 0;
  return AA >= 1089470464 ? u32[0] > 0 ? AA = 31744 : (AA = (AA & 2080374784) >> 16, IA = (u32[1] & 1048575) >> 10) : AA <= 1056964608 ? (IA = 1048576 + (u32[1] & 1048575), IA = 1048576 + (IA << (AA >> 20) - 998) >> 21, AA = 0) : (AA = AA - 1056964608 >> 10, IA = (u32[1] & 1048575) + 512 >> 10), gA | AA | IA & 65535;
}
const util_math_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  float64ToUint16,
  uint16ToFloat64
}, Symbol.toStringTag, { value: "Module" }));
class SetVisitor extends Visitor {
}
function wrapSet(CA) {
  return (gA, AA, IA) => {
    if (gA.setValid(AA, IA != null))
      return CA(gA, AA, IA);
  };
}
const setEpochMsToDays = (CA, gA, AA) => {
  CA[gA] = Math.floor(AA / 864e5);
}, setVariableWidthBytes = (CA, gA, AA, IA) => {
  if (AA + 1 < gA.length) {
    const BA = bigIntToNumber(gA[AA]), QA = bigIntToNumber(gA[AA + 1]);
    CA.set(IA.subarray(0, QA - BA), BA);
  }
}, setBool$1 = ({ offset: CA, values: gA }, AA, IA) => {
  const BA = CA + AA;
  IA ? gA[BA >> 3] |= 1 << BA % 8 : gA[BA >> 3] &= ~(1 << BA % 8);
}, setInt = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setFloat = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setFloat16 = ({ values: CA }, gA, AA) => {
  CA[gA] = float64ToUint16(AA);
}, setAnyFloat = (CA, gA, AA) => {
  switch (CA.type.precision) {
    case Precision.HALF:
      return setFloat16(CA, gA, AA);
    case Precision.SINGLE:
    case Precision.DOUBLE:
      return setFloat(CA, gA, AA);
  }
}, setDateDay = ({ values: CA }, gA, AA) => {
  setEpochMsToDays(CA, gA, AA.valueOf());
}, setDateMillisecond = ({ values: CA }, gA, AA) => {
  CA[gA] = BigInt(AA);
}, setFixedSizeBinary = ({ stride: CA, values: gA }, AA, IA) => {
  gA.set(IA.subarray(0, CA), CA * AA);
}, setBinary = ({ values: CA, valueOffsets: gA }, AA, IA) => setVariableWidthBytes(CA, gA, AA, IA), setUtf8 = ({ values: CA, valueOffsets: gA }, AA, IA) => setVariableWidthBytes(CA, gA, AA, encodeUtf8(IA)), setDate = (CA, gA, AA) => {
  CA.type.unit === DateUnit.DAY ? setDateDay(CA, gA, AA) : setDateMillisecond(CA, gA, AA);
}, setTimestampSecond = ({ values: CA }, gA, AA) => {
  CA[gA] = BigInt(AA / 1e3);
}, setTimestampMillisecond = ({ values: CA }, gA, AA) => {
  CA[gA] = BigInt(AA);
}, setTimestampMicrosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = BigInt(AA * 1e3);
}, setTimestampNanosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = BigInt(AA * 1e6);
}, setTimestamp = (CA, gA, AA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return setTimestampSecond(CA, gA, AA);
    case TimeUnit.MILLISECOND:
      return setTimestampMillisecond(CA, gA, AA);
    case TimeUnit.MICROSECOND:
      return setTimestampMicrosecond(CA, gA, AA);
    case TimeUnit.NANOSECOND:
      return setTimestampNanosecond(CA, gA, AA);
  }
}, setTimeSecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setTimeMillisecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setTimeMicrosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setTimeNanosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setTime = (CA, gA, AA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return setTimeSecond(CA, gA, AA);
    case TimeUnit.MILLISECOND:
      return setTimeMillisecond(CA, gA, AA);
    case TimeUnit.MICROSECOND:
      return setTimeMicrosecond(CA, gA, AA);
    case TimeUnit.NANOSECOND:
      return setTimeNanosecond(CA, gA, AA);
  }
}, setDecimal = ({ values: CA, stride: gA }, AA, IA) => {
  CA.set(IA.subarray(0, gA), gA * AA);
}, setList = (CA, gA, AA) => {
  const IA = CA.children[0], BA = CA.valueOffsets, QA = instance$5.getVisitFn(IA);
  if (Array.isArray(AA))
    for (let EA = -1, iA = BA[gA], oA = BA[gA + 1]; iA < oA; )
      QA(IA, iA++, AA[++EA]);
  else
    for (let EA = -1, iA = BA[gA], oA = BA[gA + 1]; iA < oA; )
      QA(IA, iA++, AA.get(++EA));
}, setMap = (CA, gA, AA) => {
  const IA = CA.children[0], { valueOffsets: BA } = CA, QA = instance$5.getVisitFn(IA);
  let { [gA]: EA, [gA + 1]: iA } = BA;
  const oA = AA instanceof Map ? AA.entries() : Object.entries(AA);
  for (const cA of oA)
    if (QA(IA, EA, cA), ++EA >= iA)
      break;
}, _setStructArrayValue = (CA, gA) => (AA, IA, BA, QA) => IA && AA(IA, CA, gA[QA]), _setStructVectorValue = (CA, gA) => (AA, IA, BA, QA) => IA && AA(IA, CA, gA.get(QA)), _setStructMapValue = (CA, gA) => (AA, IA, BA, QA) => IA && AA(IA, CA, gA.get(BA.name)), _setStructObjectValue = (CA, gA) => (AA, IA, BA, QA) => IA && AA(IA, CA, gA[BA.name]), setStruct = (CA, gA, AA) => {
  const IA = CA.type.children.map((QA) => instance$5.getVisitFn(QA.type)), BA = AA instanceof Map ? _setStructMapValue(gA, AA) : AA instanceof Vector ? _setStructVectorValue(gA, AA) : Array.isArray(AA) ? _setStructArrayValue(gA, AA) : _setStructObjectValue(gA, AA);
  CA.type.children.forEach((QA, EA) => BA(IA[EA], CA.children[EA], QA, EA));
}, setUnion = (CA, gA, AA) => {
  CA.type.mode === UnionMode.Dense ? setDenseUnion(CA, gA, AA) : setSparseUnion(CA, gA, AA);
}, setDenseUnion = (CA, gA, AA) => {
  const IA = CA.type.typeIdToChildIndex[CA.typeIds[gA]], BA = CA.children[IA];
  instance$5.visit(BA, CA.valueOffsets[gA], AA);
}, setSparseUnion = (CA, gA, AA) => {
  const IA = CA.type.typeIdToChildIndex[CA.typeIds[gA]], BA = CA.children[IA];
  instance$5.visit(BA, gA, AA);
}, setDictionary = (CA, gA, AA) => {
  var IA;
  (IA = CA.dictionary) === null || IA === void 0 || IA.set(CA.values[gA], AA);
}, setIntervalValue = (CA, gA, AA) => {
  switch (CA.type.unit) {
    case IntervalUnit.YEAR_MONTH:
      return setIntervalYearMonth(CA, gA, AA);
    case IntervalUnit.DAY_TIME:
      return setIntervalDayTime(CA, gA, AA);
    case IntervalUnit.MONTH_DAY_NANO:
      return setIntervalMonthDayNano(CA, gA, AA);
  }
}, setIntervalDayTime = ({ values: CA }, gA, AA) => {
  CA.set(AA.subarray(0, 2), 2 * gA);
}, setIntervalYearMonth = ({ values: CA }, gA, AA) => {
  CA[gA] = AA[0] * 12 + AA[1] % 12;
}, setIntervalMonthDayNano = ({ values: CA, stride: gA }, AA, IA) => {
  CA.set(IA.subarray(0, gA), gA * AA);
}, setDurationSecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setDurationMillisecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setDurationMicrosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setDurationNanosecond = ({ values: CA }, gA, AA) => {
  CA[gA] = AA;
}, setDuration = (CA, gA, AA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return setDurationSecond(CA, gA, AA);
    case TimeUnit.MILLISECOND:
      return setDurationMillisecond(CA, gA, AA);
    case TimeUnit.MICROSECOND:
      return setDurationMicrosecond(CA, gA, AA);
    case TimeUnit.NANOSECOND:
      return setDurationNanosecond(CA, gA, AA);
  }
}, setFixedSizeList = (CA, gA, AA) => {
  const { stride: IA } = CA, BA = CA.children[0], QA = instance$5.getVisitFn(BA);
  if (Array.isArray(AA))
    for (let EA = -1, iA = gA * IA; ++EA < IA; )
      QA(BA, iA + EA, AA[EA]);
  else
    for (let EA = -1, iA = gA * IA; ++EA < IA; )
      QA(BA, iA + EA, AA.get(EA));
};
SetVisitor.prototype.visitBool = wrapSet(setBool$1);
SetVisitor.prototype.visitInt = wrapSet(setInt);
SetVisitor.prototype.visitInt8 = wrapSet(setInt);
SetVisitor.prototype.visitInt16 = wrapSet(setInt);
SetVisitor.prototype.visitInt32 = wrapSet(setInt);
SetVisitor.prototype.visitInt64 = wrapSet(setInt);
SetVisitor.prototype.visitUint8 = wrapSet(setInt);
SetVisitor.prototype.visitUint16 = wrapSet(setInt);
SetVisitor.prototype.visitUint32 = wrapSet(setInt);
SetVisitor.prototype.visitUint64 = wrapSet(setInt);
SetVisitor.prototype.visitFloat = wrapSet(setAnyFloat);
SetVisitor.prototype.visitFloat16 = wrapSet(setFloat16);
SetVisitor.prototype.visitFloat32 = wrapSet(setFloat);
SetVisitor.prototype.visitFloat64 = wrapSet(setFloat);
SetVisitor.prototype.visitUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitLargeUtf8 = wrapSet(setUtf8);
SetVisitor.prototype.visitBinary = wrapSet(setBinary);
SetVisitor.prototype.visitLargeBinary = wrapSet(setBinary);
SetVisitor.prototype.visitFixedSizeBinary = wrapSet(setFixedSizeBinary);
SetVisitor.prototype.visitDate = wrapSet(setDate);
SetVisitor.prototype.visitDateDay = wrapSet(setDateDay);
SetVisitor.prototype.visitDateMillisecond = wrapSet(setDateMillisecond);
SetVisitor.prototype.visitTimestamp = wrapSet(setTimestamp);
SetVisitor.prototype.visitTimestampSecond = wrapSet(setTimestampSecond);
SetVisitor.prototype.visitTimestampMillisecond = wrapSet(setTimestampMillisecond);
SetVisitor.prototype.visitTimestampMicrosecond = wrapSet(setTimestampMicrosecond);
SetVisitor.prototype.visitTimestampNanosecond = wrapSet(setTimestampNanosecond);
SetVisitor.prototype.visitTime = wrapSet(setTime);
SetVisitor.prototype.visitTimeSecond = wrapSet(setTimeSecond);
SetVisitor.prototype.visitTimeMillisecond = wrapSet(setTimeMillisecond);
SetVisitor.prototype.visitTimeMicrosecond = wrapSet(setTimeMicrosecond);
SetVisitor.prototype.visitTimeNanosecond = wrapSet(setTimeNanosecond);
SetVisitor.prototype.visitDecimal = wrapSet(setDecimal);
SetVisitor.prototype.visitList = wrapSet(setList);
SetVisitor.prototype.visitStruct = wrapSet(setStruct);
SetVisitor.prototype.visitUnion = wrapSet(setUnion);
SetVisitor.prototype.visitDenseUnion = wrapSet(setDenseUnion);
SetVisitor.prototype.visitSparseUnion = wrapSet(setSparseUnion);
SetVisitor.prototype.visitDictionary = wrapSet(setDictionary);
SetVisitor.prototype.visitInterval = wrapSet(setIntervalValue);
SetVisitor.prototype.visitIntervalDayTime = wrapSet(setIntervalDayTime);
SetVisitor.prototype.visitIntervalYearMonth = wrapSet(setIntervalYearMonth);
SetVisitor.prototype.visitIntervalMonthDayNano = wrapSet(setIntervalMonthDayNano);
SetVisitor.prototype.visitDuration = wrapSet(setDuration);
SetVisitor.prototype.visitDurationSecond = wrapSet(setDurationSecond);
SetVisitor.prototype.visitDurationMillisecond = wrapSet(setDurationMillisecond);
SetVisitor.prototype.visitDurationMicrosecond = wrapSet(setDurationMicrosecond);
SetVisitor.prototype.visitDurationNanosecond = wrapSet(setDurationNanosecond);
SetVisitor.prototype.visitFixedSizeList = wrapSet(setFixedSizeList);
SetVisitor.prototype.visitMap = wrapSet(setMap);
const instance$5 = new SetVisitor(), kParent = /* @__PURE__ */ Symbol.for("parent"), kRowIndex = /* @__PURE__ */ Symbol.for("rowIndex");
class StructRow {
  constructor(gA, AA) {
    return this[kParent] = gA, this[kRowIndex] = AA, new Proxy(this, structRowProxyHandler);
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const gA = this[kRowIndex], AA = this[kParent], IA = AA.type.children, BA = {};
    for (let QA = -1, EA = IA.length; ++QA < EA; )
      BA[IA[QA].name] = instance$4.visit(AA.children[QA], gA);
    return BA;
  }
  toString() {
    return `{${[...this].map(([gA, AA]) => `${valueToString(gA)}: ${valueToString(AA)}`).join(", ")}}`;
  }
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
  [Symbol.iterator]() {
    return new StructRowIterator(this[kParent], this[kRowIndex]);
  }
}
class StructRowIterator {
  constructor(gA, AA) {
    this.childIndex = 0, this.children = gA.children, this.rowIndex = AA, this.childFields = gA.type.children, this.numChildren = this.childFields.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const gA = this.childIndex;
    return gA < this.numChildren ? (this.childIndex = gA + 1, {
      done: !1,
      value: [
        this.childFields[gA].name,
        instance$4.visit(this.children[gA], this.rowIndex)
      ]
    }) : { done: !0, value: null };
  }
}
Object.defineProperties(StructRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kParent]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kRowIndex]: { writable: !0, enumerable: !1, configurable: !1, value: -1 }
});
class StructRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(gA) {
    return gA[kParent].type.children.map((AA) => AA.name);
  }
  has(gA, AA) {
    return gA[kParent].type.children.some((IA) => IA.name === AA);
  }
  getOwnPropertyDescriptor(gA, AA) {
    if (gA[kParent].type.children.some((IA) => IA.name === AA))
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(gA, AA) {
    if (Reflect.has(gA, AA))
      return gA[AA];
    const IA = gA[kParent].type.children.findIndex((BA) => BA.name === AA);
    if (IA !== -1) {
      const BA = instance$4.visit(gA[kParent].children[IA], gA[kRowIndex]);
      return Reflect.set(gA, AA, BA), BA;
    }
  }
  set(gA, AA, IA) {
    const BA = gA[kParent].type.children.findIndex((QA) => QA.name === AA);
    return BA !== -1 ? (instance$5.visit(gA[kParent].children[BA], gA[kRowIndex], IA), Reflect.set(gA, AA, IA)) : Reflect.has(gA, AA) || typeof AA == "symbol" ? Reflect.set(gA, AA, IA) : !1;
  }
}
const structRowProxyHandler = new StructRowProxyHandler();
class GetVisitor extends Visitor {
}
function wrapGet(CA) {
  return (gA, AA) => gA.getValid(AA) ? CA(gA, AA) : null;
}
const epochDaysToMs = (CA, gA) => 864e5 * CA[gA], getNull = (CA, gA) => null, getVariableWidthBytes = (CA, gA, AA) => {
  if (AA + 1 >= gA.length)
    return null;
  const IA = bigIntToNumber(gA[AA]), BA = bigIntToNumber(gA[AA + 1]);
  return CA.subarray(IA, BA);
}, getBool$1 = ({ offset: CA, values: gA }, AA) => {
  const IA = CA + AA;
  return (gA[IA >> 3] & 1 << IA % 8) !== 0;
}, getDateDay = ({ values: CA }, gA) => epochDaysToMs(CA, gA), getDateMillisecond = ({ values: CA }, gA) => bigIntToNumber(CA[gA]), getNumeric = ({ stride: CA, values: gA }, AA) => gA[CA * AA], getFloat16 = ({ stride: CA, values: gA }, AA) => uint16ToFloat64(gA[CA * AA]), getBigInts = ({ values: CA }, gA) => CA[gA], getFixedSizeBinary = ({ stride: CA, values: gA }, AA) => gA.subarray(CA * AA, CA * (AA + 1)), getBinary = ({ values: CA, valueOffsets: gA }, AA) => getVariableWidthBytes(CA, gA, AA), getUtf8 = ({ values: CA, valueOffsets: gA }, AA) => {
  const IA = getVariableWidthBytes(CA, gA, AA);
  return IA !== null ? decodeUtf8(IA) : null;
}, getInt = ({ values: CA }, gA) => CA[gA], getFloat = ({ type: CA, values: gA }, AA) => CA.precision !== Precision.HALF ? gA[AA] : uint16ToFloat64(gA[AA]), getDate = (CA, gA) => CA.type.unit === DateUnit.DAY ? getDateDay(CA, gA) : getDateMillisecond(CA, gA), getTimestampSecond = ({ values: CA }, gA) => 1e3 * bigIntToNumber(CA[gA]), getTimestampMillisecond = ({ values: CA }, gA) => bigIntToNumber(CA[gA]), getTimestampMicrosecond = ({ values: CA }, gA) => divideBigInts(CA[gA], BigInt(1e3)), getTimestampNanosecond = ({ values: CA }, gA) => divideBigInts(CA[gA], BigInt(1e6)), getTimestamp = (CA, gA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return getTimestampSecond(CA, gA);
    case TimeUnit.MILLISECOND:
      return getTimestampMillisecond(CA, gA);
    case TimeUnit.MICROSECOND:
      return getTimestampMicrosecond(CA, gA);
    case TimeUnit.NANOSECOND:
      return getTimestampNanosecond(CA, gA);
  }
}, getTimeSecond = ({ values: CA }, gA) => CA[gA], getTimeMillisecond = ({ values: CA }, gA) => CA[gA], getTimeMicrosecond = ({ values: CA }, gA) => CA[gA], getTimeNanosecond = ({ values: CA }, gA) => CA[gA], getTime = (CA, gA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return getTimeSecond(CA, gA);
    case TimeUnit.MILLISECOND:
      return getTimeMillisecond(CA, gA);
    case TimeUnit.MICROSECOND:
      return getTimeMicrosecond(CA, gA);
    case TimeUnit.NANOSECOND:
      return getTimeNanosecond(CA, gA);
  }
}, getDecimal = ({ values: CA, stride: gA }, AA) => BN.decimal(CA.subarray(gA * AA, gA * (AA + 1))), getList = (CA, gA) => {
  const { valueOffsets: AA, stride: IA, children: BA } = CA, { [gA * IA]: QA, [gA * IA + 1]: EA } = AA, oA = BA[0].slice(QA, EA - QA);
  return new Vector([oA]);
}, getMap = (CA, gA) => {
  const { valueOffsets: AA, children: IA } = CA, { [gA]: BA, [gA + 1]: QA } = AA, EA = IA[0];
  return new MapRow(EA.slice(BA, QA - BA));
}, getStruct = (CA, gA) => new StructRow(CA, gA), getUnion = (CA, gA) => CA.type.mode === UnionMode.Dense ? getDenseUnion(CA, gA) : getSparseUnion(CA, gA), getDenseUnion = (CA, gA) => {
  const AA = CA.type.typeIdToChildIndex[CA.typeIds[gA]], IA = CA.children[AA];
  return instance$4.visit(IA, CA.valueOffsets[gA]);
}, getSparseUnion = (CA, gA) => {
  const AA = CA.type.typeIdToChildIndex[CA.typeIds[gA]], IA = CA.children[AA];
  return instance$4.visit(IA, gA);
}, getDictionary = (CA, gA) => {
  var AA;
  return (AA = CA.dictionary) === null || AA === void 0 ? void 0 : AA.get(CA.values[gA]);
}, getInterval = (CA, gA) => CA.type.unit === IntervalUnit.MONTH_DAY_NANO ? getIntervalMonthDayNano(CA, gA) : CA.type.unit === IntervalUnit.DAY_TIME ? getIntervalDayTime(CA, gA) : getIntervalYearMonth(CA, gA), getIntervalDayTime = ({ values: CA }, gA) => CA.subarray(2 * gA, 2 * (gA + 1)), getIntervalYearMonth = ({ values: CA }, gA) => {
  const AA = CA[gA], IA = new Int32Array(2);
  return IA[0] = Math.trunc(AA / 12), IA[1] = Math.trunc(AA % 12), IA;
}, getIntervalMonthDayNano = ({ values: CA }, gA) => CA.subarray(4 * gA, 4 * (gA + 1)), getDurationSecond = ({ values: CA }, gA) => CA[gA], getDurationMillisecond = ({ values: CA }, gA) => CA[gA], getDurationMicrosecond = ({ values: CA }, gA) => CA[gA], getDurationNanosecond = ({ values: CA }, gA) => CA[gA], getDuration = (CA, gA) => {
  switch (CA.type.unit) {
    case TimeUnit.SECOND:
      return getDurationSecond(CA, gA);
    case TimeUnit.MILLISECOND:
      return getDurationMillisecond(CA, gA);
    case TimeUnit.MICROSECOND:
      return getDurationMicrosecond(CA, gA);
    case TimeUnit.NANOSECOND:
      return getDurationNanosecond(CA, gA);
  }
}, getFixedSizeList = (CA, gA) => {
  const { stride: AA, children: IA } = CA, QA = IA[0].slice(gA * AA, AA);
  return new Vector([QA]);
};
GetVisitor.prototype.visitNull = wrapGet(getNull);
GetVisitor.prototype.visitBool = wrapGet(getBool$1);
GetVisitor.prototype.visitInt = wrapGet(getInt);
GetVisitor.prototype.visitInt8 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt16 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt32 = wrapGet(getNumeric);
GetVisitor.prototype.visitInt64 = wrapGet(getBigInts);
GetVisitor.prototype.visitUint8 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint16 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint32 = wrapGet(getNumeric);
GetVisitor.prototype.visitUint64 = wrapGet(getBigInts);
GetVisitor.prototype.visitFloat = wrapGet(getFloat);
GetVisitor.prototype.visitFloat16 = wrapGet(getFloat16);
GetVisitor.prototype.visitFloat32 = wrapGet(getNumeric);
GetVisitor.prototype.visitFloat64 = wrapGet(getNumeric);
GetVisitor.prototype.visitUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitLargeUtf8 = wrapGet(getUtf8);
GetVisitor.prototype.visitBinary = wrapGet(getBinary);
GetVisitor.prototype.visitLargeBinary = wrapGet(getBinary);
GetVisitor.prototype.visitFixedSizeBinary = wrapGet(getFixedSizeBinary);
GetVisitor.prototype.visitDate = wrapGet(getDate);
GetVisitor.prototype.visitDateDay = wrapGet(getDateDay);
GetVisitor.prototype.visitDateMillisecond = wrapGet(getDateMillisecond);
GetVisitor.prototype.visitTimestamp = wrapGet(getTimestamp);
GetVisitor.prototype.visitTimestampSecond = wrapGet(getTimestampSecond);
GetVisitor.prototype.visitTimestampMillisecond = wrapGet(getTimestampMillisecond);
GetVisitor.prototype.visitTimestampMicrosecond = wrapGet(getTimestampMicrosecond);
GetVisitor.prototype.visitTimestampNanosecond = wrapGet(getTimestampNanosecond);
GetVisitor.prototype.visitTime = wrapGet(getTime);
GetVisitor.prototype.visitTimeSecond = wrapGet(getTimeSecond);
GetVisitor.prototype.visitTimeMillisecond = wrapGet(getTimeMillisecond);
GetVisitor.prototype.visitTimeMicrosecond = wrapGet(getTimeMicrosecond);
GetVisitor.prototype.visitTimeNanosecond = wrapGet(getTimeNanosecond);
GetVisitor.prototype.visitDecimal = wrapGet(getDecimal);
GetVisitor.prototype.visitList = wrapGet(getList);
GetVisitor.prototype.visitStruct = wrapGet(getStruct);
GetVisitor.prototype.visitUnion = wrapGet(getUnion);
GetVisitor.prototype.visitDenseUnion = wrapGet(getDenseUnion);
GetVisitor.prototype.visitSparseUnion = wrapGet(getSparseUnion);
GetVisitor.prototype.visitDictionary = wrapGet(getDictionary);
GetVisitor.prototype.visitInterval = wrapGet(getInterval);
GetVisitor.prototype.visitIntervalDayTime = wrapGet(getIntervalDayTime);
GetVisitor.prototype.visitIntervalYearMonth = wrapGet(getIntervalYearMonth);
GetVisitor.prototype.visitIntervalMonthDayNano = wrapGet(getIntervalMonthDayNano);
GetVisitor.prototype.visitDuration = wrapGet(getDuration);
GetVisitor.prototype.visitDurationSecond = wrapGet(getDurationSecond);
GetVisitor.prototype.visitDurationMillisecond = wrapGet(getDurationMillisecond);
GetVisitor.prototype.visitDurationMicrosecond = wrapGet(getDurationMicrosecond);
GetVisitor.prototype.visitDurationNanosecond = wrapGet(getDurationNanosecond);
GetVisitor.prototype.visitFixedSizeList = wrapGet(getFixedSizeList);
GetVisitor.prototype.visitMap = wrapGet(getMap);
const instance$4 = new GetVisitor(), kKeys = /* @__PURE__ */ Symbol.for("keys"), kVals = /* @__PURE__ */ Symbol.for("vals"), kKeysAsStrings = /* @__PURE__ */ Symbol.for("kKeysAsStrings"), _kKeysAsStrings = /* @__PURE__ */ Symbol.for("_kKeysAsStrings");
class MapRow {
  constructor(gA) {
    return this[kKeys] = new Vector([gA.children[0]]).memoize(), this[kVals] = gA.children[1], new Proxy(this, new MapRowProxyHandler());
  }
  /** @ignore */
  get [kKeysAsStrings]() {
    return this[_kKeysAsStrings] || (this[_kKeysAsStrings] = Array.from(this[kKeys].toArray(), String));
  }
  [Symbol.iterator]() {
    return new MapRowIterator(this[kKeys], this[kVals]);
  }
  get size() {
    return this[kKeys].length;
  }
  toArray() {
    return Object.values(this.toJSON());
  }
  toJSON() {
    const gA = this[kKeys], AA = this[kVals], IA = {};
    for (let BA = -1, QA = gA.length; ++BA < QA; )
      IA[gA.get(BA)] = instance$4.visit(AA, BA);
    return IA;
  }
  toString() {
    return `{${[...this].map(([gA, AA]) => `${valueToString(gA)}: ${valueToString(AA)}`).join(", ")}}`;
  }
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return this.toString();
  }
}
class MapRowIterator {
  constructor(gA, AA) {
    this.keys = gA, this.vals = AA, this.keyIndex = 0, this.numKeys = gA.length;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    const gA = this.keyIndex;
    return gA === this.numKeys ? { done: !0, value: null } : (this.keyIndex++, {
      done: !1,
      value: [
        this.keys.get(gA),
        instance$4.visit(this.vals, gA)
      ]
    });
  }
}
class MapRowProxyHandler {
  isExtensible() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !0;
  }
  ownKeys(gA) {
    return gA[kKeysAsStrings];
  }
  has(gA, AA) {
    return gA[kKeysAsStrings].includes(AA);
  }
  getOwnPropertyDescriptor(gA, AA) {
    if (gA[kKeysAsStrings].indexOf(AA) !== -1)
      return { writable: !0, enumerable: !0, configurable: !0 };
  }
  get(gA, AA) {
    if (Reflect.has(gA, AA))
      return gA[AA];
    const IA = gA[kKeysAsStrings].indexOf(AA);
    if (IA !== -1) {
      const BA = instance$4.visit(Reflect.get(gA, kVals), IA);
      return Reflect.set(gA, AA, BA), BA;
    }
  }
  set(gA, AA, IA) {
    const BA = gA[kKeysAsStrings].indexOf(AA);
    return BA !== -1 ? (instance$5.visit(Reflect.get(gA, kVals), BA, IA), Reflect.set(gA, AA, IA)) : Reflect.has(gA, AA) ? Reflect.set(gA, AA, IA) : !1;
  }
}
Object.defineProperties(MapRow.prototype, {
  [Symbol.toStringTag]: { enumerable: !1, configurable: !1, value: "Row" },
  [kKeys]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [kVals]: { writable: !0, enumerable: !1, configurable: !1, value: null },
  [_kKeysAsStrings]: { writable: !0, enumerable: !1, configurable: !1, value: null }
});
let tmp;
function clampRange(CA, gA, AA, IA) {
  const { length: BA = 0 } = CA;
  let QA = typeof gA != "number" ? 0 : gA, EA = typeof AA != "number" ? BA : AA;
  return QA < 0 && (QA = (QA % BA + BA) % BA), EA < 0 && (EA = (EA % BA + BA) % BA), EA < QA && (tmp = QA, QA = EA, EA = tmp), EA > BA && (EA = BA), IA ? IA(CA, QA, EA) : [QA, EA];
}
const wrapIndex = (CA, gA) => CA < 0 ? gA + CA : CA, isNaNFast = (CA) => CA !== CA;
function createElementComparator(CA) {
  if (typeof CA !== "object" || CA === null)
    return isNaNFast(CA) ? isNaNFast : (AA) => AA === CA;
  if (CA instanceof Date) {
    const AA = CA.valueOf();
    return (IA) => IA instanceof Date ? IA.valueOf() === AA : !1;
  }
  return ArrayBuffer.isView(CA) ? (AA) => AA ? compareArrayLike(CA, AA) : !1 : CA instanceof Map ? createMapComparator(CA) : Array.isArray(CA) ? createArrayLikeComparator(CA) : CA instanceof Vector ? createVectorComparator(CA) : createObjectComparator(CA, !0);
}
function createArrayLikeComparator(CA) {
  const gA = [];
  for (let AA = -1, IA = CA.length; ++AA < IA; )
    gA[AA] = createElementComparator(CA[AA]);
  return createSubElementsComparator(gA);
}
function createMapComparator(CA) {
  let gA = -1;
  const AA = [];
  for (const IA of CA.values())
    AA[++gA] = createElementComparator(IA);
  return createSubElementsComparator(AA);
}
function createVectorComparator(CA) {
  const gA = [];
  for (let AA = -1, IA = CA.length; ++AA < IA; )
    gA[AA] = createElementComparator(CA.get(AA));
  return createSubElementsComparator(gA);
}
function createObjectComparator(CA, gA = !1) {
  const AA = Object.keys(CA);
  if (!gA && AA.length === 0)
    return () => !1;
  const IA = [];
  for (let BA = -1, QA = AA.length; ++BA < QA; )
    IA[BA] = createElementComparator(CA[AA[BA]]);
  return createSubElementsComparator(IA, AA);
}
function createSubElementsComparator(CA, gA) {
  return (AA) => {
    if (!AA || typeof AA != "object")
      return !1;
    switch (AA.constructor) {
      case Array:
        return compareArray$1(CA, AA);
      case Map:
        return compareObject(CA, AA, AA.keys());
      case MapRow:
      case StructRow:
      case Object:
      case void 0:
        return compareObject(CA, AA, gA || Object.keys(AA));
    }
    return AA instanceof Vector ? compareVector(CA, AA) : !1;
  };
}
function compareArray$1(CA, gA) {
  const AA = CA.length;
  if (gA.length !== AA)
    return !1;
  for (let IA = -1; ++IA < AA; )
    if (!CA[IA](gA[IA]))
      return !1;
  return !0;
}
function compareVector(CA, gA) {
  const AA = CA.length;
  if (gA.length !== AA)
    return !1;
  for (let IA = -1; ++IA < AA; )
    if (!CA[IA](gA.get(IA)))
      return !1;
  return !0;
}
function compareObject(CA, gA, AA) {
  const IA = AA[Symbol.iterator](), BA = gA instanceof Map ? gA.keys() : Object.keys(gA)[Symbol.iterator](), QA = gA instanceof Map ? gA.values() : Object.values(gA)[Symbol.iterator]();
  let EA = 0;
  const iA = CA.length;
  let oA = QA.next(), cA = IA.next(), tA = BA.next();
  for (; EA < iA && !cA.done && !tA.done && !oA.done && !(cA.value !== tA.value || !CA[EA](oA.value)); ++EA, cA = IA.next(), tA = BA.next(), oA = QA.next())
    ;
  return EA === iA && cA.done && tA.done && oA.done ? !0 : (IA.return && IA.return(), BA.return && BA.return(), QA.return && QA.return(), !1);
}
const util_vector_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clampRange,
  createElementComparator,
  wrapIndex
}, Symbol.toStringTag, { value: "Module" }));
function getBool(CA, gA, AA, IA) {
  return (AA & 1 << IA) !== 0;
}
function getBit(CA, gA, AA, IA) {
  return (AA & 1 << IA) >> IA;
}
function setBool(CA, gA, AA) {
  return AA ? !!(CA[gA >> 3] |= 1 << gA % 8) || !0 : !(CA[gA >> 3] &= ~(1 << gA % 8)) && !1;
}
function truncateBitmap(CA, gA, AA) {
  const IA = AA.byteLength + 7 & -8;
  if (CA > 0 || AA.byteLength < IA) {
    const BA = new Uint8Array(IA);
    return BA.set(CA % 8 === 0 ? AA.subarray(CA >> 3) : (
      // Otherwise iterate each bit from the offset and return a new one
      packBools(new BitIterator(AA, CA, gA, null, getBool)).subarray(0, IA)
    )), BA;
  }
  return AA;
}
function packBools(CA) {
  const gA = [];
  let AA = 0, IA = 0, BA = 0;
  for (const EA of CA)
    EA && (BA |= 1 << IA), ++IA === 8 && (gA[AA++] = BA, BA = IA = 0);
  (AA === 0 || IA > 0) && (gA[AA++] = BA);
  const QA = new Uint8Array(gA.length + 7 & -8);
  return QA.set(gA), QA;
}
class BitIterator {
  constructor(gA, AA, IA, BA, QA) {
    this.bytes = gA, this.length = IA, this.context = BA, this.get = QA, this.bit = AA % 8, this.byteIndex = AA >> 3, this.byte = gA[this.byteIndex++], this.index = 0;
  }
  next() {
    return this.index < this.length ? (this.bit === 8 && (this.bit = 0, this.byte = this.bytes[this.byteIndex++]), {
      value: this.get(this.context, this.index++, this.byte, this.bit++)
    }) : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function popcnt_bit_range(CA, gA, AA) {
  if (AA - gA <= 0)
    return 0;
  if (AA - gA < 8) {
    let QA = 0;
    for (const EA of new BitIterator(CA, gA, AA - gA, CA, getBit))
      QA += EA;
    return QA;
  }
  const IA = AA >> 3 << 3, BA = gA + (gA % 8 === 0 ? 0 : 8 - gA % 8);
  return (
    // Get the popcnt of bits between the left hand side, and the next highest multiple of 8
    popcnt_bit_range(CA, gA, BA) + // Get the popcnt of bits between the right hand side, and the next lowest multiple of 8
    popcnt_bit_range(CA, IA, AA) + // Get the popcnt of all bits between the left and right hand sides' multiples of 8
    popcnt_array(CA, BA >> 3, IA - BA >> 3)
  );
}
function popcnt_array(CA, gA, AA) {
  let IA = 0, BA = Math.trunc(gA);
  const QA = new DataView(CA.buffer, CA.byteOffset, CA.byteLength), EA = AA === void 0 ? CA.byteLength : BA + AA;
  for (; EA - BA >= 4; )
    IA += popcnt_uint32(QA.getUint32(BA)), BA += 4;
  for (; EA - BA >= 2; )
    IA += popcnt_uint32(QA.getUint16(BA)), BA += 2;
  for (; EA - BA >= 1; )
    IA += popcnt_uint32(QA.getUint8(BA)), BA += 1;
  return IA;
}
function popcnt_uint32(CA) {
  let gA = Math.trunc(CA);
  return gA = gA - (gA >>> 1 & 1431655765), gA = (gA & 858993459) + (gA >>> 2 & 858993459), (gA + (gA >>> 4) & 252645135) * 16843009 >>> 24;
}
const util_bit_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BitIterator,
  getBit,
  getBool,
  packBools,
  popcnt_array,
  popcnt_bit_range,
  popcnt_uint32,
  setBool,
  truncateBitmap
}, Symbol.toStringTag, { value: "Module" })), kUnknownNullCount = -1;
class Data {
  get typeId() {
    return this.type.typeId;
  }
  get ArrayType() {
    return this.type.ArrayType;
  }
  get buffers() {
    return [this.valueOffsets, this.values, this.nullBitmap, this.typeIds];
  }
  get nullable() {
    if (this._nullCount !== 0) {
      const { type: gA } = this;
      return DataType.isSparseUnion(gA) ? this.children.some((AA) => AA.nullable) : DataType.isDenseUnion(gA) ? this.children.some((AA) => AA.nullable) : this.nullBitmap && this.nullBitmap.byteLength > 0;
    }
    return !0;
  }
  get byteLength() {
    let gA = 0;
    const { valueOffsets: AA, values: IA, nullBitmap: BA, typeIds: QA } = this;
    return AA && (gA += AA.byteLength), IA && (gA += IA.byteLength), BA && (gA += BA.byteLength), QA && (gA += QA.byteLength), this.children.reduce((EA, iA) => EA + iA.byteLength, gA);
  }
  get nullCount() {
    if (DataType.isUnion(this.type))
      return this.children.reduce((IA, BA) => IA + BA.nullCount, 0);
    let gA = this._nullCount, AA;
    return gA <= kUnknownNullCount && (AA = this.nullBitmap) && (this._nullCount = gA = AA.length === 0 ? (
      // no null bitmap, so all values are valid
      0
    ) : this.length - popcnt_bit_range(AA, this.offset, this.offset + this.length)), gA;
  }
  constructor(gA, AA, IA, BA, QA, EA = [], iA) {
    this.type = gA, this.children = EA, this.dictionary = iA, this.offset = Math.floor(Math.max(AA || 0, 0)), this.length = Math.floor(Math.max(IA || 0, 0)), this._nullCount = Math.floor(Math.max(BA || 0, -1));
    let oA;
    QA instanceof Data ? (this.stride = QA.stride, this.values = QA.values, this.typeIds = QA.typeIds, this.nullBitmap = QA.nullBitmap, this.valueOffsets = QA.valueOffsets) : (this.stride = strideForType(gA), QA && ((oA = QA[0]) && (this.valueOffsets = oA), (oA = QA[1]) && (this.values = oA), (oA = QA[2]) && (this.nullBitmap = oA), (oA = QA[3]) && (this.typeIds = oA)));
  }
  getValid(gA) {
    const { type: AA } = this;
    if (DataType.isUnion(AA)) {
      const IA = AA, BA = this.children[IA.typeIdToChildIndex[this.typeIds[gA]]], QA = IA.mode === UnionMode.Dense ? this.valueOffsets[gA] : gA;
      return BA.getValid(QA);
    }
    if (this.nullable && this.nullCount > 0) {
      const IA = this.offset + gA;
      return (this.nullBitmap[IA >> 3] & 1 << IA % 8) !== 0;
    }
    return !0;
  }
  setValid(gA, AA) {
    let IA;
    const { type: BA } = this;
    if (DataType.isUnion(BA)) {
      const QA = BA, EA = this.children[QA.typeIdToChildIndex[this.typeIds[gA]]], iA = QA.mode === UnionMode.Dense ? this.valueOffsets[gA] : gA;
      IA = EA.getValid(iA), EA.setValid(iA, AA);
    } else {
      let { nullBitmap: QA } = this;
      const { offset: EA, length: iA } = this, oA = EA + gA, cA = 1 << oA % 8, tA = oA >> 3;
      (!QA || QA.byteLength <= tA) && (QA = new Uint8Array((EA + iA + 63 & -64) >> 3).fill(255), this.nullCount > 0 ? (QA.set(truncateBitmap(EA, iA, this.nullBitmap), 0), Object.assign(this, { nullBitmap: QA })) : Object.assign(this, { nullBitmap: QA, _nullCount: 0 }));
      const eA = QA[tA];
      IA = (eA & cA) !== 0, QA[tA] = AA ? eA | cA : eA & ~cA;
    }
    return IA !== !!AA && (this._nullCount = this.nullCount + (AA ? -1 : 1)), AA;
  }
  clone(gA = this.type, AA = this.offset, IA = this.length, BA = this._nullCount, QA = this, EA = this.children) {
    return new Data(gA, AA, IA, BA, QA, EA, this.dictionary);
  }
  slice(gA, AA) {
    const { stride: IA, typeId: BA, children: QA } = this, EA = +(this._nullCount === 0) - 1, iA = BA === 16 ? IA : 1, oA = this._sliceBuffers(gA, AA, IA, BA);
    return this.clone(
      this.type,
      this.offset + gA,
      AA,
      EA,
      oA,
      // Don't slice children if we have value offsets (the variable-width types)
      QA.length === 0 || this.valueOffsets ? QA : this._sliceChildren(QA, iA * gA, iA * AA)
    );
  }
  _changeLengthAndBackfillNullBitmap(gA) {
    if (this.typeId === Type.Null)
      return this.clone(this.type, 0, gA, 0);
    const { length: AA, nullCount: IA } = this, BA = new Uint8Array((gA + 63 & -64) >> 3).fill(255, 0, AA >> 3);
    BA[AA >> 3] = (1 << AA - (AA & -8)) - 1, IA > 0 && BA.set(truncateBitmap(this.offset, AA, this.nullBitmap), 0);
    const QA = this.buffers;
    return QA[BufferType.VALIDITY] = BA, this.clone(this.type, 0, gA, IA + (gA - AA), QA);
  }
  _sliceBuffers(gA, AA, IA, BA) {
    let QA;
    const { buffers: EA } = this;
    return (QA = EA[BufferType.TYPE]) && (EA[BufferType.TYPE] = QA.subarray(gA, gA + AA)), (QA = EA[BufferType.OFFSET]) && (EA[BufferType.OFFSET] = QA.subarray(gA, gA + AA + 1)) || // Otherwise if no offsets, slice the data buffer. Don't slice the data vector for Booleans, since the offset goes by bits not bytes
    (QA = EA[BufferType.DATA]) && (EA[BufferType.DATA] = BA === 6 ? QA : QA.subarray(IA * gA, IA * (gA + AA))), EA;
  }
  _sliceChildren(gA, AA, IA) {
    return gA.map((BA) => BA.slice(AA, IA));
  }
}
Data.prototype.children = Object.freeze([]);
class MakeDataVisitor extends Visitor {
  visit(gA) {
    return this.getVisitFn(gA.type).call(this, gA);
  }
  visitNull(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["length"]: BA = 0 } = gA;
    return new Data(AA, IA, BA, BA);
  }
  visitBool(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length >> 3, ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitInt(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length, ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitFloat(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length, ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitUtf8(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.data), QA = toUint8Array(gA.nullBitmap), EA = toInt32Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, BA, QA]);
  }
  visitLargeUtf8(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.data), QA = toUint8Array(gA.nullBitmap), EA = toBigInt64Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, BA, QA]);
  }
  visitBinary(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.data), QA = toUint8Array(gA.nullBitmap), EA = toInt32Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, BA, QA]);
  }
  visitLargeBinary(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.data), QA = toUint8Array(gA.nullBitmap), EA = toBigInt64Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, BA, QA]);
  }
  visitFixedSizeBinary(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitDate(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitTimestamp(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitTime(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitDecimal(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitList(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["child"]: BA } = gA, QA = toUint8Array(gA.nullBitmap), EA = toInt32Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, void 0, QA], [BA]);
  }
  visitStruct(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["children"]: BA = [] } = gA, QA = toUint8Array(gA.nullBitmap), { length: EA = BA.reduce((oA, { length: cA }) => Math.max(oA, cA), 0), nullCount: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, void 0, QA], BA);
  }
  visitUnion(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["children"]: BA = [] } = gA, QA = toArrayBufferView(AA.ArrayType, gA.typeIds), { ["length"]: EA = QA.length, ["nullCount"]: iA = -1 } = gA;
    if (DataType.isSparseUnion(AA))
      return new Data(AA, IA, EA, iA, [void 0, void 0, void 0, QA], BA);
    const oA = toInt32Array(gA.valueOffsets);
    return new Data(AA, IA, EA, iA, [oA, void 0, void 0, QA], BA);
  }
  visitDictionary(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.indices.ArrayType, gA.data), { ["dictionary"]: EA = new Vector([new MakeDataVisitor().visit({ type: AA.dictionary })]) } = gA, { ["length"]: iA = QA.length, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [void 0, QA, BA], [], EA);
  }
  visitInterval(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitDuration(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0 } = gA, BA = toUint8Array(gA.nullBitmap), QA = toArrayBufferView(AA.ArrayType, gA.data), { ["length"]: EA = QA.length, ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, QA, BA]);
  }
  visitFixedSizeList(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["child"]: BA = new MakeDataVisitor().visit({ type: AA.valueType }) } = gA, QA = toUint8Array(gA.nullBitmap), { ["length"]: EA = BA.length / strideForType(AA), ["nullCount"]: iA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, EA, iA, [void 0, void 0, QA], [BA]);
  }
  visitMap(gA) {
    const { ["type"]: AA, ["offset"]: IA = 0, ["child"]: BA = new MakeDataVisitor().visit({ type: AA.childType }) } = gA, QA = toUint8Array(gA.nullBitmap), EA = toInt32Array(gA.valueOffsets), { ["length"]: iA = EA.length - 1, ["nullCount"]: oA = gA.nullBitmap ? -1 : 0 } = gA;
    return new Data(AA, IA, iA, oA, [EA, void 0, QA], [BA]);
  }
}
const makeDataVisitor = new MakeDataVisitor();
function makeData(CA) {
  return makeDataVisitor.visit(CA);
}
class ChunkedIterator {
  constructor(gA = 0, AA) {
    this.numChunks = gA, this.getChunkIterator = AA, this.chunkIndex = 0, this.chunkIterator = this.getChunkIterator(0);
  }
  next() {
    for (; this.chunkIndex < this.numChunks; ) {
      const gA = this.chunkIterator.next();
      if (!gA.done)
        return gA;
      ++this.chunkIndex < this.numChunks && (this.chunkIterator = this.getChunkIterator(this.chunkIndex));
    }
    return { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
function computeChunkNullable(CA) {
  return CA.some((gA) => gA.nullable);
}
function computeChunkNullCounts(CA) {
  return CA.reduce((gA, AA) => gA + AA.nullCount, 0);
}
function computeChunkOffsets(CA) {
  return CA.reduce((gA, AA, IA) => (gA[IA + 1] = gA[IA] + AA.length, gA), new Uint32Array(CA.length + 1));
}
function sliceChunks$1(CA, gA, AA, IA) {
  const BA = [];
  for (let QA = -1, EA = CA.length; ++QA < EA; ) {
    const iA = CA[QA], oA = gA[QA], { length: cA } = iA;
    if (oA >= IA)
      break;
    if (AA >= oA + cA)
      continue;
    if (oA >= AA && oA + cA <= IA) {
      BA.push(iA);
      continue;
    }
    const tA = Math.max(0, AA - oA), eA = Math.min(IA - oA, cA);
    BA.push(iA.slice(tA, eA - tA));
  }
  return BA.length === 0 && BA.push(CA[0].slice(0, 0)), BA;
}
function binarySearch(CA, gA, AA, IA) {
  let BA = 0, QA = 0, EA = gA.length - 1;
  do {
    if (BA >= EA - 1)
      return AA < gA[EA] ? IA(CA, BA, AA - gA[BA]) : null;
    QA = BA + Math.trunc((EA - BA) * 0.5), AA < gA[QA] ? EA = QA : BA = QA;
  } while (BA < EA);
}
function isChunkedValid(CA, gA) {
  return CA.getValid(gA);
}
function wrapChunkedCall1(CA) {
  function gA(AA, IA, BA) {
    return CA(AA[IA], BA);
  }
  return function(AA) {
    const IA = this.data;
    return binarySearch(IA, this._offsets, AA, gA);
  };
}
function wrapChunkedCall2(CA) {
  let gA;
  function AA(IA, BA, QA) {
    return CA(IA[BA], QA, gA);
  }
  return function(IA, BA) {
    const QA = this.data;
    gA = BA;
    const EA = binarySearch(QA, this._offsets, IA, AA);
    return gA = void 0, EA;
  };
}
function wrapChunkedIndexOf(CA) {
  let gA;
  function AA(IA, BA, QA) {
    let EA = QA, iA = 0, oA = 0;
    for (let cA = BA - 1, tA = IA.length; ++cA < tA; ) {
      const eA = IA[cA];
      if (~(iA = CA(eA, gA, EA)))
        return oA + iA;
      EA = 0, oA += eA.length;
    }
    return -1;
  }
  return function(IA, BA) {
    gA = IA;
    const QA = this.data, EA = typeof BA != "number" ? AA(QA, 0, 0) : binarySearch(QA, this._offsets, BA, AA);
    return gA = void 0, EA;
  };
}
class IndexOfVisitor extends Visitor {
}
function nullIndexOf(CA, gA) {
  return gA === null && CA.length > 0 ? 0 : -1;
}
function indexOfNull(CA, gA) {
  const { nullBitmap: AA } = CA;
  if (!AA || CA.nullCount <= 0)
    return -1;
  let IA = 0;
  for (const BA of new BitIterator(AA, CA.offset + (gA || 0), CA.length, AA, getBool)) {
    if (!BA)
      return IA;
    ++IA;
  }
  return -1;
}
function indexOfValue(CA, gA, AA) {
  if (gA === void 0)
    return -1;
  if (gA === null)
    switch (CA.typeId) {
      // Unions don't have a nullBitmap of its own, so compare the `searchElement` to `get()`.
      case Type.Union:
        break;
      // Dictionaries do have a nullBitmap, but their dictionary could also have null elements.
      case Type.Dictionary:
        break;
      // All other types can iterate the null bitmap
      default:
        return indexOfNull(CA, AA);
    }
  const IA = instance$4.getVisitFn(CA), BA = createElementComparator(gA);
  for (let QA = (AA || 0) - 1, EA = CA.length; ++QA < EA; )
    if (BA(IA(CA, QA)))
      return QA;
  return -1;
}
function indexOfUnion(CA, gA, AA) {
  const IA = instance$4.getVisitFn(CA), BA = createElementComparator(gA);
  for (let QA = (AA || 0) - 1, EA = CA.length; ++QA < EA; )
    if (BA(IA(CA, QA)))
      return QA;
  return -1;
}
IndexOfVisitor.prototype.visitNull = nullIndexOf;
IndexOfVisitor.prototype.visitBool = indexOfValue;
IndexOfVisitor.prototype.visitInt = indexOfValue;
IndexOfVisitor.prototype.visitInt8 = indexOfValue;
IndexOfVisitor.prototype.visitInt16 = indexOfValue;
IndexOfVisitor.prototype.visitInt32 = indexOfValue;
IndexOfVisitor.prototype.visitInt64 = indexOfValue;
IndexOfVisitor.prototype.visitUint8 = indexOfValue;
IndexOfVisitor.prototype.visitUint16 = indexOfValue;
IndexOfVisitor.prototype.visitUint32 = indexOfValue;
IndexOfVisitor.prototype.visitUint64 = indexOfValue;
IndexOfVisitor.prototype.visitFloat = indexOfValue;
IndexOfVisitor.prototype.visitFloat16 = indexOfValue;
IndexOfVisitor.prototype.visitFloat32 = indexOfValue;
IndexOfVisitor.prototype.visitFloat64 = indexOfValue;
IndexOfVisitor.prototype.visitUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitLargeUtf8 = indexOfValue;
IndexOfVisitor.prototype.visitBinary = indexOfValue;
IndexOfVisitor.prototype.visitLargeBinary = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeBinary = indexOfValue;
IndexOfVisitor.prototype.visitDate = indexOfValue;
IndexOfVisitor.prototype.visitDateDay = indexOfValue;
IndexOfVisitor.prototype.visitDateMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestamp = indexOfValue;
IndexOfVisitor.prototype.visitTimestampSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimestampNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitTime = indexOfValue;
IndexOfVisitor.prototype.visitTimeSecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitTimeNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitDecimal = indexOfValue;
IndexOfVisitor.prototype.visitList = indexOfValue;
IndexOfVisitor.prototype.visitStruct = indexOfValue;
IndexOfVisitor.prototype.visitUnion = indexOfValue;
IndexOfVisitor.prototype.visitDenseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitSparseUnion = indexOfUnion;
IndexOfVisitor.prototype.visitDictionary = indexOfValue;
IndexOfVisitor.prototype.visitInterval = indexOfValue;
IndexOfVisitor.prototype.visitIntervalDayTime = indexOfValue;
IndexOfVisitor.prototype.visitIntervalYearMonth = indexOfValue;
IndexOfVisitor.prototype.visitIntervalMonthDayNano = indexOfValue;
IndexOfVisitor.prototype.visitDuration = indexOfValue;
IndexOfVisitor.prototype.visitDurationSecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMillisecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationMicrosecond = indexOfValue;
IndexOfVisitor.prototype.visitDurationNanosecond = indexOfValue;
IndexOfVisitor.prototype.visitFixedSizeList = indexOfValue;
IndexOfVisitor.prototype.visitMap = indexOfValue;
const instance$3 = new IndexOfVisitor();
class IteratorVisitor extends Visitor {
}
function vectorIterator(CA) {
  const { type: gA } = CA;
  if (CA.nullCount === 0 && CA.stride === 1 && // Don't defer to native iterator for timestamps since Numbers are expected
  // (DataType.isTimestamp(type)) && type.unit === TimeUnit.MILLISECOND ||
  (DataType.isInt(gA) && gA.bitWidth !== 64 || DataType.isTime(gA) && gA.bitWidth !== 64 || DataType.isFloat(gA) && gA.precision !== Precision.HALF))
    return new ChunkedIterator(CA.data.length, (IA) => {
      const BA = CA.data[IA];
      return BA.values.subarray(0, BA.length)[Symbol.iterator]();
    });
  let AA = 0;
  return new ChunkedIterator(CA.data.length, (IA) => {
    const QA = CA.data[IA].length, EA = CA.slice(AA, AA + QA);
    return AA += QA, new VectorIterator(EA);
  });
}
class VectorIterator {
  constructor(gA) {
    this.vector = gA, this.index = 0;
  }
  next() {
    return this.index < this.vector.length ? {
      value: this.vector.get(this.index++)
    } : { done: !0, value: null };
  }
  [Symbol.iterator]() {
    return this;
  }
}
IteratorVisitor.prototype.visitNull = vectorIterator;
IteratorVisitor.prototype.visitBool = vectorIterator;
IteratorVisitor.prototype.visitInt = vectorIterator;
IteratorVisitor.prototype.visitInt8 = vectorIterator;
IteratorVisitor.prototype.visitInt16 = vectorIterator;
IteratorVisitor.prototype.visitInt32 = vectorIterator;
IteratorVisitor.prototype.visitInt64 = vectorIterator;
IteratorVisitor.prototype.visitUint8 = vectorIterator;
IteratorVisitor.prototype.visitUint16 = vectorIterator;
IteratorVisitor.prototype.visitUint32 = vectorIterator;
IteratorVisitor.prototype.visitUint64 = vectorIterator;
IteratorVisitor.prototype.visitFloat = vectorIterator;
IteratorVisitor.prototype.visitFloat16 = vectorIterator;
IteratorVisitor.prototype.visitFloat32 = vectorIterator;
IteratorVisitor.prototype.visitFloat64 = vectorIterator;
IteratorVisitor.prototype.visitUtf8 = vectorIterator;
IteratorVisitor.prototype.visitLargeUtf8 = vectorIterator;
IteratorVisitor.prototype.visitBinary = vectorIterator;
IteratorVisitor.prototype.visitLargeBinary = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeBinary = vectorIterator;
IteratorVisitor.prototype.visitDate = vectorIterator;
IteratorVisitor.prototype.visitDateDay = vectorIterator;
IteratorVisitor.prototype.visitDateMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestamp = vectorIterator;
IteratorVisitor.prototype.visitTimestampSecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimestampNanosecond = vectorIterator;
IteratorVisitor.prototype.visitTime = vectorIterator;
IteratorVisitor.prototype.visitTimeSecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMillisecond = vectorIterator;
IteratorVisitor.prototype.visitTimeMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitTimeNanosecond = vectorIterator;
IteratorVisitor.prototype.visitDecimal = vectorIterator;
IteratorVisitor.prototype.visitList = vectorIterator;
IteratorVisitor.prototype.visitStruct = vectorIterator;
IteratorVisitor.prototype.visitUnion = vectorIterator;
IteratorVisitor.prototype.visitDenseUnion = vectorIterator;
IteratorVisitor.prototype.visitSparseUnion = vectorIterator;
IteratorVisitor.prototype.visitDictionary = vectorIterator;
IteratorVisitor.prototype.visitInterval = vectorIterator;
IteratorVisitor.prototype.visitIntervalDayTime = vectorIterator;
IteratorVisitor.prototype.visitIntervalYearMonth = vectorIterator;
IteratorVisitor.prototype.visitIntervalMonthDayNano = vectorIterator;
IteratorVisitor.prototype.visitDuration = vectorIterator;
IteratorVisitor.prototype.visitDurationSecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMillisecond = vectorIterator;
IteratorVisitor.prototype.visitDurationMicrosecond = vectorIterator;
IteratorVisitor.prototype.visitDurationNanosecond = vectorIterator;
IteratorVisitor.prototype.visitFixedSizeList = vectorIterator;
IteratorVisitor.prototype.visitMap = vectorIterator;
const instance$2 = new IteratorVisitor();
var _a$3;
const visitorsByTypeId = {}, vectorPrototypesByTypeId = {};
class Vector {
  constructor(gA) {
    var AA, IA, BA;
    const QA = gA[0] instanceof Vector ? gA.flatMap((iA) => iA.data) : gA;
    if (QA.length === 0 || QA.some((iA) => !(iA instanceof Data)))
      throw new TypeError("Vector constructor expects an Array of Data instances.");
    const EA = (AA = QA[0]) === null || AA === void 0 ? void 0 : AA.type;
    switch (QA.length) {
      case 0:
        this._offsets = [0];
        break;
      case 1: {
        const { get: iA, set: oA, indexOf: cA } = visitorsByTypeId[EA.typeId], tA = QA[0];
        this.isValid = (eA) => isChunkedValid(tA, eA), this.get = (eA) => iA(tA, eA), this.set = (eA, aA) => oA(tA, eA, aA), this.indexOf = (eA) => cA(tA, eA), this._offsets = [0, tA.length];
        break;
      }
      default:
        Object.setPrototypeOf(this, vectorPrototypesByTypeId[EA.typeId]), this._offsets = computeChunkOffsets(QA);
        break;
    }
    this.data = QA, this.type = EA, this.stride = strideForType(EA), this.numChildren = (BA = (IA = EA.children) === null || IA === void 0 ? void 0 : IA.length) !== null && BA !== void 0 ? BA : 0, this.length = this._offsets.at(-1);
  }
  /**
   * The aggregate size (in bytes) of this Vector's buffers and/or child Vectors.
   */
  get byteLength() {
    return this.data.reduce((gA, AA) => gA + AA.byteLength, 0);
  }
  /**
   * Whether this Vector's elements can contain null values.
   */
  get nullable() {
    return computeChunkNullable(this.data);
  }
  /**
   * The number of null elements in this Vector.
   */
  get nullCount() {
    return computeChunkNullCounts(this.data);
  }
  /**
   * The Array or TypedArray constructor used for the JS representation
   *  of the element's values in {@link Vector.prototype.toArray `toArray()`}.
   */
  get ArrayType() {
    return this.type.ArrayType;
  }
  /**
   * The name that should be printed when the Vector is logged in a message.
   */
  get [Symbol.toStringTag]() {
    return `${this.VectorName}<${this.type[Symbol.toStringTag]}>`;
  }
  /**
   * The name of this Vector.
   */
  get VectorName() {
    return `${Type[this.type.typeId]}Vector`;
  }
  /**
   * Check whether an element is null.
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(gA) {
    return !1;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(gA) {
    return null;
  }
  /**
   * Get an element value by position.
   * @param index The index of the element to read. A negative index will count back from the last element.
   */
  at(gA) {
    return this.get(wrapIndex(gA, this.length));
  }
  /**
   * Set an element value by position.
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(gA, AA) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(gA, AA) {
    return -1;
  }
  includes(gA, AA) {
    return this.indexOf(gA, AA) > -1;
  }
  /**
   * Iterator for the Vector's elements.
   */
  [Symbol.iterator]() {
    return instance$2.visit(this);
  }
  /**
   * Combines two or more Vectors of the same type.
   * @param others Additional Vectors to add to the end of this Vector.
   */
  concat(...gA) {
    return new Vector(this.data.concat(gA.flatMap((AA) => AA.data).flat(Number.POSITIVE_INFINITY)));
  }
  /**
   * Return a zero-copy sub-section of this Vector.
   * @param start The beginning of the specified portion of the Vector.
   * @param end The end of the specified portion of the Vector. This is exclusive of the element at the index 'end'.
   */
  slice(gA, AA) {
    return new Vector(clampRange(this, gA, AA, ({ data: IA, _offsets: BA }, QA, EA) => sliceChunks$1(IA, BA, QA, EA)));
  }
  toJSON() {
    return [...this];
  }
  /**
   * Return a JavaScript Array or TypedArray of the Vector's elements.
   *
   * @note If this Vector contains a single Data chunk and the Vector's type is a
   *  primitive numeric type corresponding to one of the JavaScript TypedArrays, this
   *  method returns a zero-copy slice of the underlying TypedArray values. If there's
   *  more than one chunk, the resulting TypedArray will be a copy of the data from each
   *  chunk's underlying TypedArray values.
   *
   * @returns An Array or TypedArray of the Vector's elements, based on the Vector's DataType.
   */
  toArray() {
    const { type: gA, data: AA, length: IA, stride: BA, ArrayType: QA } = this;
    switch (gA.typeId) {
      case Type.Int:
      case Type.Float:
      case Type.Decimal:
      case Type.Time:
      case Type.Timestamp:
        switch (AA.length) {
          case 0:
            return new QA();
          case 1:
            return AA[0].values.subarray(0, IA * BA);
          default:
            return AA.reduce((EA, { values: iA, length: oA }) => (EA.array.set(iA.subarray(0, oA * BA), EA.offset), EA.offset += oA * BA, EA), { array: new QA(IA * BA), offset: 0 }).array;
        }
    }
    return [...this];
  }
  /**
   * Returns a string representation of the Vector.
   *
   * @returns A string representation of the Vector.
   */
  toString() {
    return `[${[...this].join(",")}]`;
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(gA) {
    var AA;
    return this.getChildAt((AA = this.type.children) === null || AA === void 0 ? void 0 : AA.findIndex((IA) => IA.name === gA));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(gA) {
    return gA > -1 && gA < this.numChildren ? new Vector(this.data.map(({ children: AA }) => AA[gA])) : null;
  }
  get isMemoized() {
    return DataType.isDictionary(this.type) ? this.data[0].dictionary.isMemoized : !1;
  }
  /**
   * Adds memoization to the Vector's {@link get} method. For dictionary
   * vectors, this method return a vector that memoizes only the dictionary
   * values.
   *
   * Memoization is very useful when decoding a value is expensive such as
   * Utf8. The memoization creates a cache of the size of the Vector and
   * therefore increases memory usage.
   *
   * @returns A new vector that memoizes calls to {@link get}.
   */
  memoize() {
    if (DataType.isDictionary(this.type)) {
      const gA = new MemoizedVector(this.data[0].dictionary), AA = this.data.map((IA) => {
        const BA = IA.clone();
        return BA.dictionary = gA, BA;
      });
      return new Vector(AA);
    }
    return new MemoizedVector(this);
  }
  /**
   * Returns a vector without memoization of the {@link get} method. If this
   * vector is not memoized, this method returns this vector.
   *
   * @returns A new vector without memoization.
   */
  unmemoize() {
    if (DataType.isDictionary(this.type) && this.isMemoized) {
      const gA = this.data[0].dictionary.unmemoize(), AA = this.data.map((IA) => {
        const BA = IA.clone();
        return BA.dictionary = gA, BA;
      });
      return new Vector(AA);
    }
    return this;
  }
}
_a$3 = Symbol.toStringTag;
Vector[_a$3] = ((CA) => {
  CA.type = DataType.prototype, CA.data = [], CA.length = 0, CA.stride = 1, CA.numChildren = 0, CA._offsets = new Uint32Array([0]), CA[Symbol.isConcatSpreadable] = !0;
  const gA = Object.keys(Type).map((AA) => Type[AA]).filter((AA) => typeof AA == "number" && AA !== Type.NONE);
  for (const AA of gA) {
    const IA = instance$4.getVisitFnByTypeId(AA), BA = instance$5.getVisitFnByTypeId(AA), QA = instance$3.getVisitFnByTypeId(AA);
    visitorsByTypeId[AA] = { get: IA, set: BA, indexOf: QA }, vectorPrototypesByTypeId[AA] = Object.create(CA, {
      isValid: { value: wrapChunkedCall1(isChunkedValid) },
      get: { value: wrapChunkedCall1(instance$4.getVisitFnByTypeId(AA)) },
      set: { value: wrapChunkedCall2(instance$5.getVisitFnByTypeId(AA)) },
      indexOf: { value: wrapChunkedIndexOf(instance$3.getVisitFnByTypeId(AA)) }
    });
  }
  return "Vector";
})(Vector.prototype);
class MemoizedVector extends Vector {
  constructor(gA) {
    super(gA.data);
    const AA = this.get, IA = this.set, BA = this.slice, QA = new Array(this.length);
    Object.defineProperty(this, "get", {
      value(EA) {
        const iA = QA[EA];
        if (iA !== void 0)
          return iA;
        const oA = AA.call(this, EA);
        return QA[EA] = oA, oA;
      }
    }), Object.defineProperty(this, "set", {
      value(EA, iA) {
        IA.call(this, EA, iA), QA[EA] = iA;
      }
    }), Object.defineProperty(this, "slice", {
      value: (EA, iA) => new MemoizedVector(BA.call(this, EA, iA))
    }), Object.defineProperty(this, "isMemoized", { value: !0 }), Object.defineProperty(this, "unmemoize", {
      value: () => new Vector(this.data)
    }), Object.defineProperty(this, "memoize", {
      value: () => this
    });
  }
}
class Block {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  /**
   * Index to the start of the RecordBlock (note this is past the Message header)
   */
  offset() {
    return this.bb.readInt64(this.bb_pos);
  }
  /**
   * Length of the metadata
   */
  metaDataLength() {
    return this.bb.readInt32(this.bb_pos + 8);
  }
  /**
   * Length of the data (this is aligned so there can be a gap between this and
   * the metadata).
   */
  bodyLength() {
    return this.bb.readInt64(this.bb_pos + 16);
  }
  static sizeOf() {
    return 24;
  }
  static createBlock(gA, AA, IA, BA) {
    return gA.prep(8, 24), gA.writeInt64(BigInt(BA ?? 0)), gA.pad(4), gA.writeInt32(IA), gA.writeInt64(BigInt(AA ?? 0)), gA.offset();
  }
}
class Footer {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsFooter(gA, AA) {
    return (AA || new Footer()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsFooter(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new Footer()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  version() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : MetadataVersion.V1;
  }
  schema(gA) {
    const AA = this.bb.__offset(this.bb_pos, 6);
    return AA ? (gA || new Schema$3()).__init(this.bb.__indirect(this.bb_pos + AA), this.bb) : null;
  }
  dictionaries(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 8);
    return IA ? (AA || new Block()).__init(this.bb.__vector(this.bb_pos + IA) + gA * 24, this.bb) : null;
  }
  dictionariesLength() {
    const gA = this.bb.__offset(this.bb_pos, 8);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  recordBatches(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 10);
    return IA ? (AA || new Block()).__init(this.bb.__vector(this.bb_pos + IA) + gA * 24, this.bb) : null;
  }
  recordBatchesLength() {
    const gA = this.bb.__offset(this.bb_pos, 10);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  /**
   * User-defined metadata
   */
  customMetadata(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 12);
    return IA ? (AA || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  customMetadataLength() {
    const gA = this.bb.__offset(this.bb_pos, 12);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  static startFooter(gA) {
    gA.startObject(5);
  }
  static addVersion(gA, AA) {
    gA.addFieldInt16(0, AA, MetadataVersion.V1);
  }
  static addSchema(gA, AA) {
    gA.addFieldOffset(1, AA, 0);
  }
  static addDictionaries(gA, AA) {
    gA.addFieldOffset(2, AA, 0);
  }
  static startDictionariesVector(gA, AA) {
    gA.startVector(24, AA, 8);
  }
  static addRecordBatches(gA, AA) {
    gA.addFieldOffset(3, AA, 0);
  }
  static startRecordBatchesVector(gA, AA) {
    gA.startVector(24, AA, 8);
  }
  static addCustomMetadata(gA, AA) {
    gA.addFieldOffset(4, AA, 0);
  }
  static createCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static endFooter(gA) {
    return gA.endObject();
  }
  static finishFooterBuffer(gA, AA) {
    gA.finish(AA);
  }
  static finishSizePrefixedFooterBuffer(gA, AA) {
    gA.finish(AA, void 0, !0);
  }
}
let Schema$2 = class PI {
  constructor(gA = [], AA, IA, BA = MetadataVersion.V5) {
    this.fields = gA || [], this.metadata = AA || /* @__PURE__ */ new Map(), IA || (IA = generateDictionaryMap(this.fields)), this.dictionaries = IA, this.metadataVersion = BA;
  }
  get [Symbol.toStringTag]() {
    return "Schema";
  }
  get names() {
    return this.fields.map((gA) => gA.name);
  }
  toString() {
    return `Schema<{ ${this.fields.map((gA, AA) => `${AA}: ${gA}`).join(", ")} }>`;
  }
  /**
   * Construct a new Schema containing only specified fields.
   *
   * @param fieldNames Names of fields to keep.
   * @returns A new Schema of fields matching the specified names.
   */
  select(gA) {
    const AA = new Set(gA), IA = this.fields.filter((BA) => AA.has(BA.name));
    return new PI(IA, this.metadata);
  }
  /**
   * Construct a new Schema containing only fields at the specified indices.
   *
   * @param fieldIndices Indices of fields to keep.
   * @returns A new Schema of fields at the specified indices.
   */
  selectAt(gA) {
    const AA = gA.map((IA) => this.fields[IA]).filter(Boolean);
    return new PI(AA, this.metadata);
  }
  assign(...gA) {
    const AA = gA[0] instanceof PI ? gA[0] : Array.isArray(gA[0]) ? new PI(gA[0]) : new PI(gA), IA = [...this.fields], BA = mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), this.metadata), AA.metadata), QA = AA.fields.filter((iA) => {
      const oA = IA.findIndex((cA) => cA.name === iA.name);
      return ~oA ? (IA[oA] = iA.clone({
        metadata: mergeMaps(mergeMaps(/* @__PURE__ */ new Map(), IA[oA].metadata), iA.metadata)
      })) && !1 : !0;
    }), EA = generateDictionaryMap(QA, /* @__PURE__ */ new Map());
    return new PI([...IA, ...QA], BA, new Map([...this.dictionaries, ...EA]));
  }
};
Schema$2.prototype.fields = null;
Schema$2.prototype.metadata = null;
Schema$2.prototype.dictionaries = null;
class Field {
  /** @nocollapse */
  static new(...gA) {
    let [AA, IA, BA, QA] = gA;
    return gA[0] && typeof gA[0] == "object" && ({ name: AA } = gA[0], IA === void 0 && (IA = gA[0].type), BA === void 0 && (BA = gA[0].nullable), QA === void 0 && (QA = gA[0].metadata)), new Field(`${AA}`, IA, BA, QA);
  }
  constructor(gA, AA, IA = !1, BA) {
    this.name = gA, this.type = AA, this.nullable = IA, this.metadata = BA || /* @__PURE__ */ new Map();
  }
  get typeId() {
    return this.type.typeId;
  }
  get [Symbol.toStringTag]() {
    return "Field";
  }
  toString() {
    return `${this.name}: ${this.type}`;
  }
  clone(...gA) {
    let [AA, IA, BA, QA] = gA;
    return !gA[0] || typeof gA[0] != "object" ? [AA = this.name, IA = this.type, BA = this.nullable, QA = this.metadata] = gA : { name: AA = this.name, type: IA = this.type, nullable: BA = this.nullable, metadata: QA = this.metadata } = gA[0], Field.new(AA, IA, BA, QA);
  }
}
Field.prototype.type = null;
Field.prototype.name = null;
Field.prototype.nullable = null;
Field.prototype.metadata = null;
function mergeMaps(CA, gA) {
  return new Map([...CA || /* @__PURE__ */ new Map(), ...gA || /* @__PURE__ */ new Map()]);
}
function generateDictionaryMap(CA, gA = /* @__PURE__ */ new Map()) {
  for (let AA = -1, IA = CA.length; ++AA < IA; ) {
    const QA = CA[AA].type;
    if (DataType.isDictionary(QA)) {
      if (!gA.has(QA.id))
        gA.set(QA.id, QA.dictionary);
      else if (gA.get(QA.id) !== QA.dictionary)
        throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
    }
    QA.children && QA.children.length > 0 && generateDictionaryMap(QA.children, gA);
  }
  return gA;
}
var Builder$1 = Builder$2, ByteBuffer$1 = ByteBuffer$2;
class Footer_ {
  /** @nocollapse */
  static decode(gA) {
    gA = new ByteBuffer$1(toUint8Array(gA));
    const AA = Footer.getRootAsFooter(gA), IA = Schema$2.decode(AA.schema(), /* @__PURE__ */ new Map(), AA.version());
    return new OffHeapFooter(IA, AA);
  }
  /** @nocollapse */
  static encode(gA) {
    const AA = new Builder$1(), IA = Schema$2.encode(AA, gA.schema);
    Footer.startRecordBatchesVector(AA, gA.numRecordBatches);
    for (const EA of [...gA.recordBatches()].slice().reverse())
      FileBlock.encode(AA, EA);
    const BA = AA.endVector();
    Footer.startDictionariesVector(AA, gA.numDictionaries);
    for (const EA of [...gA.dictionaryBatches()].slice().reverse())
      FileBlock.encode(AA, EA);
    const QA = AA.endVector();
    return Footer.startFooter(AA), Footer.addSchema(AA, IA), Footer.addVersion(AA, MetadataVersion.V5), Footer.addRecordBatches(AA, BA), Footer.addDictionaries(AA, QA), Footer.finishFooterBuffer(AA, Footer.endFooter(AA)), AA.asUint8Array();
  }
  get numRecordBatches() {
    return this._recordBatches.length;
  }
  get numDictionaries() {
    return this._dictionaryBatches.length;
  }
  constructor(gA, AA = MetadataVersion.V5, IA, BA) {
    this.schema = gA, this.version = AA, IA && (this._recordBatches = IA), BA && (this._dictionaryBatches = BA);
  }
  *recordBatches() {
    for (let gA, AA = -1, IA = this.numRecordBatches; ++AA < IA; )
      (gA = this.getRecordBatch(AA)) && (yield gA);
  }
  *dictionaryBatches() {
    for (let gA, AA = -1, IA = this.numDictionaries; ++AA < IA; )
      (gA = this.getDictionaryBatch(AA)) && (yield gA);
  }
  getRecordBatch(gA) {
    return gA >= 0 && gA < this.numRecordBatches && this._recordBatches[gA] || null;
  }
  getDictionaryBatch(gA) {
    return gA >= 0 && gA < this.numDictionaries && this._dictionaryBatches[gA] || null;
  }
}
class OffHeapFooter extends Footer_ {
  get numRecordBatches() {
    return this._footer.recordBatchesLength();
  }
  get numDictionaries() {
    return this._footer.dictionariesLength();
  }
  constructor(gA, AA) {
    super(gA, AA.version()), this._footer = AA;
  }
  getRecordBatch(gA) {
    if (gA >= 0 && gA < this.numRecordBatches) {
      const AA = this._footer.recordBatches(gA);
      if (AA)
        return FileBlock.decode(AA);
    }
    return null;
  }
  getDictionaryBatch(gA) {
    if (gA >= 0 && gA < this.numDictionaries) {
      const AA = this._footer.dictionaries(gA);
      if (AA)
        return FileBlock.decode(AA);
    }
    return null;
  }
}
class FileBlock {
  /** @nocollapse */
  static decode(gA) {
    return new FileBlock(gA.metaDataLength(), gA.bodyLength(), gA.offset());
  }
  /** @nocollapse */
  static encode(gA, AA) {
    const { metaDataLength: IA } = AA, BA = BigInt(AA.offset), QA = BigInt(AA.bodyLength);
    return Block.createBlock(gA, BA, IA, QA);
  }
  constructor(gA, AA, IA) {
    this.metaDataLength = gA, this.offset = bigIntToNumber(IA), this.bodyLength = bigIntToNumber(AA);
  }
}
let Message$1 = class XI {
  constructor() {
    this.bb = null, this.bb_pos = 0;
  }
  __init(gA, AA) {
    return this.bb_pos = gA, this.bb = AA, this;
  }
  static getRootAsMessage(gA, AA) {
    return (AA || new XI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  static getSizePrefixedRootAsMessage(gA, AA) {
    return gA.setPosition(gA.position() + SIZE_PREFIX_LENGTH), (AA || new XI()).__init(gA.readInt32(gA.position()) + gA.position(), gA);
  }
  version() {
    const gA = this.bb.__offset(this.bb_pos, 4);
    return gA ? this.bb.readInt16(this.bb_pos + gA) : MetadataVersion.V1;
  }
  headerType() {
    const gA = this.bb.__offset(this.bb_pos, 6);
    return gA ? this.bb.readUint8(this.bb_pos + gA) : MessageHeader.NONE;
  }
  header(gA) {
    const AA = this.bb.__offset(this.bb_pos, 8);
    return AA ? this.bb.__union(gA, this.bb_pos + AA) : null;
  }
  bodyLength() {
    const gA = this.bb.__offset(this.bb_pos, 10);
    return gA ? this.bb.readInt64(this.bb_pos + gA) : BigInt("0");
  }
  customMetadata(gA, AA) {
    const IA = this.bb.__offset(this.bb_pos, 12);
    return IA ? (AA || new KeyValue()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + IA) + gA * 4), this.bb) : null;
  }
  customMetadataLength() {
    const gA = this.bb.__offset(this.bb_pos, 12);
    return gA ? this.bb.__vector_len(this.bb_pos + gA) : 0;
  }
  static startMessage(gA) {
    gA.startObject(5);
  }
  static addVersion(gA, AA) {
    gA.addFieldInt16(0, AA, MetadataVersion.V1);
  }
  static addHeaderType(gA, AA) {
    gA.addFieldInt8(1, AA, MessageHeader.NONE);
  }
  static addHeader(gA, AA) {
    gA.addFieldOffset(2, AA, 0);
  }
  static addBodyLength(gA, AA) {
    gA.addFieldInt64(3, AA, BigInt("0"));
  }
  static addCustomMetadata(gA, AA) {
    gA.addFieldOffset(4, AA, 0);
  }
  static createCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA.length, 4);
    for (let IA = AA.length - 1; IA >= 0; IA--)
      gA.addOffset(AA[IA]);
    return gA.endVector();
  }
  static startCustomMetadataVector(gA, AA) {
    gA.startVector(4, AA, 4);
  }
  static endMessage(gA) {
    return gA.endObject();
  }
  static finishMessageBuffer(gA, AA) {
    gA.finish(AA);
  }
  static finishSizePrefixedMessageBuffer(gA, AA) {
    gA.finish(AA, void 0, !0);
  }
  static createMessage(gA, AA, IA, BA, QA, EA) {
    return XI.startMessage(gA), XI.addVersion(gA, AA), XI.addHeaderType(gA, IA), XI.addHeader(gA, BA), XI.addBodyLength(gA, QA), XI.addCustomMetadata(gA, EA), XI.endMessage(gA);
  }
};
class TypeAssembler extends Visitor {
  visit(gA, AA) {
    return gA == null || AA == null ? void 0 : super.visit(gA, AA);
  }
  visitNull(gA, AA) {
    return Null$1.startNull(AA), Null$1.endNull(AA);
  }
  visitInt(gA, AA) {
    return Int.startInt(AA), Int.addBitWidth(AA, gA.bitWidth), Int.addIsSigned(AA, gA.isSigned), Int.endInt(AA);
  }
  visitFloat(gA, AA) {
    return FloatingPoint.startFloatingPoint(AA), FloatingPoint.addPrecision(AA, gA.precision), FloatingPoint.endFloatingPoint(AA);
  }
  visitBinary(gA, AA) {
    return Binary$1.startBinary(AA), Binary$1.endBinary(AA);
  }
  visitLargeBinary(gA, AA) {
    return LargeBinary$1.startLargeBinary(AA), LargeBinary$1.endLargeBinary(AA);
  }
  visitBool(gA, AA) {
    return Bool$1.startBool(AA), Bool$1.endBool(AA);
  }
  visitUtf8(gA, AA) {
    return Utf8$1.startUtf8(AA), Utf8$1.endUtf8(AA);
  }
  visitLargeUtf8(gA, AA) {
    return LargeUtf8$1.startLargeUtf8(AA), LargeUtf8$1.endLargeUtf8(AA);
  }
  visitDecimal(gA, AA) {
    return Decimal$1.startDecimal(AA), Decimal$1.addScale(AA, gA.scale), Decimal$1.addPrecision(AA, gA.precision), Decimal$1.addBitWidth(AA, gA.bitWidth), Decimal$1.endDecimal(AA);
  }
  visitDate(gA, AA) {
    return Date$1.startDate(AA), Date$1.addUnit(AA, gA.unit), Date$1.endDate(AA);
  }
  visitTime(gA, AA) {
    return Time.startTime(AA), Time.addUnit(AA, gA.unit), Time.addBitWidth(AA, gA.bitWidth), Time.endTime(AA);
  }
  visitTimestamp(gA, AA) {
    const IA = gA.timezone && AA.createString(gA.timezone) || void 0;
    return Timestamp.startTimestamp(AA), Timestamp.addUnit(AA, gA.unit), IA !== void 0 && Timestamp.addTimezone(AA, IA), Timestamp.endTimestamp(AA);
  }
  visitInterval(gA, AA) {
    return Interval.startInterval(AA), Interval.addUnit(AA, gA.unit), Interval.endInterval(AA);
  }
  visitDuration(gA, AA) {
    return Duration$1.startDuration(AA), Duration$1.addUnit(AA, gA.unit), Duration$1.endDuration(AA);
  }
  visitList(gA, AA) {
    return List$1.startList(AA), List$1.endList(AA);
  }
  visitStruct(gA, AA) {
    return Struct_.startStruct_(AA), Struct_.endStruct_(AA);
  }
  visitUnion(gA, AA) {
    Union.startTypeIdsVector(AA, gA.typeIds.length);
    const IA = Union.createTypeIdsVector(AA, gA.typeIds);
    return Union.startUnion(AA), Union.addMode(AA, gA.mode), Union.addTypeIds(AA, IA), Union.endUnion(AA);
  }
  visitDictionary(gA, AA) {
    const IA = this.visit(gA.indices, AA);
    return DictionaryEncoding.startDictionaryEncoding(AA), DictionaryEncoding.addId(AA, BigInt(gA.id)), DictionaryEncoding.addIsOrdered(AA, gA.isOrdered), IA !== void 0 && DictionaryEncoding.addIndexType(AA, IA), DictionaryEncoding.endDictionaryEncoding(AA);
  }
  visitFixedSizeBinary(gA, AA) {
    return FixedSizeBinary$1.startFixedSizeBinary(AA), FixedSizeBinary$1.addByteWidth(AA, gA.byteWidth), FixedSizeBinary$1.endFixedSizeBinary(AA);
  }
  visitFixedSizeList(gA, AA) {
    return FixedSizeList$1.startFixedSizeList(AA), FixedSizeList$1.addListSize(AA, gA.listSize), FixedSizeList$1.endFixedSizeList(AA);
  }
  visitMap(gA, AA) {
    return Map$1.startMap(AA), Map$1.addKeysSorted(AA, gA.keysSorted), Map$1.endMap(AA);
  }
}
const instance$1 = new TypeAssembler();
function schemaFromJSON(CA, gA = /* @__PURE__ */ new Map()) {
  return new Schema$2(schemaFieldsFromJSON(CA, gA), customMetadataFromJSON(CA.metadata), gA);
}
function recordBatchFromJSON(CA) {
  return new RecordBatch$2(CA.count, fieldNodesFromJSON(CA.columns), buffersFromJSON(CA.columns), null);
}
function dictionaryBatchFromJSON(CA) {
  return new DictionaryBatch(recordBatchFromJSON(CA.data), CA.id, CA.isDelta);
}
function schemaFieldsFromJSON(CA, gA) {
  return (CA.fields || []).filter(Boolean).map((AA) => Field.fromJSON(AA, gA));
}
function fieldChildrenFromJSON(CA, gA) {
  return (CA.children || []).filter(Boolean).map((AA) => Field.fromJSON(AA, gA));
}
function fieldNodesFromJSON(CA) {
  return (CA || []).reduce((gA, AA) => [
    ...gA,
    new FieldNode(AA.count, nullCountFromJSON(AA.VALIDITY)),
    ...fieldNodesFromJSON(AA.children)
  ], []);
}
function buffersFromJSON(CA, gA = []) {
  for (let AA = -1, IA = (CA || []).length; ++AA < IA; ) {
    const BA = CA[AA];
    BA.VALIDITY && gA.push(new BufferRegion(gA.length, BA.VALIDITY.length)), BA.TYPE_ID && gA.push(new BufferRegion(gA.length, BA.TYPE_ID.length)), BA.OFFSET && gA.push(new BufferRegion(gA.length, BA.OFFSET.length)), BA.DATA && gA.push(new BufferRegion(gA.length, BA.DATA.length)), gA = buffersFromJSON(BA.children, gA);
  }
  return gA;
}
function nullCountFromJSON(CA) {
  return (CA || []).reduce((gA, AA) => gA + +(AA === 0), 0);
}
function fieldFromJSON(CA, gA) {
  let AA, IA, BA, QA, EA, iA;
  return !gA || !(QA = CA.dictionary) ? (EA = typeFromJSON(CA, fieldChildrenFromJSON(CA, gA)), BA = new Field(CA.name, EA, CA.nullable, customMetadataFromJSON(CA.metadata))) : gA.has(AA = QA.id) ? (IA = (IA = QA.indexType) ? indexTypeFromJSON(IA) : new Int32(), iA = new Dictionary(gA.get(AA), IA, AA, QA.isOrdered), BA = new Field(CA.name, iA, CA.nullable, customMetadataFromJSON(CA.metadata))) : (IA = (IA = QA.indexType) ? indexTypeFromJSON(IA) : new Int32(), gA.set(AA, EA = typeFromJSON(CA, fieldChildrenFromJSON(CA, gA))), iA = new Dictionary(EA, IA, AA, QA.isOrdered), BA = new Field(CA.name, iA, CA.nullable, customMetadataFromJSON(CA.metadata))), BA || null;
}
function customMetadataFromJSON(CA = []) {
  return new Map(CA.map(({ key: gA, value: AA }) => [gA, AA]));
}
function indexTypeFromJSON(CA) {
  return new Int_(CA.isSigned, CA.bitWidth);
}
function typeFromJSON(CA, gA) {
  const AA = CA.type.name;
  switch (AA) {
    case "NONE":
      return new Null();
    case "null":
      return new Null();
    case "binary":
      return new Binary();
    case "largebinary":
      return new LargeBinary();
    case "utf8":
      return new Utf8();
    case "largeutf8":
      return new LargeUtf8();
    case "bool":
      return new Bool();
    case "list":
      return new List((gA || [])[0]);
    case "struct":
      return new Struct(gA || []);
    case "struct_":
      return new Struct(gA || []);
  }
  switch (AA) {
    case "int": {
      const IA = CA.type;
      return new Int_(IA.isSigned, IA.bitWidth);
    }
    case "floatingpoint": {
      const IA = CA.type;
      return new Float(Precision[IA.precision]);
    }
    case "decimal": {
      const IA = CA.type;
      return new Decimal(IA.scale, IA.precision, IA.bitWidth);
    }
    case "date": {
      const IA = CA.type;
      return new Date_(DateUnit[IA.unit]);
    }
    case "time": {
      const IA = CA.type;
      return new Time_(TimeUnit[IA.unit], IA.bitWidth);
    }
    case "timestamp": {
      const IA = CA.type;
      return new Timestamp_(TimeUnit[IA.unit], IA.timezone);
    }
    case "interval": {
      const IA = CA.type;
      return new Interval_(IntervalUnit[IA.unit]);
    }
    case "duration": {
      const IA = CA.type;
      return new Duration(TimeUnit[IA.unit]);
    }
    case "union": {
      const IA = CA.type, [BA, ...QA] = (IA.mode + "").toLowerCase(), EA = BA.toUpperCase() + QA.join("");
      return new Union_(UnionMode[EA], IA.typeIds || [], gA || []);
    }
    case "fixedsizebinary": {
      const IA = CA.type;
      return new FixedSizeBinary(IA.byteWidth);
    }
    case "fixedsizelist": {
      const IA = CA.type;
      return new FixedSizeList(IA.listSize, (gA || [])[0]);
    }
    case "map": {
      const IA = CA.type;
      return new Map_((gA || [])[0], IA.keysSorted);
    }
  }
  throw new Error(`Unrecognized type: "${AA}"`);
}
var Builder = Builder$2, ByteBuffer = ByteBuffer$2;
class Message {
  /** @nocollapse */
  static fromJSON(gA, AA) {
    const IA = new Message(0, MetadataVersion.V5, AA);
    return IA._createHeader = messageHeaderFromJSON(gA, AA), IA;
  }
  /** @nocollapse */
  static decode(gA) {
    gA = new ByteBuffer(toUint8Array(gA));
    const AA = Message$1.getRootAsMessage(gA), IA = AA.bodyLength(), BA = AA.version(), QA = AA.headerType(), EA = new Message(IA, BA, QA);
    return EA._createHeader = decodeMessageHeader(AA, QA), EA;
  }
  /** @nocollapse */
  static encode(gA) {
    const AA = new Builder();
    let IA = -1;
    return gA.isSchema() ? IA = Schema$2.encode(AA, gA.header()) : gA.isRecordBatch() ? IA = RecordBatch$2.encode(AA, gA.header()) : gA.isDictionaryBatch() && (IA = DictionaryBatch.encode(AA, gA.header())), Message$1.startMessage(AA), Message$1.addVersion(AA, MetadataVersion.V5), Message$1.addHeader(AA, IA), Message$1.addHeaderType(AA, gA.headerType), Message$1.addBodyLength(AA, BigInt(gA.bodyLength)), Message$1.finishMessageBuffer(AA, Message$1.endMessage(AA)), AA.asUint8Array();
  }
  /** @nocollapse */
  static from(gA, AA = 0) {
    if (gA instanceof Schema$2)
      return new Message(0, MetadataVersion.V5, MessageHeader.Schema, gA);
    if (gA instanceof RecordBatch$2)
      return new Message(AA, MetadataVersion.V5, MessageHeader.RecordBatch, gA);
    if (gA instanceof DictionaryBatch)
      return new Message(AA, MetadataVersion.V5, MessageHeader.DictionaryBatch, gA);
    throw new Error(`Unrecognized Message header: ${gA}`);
  }
  get type() {
    return this.headerType;
  }
  get version() {
    return this._version;
  }
  get headerType() {
    return this._headerType;
  }
  get compression() {
    return this._compression;
  }
  get bodyLength() {
    return this._bodyLength;
  }
  header() {
    return this._createHeader();
  }
  isSchema() {
    return this.headerType === MessageHeader.Schema;
  }
  isRecordBatch() {
    return this.headerType === MessageHeader.RecordBatch;
  }
  isDictionaryBatch() {
    return this.headerType === MessageHeader.DictionaryBatch;
  }
  constructor(gA, AA, IA, BA) {
    this._version = AA, this._headerType = IA, this.body = new Uint8Array(0), this._compression = BA?.compression, BA && (this._createHeader = () => BA), this._bodyLength = bigIntToNumber(gA);
  }
}
let RecordBatch$2 = class {
  get nodes() {
    return this._nodes;
  }
  get length() {
    return this._length;
  }
  get buffers() {
    return this._buffers;
  }
  get compression() {
    return this._compression;
  }
  constructor(gA, AA, IA, BA) {
    this._nodes = AA, this._buffers = IA, this._length = bigIntToNumber(gA), this._compression = BA;
  }
};
class DictionaryBatch {
  get id() {
    return this._id;
  }
  get data() {
    return this._data;
  }
  get isDelta() {
    return this._isDelta;
  }
  get length() {
    return this.data.length;
  }
  get nodes() {
    return this.data.nodes;
  }
  get buffers() {
    return this.data.buffers;
  }
  constructor(gA, AA, IA = !1) {
    this._data = gA, this._isDelta = IA, this._id = bigIntToNumber(AA);
  }
}
class BufferRegion {
  constructor(gA, AA) {
    this.offset = bigIntToNumber(gA), this.length = bigIntToNumber(AA);
  }
}
class FieldNode {
  constructor(gA, AA) {
    this.length = bigIntToNumber(gA), this.nullCount = bigIntToNumber(AA);
  }
}
class BodyCompression {
  constructor(gA, AA = BodyCompressionMethod.BUFFER) {
    this.type = gA, this.method = AA;
  }
}
function messageHeaderFromJSON(CA, gA) {
  return (() => {
    switch (gA) {
      case MessageHeader.Schema:
        return Schema$2.fromJSON(CA);
      case MessageHeader.RecordBatch:
        return RecordBatch$2.fromJSON(CA);
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.fromJSON(CA);
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[gA]}, type: ${gA} }`);
  });
}
function decodeMessageHeader(CA, gA) {
  return (() => {
    switch (gA) {
      case MessageHeader.Schema:
        return Schema$2.decode(CA.header(new Schema$3()), /* @__PURE__ */ new Map(), CA.version());
      case MessageHeader.RecordBatch:
        return RecordBatch$2.decode(CA.header(new RecordBatch$3()), CA.version());
      case MessageHeader.DictionaryBatch:
        return DictionaryBatch.decode(CA.header(new DictionaryBatch$1()), CA.version());
    }
    throw new Error(`Unrecognized Message type: { name: ${MessageHeader[gA]}, type: ${gA} }`);
  });
}
Field.encode = encodeField;
Field.decode = decodeField;
Field.fromJSON = fieldFromJSON;
Schema$2.encode = encodeSchema;
Schema$2.decode = decodeSchema;
Schema$2.fromJSON = schemaFromJSON;
RecordBatch$2.encode = encodeRecordBatch;
RecordBatch$2.decode = decodeRecordBatch;
RecordBatch$2.fromJSON = recordBatchFromJSON;
DictionaryBatch.encode = encodeDictionaryBatch;
DictionaryBatch.decode = decodeDictionaryBatch;
DictionaryBatch.fromJSON = dictionaryBatchFromJSON;
FieldNode.encode = encodeFieldNode;
FieldNode.decode = decodeFieldNode;
BufferRegion.encode = encodeBufferRegion;
BufferRegion.decode = decodeBufferRegion;
BodyCompression.encode = encodeBodyCompression;
BodyCompression.decode = decodeBodyCompression;
function decodeSchema(CA, gA = /* @__PURE__ */ new Map(), AA = MetadataVersion.V5) {
  const IA = decodeSchemaFields(CA, gA);
  return new Schema$2(IA, decodeCustomMetadata(CA), gA, AA);
}
function decodeRecordBatch(CA, gA = MetadataVersion.V5) {
  return new RecordBatch$2(CA.length(), decodeFieldNodes(CA), decodeBuffers(CA, gA), decodeBodyCompression(CA.compression()));
}
function decodeDictionaryBatch(CA, gA = MetadataVersion.V5) {
  return new DictionaryBatch(RecordBatch$2.decode(CA.data(), gA), CA.id(), CA.isDelta());
}
function decodeBufferRegion(CA) {
  return new BufferRegion(CA.offset(), CA.length());
}
function decodeFieldNode(CA) {
  return new FieldNode(CA.length(), CA.nullCount());
}
function decodeFieldNodes(CA) {
  const gA = [];
  for (let AA, IA = -1, BA = -1, QA = CA.nodesLength(); ++IA < QA; )
    (AA = CA.nodes(IA)) && (gA[++BA] = FieldNode.decode(AA));
  return gA;
}
function decodeBuffers(CA, gA) {
  const AA = [];
  for (let IA, BA = -1, QA = -1, EA = CA.buffersLength(); ++BA < EA; )
    (IA = CA.buffers(BA)) && (gA < MetadataVersion.V4 && (IA.bb_pos += 8 * (BA + 1)), AA[++QA] = BufferRegion.decode(IA));
  return AA;
}
function decodeSchemaFields(CA, gA) {
  const AA = [];
  for (let IA, BA = -1, QA = -1, EA = CA.fieldsLength(); ++BA < EA; )
    (IA = CA.fields(BA)) && (AA[++QA] = Field.decode(IA, gA));
  return AA;
}
function decodeFieldChildren(CA, gA) {
  const AA = [];
  for (let IA, BA = -1, QA = -1, EA = CA.childrenLength(); ++BA < EA; )
    (IA = CA.children(BA)) && (AA[++QA] = Field.decode(IA, gA));
  return AA;
}
function decodeField(CA, gA) {
  let AA, IA, BA, QA, EA, iA;
  return !gA || !(iA = CA.dictionary()) ? (BA = decodeFieldType(CA, decodeFieldChildren(CA, gA)), IA = new Field(CA.name(), BA, CA.nullable(), decodeCustomMetadata(CA))) : gA.has(AA = bigIntToNumber(iA.id())) ? (QA = (QA = iA.indexType()) ? decodeIndexType(QA) : new Int32(), EA = new Dictionary(gA.get(AA), QA, AA, iA.isOrdered()), IA = new Field(CA.name(), EA, CA.nullable(), decodeCustomMetadata(CA))) : (QA = (QA = iA.indexType()) ? decodeIndexType(QA) : new Int32(), gA.set(AA, BA = decodeFieldType(CA, decodeFieldChildren(CA, gA))), EA = new Dictionary(BA, QA, AA, iA.isOrdered()), IA = new Field(CA.name(), EA, CA.nullable(), decodeCustomMetadata(CA))), IA || null;
}
function decodeCustomMetadata(CA) {
  const gA = /* @__PURE__ */ new Map();
  if (CA)
    for (let AA, IA, BA = -1, QA = Math.trunc(CA.customMetadataLength()); ++BA < QA; )
      (AA = CA.customMetadata(BA)) && (IA = AA.key()) != null && gA.set(IA, AA.value());
  return gA;
}
function decodeIndexType(CA) {
  return new Int_(CA.isSigned(), CA.bitWidth());
}
function decodeFieldType(CA, gA) {
  const AA = CA.typeType();
  switch (AA) {
    case Type$1.NONE:
      return new Null();
    case Type$1.Null:
      return new Null();
    case Type$1.Binary:
      return new Binary();
    case Type$1.LargeBinary:
      return new LargeBinary();
    case Type$1.Utf8:
      return new Utf8();
    case Type$1.LargeUtf8:
      return new LargeUtf8();
    case Type$1.Bool:
      return new Bool();
    case Type$1.List:
      return new List((gA || [])[0]);
    case Type$1.Struct_:
      return new Struct(gA || []);
  }
  switch (AA) {
    case Type$1.Int: {
      const IA = CA.type(new Int());
      return new Int_(IA.isSigned(), IA.bitWidth());
    }
    case Type$1.FloatingPoint: {
      const IA = CA.type(new FloatingPoint());
      return new Float(IA.precision());
    }
    case Type$1.Decimal: {
      const IA = CA.type(new Decimal$1());
      return new Decimal(IA.scale(), IA.precision(), IA.bitWidth());
    }
    case Type$1.Date: {
      const IA = CA.type(new Date$1());
      return new Date_(IA.unit());
    }
    case Type$1.Time: {
      const IA = CA.type(new Time());
      return new Time_(IA.unit(), IA.bitWidth());
    }
    case Type$1.Timestamp: {
      const IA = CA.type(new Timestamp());
      return new Timestamp_(IA.unit(), IA.timezone());
    }
    case Type$1.Interval: {
      const IA = CA.type(new Interval());
      return new Interval_(IA.unit());
    }
    case Type$1.Duration: {
      const IA = CA.type(new Duration$1());
      return new Duration(IA.unit());
    }
    case Type$1.Union: {
      const IA = CA.type(new Union());
      return new Union_(IA.mode(), IA.typeIdsArray() || [], gA || []);
    }
    case Type$1.FixedSizeBinary: {
      const IA = CA.type(new FixedSizeBinary$1());
      return new FixedSizeBinary(IA.byteWidth());
    }
    case Type$1.FixedSizeList: {
      const IA = CA.type(new FixedSizeList$1());
      return new FixedSizeList(IA.listSize(), (gA || [])[0]);
    }
    case Type$1.Map: {
      const IA = CA.type(new Map$1());
      return new Map_((gA || [])[0], IA.keysSorted());
    }
  }
  throw new Error(`Unrecognized type: "${Type$1[AA]}" (${AA})`);
}
function decodeBodyCompression(CA) {
  return CA ? new BodyCompression(CA.codec(), CA.method()) : null;
}
function encodeSchema(CA, gA) {
  const AA = gA.fields.map((QA) => Field.encode(CA, QA));
  Schema$3.startFieldsVector(CA, AA.length);
  const IA = Schema$3.createFieldsVector(CA, AA), BA = gA.metadata && gA.metadata.size > 0 ? Schema$3.createCustomMetadataVector(CA, [...gA.metadata].map(([QA, EA]) => {
    const iA = CA.createString(`${QA}`), oA = CA.createString(`${EA}`);
    return KeyValue.startKeyValue(CA), KeyValue.addKey(CA, iA), KeyValue.addValue(CA, oA), KeyValue.endKeyValue(CA);
  })) : -1;
  return Schema$3.startSchema(CA), Schema$3.addFields(CA, IA), Schema$3.addEndianness(CA, platformIsLittleEndian ? Endianness.Little : Endianness.Big), BA !== -1 && Schema$3.addCustomMetadata(CA, BA), Schema$3.endSchema(CA);
}
function encodeField(CA, gA) {
  let AA = -1, IA = -1, BA = -1;
  const QA = gA.type;
  let EA = gA.typeId;
  DataType.isDictionary(QA) ? (EA = QA.dictionary.typeId, BA = instance$1.visit(QA, CA), IA = instance$1.visit(QA.dictionary, CA)) : IA = instance$1.visit(QA, CA);
  const iA = (QA.children || []).map((tA) => Field.encode(CA, tA)), oA = Field$1.createChildrenVector(CA, iA), cA = gA.metadata && gA.metadata.size > 0 ? Field$1.createCustomMetadataVector(CA, [...gA.metadata].map(([tA, eA]) => {
    const aA = CA.createString(`${tA}`), GA = CA.createString(`${eA}`);
    return KeyValue.startKeyValue(CA), KeyValue.addKey(CA, aA), KeyValue.addValue(CA, GA), KeyValue.endKeyValue(CA);
  })) : -1;
  return gA.name && (AA = CA.createString(gA.name)), Field$1.startField(CA), Field$1.addType(CA, IA), Field$1.addTypeType(CA, EA), Field$1.addChildren(CA, oA), Field$1.addNullable(CA, !!gA.nullable), AA !== -1 && Field$1.addName(CA, AA), BA !== -1 && Field$1.addDictionary(CA, BA), cA !== -1 && Field$1.addCustomMetadata(CA, cA), Field$1.endField(CA);
}
function encodeRecordBatch(CA, gA) {
  const AA = gA.nodes || [], IA = gA.buffers || [];
  RecordBatch$3.startNodesVector(CA, AA.length);
  for (const iA of AA.slice().reverse())
    FieldNode.encode(CA, iA);
  const BA = CA.endVector();
  RecordBatch$3.startBuffersVector(CA, IA.length);
  for (const iA of IA.slice().reverse())
    BufferRegion.encode(CA, iA);
  const QA = CA.endVector();
  let EA = null;
  return gA.compression !== null && (EA = encodeBodyCompression(CA, gA.compression)), RecordBatch$3.startRecordBatch(CA), RecordBatch$3.addLength(CA, BigInt(gA.length)), RecordBatch$3.addNodes(CA, BA), RecordBatch$3.addBuffers(CA, QA), gA.compression !== null && EA && RecordBatch$3.addCompression(CA, EA), RecordBatch$3.endRecordBatch(CA);
}
function encodeBodyCompression(CA, gA) {
  return BodyCompression$1.startBodyCompression(CA), BodyCompression$1.addCodec(CA, gA.type), BodyCompression$1.addMethod(CA, gA.method), BodyCompression$1.endBodyCompression(CA);
}
function encodeDictionaryBatch(CA, gA) {
  const AA = RecordBatch$2.encode(CA, gA.data);
  return DictionaryBatch$1.startDictionaryBatch(CA), DictionaryBatch$1.addId(CA, BigInt(gA.id)), DictionaryBatch$1.addIsDelta(CA, gA.isDelta), DictionaryBatch$1.addData(CA, AA), DictionaryBatch$1.endDictionaryBatch(CA);
}
function encodeFieldNode(CA, gA) {
  return FieldNode$1.createFieldNode(CA, BigInt(gA.length), BigInt(gA.nullCount));
}
function encodeBufferRegion(CA, gA) {
  return Buffer$1.createBuffer(CA, BigInt(gA.offset), BigInt(gA.length));
}
const platformIsLittleEndian = (() => {
  const CA = new ArrayBuffer(2);
  return new DataView(CA).setInt16(
    0,
    256,
    !0
    /* littleEndian */
  ), new Int16Array(CA)[0] === 256;
})(), ITERATOR_DONE = Object.freeze({ done: !0, value: void 0 });
class ArrowJSON {
  constructor(gA) {
    this._json = gA;
  }
  get schema() {
    return this._json.schema;
  }
  get batches() {
    return this._json.batches || [];
  }
  get dictionaries() {
    return this._json.dictionaries || [];
  }
}
class ReadableInterop {
  tee() {
    return this._getDOMStream().tee();
  }
  pipe(gA, AA) {
    return this._getNodeStream().pipe(gA, AA);
  }
  pipeTo(gA, AA) {
    return this._getDOMStream().pipeTo(gA, AA);
  }
  pipeThrough(gA, AA) {
    return this._getDOMStream().pipeThrough(gA, AA);
  }
  _getDOMStream() {
    return this._DOMStream || (this._DOMStream = this.toDOMStream());
  }
  _getNodeStream() {
    return this._nodeStream || (this._nodeStream = this.toNodeStream());
  }
}
class AsyncQueue extends ReadableInterop {
  constructor() {
    super(), this._values = [], this.resolvers = [], this._closedPromise = new Promise((gA) => this._closedPromiseResolve = gA);
  }
  get closed() {
    return this._closedPromise;
  }
  cancel(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(gA);
    });
  }
  write(gA) {
    this._ensureOpen() && (this.resolvers.length <= 0 ? this._values.push(gA) : this.resolvers.shift().resolve({ done: !1, value: gA }));
  }
  abort(gA) {
    this._closedPromiseResolve && (this.resolvers.length <= 0 ? this._error = { error: gA } : this.resolvers.shift().reject({ done: !0, value: gA }));
  }
  close() {
    if (this._closedPromiseResolve) {
      const { resolvers: gA } = this;
      for (; gA.length > 0; )
        gA.shift().resolve(ITERATOR_DONE);
      this._closedPromiseResolve(), this._closedPromiseResolve = void 0;
    }
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  toDOMStream(gA) {
    return streamAdapters.toDOMStream(this._closedPromiseResolve || this._error ? this : this._values, gA);
  }
  toNodeStream(gA) {
    return streamAdapters.toNodeStream(this._closedPromiseResolve || this._error ? this : this._values, gA);
  }
  throw(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.abort(gA), ITERATOR_DONE;
    });
  }
  return(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), ITERATOR_DONE;
    });
  }
  read(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(gA, "read")).value;
    });
  }
  peek(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(gA, "peek")).value;
    });
  }
  next(...gA) {
    return this._values.length > 0 ? Promise.resolve({ done: !1, value: this._values.shift() }) : this._error ? Promise.reject({ done: !0, value: this._error.error }) : this._closedPromiseResolve ? new Promise((AA, IA) => {
      this.resolvers.push({ resolve: AA, reject: IA });
    }) : Promise.resolve(ITERATOR_DONE);
  }
  _ensureOpen() {
    if (this._closedPromiseResolve)
      return !0;
    throw new Error("AsyncQueue is closed");
  }
}
class AsyncByteQueue extends AsyncQueue {
  write(gA) {
    if ((gA = toUint8Array(gA)).byteLength > 0)
      return super.write(gA);
  }
  toString(gA = !1) {
    return gA ? decodeUtf8(this.toUint8Array(!0)) : this.toUint8Array(!1).then(decodeUtf8);
  }
  toUint8Array(gA = !1) {
    return gA ? joinUint8Arrays(this._values)[0] : __awaiter(this, void 0, void 0, function* () {
      var AA, IA, BA, QA;
      const EA = [];
      let iA = 0;
      try {
        for (var oA = !0, cA = __asyncValues(this), tA; tA = yield cA.next(), AA = tA.done, !AA; oA = !0) {
          QA = tA.value, oA = !1;
          const eA = QA;
          EA.push(eA), iA += eA.byteLength;
        }
      } catch (eA) {
        IA = { error: eA };
      } finally {
        try {
          !oA && !AA && (BA = cA.return) && (yield BA.call(cA));
        } finally {
          if (IA) throw IA.error;
        }
      }
      return joinUint8Arrays(EA, iA)[0];
    });
  }
}
class ByteStream {
  constructor(gA) {
    gA && (this.source = new ByteStreamSource(streamAdapters.fromIterable(gA)));
  }
  [Symbol.iterator]() {
    return this;
  }
  next(gA) {
    return this.source.next(gA);
  }
  throw(gA) {
    return this.source.throw(gA);
  }
  return(gA) {
    return this.source.return(gA);
  }
  peek(gA) {
    return this.source.peek(gA);
  }
  read(gA) {
    return this.source.read(gA);
  }
}
class AsyncByteStream {
  constructor(gA) {
    gA instanceof AsyncByteStream ? this.source = gA.source : gA instanceof AsyncByteQueue ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(gA)) : isReadableNodeStream(gA) ? this.source = new AsyncByteStreamSource(streamAdapters.fromNodeStream(gA)) : isReadableDOMStream(gA) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(gA)) : isFetchResponse(gA) ? this.source = new AsyncByteStreamSource(streamAdapters.fromDOMStream(gA.body)) : isIterable(gA) ? this.source = new AsyncByteStreamSource(streamAdapters.fromIterable(gA)) : isPromise(gA) ? this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(gA)) : isAsyncIterable$1(gA) && (this.source = new AsyncByteStreamSource(streamAdapters.fromAsyncIterable(gA)));
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next(gA) {
    return this.source.next(gA);
  }
  throw(gA) {
    return this.source.throw(gA);
  }
  return(gA) {
    return this.source.return(gA);
  }
  get closed() {
    return this.source.closed;
  }
  cancel(gA) {
    return this.source.cancel(gA);
  }
  peek(gA) {
    return this.source.peek(gA);
  }
  read(gA) {
    return this.source.read(gA);
  }
}
class ByteStreamSource {
  constructor(gA) {
    this.source = gA;
  }
  cancel(gA) {
    this.return(gA);
  }
  peek(gA) {
    return this.next(gA, "peek").value;
  }
  read(gA) {
    return this.next(gA, "read").value;
  }
  next(gA, AA = "read") {
    return this.source.next({ cmd: AA, size: gA });
  }
  throw(gA) {
    return Object.create(this.source.throw && this.source.throw(gA) || ITERATOR_DONE);
  }
  return(gA) {
    return Object.create(this.source.return && this.source.return(gA) || ITERATOR_DONE);
  }
}
class AsyncByteStreamSource {
  constructor(gA) {
    this.source = gA, this._closedPromise = new Promise((AA) => this._closedPromiseResolve = AA);
  }
  cancel(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.return(gA);
    });
  }
  get closed() {
    return this._closedPromise;
  }
  read(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(gA, "read")).value;
    });
  }
  peek(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return (yield this.next(gA, "peek")).value;
    });
  }
  next(gA) {
    return __awaiter(this, arguments, void 0, function* (AA, IA = "read") {
      return yield this.source.next({ cmd: IA, size: AA });
    });
  }
  throw(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      const AA = this.source.throw && (yield this.source.throw(gA)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(AA);
    });
  }
  return(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      const AA = this.source.return && (yield this.source.return(gA)) || ITERATOR_DONE;
      return this._closedPromiseResolve && this._closedPromiseResolve(), this._closedPromiseResolve = void 0, Object.create(AA);
    });
  }
}
class RandomAccessFile extends ByteStream {
  constructor(gA, AA) {
    super(), this.position = 0, this.buffer = toUint8Array(gA), this.size = AA === void 0 ? this.buffer.byteLength : AA;
  }
  readInt32(gA) {
    const { buffer: AA, byteOffset: IA } = this.readAt(gA, 4);
    return new DataView(AA, IA).getInt32(0, !0);
  }
  seek(gA) {
    return this.position = Math.min(gA, this.size), gA < this.size;
  }
  read(gA) {
    const { buffer: AA, size: IA, position: BA } = this;
    return AA && BA < IA ? (typeof gA != "number" && (gA = Number.POSITIVE_INFINITY), this.position = Math.min(IA, BA + Math.min(IA - BA, gA)), AA.subarray(BA, this.position)) : null;
  }
  readAt(gA, AA) {
    const IA = this.buffer, BA = Math.min(this.size, gA + AA);
    return IA ? IA.subarray(gA, BA) : new Uint8Array(AA);
  }
  close() {
    this.buffer && (this.buffer = null);
  }
  throw(gA) {
    return this.close(), { done: !0, value: gA };
  }
  return(gA) {
    return this.close(), { done: !0, value: gA };
  }
}
class AsyncRandomAccessFile extends AsyncByteStream {
  constructor(gA, AA) {
    super(), this.position = 0, this._handle = gA, typeof AA == "number" ? this.size = AA : this._pending = __awaiter(this, void 0, void 0, function* () {
      this.size = (yield gA.stat()).size, delete this._pending;
    });
  }
  readInt32(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      const { buffer: AA, byteOffset: IA } = yield this.readAt(gA, 4);
      return new DataView(AA, IA).getInt32(0, !0);
    });
  }
  seek(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._pending && (yield this._pending), this.position = Math.min(gA, this.size), gA < this.size;
    });
  }
  read(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: AA, size: IA, position: BA } = this;
      if (AA && BA < IA) {
        typeof gA != "number" && (gA = Number.POSITIVE_INFINITY);
        let QA = BA, EA = 0, iA = 0;
        const oA = Math.min(IA, QA + Math.min(IA - QA, gA)), cA = new Uint8Array(Math.max(0, (this.position = oA) - QA));
        for (; (QA += iA) < oA && (EA += iA) < cA.byteLength; )
          ({ bytesRead: iA } = yield AA.read(cA, EA, cA.byteLength - EA, QA));
        return cA;
      }
      return null;
    });
  }
  readAt(gA, AA) {
    return __awaiter(this, void 0, void 0, function* () {
      this._pending && (yield this._pending);
      const { _handle: IA, size: BA } = this;
      if (IA && gA + AA < BA) {
        const QA = Math.min(BA, gA + AA), EA = new Uint8Array(QA - gA);
        return (yield IA.read(EA, 0, AA, gA)).buffer;
      }
      return new Uint8Array(AA);
    });
  }
  close() {
    return __awaiter(this, void 0, void 0, function* () {
      const gA = this._handle;
      this._handle = null, gA && (yield gA.close());
    });
  }
  throw(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: gA };
    });
  }
  return(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.close(), { done: !0, value: gA };
    });
  }
}
const carryBit16 = 65536;
function intAsHex(CA) {
  return CA < 0 && (CA = 4294967295 + CA + 1), `0x${CA.toString(16)}`;
}
const kInt32DecimalDigits = 8, kPowersOfTen = [
  1,
  10,
  100,
  1e3,
  1e4,
  1e5,
  1e6,
  1e7,
  1e8
];
class BaseInt64 {
  constructor(gA) {
    this.buffer = gA;
  }
  high() {
    return this.buffer[1];
  }
  low() {
    return this.buffer[0];
  }
  _times(gA) {
    const AA = new Uint32Array([
      this.buffer[1] >>> 16,
      this.buffer[1] & 65535,
      this.buffer[0] >>> 16,
      this.buffer[0] & 65535
    ]), IA = new Uint32Array([
      gA.buffer[1] >>> 16,
      gA.buffer[1] & 65535,
      gA.buffer[0] >>> 16,
      gA.buffer[0] & 65535
    ]);
    let BA = AA[3] * IA[3];
    this.buffer[0] = BA & 65535;
    let QA = BA >>> 16;
    return BA = AA[2] * IA[3], QA += BA, BA = AA[3] * IA[2] >>> 0, QA += BA, this.buffer[0] += QA << 16, this.buffer[1] = QA >>> 0 < BA ? carryBit16 : 0, this.buffer[1] += QA >>> 16, this.buffer[1] += AA[1] * IA[3] + AA[2] * IA[2] + AA[3] * IA[1], this.buffer[1] += AA[0] * IA[3] + AA[1] * IA[2] + AA[2] * IA[1] + AA[3] * IA[0] << 16, this;
  }
  _plus(gA) {
    const AA = this.buffer[0] + gA.buffer[0] >>> 0;
    this.buffer[1] += gA.buffer[1], AA < this.buffer[0] >>> 0 && ++this.buffer[1], this.buffer[0] = AA;
  }
  lessThan(gA) {
    return this.buffer[1] < gA.buffer[1] || this.buffer[1] === gA.buffer[1] && this.buffer[0] < gA.buffer[0];
  }
  equals(gA) {
    return this.buffer[1] === gA.buffer[1] && this.buffer[0] == gA.buffer[0];
  }
  greaterThan(gA) {
    return gA.lessThan(this);
  }
  hex() {
    return `${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
}
class Uint64 extends BaseInt64 {
  times(gA) {
    return this._times(gA), this;
  }
  plus(gA) {
    return this._plus(gA), this;
  }
  /** @nocollapse */
  static from(gA, AA = new Uint32Array(2)) {
    return Uint64.fromString(typeof gA == "string" ? gA : gA.toString(), AA);
  }
  /** @nocollapse */
  static fromNumber(gA, AA = new Uint32Array(2)) {
    return Uint64.fromString(gA.toString(), AA);
  }
  /** @nocollapse */
  static fromString(gA, AA = new Uint32Array(2)) {
    const IA = gA.length, BA = new Uint64(AA);
    for (let QA = 0; QA < IA; ) {
      const EA = kInt32DecimalDigits < IA - QA ? kInt32DecimalDigits : IA - QA, iA = new Uint64(new Uint32Array([Number.parseInt(gA.slice(QA, QA + EA), 10), 0])), oA = new Uint64(new Uint32Array([kPowersOfTen[EA], 0]));
      BA.times(oA), BA.plus(iA), QA += EA;
    }
    return BA;
  }
  /** @nocollapse */
  static convertArray(gA) {
    const AA = new Uint32Array(gA.length * 2);
    for (let IA = -1, BA = gA.length; ++IA < BA; )
      Uint64.from(gA[IA], new Uint32Array(AA.buffer, AA.byteOffset + 2 * IA * 4, 2));
    return AA;
  }
  /** @nocollapse */
  static multiply(gA, AA) {
    return new Uint64(new Uint32Array(gA.buffer)).times(AA);
  }
  /** @nocollapse */
  static add(gA, AA) {
    return new Uint64(new Uint32Array(gA.buffer)).plus(AA);
  }
}
class Int64 extends BaseInt64 {
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[0] == 0 && ++this.buffer[1], this;
  }
  times(gA) {
    return this._times(gA), this;
  }
  plus(gA) {
    return this._plus(gA), this;
  }
  lessThan(gA) {
    const AA = this.buffer[1] << 0, IA = gA.buffer[1] << 0;
    return AA < IA || AA === IA && this.buffer[0] < gA.buffer[0];
  }
  /** @nocollapse */
  static from(gA, AA = new Uint32Array(2)) {
    return Int64.fromString(typeof gA == "string" ? gA : gA.toString(), AA);
  }
  /** @nocollapse */
  static fromNumber(gA, AA = new Uint32Array(2)) {
    return Int64.fromString(gA.toString(), AA);
  }
  /** @nocollapse */
  static fromString(gA, AA = new Uint32Array(2)) {
    const IA = gA.startsWith("-"), BA = gA.length, QA = new Int64(AA);
    for (let EA = IA ? 1 : 0; EA < BA; ) {
      const iA = kInt32DecimalDigits < BA - EA ? kInt32DecimalDigits : BA - EA, oA = new Int64(new Uint32Array([Number.parseInt(gA.slice(EA, EA + iA), 10), 0])), cA = new Int64(new Uint32Array([kPowersOfTen[iA], 0]));
      QA.times(cA), QA.plus(oA), EA += iA;
    }
    return IA ? QA.negate() : QA;
  }
  /** @nocollapse */
  static convertArray(gA) {
    const AA = new Uint32Array(gA.length * 2);
    for (let IA = -1, BA = gA.length; ++IA < BA; )
      Int64.from(gA[IA], new Uint32Array(AA.buffer, AA.byteOffset + 2 * IA * 4, 2));
    return AA;
  }
  /** @nocollapse */
  static multiply(gA, AA) {
    return new Int64(new Uint32Array(gA.buffer)).times(AA);
  }
  /** @nocollapse */
  static add(gA, AA) {
    return new Int64(new Uint32Array(gA.buffer)).plus(AA);
  }
}
class Int128 {
  constructor(gA) {
    this.buffer = gA;
  }
  high() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2));
  }
  low() {
    return new Int64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset, 2));
  }
  negate() {
    return this.buffer[0] = ~this.buffer[0] + 1, this.buffer[1] = ~this.buffer[1], this.buffer[2] = ~this.buffer[2], this.buffer[3] = ~this.buffer[3], this.buffer[0] == 0 && ++this.buffer[1], this.buffer[1] == 0 && ++this.buffer[2], this.buffer[2] == 0 && ++this.buffer[3], this;
  }
  times(gA) {
    const AA = new Uint64(new Uint32Array([this.buffer[3], 0])), IA = new Uint64(new Uint32Array([this.buffer[2], 0])), BA = new Uint64(new Uint32Array([this.buffer[1], 0])), QA = new Uint64(new Uint32Array([this.buffer[0], 0])), EA = new Uint64(new Uint32Array([gA.buffer[3], 0])), iA = new Uint64(new Uint32Array([gA.buffer[2], 0])), oA = new Uint64(new Uint32Array([gA.buffer[1], 0])), cA = new Uint64(new Uint32Array([gA.buffer[0], 0]));
    let tA = Uint64.multiply(QA, cA);
    this.buffer[0] = tA.low();
    const eA = new Uint64(new Uint32Array([tA.high(), 0]));
    return tA = Uint64.multiply(BA, cA), eA.plus(tA), tA = Uint64.multiply(QA, oA), eA.plus(tA), this.buffer[1] = eA.low(), this.buffer[3] = eA.lessThan(tA) ? 1 : 0, this.buffer[2] = eA.high(), new Uint64(new Uint32Array(this.buffer.buffer, this.buffer.byteOffset + 8, 2)).plus(Uint64.multiply(IA, cA)).plus(Uint64.multiply(BA, oA)).plus(Uint64.multiply(QA, iA)), this.buffer[3] += Uint64.multiply(AA, cA).plus(Uint64.multiply(IA, oA)).plus(Uint64.multiply(BA, iA)).plus(Uint64.multiply(QA, EA)).low(), this;
  }
  plus(gA) {
    const AA = new Uint32Array(4);
    return AA[3] = this.buffer[3] + gA.buffer[3] >>> 0, AA[2] = this.buffer[2] + gA.buffer[2] >>> 0, AA[1] = this.buffer[1] + gA.buffer[1] >>> 0, AA[0] = this.buffer[0] + gA.buffer[0] >>> 0, AA[0] < this.buffer[0] >>> 0 && ++AA[1], AA[1] < this.buffer[1] >>> 0 && ++AA[2], AA[2] < this.buffer[2] >>> 0 && ++AA[3], this.buffer[3] = AA[3], this.buffer[2] = AA[2], this.buffer[1] = AA[1], this.buffer[0] = AA[0], this;
  }
  hex() {
    return `${intAsHex(this.buffer[3])} ${intAsHex(this.buffer[2])} ${intAsHex(this.buffer[1])} ${intAsHex(this.buffer[0])}`;
  }
  /** @nocollapse */
  static multiply(gA, AA) {
    return new Int128(new Uint32Array(gA.buffer)).times(AA);
  }
  /** @nocollapse */
  static add(gA, AA) {
    return new Int128(new Uint32Array(gA.buffer)).plus(AA);
  }
  /** @nocollapse */
  static from(gA, AA = new Uint32Array(4)) {
    return Int128.fromString(typeof gA == "string" ? gA : gA.toString(), AA);
  }
  /** @nocollapse */
  static fromNumber(gA, AA = new Uint32Array(4)) {
    return Int128.fromString(gA.toString(), AA);
  }
  /** @nocollapse */
  static fromString(gA, AA = new Uint32Array(4)) {
    const IA = gA.startsWith("-"), BA = gA.length, QA = new Int128(AA);
    for (let EA = IA ? 1 : 0; EA < BA; ) {
      const iA = kInt32DecimalDigits < BA - EA ? kInt32DecimalDigits : BA - EA, oA = new Int128(new Uint32Array([Number.parseInt(gA.slice(EA, EA + iA), 10), 0, 0, 0])), cA = new Int128(new Uint32Array([kPowersOfTen[iA], 0, 0, 0]));
      QA.times(cA), QA.plus(oA), EA += iA;
    }
    return IA ? QA.negate() : QA;
  }
  /** @nocollapse */
  static convertArray(gA) {
    const AA = new Uint32Array(gA.length * 4);
    for (let IA = -1, BA = gA.length; ++IA < BA; )
      Int128.from(gA[IA], new Uint32Array(AA.buffer, AA.byteOffset + 16 * IA, 4));
    return AA;
  }
}
const util_int_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInt64,
  Int128,
  Int64,
  Uint64
}, Symbol.toStringTag, { value: "Module" }));
function toIntervalDayTimeInt32Array(CA) {
  var gA, AA;
  const IA = CA.length, BA = new Int32Array(IA * 2);
  for (let QA = 0, EA = 0; QA < IA; QA++) {
    const iA = CA[QA];
    BA[EA++] = (gA = iA.days) !== null && gA !== void 0 ? gA : 0, BA[EA++] = (AA = iA.milliseconds) !== null && AA !== void 0 ? AA : 0;
  }
  return BA;
}
function toIntervalMonthDayNanoInt32Array(CA) {
  var gA, AA;
  const IA = CA.length, BA = new Int32Array(IA * 4);
  for (let QA = 0, EA = 0; QA < IA; QA++) {
    const iA = CA[QA];
    BA[EA++] = (gA = iA.months) !== null && gA !== void 0 ? gA : 0, BA[EA++] = (AA = iA.days) !== null && AA !== void 0 ? AA : 0;
    const oA = iA.nanoseconds;
    oA ? (BA[EA++] = Number(BigInt(oA) & BigInt(4294967295)), BA[EA++] = Number(BigInt(oA) >> BigInt(32))) : EA += 2;
  }
  return BA;
}
function toIntervalDayTimeObjects(CA) {
  const gA = CA.length, AA = new Array(gA / 2);
  for (let IA = 0, BA = 0; IA < gA; IA += 2)
    AA[BA++] = {
      days: CA[IA],
      milliseconds: CA[IA + 1]
    };
  return AA;
}
function toIntervalMonthDayNanoObjects(CA, gA) {
  const AA = CA.length, IA = new Array(AA / 4);
  for (let BA = 0, QA = 0; BA < AA; BA += 4) {
    const EA = BigInt(CA[BA + 3]) << BigInt(32) | BigInt(CA[BA + 2] >>> 0);
    IA[QA++] = {
      months: CA[BA],
      days: CA[BA + 1],
      nanoseconds: gA ? `${EA}` : EA
    };
  }
  return IA;
}
const util_interval_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  toIntervalDayTimeInt32Array,
  toIntervalDayTimeObjects,
  toIntervalMonthDayNanoInt32Array,
  toIntervalMonthDayNanoObjects
}, Symbol.toStringTag, { value: "Module" }));
class VectorLoader extends Visitor {
  constructor(gA, AA, IA, BA, QA = MetadataVersion.V5) {
    super(), this.nodesIndex = -1, this.buffersIndex = -1, this.bytes = gA, this.nodes = AA, this.buffers = IA, this.dictionaries = BA, this.metadataVersion = QA;
  }
  visit(gA) {
    return super.visit(gA instanceof Field ? gA.type : gA);
  }
  visitNull(gA, { length: AA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA });
  }
  visitBool(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitInt(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitFloat(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitUtf8(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), data: this.readData(gA) });
  }
  visitLargeUtf8(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), data: this.readData(gA) });
  }
  visitBinary(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), data: this.readData(gA) });
  }
  visitLargeBinary(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), data: this.readData(gA) });
  }
  visitFixedSizeBinary(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitDate(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitTimestamp(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitTime(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitDecimal(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitList(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), child: this.visit(gA.children[0]) });
  }
  visitStruct(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), children: this.visitMany(gA.children) });
  }
  visitUnion(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return this.metadataVersion < MetadataVersion.V5 && this.readNullBitmap(gA, IA), gA.mode === UnionMode.Sparse ? this.visitSparseUnion(gA, { length: AA, nullCount: IA }) : this.visitDenseUnion(gA, { length: AA, nullCount: IA });
  }
  visitDenseUnion(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, typeIds: this.readTypeIds(gA), valueOffsets: this.readOffsets(gA), children: this.visitMany(gA.children) });
  }
  visitSparseUnion(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, typeIds: this.readTypeIds(gA), children: this.visitMany(gA.children) });
  }
  visitDictionary(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA.indices), dictionary: this.readDictionary(gA) });
  }
  visitInterval(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitDuration(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), data: this.readData(gA) });
  }
  visitFixedSizeList(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), child: this.visit(gA.children[0]) });
  }
  visitMap(gA, { length: AA, nullCount: IA } = this.nextFieldNode()) {
    return makeData({ type: gA, length: AA, nullCount: IA, nullBitmap: this.readNullBitmap(gA, IA), valueOffsets: this.readOffsets(gA), child: this.visit(gA.children[0]) });
  }
  nextFieldNode() {
    return this.nodes[++this.nodesIndex];
  }
  nextBufferRange() {
    return this.buffers[++this.buffersIndex];
  }
  readNullBitmap(gA, AA, IA = this.nextBufferRange()) {
    return AA > 0 && this.readData(gA, IA) || new Uint8Array(0);
  }
  readOffsets(gA, AA) {
    return this.readData(gA, AA);
  }
  readTypeIds(gA, AA) {
    return this.readData(gA, AA);
  }
  readData(gA, { length: AA, offset: IA } = this.nextBufferRange()) {
    return this.bytes.subarray(IA, IA + AA);
  }
  readDictionary(gA) {
    return this.dictionaries.get(gA.id);
  }
}
class JSONVectorLoader extends VectorLoader {
  constructor(gA, AA, IA, BA, QA) {
    super(new Uint8Array(0), AA, IA, BA, QA), this.sources = gA;
  }
  readNullBitmap(gA, AA, { offset: IA } = this.nextBufferRange()) {
    return AA <= 0 ? new Uint8Array(0) : packBools(this.sources[IA]);
  }
  readOffsets(gA, { offset: AA } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(gA.OffsetArrayType, this.sources[AA]));
  }
  readTypeIds(gA, { offset: AA } = this.nextBufferRange()) {
    return toArrayBufferView(Uint8Array, toArrayBufferView(gA.ArrayType, this.sources[AA]));
  }
  readData(gA, { offset: AA } = this.nextBufferRange()) {
    const { sources: IA } = this;
    if (DataType.isTimestamp(gA))
      return toArrayBufferView(Uint8Array, Int64.convertArray(IA[AA]));
    if ((DataType.isInt(gA) || DataType.isTime(gA)) && gA.bitWidth === 64 || DataType.isDuration(gA))
      return toArrayBufferView(Uint8Array, Int64.convertArray(IA[AA]));
    if (DataType.isDate(gA) && gA.unit === DateUnit.MILLISECOND)
      return toArrayBufferView(Uint8Array, Int64.convertArray(IA[AA]));
    if (DataType.isDecimal(gA))
      return toArrayBufferView(Uint8Array, Int128.convertArray(IA[AA]));
    if (DataType.isBinary(gA) || DataType.isLargeBinary(gA) || DataType.isFixedSizeBinary(gA))
      return binaryDataFromJSON(IA[AA]);
    if (DataType.isBool(gA))
      return packBools(IA[AA]);
    if (DataType.isUtf8(gA) || DataType.isLargeUtf8(gA))
      return encodeUtf8(IA[AA].join(""));
    if (DataType.isInterval(gA))
      switch (gA.unit) {
        case IntervalUnit.DAY_TIME:
          return toIntervalDayTimeInt32Array(IA[AA]);
        case IntervalUnit.MONTH_DAY_NANO:
          return toIntervalMonthDayNanoInt32Array(IA[AA]);
      }
    return toArrayBufferView(Uint8Array, toArrayBufferView(gA.ArrayType, IA[AA].map((BA) => +BA)));
  }
}
function binaryDataFromJSON(CA) {
  const gA = CA.join(""), AA = new Uint8Array(gA.length / 2);
  for (let IA = 0; IA < gA.length; IA += 2)
    AA[IA >> 1] = Number.parseInt(gA.slice(IA, IA + 2), 16);
  return AA;
}
class CompressedVectorLoader extends VectorLoader {
  constructor(gA, AA, IA, BA, QA) {
    super(new Uint8Array(0), AA, IA, BA, QA), this.bodyChunks = gA;
  }
  readData(gA, AA = this.nextBufferRange()) {
    return this.bodyChunks[this.buffersIndex];
  }
}
class TypeComparator extends Visitor {
  compareSchemas(gA, AA) {
    return gA === AA || AA instanceof gA.constructor && this.compareManyFields(gA.fields, AA.fields);
  }
  compareManyFields(gA, AA) {
    return gA === AA || Array.isArray(gA) && Array.isArray(AA) && gA.length === AA.length && gA.every((IA, BA) => this.compareFields(IA, AA[BA]));
  }
  compareFields(gA, AA) {
    return gA === AA || AA instanceof gA.constructor && gA.name === AA.name && gA.nullable === AA.nullable && this.visit(gA.type, AA.type);
  }
}
function compareConstructor(CA, gA) {
  return gA instanceof CA.constructor;
}
function compareAny(CA, gA) {
  return CA === gA || compareConstructor(CA, gA);
}
function compareInt(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.bitWidth === gA.bitWidth && CA.isSigned === gA.isSigned;
}
function compareFloat(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.precision === gA.precision;
}
function compareFixedSizeBinary(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.byteWidth === gA.byteWidth;
}
function compareDate(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.unit === gA.unit;
}
function compareTimestamp(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.unit === gA.unit && CA.timezone === gA.timezone;
}
function compareTime(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.unit === gA.unit && CA.bitWidth === gA.bitWidth;
}
function compareList(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.children.length === gA.children.length && instance.compareManyFields(CA.children, gA.children);
}
function compareStruct(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.children.length === gA.children.length && instance.compareManyFields(CA.children, gA.children);
}
function compareUnion(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.mode === gA.mode && CA.typeIds.every((AA, IA) => AA === gA.typeIds[IA]) && instance.compareManyFields(CA.children, gA.children);
}
function compareDictionary(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.id === gA.id && CA.isOrdered === gA.isOrdered && instance.visit(CA.indices, gA.indices) && instance.visit(CA.dictionary, gA.dictionary);
}
function compareInterval(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.unit === gA.unit;
}
function compareDuration(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.unit === gA.unit;
}
function compareFixedSizeList(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.listSize === gA.listSize && CA.children.length === gA.children.length && instance.compareManyFields(CA.children, gA.children);
}
function compareMap(CA, gA) {
  return CA === gA || compareConstructor(CA, gA) && CA.keysSorted === gA.keysSorted && CA.children.length === gA.children.length && instance.compareManyFields(CA.children, gA.children);
}
TypeComparator.prototype.visitNull = compareAny;
TypeComparator.prototype.visitBool = compareAny;
TypeComparator.prototype.visitInt = compareInt;
TypeComparator.prototype.visitInt8 = compareInt;
TypeComparator.prototype.visitInt16 = compareInt;
TypeComparator.prototype.visitInt32 = compareInt;
TypeComparator.prototype.visitInt64 = compareInt;
TypeComparator.prototype.visitUint8 = compareInt;
TypeComparator.prototype.visitUint16 = compareInt;
TypeComparator.prototype.visitUint32 = compareInt;
TypeComparator.prototype.visitUint64 = compareInt;
TypeComparator.prototype.visitFloat = compareFloat;
TypeComparator.prototype.visitFloat16 = compareFloat;
TypeComparator.prototype.visitFloat32 = compareFloat;
TypeComparator.prototype.visitFloat64 = compareFloat;
TypeComparator.prototype.visitUtf8 = compareAny;
TypeComparator.prototype.visitLargeUtf8 = compareAny;
TypeComparator.prototype.visitBinary = compareAny;
TypeComparator.prototype.visitLargeBinary = compareAny;
TypeComparator.prototype.visitFixedSizeBinary = compareFixedSizeBinary;
TypeComparator.prototype.visitDate = compareDate;
TypeComparator.prototype.visitDateDay = compareDate;
TypeComparator.prototype.visitDateMillisecond = compareDate;
TypeComparator.prototype.visitTimestamp = compareTimestamp;
TypeComparator.prototype.visitTimestampSecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMillisecond = compareTimestamp;
TypeComparator.prototype.visitTimestampMicrosecond = compareTimestamp;
TypeComparator.prototype.visitTimestampNanosecond = compareTimestamp;
TypeComparator.prototype.visitTime = compareTime;
TypeComparator.prototype.visitTimeSecond = compareTime;
TypeComparator.prototype.visitTimeMillisecond = compareTime;
TypeComparator.prototype.visitTimeMicrosecond = compareTime;
TypeComparator.prototype.visitTimeNanosecond = compareTime;
TypeComparator.prototype.visitDecimal = compareAny;
TypeComparator.prototype.visitList = compareList;
TypeComparator.prototype.visitStruct = compareStruct;
TypeComparator.prototype.visitUnion = compareUnion;
TypeComparator.prototype.visitDenseUnion = compareUnion;
TypeComparator.prototype.visitSparseUnion = compareUnion;
TypeComparator.prototype.visitDictionary = compareDictionary;
TypeComparator.prototype.visitInterval = compareInterval;
TypeComparator.prototype.visitIntervalDayTime = compareInterval;
TypeComparator.prototype.visitIntervalYearMonth = compareInterval;
TypeComparator.prototype.visitIntervalMonthDayNano = compareInterval;
TypeComparator.prototype.visitDuration = compareDuration;
TypeComparator.prototype.visitDurationSecond = compareDuration;
TypeComparator.prototype.visitDurationMillisecond = compareDuration;
TypeComparator.prototype.visitDurationMicrosecond = compareDuration;
TypeComparator.prototype.visitDurationNanosecond = compareDuration;
TypeComparator.prototype.visitFixedSizeList = compareFixedSizeList;
TypeComparator.prototype.visitMap = compareMap;
const instance = new TypeComparator();
function compareSchemas(CA, gA) {
  return instance.compareSchemas(CA, gA);
}
function compareFields(CA, gA) {
  return instance.compareFields(CA, gA);
}
function compareTypes(CA, gA) {
  return instance.visit(CA, gA);
}
function distributeVectorsIntoRecordBatches(CA, gA) {
  return uniformlyDistributeChunksAcrossRecordBatches(CA, gA.map((AA) => AA.data.concat()));
}
function uniformlyDistributeChunksAcrossRecordBatches(CA, gA) {
  const AA = [...CA.fields], IA = [], BA = { numBatches: gA.reduce((eA, aA) => Math.max(eA, aA.length), 0) };
  let QA = 0, EA = 0, iA = -1;
  const oA = gA.length;
  let cA, tA = [];
  for (; BA.numBatches-- > 0; ) {
    for (EA = Number.POSITIVE_INFINITY, iA = -1; ++iA < oA; )
      tA[iA] = cA = gA[iA].shift(), EA = Math.min(EA, cA ? cA.length : EA);
    Number.isFinite(EA) && (tA = distributeChildren(AA, EA, tA, gA, BA), EA > 0 && (IA[QA++] = makeData({
      type: new Struct(AA),
      length: EA,
      nullCount: 0,
      children: tA.slice()
    })));
  }
  return [
    CA = CA.assign(AA),
    IA.map((eA) => new RecordBatch$1(CA, eA))
  ];
}
function distributeChildren(CA, gA, AA, IA, BA) {
  var QA;
  const EA = (gA + 63 & -64) >> 3;
  for (let iA = -1, oA = IA.length; ++iA < oA; ) {
    const cA = AA[iA], tA = cA?.length;
    if (tA >= gA)
      tA === gA ? AA[iA] = cA : (AA[iA] = cA.slice(0, gA), BA.numBatches = Math.max(BA.numBatches, IA[iA].unshift(cA.slice(gA, tA - gA))));
    else {
      const eA = CA[iA];
      CA[iA] = eA.clone({ nullable: !0 }), AA[iA] = (QA = cA?._changeLengthAndBackfillNullBitmap(gA)) !== null && QA !== void 0 ? QA : makeData({
        type: eA.type,
        length: gA,
        nullCount: gA,
        nullBitmap: new Uint8Array(EA)
      });
    }
  }
  return AA;
}
var _a$2;
let Table$2 = class $I {
  constructor(...gA) {
    var AA, IA;
    if (gA.length === 0)
      return this.batches = [], this.schema = new Schema$2([]), this._offsets = [0], this;
    let BA, QA;
    gA[0] instanceof Schema$2 && (BA = gA.shift()), gA.at(-1) instanceof Uint32Array && (QA = gA.pop());
    const EA = (oA) => {
      if (oA) {
        if (oA instanceof RecordBatch$1)
          return [oA];
        if (oA instanceof $I)
          return oA.batches;
        if (oA instanceof Data) {
          if (oA.type instanceof Struct)
            return [new RecordBatch$1(new Schema$2(oA.type.children), oA)];
        } else {
          if (Array.isArray(oA))
            return oA.flatMap((cA) => EA(cA));
          if (typeof oA[Symbol.iterator] == "function")
            return [...oA].flatMap((cA) => EA(cA));
          if (typeof oA == "object") {
            const cA = Object.keys(oA), tA = cA.map((GA) => new Vector([oA[GA]])), eA = BA ?? new Schema$2(cA.map((GA, lA) => new Field(String(GA), tA[lA].type, tA[lA].nullable))), [, aA] = distributeVectorsIntoRecordBatches(eA, tA);
            return aA.length === 0 ? [new RecordBatch$1(oA)] : aA;
          }
        }
      }
      return [];
    }, iA = gA.flatMap((oA) => EA(oA));
    if (BA = (IA = BA ?? ((AA = iA[0]) === null || AA === void 0 ? void 0 : AA.schema)) !== null && IA !== void 0 ? IA : new Schema$2([]), !(BA instanceof Schema$2))
      throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
    for (const oA of iA) {
      if (!(oA instanceof RecordBatch$1))
        throw new TypeError("Table constructor expects a [Schema, RecordBatch[]] pair.");
      if (!compareSchemas(BA, oA.schema))
        throw new TypeError("Table and inner RecordBatch schemas must be equivalent.");
    }
    this.schema = BA, this.batches = iA, this._offsets = QA ?? computeChunkOffsets(this.data);
  }
  /**
   * The contiguous {@link RecordBatch `RecordBatch`} chunks of the Table rows.
   */
  get data() {
    return this.batches.map(({ data: gA }) => gA);
  }
  /**
   * The number of columns in this Table.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this Table.
   */
  get numRows() {
    return this.data.reduce((gA, AA) => gA + AA.length, 0);
  }
  /**
   * The number of null rows in this Table.
   */
  get nullCount() {
    return this._nullCount === -1 && (this._nullCount = computeChunkNullCounts(this.data)), this._nullCount;
  }
  /**
   * Check whether an element is null.
   *
   * @param index The index at which to read the validity bitmap.
   */
  // @ts-ignore
  isValid(gA) {
    return !1;
  }
  /**
   * Get an element value by position.
   *
   * @param index The index of the element to read.
   */
  // @ts-ignore
  get(gA) {
    return null;
  }
  /**
    * Get an element value by position.
    * @param index The index of the element to read. A negative index will count back from the last element.
    */
  // @ts-ignore
  at(gA) {
    return this.get(wrapIndex(gA, this.numRows));
  }
  /**
   * Set an element value by position.
   *
   * @param index The index of the element to write.
   * @param value The value to set.
   */
  // @ts-ignore
  set(gA, AA) {
  }
  /**
   * Retrieve the index of the first occurrence of a value in an Vector.
   *
   * @param element The value to locate in the Vector.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  // @ts-ignore
  indexOf(gA, AA) {
    return -1;
  }
  /**
   * Iterator for rows in this Table.
   */
  [Symbol.iterator]() {
    return this.batches.length > 0 ? instance$2.visit(new Vector(this.data)) : new Array(0)[Symbol.iterator]();
  }
  /**
   * Return a JavaScript Array of the Table rows.
   *
   * @returns An Array of Table rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Returns a string representation of the Table rows.
   *
   * @returns A string representation of the Table rows.
   */
  toString() {
    return `[
  ${this.toArray().join(`,
  `)}
]`;
  }
  /**
   * Combines two or more Tables of the same schema.
   *
   * @param others Additional Tables to add to the end of this Tables.
   */
  concat(...gA) {
    const AA = this.schema, IA = this.data.concat(gA.flatMap(({ data: BA }) => BA));
    return new $I(AA, IA.map((BA) => new RecordBatch$1(AA, BA)));
  }
  /**
   * Return a zero-copy sub-section of this Table.
   *
   * @param begin The beginning of the specified portion of the Table.
   * @param end The end of the specified portion of the Table. This is exclusive of the element at the index 'end'.
   */
  slice(gA, AA) {
    const IA = this.schema;
    [gA, AA] = clampRange({ length: this.numRows }, gA, AA);
    const BA = sliceChunks$1(this.data, this._offsets, gA, AA);
    return new $I(IA, BA.map((QA) => new RecordBatch$1(IA, QA)));
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   *
   * @param name The name of the child to retrieve.
   */
  getChild(gA) {
    return this.getChildAt(this.schema.fields.findIndex((AA) => AA.name === gA));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   *
   * @param index The index of the child to retrieve.
   */
  getChildAt(gA) {
    if (gA > -1 && gA < this.schema.fields.length) {
      const AA = this.data.map((IA) => IA.children[gA]);
      if (AA.length === 0) {
        const { type: IA } = this.schema.fields[gA], BA = makeData({ type: IA, length: 0, nullCount: 0 });
        AA.push(BA._changeLengthAndBackfillNullBitmap(this.numRows));
      }
      return new Vector(AA);
    }
    return null;
  }
  /**
   * Sets a child Vector by name.
   *
   * @param name The name of the child to overwrite.
   * @returns A new Table with the supplied child for the specified name.
   */
  setChild(gA, AA) {
    var IA;
    return this.setChildAt((IA = this.schema.fields) === null || IA === void 0 ? void 0 : IA.findIndex((BA) => BA.name === gA), AA);
  }
  setChildAt(gA, AA) {
    let IA = this.schema, BA = [...this.batches];
    if (gA > -1 && gA < this.numCols) {
      AA || (AA = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const QA = IA.fields.slice(), EA = QA[gA].clone({ type: AA.type }), iA = this.schema.fields.map((oA, cA) => this.getChildAt(cA));
      [QA[gA], iA[gA]] = [EA, AA], [IA, BA] = distributeVectorsIntoRecordBatches(IA, iA);
    }
    return new $I(IA, BA);
  }
  /**
   * Construct a new Table containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new Table of columns matching the specified names.
   */
  select(gA) {
    const AA = this.schema.fields.reduce((IA, BA, QA) => IA.set(BA.name, QA), /* @__PURE__ */ new Map());
    return this.selectAt(gA.map((IA) => AA.get(IA)).filter((IA) => IA > -1));
  }
  /**
   * Construct a new Table containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new Table of columns at the specified indices.
   */
  selectAt(gA) {
    const AA = this.schema.selectAt(gA), IA = this.batches.map((BA) => BA.selectAt(gA));
    return new $I(AA, IA);
  }
  assign(gA) {
    const AA = this.schema.fields, [IA, BA] = gA.schema.fields.reduce((iA, oA, cA) => {
      const [tA, eA] = iA, aA = AA.findIndex((GA) => GA.name === oA.name);
      return ~aA ? eA[aA] = cA : tA.push(cA), iA;
    }, [[], []]), QA = this.schema.assign(gA.schema), EA = [
      ...AA.map((iA, oA) => [oA, BA[oA]]).map(([iA, oA]) => oA === void 0 ? this.getChildAt(iA) : gA.getChildAt(oA)),
      ...IA.map((iA) => gA.getChildAt(iA))
    ].filter(Boolean);
    return new $I(...distributeVectorsIntoRecordBatches(QA, EA));
  }
};
_a$2 = Symbol.toStringTag;
Table$2[_a$2] = ((CA) => (CA.schema = null, CA.batches = [], CA._offsets = new Uint32Array([0]), CA._nullCount = -1, CA[Symbol.isConcatSpreadable] = !0, CA.isValid = wrapChunkedCall1(isChunkedValid), CA.get = wrapChunkedCall1(instance$4.getVisitFn(Type.Struct)), CA.set = wrapChunkedCall2(instance$5.getVisitFn(Type.Struct)), CA.indexOf = wrapChunkedIndexOf(instance$3.getVisitFn(Type.Struct)), "Table"))(Table$2.prototype);
var _a$1;
let RecordBatch$1 = class ng {
  constructor(...gA) {
    switch (gA.length) {
      case 2: {
        if ([this.schema] = gA, !(this.schema instanceof Schema$2))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        if ([
          ,
          this.data = makeData({
            nullCount: 0,
            type: new Struct(this.schema.fields),
            children: this.schema.fields.map((AA) => makeData({ type: AA.type, nullCount: 0 }))
          })
        ] = gA, !(this.data instanceof Data))
          throw new TypeError("RecordBatch constructor expects a [Schema, Data] pair.");
        [this.schema, this.data] = ensureSameLengthData(this.schema, this.data.children);
        break;
      }
      case 1: {
        const [AA] = gA, { fields: IA, children: BA, length: QA } = Object.keys(AA).reduce((oA, cA, tA) => (oA.children[tA] = AA[cA], oA.length = Math.max(oA.length, AA[cA].length), oA.fields[tA] = Field.new({ name: cA, type: AA[cA].type, nullable: !0 }), oA), {
          length: 0,
          fields: new Array(),
          children: new Array()
        }), EA = new Schema$2(IA), iA = makeData({ type: new Struct(IA), length: QA, children: BA, nullCount: 0 });
        [this.schema, this.data] = ensureSameLengthData(EA, iA.children, QA);
        break;
      }
      default:
        throw new TypeError("RecordBatch constructor expects an Object mapping names to child Data, or a [Schema, Data] pair.");
    }
  }
  get dictionaries() {
    return this._dictionaries || (this._dictionaries = collectDictionaries(this.schema.fields, this.data.children));
  }
  /**
   * The number of columns in this RecordBatch.
   */
  get numCols() {
    return this.schema.fields.length;
  }
  /**
   * The number of rows in this RecordBatch.
   */
  get numRows() {
    return this.data.length;
  }
  /**
   * The number of null rows in this RecordBatch.
   */
  get nullCount() {
    return this.data.nullCount;
  }
  /**
   * Check whether an row is null.
   * @param index The index at which to read the validity bitmap.
   */
  isValid(gA) {
    return this.data.getValid(gA);
  }
  /**
   * Get a row by position.
   * @param index The index of the row to read.
   */
  get(gA) {
    return instance$4.visit(this.data, gA);
  }
  /**
    * Get a row value by position.
    * @param index The index of the row to read. A negative index will count back from the last row.
    */
  at(gA) {
    return this.get(wrapIndex(gA, this.numRows));
  }
  /**
   * Set a row by position.
   * @param index The index of the row to write.
   * @param value The value to set.
   */
  set(gA, AA) {
    return instance$5.visit(this.data, gA, AA);
  }
  /**
   * Retrieve the index of the first occurrence of a row in an RecordBatch.
   * @param element The row to locate in the RecordBatch.
   * @param offset The index at which to begin the search. If offset is omitted, the search starts at index 0.
   */
  indexOf(gA, AA) {
    return instance$3.visit(this.data, gA, AA);
  }
  /**
   * Iterator for rows in this RecordBatch.
   */
  [Symbol.iterator]() {
    return instance$2.visit(new Vector([this.data]));
  }
  /**
   * Return a JavaScript Array of the RecordBatch rows.
   * @returns An Array of RecordBatch rows.
   */
  toArray() {
    return [...this];
  }
  /**
   * Combines two or more RecordBatch of the same schema.
   * @param others Additional RecordBatch to add to the end of this RecordBatch.
   */
  concat(...gA) {
    return new Table$2(this.schema, [this, ...gA]);
  }
  /**
   * Return a zero-copy sub-section of this RecordBatch.
   * @param start The beginning of the specified portion of the RecordBatch.
   * @param end The end of the specified portion of the RecordBatch. This is exclusive of the row at the index 'end'.
   */
  slice(gA, AA) {
    const [IA] = new Vector([this.data]).slice(gA, AA).data;
    return new ng(this.schema, IA);
  }
  /**
   * Returns a child Vector by name, or null if this Vector has no child with the given name.
   * @param name The name of the child to retrieve.
   */
  getChild(gA) {
    var AA;
    return this.getChildAt((AA = this.schema.fields) === null || AA === void 0 ? void 0 : AA.findIndex((IA) => IA.name === gA));
  }
  /**
   * Returns a child Vector by index, or null if this Vector has no child at the supplied index.
   * @param index The index of the child to retrieve.
   */
  getChildAt(gA) {
    return gA > -1 && gA < this.schema.fields.length ? new Vector([this.data.children[gA]]) : null;
  }
  /**
   * Sets a child Vector by name.
   * @param name The name of the child to overwrite.
   * @returns A new RecordBatch with the new child for the specified name.
   */
  setChild(gA, AA) {
    var IA;
    return this.setChildAt((IA = this.schema.fields) === null || IA === void 0 ? void 0 : IA.findIndex((BA) => BA.name === gA), AA);
  }
  setChildAt(gA, AA) {
    let IA = this.schema, BA = this.data;
    if (gA > -1 && gA < this.numCols) {
      AA || (AA = new Vector([makeData({ type: new Null(), length: this.numRows })]));
      const QA = IA.fields.slice(), EA = BA.children.slice(), iA = QA[gA].clone({ type: AA.type });
      [QA[gA], EA[gA]] = [iA, AA.data[0]], IA = new Schema$2(QA, new Map(this.schema.metadata)), BA = makeData({ type: new Struct(QA), children: EA });
    }
    return new ng(IA, BA);
  }
  /**
   * Construct a new RecordBatch containing only specified columns.
   *
   * @param columnNames Names of columns to keep.
   * @returns A new RecordBatch of columns matching the specified names.
   */
  select(gA) {
    const AA = this.schema.select(gA), IA = new Struct(AA.fields), BA = [];
    for (const QA of gA) {
      const EA = this.schema.fields.findIndex((iA) => iA.name === QA);
      ~EA && (BA[EA] = this.data.children[EA]);
    }
    return new ng(AA, makeData({ type: IA, length: this.numRows, children: BA }));
  }
  /**
   * Construct a new RecordBatch containing only columns at the specified indices.
   *
   * @param columnIndices Indices of columns to keep.
   * @returns A new RecordBatch of columns matching at the specified indices.
   */
  selectAt(gA) {
    const AA = this.schema.selectAt(gA), IA = gA.map((QA) => this.data.children[QA]).filter(Boolean), BA = makeData({ type: new Struct(AA.fields), length: this.numRows, children: IA });
    return new ng(AA, BA);
  }
};
_a$1 = Symbol.toStringTag;
RecordBatch$1[_a$1] = ((CA) => (CA._nullCount = -1, CA[Symbol.isConcatSpreadable] = !0, "RecordBatch"))(RecordBatch$1.prototype);
function ensureSameLengthData(CA, gA, AA = gA.reduce((IA, BA) => Math.max(IA, BA.length), 0)) {
  var IA;
  const BA = [...CA.fields], QA = [...gA], EA = (AA + 63 & -64) >> 3;
  for (const [iA, oA] of CA.fields.entries()) {
    const cA = gA[iA];
    (!cA || cA.length !== AA) && (BA[iA] = oA.clone({ nullable: !0 }), QA[iA] = (IA = cA?._changeLengthAndBackfillNullBitmap(AA)) !== null && IA !== void 0 ? IA : makeData({
      type: oA.type,
      length: AA,
      nullCount: AA,
      nullBitmap: new Uint8Array(EA)
    }));
  }
  return [
    CA.assign(BA),
    makeData({ type: new Struct(BA), length: AA, children: QA })
  ];
}
function collectDictionaries(CA, gA, AA = /* @__PURE__ */ new Map()) {
  var IA, BA;
  if (((IA = CA?.length) !== null && IA !== void 0 ? IA : 0) > 0 && CA?.length === gA?.length)
    for (let QA = -1, EA = CA.length; ++QA < EA; ) {
      const { type: iA } = CA[QA], oA = gA[QA];
      for (const cA of [oA, ...((BA = oA?.dictionary) === null || BA === void 0 ? void 0 : BA.data) || []])
        collectDictionaries(iA.children, cA?.children, AA);
      if (DataType.isDictionary(iA)) {
        const { id: cA } = iA;
        if (!AA.has(cA))
          oA?.dictionary && AA.set(cA, oA.dictionary);
        else if (AA.get(cA) !== oA.dictionary)
          throw new Error("Cannot create Schema containing two different dictionaries with the same Id");
      }
    }
  return AA;
}
class _InternalEmptyPlaceholderRecordBatch extends RecordBatch$1 {
  constructor(gA) {
    const AA = gA.fields.map((BA) => makeData({ type: BA.type })), IA = makeData({ type: new Struct(gA.fields), nullCount: 0, children: AA });
    super(gA, IA);
  }
}
const invalidMessageType = (CA) => `Expected ${MessageHeader[CA]} Message in stream, but was null or length 0.`, nullMessage = (CA) => `Header pointer of flatbuffer-encoded ${MessageHeader[CA]} Message is null or length 0.`, invalidMessageMetadata = (CA, gA) => `Expected to read ${CA} metadata bytes, but only read ${gA}.`, invalidMessageBodyLength = (CA, gA) => `Expected to read ${CA} bytes for message body, but only read ${gA}.`;
class MessageReader {
  constructor(gA) {
    this.source = gA instanceof ByteStream ? gA : new ByteStream(gA);
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let gA;
    return (gA = this.readMetadataLength()).done || gA.value === -1 && (gA = this.readMetadataLength()).done || (gA = this.readMetadata(gA.value)).done ? ITERATOR_DONE : gA;
  }
  throw(gA) {
    return this.source.throw(gA);
  }
  return(gA) {
    return this.source.return(gA);
  }
  readMessage(gA) {
    let AA;
    if ((AA = this.next()).done)
      return null;
    if (gA != null && AA.value.headerType !== gA)
      throw new Error(invalidMessageType(gA));
    return AA.value;
  }
  readMessageBody(gA) {
    if (gA <= 0)
      return new Uint8Array(0);
    const AA = toUint8Array(this.source.read(gA));
    if (AA.byteLength < gA)
      throw new Error(invalidMessageBodyLength(gA, AA.byteLength));
    return (
      /* 1. */
      AA.byteOffset % 8 === 0 && /* 2. */
      AA.byteOffset + AA.byteLength <= AA.buffer.byteLength ? AA : AA.slice()
    );
  }
  readSchema(gA = !1) {
    const AA = MessageHeader.Schema, IA = this.readMessage(AA), BA = IA?.header();
    if (gA && !BA)
      throw new Error(nullMessage(AA));
    return BA;
  }
  readMetadataLength() {
    const gA = this.source.read(PADDING), AA = gA && new ByteBuffer$2(gA), IA = AA?.readInt32(0) || 0;
    return { done: IA === 0, value: IA };
  }
  readMetadata(gA) {
    const AA = this.source.read(gA);
    if (!AA)
      return ITERATOR_DONE;
    if (AA.byteLength < gA)
      throw new Error(invalidMessageMetadata(gA, AA.byteLength));
    return { done: !1, value: Message.decode(AA) };
  }
}
class AsyncMessageReader {
  constructor(gA, AA) {
    this.source = gA instanceof AsyncByteStream ? gA : isFileHandle(gA) ? new AsyncRandomAccessFile(gA, AA) : new AsyncByteStream(gA);
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      let gA;
      return (gA = yield this.readMetadataLength()).done || gA.value === -1 && (gA = yield this.readMetadataLength()).done || (gA = yield this.readMetadata(gA.value)).done ? ITERATOR_DONE : gA;
    });
  }
  throw(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.throw(gA);
    });
  }
  return(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.source.return(gA);
    });
  }
  readMessage(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      let AA;
      if ((AA = yield this.next()).done)
        return null;
      if (gA != null && AA.value.headerType !== gA)
        throw new Error(invalidMessageType(gA));
      return AA.value;
    });
  }
  readMessageBody(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      if (gA <= 0)
        return new Uint8Array(0);
      const AA = toUint8Array(yield this.source.read(gA));
      if (AA.byteLength < gA)
        throw new Error(invalidMessageBodyLength(gA, AA.byteLength));
      return (
        /* 1. */
        AA.byteOffset % 8 === 0 && /* 2. */
        AA.byteOffset + AA.byteLength <= AA.buffer.byteLength ? AA : AA.slice()
      );
    });
  }
  readSchema() {
    return __awaiter(this, arguments, void 0, function* (gA = !1) {
      const AA = MessageHeader.Schema, IA = yield this.readMessage(AA), BA = IA?.header();
      if (gA && !BA)
        throw new Error(nullMessage(AA));
      return BA;
    });
  }
  readMetadataLength() {
    return __awaiter(this, void 0, void 0, function* () {
      const gA = yield this.source.read(PADDING), AA = gA && new ByteBuffer$2(gA), IA = AA?.readInt32(0) || 0;
      return { done: IA === 0, value: IA };
    });
  }
  readMetadata(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      const AA = yield this.source.read(gA);
      if (!AA)
        return ITERATOR_DONE;
      if (AA.byteLength < gA)
        throw new Error(invalidMessageMetadata(gA, AA.byteLength));
      return { done: !1, value: Message.decode(AA) };
    });
  }
}
class JSONMessageReader extends MessageReader {
  constructor(gA) {
    super(new Uint8Array(0)), this._schema = !1, this._body = [], this._batchIndex = 0, this._dictionaryIndex = 0, this._json = gA instanceof ArrowJSON ? gA : new ArrowJSON(gA);
  }
  next() {
    const { _json: gA } = this;
    if (!this._schema)
      return this._schema = !0, { done: !1, value: Message.fromJSON(gA.schema, MessageHeader.Schema) };
    if (this._dictionaryIndex < gA.dictionaries.length) {
      const AA = gA.dictionaries[this._dictionaryIndex++];
      return this._body = AA.data.columns, { done: !1, value: Message.fromJSON(AA, MessageHeader.DictionaryBatch) };
    }
    if (this._batchIndex < gA.batches.length) {
      const AA = gA.batches[this._batchIndex++];
      return this._body = AA.columns, { done: !1, value: Message.fromJSON(AA, MessageHeader.RecordBatch) };
    }
    return this._body = [], ITERATOR_DONE;
  }
  readMessageBody(gA) {
    return AA(this._body);
    function AA(IA) {
      return (IA || []).reduce((BA, QA) => [
        ...BA,
        ...QA.VALIDITY && [QA.VALIDITY] || [],
        ...QA.TYPE_ID && [QA.TYPE_ID] || [],
        ...QA.OFFSET && [QA.OFFSET] || [],
        ...QA.DATA && [QA.DATA] || [],
        ...AA(QA.children)
      ], []);
    }
  }
  readMessage(gA) {
    let AA;
    if ((AA = this.next()).done)
      return null;
    if (gA != null && AA.value.headerType !== gA)
      throw new Error(invalidMessageType(gA));
    return AA.value;
  }
  readSchema() {
    const gA = MessageHeader.Schema, AA = this.readMessage(gA), IA = AA?.header();
    if (!AA || !IA)
      throw new Error(nullMessage(gA));
    return IA;
  }
}
const PADDING = 4, MAGIC_STR = "ARROW1", MAGIC = new Uint8Array(MAGIC_STR.length);
for (let CA = 0; CA < MAGIC_STR.length; CA += 1)
  MAGIC[CA] = MAGIC_STR.codePointAt(CA);
function checkForMagicArrowString(CA, gA = 0) {
  for (let AA = -1, IA = MAGIC.length; ++AA < IA; )
    if (MAGIC[AA] !== CA[gA + AA])
      return !1;
  return !0;
}
const magicLength = MAGIC.length, magicAndPadding = magicLength + PADDING, magicX2AndPadding = magicLength * 2 + PADDING;
class Lz4FrameValidator {
  constructor() {
    this.LZ4_FRAME_MAGIC = new Uint8Array([4, 34, 77, 24]), this.MIN_HEADER_LENGTH = 7;
  }
  isValidCodecEncode(gA) {
    const AA = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), IA = gA.encode(AA);
    return this._isValidCompressed(IA);
  }
  _isValidCompressed(gA) {
    return this._hasMinimumLength(gA) && this._hasValidMagicNumber(gA) && this._hasValidVersion(gA);
  }
  _hasMinimumLength(gA) {
    return gA.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(gA) {
    return this.LZ4_FRAME_MAGIC.every((AA, IA) => gA[IA] === AA);
  }
  _hasValidVersion(gA) {
    return (gA[4] & 192) >> 6 === 1;
  }
}
class ZstdValidator {
  constructor() {
    this.ZSTD_MAGIC = new Uint8Array([40, 181, 47, 253]), this.MIN_HEADER_LENGTH = 6;
  }
  isValidCodecEncode(gA) {
    const AA = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8]), IA = gA.encode(AA);
    return this._isValidCompressed(IA);
  }
  _isValidCompressed(gA) {
    return this._hasMinimumLength(gA) && this._hasValidMagicNumber(gA);
  }
  _hasMinimumLength(gA) {
    return gA.length >= this.MIN_HEADER_LENGTH;
  }
  _hasValidMagicNumber(gA) {
    return this.ZSTD_MAGIC.every((AA, IA) => gA[IA] === AA);
  }
}
const compressionValidators = {
  [CompressionType.LZ4_FRAME]: new Lz4FrameValidator(),
  [CompressionType.ZSTD]: new ZstdValidator()
};
class _CompressionRegistry {
  constructor() {
    this.registry = {};
  }
  set(gA, AA) {
    if (AA?.encode && typeof AA.encode == "function" && !compressionValidators[gA].isValidCodecEncode(AA))
      throw new Error(`Encoder for ${CompressionType[gA]} is not valid.`);
    this.registry[gA] = AA;
  }
  get(gA) {
    var AA;
    return ((AA = this.registry) === null || AA === void 0 ? void 0 : AA[gA]) || null;
  }
}
const compressionRegistry = new _CompressionRegistry(), LENGTH_NO_COMPRESSED_DATA = -1, COMPRESS_LENGTH_PREFIX = 8;
class RecordBatchReader extends ReadableInterop {
  constructor(gA) {
    super(), this._impl = gA;
  }
  get closed() {
    return this._impl.closed;
  }
  get schema() {
    return this._impl.schema;
  }
  get autoDestroy() {
    return this._impl.autoDestroy;
  }
  get dictionaries() {
    return this._impl.dictionaries;
  }
  get numDictionaries() {
    return this._impl.numDictionaries;
  }
  get numRecordBatches() {
    return this._impl.numRecordBatches;
  }
  get footer() {
    return this._impl.isFile() ? this._impl.footer : null;
  }
  isSync() {
    return this._impl.isSync();
  }
  isAsync() {
    return this._impl.isAsync();
  }
  isFile() {
    return this._impl.isFile();
  }
  isStream() {
    return this._impl.isStream();
  }
  next() {
    return this._impl.next();
  }
  throw(gA) {
    return this._impl.throw(gA);
  }
  return(gA) {
    return this._impl.return(gA);
  }
  cancel() {
    return this._impl.cancel();
  }
  reset(gA) {
    return this._impl.reset(gA), this._DOMStream = void 0, this._nodeStream = void 0, this;
  }
  open(gA) {
    const AA = this._impl.open(gA);
    return isPromise(AA) ? AA.then(() => this) : this;
  }
  readRecordBatch(gA) {
    return this._impl.isFile() ? this._impl.readRecordBatch(gA) : null;
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
  toDOMStream() {
    return streamAdapters.toDOMStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this });
  }
  toNodeStream() {
    return streamAdapters.toNodeStream(this.isSync() ? { [Symbol.iterator]: () => this } : { [Symbol.asyncIterator]: () => this }, { objectMode: !0 });
  }
  /** @nocollapse */
  // @ts-ignore
  static throughNode(gA) {
    throw new Error('"throughNode" not available in this environment');
  }
  /** @nocollapse */
  static throughDOM(gA, AA) {
    throw new Error('"throughDOM" not available in this environment');
  }
  /** @nocollapse */
  static from(gA) {
    return gA instanceof RecordBatchReader ? gA : isArrowJSON(gA) ? fromArrowJSON(gA) : isFileHandle(gA) ? fromFileHandle(gA) : isPromise(gA) ? __awaiter(this, void 0, void 0, function* () {
      return yield RecordBatchReader.from(yield gA);
    }) : isFetchResponse(gA) || isReadableDOMStream(gA) || isReadableNodeStream(gA) || isAsyncIterable$1(gA) ? fromAsyncByteStream(new AsyncByteStream(gA)) : fromByteStream(new ByteStream(gA));
  }
  /** @nocollapse */
  static readAll(gA) {
    return gA instanceof RecordBatchReader ? gA.isSync() ? readAllSync(gA) : readAllAsync(gA) : isArrowJSON(gA) || ArrayBuffer.isView(gA) || isIterable(gA) || isIteratorResult(gA) ? readAllSync(gA) : readAllAsync(gA);
  }
}
class RecordBatchStreamReader extends RecordBatchReader {
  constructor(gA) {
    super(gA), this._impl = gA;
  }
  readAll() {
    return [...this];
  }
  [Symbol.iterator]() {
    return this._impl[Symbol.iterator]();
  }
  [Symbol.asyncIterator]() {
    return __asyncGenerator(this, arguments, function* () {
      yield __await(yield* __asyncDelegator(__asyncValues(this[Symbol.iterator]())));
    });
  }
}
class AsyncRecordBatchStreamReader extends RecordBatchReader {
  constructor(gA) {
    super(gA), this._impl = gA;
  }
  readAll() {
    return __awaiter(this, void 0, void 0, function* () {
      var gA, AA, IA, BA;
      const QA = new Array();
      try {
        for (var EA = !0, iA = __asyncValues(this), oA; oA = yield iA.next(), gA = oA.done, !gA; EA = !0) {
          BA = oA.value, EA = !1;
          const cA = BA;
          QA.push(cA);
        }
      } catch (cA) {
        AA = { error: cA };
      } finally {
        try {
          !EA && !gA && (IA = iA.return) && (yield IA.call(iA));
        } finally {
          if (AA) throw AA.error;
        }
      }
      return QA;
    });
  }
  [Symbol.iterator]() {
    throw new Error("AsyncRecordBatchStreamReader is not Iterable");
  }
  [Symbol.asyncIterator]() {
    return this._impl[Symbol.asyncIterator]();
  }
}
class RecordBatchFileReader extends RecordBatchStreamReader {
  constructor(gA) {
    super(gA), this._impl = gA;
  }
}
class AsyncRecordBatchFileReader extends AsyncRecordBatchStreamReader {
  constructor(gA) {
    super(gA), this._impl = gA;
  }
}
class RecordBatchReaderImpl {
  get numDictionaries() {
    return this._dictionaryIndex;
  }
  get numRecordBatches() {
    return this._recordBatchIndex;
  }
  constructor(gA = /* @__PURE__ */ new Map()) {
    this.closed = !1, this.autoDestroy = !0, this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.dictionaries = gA;
  }
  isSync() {
    return !1;
  }
  isAsync() {
    return !1;
  }
  isFile() {
    return !1;
  }
  isStream() {
    return !1;
  }
  reset(gA) {
    return this._dictionaryIndex = 0, this._recordBatchIndex = 0, this.schema = gA, this.dictionaries = /* @__PURE__ */ new Map(), this;
  }
  _loadRecordBatch(gA, AA) {
    let IA;
    if (gA.compression != null) {
      const QA = compressionRegistry.get(gA.compression.type);
      if (QA?.decode && typeof QA.decode == "function") {
        const { decommpressedBody: EA, buffers: iA } = this._decompressBuffers(gA, AA, QA);
        IA = this._loadCompressedVectors(gA, EA, this.schema.fields), gA = new RecordBatch$2(gA.length, gA.nodes, iA, null);
      } else
        throw new Error("Record batch is compressed but codec not found");
    } else
      IA = this._loadVectors(gA, AA, this.schema.fields);
    const BA = makeData({ type: new Struct(this.schema.fields), length: gA.length, children: IA });
    return new RecordBatch$1(this.schema, BA);
  }
  _loadDictionaryBatch(gA, AA) {
    const { id: IA, isDelta: BA } = gA, { dictionaries: QA, schema: EA } = this, iA = QA.get(IA), oA = EA.dictionaries.get(IA);
    let cA;
    if (gA.data.compression != null) {
      const tA = compressionRegistry.get(gA.data.compression.type);
      if (tA?.decode && typeof tA.decode == "function") {
        const { decommpressedBody: eA, buffers: aA } = this._decompressBuffers(gA.data, AA, tA);
        cA = this._loadCompressedVectors(gA.data, eA, [oA]), gA = new DictionaryBatch(new RecordBatch$2(gA.data.length, gA.data.nodes, aA, null), IA, BA);
      } else
        throw new Error("Dictionary batch is compressed but codec not found");
    } else
      cA = this._loadVectors(gA.data, AA, [oA]);
    return (iA && BA ? iA.concat(new Vector(cA)) : new Vector(cA)).memoize();
  }
  _loadVectors(gA, AA, IA) {
    return new VectorLoader(AA, gA.nodes, gA.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(IA);
  }
  _loadCompressedVectors(gA, AA, IA) {
    return new CompressedVectorLoader(AA, gA.nodes, gA.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(IA);
  }
  _decompressBuffers(gA, AA, IA) {
    const BA = [], QA = [];
    let EA = 0;
    for (const { offset: iA, length: oA } of gA.buffers) {
      if (oA === 0) {
        BA.push(new Uint8Array(0)), QA.push(new BufferRegion(EA, 0));
        continue;
      }
      const cA = new ByteBuffer$2(AA.subarray(iA, iA + oA)), tA = bigIntToNumber(cA.readInt64(0)), eA = cA.bytes().subarray(COMPRESS_LENGTH_PREFIX), aA = tA === LENGTH_NO_COMPRESSED_DATA ? eA : IA.decode(eA);
      BA.push(aA);
      const GA = (EA + 7 & -8) - EA;
      EA += GA, QA.push(new BufferRegion(EA, aA.length)), EA += aA.length;
    }
    return {
      decommpressedBody: BA,
      buffers: QA
    };
  }
}
class RecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(gA, AA) {
    super(AA), this._reader = isArrowJSON(gA) ? new JSONMessageReader(this._handle = gA) : new MessageReader(this._handle = gA);
  }
  isSync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.iterator]() {
    return this;
  }
  cancel() {
    !this.closed && (this.closed = !0) && (this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
  }
  open(gA) {
    return this.closed || (this.autoDestroy = shouldAutoDestroy(this, gA), this.schema || (this.schema = this._reader.readSchema()) || this.cancel()), this;
  }
  throw(gA) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.throw(gA) : ITERATOR_DONE;
  }
  return(gA) {
    return !this.closed && this.autoDestroy && (this.closed = !0) ? this.reset()._reader.return(gA) : ITERATOR_DONE;
  }
  next() {
    if (this.closed)
      return ITERATOR_DONE;
    let gA;
    const { _reader: AA } = this;
    for (; gA = this._readNextMessageAndValidate(); )
      if (gA.isSchema())
        this.reset(gA.header());
      else if (gA.isRecordBatch()) {
        this._recordBatchIndex++;
        const IA = gA.header(), BA = AA.readMessageBody(gA.bodyLength);
        return { done: !1, value: this._loadRecordBatch(IA, BA) };
      } else if (gA.isDictionaryBatch()) {
        this._dictionaryIndex++;
        const IA = gA.header(), BA = AA.readMessageBody(gA.bodyLength), QA = this._loadDictionaryBatch(IA, BA);
        this.dictionaries.set(IA.id, QA);
      }
    return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : this.return();
  }
  _readNextMessageAndValidate(gA) {
    return this._reader.readMessage(gA);
  }
}
class AsyncRecordBatchStreamReaderImpl extends RecordBatchReaderImpl {
  constructor(gA, AA) {
    super(AA), this._reader = new AsyncMessageReader(this._handle = gA);
  }
  isAsync() {
    return !0;
  }
  isStream() {
    return !0;
  }
  [Symbol.asyncIterator]() {
    return this;
  }
  cancel() {
    return __awaiter(this, void 0, void 0, function* () {
      !this.closed && (this.closed = !0) && (yield this.reset()._reader.return(), this._reader = null, this.dictionaries = null);
    });
  }
  open(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return this.closed || (this.autoDestroy = shouldAutoDestroy(this, gA), this.schema || (this.schema = yield this._reader.readSchema()) || (yield this.cancel())), this;
    });
  }
  throw(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.throw(gA) : ITERATOR_DONE;
    });
  }
  return(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return !this.closed && this.autoDestroy && (this.closed = !0) ? yield this.reset()._reader.return(gA) : ITERATOR_DONE;
    });
  }
  next() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.closed)
        return ITERATOR_DONE;
      let gA;
      const { _reader: AA } = this;
      for (; gA = yield this._readNextMessageAndValidate(); )
        if (gA.isSchema())
          yield this.reset(gA.header());
        else if (gA.isRecordBatch()) {
          this._recordBatchIndex++;
          const IA = gA.header(), BA = yield AA.readMessageBody(gA.bodyLength);
          return { done: !1, value: this._loadRecordBatch(IA, BA) };
        } else if (gA.isDictionaryBatch()) {
          this._dictionaryIndex++;
          const IA = gA.header(), BA = yield AA.readMessageBody(gA.bodyLength), QA = this._loadDictionaryBatch(IA, BA);
          this.dictionaries.set(IA.id, QA);
        }
      return this.schema && this._recordBatchIndex === 0 ? (this._recordBatchIndex++, { done: !1, value: new _InternalEmptyPlaceholderRecordBatch(this.schema) }) : yield this.return();
    });
  }
  _readNextMessageAndValidate(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this._reader.readMessage(gA);
    });
  }
}
class RecordBatchFileReaderImpl extends RecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(gA, AA) {
    super(gA instanceof RandomAccessFile ? gA : new RandomAccessFile(gA), AA);
  }
  isSync() {
    return !0;
  }
  isFile() {
    return !0;
  }
  open(gA) {
    if (!this.closed && !this._footer) {
      this.schema = (this._footer = this._readFooter()).schema;
      for (const AA of this._footer.dictionaryBatches())
        AA && this._readDictionaryBatch(this._dictionaryIndex++);
    }
    return super.open(gA);
  }
  readRecordBatch(gA) {
    var AA;
    if (this.closed)
      return null;
    this._footer || this.open();
    const IA = (AA = this._footer) === null || AA === void 0 ? void 0 : AA.getRecordBatch(gA);
    if (IA && this._handle.seek(IA.offset)) {
      const BA = this._reader.readMessage(MessageHeader.RecordBatch);
      if (BA?.isRecordBatch()) {
        const QA = BA.header(), EA = this._reader.readMessageBody(BA.bodyLength);
        return this._loadRecordBatch(QA, EA);
      }
    }
    return null;
  }
  _readDictionaryBatch(gA) {
    var AA;
    const IA = (AA = this._footer) === null || AA === void 0 ? void 0 : AA.getDictionaryBatch(gA);
    if (IA && this._handle.seek(IA.offset)) {
      const BA = this._reader.readMessage(MessageHeader.DictionaryBatch);
      if (BA?.isDictionaryBatch()) {
        const QA = BA.header(), EA = this._reader.readMessageBody(BA.bodyLength), iA = this._loadDictionaryBatch(QA, EA);
        this.dictionaries.set(QA.id, iA);
      }
    }
  }
  _readFooter() {
    const { _handle: gA } = this, AA = gA.size - magicAndPadding, IA = gA.readInt32(AA), BA = gA.readAt(AA - IA, IA);
    return Footer_.decode(BA);
  }
  _readNextMessageAndValidate(gA) {
    var AA;
    if (this._footer || this.open(), this._footer && this._recordBatchIndex < this.numRecordBatches) {
      const IA = (AA = this._footer) === null || AA === void 0 ? void 0 : AA.getRecordBatch(this._recordBatchIndex);
      if (IA && this._handle.seek(IA.offset))
        return this._reader.readMessage(gA);
    }
    return null;
  }
}
class AsyncRecordBatchFileReaderImpl extends AsyncRecordBatchStreamReaderImpl {
  get footer() {
    return this._footer;
  }
  get numDictionaries() {
    return this._footer ? this._footer.numDictionaries : 0;
  }
  get numRecordBatches() {
    return this._footer ? this._footer.numRecordBatches : 0;
  }
  constructor(gA, ...AA) {
    const IA = typeof AA[0] != "number" ? AA.shift() : void 0, BA = AA[0] instanceof Map ? AA.shift() : void 0;
    super(gA instanceof AsyncRandomAccessFile ? gA : new AsyncRandomAccessFile(gA, IA), BA);
  }
  isFile() {
    return !0;
  }
  isAsync() {
    return !0;
  }
  open(gA) {
    const AA = Object.create(null, {
      open: { get: () => super.open }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.closed && !this._footer) {
        this.schema = (this._footer = yield this._readFooter()).schema;
        for (const IA of this._footer.dictionaryBatches())
          IA && (yield this._readDictionaryBatch(this._dictionaryIndex++));
      }
      return yield AA.open.call(this, gA);
    });
  }
  readRecordBatch(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      var AA;
      if (this.closed)
        return null;
      this._footer || (yield this.open());
      const IA = (AA = this._footer) === null || AA === void 0 ? void 0 : AA.getRecordBatch(gA);
      if (IA && (yield this._handle.seek(IA.offset))) {
        const BA = yield this._reader.readMessage(MessageHeader.RecordBatch);
        if (BA?.isRecordBatch()) {
          const QA = BA.header(), EA = yield this._reader.readMessageBody(BA.bodyLength);
          return this._loadRecordBatch(QA, EA);
        }
      }
      return null;
    });
  }
  _readDictionaryBatch(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      var AA;
      const IA = (AA = this._footer) === null || AA === void 0 ? void 0 : AA.getDictionaryBatch(gA);
      if (IA && (yield this._handle.seek(IA.offset))) {
        const BA = yield this._reader.readMessage(MessageHeader.DictionaryBatch);
        if (BA?.isDictionaryBatch()) {
          const QA = BA.header(), EA = yield this._reader.readMessageBody(BA.bodyLength), iA = this._loadDictionaryBatch(QA, EA);
          this.dictionaries.set(QA.id, iA);
        }
      }
    });
  }
  _readFooter() {
    return __awaiter(this, void 0, void 0, function* () {
      const { _handle: gA } = this;
      gA._pending && (yield gA._pending);
      const AA = gA.size - magicAndPadding, IA = yield gA.readInt32(AA), BA = yield gA.readAt(AA - IA, IA);
      return Footer_.decode(BA);
    });
  }
  _readNextMessageAndValidate(gA) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._footer || (yield this.open()), this._footer && this._recordBatchIndex < this.numRecordBatches) {
        const AA = this._footer.getRecordBatch(this._recordBatchIndex);
        if (AA && (yield this._handle.seek(AA.offset)))
          return yield this._reader.readMessage(gA);
      }
      return null;
    });
  }
}
class RecordBatchJSONReaderImpl extends RecordBatchStreamReaderImpl {
  constructor(gA, AA) {
    super(gA, AA);
  }
  _loadVectors(gA, AA, IA) {
    return new JSONVectorLoader(AA, gA.nodes, gA.buffers, this.dictionaries, this.schema.metadataVersion).visitMany(IA);
  }
}
function shouldAutoDestroy(CA, gA) {
  return gA && typeof gA.autoDestroy == "boolean" ? gA.autoDestroy : CA.autoDestroy;
}
function* readAllSync(CA) {
  const gA = RecordBatchReader.from(CA);
  try {
    if (!gA.open({ autoDestroy: !1 }).closed)
      do
        yield gA;
      while (!gA.reset().open().closed);
  } finally {
    gA.cancel();
  }
}
function readAllAsync(CA) {
  return __asyncGenerator(this, arguments, function* () {
    const AA = yield __await(RecordBatchReader.from(CA));
    try {
      if (!(yield __await(AA.open({ autoDestroy: !1 }))).closed)
        do
          yield yield __await(AA);
        while (!(yield __await(AA.reset().open())).closed);
    } finally {
      yield __await(AA.cancel());
    }
  });
}
function fromArrowJSON(CA) {
  return new RecordBatchStreamReader(new RecordBatchJSONReaderImpl(CA));
}
function fromByteStream(CA) {
  const gA = CA.peek(magicLength + 7 & -8);
  return gA && gA.byteLength >= 4 ? checkForMagicArrowString(gA) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(CA.read())) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl(CA)) : new RecordBatchStreamReader(new RecordBatchStreamReaderImpl((function* () {
  })()));
}
function fromAsyncByteStream(CA) {
  return __awaiter(this, void 0, void 0, function* () {
    const gA = yield CA.peek(magicLength + 7 & -8);
    return gA && gA.byteLength >= 4 ? checkForMagicArrowString(gA) ? new RecordBatchFileReader(new RecordBatchFileReaderImpl(yield CA.read())) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(CA)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl((function() {
      return __asyncGenerator(this, arguments, function* () {
      });
    })()));
  });
}
function fromFileHandle(CA) {
  return __awaiter(this, void 0, void 0, function* () {
    const { size: gA } = yield CA.stat(), AA = new AsyncRandomAccessFile(CA, gA);
    return gA >= magicX2AndPadding && checkForMagicArrowString(yield AA.readAt(0, magicLength + 7 & -8)) ? new AsyncRecordBatchFileReader(new AsyncRecordBatchFileReaderImpl(AA)) : new AsyncRecordBatchStreamReader(new AsyncRecordBatchStreamReaderImpl(AA));
  });
}
function tableFromIPC(CA) {
  const gA = RecordBatchReader.from(CA);
  return isPromise(gA) ? gA.then((AA) => tableFromIPC(AA)) : gA.isAsync() ? gA.readAll().then((AA) => new Table$2(AA)) : new Table$2(gA.readAll());
}
const PandasRangeIndexType = "range";
var DataFrameCellType = /* @__PURE__ */ ((CA) => (CA.INDEX = "index", CA.DATA = "data", CA))(DataFrameCellType || {});
function convertVectorToList(CA) {
  const gA = [];
  for (let AA = 0; AA < CA.length; AA++)
    gA.push(CA.get(AA));
  return gA;
}
function getPandasTypeName(CA) {
  return isNullOrUndefined$1(CA.pandasType) ? void 0 : (CA.pandasType.pandas_type === "object" ? CA.pandasType.numpy_type : CA.pandasType.pandas_type).toLowerCase().trim();
}
function getTimezone(CA) {
  const gA = CA.arrowField?.type?.timezone ?? CA.pandasType?.metadata?.timezone;
  return typeof gA == "string" ? gA : void 0;
}
function isIntegerType(CA) {
  if (isNullOrUndefined$1(CA))
    return !1;
  const gA = getPandasTypeName(CA) ?? "";
  return (
    // Period types are integers with an extra extension name
    DataType.isInt(CA.arrowField.type) && !isPeriodType(CA) || gA.startsWith("int") && !isIntervalType(CA) || isRangeIndexType(CA) || isUnsignedIntegerType(CA)
  );
}
function isUnsignedIntegerType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isInt(CA.arrowField.type) && CA.arrowField.type.isSigned === !1 || (getPandasTypeName(CA)?.startsWith("uint") ?? !1);
}
function isFloatType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : (DataType.isFloat(CA.arrowField.type) || getPandasTypeName(CA)?.startsWith("float")) ?? !1;
}
function isDecimalType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isDecimal(CA.arrowField.type) || getPandasTypeName(CA) === "decimal";
}
function isNumericType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : isIntegerType(CA) || isFloatType(CA) || isDecimalType(CA);
}
function isBooleanType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isBool(CA.arrowField.type) || getPandasTypeName(CA) === "bool";
}
function isDurationType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isDuration(CA.arrowField.type) || (getPandasTypeName(CA)?.startsWith("timedelta") ?? !1);
}
function isPeriodType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isInt(CA.arrowField.type) && CA.arrowField.metadata.get("ARROW:extension:name") === "period" || (getPandasTypeName(CA)?.startsWith("period") ?? !1);
}
function isDatetimeType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isTimestamp(CA.arrowField.type) || (getPandasTypeName(CA)?.startsWith("datetime") ?? !1);
}
function isDateType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isDate(CA.arrowField.type) || getPandasTypeName(CA) === "date";
}
function isTimeType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isTime(CA.arrowField.type) || getPandasTypeName(CA) === "time";
}
function isCategoricalType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isDictionary(CA.arrowField.type) || getPandasTypeName(CA) === "categorical";
}
function isListType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isList(CA.arrowField.type) || DataType.isFixedSizeList(CA.arrowField.type) || (getPandasTypeName(CA)?.startsWith("list") ?? !1);
}
function isObjectType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isStruct(CA.arrowField.type) || DataType.isMap(CA.arrowField.type) || getPandasTypeName(CA) === "object";
}
function isBytesType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isBinary(CA.arrowField.type) || DataType.isLargeBinary(CA.arrowField.type) || getPandasTypeName(CA) === "bytes";
}
function isStringType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isUtf8(CA.arrowField.type) || DataType.isLargeUtf8(CA.arrowField.type) || ["unicode", "large_string[pyarrow]"].includes(getPandasTypeName(CA) ?? "");
}
function isEmptyType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isNull(CA.arrowField.type) || getPandasTypeName(CA) === "empty";
}
function isIntervalType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : DataType.isStruct(CA.arrowField.type) && CA.arrowField.metadata.get("ARROW:extension:name") === "interval" || (getPandasTypeName(CA)?.startsWith("interval") ?? !1);
}
function isRangeIndexType(CA) {
  return isNullOrUndefined$1(CA) ? !1 : getPandasTypeName(CA) === PandasRangeIndexType;
}
function sameDataTypes(CA, gA) {
  return CA.every((AA, IA) => AA.pandasType?.pandas_type === gA[IA]?.pandasType?.pandas_type);
}
function sameIndexTypes(CA, gA) {
  return CA.length !== gA.length ? !1 : CA.every((AA, IA) => IA < gA.length && getPandasTypeName(AA) === getPandasTypeName(gA[IA]));
}
function concatIndexes(CA, gA, AA, IA) {
  if (AA.length === 0)
    return CA;
  if (CA.length === 0)
    return AA;
  if (!sameIndexTypes(gA, IA)) {
    const QA = IA.map((iA) => getPandasTypeName(iA)), EA = gA.map((iA) => getPandasTypeName(iA));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(QA)}\`
but was expecting \`${JSON.stringify(EA)}\`.
`);
  }
  if (gA.length === 0)
    throw new Error("There was an error while parsing index types.");
  if (isRangeIndexType(gA[0])) {
    const QA = gA[0].pandasType?.metadata;
    if (!QA)
      throw new Error("Range index metadata is missing from the base dataframe.");
    const {
      step: EA,
      stop: iA
    } = QA;
    AA = [range$1(
      iA,
      // End is not inclusive
      iA + AA[0].length * EA,
      EA
    )];
  }
  return zip$1(CA, AA).map((QA) => QA[0].concat(QA[1]));
}
function concatData(CA, gA, AA, IA) {
  if (AA.numCols === 0)
    return CA;
  if (CA.numCols === 0)
    return AA;
  if (!sameDataTypes(gA, IA)) {
    const QA = IA.map((iA) => iA.pandasType?.pandas_type), EA = gA.map((iA) => iA.pandasType?.pandas_type);
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
data signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(QA)}\`
but was expecting \`${JSON.stringify(EA)}\`.
`);
  }
  const BA = AA.selectAt(range$1(0, CA.numCols));
  return CA.concat(BA);
}
function concatTypes(CA, gA, AA, IA) {
  const BA = concatIndexTypes(CA, AA), QA = concatDataTypes(gA, IA);
  return {
    indexTypes: BA,
    dataTypes: QA
  };
}
function concatIndexTypes(CA, gA) {
  if (gA.length === 0)
    return CA;
  if (CA.length === 0)
    return gA;
  if (!sameIndexTypes(CA, gA)) {
    const AA = gA.map((BA) => getPandasTypeName(BA)), IA = CA.map((BA) => getPandasTypeName(BA));
    throw new Error(`
Unsupported operation. The data passed into \`add_rows()\` must have the same
index signature as the original data.

In this case, \`add_rows()\` received \`${JSON.stringify(AA)}\`
but was expecting \`${JSON.stringify(IA)}\`.
`);
  }
  return CA.map((AA) => {
    if (isRangeIndexType(AA) && AA.pandasType) {
      const {
        stop: IA,
        step: BA
      } = AA.pandasType.metadata, QA = gA[0].pandasType?.metadata;
      if (!QA)
        throw new Error("Range index metadata is missing from the appended dataframe.");
      const {
        start: EA,
        stop: iA,
        step: oA
      } = QA, cA = (iA - EA) / oA, tA = IA + cA * BA;
      return {
        ...AA,
        pandasType: {
          ...AA.pandasType,
          metadata: {
            ...AA.pandasType.metadata,
            stop: tA
          }
        }
      };
    }
    return AA;
  });
}
function concatDataTypes(CA, gA) {
  return CA.length === 0 ? gA : CA;
}
function concat(CA, gA, AA, IA, BA, QA, EA, iA) {
  const oA = concatIndexes(AA, gA, EA, QA), cA = concatData(IA, CA, iA, BA), {
    indexTypes: tA,
    dataTypes: eA
  } = concatTypes(gA, CA, QA, BA);
  return {
    index: oA,
    data: cA,
    indexTypes: tA,
    dataTypes: eA
  };
}
let wasm;
const heap = new Array(128).fill(void 0);
heap.push(void 0, null, !0, !1);
let heap_next = heap.length;
function addHeapObject(CA) {
  heap_next === heap.length && heap.push(heap.length + 1);
  const gA = heap_next;
  return heap_next = heap[gA], heap[gA] = CA, gA;
}
function getObject(CA) {
  return heap[CA];
}
function dropObject(CA) {
  CA < 132 || (heap[CA] = heap_next, heap_next = CA);
}
function takeObject(CA) {
  const gA = getObject(CA);
  return dropObject(CA), gA;
}
const cachedTextDecoder = typeof TextDecoder < "u" ? new TextDecoder("utf-8", { ignoreBOM: !0, fatal: !0 }) : { decode: () => {
  throw Error("TextDecoder not available");
} };
typeof TextDecoder < "u" && cachedTextDecoder.decode();
let cachedUint8Memory0 = null;
function getUint8Memory0() {
  return (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) && (cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer)), cachedUint8Memory0;
}
function getStringFromWasm0(CA, gA) {
  return CA = CA >>> 0, cachedTextDecoder.decode(getUint8Memory0().subarray(CA, CA + gA));
}
function isLikeNone(CA) {
  return CA == null;
}
let cachedFloat64Memory0 = null;
function getFloat64Memory0() {
  return (cachedFloat64Memory0 === null || cachedFloat64Memory0.byteLength === 0) && (cachedFloat64Memory0 = new Float64Array(wasm.memory.buffer)), cachedFloat64Memory0;
}
let cachedInt32Memory0 = null;
function getInt32Memory0() {
  return (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) && (cachedInt32Memory0 = new Int32Array(wasm.memory.buffer)), cachedInt32Memory0;
}
let WASM_VECTOR_LEN = 0;
const cachedTextEncoder = typeof TextEncoder < "u" ? new TextEncoder("utf-8") : { encode: () => {
  throw Error("TextEncoder not available");
} }, encodeString = typeof cachedTextEncoder.encodeInto == "function" ? function(CA, gA) {
  return cachedTextEncoder.encodeInto(CA, gA);
} : function(CA, gA) {
  const AA = cachedTextEncoder.encode(CA);
  return gA.set(AA), {
    read: CA.length,
    written: AA.length
  };
};
function passStringToWasm0(CA, gA, AA) {
  if (AA === void 0) {
    const iA = cachedTextEncoder.encode(CA), oA = gA(iA.length, 1) >>> 0;
    return getUint8Memory0().subarray(oA, oA + iA.length).set(iA), WASM_VECTOR_LEN = iA.length, oA;
  }
  let IA = CA.length, BA = gA(IA, 1) >>> 0;
  const QA = getUint8Memory0();
  let EA = 0;
  for (; EA < IA; EA++) {
    const iA = CA.charCodeAt(EA);
    if (iA > 127) break;
    QA[BA + EA] = iA;
  }
  if (EA !== IA) {
    EA !== 0 && (CA = CA.slice(EA)), BA = AA(BA, IA, IA = EA + CA.length * 3, 1) >>> 0;
    const iA = getUint8Memory0().subarray(BA + EA, BA + IA), oA = encodeString(CA, iA);
    EA += oA.written, BA = AA(BA, IA, EA, 1) >>> 0;
  }
  return WASM_VECTOR_LEN = EA, BA;
}
let cachedBigInt64Memory0 = null;
function getBigInt64Memory0() {
  return (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) && (cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer)), cachedBigInt64Memory0;
}
function debugString(CA) {
  const gA = typeof CA;
  if (gA == "number" || gA == "boolean" || CA == null)
    return `${CA}`;
  if (gA == "string")
    return `"${CA}"`;
  if (gA == "symbol") {
    const BA = CA.description;
    return BA == null ? "Symbol" : `Symbol(${BA})`;
  }
  if (gA == "function") {
    const BA = CA.name;
    return typeof BA == "string" && BA.length > 0 ? `Function(${BA})` : "Function";
  }
  if (Array.isArray(CA)) {
    const BA = CA.length;
    let QA = "[";
    BA > 0 && (QA += debugString(CA[0]));
    for (let EA = 1; EA < BA; EA++)
      QA += ", " + debugString(CA[EA]);
    return QA += "]", QA;
  }
  const AA = /\[object ([^\]]+)\]/.exec(toString.call(CA));
  let IA;
  if (AA.length > 1)
    IA = AA[1];
  else
    return toString.call(CA);
  if (IA == "Object")
    try {
      return "Object(" + JSON.stringify(CA) + ")";
    } catch {
      return "Object";
    }
  return CA instanceof Error ? `${CA.name}: ${CA.message}
${CA.stack}` : IA;
}
const CLOSURE_DTORS = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => {
  wasm.__wbindgen_export_2.get(CA.dtor)(CA.a, CA.b);
});
function makeMutClosure(CA, gA, AA, IA) {
  const BA = { a: CA, b: gA, cnt: 1, dtor: AA }, QA = (...EA) => {
    BA.cnt++;
    const iA = BA.a;
    BA.a = 0;
    try {
      return IA(iA, BA.b, ...EA);
    } finally {
      --BA.cnt === 0 ? (wasm.__wbindgen_export_2.get(BA.dtor)(iA, BA.b), CLOSURE_DTORS.unregister(BA)) : BA.a = iA;
    }
  };
  return QA.original = BA, CLOSURE_DTORS.register(QA, BA, BA), QA;
}
function __wbg_adapter_50(CA, gA, AA) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h1de40baa0df51db0(CA, gA, addHeapObject(AA));
}
function passArray8ToWasm0(CA, gA) {
  const AA = gA(CA.length * 1, 1) >>> 0;
  return getUint8Memory0().set(CA, AA / 1), WASM_VECTOR_LEN = CA.length, AA;
}
function readParquet(CA, gA) {
  try {
    const QA = wasm.__wbindgen_add_to_stack_pointer(-16), EA = passArray8ToWasm0(CA, wasm.__wbindgen_malloc), iA = WASM_VECTOR_LEN;
    wasm.readParquet(QA, EA, iA, isLikeNone(gA) ? 0 : addHeapObject(gA));
    var AA = getInt32Memory0()[QA / 4 + 0], IA = getInt32Memory0()[QA / 4 + 1], BA = getInt32Memory0()[QA / 4 + 2];
    if (BA)
      throw takeObject(IA);
    return Table$1.__wrap(AA);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}
function _assertClass(CA, gA) {
  if (!(CA instanceof gA))
    throw new Error(`expected instance of ${gA.name}`);
  return CA.ptr;
}
function getArrayU8FromWasm0(CA, gA) {
  return CA = CA >>> 0, getUint8Memory0().subarray(CA / 1, CA / 1 + gA);
}
let cachedUint32Memory0 = null;
function getUint32Memory0() {
  return (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) && (cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer)), cachedUint32Memory0;
}
function getArrayJsValueFromWasm0(CA, gA) {
  CA = CA >>> 0;
  const IA = getUint32Memory0().subarray(CA / 4, CA / 4 + gA), BA = [];
  for (let QA = 0; QA < IA.length; QA++)
    BA.push(takeObject(IA[QA]));
  return BA;
}
function handleError(CA, gA) {
  try {
    return CA.apply(this, gA);
  } catch (AA) {
    wasm.__wbindgen_exn_store(addHeapObject(AA));
  }
}
function getArrayU32FromWasm0(CA, gA) {
  return CA = CA >>> 0, getUint32Memory0().subarray(CA / 4, CA / 4 + gA);
}
function __wbg_adapter_285(CA, gA, AA, IA) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h26b6dc7d05b06fdf(CA, gA, addHeapObject(AA), addHeapObject(IA));
}
const ColumnChunkMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_columnchunkmetadata_free(CA >>> 0));
class ColumnChunkMetaData {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(ColumnChunkMetaData.prototype);
    return AA.__wbg_ptr = gA, ColumnChunkMetaDataFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ColumnChunkMetaDataFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_columnchunkmetadata_free(gA);
  }
  /**
  * File where the column chunk is stored.
  *
  * If not set, assumed to belong to the same file as the metadata.
  * This path is relative to the current file.
  * @returns {string | undefined}
  */
  filePath() {
    try {
      const IA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_filePath(IA, this.__wbg_ptr);
      var gA = getInt32Memory0()[IA / 4 + 0], AA = getInt32Memory0()[IA / 4 + 1];
      let BA;
      return gA !== 0 && (BA = getStringFromWasm0(gA, AA).slice(), wasm.__wbindgen_free(gA, AA * 1, 1)), BA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Byte offset in `file_path()`.
  * @returns {bigint}
  */
  fileOffset() {
    return wasm.columnchunkmetadata_fileOffset(this.__wbg_ptr);
  }
  /**
  * Path (or identifier) of this column.
  * @returns {(string)[]}
  */
  columnPath() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_columnPath(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getArrayJsValueFromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 4, 4), IA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * All encodings used for this column.
  * @returns {any[]}
  */
  encodings() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.columnchunkmetadata_encodings(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getArrayJsValueFromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 4, 4), IA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Total number of values in this column chunk.
  * @returns {number}
  */
  numValues() {
    return wasm.columnchunkmetadata_numValues(this.__wbg_ptr);
  }
  /**
  * Compression for this column.
  * @returns {Compression}
  */
  compression() {
    return wasm.columnchunkmetadata_compression(this.__wbg_ptr);
  }
  /**
  * Returns the total compressed data size of this column chunk.
  * @returns {number}
  */
  compressedSize() {
    return wasm.columnchunkmetadata_compressedSize(this.__wbg_ptr);
  }
  /**
  * Returns the total uncompressed data size of this column chunk.
  * @returns {number}
  */
  uncompressedSize() {
    return wasm.columnchunkmetadata_uncompressedSize(this.__wbg_ptr);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_ffiarrowarray_free(CA >>> 0));
const FFIArrowSchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_ffiarrowschema_free(CA >>> 0));
class FFIArrowSchema {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(FFIArrowSchema.prototype);
    return AA.__wbg_ptr = gA, FFIArrowSchemaFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIArrowSchemaFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_ffiarrowschema_free(gA);
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  addr() {
    return wasm.ffiarrowschema_addr(this.__wbg_ptr) >>> 0;
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_ffidata_free(CA >>> 0));
const FFIRecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_ffirecordbatch_free(CA >>> 0));
class FFIRecordBatch {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(FFIRecordBatch.prototype);
    return AA.__wbg_ptr = gA, FFIRecordBatchFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFIRecordBatchFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_ffirecordbatch_free(gA);
  }
  /**
  * Access the pointer to the
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  arrayAddr() {
    return wasm.ffirecordbatch_arrayAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Access the pointer to the
  * [`ArrowSchema`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct. This can be viewed or copied (without serialization) to an Arrow JS `Field` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmRecordBatch: FFIRecordBatch = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * // Pass `true` to copy arrays across the boundary instead of creating views.
  * const jsRecordBatch = parseRecordBatch(
  *   wasmMemory.buffer,
  *   wasmRecordBatch.arrayAddr(),
  *   wasmRecordBatch.schemaAddr(),
  *   true
  * );
  * ```
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffirecordbatch_schemaAddr(this.__wbg_ptr) >>> 0;
  }
}
const FFITableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_ffitable_free(CA >>> 0));
class FFITable {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(FFITable.prototype);
    return AA.__wbg_ptr = gA, FFITableFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FFITableFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_ffitable_free(gA);
  }
  /**
  * Get the total number of record batches in the table
  * @returns {number}
  */
  numBatches() {
    return wasm.ffitable_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowSchema FFI struct
  * @returns {number}
  */
  schemaAddr() {
    return wasm.ffitable_schemaAddr(this.__wbg_ptr) >>> 0;
  }
  /**
  * Get the pointer to one ArrowArray FFI struct for a given chunk index and column index
  *
  * Access the pointer to one
  * [`ArrowArray`](https://arrow.apache.org/docs/format/CDataInterface.html#structure-definitions)
  * struct representing one of the internal `RecordBatch`es. This can be viewed or copied (without serialization) to an Arrow JS `RecordBatch` by
  * using [`arrow-js-ffi`](https://github.com/kylebarron/arrow-js-ffi). You can access the
  * [`WebAssembly.Memory`](https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Memory)
  * instance by using {@linkcode wasmMemory}.
  *
  * **Example**:
  *
  * ```ts
  * import * as arrow from "apache-arrow";
  * import { parseRecordBatch } from "arrow-js-ffi";
  *
  * const wasmTable: FFITable = ...
  * const wasmMemory: WebAssembly.Memory = wasmMemory();
  *
  * const jsBatches: arrow.RecordBatch[] = []
  * for (let i = 0; i < wasmTable.numBatches(); i++) {
  *   // Pass `true` to copy arrays across the boundary instead of creating views.
  *   const jsRecordBatch = parseRecordBatch(
  *     wasmMemory.buffer,
  *     wasmTable.arrayAddr(i),
  *     wasmTable.schemaAddr(),
  *     true
  *   );
  *   jsBatches.push(jsRecordBatch);
  * }
  * const jsTable = new arrow.Table(jsBatches);
  * ```
  *
  * @param chunk number The chunk index to use
  * @returns number pointer to an ArrowArray FFI struct in Wasm memory
  * @param {number} chunk
  * @returns {number}
  */
  arrayAddr(gA) {
    return wasm.ffitable_arrayAddr(this.__wbg_ptr, gA) >>> 0;
  }
  /**
  * @returns {Uint32Array}
  */
  arrayAddrs() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.ffitable_arrayAddrs(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getArrayU32FromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 4, 4), IA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  */
  drop() {
    const gA = this.__destroy_into_raw();
    wasm.ffitable_drop(gA);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_ffivector_free(CA >>> 0));
const FileMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_filemetadata_free(CA >>> 0));
class FileMetaData {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(FileMetaData.prototype);
    return AA.__wbg_ptr = gA, FileMetaDataFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, FileMetaDataFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_filemetadata_free(gA);
  }
  /**
  * Returns version of this file.
  * @returns {number}
  */
  version() {
    return wasm.filemetadata_version(this.__wbg_ptr);
  }
  /**
  * Returns number of rows in the file.
  * @returns {number}
  */
  numRows() {
    return wasm.filemetadata_numRows(this.__wbg_ptr);
  }
  /**
  * String message for application that wrote this file.
  *
  * This should have the following format:
  * `<application> version <application version> (build <application build hash>)`.
  *
  * ```shell
  * parquet-mr version 1.8.0 (build 0fda28af84b9746396014ad6a415b90592a98b3b)
  * ```
  * @returns {string | undefined}
  */
  createdBy() {
    try {
      const IA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_createdBy(IA, this.__wbg_ptr);
      var gA = getInt32Memory0()[IA / 4 + 0], AA = getInt32Memory0()[IA / 4 + 1];
      let BA;
      return gA !== 0 && (BA = getStringFromWasm0(gA, AA).slice(), wasm.__wbindgen_free(gA, AA * 1, 1)), BA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns key_value_metadata of this file.
  * @returns {Map<any, any>}
  */
  keyValueMetadata() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.filemetadata_keyValueMetadata(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return takeObject(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_intounderlyingbytesource_free(CA >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_intounderlyingsink_free(CA >>> 0));
const IntoUnderlyingSourceFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_intounderlyingsource_free(CA >>> 0));
class IntoUnderlyingSource {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(IntoUnderlyingSource.prototype);
    return AA.__wbg_ptr = gA, IntoUnderlyingSourceFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, IntoUnderlyingSourceFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_intounderlyingsource_free(gA);
  }
  /**
  * @param {ReadableStreamDefaultController} controller
  * @returns {Promise<any>}
  */
  pull(gA) {
    const AA = wasm.intounderlyingsource_pull(this.__wbg_ptr, addHeapObject(gA));
    return takeObject(AA);
  }
  /**
  */
  cancel() {
    const gA = this.__destroy_into_raw();
    wasm.intounderlyingsource_cancel(gA);
  }
}
const ParquetFileFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_parquetfile_free(CA >>> 0));
class ParquetFile {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(ParquetFile.prototype);
    return AA.__wbg_ptr = gA, ParquetFileFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetFileFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_parquetfile_free(gA);
  }
  /**
  * Construct a ParquetFile from a new URL.
  *
  * @param options The options to pass into `object-store`'s [`parse_url_opts`][parse_url_opts]
  *
  * [parse_url_opts]: https://docs.rs/object_store/latest/object_store/fn.parse_url_opts.html
  * @param {string} url
  * @param {Map<any, any> | undefined} [options]
  * @returns {Promise<ParquetFile>}
  */
  static fromUrl(gA, AA) {
    const IA = passStringToWasm0(gA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), BA = WASM_VECTOR_LEN, QA = wasm.parquetfile_fromUrl(IA, BA, isLikeNone(AA) ? 0 : addHeapObject(AA));
    return takeObject(QA);
  }
  /**
  * Construct a ParquetFile from a new [Blob] or [File] handle.
  *
  * [Blob]: https://developer.mozilla.org/en-US/docs/Web/API/Blob
  * [File]: https://developer.mozilla.org/en-US/docs/Web/API/File
  *
  * Safety: Do not use this in a multi-threaded environment,
  * (transitively depends on `!Send` `web_sys::Blob`)
  * @param {Blob} handle
  * @returns {Promise<ParquetFile>}
  */
  static fromFile(gA) {
    const AA = wasm.parquetfile_fromFile(addHeapObject(gA));
    return takeObject(AA);
  }
  /**
  * @returns {ParquetMetaData}
  */
  metadata() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetfile_metadata(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return ParquetMetaData.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Read from the Parquet file in an async fashion.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<Table>}
  */
  read(gA) {
    const AA = wasm.parquetfile_read(this.__wbg_ptr, isLikeNone(gA) ? 0 : addHeapObject(gA));
    return takeObject(AA);
  }
  /**
  * Create a readable stream of record batches.
  *
  * Each item in the stream will be a {@linkcode RecordBatch}.
  *
  * @param options
  *
  *    Options for reading Parquet data. Optional keys include:
  *
  *    - `batchSize`: The number of rows in each batch. If not provided, the upstream parquet
  *           default is 1024.
  *    - `rowGroups`: Only read data from the provided row group indexes.
  *    - `limit`: Provide a limit to the number of rows to be read.
  *    - `offset`: Provide an offset to skip over the given number of rows.
  *    - `columns`: The column names from the file to read.
  *    - `concurrency`: The number of concurrent requests to make
  * @param {ReaderOptions | undefined} [options]
  * @returns {Promise<ReadableStream>}
  */
  stream(gA) {
    const AA = wasm.parquetfile_stream(this.__wbg_ptr, isLikeNone(gA) ? 0 : addHeapObject(gA));
    return takeObject(AA);
  }
}
const ParquetMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_parquetmetadata_free(CA >>> 0));
class ParquetMetaData {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(ParquetMetaData.prototype);
    return AA.__wbg_ptr = gA, ParquetMetaDataFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, ParquetMetaDataFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_parquetmetadata_free(gA);
  }
  /**
  * Returns file metadata as reference.
  * @returns {FileMetaData}
  */
  fileMetadata() {
    const gA = wasm.parquetmetadata_fileMetadata(this.__wbg_ptr);
    return FileMetaData.__wrap(gA);
  }
  /**
  * Returns number of row groups in this file.
  * @returns {number}
  */
  numRowGroups() {
    return wasm.parquetmetadata_numRowGroups(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns row group metadata for `i`th position.
  * Position should be less than number of row groups `num_row_groups`.
  * @param {number} i
  * @returns {RowGroupMetaData}
  */
  rowGroup(gA) {
    const AA = wasm.parquetmetadata_rowGroup(this.__wbg_ptr, gA);
    return RowGroupMetaData.__wrap(AA);
  }
  /**
  * Returns row group metadata for all row groups
  * @returns {(RowGroupMetaData)[]}
  */
  rowGroups() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.parquetmetadata_rowGroups(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getArrayJsValueFromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 4, 4), IA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}
const RecordBatchFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_recordbatch_free(CA >>> 0));
class RecordBatch {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(RecordBatch.prototype);
    return AA.__wbg_ptr = gA, RecordBatchFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RecordBatchFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_recordbatch_free(gA);
  }
  /**
  * The number of rows in this RecordBatch.
  * @returns {number}
  */
  get numRows() {
    return wasm.recordbatch_numRows(this.__wbg_ptr) >>> 0;
  }
  /**
  * The number of columns in this RecordBatch.
  * @returns {number}
  */
  get numColumns() {
    return wasm.recordbatch_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * The {@linkcode Schema} of this RecordBatch.
  * @returns {Schema}
  */
  get schema() {
    const gA = wasm.recordbatch_schema(this.__wbg_ptr);
    return Schema$1.__wrap(gA);
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the RecordBatch, so you must remember to call {@linkcode
  * RecordBatch.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIRecordBatch}
  */
  toFFI() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_toFFI(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFIRecordBatch.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this RecordBatch to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the RecordBatch, so the original RecordBatch will be
  * inaccessible after this call. You must still call {@linkcode FFIRecordBatch.free} after
  * you've finished using the FFIRecordBatch.
  * @returns {FFIRecordBatch}
  */
  intoFFI() {
    try {
      const BA = this.__destroy_into_raw(), QA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoFFI(QA, BA);
      var gA = getInt32Memory0()[QA / 4 + 0], AA = getInt32Memory0()[QA / 4 + 1], IA = getInt32Memory0()[QA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFIRecordBatch.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this RecordBatch and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const EA = this.__destroy_into_raw(), iA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.recordbatch_intoIPCStream(iA, EA);
      var gA = getInt32Memory0()[iA / 4 + 0], AA = getInt32Memory0()[iA / 4 + 1], IA = getInt32Memory0()[iA / 4 + 2], BA = getInt32Memory0()[iA / 4 + 3];
      if (BA)
        throw takeObject(IA);
      var QA = getArrayU8FromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 1, 1), QA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Override the schema of this [`RecordBatch`]
  *
  * Returns an error if `schema` is not a superset of the current schema
  * as determined by [`Schema::contains`]
  * @param {Schema} schema
  * @returns {RecordBatch}
  */
  withSchema(gA) {
    try {
      const EA = wasm.__wbindgen_add_to_stack_pointer(-16);
      _assertClass(gA, Schema$1);
      var AA = gA.__destroy_into_raw();
      wasm.recordbatch_withSchema(EA, this.__wbg_ptr, AA);
      var IA = getInt32Memory0()[EA / 4 + 0], BA = getInt32Memory0()[EA / 4 + 1], QA = getInt32Memory0()[EA / 4 + 2];
      if (QA)
        throw takeObject(BA);
      return RecordBatch.__wrap(IA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Return a new RecordBatch where each column is sliced
  * according to `offset` and `length`
  * @param {number} offset
  * @param {number} length
  * @returns {RecordBatch}
  */
  slice(gA, AA) {
    const IA = wasm.recordbatch_slice(this.__wbg_ptr, gA, AA);
    return RecordBatch.__wrap(IA);
  }
  /**
  * Returns the total number of bytes of memory occupied physically by this batch.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.recordbatch_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
}
const RowGroupMetaDataFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_rowgroupmetadata_free(CA >>> 0));
class RowGroupMetaData {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(RowGroupMetaData.prototype);
    return AA.__wbg_ptr = gA, RowGroupMetaDataFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, RowGroupMetaDataFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_rowgroupmetadata_free(gA);
  }
  /**
  * Number of columns in this row group.
  * @returns {number}
  */
  numColumns() {
    return wasm.rowgroupmetadata_numColumns(this.__wbg_ptr) >>> 0;
  }
  /**
  * Returns column chunk metadata for `i`th column.
  * @param {number} i
  * @returns {ColumnChunkMetaData}
  */
  column(gA) {
    const AA = wasm.rowgroupmetadata_column(this.__wbg_ptr, gA);
    return ColumnChunkMetaData.__wrap(AA);
  }
  /**
  * Returns column chunk metadata for all columns
  * @returns {(ColumnChunkMetaData)[]}
  */
  columns() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.rowgroupmetadata_columns(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getArrayJsValueFromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 4, 4), IA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Number of rows in this row group.
  * @returns {number}
  */
  numRows() {
    return wasm.rowgroupmetadata_numRows(this.__wbg_ptr);
  }
  /**
  * Total byte size of all uncompressed column data in this row group.
  * @returns {number}
  */
  totalByteSize() {
    return wasm.rowgroupmetadata_totalByteSize(this.__wbg_ptr);
  }
  /**
  * Total size of all compressed column data in this row group.
  * @returns {number}
  */
  compressedSize() {
    return wasm.rowgroupmetadata_compressedSize(this.__wbg_ptr);
  }
}
const SchemaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_schema_free(CA >>> 0));
let Schema$1 = class dg {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(dg.prototype);
    return AA.__wbg_ptr = gA, SchemaFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, SchemaFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_schema_free(gA);
  }
  /**
  * Export this schema to an FFIArrowSchema object, which can be read with arrow-js-ffi.
  *
  * This method **does not consume** the Schema, so you must remember to call {@linkcode
  * Schema.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFIArrowSchema}
  */
  toFFI() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_toFFI(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFIArrowSchema.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFIArrowSchema}
  */
  intoFFI() {
    try {
      const BA = this.__destroy_into_raw(), QA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoFFI(QA, BA);
      var gA = getInt32Memory0()[QA / 4 + 0], AA = getInt32Memory0()[QA / 4 + 1], IA = getInt32Memory0()[QA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFIArrowSchema.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this schema and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const EA = this.__destroy_into_raw(), iA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_intoIPCStream(iA, EA);
      var gA = getInt32Memory0()[iA / 4 + 0], AA = getInt32Memory0()[iA / 4 + 1], IA = getInt32Memory0()[iA / 4 + 2], BA = getInt32Memory0()[iA / 4 + 3];
      if (BA)
        throw takeObject(IA);
      var QA = getArrayU8FromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 1, 1), QA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Sets the metadata of this `Schema` to be `metadata` and returns a new object
  * @param {SchemaMetadata} metadata
  * @returns {Schema}
  */
  withMetadata(gA) {
    try {
      const QA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_withMetadata(QA, this.__wbg_ptr, addHeapObject(gA));
      var AA = getInt32Memory0()[QA / 4 + 0], IA = getInt32Memory0()[QA / 4 + 1], BA = getInt32Memory0()[QA / 4 + 2];
      if (BA)
        throw takeObject(IA);
      return dg.__wrap(AA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Find the index of the column with the given name.
  * @param {string} name
  * @returns {number}
  */
  indexOf(gA) {
    try {
      const QA = wasm.__wbindgen_add_to_stack_pointer(-16), EA = passStringToWasm0(gA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), iA = WASM_VECTOR_LEN;
      wasm.schema_indexOf(QA, this.__wbg_ptr, EA, iA);
      var AA = getInt32Memory0()[QA / 4 + 0], IA = getInt32Memory0()[QA / 4 + 1], BA = getInt32Memory0()[QA / 4 + 2];
      if (BA)
        throw takeObject(IA);
      return AA >>> 0;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns an immutable reference to the Map of custom metadata key-value pairs.
  * @returns {SchemaMetadata}
  */
  metadata() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.schema_metadata(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return takeObject(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
};
const TableFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_table_free(CA >>> 0));
let Table$1 = class Fg {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(Fg.prototype);
    return AA.__wbg_ptr = gA, TableFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, TableFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_table_free(gA);
  }
  /**
  * Access the Table's {@linkcode Schema}.
  * @returns {Schema}
  */
  get schema() {
    const gA = wasm.table_schema(this.__wbg_ptr);
    return Schema$1.__wrap(gA);
  }
  /**
  * The number of batches in the Table
  * @returns {number}
  */
  get numBatches() {
    return wasm.table_numBatches(this.__wbg_ptr) >>> 0;
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does not consume** the Table, so you must remember to call {@linkcode
  * Table.free} to release the resources. The underlying arrays are reference counted, so
  * this method does not copy data, it only prevents the data from being released.
  * @returns {FFITable}
  */
  toFFI() {
    try {
      const BA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_toFFI(BA, this.__wbg_ptr);
      var gA = getInt32Memory0()[BA / 4 + 0], AA = getInt32Memory0()[BA / 4 + 1], IA = getInt32Memory0()[BA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFITable.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Export this Table to FFI structs according to the Arrow C Data Interface.
  *
  * This method **does consume** the Table, so the original Table will be
  * inaccessible after this call. You must still call {@linkcode FFITable.free} after
  * you've finished using the FFITable.
  * @returns {FFITable}
  */
  intoFFI() {
    try {
      const BA = this.__destroy_into_raw(), QA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoFFI(QA, BA);
      var gA = getInt32Memory0()[QA / 4 + 0], AA = getInt32Memory0()[QA / 4 + 1], IA = getInt32Memory0()[QA / 4 + 2];
      if (IA)
        throw takeObject(AA);
      return FFITable.__wrap(gA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Consume this table and convert to an Arrow IPC Stream buffer
  * @returns {Uint8Array}
  */
  intoIPCStream() {
    try {
      const EA = this.__destroy_into_raw(), iA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.table_intoIPCStream(iA, EA);
      var gA = getInt32Memory0()[iA / 4 + 0], AA = getInt32Memory0()[iA / 4 + 1], IA = getInt32Memory0()[iA / 4 + 2], BA = getInt32Memory0()[iA / 4 + 3];
      if (BA)
        throw takeObject(IA);
      var QA = getArrayU8FromWasm0(gA, AA).slice();
      return wasm.__wbindgen_free(gA, AA * 1, 1), QA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Create a table from an Arrow IPC Stream buffer
  * @param {Uint8Array} buf
  * @returns {Table}
  */
  static fromIPCStream(gA) {
    try {
      const QA = wasm.__wbindgen_add_to_stack_pointer(-16), EA = passArray8ToWasm0(gA, wasm.__wbindgen_malloc), iA = WASM_VECTOR_LEN;
      wasm.table_fromIPCStream(QA, EA, iA);
      var AA = getInt32Memory0()[QA / 4 + 0], IA = getInt32Memory0()[QA / 4 + 1], BA = getInt32Memory0()[QA / 4 + 2];
      if (BA)
        throw takeObject(IA);
      return Fg.__wrap(AA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * Returns the total number of bytes of memory occupied physically by all batches in this
  * table.
  * @returns {number}
  */
  getArrayMemorySize() {
    return wasm.table_getArrayMemorySize(this.__wbg_ptr) >>> 0;
  }
};
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_wasmgetoptions_free(CA >>> 0));
const WasmObjectMetaFinalization = typeof FinalizationRegistry > "u" ? { register: () => {
}, unregister: () => {
} } : new FinalizationRegistry((CA) => wasm.__wbg_wasmobjectmeta_free(CA >>> 0));
class WasmObjectMeta {
  static __wrap(gA) {
    gA = gA >>> 0;
    const AA = Object.create(WasmObjectMeta.prototype);
    return AA.__wbg_ptr = gA, WasmObjectMetaFinalization.register(AA, AA.__wbg_ptr, AA), AA;
  }
  toJSON() {
    return {
      location: this.location,
      last_modified: this.last_modified,
      size: this.size,
      e_tag: this.e_tag,
      version: this.version
    };
  }
  toString() {
    return JSON.stringify(this);
  }
  __destroy_into_raw() {
    const gA = this.__wbg_ptr;
    return this.__wbg_ptr = 0, WasmObjectMetaFinalization.unregister(this), gA;
  }
  free() {
    const gA = this.__destroy_into_raw();
    wasm.__wbg_wasmobjectmeta_free(gA);
  }
  /**
  * The full path to the object
  * @returns {string}
  */
  get location() {
    let gA, AA;
    try {
      const QA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_location(QA, this.__wbg_ptr);
      var IA = getInt32Memory0()[QA / 4 + 0], BA = getInt32Memory0()[QA / 4 + 1];
      return gA = IA, AA = BA, getStringFromWasm0(IA, BA);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16), wasm.__wbindgen_free(gA, AA, 1);
    }
  }
  /**
  * The full path to the object
  * @param {string} arg0
  */
  set location(gA) {
    const AA = passStringToWasm0(gA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), IA = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_location(this.__wbg_ptr, AA, IA);
  }
  /**
  * The last modified time
  * @returns {Date}
  */
  get last_modified() {
    const gA = wasm.__wbg_get_wasmobjectmeta_last_modified(this.__wbg_ptr);
    return takeObject(gA);
  }
  /**
  * The last modified time
  * @param {Date} arg0
  */
  set last_modified(gA) {
    wasm.__wbg_set_wasmobjectmeta_last_modified(this.__wbg_ptr, addHeapObject(gA));
  }
  /**
  * The size in bytes of the object
  * @returns {number}
  */
  get size() {
    return wasm.__wbg_get_wasmobjectmeta_size(this.__wbg_ptr) >>> 0;
  }
  /**
  * The size in bytes of the object
  * @param {number} arg0
  */
  set size(gA) {
    wasm.__wbg_set_wasmobjectmeta_size(this.__wbg_ptr, gA);
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @returns {string | undefined}
  */
  get e_tag() {
    try {
      const IA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_e_tag(IA, this.__wbg_ptr);
      var gA = getInt32Memory0()[IA / 4 + 0], AA = getInt32Memory0()[IA / 4 + 1];
      let BA;
      return gA !== 0 && (BA = getStringFromWasm0(gA, AA).slice(), wasm.__wbindgen_free(gA, AA * 1, 1)), BA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * The unique identifier for the object
  *
  * <https://datatracker.ietf.org/doc/html/rfc9110#name-etag>
  * @param {string | undefined} [arg0]
  */
  set e_tag(gA) {
    var AA = isLikeNone(gA) ? 0 : passStringToWasm0(gA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), IA = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_e_tag(this.__wbg_ptr, AA, IA);
  }
  /**
  * A version indicator for this object
  * @returns {string | undefined}
  */
  get version() {
    try {
      const IA = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_wasmobjectmeta_version(IA, this.__wbg_ptr);
      var gA = getInt32Memory0()[IA / 4 + 0], AA = getInt32Memory0()[IA / 4 + 1];
      let BA;
      return gA !== 0 && (BA = getStringFromWasm0(gA, AA).slice(), wasm.__wbindgen_free(gA, AA * 1, 1)), BA;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
  * A version indicator for this object
  * @param {string | undefined} [arg0]
  */
  set version(gA) {
    var AA = isLikeNone(gA) ? 0 : passStringToWasm0(gA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), IA = WASM_VECTOR_LEN;
    wasm.__wbg_set_wasmobjectmeta_version(this.__wbg_ptr, AA, IA);
  }
}
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_wasmobjectstore_free(CA >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_writerproperties_free(CA >>> 0));
typeof FinalizationRegistry > "u" || new FinalizationRegistry((CA) => wasm.__wbg_writerpropertiesbuilder_free(CA >>> 0));
async function __wbg_load(CA, gA) {
  if (typeof Response == "function" && CA instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming == "function")
      try {
        return await WebAssembly.instantiateStreaming(CA, gA);
      } catch (IA) {
        if (CA.headers.get("Content-Type") != "application/wasm")
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", IA);
        else
          throw IA;
      }
    const AA = await CA.arrayBuffer();
    return await WebAssembly.instantiate(AA, gA);
  } else {
    const AA = await WebAssembly.instantiate(CA, gA);
    return AA instanceof WebAssembly.Instance ? { instance: AA, module: CA } : AA;
  }
}
function __wbg_get_imports() {
  const CA = {};
  return CA.wbg = {}, CA.wbg.__wbindgen_number_new = function(gA) {
    return addHeapObject(gA);
  }, CA.wbg.__wbg_columnchunkmetadata_new = function(gA) {
    const AA = ColumnChunkMetaData.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbg_rowgroupmetadata_new = function(gA) {
    const AA = RowGroupMetaData.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbg_parquetfile_new = function(gA) {
    const AA = ParquetFile.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_object_drop_ref = function(gA) {
    takeObject(gA);
  }, CA.wbg.__wbindgen_object_clone_ref = function(gA) {
    const AA = getObject(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_error_new = function(gA, AA) {
    const IA = new Error(getStringFromWasm0(gA, AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbindgen_is_undefined = function(gA) {
    return getObject(gA) === void 0;
  }, CA.wbg.__wbindgen_in = function(gA, AA) {
    return getObject(gA) in getObject(AA);
  }, CA.wbg.__wbindgen_is_bigint = function(gA) {
    return typeof getObject(gA) == "bigint";
  }, CA.wbg.__wbindgen_bigint_from_u64 = function(gA) {
    const AA = BigInt.asUintN(64, gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_jsval_eq = function(gA, AA) {
    return getObject(gA) === getObject(AA);
  }, CA.wbg.__wbindgen_is_object = function(gA) {
    const AA = getObject(gA);
    return typeof AA == "object" && AA !== null;
  }, CA.wbg.__wbindgen_string_new = function(gA, AA) {
    const IA = getStringFromWasm0(gA, AA);
    return addHeapObject(IA);
  }, CA.wbg.__wbindgen_number_get = function(gA, AA) {
    const IA = getObject(AA), BA = typeof IA == "number" ? IA : void 0;
    getFloat64Memory0()[gA / 8 + 1] = isLikeNone(BA) ? 0 : BA, getInt32Memory0()[gA / 4 + 0] = !isLikeNone(BA);
  }, CA.wbg.__wbg_fetch_1db5b0ae726d68b5 = function(gA) {
    const AA = fetch(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_wasmobjectmeta_new = function(gA) {
    const AA = WasmObjectMeta.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_string_get = function(gA, AA) {
    const IA = getObject(AA), BA = typeof IA == "string" ? IA : void 0;
    var QA = isLikeNone(BA) ? 0 : passStringToWasm0(BA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), EA = WASM_VECTOR_LEN;
    getInt32Memory0()[gA / 4 + 1] = EA, getInt32Memory0()[gA / 4 + 0] = QA;
  }, CA.wbg.__wbg_fetch_bc7c8e27076a5c84 = function(gA) {
    const AA = fetch(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_done_2ffa852272310e47 = function(gA) {
    return getObject(gA).done;
  }, CA.wbg.__wbg_value_9f6eeb1e2aab8d96 = function(gA) {
    const AA = getObject(gA).value;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_newwithintounderlyingsource_a03a82aa1bbbb292 = function(gA, AA) {
    const IA = new ReadableStream(IntoUnderlyingSource.__wrap(gA), takeObject(AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_getReader_ab94afcb5cb7689a = function() {
    return handleError(function(gA) {
      const AA = getObject(gA).getReader();
      return addHeapObject(AA);
    }, arguments);
  }, CA.wbg.__wbg_sethighWaterMark_ea50ed3ec2143088 = function(gA, AA) {
    getObject(gA).highWaterMark = AA;
  }, CA.wbg.__wbg_recordbatch_new = function(gA) {
    const AA = RecordBatch.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbg_table_new = function(gA) {
    const AA = Table$1.__wrap(gA);
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_jsval_loose_eq = function(gA, AA) {
    return getObject(gA) == getObject(AA);
  }, CA.wbg.__wbindgen_boolean_get = function(gA) {
    const AA = getObject(gA);
    return typeof AA == "boolean" ? AA ? 1 : 0 : 2;
  }, CA.wbg.__wbindgen_as_number = function(gA) {
    return +getObject(gA);
  }, CA.wbg.__wbg_String_b9412f8799faab3e = function(gA, AA) {
    const IA = String(getObject(AA)), BA = passStringToWasm0(IA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), QA = WASM_VECTOR_LEN;
    getInt32Memory0()[gA / 4 + 1] = QA, getInt32Memory0()[gA / 4 + 0] = BA;
  }, CA.wbg.__wbg_getwithrefkey_edc2c8960f0f1191 = function(gA, AA) {
    const IA = getObject(gA)[getObject(AA)];
    return addHeapObject(IA);
  }, CA.wbg.__wbg_set_f975102236d3c502 = function(gA, AA, IA) {
    getObject(gA)[takeObject(AA)] = takeObject(IA);
  }, CA.wbg.__wbindgen_cb_drop = function(gA) {
    const AA = takeObject(gA).original;
    return AA.cnt-- == 1 ? (AA.a = 0, !0) : !1;
  }, CA.wbg.__wbg_queueMicrotask_481971b0d87f3dd4 = function(gA) {
    queueMicrotask(getObject(gA));
  }, CA.wbg.__wbg_queueMicrotask_3cbae2ec6b6cd3d6 = function(gA) {
    const AA = getObject(gA).queueMicrotask;
    return addHeapObject(AA);
  }, CA.wbg.__wbindgen_is_function = function(gA) {
    return typeof getObject(gA) == "function";
  }, CA.wbg.__wbg_fetch_921fad6ef9e883dd = function(gA, AA) {
    const IA = getObject(gA).fetch(getObject(AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_new_ab6fd82b10560829 = function() {
    return handleError(function() {
      const gA = new Headers();
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_append_7bfcb4937d1d5e29 = function() {
    return handleError(function(gA, AA, IA, BA, QA) {
      getObject(gA).append(getStringFromWasm0(AA, IA), getStringFromWasm0(BA, QA));
    }, arguments);
  }, CA.wbg.__wbg_close_a994f9425dab445c = function() {
    return handleError(function(gA) {
      getObject(gA).close();
    }, arguments);
  }, CA.wbg.__wbg_enqueue_ea194723156c0cc2 = function() {
    return handleError(function(gA, AA) {
      getObject(gA).enqueue(getObject(AA));
    }, arguments);
  }, CA.wbg.__wbg_size_9c7e57fbd4f0f4b5 = function(gA) {
    return getObject(gA).size;
  }, CA.wbg.__wbg_arrayBuffer_307ddd1bd1d04e23 = function(gA) {
    const AA = getObject(gA).arrayBuffer();
    return addHeapObject(AA);
  }, CA.wbg.__wbg_slice_1991e6e71a6587f3 = function() {
    return handleError(function(gA, AA, IA) {
      const BA = getObject(gA).slice(AA, IA);
      return addHeapObject(BA);
    }, arguments);
  }, CA.wbg.__wbg_read_e7d0f8a49be01d86 = function(gA) {
    const AA = getObject(gA).read();
    return addHeapObject(AA);
  }, CA.wbg.__wbg_releaseLock_5c49db976c08b864 = function(gA) {
    getObject(gA).releaseLock();
  }, CA.wbg.__wbg_cancel_6ee33d4006737aef = function(gA) {
    const AA = getObject(gA).cancel();
    return addHeapObject(AA);
  }, CA.wbg.__wbg_byobRequest_72fca99f9c32c193 = function(gA) {
    const AA = getObject(gA).byobRequest;
    return isLikeNone(AA) ? 0 : addHeapObject(AA);
  }, CA.wbg.__wbg_close_184931724d961ccc = function() {
    return handleError(function(gA) {
      getObject(gA).close();
    }, arguments);
  }, CA.wbg.__wbg_instanceof_Response_849eb93e75734b6e = function(gA) {
    let AA;
    try {
      AA = getObject(gA) instanceof Response;
    } catch {
      AA = !1;
    }
    return AA;
  }, CA.wbg.__wbg_url_5f6dc4009ac5f99d = function(gA, AA) {
    const IA = getObject(AA).url, BA = passStringToWasm0(IA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), QA = WASM_VECTOR_LEN;
    getInt32Memory0()[gA / 4 + 1] = QA, getInt32Memory0()[gA / 4 + 0] = BA;
  }, CA.wbg.__wbg_status_61a01141acd3cf74 = function(gA) {
    return getObject(gA).status;
  }, CA.wbg.__wbg_headers_9620bfada380764a = function(gA) {
    const AA = getObject(gA).headers;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_body_9545a94f397829db = function(gA) {
    const AA = getObject(gA).body;
    return isLikeNone(AA) ? 0 : addHeapObject(AA);
  }, CA.wbg.__wbg_arrayBuffer_29931d52c7206b02 = function() {
    return handleError(function(gA) {
      const AA = getObject(gA).arrayBuffer();
      return addHeapObject(AA);
    }, arguments);
  }, CA.wbg.__wbg_signal_a61f78a3478fd9bc = function(gA) {
    const AA = getObject(gA).signal;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_new_0d76b0581eca6298 = function() {
    return handleError(function() {
      const gA = new AbortController();
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_abort_2aa7521d5690750e = function(gA) {
    getObject(gA).abort();
  }, CA.wbg.__wbg_view_7f0ce470793a340f = function(gA) {
    const AA = getObject(gA).view;
    return isLikeNone(AA) ? 0 : addHeapObject(AA);
  }, CA.wbg.__wbg_respond_b1a43b2e3a06d525 = function() {
    return handleError(function(gA, AA) {
      getObject(gA).respond(AA >>> 0);
    }, arguments);
  }, CA.wbg.__wbg_newwithstrandinit_3fd6fba4083ff2d0 = function() {
    return handleError(function(gA, AA, IA) {
      const BA = new Request(getStringFromWasm0(gA, AA), getObject(IA));
      return addHeapObject(BA);
    }, arguments);
  }, CA.wbg.__wbg_get_bd8e338fbd5f5cc8 = function(gA, AA) {
    const IA = getObject(gA)[AA >>> 0];
    return addHeapObject(IA);
  }, CA.wbg.__wbg_length_cd7af8117672b8b8 = function(gA) {
    return getObject(gA).length;
  }, CA.wbg.__wbg_newnoargs_e258087cd0daa0ea = function(gA, AA) {
    const IA = new Function(getStringFromWasm0(gA, AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_new_d9bc3a0147634640 = function() {
    return addHeapObject(/* @__PURE__ */ new Map());
  }, CA.wbg.__wbg_next_40fc327bfc8770e6 = function(gA) {
    const AA = getObject(gA).next;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_next_196c84450b364254 = function() {
    return handleError(function(gA) {
      const AA = getObject(gA).next();
      return addHeapObject(AA);
    }, arguments);
  }, CA.wbg.__wbg_done_298b57d23c0fc80c = function(gA) {
    return getObject(gA).done;
  }, CA.wbg.__wbg_value_d93c65011f51a456 = function(gA) {
    const AA = getObject(gA).value;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_iterator_2cee6dadfd956dfa = function() {
    return addHeapObject(Symbol.iterator);
  }, CA.wbg.__wbg_get_e3c254076557e348 = function() {
    return handleError(function(gA, AA) {
      const IA = Reflect.get(getObject(gA), getObject(AA));
      return addHeapObject(IA);
    }, arguments);
  }, CA.wbg.__wbg_call_27c0f87801dedf93 = function() {
    return handleError(function(gA, AA) {
      const IA = getObject(gA).call(getObject(AA));
      return addHeapObject(IA);
    }, arguments);
  }, CA.wbg.__wbg_new_72fb9a18b5ae2624 = function() {
    const gA = new Object();
    return addHeapObject(gA);
  }, CA.wbg.__wbindgen_is_string = function(gA) {
    return typeof getObject(gA) == "string";
  }, CA.wbg.__wbg_self_ce0dbfc45cf2f5be = function() {
    return handleError(function() {
      const gA = self.self;
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_window_c6fb939a7f436783 = function() {
    return handleError(function() {
      const gA = window.window;
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_globalThis_d1e6af4856ba331b = function() {
    return handleError(function() {
      const gA = globalThis.globalThis;
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_global_207b558942527489 = function() {
    return handleError(function() {
      const gA = global.global;
      return addHeapObject(gA);
    }, arguments);
  }, CA.wbg.__wbg_isArray_2ab64d95e09ea0ae = function(gA) {
    return Array.isArray(getObject(gA));
  }, CA.wbg.__wbg_instanceof_ArrayBuffer_836825be07d4c9d2 = function(gA) {
    let AA;
    try {
      AA = getObject(gA) instanceof ArrayBuffer;
    } catch {
      AA = !1;
    }
    return AA;
  }, CA.wbg.__wbg_new_28c511d9baebfa89 = function(gA, AA) {
    const IA = new Error(getStringFromWasm0(gA, AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_call_b3ca7c6051f9bec1 = function() {
    return handleError(function(gA, AA, IA) {
      const BA = getObject(gA).call(getObject(AA), getObject(IA));
      return addHeapObject(BA);
    }, arguments);
  }, CA.wbg.__wbg_set_8417257aaedc936b = function(gA, AA, IA) {
    const BA = getObject(gA).set(getObject(AA), getObject(IA));
    return addHeapObject(BA);
  }, CA.wbg.__wbg_isSafeInteger_f7b04ef02296c4d2 = function(gA) {
    return Number.isSafeInteger(getObject(gA));
  }, CA.wbg.__wbg_new_cf3ec55744a78578 = function(gA) {
    const AA = new Date(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_entries_95cc2c823b285a09 = function(gA) {
    const AA = Object.entries(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_new_81740750da40724f = function(gA, AA) {
    try {
      var IA = { a: gA, b: AA }, BA = (EA, iA) => {
        const oA = IA.a;
        IA.a = 0;
        try {
          return __wbg_adapter_285(oA, IA.b, EA, iA);
        } finally {
          IA.a = oA;
        }
      };
      const QA = new Promise(BA);
      return addHeapObject(QA);
    } finally {
      IA.a = IA.b = 0;
    }
  }, CA.wbg.__wbg_resolve_b0083a7967828ec8 = function(gA) {
    const AA = Promise.resolve(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_catch_0260e338d10f79ae = function(gA, AA) {
    const IA = getObject(gA).catch(getObject(AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_then_0c86a60e8fcfe9f6 = function(gA, AA) {
    const IA = getObject(gA).then(getObject(AA));
    return addHeapObject(IA);
  }, CA.wbg.__wbg_then_a73caa9a87991566 = function(gA, AA, IA) {
    const BA = getObject(gA).then(getObject(AA), getObject(IA));
    return addHeapObject(BA);
  }, CA.wbg.__wbg_buffer_12d079cc21e14bdb = function(gA) {
    const AA = getObject(gA).buffer;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(gA, AA, IA) {
    const BA = new Uint8Array(getObject(gA), AA >>> 0, IA >>> 0);
    return addHeapObject(BA);
  }, CA.wbg.__wbg_new_63b92bc8671ed464 = function(gA) {
    const AA = new Uint8Array(getObject(gA));
    return addHeapObject(AA);
  }, CA.wbg.__wbg_set_a47bac70306a19a7 = function(gA, AA, IA) {
    getObject(gA).set(getObject(AA), IA >>> 0);
  }, CA.wbg.__wbg_length_c20a40f15020d68a = function(gA) {
    return getObject(gA).length;
  }, CA.wbg.__wbg_instanceof_Uint8Array_2b3bbecd033d19f6 = function(gA) {
    let AA;
    try {
      AA = getObject(gA) instanceof Uint8Array;
    } catch {
      AA = !1;
    }
    return AA;
  }, CA.wbg.__wbg_newwithlength_e9b4878cebadb3d3 = function(gA) {
    const AA = new Uint8Array(gA >>> 0);
    return addHeapObject(AA);
  }, CA.wbg.__wbg_newwithbyteoffset_27c6424791adc775 = function(gA, AA) {
    const IA = new Uint8Array(getObject(gA), AA >>> 0);
    return addHeapObject(IA);
  }, CA.wbg.__wbg_buffer_dd7f74bc60f1faab = function(gA) {
    const AA = getObject(gA).buffer;
    return addHeapObject(AA);
  }, CA.wbg.__wbg_byteLength_58f7b4fab1919d44 = function(gA) {
    return getObject(gA).byteLength;
  }, CA.wbg.__wbg_byteOffset_81d60f7392524f62 = function(gA) {
    return getObject(gA).byteOffset;
  }, CA.wbg.__wbg_stringify_8887fe74e1c50d81 = function() {
    return handleError(function(gA) {
      const AA = JSON.stringify(getObject(gA));
      return addHeapObject(AA);
    }, arguments);
  }, CA.wbg.__wbg_has_0af94d20077affa2 = function() {
    return handleError(function(gA, AA) {
      return Reflect.has(getObject(gA), getObject(AA));
    }, arguments);
  }, CA.wbg.__wbg_set_1f9b04f170055d33 = function() {
    return handleError(function(gA, AA, IA) {
      return Reflect.set(getObject(gA), getObject(AA), getObject(IA));
    }, arguments);
  }, CA.wbg.__wbindgen_bigint_get_as_i64 = function(gA, AA) {
    const IA = getObject(AA), BA = typeof IA == "bigint" ? IA : void 0;
    getBigInt64Memory0()[gA / 8 + 1] = isLikeNone(BA) ? BigInt(0) : BA, getInt32Memory0()[gA / 4 + 0] = !isLikeNone(BA);
  }, CA.wbg.__wbindgen_debug_string = function(gA, AA) {
    const IA = debugString(getObject(AA)), BA = passStringToWasm0(IA, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc), QA = WASM_VECTOR_LEN;
    getInt32Memory0()[gA / 4 + 1] = QA, getInt32Memory0()[gA / 4 + 0] = BA;
  }, CA.wbg.__wbindgen_throw = function(gA, AA) {
    throw new Error(getStringFromWasm0(gA, AA));
  }, CA.wbg.__wbindgen_memory = function() {
    const gA = wasm.memory;
    return addHeapObject(gA);
  }, CA.wbg.__wbindgen_function_table = function() {
    const gA = wasm.__wbindgen_export_2;
    return addHeapObject(gA);
  }, CA.wbg.__wbindgen_closure_wrapper13295 = function(gA, AA, IA) {
    const BA = makeMutClosure(gA, AA, 3248, __wbg_adapter_50);
    return addHeapObject(BA);
  }, CA;
}
function __wbg_finalize_init(CA, gA) {
  return wasm = CA.exports, __wbg_init.__wbindgen_wasm_module = gA, cachedBigInt64Memory0 = null, cachedFloat64Memory0 = null, cachedInt32Memory0 = null, cachedUint32Memory0 = null, cachedUint8Memory0 = null, wasm;
}
async function __wbg_init(CA) {
  if (wasm !== void 0) return wasm;
  typeof CA > "u" && (CA = new URL("./assets/1b1a876c211e4f13.wasm", import.meta.url));
  const gA = __wbg_get_imports();
  (typeof CA == "string" || typeof Request == "function" && CA instanceof Request || typeof URL == "function" && CA instanceof URL) && (CA = fetch(CA));
  const { instance: AA, module: IA } = await __wbg_load(await CA, gA);
  return __wbg_finalize_init(AA, IA);
}
__wbg_init();
function isPandasRangeIndex(CA) {
  return typeof CA == "object" && CA.kind === "range";
}
function parsePandasSchema(CA) {
  const gA = CA.schema.metadata.get("pandas");
  if (!isNullOrUndefined$1(gA))
    return JSON.parse(gA);
}
function parsePandasIndexData(CA, gA) {
  return gA ? gA.index_columns.map((AA) => {
    if (isPandasRangeIndex(AA)) {
      const {
        start: BA,
        stop: QA,
        step: EA
      } = AA;
      return range$1(BA, QA, EA);
    }
    const IA = CA.getChild(AA);
    return IA instanceof Vector && IA.type instanceof Null ? null : IA;
  }).filter((AA) => AA !== null) : [];
}
function parseHeaderName(CA, gA) {
  if (gA === 1)
    return [CA];
  try {
    return JSON.parse(CA.trim().replace(/^\(/, "[").replace(/\)$/, "]").replace(/'/g, '"'));
  } catch {
    return [...Array(gA - 1).fill(""), CA];
  }
}
function parseColumnNames(CA, gA, AA) {
  const IA = gA.concat(CA);
  return unzip(IA.map((BA) => BA.arrowField.name.startsWith("__index_level_") ? "" : BA.arrowField.name).map((BA) => (
    // If DataFrame `columns` has multi-level indexing, the length of
    // `column_indexes` will show how many levels there are.
    parseHeaderName(BA, AA?.column_indexes.length ?? 1)
  )));
}
function parseData(CA, gA) {
  const AA = CA.numRows, IA = gA.length;
  if (AA === 0 || IA === 0)
    return CA.select([]);
  const BA = gA.map((QA) => QA.arrowField.name);
  return CA.select(BA);
}
function parsePandasIndexColumnTypes(CA, gA, AA) {
  return gA ? gA.index_columns.map((BA) => {
    if (isPandasRangeIndex(BA)) {
      const EA = BA.name || "";
      return {
        type: DataFrameCellType.INDEX,
        arrowField: new Field(EA, new Int_(!0, 64), !0),
        pandasType: {
          field_name: EA,
          name: EA,
          pandas_type: PandasRangeIndexType,
          numpy_type: PandasRangeIndexType,
          metadata: BA
        }
      };
    }
    const QA = CA.fields.find((EA) => EA.name === BA);
    if (!QA)
      throw new Error(`Index field ${BA} not found in arrow schema`);
    return {
      type: DataFrameCellType.INDEX,
      arrowField: QA,
      pandasType: gA.columns.find((EA) => EA.field_name === BA),
      categoricalOptions: AA[QA.name]
    };
  }) : [];
}
function parseDataColumnTypes(CA, gA, AA) {
  return CA.fields.filter((QA) => gA ? !gA.index_columns.includes(QA.name) : !0).map((QA) => ({
    type: DataFrameCellType.DATA,
    arrowField: QA,
    pandasType: gA?.columns.find((EA) => EA.field_name === QA.name),
    categoricalOptions: AA[QA.name]
  }));
}
function parseCategoricalOptionsForColumns(CA) {
  const gA = {};
  return CA.schema.fields.forEach((AA, IA) => {
    if (AA.type instanceof Dictionary) {
      const BA = CA.getChildAt(IA)?.data[0]?.dictionary;
      notNullOrUndefined(BA) && (gA[AA.name] = convertVectorToList(BA));
    }
  }), gA;
}
function parseArrowIpcBytes(CA) {
  const gA = CA && CA.length > 0, AA = tableFromIPC(gA ? readParquet(CA).intoIPCStream() : new Uint8Array(0)), IA = AA.schema, BA = parsePandasSchema(AA), QA = parseCategoricalOptionsForColumns(AA), EA = parsePandasIndexColumnTypes(IA, BA, QA), iA = parseDataColumnTypes(IA, BA, QA), oA = parseData(AA, iA), cA = parsePandasIndexData(AA, BA), tA = parseColumnNames(iA, EA, BA);
  return {
    pandasIndexData: cA,
    data: oA,
    columnNames: tA,
    pandasIndexColumnTypes: EA,
    dataColumnTypes: iA
  };
}
var _a;
_a = DRAFTABLE;
class Quiver {
  constructor(gA) {
    this[_a] = !0;
    const {
      pandasIndexData: AA,
      columnNames: IA,
      data: BA,
      dataColumnTypes: QA,
      pandasIndexColumnTypes: EA
    } = parseArrowIpcBytes(gA.data), iA = gA.styler ? parseStyler(gA.styler) : void 0;
    this._pandasIndexData = AA, this._columnNames = IA, this._data = BA, this._dataColumnTypes = QA, this._pandasIndexColumnTypes = EA, this._styler = iA, this._num_bytes = gA.data?.length ?? 0, this._columnTypes = this._pandasIndexColumnTypes.concat(this._dataColumnTypes);
  }
  /** Matrix of column names of the index- & data-columns.
   *
   * This is a matrix to support multi-level headers.
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  get columnNames() {
    return this._columnNames;
  }
  /** List of column types for every index- & data-column. */
  get columnTypes() {
    return this._columnTypes;
  }
  /** Pandas Styler data. This will only be defined if the user styled the dataframe
   * via Pandas Styler.
   */
  get styler() {
    return this._styler;
  }
  /** Dimensions of the DataFrame. */
  get dimensions() {
    const gA = this._pandasIndexColumnTypes.length || 0, AA = this._columnNames.length || 1, IA = this._data.numRows || 0, BA = this._dataColumnTypes.length || 0, QA = AA + IA, EA = gA + BA;
    return {
      numHeaderRows: AA,
      numIndexColumns: gA,
      numDataRows: IA,
      numDataColumns: BA,
      numRows: QA,
      numColumns: EA
    };
  }
  /**
   * A hash that identifies the underlying data.
   *
   * This hash is based on various descriptive information
   * but is not 100% guaranteed to be unique.
   */
  get hash() {
    const gA = [this.dimensions.numColumns, this.dimensions.numDataColumns, this.dimensions.numDataRows, this.dimensions.numIndexColumns, this.dimensions.numHeaderRows, this.dimensions.numRows, this._num_bytes, this._columnNames];
    return hashString(gA.join("-"));
  }
  /** Return a single cell from an (Pandas) index- or data-column of the DataFrame.
   *
   * @param rowIndex - The row index of the cell (0 is the first data or index row excluding header rows)
   * @param columnIndex - The column index of the cell (0 is the first data or index column)
   * @returns The cell's content, type, and field.
   */
  getCell(gA, AA) {
    const {
      numIndexColumns: IA,
      numDataRows: BA,
      numColumns: QA
    } = this.dimensions;
    if (gA < 0 || gA >= BA)
      throw new Error(`Row index is out of range: ${gA}`);
    if (AA < 0 || AA >= QA)
      throw new Error(`Column index is out of range: ${AA}`);
    if (AA < IA) {
      const tA = this._pandasIndexColumnTypes[AA], eA = this.getIndexValue(gA, AA);
      return {
        type: DataFrameCellType.INDEX,
        content: eA,
        contentType: tA,
        field: tA.arrowField
      };
    }
    const iA = AA - IA, oA = this._dataColumnTypes[iA], cA = this.getDataValue(gA, iA);
    return {
      type: DataFrameCellType.DATA,
      content: cA,
      contentType: oA,
      field: oA.arrowField
    };
  }
  /** Get the raw value of an index cell.
   *
   * Index columns only exist if the DataFrame was created based on a Pandas DataFrame.
   */
  getIndexValue(gA, AA) {
    const IA = this._pandasIndexData[AA];
    return IA instanceof Vector ? IA.get(gA) : IA[gA];
  }
  /** Get the raw value of a data cell. */
  getDataValue(gA, AA) {
    return this._data.getChildAt(AA)?.get(gA);
  }
  /**
   * Add the contents of another table (data + indexes) to this table.
   * Extra columns will not be created.
   */
  addRows(gA) {
    if (this.styler || gA.styler)
      throw new Error("\nUnsupported operation. `add_rows()` does not support Pandas Styler objects.\n\nIf you do not need the Styler's styles, try passing the `.data` attribute of\nthe Styler object instead to concatenate just the underlying dataframe.\n\nFor example:\n```\nst.add_rows(my_styler.data)\n```\n");
    if (gA.dimensions.numDataRows === 0)
      return produce(this, (EA) => EA);
    if (this.dimensions.numDataRows === 0)
      return produce(gA, (EA) => EA);
    const {
      index: AA,
      data: IA,
      indexTypes: BA,
      dataTypes: QA
    } = concat(this._dataColumnTypes, this._pandasIndexColumnTypes, this._pandasIndexData, this._data, gA._dataColumnTypes, gA._pandasIndexColumnTypes, gA._pandasIndexData, gA._data);
    return produce(this, (EA) => {
      EA._pandasIndexData = AA, EA._data = IA, EA._pandasIndexColumnTypes = BA, EA._dataColumnTypes = QA, EA._columnTypes = BA.concat(QA);
    });
  }
}
function parseStyler(CA) {
  return {
    uuid: CA.uuid,
    caption: CA.caption,
    cssStyles: CA.styles,
    cssId: CA.uuid ? `T_${CA.uuid}` : void 0,
    // Recursively create a new Quiver instance for Styler's display values.
    // This values will be used for rendering the DataFrame, while the original values
    // will be used for sorting, etc.
    displayValues: new Quiver({
      data: CA.displayValues
    })
  };
}
class ElementNode {
  /** Create a new ElementNode. */
  constructor(gA, AA, IA, BA, QA) {
    this.element = gA, this.metadata = AA, this.scriptRunId = IA, this.activeScriptHash = BA, this.fragmentId = QA;
  }
  get quiverElement() {
    if (this.lazyQuiverElement !== void 0)
      return this.lazyQuiverElement;
    if (this.element.type !== "table" && this.element.type !== "dataframe")
      throw new Error(`elementType '${this.element.type}' is not a valid Quiver element!`);
    const gA = this.element.type === "table" ? this.element.table?.arrowData : this.element.dataframe?.arrowData, AA = new Quiver(gA);
    return this.lazyQuiverElement = AA, AA;
  }
  get vegaLiteChartElement() {
    if (this.lazyVegaLiteChartElement !== void 0)
      return this.lazyVegaLiteChartElement;
    if (this.element.type !== "vegaLiteChart")
      throw new Error(`elementType '${this.element.type}' is not a valid VegaLiteChartElement!`);
    const gA = this.element.vegaLiteChart, AA = gA.data ? new Quiver(gA.data) : null, IA = gA.datasets.length > 0 ? wrapDatasets(gA.datasets) : [], BA = {
      data: AA,
      spec: gA.spec,
      datasets: IA,
      useContainerWidth: gA.useContainerWidth,
      vegaLiteTheme: gA.theme,
      id: gA.id,
      selectionMode: gA.selectionMode,
      formId: gA.formId
    };
    return this.lazyVegaLiteChartElement = BA, BA;
  }
  arrowAddRows(gA, AA) {
    const IA = this.element.type, BA = new ElementNode(this.element, this.metadata, AA, this.activeScriptHash, this.fragmentId);
    switch (IA) {
      case "table":
      case "dataframe": {
        BA.lazyQuiverElement = ElementNode.quiverAddRowsHelper(this.quiverElement, gA);
        break;
      }
      case "vegaLiteChart": {
        BA.lazyVegaLiteChartElement = ElementNode.vegaLiteChartAddRowsHelper(this.vegaLiteChartElement, gA);
        break;
      }
      default:
        throw new Error(`elementType '${this.element.type}' is not a valid arrowAddRows target!`);
    }
    return BA;
  }
  static quiverAddRowsHelper(gA, AA) {
    if (AA.hasName)
      throw new Error("Add rows cannot be used with a named dataset for this element.");
    const IA = new Quiver(AA.data);
    return gA.addRows(IA);
  }
  static vegaLiteChartAddRowsHelper(gA, AA) {
    const IA = AA.hasName ? AA.name : null, BA = new Quiver(AA.data);
    return produce(gA, (QA) => {
      const EA = getNamedDataSet(QA.datasets, IA);
      EA ? EA.data = EA.data.addRows(BA) : QA.data = QA.data ? QA.data.addRows(BA) : BA;
    });
  }
  /**
   * Accept a visitor.
   * @param visitor - The visitor to accept.
   * @returns The result of the visitor's visitElementNode method.
   * @example
   * const visitor = new DebugVisitor()
   * const result = elementNode.accept(visitor)
   * console.log(result)
   */
  accept(gA) {
    return gA.visitElementNode(this);
  }
  /**
   * Returns a string representation of this ElementNode for debugging purposes.
   * This method can be used to log or inspect the state of the node.
   *
   * @returns {string} A debug string describing this node.
   */
  debug() {
    return this.accept(new DebugVisitor());
  }
  replaceTransientNodeWithSelf(gA) {
    if (gA.scriptRunId !== this.scriptRunId)
      return this;
    if (gA.transientNodes.length === 0)
      return this;
    const AA = gA.updateTransientNodes((IA) => (
      // All transient nodes should be ElementNodes
      IA.accept(new ClearStaleNodeVisitor(this.scriptRunId))
    ));
    return AA.length === 0 ? this : new TransientNode(this.scriptRunId, this, AA, gA.deltaMsgReceivedAt);
  }
}
function getNamedDataSet(CA, gA) {
  return CA.length === 1 ? CA[0] : CA.find((AA) => AA.hasName && AA.name === gA);
}
function wrapDatasets(CA) {
  return CA.map((gA) => ({
    hasName: gA.hasName,
    name: gA.name,
    data: new Quiver(gA.data)
  }));
}
class ClearTransientNodesVisitor {
  constructor(gA) {
    this.fragmentIdsThisRun = gA ?? [];
  }
  visitBlockNode(gA) {
    if (
      // There are fragment IDs this run, and this block is not one of them
      this.fragmentIdsThisRun.length > 0 && gA.fragmentId && !this.fragmentIdsThisRun.includes(gA.fragmentId)
    )
      return gA;
    const AA = [];
    let IA = !1;
    return gA.children.forEach((BA) => {
      const QA = BA.accept(this);
      QA !== BA && (IA = !0), QA !== void 0 && AA.push(QA);
    }), IA ? new BlockNode(gA.activeScriptHash, AA, gA.deltaBlock, gA.scriptRunId, gA.fragmentId, gA.deltaMsgReceivedAt) : gA;
  }
  visitElementNode(gA) {
    return gA;
  }
  visitTransientNode(gA) {
    return gA.anchor;
  }
}
class ElementsSetVisitor {
  constructor() {
    this.elements = /* @__PURE__ */ new Set(), this.blockIds = /* @__PURE__ */ new Set();
  }
  visitElementNode(gA) {
    return this.elements.add(gA.element), this.elements;
  }
  visitBlockNode(gA) {
    gA.deltaBlock?.id && this.blockIds.add(gA.deltaBlock.id);
    for (const AA of gA.children)
      AA.accept(this);
    return this.elements;
  }
  visitTransientNode(gA) {
    return gA.transientNodes.forEach((AA) => {
      AA.accept(this);
    }), gA.anchor?.accept(this), this.elements;
  }
  /**
   * Static convenience method to collect all elements from a node tree.
   */
  static collectElements(gA) {
    const AA = new ElementsSetVisitor();
    return gA.accept(AA), AA.elements;
  }
}
class FilterMainScriptElementsVisitor {
  constructor(gA) {
    this.mainScriptHash = gA;
  }
  visitElementNode(gA) {
    if (gA.activeScriptHash === this.mainScriptHash)
      return gA;
  }
  visitBlockNode(gA) {
    if (gA.activeScriptHash !== this.mainScriptHash)
      return;
    let AA = !1;
    const IA = [];
    for (const BA of gA.children) {
      const QA = BA.accept(this);
      QA !== BA && (AA = !0), QA !== void 0 && IA.push(QA);
    }
    return AA ? new BlockNode(gA.activeScriptHash, IA, gA.deltaBlock, gA.scriptRunId, gA.fragmentId, gA.deltaMsgReceivedAt) : gA;
  }
  visitTransientNode(gA) {
    const AA = gA.anchor?.accept(this), IA = gA.updateTransientNodes((BA) => BA.accept(this));
    if (!(!AA && IA.length === 0))
      return IA.length === 0 ? AA : new TransientNode(gA.scriptRunId, AA, IA, gA.deltaMsgReceivedAt);
  }
  /**
   * Static convenience method to filter a node tree based on mainScriptHash.
   */
  static filterNode(gA, AA) {
    const IA = new FilterMainScriptElementsVisitor(AA);
    return gA.accept(IA);
  }
}
class GetNodeByDeltaPathVisitor {
  constructor(gA) {
    this.deltaPath = gA;
  }
  visitElementNode(gA) {
  }
  visitBlockNode(gA) {
    if (this.deltaPath.length === 0)
      return;
    const [AA, ...IA] = this.deltaPath;
    if (AA < 0 || AA >= gA.children.length)
      return;
    if (IA.length === 0)
      return gA.children[AA];
    const BA = new GetNodeByDeltaPathVisitor(IA);
    return gA.children[AA].accept(BA);
  }
  visitTransientNode(gA) {
    return this.deltaPath.length === 0 ? gA.anchor : gA.anchor?.accept(this);
  }
  /**
   * Static convenience method to get a node at a delta path.
   */
  static getNodeAtPath(gA, AA) {
    const IA = new GetNodeByDeltaPathVisitor(AA);
    return gA.accept(IA);
  }
}
class SetNodeByDeltaPathVisitor {
  constructor(gA, AA, IA) {
    this.deltaPath = gA, this.nodeToSet = AA, this.scriptRunId = IA;
  }
  visitElementNode(gA) {
    if (this.deltaPath.length > 0)
      throw new Error("'setIn' cannot be called on an ElementNode");
    return this.nodeToSet instanceof TransientNode && !this.nodeToSet.anchor ? new TransientNode(this.nodeToSet.scriptRunId, gA, this.nodeToSet.transientNodes, this.nodeToSet.deltaMsgReceivedAt) : this.nodeToSet;
  }
  visitTransientNode(gA) {
    if (this.deltaPath.length === 0)
      return this.nodeToSet.replaceTransientNodeWithSelf(gA);
    if (gA.anchor) {
      const AA = gA.anchor.accept(this);
      return new TransientNode(gA.scriptRunId, AA, gA.transientNodes, gA.deltaMsgReceivedAt);
    }
    throw new Error("TransientNode has no anchor to set node at");
  }
  visitBlockNode(gA) {
    if (this.deltaPath.length === 0)
      return this.nodeToSet instanceof TransientNode && !this.nodeToSet.anchor ? new TransientNode(this.nodeToSet.scriptRunId, gA, this.nodeToSet.transientNodes, this.nodeToSet.deltaMsgReceivedAt) : this.nodeToSet;
    const [AA, ...IA] = this.deltaPath;
    if (AA < 0 || AA > gA.children.length)
      throw new Error(`Bad delta path index ${AA} (should be between [0, ${gA.children.length}])`);
    let BA = [];
    const QA = new SetNodeByDeltaPathVisitor(IA, this.nodeToSet, this.scriptRunId);
    if (gA.children[AA]) {
      let EA = 0;
      for (; EA < gA.children.length; ) {
        const iA = gA.children[EA];
        if (EA !== AA) {
          BA.push(iA), EA++;
          continue;
        }
        const oA = iA.accept(QA);
        !(iA instanceof TransientNode) && oA instanceof TransientNode && oA.anchor !== iA ? (BA.push(oA), BA.push(iA)) : BA.push(oA), EA++;
      }
    } else {
      if (IA.length > 0)
        throw new Error("Cannot set a node at a delta path");
      BA = gA.children.slice(), BA[AA] = this.nodeToSet;
    }
    return new BlockNode(gA.activeScriptHash, BA, gA.deltaBlock, this.scriptRunId, gA.fragmentId, gA.deltaMsgReceivedAt);
  }
  /**
   * Static convenience method to set a node at a delta path.
   */
  static setNodeAtPath(gA, AA, IA, BA) {
    const QA = new SetNodeByDeltaPathVisitor(AA, IA, BA);
    return gA.accept(QA);
  }
}
class AppRoot {
  /**
   * Create an empty AppRoot with a placeholder "skeleton" element.
   * @param mainScriptHash - The hash of the main script that creates this AppRoot.
   * @param isInitialRender - Whether this is the initial render.
   * @param sidebarElements - The elements to add to the sidebar (this was a relic
   * of MPA V1 to maintain the sidebar from flickering, we don't use it anymore).
   * @param logo - The logo to add to the app.
   * @returns A new AppRoot with the given parameters.
   */
  static empty(gA = "", AA = !0, IA, BA) {
    const QA = [];
    let EA;
    switch (getLoadingScreenType()) {
      case LoadingScreenType.NONE:
        break;
      case LoadingScreenType.V1:
        AA && (EA = makeElementWithInfoText("Please wait..."));
        break;
      default:
        EA = makeAppSkeletonElement();
        break;
    }
    EA && QA.push(new ElementNode(EA, ForwardMsgMetadata.create({}), NO_SCRIPT_RUN_ID, gA));
    const iA = new BlockNode(gA, QA, new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), oA = IA || new BlockNode(gA, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), cA = new BlockNode(gA, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), tA = new BlockNode(gA, [], new Block$1({
      allowEmpty: !0
    }), NO_SCRIPT_RUN_ID), eA = BA ? {
      logo: BA,
      activeScriptHash: gA,
      scriptRunId: NO_SCRIPT_RUN_ID
    } : null;
    return new AppRoot(gA, new BlockNode(gA, [iA, oA, cA, tA]), eA);
  }
  constructor(gA, AA, IA = null) {
    if (this.mainScriptHash = gA, this.root = AA, this.appLogo = IA, this.root.children.length !== 4 || isNullOrUndefined$1(this.main) || isNullOrUndefined$1(this.sidebar) || isNullOrUndefined$1(this.event) || isNullOrUndefined$1(this.bottom))
      throw new Error(`Invalid root node children! ${AA}`);
  }
  get main() {
    const [gA] = this.root.children;
    return gA;
  }
  get sidebar() {
    const [, gA] = this.root.children;
    return gA;
  }
  get event() {
    const [, , gA] = this.root.children;
    return gA;
  }
  get bottom() {
    const [, , , gA] = this.root.children;
    return gA;
  }
  get logo() {
    return this.appLogo?.logo ?? null;
  }
  appRootWithLogo(gA, AA) {
    return new AppRoot(this.mainScriptHash, this.root, {
      logo: gA,
      ...AA
    });
  }
  applyDelta(gA, AA, IA) {
    const {
      deltaPath: BA,
      activeScriptHash: QA
    } = IA;
    switch (AA.type) {
      case "newElement": {
        const EA = AA.newElement;
        return this.addElement(BA, gA, EA, IA, QA, AA.fragmentId);
      }
      case "addBlock": {
        const EA = Date.now();
        return this.addBlock(BA, AA.addBlock, gA, QA, AA.fragmentId, EA);
      }
      case "newTransient": {
        const EA = AA.newTransient;
        return this.addTransient(BA, gA, EA, IA, QA, AA.fragmentId);
      }
      case "arrowAddRows":
        try {
          return this.arrowAddRows(BA, AA.arrowAddRows, gA);
        } catch (EA) {
          const iA = makeElementWithErrorText(ensureError(EA).message);
          return this.addElement(BA, gA, iA, IA, QA);
        }
      default:
        throw new Error(`Unrecognized deltaType: '${AA.type}'`);
    }
  }
  ensureBlockNode(gA, AA = this.mainScriptHash) {
    return gA ?? new BlockNode(AA);
  }
  /**
   * Clears all nodes that are not associated with the mainScriptHash.
   * @param mainScriptHash - The hash of the main script.
   * @returns A new AppRoot with the filtered nodes.
   */
  filterMainScriptElements(gA) {
    const AA = this.main.scriptRunId, IA = new FilterMainScriptElementsVisitor(gA), BA = this.root.children.map((EA) => this.ensureBlockNode(EA.accept(IA), gA)), QA = this.appLogo?.activeScriptHash === gA ? this.appLogo : null;
    return new AppRoot(gA, new BlockNode(gA, BA, new Block$1({
      allowEmpty: !0
    }), AA), QA);
  }
  clearStaleNodes(gA, AA) {
    const IA = new ClearStaleNodeVisitor(gA, AA), BA = this.root.children.map((iA) => this.ensureBlockNode(iA.accept(IA))), EA = AA && AA.length > 0 || this.appLogo?.scriptRunId === gA ? this.appLogo : null;
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, BA, new Block$1({
      allowEmpty: !0
    }), gA), EA);
  }
  clearTransientNodes(gA) {
    const AA = new ClearTransientNodesVisitor(gA), IA = this.root.children.map((BA) => this.ensureBlockNode(BA.accept(AA)));
    return new AppRoot(this.mainScriptHash, new BlockNode(this.mainScriptHash, IA, new Block$1({
      allowEmpty: !0
    }), this.main.scriptRunId), this.appLogo);
  }
  /** Return a Set containing all Elements in the tree. */
  getElements() {
    return this.getActiveIds().elements;
  }
  /**
   * Return all active element IDs and block IDs in the tree.
   * Block IDs are collected from blocks that have a stable identity
   * (e.g. keyed layout containers), and are needed to prevent
   * elementStates entries from being garbage-collected.
   */
  getActiveIds() {
    const gA = new ElementsSetVisitor();
    return this.main.accept(gA), this.sidebar.accept(gA), this.event.accept(gA), this.bottom.accept(gA), {
      elements: gA.elements,
      blockIds: gA.blockIds
    };
  }
  addElement(gA, AA, IA, BA, QA, EA) {
    const iA = new ElementNode(IA, BA, AA, QA, EA);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, gA, iA, AA), this.appLogo);
  }
  addBlock(gA, AA, IA, BA, QA, EA) {
    const iA = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, gA), oA = iA instanceof TransientNode ? iA.anchor ?? iA : iA;
    let cA = [];
    oA instanceof BlockNode && oA.deltaBlock.type === AA.type && (AA.dialog && oA.deltaBlock.dialog && AA.id !== oA.deltaBlock.id || (cA = oA.children));
    const tA = new BlockNode(BA, cA, AA, IA, QA, EA);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, gA, tA, IA), this.appLogo);
  }
  addTransient(gA, AA, IA, BA, QA, EA, iA) {
    const oA = new TransientNode(
      AA,
      void 0,
      // We do not have an anchor yet
      IA.elements.map((cA) => new ElementNode(cA, BA, AA, QA, EA)),
      iA
    );
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, gA, oA, AA), this.appLogo);
  }
  arrowAddRows(gA, AA, IA) {
    const BA = GetNodeByDeltaPathVisitor.getNodeAtPath(this.root, gA);
    if (isNullOrUndefined$1(BA) || !(BA instanceof ElementNode))
      throw new Error(`Can't arrowAddRows: invalid deltaPath: ${gA}`);
    const QA = BA.arrowAddRows(AA, IA);
    return new AppRoot(this.mainScriptHash, SetNodeByDeltaPathVisitor.setNodeAtPath(this.root, gA, QA, IA), this.appLogo);
  }
  getChildName(gA) {
    switch (gA) {
      case this.main:
        return "main";
      case this.sidebar:
        return "sidebar";
      case this.event:
        return "event";
      case this.bottom:
        return "bottom";
      default:
        return "unknown";
    }
  }
  /**
   * Returns a string representation of the AppRoot structure for debugging purposes.
   * This method traverses the AppRoot tree and outputs a formatted string
   * showing the hierarchy of its child nodes.
   *
   * @returns {string} A formatted string representing the AppRoot structure.
   */
  debug() {
    let gA = `AppRoot
`;
    return this.root.children.forEach((AA, IA) => {
      const BA = IA === this.root.children.length - 1, QA = this.getChildName(AA), EA = BA ? "└── " : "├── ", iA = BA ? "    " : "│   ";
      gA += `${EA}${QA}:
`;
      const oA = new DebugVisitor(iA, !0);
      gA += AA.accept(oA);
    }), gA;
  }
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  return hasRequiredClassnames || (hasRequiredClassnames = 1, (function(CA) {
    (function() {
      var gA = {}.hasOwnProperty;
      function AA() {
        for (var QA = "", EA = 0; EA < arguments.length; EA++) {
          var iA = arguments[EA];
          iA && (QA = BA(QA, IA(iA)));
        }
        return QA;
      }
      function IA(QA) {
        if (typeof QA == "string" || typeof QA == "number")
          return QA;
        if (typeof QA != "object")
          return "";
        if (Array.isArray(QA))
          return AA.apply(null, QA);
        if (QA.toString !== Object.prototype.toString && !QA.toString.toString().includes("[native code]"))
          return QA.toString();
        var EA = "";
        for (var iA in QA)
          gA.call(QA, iA) && QA[iA] && (EA = BA(EA, iA));
        return EA;
      }
      function BA(QA, EA) {
        return EA ? QA ? QA + " " + EA : QA + EA : QA;
      }
      CA.exports ? (AA.default = AA, CA.exports = AA) : window.classNames = AA;
    })();
  })(classnames)), classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
var Direction = /* @__PURE__ */ ((CA) => (CA.HORIZONTAL = "row", CA.VERTICAL = "column", CA))(Direction || {});
function getDirectionOfBlock(CA) {
  return CA.flexContainer ? CA.flexContainer.direction == Block$1.FlexContainer.Direction.HORIZONTAL ? "row" : "column" : CA.vertical ? "column" : CA.horizontal ? "row" : "column";
}
function shouldWidthStretch(CA) {
  return !!(CA?.useStretch || CA?.pixelWidth);
}
function shouldHeightStretch(CA) {
  return !!(CA?.useStretch || CA?.pixelHeight);
}
const alignmentMap = {
  [streamlit.TextAlignmentConfig.Alignment.LEFT]: "left",
  [streamlit.TextAlignmentConfig.Alignment.CENTER]: "center",
  [streamlit.TextAlignmentConfig.Alignment.RIGHT]: "right",
  [streamlit.TextAlignmentConfig.Alignment.JUSTIFY]: "justify",
  [streamlit.TextAlignmentConfig.Alignment.UNSPECIFIED]: "left"
};
function getTextAlignmentStyle(CA) {
  if (CA?.alignment)
    return alignmentMap[CA.alignment] || "left";
}
const FlexContext = createContext(null);
FlexContext.displayName = "FlexContext";
const FlexContextProvider = ({
  children: CA,
  direction: gA,
  isRoot: AA,
  parentWidth: IA,
  hasContentWidth: BA = !1,
  hasFixedWidth: QA = !1,
  parentContext: EA = null
}) => {
  const iA = useMemo$1(() => {
    const oA = gA === Direction.HORIZONTAL;
    let cA;
    return BA ? cA = !0 : QA ? cA = !1 : cA = EA?.isInContentWidthContainer ?? !1, {
      direction: gA,
      isInHorizontalLayout: oA,
      isInRoot: AA ?? !1,
      parentWidth: IA,
      isInContentWidthContainer: cA
    };
  }, [gA, AA, IA, BA, QA, EA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContext.Provider, { value: iA, children: CA });
};
function guard(CA, gA, AA) {
  return Math.min(Math.max(CA, AA), gA);
}
class ColorError extends Error {
  constructor(gA) {
    super(`Failed to parse color: "${gA}"`);
  }
}
var ColorError$1 = ColorError;
function parseToRgba(CA) {
  if (typeof CA != "string") throw new ColorError$1(CA);
  if (CA.trim().toLowerCase() === "transparent") return [0, 0, 0, 0];
  let gA = CA.trim();
  gA = namedColorRegex.test(CA) ? nameToHex(CA) : CA;
  const AA = reducedHexRegex.exec(gA);
  if (AA) {
    const EA = Array.from(AA).slice(1);
    return [...EA.slice(0, 3).map((iA) => parseInt(r$4(iA, 2), 16)), parseInt(r$4(EA[3] || "f", 2), 16) / 255];
  }
  const IA = hexRegex.exec(gA);
  if (IA) {
    const EA = Array.from(IA).slice(1);
    return [...EA.slice(0, 3).map((iA) => parseInt(iA, 16)), parseInt(EA[3] || "ff", 16) / 255];
  }
  const BA = rgbaRegex.exec(gA);
  if (BA) {
    const EA = Array.from(BA).slice(1);
    return [...EA.slice(0, 3).map((iA) => parseInt(iA, 10)), parseFloat(EA[3] || "1")];
  }
  const QA = hslaRegex.exec(gA);
  if (QA) {
    const [EA, iA, oA, cA] = Array.from(QA).slice(1).map(parseFloat);
    if (guard(0, 100, iA) !== iA) throw new ColorError$1(CA);
    if (guard(0, 100, oA) !== oA) throw new ColorError$1(CA);
    return [...hslToRgb(EA, iA, oA), Number.isNaN(cA) ? 1 : cA];
  }
  throw new ColorError$1(CA);
}
function hash(CA) {
  let gA = 5381, AA = CA.length;
  for (; AA; )
    gA = gA * 33 ^ CA.charCodeAt(--AA);
  return (gA >>> 0) % 2341;
}
const colorToInt = (CA) => parseInt(CA.replace(/_/g, ""), 36), compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((CA, gA) => {
  const AA = colorToInt(gA.substring(0, 3)), IA = colorToInt(gA.substring(3)).toString(16);
  let BA = "";
  for (let QA = 0; QA < 6 - IA.length; QA++)
    BA += "0";
  return CA[AA] = `${BA}${IA}`, CA;
}, {});
function nameToHex(CA) {
  const gA = CA.toLowerCase().trim(), AA = compressedColorMap[hash(gA)];
  if (!AA) throw new ColorError$1(CA);
  return `#${AA}`;
}
const r$4 = (CA, gA) => Array.from(Array(gA)).map(() => CA).join(""), reducedHexRegex = new RegExp(`^#${r$4("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), hexRegex = new RegExp(`^#${r$4("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$4(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, namedColorRegex = /^[a-z]+$/i, roundColor = (CA) => Math.round(CA * 255), hslToRgb = (CA, gA, AA) => {
  let IA = AA / 100;
  if (gA === 0)
    return [IA, IA, IA].map(roundColor);
  const BA = (CA % 360 + 360) % 360 / 60, QA = (1 - Math.abs(2 * IA - 1)) * (gA / 100), EA = QA * (1 - Math.abs(BA % 2 - 1));
  let iA = 0, oA = 0, cA = 0;
  BA >= 0 && BA < 1 ? (iA = QA, oA = EA) : BA >= 1 && BA < 2 ? (iA = EA, oA = QA) : BA >= 2 && BA < 3 ? (oA = QA, cA = EA) : BA >= 3 && BA < 4 ? (oA = EA, cA = QA) : BA >= 4 && BA < 5 ? (iA = EA, cA = QA) : BA >= 5 && BA < 6 && (iA = QA, cA = EA);
  const tA = IA - QA / 2, eA = iA + tA, aA = oA + tA, GA = cA + tA;
  return [eA, aA, GA].map(roundColor);
};
function parseToHsla(CA) {
  const [gA, AA, IA, BA] = parseToRgba(CA).map((eA, aA) => (
    // 3rd index is alpha channel which is already normalized
    aA === 3 ? eA : eA / 255
  )), QA = Math.max(gA, AA, IA), EA = Math.min(gA, AA, IA), iA = (QA + EA) / 2;
  if (QA === EA) return [0, 0, iA, BA];
  const oA = QA - EA, cA = iA > 0.5 ? oA / (2 - QA - EA) : oA / (QA + EA);
  return [60 * (gA === QA ? (AA - IA) / oA + (AA < IA ? 6 : 0) : AA === QA ? (IA - gA) / oA + 2 : (gA - AA) / oA + 4), cA, iA, BA];
}
function hsla(CA, gA, AA, IA) {
  return `hsla(${(CA % 360).toFixed()}, ${guard(0, 100, gA * 100).toFixed()}%, ${guard(0, 100, AA * 100).toFixed()}%, ${parseFloat(guard(0, 1, IA).toFixed(3))})`;
}
function darken(CA, gA) {
  const [AA, IA, BA, QA] = parseToHsla(CA);
  return hsla(AA, IA, BA - gA, QA);
}
function getLuminance(CA) {
  if (CA === "transparent") return 0;
  function gA(QA) {
    const EA = QA / 255;
    return EA <= 0.04045 ? EA / 12.92 : Math.pow((EA + 0.055) / 1.055, 2.4);
  }
  const [AA, IA, BA] = parseToRgba(CA);
  return 0.2126 * gA(AA) + 0.7152 * gA(IA) + 0.0722 * gA(BA);
}
function rgba(CA, gA, AA, IA) {
  return `rgba(${guard(0, 255, CA).toFixed()}, ${guard(0, 255, gA).toFixed()}, ${guard(0, 255, AA).toFixed()}, ${parseFloat(guard(0, 1, IA).toFixed(3))})`;
}
function mix(CA, gA, AA) {
  const IA = (rA, yA) => (
    // 3rd index is alpha channel which is already normalized
    yA === 3 ? rA : rA / 255
  ), [BA, QA, EA, iA] = parseToRgba(CA).map(IA), [oA, cA, tA, eA] = parseToRgba(gA).map(IA), aA = eA - iA, GA = AA * 2 - 1, nA = ((GA * aA === -1 ? GA : GA + aA / (1 + GA * aA)) + 1) / 2, DA = 1 - nA, hA = (BA * DA + oA * nA) * 255, wA = (QA * DA + cA * nA) * 255, sA = (EA * DA + tA * nA) * 255, NA = eA * AA + iA * (1 - AA);
  return rgba(hA, wA, sA, NA);
}
function lighten(CA, gA) {
  return darken(CA, -gA);
}
function transparentize(CA, gA) {
  const [AA, IA, BA, QA] = parseToRgba(CA);
  return rgba(AA, IA, BA, QA - gA);
}
function toHex(CA) {
  const [gA, AA, IA, BA] = parseToRgba(CA);
  let QA = (EA) => {
    const iA = guard(0, 255, EA).toString(16);
    return iA.length === 1 ? `0${iA}` : iA;
  };
  return `#${QA(gA)}${QA(AA)}${QA(IA)}${BA < 1 ? QA(Math.round(BA * 255)) : ""}`;
}
const CACHED_THEME_VERSION = 2, CACHED_THEME_BASE_KEY = `stActiveTheme-${window.location.pathname}`, LocalStore = {
  CACHED_THEME_VERSION,
  CACHED_THEME_BASE_KEY,
  ACTIVE_THEME: `${CACHED_THEME_BASE_KEY}-v${CACHED_THEME_VERSION}`
};
var baseui = {}, colors$3 = {
  white: "#FFFFFF",
  gray50: "#F6F6F6",
  gray100: "#EEEEEE",
  gray200: "#E2E2E2",
  gray300: "#CBCBCB",
  gray400: "#AFAFAF",
  gray500: "#6B6B6B",
  gray600: "#545454",
  gray700: "#333333",
  gray800: "#1F1F1F",
  gray900: "#141414",
  black: "#000000",
  platinum400: "#8EA3AD",
  red50: "#FFEFED",
  red100: "#FED7D2",
  red200: "#F1998E",
  red300: "#E85C4A",
  red400: "#E11900",
  red500: "#AB1300",
  red600: "#870F00",
  red700: "#5A0A00",
  orange200: "#FABDA5",
  orange300: "#FA9269",
  orange400: "#FF6937",
  orange500: "#C14F29",
  orange600: "#9A3F21",
  orange700: "#672A16",
  yellow50: "#FFFAF0",
  yellow100: "#FFF2D9",
  yellow200: "#FFE3AC",
  yellow300: "#FFCF70",
  yellow400: "#FFC043",
  yellow500: "#BC8B2C",
  yellow600: "#996F00",
  yellow700: "#674D1B",
  green50: "#E6F2ED",
  green100: "#ADDEC9",
  green200: "#66D19E",
  green300: "#06C167",
  green400: "#048848",
  green500: "#03703C",
  green600: "#03582F",
  green700: "#10462D",
  blue50: "#EFF3FE",
  blue100: "#D4E2FC",
  blue200: "#A0BFF8",
  blue300: "#5B91F5",
  blue400: "#276EF1",
  blue500: "#1E54B7",
  blue600: "#174291",
  blue700: "#102C60",
  cobalt400: "#0E1FC1",
  purple200: "#C1B4E2",
  purple300: "#957FCE",
  purple400: "#7356BF",
  purple500: "#574191",
  purple600: "#453473",
  purple700: "#2E224C",
  brown200: "#D2BBB0",
  brown300: "#B18977",
  brown400: "#99644C",
  brown500: "#744C3A",
  brown600: "#5C3C2E",
  brown700: "#3D281E"
}, lightColorTokens = {
  // Primary Palette
  primaryA: colors$3.black,
  primaryB: colors$3.white,
  primary: colors$3.black,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red400,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow400,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green500,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.white,
  mono200: colors$3.gray50,
  mono300: colors$3.gray100,
  mono400: colors$3.gray200,
  mono500: colors$3.gray300,
  mono600: colors$3.gray400,
  mono700: colors$3.gray500,
  mono800: colors$3.gray600,
  mono900: colors$3.gray700,
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray100,
  ratingStroke: colors$3.gray300
};
function hexToRgb() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "1", AA = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  CA = CA.replace(AA, function(BA, QA, EA, iA) {
    return QA + QA + EA + EA + iA + iA;
  });
  var IA = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(CA);
  return IA ? "rgba(".concat(parseInt(IA[1], 16), ", ").concat(parseInt(IA[2], 16), ", ").concat(parseInt(IA[3], 16), ", ").concat(gA, ")") : null;
}
var ellipsisText = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  wordWrap: "normal"
};
function expandBorderStyles(CA) {
  return {
    borderTopWidth: CA.borderWidth,
    borderTopStyle: CA.borderStyle,
    borderTopColor: CA.borderColor,
    borderBottomWidth: CA.borderWidth,
    borderBottomStyle: CA.borderStyle,
    borderBottomColor: CA.borderColor,
    borderLeftWidth: CA.borderWidth,
    borderLeftStyle: CA.borderStyle,
    borderLeftColor: CA.borderColor,
    borderRightWidth: CA.borderWidth,
    borderRightStyle: CA.borderStyle,
    borderRightColor: CA.borderColor
  };
}
function ownKeys$s(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$q(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$s(Object(AA), !0).forEach(function(IA) {
      _defineProperty$x(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$s(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$x(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
const getSemanticColorTokens$1 = (function() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens, gA = {
    // Background
    backgroundPrimary: CA.primaryB,
    backgroundSecondary: colors$3.gray50,
    backgroundTertiary: colors$3.gray100,
    backgroundInversePrimary: CA.primaryA,
    backgroundInverseSecondary: colors$3.gray800,
    // Content
    contentPrimary: CA.primaryA,
    contentSecondary: colors$3.gray600,
    contentTertiary: colors$3.gray500,
    contentInversePrimary: CA.primaryB,
    contentInverseSecondary: colors$3.gray300,
    contentInverseTertiary: colors$3.gray400,
    // Border
    borderOpaque: colors$3.gray200,
    borderTransparent: hexToRgb(CA.primaryA, "0.08"),
    borderSelected: CA.primaryA,
    borderInverseOpaque: colors$3.gray700,
    borderInverseTransparent: hexToRgb(CA.primaryB, "0.2"),
    borderInverseSelected: CA.primaryB
  }, AA = {
    // Backgrounds
    backgroundStateDisabled: colors$3.gray50,
    backgroundOverlayDark: hexToRgb(colors$3.black, "0.3"),
    backgroundOverlayLight: hexToRgb(colors$3.black, "0.08"),
    backgroundOverlayArt: hexToRgb(colors$3.black, "0.00"),
    backgroundAccent: CA.accent,
    backgroundNegative: CA.negative,
    backgroundWarning: CA.warning,
    backgroundPositive: colors$3.green400,
    backgroundLightAccent: colors$3.blue50,
    backgroundLightNegative: colors$3.red50,
    backgroundLightWarning: colors$3.yellow50,
    backgroundLightPositive: colors$3.green50,
    backgroundAlwaysDark: colors$3.black,
    backgroundAlwaysLight: colors$3.white,
    // Content
    contentStateDisabled: colors$3.gray400,
    contentAccent: CA.accent,
    contentOnColor: colors$3.white,
    contentOnColorInverse: colors$3.black,
    contentNegative: CA.negative,
    contentWarning: colors$3.yellow600,
    contentPositive: colors$3.green400,
    // Border
    borderStateDisabled: colors$3.gray50,
    borderAccent: colors$3.blue400,
    borderAccentLight: colors$3.blue200,
    borderNegative: colors$3.red200,
    borderWarning: colors$3.yellow200,
    borderPositive: colors$3.green200,
    // Programs
    safety: colors$3.blue400,
    eatsGreen400: colors$3.green400,
    freightBlue400: colors$3.cobalt400,
    jumpRed400: colors$3.red400,
    rewardsTier1: colors$3.blue400,
    rewardsTier2: colors$3.yellow400,
    rewardsTier3: colors$3.platinum400,
    rewardsTier4: colors$3.black,
    membership: colors$3.yellow600
  };
  return _objectSpread$q(_objectSpread$q({}, gA), AA);
});
var tagHoverBackground$1 = "rgba(0, 0, 0, 0.08)";
const getComponentColorTokens$1 = (function() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : lightColorTokens;
  return {
    bannerActionLowInfo: CA.accent100,
    bannerActionLowNegative: CA.negative100,
    bannerActionLowPositive: CA.positive100,
    bannerActionLowWarning: CA.warning200,
    bannerActionHighInfo: CA.accent500,
    bannerActionHighNegative: CA.negative500,
    bannerActionHighPositive: CA.positive500,
    bannerActionHighWarning: CA.warning200,
    // Buttons
    buttonPrimaryFill: CA.primary,
    buttonPrimaryText: CA.white,
    buttonPrimaryHover: CA.primary700,
    buttonPrimaryActive: CA.primary600,
    buttonPrimarySelectedFill: CA.primary600,
    buttonPrimarySelectedText: CA.white,
    buttonPrimarySpinnerForeground: CA.accent,
    buttonPrimarySpinnerBackground: CA.primaryB,
    buttonSecondaryFill: CA.primary100,
    buttonSecondaryText: CA.primary,
    buttonSecondaryHover: CA.primary200,
    buttonSecondaryActive: CA.primary300,
    buttonSecondarySelectedFill: CA.primary300,
    buttonSecondarySelectedText: CA.primary,
    buttonSecondarySpinnerForeground: CA.accent,
    buttonSecondarySpinnerBackground: CA.primaryB,
    buttonTertiaryFill: "transparent",
    buttonTertiaryText: CA.primary,
    buttonTertiaryHover: CA.primary50,
    buttonTertiaryActive: CA.primary100,
    buttonTertiarySelectedFill: CA.primary100,
    buttonTertiarySelectedText: CA.primary,
    buttonTertiaryDisabledActiveFill: CA.primary50,
    buttonTertiaryDisabledActiveText: CA.mono600,
    buttonTertiarySpinnerForeground: CA.accent,
    buttonTertiarySpinnerBackground: CA.primary100,
    buttonDisabledFill: CA.mono200,
    buttonDisabledText: CA.mono600,
    buttonDisabledActiveFill: CA.mono700,
    buttonDisabledActiveText: CA.mono100,
    buttonDisabledSpinnerForeground: CA.mono600,
    buttonDisabledSpinnerBackground: CA.mono400,
    // Breadcrumbs
    breadcrumbsText: CA.black,
    breadcrumbsSeparatorFill: CA.mono700,
    // Datepicker
    calendarBackground: CA.mono100,
    calendarForeground: CA.mono1000,
    calendarForegroundDisabled: CA.mono500,
    calendarHeaderBackground: CA.white,
    calendarHeaderForeground: CA.primary,
    calendarHeaderBackgroundActive: CA.primary700,
    calendarHeaderForegroundDisabled: CA.primary500,
    calendarDayForegroundPseudoSelected: CA.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: CA.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: CA.mono1000,
    calendarDayBackgroundSelected: CA.primary,
    calendarDayForegroundSelected: CA.white,
    calendarDayBackgroundSelectedHighlighted: CA.primary,
    calendarDayForegroundSelectedHighlighted: CA.white,
    // Combobox
    comboboxListItemFocus: CA.mono200,
    comboboxListItemHover: CA.mono300,
    // FileUploader
    fileUploaderBackgroundColor: CA.mono200,
    fileUploaderBackgroundColorActive: CA.primary50,
    fileUploaderBorderColorActive: CA.primary,
    fileUploaderBorderColorDefault: CA.mono500,
    fileUploaderMessageColor: CA.mono800,
    // Links
    linkText: CA.primary,
    linkVisited: CA.primary700,
    linkHover: CA.primary600,
    linkActive: CA.primary500,
    // List
    listHeaderFill: CA.white,
    listBodyFill: CA.white,
    // ProgressSteps
    progressStepsCompletedText: CA.white,
    progressStepsCompletedFill: CA.primary,
    progressStepsActiveText: CA.white,
    progressStepsActiveFill: CA.primary,
    // Toggle
    toggleFill: CA.white,
    toggleFillChecked: CA.primary,
    toggleFillDisabled: CA.mono600,
    toggleTrackFill: CA.mono400,
    toggleTrackFillDisabled: CA.mono300,
    // Tick
    tickFill: CA.mono100,
    tickFillHover: CA.mono200,
    tickFillActive: CA.mono300,
    tickFillSelected: CA.primary,
    tickFillSelectedHover: CA.primary700,
    tickFillSelectedHoverActive: CA.primary600,
    tickFillError: CA.negative50,
    tickFillErrorHover: CA.negative100,
    tickFillErrorHoverActive: CA.negative200,
    tickFillErrorSelected: CA.negative400,
    tickFillErrorSelectedHover: CA.negative500,
    tickFillErrorSelectedHoverActive: CA.negative600,
    tickFillDisabled: CA.mono600,
    tickBorder: CA.mono700,
    tickBorderError: CA.negative400,
    tickMarkFill: CA.white,
    tickMarkFillError: CA.white,
    tickMarkFillDisabled: CA.mono100,
    // Slider/Toggle
    sliderTrackFill: "transparent",
    sliderHandleFill: CA.primaryA,
    sliderHandleFillDisabled: CA.primary400,
    sliderHandleInnerFill: CA.primaryA,
    sliderTrackFillHover: CA.mono500,
    sliderTrackFillActive: CA.mono600,
    sliderTrackFillDisabled: CA.mono300,
    sliderHandleInnerFillDisabled: CA.mono400,
    sliderHandleInnerFillSelectedHover: CA.primary,
    sliderHandleInnerFillSelectedActive: CA.primary500,
    // Inputs
    inputBorder: CA.mono300,
    inputFill: CA.mono300,
    inputFillError: CA.negative50,
    inputFillDisabled: CA.mono200,
    inputFillActive: CA.mono200,
    inputFillPositive: CA.positive50,
    inputTextDisabled: CA.mono600,
    inputBorderError: CA.negative200,
    inputBorderPositive: CA.positive200,
    inputEnhancerFill: CA.mono300,
    inputEnhancerFillDisabled: CA.mono300,
    inputEnhancerTextDisabled: CA.mono600,
    inputPlaceholder: CA.mono700,
    inputPlaceholderDisabled: CA.mono600,
    // Menu
    menuFill: CA.mono100,
    menuFillHover: CA.mono200,
    menuFontDefault: CA.mono800,
    menuFontDisabled: CA.mono500,
    menuFontHighlighted: CA.mono1000,
    menuFontSelected: CA.mono1000,
    // Modal
    modalCloseColor: CA.mono1000,
    modalCloseColorHover: CA.mono800,
    modalCloseColorFocus: CA.mono800,
    // Tab
    tabBarFill: CA.mono200,
    tabColor: CA.mono800,
    // Notification
    notificationInfoBackground: CA.accent50,
    notificationInfoText: CA.primaryA,
    notificationPositiveBackground: CA.positive50,
    notificationPositiveText: CA.primaryA,
    notificationWarningBackground: CA.warning50,
    notificationWarningText: CA.primaryA,
    notificationNegativeBackground: CA.negative50,
    notificationNegativeText: CA.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: "100",
    tagSolidFontRampUnit: "0",
    tagSolidRampUnit: "400",
    tagOutlinedFontRampUnit: "400",
    tagOutlinedRampUnit: "200",
    // Deprecated
    tagSolidHoverRampUnit: "50",
    tagSolidActiveRampUnit: "100",
    tagSolidDisabledRampUnit: "50",
    tagSolidFontHoverRampUnit: "500",
    tagLightRampUnit: "50",
    tagLightHoverRampUnit: "100",
    tagLightActiveRampUnit: "100",
    tagLightFontRampUnit: "500",
    tagLightFontHoverRampUnit: "500",
    tagOutlinedHoverRampUnit: "50",
    tagOutlinedActiveRampUnit: "0",
    tagOutlinedFontHoverRampUnit: "400",
    // Neutral
    tagNeutralFontDisabled: CA.mono600,
    tagNeutralOutlinedDisabled: CA.mono400,
    tagNeutralSolidFont: CA.white,
    tagNeutralSolidBackground: CA.black,
    tagNeutralOutlinedBackground: CA.mono600,
    tagNeutralOutlinedFont: CA.black,
    // Deprecated
    tagNeutralSolidHover: CA.mono300,
    tagNeutralSolidActive: CA.mono400,
    tagNeutralSolidDisabled: CA.mono200,
    tagNeutralSolidFontHover: CA.mono900,
    tagNeutralLightBackground: CA.mono300,
    tagNeutralLightHover: CA.mono300,
    tagNeutralLightActive: CA.mono400,
    tagNeutralLightDisabled: CA.mono200,
    tagNeutralLightFont: CA.mono900,
    tagNeutralLightFontHover: CA.mono900,
    tagNeutralOutlinedActive: CA.mono900,
    tagNeutralOutlinedFontHover: CA.mono800,
    tagNeutralOutlinedHover: tagHoverBackground$1,
    // Primary
    tagPrimaryFontDisabled: CA.primary400,
    tagPrimaryOutlinedDisabled: CA.primary200,
    tagPrimarySolidFont: CA.white,
    tagPrimarySolidBackground: CA.primary,
    tagPrimaryOutlinedFontHover: CA.primary,
    tagPrimaryOutlinedFont: CA.primary,
    // Deprecated
    tagPrimarySolidHover: CA.primary100,
    tagPrimarySolidActive: CA.primary200,
    tagPrimarySolidDisabled: CA.primary50,
    tagPrimarySolidFontHover: CA.primary700,
    tagPrimaryLightBackground: CA.primary50,
    tagPrimaryLightHover: CA.primary100,
    tagPrimaryLightActive: CA.primary100,
    tagPrimaryLightDisabled: CA.primary50,
    tagPrimaryLightFont: CA.primary500,
    tagPrimaryLightFontHover: CA.primary500,
    tagPrimaryOutlinedActive: CA.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground$1,
    tagPrimaryOutlinedBackground: CA.primary400,
    // Accent
    tagAccentFontDisabled: CA.accent200,
    tagAccentOutlinedDisabled: CA.accent200,
    tagAccentSolidFont: CA.white,
    tagAccentSolidBackground: CA.accent400,
    tagAccentOutlinedBackground: CA.accent200,
    tagAccentOutlinedFont: CA.accent400,
    // Deprecated
    tagAccentSolidHover: CA.accent50,
    tagAccentSolidActive: CA.accent100,
    tagAccentSolidDisabled: CA.accent50,
    tagAccentSolidFontHover: CA.accent500,
    tagAccentLightBackground: CA.accent50,
    tagAccentLightHover: CA.accent100,
    tagAccentLightActive: CA.accent100,
    tagAccentLightDisabled: CA.accent50,
    tagAccentLightFont: CA.accent500,
    tagAccentLightFontHover: CA.accent500,
    tagAccentOutlinedActive: CA.accent600,
    tagAccentOutlinedFontHover: CA.accent400,
    tagAccentOutlinedHover: tagHoverBackground$1,
    // Positive
    tagPositiveFontDisabled: CA.positive200,
    tagPositiveOutlinedDisabled: CA.positive200,
    tagPositiveSolidFont: CA.white,
    tagPositiveSolidBackground: CA.positive400,
    tagPositiveOutlinedBackground: CA.positive200,
    tagPositiveOutlinedFont: CA.positive400,
    // Deprecated
    tagPositiveSolidHover: CA.positive50,
    tagPositiveSolidActive: CA.positive100,
    tagPositiveSolidDisabled: CA.positive50,
    tagPositiveSolidFontHover: CA.positive500,
    tagPositiveLightBackground: CA.positive50,
    tagPositiveLightHover: CA.positive100,
    tagPositiveLightActive: CA.positive100,
    tagPositiveLightDisabled: CA.positive50,
    tagPositiveLightFont: CA.positive500,
    tagPositiveLightFontHover: CA.positive500,
    tagPositiveOutlinedActive: CA.positive600,
    tagPositiveOutlinedFontHover: CA.positive400,
    tagPositiveOutlinedHover: tagHoverBackground$1,
    // Warning
    tagWarningFontDisabled: CA.warning300,
    tagWarningOutlinedDisabled: CA.warning300,
    tagWarningSolidFont: CA.warning700,
    tagWarningSolidBackground: CA.warning400,
    tagWarningOutlinedBackground: CA.warning300,
    tagWarningOutlinedFont: CA.warning600,
    // Deprecated
    tagWarningSolidHover: CA.warning50,
    tagWarningSolidActive: CA.warning100,
    tagWarningSolidDisabled: CA.warning50,
    tagWarningSolidFontHover: CA.warning500,
    tagWarningLightBackground: CA.warning50,
    tagWarningLightHover: CA.warning100,
    tagWarningLightActive: CA.warning100,
    tagWarningLightDisabled: CA.warning50,
    tagWarningLightFont: CA.warning500,
    tagWarningLightFontHover: CA.warning500,
    tagWarningOutlinedActive: CA.warning600,
    tagWarningOutlinedFontHover: CA.warning600,
    tagWarningOutlinedHover: tagHoverBackground$1,
    // Negative
    tagNegativeFontDisabled: CA.negative200,
    tagNegativeOutlinedDisabled: CA.negative200,
    tagNegativeSolidFont: CA.white,
    tagNegativeSolidBackground: CA.negative400,
    tagNegativeOutlinedBackground: CA.negative200,
    tagNegativeOutlinedFont: CA.negative400,
    // Deprecated
    tagNegativeSolidHover: CA.negative50,
    tagNegativeSolidActive: CA.negative100,
    tagNegativeSolidDisabled: CA.negative50,
    tagNegativeSolidFontHover: CA.negative500,
    tagNegativeLightBackground: CA.negative50,
    tagNegativeLightHover: CA.negative100,
    tagNegativeLightActive: CA.negative100,
    tagNegativeLightDisabled: CA.negative50,
    tagNegativeLightFont: CA.negative500,
    tagNegativeLightFontHover: CA.negative500,
    tagNegativeOutlinedActive: CA.negative600,
    tagNegativeOutlinedFontHover: CA.negative400,
    tagNegativeOutlinedHover: tagHoverBackground$1,
    // Table
    tableHeadBackgroundColor: CA.mono100,
    tableBackground: CA.mono100,
    tableStripedBackground: CA.mono200,
    tableFilter: CA.mono600,
    tableFilterHeading: CA.mono700,
    tableFilterBackground: CA.mono100,
    tableFilterFooterBackground: CA.mono200,
    // Toast
    toastText: CA.white,
    toastPrimaryText: CA.white,
    toastInfoBackground: CA.accent400,
    toastInfoText: CA.white,
    toastPositiveBackground: CA.positive400,
    toastPositiveText: CA.white,
    toastWarningBackground: CA.warning400,
    toastWarningText: CA.black,
    toastNegativeBackground: CA.negative400,
    toastNegativeText: CA.white,
    // Spinner
    spinnerTrackFill: CA.mono900,
    // Progress bar
    progressbarTrackFill: CA.mono900,
    // Tooltip
    tooltipBackground: CA.mono900,
    tooltipText: CA.mono100
  };
});
var borders$1 = {
  border100: {
    borderColor: "hsla(0, 0%, 0%, 0.04)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border200: {
    borderColor: "hsla(0, 0%, 0%, 0.08)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border300: {
    borderColor: "hsla(0, 0%, 0%, 0.12)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border400: {
    borderColor: "hsla(0, 0%, 0%, 0.16)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border500: {
    borderColor: "hsla(0, 0%, 0%, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  border600: {
    borderColor: "hsla(0, 0%, 0%, 0.24)",
    borderStyle: "solid",
    borderWidth: "1px"
  },
  radius100: "2px",
  radius200: "4px",
  radius300: "8px",
  radius400: "12px",
  radius500: "16px",
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: !0,
  /** Button, ButtonGroup */
  buttonBorderRadiusMini: "4px",
  buttonBorderRadius: "8px",
  /** Checkbox */
  checkboxBorderRadius: "0px",
  /** Input, Select, Textarea */
  inputBorderRadiusMini: "4px",
  inputBorderRadius: "8px",
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: "8px",
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: "0px",
  /** Tag */
  tagBorderRadius: "24px"
}, lighting = {
  shadow400: "0 1px 4px hsla(0, 0%, 0%, 0.16)",
  shadow500: "0 2px 8px hsla(0, 0%, 0%, 0.16)",
  shadow600: "0 4px 16px hsla(0, 0%, 0%, 0.16)",
  shadow700: "0 8px 24px hsla(0, 0%, 0%, 0.16)",
  overlay0: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0)",
  overlay100: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)",
  overlay200: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)",
  overlay300: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)",
  overlay400: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)",
  overlay500: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)",
  overlay600: "inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)",
  shallowAbove: "0px -4px 16px rgba(0, 0, 0, 0.12)",
  shallowBelow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
  deepAbove: "0px -16px 48px rgba(0, 0, 0, 0.22)",
  deepBelow: "0px 16px 48px rgba(0, 0, 0, 0.22)"
};
function ownKeys$r(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$p(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$r(Object(AA), !0).forEach(function(IA) {
      _defineProperty$w(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$r(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$w(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
}, monoFontFamily$1 = '"Lucida Console", Monaco, monospace';
const getTypography = (function() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultFontTokens, gA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "12px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, AA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px"
  }, IA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
  }, BA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16px"
  }, QA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "24px"
  }, EA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px"
  }, iA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "18px",
    fontWeight: "normal",
    lineHeight: "28px"
  }, oA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "24px"
  }, cA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "28px"
  }, tA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px"
  }, eA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "36px"
  }, aA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "32px",
    fontWeight: 700,
    lineHeight: "40px"
  }, GA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, lA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "40px",
    fontWeight: 700,
    lineHeight: "52px"
  }, nA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "44px"
  }, DA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "44px",
    fontWeight: 700,
    lineHeight: "52px"
  }, hA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "52px",
    fontWeight: 700,
    lineHeight: "64px"
  }, wA = {
    fontFamily: CA.primaryFontFamily,
    fontSize: "96px",
    fontWeight: 700,
    lineHeight: "112px"
  };
  return {
    font100: gA,
    font150: AA,
    font200: IA,
    font250: BA,
    font300: QA,
    font350: EA,
    font400: iA,
    font450: oA,
    font550: cA,
    font650: tA,
    font750: eA,
    font850: aA,
    font950: GA,
    font1050: lA,
    font1150: nA,
    font1250: DA,
    font1350: hA,
    font1450: wA,
    ParagraphXSmall: gA,
    ParagraphSmall: IA,
    ParagraphMedium: QA,
    ParagraphLarge: iA,
    LabelXSmall: AA,
    LabelSmall: BA,
    LabelMedium: EA,
    LabelLarge: oA,
    HeadingXSmall: cA,
    HeadingSmall: tA,
    HeadingMedium: eA,
    HeadingLarge: aA,
    HeadingXLarge: GA,
    HeadingXXLarge: lA,
    DisplayXSmall: nA,
    DisplaySmall: DA,
    DisplayMedium: hA,
    DisplayLarge: wA,
    MonoParagraphXSmall: _objectSpread$p(_objectSpread$p({}, gA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoParagraphSmall: _objectSpread$p(_objectSpread$p({}, IA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoParagraphMedium: _objectSpread$p(_objectSpread$p({}, QA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoParagraphLarge: _objectSpread$p(_objectSpread$p({}, iA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoLabelXSmall: _objectSpread$p(_objectSpread$p({}, AA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoLabelSmall: _objectSpread$p(_objectSpread$p({}, BA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoLabelMedium: _objectSpread$p(_objectSpread$p({}, EA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoLabelLarge: _objectSpread$p(_objectSpread$p({}, oA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingXSmall: _objectSpread$p(_objectSpread$p({}, cA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingSmall: _objectSpread$p(_objectSpread$p({}, tA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingMedium: _objectSpread$p(_objectSpread$p({}, eA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingLarge: _objectSpread$p(_objectSpread$p({}, aA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingXLarge: _objectSpread$p(_objectSpread$p({}, GA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoHeadingXXLarge: _objectSpread$p(_objectSpread$p({}, lA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoDisplayXSmall: _objectSpread$p(_objectSpread$p({}, nA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoDisplaySmall: _objectSpread$p(_objectSpread$p({}, DA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoDisplayMedium: _objectSpread$p(_objectSpread$p({}, hA), {}, {
      fontFamily: monoFontFamily$1
    }),
    MonoDisplayLarge: _objectSpread$p(_objectSpread$p({}, wA), {}, {
      fontFamily: monoFontFamily$1
    })
  };
});
var animation = {
  timing100: "100ms",
  timing200: "200ms",
  timing300: "300ms",
  timing400: "400ms",
  timing500: "500ms",
  timing600: "600ms",
  timing700: "700ms",
  timing800: "800ms",
  timing900: "900ms",
  timing1000: "1000ms",
  easeInCurve: "cubic-bezier(.8, .2, .6, 1)",
  easeOutCurve: "cubic-bezier(.2, .8, .4, 1)",
  easeInOutCurve: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeInQuinticCurve: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  easeOutQuinticCurve: "cubic-bezier(0.23, 1, 0.32, 1)",
  easeInOutQuinticCurve: "cubic-bezier(0.86, 0, 0.07, 1)",
  linearCurve: "cubic-bezier(0, 0, 1, 1)"
}, breakpoints$1 = {
  small: 320,
  medium: 600,
  large: 1136
}, grid$1 = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: "px",
  maxWidth: 1280
}, getMediaQuery = function CA(gA) {
  return "@media screen and (min-width: ".concat(gA, "px)");
}, mediaQuery = {
  small: getMediaQuery(breakpoints$1.small),
  medium: getMediaQuery(breakpoints$1.medium),
  large: getMediaQuery(breakpoints$1.large)
}, sizing$1 = {
  scale0: "2px",
  scale100: "4px",
  scale200: "6px",
  scale300: "8px",
  scale400: "10px",
  scale500: "12px",
  scale550: "14px",
  scale600: "16px",
  scale650: "18px",
  scale700: "20px",
  scale750: "22px",
  scale800: "24px",
  scale850: "28px",
  scale900: "32px",
  scale950: "36px",
  scale1000: "40px",
  scale1200: "48px",
  scale1400: "56px",
  scale1600: "64px",
  scale2400: "96px",
  scale3200: "128px",
  scale4800: "192px"
};
function ownKeys$q(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$o(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$q(Object(AA), !0).forEach(function(IA) {
      _defineProperty$v(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$q(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$v(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var LightTheme = {
  name: "light-theme",
  colors: _objectSpread$o(_objectSpread$o(_objectSpread$o({}, lightColorTokens), getComponentColorTokens$1()), getSemanticColorTokens$1()),
  animation,
  breakpoints: breakpoints$1,
  borders: borders$1,
  direction: "auto",
  grid: grid$1,
  lighting,
  mediaQuery,
  sizing: sizing$1,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2e3
  }
};
function _typeof$f(CA) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$f(CA);
}
function deepMerge$2(CA) {
  CA = CA || {};
  for (var gA = arguments.length <= 1 ? 0 : arguments.length - 1, AA, IA, BA = 0; BA < gA; BA++) {
    AA = (BA + 1 < 1 || arguments.length <= BA + 1 ? void 0 : arguments[BA + 1]) || {};
    for (var QA in AA)
      _typeof$f(AA[QA]) !== void 0 && (IA = AA[QA], isCloneable(IA) ? CA[QA] = deepMerge$2(
        /* eslint-disable-next-line no-mixed-operators */
        CA[QA] || Array.isArray(IA) && [] || {},
        IA
      ) : CA[QA] = IA);
  }
  return CA;
}
function isCloneable(CA) {
  return Array.isArray(CA) || {}.toString.call(CA) == "[object Object]";
}
var fontTokens = {
  primaryFontFamily: 'UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
}, secondaryFontFamily = 'UberMove, UberMoveText, system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif', monoFontFamily = 'UberMoveMono, "Lucida Console", Monaco, monospace', typography = {
  font1450: {
    fontFamily: secondaryFontFamily
  },
  font1350: {
    fontFamily: secondaryFontFamily
  },
  font1250: {
    fontFamily: secondaryFontFamily
  },
  font1150: {
    fontFamily: secondaryFontFamily
  },
  font1050: {
    fontFamily: secondaryFontFamily
  },
  font950: {
    fontFamily: secondaryFontFamily
  },
  font850: {
    fontFamily: secondaryFontFamily
  },
  font750: {
    fontFamily: secondaryFontFamily
  },
  font650: {
    fontFamily: secondaryFontFamily
  },
  font550: {
    fontFamily: secondaryFontFamily
  },
  DisplayLarge: {
    fontFamily: secondaryFontFamily
  },
  DisplayMedium: {
    fontFamily: secondaryFontFamily
  },
  DisplaySmall: {
    fontFamily: secondaryFontFamily
  },
  DisplayXSmall: {
    fontFamily: secondaryFontFamily
  },
  HeadingXXLarge: {
    fontFamily: secondaryFontFamily
  },
  HeadingXLarge: {
    fontFamily: secondaryFontFamily
  },
  HeadingLarge: {
    fontFamily: secondaryFontFamily
  },
  HeadingMedium: {
    fontFamily: secondaryFontFamily
  },
  HeadingSmall: {
    fontFamily: secondaryFontFamily
  },
  HeadingXSmall: {
    fontFamily: secondaryFontFamily
  },
  MonoParagraphXSmall: {
    fontFamily: monoFontFamily
  },
  MonoParagraphSmall: {
    fontFamily: monoFontFamily
  },
  MonoParagraphMedium: {
    fontFamily: monoFontFamily
  },
  MonoParagraphLarge: {
    fontFamily: monoFontFamily
  },
  MonoLabelXSmall: {
    fontFamily: monoFontFamily
  },
  MonoLabelSmall: {
    fontFamily: monoFontFamily
  },
  MonoLabelMedium: {
    fontFamily: monoFontFamily
  },
  MonoLabelLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXSmall: {
    fontFamily: monoFontFamily
  },
  MonoHeadingSmall: {
    fontFamily: monoFontFamily
  },
  MonoHeadingMedium: {
    fontFamily: monoFontFamily
  },
  MonoHeadingLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXLarge: {
    fontFamily: monoFontFamily
  },
  MonoHeadingXXLarge: {
    fontFamily: monoFontFamily
  },
  MonoDisplayXSmall: {
    fontFamily: monoFontFamily
  },
  MonoDisplaySmall: {
    fontFamily: monoFontFamily
  },
  MonoDisplayMedium: {
    fontFamily: monoFontFamily
  },
  MonoDisplayLarge: {
    fontFamily: monoFontFamily
  }
}, LightThemeMove = deepMerge$2({}, LightTheme, {
  name: "light-theme-with-move",
  // For the move theme we need to override typography values
  // in the default lightTheme with a font values that reference
  // our custom font family. In addition to it we want to replace some
  // of the fonts with an additional secondary font that specified
  // in `moveTypography`. For it we'll get the typography value built
  // with a custom font using `getTypography` helper and extend the result
  // value with the customized set of fonts that reference a secondary font
  typography: deepMerge$2(getTypography(fontTokens), typography)
}), darkColorTokens = {
  // Primary Palette
  primaryA: colors$3.gray200,
  primaryB: colors$3.gray900,
  primary: colors$3.white,
  primary50: colors$3.gray50,
  primary100: colors$3.gray100,
  primary200: colors$3.gray200,
  primary300: colors$3.gray300,
  primary400: colors$3.gray400,
  primary500: colors$3.gray500,
  primary600: colors$3.gray600,
  primary700: colors$3.gray700,
  // Accent Palette
  accent: colors$3.blue400,
  accent50: colors$3.blue50,
  accent100: colors$3.blue100,
  accent200: colors$3.blue200,
  accent300: colors$3.blue300,
  accent400: colors$3.blue400,
  accent500: colors$3.blue500,
  accent600: colors$3.blue600,
  accent700: colors$3.blue700,
  // Negative Palette
  negative: colors$3.red500,
  negative50: colors$3.red50,
  negative100: colors$3.red100,
  negative200: colors$3.red200,
  negative300: colors$3.red300,
  negative400: colors$3.red400,
  negative500: colors$3.red500,
  negative600: colors$3.red600,
  negative700: colors$3.red700,
  // Warning Palette
  warning: colors$3.yellow500,
  warning50: colors$3.yellow50,
  warning100: colors$3.yellow100,
  warning200: colors$3.yellow200,
  warning300: colors$3.yellow300,
  warning400: colors$3.yellow400,
  warning500: colors$3.yellow500,
  warning600: colors$3.yellow600,
  warning700: colors$3.yellow700,
  // Positive Palette
  positive: colors$3.green400,
  positive50: colors$3.green50,
  positive100: colors$3.green100,
  positive200: colors$3.green200,
  positive300: colors$3.green300,
  positive400: colors$3.green400,
  positive500: colors$3.green500,
  positive600: colors$3.green600,
  positive700: colors$3.green700,
  // Monochrome Palette
  white: colors$3.white,
  black: colors$3.black,
  mono100: colors$3.gray300,
  mono200: colors$3.gray400,
  mono300: colors$3.gray500,
  mono400: colors$3.gray600,
  mono500: colors$3.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: "#292929",
  mono700: "#1F1F1F",
  mono800: "#141414",
  mono900: "#111111",
  mono1000: colors$3.black,
  // Rating Palette,
  ratingInactiveFill: colors$3.gray500,
  ratingStroke: colors$3.gray700
};
function ownKeys$p(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$n(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$p(Object(AA), !0).forEach(function(IA) {
      _defineProperty$u(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$p(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$u(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
const getSemanticColorTokens = (function() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : darkColorTokens, gA = {
    // Background
    backgroundPrimary: CA.primaryB,
    backgroundSecondary: colors$3.gray800,
    backgroundTertiary: colors$3.gray700,
    backgroundInversePrimary: CA.primaryA,
    backgroundInverseSecondary: colors$3.gray300,
    // Content
    contentPrimary: colors$3.white,
    contentSecondary: colors$3.gray300,
    contentTertiary: colors$3.gray400,
    contentInversePrimary: colors$3.black,
    contentInverseSecondary: colors$3.gray700,
    contentInverseTertiary: colors$3.gray600,
    // Border
    borderOpaque: colors$3.gray700,
    borderTransparent: hexToRgb(CA.primaryA, "0.08"),
    borderSelected: CA.primaryA,
    borderInverseOpaque: colors$3.gray400,
    borderInverseTransparent: hexToRgb(CA.primaryB, "0.2"),
    borderInverseSelected: CA.primaryB
  }, AA = {
    // Backgrounds
    backgroundStateDisabled: colors$3.gray800,
    backgroundOverlayDark: hexToRgb(colors$3.black, "0.3"),
    backgroundOverlayLight: hexToRgb(colors$3.black, "0.08"),
    backgroundOverlayArt: hexToRgb(colors$3.black, "0.16"),
    backgroundAccent: CA.accent,
    backgroundNegative: CA.negative,
    backgroundWarning: CA.warning,
    backgroundPositive: colors$3.green500,
    backgroundLightAccent: colors$3.blue700,
    backgroundLightPositive: colors$3.green700,
    backgroundLightNegative: colors$3.red700,
    backgroundLightWarning: colors$3.yellow700,
    backgroundAlwaysDark: colors$3.gray900,
    backgroundAlwaysLight: colors$3.gray100,
    // Content
    contentStateDisabled: colors$3.gray600,
    contentAccent: colors$3.blue300,
    contentOnColor: colors$3.white,
    contentOnColorInverse: colors$3.black,
    contentNegative: colors$3.red300,
    contentWarning: colors$3.yellow300,
    contentPositive: colors$3.green300,
    // Border
    borderStateDisabled: colors$3.gray800,
    borderAccent: colors$3.blue400,
    borderAccentLight: colors$3.blue500,
    borderNegative: colors$3.red500,
    borderWarning: colors$3.yellow500,
    borderPositive: colors$3.green500,
    // Programs
    safety: colors$3.blue400,
    eatsGreen400: colors$3.green400,
    freightBlue400: colors$3.cobalt400,
    jumpRed400: colors$3.red400,
    rewardsTier1: colors$3.blue400,
    rewardsTier2: colors$3.yellow400,
    rewardsTier3: colors$3.platinum400,
    rewardsTier4: colors$3.gray200,
    membership: colors$3.yellow600
  };
  return _objectSpread$n(_objectSpread$n({}, gA), AA);
});
var tagHoverBackground = "rgba(255, 255, 255, 0.2)";
const getComponentColorTokens = (function() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : darkColorTokens;
  return {
    bannerActionLowInfo: CA.accent600,
    bannerActionLowNegative: CA.negative600,
    bannerActionLowPositive: CA.positive600,
    bannerActionLowWarning: CA.warning600,
    bannerActionHighInfo: CA.accent500,
    bannerActionHighNegative: CA.negative600,
    bannerActionHighPositive: CA.positive600,
    bannerActionHighWarning: CA.warning600,
    // Buttons
    buttonPrimaryFill: CA.primaryA,
    buttonPrimaryText: CA.black,
    buttonPrimaryHover: CA.primary100,
    buttonPrimaryActive: CA.primary200,
    buttonPrimarySelectedText: CA.black,
    buttonPrimarySelectedFill: CA.primary200,
    buttonPrimarySpinnerForeground: CA.primary700,
    buttonPrimarySpinnerBackground: CA.primary300,
    buttonSecondaryFill: CA.primary700,
    buttonSecondaryText: CA.primary,
    buttonSecondaryHover: CA.primary600,
    buttonSecondaryActive: CA.primary500,
    buttonSecondarySelectedText: CA.primary,
    buttonSecondarySelectedFill: CA.primary500,
    buttonSecondarySpinnerForeground: CA.white,
    buttonSecondarySpinnerBackground: CA.primary400,
    buttonTertiaryFill: "transparent",
    buttonTertiaryText: CA.primary,
    buttonTertiaryHover: CA.primary700,
    buttonTertiaryActive: CA.primary600,
    buttonTertiarySelectedText: CA.primary,
    buttonTertiarySelectedFill: CA.primary600,
    buttonTertiaryDisabledActiveFill: CA.primary700,
    buttonTertiaryDisabledActiveText: CA.mono300,
    buttonTertiarySpinnerForeground: CA.primary50,
    buttonTertiarySpinnerBackground: CA.primary500,
    buttonDisabledFill: CA.mono600,
    buttonDisabledText: CA.mono300,
    buttonDisabledActiveFill: CA.mono200,
    buttonDisabledActiveText: CA.primary500,
    buttonDisabledSpinnerForeground: CA.mono200,
    buttonDisabledSpinnerBackground: CA.mono400,
    // Breadcrumbs
    breadcrumbsText: CA.white,
    breadcrumbsSeparatorFill: CA.mono200,
    // Datepicker
    calendarBackground: CA.mono800,
    calendarForeground: CA.white,
    calendarForegroundDisabled: CA.mono300,
    calendarHeaderBackground: CA.primary700,
    calendarHeaderForeground: CA.primary,
    calendarHeaderBackgroundActive: CA.primary600,
    calendarHeaderForegroundDisabled: CA.primary500,
    calendarDayForegroundPseudoSelected: CA.primary,
    calendarDayBackgroundPseudoSelectedHighlighted: CA.primary600,
    calendarDayForegroundPseudoSelectedHighlighted: CA.primary,
    calendarDayBackgroundSelected: CA.primary,
    calendarDayForegroundSelected: CA.black,
    calendarDayBackgroundSelectedHighlighted: CA.primary100,
    calendarDayForegroundSelectedHighlighted: CA.black,
    // Combobox
    comboboxListItemFocus: CA.mono600,
    comboboxListItemHover: CA.mono500,
    // FileUploader
    fileUploaderBackgroundColor: CA.mono700,
    fileUploaderBackgroundColorActive: CA.mono600,
    fileUploaderBorderColorActive: CA.primary,
    fileUploaderBorderColorDefault: CA.mono500,
    fileUploaderMessageColor: CA.mono100,
    // Links
    linkText: CA.primary,
    linkVisited: CA.primary100,
    linkHover: CA.primary200,
    linkActive: CA.primary300,
    // List
    listHeaderFill: CA.mono600,
    listBodyFill: CA.mono800,
    // ProgressSteps
    progressStepsCompletedText: CA.black,
    progressStepsCompletedFill: CA.primary,
    progressStepsActiveText: CA.black,
    progressStepsActiveFill: CA.primary,
    // Modal
    modalCloseColor: CA.mono300,
    modalCloseColorHover: CA.mono400,
    modalCloseColorFocus: CA.mono400,
    // Notification
    notificationInfoBackground: CA.accent700,
    notificationInfoText: CA.primaryA,
    notificationPositiveBackground: CA.positive700,
    notificationPositiveText: CA.primaryA,
    notificationWarningBackground: CA.warning700,
    notificationWarningText: CA.primaryA,
    notificationNegativeBackground: CA.negative700,
    notificationNegativeText: CA.primaryA,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: "600",
    tagSolidFontRampUnit: "0",
    tagSolidRampUnit: "500",
    tagOutlinedFontRampUnit: "500",
    tagOutlinedRampUnit: "500",
    // Deprecated
    tagSolidHoverRampUnit: "500",
    tagSolidActiveRampUnit: "400",
    tagSolidDisabledRampUnit: "700",
    tagSolidFontHoverRampUnit: "100",
    tagLightRampUnit: "700",
    tagLightHoverRampUnit: "700",
    tagLightActiveRampUnit: "600",
    tagLightFontRampUnit: "100",
    tagLightFontHoverRampUnit: "100",
    tagOutlinedActiveRampUnit: "300",
    tagOutlinedHoverRampUnit: "800",
    tagOutlinedFontHoverRampUnit: "100",
    // Neutral
    tagNeutralOutlinedFont: CA.mono100,
    tagNeutralOutlinedBackground: CA.mono200,
    tagNeutralSolidFont: CA.black,
    // not much we can do to get the correct gray here
    tagNeutralSolidBackground: CA.primary200,
    tagNeutralFontDisabled: CA.mono400,
    tagNeutralOutlinedDisabled: CA.mono500,
    // Deprecated
    tagNeutralSolidHover: CA.mono600,
    tagNeutralSolidActive: CA.mono500,
    tagNeutralSolidDisabled: CA.mono700,
    tagNeutralSolidFontHover: CA.mono200,
    tagNeutralLightBackground: CA.mono800,
    tagNeutralLightHover: CA.mono800,
    tagNeutralLightActive: CA.mono700,
    tagNeutralLightDisabled: CA.mono700,
    tagNeutralLightFont: CA.mono200,
    tagNeutralLightFontHover: CA.mono200,
    tagNeutralOutlinedActive: CA.mono400,
    tagNeutralOutlinedFontHover: CA.mono100,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryOutlinedFont: CA.primary200,
    tagPrimaryOutlinedBackground: CA.primary400,
    tagPrimarySolidFont: CA.black,
    tagPrimarySolidBackground: CA.primary200,
    tagPrimaryFontDisabled: CA.primary600,
    tagPrimaryOutlinedDisabled: CA.primary700,
    // Deprecated
    tagPrimarySolidHover: CA.primary700,
    tagPrimarySolidActive: CA.primary400,
    tagPrimarySolidDisabled: CA.primary700,
    tagPrimarySolidFontHover: CA.primary100,
    tagPrimaryLightBackground: CA.primary700,
    tagPrimaryLightHover: CA.primary700,
    tagPrimaryLightActive: CA.primary600,
    tagPrimaryLightDisabled: CA.primary700,
    tagPrimaryLightFont: CA.primary100,
    tagPrimaryLightFontHover: CA.primary100,
    tagPrimaryOutlinedActive: CA.primary600,
    tagPrimaryOutlinedFontHover: CA.primary200,
    tagPrimaryOutlinedHover: tagHoverBackground,
    // Accent
    tagAccentOutlinedFont: CA.accent200,
    tagAccentOutlinedBackground: CA.accent500,
    tagAccentSolidFont: CA.white,
    tagAccentSolidBackground: CA.accent500,
    tagAccentFontDisabled: CA.accent600,
    tagAccentOutlinedDisabled: CA.accent700,
    // Deprecated
    tagAccentSolidHover: CA.accent500,
    tagAccentSolidActive: CA.accent400,
    tagAccentSolidDisabled: CA.accent700,
    tagAccentSolidFontHover: CA.accent100,
    tagAccentLightBackground: CA.accent700,
    tagAccentLightHover: CA.accent700,
    tagAccentLightActive: CA.accent600,
    tagAccentLightDisabled: CA.accent700,
    tagAccentLightFont: CA.accent100,
    tagAccentLightFontHover: CA.accent100,
    tagAccentOutlinedActive: CA.accent300,
    tagAccentOutlinedFontHover: CA.accent200,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveOutlinedFont: CA.positive300,
    tagPositiveOutlinedBackground: CA.positive500,
    tagPositiveSolidFont: CA.white,
    tagPositiveSolidBackground: CA.positive500,
    tagPositiveFontDisabled: CA.positive600,
    tagPositiveOutlinedDisabled: CA.positive700,
    // Deprecated
    tagPositiveSolidHover: CA.positive500,
    tagPositiveSolidActive: CA.positive400,
    tagPositiveSolidDisabled: CA.positive700,
    tagPositiveSolidFontHover: CA.positive100,
    tagPositiveLightBackground: CA.positive700,
    tagPositiveLightHover: CA.positive700,
    tagPositiveLightActive: CA.positive600,
    tagPositiveLightDisabled: CA.positive700,
    tagPositiveLightFont: CA.positive100,
    tagPositiveLightFontHover: CA.positive100,
    tagPositiveOutlinedActive: CA.positive300,
    tagPositiveOutlinedFontHover: CA.positive300,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningOutlinedFont: CA.warning300,
    tagWarningOutlinedBackground: CA.warning500,
    tagWarningSolidFont: CA.black,
    tagWarningSolidBackground: CA.warning500,
    tagWarningFontDisabled: CA.warning600,
    tagWarningOutlinedDisabled: CA.warning700,
    // Deprecated
    tagWarningSolidHover: CA.warning500,
    tagWarningSolidActive: CA.warning400,
    tagWarningSolidDisabled: CA.warning700,
    tagWarningSolidFontHover: CA.warning100,
    tagWarningLightBackground: CA.warning700,
    tagWarningLightHover: CA.warning700,
    tagWarningLightActive: CA.warning600,
    tagWarningLightDisabled: CA.warning700,
    tagWarningLightFont: CA.warning100,
    tagWarningLightFontHover: CA.warning100,
    tagWarningOutlinedActive: CA.warning300,
    tagWarningOutlinedFontHover: CA.warning300,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeOutlinedFont: CA.negative300,
    tagNegativeOutlinedBackground: CA.negative500,
    tagNegativeSolidFont: CA.white,
    tagNegativeSolidBackground: CA.negative500,
    tagNegativeFontDisabled: CA.negative600,
    tagNegativeOutlinedDisabled: CA.negative700,
    // Deprecated
    tagNegativeSolidHover: CA.negative500,
    tagNegativeSolidActive: CA.negative400,
    tagNegativeSolidDisabled: CA.negative700,
    tagNegativeSolidFontHover: CA.negative100,
    tagNegativeLightBackground: CA.negative700,
    tagNegativeLightHover: CA.negative700,
    tagNegativeLightActive: CA.negative600,
    tagNegativeLightDisabled: CA.negative700,
    tagNegativeLightFont: CA.negative100,
    tagNegativeLightFontHover: CA.negative100,
    tagNegativeOutlinedActive: CA.negative300,
    tagNegativeOutlinedFontHover: CA.negative300,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: CA.mono700,
    tableBackground: CA.mono800,
    tableStripedBackground: CA.mono700,
    tableFilter: CA.mono400,
    tableFilterHeading: CA.mono300,
    tableFilterBackground: CA.mono700,
    tableFilterFooterBackground: CA.mono800,
    // Toast
    toastText: CA.white,
    toastPrimaryText: CA.white,
    toastInfoBackground: CA.accent400,
    toastInfoText: CA.white,
    toastPositiveBackground: CA.positive400,
    toastPositiveText: CA.white,
    toastWarningBackground: CA.warning400,
    toastWarningText: CA.black,
    toastNegativeBackground: CA.negative400,
    toastNegativeText: CA.white,
    // Toggle
    toggleFill: CA.mono300,
    toggleFillChecked: CA.primary,
    toggleFillDisabled: CA.mono600,
    toggleTrackFill: CA.mono400,
    toggleTrackFillDisabled: CA.mono700,
    // Tick
    tickFill: CA.mono1000,
    tickFillHover: CA.mono700,
    tickFillActive: CA.mono600,
    tickFillSelected: CA.primary,
    tickFillSelectedHover: CA.primary50,
    tickFillSelectedHoverActive: CA.primary100,
    tickFillError: CA.negative700,
    tickFillErrorHover: CA.negative600,
    tickFillErrorHoverActive: CA.negative500,
    tickFillErrorSelected: CA.negative500,
    tickFillErrorSelectedHover: CA.negative600,
    tickFillErrorSelectedHoverActive: CA.negative700,
    tickFillDisabled: CA.mono500,
    tickBorder: CA.mono300,
    tickBorderError: CA.negative400,
    tickMarkFill: CA.black,
    tickMarkFillError: CA.white,
    tickMarkFillDisabled: CA.mono800,
    // Slider/Toggle
    sliderTrackFill: "transparent",
    sliderHandleFill: CA.primaryA,
    sliderHandleFillDisabled: CA.primary500,
    sliderHandleInnerFill: CA.primaryA,
    sliderTrackFillHover: CA.mono500,
    sliderTrackFillActive: CA.mono400,
    sliderTrackFillDisabled: CA.mono700,
    sliderHandleInnerFillDisabled: CA.mono500,
    sliderHandleInnerFillSelectedHover: CA.primary600,
    sliderHandleInnerFillSelectedActive: CA.primary700,
    // Input
    inputBorder: CA.mono600,
    inputFill: CA.mono600,
    inputFillActive: CA.mono500,
    inputFillError: CA.negative700,
    inputFillDisabled: CA.mono800,
    inputFillPositive: CA.positive700,
    inputTextDisabled: CA.mono500,
    inputBorderError: CA.negative400,
    inputBorderPositive: CA.positive400,
    inputEnhancerFill: CA.mono500,
    inputEnhancerFillDisabled: CA.mono700,
    inputEnhancerTextDisabled: CA.mono500,
    inputPlaceholder: CA.mono300,
    inputPlaceholderDisabled: CA.mono500,
    // Menu
    menuFill: CA.mono600,
    menuFillHover: CA.mono700,
    menuFontDefault: CA.mono300,
    menuFontDisabled: CA.mono400,
    menuFontHighlighted: CA.white,
    menuFontSelected: CA.white,
    // Tab
    tabBarFill: CA.mono1000,
    tabColor: CA.mono300,
    // Spinner
    spinnerTrackFill: CA.mono100,
    // Progress bar
    progressbarTrackFill: CA.mono100,
    // Tooltip
    tooltipBackground: CA.mono200,
    tooltipText: CA.mono1000
  };
});
var borders = deepMerge$2({}, borders$1, {
  border100: {
    borderColor: "hsla(0, 0%, 100%, 0.04)"
  },
  border200: {
    borderColor: "hsla(0, 0%, 100%, 0.08)"
  },
  border300: {
    borderColor: "hsla(0, 0%, 100%, 0.12)"
  },
  border400: {
    borderColor: "hsla(0, 0%, 100%, 0.16)"
  },
  border500: {
    borderColor: "hsla(0, 0%, 100%, 0.2)"
  },
  border600: {
    borderColor: "hsla(0, 0%, 100%, 0.24)"
  }
});
function ownKeys$o(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$m(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$o(Object(AA), !0).forEach(function(IA) {
      _defineProperty$t(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$o(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$t(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var DarkTheme = {
  name: "dark-theme",
  colors: _objectSpread$m(_objectSpread$m(_objectSpread$m({}, darkColorTokens), getComponentColorTokens()), getSemanticColorTokens()),
  animation,
  breakpoints: breakpoints$1,
  borders,
  direction: "auto",
  grid: grid$1,
  lighting,
  mediaQuery,
  sizing: sizing$1,
  typography: getTypography(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2e3
  }
}, DarkThemeMove = deepMerge$2({}, DarkTheme, {
  name: "dark-theme-with-move",
  // For the move theme we need to override typography values
  // in the default darkTheme with a font values that reference
  // our custom font family. In addition to it we want to replace some
  // of the fonts with an additional secondary font that specified
  // in `moveTypography`. For it we'll get the typography value built
  // with a custom font using `getTypography` helper and extend the result
  // value with the customized set of fonts that reference a secondary font
  typography: deepMerge$2(getTypography(fontTokens), typography)
}), _excluded$d = ["primaryFontFamily"];
function ownKeys$n(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$l(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$n(Object(AA), !0).forEach(function(IA) {
      _defineProperty$s(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$n(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$s(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _objectWithoutProperties$f(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$f(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$f(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function createDarkTheme() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gA = arguments.length > 1 ? arguments[1] : void 0, AA = CA.primaryFontFamily, IA = _objectWithoutProperties$f(CA, _excluded$d), BA = _objectSpread$l(_objectSpread$l({}, darkColorTokens), IA), QA = {
    animation,
    borders,
    breakpoints: breakpoints$1,
    colors: _objectSpread$l(_objectSpread$l(_objectSpread$l({}, BA), getComponentColorTokens(BA)), getSemanticColorTokens(BA)),
    direction: "auto",
    grid: grid$1,
    lighting,
    mediaQuery,
    sizing: sizing$1,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: AA ? getTypography({
      primaryFontFamily: AA
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2e3
    }
  };
  return deepMerge$2(QA, gA);
}
var _excluded$c = ["primaryFontFamily"];
function ownKeys$m(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$k(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$m(Object(AA), !0).forEach(function(IA) {
      _defineProperty$r(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$m(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$r(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _objectWithoutProperties$e(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$e(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$e(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function createLightTheme() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gA = arguments.length > 1 ? arguments[1] : void 0, AA = CA.primaryFontFamily, IA = _objectWithoutProperties$e(CA, _excluded$c), BA = _objectSpread$k(_objectSpread$k({}, lightColorTokens), IA), QA = {
    animation,
    borders: borders$1,
    breakpoints: breakpoints$1,
    colors: _objectSpread$k(_objectSpread$k(_objectSpread$k({}, BA), getComponentColorTokens$1(BA)), getSemanticColorTokens$1(BA)),
    direction: "auto",
    grid: grid$1,
    lighting,
    mediaQuery,
    sizing: sizing$1,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: AA ? getTypography({
      primaryFontFamily: AA
    }) : getTypography(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2e3
    }
  };
  return deepMerge$2(QA, gA);
}
function ownKeys$l(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$j(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$l(Object(AA), !0).forEach(function(IA) {
      _defineProperty$q(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$l(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$q(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var primitives$1 = _objectSpread$j(_objectSpread$j({}, darkColorTokens), defaultFontTokens);
function ownKeys$k(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$i(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$k(Object(AA), !0).forEach(function(IA) {
      _defineProperty$p(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$k(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$p(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var primitives = _objectSpread$i(_objectSpread$i({}, lightColorTokens), defaultFontTokens);
const themes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DarkTheme,
  DarkThemeMove,
  LightTheme,
  LightThemeMove,
  createDarkTheme,
  createLightTheme,
  createTheme: createLightTheme,
  darkThemeOverrides: DarkTheme,
  darkThemePrimitives: primitives$1,
  lightThemePrimitives: primitives
}, Symbol.toStringTag, { value: "Module" }));
var ThemeContext$1 = /* @__PURE__ */ React.createContext(LightTheme), ThemeProvider$1 = function CA(gA) {
  var AA = gA.theme, IA = gA.children;
  return /* @__PURE__ */ React.createElement(ThemeContext$1.Provider, {
    value: AA
  }, IA);
};
function driver(CA, gA) {
  const AA = renderDeclarativeRules(CA, gA);
  return gA.renderStyle(AA);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(CA, gA) {
  for (const AA in CA) {
    const IA = CA[AA];
    if (AA === "animationName" && typeof IA != "string") {
      CA.animationName = gA.renderKeyframes(IA);
      continue;
    }
    if (AA === "fontFamily" && typeof IA != "string")
      if (Array.isArray(IA)) {
        let BA = "";
        for (const QA of IA)
          typeof QA == "object" ? BA += `${gA.renderFontFace(QA)},` : typeof QA == "string" && (BA += `${QA},`);
        CA.fontFamily = BA.slice(0, -1);
        continue;
      } else {
        if (IA === void 0)
          continue;
        CA.fontFamily = gA.renderFontFace(IA);
        continue;
      }
    typeof IA == "object" && IA !== null && renderDeclarativeRules(IA, gA);
  }
  return CA;
}
function addDebugMetadata(CA, gA) {
  const {
    stack: AA,
    stacktrace: IA,
    message: BA
  } = new Error("stacktrace source");
  CA.debug = {
    stackInfo: {
      stack: AA,
      stacktrace: IA,
      message: BA
    },
    stackIndex: gA
  };
}
const setupDevtoolsExtension = () => {
  const CA = {}, gA = /* @__PURE__ */ new Map(), AA = /* @__PURE__ */ new Map(), IA = (BA) => {
    const QA = {};
    if (typeof BA != "string")
      return QA;
    if (AA.has(BA)) {
      QA.styles = AA.get(BA);
      const EA = BA.split(" ");
      if (EA.length) {
        const iA = {};
        EA.forEach((oA) => {
          iA[oA] = CA[oA];
        }), QA.classes = iA;
      }
      if (gA.has(BA)) {
        const iA = gA.get(BA);
        QA.extends = iA;
      }
      return QA;
    }
  };
  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: CA,
    extensionsMap: gA,
    stylesMap: AA,
    getStyles: IA
  };
};
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$l.apply(this, arguments);
}
const noopEngine = {
  renderStyle: () => "",
  renderKeyframes: () => "",
  renderFontFace: () => ""
}, StyletronContext = /* @__PURE__ */ React.createContext(noopEngine), HydrationContext = /* @__PURE__ */ React.createContext(!1), DebugEngineContext = /* @__PURE__ */ React.createContext(void 0);
class DevProvider extends React.Component {
  constructor(gA) {
    super(gA), this.state = {
      hydrating: !!gA.debugAfterHydration
    };
  }
  componentDidMount() {
    this.state.hydrating === !0 && this.setState({
      hydrating: !1
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(StyletronContext.Provider, {
      value: this.props.value
    }, /* @__PURE__ */ React.createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, /* @__PURE__ */ React.createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  }
}
const Provider$1 = process.env.NODE_ENV !== "production" ? DevProvider : StyletronContext.Provider;
process.env.NODE_ENV !== "production" && !window.__STYLETRON_DEVTOOLS__ && setupDevtoolsExtension();
function checkNoopEngine(CA) {
  process.env.NODE_ENV !== "test" && CA === noopEngine && // eslint-disable-next-line no-console
  console.warn(process.env.NODE_ENV !== "production" ? `
Styletron has been switched to a no-op (test) mode.

A Styletron styled component was rendered, but no Styletron engine instance was provided in React context.

Did you forget to provide a Styletron engine instance to React context via using the Styletron provider component?

Note: Providers and Consumers must come from the exact same React.createContext call to work.
If your app has multiple instances of the "styletron-react" package in your node_module tree,
your Provider may be coming from a different React.createContext call, which means the styled components
will not recieve the provided engine instance. This scenario can arise, for example, when using "npm link".
` : "Styletron Provider is not set up. Defaulting to no-op.");
}
function useStyletron$1() {
  const CA = React.useContext(StyletronContext), gA = React.useContext(DebugEngineContext), AA = React.useContext(HydrationContext);
  checkNoopEngine(CA);
  const IA = React.useRef(""), BA = React.useRef([]);
  return [function(EA) {
    const iA = driver(EA, CA);
    if (process.env.NODE_ENV === "production")
      return iA;
    const {
      stack: oA,
      message: cA
    } = new Error("stacktrace source"), tA = [gA, AA];
    return (BA.current[0] !== tA[0] || BA.current[1] !== tA[1]) && (gA && !AA && (IA.current = gA.debug({
      stackInfo: {
        stack: oA,
        message: cA
      },
      stackIndex: 1
    })), BA.current = tA), IA.current ? `${IA.current} ${iA}` : iA;
  }];
}
function createStyled$1({
  getInitialStyle: CA,
  driver: gA,
  wrapper: AA
}) {
  function IA(BA, QA) {
    process.env.NODE_ENV !== "production" && BA.__STYLETRON__ && (console.warn("It appears you are passing a styled component into `styled`."), console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead."));
    const EA = {
      reducers: [],
      base: BA,
      driver: gA,
      getInitialStyle: CA,
      wrapper: AA
    };
    return process.env.NODE_ENV !== "production" && addDebugMetadata(EA, 2), createStyledElementComponent(autoComposeShallow(EA, QA));
  }
  return IA;
}
const withStyleDeep = (CA, gA) => {
  const AA = CA.__STYLETRON__;
  return process.env.NODE_ENV !== "production" && (AA || console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).")), process.env.NODE_ENV !== "production" ? (addDebugMetadata(AA, 2), createStyledElementComponent(addExtension(autoComposeDeep(AA, gA), CA, gA))) : createStyledElementComponent(autoComposeDeep(AA, gA));
}, withStyle$1 = withStyleDeep, withWrapper$1 = (CA, gA) => {
  const AA = CA.__STYLETRON__;
  process.env.NODE_ENV !== "production" && (AA || console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers)."));
  const IA = {
    getInitialStyle: AA.getInitialStyle,
    base: AA.base,
    driver: AA.driver,
    wrapper: gA,
    reducers: AA.reducers
  };
  return process.env.NODE_ENV !== "production" && addDebugMetadata(IA, 2), createStyledElementComponent(IA);
};
function autoComposeShallow(CA, gA) {
  return typeof gA == "function" ? dynamicComposeShallow(CA, gA) : staticComposeShallow(CA, gA);
}
function addExtension(CA, gA, AA) {
  return {
    ...CA,
    ext: {
      with: AA,
      name: gA.displayName,
      base: gA.__STYLETRON__.base,
      getInitialStyle: gA.__STYLETRON__.reducers.length ? gA.__STYLETRON__.reducers[0].reducer : gA.__STYLETRON__.getInitialStyle
    }
  };
}
function autoComposeDeep(CA, gA) {
  return typeof gA == "function" ? dynamicComposeDeep(CA, gA) : staticComposeDeep(CA, gA);
}
function staticComposeShallow(CA, gA) {
  return composeStatic(CA, createShallowMergeReducer(gA));
}
function staticComposeDeep(CA, gA) {
  return composeStatic(CA, createDeepMergeReducer(gA));
}
function dynamicComposeShallow(CA, gA) {
  return composeDynamic(CA, (AA, IA) => shallowMerge(AA, gA(IA)));
}
function dynamicComposeDeep(CA, gA) {
  return composeDynamic(CA, (AA, IA) => deepMerge$1(AA, gA(IA)));
}
function createShallowMergeReducer(CA) {
  return {
    reducer: (gA) => shallowMerge(gA, CA),
    assignmentCommutative: !0,
    factory: createShallowMergeReducer,
    style: CA
  };
}
function createDeepMergeReducer(CA) {
  return {
    reducer: (gA) => deepMerge$1(gA, CA),
    assignmentCommutative: !0,
    factory: createDeepMergeReducer,
    style: CA
  };
}
function composeStatic(CA, gA) {
  if (CA.reducers.length === 0) {
    const AA = gA.reducer(CA.getInitialStyle()), IA = {
      reducers: CA.reducers,
      base: CA.base,
      driver: CA.driver,
      wrapper: CA.wrapper,
      getInitialStyle: () => AA
    };
    return process.env.NODE_ENV !== "production" && (IA.debug = CA.debug), IA;
  } else {
    const AA = CA.reducers[0];
    if (AA.assignmentCommutative === !0 && gA.assignmentCommutative === !0) {
      const IA = gA.reducer(AA.style), BA = {
        getInitialStyle: CA.getInitialStyle,
        base: CA.base,
        driver: CA.driver,
        wrapper: CA.wrapper,
        reducers: [AA.factory(IA)].concat(CA.reducers.slice(1))
      };
      return process.env.NODE_ENV !== "production" && (BA.debug = CA.debug), BA;
    }
    return composeDynamic(CA, gA.reducer);
  }
}
function composeDynamic(CA, gA) {
  const AA = {
    getInitialStyle: CA.getInitialStyle,
    base: CA.base,
    driver: CA.driver,
    wrapper: CA.wrapper,
    // @ts-ignore
    reducers: [{
      assignmentCommutative: !1,
      reducer: gA
    }].concat(CA.reducers)
  };
  return process.env.NODE_ENV !== "production" && (AA.debug = CA.debug), AA;
}
function createStyledElementComponent(CA) {
  const {
    reducers: gA,
    base: AA,
    driver: IA,
    wrapper: BA,
    getInitialStyle: QA,
    ext: EA
  } = CA;
  if (process.env.NODE_ENV !== "production") {
    var iA, oA;
    CA.debug && (iA = CA.debug.stackInfo, oA = CA.debug.stackIndex);
  }
  if (process.env.NODE_ENV !== "production")
    var cA;
  const eA = BA(/* @__PURE__ */ React.forwardRef((aA, GA) => {
    const lA = React.useContext(StyletronContext), nA = React.useContext(DebugEngineContext), DA = React.useContext(HydrationContext);
    checkNoopEngine(lA);
    const hA = omitPrefixedKeys(aA);
    let wA = resolveStyle(QA, gA, aA);
    aA.$style && (typeof aA.$style == "function" ? wA = deepMerge$1(wA, aA.$style(aA)) : wA = deepMerge$1(wA, aA.$style));
    const sA = IA(wA, lA), NA = aA.$as ? aA.$as : AA;
    if (hA.className = aA.className ? `${aA.className} ${sA}` : sA, process.env.NODE_ENV !== "production" && nA && !DA) {
      cA || (cA = nA.debug({
        stackInfo: iA,
        stackIndex: oA
      }));
      const rA = `${cA} ${hA.className}`;
      hA.className = rA;
    }
    return process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && (window.__STYLETRON_DEVTOOLS__.stylesMap.set(hA.className, wA), EA && window.__STYLETRON_DEVTOOLS__.extensionsMap.set(hA.className, {
      base: EA.base,
      displayName: EA.name,
      initialStyles: EA.getInitialStyle({}, aA),
      styleOverrides: typeof EA.with == "function" ? EA.with(aA) : EA.with
    })), aA.$ref && console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef."), /* @__PURE__ */ React.createElement(NA, _extends$l({}, hA, {
      ref: GA || aA.$ref
    }));
  }));
  if (eA.__STYLETRON__ = {
    base: AA,
    reducers: gA,
    driver: IA,
    wrapper: BA,
    getInitialStyle: QA
  }, process.env.NODE_ENV !== "production") {
    let aA;
    typeof AA == "string" ? aA = AA : AA.displayName ? aA = AA.displayName : AA.name ? aA = AA.name : aA = "Unknown", eA.displayName = `Styled(${aA})`;
  }
  return eA;
}
function resolveStyle(CA, gA, AA) {
  let IA = CA(), BA = gA.length;
  for (; BA--; ) {
    const QA = gA[BA].reducer;
    IA = QA(IA, AA);
  }
  return IA;
}
function isObject$1(CA) {
  return typeof CA == "object" && CA !== null;
}
function omitPrefixedKeys(CA) {
  const gA = {};
  for (const AA in CA)
    AA[0] !== "$" && (gA[AA] = CA[AA]);
  return gA;
}
function deepMerge$1(CA, gA) {
  const AA = assign({}, CA);
  for (const IA in gA) {
    const BA = gA[IA];
    isObject$1(BA) && isObject$1(CA[IA]) ? AA[IA] = deepMerge$1(CA[IA], BA) : AA[IA] = BA;
  }
  return AA;
}
function shallowMerge(CA, gA) {
  return assign(assign({}, CA), gA);
}
function assign(CA, gA) {
  for (const AA in gA)
    CA[AA] = gA[AA];
  return CA;
}
function ownKeys$j(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$h(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$j(Object(AA), !0).forEach(function(IA) {
      _defineProperty$o(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$j(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$o(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _slicedToArray$a(CA, gA) {
  return _arrayWithHoles$9(CA) || _iterableToArrayLimit$9(CA, gA) || _unsupportedIterableToArray$9(CA, gA) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$9(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$9(CA, gA);
  }
}
function _arrayLikeToArray$9(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$9(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$9(CA) {
  if (Array.isArray(CA)) return CA;
}
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$k.apply(this, arguments);
}
var wrapper = function CA(gA) {
  return /* @__PURE__ */ React.forwardRef(function(AA, IA) {
    return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(BA) {
      return /* @__PURE__ */ React.createElement(gA, _extends$k({
        ref: IA
      }, AA, {
        $theme: BA
      }));
    });
  });
};
function createThemedStyled() {
  return createStyled$1({
    wrapper,
    getInitialStyle,
    driver
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  return withStyle$1;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function() {
    var CA = React.useContext(ThemeContext$1), gA = useStyletron$1(), AA = _slicedToArray$a(gA, 1), IA = AA[0];
    return [IA, CA];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper(CA, gA) {
  return withWrapper$1(CA, function(AA) {
    return /* @__PURE__ */ React.forwardRef(function(IA, BA) {
      return /* @__PURE__ */ React.createElement(ThemeContext$1.Consumer, null, function(QA) {
        return (
          // @ts-ignore
          gA(AA)(_objectSpread$h(_objectSpread$h({
            ref: BA
          }, IA), {}, {
            $theme: QA
          }))
        );
      });
    });
  });
}
var ThemeConsumer = ThemeContext$1.Consumer;
const styles$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ThemeConsumer,
  ThemeProvider: ThemeProvider$1,
  createThemedStyled,
  createThemedUseStyletron,
  createThemedWithStyle,
  expandBorderStyles,
  hexToRgb,
  styled,
  useStyletron,
  withStyle,
  withWrapper
}, Symbol.toStringTag, { value: "Module" })), require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(styles$1), require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(themes);
var justExtend, hasRequiredJustExtend;
function requireJustExtend() {
  if (hasRequiredJustExtend) return justExtend;
  hasRequiredJustExtend = 1, justExtend = CA;
  function CA() {
    var IA = [].slice.call(arguments), BA = !1;
    typeof IA[0] == "boolean" && (BA = IA.shift());
    var QA = IA[0];
    if (AA(QA))
      throw new Error("extendee must be an object");
    for (var EA = IA.slice(1), iA = EA.length, oA = 0; oA < iA; oA++) {
      var cA = EA[oA];
      for (var tA in cA)
        if (Object.prototype.hasOwnProperty.call(cA, tA)) {
          var eA = cA[tA];
          if (BA && gA(eA)) {
            var aA = Array.isArray(eA) ? [] : {};
            QA[tA] = CA(
              !0,
              Object.prototype.hasOwnProperty.call(QA, tA) && !AA(QA[tA]) ? QA[tA] : aA,
              eA
            );
          } else
            QA[tA] = eA;
        }
    }
    return QA;
  }
  function gA(IA) {
    return Array.isArray(IA) || {}.toString.call(IA) == "[object Object]";
  }
  function AA(IA) {
    return !IA || typeof IA != "object" && typeof IA != "function";
  }
  return justExtend;
}
var justExtendExports = requireJustExtend();
const extend$2 = /* @__PURE__ */ getDefaultExportFromCjs(justExtendExports);
var locale$c = {
  collapse: "Collapse",
  expand: "Expand"
}, locale$b = {
  ariaLabel: "Breadcrumbs navigation"
}, locale$a = {
  ariaLabel: "Select a date.",
  ariaLabelRange: "Select a date range.",
  ariaLabelCalendar: "Calendar.",
  ariaRoleDescriptionCalendarMonth: "Calendar month",
  previousMonth: "Previous month.",
  nextMonth: "Next month.",
  pastWeek: "Past Week",
  pastMonth: "Past Month",
  pastThreeMonths: "Past 3 Months",
  pastSixMonths: "Past 6 Months",
  pastYear: "Past Year",
  pastTwoYears: "Past 2 Years",
  screenReaderMessageInput: "Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.",
  selectedDate: "Selected date is ${date}.",
  selectedDateRange: "Selected date range is from ${startDate} to ${endDate}.",
  selectSecondDatePrompt: "Select the second date.",
  quickSelectLabel: "Choose a date range",
  quickSelectAriaLabel: "Choose a date range",
  quickSelectPlaceholder: "None",
  timeSelectEndLabel: "End time",
  timeSelectStartLabel: "Start time",
  timePickerAriaLabel12Hour: "Select a time, 12-hour format.",
  timePickerAriaLabel24Hour: "Select a time, 24-hour format.",
  timezonePickerAriaLabel: "Select a timezone.",
  selectedStartDateLabel: "Selected start date.",
  selectedEndDateLabel: "Selected end date.",
  dateNotAvailableLabel: "Not available.",
  dateAvailableLabel: "It's available.",
  selectedLabel: "Selected.",
  chooseLabel: "Choose"
}, locale$9 = {
  emptyState: "No rows match the filter criteria defined. Please remove one or more filters to view more data.",
  loadingState: "Loading rows.",
  searchAriaLabel: "Search by text",
  filterAdd: "Add Filter",
  filterExclude: "Exclude",
  filterApply: "Apply",
  filterExcludeRange: "Exclude range",
  filterExcludeValue: "Exclude value",
  filterAppliedTo: "filter applied to",
  optionsLabel: "Select column to filter by",
  optionsSearch: "Search for a column to filter by...",
  optionsEmpty: "No columns available.",
  categoricalFilterSelectAll: "Select All",
  categoricalFilterSelectClear: "Clear",
  categoricalFilterEmpty: "No categories found",
  datetimeFilterRange: "Range",
  datetimeFilterRangeDatetime: "Date, Time",
  datetimeFilterRangeDate: "Date",
  datetimeFilterRangeTime: "Time",
  datetimeFilterCategorical: "Categorical",
  datetimeFilterCategoricalWeekday: "Weekday",
  datetimeFilterCategoricalMonth: "Month",
  datetimeFilterCategoricalQuarter: "Quarter",
  datetimeFilterCategoricalHalf: "Half",
  datetimeFilterCategoricalFirstHalf: "H1",
  datetimeFilterCategoricalSecondHalf: "H2",
  datetimeFilterCategoricalYear: "Year",
  numericalFilterRange: "Range",
  numericalFilterSingleValue: "Single Value",
  booleanFilterTrue: "true",
  booleanFilterFalse: "false",
  booleanColumnTrueShort: "T",
  booleanColumnFalseShort: "F",
  selectRow: "Select row",
  selectAllRows: "Select all rows"
}, locale$8 = {
  ariaLabel: "button group"
}, locale$7 = {
  dropFilesToUpload: "Drop files here to upload...",
  or: "",
  browseFiles: "Browse files",
  retry: "Retry Upload",
  cancel: "Cancel"
}, locale$6 = {
  noResultsMsg: "No results",
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
}, locale$5 = {
  close: "Close"
}, locale$4 = {
  close: "Close"
}, locale$3 = {
  prev: "Prev",
  next: "Next",
  preposition: "of"
}, locale$2 = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: "No results found",
  placeholder: "Select...",
  create: "Create"
}, locale$1 = {
  close: "Close"
}, en_US = {
  accordion: locale$c,
  breadcrumbs: locale$b,
  datepicker: locale$a,
  datatable: locale$9,
  buttongroup: locale$8,
  fileuploader: locale$7,
  menu: locale$6,
  modal: locale$5,
  drawer: locale$4,
  pagination: locale$3,
  select: locale$2,
  toast: locale$1
}, LocaleContext = /* @__PURE__ */ React.createContext(en_US), LocaleProvider = function CA(gA) {
  var AA, IA = gA.locale, BA = gA.children, QA = (AA = React.useContext(LocaleContext)) !== null && AA !== void 0 ? AA : {};
  return /* @__PURE__ */ React.createElement(LocaleContext.Provider, {
    value: extend$2({}, en_US, QA, IA)
  }, BA);
};
const locale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LocaleContext,
  default: LocaleProvider
}, Symbol.toStringTag, { value: "Module" })), require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(locale);
var baseProvider = {}, generateUID$1 = function() {
  var CA = 1, gA = /* @__PURE__ */ new WeakMap(), AA = function(IA, BA) {
    return typeof IA == "number" || typeof IA == "string" ? BA ? "idx-".concat(BA) : "val-".concat(IA) : gA.has(IA) ? "uid" + gA.get(IA) : (gA.set(IA, CA++), AA(IA));
  };
  return AA;
}, uid = generateUID$1(), createSource = function(CA) {
  return CA === void 0 && (CA = ""), {
    value: 1,
    prefix: CA,
    uid: generateUID$1()
  };
}, counter = createSource(), source = React.createContext(createSource()), getId = function(CA) {
  return CA.value++;
}, getPrefix = function(CA) {
  return CA ? CA.prefix : "";
}, __extends$1 = /* @__PURE__ */ (function() {
  var CA = function(gA, AA) {
    return CA = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(IA, BA) {
      IA.__proto__ = BA;
    } || function(IA, BA) {
      for (var QA in BA) Object.prototype.hasOwnProperty.call(BA, QA) && (IA[QA] = BA[QA]);
    }, CA(gA, AA);
  };
  return function(gA, AA) {
    if (typeof AA != "function" && AA !== null)
      throw new TypeError("Class extends value " + String(AA) + " is not a constructor or null");
    CA(gA, AA);
    function IA() {
      this.constructor = gA;
    }
    gA.prototype = AA === null ? Object.create(AA) : (IA.prototype = AA.prototype, new IA());
  };
})(), prefixId = function(CA, gA, AA) {
  var IA = gA + CA;
  return String(AA ? AA(IA) : IA);
}, UID = (
  /** @class */
  (function(CA) {
    __extends$1(gA, CA);
    function gA() {
      var AA = CA !== null && CA.apply(this, arguments) || this;
      return AA.state = {
        quartz: AA.props.idSource || counter,
        prefix: getPrefix(AA.props.idSource),
        id: getId(AA.props.idSource || counter)
      }, AA.uid = function(IA) {
        return prefixId(AA.state.id + "-" + AA.state.quartz.uid(IA), AA.state.prefix, AA.props.name);
      }, AA;
    }
    return gA.prototype.render = function() {
      var AA = this.props, IA = AA.children, BA = AA.name, QA = this.state, EA = QA.id, iA = QA.prefix;
      return IA(prefixId(EA, iA, BA), this.uid);
    }, gA;
  })(React.Component)
), generateUID = function(CA) {
  var gA = CA || counter, AA = getPrefix(gA), IA = getId(gA), BA = AA + IA, QA = function(EA) {
    return BA + gA.uid(EA);
  };
  return { uid: BA, gen: QA };
}, useUIDState = function() {
  if (process.env.NODE_ENV !== "production" && !("useContext" in React))
    throw new Error("Hooks API requires React 16.8+");
  var CA = useContext(source), gA = useState(function() {
    return generateUID(CA);
  })[0];
  return gA;
}, useUID = function() {
  var CA = useUIDState().uid;
  return CA;
}, useUIDSeed = function() {
  var CA = useUIDState().gen;
  return CA;
}, UIDReset = function(CA) {
  var gA = CA.children, AA = CA.prefix, IA = AA === void 0 ? "" : AA, BA = useState(function() {
    return createSource(IA);
  })[0];
  return React.createElement(source.Provider, { value: BA }, gA);
}, UIDFork = function(CA) {
  var gA = CA.children, AA = CA.prefix, IA = AA === void 0 ? "" : AA, BA = useUID(), QA = useState(function() {
    return createSource(BA + "-" + IA);
  })[0];
  return React.createElement(source.Provider, { value: QA }, gA);
}, UIDConsumer = function(CA) {
  var gA = CA.name, AA = CA.children;
  return React.createElement(source.Consumer, null, function(IA) {
    return React.createElement(UID, { name: gA, idSource: IA, children: AA });
  });
};
const es2015 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UID,
  UIDConsumer,
  UIDFork,
  UIDReset,
  generateUID: generateUID$1,
  uid,
  useUID,
  useUIDSeed
}, Symbol.toStringTag, { value: "Module" })), require$$1 = /* @__PURE__ */ getAugmentedNamespace(es2015);
var reactIsExports$1 = requireReactIs$1();
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$j.apply(this, arguments);
}
function ownKeys$i(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$g(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$i(Object(AA), !0).forEach(function(IA) {
      _defineProperty$n(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$i(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$n(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _typeof$e(CA) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$e(CA);
}
function getOverride(CA) {
  return reactIsExports$1.isValidElementType(CA) ? CA : CA && _typeof$e(CA) === "object" ? CA.component : CA;
}
function getOverrideProps(CA) {
  return CA && _typeof$e(CA) === "object" ? _typeof$e(CA.props) === "object" ? _objectSpread$g(_objectSpread$g({}, CA.props), {}, {
    $style: CA.style
  }) : {
    $style: CA.style
  } : {};
}
function toObjectOverride(CA) {
  return reactIsExports$1.isValidElementType(CA) ? {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: CA
  } : CA || {};
}
function getOverrides(CA, gA) {
  var AA = getOverride(CA) || gA;
  if (CA && _typeof$e(CA) === "object" && typeof CA.props == "function") {
    process.env.NODE_ENV !== "production" && console.warn("baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent");
    var IA = /* @__PURE__ */ React.forwardRef(function(QA, EA) {
      var iA = CA.props(QA), oA = getOverrideProps(_objectSpread$g(_objectSpread$g({}, CA), {}, {
        props: iA
      }));
      return /* @__PURE__ */ React.createElement(AA, _extends$j({
        ref: EA
      }, oA));
    });
    return IA.displayName = AA.displayName, [IA, {}];
  }
  var BA = getOverrideProps(CA);
  return [AA, BA];
}
function mergeOverrides() {
  var CA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, AA = Object.assign({}, CA, gA), IA = Object.keys(AA);
  return IA.reduce(function(BA, QA) {
    return BA[QA] = mergeOverride(toObjectOverride(CA[QA]), toObjectOverride(gA[QA])), BA;
  }, {});
}
function mergeOverride(CA, gA) {
  var AA = _objectSpread$g(_objectSpread$g({}, CA), gA);
  return CA.props && gA.props && (AA.props = mergeConfigurationOverrides(CA.props, gA.props)), CA.style && gA.style && (AA.style = mergeConfigurationOverrides(CA.style, gA.style)), AA;
}
function mergeConfigurationOverrides(CA, gA) {
  return _typeof$e(CA) === "object" && _typeof$e(gA) === "object" ? deepMerge$2({}, CA, gA) : function() {
    return deepMerge$2({}, typeof CA == "function" ? CA.apply(void 0, arguments) : CA, typeof gA == "function" ? gA.apply(void 0, arguments) : gA);
  };
}
var initialized = !1, hadKeyboardEvent = !0, inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(CA) {
  var gA = CA.type, AA = CA.tagName;
  return !!(AA === "INPUT" && inputTypesWhitelist[gA] && !CA.readOnly || AA === "TEXTAREA" && !CA.readOnly || CA.isContentEditable);
}
function handleKeyDown(CA) {
  CA.metaKey || CA.altKey || CA.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState;
}
function prepare(CA) {
  CA.addEventListener("keydown", handleKeyDown, !0), CA.addEventListener("mousedown", handlePointerDown, !0), CA.addEventListener("pointerdown", handlePointerDown, !0), CA.addEventListener("touchstart", handlePointerDown, !0), CA.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(CA) {
  try {
    return CA.target.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(CA.target);
}
function initFocusVisible(CA) {
  !initialized && CA != null && (initialized = !0, prepare(CA.ownerDocument));
}
var forkFocus = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function CA(gA, AA) {
    return function(IA) {
      typeof gA.onFocus == "function" && gA.onFocus(IA), AA(IA);
    };
  }
), forkBlur = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function CA(gA, AA) {
    return function(IA) {
      typeof gA.onBlur == "function" && gA.onBlur(IA), AA(IA);
    };
  }
);
function _typeof$d(CA) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$d(CA);
}
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$i.apply(this, arguments);
}
function _slicedToArray$9(CA, gA) {
  return _arrayWithHoles$8(CA) || _iterableToArrayLimit$8(CA, gA) || _unsupportedIterableToArray$8(CA, gA) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$8(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$8(CA) {
  if (Array.isArray(CA)) return CA;
}
function _toConsumableArray$2(CA) {
  return _arrayWithoutHoles$2(CA) || _iterableToArray$2(CA) || _unsupportedIterableToArray$8(CA) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$8(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$8(CA, gA);
  }
}
function _iterableToArray$2(CA) {
  if (typeof Symbol < "u" && CA[Symbol.iterator] != null || CA["@@iterator"] != null) return Array.from(CA);
}
function _arrayWithoutHoles$2(CA) {
  if (Array.isArray(CA)) return _arrayLikeToArray$8(CA);
}
function _arrayLikeToArray$8(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _classCallCheck$b(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$b(CA, gA, AA) {
  return gA && _defineProperties$b(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$b(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$c(CA, gA);
}
function _setPrototypeOf$c(CA, gA) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$c(CA, gA);
}
function _createSuper$b(CA) {
  var gA = _isNativeReflectConstruct$b();
  return function() {
    var IA = _getPrototypeOf$b(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$b(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$b(this, BA);
  };
}
function _possibleConstructorReturn$b(CA, gA) {
  if (gA && (_typeof$d(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(CA);
}
function _assertThisInitialized$b(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$b(CA) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$b(CA);
}
function _defineProperty$m(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var StyledAppContainer = styled("div", {});
StyledAppContainer.displayName = "StyledAppContainer";
var StyledLayersContainer = styled("div", {});
StyledLayersContainer.displayName = "StyledLayersContainer";
function defaultEventHandlerFn() {
  process.env.NODE_ENV !== "production" && console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information");
}
var LayersContext = /* @__PURE__ */ React.createContext({
  addEscapeHandler: defaultEventHandlerFn,
  removeEscapeHandler: defaultEventHandlerFn,
  addKeyDownHandler: defaultEventHandlerFn,
  removeKeyDownHandler: defaultEventHandlerFn,
  addKeyUpHandler: defaultEventHandlerFn,
  removeKeyUpHandler: defaultEventHandlerFn,
  addKeyPressHandler: defaultEventHandlerFn,
  removeKeyPressHandler: defaultEventHandlerFn,
  addDocClickHandler: defaultEventHandlerFn,
  removeDocClickHandler: defaultEventHandlerFn,
  host: void 0,
  zIndex: void 0
}), Provider = LayersContext.Provider, Consumer = LayersContext.Consumer, LayersManager = /* @__PURE__ */ (function(CA) {
  _inherits$b(AA, CA);
  var gA = _createSuper$b(AA);
  function AA(IA) {
    var BA;
    return _classCallCheck$b(this, AA), BA = gA.call(this, IA), _defineProperty$m(_assertThisInitialized$b(BA), "host", /* @__PURE__ */ React.createRef()), _defineProperty$m(_assertThisInitialized$b(BA), "containerRef", /* @__PURE__ */ React.createRef()), _defineProperty$m(_assertThisInitialized$b(BA), "onDocumentClick", function(QA) {
      var EA = BA.state.docClickHandlers[BA.state.docClickHandlers.length - 1];
      EA && EA(QA);
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onKeyDown", function(QA) {
      var EA = BA.state.keyDownHandlers[BA.state.keyDownHandlers.length - 1];
      EA && EA(QA);
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onKeyUp", function(QA) {
      if (QA.key === "Escape") {
        var EA = BA.state.escapeKeyHandlers[BA.state.escapeKeyHandlers.length - 1];
        EA && EA();
      }
      var iA = BA.state.keyUpHandlers[BA.state.keyUpHandlers.length - 1];
      iA && iA(QA);
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onKeyPress", function(QA) {
      var EA = BA.state.keyPressHandlers[BA.state.keyPressHandlers.length - 1];
      EA && EA(QA);
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onAddEscapeHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          escapeKeyHandlers: [].concat(_toConsumableArray$2(EA.escapeKeyHandlers), [QA])
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onRemoveEscapeHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          escapeKeyHandlers: EA.escapeKeyHandlers.filter(function(iA) {
            return iA !== QA;
          })
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onAddKeyDownHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyDownHandlers: [].concat(_toConsumableArray$2(EA.keyDownHandlers), [QA])
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onRemoveKeyDownHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyDownHandlers: EA.keyDownHandlers.filter(function(iA) {
            return iA !== QA;
          })
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onAddKeyUpHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyUpHandlers: [].concat(_toConsumableArray$2(EA.keyUpHandlers), [QA])
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onRemoveKeyUpHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyUpHandlers: EA.keyUpHandlers.filter(function(iA) {
            return iA !== QA;
          })
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onAddKeyPressHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyPressHandlers: [].concat(_toConsumableArray$2(EA.keyPressHandlers), [QA])
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onRemoveKeyPressHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          keyPressHandlers: EA.keyPressHandlers.filter(function(iA) {
            return iA !== QA;
          })
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onAddDocClickHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          docClickHandlers: [].concat(_toConsumableArray$2(EA.docClickHandlers), [QA])
        };
      });
    }), _defineProperty$m(_assertThisInitialized$b(BA), "onRemoveDocClickHandler", function(QA) {
      BA.setState(function(EA) {
        return {
          docClickHandlers: EA.docClickHandlers.filter(function(iA) {
            return iA !== QA;
          })
        };
      });
    }), BA.state = {
      escapeKeyHandlers: [],
      keyDownHandlers: [],
      keyUpHandlers: [],
      keyPressHandlers: [],
      docClickHandlers: []
    }, BA;
  }
  return _createClass$b(AA, [{
    key: "componentDidMount",
    value: function() {
      this.forceUpdate(), initFocusVisible(this.containerRef.current), typeof document < "u" && (document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.onKeyUp), document.addEventListener("keypress", this.onKeyPress), document.addEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      typeof document < "u" && (document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keypress", this.onKeyPress), document.removeEventListener("mousedown", this.onDocumentClick));
    }
  }, {
    key: "render",
    value: function() {
      var BA = this, QA = this.props.overrides, EA = QA === void 0 ? {} : QA, iA = getOverrides(EA.AppContainer, StyledAppContainer), oA = _slicedToArray$9(iA, 2), cA = oA[0], tA = oA[1], eA = getOverrides(EA.LayersContainer, StyledLayersContainer), aA = _slicedToArray$9(eA, 2), GA = aA[0], lA = aA[1];
      return /* @__PURE__ */ React.createElement(Consumer, null, function(nA) {
        var DA = nA.host;
        return process.env.NODE_ENV !== "production" && DA !== void 0 && console.warn("There is a LayersManager already exists in your application. It is not recommended to have more than one LayersManager in an application."), /* @__PURE__ */ React.createElement(Provider, {
          value: {
            host: DA || BA.host.current,
            zIndex: BA.props.zIndex,
            addEscapeHandler: BA.onAddEscapeHandler,
            removeEscapeHandler: BA.onRemoveEscapeHandler,
            addKeyDownHandler: BA.onAddKeyDownHandler,
            removeKeyDownHandler: BA.onRemoveKeyDownHandler,
            addKeyUpHandler: BA.onAddKeyUpHandler,
            removeKeyUpHandler: BA.onRemoveKeyUpHandler,
            addKeyPressHandler: BA.onAddKeyPressHandler,
            removeKeyPressHandler: BA.onRemoveKeyPressHandler,
            addDocClickHandler: BA.onAddDocClickHandler,
            removeDocClickHandler: BA.onRemoveDocClickHandler
          }
        }, /* @__PURE__ */ React.createElement(cA, _extends$i({}, tA, {
          ref: BA.containerRef
        }), BA.props.children), /* @__PURE__ */ React.createElement(GA, _extends$i({}, lA, {
          ref: BA.host
        })));
      });
    }
  }]), AA;
})(React.Component);
function _typeof$c(CA) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$c(CA);
}
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$h.apply(this, arguments);
}
function _classCallCheck$a(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$a(CA, gA, AA) {
  return gA && _defineProperties$a(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$a(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$b(CA, gA);
}
function _setPrototypeOf$b(CA, gA) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$b(CA, gA);
}
function _createSuper$a(CA) {
  var gA = _isNativeReflectConstruct$a();
  return function() {
    var IA = _getPrototypeOf$a(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$a(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$a(this, BA);
  };
}
function _possibleConstructorReturn$a(CA, gA) {
  if (gA && (_typeof$c(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(CA);
}
function _assertThisInitialized$a(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$a(CA) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$a(CA);
}
function _defineProperty$l(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Container = styled("div", function(CA) {
  var gA = CA.$zIndex;
  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: gA || null
  };
});
Container.displayName = "Container";
var LayerComponent = /* @__PURE__ */ (function(CA) {
  _inherits$a(AA, CA);
  var gA = _createSuper$a(AA);
  function AA() {
    var IA;
    _classCallCheck$a(this, AA);
    for (var BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = gA.call.apply(gA, [this].concat(QA)), _defineProperty$l(_assertThisInitialized$a(IA), "state", {
      container: null
    }), _defineProperty$l(_assertThisInitialized$a(IA), "onEscape", function() {
      IA.props.onEscape && IA.props.onEscape();
    }), _defineProperty$l(_assertThisInitialized$a(IA), "onKeyDown", function(iA) {
      IA.props.onKeyDown && IA.props.onKeyDown(iA);
    }), _defineProperty$l(_assertThisInitialized$a(IA), "onKeyUp", function(iA) {
      IA.props.onKeyUp && IA.props.onKeyUp(iA);
    }), _defineProperty$l(_assertThisInitialized$a(IA), "onKeyPress", function(iA) {
      IA.props.onKeyPress && IA.props.onKeyPress(iA);
    }), _defineProperty$l(_assertThisInitialized$a(IA), "onDocumentClick", function(iA) {
      IA.props.onDocumentClick && IA.props.onDocumentClick(iA);
    }), IA;
  }
  return _createClass$a(AA, [{
    key: "componentDidMount",
    value: function() {
      this.context.addEscapeHandler(this.onEscape), this.context.addKeyDownHandler(this.onKeyDown), this.context.addKeyUpHandler(this.onKeyUp), this.context.addKeyPressHandler(this.onKeyPress), this.props.isHoverLayer || this.context.addDocClickHandler(this.onDocumentClick);
      var BA = this.props, QA = BA.onMount, EA = BA.mountNode, iA = BA.host;
      if (EA) {
        QA && QA();
        return;
      }
      var oA = iA !== void 0;
      process.env.NODE_ENV !== "production" && (oA || console.warn("`LayersManager` was not found. This occurs if you are attempting to use a component requiring `Layer` without using the `BaseProvider` at the root of your app. Please visit https://baseweb.design/components/base-provider/ for more information"));
      var cA = oA ? iA : document.body;
      cA && this.addContainer(cA);
    }
  }, {
    key: "componentDidUpdate",
    value: function(BA) {
      var QA = this.props, EA = QA.host, iA = QA.mountNode;
      iA || (EA && EA !== BA.host && BA.host === null && this.addContainer(EA), BA.isHoverLayer != this.props.isHoverLayer && (this.props.isHoverLayer ? this.context.removeDocClickHandler(this.onDocumentClick) : this.context.addDocClickHandler(this.onDocumentClick)));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.context.removeEscapeHandler(this.onEscape), this.context.removeKeyDownHandler(this.onKeyDown), this.context.removeKeyUpHandler(this.onKeyUp), this.context.removeKeyPressHandler(this.onKeyPress), this.context.removeDocClickHandler(this.onDocumentClick), this.props.onUnmount && this.props.onUnmount();
      var BA = this.props.host, QA = this.state.container;
      BA && QA && BA.contains(QA) && BA.removeChild(QA);
    }
  }, {
    key: "addContainer",
    value: function(BA) {
      var QA = this.props, EA = QA.index, iA = QA.mountNode, oA = QA.onMount;
      if (!iA && BA) {
        var cA = BA.ownerDocument.createElement("div"), tA = typeof EA == "number" ? BA.children[EA] : null;
        tA ? BA.insertBefore(cA, tA) : BA.appendChild(cA), this.setState({
          container: cA
        }, function() {
          oA && oA();
        });
      }
    }
  }, {
    key: "render",
    value: function() {
      var BA = this.state.container, QA = this.props, EA = QA.children, iA = QA.mountNode, oA = QA.zIndex, cA = oA ? /* @__PURE__ */ React.createElement(Container, {
        $zIndex: oA
      }, EA) : EA;
      return typeof document < "u" ? iA ? /* @__PURE__ */ ReactDOM.createPortal(cA, iA) : BA ? /* @__PURE__ */ ReactDOM.createPortal(cA, BA) : null : null;
    }
  }]), AA;
})(React.Component);
_defineProperty$l(LayerComponent, "contextType", LayersContext);
function Layer(CA) {
  return /* @__PURE__ */ React.createElement(Consumer, null, function(gA) {
    var AA = gA.host, IA = gA.zIndex;
    return /* @__PURE__ */ React.createElement(LayerComponent, _extends$h({}, CA, {
      host: AA,
      zIndex: IA
    }));
  });
}
var isBrowser$1 = typeof window < "u" && typeof document < "u" && typeof navigator < "u", timeoutDuration = (function() {
  for (var CA = ["Edge", "Trident", "Firefox"], gA = 0; gA < CA.length; gA += 1)
    if (isBrowser$1 && navigator.userAgent.indexOf(CA[gA]) >= 0)
      return 1;
  return 0;
})();
function microtaskDebounce(CA) {
  var gA = !1;
  return function() {
    gA || (gA = !0, window.Promise.resolve().then(function() {
      gA = !1, CA();
    }));
  };
}
function taskDebounce(CA) {
  var gA = !1;
  return function() {
    gA || (gA = !0, setTimeout(function() {
      gA = !1, CA();
    }, timeoutDuration));
  };
}
var supportsMicroTasks = isBrowser$1 && window.Promise, debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$1(CA) {
  var gA = {};
  return CA && gA.toString.call(CA) === "[object Function]";
}
function getStyleComputedProperty(CA, gA) {
  if (CA.nodeType !== 1)
    return [];
  var AA = CA.ownerDocument.defaultView, IA = AA.getComputedStyle(CA, null);
  return gA ? IA[gA] : IA;
}
function getParentNode$1(CA) {
  return CA.nodeName === "HTML" ? CA : CA.parentNode || CA.host;
}
function getScrollParent(CA) {
  if (!CA)
    return document.body;
  switch (CA.nodeName) {
    case "HTML":
    case "BODY":
      return CA.ownerDocument.body;
    case "#document":
      return CA.body;
  }
  var gA = getStyleComputedProperty(CA), AA = gA.overflow, IA = gA.overflowX, BA = gA.overflowY;
  return /(auto|scroll|overlay)/.test(AA + BA + IA) ? CA : getScrollParent(getParentNode$1(CA));
}
function getReferenceNode(CA) {
  return CA && CA.referenceNode ? CA.referenceNode : CA;
}
var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode), isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);
function isIE(CA) {
  return CA === 11 ? isIE11 : CA === 10 ? isIE10 : isIE11 || isIE10;
}
function getOffsetParent(CA) {
  if (!CA)
    return document.documentElement;
  for (var gA = isIE(10) ? document.body : null, AA = CA.offsetParent || null; AA === gA && CA.nextElementSibling; )
    AA = (CA = CA.nextElementSibling).offsetParent;
  var IA = AA && AA.nodeName;
  return !IA || IA === "BODY" || IA === "HTML" ? CA ? CA.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(AA.nodeName) !== -1 && getStyleComputedProperty(AA, "position") === "static" ? getOffsetParent(AA) : AA;
}
function isOffsetContainer(CA) {
  var gA = CA.nodeName;
  return gA === "BODY" ? !1 : gA === "HTML" || getOffsetParent(CA.firstElementChild) === CA;
}
function getRoot(CA) {
  return CA.parentNode !== null ? getRoot(CA.parentNode) : CA;
}
function findCommonOffsetParent(CA, gA) {
  if (!CA || !CA.nodeType || !gA || !gA.nodeType)
    return document.documentElement;
  var AA = CA.compareDocumentPosition(gA) & Node.DOCUMENT_POSITION_FOLLOWING, IA = AA ? CA : gA, BA = AA ? gA : CA, QA = document.createRange();
  QA.setStart(IA, 0), QA.setEnd(BA, 0);
  var EA = QA.commonAncestorContainer;
  if (CA !== EA && gA !== EA || IA.contains(BA))
    return isOffsetContainer(EA) ? EA : getOffsetParent(EA);
  var iA = getRoot(CA);
  return iA.host ? findCommonOffsetParent(iA.host, gA) : findCommonOffsetParent(CA, getRoot(gA).host);
}
function getScroll(CA) {
  var gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", AA = gA === "top" ? "scrollTop" : "scrollLeft", IA = CA.nodeName;
  if (IA === "BODY" || IA === "HTML") {
    var BA = CA.ownerDocument.documentElement, QA = CA.ownerDocument.scrollingElement || BA;
    return QA[AA];
  }
  return CA[AA];
}
function includeScroll(CA, gA) {
  var AA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, IA = getScroll(gA, "top"), BA = getScroll(gA, "left"), QA = AA ? -1 : 1;
  return CA.top += IA * QA, CA.bottom += IA * QA, CA.left += BA * QA, CA.right += BA * QA, CA;
}
function getBordersSize$1(CA, gA) {
  var AA = gA === "x" ? "Left" : "Top", IA = AA === "Left" ? "Right" : "Bottom";
  return parseFloat(CA["border" + AA + "Width"]) + parseFloat(CA["border" + IA + "Width"]);
}
function getSize(CA, gA, AA, IA) {
  return Math.max(gA["offset" + CA], gA["scroll" + CA], AA["client" + CA], AA["offset" + CA], AA["scroll" + CA], isIE(10) ? parseInt(AA["offset" + CA]) + parseInt(IA["margin" + (CA === "Height" ? "Top" : "Left")]) + parseInt(IA["margin" + (CA === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(CA) {
  var gA = CA.body, AA = CA.documentElement, IA = isIE(10) && getComputedStyle(AA);
  return {
    height: getSize("Height", gA, AA, IA),
    width: getSize("Width", gA, AA, IA)
  };
}
var classCallCheck = function(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}, createClass = /* @__PURE__ */ (function() {
  function CA(gA, AA) {
    for (var IA = 0; IA < AA.length; IA++) {
      var BA = AA[IA];
      BA.enumerable = BA.enumerable || !1, BA.configurable = !0, "value" in BA && (BA.writable = !0), Object.defineProperty(gA, BA.key, BA);
    }
  }
  return function(gA, AA, IA) {
    return AA && CA(gA.prototype, AA), IA && CA(gA, IA), gA;
  };
})(), defineProperty = function(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, {
    value: AA,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : CA[gA] = AA, CA;
}, _extends$g = Object.assign || function(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA];
    for (var IA in AA)
      Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
  }
  return CA;
};
function getClientRect(CA) {
  return _extends$g({}, CA, {
    right: CA.left + CA.width,
    bottom: CA.top + CA.height
  });
}
function getBoundingClientRect(CA) {
  var gA = {};
  try {
    if (isIE(10)) {
      gA = CA.getBoundingClientRect();
      var AA = getScroll(CA, "top"), IA = getScroll(CA, "left");
      gA.top += AA, gA.left += IA, gA.bottom += AA, gA.right += IA;
    } else
      gA = CA.getBoundingClientRect();
  } catch {
  }
  var BA = {
    left: gA.left,
    top: gA.top,
    width: gA.right - gA.left,
    height: gA.bottom - gA.top
  }, QA = CA.nodeName === "HTML" ? getWindowSizes(CA.ownerDocument) : {}, EA = QA.width || CA.clientWidth || BA.width, iA = QA.height || CA.clientHeight || BA.height, oA = CA.offsetWidth - EA, cA = CA.offsetHeight - iA;
  if (oA || cA) {
    var tA = getStyleComputedProperty(CA);
    oA -= getBordersSize$1(tA, "x"), cA -= getBordersSize$1(tA, "y"), BA.width -= oA, BA.height -= cA;
  }
  return getClientRect(BA);
}
function getOffsetRectRelativeToArbitraryNode(CA, gA) {
  var AA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, IA = isIE(10), BA = gA.nodeName === "HTML", QA = getBoundingClientRect(CA), EA = getBoundingClientRect(gA), iA = getScrollParent(CA), oA = getStyleComputedProperty(gA), cA = parseFloat(oA.borderTopWidth), tA = parseFloat(oA.borderLeftWidth);
  AA && BA && (EA.top = Math.max(EA.top, 0), EA.left = Math.max(EA.left, 0));
  var eA = getClientRect({
    top: QA.top - EA.top - cA,
    left: QA.left - EA.left - tA,
    width: QA.width,
    height: QA.height
  });
  if (eA.marginTop = 0, eA.marginLeft = 0, !IA && BA) {
    var aA = parseFloat(oA.marginTop), GA = parseFloat(oA.marginLeft);
    eA.top -= cA - aA, eA.bottom -= cA - aA, eA.left -= tA - GA, eA.right -= tA - GA, eA.marginTop = aA, eA.marginLeft = GA;
  }
  return (IA && !AA ? gA.contains(iA) : gA === iA && iA.nodeName !== "BODY") && (eA = includeScroll(eA, gA)), eA;
}
function getViewportOffsetRectRelativeToArtbitraryNode(CA) {
  var gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, AA = CA.ownerDocument.documentElement, IA = getOffsetRectRelativeToArbitraryNode(CA, AA), BA = Math.max(AA.clientWidth, window.innerWidth || 0), QA = Math.max(AA.clientHeight, window.innerHeight || 0), EA = gA ? 0 : getScroll(AA), iA = gA ? 0 : getScroll(AA, "left"), oA = {
    top: EA - IA.top + IA.marginTop,
    left: iA - IA.left + IA.marginLeft,
    width: BA,
    height: QA
  };
  return getClientRect(oA);
}
function isFixed$1(CA) {
  var gA = CA.nodeName;
  if (gA === "BODY" || gA === "HTML")
    return !1;
  if (getStyleComputedProperty(CA, "position") === "fixed")
    return !0;
  var AA = getParentNode$1(CA);
  return AA ? isFixed$1(AA) : !1;
}
function getFixedPositionOffsetParent(CA) {
  if (!CA || !CA.parentElement || isIE())
    return document.documentElement;
  for (var gA = CA.parentElement; gA && getStyleComputedProperty(gA, "transform") === "none"; )
    gA = gA.parentElement;
  return gA || document.documentElement;
}
function getBoundaries(CA, gA, AA, IA) {
  var BA = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, QA = { top: 0, left: 0 }, EA = BA ? getFixedPositionOffsetParent(CA) : findCommonOffsetParent(CA, getReferenceNode(gA));
  if (IA === "viewport")
    QA = getViewportOffsetRectRelativeToArtbitraryNode(EA, BA);
  else {
    var iA = void 0;
    IA === "scrollParent" ? (iA = getScrollParent(getParentNode$1(gA)), iA.nodeName === "BODY" && (iA = CA.ownerDocument.documentElement)) : IA === "window" ? iA = CA.ownerDocument.documentElement : iA = IA;
    var oA = getOffsetRectRelativeToArbitraryNode(iA, EA, BA);
    if (iA.nodeName === "HTML" && !isFixed$1(EA)) {
      var cA = getWindowSizes(CA.ownerDocument), tA = cA.height, eA = cA.width;
      QA.top += oA.top - oA.marginTop, QA.bottom = tA + oA.top, QA.left += oA.left - oA.marginLeft, QA.right = eA + oA.left;
    } else
      QA = oA;
  }
  AA = AA || 0;
  var aA = typeof AA == "number";
  return QA.left += aA ? AA : AA.left || 0, QA.top += aA ? AA : AA.top || 0, QA.right -= aA ? AA : AA.right || 0, QA.bottom -= aA ? AA : AA.bottom || 0, QA;
}
function getArea(CA) {
  var gA = CA.width, AA = CA.height;
  return gA * AA;
}
function computeAutoPlacement(CA, gA, AA, IA, BA) {
  var QA = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (CA.indexOf("auto") === -1)
    return CA;
  var EA = getBoundaries(AA, IA, QA, BA), iA = {
    top: {
      width: EA.width,
      height: gA.top - EA.top
    },
    right: {
      width: EA.right - gA.right,
      height: EA.height
    },
    bottom: {
      width: EA.width,
      height: EA.bottom - gA.bottom
    },
    left: {
      width: gA.left - EA.left,
      height: EA.height
    }
  }, oA = Object.keys(iA).map(function(aA) {
    return _extends$g({
      key: aA
    }, iA[aA], {
      area: getArea(iA[aA])
    });
  }).sort(function(aA, GA) {
    return GA.area - aA.area;
  }), cA = oA.filter(function(aA) {
    var GA = aA.width, lA = aA.height;
    return GA >= AA.clientWidth && lA >= AA.clientHeight;
  }), tA = cA.length > 0 ? cA[0].key : oA[0].key, eA = CA.split("-")[1];
  return tA + (eA ? "-" + eA : "");
}
function getReferenceOffsets(CA, gA, AA) {
  var IA = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, BA = IA ? getFixedPositionOffsetParent(gA) : findCommonOffsetParent(gA, getReferenceNode(AA));
  return getOffsetRectRelativeToArbitraryNode(AA, BA, IA);
}
function getOuterSizes(CA) {
  var gA = CA.ownerDocument.defaultView, AA = gA.getComputedStyle(CA), IA = parseFloat(AA.marginTop || 0) + parseFloat(AA.marginBottom || 0), BA = parseFloat(AA.marginLeft || 0) + parseFloat(AA.marginRight || 0), QA = {
    width: CA.offsetWidth + BA,
    height: CA.offsetHeight + IA
  };
  return QA;
}
function getOppositePlacement(CA) {
  var gA = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return CA.replace(/left|right|bottom|top/g, function(AA) {
    return gA[AA];
  });
}
function getPopperOffsets(CA, gA, AA) {
  AA = AA.split("-")[0];
  var IA = getOuterSizes(CA), BA = {
    width: IA.width,
    height: IA.height
  }, QA = ["right", "left"].indexOf(AA) !== -1, EA = QA ? "top" : "left", iA = QA ? "left" : "top", oA = QA ? "height" : "width", cA = QA ? "width" : "height";
  return BA[EA] = gA[EA] + gA[oA] / 2 - IA[oA] / 2, AA === iA ? BA[iA] = gA[iA] - IA[cA] : BA[iA] = gA[getOppositePlacement(iA)], BA;
}
function find$2(CA, gA) {
  return Array.prototype.find ? CA.find(gA) : CA.filter(gA)[0];
}
function findIndex$1(CA, gA, AA) {
  if (Array.prototype.findIndex)
    return CA.findIndex(function(BA) {
      return BA[gA] === AA;
    });
  var IA = find$2(CA, function(BA) {
    return BA[gA] === AA;
  });
  return CA.indexOf(IA);
}
function runModifiers(CA, gA, AA) {
  var IA = AA === void 0 ? CA : CA.slice(0, findIndex$1(CA, "name", AA));
  return IA.forEach(function(BA) {
    BA.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var QA = BA.function || BA.fn;
    BA.enabled && isFunction$1(QA) && (gA.offsets.popper = getClientRect(gA.offsets.popper), gA.offsets.reference = getClientRect(gA.offsets.reference), gA = QA(gA, BA));
  }), gA;
}
function update() {
  if (!this.state.isDestroyed) {
    var CA = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    CA.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed), CA.placement = computeAutoPlacement(this.options.placement, CA.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), CA.originalPlacement = CA.placement, CA.positionFixed = this.options.positionFixed, CA.offsets.popper = getPopperOffsets(this.popper, CA.offsets.reference, CA.placement), CA.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", CA = runModifiers(this.modifiers, CA), this.state.isCreated ? this.options.onUpdate(CA) : (this.state.isCreated = !0, this.options.onCreate(CA));
  }
}
function isModifierEnabled(CA, gA) {
  return CA.some(function(AA) {
    var IA = AA.name, BA = AA.enabled;
    return BA && IA === gA;
  });
}
function getSupportedPropertyName(CA) {
  for (var gA = [!1, "ms", "Webkit", "Moz", "O"], AA = CA.charAt(0).toUpperCase() + CA.slice(1), IA = 0; IA < gA.length; IA++) {
    var BA = gA[IA], QA = BA ? "" + BA + AA : CA;
    if (typeof document.body.style[QA] < "u")
      return QA;
  }
  return null;
}
function destroy() {
  return this.state.isDestroyed = !0, isModifierEnabled(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[getSupportedPropertyName("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function getWindow(CA) {
  var gA = CA.ownerDocument;
  return gA ? gA.defaultView : window;
}
function attachToScrollParents(CA, gA, AA, IA) {
  var BA = CA.nodeName === "BODY", QA = BA ? CA.ownerDocument.defaultView : CA;
  QA.addEventListener(gA, AA, { passive: !0 }), BA || attachToScrollParents(getScrollParent(QA.parentNode), gA, AA, IA), IA.push(QA);
}
function setupEventListeners(CA, gA, AA, IA) {
  AA.updateBound = IA, getWindow(CA).addEventListener("resize", AA.updateBound, { passive: !0 });
  var BA = getScrollParent(CA);
  return attachToScrollParents(BA, "scroll", AA.updateBound, AA.scrollParents), AA.scrollElement = BA, AA.eventsEnabled = !0, AA;
}
function enableEventListeners() {
  this.state.eventsEnabled || (this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate));
}
function removeEventListeners(CA, gA) {
  return getWindow(CA).removeEventListener("resize", gA.updateBound), gA.scrollParents.forEach(function(AA) {
    AA.removeEventListener("scroll", gA.updateBound);
  }), gA.updateBound = null, gA.scrollParents = [], gA.scrollElement = null, gA.eventsEnabled = !1, gA;
}
function disableEventListeners() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = removeEventListeners(this.reference, this.state));
}
function isNumeric(CA) {
  return CA !== "" && !isNaN(parseFloat(CA)) && isFinite(CA);
}
function setStyles(CA, gA) {
  Object.keys(gA).forEach(function(AA) {
    var IA = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(AA) !== -1 && isNumeric(gA[AA]) && (IA = "px"), CA.style[AA] = gA[AA] + IA;
  });
}
function setAttributes(CA, gA) {
  Object.keys(gA).forEach(function(AA) {
    var IA = gA[AA];
    IA !== !1 ? CA.setAttribute(AA, gA[AA]) : CA.removeAttribute(AA);
  });
}
function applyStyle(CA) {
  return setStyles(CA.instance.popper, CA.styles), setAttributes(CA.instance.popper, CA.attributes), CA.arrowElement && Object.keys(CA.arrowStyles).length && setStyles(CA.arrowElement, CA.arrowStyles), CA;
}
function applyStyleOnLoad(CA, gA, AA, IA, BA) {
  var QA = getReferenceOffsets(BA, gA, CA, AA.positionFixed), EA = computeAutoPlacement(AA.placement, QA, gA, CA, AA.modifiers.flip.boundariesElement, AA.modifiers.flip.padding);
  return gA.setAttribute("x-placement", EA), setStyles(gA, { position: AA.positionFixed ? "fixed" : "absolute" }), AA;
}
function getRoundedOffsets(CA, gA) {
  var AA = CA.offsets, IA = AA.popper, BA = AA.reference, QA = Math.round, EA = Math.floor, iA = function(hA) {
    return hA;
  }, oA = QA(BA.width), cA = QA(IA.width), tA = ["left", "right"].indexOf(CA.placement) !== -1, eA = CA.placement.indexOf("-") !== -1, aA = oA % 2 === cA % 2, GA = oA % 2 === 1 && cA % 2 === 1, lA = gA ? tA || eA || aA ? QA : EA : iA, nA = gA ? QA : iA;
  return {
    left: lA(GA && !eA && gA ? IA.left - 1 : IA.left),
    top: nA(IA.top),
    bottom: nA(IA.bottom),
    right: lA(IA.right)
  };
}
var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);
function computeStyle(CA, gA) {
  var AA = gA.x, IA = gA.y, BA = CA.offsets.popper, QA = find$2(CA.instance.modifiers, function(sA) {
    return sA.name === "applyStyle";
  }).gpuAcceleration;
  QA !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var EA = QA !== void 0 ? QA : gA.gpuAcceleration, iA = getOffsetParent(CA.instance.popper), oA = getBoundingClientRect(iA), cA = {
    position: BA.position
  }, tA = getRoundedOffsets(CA, window.devicePixelRatio < 2 || !isFirefox), eA = AA === "bottom" ? "top" : "bottom", aA = IA === "right" ? "left" : "right", GA = getSupportedPropertyName("transform"), lA = void 0, nA = void 0;
  if (eA === "bottom" ? iA.nodeName === "HTML" ? nA = -iA.clientHeight + tA.bottom : nA = -oA.height + tA.bottom : nA = tA.top, aA === "right" ? iA.nodeName === "HTML" ? lA = -iA.clientWidth + tA.right : lA = -oA.width + tA.right : lA = tA.left, EA && GA)
    cA[GA] = "translate3d(" + lA + "px, " + nA + "px, 0)", cA[eA] = 0, cA[aA] = 0, cA.willChange = "transform";
  else {
    var DA = eA === "bottom" ? -1 : 1, hA = aA === "right" ? -1 : 1;
    cA[eA] = nA * DA, cA[aA] = lA * hA, cA.willChange = eA + ", " + aA;
  }
  var wA = {
    "x-placement": CA.placement
  };
  return CA.attributes = _extends$g({}, wA, CA.attributes), CA.styles = _extends$g({}, cA, CA.styles), CA.arrowStyles = _extends$g({}, CA.offsets.arrow, CA.arrowStyles), CA;
}
function isModifierRequired(CA, gA, AA) {
  var IA = find$2(CA, function(iA) {
    var oA = iA.name;
    return oA === gA;
  }), BA = !!IA && CA.some(function(iA) {
    return iA.name === AA && iA.enabled && iA.order < IA.order;
  });
  if (!BA) {
    var QA = "`" + gA + "`", EA = "`" + AA + "`";
    console.warn(EA + " modifier is required by " + QA + " modifier in order to work, be sure to include it before " + QA + "!");
  }
  return BA;
}
function arrow(CA, gA) {
  var AA;
  if (!isModifierRequired(CA.instance.modifiers, "arrow", "keepTogether"))
    return CA;
  var IA = gA.element;
  if (typeof IA == "string") {
    if (IA = CA.instance.popper.querySelector(IA), !IA)
      return CA;
  } else if (!CA.instance.popper.contains(IA))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), CA;
  var BA = CA.placement.split("-")[0], QA = CA.offsets, EA = QA.popper, iA = QA.reference, oA = ["left", "right"].indexOf(BA) !== -1, cA = oA ? "height" : "width", tA = oA ? "Top" : "Left", eA = tA.toLowerCase(), aA = oA ? "left" : "top", GA = oA ? "bottom" : "right", lA = getOuterSizes(IA)[cA];
  iA[GA] - lA < EA[eA] && (CA.offsets.popper[eA] -= EA[eA] - (iA[GA] - lA)), iA[eA] + lA > EA[GA] && (CA.offsets.popper[eA] += iA[eA] + lA - EA[GA]), CA.offsets.popper = getClientRect(CA.offsets.popper);
  var nA = iA[eA] + iA[cA] / 2 - lA / 2, DA = getStyleComputedProperty(CA.instance.popper), hA = parseFloat(DA["margin" + tA]), wA = parseFloat(DA["border" + tA + "Width"]), sA = nA - CA.offsets.popper[eA] - hA - wA;
  return sA = Math.max(Math.min(EA[cA] - lA, sA), 0), CA.arrowElement = IA, CA.offsets.arrow = (AA = {}, defineProperty(AA, eA, Math.round(sA)), defineProperty(AA, aA, ""), AA), CA;
}
function getOppositeVariation(CA) {
  return CA === "end" ? "start" : CA === "start" ? "end" : CA;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], validPlacements = placements.slice(3);
function clockwise(CA) {
  var gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, AA = validPlacements.indexOf(CA), IA = validPlacements.slice(AA + 1).concat(validPlacements.slice(0, AA));
  return gA ? IA.reverse() : IA;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(CA, gA) {
  if (isModifierEnabled(CA.instance.modifiers, "inner") || CA.flipped && CA.placement === CA.originalPlacement)
    return CA;
  var AA = getBoundaries(CA.instance.popper, CA.instance.reference, gA.padding, gA.boundariesElement, CA.positionFixed), IA = CA.placement.split("-")[0], BA = getOppositePlacement(IA), QA = CA.placement.split("-")[1] || "", EA = [];
  switch (gA.behavior) {
    case BEHAVIORS.FLIP:
      EA = [IA, BA];
      break;
    case BEHAVIORS.CLOCKWISE:
      EA = clockwise(IA);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      EA = clockwise(IA, !0);
      break;
    default:
      EA = gA.behavior;
  }
  return EA.forEach(function(iA, oA) {
    if (IA !== iA || EA.length === oA + 1)
      return CA;
    IA = CA.placement.split("-")[0], BA = getOppositePlacement(IA);
    var cA = CA.offsets.popper, tA = CA.offsets.reference, eA = Math.floor, aA = IA === "left" && eA(cA.right) > eA(tA.left) || IA === "right" && eA(cA.left) < eA(tA.right) || IA === "top" && eA(cA.bottom) > eA(tA.top) || IA === "bottom" && eA(cA.top) < eA(tA.bottom), GA = eA(cA.left) < eA(AA.left), lA = eA(cA.right) > eA(AA.right), nA = eA(cA.top) < eA(AA.top), DA = eA(cA.bottom) > eA(AA.bottom), hA = IA === "left" && GA || IA === "right" && lA || IA === "top" && nA || IA === "bottom" && DA, wA = ["top", "bottom"].indexOf(IA) !== -1, sA = !!gA.flipVariations && (wA && QA === "start" && GA || wA && QA === "end" && lA || !wA && QA === "start" && nA || !wA && QA === "end" && DA), NA = !!gA.flipVariationsByContent && (wA && QA === "start" && lA || wA && QA === "end" && GA || !wA && QA === "start" && DA || !wA && QA === "end" && nA), rA = sA || NA;
    (aA || hA || rA) && (CA.flipped = !0, (aA || hA) && (IA = EA[oA + 1]), rA && (QA = getOppositeVariation(QA)), CA.placement = IA + (QA ? "-" + QA : ""), CA.offsets.popper = _extends$g({}, CA.offsets.popper, getPopperOffsets(CA.instance.popper, CA.offsets.reference, CA.placement)), CA = runModifiers(CA.instance.modifiers, CA, "flip"));
  }), CA;
}
function keepTogether(CA) {
  var gA = CA.offsets, AA = gA.popper, IA = gA.reference, BA = CA.placement.split("-")[0], QA = Math.floor, EA = ["top", "bottom"].indexOf(BA) !== -1, iA = EA ? "right" : "bottom", oA = EA ? "left" : "top", cA = EA ? "width" : "height";
  return AA[iA] < QA(IA[oA]) && (CA.offsets.popper[oA] = QA(IA[oA]) - AA[cA]), AA[oA] > QA(IA[iA]) && (CA.offsets.popper[oA] = QA(IA[iA])), CA;
}
function toValue(CA, gA, AA, IA) {
  var BA = CA.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), QA = +BA[1], EA = BA[2];
  if (!QA)
    return CA;
  if (EA.indexOf("%") === 0) {
    var iA = void 0;
    EA === "%p" ? iA = AA : iA = IA;
    var oA = getClientRect(iA);
    return oA[gA] / 100 * QA;
  } else if (EA === "vh" || EA === "vw") {
    var cA = void 0;
    return EA === "vh" ? cA = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : cA = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), cA / 100 * QA;
  } else
    return QA;
}
function parseOffset(CA, gA, AA, IA) {
  var BA = [0, 0], QA = ["right", "left"].indexOf(IA) !== -1, EA = CA.split(/(\+|\-)/).map(function(tA) {
    return tA.trim();
  }), iA = EA.indexOf(find$2(EA, function(tA) {
    return tA.search(/,|\s/) !== -1;
  }));
  EA[iA] && EA[iA].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var oA = /\s*,\s*|\s+/, cA = iA !== -1 ? [EA.slice(0, iA).concat([EA[iA].split(oA)[0]]), [EA[iA].split(oA)[1]].concat(EA.slice(iA + 1))] : [EA];
  return cA = cA.map(function(tA, eA) {
    var aA = (eA === 1 ? !QA : QA) ? "height" : "width", GA = !1;
    return tA.reduce(function(lA, nA) {
      return lA[lA.length - 1] === "" && ["+", "-"].indexOf(nA) !== -1 ? (lA[lA.length - 1] = nA, GA = !0, lA) : GA ? (lA[lA.length - 1] += nA, GA = !1, lA) : lA.concat(nA);
    }, []).map(function(lA) {
      return toValue(lA, aA, gA, AA);
    });
  }), cA.forEach(function(tA, eA) {
    tA.forEach(function(aA, GA) {
      isNumeric(aA) && (BA[eA] += aA * (tA[GA - 1] === "-" ? -1 : 1));
    });
  }), BA;
}
function offset(CA, gA) {
  var AA = gA.offset, IA = CA.placement, BA = CA.offsets, QA = BA.popper, EA = BA.reference, iA = IA.split("-")[0], oA = void 0;
  return isNumeric(+AA) ? oA = [+AA, 0] : oA = parseOffset(AA, QA, EA, iA), iA === "left" ? (QA.top += oA[0], QA.left -= oA[1]) : iA === "right" ? (QA.top += oA[0], QA.left += oA[1]) : iA === "top" ? (QA.left += oA[0], QA.top -= oA[1]) : iA === "bottom" && (QA.left += oA[0], QA.top += oA[1]), CA.popper = QA, CA;
}
function preventOverflow(CA, gA) {
  var AA = gA.boundariesElement || getOffsetParent(CA.instance.popper);
  CA.instance.reference === AA && (AA = getOffsetParent(AA));
  var IA = getSupportedPropertyName("transform"), BA = CA.instance.popper.style, QA = BA.top, EA = BA.left, iA = BA[IA];
  BA.top = "", BA.left = "", BA[IA] = "";
  var oA = getBoundaries(CA.instance.popper, CA.instance.reference, gA.padding, AA, CA.positionFixed);
  BA.top = QA, BA.left = EA, BA[IA] = iA, gA.boundaries = oA;
  var cA = gA.priority, tA = CA.offsets.popper, eA = {
    primary: function(GA) {
      var lA = tA[GA];
      return tA[GA] < oA[GA] && !gA.escapeWithReference && (lA = Math.max(tA[GA], oA[GA])), defineProperty({}, GA, lA);
    },
    secondary: function(GA) {
      var lA = GA === "right" ? "left" : "top", nA = tA[lA];
      return tA[GA] > oA[GA] && !gA.escapeWithReference && (nA = Math.min(tA[lA], oA[GA] - (GA === "right" ? tA.width : tA.height))), defineProperty({}, lA, nA);
    }
  };
  return cA.forEach(function(aA) {
    var GA = ["left", "top"].indexOf(aA) !== -1 ? "primary" : "secondary";
    tA = _extends$g({}, tA, eA[GA](aA));
  }), CA.offsets.popper = tA, CA;
}
function shift(CA) {
  var gA = CA.placement, AA = gA.split("-")[0], IA = gA.split("-")[1];
  if (IA) {
    var BA = CA.offsets, QA = BA.reference, EA = BA.popper, iA = ["bottom", "top"].indexOf(AA) !== -1, oA = iA ? "left" : "top", cA = iA ? "width" : "height", tA = {
      start: defineProperty({}, oA, QA[oA]),
      end: defineProperty({}, oA, QA[oA] + QA[cA] - EA[cA])
    };
    CA.offsets.popper = _extends$g({}, EA, tA[IA]);
  }
  return CA;
}
function hide(CA) {
  if (!isModifierRequired(CA.instance.modifiers, "hide", "preventOverflow"))
    return CA;
  var gA = CA.offsets.reference, AA = find$2(CA.instance.modifiers, function(IA) {
    return IA.name === "preventOverflow";
  }).boundaries;
  if (gA.bottom < AA.top || gA.left > AA.right || gA.top > AA.bottom || gA.right < AA.left) {
    if (CA.hide === !0)
      return CA;
    CA.hide = !0, CA.attributes["x-out-of-boundaries"] = "";
  } else {
    if (CA.hide === !1)
      return CA;
    CA.hide = !1, CA.attributes["x-out-of-boundaries"] = !1;
  }
  return CA;
}
function inner(CA) {
  var gA = CA.placement, AA = gA.split("-")[0], IA = CA.offsets, BA = IA.popper, QA = IA.reference, EA = ["left", "right"].indexOf(AA) !== -1, iA = ["top", "left"].indexOf(AA) === -1;
  return BA[EA ? "left" : "top"] = QA[AA] - (iA ? BA[EA ? "width" : "height"] : 0), CA.placement = getOppositePlacement(gA), CA.offsets.popper = getClientRect(BA), CA;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function CA() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function CA() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
}, Popper = (function() {
  function CA(gA, AA) {
    var IA = this, BA = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, CA), this.scheduleUpdate = function() {
      return requestAnimationFrame(IA.update);
    }, this.update = debounce(this.update.bind(this)), this.options = _extends$g({}, CA.Defaults, BA), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = gA && gA.jquery ? gA[0] : gA, this.popper = AA && AA.jquery ? AA[0] : AA, this.options.modifiers = {}, Object.keys(_extends$g({}, CA.Defaults.modifiers, BA.modifiers)).forEach(function(EA) {
      IA.options.modifiers[EA] = _extends$g({}, CA.Defaults.modifiers[EA] || {}, BA.modifiers ? BA.modifiers[EA] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(EA) {
      return _extends$g({
        name: EA
      }, IA.options.modifiers[EA]);
    }).sort(function(EA, iA) {
      return EA.order - iA.order;
    }), this.modifiers.forEach(function(EA) {
      EA.enabled && isFunction$1(EA.onLoad) && EA.onLoad(IA.reference, IA.popper, IA.options, EA, IA.state);
    }), this.update();
    var QA = this.options.eventsEnabled;
    QA && this.enableEventListeners(), this.state.eventsEnabled = QA;
  }
  return createClass(CA, [{
    key: "update",
    value: function() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), CA;
})();
Popper.Utils = (typeof window < "u" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
function toPopperPlacement(CA) {
  return CA.replace(/(Top|Left)$/, "-start").replace(/(Right|Bottom)$/, "-end");
}
function parsePopperOffset(CA) {
  return {
    top: Math.floor(CA.top || 0),
    left: Math.floor(CA.left || 0)
  };
}
var TETHER_PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
};
function _typeof$b(CA) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$b(CA);
}
var _excluded$b = ["modifiers"];
function ownKeys$h(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$f(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$h(Object(AA), !0).forEach(function(IA) {
      _defineProperty$k(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$h(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _objectWithoutProperties$d(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$d(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$d(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function _classCallCheck$9(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$9(CA, gA, AA) {
  return gA && _defineProperties$9(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$9(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$a(CA, gA);
}
function _setPrototypeOf$a(CA, gA) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$a(CA, gA);
}
function _createSuper$9(CA) {
  var gA = _isNativeReflectConstruct$9();
  return function() {
    var IA = _getPrototypeOf$9(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$9(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$9(this, BA);
  };
}
function _possibleConstructorReturn$9(CA, gA) {
  if (gA && (_typeof$b(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(CA);
}
function _assertThisInitialized$9(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$9(CA) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$9(CA);
}
function _defineProperty$k(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Tether = /* @__PURE__ */ (function(CA) {
  _inherits$9(AA, CA);
  var gA = _createSuper$9(AA);
  function AA() {
    var IA;
    _classCallCheck$9(this, AA);
    for (var BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = gA.call.apply(gA, [this].concat(QA)), _defineProperty$k(_assertThisInitialized$9(IA), "popper", void 0), _defineProperty$k(_assertThisInitialized$9(IA), "popperHeight", 0), _defineProperty$k(_assertThisInitialized$9(IA), "popperWidth", 0), _defineProperty$k(_assertThisInitialized$9(IA), "anchorHeight", 0), _defineProperty$k(_assertThisInitialized$9(IA), "anchorWidth", 0), _defineProperty$k(_assertThisInitialized$9(IA), "state", {
      isMounted: !1
    }), _defineProperty$k(_assertThisInitialized$9(IA), "onPopperUpdate", function(iA) {
      var oA = {
        popper: parsePopperOffset(iA.offsets.popper),
        arrow: iA.offsets.arrow ? parsePopperOffset(iA.offsets.arrow) : {
          top: 0,
          left: 0
        }
      };
      IA.props.onPopperUpdate(oA, iA);
    }), IA;
  }
  return _createClass$9(AA, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(BA, QA) {
      if (this.props.anchorRef) {
        var EA = this.props.anchorRef.getBoundingClientRect(), iA = EA.height, oA = EA.width;
        (this.anchorHeight !== iA || this.anchorWidth !== oA) && (this.anchorHeight = iA, this.anchorWidth = oA, this.popper && this.popper.scheduleUpdate());
      }
      if (this.props.popperRef) {
        var cA = this.props.popperRef.getBoundingClientRect(), tA = cA.height, eA = cA.width;
        (this.popperHeight !== tA || this.popperWidth !== eA) && (this.popperHeight = tA, this.popperWidth = eA, this.popper && this.popper.scheduleUpdate()), this.state.isMounted !== QA.isMounted && (this.props.anchorRef ? this.initializePopper() : process.env.NODE_ENV !== "production" && console.warn(`[baseui][TetherBehavior] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyPopover();
    }
  }, {
    key: "initializePopper",
    value: function() {
      var BA = this.props, QA = BA.placement, EA = BA.popperOptions, iA = EA.modifiers, oA = _objectWithoutProperties$d(EA, _excluded$b);
      !this.props.anchorRef || !this.props.popperRef || (this.popper = new Popper(this.props.anchorRef, this.props.popperRef, _objectSpread$f({
        // Recommended placement (popper may ignore if it causes a viewport overflow, etc)
        placement: toPopperPlacement(QA),
        modifiers: _objectSpread$f({
          // Passing the arrow ref will measure the arrow when calculating styles
          arrow: {
            element: this.props.arrowRef,
            enabled: !!this.props.arrowRef
          },
          computeStyle: {
            // Make popper use top/left instead of transform translate, this is because
            // we use transform for animations and we dont want them to conflict
            gpuAcceleration: !1
          },
          applyStyle: {
            // Disable default styling modifier, we'll apply styles on our own
            enabled: !1
          },
          applyReactStyle: {
            enabled: !0,
            fn: this.onPopperUpdate,
            order: 900
          },
          preventOverflow: {
            enabled: !0
          }
        }, iA)
      }, oA)));
    }
  }, {
    key: "destroyPopover",
    value: function() {
      this.popper && (this.popper.destroy(), delete this.popper);
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children || null;
    }
  }]), AA;
})(React.Component);
_defineProperty$k(Tether, "defaultProps", {
  anchorRef: null,
  onPopperUpdate: function CA() {
    return null;
  },
  placement: TETHER_PLACEMENT.auto,
  popperRef: null,
  popperOptions: {}
});
const layer = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Layer,
  LayersContext,
  LayersManager,
  TETHER_PLACEMENT,
  TetherBehavior: Tether
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(layer);
var hasRequiredBaseProvider;
function requireBaseProvider() {
  if (hasRequiredBaseProvider) return baseProvider;
  hasRequiredBaseProvider = 1;
  function CA(cA) {
    "@babel/helpers - typeof";
    return CA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(tA) {
      return typeof tA;
    } : function(tA) {
      return tA && typeof Symbol == "function" && tA.constructor === Symbol && tA !== Symbol.prototype ? "symbol" : typeof tA;
    }, CA(cA);
  }
  Object.defineProperty(baseProvider, "__esModule", {
    value: !0
  }), baseProvider.default = void 0;
  var gA = EA(React__default), AA = require$$1, IA = require$$2, BA = require$$0$3;
  function QA(cA) {
    if (typeof WeakMap != "function") return null;
    var tA = /* @__PURE__ */ new WeakMap(), eA = /* @__PURE__ */ new WeakMap();
    return (QA = function(GA) {
      return GA ? eA : tA;
    })(cA);
  }
  function EA(cA, tA) {
    if (cA && cA.__esModule)
      return cA;
    if (cA === null || CA(cA) !== "object" && typeof cA != "function")
      return { default: cA };
    var eA = QA(tA);
    if (eA && eA.has(cA))
      return eA.get(cA);
    var aA = {}, GA = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var lA in cA)
      if (lA !== "default" && Object.prototype.hasOwnProperty.call(cA, lA)) {
        var nA = GA ? Object.getOwnPropertyDescriptor(cA, lA) : null;
        nA && (nA.get || nA.set) ? Object.defineProperty(aA, lA, nA) : aA[lA] = cA[lA];
      }
    return aA.default = cA, eA && eA.set(cA, aA), aA;
  }
  var iA = function(tA) {
    var eA = tA.children, aA = tA.overrides, GA = tA.theme, lA = tA.zIndex;
    return /* @__PURE__ */ gA.createElement(IA.LayersManager, {
      zIndex: lA,
      overrides: aA
    }, /* @__PURE__ */ gA.createElement(AA.UIDReset, {
      prefix: "bui"
    }, /* @__PURE__ */ gA.createElement(BA.ThemeProvider, {
      theme: GA
    }, eA)));
  }, oA = iA;
  return baseProvider.default = oA, baseProvider;
}
var overrides = {}, deepMerge = {}, hasRequiredDeepMerge;
function requireDeepMerge() {
  if (hasRequiredDeepMerge) return deepMerge;
  hasRequiredDeepMerge = 1, Object.defineProperty(deepMerge, "__esModule", {
    value: !0
  }), deepMerge.default = gA;
  function CA(IA) {
    "@babel/helpers - typeof";
    return CA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(BA) {
      return typeof BA;
    } : function(BA) {
      return BA && typeof Symbol == "function" && BA.constructor === Symbol && BA !== Symbol.prototype ? "symbol" : typeof BA;
    }, CA(IA);
  }
  function gA(IA) {
    IA = IA || {};
    for (var BA = arguments.length <= 1 ? 0 : arguments.length - 1, QA, EA, iA = 0; iA < BA; iA++) {
      QA = (iA + 1 < 1 || arguments.length <= iA + 1 ? void 0 : arguments[iA + 1]) || {};
      for (var oA in QA)
        CA(QA[oA]) !== void 0 && (EA = QA[oA], AA(EA) ? IA[oA] = gA(
          /* eslint-disable-next-line no-mixed-operators */
          IA[oA] || Array.isArray(EA) && [] || {},
          EA
        ) : IA[oA] = EA);
    }
    return IA;
  }
  function AA(IA) {
    return Array.isArray(IA) || {}.toString.call(IA) == "[object Object]";
  }
  return deepMerge;
}
var hasRequiredOverrides;
function requireOverrides() {
  if (hasRequiredOverrides) return overrides;
  hasRequiredOverrides = 1, Object.defineProperty(overrides, "__esModule", {
    value: !0
  }), overrides.getOverride = eA, overrides.getOverrideProps = aA, overrides.getOverrides = lA, overrides.mergeConfigurationOverrides = hA, overrides.mergeOverride = DA, overrides.mergeOverrides = nA, overrides.toObjectOverride = GA, overrides.useOverrides = wA;
  var CA = QA(React__default), gA = requireReactIs$1(), AA = IA(/* @__PURE__ */ requireDeepMerge());
  function IA(sA) {
    return sA && sA.__esModule ? sA : { default: sA };
  }
  function BA(sA) {
    if (typeof WeakMap != "function") return null;
    var NA = /* @__PURE__ */ new WeakMap(), rA = /* @__PURE__ */ new WeakMap();
    return (BA = function(bA) {
      return bA ? rA : NA;
    })(sA);
  }
  function QA(sA, NA) {
    if (sA && sA.__esModule)
      return sA;
    if (sA === null || tA(sA) !== "object" && typeof sA != "function")
      return { default: sA };
    var rA = BA(NA);
    if (rA && rA.has(sA))
      return rA.get(sA);
    var yA = {}, bA = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var RA in sA)
      if (RA !== "default" && Object.prototype.hasOwnProperty.call(sA, RA)) {
        var FA = bA ? Object.getOwnPropertyDescriptor(sA, RA) : null;
        FA && (FA.get || FA.set) ? Object.defineProperty(yA, RA, FA) : yA[RA] = sA[RA];
      }
    return yA.default = sA, rA && rA.set(sA, yA), yA;
  }
  function EA() {
    return EA = Object.assign ? Object.assign.bind() : function(sA) {
      for (var NA = 1; NA < arguments.length; NA++) {
        var rA = arguments[NA];
        for (var yA in rA)
          Object.prototype.hasOwnProperty.call(rA, yA) && (sA[yA] = rA[yA]);
      }
      return sA;
    }, EA.apply(this, arguments);
  }
  function iA(sA, NA) {
    var rA = Object.keys(sA);
    if (Object.getOwnPropertySymbols) {
      var yA = Object.getOwnPropertySymbols(sA);
      NA && (yA = yA.filter(function(bA) {
        return Object.getOwnPropertyDescriptor(sA, bA).enumerable;
      })), rA.push.apply(rA, yA);
    }
    return rA;
  }
  function oA(sA) {
    for (var NA = 1; NA < arguments.length; NA++) {
      var rA = arguments[NA] != null ? arguments[NA] : {};
      NA % 2 ? iA(Object(rA), !0).forEach(function(yA) {
        cA(sA, yA, rA[yA]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(sA, Object.getOwnPropertyDescriptors(rA)) : iA(Object(rA)).forEach(function(yA) {
        Object.defineProperty(sA, yA, Object.getOwnPropertyDescriptor(rA, yA));
      });
    }
    return sA;
  }
  function cA(sA, NA, rA) {
    return NA in sA ? Object.defineProperty(sA, NA, { value: rA, enumerable: !0, configurable: !0, writable: !0 }) : sA[NA] = rA, sA;
  }
  function tA(sA) {
    "@babel/helpers - typeof";
    return tA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(NA) {
      return typeof NA;
    } : function(NA) {
      return NA && typeof Symbol == "function" && NA.constructor === Symbol && NA !== Symbol.prototype ? "symbol" : typeof NA;
    }, tA(sA);
  }
  function eA(sA) {
    return (0, gA.isValidElementType)(sA) ? sA : sA && tA(sA) === "object" ? sA.component : sA;
  }
  function aA(sA) {
    return sA && tA(sA) === "object" ? tA(sA.props) === "object" ? oA(oA({}, sA.props), {}, {
      $style: sA.style
    }) : {
      $style: sA.style
    } : {};
  }
  function GA(sA) {
    return (0, gA.isValidElementType)(sA) ? {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      component: sA
    } : sA || {};
  }
  function lA(sA, NA) {
    var rA = eA(sA) || NA;
    if (sA && tA(sA) === "object" && typeof sA.props == "function") {
      process.env.NODE_ENV !== "production" && console.warn("baseui:Overrides Props as a function will be removed in the next major version. Override the whole component instead. See https://baseweb.design/guides/understanding-overrides/#override-the-entire-subcomponent");
      var yA = /* @__PURE__ */ CA.forwardRef(function(RA, FA) {
        var dA = sA.props(RA), kA = aA(oA(oA({}, sA), {}, {
          props: dA
        }));
        return /* @__PURE__ */ CA.createElement(rA, EA({
          ref: FA
        }, kA));
      });
      return yA.displayName = rA.displayName, [yA, {}];
    }
    var bA = aA(sA);
    return [rA, bA];
  }
  function nA() {
    var sA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, NA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, rA = Object.assign({}, sA, NA), yA = Object.keys(rA);
    return yA.reduce(function(bA, RA) {
      return bA[RA] = DA(GA(sA[RA]), GA(NA[RA])), bA;
    }, {});
  }
  function DA(sA, NA) {
    var rA = oA(oA({}, sA), NA);
    return sA.props && NA.props && (rA.props = hA(sA.props, NA.props)), sA.style && NA.style && (rA.style = hA(sA.style, NA.style)), rA;
  }
  function hA(sA, NA) {
    return tA(sA) === "object" && tA(NA) === "object" ? (0, AA.default)({}, sA, NA) : function() {
      return (0, AA.default)({}, typeof sA == "function" ? sA.apply(void 0, arguments) : sA, typeof NA == "function" ? NA.apply(void 0, arguments) : NA);
    };
  }
  function wA(sA) {
    var NA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return CA.useMemo(function() {
      return Object.keys(sA).reduce(function(rA, yA) {
        return rA[yA] = lA(NA[yA], sA[yA]), rA;
      }, {});
    }, [NA]);
  }
  return overrides;
}
var hasRequiredBaseui;
function requireBaseui() {
  return hasRequiredBaseui || (hasRequiredBaseui = 1, (function(CA) {
    Object.defineProperty(CA, "__esModule", {
      value: !0
    }), Object.defineProperty(CA, "BaseProvider", {
      enumerable: !0,
      get: function() {
        return BA.default;
      }
    }), Object.defineProperty(CA, "DarkTheme", {
      enumerable: !0,
      get: function() {
        return AA.DarkTheme;
      }
    }), Object.defineProperty(CA, "DarkThemeMove", {
      enumerable: !0,
      get: function() {
        return AA.DarkThemeMove;
      }
    }), Object.defineProperty(CA, "LightTheme", {
      enumerable: !0,
      get: function() {
        return AA.LightTheme;
      }
    }), Object.defineProperty(CA, "LightThemeMove", {
      enumerable: !0,
      get: function() {
        return AA.LightThemeMove;
      }
    }), Object.defineProperty(CA, "LocaleProvider", {
      enumerable: !0,
      get: function() {
        return IA.default;
      }
    }), Object.defineProperty(CA, "ThemeConsumer", {
      enumerable: !0,
      get: function() {
        return gA.ThemeConsumer;
      }
    }), Object.defineProperty(CA, "ThemeProvider", {
      enumerable: !0,
      get: function() {
        return gA.ThemeProvider;
      }
    }), Object.defineProperty(CA, "createDarkTheme", {
      enumerable: !0,
      get: function() {
        return AA.createDarkTheme;
      }
    }), Object.defineProperty(CA, "createLightTheme", {
      enumerable: !0,
      get: function() {
        return AA.createLightTheme;
      }
    }), Object.defineProperty(CA, "createTheme", {
      enumerable: !0,
      get: function() {
        return AA.createTheme;
      }
    }), Object.defineProperty(CA, "createThemedStyled", {
      enumerable: !0,
      get: function() {
        return gA.createThemedStyled;
      }
    }), Object.defineProperty(CA, "createThemedUseStyletron", {
      enumerable: !0,
      get: function() {
        return gA.createThemedUseStyletron;
      }
    }), Object.defineProperty(CA, "createThemedWithStyle", {
      enumerable: !0,
      get: function() {
        return gA.createThemedWithStyle;
      }
    }), Object.defineProperty(CA, "darkThemeOverrides", {
      enumerable: !0,
      get: function() {
        return AA.darkThemeOverrides;
      }
    }), Object.defineProperty(CA, "darkThemePrimitives", {
      enumerable: !0,
      get: function() {
        return AA.darkThemePrimitives;
      }
    }), Object.defineProperty(CA, "getOverrides", {
      enumerable: !0,
      get: function() {
        return QA.getOverrides;
      }
    }), Object.defineProperty(CA, "lightThemePrimitives", {
      enumerable: !0,
      get: function() {
        return AA.lightThemePrimitives;
      }
    }), Object.defineProperty(CA, "mergeOverrides", {
      enumerable: !0,
      get: function() {
        return QA.mergeOverrides;
      }
    }), Object.defineProperty(CA, "styled", {
      enumerable: !0,
      get: function() {
        return gA.styled;
      }
    }), Object.defineProperty(CA, "useStyletron", {
      enumerable: !0,
      get: function() {
        return gA.useStyletron;
      }
    }), Object.defineProperty(CA, "withStyle", {
      enumerable: !0,
      get: function() {
        return gA.withStyle;
      }
    }), Object.defineProperty(CA, "withWrapper", {
      enumerable: !0,
      get: function() {
        return gA.withWrapper;
      }
    });
    var gA = require$$0$3, AA = require$$1$1, IA = EA(require$$2$1), BA = EA(/* @__PURE__ */ requireBaseProvider()), QA = /* @__PURE__ */ requireOverrides();
    function EA(iA) {
      return iA && iA.__esModule ? iA : { default: iA };
    }
  })(baseui)), baseui;
}
var baseuiExports = /* @__PURE__ */ requireBaseui();
const baseuiCjs = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null
}, [baseuiExports]), {
  createTheme: createBaseTheme,
  lightThemePrimitives: lightBaseThemePrimitives
} = baseuiCjs, createBaseUiThemePrimitives = (CA, gA) => {
  const {
    colors: AA,
    genericFonts: IA
  } = gA;
  return {
    ...CA,
    primaryFontFamily: IA.bodyFont,
    primary100: AA.primary,
    primary200: AA.primary,
    primary300: AA.primary,
    primary400: AA.primary,
    primary500: AA.primary,
    primary600: AA.primary,
    primary700: AA.primary,
    // Override gray values based on what is actually used in BaseWeb, and the
    // way we want it to match our theme originating from Bootstrap.
    mono100: AA.bgColor,
    // Popup menu
    mono200: AA.secondaryBg,
    // Text input, text area, selectbox
    mono300: AA.gray30,
    // Disabled widget background
    mono400: AA.gray30,
    // Slider track
    mono500: AA.gray60,
    // Clicked checkbox and radio
    mono600: AA.fadedText40,
    // Disabled widget text
    mono700: AA.gray60,
    // Unselected checkbox and radio
    mono800: AA.bodyText,
    // Selectbox text
    mono900: AA.bodyText,
    // Not used, but just in case.
    mono1000: AA.black
  };
}, createBaseUiThemeOverrides = (CA) => {
  const {
    inSidebar: gA,
    colors: AA,
    genericFonts: IA,
    fontSizes: BA,
    lineHeights: QA,
    radii: EA
  } = CA, iA = {
    fontFamily: IA.bodyFont,
    fontSize: BA.md,
    fontSizeSm: BA.sm,
    fontWeight: "normal",
    lineHeight: QA.base,
    lineHeightTight: QA.tight
  }, oA = AA.secondaryBg, cA = gA ? AA.secondaryBg : AA.bgColor, tA = gA ? AA.bgColor : AA.secondaryBg;
  return {
    borders: {
      // Override borders that are declared from literals in
      // https://github.com/uber/baseweb/blob/master/src/themes/shared/borders.ts
      radius100: EA.default,
      radius200: EA.default,
      radius300: EA.default,
      radius400: EA.default,
      radius500: EA.default,
      /** Datepicker (Range), Progress Bar, Slider, Tag */
      useRoundedCorners: !0,
      /** Button, ButtonGroup */
      buttonBorderRadiusMini: EA.sm,
      // Unused today.
      buttonBorderRadius: EA.default,
      /** Checkbox */
      checkboxBorderRadius: `min(${EA.sm}, ${EA.maxCheckbox})`,
      /** Input, Select, Textarea */
      inputBorderRadiusMini: EA.sm,
      // Unused today.
      inputBorderRadius: EA.default,
      /** Popover, Menu, Tooltip */
      popoverBorderRadius: EA.default,
      /** Card, Datepicker, Modal, Toast, Notification */
      surfaceBorderRadius: EA.default,
      /** Tag */
      tagBorderRadius: EA.sm
    },
    typography: {
      // Here we override some fonts that are used in widgets. We don't care
      // about the ones that are not used.
      font100: {},
      font150: {
        ...iA
      },
      // Popup menus
      font200: {},
      font250: {},
      font300: {
        ...iA
      },
      // Popup menus
      font350: {
        ...iA
      },
      // Checkbox
      font400: {
        ...iA
      },
      // Textinput, textarea, selectboxes
      font450: {
        ...iA
      },
      // Radio
      font460: {
        ...iA
      },
      // Calendar header buttons
      font470: {
        ...iA
      },
      // Button
      font500: {
        ...iA
      },
      // Selected items in selectbox
      font600: {},
      LabelXSmall: {
        ...iA
      },
      LabelSmall: {
        ...iA
      },
      LabelMedium: {
        ...iA
      },
      LabelLarge: {
        ...iA
      },
      ParagraphSmall: {
        ...iA
      }
    },
    colors: {
      white: AA.white,
      black: AA.black,
      primary: AA.primary,
      primaryA: AA.primary,
      backgroundPrimary: AA.bgColor,
      backgroundSecondary: oA,
      backgroundTertiary: AA.bgColor,
      borderOpaque: AA.darkenedBgMix25,
      accent: transparentize(AA.primary, 0.5),
      tagPrimarySolidBackground: AA.primary,
      tagPrimaryFontDisabled: AA.fadedText40,
      tagPrimaryOutlinedDisabled: AA.transparent,
      borderSelected: AA.primary,
      contentPrimary: AA.bodyText,
      inputPlaceholder: AA.fadedText60,
      tickFillDisabled: AA.fadedText40,
      tickMarkFill: AA.gray20,
      tickFillSelected: AA.primary,
      datepickerBackground: cA,
      calendarBackground: cA,
      calendarForeground: AA.bodyText,
      calendarDayForegroundPseudoSelected: AA.bodyText,
      calendarHeaderBackground: tA,
      calendarHeaderBackgroundActive: tA,
      calendarHeaderForeground: AA.bodyText,
      calendarHeaderForegroundDisabled: AA.gray40,
      calendarDayBackgroundSelected: AA.primary,
      calendarDayBackgroundSelectedHighlighted: AA.primary,
      calendarDayForegroundSelected: AA.white,
      calendarDayForegroundSelectedHighlighted: AA.white,
      calendarDayForegroundPseudoSelectedHighlighted: AA.bodyText,
      menuFontHighlighted: AA.bodyText,
      menuFontSelected: AA.bodyText,
      modalCloseColor: AA.bodyText,
      notificationInfoBackground: AA.blueBackgroundColor,
      notificationInfoText: AA.blueTextColor,
      notificationPositiveBackground: AA.greenBackgroundColor,
      notificationPositiveText: AA.greenTextColor,
      notificationWarningBackground: AA.yellowBackgroundColor,
      notificationWarningText: AA.yellowTextColor,
      notificationNegativeBackground: AA.redBackgroundColor,
      notificationNegativeText: AA.redTextColor,
      progressbarTrackFill: oA,
      // mono100 overrides
      tickFill: AA.lightenedBg05,
      // Checkbox and Radio
      tickMarkFillDisabled: AA.lightenedBg05,
      // We want menuFill to always use bgColor. But when in sidebar, bgColor and secondaryBg are
      // swapped! So here we unswap them.
      menuFill: cA,
      // mono200 overrides
      buttonDisabledFill: AA.lightenedBg05,
      tickFillHover: oA,
      inputFillDisabled: oA,
      inputFillActive: oA,
      // mono300 overrides
      toggleTrackFillDisabled: oA,
      tickFillActive: oA,
      sliderTrackFillDisabled: oA,
      inputBorder: AA.widgetBorderColor || oA,
      inputFill: oA,
      inputEnhanceFill: oA,
      inputEnhancerFillDisabled: oA,
      // mono400 overrides
      buttonDisabledSpinnerBackground: AA.gray40,
      toggleTrackFill: AA.gray40,
      sliderTrackFill: AA.gray40,
      sliderHandleInnerFill: AA.gray40,
      sliderHandleInnerFillDisabled: AA.gray40
    }
  };
}, createBaseUiTheme = (CA, gA = lightBaseThemePrimitives) => createBaseTheme(createBaseUiThemePrimitives(gA, CA), createBaseUiThemeOverrides(CA)), NAMED_COLOR_CONFIG = {
  red: {
    colorKey: "redColor",
    bgColorKey: "redBackgroundColor"
  },
  orange: {
    colorKey: "orangeColor",
    bgColorKey: "orangeBackgroundColor"
  },
  yellow: {
    colorKey: "yellowColor",
    bgColorKey: "yellowBackgroundColor"
  },
  green: {
    colorKey: "greenColor",
    bgColorKey: "greenBackgroundColor"
  },
  blue: {
    colorKey: "blueColor",
    bgColorKey: "blueBackgroundColor"
  },
  violet: {
    colorKey: "violetColor",
    bgColorKey: "violetBackgroundColor"
  },
  gray: {
    colorKey: "grayColor",
    bgColorKey: "grayBackgroundColor"
  },
  grey: {
    colorKey: "grayColor",
    bgColorKey: "grayBackgroundColor"
  },
  // alias
  primary: {
    colorKey: "primary",
    bgColorKey: null
  }
  // primary bg is computed
}, BACKGROUND_ONLY_COLORS = {
  purple: {
    bgColorKey: "purplebg"
  }
  // distinct from violet
}, NAMED_COLORS = new Set(Object.keys(NAMED_COLOR_CONFIG));
function isNamedColor(CA) {
  return typeof CA == "string" && NAMED_COLORS.has(CA.toLowerCase());
}
const computeDerivedColors = (CA) => {
  const {
    bodyText: gA,
    secondaryBg: AA,
    bgColor: IA
  } = CA, BA = getLuminance(IA) > 0.5, QA = transparentize(gA, 0.9), EA = transparentize(gA, 0.8), iA = transparentize(gA, 0.7), oA = transparentize(gA, 0.6), cA = transparentize(gA, 0.4), tA = mix(IA, AA, 0.5), eA = BA ? darken(tA, 0.3) : lighten(tA, 0.6), aA = transparentize(eA, 0.75), GA = transparentize(eA, 0.85), lA = lighten(IA, 0.025);
  return {
    fadedText05: QA,
    fadedText10: EA,
    fadedText20: iA,
    fadedText40: oA,
    fadedText60: cA,
    bgMix: tA,
    darkenedBgMix100: eA,
    darkenedBgMix25: aA,
    darkenedBgMix15: GA,
    lightenedBg05: lA
  };
};
function _isLightBackground(CA) {
  return getLuminance(CA) > 0.5;
}
function hasLightBackgroundColor(CA) {
  return _isLightBackground(CA.colors.bgColor);
}
const createEmotionColors = (CA) => {
  const gA = computeDerivedColors(CA), AA = defaultCategoricalColorsArray(CA), IA = defaultSequentialColorsArray(CA), BA = defaultDivergingColorsArray(CA);
  return {
    ...CA,
    ...gA,
    link: CA.blueTextColor,
    codeTextColor: CA.greenTextColor,
    codeBackgroundColor: gA.bgMix,
    borderColor: gA.fadedText10,
    borderColorLight: gA.fadedText05,
    dataframeBorderColor: gA.fadedText05,
    dataframeHeaderBackgroundColor: gA.bgMix,
    headingColor: CA.bodyText,
    chartCategoricalColors: AA,
    chartSequentialColors: IA,
    chartDivergingColors: BA
  };
};
function getDividerColors(CA) {
  const {
    redColor: gA,
    orangeColor: AA,
    yellowColor: IA,
    blueColor: BA,
    greenColor: QA,
    violetColor: EA,
    grayColor: iA
  } = CA.colors;
  return {
    red: gA,
    orange: AA,
    yellow: IA,
    blue: BA,
    green: QA,
    violet: EA,
    gray: iA,
    grey: iA,
    rainbow: `linear-gradient(to right, ${gA}, ${AA}, ${IA}, ${QA}, ${BA}, ${EA})`
  };
}
function getThemeBackgroundColors(CA) {
  const gA = hasLightBackgroundColor(CA), AA = CA.colors;
  return {
    redbg: AA.redBackgroundColor,
    orangebg: AA.orangeBackgroundColor,
    yellowbg: AA.yellowBackgroundColor,
    bluebg: AA.blueBackgroundColor,
    greenbg: AA.greenBackgroundColor,
    violetbg: AA.violetBackgroundColor,
    purplebg: transparentize(AA[gA ? "purple90" : "purple80"], gA ? 0.9 : 0.7),
    graybg: AA.grayBackgroundColor,
    primarybg: transparentize(AA.primary, gA ? 0.9 : 0.7)
  };
}
function getMarkdownTextColors(CA) {
  const gA = hasLightBackgroundColor(CA), AA = CA.colors, IA = AA.primary, BA = AA.redTextColor, QA = AA.orangeTextColor, EA = AA.yellowTextColor, iA = AA.blueTextColor, oA = AA.greenTextColor, cA = AA.violetTextColor, tA = gA ? AA.purple100 : AA.purple80, eA = AA.grayTextColor;
  return {
    red: BA,
    orange: QA,
    yellow: EA,
    green: oA,
    blue: iA,
    violet: cA,
    purple: tA,
    gray: eA,
    primary: IA
  };
}
function getGray70(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.gray70 : CA.colors.gray30;
}
function getGray30(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.gray30 : CA.colors.gray85;
}
function getGray90(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.gray90 : CA.colors.gray10;
}
function getBlue80(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.blue80 : CA.colors.blue40;
}
function getBlueArrayAsc(CA) {
  return [CA.blue10, CA.blue20, CA.blue30, CA.blue40, CA.blue50, CA.blue60, CA.blue70, CA.blue80, CA.blue90, CA.blue100];
}
function getBlueArrayDesc(CA) {
  return [CA.blue100, CA.blue90, CA.blue80, CA.blue70, CA.blue60, CA.blue50, CA.blue40, CA.blue30, CA.blue20, CA.blue10];
}
function defaultDivergingColorsArray(CA) {
  return [CA.red100, CA.red90, CA.red70, CA.red50, CA.red30, CA.blue30, CA.blue50, CA.blue70, CA.blue90, CA.blue100];
}
function defaultSequentialColorsArray(CA) {
  return _isLightBackground(CA.bgColor) ? getBlueArrayAsc(CA) : getBlueArrayDesc(CA);
}
function defaultCategoricalColorsArray(CA) {
  return _isLightBackground(CA.bgColor) ? [CA.blue80, CA.blue40, CA.red80, CA.red40, CA.blueGreen80, CA.green40, CA.orange80, CA.orange50, CA.purple80, CA.gray40] : [CA.blue40, CA.blue80, CA.red40, CA.red80, CA.green40, CA.blueGreen80, CA.orange50, CA.orange80, CA.purple80, CA.gray40];
}
function getDecreasingRed(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.red80 : CA.colors.red40;
}
function getIncreasingGreen(CA) {
  return hasLightBackgroundColor(CA) ? CA.colors.blueGreen80 : CA.colors.green40;
}
const namedColorCache = /* @__PURE__ */ new WeakMap(), namedBgColorCache = /* @__PURE__ */ new WeakMap();
function getNamedColorMap(CA) {
  let gA = namedColorCache.get(CA);
  if (!gA) {
    gA = /* @__PURE__ */ new Map();
    for (const [AA, IA] of Object.entries(NAMED_COLOR_CONFIG)) {
      const BA = CA.colors[IA.colorKey];
      typeof BA == "string" && gA.set(AA, BA);
    }
    namedColorCache.set(CA, gA);
  }
  return gA;
}
function getNamedBgColorMap(CA) {
  let gA = namedBgColorCache.get(CA);
  if (!gA) {
    const AA = getThemeBackgroundColors(CA);
    gA = /* @__PURE__ */ new Map();
    for (const [IA, BA] of Object.entries(NAMED_COLOR_CONFIG))
      if (BA.bgColorKey) {
        const QA = CA.colors[BA.bgColorKey];
        typeof QA == "string" && gA.set(IA, QA);
      }
    gA.set("primary", AA.primarybg);
    for (const [IA, BA] of Object.entries(BACKGROUND_ONLY_COLORS)) {
      const QA = AA[BA.bgColorKey];
      typeof QA == "string" && gA.set(IA, QA);
    }
    namedBgColorCache.set(CA, gA);
  }
  return gA;
}
function resolveNamedColor(CA, gA) {
  return getNamedColorMap(gA).get(CA.toLowerCase()) ?? CA;
}
function resolveNamedBackgroundColor(CA, gA) {
  return getNamedBgColorMap(gA).get(CA.toLowerCase()) ?? CA;
}
const elevationShadows$1 = {
  tooltip: "0px 1px 4px rgba(0, 0, 0, 0.16)",
  popover: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  toolbar: "1px 2px 8px rgba(0, 0, 0, 0.08)",
  sidebar: "-2rem 0 2rem 2rem rgba(0, 0, 0, 0.16)",
  none: "none"
}, elevationShadows = {
  tooltip: "0px 1px 4px rgba(0, 0, 0, 0.4)",
  popover: "0px 4px 16px rgba(0, 0, 0, 0.7)",
  toolbar: "1px 2px 8px rgba(0, 0, 0, 0.2)",
  sidebar: "-2rem 0 2rem 2rem rgba(0, 0, 0, 0.4)",
  none: "none"
}, spacing = {
  px: "1px",
  none: "0",
  threeXS: "0.125rem",
  // 2px
  twoXS: "0.25rem",
  // 4px
  xs: "0.375rem",
  // 6px
  sm: "0.5rem",
  // 8px
  md: "0.75rem",
  // 12px
  lg: "1rem",
  // 16px
  xl: "1.25rem",
  // 20px
  twoXL: "1.5rem",
  // 24px
  threeXL: "2rem",
  // 32px
  fourXL: "4rem",
  // 64px
  fiveXL: "6rem",
  // 96px
  sixXL: "8rem"
  // 128px
}, minElementHeight = "2.5rem", borderWidth = "1px", sizes = {
  full: "100%",
  headerHeight: "3.75rem",
  // Old header height to avoid addtl cascading visual/snapshot changes
  fullScreenHeaderHeight: "2.875rem",
  sidebarTopSpace: "6rem",
  toastWidth: "21rem",
  // Use px here since we want to keep the width the same
  // regardless of the root font size.
  contentMaxWidth: "736px",
  maxChartTooltipWidth: "30rem",
  // Used for checkboxes, radio, and toggles:
  checkbox: "1rem",
  borderWidth,
  // Used for checkboxes/toggle
  smallElementHeight: "1.5rem",
  // min height used for most input widgets
  minElementHeight,
  // Height for hover/focus highlights inside input widgets (e.g., dropdown items)
  // Calculated as: minElementHeight - 2 * spacing.xs (vertical padding)
  elementHighlightHeight: `calc(${minElementHeight} - 2 * ${spacing.xs})`,
  tagMarginInsideBorder: `calc(${spacing.xs} - ${borderWidth})`,
  // min height for larger input widgets like text area and audio input
  largestElementHeight: "4.25rem",
  smallLogoHeight: "1.25rem",
  defaultLogoHeight: "1.5rem",
  largeLogoHeight: "2rem",
  sliderThumb: "0.75rem",
  wideSidePadding: "5rem",
  headerDecorationHeight: "0.125rem",
  appMainMenu: "12rem",
  appRunningMen: "1.6rem",
  appStatusMaxWidth: "20rem",
  tableColumnMaxWidth: "25rem",
  spinnerSize: "1.375rem",
  spinnerThickness: "0.125rem",
  tabHeight: "2.5rem",
  // Min width used for popover and dialog:
  minPopupWidth: "20rem",
  maxTooltipHeight: "18.75rem",
  chatAvatarSize: "2rem",
  // Used for the clear icon used by some Input elements
  clearIconSize: "1.5em",
  numberInputControlsWidth: "2rem",
  emptyDropdownHeight: "5.625rem",
  dropdownItemHeight: "2.5rem",
  maxDropdownHeight: "18.75rem",
  appDefaultBottomPadding: "3.5rem",
  defaultMapHeight: "31.25rem",
  defaultChartHeight: "21.875rem",
  defaultChartWidth: "25rem",
  // The minimum width of the menu (used for the dataframe column menu)
  minMenuWidth: "8rem",
  minChatInputFileListHeight: "3rem",
  uploadedFileIconSize: "2rem",
  headerItemHeight: "1.75rem",
  headerRightContentMaxWidth: "12.5rem",
  chatInputTextareaMinHeight: "1.5rem",
  chatInputPrimaryButtonSize: "2rem",
  // Offset to vertically center button with textarea text in simple mode
  // (3px margin the bottom with flex-end to center by default but keep it at the bottom)
  chatInputButtonVerticalOffset: "0.1875rem",
  dialogLargeWidth: "80rem",
  defaultStrokeWidth: 2.25,
  metricStrokeWidth: 2,
  // Default for box-shadow focus ring width
  focusRingWidth: "0.2rem",
  fileChipNameMinWidth: "4.875rem"
}, createShadows = (CA) => {
  const gA = getLuminance(CA.bgColor) > 0.5, AA = gA ? elevationShadows$1 : elevationShadows, IA = sizes.focusRingWidth, BA = gA ? CA.gray90 : CA.gray10;
  return {
    ...AA,
    // Primary focus ring - buttons, checkboxes, sliders, inputs
    focusRing: `0 0 0 ${IA} ${transparentize(CA.primary, 0.5)}`,
    // Subtle focus ring - CodeBlock copy button
    focusRingSubtle: `0 0 0 ${IA} ${transparentize(CA.darkenedBgMix25, 0.5)}`,
    // Solid outline focus ring - FileUploader dropzone
    focusRingOutline: `0 0 0 1px ${CA.primary}`,
    // Muted focus ring - header link buttons
    focusRingMuted: `0 0 0 ${IA} ${transparentize(BA, 0.8)}`
  };
}, fonts = {
  sansSerif: '"Source Sans", sans-serif',
  monospace: '"Source Code Pro", monospace',
  serif: '"Source Serif", serif',
  materialIcons: "Material Symbols Rounded"
}, genericFonts = {
  bodyFont: fonts.sansSerif,
  codeFont: fonts.monospace,
  headingFont: fonts.sansSerif,
  iconFont: fonts.materialIcons
}, fontSizes = {
  // baseFontSize equals to md, but in pixels (this value can also be configured by the user)
  // The baseFontSize should only be used in global styles.
  baseFontSize: 16,
  twoSm: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  mdLg: "1.125rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.75rem",
  threeXL: "2.25rem",
  fourXL: "2.75rem",
  codeFontSize: "0.875rem",
  // Inline code font size as em value for proper scaling w/ headers, captions,
  // sidebar, etc.
  inlineCodeFontSize: "0.75em",
  // Header font sizes - unaffected by baseFontSize, configured via headingFontSizes
  h1FontSize: "2.75rem",
  h2FontSize: "2.25rem",
  h3FontSize: "1.75rem",
  h4FontSize: "1.5rem",
  h5FontSize: "1.25rem",
  h6FontSize: "1rem",
  metricValueFontSize: "2.25rem"
}, fontWeights = {
  normal: 400,
  semiBold: 500,
  bold: 600,
  extrabold: 700,
  // codeFontWeight separately configurable
  code: 400,
  codeBold: 600,
  codeExtraBold: 700,
  // baseFontWeight config does not affect headers
  // defaults set here for h1-h6
  h1FontWeight: 700,
  h2FontWeight: 600,
  h3FontWeight: 600,
  h4FontWeight: 600,
  h5FontWeight: 600,
  h6FontWeight: 600,
  metricValueFontWeight: 400
}, lineHeights = {
  none: 1,
  headings: 1.2,
  tight: 1.25,
  inputWidget: 1.4,
  small: 1.5,
  base: 1.6,
  menuItem: 2
};
var BaseProvider = function CA(gA) {
  var AA = gA.children, IA = gA.overrides, BA = gA.theme, QA = gA.zIndex;
  return /* @__PURE__ */ React.createElement(LayersManager, {
    zIndex: QA,
    overrides: IA
  }, /* @__PURE__ */ React.createElement(UIDReset, {
    prefix: "bui"
  }, /* @__PURE__ */ React.createElement(ThemeProvider$1, {
    theme: BA
  }, AA)));
};
const breakpoints = {
  // This value is used to determine whether we should hide/show the "Please enter to apply" in all widgets.
  hideWidgetDetails: "11.25rem",
  // 180px at 16px base
  // This value is used to determine whether we should hide/show the - and + buttons in st.number_input.
  hideNumberInputControls: "7.5rem",
  // 120px at 16px base
  sm: "576px",
  columns: "640px",
  md: "768px"
}, iconSizes = {
  xs: "0.5rem",
  sm: "0.75rem",
  md: "0.9rem",
  base: "1rem",
  lg: "1.25rem",
  xl: "1.5rem",
  twoXL: "1.8rem",
  threeXL: "2.3rem"
}, radii = {
  sm: "0.25rem",
  // Used for dropdown item highlights:
  md2: "0.375rem",
  // This is the default radius used in most elements:
  default: "0.5rem",
  xl: "0.75rem",
  xxl: "1rem",
  // Radius specific to buttons (enables buttonRadius config):
  button: "0.5rem",
  // Chat input enforces a more rounded look:
  chatInput: "1.25rem",
  // Ensures that the element is fully rounded:
  full: "9999px",
  // The maximum radius for checkboxes to still be recognizable as a checkbox:
  maxCheckbox: "0.35rem"
}, sidebar = 100, menuButton = sidebar + 10, balloons = 1e6, header = balloons - 10, bottom = sidebar - 1, sidebarMobile = balloons - 5, fullscreenWrapper = balloons + 50, headerDecoration = balloons - 1, popup = fullscreenWrapper + 10, tablePortal = fullscreenWrapper + 60, cacheSpinner = sidebar + 1, toast = popup + 1, zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  // this is used if we want to ensure that an element
  // is shown above the parent elements.
  priority: 1,
  sidebar,
  menuButton,
  balloons,
  header,
  sidebarMobile,
  popup,
  fullscreenWrapper,
  tablePortal,
  bottom,
  cacheSpinner,
  toast,
  headerDecoration
}, colors$2 = {
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f0f2f6",
  gray30: "#e6eaf1",
  gray40: "#d5dae5",
  gray50: "#bfc5d3",
  gray60: "#a3a8b8",
  gray70: "#808495",
  gray80: "#555867",
  gray85: "#31333F",
  gray90: "#262730",
  gray100: "#0e1117",
  red10: "#fff0f0",
  red20: "#ffdede",
  red30: "#ffc7c7",
  red40: "#ffabab",
  red50: "#ff8c8c",
  red60: "#ff6c6c",
  red70: "#ff4b4b",
  red80: "#ff2b2b",
  red90: "#bd4043",
  red100: "#7d353b",
  orange10: "#fffae8",
  orange20: "#fff6d0",
  orange30: "#ffecb0",
  orange40: "#ffe08e",
  orange50: "#ffd16a",
  orange60: "#ffbd45",
  orange70: "#ffa421",
  orange80: "#ff8700",
  orange90: "#ed6f13",
  orange95: "#e2660c",
  orange100: "#d95a00",
  yellow10: "#ffffe1",
  yellow20: "#ffffc2",
  yellow30: "#ffffa0",
  yellow40: "#ffff7d",
  yellow50: "#ffff59",
  yellow60: "#fff835",
  yellow65: "#ffff12",
  yellow70: "#ffe312",
  yellow80: "#faca2b",
  yellow90: "#edbb16",
  yellow100: "#dea816",
  yellow110: "#916e10",
  yellow115: "#926c05",
  green10: "#dffde9",
  green20: "#c0fcd3",
  green30: "#9ef6bb",
  green40: "#7defa1",
  green50: "#5ce488",
  green60: "#3dd56d",
  green70: "#21c354",
  green80: "#09ab3b",
  green90: "#158237",
  green100: "#177233",
  blueGreen10: "#dcfffb",
  blueGreen20: "#bafff7",
  blueGreen30: "#93ffee",
  blueGreen40: "#6bfde3",
  blueGreen50: "#45f4d5",
  blueGreen60: "#20e7c5",
  blueGreen70: "#00d4b1",
  blueGreen80: "#29b09d",
  blueGreen90: "#2c867c",
  blueGreen100: "#246e69",
  lightBlue10: "#e0feff",
  lightBlue20: "#bffdff",
  lightBlue30: "#9af8ff",
  lightBlue40: "#73efff",
  lightBlue50: "#4be4ff",
  lightBlue60: "#24d4ff",
  lightBlue70: "#00c0f2",
  lightBlue80: "#00a4d4",
  lightBlue90: "#0d8cb5",
  lightBlue100: "#15799e",
  blue10: "#e4f5ff",
  blue20: "#c7ebff",
  blue30: "#a6dcff",
  blue40: "#83c9ff",
  blue50: "#60b4ff",
  blue60: "#3d9df3",
  blue65: "#1c83ff",
  blue70: "#1c83e1",
  blue80: "#0068c9",
  blue90: "#0054a3",
  blue100: "#004280",
  purple10: "#f5ebff",
  purple20: "#ebd6ff",
  purple30: "#dbbbff",
  purple40: "#c89dff",
  purple50: "#b27eff",
  purple60: "#9a5dff",
  purple70: "#803df5",
  purple80: "#6d3fc0",
  purple90: "#583f84",
  purple100: "#3f3163"
}, requiredThemeColors = {
  bgColor: colors$2.white,
  secondaryBg: colors$2.gray20,
  bodyText: colors$2.gray85,
  primary: colors$2.red70,
  secondary: colors$2.blue70,
  // Used in progress bar
  // Default main theme colors (light theme)
  redColor: colors$2.red70,
  orangeColor: colors$2.orange70,
  yellowColor: colors$2.yellow80,
  blueColor: colors$2.blue70,
  greenColor: colors$2.green70,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray60,
  // Default background theme colors (light theme)
  redBackgroundColor: transparentize(colors$2.red80, 0.9),
  orangeBackgroundColor: transparentize(colors$2.orange70, 0.9),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.9),
  blueBackgroundColor: transparentize(colors$2.blue65, 0.9),
  greenBackgroundColor: transparentize(colors$2.green70, 0.9),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.9),
  grayBackgroundColor: transparentize(colors$2.gray85, 0.9),
  // Default text theme colors (light theme)
  redTextColor: colors$2.red90,
  orangeTextColor: colors$2.orange95,
  yellowTextColor: colors$2.yellow115,
  blueTextColor: colors$2.blue90,
  greenTextColor: colors$2.green90,
  violetTextColor: colors$2.purple90,
  grayTextColor: transparentize(colors$2.gray85, 0.4)
}, optionalThemeColors = {}, themeColors = {
  ...colors$2,
  ...requiredThemeColors,
  ...optionalThemeColors
}, colors$1 = createEmotionColors(themeColors), shadows$1 = createShadows(colors$1), emotionBaseTheme = {
  inSidebar: !1,
  showSidebarBorder: !1,
  linkUnderline: !0,
  breakpoints,
  colors: colors$1,
  fonts,
  fontSizes,
  fontWeights,
  genericFonts,
  iconSizes,
  lineHeights,
  radii,
  shadows: shadows$1,
  sizes,
  spacing,
  zIndices
}, genericColors = {
  ...colors$2,
  bgColor: colors$2.gray100,
  bodyText: colors$2.gray10,
  primary: colors$2.red70,
  secondaryBg: colors$2.gray90,
  // Default main theme colors (dark theme)
  redColor: colors$2.red80,
  orangeColor: colors$2.orange80,
  yellowColor: colors$2.yellow70,
  blueColor: colors$2.blue80,
  greenColor: colors$2.green80,
  violetColor: colors$2.purple70,
  grayColor: colors$2.gray80,
  // Default background theme colors (dark theme)
  redBackgroundColor: transparentize(colors$2.red60, 0.8),
  orangeBackgroundColor: transparentize(colors$2.orange80, 0.8),
  yellowBackgroundColor: transparentize(colors$2.yellow65, 0.8),
  blueBackgroundColor: transparentize(colors$2.blue60, 0.8),
  greenBackgroundColor: transparentize(colors$2.green60, 0.8),
  violetBackgroundColor: transparentize(colors$2.purple60, 0.8),
  grayBackgroundColor: transparentize(colors$2.gray70, 0.8),
  // Default text theme colors (dark theme)
  redTextColor: colors$2.red60,
  orangeTextColor: colors$2.orange60,
  yellowTextColor: colors$2.yellow20,
  blueTextColor: colors$2.blue60,
  greenTextColor: colors$2.green50,
  violetTextColor: colors$2.purple50,
  grayTextColor: transparentize(colors$2.gray10, 0.4)
}, colors = createEmotionColors({
  ...emotionBaseTheme.colors,
  ...genericColors
}), shadows = createShadows(colors), emotionDarkTheme = {
  ...emotionBaseTheme,
  inSidebar: !1,
  colors,
  shadows
}, emotionLightTheme = {
  ...emotionBaseTheme,
  inSidebar: !1
}, baseuiLightTheme = createBaseUiTheme(emotionLightTheme, primitives), baseuiDarkTheme = createBaseUiTheme(emotionDarkTheme, primitives$1), baseTheme = {
  name: "base",
  emotion: emotionBaseTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, darkTheme = {
  name: "Dark",
  emotion: emotionDarkTheme,
  basewebTheme: baseuiDarkTheme,
  primitives: primitives$1
}, lightTheme = {
  name: "Light",
  emotion: emotionLightTheme,
  basewebTheme: baseuiLightTheme,
  primitives
}, AUTO_THEME_NAME = "Use system setting", CUSTOM_THEME_NAME = "Custom Theme", CUSTOM_THEME_LIGHT_NAME = "Custom Theme Light", CUSTOM_THEME_DARK_NAME = "Custom Theme Dark", CUSTOM_THEME_AUTO_NAME = "Custom Theme Auto", LOG$e = loglevelExports.getLogger("theme:utils");
function sortThemeInputKeys(CA) {
  if (CA == null)
    return CA;
  if (Array.isArray(CA))
    return CA.map((gA) => sortThemeInputKeys(gA));
  if (typeof CA == "object") {
    const gA = {};
    return Object.keys(CA).sort().forEach((AA) => {
      gA[AA] = sortThemeInputKeys(CA[AA]);
    }), gA;
  }
  return CA;
}
function mergeTheme(CA, gA) {
  if (gA && isObject$3(gA)) {
    const AA = new CustomThemeConfig(gA);
    return createTheme(CA.name, AA, CA);
  }
  return CA;
}
const getMergedLightTheme = once$1(() => mergeTheme(lightTheme, StreamlitConfig.LIGHT_THEME)), getMergedDarkTheme = once$1(() => mergeTheme(darkTheme, StreamlitConfig.DARK_THEME)), getSystemThemePreference = () => window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", getSystemTheme = () => getSystemThemePreference() === "dark" ? getMergedDarkTheme() : getMergedLightTheme(), createAutoTheme = () => ({
  ...getSystemTheme(),
  name: AUTO_THEME_NAME
}), createPresetThemes = () => [createAutoTheme(), getMergedLightTheme(), getMergedDarkTheme()], isPresetTheme = (CA) => createPresetThemes().map((AA) => AA.name).includes(CA.name), bgColorToBaseString = (CA) => CA === void 0 || getLuminance(CA) > 0.5 ? "light" : "dark", isColor = (CA) => {
  const gA = new Option().style;
  return gA.color = CA, gA.color !== "";
}, roundFontSizeToNearestEighth = (CA) => Math.round(CA * 8) / 8, parseFont = (CA, gA = fonts.sansSerif) => {
  const AA = CA.trim();
  if (!AA)
    return gA;
  const IA = {
    "sans-serif": fonts.sansSerif,
    serif: fonts.serif,
    monospace: fonts.monospace
  }, BA = AA.toLowerCase().replaceAll(" ", "-");
  return BA in IA ? IA[BA] : `${AA}, ${gA}`;
}, parseColor = (CA, gA, AA = !1) => {
  if (isColor(CA))
    return CA;
  if (isColor(`#${CA}`))
    return `#${CA}`;
  if (gA.toLowerCase().includes("color")) {
    const BA = AA ? "theme.sidebar" : "theme";
    LOG$e.warn(`Invalid color passed for ${gA} in ${BA}: "${CA}"`);
  }
}, resolveBgColor = (CA, gA, AA, IA) => CA || (gA ? transparentize(gA, IA ? 0.9 : 0.8) : AA), resolveTextColor = (CA, gA, AA, IA) => CA || (gA ? IA ? darken(gA, 0.15) : lighten(gA, 0.15) : AA), setBackgroundColors = (CA, gA) => {
  const AA = {
    ...CA
  }, IA = {
    redBackgroundColor: {
      main: gA.redColor,
      background: gA.redBackgroundColor
    },
    orangeBackgroundColor: {
      main: gA.orangeColor,
      background: gA.orangeBackgroundColor
    },
    yellowBackgroundColor: {
      main: gA.yellowColor,
      background: gA.yellowBackgroundColor
    },
    blueBackgroundColor: {
      main: gA.blueColor,
      background: gA.blueBackgroundColor
    },
    greenBackgroundColor: {
      main: gA.greenColor,
      background: gA.greenBackgroundColor
    },
    violetBackgroundColor: {
      main: gA.violetColor,
      background: gA.violetBackgroundColor
    },
    grayBackgroundColor: {
      main: gA.grayColor,
      background: gA.grayBackgroundColor
    }
  }, BA = getLuminance(AA.bgColor) > 0.5;
  return Object.entries(IA).forEach(([QA, {
    main: EA,
    background: iA
  }]) => {
    const oA = QA;
    AA[oA] = resolveBgColor(iA, EA, CA[oA], BA);
  }), AA;
}, setTextColors = (CA, gA) => {
  const AA = {
    ...CA
  }, IA = {
    redTextColor: {
      main: gA.redColor,
      text: gA.redTextColor
    },
    orangeTextColor: {
      main: gA.orangeColor,
      text: gA.orangeTextColor
    },
    yellowTextColor: {
      main: gA.yellowColor,
      text: gA.yellowTextColor
    },
    blueTextColor: {
      main: gA.blueColor,
      text: gA.blueTextColor
    },
    greenTextColor: {
      main: gA.greenColor,
      text: gA.greenTextColor
    },
    violetTextColor: {
      main: gA.violetColor,
      text: gA.violetTextColor
    },
    grayTextColor: {
      main: gA.grayColor,
      text: gA.grayTextColor
    }
  }, BA = getLuminance(AA.bgColor) > 0.5;
  return Object.entries(IA).forEach(([QA, {
    main: EA,
    text: iA
  }]) => {
    const oA = QA;
    AA[oA] = resolveTextColor(iA, EA, CA[oA], BA);
  }), AA;
}, parseRadius = (CA) => {
  let gA = "rem", AA;
  const IA = CA.trim().toLowerCase();
  return IA === "none" ? AA = 0 : IA === "small" ? AA = 0.35 : IA === "medium" ? AA = 0.5 : IA === "large" ? AA = 1 : IA === "full" ? AA = 1.4 : IA.endsWith("rem") ? AA = parseFloat(IA) : IA.endsWith("px") ? (AA = parseFloat(IA), gA = "px") : isNaN(parseFloat(IA)) || (AA = parseFloat(IA), gA = "px"), [AA, gA];
}, parseFontSize = (CA, gA, AA) => {
  const IA = AA ? "theme.sidebar" : "theme";
  if (typeof gA == "string") {
    const BA = gA.trim().toLowerCase(), QA = parseFloat(BA);
    if (QA && (BA.endsWith("rem") || BA.endsWith("px")))
      return BA;
    if (QA.toString() === BA)
      return `${BA}px`;
  }
  LOG$e.warn(`Invalid size passed for ${CA} in ${IA}: ${gA}. Falling back to default ${CA}.`);
}, isValidFontWeight = (CA, gA, AA, IA, BA) => {
  const QA = BA ? "theme.sidebar" : "theme";
  if (notNullOrUndefined(gA)) {
    const EA = Number.isInteger(gA), iA = gA % 100 === 0, oA = gA >= AA && gA <= IA;
    return !EA || !iA || !oA ? (LOG$e.warn(`Invalid ${CA}: ${gA} in ${QA}. The ${CA} must be an integer ${AA}-${IA}, and an increment of 100. Falling back to default font weight.`), !1) : !0;
  }
  return !1;
}, convertHeadingFontSizeToRem = (CA, gA, AA, IA) => {
  const BA = parseFontSize(CA, gA, IA);
  if (BA?.endsWith("rem"))
    return BA;
  if (BA?.endsWith("px"))
    return `${parseFloat(BA) / AA}rem`;
}, setHeadingFontSizes = (CA, gA, AA, IA) => {
  const BA = {
    ...CA
  };
  return IA && IA.forEach((QA, EA) => {
    const iA = `h${EA + 1}FontSize`, oA = convertHeadingFontSizeToRem(`${iA} in headingFontSizes`, QA, AA, gA);
    oA && (BA[iA] = oA);
  }), BA;
}, setFontWeights = (CA, gA, AA, IA, BA) => {
  const QA = {
    ...CA,
    // Override default h1FontWeight for sidebar to 600
    // Default for main theme set in typography (700)
    h1FontWeight: gA ? 600 : CA.h1FontWeight
  };
  return AA && isValidFontWeight("baseFontWeight", AA, 100, 600) && (QA.normal = AA, QA.semiBold = AA + 100, QA.bold = AA + 200, QA.extrabold = AA + 300, QA.code = AA, QA.codeBold = AA + 200, QA.codeExtraBold = AA + 300), IA && isValidFontWeight("codeFontWeight", IA, 100, 600) && (QA.code = IA, QA.codeBold = IA + 200, QA.codeExtraBold = IA + 300), BA && BA.forEach((EA, iA) => {
    const oA = `h${iA + 1}FontWeight`;
    isValidFontWeight(`${oA} in headingFontWeights`, EA, 100, 900, gA) && (QA[oA] = EA);
  }), QA;
}, validateChartColors = (CA, gA) => gA.map((AA) => parseColor(AA, CA)).filter((AA) => AA !== void 0), createEmotionTheme = (CA, gA = baseTheme) => {
  const {
    colors: AA,
    genericFonts: IA,
    inSidebar: BA
  } = gA.emotion, {
    baseFontSize: QA,
    baseFontWeight: EA,
    baseRadius: iA,
    buttonRadius: oA,
    codeFontSize: cA,
    codeFontWeight: tA,
    showWidgetBorder: eA,
    headingFont: aA,
    headingFontSizes: GA,
    headingFontWeights: lA,
    bodyFont: nA,
    codeFont: DA,
    showSidebarBorder: hA,
    linkUnderline: wA,
    // Since chart color configs passed as array, handle separate from parsedColors
    chartCategoricalColors: sA,
    chartSequentialColors: NA,
    chartDivergingColors: rA,
    // Metric value styling
    metricValueFontSize: yA,
    metricValueFontWeight: bA,
    ...RA
  } = CA, FA = Object.entries(RA).reduce((II, [vA, wI]) => {
    const $A = parseColor(wI, vA, BA);
    return $A && (II[vA] = $A), II;
  }, {}), {
    secondaryBackgroundColor: dA,
    backgroundColor: kA,
    primaryColor: pA,
    textColor: YA,
    dataframeBorderColor: SA,
    dataframeHeaderBackgroundColor: JA,
    borderColor: UA,
    linkColor: fA,
    codeTextColor: zA,
    codeBackgroundColor: _A,
    redColor: uA,
    orangeColor: HA,
    yellowColor: TA,
    blueColor: ZA,
    greenColor: AI,
    violetColor: QI,
    grayColor: LA
  } = FA, PA = {
    ...AA,
    primary: pA ?? AA.primary,
    bodyText: YA ?? AA.bodyText,
    secondaryBg: dA ?? AA.secondaryBg,
    bgColor: kA ?? AA.bgColor,
    // Main theme colors
    redColor: uA ?? AA.redColor,
    orangeColor: HA ?? AA.orangeColor,
    yellowColor: TA ?? AA.yellowColor,
    blueColor: ZA ?? AA.blueColor,
    greenColor: AI ?? AA.greenColor,
    violetColor: QI ?? AA.violetColor,
    grayColor: LA ?? AA.grayColor,
    // Secondary color is not yet configurable. Set secondary color to primary color
    // by default for all custom themes.
    secondary: pA ?? AA.primary
  }, XA = {
    colors: {
      ...createEmotionColors(PA)
    },
    showSidebarBorder: hA ?? gA.emotion.showSidebarBorder,
    linkUnderline: wA ?? gA.emotion.linkUnderline,
    // Copy over the default values for the other configurable theme properties
    radii: {
      ...gA.emotion.radii
    },
    fontSizes: {
      ...gA.emotion.fontSizes
    },
    fontWeights: {
      ...gA.emotion.fontWeights
    }
  };
  if (XA.colors.codeBackgroundColor = _A ?? AA.codeBackgroundColor, XA.colors.dataframeHeaderBackgroundColor = JA ?? AA.dataframeHeaderBackgroundColor, notNullOrUndefined(UA)) {
    XA.colors.borderColor = UA;
    const II = transparentize(UA, 0.55);
    XA.colors.borderColorLight = II, XA.colors.dataframeBorderColor = II;
  }
  if (notNullOrUndefined(SA) && (XA.colors.dataframeBorderColor = SA), eA && (XA.colors.widgetBorderColor = XA.colors.borderColor), XA.colors = setBackgroundColors(XA.colors, FA), XA.colors = setTextColors(XA.colors, FA), XA.colors.link = fA ?? XA.colors.blueTextColor, XA.colors.codeTextColor = zA ?? XA.colors.greenTextColor, notNullOrUndefined(sA) && sA.length > 0) {
    const II = validateChartColors("chartCategoricalColors", sA);
    II.length > 0 && (XA.colors.chartCategoricalColors = II);
  }
  if (notNullOrUndefined(NA) && NA.length > 0) {
    const II = validateChartColors("chartSequentialColors", NA);
    II.length === 10 ? XA.colors.chartSequentialColors = II : LOG$e.warn(`Invalid chartSequentialColors: ${NA.toString()}. Falling back to default chartSequentialColors.`);
  }
  if (notNullOrUndefined(rA) && rA.length > 0) {
    const II = validateChartColors("chartDivergingColors", rA);
    II.length === 10 ? XA.colors.chartDivergingColors = II : LOG$e.warn(`Invalid chartDivergingColors: ${rA.toString()}. Falling back to default chartDivergingColors.`);
  }
  if (notNullOrUndefined(iA)) {
    const [II, vA] = parseRadius(iA);
    if (notNullOrUndefined(II) && !isNaN(II)) {
      const wI = addCssUnit(II, vA);
      XA.radii.default = wI, XA.radii.button = wI, XA.radii.sm = addCssUnit(roundToTwoDecimals(II * 0.5), vA), XA.radii.md2 = addCssUnit(roundToTwoDecimals(II * 0.75), vA), XA.radii.xl = addCssUnit(roundToTwoDecimals(II * 1.5), vA), XA.radii.xxl = addCssUnit(roundToTwoDecimals(II * 2), vA);
    } else
      LOG$e.warn(`Invalid base radius: ${iA}. Falling back to default base radius.`);
  }
  if (notNullOrUndefined(oA)) {
    const [II, vA] = parseRadius(oA);
    notNullOrUndefined(II) && !isNaN(II) ? XA.radii.button = addCssUnit(II, vA) : LOG$e.warn(`Invalid button radius: ${oA}. Falling back to default button radius.`);
  }
  if (QA && QA > 0 && (XA.fontSizes.baseFontSize = QA), cA) {
    const II = parseFontSize("codeFontSize", cA, BA);
    II && (XA.fontSizes.codeFontSize = II);
  }
  if (XA.fontSizes = setHeadingFontSizes(XA.fontSizes, BA, XA.fontSizes.baseFontSize, GA), yA) {
    const II = parseFontSize("metricValueFontSize", yA, BA);
    II && (parseFloat(II) <= 0 ? LOG$e.warn(`Invalid metricValueFontSize: ${yA} in theme. The metricValueFontSize must be greater than 0. Falling back to default metricValueFontSize.`) : XA.fontSizes.metricValueFontSize = II);
  }
  XA.fontWeights = setFontWeights(gA.emotion.fontWeights, BA, EA, tA, lA), bA && (bA >= 100 && bA <= 900 ? XA.fontWeights.metricValueFontWeight = bA : LOG$e.warn(`Invalid metricValueFontWeight: ${bA}. Must be between 100 and 900.`));
  const EI = {
    // Default values for the generic fonts
    ...IA,
    // Override properties if configured
    bodyFont: nA ? parseFont(nA, fonts.sansSerif) : IA.bodyFont,
    codeFont: DA ? parseFont(DA, fonts.monospace) : IA.codeFont,
    headingFont: aA ? parseFont(aA, fonts.sansSerif) : IA.headingFont
  };
  nA && !aA && (EI.headingFont = parseFont(nA, fonts.sansSerif));
  const CI = createShadows(XA.colors);
  return {
    ...gA.emotion,
    genericFonts: EI,
    ...XA,
    shadows: CI
  };
}, toThemeInput = (CA) => {
  const {
    colors: gA
  } = CA;
  return {
    primaryColor: gA.primary,
    backgroundColor: gA.bgColor,
    secondaryBackgroundColor: gA.secondaryBg,
    textColor: gA.bodyText,
    bodyFont: CA.genericFonts.bodyFont
  };
}, toExportedTheme = (CA) => {
  const {
    colors: gA
  } = CA, AA = toThemeInput(CA);
  return {
    primaryColor: AA.primaryColor,
    backgroundColor: AA.backgroundColor,
    secondaryBackgroundColor: AA.secondaryBackgroundColor,
    textColor: AA.textColor,
    bodyFont: AA.bodyFont,
    base: bgColorToBaseString(AA.backgroundColor),
    ...computeDerivedColors(gA)
  };
}, completeThemeInput = (CA, gA) => new CustomThemeConfig({
  ...toThemeInput(gA.emotion),
  ...CA
}), createTheme = (CA, gA, AA, IA = !1) => {
  let BA;
  AA ? BA = completeThemeInput(gA, AA) : gA.base === CustomThemeConfig.BaseTheme.DARK ? BA = completeThemeInput(gA, darkTheme) : BA = completeThemeInput(gA, lightTheme);
  const QA = BA.backgroundColor, EA = merge$1(cloneDeep(AA || (getLuminance(QA) > 0.5 ? lightTheme : darkTheme)), {
    emotion: {
      inSidebar: IA
    }
  }), iA = createEmotionTheme(BA, EA), oA = cloneDeep(createBaseUiTheme(iA, EA.primitives));
  return {
    ...EA,
    name: CA,
    emotion: iA,
    basewebTheme: oA,
    themeInput: gA
  };
}, deleteOldCachedThemes = () => {
  const {
    CACHED_THEME_VERSION: CA,
    CACHED_THEME_BASE_KEY: gA
  } = LocalStore, {
    localStorage: AA
  } = window;
  AA.removeItem("stActiveTheme"), AA.removeItem(gA);
  for (let IA = 1; IA < CA; IA++)
    AA.removeItem(`${gA}-v${IA}`);
}, getThemeSelectionFromThemeConfig = (CA) => CA.name === AUTO_THEME_NAME || CA.name === CUSTOM_THEME_AUTO_NAME ? "System" : CA.name === lightTheme.name || CA.name === CUSTOM_THEME_LIGHT_NAME ? "Light" : CA.name === darkTheme.name || CA.name === CUSTOM_THEME_DARK_NAME ? "Dark" : (CA.name === CUSTOM_THEME_NAME, "System"), isThemeSelection = (CA) => CA === "System" || CA === "Light" || CA === "Dark", getCachedThemeSelection = () => {
  if (!localStorageAvailable())
    return null;
  deleteOldCachedThemes();
  const CA = window.localStorage.getItem(LocalStore.ACTIVE_THEME);
  if (!CA)
    return null;
  const gA = JSON.parse(CA);
  return isThemeSelection(gA) ? gA : null;
}, setCachedThemeSelection = (CA) => {
  if (!localStorageAvailable() || (deleteOldCachedThemes(), isLightThemeInQueryParams() || isDarkThemeInQueryParams()))
    return;
  const gA = getThemeSelectionFromThemeConfig(CA);
  window.localStorage.setItem(LocalStore.ACTIVE_THEME, JSON.stringify(gA));
}, getHostSpecifiedThemeOnly = () => isLightThemeInQueryParams() ? getMergedLightTheme() : isDarkThemeInQueryParams() ? getMergedDarkTheme() : null, getHostSpecifiedTheme = () => getHostSpecifiedThemeOnly() ?? createAutoTheme(), getDefaultTheme = () => {
  const CA = getHostSpecifiedThemeOnly();
  if (CA)
    return CA;
  const gA = getCachedThemeSelection();
  return gA === "Light" ? getMergedLightTheme() : gA === "Dark" ? getMergedDarkTheme() : createAutoTheme();
}, whiteSpace = /\s+/;
function computeSpacingStyle(CA, gA) {
  return CA === "" ? "" : CA.split(whiteSpace).map((AA) => AA === "0" ? gA.spacing.none : AA in gA.spacing ? gA.spacing[AA] : (LOG$e.error(`Invalid spacing value: ${AA}`), gA.spacing.none)).join(" ");
}
function addCssUnit(CA, gA) {
  return `${CA}${gA}`;
}
function roundToTwoDecimals(CA) {
  return parseFloat(CA.toFixed(2));
}
function blend(CA, gA) {
  if (gA === void 0) return CA;
  const [AA, IA, BA, QA] = parseToRgba(CA);
  if (QA === 1) return CA;
  const [EA, iA, oA, cA] = parseToRgba(gA), tA = QA + cA * (1 - QA), eA = Math.round((QA * AA + cA * EA * (1 - QA)) / tA), aA = Math.round((QA * IA + cA * iA * (1 - QA)) / tA), GA = Math.round((QA * BA + cA * oA * (1 - QA)) / tA);
  return toHex(`rgba(${eA}, ${aA}, ${GA}, ${tA})`);
}
const convertRemToPx = (CA) => (
  // TODO(lukasmasuch): We might want to somehow cache this value at some point.
  // However, I did experimented with the performance of calling this, and
  // it seems not like a big deal to call it many times.
  parseFloat(CA.replace(/rem$/, "")) * // We fallback to 16px if the fontSize is not defined (should only happen in tests)
  (parseFloat(getComputedStyle(document.documentElement).fontSize) || 16)
), skipProtobufDefaults = (CA, gA) => {
  if (gA === "" || gA === null || Array.isArray(gA) && gA.length === 0)
    return CA;
}, handleSectionInheritance = (CA, gA) => {
  const AA = gA === "light", IA = AA ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK, {
    light: BA,
    dark: QA,
    sidebar: EA,
    ...iA
  } = CA, oA = AA ? BA : QA, {
    sidebar: cA,
    ...tA
  } = oA || {}, eA = mergeWith(
    {},
    iA,
    // Common theme properties from themeInput
    tA,
    // Variant-specific theme overrides (without sidebar)
    {
      base: IA
    },
    // Set base last to override any base from commonTheme/variantTheme
    skipProtobufDefaults
  );
  return (EA || cA) && (eA.sidebar = mergeWith({}, EA, cA, skipProtobufDefaults)), eA;
}, hasThemeSectionConfigs = (CA) => {
  if (!CA)
    return !1;
  const gA = (AA) => AA == null ? !1 : Array.isArray(AA) ? AA.length > 0 : typeof AA == "object" ? Object.values(AA).some(gA) : !0;
  return Object.values(CA).some(gA);
}, createCustomThemes = (CA) => {
  const gA = hasThemeSectionConfigs(CA.light), AA = hasThemeSectionConfigs(CA.dark), IA = [];
  if (gA || AA) {
    const BA = handleSectionInheritance(CA, "light"), QA = {
      ...createTheme(CUSTOM_THEME_LIGHT_NAME, BA),
      displayName: "Light"
    }, EA = handleSectionInheritance(CA, "dark"), iA = {
      ...createTheme(CUSTOM_THEME_DARK_NAME, EA),
      displayName: "Dark"
    }, cA = {
      ...getSystemThemePreference() === "dark" ? iA : QA,
      displayName: AUTO_THEME_NAME,
      name: CUSTOM_THEME_AUTO_NAME
    };
    IA.push(QA, iA, cA);
  } else {
    const BA = createTheme(CUSTOM_THEME_NAME, CA);
    IA.push(BA);
  }
  return IA;
}, setSidebarHeadingFontSizes = (CA) => merge$1([], ["1.5rem", "1.25rem", "1.125rem", "1rem", "0.875rem", "0.75rem"], CA || []), createSidebarTheme = (CA) => {
  const gA = CA.themeInput?.sidebar, {
    bgColor: AA,
    secondaryBg: IA
  } = CA.emotion.colors, BA = gA?.backgroundColor || IA, QA = gA?.secondaryBackgroundColor || AA, EA = setSidebarHeadingFontSizes(gA?.headingFontSizes);
  let iA = getLuminance(BA) > 0.5 ? CustomThemeConfig.BaseTheme.LIGHT : CustomThemeConfig.BaseTheme.DARK;
  CA.name === CUSTOM_THEME_LIGHT_NAME ? iA = CustomThemeConfig.BaseTheme.LIGHT : CA.name === CUSTOM_THEME_DARK_NAME && (iA = CustomThemeConfig.BaseTheme.DARK);
  const oA = mergeWith(
    {},
    CA.themeInput,
    // Use the theme props from the main theme as basis
    gA,
    // Merge sidebar configs
    {
      // Explicit overrides that should always be applied
      base: iA,
      backgroundColor: BA,
      secondaryBackgroundColor: QA,
      headingFontSizes: EA
    },
    skipProtobufDefaults
  );
  return createTheme(
    "Sidebar",
    oA,
    void 0,
    // Creating a new theme from scratch
    !0
    // inSidebar
  );
}, mapCachedThemeSelectionToAvailableTheme = (CA, gA) => {
  if (!CA)
    return null;
  const AA = {
    System: [CUSTOM_THEME_AUTO_NAME, AUTO_THEME_NAME, CUSTOM_THEME_NAME],
    Light: [CUSTOM_THEME_LIGHT_NAME, lightTheme.name],
    Dark: [CUSTOM_THEME_DARK_NAME, darkTheme.name]
  };
  for (const IA of AA[CA]) {
    const BA = gA.find((QA) => QA.name === IA);
    if (BA)
      return BA;
  }
  return null;
}, getPreferredTheme = (CA) => {
  const gA = getHostSpecifiedThemeOnly(), IA = (gA ? getThemeSelectionFromThemeConfig(gA) : null) ?? getCachedThemeSelection();
  return mapCachedThemeSelectionToAvailableTheme(IA, CA);
}, isPositiveNumber = (CA) => typeof CA == "number" && CA >= 0 && !isNaN(CA), isNonZeroPositiveNumber = (CA) => typeof CA == "number" && CA > 0 && !isNaN(CA), getWidth = (CA, gA) => {
  if (gA?.useContainerWidth)
    return {
      type: "stretch"
      /* STRETCH */
    };
  const AA = CA.widthConfig?.useStretch || gA?.widthConfig?.useStretch, IA = CA?.widthConfig?.useContent || gA?.widthConfig?.useContent, BA = CA?.widthConfig?.pixelWidth || gA?.widthConfig?.pixelWidth || CA.widthConfig?.pixelWidth === 0, QA = CA.widthConfig?.remWidth;
  return AA ? {
    type: "stretch"
    /* STRETCH */
  } : IA ? {
    type: "content"
    /* CONTENT */
  } : QA && isPositiveNumber(CA.widthConfig?.remWidth) ? {
    type: "rem",
    rem: CA.widthConfig.remWidth
  } : BA && isPositiveNumber(CA.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: CA.widthConfig.pixelWidth
  } : BA && isPositiveNumber(gA?.widthConfig?.pixelWidth) ? {
    type: "pixel",
    pixels: gA.widthConfig.pixelWidth
  } : isNonZeroPositiveNumber(gA?.width) && !CA.widthConfig ? {
    type: "pixel",
    pixels: gA.width
  } : {
    type: "auto"
    /* AUTO */
  };
}, getHeight = (CA, gA) => {
  const AA = !!CA.heightConfig?.useStretch, IA = !!CA.heightConfig?.useContent, BA = !!CA.heightConfig?.pixelHeight || CA.heightConfig?.pixelHeight === 0, QA = CA.heightConfig?.remHeight;
  return AA ? {
    type: "stretch"
    /* STRETCH */
  } : IA ? {
    type: "content"
    /* CONTENT */
  } : QA && isPositiveNumber(CA.heightConfig?.remHeight) ? {
    type: "rem",
    rem: CA.heightConfig.remHeight
  } : BA && isPositiveNumber(CA.heightConfig?.pixelHeight) ? {
    type: "pixel",
    pixels: CA.heightConfig.pixelHeight
  } : isNonZeroPositiveNumber(gA?.height) && !CA.heightConfig ? {
    type: "pixel",
    pixels: gA.height
  } : {
    type: "auto"
    /* AUTO */
  };
}, getFlex = (CA, gA, AA, IA) => {
  if (AA === Direction.HORIZONTAL)
    switch (CA.type) {
      case "pixel":
        return `0 0 ${CA.pixels}px`;
      case "rem":
        return `0 0 ${CA.rem}rem`;
      case "content":
        return "0 0 fit-content";
      case "stretch":
        return `1 1 ${IA ?? "fit-content"}`;
      case "auto":
        return;
      default:
        assertNever(CA);
    }
  else if (AA === Direction.VERTICAL)
    switch (gA.type) {
      case "pixel":
        return `0 0 ${gA.pixels}px`;
      case "rem":
        return `0 0 ${gA.rem}rem`;
      case "content":
      case "stretch":
      case "auto":
        return;
      default:
        assertNever(gA);
    }
}, getDirection = (CA) => CA?.direction, calculateMinWidthWithParentConstraint = (CA, gA, AA = 32) => {
  if (gA === void 0 || CA === void 0 || CA === "fit-content")
    return CA;
  const IA = convertRemToPx(CA);
  return gA < IA && gA > AA ? `${gA - AA}px` : CA;
}, useLayoutStyles = ({
  element: CA,
  subElement: gA,
  styleOverrides: AA,
  minStretchBehavior: IA
}) => {
  const BA = useContext(FlexContext);
  return useMemo$1(() => {
    if (!CA)
      return {
        width: "auto",
        height: "auto",
        overflow: "visible"
      };
    const EA = getWidth(CA, gA);
    let iA, oA;
    switch (EA.type) {
      case "stretch":
        iA = "100%";
        break;
      case "rem":
        iA = `${EA.rem}rem`;
        break;
      case "pixel":
        iA = `${EA.pixels}px`;
        break;
      case "content":
        iA = "fit-content";
        break;
      case "auto":
        iA = "auto";
        break;
      default:
        assertNever(EA);
    }
    const cA = getDirection(BA);
    BA?.isInContentWidthContainer && EA.type === "stretch" && IA !== void 0 && (oA = calculateMinWidthWithParentConstraint(IA, BA?.parentWidth));
    const tA = getHeight(CA, gA);
    let eA, aA = "visible";
    switch (tA.type) {
      case "stretch":
        eA = "100%";
        break;
      case "content":
        eA = "auto";
        break;
      case "rem":
        eA = `${tA.rem}rem`;
        break;
      case "pixel":
        eA = `${tA.pixels}px`, aA = "auto";
        break;
      case "auto":
        eA = "auto";
        break;
      default:
        assertNever(tA);
    }
    const GA = getFlex(EA, tA, cA, IA), lA = getTextAlignmentStyle("textAlignmentConfig" in CA ? CA.textAlignmentConfig : void 0);
    return {
      ...{
        width: iA,
        height: eA,
        overflow: aA,
        flex: GA,
        minWidth: oA,
        textAlign: lA
      },
      ...AA
    };
  }, [CA, gA, AA, BA, IA]);
};
var ScriptRunState = /* @__PURE__ */ ((CA) => (CA.NOT_RUNNING = "notRunning", CA.RUNNING = "running", CA.RERUN_REQUESTED = "rerunRequested", CA.STOP_REQUESTED = "stopRequested", CA.COMPILATION_ERROR = "compilationError", CA))(ScriptRunState || {});
const ScriptRunContext = createContext({
  scriptRunState: ScriptRunState.NOT_RUNNING,
  scriptRunId: "<null>",
  fragmentIdsThisRun: []
});
ScriptRunContext.displayName = "ScriptRunContext";
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$1 = /* @__PURE__ */ memoize$1(
  function(CA) {
    return reactPropsRegex$1.test(CA) || CA.charCodeAt(0) === 111 && CA.charCodeAt(1) === 110 && CA.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid$1, testOmitPropsOnComponent = function CA(gA) {
  return gA !== "theme";
}, getDefaultShouldForwardProp = function CA(gA) {
  return typeof gA == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  gA.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function CA(gA, AA, IA) {
  var BA;
  if (AA) {
    var QA = AA.shouldForwardProp;
    BA = gA.__emotion_forwardProp && QA ? function(EA) {
      return gA.__emotion_forwardProp(EA) && QA(EA);
    } : QA;
  }
  return typeof BA != "function" && IA && (BA = gA.__emotion_forwardProp), BA;
}, Insertion = function CA(gA) {
  var AA = gA.cache, IA = gA.serialized, BA = gA.isStringTag;
  return registerStyles(AA, IA, BA), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(AA, IA, BA);
  }), null;
}, createStyled = function CA(gA, AA) {
  var IA = gA.__emotion_real === gA, BA = IA && gA.__emotion_base || gA, QA, EA;
  AA !== void 0 && (QA = AA.label, EA = AA.target);
  var iA = composeShouldForwardProps(gA, AA, IA), oA = iA || getDefaultShouldForwardProp(BA), cA = !oA("as");
  return function() {
    var tA = arguments, eA = IA && gA.__emotion_styles !== void 0 ? gA.__emotion_styles.slice(0) : [];
    if (QA !== void 0 && eA.push("label:" + QA + ";"), tA[0] == null || tA[0].raw === void 0)
      eA.push.apply(eA, tA);
    else {
      var aA = tA[0];
      eA.push(aA[0]);
      for (var GA = tA.length, lA = 1; lA < GA; lA++)
        eA.push(tA[lA], aA[lA]);
    }
    var nA = withEmotionCache(function(DA, hA, wA) {
      var sA = cA && DA.as || BA, NA = "", rA = [], yA = DA;
      if (DA.theme == null) {
        yA = {};
        for (var bA in DA)
          yA[bA] = DA[bA];
        yA.theme = React.useContext(ThemeContext$2);
      }
      typeof DA.className == "string" ? NA = getRegisteredStyles(hA.registered, rA, DA.className) : DA.className != null && (NA = DA.className + " ");
      var RA = serializeStyles(eA.concat(rA), hA.registered, yA);
      NA += hA.key + "-" + RA.name, EA !== void 0 && (NA += " " + EA);
      var FA = cA && iA === void 0 ? getDefaultShouldForwardProp(sA) : oA, dA = {};
      for (var kA in DA)
        cA && kA === "as" || FA(kA) && (dA[kA] = DA[kA]);
      return dA.className = NA, wA && (dA.ref = wA), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: hA,
        serialized: RA,
        isStringTag: typeof sA == "string"
      }), /* @__PURE__ */ React.createElement(sA, dA));
    });
    return nA.displayName = QA !== void 0 ? QA : "Styled(" + (typeof BA == "string" ? BA : BA.displayName || BA.name || "Component") + ")", nA.defaultProps = gA.defaultProps, nA.__emotion_real = nA, nA.__emotion_base = BA, nA.__emotion_styles = eA, nA.__emotion_forwardProp = iA, Object.defineProperty(nA, "toString", {
      value: function() {
        return "." + EA;
      }
    }), nA.withComponent = function(DA, hA) {
      var wA = CA(DA, _extends$m({}, AA, hA, {
        shouldForwardProp: composeShouldForwardProps(nA, hA, !0)
      }));
      return wA.apply(void 0, eA);
    }, nA;
  };
}, reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(CA) {
    return reactPropsRegex.test(CA) || CA.charCodeAt(0) === 111 && CA.charCodeAt(1) === 110 && CA.charCodeAt(2) < 91;
  }
  /* Z+1 */
), SIZE$1 = {
  medium: "medium"
}, spin = {
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
}, StyledSpinner = styled("i", function(CA) {
  var gA = CA.$theme, AA = CA.$color, IA = AA === void 0 ? gA.colors.contentAccent : AA, BA = CA.$borderWidth, QA = CA.$size, EA = QA === void 0 ? SIZE$1.medium : QA, iA = {
    large: gA.sizing.scale300,
    medium: gA.sizing.scale100,
    small: gA.sizing.scale0
  }[BA || EA], oA = {
    large: gA.sizing.scale1000,
    medium: gA.sizing.scale900,
    small: gA.sizing.scale800
  }[EA];
  return iA || (iA = gA.sizing[BA], iA || (iA = "".concat(parseInt(BA), "px"))), oA || (oA = gA.sizing[EA], oA || (oA = "".concat(parseInt(EA), "px"))), {
    display: "block",
    animationName: spin,
    animationDuration: gA.animation.timing1000,
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderRadius: "50%",
    borderTopColor: IA,
    borderRightColor: gA.colors.backgroundTertiary,
    borderBottomColor: gA.colors.backgroundTertiary,
    borderLeftColor: gA.colors.backgroundTertiary,
    borderLeftWidth: iA,
    borderRightWidth: iA,
    borderTopWidth: iA,
    borderBottomWidth: iA,
    width: oA,
    height: oA,
    cursor: "wait"
  };
});
StyledSpinner.displayName = "StyledSpinner";
StyledSpinner.displayName = "StyledSpinner";
function _EMOTION_STRINGIFIED_CSS_ERROR__$h() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledSpinnerIcon = /* @__PURE__ */ createStyled(StyledSpinner, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (CA) => isPropValid(CA) && !["size"].includes(CA),
  target: "eyeqlp54"
} : {
  shouldForwardProp: (CA) => isPropValid(CA) && !["size"].includes(CA),
  target: "eyeqlp54",
  label: "StyledSpinnerIcon"
})(({
  size: CA = "lg",
  margin: gA = "",
  padding: AA = "",
  theme: IA
}) => {
  const BA = `calc(${IA.iconSizes[CA]} * 0.80)`;
  return {
    width: BA,
    height: BA,
    fontSize: BA,
    justifyContent: "center",
    margin: computeSpacingStyle(gA, IA),
    padding: computeSpacingStyle(AA, IA),
    borderColor: IA.colors.fadedText10,
    borderTopColor: IA.colors.bodyText,
    borderWidth: IA.sizes.spinnerThickness,
    flexGrow: 0,
    flexShrink: 0
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvSWNvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4QmlDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvSWNvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgaXNQcm9wVmFsaWQgZnJvbSBcIkBlbW90aW9uL2lzLXByb3AtdmFsaWRcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IEVtb3Rpb25JY29uIH0gZnJvbSBcIkBlbW90aW9uLWljb25zL2Vtb3Rpb24taWNvblwiXG5pbXBvcnQgeyBTcGlubmVyIH0gZnJvbSBcImJhc2V1aS9zcGlubmVyXCJcblxuaW1wb3J0IHR5cGUgeyBJY29uU2l6ZSB9IGZyb20gXCJ+bGliL3RoZW1lL3R5cGVzXCJcbmltcG9ydCB7IGNvbXB1dGVTcGFjaW5nU3R5bGUgfSBmcm9tIFwifmxpYi90aGVtZS91dGlsc1wiXG5cbmludGVyZmFjZSBTdHlsZWRTcGlubmVySWNvblByb3BzIHtcbiAgc2l6ZT86IEljb25TaXplXG4gIG1hcmdpbj86IHN0cmluZ1xuICBwYWRkaW5nPzogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTcGlubmVySWNvbiA9IHN0eWxlZChTcGlubmVyLCB7XG4gIHNob3VsZEZvcndhcmRQcm9wOiAocHJvcDogc3RyaW5nKSA9PlxuICAgIGlzUHJvcFZhbGlkKHByb3ApICYmICFbXCJzaXplXCJdLmluY2x1ZGVzKHByb3ApLFxufSk8U3R5bGVkU3Bpbm5lckljb25Qcm9wcz4oKHtcbiAgc2l6ZSA9IFwibGdcIixcbiAgbWFyZ2luID0gXCJcIixcbiAgcGFkZGluZyA9IFwiXCIsXG4gIHRoZW1lLFxufSkgPT4ge1xuICAvLyBTcGlubmVycyBhcmUgcmVuZGVyZWQgMjAlIHNtYWxsZXIgdG8gdmlzdWFsbHkgbWF0Y2ggdGhlIHNpemUgb2YgTWF0ZXJpYWwgaWNvbnM6XG4gIGNvbnN0IGFkanVzdGVkU3Bpbm5lclNpemUgPSBgY2FsYygke3RoZW1lLmljb25TaXplc1tzaXplXX0gKiAwLjgwKWBcblxuICByZXR1cm4ge1xuICAgIHdpZHRoOiBhZGp1c3RlZFNwaW5uZXJTaXplLFxuICAgIGhlaWdodDogYWRqdXN0ZWRTcGlubmVyU2l6ZSxcbiAgICBmb250U2l6ZTogYWRqdXN0ZWRTcGlubmVyU2l6ZSxcbiAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICBtYXJnaW46IGNvbXB1dGVTcGFjaW5nU3R5bGUobWFyZ2luLCB0aGVtZSksXG4gICAgcGFkZGluZzogY29tcHV0ZVNwYWNpbmdTdHlsZShwYWRkaW5nLCB0aGVtZSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQxMCxcbiAgICBib3JkZXJUb3BDb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGJvcmRlcldpZHRoOiB0aGVtZS5zaXplcy5zcGlubmVyVGhpY2tuZXNzLFxuICAgIGZsZXhHcm93OiAwLFxuICAgIGZsZXhTaHJpbms6IDAsXG4gIH1cbn0pXG5cbmludGVyZmFjZSBTdHlsZWRJY29uUHJvcHMge1xuICBhcz86IEVtb3Rpb25JY29uXG4gIGNvbG9yPzogc3RyaW5nXG4gIHNpemU6IEljb25TaXplXG4gIG1hcmdpbjogc3RyaW5nXG4gIHBhZGRpbmc6IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSWNvbiA9IHN0eWxlZChcInNwYW5cIiwge1xuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3A6IHN0cmluZykgPT5cbiAgICBpc1Byb3BWYWxpZChwcm9wKSAmJiAhW1wic2l6ZVwiLCBcImFzXCJdLmluY2x1ZGVzKHByb3ApLFxufSk8U3R5bGVkSWNvblByb3BzPigoeyBjb2xvciwgc2l6ZSwgbWFyZ2luLCBwYWRkaW5nLCB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgY29sb3I6IGNvbG9yIHx8IFwiaW5oZXJpdFwiLFxuICAgIGZpbGw6IFwiY3VycmVudENvbG9yXCIsXG4gICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgZm9udFNpemU6IHRoZW1lLmljb25TaXplc1tzaXplXSxcbiAgICB3aWR0aDogdGhlbWUuaWNvblNpemVzW3NpemVdLFxuICAgIGhlaWdodDogdGhlbWUuaWNvblNpemVzW3NpemVdLFxuICAgIG1hcmdpbjogY29tcHV0ZVNwYWNpbmdTdHlsZShtYXJnaW4sIHRoZW1lKSxcbiAgICBwYWRkaW5nOiBjb21wdXRlU3BhY2luZ1N0eWxlKHBhZGRpbmcsIHRoZW1lKSxcbiAgICBmbGV4U2hyaW5rOiAwLFxuICB9XG59KVxuXG5pbnRlcmZhY2UgU3R5bGVkRHluYW1pY0ljb25Qcm9wcyB7XG4gIHNpemU/OiBJY29uU2l6ZVxuICBtYXJnaW4/OiBzdHJpbmdcbiAgcGFkZGluZz86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRHluYW1pY0ljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWREeW5hbWljSWNvblByb3BzPihcbiAgKHsgc2l6ZSA9IFwibGdcIiwgbWFyZ2luID0gXCJcIiwgcGFkZGluZyA9IFwiXCIsIHRoZW1lIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZmlsbDogXCJjdXJyZW50Q29sb3JcIixcbiAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICAgIGZvbnRTaXplOiB0aGVtZS5pY29uU2l6ZXNbc2l6ZV0sXG4gICAgICB3aWR0aDogdGhlbWUuaWNvblNpemVzW3NpemVdLFxuICAgICAgaGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXNbc2l6ZV0sXG4gICAgICBtYXJnaW46IGNvbXB1dGVTcGFjaW5nU3R5bGUobWFyZ2luLCB0aGVtZSksXG4gICAgICBwYWRkaW5nOiBjb21wdXRlU3BhY2luZ1N0eWxlKHBhZGRpbmcsIHRoZW1lKSxcbiAgICAgIGZsZXhTaHJpbms6IDAsXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJbWFnZUljb24gPSBzdHlsZWQuaW1nKHtcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBoZWlnaHQ6IFwiMTAwJVwiLFxufSlcblxuaW50ZXJmYWNlIFN0eWxlZEVtb2ppSWNvblByb3BzIHtcbiAgc2l6ZTogSWNvblNpemVcbiAgbWFyZ2luOiBzdHJpbmdcbiAgcGFkZGluZzogc3RyaW5nXG4gIGNvbG9yPzogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFbW9qaUljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRFbW9qaUljb25Qcm9wcz4oXG4gICh7IHNpemUsIG1hcmdpbiwgcGFkZGluZywgdGhlbWUsIGNvbG9yIH0pID0+IHtcbiAgICAvLyBFbW9qaXMgYXJlIHJlbmRlcmVkIDEwJSBzbWFsbGVyIHRvIHZpc3VhbGx5IG1hdGNoIHRoZSBzaXplIG9mIE1hdGVyaWFsIGljb25zOlxuICAgIGNvbnN0IGFkanVzdGVkSWNvblNpemUgPSBgY2FsYygke3RoZW1lLmljb25TaXplc1tzaXplXX0gKiAwLjkwKWBcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgICAgZm9udFNpemU6IGFkanVzdGVkSWNvblNpemUsXG4gICAgICB3aWR0aDogYWRqdXN0ZWRJY29uU2l6ZSxcbiAgICAgIGhlaWdodDogYWRqdXN0ZWRJY29uU2l6ZSxcbiAgICAgIG1hcmdpbjogY29tcHV0ZVNwYWNpbmdTdHlsZShtYXJnaW4sIHRoZW1lKSxcbiAgICAgIHBhZGRpbmc6IGNvbXB1dGVTcGFjaW5nU3R5bGUocGFkZGluZywgdGhlbWUpLFxuICAgICAgY29sb3I6IGNvbG9yLFxuICAgIH1cbiAgfVxuKVxuIl19 */"), StyledIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  shouldForwardProp: (CA) => isPropValid(CA) && !["size", "as"].includes(CA),
  target: "eyeqlp53"
} : {
  shouldForwardProp: (CA) => isPropValid(CA) && !["size", "as"].includes(CA),
  target: "eyeqlp53",
  label: "StyledIcon"
})(({
  color: CA,
  size: gA,
  margin: AA,
  padding: IA,
  theme: BA
}) => ({
  color: CA || "inherit",
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: BA.iconSizes[gA],
  width: BA.iconSizes[gA],
  height: BA.iconSizes[gA],
  margin: computeSpacingStyle(AA, BA),
  padding: computeSpacingStyle(IA, BA),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDynamicIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp52"
} : {
  target: "eyeqlp52",
  label: "StyledDynamicIcon"
})(({
  size: CA = "lg",
  margin: gA = "",
  padding: AA = "",
  theme: IA
}) => ({
  fill: "currentColor",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: IA.iconSizes[CA],
  width: IA.iconSizes[CA],
  height: IA.iconSizes[CA],
  margin: computeSpacingStyle(gA, IA),
  padding: computeSpacingStyle(AA, IA),
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledImageIcon = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp51"
} : {
  target: "eyeqlp51",
  label: "StyledImageIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
}), StyledEmojiIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eyeqlp50"
} : {
  target: "eyeqlp50",
  label: "StyledEmojiIcon"
})(({
  size: CA,
  margin: gA,
  padding: AA,
  theme: IA,
  color: BA
}) => {
  const QA = `calc(${IA.iconSizes[CA]} * 0.90)`;
  return {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: QA,
    width: QA,
    height: QA,
    margin: computeSpacingStyle(gA, IA),
    padding: computeSpacingStyle(AA, IA),
    color: BA
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps$1 = ({
  size: CA,
  margin: gA,
  padding: AA,
  color: IA
}) => ({
  size: CA || "md",
  margin: gA || "",
  padding: AA || "",
  color: IA || void 0
}), Icon$2 = ({
  content: CA,
  color: gA,
  size: AA,
  margin: IA,
  padding: BA,
  testid: QA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIcon, { as: CA, "aria-hidden": "true", "data-testid": QA, ...getDefaultProps$1({
  size: AA,
  margin: IA,
  padding: BA,
  color: gA
}) }), EmojiIcon = ({
  size: CA,
  margin: gA,
  padding: AA,
  children: IA,
  color: BA,
  testid: QA
}) => (typeof IA == "string" && (IA = IA.replace(/^emoji:/, "")), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEmojiIcon, { "data-testid": QA || "stIconEmoji", "aria-hidden": "true", ...getDefaultProps$1({
  size: CA,
  margin: gA,
  padding: AA,
  color: BA
}), children: IA })), StyledMaterialIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16edly10"
} : {
  target: "e16edly10",
  label: "StyledMaterialIcon"
})(({
  size: CA,
  margin: gA,
  padding: AA,
  theme: IA,
  color: BA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: BA,
  fontSize: IA.iconSizes[CA],
  width: IA.iconSizes[CA],
  height: IA.iconSizes[CA],
  margin: computeSpacingStyle(gA, IA),
  padding: computeSpacingStyle(AA, IA),
  userSelect: "none",
  fontFamily: IA.genericFonts.iconFont,
  fontWeight: IA.fontWeights.normal,
  fontStyle: "normal",
  lineHeight: IA.lineHeights.none,
  letterSpacing: "normal",
  textTransform: "none",
  whiteSpace: "nowrap",
  wordWrap: "normal",
  direction: "ltr",
  fontFeatureSettings: "liga",
  MozFontFeatureSettings: "liga",
  WebkitFontFeatureSettings: "liga",
  WebkitFontSmoothing: "antialiased"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getDefaultProps = ({
  size: CA,
  margin: gA,
  padding: AA,
  color: IA
}) => ({
  size: CA || "md",
  margin: gA || "",
  padding: AA || "",
  color: IA || "inherit"
}), MaterialFontIcon = ({
  iconName: CA,
  ...gA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  StyledMaterialIcon,
  {
    ...getDefaultProps(gA),
    "data-testid": gA.testid || "stIconMaterial",
    translate: "no",
    children: CA
  }
);
function parseIconPackEntry(CA) {
  const gA = CA.match(/^:(.+)\/(.+):$/);
  if (gA === null)
    return {
      pack: "emoji",
      icon: CA
    };
  const AA = gA[1], IA = gA[2];
  return {
    pack: AA,
    icon: IA
  };
}
function isMaterialIcon(CA) {
  if (!CA)
    return !1;
  const gA = parseIconPackEntry(CA);
  return gA.pack === "material" && gA.icon !== "";
}
function extractLeadingMaterialIcon(CA) {
  const gA = CA.match(/^(:material\/\w+:)\s*(.*)$/);
  return gA ? {
    icon: gA[1],
    text: gA[2]
  } : {
    icon: null,
    text: CA
  };
}
function getFilledStarIconSrc() {
  return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTg2MF84NDMpIj48cGF0aCBkPSJNOS45OTk5NCAxNC4zOTE2TDEzLjQ1ODMgMTYuNDgzM0MxNC4wOTE2IDE2Ljg2NjYgMTQuODY2NiAxNi4zIDE0LjY5OTkgMTUuNTgzM0wxMy43ODMzIDExLjY1TDE2Ljg0MTYgOC45OTk5N0MxNy4zOTk5IDguNTE2NjMgMTcuMDk5OSA3LjU5OTk3IDE2LjM2NjYgNy41NDE2M0wxMi4zNDE2IDcuMTk5OTdMMTAuNzY2NiAzLjQ4MzNDMTAuNDgzMyAyLjgwODMgOS41MTY2MSAyLjgwODMgOS4yMzMyNyAzLjQ4MzNMNy42NTgyNyA3LjE5MTYzTDMuNjMzMjcgNy41MzMzQzIuODk5OTQgNy41OTE2MyAyLjU5OTk0IDguNTA4MyAzLjE1ODI3IDguOTkxNjNMNi4yMTY2MSAxMS42NDE2TDUuMjk5OTQgMTUuNTc1QzUuMTMzMjcgMTYuMjkxNiA1LjkwODI3IDE2Ljg1ODMgNi41NDE2MSAxNi40NzVMOS45OTk5NCAxNC4zOTE2WiIgZmlsbD0iI0ZBQ0EyQiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzE4NjBfODQzIj48cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
}
const DynamicIconDispatcher = ({
  iconValue: CA,
  ...gA
}) => {
  if (CA === "spinner")
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpinnerIcon, { "data-testid": gA.testid || "stSpinnerIcon", ...gA }) });
  const {
    pack: AA,
    icon: IA
  } = parseIconPackEntry(CA);
  return AA === "material" ? IA === "star_filled" ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledImageIcon, { src: getFilledStarIconSrc(), "data-testid": gA.testid || "stImageIcon" }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MaterialFontIcon, { pack: AA, iconName: IA, ...gA }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...gA, children: IA }) });
}, DynamicIcon = (CA) => /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDynamicIcon, { ...CA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmojiIcon, { ...CA, children: " " }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIconDispatcher, { ...CA }) }, CA.iconValue), LibConfigContext = createContext({
  locale: window.navigator.language,
  // Selected libConfig properties:
  mapboxToken: void 0,
  enforceDownloadInNewTab: void 0,
  resourceCrossOriginMode: void 0,
  showErrorLinks: Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO
});
LibConfigContext.displayName = "LibConfigContext";
var Pe = Object.defineProperty, a$2 = (CA, gA) => Pe(CA, "name", { value: gA, configurable: !0 }), P$1 = class {
  type = 3;
  name = "";
  prefix = "";
  value = "";
  suffix = "";
  modifier = 3;
  constructor(gA, AA, IA, BA, QA, EA) {
    this.type = gA, this.name = AA, this.prefix = IA, this.value = BA, this.suffix = QA, this.modifier = EA;
  }
  hasCustomName() {
    return this.name !== "" && typeof this.name != "number";
  }
};
a$2(P$1, "Part");
var Re = /[$_\p{ID_Start}]/u, Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, v$1 = ".*";
function Oe(CA, gA) {
  return (gA ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(CA);
}
a$2(Oe, "isASCII");
function D$1(CA, gA = !1) {
  let AA = [], IA = 0;
  for (; IA < CA.length; ) {
    let BA = CA[IA], QA = a$2(function(EA) {
      if (!gA) throw new TypeError(EA);
      AA.push({ type: "INVALID_CHAR", index: IA, value: CA[IA++] });
    }, "ErrorOrInvalid");
    if (BA === "*") {
      AA.push({ type: "ASTERISK", index: IA, value: CA[IA++] });
      continue;
    }
    if (BA === "+" || BA === "?") {
      AA.push({ type: "OTHER_MODIFIER", index: IA, value: CA[IA++] });
      continue;
    }
    if (BA === "\\") {
      AA.push({ type: "ESCAPED_CHAR", index: IA++, value: CA[IA++] });
      continue;
    }
    if (BA === "{") {
      AA.push({ type: "OPEN", index: IA, value: CA[IA++] });
      continue;
    }
    if (BA === "}") {
      AA.push({ type: "CLOSE", index: IA, value: CA[IA++] });
      continue;
    }
    if (BA === ":") {
      let EA = "", iA = IA + 1;
      for (; iA < CA.length; ) {
        let oA = CA.substr(iA, 1);
        if (iA === IA + 1 && Re.test(oA) || iA !== IA + 1 && Ee.test(oA)) {
          EA += CA[iA++];
          continue;
        }
        break;
      }
      if (!EA) {
        QA(`Missing parameter name at ${IA}`);
        continue;
      }
      AA.push({ type: "NAME", index: IA, value: EA }), IA = iA;
      continue;
    }
    if (BA === "(") {
      let EA = 1, iA = "", oA = IA + 1, cA = !1;
      if (CA[oA] === "?") {
        QA(`Pattern cannot start with "?" at ${oA}`);
        continue;
      }
      for (; oA < CA.length; ) {
        if (!Oe(CA[oA], !1)) {
          QA(`Invalid character '${CA[oA]}' at ${oA}.`), cA = !0;
          break;
        }
        if (CA[oA] === "\\") {
          iA += CA[oA++] + CA[oA++];
          continue;
        }
        if (CA[oA] === ")") {
          if (EA--, EA === 0) {
            oA++;
            break;
          }
        } else if (CA[oA] === "(" && (EA++, CA[oA + 1] !== "?")) {
          QA(`Capturing groups are not allowed at ${oA}`), cA = !0;
          break;
        }
        iA += CA[oA++];
      }
      if (cA) continue;
      if (EA) {
        QA(`Unbalanced pattern at ${IA}`);
        continue;
      }
      if (!iA) {
        QA(`Missing pattern at ${IA}`);
        continue;
      }
      AA.push({ type: "REGEX", index: IA, value: iA }), IA = oA;
      continue;
    }
    AA.push({ type: "CHAR", index: IA, value: CA[IA++] });
  }
  return AA.push({ type: "END", index: IA, value: "" }), AA;
}
a$2(D$1, "lexer");
function F$2(CA, gA = {}) {
  let AA = D$1(CA);
  gA.delimiter ??= "/#?", gA.prefixes ??= "./";
  let IA = `[^${x$1(gA.delimiter)}]+?`, BA = [], QA = 0, EA = 0, iA = /* @__PURE__ */ new Set(), oA = a$2((wA) => {
    if (EA < AA.length && AA[EA].type === wA) return AA[EA++].value;
  }, "tryConsume"), cA = a$2(() => oA("OTHER_MODIFIER") ?? oA("ASTERISK"), "tryConsumeModifier"), tA = a$2((wA) => {
    let sA = oA(wA);
    if (sA !== void 0) return sA;
    let { type: NA, index: rA } = AA[EA];
    throw new TypeError(`Unexpected ${NA} at ${rA}, expected ${wA}`);
  }, "mustConsume"), eA = a$2(() => {
    let wA = "", sA;
    for (; sA = oA("CHAR") ?? oA("ESCAPED_CHAR"); ) wA += sA;
    return wA;
  }, "consumeText"), aA = a$2((wA) => wA, "DefaultEncodePart"), GA = gA.encodePart || aA, lA = "", nA = a$2((wA) => {
    lA += wA;
  }, "appendToPendingFixedValue"), DA = a$2(() => {
    lA.length && (BA.push(new P$1(3, "", "", GA(lA), "", 3)), lA = "");
  }, "maybeAddPartFromPendingFixedValue"), hA = a$2((wA, sA, NA, rA, yA) => {
    let bA = 3;
    switch (yA) {
      case "?":
        bA = 1;
        break;
      case "*":
        bA = 0;
        break;
      case "+":
        bA = 2;
        break;
    }
    if (!sA && !NA && bA === 3) {
      nA(wA);
      return;
    }
    if (DA(), !sA && !NA) {
      if (!wA) return;
      BA.push(new P$1(3, "", "", GA(wA), "", bA));
      return;
    }
    let RA;
    NA ? NA === "*" ? RA = v$1 : RA = NA : RA = IA;
    let FA = 2;
    RA === IA ? (FA = 1, RA = "") : RA === v$1 && (FA = 0, RA = "");
    let dA;
    if (sA ? dA = sA : NA && (dA = QA++), iA.has(dA)) throw new TypeError(`Duplicate name '${dA}'.`);
    iA.add(dA), BA.push(new P$1(FA, dA, GA(wA), RA, GA(rA), bA));
  }, "addPart");
  for (; EA < AA.length; ) {
    let wA = oA("CHAR"), sA = oA("NAME"), NA = oA("REGEX");
    if (!sA && !NA && (NA = oA("ASTERISK")), sA || NA) {
      let yA = wA ?? "";
      gA.prefixes.indexOf(yA) === -1 && (nA(yA), yA = ""), DA();
      let bA = cA();
      hA(yA, sA, NA, "", bA);
      continue;
    }
    let rA = wA ?? oA("ESCAPED_CHAR");
    if (rA) {
      nA(rA);
      continue;
    }
    if (oA("OPEN")) {
      let yA = eA(), bA = oA("NAME"), RA = oA("REGEX");
      !bA && !RA && (RA = oA("ASTERISK"));
      let FA = eA();
      tA("CLOSE");
      let dA = cA();
      hA(yA, bA, RA, FA, dA);
      continue;
    }
    DA(), tA("END");
  }
  return BA;
}
a$2(F$2, "parse");
function x$1(CA) {
  return CA.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$2(x$1, "escapeString");
function B$2(CA) {
  return CA && CA.ignoreCase ? "ui" : "u";
}
a$2(B$2, "flags");
function q$1(CA, gA, AA) {
  return W$2(F$2(CA, AA), gA, AA);
}
a$2(q$1, "stringToRegexp");
function T$1(CA) {
  switch (CA) {
    case 0:
      return "*";
    case 1:
      return "?";
    case 2:
      return "+";
    case 3:
      return "";
  }
}
a$2(T$1, "modifierToString");
function W$2(CA, gA, AA = {}) {
  AA.delimiter ??= "/#?", AA.prefixes ??= "./", AA.sensitive ??= !1, AA.strict ??= !1, AA.end ??= !0, AA.start ??= !0, AA.endsWith = "";
  let IA = AA.start ? "^" : "";
  for (let iA of CA) {
    if (iA.type === 3) {
      iA.modifier === 3 ? IA += x$1(iA.value) : IA += `(?:${x$1(iA.value)})${T$1(iA.modifier)}`;
      continue;
    }
    gA && gA.push(iA.name);
    let oA = `[^${x$1(AA.delimiter)}]+?`, cA = iA.value;
    if (iA.type === 1 ? cA = oA : iA.type === 0 && (cA = v$1), !iA.prefix.length && !iA.suffix.length) {
      iA.modifier === 3 || iA.modifier === 1 ? IA += `(${cA})${T$1(iA.modifier)}` : IA += `((?:${cA})${T$1(iA.modifier)})`;
      continue;
    }
    if (iA.modifier === 3 || iA.modifier === 1) {
      IA += `(?:${x$1(iA.prefix)}(${cA})${x$1(iA.suffix)})`, IA += T$1(iA.modifier);
      continue;
    }
    IA += `(?:${x$1(iA.prefix)}`, IA += `((?:${cA})(?:`, IA += x$1(iA.suffix), IA += x$1(iA.prefix), IA += `(?:${cA}))*)${x$1(iA.suffix)})`, iA.modifier === 0 && (IA += "?");
  }
  let BA = `[${x$1(AA.endsWith)}]|$`, QA = `[${x$1(AA.delimiter)}]`;
  if (AA.end) return AA.strict || (IA += `${QA}?`), AA.endsWith.length ? IA += `(?=${BA})` : IA += "$", new RegExp(IA, B$2(AA));
  AA.strict || (IA += `(?:${QA}(?=${BA}))?`);
  let EA = !1;
  if (CA.length) {
    let iA = CA[CA.length - 1];
    iA.type === 3 && iA.modifier === 3 && (EA = AA.delimiter.indexOf(iA) > -1);
  }
  return EA || (IA += `(?=${QA}|${BA})`), new RegExp(IA, B$2(AA));
}
a$2(W$2, "partsToRegexp");
var b$1 = { delimiter: "", prefixes: "", sensitive: !0, strict: !0 }, J$2 = { delimiter: ".", prefixes: "", sensitive: !0, strict: !0 }, Q$2 = { delimiter: "/", prefixes: "/", sensitive: !0, strict: !0 };
function ee(CA, gA) {
  return CA.length ? CA[0] === "/" ? !0 : !gA || CA.length < 2 ? !1 : (CA[0] == "\\" || CA[0] == "{") && CA[1] == "/" : !1;
}
a$2(ee, "isAbsolutePathname");
function te(CA, gA) {
  return CA.startsWith(gA) ? CA.substring(gA.length, CA.length) : CA;
}
a$2(te, "maybeStripPrefix");
function ke(CA, gA) {
  return CA.endsWith(gA) ? CA.substr(0, CA.length - gA.length) : CA;
}
a$2(ke, "maybeStripSuffix");
function _(CA) {
  return !CA || CA.length < 2 ? !1 : CA[0] === "[" || (CA[0] === "\\" || CA[0] === "{") && CA[1] === "[";
}
a$2(_, "treatAsIPv6Hostname");
var re$1 = ["ftp", "file", "http", "https", "ws", "wss"];
function U$2(CA) {
  if (!CA) return !0;
  for (let gA of re$1) if (CA.test(gA)) return !0;
  return !1;
}
a$2(U$2, "isSpecialScheme");
function ne(CA, gA) {
  if (CA = te(CA, "#"), gA || CA === "") return CA;
  let AA = new URL("https://example.com");
  return AA.hash = CA, AA.hash ? AA.hash.substring(1, AA.hash.length) : "";
}
a$2(ne, "canonicalizeHash");
function se(CA, gA) {
  if (CA = te(CA, "?"), gA || CA === "") return CA;
  let AA = new URL("https://example.com");
  return AA.search = CA, AA.search ? AA.search.substring(1, AA.search.length) : "";
}
a$2(se, "canonicalizeSearch");
function ie(CA, gA) {
  return gA || CA === "" ? CA : _(CA) ? K$2(CA) : j$1(CA);
}
a$2(ie, "canonicalizeHostname");
function ae(CA, gA) {
  if (gA || CA === "") return CA;
  let AA = new URL("https://example.com");
  return AA.password = CA, AA.password;
}
a$2(ae, "canonicalizePassword");
function oe(CA, gA) {
  if (gA || CA === "") return CA;
  let AA = new URL("https://example.com");
  return AA.username = CA, AA.username;
}
a$2(oe, "canonicalizeUsername");
function ce(CA, gA, AA) {
  if (AA || CA === "") return CA;
  if (gA && !re$1.includes(gA)) return new URL(`${gA}:${CA}`).pathname;
  let IA = CA[0] == "/";
  return CA = new URL(IA ? CA : "/-" + CA, "https://example.com").pathname, IA || (CA = CA.substring(2, CA.length)), CA;
}
a$2(ce, "canonicalizePathname");
function le(CA, gA, AA) {
  return z$2(gA) === CA && (CA = ""), AA || CA === "" ? CA : G$2(CA);
}
a$2(le, "canonicalizePort");
function fe(CA, gA) {
  return CA = ke(CA, ":"), gA || CA === "" ? CA : w$2(CA);
}
a$2(fe, "canonicalizeProtocol");
function z$2(CA) {
  switch (CA) {
    case "ws":
    case "http":
      return "80";
    case "wws":
    case "https":
      return "443";
    case "ftp":
      return "21";
    default:
      return "";
  }
}
a$2(z$2, "defaultPortForProtocol");
function w$2(CA) {
  if (CA === "") return CA;
  if (/^[-+.A-Za-z0-9]*$/.test(CA)) return CA.toLowerCase();
  throw new TypeError(`Invalid protocol '${CA}'.`);
}
a$2(w$2, "protocolEncodeCallback");
function he(CA) {
  if (CA === "") return CA;
  let gA = new URL("https://example.com");
  return gA.username = CA, gA.username;
}
a$2(he, "usernameEncodeCallback");
function ue(CA) {
  if (CA === "") return CA;
  let gA = new URL("https://example.com");
  return gA.password = CA, gA.password;
}
a$2(ue, "passwordEncodeCallback");
function j$1(CA) {
  if (CA === "") return CA;
  if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(CA)) throw new TypeError(`Invalid hostname '${CA}'`);
  let gA = new URL("https://example.com");
  return gA.hostname = CA, gA.hostname;
}
a$2(j$1, "hostnameEncodeCallback");
function K$2(CA) {
  if (CA === "") return CA;
  if (/[^0-9a-fA-F[\]:]/g.test(CA)) throw new TypeError(`Invalid IPv6 hostname '${CA}'`);
  return CA.toLowerCase();
}
a$2(K$2, "ipv6HostnameEncodeCallback");
function G$2(CA) {
  if (CA === "" || /^[0-9]*$/.test(CA) && parseInt(CA) <= 65535) return CA;
  throw new TypeError(`Invalid port '${CA}'.`);
}
a$2(G$2, "portEncodeCallback");
function de(CA) {
  if (CA === "") return CA;
  let gA = new URL("https://example.com");
  return gA.pathname = CA[0] !== "/" ? "/-" + CA : CA, CA[0] !== "/" ? gA.pathname.substring(2, gA.pathname.length) : gA.pathname;
}
a$2(de, "standardURLPathnameEncodeCallback");
function pe(CA) {
  return CA === "" ? CA : new URL(`data:${CA}`).pathname;
}
a$2(pe, "pathURLPathnameEncodeCallback");
function ge(CA) {
  if (CA === "") return CA;
  let gA = new URL("https://example.com");
  return gA.search = CA, gA.search.substring(1, gA.search.length);
}
a$2(ge, "searchEncodeCallback");
function me(CA) {
  if (CA === "") return CA;
  let gA = new URL("https://example.com");
  return gA.hash = CA, gA.hash.substring(1, gA.hash.length);
}
a$2(me, "hashEncodeCallback");
var C$1 = class {
  #Q;
  #C = [];
  #I = {};
  #A = 0;
  #B = 1;
  #c = 0;
  #i = 0;
  #G = 0;
  #l = 0;
  #n = !1;
  constructor(gA) {
    this.#Q = gA;
  }
  get result() {
    return this.#I;
  }
  parse() {
    for (this.#C = D$1(this.#Q, !0); this.#A < this.#C.length; this.#A += this.#B) {
      if (this.#B = 1, this.#C[this.#A].type === "END") {
        if (this.#i === 0) {
          this.#h(), this.#t() ? this.#g(9, 1) : this.#e() ? this.#g(8, 1) : this.#g(7, 0);
          continue;
        } else if (this.#i === 2) {
          this.#a(5);
          continue;
        }
        this.#g(10, 0);
        break;
      }
      if (this.#G > 0) if (this.#k()) this.#G -= 1;
      else continue;
      if (this.#F()) {
        this.#G += 1;
        continue;
      }
      switch (this.#i) {
        case 0:
          this.#N() && this.#a(1);
          break;
        case 1:
          if (this.#N()) {
            this.#Y();
            let gA = 7, AA = 1;
            this.#y() ? (gA = 2, AA = 3) : this.#n && (gA = 2), this.#g(gA, AA);
          }
          break;
        case 2:
          this.#w() ? this.#a(3) : (this.#s() || this.#e() || this.#t()) && this.#a(5);
          break;
        case 3:
          this.#b() ? this.#g(4, 1) : this.#w() && this.#g(5, 1);
          break;
        case 4:
          this.#w() && this.#g(5, 1);
          break;
        case 5:
          this.#R() ? this.#l += 1 : this.#u() && (this.#l -= 1), this.#d() && !this.#l ? this.#g(6, 1) : this.#s() ? this.#g(7, 0) : this.#e() ? this.#g(8, 1) : this.#t() && this.#g(9, 1);
          break;
        case 6:
          this.#s() ? this.#g(7, 0) : this.#e() ? this.#g(8, 1) : this.#t() && this.#g(9, 1);
          break;
        case 7:
          this.#e() ? this.#g(8, 1) : this.#t() && this.#g(9, 1);
          break;
        case 8:
          this.#t() && this.#g(9, 1);
          break;
      }
    }
    this.#I.hostname !== void 0 && this.#I.port === void 0 && (this.#I.port = "");
  }
  #g(gA, AA) {
    switch (this.#i) {
      case 0:
        break;
      case 1:
        this.#I.protocol = this.#o();
        break;
      case 2:
        break;
      case 3:
        this.#I.username = this.#o();
        break;
      case 4:
        this.#I.password = this.#o();
        break;
      case 5:
        this.#I.hostname = this.#o();
        break;
      case 6:
        this.#I.port = this.#o();
        break;
      case 7:
        this.#I.pathname = this.#o();
        break;
      case 8:
        this.#I.search = this.#o();
        break;
      case 9:
        this.#I.hash = this.#o();
        break;
    }
    this.#i !== 0 && gA !== 10 && ([1, 2, 3, 4].includes(this.#i) && [6, 7, 8, 9].includes(gA) && (this.#I.hostname ??= ""), [1, 2, 3, 4, 5, 6].includes(this.#i) && [8, 9].includes(gA) && (this.#I.pathname ??= this.#n ? "/" : ""), [1, 2, 3, 4, 5, 6, 7].includes(this.#i) && gA === 9 && (this.#I.search ??= "")), this.#r(gA, AA);
  }
  #r(gA, AA) {
    this.#i = gA, this.#c = this.#A + AA, this.#A += AA, this.#B = 0;
  }
  #h() {
    this.#A = this.#c, this.#B = 0;
  }
  #a(gA) {
    this.#h(), this.#i = gA;
  }
  #D(gA) {
    return gA < 0 && (gA = this.#C.length - gA), gA < this.#C.length ? this.#C[gA] : this.#C[this.#C.length - 1];
  }
  #E(gA, AA) {
    let IA = this.#D(gA);
    return IA.value === AA && (IA.type === "CHAR" || IA.type === "ESCAPED_CHAR" || IA.type === "INVALID_CHAR");
  }
  #N() {
    return this.#E(this.#A, ":");
  }
  #y() {
    return this.#E(this.#A + 1, "/") && this.#E(this.#A + 2, "/");
  }
  #w() {
    return this.#E(this.#A, "@");
  }
  #b() {
    return this.#E(this.#A, ":");
  }
  #d() {
    return this.#E(this.#A, ":");
  }
  #s() {
    return this.#E(this.#A, "/");
  }
  #e() {
    if (this.#E(this.#A, "?")) return !0;
    if (this.#C[this.#A].value !== "?") return !1;
    let gA = this.#D(this.#A - 1);
    return gA.type !== "NAME" && gA.type !== "REGEX" && gA.type !== "CLOSE" && gA.type !== "ASTERISK";
  }
  #t() {
    return this.#E(this.#A, "#");
  }
  #F() {
    return this.#C[this.#A].type == "OPEN";
  }
  #k() {
    return this.#C[this.#A].type == "CLOSE";
  }
  #R() {
    return this.#E(this.#A, "[");
  }
  #u() {
    return this.#E(this.#A, "]");
  }
  #o() {
    let gA = this.#C[this.#A], AA = this.#D(this.#c).index;
    return this.#Q.substring(AA, gA.index);
  }
  #Y() {
    let gA = {};
    Object.assign(gA, b$1), gA.encodePart = w$2;
    let AA = q$1(this.#o(), void 0, gA);
    this.#n = U$2(AA);
  }
};
a$2(C$1, "Parser");
var V$2 = ["protocol", "username", "password", "hostname", "port", "pathname", "search", "hash"], O$1 = "*";
function Se(CA, gA) {
  if (typeof CA != "string") throw new TypeError("parameter 1 is not of type 'string'.");
  let AA = new URL(CA, gA);
  return { protocol: AA.protocol.substring(0, AA.protocol.length - 1), username: AA.username, password: AA.password, hostname: AA.hostname, port: AA.port, pathname: AA.pathname, search: AA.search !== "" ? AA.search.substring(1, AA.search.length) : void 0, hash: AA.hash !== "" ? AA.hash.substring(1, AA.hash.length) : void 0 };
}
a$2(Se, "extractValues");
function R$1(CA, gA) {
  return gA ? I$2(CA) : CA;
}
a$2(R$1, "processBaseURLString");
function L$2(CA, gA, AA) {
  let IA;
  if (typeof gA.baseURL == "string") try {
    IA = new URL(gA.baseURL), gA.protocol === void 0 && (CA.protocol = R$1(IA.protocol.substring(0, IA.protocol.length - 1), AA)), !AA && gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && gA.username === void 0 && (CA.username = R$1(IA.username, AA)), !AA && gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && gA.username === void 0 && gA.password === void 0 && (CA.password = R$1(IA.password, AA)), gA.protocol === void 0 && gA.hostname === void 0 && (CA.hostname = R$1(IA.hostname, AA)), gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && (CA.port = R$1(IA.port, AA)), gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && gA.pathname === void 0 && (CA.pathname = R$1(IA.pathname, AA)), gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && gA.pathname === void 0 && gA.search === void 0 && (CA.search = R$1(IA.search.substring(1, IA.search.length), AA)), gA.protocol === void 0 && gA.hostname === void 0 && gA.port === void 0 && gA.pathname === void 0 && gA.search === void 0 && gA.hash === void 0 && (CA.hash = R$1(IA.hash.substring(1, IA.hash.length), AA));
  } catch {
    throw new TypeError(`invalid baseURL '${gA.baseURL}'.`);
  }
  if (typeof gA.protocol == "string" && (CA.protocol = fe(gA.protocol, AA)), typeof gA.username == "string" && (CA.username = oe(gA.username, AA)), typeof gA.password == "string" && (CA.password = ae(gA.password, AA)), typeof gA.hostname == "string" && (CA.hostname = ie(gA.hostname, AA)), typeof gA.port == "string" && (CA.port = le(gA.port, CA.protocol, AA)), typeof gA.pathname == "string") {
    if (CA.pathname = gA.pathname, IA && !ee(CA.pathname, AA)) {
      let BA = IA.pathname.lastIndexOf("/");
      BA >= 0 && (CA.pathname = R$1(IA.pathname.substring(0, BA + 1), AA) + CA.pathname);
    }
    CA.pathname = ce(CA.pathname, CA.protocol, AA);
  }
  return typeof gA.search == "string" && (CA.search = se(gA.search, AA)), typeof gA.hash == "string" && (CA.hash = ne(gA.hash, AA)), CA;
}
a$2(L$2, "applyInit");
function I$2(CA) {
  return CA.replace(/([+*?:{}()\\])/g, "\\$1");
}
a$2(I$2, "escapePatternString");
function Te(CA) {
  return CA.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
a$2(Te, "escapeRegexpString");
function Ae(CA, gA) {
  gA.delimiter ??= "/#?", gA.prefixes ??= "./", gA.sensitive ??= !1, gA.strict ??= !1, gA.end ??= !0, gA.start ??= !0, gA.endsWith = "";
  let AA = ".*", IA = `[^${Te(gA.delimiter)}]+?`, BA = /[$_\u200C\u200D\p{ID_Continue}]/u, QA = "";
  for (let EA = 0; EA < CA.length; ++EA) {
    let iA = CA[EA];
    if (iA.type === 3) {
      if (iA.modifier === 3) {
        QA += I$2(iA.value);
        continue;
      }
      QA += `{${I$2(iA.value)}}${T$1(iA.modifier)}`;
      continue;
    }
    let oA = iA.hasCustomName(), cA = !!iA.suffix.length || !!iA.prefix.length && (iA.prefix.length !== 1 || !gA.prefixes.includes(iA.prefix)), tA = EA > 0 ? CA[EA - 1] : null, eA = EA < CA.length - 1 ? CA[EA + 1] : null;
    if (!cA && oA && iA.type === 1 && iA.modifier === 3 && eA && !eA.prefix.length && !eA.suffix.length) if (eA.type === 3) {
      let aA = eA.value.length > 0 ? eA.value[0] : "";
      cA = BA.test(aA);
    } else cA = !eA.hasCustomName();
    if (!cA && !iA.prefix.length && tA && tA.type === 3) {
      let aA = tA.value[tA.value.length - 1];
      cA = gA.prefixes.includes(aA);
    }
    cA && (QA += "{"), QA += I$2(iA.prefix), oA && (QA += `:${iA.name}`), iA.type === 2 ? QA += `(${iA.value})` : iA.type === 1 ? oA || (QA += `(${IA})`) : iA.type === 0 && (!oA && (!tA || tA.type === 3 || tA.modifier !== 3 || cA || iA.prefix !== "") ? QA += "*" : QA += `(${AA})`), iA.type === 1 && oA && iA.suffix.length && BA.test(iA.suffix[0]) && (QA += "\\"), QA += I$2(iA.suffix), cA && (QA += "}"), iA.modifier !== 3 && (QA += T$1(iA.modifier));
  }
  return QA;
}
a$2(Ae, "partsToPattern");
var Y$1 = class {
  #Q;
  #C = {};
  #I = {};
  #A = {};
  #B = {};
  #c = !1;
  constructor(gA = {}, AA, IA) {
    try {
      let BA;
      if (typeof AA == "string" ? BA = AA : IA = AA, typeof gA == "string") {
        let oA = new C$1(gA);
        if (oA.parse(), gA = oA.result, BA === void 0 && typeof gA.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
        gA.baseURL = BA;
      } else {
        if (!gA || typeof gA != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
        if (BA) throw new TypeError("parameter 1 is not of type 'string'.");
      }
      typeof IA > "u" && (IA = { ignoreCase: !1 });
      let QA = { ignoreCase: IA.ignoreCase === !0 }, EA = { pathname: O$1, protocol: O$1, username: O$1, password: O$1, hostname: O$1, port: O$1, search: O$1, hash: O$1 };
      this.#Q = L$2(EA, gA, !0), z$2(this.#Q.protocol) === this.#Q.port && (this.#Q.port = "");
      let iA;
      for (iA of V$2) {
        if (!(iA in this.#Q)) continue;
        let oA = {}, cA = this.#Q[iA];
        switch (this.#I[iA] = [], iA) {
          case "protocol":
            Object.assign(oA, b$1), oA.encodePart = w$2;
            break;
          case "username":
            Object.assign(oA, b$1), oA.encodePart = he;
            break;
          case "password":
            Object.assign(oA, b$1), oA.encodePart = ue;
            break;
          case "hostname":
            Object.assign(oA, J$2), _(cA) ? oA.encodePart = K$2 : oA.encodePart = j$1;
            break;
          case "port":
            Object.assign(oA, b$1), oA.encodePart = G$2;
            break;
          case "pathname":
            U$2(this.#C.protocol) ? (Object.assign(oA, Q$2, QA), oA.encodePart = de) : (Object.assign(oA, b$1, QA), oA.encodePart = pe);
            break;
          case "search":
            Object.assign(oA, b$1, QA), oA.encodePart = ge;
            break;
          case "hash":
            Object.assign(oA, b$1, QA), oA.encodePart = me;
            break;
        }
        try {
          this.#B[iA] = F$2(cA, oA), this.#C[iA] = W$2(this.#B[iA], this.#I[iA], oA), this.#A[iA] = Ae(this.#B[iA], oA), this.#c = this.#c || this.#B[iA].some((tA) => tA.type === 2);
        } catch {
          throw new TypeError(`invalid ${iA} pattern '${this.#Q[iA]}'.`);
        }
      }
    } catch (BA) {
      throw new TypeError(`Failed to construct 'URLPattern': ${BA.message}`);
    }
  }
  get [Symbol.toStringTag]() {
    return "URLPattern";
  }
  test(gA = {}, AA) {
    let IA = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof gA != "string" && AA) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof gA > "u") return !1;
    try {
      typeof gA == "object" ? IA = L$2(IA, gA, !1) : IA = L$2(IA, Se(gA, AA), !1);
    } catch {
      return !1;
    }
    let BA;
    for (BA of V$2) if (!this.#C[BA].exec(IA[BA])) return !1;
    return !0;
  }
  exec(gA = {}, AA) {
    let IA = { pathname: "", protocol: "", username: "", password: "", hostname: "", port: "", search: "", hash: "" };
    if (typeof gA != "string" && AA) throw new TypeError("parameter 1 is not of type 'string'.");
    if (typeof gA > "u") return;
    try {
      typeof gA == "object" ? IA = L$2(IA, gA, !1) : IA = L$2(IA, Se(gA, AA), !1);
    } catch {
      return null;
    }
    let BA = {};
    AA ? BA.inputs = [gA, AA] : BA.inputs = [gA];
    let QA;
    for (QA of V$2) {
      let EA = this.#C[QA].exec(IA[QA]);
      if (!EA) return null;
      let iA = {};
      for (let [oA, cA] of this.#I[QA].entries()) if (typeof cA == "string" || typeof cA == "number") {
        let tA = EA[oA + 1];
        iA[cA] = tA;
      }
      BA[QA] = { input: IA[QA] ?? "", groups: iA };
    }
    return BA;
  }
  static compareComponent(gA, AA, IA) {
    let BA = a$2((oA, cA) => {
      for (let tA of ["type", "modifier", "prefix", "value", "suffix"]) {
        if (oA[tA] < cA[tA]) return -1;
        if (oA[tA] !== cA[tA])
          return 1;
      }
      return 0;
    }, "comparePart"), QA = new P$1(3, "", "", "", "", 3), EA = new P$1(0, "", "", "", "", 3), iA = a$2((oA, cA) => {
      let tA = 0;
      for (; tA < Math.min(oA.length, cA.length); ++tA) {
        let eA = BA(oA[tA], cA[tA]);
        if (eA) return eA;
      }
      return oA.length === cA.length ? 0 : BA(oA[tA] ?? QA, cA[tA] ?? QA);
    }, "comparePartList");
    return !AA.#A[gA] && !IA.#A[gA] ? 0 : AA.#A[gA] && !IA.#A[gA] ? iA(AA.#B[gA], [EA]) : !AA.#A[gA] && IA.#A[gA] ? iA([EA], IA.#B[gA]) : iA(AA.#B[gA], IA.#B[gA]);
  }
  get protocol() {
    return this.#A.protocol;
  }
  get username() {
    return this.#A.username;
  }
  get password() {
    return this.#A.password;
  }
  get hostname() {
    return this.#A.hostname;
  }
  get port() {
    return this.#A.port;
  }
  get pathname() {
    return this.#A.pathname;
  }
  get search() {
    return this.#A.search;
  }
  get hash() {
    return this.#A.hash;
  }
  get hasRegExpGroups() {
    return this.#c;
  }
};
a$2(Y$1, "URLPattern");
globalThis.URLPattern || (globalThis.URLPattern = Y$1);
function isValidOrigin(CA, gA) {
  let AA, IA, BA;
  try {
    AA = new URLPattern(CA), IA = new URLPattern({
      protocol: AA.protocol,
      hostname: AA.hostname
    }), BA = new URL(gA);
  } catch {
    return !1;
  }
  return BA.hostname === "localhost" && IA.test(BA) ? !0 : AA.test(BA);
}
function getCrossOriginAttribute(CA, gA) {
  if (gA)
    try {
      const AA = new URL(gA);
      return StreamlitConfig.BACKEND_BASE_URL && AA.origin === new URL(StreamlitConfig.BACKEND_BASE_URL).origin ? CA : void 0;
    } catch {
      return StreamlitConfig.BACKEND_BASE_URL ? CA : void 0;
    }
}
const useCrossOriginAttribute = (CA) => {
  const {
    resourceCrossOriginMode: gA
  } = useContext(LibConfigContext);
  if (CA)
    return getCrossOriginAttribute(gA, CA);
}, useEmotionTheme = () => useTheme(), StyledChatMessageContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq4"
} : {
  target: "eeusbqq4",
  label: "StyledChatMessageContainer"
})(({
  theme: CA,
  background: gA
}) => {
  const AA = hasLightBackgroundColor(CA);
  return {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    gap: CA.spacing.sm,
    padding: CA.spacing.lg,
    paddingRight: gA ? CA.spacing.lg : 0,
    borderRadius: CA.radii.default,
    ...gA ? {
      backgroundColor: transparentize(AA ? CA.colors.gray20 : CA.colors.gray90, 0.5)
    } : {}
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9DaGF0TWVzc2FnZS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQkUiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0NoYXRNZXNzYWdlL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHsgaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IgfSBmcm9tIFwifmxpYi90aGVtZS9nZXRDb2xvcnNcIlxuXG5pbnRlcmZhY2UgU3R5bGVkQ2hhdE1lc3NhZ2VDb250YWluZXJQcm9wcyB7XG4gIGJhY2tncm91bmQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZENoYXRNZXNzYWdlQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRDaGF0TWVzc2FnZUNvbnRhaW5lclByb3BzPigoeyB0aGVtZSwgYmFja2dyb3VuZCB9KSA9PiB7XG4gICAgY29uc3QgbGlnaHRUaGVtZSA9IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKVxuICAgIHJldHVybiB7XG4gICAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGFsaWduSXRlbXM6IFwiZmxleC1zdGFydFwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgIHBhZGRpbmdSaWdodDogYmFja2dyb3VuZCA/IHRoZW1lLnNwYWNpbmcubGcgOiAwLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgLi4uKGJhY2tncm91bmRcbiAgICAgICAgPyB7XG4gICAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IGxpZ2h0VGhlbWVcbiAgICAgICAgICAgICAgPyB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuZ3JheTIwLCAwLjUpXG4gICAgICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmdyYXk5MCwgMC41KSxcbiAgICAgICAgICB9XG4gICAgICAgIDoge30pLFxuICAgIH1cbiAgfSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lc3NhZ2VDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICBtYXJnaW46IFwiYXV0b1wiLFxuICBmbGV4R3JvdzogMSxcbiAgLy8gRW5zdXJlIHRoZSBzaXplIG9mIHRoZSBtZXNzYWdlIGhhcyBhbiBpbnRlcnByZXRlZCB3aWR0aCBhc1xuICAvLyB0aGUgYW1vdW50IGRlZmluZWQgYnkgZmxleCBsYXlvdXQgYW5kIGRpc3JlZ2FyZCBpdHMgY29udGVudHNcbiAgLy8gdGhleSB3aWxsIGhhbmRsZSB0aGVpciBvdmVyZmxvdy5cbiAgLy9cbiAgLy8gVW5pbnR1aXRpdmVseSwgc2V0dGluZyB0aGUgbWluIHdpZHRoIHRvIDAgdGVsbHMgdGhlIGJyb3dzZXJcbiAgLy8gdGhhdCBpdCBjYW4gc2hyaW5rIHBhc3QgdGhlIGNvbnRlbnQncyB3aWR0aCB0byB0aGUgZGVzaXJlZCBzaXplLlxuICAvLyBodHRwczovL21ha2FuZHJhY2FyZHMuY29tL21ha2FuZHJhLzY2OTk0LWNzcy1mbGV4LWFuZC1taW4td2lkdGhcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEF2YXRhckJhY2tncm91bmQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+IHtcbiAgY29uc3QgbGlnaHRUaGVtZSA9IGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yKHRoZW1lKVxuICByZXR1cm4ge1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7XG4gICAgICBsaWdodFRoZW1lID8gdGhlbWUuY29sb3JzLmdyYXk0MCA6IHRoZW1lLmNvbG9ycy5ncmF5ODVcbiAgICB9YCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGxpZ2h0VGhlbWUgPyB0aGVtZS5jb2xvcnMud2hpdGUgOiB0aGVtZS5jb2xvcnMuZ3JheTEwMCxcbiAgICBjb2xvcjogbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy5ncmF5OTAgOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubm9uZSxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLm1kLFxuICAgIC8vIEVuc3VyZSB0aGUgYXZhdGFyIGFsd2F5cyByZXNwZWN0cyB0aGUgd2lkdGgvaGVpZ2h0XG4gICAgZmxleFNocmluazogMCxcbiAgICB3aWR0aDogdGhlbWUuc2l6ZXMuY2hhdEF2YXRhclNpemUsXG4gICAgaGVpZ2h0OiB0aGVtZS5zaXplcy5jaGF0QXZhdGFyU2l6ZSxcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgfVxufSlcblxuaW50ZXJmYWNlIFN0eWxlZEF2YXRhckljb25Qcm9wcyB7XG4gIGJhY2tncm91bmQ6IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXZhdGFySWNvbiA9IHN0eWxlZC5kaXY8U3R5bGVkQXZhdGFySWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGJhY2tncm91bmQgfSkgPT4ge1xuICAgIGNvbnN0IGxpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICB3aWR0aDogdGhlbWUuc2l6ZXMuY2hhdEF2YXRhclNpemUsXG4gICAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmNoYXRBdmF0YXJTaXplLFxuICAgICAgLy8gRW5zdXJlIHRoZSBhdmF0YXIgYWx3YXlzIHJlc3BlY3RzIHRoZSB3aWR0aC9oZWlnaHRcbiAgICAgIGZsZXhTaHJpbms6IDAsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IGJhY2tncm91bmQsXG4gICAgICBjb2xvcjogbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy53aGl0ZSA6IHRoZW1lLmNvbG9ycy5ncmF5MTAwLFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQXZhdGFySW1hZ2UgPSBzdHlsZWQuaW1nKCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICB3aWR0aDogdGhlbWUuc2l6ZXMuY2hhdEF2YXRhclNpemUsXG4gICAgaGVpZ2h0OiB0aGVtZS5zaXplcy5jaGF0QXZhdGFyU2l6ZSxcbiAgICAvLyBFbnN1cmUgdGhlIGF2YXRhciBhbHdheXMgcmVzcGVjdHMgdGhlIHdpZHRoL2hlaWdodFxuICAgIGZsZXhTaHJpbms6IDAsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG9iamVjdEZpdDogXCJjb3ZlclwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICB9XG59KVxuIl19 */"), StyledMessageContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq3"
} : {
  target: "eeusbqq3",
  label: "StyledMessageContent"
})(({
  theme: CA
}) => ({
  color: CA.colors.bodyText,
  margin: "auto",
  flexGrow: 1,
  // Ensure the size of the message has an interpreted width as
  // the amount defined by flex layout and disregard its contents
  // they will handle their overflow.
  //
  // Unintuitively, setting the min width to 0 tells the browser
  // that it can shrink past the content's width to the desired size.
  // https://makandracards.com/makandra/66994-css-flex-and-min-width
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarBackground = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq2"
} : {
  target: "eeusbqq2",
  label: "StyledAvatarBackground"
})(({
  theme: CA
}) => {
  const gA = hasLightBackgroundColor(CA);
  return {
    display: "flex",
    border: `${CA.sizes.borderWidth} solid ${gA ? CA.colors.gray40 : CA.colors.gray85}`,
    backgroundColor: gA ? CA.colors.white : CA.colors.gray100,
    color: gA ? CA.colors.gray90 : CA.colors.white,
    lineHeight: CA.lineHeights.none,
    fontSize: CA.fontSizes.md,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    width: CA.sizes.chatAvatarSize,
    height: CA.sizes.chatAvatarSize,
    borderRadius: CA.radii.default,
    alignItems: "center",
    justifyContent: "center"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq1"
} : {
  target: "eeusbqq1",
  label: "StyledAvatarIcon"
})(({
  theme: CA,
  background: gA
}) => {
  const AA = hasLightBackgroundColor(CA);
  return {
    display: "flex",
    width: CA.sizes.chatAvatarSize,
    height: CA.sizes.chatAvatarSize,
    // Ensure the avatar always respects the width/height
    flexShrink: 0,
    borderRadius: CA.radii.default,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: gA,
    color: AA ? CA.colors.white : CA.colors.gray100
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAvatarImage = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eeusbqq0"
} : {
  target: "eeusbqq0",
  label: "StyledAvatarImage"
})(({
  theme: CA
}) => ({
  width: CA.sizes.chatAvatarSize,
  height: CA.sizes.chatAvatarSize,
  // Ensure the avatar always respects the width/height
  flexShrink: 0,
  borderRadius: CA.radii.default,
  objectFit: "cover",
  display: "flex"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ChatMessageAvatar(CA) {
  const {
    avatar: gA,
    avatarType: AA,
    name: IA,
    endpoints: BA
  } = CA, QA = useEmotionTheme(), EA = useCrossOriginAttribute(gA);
  if (gA)
    switch (AA) {
      case void 0:
        break;
      case Block$1.ChatMessage.AvatarType.IMAGE:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarImage, { src: BA.buildMediaURL(gA), alt: `${IA} avatar`, crossOrigin: EA });
      case Block$1.ChatMessage.AvatarType.EMOJI:
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: gA });
      case Block$1.ChatMessage.AvatarType.ICON:
        if (gA === "user")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarUser", background: QA.colors.redColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/face:" }) });
        if (gA === "assistant")
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarIcon, { "data-testid": "stChatMessageAvatarAssistant", background: QA.colors.orangeColor, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/smart_toy:" }) });
        if (gA.startsWith(":material"))
          return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { "data-testid": "stChatMessageAvatarCustom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: gA, color: QA.colors.bodyText }) });
    }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAvatarBackground, { children: IA ? IA.charAt(0).toUpperCase() : "🧑‍💻" });
}
const ChatMessage = ({
  endpoints: CA,
  element: gA,
  children: AA
}) => {
  const {
    avatar: IA,
    avatarType: BA,
    name: QA
  } = gA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledChatMessageContainer, { className: "stChatMessage", "data-testid": "stChatMessage", background: ["user", "human"].includes(QA.toLowerCase()), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessageAvatar, { name: QA, avatar: IA, avatarType: BA, endpoints: CA }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageContent, { "data-testid": "stChatMessageContent", "aria-label": `Chat message from ${QA}`, children: AA })
  ] });
}, ChatMessage$1 = memo(ChatMessage), IsDialogContext = createContext(!1);
IsDialogContext.displayName = "IsDialogContext";
function _objectWithoutPropertiesLoose$c(CA, gA) {
  if (CA == null) return {};
  var AA = {};
  for (var IA in CA) if ({}.hasOwnProperty.call(CA, IA)) {
    if (gA.indexOf(IA) !== -1) continue;
    AA[IA] = CA[IA];
  }
  return AA;
}
var propTypes$1 = { exports: {} };
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var CA = Object.getOwnPropertySymbols, gA = Object.prototype.hasOwnProperty, AA = Object.prototype.propertyIsEnumerable;
  function IA(QA) {
    if (QA == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(QA);
  }
  function BA() {
    try {
      if (!Object.assign)
        return !1;
      var QA = new String("abc");
      if (QA[5] = "de", Object.getOwnPropertyNames(QA)[0] === "5")
        return !1;
      for (var EA = {}, iA = 0; iA < 10; iA++)
        EA["_" + String.fromCharCode(iA)] = iA;
      var oA = Object.getOwnPropertyNames(EA).map(function(tA) {
        return EA[tA];
      });
      if (oA.join("") !== "0123456789")
        return !1;
      var cA = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(tA) {
        cA[tA] = tA;
      }), Object.keys(Object.assign({}, cA)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = BA() ? Object.assign : function(QA, EA) {
    for (var iA, oA = IA(QA), cA, tA = 1; tA < arguments.length; tA++) {
      iA = Object(arguments[tA]);
      for (var eA in iA)
        gA.call(iA, eA) && (oA[eA] = iA[eA]);
      if (CA) {
        cA = CA(iA);
        for (var aA = 0; aA < cA.length; aA++)
          AA.call(iA, cA[aA]) && (oA[cA[aA]] = iA[cA[aA]]);
      }
    }
    return oA;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var CA = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = CA, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var CA = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var gA = /* @__PURE__ */ requireReactPropTypesSecret(), AA = {}, IA = /* @__PURE__ */ requireHas();
    CA = function(QA) {
      var EA = "Warning: " + QA;
      typeof console < "u" && console.error(EA);
      try {
        throw new Error(EA);
      } catch {
      }
    };
  }
  function BA(QA, EA, iA, oA, cA) {
    if (process.env.NODE_ENV !== "production") {
      for (var tA in QA)
        if (IA(QA, tA)) {
          var eA;
          try {
            if (typeof QA[tA] != "function") {
              var aA = Error(
                (oA || "React class") + ": " + iA + " type `" + tA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof QA[tA] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw aA.name = "Invariant Violation", aA;
            }
            eA = QA[tA](EA, tA, oA, iA, null, gA);
          } catch (lA) {
            eA = lA;
          }
          if (eA && !(eA instanceof Error) && CA(
            (oA || "React class") + ": type specification of " + iA + " `" + tA + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof eA + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), eA instanceof Error && !(eA.message in AA)) {
            AA[eA.message] = !0;
            var GA = cA ? cA() : "";
            CA(
              "Failed " + iA + " type: " + eA.message + (GA ?? "")
            );
          }
        }
    }
  }
  return BA.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (AA = {});
  }, checkPropTypes_1 = BA, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var CA = requireReactIs$1(), gA = requireObjectAssign(), AA = /* @__PURE__ */ requireReactPropTypesSecret(), IA = /* @__PURE__ */ requireHas(), BA = /* @__PURE__ */ requireCheckPropTypes(), QA = function() {
  };
  process.env.NODE_ENV !== "production" && (QA = function(iA) {
    var oA = "Warning: " + iA;
    typeof console < "u" && console.error(oA);
    try {
      throw new Error(oA);
    } catch {
    }
  });
  function EA() {
    return null;
  }
  return factoryWithTypeCheckers = function(iA, oA) {
    var cA = typeof Symbol == "function" && Symbol.iterator, tA = "@@iterator";
    function eA(uA) {
      var HA = uA && (cA && uA[cA] || uA[tA]);
      if (typeof HA == "function")
        return HA;
    }
    var aA = "<<anonymous>>", GA = {
      array: hA("array"),
      bigint: hA("bigint"),
      bool: hA("boolean"),
      func: hA("function"),
      number: hA("number"),
      object: hA("object"),
      string: hA("string"),
      symbol: hA("symbol"),
      any: wA(),
      arrayOf: sA,
      element: NA(),
      elementType: rA(),
      instanceOf: yA,
      node: dA(),
      objectOf: RA,
      oneOf: bA,
      oneOfType: FA,
      shape: pA,
      exact: YA
    };
    function lA(uA, HA) {
      return uA === HA ? uA !== 0 || 1 / uA === 1 / HA : uA !== uA && HA !== HA;
    }
    function nA(uA, HA) {
      this.message = uA, this.data = HA && typeof HA == "object" ? HA : {}, this.stack = "";
    }
    nA.prototype = Error.prototype;
    function DA(uA) {
      if (process.env.NODE_ENV !== "production")
        var HA = {}, TA = 0;
      function ZA(QI, LA, PA, XA, EI, CI, II) {
        if (XA = XA || aA, CI = CI || PA, II !== AA) {
          if (oA) {
            var vA = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw vA.name = "Invariant Violation", vA;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var wI = XA + ":" + PA;
            !HA[wI] && // Avoid spamming the console because they are often not actionable except for lib authors
            TA < 3 && (QA(
              "You are manually calling a React.PropTypes validation function for the `" + CI + "` prop on `" + XA + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), HA[wI] = !0, TA++);
          }
        }
        return LA[PA] == null ? QI ? LA[PA] === null ? new nA("The " + EI + " `" + CI + "` is marked as required " + ("in `" + XA + "`, but its value is `null`.")) : new nA("The " + EI + " `" + CI + "` is marked as required in " + ("`" + XA + "`, but its value is `undefined`.")) : null : uA(LA, PA, XA, EI, CI);
      }
      var AI = ZA.bind(null, !1);
      return AI.isRequired = ZA.bind(null, !0), AI;
    }
    function hA(uA) {
      function HA(TA, ZA, AI, QI, LA, PA) {
        var XA = TA[ZA], EI = UA(XA);
        if (EI !== uA) {
          var CI = fA(XA);
          return new nA(
            "Invalid " + QI + " `" + LA + "` of type " + ("`" + CI + "` supplied to `" + AI + "`, expected ") + ("`" + uA + "`."),
            { expectedType: uA }
          );
        }
        return null;
      }
      return DA(HA);
    }
    function wA() {
      return DA(EA);
    }
    function sA(uA) {
      function HA(TA, ZA, AI, QI, LA) {
        if (typeof uA != "function")
          return new nA("Property `" + LA + "` of component `" + AI + "` has invalid PropType notation inside arrayOf.");
        var PA = TA[ZA];
        if (!Array.isArray(PA)) {
          var XA = UA(PA);
          return new nA("Invalid " + QI + " `" + LA + "` of type " + ("`" + XA + "` supplied to `" + AI + "`, expected an array."));
        }
        for (var EI = 0; EI < PA.length; EI++) {
          var CI = uA(PA, EI, AI, QI, LA + "[" + EI + "]", AA);
          if (CI instanceof Error)
            return CI;
        }
        return null;
      }
      return DA(HA);
    }
    function NA() {
      function uA(HA, TA, ZA, AI, QI) {
        var LA = HA[TA];
        if (!iA(LA)) {
          var PA = UA(LA);
          return new nA("Invalid " + AI + " `" + QI + "` of type " + ("`" + PA + "` supplied to `" + ZA + "`, expected a single ReactElement."));
        }
        return null;
      }
      return DA(uA);
    }
    function rA() {
      function uA(HA, TA, ZA, AI, QI) {
        var LA = HA[TA];
        if (!CA.isValidElementType(LA)) {
          var PA = UA(LA);
          return new nA("Invalid " + AI + " `" + QI + "` of type " + ("`" + PA + "` supplied to `" + ZA + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return DA(uA);
    }
    function yA(uA) {
      function HA(TA, ZA, AI, QI, LA) {
        if (!(TA[ZA] instanceof uA)) {
          var PA = uA.name || aA, XA = _A(TA[ZA]);
          return new nA("Invalid " + QI + " `" + LA + "` of type " + ("`" + XA + "` supplied to `" + AI + "`, expected ") + ("instance of `" + PA + "`."));
        }
        return null;
      }
      return DA(HA);
    }
    function bA(uA) {
      if (!Array.isArray(uA))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? QA(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : QA("Invalid argument supplied to oneOf, expected an array.")), EA;
      function HA(TA, ZA, AI, QI, LA) {
        for (var PA = TA[ZA], XA = 0; XA < uA.length; XA++)
          if (lA(PA, uA[XA]))
            return null;
        var EI = JSON.stringify(uA, function(II, vA) {
          var wI = fA(vA);
          return wI === "symbol" ? String(vA) : vA;
        });
        return new nA("Invalid " + QI + " `" + LA + "` of value `" + String(PA) + "` " + ("supplied to `" + AI + "`, expected one of " + EI + "."));
      }
      return DA(HA);
    }
    function RA(uA) {
      function HA(TA, ZA, AI, QI, LA) {
        if (typeof uA != "function")
          return new nA("Property `" + LA + "` of component `" + AI + "` has invalid PropType notation inside objectOf.");
        var PA = TA[ZA], XA = UA(PA);
        if (XA !== "object")
          return new nA("Invalid " + QI + " `" + LA + "` of type " + ("`" + XA + "` supplied to `" + AI + "`, expected an object."));
        for (var EI in PA)
          if (IA(PA, EI)) {
            var CI = uA(PA, EI, AI, QI, LA + "." + EI, AA);
            if (CI instanceof Error)
              return CI;
          }
        return null;
      }
      return DA(HA);
    }
    function FA(uA) {
      if (!Array.isArray(uA))
        return process.env.NODE_ENV !== "production" && QA("Invalid argument supplied to oneOfType, expected an instance of array."), EA;
      for (var HA = 0; HA < uA.length; HA++) {
        var TA = uA[HA];
        if (typeof TA != "function")
          return QA(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + zA(TA) + " at index " + HA + "."
          ), EA;
      }
      function ZA(AI, QI, LA, PA, XA) {
        for (var EI = [], CI = 0; CI < uA.length; CI++) {
          var II = uA[CI], vA = II(AI, QI, LA, PA, XA, AA);
          if (vA == null)
            return null;
          vA.data && IA(vA.data, "expectedType") && EI.push(vA.data.expectedType);
        }
        var wI = EI.length > 0 ? ", expected one of type [" + EI.join(", ") + "]" : "";
        return new nA("Invalid " + PA + " `" + XA + "` supplied to " + ("`" + LA + "`" + wI + "."));
      }
      return DA(ZA);
    }
    function dA() {
      function uA(HA, TA, ZA, AI, QI) {
        return SA(HA[TA]) ? null : new nA("Invalid " + AI + " `" + QI + "` supplied to " + ("`" + ZA + "`, expected a ReactNode."));
      }
      return DA(uA);
    }
    function kA(uA, HA, TA, ZA, AI) {
      return new nA(
        (uA || "React class") + ": " + HA + " type `" + TA + "." + ZA + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + AI + "`."
      );
    }
    function pA(uA) {
      function HA(TA, ZA, AI, QI, LA) {
        var PA = TA[ZA], XA = UA(PA);
        if (XA !== "object")
          return new nA("Invalid " + QI + " `" + LA + "` of type `" + XA + "` " + ("supplied to `" + AI + "`, expected `object`."));
        for (var EI in uA) {
          var CI = uA[EI];
          if (typeof CI != "function")
            return kA(AI, QI, LA, EI, fA(CI));
          var II = CI(PA, EI, AI, QI, LA + "." + EI, AA);
          if (II)
            return II;
        }
        return null;
      }
      return DA(HA);
    }
    function YA(uA) {
      function HA(TA, ZA, AI, QI, LA) {
        var PA = TA[ZA], XA = UA(PA);
        if (XA !== "object")
          return new nA("Invalid " + QI + " `" + LA + "` of type `" + XA + "` " + ("supplied to `" + AI + "`, expected `object`."));
        var EI = gA({}, TA[ZA], uA);
        for (var CI in EI) {
          var II = uA[CI];
          if (IA(uA, CI) && typeof II != "function")
            return kA(AI, QI, LA, CI, fA(II));
          if (!II)
            return new nA(
              "Invalid " + QI + " `" + LA + "` key `" + CI + "` supplied to `" + AI + "`.\nBad object: " + JSON.stringify(TA[ZA], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(uA), null, "  ")
            );
          var vA = II(PA, CI, AI, QI, LA + "." + CI, AA);
          if (vA)
            return vA;
        }
        return null;
      }
      return DA(HA);
    }
    function SA(uA) {
      switch (typeof uA) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !uA;
        case "object":
          if (Array.isArray(uA))
            return uA.every(SA);
          if (uA === null || iA(uA))
            return !0;
          var HA = eA(uA);
          if (HA) {
            var TA = HA.call(uA), ZA;
            if (HA !== uA.entries) {
              for (; !(ZA = TA.next()).done; )
                if (!SA(ZA.value))
                  return !1;
            } else
              for (; !(ZA = TA.next()).done; ) {
                var AI = ZA.value;
                if (AI && !SA(AI[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function JA(uA, HA) {
      return uA === "symbol" ? !0 : HA ? HA["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && HA instanceof Symbol : !1;
    }
    function UA(uA) {
      var HA = typeof uA;
      return Array.isArray(uA) ? "array" : uA instanceof RegExp ? "object" : JA(HA, uA) ? "symbol" : HA;
    }
    function fA(uA) {
      if (typeof uA > "u" || uA === null)
        return "" + uA;
      var HA = UA(uA);
      if (HA === "object") {
        if (uA instanceof Date)
          return "date";
        if (uA instanceof RegExp)
          return "regexp";
      }
      return HA;
    }
    function zA(uA) {
      var HA = fA(uA);
      switch (HA) {
        case "array":
        case "object":
          return "an " + HA;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + HA;
        default:
          return HA;
      }
    }
    function _A(uA) {
      return !uA.constructor || !uA.constructor.name ? aA : uA.constructor.name;
    }
    return GA.checkPropTypes = BA, GA.resetWarningCache = BA.resetWarningCache, GA.PropTypes = GA, GA;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var CA = /* @__PURE__ */ requireReactPropTypesSecret();
  function gA() {
  }
  function AA() {
  }
  return AA.resetWarningCache = gA, factoryWithThrowingShims = function() {
    function IA(EA, iA, oA, cA, tA, eA) {
      if (eA !== CA) {
        var aA = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw aA.name = "Invariant Violation", aA;
      }
    }
    IA.isRequired = IA;
    function BA() {
      return IA;
    }
    var QA = {
      array: IA,
      bigint: IA,
      bool: IA,
      func: IA,
      number: IA,
      object: IA,
      string: IA,
      symbol: IA,
      any: IA,
      arrayOf: BA,
      element: IA,
      elementType: IA,
      instanceOf: BA,
      node: IA,
      objectOf: BA,
      oneOf: BA,
      oneOfType: BA,
      shape: BA,
      exact: BA,
      checkPropTypes: AA,
      resetWarningCache: gA
    };
    return QA.PropTypes = QA, QA;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes$1.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var CA = requireReactIs$1(), gA = !0;
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(CA.isElement, gA);
  } else
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes$1.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var FOCUS_GROUP = "data-focus-lock", FOCUS_DISABLED = "data-focus-lock-disabled", FOCUS_ALLOW = "data-no-focus-lock", FOCUS_AUTO = "data-autofocus-inside", FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
function assignRef(CA, gA) {
  return typeof CA == "function" ? CA(gA) : CA && (CA.current = gA), CA;
}
function useCallbackRef(CA, gA) {
  var AA = useState(function() {
    return {
      // value
      value: CA,
      // last callback
      callback: gA,
      // "memoized" public interface
      facade: {
        get current() {
          return AA.value;
        },
        set current(IA) {
          var BA = AA.value;
          BA !== IA && (AA.value = IA, AA.callback(IA, BA));
        }
      }
    };
  })[0];
  return AA.callback = gA, AA.facade;
}
var useIsomorphicLayoutEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect, currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(CA, gA) {
  var AA = useCallbackRef(null, function(IA) {
    return CA.forEach(function(BA) {
      return assignRef(BA, IA);
    });
  });
  return useIsomorphicLayoutEffect(function() {
    var IA = currentValues.get(AA);
    if (IA) {
      var BA = new Set(IA), QA = new Set(CA), EA = AA.current;
      BA.forEach(function(iA) {
        QA.has(iA) || assignRef(iA, null);
      }), QA.forEach(function(iA) {
        BA.has(iA) || assignRef(iA, EA);
      });
    }
    currentValues.set(AA, CA);
  }, [CA]), AA;
}
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && PropTypes.node;
function ItoI(CA) {
  return CA;
}
function innerCreateMedium(CA, gA) {
  gA === void 0 && (gA = ItoI);
  var AA = [], IA = !1, BA = {
    read: function() {
      if (IA)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return AA.length ? AA[AA.length - 1] : CA;
    },
    useMedium: function(QA) {
      var EA = gA(QA, IA);
      return AA.push(EA), function() {
        AA = AA.filter(function(iA) {
          return iA !== EA;
        });
      };
    },
    assignSyncMedium: function(QA) {
      for (IA = !0; AA.length; ) {
        var EA = AA;
        AA = [], EA.forEach(QA);
      }
      AA = {
        push: function(iA) {
          return QA(iA);
        },
        filter: function() {
          return AA;
        }
      };
    },
    assignMedium: function(QA) {
      IA = !0;
      var EA = [];
      if (AA.length) {
        var iA = AA;
        AA = [], iA.forEach(QA), EA = AA;
      }
      var oA = function() {
        var tA = EA;
        EA = [], tA.forEach(QA);
      }, cA = function() {
        return Promise.resolve().then(oA);
      };
      cA(), AA = {
        push: function(tA) {
          EA.push(tA), cA();
        },
        filter: function(tA) {
          return EA = EA.filter(tA), AA;
        }
      };
    }
  };
  return BA;
}
function createMedium(CA, gA) {
  return gA === void 0 && (gA = ItoI), innerCreateMedium(CA, gA);
}
function createSidecarMedium(CA) {
  CA === void 0 && (CA = {});
  var gA = innerCreateMedium(null);
  return gA.options = __assign$2({ async: !0, ssr: !1 }, CA), gA;
}
var mediumFocus = createMedium({}, function(CA) {
  var gA = CA.target, AA = CA.currentTarget;
  return {
    target: gA,
    currentTarget: AA
  };
}), mediumBlur = createMedium(), mediumEffect = createMedium(), mediumSidecar = createSidecarMedium({
  async: !0,
  ssr: typeof document < "u"
}), focusScope = /* @__PURE__ */ createContext(void 0), emptyArray = [], FocusLock = /* @__PURE__ */ forwardRef(function CA(gA, AA) {
  var IA, BA = useState(), QA = BA[0], EA = BA[1], iA = useRef(), oA = useRef(!1), cA = useRef(null), tA = useState({}), eA = tA[1], aA = gA.children, GA = gA.disabled, lA = GA === void 0 ? !1 : GA, nA = gA.noFocusGuards, DA = nA === void 0 ? !1 : nA, hA = gA.persistentFocus, wA = hA === void 0 ? !1 : hA, sA = gA.crossFrame, NA = sA === void 0 ? !0 : sA, rA = gA.autoFocus, yA = rA === void 0 ? !0 : rA, bA = gA.allowTextSelection, RA = gA.group, FA = gA.className, dA = gA.whiteList, kA = gA.hasPositiveIndices, pA = gA.shards, YA = pA === void 0 ? emptyArray : pA, SA = gA.as, JA = SA === void 0 ? "div" : SA, UA = gA.lockProps, fA = UA === void 0 ? {} : UA, zA = gA.sideCar, _A = gA.returnFocus, uA = _A === void 0 ? !1 : _A, HA = gA.focusOptions, TA = gA.onActivation, ZA = gA.onDeactivation, AI = useState({}), QI = AI[0], LA = useCallback(function(nI) {
    var uI = nI.captureFocusRestore;
    if (!cA.current) {
      var hI, bI = (hI = document) == null ? void 0 : hI.activeElement;
      cA.current = bI, bI !== document.body && (cA.current = uI(bI));
    }
    iA.current && TA && TA(iA.current), oA.current = !0, eA();
  }, [TA]), PA = useCallback(function() {
    oA.current = !1, ZA && ZA(iA.current), eA();
  }, [ZA]), XA = useCallback(function(nI) {
    var uI = cA.current;
    if (uI) {
      var hI = (typeof uI == "function" ? uI() : uI) || document.body, bI = typeof uA == "function" ? uA(hI) : uA;
      if (bI) {
        var HI = typeof bI == "object" ? bI : void 0;
        cA.current = null, nI ? Promise.resolve().then(function() {
          return hI.focus(HI);
        }) : hI.focus(HI);
      }
    }
  }, [uA]), EI = useCallback(function(nI) {
    oA.current && mediumFocus.useMedium(nI);
  }, []), CI = mediumBlur.useMedium, II = useCallback(function(nI) {
    iA.current !== nI && (iA.current = nI, EA(nI));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof bA < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), useEffect(function() {
    !iA.current && typeof JA != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var vA = _extends$m((IA = {}, IA[FOCUS_DISABLED] = lA && "disabled", IA[FOCUS_GROUP] = RA, IA), fA), wI = DA !== !0, $A = wI && DA !== "tail", YI = useMergeRefs([AA, II]), FI = useMemo$1(function() {
    return {
      observed: iA,
      shards: YA,
      enabled: !lA,
      active: oA.current
    };
  }, [lA, oA.current, YA, QA]);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, wI && [
    /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: lA ? -1 : 0,
      style: hiddenGuard
    }),
    kA ? /* @__PURE__ */ React__default.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: lA ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !lA && /* @__PURE__ */ React__default.createElement(zA, {
    id: QI,
    sideCar: mediumSidecar,
    observed: QA,
    disabled: lA,
    persistentFocus: wA,
    crossFrame: NA,
    autoFocus: yA,
    whiteList: dA,
    shards: YA,
    onActivation: LA,
    onDeactivation: PA,
    returnFocus: XA,
    focusOptions: HA,
    noFocusGuards: DA
  }), /* @__PURE__ */ React__default.createElement(JA, _extends$m({
    ref: YI
  }, vA, {
    className: FA,
    onBlur: CI,
    onFocus: EI
  }), /* @__PURE__ */ React__default.createElement(focusScope.Provider, {
    value: FI
  }, aA)), $A && /* @__PURE__ */ React__default.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: lA ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
function _setPrototypeOf$9(CA, gA) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(AA, IA) {
    return AA.__proto__ = IA, AA;
  }, _setPrototypeOf$9(CA, gA);
}
function _inheritsLoose(CA, gA) {
  CA.prototype = Object.create(gA.prototype), CA.prototype.constructor = CA, _setPrototypeOf$9(CA, gA);
}
function _typeof$a(CA) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$a(CA);
}
function toPrimitive$2(CA, gA) {
  if (_typeof$a(CA) != "object" || !CA) return CA;
  var AA = CA[Symbol.toPrimitive];
  if (AA !== void 0) {
    var IA = AA.call(CA, gA);
    if (_typeof$a(IA) != "object") return IA;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (gA === "string" ? String : Number)(CA);
}
function toPropertyKey$2(CA) {
  var gA = toPrimitive$2(CA, "string");
  return _typeof$a(gA) == "symbol" ? gA : gA + "";
}
function _defineProperty$j(CA, gA, AA) {
  return (gA = toPropertyKey$2(gA)) in CA ? Object.defineProperty(CA, gA, {
    value: AA,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : CA[gA] = AA, CA;
}
function withSideEffect(CA, gA) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof CA != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof gA != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function AA(IA) {
    return IA.displayName || IA.name || "Component";
  }
  return function(BA) {
    if (process.env.NODE_ENV !== "production" && typeof BA != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var QA = [], EA;
    function iA() {
      EA = CA(QA.map(function(cA) {
        return cA.props;
      })), gA(EA);
    }
    var oA = /* @__PURE__ */ (function(cA) {
      _inheritsLoose(tA, cA);
      function tA() {
        return cA.apply(this, arguments) || this;
      }
      tA.peek = function() {
        return EA;
      };
      var eA = tA.prototype;
      return eA.componentDidMount = function() {
        QA.push(this), iA();
      }, eA.componentDidUpdate = function() {
        iA();
      }, eA.componentWillUnmount = function() {
        var GA = QA.indexOf(this);
        QA.splice(GA, 1), iA();
      }, eA.render = function() {
        return /* @__PURE__ */ React__default.createElement(BA, this.props);
      }, tA;
    })(PureComponent);
    return _defineProperty$j(oA, "displayName", "SideEffect(" + AA(BA) + ")"), oA;
  };
}
var toArray$2 = function(CA) {
  for (var gA = Array(CA.length), AA = 0; AA < CA.length; ++AA)
    gA[AA] = CA[AA];
  return gA;
}, asArray = function(CA) {
  return Array.isArray(CA) ? CA : [CA];
}, getFirst = function(CA) {
  return Array.isArray(CA) ? CA[0] : CA;
}, isElementHidden = function(CA) {
  if (CA.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var gA = window.getComputedStyle(CA, null);
  return !gA || !gA.getPropertyValue ? !1 : gA.getPropertyValue("display") === "none" || gA.getPropertyValue("visibility") === "hidden";
}, getParentNode = function(CA) {
  return CA.parentNode && CA.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CA.parentNode.host
  ) : CA.parentNode;
}, isTopNode = function(CA) {
  return CA === document || CA && CA.nodeType === Node.DOCUMENT_NODE;
}, isInert = function(CA) {
  return CA.hasAttribute("inert");
}, isVisibleUncached = function(CA, gA) {
  return !CA || isTopNode(CA) || !isElementHidden(CA) && !isInert(CA) && gA(getParentNode(CA));
}, isVisibleCached = function(CA, gA) {
  var AA = CA.get(gA);
  if (AA !== void 0)
    return AA;
  var IA = isVisibleUncached(gA, isVisibleCached.bind(void 0, CA));
  return CA.set(gA, IA), IA;
}, isAutoFocusAllowedUncached = function(CA, gA) {
  return CA && !isTopNode(CA) ? isAutoFocusAllowed(CA) ? gA(getParentNode(CA)) : !1 : !0;
}, isAutoFocusAllowedCached = function(CA, gA) {
  var AA = CA.get(gA);
  if (AA !== void 0)
    return AA;
  var IA = isAutoFocusAllowedUncached(gA, isAutoFocusAllowedCached.bind(void 0, CA));
  return CA.set(gA, IA), IA;
}, getDataset = function(CA) {
  return CA.dataset;
}, isHTMLButtonElement = function(CA) {
  return CA.tagName === "BUTTON";
}, isHTMLInputElement = function(CA) {
  return CA.tagName === "INPUT";
}, isRadioElement = function(CA) {
  return isHTMLInputElement(CA) && CA.type === "radio";
}, notHiddenInput = function(CA) {
  return !((isHTMLInputElement(CA) || isHTMLButtonElement(CA)) && (CA.type === "hidden" || CA.disabled));
}, isAutoFocusAllowed = function(CA) {
  var gA = CA.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![!0, "true", ""].includes(gA);
}, isGuard = function(CA) {
  var gA;
  return !!(CA && (!((gA = getDataset(CA)) === null || gA === void 0) && gA.focusGuard));
}, isNotAGuard = function(CA) {
  return !isGuard(CA);
}, isDefined = function(CA) {
  return !!CA;
}, tabSort = function(CA, gA) {
  var AA = Math.max(0, CA.tabIndex), IA = Math.max(0, gA.tabIndex), BA = AA - IA, QA = CA.index - gA.index;
  if (BA) {
    if (!AA)
      return 1;
    if (!IA)
      return -1;
  }
  return BA || QA;
}, getTabIndex = function(CA) {
  return CA.tabIndex < 0 && !CA.hasAttribute("tabindex") ? 0 : CA.tabIndex;
}, orderByTabIndex = function(CA, gA, AA) {
  return toArray$2(CA).map(function(IA, BA) {
    var QA = getTabIndex(IA);
    return {
      node: IA,
      index: BA,
      tabIndex: AA && QA === -1 ? (IA.dataset || {}).focusGuard ? 0 : -1 : QA
    };
  }).filter(function(IA) {
    return !gA || IA.tabIndex >= 0;
  }).sort(tabSort);
}, tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], queryTabbables = tabbables.join(","), queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]"), getFocusablesWithShadowDom = function(CA, gA) {
  return toArray$2((CA.shadowRoot || CA).children).reduce(function(AA, IA) {
    return AA.concat(IA.matches(gA ? queryGuardTabbables : queryTabbables) ? [IA] : [], getFocusablesWithShadowDom(IA));
  }, []);
}, getFocusablesWithIFrame = function(CA, gA) {
  var AA;
  return CA instanceof HTMLIFrameElement && (!((AA = CA.contentDocument) === null || AA === void 0) && AA.body) ? getFocusables([CA.contentDocument.body], gA) : [CA];
}, getFocusables = function(CA, gA) {
  return CA.reduce(function(AA, IA) {
    var BA, QA = getFocusablesWithShadowDom(IA, gA), EA = (BA = []).concat.apply(BA, QA.map(function(iA) {
      return getFocusablesWithIFrame(iA, gA);
    }));
    return AA.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      EA,
      // add if node is tabbable itself
      IA.parentNode ? toArray$2(IA.parentNode.querySelectorAll(queryTabbables)).filter(function(iA) {
        return iA === IA;
      }) : []
    );
  }, []);
}, getParentAutofocusables = function(CA) {
  var gA = CA.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray$2(gA).map(function(AA) {
    return getFocusables([AA]);
  }).reduce(function(AA, IA) {
    return AA.concat(IA);
  }, []);
}, filterFocusable = function(CA, gA) {
  return toArray$2(CA).filter(function(AA) {
    return isVisibleCached(gA, AA);
  }).filter(function(AA) {
    return notHiddenInput(AA);
  });
}, filterAutoFocusable = function(CA, gA) {
  return gA === void 0 && (gA = /* @__PURE__ */ new Map()), toArray$2(CA).filter(function(AA) {
    return isAutoFocusAllowedCached(gA, AA);
  });
}, getTabbableNodes = function(CA, gA, AA) {
  return orderByTabIndex(filterFocusable(getFocusables(CA, AA), gA), !0, AA);
}, getFocusableNodes = function(CA, gA) {
  return orderByTabIndex(filterFocusable(getFocusables(CA), gA), !1);
}, parentAutofocusables = function(CA, gA) {
  return filterFocusable(getParentAutofocusables(CA), gA);
}, contains = function(CA, gA) {
  return CA.shadowRoot ? contains(CA.shadowRoot, gA) : Object.getPrototypeOf(CA).contains !== void 0 && Object.getPrototypeOf(CA).contains.call(CA, gA) ? !0 : toArray$2(CA.children).some(function(AA) {
    var IA;
    if (AA instanceof HTMLIFrameElement) {
      var BA = (IA = AA.contentDocument) === null || IA === void 0 ? void 0 : IA.body;
      return BA ? contains(BA, gA) : !1;
    }
    return contains(AA, gA);
  });
}, filterNested = function(CA) {
  for (var gA = /* @__PURE__ */ new Set(), AA = CA.length, IA = 0; IA < AA; IA += 1)
    for (var BA = IA + 1; BA < AA; BA += 1) {
      var QA = CA[IA].compareDocumentPosition(CA[BA]);
      (QA & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && gA.add(BA), (QA & Node.DOCUMENT_POSITION_CONTAINS) > 0 && gA.add(IA);
    }
  return CA.filter(function(EA, iA) {
    return !gA.has(iA);
  });
}, getTopParent = function(CA) {
  return CA.parentNode ? getTopParent(CA.parentNode) : CA;
}, getAllAffectedNodes = function(CA) {
  var gA = asArray(CA);
  return gA.filter(Boolean).reduce(function(AA, IA) {
    var BA = IA.getAttribute(FOCUS_GROUP);
    return AA.push.apply(AA, BA ? filterNested(toArray$2(getTopParent(IA).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(BA, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [IA]), AA;
  }, []);
}, safeProbe = function(CA) {
  try {
    return CA();
  } catch {
    return;
  }
}, getActiveElement = function(CA) {
  if (CA === void 0 && (CA = document), !(!CA || !CA.activeElement)) {
    var gA = CA.activeElement;
    return gA.shadowRoot ? getActiveElement(gA.shadowRoot) : gA instanceof HTMLIFrameElement && safeProbe(function() {
      return gA.contentWindow.document;
    }) ? getActiveElement(gA.contentWindow.document) : gA;
  }
}, focusInFrame = function(CA, gA) {
  return CA === gA;
}, focusInsideIframe = function(CA, gA) {
  return !!toArray$2(CA.querySelectorAll("iframe")).some(function(AA) {
    return focusInFrame(AA, gA);
  });
}, focusInside = function(CA, gA) {
  return gA === void 0 && (gA = getActiveElement(getFirst(CA).ownerDocument)), !gA || gA.dataset && gA.dataset.focusGuard ? !1 : getAllAffectedNodes(CA).some(function(AA) {
    return contains(AA, gA) || focusInsideIframe(AA, gA);
  });
}, focusIsHidden = function(CA) {
  CA === void 0 && (CA = document);
  var gA = getActiveElement(CA);
  return gA ? toArray$2(CA.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(AA) {
    return contains(AA, gA);
  }) : !1;
}, findSelectedRadio = function(CA, gA) {
  return gA.filter(isRadioElement).filter(function(AA) {
    return AA.name === CA.name;
  }).filter(function(AA) {
    return AA.checked;
  })[0] || CA;
}, correctNode = function(CA, gA) {
  return isRadioElement(CA) && CA.name ? findSelectedRadio(CA, gA) : CA;
}, correctNodes = function(CA) {
  var gA = /* @__PURE__ */ new Set();
  return CA.forEach(function(AA) {
    return gA.add(correctNode(AA, CA));
  }), CA.filter(function(AA) {
    return gA.has(AA);
  });
}, pickFirstFocus = function(CA) {
  return CA[0] && CA.length > 1 ? correctNode(CA[0], CA) : CA[0];
}, pickFocusable = function(CA, gA) {
  return CA.indexOf(correctNode(gA, CA));
}, NEW_FOCUS = "NEW_FOCUS", newFocus = function(CA, gA, AA, IA, BA) {
  var QA = CA.length, EA = CA[0], iA = CA[QA - 1], oA = isGuard(IA);
  if (!(IA && CA.indexOf(IA) >= 0)) {
    var cA = IA !== void 0 ? AA.indexOf(IA) : -1, tA = BA ? AA.indexOf(BA) : cA, eA = BA ? CA.indexOf(BA) : -1;
    if (cA === -1)
      return eA !== -1 ? eA : NEW_FOCUS;
    if (eA === -1)
      return NEW_FOCUS;
    var aA = cA - tA, GA = AA.indexOf(EA), lA = AA.indexOf(iA), nA = correctNodes(AA), DA = IA !== void 0 ? nA.indexOf(IA) : -1, hA = BA ? nA.indexOf(BA) : DA, wA = nA.filter(function(RA) {
      return RA.tabIndex >= 0;
    }), sA = IA !== void 0 ? wA.indexOf(IA) : -1, NA = BA ? wA.indexOf(BA) : sA, rA = sA >= 0 && NA >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      NA - sA
    ) : (
      // or else measure in focusable space
      hA - DA
    );
    if (!aA && eA >= 0 || gA.length === 0)
      return eA;
    var yA = pickFocusable(CA, gA[0]), bA = pickFocusable(CA, gA[gA.length - 1]);
    if (cA <= GA && oA && Math.abs(aA) > 1)
      return bA;
    if (cA >= lA && oA && Math.abs(aA) > 1)
      return yA;
    if (aA && Math.abs(rA) > 1)
      return eA;
    if (cA <= GA)
      return bA;
    if (cA > lA)
      return yA;
    if (aA)
      return Math.abs(aA) > 1 ? eA : (QA + eA + aA) % QA;
  }
}, findAutoFocused = function(CA) {
  return function(gA) {
    var AA, IA = (AA = getDataset(gA)) === null || AA === void 0 ? void 0 : AA.autofocus;
    return (
      // @ts-expect-error
      gA.autofocus || //
      IA !== void 0 && IA !== "false" || //
      CA.indexOf(gA) >= 0
    );
  };
}, pickAutofocus = function(CA, gA, AA) {
  var IA = CA.map(function(QA) {
    var EA = QA.node;
    return EA;
  }), BA = filterAutoFocusable(IA.filter(findAutoFocused(AA)));
  return BA && BA.length ? pickFirstFocus(BA) : pickFirstFocus(filterAutoFocusable(gA));
}, getParents = function(CA, gA) {
  return gA === void 0 && (gA = []), gA.push(CA), CA.parentNode && getParents(CA.parentNode.host || CA.parentNode, gA), gA;
}, getCommonParent = function(CA, gA) {
  for (var AA = getParents(CA), IA = getParents(gA), BA = 0; BA < AA.length; BA += 1) {
    var QA = AA[BA];
    if (IA.indexOf(QA) >= 0)
      return QA;
  }
  return !1;
}, getTopCommonParent = function(CA, gA, AA) {
  var IA = asArray(CA), BA = asArray(gA), QA = IA[0], EA = !1;
  return BA.filter(Boolean).forEach(function(iA) {
    EA = getCommonParent(EA || iA, iA) || EA, AA.filter(Boolean).forEach(function(oA) {
      var cA = getCommonParent(QA, oA);
      cA && (!EA || contains(cA, EA) ? EA = cA : EA = getCommonParent(cA, EA));
    });
  }), EA;
}, allParentAutofocusables = function(CA, gA) {
  return CA.reduce(function(AA, IA) {
    return AA.concat(parentAutofocusables(IA, gA));
  }, []);
}, reorderNodes = function(CA, gA) {
  var AA = /* @__PURE__ */ new Map();
  return gA.forEach(function(IA) {
    return AA.set(IA.node, IA);
  }), CA.map(function(IA) {
    return AA.get(IA);
  }).filter(isDefined);
}, focusSolver = function(CA, gA) {
  var AA = getActiveElement(asArray(CA).length > 0 ? document : getFirst(CA).ownerDocument), IA = getAllAffectedNodes(CA).filter(isNotAGuard), BA = getTopCommonParent(AA || CA, CA, IA), QA = /* @__PURE__ */ new Map(), EA = getFocusableNodes(IA, QA), iA = EA.filter(function(lA) {
    var nA = lA.node;
    return isNotAGuard(nA);
  });
  if (iA[0]) {
    var oA = getFocusableNodes([BA], QA).map(function(lA) {
      var nA = lA.node;
      return nA;
    }), cA = reorderNodes(oA, iA), tA = cA.map(function(lA) {
      var nA = lA.node;
      return nA;
    }), eA = cA.filter(function(lA) {
      var nA = lA.tabIndex;
      return nA >= 0;
    }).map(function(lA) {
      var nA = lA.node;
      return nA;
    }), aA = newFocus(tA, eA, oA, AA, gA);
    if (aA === NEW_FOCUS) {
      var GA = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(EA, eA, allParentAutofocusables(IA, QA)) || pickAutofocus(EA, tA, allParentAutofocusables(IA, QA))
      );
      if (GA)
        return { node: GA };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return aA === void 0 ? aA : cA[aA];
  }
}, expandFocusableNodes = function(CA) {
  var gA = getAllAffectedNodes(CA).filter(isNotAGuard), AA = getTopCommonParent(CA, CA, gA), IA = orderByTabIndex(getFocusables([AA], !0), !0, !0), BA = getFocusables(gA, !1);
  return IA.map(function(QA) {
    var EA = QA.node, iA = QA.index;
    return {
      node: EA,
      index: iA,
      lockItem: BA.indexOf(EA) >= 0,
      guard: isGuard(EA)
    };
  });
}, focusOn = function(CA, gA) {
  CA && ("focus" in CA && CA.focus(gA), "contentWindow" in CA && CA.contentWindow && CA.contentWindow.focus());
}, guardCount = 0, lockDisabled = !1, moveFocusInside = function(CA, gA, AA) {
  AA === void 0 && (AA = {});
  var IA = focusSolver(CA, gA);
  if (!lockDisabled && IA) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), lockDisabled = !0, setTimeout(function() {
        lockDisabled = !1;
      }, 1);
      return;
    }
    guardCount++, focusOn(IA.node, AA.focusOptions), guardCount--;
  }
};
function weakRef(CA) {
  if (!CA)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return CA || null;
    };
  var gA = CA ? new WeakRef(CA) : null;
  return function() {
    return gA?.deref() || null;
  };
}
var recordElementLocation = function(CA) {
  if (!CA)
    return null;
  for (var gA = [], AA = CA; AA && AA !== document.body; )
    gA.push({
      current: weakRef(AA),
      parent: weakRef(AA.parentElement),
      left: weakRef(AA.previousElementSibling),
      right: weakRef(AA.nextElementSibling)
    }), AA = AA.parentElement;
  return {
    element: weakRef(CA),
    stack: gA,
    ownerDocument: CA.ownerDocument
  };
}, restoreFocusTo = function(CA) {
  var gA, AA, IA, BA, QA;
  if (CA)
    for (var EA = CA.stack, iA = CA.ownerDocument, oA = /* @__PURE__ */ new Map(), cA = 0, tA = EA; cA < tA.length; cA++) {
      var eA = tA[cA], aA = (gA = eA.parent) === null || gA === void 0 ? void 0 : gA.call(eA);
      if (aA && iA.contains(aA)) {
        for (var GA = (AA = eA.left) === null || AA === void 0 ? void 0 : AA.call(eA), lA = eA.current(), nA = aA.contains(lA) ? lA : void 0, DA = (IA = eA.right) === null || IA === void 0 ? void 0 : IA.call(eA), hA = getTabbableNodes([aA], oA), wA = (
          // that is element itself
          (QA = (BA = nA ?? GA?.nextElementSibling) !== null && BA !== void 0 ? BA : (
            // or somebody to the right, still close enough
            DA
          )) !== null && QA !== void 0 ? QA : (
            // or somebody to the left, something?
            GA
          )
        ); wA; ) {
          for (var sA = 0, NA = hA; sA < NA.length; sA++) {
            var rA = NA[sA];
            if (wA?.contains(rA.node))
              return rA.node;
          }
          wA = wA.nextElementSibling;
        }
        if (hA.length)
          return hA[0].node;
      }
    }
}, captureFocusRestore = function(CA) {
  var gA = recordElementLocation(CA);
  return function() {
    return restoreFocusTo(gA);
  };
}, getRelativeFocusable = function(CA, gA, AA) {
  if (!CA || !gA)
    return console.error("no element or scope given"), {};
  var IA = asArray(gA);
  if (IA.every(function(EA) {
    return !contains(EA, CA);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var BA = AA ? getTabbableNodes(IA, /* @__PURE__ */ new Map()) : getFocusableNodes(IA, /* @__PURE__ */ new Map()), QA = BA.findIndex(function(EA) {
    var iA = EA.node;
    return iA === CA;
  });
  if (QA !== -1)
    return {
      prev: BA[QA - 1],
      next: BA[QA + 1],
      first: BA[0],
      last: BA[BA.length - 1]
    };
}, getBoundary = function(CA, gA) {
  var AA = gA ? getTabbableNodes(asArray(CA), /* @__PURE__ */ new Map()) : getFocusableNodes(asArray(CA), /* @__PURE__ */ new Map());
  return {
    first: AA[0],
    last: AA[AA.length - 1]
  };
}, defaultOptions$1 = function(CA) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, CA);
}, moveFocus = function(CA, gA, AA) {
  gA === void 0 && (gA = {});
  var IA = defaultOptions$1(gA), BA = getRelativeFocusable(CA, IA.scope, IA.onlyTabbable);
  if (BA) {
    var QA = AA(BA, IA.cycle);
    QA && focusOn(QA.node, IA.focusOptions);
  }
}, focusNextElement = function(CA, gA) {
  gA === void 0 && (gA = {}), moveFocus(CA, gA, function(AA, IA) {
    var BA = AA.next, QA = AA.first;
    return BA || IA && QA;
  });
}, focusPrevElement = function(CA, gA) {
  gA === void 0 && (gA = {}), moveFocus(CA, gA, function(AA, IA) {
    var BA = AA.prev, QA = AA.last;
    return BA || IA && QA;
  });
}, pickBoundary = function(CA, gA, AA) {
  var IA, BA = getBoundary(CA, (IA = gA.onlyTabbable) !== null && IA !== void 0 ? IA : !0), QA = BA[AA];
  QA && focusOn(QA.node, gA.focusOptions);
}, focusFirstElement = function(CA, gA) {
  gA === void 0 && (gA = {}), pickBoundary(CA, gA, "first");
}, focusLastElement = function(CA, gA) {
  gA === void 0 && (gA = {}), pickBoundary(CA, gA, "last");
};
function deferAction(CA) {
  setTimeout(CA, 1);
}
var inlineProp = function CA(gA, AA) {
  var IA = {};
  return IA[gA] = AA, IA;
}, extractRef = function CA(gA) {
  return gA && "current" in gA ? gA.current : gA;
}, focusOnBody = function CA() {
  return document && document.activeElement === document.body;
}, isFreeFocus = function CA() {
  return focusOnBody() || focusIsHidden();
}, lastActiveTrap = null, lastActiveFocus = null, tryRestoreFocus = function CA() {
  return null;
}, lastPortaledElement = null, focusWasOutsideWindow = !1, windowFocused = !1, defaultWhitelist = function CA() {
  return !0;
}, focusWhitelisted = function CA(gA) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(gA);
}, recordPortal = function CA(gA, AA) {
  lastPortaledElement = {
    observerNode: gA,
    portaledElement: AA
  };
}, focusIsPortaledPair = function CA(gA) {
  return lastPortaledElement && lastPortaledElement.portaledElement === gA;
};
function autoGuard(CA, gA, AA, IA) {
  var BA = null, QA = CA;
  do {
    var EA = IA[QA];
    if (EA.guard)
      EA.node.dataset.focusAutoGuard && (BA = EA);
    else if (EA.lockItem) {
      if (QA !== CA)
        return;
      BA = null;
    } else
      break;
  } while ((QA += AA) !== gA);
  BA && (BA.node.tabIndex = 0);
}
var focusWasOutside = function CA(gA) {
  return gA ? !!focusWasOutsideWindow : focusWasOutsideWindow === "meanwhile";
}, checkInHost = function CA(gA, AA, IA) {
  return AA && (AA.host === gA && (!AA.activeElement || IA.contains(AA.activeElement)) || AA.parentNode && CA(gA, AA.parentNode, IA));
}, withinHost = function CA(gA, AA) {
  return AA.some(function(IA) {
    return checkInHost(gA, IA, IA);
  });
}, getNodeFocusables = function CA(gA) {
  return getFocusableNodes(gA, /* @__PURE__ */ new Map());
}, isNotFocusable = function CA(gA) {
  return !getNodeFocusables([gA.parentNode]).some(function(AA) {
    return AA.node === gA;
  });
}, activateTrap = function CA() {
  var gA = !1;
  if (lastActiveTrap) {
    var AA = lastActiveTrap, IA = AA.observed, BA = AA.persistentFocus, QA = AA.autoFocus, EA = AA.shards, iA = AA.crossFrame, oA = AA.focusOptions, cA = AA.noFocusGuards, tA = IA || lastPortaledElement && lastPortaledElement.portaledElement;
    if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body && (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus))) {
      var eA = tryRestoreFocus();
      eA && eA.focus();
    }
    var aA = document && document.activeElement;
    if (tA) {
      var GA = [tA].concat(EA.map(extractRef).filter(Boolean)), lA = function() {
        if (!focusWasOutside(iA) || !cA || !lastActiveFocus || windowFocused)
          return !1;
        var sA = getNodeFocusables(GA), NA = sA.findIndex(function(rA) {
          var yA = rA.node;
          return yA === lastActiveFocus;
        });
        return NA === 0 || NA === sA.length - 1;
      };
      if ((!aA || focusWhitelisted(aA)) && (BA || lA() || !isFreeFocus() || !lastActiveFocus && QA) && (tA && !(focusInside(GA) || aA && withinHost(aA, GA) || focusIsPortaledPair(aA)) && (document && !lastActiveFocus && aA && !QA ? (aA.blur && aA.blur(), document.body.focus()) : (gA = moveFocusInside(GA, lastActiveFocus, {
        focusOptions: oA
      }), lastPortaledElement = {})), lastActiveFocus = document && document.activeElement, lastActiveFocus !== document.body && (tryRestoreFocus = captureFocusRestore(lastActiveFocus)), focusWasOutsideWindow = !1), document && aA !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var nA = document && document.activeElement, DA = expandFocusableNodes(GA), hA = DA.map(function(wA) {
          var sA = wA.node;
          return sA;
        }).indexOf(nA);
        hA > -1 && (DA.filter(function(wA) {
          var sA = wA.guard, NA = wA.node;
          return sA && NA.dataset.focusAutoGuard;
        }).forEach(function(wA) {
          var sA = wA.node;
          return sA.removeAttribute("tabIndex");
        }), autoGuard(hA, DA.length, 1, DA), autoGuard(hA, -1, -1, DA));
      }
    }
  }
  return gA;
}, onTrap = function CA(gA) {
  activateTrap() && gA && (gA.stopPropagation(), gA.preventDefault());
}, onBlur = function CA() {
  return deferAction(activateTrap);
}, onFocus = function CA(gA) {
  var AA = gA.target, IA = gA.currentTarget;
  IA.contains(AA) || recordPortal(IA, AA);
}, FocusWatcher = function CA() {
  return null;
};
process.env.NODE_ENV !== "production" && PropTypes.node.isRequired;
var onWindowFocus = function CA() {
  windowFocused = !0;
}, onWindowBlur = function CA() {
  windowFocused = !1, focusWasOutsideWindow = "just", deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
}, attachHandler = function CA() {
  document.addEventListener("focusin", onTrap), document.addEventListener("focusout", onBlur), window.addEventListener("focus", onWindowFocus), window.addEventListener("blur", onWindowBlur);
}, detachHandler = function CA() {
  document.removeEventListener("focusin", onTrap), document.removeEventListener("focusout", onBlur), window.removeEventListener("focus", onWindowFocus), window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(CA) {
  return CA.filter(function(gA) {
    var AA = gA.disabled;
    return !AA;
  });
}
var focusLockAPI = {
  moveFocusInside,
  focusInside,
  focusNextElement,
  focusPrevElement,
  focusFirstElement,
  focusLastElement,
  captureFocusRestore
};
function handleStateChangeOnClient(CA) {
  var gA = CA.slice(-1)[0];
  gA && !lastActiveTrap && attachHandler();
  var AA = lastActiveTrap, IA = AA && gA && gA.id === AA.id;
  lastActiveTrap = gA, AA && !IA && (AA.onDeactivation(), CA.filter(function(BA) {
    var QA = BA.id;
    return QA === AA.id;
  }).length || AA.returnFocus(!gA)), gA ? (lastActiveFocus = null, (!IA || AA.observed !== gA.observed) && gA.onActivation(focusLockAPI), activateTrap(), deferAction(activateTrap)) : (detachHandler(), lastActiveFocus = null);
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(CA) {
  return CA(focusLockAPI);
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
var FocusLockCombination = /* @__PURE__ */ forwardRef(function CA(gA, AA) {
  return /* @__PURE__ */ React__default.createElement(FocusLock, _extends$m({
    sideCar: FocusTrap,
    ref: AA
  }, gA));
}), _ref = FocusLock.propTypes || {};
_ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose$c(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
var useFocusInside = function CA(gA) {
  useEffect(function() {
    var AA = !0;
    return mediumEffect.useMedium(function(IA) {
      var BA = gA && gA.current;
      AA && BA && (IA.focusInside(BA) || IA.moveFocusInside(BA, null));
    }), function() {
      AA = !1;
    };
  }, [gA]);
};
function MoveFocusInside(CA) {
  var gA = CA.disabled, AA = gA === void 0 ? !1 : gA, IA = CA.className, BA = CA.children, QA = useRef(null);
  return useFocusInside(AA ? void 0 : QA), /* @__PURE__ */ React__default.createElement("div", _extends$m({}, inlineProp(FOCUS_AUTO, !AA), {
    ref: QA,
    className: IA
  }), BA);
}
MoveFocusInside.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
} : {};
var SIZE = {
  default: "default",
  full: "full",
  auto: "auto"
}, SIZE_WIDTHS = {
  default: "500px",
  full: "100%",
  auto: "auto"
}, ROLE = {
  dialog: "dialog"
}, CLOSE_SOURCE = {
  closeButton: "closeButton",
  backdrop: "backdrop",
  escape: "escape"
};
function ownKeys$g(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$e(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$g(Object(AA), !0).forEach(function(IA) {
      _defineProperty$i(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$g(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$i(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function getSizeStyles(CA) {
  var gA = {
    maxWidth: "100%",
    width: null
  };
  return typeof CA == "number" ? gA.width = "".concat(CA, "px") : SIZE[CA] ? gA.width = SIZE_WIDTHS[CA] : typeof CA == "string" && (gA.width = CA), CA === SIZE.full && (gA.alignSelf = "stretch"), gA;
}
var Root$2 = styled("div", function(CA) {
  var gA = CA.$isOpen;
  return {
    position: "fixed",
    overflow: "auto",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    pointerEvents: gA ? "auto" : "none"
  };
});
Root$2.displayName = "Root";
Root$2.displayName = "Root";
var DialogContainer = styled("div", function(CA) {
  var gA = CA.$animate, AA = CA.$isOpen, IA = CA.$isVisible, BA = CA.$theme, QA = {
    transitionProperty: "opacity",
    transitionDuration: BA.animation.timing400,
    transitionTimingFunction: BA.animation.easeOutCurve
  };
  return _objectSpread$e({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100%",
    userSelect: "none",
    pointerEvents: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    // Remove grey highlight
    WebkitTapHighlightColor: "transparent",
    opacity: IA && AA ? 1 : 0
  }, gA ? QA : null);
});
DialogContainer.displayName = "DialogContainer";
DialogContainer.displayName = "DialogContainer";
var Dialog$2 = styled("div", function(CA) {
  var gA = CA.$animate, AA = CA.$isOpen, IA = CA.$isVisible, BA = CA.$size, QA = CA.$theme;
  return _objectSpread$e(_objectSpread$e(_objectSpread$e({
    position: "relative",
    backgroundColor: QA.colors.backgroundPrimary,
    borderTopLeftRadius: QA.borders.radius500,
    borderTopRightRadius: QA.borders.radius500,
    borderBottomRightRadius: QA.borders.radius500,
    borderBottomLeftRadius: QA.borders.radius500,
    marginLeft: QA.sizing.scale600,
    marginTop: QA.sizing.scale600,
    marginRight: QA.sizing.scale600,
    marginBottom: QA.sizing.scale600
  }, getSizeStyles(BA)), {}, {
    // Animation
    opacity: IA && AA ? 1 : 0,
    transform: IA ? "translateY(0)" : "translateY(20px)"
  }, gA ? {
    transitionProperty: "opacity, transform",
    transitionDuration: QA.animation.timing400,
    transitionTimingFunction: QA.animation.easeOutCurve
  } : null), {}, {
    // Reset interactivity properties set by container
    userSelect: "text",
    pointerEvents: AA ? "all" : "none",
    // We move focus to the modal, but we don't want the blue outline style
    ":focus": {
      outline: "none"
    }
  });
});
Dialog$2.displayName = "Dialog";
Dialog$2.displayName = "Dialog";
var Close = styled("button", function(CA) {
  var gA, AA = CA.$theme, IA = CA.$isFocusVisible, BA = AA.direction === "rtl" ? "left" : "right";
  return gA = {
    // Reset button styles
    background: "transparent",
    outline: 0,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    // colors
    color: AA.colors.modalCloseColor,
    transitionProperty: "color, border-color",
    transitionDuration: AA.animation.timing200,
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    ":hover": {
      color: AA.colors.modalCloseColorHover
    },
    ":focus": {
      outline: IA ? "3px solid ".concat(AA.colors.accent) : "none"
    },
    // Positioning
    position: "absolute",
    top: AA.sizing.scale500
  }, _defineProperty$i(gA, BA, AA.sizing.scale500), _defineProperty$i(gA, "width", AA.sizing.scale800), _defineProperty$i(gA, "height", AA.sizing.scale800), _defineProperty$i(gA, "display", "flex"), _defineProperty$i(gA, "justifyContent", "center"), _defineProperty$i(gA, "alignItems", "center"), _defineProperty$i(gA, "cursor", "pointer"), gA;
});
Close.displayName = "Close";
Close.displayName = "Close";
var ModalHeader$1 = styled("div", function(CA) {
  var gA, AA = CA.$theme, IA = AA.direction === "rtl" ? "marginRight" : "marginLeft", BA = AA.direction === "rtl" ? "marginLeft" : "marginRight";
  return _objectSpread$e(_objectSpread$e({}, AA.typography.font550), {}, (gA = {
    color: AA.colors.contentPrimary,
    marginTop: AA.sizing.scale900,
    marginBottom: AA.sizing.scale600
  }, _defineProperty$i(gA, IA, AA.sizing.scale800), _defineProperty$i(gA, BA, AA.sizing.scale900), gA));
});
ModalHeader$1.displayName = "ModalHeader";
ModalHeader$1.displayName = "ModalHeader";
var ModalBody$2 = styled("div", function(CA) {
  var gA = CA.$theme;
  return _objectSpread$e(_objectSpread$e({}, gA.typography.font200), {}, {
    color: gA.colors.contentSecondary,
    marginTop: gA.sizing.scale600,
    marginLeft: gA.sizing.scale800,
    marginRight: gA.sizing.scale800,
    marginBottom: gA.sizing.scale700
  });
});
ModalBody$2.displayName = "ModalBody";
ModalBody$2.displayName = "ModalBody";
var ModalFooter$1 = styled("div", function(CA) {
  var gA = CA.$theme;
  return _objectSpread$e(_objectSpread$e({}, gA.typography.font200), {}, {
    marginTop: gA.sizing.scale700,
    marginLeft: gA.sizing.scale800,
    marginRight: gA.sizing.scale800,
    paddingTop: gA.sizing.scale500,
    paddingBottom: gA.sizing.scale500,
    textAlign: gA.direction === "rtl" ? "left" : "right"
  });
});
ModalFooter$1.displayName = "ModalFooter";
ModalFooter$1.displayName = "ModalFooter";
function CloseIcon() {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    style: {
      stroke: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M9 1L5 5M1 9L5 5M5 5L1 1M5 5L9 9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
function _typeof$9(CA) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$9(CA);
}
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$f.apply(this, arguments);
}
function _slicedToArray$8(CA, gA) {
  return _arrayWithHoles$7(CA) || _iterableToArrayLimit$7(CA, gA) || _unsupportedIterableToArray$7(CA, gA) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$7(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$7(CA, gA);
  }
}
function _arrayLikeToArray$7(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$7(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$7(CA) {
  if (Array.isArray(CA)) return CA;
}
function _classCallCheck$8(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$8(CA, gA, AA) {
  return gA && _defineProperties$8(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$8(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$8(CA, gA);
}
function _setPrototypeOf$8(CA, gA) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$8(CA, gA);
}
function _createSuper$8(CA) {
  var gA = _isNativeReflectConstruct$8();
  return function() {
    var IA = _getPrototypeOf$8(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$8(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$8(this, BA);
  };
}
function _possibleConstructorReturn$8(CA, gA) {
  if (gA && (_typeof$9(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(CA);
}
function _assertThisInitialized$8(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$8(CA) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$8(CA);
}
function _defineProperty$h(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Modal$1 = /* @__PURE__ */ (function(CA) {
  _inherits$8(AA, CA);
  var gA = _createSuper$8(AA);
  function AA() {
    var IA;
    _classCallCheck$8(this, AA);
    for (var BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = gA.call.apply(gA, [this].concat(QA)), _defineProperty$h(_assertThisInitialized$8(IA), "animateOutTimer", void 0), _defineProperty$h(_assertThisInitialized$8(IA), "animateStartTimer", void 0), _defineProperty$h(_assertThisInitialized$8(IA), "dialogContainerRef", /* @__PURE__ */ React.createRef()), _defineProperty$h(_assertThisInitialized$8(IA), "lastFocus", null), _defineProperty$h(_assertThisInitialized$8(IA), "lastMountNodeOverflowStyle", null), _defineProperty$h(_assertThisInitialized$8(IA), "rootRef", /* @__PURE__ */ React.createRef()), _defineProperty$h(_assertThisInitialized$8(IA), "state", {
      isVisible: !1,
      mounted: !1,
      isFocusVisible: !1
    }), _defineProperty$h(_assertThisInitialized$8(IA), "handleFocus", function(iA) {
      isFocusVisible(iA) && IA.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$h(_assertThisInitialized$8(IA), "handleBlur", function(iA) {
      IA.state.isFocusVisible !== !1 && IA.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$h(_assertThisInitialized$8(IA), "onEscape", function() {
      IA.props.closeable && IA.triggerClose(CLOSE_SOURCE.escape);
    }), _defineProperty$h(_assertThisInitialized$8(IA), "onDocumentClick", function(iA) {
      iA.target && iA.target instanceof HTMLElement && iA.target.contains(IA.dialogContainerRef.current) && IA.onBackdropClick();
    }), _defineProperty$h(_assertThisInitialized$8(IA), "onBackdropClick", function() {
      IA.props.closeable && IA.triggerClose(CLOSE_SOURCE.backdrop);
    }), _defineProperty$h(_assertThisInitialized$8(IA), "onCloseClick", function() {
      IA.triggerClose(CLOSE_SOURCE.closeButton);
    }), _defineProperty$h(_assertThisInitialized$8(IA), "animateOutComplete", function() {
      IA.setState({
        isVisible: !1
      });
    }), IA;
  }
  return _createClass$8(AA, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        mounted: !0
      }), process.env.NODE_ENV !== "production" && this.props.closable && console.warn("The property `closable` is not supported on the Modal. Did you mean `closeable`?");
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.resetMountNodeScroll(), this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function(BA, QA) {
      var EA = this.props.isOpen;
      // If isOpen is changing *or* we just mounted and modal should be open
      (EA !== BA.isOpen || EA && this.state.mounted && !QA.mounted) && (EA ? this.didOpen() : this.didClose());
    }
  }, {
    key: "disableMountNodeScroll",
    value: function() {
      var BA = this.getMountNode();
      this.lastMountNodeOverflowStyle = BA.style.overflow || "", BA.style.overflow = "hidden";
    }
  }, {
    key: "resetMountNodeScroll",
    value: function() {
      var BA = this.getMountNode(), QA = this.lastMountNodeOverflowStyle;
      BA && QA !== null && (BA.style.overflow === "hidden" && (BA.style.overflow = QA || ""), this.lastMountNodeOverflowStyle = null);
    }
  }, {
    key: "clearTimers",
    value: function() {
      this.animateOutTimer && clearTimeout(this.animateOutTimer), this.animateStartTimer && cancelAnimationFrame(this.animateStartTimer);
    }
  }, {
    key: "didOpen",
    value: function() {
      var BA = this, QA = this.rootRef.current;
      QA && (QA.scrollTop = 0), this.clearTimers(), this.disableMountNodeScroll(), this.animateStartTimer = requestAnimationFrame(function() {
        BA.setState({
          isVisible: !0
        });
      });
    }
  }, {
    key: "didClose",
    value: function() {
      this.resetMountNodeScroll(), this.animateOutTimer = setTimeout(this.animateOutComplete, 500);
    }
  }, {
    key: "triggerClose",
    value: function(BA) {
      this.props.onClose && BA && this.props.onClose({
        closeSource: BA
      });
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var BA = this.props, QA = BA.animate, EA = BA.isOpen, iA = BA.size, oA = BA.role, cA = BA.closeable;
      return {
        $animate: QA,
        $isVisible: this.state.isVisible,
        $isOpen: !!EA,
        $size: iA,
        $role: oA,
        $closeable: !!cA,
        $isFocusVisible: this.state.isFocusVisible
      };
    }
  }, {
    key: "getMountNode",
    value: function() {
      var BA = this.props.mountNode;
      return BA || document.body;
    }
  }, {
    key: "getChildren",
    value: function() {
      var BA = this.props.children;
      return typeof BA == "function" ? BA() : BA;
    }
  }, {
    key: "renderModal",
    value: function() {
      var BA = this, QA = this.props, EA = QA.overrides, iA = EA === void 0 ? {} : EA, oA = QA.closeable, cA = QA.role, tA = QA.autoFocus, eA = QA.focusLock, aA = QA.returnFocus, GA = iA.Root, lA = iA.Dialog, nA = iA.DialogContainer, DA = iA.Close, hA = getOverrides(GA, Root$2), wA = _slicedToArray$8(hA, 2), sA = wA[0], NA = wA[1], rA = getOverrides(nA, DialogContainer), yA = _slicedToArray$8(rA, 2), bA = yA[0], RA = yA[1], FA = getOverrides(lA, Dialog$2), dA = _slicedToArray$8(FA, 2), kA = dA[0], pA = dA[1], YA = getOverrides(DA, Close), SA = _slicedToArray$8(YA, 2), JA = SA[0], UA = SA[1], fA = this.getSharedProps(), zA = this.getChildren();
      return /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(_A) {
        return /* @__PURE__ */ React.createElement(FocusLockCombination, {
          disabled: !eA,
          crossFrame: !1,
          returnFocus: aA,
          autoFocus: tA
        }, /* @__PURE__ */ React.createElement(sA, _extends$f({
          "data-baseweb": "modal",
          ref: BA.rootRef
        }, fA, NA), /* @__PURE__ */ React.createElement(
          bA,
          _extends$f({
            ref: BA.dialogContainerRef
          }, fA, RA),
          /* @__PURE__ */ React.createElement(kA, _extends$f({
            tabIndex: -1,
            "aria-modal": !0,
            "aria-label": "dialog",
            role: cA
          }, fA, pA), zA, oA ? /* @__PURE__ */ React.createElement(JA, _extends$f({
            "aria-label": _A.modal.close,
            onClick: BA.onCloseClick
          }, fA, UA, {
            onFocus: forkFocus(UA, BA.handleFocus),
            onBlur: forkBlur(UA, BA.handleBlur)
          }), /* @__PURE__ */ React.createElement(CloseIcon, null)) : null)
        )));
      });
    }
  }, {
    key: "render",
    value: function() {
      return !this.state.mounted || !this.props.isOpen && !this.state.isVisible ? null : /* @__PURE__ */ React.createElement(Layer, {
        onEscape: this.onEscape,
        onDocumentClick: this.onDocumentClick,
        mountNode: this.props.mountNode
      }, this.renderModal());
    }
  }]), AA;
})(React.Component);
_defineProperty$h(Modal$1, "defaultProps", {
  animate: !0,
  autoFocus: !0,
  focusLock: !0,
  returnFocus: !0,
  closeable: !0,
  name: "dialog",
  isOpen: !1,
  overrides: {},
  role: ROLE.dialog,
  size: SIZE.default
});
var BaseButtonKind = /* @__PURE__ */ ((CA) => (CA.PRIMARY = "primary", CA.SECONDARY = "secondary", CA.TERTIARY = "tertiary", CA.GHOST = "ghost", CA.BORDERLESS_ICON = "borderlessIcon", CA.BORDERLESS_ICON_ACTIVE = "borderlessIconActive", CA.MINIMAL = "minimal", CA.PRIMARY_FORM_SUBMIT = "primaryFormSubmit", CA.SECONDARY_FORM_SUBMIT = "secondaryFormSubmit", CA.TERTIARY_FORM_SUBMIT = "tertiaryFormSubmit", CA.HEADER_BUTTON = "header", CA.HEADER_NO_PADDING = "headerNoPadding", CA.ELEMENT_TOOLBAR = "elementToolbar", CA.PILLS = "pills", CA.PILLS_ACTIVE = "pillsActive", CA.SEGMENTED_CONTROL = "segmented_control", CA.SEGMENTED_CONTROL_ACTIVE = "segmented_controlActive", CA))(BaseButtonKind || {}), BaseButtonSize = /* @__PURE__ */ ((CA) => (CA.XSMALL = "xsmall", CA.SMALL = "small", CA.MEDIUM = "medium", CA.LARGE = "large", CA))(BaseButtonSize || {});
function getSizeStyle(CA, gA) {
  switch (CA) {
    case "xsmall":
      return {
        padding: `${gA.spacing.twoXS} ${gA.spacing.sm}`,
        fontSize: gA.fontSizes.sm
      };
    case "small":
      return {
        padding: `${gA.spacing.twoXS} ${gA.spacing.md}`
      };
    case "large":
      return {
        padding: `${gA.spacing.md} ${gA.spacing.md}`
      };
    default:
      return {
        padding: `${gA.spacing.xs} ${gA.spacing.md}`
      };
  }
}
const StyledBaseButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc24"
} : {
  target: "ef3psqc24",
  label: "StyledBaseButton"
})(({
  containerWidth: CA,
  size: gA,
  theme: AA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: AA.fontWeights.normal,
  padding: `${AA.spacing.xs} ${AA.spacing.md}`,
  borderRadius: AA.radii.button,
  minHeight: AA.sizes.minElementHeight,
  margin: AA.spacing.none,
  lineHeight: AA.lineHeights.base,
  textTransform: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  color: "inherit",
  width: CA ? "100%" : "auto",
  cursor: "pointer",
  userSelect: "none",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    // When focus-visible (e.g. if the button was focused via keyboard navigation)
    // we use the hover style of the respective button type (see below) and
    // additionally show a colored focus ring
    boxShadow: AA.shadows.focusRing
  },
  ...getSizeStyle(gA, AA)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4RnlCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHR5cGUgeyBFbW90aW9uVGhlbWUgfSBmcm9tIFwifmxpYi90aGVtZS90eXBlc1wiXG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25LaW5kIHtcbiAgUFJJTUFSWSA9IFwicHJpbWFyeVwiLFxuICBTRUNPTkRBUlkgPSBcInNlY29uZGFyeVwiLFxuICBURVJUSUFSWSA9IFwidGVydGlhcnlcIixcbiAgR0hPU1QgPSBcImdob3N0XCIsXG4gIEJPUkRFUkxFU1NfSUNPTiA9IFwiYm9yZGVybGVzc0ljb25cIixcbiAgQk9SREVSTEVTU19JQ09OX0FDVElWRSA9IFwiYm9yZGVybGVzc0ljb25BY3RpdmVcIixcbiAgTUlOSU1BTCA9IFwibWluaW1hbFwiLFxuICBQUklNQVJZX0ZPUk1fU1VCTUlUID0gXCJwcmltYXJ5Rm9ybVN1Ym1pdFwiLFxuICBTRUNPTkRBUllfRk9STV9TVUJNSVQgPSBcInNlY29uZGFyeUZvcm1TdWJtaXRcIixcbiAgVEVSVElBUllfRk9STV9TVUJNSVQgPSBcInRlcnRpYXJ5Rm9ybVN1Ym1pdFwiLFxuICBIRUFERVJfQlVUVE9OID0gXCJoZWFkZXJcIixcbiAgSEVBREVSX05PX1BBRERJTkcgPSBcImhlYWRlck5vUGFkZGluZ1wiLFxuICBFTEVNRU5UX1RPT0xCQVIgPSBcImVsZW1lbnRUb29sYmFyXCIsXG4gIFBJTExTID0gXCJwaWxsc1wiLFxuICBQSUxMU19BQ1RJVkUgPSBcInBpbGxzQWN0aXZlXCIsXG4gIFNFR01FTlRFRF9DT05UUk9MID0gXCJzZWdtZW50ZWRfY29udHJvbFwiLFxuICBTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkUgPSBcInNlZ21lbnRlZF9jb250cm9sQWN0aXZlXCIsXG59XG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25TaXplIHtcbiAgWFNNQUxMID0gXCJ4c21hbGxcIixcbiAgU01BTEwgPSBcInNtYWxsXCIsXG4gIE1FRElVTSA9IFwibWVkaXVtXCIsXG4gIExBUkdFID0gXCJsYXJnZVwiLFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEJhc2VCdXR0b25Qcm9wcyB7XG4gIGtpbmQ6IEJhc2VCdXR0b25LaW5kXG4gIHNpemU/OiBCYXNlQnV0dG9uU2l6ZVxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gdm9pZFxuICBkaXNhYmxlZD86IGJvb2xlYW5cbiAgLy8gSWYgdHJ1ZSwgdGhlIGJ1dHRvbiBzaG91bGQgdGFrZSB1cCBjb250YWluZXIncyBmdWxsIHdpZHRoXG4gIGNvbnRhaW5lcldpZHRoPzogYm9vbGVhblxuICBjaGlsZHJlbjogUmVhY3ROb2RlXG4gIGF1dG9Gb2N1cz86IGJvb2xlYW5cbiAgXCJkYXRhLXRlc3RpZFwiPzogc3RyaW5nXG4gIFwiYXJpYS1sYWJlbFwiPzogc3RyaW5nXG4gIFwiYXJpYS1oYXNwb3B1cFwiPzogXCJtZW51XCIgfCBcInRydWVcIiB8IFwiZGlhbG9nXCIgfCBcImxpc3Rib3hcIiB8IFwidHJlZVwiIHwgXCJncmlkXCJcbiAgXCJhcmlhLWV4cGFuZGVkXCI/OiBib29sZWFuXG59XG5cbi8vIE1vc3QgcHJvcHMgYmVjb21lIHJlcXVpcmVkIHZpYSBkZWZhdWx0cyBpbiBCYXNlQnV0dG9uLCBidXQgQVJJQSBwb3B1cFxuLy8gYXR0cmlidXRlcyBzdGF5IG9wdGlvbmFsIHNvIHRoZXkgb25seSBhcHBlYXIgaW4gdGhlIERPTSB3aGVuIGV4cGxpY2l0bHkgc2V0LlxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPFxuICBPbWl0PEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cbj4gJlxuICBQaWNrPEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5jb25zdCBTdHlsZWRCYXNlQnV0dG9uID0gc3R5bGVkLmJ1dHRvbjxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oXG4gICh7IGNvbnRhaW5lcldpZHRoLCBzaXplLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLm1pbkVsZW1lbnRIZWlnaHQsXG4gICAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgICB0ZXh0VHJhbnNmb3JtOiBcIm5vbmVcIixcbiAgICAgIGZvbnRTaXplOiBcImluaGVyaXRcIixcbiAgICAgIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgICAgd2lkdGg6IGNvbnRhaW5lcldpZHRoID8gXCIxMDAlXCIgOiBcImF1dG9cIixcbiAgICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgICAgLy8gV2hlbiBmb2N1cy12aXNpYmxlIChlLmcuIGlmIHRoZSBidXR0b24gd2FzIGZvY3VzZWQgdmlhIGtleWJvYXJkIG5hdmlnYXRpb24pXG4gICAgICAgIC8vIHdlIHVzZSB0aGUgaG92ZXIgc3R5bGUgb2YgdGhlIHJlc3BlY3RpdmUgYnV0dG9uIHR5cGUgKHNlZSBiZWxvdykgYW5kXG4gICAgICAgIC8vIGFkZGl0aW9uYWxseSBzaG93IGEgY29sb3JlZCBmb2N1cyByaW5nXG4gICAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgICB9LFxuICAgICAgLi4uZ2V0U2l6ZVN0eWxlKHNpemUsIHRoZW1lKSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLnByaW1hcnl9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAvLyBLZWVwIHRoZSBib3JkZXIgZGFya2VyIHdoZW4gY2xpY2tlZCBzbyB0aGF0IHRoZSBidXR0b24gbG9va3MgXCJwcmVzc2VkXCJcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmxpZ2h0ZW5lZEJnMDUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpob3Zlcjpub3QoOmRpc2FibGVkKSwgJjpmb2N1cy12aXNpYmxlOm5vdCg6ZGlzYWJsZWQpXCI6IHtcbiAgICAgIC8vIEFsc28gbWFrZSBjb2xvcmVkIHRleHQgaGF2ZSB0aGUgcHJpbWFyeSBjb2xvciBvbiBob3Zlci4gU2luY2UgdGV4dCBjb2xvciBpc1xuICAgICAgLy8gYXBwbGllZCBhcyBhbiBpbmxpbmUgc3R5bGUgd2UgbmVlZCB0byB1c2UgIWltcG9ydGFudCB0byBvdmVycmlkZSBpdC5cbiAgICAgIC8vIE5vdGUgdGhhdCB3ZSdyZSBub3QgZG9pbmcgdGhpcyB3aGVuIGRpc2FibGVkLiBXZSBzaG91bGQgcHJvYmFibHkgZG8gdGhhdCBhc1xuICAgICAgLy8gd2VsbCBidXQgd2UgZG9uJ3QgZG8gaXQgYW55d2hlcmUgZWxzZS5cbiAgICAgIFwic3Bhbi5zdE1hcmtkb3duQ29sb3JlZFRleHRcIjoge1xuICAgICAgICBjb2xvcjogXCJpbmhlcml0ICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMjUpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkR2hvc3RCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy50cmFuc3BhcmVudH1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWluaW1hbEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJveFNoYWRvdzogXCJub25lXCIsXG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgXCImOmhvdmVyLCAmOmFjdGl2ZSwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlGb3JtU3VibWl0QnV0dG9uID1cbiAgc3R5bGVkKFN0eWxlZFByaW1hcnlCdXR0b24pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlGb3JtU3VibWl0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRTZWNvbmRhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRlcnRpYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkVGVydGlhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuY29uc3QgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1pbkhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG5cbiAgICAvLyBzaG93IHBpbGxzIHdpdGggbG9uZyB0ZXh0IGluIHNpbmdsZSBsaW5lIGFuZCB1c2UgZWxsaXBzaXMgZm9yIG92ZXJmbG93XG4gICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcblxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG5cbiAgICBcIiYgZGl2XCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgICBcIiYgcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRQaWxsc0J1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gU2VnbWVudGVkIGNvbnRyb2wgYm9yZGVyIG1vZGVsOlxuLy8gbmVpZ2hib3JpbmcgYnV0dG9ucyBvdmVybGFwIGJ5IDEgYm9yZGVyIHdpZHRoLCBzbyBlYWNoIHNoYXJlZCBlZGdlIG5lZWRzIGFcbi8vIHNpbmdsZSBcIm93bmVyXCIgdG8gYXZvaWQgZG91YmxlLXdpZHRoIHNlYW1zLiBXZSB0cmVhdCBhY3RpdmUvaW50ZXJhY3RpdmVcbi8vIChob3Zlci9mb2N1cy12aXNpYmxlKSBidXR0b25zIGFzIHJhaXNlZCBhbmQgbGV0IHRoZW0gb3duIHNoYXJlZCBib3JkZXJzLlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOVEVSQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX05FVVRSQUxfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6bm90KDpob3Zlcik6bm90KDpmb2N1cy12aXNpYmxlKVwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sQWN0aXZlJ106bm90KDpkaXNhYmxlZCksICZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKWBdOlxuICAgICAge1xuICAgICAgICAvLyBSYWlzZWQgc2VnbWVudHMgc2hvdWxkIHJlbmRlciBhYm92ZSBuZXV0cmFsIG5laWdoYm9ycy5cbiAgICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICAgIH0sXG4gICAgLy8gQWN0aXZlIGhhcyBzdHJvbmdlc3QgcHJlY2VkZW5jZToga2VlcCBpdHMgYm9yZGVyIHZpc2libGUgYWdhaW5zdCBib3RoXG4gICAgLy8gbmV1dHJhbCBhbmQgaW50ZXJhY3RpdmUgbmVpZ2hib3JzLlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpICsgJHtTRUdNRU5URURfQ09OVFJPTF9JTkFDVElWRV9FTkFCTEVEfWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJMZWZ0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aGFzKCsgJHtTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgLy8gSG92ZXIvZm9jdXMgb3duZXJzaGlwIGlzIG9ubHkgYXBwbGllZCBiZXR3ZWVuIG5ldXRyYWwgbmVpZ2hib3JzIHNvIHdlXG4gICAgLy8gbmV2ZXIgaGlkZSB0aGUgYWN0aXZlIGJvcmRlciBpbiBhY3RpdmUraG92ZXIgYWRqYWNlbmN5LlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpICsgJHtTRUdNRU5URURfQ09OVFJPTF9ORVVUUkFMX0VOQUJMRUR9YF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlckxlZnRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTpub3QoOmhvdmVyKTpub3QoOmZvY3VzLXZpc2libGUpOmhhcygrICR7U0VHTUVOVEVEX0NPTlRST0xfSU5URVJBQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledPrimaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc23"
} : {
  target: "ef3psqc23",
  label: "StyledPrimaryButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.primary,
  color: CA.colors.white,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.primary}`,
  "&:hover, &:focus-visible": {
    backgroundColor: darken(CA.colors.primary, 0.15),
    borderColor: darken(CA.colors.primary, 0.15)
  },
  "&:active": {
    backgroundColor: CA.colors.primary,
    // Keep the border darker when clicked so that the button looks "pressed"
    borderColor: darken(CA.colors.primary, 0.15)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: CA.colors.borderColor,
    backgroundColor: CA.colors.transparent,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc22"
} : {
  target: "ef3psqc22",
  label: "StyledSecondaryButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.lightenedBg05,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
  "&:hover, &:focus-visible": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: CA.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: CA.colors.borderColor,
    backgroundColor: CA.colors.transparent,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc21"
} : {
  target: "ef3psqc21",
  label: "StyledTertiaryButton"
})(({
  theme: CA
}) => ({
  padding: CA.spacing.none,
  backgroundColor: CA.colors.transparent,
  border: "none",
  "&:hover, &:focus-visible": {
    color: CA.colors.primary
  },
  "&:hover:not(:disabled), &:focus-visible:not(:disabled)": {
    // Also make colored text have the primary color on hover. Since text color is
    // applied as an inline style we need to use !important to override it.
    // Note that we're not doing this when disabled. We should probably do that as
    // well but we don't do it anywhere else.
    "span.stMarkdownColoredText": {
      color: "inherit !important"
    }
  },
  "&:active": {
    color: darken(CA.colors.primary, 0.25)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: CA.colors.transparent,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledGhostButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc20"
} : {
  target: "ef3psqc20",
  label: "StyledGhostButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.transparent,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.transparent}`,
  "&:hover, &:focus-visible": {
    borderColor: CA.colors.transparent,
    color: CA.colors.primary
  },
  "&:active": {
    color: CA.colors.primary,
    borderColor: CA.colors.transparent,
    backgroundColor: CA.colors.transparent
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: CA.colors.gray30,
    borderColor: CA.colors.transparent,
    color: CA.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMinimalButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc19"
} : {
  target: "ef3psqc19",
  label: "StyledMinimalButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.transparent,
  border: "none",
  boxShadow: "none",
  padding: CA.spacing.none,
  "&:hover, &:active, &:focus-visible": {
    color: CA.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0Tm1DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHR5cGUgeyBFbW90aW9uVGhlbWUgfSBmcm9tIFwifmxpYi90aGVtZS90eXBlc1wiXG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25LaW5kIHtcbiAgUFJJTUFSWSA9IFwicHJpbWFyeVwiLFxuICBTRUNPTkRBUlkgPSBcInNlY29uZGFyeVwiLFxuICBURVJUSUFSWSA9IFwidGVydGlhcnlcIixcbiAgR0hPU1QgPSBcImdob3N0XCIsXG4gIEJPUkRFUkxFU1NfSUNPTiA9IFwiYm9yZGVybGVzc0ljb25cIixcbiAgQk9SREVSTEVTU19JQ09OX0FDVElWRSA9IFwiYm9yZGVybGVzc0ljb25BY3RpdmVcIixcbiAgTUlOSU1BTCA9IFwibWluaW1hbFwiLFxuICBQUklNQVJZX0ZPUk1fU1VCTUlUID0gXCJwcmltYXJ5Rm9ybVN1Ym1pdFwiLFxuICBTRUNPTkRBUllfRk9STV9TVUJNSVQgPSBcInNlY29uZGFyeUZvcm1TdWJtaXRcIixcbiAgVEVSVElBUllfRk9STV9TVUJNSVQgPSBcInRlcnRpYXJ5Rm9ybVN1Ym1pdFwiLFxuICBIRUFERVJfQlVUVE9OID0gXCJoZWFkZXJcIixcbiAgSEVBREVSX05PX1BBRERJTkcgPSBcImhlYWRlck5vUGFkZGluZ1wiLFxuICBFTEVNRU5UX1RPT0xCQVIgPSBcImVsZW1lbnRUb29sYmFyXCIsXG4gIFBJTExTID0gXCJwaWxsc1wiLFxuICBQSUxMU19BQ1RJVkUgPSBcInBpbGxzQWN0aXZlXCIsXG4gIFNFR01FTlRFRF9DT05UUk9MID0gXCJzZWdtZW50ZWRfY29udHJvbFwiLFxuICBTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkUgPSBcInNlZ21lbnRlZF9jb250cm9sQWN0aXZlXCIsXG59XG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25TaXplIHtcbiAgWFNNQUxMID0gXCJ4c21hbGxcIixcbiAgU01BTEwgPSBcInNtYWxsXCIsXG4gIE1FRElVTSA9IFwibWVkaXVtXCIsXG4gIExBUkdFID0gXCJsYXJnZVwiLFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEJhc2VCdXR0b25Qcm9wcyB7XG4gIGtpbmQ6IEJhc2VCdXR0b25LaW5kXG4gIHNpemU/OiBCYXNlQnV0dG9uU2l6ZVxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gdm9pZFxuICBkaXNhYmxlZD86IGJvb2xlYW5cbiAgLy8gSWYgdHJ1ZSwgdGhlIGJ1dHRvbiBzaG91bGQgdGFrZSB1cCBjb250YWluZXIncyBmdWxsIHdpZHRoXG4gIGNvbnRhaW5lcldpZHRoPzogYm9vbGVhblxuICBjaGlsZHJlbjogUmVhY3ROb2RlXG4gIGF1dG9Gb2N1cz86IGJvb2xlYW5cbiAgXCJkYXRhLXRlc3RpZFwiPzogc3RyaW5nXG4gIFwiYXJpYS1sYWJlbFwiPzogc3RyaW5nXG4gIFwiYXJpYS1oYXNwb3B1cFwiPzogXCJtZW51XCIgfCBcInRydWVcIiB8IFwiZGlhbG9nXCIgfCBcImxpc3Rib3hcIiB8IFwidHJlZVwiIHwgXCJncmlkXCJcbiAgXCJhcmlhLWV4cGFuZGVkXCI/OiBib29sZWFuXG59XG5cbi8vIE1vc3QgcHJvcHMgYmVjb21lIHJlcXVpcmVkIHZpYSBkZWZhdWx0cyBpbiBCYXNlQnV0dG9uLCBidXQgQVJJQSBwb3B1cFxuLy8gYXR0cmlidXRlcyBzdGF5IG9wdGlvbmFsIHNvIHRoZXkgb25seSBhcHBlYXIgaW4gdGhlIERPTSB3aGVuIGV4cGxpY2l0bHkgc2V0LlxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPFxuICBPbWl0PEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cbj4gJlxuICBQaWNrPEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5jb25zdCBTdHlsZWRCYXNlQnV0dG9uID0gc3R5bGVkLmJ1dHRvbjxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oXG4gICh7IGNvbnRhaW5lcldpZHRoLCBzaXplLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLm1pbkVsZW1lbnRIZWlnaHQsXG4gICAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgICB0ZXh0VHJhbnNmb3JtOiBcIm5vbmVcIixcbiAgICAgIGZvbnRTaXplOiBcImluaGVyaXRcIixcbiAgICAgIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgICAgd2lkdGg6IGNvbnRhaW5lcldpZHRoID8gXCIxMDAlXCIgOiBcImF1dG9cIixcbiAgICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgICAgLy8gV2hlbiBmb2N1cy12aXNpYmxlIChlLmcuIGlmIHRoZSBidXR0b24gd2FzIGZvY3VzZWQgdmlhIGtleWJvYXJkIG5hdmlnYXRpb24pXG4gICAgICAgIC8vIHdlIHVzZSB0aGUgaG92ZXIgc3R5bGUgb2YgdGhlIHJlc3BlY3RpdmUgYnV0dG9uIHR5cGUgKHNlZSBiZWxvdykgYW5kXG4gICAgICAgIC8vIGFkZGl0aW9uYWxseSBzaG93IGEgY29sb3JlZCBmb2N1cyByaW5nXG4gICAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgICB9LFxuICAgICAgLi4uZ2V0U2l6ZVN0eWxlKHNpemUsIHRoZW1lKSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLnByaW1hcnl9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAvLyBLZWVwIHRoZSBib3JkZXIgZGFya2VyIHdoZW4gY2xpY2tlZCBzbyB0aGF0IHRoZSBidXR0b24gbG9va3MgXCJwcmVzc2VkXCJcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmxpZ2h0ZW5lZEJnMDUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpob3Zlcjpub3QoOmRpc2FibGVkKSwgJjpmb2N1cy12aXNpYmxlOm5vdCg6ZGlzYWJsZWQpXCI6IHtcbiAgICAgIC8vIEFsc28gbWFrZSBjb2xvcmVkIHRleHQgaGF2ZSB0aGUgcHJpbWFyeSBjb2xvciBvbiBob3Zlci4gU2luY2UgdGV4dCBjb2xvciBpc1xuICAgICAgLy8gYXBwbGllZCBhcyBhbiBpbmxpbmUgc3R5bGUgd2UgbmVlZCB0byB1c2UgIWltcG9ydGFudCB0byBvdmVycmlkZSBpdC5cbiAgICAgIC8vIE5vdGUgdGhhdCB3ZSdyZSBub3QgZG9pbmcgdGhpcyB3aGVuIGRpc2FibGVkLiBXZSBzaG91bGQgcHJvYmFibHkgZG8gdGhhdCBhc1xuICAgICAgLy8gd2VsbCBidXQgd2UgZG9uJ3QgZG8gaXQgYW55d2hlcmUgZWxzZS5cbiAgICAgIFwic3Bhbi5zdE1hcmtkb3duQ29sb3JlZFRleHRcIjoge1xuICAgICAgICBjb2xvcjogXCJpbmhlcml0ICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMjUpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkR2hvc3RCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy50cmFuc3BhcmVudH1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWluaW1hbEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJveFNoYWRvdzogXCJub25lXCIsXG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgXCImOmhvdmVyLCAmOmFjdGl2ZSwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlGb3JtU3VibWl0QnV0dG9uID1cbiAgc3R5bGVkKFN0eWxlZFByaW1hcnlCdXR0b24pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlGb3JtU3VibWl0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRTZWNvbmRhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRlcnRpYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkVGVydGlhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuY29uc3QgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1pbkhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG5cbiAgICAvLyBzaG93IHBpbGxzIHdpdGggbG9uZyB0ZXh0IGluIHNpbmdsZSBsaW5lIGFuZCB1c2UgZWxsaXBzaXMgZm9yIG92ZXJmbG93XG4gICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcblxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG5cbiAgICBcIiYgZGl2XCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgICBcIiYgcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRQaWxsc0J1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gU2VnbWVudGVkIGNvbnRyb2wgYm9yZGVyIG1vZGVsOlxuLy8gbmVpZ2hib3JpbmcgYnV0dG9ucyBvdmVybGFwIGJ5IDEgYm9yZGVyIHdpZHRoLCBzbyBlYWNoIHNoYXJlZCBlZGdlIG5lZWRzIGFcbi8vIHNpbmdsZSBcIm93bmVyXCIgdG8gYXZvaWQgZG91YmxlLXdpZHRoIHNlYW1zLiBXZSB0cmVhdCBhY3RpdmUvaW50ZXJhY3RpdmVcbi8vIChob3Zlci9mb2N1cy12aXNpYmxlKSBidXR0b25zIGFzIHJhaXNlZCBhbmQgbGV0IHRoZW0gb3duIHNoYXJlZCBib3JkZXJzLlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOVEVSQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX05FVVRSQUxfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6bm90KDpob3Zlcik6bm90KDpmb2N1cy12aXNpYmxlKVwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sQWN0aXZlJ106bm90KDpkaXNhYmxlZCksICZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKWBdOlxuICAgICAge1xuICAgICAgICAvLyBSYWlzZWQgc2VnbWVudHMgc2hvdWxkIHJlbmRlciBhYm92ZSBuZXV0cmFsIG5laWdoYm9ycy5cbiAgICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICAgIH0sXG4gICAgLy8gQWN0aXZlIGhhcyBzdHJvbmdlc3QgcHJlY2VkZW5jZToga2VlcCBpdHMgYm9yZGVyIHZpc2libGUgYWdhaW5zdCBib3RoXG4gICAgLy8gbmV1dHJhbCBhbmQgaW50ZXJhY3RpdmUgbmVpZ2hib3JzLlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpICsgJHtTRUdNRU5URURfQ09OVFJPTF9JTkFDVElWRV9FTkFCTEVEfWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJMZWZ0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aGFzKCsgJHtTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgLy8gSG92ZXIvZm9jdXMgb3duZXJzaGlwIGlzIG9ubHkgYXBwbGllZCBiZXR3ZWVuIG5ldXRyYWwgbmVpZ2hib3JzIHNvIHdlXG4gICAgLy8gbmV2ZXIgaGlkZSB0aGUgYWN0aXZlIGJvcmRlciBpbiBhY3RpdmUraG92ZXIgYWRqYWNlbmN5LlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpICsgJHtTRUdNRU5URURfQ09OVFJPTF9ORVVUUkFMX0VOQUJMRUR9YF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlckxlZnRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTpub3QoOmhvdmVyKTpub3QoOmZvY3VzLXZpc2libGUpOmhhcygrICR7U0VHTUVOVEVEX0NPTlRST0xfSU5URVJBQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledPrimaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledPrimaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc18"
} : {
  target: "ef3psqc18",
  label: "StyledPrimaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2T0UiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL3NoYXJlZC9CYXNlQnV0dG9uL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCB7IE1vdXNlRXZlbnQsIFJlYWN0Tm9kZSB9IGZyb20gXCJyZWFjdFwiXG5cbmltcG9ydCBzdHlsZWQsIHsgQ1NTT2JqZWN0IH0gZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5pbXBvcnQgeyBkYXJrZW4sIHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgdHlwZSB7IEVtb3Rpb25UaGVtZSB9IGZyb20gXCJ+bGliL3RoZW1lL3R5cGVzXCJcblxuZXhwb3J0IGVudW0gQmFzZUJ1dHRvbktpbmQge1xuICBQUklNQVJZID0gXCJwcmltYXJ5XCIsXG4gIFNFQ09OREFSWSA9IFwic2Vjb25kYXJ5XCIsXG4gIFRFUlRJQVJZID0gXCJ0ZXJ0aWFyeVwiLFxuICBHSE9TVCA9IFwiZ2hvc3RcIixcbiAgQk9SREVSTEVTU19JQ09OID0gXCJib3JkZXJsZXNzSWNvblwiLFxuICBCT1JERVJMRVNTX0lDT05fQUNUSVZFID0gXCJib3JkZXJsZXNzSWNvbkFjdGl2ZVwiLFxuICBNSU5JTUFMID0gXCJtaW5pbWFsXCIsXG4gIFBSSU1BUllfRk9STV9TVUJNSVQgPSBcInByaW1hcnlGb3JtU3VibWl0XCIsXG4gIFNFQ09OREFSWV9GT1JNX1NVQk1JVCA9IFwic2Vjb25kYXJ5Rm9ybVN1Ym1pdFwiLFxuICBURVJUSUFSWV9GT1JNX1NVQk1JVCA9IFwidGVydGlhcnlGb3JtU3VibWl0XCIsXG4gIEhFQURFUl9CVVRUT04gPSBcImhlYWRlclwiLFxuICBIRUFERVJfTk9fUEFERElORyA9IFwiaGVhZGVyTm9QYWRkaW5nXCIsXG4gIEVMRU1FTlRfVE9PTEJBUiA9IFwiZWxlbWVudFRvb2xiYXJcIixcbiAgUElMTFMgPSBcInBpbGxzXCIsXG4gIFBJTExTX0FDVElWRSA9IFwicGlsbHNBY3RpdmVcIixcbiAgU0VHTUVOVEVEX0NPTlRST0wgPSBcInNlZ21lbnRlZF9jb250cm9sXCIsXG4gIFNFR01FTlRFRF9DT05UUk9MX0FDVElWRSA9IFwic2VnbWVudGVkX2NvbnRyb2xBY3RpdmVcIixcbn1cblxuZXhwb3J0IGVudW0gQmFzZUJ1dHRvblNpemUge1xuICBYU01BTEwgPSBcInhzbWFsbFwiLFxuICBTTUFMTCA9IFwic21hbGxcIixcbiAgTUVESVVNID0gXCJtZWRpdW1cIixcbiAgTEFSR0UgPSBcImxhcmdlXCIsXG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgQmFzZUJ1dHRvblByb3BzIHtcbiAga2luZDogQmFzZUJ1dHRvbktpbmRcbiAgc2l6ZT86IEJhc2VCdXR0b25TaXplXG4gIG9uQ2xpY2s/OiAoZXZlbnQ6IE1vdXNlRXZlbnQ8SFRNTEJ1dHRvbkVsZW1lbnQ+KSA9PiB2b2lkXG4gIGRpc2FibGVkPzogYm9vbGVhblxuICAvLyBJZiB0cnVlLCB0aGUgYnV0dG9uIHNob3VsZCB0YWtlIHVwIGNvbnRhaW5lcidzIGZ1bGwgd2lkdGhcbiAgY29udGFpbmVyV2lkdGg/OiBib29sZWFuXG4gIGNoaWxkcmVuOiBSZWFjdE5vZGVcbiAgYXV0b0ZvY3VzPzogYm9vbGVhblxuICBcImRhdGEtdGVzdGlkXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWxhYmVsXCI/OiBzdHJpbmdcbiAgXCJhcmlhLWhhc3BvcHVwXCI/OiBcIm1lbnVcIiB8IFwidHJ1ZVwiIHwgXCJkaWFsb2dcIiB8IFwibGlzdGJveFwiIHwgXCJ0cmVlXCIgfCBcImdyaWRcIlxuICBcImFyaWEtZXhwYW5kZWRcIj86IGJvb2xlYW5cbn1cblxuLy8gTW9zdCBwcm9wcyBiZWNvbWUgcmVxdWlyZWQgdmlhIGRlZmF1bHRzIGluIEJhc2VCdXR0b24sIGJ1dCBBUklBIHBvcHVwXG4vLyBhdHRyaWJ1dGVzIHN0YXkgb3B0aW9uYWwgc28gdGhleSBvbmx5IGFwcGVhciBpbiB0aGUgRE9NIHdoZW4gZXhwbGljaXRseSBzZXQuXG50eXBlIFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzID0gUmVxdWlyZWQ8XG4gIE9taXQ8QmFzZUJ1dHRvblByb3BzLCBcImFyaWEtaGFzcG9wdXBcIiB8IFwiYXJpYS1leHBhbmRlZFwiPlxuPiAmXG4gIFBpY2s8QmFzZUJ1dHRvblByb3BzLCBcImFyaWEtaGFzcG9wdXBcIiB8IFwiYXJpYS1leHBhbmRlZFwiPlxuXG5mdW5jdGlvbiBnZXRTaXplU3R5bGUoc2l6ZTogQmFzZUJ1dHRvblNpemUsIHRoZW1lOiBFbW90aW9uVGhlbWUpOiBDU1NPYmplY3Qge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlhTTUFMTDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgICAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgICAgfVxuICAgIGNhc2UgQmFzZUJ1dHRvblNpemUuU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLkxBUkdFOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5tZH0gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICB9XG59XG5cbmNvbnN0IFN0eWxlZEJhc2VCdXR0b24gPSBzdHlsZWQuYnV0dG9uPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPihcbiAgKHsgY29udGFpbmVyV2lkdGgsIHNpemUsIHRoZW1lIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy54c30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIG1pbkhlaWdodDogdGhlbWUuc2l6ZXMubWluRWxlbWVudEhlaWdodCxcbiAgICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICAgIHRleHRUcmFuc2Zvcm06IFwibm9uZVwiLFxuICAgICAgZm9udFNpemU6IFwiaW5oZXJpdFwiLFxuICAgICAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gICAgICBjb2xvcjogXCJpbmhlcml0XCIsXG4gICAgICB3aWR0aDogY29udGFpbmVyV2lkdGggPyBcIjEwMCVcIiA6IFwiYXV0b1wiLFxuICAgICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICAgIHVzZXJTZWxlY3Q6IFwibm9uZVwiLFxuICAgICAgXCImOmZvY3VzXCI6IHtcbiAgICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICB9LFxuICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgICAvLyBXaGVuIGZvY3VzLXZpc2libGUgKGUuZy4gaWYgdGhlIGJ1dHRvbiB3YXMgZm9jdXNlZCB2aWEga2V5Ym9hcmQgbmF2aWdhdGlvbilcbiAgICAgICAgLy8gd2UgdXNlIHRoZSBob3ZlciBzdHlsZSBvZiB0aGUgcmVzcGVjdGl2ZSBidXR0b24gdHlwZSAoc2VlIGJlbG93KSBhbmRcbiAgICAgICAgLy8gYWRkaXRpb25hbGx5IHNob3cgYSBjb2xvcmVkIGZvY3VzIHJpbmdcbiAgICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZyxcbiAgICAgIH0sXG4gICAgICAuLi5nZXRTaXplU3R5bGUoc2l6ZSwgdGhlbWUpLFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUHJpbWFyeUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy53aGl0ZSxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMucHJpbWFyeX1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMTUpLFxuICAgIGJvcmRlckNvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMTUpLFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIC8vIEtlZXAgdGhlIGJvcmRlciBkYXJrZXIgd2hlbiBjbGlja2VkIHNvIHRoYXQgdGhlIGJ1dHRvbiBsb29rcyBcInByZXNzZWRcIlxuICAgIGJvcmRlckNvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMTUpLFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlY29uZGFyeUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMubGlnaHRlbmVkQmcwNSxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRlcnRpYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gICAgXCImOmhvdmVyOm5vdCg6ZGlzYWJsZWQpLCAmOmZvY3VzLXZpc2libGU6bm90KDpkaXNhYmxlZClcIjoge1xuICAgICAgLy8gQWxzbyBtYWtlIGNvbG9yZWQgdGV4dCBoYXZlIHRoZSBwcmltYXJ5IGNvbG9yIG9uIGhvdmVyLiBTaW5jZSB0ZXh0IGNvbG9yIGlzXG4gICAgICAvLyBhcHBsaWVkIGFzIGFuIGlubGluZSBzdHlsZSB3ZSBuZWVkIHRvIHVzZSAhaW1wb3J0YW50IHRvIG92ZXJyaWRlIGl0LlxuICAgICAgLy8gTm90ZSB0aGF0IHdlJ3JlIG5vdCBkb2luZyB0aGlzIHdoZW4gZGlzYWJsZWQuIFdlIHNob3VsZCBwcm9iYWJseSBkbyB0aGF0IGFzXG4gICAgICAvLyB3ZWxsIGJ1dCB3ZSBkb24ndCBkbyBpdCBhbnl3aGVyZSBlbHNlLlxuICAgICAgXCJzcGFuLnN0TWFya2Rvd25Db2xvcmVkVGV4dFwiOiB7XG4gICAgICAgIGNvbG9yOiBcImluaGVyaXQgIWltcG9ydGFudFwiLFxuICAgICAgfSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4yNSksXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRHaG9zdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLnRyYW5zcGFyZW50fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNaW5pbWFsQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBcIm5vbmVcIixcbiAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgcGFkZGluZzogdGhlbWUuc3BhY2luZy5ub25lLFxuICBcIiY6aG92ZXIsICY6YWN0aXZlLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUHJpbWFyeUZvcm1TdWJtaXRCdXR0b24gPVxuICBzdHlsZWQoU3R5bGVkUHJpbWFyeUJ1dHRvbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlY29uZGFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFNlY29uZGFyeUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlGb3JtU3VibWl0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRUZXJ0aWFyeUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5jb25zdCBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kOiB0aGVtZS5jb2xvcnMuYmdDb2xvcixcbiAgICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgaGVpZ2h0OiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5sYXJnZUxvZ29IZWlnaHQsXG4gICAgbWF4V2lkdGg6IHRoZW1lLnNpemVzLmNvbnRlbnRNYXhXaWR0aCxcblxuICAgIC8vIHNob3cgcGlsbHMgd2l0aCBsb25nIHRleHQgaW4gc2luZ2xlIGxpbmUgYW5kIHVzZSBlbGxpcHNpcyBmb3Igb3ZlcmZsb3dcbiAgICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcblxuICAgIFwiJiBkaXZcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICAgIFwiJiBwXCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgIC8vIFdoZW4gY29udGFpbmVyV2lkdGggaXMgdHJ1ZSwgdGhlIGJ1dHRvbnMgd2lsbCBzdHJldGNoIHRvIGZpbGwgdGhlIGNvbnRhaW5lci5cbiAgICBmbGV4OiBjb250YWluZXJXaWR0aCA/IFwiMSAxIGZpdC1jb250ZW50XCIgOiBcIlwiLFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFBpbGxzQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC45KSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOCksXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQwNSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuICB9XG59KVxuXG4vLyBTZWdtZW50ZWQgY29udHJvbCBib3JkZXIgbW9kZWw6XG4vLyBuZWlnaGJvcmluZyBidXR0b25zIG92ZXJsYXAgYnkgMSBib3JkZXIgd2lkdGgsIHNvIGVhY2ggc2hhcmVkIGVkZ2UgbmVlZHMgYVxuLy8gc2luZ2xlIFwib3duZXJcIiB0byBhdm9pZCBkb3VibGUtd2lkdGggc2VhbXMuIFdlIHRyZWF0IGFjdGl2ZS9pbnRlcmFjdGl2ZVxuLy8gKGhvdmVyL2ZvY3VzLXZpc2libGUpIGJ1dHRvbnMgYXMgcmFpc2VkIGFuZCBsZXQgdGhlbSBvd24gc2hhcmVkIGJvcmRlcnMuXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkVfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sQWN0aXZlJ106bm90KDpkaXNhYmxlZClcIlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfSU5BQ1RJVkVfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZClcIlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfSU5URVJBQ1RJVkVfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aXMoOmhvdmVyLCA6Zm9jdXMtdmlzaWJsZSlcIlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfTkVVVFJBTF9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTpub3QoOmhvdmVyKTpub3QoOmZvY3VzLXZpc2libGUpXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcbiAgICBib3JkZXJSYWRpdXM6IFwiMFwiLFxuICAgIC8vIFdoZW4gY29udGFpbmVyV2lkdGggaXMgdHJ1ZSwgdGhlIGJ1dHRvbnMgd2lsbCBzdHJldGNoIHRvIGZpbGwgdGhlIGNvbnRhaW5lci5cbiAgICBmbGV4OiBjb250YWluZXJXaWR0aCA/IFwiMSAxIGZpdC1jb250ZW50XCIgOiBcIlwiLFxuICAgIG1heFdpZHRoOiBcIjEwMCVcIixcbiAgICBtYXJnaW5SaWdodDogYC0ke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofWAsIC8vIEFkZCBuZWdhdGl2ZSBtYXJnaW4gdG8gb3ZlcmxhcCBib3JkZXJzXG5cbiAgICBcIiY6Zmlyc3QtY2hpbGRcIjoge1xuICAgICAgYm9yZGVyVG9wTGVmdFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgIH0sXG4gICAgXCImOmxhc3QtY2hpbGRcIjoge1xuICAgICAgYm9yZGVyVG9wUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLCAvLyBSZXNldCBtYXJnaW4gZm9yIHRoZSBsYXN0IGNoaWxkXG4gICAgfSxcbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2xBY3RpdmUnXTpub3QoOmRpc2FibGVkKSwgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpYF06XG4gICAgICB7XG4gICAgICAgIC8vIFJhaXNlZCBzZWdtZW50cyBzaG91bGQgcmVuZGVyIGFib3ZlIG5ldXRyYWwgbmVpZ2hib3JzLlxuICAgICAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLnByaW9yaXR5LFxuICAgICAgfSxcbiAgICAvLyBBY3RpdmUgaGFzIHN0cm9uZ2VzdCBwcmVjZWRlbmNlOiBrZWVwIGl0cyBib3JkZXIgdmlzaWJsZSBhZ2FpbnN0IGJvdGhcbiAgICAvLyBuZXV0cmFsIGFuZCBpbnRlcmFjdGl2ZSBuZWlnaGJvcnMuXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sQWN0aXZlJ106bm90KDpkaXNhYmxlZCkgKyAke1NFR01FTlRFRF9DT05UUk9MX0lOQUNUSVZFX0VOQUJMRUR9YF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlckxlZnRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTpoYXMoKyAke1NFR01FTlRFRF9DT05UUk9MX0FDVElWRV9FTkFCTEVEfSlgXTpcbiAgICAgIHtcbiAgICAgICAgYm9yZGVyUmlnaHRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICAvLyBIb3Zlci9mb2N1cyBvd25lcnNoaXAgaXMgb25seSBhcHBsaWVkIGJldHdlZW4gbmV1dHJhbCBuZWlnaGJvcnMgc28gd2VcbiAgICAvLyBuZXZlciBoaWRlIHRoZSBhY3RpdmUgYm9yZGVyIGluIGFjdGl2ZStob3ZlciBhZGphY2VuY3kuXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aXMoOmhvdmVyLCA6Zm9jdXMtdmlzaWJsZSkgKyAke1NFR01FTlRFRF9DT05UUk9MX05FVVRSQUxfRU5BQkxFRH1gXTpcbiAgICAgIHtcbiAgICAgICAgYm9yZGVyTGVmdENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOm5vdCg6aG92ZXIpOm5vdCg6Zm9jdXMtdmlzaWJsZSk6aGFzKCsgJHtTRUdNRU5URURfQ09OVFJPTF9JTlRFUkFDVElWRV9FTkFCTEVEfSlgXTpcbiAgICAgIHtcbiAgICAgICAgYm9yZGVyUmlnaHRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAvLyBNYWtlIHN1cmUgdGhlIGZvY3VzIHJpbmcgaXNuJ3QgYmVsb3cgdGhlIHByZXZpb3VzL25leHQgYnV0dG9uLlxuICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VnbWVudGVkQ29udHJvbEJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkU2VnbWVudGVkQ29udHJvbEJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLnByaW9yaXR5LFxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOCksXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQwNSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGVyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMubm9uZSxcblxuICAgIG1pbldpZHRoOiB0aGVtZS5zaXplcy5oZWFkZXJJdGVtSGVpZ2h0LFxuICAgIG1pbkhlaWdodDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmdNdXRlZCxcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICAgIH0sXG4gIH1cbn0pXG5cbi8vIFRha2Ugb3V0IHBhZGRpbmcgZm9yIHRoaXMgc3BlY2lmaWMgYnV0dG9uLCBzbyB3ZSBjYW4gZW5zdXJlIGl0J3MgMzJ4MzJweCBsaWtlIG90aGVyIGJ1dHRvbnMgaW4gQ29tbXVuaXR5IENsb3VkXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGVyTm9QYWRkaW5nQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRIZWFkZXJCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCgpID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiAwLFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgY29uc3QgaWNvblBhZGRpbmc6IFJlY29yZDxCYXNlQnV0dG9uU2l6ZSwgc3RyaW5nPiA9IHtcbiAgICBbQmFzZUJ1dHRvblNpemUuWFNNQUxMXTogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5TTUFMTF06IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgW0Jhc2VCdXR0b25TaXplLk1FRElVTV06IHRoZW1lLnNwYWNpbmcubWQsXG4gICAgW0Jhc2VCdXR0b25TaXplLkxBUkdFXTogdGhlbWUuc3BhY2luZy5sZyxcbiAgfVxuXG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ2MCxcbiAgICBwYWRkaW5nOiBpY29uUGFkZGluZ1tzaXplXSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcblxuICAgIC8vIEtlZXBzIHRoZSBidXR0b25zIGZyb20gc3RhY2tpbmcgd2hlbiBpbiBjb250YWluZXJXaWR0aCBtb2RlLlxuICAgIC8vIFRoZXNlIGJ1dHRvbnMgc2hvdWxkIHN0YXkgdG9nZXRoZXIgYW5kIG5vdCBzdHJldGNoIHRvIGZpbGwgdGhlIGNvbnRhaW5lci5cbiAgICBmbGV4OiBcIjAgMCBmaXQtY29udGVudFwiLFxuXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBtaW5IZWlnaHQ6IFwidW5zZXRcIixcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQxMCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuXG4gICAgICAvLyBGb3IgaW1hZ2UgY29udGVudFxuICAgICAgaW1nOiB7XG4gICAgICAgIG9wYWNpdHk6IDAuNCxcbiAgICAgIH0sXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTm9ybWFsID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgZGlzcGxheTogXCJub25lXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvb2x0aXBNb2JpbGUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwibm9uZVwiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRWxlbWVudFRvb2xiYXJCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy50d29TbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBnYXA6IHRoZW1lLnNwYWNpbmcueHMsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBtaW5IZWlnaHQ6IFwidW5zZXRcIixcbiAgICAvLyBsaW5lIGhlaWdodCBzaG91bGQgYmUgdGhlIHNhbWUgYXMgdGhlIGljb24gc2l6ZVxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmljb25TaXplcy5tZCxcbiAgICB3aWR0aDogXCJhdXRvXCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uR3JvdXAgPSBzdHlsZWQuZGl2PHsgY29udGFpbmVyV2lkdGg6IGJvb2xlYW4gfT4oXG4gICh7IGNvbnRhaW5lcldpZHRoIH0pID0+ICh7XG4gICAgd2lkdGg6IGNvbnRhaW5lcldpZHRoID8gXCIxMDAlXCIgOiBcImF1dG9cIixcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkxhYmVsID0gc3R5bGVkLmRpdigoKSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uTWFpbkxhYmVsID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBtaW5XaWR0aDogMCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uU2hvcnRjdXQgPSBzdHlsZWQua2JkKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIG9wYWNpdHk6IDAuNixcbiAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnRpZ2h0LFxuICBsZXR0ZXJTcGFjaW5nOiBcIjAuMDFlbVwiLFxufSkpXG4iXX0= */"), StyledSecondaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledSecondaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc17"
} : {
  target: "ef3psqc17",
  label: "StyledSecondaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTertiaryFormSubmitButton = /* @__PURE__ */ createStyled(StyledTertiaryButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc16"
} : {
  target: "ef3psqc16",
  label: "StyledTertiaryFormSubmitButton"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonGroupBaseButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc15"
} : {
  target: "ef3psqc15",
  label: "StyledButtonGroupBaseButton"
})(({
  theme: CA
}) => ({
  background: CA.colors.bgColor,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
  fontSize: CA.fontSizes.sm,
  lineHeight: CA.lineHeights.base,
  fontWeight: CA.fontWeights.normal,
  height: CA.sizes.largeLogoHeight,
  minHeight: CA.sizes.largeLogoHeight,
  maxWidth: CA.sizes.contentMaxWidth,
  // show pills with long text in single line and use ellipsis for overflow
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "&:hover, &:focus-visible": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: CA.colors.borderColor,
    backgroundColor: CA.colors.transparent,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  },
  "& div": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  "& p": {
    textOverflow: "ellipsis",
    overflow: "hidden"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc14"
} : {
  target: "ef3psqc14",
  label: "StyledPillsButton"
})(({
  theme: CA,
  containerWidth: gA
}) => ({
  borderRadius: CA.radii.full,
  padding: `${CA.spacing.twoXS} ${CA.spacing.md}`,
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: gA ? "1 1 fit-content" : ""
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPillsButtonActive = /* @__PURE__ */ createStyled(StyledPillsButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc13"
} : {
  target: "ef3psqc13",
  label: "StyledPillsButtonActive"
})(({
  theme: CA
}) => ({
  backgroundColor: transparentize(CA.colors.primary, 0.9),
  borderColor: CA.colors.primary,
  color: CA.colors.primary,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(CA.colors.primary, 0.8),
    borderColor: CA.colors.primary,
    color: CA.colors.primary
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: CA.colors.borderColor,
    backgroundColor: CA.colors.fadedText05,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SEGMENTED_CONTROL_ACTIVE_ENABLED = "button[kind='segmented_controlActive']:not(:disabled)", SEGMENTED_CONTROL_INACTIVE_ENABLED = "button[kind='segmented_control']:not(:disabled)", SEGMENTED_CONTROL_INTERACTIVE_ENABLED = "button[kind='segmented_control']:not(:disabled):is(:hover, :focus-visible)", SEGMENTED_CONTROL_NEUTRAL_ENABLED = "button[kind='segmented_control']:not(:disabled):not(:hover):not(:focus-visible)", StyledSegmentedControlButton = /* @__PURE__ */ createStyled(StyledButtonGroupBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc12"
} : {
  target: "ef3psqc12",
  label: "StyledSegmentedControlButton"
})(({
  theme: CA,
  containerWidth: gA
}) => ({
  padding: `${CA.spacing.twoXS} ${CA.spacing.lg}`,
  borderRadius: "0",
  // When containerWidth is true, the buttons will stretch to fill the container.
  flex: gA ? "1 1 fit-content" : "",
  maxWidth: "100%",
  marginRight: `-${CA.sizes.borderWidth}`,
  // Add negative margin to overlap borders
  "&:first-child": {
    borderTopLeftRadius: CA.radii.button,
    borderBottomLeftRadius: CA.radii.button
  },
  "&:last-child": {
    borderTopRightRadius: CA.radii.button,
    borderBottomRightRadius: CA.radii.button,
    marginRight: CA.spacing.none
    // Reset margin for the last child
  },
  "&[kind='segmented_controlActive']:not(:disabled), &[kind='segmented_control']:not(:disabled):is(:hover, :focus-visible)": {
    // Raised segments should render above neutral neighbors.
    zIndex: CA.zIndices.priority
  },
  // Active has strongest precedence: keep its border visible against both
  // neutral and interactive neighbors.
  [`&[kind='segmented_controlActive']:not(:disabled) + ${SEGMENTED_CONTROL_INACTIVE_ENABLED}`]: {
    borderLeftColor: CA.colors.transparent
  },
  [`&[kind='segmented_control']:not(:disabled):has(+ ${SEGMENTED_CONTROL_ACTIVE_ENABLED})`]: {
    borderRightColor: CA.colors.transparent
  },
  // Hover/focus ownership is only applied between neutral neighbors so we
  // never hide the active border in active+hover adjacency.
  [`&[kind='segmented_control']:not(:disabled):is(:hover, :focus-visible) + ${SEGMENTED_CONTROL_NEUTRAL_ENABLED}`]: {
    borderLeftColor: CA.colors.transparent
  },
  [`&[kind='segmented_control']:not(:disabled):not(:hover):not(:focus-visible):has(+ ${SEGMENTED_CONTROL_INTERACTIVE_ENABLED})`]: {
    borderRightColor: CA.colors.transparent
  },
  "&:focus-visible": {
    // Make sure the focus ring isn't below the previous/next button.
    zIndex: CA.zIndices.priority
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSegmentedControlButtonActive = /* @__PURE__ */ createStyled(StyledSegmentedControlButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc11"
} : {
  target: "ef3psqc11",
  label: "StyledSegmentedControlButtonActive"
})(({
  theme: CA
}) => ({
  backgroundColor: transparentize(CA.colors.primary, 0.9),
  borderColor: CA.colors.primary,
  color: CA.colors.primary,
  zIndex: CA.zIndices.priority,
  "&:hover, &:focus-visible": {
    backgroundColor: transparentize(CA.colors.primary, 0.8)
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    borderColor: CA.colors.borderColor,
    backgroundColor: CA.colors.fadedText05,
    color: CA.colors.fadedText40,
    cursor: "not-allowed"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErWGtEIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBNb3VzZUV2ZW50LCBSZWFjdE5vZGUgfSBmcm9tIFwicmVhY3RcIlxuXG5pbXBvcnQgc3R5bGVkLCB7IENTU09iamVjdCB9IGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuaW1wb3J0IHsgZGFya2VuLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gXCJjb2xvcjJrXCJcblxuaW1wb3J0IHR5cGUgeyBFbW90aW9uVGhlbWUgfSBmcm9tIFwifmxpYi90aGVtZS90eXBlc1wiXG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25LaW5kIHtcbiAgUFJJTUFSWSA9IFwicHJpbWFyeVwiLFxuICBTRUNPTkRBUlkgPSBcInNlY29uZGFyeVwiLFxuICBURVJUSUFSWSA9IFwidGVydGlhcnlcIixcbiAgR0hPU1QgPSBcImdob3N0XCIsXG4gIEJPUkRFUkxFU1NfSUNPTiA9IFwiYm9yZGVybGVzc0ljb25cIixcbiAgQk9SREVSTEVTU19JQ09OX0FDVElWRSA9IFwiYm9yZGVybGVzc0ljb25BY3RpdmVcIixcbiAgTUlOSU1BTCA9IFwibWluaW1hbFwiLFxuICBQUklNQVJZX0ZPUk1fU1VCTUlUID0gXCJwcmltYXJ5Rm9ybVN1Ym1pdFwiLFxuICBTRUNPTkRBUllfRk9STV9TVUJNSVQgPSBcInNlY29uZGFyeUZvcm1TdWJtaXRcIixcbiAgVEVSVElBUllfRk9STV9TVUJNSVQgPSBcInRlcnRpYXJ5Rm9ybVN1Ym1pdFwiLFxuICBIRUFERVJfQlVUVE9OID0gXCJoZWFkZXJcIixcbiAgSEVBREVSX05PX1BBRERJTkcgPSBcImhlYWRlck5vUGFkZGluZ1wiLFxuICBFTEVNRU5UX1RPT0xCQVIgPSBcImVsZW1lbnRUb29sYmFyXCIsXG4gIFBJTExTID0gXCJwaWxsc1wiLFxuICBQSUxMU19BQ1RJVkUgPSBcInBpbGxzQWN0aXZlXCIsXG4gIFNFR01FTlRFRF9DT05UUk9MID0gXCJzZWdtZW50ZWRfY29udHJvbFwiLFxuICBTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkUgPSBcInNlZ21lbnRlZF9jb250cm9sQWN0aXZlXCIsXG59XG5cbmV4cG9ydCBlbnVtIEJhc2VCdXR0b25TaXplIHtcbiAgWFNNQUxMID0gXCJ4c21hbGxcIixcbiAgU01BTEwgPSBcInNtYWxsXCIsXG4gIE1FRElVTSA9IFwibWVkaXVtXCIsXG4gIExBUkdFID0gXCJsYXJnZVwiLFxufVxuXG5leHBvcnQgaW50ZXJmYWNlIEJhc2VCdXR0b25Qcm9wcyB7XG4gIGtpbmQ6IEJhc2VCdXR0b25LaW5kXG4gIHNpemU/OiBCYXNlQnV0dG9uU2l6ZVxuICBvbkNsaWNrPzogKGV2ZW50OiBNb3VzZUV2ZW50PEhUTUxCdXR0b25FbGVtZW50PikgPT4gdm9pZFxuICBkaXNhYmxlZD86IGJvb2xlYW5cbiAgLy8gSWYgdHJ1ZSwgdGhlIGJ1dHRvbiBzaG91bGQgdGFrZSB1cCBjb250YWluZXIncyBmdWxsIHdpZHRoXG4gIGNvbnRhaW5lcldpZHRoPzogYm9vbGVhblxuICBjaGlsZHJlbjogUmVhY3ROb2RlXG4gIGF1dG9Gb2N1cz86IGJvb2xlYW5cbiAgXCJkYXRhLXRlc3RpZFwiPzogc3RyaW5nXG4gIFwiYXJpYS1sYWJlbFwiPzogc3RyaW5nXG4gIFwiYXJpYS1oYXNwb3B1cFwiPzogXCJtZW51XCIgfCBcInRydWVcIiB8IFwiZGlhbG9nXCIgfCBcImxpc3Rib3hcIiB8IFwidHJlZVwiIHwgXCJncmlkXCJcbiAgXCJhcmlhLWV4cGFuZGVkXCI/OiBib29sZWFuXG59XG5cbi8vIE1vc3QgcHJvcHMgYmVjb21lIHJlcXVpcmVkIHZpYSBkZWZhdWx0cyBpbiBCYXNlQnV0dG9uLCBidXQgQVJJQSBwb3B1cFxuLy8gYXR0cmlidXRlcyBzdGF5IG9wdGlvbmFsIHNvIHRoZXkgb25seSBhcHBlYXIgaW4gdGhlIERPTSB3aGVuIGV4cGxpY2l0bHkgc2V0LlxudHlwZSBSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcyA9IFJlcXVpcmVkPFxuICBPbWl0PEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cbj4gJlxuICBQaWNrPEJhc2VCdXR0b25Qcm9wcywgXCJhcmlhLWhhc3BvcHVwXCIgfCBcImFyaWEtZXhwYW5kZWRcIj5cblxuZnVuY3Rpb24gZ2V0U2l6ZVN0eWxlKHNpemU6IEJhc2VCdXR0b25TaXplLCB0aGVtZTogRW1vdGlvblRoZW1lKTogQ1NTT2JqZWN0IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5YU01BTEw6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIH1cbiAgICBjYXNlIEJhc2VCdXR0b25TaXplLlNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5MQVJHRTpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcubWR9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgfVxufVxuXG5jb25zdCBTdHlsZWRCYXNlQnV0dG9uID0gc3R5bGVkLmJ1dHRvbjxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oXG4gICh7IGNvbnRhaW5lcldpZHRoLCBzaXplLCB0aGVtZSB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLm1pbkVsZW1lbnRIZWlnaHQsXG4gICAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgICB0ZXh0VHJhbnNmb3JtOiBcIm5vbmVcIixcbiAgICAgIGZvbnRTaXplOiBcImluaGVyaXRcIixcbiAgICAgIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgICAgd2lkdGg6IGNvbnRhaW5lcldpZHRoID8gXCIxMDAlXCIgOiBcImF1dG9cIixcbiAgICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcbiAgICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgICAgLy8gV2hlbiBmb2N1cy12aXNpYmxlIChlLmcuIGlmIHRoZSBidXR0b24gd2FzIGZvY3VzZWQgdmlhIGtleWJvYXJkIG5hdmlnYXRpb24pXG4gICAgICAgIC8vIHdlIHVzZSB0aGUgaG92ZXIgc3R5bGUgb2YgdGhlIHJlc3BlY3RpdmUgYnV0dG9uIHR5cGUgKHNlZSBiZWxvdykgYW5kXG4gICAgICAgIC8vIGFkZGl0aW9uYWxseSBzaG93IGEgY29sb3JlZCBmb2N1cyByaW5nXG4gICAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgICB9LFxuICAgICAgLi4uZ2V0U2l6ZVN0eWxlKHNpemUsIHRoZW1lKSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIGNvbG9yOiB0aGVtZS5jb2xvcnMud2hpdGUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLnByaW1hcnl9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAvLyBLZWVwIHRoZSBib3JkZXIgZGFya2VyIHdoZW4gY2xpY2tlZCBzbyB0aGF0IHRoZSBidXR0b24gbG9va3MgXCJwcmVzc2VkXCJcbiAgICBib3JkZXJDb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjE1KSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmxpZ2h0ZW5lZEJnMDUsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpob3Zlcjpub3QoOmRpc2FibGVkKSwgJjpmb2N1cy12aXNpYmxlOm5vdCg6ZGlzYWJsZWQpXCI6IHtcbiAgICAgIC8vIEFsc28gbWFrZSBjb2xvcmVkIHRleHQgaGF2ZSB0aGUgcHJpbWFyeSBjb2xvciBvbiBob3Zlci4gU2luY2UgdGV4dCBjb2xvciBpc1xuICAgICAgLy8gYXBwbGllZCBhcyBhbiBpbmxpbmUgc3R5bGUgd2UgbmVlZCB0byB1c2UgIWltcG9ydGFudCB0byBvdmVycmlkZSBpdC5cbiAgICAgIC8vIE5vdGUgdGhhdCB3ZSdyZSBub3QgZG9pbmcgdGhpcyB3aGVuIGRpc2FibGVkLiBXZSBzaG91bGQgcHJvYmFibHkgZG8gdGhhdCBhc1xuICAgICAgLy8gd2VsbCBidXQgd2UgZG9uJ3QgZG8gaXQgYW55d2hlcmUgZWxzZS5cbiAgICAgIFwic3Bhbi5zdE1hcmtkb3duQ29sb3JlZFRleHRcIjoge1xuICAgICAgICBjb2xvcjogXCJpbmhlcml0ICFpbXBvcnRhbnRcIixcbiAgICAgIH0sXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiBkYXJrZW4odGhlbWUuY29sb3JzLnByaW1hcnksIDAuMjUpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkR2hvc3RCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy50cmFuc3BhcmVudH1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWluaW1hbEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIGJveFNoYWRvdzogXCJub25lXCIsXG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgXCImOmhvdmVyLCAmOmFjdGl2ZSwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByaW1hcnlGb3JtU3VibWl0QnV0dG9uID1cbiAgc3R5bGVkKFN0eWxlZFByaW1hcnlCdXR0b24pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWNvbmRhcnlGb3JtU3VibWl0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRTZWNvbmRhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRlcnRpYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkVGVydGlhcnlCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KClcblxuY29uc3QgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZDogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gICAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmJhc2UsXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1pbkhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxuICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG5cbiAgICAvLyBzaG93IHBpbGxzIHdpdGggbG9uZyB0ZXh0IGluIHNpbmdsZSBsaW5lIGFuZCB1c2UgZWxsaXBzaXMgZm9yIG92ZXJmbG93XG4gICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcblxuICAgIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG5cbiAgICBcIiYgZGl2XCI6IHtcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgfSxcbiAgICBcIiYgcFwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFBpbGxzQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRQaWxsc0J1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLnByaW1hcnksIDAuOSksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gU2VnbWVudGVkIGNvbnRyb2wgYm9yZGVyIG1vZGVsOlxuLy8gbmVpZ2hib3JpbmcgYnV0dG9ucyBvdmVybGFwIGJ5IDEgYm9yZGVyIHdpZHRoLCBzbyBlYWNoIHNoYXJlZCBlZGdlIG5lZWRzIGFcbi8vIHNpbmdsZSBcIm93bmVyXCIgdG8gYXZvaWQgZG91YmxlLXdpZHRoIHNlYW1zLiBXZSB0cmVhdCBhY3RpdmUvaW50ZXJhY3RpdmVcbi8vIChob3Zlci9mb2N1cy12aXNpYmxlKSBidXR0b25zIGFzIHJhaXNlZCBhbmQgbGV0IHRoZW0gb3duIHNoYXJlZCBib3JkZXJzLlxuY29uc3QgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0lOVEVSQUNUSVZFX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpXCJcbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX05FVVRSQUxfRU5BQkxFRCA9XG4gIFwiYnV0dG9uW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6bm90KDpob3Zlcik6bm90KDpmb2N1cy12aXNpYmxlKVwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCdXR0b25Hcm91cEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lLCBjb250YWluZXJXaWR0aCB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgYm9yZGVyUmFkaXVzOiBcIjBcIixcbiAgICAvLyBXaGVuIGNvbnRhaW5lcldpZHRoIGlzIHRydWUsIHRoZSBidXR0b25zIHdpbGwgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogY29udGFpbmVyV2lkdGggPyBcIjEgMSBmaXQtY29udGVudFwiIDogXCJcIixcbiAgICBtYXhXaWR0aDogXCIxMDAlXCIsXG4gICAgbWFyZ2luUmlnaHQ6IGAtJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH1gLCAvLyBBZGQgbmVnYXRpdmUgbWFyZ2luIHRvIG92ZXJsYXAgYm9yZGVyc1xuXG4gICAgXCImOmZpcnN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIGJvcmRlckJvdHRvbUxlZnRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICB9LFxuICAgIFwiJjpsYXN0LWNoaWxkXCI6IHtcbiAgICAgIGJvcmRlclRvcFJpZ2h0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21SaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcubm9uZSwgLy8gUmVzZXQgbWFyZ2luIGZvciB0aGUgbGFzdCBjaGlsZFxuICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sQWN0aXZlJ106bm90KDpkaXNhYmxlZCksICZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKWBdOlxuICAgICAge1xuICAgICAgICAvLyBSYWlzZWQgc2VnbWVudHMgc2hvdWxkIHJlbmRlciBhYm92ZSBuZXV0cmFsIG5laWdoYm9ycy5cbiAgICAgICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICAgIH0sXG4gICAgLy8gQWN0aXZlIGhhcyBzdHJvbmdlc3QgcHJlY2VkZW5jZToga2VlcCBpdHMgYm9yZGVyIHZpc2libGUgYWdhaW5zdCBib3RoXG4gICAgLy8gbmV1dHJhbCBhbmQgaW50ZXJhY3RpdmUgbmVpZ2hib3JzLlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpICsgJHtTRUdNRU5URURfQ09OVFJPTF9JTkFDVElWRV9FTkFCTEVEfWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJMZWZ0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aGFzKCsgJHtTRUdNRU5URURfQ09OVFJPTF9BQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgLy8gSG92ZXIvZm9jdXMgb3duZXJzaGlwIGlzIG9ubHkgYXBwbGllZCBiZXR3ZWVuIG5ldXRyYWwgbmVpZ2hib3JzIHNvIHdlXG4gICAgLy8gbmV2ZXIgaGlkZSB0aGUgYWN0aXZlIGJvcmRlciBpbiBhY3RpdmUraG92ZXIgYWRqYWNlbmN5LlxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmlzKDpob3ZlciwgOmZvY3VzLXZpc2libGUpICsgJHtTRUdNRU5URURfQ09OVFJPTF9ORVVUUkFMX0VOQUJMRUR9YF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlckxlZnRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgfSxcbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTpub3QoOmhvdmVyKTpub3QoOmZvY3VzLXZpc2libGUpOmhhcygrICR7U0VHTUVOVEVEX0NPTlRST0xfSU5URVJBQ1RJVkVfRU5BQkxFRH0pYF06XG4gICAgICB7XG4gICAgICAgIGJvcmRlclJpZ2h0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgLy8gTWFrZSBzdXJlIHRoZSBmb2N1cyByaW5nIGlzbid0IGJlbG93IHRoZSBwcmV2aW91cy9uZXh0IGJ1dHRvbi5cbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZFNlZ21lbnRlZENvbnRyb2xCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5wcmlvcml0eSxcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjgpLFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLmJvcmRlckNvbG9yLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MDUsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcblxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm5vbmUsXG5cbiAgICBtaW5XaWR0aDogdGhlbWUuc2l6ZXMuaGVhZGVySXRlbUhlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nTXV0ZWQsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmdyYXkzMCxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk2MCxcbiAgICB9LFxuICB9XG59KVxuXG4vLyBUYWtlIG91dCBwYWRkaW5nIGZvciB0aGlzIHNwZWNpZmljIGJ1dHRvbiwgc28gd2UgY2FuIGVuc3VyZSBpdCdzIDMyeDMycHggbGlrZSBvdGhlciBidXR0b25zIGluIENvbW11bml0eSBDbG91ZFxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlck5vUGFkZGluZ0J1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkSGVhZGVyQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoKSA9PiB7XG4gIHJldHVybiB7XG4gICAgcGFkZGluZzogMCxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIGNvbnN0IGljb25QYWRkaW5nOiBSZWNvcmQ8QmFzZUJ1dHRvblNpemUsIHN0cmluZz4gPSB7XG4gICAgW0Jhc2VCdXR0b25TaXplLlhTTUFMTF06IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuU01BTExdOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5NRURJVU1dOiB0aGVtZS5zcGFjaW5nLm1kLFxuICAgIFtCYXNlQnV0dG9uU2l6ZS5MQVJHRV06IHRoZW1lLnNwYWNpbmcubGcsXG4gIH1cblxuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgcGFkZGluZzogaWNvblBhZGRpbmdbc2l6ZV0sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG5cbiAgICAvLyBLZWVwcyB0aGUgYnV0dG9ucyBmcm9tIHN0YWNraW5nIHdoZW4gaW4gY29udGFpbmVyV2lkdGggbW9kZS5cbiAgICAvLyBUaGVzZSBidXR0b25zIHNob3VsZCBzdGF5IHRvZ2V0aGVyIGFuZCBub3Qgc3RyZXRjaCB0byBmaWxsIHRoZSBjb250YWluZXIuXG4gICAgZmxleDogXCIwIDAgZml0LWNvbnRlbnRcIixcblxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG5cbiAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0MTAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcblxuICAgICAgLy8gRm9yIGltYWdlIGNvbnRlbnRcbiAgICAgIGltZzoge1xuICAgICAgICBvcGFjaXR5OiAwLjQsXG4gICAgICB9LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE5vcm1hbCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJibG9ja1wiLFxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgIGRpc3BsYXk6IFwibm9uZVwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwTW9iaWxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnRUb29sYmFyQnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMudHdvU20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgbWluSGVpZ2h0OiBcInVuc2V0XCIsXG4gICAgLy8gbGluZSBoZWlnaHQgc2hvdWxkIGJlIHRoZSBzYW1lIGFzIHRoZSBpY29uIHNpemVcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG4gICAgd2lkdGg6IFwiYXV0b1wiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwID0gc3R5bGVkLmRpdjx7IGNvbnRhaW5lcldpZHRoOiBib29sZWFuIH0+KFxuICAoeyBjb250YWluZXJXaWR0aCB9KSA9PiAoe1xuICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25MYWJlbCA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvbk1haW5MYWJlbCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWluV2lkdGg6IDAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEJ1dHRvblNob3J0Y3V0ID0gc3R5bGVkLmtiZCgoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICBvcGFjaXR5OiAwLjYsXG4gIGZvbnRGYW1pbHk6IFwiaW5oZXJpdFwiLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy50aWdodCxcbiAgbGV0dGVyU3BhY2luZzogXCIwLjAxZW1cIixcbn0pKVxuIl19 */"), StyledHeaderButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc10"
} : {
  target: "ef3psqc10",
  label: "StyledHeaderButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.transparent,
  border: "none",
  padding: `0 ${CA.spacing.sm}`,
  fontSize: CA.fontSizes.sm,
  marginLeft: CA.spacing.threeXS,
  marginRight: CA.spacing.threeXS,
  lineHeight: CA.lineHeights.none,
  minWidth: CA.sizes.headerItemHeight,
  minHeight: CA.sizes.headerItemHeight,
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRingMuted
  },
  "&:hover": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: CA.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: CA.colors.gray30,
    borderColor: CA.colors.transparent,
    color: CA.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderNoPaddingButton = /* @__PURE__ */ createStyled(StyledHeaderButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc9"
} : {
  target: "ef3psqc9",
  label: "StyledHeaderNoPaddingButton"
})(() => ({
  padding: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledBorderlessIconButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc8"
} : {
  target: "ef3psqc8",
  label: "StyledBorderlessIconButton"
})(({
  size: CA,
  theme: gA
}) => {
  const AA = {
    xsmall: gA.spacing.threeXS,
    small: gA.spacing.twoXS,
    medium: gA.spacing.md,
    large: gA.spacing.lg
  };
  return {
    backgroundColor: gA.colors.transparent,
    color: gA.colors.fadedText60,
    padding: AA[CA],
    marginLeft: gA.spacing.none,
    marginRight: gA.spacing.none,
    // Keeps the buttons from stacking when in containerWidth mode.
    // These buttons should stay together and not stretch to fill the container.
    flex: "0 0 fit-content",
    border: "none",
    display: "flex",
    minHeight: "unset",
    "&:focus": {
      boxShadow: "none",
      outline: "none"
    },
    "&:hover": {
      color: gA.colors.bodyText
    },
    "&:disabled, &:disabled:hover, &:disabled:active": {
      color: gA.colors.fadedText10,
      cursor: "not-allowed",
      // For image content
      img: {
        opacity: 0.4
      }
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledBorderlessIconButtonActive = /* @__PURE__ */ createStyled(StyledBorderlessIconButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc7"
} : {
  target: "ef3psqc7",
  label: "StyledBorderlessIconButtonActive"
})(({
  theme: CA
}) => ({
  color: CA.colors.bodyText,
  "&:disabled, &:disabled:hover, &:disabled:active": {
    color: CA.colors.fadedText40
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipNormal = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc6"
} : {
  target: "ef3psqc6",
  label: "StyledTooltipNormal"
})(({
  theme: CA
}) => ({
  display: "block",
  [`@media (max-width: ${CA.breakpoints.sm})`]: {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipMobile = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc5"
} : {
  target: "ef3psqc5",
  label: "StyledTooltipMobile"
})(({
  theme: CA
}) => ({
  display: "none",
  [`@media (max-width: ${CA.breakpoints.sm})`]: {
    display: "block"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElementToolbarButton = /* @__PURE__ */ createStyled(StyledBaseButton, process.env.NODE_ENV === "production" ? {
  target: "ef3psqc4"
} : {
  target: "ef3psqc4",
  label: "StyledElementToolbarButton"
})(({
  theme: CA
}) => ({
  backgroundColor: CA.colors.transparent,
  border: "none",
  padding: CA.spacing.twoXS,
  fontSize: CA.fontSizes.twoSm,
  marginLeft: CA.spacing.none,
  marginRight: CA.spacing.none,
  display: "flex",
  gap: CA.spacing.xs,
  alignItems: "center",
  minHeight: "unset",
  // line height should be the same as the icon size
  lineHeight: CA.iconSizes.md,
  width: "auto",
  "&:focus": {
    outline: "none",
    border: "none",
    boxShadow: "none"
  },
  "&:focus-visible": {
    outline: "none",
    border: "none",
    boxShadow: "none",
    backgroundColor: CA.colors.darkenedBgMix25
  },
  "&:hover": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: CA.colors.darkenedBgMix25
  },
  "&:disabled, &:disabled:hover, &:disabled:active": {
    backgroundColor: CA.colors.gray30,
    borderColor: CA.colors.transparent,
    color: CA.colors.gray60
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxZ0IwQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL0Jhc2VCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHsgTW91c2VFdmVudCwgUmVhY3ROb2RlIH0gZnJvbSBcInJlYWN0XCJcblxuaW1wb3J0IHN0eWxlZCwgeyBDU1NPYmplY3QgfSBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IGRhcmtlbiwgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB0eXBlIHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWUvdHlwZXNcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgb25DbGljaz86IChldmVudDogTW91c2VFdmVudDxIVE1MQnV0dG9uRWxlbWVudD4pID0+IHZvaWRcbiAgZGlzYWJsZWQ/OiBib29sZWFuXG4gIC8vIElmIHRydWUsIHRoZSBidXR0b24gc2hvdWxkIHRha2UgdXAgY29udGFpbmVyJ3MgZnVsbCB3aWR0aFxuICBjb250YWluZXJXaWR0aD86IGJvb2xlYW5cbiAgY2hpbGRyZW46IFJlYWN0Tm9kZVxuICBhdXRvRm9jdXM/OiBib29sZWFuXG4gIFwiZGF0YS10ZXN0aWRcIj86IHN0cmluZ1xuICBcImFyaWEtbGFiZWxcIj86IHN0cmluZ1xuICBcImFyaWEtaGFzcG9wdXBcIj86IFwibWVudVwiIHwgXCJ0cnVlXCIgfCBcImRpYWxvZ1wiIHwgXCJsaXN0Ym94XCIgfCBcInRyZWVcIiB8IFwiZ3JpZFwiXG4gIFwiYXJpYS1leHBhbmRlZFwiPzogYm9vbGVhblxufVxuXG4vLyBNb3N0IHByb3BzIGJlY29tZSByZXF1aXJlZCB2aWEgZGVmYXVsdHMgaW4gQmFzZUJ1dHRvbiwgYnV0IEFSSUEgcG9wdXBcbi8vIGF0dHJpYnV0ZXMgc3RheSBvcHRpb25hbCBzbyB0aGV5IG9ubHkgYXBwZWFyIGluIHRoZSBET00gd2hlbiBleHBsaWNpdGx5IHNldC5cbnR5cGUgUmVxdWlyZWRCYXNlQnV0dG9uUHJvcHMgPSBSZXF1aXJlZDxcbiAgT21pdDxCYXNlQnV0dG9uUHJvcHMsIFwiYXJpYS1oYXNwb3B1cFwiIHwgXCJhcmlhLWV4cGFuZGVkXCI+XG4+ICZcbiAgUGljazxCYXNlQnV0dG9uUHJvcHMsIFwiYXJpYS1oYXNwb3B1cFwiIHwgXCJhcmlhLWV4cGFuZGVkXCI+XG5cbmZ1bmN0aW9uIGdldFNpemVTdHlsZShzaXplOiBCYXNlQnV0dG9uU2l6ZSwgdGhlbWU6IEVtb3Rpb25UaGVtZSk6IENTU09iamVjdCB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgQmFzZUJ1dHRvblNpemUuWFNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5TTUFMTDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGNhc2UgQmFzZUJ1dHRvblNpemUuTEFSR0U6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLm1kfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy54c30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gIH1cbn1cblxuY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbi8vIFNlZ21lbnRlZCBjb250cm9sIGJvcmRlciBtb2RlbDpcbi8vIG5laWdoYm9yaW5nIGJ1dHRvbnMgb3ZlcmxhcCBieSAxIGJvcmRlciB3aWR0aCwgc28gZWFjaCBzaGFyZWQgZWRnZSBuZWVkcyBhXG4vLyBzaW5nbGUgXCJvd25lclwiIHRvIGF2b2lkIGRvdWJsZS13aWR0aCBzZWFtcy4gV2UgdHJlYXQgYWN0aXZlL2ludGVyYWN0aXZlXG4vLyAoaG92ZXIvZm9jdXMtdmlzaWJsZSkgYnV0dG9ucyBhcyByYWlzZWQgYW5kIGxldCB0aGVtIG93biBzaGFyZWQgYm9yZGVycy5cbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0FDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2xBY3RpdmUnXTpub3QoOmRpc2FibGVkKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9JTkFDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9JTlRFUkFDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9ORVVUUkFMX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOm5vdCg6aG92ZXIpOm5vdCg6Zm9jdXMtdmlzaWJsZSlcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VnbWVudGVkQ29udHJvbEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICAgIGJvcmRlclJhZGl1czogXCIwXCIsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgIG1hcmdpblJpZ2h0OiBgLSR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9YCwgLy8gQWRkIG5lZ2F0aXZlIG1hcmdpbiB0byBvdmVybGFwIGJvcmRlcnNcblxuICAgIFwiJjpmaXJzdC1jaGlsZFwiOiB7XG4gICAgICBib3JkZXJUb3BMZWZ0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21MZWZ0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgfSxcbiAgICBcIiY6bGFzdC1jaGlsZFwiOiB7XG4gICAgICBib3JkZXJUb3BSaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgYm9yZGVyQm90dG9tUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsIC8vIFJlc2V0IG1hcmdpbiBmb3IgdGhlIGxhc3QgY2hpbGRcbiAgICB9LFxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpLCAmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aXMoOmhvdmVyLCA6Zm9jdXMtdmlzaWJsZSlgXTpcbiAgICAgIHtcbiAgICAgICAgLy8gUmFpc2VkIHNlZ21lbnRzIHNob3VsZCByZW5kZXIgYWJvdmUgbmV1dHJhbCBuZWlnaGJvcnMuXG4gICAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgICB9LFxuICAgIC8vIEFjdGl2ZSBoYXMgc3Ryb25nZXN0IHByZWNlZGVuY2U6IGtlZXAgaXRzIGJvcmRlciB2aXNpYmxlIGFnYWluc3QgYm90aFxuICAgIC8vIG5ldXRyYWwgYW5kIGludGVyYWN0aXZlIG5laWdoYm9ycy5cbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2xBY3RpdmUnXTpub3QoOmRpc2FibGVkKSArICR7U0VHTUVOVEVEX0NPTlRST0xfSU5BQ1RJVkVfRU5BQkxFRH1gXTpcbiAgICAgIHtcbiAgICAgICAgYm9yZGVyTGVmdENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmhhcygrICR7U0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFX0VOQUJMRUR9KWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJSaWdodENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIC8vIEhvdmVyL2ZvY3VzIG93bmVyc2hpcCBpcyBvbmx5IGFwcGxpZWQgYmV0d2VlbiBuZXV0cmFsIG5laWdoYm9ycyBzbyB3ZVxuICAgIC8vIG5ldmVyIGhpZGUgdGhlIGFjdGl2ZSBib3JkZXIgaW4gYWN0aXZlK2hvdmVyIGFkamFjZW5jeS5cbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKSArICR7U0VHTUVOVEVEX0NPTlRST0xfTkVVVFJBTF9FTkFCTEVEfWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJMZWZ0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6bm90KDpob3Zlcik6bm90KDpmb2N1cy12aXNpYmxlKTpoYXMoKyAke1NFR01FTlRFRF9DT05UUk9MX0lOVEVSQUNUSVZFX0VOQUJMRUR9KWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJSaWdodENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIC8vIE1ha2Ugc3VyZSB0aGUgZm9jdXMgcmluZyBpc24ndCBiZWxvdyB0aGUgcHJldmlvdXMvbmV4dCBidXR0b24uXG4gICAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLnByaW9yaXR5LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC45KSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG5cbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuXG4gICAgbWluV2lkdGg6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJJdGVtSGVpZ2h0LFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gVGFrZSBvdXQgcGFkZGluZyBmb3IgdGhpcyBzcGVjaWZpYyBidXR0b24sIHNvIHdlIGNhbiBlbnN1cmUgaXQncyAzMngzMnB4IGxpa2Ugb3RoZXIgYnV0dG9ucyBpbiBDb21tdW5pdHkgQ2xvdWRcbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJOb1BhZGRpbmdCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEhlYWRlckJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IDAsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBpY29uUGFkZGluZzogUmVjb3JkPEJhc2VCdXR0b25TaXplLCBzdHJpbmc+ID0ge1xuICAgIFtCYXNlQnV0dG9uU2l6ZS5YU01BTExdOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgW0Jhc2VCdXR0b25TaXplLlNNQUxMXTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuTUVESVVNXTogdGhlbWUuc3BhY2luZy5tZCxcbiAgICBbQmFzZUJ1dHRvblNpemUuTEFSR0VdOiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgIHBhZGRpbmc6IGljb25QYWRkaW5nW3NpemVdLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuXG4gICAgLy8gS2VlcHMgdGhlIGJ1dHRvbnMgZnJvbSBzdGFja2luZyB3aGVuIGluIGNvbnRhaW5lcldpZHRoIG1vZGUuXG4gICAgLy8gVGhlc2UgYnV0dG9ucyBzaG91bGQgc3RheSB0b2dldGhlciBhbmQgbm90IHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IFwiMCAwIGZpdC1jb250ZW50XCIsXG5cbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDEwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG5cbiAgICAgIC8vIEZvciBpbWFnZSBjb250ZW50XG4gICAgICBpbWc6IHtcbiAgICAgICAgb3BhY2l0eTogMC40LFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvb2x0aXBOb3JtYWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE1vYmlsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJub25lXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgZGlzcGxheTogXCJibG9ja1wiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFbGVtZW50VG9vbGJhckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy54cyxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuICAgIC8vIGxpbmUgaGVpZ2h0IHNob3VsZCBiZSB0aGUgc2FtZSBhcyB0aGUgaWNvbiBzaXplXG4gICAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxuICAgIHdpZHRoOiBcImF1dG9cIixcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Hcm91cCA9IHN0eWxlZC5kaXY8eyBjb250YWluZXJXaWR0aDogYm9vbGVhbiB9PihcbiAgKHsgY29udGFpbmVyV2lkdGggfSkgPT4gKHtcbiAgICB3aWR0aDogY29udGFpbmVyV2lkdGggPyBcIjEwMCVcIiA6IFwiYXV0b1wiLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uTGFiZWwgPSBzdHlsZWQuZGl2KCgpID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25NYWluTGFiZWwgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1pbldpZHRoOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25TaG9ydGN1dCA9IHN0eWxlZC5rYmQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgb3BhY2l0eTogMC42LFxuICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMudGlnaHQsXG4gIGxldHRlclNwYWNpbmc6IFwiMC4wMWVtXCIsXG59KSlcbiJdfQ== */"), StyledButtonGroup = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc3"
} : {
  target: "ef3psqc3",
  label: "StyledButtonGroup"
})(({
  containerWidth: CA
}) => ({
  width: CA ? "100%" : "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc2"
} : {
  target: "ef3psqc2",
  label: "StyledButtonLabel"
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledButtonMainLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc1"
} : {
  target: "ef3psqc1",
  label: "StyledButtonMainLabel"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: CA.spacing.sm,
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvQmFzZUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE2akJxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL0Jhc2VCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHsgTW91c2VFdmVudCwgUmVhY3ROb2RlIH0gZnJvbSBcInJlYWN0XCJcblxuaW1wb3J0IHN0eWxlZCwgeyBDU1NPYmplY3QgfSBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IGRhcmtlbiwgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiXG5cbmltcG9ydCB0eXBlIHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIn5saWIvdGhlbWUvdHlwZXNcIlxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uS2luZCB7XG4gIFBSSU1BUlkgPSBcInByaW1hcnlcIixcbiAgU0VDT05EQVJZID0gXCJzZWNvbmRhcnlcIixcbiAgVEVSVElBUlkgPSBcInRlcnRpYXJ5XCIsXG4gIEdIT1NUID0gXCJnaG9zdFwiLFxuICBCT1JERVJMRVNTX0lDT04gPSBcImJvcmRlcmxlc3NJY29uXCIsXG4gIEJPUkRFUkxFU1NfSUNPTl9BQ1RJVkUgPSBcImJvcmRlcmxlc3NJY29uQWN0aXZlXCIsXG4gIE1JTklNQUwgPSBcIm1pbmltYWxcIixcbiAgUFJJTUFSWV9GT1JNX1NVQk1JVCA9IFwicHJpbWFyeUZvcm1TdWJtaXRcIixcbiAgU0VDT05EQVJZX0ZPUk1fU1VCTUlUID0gXCJzZWNvbmRhcnlGb3JtU3VibWl0XCIsXG4gIFRFUlRJQVJZX0ZPUk1fU1VCTUlUID0gXCJ0ZXJ0aWFyeUZvcm1TdWJtaXRcIixcbiAgSEVBREVSX0JVVFRPTiA9IFwiaGVhZGVyXCIsXG4gIEhFQURFUl9OT19QQURESU5HID0gXCJoZWFkZXJOb1BhZGRpbmdcIixcbiAgRUxFTUVOVF9UT09MQkFSID0gXCJlbGVtZW50VG9vbGJhclwiLFxuICBQSUxMUyA9IFwicGlsbHNcIixcbiAgUElMTFNfQUNUSVZFID0gXCJwaWxsc0FjdGl2ZVwiLFxuICBTRUdNRU5URURfQ09OVFJPTCA9IFwic2VnbWVudGVkX2NvbnRyb2xcIixcbiAgU0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFID0gXCJzZWdtZW50ZWRfY29udHJvbEFjdGl2ZVwiLFxufVxuXG5leHBvcnQgZW51bSBCYXNlQnV0dG9uU2l6ZSB7XG4gIFhTTUFMTCA9IFwieHNtYWxsXCIsXG4gIFNNQUxMID0gXCJzbWFsbFwiLFxuICBNRURJVU0gPSBcIm1lZGl1bVwiLFxuICBMQVJHRSA9IFwibGFyZ2VcIixcbn1cblxuZXhwb3J0IGludGVyZmFjZSBCYXNlQnV0dG9uUHJvcHMge1xuICBraW5kOiBCYXNlQnV0dG9uS2luZFxuICBzaXplPzogQmFzZUJ1dHRvblNpemVcbiAgb25DbGljaz86IChldmVudDogTW91c2VFdmVudDxIVE1MQnV0dG9uRWxlbWVudD4pID0+IHZvaWRcbiAgZGlzYWJsZWQ/OiBib29sZWFuXG4gIC8vIElmIHRydWUsIHRoZSBidXR0b24gc2hvdWxkIHRha2UgdXAgY29udGFpbmVyJ3MgZnVsbCB3aWR0aFxuICBjb250YWluZXJXaWR0aD86IGJvb2xlYW5cbiAgY2hpbGRyZW46IFJlYWN0Tm9kZVxuICBhdXRvRm9jdXM/OiBib29sZWFuXG4gIFwiZGF0YS10ZXN0aWRcIj86IHN0cmluZ1xuICBcImFyaWEtbGFiZWxcIj86IHN0cmluZ1xuICBcImFyaWEtaGFzcG9wdXBcIj86IFwibWVudVwiIHwgXCJ0cnVlXCIgfCBcImRpYWxvZ1wiIHwgXCJsaXN0Ym94XCIgfCBcInRyZWVcIiB8IFwiZ3JpZFwiXG4gIFwiYXJpYS1leHBhbmRlZFwiPzogYm9vbGVhblxufVxuXG4vLyBNb3N0IHByb3BzIGJlY29tZSByZXF1aXJlZCB2aWEgZGVmYXVsdHMgaW4gQmFzZUJ1dHRvbiwgYnV0IEFSSUEgcG9wdXBcbi8vIGF0dHJpYnV0ZXMgc3RheSBvcHRpb25hbCBzbyB0aGV5IG9ubHkgYXBwZWFyIGluIHRoZSBET00gd2hlbiBleHBsaWNpdGx5IHNldC5cbnR5cGUgUmVxdWlyZWRCYXNlQnV0dG9uUHJvcHMgPSBSZXF1aXJlZDxcbiAgT21pdDxCYXNlQnV0dG9uUHJvcHMsIFwiYXJpYS1oYXNwb3B1cFwiIHwgXCJhcmlhLWV4cGFuZGVkXCI+XG4+ICZcbiAgUGljazxCYXNlQnV0dG9uUHJvcHMsIFwiYXJpYS1oYXNwb3B1cFwiIHwgXCJhcmlhLWV4cGFuZGVkXCI+XG5cbmZ1bmN0aW9uIGdldFNpemVTdHlsZShzaXplOiBCYXNlQnV0dG9uU2l6ZSwgdGhlbWU6IEVtb3Rpb25UaGVtZSk6IENTU09iamVjdCB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgQmFzZUJ1dHRvblNpemUuWFNNQUxMOlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLnNtfWAsXG4gICAgICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgICB9XG4gICAgY2FzZSBCYXNlQnV0dG9uU2l6ZS5TTUFMTDpcbiAgICAgIHJldHVybiB7XG4gICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgfVxuICAgIGNhc2UgQmFzZUJ1dHRvblNpemUuTEFSR0U6XG4gICAgICByZXR1cm4ge1xuICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLm1kfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIH1cbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy54c30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgICB9XG4gIH1cbn1cblxuY29uc3QgU3R5bGVkQmFzZUJ1dHRvbiA9IHN0eWxlZC5idXR0b248UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KFxuICAoeyBjb250YWluZXJXaWR0aCwgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICAgIHJldHVybiB7XG4gICAgICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWwsXG4gICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcubWR9YCxcbiAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5taW5FbGVtZW50SGVpZ2h0LFxuICAgICAgbWFyZ2luOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgICAgdGV4dFRyYW5zZm9ybTogXCJub25lXCIsXG4gICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgICAgIGNvbG9yOiBcImluaGVyaXRcIixcbiAgICAgIHdpZHRoOiBjb250YWluZXJXaWR0aCA/IFwiMTAwJVwiIDogXCJhdXRvXCIsXG4gICAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgICAgdXNlclNlbGVjdDogXCJub25lXCIsXG4gICAgICBcIiY6Zm9jdXNcIjoge1xuICAgICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIH0sXG4gICAgICBcIiY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICAgIC8vIFdoZW4gZm9jdXMtdmlzaWJsZSAoZS5nLiBpZiB0aGUgYnV0dG9uIHdhcyBmb2N1c2VkIHZpYSBrZXlib2FyZCBuYXZpZ2F0aW9uKVxuICAgICAgICAvLyB3ZSB1c2UgdGhlIGhvdmVyIHN0eWxlIG9mIHRoZSByZXNwZWN0aXZlIGJ1dHRvbiB0eXBlIChzZWUgYmVsb3cpIGFuZFxuICAgICAgICAvLyBhZGRpdGlvbmFsbHkgc2hvdyBhIGNvbG9yZWQgZm9jdXMgcmluZ1xuICAgICAgICBib3hTaGFkb3c6IHRoZW1lLnNoYWRvd3MuZm9jdXNSaW5nLFxuICAgICAgfSxcbiAgICAgIC4uLmdldFNpemVTdHlsZShzaXplLCB0aGVtZSksXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICBjb2xvcjogdGhlbWUuY29sb3JzLndoaXRlLFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5wcmltYXJ5fWAsXG4gIFwiJjpob3ZlciwgJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjphY3RpdmVcIjoge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgLy8gS2VlcCB0aGUgYm9yZGVyIGRhcmtlciB3aGVuIGNsaWNrZWQgc28gdGhhdCB0aGUgYnV0dG9uIGxvb2tzIFwicHJlc3NlZFwiXG4gICAgYm9yZGVyQ29sb3I6IGRhcmtlbih0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC4xNSksXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5saWdodGVuZWRCZzA1LFxuICBib3JkZXI6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUsXG4gIH0sXG4gIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVGVydGlhcnlCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgfSxcbiAgICBcIiY6aG92ZXI6bm90KDpkaXNhYmxlZCksICY6Zm9jdXMtdmlzaWJsZTpub3QoOmRpc2FibGVkKVwiOiB7XG4gICAgICAvLyBBbHNvIG1ha2UgY29sb3JlZCB0ZXh0IGhhdmUgdGhlIHByaW1hcnkgY29sb3Igb24gaG92ZXIuIFNpbmNlIHRleHQgY29sb3IgaXNcbiAgICAgIC8vIGFwcGxpZWQgYXMgYW4gaW5saW5lIHN0eWxlIHdlIG5lZWQgdG8gdXNlICFpbXBvcnRhbnQgdG8gb3ZlcnJpZGUgaXQuXG4gICAgICAvLyBOb3RlIHRoYXQgd2UncmUgbm90IGRvaW5nIHRoaXMgd2hlbiBkaXNhYmxlZC4gV2Ugc2hvdWxkIHByb2JhYmx5IGRvIHRoYXQgYXNcbiAgICAgIC8vIHdlbGwgYnV0IHdlIGRvbid0IGRvIGl0IGFueXdoZXJlIGVsc2UuXG4gICAgICBcInNwYW4uc3RNYXJrZG93bkNvbG9yZWRUZXh0XCI6IHtcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdCAhaW1wb3J0YW50XCIsXG4gICAgICB9LFxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogZGFya2VuKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjI1KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEdob3N0QnV0dG9uID0gc3R5bGVkKFxuICBTdHlsZWRCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiAoe1xuICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgYm9yZGVyOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnR9YCxcbiAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgfSxcbiAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1pbmltYWxCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+ICh7XG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICBib3JkZXI6IFwibm9uZVwiLFxuICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICBwYWRkaW5nOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIFwiJjpob3ZlciwgJjphY3RpdmUsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICB9LFxuICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwLFxuICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQcmltYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9XG4gIHN0eWxlZChTdHlsZWRQcmltYXJ5QnV0dG9uKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2Vjb25kYXJ5Rm9ybVN1Ym1pdEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkU2Vjb25kYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUZXJ0aWFyeUZvcm1TdWJtaXRCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZFRlcnRpYXJ5QnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigpXG5cbmNvbnN0IFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5iZ0NvbG9yLFxuICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5iYXNlLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICBoZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtaW5IZWlnaHQ6IHRoZW1lLnNpemVzLmxhcmdlTG9nb0hlaWdodCxcbiAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuXG4gICAgLy8gc2hvdyBwaWxscyB3aXRoIGxvbmcgdGV4dCBpbiBzaW5nbGUgbGluZSBhbmQgdXNlIGVsbGlwc2lzIGZvciBvdmVyZmxvd1xuICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3IsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgXCImIGRpdlwiOiB7XG4gICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgIH0sXG4gICAgXCImIHBcIjoge1xuICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGlsbHNCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJ1dHRvbkdyb3VwQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUsIGNvbnRhaW5lcldpZHRoIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5zcGFjaW5nLm1kfWAsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRQaWxsc0J1dHRvbkFjdGl2ZSA9IHN0eWxlZChcbiAgU3R5bGVkUGlsbHNCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRyYW5zcGFyZW50aXplKHRoZW1lLmNvbG9ycy5wcmltYXJ5LCAwLjkpLFxuICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICAgIGJvcmRlckNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbi8vIFNlZ21lbnRlZCBjb250cm9sIGJvcmRlciBtb2RlbDpcbi8vIG5laWdoYm9yaW5nIGJ1dHRvbnMgb3ZlcmxhcCBieSAxIGJvcmRlciB3aWR0aCwgc28gZWFjaCBzaGFyZWQgZWRnZSBuZWVkcyBhXG4vLyBzaW5nbGUgXCJvd25lclwiIHRvIGF2b2lkIGRvdWJsZS13aWR0aCBzZWFtcy4gV2UgdHJlYXQgYWN0aXZlL2ludGVyYWN0aXZlXG4vLyAoaG92ZXIvZm9jdXMtdmlzaWJsZSkgYnV0dG9ucyBhcyByYWlzZWQgYW5kIGxldCB0aGVtIG93biBzaGFyZWQgYm9yZGVycy5cbmNvbnN0IFNFR01FTlRFRF9DT05UUk9MX0FDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2xBY3RpdmUnXTpub3QoOmRpc2FibGVkKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9JTkFDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9JTlRFUkFDVElWRV9FTkFCTEVEID1cbiAgXCJidXR0b25ba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKVwiXG5jb25zdCBTRUdNRU5URURfQ09OVFJPTF9ORVVUUkFMX0VOQUJMRUQgPVxuICBcImJ1dHRvbltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOm5vdCg6aG92ZXIpOm5vdCg6Zm9jdXMtdmlzaWJsZSlcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VnbWVudGVkQ29udHJvbEJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQnV0dG9uR3JvdXBCYXNlQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSwgY29udGFpbmVyV2lkdGggfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICAgIGJvcmRlclJhZGl1czogXCIwXCIsXG4gICAgLy8gV2hlbiBjb250YWluZXJXaWR0aCBpcyB0cnVlLCB0aGUgYnV0dG9ucyB3aWxsIHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IGNvbnRhaW5lcldpZHRoID8gXCIxIDEgZml0LWNvbnRlbnRcIiA6IFwiXCIsXG4gICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgIG1hcmdpblJpZ2h0OiBgLSR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9YCwgLy8gQWRkIG5lZ2F0aXZlIG1hcmdpbiB0byBvdmVybGFwIGJvcmRlcnNcblxuICAgIFwiJjpmaXJzdC1jaGlsZFwiOiB7XG4gICAgICBib3JkZXJUb3BMZWZ0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgICBib3JkZXJCb3R0b21MZWZ0UmFkaXVzOiB0aGVtZS5yYWRpaS5idXR0b24sXG4gICAgfSxcbiAgICBcIiY6bGFzdC1jaGlsZFwiOiB7XG4gICAgICBib3JkZXJUb3BSaWdodFJhZGl1czogdGhlbWUucmFkaWkuYnV0dG9uLFxuICAgICAgYm9yZGVyQm90dG9tUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmJ1dHRvbixcbiAgICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsIC8vIFJlc2V0IG1hcmdpbiBmb3IgdGhlIGxhc3QgY2hpbGRcbiAgICB9LFxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbEFjdGl2ZSddOm5vdCg6ZGlzYWJsZWQpLCAmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6aXMoOmhvdmVyLCA6Zm9jdXMtdmlzaWJsZSlgXTpcbiAgICAgIHtcbiAgICAgICAgLy8gUmFpc2VkIHNlZ21lbnRzIHNob3VsZCByZW5kZXIgYWJvdmUgbmV1dHJhbCBuZWlnaGJvcnMuXG4gICAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgICB9LFxuICAgIC8vIEFjdGl2ZSBoYXMgc3Ryb25nZXN0IHByZWNlZGVuY2U6IGtlZXAgaXRzIGJvcmRlciB2aXNpYmxlIGFnYWluc3QgYm90aFxuICAgIC8vIG5ldXRyYWwgYW5kIGludGVyYWN0aXZlIG5laWdoYm9ycy5cbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2xBY3RpdmUnXTpub3QoOmRpc2FibGVkKSArICR7U0VHTUVOVEVEX0NPTlRST0xfSU5BQ1RJVkVfRU5BQkxFRH1gXTpcbiAgICAgIHtcbiAgICAgICAgYm9yZGVyTGVmdENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIFtgJltraW5kPSdzZWdtZW50ZWRfY29udHJvbCddOm5vdCg6ZGlzYWJsZWQpOmhhcygrICR7U0VHTUVOVEVEX0NPTlRST0xfQUNUSVZFX0VOQUJMRUR9KWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJSaWdodENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIC8vIEhvdmVyL2ZvY3VzIG93bmVyc2hpcCBpcyBvbmx5IGFwcGxpZWQgYmV0d2VlbiBuZXV0cmFsIG5laWdoYm9ycyBzbyB3ZVxuICAgIC8vIG5ldmVyIGhpZGUgdGhlIGFjdGl2ZSBib3JkZXIgaW4gYWN0aXZlK2hvdmVyIGFkamFjZW5jeS5cbiAgICBbYCZba2luZD0nc2VnbWVudGVkX2NvbnRyb2wnXTpub3QoOmRpc2FibGVkKTppcyg6aG92ZXIsIDpmb2N1cy12aXNpYmxlKSArICR7U0VHTUVOVEVEX0NPTlRST0xfTkVVVFJBTF9FTkFCTEVEfWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJMZWZ0Q29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIH0sXG4gICAgW2AmW2tpbmQ9J3NlZ21lbnRlZF9jb250cm9sJ106bm90KDpkaXNhYmxlZCk6bm90KDpob3Zlcik6bm90KDpmb2N1cy12aXNpYmxlKTpoYXMoKyAke1NFR01FTlRFRF9DT05UUk9MX0lOVEVSQUNUSVZFX0VOQUJMRUR9KWBdOlxuICAgICAge1xuICAgICAgICBib3JkZXJSaWdodENvbG9yOiB0aGVtZS5jb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgICB9LFxuICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgIC8vIE1ha2Ugc3VyZSB0aGUgZm9jdXMgcmluZyBpc24ndCBiZWxvdyB0aGUgcHJldmlvdXMvbmV4dCBidXR0b24uXG4gICAgICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLnByaW9yaXR5LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uQWN0aXZlID0gc3R5bGVkKFxuICBTdHlsZWRTZWdtZW50ZWRDb250cm9sQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC45KSxcbiAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnByaW1hcnksXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5wcmltYXJ5LFxuICAgIHpJbmRleDogdGhlbWUuekluZGljZXMucHJpb3JpdHksXG4gICAgXCImOmhvdmVyLCAmOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMucHJpbWFyeSwgMC44KSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDA1LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ0MCxcbiAgICAgIGN1cnNvcjogXCJub3QtYWxsb3dlZFwiLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEJhc2VCdXR0b25cbik8UmVxdWlyZWRCYXNlQnV0dG9uUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG5cbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuXG4gICAgbWluV2lkdGg6IHRoZW1lLnNpemVzLmhlYWRlckl0ZW1IZWlnaHQsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5oZWFkZXJJdGVtSGVpZ2h0LFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5MzAsXG4gICAgICBib3JkZXJDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ncmF5NjAsXG4gICAgfSxcbiAgfVxufSlcblxuLy8gVGFrZSBvdXQgcGFkZGluZyBmb3IgdGhpcyBzcGVjaWZpYyBidXR0b24sIHNvIHdlIGNhbiBlbnN1cmUgaXQncyAzMngzMnB4IGxpa2Ugb3RoZXIgYnV0dG9ucyBpbiBDb21tdW5pdHkgQ2xvdWRcbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkZXJOb1BhZGRpbmdCdXR0b24gPSBzdHlsZWQoXG4gIFN0eWxlZEhlYWRlckJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKCkgPT4ge1xuICByZXR1cm4ge1xuICAgIHBhZGRpbmc6IDAsXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCb3JkZXJsZXNzSWNvbkJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBpY29uUGFkZGluZzogUmVjb3JkPEJhc2VCdXR0b25TaXplLCBzdHJpbmc+ID0ge1xuICAgIFtCYXNlQnV0dG9uU2l6ZS5YU01BTExdOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgW0Jhc2VCdXR0b25TaXplLlNNQUxMXTogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBbQmFzZUJ1dHRvblNpemUuTUVESVVNXTogdGhlbWUuc3BhY2luZy5tZCxcbiAgICBbQmFzZUJ1dHRvblNpemUuTEFSR0VdOiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgIHBhZGRpbmc6IGljb25QYWRkaW5nW3NpemVdLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuXG4gICAgLy8gS2VlcHMgdGhlIGJ1dHRvbnMgZnJvbSBzdGFja2luZyB3aGVuIGluIGNvbnRhaW5lcldpZHRoIG1vZGUuXG4gICAgLy8gVGhlc2UgYnV0dG9ucyBzaG91bGQgc3RheSB0b2dldGhlciBhbmQgbm90IHN0cmV0Y2ggdG8gZmlsbCB0aGUgY29udGFpbmVyLlxuICAgIGZsZXg6IFwiMCAwIGZpdC1jb250ZW50XCIsXG5cbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIH0sXG4gICAgXCImOmRpc2FibGVkLCAmOmRpc2FibGVkOmhvdmVyLCAmOmRpc2FibGVkOmFjdGl2ZVwiOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDEwLFxuICAgICAgY3Vyc29yOiBcIm5vdC1hbGxvd2VkXCIsXG5cbiAgICAgIC8vIEZvciBpbWFnZSBjb250ZW50XG4gICAgICBpbWc6IHtcbiAgICAgICAgb3BhY2l0eTogMC40LFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm9yZGVybGVzc0ljb25CdXR0b25BY3RpdmUgPSBzdHlsZWQoXG4gIFN0eWxlZEJvcmRlcmxlc3NJY29uQnV0dG9uXG4pPFJlcXVpcmVkQmFzZUJ1dHRvblByb3BzPigoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICBcIiY6ZGlzYWJsZWQsICY6ZGlzYWJsZWQ6aG92ZXIsICY6ZGlzYWJsZWQ6YWN0aXZlXCI6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDAsXG4gICAgfSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFRvb2x0aXBOb3JtYWwgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiYmxvY2tcIixcbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5zbX0pYF06IHtcbiAgICBkaXNwbGF5OiBcIm5vbmVcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcE1vYmlsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJub25lXCIsXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMuc219KWBdOiB7XG4gICAgZGlzcGxheTogXCJibG9ja1wiLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRFbGVtZW50VG9vbGJhckJ1dHRvbiA9IHN0eWxlZChcbiAgU3R5bGVkQmFzZUJ1dHRvblxuKTxSZXF1aXJlZEJhc2VCdXR0b25Qcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgcGFkZGluZzogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy54cyxcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIG1pbkhlaWdodDogXCJ1bnNldFwiLFxuICAgIC8vIGxpbmUgaGVpZ2h0IHNob3VsZCBiZSB0aGUgc2FtZSBhcyB0aGUgaWNvbiBzaXplXG4gICAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxuICAgIHdpZHRoOiBcImF1dG9cIixcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3hTaGFkb3c6IFwibm9uZVwiLFxuICAgIH0sXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgb3V0bGluZTogXCJub25lXCIsXG4gICAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgICAgYm94U2hhZG93OiBcIm5vbmVcIixcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpob3ZlclwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcbiAgICBcIiY6YWN0aXZlXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSxcbiAgICB9LFxuICAgIFwiJjpkaXNhYmxlZCwgJjpkaXNhYmxlZDpob3ZlciwgJjpkaXNhYmxlZDphY3RpdmVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTMwLFxuICAgICAgYm9yZGVyQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZ3JheTYwLFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25Hcm91cCA9IHN0eWxlZC5kaXY8eyBjb250YWluZXJXaWR0aDogYm9vbGVhbiB9PihcbiAgKHsgY29udGFpbmVyV2lkdGggfSkgPT4gKHtcbiAgICB3aWR0aDogY29udGFpbmVyV2lkdGggPyBcIjEwMCVcIiA6IFwiYXV0b1wiLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uTGFiZWwgPSBzdHlsZWQuZGl2KCgpID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25NYWluTGFiZWwgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1pbldpZHRoOiAwLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRCdXR0b25TaG9ydGN1dCA9IHN0eWxlZC5rYmQoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgb3BhY2l0eTogMC42LFxuICBmb250RmFtaWx5OiBcImluaGVyaXRcIixcbiAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMudGlnaHQsXG4gIGxldHRlclNwYWNpbmc6IFwiMC4wMWVtXCIsXG59KSlcbiJdfQ== */"), StyledButtonShortcut = /* @__PURE__ */ createStyled("kbd", process.env.NODE_ENV === "production" ? {
  target: "ef3psqc0"
} : {
  target: "ef3psqc0",
  label: "StyledButtonShortcut"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  fontSize: CA.fontSizes.sm,
  opacity: 0.6,
  fontFamily: "inherit",
  lineHeight: CA.lineHeights.tight,
  letterSpacing: "0.01em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), BaseButton = forwardRef(function CA(gA, AA) {
  const {
    kind: IA,
    size: BA,
    disabled: QA,
    onClick: EA,
    containerWidth: iA,
    children: oA,
    autoFocus: cA
  } = gA;
  let tA = StyledPrimaryButton;
  return IA === BaseButtonKind.SECONDARY ? tA = StyledSecondaryButton : IA === BaseButtonKind.TERTIARY ? tA = StyledTertiaryButton : IA === BaseButtonKind.GHOST ? tA = StyledGhostButton : IA === BaseButtonKind.PILLS ? tA = StyledPillsButton : IA === BaseButtonKind.PILLS_ACTIVE ? tA = StyledPillsButtonActive : IA === BaseButtonKind.SEGMENTED_CONTROL ? tA = StyledSegmentedControlButton : IA === BaseButtonKind.SEGMENTED_CONTROL_ACTIVE ? tA = StyledSegmentedControlButtonActive : IA === BaseButtonKind.BORDERLESS_ICON ? tA = StyledBorderlessIconButton : IA === BaseButtonKind.BORDERLESS_ICON_ACTIVE ? tA = StyledBorderlessIconButtonActive : IA === BaseButtonKind.MINIMAL ? tA = StyledMinimalButton : IA === BaseButtonKind.PRIMARY_FORM_SUBMIT ? tA = StyledPrimaryFormSubmitButton : IA === BaseButtonKind.SECONDARY_FORM_SUBMIT ? tA = StyledSecondaryFormSubmitButton : IA === BaseButtonKind.TERTIARY_FORM_SUBMIT ? tA = StyledTertiaryFormSubmitButton : IA === BaseButtonKind.HEADER_BUTTON ? tA = StyledHeaderButton : IA === BaseButtonKind.HEADER_NO_PADDING ? tA = StyledHeaderNoPaddingButton : IA === BaseButtonKind.ELEMENT_TOOLBAR && (tA = StyledElementToolbarButton), /* @__PURE__ */ jsxRuntimeExports.jsx(tA, { ref: AA, kind: IA, size: BA ?? BaseButtonSize.MEDIUM, containerWidth: iA || !1, disabled: QA || !1, onClick: EA || (() => {
  }), autoFocus: cA || !1, "data-testid": gA["data-testid"] ?? `stBaseButton-${IA}`, "aria-label": gA["aria-label"] ?? "", "aria-haspopup": gA["aria-haspopup"], "aria-expanded": gA["aria-expanded"], children: oA });
}), StyledModalButton = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e18cebhv0"
} : {
  target: "e18cebhv0",
  label: "StyledModalButton"
})(({
  theme: CA
}) => ({
  marginRight: CA.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTW9kYWwvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL01vZGFsL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNb2RhbEJ1dHRvbiA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxufSkpXG4iXX0= */");
function ModalHeader({
  children: CA,
  overrides: gA
}) {
  const {
    genericFonts: AA,
    fontSizes: IA,
    spacing: BA,
    fontWeights: QA,
    lineHeights: EA
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader$1, { style: {
    marginTop: BA.none,
    marginLeft: BA.none,
    marginRight: BA.none,
    marginBottom: BA.none,
    paddingTop: BA.twoXL,
    paddingRight: BA.twoXL,
    paddingBottom: BA.md,
    paddingLeft: BA.twoXL,
    fontFamily: AA.bodyFont,
    fontSize: IA.xl,
    fontWeight: QA.bold,
    margin: BA.none,
    lineHeight: EA.small,
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    maxHeight: "80vh",
    flexDirection: "row",
    ...gA
  }, children: CA });
}
function ModalBody$1({
  children: CA
}) {
  const {
    colors: gA,
    fontSizes: AA,
    spacing: IA
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: IA.none,
    marginLeft: IA.none,
    marginRight: IA.none,
    marginBottom: IA.none,
    paddingTop: IA.md,
    paddingRight: IA.twoXL,
    paddingBottom: IA.twoXL,
    paddingLeft: IA.twoXL,
    color: gA.bodyText,
    fontSize: AA.md
  }, children: CA });
}
function ModalFooter({
  children: CA
}) {
  const {
    spacing: gA
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter$1, { style: {
    marginTop: gA.none,
    marginLeft: gA.none,
    marginRight: gA.none,
    marginBottom: gA.none,
    paddingTop: gA.md,
    paddingRight: gA.md,
    paddingBottom: gA.md,
    paddingLeft: gA.md
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: CA }) });
}
const ModalButton = (CA) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledModalButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...CA }) });
function calculateModalSize(CA, gA, AA, IA) {
  return CA === "large" && IA ? IA : CA === "medium" && gA && AA ? `calc(${gA} + ${AA})` : CA === "auto" ? SIZE.auto : SIZE.default;
}
function Modal(CA) {
  const {
    spacing: gA,
    radii: AA,
    colors: IA,
    sizes: BA
  } = useEmotionTheme(), QA = {
    Root: {
      style: {
        background: IA.darkenedBgMix25
      },
      props: {
        className: "stDialog",
        "data-testid": "stDialog"
      }
    },
    DialogContainer: {
      style: {
        alignItems: "start",
        paddingTop: gA.threeXL
      }
    },
    Dialog: {
      style: {
        borderBottomRightRadius: AA.xxl,
        borderBottomLeftRadius: AA.xxl,
        borderTopRightRadius: AA.xxl,
        borderTopLeftRadius: AA.xxl,
        // make sure the modal is not too small on mobile
        minWidth: BA.minPopupWidth
      }
    },
    Close: {
      style: {
        top: `calc(${gA.twoXL} + ${gA.xs})`,
        // Trying to center the button on the available space.
        right: gA.twoXL
      }
    }
  }, EA = calculateModalSize(CA.size, BA.contentMaxWidth, gA.lg, BA.dialogLargeWidth), iA = merge$1(QA, CA.overrides), oA = {
    ...CA,
    size: EA
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { ...oA, overrides: iA });
}
function escapeStringRegexp$1(CA) {
  if (typeof CA != "string")
    throw new TypeError("Expected a string");
  return CA.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const replacements = [
  // German umlauts
  ["ß", "ss"],
  ["ẞ", "Ss"],
  ["ä", "ae"],
  ["Ä", "Ae"],
  ["ö", "oe"],
  ["Ö", "Oe"],
  ["ü", "ue"],
  ["Ü", "Ue"],
  // Latin
  ["À", "A"],
  ["Á", "A"],
  ["Â", "A"],
  ["Ã", "A"],
  ["Ä", "Ae"],
  ["Å", "A"],
  ["Æ", "AE"],
  ["Ç", "C"],
  ["È", "E"],
  ["É", "E"],
  ["Ê", "E"],
  ["Ë", "E"],
  ["Ə", "A"],
  // Azerbaijani schwa
  ["Ì", "I"],
  ["Í", "I"],
  ["Î", "I"],
  ["Ï", "I"],
  ["Ð", "D"],
  ["Ñ", "N"],
  ["Ò", "O"],
  ["Ó", "O"],
  ["Ô", "O"],
  ["Õ", "O"],
  ["Ö", "Oe"],
  ["Ō", "O"],
  ["Ő", "O"],
  ["Ø", "O"],
  ["Œ", "OE"],
  // French ligature
  ["Ù", "U"],
  ["Ú", "U"],
  ["Û", "U"],
  ["Ü", "Ue"],
  ["Ű", "U"],
  ["Ý", "Y"],
  ["Þ", "TH"],
  ["ß", "ss"],
  ["à", "a"],
  ["á", "a"],
  ["â", "a"],
  ["ã", "a"],
  ["ä", "ae"],
  ["å", "a"],
  ["æ", "ae"],
  ["ç", "c"],
  ["è", "e"],
  ["é", "e"],
  ["ê", "e"],
  ["ë", "e"],
  ["ə", "a"],
  // Azerbaijani schwa
  ["ì", "i"],
  ["í", "i"],
  ["î", "i"],
  ["ï", "i"],
  ["ð", "d"],
  ["ñ", "n"],
  ["ò", "o"],
  ["ó", "o"],
  ["ô", "o"],
  ["õ", "o"],
  ["ö", "oe"],
  ["ō", "o"],
  ["ő", "o"],
  ["ø", "o"],
  ["œ", "oe"],
  // French ligature
  ["ù", "u"],
  ["ú", "u"],
  ["û", "u"],
  ["ü", "ue"],
  ["ű", "u"],
  ["ý", "y"],
  ["þ", "th"],
  ["ÿ", "y"],
  // Vietnamese
  ["à", "a"],
  ["À", "A"],
  ["á", "a"],
  ["Á", "A"],
  ["â", "a"],
  ["Â", "A"],
  ["ã", "a"],
  ["Ã", "A"],
  ["è", "e"],
  ["È", "E"],
  ["é", "e"],
  ["É", "E"],
  ["ê", "e"],
  ["Ê", "E"],
  ["ì", "i"],
  ["Ì", "I"],
  ["í", "i"],
  ["Í", "I"],
  ["ò", "o"],
  ["Ò", "O"],
  ["ó", "o"],
  ["Ó", "O"],
  ["ô", "o"],
  ["Ô", "O"],
  ["õ", "o"],
  ["Õ", "O"],
  ["ù", "u"],
  ["Ù", "U"],
  ["ú", "u"],
  ["Ú", "U"],
  ["ý", "y"],
  ["Ý", "Y"],
  ["ă", "a"],
  ["Ă", "A"],
  ["Đ", "D"],
  ["đ", "d"],
  ["ĩ", "i"],
  ["Ĩ", "I"],
  ["ũ", "u"],
  ["Ũ", "U"],
  ["ơ", "o"],
  ["Ơ", "O"],
  ["ư", "u"],
  ["Ư", "U"],
  ["ạ", "a"],
  ["Ạ", "A"],
  ["ả", "a"],
  ["Ả", "A"],
  ["ấ", "a"],
  ["Ấ", "A"],
  ["ầ", "a"],
  ["Ầ", "A"],
  ["ẩ", "a"],
  ["Ẩ", "A"],
  ["ẫ", "a"],
  ["Ẫ", "A"],
  ["ậ", "a"],
  ["Ậ", "A"],
  ["ắ", "a"],
  ["Ắ", "A"],
  ["ằ", "a"],
  ["Ằ", "A"],
  ["ẳ", "a"],
  ["Ẳ", "A"],
  ["ẵ", "a"],
  ["Ẵ", "A"],
  ["ặ", "a"],
  ["Ặ", "A"],
  ["ẹ", "e"],
  ["Ẹ", "E"],
  ["ẻ", "e"],
  ["Ẻ", "E"],
  ["ẽ", "e"],
  ["Ẽ", "E"],
  ["ế", "e"],
  ["Ế", "E"],
  ["ề", "e"],
  ["Ề", "E"],
  ["ể", "e"],
  ["Ể", "E"],
  ["ễ", "e"],
  ["Ễ", "E"],
  ["ệ", "e"],
  ["Ệ", "E"],
  ["ỉ", "i"],
  ["Ỉ", "I"],
  ["ị", "i"],
  ["Ị", "I"],
  ["ọ", "o"],
  ["Ọ", "O"],
  ["ỏ", "o"],
  ["Ỏ", "O"],
  ["ố", "o"],
  ["Ố", "O"],
  ["ồ", "o"],
  ["Ồ", "O"],
  ["ổ", "o"],
  ["Ổ", "O"],
  ["ỗ", "o"],
  ["Ỗ", "O"],
  ["ộ", "o"],
  ["Ộ", "O"],
  ["ớ", "o"],
  ["Ớ", "O"],
  ["ờ", "o"],
  ["Ờ", "O"],
  ["ở", "o"],
  ["Ở", "O"],
  ["ỡ", "o"],
  ["Ỡ", "O"],
  ["ợ", "o"],
  ["Ợ", "O"],
  ["ụ", "u"],
  ["Ụ", "U"],
  ["ủ", "u"],
  ["Ủ", "U"],
  ["ứ", "u"],
  ["Ứ", "U"],
  ["ừ", "u"],
  ["Ừ", "U"],
  ["ử", "u"],
  ["Ử", "U"],
  ["ữ", "u"],
  ["Ữ", "U"],
  ["ự", "u"],
  ["Ự", "U"],
  ["ỳ", "y"],
  ["Ỳ", "Y"],
  ["ỵ", "y"],
  ["Ỵ", "Y"],
  ["ỷ", "y"],
  ["Ỷ", "Y"],
  ["ỹ", "y"],
  ["Ỹ", "Y"],
  // Arabic
  ["ء", "e"],
  ["آ", "a"],
  ["أ", "a"],
  ["ؤ", "w"],
  ["إ", "a"],
  ["ئ", "y"],
  ["ا", "a"],
  ["ب", "b"],
  ["ة", "t"],
  ["ت", "t"],
  ["ث", "th"],
  ["ج", "j"],
  ["ح", "h"],
  ["خ", "kh"],
  ["د", "d"],
  ["ذ", "dh"],
  ["ر", "r"],
  ["ز", "z"],
  ["س", "s"],
  ["ش", "sh"],
  ["ص", "s"],
  ["ض", "d"],
  ["ط", "t"],
  ["ظ", "z"],
  ["ع", "e"],
  ["غ", "gh"],
  ["ـ", "_"],
  ["ف", "f"],
  ["ق", "q"],
  ["ك", "k"],
  ["ل", "l"],
  ["م", "m"],
  ["ن", "n"],
  ["ه", "h"],
  ["و", "w"],
  ["ى", "a"],
  ["ي", "y"],
  ["َ‎", "a"],
  ["ُ", "u"],
  ["ِ‎", "i"],
  ["٠", "0"],
  ["١", "1"],
  ["٢", "2"],
  ["٣", "3"],
  ["٤", "4"],
  ["٥", "5"],
  ["٦", "6"],
  ["٧", "7"],
  ["٨", "8"],
  ["٩", "9"],
  // Persian / Farsi
  ["چ", "ch"],
  ["ک", "k"],
  ["گ", "g"],
  ["پ", "p"],
  ["ژ", "zh"],
  ["ی", "y"],
  ["۰", "0"],
  ["۱", "1"],
  ["۲", "2"],
  ["۳", "3"],
  ["۴", "4"],
  ["۵", "5"],
  ["۶", "6"],
  ["۷", "7"],
  ["۸", "8"],
  ["۹", "9"],
  // Pashto
  ["ټ", "p"],
  ["ځ", "z"],
  ["څ", "c"],
  ["ډ", "d"],
  ["ﺫ", "d"],
  ["ﺭ", "r"],
  ["ړ", "r"],
  ["ﺯ", "z"],
  ["ږ", "g"],
  ["ښ", "x"],
  ["ګ", "g"],
  ["ڼ", "n"],
  ["ۀ", "e"],
  ["ې", "e"],
  ["ۍ", "ai"],
  // Urdu
  ["ٹ", "t"],
  ["ڈ", "d"],
  ["ڑ", "r"],
  ["ں", "n"],
  ["ہ", "h"],
  ["ھ", "h"],
  ["ے", "e"],
  // Russian
  ["А", "A"],
  ["а", "a"],
  ["Б", "B"],
  ["б", "b"],
  ["В", "V"],
  ["в", "v"],
  ["Г", "G"],
  ["г", "g"],
  ["Д", "D"],
  ["д", "d"],
  ["ъе", "ye"],
  ["Ъе", "Ye"],
  ["ъЕ", "yE"],
  ["ЪЕ", "YE"],
  ["Е", "E"],
  ["е", "e"],
  ["Ё", "Yo"],
  ["ё", "yo"],
  ["Ж", "Zh"],
  ["ж", "zh"],
  ["З", "Z"],
  ["з", "z"],
  ["И", "I"],
  ["и", "i"],
  ["ый", "iy"],
  ["Ый", "Iy"],
  ["ЫЙ", "IY"],
  ["ыЙ", "iY"],
  ["Й", "Y"],
  ["й", "y"],
  ["К", "K"],
  ["к", "k"],
  ["Л", "L"],
  ["л", "l"],
  ["М", "M"],
  ["м", "m"],
  ["Н", "N"],
  ["н", "n"],
  ["О", "O"],
  ["о", "o"],
  ["П", "P"],
  ["п", "p"],
  ["Р", "R"],
  ["р", "r"],
  ["С", "S"],
  ["с", "s"],
  ["Т", "T"],
  ["т", "t"],
  ["У", "U"],
  ["у", "u"],
  ["Ф", "F"],
  ["ф", "f"],
  ["Х", "Kh"],
  ["х", "kh"],
  ["Ц", "Ts"],
  ["ц", "ts"],
  ["Ч", "Ch"],
  ["ч", "ch"],
  ["Ш", "Sh"],
  ["ш", "sh"],
  ["Щ", "Sch"],
  ["щ", "sch"],
  ["Ъ", ""],
  ["ъ", ""],
  ["Ы", "Y"],
  ["ы", "y"],
  ["Ь", ""],
  ["ь", ""],
  ["Э", "E"],
  ["э", "e"],
  ["Ю", "Yu"],
  ["ю", "yu"],
  ["Я", "Ya"],
  ["я", "ya"],
  // Romanian
  ["ă", "a"],
  ["Ă", "A"],
  ["ș", "s"],
  ["Ș", "S"],
  ["ț", "t"],
  ["Ț", "T"],
  ["ţ", "t"],
  ["Ţ", "T"],
  // Turkish
  ["ş", "s"],
  ["Ş", "S"],
  ["ç", "c"],
  ["Ç", "C"],
  ["ğ", "g"],
  ["Ğ", "G"],
  ["ı", "i"],
  ["İ", "I"],
  // Armenian
  ["ա", "a"],
  ["Ա", "A"],
  ["բ", "b"],
  ["Բ", "B"],
  ["գ", "g"],
  ["Գ", "G"],
  ["դ", "d"],
  ["Դ", "D"],
  ["ե", "ye"],
  ["Ե", "Ye"],
  ["զ", "z"],
  ["Զ", "Z"],
  ["է", "e"],
  ["Է", "E"],
  ["ը", "y"],
  ["Ը", "Y"],
  ["թ", "t"],
  ["Թ", "T"],
  ["ժ", "zh"],
  ["Ժ", "Zh"],
  ["ի", "i"],
  ["Ի", "I"],
  ["լ", "l"],
  ["Լ", "L"],
  ["խ", "kh"],
  ["Խ", "Kh"],
  ["ծ", "ts"],
  ["Ծ", "Ts"],
  ["կ", "k"],
  ["Կ", "K"],
  ["հ", "h"],
  ["Հ", "H"],
  ["ձ", "dz"],
  ["Ձ", "Dz"],
  ["ղ", "gh"],
  ["Ղ", "Gh"],
  ["ճ", "tch"],
  ["Ճ", "Tch"],
  ["մ", "m"],
  ["Մ", "M"],
  ["յ", "y"],
  ["Յ", "Y"],
  ["ն", "n"],
  ["Ն", "N"],
  ["շ", "sh"],
  ["Շ", "Sh"],
  // NOTE: Longer Armenian sequences must come before shorter ones
  ["ու", "u"],
  ["ՈՒ", "U"],
  ["Ու", "U"],
  ["ո", "vo"],
  ["Ո", "Vo"],
  ["չ", "ch"],
  ["Չ", "Ch"],
  ["պ", "p"],
  ["Պ", "P"],
  ["ջ", "j"],
  ["Ջ", "J"],
  ["ռ", "r"],
  ["Ռ", "R"],
  ["ս", "s"],
  ["Ս", "S"],
  ["վ", "v"],
  ["Վ", "V"],
  ["տ", "t"],
  ["Տ", "T"],
  ["ր", "r"],
  ["Ր", "R"],
  ["ց", "c"],
  ["Ց", "C"],
  ["փ", "p"],
  ["Փ", "P"],
  ["ք", "q"],
  ["Ք", "Q"],
  ["օ", "o"],
  ["Օ", "O"],
  ["ֆ", "f"],
  ["Ֆ", "F"],
  ["և", "yev"],
  // Georgian
  ["ა", "a"],
  ["ბ", "b"],
  ["გ", "g"],
  ["დ", "d"],
  ["ე", "e"],
  ["ვ", "v"],
  ["ზ", "z"],
  ["თ", "t"],
  ["ი", "i"],
  ["კ", "k"],
  ["ლ", "l"],
  ["მ", "m"],
  ["ნ", "n"],
  ["ო", "o"],
  ["პ", "p"],
  ["ჟ", "zh"],
  ["რ", "r"],
  ["ს", "s"],
  ["ტ", "t"],
  ["უ", "u"],
  ["ფ", "ph"],
  ["ქ", "q"],
  ["ღ", "gh"],
  ["ყ", "k"],
  ["შ", "sh"],
  ["ჩ", "ch"],
  ["ც", "ts"],
  ["ძ", "dz"],
  ["წ", "ts"],
  ["ჭ", "tch"],
  ["ხ", "kh"],
  ["ჯ", "j"],
  ["ჰ", "h"],
  // Czech
  ["č", "c"],
  ["ď", "d"],
  ["ě", "e"],
  ["ň", "n"],
  ["ř", "r"],
  ["š", "s"],
  ["ť", "t"],
  ["ů", "u"],
  ["ž", "z"],
  ["Č", "C"],
  ["Ď", "D"],
  ["Ě", "E"],
  ["Ň", "N"],
  ["Ř", "R"],
  ["Š", "S"],
  ["Ť", "T"],
  ["Ů", "U"],
  ["Ž", "Z"],
  // Dhivehi
  ["ހ", "h"],
  ["ށ", "sh"],
  ["ނ", "n"],
  ["ރ", "r"],
  ["ބ", "b"],
  ["ޅ", "lh"],
  ["ކ", "k"],
  ["އ", "a"],
  ["ވ", "v"],
  ["މ", "m"],
  ["ފ", "f"],
  ["ދ", "dh"],
  ["ތ", "th"],
  ["ލ", "l"],
  ["ގ", "g"],
  ["ޏ", "gn"],
  ["ސ", "s"],
  ["ޑ", "d"],
  ["ޒ", "z"],
  ["ޓ", "t"],
  ["ޔ", "y"],
  ["ޕ", "p"],
  ["ޖ", "j"],
  ["ޗ", "ch"],
  ["ޘ", "tt"],
  ["ޙ", "hh"],
  ["ޚ", "kh"],
  ["ޛ", "th"],
  ["ޜ", "z"],
  ["ޝ", "sh"],
  ["ޞ", "s"],
  ["ޟ", "d"],
  ["ޠ", "t"],
  ["ޡ", "z"],
  ["ޢ", "a"],
  ["ޣ", "gh"],
  ["ޤ", "q"],
  ["ޥ", "w"],
  ["ަ", "a"],
  ["ާ", "aa"],
  ["ި", "i"],
  ["ީ", "ee"],
  ["ު", "u"],
  ["ޫ", "oo"],
  ["ެ", "e"],
  ["ޭ", "ey"],
  ["ޮ", "o"],
  ["ޯ", "oa"],
  ["ް", ""],
  // Greek
  ["α", "a"],
  ["β", "v"],
  ["γ", "g"],
  ["δ", "d"],
  ["ε", "e"],
  ["ζ", "z"],
  ["η", "i"],
  ["θ", "th"],
  ["ι", "i"],
  ["κ", "k"],
  ["λ", "l"],
  ["μ", "m"],
  ["ν", "n"],
  ["ξ", "ks"],
  ["ο", "o"],
  ["π", "p"],
  ["ρ", "r"],
  ["σ", "s"],
  ["τ", "t"],
  ["υ", "y"],
  ["φ", "f"],
  ["χ", "x"],
  ["ψ", "ps"],
  ["ω", "o"],
  ["ά", "a"],
  ["έ", "e"],
  ["ί", "i"],
  ["ό", "o"],
  ["ύ", "y"],
  ["ή", "i"],
  ["ώ", "o"],
  ["ς", "s"],
  ["ϊ", "i"],
  ["ΰ", "y"],
  ["ϋ", "y"],
  ["ΐ", "i"],
  ["Α", "A"],
  ["Β", "B"],
  ["Γ", "G"],
  ["Δ", "D"],
  ["Ε", "E"],
  ["Ζ", "Z"],
  ["Η", "I"],
  ["Θ", "TH"],
  ["Ι", "I"],
  ["Κ", "K"],
  ["Λ", "L"],
  ["Μ", "M"],
  ["Ν", "N"],
  ["Ξ", "KS"],
  ["Ο", "O"],
  ["Π", "P"],
  ["Ρ", "R"],
  ["Σ", "S"],
  ["Τ", "T"],
  ["Υ", "Y"],
  ["Φ", "F"],
  ["Χ", "X"],
  ["Ψ", "PS"],
  ["Ω", "O"],
  ["Ά", "A"],
  ["Έ", "E"],
  ["Ί", "I"],
  ["Ό", "O"],
  ["Ύ", "Y"],
  ["Ή", "I"],
  ["Ώ", "O"],
  ["Ϊ", "I"],
  ["Ϋ", "Y"],
  // Disabled as it conflicts with German and Latin.
  // Hungarian
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // ['ü', 'u'],
  // ['Ü', 'U'],
  // ['ű', 'u'],
  // ['Ű', 'U'],
  // Latvian
  ["ā", "a"],
  ["ē", "e"],
  ["ģ", "g"],
  ["ī", "i"],
  ["ķ", "k"],
  ["ļ", "l"],
  ["ņ", "n"],
  ["ū", "u"],
  ["Ā", "A"],
  ["Ē", "E"],
  ["Ģ", "G"],
  ["Ī", "I"],
  ["Ķ", "K"],
  ["Ļ", "L"],
  ["Ņ", "N"],
  ["Ū", "U"],
  ["č", "c"],
  ["š", "s"],
  ["ž", "z"],
  ["Č", "C"],
  ["Š", "S"],
  ["Ž", "Z"],
  // Lithuanian
  ["ą", "a"],
  ["č", "c"],
  ["ę", "e"],
  ["ė", "e"],
  ["į", "i"],
  ["š", "s"],
  ["ų", "u"],
  ["ū", "u"],
  ["ž", "z"],
  ["Ą", "A"],
  ["Č", "C"],
  ["Ę", "E"],
  ["Ė", "E"],
  ["Į", "I"],
  ["Š", "S"],
  ["Ų", "U"],
  ["Ū", "U"],
  // Macedonian
  ["Ќ", "Kj"],
  ["ќ", "kj"],
  ["Љ", "Lj"],
  ["љ", "lj"],
  ["Њ", "Nj"],
  ["њ", "nj"],
  ["Тс", "Ts"],
  ["тс", "ts"],
  // Polish
  ["ą", "a"],
  ["ć", "c"],
  ["ę", "e"],
  ["ł", "l"],
  ["ń", "n"],
  ["ś", "s"],
  ["ź", "z"],
  ["ż", "z"],
  ["Ą", "A"],
  ["Ć", "C"],
  ["Ę", "E"],
  ["Ł", "L"],
  ["Ń", "N"],
  ["Ś", "S"],
  ["Ź", "Z"],
  ["Ż", "Z"],
  // Disabled as it conflicts with Vietnamese.
  // Serbian
  // ['љ', 'lj'],
  // ['њ', 'nj'],
  // ['Љ', 'Lj'],
  // ['Њ', 'Nj'],
  // ['đ', 'dj'],
  // ['Đ', 'Dj'],
  // ['ђ', 'dj'],
  // ['ј', 'j'],
  // ['ћ', 'c'],
  // ['џ', 'dz'],
  // ['Ђ', 'Dj'],
  // ['Ј', 'j'],
  // ['Ћ', 'C'],
  // ['Џ', 'Dz'],
  // Disabled as it conflicts with German and Latin.
  // Slovak
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ľ', 'l'],
  // ['ĺ', 'l'],
  // ['ŕ', 'r'],
  // ['Ľ', 'L'],
  // ['Ĺ', 'L'],
  // ['Ŕ', 'R'],
  // Disabled as it conflicts with German and Latin.
  // Swedish
  // ['å', 'o'],
  // ['Å', 'o'],
  // ['ä', 'a'],
  // ['Ä', 'A'],
  // ['ë', 'e'],
  // ['Ë', 'E'],
  // ['ö', 'o'],
  // ['Ö', 'O'],
  // Ukrainian
  ["Є", "Ye"],
  ["І", "I"],
  ["Ї", "Yi"],
  ["Ґ", "G"],
  ["є", "ye"],
  ["і", "i"],
  ["ї", "yi"],
  ["ґ", "g"],
  // Dutch
  ["Ĳ", "IJ"],
  ["ĳ", "ij"],
  // Danish
  // ['Æ', 'Ae'],
  // ['Ø', 'Oe'],
  // ['Å', 'Aa'],
  // ['æ', 'ae'],
  // ['ø', 'oe'],
  // ['å', 'aa']
  // Currencies
  ["¢", "c"],
  ["¥", "Y"],
  ["߿", "b"],
  ["৳", "t"],
  ["૱", "Bo"],
  ["฿", "B"],
  ["₠", "CE"],
  ["₡", "C"],
  ["₢", "Cr"],
  ["₣", "F"],
  ["₥", "m"],
  ["₦", "N"],
  ["₧", "Pt"],
  ["₨", "Rs"],
  ["₩", "W"],
  ["₫", "s"],
  ["€", "E"],
  ["₭", "K"],
  ["₮", "T"],
  ["₯", "Dp"],
  ["₰", "S"],
  ["₱", "P"],
  ["₲", "G"],
  ["₳", "A"],
  ["₴", "S"],
  ["₵", "C"],
  ["₶", "tt"],
  ["₷", "S"],
  ["₸", "T"],
  ["₹", "R"],
  ["₺", "L"],
  ["₽", "P"],
  ["₿", "B"],
  ["﹩", "$"],
  ["￠", "c"],
  ["￥", "Y"],
  ["￦", "W"],
  // Latin
  ["𝐀", "A"],
  ["𝐁", "B"],
  ["𝐂", "C"],
  ["𝐃", "D"],
  ["𝐄", "E"],
  ["𝐅", "F"],
  ["𝐆", "G"],
  ["𝐇", "H"],
  ["𝐈", "I"],
  ["𝐉", "J"],
  ["𝐊", "K"],
  ["𝐋", "L"],
  ["𝐌", "M"],
  ["𝐍", "N"],
  ["𝐎", "O"],
  ["𝐏", "P"],
  ["𝐐", "Q"],
  ["𝐑", "R"],
  ["𝐒", "S"],
  ["𝐓", "T"],
  ["𝐔", "U"],
  ["𝐕", "V"],
  ["𝐖", "W"],
  ["𝐗", "X"],
  ["𝐘", "Y"],
  ["𝐙", "Z"],
  ["𝐚", "a"],
  ["𝐛", "b"],
  ["𝐜", "c"],
  ["𝐝", "d"],
  ["𝐞", "e"],
  ["𝐟", "f"],
  ["𝐠", "g"],
  ["𝐡", "h"],
  ["𝐢", "i"],
  ["𝐣", "j"],
  ["𝐤", "k"],
  ["𝐥", "l"],
  ["𝐦", "m"],
  ["𝐧", "n"],
  ["𝐨", "o"],
  ["𝐩", "p"],
  ["𝐪", "q"],
  ["𝐫", "r"],
  ["𝐬", "s"],
  ["𝐭", "t"],
  ["𝐮", "u"],
  ["𝐯", "v"],
  ["𝐰", "w"],
  ["𝐱", "x"],
  ["𝐲", "y"],
  ["𝐳", "z"],
  ["𝐴", "A"],
  ["𝐵", "B"],
  ["𝐶", "C"],
  ["𝐷", "D"],
  ["𝐸", "E"],
  ["𝐹", "F"],
  ["𝐺", "G"],
  ["𝐻", "H"],
  ["𝐼", "I"],
  ["𝐽", "J"],
  ["𝐾", "K"],
  ["𝐿", "L"],
  ["𝑀", "M"],
  ["𝑁", "N"],
  ["𝑂", "O"],
  ["𝑃", "P"],
  ["𝑄", "Q"],
  ["𝑅", "R"],
  ["𝑆", "S"],
  ["𝑇", "T"],
  ["𝑈", "U"],
  ["𝑉", "V"],
  ["𝑊", "W"],
  ["𝑋", "X"],
  ["𝑌", "Y"],
  ["𝑍", "Z"],
  ["𝑎", "a"],
  ["𝑏", "b"],
  ["𝑐", "c"],
  ["𝑑", "d"],
  ["𝑒", "e"],
  ["𝑓", "f"],
  ["𝑔", "g"],
  ["𝑖", "i"],
  ["𝑗", "j"],
  ["𝑘", "k"],
  ["𝑙", "l"],
  ["𝑚", "m"],
  ["𝑛", "n"],
  ["𝑜", "o"],
  ["𝑝", "p"],
  ["𝑞", "q"],
  ["𝑟", "r"],
  ["𝑠", "s"],
  ["𝑡", "t"],
  ["𝑢", "u"],
  ["𝑣", "v"],
  ["𝑤", "w"],
  ["𝑥", "x"],
  ["𝑦", "y"],
  ["𝑧", "z"],
  ["𝑨", "A"],
  ["𝑩", "B"],
  ["𝑪", "C"],
  ["𝑫", "D"],
  ["𝑬", "E"],
  ["𝑭", "F"],
  ["𝑮", "G"],
  ["𝑯", "H"],
  ["𝑰", "I"],
  ["𝑱", "J"],
  ["𝑲", "K"],
  ["𝑳", "L"],
  ["𝑴", "M"],
  ["𝑵", "N"],
  ["𝑶", "O"],
  ["𝑷", "P"],
  ["𝑸", "Q"],
  ["𝑹", "R"],
  ["𝑺", "S"],
  ["𝑻", "T"],
  ["𝑼", "U"],
  ["𝑽", "V"],
  ["𝑾", "W"],
  ["𝑿", "X"],
  ["𝒀", "Y"],
  ["𝒁", "Z"],
  ["𝒂", "a"],
  ["𝒃", "b"],
  ["𝒄", "c"],
  ["𝒅", "d"],
  ["𝒆", "e"],
  ["𝒇", "f"],
  ["𝒈", "g"],
  ["𝒉", "h"],
  ["𝒊", "i"],
  ["𝒋", "j"],
  ["𝒌", "k"],
  ["𝒍", "l"],
  ["𝒎", "m"],
  ["𝒏", "n"],
  ["𝒐", "o"],
  ["𝒑", "p"],
  ["𝒒", "q"],
  ["𝒓", "r"],
  ["𝒔", "s"],
  ["𝒕", "t"],
  ["𝒖", "u"],
  ["𝒗", "v"],
  ["𝒘", "w"],
  ["𝒙", "x"],
  ["𝒚", "y"],
  ["𝒛", "z"],
  ["𝒜", "A"],
  ["𝒞", "C"],
  ["𝒟", "D"],
  ["𝒢", "g"],
  ["𝒥", "J"],
  ["𝒦", "K"],
  ["𝒩", "N"],
  ["𝒪", "O"],
  ["𝒫", "P"],
  ["𝒬", "Q"],
  ["𝒮", "S"],
  ["𝒯", "T"],
  ["𝒰", "U"],
  ["𝒱", "V"],
  ["𝒲", "W"],
  ["𝒳", "X"],
  ["𝒴", "Y"],
  ["𝒵", "Z"],
  ["𝒶", "a"],
  ["𝒷", "b"],
  ["𝒸", "c"],
  ["𝒹", "d"],
  ["𝒻", "f"],
  ["𝒽", "h"],
  ["𝒾", "i"],
  ["𝒿", "j"],
  ["𝓀", "k"],
  ["𝓁", "l"],
  ["𝓂", "m"],
  ["𝓃", "n"],
  ["𝓅", "p"],
  ["𝓆", "q"],
  ["𝓇", "r"],
  ["𝓈", "s"],
  ["𝓉", "t"],
  ["𝓊", "u"],
  ["𝓋", "v"],
  ["𝓌", "w"],
  ["𝓍", "x"],
  ["𝓎", "y"],
  ["𝓏", "z"],
  ["𝓐", "A"],
  ["𝓑", "B"],
  ["𝓒", "C"],
  ["𝓓", "D"],
  ["𝓔", "E"],
  ["𝓕", "F"],
  ["𝓖", "G"],
  ["𝓗", "H"],
  ["𝓘", "I"],
  ["𝓙", "J"],
  ["𝓚", "K"],
  ["𝓛", "L"],
  ["𝓜", "M"],
  ["𝓝", "N"],
  ["𝓞", "O"],
  ["𝓟", "P"],
  ["𝓠", "Q"],
  ["𝓡", "R"],
  ["𝓢", "S"],
  ["𝓣", "T"],
  ["𝓤", "U"],
  ["𝓥", "V"],
  ["𝓦", "W"],
  ["𝓧", "X"],
  ["𝓨", "Y"],
  ["𝓩", "Z"],
  ["𝓪", "a"],
  ["𝓫", "b"],
  ["𝓬", "c"],
  ["𝓭", "d"],
  ["𝓮", "e"],
  ["𝓯", "f"],
  ["𝓰", "g"],
  ["𝓱", "h"],
  ["𝓲", "i"],
  ["𝓳", "j"],
  ["𝓴", "k"],
  ["𝓵", "l"],
  ["𝓶", "m"],
  ["𝓷", "n"],
  ["𝓸", "o"],
  ["𝓹", "p"],
  ["𝓺", "q"],
  ["𝓻", "r"],
  ["𝓼", "s"],
  ["𝓽", "t"],
  ["𝓾", "u"],
  ["𝓿", "v"],
  ["𝔀", "w"],
  ["𝔁", "x"],
  ["𝔂", "y"],
  ["𝔃", "z"],
  ["𝔄", "A"],
  ["𝔅", "B"],
  ["𝔇", "D"],
  ["𝔈", "E"],
  ["𝔉", "F"],
  ["𝔊", "G"],
  ["𝔍", "J"],
  ["𝔎", "K"],
  ["𝔏", "L"],
  ["𝔐", "M"],
  ["𝔑", "N"],
  ["𝔒", "O"],
  ["𝔓", "P"],
  ["𝔔", "Q"],
  ["𝔖", "S"],
  ["𝔗", "T"],
  ["𝔘", "U"],
  ["𝔙", "V"],
  ["𝔚", "W"],
  ["𝔛", "X"],
  ["𝔜", "Y"],
  ["𝔞", "a"],
  ["𝔟", "b"],
  ["𝔠", "c"],
  ["𝔡", "d"],
  ["𝔢", "e"],
  ["𝔣", "f"],
  ["𝔤", "g"],
  ["𝔥", "h"],
  ["𝔦", "i"],
  ["𝔧", "j"],
  ["𝔨", "k"],
  ["𝔩", "l"],
  ["𝔪", "m"],
  ["𝔫", "n"],
  ["𝔬", "o"],
  ["𝔭", "p"],
  ["𝔮", "q"],
  ["𝔯", "r"],
  ["𝔰", "s"],
  ["𝔱", "t"],
  ["𝔲", "u"],
  ["𝔳", "v"],
  ["𝔴", "w"],
  ["𝔵", "x"],
  ["𝔶", "y"],
  ["𝔷", "z"],
  ["𝔸", "A"],
  ["𝔹", "B"],
  ["𝔻", "D"],
  ["𝔼", "E"],
  ["𝔽", "F"],
  ["𝔾", "G"],
  ["𝕀", "I"],
  ["𝕁", "J"],
  ["𝕂", "K"],
  ["𝕃", "L"],
  ["𝕄", "M"],
  ["𝕆", "O"],
  ["𝕊", "S"],
  ["𝕋", "T"],
  ["𝕌", "U"],
  ["𝕍", "V"],
  ["𝕎", "W"],
  ["𝕏", "X"],
  ["𝕐", "Y"],
  ["𝕒", "a"],
  ["𝕓", "b"],
  ["𝕔", "c"],
  ["𝕕", "d"],
  ["𝕖", "e"],
  ["𝕗", "f"],
  ["𝕘", "g"],
  ["𝕙", "h"],
  ["𝕚", "i"],
  ["𝕛", "j"],
  ["𝕜", "k"],
  ["𝕝", "l"],
  ["𝕞", "m"],
  ["𝕟", "n"],
  ["𝕠", "o"],
  ["𝕡", "p"],
  ["𝕢", "q"],
  ["𝕣", "r"],
  ["𝕤", "s"],
  ["𝕥", "t"],
  ["𝕦", "u"],
  ["𝕧", "v"],
  ["𝕨", "w"],
  ["𝕩", "x"],
  ["𝕪", "y"],
  ["𝕫", "z"],
  ["𝕬", "A"],
  ["𝕭", "B"],
  ["𝕮", "C"],
  ["𝕯", "D"],
  ["𝕰", "E"],
  ["𝕱", "F"],
  ["𝕲", "G"],
  ["𝕳", "H"],
  ["𝕴", "I"],
  ["𝕵", "J"],
  ["𝕶", "K"],
  ["𝕷", "L"],
  ["𝕸", "M"],
  ["𝕹", "N"],
  ["𝕺", "O"],
  ["𝕻", "P"],
  ["𝕼", "Q"],
  ["𝕽", "R"],
  ["𝕾", "S"],
  ["𝕿", "T"],
  ["𝖀", "U"],
  ["𝖁", "V"],
  ["𝖂", "W"],
  ["𝖃", "X"],
  ["𝖄", "Y"],
  ["𝖅", "Z"],
  ["𝖆", "a"],
  ["𝖇", "b"],
  ["𝖈", "c"],
  ["𝖉", "d"],
  ["𝖊", "e"],
  ["𝖋", "f"],
  ["𝖌", "g"],
  ["𝖍", "h"],
  ["𝖎", "i"],
  ["𝖏", "j"],
  ["𝖐", "k"],
  ["𝖑", "l"],
  ["𝖒", "m"],
  ["𝖓", "n"],
  ["𝖔", "o"],
  ["𝖕", "p"],
  ["𝖖", "q"],
  ["𝖗", "r"],
  ["𝖘", "s"],
  ["𝖙", "t"],
  ["𝖚", "u"],
  ["𝖛", "v"],
  ["𝖜", "w"],
  ["𝖝", "x"],
  ["𝖞", "y"],
  ["𝖟", "z"],
  ["𝖠", "A"],
  ["𝖡", "B"],
  ["𝖢", "C"],
  ["𝖣", "D"],
  ["𝖤", "E"],
  ["𝖥", "F"],
  ["𝖦", "G"],
  ["𝖧", "H"],
  ["𝖨", "I"],
  ["𝖩", "J"],
  ["𝖪", "K"],
  ["𝖫", "L"],
  ["𝖬", "M"],
  ["𝖭", "N"],
  ["𝖮", "O"],
  ["𝖯", "P"],
  ["𝖰", "Q"],
  ["𝖱", "R"],
  ["𝖲", "S"],
  ["𝖳", "T"],
  ["𝖴", "U"],
  ["𝖵", "V"],
  ["𝖶", "W"],
  ["𝖷", "X"],
  ["𝖸", "Y"],
  ["𝖹", "Z"],
  ["𝖺", "a"],
  ["𝖻", "b"],
  ["𝖼", "c"],
  ["𝖽", "d"],
  ["𝖾", "e"],
  ["𝖿", "f"],
  ["𝗀", "g"],
  ["𝗁", "h"],
  ["𝗂", "i"],
  ["𝗃", "j"],
  ["𝗄", "k"],
  ["𝗅", "l"],
  ["𝗆", "m"],
  ["𝗇", "n"],
  ["𝗈", "o"],
  ["𝗉", "p"],
  ["𝗊", "q"],
  ["𝗋", "r"],
  ["𝗌", "s"],
  ["𝗍", "t"],
  ["𝗎", "u"],
  ["𝗏", "v"],
  ["𝗐", "w"],
  ["𝗑", "x"],
  ["𝗒", "y"],
  ["𝗓", "z"],
  ["𝗔", "A"],
  ["𝗕", "B"],
  ["𝗖", "C"],
  ["𝗗", "D"],
  ["𝗘", "E"],
  ["𝗙", "F"],
  ["𝗚", "G"],
  ["𝗛", "H"],
  ["𝗜", "I"],
  ["𝗝", "J"],
  ["𝗞", "K"],
  ["𝗟", "L"],
  ["𝗠", "M"],
  ["𝗡", "N"],
  ["𝗢", "O"],
  ["𝗣", "P"],
  ["𝗤", "Q"],
  ["𝗥", "R"],
  ["𝗦", "S"],
  ["𝗧", "T"],
  ["𝗨", "U"],
  ["𝗩", "V"],
  ["𝗪", "W"],
  ["𝗫", "X"],
  ["𝗬", "Y"],
  ["𝗭", "Z"],
  ["𝗮", "a"],
  ["𝗯", "b"],
  ["𝗰", "c"],
  ["𝗱", "d"],
  ["𝗲", "e"],
  ["𝗳", "f"],
  ["𝗴", "g"],
  ["𝗵", "h"],
  ["𝗶", "i"],
  ["𝗷", "j"],
  ["𝗸", "k"],
  ["𝗹", "l"],
  ["𝗺", "m"],
  ["𝗻", "n"],
  ["𝗼", "o"],
  ["𝗽", "p"],
  ["𝗾", "q"],
  ["𝗿", "r"],
  ["𝘀", "s"],
  ["𝘁", "t"],
  ["𝘂", "u"],
  ["𝘃", "v"],
  ["𝘄", "w"],
  ["𝘅", "x"],
  ["𝘆", "y"],
  ["𝘇", "z"],
  ["𝘈", "A"],
  ["𝘉", "B"],
  ["𝘊", "C"],
  ["𝘋", "D"],
  ["𝘌", "E"],
  ["𝘍", "F"],
  ["𝘎", "G"],
  ["𝘏", "H"],
  ["𝘐", "I"],
  ["𝘑", "J"],
  ["𝘒", "K"],
  ["𝘓", "L"],
  ["𝘔", "M"],
  ["𝘕", "N"],
  ["𝘖", "O"],
  ["𝘗", "P"],
  ["𝘘", "Q"],
  ["𝘙", "R"],
  ["𝘚", "S"],
  ["𝘛", "T"],
  ["𝘜", "U"],
  ["𝘝", "V"],
  ["𝘞", "W"],
  ["𝘟", "X"],
  ["𝘠", "Y"],
  ["𝘡", "Z"],
  ["𝘢", "a"],
  ["𝘣", "b"],
  ["𝘤", "c"],
  ["𝘥", "d"],
  ["𝘦", "e"],
  ["𝘧", "f"],
  ["𝘨", "g"],
  ["𝘩", "h"],
  ["𝘪", "i"],
  ["𝘫", "j"],
  ["𝘬", "k"],
  ["𝘭", "l"],
  ["𝘮", "m"],
  ["𝘯", "n"],
  ["𝘰", "o"],
  ["𝘱", "p"],
  ["𝘲", "q"],
  ["𝘳", "r"],
  ["𝘴", "s"],
  ["𝘵", "t"],
  ["𝘶", "u"],
  ["𝘷", "v"],
  ["𝘸", "w"],
  ["𝘹", "x"],
  ["𝘺", "y"],
  ["𝘻", "z"],
  ["𝘼", "A"],
  ["𝘽", "B"],
  ["𝘾", "C"],
  ["𝘿", "D"],
  ["𝙀", "E"],
  ["𝙁", "F"],
  ["𝙂", "G"],
  ["𝙃", "H"],
  ["𝙄", "I"],
  ["𝙅", "J"],
  ["𝙆", "K"],
  ["𝙇", "L"],
  ["𝙈", "M"],
  ["𝙉", "N"],
  ["𝙊", "O"],
  ["𝙋", "P"],
  ["𝙌", "Q"],
  ["𝙍", "R"],
  ["𝙎", "S"],
  ["𝙏", "T"],
  ["𝙐", "U"],
  ["𝙑", "V"],
  ["𝙒", "W"],
  ["𝙓", "X"],
  ["𝙔", "Y"],
  ["𝙕", "Z"],
  ["𝙖", "a"],
  ["𝙗", "b"],
  ["𝙘", "c"],
  ["𝙙", "d"],
  ["𝙚", "e"],
  ["𝙛", "f"],
  ["𝙜", "g"],
  ["𝙝", "h"],
  ["𝙞", "i"],
  ["𝙟", "j"],
  ["𝙠", "k"],
  ["𝙡", "l"],
  ["𝙢", "m"],
  ["𝙣", "n"],
  ["𝙤", "o"],
  ["𝙥", "p"],
  ["𝙦", "q"],
  ["𝙧", "r"],
  ["𝙨", "s"],
  ["𝙩", "t"],
  ["𝙪", "u"],
  ["𝙫", "v"],
  ["𝙬", "w"],
  ["𝙭", "x"],
  ["𝙮", "y"],
  ["𝙯", "z"],
  ["𝙰", "A"],
  ["𝙱", "B"],
  ["𝙲", "C"],
  ["𝙳", "D"],
  ["𝙴", "E"],
  ["𝙵", "F"],
  ["𝙶", "G"],
  ["𝙷", "H"],
  ["𝙸", "I"],
  ["𝙹", "J"],
  ["𝙺", "K"],
  ["𝙻", "L"],
  ["𝙼", "M"],
  ["𝙽", "N"],
  ["𝙾", "O"],
  ["𝙿", "P"],
  ["𝚀", "Q"],
  ["𝚁", "R"],
  ["𝚂", "S"],
  ["𝚃", "T"],
  ["𝚄", "U"],
  ["𝚅", "V"],
  ["𝚆", "W"],
  ["𝚇", "X"],
  ["𝚈", "Y"],
  ["𝚉", "Z"],
  ["𝚊", "a"],
  ["𝚋", "b"],
  ["𝚌", "c"],
  ["𝚍", "d"],
  ["𝚎", "e"],
  ["𝚏", "f"],
  ["𝚐", "g"],
  ["𝚑", "h"],
  ["𝚒", "i"],
  ["𝚓", "j"],
  ["𝚔", "k"],
  ["𝚕", "l"],
  ["𝚖", "m"],
  ["𝚗", "n"],
  ["𝚘", "o"],
  ["𝚙", "p"],
  ["𝚚", "q"],
  ["𝚛", "r"],
  ["𝚜", "s"],
  ["𝚝", "t"],
  ["𝚞", "u"],
  ["𝚟", "v"],
  ["𝚠", "w"],
  ["𝚡", "x"],
  ["𝚢", "y"],
  ["𝚣", "z"],
  // Dotless letters
  ["𝚤", "l"],
  ["𝚥", "j"],
  // Greek
  ["𝛢", "A"],
  ["𝛣", "B"],
  ["𝛤", "G"],
  ["𝛥", "D"],
  ["𝛦", "E"],
  ["𝛧", "Z"],
  ["𝛨", "I"],
  ["𝛩", "TH"],
  ["𝛪", "I"],
  ["𝛫", "K"],
  ["𝛬", "L"],
  ["𝛭", "M"],
  ["𝛮", "N"],
  ["𝛯", "KS"],
  ["𝛰", "O"],
  ["𝛱", "P"],
  ["𝛲", "R"],
  ["𝛳", "TH"],
  ["𝛴", "S"],
  ["𝛵", "T"],
  ["𝛶", "Y"],
  ["𝛷", "F"],
  ["𝛸", "x"],
  ["𝛹", "PS"],
  ["𝛺", "O"],
  ["𝛻", "D"],
  ["𝛼", "a"],
  ["𝛽", "b"],
  ["𝛾", "g"],
  ["𝛿", "d"],
  ["𝜀", "e"],
  ["𝜁", "z"],
  ["𝜂", "i"],
  ["𝜃", "th"],
  ["𝜄", "i"],
  ["𝜅", "k"],
  ["𝜆", "l"],
  ["𝜇", "m"],
  ["𝜈", "n"],
  ["𝜉", "ks"],
  ["𝜊", "o"],
  ["𝜋", "p"],
  ["𝜌", "r"],
  ["𝜍", "s"],
  ["𝜎", "s"],
  ["𝜏", "t"],
  ["𝜐", "y"],
  ["𝜑", "f"],
  ["𝜒", "x"],
  ["𝜓", "ps"],
  ["𝜔", "o"],
  ["𝜕", "d"],
  ["𝜖", "E"],
  ["𝜗", "TH"],
  ["𝜘", "K"],
  ["𝜙", "f"],
  ["𝜚", "r"],
  ["𝜛", "p"],
  ["𝜜", "A"],
  ["𝜝", "V"],
  ["𝜞", "G"],
  ["𝜟", "D"],
  ["𝜠", "E"],
  ["𝜡", "Z"],
  ["𝜢", "I"],
  ["𝜣", "TH"],
  ["𝜤", "I"],
  ["𝜥", "K"],
  ["𝜦", "L"],
  ["𝜧", "M"],
  ["𝜨", "N"],
  ["𝜩", "KS"],
  ["𝜪", "O"],
  ["𝜫", "P"],
  ["𝜬", "S"],
  ["𝜭", "TH"],
  ["𝜮", "S"],
  ["𝜯", "T"],
  ["𝜰", "Y"],
  ["𝜱", "F"],
  ["𝜲", "X"],
  ["𝜳", "PS"],
  ["𝜴", "O"],
  ["𝜵", "D"],
  ["𝜶", "a"],
  ["𝜷", "v"],
  ["𝜸", "g"],
  ["𝜹", "d"],
  ["𝜺", "e"],
  ["𝜻", "z"],
  ["𝜼", "i"],
  ["𝜽", "th"],
  ["𝜾", "i"],
  ["𝜿", "k"],
  ["𝝀", "l"],
  ["𝝁", "m"],
  ["𝝂", "n"],
  ["𝝃", "ks"],
  ["𝝄", "o"],
  ["𝝅", "p"],
  ["𝝆", "r"],
  ["𝝇", "s"],
  ["𝝈", "s"],
  ["𝝉", "t"],
  ["𝝊", "y"],
  ["𝝋", "f"],
  ["𝝌", "x"],
  ["𝝍", "ps"],
  ["𝝎", "o"],
  ["𝝏", "a"],
  ["𝝐", "e"],
  ["𝝑", "i"],
  ["𝝒", "k"],
  ["𝝓", "f"],
  ["𝝔", "r"],
  ["𝝕", "p"],
  ["𝝖", "A"],
  ["𝝗", "B"],
  ["𝝘", "G"],
  ["𝝙", "D"],
  ["𝝚", "E"],
  ["𝝛", "Z"],
  ["𝝜", "I"],
  ["𝝝", "TH"],
  ["𝝞", "I"],
  ["𝝟", "K"],
  ["𝝠", "L"],
  ["𝝡", "M"],
  ["𝝢", "N"],
  ["𝝣", "KS"],
  ["𝝤", "O"],
  ["𝝥", "P"],
  ["𝝦", "R"],
  ["𝝧", "TH"],
  ["𝝨", "S"],
  ["𝝩", "T"],
  ["𝝪", "Y"],
  ["𝝫", "F"],
  ["𝝬", "X"],
  ["𝝭", "PS"],
  ["𝝮", "O"],
  ["𝝯", "D"],
  ["𝝰", "a"],
  ["𝝱", "v"],
  ["𝝲", "g"],
  ["𝝳", "d"],
  ["𝝴", "e"],
  ["𝝵", "z"],
  ["𝝶", "i"],
  ["𝝷", "th"],
  ["𝝸", "i"],
  ["𝝹", "k"],
  ["𝝺", "l"],
  ["𝝻", "m"],
  ["𝝼", "n"],
  ["𝝽", "ks"],
  ["𝝾", "o"],
  ["𝝿", "p"],
  ["𝞀", "r"],
  ["𝞁", "s"],
  ["𝞂", "s"],
  ["𝞃", "t"],
  ["𝞄", "y"],
  ["𝞅", "f"],
  ["𝞆", "x"],
  ["𝞇", "ps"],
  ["𝞈", "o"],
  ["𝞉", "a"],
  ["𝞊", "e"],
  ["𝞋", "i"],
  ["𝞌", "k"],
  ["𝞍", "f"],
  ["𝞎", "r"],
  ["𝞏", "p"],
  ["𝞐", "A"],
  ["𝞑", "V"],
  ["𝞒", "G"],
  ["𝞓", "D"],
  ["𝞔", "E"],
  ["𝞕", "Z"],
  ["𝞖", "I"],
  ["𝞗", "TH"],
  ["𝞘", "I"],
  ["𝞙", "K"],
  ["𝞚", "L"],
  ["𝞛", "M"],
  ["𝞜", "N"],
  ["𝞝", "KS"],
  ["𝞞", "O"],
  ["𝞟", "P"],
  ["𝞠", "S"],
  ["𝞡", "TH"],
  ["𝞢", "S"],
  ["𝞣", "T"],
  ["𝞤", "Y"],
  ["𝞥", "F"],
  ["𝞦", "X"],
  ["𝞧", "PS"],
  ["𝞨", "O"],
  ["𝞩", "D"],
  ["𝞪", "av"],
  ["𝞫", "g"],
  ["𝞬", "d"],
  ["𝞭", "e"],
  ["𝞮", "z"],
  ["𝞯", "i"],
  ["𝞰", "i"],
  ["𝞱", "th"],
  ["𝞲", "i"],
  ["𝞳", "k"],
  ["𝞴", "l"],
  ["𝞵", "m"],
  ["𝞶", "n"],
  ["𝞷", "ks"],
  ["𝞸", "o"],
  ["𝞹", "p"],
  ["𝞺", "r"],
  ["𝞻", "s"],
  ["𝞼", "s"],
  ["𝞽", "t"],
  ["𝞾", "y"],
  ["𝞿", "f"],
  ["𝟀", "x"],
  ["𝟁", "ps"],
  ["𝟂", "o"],
  ["𝟃", "a"],
  ["𝟄", "e"],
  ["𝟅", "i"],
  ["𝟆", "k"],
  ["𝟇", "f"],
  ["𝟈", "r"],
  ["𝟉", "p"],
  ["𝟊", "F"],
  ["𝟋", "f"],
  ["⒜", "(a)"],
  ["⒝", "(b)"],
  ["⒞", "(c)"],
  ["⒟", "(d)"],
  ["⒠", "(e)"],
  ["⒡", "(f)"],
  ["⒢", "(g)"],
  ["⒣", "(h)"],
  ["⒤", "(i)"],
  ["⒥", "(j)"],
  ["⒦", "(k)"],
  ["⒧", "(l)"],
  ["⒨", "(m)"],
  ["⒩", "(n)"],
  ["⒪", "(o)"],
  ["⒫", "(p)"],
  ["⒬", "(q)"],
  ["⒭", "(r)"],
  ["⒮", "(s)"],
  ["⒯", "(t)"],
  ["⒰", "(u)"],
  ["⒱", "(v)"],
  ["⒲", "(w)"],
  ["⒳", "(x)"],
  ["⒴", "(y)"],
  ["⒵", "(z)"],
  ["Ⓐ", "(A)"],
  ["Ⓑ", "(B)"],
  ["Ⓒ", "(C)"],
  ["Ⓓ", "(D)"],
  ["Ⓔ", "(E)"],
  ["Ⓕ", "(F)"],
  ["Ⓖ", "(G)"],
  ["Ⓗ", "(H)"],
  ["Ⓘ", "(I)"],
  ["Ⓙ", "(J)"],
  ["Ⓚ", "(K)"],
  ["Ⓛ", "(L)"],
  ["Ⓝ", "(N)"],
  ["Ⓞ", "(O)"],
  ["Ⓟ", "(P)"],
  ["Ⓠ", "(Q)"],
  ["Ⓡ", "(R)"],
  ["Ⓢ", "(S)"],
  ["Ⓣ", "(T)"],
  ["Ⓤ", "(U)"],
  ["Ⓥ", "(V)"],
  ["Ⓦ", "(W)"],
  ["Ⓧ", "(X)"],
  ["Ⓨ", "(Y)"],
  ["Ⓩ", "(Z)"],
  ["ⓐ", "(a)"],
  ["ⓑ", "(b)"],
  ["ⓒ", "(c)"],
  ["ⓓ", "(d)"],
  ["ⓔ", "(e)"],
  ["ⓕ", "(f)"],
  ["ⓖ", "(g)"],
  ["ⓗ", "(h)"],
  ["ⓘ", "(i)"],
  ["ⓙ", "(j)"],
  ["ⓚ", "(k)"],
  ["ⓛ", "(l)"],
  ["ⓜ", "(m)"],
  ["ⓝ", "(n)"],
  ["ⓞ", "(o)"],
  ["ⓟ", "(p)"],
  ["ⓠ", "(q)"],
  ["ⓡ", "(r)"],
  ["ⓢ", "(s)"],
  ["ⓣ", "(t)"],
  ["ⓤ", "(u)"],
  ["ⓥ", "(v)"],
  ["ⓦ", "(w)"],
  ["ⓧ", "(x)"],
  ["ⓨ", "(y)"],
  ["ⓩ", "(z)"],
  // Maltese
  ["Ċ", "C"],
  ["ċ", "c"],
  ["Ġ", "G"],
  ["ġ", "g"],
  ["Ħ", "H"],
  ["ħ", "h"],
  ["Ż", "Z"],
  ["ż", "z"],
  // Numbers
  ["𝟎", "0"],
  ["𝟏", "1"],
  ["𝟐", "2"],
  ["𝟑", "3"],
  ["𝟒", "4"],
  ["𝟓", "5"],
  ["𝟔", "6"],
  ["𝟕", "7"],
  ["𝟖", "8"],
  ["𝟗", "9"],
  ["𝟘", "0"],
  ["𝟙", "1"],
  ["𝟚", "2"],
  ["𝟛", "3"],
  ["𝟜", "4"],
  ["𝟝", "5"],
  ["𝟞", "6"],
  ["𝟟", "7"],
  ["𝟠", "8"],
  ["𝟡", "9"],
  ["𝟢", "0"],
  ["𝟣", "1"],
  ["𝟤", "2"],
  ["𝟥", "3"],
  ["𝟦", "4"],
  ["𝟧", "5"],
  ["𝟨", "6"],
  ["𝟩", "7"],
  ["𝟪", "8"],
  ["𝟫", "9"],
  ["𝟬", "0"],
  ["𝟭", "1"],
  ["𝟮", "2"],
  ["𝟯", "3"],
  ["𝟰", "4"],
  ["𝟱", "5"],
  ["𝟲", "6"],
  ["𝟳", "7"],
  ["𝟴", "8"],
  ["𝟵", "9"],
  ["𝟶", "0"],
  ["𝟷", "1"],
  ["𝟸", "2"],
  ["𝟹", "3"],
  ["𝟺", "4"],
  ["𝟻", "5"],
  ["𝟼", "6"],
  ["𝟽", "7"],
  ["𝟾", "8"],
  ["𝟿", "9"],
  ["①", "1"],
  ["②", "2"],
  ["③", "3"],
  ["④", "4"],
  ["⑤", "5"],
  ["⑥", "6"],
  ["⑦", "7"],
  ["⑧", "8"],
  ["⑨", "9"],
  ["⑩", "10"],
  ["⑪", "11"],
  ["⑫", "12"],
  ["⑬", "13"],
  ["⑭", "14"],
  ["⑮", "15"],
  ["⑯", "16"],
  ["⑰", "17"],
  ["⑱", "18"],
  ["⑲", "19"],
  ["⑳", "20"],
  ["⑴", "1"],
  ["⑵", "2"],
  ["⑶", "3"],
  ["⑷", "4"],
  ["⑸", "5"],
  ["⑹", "6"],
  ["⑺", "7"],
  ["⑻", "8"],
  ["⑼", "9"],
  ["⑽", "10"],
  ["⑾", "11"],
  ["⑿", "12"],
  ["⒀", "13"],
  ["⒁", "14"],
  ["⒂", "15"],
  ["⒃", "16"],
  ["⒄", "17"],
  ["⒅", "18"],
  ["⒆", "19"],
  ["⒇", "20"],
  ["⒈", "1."],
  ["⒉", "2."],
  ["⒊", "3."],
  ["⒋", "4."],
  ["⒌", "5."],
  ["⒍", "6."],
  ["⒎", "7."],
  ["⒏", "8."],
  ["⒐", "9."],
  ["⒑", "10."],
  ["⒒", "11."],
  ["⒓", "12."],
  ["⒔", "13."],
  ["⒕", "14."],
  ["⒖", "15."],
  ["⒗", "16."],
  ["⒘", "17."],
  ["⒙", "18."],
  ["⒚", "19."],
  ["⒛", "20."],
  ["⓪", "0"],
  ["⓫", "11"],
  ["⓬", "12"],
  ["⓭", "13"],
  ["⓮", "14"],
  ["⓯", "15"],
  ["⓰", "16"],
  ["⓱", "17"],
  ["⓲", "18"],
  ["⓳", "19"],
  ["⓴", "20"],
  ["⓵", "1"],
  ["⓶", "2"],
  ["⓷", "3"],
  ["⓸", "4"],
  ["⓹", "5"],
  ["⓺", "6"],
  ["⓻", "7"],
  ["⓼", "8"],
  ["⓽", "9"],
  ["⓾", "10"],
  ["⓿", "0"],
  // Punctuation
  ["🙰", "&"],
  ["🙱", "&"],
  ["🙲", "&"],
  ["🙳", "&"],
  ["🙴", "&"],
  ["🙵", "&"],
  ["🙶", '"'],
  ["🙷", '"'],
  ["🙸", '"'],
  ["‽", "?!"],
  ["🙹", "?!"],
  ["🙺", "?!"],
  ["🙻", "?!"],
  ["🙼", "/"],
  ["🙽", "\\"],
  // Alchemy
  ["🜇", "AR"],
  ["🜈", "V"],
  ["🜉", "V"],
  ["🜆", "VR"],
  ["🜅", "VF"],
  ["🜩", "2"],
  ["🜪", "5"],
  ["🝡", "f"],
  ["🝢", "W"],
  ["🝣", "U"],
  ["🝧", "V"],
  ["🝨", "T"],
  ["🝪", "V"],
  ["🝫", "MB"],
  ["🝬", "VB"],
  ["🝲", "3B"],
  ["🝳", "3B"],
  // Emojis
  ["💯", "100"],
  ["🔙", "BACK"],
  ["🔚", "END"],
  ["🔛", "ON!"],
  ["🔜", "SOON"],
  ["🔝", "TOP"],
  ["🔞", "18"],
  ["🔤", "abc"],
  ["🔠", "ABCD"],
  ["🔡", "abcd"],
  ["🔢", "1234"],
  ["🔣", "T&@%"],
  ["#️⃣", "#"],
  ["*️⃣", "*"],
  ["0️⃣", "0"],
  ["1️⃣", "1"],
  ["2️⃣", "2"],
  ["3️⃣", "3"],
  ["4️⃣", "4"],
  ["5️⃣", "5"],
  ["6️⃣", "6"],
  ["7️⃣", "7"],
  ["8️⃣", "8"],
  ["9️⃣", "9"],
  ["🔟", "10"],
  ["🅰️", "A"],
  ["🅱️", "B"],
  ["🆎", "AB"],
  ["🆑", "CL"],
  ["🅾️", "O"],
  ["🅿", "P"],
  ["🆘", "SOS"],
  ["🅲", "C"],
  ["🅳", "D"],
  ["🅴", "E"],
  ["🅵", "F"],
  ["🅶", "G"],
  ["🅷", "H"],
  ["🅸", "I"],
  ["🅹", "J"],
  ["🅺", "K"],
  ["🅻", "L"],
  ["🅼", "M"],
  ["🅽", "N"],
  ["🆀", "Q"],
  ["🆁", "R"],
  ["🆂", "S"],
  ["🆃", "T"],
  ["🆄", "U"],
  ["🆅", "V"],
  ["🆆", "W"],
  ["🆇", "X"],
  ["🆈", "Y"],
  ["🆉", "Z"],
  // Dashes not covered by Dash_Punctuation category
  ["−", "-"],
  // U+2212 Minus Sign (Mathematical Operators category)
  ["⁓", "-"]
  // U+2053 Swung Dash (Other_Punctuation category)
], builtinReplacements = new Map(replacements), danishNorwegianReplacements = [
  ["æ", "ae"],
  ["Æ", "Ae"],
  ["ø", "oe"],
  ["Ø", "Oe"],
  ["å", "aa"],
  ["Å", "Aa"]
], localeReplacements = {
  // Swedish
  sv: [
    ["ä", "a"],
    ["Ä", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["å", "a"],
    ["Å", "A"]
  ],
  // Danish
  da: danishNorwegianReplacements,
  // Norwegian Bokmål
  nb: danishNorwegianReplacements,
  // German
  de: [
    ["ä", "ae"],
    ["Ä", "Ae"],
    ["ö", "oe"],
    ["Ö", "Oe"],
    ["ü", "ue"],
    ["Ü", "Ue"],
    ["ß", "ss"],
    ["ẞ", "Ss"]
  ],
  // Turkish
  tr: [
    ["â", "a"],
    ["Â", "A"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"]
  ],
  // Hungarian
  hu: [
    ["ű", "u"],
    ["Ű", "U"],
    ["ö", "o"],
    ["Ö", "O"],
    ["ü", "u"],
    ["Ü", "U"],
    ["á", "a"],
    ["Á", "A"],
    ["é", "e"],
    ["É", "E"],
    ["í", "i"],
    ["Í", "I"],
    ["ó", "o"],
    ["Ó", "O"],
    ["ú", "u"],
    ["Ú", "U"]
  ],
  // Serbian
  sr: [
    ["ђ", "dj"],
    ["Ђ", "Dj"],
    ["џ", "dz"],
    ["Џ", "Dz"],
    ["љ", "lj"],
    ["Љ", "Lj"],
    ["њ", "nj"],
    ["Њ", "Nj"],
    ["ћ", "c"],
    ["Ћ", "C"],
    ["ч", "ch"],
    ["Ч", "Ch"],
    ["ш", "sh"],
    ["Ш", "Sh"],
    ["ж", "zh"],
    ["Ж", "Zh"]
  ]
};
for (const CA of Object.keys(localeReplacements))
  localeReplacements[CA] = new Map(localeReplacements[CA]);
const doCustomReplacements = (CA, gA) => {
  for (const [AA, IA] of gA)
    CA = CA.replaceAll(AA, IA);
  return CA;
}, getLocaleReplacements = (CA) => {
  if (!CA)
    return;
  const gA = CA.toLowerCase().replace(/^no(-|$)/, "nb$1");
  return localeReplacements[gA] || localeReplacements[gA.split("-")[0]] || void 0;
};
function transliterate(CA, gA) {
  if (typeof CA != "string")
    throw new TypeError(`Expected a string, got \`${typeof CA}\``);
  gA = {
    customReplacements: [],
    ...gA
  };
  const AA = getLocaleReplacements(gA.locale);
  let IA = builtinReplacements;
  const BA = gA.customReplacements.length > 0 || gA.customReplacements.size > 0;
  if (AA || BA) {
    if (IA = new Map(builtinReplacements), AA)
      for (const [QA, EA] of AA)
        IA.set(QA, EA);
    for (const [QA, EA] of gA.customReplacements)
      IA.set(QA, EA);
  }
  return CA = CA.normalize(), CA = doCustomReplacements(CA, IA), CA = CA.normalize("NFD").replaceAll(new RegExp("\\p{Diacritic}", "gu"), "").normalize(), CA = CA.replaceAll(new RegExp("\\p{Dash_Punctuation}", "gu"), "-"), CA;
}
const overridableReplacements = [
  ["&", " and "],
  ["🦄", " unicorn "],
  ["♥", " love "]
], decamelize = (CA) => CA.replaceAll(/([A-Z]{2,})(\d+)/g, "$1 $2").replaceAll(/([a-z\d]+)([A-Z]{2,})/g, "$1 $2").replaceAll(/([a-z\d])([A-Z])/g, "$1 $2").replaceAll(/([A-Z]+)([A-Z][a-rt-z\d]+)/g, "$1 $2"), removeMootSeparators = (CA, gA) => {
  const AA = escapeStringRegexp$1(gA);
  return CA.replaceAll(new RegExp(`(?:${AA}){2,}`, "g"), gA).replaceAll(new RegExp(`^(?:${AA})|(?:${AA})$`, "g"), "");
}, buildPatternSlug = (CA) => {
  let gA = String.raw`a-z\d`;
  if (gA += CA.lowercase ? "" : "A-Z", CA.transliterate === !1 && (gA += String.raw`\p{L}\p{N}`), CA.preserveCharacters.length > 0)
    for (const IA of CA.preserveCharacters) {
      if (IA === CA.separator)
        throw new Error(`The separator character \`${CA.separator}\` cannot be included in preserved characters: ${CA.preserveCharacters}`);
      gA += escapeStringRegexp$1(IA);
    }
  const AA = CA.transliterate ? "g" : "gu";
  return new RegExp(`[^${gA}]+`, AA);
};
function slugify(CA, gA) {
  if (typeof CA != "string")
    throw new TypeError(`Expected a string, got \`${typeof CA}\``);
  gA = {
    separator: "-",
    lowercase: !0,
    decamelize: !0,
    customReplacements: [],
    preserveLeadingUnderscore: !1,
    preserveTrailingDash: !1,
    preserveCharacters: [],
    transliterate: !0,
    ...gA
  };
  const AA = gA.preserveLeadingUnderscore && CA.startsWith("_"), IA = gA.preserveTrailingDash && CA.endsWith("-");
  if (gA.transliterate) {
    const QA = new Map([
      ...overridableReplacements,
      ...gA.customReplacements
    ]);
    CA = transliterate(CA, { customReplacements: QA, locale: gA.locale });
  } else if (gA.customReplacements.length > 0)
    for (const [QA, EA] of gA.customReplacements)
      CA = CA.replaceAll(QA, EA);
  gA.decamelize && (CA = decamelize(CA));
  const BA = buildPatternSlug(gA);
  return gA.lowercase && (CA = gA.locale ? CA.toLocaleLowerCase(gA.locale) : CA.toLowerCase()), CA = CA.replaceAll(/([a-zA-Z\d]+)['\u2019]([ts])(\s|$)/g, "$1$2$3"), CA = CA.replace(BA, gA.separator), CA = CA.replaceAll("\\", ""), gA.separator && (CA = removeMootSeparators(CA, gA.separator)), AA && (CA = `_${CA}`), IA && (CA = `${CA}-`), CA;
}
function escapeStringRegexp(CA) {
  if (typeof CA != "string")
    throw new TypeError("Expected a string");
  return CA.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(CA) {
    if (CA == null)
      return ok$1;
    if (typeof CA == "function")
      return castFactory(CA);
    if (typeof CA == "object")
      return Array.isArray(CA) ? anyFactory(CA) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        propertiesFactory(
          /** @type {Props} */
          CA
        )
      );
    if (typeof CA == "string")
      return typeFactory(CA);
    throw new Error("Expected function, string, or object as test");
  })
);
function anyFactory(CA) {
  const gA = [];
  let AA = -1;
  for (; ++AA < CA.length; )
    gA[AA] = convert(CA[AA]);
  return castFactory(IA);
  function IA(...BA) {
    let QA = -1;
    for (; ++QA < gA.length; )
      if (gA[QA].apply(this, BA)) return !0;
    return !1;
  }
}
function propertiesFactory(CA) {
  const gA = (
    /** @type {Record<string, unknown>} */
    CA
  );
  return castFactory(AA);
  function AA(IA) {
    const BA = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      IA
    );
    let QA;
    for (QA in CA)
      if (BA[QA] !== gA[QA]) return !1;
    return !0;
  }
}
function typeFactory(CA) {
  return castFactory(gA);
  function gA(AA) {
    return AA && AA.type === CA;
  }
}
function castFactory(CA) {
  return gA;
  function gA(AA, IA, BA) {
    return !!(looksLikeANode(AA) && CA.call(
      this,
      AA,
      typeof IA == "number" ? IA : void 0,
      BA || void 0
    ));
  }
}
function ok$1() {
  return !0;
}
function looksLikeANode(CA) {
  return CA !== null && typeof CA == "object" && "type" in CA;
}
function color(CA) {
  return CA;
}
const empty$2 = [], CONTINUE = !0, EXIT = !1, SKIP = "skip";
function visitParents(CA, gA, AA, IA) {
  let BA;
  typeof gA == "function" && typeof AA != "function" ? (IA = AA, AA = gA) : BA = gA;
  const QA = convert(BA), EA = IA ? -1 : 1;
  iA(CA, void 0, [])();
  function iA(oA, cA, tA) {
    const eA = (
      /** @type {Record<string, unknown>} */
      oA && typeof oA == "object" ? oA : {}
    );
    if (typeof eA.type == "string") {
      const GA = (
        // `hast`
        typeof eA.tagName == "string" ? eA.tagName : (
          // `xast`
          typeof eA.name == "string" ? eA.name : void 0
        )
      );
      Object.defineProperty(aA, "name", {
        value: "node (" + (oA.type + (GA ? "<" + GA + ">" : "")) + ")"
      });
    }
    return aA;
    function aA() {
      let GA = empty$2, lA, nA, DA;
      if ((!gA || QA(oA, cA, tA[tA.length - 1] || void 0)) && (GA = toResult(AA(oA, tA)), GA[0] === EXIT))
        return GA;
      if ("children" in oA && oA.children) {
        const hA = (
          /** @type {UnistParent} */
          oA
        );
        if (hA.children && GA[0] !== SKIP)
          for (nA = (IA ? hA.children.length : -1) + EA, DA = tA.concat(hA); nA > -1 && nA < hA.children.length; ) {
            const wA = hA.children[nA];
            if (lA = iA(wA, nA, DA)(), lA[0] === EXIT)
              return lA;
            nA = typeof lA[1] == "number" ? lA[1] : nA + EA;
          }
      }
      return GA;
    }
  }
}
function toResult(CA) {
  return Array.isArray(CA) ? CA : typeof CA == "number" ? [CONTINUE, CA] : CA == null ? empty$2 : [CA];
}
function findAndReplace(CA, gA, AA) {
  const BA = convert((AA || {}).ignore || []), QA = toPairs(gA);
  let EA = -1;
  for (; ++EA < QA.length; )
    visitParents(CA, "text", iA);
  function iA(cA, tA) {
    let eA = -1, aA;
    for (; ++eA < tA.length; ) {
      const GA = tA[eA], lA = aA ? aA.children : void 0;
      if (BA(
        GA,
        lA ? lA.indexOf(GA) : void 0,
        aA
      ))
        return;
      aA = GA;
    }
    if (aA)
      return oA(cA, tA);
  }
  function oA(cA, tA) {
    const eA = tA[tA.length - 1], aA = QA[EA][0], GA = QA[EA][1];
    let lA = 0;
    const DA = eA.children.indexOf(cA);
    let hA = !1, wA = [];
    aA.lastIndex = 0;
    let sA = aA.exec(cA.value);
    for (; sA; ) {
      const NA = sA.index, rA = {
        index: sA.index,
        input: sA.input,
        stack: [...tA, cA]
      };
      let yA = GA(...sA, rA);
      if (typeof yA == "string" && (yA = yA.length > 0 ? { type: "text", value: yA } : void 0), yA === !1 ? aA.lastIndex = NA + 1 : (lA !== NA && wA.push({
        type: "text",
        value: cA.value.slice(lA, NA)
      }), Array.isArray(yA) ? wA.push(...yA) : yA && wA.push(yA), lA = NA + sA[0].length, hA = !0), !aA.global)
        break;
      sA = aA.exec(cA.value);
    }
    return hA ? (lA < cA.value.length && wA.push({ type: "text", value: cA.value.slice(lA) }), eA.children.splice(DA, 1, ...wA)) : wA = [cA], DA + wA.length;
  }
}
function toPairs(CA) {
  const gA = [];
  if (!Array.isArray(CA))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const AA = !CA[0] || Array.isArray(CA[0]) ? CA : [CA];
  let IA = -1;
  for (; ++IA < AA.length; ) {
    const BA = AA[IA];
    gA.push([toExpression(BA[0]), toFunction(BA[1])]);
  }
  return gA;
}
function toExpression(CA) {
  return typeof CA == "string" ? new RegExp(escapeStringRegexp(CA), "g") : CA;
}
function toFunction(CA) {
  return typeof CA == "function" ? CA : function() {
    return CA;
  };
}
function _extends$e() {
  return _extends$e = Object.assign || function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$e.apply(this, arguments);
}
function _objectWithoutProperties$c(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$b(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$b(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
var Check$1 = forwardRef(function(CA, gA) {
  var AA = CA.color, IA = AA === void 0 ? "currentColor" : AA, BA = CA.size, QA = BA === void 0 ? 24 : BA, EA = _objectWithoutProperties$c(CA, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$e({
    ref: gA,
    xmlns: "http://www.w3.org/2000/svg",
    width: QA,
    height: QA,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: IA,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, EA), /* @__PURE__ */ React__default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});
Check$1.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check$1.displayName = "Check";
function _extends$d() {
  return _extends$d = Object.assign || function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$d.apply(this, arguments);
}
function _objectWithoutProperties$b(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$a(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$a(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
var Copy = forwardRef(function(CA, gA) {
  var AA = CA.color, IA = AA === void 0 ? "currentColor" : AA, BA = CA.size, QA = BA === void 0 ? 24 : BA, EA = _objectWithoutProperties$b(CA, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$d({
    ref: gA,
    xmlns: "http://www.w3.org/2000/svg",
    width: QA,
    height: QA,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: IA,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, EA), /* @__PURE__ */ React__default.createElement("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
});
Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Copy.displayName = "Copy";
function _extends$c() {
  return _extends$c = Object.assign || function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$c.apply(this, arguments);
}
function _objectWithoutProperties$a(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$9(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$9(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
var HelpCircle = forwardRef(function(CA, gA) {
  var AA = CA.color, IA = AA === void 0 ? "currentColor" : AA, BA = CA.size, QA = BA === void 0 ? 24 : BA, EA = _objectWithoutProperties$a(CA, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$c({
    ref: gA,
    xmlns: "http://www.w3.org/2000/svg",
    width: QA,
    height: QA,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: IA,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, EA), /* @__PURE__ */ React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
HelpCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
HelpCircle.displayName = "HelpCircle";
function _extends$b() {
  return _extends$b = Object.assign || function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$b.apply(this, arguments);
}
function _objectWithoutProperties$9(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$8(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$8(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
var Link2 = forwardRef(function(CA, gA) {
  var AA = CA.color, IA = AA === void 0 ? "currentColor" : AA, BA = CA.size, QA = BA === void 0 ? 24 : BA, EA = _objectWithoutProperties$9(CA, ["color", "size"]);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$b({
    ref: gA,
    xmlns: "http://www.w3.org/2000/svg",
    width: QA,
    height: QA,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: IA,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, EA), /* @__PURE__ */ React__default.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /* @__PURE__ */ React__default.createElement("line", {
    x1: "8",
    y1: "12",
    x2: "16",
    y2: "12"
  }));
});
Link2.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Link2.displayName = "Link2";
function ok() {
}
function unreachable() {
}
function parse$3(CA) {
  const gA = [], AA = String(CA || "");
  let IA = AA.indexOf(","), BA = 0, QA = !1;
  for (; !QA; ) {
    IA === -1 && (IA = AA.length, QA = !0);
    const EA = AA.slice(BA, IA).trim();
    (EA || !QA) && gA.push(EA), BA = IA + 1, IA = AA.indexOf(",", BA);
  }
  return gA;
}
function stringify$2(CA, gA) {
  const AA = {};
  return (CA[CA.length - 1] === "" ? [...CA, ""] : CA).join(
    (AA.padRight ? " " : "") + "," + (AA.padLeft === !1 ? "" : " ")
  ).trim();
}
const nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, emptyOptions$5 = {};
function name(CA, gA) {
  return (emptyOptions$5.jsx ? nameReJsx : nameRe).test(CA);
}
const re = /[ \t\n\f\r]/g;
function whitespace(CA) {
  return typeof CA == "object" ? CA.type === "text" ? empty$1(CA.value) : !1 : empty$1(CA);
}
function empty$1(CA) {
  return CA.replace(re, "") === "";
}
class Schema {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(gA, AA, IA) {
    this.normal = AA, this.property = gA, IA && (this.space = IA);
  }
}
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = void 0;
function merge(CA, gA) {
  const AA = {}, IA = {};
  for (const BA of CA)
    Object.assign(AA, BA.property), Object.assign(IA, BA.normal);
  return new Schema(AA, IA, gA);
}
function normalize$1(CA) {
  return CA.toLowerCase();
}
class Info {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(gA, AA) {
    this.attribute = AA, this.property = gA;
  }
}
Info.prototype.attribute = "";
Info.prototype.booleanish = !1;
Info.prototype.boolean = !1;
Info.prototype.commaOrSpaceSeparated = !1;
Info.prototype.commaSeparated = !1;
Info.prototype.defined = !1;
Info.prototype.mustUseProperty = !1;
Info.prototype.number = !1;
Info.prototype.overloadedBoolean = !1;
Info.prototype.property = "";
Info.prototype.spaceSeparated = !1;
Info.prototype.space = void 0;
let powers = 0;
const boolean = increment(), booleanish = increment(), overloadedBoolean = increment(), number = increment(), spaceSeparated = increment(), commaSeparated = increment(), commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}
const types$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean,
  booleanish,
  commaOrSpaceSeparated,
  commaSeparated,
  number,
  overloadedBoolean,
  spaceSeparated
}, Symbol.toStringTag, { value: "Module" })), checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types$1)
);
class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(gA, AA, IA, BA) {
    let QA = -1;
    if (super(gA, AA), mark$1(this, "space", BA), typeof IA == "number")
      for (; ++QA < checks.length; ) {
        const EA = checks[QA];
        mark$1(this, checks[QA], (IA & types$1[EA]) === types$1[EA]);
      }
  }
}
DefinedInfo.prototype.defined = !0;
function mark$1(CA, gA, AA) {
  AA && (CA[gA] = AA);
}
function create(CA) {
  const gA = {}, AA = {};
  for (const [IA, BA] of Object.entries(CA.properties)) {
    const QA = new DefinedInfo(
      IA,
      CA.transform(CA.attributes || {}, IA),
      BA,
      CA.space
    );
    CA.mustUseProperty && CA.mustUseProperty.includes(IA) && (QA.mustUseProperty = !0), gA[IA] = QA, AA[normalize$1(IA)] = IA, AA[normalize$1(QA.attribute)] = IA;
  }
  return new Schema(gA, AA, CA.space);
}
const aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(CA, gA) {
    return gA === "role" ? gA : "aria-" + gA.slice(4).toLowerCase();
  }
});
function caseSensitiveTransform(CA, gA) {
  return gA in CA ? CA[gA] : gA;
}
function caseInsensitiveTransform(CA, gA) {
  return caseSensitiveTransform(CA, gA.toLowerCase());
}
const html$3 = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
}), svg$1 = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
}), xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(CA, gA) {
    return "xlink:" + gA.slice(5).toLowerCase();
  }
}), xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
}), xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(CA, gA) {
    return "xml:" + gA.slice(3).toLowerCase();
  }
}), hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, cap$1 = /[A-Z]/g, dash = /-[a-z]/g, valid = /^data[-\w.:]+$/i;
function find$1(CA, gA) {
  const AA = normalize$1(gA);
  let IA = gA, BA = Info;
  if (AA in CA.normal)
    return CA.property[CA.normal[AA]];
  if (AA.length > 4 && AA.slice(0, 4) === "data" && valid.test(gA)) {
    if (gA.charAt(4) === "-") {
      const QA = gA.slice(5).replace(dash, camelcase);
      IA = "data" + QA.charAt(0).toUpperCase() + QA.slice(1);
    } else {
      const QA = gA.slice(4);
      if (!dash.test(QA)) {
        let EA = QA.replace(cap$1, kebab);
        EA.charAt(0) !== "-" && (EA = "-" + EA), gA = "data" + EA;
      }
    }
    BA = DefinedInfo;
  }
  return new BA(IA, gA);
}
function kebab(CA) {
  return "-" + CA.toLowerCase();
}
function camelcase(CA) {
  return CA.charAt(1).toUpperCase();
}
const html$2 = merge([aria, html$3, xlink, xmlns, xml], "html"), svg = merge([aria, svg$1, xlink, xmlns, xml], "svg");
function parse$2(CA) {
  const gA = String(CA || "").trim();
  return gA ? gA.split(/[ \t\n\r\f]+/g) : [];
}
function stringify$1(CA) {
  return CA.join(" ").trim();
}
var cjs$2 = {}, cjs$1, hasRequiredCjs$2;
function requireCjs$2() {
  if (hasRequiredCjs$2) return cjs$1;
  hasRequiredCjs$2 = 1;
  var CA = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, gA = /\n/g, AA = /^\s*/, IA = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, BA = /^:\s*/, QA = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, EA = /^[;\s]*/, iA = /^\s+|\s+$/g, oA = `
`, cA = "/", tA = "*", eA = "", aA = "comment", GA = "declaration";
  function lA(DA, hA) {
    if (typeof DA != "string")
      throw new TypeError("First argument must be a string");
    if (!DA) return [];
    hA = hA || {};
    var wA = 1, sA = 1;
    function NA(SA) {
      var JA = SA.match(gA);
      JA && (wA += JA.length);
      var UA = SA.lastIndexOf(oA);
      sA = ~UA ? SA.length - UA : sA + SA.length;
    }
    function rA() {
      var SA = { line: wA, column: sA };
      return function(JA) {
        return JA.position = new yA(SA), FA(), JA;
      };
    }
    function yA(SA) {
      this.start = SA, this.end = { line: wA, column: sA }, this.source = hA.source;
    }
    yA.prototype.content = DA;
    function bA(SA) {
      var JA = new Error(
        hA.source + ":" + wA + ":" + sA + ": " + SA
      );
      if (JA.reason = SA, JA.filename = hA.source, JA.line = wA, JA.column = sA, JA.source = DA, !hA.silent) throw JA;
    }
    function RA(SA) {
      var JA = SA.exec(DA);
      if (JA) {
        var UA = JA[0];
        return NA(UA), DA = DA.slice(UA.length), JA;
      }
    }
    function FA() {
      RA(AA);
    }
    function dA(SA) {
      var JA;
      for (SA = SA || []; JA = kA(); )
        JA !== !1 && SA.push(JA);
      return SA;
    }
    function kA() {
      var SA = rA();
      if (!(cA != DA.charAt(0) || tA != DA.charAt(1))) {
        for (var JA = 2; eA != DA.charAt(JA) && (tA != DA.charAt(JA) || cA != DA.charAt(JA + 1)); )
          ++JA;
        if (JA += 2, eA === DA.charAt(JA - 1))
          return bA("End of comment missing");
        var UA = DA.slice(2, JA - 2);
        return sA += 2, NA(UA), DA = DA.slice(JA), sA += 2, SA({
          type: aA,
          comment: UA
        });
      }
    }
    function pA() {
      var SA = rA(), JA = RA(IA);
      if (JA) {
        if (kA(), !RA(BA)) return bA("property missing ':'");
        var UA = RA(QA), fA = SA({
          type: GA,
          property: nA(JA[0].replace(CA, eA)),
          value: UA ? nA(UA[0].replace(CA, eA)) : eA
        });
        return RA(EA), fA;
      }
    }
    function YA() {
      var SA = [];
      dA(SA);
      for (var JA; JA = pA(); )
        JA !== !1 && (SA.push(JA), dA(SA));
      return SA;
    }
    return FA(), YA();
  }
  function nA(DA) {
    return DA ? DA.replace(iA, eA) : eA;
  }
  return cjs$1 = lA, cjs$1;
}
var hasRequiredCjs$1;
function requireCjs$1() {
  if (hasRequiredCjs$1) return cjs$2;
  hasRequiredCjs$1 = 1;
  var CA = cjs$2 && cjs$2.__importDefault || function(IA) {
    return IA && IA.__esModule ? IA : { default: IA };
  };
  Object.defineProperty(cjs$2, "__esModule", { value: !0 }), cjs$2.default = AA;
  const gA = CA(requireCjs$2());
  function AA(IA, BA) {
    let QA = null;
    if (!IA || typeof IA != "string")
      return QA;
    const EA = (0, gA.default)(IA), iA = typeof BA == "function";
    return EA.forEach((oA) => {
      if (oA.type !== "declaration")
        return;
      const { property: cA, value: tA } = oA;
      iA ? BA(cA, tA, oA) : tA && (QA = QA || {}, QA[cA] = tA);
    }), QA;
  }
  return cjs$2;
}
var utilities = {}, hasRequiredUtilities;
function requireUtilities() {
  if (hasRequiredUtilities) return utilities;
  hasRequiredUtilities = 1, Object.defineProperty(utilities, "__esModule", { value: !0 }), utilities.camelCase = void 0;
  var CA = /^--[a-zA-Z0-9_-]+$/, gA = /-([a-z])/g, AA = /^[^-]+$/, IA = /^-(webkit|moz|ms|o|khtml)-/, BA = /^-(ms)-/, QA = function(cA) {
    return !cA || AA.test(cA) || CA.test(cA);
  }, EA = function(cA, tA) {
    return tA.toUpperCase();
  }, iA = function(cA, tA) {
    return "".concat(tA, "-");
  }, oA = function(cA, tA) {
    return tA === void 0 && (tA = {}), QA(cA) ? cA : (cA = cA.toLowerCase(), tA.reactCompat ? cA = cA.replace(BA, iA) : cA = cA.replace(IA, iA), cA.replace(gA, EA));
  };
  return utilities.camelCase = oA, utilities;
}
var cjs, hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var CA = cjs && cjs.__importDefault || function(BA) {
    return BA && BA.__esModule ? BA : { default: BA };
  }, gA = CA(requireCjs$1()), AA = requireUtilities();
  function IA(BA, QA) {
    var EA = {};
    return !BA || typeof BA != "string" || (0, gA.default)(BA, function(iA, oA) {
      iA && oA && (EA[(0, AA.camelCase)(iA, QA)] = oA);
    }), EA;
  }
  return IA.default = IA, cjs = IA, cjs;
}
var cjsExports = requireCjs();
const styleToJs = /* @__PURE__ */ getDefaultExportFromCjs(cjsExports), pointEnd = point$2("end"), pointStart = point$2("start");
function point$2(CA) {
  return gA;
  function gA(AA) {
    const IA = AA && AA.position && AA.position[CA] || {};
    if (typeof IA.line == "number" && IA.line > 0 && typeof IA.column == "number" && IA.column > 0)
      return {
        line: IA.line,
        column: IA.column,
        offset: typeof IA.offset == "number" && IA.offset > -1 ? IA.offset : void 0
      };
  }
}
function position$2(CA) {
  const gA = pointStart(CA), AA = pointEnd(CA);
  if (gA && AA)
    return { start: gA, end: AA };
}
function stringifyPosition(CA) {
  return !CA || typeof CA != "object" ? "" : "position" in CA || "type" in CA ? position$1(CA.position) : "start" in CA || "end" in CA ? position$1(CA) : "line" in CA || "column" in CA ? point$1(CA) : "";
}
function point$1(CA) {
  return index$1(CA && CA.line) + ":" + index$1(CA && CA.column);
}
function position$1(CA) {
  return point$1(CA && CA.start) + "-" + point$1(CA && CA.end);
}
function index$1(CA) {
  return CA && typeof CA == "number" ? CA : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(gA, AA, IA) {
    super(), typeof AA == "string" && (IA = AA, AA = void 0);
    let BA = "", QA = {}, EA = !1;
    if (AA && ("line" in AA && "column" in AA ? QA = { place: AA } : "start" in AA && "end" in AA ? QA = { place: AA } : "type" in AA ? QA = {
      ancestors: [AA],
      place: AA.position
    } : QA = { ...AA }), typeof gA == "string" ? BA = gA : !QA.cause && gA && (EA = !0, BA = gA.message, QA.cause = gA), !QA.ruleId && !QA.source && typeof IA == "string") {
      const oA = IA.indexOf(":");
      oA === -1 ? QA.ruleId = IA : (QA.source = IA.slice(0, oA), QA.ruleId = IA.slice(oA + 1));
    }
    if (!QA.place && QA.ancestors && QA.ancestors) {
      const oA = QA.ancestors[QA.ancestors.length - 1];
      oA && (QA.place = oA.position);
    }
    const iA = QA.place && "start" in QA.place ? QA.place.start : QA.place;
    this.ancestors = QA.ancestors || void 0, this.cause = QA.cause || void 0, this.column = iA ? iA.column : void 0, this.fatal = void 0, this.file = "", this.message = BA, this.line = iA ? iA.line : void 0, this.name = stringifyPosition(QA.place) || "1:1", this.place = QA.place || void 0, this.reason = this.message, this.ruleId = QA.ruleId || void 0, this.source = QA.source || void 0, this.stack = EA && QA.cause && typeof QA.cause.stack == "string" ? QA.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const own$4 = {}.hasOwnProperty, emptyMap = /* @__PURE__ */ new Map(), cap = /[A-Z]/g, tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), tableCellElement = /* @__PURE__ */ new Set(["td", "th"]), docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(CA, gA) {
  if (!gA || gA.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const AA = gA.filePath || void 0;
  let IA;
  if (gA.development) {
    if (typeof gA.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    IA = developmentCreate(AA, gA.jsxDEV);
  } else {
    if (typeof gA.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof gA.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    IA = productionCreate(AA, gA.jsx, gA.jsxs);
  }
  const BA = {
    Fragment: gA.Fragment,
    ancestors: [],
    components: gA.components || {},
    create: IA,
    elementAttributeNameCase: gA.elementAttributeNameCase || "react",
    evaluater: gA.createEvaluater ? gA.createEvaluater() : void 0,
    filePath: AA,
    ignoreInvalidStyle: gA.ignoreInvalidStyle || !1,
    passKeys: gA.passKeys !== !1,
    passNode: gA.passNode || !1,
    schema: gA.space === "svg" ? svg : html$2,
    stylePropertyNameCase: gA.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: gA.tableCellAlignToStyle !== !1
  }, QA = one$1(BA, CA, void 0);
  return QA && typeof QA != "string" ? QA : BA.create(
    CA,
    BA.Fragment,
    { children: QA || void 0 },
    void 0
  );
}
function one$1(CA, gA, AA) {
  if (gA.type === "element")
    return element$1(CA, gA, AA);
  if (gA.type === "mdxFlowExpression" || gA.type === "mdxTextExpression")
    return mdxExpression(CA, gA);
  if (gA.type === "mdxJsxFlowElement" || gA.type === "mdxJsxTextElement")
    return mdxJsxElement(CA, gA, AA);
  if (gA.type === "mdxjsEsm")
    return mdxEsm(CA, gA);
  if (gA.type === "root")
    return root$3(CA, gA, AA);
  if (gA.type === "text")
    return text$6(CA, gA);
}
function element$1(CA, gA, AA) {
  const IA = CA.schema;
  let BA = IA;
  gA.tagName.toLowerCase() === "svg" && IA.space === "html" && (BA = svg, CA.schema = BA), CA.ancestors.push(gA);
  const QA = findComponentFromName(CA, gA.tagName, !1), EA = createElementProps(CA, gA);
  let iA = createChildren(CA, gA);
  return tableElements.has(gA.tagName) && (iA = iA.filter(function(oA) {
    return typeof oA == "string" ? !whitespace(oA) : !0;
  })), addNode(CA, EA, QA, gA), addChildren(EA, iA), CA.ancestors.pop(), CA.schema = IA, CA.create(gA, QA, EA, AA);
}
function mdxExpression(CA, gA) {
  if (gA.data && gA.data.estree && CA.evaluater) {
    const IA = gA.data.estree.body[0];
    return IA.type, /** @type {Child | undefined} */
    CA.evaluater.evaluateExpression(IA.expression);
  }
  crashEstree(CA, gA.position);
}
function mdxEsm(CA, gA) {
  if (gA.data && gA.data.estree && CA.evaluater)
    return (
      /** @type {Child | undefined} */
      CA.evaluater.evaluateProgram(gA.data.estree)
    );
  crashEstree(CA, gA.position);
}
function mdxJsxElement(CA, gA, AA) {
  const IA = CA.schema;
  let BA = IA;
  gA.name === "svg" && IA.space === "html" && (BA = svg, CA.schema = BA), CA.ancestors.push(gA);
  const QA = gA.name === null ? CA.Fragment : findComponentFromName(CA, gA.name, !0), EA = createJsxElementProps(CA, gA), iA = createChildren(CA, gA);
  return addNode(CA, EA, QA, gA), addChildren(EA, iA), CA.ancestors.pop(), CA.schema = IA, CA.create(gA, QA, EA, AA);
}
function root$3(CA, gA, AA) {
  const IA = {};
  return addChildren(IA, createChildren(CA, gA)), CA.create(gA, CA.Fragment, IA, AA);
}
function text$6(CA, gA) {
  return gA.value;
}
function addNode(CA, gA, AA, IA) {
  typeof AA != "string" && AA !== CA.Fragment && CA.passNode && (gA.node = IA);
}
function addChildren(CA, gA) {
  if (gA.length > 0) {
    const AA = gA.length > 1 ? gA : gA[0];
    AA && (CA.children = AA);
  }
}
function productionCreate(CA, gA, AA) {
  return IA;
  function IA(BA, QA, EA, iA) {
    const cA = Array.isArray(EA.children) ? AA : gA;
    return iA ? cA(QA, EA, iA) : cA(QA, EA);
  }
}
function developmentCreate(CA, gA) {
  return AA;
  function AA(IA, BA, QA, EA) {
    const iA = Array.isArray(QA.children), oA = pointStart(IA);
    return gA(
      BA,
      QA,
      EA,
      iA,
      {
        columnNumber: oA ? oA.column - 1 : void 0,
        fileName: CA,
        lineNumber: oA ? oA.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(CA, gA) {
  const AA = {};
  let IA, BA;
  for (BA in gA.properties)
    if (BA !== "children" && own$4.call(gA.properties, BA)) {
      const QA = createProperty(CA, BA, gA.properties[BA]);
      if (QA) {
        const [EA, iA] = QA;
        CA.tableCellAlignToStyle && EA === "align" && typeof iA == "string" && tableCellElement.has(gA.tagName) ? IA = iA : AA[EA] = iA;
      }
    }
  if (IA) {
    const QA = (
      /** @type {Style} */
      AA.style || (AA.style = {})
    );
    QA[CA.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = IA;
  }
  return AA;
}
function createJsxElementProps(CA, gA) {
  const AA = {};
  for (const IA of gA.attributes)
    if (IA.type === "mdxJsxExpressionAttribute")
      if (IA.data && IA.data.estree && CA.evaluater) {
        const QA = IA.data.estree.body[0];
        QA.type;
        const EA = QA.expression;
        EA.type;
        const iA = EA.properties[0];
        iA.type, Object.assign(
          AA,
          CA.evaluater.evaluateExpression(iA.argument)
        );
      } else
        crashEstree(CA, gA.position);
    else {
      const BA = IA.name;
      let QA;
      if (IA.value && typeof IA.value == "object")
        if (IA.value.data && IA.value.data.estree && CA.evaluater) {
          const iA = IA.value.data.estree.body[0];
          iA.type, QA = CA.evaluater.evaluateExpression(iA.expression);
        } else
          crashEstree(CA, gA.position);
      else
        QA = IA.value === null ? !0 : IA.value;
      AA[BA] = /** @type {Props[keyof Props]} */
      QA;
    }
  return AA;
}
function createChildren(CA, gA) {
  const AA = [];
  let IA = -1;
  const BA = CA.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  for (; ++IA < gA.children.length; ) {
    const QA = gA.children[IA];
    let EA;
    if (CA.passKeys) {
      const oA = QA.type === "element" ? QA.tagName : QA.type === "mdxJsxFlowElement" || QA.type === "mdxJsxTextElement" ? QA.name : void 0;
      if (oA) {
        const cA = BA.get(oA) || 0;
        EA = oA + "-" + cA, BA.set(oA, cA + 1);
      }
    }
    const iA = one$1(CA, QA, EA);
    iA !== void 0 && AA.push(iA);
  }
  return AA;
}
function createProperty(CA, gA, AA) {
  const IA = find$1(CA.schema, gA);
  if (!(AA == null || typeof AA == "number" && Number.isNaN(AA))) {
    if (Array.isArray(AA) && (AA = IA.commaSeparated ? stringify$2(AA) : stringify$1(AA)), IA.property === "style") {
      let BA = typeof AA == "object" ? AA : parseStyle(CA, String(AA));
      return CA.stylePropertyNameCase === "css" && (BA = transformStylesToCssCasing(BA)), ["style", BA];
    }
    return [
      CA.elementAttributeNameCase === "react" && IA.space ? hastToReact[IA.property] || IA.property : IA.attribute,
      AA
    ];
  }
}
function parseStyle(CA, gA) {
  try {
    return styleToJs(gA, { reactCompat: !0 });
  } catch (AA) {
    if (CA.ignoreInvalidStyle)
      return {};
    const IA = (
      /** @type {Error} */
      AA
    ), BA = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: CA.ancestors,
      cause: IA,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw BA.file = CA.filePath || void 0, BA.url = docs + "#cannot-parse-style-attribute", BA;
  }
}
function findComponentFromName(CA, gA, AA) {
  let IA;
  if (!AA)
    IA = { type: "Literal", value: gA };
  else if (gA.includes(".")) {
    const BA = gA.split(".");
    let QA = -1, EA;
    for (; ++QA < BA.length; ) {
      const iA = name(BA[QA]) ? { type: "Identifier", name: BA[QA] } : { type: "Literal", value: BA[QA] };
      EA = EA ? {
        type: "MemberExpression",
        object: EA,
        property: iA,
        computed: !!(QA && iA.type === "Literal"),
        optional: !1
      } : iA;
    }
    IA = EA;
  } else
    IA = name(gA) && !/^[a-z]/.test(gA) ? { type: "Identifier", name: gA } : { type: "Literal", value: gA };
  if (IA.type === "Literal") {
    const BA = (
      /** @type {string | number} */
      IA.value
    );
    return own$4.call(CA.components, BA) ? CA.components[BA] : BA;
  }
  if (CA.evaluater)
    return CA.evaluater.evaluateExpression(IA);
  crashEstree(CA);
}
function crashEstree(CA, gA) {
  const AA = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: CA.ancestors,
      place: gA,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw AA.file = CA.filePath || void 0, AA.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater", AA;
}
function transformStylesToCssCasing(CA) {
  const gA = {};
  let AA;
  for (AA in CA)
    own$4.call(CA, AA) && (gA[transformStyleToCssCasing(AA)] = CA[AA]);
  return gA;
}
function transformStyleToCssCasing(CA) {
  let gA = CA.replace(cap, toDash);
  return gA.slice(0, 3) === "ms-" && (gA = "-" + gA), gA;
}
function toDash(CA) {
  return "-" + CA.toLowerCase();
}
const urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, emptyOptions$4 = {};
function toString$2(CA, gA) {
  const AA = emptyOptions$4, IA = typeof AA.includeImageAlt == "boolean" ? AA.includeImageAlt : !0, BA = typeof AA.includeHtml == "boolean" ? AA.includeHtml : !0;
  return one(CA, IA, BA);
}
function one(CA, gA, AA) {
  if (node(CA)) {
    if ("value" in CA)
      return CA.type === "html" && !AA ? "" : CA.value;
    if (gA && "alt" in CA && CA.alt)
      return CA.alt;
    if ("children" in CA)
      return all(CA.children, gA, AA);
  }
  return Array.isArray(CA) ? all(CA, gA, AA) : "";
}
function all(CA, gA, AA) {
  const IA = [];
  let BA = -1;
  for (; ++BA < CA.length; )
    IA[BA] = one(CA[BA], gA, AA);
  return IA.join("");
}
function node(CA) {
  return !!(CA && typeof CA == "object");
}
const element = document.createElement("i");
function decodeNamedCharacterReference(CA) {
  const gA = "&" + CA + ";";
  element.innerHTML = gA;
  const AA = element.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    AA.charCodeAt(AA.length - 1) === 59 && CA !== "semi" || AA === gA ? !1 : AA
  );
}
function splice(CA, gA, AA, IA) {
  const BA = CA.length;
  let QA = 0, EA;
  if (gA < 0 ? gA = -gA > BA ? 0 : BA + gA : gA = gA > BA ? BA : gA, AA = AA > 0 ? AA : 0, IA.length < 1e4)
    EA = Array.from(IA), EA.unshift(gA, AA), CA.splice(...EA);
  else
    for (AA && CA.splice(gA, AA); QA < IA.length; )
      EA = IA.slice(QA, QA + 1e4), EA.unshift(gA, 0), CA.splice(...EA), QA += 1e4, gA += 1e4;
}
function push(CA, gA) {
  return CA.length > 0 ? (splice(CA, CA.length, 0, gA), CA) : gA;
}
const hasOwnProperty = {}.hasOwnProperty;
function combineExtensions(CA) {
  const gA = {};
  let AA = -1;
  for (; ++AA < CA.length; )
    syntaxExtension(gA, CA[AA]);
  return gA;
}
function syntaxExtension(CA, gA) {
  let AA;
  for (AA in gA) {
    const BA = (hasOwnProperty.call(CA, AA) ? CA[AA] : void 0) || (CA[AA] = {}), QA = gA[AA];
    let EA;
    if (QA)
      for (EA in QA) {
        hasOwnProperty.call(BA, EA) || (BA[EA] = []);
        const iA = QA[EA];
        constructs(
          // @ts-expect-error Looks like a list.
          BA[EA],
          Array.isArray(iA) ? iA : iA ? [iA] : []
        );
      }
  }
}
function constructs(CA, gA) {
  let AA = -1;
  const IA = [];
  for (; ++AA < gA.length; )
    (gA[AA].add === "after" ? CA : IA).push(gA[AA]);
  splice(CA, 0, 0, IA);
}
function decodeNumericCharacterReference(CA, gA) {
  const AA = Number.parseInt(CA, gA);
  return (
    // C0 except for HT, LF, FF, CR, space.
    AA < 9 || AA === 11 || AA > 13 && AA < 32 || // Control character (DEL) of C0, and C1 controls.
    AA > 126 && AA < 160 || // Lone high surrogates and low surrogates.
    AA > 55295 && AA < 57344 || // Noncharacters.
    AA > 64975 && AA < 65008 || /* eslint-disable no-bitwise */
    (AA & 65535) === 65535 || (AA & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    AA > 1114111 ? "�" : String.fromCodePoint(AA)
  );
}
function normalizeIdentifier(CA) {
  return CA.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/), asciiAlphanumeric = regexCheck(/[\dA-Za-z]/), asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(CA) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    CA !== null && (CA < 32 || CA === 127)
  );
}
const asciiDigit = regexCheck(/\d/), asciiHexDigit = regexCheck(/[\dA-Fa-f]/), asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(CA) {
  return CA !== null && CA < -2;
}
function markdownLineEndingOrSpace(CA) {
  return CA !== null && (CA < 0 || CA === 32);
}
function markdownSpace(CA) {
  return CA === -2 || CA === -1 || CA === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u")), unicodeWhitespace = regexCheck(/\s/);
function regexCheck(CA) {
  return gA;
  function gA(AA) {
    return AA !== null && AA > -1 && CA.test(String.fromCharCode(AA));
  }
}
function normalizeUri(CA) {
  const gA = [];
  let AA = -1, IA = 0, BA = 0;
  for (; ++AA < CA.length; ) {
    const QA = CA.charCodeAt(AA);
    let EA = "";
    if (QA === 37 && asciiAlphanumeric(CA.charCodeAt(AA + 1)) && asciiAlphanumeric(CA.charCodeAt(AA + 2)))
      BA = 2;
    else if (QA < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(QA)) || (EA = String.fromCharCode(QA));
    else if (QA > 55295 && QA < 57344) {
      const iA = CA.charCodeAt(AA + 1);
      QA < 56320 && iA > 56319 && iA < 57344 ? (EA = String.fromCharCode(QA, iA), BA = 1) : EA = "�";
    } else
      EA = String.fromCharCode(QA);
    EA && (gA.push(CA.slice(IA, AA), encodeURIComponent(EA)), IA = AA + BA + 1, EA = ""), BA && (AA += BA, BA = 0);
  }
  return gA.join("") + CA.slice(IA);
}
function factorySpace(CA, gA, AA, IA) {
  const BA = IA ? IA - 1 : Number.POSITIVE_INFINITY;
  let QA = 0;
  return EA;
  function EA(oA) {
    return markdownSpace(oA) ? (CA.enter(AA), iA(oA)) : gA(oA);
  }
  function iA(oA) {
    return markdownSpace(oA) && QA++ < BA ? (CA.consume(oA), iA) : (CA.exit(AA), gA(oA));
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(CA) {
  const gA = CA.attempt(this.parser.constructs.contentInitial, IA, BA);
  let AA;
  return gA;
  function IA(iA) {
    if (iA === null) {
      CA.consume(iA);
      return;
    }
    return CA.enter("lineEnding"), CA.consume(iA), CA.exit("lineEnding"), factorySpace(CA, gA, "linePrefix");
  }
  function BA(iA) {
    return CA.enter("paragraph"), QA(iA);
  }
  function QA(iA) {
    const oA = CA.enter("chunkText", {
      contentType: "text",
      previous: AA
    });
    return AA && (AA.next = oA), AA = oA, EA(iA);
  }
  function EA(iA) {
    if (iA === null) {
      CA.exit("chunkText"), CA.exit("paragraph"), CA.consume(iA);
      return;
    }
    return markdownLineEnding(iA) ? (CA.consume(iA), CA.exit("chunkText"), QA) : (CA.consume(iA), EA);
  }
}
const document$2 = {
  tokenize: initializeDocument
}, containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(CA) {
  const gA = this, AA = [];
  let IA = 0, BA, QA, EA;
  return iA;
  function iA(sA) {
    if (IA < AA.length) {
      const NA = AA[IA];
      return gA.containerState = NA[1], CA.attempt(NA[0].continuation, oA, cA)(sA);
    }
    return cA(sA);
  }
  function oA(sA) {
    if (IA++, gA.containerState._closeFlow) {
      gA.containerState._closeFlow = void 0, BA && wA();
      const NA = gA.events.length;
      let rA = NA, yA;
      for (; rA--; )
        if (gA.events[rA][0] === "exit" && gA.events[rA][1].type === "chunkFlow") {
          yA = gA.events[rA][1].end;
          break;
        }
      hA(IA);
      let bA = NA;
      for (; bA < gA.events.length; )
        gA.events[bA][1].end = {
          ...yA
        }, bA++;
      return splice(gA.events, rA + 1, 0, gA.events.slice(NA)), gA.events.length = bA, cA(sA);
    }
    return iA(sA);
  }
  function cA(sA) {
    if (IA === AA.length) {
      if (!BA)
        return aA(sA);
      if (BA.currentConstruct && BA.currentConstruct.concrete)
        return lA(sA);
      gA.interrupt = !!(BA.currentConstruct && !BA._gfmTableDynamicInterruptHack);
    }
    return gA.containerState = {}, CA.check(containerConstruct, tA, eA)(sA);
  }
  function tA(sA) {
    return BA && wA(), hA(IA), aA(sA);
  }
  function eA(sA) {
    return gA.parser.lazy[gA.now().line] = IA !== AA.length, EA = gA.now().offset, lA(sA);
  }
  function aA(sA) {
    return gA.containerState = {}, CA.attempt(containerConstruct, GA, lA)(sA);
  }
  function GA(sA) {
    return IA++, AA.push([gA.currentConstruct, gA.containerState]), aA(sA);
  }
  function lA(sA) {
    if (sA === null) {
      BA && wA(), hA(0), CA.consume(sA);
      return;
    }
    return BA = BA || gA.parser.flow(gA.now()), CA.enter("chunkFlow", {
      _tokenizer: BA,
      contentType: "flow",
      previous: QA
    }), nA(sA);
  }
  function nA(sA) {
    if (sA === null) {
      DA(CA.exit("chunkFlow"), !0), hA(0), CA.consume(sA);
      return;
    }
    return markdownLineEnding(sA) ? (CA.consume(sA), DA(CA.exit("chunkFlow")), IA = 0, gA.interrupt = void 0, iA) : (CA.consume(sA), nA);
  }
  function DA(sA, NA) {
    const rA = gA.sliceStream(sA);
    if (NA && rA.push(null), sA.previous = QA, QA && (QA.next = sA), QA = sA, BA.defineSkip(sA.start), BA.write(rA), gA.parser.lazy[sA.start.line]) {
      let yA = BA.events.length;
      for (; yA--; )
        if (
          // The token starts before the line ending…
          BA.events[yA][1].start.offset < EA && // …and either is not ended yet…
          (!BA.events[yA][1].end || // …or ends after it.
          BA.events[yA][1].end.offset > EA)
        )
          return;
      const bA = gA.events.length;
      let RA = bA, FA, dA;
      for (; RA--; )
        if (gA.events[RA][0] === "exit" && gA.events[RA][1].type === "chunkFlow") {
          if (FA) {
            dA = gA.events[RA][1].end;
            break;
          }
          FA = !0;
        }
      for (hA(IA), yA = bA; yA < gA.events.length; )
        gA.events[yA][1].end = {
          ...dA
        }, yA++;
      splice(gA.events, RA + 1, 0, gA.events.slice(bA)), gA.events.length = yA;
    }
  }
  function hA(sA) {
    let NA = AA.length;
    for (; NA-- > sA; ) {
      const rA = AA[NA];
      gA.containerState = rA[1], rA[0].exit.call(gA, CA);
    }
    AA.length = sA;
  }
  function wA() {
    BA.write([null]), QA = void 0, BA = void 0, gA.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(CA, gA, AA) {
  return factorySpace(CA, CA.attempt(this.parser.constructs.document, gA, AA), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(CA) {
  if (CA === null || markdownLineEndingOrSpace(CA) || unicodeWhitespace(CA))
    return 1;
  if (unicodePunctuation(CA))
    return 2;
}
function resolveAll(CA, gA, AA) {
  const IA = [];
  let BA = -1;
  for (; ++BA < CA.length; ) {
    const QA = CA[BA].resolveAll;
    QA && !IA.includes(QA) && (gA = QA(gA, AA), IA.push(QA));
  }
  return gA;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(CA, gA) {
  let AA = -1, IA, BA, QA, EA, iA, oA, cA, tA;
  for (; ++AA < CA.length; )
    if (CA[AA][0] === "enter" && CA[AA][1].type === "attentionSequence" && CA[AA][1]._close) {
      for (IA = AA; IA--; )
        if (CA[IA][0] === "exit" && CA[IA][1].type === "attentionSequence" && CA[IA][1]._open && // If the markers are the same:
        gA.sliceSerialize(CA[IA][1]).charCodeAt(0) === gA.sliceSerialize(CA[AA][1]).charCodeAt(0)) {
          if ((CA[IA][1]._close || CA[AA][1]._open) && (CA[AA][1].end.offset - CA[AA][1].start.offset) % 3 && !((CA[IA][1].end.offset - CA[IA][1].start.offset + CA[AA][1].end.offset - CA[AA][1].start.offset) % 3))
            continue;
          oA = CA[IA][1].end.offset - CA[IA][1].start.offset > 1 && CA[AA][1].end.offset - CA[AA][1].start.offset > 1 ? 2 : 1;
          const eA = {
            ...CA[IA][1].end
          }, aA = {
            ...CA[AA][1].start
          };
          movePoint(eA, -oA), movePoint(aA, oA), EA = {
            type: oA > 1 ? "strongSequence" : "emphasisSequence",
            start: eA,
            end: {
              ...CA[IA][1].end
            }
          }, iA = {
            type: oA > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...CA[AA][1].start
            },
            end: aA
          }, QA = {
            type: oA > 1 ? "strongText" : "emphasisText",
            start: {
              ...CA[IA][1].end
            },
            end: {
              ...CA[AA][1].start
            }
          }, BA = {
            type: oA > 1 ? "strong" : "emphasis",
            start: {
              ...EA.start
            },
            end: {
              ...iA.end
            }
          }, CA[IA][1].end = {
            ...EA.start
          }, CA[AA][1].start = {
            ...iA.end
          }, cA = [], CA[IA][1].end.offset - CA[IA][1].start.offset && (cA = push(cA, [["enter", CA[IA][1], gA], ["exit", CA[IA][1], gA]])), cA = push(cA, [["enter", BA, gA], ["enter", EA, gA], ["exit", EA, gA], ["enter", QA, gA]]), cA = push(cA, resolveAll(gA.parser.constructs.insideSpan.null, CA.slice(IA + 1, AA), gA)), cA = push(cA, [["exit", QA, gA], ["enter", iA, gA], ["exit", iA, gA], ["exit", BA, gA]]), CA[AA][1].end.offset - CA[AA][1].start.offset ? (tA = 2, cA = push(cA, [["enter", CA[AA][1], gA], ["exit", CA[AA][1], gA]])) : tA = 0, splice(CA, IA - 1, AA - IA + 3, cA), AA = IA + cA.length - tA - 2;
          break;
        }
    }
  for (AA = -1; ++AA < CA.length; )
    CA[AA][1].type === "attentionSequence" && (CA[AA][1].type = "data");
  return CA;
}
function tokenizeAttention(CA, gA) {
  const AA = this.parser.constructs.attentionMarkers.null, IA = this.previous, BA = classifyCharacter(IA);
  let QA;
  return EA;
  function EA(oA) {
    return QA = oA, CA.enter("attentionSequence"), iA(oA);
  }
  function iA(oA) {
    if (oA === QA)
      return CA.consume(oA), iA;
    const cA = CA.exit("attentionSequence"), tA = classifyCharacter(oA), eA = !tA || tA === 2 && BA || AA.includes(oA), aA = !BA || BA === 2 && tA || AA.includes(IA);
    return cA._open = !!(QA === 42 ? eA : eA && (BA || !aA)), cA._close = !!(QA === 42 ? aA : aA && (tA || !eA)), gA(oA);
  }
}
function movePoint(CA, gA) {
  CA.column += gA, CA.offset += gA, CA._bufferIndex += gA;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(CA, gA, AA) {
  let IA = 0;
  return BA;
  function BA(GA) {
    return CA.enter("autolink"), CA.enter("autolinkMarker"), CA.consume(GA), CA.exit("autolinkMarker"), CA.enter("autolinkProtocol"), QA;
  }
  function QA(GA) {
    return asciiAlpha(GA) ? (CA.consume(GA), EA) : GA === 64 ? AA(GA) : cA(GA);
  }
  function EA(GA) {
    return GA === 43 || GA === 45 || GA === 46 || asciiAlphanumeric(GA) ? (IA = 1, iA(GA)) : cA(GA);
  }
  function iA(GA) {
    return GA === 58 ? (CA.consume(GA), IA = 0, oA) : (GA === 43 || GA === 45 || GA === 46 || asciiAlphanumeric(GA)) && IA++ < 32 ? (CA.consume(GA), iA) : (IA = 0, cA(GA));
  }
  function oA(GA) {
    return GA === 62 ? (CA.exit("autolinkProtocol"), CA.enter("autolinkMarker"), CA.consume(GA), CA.exit("autolinkMarker"), CA.exit("autolink"), gA) : GA === null || GA === 32 || GA === 60 || asciiControl(GA) ? AA(GA) : (CA.consume(GA), oA);
  }
  function cA(GA) {
    return GA === 64 ? (CA.consume(GA), tA) : asciiAtext(GA) ? (CA.consume(GA), cA) : AA(GA);
  }
  function tA(GA) {
    return asciiAlphanumeric(GA) ? eA(GA) : AA(GA);
  }
  function eA(GA) {
    return GA === 46 ? (CA.consume(GA), IA = 0, tA) : GA === 62 ? (CA.exit("autolinkProtocol").type = "autolinkEmail", CA.enter("autolinkMarker"), CA.consume(GA), CA.exit("autolinkMarker"), CA.exit("autolink"), gA) : aA(GA);
  }
  function aA(GA) {
    if ((GA === 45 || asciiAlphanumeric(GA)) && IA++ < 63) {
      const lA = GA === 45 ? aA : eA;
      return CA.consume(GA), lA;
    }
    return AA(GA);
  }
}
const blankLine = {
  partial: !0,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(CA, gA, AA) {
  return IA;
  function IA(QA) {
    return markdownSpace(QA) ? factorySpace(CA, BA, "linePrefix")(QA) : BA(QA);
  }
  function BA(QA) {
    return QA === null || markdownLineEnding(QA) ? gA(QA) : AA(QA);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$2,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    if (EA === 62) {
      const iA = IA.containerState;
      return iA.open || (CA.enter("blockQuote", {
        _container: !0
      }), iA.open = !0), CA.enter("blockQuotePrefix"), CA.enter("blockQuoteMarker"), CA.consume(EA), CA.exit("blockQuoteMarker"), QA;
    }
    return AA(EA);
  }
  function QA(EA) {
    return markdownSpace(EA) ? (CA.enter("blockQuotePrefixWhitespace"), CA.consume(EA), CA.exit("blockQuotePrefixWhitespace"), CA.exit("blockQuotePrefix"), gA) : (CA.exit("blockQuotePrefix"), gA(EA));
  }
}
function tokenizeBlockQuoteContinuation(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return markdownSpace(EA) ? factorySpace(CA, QA, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(EA) : QA(EA);
  }
  function QA(EA) {
    return CA.attempt(blockQuote, gA, AA)(EA);
  }
}
function exit$2(CA) {
  CA.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(CA, gA, AA) {
  return IA;
  function IA(QA) {
    return CA.enter("characterEscape"), CA.enter("escapeMarker"), CA.consume(QA), CA.exit("escapeMarker"), BA;
  }
  function BA(QA) {
    return asciiPunctuation(QA) ? (CA.enter("characterEscapeValue"), CA.consume(QA), CA.exit("characterEscapeValue"), CA.exit("characterEscape"), gA) : AA(QA);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(CA, gA, AA) {
  const IA = this;
  let BA = 0, QA, EA;
  return iA;
  function iA(eA) {
    return CA.enter("characterReference"), CA.enter("characterReferenceMarker"), CA.consume(eA), CA.exit("characterReferenceMarker"), oA;
  }
  function oA(eA) {
    return eA === 35 ? (CA.enter("characterReferenceMarkerNumeric"), CA.consume(eA), CA.exit("characterReferenceMarkerNumeric"), cA) : (CA.enter("characterReferenceValue"), QA = 31, EA = asciiAlphanumeric, tA(eA));
  }
  function cA(eA) {
    return eA === 88 || eA === 120 ? (CA.enter("characterReferenceMarkerHexadecimal"), CA.consume(eA), CA.exit("characterReferenceMarkerHexadecimal"), CA.enter("characterReferenceValue"), QA = 6, EA = asciiHexDigit, tA) : (CA.enter("characterReferenceValue"), QA = 7, EA = asciiDigit, tA(eA));
  }
  function tA(eA) {
    if (eA === 59 && BA) {
      const aA = CA.exit("characterReferenceValue");
      return EA === asciiAlphanumeric && !decodeNamedCharacterReference(IA.sliceSerialize(aA)) ? AA(eA) : (CA.enter("characterReferenceMarker"), CA.consume(eA), CA.exit("characterReferenceMarker"), CA.exit("characterReference"), gA);
    }
    return EA(eA) && BA++ < QA ? (CA.consume(eA), tA) : AA(eA);
  }
}
const nonLazyContinuation$1 = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuation$1
}, codeFenced = {
  concrete: !0,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(CA, gA, AA) {
  const IA = this, BA = {
    partial: !0,
    tokenize: rA
  };
  let QA = 0, EA = 0, iA;
  return oA;
  function oA(yA) {
    return cA(yA);
  }
  function cA(yA) {
    const bA = IA.events[IA.events.length - 1];
    return QA = bA && bA[1].type === "linePrefix" ? bA[2].sliceSerialize(bA[1], !0).length : 0, iA = yA, CA.enter("codeFenced"), CA.enter("codeFencedFence"), CA.enter("codeFencedFenceSequence"), tA(yA);
  }
  function tA(yA) {
    return yA === iA ? (EA++, CA.consume(yA), tA) : EA < 3 ? AA(yA) : (CA.exit("codeFencedFenceSequence"), markdownSpace(yA) ? factorySpace(CA, eA, "whitespace")(yA) : eA(yA));
  }
  function eA(yA) {
    return yA === null || markdownLineEnding(yA) ? (CA.exit("codeFencedFence"), IA.interrupt ? gA(yA) : CA.check(nonLazyContinuation$1, nA, NA)(yA)) : (CA.enter("codeFencedFenceInfo"), CA.enter("chunkString", {
      contentType: "string"
    }), aA(yA));
  }
  function aA(yA) {
    return yA === null || markdownLineEnding(yA) ? (CA.exit("chunkString"), CA.exit("codeFencedFenceInfo"), eA(yA)) : markdownSpace(yA) ? (CA.exit("chunkString"), CA.exit("codeFencedFenceInfo"), factorySpace(CA, GA, "whitespace")(yA)) : yA === 96 && yA === iA ? AA(yA) : (CA.consume(yA), aA);
  }
  function GA(yA) {
    return yA === null || markdownLineEnding(yA) ? eA(yA) : (CA.enter("codeFencedFenceMeta"), CA.enter("chunkString", {
      contentType: "string"
    }), lA(yA));
  }
  function lA(yA) {
    return yA === null || markdownLineEnding(yA) ? (CA.exit("chunkString"), CA.exit("codeFencedFenceMeta"), eA(yA)) : yA === 96 && yA === iA ? AA(yA) : (CA.consume(yA), lA);
  }
  function nA(yA) {
    return CA.attempt(BA, NA, DA)(yA);
  }
  function DA(yA) {
    return CA.enter("lineEnding"), CA.consume(yA), CA.exit("lineEnding"), hA;
  }
  function hA(yA) {
    return QA > 0 && markdownSpace(yA) ? factorySpace(CA, wA, "linePrefix", QA + 1)(yA) : wA(yA);
  }
  function wA(yA) {
    return yA === null || markdownLineEnding(yA) ? CA.check(nonLazyContinuation$1, nA, NA)(yA) : (CA.enter("codeFlowValue"), sA(yA));
  }
  function sA(yA) {
    return yA === null || markdownLineEnding(yA) ? (CA.exit("codeFlowValue"), wA(yA)) : (CA.consume(yA), sA);
  }
  function NA(yA) {
    return CA.exit("codeFenced"), gA(yA);
  }
  function rA(yA, bA, RA) {
    let FA = 0;
    return dA;
    function dA(JA) {
      return yA.enter("lineEnding"), yA.consume(JA), yA.exit("lineEnding"), kA;
    }
    function kA(JA) {
      return yA.enter("codeFencedFence"), markdownSpace(JA) ? factorySpace(yA, pA, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(JA) : pA(JA);
    }
    function pA(JA) {
      return JA === iA ? (yA.enter("codeFencedFenceSequence"), YA(JA)) : RA(JA);
    }
    function YA(JA) {
      return JA === iA ? (FA++, yA.consume(JA), YA) : FA >= EA ? (yA.exit("codeFencedFenceSequence"), markdownSpace(JA) ? factorySpace(yA, SA, "whitespace")(JA) : SA(JA)) : RA(JA);
    }
    function SA(JA) {
      return JA === null || markdownLineEnding(JA) ? (yA.exit("codeFencedFence"), bA(JA)) : RA(JA);
    }
  }
}
function tokenizeNonLazyContinuation$1(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return EA === null ? AA(EA) : (CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), QA);
  }
  function QA(EA) {
    return IA.parser.lazy[IA.now().line] ? AA(EA) : gA(EA);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
}, furtherStart = {
  partial: !0,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(cA) {
    return CA.enter("codeIndented"), factorySpace(CA, QA, "linePrefix", 5)(cA);
  }
  function QA(cA) {
    const tA = IA.events[IA.events.length - 1];
    return tA && tA[1].type === "linePrefix" && tA[2].sliceSerialize(tA[1], !0).length >= 4 ? EA(cA) : AA(cA);
  }
  function EA(cA) {
    return cA === null ? oA(cA) : markdownLineEnding(cA) ? CA.attempt(furtherStart, EA, oA)(cA) : (CA.enter("codeFlowValue"), iA(cA));
  }
  function iA(cA) {
    return cA === null || markdownLineEnding(cA) ? (CA.exit("codeFlowValue"), EA(cA)) : (CA.consume(cA), iA);
  }
  function oA(cA) {
    return CA.exit("codeIndented"), gA(cA);
  }
}
function tokenizeFurtherStart(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return IA.parser.lazy[IA.now().line] ? AA(EA) : markdownLineEnding(EA) ? (CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), BA) : factorySpace(CA, QA, "linePrefix", 5)(EA);
  }
  function QA(EA) {
    const iA = IA.events[IA.events.length - 1];
    return iA && iA[1].type === "linePrefix" && iA[2].sliceSerialize(iA[1], !0).length >= 4 ? gA(EA) : markdownLineEnding(EA) ? BA(EA) : AA(EA);
  }
}
const codeText = {
  name: "codeText",
  previous: previous$3,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(CA) {
  let gA = CA.length - 4, AA = 3, IA, BA;
  if ((CA[AA][1].type === "lineEnding" || CA[AA][1].type === "space") && (CA[gA][1].type === "lineEnding" || CA[gA][1].type === "space")) {
    for (IA = AA; ++IA < gA; )
      if (CA[IA][1].type === "codeTextData") {
        CA[AA][1].type = "codeTextPadding", CA[gA][1].type = "codeTextPadding", AA += 2, gA -= 2;
        break;
      }
  }
  for (IA = AA - 1, gA++; ++IA <= gA; )
    BA === void 0 ? IA !== gA && CA[IA][1].type !== "lineEnding" && (BA = IA) : (IA === gA || CA[IA][1].type === "lineEnding") && (CA[BA][1].type = "codeTextData", IA !== BA + 2 && (CA[BA][1].end = CA[IA - 1][1].end, CA.splice(BA + 2, IA - BA - 2), gA -= IA - BA - 2, IA = BA + 2), BA = void 0);
  return CA;
}
function previous$3(CA) {
  return CA !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(CA, gA, AA) {
  let IA = 0, BA, QA;
  return EA;
  function EA(eA) {
    return CA.enter("codeText"), CA.enter("codeTextSequence"), iA(eA);
  }
  function iA(eA) {
    return eA === 96 ? (CA.consume(eA), IA++, iA) : (CA.exit("codeTextSequence"), oA(eA));
  }
  function oA(eA) {
    return eA === null ? AA(eA) : eA === 32 ? (CA.enter("space"), CA.consume(eA), CA.exit("space"), oA) : eA === 96 ? (QA = CA.enter("codeTextSequence"), BA = 0, tA(eA)) : markdownLineEnding(eA) ? (CA.enter("lineEnding"), CA.consume(eA), CA.exit("lineEnding"), oA) : (CA.enter("codeTextData"), cA(eA));
  }
  function cA(eA) {
    return eA === null || eA === 32 || eA === 96 || markdownLineEnding(eA) ? (CA.exit("codeTextData"), oA(eA)) : (CA.consume(eA), cA);
  }
  function tA(eA) {
    return eA === 96 ? (CA.consume(eA), BA++, tA) : BA === IA ? (CA.exit("codeTextSequence"), CA.exit("codeText"), gA(eA)) : (QA.type = "codeTextData", cA(eA));
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(gA) {
    this.left = gA ? [...gA] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(gA) {
    if (gA < 0 || gA >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + gA + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return gA < this.left.length ? this.left[gA] : this.right[this.right.length - gA + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(gA, AA) {
    const IA = AA ?? Number.POSITIVE_INFINITY;
    return IA < this.left.length ? this.left.slice(gA, IA) : gA > this.left.length ? this.right.slice(this.right.length - IA + this.left.length, this.right.length - gA + this.left.length).reverse() : this.left.slice(gA).concat(this.right.slice(this.right.length - IA + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(gA, AA, IA) {
    const BA = AA || 0;
    this.setCursor(Math.trunc(gA));
    const QA = this.right.splice(this.right.length - BA, Number.POSITIVE_INFINITY);
    return IA && chunkedPush(this.left, IA), QA.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(gA) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(gA);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(gA) {
    this.setCursor(Number.POSITIVE_INFINITY), chunkedPush(this.left, gA);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(gA) {
    this.setCursor(0), this.right.push(gA);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(gA) {
    this.setCursor(0), chunkedPush(this.right, gA.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(gA) {
    if (!(gA === this.left.length || gA > this.left.length && this.right.length === 0 || gA < 0 && this.left.length === 0))
      if (gA < this.left.length) {
        const AA = this.left.splice(gA, Number.POSITIVE_INFINITY);
        chunkedPush(this.right, AA.reverse());
      } else {
        const AA = this.right.splice(this.left.length + this.right.length - gA, Number.POSITIVE_INFINITY);
        chunkedPush(this.left, AA.reverse());
      }
  }
}
function chunkedPush(CA, gA) {
  let AA = 0;
  if (gA.length < 1e4)
    CA.push(...gA);
  else
    for (; AA < gA.length; )
      CA.push(...gA.slice(AA, AA + 1e4)), AA += 1e4;
}
function subtokenize(CA) {
  const gA = {};
  let AA = -1, IA, BA, QA, EA, iA, oA, cA;
  const tA = new SpliceBuffer(CA);
  for (; ++AA < tA.length; ) {
    for (; AA in gA; )
      AA = gA[AA];
    if (IA = tA.get(AA), AA && IA[1].type === "chunkFlow" && tA.get(AA - 1)[1].type === "listItemPrefix" && (oA = IA[1]._tokenizer.events, QA = 0, QA < oA.length && oA[QA][1].type === "lineEndingBlank" && (QA += 2), QA < oA.length && oA[QA][1].type === "content"))
      for (; ++QA < oA.length && oA[QA][1].type !== "content"; )
        oA[QA][1].type === "chunkText" && (oA[QA][1]._isInFirstContentOfListItem = !0, QA++);
    if (IA[0] === "enter")
      IA[1].contentType && (Object.assign(gA, subcontent(tA, AA)), AA = gA[AA], cA = !0);
    else if (IA[1]._container) {
      for (QA = AA, BA = void 0; QA--; )
        if (EA = tA.get(QA), EA[1].type === "lineEnding" || EA[1].type === "lineEndingBlank")
          EA[0] === "enter" && (BA && (tA.get(BA)[1].type = "lineEndingBlank"), EA[1].type = "lineEnding", BA = QA);
        else if (!(EA[1].type === "linePrefix" || EA[1].type === "listItemIndent")) break;
      BA && (IA[1].end = {
        ...tA.get(BA)[1].start
      }, iA = tA.slice(BA, AA), iA.unshift(IA), tA.splice(BA, AA - BA + 1, iA));
    }
  }
  return splice(CA, 0, Number.POSITIVE_INFINITY, tA.slice(0)), !cA;
}
function subcontent(CA, gA) {
  const AA = CA.get(gA)[1], IA = CA.get(gA)[2];
  let BA = gA - 1;
  const QA = [];
  let EA = AA._tokenizer;
  EA || (EA = IA.parser[AA.contentType](AA.start), AA._contentTypeTextTrailing && (EA._contentTypeTextTrailing = !0));
  const iA = EA.events, oA = [], cA = {};
  let tA, eA, aA = -1, GA = AA, lA = 0, nA = 0;
  const DA = [nA];
  for (; GA; ) {
    for (; CA.get(++BA)[1] !== GA; )
      ;
    QA.push(BA), GA._tokenizer || (tA = IA.sliceStream(GA), GA.next || tA.push(null), eA && EA.defineSkip(GA.start), GA._isInFirstContentOfListItem && (EA._gfmTasklistFirstContentOfListItem = !0), EA.write(tA), GA._isInFirstContentOfListItem && (EA._gfmTasklistFirstContentOfListItem = void 0)), eA = GA, GA = GA.next;
  }
  for (GA = AA; ++aA < iA.length; )
    // Find a void token that includes a break.
    iA[aA][0] === "exit" && iA[aA - 1][0] === "enter" && iA[aA][1].type === iA[aA - 1][1].type && iA[aA][1].start.line !== iA[aA][1].end.line && (nA = aA + 1, DA.push(nA), GA._tokenizer = void 0, GA.previous = void 0, GA = GA.next);
  for (EA.events = [], GA ? (GA._tokenizer = void 0, GA.previous = void 0) : DA.pop(), aA = DA.length; aA--; ) {
    const hA = iA.slice(DA[aA], DA[aA + 1]), wA = QA.pop();
    oA.push([wA, wA + hA.length - 1]), CA.splice(wA, 2, hA);
  }
  for (oA.reverse(), aA = -1; ++aA < oA.length; )
    cA[lA + oA[aA][0]] = lA + oA[aA][1], lA += oA[aA][1] - oA[aA][0] - 1;
  return cA;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
}, continuationConstruct = {
  partial: !0,
  tokenize: tokenizeContinuation
};
function resolveContent(CA) {
  return subtokenize(CA), CA;
}
function tokenizeContent(CA, gA) {
  let AA;
  return IA;
  function IA(iA) {
    return CA.enter("content"), AA = CA.enter("chunkContent", {
      contentType: "content"
    }), BA(iA);
  }
  function BA(iA) {
    return iA === null ? QA(iA) : markdownLineEnding(iA) ? CA.check(continuationConstruct, EA, QA)(iA) : (CA.consume(iA), BA);
  }
  function QA(iA) {
    return CA.exit("chunkContent"), CA.exit("content"), gA(iA);
  }
  function EA(iA) {
    return CA.consume(iA), CA.exit("chunkContent"), AA.next = CA.enter("chunkContent", {
      contentType: "content",
      previous: AA
    }), AA = AA.next, BA;
  }
}
function tokenizeContinuation(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return CA.exit("chunkContent"), CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), factorySpace(CA, QA, "linePrefix");
  }
  function QA(EA) {
    if (EA === null || markdownLineEnding(EA))
      return AA(EA);
    const iA = IA.events[IA.events.length - 1];
    return !IA.parser.constructs.disable.null.includes("codeIndented") && iA && iA[1].type === "linePrefix" && iA[2].sliceSerialize(iA[1], !0).length >= 4 ? gA(EA) : CA.interrupt(IA.parser.constructs.flow, AA, gA)(EA);
  }
}
function factoryDestination(CA, gA, AA, IA, BA, QA, EA, iA, oA) {
  const cA = oA || Number.POSITIVE_INFINITY;
  let tA = 0;
  return eA;
  function eA(hA) {
    return hA === 60 ? (CA.enter(IA), CA.enter(BA), CA.enter(QA), CA.consume(hA), CA.exit(QA), aA) : hA === null || hA === 32 || hA === 41 || asciiControl(hA) ? AA(hA) : (CA.enter(IA), CA.enter(EA), CA.enter(iA), CA.enter("chunkString", {
      contentType: "string"
    }), nA(hA));
  }
  function aA(hA) {
    return hA === 62 ? (CA.enter(QA), CA.consume(hA), CA.exit(QA), CA.exit(BA), CA.exit(IA), gA) : (CA.enter(iA), CA.enter("chunkString", {
      contentType: "string"
    }), GA(hA));
  }
  function GA(hA) {
    return hA === 62 ? (CA.exit("chunkString"), CA.exit(iA), aA(hA)) : hA === null || hA === 60 || markdownLineEnding(hA) ? AA(hA) : (CA.consume(hA), hA === 92 ? lA : GA);
  }
  function lA(hA) {
    return hA === 60 || hA === 62 || hA === 92 ? (CA.consume(hA), GA) : GA(hA);
  }
  function nA(hA) {
    return !tA && (hA === null || hA === 41 || markdownLineEndingOrSpace(hA)) ? (CA.exit("chunkString"), CA.exit(iA), CA.exit(EA), CA.exit(IA), gA(hA)) : tA < cA && hA === 40 ? (CA.consume(hA), tA++, nA) : hA === 41 ? (CA.consume(hA), tA--, nA) : hA === null || hA === 32 || hA === 40 || asciiControl(hA) ? AA(hA) : (CA.consume(hA), hA === 92 ? DA : nA);
  }
  function DA(hA) {
    return hA === 40 || hA === 41 || hA === 92 ? (CA.consume(hA), nA) : nA(hA);
  }
}
function factoryLabel$1(CA, gA, AA, IA, BA, QA) {
  const EA = this;
  let iA = 0, oA;
  return cA;
  function cA(GA) {
    return CA.enter(IA), CA.enter(BA), CA.consume(GA), CA.exit(BA), CA.enter(QA), tA;
  }
  function tA(GA) {
    return iA > 999 || GA === null || GA === 91 || GA === 93 && !oA || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    GA === 94 && !iA && "_hiddenFootnoteSupport" in EA.parser.constructs ? AA(GA) : GA === 93 ? (CA.exit(QA), CA.enter(BA), CA.consume(GA), CA.exit(BA), CA.exit(IA), gA) : markdownLineEnding(GA) ? (CA.enter("lineEnding"), CA.consume(GA), CA.exit("lineEnding"), tA) : (CA.enter("chunkString", {
      contentType: "string"
    }), eA(GA));
  }
  function eA(GA) {
    return GA === null || GA === 91 || GA === 93 || markdownLineEnding(GA) || iA++ > 999 ? (CA.exit("chunkString"), tA(GA)) : (CA.consume(GA), oA || (oA = !markdownSpace(GA)), GA === 92 ? aA : eA);
  }
  function aA(GA) {
    return GA === 91 || GA === 92 || GA === 93 ? (CA.consume(GA), iA++, eA) : eA(GA);
  }
}
function factoryTitle(CA, gA, AA, IA, BA, QA) {
  let EA;
  return iA;
  function iA(aA) {
    return aA === 34 || aA === 39 || aA === 40 ? (CA.enter(IA), CA.enter(BA), CA.consume(aA), CA.exit(BA), EA = aA === 40 ? 41 : aA, oA) : AA(aA);
  }
  function oA(aA) {
    return aA === EA ? (CA.enter(BA), CA.consume(aA), CA.exit(BA), CA.exit(IA), gA) : (CA.enter(QA), cA(aA));
  }
  function cA(aA) {
    return aA === EA ? (CA.exit(QA), oA(EA)) : aA === null ? AA(aA) : markdownLineEnding(aA) ? (CA.enter("lineEnding"), CA.consume(aA), CA.exit("lineEnding"), factorySpace(CA, cA, "linePrefix")) : (CA.enter("chunkString", {
      contentType: "string"
    }), tA(aA));
  }
  function tA(aA) {
    return aA === EA || aA === null || markdownLineEnding(aA) ? (CA.exit("chunkString"), cA(aA)) : (CA.consume(aA), aA === 92 ? eA : tA);
  }
  function eA(aA) {
    return aA === EA || aA === 92 ? (CA.consume(aA), tA) : tA(aA);
  }
}
function factoryWhitespace(CA, gA) {
  let AA;
  return IA;
  function IA(BA) {
    return markdownLineEnding(BA) ? (CA.enter("lineEnding"), CA.consume(BA), CA.exit("lineEnding"), AA = !0, IA) : markdownSpace(BA) ? factorySpace(CA, IA, AA ? "linePrefix" : "lineSuffix")(BA) : gA(BA);
  }
}
const definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition
}, titleBefore = {
  partial: !0,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(CA, gA, AA) {
  const IA = this;
  let BA;
  return QA;
  function QA(GA) {
    return CA.enter("definition"), EA(GA);
  }
  function EA(GA) {
    return factoryLabel$1.call(
      IA,
      CA,
      iA,
      // Note: we don’t need to reset the way `markdown-rs` does.
      AA,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(GA);
  }
  function iA(GA) {
    return BA = normalizeIdentifier(IA.sliceSerialize(IA.events[IA.events.length - 1][1]).slice(1, -1)), GA === 58 ? (CA.enter("definitionMarker"), CA.consume(GA), CA.exit("definitionMarker"), oA) : AA(GA);
  }
  function oA(GA) {
    return markdownLineEndingOrSpace(GA) ? factoryWhitespace(CA, cA)(GA) : cA(GA);
  }
  function cA(GA) {
    return factoryDestination(
      CA,
      tA,
      // Note: we don’t need to reset the way `markdown-rs` does.
      AA,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(GA);
  }
  function tA(GA) {
    return CA.attempt(titleBefore, eA, eA)(GA);
  }
  function eA(GA) {
    return markdownSpace(GA) ? factorySpace(CA, aA, "whitespace")(GA) : aA(GA);
  }
  function aA(GA) {
    return GA === null || markdownLineEnding(GA) ? (CA.exit("definition"), IA.parser.defined.push(BA), gA(GA)) : AA(GA);
  }
}
function tokenizeTitleBefore(CA, gA, AA) {
  return IA;
  function IA(iA) {
    return markdownLineEndingOrSpace(iA) ? factoryWhitespace(CA, BA)(iA) : AA(iA);
  }
  function BA(iA) {
    return factoryTitle(CA, QA, AA, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(iA);
  }
  function QA(iA) {
    return markdownSpace(iA) ? factorySpace(CA, EA, "whitespace")(iA) : EA(iA);
  }
  function EA(iA) {
    return iA === null || markdownLineEnding(iA) ? gA(iA) : AA(iA);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(CA, gA, AA) {
  return IA;
  function IA(QA) {
    return CA.enter("hardBreakEscape"), CA.consume(QA), BA;
  }
  function BA(QA) {
    return markdownLineEnding(QA) ? (CA.exit("hardBreakEscape"), gA(QA)) : AA(QA);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(CA, gA) {
  let AA = CA.length - 2, IA = 3, BA, QA;
  return CA[IA][1].type === "whitespace" && (IA += 2), AA - 2 > IA && CA[AA][1].type === "whitespace" && (AA -= 2), CA[AA][1].type === "atxHeadingSequence" && (IA === AA - 1 || AA - 4 > IA && CA[AA - 2][1].type === "whitespace") && (AA -= IA + 1 === AA ? 2 : 4), AA > IA && (BA = {
    type: "atxHeadingText",
    start: CA[IA][1].start,
    end: CA[AA][1].end
  }, QA = {
    type: "chunkText",
    start: CA[IA][1].start,
    end: CA[AA][1].end,
    contentType: "text"
  }, splice(CA, IA, AA - IA + 1, [["enter", BA, gA], ["enter", QA, gA], ["exit", QA, gA], ["exit", BA, gA]])), CA;
}
function tokenizeHeadingAtx(CA, gA, AA) {
  let IA = 0;
  return BA;
  function BA(tA) {
    return CA.enter("atxHeading"), QA(tA);
  }
  function QA(tA) {
    return CA.enter("atxHeadingSequence"), EA(tA);
  }
  function EA(tA) {
    return tA === 35 && IA++ < 6 ? (CA.consume(tA), EA) : tA === null || markdownLineEndingOrSpace(tA) ? (CA.exit("atxHeadingSequence"), iA(tA)) : AA(tA);
  }
  function iA(tA) {
    return tA === 35 ? (CA.enter("atxHeadingSequence"), oA(tA)) : tA === null || markdownLineEnding(tA) ? (CA.exit("atxHeading"), gA(tA)) : markdownSpace(tA) ? factorySpace(CA, iA, "whitespace")(tA) : (CA.enter("atxHeadingText"), cA(tA));
  }
  function oA(tA) {
    return tA === 35 ? (CA.consume(tA), oA) : (CA.exit("atxHeadingSequence"), iA(tA));
  }
  function cA(tA) {
    return tA === null || tA === 35 || markdownLineEndingOrSpace(tA) ? (CA.exit("atxHeadingText"), iA(tA)) : (CA.consume(tA), cA);
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], htmlRawNames = ["pre", "script", "style", "textarea"], htmlFlow = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
}, blankLineBefore = {
  partial: !0,
  tokenize: tokenizeBlankLineBefore
}, nonLazyContinuationStart = {
  partial: !0,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(CA) {
  let gA = CA.length;
  for (; gA-- && !(CA[gA][0] === "enter" && CA[gA][1].type === "htmlFlow"); )
    ;
  return gA > 1 && CA[gA - 2][1].type === "linePrefix" && (CA[gA][1].start = CA[gA - 2][1].start, CA[gA + 1][1].start = CA[gA - 2][1].start, CA.splice(gA - 2, 2)), CA;
}
function tokenizeHtmlFlow(CA, gA, AA) {
  const IA = this;
  let BA, QA, EA, iA, oA;
  return cA;
  function cA(ZA) {
    return tA(ZA);
  }
  function tA(ZA) {
    return CA.enter("htmlFlow"), CA.enter("htmlFlowData"), CA.consume(ZA), eA;
  }
  function eA(ZA) {
    return ZA === 33 ? (CA.consume(ZA), aA) : ZA === 47 ? (CA.consume(ZA), QA = !0, nA) : ZA === 63 ? (CA.consume(ZA), BA = 3, IA.interrupt ? gA : uA) : asciiAlpha(ZA) ? (CA.consume(ZA), EA = String.fromCharCode(ZA), DA) : AA(ZA);
  }
  function aA(ZA) {
    return ZA === 45 ? (CA.consume(ZA), BA = 2, GA) : ZA === 91 ? (CA.consume(ZA), BA = 5, iA = 0, lA) : asciiAlpha(ZA) ? (CA.consume(ZA), BA = 4, IA.interrupt ? gA : uA) : AA(ZA);
  }
  function GA(ZA) {
    return ZA === 45 ? (CA.consume(ZA), IA.interrupt ? gA : uA) : AA(ZA);
  }
  function lA(ZA) {
    const AI = "CDATA[";
    return ZA === AI.charCodeAt(iA++) ? (CA.consume(ZA), iA === AI.length ? IA.interrupt ? gA : pA : lA) : AA(ZA);
  }
  function nA(ZA) {
    return asciiAlpha(ZA) ? (CA.consume(ZA), EA = String.fromCharCode(ZA), DA) : AA(ZA);
  }
  function DA(ZA) {
    if (ZA === null || ZA === 47 || ZA === 62 || markdownLineEndingOrSpace(ZA)) {
      const AI = ZA === 47, QI = EA.toLowerCase();
      return !AI && !QA && htmlRawNames.includes(QI) ? (BA = 1, IA.interrupt ? gA(ZA) : pA(ZA)) : htmlBlockNames.includes(EA.toLowerCase()) ? (BA = 6, AI ? (CA.consume(ZA), hA) : IA.interrupt ? gA(ZA) : pA(ZA)) : (BA = 7, IA.interrupt && !IA.parser.lazy[IA.now().line] ? AA(ZA) : QA ? wA(ZA) : sA(ZA));
    }
    return ZA === 45 || asciiAlphanumeric(ZA) ? (CA.consume(ZA), EA += String.fromCharCode(ZA), DA) : AA(ZA);
  }
  function hA(ZA) {
    return ZA === 62 ? (CA.consume(ZA), IA.interrupt ? gA : pA) : AA(ZA);
  }
  function wA(ZA) {
    return markdownSpace(ZA) ? (CA.consume(ZA), wA) : dA(ZA);
  }
  function sA(ZA) {
    return ZA === 47 ? (CA.consume(ZA), dA) : ZA === 58 || ZA === 95 || asciiAlpha(ZA) ? (CA.consume(ZA), NA) : markdownSpace(ZA) ? (CA.consume(ZA), sA) : dA(ZA);
  }
  function NA(ZA) {
    return ZA === 45 || ZA === 46 || ZA === 58 || ZA === 95 || asciiAlphanumeric(ZA) ? (CA.consume(ZA), NA) : rA(ZA);
  }
  function rA(ZA) {
    return ZA === 61 ? (CA.consume(ZA), yA) : markdownSpace(ZA) ? (CA.consume(ZA), rA) : sA(ZA);
  }
  function yA(ZA) {
    return ZA === null || ZA === 60 || ZA === 61 || ZA === 62 || ZA === 96 ? AA(ZA) : ZA === 34 || ZA === 39 ? (CA.consume(ZA), oA = ZA, bA) : markdownSpace(ZA) ? (CA.consume(ZA), yA) : RA(ZA);
  }
  function bA(ZA) {
    return ZA === oA ? (CA.consume(ZA), oA = null, FA) : ZA === null || markdownLineEnding(ZA) ? AA(ZA) : (CA.consume(ZA), bA);
  }
  function RA(ZA) {
    return ZA === null || ZA === 34 || ZA === 39 || ZA === 47 || ZA === 60 || ZA === 61 || ZA === 62 || ZA === 96 || markdownLineEndingOrSpace(ZA) ? rA(ZA) : (CA.consume(ZA), RA);
  }
  function FA(ZA) {
    return ZA === 47 || ZA === 62 || markdownSpace(ZA) ? sA(ZA) : AA(ZA);
  }
  function dA(ZA) {
    return ZA === 62 ? (CA.consume(ZA), kA) : AA(ZA);
  }
  function kA(ZA) {
    return ZA === null || markdownLineEnding(ZA) ? pA(ZA) : markdownSpace(ZA) ? (CA.consume(ZA), kA) : AA(ZA);
  }
  function pA(ZA) {
    return ZA === 45 && BA === 2 ? (CA.consume(ZA), UA) : ZA === 60 && BA === 1 ? (CA.consume(ZA), fA) : ZA === 62 && BA === 4 ? (CA.consume(ZA), HA) : ZA === 63 && BA === 3 ? (CA.consume(ZA), uA) : ZA === 93 && BA === 5 ? (CA.consume(ZA), _A) : markdownLineEnding(ZA) && (BA === 6 || BA === 7) ? (CA.exit("htmlFlowData"), CA.check(blankLineBefore, TA, YA)(ZA)) : ZA === null || markdownLineEnding(ZA) ? (CA.exit("htmlFlowData"), YA(ZA)) : (CA.consume(ZA), pA);
  }
  function YA(ZA) {
    return CA.check(nonLazyContinuationStart, SA, TA)(ZA);
  }
  function SA(ZA) {
    return CA.enter("lineEnding"), CA.consume(ZA), CA.exit("lineEnding"), JA;
  }
  function JA(ZA) {
    return ZA === null || markdownLineEnding(ZA) ? YA(ZA) : (CA.enter("htmlFlowData"), pA(ZA));
  }
  function UA(ZA) {
    return ZA === 45 ? (CA.consume(ZA), uA) : pA(ZA);
  }
  function fA(ZA) {
    return ZA === 47 ? (CA.consume(ZA), EA = "", zA) : pA(ZA);
  }
  function zA(ZA) {
    if (ZA === 62) {
      const AI = EA.toLowerCase();
      return htmlRawNames.includes(AI) ? (CA.consume(ZA), HA) : pA(ZA);
    }
    return asciiAlpha(ZA) && EA.length < 8 ? (CA.consume(ZA), EA += String.fromCharCode(ZA), zA) : pA(ZA);
  }
  function _A(ZA) {
    return ZA === 93 ? (CA.consume(ZA), uA) : pA(ZA);
  }
  function uA(ZA) {
    return ZA === 62 ? (CA.consume(ZA), HA) : ZA === 45 && BA === 2 ? (CA.consume(ZA), uA) : pA(ZA);
  }
  function HA(ZA) {
    return ZA === null || markdownLineEnding(ZA) ? (CA.exit("htmlFlowData"), TA(ZA)) : (CA.consume(ZA), HA);
  }
  function TA(ZA) {
    return CA.exit("htmlFlow"), gA(ZA);
  }
}
function tokenizeNonLazyContinuationStart(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return markdownLineEnding(EA) ? (CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), QA) : AA(EA);
  }
  function QA(EA) {
    return IA.parser.lazy[IA.now().line] ? AA(EA) : gA(EA);
  }
}
function tokenizeBlankLineBefore(CA, gA, AA) {
  return IA;
  function IA(BA) {
    return CA.enter("lineEnding"), CA.consume(BA), CA.exit("lineEnding"), CA.attempt(blankLine, gA, AA);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(CA, gA, AA) {
  const IA = this;
  let BA, QA, EA;
  return iA;
  function iA(uA) {
    return CA.enter("htmlText"), CA.enter("htmlTextData"), CA.consume(uA), oA;
  }
  function oA(uA) {
    return uA === 33 ? (CA.consume(uA), cA) : uA === 47 ? (CA.consume(uA), rA) : uA === 63 ? (CA.consume(uA), sA) : asciiAlpha(uA) ? (CA.consume(uA), RA) : AA(uA);
  }
  function cA(uA) {
    return uA === 45 ? (CA.consume(uA), tA) : uA === 91 ? (CA.consume(uA), QA = 0, lA) : asciiAlpha(uA) ? (CA.consume(uA), wA) : AA(uA);
  }
  function tA(uA) {
    return uA === 45 ? (CA.consume(uA), GA) : AA(uA);
  }
  function eA(uA) {
    return uA === null ? AA(uA) : uA === 45 ? (CA.consume(uA), aA) : markdownLineEnding(uA) ? (EA = eA, fA(uA)) : (CA.consume(uA), eA);
  }
  function aA(uA) {
    return uA === 45 ? (CA.consume(uA), GA) : eA(uA);
  }
  function GA(uA) {
    return uA === 62 ? UA(uA) : uA === 45 ? aA(uA) : eA(uA);
  }
  function lA(uA) {
    const HA = "CDATA[";
    return uA === HA.charCodeAt(QA++) ? (CA.consume(uA), QA === HA.length ? nA : lA) : AA(uA);
  }
  function nA(uA) {
    return uA === null ? AA(uA) : uA === 93 ? (CA.consume(uA), DA) : markdownLineEnding(uA) ? (EA = nA, fA(uA)) : (CA.consume(uA), nA);
  }
  function DA(uA) {
    return uA === 93 ? (CA.consume(uA), hA) : nA(uA);
  }
  function hA(uA) {
    return uA === 62 ? UA(uA) : uA === 93 ? (CA.consume(uA), hA) : nA(uA);
  }
  function wA(uA) {
    return uA === null || uA === 62 ? UA(uA) : markdownLineEnding(uA) ? (EA = wA, fA(uA)) : (CA.consume(uA), wA);
  }
  function sA(uA) {
    return uA === null ? AA(uA) : uA === 63 ? (CA.consume(uA), NA) : markdownLineEnding(uA) ? (EA = sA, fA(uA)) : (CA.consume(uA), sA);
  }
  function NA(uA) {
    return uA === 62 ? UA(uA) : sA(uA);
  }
  function rA(uA) {
    return asciiAlpha(uA) ? (CA.consume(uA), yA) : AA(uA);
  }
  function yA(uA) {
    return uA === 45 || asciiAlphanumeric(uA) ? (CA.consume(uA), yA) : bA(uA);
  }
  function bA(uA) {
    return markdownLineEnding(uA) ? (EA = bA, fA(uA)) : markdownSpace(uA) ? (CA.consume(uA), bA) : UA(uA);
  }
  function RA(uA) {
    return uA === 45 || asciiAlphanumeric(uA) ? (CA.consume(uA), RA) : uA === 47 || uA === 62 || markdownLineEndingOrSpace(uA) ? FA(uA) : AA(uA);
  }
  function FA(uA) {
    return uA === 47 ? (CA.consume(uA), UA) : uA === 58 || uA === 95 || asciiAlpha(uA) ? (CA.consume(uA), dA) : markdownLineEnding(uA) ? (EA = FA, fA(uA)) : markdownSpace(uA) ? (CA.consume(uA), FA) : UA(uA);
  }
  function dA(uA) {
    return uA === 45 || uA === 46 || uA === 58 || uA === 95 || asciiAlphanumeric(uA) ? (CA.consume(uA), dA) : kA(uA);
  }
  function kA(uA) {
    return uA === 61 ? (CA.consume(uA), pA) : markdownLineEnding(uA) ? (EA = kA, fA(uA)) : markdownSpace(uA) ? (CA.consume(uA), kA) : FA(uA);
  }
  function pA(uA) {
    return uA === null || uA === 60 || uA === 61 || uA === 62 || uA === 96 ? AA(uA) : uA === 34 || uA === 39 ? (CA.consume(uA), BA = uA, YA) : markdownLineEnding(uA) ? (EA = pA, fA(uA)) : markdownSpace(uA) ? (CA.consume(uA), pA) : (CA.consume(uA), SA);
  }
  function YA(uA) {
    return uA === BA ? (CA.consume(uA), BA = void 0, JA) : uA === null ? AA(uA) : markdownLineEnding(uA) ? (EA = YA, fA(uA)) : (CA.consume(uA), YA);
  }
  function SA(uA) {
    return uA === null || uA === 34 || uA === 39 || uA === 60 || uA === 61 || uA === 96 ? AA(uA) : uA === 47 || uA === 62 || markdownLineEndingOrSpace(uA) ? FA(uA) : (CA.consume(uA), SA);
  }
  function JA(uA) {
    return uA === 47 || uA === 62 || markdownLineEndingOrSpace(uA) ? FA(uA) : AA(uA);
  }
  function UA(uA) {
    return uA === 62 ? (CA.consume(uA), CA.exit("htmlTextData"), CA.exit("htmlText"), gA) : AA(uA);
  }
  function fA(uA) {
    return CA.exit("htmlTextData"), CA.enter("lineEnding"), CA.consume(uA), CA.exit("lineEnding"), zA;
  }
  function zA(uA) {
    return markdownSpace(uA) ? factorySpace(CA, _A, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(uA) : _A(uA);
  }
  function _A(uA) {
    return CA.enter("htmlTextData"), EA(uA);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
}, resourceConstruct = {
  tokenize: tokenizeResource
}, referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}, referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(CA) {
  let gA = -1;
  const AA = [];
  for (; ++gA < CA.length; ) {
    const IA = CA[gA][1];
    if (AA.push(CA[gA]), IA.type === "labelImage" || IA.type === "labelLink" || IA.type === "labelEnd") {
      const BA = IA.type === "labelImage" ? 4 : 2;
      IA.type = "data", gA += BA;
    }
  }
  return CA.length !== AA.length && splice(CA, 0, CA.length, AA), CA;
}
function resolveToLabelEnd(CA, gA) {
  let AA = CA.length, IA = 0, BA, QA, EA, iA;
  for (; AA--; )
    if (BA = CA[AA][1], QA) {
      if (BA.type === "link" || BA.type === "labelLink" && BA._inactive)
        break;
      CA[AA][0] === "enter" && BA.type === "labelLink" && (BA._inactive = !0);
    } else if (EA) {
      if (CA[AA][0] === "enter" && (BA.type === "labelImage" || BA.type === "labelLink") && !BA._balanced && (QA = AA, BA.type !== "labelLink")) {
        IA = 2;
        break;
      }
    } else BA.type === "labelEnd" && (EA = AA);
  const oA = {
    type: CA[QA][1].type === "labelLink" ? "link" : "image",
    start: {
      ...CA[QA][1].start
    },
    end: {
      ...CA[CA.length - 1][1].end
    }
  }, cA = {
    type: "label",
    start: {
      ...CA[QA][1].start
    },
    end: {
      ...CA[EA][1].end
    }
  }, tA = {
    type: "labelText",
    start: {
      ...CA[QA + IA + 2][1].end
    },
    end: {
      ...CA[EA - 2][1].start
    }
  };
  return iA = [["enter", oA, gA], ["enter", cA, gA]], iA = push(iA, CA.slice(QA + 1, QA + IA + 3)), iA = push(iA, [["enter", tA, gA]]), iA = push(iA, resolveAll(gA.parser.constructs.insideSpan.null, CA.slice(QA + IA + 4, EA - 3), gA)), iA = push(iA, [["exit", tA, gA], CA[EA - 2], CA[EA - 1], ["exit", cA, gA]]), iA = push(iA, CA.slice(EA + 1)), iA = push(iA, [["exit", oA, gA]]), splice(CA, QA, CA.length, iA), CA;
}
function tokenizeLabelEnd(CA, gA, AA) {
  const IA = this;
  let BA = IA.events.length, QA, EA;
  for (; BA--; )
    if ((IA.events[BA][1].type === "labelImage" || IA.events[BA][1].type === "labelLink") && !IA.events[BA][1]._balanced) {
      QA = IA.events[BA][1];
      break;
    }
  return iA;
  function iA(aA) {
    return QA ? QA._inactive ? eA(aA) : (EA = IA.parser.defined.includes(normalizeIdentifier(IA.sliceSerialize({
      start: QA.end,
      end: IA.now()
    }))), CA.enter("labelEnd"), CA.enter("labelMarker"), CA.consume(aA), CA.exit("labelMarker"), CA.exit("labelEnd"), oA) : AA(aA);
  }
  function oA(aA) {
    return aA === 40 ? CA.attempt(resourceConstruct, tA, EA ? tA : eA)(aA) : aA === 91 ? CA.attempt(referenceFullConstruct, tA, EA ? cA : eA)(aA) : EA ? tA(aA) : eA(aA);
  }
  function cA(aA) {
    return CA.attempt(referenceCollapsedConstruct, tA, eA)(aA);
  }
  function tA(aA) {
    return gA(aA);
  }
  function eA(aA) {
    return QA._balanced = !0, AA(aA);
  }
}
function tokenizeResource(CA, gA, AA) {
  return IA;
  function IA(eA) {
    return CA.enter("resource"), CA.enter("resourceMarker"), CA.consume(eA), CA.exit("resourceMarker"), BA;
  }
  function BA(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(CA, QA)(eA) : QA(eA);
  }
  function QA(eA) {
    return eA === 41 ? tA(eA) : factoryDestination(CA, EA, iA, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(eA);
  }
  function EA(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(CA, oA)(eA) : tA(eA);
  }
  function iA(eA) {
    return AA(eA);
  }
  function oA(eA) {
    return eA === 34 || eA === 39 || eA === 40 ? factoryTitle(CA, cA, AA, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(eA) : tA(eA);
  }
  function cA(eA) {
    return markdownLineEndingOrSpace(eA) ? factoryWhitespace(CA, tA)(eA) : tA(eA);
  }
  function tA(eA) {
    return eA === 41 ? (CA.enter("resourceMarker"), CA.consume(eA), CA.exit("resourceMarker"), CA.exit("resource"), gA) : AA(eA);
  }
}
function tokenizeReferenceFull(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(iA) {
    return factoryLabel$1.call(IA, CA, QA, EA, "reference", "referenceMarker", "referenceString")(iA);
  }
  function QA(iA) {
    return IA.parser.defined.includes(normalizeIdentifier(IA.sliceSerialize(IA.events[IA.events.length - 1][1]).slice(1, -1))) ? gA(iA) : AA(iA);
  }
  function EA(iA) {
    return AA(iA);
  }
}
function tokenizeReferenceCollapsed(CA, gA, AA) {
  return IA;
  function IA(QA) {
    return CA.enter("reference"), CA.enter("referenceMarker"), CA.consume(QA), CA.exit("referenceMarker"), BA;
  }
  function BA(QA) {
    return QA === 93 ? (CA.enter("referenceMarker"), CA.consume(QA), CA.exit("referenceMarker"), CA.exit("reference"), gA) : AA(QA);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(iA) {
    return CA.enter("labelImage"), CA.enter("labelImageMarker"), CA.consume(iA), CA.exit("labelImageMarker"), QA;
  }
  function QA(iA) {
    return iA === 91 ? (CA.enter("labelMarker"), CA.consume(iA), CA.exit("labelMarker"), CA.exit("labelImage"), EA) : AA(iA);
  }
  function EA(iA) {
    return iA === 94 && "_hiddenFootnoteSupport" in IA.parser.constructs ? AA(iA) : gA(iA);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return CA.enter("labelLink"), CA.enter("labelMarker"), CA.consume(EA), CA.exit("labelMarker"), CA.exit("labelLink"), QA;
  }
  function QA(EA) {
    return EA === 94 && "_hiddenFootnoteSupport" in IA.parser.constructs ? AA(EA) : gA(EA);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(CA, gA) {
  return AA;
  function AA(IA) {
    return CA.enter("lineEnding"), CA.consume(IA), CA.exit("lineEnding"), factorySpace(CA, gA, "linePrefix");
  }
}
const thematicBreak$2 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(CA, gA, AA) {
  let IA = 0, BA;
  return QA;
  function QA(cA) {
    return CA.enter("thematicBreak"), EA(cA);
  }
  function EA(cA) {
    return BA = cA, iA(cA);
  }
  function iA(cA) {
    return cA === BA ? (CA.enter("thematicBreakSequence"), oA(cA)) : IA >= 3 && (cA === null || markdownLineEnding(cA)) ? (CA.exit("thematicBreak"), gA(cA)) : AA(cA);
  }
  function oA(cA) {
    return cA === BA ? (CA.consume(cA), IA++, oA) : (CA.exit("thematicBreakSequence"), markdownSpace(cA) ? factorySpace(CA, iA, "whitespace")(cA) : iA(cA));
  }
}
const list$2 = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
}, listItemPrefixWhitespaceConstruct = {
  partial: !0,
  tokenize: tokenizeListItemPrefixWhitespace
}, indentConstruct = {
  partial: !0,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart(CA, gA, AA) {
  const IA = this, BA = IA.events[IA.events.length - 1];
  let QA = BA && BA[1].type === "linePrefix" ? BA[2].sliceSerialize(BA[1], !0).length : 0, EA = 0;
  return iA;
  function iA(GA) {
    const lA = IA.containerState.type || (GA === 42 || GA === 43 || GA === 45 ? "listUnordered" : "listOrdered");
    if (lA === "listUnordered" ? !IA.containerState.marker || GA === IA.containerState.marker : asciiDigit(GA)) {
      if (IA.containerState.type || (IA.containerState.type = lA, CA.enter(lA, {
        _container: !0
      })), lA === "listUnordered")
        return CA.enter("listItemPrefix"), GA === 42 || GA === 45 ? CA.check(thematicBreak$2, AA, cA)(GA) : cA(GA);
      if (!IA.interrupt || GA === 49)
        return CA.enter("listItemPrefix"), CA.enter("listItemValue"), oA(GA);
    }
    return AA(GA);
  }
  function oA(GA) {
    return asciiDigit(GA) && ++EA < 10 ? (CA.consume(GA), oA) : (!IA.interrupt || EA < 2) && (IA.containerState.marker ? GA === IA.containerState.marker : GA === 41 || GA === 46) ? (CA.exit("listItemValue"), cA(GA)) : AA(GA);
  }
  function cA(GA) {
    return CA.enter("listItemMarker"), CA.consume(GA), CA.exit("listItemMarker"), IA.containerState.marker = IA.containerState.marker || GA, CA.check(
      blankLine,
      // Can’t be empty when interrupting.
      IA.interrupt ? AA : tA,
      CA.attempt(listItemPrefixWhitespaceConstruct, aA, eA)
    );
  }
  function tA(GA) {
    return IA.containerState.initialBlankLine = !0, QA++, aA(GA);
  }
  function eA(GA) {
    return markdownSpace(GA) ? (CA.enter("listItemPrefixWhitespace"), CA.consume(GA), CA.exit("listItemPrefixWhitespace"), aA) : AA(GA);
  }
  function aA(GA) {
    return IA.containerState.size = QA + IA.sliceSerialize(CA.exit("listItemPrefix"), !0).length, gA(GA);
  }
}
function tokenizeListContinuation(CA, gA, AA) {
  const IA = this;
  return IA.containerState._closeFlow = void 0, CA.check(blankLine, BA, QA);
  function BA(iA) {
    return IA.containerState.furtherBlankLines = IA.containerState.furtherBlankLines || IA.containerState.initialBlankLine, factorySpace(CA, gA, "listItemIndent", IA.containerState.size + 1)(iA);
  }
  function QA(iA) {
    return IA.containerState.furtherBlankLines || !markdownSpace(iA) ? (IA.containerState.furtherBlankLines = void 0, IA.containerState.initialBlankLine = void 0, EA(iA)) : (IA.containerState.furtherBlankLines = void 0, IA.containerState.initialBlankLine = void 0, CA.attempt(indentConstruct, gA, EA)(iA));
  }
  function EA(iA) {
    return IA.containerState._closeFlow = !0, IA.interrupt = void 0, factorySpace(CA, CA.attempt(list$2, gA, AA), "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(iA);
  }
}
function tokenizeIndent$1(CA, gA, AA) {
  const IA = this;
  return factorySpace(CA, BA, "listItemIndent", IA.containerState.size + 1);
  function BA(QA) {
    const EA = IA.events[IA.events.length - 1];
    return EA && EA[1].type === "listItemIndent" && EA[2].sliceSerialize(EA[1], !0).length === IA.containerState.size ? gA(QA) : AA(QA);
  }
}
function tokenizeListEnd(CA) {
  CA.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(CA, gA, AA) {
  const IA = this;
  return factorySpace(CA, BA, "listItemPrefixWhitespace", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function BA(QA) {
    const EA = IA.events[IA.events.length - 1];
    return !markdownSpace(QA) && EA && EA[1].type === "listItemPrefixWhitespace" ? gA(QA) : AA(QA);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(CA, gA) {
  let AA = CA.length, IA, BA, QA;
  for (; AA--; )
    if (CA[AA][0] === "enter") {
      if (CA[AA][1].type === "content") {
        IA = AA;
        break;
      }
      CA[AA][1].type === "paragraph" && (BA = AA);
    } else
      CA[AA][1].type === "content" && CA.splice(AA, 1), !QA && CA[AA][1].type === "definition" && (QA = AA);
  const EA = {
    type: "setextHeading",
    start: {
      ...CA[IA][1].start
    },
    end: {
      ...CA[CA.length - 1][1].end
    }
  };
  return CA[BA][1].type = "setextHeadingText", QA ? (CA.splice(BA, 0, ["enter", EA, gA]), CA.splice(QA + 1, 0, ["exit", CA[IA][1], gA]), CA[IA][1].end = {
    ...CA[QA][1].end
  }) : CA[IA][1] = EA, CA.push(["exit", EA, gA]), CA;
}
function tokenizeSetextUnderline(CA, gA, AA) {
  const IA = this;
  let BA;
  return QA;
  function QA(cA) {
    let tA = IA.events.length, eA;
    for (; tA--; )
      if (IA.events[tA][1].type !== "lineEnding" && IA.events[tA][1].type !== "linePrefix" && IA.events[tA][1].type !== "content") {
        eA = IA.events[tA][1].type === "paragraph";
        break;
      }
    return !IA.parser.lazy[IA.now().line] && (IA.interrupt || eA) ? (CA.enter("setextHeadingLine"), BA = cA, EA(cA)) : AA(cA);
  }
  function EA(cA) {
    return CA.enter("setextHeadingLineSequence"), iA(cA);
  }
  function iA(cA) {
    return cA === BA ? (CA.consume(cA), iA) : (CA.exit("setextHeadingLineSequence"), markdownSpace(cA) ? factorySpace(CA, oA, "lineSuffix")(cA) : oA(cA));
  }
  function oA(cA) {
    return cA === null || markdownLineEnding(cA) ? (CA.exit("setextHeadingLine"), gA(cA)) : AA(cA);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(CA) {
  const gA = this, AA = CA.attempt(
    // Try to parse a blank line.
    blankLine,
    IA,
    // Try to parse initial flow (essentially, only code).
    CA.attempt(this.parser.constructs.flowInitial, BA, factorySpace(CA, CA.attempt(this.parser.constructs.flow, BA, CA.attempt(content, BA)), "linePrefix"))
  );
  return AA;
  function IA(QA) {
    if (QA === null) {
      CA.consume(QA);
      return;
    }
    return CA.enter("lineEndingBlank"), CA.consume(QA), CA.exit("lineEndingBlank"), gA.currentConstruct = void 0, AA;
  }
  function BA(QA) {
    if (QA === null) {
      CA.consume(QA);
      return;
    }
    return CA.enter("lineEnding"), CA.consume(QA), CA.exit("lineEnding"), gA.currentConstruct = void 0, AA;
  }
}
const resolver = {
  resolveAll: createResolver()
}, string$1 = initializeFactory("string"), text$5 = initializeFactory("text");
function initializeFactory(CA) {
  return {
    resolveAll: createResolver(CA === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: gA
  };
  function gA(AA) {
    const IA = this, BA = this.parser.constructs[CA], QA = AA.attempt(BA, EA, iA);
    return EA;
    function EA(tA) {
      return cA(tA) ? QA(tA) : iA(tA);
    }
    function iA(tA) {
      if (tA === null) {
        AA.consume(tA);
        return;
      }
      return AA.enter("data"), AA.consume(tA), oA;
    }
    function oA(tA) {
      return cA(tA) ? (AA.exit("data"), QA(tA)) : (AA.consume(tA), oA);
    }
    function cA(tA) {
      if (tA === null)
        return !0;
      const eA = BA[tA];
      let aA = -1;
      if (eA)
        for (; ++aA < eA.length; ) {
          const GA = eA[aA];
          if (!GA.previous || GA.previous.call(IA, IA.previous))
            return !0;
        }
      return !1;
    }
  }
}
function createResolver(CA) {
  return gA;
  function gA(AA, IA) {
    let BA = -1, QA;
    for (; ++BA <= AA.length; )
      QA === void 0 ? AA[BA] && AA[BA][1].type === "data" && (QA = BA, BA++) : (!AA[BA] || AA[BA][1].type !== "data") && (BA !== QA + 2 && (AA[QA][1].end = AA[BA - 1][1].end, AA.splice(QA + 2, BA - QA - 2), BA = QA + 2), QA = void 0);
    return CA ? CA(AA, IA) : AA;
  }
}
function resolveAllLineSuffixes(CA, gA) {
  let AA = 0;
  for (; ++AA <= CA.length; )
    if ((AA === CA.length || CA[AA][1].type === "lineEnding") && CA[AA - 1][1].type === "data") {
      const IA = CA[AA - 1][1], BA = gA.sliceStream(IA);
      let QA = BA.length, EA = -1, iA = 0, oA;
      for (; QA--; ) {
        const cA = BA[QA];
        if (typeof cA == "string") {
          for (EA = cA.length; cA.charCodeAt(EA - 1) === 32; )
            iA++, EA--;
          if (EA) break;
          EA = -1;
        } else if (cA === -2)
          oA = !0, iA++;
        else if (cA !== -1) {
          QA++;
          break;
        }
      }
      if (gA._contentTypeTextTrailing && AA === CA.length && (iA = 0), iA) {
        const cA = {
          type: AA === CA.length || oA || iA < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: QA ? EA : IA.start._bufferIndex + EA,
            _index: IA.start._index + QA,
            line: IA.end.line,
            column: IA.end.column - iA,
            offset: IA.end.offset - iA
          },
          end: {
            ...IA.end
          }
        };
        IA.end = {
          ...cA.start
        }, IA.start.offset === IA.end.offset ? Object.assign(IA, cA) : (CA.splice(AA, 0, ["enter", cA, gA], ["exit", cA, gA]), AA += 2);
      }
      AA++;
    }
  return CA;
}
const document$1 = {
  42: list$2,
  43: list$2,
  45: list$2,
  48: list$2,
  49: list$2,
  50: list$2,
  51: list$2,
  52: list$2,
  53: list$2,
  54: list$2,
  55: list$2,
  56: list$2,
  57: list$2,
  62: blockQuote
}, contentInitial = {
  91: definition$1
}, flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  32: codeIndented
}, flow = {
  35: headingAtx,
  42: thematicBreak$2,
  45: [setextUnderline, thematicBreak$2],
  60: htmlFlow,
  61: setextUnderline,
  95: thematicBreak$2,
  96: codeFenced,
  126: codeFenced
}, string = {
  38: characterReference,
  92: characterEscape
}, text$4 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  33: labelStartImage,
  38: characterReference,
  42: attention,
  60: [autolink, htmlText],
  91: labelStartLink,
  92: [hardBreakEscape, characterEscape],
  93: labelEnd,
  95: attention,
  96: codeText
}, insideSpan = {
  null: [attention, resolver]
}, attentionMarkers = {
  null: [42, 95]
}, disable = {
  null: []
}, defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text: text$4
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(CA, gA, AA) {
  let IA = {
    _bufferIndex: -1,
    _index: 0,
    line: AA && AA.line || 1,
    column: AA && AA.column || 1,
    offset: AA && AA.offset || 0
  };
  const BA = {}, QA = [];
  let EA = [], iA = [];
  const oA = {
    attempt: bA(rA),
    check: bA(yA),
    consume: wA,
    enter: sA,
    exit: NA,
    interrupt: bA(yA, {
      interrupt: !0
    })
  }, cA = {
    code: null,
    containerState: {},
    defineSkip: nA,
    events: [],
    now: lA,
    parser: CA,
    previous: null,
    sliceSerialize: aA,
    sliceStream: GA,
    write: eA
  };
  let tA = gA.tokenize.call(cA, oA);
  return gA.resolveAll && QA.push(gA), cA;
  function eA(kA) {
    return EA = push(EA, kA), DA(), EA[EA.length - 1] !== null ? [] : (RA(gA, 0), cA.events = resolveAll(QA, cA.events, cA), cA.events);
  }
  function aA(kA, pA) {
    return serializeChunks(GA(kA), pA);
  }
  function GA(kA) {
    return sliceChunks(EA, kA);
  }
  function lA() {
    const {
      _bufferIndex: kA,
      _index: pA,
      line: YA,
      column: SA,
      offset: JA
    } = IA;
    return {
      _bufferIndex: kA,
      _index: pA,
      line: YA,
      column: SA,
      offset: JA
    };
  }
  function nA(kA) {
    BA[kA.line] = kA.column, dA();
  }
  function DA() {
    let kA;
    for (; IA._index < EA.length; ) {
      const pA = EA[IA._index];
      if (typeof pA == "string")
        for (kA = IA._index, IA._bufferIndex < 0 && (IA._bufferIndex = 0); IA._index === kA && IA._bufferIndex < pA.length; )
          hA(pA.charCodeAt(IA._bufferIndex));
      else
        hA(pA);
    }
  }
  function hA(kA) {
    tA = tA(kA);
  }
  function wA(kA) {
    markdownLineEnding(kA) ? (IA.line++, IA.column = 1, IA.offset += kA === -3 ? 2 : 1, dA()) : kA !== -1 && (IA.column++, IA.offset++), IA._bufferIndex < 0 ? IA._index++ : (IA._bufferIndex++, IA._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    EA[IA._index].length && (IA._bufferIndex = -1, IA._index++)), cA.previous = kA;
  }
  function sA(kA, pA) {
    const YA = pA || {};
    return YA.type = kA, YA.start = lA(), cA.events.push(["enter", YA, cA]), iA.push(YA), YA;
  }
  function NA(kA) {
    const pA = iA.pop();
    return pA.end = lA(), cA.events.push(["exit", pA, cA]), pA;
  }
  function rA(kA, pA) {
    RA(kA, pA.from);
  }
  function yA(kA, pA) {
    pA.restore();
  }
  function bA(kA, pA) {
    return YA;
    function YA(SA, JA, UA) {
      let fA, zA, _A, uA;
      return Array.isArray(SA) ? (
        /* c8 ignore next 1 */
        TA(SA)
      ) : "tokenize" in SA ? (
        // Looks like a construct.
        TA([
          /** @type {Construct} */
          SA
        ])
      ) : HA(SA);
      function HA(LA) {
        return PA;
        function PA(XA) {
          const EI = XA !== null && LA[XA], CI = XA !== null && LA.null, II = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(EI) ? EI : EI ? [EI] : [],
            ...Array.isArray(CI) ? CI : CI ? [CI] : []
          ];
          return TA(II)(XA);
        }
      }
      function TA(LA) {
        return fA = LA, zA = 0, LA.length === 0 ? UA : ZA(LA[zA]);
      }
      function ZA(LA) {
        return PA;
        function PA(XA) {
          return uA = FA(), _A = LA, LA.partial || (cA.currentConstruct = LA), LA.name && cA.parser.constructs.disable.null.includes(LA.name) ? QI() : LA.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            pA ? Object.assign(Object.create(cA), pA) : cA,
            oA,
            AI,
            QI
          )(XA);
        }
      }
      function AI(LA) {
        return kA(_A, uA), JA;
      }
      function QI(LA) {
        return uA.restore(), ++zA < fA.length ? ZA(fA[zA]) : UA;
      }
    }
  }
  function RA(kA, pA) {
    kA.resolveAll && !QA.includes(kA) && QA.push(kA), kA.resolve && splice(cA.events, pA, cA.events.length - pA, kA.resolve(cA.events.slice(pA), cA)), kA.resolveTo && (cA.events = kA.resolveTo(cA.events, cA));
  }
  function FA() {
    const kA = lA(), pA = cA.previous, YA = cA.currentConstruct, SA = cA.events.length, JA = Array.from(iA);
    return {
      from: SA,
      restore: UA
    };
    function UA() {
      IA = kA, cA.previous = pA, cA.currentConstruct = YA, cA.events.length = SA, iA = JA, dA();
    }
  }
  function dA() {
    IA.line in BA && IA.column < 2 && (IA.column = BA[IA.line], IA.offset += BA[IA.line] - 1);
  }
}
function sliceChunks(CA, gA) {
  const AA = gA.start._index, IA = gA.start._bufferIndex, BA = gA.end._index, QA = gA.end._bufferIndex;
  let EA;
  if (AA === BA)
    EA = [CA[AA].slice(IA, QA)];
  else {
    if (EA = CA.slice(AA, BA), IA > -1) {
      const iA = EA[0];
      typeof iA == "string" ? EA[0] = iA.slice(IA) : EA.shift();
    }
    QA > 0 && EA.push(CA[BA].slice(0, QA));
  }
  return EA;
}
function serializeChunks(CA, gA) {
  let AA = -1;
  const IA = [];
  let BA;
  for (; ++AA < CA.length; ) {
    const QA = CA[AA];
    let EA;
    if (typeof QA == "string")
      EA = QA;
    else switch (QA) {
      case -5: {
        EA = "\r";
        break;
      }
      case -4: {
        EA = `
`;
        break;
      }
      case -3: {
        EA = `\r
`;
        break;
      }
      case -2: {
        EA = gA ? " " : "	";
        break;
      }
      case -1: {
        if (!gA && BA) continue;
        EA = " ";
        break;
      }
      default:
        EA = String.fromCharCode(QA);
    }
    BA = QA === -2, IA.push(EA);
  }
  return IA.join("");
}
function parse$1(CA) {
  const IA = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      combineExtensions([defaultConstructs, ...(CA || {}).extensions || []])
    ),
    content: BA(content$1),
    defined: [],
    document: BA(document$2),
    flow: BA(flow$1),
    lazy: {},
    string: BA(string$1),
    text: BA(text$5)
  };
  return IA;
  function BA(QA) {
    return EA;
    function EA(iA) {
      return createTokenizer(IA, QA, iA);
    }
  }
}
function postprocess(CA) {
  for (; !subtokenize(CA); )
    ;
  return CA;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let CA = 1, gA = "", AA = !0, IA;
  return BA;
  function BA(QA, EA, iA) {
    const oA = [];
    let cA, tA, eA, aA, GA;
    for (QA = gA + (typeof QA == "string" ? QA.toString() : new TextDecoder(EA || void 0).decode(QA)), eA = 0, gA = "", AA && (QA.charCodeAt(0) === 65279 && eA++, AA = void 0); eA < QA.length; ) {
      if (search.lastIndex = eA, cA = search.exec(QA), aA = cA && cA.index !== void 0 ? cA.index : QA.length, GA = QA.charCodeAt(aA), !cA) {
        gA = QA.slice(eA);
        break;
      }
      if (GA === 10 && eA === aA && IA)
        oA.push(-3), IA = void 0;
      else
        switch (IA && (oA.push(-5), IA = void 0), eA < aA && (oA.push(QA.slice(eA, aA)), CA += aA - eA), GA) {
          case 0: {
            oA.push(65533), CA++;
            break;
          }
          case 9: {
            for (tA = Math.ceil(CA / 4) * 4, oA.push(-2); CA++ < tA; ) oA.push(-1);
            break;
          }
          case 10: {
            oA.push(-4), CA = 1;
            break;
          }
          default:
            IA = !0, CA = 1;
        }
      eA = aA + 1;
    }
    return iA && (IA && oA.push(-5), gA && oA.push(gA), oA.push(null)), oA;
  }
}
const characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function decodeString(CA) {
  return CA.replace(characterEscapeOrReference, decode$2);
}
function decode$2(CA, gA, AA) {
  if (gA)
    return gA;
  if (AA.charCodeAt(0) === 35) {
    const BA = AA.charCodeAt(1), QA = BA === 120 || BA === 88;
    return decodeNumericCharacterReference(AA.slice(QA ? 2 : 1), QA ? 16 : 10);
  }
  return decodeNamedCharacterReference(AA) || CA;
}
const own$3 = {}.hasOwnProperty;
function fromMarkdown(CA, gA, AA) {
  return typeof gA != "string" && (AA = gA, gA = void 0), compiler(AA)(postprocess(parse$1(AA).document().write(preprocess()(CA, gA, !0))));
}
function compiler(CA) {
  const gA = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: QA(hI),
      autolinkProtocol: FA,
      autolinkEmail: FA,
      atxHeading: QA(YI),
      blockQuote: QA(CI),
      characterEscape: FA,
      characterReference: FA,
      codeFenced: QA(II),
      codeFencedFenceInfo: EA,
      codeFencedFenceMeta: EA,
      codeIndented: QA(II, EA),
      codeText: QA(vA, EA),
      codeTextData: FA,
      data: FA,
      codeFlowValue: FA,
      definition: QA(wI),
      definitionDestinationString: EA,
      definitionLabelString: EA,
      definitionTitleString: EA,
      emphasis: QA($A),
      hardBreakEscape: QA(FI),
      hardBreakTrailing: QA(FI),
      htmlFlow: QA(nI, EA),
      htmlFlowData: FA,
      htmlText: QA(nI, EA),
      htmlTextData: FA,
      image: QA(uI),
      label: EA,
      link: QA(hI),
      listItem: QA(HI),
      listItemValue: aA,
      listOrdered: QA(bI, eA),
      listUnordered: QA(bI),
      paragraph: QA(UI),
      reference: ZA,
      referenceString: EA,
      resourceDestinationString: EA,
      resourceTitleString: EA,
      setextHeading: QA(YI),
      strong: QA(pI),
      thematicBreak: QA(rI)
    },
    exit: {
      atxHeading: oA(),
      atxHeadingSequence: rA,
      autolink: oA(),
      autolinkEmail: EI,
      autolinkProtocol: XA,
      blockQuote: oA(),
      characterEscapeValue: dA,
      characterReferenceMarkerHexadecimal: QI,
      characterReferenceMarkerNumeric: QI,
      characterReferenceValue: LA,
      characterReference: PA,
      codeFenced: oA(DA),
      codeFencedFence: nA,
      codeFencedFenceInfo: GA,
      codeFencedFenceMeta: lA,
      codeFlowValue: dA,
      codeIndented: oA(hA),
      codeText: oA(JA),
      codeTextData: dA,
      data: dA,
      definition: oA(),
      definitionDestinationString: NA,
      definitionLabelString: wA,
      definitionTitleString: sA,
      emphasis: oA(),
      hardBreakEscape: oA(pA),
      hardBreakTrailing: oA(pA),
      htmlFlow: oA(YA),
      htmlFlowData: dA,
      htmlText: oA(SA),
      htmlTextData: dA,
      image: oA(fA),
      label: _A,
      labelText: zA,
      lineEnding: kA,
      link: oA(UA),
      listItem: oA(),
      listOrdered: oA(),
      listUnordered: oA(),
      paragraph: oA(),
      referenceString: AI,
      resourceDestinationString: uA,
      resourceTitleString: HA,
      resource: TA,
      setextHeading: oA(RA),
      setextHeadingLineSequence: bA,
      setextHeadingText: yA,
      strong: oA(),
      thematicBreak: oA()
    }
  };
  configure(gA, (CA || {}).mdastExtensions || []);
  const AA = {};
  return IA;
  function IA(KA) {
    let OA = {
      type: "root",
      children: []
    };
    const iI = {
      stack: [OA],
      tokenStack: [],
      config: gA,
      enter: iA,
      exit: cA,
      buffer: EA,
      resume: tA,
      data: AA
    }, tI = [];
    let GI = -1;
    for (; ++GI < KA.length; )
      if (KA[GI][1].type === "listOrdered" || KA[GI][1].type === "listUnordered")
        if (KA[GI][0] === "enter")
          tI.push(GI);
        else {
          const oI = tI.pop();
          GI = BA(KA, oI, GI);
        }
    for (GI = -1; ++GI < KA.length; ) {
      const oI = gA[KA[GI][0]];
      own$3.call(oI, KA[GI][1].type) && oI[KA[GI][1].type].call(Object.assign({
        sliceSerialize: KA[GI][2].sliceSerialize
      }, iI), KA[GI][1]);
    }
    if (iI.tokenStack.length > 0) {
      const oI = iI.tokenStack[iI.tokenStack.length - 1];
      (oI[1] || defaultOnError).call(iI, void 0, oI[0]);
    }
    for (OA.position = {
      start: point(KA.length > 0 ? KA[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: point(KA.length > 0 ? KA[KA.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, GI = -1; ++GI < gA.transforms.length; )
      OA = gA.transforms[GI](OA) || OA;
    return OA;
  }
  function BA(KA, OA, iI) {
    let tI = OA - 1, GI = -1, oI = !1, eI, gI, mA, WA;
    for (; ++tI <= iI; ) {
      const xA = KA[tI];
      switch (xA[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          xA[0] === "enter" ? GI++ : GI--, WA = void 0;
          break;
        }
        case "lineEndingBlank": {
          xA[0] === "enter" && (eI && !WA && !GI && !mA && (mA = tI), WA = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          WA = void 0;
      }
      if (!GI && xA[0] === "enter" && xA[1].type === "listItemPrefix" || GI === -1 && xA[0] === "exit" && (xA[1].type === "listUnordered" || xA[1].type === "listOrdered")) {
        if (eI) {
          let qA = tI;
          for (gI = void 0; qA--; ) {
            const VA = KA[qA];
            if (VA[1].type === "lineEnding" || VA[1].type === "lineEndingBlank") {
              if (VA[0] === "exit") continue;
              gI && (KA[gI][1].type = "lineEndingBlank", oI = !0), VA[1].type = "lineEnding", gI = qA;
            } else if (!(VA[1].type === "linePrefix" || VA[1].type === "blockQuotePrefix" || VA[1].type === "blockQuotePrefixWhitespace" || VA[1].type === "blockQuoteMarker" || VA[1].type === "listItemIndent")) break;
          }
          mA && (!gI || mA < gI) && (eI._spread = !0), eI.end = Object.assign({}, gI ? KA[gI][1].start : xA[1].end), KA.splice(gI || tI, 0, ["exit", eI, xA[2]]), tI++, iI++;
        }
        if (xA[1].type === "listItemPrefix") {
          const qA = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, xA[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          eI = qA, KA.splice(tI, 0, ["enter", qA, xA[2]]), tI++, iI++, mA = void 0, WA = !0;
        }
      }
    }
    return KA[OA][1]._spread = oI, iI;
  }
  function QA(KA, OA) {
    return iI;
    function iI(tI) {
      iA.call(this, KA(tI), tI), OA && OA.call(this, tI);
    }
  }
  function EA() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function iA(KA, OA, iI) {
    this.stack[this.stack.length - 1].children.push(KA), this.stack.push(KA), this.tokenStack.push([OA, iI || void 0]), KA.position = {
      start: point(OA.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function oA(KA) {
    return OA;
    function OA(iI) {
      KA && KA.call(this, iI), cA.call(this, iI);
    }
  }
  function cA(KA, OA) {
    const iI = this.stack.pop(), tI = this.tokenStack.pop();
    if (tI)
      tI[0].type !== KA.type && (OA ? OA.call(this, KA, tI[0]) : (tI[1] || defaultOnError).call(this, KA, tI[0]));
    else throw new Error("Cannot close `" + KA.type + "` (" + stringifyPosition({
      start: KA.start,
      end: KA.end
    }) + "): it’s not open");
    iI.position.end = point(KA.end);
  }
  function tA() {
    return toString$2(this.stack.pop());
  }
  function eA() {
    this.data.expectingFirstListItemValue = !0;
  }
  function aA(KA) {
    if (this.data.expectingFirstListItemValue) {
      const OA = this.stack[this.stack.length - 2];
      OA.start = Number.parseInt(this.sliceSerialize(KA), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function GA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.lang = KA;
  }
  function lA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.meta = KA;
  }
  function nA() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function DA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.value = KA.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function hA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.value = KA.replace(/(\r?\n|\r)$/g, "");
  }
  function wA(KA) {
    const OA = this.resume(), iI = this.stack[this.stack.length - 1];
    iI.label = OA, iI.identifier = normalizeIdentifier(this.sliceSerialize(KA)).toLowerCase();
  }
  function sA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.title = KA;
  }
  function NA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.url = KA;
  }
  function rA(KA) {
    const OA = this.stack[this.stack.length - 1];
    if (!OA.depth) {
      const iI = this.sliceSerialize(KA).length;
      OA.depth = iI;
    }
  }
  function yA() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function bA(KA) {
    const OA = this.stack[this.stack.length - 1];
    OA.depth = this.sliceSerialize(KA).codePointAt(0) === 61 ? 1 : 2;
  }
  function RA() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function FA(KA) {
    const iI = this.stack[this.stack.length - 1].children;
    let tI = iI[iI.length - 1];
    (!tI || tI.type !== "text") && (tI = mI(), tI.position = {
      start: point(KA.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, iI.push(tI)), this.stack.push(tI);
  }
  function dA(KA) {
    const OA = this.stack.pop();
    OA.value += this.sliceSerialize(KA), OA.position.end = point(KA.end);
  }
  function kA(KA) {
    const OA = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const iI = OA.children[OA.children.length - 1];
      iI.position.end = point(KA.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && gA.canContainEols.includes(OA.type) && (FA.call(this, KA), dA.call(this, KA));
  }
  function pA() {
    this.data.atHardBreak = !0;
  }
  function YA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.value = KA;
  }
  function SA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.value = KA;
  }
  function JA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.value = KA;
  }
  function UA() {
    const KA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const OA = this.data.referenceType || "shortcut";
      KA.type += "Reference", KA.referenceType = OA, delete KA.url, delete KA.title;
    } else
      delete KA.identifier, delete KA.label;
    this.data.referenceType = void 0;
  }
  function fA() {
    const KA = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const OA = this.data.referenceType || "shortcut";
      KA.type += "Reference", KA.referenceType = OA, delete KA.url, delete KA.title;
    } else
      delete KA.identifier, delete KA.label;
    this.data.referenceType = void 0;
  }
  function zA(KA) {
    const OA = this.sliceSerialize(KA), iI = this.stack[this.stack.length - 2];
    iI.label = decodeString(OA), iI.identifier = normalizeIdentifier(OA).toLowerCase();
  }
  function _A() {
    const KA = this.stack[this.stack.length - 1], OA = this.resume(), iI = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, iI.type === "link") {
      const tI = KA.children;
      iI.children = tI;
    } else
      iI.alt = OA;
  }
  function uA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.url = KA;
  }
  function HA() {
    const KA = this.resume(), OA = this.stack[this.stack.length - 1];
    OA.title = KA;
  }
  function TA() {
    this.data.inReference = void 0;
  }
  function ZA() {
    this.data.referenceType = "collapsed";
  }
  function AI(KA) {
    const OA = this.resume(), iI = this.stack[this.stack.length - 1];
    iI.label = OA, iI.identifier = normalizeIdentifier(this.sliceSerialize(KA)).toLowerCase(), this.data.referenceType = "full";
  }
  function QI(KA) {
    this.data.characterReferenceType = KA.type;
  }
  function LA(KA) {
    const OA = this.sliceSerialize(KA), iI = this.data.characterReferenceType;
    let tI;
    iI ? (tI = decodeNumericCharacterReference(OA, iI === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : tI = decodeNamedCharacterReference(OA);
    const GI = this.stack[this.stack.length - 1];
    GI.value += tI;
  }
  function PA(KA) {
    const OA = this.stack.pop();
    OA.position.end = point(KA.end);
  }
  function XA(KA) {
    dA.call(this, KA);
    const OA = this.stack[this.stack.length - 1];
    OA.url = this.sliceSerialize(KA);
  }
  function EI(KA) {
    dA.call(this, KA);
    const OA = this.stack[this.stack.length - 1];
    OA.url = "mailto:" + this.sliceSerialize(KA);
  }
  function CI() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function II() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function vA() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function wI() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function $A() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function YI() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function FI() {
    return {
      type: "break"
    };
  }
  function nI() {
    return {
      type: "html",
      value: ""
    };
  }
  function uI() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function hI() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function bI(KA) {
    return {
      type: "list",
      ordered: KA.type === "listOrdered",
      start: null,
      spread: KA._spread,
      children: []
    };
  }
  function HI(KA) {
    return {
      type: "listItem",
      spread: KA._spread,
      checked: null,
      children: []
    };
  }
  function UI() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function pI() {
    return {
      type: "strong",
      children: []
    };
  }
  function mI() {
    return {
      type: "text",
      value: ""
    };
  }
  function rI() {
    return {
      type: "thematicBreak"
    };
  }
}
function point(CA) {
  return {
    line: CA.line,
    column: CA.column,
    offset: CA.offset
  };
}
function configure(CA, gA) {
  let AA = -1;
  for (; ++AA < gA.length; ) {
    const IA = gA[AA];
    Array.isArray(IA) ? configure(CA, IA) : extension(CA, IA);
  }
}
function extension(CA, gA) {
  let AA;
  for (AA in gA)
    if (own$3.call(gA, AA))
      switch (AA) {
        case "canContainEols": {
          const IA = gA[AA];
          IA && CA[AA].push(...IA);
          break;
        }
        case "transforms": {
          const IA = gA[AA];
          IA && CA[AA].push(...IA);
          break;
        }
        case "enter":
        case "exit": {
          const IA = gA[AA];
          IA && Object.assign(CA[AA], IA);
          break;
        }
      }
}
function defaultOnError(CA, gA) {
  throw CA ? new Error("Cannot close `" + CA.type + "` (" + stringifyPosition({
    start: CA.start,
    end: CA.end
  }) + "): a different token (`" + gA.type + "`, " + stringifyPosition({
    start: gA.start,
    end: gA.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + gA.type + "`, " + stringifyPosition({
    start: gA.start,
    end: gA.end
  }) + ") is still open");
}
function remarkParse(CA) {
  const gA = this;
  gA.parser = AA;
  function AA(IA) {
    return fromMarkdown(IA, {
      ...gA.data("settings"),
      ...CA,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: gA.data("micromarkExtensions") || [],
      mdastExtensions: gA.data("fromMarkdownExtensions") || []
    });
  }
}
function blockquote$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: CA.wrap(CA.all(gA), !0)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function hardBreak$1(CA, gA) {
  const AA = { type: "element", tagName: "br", properties: {}, children: [] };
  return CA.patch(gA, AA), [CA.applyData(gA, AA), { type: "text", value: `
` }];
}
function code$3(CA, gA) {
  const AA = gA.value ? gA.value + `
` : "", IA = {};
  gA.lang && (IA.className = ["language-" + gA.lang]);
  let BA = {
    type: "element",
    tagName: "code",
    properties: IA,
    children: [{ type: "text", value: AA }]
  };
  return gA.meta && (BA.data = { meta: gA.meta }), CA.patch(gA, BA), BA = CA.applyData(gA, BA), BA = { type: "element", tagName: "pre", properties: {}, children: [BA] }, CA.patch(gA, BA), BA;
}
function strikethrough(CA, gA) {
  const AA = {
    type: "element",
    tagName: "del",
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function emphasis$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "em",
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function footnoteReference$1(CA, gA) {
  const AA = typeof CA.options.clobberPrefix == "string" ? CA.options.clobberPrefix : "user-content-", IA = String(gA.identifier).toUpperCase(), BA = normalizeUri(IA.toLowerCase()), QA = CA.footnoteOrder.indexOf(IA);
  let EA, iA = CA.footnoteCounts.get(IA);
  iA === void 0 ? (iA = 0, CA.footnoteOrder.push(IA), EA = CA.footnoteOrder.length) : EA = QA + 1, iA += 1, CA.footnoteCounts.set(IA, iA);
  const oA = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + AA + "fn-" + BA,
      id: AA + "fnref-" + BA + (iA > 1 ? "-" + iA : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(EA) }]
  };
  CA.patch(gA, oA);
  const cA = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [oA]
  };
  return CA.patch(gA, cA), CA.applyData(gA, cA);
}
function heading$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "h" + gA.depth,
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function html$1(CA, gA) {
  if (CA.options.allowDangerousHtml) {
    const AA = { type: "raw", value: gA.value };
    return CA.patch(gA, AA), CA.applyData(gA, AA);
  }
}
function revert(CA, gA) {
  const AA = gA.referenceType;
  let IA = "]";
  if (AA === "collapsed" ? IA += "[]" : AA === "full" && (IA += "[" + (gA.label || gA.identifier) + "]"), gA.type === "imageReference")
    return [{ type: "text", value: "![" + gA.alt + IA }];
  const BA = CA.all(gA), QA = BA[0];
  QA && QA.type === "text" ? QA.value = "[" + QA.value : BA.unshift({ type: "text", value: "[" });
  const EA = BA[BA.length - 1];
  return EA && EA.type === "text" ? EA.value += IA : BA.push({ type: "text", value: IA }), BA;
}
function imageReference$1(CA, gA) {
  const AA = String(gA.identifier).toUpperCase(), IA = CA.definitionById.get(AA);
  if (!IA)
    return revert(CA, gA);
  const BA = { src: normalizeUri(IA.url || ""), alt: gA.alt };
  IA.title !== null && IA.title !== void 0 && (BA.title = IA.title);
  const QA = { type: "element", tagName: "img", properties: BA, children: [] };
  return CA.patch(gA, QA), CA.applyData(gA, QA);
}
function image$1(CA, gA) {
  const AA = { src: normalizeUri(gA.url) };
  gA.alt !== null && gA.alt !== void 0 && (AA.alt = gA.alt), gA.title !== null && gA.title !== void 0 && (AA.title = gA.title);
  const IA = { type: "element", tagName: "img", properties: AA, children: [] };
  return CA.patch(gA, IA), CA.applyData(gA, IA);
}
function inlineCode$1(CA, gA) {
  const AA = { type: "text", value: gA.value.replace(/\r?\n|\r/g, " ") };
  CA.patch(gA, AA);
  const IA = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [AA]
  };
  return CA.patch(gA, IA), CA.applyData(gA, IA);
}
function linkReference$1(CA, gA) {
  const AA = String(gA.identifier).toUpperCase(), IA = CA.definitionById.get(AA);
  if (!IA)
    return revert(CA, gA);
  const BA = { href: normalizeUri(IA.url || "") };
  IA.title !== null && IA.title !== void 0 && (BA.title = IA.title);
  const QA = {
    type: "element",
    tagName: "a",
    properties: BA,
    children: CA.all(gA)
  };
  return CA.patch(gA, QA), CA.applyData(gA, QA);
}
function link$1(CA, gA) {
  const AA = { href: normalizeUri(gA.url) };
  gA.title !== null && gA.title !== void 0 && (AA.title = gA.title);
  const IA = {
    type: "element",
    tagName: "a",
    properties: AA,
    children: CA.all(gA)
  };
  return CA.patch(gA, IA), CA.applyData(gA, IA);
}
function listItem$1(CA, gA, AA) {
  const IA = CA.all(gA), BA = AA ? listLoose(AA) : listItemLoose(gA), QA = {}, EA = [];
  if (typeof gA.checked == "boolean") {
    const tA = IA[0];
    let eA;
    tA && tA.type === "element" && tA.tagName === "p" ? eA = tA : (eA = { type: "element", tagName: "p", properties: {}, children: [] }, IA.unshift(eA)), eA.children.length > 0 && eA.children.unshift({ type: "text", value: " " }), eA.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: gA.checked, disabled: !0 },
      children: []
    }), QA.className = ["task-list-item"];
  }
  let iA = -1;
  for (; ++iA < IA.length; ) {
    const tA = IA[iA];
    (BA || iA !== 0 || tA.type !== "element" || tA.tagName !== "p") && EA.push({ type: "text", value: `
` }), tA.type === "element" && tA.tagName === "p" && !BA ? EA.push(...tA.children) : EA.push(tA);
  }
  const oA = IA[IA.length - 1];
  oA && (BA || oA.type !== "element" || oA.tagName !== "p") && EA.push({ type: "text", value: `
` });
  const cA = { type: "element", tagName: "li", properties: QA, children: EA };
  return CA.patch(gA, cA), CA.applyData(gA, cA);
}
function listLoose(CA) {
  let gA = !1;
  if (CA.type === "list") {
    gA = CA.spread || !1;
    const AA = CA.children;
    let IA = -1;
    for (; !gA && ++IA < AA.length; )
      gA = listItemLoose(AA[IA]);
  }
  return gA;
}
function listItemLoose(CA) {
  const gA = CA.spread;
  return gA ?? CA.children.length > 1;
}
function list$1(CA, gA) {
  const AA = {}, IA = CA.all(gA);
  let BA = -1;
  for (typeof gA.start == "number" && gA.start !== 1 && (AA.start = gA.start); ++BA < IA.length; ) {
    const EA = IA[BA];
    if (EA.type === "element" && EA.tagName === "li" && EA.properties && Array.isArray(EA.properties.className) && EA.properties.className.includes("task-list-item")) {
      AA.className = ["contains-task-list"];
      break;
    }
  }
  const QA = {
    type: "element",
    tagName: gA.ordered ? "ol" : "ul",
    properties: AA,
    children: CA.wrap(IA, !0)
  };
  return CA.patch(gA, QA), CA.applyData(gA, QA);
}
function paragraph$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "p",
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function root$2(CA, gA) {
  const AA = { type: "root", children: CA.wrap(CA.all(gA)) };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function strong$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function table(CA, gA) {
  const AA = CA.all(gA), IA = AA.shift(), BA = [];
  if (IA) {
    const EA = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: CA.wrap([IA], !0)
    };
    CA.patch(gA.children[0], EA), BA.push(EA);
  }
  if (AA.length > 0) {
    const EA = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: CA.wrap(AA, !0)
    }, iA = pointStart(gA.children[1]), oA = pointEnd(gA.children[gA.children.length - 1]);
    iA && oA && (EA.position = { start: iA, end: oA }), BA.push(EA);
  }
  const QA = {
    type: "element",
    tagName: "table",
    properties: {},
    children: CA.wrap(BA, !0)
  };
  return CA.patch(gA, QA), CA.applyData(gA, QA);
}
function tableRow(CA, gA, AA) {
  const IA = AA ? AA.children : void 0, QA = (IA ? IA.indexOf(gA) : 1) === 0 ? "th" : "td", EA = AA && AA.type === "table" ? AA.align : void 0, iA = EA ? EA.length : gA.children.length;
  let oA = -1;
  const cA = [];
  for (; ++oA < iA; ) {
    const eA = gA.children[oA], aA = {}, GA = EA ? EA[oA] : void 0;
    GA && (aA.align = GA);
    let lA = { type: "element", tagName: QA, properties: aA, children: [] };
    eA && (lA.children = CA.all(eA), CA.patch(eA, lA), lA = CA.applyData(eA, lA)), cA.push(lA);
  }
  const tA = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: CA.wrap(cA, !0)
  };
  return CA.patch(gA, tA), CA.applyData(gA, tA);
}
function tableCell(CA, gA) {
  const AA = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
const tab = 9, space = 32;
function trimLines(CA) {
  const gA = String(CA), AA = /\r?\n|\r/g;
  let IA = AA.exec(gA), BA = 0;
  const QA = [];
  for (; IA; )
    QA.push(
      trimLine(gA.slice(BA, IA.index), BA > 0, !0),
      IA[0]
    ), BA = IA.index + IA[0].length, IA = AA.exec(gA);
  return QA.push(trimLine(gA.slice(BA), BA > 0, !1)), QA.join("");
}
function trimLine(CA, gA, AA) {
  let IA = 0, BA = CA.length;
  if (gA) {
    let QA = CA.codePointAt(IA);
    for (; QA === tab || QA === space; )
      IA++, QA = CA.codePointAt(IA);
  }
  if (AA) {
    let QA = CA.codePointAt(BA - 1);
    for (; QA === tab || QA === space; )
      BA--, QA = CA.codePointAt(BA - 1);
  }
  return BA > IA ? CA.slice(IA, BA) : "";
}
function text$3(CA, gA) {
  const AA = { type: "text", value: trimLines(String(gA.value)) };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
function thematicBreak$1(CA, gA) {
  const AA = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return CA.patch(gA, AA), CA.applyData(gA, AA);
}
const handlers = {
  blockquote: blockquote$1,
  break: hardBreak$1,
  code: code$3,
  delete: strikethrough,
  emphasis: emphasis$1,
  footnoteReference: footnoteReference$1,
  heading: heading$1,
  html: html$1,
  imageReference: imageReference$1,
  image: image$1,
  inlineCode: inlineCode$1,
  linkReference: linkReference$1,
  link: link$1,
  listItem: listItem$1,
  list: list$1,
  paragraph: paragraph$1,
  // @ts-expect-error: root is different, but hard to type.
  root: root$2,
  strong: strong$1,
  table,
  tableCell,
  tableRow,
  text: text$3,
  thematicBreak: thematicBreak$1,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
}
const VOID = -1, PRIMITIVE = 0, ARRAY = 1, OBJECT = 2, DATE = 3, REGEXP = 4, MAP = 5, SET = 6, ERROR = 7, BIGINT = 8, env = typeof self == "object" ? self : globalThis, deserializer = (CA, gA) => {
  const AA = (BA, QA) => (CA.set(QA, BA), BA), IA = (BA) => {
    if (CA.has(BA))
      return CA.get(BA);
    const [QA, EA] = gA[BA];
    switch (QA) {
      case PRIMITIVE:
      case VOID:
        return AA(EA, BA);
      case ARRAY: {
        const iA = AA([], BA);
        for (const oA of EA)
          iA.push(IA(oA));
        return iA;
      }
      case OBJECT: {
        const iA = AA({}, BA);
        for (const [oA, cA] of EA)
          iA[IA(oA)] = IA(cA);
        return iA;
      }
      case DATE:
        return AA(new Date(EA), BA);
      case REGEXP: {
        const { source: iA, flags: oA } = EA;
        return AA(new RegExp(iA, oA), BA);
      }
      case MAP: {
        const iA = AA(/* @__PURE__ */ new Map(), BA);
        for (const [oA, cA] of EA)
          iA.set(IA(oA), IA(cA));
        return iA;
      }
      case SET: {
        const iA = AA(/* @__PURE__ */ new Set(), BA);
        for (const oA of EA)
          iA.add(IA(oA));
        return iA;
      }
      case ERROR: {
        const { name: iA, message: oA } = EA;
        return AA(new env[iA](oA), BA);
      }
      case BIGINT:
        return AA(BigInt(EA), BA);
      case "BigInt":
        return AA(Object(BigInt(EA)), BA);
      case "ArrayBuffer":
        return AA(new Uint8Array(EA).buffer, EA);
      case "DataView": {
        const { buffer: iA } = new Uint8Array(EA);
        return AA(new DataView(iA), EA);
      }
    }
    return AA(new env[QA](EA), BA);
  };
  return IA;
}, deserialize = (CA) => deserializer(/* @__PURE__ */ new Map(), CA)(0), EMPTY = "", { toString: toString$1 } = {}, { keys } = Object, typeOf = (CA) => {
  const gA = typeof CA;
  if (gA !== "object" || !CA)
    return [PRIMITIVE, gA];
  const AA = toString$1.call(CA).slice(8, -1);
  switch (AA) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, AA];
  }
  return AA.includes("Array") ? [ARRAY, AA] : AA.includes("Error") ? [ERROR, AA] : [OBJECT, AA];
}, shouldSkip = ([CA, gA]) => CA === PRIMITIVE && (gA === "function" || gA === "symbol"), serializer = (CA, gA, AA, IA) => {
  const BA = (EA, iA) => {
    const oA = IA.push(EA) - 1;
    return AA.set(iA, oA), oA;
  }, QA = (EA) => {
    if (AA.has(EA))
      return AA.get(EA);
    let [iA, oA] = typeOf(EA);
    switch (iA) {
      case PRIMITIVE: {
        let tA = EA;
        switch (oA) {
          case "bigint":
            iA = BIGINT, tA = EA.toString();
            break;
          case "function":
          case "symbol":
            if (CA)
              throw new TypeError("unable to serialize " + oA);
            tA = null;
            break;
          case "undefined":
            return BA([VOID], EA);
        }
        return BA([iA, tA], EA);
      }
      case ARRAY: {
        if (oA) {
          let aA = EA;
          return oA === "DataView" ? aA = new Uint8Array(EA.buffer) : oA === "ArrayBuffer" && (aA = new Uint8Array(EA)), BA([oA, [...aA]], EA);
        }
        const tA = [], eA = BA([iA, tA], EA);
        for (const aA of EA)
          tA.push(QA(aA));
        return eA;
      }
      case OBJECT: {
        if (oA)
          switch (oA) {
            case "BigInt":
              return BA([oA, EA.toString()], EA);
            case "Boolean":
            case "Number":
            case "String":
              return BA([oA, EA.valueOf()], EA);
          }
        if (gA && "toJSON" in EA)
          return QA(EA.toJSON());
        const tA = [], eA = BA([iA, tA], EA);
        for (const aA of keys(EA))
          (CA || !shouldSkip(typeOf(EA[aA]))) && tA.push([QA(aA), QA(EA[aA])]);
        return eA;
      }
      case DATE:
        return BA([iA, EA.toISOString()], EA);
      case REGEXP: {
        const { source: tA, flags: eA } = EA;
        return BA([iA, { source: tA, flags: eA }], EA);
      }
      case MAP: {
        const tA = [], eA = BA([iA, tA], EA);
        for (const [aA, GA] of EA)
          (CA || !(shouldSkip(typeOf(aA)) || shouldSkip(typeOf(GA)))) && tA.push([QA(aA), QA(GA)]);
        return eA;
      }
      case SET: {
        const tA = [], eA = BA([iA, tA], EA);
        for (const aA of EA)
          (CA || !shouldSkip(typeOf(aA))) && tA.push(QA(aA));
        return eA;
      }
    }
    const { message: cA } = EA;
    return BA([iA, { name: oA, message: cA }], EA);
  };
  return QA;
}, serialize$1 = (CA, { json: gA, lossy: AA } = {}) => {
  const IA = [];
  return serializer(!(gA || AA), !!gA, /* @__PURE__ */ new Map(), IA)(CA), IA;
}, structuredClone$1 = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (CA, gA) => gA && ("json" in gA || "lossy" in gA) ? deserialize(serialize$1(CA, gA)) : structuredClone(CA)
) : (CA, gA) => deserialize(serialize$1(CA, gA));
function defaultFootnoteBackContent(CA, gA) {
  const AA = [{ type: "text", value: "↩" }];
  return gA > 1 && AA.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(gA) }]
  }), AA;
}
function defaultFootnoteBackLabel(CA, gA) {
  return "Back to reference " + (CA + 1) + (gA > 1 ? "-" + gA : "");
}
function footer(CA) {
  const gA = typeof CA.options.clobberPrefix == "string" ? CA.options.clobberPrefix : "user-content-", AA = CA.options.footnoteBackContent || defaultFootnoteBackContent, IA = CA.options.footnoteBackLabel || defaultFootnoteBackLabel, BA = CA.options.footnoteLabel || "Footnotes", QA = CA.options.footnoteLabelTagName || "h2", EA = CA.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, iA = [];
  let oA = -1;
  for (; ++oA < CA.footnoteOrder.length; ) {
    const cA = CA.footnoteById.get(
      CA.footnoteOrder[oA]
    );
    if (!cA)
      continue;
    const tA = CA.all(cA), eA = String(cA.identifier).toUpperCase(), aA = normalizeUri(eA.toLowerCase());
    let GA = 0;
    const lA = [], nA = CA.footnoteCounts.get(eA);
    for (; nA !== void 0 && ++GA <= nA; ) {
      lA.length > 0 && lA.push({ type: "text", value: " " });
      let wA = typeof AA == "string" ? AA : AA(oA, GA);
      typeof wA == "string" && (wA = { type: "text", value: wA }), lA.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + gA + "fnref-" + aA + (GA > 1 ? "-" + GA : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof IA == "string" ? IA : IA(oA, GA),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(wA) ? wA : [wA]
      });
    }
    const DA = tA[tA.length - 1];
    if (DA && DA.type === "element" && DA.tagName === "p") {
      const wA = DA.children[DA.children.length - 1];
      wA && wA.type === "text" ? wA.value += " " : DA.children.push({ type: "text", value: " " }), DA.children.push(...lA);
    } else
      tA.push(...lA);
    const hA = {
      type: "element",
      tagName: "li",
      properties: { id: gA + "fn-" + aA },
      children: CA.wrap(tA, !0)
    };
    CA.patch(cA, hA), iA.push(hA);
  }
  if (iA.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: QA,
          properties: {
            ...structuredClone$1(EA),
            id: "footnote-label"
          },
          children: [{ type: "text", value: BA }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: CA.wrap(iA, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function visit$3(CA, gA, AA, IA) {
  let BA, QA, EA;
  typeof gA == "function" && typeof AA != "function" ? (QA = void 0, EA = gA, BA = AA) : (QA = gA, EA = AA, BA = IA), visitParents(CA, QA, iA, BA);
  function iA(oA, cA) {
    const tA = cA[cA.length - 1], eA = tA ? tA.children.indexOf(oA) : void 0;
    return EA(oA, eA, tA);
  }
}
const own$2 = {}.hasOwnProperty, emptyOptions$3 = {};
function createState(CA, gA) {
  const AA = gA || emptyOptions$3, IA = /* @__PURE__ */ new Map(), BA = /* @__PURE__ */ new Map(), QA = /* @__PURE__ */ new Map(), EA = { ...handlers, ...AA.handlers }, iA = {
    all: cA,
    applyData,
    definitionById: IA,
    footnoteById: BA,
    footnoteCounts: QA,
    footnoteOrder: [],
    handlers: EA,
    one: oA,
    options: AA,
    patch,
    wrap: wrap$1
  };
  return visit$3(CA, function(tA) {
    if (tA.type === "definition" || tA.type === "footnoteDefinition") {
      const eA = tA.type === "definition" ? IA : BA, aA = String(tA.identifier).toUpperCase();
      eA.has(aA) || eA.set(aA, tA);
    }
  }), iA;
  function oA(tA, eA) {
    const aA = tA.type, GA = iA.handlers[aA];
    if (own$2.call(iA.handlers, aA) && GA)
      return GA(iA, tA, eA);
    if (iA.options.passThrough && iA.options.passThrough.includes(aA)) {
      if ("children" in tA) {
        const { children: nA, ...DA } = tA, hA = structuredClone$1(DA);
        return hA.children = iA.all(tA), hA;
      }
      return structuredClone$1(tA);
    }
    return (iA.options.unknownHandler || defaultUnknownHandler)(iA, tA, eA);
  }
  function cA(tA) {
    const eA = [];
    if ("children" in tA) {
      const aA = tA.children;
      let GA = -1;
      for (; ++GA < aA.length; ) {
        const lA = iA.one(aA[GA], tA);
        if (lA) {
          if (GA && aA[GA - 1].type === "break" && (!Array.isArray(lA) && lA.type === "text" && (lA.value = trimMarkdownSpaceStart(lA.value)), !Array.isArray(lA) && lA.type === "element")) {
            const nA = lA.children[0];
            nA && nA.type === "text" && (nA.value = trimMarkdownSpaceStart(nA.value));
          }
          Array.isArray(lA) ? eA.push(...lA) : eA.push(lA);
        }
      }
    }
    return eA;
  }
}
function patch(CA, gA) {
  CA.position && (gA.position = position$2(CA));
}
function applyData(CA, gA) {
  let AA = gA;
  if (CA && CA.data) {
    const IA = CA.data.hName, BA = CA.data.hChildren, QA = CA.data.hProperties;
    if (typeof IA == "string")
      if (AA.type === "element")
        AA.tagName = IA;
      else {
        const EA = "children" in AA ? AA.children : [AA];
        AA = { type: "element", tagName: IA, properties: {}, children: EA };
      }
    AA.type === "element" && QA && Object.assign(AA.properties, structuredClone$1(QA)), "children" in AA && AA.children && BA !== null && BA !== void 0 && (AA.children = BA);
  }
  return AA;
}
function defaultUnknownHandler(CA, gA) {
  const AA = gA.data || {}, IA = "value" in gA && !(own$2.call(AA, "hProperties") || own$2.call(AA, "hChildren")) ? { type: "text", value: gA.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: CA.all(gA)
  };
  return CA.patch(gA, IA), CA.applyData(gA, IA);
}
function wrap$1(CA, gA) {
  const AA = [];
  let IA = -1;
  for (gA && AA.push({ type: "text", value: `
` }); ++IA < CA.length; )
    IA && AA.push({ type: "text", value: `
` }), AA.push(CA[IA]);
  return gA && CA.length > 0 && AA.push({ type: "text", value: `
` }), AA;
}
function trimMarkdownSpaceStart(CA) {
  let gA = 0, AA = CA.charCodeAt(gA);
  for (; AA === 9 || AA === 32; )
    gA++, AA = CA.charCodeAt(gA);
  return CA.slice(gA);
}
function toHast(CA, gA) {
  const AA = createState(CA, gA), IA = AA.one(CA, void 0), BA = footer(AA), QA = Array.isArray(IA) ? { type: "root", children: IA } : IA || { type: "root", children: [] };
  return BA && QA.children.push({ type: "text", value: `
` }, BA), QA;
}
function remarkRehype(CA, gA) {
  return CA && "run" in CA ? async function(AA, IA) {
    const BA = (
      /** @type {HastRoot} */
      toHast(AA, { file: IA, ...gA })
    );
    await CA.run(BA, IA);
  } : function(AA, IA) {
    return (
      /** @type {HastRoot} */
      toHast(AA, { file: IA, ...CA || gA })
    );
  };
}
function bail(CA) {
  if (CA)
    throw CA;
}
var extend$1, hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$1;
  hasRequiredExtend = 1;
  var CA = Object.prototype.hasOwnProperty, gA = Object.prototype.toString, AA = Object.defineProperty, IA = Object.getOwnPropertyDescriptor, BA = function(cA) {
    return typeof Array.isArray == "function" ? Array.isArray(cA) : gA.call(cA) === "[object Array]";
  }, QA = function(cA) {
    if (!cA || gA.call(cA) !== "[object Object]")
      return !1;
    var tA = CA.call(cA, "constructor"), eA = cA.constructor && cA.constructor.prototype && CA.call(cA.constructor.prototype, "isPrototypeOf");
    if (cA.constructor && !tA && !eA)
      return !1;
    var aA;
    for (aA in cA)
      ;
    return typeof aA > "u" || CA.call(cA, aA);
  }, EA = function(cA, tA) {
    AA && tA.name === "__proto__" ? AA(cA, tA.name, {
      enumerable: !0,
      configurable: !0,
      value: tA.newValue,
      writable: !0
    }) : cA[tA.name] = tA.newValue;
  }, iA = function(cA, tA) {
    if (tA === "__proto__")
      if (CA.call(cA, tA)) {
        if (IA)
          return IA(cA, tA).value;
      } else return;
    return cA[tA];
  };
  return extend$1 = function oA() {
    var cA, tA, eA, aA, GA, lA, nA = arguments[0], DA = 1, hA = arguments.length, wA = !1;
    for (typeof nA == "boolean" && (wA = nA, nA = arguments[1] || {}, DA = 2), (nA == null || typeof nA != "object" && typeof nA != "function") && (nA = {}); DA < hA; ++DA)
      if (cA = arguments[DA], cA != null)
        for (tA in cA)
          eA = iA(nA, tA), aA = iA(cA, tA), nA !== aA && (wA && aA && (QA(aA) || (GA = BA(aA))) ? (GA ? (GA = !1, lA = eA && BA(eA) ? eA : []) : lA = eA && QA(eA) ? eA : {}, EA(nA, { name: tA, newValue: oA(wA, lA, aA) })) : typeof aA < "u" && EA(nA, { name: tA, newValue: aA }));
    return nA;
  }, extend$1;
}
var extendExports = requireExtend();
const extend = /* @__PURE__ */ getDefaultExportFromCjs(extendExports);
function isPlainObject$1(CA) {
  if (typeof CA != "object" || CA === null)
    return !1;
  const gA = Object.getPrototypeOf(CA);
  return (gA === null || gA === Object.prototype || Object.getPrototypeOf(gA) === null) && !(Symbol.toStringTag in CA) && !(Symbol.iterator in CA);
}
function trough() {
  const CA = [], gA = { run: AA, use: IA };
  return gA;
  function AA(...BA) {
    let QA = -1;
    const EA = BA.pop();
    if (typeof EA != "function")
      throw new TypeError("Expected function as last argument, not " + EA);
    iA(null, ...BA);
    function iA(oA, ...cA) {
      const tA = CA[++QA];
      let eA = -1;
      if (oA) {
        EA(oA);
        return;
      }
      for (; ++eA < BA.length; )
        (cA[eA] === null || cA[eA] === void 0) && (cA[eA] = BA[eA]);
      BA = cA, tA ? wrap(tA, iA)(...cA) : EA(null, ...cA);
    }
  }
  function IA(BA) {
    if (typeof BA != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + BA
      );
    return CA.push(BA), gA;
  }
}
function wrap(CA, gA) {
  let AA;
  return IA;
  function IA(...EA) {
    const iA = CA.length > EA.length;
    let oA;
    iA && EA.push(BA);
    try {
      oA = CA.apply(this, EA);
    } catch (cA) {
      const tA = (
        /** @type {Error} */
        cA
      );
      if (iA && AA)
        throw tA;
      return BA(tA);
    }
    iA || (oA && oA.then && typeof oA.then == "function" ? oA.then(QA, BA) : oA instanceof Error ? BA(oA) : QA(oA));
  }
  function BA(EA, ...iA) {
    AA || (AA = !0, gA(EA, ...iA));
  }
  function QA(EA) {
    BA(null, EA);
  }
}
const minpath = { basename, dirname, extname, join, sep: "/" };
function basename(CA, gA) {
  if (gA !== void 0 && typeof gA != "string")
    throw new TypeError('"ext" argument must be a string');
  assertPath$1(CA);
  let AA = 0, IA = -1, BA = CA.length, QA;
  if (gA === void 0 || gA.length === 0 || gA.length > CA.length) {
    for (; BA--; )
      if (CA.codePointAt(BA) === 47) {
        if (QA) {
          AA = BA + 1;
          break;
        }
      } else IA < 0 && (QA = !0, IA = BA + 1);
    return IA < 0 ? "" : CA.slice(AA, IA);
  }
  if (gA === CA)
    return "";
  let EA = -1, iA = gA.length - 1;
  for (; BA--; )
    if (CA.codePointAt(BA) === 47) {
      if (QA) {
        AA = BA + 1;
        break;
      }
    } else
      EA < 0 && (QA = !0, EA = BA + 1), iA > -1 && (CA.codePointAt(BA) === gA.codePointAt(iA--) ? iA < 0 && (IA = BA) : (iA = -1, IA = EA));
  return AA === IA ? IA = EA : IA < 0 && (IA = CA.length), CA.slice(AA, IA);
}
function dirname(CA) {
  if (assertPath$1(CA), CA.length === 0)
    return ".";
  let gA = -1, AA = CA.length, IA;
  for (; --AA; )
    if (CA.codePointAt(AA) === 47) {
      if (IA) {
        gA = AA;
        break;
      }
    } else IA || (IA = !0);
  return gA < 0 ? CA.codePointAt(0) === 47 ? "/" : "." : gA === 1 && CA.codePointAt(0) === 47 ? "//" : CA.slice(0, gA);
}
function extname(CA) {
  assertPath$1(CA);
  let gA = CA.length, AA = -1, IA = 0, BA = -1, QA = 0, EA;
  for (; gA--; ) {
    const iA = CA.codePointAt(gA);
    if (iA === 47) {
      if (EA) {
        IA = gA + 1;
        break;
      }
      continue;
    }
    AA < 0 && (EA = !0, AA = gA + 1), iA === 46 ? BA < 0 ? BA = gA : QA !== 1 && (QA = 1) : BA > -1 && (QA = -1);
  }
  return BA < 0 || AA < 0 || // We saw a non-dot character immediately before the dot.
  QA === 0 || // The (right-most) trimmed path component is exactly `..`.
  QA === 1 && BA === AA - 1 && BA === IA + 1 ? "" : CA.slice(BA, AA);
}
function join(...CA) {
  let gA = -1, AA;
  for (; ++gA < CA.length; )
    assertPath$1(CA[gA]), CA[gA] && (AA = AA === void 0 ? CA[gA] : AA + "/" + CA[gA]);
  return AA === void 0 ? "." : normalize(AA);
}
function normalize(CA) {
  assertPath$1(CA);
  const gA = CA.codePointAt(0) === 47;
  let AA = normalizeString(CA, !gA);
  return AA.length === 0 && !gA && (AA = "."), AA.length > 0 && CA.codePointAt(CA.length - 1) === 47 && (AA += "/"), gA ? "/" + AA : AA;
}
function normalizeString(CA, gA) {
  let AA = "", IA = 0, BA = -1, QA = 0, EA = -1, iA, oA;
  for (; ++EA <= CA.length; ) {
    if (EA < CA.length)
      iA = CA.codePointAt(EA);
    else {
      if (iA === 47)
        break;
      iA = 47;
    }
    if (iA === 47) {
      if (!(BA === EA - 1 || QA === 1)) if (BA !== EA - 1 && QA === 2) {
        if (AA.length < 2 || IA !== 2 || AA.codePointAt(AA.length - 1) !== 46 || AA.codePointAt(AA.length - 2) !== 46) {
          if (AA.length > 2) {
            if (oA = AA.lastIndexOf("/"), oA !== AA.length - 1) {
              oA < 0 ? (AA = "", IA = 0) : (AA = AA.slice(0, oA), IA = AA.length - 1 - AA.lastIndexOf("/")), BA = EA, QA = 0;
              continue;
            }
          } else if (AA.length > 0) {
            AA = "", IA = 0, BA = EA, QA = 0;
            continue;
          }
        }
        gA && (AA = AA.length > 0 ? AA + "/.." : "..", IA = 2);
      } else
        AA.length > 0 ? AA += "/" + CA.slice(BA + 1, EA) : AA = CA.slice(BA + 1, EA), IA = EA - BA - 1;
      BA = EA, QA = 0;
    } else iA === 46 && QA > -1 ? QA++ : QA = -1;
  }
  return AA;
}
function assertPath$1(CA) {
  if (typeof CA != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(CA)
    );
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(CA) {
  return !!(CA !== null && typeof CA == "object" && "href" in CA && CA.href && "protocol" in CA && CA.protocol && // @ts-expect-error: indexing is fine.
  CA.auth === void 0);
}
function urlToPath(CA) {
  if (typeof CA == "string")
    CA = new URL(CA);
  else if (!isUrl(CA)) {
    const gA = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + CA + "`"
    );
    throw gA.code = "ERR_INVALID_ARG_TYPE", gA;
  }
  if (CA.protocol !== "file:") {
    const gA = new TypeError("The URL must be of scheme file");
    throw gA.code = "ERR_INVALID_URL_SCHEME", gA;
  }
  return getPathFromURLPosix(CA);
}
function getPathFromURLPosix(CA) {
  if (CA.hostname !== "") {
    const IA = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw IA.code = "ERR_INVALID_FILE_URL_HOST", IA;
  }
  const gA = CA.pathname;
  let AA = -1;
  for (; ++AA < gA.length; )
    if (gA.codePointAt(AA) === 37 && gA.codePointAt(AA + 1) === 50) {
      const IA = gA.codePointAt(AA + 2);
      if (IA === 70 || IA === 102) {
        const BA = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw BA.code = "ERR_INVALID_FILE_URL_PATH", BA;
      }
    }
  return decodeURIComponent(gA);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(gA) {
    let AA;
    gA ? isUrl(gA) ? AA = { path: gA } : typeof gA == "string" || isUint8Array$1(gA) ? AA = { value: gA } : AA = gA : AA = {}, this.cwd = "cwd" in AA ? "" : minproc.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let IA = -1;
    for (; ++IA < order.length; ) {
      const QA = order[IA];
      QA in AA && AA[QA] !== void 0 && AA[QA] !== null && (this[QA] = QA === "history" ? [...AA[QA]] : AA[QA]);
    }
    let BA;
    for (BA in AA)
      order.includes(BA) || (this[BA] = AA[BA]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(gA) {
    assertNonEmpty(gA, "basename"), assertPart(gA, "basename"), this.path = minpath.join(this.dirname || "", gA);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(gA) {
    assertPath(this.basename, "dirname"), this.path = minpath.join(gA || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(gA) {
    if (assertPart(gA, "extname"), assertPath(this.dirname, "extname"), gA) {
      if (gA.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (gA.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = minpath.join(this.dirname, this.stem + (gA || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(gA) {
    isUrl(gA) && (gA = urlToPath(gA)), assertNonEmpty(gA, "path"), this.path !== gA && this.history.push(gA);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(gA) {
    assertNonEmpty(gA, "stem"), assertPart(gA, "stem"), this.path = minpath.join(this.dirname || "", gA + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(gA, AA, IA) {
    const BA = this.message(gA, AA, IA);
    throw BA.fatal = !0, BA;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(gA, AA, IA) {
    const BA = this.message(gA, AA, IA);
    return BA.fatal = void 0, BA;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(gA, AA, IA) {
    const BA = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      gA,
      AA,
      IA
    );
    return this.path && (BA.name = this.path + ":" + BA.name, BA.file = this.path), BA.fatal = !1, this.messages.push(BA), BA;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(gA) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(gA || void 0).decode(this.value);
  }
}
function assertPart(CA, gA) {
  if (CA && CA.includes(minpath.sep))
    throw new Error(
      "`" + gA + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
}
function assertNonEmpty(CA, gA) {
  if (!CA)
    throw new Error("`" + gA + "` cannot be empty");
}
function assertPath(CA, gA) {
  if (!CA)
    throw new Error("Setting `" + gA + "` requires `path` to be set too");
}
function isUint8Array$1(CA) {
  return !!(CA && typeof CA == "object" && "byteLength" in CA && "byteOffset" in CA);
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(CA) {
    const IA = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), BA = IA[CA], QA = function() {
      return BA.apply(QA, arguments);
    };
    return Object.setPrototypeOf(QA, IA), QA;
  })
), own$1 = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const gA = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let AA = -1;
    for (; ++AA < this.attachers.length; ) {
      const IA = this.attachers[AA];
      gA.use(...IA);
    }
    return gA.data(extend(!0, {}, this.namespace)), gA;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(gA, AA) {
    return typeof gA == "string" ? arguments.length === 2 ? (assertUnfrozen("data", this.frozen), this.namespace[gA] = AA, this) : own$1.call(this.namespace, gA) && this.namespace[gA] || void 0 : gA ? (assertUnfrozen("data", this.frozen), this.namespace = gA, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const gA = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [AA, ...IA] = this.attachers[this.freezeIndex];
      if (IA[0] === !1)
        continue;
      IA[0] === !0 && (IA[0] = void 0);
      const BA = AA.call(gA, ...IA);
      typeof BA == "function" && this.transformers.use(BA);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(gA) {
    this.freeze();
    const AA = vfile(gA), IA = this.parser || this.Parser;
    return assertParser("parse", IA), IA(String(AA), AA);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(gA, AA) {
    const IA = this;
    return this.freeze(), assertParser("process", this.parser || this.Parser), assertCompiler("process", this.compiler || this.Compiler), AA ? BA(void 0, AA) : new Promise(BA);
    function BA(QA, EA) {
      const iA = vfile(gA), oA = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        IA.parse(iA)
      );
      IA.run(oA, iA, function(tA, eA, aA) {
        if (tA || !eA || !aA)
          return cA(tA);
        const GA = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          eA
        ), lA = IA.stringify(GA, aA);
        looksLikeAValue(lA) ? aA.value = lA : aA.result = lA, cA(
          tA,
          /** @type {VFileWithOutput<CompileResult>} */
          aA
        );
      });
      function cA(tA, eA) {
        tA || !eA ? EA(tA) : QA ? QA(eA) : AA(void 0, eA);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(gA) {
    let AA = !1, IA;
    return this.freeze(), assertParser("processSync", this.parser || this.Parser), assertCompiler("processSync", this.compiler || this.Compiler), this.process(gA, BA), assertDone("processSync", "process", AA), IA;
    function BA(QA, EA) {
      AA = !0, bail(QA), IA = EA;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(gA, AA, IA) {
    assertNode(gA), this.freeze();
    const BA = this.transformers;
    return !IA && typeof AA == "function" && (IA = AA, AA = void 0), IA ? QA(void 0, IA) : new Promise(QA);
    function QA(EA, iA) {
      const oA = vfile(AA);
      BA.run(gA, oA, cA);
      function cA(tA, eA, aA) {
        const GA = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          eA || gA
        );
        tA ? iA(tA) : EA ? EA(GA) : IA(void 0, GA, aA);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(gA, AA) {
    let IA = !1, BA;
    return this.run(gA, AA, QA), assertDone("runSync", "run", IA), BA;
    function QA(EA, iA) {
      bail(EA), BA = iA, IA = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(gA, AA) {
    this.freeze();
    const IA = vfile(AA), BA = this.compiler || this.Compiler;
    return assertCompiler("stringify", BA), assertNode(gA), BA(gA, IA);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(gA, ...AA) {
    const IA = this.attachers, BA = this.namespace;
    if (assertUnfrozen("use", this.frozen), gA != null) if (typeof gA == "function")
      oA(gA, AA);
    else if (typeof gA == "object")
      Array.isArray(gA) ? iA(gA) : EA(gA);
    else
      throw new TypeError("Expected usable value, not `" + gA + "`");
    return this;
    function QA(cA) {
      if (typeof cA == "function")
        oA(cA, []);
      else if (typeof cA == "object")
        if (Array.isArray(cA)) {
          const [tA, ...eA] = (
            /** @type {PluginTuple<Array<unknown>>} */
            cA
          );
          oA(tA, eA);
        } else
          EA(cA);
      else
        throw new TypeError("Expected usable value, not `" + cA + "`");
    }
    function EA(cA) {
      if (!("plugins" in cA) && !("settings" in cA))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      iA(cA.plugins), cA.settings && (BA.settings = extend(!0, BA.settings, cA.settings));
    }
    function iA(cA) {
      let tA = -1;
      if (cA != null) if (Array.isArray(cA))
        for (; ++tA < cA.length; ) {
          const eA = cA[tA];
          QA(eA);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + cA + "`");
    }
    function oA(cA, tA) {
      let eA = -1, aA = -1;
      for (; ++eA < IA.length; )
        if (IA[eA][0] === cA) {
          aA = eA;
          break;
        }
      if (aA === -1)
        IA.push([cA, ...tA]);
      else if (tA.length > 0) {
        let [GA, ...lA] = tA;
        const nA = IA[aA][1];
        isPlainObject$1(nA) && isPlainObject$1(GA) && (GA = extend(!0, nA, GA)), IA[aA] = [cA, GA, ...lA];
      }
    }
  }
}
const unified = new Processor().freeze();
function assertParser(CA, gA) {
  if (typeof gA != "function")
    throw new TypeError("Cannot `" + CA + "` without `parser`");
}
function assertCompiler(CA, gA) {
  if (typeof gA != "function")
    throw new TypeError("Cannot `" + CA + "` without `compiler`");
}
function assertUnfrozen(CA, gA) {
  if (gA)
    throw new Error(
      "Cannot call `" + CA + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function assertNode(CA) {
  if (!isPlainObject$1(CA) || typeof CA.type != "string")
    throw new TypeError("Expected node, got `" + CA + "`");
}
function assertDone(CA, gA, AA) {
  if (!AA)
    throw new Error(
      "`" + CA + "` finished async. Use `" + gA + "` instead"
    );
}
function vfile(CA) {
  return looksLikeAVFile(CA) ? CA : new VFile(CA);
}
function looksLikeAVFile(CA) {
  return !!(CA && typeof CA == "object" && "message" in CA && "messages" in CA);
}
function looksLikeAValue(CA) {
  return typeof CA == "string" || isUint8Array(CA);
}
function isUint8Array(CA) {
  return !!(CA && typeof CA == "object" && "byteLength" in CA && "byteOffset" in CA);
}
function visit$2(CA, gA, AA, IA) {
  let BA, QA, EA;
  typeof gA == "function" && typeof AA != "function" ? (QA = void 0, EA = gA, BA = AA) : (QA = gA, EA = AA, BA = IA), visitParents(CA, QA, iA, BA);
  function iA(oA, cA) {
    const tA = cA[cA.length - 1], eA = tA ? tA.children.indexOf(oA) : void 0;
    return EA(oA, eA, tA);
  }
}
const changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", emptyPlugins = [], emptyRemarkRehypeOptions = { allowDangerousHtml: !0 }, safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i, deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown$2(CA) {
  const gA = createProcessor(CA), AA = createFile(CA);
  return post(gA.runSync(gA.parse(AA), AA), CA);
}
function createProcessor(CA) {
  const gA = CA.rehypePlugins || emptyPlugins, AA = CA.remarkPlugins || emptyPlugins, IA = CA.remarkRehypeOptions ? { ...CA.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  return unified().use(remarkParse).use(AA).use(remarkRehype, IA).use(gA);
}
function createFile(CA) {
  const gA = CA.children || "", AA = new VFile();
  return typeof gA == "string" && (AA.value = gA), AA;
}
function post(CA, gA) {
  const AA = gA.allowedElements, IA = gA.allowElement, BA = gA.components, QA = gA.disallowedElements, EA = gA.skipHtml, iA = gA.unwrapDisallowed, oA = gA.urlTransform || defaultUrlTransform;
  for (const tA of deprecations)
    Object.hasOwn(gA, tA.from) && ("" + tA.from + (tA.to ? "use `" + tA.to + "` instead" : "remove it") + changelog + tA.id, void 0);
  return visit$2(CA, cA), toJsxRuntime(CA, {
    Fragment: jsxRuntimeExports.Fragment,
    components: BA,
    ignoreInvalidStyle: !0,
    jsx: jsxRuntimeExports.jsx,
    jsxs: jsxRuntimeExports.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function cA(tA, eA, aA) {
    if (tA.type === "raw" && aA && typeof eA == "number")
      return EA ? aA.children.splice(eA, 1) : aA.children[eA] = { type: "text", value: tA.value }, eA;
    if (tA.type === "element") {
      let GA;
      for (GA in urlAttributes)
        if (Object.hasOwn(urlAttributes, GA) && Object.hasOwn(tA.properties, GA)) {
          const lA = tA.properties[GA], nA = urlAttributes[GA];
          (nA === null || nA.includes(tA.tagName)) && (tA.properties[GA] = oA(String(lA || ""), GA, tA));
        }
    }
    if (tA.type === "element") {
      let GA = AA ? !AA.includes(tA.tagName) : QA ? QA.includes(tA.tagName) : !1;
      if (!GA && IA && typeof eA == "number" && (GA = !IA(tA, eA, aA)), GA && aA && typeof eA == "number")
        return iA && tA.children ? aA.children.splice(eA, 1, ...tA.children) : aA.children.splice(eA, 1), eA;
    }
  }
}
function defaultUrlTransform(CA) {
  const gA = CA.indexOf(":"), AA = CA.indexOf("?"), IA = CA.indexOf("#"), BA = CA.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    gA === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    BA !== -1 && gA > BA || AA !== -1 && gA > AA || IA !== -1 && gA > IA || // It is a protocol, it should be allowed.
    safeProtocol.test(CA.slice(0, gA)) ? CA : ""
  );
}
function ccount(CA, gA) {
  const AA = String(CA);
  if (typeof gA != "string")
    throw new TypeError("Expected character");
  let IA = 0, BA = AA.indexOf(gA);
  for (; BA !== -1; )
    IA++, BA = AA.indexOf(gA, BA + gA.length);
  return IA;
}
const characterEntitiesLegacy = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], characterReferenceInvalid = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function isDecimal(CA) {
  const gA = typeof CA == "string" ? CA.charCodeAt(0) : CA;
  return gA >= 48 && gA <= 57;
}
function isHexadecimal(CA) {
  const gA = typeof CA == "string" ? CA.charCodeAt(0) : CA;
  return gA >= 97 && gA <= 102 || gA >= 65 && gA <= 70 || gA >= 48 && gA <= 57;
}
function isAlphabetical(CA) {
  const gA = typeof CA == "string" ? CA.charCodeAt(0) : CA;
  return gA >= 97 && gA <= 122 || gA >= 65 && gA <= 90;
}
function isAlphanumerical(CA) {
  return isAlphabetical(CA) || isDecimal(CA);
}
const messages = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function parseEntities(CA, gA) {
  const AA = gA || {}, IA = typeof AA.additional == "string" ? AA.additional.charCodeAt(0) : AA.additional, BA = [];
  let QA = 0, EA = -1, iA = "", oA, cA;
  AA.position && ("start" in AA.position || "indent" in AA.position ? (cA = AA.position.indent, oA = AA.position.start) : oA = AA.position);
  let tA = (oA ? oA.line : 0) || 1, eA = (oA ? oA.column : 0) || 1, aA = lA(), GA;
  for (QA--; ++QA <= CA.length; )
    if (GA === 10 && (eA = (cA ? cA[EA] : 0) || 1), GA = CA.charCodeAt(QA), GA === 38) {
      const hA = CA.charCodeAt(QA + 1);
      if (hA === 9 || hA === 10 || hA === 12 || hA === 32 || hA === 38 || hA === 60 || Number.isNaN(hA) || IA && hA === IA) {
        iA += String.fromCharCode(GA), eA++;
        continue;
      }
      const wA = QA + 1;
      let sA = wA, NA = wA, rA;
      if (hA === 35) {
        NA = ++sA;
        const YA = CA.charCodeAt(NA);
        YA === 88 || YA === 120 ? (rA = "hexadecimal", NA = ++sA) : rA = "decimal";
      } else
        rA = "named";
      let yA = "", bA = "", RA = "";
      const FA = rA === "named" ? isAlphanumerical : rA === "decimal" ? isDecimal : isHexadecimal;
      for (NA--; ++NA <= CA.length; ) {
        const YA = CA.charCodeAt(NA);
        if (!FA(YA))
          break;
        RA += String.fromCharCode(YA), rA === "named" && characterEntitiesLegacy.includes(RA) && (yA = RA, bA = decodeNamedCharacterReference(RA));
      }
      let dA = CA.charCodeAt(NA) === 59;
      if (dA) {
        NA++;
        const YA = rA === "named" ? decodeNamedCharacterReference(RA) : !1;
        YA && (yA = RA, bA = YA);
      }
      let kA = 1 + NA - wA, pA = "";
      if (!(!dA && AA.nonTerminated === !1)) if (!RA)
        rA !== "named" && nA(4, kA);
      else if (rA === "named") {
        if (dA && !bA)
          nA(5, 1);
        else if (yA !== RA && (NA = sA + yA.length, kA = 1 + NA - sA, dA = !1), !dA) {
          const YA = yA ? 1 : 3;
          if (AA.attribute) {
            const SA = CA.charCodeAt(NA);
            SA === 61 ? (nA(YA, kA), bA = "") : isAlphanumerical(SA) ? bA = "" : nA(YA, kA);
          } else
            nA(YA, kA);
        }
        pA = bA;
      } else {
        dA || nA(2, kA);
        let YA = Number.parseInt(
          RA,
          rA === "hexadecimal" ? 16 : 10
        );
        if (prohibited(YA))
          nA(7, kA), pA = "�";
        else if (YA in characterReferenceInvalid)
          nA(6, kA), pA = characterReferenceInvalid[YA];
        else {
          let SA = "";
          disallowed(YA) && nA(6, kA), YA > 65535 && (YA -= 65536, SA += String.fromCharCode(
            YA >>> 10 | 55296
          ), YA = 56320 | YA & 1023), pA = SA + String.fromCharCode(YA);
        }
      }
      if (pA) {
        DA(), aA = lA(), QA = NA - 1, eA += NA - wA + 1, BA.push(pA);
        const YA = lA();
        YA.offset++, AA.reference && AA.reference.call(
          AA.referenceContext || void 0,
          pA,
          { start: aA, end: YA },
          CA.slice(wA - 1, NA)
        ), aA = YA;
      } else
        RA = CA.slice(wA - 1, NA), iA += RA, eA += RA.length, QA = NA - 1;
    } else
      GA === 10 && (tA++, EA++, eA = 0), Number.isNaN(GA) ? DA() : (iA += String.fromCharCode(GA), eA++);
  return BA.join("");
  function lA() {
    return {
      line: tA,
      column: eA,
      offset: QA + ((oA ? oA.offset : 0) || 0)
    };
  }
  function nA(hA, wA) {
    let sA;
    AA.warning && (sA = lA(), sA.column += wA, sA.offset += wA, AA.warning.call(
      AA.warningContext || void 0,
      messages[hA],
      sA,
      hA
    ));
  }
  function DA() {
    iA && (BA.push(iA), AA.text && AA.text.call(AA.textContext || void 0, iA, {
      start: aA,
      end: lA()
    }), iA = "");
  }
}
function prohibited(CA) {
  return CA >= 55296 && CA <= 57343 || CA > 1114111;
}
function disallowed(CA) {
  return CA >= 1 && CA <= 8 || CA === 11 || CA >= 13 && CA <= 31 || CA >= 127 && CA <= 159 || CA >= 64976 && CA <= 65007 || (CA & 65535) === 65535 || (CA & 65535) === 65534;
}
const defaultSubsetRegex = /["&'<>`]/g, surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g, subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core(CA, gA) {
  if (CA = CA.replace(
    gA.subset ? charactersToExpressionCached(gA.subset) : defaultSubsetRegex,
    IA
  ), gA.subset || gA.escapeOnly)
    return CA;
  return CA.replace(surrogatePairsRegex, AA).replace(controlCharactersRegex, IA);
  function AA(BA, QA, EA) {
    return gA.format(
      (BA.charCodeAt(0) - 55296) * 1024 + BA.charCodeAt(1) - 56320 + 65536,
      EA.charCodeAt(QA + 2),
      gA
    );
  }
  function IA(BA, QA, EA) {
    return gA.format(
      BA.charCodeAt(0),
      EA.charCodeAt(QA + 1),
      gA
    );
  }
}
function charactersToExpressionCached(CA) {
  let gA = subsetToRegexCache.get(CA);
  return gA || (gA = charactersToExpression(CA), subsetToRegexCache.set(CA, gA)), gA;
}
function charactersToExpression(CA) {
  const gA = [];
  let AA = -1;
  for (; ++AA < CA.length; )
    gA.push(CA[AA].replace(regexEscapeRegex, "\\$&"));
  return new RegExp("(?:" + gA.join("|") + ")", "g");
}
function formatBasic(CA) {
  return "&#x" + CA.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(CA, gA) {
  return core(CA, Object.assign({ format: formatBasic }, gA));
}
const own = {}.hasOwnProperty, emptyOptions$2 = {}, shortcut = /^[^\t\n\r "#'.<=>`}]+$/, unquoted = /^[^\t\n\r "'<=>`}]+$/;
function directiveFromMarkdown() {
  return {
    canContainEols: ["textDirective"],
    enter: {
      directiveContainer: enterContainer,
      directiveContainerAttributes: enterAttributes,
      directiveContainerLabel: enterContainerLabel,
      directiveLeaf: enterLeaf,
      directiveLeafAttributes: enterAttributes,
      directiveText: enterText,
      directiveTextAttributes: enterAttributes
    },
    exit: {
      directiveContainer: exit$1,
      directiveContainerAttributeClassValue: exitAttributeClassValue,
      directiveContainerAttributeIdValue: exitAttributeIdValue,
      directiveContainerAttributeName: exitAttributeName,
      directiveContainerAttributeValue: exitAttributeValue,
      directiveContainerAttributes: exitAttributes,
      directiveContainerLabel: exitContainerLabel,
      directiveContainerName: exitName,
      directiveLeaf: exit$1,
      directiveLeafAttributeClassValue: exitAttributeClassValue,
      directiveLeafAttributeIdValue: exitAttributeIdValue,
      directiveLeafAttributeName: exitAttributeName,
      directiveLeafAttributeValue: exitAttributeValue,
      directiveLeafAttributes: exitAttributes,
      directiveLeafName: exitName,
      directiveText: exit$1,
      directiveTextAttributeClassValue: exitAttributeClassValue,
      directiveTextAttributeIdValue: exitAttributeIdValue,
      directiveTextAttributeName: exitAttributeName,
      directiveTextAttributeValue: exitAttributeValue,
      directiveTextAttributes: exitAttributes,
      directiveTextName: exitName
    }
  };
}
function directiveToMarkdown(CA) {
  const gA = emptyOptions$2;
  if (gA.quote !== '"' && gA.quote !== "'" && gA.quote !== null && gA.quote !== void 0)
    throw new Error(
      "Invalid quote `" + gA.quote + "`, expected `'` or `\"`"
    );
  return AA.peek = peekDirective, {
    handlers: {
      containerDirective: AA,
      leafDirective: AA,
      textDirective: AA
    },
    unsafe: [
      {
        character: "\r",
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        character: `
`,
        inConstruct: ["leafDirectiveLabel", "containerDirectiveLabel"]
      },
      {
        before: "[^:]",
        character: ":",
        after: "[A-Za-z]",
        inConstruct: ["phrasing"]
      },
      { atBreak: !0, character: ":", after: ":" }
    ]
  };
  function AA(QA, EA, iA, oA) {
    const cA = iA.createTracker(oA), tA = fence(QA), eA = iA.enter(QA.type);
    let aA = cA.move(tA + (QA.name || "")), GA;
    if (QA.type === "containerDirective") {
      const lA = (QA.children || [])[0];
      GA = inlineDirectiveLabel(lA) ? lA : void 0;
    } else
      GA = QA;
    if (GA && GA.children && GA.children.length > 0) {
      const lA = iA.enter("label"), nA = `${QA.type}Label`, DA = iA.enter(nA);
      aA += cA.move("["), aA += cA.move(
        iA.containerPhrasing(GA, {
          ...cA.current(),
          before: aA,
          after: "]"
        })
      ), aA += cA.move("]"), DA(), lA();
    }
    if (aA += cA.move(IA(QA, iA)), QA.type === "containerDirective") {
      const lA = (QA.children || [])[0];
      let nA = QA;
      inlineDirectiveLabel(lA) && (nA = Object.assign({}, QA, { children: QA.children.slice(1) })), nA && nA.children && nA.children.length > 0 && (aA += cA.move(`
`), aA += cA.move(iA.containerFlow(nA, cA.current()))), aA += cA.move(`
` + tA);
    }
    return eA(), aA;
  }
  function IA(QA, EA) {
    const iA = QA.attributes || {}, oA = [];
    let cA, tA, eA, aA;
    for (aA in iA)
      if (own.call(iA, aA) && iA[aA] !== void 0 && iA[aA] !== null) {
        const GA = String(iA[aA]);
        if (aA === "id")
          eA = gA.preferShortcut !== !1 && shortcut.test(GA) ? "#" + GA : BA("id", GA, QA, EA);
        else if (aA === "class") {
          const lA = GA.split(/[\t\n\r ]+/g), nA = [], DA = [];
          let hA = -1;
          for (; ++hA < lA.length; )
            (gA.preferShortcut !== !1 && shortcut.test(lA[hA]) ? DA : nA).push(lA[hA]);
          cA = nA.length > 0 ? BA("class", nA.join(" "), QA, EA) : "", tA = DA.length > 0 ? "." + DA.join(".") : "";
        } else
          oA.push(BA(aA, GA, QA, EA));
      }
    return cA && oA.unshift(cA), tA && oA.unshift(tA), eA && oA.unshift(eA), oA.length > 0 ? "{" + oA.join(" ") + "}" : "";
  }
  function BA(QA, EA, iA, oA) {
    if (gA.collapseEmptyAttributes !== !1 && !EA) return QA;
    if (gA.preferUnquoted && unquoted.test(EA))
      return QA + "=" + EA;
    const cA = gA.quote || oA.options.quote || '"', tA = cA === '"' ? "'" : '"', eA = gA.quoteSmart && ccount(EA, cA) > ccount(EA, tA) ? tA : cA, aA = iA.type === "textDirective" ? [eA] : [eA, `
`, "\r"];
    return QA + "=" + eA + stringifyEntitiesLight(EA, { subset: aA }) + eA;
  }
}
function enterContainer(CA) {
  enter.call(this, "containerDirective", CA);
}
function enterLeaf(CA) {
  enter.call(this, "leafDirective", CA);
}
function enterText(CA) {
  enter.call(this, "textDirective", CA);
}
function enter(CA, gA) {
  this.enter({ type: CA, name: "", attributes: {}, children: [] }, gA);
}
function exitName(CA) {
  const gA = this.stack[this.stack.length - 1];
  gA.type === "containerDirective" || gA.type === "leafDirective" || gA.type, gA.name = this.sliceSerialize(CA);
}
function enterContainerLabel(CA) {
  this.enter(
    { type: "paragraph", data: { directiveLabel: !0 }, children: [] },
    CA
  );
}
function exitContainerLabel(CA) {
  this.exit(CA);
}
function enterAttributes() {
  this.data.directiveAttributes = [], this.buffer();
}
function exitAttributeIdValue(CA) {
  this.data.directiveAttributes.push([
    "id",
    parseEntities(this.sliceSerialize(CA), { attribute: !0 })
  ]);
}
function exitAttributeClassValue(CA) {
  this.data.directiveAttributes.push([
    "class",
    parseEntities(this.sliceSerialize(CA), { attribute: !0 })
  ]);
}
function exitAttributeValue(CA) {
  const gA = this.data.directiveAttributes;
  gA[gA.length - 1][1] = parseEntities(this.sliceSerialize(CA), {
    attribute: !0
  });
}
function exitAttributeName(CA) {
  this.data.directiveAttributes.push([this.sliceSerialize(CA), ""]);
}
function exitAttributes() {
  const CA = this.data.directiveAttributes, gA = {};
  let AA = -1;
  for (; ++AA < CA.length; ) {
    const BA = CA[AA];
    BA[0] === "class" && gA.class ? gA.class += " " + BA[1] : gA[BA[0]] = BA[1];
  }
  this.data.directiveAttributes = void 0, this.resume();
  const IA = this.stack[this.stack.length - 1];
  IA.type === "containerDirective" || IA.type === "leafDirective" || IA.type, IA.attributes = gA;
}
function exit$1(CA) {
  this.exit(CA);
}
function peekDirective() {
  return ":";
}
function inlineDirectiveLabel(CA) {
  return !!(CA && CA.type === "paragraph" && CA.data && CA.data.directiveLabel);
}
function fence(CA) {
  let gA = 0;
  return CA.type === "containerDirective" ? (visitParents(CA, function(AA, IA) {
    if (AA.type === "containerDirective") {
      let BA = IA.length, QA = 0;
      for (; BA--; )
        IA[BA].type === "containerDirective" && QA++;
      QA > gA && (gA = QA);
    }
  }), gA += 3) : CA.type === "leafDirective" ? gA = 2 : gA = 1, ":".repeat(gA);
}
function factoryAttributes(CA, gA, AA, IA, BA, QA, EA, iA, oA, cA, tA, eA, aA, GA, lA) {
  let nA, DA;
  return hA;
  function hA(JA) {
    return CA.enter(IA), CA.enter(BA), CA.consume(JA), CA.exit(BA), wA;
  }
  function wA(JA) {
    return JA === 35 ? (nA = EA, sA(JA)) : JA === 46 ? (nA = iA, sA(JA)) : lA && markdownSpace(JA) ? factorySpace(CA, wA, "whitespace")(JA) : !lA && markdownLineEndingOrSpace(JA) ? factoryWhitespace(CA, wA)(JA) : JA === null || markdownLineEnding(JA) || unicodeWhitespace(JA) || unicodePunctuation(JA) && JA !== 45 && JA !== 95 ? SA(JA) : (CA.enter(QA), CA.enter(oA), CA.consume(JA), yA);
  }
  function sA(JA) {
    const UA = (
      /** @type {TokenType} */
      nA + "Marker"
    );
    return CA.enter(QA), CA.enter(nA), CA.enter(UA), CA.consume(JA), CA.exit(UA), NA;
  }
  function NA(JA) {
    if (JA === null || JA === 34 || JA === 35 || JA === 39 || JA === 46 || JA === 60 || JA === 61 || JA === 62 || JA === 96 || JA === 125 || markdownLineEndingOrSpace(JA))
      return AA(JA);
    const UA = (
      /** @type {TokenType} */
      nA + "Value"
    );
    return CA.enter(UA), CA.consume(JA), rA;
  }
  function rA(JA) {
    if (JA === null || JA === 34 || JA === 39 || JA === 60 || JA === 61 || JA === 62 || JA === 96)
      return AA(JA);
    if (JA === 35 || JA === 46 || JA === 125 || markdownLineEndingOrSpace(JA)) {
      const UA = (
        /** @type {TokenType} */
        nA + "Value"
      );
      return CA.exit(UA), CA.exit(nA), CA.exit(QA), wA(JA);
    }
    return CA.consume(JA), rA;
  }
  function yA(JA) {
    return JA === null || markdownLineEnding(JA) || unicodeWhitespace(JA) || unicodePunctuation(JA) && JA !== 45 && JA !== 46 && JA !== 58 && JA !== 95 ? (CA.exit(oA), lA && markdownSpace(JA) ? factorySpace(CA, bA, "whitespace")(JA) : !lA && markdownLineEndingOrSpace(JA) ? factoryWhitespace(CA, bA)(JA) : bA(JA)) : (CA.consume(JA), yA);
  }
  function bA(JA) {
    return JA === 61 ? (CA.enter(cA), CA.consume(JA), CA.exit(cA), RA) : (CA.exit(QA), wA(JA));
  }
  function RA(JA) {
    return JA === null || JA === 60 || JA === 61 || JA === 62 || JA === 96 || JA === 125 || lA && markdownLineEnding(JA) ? AA(JA) : JA === 34 || JA === 39 ? (CA.enter(tA), CA.enter(aA), CA.consume(JA), CA.exit(aA), DA = JA, dA) : lA && markdownSpace(JA) ? factorySpace(CA, RA, "whitespace")(JA) : !lA && markdownLineEndingOrSpace(JA) ? factoryWhitespace(CA, RA)(JA) : (CA.enter(eA), CA.enter(GA), CA.consume(JA), DA = void 0, FA);
  }
  function FA(JA) {
    return JA === null || JA === 34 || JA === 39 || JA === 60 || JA === 61 || JA === 62 || JA === 96 ? AA(JA) : JA === 125 || markdownLineEndingOrSpace(JA) ? (CA.exit(GA), CA.exit(eA), CA.exit(QA), wA(JA)) : (CA.consume(JA), FA);
  }
  function dA(JA) {
    return JA === DA ? (CA.enter(aA), CA.consume(JA), CA.exit(aA), CA.exit(tA), CA.exit(QA), YA) : (CA.enter(eA), kA(JA));
  }
  function kA(JA) {
    return JA === DA ? (CA.exit(eA), dA(JA)) : JA === null ? AA(JA) : markdownLineEnding(JA) ? lA ? AA(JA) : factoryWhitespace(CA, kA)(JA) : (CA.enter(GA), CA.consume(JA), pA);
  }
  function pA(JA) {
    return JA === DA || JA === null || markdownLineEnding(JA) ? (CA.exit(GA), kA(JA)) : (CA.consume(JA), pA);
  }
  function YA(JA) {
    return JA === 125 || markdownLineEndingOrSpace(JA) ? wA(JA) : SA(JA);
  }
  function SA(JA) {
    return JA === 125 ? (CA.enter(BA), CA.consume(JA), CA.exit(BA), CA.exit(IA), gA) : AA(JA);
  }
}
function factoryLabel(CA, gA, AA, IA, BA, QA, EA) {
  let iA = 0, oA = 0, cA;
  return tA;
  function tA(DA) {
    return CA.enter(IA), CA.enter(BA), CA.consume(DA), CA.exit(BA), eA;
  }
  function eA(DA) {
    return DA === 93 ? (CA.enter(BA), CA.consume(DA), CA.exit(BA), CA.exit(IA), gA) : (CA.enter(QA), aA(DA));
  }
  function aA(DA) {
    if (DA === 93 && !oA)
      return nA(DA);
    const hA = CA.enter("chunkText", {
      _contentTypeTextTrailing: !0,
      contentType: "text",
      previous: cA
    });
    return cA && (cA.next = hA), cA = hA, GA(DA);
  }
  function GA(DA) {
    return DA === null || iA > 999 || DA === 91 && ++oA > 32 ? AA(DA) : DA === 93 && !oA-- ? (CA.exit("chunkText"), nA(DA)) : markdownLineEnding(DA) ? EA ? AA(DA) : (CA.consume(DA), CA.exit("chunkText"), aA) : (CA.consume(DA), DA === 92 ? lA : GA);
  }
  function lA(DA) {
    return DA === 91 || DA === 92 || DA === 93 ? (CA.consume(DA), iA++, GA) : GA(DA);
  }
  function nA(DA) {
    return CA.exit(QA), CA.enter(BA), CA.consume(DA), CA.exit(BA), CA.exit(IA), gA;
  }
}
function factoryName(CA, gA, AA, IA) {
  const BA = this;
  return QA;
  function QA(iA) {
    return iA === null || markdownLineEnding(iA) || unicodePunctuation(iA) || unicodeWhitespace(iA) ? AA(iA) : (CA.enter(IA), CA.consume(iA), EA);
  }
  function EA(iA) {
    return iA === null || markdownLineEnding(iA) || unicodeWhitespace(iA) || unicodePunctuation(iA) && iA !== 45 && iA !== 95 ? (CA.exit(IA), BA.previous === 45 || BA.previous === 95 ? AA(iA) : gA(iA)) : (CA.consume(iA), EA);
  }
}
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: !0
}, label$2 = {
  tokenize: tokenizeLabel$2,
  partial: !0
}, attributes$2 = {
  tokenize: tokenizeAttributes$2,
  partial: !0
}, nonLazyLine = {
  tokenize: tokenizeNonLazyLine,
  partial: !0
};
function tokenizeDirectiveContainer(CA, gA, AA) {
  const IA = this, BA = IA.events[IA.events.length - 1], QA = BA && BA[1].type === "linePrefix" ? BA[2].sliceSerialize(BA[1], !0).length : 0;
  let EA = 0, iA;
  return oA;
  function oA(FA) {
    return CA.enter("directiveContainer"), CA.enter("directiveContainerFence"), CA.enter("directiveContainerSequence"), cA(FA);
  }
  function cA(FA) {
    return FA === 58 ? (CA.consume(FA), EA++, cA) : EA < 3 ? AA(FA) : (CA.exit("directiveContainerSequence"), factoryName.call(IA, CA, tA, AA, "directiveContainerName")(FA));
  }
  function tA(FA) {
    return FA === 91 ? CA.attempt(label$2, eA, eA)(FA) : eA(FA);
  }
  function eA(FA) {
    return FA === 123 ? CA.attempt(attributes$2, aA, aA)(FA) : aA(FA);
  }
  function aA(FA) {
    return factorySpace(CA, GA, "whitespace")(FA);
  }
  function GA(FA) {
    return CA.exit("directiveContainerFence"), FA === null ? bA(FA) : markdownLineEnding(FA) ? IA.interrupt ? gA(FA) : CA.attempt(nonLazyLine, lA, bA)(FA) : AA(FA);
  }
  function lA(FA) {
    return FA === null ? bA(FA) : markdownLineEnding(FA) ? CA.check(nonLazyLine, sA, bA)(FA) : (CA.enter("directiveContainerContent"), nA(FA));
  }
  function nA(FA) {
    return CA.attempt({
      tokenize: RA,
      partial: !0
    }, yA, QA ? factorySpace(CA, DA, "linePrefix", QA + 1) : DA)(FA);
  }
  function DA(FA) {
    return FA === null ? yA(FA) : markdownLineEnding(FA) ? CA.check(nonLazyLine, wA, yA)(FA) : wA(FA);
  }
  function hA(FA) {
    if (FA === null) {
      const dA = CA.exit("chunkDocument");
      return IA.parser.lazy[dA.start.line] = !1, yA(FA);
    }
    return markdownLineEnding(FA) ? CA.check(nonLazyLine, NA, rA)(FA) : (CA.consume(FA), hA);
  }
  function wA(FA) {
    const dA = CA.enter("chunkDocument", {
      contentType: "document",
      previous: iA
    });
    return iA && (iA.next = dA), iA = dA, hA(FA);
  }
  function sA(FA) {
    return CA.enter("directiveContainerContent"), nA(FA);
  }
  function NA(FA) {
    CA.consume(FA);
    const dA = CA.exit("chunkDocument");
    return IA.parser.lazy[dA.start.line] = !1, nA;
  }
  function rA(FA) {
    const dA = CA.exit("chunkDocument");
    return IA.parser.lazy[dA.start.line] = !1, yA(FA);
  }
  function yA(FA) {
    return CA.exit("directiveContainerContent"), bA(FA);
  }
  function bA(FA) {
    return CA.exit("directiveContainer"), gA(FA);
  }
  function RA(FA, dA, kA) {
    let pA = 0;
    return factorySpace(FA, YA, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function YA(UA) {
      return FA.enter("directiveContainerFence"), FA.enter("directiveContainerSequence"), SA(UA);
    }
    function SA(UA) {
      return UA === 58 ? (FA.consume(UA), pA++, SA) : pA < EA ? kA(UA) : (FA.exit("directiveContainerSequence"), factorySpace(FA, JA, "whitespace")(UA));
    }
    function JA(UA) {
      return UA === null || markdownLineEnding(UA) ? (FA.exit("directiveContainerFence"), dA(UA)) : kA(UA);
    }
  }
}
function tokenizeLabel$2(CA, gA, AA) {
  return factoryLabel(CA, gA, AA, "directiveContainerLabel", "directiveContainerLabelMarker", "directiveContainerLabelString", !0);
}
function tokenizeAttributes$2(CA, gA, AA) {
  return factoryAttributes(CA, gA, AA, "directiveContainerAttributes", "directiveContainerAttributesMarker", "directiveContainerAttribute", "directiveContainerAttributeId", "directiveContainerAttributeClass", "directiveContainerAttributeName", "directiveContainerAttributeInitializerMarker", "directiveContainerAttributeValueLiteral", "directiveContainerAttributeValue", "directiveContainerAttributeValueMarker", "directiveContainerAttributeValueData", !0);
}
function tokenizeNonLazyLine(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), QA;
  }
  function QA(EA) {
    return IA.parser.lazy[IA.now().line] ? AA(EA) : gA(EA);
  }
}
const directiveLeaf = {
  tokenize: tokenizeDirectiveLeaf
}, label$1 = {
  tokenize: tokenizeLabel$1,
  partial: !0
}, attributes$1 = {
  tokenize: tokenizeAttributes$1,
  partial: !0
};
function tokenizeDirectiveLeaf(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(tA) {
    return CA.enter("directiveLeaf"), CA.enter("directiveLeafSequence"), CA.consume(tA), QA;
  }
  function QA(tA) {
    return tA === 58 ? (CA.consume(tA), CA.exit("directiveLeafSequence"), factoryName.call(IA, CA, EA, AA, "directiveLeafName")) : AA(tA);
  }
  function EA(tA) {
    return tA === 91 ? CA.attempt(label$1, iA, iA)(tA) : iA(tA);
  }
  function iA(tA) {
    return tA === 123 ? CA.attempt(attributes$1, oA, oA)(tA) : oA(tA);
  }
  function oA(tA) {
    return factorySpace(CA, cA, "whitespace")(tA);
  }
  function cA(tA) {
    return tA === null || markdownLineEnding(tA) ? (CA.exit("directiveLeaf"), gA(tA)) : AA(tA);
  }
}
function tokenizeLabel$1(CA, gA, AA) {
  return factoryLabel(CA, gA, AA, "directiveLeafLabel", "directiveLeafLabelMarker", "directiveLeafLabelString", !0);
}
function tokenizeAttributes$1(CA, gA, AA) {
  return factoryAttributes(CA, gA, AA, "directiveLeafAttributes", "directiveLeafAttributesMarker", "directiveLeafAttribute", "directiveLeafAttributeId", "directiveLeafAttributeClass", "directiveLeafAttributeName", "directiveLeafAttributeInitializerMarker", "directiveLeafAttributeValueLiteral", "directiveLeafAttributeValue", "directiveLeafAttributeValueMarker", "directiveLeafAttributeValueData", !0);
}
const directiveText = {
  tokenize: tokenizeDirectiveText,
  previous: previous$2
}, label = {
  tokenize: tokenizeLabel,
  partial: !0
}, attributes = {
  tokenize: tokenizeAttributes,
  partial: !0
};
function previous$2(CA) {
  return CA !== 58 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeDirectiveText(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(oA) {
    return CA.enter("directiveText"), CA.enter("directiveTextMarker"), CA.consume(oA), CA.exit("directiveTextMarker"), factoryName.call(IA, CA, QA, AA, "directiveTextName");
  }
  function QA(oA) {
    return oA === 58 ? AA(oA) : oA === 91 ? CA.attempt(label, EA, EA)(oA) : EA(oA);
  }
  function EA(oA) {
    return oA === 123 ? CA.attempt(attributes, iA, iA)(oA) : iA(oA);
  }
  function iA(oA) {
    return CA.exit("directiveText"), gA(oA);
  }
}
function tokenizeLabel(CA, gA, AA) {
  return factoryLabel(CA, gA, AA, "directiveTextLabel", "directiveTextLabelMarker", "directiveTextLabelString");
}
function tokenizeAttributes(CA, gA, AA) {
  return factoryAttributes(CA, gA, AA, "directiveTextAttributes", "directiveTextAttributesMarker", "directiveTextAttribute", "directiveTextAttributeId", "directiveTextAttributeClass", "directiveTextAttributeName", "directiveTextAttributeInitializerMarker", "directiveTextAttributeValueLiteral", "directiveTextAttributeValue", "directiveTextAttributeValueMarker", "directiveTextAttributeValueData");
}
function directive() {
  return {
    text: {
      58: directiveText
    },
    flow: {
      58: [directiveContainer, directiveLeaf]
    }
  };
}
function remarkDirective() {
  const gA = /** @type {Processor<Root>} */ this.data(), AA = gA.micromarkExtensions || (gA.micromarkExtensions = []), IA = gA.fromMarkdownExtensions || (gA.fromMarkdownExtensions = []), BA = gA.toMarkdownExtensions || (gA.toMarkdownExtensions = []);
  AA.push(directive()), IA.push(directiveFromMarkdown()), BA.push(directiveToMarkdown());
}
const inConstruct = "phrasing", notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(CA) {
  this.enter({ type: "link", title: null, url: "", children: [] }, CA);
}
function enterLiteralAutolinkValue(CA) {
  this.config.enter.autolinkProtocol.call(this, CA);
}
function exitLiteralAutolinkHttp(CA) {
  this.config.exit.autolinkProtocol.call(this, CA);
}
function exitLiteralAutolinkWww(CA) {
  this.config.exit.data.call(this, CA);
  const gA = this.stack[this.stack.length - 1];
  gA.type, gA.url = "http://" + this.sliceSerialize(CA);
}
function exitLiteralAutolinkEmail(CA) {
  this.config.exit.autolinkEmail.call(this, CA);
}
function exitLiteralAutolink(CA) {
  this.exit(CA);
}
function transformGfmAutolinkLiterals(CA) {
  findAndReplace(
    CA,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(CA, gA, AA, IA, BA) {
  let QA = "";
  if (!previous$1(BA) || (/^w/i.test(gA) && (AA = gA + AA, gA = "", QA = "http://"), !isCorrectDomain(AA)))
    return !1;
  const EA = splitUrl(AA + IA);
  if (!EA[0]) return !1;
  const iA = {
    type: "link",
    title: null,
    url: QA + gA + EA[0],
    children: [{ type: "text", value: gA + EA[0] }]
  };
  return EA[1] ? [iA, { type: "text", value: EA[1] }] : iA;
}
function findEmail(CA, gA, AA, IA) {
  return (
    // Not an expected previous character.
    !previous$1(IA, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(AA) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + gA + "@" + AA,
      children: [{ type: "text", value: gA + "@" + AA }]
    }
  );
}
function isCorrectDomain(CA) {
  const gA = CA.split(".");
  return !(gA.length < 2 || gA[gA.length - 1] && (/_/.test(gA[gA.length - 1]) || !/[a-zA-Z\d]/.test(gA[gA.length - 1])) || gA[gA.length - 2] && (/_/.test(gA[gA.length - 2]) || !/[a-zA-Z\d]/.test(gA[gA.length - 2])));
}
function splitUrl(CA) {
  const gA = /[!"&'),.:;<>?\]}]+$/.exec(CA);
  if (!gA)
    return [CA, void 0];
  CA = CA.slice(0, gA.index);
  let AA = gA[0], IA = AA.indexOf(")");
  const BA = ccount(CA, "(");
  let QA = ccount(CA, ")");
  for (; IA !== -1 && BA > QA; )
    CA += AA.slice(0, IA + 1), AA = AA.slice(IA + 1), IA = AA.indexOf(")"), QA++;
  return [CA, AA];
}
function previous$1(CA, gA) {
  const AA = CA.input.charCodeAt(CA.index - 1);
  return (CA.index === 0 || unicodeWhitespace(AA) || unicodePunctuation(AA)) && // If it’s an email, the previous character should not be a slash.
  (!gA || AA !== 47);
}
footnoteReference.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(CA) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, CA);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(CA) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    CA
  );
}
function exitFootnoteCallString(CA) {
  const gA = this.resume(), AA = this.stack[this.stack.length - 1];
  AA.type, AA.identifier = normalizeIdentifier(
    this.sliceSerialize(CA)
  ).toLowerCase(), AA.label = gA;
}
function exitFootnoteCall(CA) {
  this.exit(CA);
}
function exitFootnoteDefinitionLabelString(CA) {
  const gA = this.resume(), AA = this.stack[this.stack.length - 1];
  AA.type, AA.identifier = normalizeIdentifier(
    this.sliceSerialize(CA)
  ).toLowerCase(), AA.label = gA;
}
function exitFootnoteDefinition(CA) {
  this.exit(CA);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference(CA, gA, AA, IA) {
  const BA = AA.createTracker(IA);
  let QA = BA.move("[^");
  const EA = AA.enter("footnoteReference"), iA = AA.enter("reference");
  return QA += BA.move(
    AA.safe(AA.associationId(CA), { after: "]", before: QA })
  ), iA(), EA(), QA += BA.move("]"), QA;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(CA) {
  let gA = !1;
  return CA && CA.firstLineBlank && (gA = !0), {
    handlers: { footnoteDefinition: AA, footnoteReference },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function AA(IA, BA, QA, EA) {
    const iA = QA.createTracker(EA);
    let oA = iA.move("[^");
    const cA = QA.enter("footnoteDefinition"), tA = QA.enter("label");
    return oA += iA.move(
      QA.safe(QA.associationId(IA), { before: oA, after: "]" })
    ), tA(), oA += iA.move("]:"), IA.children && IA.children.length > 0 && (iA.shift(4), oA += iA.move(
      (gA ? `
` : " ") + QA.indentLines(
        QA.containerFlow(IA, iA.current()),
        gA ? mapAll : mapExceptFirst
      )
    )), cA(), oA;
  }
}
function mapExceptFirst(CA, gA, AA) {
  return gA === 0 ? CA : mapAll(CA, gA, AA);
}
function mapAll(CA, gA, AA) {
  return (AA ? "" : "    ") + CA;
}
const constructsWithoutStrikethrough = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
handleDelete.peek = peekDelete;
function gfmStrikethroughFromMarkdown() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: enterStrikethrough },
    exit: { strikethrough: exitStrikethrough }
  };
}
function gfmStrikethroughToMarkdown() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: constructsWithoutStrikethrough
      }
    ],
    handlers: { delete: handleDelete }
  };
}
function enterStrikethrough(CA) {
  this.enter({ type: "delete", children: [] }, CA);
}
function exitStrikethrough(CA) {
  this.exit(CA);
}
function handleDelete(CA, gA, AA, IA) {
  const BA = AA.createTracker(IA), QA = AA.enter("strikethrough");
  let EA = BA.move("~~");
  return EA += AA.containerPhrasing(CA, {
    ...BA.current(),
    before: EA,
    after: "~"
  }), EA += BA.move("~~"), QA(), EA;
}
function peekDelete() {
  return "~";
}
function defaultStringLength(CA) {
  return CA.length;
}
function markdownTable(CA, gA) {
  const AA = gA || {}, IA = (AA.align || []).concat(), BA = AA.stringLength || defaultStringLength, QA = [], EA = [], iA = [], oA = [];
  let cA = 0, tA = -1;
  for (; ++tA < CA.length; ) {
    const nA = [], DA = [];
    let hA = -1;
    for (CA[tA].length > cA && (cA = CA[tA].length); ++hA < CA[tA].length; ) {
      const wA = serialize(CA[tA][hA]);
      if (AA.alignDelimiters !== !1) {
        const sA = BA(wA);
        DA[hA] = sA, (oA[hA] === void 0 || sA > oA[hA]) && (oA[hA] = sA);
      }
      nA.push(wA);
    }
    EA[tA] = nA, iA[tA] = DA;
  }
  let eA = -1;
  if (typeof IA == "object" && "length" in IA)
    for (; ++eA < cA; )
      QA[eA] = toAlignment(IA[eA]);
  else {
    const nA = toAlignment(IA);
    for (; ++eA < cA; )
      QA[eA] = nA;
  }
  eA = -1;
  const aA = [], GA = [];
  for (; ++eA < cA; ) {
    const nA = QA[eA];
    let DA = "", hA = "";
    nA === 99 ? (DA = ":", hA = ":") : nA === 108 ? DA = ":" : nA === 114 && (hA = ":");
    let wA = AA.alignDelimiters === !1 ? 1 : Math.max(
      1,
      oA[eA] - DA.length - hA.length
    );
    const sA = DA + "-".repeat(wA) + hA;
    AA.alignDelimiters !== !1 && (wA = DA.length + wA + hA.length, wA > oA[eA] && (oA[eA] = wA), GA[eA] = wA), aA[eA] = sA;
  }
  EA.splice(1, 0, aA), iA.splice(1, 0, GA), tA = -1;
  const lA = [];
  for (; ++tA < EA.length; ) {
    const nA = EA[tA], DA = iA[tA];
    eA = -1;
    const hA = [];
    for (; ++eA < cA; ) {
      const wA = nA[eA] || "";
      let sA = "", NA = "";
      if (AA.alignDelimiters !== !1) {
        const rA = oA[eA] - (DA[eA] || 0), yA = QA[eA];
        yA === 114 ? sA = " ".repeat(rA) : yA === 99 ? rA % 2 ? (sA = " ".repeat(rA / 2 + 0.5), NA = " ".repeat(rA / 2 - 0.5)) : (sA = " ".repeat(rA / 2), NA = sA) : NA = " ".repeat(rA);
      }
      AA.delimiterStart !== !1 && !eA && hA.push("|"), AA.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(AA.alignDelimiters === !1 && wA === "") && (AA.delimiterStart !== !1 || eA) && hA.push(" "), AA.alignDelimiters !== !1 && hA.push(sA), hA.push(wA), AA.alignDelimiters !== !1 && hA.push(NA), AA.padding !== !1 && hA.push(" "), (AA.delimiterEnd !== !1 || eA !== cA - 1) && hA.push("|");
    }
    lA.push(
      AA.delimiterEnd === !1 ? hA.join("").replace(/ +$/, "") : hA.join("")
    );
  }
  return lA.join(`
`);
}
function serialize(CA) {
  return CA == null ? "" : String(CA);
}
function toAlignment(CA) {
  const gA = typeof CA == "string" ? CA.codePointAt(0) : 0;
  return gA === 67 || gA === 99 ? 99 : gA === 76 || gA === 108 ? 108 : gA === 82 || gA === 114 ? 114 : 0;
}
function blockquote(CA, gA, AA, IA) {
  const BA = AA.enter("blockquote"), QA = AA.createTracker(IA);
  QA.move("> "), QA.shift(2);
  const EA = AA.indentLines(
    AA.containerFlow(CA, QA.current()),
    map$2
  );
  return BA(), EA;
}
function map$2(CA, gA, AA) {
  return ">" + (AA ? "" : " ") + CA;
}
function patternInScope(CA, gA) {
  return listInScope(CA, gA.inConstruct, !0) && !listInScope(CA, gA.notInConstruct, !1);
}
function listInScope(CA, gA, AA) {
  if (typeof gA == "string" && (gA = [gA]), !gA || gA.length === 0)
    return AA;
  let IA = -1;
  for (; ++IA < gA.length; )
    if (CA.includes(gA[IA]))
      return !0;
  return !1;
}
function hardBreak(CA, gA, AA, IA) {
  let BA = -1;
  for (; ++BA < AA.unsafe.length; )
    if (AA.unsafe[BA].character === `
` && patternInScope(AA.stack, AA.unsafe[BA]))
      return /[ \t]/.test(IA.before) ? "" : " ";
  return `\\
`;
}
function longestStreak(CA, gA) {
  const AA = String(CA);
  let IA = AA.indexOf(gA), BA = IA, QA = 0, EA = 0;
  if (typeof gA != "string")
    throw new TypeError("Expected substring");
  for (; IA !== -1; )
    IA === BA ? ++QA > EA && (EA = QA) : QA = 1, BA = IA + gA.length, IA = AA.indexOf(gA, BA);
  return EA;
}
function formatCodeAsIndented(CA, gA) {
  return !!(gA.options.fences === !1 && CA.value && // If there’s no info…
  !CA.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(CA.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(CA.value));
}
function checkFence(CA) {
  const gA = CA.options.fence || "`";
  if (gA !== "`" && gA !== "~")
    throw new Error(
      "Cannot serialize code with `" + gA + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return gA;
}
function code$2(CA, gA, AA, IA) {
  const BA = checkFence(AA), QA = CA.value || "", EA = BA === "`" ? "GraveAccent" : "Tilde";
  if (formatCodeAsIndented(CA, AA)) {
    const eA = AA.enter("codeIndented"), aA = AA.indentLines(QA, map$1);
    return eA(), aA;
  }
  const iA = AA.createTracker(IA), oA = BA.repeat(Math.max(longestStreak(QA, BA) + 1, 3)), cA = AA.enter("codeFenced");
  let tA = iA.move(oA);
  if (CA.lang) {
    const eA = AA.enter(`codeFencedLang${EA}`);
    tA += iA.move(
      AA.safe(CA.lang, {
        before: tA,
        after: " ",
        encode: ["`"],
        ...iA.current()
      })
    ), eA();
  }
  if (CA.lang && CA.meta) {
    const eA = AA.enter(`codeFencedMeta${EA}`);
    tA += iA.move(" "), tA += iA.move(
      AA.safe(CA.meta, {
        before: tA,
        after: `
`,
        encode: ["`"],
        ...iA.current()
      })
    ), eA();
  }
  return tA += iA.move(`
`), QA && (tA += iA.move(QA + `
`)), tA += iA.move(oA), cA(), tA;
}
function map$1(CA, gA, AA) {
  return (AA ? "" : "    ") + CA;
}
function checkQuote(CA) {
  const gA = CA.options.quote || '"';
  if (gA !== '"' && gA !== "'")
    throw new Error(
      "Cannot serialize title with `" + gA + "` for `options.quote`, expected `\"`, or `'`"
    );
  return gA;
}
function definition(CA, gA, AA, IA) {
  const BA = checkQuote(AA), QA = BA === '"' ? "Quote" : "Apostrophe", EA = AA.enter("definition");
  let iA = AA.enter("label");
  const oA = AA.createTracker(IA);
  let cA = oA.move("[");
  return cA += oA.move(
    AA.safe(AA.associationId(CA), {
      before: cA,
      after: "]",
      ...oA.current()
    })
  ), cA += oA.move("]: "), iA(), // If there’s no url, or…
  !CA.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(CA.url) ? (iA = AA.enter("destinationLiteral"), cA += oA.move("<"), cA += oA.move(
    AA.safe(CA.url, { before: cA, after: ">", ...oA.current() })
  ), cA += oA.move(">")) : (iA = AA.enter("destinationRaw"), cA += oA.move(
    AA.safe(CA.url, {
      before: cA,
      after: CA.title ? " " : `
`,
      ...oA.current()
    })
  )), iA(), CA.title && (iA = AA.enter(`title${QA}`), cA += oA.move(" " + BA), cA += oA.move(
    AA.safe(CA.title, {
      before: cA,
      after: BA,
      ...oA.current()
    })
  ), cA += oA.move(BA), iA()), EA(), cA;
}
function checkEmphasis(CA) {
  const gA = CA.options.emphasis || "*";
  if (gA !== "*" && gA !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + gA + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return gA;
}
function encodeCharacterReference(CA) {
  return "&#x" + CA.toString(16).toUpperCase() + ";";
}
function encodeInfo(CA, gA, AA) {
  const IA = classifyCharacter(CA), BA = classifyCharacter(gA);
  return IA === void 0 ? BA === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    AA === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : BA === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : IA === 1 ? BA === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : BA === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : BA === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : BA === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
emphasis.peek = emphasisPeek;
function emphasis(CA, gA, AA, IA) {
  const BA = checkEmphasis(AA), QA = AA.enter("emphasis"), EA = AA.createTracker(IA), iA = EA.move(BA);
  let oA = EA.move(
    AA.containerPhrasing(CA, {
      after: BA,
      before: iA,
      ...EA.current()
    })
  );
  const cA = oA.charCodeAt(0), tA = encodeInfo(
    IA.before.charCodeAt(IA.before.length - 1),
    cA,
    BA
  );
  tA.inside && (oA = encodeCharacterReference(cA) + oA.slice(1));
  const eA = oA.charCodeAt(oA.length - 1), aA = encodeInfo(IA.after.charCodeAt(0), eA, BA);
  aA.inside && (oA = oA.slice(0, -1) + encodeCharacterReference(eA));
  const GA = EA.move(BA);
  return QA(), AA.attentionEncodeSurroundingInfo = {
    after: aA.outside,
    before: tA.outside
  }, iA + oA + GA;
}
function emphasisPeek(CA, gA, AA) {
  return AA.options.emphasis || "*";
}
function visit$1(CA, gA, AA, IA) {
  let BA, QA, EA;
  typeof gA == "function" && typeof AA != "function" ? (QA = void 0, EA = gA, BA = AA) : (QA = gA, EA = AA, BA = IA), visitParents(CA, QA, iA, BA);
  function iA(oA, cA) {
    const tA = cA[cA.length - 1], eA = tA ? tA.children.indexOf(oA) : void 0;
    return EA(oA, eA, tA);
  }
}
function formatHeadingAsSetext(CA, gA) {
  let AA = !1;
  return visit$1(CA, function(IA) {
    if ("value" in IA && /\r?\n|\r/.test(IA.value) || IA.type === "break")
      return AA = !0, EXIT;
  }), !!((!CA.depth || CA.depth < 3) && toString$2(CA) && (gA.options.setext || AA));
}
function heading(CA, gA, AA, IA) {
  const BA = Math.max(Math.min(6, CA.depth || 1), 1), QA = AA.createTracker(IA);
  if (formatHeadingAsSetext(CA, AA)) {
    const tA = AA.enter("headingSetext"), eA = AA.enter("phrasing"), aA = AA.containerPhrasing(CA, {
      ...QA.current(),
      before: `
`,
      after: `
`
    });
    return eA(), tA(), aA + `
` + (BA === 1 ? "=" : "-").repeat(
      // The whole size…
      aA.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(aA.lastIndexOf("\r"), aA.lastIndexOf(`
`)) + 1)
    );
  }
  const EA = "#".repeat(BA), iA = AA.enter("headingAtx"), oA = AA.enter("phrasing");
  QA.move(EA + " ");
  let cA = AA.containerPhrasing(CA, {
    before: "# ",
    after: `
`,
    ...QA.current()
  });
  return /^[\t ]/.test(cA) && (cA = encodeCharacterReference(cA.charCodeAt(0)) + cA.slice(1)), cA = cA ? EA + " " + cA : EA, AA.options.closeAtx && (cA += " " + EA), oA(), iA(), cA;
}
html.peek = htmlPeek;
function html(CA) {
  return CA.value || "";
}
function htmlPeek() {
  return "<";
}
image.peek = imagePeek;
function image(CA, gA, AA, IA) {
  const BA = checkQuote(AA), QA = BA === '"' ? "Quote" : "Apostrophe", EA = AA.enter("image");
  let iA = AA.enter("label");
  const oA = AA.createTracker(IA);
  let cA = oA.move("![");
  return cA += oA.move(
    AA.safe(CA.alt, { before: cA, after: "]", ...oA.current() })
  ), cA += oA.move("]("), iA(), // If there’s no url but there is a title…
  !CA.url && CA.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(CA.url) ? (iA = AA.enter("destinationLiteral"), cA += oA.move("<"), cA += oA.move(
    AA.safe(CA.url, { before: cA, after: ">", ...oA.current() })
  ), cA += oA.move(">")) : (iA = AA.enter("destinationRaw"), cA += oA.move(
    AA.safe(CA.url, {
      before: cA,
      after: CA.title ? " " : ")",
      ...oA.current()
    })
  )), iA(), CA.title && (iA = AA.enter(`title${QA}`), cA += oA.move(" " + BA), cA += oA.move(
    AA.safe(CA.title, {
      before: cA,
      after: BA,
      ...oA.current()
    })
  ), cA += oA.move(BA), iA()), cA += oA.move(")"), EA(), cA;
}
function imagePeek() {
  return "!";
}
imageReference.peek = imageReferencePeek;
function imageReference(CA, gA, AA, IA) {
  const BA = CA.referenceType, QA = AA.enter("imageReference");
  let EA = AA.enter("label");
  const iA = AA.createTracker(IA);
  let oA = iA.move("![");
  const cA = AA.safe(CA.alt, {
    before: oA,
    after: "]",
    ...iA.current()
  });
  oA += iA.move(cA + "]["), EA();
  const tA = AA.stack;
  AA.stack = [], EA = AA.enter("reference");
  const eA = AA.safe(AA.associationId(CA), {
    before: oA,
    after: "]",
    ...iA.current()
  });
  return EA(), AA.stack = tA, QA(), BA === "full" || !cA || cA !== eA ? oA += iA.move(eA + "]") : BA === "shortcut" ? oA = oA.slice(0, -1) : oA += iA.move("]"), oA;
}
function imageReferencePeek() {
  return "!";
}
inlineCode.peek = inlineCodePeek;
function inlineCode(CA, gA, AA) {
  let IA = CA.value || "", BA = "`", QA = -1;
  for (; new RegExp("(^|[^`])" + BA + "([^`]|$)").test(IA); )
    BA += "`";
  for (/[^ \r\n]/.test(IA) && (/^[ \r\n]/.test(IA) && /[ \r\n]$/.test(IA) || /^`|`$/.test(IA)) && (IA = " " + IA + " "); ++QA < AA.unsafe.length; ) {
    const EA = AA.unsafe[QA], iA = AA.compilePattern(EA);
    let oA;
    if (EA.atBreak)
      for (; oA = iA.exec(IA); ) {
        let cA = oA.index;
        IA.charCodeAt(cA) === 10 && IA.charCodeAt(cA - 1) === 13 && cA--, IA = IA.slice(0, cA) + " " + IA.slice(oA.index + 1);
      }
  }
  return BA + IA + BA;
}
function inlineCodePeek() {
  return "`";
}
function formatLinkAsAutolink(CA, gA) {
  const AA = toString$2(CA);
  return !!(!gA.options.resourceLink && // If there’s a url…
  CA.url && // And there’s a no title…
  !CA.title && // And the content of `node` is a single text node…
  CA.children && CA.children.length === 1 && CA.children[0].type === "text" && // And if the url is the same as the content…
  (AA === CA.url || "mailto:" + AA === CA.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(CA.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(CA.url));
}
link.peek = linkPeek;
function link(CA, gA, AA, IA) {
  const BA = checkQuote(AA), QA = BA === '"' ? "Quote" : "Apostrophe", EA = AA.createTracker(IA);
  let iA, oA;
  if (formatLinkAsAutolink(CA, AA)) {
    const tA = AA.stack;
    AA.stack = [], iA = AA.enter("autolink");
    let eA = EA.move("<");
    return eA += EA.move(
      AA.containerPhrasing(CA, {
        before: eA,
        after: ">",
        ...EA.current()
      })
    ), eA += EA.move(">"), iA(), AA.stack = tA, eA;
  }
  iA = AA.enter("link"), oA = AA.enter("label");
  let cA = EA.move("[");
  return cA += EA.move(
    AA.containerPhrasing(CA, {
      before: cA,
      after: "](",
      ...EA.current()
    })
  ), cA += EA.move("]("), oA(), // If there’s no url but there is a title…
  !CA.url && CA.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(CA.url) ? (oA = AA.enter("destinationLiteral"), cA += EA.move("<"), cA += EA.move(
    AA.safe(CA.url, { before: cA, after: ">", ...EA.current() })
  ), cA += EA.move(">")) : (oA = AA.enter("destinationRaw"), cA += EA.move(
    AA.safe(CA.url, {
      before: cA,
      after: CA.title ? " " : ")",
      ...EA.current()
    })
  )), oA(), CA.title && (oA = AA.enter(`title${QA}`), cA += EA.move(" " + BA), cA += EA.move(
    AA.safe(CA.title, {
      before: cA,
      after: BA,
      ...EA.current()
    })
  ), cA += EA.move(BA), oA()), cA += EA.move(")"), iA(), cA;
}
function linkPeek(CA, gA, AA) {
  return formatLinkAsAutolink(CA, AA) ? "<" : "[";
}
linkReference.peek = linkReferencePeek;
function linkReference(CA, gA, AA, IA) {
  const BA = CA.referenceType, QA = AA.enter("linkReference");
  let EA = AA.enter("label");
  const iA = AA.createTracker(IA);
  let oA = iA.move("[");
  const cA = AA.containerPhrasing(CA, {
    before: oA,
    after: "]",
    ...iA.current()
  });
  oA += iA.move(cA + "]["), EA();
  const tA = AA.stack;
  AA.stack = [], EA = AA.enter("reference");
  const eA = AA.safe(AA.associationId(CA), {
    before: oA,
    after: "]",
    ...iA.current()
  });
  return EA(), AA.stack = tA, QA(), BA === "full" || !cA || cA !== eA ? oA += iA.move(eA + "]") : BA === "shortcut" ? oA = oA.slice(0, -1) : oA += iA.move("]"), oA;
}
function linkReferencePeek() {
  return "[";
}
function checkBullet(CA) {
  const gA = CA.options.bullet || "*";
  if (gA !== "*" && gA !== "+" && gA !== "-")
    throw new Error(
      "Cannot serialize items with `" + gA + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return gA;
}
function checkBulletOther(CA) {
  const gA = checkBullet(CA), AA = CA.options.bulletOther;
  if (!AA)
    return gA === "*" ? "-" : "*";
  if (AA !== "*" && AA !== "+" && AA !== "-")
    throw new Error(
      "Cannot serialize items with `" + AA + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (AA === gA)
    throw new Error(
      "Expected `bullet` (`" + gA + "`) and `bulletOther` (`" + AA + "`) to be different"
    );
  return AA;
}
function checkBulletOrdered(CA) {
  const gA = CA.options.bulletOrdered || ".";
  if (gA !== "." && gA !== ")")
    throw new Error(
      "Cannot serialize items with `" + gA + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return gA;
}
function checkRule(CA) {
  const gA = CA.options.rule || "*";
  if (gA !== "*" && gA !== "-" && gA !== "_")
    throw new Error(
      "Cannot serialize rules with `" + gA + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return gA;
}
function list(CA, gA, AA, IA) {
  const BA = AA.enter("list"), QA = AA.bulletCurrent;
  let EA = CA.ordered ? checkBulletOrdered(AA) : checkBullet(AA);
  const iA = CA.ordered ? EA === "." ? ")" : "." : checkBulletOther(AA);
  let oA = gA && AA.bulletLastUsed ? EA === AA.bulletLastUsed : !1;
  if (!CA.ordered) {
    const tA = CA.children ? CA.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (EA === "*" || EA === "-") && // Empty first list item:
      tA && (!tA.children || !tA.children[0]) && // Directly in two other list items:
      AA.stack[AA.stack.length - 1] === "list" && AA.stack[AA.stack.length - 2] === "listItem" && AA.stack[AA.stack.length - 3] === "list" && AA.stack[AA.stack.length - 4] === "listItem" && // That are each the first child.
      AA.indexStack[AA.indexStack.length - 1] === 0 && AA.indexStack[AA.indexStack.length - 2] === 0 && AA.indexStack[AA.indexStack.length - 3] === 0 && (oA = !0), checkRule(AA) === EA && tA
    ) {
      let eA = -1;
      for (; ++eA < CA.children.length; ) {
        const aA = CA.children[eA];
        if (aA && aA.type === "listItem" && aA.children && aA.children[0] && aA.children[0].type === "thematicBreak") {
          oA = !0;
          break;
        }
      }
    }
  }
  oA && (EA = iA), AA.bulletCurrent = EA;
  const cA = AA.containerFlow(CA, IA);
  return AA.bulletLastUsed = EA, AA.bulletCurrent = QA, BA(), cA;
}
function checkListItemIndent(CA) {
  const gA = CA.options.listItemIndent || "one";
  if (gA !== "tab" && gA !== "one" && gA !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + gA + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return gA;
}
function listItem(CA, gA, AA, IA) {
  const BA = checkListItemIndent(AA);
  let QA = AA.bulletCurrent || checkBullet(AA);
  gA && gA.type === "list" && gA.ordered && (QA = (typeof gA.start == "number" && gA.start > -1 ? gA.start : 1) + (AA.options.incrementListMarker === !1 ? 0 : gA.children.indexOf(CA)) + QA);
  let EA = QA.length + 1;
  (BA === "tab" || BA === "mixed" && (gA && gA.type === "list" && gA.spread || CA.spread)) && (EA = Math.ceil(EA / 4) * 4);
  const iA = AA.createTracker(IA);
  iA.move(QA + " ".repeat(EA - QA.length)), iA.shift(EA);
  const oA = AA.enter("listItem"), cA = AA.indentLines(
    AA.containerFlow(CA, iA.current()),
    tA
  );
  return oA(), cA;
  function tA(eA, aA, GA) {
    return aA ? (GA ? "" : " ".repeat(EA)) + eA : (GA ? QA : QA + " ".repeat(EA - QA.length)) + eA;
  }
}
function paragraph(CA, gA, AA, IA) {
  const BA = AA.enter("paragraph"), QA = AA.enter("phrasing"), EA = AA.containerPhrasing(CA, IA);
  return QA(), BA(), EA;
}
const phrasing = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  convert([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function root$1(CA, gA, AA, IA) {
  return (CA.children.some(function(EA) {
    return phrasing(EA);
  }) ? AA.containerPhrasing : AA.containerFlow).call(AA, CA, IA);
}
function checkStrong(CA) {
  const gA = CA.options.strong || "*";
  if (gA !== "*" && gA !== "_")
    throw new Error(
      "Cannot serialize strong with `" + gA + "` for `options.strong`, expected `*`, or `_`"
    );
  return gA;
}
strong.peek = strongPeek;
function strong(CA, gA, AA, IA) {
  const BA = checkStrong(AA), QA = AA.enter("strong"), EA = AA.createTracker(IA), iA = EA.move(BA + BA);
  let oA = EA.move(
    AA.containerPhrasing(CA, {
      after: BA,
      before: iA,
      ...EA.current()
    })
  );
  const cA = oA.charCodeAt(0), tA = encodeInfo(
    IA.before.charCodeAt(IA.before.length - 1),
    cA,
    BA
  );
  tA.inside && (oA = encodeCharacterReference(cA) + oA.slice(1));
  const eA = oA.charCodeAt(oA.length - 1), aA = encodeInfo(IA.after.charCodeAt(0), eA, BA);
  aA.inside && (oA = oA.slice(0, -1) + encodeCharacterReference(eA));
  const GA = EA.move(BA + BA);
  return QA(), AA.attentionEncodeSurroundingInfo = {
    after: aA.outside,
    before: tA.outside
  }, iA + oA + GA;
}
function strongPeek(CA, gA, AA) {
  return AA.options.strong || "*";
}
function text$2(CA, gA, AA, IA) {
  return AA.safe(CA.value, IA);
}
function checkRuleRepetition(CA) {
  const gA = CA.options.ruleRepetition || 3;
  if (gA < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + gA + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return gA;
}
function thematicBreak(CA, gA, AA) {
  const IA = (checkRule(AA) + (AA.options.ruleSpaces ? " " : "")).repeat(checkRuleRepetition(AA));
  return AA.options.ruleSpaces ? IA.slice(0, -1) : IA;
}
const handle = {
  blockquote,
  break: hardBreak,
  code: code$2,
  definition,
  emphasis,
  hardBreak,
  heading,
  html,
  image,
  imageReference,
  inlineCode,
  link,
  linkReference,
  list,
  listItem,
  paragraph,
  root: root$1,
  strong,
  text: text$2,
  thematicBreak
};
function gfmTableFromMarkdown() {
  return {
    enter: {
      table: enterTable,
      tableData: enterCell,
      tableHeader: enterCell,
      tableRow: enterRow
    },
    exit: {
      codeText: exitCodeText,
      table: exitTable,
      tableData: exit,
      tableHeader: exit,
      tableRow: exit
    }
  };
}
function enterTable(CA) {
  const gA = CA._align;
  this.enter(
    {
      type: "table",
      align: gA.map(function(AA) {
        return AA === "none" ? null : AA;
      }),
      children: []
    },
    CA
  ), this.data.inTable = !0;
}
function exitTable(CA) {
  this.exit(CA), this.data.inTable = void 0;
}
function enterRow(CA) {
  this.enter({ type: "tableRow", children: [] }, CA);
}
function exit(CA) {
  this.exit(CA);
}
function enterCell(CA) {
  this.enter({ type: "tableCell", children: [] }, CA);
}
function exitCodeText(CA) {
  let gA = this.resume();
  this.data.inTable && (gA = gA.replace(/\\([\\|])/g, replace));
  const AA = this.stack[this.stack.length - 1];
  AA.type, AA.value = gA, this.exit(CA);
}
function replace(CA, gA) {
  return gA === "|" ? gA : CA;
}
function gfmTableToMarkdown(CA) {
  const gA = CA || {}, AA = gA.tableCellPadding, IA = gA.tablePipeAlign, BA = gA.stringLength, QA = AA ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: aA,
      table: EA,
      tableCell: oA,
      tableRow: iA
    }
  };
  function EA(GA, lA, nA, DA) {
    return cA(tA(GA, nA, DA), GA.align);
  }
  function iA(GA, lA, nA, DA) {
    const hA = eA(GA, nA, DA), wA = cA([hA]);
    return wA.slice(0, wA.indexOf(`
`));
  }
  function oA(GA, lA, nA, DA) {
    const hA = nA.enter("tableCell"), wA = nA.enter("phrasing"), sA = nA.containerPhrasing(GA, {
      ...DA,
      before: QA,
      after: QA
    });
    return wA(), hA(), sA;
  }
  function cA(GA, lA) {
    return markdownTable(GA, {
      align: lA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: IA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: AA,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: BA
    });
  }
  function tA(GA, lA, nA) {
    const DA = GA.children;
    let hA = -1;
    const wA = [], sA = lA.enter("table");
    for (; ++hA < DA.length; )
      wA[hA] = eA(DA[hA], lA, nA);
    return sA(), wA;
  }
  function eA(GA, lA, nA) {
    const DA = GA.children;
    let hA = -1;
    const wA = [], sA = lA.enter("tableRow");
    for (; ++hA < DA.length; )
      wA[hA] = oA(DA[hA], GA, lA, nA);
    return sA(), wA;
  }
  function aA(GA, lA, nA) {
    let DA = handle.inlineCode(GA, lA, nA);
    return nA.stack.includes("tableCell") && (DA = DA.replace(/\|/g, "\\$&")), DA;
  }
}
function gfmTaskListItemFromMarkdown() {
  return {
    exit: {
      taskListCheckValueChecked: exitCheck,
      taskListCheckValueUnchecked: exitCheck,
      paragraph: exitParagraphWithTaskListItem
    }
  };
}
function gfmTaskListItemToMarkdown() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: listItemWithTaskListItem }
  };
}
function exitCheck(CA) {
  const gA = this.stack[this.stack.length - 2];
  gA.type, gA.checked = CA.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(CA) {
  const gA = this.stack[this.stack.length - 2];
  if (gA && gA.type === "listItem" && typeof gA.checked == "boolean") {
    const AA = this.stack[this.stack.length - 1];
    AA.type;
    const IA = AA.children[0];
    if (IA && IA.type === "text") {
      const BA = gA.children;
      let QA = -1, EA;
      for (; ++QA < BA.length; ) {
        const iA = BA[QA];
        if (iA.type === "paragraph") {
          EA = iA;
          break;
        }
      }
      EA === AA && (IA.value = IA.value.slice(1), IA.value.length === 0 ? AA.children.shift() : AA.position && IA.position && typeof IA.position.start.offset == "number" && (IA.position.start.column++, IA.position.start.offset++, AA.position.start = Object.assign({}, IA.position.start)));
    }
  }
  this.exit(CA);
}
function listItemWithTaskListItem(CA, gA, AA, IA) {
  const BA = CA.children[0], QA = typeof CA.checked == "boolean" && BA && BA.type === "paragraph", EA = "[" + (CA.checked ? "x" : " ") + "] ", iA = AA.createTracker(IA);
  QA && iA.move(EA);
  let oA = handle.listItem(CA, gA, AA, {
    ...IA,
    ...iA.current()
  });
  return QA && (oA = oA.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, cA)), oA;
  function cA(tA) {
    return tA + EA;
  }
}
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(CA) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(CA),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(CA),
      gfmTaskListItemToMarkdown()
    ]
  };
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: !0
}, domain = {
  tokenize: tokenizeDomain,
  partial: !0
}, path$2 = {
  tokenize: tokenizePath,
  partial: !0
}, trail = {
  tokenize: tokenizeTrail,
  partial: !0
}, emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: !0
}, wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}, protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}, emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}, text$1 = {};
function gfmAutolinkLiteral() {
  return {
    text: text$1
  };
}
let code$1 = 48;
for (; code$1 < 123; )
  text$1[code$1] = emailAutolink, code$1++, code$1 === 58 ? code$1 = 65 : code$1 === 91 && (code$1 = 97);
text$1[43] = emailAutolink;
text$1[45] = emailAutolink;
text$1[46] = emailAutolink;
text$1[95] = emailAutolink;
text$1[72] = [emailAutolink, protocolAutolink];
text$1[104] = [emailAutolink, protocolAutolink];
text$1[87] = [emailAutolink, wwwAutolink];
text$1[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(CA, gA, AA) {
  const IA = this;
  let BA, QA;
  return EA;
  function EA(eA) {
    return !gfmAtext(eA) || !previousEmail.call(IA, IA.previous) || previousUnbalanced(IA.events) ? AA(eA) : (CA.enter("literalAutolink"), CA.enter("literalAutolinkEmail"), iA(eA));
  }
  function iA(eA) {
    return gfmAtext(eA) ? (CA.consume(eA), iA) : eA === 64 ? (CA.consume(eA), oA) : AA(eA);
  }
  function oA(eA) {
    return eA === 46 ? CA.check(emailDomainDotTrail, tA, cA)(eA) : eA === 45 || eA === 95 || asciiAlphanumeric(eA) ? (QA = !0, CA.consume(eA), oA) : tA(eA);
  }
  function cA(eA) {
    return CA.consume(eA), BA = !0, oA;
  }
  function tA(eA) {
    return QA && BA && asciiAlpha(IA.previous) ? (CA.exit("literalAutolinkEmail"), CA.exit("literalAutolink"), gA(eA)) : AA(eA);
  }
}
function tokenizeWwwAutolink(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return EA !== 87 && EA !== 119 || !previousWww.call(IA, IA.previous) || previousUnbalanced(IA.events) ? AA(EA) : (CA.enter("literalAutolink"), CA.enter("literalAutolinkWww"), CA.check(wwwPrefix, CA.attempt(domain, CA.attempt(path$2, QA), AA), AA)(EA));
  }
  function QA(EA) {
    return CA.exit("literalAutolinkWww"), CA.exit("literalAutolink"), gA(EA);
  }
}
function tokenizeProtocolAutolink(CA, gA, AA) {
  const IA = this;
  let BA = "", QA = !1;
  return EA;
  function EA(eA) {
    return (eA === 72 || eA === 104) && previousProtocol.call(IA, IA.previous) && !previousUnbalanced(IA.events) ? (CA.enter("literalAutolink"), CA.enter("literalAutolinkHttp"), BA += String.fromCodePoint(eA), CA.consume(eA), iA) : AA(eA);
  }
  function iA(eA) {
    if (asciiAlpha(eA) && BA.length < 5)
      return BA += String.fromCodePoint(eA), CA.consume(eA), iA;
    if (eA === 58) {
      const aA = BA.toLowerCase();
      if (aA === "http" || aA === "https")
        return CA.consume(eA), oA;
    }
    return AA(eA);
  }
  function oA(eA) {
    return eA === 47 ? (CA.consume(eA), QA ? cA : (QA = !0, oA)) : AA(eA);
  }
  function cA(eA) {
    return eA === null || asciiControl(eA) || markdownLineEndingOrSpace(eA) || unicodeWhitespace(eA) || unicodePunctuation(eA) ? AA(eA) : CA.attempt(domain, CA.attempt(path$2, tA), AA)(eA);
  }
  function tA(eA) {
    return CA.exit("literalAutolinkHttp"), CA.exit("literalAutolink"), gA(eA);
  }
}
function tokenizeWwwPrefix(CA, gA, AA) {
  let IA = 0;
  return BA;
  function BA(EA) {
    return (EA === 87 || EA === 119) && IA < 3 ? (IA++, CA.consume(EA), BA) : EA === 46 && IA === 3 ? (CA.consume(EA), QA) : AA(EA);
  }
  function QA(EA) {
    return EA === null ? AA(EA) : gA(EA);
  }
}
function tokenizeDomain(CA, gA, AA) {
  let IA, BA, QA;
  return EA;
  function EA(cA) {
    return cA === 46 || cA === 95 ? CA.check(trail, oA, iA)(cA) : cA === null || markdownLineEndingOrSpace(cA) || unicodeWhitespace(cA) || cA !== 45 && unicodePunctuation(cA) ? oA(cA) : (QA = !0, CA.consume(cA), EA);
  }
  function iA(cA) {
    return cA === 95 ? IA = !0 : (BA = IA, IA = void 0), CA.consume(cA), EA;
  }
  function oA(cA) {
    return BA || IA || !QA ? AA(cA) : gA(cA);
  }
}
function tokenizePath(CA, gA) {
  let AA = 0, IA = 0;
  return BA;
  function BA(EA) {
    return EA === 40 ? (AA++, CA.consume(EA), BA) : EA === 41 && IA < AA ? QA(EA) : EA === 33 || EA === 34 || EA === 38 || EA === 39 || EA === 41 || EA === 42 || EA === 44 || EA === 46 || EA === 58 || EA === 59 || EA === 60 || EA === 63 || EA === 93 || EA === 95 || EA === 126 ? CA.check(trail, gA, QA)(EA) : EA === null || markdownLineEndingOrSpace(EA) || unicodeWhitespace(EA) ? gA(EA) : (CA.consume(EA), BA);
  }
  function QA(EA) {
    return EA === 41 && IA++, CA.consume(EA), BA;
  }
}
function tokenizeTrail(CA, gA, AA) {
  return IA;
  function IA(iA) {
    return iA === 33 || iA === 34 || iA === 39 || iA === 41 || iA === 42 || iA === 44 || iA === 46 || iA === 58 || iA === 59 || iA === 63 || iA === 95 || iA === 126 ? (CA.consume(iA), IA) : iA === 38 ? (CA.consume(iA), QA) : iA === 93 ? (CA.consume(iA), BA) : (
      // `<` is an end.
      iA === 60 || // So is whitespace.
      iA === null || markdownLineEndingOrSpace(iA) || unicodeWhitespace(iA) ? gA(iA) : AA(iA)
    );
  }
  function BA(iA) {
    return iA === null || iA === 40 || iA === 91 || markdownLineEndingOrSpace(iA) || unicodeWhitespace(iA) ? gA(iA) : IA(iA);
  }
  function QA(iA) {
    return asciiAlpha(iA) ? EA(iA) : AA(iA);
  }
  function EA(iA) {
    return iA === 59 ? (CA.consume(iA), IA) : asciiAlpha(iA) ? (CA.consume(iA), EA) : AA(iA);
  }
}
function tokenizeEmailDomainDotTrail(CA, gA, AA) {
  return IA;
  function IA(QA) {
    return CA.consume(QA), BA;
  }
  function BA(QA) {
    return asciiAlphanumeric(QA) ? AA(QA) : gA(QA);
  }
}
function previousWww(CA) {
  return CA === null || CA === 40 || CA === 42 || CA === 95 || CA === 91 || CA === 93 || CA === 126 || markdownLineEndingOrSpace(CA);
}
function previousProtocol(CA) {
  return !asciiAlpha(CA);
}
function previousEmail(CA) {
  return !(CA === 47 || gfmAtext(CA));
}
function gfmAtext(CA) {
  return CA === 43 || CA === 45 || CA === 46 || CA === 95 || asciiAlphanumeric(CA);
}
function previousUnbalanced(CA) {
  let gA = CA.length, AA = !1;
  for (; gA--; ) {
    const IA = CA[gA][1];
    if ((IA.type === "labelLink" || IA.type === "labelImage") && !IA._balanced) {
      AA = !0;
      break;
    }
    if (IA._gfmAutolinkLiteralWalkedInto) {
      AA = !1;
      break;
    }
  }
  return CA.length > 0 && !AA && (CA[CA.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), AA;
}
const indent = {
  tokenize: tokenizeIndent,
  partial: !0
};
function gfmFootnote() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(CA, gA, AA) {
  const IA = this;
  let BA = IA.events.length;
  const QA = IA.parser.gfmFootnotes || (IA.parser.gfmFootnotes = []);
  let EA;
  for (; BA--; ) {
    const oA = IA.events[BA][1];
    if (oA.type === "labelImage") {
      EA = oA;
      break;
    }
    if (oA.type === "gfmFootnoteCall" || oA.type === "labelLink" || oA.type === "label" || oA.type === "image" || oA.type === "link")
      break;
  }
  return iA;
  function iA(oA) {
    if (!EA || !EA._balanced)
      return AA(oA);
    const cA = normalizeIdentifier(IA.sliceSerialize({
      start: EA.end,
      end: IA.now()
    }));
    return cA.codePointAt(0) !== 94 || !QA.includes(cA.slice(1)) ? AA(oA) : (CA.enter("gfmFootnoteCallLabelMarker"), CA.consume(oA), CA.exit("gfmFootnoteCallLabelMarker"), gA(oA));
  }
}
function resolveToPotentialGfmFootnoteCall(CA, gA) {
  let AA = CA.length;
  for (; AA--; )
    if (CA[AA][1].type === "labelImage" && CA[AA][0] === "enter") {
      CA[AA][1];
      break;
    }
  CA[AA + 1][1].type = "data", CA[AA + 3][1].type = "gfmFootnoteCallLabelMarker";
  const IA = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, CA[AA + 3][1].start),
    end: Object.assign({}, CA[CA.length - 1][1].end)
  }, BA = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, CA[AA + 3][1].end),
    end: Object.assign({}, CA[AA + 3][1].end)
  };
  BA.end.column++, BA.end.offset++, BA.end._bufferIndex++;
  const QA = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, BA.end),
    end: Object.assign({}, CA[CA.length - 1][1].start)
  }, EA = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, QA.start),
    end: Object.assign({}, QA.end)
  }, iA = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    CA[AA + 1],
    CA[AA + 2],
    ["enter", IA, gA],
    // The `[`
    CA[AA + 3],
    CA[AA + 4],
    // The `^`.
    ["enter", BA, gA],
    ["exit", BA, gA],
    // Everything in between.
    ["enter", QA, gA],
    ["enter", EA, gA],
    ["exit", EA, gA],
    ["exit", QA, gA],
    // The ending (`]`, properly parsed and labelled).
    CA[CA.length - 2],
    CA[CA.length - 1],
    ["exit", IA, gA]
  ];
  return CA.splice(AA, CA.length - AA + 1, ...iA), CA;
}
function tokenizeGfmFootnoteCall(CA, gA, AA) {
  const IA = this, BA = IA.parser.gfmFootnotes || (IA.parser.gfmFootnotes = []);
  let QA = 0, EA;
  return iA;
  function iA(eA) {
    return CA.enter("gfmFootnoteCall"), CA.enter("gfmFootnoteCallLabelMarker"), CA.consume(eA), CA.exit("gfmFootnoteCallLabelMarker"), oA;
  }
  function oA(eA) {
    return eA !== 94 ? AA(eA) : (CA.enter("gfmFootnoteCallMarker"), CA.consume(eA), CA.exit("gfmFootnoteCallMarker"), CA.enter("gfmFootnoteCallString"), CA.enter("chunkString").contentType = "string", cA);
  }
  function cA(eA) {
    if (
      // Too long.
      QA > 999 || // Closing brace with nothing.
      eA === 93 && !EA || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      eA === null || eA === 91 || markdownLineEndingOrSpace(eA)
    )
      return AA(eA);
    if (eA === 93) {
      CA.exit("chunkString");
      const aA = CA.exit("gfmFootnoteCallString");
      return BA.includes(normalizeIdentifier(IA.sliceSerialize(aA))) ? (CA.enter("gfmFootnoteCallLabelMarker"), CA.consume(eA), CA.exit("gfmFootnoteCallLabelMarker"), CA.exit("gfmFootnoteCall"), gA) : AA(eA);
    }
    return markdownLineEndingOrSpace(eA) || (EA = !0), QA++, CA.consume(eA), eA === 92 ? tA : cA;
  }
  function tA(eA) {
    return eA === 91 || eA === 92 || eA === 93 ? (CA.consume(eA), QA++, cA) : cA(eA);
  }
}
function tokenizeDefinitionStart(CA, gA, AA) {
  const IA = this, BA = IA.parser.gfmFootnotes || (IA.parser.gfmFootnotes = []);
  let QA, EA = 0, iA;
  return oA;
  function oA(lA) {
    return CA.enter("gfmFootnoteDefinition")._container = !0, CA.enter("gfmFootnoteDefinitionLabel"), CA.enter("gfmFootnoteDefinitionLabelMarker"), CA.consume(lA), CA.exit("gfmFootnoteDefinitionLabelMarker"), cA;
  }
  function cA(lA) {
    return lA === 94 ? (CA.enter("gfmFootnoteDefinitionMarker"), CA.consume(lA), CA.exit("gfmFootnoteDefinitionMarker"), CA.enter("gfmFootnoteDefinitionLabelString"), CA.enter("chunkString").contentType = "string", tA) : AA(lA);
  }
  function tA(lA) {
    if (
      // Too long.
      EA > 999 || // Closing brace with nothing.
      lA === 93 && !iA || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      lA === null || lA === 91 || markdownLineEndingOrSpace(lA)
    )
      return AA(lA);
    if (lA === 93) {
      CA.exit("chunkString");
      const nA = CA.exit("gfmFootnoteDefinitionLabelString");
      return QA = normalizeIdentifier(IA.sliceSerialize(nA)), CA.enter("gfmFootnoteDefinitionLabelMarker"), CA.consume(lA), CA.exit("gfmFootnoteDefinitionLabelMarker"), CA.exit("gfmFootnoteDefinitionLabel"), aA;
    }
    return markdownLineEndingOrSpace(lA) || (iA = !0), EA++, CA.consume(lA), lA === 92 ? eA : tA;
  }
  function eA(lA) {
    return lA === 91 || lA === 92 || lA === 93 ? (CA.consume(lA), EA++, tA) : tA(lA);
  }
  function aA(lA) {
    return lA === 58 ? (CA.enter("definitionMarker"), CA.consume(lA), CA.exit("definitionMarker"), BA.includes(QA) || BA.push(QA), factorySpace(CA, GA, "gfmFootnoteDefinitionWhitespace")) : AA(lA);
  }
  function GA(lA) {
    return gA(lA);
  }
}
function tokenizeDefinitionContinuation(CA, gA, AA) {
  return CA.check(blankLine, gA, CA.attempt(indent, gA, AA));
}
function gfmFootnoteDefinitionEnd(CA) {
  CA.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(CA, gA, AA) {
  const IA = this;
  return factorySpace(CA, BA, "gfmFootnoteDefinitionIndent", 5);
  function BA(QA) {
    const EA = IA.events[IA.events.length - 1];
    return EA && EA[1].type === "gfmFootnoteDefinitionIndent" && EA[2].sliceSerialize(EA[1], !0).length === 4 ? gA(QA) : AA(QA);
  }
}
function gfmStrikethrough(CA) {
  let AA = (CA || {}).singleTilde;
  const IA = {
    name: "strikethrough",
    tokenize: QA,
    resolveAll: BA
  };
  return AA == null && (AA = !0), {
    text: {
      126: IA
    },
    insideSpan: {
      null: [IA]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function BA(EA, iA) {
    let oA = -1;
    for (; ++oA < EA.length; )
      if (EA[oA][0] === "enter" && EA[oA][1].type === "strikethroughSequenceTemporary" && EA[oA][1]._close) {
        let cA = oA;
        for (; cA--; )
          if (EA[cA][0] === "exit" && EA[cA][1].type === "strikethroughSequenceTemporary" && EA[cA][1]._open && // If the sizes are the same:
          EA[oA][1].end.offset - EA[oA][1].start.offset === EA[cA][1].end.offset - EA[cA][1].start.offset) {
            EA[oA][1].type = "strikethroughSequence", EA[cA][1].type = "strikethroughSequence";
            const tA = {
              type: "strikethrough",
              start: Object.assign({}, EA[cA][1].start),
              end: Object.assign({}, EA[oA][1].end)
            }, eA = {
              type: "strikethroughText",
              start: Object.assign({}, EA[cA][1].end),
              end: Object.assign({}, EA[oA][1].start)
            }, aA = [["enter", tA, iA], ["enter", EA[cA][1], iA], ["exit", EA[cA][1], iA], ["enter", eA, iA]], GA = iA.parser.constructs.insideSpan.null;
            GA && splice(aA, aA.length, 0, resolveAll(GA, EA.slice(cA + 1, oA), iA)), splice(aA, aA.length, 0, [["exit", eA, iA], ["enter", EA[oA][1], iA], ["exit", EA[oA][1], iA], ["exit", tA, iA]]), splice(EA, cA - 1, oA - cA + 3, aA), oA = cA + aA.length - 2;
            break;
          }
      }
    for (oA = -1; ++oA < EA.length; )
      EA[oA][1].type === "strikethroughSequenceTemporary" && (EA[oA][1].type = "data");
    return EA;
  }
  function QA(EA, iA, oA) {
    const cA = this.previous, tA = this.events;
    let eA = 0;
    return aA;
    function aA(lA) {
      return cA === 126 && tA[tA.length - 1][1].type !== "characterEscape" ? oA(lA) : (EA.enter("strikethroughSequenceTemporary"), GA(lA));
    }
    function GA(lA) {
      const nA = classifyCharacter(cA);
      if (lA === 126)
        return eA > 1 ? oA(lA) : (EA.consume(lA), eA++, GA);
      if (eA < 2 && !AA) return oA(lA);
      const DA = EA.exit("strikethroughSequenceTemporary"), hA = classifyCharacter(lA);
      return DA._open = !hA || hA === 2 && !!nA, DA._close = !nA || nA === 2 && !!hA, iA(lA);
    }
  }
}
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(gA, AA, IA) {
    addImplementation(this, gA, AA, IA);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(gA) {
    if (this.map.sort(function(QA, EA) {
      return QA[0] - EA[0];
    }), this.map.length === 0)
      return;
    let AA = this.map.length;
    const IA = [];
    for (; AA > 0; )
      AA -= 1, IA.push(gA.slice(this.map[AA][0] + this.map[AA][1]), this.map[AA][2]), gA.length = this.map[AA][0];
    IA.push(gA.slice()), gA.length = 0;
    let BA = IA.pop();
    for (; BA; ) {
      for (const QA of BA)
        gA.push(QA);
      BA = IA.pop();
    }
    this.map.length = 0;
  }
}
function addImplementation(CA, gA, AA, IA) {
  let BA = 0;
  if (!(AA === 0 && IA.length === 0)) {
    for (; BA < CA.map.length; ) {
      if (CA.map[BA][0] === gA) {
        CA.map[BA][1] += AA, CA.map[BA][2].push(...IA);
        return;
      }
      BA += 1;
    }
    CA.map.push([gA, AA, IA]);
  }
}
function gfmTableAlign(CA, gA) {
  let AA = !1;
  const IA = [];
  for (; gA < CA.length; ) {
    const BA = CA[gA];
    if (AA) {
      if (BA[0] === "enter")
        BA[1].type === "tableContent" && IA.push(CA[gA + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (BA[1].type === "tableContent") {
        if (CA[gA - 1][1].type === "tableDelimiterMarker") {
          const QA = IA.length - 1;
          IA[QA] = IA[QA] === "left" ? "center" : "right";
        }
      } else if (BA[1].type === "tableDelimiterRow")
        break;
    } else BA[0] === "enter" && BA[1].type === "tableDelimiterRow" && (AA = !0);
    gA += 1;
  }
  return IA;
}
function gfmTable() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: tokenizeTable,
        resolveAll: resolveTable
      }
    }
  };
}
function tokenizeTable(CA, gA, AA) {
  const IA = this;
  let BA = 0, QA = 0, EA;
  return iA;
  function iA(dA) {
    let kA = IA.events.length - 1;
    for (; kA > -1; ) {
      const SA = IA.events[kA][1].type;
      if (SA === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      SA === "linePrefix") kA--;
      else break;
    }
    const pA = kA > -1 ? IA.events[kA][1].type : null, YA = pA === "tableHead" || pA === "tableRow" ? yA : oA;
    return YA === yA && IA.parser.lazy[IA.now().line] ? AA(dA) : YA(dA);
  }
  function oA(dA) {
    return CA.enter("tableHead"), CA.enter("tableRow"), cA(dA);
  }
  function cA(dA) {
    return dA === 124 || (EA = !0, QA += 1), tA(dA);
  }
  function tA(dA) {
    return dA === null ? AA(dA) : markdownLineEnding(dA) ? QA > 1 ? (QA = 0, IA.interrupt = !0, CA.exit("tableRow"), CA.enter("lineEnding"), CA.consume(dA), CA.exit("lineEnding"), GA) : AA(dA) : markdownSpace(dA) ? factorySpace(CA, tA, "whitespace")(dA) : (QA += 1, EA && (EA = !1, BA += 1), dA === 124 ? (CA.enter("tableCellDivider"), CA.consume(dA), CA.exit("tableCellDivider"), EA = !0, tA) : (CA.enter("data"), eA(dA)));
  }
  function eA(dA) {
    return dA === null || dA === 124 || markdownLineEndingOrSpace(dA) ? (CA.exit("data"), tA(dA)) : (CA.consume(dA), dA === 92 ? aA : eA);
  }
  function aA(dA) {
    return dA === 92 || dA === 124 ? (CA.consume(dA), eA) : eA(dA);
  }
  function GA(dA) {
    return IA.interrupt = !1, IA.parser.lazy[IA.now().line] ? AA(dA) : (CA.enter("tableDelimiterRow"), EA = !1, markdownSpace(dA) ? factorySpace(CA, lA, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(dA) : lA(dA));
  }
  function lA(dA) {
    return dA === 45 || dA === 58 ? DA(dA) : dA === 124 ? (EA = !0, CA.enter("tableCellDivider"), CA.consume(dA), CA.exit("tableCellDivider"), nA) : rA(dA);
  }
  function nA(dA) {
    return markdownSpace(dA) ? factorySpace(CA, DA, "whitespace")(dA) : DA(dA);
  }
  function DA(dA) {
    return dA === 58 ? (QA += 1, EA = !0, CA.enter("tableDelimiterMarker"), CA.consume(dA), CA.exit("tableDelimiterMarker"), hA) : dA === 45 ? (QA += 1, hA(dA)) : dA === null || markdownLineEnding(dA) ? NA(dA) : rA(dA);
  }
  function hA(dA) {
    return dA === 45 ? (CA.enter("tableDelimiterFiller"), wA(dA)) : rA(dA);
  }
  function wA(dA) {
    return dA === 45 ? (CA.consume(dA), wA) : dA === 58 ? (EA = !0, CA.exit("tableDelimiterFiller"), CA.enter("tableDelimiterMarker"), CA.consume(dA), CA.exit("tableDelimiterMarker"), sA) : (CA.exit("tableDelimiterFiller"), sA(dA));
  }
  function sA(dA) {
    return markdownSpace(dA) ? factorySpace(CA, NA, "whitespace")(dA) : NA(dA);
  }
  function NA(dA) {
    return dA === 124 ? lA(dA) : dA === null || markdownLineEnding(dA) ? !EA || BA !== QA ? rA(dA) : (CA.exit("tableDelimiterRow"), CA.exit("tableHead"), gA(dA)) : rA(dA);
  }
  function rA(dA) {
    return AA(dA);
  }
  function yA(dA) {
    return CA.enter("tableRow"), bA(dA);
  }
  function bA(dA) {
    return dA === 124 ? (CA.enter("tableCellDivider"), CA.consume(dA), CA.exit("tableCellDivider"), bA) : dA === null || markdownLineEnding(dA) ? (CA.exit("tableRow"), gA(dA)) : markdownSpace(dA) ? factorySpace(CA, bA, "whitespace")(dA) : (CA.enter("data"), RA(dA));
  }
  function RA(dA) {
    return dA === null || dA === 124 || markdownLineEndingOrSpace(dA) ? (CA.exit("data"), bA(dA)) : (CA.consume(dA), dA === 92 ? FA : RA);
  }
  function FA(dA) {
    return dA === 92 || dA === 124 ? (CA.consume(dA), RA) : RA(dA);
  }
}
function resolveTable(CA, gA) {
  let AA = -1, IA = !0, BA = 0, QA = [0, 0, 0, 0], EA = [0, 0, 0, 0], iA = !1, oA = 0, cA, tA, eA;
  const aA = new EditMap();
  for (; ++AA < CA.length; ) {
    const GA = CA[AA], lA = GA[1];
    GA[0] === "enter" ? lA.type === "tableHead" ? (iA = !1, oA !== 0 && (flushTableEnd(aA, gA, oA, cA, tA), tA = void 0, oA = 0), cA = {
      type: "table",
      start: Object.assign({}, lA.start),
      // Note: correct end is set later.
      end: Object.assign({}, lA.end)
    }, aA.add(AA, 0, [["enter", cA, gA]])) : lA.type === "tableRow" || lA.type === "tableDelimiterRow" ? (IA = !0, eA = void 0, QA = [0, 0, 0, 0], EA = [0, AA + 1, 0, 0], iA && (iA = !1, tA = {
      type: "tableBody",
      start: Object.assign({}, lA.start),
      // Note: correct end is set later.
      end: Object.assign({}, lA.end)
    }, aA.add(AA, 0, [["enter", tA, gA]])), BA = lA.type === "tableDelimiterRow" ? 2 : tA ? 3 : 1) : BA && (lA.type === "data" || lA.type === "tableDelimiterMarker" || lA.type === "tableDelimiterFiller") ? (IA = !1, EA[2] === 0 && (QA[1] !== 0 && (EA[0] = EA[1], eA = flushCell(aA, gA, QA, BA, void 0, eA), QA = [0, 0, 0, 0]), EA[2] = AA)) : lA.type === "tableCellDivider" && (IA ? IA = !1 : (QA[1] !== 0 && (EA[0] = EA[1], eA = flushCell(aA, gA, QA, BA, void 0, eA)), QA = EA, EA = [QA[1], AA, 0, 0])) : lA.type === "tableHead" ? (iA = !0, oA = AA) : lA.type === "tableRow" || lA.type === "tableDelimiterRow" ? (oA = AA, QA[1] !== 0 ? (EA[0] = EA[1], eA = flushCell(aA, gA, QA, BA, AA, eA)) : EA[1] !== 0 && (eA = flushCell(aA, gA, EA, BA, AA, eA)), BA = 0) : BA && (lA.type === "data" || lA.type === "tableDelimiterMarker" || lA.type === "tableDelimiterFiller") && (EA[3] = AA);
  }
  for (oA !== 0 && flushTableEnd(aA, gA, oA, cA, tA), aA.consume(gA.events), AA = -1; ++AA < gA.events.length; ) {
    const GA = gA.events[AA];
    GA[0] === "enter" && GA[1].type === "table" && (GA[1]._align = gfmTableAlign(gA.events, AA));
  }
  return CA;
}
function flushCell(CA, gA, AA, IA, BA, QA) {
  const EA = IA === 1 ? "tableHeader" : IA === 2 ? "tableDelimiter" : "tableData", iA = "tableContent";
  AA[0] !== 0 && (QA.end = Object.assign({}, getPoint(gA.events, AA[0])), CA.add(AA[0], 0, [["exit", QA, gA]]));
  const oA = getPoint(gA.events, AA[1]);
  if (QA = {
    type: EA,
    start: Object.assign({}, oA),
    // Note: correct end is set later.
    end: Object.assign({}, oA)
  }, CA.add(AA[1], 0, [["enter", QA, gA]]), AA[2] !== 0) {
    const cA = getPoint(gA.events, AA[2]), tA = getPoint(gA.events, AA[3]), eA = {
      type: iA,
      start: Object.assign({}, cA),
      end: Object.assign({}, tA)
    };
    if (CA.add(AA[2], 0, [["enter", eA, gA]]), IA !== 2) {
      const aA = gA.events[AA[2]], GA = gA.events[AA[3]];
      if (aA[1].end = Object.assign({}, GA[1].end), aA[1].type = "chunkText", aA[1].contentType = "text", AA[3] > AA[2] + 1) {
        const lA = AA[2] + 1, nA = AA[3] - AA[2] - 1;
        CA.add(lA, nA, []);
      }
    }
    CA.add(AA[3] + 1, 0, [["exit", eA, gA]]);
  }
  return BA !== void 0 && (QA.end = Object.assign({}, getPoint(gA.events, BA)), CA.add(BA, 0, [["exit", QA, gA]]), QA = void 0), QA;
}
function flushTableEnd(CA, gA, AA, IA, BA) {
  const QA = [], EA = getPoint(gA.events, AA);
  BA && (BA.end = Object.assign({}, EA), QA.push(["exit", BA, gA])), IA.end = Object.assign({}, EA), QA.push(["exit", IA, gA]), CA.add(AA + 1, 0, QA);
}
function getPoint(CA, gA) {
  const AA = CA[gA], IA = AA[0] === "enter" ? "start" : "end";
  return AA[1][IA];
}
const tasklistCheck = {
  name: "tasklistCheck",
  tokenize: tokenizeTasklistCheck
};
function gfmTaskListItem() {
  return {
    text: {
      91: tasklistCheck
    }
  };
}
function tokenizeTasklistCheck(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(oA) {
    return (
      // Exit if there’s stuff before.
      IA.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !IA._gfmTasklistFirstContentOfListItem ? AA(oA) : (CA.enter("taskListCheck"), CA.enter("taskListCheckMarker"), CA.consume(oA), CA.exit("taskListCheckMarker"), QA)
    );
  }
  function QA(oA) {
    return markdownLineEndingOrSpace(oA) ? (CA.enter("taskListCheckValueUnchecked"), CA.consume(oA), CA.exit("taskListCheckValueUnchecked"), EA) : oA === 88 || oA === 120 ? (CA.enter("taskListCheckValueChecked"), CA.consume(oA), CA.exit("taskListCheckValueChecked"), EA) : AA(oA);
  }
  function EA(oA) {
    return oA === 93 ? (CA.enter("taskListCheckMarker"), CA.consume(oA), CA.exit("taskListCheckMarker"), CA.exit("taskListCheck"), iA) : AA(oA);
  }
  function iA(oA) {
    return markdownLineEnding(oA) ? gA(oA) : markdownSpace(oA) ? CA.check({
      tokenize: spaceThenNonSpace
    }, gA, AA)(oA) : AA(oA);
  }
}
function spaceThenNonSpace(CA, gA, AA) {
  return factorySpace(CA, IA, "whitespace");
  function IA(BA) {
    return BA === null ? AA(BA) : gA(BA);
  }
}
function gfm(CA) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(CA),
    gfmTable(),
    gfmTaskListItem()
  ]);
}
const emptyOptions$1 = {};
function remarkGfm(CA) {
  const gA = (
    /** @type {Processor<Root>} */
    this
  ), AA = CA || emptyOptions$1, IA = gA.data(), BA = IA.micromarkExtensions || (IA.micromarkExtensions = []), QA = IA.fromMarkdownExtensions || (IA.fromMarkdownExtensions = []), EA = IA.toMarkdownExtensions || (IA.toMarkdownExtensions = []);
  BA.push(gfm(AA)), QA.push(gfmFromMarkdown()), EA.push(gfmToMarkdown(AA));
}
function mathFromMarkdown() {
  return {
    enter: {
      mathFlow: CA,
      mathFlowFenceMeta: gA,
      mathText: QA
    },
    exit: {
      mathFlow: BA,
      mathFlowFence: IA,
      mathFlowFenceMeta: AA,
      mathFlowValue: iA,
      mathText: EA,
      mathTextData: iA
    }
  };
  function CA(oA) {
    const cA = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [cA] }
      },
      oA
    );
  }
  function gA() {
    this.buffer();
  }
  function AA() {
    const oA = this.resume(), cA = this.stack[this.stack.length - 1];
    cA.type, cA.meta = oA;
  }
  function IA() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function BA(oA) {
    const cA = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), tA = this.stack[this.stack.length - 1];
    tA.type, this.exit(oA), tA.value = cA;
    const eA = (
      /** @type {HastElement} */
      tA.data.hChildren[0]
    );
    eA.type, eA.tagName, eA.children.push({ type: "text", value: cA }), this.data.mathFlowInside = void 0;
  }
  function QA(oA) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      oA
    ), this.buffer();
  }
  function EA(oA) {
    const cA = this.resume(), tA = this.stack[this.stack.length - 1];
    tA.type, this.exit(oA), tA.value = cA, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    tA.data.hChildren.push({ type: "text", value: cA });
  }
  function iA(oA) {
    this.config.enter.data.call(this, oA), this.config.exit.data.call(this, oA);
  }
}
function mathToMarkdown(CA) {
  let gA = (CA || {}).singleDollarTextMath;
  return gA == null && (gA = !0), IA.peek = BA, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: gA ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: AA, inlineMath: IA }
  };
  function AA(QA, EA, iA, oA) {
    const cA = QA.value || "", tA = iA.createTracker(oA), eA = "$".repeat(Math.max(longestStreak(cA, "$") + 1, 2)), aA = iA.enter("mathFlow");
    let GA = tA.move(eA);
    if (QA.meta) {
      const lA = iA.enter("mathFlowMeta");
      GA += tA.move(
        iA.safe(QA.meta, {
          after: `
`,
          before: GA,
          encode: ["$"],
          ...tA.current()
        })
      ), lA();
    }
    return GA += tA.move(`
`), cA && (GA += tA.move(cA + `
`)), GA += tA.move(eA), aA(), GA;
  }
  function IA(QA, EA, iA) {
    let oA = QA.value || "", cA = 1;
    for (gA || cA++; new RegExp("(^|[^$])" + "\\$".repeat(cA) + "([^$]|$)").test(oA); )
      cA++;
    const tA = "$".repeat(cA);
    // Contains non-space.
    /[^ \r\n]/.test(oA) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(oA) && /[ \r\n]$/.test(oA) || // Starts or ends with dollar.
    /^\$|\$$/.test(oA)) && (oA = " " + oA + " ");
    let eA = -1;
    for (; ++eA < iA.unsafe.length; ) {
      const aA = iA.unsafe[eA];
      if (!aA.atBreak) continue;
      const GA = iA.compilePattern(aA);
      let lA;
      for (; lA = GA.exec(oA); ) {
        let nA = lA.index;
        oA.codePointAt(nA) === 10 && oA.codePointAt(nA - 1) === 13 && nA--, oA = oA.slice(0, nA) + " " + oA.slice(lA.index + 1);
      }
    }
    return tA + oA + tA;
  }
  function BA() {
    return "$";
  }
}
const mathFlow = {
  tokenize: tokenizeMathFenced,
  concrete: !0,
  name: "mathFlow"
}, nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: !0
};
function tokenizeMathFenced(CA, gA, AA) {
  const IA = this, BA = IA.events[IA.events.length - 1], QA = BA && BA[1].type === "linePrefix" ? BA[2].sliceSerialize(BA[1], !0).length : 0;
  let EA = 0;
  return iA;
  function iA(wA) {
    return CA.enter("mathFlow"), CA.enter("mathFlowFence"), CA.enter("mathFlowFenceSequence"), oA(wA);
  }
  function oA(wA) {
    return wA === 36 ? (CA.consume(wA), EA++, oA) : EA < 2 ? AA(wA) : (CA.exit("mathFlowFenceSequence"), factorySpace(CA, cA, "whitespace")(wA));
  }
  function cA(wA) {
    return wA === null || markdownLineEnding(wA) ? eA(wA) : (CA.enter("mathFlowFenceMeta"), CA.enter("chunkString", {
      contentType: "string"
    }), tA(wA));
  }
  function tA(wA) {
    return wA === null || markdownLineEnding(wA) ? (CA.exit("chunkString"), CA.exit("mathFlowFenceMeta"), eA(wA)) : wA === 36 ? AA(wA) : (CA.consume(wA), tA);
  }
  function eA(wA) {
    return CA.exit("mathFlowFence"), IA.interrupt ? gA(wA) : CA.attempt(nonLazyContinuation, aA, DA)(wA);
  }
  function aA(wA) {
    return CA.attempt({
      tokenize: hA,
      partial: !0
    }, DA, GA)(wA);
  }
  function GA(wA) {
    return (QA ? factorySpace(CA, lA, "linePrefix", QA + 1) : lA)(wA);
  }
  function lA(wA) {
    return wA === null ? DA(wA) : markdownLineEnding(wA) ? CA.attempt(nonLazyContinuation, aA, DA)(wA) : (CA.enter("mathFlowValue"), nA(wA));
  }
  function nA(wA) {
    return wA === null || markdownLineEnding(wA) ? (CA.exit("mathFlowValue"), lA(wA)) : (CA.consume(wA), nA);
  }
  function DA(wA) {
    return CA.exit("mathFlow"), gA(wA);
  }
  function hA(wA, sA, NA) {
    let rA = 0;
    return factorySpace(wA, yA, "linePrefix", IA.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function yA(FA) {
      return wA.enter("mathFlowFence"), wA.enter("mathFlowFenceSequence"), bA(FA);
    }
    function bA(FA) {
      return FA === 36 ? (rA++, wA.consume(FA), bA) : rA < EA ? NA(FA) : (wA.exit("mathFlowFenceSequence"), factorySpace(wA, RA, "whitespace")(FA));
    }
    function RA(FA) {
      return FA === null || markdownLineEnding(FA) ? (wA.exit("mathFlowFence"), sA(FA)) : NA(FA);
    }
  }
}
function tokenizeNonLazyContinuation(CA, gA, AA) {
  const IA = this;
  return BA;
  function BA(EA) {
    return EA === null ? gA(EA) : (CA.enter("lineEnding"), CA.consume(EA), CA.exit("lineEnding"), QA);
  }
  function QA(EA) {
    return IA.parser.lazy[IA.now().line] ? AA(EA) : gA(EA);
  }
}
function mathText(CA) {
  let AA = (CA || {}).singleDollarTextMath;
  return AA == null && (AA = !0), {
    tokenize: IA,
    resolve: resolveMathText,
    previous,
    name: "mathText"
  };
  function IA(BA, QA, EA) {
    let iA = 0, oA, cA;
    return tA;
    function tA(nA) {
      return BA.enter("mathText"), BA.enter("mathTextSequence"), eA(nA);
    }
    function eA(nA) {
      return nA === 36 ? (BA.consume(nA), iA++, eA) : iA < 2 && !AA ? EA(nA) : (BA.exit("mathTextSequence"), aA(nA));
    }
    function aA(nA) {
      return nA === null ? EA(nA) : nA === 36 ? (cA = BA.enter("mathTextSequence"), oA = 0, lA(nA)) : nA === 32 ? (BA.enter("space"), BA.consume(nA), BA.exit("space"), aA) : markdownLineEnding(nA) ? (BA.enter("lineEnding"), BA.consume(nA), BA.exit("lineEnding"), aA) : (BA.enter("mathTextData"), GA(nA));
    }
    function GA(nA) {
      return nA === null || nA === 32 || nA === 36 || markdownLineEnding(nA) ? (BA.exit("mathTextData"), aA(nA)) : (BA.consume(nA), GA);
    }
    function lA(nA) {
      return nA === 36 ? (BA.consume(nA), oA++, lA) : oA === iA ? (BA.exit("mathTextSequence"), BA.exit("mathText"), QA(nA)) : (cA.type = "mathTextData", GA(nA));
    }
  }
}
function resolveMathText(CA) {
  let gA = CA.length - 4, AA = 3, IA, BA;
  if ((CA[AA][1].type === "lineEnding" || CA[AA][1].type === "space") && (CA[gA][1].type === "lineEnding" || CA[gA][1].type === "space")) {
    for (IA = AA; ++IA < gA; )
      if (CA[IA][1].type === "mathTextData") {
        CA[gA][1].type = "mathTextPadding", CA[AA][1].type = "mathTextPadding", AA += 2, gA -= 2;
        break;
      }
  }
  for (IA = AA - 1, gA++; ++IA <= gA; )
    BA === void 0 ? IA !== gA && CA[IA][1].type !== "lineEnding" && (BA = IA) : (IA === gA || CA[IA][1].type === "lineEnding") && (CA[BA][1].type = "mathTextData", IA !== BA + 2 && (CA[BA][1].end = CA[IA - 1][1].end, CA.splice(BA + 2, IA - BA - 2), gA -= IA - BA - 2, IA = BA + 2), BA = void 0);
  return CA;
}
function previous(CA) {
  return CA !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function math(CA) {
  return {
    flow: {
      36: mathFlow
    },
    text: {
      36: mathText(CA)
    }
  };
}
const emptyOptions = {};
function remarkMath(CA) {
  const gA = (
    /** @type {Processor} */
    this
  ), AA = CA || emptyOptions, IA = gA.data(), BA = IA.micromarkExtensions || (IA.micromarkExtensions = []), QA = IA.fromMarkdownExtensions || (IA.fromMarkdownExtensions = []), EA = IA.toMarkdownExtensions || (IA.toMarkdownExtensions = []);
  BA.push(math(AA)), QA.push(mathFromMarkdown()), EA.push(mathToMarkdown(AA));
}
var cn = Object.defineProperty, un = Object.defineProperties, fn = Object.getOwnPropertyDescriptors, $$1 = Object.getOwnPropertySymbols, dn = Object.prototype.hasOwnProperty, gn = Object.prototype.propertyIsEnumerable, O = (CA, gA, AA) => gA in CA ? cn(CA, gA, { enumerable: !0, configurable: !0, writable: !0, value: AA }) : CA[gA] = AA, I$1 = (CA, gA) => {
  for (var AA in gA || (gA = {})) dn.call(gA, AA) && O(CA, AA, gA[AA]);
  if ($$1) for (var AA of $$1(gA)) gn.call(gA, AA) && O(CA, AA, gA[AA]);
  return CA;
}, k = (CA, gA) => un(CA, fn(gA)), c$2 = (CA, gA) => {
  let AA = !1, IA = !1;
  for (let BA = 0; BA < gA; BA += 1) {
    if (CA[BA] === "\\" && BA + 1 < CA.length && CA[BA + 1] === "`") {
      BA += 1;
      continue;
    }
    if (CA.substring(BA, BA + 3) === "```") {
      IA = !IA, BA += 2;
      continue;
    }
    !IA && CA[BA] === "`" && (AA = !AA);
  }
  return AA || IA;
}, hn = (CA, gA) => {
  let AA = CA.substring(gA, gA + 3) === "```", IA = gA > 0 && CA.substring(gA - 1, gA + 2) === "```", BA = gA > 1 && CA.substring(gA - 2, gA + 1) === "```";
  return AA || IA || BA;
}, L$1 = (CA) => {
  let gA = 0;
  for (let AA = 0; AA < CA.length; AA += 1) {
    if (CA[AA] === "\\" && AA + 1 < CA.length && CA[AA + 1] === "`") {
      AA += 1;
      continue;
    }
    CA[AA] === "`" && !hn(CA, AA) && (gA += 1);
  }
  return gA;
}, f$1 = (CA, gA) => {
  let AA = !1, IA = !1, BA = -1;
  for (let QA = 0; QA < CA.length; QA += 1) {
    if (CA[QA] === "\\" && QA + 1 < CA.length && CA[QA + 1] === "`") {
      QA += 1;
      continue;
    }
    if (CA.substring(QA, QA + 3) === "```") {
      IA = !IA, QA += 2;
      continue;
    }
    if (!IA && CA[QA] === "`") if (AA) {
      if (BA < gA && gA < QA) return !0;
      AA = !1, BA = -1;
    } else AA = !0, BA = QA;
  }
  return !1;
}, mn = /^(\s*(?:[-*+]|\d+[.)]) +)>(=?\s*[$]?\d)/gm, E = (CA) => !CA || typeof CA != "string" || !CA.includes(">") ? CA : CA.replace(mn, (gA, AA, IA, BA) => c$2(CA, BA) ? gA : `${AA}\\>${IA}`), M = /(\*\*)([^*]*\*?)$/, N$1 = /(__)([^_]*?)$/, y$1 = /(\*\*\*)([^*]*?)$/, R = /(\*)([^*]*?)$/, U$1 = /(_)([^_]*?)$/, W$1 = /(`)([^`]*?)$/, K$1 = /(~~)([^~]*?)$/, d$1 = /^[\s_~*`]*$/, b = /^[\s]*[-*+][\s]+$/, H = /[\p{L}\p{N}_]/u, D = /^```[^`\n]*```?$/, w$1 = /^\*{4,}$/, G$1 = /(__)([^_]+)_$/, F$1 = /(~~)([^~]+)~$/, T = /~~/g, g = (CA) => {
  if (!CA) return !1;
  let gA = CA.charCodeAt(0);
  return gA >= 48 && gA <= 57 || gA >= 65 && gA <= 90 || gA >= 97 && gA <= 122 || gA === 95 ? !0 : H.test(CA);
}, X$1 = (CA, gA) => {
  let AA = 1;
  for (let IA = gA - 1; IA >= 0; IA -= 1) if (CA[IA] === "]") AA += 1;
  else if (CA[IA] === "[" && (AA -= 1, AA === 0)) return IA;
  return -1;
}, C = (CA, gA) => {
  let AA = 1;
  for (let IA = gA + 1; IA < CA.length; IA += 1) if (CA[IA] === "[") AA += 1;
  else if (CA[IA] === "]" && (AA -= 1, AA === 0)) return IA;
  return -1;
}, h = (CA, gA) => {
  let AA = !1, IA = !1;
  for (let BA = 0; BA < CA.length && BA < gA; BA += 1) {
    if (CA[BA] === "\\" && CA[BA + 1] === "$") {
      BA += 1;
      continue;
    }
    CA[BA] === "$" && (CA[BA + 1] === "$" ? (IA = !IA, BA += 1, AA = !1) : IA || (AA = !AA));
  }
  return AA || IA;
}, In = (CA, gA) => {
  for (let AA = gA; AA < CA.length; AA += 1) {
    if (CA[AA] === ")") return !0;
    if (CA[AA] === `
`) return !1;
  }
  return !1;
}, m$1 = (CA, gA) => {
  for (let AA = gA - 1; AA >= 0; AA -= 1) {
    if (CA[AA] === ")") return !1;
    if (CA[AA] === "(") return AA > 0 && CA[AA - 1] === "]" ? In(CA, gA) : !1;
    if (CA[AA] === `
`) return !1;
  }
  return !1;
}, z$1 = (CA, gA) => {
  for (let AA = gA - 1; AA >= 0; AA -= 1) {
    if (CA[AA] === ">") return !1;
    if (CA[AA] === "<") {
      let IA = AA + 1 < CA.length ? CA[AA + 1] : "";
      return IA >= "a" && IA <= "z" || IA >= "A" && IA <= "Z" || IA === "/";
    }
    if (CA[AA] === `
`) return !1;
  }
  return !1;
}, p$1 = (CA, gA, AA) => {
  let IA = 0;
  for (let oA = gA - 1; oA >= 0; oA -= 1) if (CA[oA] === `
`) {
    IA = oA + 1;
    break;
  }
  let BA = CA.length;
  for (let oA = gA; oA < CA.length; oA += 1) if (CA[oA] === `
`) {
    BA = oA;
    break;
  }
  let QA = CA.substring(IA, BA), EA = 0, iA = !1;
  for (let oA of QA) if (oA === AA) EA += 1;
  else if (oA !== " " && oA !== "	") {
    iA = !0;
    break;
  }
  return EA >= 3 && !iA;
}, kn = (CA, gA, AA, IA) => AA === "\\" || CA.includes("$") && h(CA, gA) ? !0 : AA !== "*" && IA === "*" ? (gA < CA.length - 2 ? CA[gA + 2] : "") !== "*" : !!(AA === "*" || AA && IA && g(AA) && g(IA) || (!AA || AA === " " || AA === "	" || AA === `
`) && (!IA || IA === " " || IA === "	" || IA === `
`)), Y = (CA) => {
  let gA = 0, AA = !1, IA = CA.length;
  for (let BA = 0; BA < IA; BA += 1) {
    if (CA[BA] === "`" && BA + 2 < IA && CA[BA + 1] === "`" && CA[BA + 2] === "`") {
      AA = !AA, BA += 2;
      continue;
    }
    if (AA || CA[BA] !== "*") continue;
    let QA = BA > 0 ? CA[BA - 1] : "", EA = BA < IA - 1 ? CA[BA + 1] : "";
    kn(CA, BA, QA, EA) || (gA += 1);
  }
  return gA;
}, bn = (CA, gA, AA, IA) => !!(AA === "\\" || CA.includes("$") && h(CA, gA) || m$1(CA, gA) || z$1(CA, gA) || AA === "_" || IA === "_" || AA && IA && g(AA) && g(IA)), Tn = (CA) => {
  let gA = 0, AA = !1, IA = CA.length;
  for (let BA = 0; BA < IA; BA += 1) {
    if (CA[BA] === "`" && BA + 2 < IA && CA[BA + 1] === "`" && CA[BA + 2] === "`") {
      AA = !AA, BA += 2;
      continue;
    }
    if (AA || CA[BA] !== "_") continue;
    let QA = BA > 0 ? CA[BA - 1] : "", EA = BA < IA - 1 ? CA[BA + 1] : "";
    bn(CA, BA, QA, EA) || (gA += 1);
  }
  return gA;
}, Cn = (CA) => {
  let gA = 0, AA = 0, IA = !1;
  for (let BA = 0; BA < CA.length; BA += 1) {
    if (CA[BA] === "`" && BA + 2 < CA.length && CA[BA + 1] === "`" && CA[BA + 2] === "`") {
      AA >= 3 && (gA += Math.floor(AA / 3)), AA = 0, IA = !IA, BA += 2;
      continue;
    }
    IA || (CA[BA] === "*" ? AA += 1 : (AA >= 3 && (gA += Math.floor(AA / 3)), AA = 0));
  }
  return AA >= 3 && (gA += Math.floor(AA / 3)), gA;
}, A = (CA) => {
  let gA = 0, AA = !1;
  for (let IA = 0; IA < CA.length; IA += 1) {
    if (CA[IA] === "`" && IA + 2 < CA.length && CA[IA + 1] === "`" && CA[IA + 2] === "`") {
      AA = !AA, IA += 2;
      continue;
    }
    AA || CA[IA] === "*" && IA + 1 < CA.length && CA[IA + 1] === "*" && (gA += 1, IA += 1);
  }
  return gA;
}, v = (CA) => {
  let gA = 0, AA = !1;
  for (let IA = 0; IA < CA.length; IA += 1) {
    if (CA[IA] === "`" && IA + 2 < CA.length && CA[IA + 1] === "`" && CA[IA + 2] === "`") {
      AA = !AA, IA += 2;
      continue;
    }
    AA || CA[IA] === "_" && IA + 1 < CA.length && CA[IA + 1] === "_" && (gA += 1, IA += 1);
  }
  return gA;
}, An = (CA, gA, AA) => {
  if (!gA || d$1.test(gA)) return !0;
  let IA = CA.substring(0, AA).lastIndexOf(`
`), BA = IA === -1 ? 0 : IA + 1, QA = CA.substring(BA, AA);
  return b.test(QA) && gA.includes(`
`) ? !0 : p$1(CA, AA, "*");
}, j = (CA) => {
  let gA = CA.match(M);
  if (!gA) return CA;
  let AA = gA[2], IA = CA.lastIndexOf(gA[1]);
  return c$2(CA, IA) || f$1(CA, IA) || An(CA, AA, IA) ? CA : A(CA) % 2 === 1 ? AA.endsWith("*") ? `${CA}*` : `${CA}**` : CA;
}, Bn = (CA, gA, AA) => {
  if (!gA || d$1.test(gA)) return !0;
  let IA = CA.substring(0, AA).lastIndexOf(`
`), BA = IA === -1 ? 0 : IA + 1, QA = CA.substring(BA, AA);
  return b.test(QA) && gA.includes(`
`) ? !0 : p$1(CA, AA, "_");
}, Q$1 = (CA) => {
  let gA = CA.match(N$1);
  if (!gA) {
    let BA = CA.match(G$1);
    if (BA) {
      let QA = CA.lastIndexOf(BA[1]);
      if (!(c$2(CA, QA) || f$1(CA, QA)) && v(CA) % 2 === 1) return `${CA}_`;
    }
    return CA;
  }
  let AA = gA[2], IA = CA.lastIndexOf(gA[1]);
  return c$2(CA, IA) || f$1(CA, IA) || Bn(CA, AA, IA) ? CA : v(CA) % 2 === 1 ? `${CA}__` : CA;
}, Sn = (CA) => {
  let gA = !1;
  for (let AA = 0; AA < CA.length; AA += 1) {
    if (CA[AA] === "`" && AA + 2 < CA.length && CA[AA + 1] === "`" && CA[AA + 2] === "`") {
      gA = !gA, AA += 2;
      continue;
    }
    if (!gA && CA[AA] === "*" && CA[AA - 1] !== "*" && CA[AA + 1] !== "*" && CA[AA - 1] !== "\\" && !h(CA, AA)) {
      let IA = AA > 0 ? CA[AA - 1] : "", BA = AA < CA.length - 1 ? CA[AA + 1] : "";
      if ((!IA || IA === " " || IA === "	" || IA === `
`) && (!BA || BA === " " || BA === "	" || BA === `
`) || IA && BA && g(IA) && g(BA)) continue;
      return AA;
    }
  }
  return -1;
}, Z$1 = (CA) => {
  if (!CA.match(R)) return CA;
  let gA = Sn(CA);
  if (gA === -1 || c$2(CA, gA) || f$1(CA, gA)) return CA;
  let AA = CA.substring(gA + 1);
  return !AA || d$1.test(AA) ? CA : Y(CA) % 2 === 1 ? `${CA}*` : CA;
}, q = (CA) => {
  let gA = !1;
  for (let AA = 0; AA < CA.length; AA += 1) {
    if (CA[AA] === "`" && AA + 2 < CA.length && CA[AA + 1] === "`" && CA[AA + 2] === "`") {
      gA = !gA, AA += 2;
      continue;
    }
    if (!gA && CA[AA] === "_" && CA[AA - 1] !== "_" && CA[AA + 1] !== "_" && CA[AA - 1] !== "\\" && !h(CA, AA) && !m$1(CA, AA)) {
      let IA = AA > 0 ? CA[AA - 1] : "", BA = AA < CA.length - 1 ? CA[AA + 1] : "";
      if (IA && BA && g(IA) && g(BA)) continue;
      return AA;
    }
  }
  return -1;
}, _n = (CA) => {
  let gA = CA.length;
  for (; gA > 0 && CA[gA - 1] === `
`; ) gA -= 1;
  if (gA < CA.length) {
    let AA = CA.slice(0, gA), IA = CA.slice(gA);
    return `${AA}_${IA}`;
  }
  return `${CA}_`;
}, Pn = (CA) => {
  if (!CA.endsWith("**")) return null;
  let gA = CA.slice(0, -2);
  if (A(gA) % 2 !== 1) return null;
  let AA = gA.indexOf("**"), IA = q(gA);
  return AA !== -1 && IA !== -1 && AA < IA ? `${gA}_**` : null;
}, J$1 = (CA) => {
  if (!CA.match(U$1)) return CA;
  let gA = q(CA);
  if (gA === -1) return CA;
  let AA = CA.substring(gA + 1);
  if (!AA || d$1.test(AA) || c$2(CA, gA) || f$1(CA, gA)) return CA;
  if (Tn(CA) % 2 === 1) {
    let IA = Pn(CA);
    return IA !== null ? IA : _n(CA);
  }
  return CA;
}, $n = (CA) => {
  let gA = A(CA), AA = Y(CA);
  return gA % 2 === 0 && AA % 2 === 0;
}, On = (CA, gA, AA) => !gA || d$1.test(gA) || c$2(CA, AA) || f$1(CA, AA) ? !0 : p$1(CA, AA, "*"), V$1 = (CA) => {
  if (w$1.test(CA)) return CA;
  let gA = CA.match(y$1);
  if (!gA) return CA;
  let AA = gA[2], IA = CA.lastIndexOf(gA[1]);
  return On(CA, AA, IA) ? CA : Cn(CA) % 2 === 1 ? $n(CA) ? CA : `${CA}***` : CA;
}, Ln = /<[a-zA-Z/][^>]*$/, x = (CA) => {
  let gA = CA.match(Ln);
  return !gA || gA.index === void 0 || c$2(CA, gA.index) ? CA : CA.substring(0, gA.index).trimEnd();
}, En = (CA) => !CA.match(D) || CA.includes(`
`) ? null : CA.endsWith("``") && !CA.endsWith("```") ? `${CA}\`` : CA, Mn = (CA) => (CA.match(/```/g) || []).length % 2 === 1, nn = (CA) => {
  let gA = En(CA);
  if (gA !== null) return gA;
  let AA = CA.match(W$1);
  if (AA && !Mn(CA)) {
    let IA = AA[2];
    if (!IA || d$1.test(IA)) return CA;
    if (L$1(CA) % 2 === 1) return `${CA}\``;
  }
  return CA;
}, en = (CA, gA) => gA >= 2 && CA.substring(gA - 2, gA + 1) === "```" || gA >= 1 && CA.substring(gA - 1, gA + 2) === "```" || gA <= CA.length - 3 && CA.substring(gA, gA + 3) === "```", Nn = (CA) => {
  let gA = 0, AA = !1;
  for (let IA = 0; IA < CA.length - 1; IA += 1) CA[IA] === "`" && !en(CA, IA) && (AA = !AA), !AA && CA[IA] === "$" && CA[IA + 1] === "$" && (gA += 1, IA += 1);
  return gA;
}, yn = (CA) => {
  let gA = 0, AA = !1;
  for (let IA = 0; IA < CA.length; IA += 1) {
    if (CA[IA] === "\\") {
      IA += 1;
      continue;
    }
    if (CA[IA] === "`" && !en(CA, IA)) {
      AA = !AA;
      continue;
    }
    !AA && CA[IA] === "$" && (IA + 1 < CA.length && CA[IA + 1] === "$" ? IA += 1 : gA += 1);
  }
  return gA;
}, Rn = (CA) => {
  if (CA.endsWith("$") && !CA.endsWith("$$")) return `${CA}$`;
  let gA = CA.indexOf("$$");
  return gA !== -1 && CA.indexOf(`
`, gA) !== -1 && !CA.endsWith(`
`) ? `${CA}
$$` : `${CA}$$`;
}, rn = (CA) => Nn(CA) % 2 === 0 ? CA : Rn(CA), sn = (CA) => yn(CA) % 2 === 1 ? `${CA}$` : CA, Un = (CA, gA, AA) => {
  if (CA.substring(gA + 2).includes(")")) return null;
  let IA = X$1(CA, gA);
  if (IA === -1 || c$2(CA, IA)) return null;
  let BA = IA > 0 && CA[IA - 1] === "!", QA = BA ? IA - 1 : IA, EA = CA.substring(0, QA);
  if (BA) return EA;
  let iA = CA.substring(IA + 1, gA);
  return AA === "text-only" ? `${EA}${iA}` : `${EA}[${iA}](streamdown:incomplete-link)`;
}, on = (CA, gA) => {
  for (let AA = 0; AA < gA; AA++) if (CA[AA] === "[" && !c$2(CA, AA)) {
    if (AA > 0 && CA[AA - 1] === "!") continue;
    let IA = C(CA, AA);
    if (IA === -1) return AA;
    if (IA + 1 < CA.length && CA[IA + 1] === "(") {
      let BA = CA.indexOf(")", IA + 2);
      BA !== -1 && (AA = BA);
    }
  }
  return gA;
}, Wn = (CA, gA, AA) => {
  let IA = gA > 0 && CA[gA - 1] === "!", BA = IA ? gA - 1 : gA;
  if (!CA.substring(gA + 1).includes("]")) {
    let QA = CA.substring(0, BA);
    if (IA) return QA;
    if (AA === "text-only") {
      let EA = on(CA, gA);
      return CA.substring(0, EA) + CA.substring(EA + 1);
    }
    return `${CA}](streamdown:incomplete-link)`;
  }
  if (C(CA, gA) === -1) {
    let QA = CA.substring(0, BA);
    if (IA) return QA;
    if (AA === "text-only") {
      let EA = on(CA, gA);
      return CA.substring(0, EA) + CA.substring(EA + 1);
    }
    return `${CA}](streamdown:incomplete-link)`;
  }
  return null;
}, B$1 = (CA, gA = "protocol") => {
  let AA = CA.lastIndexOf("](");
  if (AA !== -1 && !c$2(CA, AA)) {
    let IA = Un(CA, AA, gA);
    if (IA !== null) return IA;
  }
  for (let IA = CA.length - 1; IA >= 0; IA -= 1) if (CA[IA] === "[" && !c$2(CA, IA)) {
    let BA = Wn(CA, IA, gA);
    if (BA !== null) return BA;
  }
  return CA;
}, Kn = /^-{1,2}$/, Hn = /^[\s]*-{1,2}[\s]+$/, Dn = /^={1,2}$/, wn = /^[\s]*={1,2}[\s]+$/, ln = (CA) => {
  if (!CA || typeof CA != "string") return CA;
  let gA = CA.lastIndexOf(`
`);
  if (gA === -1) return CA;
  let AA = CA.substring(gA + 1), IA = CA.substring(0, gA), BA = AA.trim();
  if (Kn.test(BA) && !AA.match(Hn)) {
    let QA = IA.split(`
`).at(-1);
    if (QA && QA.trim().length > 0) return `${CA}​`;
  }
  if (Dn.test(BA) && !AA.match(wn)) {
    let QA = IA.split(`
`).at(-1);
    if (QA && QA.trim().length > 0) return `${CA}​`;
  }
  return CA;
}, Gn = new RegExp("(?<=[\\p{L}\\p{N}_])~(?!~)(?=[\\p{L}\\p{N}_])", "gu"), tn = (CA) => !CA || typeof CA != "string" || !CA.includes("~") ? CA : CA.replace(Gn, (gA, AA) => c$2(CA, AA) ? gA : "\\~"), an = (CA) => {
  var gA, AA;
  let IA = CA.match(K$1);
  if (IA) {
    let BA = IA[2];
    if (!BA || d$1.test(BA)) return CA;
    let QA = CA.lastIndexOf(IA[1]);
    if (c$2(CA, QA) || f$1(CA, QA)) return CA;
    if (((gA = CA.match(T)) == null ? void 0 : gA.length) % 2 === 1) return `${CA}~~`;
  } else {
    let BA = CA.match(F$1);
    if (BA) {
      let QA = CA.lastIndexOf(BA[0].slice(0, 2));
      if (c$2(CA, QA) || f$1(CA, QA)) return CA;
      if (((AA = CA.match(T)) == null ? void 0 : AA.length) % 2 === 1) return `${CA}~`;
    }
  }
  return CA;
}, S = (CA) => CA !== !1, Fn = (CA) => CA === !0, u$1 = { SINGLE_TILDE: 0, COMPARISON_OPERATORS: 5, HTML_TAGS: 10, SETEXT_HEADINGS: 15, LINKS: 20, BOLD_ITALIC: 30, BOLD: 35, ITALIC_DOUBLE_UNDERSCORE: 40, ITALIC_SINGLE_ASTERISK: 41, ITALIC_SINGLE_UNDERSCORE: 42, INLINE_CODE: 50, STRIKETHROUGH: 60, KATEX: 70, INLINE_KATEX: 75, DEFAULT: 100 }, Xn = [{ handler: { name: "singleTilde", handle: tn, priority: u$1.SINGLE_TILDE }, optionKey: "singleTilde" }, { handler: { name: "comparisonOperators", handle: E, priority: u$1.COMPARISON_OPERATORS }, optionKey: "comparisonOperators" }, { handler: { name: "htmlTags", handle: x, priority: u$1.HTML_TAGS }, optionKey: "htmlTags" }, { handler: { name: "setextHeadings", handle: ln, priority: u$1.SETEXT_HEADINGS }, optionKey: "setextHeadings" }, { handler: { name: "links", handle: B$1, priority: u$1.LINKS }, optionKey: "links", earlyReturn: (CA) => CA.endsWith("](streamdown:incomplete-link)") }, { handler: { name: "boldItalic", handle: V$1, priority: u$1.BOLD_ITALIC }, optionKey: "boldItalic" }, { handler: { name: "bold", handle: j, priority: u$1.BOLD }, optionKey: "bold" }, { handler: { name: "italicDoubleUnderscore", handle: Q$1, priority: u$1.ITALIC_DOUBLE_UNDERSCORE }, optionKey: "italic" }, { handler: { name: "italicSingleAsterisk", handle: Z$1, priority: u$1.ITALIC_SINGLE_ASTERISK }, optionKey: "italic" }, { handler: { name: "italicSingleUnderscore", handle: J$1, priority: u$1.ITALIC_SINGLE_UNDERSCORE }, optionKey: "italic" }, { handler: { name: "inlineCode", handle: nn, priority: u$1.INLINE_CODE }, optionKey: "inlineCode" }, { handler: { name: "strikethrough", handle: an, priority: u$1.STRIKETHROUGH }, optionKey: "strikethrough" }, { handler: { name: "katex", handle: rn, priority: u$1.KATEX }, optionKey: "katex" }, { handler: { name: "inlineKatex", handle: sn, priority: u$1.INLINE_KATEX }, optionKey: "inlineKatex" }], zn = (CA) => {
  var gA;
  let AA = (gA = CA?.linkMode) != null ? gA : "protocol";
  return Xn.filter(({ handler: IA, optionKey: BA }) => IA.name === "links" ? S(CA?.links) || S(CA?.images) : IA.name === "inlineKatex" ? Fn(CA?.inlineKatex) : S(CA?.[BA])).map(({ handler: IA, earlyReturn: BA }) => IA.name === "links" ? { handler: k(I$1({}, IA), { handle: (QA) => B$1(QA, AA) }), earlyReturn: AA === "protocol" ? BA : void 0 } : { handler: IA, earlyReturn: BA });
}, vn = (CA, gA) => {
  var AA;
  if (!CA || typeof CA != "string") return CA;
  let IA = CA.endsWith(" ") && !CA.endsWith("  ") ? CA.slice(0, -1) : CA, BA = zn(gA), QA = ((AA = gA?.handlers) != null ? AA : []).map((iA) => {
    var oA;
    return { handler: k(I$1({}, iA), { priority: (oA = iA.priority) != null ? oA : u$1.DEFAULT }), earlyReturn: void 0 };
  }), EA = [...BA, ...QA].sort((iA, oA) => {
    var cA, tA;
    return ((cA = iA.handler.priority) != null ? cA : 0) - ((tA = oA.handler.priority) != null ? tA : 0);
  });
  for (let { handler: iA, earlyReturn: oA } of EA) if (IA = iA.handle(IA), oA != null && oA(IA)) return IA;
  return IA;
}, $e = vn;
function visit(CA, gA, AA, IA) {
  let BA, QA, EA;
  typeof gA == "function" && typeof AA != "function" ? (QA = void 0, EA = gA, BA = AA) : (QA = gA, EA = AA, BA = IA), visitParents(CA, QA, iA, BA);
  function iA(oA, cA) {
    const tA = cA[cA.length - 1], eA = tA ? tA.children.indexOf(oA) : void 0;
    return EA(oA, eA, tA);
  }
}
const streamlitLogo = "data:image/svg+xml,%3csvg%20width='301'%20height='165'%20viewBox='0%200%20301%20165'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M150.731%20101.547L98.1387%2073.7471L6.84674%2025.4969C6.7634%2025.4136%206.59674%2025.4136%206.51341%2025.4136C3.18007%2023.8303%20-0.236608%2027.1636%201.0134%2030.497L47.5302%20149.139L47.5385%20149.164C47.5885%20149.281%2047.6302%20149.397%2047.6802%20149.514C49.5885%20153.939%2053.7552%20156.672%2058.2886%20157.747C58.6719%20157.831%2058.9461%20157.906%2059.4064%20157.998C59.8645%20158.1%2060.5052%20158.239%2061.0552%20158.281C61.1469%20158.289%2061.2302%20158.289%2061.3219%20158.297H61.3886C61.4552%20158.306%2061.5219%20158.306%2061.5886%20158.314H61.6802C61.7386%20158.322%2061.8052%20158.322%2061.8636%20158.322H61.9719C62.0386%20158.331%2062.1052%20158.331%2062.1719%20158.331V158.331C121.084%20164.754%20180.519%20164.754%20239.431%20158.331V158.331C240.139%20158.331%20240.831%20158.297%20241.497%20158.231C241.714%20158.206%20241.922%20158.181%20242.131%20158.156C242.156%20158.147%20242.189%20158.147%20242.214%20158.139C242.356%20158.122%20242.497%20158.097%20242.639%20158.072C242.847%20158.047%20243.056%20158.006%20243.264%20157.964C243.681%20157.872%20243.87%20157.806%20244.436%20157.611C245.001%20157.417%20245.94%20157.077%20246.527%20156.794C247.115%20156.511%20247.522%20156.239%20248.014%20155.931C248.622%20155.547%20249.201%20155.155%20249.788%20154.715C250.041%20154.521%20250.214%20154.397%20250.397%20154.222L250.297%20154.164L150.731%20101.547Z'%20fill='%23FF4B4B'/%3e%3cpath%20d='M294.766%2025.4981H294.683L203.357%2073.7483L254.124%20149.357L300.524%2030.4981V30.3315C301.691%2026.8314%20298.108%2023.6648%20294.766%2025.4981'%20fill='%237D353B'/%3e%3cpath%20d='M155.598%202.55572C153.264%20-0.852624%20148.181%20-0.852624%20145.931%202.55572L98.1389%2073.7477L150.731%20101.548L250.398%20154.222C251.024%20153.609%20251.526%20153.012%20252.056%20152.381C252.806%20151.456%20253.506%20150.465%20254.123%20149.356L203.356%2073.7477L155.598%202.55572Z'%20fill='%23BD4043'/%3e%3c/svg%3e", IsSidebarContext = createContext(!1);
IsSidebarContext.displayName = "IsSidebarContext";
const TOP_DISTANCE = "-2.65rem", StyledToolbarWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e2wxzia2"
} : {
  target: "e2wxzia2",
  label: "StyledToolbarWrapper"
})(({
  theme: CA,
  locked: gA,
  target: AA
}) => ({
  padding: `${CA.spacing.sm} 0 ${CA.spacing.sm} ${CA.spacing.sm}`,
  position: "absolute",
  top: gA ? TOP_DISTANCE : "-1rem",
  right: CA.spacing.none,
  transition: "none",
  ...!gA && {
    opacity: 0,
    "&:active, &:focus-visible, &:hover": {
      transition: "opacity 150ms 100ms, top 100ms 100ms",
      opacity: 1,
      top: TOP_DISTANCE
    },
    ...AA && {
      [`${AA}:hover &, ${AA}:active &, ${AA}:focus-visible &`]: {
        transition: "opacity 150ms 100ms, top 100ms 100ms",
        opacity: 1,
        top: TOP_DISTANCE
      }
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbar = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e2wxzia1"
} : {
  target: "e2wxzia1",
  label: "StyledToolbar"
})(({
  theme: CA
}) => ({
  color: hasLightBackgroundColor(CA) ? CA.colors.fadedText60 : CA.colors.bodyText,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-end",
  boxShadow: CA.shadows.toolbar,
  borderRadius: CA.radii.default,
  backgroundColor: CA.colors.lightenedBg05,
  width: "fit-content",
  zIndex: CA.zIndices.sidebar + 1,
  padding: CA.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbarElementContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e2wxzia0"
} : {
  target: "e2wxzia0",
  label: "StyledToolbarElementContainer"
})(({
  height: CA,
  useContainerWidth: gA,
  topCentered: AA,
  useContainerHeight: IA
}) => ({
  position: "relative",
  height: gA && CA ? CA : IA ? CA || "100%" : "fit-content",
  maxWidth: "100%",
  width: gA ? "100%" : "fit-content",
  ...AA ? {
    display: "flex",
    justifyContent: "center"
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__$g() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const codeLink = {
  // Streamline the style when inside anchors to avoid broken underline and more
  "a > &": {
    color: "inherit"
  }
}, StyledInlineCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz5"
} : {
  target: "e1ycw9pz5",
  label: "StyledInlineCode"
})(({
  theme: CA
}) => ({
  padding: "0.2em 0.4em",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0,
  borderRadius: CA.radii.sm,
  background: CA.colors.codeBackgroundColor,
  color: CA.colors.codeTextColor,
  fontFamily: CA.genericFonts.codeFont,
  // Use em here so that it works correctly within headers, captions,
  // sidebar, etc.
  fontSize: CA.fontSizes.inlineCodeFontSize,
  fontWeight: CA.fontWeights.code,
  ...codeLink
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), codeBlockStyle = (CA, gA) => ({
  background: "transparent",
  border: 0,
  color: "inherit",
  display: "inline",
  fontFamily: CA.genericFonts.codeFont,
  fontSize: CA.fontSizes.codeFontSize,
  fontWeight: CA.fontWeights.code,
  lineHeight: "inherit",
  margin: 0,
  overflowX: "auto",
  padding: 0,
  whiteSpace: gA ? "pre-wrap" : "pre",
  overflowWrap: gA ? "break-word" : "normal",
  ...codeLink
}), StyledCode = /* @__PURE__ */ createStyled("code", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz4"
} : {
  target: "e1ycw9pz4",
  label: "StyledCode"
})(({
  theme: CA,
  wrapLines: gA
}) => ({
  ...codeBlockStyle(CA, gA)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPre = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz3"
} : {
  target: "e1ycw9pz3",
  label: "StyledPre"
})(({
  theme: CA,
  wrapLines: gA
}) => ({
  height: "100%",
  background: CA.colors.codeBackgroundColor,
  borderRadius: CA.radii.default,
  color: CA.colors.bodyText,
  fontSize: CA.fontSizes.twoSm,
  fontFamily: CA.genericFonts.codeFont,
  display: "block",
  // Remove browser default top margin
  margin: 0,
  // Disable auto-hiding scrollbar in legacy Edge to avoid overlap,
  // making it impossible to interact with the content
  msOverflowStyle: "scrollbar",
  // Don't allow content to break outside
  overflow: "auto",
  // Add padding around the code
  padding: CA.spacing.lg,
  code: {
    ...codeBlockStyle(CA, gA)
  },
  // The token can consist of many lines, e.g. a triple-quote string, so
  // we need to make sure that the color is not overwritten.
  ".comment.linenumber": {
    color: CA.colors.fadedText40,
    fontSize: CA.fontSizes.twoSm,
    // Center-align number vertically, or they'll be positioned differently when
    // wrapLines=true. Even with this change, though, the position is still ~2px
    // off.
    // NOTE: The alignSelf below only apply applies when wrapLines=true, because
    // that option wraps this element in a flex container.
    alignSelf: "center",
    // Override the default token's min-width, to ensure it fits 3-digit lines
    minWidth: `${CA.spacing.threeXL} !important`
  },
  ".token.comment, .token.prolog, .token.doctype, .token.cdata": {
    color: CA.colors.gray70
  },
  ".token.punctuation": {
    color: CA.colors.gray70
  },
  ".namespace": {
    opacity: 0.7
  },
  ".token.attr-name, .token.property, .token.variable": {
    color: CA.colors.lightBlue80
  },
  ".token.boolean, .token.constant, .token.symbol": {
    color: CA.colors.green70
  },
  ".token.number, .token.regex": {
    color: CA.colors.blueGreen80
  },
  ".token.string, .token.char, .token.attr-value": {
    color: CA.colors.green80
  },
  ".token.operator, .token.entity": {
    color: CA.colors.orange90
  },
  ".token.url": {
    color: CA.colors.purple80
  },
  ".token.decorator, .token.atrule": {
    color: CA.colors.orange90
  },
  ".token.keyword, .token.tag": {
    color: CA.colors.blue70
  },
  ".token.function, .token.class-name, .token.selector": {
    color: CA.colors.blue70,
    fontWeight: CA.fontWeights.codeExtraBold
  },
  ".token.important": {
    color: CA.colors.red70,
    fontWeight: CA.fontWeights.codeExtraBold
  },
  ".token.comment": {
    color: CA.colors.gray70,
    fontStyle: "italic"
  },
  ".token.italic": {
    fontStyle: "italic"
  },
  ".token.entity": {
    cursor: "help"
  },
  /**
   * Diff syntax highlighting
   */
  ".token.deleted.line, .token.deleted.prefix": {
    color: CA.colors.red70
  },
  ".token.inserted.line, .token.inserted.prefix": {
    color: CA.colors.green70
  },
  ".token.unchanged.line": {
    color: CA.colors.gray70
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), CODE_TOOLBAR_OPACITY_TRANSITION = "opacity 300ms 150ms", CODE_TOOLBAR_HIDE_TRANSITION = `${CODE_TOOLBAR_OPACITY_TRANSITION}, visibility 0ms linear 450ms`, CODE_TOOLBAR_SHOW_TRANSITION = `${CODE_TOOLBAR_OPACITY_TRANSITION}, visibility 0ms linear 150ms`, StyledCodeToolbarWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz2"
} : {
  target: "e1ycw9pz2",
  label: "StyledCodeToolbarWrapper"
})(({
  theme: CA
}) => ({
  opacity: 0,
  // Keep it out of hit testing and screen rendering while hidden.
  visibility: "hidden",
  padding: `${CA.spacing.sm} ${CA.spacing.sm} 0 0`,
  top: 0,
  right: 0,
  position: "absolute",
  zIndex: CA.zIndices.sidebar + 1,
  pointerEvents: "none",
  // Keep the delayed fade-in, but only hide visibility after fade-out completes.
  transition: CODE_TOOLBAR_HIDE_TRANSITION
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCodeBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz1"
} : {
  target: "e1ycw9pz1",
  label: "StyledCodeBlock"
})(({
  theme: CA
}) => ({
  height: "100%",
  position: "relative",
  borderRadius: CA.radii.default,
  marginLeft: CA.spacing.none,
  marginRight: CA.spacing.none,
  marginTop: CA.spacing.none,
  marginBottom: void 0,
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRing
  },
  // Keep the toolbar visible while hovering, when the container itself has
  // keyboard focus, and for keyboard focus within the toolbar.
  // Mouse clicks can focus the button too; gating descendant focus on
  // :focus-visible avoids leaving the toolbar pinned after pointer interactions.
  "&:hover, &:focus-visible, &:focus-within:has(:focus-visible)": {
    [`${StyledCodeToolbarWrapper}`]: {
      opacity: 1,
      visibility: "visible",
      pointerEvents: "auto",
      // Match visibility timing to opacity delay so it is never clickable while invisible.
      transition: CODE_TOOLBAR_SHOW_TRANSITION
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCodeToolbar = /* @__PURE__ */ createStyled(StyledToolbar, process.env.NODE_ENV === "production" ? {
  target: "e1ycw9pz0"
} : {
  target: "e1ycw9pz0",
  label: "StyledCodeToolbar"
})(process.env.NODE_ENV === "production" ? {
  name: "1quw0ni",
  styles: "pointer-events:auto"
} : {
  name: "1quw0ni",
  styles: "pointer-events:auto/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
function useTimeout(CA, gA, AA = {}) {
  const IA = useRef(null), BA = useRef(CA), QA = useRef(gA), {
    autoStart: EA = !0
  } = AA;
  useEffect(() => {
    BA.current = CA;
  }, [CA]), useEffect(() => {
    QA.current = gA;
  }, [gA]);
  const iA = useCallback(() => {
    IA.current && (clearTimeout(IA.current), IA.current = null);
  }, []), oA = useCallback((tA) => {
    iA();
    const eA = tA === void 0 ? QA.current : tA;
    eA !== null && (IA.current = setTimeout(() => {
      BA.current();
    }, eA));
  }, [iA]);
  useEffect(() => {
    if (EA)
      return oA(), iA;
  }, [EA, gA, oA, iA]), useEffect(() => iA, [iA]);
  const cA = useCallback((tA) => {
    oA(tA);
  }, [oA]);
  return {
    clear: iA,
    restart: cA
  };
}
const pulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
`, ANIMATION_STYLES = {
  animationDuration: "750ms",
  animationName: pulseAnimation,
  animationTimingFunction: "ease-in",
  animationDirection: "normal",
  animationIterationCount: "infinite"
}, StyledSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o4"
} : {
  target: "e1lmee1o4",
  label: "StyledSkeleton"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TitleSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o3"
} : {
  target: "e1lmee1o3",
  label: "TitleSkeleton"
})(({
  theme: CA
}) => ({
  height: CA.fontSizes.fourXL,
  width: `calc(${CA.sizes.contentMaxWidth} * 0.37)`,
  // Picked because it looks good.
  maxWidth: "75%",
  // Picked because it looks good.
  background: CA.colors.darkenedBgMix15,
  borderRadius: CA.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ParagraphSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o2"
} : {
  target: "e1lmee1o2",
  label: "ParagraphSkeleton"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: CA.spacing.sm
  // Picked because it looks good.
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), TextLineSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o1"
} : {
  target: "e1lmee1o1",
  label: "TextLineSkeleton"
})(({
  theme: CA,
  width: gA
}) => ({
  height: CA.fontSizes.md,
  width: gA,
  background: CA.colors.darkenedBgMix15,
  borderRadius: CA.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Ta2VsZXRvbi9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4RGdDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9Ta2VsZXRvbi9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuY29uc3QgcHVsc2VBbmltYXRpb24gPSBrZXlmcmFtZXNgXG4gIDAlLCAxMDAlIHtcbiAgICBvcGFjaXR5OiAwLjU7XG4gIH1cblxuICA1MCUge1xuICAgIG9wYWNpdHk6IDE7XG4gIH1cbmBcblxuY29uc3QgQU5JTUFUSU9OX1NUWUxFUyA9IHtcbiAgYW5pbWF0aW9uRHVyYXRpb246IFwiNzUwbXNcIixcbiAgYW5pbWF0aW9uTmFtZTogcHVsc2VBbmltYXRpb24sXG4gIGFuaW1hdGlvblRpbWluZ0Z1bmN0aW9uOiBcImVhc2UtaW5cIixcbiAgYW5pbWF0aW9uRGlyZWN0aW9uOiBcIm5vcm1hbFwiLFxuICBhbmltYXRpb25JdGVyYXRpb25Db3VudDogXCJpbmZpbml0ZVwiLFxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcubGcsXG59KSlcblxuZXhwb3J0IGNvbnN0IFRpdGxlU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGhlaWdodDogdGhlbWUuZm9udFNpemVzLmZvdXJYTCxcbiAgd2lkdGg6IGBjYWxjKCR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSAqIDAuMzcpYCwgLy8gUGlja2VkIGJlY2F1c2UgaXQgbG9va3MgZ29vZC5cbiAgbWF4V2lkdGg6IFwiNzUlXCIsIC8vIFBpY2tlZCBiZWNhdXNlIGl0IGxvb2tzIGdvb2QuXG4gIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgLi4uQU5JTUFUSU9OX1NUWUxFUyxcbn0pKVxuXG5leHBvcnQgY29uc3QgUGFyYWdyYXBoU2tlbGV0b24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sIC8vIFBpY2tlZCBiZWNhdXNlIGl0IGxvb2tzIGdvb2QuXG59KSlcblxuaW50ZXJmYWNlIFRleHRMaW5lU2tlbGV0b25Qcm9wcyB7XG4gIHdpZHRoOiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFRleHRMaW5lU2tlbGV0b24gPSBzdHlsZWQuZGl2PFRleHRMaW5lU2tlbGV0b25Qcm9wcz4oXG4gICh7IHRoZW1lLCB3aWR0aCB9KSA9PiAoe1xuICAgIGhlaWdodDogdGhlbWUuZm9udFNpemVzLm1kLFxuICAgIHdpZHRoLFxuICAgIGJhY2tncm91bmQ6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIC4uLkFOSU1BVElPTl9TVFlMRVMsXG4gIH0pXG4pXG5cbmludGVyZmFjZSBTcXVhcmVTa2VsZXRvblByb3BzIHtcbiAgaGVpZ2h0Pzogc3RyaW5nXG4gIHdpZHRoPzogc3RyaW5nXG59XG5cbmV4cG9ydCBjb25zdCBTcXVhcmVTa2VsZXRvbiA9IHN0eWxlZC5kaXY8U3F1YXJlU2tlbGV0b25Qcm9wcz4oXG4gICh7IHRoZW1lLCBoZWlnaHQsIHdpZHRoIH0pID0+ICh7XG4gICAgaGVpZ2h0OiBoZWlnaHQgPz8gdGhlbWUuZm9udFNpemVzLmZvdXJYTCxcbiAgICB3aWR0aDogd2lkdGggPz8gXCIxMDAlXCIsXG4gICAgYmFja2dyb3VuZDogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gICAgLi4uQU5JTUFUSU9OX1NUWUxFUyxcbiAgfSlcbilcbiJdfQ== */"), SquareSkeleton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1lmee1o0"
} : {
  target: "e1lmee1o0",
  label: "SquareSkeleton"
})(({
  theme: CA,
  height: gA,
  width: AA
}) => ({
  height: gA ?? CA.fontSizes.fourXL,
  width: AA ?? "100%",
  background: CA.colors.darkenedBgMix15,
  borderRadius: CA.radii.default,
  ...ANIMATION_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SHOW_DELAY_MS = 500, RawAppSkeleton = () => {
  const [CA, gA] = useState(!1);
  return useTimeout(() => {
    gA(!0);
  }, SHOW_DELAY_MS), CA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSkeleton, { className: "stAppSkeleton", "data-testid": "stAppSkeleton", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TitleSkeleton, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ParagraphSkeleton, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "98%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "100%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "96%" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextLineSkeleton, { width: "65%" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { width: "75%", height: "9rem" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, AppSkeleton = memo(RawAppSkeleton), RawSkeleton = ({
  element: CA
}) => CA.style == Skeleton$1.SkeletonStyle.APP ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppSkeleton, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(SquareSkeleton, { className: "stSkeleton", "data-testid": "stSkeleton", height: CA?.height ? CA.height + "px" : void 0 }), Skeleton = memo(RawSkeleton);
var KIND = Object.freeze({
  info: "info",
  positive: "positive",
  warning: "warning",
  negative: "negative"
}), TYPE = Object.freeze({
  inline: "inline",
  toast: "toast"
}), PLACEMENT$1 = Object.freeze({
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft"
});
function getSvgStyles(CA) {
  var gA = CA.$theme, AA = CA.$size, IA = CA.$color, BA = gA.sizing.scale600;
  AA && (gA.sizing[AA] ? BA = gA.sizing[AA] : typeof AA == "number" ? BA = "".concat(AA, "px") : BA = AA);
  var QA = "currentColor";
  return IA && (gA.colors[IA] ? QA = gA.colors[IA] : QA = IA), {
    display: "inline-block",
    fill: QA,
    color: QA,
    height: BA,
    width: BA
  };
}
var Svg = styled("svg", getSvgStyles);
Svg.displayName = "Svg";
Svg.displayName = "Svg";
function _objectDestructuringEmpty(CA) {
  if (CA == null) throw new TypeError("Cannot destructure undefined");
}
function ownKeys$f(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$d(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$f(Object(AA), !0).forEach(function(IA) {
      _defineProperty$g(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$f(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$g(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function getBackgroundColor(CA, gA, AA) {
  var IA, BA = gA === TYPE.inline;
  return (IA = {}, _defineProperty$g(IA, KIND.info, BA ? AA.colors.notificationInfoBackground : AA.colors.toastInfoBackground), _defineProperty$g(IA, KIND.positive, BA ? AA.colors.notificationPositiveBackground : AA.colors.toastPositiveBackground), _defineProperty$g(IA, KIND.warning, BA ? AA.colors.notificationWarningBackground : AA.colors.toastWarningBackground), _defineProperty$g(IA, KIND.negative, BA ? AA.colors.notificationNegativeBackground : AA.colors.toastNegativeBackground), IA)[CA];
}
function getFontColor(CA, gA, AA) {
  var IA, BA = gA === TYPE.inline;
  if (BA) {
    var QA;
    return (QA = {}, _defineProperty$g(QA, KIND.info, AA.colors.notificationInfoText), _defineProperty$g(QA, KIND.positive, AA.colors.notificationPositiveText), _defineProperty$g(QA, KIND.warning, AA.colors.notificationWarningText), _defineProperty$g(QA, KIND.negative, AA.colors.notificationNegativeText), QA)[CA];
  }
  return (IA = {}, _defineProperty$g(IA, KIND.info, AA.colors.toastInfoText), _defineProperty$g(IA, KIND.positive, AA.colors.toastPositiveText), _defineProperty$g(IA, KIND.warning, AA.colors.toastWarningText), _defineProperty$g(IA, KIND.negative, AA.colors.toastNegativeText), IA)[CA];
}
function getPlacement(CA) {
  switch (CA) {
    case PLACEMENT$1.topLeft:
      return {
        top: 0,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.top:
      return {
        top: 0,
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.topRight:
      return {
        top: 0,
        alignItems: "flex-end",
        justifyContent: "flex-start",
        flexDirection: "column"
      };
    case PLACEMENT$1.bottomRight:
      return {
        bottom: 0,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottom:
      return {
        bottom: 0,
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
    case PLACEMENT$1.bottomLeft:
      return {
        bottom: 0,
        alignItems: "flex-start",
        justifyContent: "flex-end",
        flexDirection: "column-reverse"
      };
  }
}
var Root$1 = styled("div", function(CA) {
  var gA = CA.$placement, AA = CA.$theme;
  return _objectSpread$d({
    pointerEvents: "none",
    position: "fixed",
    right: 0,
    left: 0,
    display: "flex",
    marginTop: AA.sizing.scale300,
    marginBottom: AA.sizing.scale300,
    marginLeft: AA.sizing.scale600,
    marginRight: AA.sizing.scale600
  }, getPlacement(gA));
});
Root$1.displayName = "Root";
Root$1.displayName = "Root";
var InnerContainer = styled(
  "div",
  // eslint-disable-next-line no-empty-pattern
  function(CA) {
    return _objectDestructuringEmpty(CA), {};
  }
);
InnerContainer.displayName = "InnerContainer";
InnerContainer.displayName = "InnerContainer";
var Body$3 = styled("div", function(CA) {
  var gA = CA.$isVisible, AA = CA.$kind, IA = CA.$type, BA = CA.$theme, QA = IA === TYPE.inline;
  return _objectSpread$d(_objectSpread$d({}, BA.typography.font300), {}, {
    pointerEvents: "auto",
    color: getFontColor(AA, IA, BA),
    height: "auto",
    width: "288px",
    paddingTop: BA.sizing.scale600,
    paddingRight: BA.sizing.scale600,
    paddingBottom: BA.sizing.scale600,
    paddingLeft: BA.sizing.scale600,
    marginTop: BA.sizing.scale300,
    marginBottom: BA.sizing.scale300,
    backgroundColor: getBackgroundColor(AA, IA, BA) || BA.colors.accent,
    borderTopLeftRadius: BA.borders.radius400,
    borderTopRightRadius: BA.borders.radius400,
    borderBottomRightRadius: BA.borders.radius400,
    borderBottomLeftRadius: BA.borders.radius400,
    boxShadow: QA ? "none" : BA.lighting.shadow600,
    opacity: gA ? 1 : 0,
    transitionProperty: "all",
    transitionDuration: BA.animation.timing200,
    transitionTimingFunction: BA.animation.easeInOutCurve,
    display: "flex",
    justifyContent: "space-between"
  });
});
Body$3.displayName = "Body";
Body$3.displayName = "Body";
var CloseIconSvg = styled("svg", function(CA) {
  var gA = CA.$theme, AA = CA.$size, IA = CA.$color, BA = CA.$isFocusVisible;
  return _objectSpread$d(_objectSpread$d({}, getSvgStyles({
    $theme: gA,
    $size: AA,
    $color: IA
  })), {}, {
    cursor: "pointer",
    width: AA || "16px",
    flexShrink: 0,
    outline: BA ? "3px solid ".concat(gA.colors.accent) : "none"
  });
});
CloseIconSvg.displayName = "CloseIconSvg";
CloseIconSvg.displayName = "CloseIconSvg";
function omitDollarPrefixedKeys(CA) {
  var gA = {};
  for (var AA in CA)
    AA[0] !== "$" && (gA[AA] = CA[AA]);
  return gA;
}
var _excluded$a = ["children", "title", "size", "color", "overrides"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$a.apply(this, arguments);
}
function ownKeys$e(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$c(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$e(Object(AA), !0).forEach(function(IA) {
      _defineProperty$f(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$e(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$f(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _slicedToArray$7(CA, gA) {
  return _arrayWithHoles$6(CA) || _iterableToArrayLimit$6(CA, gA) || _unsupportedIterableToArray$6(CA, gA) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$6(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$6(CA, gA);
  }
}
function _arrayLikeToArray$6(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$6(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$6(CA) {
  if (Array.isArray(CA)) return CA;
}
function _objectWithoutProperties$8(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$7(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$7(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
var Icon = function CA(gA, AA) {
  var IA = gA.children, BA = gA.title, QA = gA.size, EA = gA.color, iA = gA.overrides, oA = iA === void 0 ? {} : iA, cA = _objectWithoutProperties$8(gA, _excluded$a), tA = getOverrides(oA.Svg, Svg), eA = _slicedToArray$7(tA, 2), aA = eA[0], GA = eA[1], lA = aA.__STYLETRON__ ? _objectSpread$c(_objectSpread$c({
    title: BA,
    $color: EA,
    $size: QA
  }, cA), GA) : _objectSpread$c(_objectSpread$c({
    title: BA,
    color: EA,
    size: QA
  }, omitDollarPrefixedKeys(cA)), omitDollarPrefixedKeys(GA));
  return /* @__PURE__ */ React.createElement(aA, _extends$a({
    "data-baseweb": "icon",
    ref: AA
  }, lA), BA ? /* @__PURE__ */ React.createElement("title", null, BA) : null, IA);
};
const Icon$1 = /* @__PURE__ */ React.forwardRef(Icon);
var _excluded$9 = ["title", "size", "color", "overrides"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$9.apply(this, arguments);
}
function _objectWithoutProperties$7(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$6(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$6(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function _slicedToArray$6(CA, gA) {
  return _arrayWithHoles$5(CA) || _iterableToArrayLimit$5(CA, gA) || _unsupportedIterableToArray$5(CA, gA) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$5(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$5(CA, gA);
  }
}
function _arrayLikeToArray$5(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$5(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$5(CA) {
  if (Array.isArray(CA)) return CA;
}
function Delete(CA, gA) {
  var AA = useStyletron(), IA = _slicedToArray$6(AA, 2), BA = IA[1], QA = CA.title, EA = QA === void 0 ? "Delete" : QA, iA = CA.size, oA = CA.color, cA = CA.overrides, tA = cA === void 0 ? {} : cA, eA = _objectWithoutProperties$7(CA, _excluded$9), aA = mergeOverride(
    // Icons from the theme target the SVG override in the underlying Icon component
    {
      component: BA.icons && BA.icons.Delete ? BA.icons.Delete : null
    },
    tA && tA.Svg ? toObjectOverride(tA.Svg) : {}
  );
  return /* @__PURE__ */ React.createElement(Icon$1, _extends$9({
    viewBox: "0 0 24 24",
    ref: gA,
    title: EA,
    size: iA,
    color: oA,
    overrides: {
      Svg: aA
    }
  }, eA), /* @__PURE__ */ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}
const DeleteIcon = /* @__PURE__ */ React.forwardRef(Delete);
function _typeof$8(CA) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$8(CA);
}
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$8.apply(this, arguments);
}
function _slicedToArray$5(CA, gA) {
  return _arrayWithHoles$4(CA) || _iterableToArrayLimit$4(CA, gA) || _unsupportedIterableToArray$4(CA, gA) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$4(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$4(CA, gA);
  }
}
function _arrayLikeToArray$4(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$4(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$4(CA) {
  if (Array.isArray(CA)) return CA;
}
function _classCallCheck$7(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$7(CA, gA, AA) {
  return gA && _defineProperties$7(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$7(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$7(CA, gA);
}
function _setPrototypeOf$7(CA, gA) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$7(CA, gA);
}
function _createSuper$7(CA) {
  var gA = _isNativeReflectConstruct$7();
  return function() {
    var IA = _getPrototypeOf$7(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$7(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$7(this, BA);
  };
}
function _possibleConstructorReturn$7(CA, gA) {
  if (gA && (_typeof$8(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(CA);
}
function _assertThisInitialized$7(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$7(CA) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$7(CA);
}
function _defineProperty$e(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Toast$1 = /* @__PURE__ */ (function(CA) {
  _inherits$7(AA, CA);
  var gA = _createSuper$7(AA);
  function AA(IA) {
    var BA;
    return _classCallCheck$7(this, AA), BA = gA.call(this, IA), _defineProperty$e(_assertThisInitialized$7(BA), "autoHideTimeout", void 0), _defineProperty$e(_assertThisInitialized$7(BA), "animateInTimer", void 0), _defineProperty$e(_assertThisInitialized$7(BA), "animateOutCompleteTimer", void 0), _defineProperty$e(_assertThisInitialized$7(BA), "closeRef", void 0), _defineProperty$e(_assertThisInitialized$7(BA), "previouslyFocusedElement", void 0), _defineProperty$e(_assertThisInitialized$7(BA), "state", {
      isVisible: !1,
      isRendered: !0,
      isFocusVisible: !1
    }), _defineProperty$e(_assertThisInitialized$7(BA), "handleFocus", function(QA) {
      isFocusVisible(QA) && BA.setState({
        isFocusVisible: !0
      });
    }), _defineProperty$e(_assertThisInitialized$7(BA), "handleBlur", function(QA) {
      BA.state.isFocusVisible !== !1 && BA.setState({
        isFocusVisible: !1
      });
    }), _defineProperty$e(_assertThisInitialized$7(BA), "animateIn", function() {
      BA.animateInTimer = setTimeout(function() {
        BA.setState({
          isVisible: !0
        });
      }, 0);
    }), _defineProperty$e(_assertThisInitialized$7(BA), "animateOut", function() {
      var QA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      BA.setState({
        isVisible: !1
      }), BA.animateOutCompleteTimer = setTimeout(function() {
        BA.setState({
          isRendered: !1
        }), QA();
      }, 600);
    }), _defineProperty$e(_assertThisInitialized$7(BA), "dismiss", function() {
      BA.animateOut(BA.props.onClose), BA.props.autoFocus && BA.previouslyFocusedElement && BA.previouslyFocusedElement.focus();
    }), _defineProperty$e(_assertThisInitialized$7(BA), "onFocus", function(QA) {
      BA.state.isVisible && (clearTimeout(BA.autoHideTimeout), clearTimeout(BA.animateOutCompleteTimer), typeof BA.props.onFocus == "function" && BA.props.onFocus(QA));
    }), _defineProperty$e(_assertThisInitialized$7(BA), "onMouseEnter", function(QA) {
      BA.state.isVisible && (clearTimeout(BA.autoHideTimeout), clearTimeout(BA.animateOutCompleteTimer), typeof BA.props.onMouseEnter == "function" && BA.props.onMouseEnter(QA));
    }), _defineProperty$e(_assertThisInitialized$7(BA), "onBlur", function(QA) {
      BA.startTimeout(), typeof BA.props.onBlur == "function" && BA.props.onBlur(QA);
    }), _defineProperty$e(_assertThisInitialized$7(BA), "onMouseLeave", function(QA) {
      BA.startTimeout(), typeof BA.props.onMouseLeave == "function" && BA.props.onMouseLeave(QA);
    }), BA.closeRef = /* @__PURE__ */ React.createRef(), BA.previouslyFocusedElement = null, BA;
  }
  return _createClass$7(AA, [{
    key: "componentDidMount",
    value: function() {
      this.animateIn(), this.startTimeout(), typeof document < "u" && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus == "function" && (this.previouslyFocusedElement = document.activeElement, this.closeRef.current.focus(), this.setState({
        isFocusVisible: !0
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function(BA) {
      (this.props.autoHideDuration !== BA.autoHideDuration || this.props.__updated !== BA.__updated) && this.startTimeout();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function() {
      this.props.autoHideDuration && (this.autoHideTimeout && clearTimeout(this.autoHideTimeout), this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration));
    }
  }, {
    key: "clearTimeout",
    value: (function(IA) {
      function BA() {
        return IA.apply(this, arguments);
      }
      return BA.toString = function() {
        return IA.toString();
      }, BA;
    })(function() {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function(IA) {
        IA && clearTimeout(IA);
      });
    })
  }, {
    key: "getSharedProps",
    value: function() {
      var BA = this.props, QA = BA.kind, EA = BA.notificationType, iA = BA.closeable, oA = this.state, cA = oA.isRendered, tA = oA.isVisible;
      return {
        $kind: QA,
        $type: EA,
        $closeable: iA,
        $isRendered: cA,
        $isVisible: tA
      };
    }
  }, {
    key: "render",
    value: function() {
      var BA = this, QA = this.props, EA = QA.children, iA = QA.closeable, oA = this.state.isRendered, cA = this.props.overrides, tA = cA.Body, eA = cA.CloseIcon, aA = cA.InnerContainer, GA = getOverrides(tA, Body$3), lA = _slicedToArray$5(GA, 2), nA = lA[0], DA = lA[1], hA = getOverrides(aA, InnerContainer), wA = _slicedToArray$5(hA, 2), sA = wA[0], NA = wA[1], rA = getOverrides(eA, CloseIconSvg), yA = _slicedToArray$5(rA, 2), bA = yA[0], RA = yA[1], FA = mergeOverrides({
        Svg: {
          component: bA
        }
      }, {
        Svg: eA
      }), dA = this.getSharedProps();
      return oA ? /* @__PURE__ */ React.createElement(LocaleContext.Consumer, null, function(kA) {
        return /* @__PURE__ */ React.createElement(nA, _extends$8({
          role: "alert",
          "data-baseweb": BA.props["data-baseweb"] || "toast"
        }, dA, DA, {
          // the properties below have to go after overrides
          onBlur: BA.onBlur,
          onFocus: BA.onFocus,
          onMouseEnter: BA.onMouseEnter,
          onMouseLeave: BA.onMouseLeave
        }), /* @__PURE__ */ React.createElement(sA, _extends$8({}, dA, NA), typeof EA == "function" ? EA({
          dismiss: BA.dismiss
        }) : EA), iA ? /* @__PURE__ */ React.createElement(DeleteIcon, _extends$8({
          ref: BA.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: BA.state.isFocusVisible,
          onClick: BA.dismiss,
          onKeyPress: function(YA) {
            YA.key === "Enter" && BA.dismiss();
          },
          title: kA.toast.close
        }, dA, RA, {
          onFocus: forkFocus(RA, BA.handleFocus),
          onBlur: forkBlur(RA, BA.handleBlur),
          overrides: FA
        })) : null);
      }) : null;
    }
  }]), AA;
})(React.Component);
_defineProperty$e(Toast$1, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  closeable: !0,
  kind: KIND.info,
  notificationType: TYPE.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function CA() {
  },
  onBlur: function CA() {
  },
  onFocus: function CA() {
  },
  onMouseEnter: function CA() {
  },
  onMouseLeave: function CA() {
  },
  overrides: {}
});
function _typeof$7(CA) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$7(CA);
}
var _excluded$8 = ["onClose", "children", "key"];
function _slicedToArray$4(CA, gA) {
  return _arrayWithHoles$3(CA) || _iterableToArrayLimit$3(CA, gA) || _unsupportedIterableToArray$3(CA, gA) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$3(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$3(CA) {
  if (Array.isArray(CA)) return CA;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$7.apply(this, arguments);
}
function _objectWithoutProperties$6(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$5(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$5(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function _toConsumableArray$1(CA) {
  return _arrayWithoutHoles$1(CA) || _iterableToArray$1(CA) || _unsupportedIterableToArray$3(CA) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$3(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$3(CA, gA);
  }
}
function _iterableToArray$1(CA) {
  if (typeof Symbol < "u" && CA[Symbol.iterator] != null || CA["@@iterator"] != null) return Array.from(CA);
}
function _arrayWithoutHoles$1(CA) {
  if (Array.isArray(CA)) return _arrayLikeToArray$3(CA);
}
function _arrayLikeToArray$3(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function ownKeys$d(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$b(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$d(Object(AA), !0).forEach(function(IA) {
      _defineProperty$d(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$d(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _classCallCheck$6(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$6(CA, gA, AA) {
  return gA && _defineProperties$6(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$6(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$6(CA, gA);
}
function _setPrototypeOf$6(CA, gA) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$6(CA, gA);
}
function _createSuper$6(CA) {
  var gA = _isNativeReflectConstruct$6();
  return function() {
    var IA = _getPrototypeOf$6(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$6(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$6(this, BA);
  };
}
function _possibleConstructorReturn$6(CA, gA) {
  if (gA && (_typeof$7(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(CA);
}
function _assertThisInitialized$6(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$6(CA) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$6(CA);
}
function _defineProperty$d(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var toasterRef, ToasterContainer = /* @__PURE__ */ (function(CA) {
  _inherits$6(AA, CA);
  var gA = _createSuper$6(AA);
  function AA(IA) {
    var BA;
    return _classCallCheck$6(this, AA), BA = gA.call(this, IA), _defineProperty$d(_assertThisInitialized$6(BA), "state", {
      isMounted: !1,
      toasts: []
    }), _defineProperty$d(_assertThisInitialized$6(BA), "dismissHandlers", {}), _defineProperty$d(_assertThisInitialized$6(BA), "toastId", 0), _defineProperty$d(_assertThisInitialized$6(BA), "getToastProps", function(QA) {
      var EA = BA.props, iA = EA.autoFocus, oA = EA.autoHideDuration, cA = EA.closeable, tA = QA.key || "toast-".concat(BA.toastId++);
      return _objectSpread$b(_objectSpread$b({
        autoFocus: iA,
        autoHideDuration: oA,
        closeable: cA
      }, QA), {}, {
        key: tA
      });
    }), _defineProperty$d(_assertThisInitialized$6(BA), "show", function() {
      var QA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (BA.state.toasts.map(function(iA) {
        return iA.key;
      }).includes(QA.key))
        return BA.update(QA.key, QA), QA.key;
      var EA = BA.getToastProps(QA);
      return BA.setState(function(iA) {
        var oA = iA.toasts;
        return {
          toasts: [].concat(_toConsumableArray$1(oA), [EA])
        };
      }), EA.key;
    }), _defineProperty$d(_assertThisInitialized$6(BA), "update", function(QA, EA) {
      BA.setState(function(iA) {
        var oA = iA.toasts, cA = oA.map(function(tA) {
          if (tA.key === QA) {
            var eA = _objectSpread$b(_objectSpread$b(_objectSpread$b({}, tA), BA.getToastProps(_objectSpread$b({
              autoHideDuration: tA.autoHideDuration
            }, EA))), {}, {
              key: QA
            }, BA.props.resetAutoHideTimerOnUpdate ? {
              __updated: (+tA.__updated || 0) + 1
            } : {});
            return eA;
          }
          return tA;
        });
        return {
          toasts: cA
        };
      });
    }), _defineProperty$d(_assertThisInitialized$6(BA), "dismiss", function(QA) {
      BA.dismissHandlers[QA] && BA.dismissHandlers[QA]();
    }), _defineProperty$d(_assertThisInitialized$6(BA), "clearAll", function() {
      Object.keys(BA.dismissHandlers).forEach(function(QA) {
        BA.dismissHandlers[QA]();
      });
    }), _defineProperty$d(_assertThisInitialized$6(BA), "clear", function(QA) {
      QA === void 0 ? BA.clearAll() : BA.dismiss(QA);
    }), _defineProperty$d(_assertThisInitialized$6(BA), "internalOnClose", function(QA) {
      delete BA.dismissHandlers[QA], BA.setState(function(EA) {
        var iA = EA.toasts;
        return {
          toasts: iA.filter(function(oA) {
            return oA.key !== QA;
          })
        };
      });
    }), _defineProperty$d(_assertThisInitialized$6(BA), "getOnCloseHandler", function(QA, EA) {
      return function() {
        BA.internalOnClose(QA), typeof EA == "function" && EA();
      };
    }), _defineProperty$d(_assertThisInitialized$6(BA), "renderToast", function(QA) {
      var EA = QA.onClose, iA = QA.children, oA = QA.key, cA = _objectWithoutProperties$6(QA, _excluded$8), tA = BA.props.overrides, eA = tA.ToastBody, aA = tA.ToastCloseIcon, GA = tA.ToastInnerContainer, lA = mergeOverrides({
        Body: Body$3,
        CloseIcon: CloseIconSvg,
        InnerContainer
      }, {
        Body: eA || {},
        CloseIcon: aA || {},
        InnerContainer: GA || {}
      }), nA = mergeOverrides(lA, QA.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$7({}, cA, {
        overrides: nA,
        key: oA,
        onClose: BA.getOnCloseHandler(oA, EA)
      }), function(DA) {
        var hA = DA.dismiss;
        return BA.dismissHandlers[oA] = hA, iA;
      });
    }), _defineProperty$d(_assertThisInitialized$6(BA), "getSharedProps", function() {
      var QA = BA.props.placement;
      return {
        $placement: QA
      };
    }), toasterRef = _assertThisInitialized$6(BA), BA;
  }
  return _createClass$6(AA, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "render",
    value: function() {
      for (var BA = this.getSharedProps(), QA = this.props.overrides.Root, EA = getOverrides(QA, Root$1), iA = _slicedToArray$4(EA, 2), oA = iA[0], cA = iA[1], tA = this.state.toasts.length, eA = [], aA = tA - 1; aA >= 0; aA--)
        eA.push(this.renderToast(this.state.toasts[aA]));
      var GA = /* @__PURE__ */ React.createElement(oA, _extends$7({
        "data-baseweb": "toaster"
      }, BA, cA), eA);
      return this.state.isMounted ? /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.usePortal && typeof document < "u" && document.body ? /* @__PURE__ */ ReactDOM.createPortal(GA, document.body) : GA, this.props.children) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.props.children);
    }
  }]), AA;
})(React.Component);
_defineProperty$d(ToasterContainer, "defaultProps", {
  autoFocus: !1,
  autoHideDuration: 0,
  children: null,
  closeable: !0,
  overrides: {},
  placement: PLACEMENT$1.top,
  resetAutoHideTimerOnUpdate: !0,
  usePortal: !0
});
var toaster = {
  getRef: function CA() {
    return toasterRef;
  },
  show: function CA(gA) {
    var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, IA = this.getRef();
    if (IA)
      return IA.show(_objectSpread$b(_objectSpread$b({}, AA), {}, {
        children: gA
      }));
    if (process.env.NODE_ENV !== "production")
      throw new Error("Please make sure to add the ToasterContainer to your application, and it is mounted, before adding toasts! You can find more information here: https://baseweb.design/components/toast");
  },
  info: function CA(gA) {
    var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(gA, _objectSpread$b(_objectSpread$b({}, AA), {}, {
      kind: KIND.info
    }));
  },
  positive: function CA(gA) {
    var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(gA, _objectSpread$b(_objectSpread$b({}, AA), {}, {
      kind: KIND.positive
    }));
  },
  warning: function CA(gA) {
    var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(gA, _objectSpread$b(_objectSpread$b({}, AA), {}, {
      kind: KIND.warning
    }));
  },
  negative: function CA(gA) {
    var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.show(gA, _objectSpread$b(_objectSpread$b({}, AA), {}, {
      kind: KIND.negative
    }));
  },
  update: function CA(gA, AA) {
    var IA = this.getRef();
    IA ? IA.update(gA, AA) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  },
  clear: function CA(gA) {
    var AA = this.getRef();
    AA ? AA.clear(gA) : process.env.NODE_ENV !== "production" && console.error("No ToasterContainer is mounted yet.");
  }
};
function _typeof$6(CA) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$6(CA);
}
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$6.apply(this, arguments);
}
function _classCallCheck$5(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$5(CA, gA, AA) {
  return gA && _defineProperties$5(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$5(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$5(CA, gA);
}
function _setPrototypeOf$5(CA, gA) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$5(CA, gA);
}
function _createSuper$5(CA) {
  var gA = _isNativeReflectConstruct$5();
  return function() {
    var IA = _getPrototypeOf$5(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$5(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$5(this, BA);
  };
}
function _possibleConstructorReturn$5(CA, gA) {
  if (gA && (_typeof$6(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(CA);
}
function _assertThisInitialized$5(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$5(CA) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$5(CA);
}
function _defineProperty$c(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Notification = /* @__PURE__ */ (function(CA) {
  _inherits$5(AA, CA);
  var gA = _createSuper$5(AA);
  function AA() {
    return _classCallCheck$5(this, AA), gA.apply(this, arguments);
  }
  return _createClass$5(AA, [{
    key: "render",
    value: function() {
      var BA = mergeOverrides({
        Body: {
          style: function(EA) {
            var iA = EA.$theme;
            return {
              marginTop: iA.sizing.scale600,
              marginRight: iA.sizing.scale600,
              marginBottom: iA.sizing.scale600,
              marginLeft: iA.sizing.scale600
            };
          }
        }
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Toast$1, _extends$6({
        "data-baseweb": "notification"
      }, this.props, {
        overrides: BA
      }));
    }
  }]), AA;
})(React.Component);
_defineProperty$c(Notification, "defaultProps", {
  notificationType: TYPE.inline,
  closeable: !1
});
const StyledAlertContent$1 = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e4pi9i0"
} : {
  target: "e1e4pi9i0",
  label: "StyledAlertContent"
})(({
  theme: CA
}) => ({
  pre: {
    backgroundColor: CA.colors.transparent,
    paddingTop: CA.spacing.lg,
    paddingBottom: CA.spacing.lg,
    paddingRight: CA.spacing.lg,
    paddingLeft: CA.spacing.lg,
    border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
    "pre, code": {
      backgroundColor: CA.colors.transparent,
      color: "inherit"
    }
  },
  code: {
    backgroundColor: CA.colors.transparent,
    padding: CA.spacing.none
  },
  "pre, code": {
    color: "inherit"
  },
  a: {
    color: "inherit",
    textDecoration: "underline"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var Kind = /* @__PURE__ */ ((CA) => (CA.ERROR = "error", CA.INFO = "info", CA.SUCCESS = "success", CA.WARNING = "warning", CA))(Kind || {});
function getNotificationKind(CA) {
  switch (CA) {
    case "error":
      return KIND.negative;
    case "info":
      return KIND.info;
    case "success":
      return KIND.positive;
    case "warning":
      return KIND.warning;
    default:
      throw new Error(`Unexpected alert type: ${CA}`);
  }
}
function AlertContainer({
  kind: CA,
  width: gA,
  children: AA
}) {
  const IA = useEmotionTheme(), BA = CA.charAt(0).toUpperCase() + CA.slice(1);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Notification, { kind: getNotificationKind(CA), overrides: {
    Body: {
      style: {
        fontWeight: IA.fontWeights.normal,
        marginTop: IA.spacing.none,
        marginBottom: IA.spacing.none,
        marginLeft: IA.spacing.none,
        marginRight: IA.spacing.none,
        width: gA ? gA.toString() : void 0,
        border: 0,
        borderTopRightRadius: IA.radii.default,
        borderBottomRightRadius: IA.radii.default,
        borderTopLeftRadius: IA.radii.default,
        borderBottomLeftRadius: IA.radii.default,
        paddingTop: IA.spacing.lg,
        paddingBottom: IA.spacing.lg,
        paddingRight: IA.spacing.lg,
        paddingLeft: IA.spacing.lg
      },
      props: {
        "data-testid": "stAlertContainer",
        className: "stAlertContainer"
      }
    },
    InnerContainer: {
      style: {
        width: "100%",
        lineHeight: IA.lineHeights.small
      }
    }
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertContent$1, { "data-testid": `stAlertContent${BA}`, children: AA }) });
}
const StyledStackTrace = /* @__PURE__ */ createStyled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a01"
} : {
  target: "e1ixn3a01",
  label: "StyledStackTrace"
})(({
  theme: CA
}) => ({
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  color: "inherit",
  fontSize: CA.fontSizes.codeFontSize,
  fontFamily: CA.genericFonts.codeFont,
  fontWeight: CA.fontWeights.code,
  backgroundColor: CA.colors.transparent,
  overflowX: "auto",
  margin: 0,
  borderRadius: CA.radii.default,
  padding: CA.spacing.lg,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorName = /* @__PURE__ */ createStyled("strong", process.env.NODE_ENV === "production" ? {
  target: "e1ixn3a00"
} : {
  target: "e1ixn3a00",
  label: "StyledErrorName"
})(({
  theme: CA
}) => ({
  fontWeight: CA.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ErrorElement(CA) {
  const {
    name: gA,
    message: AA,
    stack: IA,
    width: BA
  } = CA, QA = IA ? IA.split(`
`) : [];
  QA.shift();
  const EA = QA.map((iA) => iA.trim()).join(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AlertContainer, { kind: Kind.ERROR, width: BA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledErrorName, { children: [
      gA,
      ": "
    ] }),
    AA,
    IA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { "data-testid": "stErrorElementStack", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: EA }) }) : null
  ] });
}
const LOG$d = loglevelExports.getLogger("ErrorBoundary"), kg = class kg extends PureComponent {
  constructor() {
    super(...arguments), this.state = {
      error: null
    }, this.componentDidCatch = (gA) => {
      LOG$d.error(`${gA.name}: ${gA.message}
${gA.stack}`);
    };
  }
  render() {
    const {
      error: gA
    } = this.state;
    return gA ? gA.name === "ChunkLoadError" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: "Network issue", message: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Cannot load Streamlit frontend code. This can happen when you update Streamlit while a Streamlit app is running.",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "To fix this, simply reload this app by pressing",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "F5" }),
      ",",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Ctrl+R" }),
      ", or",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { children: "Cmd+R" }),
      ".",
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      "If the error persists, try force-clearing your browser's cache as described",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://en.wikipedia.org/wiki/Wikipedia:Bypass_your_cache#Cache_clearing_and_disabling", rel: "noopener noreferrer", target: "_blank", children: "here" })
    ] }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorElement, { width: this.props.width, name: gA.name, message: gA.message, stack: gA.stack }) : this.props.children;
  }
};
kg.getDerivedStateFromError = (gA) => ({
  error: gA
});
let ErrorBoundary = kg;
var PLACEMENT = {
  auto: "auto",
  topLeft: "topLeft",
  top: "top",
  topRight: "topRight",
  rightTop: "rightTop",
  right: "right",
  rightBottom: "rightBottom",
  bottomRight: "bottomRight",
  bottom: "bottom",
  bottomLeft: "bottomLeft",
  leftBottom: "leftBottom",
  left: "left",
  leftTop: "leftTop"
}, TRIGGER_TYPE = {
  click: "click",
  hover: "hover"
}, STATE_CHANGE_TYPE = {
  open: "open",
  close: "close"
}, ACCESSIBILITY_TYPE = {
  none: "none",
  menu: "menu",
  tooltip: "tooltip"
}, POPOVER_MARGIN = 8, ARROW_SIZE = 6, ANIMATE_OUT_TIME = 0, ANIMATE_IN_TIME = 20, ARROW_WIDTH = Math.ceil(Math.sqrt(Math.pow(ARROW_SIZE * 2, 2) / 2));
function _typeof$5(CA) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$5(CA);
}
function ownKeys$c(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$a(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$c(Object(AA), !0).forEach(function(IA) {
      _defineProperty$b(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$c(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _classCallCheck$4(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$4(CA, gA, AA) {
  return gA && _defineProperties$4(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$4(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$4(CA, gA);
}
function _setPrototypeOf$4(CA, gA) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$4(CA, gA);
}
function _createSuper$4(CA) {
  var gA = _isNativeReflectConstruct$4();
  return function() {
    var IA = _getPrototypeOf$4(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$4(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$4(this, BA);
  };
}
function _possibleConstructorReturn$4(CA, gA) {
  if (gA && (_typeof$5(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(CA);
}
function _assertThisInitialized$4(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$4(CA) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$4(CA);
}
function _defineProperty$b(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var defaultStateReducer = function CA(gA, AA) {
  return AA;
}, StatefulContainer$1 = /* @__PURE__ */ (function(CA) {
  _inherits$4(AA, CA);
  var gA = _createSuper$4(AA);
  function AA() {
    var IA;
    _classCallCheck$4(this, AA);
    for (var BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = gA.call.apply(gA, [this].concat(QA)), _defineProperty$b(_assertThisInitialized$4(IA), "state", _objectSpread$a({
      isOpen: !1
    }, IA.props.initialState)), _defineProperty$b(_assertThisInitialized$4(IA), "onBlur", function(iA) {
      IA.props.onBlur && IA.props.onBlur(iA), !(IA.props.focusLock || IA.props.autoFocus) && IA.close();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onClick", function(iA) {
      IA.props.onClick && IA.props.onClick(iA), IA.state.isOpen ? IA.close() : IA.open();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onClickOutside", function() {
      IA.close();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onEsc", function() {
      IA.close();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onFocus", function(iA) {
      IA.props.onFocus && IA.props.onFocus(iA), isFocusVisible(iA) && IA.open();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onMouseEnter", function(iA) {
      IA.props.onMouseEnter && IA.props.onMouseEnter(iA), IA.open();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onMouseLeave", function(iA) {
      IA.props.onMouseLeave && IA.props.onMouseLeave(iA), IA.close();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "onContentClose", function() {
      IA.close();
    }), _defineProperty$b(_assertThisInitialized$4(IA), "renderContent", function() {
      var iA = IA.props.content;
      return typeof iA == "function" ? iA({
        close: IA.onContentClose
      }) : iA;
    }), IA;
  }
  return _createClass$4(AA, [{
    key: "open",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE.open, {
        isOpen: !0
      }), this.props.onOpen && this.props.onOpen();
    }
  }, {
    key: "close",
    value: function() {
      this.internalSetState(STATE_CHANGE_TYPE.close, {
        isOpen: !1
      }), this.props.onClose && this.props.onClose();
    }
  }, {
    key: "internalSetState",
    value: function(BA, QA) {
      var EA = this.props.stateReducer;
      if (typeof EA != "function") {
        this.setState(QA);
        return;
      }
      this.setState(function(iA) {
        return EA(BA, QA, iA);
      });
    }
    /**
     * If user passed a content render prop, we want to give them a
     * callback to close the Popover. This is useful in any case where
     * a dev wants to manually close the popover based on some action.
     *
     * One simple example is a Popover with a "Dismiss" button in it:
     * <StatefulPopover content={({close}) => <button onClick={close}>Dismiss</button>}>
     *  Click me
     * </StatefulPopover>
     */
  }, {
    key: "render",
    value: function() {
      var BA = this.props, QA = BA.accessibilityType, EA = BA.autoFocus, iA = BA.animateOutTime, oA = BA.dismissOnClickOutside, cA = BA.dismissOnEsc, tA = BA.focusLock, eA = BA.ignoreBoundary, aA = BA.mountNode, GA = BA.onBlur, lA = BA.onClick, nA = BA.onFocus, DA = BA.onMouseEnter, hA = BA.onMouseLeave, wA = BA.onMouseEnterDelay, sA = BA.onMouseLeaveDelay, NA = BA.overrides, rA = BA.placement, yA = BA.popperOptions, bA = BA.renderAll, RA = BA.returnFocus, FA = BA.showArrow, dA = BA.triggerType, kA = BA.popoverMargin, pA = BA.focusOptions, YA = {
        accessibilityType: QA,
        animateOutTime: iA,
        autoFocus: EA,
        content: this.renderContent,
        focusLock: tA,
        ignoreBoundary: eA,
        isOpen: this.state.isOpen,
        mountNode: aA,
        onBlur: GA,
        onClick: lA,
        onFocus: nA,
        onMouseEnter: DA,
        onMouseLeave: hA,
        onMouseEnterDelay: wA,
        onMouseLeaveDelay: sA,
        overrides: NA,
        placement: rA,
        popperOptions: yA,
        renderAll: bA,
        returnFocus: RA,
        showArrow: FA,
        triggerType: dA,
        popoverMargin: kA,
        focusOptions: pA
      };
      return oA && (YA.onClickOutside = this.onClickOutside), cA && (YA.onEsc = this.onEsc), dA === TRIGGER_TYPE.hover ? (YA.onBlur = this.onBlur, YA.onFocus = this.onFocus, YA.onMouseEnter = this.onMouseEnter, YA.onMouseLeave = this.onMouseLeave) : YA.onClick = this.onClick, this.props.children(YA);
    }
  }]), AA;
})(React.Component);
_defineProperty$b(StatefulContainer$1, "defaultProps", {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  popperOptions: {},
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: defaultStateReducer,
  popoverMargin: POPOVER_MARGIN
});
function ownKeys$b(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$9(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$b(Object(AA), !0).forEach(function(IA) {
      _defineProperty$a(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$b(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$a(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _slicedToArray$3(CA, gA) {
  return _arrayWithHoles$2(CA) || _iterableToArrayLimit$2(CA, gA) || _unsupportedIterableToArray$2(CA, gA) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$2(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$2(CA, gA);
  }
}
function _arrayLikeToArray$2(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$2(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$2(CA) {
  if (Array.isArray(CA)) return CA;
}
var OPPOSITE_POSITIONS = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
function getOppositePosition(CA) {
  return OPPOSITE_POSITIONS[CA];
}
function isVerticalPosition(CA) {
  return CA === "top" || CA === "bottom";
}
function capitalize(CA) {
  return CA.charAt(0).toUpperCase() + CA.slice(1);
}
function fromPopperPlacement(CA) {
  var gA = CA.replace(/(top|bottom)-start$/, "$1Left").replace(/(top|bottom)-end$/, "$1Right").replace(/(left|right)-start$/, "$1Top").replace(/(left|right)-end$/, "$1Bottom");
  return PLACEMENT[gA] || null;
}
function splitPlacement(CA) {
  var gA = CA.match(/^([a-z]+)([A-Z][a-z]+)?/) || [];
  return gA.slice(1, 3).filter(Boolean).map(function(AA) {
    return AA.toLowerCase();
  });
}
function getPopoverMarginStyles(CA, gA, AA) {
  var IA = splitPlacement(gA), BA = _slicedToArray$3(IA, 1), QA = BA[0], EA = getOppositePosition(QA);
  if (!EA)
    return null;
  var iA = "margin".concat(capitalize(EA));
  return _defineProperty$a({}, iA, "".concat(CA + AA, "px"));
}
function getStartPosition(CA, gA, AA, IA) {
  CA = _objectSpread$9({}, CA);
  var BA = splitPlacement(gA), QA = _slicedToArray$3(BA, 1), EA = QA[0], iA = (AA > 0 ? AA : IA) * 2;
  return isVerticalPosition(EA) ? CA.top += EA === "top" ? iA : -iA : CA.left += EA === "left" ? iA : -iA, "translate3d(".concat(CA.left, "px, ").concat(CA.top, "px, 0)");
}
function getEndPosition(CA) {
  return "translate3d(".concat(CA.left, "px, ").concat(CA.top, "px, 0)");
}
function getArrowPositionStyles(CA, gA) {
  var AA, IA = splitPlacement(gA), BA = _slicedToArray$3(IA, 1), QA = BA[0], EA = getOppositePosition(QA);
  if (!EA)
    return null;
  var iA = isVerticalPosition(QA) ? "left" : "top";
  return AA = {}, _defineProperty$a(AA, iA, "".concat(CA[iA], "px")), _defineProperty$a(AA, EA, "-".concat(ARROW_SIZE - 2, "px")), AA;
}
function ownKeys$a(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$8(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$a(Object(AA), !0).forEach(function(IA) {
      _defineProperty$9(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$a(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$9(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function getBodyStyles(CA) {
  var gA = CA.$animationDuration, AA = CA.$isOpen, IA = CA.$isAnimating, BA = CA.$placement, QA = CA.$popoverOffset, EA = CA.$showArrow, iA = CA.$theme, oA = CA.$popoverMargin, cA = CA.$isHoverTrigger;
  return _objectSpread$8(_objectSpread$8({
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: iA.colors.backgroundTertiary,
    borderTopLeftRadius: iA.borders.popoverBorderRadius,
    borderTopRightRadius: iA.borders.popoverBorderRadius,
    borderBottomRightRadius: iA.borders.popoverBorderRadius,
    borderBottomLeftRadius: iA.borders.popoverBorderRadius,
    boxShadow: iA.lighting.shadow600,
    transitionProperty: "opacity,transform",
    transitionDuration: IA ? AA ? "0.1s" : "".concat(gA, "ms") : "0s",
    transitionTimingFunction: AA ? iA.animation.easeOutCurve : iA.animation.easeInCurve,
    opacity: IA && AA ? 1 : 0,
    transform: IA && AA ? getEndPosition(QA) : getStartPosition(QA, BA, EA ? ARROW_SIZE : 0, oA)
  }, getPopoverMarginStyles(EA ? ARROW_SIZE : 0, BA, oA)), cA ? {
    animationDuration: ".1s",
    animationName: {
      "0%": {
        pointerEvents: "none"
      },
      "99%": {
        pointerEvents: "none"
      },
      "100%": {
        pointerEvents: "auto"
      }
    }
  } : {});
}
var Body$2 = styled("div", getBodyStyles);
Body$2.displayName = "Body";
Body$2.displayName = "Body";
function getArrowStyles(CA) {
  var gA = CA.$arrowOffset, AA = CA.$placement, IA = CA.$theme;
  return _objectSpread$8({
    backgroundColor: IA.colors.backgroundTertiary,
    boxShadow: IA.lighting.shadow600,
    width: "".concat(ARROW_WIDTH, "px"),
    height: "".concat(ARROW_WIDTH, "px"),
    transform: "rotate(45deg)",
    position: "absolute"
  }, getArrowPositionStyles(gA, AA));
}
var Arrow$1 = styled("div", getArrowStyles);
Arrow$1.displayName = "Arrow";
Arrow$1.displayName = "Arrow";
function getInnerStyles(CA) {
  var gA = CA.$theme;
  return {
    backgroundColor: gA.colors.backgroundTertiary,
    borderTopLeftRadius: gA.borders.popoverBorderRadius,
    borderTopRightRadius: gA.borders.popoverBorderRadius,
    borderBottomRightRadius: gA.borders.popoverBorderRadius,
    borderBottomLeftRadius: gA.borders.popoverBorderRadius,
    color: gA.colors.contentPrimary,
    position: "relative"
  };
}
var Inner$1 = styled("div", getInnerStyles);
Inner$1.displayName = "Inner";
Inner$1.displayName = "Inner";
var Padding = styled("div", {
  paddingLeft: "12px",
  paddingTop: "12px",
  paddingRight: "12px",
  paddingBottom: "12px"
});
Padding.displayName = "Padding";
Padding.displayName = "Padding";
var Hidden = styled("div", {
  display: "none"
});
Hidden.displayName = "Hidden";
Hidden.displayName = "Hidden";
var baseDefaultProps$1 = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  focusLock: !1,
  autoFocus: !0,
  returnFocus: !0,
  // Remove the `ignoreBoundary` prop in the next major version
  // and have it replaced with the TetherBehavior props overrides
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  renderAll: !1
};
function ownKeys$9(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$7(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$9(Object(AA), !0).forEach(function(IA) {
      _defineProperty$8(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$9(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$5.apply(this, arguments);
}
function _typeof$4(CA) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$4(CA);
}
function _classCallCheck$3(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$3(CA, gA, AA) {
  return gA && _defineProperties$3(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$3(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$3(CA, gA);
}
function _setPrototypeOf$3(CA, gA) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$3(CA, gA);
}
function _createSuper$3(CA) {
  var gA = _isNativeReflectConstruct$3();
  return function() {
    var IA = _getPrototypeOf$3(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$3(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$3(this, BA);
  };
}
function _possibleConstructorReturn$3(CA, gA) {
  if (gA && (_typeof$4(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(CA);
}
function _assertThisInitialized$3(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$3(CA) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$3(CA);
}
function _defineProperty$8(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var PopoverInner = /* @__PURE__ */ (function(CA) {
  _inherits$3(AA, CA);
  var gA = _createSuper$3(AA);
  function AA() {
    var IA;
    _classCallCheck$3(this, AA);
    for (var BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = gA.call.apply(gA, [this].concat(QA)), _defineProperty$8(_assertThisInitialized$3(IA), "animateInTimer", void 0), _defineProperty$8(_assertThisInitialized$3(IA), "animateOutTimer", void 0), _defineProperty$8(_assertThisInitialized$3(IA), "animateOutCompleteTimer", void 0), _defineProperty$8(_assertThisInitialized$3(IA), "onMouseEnterTimer", void 0), _defineProperty$8(_assertThisInitialized$3(IA), "onMouseLeaveTimer", void 0), _defineProperty$8(_assertThisInitialized$3(IA), "anchorRef", /* @__PURE__ */ React.createRef()), _defineProperty$8(_assertThisInitialized$3(IA), "popperRef", /* @__PURE__ */ React.createRef()), _defineProperty$8(_assertThisInitialized$3(IA), "arrowRef", /* @__PURE__ */ React.createRef()), _defineProperty$8(_assertThisInitialized$3(IA), "state", IA.getDefaultState(IA.props)), _defineProperty$8(_assertThisInitialized$3(IA), "animateIn", function() {
      IA.props.isOpen && IA.setState({
        isAnimating: !0
      });
    }), _defineProperty$8(_assertThisInitialized$3(IA), "animateOut", function() {
      IA.props.isOpen || (IA.setState({
        isAnimating: !0
      }), IA.animateOutCompleteTimer = setTimeout(function() {
        IA.setState({
          isAnimating: !1,
          // Reset to ideal placement specified in props
          placement: IA.props.placement
        });
      }, IA.props.animateOutTime || ANIMATE_OUT_TIME));
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onAnchorClick", function(iA) {
      IA.props.onClick && IA.props.onClick(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onAnchorMouseEnter", function(iA) {
      IA.onMouseLeaveTimer && clearTimeout(IA.onMouseLeaveTimer), IA.triggerOnMouseEnterWithDelay(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onAnchorMouseLeave", function(iA) {
      IA.onMouseEnterTimer && clearTimeout(IA.onMouseEnterTimer), IA.triggerOnMouseLeaveWithDelay(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onPopoverMouseEnter", function() {
      IA.onMouseLeaveTimer && clearTimeout(IA.onMouseLeaveTimer);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onPopoverMouseLeave", function(iA) {
      IA.triggerOnMouseLeaveWithDelay(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onPopperUpdate", function(iA, oA) {
      var cA = fromPopperPlacement(oA.placement) || PLACEMENT.top;
      return IA.setState({
        arrowOffset: iA.arrow,
        popoverOffset: iA.popper,
        placement: cA
      }), IA.animateInTimer = setTimeout(IA.animateIn, ANIMATE_IN_TIME), oA;
    }), _defineProperty$8(_assertThisInitialized$3(IA), "triggerOnMouseLeave", function(iA) {
      IA.props.onMouseLeave && IA.props.onMouseLeave(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "triggerOnMouseEnter", function(iA) {
      IA.props.onMouseEnter && IA.props.onMouseEnter(iA);
    }), _defineProperty$8(_assertThisInitialized$3(IA), "onDocumentClick", function(iA) {
      var oA = iA.composedPath ? iA.composedPath()[0] : iA.target, cA = IA.popperRef.current, tA = IA.anchorRef.current;
      !cA || cA === oA || oA instanceof Node && cA.contains(oA) || !tA || tA === oA || oA instanceof Node && tA.contains(oA) || IA.props.onClickOutside && IA.props.onClickOutside(iA);
    }), IA;
  }
  return _createClass$3(AA, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        isMounted: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(BA, QA) {
      this.init(BA, QA), this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip && this.props.autoFocus && !this.state.autoFocusAfterPositioning && this.popperRef.current !== null && this.popperRef.current.getBoundingClientRect().top > 0 && this.setState({
        autoFocusAfterPositioning: !0
      }), process.env.NODE_ENV !== "production" && (this.anchorRef.current || console.warn(`[baseui][Popover] ref has not been passed to the Popper's anchor element.
              See how to pass the ref to an anchor element in the Popover example
              https://baseweb.design/components/popover/#anchor-ref-handling-example`));
    }
  }, {
    key: "init",
    value: function(BA, QA) {
      if (this.props.isOpen !== BA.isOpen || this.state.isMounted !== QA.isMounted || this.state.isLayerMounted !== QA.isLayerMounted) {
        if (this.props.isOpen && this.state.isLayerMounted) {
          this.clearTimers();
          return;
        }
        if (!this.props.isOpen && BA.isOpen) {
          this.animateOutTimer = setTimeout(this.animateOut, 20);
          return;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimers();
    }
  }, {
    key: "getDefaultState",
    value: function(BA) {
      return {
        isAnimating: !1,
        arrowOffset: {
          left: 0,
          top: 0
        },
        popoverOffset: {
          left: 0,
          top: 0
        },
        placement: BA.placement,
        isMounted: !1,
        isLayerMounted: !1,
        autoFocusAfterPositioning: !1
      };
    }
  }, {
    key: "clearTimers",
    value: function() {
      [this.animateInTimer, this.animateOutTimer, this.animateOutCompleteTimer, this.onMouseEnterTimer, this.onMouseLeaveTimer].forEach(function(BA) {
        BA && clearTimeout(BA);
      });
    }
  }, {
    key: "triggerOnMouseLeaveWithDelay",
    value: function(BA) {
      var QA = this, EA = this.props.onMouseLeaveDelay;
      if (EA) {
        this.onMouseLeaveTimer = setTimeout(function() {
          return QA.triggerOnMouseLeave(BA);
        }, EA);
        return;
      }
      this.triggerOnMouseLeave(BA);
    }
  }, {
    key: "triggerOnMouseEnterWithDelay",
    value: function(BA) {
      var QA = this, EA = this.props.onMouseEnterDelay;
      if (EA) {
        this.onMouseEnterTimer = setTimeout(function() {
          return QA.triggerOnMouseEnter(BA);
        }, EA);
        return;
      }
      this.triggerOnMouseEnter(BA);
    }
  }, {
    key: "isClickTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.click;
    }
  }, {
    key: "isHoverTrigger",
    value: function() {
      return this.props.triggerType === TRIGGER_TYPE.hover;
    }
  }, {
    key: "isAccessibilityTypeMenu",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.menu;
    }
  }, {
    key: "isAccessibilityTypeTooltip",
    value: function() {
      return this.props.accessibilityType === ACCESSIBILITY_TYPE.tooltip;
    }
  }, {
    key: "getAnchorIdAttr",
    value: function() {
      var BA = this.getPopoverIdAttr();
      return BA ? "".concat(BA, "__anchor") : null;
    }
  }, {
    key: "getPopoverIdAttr",
    value: function() {
      return this.props.id || null;
    }
  }, {
    key: "getAnchorProps",
    value: function() {
      var BA = this.props.isOpen, QA = {
        ref: this.anchorRef
      }, EA = this.getPopoverIdAttr();
      if (this.isAccessibilityTypeMenu()) {
        var iA = this.isClickTrigger() ? "aria-controls" : "aria-owns";
        QA[iA] = BA ? EA : null, QA["aria-haspopup"] = !0, QA["aria-expanded"] = !!BA;
      } else this.isAccessibilityTypeTooltip() && (QA.id = this.getAnchorIdAttr(), QA["aria-describedby"] = BA ? EA : null);
      return this.isHoverTrigger() ? (QA.onMouseEnter = this.onAnchorMouseEnter, QA.onMouseLeave = this.onAnchorMouseLeave, QA.onBlur = this.props.onBlur, QA.onFocus = this.props.onFocus) : QA.onClick = this.onAnchorClick, QA;
    }
  }, {
    key: "getPopoverBodyProps",
    value: function() {
      var BA = {}, QA = this.getPopoverIdAttr();
      return this.isAccessibilityTypeMenu() ? BA.id = QA : this.isAccessibilityTypeTooltip() && (BA.id = QA, BA.role = "tooltip"), this.isHoverTrigger() && (BA.onMouseEnter = this.onPopoverMouseEnter, BA.onMouseLeave = this.onPopoverMouseLeave), BA;
    }
  }, {
    key: "getSharedProps",
    value: function() {
      var BA = this.props, QA = BA.isOpen, EA = BA.showArrow, iA = BA.popoverMargin, oA = iA === void 0 ? POPOVER_MARGIN : iA, cA = this.state, tA = cA.isAnimating, eA = cA.arrowOffset, aA = cA.popoverOffset, GA = cA.placement;
      return {
        $showArrow: !!EA,
        $arrowOffset: eA,
        $popoverOffset: aA,
        $placement: GA,
        $isAnimating: tA,
        $animationDuration: this.props.animateOutTime || ANIMATE_OUT_TIME,
        $isOpen: QA,
        $popoverMargin: oA,
        $isHoverTrigger: this.isHoverTrigger()
      };
    }
  }, {
    key: "getAnchorFromChildren",
    value: function() {
      var BA = this.props.children, QA = React.Children.toArray(BA);
      return QA.length !== 1 && console.error("[baseui] Exactly 1 child must be passed to Popover/Tooltip, found ".concat(QA.length, " children")), QA[0];
    }
  }, {
    key: "renderAnchor",
    value: function() {
      var BA = this.getAnchorFromChildren();
      if (!BA)
        return null;
      var QA = /* @__PURE__ */ React.isValidElement(BA), EA = this.getAnchorProps();
      return _typeof$4(BA) === "object" && QA ? /* @__PURE__ */ React.cloneElement(BA, EA) : /* @__PURE__ */ React.createElement("span", _extends$5({
        key: "popover-anchor"
      }, EA), BA);
    }
  }, {
    key: "renderPopover",
    value: function(BA) {
      var QA = this.props, EA = QA.showArrow, iA = QA.overrides, oA = iA === void 0 ? {} : iA, cA = oA.Arrow, tA = oA.Body, eA = oA.Inner, aA = getOverride(cA) || Arrow$1, GA = getOverride(tA) || Body$2, lA = getOverride(eA) || Inner$1, nA = this.getSharedProps(), DA = this.getPopoverBodyProps();
      return /* @__PURE__ */ React.createElement(GA, _extends$5({
        key: "popover-body",
        ref: this.popperRef,
        "data-baseweb": this.props["data-baseweb"] || "popover"
      }, DA, nA, getOverrideProps(tA)), EA ? /* @__PURE__ */ React.createElement(aA, _extends$5({
        key: "popover-arrow",
        ref: this.arrowRef
      }, nA, getOverrideProps(cA))) : null, /* @__PURE__ */ React.createElement(lA, _extends$5({}, nA, getOverrideProps(eA)), BA));
    }
  }, {
    key: "renderContent",
    value: function() {
      var BA = this.props.content;
      return typeof BA == "function" ? BA() : BA;
    }
  }, {
    key: "render",
    value: function() {
      var BA = this, QA = this.state.isMounted && (this.props.isOpen || this.state.isAnimating), EA = [this.renderAnchor()], iA = QA || this.props.renderAll ? this.renderContent() : null, oA = {
        modifiers: {
          preventOverflow: {
            enabled: !this.props.ignoreBoundary,
            padding: 0
          }
        }
      };
      return iA && (QA ? EA.push(/* @__PURE__ */ React.createElement(Layer, {
        key: "new-layer",
        mountNode: this.props.mountNode,
        onEscape: this.props.onEsc,
        onDocumentClick: this.isHoverTrigger() ? void 0 : this.onDocumentClick,
        isHoverLayer: this.isHoverTrigger(),
        onMount: function() {
          return BA.setState({
            isLayerMounted: !0
          });
        },
        onUnmount: function() {
          return BA.setState({
            isLayerMounted: !1
          });
        }
      }, /* @__PURE__ */ React.createElement(Tether, {
        anchorRef: this.anchorRef.current,
        arrowRef: this.arrowRef.current,
        popperRef: this.popperRef.current,
        popperOptions: _objectSpread$7(_objectSpread$7({}, oA), this.props.popperOptions),
        onPopperUpdate: this.onPopperUpdate,
        placement: this.state.placement
      }, this.props.focusLock && this.props.accessibilityType !== ACCESSIBILITY_TYPE.tooltip ? /* @__PURE__ */ React.createElement(FocusLockCombination, {
        disabled: !this.props.focusLock,
        noFocusGuards: !1,
        returnFocus: !this.isHoverTrigger() && this.props.returnFocus,
        autoFocus: this.state.autoFocusAfterPositioning,
        crossFrame: !1,
        focusOptions: this.props.focusOptions
      }, this.renderPopover(iA)) : /* @__PURE__ */ React.createElement(MoveFocusInside, {
        disabled: !this.props.autoFocus || !this.state.autoFocusAfterPositioning
      }, this.renderPopover(iA))))) : EA.push(/* @__PURE__ */ React.createElement(Hidden, {
        key: "hidden-layer"
      }, iA))), EA;
    }
  }]), AA;
})(React.Component);
_defineProperty$8(PopoverInner, "defaultProps", baseDefaultProps$1);
var Popover$2 = function CA(gA) {
  var AA = gA.innerRef, IA = useUID();
  return /* @__PURE__ */ React.createElement(PopoverInner, _extends$5({
    id: gA.id || IA,
    ref: AA
  }, gA));
};
Popover$2.defaultProps = baseDefaultProps$1;
var _excluded$7 = ["children"];
function _objectWithoutProperties$5(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$4(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$4(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function StatefulPopover(CA) {
  var gA = CA.children, AA = _objectWithoutProperties$5(CA, _excluded$7);
  return /* @__PURE__ */ React.createElement(StatefulContainer$1, AA, function(IA) {
    return /* @__PURE__ */ React.createElement(Popover$2, IA, gA);
  });
}
StatefulPopover.defaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.menu,
  ignoreBoundary: !1,
  overrides: {},
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  placement: PLACEMENT.auto,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.click,
  dismissOnClickOutside: !0,
  dismissOnEsc: !0,
  stateReducer: function CA(gA, AA) {
    return AA;
  },
  popoverMargin: POPOVER_MARGIN
};
var baseDefaultProps = {
  accessibilityType: ACCESSIBILITY_TYPE.tooltip,
  focusLock: !1,
  autoFocus: !1,
  returnFocus: !1,
  onMouseEnterDelay: 200,
  onMouseLeaveDelay: 200,
  overrides: {},
  placement: PLACEMENT.auto,
  popoverMargin: 0,
  showArrow: !1,
  triggerType: TRIGGER_TYPE.hover,
  renderAll: !1
};
function _typeof$3(CA) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$3(CA);
}
function ownKeys$8(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$6(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$8(Object(AA), !0).forEach(function(IA) {
      _defineProperty$7(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$8(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _classCallCheck$2(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$2(CA, gA, AA) {
  return gA && _defineProperties$2(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$2(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$2(CA, gA);
}
function _setPrototypeOf$2(CA, gA) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$2(CA, gA);
}
function _createSuper$2(CA) {
  var gA = _isNativeReflectConstruct$2();
  return function() {
    var IA = _getPrototypeOf$2(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$2(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$2(this, BA);
  };
}
function _possibleConstructorReturn$2(CA, gA) {
  if (gA && (_typeof$3(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(CA);
}
function _assertThisInitialized$2(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$2(CA) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$2(CA);
}
function _defineProperty$7(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var StatefulContainer = /* @__PURE__ */ (function(CA) {
  _inherits$2(AA, CA);
  var gA = _createSuper$2(AA);
  function AA() {
    return _classCallCheck$2(this, AA), gA.apply(this, arguments);
  }
  return _createClass$2(AA, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React.createElement(StatefulContainer$1, this.props);
    }
  }]), AA;
})(React.Component);
_defineProperty$7(StatefulContainer, "defaultProps", _objectSpread$6({}, baseDefaultProps));
function ownKeys$7(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$5(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$7(Object(AA), !0).forEach(function(IA) {
      _defineProperty$6(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$7(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$6(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Body$1 = styled("div", function(CA) {
  return _objectSpread$5(_objectSpread$5({}, getBodyStyles(CA)), {}, {
    backgroundColor: CA.$theme.colors.tooltipBackground,
    borderTopLeftRadius: CA.$theme.borders.radius300,
    borderTopRightRadius: CA.$theme.borders.radius300,
    borderBottomRightRadius: CA.$theme.borders.radius300,
    borderBottomLeftRadius: CA.$theme.borders.radius300,
    boxShadow: CA.$theme.lighting.shadow400,
    color: CA.$theme.colors.tooltipText,
    // Reset transition property to opacity only, and static transform
    transitionProperty: "opacity",
    transform: getEndPosition(CA.$popoverOffset)
  });
});
Body$1.displayName = "Body";
Body$1.displayName = "Body";
var Inner = styled("div", function(CA) {
  return _objectSpread$5(_objectSpread$5(_objectSpread$5({}, getInnerStyles(CA)), {}, {
    backgroundColor: CA.$theme.colors.tooltipBackground,
    borderTopLeftRadius: CA.$theme.borders.radius300,
    borderTopRightRadius: CA.$theme.borders.radius300,
    borderBottomRightRadius: CA.$theme.borders.radius300,
    borderBottomLeftRadius: CA.$theme.borders.radius300,
    paddingTop: CA.$theme.sizing.scale300,
    paddingBottom: CA.$theme.sizing.scale300,
    paddingLeft: CA.$theme.sizing.scale600,
    paddingRight: CA.$theme.sizing.scale600
  }, CA.$theme.typography.font150), {}, {
    color: CA.$theme.colors.tooltipText
  });
});
Inner.displayName = "Inner";
Inner.displayName = "Inner";
var Arrow = styled("div", function(CA) {
  return _objectSpread$5(_objectSpread$5({}, getArrowStyles(CA)), {}, {
    backgroundColor: CA.$theme.colors.tooltipBackground
  });
});
Arrow.displayName = "Arrow";
Arrow.displayName = "Arrow";
function _typeof$2(CA) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$2(CA);
}
function ownKeys$6(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$4(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$6(Object(AA), !0).forEach(function(IA) {
      _defineProperty$5(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$6(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$4.apply(this, arguments);
}
function _classCallCheck$1(CA, gA) {
  if (!(CA instanceof gA))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, IA.key, IA);
  }
}
function _createClass$1(CA, gA, AA) {
  return gA && _defineProperties$1(CA.prototype, gA), Object.defineProperty(CA, "prototype", { writable: !1 }), CA;
}
function _inherits$1(CA, gA) {
  if (typeof gA != "function" && gA !== null)
    throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, { constructor: { value: CA, writable: !0, configurable: !0 } }), Object.defineProperty(CA, "prototype", { writable: !1 }), gA && _setPrototypeOf$1(CA, gA);
}
function _setPrototypeOf$1(CA, gA) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(IA, BA) {
    return IA.__proto__ = BA, IA;
  }, _setPrototypeOf$1(CA, gA);
}
function _createSuper$1(CA) {
  var gA = _isNativeReflectConstruct$1();
  return function() {
    var IA = _getPrototypeOf$1(CA), BA;
    if (gA) {
      var QA = _getPrototypeOf$1(this).constructor;
      BA = Reflect.construct(IA, arguments, QA);
    } else
      BA = IA.apply(this, arguments);
    return _possibleConstructorReturn$1(this, BA);
  };
}
function _possibleConstructorReturn$1(CA, gA) {
  if (gA && (_typeof$2(gA) === "object" || typeof gA == "function"))
    return gA;
  if (gA !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(CA);
}
function _assertThisInitialized$1(CA) {
  if (CA === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$1(CA) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(AA) {
    return AA.__proto__ || Object.getPrototypeOf(AA);
  }, _getPrototypeOf$1(CA);
}
function _defineProperty$5(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Tooltip$2 = /* @__PURE__ */ (function(CA) {
  _inherits$1(AA, CA);
  var gA = _createSuper$1(AA);
  function AA() {
    return _classCallCheck$1(this, AA), gA.apply(this, arguments);
  }
  return _createClass$1(AA, [{
    key: "render",
    value: function() {
      var BA = mergeOverrides({
        Arrow,
        Body: Body$1,
        Inner
      }, this.props.overrides);
      return /* @__PURE__ */ React.createElement(Popover$2, _extends$4({
        autoFocus: !1,
        "data-baseweb": "tooltip"
      }, this.props, {
        overrides: BA
      }));
    }
  }]), AA;
})(React.Component);
_defineProperty$5(Tooltip$2, "defaultProps", _objectSpread$4({}, baseDefaultProps));
var _excluded$6 = ["children"];
function _objectWithoutProperties$4(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$3(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$3(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function StatefulTooltip(CA) {
  var gA = CA.children, AA = _objectWithoutProperties$4(CA, _excluded$6);
  return /* @__PURE__ */ React.createElement(StatefulContainer, AA, function(IA) {
    return /* @__PURE__ */ React.createElement(Tooltip$2, IA, gA);
  });
}
StatefulTooltip.defaultProps = StatefulContainer.defaultProps;
function _EMOTION_STRINGIFIED_CSS_ERROR__$f() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo22"
} : {
  target: "e1gc5fo22",
  label: "StyledWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%"
} : {
  name: "87mhkc",
  styles: "display:table;table-layout:fixed;width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledEllipsizedDiv = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo21"
} : {
  target: "e1gc5fo21",
  label: "StyledEllipsizedDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell"
} : {
  name: "sy3zga",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:table-cell/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
}), StyledTooltipContentWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gc5fo20"
} : {
  target: "e1gc5fo20",
  label: "StyledTooltipContentWrapper"
})(({
  theme: CA
}) => ({
  boxSizing: "border-box",
  fontSize: `${CA.fontSizes.sm}`,
  maxWidth: `calc(${CA.sizes.contentMaxWidth} - 2 * ${CA.spacing.threeXL})`,
  maxHeight: CA.sizes.maxTooltipHeight,
  overflow: "auto",
  padding: `${CA.spacing.xs} ${CA.spacing.md}`,
  [`@media (max-width: ${CA.breakpoints.sm})`]: {
    maxWidth: `calc(100% - ${CA.spacing.threeXL})`
  },
  img: {
    maxWidth: "100%"
  },
  "*": {
    fontSize: CA.fontSizes.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function useTooltipMeasurementSideEffect(CA, gA) {
  const {
    innerWidth: AA
  } = useWindowDimensionsContext();
  useEffect(() => {
    const IA = CA?.parentElement;
    if (!IA)
      return;
    (async () => {
      const QA = () => {
        const aA = IA.getBoundingClientRect();
        return aA.x !== 0 || aA.y !== 0 ? aA : null;
      };
      let EA = null, iA = 0;
      const oA = 5;
      for (; !EA && iA < oA; )
        EA = QA(), EA || (iA++, await new Promise((aA) => requestAnimationFrame(aA)));
      EA || (EA = IA.getBoundingClientRect());
      const cA = EA.x, tA = cA + EA.width - AA, eA = IA.parentElement;
      if (tA > 0 && eA) {
        const aA = new DOMMatrix(
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          window.getComputedStyle(eA)?.transform
        );
        eA.style.transform = `translate3d(${aA.e - tA}px, ${aA.f}px, 0px)`;
      }
      cA < 0 && (IA.style.left = `${-cA}px`);
    })();
  }, [CA, gA, AA]);
}
var Placement = /* @__PURE__ */ ((CA) => (CA.AUTO = "auto", CA.TOP_LEFT = "topLeft", CA.TOP = "top", CA.TOP_RIGHT = "topRight", CA.RIGHT_TOP = "rightTop", CA.RIGHT = "right", CA.RIGHT_BOTTOM = "rightBottom", CA.BOTTOM_RIGHT = "bottomRight", CA.BOTTOM = "bottom", CA.BOTTOM_LEFT = "bottomLeft", CA.LEFT_BOTTOM = "leftBottom", CA.LEFT = "left", CA.LEFT_TOP = "leftTop", CA))(Placement || {});
const generateDefaultTooltipOverrides = (CA, gA) => {
  const {
    colors: AA,
    fontSizes: IA,
    radii: BA,
    fontWeights: QA
  } = CA;
  return {
    Body: {
      style: {
        // This is annoying, but a bunch of warnings get logged when the
        // shorthand version `borderRadius` is used here since the long
        // names are used by BaseWeb and mixing the two is apparently
        // bad :(
        borderTopLeftRadius: BA.default,
        borderTopRightRadius: BA.default,
        borderBottomLeftRadius: BA.default,
        borderBottomRightRadius: BA.default,
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        backgroundColor: "transparent"
      }
    },
    Inner: {
      style: {
        backgroundColor: hasLightBackgroundColor(CA) ? AA.bgColor : AA.secondaryBg,
        color: AA.bodyText,
        fontSize: IA.sm,
        fontWeight: QA.normal,
        // See the long comment about `borderRadius`. The same applies here
        // to `padding`.
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important"
      },
      // overrides prop replaces tooltip subcomponent overrides
      ...gA
    }
  };
};
function Tooltip({
  content: CA,
  placement: gA,
  children: AA,
  inline: IA,
  style: BA,
  onMouseEnterDelay: QA,
  overrides: EA,
  containerWidth: iA,
  error: oA
}) {
  const cA = useEmotionTheme(), [tA, eA] = useState(null), [aA, GA] = useState(!1), lA = useRef(null), nA = useCallback(() => {
    GA(!0);
  }, []), DA = useCallback(() => {
    GA(!1), lA.current = null;
  }, []);
  useEffect(() => () => {
    lA.current = null;
  }, []);
  const hA = useCallback((rA) => {
    if (rA.key !== "Escape" || !aA)
      return;
    const yA = rA.currentTarget, bA = yA.ownerDocument?.activeElement;
    bA instanceof HTMLElement && yA.contains(bA) && (lA.current?.(), rA.preventDefault(), rA.stopPropagation());
  }, [aA]);
  useTooltipMeasurementSideEffect(tA, aA);
  const wA = generateDefaultTooltipOverrides(cA, EA), sA = IA ? "span" : "div", NA = useCallback(({
    close: rA
  }) => (lA.current = rA, /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipContentWrapper, { className: oA ? "stTooltipErrorContent" : "stTooltipContent", "data-testid": oA ? "stTooltipErrorContent" : "stTooltipContent", ref: eA, children: CA })), [CA, oA, eA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StatefulTooltip, { onOpen: nA, onClose: DA, content: CA ? NA : null, placement: PLACEMENT[gA], accessibilityType: ACCESSIBILITY_TYPE.tooltip, showArrow: !1, popoverMargin: 10, onMouseEnterDelay: QA, overrides: wA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(sA, { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: IA ? "flex-end" : "",
    width: iA ? "100%" : "auto",
    ...BA
  }, onKeyDownCapture: hA, "data-testid": oA ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", className: oA ? "stTooltipErrorHoverTarget" : "stTooltipHoverTarget", children: AA }) });
}
const Tooltip$1 = memo(Tooltip), StyledTooltipTriggerButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "ewgb6653"
} : {
  target: "ewgb6653",
  label: "StyledTooltipTriggerButton"
})(({
  theme: CA
}) => ({
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  color: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 0,
  cursor: "help",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRing,
    borderRadius: CA.radii.default
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTooltipIconWrapper = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "ewgb6652"
} : {
  target: "ewgb6652",
  label: "StyledTooltipIconWrapper"
})(({
  isLatex: CA,
  theme: gA
}) => ({
  display: "flex",
  alignItems: "center",
  marginTop: CA ? gA.spacing.md : "0",
  // The tooltip hover target wraps the trigger for accessibility.
  // Only style TooltipIcon's default trigger glyph (HelpCircleIcon).
  // TooltipIcon is also used as a wrapper around arbitrary triggers (e.g. a
  // button with its own Icon). Those triggers should keep their own styling.
  "& .stTooltipHoverTarget svg.icon": {
    stroke: gA.colors.fadedText60,
    strokeWidth: gA.sizes.defaultStrokeWidth
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLabelHelpWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ewgb6651"
} : {
  target: "ewgb6651",
  label: "StyledLabelHelpWrapper"
})(({
  isLatex: CA
}) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  visibility: "visible",
  // For LaTeX, use fit-content to keep icon close, but constrain with maxWidth
  // so long formulas can scroll. Center using margin-inline: auto
  width: CA ? "fit-content" : "100%",
  ...CA ? {
    maxWidth: "100%",
    marginInline: "auto"
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvVG9vbHRpcEljb24vc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0RzQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvc2hhcmVkL1Rvb2x0aXBJY29uL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sdGlwVHJpZ2dlckJ1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4gKHtcbiAgYmFja2dyb3VuZDogXCJub25lXCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIHBhZGRpbmc6IDAsXG4gIG1hcmdpbjogMCxcbiAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIGxpbmVIZWlnaHQ6IDAsXG4gIGN1cnNvcjogXCJoZWxwXCIsXG5cbiAgXCImOmZvY3VzXCI6IHtcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgfSxcbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5mb2N1c1JpbmcsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICB9LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRUb29sdGlwSWNvbldyYXBwZXJQcm9wcyB7XG4gIGlzTGF0ZXg/OiBib29sZWFuXG59XG5cbmludGVyZmFjZSBTdHlsZWRMYWJlbEhlbHBXcmFwcGVyUHJvcHMge1xuICBpc0xhdGV4PzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9vbHRpcEljb25XcmFwcGVyID1cbiAgc3R5bGVkLnNwYW48U3R5bGVkVG9vbHRpcEljb25XcmFwcGVyUHJvcHM+KCh7IGlzTGF0ZXgsIHRoZW1lIH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBtYXJnaW5Ub3A6IGlzTGF0ZXggPyB0aGVtZS5zcGFjaW5nLm1kIDogXCIwXCIsXG5cbiAgICAvLyBUaGUgdG9vbHRpcCBob3ZlciB0YXJnZXQgd3JhcHMgdGhlIHRyaWdnZXIgZm9yIGFjY2Vzc2liaWxpdHkuXG4gICAgLy8gT25seSBzdHlsZSBUb29sdGlwSWNvbidzIGRlZmF1bHQgdHJpZ2dlciBnbHlwaCAoSGVscENpcmNsZUljb24pLlxuICAgIC8vIFRvb2x0aXBJY29uIGlzIGFsc28gdXNlZCBhcyBhIHdyYXBwZXIgYXJvdW5kIGFyYml0cmFyeSB0cmlnZ2VycyAoZS5nLiBhXG4gICAgLy8gYnV0dG9uIHdpdGggaXRzIG93biBJY29uKS4gVGhvc2UgdHJpZ2dlcnMgc2hvdWxkIGtlZXAgdGhlaXIgb3duIHN0eWxpbmcuXG4gICAgXCImIC5zdFRvb2x0aXBIb3ZlclRhcmdldCBzdmcuaWNvblwiOiB7XG4gICAgICBzdHJva2U6IHRoZW1lLmNvbG9ycy5mYWRlZFRleHQ2MCxcbiAgICAgIHN0cm9rZVdpZHRoOiB0aGVtZS5zaXplcy5kZWZhdWx0U3Ryb2tlV2lkdGgsXG4gICAgfSxcbiAgfSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMYWJlbEhlbHBXcmFwcGVyID0gc3R5bGVkLmRpdjxTdHlsZWRMYWJlbEhlbHBXcmFwcGVyUHJvcHM+KFxuICAoeyBpc0xhdGV4IH0pID0+ICh7XG4gICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgZmxleERpcmVjdGlvbjogXCJyb3dcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgIC8vIEZvciBMYVRlWCwgdXNlIGZpdC1jb250ZW50IHRvIGtlZXAgaWNvbiBjbG9zZSwgYnV0IGNvbnN0cmFpbiB3aXRoIG1heFdpZHRoXG4gICAgLy8gc28gbG9uZyBmb3JtdWxhcyBjYW4gc2Nyb2xsLiBDZW50ZXIgdXNpbmcgbWFyZ2luLWlubGluZTogYXV0b1xuICAgIHdpZHRoOiBpc0xhdGV4ID8gXCJmaXQtY29udGVudFwiIDogXCIxMDAlXCIsXG4gICAgLi4uKGlzTGF0ZXggPyB7IG1heFdpZHRoOiBcIjEwMCVcIiwgbWFyZ2luSW5saW5lOiBcImF1dG9cIiB9IDoge30pLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTGFiZWxIZWxwSW5saW5lID0gc3R5bGVkLmxhYmVsKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcueHMsXG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcInJvd1wiLFxufSkpXG4iXX0= */"), StyledLabelHelpInline = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "ewgb6650"
} : {
  target: "ewgb6650",
  label: "StyledLabelHelpInline"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.xs,
  position: "relative",
  display: "flex",
  flexDirection: "row"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function TooltipIcon(CA) {
  const {
    placement: gA = Placement.AUTO,
    isLatex: AA = !1,
    content: IA,
    markdownProps: BA,
    onMouseEnterDelay: QA,
    containerWidth: EA = !1
  } = CA, iA = useEmotionTheme(), oA = (tA) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipTriggerButton, { type: "button", "aria-label": tA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    HelpCircle,
    {
      className: "icon",
      "aria-hidden": "true",
      focusable: "false",
      size: convertRemToPx(iA.iconSizes.base)
    }
  ) }), cA = () => {
    if ("children" in CA)
      return isValidElement(CA.children) ? CA.children : oA("Help");
    const tA = CA.ariaLabel.trim();
    return tA.length ? oA(tA) : oA("Help");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipIconWrapper, { className: "stTooltipIcon", "data-testid": "stTooltipIcon", isLatex: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { style: {
    fontSize: iA.fontSizes.sm
  }, source: IA, allowHTML: !1, ...BA || {} }), placement: gA, onMouseEnterDelay: QA, inline: !0, containerWidth: EA, children: cA() }) });
}
function getHelpTooltipAriaLabel(CA) {
  const gA = CA?.trim(), AA = gA ? gA.replace(/\s+/g, " ") : null;
  return AA ? `Help for ${AA}` : "Help";
}
const InlineTooltipIcon = ({
  placement: CA = Placement.TOP_RIGHT,
  isLatex: gA = !1,
  content: AA,
  markdownProps: IA,
  onMouseEnterDelay: BA,
  containerWidth: QA,
  ariaLabel: EA = "Help"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpInline, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { placement: CA, isLatex: gA, content: AA, markdownProps: IA, onMouseEnterDelay: BA, containerWidth: QA, ariaLabel: EA }) });
function _EMOTION_STRINGIFIED_CSS_ERROR__$e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function convertRemToEm(CA) {
  return CA.replace(/rem$/, "em");
}
function sharedMarkdownStyle(CA) {
  return {
    a: {
      color: CA.colors.link,
      textDecoration: CA.linkUnderline ? "underline" : "none",
      "&:focus": {
        outline: "none",
        // Fallback for environments without :focus-visible support:
        boxShadow: CA.shadows.focusRing,
        borderRadius: CA.radii.default
      },
      // In browsers that support :focus-visible, avoid showing the focus ring on
      // mouse focus (while still keeping the fallback behavior in others).
      "&:focus:not(:focus-visible)": {
        boxShadow: CA.shadows.none
      },
      "&:focus-visible": {
        boxShadow: CA.shadows.focusRing,
        borderRadius: CA.radii.default
      }
    }
  };
}
function convertFontSizes(CA, gA, AA) {
  if (gA) {
    const IA = roundFontSizeToNearestEighth(parseFloat(CA) * 0.65), BA = `${Math.max(IA, 0.75)}rem`;
    return AA ? convertRemToEm(BA) : BA;
  }
  return AA ? convertRemToEm(CA) : CA;
}
function getMarkdownHeadingDefinitions(CA, gA, AA, IA) {
  return {
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: CA.genericFonts.headingFont,
      lineHeight: CA.lineHeights.headings,
      margin: 0,
      color: "inherit"
    },
    h1: {
      fontSize: convertFontSizes(CA.fontSizes.h1FontSize, gA, AA),
      fontWeight: CA.fontWeights.h1FontWeight,
      padding: IA ? 0 : `${CA.spacing.xl} 0 ${CA.spacing.lg} 0`
    },
    "h1 b, h1 strong": {
      // Per Pull Request #9395, setting text to bold in headers
      // should NOT change its font-weight
      fontWeight: CA.fontWeights.h1FontWeight
    },
    "h2, h3": {
      letterSpacing: "-0.005em"
    },
    h2: {
      fontSize: convertFontSizes(CA.fontSizes.h2FontSize, gA, AA),
      fontWeight: CA.fontWeights.h2FontWeight,
      padding: IA ? 0 : `${CA.spacing.lg} 0 ${CA.spacing.lg} 0`
    },
    h3: {
      fontSize: convertFontSizes(CA.fontSizes.h3FontSize, gA, AA),
      fontWeight: CA.fontWeights.h3FontWeight,
      padding: IA ? 0 : `${CA.spacing.md} 0 ${CA.spacing.lg} 0`
    },
    h4: {
      fontSize: convertFontSizes(CA.fontSizes.h4FontSize, gA, AA),
      fontWeight: CA.fontWeights.h4FontWeight,
      padding: IA ? 0 : `${CA.spacing.sm} 0 ${CA.spacing.lg} 0`
    },
    h5: {
      fontSize: convertFontSizes(CA.fontSizes.h5FontSize, gA, AA),
      fontWeight: CA.fontWeights.h5FontWeight,
      padding: IA ? 0 : `${CA.spacing.xs} 0 ${CA.spacing.lg} 0`
    },
    h6: {
      fontSize: convertFontSizes(CA.fontSizes.h6FontSize, gA, AA),
      fontWeight: CA.fontWeights.h6FontWeight,
      padding: IA ? 0 : `${CA.spacing.twoXS} 0 ${CA.spacing.lg} 0`
    }
  };
}
const StyledStreamlitMarkdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr6"
} : {
  target: "e1nzilvr6",
  label: "StyledStreamlitMarkdown"
})(({
  theme: CA,
  isCaption: gA,
  isInDialog: AA,
  isLabel: IA,
  isInHorizontalLayout: BA = !1,
  inheritFont: QA,
  boldLabel: EA,
  largerLabel: iA,
  isToast: oA,
  truncate: cA
}) => {
  const tA = IA && !iA || oA || gA;
  return {
    fontFamily: QA ? "inherit" : CA.genericFonts.bodyFont,
    fontSize: QA ? "inherit" : tA ? CA.fontSizes.sm : CA.fontSizes.md,
    fontWeight: QA ? "inherit" : void 0,
    marginBottom: IA || BA ? "" : `-${CA.spacing.lg}`,
    opacity: gA ? 0.6 : void 0,
    color: "inherit",
    // Always respect the width of the parent container:
    maxWidth: "100%",
    width: IA ? "" : "100%",
    // Break long words to prevent them from overflowing the container:
    overflowWrap: "break-word",
    ...sharedMarkdownStyle(CA),
    ...getMarkdownHeadingDefinitions(CA, AA, gA, BA),
    // Truncate text with ellipsis when it overflows the container.
    // This is useful for single-line text that should not wrap.
    // When inheritFont is false, lineHeight: "normal" resets inherited line heights
    // (e.g., when parent has a large line-height). When inheritFont is true,
    // we preserve the parent's line height for consistent styling.
    ...cA && {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      lineHeight: QA ? "inherit" : "normal",
      "& p": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        lineHeight: QA ? "inherit" : "normal"
      }
    },
    // This is required so that long Latex formulas in `st.latex` are scrollable
    // when `help` is set (see below).
    "&:has(.katex-display)": {
      overflowX: "hidden"
    },
    p: {
      wordBreak: "break-word",
      marginBottom: IA ? CA.spacing.none : "",
      fontWeight: QA ? "inherit" : EA ? CA.fontWeights.bold : void 0,
      marginTop: CA.spacing.none,
      marginLeft: CA.spacing.none,
      marginRight: CA.spacing.none
    },
    img: {
      // Images in markdown should never be wider
      // than the content area.
      maxWidth: "100%",
      // In labels, widgets should never be taller than the text.
      maxHeight: IA ? "1em" : void 0,
      verticalAlign: "middle",
      // Ensure that images are not distorted:
      objectFit: "scale-down"
    },
    li: {
      margin: "0.2em 0 0.2em 1.15em",
      padding: "0 0 0 0.3em"
    },
    "li.task-list-item": {
      listStyleType: "none",
      padding: "0",
      marginLeft: "0",
      "input[type='checkbox']": {
        verticalAlign: "middle",
        margin: "0 0.35em 0.1em 0"
      }
    },
    // Handles quotes:
    blockquote: {
      margin: "1em 0 1em 0",
      padding: "0 0 0 0.75em",
      borderLeft: `0.15em solid ${CA.colors.borderColor}`,
      opacity: 0.6
    },
    "b, strong": {
      fontWeight: CA.fontWeights.bold
    },
    // Issue #11976: Handle bolded inline code
    "b code, strong code": {
      fontWeight: CA.fontWeights.codeBold
    },
    // Handles the horizontal divider:
    hr: {
      margin: "2em 0",
      padding: 0,
      // Reset Firefox's gray color:
      color: "inherit",
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
      // Set correct height and prevent the size attribute
      // to make the hr look like an input field:
      "&:not([size])": {
        height: CA.sizes.borderWidth
      }
    },
    table: {
      display: "table",
      // Prevent double borders
      borderCollapse: "collapse",
      marginBottom: CA.spacing.lg
    },
    tr: {
      borderTop: `${CA.sizes.borderWidth} solid ${CA.colors.dataframeBorderColor}`
    },
    th: {
      // TODO: check whether this should be adjusted
      // defaults to font-weight: "bold" (700)
      textAlign: "inherit"
    },
    "th, td": {
      padding: `${CA.spacing.xs} ${CA.spacing.md}`,
      border: `${CA.sizes.borderWidth} solid ${CA.colors.dataframeBorderColor}`
    },
    "span.stMarkdownColoredBackground": {
      borderRadius: CA.radii.sm,
      padding: `${CA.spacing.threeXS} ${CA.spacing.twoXS}`,
      margin: CA.spacing.none,
      boxDecorationBreak: "clone"
    },
    "span.stMarkdownBadge": {
      borderRadius: CA.radii.sm,
      // Since we're using inline-block below, we're not using vertical padding here,
      // because inline-block already makes the element look a bit taller.
      padding: `0 ${CA.spacing.twoXS}`,
      // Add a small margin to separate it a bit from other text.
      margin: `0 ${CA.spacing.px}`,
      // Make badges not wrap and ellipsize them if they are too long for the
      // parent container.
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      display: "inline-block",
      verticalAlign: "middle"
    },
    "p, ol, ul, dl, li": {
      fontSize: "inherit"
    },
    "& > ul, & > ol": {
      display: "block",
      width: "fit-content",
      textAlign: "left"
    },
    // Ensure nested lists stay as block elements
    "li > ul, li > ol": {
      display: "block"
    },
    // Allow long Latex formulas that are not inline (i.e. either from `st.latex`
    // or in their own paragraph inside `st.markdown`) to scroll horizontally.
    ".katex-display": {
      overflowX: "auto",
      overflowY: "hidden"
    },
    ".katex": {
      fontWeight: CA.fontWeights.normal
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvU3RyZWFtbGl0TWFya2Rvd24vc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUxFIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9zaGFyZWQvU3RyZWFtbGl0TWFya2Rvd24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHsgVGhlbWUgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgcm91bmRGb250U2l6ZVRvTmVhcmVzdEVpZ2h0aCB9IGZyb20gXCJ+bGliL3RoZW1lL3V0aWxzXCJcblxuaW50ZXJmYWNlIFN0eWxlZFN0cmVhbWxpdE1hcmtkb3duUHJvcHMge1xuICBpc0NhcHRpb246IGJvb2xlYW5cbiAgaXNJbkRpYWxvZzogYm9vbGVhblxuICBpc0xhYmVsPzogYm9vbGVhblxuICBpc0luSG9yaXpvbnRhbExheW91dD86IGJvb2xlYW5cbiAgaW5oZXJpdEZvbnQ/OiBib29sZWFuXG4gIGJvbGRMYWJlbD86IGJvb2xlYW5cbiAgbGFyZ2VyTGFiZWw/OiBib29sZWFuXG4gIGlzVG9hc3Q/OiBib29sZWFuXG4gIHRydW5jYXRlPzogYm9vbGVhblxufVxuXG5mdW5jdGlvbiBjb252ZXJ0UmVtVG9FbShzOiBzdHJpbmcpOiBzdHJpbmcge1xuICByZXR1cm4gcy5yZXBsYWNlKC9yZW0kLywgXCJlbVwiKVxufVxuXG5mdW5jdGlvbiBzaGFyZWRNYXJrZG93blN0eWxlKHRoZW1lOiBUaGVtZSk6IFJlY29yZDxzdHJpbmcsIHVua25vd24+IHtcbiAgcmV0dXJuIHtcbiAgICBhOiB7XG4gICAgICBjb2xvcjogdGhlbWUuY29sb3JzLmxpbmssXG4gICAgICB0ZXh0RGVjb3JhdGlvbjogdGhlbWUubGlua1VuZGVybGluZSA/IFwidW5kZXJsaW5lXCIgOiBcIm5vbmVcIixcbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgICAvLyBGYWxsYmFjayBmb3IgZW52aXJvbm1lbnRzIHdpdGhvdXQgOmZvY3VzLXZpc2libGUgc3VwcG9ydDpcbiAgICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZyxcbiAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgfSxcbiAgICAgIC8vIEluIGJyb3dzZXJzIHRoYXQgc3VwcG9ydCA6Zm9jdXMtdmlzaWJsZSwgYXZvaWQgc2hvd2luZyB0aGUgZm9jdXMgcmluZyBvblxuICAgICAgLy8gbW91c2UgZm9jdXMgKHdoaWxlIHN0aWxsIGtlZXBpbmcgdGhlIGZhbGxiYWNrIGJlaGF2aW9yIGluIG90aGVycykuXG4gICAgICBcIiY6Zm9jdXM6bm90KDpmb2N1cy12aXNpYmxlKVwiOiB7XG4gICAgICAgIGJveFNoYWRvdzogdGhlbWUuc2hhZG93cy5ub25lLFxuICAgICAgfSxcbiAgICAgIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZyxcbiAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59XG5cbi8qKlxuICogQ2FwdGlvbiBzaXplcyB0YWtlbiBmcm9tIGRlZmF1bHQgc3R5bGVzLCBidXQgdXNpbmcgZW0gaW5zdGVhZCBvZiByZW0sIHNvIGl0XG4gKiBpbmhlcml0cyB0aGUgPHNtYWxsPidzIHNocnVuayBzaXplLiBBbHNvIGhhbmRsZXMgcmVkdWNlZCBoZWFkaW5nIGZvbnQgc2l6ZXNcbiAqIGluIGRpYWxvZ3MuXG4gKi9cbmZ1bmN0aW9uIGNvbnZlcnRGb250U2l6ZXMoXG4gIGZvbnRTaXplOiBzdHJpbmcsXG4gIGlzSW5EaWFsb2c6IGJvb2xlYW4sXG4gIGlzQ2FwdGlvbjogYm9vbGVhblxuKTogc3RyaW5nIHtcbiAgLy8gRm9yIGhlYWRlcnMgaW4gYHN0LmNhcHRpb25gLCB3ZSB1c2UgYGVtYCB2YWx1ZXMsIHNvIHRoZSBoZWFkZXJzIGF1dG9tYXRpY2FsbHlcbiAgLy8gYmVjb21lIGEgYml0IHNtYWxsZXIgYnkgYWRhcHRpbmcgdG8gdGhlIGZvbnQgc2l6ZSBvZiB0aGUgY2FwdGlvbi5cblxuICBpZiAoaXNJbkRpYWxvZykge1xuICAgIC8vIERpYWxvZ3MgYWxzbyByZWR1Y2UgdGhlIGZvbnQgc2l6ZSBvZiB0aGUgaGVhZGluZ3MgdG8gNjUlIG9mIHRoZSBiYXNlIGZvbnQgc2l6ZVxuICAgIC8vIFJvdW5kIHRoZSBmb250IHNpemUgdG8gdGhlIG5lYXJlc3QgZWlnaHRoIG9mIGEgcmVtIHRvIHRyeSB0byBrZWVwIHRvIHJvdW5kIHB4IHZhbHVlc1xuICAgIGNvbnN0IHJvdW5kZWRGb250U2l6ZSA9IHJvdW5kRm9udFNpemVUb05lYXJlc3RFaWdodGgoXG4gICAgICBwYXJzZUZsb2F0KGZvbnRTaXplKSAqIDAuNjVcbiAgICApXG5cbiAgICAvLyBFbnN1cmUgdGhlIGZvbnQgc2l6ZSBpcyBhdCBsZWFzdCAwLjc1cmVtXG4gICAgY29uc3QgZGlhbG9nRm9udFNpemUgPSBgJHtNYXRoLm1heChyb3VuZGVkRm9udFNpemUsIDAuNzUpfXJlbWBcbiAgICByZXR1cm4gaXNDYXB0aW9uID8gY29udmVydFJlbVRvRW0oZGlhbG9nRm9udFNpemUpIDogZGlhbG9nRm9udFNpemVcbiAgfVxuXG4gIHJldHVybiBpc0NhcHRpb24gPyBjb252ZXJ0UmVtVG9FbShmb250U2l6ZSkgOiBmb250U2l6ZVxufVxuXG5mdW5jdGlvbiBnZXRNYXJrZG93bkhlYWRpbmdEZWZpbml0aW9ucyhcbiAgdGhlbWU6IFRoZW1lLFxuICBpc0luRGlhbG9nOiBib29sZWFuLFxuICBpc0NhcHRpb246IGJvb2xlYW4sXG4gIGlzSW5Ib3Jpem9udGFsTGF5b3V0OiBib29sZWFuXG4pOiBSZWNvcmQ8c3RyaW5nLCB1bmtub3duPiB7XG4gIHJldHVybiB7XG4gICAgXCJoMSwgaDIsIGgzLCBoNCwgaDUsIGg2XCI6IHtcbiAgICAgIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5oZWFkaW5nRm9udCxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLmhlYWRpbmdzLFxuICAgICAgbWFyZ2luOiAwLFxuICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgIH0sXG4gICAgaDE6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDFGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5oMUZvbnRXZWlnaHQsXG4gICAgICBwYWRkaW5nOiBpc0luSG9yaXpvbnRhbExheW91dFxuICAgICAgICA/IDBcbiAgICAgICAgOiBgJHt0aGVtZS5zcGFjaW5nLnhsfSAwICR7dGhlbWUuc3BhY2luZy5sZ30gMGAsXG4gICAgfSxcbiAgICBcImgxIGIsIGgxIHN0cm9uZ1wiOiB7XG4gICAgICAvLyBQZXIgUHVsbCBSZXF1ZXN0ICM5Mzk1LCBzZXR0aW5nIHRleHQgdG8gYm9sZCBpbiBoZWFkZXJzXG4gICAgICAvLyBzaG91bGQgTk9UIGNoYW5nZSBpdHMgZm9udC13ZWlnaHRcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmgxRm9udFdlaWdodCxcbiAgICB9LFxuICAgIFwiaDIsIGgzXCI6IHtcbiAgICAgIGxldHRlclNwYWNpbmc6IFwiLTAuMDA1ZW1cIixcbiAgICB9LFxuICAgIGgyOiB7XG4gICAgICBmb250U2l6ZTogY29udmVydEZvbnRTaXplcyhcbiAgICAgICAgdGhlbWUuZm9udFNpemVzLmgyRm9udFNpemUsXG4gICAgICAgIGlzSW5EaWFsb2csXG4gICAgICAgIGlzQ2FwdGlvblxuICAgICAgKSxcbiAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmgyRm9udFdlaWdodCxcbiAgICAgIHBhZGRpbmc6IGlzSW5Ib3Jpem9udGFsTGF5b3V0XG4gICAgICAgID8gMFxuICAgICAgICA6IGAke3RoZW1lLnNwYWNpbmcubGd9IDAgJHt0aGVtZS5zcGFjaW5nLmxnfSAwYCxcbiAgICB9LFxuICAgIGgzOiB7XG4gICAgICBmb250U2l6ZTogY29udmVydEZvbnRTaXplcyhcbiAgICAgICAgdGhlbWUuZm9udFNpemVzLmgzRm9udFNpemUsXG4gICAgICAgIGlzSW5EaWFsb2csXG4gICAgICAgIGlzQ2FwdGlvblxuICAgICAgKSxcblxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDNGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogaXNJbkhvcml6b250YWxMYXlvdXRcbiAgICAgICAgPyAwXG4gICAgICAgIDogYCR7dGhlbWUuc3BhY2luZy5tZH0gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDQ6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDRGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDRGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogaXNJbkhvcml6b250YWxMYXlvdXRcbiAgICAgICAgPyAwXG4gICAgICAgIDogYCR7dGhlbWUuc3BhY2luZy5zbX0gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDU6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDVGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuaDVGb250V2VpZ2h0LFxuICAgICAgcGFkZGluZzogaXNJbkhvcml6b250YWxMYXlvdXRcbiAgICAgICAgPyAwXG4gICAgICAgIDogYCR7dGhlbWUuc3BhY2luZy54c30gMCAke3RoZW1lLnNwYWNpbmcubGd9IDBgLFxuICAgIH0sXG4gICAgaDY6IHtcbiAgICAgIGZvbnRTaXplOiBjb252ZXJ0Rm9udFNpemVzKFxuICAgICAgICB0aGVtZS5mb250U2l6ZXMuaDZGb250U2l6ZSxcbiAgICAgICAgaXNJbkRpYWxvZyxcbiAgICAgICAgaXNDYXB0aW9uXG4gICAgICApLFxuXG4gICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5oNkZvbnRXZWlnaHQsXG4gICAgICBwYWRkaW5nOiBpc0luSG9yaXpvbnRhbExheW91dFxuICAgICAgICA/IDBcbiAgICAgICAgOiBgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAwICR7dGhlbWUuc3BhY2luZy5sZ30gMGAsXG4gICAgfSxcbiAgfVxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU3RyZWFtbGl0TWFya2Rvd24gPVxuICBzdHlsZWQuZGl2PFN0eWxlZFN0cmVhbWxpdE1hcmtkb3duUHJvcHM+KFxuICAgICh7XG4gICAgICB0aGVtZSxcbiAgICAgIGlzQ2FwdGlvbixcbiAgICAgIGlzSW5EaWFsb2csXG4gICAgICBpc0xhYmVsLFxuICAgICAgaXNJbkhvcml6b250YWxMYXlvdXQgPSBmYWxzZSxcbiAgICAgIGluaGVyaXRGb250LFxuICAgICAgYm9sZExhYmVsLFxuICAgICAgbGFyZ2VyTGFiZWwsXG4gICAgICBpc1RvYXN0LFxuICAgICAgdHJ1bmNhdGUsXG4gICAgfSkgPT4ge1xuICAgICAgLy8gV2lkZ2V0IExhYmVscyBoYXZlIHNtYWxsZXIgZm9udCBzaXplIHdpdGggZXhjZXB0aW9uIG9mIEJ1dHRvbi9DaGVja2JveC9SYWRpbyBCdXR0b24gbGFiZWxzXG4gICAgICAvLyBUb2FzdHMgYWxzbyBoYXZlIHNtYWxsZXIgZm9udCBzaXplIGFzIHdlbGwgYXMgcGlsbHMgYW5kIHNlZ21lbnRlZCBjb250cm9scy5cbiAgICAgIGNvbnN0IHVzZVNtYWxsZXJGb250U2l6ZSA9XG4gICAgICAgIChpc0xhYmVsICYmICFsYXJnZXJMYWJlbCkgfHwgaXNUb2FzdCB8fCBpc0NhcHRpb25cblxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgZm9udEZhbWlseTogaW5oZXJpdEZvbnQgPyBcImluaGVyaXRcIiA6IHRoZW1lLmdlbmVyaWNGb250cy5ib2R5Rm9udCxcbiAgICAgICAgZm9udFNpemU6IGluaGVyaXRGb250XG4gICAgICAgICAgPyBcImluaGVyaXRcIlxuICAgICAgICAgIDogdXNlU21hbGxlckZvbnRTaXplXG4gICAgICAgICAgICA/IHRoZW1lLmZvbnRTaXplcy5zbVxuICAgICAgICAgICAgOiB0aGVtZS5mb250U2l6ZXMubWQsXG4gICAgICAgIGZvbnRXZWlnaHQ6IGluaGVyaXRGb250ID8gXCJpbmhlcml0XCIgOiB1bmRlZmluZWQsXG4gICAgICAgIG1hcmdpbkJvdHRvbTpcbiAgICAgICAgICBpc0xhYmVsIHx8IGlzSW5Ib3Jpem9udGFsTGF5b3V0ID8gXCJcIiA6IGAtJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gICAgICAgIG9wYWNpdHk6IGlzQ2FwdGlvbiA/IDAuNiA6IHVuZGVmaW5lZCxcbiAgICAgICAgY29sb3I6IFwiaW5oZXJpdFwiLFxuICAgICAgICAvLyBBbHdheXMgcmVzcGVjdCB0aGUgd2lkdGggb2YgdGhlIHBhcmVudCBjb250YWluZXI6XG4gICAgICAgIG1heFdpZHRoOiBcIjEwMCVcIixcbiAgICAgICAgd2lkdGg6IGlzTGFiZWwgPyBcIlwiIDogXCIxMDAlXCIsXG4gICAgICAgIC8vIEJyZWFrIGxvbmcgd29yZHMgdG8gcHJldmVudCB0aGVtIGZyb20gb3ZlcmZsb3dpbmcgdGhlIGNvbnRhaW5lcjpcbiAgICAgICAgb3ZlcmZsb3dXcmFwOiBcImJyZWFrLXdvcmRcIixcbiAgICAgICAgLi4uc2hhcmVkTWFya2Rvd25TdHlsZSh0aGVtZSksXG4gICAgICAgIC4uLmdldE1hcmtkb3duSGVhZGluZ0RlZmluaXRpb25zKFxuICAgICAgICAgIHRoZW1lLFxuICAgICAgICAgIGlzSW5EaWFsb2csXG4gICAgICAgICAgaXNDYXB0aW9uLFxuICAgICAgICAgIGlzSW5Ib3Jpem9udGFsTGF5b3V0XG4gICAgICAgICksXG5cbiAgICAgICAgLy8gVHJ1bmNhdGUgdGV4dCB3aXRoIGVsbGlwc2lzIHdoZW4gaXQgb3ZlcmZsb3dzIHRoZSBjb250YWluZXIuXG4gICAgICAgIC8vIFRoaXMgaXMgdXNlZnVsIGZvciBzaW5nbGUtbGluZSB0ZXh0IHRoYXQgc2hvdWxkIG5vdCB3cmFwLlxuICAgICAgICAvLyBXaGVuIGluaGVyaXRGb250IGlzIGZhbHNlLCBsaW5lSGVpZ2h0OiBcIm5vcm1hbFwiIHJlc2V0cyBpbmhlcml0ZWQgbGluZSBoZWlnaHRzXG4gICAgICAgIC8vIChlLmcuLCB3aGVuIHBhcmVudCBoYXMgYSBsYXJnZSBsaW5lLWhlaWdodCkuIFdoZW4gaW5oZXJpdEZvbnQgaXMgdHJ1ZSxcbiAgICAgICAgLy8gd2UgcHJlc2VydmUgdGhlIHBhcmVudCdzIGxpbmUgaGVpZ2h0IGZvciBjb25zaXN0ZW50IHN0eWxpbmcuXG4gICAgICAgIC4uLih0cnVuY2F0ZSAmJiB7XG4gICAgICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgICAgICB0ZXh0T3ZlcmZsb3c6IFwiZWxsaXBzaXNcIixcbiAgICAgICAgICBsaW5lSGVpZ2h0OiBpbmhlcml0Rm9udCA/IFwiaW5oZXJpdFwiIDogXCJub3JtYWxcIixcblxuICAgICAgICAgIFwiJiBwXCI6IHtcbiAgICAgICAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgICAgICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgICAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgICAgICAgbGluZUhlaWdodDogaW5oZXJpdEZvbnQgPyBcImluaGVyaXRcIiA6IFwibm9ybWFsXCIsXG4gICAgICAgICAgfSxcbiAgICAgICAgfSksXG5cbiAgICAgICAgLy8gVGhpcyBpcyByZXF1aXJlZCBzbyB0aGF0IGxvbmcgTGF0ZXggZm9ybXVsYXMgaW4gYHN0LmxhdGV4YCBhcmUgc2Nyb2xsYWJsZVxuICAgICAgICAvLyB3aGVuIGBoZWxwYCBpcyBzZXQgKHNlZSBiZWxvdykuXG4gICAgICAgIFwiJjpoYXMoLmthdGV4LWRpc3BsYXkpXCI6IHtcbiAgICAgICAgICBvdmVyZmxvd1g6IFwiaGlkZGVuXCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgcDoge1xuICAgICAgICAgIHdvcmRCcmVhazogXCJicmVhay13b3JkXCIsXG4gICAgICAgICAgbWFyZ2luQm90dG9tOiBpc0xhYmVsID8gdGhlbWUuc3BhY2luZy5ub25lIDogXCJcIixcbiAgICAgICAgICBmb250V2VpZ2h0OiBpbmhlcml0Rm9udFxuICAgICAgICAgICAgPyBcImluaGVyaXRcIlxuICAgICAgICAgICAgOiBib2xkTGFiZWxcbiAgICAgICAgICAgICAgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkXG4gICAgICAgICAgICAgIDogdW5kZWZpbmVkLFxuICAgICAgICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgICAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICB9LFxuXG4gICAgICAgIGltZzoge1xuICAgICAgICAgIC8vIEltYWdlcyBpbiBtYXJrZG93biBzaG91bGQgbmV2ZXIgYmUgd2lkZXJcbiAgICAgICAgICAvLyB0aGFuIHRoZSBjb250ZW50IGFyZWEuXG4gICAgICAgICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICAgIC8vIEluIGxhYmVscywgd2lkZ2V0cyBzaG91bGQgbmV2ZXIgYmUgdGFsbGVyIHRoYW4gdGhlIHRleHQuXG4gICAgICAgICAgbWF4SGVpZ2h0OiBpc0xhYmVsID8gXCIxZW1cIiA6IHVuZGVmaW5lZCxcbiAgICAgICAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICAgICAgICAgIC8vIEVuc3VyZSB0aGF0IGltYWdlcyBhcmUgbm90IGRpc3RvcnRlZDpcbiAgICAgICAgICBvYmplY3RGaXQ6IFwic2NhbGUtZG93blwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIGxpOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjAuMmVtIDAgMC4yZW0gMS4xNWVtXCIsXG4gICAgICAgICAgcGFkZGluZzogXCIwIDAgMCAwLjNlbVwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFwibGkudGFzay1saXN0LWl0ZW1cIjoge1xuICAgICAgICAgIGxpc3RTdHlsZVR5cGU6IFwibm9uZVwiLFxuICAgICAgICAgIHBhZGRpbmc6IFwiMFwiLFxuICAgICAgICAgIG1hcmdpbkxlZnQ6IFwiMFwiLFxuICAgICAgICAgIFwiaW5wdXRbdHlwZT0nY2hlY2tib3gnXVwiOiB7XG4gICAgICAgICAgICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICAgICAgICAgICAgbWFyZ2luOiBcIjAgMC4zNWVtIDAuMWVtIDBcIixcbiAgICAgICAgICB9LFxuICAgICAgICB9LFxuXG4gICAgICAgIC8vIEhhbmRsZXMgcXVvdGVzOlxuICAgICAgICBibG9ja3F1b3RlOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjFlbSAwIDFlbSAwXCIsXG4gICAgICAgICAgcGFkZGluZzogYDAgMCAwIDAuNzVlbWAsXG4gICAgICAgICAgYm9yZGVyTGVmdDogYDAuMTVlbSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIG9wYWNpdHk6IDAuNixcbiAgICAgICAgfSxcblxuICAgICAgICBcImIsIHN0cm9uZ1wiOiB7XG4gICAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCxcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBJc3N1ZSAjMTE5NzY6IEhhbmRsZSBib2xkZWQgaW5saW5lIGNvZGVcbiAgICAgICAgXCJiIGNvZGUsIHN0cm9uZyBjb2RlXCI6IHtcbiAgICAgICAgICBmb250V2VpZ2h0OiB0aGVtZS5mb250V2VpZ2h0cy5jb2RlQm9sZCxcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBIYW5kbGVzIHRoZSBob3Jpem9udGFsIGRpdmlkZXI6XG4gICAgICAgIGhyOiB7XG4gICAgICAgICAgbWFyZ2luOiBcIjJlbSAwXCIsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBSZXNldCBGaXJlZm94J3MgZ3JheSBjb2xvcjpcbiAgICAgICAgICBjb2xvcjogXCJpbmhlcml0XCIsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiBcInRyYW5zcGFyZW50XCIsXG4gICAgICAgICAgYm9yZGVyOiBcIm5vbmVcIixcbiAgICAgICAgICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAgICAgICAgIC8vIFNldCBjb3JyZWN0IGhlaWdodCBhbmQgcHJldmVudCB0aGUgc2l6ZSBhdHRyaWJ1dGVcbiAgICAgICAgICAvLyB0byBtYWtlIHRoZSBociBsb29rIGxpa2UgYW4gaW5wdXQgZmllbGQ6XG4gICAgICAgICAgXCImOm5vdChbc2l6ZV0pXCI6IHtcbiAgICAgICAgICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGgsXG4gICAgICAgICAgfSxcbiAgICAgICAgfSxcblxuICAgICAgICB0YWJsZToge1xuICAgICAgICAgIGRpc3BsYXk6IFwidGFibGVcIixcbiAgICAgICAgICAvLyBQcmV2ZW50IGRvdWJsZSBib3JkZXJzXG4gICAgICAgICAgYm9yZGVyQ29sbGFwc2U6IFwiY29sbGFwc2VcIixcbiAgICAgICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIH0sXG5cbiAgICAgICAgdHI6IHtcbiAgICAgICAgICBib3JkZXJUb3A6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5kYXRhZnJhbWVCb3JkZXJDb2xvcn1gLFxuICAgICAgICB9LFxuXG4gICAgICAgIHRoOiB7XG4gICAgICAgICAgLy8gVE9ETzogY2hlY2sgd2hldGhlciB0aGlzIHNob3VsZCBiZSBhZGp1c3RlZFxuICAgICAgICAgIC8vIGRlZmF1bHRzIHRvIGZvbnQtd2VpZ2h0OiBcImJvbGRcIiAoNzAwKVxuICAgICAgICAgIHRleHRBbGlnbjogXCJpbmhlcml0XCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCJ0aCwgdGRcIjoge1xuICAgICAgICAgIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcueHN9ICR7dGhlbWUuc3BhY2luZy5tZH1gLFxuICAgICAgICAgIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmRhdGFmcmFtZUJvcmRlckNvbG9yfWAsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCJzcGFuLnN0TWFya2Rvd25Db2xvcmVkQmFja2dyb3VuZFwiOiB7XG4gICAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5zbSxcbiAgICAgICAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy50d29YU31gLFxuICAgICAgICAgIG1hcmdpbjogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgICAgIGJveERlY29yYXRpb25CcmVhazogXCJjbG9uZVwiLFxuICAgICAgICB9LFxuXG4gICAgICAgIFwic3Bhbi5zdE1hcmtkb3duQmFkZ2VcIjoge1xuICAgICAgICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuc20sXG4gICAgICAgICAgLy8gU2luY2Ugd2UncmUgdXNpbmcgaW5saW5lLWJsb2NrIGJlbG93LCB3ZSdyZSBub3QgdXNpbmcgdmVydGljYWwgcGFkZGluZyBoZXJlLFxuICAgICAgICAgIC8vIGJlY2F1c2UgaW5saW5lLWJsb2NrIGFscmVhZHkgbWFrZXMgdGhlIGVsZW1lbnQgbG9vayBhIGJpdCB0YWxsZXIuXG4gICAgICAgICAgcGFkZGluZzogYDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfWAsXG4gICAgICAgICAgLy8gQWRkIGEgc21hbGwgbWFyZ2luIHRvIHNlcGFyYXRlIGl0IGEgYml0IGZyb20gb3RoZXIgdGV4dC5cbiAgICAgICAgICBtYXJnaW46IGAwICR7dGhlbWUuc3BhY2luZy5weH1gLFxuXG4gICAgICAgICAgLy8gTWFrZSBiYWRnZXMgbm90IHdyYXAgYW5kIGVsbGlwc2l6ZSB0aGVtIGlmIHRoZXkgYXJlIHRvbyBsb25nIGZvciB0aGVcbiAgICAgICAgICAvLyBwYXJlbnQgY29udGFpbmVyLlxuICAgICAgICAgIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gICAgICAgICAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gICAgICAgICAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gICAgICAgICAgbWF4V2lkdGg6IFwiMTAwJVwiLFxuICAgICAgICAgIGRpc3BsYXk6IFwiaW5saW5lLWJsb2NrXCIsXG4gICAgICAgICAgdmVydGljYWxBbGlnbjogXCJtaWRkbGVcIixcbiAgICAgICAgfSxcblxuICAgICAgICBcInAsIG9sLCB1bCwgZGwsIGxpXCI6IHtcbiAgICAgICAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCImID4gdWwsICYgPiBvbFwiOiB7XG4gICAgICAgICAgZGlzcGxheTogXCJibG9ja1wiLFxuICAgICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgICAgdGV4dEFsaWduOiBcImxlZnRcIixcbiAgICAgICAgfSxcblxuICAgICAgICAvLyBFbnN1cmUgbmVzdGVkIGxpc3RzIHN0YXkgYXMgYmxvY2sgZWxlbWVudHNcbiAgICAgICAgXCJsaSA+IHVsLCBsaSA+IG9sXCI6IHtcbiAgICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgLy8gQWxsb3cgbG9uZyBMYXRleCBmb3JtdWxhcyB0aGF0IGFyZSBub3QgaW5saW5lIChpLmUuIGVpdGhlciBmcm9tIGBzdC5sYXRleGBcbiAgICAgICAgLy8gb3IgaW4gdGhlaXIgb3duIHBhcmFncmFwaCBpbnNpZGUgYHN0Lm1hcmtkb3duYCkgdG8gc2Nyb2xsIGhvcml6b250YWxseS5cbiAgICAgICAgXCIua2F0ZXgtZGlzcGxheVwiOiB7XG4gICAgICAgICAgb3ZlcmZsb3dYOiBcImF1dG9cIixcbiAgICAgICAgICBvdmVyZmxvd1k6IFwiaGlkZGVuXCIsXG4gICAgICAgIH0sXG5cbiAgICAgICAgXCIua2F0ZXhcIjoge1xuICAgICAgICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZExpbmtJY29uID0gc3R5bGVkLmEoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gY2VudGVyIGljb25cbiAgbGluZUhlaWdodDogMCxcbiAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICBqdXN0aWZ5Q29udGVudDogXCJjZW50ZXJcIixcbiAgb3BhY2l0eTogMCxcbiAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG4gIHRyYW5zaXRpb246IFwib3BhY2l0eSAxNTBtcyBlYXNlLWluLW91dFwiLFxuXG4gIHN2Zzoge1xuICAgIC8vIHNhbWUgY29sb3IgYXMgdGhlIHRvb2x0aXAtaWNvblxuICAgIHN0cm9rZTogdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwLFxuICAgIHN0cm9rZVdpZHRoOiB0aGVtZS5zaXplcy5kZWZhdWx0U3Ryb2tlV2lkdGgsXG4gIH0sXG5cbiAgXCImOmhvdmVyIHN2Z1wiOiB7XG4gICAgc3Ryb2tlOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIH0sXG5cbiAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgIG9wYWNpdHk6IDEsXG4gICAgcG9pbnRlckV2ZW50czogXCJhdXRvXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRpbmdXaXRoQWN0aW9uRWxlbWVudHMgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiaDEsIGgyLCBoMywgaDQsIGg1LCBoNiwgc3BhblwiOiB7XG4gICAgc2Nyb2xsTWFyZ2luVG9wOiB0aGVtZS5zaXplcy5oZWFkZXJIZWlnaHQsXG4gIH0sXG4gIC4uLnNoYXJlZE1hcmtkb3duU3R5bGUodGhlbWUpLFxuXG4gIC8vIGJyZWFrLXdvcmQgJiBwcmV0dHkgbWFrZXMgbW9zdCBoZWFkaW5ncyBicmVhayBpbiBhIG5pY2VyIHdheSB0aGFuIGJyZWFrLWFsbCB3aGlsZSBzdGlsbFxuICAvLyBwcmV2ZW50aW5nIG92ZXJmbG93aW5nIG9mIHRoZSBjb250YWluZXIgdG8gdGhlIHNpZGUuIExvbmcgaGVhZGluZ3Mgd2l0aG91dCB3aGl0ZXNwYWNlcyBvciBoeXBoZW5zIG1pZ2h0IHN0aWxsIGxvb2sgd2VpcmRcbiAgd29yZEJyZWFrOiBcImJyZWFrLXdvcmRcIixcbiAgdGV4dFdyYXA6IFwicHJldHR5XCIsXG5cbiAgLy8gU2hvdyBsaW5rIGljb24gd2hlbiBob3ZlcmluZyBvciB3aGVuIGZvY3VzIGlzIHdpdGhpbiB0aGUgaGVhZGluZyBjb250YWluZXIuXG4gIC8vIFdlIHVzZSBvcGFjaXR5IGluc3RlYWQgb2YgdmlzaWJpbGl0eSBzbyB0aGUgbGluayByZW1haW5zIGluIHRoZSB0YWIgb3JkZXIuXG4gIFwiJjpob3ZlciwgJjpmb2N1cy13aXRoaW5cIjoge1xuICAgIFtTdHlsZWRMaW5rSWNvbiBhcyB1bmtub3duIGFzIHN0cmluZ106IHtcbiAgICAgIG9wYWNpdHk6IDEsXG4gICAgICBwb2ludGVyRXZlbnRzOiBcImF1dG9cIixcbiAgICB9LFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRIZWFkaW5nQWN0aW9uRWxlbWVudHMgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5MZWZ0OiB0aGVtZS5zcGFjaW5nLnNtLFxuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcblxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuXG4gIFwiJiA+ICpcIjoge1xuICAgIC8vIHJlbW92ZSBtYXJnaW5zIG9mIGlubmVyIGVsZW1lbnRzIGFzIHRoZXkgYXJlIHdyYXBwZWQgaW4gYSBjb250YWluZXIgdGhhdCBhcHBsaWVzIHRoZSBtYXJnaW5cbiAgICBtYXJnaW5MZWZ0OiBcIjAgIWltcG9ydGFudFwiLFxuICB9LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWREaXZpZGVyUHJvcHMge1xuICByYWluYm93OiBib29sZWFuXG4gIGNvbG9yOiBzdHJpbmdcbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEhlYWRlckRpdmlkZXIgPSBzdHlsZWQuaHI8U3R5bGVkRGl2aWRlclByb3BzPihcbiAgKHsgdGhlbWUsIHJhaW5ib3csIGNvbG9yIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgLy8gSGVpZ2h0IG5lZWRzIHRvIGJlICFpbXBvcnRhbnQgZHVlIHRvIGdsb2JhbFN0eWxlcy50c3ggaHIgaGVpZ2h0IG92ZXJyaWRlIC0gbGluZSAjMTcwXG4gICAgICBoZWlnaHQ6IGAke3RoZW1lLnNwYWNpbmcudGhyZWVYU30gIWltcG9ydGFudGAsXG4gICAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgICAuLi4ocmFpbmJvdyA/IHsgYmFja2dyb3VuZDogY29sb3IgfSA6IHsgYmFja2dyb3VuZENvbG9yOiBjb2xvciB9KSxcbiAgICB9XG4gIH1cbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFByZVdyYXBwZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIFNldCBzcGFjaW5nIGJldHdlZW4gcHJlLWVsZW1lbnRzIGluc2lkZSBvZiBtYXJrZG93biBzaW1pbGFyIHRvIG91ciBnYXAgc3BhY2luZyBiZXR3ZWVuIGVsZW1lbnRzXG4gIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVscEljb25XcmFwcGVyID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1ibG9ja1wiLFxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICB0cmFuc2Zvcm06IFwidHJhbnNsYXRlWSgtMC4xZW0pXCIsXG59KVxuIl19 */"), StyledLinkIcon = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr5"
} : {
  target: "e1nzilvr5",
  label: "StyledLinkIcon"
})(({
  theme: CA
}) => ({
  // center icon
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0,
  pointerEvents: "none",
  transition: "opacity 150ms ease-in-out",
  svg: {
    // same color as the tooltip-icon
    stroke: CA.colors.fadedText60,
    strokeWidth: CA.sizes.defaultStrokeWidth
  },
  "&:hover svg": {
    stroke: CA.colors.bodyText
  },
  "&:focus-visible": {
    opacity: 1,
    pointerEvents: "auto"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingWithActionElements = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr4"
} : {
  target: "e1nzilvr4",
  label: "StyledHeadingWithActionElements"
})(({
  theme: CA
}) => ({
  "h1, h2, h3, h4, h5, h6, span": {
    scrollMarginTop: CA.sizes.headerHeight
  },
  ...sharedMarkdownStyle(CA),
  // break-word & pretty makes most headings break in a nicer way than break-all while still
  // preventing overflowing of the container to the side. Long headings without whitespaces or hyphens might still look weird
  wordBreak: "break-word",
  textWrap: "pretty",
  // Show link icon when hovering or when focus is within the heading container.
  // We use opacity instead of visibility so the link remains in the tab order.
  "&:hover, &:focus-within": {
    [StyledLinkIcon]: {
      opacity: 1,
      pointerEvents: "auto"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeadingActionElements = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr3"
} : {
  target: "e1nzilvr3",
  label: "StyledHeadingActionElements"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.sm,
  display: "inline-flex",
  gap: CA.spacing.sm,
  verticalAlign: "middle",
  "& > *": {
    // remove margins of inner elements as they are wrapped in a container that applies the margin
    marginLeft: "0 !important"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderDivider = /* @__PURE__ */ createStyled("hr", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr2"
} : {
  target: "e1nzilvr2",
  label: "StyledHeaderDivider"
})(({
  theme: CA,
  rainbow: gA,
  color: AA
}) => ({
  // Height needs to be !important due to globalStyles.tsx hr height override - line #170
  height: `${CA.spacing.threeXS} !important`,
  marginTop: CA.spacing.sm,
  marginBottom: CA.spacing.none,
  border: "none",
  borderRadius: CA.radii.full,
  ...gA ? {
    background: AA
  } : {
    backgroundColor: AA
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPreWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr1"
} : {
  target: "e1nzilvr1",
  label: "StyledPreWrapper"
})(({
  theme: CA
}) => ({
  // Set spacing between pre-elements inside of markdown similar to our gap spacing between elements
  marginBottom: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHelpIconWrapper = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nzilvr0"
} : {
  target: "e1nzilvr0",
  label: "StyledHelpIconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)"
} : {
  name: "s36o2q",
  styles: "display:inline-block;vertical-align:middle;transform:translateY(-0.1em)/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
}), LOAD_FAILED = /* @__PURE__ */ Symbol("plugin_load_failed"), pluginCache = {
  katex: null,
  raw: null,
  emoji: null
}, loadingPromises = {
  katex: null,
  raw: null,
  emoji: null
}, loadKatexPlugin = () => import("./index-I7jKEriY.js"), loadKatexStyles = once$1(() => {
  Promise.resolve().then(() => katex_min);
}), loadRehypeRaw = () => import("./index-D1kjTmWN.js"), loadRemarkEmoji = () => import("./index-BxCkce84.js");
function isLoadedPlugin(CA) {
  return CA !== null && CA !== LOAD_FAILED;
}
function extractPlugin(CA, gA) {
  const AA = [];
  let IA = CA, BA = 0;
  for (; IA && typeof IA == "object" && "default" in IA && BA < 5; ) {
    const QA = IA.default;
    if (AA.push(QA), QA === IA)
      break;
    IA = QA, BA += 1;
  }
  AA.push(CA);
  for (const QA of AA)
    if (typeof QA == "function")
      return QA;
  return console.warn(`[StreamlitMarkdown] Failed to load ${gA} plugin`), LOAD_FAILED;
}
function wrapRehypePlugin(CA, gA) {
  return (AA) => {
    const IA = CA(AA);
    return (BA, QA) => {
      if (!BA)
        return BA;
      try {
        return IA(BA, QA);
      } catch (EA) {
        return console.error(`[StreamlitMarkdown] ${gA} crashed while transforming`, EA), BA;
      }
    };
  };
}
function wrapRemarkPlugin(CA, gA) {
  return (AA) => {
    const IA = CA(AA);
    return (BA, QA) => {
      if (!BA)
        return BA;
      try {
        return IA(BA, QA);
      } catch (EA) {
        return console.error(`[StreamlitMarkdown] ${gA} crashed while transforming`, EA), BA;
      }
    };
  };
}
function useLazyPlugin(CA) {
  const {
    key: gA,
    needed: AA,
    load: IA,
    pluginName: BA,
    onBeforeLoad: QA
  } = CA, EA = AA ? pluginCache[gA] : null, [iA, oA] = useState(null);
  return useEffect(() => {
    if (!AA || EA || iA)
      return;
    const cA = loadingPromises[gA];
    if (cA) {
      let aA = !1;
      return cA.then((GA) => {
        aA || oA(() => GA);
      }), () => {
        aA = !0;
      };
    }
    QA?.();
    let tA = !1;
    const eA = IA().then((aA) => extractPlugin(aA, BA)).then((aA) => (pluginCache[gA] = aA, tA || oA(() => aA), aA)).catch(() => {
      const aA = LOAD_FAILED;
      return pluginCache[gA] = aA, tA || oA(() => aA), aA;
    }).finally(() => {
      loadingPromises[gA] = null;
    });
    return loadingPromises[gA] = eA, () => {
      tA = !0;
    };
  }, [AA, EA, iA, gA, IA, BA, QA]), AA ? EA ?? iA : null;
}
const StreamlitSyntaxHighlighter$1 = lazy(() => import("./StreamlitSyntaxHighlighter-U8o3ATK-.js"));
function containsEmojiShortcodes(CA) {
  return /:(?!material\/|streamlit:)[\w+-][\w_+-]*:/.test(CA);
}
function containsMathSyntax(CA) {
  return new RegExp("\\$\\$[\\s\\S]+?\\$\\$|\\$(?!\\s)[^$\\n]+?(?<!\\s)\\$").test(CA);
}
var Tags = /* @__PURE__ */ ((CA) => (CA.H1 = "h1", CA.H2 = "h2", CA.H3 = "h3", CA))(Tags || {});
function rehypeSetCodeInlineProperty() {
  return (CA) => {
    visit(CA, "element", (gA, AA, IA) => {
      gA.tagName === "code" && (IA?.type === "element" && IA.tagName === "pre" ? gA.properties = {
        ...gA.properties,
        inline: !1
      } : gA.properties = {
        ...gA.properties,
        inline: !0
      });
    });
  };
}
function createAnchorFromText(CA) {
  if (!CA)
    return "";
  const gA = slugify(CA);
  return gA.length > 0 ? gA : xxhash.h32(CA, 43981).toString(16);
}
function transformLinkUri(CA) {
  return CA;
}
const scrollNodeIntoView = once$1((CA) => {
  CA.scrollIntoView(!0);
}), HeaderActionElements = ({
  elementId: CA,
  help: gA,
  hideAnchor: AA
}) => {
  const IA = useEmotionTheme();
  return !gA && AA ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeadingActionElements, { "data-testid": "stHeaderActionElements", children: [
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: gA }),
    CA && !AA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkIcon, { href: `#${CA}`, "aria-label": "Link to heading", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Link2,
      {
        size: convertRemToPx(IA.iconSizes.base),
        "aria-hidden": "true"
      }
    ) })
  ] });
}, HeadingWithActionElements = ({
  tag: CA,
  anchor: gA,
  help: AA,
  hideAnchor: IA,
  children: BA,
  tagProps: QA
}) => {
  const EA = useContext(IsSidebarContext), iA = useContext(IsDialogContext), [oA, cA] = useState(gA), tA = useCallback((NA) => {
    if (NA === null)
      return;
    const rA = gA || createAnchorFromText(NA.textContent);
    cA(rA);
    const yA = window.location.hash.slice(1);
    yA && yA === rA && scrollNodeIntoView(NA);
  }, [gA]), eA = EA || iA, aA = /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderActionElements, { elementId: oA, help: AA, hideAnchor: IA || eA }), GA = useId(), lA = AA || oA && !IA && !eA ? GA : void 0, nA = oA ? {
    id: oA
  } : {}, DA = lA ? {
    "aria-labelledby": lA
  } : {}, hA = {
    ...eA ? {} : {
      ref: tA,
      ...nA
    },
    ...DA
  }, wA = CA, sA = /* @__PURE__ */ jsxRuntimeExports.jsxs(wA, { ...QA, ...hA, children: [
    lA ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { id: lA, children: BA }) : BA,
    aA
  ] });
  return eA ? sA : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeadingWithActionElements, { "data-testid": "stHeadingWithActionElements", children: sA });
}, CustomHeading = ({
  node: CA,
  children: gA,
  ...AA
}) => {
  const IA = AA["data-anchor"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { tag: CA.tagName, anchor: IA, tagProps: AA, children: gA });
}, CustomCodeTag = ({
  inline: CA,
  className: gA,
  children: AA,
  ...IA
}) => {
  const BA = /language-(\w+)/.exec(gA || ""), QA = String(AA ?? "").replace(/^\n/, "").replace(/\n$/, ""), EA = BA?.[1] || "";
  return CA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineCode, { className: gA, ...omit(IA, "node"), children: AA }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter$1, { language: EA, showLineNumbers: !1, children: QA }) }) });
}, CustomPreTag = ({
  children: CA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPreWrapper, { "data-testid": "stMarkdownPre", children: CA }), CustomMediaTag = ({
  node: CA,
  ...gA
}) => {
  const AA = useCrossOriginAttribute(gA.src), IA = CA.tagName, BA = {
    ...gA,
    crossOrigin: AA
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IA, { ...BA });
}, HelpTextContext = createContext(void 0);
HelpTextContext.displayName = "HelpTextContext";
const CustomHelpIcon = ({
  children: CA
}) => {
  const AA = useContext(HelpTextContext) || (typeof CA == "string" ? CA : "");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHelpIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: AA }) });
}, BASE_RENDERERS = {
  pre: CustomPreTag,
  code: CustomCodeTag,
  h1: CustomHeading,
  h2: CustomHeading,
  h3: CustomHeading,
  h4: CustomHeading,
  h5: CustomHeading,
  h6: CustomHeading,
  img: CustomMediaTag,
  video: CustomMediaTag,
  audio: CustomMediaTag,
  "streamlit-help-icon": CustomHelpIcon
};
function createColorMapping(CA) {
  const {
    red: gA,
    orange: AA,
    yellow: IA,
    green: BA,
    blue: QA,
    violet: EA,
    purple: iA,
    gray: oA,
    primary: cA
  } = getMarkdownTextColors(CA), {
    redbg: tA,
    orangebg: eA,
    yellowbg: aA,
    greenbg: GA,
    bluebg: lA,
    violetbg: nA,
    purplebg: DA,
    graybg: hA,
    primarybg: wA
  } = getThemeBackgroundColors(CA);
  return new Map(Object.entries({
    red: `color: ${gA}`,
    orange: `color: ${AA}`,
    yellow: `color: ${IA}`,
    blue: `color: ${QA}`,
    green: `color: ${BA}`,
    violet: `color: ${EA}`,
    gray: `color: ${oA}`,
    grey: `color: ${oA}`,
    primary: `color: ${cA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    rainbow: `color: transparent; background-clip: text; -webkit-background-clip: text; background-image: linear-gradient(to right,
        ${gA}, ${AA}, ${IA}, ${BA}, ${QA}, ${EA}, ${iA});`,
    "red-background": `background-color: ${tA}`,
    "orange-background": `background-color: ${eA}`,
    "yellow-background": `background-color: ${aA}`,
    "blue-background": `background-color: ${lA}`,
    "green-background": `background-color: ${GA}`,
    "violet-background": `background-color: ${nA}`,
    "gray-background": `background-color: ${hA}`,
    "grey-background": `background-color: ${hA}`,
    "primary-background": `background-color: ${wA}`,
    // Gradient from red, orange, yellow, green, blue, violet, purple
    "rainbow-background": `background: linear-gradient(to right,
        ${tA}, ${eA}, ${aA}, ${GA}, ${lA}, ${nA}, ${DA});`
  }));
}
function createRemarkHelpIcon() {
  return () => (CA) => (visit(CA, "textDirective", (gA, AA, IA) => {
    if (String(gA.name) === "help") {
      const QA = gA.data || (gA.data = {});
      QA.hName = "streamlit-help-icon", QA.hProperties = QA.hProperties || {};
      return;
    }
  }), CA);
}
function isValidCssColor(CA) {
  if (!CA) return !1;
  try {
    return parseToRgba(CA), !0;
  } catch {
    return !1;
  }
}
function createRemarkColoringAndSmall(CA, gA) {
  return () => (AA) => (visit(AA, "textDirective", (IA, BA, QA) => {
    const EA = String(IA.name);
    if (EA === "small") {
      const oA = IA.data || (IA.data = {});
      oA.hName = "span", oA.hProperties = oA.hProperties || {}, oA.hProperties.style = `font-size: ${CA.fontSizes.sm};`;
      return;
    }
    if (EA === "color" && IA.attributes) {
      const {
        foreground: oA,
        background: cA
      } = IA.attributes, tA = oA && isValidCssColor(oA), eA = cA && isValidCssColor(cA), aA = IA.data || (IA.data = {});
      if (aA.hName = "span", aA.hProperties = aA.hProperties || {}, tA || eA) {
        const GA = [];
        tA && GA.push(`color: ${oA}`), eA && GA.push(`background-color: ${cA}`);
        const lA = eA ? "stMarkdownColoredBackground" : "stMarkdownColoredText";
        aA.hProperties.style = GA.join("; "), aA.hProperties.className = lA;
      }
      return;
    }
    const iA = EA.match(/^(.+)-badge$/);
    if (iA && gA.has(iA[1])) {
      const oA = iA[1];
      if (oA === "rainbow")
        return;
      const cA = gA.get(oA), tA = gA.get(`${oA}-background`);
      if (cA && tA) {
        const eA = IA.data || (IA.data = {});
        eA.hName = "span", eA.hProperties = eA.hProperties || {}, eA.hProperties.className = "stMarkdownBadge", eA.hProperties.style = `${tA}; ${cA}; font-size: ${CA.fontSizes.sm};`;
        return;
      }
    }
    if (gA.has(EA)) {
      const oA = IA.data || (IA.data = {}), cA = gA.get(EA);
      oA.hName = "span", oA.hProperties = oA.hProperties || {}, oA.hProperties.style = cA, oA.hProperties.className = "stMarkdownColoredText", cA && (/background-color:/.test(cA) || /background:/.test(cA)) && (oA.hProperties.className = "stMarkdownColoredBackground");
      return;
    }
  }), AA);
}
function createRemarkUnsupportedDirectivesCleanup() {
  return () => (CA) => (visit(CA, "textDirective", (gA, AA, IA) => {
    if (!gA.data?.hName && IA && AA !== void 0) {
      const BA = {
        type: "text",
        value: `:${gA.name}`
      };
      IA.children[AA] = BA;
    }
  }), CA);
}
function createRemarkMaterialIcons(CA) {
  return () => (gA) => {
    function AA(IA, BA) {
      return {
        type: "text",
        value: IA,
        data: {
          hName: "span",
          hProperties: {
            role: "img",
            ariaLabel: BA + " icon",
            // Prevent the icon text from being translated
            // this would break the icon display in the UI.
            // https://github.com/streamlit/streamlit/issues/10168
            translate: "no",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            style: `
            display: inline-block;
            font-family: ${CA.genericFonts.iconFont};
            font-weight: ${CA.fontWeights.normal};
            user-select: none;
            vertical-align: bottom;
            white-space: nowrap;
            word-wrap: normal;
            `
          },
          hChildren: [{
            type: "text",
            value: BA
          }]
        }
      };
    }
    return findAndReplace(gA, [[/:material_(\w+):/g, AA]]), gA;
  };
}
function createRemarkStreamlitLogo() {
  return () => (CA) => {
    function gA() {
      return {
        type: "text",
        value: "",
        data: {
          hName: "img",
          hProperties: {
            src: streamlitLogo,
            alt: "Streamlit logo",
            // We need to use string-style CSS here so that it works
            // correctly with the rehype-raw plugin.
            // The base of the Streamlit logo is curved, so move it down a bit to
            // make it look aligned with the text.
            style: "display: inline-block; user-select: none; height: 0.75em; vertical-align: baseline; margin-bottom: -0.05ex;"
          }
        }
      };
    }
    return findAndReplace(CA, [[/:streamlit:/g, gA]]), CA;
  };
}
function createRemarkTypographicalSymbols() {
  return () => (CA) => (visit(CA, (gA, AA, IA) => {
    if (!(IA && (IA.type === "link" || IA.type === "linkReference")) && gA.type === "text" && gA.value) {
      const BA = [[/(^|\s)<->(\s|$)/g, "$1↔$2"], [/(^|\s)->(\s|$)/g, "$1→$2"], [/(^|\s)<-(\s|$)/g, "$1←$2"], [/(^|\s)--(\s|$)/g, "$1—$2"], [/(^|\s)>=(\s|$)/g, "$1≥$2"], [/(^|\s)<=(\s|$)/g, "$1≤$2"], [/(^|\s)~=(\s|$)/g, "$1≈$2"]];
      let QA = gA.value;
      for (const [EA, iA] of BA)
        QA = QA.replace(EA, iA);
      QA !== gA.value && (gA.value = QA);
    }
  }), CA);
}
const directiveCompletionHandler = {
  name: "streamlit-directives",
  priority: 10,
  handle: (CA) => {
    const gA = /:[a-z][a-z0-9-]*\[/, AA = gA.exec(CA);
    if (!AA)
      return CA;
    let IA = 1, BA = AA.index + AA[0].length;
    for (; BA < CA.length; ) {
      const QA = CA[BA];
      if (QA === "[" && IA > 0) {
        IA += 1, BA += 1;
        continue;
      }
      if (QA === "]" && IA > 0) {
        IA -= 1, BA += 1;
        continue;
      }
      if (QA === ":") {
        const EA = CA.slice(BA), iA = gA.exec(EA);
        if (iA?.index === 0) {
          IA += 1, BA += iA[0].length;
          continue;
        }
      }
      BA += 1;
    }
    return IA > 0 ? CA + "]".repeat(IA) : CA;
  }
}, REMEND_OPTIONS = {
  handlers: [directiveCompletionHandler]
}, BASE_REMARK_PLUGINS = [remarkMath, remarkGfm, remarkDirective, createRemarkHelpIcon(), createRemarkStreamlitLogo(), createRemarkTypographicalSymbols()], LABEL_DISALLOWED_ELEMENTS = [
  // Restricts table elements, headings, unordered/ordered lists, task lists, horizontal rules, & blockquotes
  // Note that images are allowed but have a max height equal to the text height
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "input",
  "hr",
  "blockquote"
], LINKS_DISALLOWED_ELEMENTS = [...LABEL_DISALLOWED_ELEMENTS, "a"];
function LinkWithTargetBlank(CA) {
  const {
    href: gA
  } = CA;
  if (gA?.startsWith("#")) {
    const {
      children: iA,
      ...oA
    } = CA;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { ...omit(oA, "node"), children: iA });
  }
  const {
    title: AA,
    children: IA,
    target: BA,
    rel: QA,
    ...EA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: gA, title: AA, target: BA || "_blank", rel: QA || "noopener noreferrer", ...omit(EA, "node"), children: IA });
}
const RenderedMarkdown = memo(function CA({
  allowHTML: gA,
  source: AA,
  overrideComponents: IA,
  isLabel: BA,
  disableLinks: QA,
  helpText: EA,
  unterminatedParsing: iA
}) {
  const oA = useEmotionTheme(), cA = useMemo$1(() => containsMathSyntax(AA), [AA]), tA = useMemo$1(() => containsEmojiShortcodes(AA), [AA]), eA = useLazyPlugin({
    key: "katex",
    needed: cA,
    load: loadKatexPlugin,
    pluginName: "rehype-katex",
    onBeforeLoad: loadKatexStyles
  }), aA = useLazyPlugin({
    key: "raw",
    needed: gA,
    load: loadRehypeRaw,
    pluginName: "rehype-raw"
  }), GA = useLazyPlugin({
    key: "emoji",
    needed: tA,
    load: loadRemarkEmoji,
    pluginName: "remark-emoji"
  }), lA = useMemo$1(() => createColorMapping(oA), [oA]), nA = useMemo$1(() => isLoadedPlugin(eA) ? wrapRehypePlugin(eA, "rehype-katex") : null, [eA]), DA = useMemo$1(() => isLoadedPlugin(aA) ? wrapRehypePlugin(aA, "rehype-raw") : null, [aA]), hA = useMemo$1(() => isLoadedPlugin(GA) ? (
    // Cast needed: unified's Plugin type is more complex than our RemarkPluginFactory wrapper
    wrapRemarkPlugin(GA, "remark-emoji")
  ) : null, [GA]), wA = useMemo$1(() => {
    const RA = [...BASE_REMARK_PLUGINS, createRemarkColoringAndSmall(oA, lA), createRemarkMaterialIcons(oA)];
    return tA && hA && RA.push(hA), RA.push(createRemarkUnsupportedDirectivesCleanup()), RA;
  }, [oA, lA, tA, hA]), sA = useMemo$1(() => {
    const RA = [];
    return cA && nA && RA.push(nA), gA && DA && RA.push(DA), RA.push(rehypeSetCodeInlineProperty), RA;
  }, [gA, cA, nA, DA]), NA = useMemo$1(() => ({
    ...BASE_RENDERERS,
    a: LinkWithTargetBlank,
    ...IA
  }), [IA]), rA = useMemo$1(() => {
    let RA = AA.replaceAll(":material/", ":material_");
    return BA && (RA = RA.replace(/^(\s*)((?:[+\-*]|#+)(?=\s|$)|>)/gm, "$1\\$2"), RA = RA.replace(/^(\s*)(\d+)([.)])(?=\s|$)/gm, "$1$2\\$3")), iA && !BA && !gA && (RA = $e(RA, REMEND_OPTIONS)), RA;
  }, [AA, BA, gA, iA]), yA = useMemo$1(() => BA ? QA ? LINKS_DISALLOWED_ELEMENTS : LABEL_DISALLOWED_ELEMENTS : [], [BA, QA]);
  return cA && eA === null || gA && aA === null || tA && GA === null ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(HelpTextContext.Provider, { value: EA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Markdown$2,
    {
      remarkPlugins: wA,
      rehypePlugins: sA,
      components: NA,
      urlTransform: transformLinkUri,
      disallowedElements: yA,
      unwrapDisallowed: !0,
      children: rA
    }
  ) }) });
}), StreamlitMarkdown = ({
  source: CA,
  allowHTML: gA,
  style: AA,
  isCaption: IA,
  isLabel: BA,
  boldLabel: QA,
  largerLabel: EA,
  disableLinks: iA,
  isToast: oA,
  inheritFont: cA,
  helpText: tA,
  truncate: eA,
  unterminatedParsing: aA
}) => {
  const GA = useContext(IsDialogContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStreamlitMarkdown, { isCaption: !!IA, isInDialog: GA, isLabel: BA, inheritFont: cA, boldLabel: QA, largerLabel: EA, isToast: oA, truncate: eA, style: AA, "data-testid": IA ? "stCaptionContainer" : "stMarkdownContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: CA, allowHTML: gA, isLabel: BA, disableLinks: iA, helpText: tA, unterminatedParsing: aA }) });
}, StreamlitMarkdown$1 = memo(StreamlitMarkdown), StyledDialogTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke331"
} : {
  target: "eh5ke331",
  label: "StyledDialogTitle"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  gap: CA.spacing.sm,
  // Add right margin to prevent overlap with close button
  marginRight: CA.spacing.threeXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nSWNvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBmbGV4U2hyaW5rOiAwLFxufSkpXG4iXX0= */"), StyledDialogIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eh5ke330"
} : {
  target: "eh5ke330",
  label: "StyledDialogIcon"
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9EaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJnQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9saWIvc3JjL2NvbXBvbmVudHMvZWxlbWVudHMvRGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREaWFsb2dUaXRsZSA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgLy8gQWRkIHJpZ2h0IG1hcmdpbiB0byBwcmV2ZW50IG92ZXJsYXAgd2l0aCBjbG9zZSBidXR0b25cbiAgbWFyZ2luUmlnaHQ6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRGlhbG9nSWNvbiA9IHN0eWxlZC5kaXYoKCkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICBmbGV4U2hyaW5rOiAwLFxufSkpXG4iXX0= */");
function mapDialogWidthToModalSize(CA) {
  switch (CA) {
    case Block$1.Dialog.DialogWidth.MEDIUM:
      return "medium";
    case Block$1.Dialog.DialogWidth.LARGE:
      return "large";
    case Block$1.Dialog.DialogWidth.SMALL:
      return "default";
    default:
      return assertNever(CA), "default";
  }
}
const Dialog = ({
  element: CA,
  deltaMsgReceivedAt: gA,
  children: AA,
  widgetMgr: IA,
  fragmentId: BA
}) => {
  const {
    title: QA,
    dismissible: EA,
    width: iA,
    isOpen: oA,
    id: cA,
    icon: tA
  } = CA, [eA, aA] = useState(!1);
  useEffect(() => {
    notNullOrUndefined(oA) && aA(oA);
  }, [oA, gA]);
  const GA = useCallback(() => {
    aA(!1), cA && IA && IA.setTriggerValue(
      {
        id: cA,
        formId: ""
      },
      // WidgetInfo object - dialogs are not compatible with forms
      {
        fromUi: !0
      },
      BA
    );
  }, [cA, IA, BA]), lA = useCallback((nA) => {
    if (eA && nA.key.toLowerCase() === "r" && !CA.dismissible) {
      const DA = nA.target;
      if (DA && (DA.isContentEditable || DA.tagName === "INPUT" || DA.tagName === "TEXTAREA" || DA.tagName === "SELECT"))
        return;
      nA.preventDefault(), nA.stopPropagation();
    }
  }, [eA, CA.dismissible]);
  return useEffect(() => {
    if (eA && !CA.dismissible)
      return document.addEventListener("keydown", lA, !0), () => {
        document.removeEventListener("keydown", lA, !0);
      };
  }, [eA, CA.dismissible, lA]), eA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: EA, onClose: GA, size: mapDialogWidthToModalSize(iA), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogTitle, { children: [
      tA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDialogIcon, { "data-testid": "stDialogIcon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: tA, size: "lg" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: QA, allowHTML: !1, isLabel: !0, inheritFont: !0 })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: AA })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
function DialogWithProvider(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsDialogContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog, { ...CA }) });
}
const Dialog$1 = memo(DialogWithProvider);
class FormClearHelper {
  /**
   * Register the listener that will be called when the widget's form is cleared.
   * This should be called in the `render` function of every class-based widget
   * element - it mimics the behavior of a `useEffect` hook, and ensures that
   * subscription and unsubscription happen correctly.
   *
   * Hooks-based widgets can just use `useEffect` and call
   * `widgetMgr.addFormClearedListener` directly. Or just use the convenient
   * hook `useFormClearHelper`, below.
   */
  manageFormClearListener(gA, AA, IA) {
    notNullOrUndefined(this.formClearListener) && this.lastWidgetMgr === gA && this.lastFormId === AA || (this.disconnect(), isValidFormId(AA) && (this.formClearListener = gA.addFormClearedListener(AA, IA), this.lastWidgetMgr = gA, this.lastFormId = AA));
  }
  /**
   * Disconnect from the form-clear signal, if we're connected.
   * This should be called from the `componentWillUnmount` function of every
   * element that uses it.
   */
  disconnect() {
    this.formClearListener?.disconnect(), this.formClearListener = void 0, this.lastWidgetMgr = void 0, this.lastFormId = void 0;
  }
}
function useFormClearHelper({
  element: CA,
  widgetMgr: gA,
  onFormCleared: AA
}) {
  useEffect(() => {
    if (!gA || !isValidFormId(CA.formId))
      return;
    const IA = gA.addFormClearedListener(CA.formId, AA);
    return () => {
      IA.disconnect();
    };
  }, [CA, gA, AA]);
}
const useWidgetManagerElementState = ({
  widgetMgr: CA,
  id: gA,
  formId: AA,
  key: IA,
  defaultValue: BA
}) => {
  useEffect(() => {
    const tA = CA.getElementState(gA, IA);
    isNullOrUndefined$1(tA) && notNullOrUndefined(BA) && CA.setElementState(gA, IA, BA);
  }, [CA, gA, IA, BA]);
  const [QA, EA] = useState(CA.getElementState(gA, IA) ?? BA), iA = useCallback((tA) => {
    CA.setElementState(gA, IA, tA), EA(tA);
  }, [CA, gA, IA]), oA = useMemo$1(() => ({
    formId: AA || ""
  }), [AA]), cA = useCallback(() => iA(BA), [BA, iA]);
  return useFormClearHelper({
    element: oA,
    widgetMgr: CA,
    onFormCleared: cA
  }), [QA, iA];
}, STALE_TRANSITION_PARAMS = "1s ease-in 0.5s", STALE_STYLES = {
  opacity: 0.33,
  transition: `opacity ${STALE_TRANSITION_PARAMS}`
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$d() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledExpandableContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx5"
} : {
  target: "eqpbllx5",
  label: "StyledExpandableContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), BORDER_SIZE = 1, StyledDetails = /* @__PURE__ */ createStyled("details", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx4"
} : {
  target: "eqpbllx4",
  label: "StyledDetails"
})(({
  isStale: CA,
  theme: gA
}) => ({
  marginBottom: 0,
  marginTop: 0,
  width: "100%",
  borderStyle: "solid",
  borderWidth: gA.sizes.borderWidth,
  borderColor: gA.colors.borderColor,
  borderRadius: gA.radii.default,
  ...CA ? {
    borderColor: gA.colors.borderColorLight,
    transition: `border ${STALE_TRANSITION_PARAMS}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryHeading = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx3"
} : {
  target: "eqpbllx3",
  label: "StyledSummaryHeading"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  gap: CA.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSummaryLabelWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx2"
} : {
  target: "eqpbllx2",
  label: "StyledSummaryLabelWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden"
} : {
  name: "xomnir",
  styles: "display:flex;width:100%;flex-grow:1;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
}), StyledSummary = /* @__PURE__ */ createStyled("summary", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx1"
} : {
  target: "eqpbllx1",
  label: "StyledSummary"
})(({
  theme: CA,
  isStale: gA,
  expanded: AA
}) => ({
  position: "relative",
  display: "flex",
  width: "100%",
  // Prevent chevron/user icon from overlapping content by ensuring
  // children can shrink and the summary can clip excess inline overflow.
  minWidth: 0,
  overflow: "hidden",
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRing
  },
  fontSize: "inherit",
  paddingLeft: CA.spacing.md,
  paddingRight: CA.spacing.md,
  paddingTop: CA.spacing.twoXS,
  paddingBottom: CA.spacing.twoXS,
  minHeight: `calc(${CA.sizes.minElementHeight} - 2 * ${CA.sizes.borderWidth})`,
  alignItems: "center",
  cursor: "pointer",
  listStyleType: "none",
  "&::-webkit-details-marker": {
    display: "none"
  },
  backgroundColor: AA ? CA.colors.bgMix : "transparent",
  // When expanded, only round the top corners
  borderRadius: AA ? `${CA.radii.default} ${CA.radii.default} 0 0` : CA.radii.default,
  // Animate border-radius changes when expanding/collapsing to match the animation of
  // the expander content. Use a delay when collapsing because the content first needs
  // to slide up.
  transition: AA ? "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1), background-color 150ms ease" : "border-radius 200ms cubic-bezier(0.23, 1, 0.32, 1) 300ms, background-color 150ms ease",
  "&:hover, &:focus-visible": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:active": {
    backgroundColor: CA.colors.darkenedBgMix25
  },
  ...gA && STALE_STYLES
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDetailsPanel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eqpbllx0"
} : {
  target: "eqpbllx0",
  label: "StyledDetailsPanel"
})(({
  theme: CA
}) => ({
  padding: CA.spacing.lg,
  borderTop: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), DEFAULT_DURATION = 500, DEFAULT_EASING = "cubic-bezier(0.23, 1, 0.32, 1)";
function animateHeight(CA, gA, AA, IA = {}) {
  const {
    duration: BA = DEFAULT_DURATION,
    easing: QA = DEFAULT_EASING,
    onFinish: EA
  } = IA, iA = CA.animate({
    height: [`${gA}px`, `${AA}px`]
  }, {
    duration: BA,
    easing: QA
  }), oA = new Promise((cA) => {
    iA.addEventListener("finish", () => {
      CA.style.height = "", CA.style.overflow = "", EA?.(), cA();
    }), iA.addEventListener("cancel", () => {
      cA();
    });
  });
  return {
    cancel: () => iA.cancel(),
    finished: oA
  };
}
const RESIZE_DEBOUNCE_MS = 10, RESIZE_THRESHOLD_PX = 5;
function useDetailsAnimation({
  backendExpanded: CA,
  label: gA,
  onToggle: AA
}) {
  const [IA, BA] = useState(CA ?? !1), QA = useRef(null), EA = useRef(null), iA = useRef(null), oA = useRef(null), cA = useRef(IA), tA = useRef(gA), eA = useRef(!1), aA = useCallback(() => {
    oA.current?.cancel(), oA.current = null;
  }, []), GA = useCallback((wA) => {
    const sA = QA.current, NA = EA.current, rA = iA.current;
    if (!sA || !NA)
      return;
    const yA = sA.getBoundingClientRect().height, bA = NA.getBoundingClientRect().height;
    if (aA(), sA.style.height = `${yA}px`, sA.style.overflow = "hidden", wA) {
      sA.open = !0;
      const RA = rA?.getBoundingClientRect().height ?? 0;
      if (RA > 0) {
        const FA = bA + RA + 2 * BORDER_SIZE;
        oA.current = animateHeight(sA, yA, FA);
      }
    } else {
      const RA = bA + 2 * BORDER_SIZE;
      oA.current = animateHeight(sA, yA, RA, {
        onFinish: () => {
          QA.current && (QA.current.open = !1);
        }
      });
    }
  }, [aA]), lA = useCallback((wA, sA) => {
    const NA = QA.current;
    NA && (aA(), NA.style.height = `${wA}px`, NA.style.overflow = "hidden", oA.current = animateHeight(NA, wA, sA));
  }, [aA]), {
    clear: nA,
    restart: DA
  } = useTimeout(() => {
    const wA = iA.current, sA = QA.current, NA = EA.current;
    if (!wA || !sA || !NA || !sA.open || !cA.current)
      return;
    const rA = wA.getBoundingClientRect().height, yA = NA.getBoundingClientRect().height, bA = sA.getBoundingClientRect().height, RA = yA + rA + 2 * BORDER_SIZE;
    Math.abs(bA - RA) > RESIZE_THRESHOLD_PX && lA(bA, RA);
  }, RESIZE_DEBOUNCE_MS, {
    autoStart: !1
  });
  useEffect(() => {
    const wA = !eA.current;
    eA.current = !0;
    const sA = gA !== tA.current;
    if (tA.current = gA, sA) {
      aA();
      const NA = CA ?? !1;
      cA.current = NA, BA(NA), QA.current && (QA.current.style.height = "", QA.current.style.overflow = "", QA.current.open = NA);
      return;
    }
    if (!isNullOrUndefined$1(CA)) {
      if (wA) {
        QA.current && (QA.current.open = CA);
        return;
      }
      CA !== cA.current && (cA.current = CA, BA(CA), GA(CA));
    }
  }, [CA, gA, aA, GA]), useEffect(() => {
    const wA = iA.current, sA = QA.current;
    if (!wA || !sA)
      return;
    const NA = new ResizeObserver(() => {
      sA.open && DA();
    });
    return NA.observe(wA), () => {
      NA.disconnect(), nA();
    };
  }, [nA, DA]), useEffect(() => () => {
    aA(), nA();
  }, [aA, nA]);
  const hA = useCallback((wA) => {
    wA.preventDefault();
    const sA = !cA.current;
    cA.current = sA, BA(sA), GA(sA), AA?.(sA);
  }, [AA, GA]);
  return {
    isOpen: IA,
    detailsRef: QA,
    summaryRef: EA,
    contentRef: iA,
    handleToggle: hA
  };
}
const ExpanderIcon = (CA) => {
  const {
    icon: gA
  } = CA, AA = {
    ":material/check:": "stExpanderIconCheck",
    ":material/error:": "stExpanderIconError",
    spinner: "stExpanderIconSpinner"
  };
  return gA ? /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: gA, testid: AA[gA] || "stExpanderIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
}, Expander = ({
  element: CA,
  isStale: gA,
  widgetMgr: AA,
  blockId: IA,
  fragmentId: BA,
  children: QA
}) => {
  const {
    label: EA,
    icon: iA
  } = CA, [oA, cA] = useState(!1), tA = CA.id || void 0, eA = !!(AA && tA), aA = !!IA && !eA, [GA, lA] = useWidgetManagerElementState({
    widgetMgr: AA,
    id: aA ? IA ?? "" : "",
    key: "expanded",
    defaultValue: CA.expanded ?? !1
  }), nA = aA ? GA : CA.expanded, DA = useCallback((pA) => {
    AA && tA && AA.setBoolValue({
      id: tA
    }, pA, {
      fromUi: !0
    }, BA);
  }, [AA, tA, BA]), hA = useCallback((pA) => {
    lA(pA);
  }, [lA]), wA = eA ? DA : aA ? hA : void 0, {
    isOpen: sA,
    detailsRef: NA,
    summaryRef: rA,
    contentRef: yA,
    handleToggle: bA
  } = useDetailsAnimation({
    backendExpanded: nA,
    label: EA,
    onToggle: wA
  }), RA = !iA || oA, FA = iA && !oA, dA = () => {
    cA(!0);
  }, kA = () => {
    cA(!1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExpandableContainer, { className: "stExpander", "data-testid": "stExpander", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDetails, { isStale: gA, ref: NA, onMouseEnter: dA, onMouseLeave: kA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummary, { onClick: bA, ref: rA, isStale: gA, expanded: sA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSummaryHeading, { children: [
      RA && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: sA ? ":material/keyboard_arrow_down:" : ":material/keyboard_arrow_right:", size: "lg" }),
      FA && /* @__PURE__ */ jsxRuntimeExports.jsx(ExpanderIcon, { icon: iA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSummaryLabelWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: EA, allowHTML: !1, isLabel: !0, largerLabel: !0 }) })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledDetailsPanel,
      {
        "data-testid": "stExpanderDetails",
        ref: yA,
        inert: sA ? void 0 : "",
        children: QA
      }
    )
  ] }) });
}, Expander$1 = memo(Expander), Box = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "epl6yf30"
} : {
  target: "epl6yf30",
  label: "Box"
})(({
  width: CA = "100%",
  height: gA
}) => ({
  width: CA,
  height: gA
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getPopoverContainerStyle = (CA) => {
  const gA = hasLightBackgroundColor(CA);
  return {
    boxSizing: "border-box",
    borderTopLeftRadius: CA.radii.default,
    borderTopRightRadius: CA.radii.default,
    borderBottomRightRadius: CA.radii.default,
    borderBottomLeftRadius: CA.radii.default,
    // Always use same border width - in light mode, match background
    // so we don't need to adjust for pixel shifts
    borderWidth: CA.sizes.borderWidth,
    borderStyle: "solid",
    borderColor: gA ? CA.colors.bgColor : CA.colors.borderColor,
    // Only show shadow in light mode
    boxShadow: gA ? CA.shadows.popover : CA.shadows.none
  };
}, getBorderColor = (CA, gA) => {
  let AA = CA.widgetBorderColor ?? CA.secondaryBg;
  return gA && (AA = CA.primary), AA;
};
function BaseButtonTooltip({
  children: CA,
  help: gA,
  placement: AA,
  containerWidth: IA
}) {
  return gA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipNormal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipIcon, { content: gA, placement: AA || Placement.TOP, containerWidth: IA, children: CA }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTooltipMobile, { children: CA })
  ] }) : CA;
}
const isff = typeof navigator < "u" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1;
function addEvent(CA, gA, AA, IA) {
  CA.addEventListener ? CA.addEventListener(gA, AA, IA) : CA.attachEvent && CA.attachEvent("on".concat(gA), AA);
}
function removeEvent(CA, gA, AA, IA) {
  CA.removeEventListener ? CA.removeEventListener(gA, AA, IA) : CA.detachEvent && CA.detachEvent("on".concat(gA), AA);
}
function getMods(CA, gA) {
  const AA = gA.slice(0, gA.length - 1);
  for (let IA = 0; IA < AA.length; IA++) AA[IA] = CA[AA[IA].toLowerCase()];
  return AA;
}
function getKeys(CA) {
  typeof CA != "string" && (CA = ""), CA = CA.replace(/\s/g, "");
  const gA = CA.split(",");
  let AA = gA.lastIndexOf("");
  for (; AA >= 0; )
    gA[AA - 1] += ",", gA.splice(AA, 1), AA = gA.lastIndexOf("");
  return gA;
}
function compareArray(CA, gA) {
  const AA = CA.length >= gA.length ? CA : gA, IA = CA.length >= gA.length ? gA : CA;
  let BA = !0;
  for (let QA = 0; QA < AA.length; QA++)
    IA.indexOf(AA[QA]) === -1 && (BA = !1);
  return BA;
}
const _keyMap = {
  backspace: 8,
  "⌫": 8,
  tab: 9,
  clear: 12,
  enter: 13,
  "↩": 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  /// https://w3c.github.io/uievents/#events-keyboard-key-location
  arrowup: 38,
  arrowdown: 40,
  arrowleft: 37,
  arrowright: 39,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": isff ? 173 : 189,
  "=": isff ? 61 : 187,
  ";": isff ? 59 : 186,
  "'": 222,
  "{": 219,
  "}": 221,
  "[": 219,
  "]": 221,
  "\\": 220
}, _modifier = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  meta: 91,
  command: 91
}, modifierMap = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, _mods = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, _handlers = {};
for (let CA = 1; CA < 20; CA++)
  _keyMap["f".concat(CA)] = 111 + CA;
let _downKeys = [], winListendFocus = null, _scope = "all";
const elementEventMap = /* @__PURE__ */ new Map(), code = (CA) => _keyMap[CA.toLowerCase()] || _modifier[CA.toLowerCase()] || CA.toUpperCase().charCodeAt(0), getKey = (CA) => Object.keys(_keyMap).find((gA) => _keyMap[gA] === CA), getModifier = (CA) => Object.keys(_modifier).find((gA) => _modifier[gA] === CA);
function setScope(CA) {
  _scope = CA || "all";
}
function getScope() {
  return _scope || "all";
}
function getPressedKeyCodes() {
  return _downKeys.slice(0);
}
function getPressedKeyString() {
  return _downKeys.map((CA) => getKey(CA) || getModifier(CA) || String.fromCharCode(CA));
}
function getAllKeyCodes() {
  const CA = [];
  return Object.keys(_handlers).forEach((gA) => {
    _handlers[gA].forEach((AA) => {
      let {
        key: IA,
        scope: BA,
        mods: QA,
        shortcut: EA
      } = AA;
      CA.push({
        scope: BA,
        shortcut: EA,
        mods: QA,
        keys: IA.split("+").map((iA) => code(iA))
      });
    });
  }), CA;
}
function filter$2(CA) {
  const gA = CA.target || CA.srcElement, {
    tagName: AA
  } = gA;
  let IA = !0;
  const BA = AA === "INPUT" && !["checkbox", "radio", "range", "button", "file", "reset", "submit", "color"].includes(gA.type);
  return (gA.isContentEditable || (BA || AA === "TEXTAREA" || AA === "SELECT") && !gA.readOnly) && (IA = !1), IA;
}
function isPressed(CA) {
  return typeof CA == "string" && (CA = code(CA)), _downKeys.indexOf(CA) !== -1;
}
function deleteScope(CA, gA) {
  let AA, IA;
  CA || (CA = getScope());
  for (const BA in _handlers)
    if (Object.prototype.hasOwnProperty.call(_handlers, BA))
      for (AA = _handlers[BA], IA = 0; IA < AA.length; )
        AA[IA].scope === CA ? AA.splice(IA, 1).forEach((EA) => {
          let {
            element: iA
          } = EA;
          return removeKeyEvent(iA);
        }) : IA++;
  getScope() === CA && setScope(gA || "all");
}
function clearModifier(CA) {
  let gA = CA.keyCode || CA.which || CA.charCode;
  CA.key && CA.key.toLowerCase() === "capslock" && (gA = code(CA.key));
  const AA = _downKeys.indexOf(gA);
  if (AA >= 0 && _downKeys.splice(AA, 1), CA.key && CA.key.toLowerCase() === "meta" && _downKeys.splice(0, _downKeys.length), (gA === 93 || gA === 224) && (gA = 91), gA in _mods) {
    _mods[gA] = !1;
    for (const IA in _modifier) _modifier[IA] === gA && (hotkeys[IA] = !1);
  }
}
function unbind(CA) {
  if (typeof CA > "u")
    Object.keys(_handlers).forEach((BA) => {
      Array.isArray(_handlers[BA]) && _handlers[BA].forEach((QA) => eachUnbind(QA)), delete _handlers[BA];
    }), removeKeyEvent(null);
  else if (Array.isArray(CA))
    CA.forEach((BA) => {
      BA.key && eachUnbind(BA);
    });
  else if (typeof CA == "object")
    CA.key && eachUnbind(CA);
  else if (typeof CA == "string") {
    for (var gA = arguments.length, AA = new Array(gA > 1 ? gA - 1 : 0), IA = 1; IA < gA; IA++)
      AA[IA - 1] = arguments[IA];
    let [BA, QA] = AA;
    typeof BA == "function" && (QA = BA, BA = ""), eachUnbind({
      key: CA,
      scope: BA,
      method: QA,
      splitKey: "+"
    });
  }
}
const eachUnbind = (CA) => {
  let {
    key: gA,
    scope: AA,
    method: IA,
    splitKey: BA = "+"
  } = CA;
  getKeys(gA).forEach((EA) => {
    const iA = EA.split(BA), oA = iA.length, cA = iA[oA - 1], tA = cA === "*" ? "*" : code(cA);
    if (!_handlers[tA]) return;
    AA || (AA = getScope());
    const eA = oA > 1 ? getMods(_modifier, iA) : [], aA = [];
    _handlers[tA] = _handlers[tA].filter((GA) => {
      const nA = (IA ? GA.method === IA : !0) && GA.scope === AA && compareArray(GA.mods, eA);
      return nA && aA.push(GA.element), !nA;
    }), aA.forEach((GA) => removeKeyEvent(GA));
  });
};
function eventHandler(CA, gA, AA, IA) {
  if (gA.element !== IA)
    return;
  let BA;
  if (gA.scope === AA || gA.scope === "all") {
    BA = gA.mods.length > 0;
    for (const QA in _mods)
      Object.prototype.hasOwnProperty.call(_mods, QA) && (!_mods[QA] && gA.mods.indexOf(+QA) > -1 || _mods[QA] && gA.mods.indexOf(+QA) === -1) && (BA = !1);
    (gA.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || BA || gA.shortcut === "*") && (gA.keys = [], gA.keys = gA.keys.concat(_downKeys), gA.method(CA, gA) === !1 && (CA.preventDefault ? CA.preventDefault() : CA.returnValue = !1, CA.stopPropagation && CA.stopPropagation(), CA.cancelBubble && (CA.cancelBubble = !0)));
  }
}
function dispatch(CA, gA) {
  const AA = _handlers["*"];
  let IA = CA.keyCode || CA.which || CA.charCode;
  if (CA.key && CA.key.toLowerCase() === "capslock" || !hotkeys.filter.call(this, CA)) return;
  if ((IA === 93 || IA === 224) && (IA = 91), _downKeys.indexOf(IA) === -1 && IA !== 229 && _downKeys.push(IA), ["metaKey", "ctrlKey", "altKey", "shiftKey"].forEach((iA) => {
    const oA = modifierMap[iA];
    CA[iA] && _downKeys.indexOf(oA) === -1 ? _downKeys.push(oA) : !CA[iA] && _downKeys.indexOf(oA) > -1 ? _downKeys.splice(_downKeys.indexOf(oA), 1) : iA === "metaKey" && CA[iA] && (_downKeys = _downKeys.filter((cA) => cA in modifierMap || cA === IA));
  }), IA in _mods) {
    _mods[IA] = !0;
    for (const iA in _modifier)
      if (Object.prototype.hasOwnProperty.call(_modifier, iA)) {
        const oA = modifierMap[_modifier[iA]];
        hotkeys[iA] = CA[oA];
      }
    if (!AA) return;
  }
  for (const iA in _mods)
    Object.prototype.hasOwnProperty.call(_mods, iA) && (_mods[iA] = CA[modifierMap[iA]]);
  CA.getModifierState && !(CA.altKey && !CA.ctrlKey) && CA.getModifierState("AltGraph") && (_downKeys.indexOf(17) === -1 && _downKeys.push(17), _downKeys.indexOf(18) === -1 && _downKeys.push(18), _mods[17] = !0, _mods[18] = !0);
  const BA = getScope();
  if (AA)
    for (let iA = 0; iA < AA.length; iA++)
      AA[iA].scope === BA && (CA.type === "keydown" && AA[iA].keydown || CA.type === "keyup" && AA[iA].keyup) && eventHandler(CA, AA[iA], BA, gA);
  if (!(IA in _handlers)) return;
  const QA = _handlers[IA], EA = QA.length;
  for (let iA = 0; iA < EA; iA++)
    if ((CA.type === "keydown" && QA[iA].keydown || CA.type === "keyup" && QA[iA].keyup) && QA[iA].key) {
      const oA = QA[iA], {
        splitKey: cA
      } = oA, tA = oA.key.split(cA), eA = [];
      for (let aA = 0; aA < tA.length; aA++)
        eA.push(code(tA[aA]));
      eA.sort().join("") === _downKeys.sort().join("") && eventHandler(CA, oA, BA, gA);
    }
}
function hotkeys(CA, gA, AA) {
  _downKeys = [];
  const IA = getKeys(CA);
  let BA = [], QA = "all", EA = document, iA = 0, oA = !1, cA = !0, tA = "+", eA = !1, aA = !1;
  for (AA === void 0 && typeof gA == "function" && (AA = gA), Object.prototype.toString.call(gA) === "[object Object]" && (gA.scope && (QA = gA.scope), gA.element && (EA = gA.element), gA.keyup && (oA = gA.keyup), gA.keydown !== void 0 && (cA = gA.keydown), gA.capture !== void 0 && (eA = gA.capture), typeof gA.splitKey == "string" && (tA = gA.splitKey), gA.single === !0 && (aA = !0)), typeof gA == "string" && (QA = gA), aA && unbind(CA, QA); iA < IA.length; iA++)
    CA = IA[iA].split(tA), BA = [], CA.length > 1 && (BA = getMods(_modifier, CA)), CA = CA[CA.length - 1], CA = CA === "*" ? "*" : code(CA), CA in _handlers || (_handlers[CA] = []), _handlers[CA].push({
      keyup: oA,
      keydown: cA,
      scope: QA,
      mods: BA,
      shortcut: IA[iA],
      method: AA,
      key: IA[iA],
      splitKey: tA,
      element: EA
    });
  if (typeof EA < "u" && window) {
    if (!elementEventMap.has(EA)) {
      const GA = function() {
        let nA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        return dispatch(nA, EA);
      }, lA = function() {
        let nA = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.event;
        dispatch(nA, EA), clearModifier(nA);
      };
      elementEventMap.set(EA, {
        keydownListener: GA,
        keyupListenr: lA,
        capture: eA
      }), addEvent(EA, "keydown", GA, eA), addEvent(EA, "keyup", lA, eA);
    }
    if (!winListendFocus) {
      const GA = () => {
        _downKeys = [];
      };
      winListendFocus = {
        listener: GA,
        capture: eA
      }, addEvent(window, "focus", GA, eA);
    }
  }
}
function trigger(CA) {
  let gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
  Object.keys(_handlers).forEach((AA) => {
    _handlers[AA].filter((BA) => BA.scope === gA && BA.shortcut === CA).forEach((BA) => {
      BA && BA.method && BA.method();
    });
  });
}
function removeKeyEvent(CA) {
  const gA = Object.values(_handlers).flat();
  if (gA.findIndex((IA) => {
    let {
      element: BA
    } = IA;
    return BA === CA;
  }) < 0) {
    const {
      keydownListener: IA,
      keyupListenr: BA,
      capture: QA
    } = elementEventMap.get(CA) || {};
    IA && BA && (removeEvent(CA, "keyup", BA, QA), removeEvent(CA, "keydown", IA, QA), elementEventMap.delete(CA));
  }
  if ((gA.length <= 0 || elementEventMap.size <= 0) && (Object.keys(elementEventMap).forEach((BA) => {
    const {
      keydownListener: QA,
      keyupListenr: EA,
      capture: iA
    } = elementEventMap.get(BA) || {};
    QA && EA && (removeEvent(BA, "keyup", EA, iA), removeEvent(BA, "keydown", QA, iA), elementEventMap.delete(BA));
  }), elementEventMap.clear(), Object.keys(_handlers).forEach((BA) => delete _handlers[BA]), winListendFocus)) {
    const {
      listener: BA,
      capture: QA
    } = winListendFocus;
    removeEvent(window, "focus", BA, QA), winListendFocus = null;
  }
}
const _api = {
  getPressedKeyString,
  setScope,
  getScope,
  deleteScope,
  getPressedKeyCodes,
  getAllKeyCodes,
  isPressed,
  filter: filter$2,
  trigger,
  unbind,
  keyMap: _keyMap,
  modifier: _modifier,
  modifierMap
};
for (const CA in _api)
  Object.prototype.hasOwnProperty.call(_api, CA) && (hotkeys[CA] = _api[CA]);
if (typeof window < "u") {
  const CA = window.hotkeys;
  hotkeys.noConflict = (gA) => (gA && window.hotkeys === hotkeys && (window.hotkeys = CA), hotkeys), window.hotkeys = hotkeys;
}
const EDITABLE_TAGS = /* @__PURE__ */ new Set(["INPUT", "TEXTAREA", "SELECT"]), MODIFIER_TOKENS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "shift", "mod"]), SYSTEM_MODIFIERS = /* @__PURE__ */ new Set(["ctrl", "cmd", "alt", "mod"]), MODIFIER_ORDER = ["ctrl", "cmd", "alt", "shift", "mod"], MODIFIER_DISPLAY = {
  ctrl: "Ctrl",
  cmd: "⌘",
  alt: "Alt",
  shift: "Shift",
  mod: "Mod"
  // Placeholder, will be replaced by getModifierLabel
}, KEY_DISPLAY = {
  enter: "Enter",
  space: "Space",
  tab: "Tab",
  escape: "Esc",
  backspace: "Backspace",
  delete: "Delete",
  home: "Home",
  end: "End",
  pageup: "PageUp",
  pagedown: "PageDown",
  left: "←",
  right: "→",
  up: "↑",
  down: "↓"
}, NAVIGATION_KEYS = /* @__PURE__ */ new Set(["left", "right", "up", "down", "home", "end", "pageup", "pagedown", "backspace", "delete"]);
let filterConfigured = !1;
function getEditableEventTarget(CA) {
  const gA = CA.composedPath?.();
  if (gA?.length) {
    for (const IA of gA) {
      const BA = IA;
      if (BA?.tagName && (EDITABLE_TAGS.has(BA.tagName) || // Some environments (e.g. jsdom) expose contentEditable primarily via
      // the attribute, so we explicitly check both the property and the
      // attribute to reliably detect editable hosts.
      BA.isContentEditable || BA.getAttribute("contenteditable") === "true"))
        return BA;
    }
    return null;
  }
  const AA = CA.target || CA.srcElement;
  return AA?.tagName && (EDITABLE_TAGS.has(AA.tagName) || AA.isContentEditable || AA.getAttribute("contenteditable") === "true") ? AA : null;
}
function isKeyboardEventFromEditableTarget(CA) {
  return CA ? !!getEditableEventTarget(CA) : !1;
}
function ensureHotkeysFilterConfigured() {
  filterConfigured || (hotkeys.filter = (CA) => {
    if (!getEditableEventTarget(CA) || CA.key === "Escape" || CA.ctrlKey || CA.metaKey || CA.altKey)
      return !0;
    if (CA.shiftKey) {
      const AA = CA.key ?? "";
      if (AA.length > 1 && !/^[a-z0-9]$/i.test(AA))
        return !0;
    }
    return !1;
  }, filterConfigured = !0);
}
function parseShortcutString(CA) {
  if (!CA)
    return;
  const gA = CA.split("+").map((BA) => BA.trim().toLowerCase()).filter(Boolean);
  if (gA.length === 0)
    return;
  let AA;
  for (let BA = gA.length - 1; BA >= 0; BA -= 1) {
    const QA = gA[BA];
    if (!MODIFIER_TOKENS.has(QA)) {
      AA = QA;
      break;
    }
  }
  const IA = gA.some((BA) => SYSTEM_MODIFIERS.has(BA));
  return {
    tokens: gA,
    baseKey: AA,
    hasSystemModifier: IA
  };
}
function shouldBlockShortcutInInput(CA, gA) {
  if (!getEditableEventTarget(gA) || CA.hasSystemModifier)
    return !1;
  const IA = CA.baseKey;
  return !!(!IA || IA.length === 1 && /^[a-z0-9]$/i.test(IA) || IA === "space" || IA === "tab" || IA === "enter" || NAVIGATION_KEYS.has(IA));
}
function toHotkeysSequenceFromTokens(CA) {
  return CA.map((gA) => gA === "cmd" ? "command" : gA).join("+");
}
function buildSequences(CA) {
  if (!CA)
    return [];
  const {
    tokens: gA
  } = CA, IA = isFromMac() ? "cmd" : "ctrl", BA = gA.map((EA) => EA === "cmd" || EA === "ctrl" || EA === "mod" ? IA : EA), QA = Array.from(new Set(BA));
  return [toHotkeysSequenceFromTokens(QA)];
}
function getModifierLabel(CA, gA) {
  return CA === "cmd" || CA === "ctrl" || CA === "mod" ? gA ? MODIFIER_DISPLAY.cmd : MODIFIER_DISPLAY.ctrl : CA === "alt" && gA ? "⌥" : MODIFIER_DISPLAY[CA];
}
function getKeyLabel(CA) {
  return KEY_DISPLAY[CA] ? KEY_DISPLAY[CA] : (CA.length === 1 || CA.startsWith("f") && /^\d+$/.test(CA.slice(1)), CA.toUpperCase());
}
function formatShortcutForDisplay(CA, gA) {
  const AA = parseShortcutString(CA);
  if (!AA)
    return;
  const IA = gA?.isMac ?? !1, BA = [];
  if (MODIFIER_ORDER.forEach((QA) => {
    if (AA.tokens.includes(QA)) {
      const EA = getModifierLabel(QA, IA);
      EA && BA.push(EA);
    }
  }), AA.baseKey && BA.push(getKeyLabel(AA.baseKey)), BA.length !== 0)
    return BA.join(" + ");
}
function useRegisterShortcut({
  shortcut: CA,
  disabled: gA = !1,
  onActivate: AA
}) {
  const IA = useMemo$1(() => parseShortcutString(CA), [CA]), BA = useMemo$1(() => buildSequences(IA), [IA]);
  useEffect(() => {
    if (!IA || BA.length === 0 || gA)
      return;
    const QA = (EA, iA) => {
      gA || shouldBlockShortcutInInput(IA, EA) || (EA.preventDefault(), AA());
    };
    return BA.forEach((EA) => {
      hotkeys(EA, QA);
    }), () => {
      BA.forEach((EA) => {
        hotkeys.unbind(EA, QA);
      });
    };
  }, [IA, BA, gA, AA]);
}
const DynamicButtonLabel = ({
  icon: CA,
  label: gA,
  iconSize: AA,
  useSmallerFont: IA = !1,
  iconPosition: BA = "left",
  shortcut: QA
}) => {
  const EA = useMemo$1(() => formatShortcutForDisplay(QA, {
    isMac: isFromMac()
  }), [QA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonLabel, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButtonMainLabel, { "data-has-shortcut": !!EA, children: [
    CA && BA === "left" && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: AA ?? "lg", iconValue: CA }),
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: gA, allowHTML: !1, isLabel: !0, largerLabel: !IA, disableLinks: !0 }),
    CA && BA === "right" && /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: AA ?? "lg", iconValue: CA }),
    EA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButtonShortcut, { "aria-label": `Shortcut ${EA}`, children: EA })
  ] }) });
}, useResizeObserver = (CA, gA = []) => {
  const AA = useRef(null), [IA, BA] = useState([]), QA = useCallback(() => {
    if (!AA.current)
      return [];
    const EA = AA.current.getBoundingClientRect();
    return CA.map((iA) => EA[iA]);
  }, [CA]);
  return useEffect(() => {
    if (!AA.current)
      return;
    BA(QA());
    let EA;
    const iA = new ResizeObserver(() => {
      EA = window.requestAnimationFrame(() => {
        BA(QA());
      });
    });
    return iA.observe(AA.current), () => {
      iA.disconnect(), EA && cancelAnimationFrame(EA);
    };
  }, [CA, QA, ...gA]), {
    values: IA,
    elementRef: AA
  };
}, useCalculatedDimensions = (CA = [], gA = -1) => {
  const {
    values: [AA, IA],
    elementRef: BA
  } = useResizeObserver(useMemo$1(() => ["width", "height"], []), CA);
  return {
    width: AA || gA,
    height: IA || gA,
    elementRef: BA
  };
}, arrayComparator = (CA, gA) => CA.length !== gA.length ? !1 : CA.every((AA, IA) => Object.is(AA, gA[IA])), useExecuteWhenChanged = (CA, gA, AA = arrayComparator) => {
  const [IA, BA] = useState(gA);
  AA(IA, gA) || (BA(gA), CA());
}, StyledPopoverLabelContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot51"
} : {
  target: "e1pbrot51",
  label: "StyledPopoverLabelContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  gap: CA.spacing.threeXS,
  // This is a hacky way to offset the "padding" of the expansion svg
  // icon. Reason is that we want to use the same padding to the right side
  // as the text on the left side. The alternative would be to overwrite the
  // right padding of the button, which would also be hacky and involve slightly
  // more logic.
  // If the padding of the icon changes, this value needs to be adjusted.
  // Also, if we want to apply the same adjustment for other elements, we should
  // consider putting this into a theme variable or creating a shared styled component.
  // The SVG icon we are using seems to have an internal padding of around 25%.
  marginRight: `calc(-${CA.iconSizes.lg} * 0.25)`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverExpansionIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pbrot50"
} : {
  target: "e1pbrot50",
  label: "StyledPopoverExpansionIcon"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  // Small hack to better align the expansion icon with the label.
  marginTop: CA.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Popover = ({
  element: CA,
  empty: gA,
  children: AA,
  stretchWidth: IA,
  widgetMgr: BA,
  blockId: QA,
  fragmentId: EA
}) => {
  const iA = useContext(IsSidebarContext), oA = useEmotionTheme(), cA = CA.id, eA = !!QA && !!!cA, [aA, GA] = useWidgetManagerElementState({
    widgetMgr: BA,
    id: eA ? QA ?? "" : "",
    key: "open",
    defaultValue: CA.open ?? !1
  }), lA = eA ? aA : CA.open ?? !1, [nA, DA] = useState(lA);
  useExecuteWhenChanged(() => {
    !cA || !notNullOrUndefined(CA.open) || DA(CA.open);
  }, [cA, CA.open]);
  const {
    width: hA,
    elementRef: wA
  } = useCalculatedDimensions(), sA = useCallback(() => {
    const yA = !nA;
    DA(yA), cA ? BA?.setBoolValue({
      id: cA
    }, yA, {
      fromUi: !0
    }, EA) : eA && GA(yA);
  }, [nA, BA, cA, EA, eA, GA]), NA = useCallback(() => {
    DA(!1), cA ? BA?.setBoolValue({
      id: cA
    }, !1, {
      fromUi: !0
    }, EA) : eA && GA(!1);
  }, [BA, cA, EA, eA, GA]);
  let rA = BaseButtonKind.SECONDARY;
  return CA.type === "primary" ? rA = BaseButtonKind.PRIMARY : CA.type === "tertiary" && (rA = BaseButtonKind.TERTIARY), /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-testid": "stPopover", className: "stPopover", ref: wA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => AA,
      isOpen: nA,
      onClickOutside: NA,
      onClick: () => nA ? NA() : void 0,
      onEsc: NA,
      ignoreBoundary: iA,
      popoverMargin: convertRemToPx(oA.spacing.twoXS),
      renderAll: !0,
      overrides: {
        Body: {
          props: {
            "data-testid": "stPopoverBody"
          },
          style: () => ({
            ...getPopoverContainerStyle(oA),
            // Override radii — st.popover uses xl instead of default
            borderTopLeftRadius: oA.radii.xl,
            borderTopRightRadius: oA.radii.xl,
            borderBottomRightRadius: oA.radii.xl,
            borderBottomLeftRadius: oA.radii.xl,
            marginRight: oA.spacing.lg,
            marginBottom: oA.spacing.lg,
            maxHeight: "70vh",
            overflow: "auto",
            maxWidth: `calc(${oA.sizes.contentMaxWidth} - 2*${oA.spacing.lg})`,
            minWidth: IA ? (
              // If width="stretch", we use the container width as minimum:
              `${Math.max(hA, 160)}px`
            ) : oA.sizes.minPopupWidth,
            [`@media (max-width: ${oA.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${oA.spacing.threeXL})`
            },
            paddingRight: `calc(${oA.spacing.twoXL} - ${oA.sizes.borderWidth})`,
            // 1px to account for border.
            paddingLeft: `calc(${oA.spacing.twoXL} - ${oA.sizes.borderWidth})`,
            paddingBottom: `calc(${oA.spacing.twoXL} - ${oA.sizes.borderWidth})`,
            paddingTop: `calc(${oA.spacing.twoXL} - ${oA.sizes.borderWidth})`
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: CA.help, containerWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { "data-testid": "stPopoverButton", kind: rA, size: BaseButtonSize.SMALL, disabled: gA && !cA || CA.disabled, containerWidth: !0, onClick: sA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledPopoverLabelContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicButtonLabel, { icon: CA.icon, label: CA.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverExpansionIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: nA ? ":material/expand_less:" : ":material/expand_more:", size: "lg" }) })
      ] }) }) }) })
    }
  ) });
}, Popover$1 = memo(Popover);
function _objectWithoutProperties$3(CA, gA) {
  if (CA == null) return {};
  var AA, IA, BA = _objectWithoutPropertiesLoose$c(CA, gA);
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (IA = 0; IA < QA.length; IA++) AA = QA[IA], gA.indexOf(AA) === -1 && {}.propertyIsEnumerable.call(CA, AA) && (BA[AA] = CA[AA]);
  }
  return BA;
}
var _excluded$5 = ["children", "iconAttrs", "iconVerticalAlign", "iconViewBox", "size", "title"];
function ownKeys$5(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$3(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$5(Object(AA), !0).forEach(function(IA) {
      _defineProperty$j(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$5(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
var EmotionIconBaseBase = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = CA.children, IA = CA.iconAttrs;
  CA.iconVerticalAlign;
  var BA = CA.iconViewBox, QA = CA.size, EA = CA.title, iA = _objectWithoutProperties$3(CA, _excluded$5), oA = _objectSpread$3(_objectSpread$3({
    viewBox: BA,
    height: CA.height !== void 0 ? CA.height : QA,
    width: CA.width !== void 0 ? CA.width : QA,
    "aria-hidden": EA == null ? "true" : void 0,
    focusable: "false",
    role: EA != null ? "img" : void 0
  }, IA), iA);
  return /* @__PURE__ */ React.createElement("svg", _extends$m({}, oA, {
    ref: gA
  }), EA && /* @__PURE__ */ React.createElement("title", {
    key: "icon-title"
  }, EA), AA);
}), EmotionIconBase = /* @__PURE__ */ createStyled(EmotionIconBaseBase, process.env.NODE_ENV === "production" ? {
  target: "ex0cdmw0"
} : {
  target: "ex0cdmw0",
  label: "EmotionIconBase"
})("display:inline-block;vertical-align:", function(CA) {
  return CA.iconVerticalAlign;
}, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), AccessibilityNew = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }));
});
AccessibilityNew.displayName = "AccessibilityNew";
var AccessibleForward = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 18,
    cy: 4.54,
    r: 2
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
  }));
});
AccessibleForward.displayName = "AccessibleForward";
var Check = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
  }));
});
Check.displayName = "Check";
var ChevronLeft = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
  }));
});
ChevronLeft.displayName = "ChevronLeft";
var ChevronRight = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
  }));
});
ChevronRight.displayName = "ChevronRight";
var ContentCopy = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
  }));
});
ContentCopy.displayName = "ContentCopy";
var DirectionsBike = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
  }));
});
DirectionsBike.displayName = "DirectionsBike";
var DirectionsRun = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
  }));
});
DirectionsRun.displayName = "DirectionsRun";
var Fullscreen = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
  }));
});
Fullscreen.displayName = "Fullscreen";
var FullscreenExit = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
  }));
});
FullscreenExit.displayName = "FullscreenExit";
var KeyboardArrowDown = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
  }));
});
KeyboardArrowDown.displayName = "KeyboardArrowDown";
var KeyboardArrowUp = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
});
KeyboardArrowUp.displayName = "KeyboardArrowUp";
var Pool = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 2.5
  }));
});
Pool.displayName = "Pool";
var Rowing = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
  }));
});
Rowing.displayName = "Rowing";
var ORIENTATION = {
  vertical: "vertical",
  horizontal: "horizontal"
}, FILL = {
  fixed: "fixed",
  intrinsic: "intrinsic"
}, getTabId = function CA(gA, AA) {
  return "tabs-".concat(gA, "-tab-").concat(AA);
}, getTabPanelId = function CA(gA, AA) {
  return "tabs-".concat(gA, "-tabpanel-").concat(AA);
}, isHorizontal = function CA(gA) {
  return gA === ORIENTATION.horizontal;
}, isVertical = function CA(gA) {
  return gA === ORIENTATION.vertical;
}, isRTL = function CA(gA) {
  return gA === "rtl";
}, isIntrinsic = function CA(gA) {
  return gA === FILL.intrinsic;
}, isFixed = function CA(gA) {
  return gA === FILL.fixed;
};
function ownKeys$4(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$2(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$4(Object(AA), !0).forEach(function(IA) {
      _defineProperty$4(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$4(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$4(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var StyledRoot = styled("div", function(CA) {
  CA.$theme;
  var gA = CA.$orientation, AA = gA === void 0 ? ORIENTATION.horizontal : gA, IA = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: "scale(1)"
  };
  return isVertical(AA) && (IA.display = "flex"), IA;
});
StyledRoot.displayName = "StyledRoot";
StyledRoot.displayName = "StyledRoot";
var StyledTabBar = styled("div", function(CA) {
  var gA = CA.$hasEndEnhancer, AA = CA.$orientation;
  return gA || !isHorizontal(AA) ? {
    display: "flex"
  } : {};
});
StyledTabBar.displayName = "StyledTabBar";
StyledTabBar.displayName = "StyledTabBar";
var StyledTabList = styled("div", function(CA) {
  var gA = CA.$theme, AA = CA.$fill, IA = AA === void 0 ? FILL.intrinsic : AA, BA = CA.$orientation, QA = BA === void 0 ? ORIENTATION.horizontal : BA, EA = {
    position: "relative",
    display: "flex",
    flexWrap: "nowrap",
    flexGrow: 1
  };
  return isHorizontal(QA) ? (EA.flexDirection = "row", EA.paddingBottom = "5px", EA.marginBottom = "-5px") : (EA.flexDirection = "column", isRTL(gA.direction) ? (EA.paddingLeft = "5px", EA.marginLeft = "-5px") : (EA.paddingRight = "5px", EA.marginRight = "-5px")), isIntrinsic(IA) && (EA["::-webkit-scrollbar"] = {
    display: "none"
  }, EA["-ms-overflow-style"] = "none", EA.scrollbarWidth = "none", isHorizontal(QA) ? EA.overflowX = "scroll" : EA.overflowY = "scroll"), EA;
});
StyledTabList.displayName = "StyledTabList";
StyledTabList.displayName = "StyledTabList";
var StyledTab = styled("button", function(CA) {
  var gA = CA.$theme, AA = CA.$orientation, IA = AA === void 0 ? ORIENTATION.horizontal : AA, BA = CA.$fill, QA = BA === void 0 ? FILL.intrinsic : BA, EA = CA.$focusVisible, iA = EA === void 0 ? !1 : EA;
  CA.$isActive;
  var oA = _objectSpread$2({
    cursor: "pointer",
    WebkitAppearance: "none",
    marginLeft: "0",
    marginRight: "0",
    marginTop: "0",
    marginBottom: "0",
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    paddingLeft: gA.sizing.scale600,
    paddingTop: gA.sizing.scale600,
    paddingRight: gA.sizing.scale600,
    paddingBottom: gA.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: "none",
    borderTopStyle: "none",
    borderRightStyle: "none",
    borderBottomStyle: "none",
    color: gA.colors.contentPrimary,
    background: gA.colors.backgroundPrimary,
    transitionProperty: "background",
    transitionDuration: gA.animation.timing200,
    transitionTimingFunction: gA.animation.linearCurve,
    outline: "none",
    outlineOffset: "-3px",
    ":disabled": {
      cursor: "not-allowed",
      color: gA.colors.contentStateDisabled
    },
    ":hover": {
      background: gA.colors.backgroundSecondary
    },
    ":disabled:hover": {
      background: "none"
    }
  }, gA.typography.LabelSmall);
  return iA && (oA.outline = "3px solid ".concat(gA.colors.accent)), isFixed(QA) && (oA.flexGrow = 1, oA.flexBasis = 0), isHorizontal(IA) ? oA.justifyContent = "center" : oA.justifyContent = "flex-end", oA;
});
StyledTab.displayName = "StyledTab";
StyledTab.displayName = "StyledTab";
var StyledEndEnhancerContainer = styled("div", function(CA) {
  var gA = CA.$theme, AA = gA.direction === "rtl" ? "marginRight" : "marginLeft";
  return _defineProperty$4({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, AA, gA.sizing.scale600);
});
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
StyledEndEnhancerContainer.displayName = "StyledEndEnhancerContainer";
var StyledArtworkContainer = styled("div", function(CA) {
  var gA = CA.$theme;
  CA.$orientation;
  var AA = {
    display: "flex"
  };
  return isRTL(gA.direction) ? AA.marginLeft = gA.sizing.scale300 : AA.marginRight = gA.sizing.scale300, AA;
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledTabBorder = styled("div", function(CA) {
  var gA = CA.$theme, AA = CA.$orientation, IA = AA === void 0 ? ORIENTATION.horizontal : AA, BA = {
    backgroundColor: gA.colors.borderOpaque,
    position: "relative"
  };
  return isHorizontal(IA) ? BA.height = "5px" : BA.width = "5px", BA;
});
StyledTabBorder.displayName = "StyledTabBorder";
StyledTabBorder.displayName = "StyledTabBorder";
var StyledTabHighlight = styled("div", function(CA) {
  var gA = CA.$theme, AA = CA.$orientation, IA = AA === void 0 ? ORIENTATION.horizontal : AA, BA = CA.$length, QA = BA === void 0 ? 0 : BA, EA = CA.$distance, iA = EA === void 0 ? 0 : EA, oA = CA.$animate, cA = oA === void 0 ? !1 : oA, tA = {
    backgroundColor: gA.colors.borderSelected,
    position: "absolute",
    zIndex: 1
  };
  return isHorizontal(IA) ? (tA.bottom = "0px", tA.left = "0px", tA.height = "5px", tA.width = "".concat(QA, "px"), tA.transform = "translateX(".concat(iA, "px)")) : (tA.transform = "translateY(".concat(iA, "px)"), tA.width = "5px", tA.height = "".concat(QA, "px"), isRTL(gA.direction) ? tA.left = "0px" : tA.right = "0px"), cA && (tA.transitionProperty = "all", tA.transitionDuration = gA.animation.timing400, tA.transitionTimingFunction = gA.animation.easeInOutQuinticCurve), tA;
});
StyledTabHighlight.displayName = "StyledTabHighlight";
StyledTabHighlight.displayName = "StyledTabHighlight";
var StyledTabPanel = styled("div", function(CA) {
  var gA = CA.$theme, AA = CA.$pad, IA = AA === void 0 ? !0 : AA, BA = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: "none"
  };
  return IA && (BA.paddingTop = gA.sizing.scale600, BA.paddingRight = gA.sizing.scale600, BA.paddingBottom = gA.sizing.scale600, BA.paddingLeft = gA.sizing.scale600), BA;
});
StyledTabPanel.displayName = "StyledTabPanel";
StyledTabPanel.displayName = "StyledTabPanel";
var _excluded$4 = ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"], _excluded2$2 = ["artwork", "overrides", "tabRef", "onClick", "title"], _excluded3$1 = ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"];
function ownKeys$3(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread$1(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$3(Object(AA), !0).forEach(function(IA) {
      _defineProperty$3(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$3(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty$3(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
function _toConsumableArray(CA) {
  return _arrayWithoutHoles(CA) || _iterableToArray(CA) || _unsupportedIterableToArray$1(CA) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray(CA) {
  if (typeof Symbol < "u" && CA[Symbol.iterator] != null || CA["@@iterator"] != null) return Array.from(CA);
}
function _arrayWithoutHoles(CA) {
  if (Array.isArray(CA)) return _arrayLikeToArray$1(CA);
}
function _objectWithoutProperties$2(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose$2(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose$2(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$3.apply(this, arguments);
}
function _slicedToArray$2(CA, gA) {
  return _arrayWithHoles$1(CA) || _iterableToArrayLimit$1(CA, gA) || _unsupportedIterableToArray$1(CA, gA) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray$1(CA, gA);
    var AA = Object.prototype.toString.call(CA).slice(8, -1);
    if (AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set") return Array.from(CA);
    if (AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA)) return _arrayLikeToArray$1(CA, gA);
  }
}
function _arrayLikeToArray$1(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = new Array(gA); AA < gA; AA++)
    IA[AA] = CA[AA];
  return IA;
}
function _iterableToArrayLimit$1(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA = [], BA = !0, QA = !1, EA, iA;
    try {
      for (AA = AA.call(CA); !(BA = (EA = AA.next()).done) && (IA.push(EA.value), !(gA && IA.length === gA)); BA = !0)
        ;
    } catch (oA) {
      QA = !0, iA = oA;
    } finally {
      try {
        !BA && AA.return != null && AA.return();
      } finally {
        if (QA) throw iA;
      }
    }
    return IA;
  }
}
function _arrayWithHoles$1(CA) {
  if (Array.isArray(CA)) return CA;
}
var KEYBOARD_ACTION = {
  next: "next",
  previous: "previous"
}, getLayoutParams = function CA(gA, AA) {
  return gA ? isVertical(AA) ? {
    length: gA.clientHeight,
    distance: gA.offsetTop
  } : {
    length: gA.clientWidth,
    distance: gA.offsetLeft
  } : {
    length: 0,
    distance: 0
  };
}, scrollParentToCentreTarget = function CA(gA) {
  var AA = gA.parentNode.getBoundingClientRect(), IA = AA.x, BA = AA.y, QA = AA.width, EA = AA.height, iA = gA.getBoundingClientRect(), oA = iA.x, cA = iA.y, tA = iA.width, eA = iA.height, aA = {
    x: oA - IA + tA / 2,
    y: cA - BA + eA / 2
  }, GA = gA.parentNode, lA = GA.scrollLeft, nA = GA.scrollTop, DA = {
    x: lA + aA.x - QA / 2,
    y: nA + aA.y - EA / 2
  };
  gA.parentNode.scroll(DA.x, DA.y);
};
function RenderEnhancer(CA) {
  var gA = CA.Enhancer;
  return typeof gA == "string" ? gA : reactIsExports$1.isValidElementType(gA) ? /* @__PURE__ */ React.createElement(gA, null) : gA;
}
function Tabs$2(CA) {
  var gA = CA.activeKey, AA = gA === void 0 ? "0" : gA, IA = CA.disabled, BA = IA === void 0 ? !1 : IA, QA = CA.children, EA = CA.fill, iA = EA === void 0 ? FILL.intrinsic : EA, oA = CA.activateOnFocus, cA = oA === void 0 ? !0 : oA, tA = CA.onChange, eA = CA.orientation, aA = eA === void 0 ? ORIENTATION.horizontal : eA, GA = CA.overrides, lA = GA === void 0 ? {} : GA, nA = CA.renderAll, DA = nA === void 0 ? !1 : nA, hA = CA.uid, wA = hA === void 0 ? null : hA, sA = CA.endEnhancer, NA = useUID(), rA = wA || NA, yA = lA.Root, bA = lA.TabList, RA = lA.TabHighlight, FA = lA.TabBorder, dA = getOverrides(yA, StyledRoot), kA = _slicedToArray$2(dA, 2), pA = kA[0], YA = kA[1], SA = getOverrides(bA, StyledTabList), JA = _slicedToArray$2(SA, 2), UA = JA[0], fA = JA[1], zA = getOverrides(RA, StyledTabHighlight), _A = _slicedToArray$2(zA, 2), uA = _A[0], HA = _A[1], TA = getOverrides(FA, StyledTabBorder), ZA = _slicedToArray$2(TA, 2), AI = ZA[0], QI = ZA[1], LA = getOverrides(lA.EndEnhancerContainer, StyledEndEnhancerContainer), PA = _slicedToArray$2(LA, 2), XA = PA[0], EI = PA[1], CI = React.useState(0), II = _slicedToArray$2(CI, 2), vA = II[0], wI = II[1];
  React.useEffect(function() {
    wI(vA + 1);
  }, [AA]);
  var $A = React.useRef(), YI = React.useState({
    length: 0,
    distance: 0
  }), FI = _slicedToArray$2(YI, 2), nI = FI[0], uI = FI[1], hI = React.useCallback(function() {
    $A.current && uI(getLayoutParams($A.current, aA));
  }, [$A.current, aA]);
  React.useEffect(hI, [$A.current, aA]), React.useEffect(function() {
    $A.current && (isHorizontal(aA) ? (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      $A.current.parentNode.scrollWidth > // @ts-expect-error todo(flow->ts) maybe parentElement?
      $A.current.parentNode.clientWidth
    ) : (
      // @ts-expect-error todo(flow->ts) maybe parentElement?
      $A.current.parentNode.scrollHeight > // @ts-expect-error todo(flow->ts) maybe parentElement?
      $A.current.parentNode.clientHeight
    )) && (vA > 1 ? $A.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    }) : scrollParentToCentreTarget($A.current));
  }, [$A.current]);
  var bI = {
    $orientation: aA,
    $fill: iA
  }, HI = useStyletron(), UI = _slicedToArray$2(HI, 2), pI = UI[1], mI = React.useCallback(function(rI) {
    if (isHorizontal(aA))
      if (isRTL(pI.direction))
        switch (rI.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;
          case 37:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
      else
        switch (rI.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;
          case 39:
            return KEYBOARD_ACTION.next;
          default:
            return null;
        }
    else
      switch (rI.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;
        case 40:
          return KEYBOARD_ACTION.next;
        default:
          return null;
      }
  }, [aA, pI.direction]);
  return /* @__PURE__ */ React.createElement(pA, _extends$3({}, bI, YA), /* @__PURE__ */ React.createElement(StyledTabBar, {
    $hasEndEnhancer: !!sA,
    $orientation: aA
  }, /* @__PURE__ */ React.createElement(UA, _extends$3({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": aA
  }, bI, fA), React.Children.map(QA, function(rI, KA) {
    if (rI)
      return /* @__PURE__ */ React.createElement(InternalTab, _extends$3({
        childKey: rI.key,
        childIndex: KA,
        activeKey: AA,
        orientation: aA,
        activeTabRef: $A,
        updateHighlight: hI,
        parseKeyDown: mI,
        activateOnFocus: cA,
        uid: rA,
        disabled: BA,
        sharedStylingProps: bI,
        onChange: tA
      }, rI.props));
  }), /* @__PURE__ */ React.createElement(uA, _extends$3({
    "data-baseweb": "tab-highlight",
    $length: nI.length,
    $distance: nI.distance,
    $animate: vA > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, bI, HA))), aA === ORIENTATION.horizontal && sA !== null && sA !== void 0 && /* @__PURE__ */ React.createElement(XA, _extends$3({}, EI, {
    $orientation: aA
  }), /* @__PURE__ */ React.createElement(RenderEnhancer, {
    Enhancer: sA
  }))), /* @__PURE__ */ React.createElement(AI, _extends$3({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, bI, QI)), React.Children.map(QA, function(rI, KA) {
    if (rI)
      return /* @__PURE__ */ React.createElement(InternalTabPanel, _extends$3({
        childKey: rI.key,
        childIndex: KA,
        activeKey: AA,
        uid: rA,
        sharedStylingProps: bI,
        renderAll: DA
      }, rI.props));
  }));
}
function InternalTab(CA) {
  var gA = CA.childKey, AA = CA.childIndex, IA = CA.activeKey, BA = CA.orientation, QA = CA.activeTabRef, EA = CA.updateHighlight, iA = CA.parseKeyDown, oA = CA.activateOnFocus, cA = CA.uid, tA = CA.disabled, eA = CA.sharedStylingProps, aA = CA.onChange, GA = _objectWithoutProperties$2(CA, _excluded$4), lA = gA || String(AA), nA = lA == IA, DA = GA.artwork, hA = GA.overrides, wA = hA === void 0 ? {} : hA, sA = GA.tabRef, NA = GA.onClick, rA = GA.title, yA = _objectWithoutProperties$2(GA, _excluded2$2), bA = React.useRef();
  React.useImperativeHandle(sA, function() {
    return nA ? QA.current : bA.current;
  });
  var RA = React.useRef({
    length: 0,
    distance: 0
  });
  React.useEffect(function() {
    RA.current = getLayoutParams(nA ? QA.current : bA.current, BA);
  }), React.useEffect(function() {
    if (window.ResizeObserver) {
      var LA = new window.ResizeObserver(function(PA) {
        if (PA[0] && PA[0].target) {
          var XA = getLayoutParams(PA[0].target, BA);
          (XA.length !== RA.current.length || XA.distance !== RA.current.distance) && EA();
        }
      });
      return LA.observe(nA ? QA.current : bA.current), function() {
        LA.disconnect();
      };
    }
  }, [IA, BA]), React.useEffect(EA, [rA]);
  var FA = wA.Tab, dA = wA.ArtworkContainer, kA = getOverrides(FA, StyledTab), pA = _slicedToArray$2(kA, 2), YA = pA[0], SA = pA[1], JA = getOverrides(dA, StyledArtworkContainer), UA = _slicedToArray$2(JA, 2), fA = UA[0], zA = UA[1], _A = React.useState(!1), uA = _slicedToArray$2(_A, 2), HA = uA[0], TA = uA[1], ZA = React.useCallback(function(LA) {
    isFocusVisible(LA) && TA(!0);
  }, []), AI = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function(LA) {
      HA !== !1 && TA(!1);
    },
    [HA]
  ), QI = React.useCallback(function(LA) {
    var PA = _toConsumableArray(LA.target.parentNode.childNodes).filter(function(II) {
      return !II.disabled && II.getAttribute("role") === "tab";
    });
    if (PA.length !== 1) {
      var XA = PA.indexOf(LA.target), EI = iA(LA);
      if (EI) {
        var CI;
        EI === KEYBOARD_ACTION.previous ? PA[XA - 1] ? CI = PA[XA - 1] : CI = PA[PA.length - 1] : EI === KEYBOARD_ACTION.next && (PA[XA + 1] ? CI = PA[XA + 1] : CI = PA[0]), CI && (CI.focus(), oA && CI.click()), isVertical(BA) && LA.preventDefault();
      }
    }
  });
  return /* @__PURE__ */ React.createElement(YA, _extends$3({
    "data-baseweb": "tab",
    key: lA,
    id: getTabId(cA, lA),
    role: "tab",
    onKeyDown: QI,
    "aria-selected": nA,
    "aria-controls": getTabPanelId(cA, lA),
    tabIndex: nA ? "0" : "-1",
    ref: nA ? QA : bA,
    disabled: !nA && tA,
    type: "button",
    $focusVisible: HA,
    $isActive: nA
  }, eA, yA, SA, {
    onClick: function(PA) {
      typeof aA == "function" && aA({
        activeKey: lA
      }), typeof NA == "function" && NA(PA);
    },
    onFocus: forkFocus(_objectSpread$1(_objectSpread$1({}, yA), SA), ZA),
    onBlur: forkBlur(_objectSpread$1(_objectSpread$1({}, yA), SA), AI)
  }), DA ? /* @__PURE__ */ React.createElement(fA, _extends$3({
    "data-baseweb": "artwork-container"
  }, eA, zA), /* @__PURE__ */ React.createElement(DA, {
    size: 20,
    color: "contentPrimary"
  })) : null, rA || lA);
}
function InternalTabPanel(CA) {
  var gA = CA.childKey, AA = CA.childIndex, IA = CA.activeKey, BA = CA.uid, QA = CA.sharedStylingProps, EA = CA.renderAll, iA = _objectWithoutProperties$2(CA, _excluded3$1), oA = gA || String(AA), cA = oA == IA, tA = iA.overrides, eA = tA === void 0 ? {} : tA, aA = iA.children, GA = eA.TabPanel, lA = getOverrides(GA, StyledTabPanel), nA = _slicedToArray$2(lA, 2), DA = nA[0], hA = nA[1];
  return /* @__PURE__ */ React.createElement(DA, _extends$3({
    "data-baseweb": "tab-panel",
    key: oA,
    role: "tabpanel",
    id: getTabPanelId(BA, oA),
    "aria-labelledby": getTabId(BA, oA),
    hidden: !cA
  }, QA, hA), cA || EA ? aA : null);
}
function Tab(CA) {
  return null;
}
function getClassnamePrefix(CA) {
  return CA === Direction.HORIZONTAL ? "stHorizontalBlock" : "stVerticalBlock";
}
function shouldComponentBeEnabled(CA, gA) {
  return CA !== "empty" || gA !== ScriptRunState.RUNNING;
}
function isElementStale(CA, gA, AA, IA) {
  return gA === ScriptRunState.RERUN_REQUESTED ? !0 : gA === ScriptRunState.RUNNING ? IA?.length ? !!(CA.fragmentId && IA.includes(CA.fragmentId) && CA.scriptRunId !== AA) : CA.scriptRunId !== AA : !1;
}
function isComponentStale(CA, gA, AA, IA, BA) {
  return !CA || isElementStale(gA, AA, IA, BA);
}
function assignDividerColor(CA, gA) {
  const AA = getDividerColors(gA), IA = Object.keys(AA), {
    blue: BA,
    green: QA,
    orange: EA,
    red: iA,
    violet: oA,
    yellow: cA
  } = AA, tA = {
    blue: BA,
    green: QA,
    orange: EA,
    red: iA,
    violet: oA,
    yellow: cA
  }, eA = Object.keys(tA);
  let aA = 0;
  for (const GA of ElementsSetVisitor.collectElements(CA)) {
    const lA = GA.heading?.divider;
    if (GA.type === "heading" && lA)
      if (lA === "auto") {
        const nA = eA[aA];
        GA.heading.divider = tA[nA], aA += 1, aA === eA.length && (aA = 0);
      } else IA.includes(lA) && (GA.heading.divider = AA[lA]);
  }
}
function convertKeyToClassName(CA) {
  return CA ? "st-key-" + CA.trim().replace(/[^a-zA-Z0-9_-]/g, "-") : "";
}
function getKeyFromId(CA) {
  if (!CA || !isValidElementId(CA))
    return;
  const AA = CA.split("-").slice(2).join("-");
  return AA === "None" ? void 0 : AA;
}
function getColumnGapSize(CA) {
  return CA.gapConfig?.gapSize ? CA.gapConfig.gapSize : streamlit.GapSize.SMALL;
}
function checkFlexContainerBackwardsCompatibile(CA) {
  return !!(CA.flexContainer || CA.vertical || CA.horizontal);
}
function shouldActivateScrollToBottom(CA) {
  if (!CA.deltaBlock.heightConfig?.pixelHeight)
    return !1;
  const {
    autoscroll: AA
  } = CA.deltaBlock;
  return AA ?? CA.children.some((IA) => IA instanceof BlockNode && IA.deltaBlock.type === "chatMessage");
}
function getBorderBackwardsCompatible(CA) {
  return CA.flexContainer?.border || CA.vertical?.border || !1;
}
const StyledTabContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "esjhkag1"
} : {
  target: "esjhkag1",
  label: "StyledTabContainer"
})(({
  isOverflowing: CA,
  width: gA,
  flex: AA
}) => ({
  position: CA ? "relative" : void 0,
  width: gA || void 0,
  flex: AA || void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledScrollArrow = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "esjhkag0"
} : {
  target: "esjhkag0",
  label: "StyledScrollArrow"
})(({
  theme: CA,
  position: gA,
  tabHeight: AA
}) => ({
  position: "absolute",
  top: 0,
  [gA]: 0,
  zIndex: CA.zIndices.priority,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: AA,
  width: CA.spacing.xl,
  padding: 0,
  border: "none",
  cursor: "pointer",
  color: CA.colors.fadedText60,
  background: "transparent",
  // Apply gradient background on the side closest to the content
  backgroundImage: gA === "right" ? `linear-gradient(to right, ${transparentize(CA.colors.bgColor, 1)}, ${CA.colors.bgColor} 40%)` : `linear-gradient(to left, ${transparentize(CA.colors.bgColor, 1)}, ${CA.colors.bgColor} 40%)`,
  "&:hover": {
    color: CA.colors.bodyText
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRing
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), SCROLL_AMOUNT = 200, SCROLL_TOLERANCE = 1;
function getPersistedTabIndex(CA, gA, AA) {
  const IA = CA.getElementState(gA, "activeTabLabel");
  if (!IA) return null;
  const BA = AA.indexOf(IA);
  return BA >= 0 ? {
    index: BA,
    label: IA
  } : null;
}
function Tabs(CA) {
  const {
    widgetsDisabled: gA,
    node: AA,
    isStale: IA,
    width: BA,
    flex: QA,
    widgetMgr: EA,
    fragmentId: iA
  } = CA, {
    scriptRunState: oA,
    scriptRunId: cA,
    fragmentIdsThisRun: tA
  } = useContext(ScriptRunContext), eA = AA.deltaBlock?.tabContainer?.defaultTabIndex ?? 0, aA = AA.deltaBlock?.tabContainer?.id, GA = AA.deltaBlock?.id ?? "", lA = !!aA, nA = !!GA && !lA, DA = getKeyFromId(GA), hA = useMemo$1(() => AA.children.map((uA, HA) => uA?.deltaBlock?.tab?.label ?? HA.toString()), [AA.children]), [wA, sA] = useState(() => {
    if (nA) {
      const uA = getPersistedTabIndex(EA, GA, hA);
      if (uA) return uA.index;
    }
    return eA;
  }), [NA, rA] = useState(() => {
    if (nA) {
      const HA = getPersistedTabIndex(EA, GA, hA);
      if (HA) return HA.label;
    }
    return AA.children[eA]?.deltaBlock?.tab?.label ?? "0";
  }), yA = useRef(null), bA = useEmotionTheme(), [RA, FA] = useState(!1), [dA, kA] = useState(!1), pA = RA || dA, YA = useCallback(() => {
    if (yA.current) {
      const {
        scrollLeft: uA,
        scrollWidth: HA,
        clientWidth: TA
      } = yA.current;
      FA(uA > SCROLL_TOLERANCE), kA(uA + TA < HA - SCROLL_TOLERANCE);
    }
  }, []), SA = useCallback((uA) => {
    yA.current?.scrollBy({
      left: uA === "left" ? -SCROLL_AMOUNT : SCROLL_AMOUNT,
      behavior: "smooth"
    });
  }, []), JA = useCallback(() => SA("left"), [SA]), UA = useCallback(() => SA("right"), [SA]), fA = useRef(eA);
  useEffect(() => {
    if (lA && hA.length > 0 && eA !== fA.current) {
      const HA = hA[eA];
      HA && (sA(eA), rA(HA)), fA.current = eA;
    }
  }, [eA, lA, hA]), useEffect(() => {
    if (nA) {
      const HA = getPersistedTabIndex(EA, GA, hA);
      if (HA) {
        sA(HA.index), rA(HA.label);
        return;
      }
    }
    if (hA.indexOf(NA) === -1) {
      const HA = hA[eA];
      sA(eA), rA(HA), nA && EA.setElementState(GA, "activeTabLabel", HA);
    }
  }, [hA]), useEffect(() => {
    const uA = yA.current;
    if (uA) {
      uA.addEventListener("scroll", YA, {
        passive: !0
      });
      const HA = new ResizeObserver(() => {
        YA();
      });
      return HA.observe(uA), () => {
        uA.removeEventListener("scroll", YA), HA.disconnect();
      };
    }
  }, [YA]), useEffect(() => {
    if (YA(), nA) {
      const HA = getPersistedTabIndex(EA, GA, hA);
      if (HA) {
        sA(HA.index), rA(HA.label);
        return;
      }
    }
    const uA = hA.indexOf(NA);
    if (uA !== -1)
      sA(uA), rA(hA[uA]);
    else {
      const HA = hA[eA];
      sA(eA), rA(HA), nA && EA.setElementState(GA, "activeTabLabel", HA);
    }
  }, [AA.children.length, YA]);
  const zA = bA.sizes.tabHeight, _A = bA.spacing.threeXS;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTabContainer, { className: classNames("stTabs", convertKeyToClassName(DA)), "data-testid": "stTabs", isOverflowing: pA, width: BA, flex: QA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tabs$2,
      {
        activateOnFocus: !0,
        activeKey: wA,
        onChange: ({
          activeKey: uA
        }) => {
          const HA = hA[uA];
          sA(uA), rA(HA), nA && EA.setElementState(GA, "activeTabLabel", HA), lA && aA && EA && EA.setStringValue({
            id: aA,
            formId: ""
          }, HA, {
            fromUi: !0
          }, iA);
        },
        renderAll: !0,
        overrides: {
          TabHighlight: {
            style: () => ({
              backgroundColor: bA.colors.primary,
              height: _A
            })
          },
          TabBorder: {
            style: () => ({
              backgroundColor: bA.colors.borderColorLight,
              height: _A
            })
          },
          TabList: {
            props: {
              ref: yA
            },
            style: () => ({
              gap: bA.spacing.lg,
              marginBottom: `-${_A}`,
              paddingBottom: _A,
              overflowY: "hidden",
              ...IA && STALE_STYLES
            })
          },
          Root: {
            style: () => ({
              // resetting transform to fix full screen wrapper
              transform: "none"
            })
          }
        },
        children: AA.children.map((uA, HA) => {
          const TA = isElementStale(uA, oA, cA, tA), ZA = {
            ...CA,
            isStale: IA || TA,
            widgetsDisabled: gA,
            node: uA
          }, AI = hA[HA] ?? HA.toString(), QI = wA.toString() === HA.toString();
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tab,
            {
              "data-testid": "stTab",
              title: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: AI, allowHTML: !1, isLabel: !0 }),
              disabled: !IA && TA,
              overrides: {
                TabPanel: {
                  style: () => ({
                    paddingLeft: bA.spacing.none,
                    paddingRight: bA.spacing.none,
                    paddingBottom: bA.spacing.none,
                    paddingTop: bA.spacing.lg
                  })
                },
                Tab: {
                  style: () => ({
                    height: zA,
                    whiteSpace: "nowrap",
                    paddingLeft: bA.spacing.none,
                    paddingRight: bA.spacing.none,
                    paddingTop: bA.spacing.none,
                    paddingBottom: bA.spacing.none,
                    fontSize: bA.fontSizes.sm,
                    background: "transparent",
                    color: bA.colors.bodyText,
                    ":focus": {
                      outline: "none",
                      color: bA.colors.primary,
                      background: "none"
                    },
                    ":hover": {
                      color: bA.colors.primary,
                      background: "none"
                    },
                    ...QI ? {
                      color: bA.colors.primary
                    } : {},
                    // Apply stale effect if only this specific
                    // tab is stale but not the entire tab container.
                    ...!IA && TA && STALE_STYLES
                  })
                }
              },
              children: CA.renderTabContent(ZA)
            },
            HA
          );
        })
      }
    ),
    RA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledScrollArrow, { position: "left", tabHeight: zA, onClick: JA, "aria-label": "Scroll tabs left", "data-testid": "stTabsScrollLeft", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: ChevronLeft, size: "lg" }) }),
    dA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledScrollArrow, { position: "right", tabHeight: zA, onClick: UA, "aria-label": "Scroll tabs right", "data-testid": "stTabsScrollRight", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: ChevronRight, size: "lg" }) })
  ] });
}
const Tabs$1 = memo(Tabs), FormsContext = createContext(null);
FormsContext.displayName = "FormsContext";
const StyledAlertContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb541"
} : {
  target: "e1eexb541",
  label: "StyledAlertContent"
})(({
  theme: CA
}) => ({
  display: "flex",
  gap: CA.spacing.sm,
  width: "100%",
  [`${StyledCodeBlock} code`]: {
    paddingRight: CA.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9Ca0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */"), StyledAlertIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eexb540"
} : {
  target: "e1eexb540",
  label: "StyledAlertIcon"
})(({
  theme: CA
}) => ({
  position: "relative",
  top: CA.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9BbGVydEVsZW1lbnQvc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCK0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0FsZXJ0RWxlbWVudC9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgU3R5bGVkQ29kZUJsb2NrIH0gZnJvbSBcIn5saWIvY29tcG9uZW50cy9lbGVtZW50cy9Db2RlQmxvY2svc3R5bGVkLWNvbXBvbmVudHNcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWxlcnRDb250ZW50ID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICB3aWR0aDogXCIxMDAlXCIsXG5cbiAgW2Ake1N0eWxlZENvZGVCbG9ja30gY29kZWBdOiB7XG4gICAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLmxnLFxuICB9LFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBbGVydEljb24gPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxufSkpXG4iXX0= */");
function AlertElement({
  icon: CA,
  body: gA,
  kind: AA
}) {
  const IA = useEmotionTheme(), BA = {
    // Fix issue #6394 - Need to account for icon size (iconSizes.lg) + gap when icon present
    width: CA ? `calc(100% - (${IA.iconSizes.lg} + ${IA.spacing.sm}))` : "100%"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAlert", "data-testid": "stAlert", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAlertContent, { children: [
    CA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAlertIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: CA, size: "lg", testid: "stAlertDynamicIcon" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: gA, allowHTML: !1, style: BA })
  ] }) }) });
}
const AlertElement$1 = memo(AlertElement), useRequiredContext = (CA) => {
  const gA = useContext(CA);
  if (gA == null)
    throw new Error(`useRequiredContext: ${CA.displayName ?? "context"} not found`);
  return gA;
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$c() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledFormSubmitContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by2"
} : {
  target: "e10yg2by2",
  label: "StyledFormSubmitContent"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
}), StyledForm = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by1"
} : {
  target: "e10yg2by1",
  label: "StyledForm"
})(({
  theme: CA,
  border: gA,
  overflow: AA
}) => ({
  ...gA && {
    border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
    borderRadius: CA.radii.default,
    padding: `calc(${CA.spacing.lg} - ${CA.sizes.borderWidth})`
  },
  width: "100%",
  height: "100%",
  overflow: AA
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10yg2by0"
} : {
  target: "e10yg2by0",
  label: "StyledErrorContainer"
})(({
  theme: CA
}) => ({
  marginTop: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), MISSING_SUBMIT_BUTTON_WARNING = `**Missing Submit Button**

This form has no submit button, which means that user interactions will never be sent to your Streamlit app.

To create a submit button, use the \`st.form_submit_button()\` function.

For more information, refer to the [documentation for forms](https://docs.streamlit.io/develop/api-reference/execution-flow/st.form).`;
function Form(CA) {
  const {
    formId: gA,
    widgetMgr: AA,
    children: IA,
    clearOnSubmit: BA,
    enterToSubmit: QA,
    border: EA,
    overflow: iA
  } = CA, {
    formsData: oA
  } = useRequiredContext(FormsContext), cA = oA.submitButtons.get(gA), tA = cA !== void 0 && cA.length > 0, {
    scriptRunState: eA
  } = useContext(ScriptRunContext), aA = eA === ScriptRunState.NOT_RUNNING;
  useEffect(() => {
    AA.setFormSubmitBehaviors(gA, BA, QA);
  }, [AA, gA, BA, QA]);
  const [GA, lA] = useState(!1);
  tA && GA ? lA(!1) : !tA && !GA && aA && lA(!0);
  let nA;
  return GA && (nA = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { body: MISSING_SUBMIT_BUTTON_WARNING, kind: Kind.ERROR }) })), /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledForm, { className: "stForm", "data-testid": "stForm", border: EA, overflow: iA, children: [
    IA,
    nA
  ] });
}
const Form$1 = memo(Form);
function squareStepper(CA, gA) {
  const AA = Math.sign(gA - CA), IA = Math.sqrt(Math.abs(gA - CA)), BA = CA + IA * AA;
  return AA > 0 ? Math.min(gA, BA) : Math.max(gA, BA);
}
function step(CA, gA, AA, IA) {
  let BA = CA;
  for (let QA = 0; QA < IA; QA++)
    BA = AA(BA, gA);
  return BA;
}
function useScrollAnimation(CA, gA, AA, IA) {
  const BA = useRef(0), QA = useCallback((iA, oA, cA = Date.now()) => {
    cancelAnimationFrame(BA.current), BA.current = requestAnimationFrame(() => {
      if (CA) {
        const tA = CA.scrollHeight - CA.offsetHeight;
        let eA = step(iA, tA, squareStepper, (Date.now() - cA) / 5);
        Math.abs(tA - eA) < 1.5 && (eA = tA), CA.scrollTop = eA, tA === eA ? gA() : QA(iA, oA + 1, cA);
      }
    });
  }, [BA, gA, CA]), EA = useCallback(() => {
    cancelAnimationFrame(BA.current), gA();
  }, [gA]);
  useLayoutEffect$1(() => {
    if (!(!CA || !AA || !IA))
      return QA(CA.scrollTop, 1), CA ? (CA.addEventListener("pointerdown", EA, {
        passive: !0
      }), CA.addEventListener("wheel", EA, {
        passive: !0
      }), () => {
        CA.removeEventListener("pointerdown", EA), CA.removeEventListener("wheel", EA), cancelAnimationFrame(BA.current);
      }) : () => cancelAnimationFrame(BA.current);
  }, [QA, BA, EA, CA, AA, IA]);
}
const DEFAULT_DEBOUNCE_MS = 100;
function useScrollSpy(CA, gA, AA) {
  const IA = useRef(gA), BA = useRef(0), QA = useRef();
  useEffect(() => {
    IA.current = gA;
  }, [gA]);
  const {
    clear: EA,
    restart: iA
  } = useTimeout(() => {
    QA.current && (IA.current(QA.current), QA.current = void 0, BA.current = Date.now());
  }, DEFAULT_DEBOUNCE_MS, {
    autoStart: !1
  }), oA = useCallback((tA) => {
    const eA = Date.now(), aA = eA - BA.current;
    if (aA > DEFAULT_DEBOUNCE_MS) {
      EA(), QA.current = void 0, IA.current(tA), BA.current = eA;
      return;
    }
    QA.current = tA, iA(Math.max(0, DEFAULT_DEBOUNCE_MS - aA));
  }, [EA, iA]), cA = useCallback((tA) => {
    const eA = {
      timeStampLow: Date.now(),
      target: tA.target
    };
    oA(eA);
  }, [oA]);
  useLayoutEffect$1(() => !CA || !AA ? () => {
    EA(), QA.current = void 0;
  } : (CA.addEventListener("scroll", cA, {
    passive: !0
  }), oA({
    timeStampLow: Date.now(),
    target: CA
  }), () => {
    CA.removeEventListener("scroll", cA), EA(), QA.current = void 0;
  }), [AA, EA, oA, cA, CA]);
}
function useStateRef(CA) {
  const [gA, AA] = useState(CA), IA = useRef(CA);
  return IA.current = gA, [gA, AA, IA];
}
const DEFAULT_BOTTOM_THRESHOLD = 1, SCROLL_DECISION_DURATION = 34, MIN_CHECK_INTERVAL = 17;
function setImmediateInterval(CA, gA) {
  return CA(), setInterval(CA, gA);
}
function isAtBottom({
  scrollHeight: CA,
  offsetHeight: gA,
  scrollTop: AA
}) {
  return CA - AA - gA < DEFAULT_BOTTOM_THRESHOLD;
}
function useScrollToBottom(CA) {
  const gA = useRef(null), [AA, IA, BA] = useStateRef(!1), [QA, EA, iA] = useStateRef(!0);
  useEffect(() => {
    IA(!0);
  }, [IA]);
  const oA = useRef(0), cA = useRef(0), tA = useRef(0), eA = useCallback(() => {
    oA.current = Date.now(), iA.current || IA(!1), EA(!1);
  }, [oA, iA, EA, IA]), aA = useCallback(({
    timeStampLow: GA
  }) => {
    const {
      current: lA
    } = gA, nA = iA.current;
    if (GA <= oA.current || !lA)
      return;
    const DA = isAtBottom(lA), {
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      offsetHeight: hA,
      // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
      scrollHeight: wA
    } = lA, {
      current: sA
    } = cA, {
      current: NA
    } = tA, rA = hA !== sA, yA = wA !== NA;
    if (rA && (cA.current = hA), yA && (tA.current = wA), !rA && !yA) {
      const bA = nA || DA;
      BA.current !== bA && IA(bA);
    } else BA.current && (EA(!0), IA(!0));
  }, [oA, cA, tA, iA, BA, EA, IA]);
  return useEffect(() => {
    if (gA.current && CA) {
      let GA = 0;
      const lA = setImmediateInterval(() => {
        const {
          current: nA
        } = gA, DA = iA.current;
        BA.current && nA ? isAtBottom(nA) ? GA = 0 : GA ? Date.now() - GA > SCROLL_DECISION_DURATION && (DA || (EA(!0), IA(!0)), GA = 0) : GA = Date.now() : nA && // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
        nA.scrollHeight <= nA.offsetHeight && !BA.current && IA(!0);
      }, MIN_CHECK_INTERVAL);
      return () => clearInterval(lA);
    }
  }, [gA, AA, QA, iA, BA, IA, EA, CA]), useEffect(() => {
    const GA = gA.current;
    if (GA && CA) {
      const lA = () => {
        tA.current = GA.scrollHeight;
      };
      return GA.addEventListener("focus", lA, {
        capture: !0,
        passive: !0
      }), () => {
        GA.removeEventListener("focus", lA, {
          capture: !0
        });
      };
    }
  }, [gA, CA]), useScrollSpy(gA.current, aA, CA), useScrollAnimation(
    // eslint-disable-next-line react-hooks/refs -- TODO: Do not access ref during render
    gA.current,
    eA,
    QA,
    CA
  ), gA;
}
const Maybe = memo(function CA({
  children: gA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: gA });
}, (CA, gA) => !(CA.enable || gA.enable));
function getAlertElementKind(CA) {
  switch (CA) {
    case Alert.Format.ERROR:
      return Kind.ERROR;
    case Alert.Format.INFO:
      return Kind.INFO;
    case Alert.Format.SUCCESS:
      return Kind.SUCCESS;
    case Alert.Format.WARNING:
      return Kind.WARNING;
    default:
      throw new Error(`Unexpected alert type: ${CA}`);
  }
}
const LOG$c = loglevelExports.getLogger("useCopyToClipboard"), useCopyToClipboard = ({
  timeout: CA = 2e3
} = {}) => {
  const [gA, AA] = useState(!1), {
    restart: IA
  } = useTimeout(useCallback(() => {
    AA(!1);
  }, []), gA ? CA : null), BA = useCallback((EA) => {
    (async () => {
      try {
        await navigator.clipboard.writeText(EA), AA(!0), IA();
      } catch (oA) {
        LOG$c.error("Failed to copy text to clipboard:", oA), AA(!1);
      }
    })();
  }, [IA]);
  return {
    isCopied: gA,
    copyToClipboard: BA,
    label: gA ? "Copied" : "Copy to clipboard"
  };
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$b() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledStackTraceRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv7"
} : {
  target: "e1dl0tyv7",
  label: "StyledStackTraceRow"
})(({
  theme: CA
}) => ({
  marginTop: CA.spacing.sm,
  "&:first-of-type": {
    marginTop: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMessageType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv6"
} : {
  target: "e1dl0tyv6",
  label: "StyledMessageType"
})(({
  theme: CA
}) => ({
  fontWeight: CA.fontWeights.bold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceTitle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv5"
} : {
  target: "e1dl0tyv5",
  label: "StyledStackTraceTitle"
})(({
  theme: CA
}) => ({
  marginBottom: CA.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStackTraceContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv4"
} : {
  target: "e1dl0tyv4",
  label: "StyledStackTraceContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%"
} : {
  name: "1flqko7",
  styles: "display:inline-block;min-width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionMessage = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv3"
} : {
  target: "e1dl0tyv3",
  label: "StyledExceptionMessage"
})(process.env.NODE_ENV === "production" ? {
  name: "10s3lzp",
  styles: "word-wrap:break-word"
} : {
  name: "10s3lzp",
  styles: "word-wrap:break-word/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionLinks = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv2"
} : {
  target: "e1dl0tyv2",
  label: "StyledExceptionLinks"
})(({
  theme: CA
}) => ({
  fontSize: CA.fontSizes.sm,
  display: "flex",
  flexWrap: "wrap",
  gap: CA.spacing.md,
  justifyContent: "flex-end"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledExceptionCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv1"
} : {
  target: "e1dl0tyv1",
  label: "StyledExceptionCopyButton"
})(process.env.NODE_ENV === "production" ? {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline"
} : {
  name: "x9hjea",
  styles: "all:unset;font:inherit;text-decoration:underline/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
}), StyledExceptionWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dl0tyv0"
} : {
  target: "e1dl0tyv0",
  label: "StyledExceptionWrapper"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function isNonEmptyString(CA) {
  return notNullOrUndefined(CA) && CA !== "";
}
function ExceptionMessage({
  type: CA,
  message: gA,
  messageIsMarkdown: AA
}) {
  if (AA) {
    let IA = gA ?? "";
    return CA.length !== 0 && (IA = `**${CA}**: ${IA}`), /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: IA, allowHTML: !1 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMessageType, { children: CA }),
    CA.length !== 0 && ": ",
    isNonEmptyString(gA) ? gA : null
  ] });
}
function StackTrace({
  stackTrace: CA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceTitle, { children: "Traceback:" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTrace, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStackTraceContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: CA.map((gA, AA) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      StyledStackTraceRow,
      {
        "data-testid": "stExceptionTraceRow",
        children: gA
      },
      AA
    )) }) }) })
  ] });
}
function ExceptionElement({
  element: CA
}) {
  const {
    showErrorLinks: gA = Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO
  } = useContext(LibConfigContext), AA = gA === Config.ShowErrorLinks.SHOW_ERROR_LINKS_TRUE || gA === Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO && isLocalhost(), IA = `${CA.type}: ${CA.message}`, BA = `${IA}

${CA.stackTrace?.join(`
`)}`, QA = `https://www.google.com/search?q=${encodeURIComponent(IA)}`, EA = `https://chatgpt.com/?q=${encodeURIComponent(BA)}`, {
    copyToClipboard: iA
  } = useCopyToClipboard(), oA = useCallback(() => {
    iA(BA);
  }, [iA, BA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stException", "data-testid": "stException", children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertContainer, { kind: CA.isWarning ? Kind.WARNING : Kind.ERROR, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionMessage, { "data-testid": "stExceptionMessage", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionMessage, { type: CA.type, message: CA.message, messageIsMarkdown: CA.messageIsMarkdown }) }),
    CA.stackTrace && CA.stackTrace.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StackTrace, { stackTrace: CA.stackTrace }) : null,
    AA && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledExceptionLinks, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledExceptionCopyButton, { onClick: oA, children: "Copy" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: QA, target: "_blank", rel: "noopener noreferrer", children: "Ask Google" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: EA, target: "_blank", rel: "noopener noreferrer", children: "Ask ChatGPT" })
    ] })
  ] }) }) });
}
const ExceptionElement$1 = memo(ExceptionElement), StyledDocSummary = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf10"
} : {
  target: "epr3rsf10",
  label: "StyledDocSummary"
})(({
  theme: CA
}) => ({
  "& > *": {
    marginRight: CA.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9IZWxwL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCZ0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0hlbHAvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY1N1bW1hcnkgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiYgPiAqXCI6IHtcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jTmFtZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmNvZGVCb2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NUeXBlID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5jb2RlVGV4dENvbG9yLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NWYWx1ZSA9IHN0eWxlZC5zcGFuKClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY0NvbnRhaW5lciA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5jb2RlRm9udCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmNvZGUsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY0hlYWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnTWl4LFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAvLyBBZGQgcm91bmRlZCBjb3JuZXJzIHRvIHRoZSB0b3Agb2YgdGhlIGNvbnRhaW5lciB0byBwcmV2ZW50IHRoZSBiYWNrZ3JvdW5kXG4gIC8vIGNvbG9yIGZyb20gYmxlZWRpbmcgaW50byB0aGUgc3Vycm91bmRpbmcgYXJlYS5cbiAgYm9yZGVyVG9wTGVmdFJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgYm9yZGVyVG9wUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBvdmVyZmxvdzogXCJhdXRvXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY1N0cmluZyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJwcmVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBtYXhIZWlnaHQ6IFwiMzAuNXJlbVwiLCAvLyBUaGUgZXh0cmEgMC41cmVtIGlzIHRvIHNob3cgYSBsaXR0bGUgb2YgdGhlIG92ZXJmbG93aW5nIGxpbmUuXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcblxuICBcIiY6bm90KDpsYXN0LWNoaWxkKVwiOiB7XG4gICAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVtYmVyc1RhYmxlID0gc3R5bGVkLnRhYmxlKCh7IHRoZW1lIH0pID0+ICh7XG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnTWl4LFxuICB0YWJsZUxheW91dDogXCJmaXhlZFwiLCAvLyBGaXggdGFibGUgdG8gY29udGFpbmVyJ3MgYm91bmRhcmllcy5cbiAgYm9yZGVyQ29sbGFwc2U6IFwiY29sbGFwc2VcIixcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgYm90dG9tIG9mIHRoZSB0YWJsZSB0byBtYXRjaCBjb250YWluZXJcbiAgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgYm9yZGVyQm90dG9tUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNSb3cgPSBzdHlsZWQudHIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNTdW1tYXJ5Q2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIzMCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcblxuICBcIiYgPiAqXCI6IHtcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVtYmVyc0RldGFpbHNDZWxsID0gc3R5bGVkLnRkKCh7IHRoZW1lIH0pID0+ICh7XG4gIHdpZHRoOiBcIjcwJVwiLFxuICBvdmVyZmxvdzogXCJhdXRvXCIsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG4iXX0= */"), StyledDocName = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf9"
} : {
  target: "epr3rsf9",
  label: "StyledDocName"
})(({
  theme: CA
}) => ({
  fontWeight: CA.fontWeights.codeBold
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocType = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf8"
} : {
  target: "epr3rsf8",
  label: "StyledDocType"
})(({
  theme: CA
}) => ({
  color: CA.colors.codeTextColor
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocValue = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf7"
} : {
  target: "epr3rsf7",
  label: "StyledDocValue"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf6"
} : {
  target: "epr3rsf6",
  label: "StyledDocContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: CA.radii.default,
  border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
  fontFamily: CA.genericFonts.codeFont,
  fontSize: CA.fontSizes.codeFontSize,
  fontWeight: CA.fontWeights.code
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDocHeader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf5"
} : {
  target: "epr3rsf5",
  label: "StyledDocHeader"
})(({
  theme: CA
}) => ({
  padding: `${CA.spacing.sm} ${CA.spacing.lg}`,
  backgroundColor: CA.colors.bgMix,
  borderBottom: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
  // Add rounded corners to the top of the container to prevent the background
  // color from bleeding into the surrounding area.
  borderTopLeftRadius: CA.radii.default,
  borderTopRightRadius: CA.radii.default,
  fontSize: CA.fontSizes.codeFontSize,
  overflow: "auto"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvY29tcG9uZW50cy9lbGVtZW50cy9IZWxwL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRDK0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvbGliL3NyYy9jb21wb25lbnRzL2VsZW1lbnRzL0hlbHAvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY1N1bW1hcnkgPSBzdHlsZWQuc3BhbigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiYgPiAqXCI6IHtcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRG9jTmFtZSA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmNvZGVCb2xkLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NUeXBlID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5jb2RlVGV4dENvbG9yLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREb2NWYWx1ZSA9IHN0eWxlZC5zcGFuKClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY0NvbnRhaW5lciA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGJvcmRlcjogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIGZvbnRGYW1pbHk6IHRoZW1lLmdlbmVyaWNGb250cy5jb2RlRm9udCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLmNvZGUsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY0hlYWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy5zbX0gJHt0aGVtZS5zcGFjaW5nLmxnfWAsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnTWl4LFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICAvLyBBZGQgcm91bmRlZCBjb3JuZXJzIHRvIHRoZSB0b3Agb2YgdGhlIGNvbnRhaW5lciB0byBwcmV2ZW50IHRoZSBiYWNrZ3JvdW5kXG4gIC8vIGNvbG9yIGZyb20gYmxlZWRpbmcgaW50byB0aGUgc3Vycm91bmRpbmcgYXJlYS5cbiAgYm9yZGVyVG9wTGVmdFJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgYm9yZGVyVG9wUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuY29kZUZvbnRTaXplLFxuICBvdmVyZmxvdzogXCJhdXRvXCIsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZERvY1N0cmluZyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJwcmVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBtYXhIZWlnaHQ6IFwiMzAuNXJlbVwiLCAvLyBUaGUgZXh0cmEgMC41cmVtIGlzIHRvIHNob3cgYSBsaXR0bGUgb2YgdGhlIG92ZXJmbG93aW5nIGxpbmUuXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLmNvZGVGb250U2l6ZSxcblxuICBcIiY6bm90KDpsYXN0LWNoaWxkKVwiOiB7XG4gICAgYm9yZGVyQm90dG9tOiBgJHt0aGVtZS5zaXplcy5ib3JkZXJXaWR0aH0gc29saWQgJHt0aGVtZS5jb2xvcnMuYm9yZGVyQ29sb3J9YCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVtYmVyc1RhYmxlID0gc3R5bGVkLnRhYmxlKCh7IHRoZW1lIH0pID0+ICh7XG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5jb2RlRm9udFNpemUsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnTWl4LFxuICB0YWJsZUxheW91dDogXCJmaXhlZFwiLCAvLyBGaXggdGFibGUgdG8gY29udGFpbmVyJ3MgYm91bmRhcmllcy5cbiAgYm9yZGVyQ29sbGFwc2U6IFwiY29sbGFwc2VcIixcbiAgLy8gQWRkIHJvdW5kZWQgY29ybmVycyB0byB0aGUgYm90dG9tIG9mIHRoZSB0YWJsZSB0byBtYXRjaCBjb250YWluZXJcbiAgYm9yZGVyQm90dG9tTGVmdFJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgYm9yZGVyQm90dG9tUmlnaHRSYWRpdXM6IHRoZW1lLnJhZGlpLmRlZmF1bHQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNSb3cgPSBzdHlsZWQudHIoKHsgdGhlbWUgfSkgPT4gKHtcbiAgXCImOm5vdCg6bGFzdC1jaGlsZClcIjoge1xuICAgIGJvcmRlckJvdHRvbTogYCR7dGhlbWUuc2l6ZXMuYm9yZGVyV2lkdGh9IHNvbGlkICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfWAsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbWJlcnNTdW1tYXJ5Q2VsbCA9IHN0eWxlZC50ZCgoeyB0aGVtZSB9KSA9PiAoe1xuICB3aWR0aDogXCIzMCVcIixcbiAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcubGd9YCxcblxuICBcIiYgPiAqXCI6IHtcbiAgICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTWVtYmVyc0RldGFpbHNDZWxsID0gc3R5bGVkLnRkKCh7IHRoZW1lIH0pID0+ICh7XG4gIHdpZHRoOiBcIjcwJVwiLFxuICBvdmVyZmxvdzogXCJhdXRvXCIsXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcuc219ICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG4iXX0= */"), StyledDocString = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf4"
} : {
  target: "epr3rsf4",
  label: "StyledDocString"
})(({
  theme: CA
}) => ({
  whiteSpace: "pre",
  overflow: "auto",
  maxHeight: "30.5rem",
  // The extra 0.5rem is to show a little of the overflowing line.
  padding: `${CA.spacing.sm} ${CA.spacing.lg}`,
  fontSize: CA.fontSizes.codeFontSize,
  "&:not(:last-child)": {
    borderBottom: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersTable = /* @__PURE__ */ createStyled("table", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf3"
} : {
  target: "epr3rsf3",
  label: "StyledMembersTable"
})(({
  theme: CA
}) => ({
  width: "100%",
  fontSize: CA.fontSizes.codeFontSize,
  backgroundColor: CA.colors.bgMix,
  tableLayout: "fixed",
  // Fix table to container's boundaries.
  borderCollapse: "collapse",
  // Add rounded corners to the bottom of the table to match container
  borderBottomLeftRadius: CA.radii.default,
  borderBottomRightRadius: CA.radii.default
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersRow = /* @__PURE__ */ createStyled("tr", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf2"
} : {
  target: "epr3rsf2",
  label: "StyledMembersRow"
})(({
  theme: CA
}) => ({
  "&:not(:last-child)": {
    borderBottom: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersSummaryCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf1"
} : {
  target: "epr3rsf1",
  label: "StyledMembersSummaryCell"
})(({
  theme: CA
}) => ({
  width: "30%",
  overflow: "auto",
  padding: `${CA.spacing.sm} ${CA.spacing.lg}`,
  "& > *": {
    marginRight: CA.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMembersDetailsCell = /* @__PURE__ */ createStyled("td", process.env.NODE_ENV === "production" ? {
  target: "epr3rsf0"
} : {
  target: "epr3rsf0",
  label: "StyledMembersDetailsCell"
})(({
  theme: CA
}) => ({
  width: "70%",
  overflow: "auto",
  padding: `${CA.spacing.sm} ${CA.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function Help({
  element: CA
}) {
  const {
    name: gA,
    type: AA,
    value: IA,
    docString: BA,
    members: QA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocContainer, { className: "stHelp", "data-testid": "stHelp", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDocSummary, { children: [
      gA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpName", children: gA }) : null,
      AA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpType", children: AA }) : null,
      IA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpValue", children: IA }) : null
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocString, { "data-testid": "stHelpDoc", children: BA || "No docs available" }),
    QA.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersTable, { "data-testid": "stHelpMembersTable", children: /* @__PURE__ */ jsxRuntimeExports.jsx("tbody", { children: QA.map((EA) => /* @__PURE__ */ jsxRuntimeExports.jsx(Member, { member: EA }, EA.name)) }) }) : null
  ] });
}
function Member({
  member: CA
}) {
  const {
    name: gA,
    type: AA,
    value: IA,
    docString: BA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersRow, { "data-testid": "stHelpMember", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMembersSummaryCell, { children: [
      gA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocName, { "data-testid": "stHelpMemberDocName", children: gA }) : null,
      AA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocType, { "data-testid": "stHelpMemberDocType", children: AA }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMembersDetailsCell, { children: IA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocValue", children: IA }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocValue, { "data-testid": "stHelpMemberDocString", children: BA || "No docs available" }) })
  ] });
}
const Help$1 = memo(Help), SINGLE_BADGE_REGEX = /^:\w+-badge\[((?:\\.|[^\]\\])*)\]$/;
function Markdown({
  element: CA
}) {
  const {
    allowHtml: gA,
    body: AA,
    elementType: IA,
    help: BA,
    unterminatedParsing: QA
  } = CA, EA = IA === Markdown$3.Type.CAPTION, iA = IA === Markdown$3.Type.LATEX, oA = IA === Markdown$3.Type.NATIVE && SINGLE_BADGE_REGEX.test(AA.trim());
  let cA;
  if (BA && oA)
    cA = /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButtonTooltip, { help: BA, containerWidth: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: EA, source: AA, allowHTML: gA, unterminatedParsing: QA }) });
  else if (BA && iA)
    cA = /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelHelpWrapper, { isLatex: iA, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: EA, source: AA, allowHTML: gA, unterminatedParsing: QA }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: BA, isLatex: iA })
    ] });
  else {
    const tA = BA ? `${AA} :help[]` : AA;
    cA = /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { isLatex: iA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { isCaption: EA, source: tA, allowHTML: gA, helpText: BA, unterminatedParsing: QA }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stMarkdown", "data-testid": "stMarkdown", children: cA });
}
const Markdown$1 = memo(Markdown), StyledText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b1"
} : {
  target: "exotz4b1",
  label: "StyledText"
})(({
  theme: CA
}) => ({
  fontFamily: CA.genericFonts.bodyFont,
  color: CA.colors.bodyText,
  whiteSpace: "pre-line",
  whiteSpaceCollapse: "preserve",
  wordBreak: "break-word",
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInlineHelpIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "exotz4b0"
} : {
  target: "exotz4b0",
  label: "StyledInlineHelpIcon"
})(({
  theme: CA
}) => ({
  display: "inline-block",
  verticalAlign: "middle",
  marginLeft: CA.spacing.twoXS,
  // Fine-tune vertical positioning for perfect visual centering
  transform: "translateY(-0.05em)"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function TextElement({
  element: CA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabelHelpWrapper, { className: "stText", "data-testid": "stText", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledText, { children: [
    CA.body,
    CA.help && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInlineHelpIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(InlineTooltipIcon, { content: CA.help }) })
  ] }) });
}
const TextElement$1 = memo(TextElement), katex_min = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
function makeMarkdownHeading(CA, gA) {
  switch (CA.toLowerCase()) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H1:
      return `# ${gA}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H2:
      return `## ${gA}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- TODO: Fix this
    case Tags.H3:
      return `### ${gA}`;
    default:
      throw new Error(`Unrecognized tag for header: ${CA}`);
  }
}
const OVERRIDE_COMPONENTS = {
  p: Fragment,
  h1: Fragment,
  h2: Fragment,
  h3: Fragment,
  h4: Fragment,
  h5: Fragment,
  h6: Fragment
};
function Heading(CA) {
  const {
    element: gA
  } = CA, {
    tag: AA,
    anchor: IA,
    body: BA,
    help: QA,
    hideAnchor: EA,
    divider: iA
  } = gA, oA = useContext(IsDialogContext), cA = useContext(FlexContext), [tA, ...eA] = BA.split(`
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "stHeading", "data-testid": "stHeading", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledStreamlitMarkdown, { isCaption: !1, isInDialog: oA, isInHorizontalLayout: cA?.isInHorizontalLayout, "data-testid": "stMarkdownContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeadingWithActionElements, { anchor: IA, help: QA, hideAnchor: EA, tag: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        RenderedMarkdown,
        {
          allowHTML: !1,
          source: makeMarkdownHeading(AA, tA),
          overrideComponents: OVERRIDE_COMPONENTS
        }
      ) }),
      eA.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(RenderedMarkdown, { source: eA.join(`
`), allowHTML: !1 })
    ] }),
    iA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderDivider, { "data-testid": "stHeadingDivider", rainbow: iA.includes("linear"), color: iA })
  ] });
}
const ViewStateContext = createContext({
  isFullScreen: !1,
  setFullScreen: () => {
  }
});
ViewStateContext.displayName = "ViewStateContext";
const StyledCheckbox = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd611"
} : {
  target: "edwcd611",
  label: "StyledCheckbox"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  minHeight: CA.sizes.smallElementHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "edwcd610"
} : {
  target: "edwcd610",
  label: "StyledContent"
})(({
  visibility: CA
}) => ({
  display: CA === LabelVisibilityOptions.Collapsed ? "none" : "flex",
  visibility: CA === LabelVisibilityOptions.Hidden ? "hidden" : "visible",
  verticalAlign: "middle",
  flexDirection: "row",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function _EMOTION_STRINGIFIED_CSS_ERROR__$a() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function translateGapWidth(CA, gA) {
  switch (CA) {
    case streamlit.GapSize.XXSMALL:
      return gA.spacing.twoXS;
    case streamlit.GapSize.XSMALL:
      return gA.spacing.sm;
    case streamlit.GapSize.SMALL:
      return gA.spacing.lg;
    case streamlit.GapSize.MEDIUM:
      return gA.spacing.threeXL;
    case streamlit.GapSize.LARGE:
      return gA.spacing.fourXL;
    case streamlit.GapSize.XLARGE:
      return gA.spacing.fiveXL;
    case streamlit.GapSize.XXLARGE:
      return gA.spacing.sixXL;
    case streamlit.GapSize.NONE:
      return gA.spacing.none;
    default:
      return gA.spacing.lg;
  }
}
const StyledSpace = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn4"
} : {
  target: "e1f1d6gn4",
  label: "StyledSpace"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
}), GLOBAL_ELEMENTS = ["balloons", "snow"], StyledElementContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn3"
} : {
  target: "e1f1d6gn3",
  label: "StyledElementContainer"
})(({
  theme: CA,
  isStale: gA,
  width: AA,
  height: IA,
  elementType: BA,
  overflow: QA,
  flex: EA,
  minWidth: iA,
  textAlign: oA
}) => ({
  width: AA,
  height: IA,
  textAlign: oA,
  maxWidth: "100%",
  // Important so that individual elements don't take up too much space
  // in horizontal layouts. Particularly when an element uses the full screen wrapper.
  // Some components support zero width (e.g. iframe).
  minWidth: AA === "0px" ? 0 : iA ?? "1rem",
  // Allows to have absolutely-positioned nodes inside app elements, like
  // floating buttons.
  position: "relative",
  overflow: QA,
  flex: EA,
  "@media print": {
    overflow: "visible"
  },
  ":has(> .stCacheSpinner)": {
    height: CA.spacing.none,
    overflow: "visible",
    visibility: "visible",
    marginBottom: `-${CA.spacing.lg}`,
    zIndex: CA.zIndices.cacheSpinner
  },
  ":has(> .stPageLink)": {
    marginTop: `-${CA.spacing.xs}`,
    marginBottom: `-${CA.spacing.xs}`
  },
  ...gA && BA !== "skeleton" && STALE_STYLES,
  ...BA === "empty" ? {
    // Use display: none for empty elements to avoid the flexbox gap.
    display: "none"
  } : {},
  ...BA === "space" ? {
    // Space elements should have minimal cross-axis dimensions.
    // The FlexContext logic in StyledElementContainerLayoutWrapper handles
    // the primary dimension (width for horizontal, height for vertical).
    minWidth: 0,
    minHeight: 0
  } : {},
  ...GLOBAL_ELEMENTS.includes(BA) ? {
    // Global elements are rendered in their delta position, but they
    // are not part of the flexbox layout. We apply a negative margin
    // to remove the flexbox gap. display: none does not work for these,
    // since they needs to be visible.
    marginBottom: `-${CA.spacing.lg}`
  } : {}
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn2"
} : {
  target: "e1f1d6gn2",
  label: "StyledColumn"
})(({
  theme: CA,
  weight: gA,
  gap: AA,
  showBorder: IA,
  verticalAlignment: BA
}) => {
  const {
    VerticalAlignment: QA
  } = Block$1.Column, EA = gA * 100, iA = translateGapWidth(AA, CA), oA = iA === CA.spacing.none ? `${EA}%` : `calc(${EA}% - ${iA})`;
  return {
    // Calculate width based on percentage, but fill all available space,
    // e.g. if it overflows to next row.
    width: oA,
    flex: `1 1 ${oA}`,
    [`@media (max-width: ${CA.breakpoints.columns})`]: {
      minWidth: `calc(100% - ${CA.spacing.twoXL})`
    },
    ...BA === QA.BOTTOM && {
      marginTop: "auto",
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:last-of-type > ${StyledCheckbox}`]: {
        marginBottom: CA.spacing.sm
      }
    },
    ...BA === QA.TOP && {
      // Add margin to the first checkbox/toggle within the column to align it
      // better with other input widgets.
      [`& ${StyledElementContainer}:first-of-type > ${StyledCheckbox}`]: {
        marginTop: CA.spacing.sm
      }
    },
    ...BA === QA.CENTER && {
      marginTop: "auto",
      marginBottom: "auto"
    },
    ...IA && {
      border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
      borderRadius: CA.radii.default,
      padding: `calc(${CA.spacing.lg} - ${CA.sizes.borderWidth})`
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), getAlignItems = (CA) => {
  switch (CA) {
    case Block$1.FlexContainer.Align.ALIGN_START:
      return "start";
    case Block$1.FlexContainer.Align.ALIGN_CENTER:
      return "center";
    case Block$1.FlexContainer.Align.ALIGN_END:
      return "end";
    case Block$1.FlexContainer.Align.STRETCH:
      return "stretch";
    case Block$1.FlexContainer.Align.ALIGN_UNDEFINED:
    case void 0:
    case null:
      return "stretch";
    default:
      return assertNever(CA);
  }
}, getJustifyContent = (CA) => {
  switch (CA) {
    case Block$1.FlexContainer.Justify.JUSTIFY_START:
      return "start";
    case Block$1.FlexContainer.Justify.JUSTIFY_CENTER:
      return "center";
    case Block$1.FlexContainer.Justify.JUSTIFY_END:
      return "end";
    case Block$1.FlexContainer.Justify.SPACE_BETWEEN:
      return "space-between";
    case Block$1.FlexContainer.Justify.JUSTIFY_UNDEFINED:
    case void 0:
    case null:
      return "start";
    default:
      return assertNever(CA);
  }
}, StyledFlexContainerBlock = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn1"
} : {
  target: "e1f1d6gn1",
  label: "StyledFlexContainerBlock"
})(({
  theme: CA,
  direction: gA,
  gap: AA,
  flex: IA,
  $wrap: BA,
  height: QA,
  border: EA,
  align: iA,
  justify: oA,
  overflow: cA
}) => {
  let tA;
  return AA !== void 0 && (tA = translateGapWidth(AA, CA)), {
    display: "flex",
    gap: tA,
    width: "100%",
    maxWidth: "100%",
    height: QA ?? "auto",
    minWidth: "1rem",
    flexDirection: gA,
    flex: IA,
    alignItems: getAlignItems(iA),
    justifyContent: getJustifyContent(oA),
    flexWrap: BA ? "wrap" : "nowrap",
    ...EA && {
      border: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
      borderRadius: CA.radii.default,
      padding: `calc(${CA.spacing.lg} - ${CA.sizes.borderWidth})`
    },
    overflow: cA
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledLayoutWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f1d6gn0"
} : {
  target: "e1f1d6gn0",
  label: "StyledLayoutWrapper"
})(({
  width: CA,
  height: gA,
  flex: AA
}) => ({
  display: "flex",
  // This shouldn't matter since this is a wrapper and should only have one child.
  // However, adding it here to be explicit.
  flexDirection: "column",
  width: CA,
  maxWidth: "100%",
  minWidth: "1rem",
  height: gA,
  flex: AA
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElementContainerLayoutWrapper = ({
  node: CA,
  config: gA,
  ...AA
}) => {
  const {
    isInHorizontalLayout: IA
  } = useRequiredContext(FlexContext), BA = useMemo$1(() => gA.computeStyleOverrides(), [gA]), QA = useMemo$1(() => gA.getMinStretchBehavior(), [gA]);
  let EA = useLayoutStyles({
    element: CA.element,
    subElement: CA.element?.type && CA.element[CA.element.type] || void 0,
    styleOverrides: BA,
    minStretchBehavior: QA
  });
  return CA.element.type === "space" && (IA ? EA = {
    ...EA,
    height: "auto"
  } : EA = {
    ...EA,
    width: "auto"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledElementContainer, { ...AA, ...EA });
}, ElementContainer = ({
  node: CA,
  config: gA,
  isStale: AA,
  children: IA
}) => {
  const {
    isFullScreen: BA
  } = useContext(ViewStateContext), QA = CA.element.type || "", EA = getElementId(CA.element), iA = getKeyFromId(EA);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledElementContainerLayoutWrapper, { className: classNames("stElementContainer", "element-container", convertKeyToClassName(iA)), "data-testid": "stElementContainer", "data-stale": AA, isStale: AA && !BA, elementType: QA, node: CA, config: gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: Skeleton$1.create({
    style: Skeleton$1.SkeletonStyle.ELEMENT
  }) }), children: IA }) }) });
};
var MinStretchWidth = /* @__PURE__ */ ((CA) => (CA.LARGE = "14rem", CA.MEDIUM = "8rem", CA.FIT_CONTENT = "fit-content", CA.NONE = "none", CA))(MinStretchWidth || {});
const WI = class WI {
  constructor(gA = {}) {
    this.minStretchWidth = gA.minStretchWidth ?? "none", this.styleOverrides = gA.styleOverrides;
  }
  /**
   * Creates a new config by merging this config with overrides.
   * Useful for extending pre-defined configs with element-specific adjustments.
   *
   * @example
   * ```typescript
   * ElementContainerConfig.LARGE_ELEMENT.with({ styleOverrides: { overflow: "visible" } })
   * ```
   */
  with(gA) {
    return new WI({
      minStretchWidth: gA.minStretchWidth ?? this.minStretchWidth,
      styleOverrides: gA.styleOverrides !== void 0 ? {
        ...this.styleOverrides,
        ...gA.styleOverrides
      } : this.styleOverrides
    });
  }
  /**
   * Returns the style overrides to be applied to the element container.
   */
  computeStyleOverrides() {
    return this.styleOverrides ?? {};
  }
  /**
   * Returns the minStretchBehavior value for useLayoutStyles.
   * Returns undefined for NONE to maintain backward compatibility.
   */
  getMinStretchBehavior() {
    return this.minStretchWidth === "none" ? void 0 : this.minStretchWidth;
  }
};
WI.DEFAULT = new WI({}), WI.LARGE_ELEMENT = new WI({
  minStretchWidth: "14rem"
  /* LARGE */
}), WI.MEDIUM_ELEMENT = new WI({
  minStretchWidth: "8rem"
  /* MEDIUM */
}), WI.FIT_CONTENT_ELEMENT = new WI({
  minStretchWidth: "fit-content"
  /* FIT_CONTENT */
}), WI.FULL_WIDTH = new WI({
  styleOverrides: {
    width: "100%"
  }
}), WI.LARGE_OVERFLOW_VISIBLE = new WI({
  minStretchWidth: "14rem",
  styleOverrides: {
    overflow: "visible"
  }
});
let ElementContainerConfig = WI;
const Table = lazy(() => import("./Table-JcIvdLi_.js")), ArrowVegaLiteChart = lazy(() => import("./ArrowVegaLiteChart-AuhdMhKC.js")), Audio = lazy(() => import("./Audio-MPOURgx8.js")), Balloons = lazy(() => import("./Balloons-C0le0djA.js")), DeckGlJsonChart = lazy(() => import("./DeckGlJsonChart-dSij3LC8.js")), GraphVizChart = lazy(() => import("./GraphVizChart-BKutiaGH.js")), Html = lazy(() => import("./Html-D45ILBvq.js")), IFrame = lazy(() => import("./IFrame-DK-NJrL7.js")), ImageList = lazy(() => import("./ImageList-I3kPNHfL.js")), Json = lazy(() => import("./Json-DSgvYeF6.js")), LinkButton = lazy(() => import("./LinkButton-DLHHsxjM.js")), Metric = lazy(() => import("./Metric-B0YF468a.js")), PageLink = lazy(() => import("./PageLink--V5rxSOF.js")), PlotlyChart = lazy(() => import("./PlotlyChart-BVhQF5xf.js")), Progress = lazy(() => import("./Progress-BokEk05X.js")), Snow = lazy(() => import("./Snow-dqZuIKEv.js")), Spinner = lazy(() => import("./Spinner-Bk-w9tKQ.js")), StreamlitSyntaxHighlighter = lazy(() => import("./StreamlitSyntaxHighlighter-U8o3ATK-.js")), Toast = lazy(() => import("./Toast-Dxo0ZqMx.js")), Video = lazy(() => import("./Video-CYwcC1JG.js")), AudioInput = lazy(() => import("./AudioInput-D-1IugfD.js")), ArrowDataFrame = lazy(() => import("./DataFrame-BARAH3XB.js").then((CA) => CA.c)), Button = lazy(() => import("./Button-AgVrhiWW.js")), ButtonGroup = lazy(() => import("./ButtonGroup-DhgjbbBB.js")), ComponentInstance = lazy(() => import("./ComponentInstance-CZJj3rmu.js")), CameraInput = lazy(() => import("./CameraInput-CEJ0-YBv.js")), ChatInput = lazy(() => import("./ChatInput-C2YGDsKa.js")), Checkbox = lazy(() => import("./Checkbox-DpcMXROE.js")), ColorPicker = lazy(() => import("./ColorPicker-DfcSCXdu.js")), DateInput = lazy(() => import("./DateInput-dJ0HrH9I.js")), DateTimeInput = lazy(() => import("./DateTimeInput-Dc_pZKKa.js")), DownloadButton = lazy(() => import("./DownloadButton-5Bz1-AC5.js")), Feedback = lazy(() => import("./Feedback-CQYxHKC-.js")), FileUploader = lazy(() => import("./FileUploader-CFj8fg_u.js")), FormSubmitContent = lazy(() => import("./FormSubmitContent-RGGkQf1N.js").then((CA) => ({
  default: CA.FormSubmitContent
}))), Multiselect = lazy(() => import("./Multiselect-CVHVCj3g.js")), MenuButton = lazy(() => import("./MenuButton-Oq8rRct9.js")), NumberInput = lazy(() => import("./NumberInput-eLkJ0pTb.js")), Radio = lazy(() => import("./Radio-CUrfrjvU.js")), Selectbox = lazy(() => import("./Selectbox-DwkeQO0S.js")), Slider = lazy(() => import("./Slider--afJTFYr.js")), TextArea = lazy(() => import("./TextArea-DnpuYIA5.js")), TextInput = lazy(() => import("./TextInput-BOxdqnrF.js")), TimeInput = lazy(() => import("./TimeInput-CjU6O1Hm.js")), BidiComponent = lazy(() => import("./BidiComponent-BsO32qTF.js"));
function hideIfStale(CA, gA) {
  return CA ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : gA;
}
const RawElementNodeRenderer = (CA) => {
  const {
    node: gA,
    isStale: AA
  } = CA, {
    isInRoot: IA,
    isInHorizontalLayout: BA
  } = useRequiredContext(FlexContext);
  if (!gA)
    throw new Error("ElementNode not found.");
  const QA = {
    disableFullscreenMode: CA.disableFullscreenMode,
    widthConfig: gA.element.widthConfig,
    heightConfig: gA.element.heightConfig
  }, EA = {
    ...QA,
    widgetMgr: CA.widgetMgr,
    disabled: CA.widgetsDisabled,
    fragmentId: gA.fragmentId,
    componentRegistry: CA.componentRegistry
  };
  switch (gA.element.type) {
    case "alert": {
      const iA = gA.element.alert;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertElement$1, { icon: iA.icon, body: iA.body, kind: getAlertElementKind(iA.format), ...QA }) });
    }
    case "table": {
      const iA = gA.element.table;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { element: iA, data: gA.quiverElement, ...QA }) });
    }
    case "audio":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Audio, { element: gA.element.audio, endpoints: CA.endpoints, ...QA, elementMgr: CA.widgetMgr }) });
    case "balloons":
      return hideIfStale(AA, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Balloons, { scriptRunId: gA.scriptRunId }) }));
    case "code": {
      const iA = gA.element.code;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitSyntaxHighlighter, { language: iA.language, showLineNumbers: iA.showLineNumbers, wrapLines: iA.wrapLines, children: iA.codeText }) });
    }
    case "deckGlJsonChart": {
      const iA = gA.element.deckGlJsonChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_OVERFLOW_VISIBLE, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        DeckGlJsonChart,
        {
          element: iA,
          ...EA
        },
        iA.id || void 0
      ) });
    }
    case "helpInfo":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Help$1, { element: gA.element.helpInfo, ...QA }) });
    case "empty":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stEmpty", "data-testid": "stEmpty" }) });
    case "exception":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ExceptionElement$1, { element: gA.element.exception, ...QA }) });
    case "graphvizChart":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_OVERFLOW_VISIBLE, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(GraphVizChart, { element: gA.element.graphvizChart, ...QA }) });
    case "heading":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Heading, { element: gA.element.heading, ...QA }) });
    case "iframe":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_OVERFLOW_VISIBLE, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IFrame, { element: gA.element.iframe, ...QA }) });
    case "imgs": {
      const oA = !gA.element.widthConfig || gA.element.widthConfig.useStretch ? ElementContainerConfig.FULL_WIDTH : new ElementContainerConfig({
        styleOverrides: {
          width: "auto"
        }
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: oA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ImageList, { element: gA.element.imgs, endpoints: CA.endpoints, ...QA }) });
    }
    case "json":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Json, { element: gA.element.json, ...QA }) });
    case "markdown": {
      const iA = gA.element.widthConfig ? ElementContainerConfig.DEFAULT : BA ? new ElementContainerConfig({
        styleOverrides: {
          width: "fit-content"
        }
      }) : ElementContainerConfig.FULL_WIDTH;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: iA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Markdown$1, { element: gA.element.markdown, ...QA }) });
    }
    case "metric": {
      const iA = gA.element.metric, oA = iA.chartData && iA.chartData.length > 0;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: oA ? ElementContainerConfig.LARGE_ELEMENT : ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Metric, { element: iA, ...QA }) });
    }
    case "html":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Html, { element: gA.element.html, ...QA }) });
    case "pageLink": {
      const iA = gA.element.pageLink, oA = EA.disabled || iA.disabled;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PageLink, { element: iA, disabled: oA, ...QA }) });
    }
    case "progress":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Progress, { element: gA.element.progress, ...QA }) });
    case "skeleton":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.FULL_WIDTH, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { element: gA.element.skeleton }) });
    case "snow":
      return hideIfStale(AA, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Snow, { scriptRunId: gA.scriptRunId }) }));
    case "space":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSpace, { className: "stSpace", "data-testid": "stSpace" }) });
    case "spinner":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { element: gA.element.spinner, ...QA }) });
    case "text":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextElement$1, { element: gA.element.text, ...QA }) });
    case "video":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Video, { element: gA.element.video, endpoints: CA.endpoints, ...QA, elementMgr: CA.widgetMgr }) });
    // Events:
    case "toast": {
      const iA = gA.element.toast;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Toast,
        {
          element: iA,
          ...QA
        },
        gA.scriptRunId
      ) });
    }
    // Widgets:
    case "dataframe": {
      const iA = gA.element.dataframe;
      EA.disabled = EA.disabled || iA.disabled;
      const cA = gA.element.widthConfig?.useContent && IA ? new ElementContainerConfig({
        minStretchWidth: MinStretchWidth.LARGE,
        styleOverrides: {
          overflow: "visible",
          width: "100%"
        }
      }) : ElementContainerConfig.LARGE_OVERFLOW_VISIBLE;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: cA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowDataFrame,
        {
          element: iA,
          data: gA.quiverElement,
          ...EA
        },
        iA.id || void 0
      ) });
    }
    case "vegaLiteChart": {
      const iA = gA.vegaLiteChartElement, oA = gA.element.widthConfig?.useContent && IA, cA = BA && !gA.element.widthConfig, tA = oA || cA ? new ElementContainerConfig({
        minStretchWidth: MinStretchWidth.LARGE,
        styleOverrides: {
          overflow: "visible",
          ...oA && {
            width: "100%"
          },
          ...cA && {
            flex: "1 1 14rem"
          }
        }
      }) : ElementContainerConfig.LARGE_OVERFLOW_VISIBLE;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: tA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        ArrowVegaLiteChart,
        {
          element: iA,
          ...EA
        },
        iA.id || void 0
      ) });
    }
    case "audioInput": {
      const iA = gA.element.audioInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AudioInput, { uploadClient: CA.uploadClient, element: iA, ...EA }, iA.id) });
    }
    case "button": {
      const iA = gA.element.button;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: iA.isFormSubmitter ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormSubmitContent, { element: iA, ...EA }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { element: iA, ...EA }) });
    }
    case "buttonGroup": {
      const iA = gA.element.buttonGroup;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroup, { element: iA, ...EA }, iA.id) });
    }
    case "downloadButton": {
      const iA = gA.element.downloadButton;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadButton, { endpoints: CA.endpoints, element: iA, ...EA }, iA.id) });
    }
    case "feedback": {
      const iA = gA.element.feedback;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.FIT_CONTENT_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Feedback, { element: iA, ...EA }, iA.id) });
    }
    case "cameraInput": {
      const iA = gA.element.cameraInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CameraInput, { element: iA, uploadClient: CA.uploadClient, ...EA }, iA.id) });
    }
    case "chatInput": {
      const iA = gA.element.chatInput;
      EA.disabled = EA.disabled || iA.disabled;
      const oA = gA.element.heightConfig, cA = new ElementContainerConfig({
        minStretchWidth: MinStretchWidth.MEDIUM,
        styleOverrides: oA?.useStretch ? {
          height: "100%",
          flex: "1 1 8rem"
        } : oA?.pixelHeight ? {
          height: "auto",
          overflow: "visible",
          ...BA ? {} : {
            flex: ""
          }
        } : void 0
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: cA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChatInput, { element: iA, uploadClient: CA.uploadClient, ...EA }, iA.id) });
    }
    case "checkbox": {
      const iA = gA.element.checkbox;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { element: iA, ...EA }, iA.id) });
    }
    case "colorPicker": {
      const iA = gA.element.colorPicker;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ColorPicker, { element: iA, ...EA }, iA.id) });
    }
    case "componentInstance":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.FULL_WIDTH, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentInstance, { element: gA.element.componentInstance, ...EA }) });
    case "dateInput": {
      const iA = gA.element.dateInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DateInput, { element: iA, ...EA }, iA.id) });
    }
    case "fileUploader": {
      const iA = gA.element.fileUploader;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploader, { element: iA, uploadClient: CA.uploadClient, ...EA }, iA.id) });
    }
    case "linkButton": {
      const iA = gA.element.linkButton;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { element: iA, widgetMgr: CA.widgetMgr, fragmentId: gA.fragmentId }) });
    }
    case "multiselect": {
      const iA = gA.element.multiselect;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Multiselect, { element: iA, ...EA }, iA.id) });
    }
    case "menuButton": {
      const iA = gA.element.menuButton;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuButton, { element: iA, ...EA }) });
    }
    case "numberInput": {
      const iA = gA.element.numberInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberInput, { element: iA, ...EA }, iA.id) });
    }
    case "plotlyChart": {
      const iA = gA.element.plotlyChart;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.LARGE_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PlotlyChart, { element: iA, ...EA }, iA.id) });
    }
    case "radio": {
      const iA = gA.element.radio;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { element: iA, ...EA }, iA.id) });
    }
    case "selectbox": {
      const iA = gA.element.selectbox;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Selectbox, { element: iA, ...EA }, iA.id) });
    }
    case "slider": {
      const iA = gA.element.slider;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Slider, { element: iA, ...EA }, iA.id) });
    }
    case "textArea": {
      const iA = gA.element.textArea;
      EA.disabled = EA.disabled || iA.disabled;
      const oA = gA.element.heightConfig?.useStretch, cA = new ElementContainerConfig({
        minStretchWidth: MinStretchWidth.MEDIUM,
        styleOverrides: oA ? {
          height: "100%",
          flex: "1 1 8rem"
        } : (
          // Content height text area in vertical layout cannot have flex.
          {
            height: "auto",
            ...BA ? {} : {
              flex: ""
            }
          }
        )
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: cA, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextArea, { element: iA, outerElement: gA.element, ...EA }, iA.id) });
    }
    case "textInput": {
      const iA = gA.element.textInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { element: iA, ...EA }, iA.id) });
    }
    case "dateTimeInput": {
      const iA = gA.element.dateTimeInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { element: iA, ...EA }, iA.id) });
    }
    case "timeInput": {
      const iA = gA.element.timeInput;
      return EA.disabled = EA.disabled || iA.disabled, /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.MEDIUM_ELEMENT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TimeInput, { element: iA, ...EA }, iA.id) });
    }
    case "bidiComponent": {
      const iA = gA.element.bidiComponent;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElementContainer, { node: gA, config: ElementContainerConfig.DEFAULT, isStale: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(BidiComponent, { element: iA, ...EA }, iA.id) });
    }
    default:
      throw new Error(`Unrecognized Element type ${gA.element.type}`);
  }
}, ElementNodeRenderer = (CA) => {
  const {
    scriptRunState: gA,
    scriptRunId: AA,
    fragmentIdsThisRun: IA
  } = useContext(ScriptRunContext), {
    node: BA
  } = CA, QA = BA.element.type || "", EA = shouldComponentBeEnabled(QA, gA), iA = isComponentStale(EA, BA, gA, AA, IA);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Maybe, { enable: EA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawElementNodeRenderer, { ...CA, isStale: iA }) });
};
class RenderNodeVisitor {
  constructor(gA, AA) {
    this.props = gA, this.elementKeyOverride = AA, this.elementKeySet = /* @__PURE__ */ new Set(), this.reactElements = [], this.index = 0, this.transientElementCount = 0;
  }
  getCurrentKey(gA) {
    return this.elementKeyOverride || gA || this.index.toString();
  }
  conformToArray(gA) {
    return gA ? Array.isArray(gA) ? gA : [gA] : [];
  }
  visitBlockNode(gA) {
    const AA = {
      ...this.props,
      node: gA
    }, IA = this.getCurrentKey(gA.deltaBlock?.id || void 0);
    this.index += 1;
    const BA = /* @__PURE__ */ jsxRuntimeExports.jsx(BlockNodeRenderer, { ...AA }, IA);
    return this.reactElements.push(BA), BA;
  }
  visitTransientNode(gA) {
    const AA = [];
    gA.transientNodes.forEach((BA) => {
      const QA = this.getCurrentKey(`transient-${this.transientElementCount}`);
      this.transientElementCount += 1;
      const EA = BA.accept(new RenderNodeVisitor(this.props, QA));
      AA.push(...this.conformToArray(EA));
    }), this.reactElements.push(...AA);
    const IA = gA.anchor?.accept(this);
    return AA.push(...this.conformToArray(IA)), AA;
  }
  visitElementNode(gA) {
    const AA = {
      ...this.props,
      node: gA
    }, IA = this.getCurrentKey(getElementId(gA.element));
    if (this.index += 1, this.elementKeySet.has(IA))
      return null;
    this.elementKeySet.add(IA);
    const BA = /* @__PURE__ */ jsxRuntimeExports.jsx(ElementNodeRenderer, { ...AA }, IA);
    return this.reactElements.push(BA), BA;
  }
  /**
   * Convenience method to render all children of a block as React elements.
   *
   * This is the primary entry point for rendering - it creates a visitor,
   * traverses all children, and returns the accumulated React elements.
   *
   * @param props - Block props containing the node to render
   * @param disableFullscreenMode - Whether to disable fullscreen mode for elements
   * @returns Array of React elements ready to render (may include nulls for duplicates)
   *
   * @example
   * const ChildRenderer = (props) => {
   *   return <>{RenderNodeVisitor.collectReactElements(props, false)}</>
   * }
   */
  static collectReactElements(gA) {
    if (!gA.node.children)
      return [];
    const AA = new RenderNodeVisitor(gA);
    return gA.node.children.forEach((IA) => IA.accept(AA)), AA.reactElements;
  }
}
const ChildRenderer = (CA) => (assignDividerColor(CA.node, useEmotionTheme()), /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: RenderNodeVisitor.collectReactElements(CA) })), getLayoutSubElement = (CA) => {
  const gA = CA.type, AA = gA ? CA[gA] : void 0;
  if (!AA || typeof AA != "object") return;
  const IA = AA, BA = {
    useContainerWidth: IA.useContainerWidth,
    height: IA.height,
    width: IA.width,
    widthConfig: IA.widthConfig
  };
  if (!(BA.useContainerWidth === void 0 && BA.height === void 0 && BA.width === void 0 && BA.widthConfig === void 0))
    return BA;
}, ContainerContentsWrapper = (CA) => {
  const gA = useContext(FlexContext), AA = {
    direction: Direction.VERTICAL,
    flex: 1,
    gap: streamlit.GapSize.SMALL,
    height: CA.height,
    // eslint-disable-next-line streamlit-custom/no-hardcoded-theme-values
    border: !1
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: Direction.VERTICAL, isRoot: CA.isRoot, parentContext: gA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...AA, className: getClassnamePrefix(Direction.VERTICAL), "data-testid": getClassnamePrefix(Direction.VERTICAL), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...CA }) }) });
}, FlexBoxContainer = (CA) => {
  const gA = getDirectionOfBlock(CA.node.deltaBlock), AA = useContext(FlexContext), IA = shouldActivateScrollToBottom(CA.node), BA = useScrollToBottom(IA), QA = useLayoutStyles({
    element: CA.node.deltaBlock,
    subElement: getLayoutSubElement(CA.node.deltaBlock)
  }), EA = {
    gap: (
      // This is backwards compatible with old proto messages since previously
      // the gap size was defaulted to small.
      CA.node.deltaBlock.flexContainer?.gapConfig?.gapSize ?? streamlit.GapSize.SMALL
    ),
    direction: gA,
    // This is also backwards compatible since previously wrap was not added
    // to the flex container.
    $wrap: CA.node.deltaBlock.flexContainer?.wrap ?? !1,
    overflow: QA.overflow,
    border: getBorderBackwardsCompatible(CA.node.deltaBlock),
    // We need the height on the container for scrolling.
    height: QA.height,
    // Flex properties are set on the LayoutWrapper.
    flex: "1",
    align: CA.node.deltaBlock.flexContainer?.align,
    justify: CA.node.deltaBlock.flexContainer?.justify
  }, iA = getKeyFromId(CA.node.deltaBlock.id), oA = CA.node.deltaBlock.widthConfig?.pixelWidth ?? void 0, cA = CA.node.deltaBlock.widthConfig?.useContent ?? !1, tA = (CA.node.deltaBlock.widthConfig?.pixelWidth ?? 0) > 0 || (CA.node.deltaBlock.widthConfig?.remWidth ?? 0) > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FlexContextProvider, { direction: gA, parentWidth: oA, hasContentWidth: cA, hasFixedWidth: tA, parentContext: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFlexContainerBlock, { ...EA, className: classNames(getClassnamePrefix(gA), convertKeyToClassName(iA)), "data-testid": getClassnamePrefix(gA), ref: BA, "data-test-scroll-behavior": IA ? "scroll-to-bottom" : "normal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ChildRenderer, { ...CA }) }) });
}, LARGE_STRETCH_BEHAVIOR = ["tabContainer"], MEDIUM_STRETCH_BEHAVIOR = ["chatInput"], BlockNodeRenderer = (CA) => {
  const {
    node: gA
  } = CA, {
    scriptRunState: AA,
    scriptRunId: IA,
    fragmentIdsThisRun: BA
  } = useContext(ScriptRunContext);
  let QA;
  LARGE_STRETCH_BEHAVIOR.includes(gA.deltaBlock.type ?? "") ? QA = "14rem" : MEDIUM_STRETCH_BEHAVIOR.includes(gA.deltaBlock.type ?? "") ? QA = "8rem" : gA.deltaBlock.type === "chatMessage" ? gA.isEmpty && (QA = "8rem") : (gA.deltaBlock.type === "flexContainer" || gA.deltaBlock.column || gA.deltaBlock.expandable) && (gA.isEmpty || (QA = "8rem"));
  const EA = useLayoutStyles({
    element: gA.deltaBlock,
    subElement: getLayoutSubElement(gA.deltaBlock),
    minStretchBehavior: QA
  });
  if (gA.isEmpty && !gA.deltaBlock.allowEmpty)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  const iA = shouldComponentBeEnabled("", AA), oA = isComponentStale(iA, gA, AA, IA, BA), cA = {
    ...CA,
    node: gA
  }, tA = CA.disableFullscreenMode || notNullOrUndefined(gA.deltaBlock.dialog) || notNullOrUndefined(gA.deltaBlock.popover);
  let eA, aA = !1;
  const GA = getKeyFromId(gA.deltaBlock.id), lA = /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...cA, disableFullscreenMode: tA, height: "100%" });
  if (checkFlexContainerBackwardsCompatibile(gA.deltaBlock) && (eA = /* @__PURE__ */ jsxRuntimeExports.jsx(FlexBoxContainer, { ...cA })), gA.deltaBlock.dialog)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Dialog$1, { element: gA.deltaBlock.dialog, deltaMsgReceivedAt: gA.deltaMsgReceivedAt, widgetMgr: CA.widgetMgr, fragmentId: gA.fragmentId, children: lA });
  if (gA.deltaBlock.expandable && (aA = !0, eA = /* @__PURE__ */ jsxRuntimeExports.jsx(Expander$1, { isStale: oA, element: gA.deltaBlock.expandable, widgetMgr: CA.widgetMgr, blockId: gA.deltaBlock.id || void 0, fragmentId: gA.fragmentId, children: lA })), gA.deltaBlock.popover && (aA = !0, eA = /* @__PURE__ */ jsxRuntimeExports.jsx(Popover$1, { empty: gA.isEmpty, element: gA.deltaBlock.popover, stretchWidth: shouldWidthStretch(gA.deltaBlock.widthConfig), widgetMgr: CA.widgetMgr, blockId: gA.deltaBlock.id || void 0, fragmentId: gA.fragmentId, children: lA })), gA.deltaBlock.type === "form") {
    const {
      formId: nA,
      clearOnSubmit: DA,
      enterToSubmit: hA,
      border: wA
    } = gA.deltaBlock.form;
    eA = /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { formId: nA, clearOnSubmit: DA, enterToSubmit: hA, widgetMgr: CA.widgetMgr, border: wA, overflow: EA.overflow, children: lA });
  }
  if (gA.deltaBlock.chatMessage && (eA = /* @__PURE__ */ jsxRuntimeExports.jsx(ChatMessage$1, { element: gA.deltaBlock.chatMessage, endpoints: CA.endpoints, children: lA })), gA.deltaBlock.column)
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledColumn, { weight: gA.deltaBlock.column.weight ?? 0, gap: getColumnGapSize(gA.deltaBlock.column), verticalAlignment: gA.deltaBlock.column.verticalAlignment ?? void 0, showBorder: gA.deltaBlock.column.showBorder ?? !1, className: "stColumn", "data-testid": "stColumn", children: lA });
  if (gA.deltaBlock.tabContainer) {
    const DA = {
      ...cA,
      isStale: oA,
      renderTabContent: (hA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { ...hA, height: "auto" }),
      width: EA.width,
      flex: EA.flex,
      fragmentId: gA.fragmentId
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { ...DA });
  }
  return eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLayoutWrapper, { "data-testid": "stLayoutWrapper", className: convertKeyToClassName(aA ? GA : void 0), ...EA, children: eA }) : lA;
}, DownloadContext = createContext({
  requestDeferredFile: void 0
});
DownloadContext.displayName = "DownloadContext";
const NavigationContext = createContext({
  pageLinkBaseUrl: "",
  currentPageScriptHash: "",
  onPageChange: () => {
  },
  navSections: [],
  appPages: []
});
NavigationContext.displayName = "NavigationContext";
const StyledDataFrameOverlay = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc1"
} : {
  target: "e1v116lc1",
  label: "StyledDataFrameOverlay"
})(({
  theme: CA
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: CA.zIndices.tablePortal,
  lineHeight: "100%",
  ...!hasLightBackgroundColor(CA) && {
    "& input[type='date'], & input[type='time'], & input[type='datetime-local']": {
      "&::-webkit-calendar-picker-indicator": {
        filter: "brightness(0) invert(1)",
        opacity: 1
      }
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledErrorMessage = /* @__PURE__ */ createStyled("small", process.env.NODE_ENV === "production" ? {
  target: "e1v116lc0"
} : {
  target: "e1v116lc0",
  label: "StyledErrorMessage"
})(({
  theme: CA
}) => ({
  color: CA.colors.redTextColor,
  fontSize: CA.fontSizes.sm,
  marginTop: CA.spacing.twoXS,
  display: "block"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), PortalContext = createContext(null);
PortalContext.displayName = "PortalContext";
const PortalProvider = ({
  children: CA
}) => {
  const gA = useRef(null), AA = useCallback(() => gA.current, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalContext.Provider, { value: AA, children: [
    CA,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDataFrameOverlay, { "data-testid": "portal", id: "portal", ref: gA })
  ] });
}, SidebarConfigContext = createContext({
  initialSidebarState: PageConfig.SidebarState.AUTO,
  appLogo: null,
  sidebarChevronDownshift: 0,
  expandSidebarNav: !1,
  hideSidebarNav: !1
});
SidebarConfigContext.displayName = "SidebarConfigContext";
const ThemeContext = createContext({
  activeTheme: getDefaultTheme(),
  setTheme: () => {
  },
  availableThemes: []
});
ThemeContext.displayName = "ThemeContext";
function ThemeProvider({
  theme: CA,
  baseuiTheme: gA,
  children: AA
}) {
  return (
    // Type error coming from BaseUI "property children doesn't exist"
    // @ts-expect-error
    /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: gA || baseuiLightTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, { theme: CA, children: AA }) })
  );
}
function ToolbarAction({
  label: CA,
  show_label: gA,
  icon: AA,
  onClick: IA
}) {
  const BA = useEmotionTheme(), QA = gA ? CA : "";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stElementToolbarButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Tooltip$1,
    {
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: CA, allowHTML: !1, style: {
        fontSize: BA.fontSizes.sm
      } }),
      placement: Placement.TOP,
      onMouseEnterDelay: 1e3,
      inline: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BaseButton, { onClick: (EA) => {
        IA && IA(), EA.stopPropagation();
      }, kind: BaseButtonKind.ELEMENT_TOOLBAR, "aria-label": CA, children: [
        AA && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: AA, size: "md", testid: "stElementToolbarButtonIcon" }),
        QA && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: QA })
      ] })
    }
  ) });
}
const Toolbar = ({
  onExpand: CA,
  onCollapse: gA,
  isFullScreen: AA,
  locked: IA,
  children: BA,
  target: QA,
  disableFullscreenMode: EA
}) => {
  const iA = CA && !EA && !AA, oA = gA && !EA && AA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToolbarWrapper, { className: "stElementToolbar", "data-testid": "stElementToolbar", locked: IA || AA, target: QA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledToolbar, { "data-testid": "stElementToolbarButtonContainer", children: [
    BA,
    iA && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarAction, { label: "Fullscreen", icon: Fullscreen, onClick: () => CA() }),
    oA && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarAction, { label: "Close fullscreen", icon: FullscreenExit, onClick: () => gA() })
  ] }) });
};
function CodeBlockCopyToolbar({
  text: CA
}) {
  const {
    isCopied: gA,
    copyToClipboard: AA,
    label: IA
  } = useCopyToClipboard(), BA = useCallback(() => {
    AA(CA);
  }, [AA, CA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCodeToolbarWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCodeToolbar, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarAction, { label: IA, icon: gA ? Check : ContentCopy, onClick: BA }) }) });
}
const CodeBlockCopyToolbar$1 = memo(CodeBlockCopyToolbar);
function StreamlitErrorCodeBlock({
  children: CA
}) {
  const gA = typeof CA == "string" && CA.trim().length > 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCodeBlock, { className: "stErrorCodeBlock", "data-testid": "stErrorCodeBlock", tabIndex: gA ? 0 : void 0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPre, { wrapLines: !1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCode, { wrapLines: !1, children: CA }) }),
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(CodeBlockCopyToolbar$1, { text: CA })
  ] });
}
const StreamlitErrorCodeBlock$1 = memo(StreamlitErrorCodeBlock);
function iconToUrl(CA) {
  const gA = /^:(.+)\/(.+):$/, AA = CA.match(gA);
  return AA === null ? "" : `https://fonts.gstatic.com/s/i/short-term/release/materialsymbolsrounded/${AA[2]}/default/24px.svg`;
}
function handleFavicon(CA, gA, AA) {
  const IA = (EA) => {
    overwriteFavicon(EA), gA({
      type: "SET_PAGE_FAVICON",
      favicon: EA
    });
  };
  if (CA.startsWith(":material")) {
    IA(iconToUrl(CA));
    return;
  }
  const BA = "emoji:";
  if (CA.startsWith(BA)) {
    const EA = CA.substring(BA.length), iA = createEmojiDataUrl(EA);
    IA(iA);
    return;
  }
  /^:[a-zA-Z0-9_+-]+:$/.test(CA) ? convertShortcodeToEmoji(CA).then((EA) => {
    IA(EA ? createEmojiDataUrl(EA) : AA.buildMediaURL(CA));
  }).catch(() => {
    IA(AA.buildMediaURL(CA));
  }) : IA(AA.buildMediaURL(CA));
}
function createEmojiDataUrl(CA) {
  return `data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>${CA}</text></svg>`;
}
function overwriteFavicon(CA) {
  const gA = document.querySelector("link[rel='shortcut icon']");
  gA && (gA.href = CA);
}
async function convertShortcodeToEmoji(CA) {
  const gA = await import("./index-DJIbJyKa.js"), AA = CA.replace(/-/g, "_"), IA = gA.get(AA);
  return IA && IA !== AA && gA.has(IA) ? IA : "";
}
const WindowDimensionsContext = createContext(null);
WindowDimensionsContext.displayName = "WindowDimensionsContext";
const useWindowDimensionsContext = () => useRequiredContext(WindowDimensionsContext), measureScrollbarGutterSize = () => {
  const CA = document.createElement("div");
  CA.style.position = "absolute", CA.style.top = "-9999px", CA.style.left = "-9999px", CA.style.visibility = "hidden", CA.style.overflow = "scroll", CA.style.width = "50px", CA.style.height = "50px", document.body.appendChild(CA);
  const gA = document.createElement("div");
  gA.style.width = "100%", gA.style.height = "100%", CA.appendChild(gA);
  const AA = CA.offsetWidth - gA.offsetWidth;
  return CA.remove(), AA;
}, useScrollbarGutterSize = () => {
  const CA = window.devicePixelRatio;
  return useMemo$1(() => measureScrollbarGutterSize(), [CA]);
};
var uaParser$1 = { exports: {} }, uaParser = uaParser$1.exports, hasRequiredUaParser;
function requireUaParser() {
  return hasRequiredUaParser || (hasRequiredUaParser = 1, (function(CA, gA) {
    (function(AA, IA) {
      var BA = "1.0.41", QA = "", EA = "?", iA = "function", oA = "undefined", cA = "object", tA = "string", eA = "major", aA = "model", GA = "name", lA = "type", nA = "vendor", DA = "version", hA = "architecture", wA = "console", sA = "mobile", NA = "tablet", rA = "smarttv", yA = "wearable", bA = "embedded", RA = 500, FA = "Amazon", dA = "Apple", kA = "ASUS", pA = "BlackBerry", YA = "Browser", SA = "Chrome", JA = "Edge", UA = "Firefox", fA = "Google", zA = "Honor", _A = "Huawei", uA = "Lenovo", HA = "LG", TA = "Microsoft", ZA = "Motorola", AI = "Nvidia", QI = "OnePlus", LA = "Opera", PA = "OPPO", XA = "Samsung", EI = "Sharp", CI = "Sony", II = "Xiaomi", vA = "Zebra", wI = "Facebook", $A = "Chromium OS", YI = "Mac OS", FI = " Browser", nI = function(oI, eI) {
        var gI = {};
        for (var mA in oI)
          eI[mA] && eI[mA].length % 2 === 0 ? gI[mA] = eI[mA].concat(oI[mA]) : gI[mA] = oI[mA];
        return gI;
      }, uI = function(oI) {
        for (var eI = {}, gI = 0; gI < oI.length; gI++)
          eI[oI[gI].toUpperCase()] = oI[gI];
        return eI;
      }, hI = function(oI, eI) {
        return typeof oI === tA ? bI(eI).indexOf(bI(oI)) !== -1 : !1;
      }, bI = function(oI) {
        return oI.toLowerCase();
      }, HI = function(oI) {
        return typeof oI === tA ? oI.replace(/[^\d\.]/g, QA).split(".")[0] : IA;
      }, UI = function(oI, eI) {
        if (typeof oI === tA)
          return oI = oI.replace(/^\s\s*/, QA), typeof eI === oA ? oI : oI.substring(0, RA);
      }, pI = function(oI, eI) {
        for (var gI = 0, mA, WA, xA, qA, VA, cI; gI < eI.length && !VA; ) {
          var DI = eI[gI], JI = eI[gI + 1];
          for (mA = WA = 0; mA < DI.length && !VA && DI[mA]; )
            if (VA = DI[mA++].exec(oI), VA)
              for (xA = 0; xA < JI.length; xA++)
                cI = VA[++WA], qA = JI[xA], typeof qA === cA && qA.length > 0 ? qA.length === 2 ? typeof qA[1] == iA ? this[qA[0]] = qA[1].call(this, cI) : this[qA[0]] = qA[1] : qA.length === 3 ? typeof qA[1] === iA && !(qA[1].exec && qA[1].test) ? this[qA[0]] = cI ? qA[1].call(this, cI, qA[2]) : IA : this[qA[0]] = cI ? cI.replace(qA[1], qA[2]) : IA : qA.length === 4 && (this[qA[0]] = cI ? qA[3].call(this, cI.replace(qA[1], qA[2])) : IA) : this[qA] = cI || IA;
          gI += 2;
        }
      }, mI = function(oI, eI) {
        for (var gI in eI)
          if (typeof eI[gI] === cA && eI[gI].length > 0) {
            for (var mA = 0; mA < eI[gI].length; mA++)
              if (hI(eI[gI][mA], oI))
                return gI === EA ? IA : gI;
          } else if (hI(eI[gI], oI))
            return gI === EA ? IA : gI;
        return eI.hasOwnProperty("*") ? eI["*"] : oI;
      }, rI = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      }, KA = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        "8.1": "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      }, OA = {
        browser: [
          [
            /\b(?:crmo|crios)\/([\w\.]+)/i
            // Chrome for Android/iOS
          ],
          [DA, [GA, "Chrome"]],
          [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
            // Microsoft Edge
          ],
          [DA, [GA, "Edge"]],
          [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            // Opera
          ],
          [GA, DA],
          [
            /opios[\/ ]+([\w\.]+)/i
            // Opera mini on iphone >= 8.0
          ],
          [DA, [GA, LA + " Mini"]],
          [
            /\bop(?:rg)?x\/([\w\.]+)/i
            // Opera GX
          ],
          [DA, [GA, LA + " GX"]],
          [
            /\bopr\/([\w\.]+)/i
            // Opera Webkit
          ],
          [DA, [GA, LA]],
          [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            // Baidu
          ],
          [DA, [GA, "Baidu"]],
          [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
            // Maxthon
          ],
          [DA, [GA, "Maxthon"]],
          [
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Internet Explorer
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            // HeyTap/Ovi/115
            /(weibo)__([\d\.]+)/i
            // Weibo
          ],
          [GA, DA],
          [
            /quark(?:pc)?\/([-\w\.]+)/i
            // Quark
          ],
          [DA, [GA, "Quark"]],
          [
            /\bddg\/([\w\.]+)/i
            // DuckDuckGo
          ],
          [DA, [GA, "DuckDuckGo"]],
          [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            // UCBrowser
          ],
          [DA, [GA, "UC" + YA]],
          [
            /microm.+\bqbcore\/([\w\.]+)/i,
            // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i
            // WeChat
          ],
          [DA, [GA, "WeChat"]],
          [
            /konqueror\/([\w\.]+)/i
            // Konqueror
          ],
          [DA, [GA, "Konqueror"]],
          [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            // IE11
          ],
          [DA, [GA, "IE"]],
          [
            /ya(?:search)?browser\/([\w\.]+)/i
            // Yandex
          ],
          [DA, [GA, "Yandex"]],
          [
            /slbrowser\/([\w\.]+)/i
            // Smart Lenovo Browser
          ],
          [DA, [GA, "Smart Lenovo " + YA]],
          [
            /(avast|avg)\/([\w\.]+)/i
            // Avast/AVG Secure Browser
          ],
          [[GA, /(.+)/, "$1 Secure " + YA], DA],
          [
            /\bfocus\/([\w\.]+)/i
            // Firefox Focus
          ],
          [DA, [GA, UA + " Focus"]],
          [
            /\bopt\/([\w\.]+)/i
            // Opera Touch
          ],
          [DA, [GA, LA + " Touch"]],
          [
            /coc_coc\w+\/([\w\.]+)/i
            // Coc Coc Browser
          ],
          [DA, [GA, "Coc Coc"]],
          [
            /dolfin\/([\w\.]+)/i
            // Dolphin
          ],
          [DA, [GA, "Dolphin"]],
          [
            /coast\/([\w\.]+)/i
            // Opera Coast
          ],
          [DA, [GA, LA + " Coast"]],
          [
            /miuibrowser\/([\w\.]+)/i
            // MIUI Browser
          ],
          [DA, [GA, "MIUI" + FI]],
          [
            /fxios\/([\w\.-]+)/i
            // Firefox for iOS
          ],
          [DA, [GA, UA]],
          [
            /\bqihoobrowser\/?([\w\.]*)/i
            // 360
          ],
          [DA, [GA, "360"]],
          [
            /\b(qq)\/([\w\.]+)/i
            // QQ
          ],
          [[GA, /(.+)/, "$1Browser"], DA],
          [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
          ],
          [[GA, /(.+)/, "$1" + FI], DA],
          [
            // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
            /samsungbrowser\/([\w\.]+)/i
            // Samsung Internet
          ],
          [DA, [GA, XA + " Internet"]],
          [
            /metasr[\/ ]?([\d\.]+)/i
            // Sogou Explorer
          ],
          [DA, [GA, "Sogou Explorer"]],
          [
            /(sogou)mo\w+\/([\d\.]+)/i
            // Sogou Mobile
          ],
          [[GA, "Sogou Mobile"], DA],
          [
            /(electron)\/([\w\.]+) safari/i,
            // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            // Tesla
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
            // QQ/2345
          ],
          [GA, DA],
          [
            /(lbbrowser|rekonq)/i,
            // LieBao Browser/Rekonq
            /\[(linkedin)app\]/i
            // LinkedIn App for iOS & Android
          ],
          [GA],
          [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            // Iron
            /ome\/([\w\.]+).+qihu (360)[es]e/i
            // 360
          ],
          [DA, GA],
          [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            // Facebook App for iOS & Android
          ],
          [[GA, wI], DA],
          [
            /(Klarna)\/([\w\.]+)/i,
            // Klarna Shopping Browser for iOS & Android
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            // Kakao App
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            // Naver InApp
            /(daum)apps[\/ ]([\w\.]+)/i,
            // Daum App
            /safari (line)\/([\w\.]+)/i,
            // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,
            // Line App for Android
            /(alipay)client\/([\w\.]+)/i,
            // Alipay
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            // Twitter
            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            // Chromium/Instagram/Snapchat
          ],
          [GA, DA],
          [
            /\bgsa\/([\w\.]+) .*safari\//i
            // Google Search Appliance on iOS
          ],
          [DA, [GA, "GSA"]],
          [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            // TikTok
          ],
          [DA, [GA, "TikTok"]],
          [
            /headlesschrome(?:\/([\w\.]+)| )/i
            // Chrome Headless
          ],
          [DA, [GA, SA + " Headless"]],
          [
            / wv\).+(chrome)\/([\w\.]+)/i
            // Chrome WebView
          ],
          [[GA, SA + " WebView"], DA],
          [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            // Android Browser
          ],
          [DA, [GA, "Android " + YA]],
          [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            // Chrome/OmniWeb/Arora/Tizen/Nokia
          ],
          [GA, DA],
          [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            // Mobile Safari
          ],
          [DA, [GA, "Mobile Safari"]],
          [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            // Safari & Safari Mobile
          ],
          [DA, GA],
          [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            // Safari < 3.0
          ],
          [GA, [DA, mI, rI]],
          [
            /(webkit|khtml)\/([\w\.]+)/i
          ],
          [GA, DA],
          [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
            // Netscape
          ],
          [[GA, "Netscape"], DA],
          [
            /(wolvic|librewolf)\/([\w\.]+)/i
            // Wolvic/LibreWolf
          ],
          [GA, DA],
          [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
            // Firefox Reality
          ],
          [DA, [GA, UA + " Reality"]],
          [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            // Flow
            /(swiftfox)/i,
            // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Mozilla
            // Other
            /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
            /\b(links) \(([\w\.]+)/i
            // Links
          ],
          [GA, [DA, /_/g, "."]],
          [
            /(cobalt)\/([\w\.]+)/i
            // Cobalt
          ],
          [GA, [DA, /master.|lts./, ""]]
        ],
        cpu: [
          [
            /\b((amd|x|x86[-_]?|wow|win)64)\b/i
            // AMD64 (x64)
          ],
          [[hA, "amd64"]],
          [
            /(ia32(?=;))/i,
            // IA32 (quicktime)
            /\b((i[346]|x)86)(pc)?\b/i
            // IA32 (x86)
          ],
          [[hA, "ia32"]],
          [
            /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
            // ARM64
          ],
          [[hA, "arm64"]],
          [
            /\b(arm(v[67])?ht?n?[fl]p?)\b/i
            // ARMHF
          ],
          [[hA, "armhf"]],
          [
            // PocketPC mistakenly identified as PowerPC
            /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
          ],
          [[hA, "arm"]],
          [
            /((ppc|powerpc)(64)?)( mac|;|\))/i
            // PowerPC
          ],
          [[hA, /ower/, QA, bI]],
          [
            / sun4\w[;\)]/i
            // SPARC
          ],
          [[hA, "sparc"]],
          [
            /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
          ],
          [[hA, bI]]
        ],
        device: [
          [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
          ],
          [aA, [nA, XA], [lA, NA]],
          [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
          ],
          [aA, [nA, XA], [lA, sA]],
          [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            // iPod/iPhone
          ],
          [aA, [nA, dA], [lA, sA]],
          [
            /\((ipad);[-\w\),; ]+apple/i,
            // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
          ],
          [aA, [nA, dA], [lA, NA]],
          [
            /(macintosh);/i
          ],
          [aA, [nA, dA]],
          [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
          ],
          [aA, [nA, EI], [lA, sA]],
          [
            // Honor
            /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
          ],
          [aA, [nA, zA], [lA, NA]],
          [
            /honor([-\w ]+)[;\)]/i
          ],
          [aA, [nA, zA], [lA, sA]],
          [
            // Huawei
            /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
          ],
          [aA, [nA, _A], [lA, NA]],
          [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
          ],
          [aA, [nA, _A], [lA, sA]],
          [
            // Xiaomi
            /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
            /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
            // Mi Pad tablets
          ],
          [[aA, /_/g, " "], [nA, II], [lA, NA]],
          [
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,
            // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            // Xiaomi Redmi
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            // Xiaomi Redmi 'numeric' models
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
            // Xiaomi Mi
            / ([\w ]+) miui\/v?\d/i
          ],
          [[aA, /_/g, " "], [nA, II], [lA, sA]],
          [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
          ],
          [aA, [nA, PA], [lA, sA]],
          [
            /\b(opd2(\d{3}a?))(?: bui|\))/i
          ],
          [aA, [nA, mI, { OnePlus: ["304", "403", "203"], "*": PA }], [lA, NA]],
          [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
          ],
          [aA, [nA, "Vivo"], [lA, sA]],
          [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
          ],
          [aA, [nA, "Realme"], [lA, sA]],
          [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
          ],
          [aA, [nA, ZA], [lA, sA]],
          [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
          ],
          [aA, [nA, ZA], [lA, NA]],
          [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
          ],
          [aA, [nA, HA], [lA, NA]],
          [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
            /\blg-?([\d\w]+) bui/i
          ],
          [aA, [nA, HA], [lA, sA]],
          [
            // Lenovo
            /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
            /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
          ],
          [aA, [nA, uA], [lA, NA]],
          [
            // Nokia
            /(nokia) (t[12][01])/i
          ],
          [nA, aA, [lA, NA]],
          [
            /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
            /nokia[-_ ]?(([-\w\. ]*))/i
          ],
          [[aA, /_/g, " "], [lA, sA], [nA, "Nokia"]],
          [
            // Google
            /(pixel (c|tablet))\b/i
            // Google Pixel C/Tablet
          ],
          [aA, [nA, fA], [lA, NA]],
          [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            // Google Pixel
          ],
          [aA, [nA, fA], [lA, sA]],
          [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
          ],
          [aA, [nA, CI], [lA, sA]],
          [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
          ],
          [[aA, "Xperia Tablet"], [nA, CI], [lA, NA]],
          [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
          ],
          [aA, [nA, QI], [lA, sA]],
          [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            // Kindle Fire without Silk / Echo Show
            /(kf[a-z]+)( bui|\)).+silk\//i
            // Kindle Fire HD
          ],
          [aA, [nA, FA], [lA, NA]],
          [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            // Fire Phone
          ],
          [[aA, /(.+)/g, "Fire Phone $1"], [nA, FA], [lA, sA]],
          [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
            // BlackBerry PlayBook
          ],
          [aA, nA, [lA, NA]],
          [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
            // BlackBerry 10
          ],
          [aA, [nA, pA], [lA, sA]],
          [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
          ],
          [aA, [nA, kA], [lA, NA]],
          [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
          ],
          [aA, [nA, kA], [lA, sA]],
          [
            // HTC
            /(nexus 9)/i
            // HTC Nexus 9
          ],
          [aA, [nA, "HTC"], [lA, NA]],
          [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // HTC
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
          ],
          [nA, [aA, /_/g, " "], [lA, sA]],
          [
            // TCL
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
          ],
          [aA, [nA, "TCL"], [lA, NA]],
          [
            // itel
            /(itel) ((\w+))/i
          ],
          [[nA, bI], aA, [lA, mI, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
          [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
          ],
          [aA, [nA, "Acer"], [lA, NA]],
          [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
          ],
          [aA, [nA, "Meizu"], [lA, sA]],
          [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
          ],
          [aA, [nA, "Ulefone"], [lA, sA]],
          [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
          ],
          [aA, [nA, "Energizer"], [lA, sA]],
          [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
          ],
          [aA, [nA, "Cat"], [lA, sA]],
          [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
          ],
          [aA, [nA, "Smartfren"], [lA, sA]],
          [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
          ],
          [aA, [nA, "Nothing"], [lA, sA]],
          [
            // Archos
            /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
            /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
          ],
          [aA, [nA, "Archos"], [lA, NA]],
          [
            /archos ([\w ]+)( b|\))/i,
            /; (ac[3-6]\d\w{2,8})( b|\))/i
          ],
          [aA, [nA, "Archos"], [lA, sA]],
          [
            // MIXED
            /(imo) (tab \w+)/i,
            // IMO
            /(infinix) (x1101b?)/i
            // Infinix XPad
          ],
          [nA, aA, [lA, NA]],
          [
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
            // HMD/IMO
            /(hp) ([\w ]+\w)/i,
            // HP iPAQ
            /(microsoft); (lumia[\w ]+)/i,
            // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
            // Lenovo
            /(oppo) ?([\w ]+) bui/i
            // OPPO
          ],
          [nA, aA, [lA, sA]],
          [
            /(kobo)\s(ereader|touch)/i,
            // Kobo
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            // HP TouchPad
            /(kindle)\/([\w\.]+)/i,
            // Kindle
            /(nook)[\w ]+build\/(\w+)/i,
            // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,
            // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,
            // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i
            // Vodafone
          ],
          [nA, aA, [lA, NA]],
          [
            /(surface duo)/i
            // Surface Duo
          ],
          [aA, [nA, TA], [lA, NA]],
          [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
            // Fairphone
          ],
          [aA, [nA, "Fairphone"], [lA, sA]],
          [
            /(u304aa)/i
            // AT&T
          ],
          [aA, [nA, "AT&T"], [lA, sA]],
          [
            /\bsie-(\w*)/i
            // Siemens
          ],
          [aA, [nA, "Siemens"], [lA, sA]],
          [
            /\b(rct\w+) b/i
            // RCA Tablets
          ],
          [aA, [nA, "RCA"], [lA, NA]],
          [
            /\b(venue[\d ]{2,7}) b/i
            // Dell Venue Tablets
          ],
          [aA, [nA, "Dell"], [lA, NA]],
          [
            /\b(q(?:mv|ta)\w+) b/i
            // Verizon Tablet
          ],
          [aA, [nA, "Verizon"], [lA, NA]],
          [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            // Barnes & Noble Tablet
          ],
          [aA, [nA, "Barnes & Noble"], [lA, NA]],
          [
            /\b(tm\d{3}\w+) b/i
          ],
          [aA, [nA, "NuVision"], [lA, NA]],
          [
            /\b(k88) b/i
            // ZTE K Series Tablet
          ],
          [aA, [nA, "ZTE"], [lA, NA]],
          [
            /\b(nx\d{3}j) b/i
            // ZTE Nubia
          ],
          [aA, [nA, "ZTE"], [lA, sA]],
          [
            /\b(gen\d{3}) b.+49h/i
            // Swiss GEN Mobile
          ],
          [aA, [nA, "Swiss"], [lA, sA]],
          [
            /\b(zur\d{3}) b/i
            // Swiss ZUR Tablet
          ],
          [aA, [nA, "Swiss"], [lA, NA]],
          [
            /\b((zeki)?tb.*\b) b/i
            // Zeki Tablets
          ],
          [aA, [nA, "Zeki"], [lA, NA]],
          [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            // Dragon Touch Tablet
          ],
          [[nA, "Dragon Touch"], aA, [lA, NA]],
          [
            /\b(ns-?\w{0,9}) b/i
            // Insignia Tablets
          ],
          [aA, [nA, "Insignia"], [lA, NA]],
          [
            /\b((nxa|next)-?\w{0,9}) b/i
            // NextBook Tablets
          ],
          [aA, [nA, "NextBook"], [lA, NA]],
          [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            // Voice Xtreme Phones
          ],
          [[nA, "Voice"], aA, [lA, sA]],
          [
            /\b(lvtel\-)?(v1[12]) b/i
            // LvTel Phones
          ],
          [[nA, "LvTel"], aA, [lA, sA]],
          [
            /\b(ph-1) /i
            // Essential PH-1
          ],
          [aA, [nA, "Essential"], [lA, sA]],
          [
            /\b(v(100md|700na|7011|917g).*\b) b/i
            // Envizen Tablets
          ],
          [aA, [nA, "Envizen"], [lA, NA]],
          [
            /\b(trio[-\w\. ]+) b/i
            // MachSpeed Tablets
          ],
          [aA, [nA, "MachSpeed"], [lA, NA]],
          [
            /\btu_(1491) b/i
            // Rotor Tablets
          ],
          [aA, [nA, "Rotor"], [lA, NA]],
          [
            /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
            // Nvidia Tablets
          ],
          [aA, [nA, AI], [lA, NA]],
          [
            /(sprint) (\w+)/i
            // Sprint Phones
          ],
          [nA, aA, [lA, sA]],
          [
            /(kin\.[onetw]{3})/i
            // Microsoft Kin
          ],
          [[aA, /\./g, " "], [nA, TA], [lA, sA]],
          [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            // Zebra
          ],
          [aA, [nA, vA], [lA, NA]],
          [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
          ],
          [aA, [nA, vA], [lA, sA]],
          [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
            // Samsung
          ],
          [nA, [lA, rA]],
          [
            /hbbtv.+maple;(\d+)/i
          ],
          [[aA, /^/, "SmartTV"], [nA, XA], [lA, rA]],
          [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            // LG SmartTV
          ],
          [[nA, HA], [lA, rA]],
          [
            /(apple) ?tv/i
            // Apple TV
          ],
          [nA, [aA, dA + " TV"], [lA, rA]],
          [
            /crkey/i
            // Google Chromecast
          ],
          [[aA, SA + "cast"], [nA, fA], [lA, rA]],
          [
            /droid.+aft(\w+)( bui|\))/i
            // Fire TV
          ],
          [aA, [nA, FA], [lA, rA]],
          [
            /(shield \w+ tv)/i
            // Nvidia Shield TV
          ],
          [aA, [nA, AI], [lA, rA]],
          [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
            // Sharp
          ],
          [aA, [nA, EI], [lA, rA]],
          [
            /(bravia[\w ]+)( bui|\))/i
            // Sony
          ],
          [aA, [nA, CI], [lA, rA]],
          [
            /(mi(tv|box)-?\w+) bui/i
            // Xiaomi
          ],
          [aA, [nA, II], [lA, rA]],
          [
            /Hbbtv.*(technisat) (.*);/i
            // TechniSAT
          ],
          [nA, aA, [lA, rA]],
          [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            // HbbTV devices
          ],
          [[nA, UI], [aA, UI], [lA, rA]],
          [
            // SmartTV from Unidentified Vendors
            /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
          ],
          [aA, [lA, rA]],
          [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          ],
          [[lA, rA]],
          [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            // Ouya
            /(nintendo) ([wids3utch]+)/i
            // Nintendo
          ],
          [nA, aA, [lA, wA]],
          [
            /droid.+; (shield)( bui|\))/i
            // Nvidia Portable
          ],
          [aA, [nA, AI], [lA, wA]],
          [
            /(playstation \w+)/i
            // Playstation
          ],
          [aA, [nA, CI], [lA, wA]],
          [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            // Microsoft Xbox
          ],
          [aA, [nA, TA], [lA, wA]],
          [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
            // Samsung Galaxy Watch
          ],
          [aA, [nA, XA], [lA, yA]],
          [
            /((pebble))app/i,
            // Pebble
            /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
            // Asus ZenWatch / LG Watch / Pixel Watch
          ],
          [nA, aA, [lA, yA]],
          [
            /(ow(?:19|20)?we?[1-3]{1,3})/i
            // Oppo Watch
          ],
          [aA, [nA, PA], [lA, yA]],
          [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            // Apple Watch
          ],
          [aA, [nA, dA], [lA, yA]],
          [
            /(opwwe\d{3})/i
            // OnePlus Watch
          ],
          [aA, [nA, QI], [lA, yA]],
          [
            /(moto 360)/i
            // Motorola 360
          ],
          [aA, [nA, ZA], [lA, yA]],
          [
            /(smartwatch 3)/i
            // Sony SmartWatch
          ],
          [aA, [nA, CI], [lA, yA]],
          [
            /(g watch r)/i
            // LG G Watch R
          ],
          [aA, [nA, HA], [lA, yA]],
          [
            /droid.+; (wt63?0{2,3})\)/i
          ],
          [aA, [nA, vA], [lA, yA]],
          [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i
            // Google Glass
          ],
          [aA, [nA, fA], [lA, yA]],
          [
            /(pico) (4|neo3(?: link|pro)?)/i
            // Pico
          ],
          [nA, aA, [lA, yA]],
          [
            /; (quest( \d| pro)?)/i
            // Oculus Quest
          ],
          [aA, [nA, wI], [lA, yA]],
          [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            // Tesla
          ],
          [nA, [lA, bA]],
          [
            /(aeobc)\b/i
            // Echo Dot
          ],
          [aA, [nA, FA], [lA, bA]],
          [
            /(homepod).+mac os/i
            // Apple HomePod
          ],
          [aA, [nA, dA], [lA, bA]],
          [
            /windows iot/i
          ],
          [[lA, bA]],
          [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            // Android Phones from Unidentified Vendors
          ],
          [aA, [lA, sA]],
          [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            // Android Tablets from Unidentified Vendors
          ],
          [aA, [lA, NA]],
          [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            // Unidentifiable Tablet
          ],
          [[lA, NA]],
          [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            // Unidentifiable Mobile
          ],
          [[lA, sA]],
          [
            /droid .+?; ([\w\. -]+)( bui|\))/i
            // Generic Android Device
          ],
          [aA, [nA, "Generic"]]
        ],
        engine: [
          [
            /windows.+ edge\/([\w\.]+)/i
            // EdgeHTML
          ],
          [DA, [GA, JA + "HTML"]],
          [
            /(arkweb)\/([\w\.]+)/i
            // ArkWeb
          ],
          [GA, DA],
          [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            // Blink
          ],
          [DA, [GA, "Blink"]],
          [
            /(presto)\/([\w\.]+)/i,
            // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
            /ekioh(flow)\/([\w\.]+)/i,
            // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            // iCab
            /\b(libweb)/i
            // LibWeb
          ],
          [GA, DA],
          [
            /ladybird\//i
          ],
          [[GA, "LibWeb"]],
          [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
            // Gecko
          ],
          [DA, GA]
        ],
        os: [
          [
            // Windows
            /microsoft (windows) (vista|xp)/i
            // Windows (iTunes)
          ],
          [GA, DA],
          [
            /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
            // Windows Phone
          ],
          [GA, [DA, mI, KA]],
          [
            /windows nt 6\.2; (arm)/i,
            // Windows RT
            /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
          ],
          [[DA, mI, KA], [GA, "Windows"]],
          [
            // iOS/macOS
            /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
            // iOS
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
          ],
          [[DA, /_/g, "."], [GA, "iOS"]],
          [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            // Mac OS
          ],
          [[GA, YI], [DA, /_/g, "."]],
          [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            // Android-x86/HarmonyOS
          ],
          [DA, GA],
          [
            /(ubuntu) ([\w\.]+) like android/i
            // Ubuntu Touch
          ],
          [[GA, /(.+)/, "$1 Touch"], DA],
          [
            // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
            /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
          ],
          [GA, DA],
          [
            /\(bb(10);/i
            // BlackBerry 10
          ],
          [DA, [GA, pA]],
          [
            /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
            // Symbian
          ],
          [DA, [GA, "Symbian"]],
          [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            // Firefox OS
          ],
          [DA, [GA, UA + " OS"]],
          [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            // WebOS
          ],
          [DA, [GA, "webOS"]],
          [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            // watchOS
          ],
          [DA, [GA, "watchOS"]],
          [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
            // Google Chromecast
          ],
          [DA, [GA, SA + "cast"]],
          [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            // Chromium OS
          ],
          [[GA, $A], DA],
          [
            // Smart TVs
            /panasonic;(viera)/i,
            // Panasonic Viera
            /(netrange)mmh/i,
            // Netrange
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // NetTV
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,
            // Microsoft Xbox (360, One, X, S, Series X, Series S)
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,
            // Mint
            /(mageia|vectorlinux)[; ]/i,
            // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
            // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,
            // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i
            // Haiku
          ],
          [GA, DA],
          [
            /(sunos) ?([\w\.\d]*)/i
            // Solaris
          ],
          [[GA, "Solaris"], DA],
          [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
            /(unix) ?([\w\.]*)/i
            // UNIX
          ],
          [GA, DA]
        ]
      }, iI = function(oI, eI) {
        if (typeof oI === cA && (eI = oI, oI = IA), !(this instanceof iI))
          return new iI(oI, eI).getResult();
        var gI = typeof AA !== oA && AA.navigator ? AA.navigator : IA, mA = oI || (gI && gI.userAgent ? gI.userAgent : QA), WA = gI && gI.userAgentData ? gI.userAgentData : IA, xA = eI ? nI(OA, eI) : OA, qA = gI && gI.userAgent == mA;
        return this.getBrowser = function() {
          var VA = {};
          return VA[GA] = IA, VA[DA] = IA, pI.call(VA, mA, xA.browser), VA[eA] = HI(VA[DA]), qA && gI && gI.brave && typeof gI.brave.isBrave == iA && (VA[GA] = "Brave"), VA;
        }, this.getCPU = function() {
          var VA = {};
          return VA[hA] = IA, pI.call(VA, mA, xA.cpu), VA;
        }, this.getDevice = function() {
          var VA = {};
          return VA[nA] = IA, VA[aA] = IA, VA[lA] = IA, pI.call(VA, mA, xA.device), qA && !VA[lA] && WA && WA.mobile && (VA[lA] = sA), qA && VA[aA] == "Macintosh" && gI && typeof gI.standalone !== oA && gI.maxTouchPoints && gI.maxTouchPoints > 2 && (VA[aA] = "iPad", VA[lA] = NA), VA;
        }, this.getEngine = function() {
          var VA = {};
          return VA[GA] = IA, VA[DA] = IA, pI.call(VA, mA, xA.engine), VA;
        }, this.getOS = function() {
          var VA = {};
          return VA[GA] = IA, VA[DA] = IA, pI.call(VA, mA, xA.os), qA && !VA[GA] && WA && WA.platform && WA.platform != "Unknown" && (VA[GA] = WA.platform.replace(/chrome os/i, $A).replace(/macos/i, YI)), VA;
        }, this.getResult = function() {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function() {
          return mA;
        }, this.setUA = function(VA) {
          return mA = typeof VA === tA && VA.length > RA ? UI(VA, RA) : VA, this;
        }, this.setUA(mA), this;
      };
      iI.VERSION = BA, iI.BROWSER = uI([GA, DA, eA]), iI.CPU = uI([hA]), iI.DEVICE = uI([aA, nA, lA, wA, sA, rA, NA, yA, bA]), iI.ENGINE = iI.OS = uI([GA, DA]), CA.exports && (gA = CA.exports = iI), gA.UAParser = iI;
      var tI = typeof AA !== oA && (AA.jQuery || AA.Zepto);
      if (tI && !tI.ua) {
        var GI = new iI();
        tI.ua = GI.getResult(), tI.ua.get = function() {
          return GI.getUA();
        }, tI.ua.set = function(oI) {
          GI.setUA(oI);
          var eI = GI.getResult();
          for (var gI in eI)
            tI.ua[gI] = eI[gI];
        };
      }
    })(typeof window == "object" ? window : uaParser);
  })(uaParser$1, uaParser$1.exports)), uaParser$1.exports;
}
var uaParserExports = requireUaParser();
const UAParser = /* @__PURE__ */ getDefaultExportFromCjs(uaParserExports), parser = new UAParser();
function isMobile() {
  return parser.getResult().device.type === "mobile";
}
class CircularBuffer {
  /**
   * Creates an instance of CircularBuffer.
   * @param {number} size - The size of the buffer.
   */
  constructor(gA) {
    this._buffer = new Array(gA), this._size = gA, this._index = 0, this._wrappedCount = 0;
  }
  /**
   * Adds a value to the buffer.
   * @param {T} value - The value to add to the buffer.
   */
  push(gA) {
    this._buffer[this._index] = gA, this._index = (this._index + 1) % this._size, this._index === 0 && (this._wrappedCount = this._wrappedCount + 1);
  }
  /**
   * Gets the current state of the buffer.
   * @returns {readonly T[]} The buffer array.
   */
  get buffer() {
    return this._buffer;
  }
  /**
   * Gets the total number of entries written to the buffer.
   * @returns {number} The total number of written entries.
   */
  get totalWrittenEntries() {
    return this._wrappedCount * this._size + this._index;
  }
}
const handleRender = (CA, gA, AA, IA, BA, QA) => {
  window.__streamlit_profiles__ = window.__streamlit_profiles__ || {}, window.__streamlit_profiles__[CA] = window.__streamlit_profiles__[CA] || // Use a CircularBuffer to limit the number of profiles stored in memory to
  // prevent any potential memory leaks.
  // 1000 is an arbitrary number that should be enough to store more than
  // enough entries for debugging purposes without consuming too much memory.
  new CircularBuffer(1e3), window.__streamlit_profiles__[CA].push({
    phase: gA,
    actualDuration: AA,
    baseDuration: IA,
    startTime: BA,
    commitTime: QA
  });
}, Profiler = ({
  id: CA,
  children: gA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler$1, { id: CA, onRender: handleRender, children: gA }), getCopyButtonBaseStyles = (CA, {
  buttonSize: gA,
  focusRing: AA
} = {}) => ({
  ...gA && {
    height: gA,
    width: gA
  },
  padding: CA.spacing.none,
  border: "none",
  backgroundColor: CA.colors.transparent,
  color: CA.colors.fadedText60,
  cursor: "pointer",
  borderRadius: CA.radii.sm,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    color: CA.colors.bodyText,
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:active": {
    color: CA.colors.bodyText,
    backgroundColor: CA.colors.darkenedBgMix25
  },
  "&:focus-visible": {
    outline: "none",
    boxShadow: AA ?? CA.shadows.focusRing
  }
}), StyledCopyButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e1cxdbri0"
} : {
  target: "e1cxdbri0",
  label: "StyledCopyButton"
})(({
  theme: CA,
  buttonSize: gA
}) => ({
  ...getCopyButtonBaseStyles(CA, {
    buttonSize: gA
  })
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), CopyButton = ({
  text: CA,
  iconSize: gA,
  buttonSize: AA,
  copyLabel: IA,
  copiedLabel: BA,
  className: QA,
  "data-testid": EA,
  "aria-label": iA,
  title: oA
}) => {
  const cA = useEmotionTheme(), {
    isCopied: tA,
    copyToClipboard: eA,
    label: aA
  } = useCopyToClipboard(), GA = useCallback(() => {
    eA(CA);
  }, [eA, CA]), lA = convertRemToPx(gA ?? cA.iconSizes.base), nA = AA ?? cA.iconSizes.threeXL, DA = tA ? BA ?? aA : IA ?? aA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCopyButton, { className: QA, "data-testid": EA, title: oA ?? DA, "aria-label": iA ?? DA, "data-copy-state": tA ? "copied" : "idle", type: "button", buttonSize: nA, onClick: GA, children: tA ? /* @__PURE__ */ jsxRuntimeExports.jsx(Check$1, { size: lA }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Copy, { size: lA }) });
}, CopyButton$1 = memo(CopyButton), useWindowDimensions = () => {
  const CA = useEmotionTheme(), [gA, AA] = useState({
    fullWidth: 0,
    fullHeight: 0,
    innerWidth: 0,
    innerHeight: 0
  }), IA = useCallback(() => {
    const QA = convertRemToPx(CA.spacing.md), EA = convertRemToPx(CA.sizes.fullScreenHeaderHeight), {
      innerWidth: iA,
      innerHeight: oA
    } = window;
    return {
      fullWidth: iA - QA * 2,
      // Left and right
      fullHeight: oA - (QA + EA),
      // Bottom and Top
      innerWidth: iA,
      innerHeight: oA
    };
  }, [CA.sizes.fullScreenHeaderHeight, CA.spacing.md]), BA = useCallback(() => {
    AA(IA());
  }, [IA]);
  return useEffect(() => (window.addEventListener("resize", BA), () => {
    window.removeEventListener("resize", BA);
  }), [BA]), useLayoutEffect$1(() => {
    BA();
  }, [BA]), gA;
}, WindowDimensionsProvider = ({
  children: CA
}) => {
  const gA = useWindowDimensions();
  if (useContext(WindowDimensionsContext))
    throw new Error("WindowDimensionsProvider should only be used once per app. If you need to read window dimensions, utilize `useWindowDimensionsContext()` instead.");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsContext.Provider, { value: gA, children: CA });
}, LOG$b = loglevelExports.getLogger("ComponentRegistry");
class ComponentRegistry {
  constructor(gA) {
    this.msgListeners = /* @__PURE__ */ new Map(), this.registerListener = (AA, IA) => {
      this.msgListeners.has(AA) && LOG$b.warn("MessageEventSource registered multiple times!", AA), this.msgListeners.set(AA, IA);
    }, this.deregisterListener = (AA) => {
      this.msgListeners.delete(AA) || LOG$b.warn("Could not deregister unregistered MessageEventSource!");
    }, this.checkSourceUrlResponse = (AA, IA) => this.endpoints.checkSourceUrlResponse(AA, "Custom Component", IA), this.sendTimeoutError = (AA, IA) => {
      this.endpoints.sendClientErrorToHost("Custom Component", "Request Timeout", "Your app is having trouble loading the component.", AA, IA);
    }, this.getComponentURL = (AA, IA) => this.endpoints.buildComponentURL(AA, IA), this.getBidiComponentURL = (AA, IA) => this.endpoints.buildBidiComponentURL(AA, IA), this.onMessageEvent = (AA) => {
      if (isNullOrUndefined$1(AA.data) || !Object.hasOwn(AA.data, "isStreamlitMessage"))
        return;
      if (isNullOrUndefined$1(AA.source)) {
        LOG$b.warn("Received component message with no eventSource!", AA.data);
        return;
      }
      const IA = this.msgListeners.get(AA.source);
      if (isNullOrUndefined$1(IA) || typeof IA != "function") {
        LOG$b.warn("Received component message for unregistered ComponentInstance!", AA.data);
        return;
      }
      const {
        type: BA
      } = AA.data;
      if (isNullOrUndefined$1(BA)) {
        LOG$b.warn("Received Streamlit message with no type!", AA.data);
        return;
      }
      IA(BA, AA.data);
    }, this.endpoints = gA, window.addEventListener("message", this.onMessageEvent);
  }
}
const byteToHex = [];
for (let CA = 0; CA < 256; ++CA)
  byteToHex.push((CA + 256).toString(16).slice(1));
function unsafeStringify(CA, gA = 0) {
  return (byteToHex[CA[gA + 0]] + byteToHex[CA[gA + 1]] + byteToHex[CA[gA + 2]] + byteToHex[CA[gA + 3]] + "-" + byteToHex[CA[gA + 4]] + byteToHex[CA[gA + 5]] + "-" + byteToHex[CA[gA + 6]] + byteToHex[CA[gA + 7]] + "-" + byteToHex[CA[gA + 8]] + byteToHex[CA[gA + 9]] + "-" + byteToHex[CA[gA + 10]] + byteToHex[CA[gA + 11]] + byteToHex[CA[gA + 12]] + byteToHex[CA[gA + 13]] + byteToHex[CA[gA + 14]] + byteToHex[CA[gA + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function _v4(CA, gA, AA) {
  CA = CA || {};
  const IA = CA.random ?? CA.rng?.() ?? rng();
  if (IA.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return IA[6] = IA[6] & 15 | 64, IA[8] = IA[8] & 63 | 128, unsafeStringify(IA);
}
function v4(CA, gA, AA) {
  return native.randomUUID && !CA ? native.randomUUID() : _v4(CA);
}
var __typeError = (CA) => {
  throw TypeError(CA);
}, __accessCheck = (CA, gA, AA) => gA.has(CA) || __typeError("Cannot " + AA), __privateGet = (CA, gA, AA) => (__accessCheck(CA, gA, "read from private field"), AA ? AA.call(CA) : gA.get(CA)), __privateAdd = (CA, gA, AA) => gA.has(CA) ? __typeError("Cannot add the same private member more than once") : gA instanceof WeakSet ? gA.add(CA) : gA.set(CA, AA), __privateSet = (CA, gA, AA, IA) => (__accessCheck(CA, gA, "write to private field"), gA.set(CA, AA), AA), __privateMethod = (CA, gA, AA) => (__accessCheck(CA, gA, "access private method"), AA), MAX_CHUNK_SIZE = 65536;
function* chunk(CA) {
  if (CA.byteLength <= MAX_CHUNK_SIZE) {
    yield CA;
    return;
  }
  let gA = 0;
  for (; gA < CA.byteLength; ) {
    const AA = Math.min(CA.byteLength - gA, MAX_CHUNK_SIZE), IA = CA.buffer.slice(gA, gA + AA);
    gA += IA.byteLength, yield new Uint8Array(IA);
  }
}
var alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
function createBoundary() {
  let CA = 16, gA = "";
  for (; CA--; )
    gA += alphabet[Math.random() * alphabet.length << 0];
  return gA;
}
var escapeName = (CA) => String(CA).replace(/\r/g, "%0D").replace(/\n/g, "%0A").replace(/"/g, "%22"), isFunction = (CA) => typeof CA == "function", isReadableStreamFallback = (CA) => !!CA && typeof CA == "object" && !Array.isArray(CA) && isFunction(CA.getReader), isAsyncIterable = (CA) => isFunction(CA[Symbol.asyncIterator]);
async function* readStream(CA) {
  const gA = CA.getReader();
  for (; ; ) {
    const { done: AA, value: IA } = await gA.read();
    if (AA)
      break;
    yield IA;
  }
}
async function* chunkStream(CA) {
  for await (const gA of CA)
    yield* chunk(gA);
}
var getStreamIterator = (CA) => {
  if (isAsyncIterable(CA))
    return chunkStream(CA);
  if (isReadableStreamFallback(CA))
    return chunkStream(readStream(CA));
  throw new TypeError(
    "Unsupported data source: Expected either ReadableStream or async iterable."
  );
}, isFile = (CA) => !!(CA && typeof CA == "object" && isFunction(CA.constructor) && CA[Symbol.toStringTag] === "File" && isFunction(CA.stream) && CA.name != null), isFormData = (CA) => !!(CA && isFunction(CA.constructor) && CA[Symbol.toStringTag] === "FormData" && isFunction(CA.append) && isFunction(CA.getAll) && isFunction(CA.entries) && isFunction(CA[Symbol.iterator])), getType = (CA) => Object.prototype.toString.call(CA).slice(8, -1).toLowerCase();
function isPlainObject(CA) {
  if (getType(CA) !== "object")
    return !1;
  const gA = Object.getPrototypeOf(CA);
  return gA == null ? !0 : gA.constructor?.toString?.() === Object.toString();
}
var normalizeValue = (CA) => String(CA).replace(/\r|\n/g, (gA, AA, IA) => gA === "\r" && IA[AA + 1] !== `
` || gA === `
` && IA[AA - 1] !== "\r" ? `\r
` : gA);
function getProperty(CA, gA) {
  if (typeof gA == "string") {
    for (const [AA, IA] of Object.entries(CA))
      if (gA.toLowerCase() === AA.toLowerCase())
        return IA;
  }
}
var proxyHeaders = (CA) => new Proxy(
  CA,
  {
    get: (gA, AA) => getProperty(gA, AA),
    has: (gA, AA) => getProperty(gA, AA) !== void 0
  }
), defaultOptions = {
  enableAdditionalHeaders: !1
}, readonlyProp = { writable: !1, configurable: !1 }, _CRLF, _CRLF_BYTES, _CRLF_BYTES_LENGTH, _DASHES, _encoder, _footer, _form, _options, _FormDataEncoder_instances, getFieldHeader_fn, getContentLength_fn, FormDataEncoder = class {
  constructor(CA, gA, AA) {
    if (__privateAdd(this, _FormDataEncoder_instances), __privateAdd(this, _CRLF, `\r
`), __privateAdd(this, _CRLF_BYTES), __privateAdd(this, _CRLF_BYTES_LENGTH), __privateAdd(this, _DASHES, "-".repeat(2)), __privateAdd(this, _encoder, new TextEncoder()), __privateAdd(this, _footer), __privateAdd(this, _form), __privateAdd(this, _options), !isFormData(CA))
      throw new TypeError("Expected first argument to be a FormData instance.");
    let IA;
    if (isPlainObject(gA) ? AA = gA : IA = gA, IA || (IA = `form-data-encoder-${createBoundary()}`), typeof IA != "string")
      throw new TypeError("Expected boundary argument to be a string.");
    if (AA && !isPlainObject(AA))
      throw new TypeError("Expected options argument to be an object.");
    __privateSet(this, _form, Array.from(CA.entries())), __privateSet(this, _options, { ...defaultOptions, ...AA }), __privateSet(this, _CRLF_BYTES, __privateGet(this, _encoder).encode(__privateGet(this, _CRLF))), __privateSet(this, _CRLF_BYTES_LENGTH, __privateGet(this, _CRLF_BYTES).byteLength), this.boundary = IA, this.contentType = `multipart/form-data; boundary=${this.boundary}`, __privateSet(this, _footer, __privateGet(this, _encoder).encode(
      `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _DASHES)}${__privateGet(this, _CRLF).repeat(2)}`
    ));
    const BA = {
      "Content-Type": this.contentType
    }, QA = __privateMethod(this, _FormDataEncoder_instances, getContentLength_fn).call(this);
    QA && (this.contentLength = QA, BA["Content-Length"] = QA), this.headers = proxyHeaders(Object.freeze(BA)), Object.defineProperties(this, {
      boundary: readonlyProp,
      contentType: readonlyProp,
      contentLength: readonlyProp,
      headers: readonlyProp
    });
  }
  /**
   * Creates an iterator allowing to go through form-data parts (with metadata).
   * This method **will not** read the files and **will not** split values big into smaller chunks.
   *
   * Using this method, you can convert form-data content into Blob:
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import {FormData} from "formdata-polyfill/esm-min.js"
   * import {fileFrom} from "fetch-blob/form.js"
   * import {File} from "fetch-blob/file.js"
   * import {Blob} from "fetch-blob"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"]))
   * form.set("fileFromPath", await fileFrom("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   body: new Blob(encoder, {type: encoder.contentType})
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  *values() {
    for (const [CA, gA] of __privateGet(this, _form)) {
      const AA = isFile(gA) ? gA : __privateGet(this, _encoder).encode(normalizeValue(gA));
      yield __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, CA, AA), yield AA, yield __privateGet(this, _CRLF_BYTES);
    }
    yield __privateGet(this, _footer);
  }
  /**
   * Creates an async iterator allowing to perform the encoding by portions.
   * This method reads through files and splits big values into smaller pieces (65536 bytes per each).
   *
   * @example
   *
   * ```ts
   * import {Readable} from "stream"
   *
   * import {FormData, File, fileFromPath} from "formdata-node"
   * import {FormDataEncoder} from "form-data-encoder"
   *
   * import fetch from "node-fetch"
   *
   * const form = new FormData()
   *
   * form.set("field", "Just a random string")
   * form.set("file", new File(["Using files is class amazing"], "file.txt"))
   * form.set("fileFromPath", await fileFromPath("path/to/a/file.txt"))
   *
   * const encoder = new FormDataEncoder(form)
   *
   * const options = {
   *   method: "post",
   *   headers: encoder.headers,
   *   body: Readable.from(encoder.encode()) // or Readable.from(encoder)
   * }
   *
   * const response = await fetch("https://httpbin.org/post", options)
   *
   * console.log(await response.json())
   * ```
   */
  async *encode() {
    for (const CA of this.values())
      isFile(CA) ? yield* getStreamIterator(CA.stream()) : yield* chunk(CA);
  }
  /**
   * Creates an iterator allowing to read through the encoder data using for...of loops
   */
  [Symbol.iterator]() {
    return this.values();
  }
  /**
   * Creates an **async** iterator allowing to read through the encoder data using for-await...of loops
   */
  [Symbol.asyncIterator]() {
    return this.encode();
  }
};
_CRLF = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES = /* @__PURE__ */ new WeakMap();
_CRLF_BYTES_LENGTH = /* @__PURE__ */ new WeakMap();
_DASHES = /* @__PURE__ */ new WeakMap();
_encoder = /* @__PURE__ */ new WeakMap();
_footer = /* @__PURE__ */ new WeakMap();
_form = /* @__PURE__ */ new WeakMap();
_options = /* @__PURE__ */ new WeakMap();
_FormDataEncoder_instances = /* @__PURE__ */ new WeakSet();
getFieldHeader_fn = function(CA, gA) {
  let AA = "";
  if (AA += `${__privateGet(this, _DASHES)}${this.boundary}${__privateGet(this, _CRLF)}`, AA += `Content-Disposition: form-data; name="${escapeName(CA)}"`, isFile(gA) && (AA += `; filename="${escapeName(gA.name)}"${__privateGet(this, _CRLF)}`, AA += `Content-Type: ${gA.type || "application/octet-stream"}`), __privateGet(this, _options).enableAdditionalHeaders === !0) {
    const IA = isFile(gA) ? gA.size : gA.byteLength;
    IA != null && !isNaN(IA) && (AA += `${__privateGet(this, _CRLF)}Content-Length: ${IA}`);
  }
  return __privateGet(this, _encoder).encode(`${AA}${__privateGet(this, _CRLF).repeat(2)}`);
};
getContentLength_fn = function() {
  let CA = 0;
  for (const [gA, AA] of __privateGet(this, _form)) {
    const IA = isFile(AA) ? AA : __privateGet(this, _encoder).encode(normalizeValue(AA)), BA = isFile(IA) ? IA.size : IA.byteLength;
    if (BA == null || isNaN(BA))
      return;
    CA += __privateMethod(this, _FormDataEncoder_instances, getFieldHeader_fn).call(this, gA, IA).byteLength, CA += BA, CA += __privateGet(this, _CRLF_BYTES_LENGTH);
  }
  return String(CA + __privateGet(this, _footer).byteLength);
};
const LOG$a = loglevelExports.getLogger("FileUploadClient");
class FileUploadClient {
  constructor(gA) {
    this.formsWithPendingRequests = /* @__PURE__ */ new Map(), this.pendingFileURLsRequests = /* @__PURE__ */ new Map(), this.sessionInfo = gA.sessionInfo, this.endpoints = gA.endpoints, this.pendingFormUploadsChanged = gA.formsWithPendingRequestsChanged, this.requestFileURLs = gA.requestFileURLs;
  }
  setKernel(gA) {
    this.kernel = gA;
  }
  /**
   * Upload a file to the given URL. It will be associated with this browser's
   * sessionID.
   *
   * @param widget: the FileUploader widget that's doing the upload.
   * @param fileUploadUrl: the URL to upload the file to.
   * @param file: the files to upload.
   * @param onUploadProgress: an optional function that will be called repeatedly with progress events during the upload.
   * @param signal: an optional AbortSignal that can be used to cancel the in-progress upload.
   *
   * @return a Promise<void> that resolves with a void promise when the upload is complete.
   */
  async uploadFile(gA, AA, IA, BA, QA) {
    this.offsetPendingRequestCount(gA.formId, 1);
    const EA = new FormData();
    EA.append(IA.name, IA);
    const iA = new FormDataEncoder(EA);
    return new Blob(iA, {
      type: iA.contentType
    }).arrayBuffer().then((cA) => {
      if (this.kernel == null)
        throw new Error("Kernel not ready");
      return this.kernel.sendHttpRequest({
        method: "PUT",
        path: AA,
        body: cA,
        headers: {
          ...iA.headers
        }
      }, QA).then((tA) => {
        if (Math.floor(tA.statusCode / 100) !== 2)
          throw new Error(`Unexpected status code ${tA.statusCode} when uploading file.`);
      }).finally(() => this.offsetPendingRequestCount(gA.formId, -1));
    });
  }
  /**
   * Request that the file at the given URL is deleted.
   * @param fileUrl: the URL of the file to delete.
   */
  deleteFile(gA) {
    if (this.kernel == null)
      throw new Error("Kernel not ready");
    return this.kernel.sendHttpRequest({
      method: "DELETE",
      path: gA,
      body: "",
      headers: {}
    }).then((AA) => {
      if (Math.floor(AA.statusCode / 100) !== 2)
        throw new Error(`Unexpected status code ${AA.statusCode} when uploading file.`);
    });
  }
  /**
   * Request that the app fetch URLs to upload/delete/get the given files. Once
   * this is done, the app should call this class' onFileURLsResponse to
   * signify completion.
   *
   * @param files: An array of files.
   *
   * @return a Promise<FileURLsResponse.IFileURLs[]> resolving to a list of
   * URLs for uploading and deleting the given files.
   */
  fetchFileURLs(gA) {
    if (!this.requestFileURLs)
      return Promise.resolve([]);
    const AA = Promise.withResolvers(), IA = v4();
    return this.pendingFileURLsRequests.set(IA, AA), this.requestFileURLs(IA, gA), AA.promise;
  }
  /**
   * Callback to be called by the app once the file URLs corresponding to a
   * call to this.requestFileURLs has been received.
   *
   * @param resp: the FileURLsResponse corresponding to a call to
   * this.requestFileURLs.
   */
  onFileURLsResponse(gA) {
    const AA = gA.responseId, IA = this.pendingFileURLsRequests.get(AA);
    IA ? (gA.errorMsg ? IA.reject(gA.errorMsg) : IA.resolve(gA.fileUrls || []), this.pendingFileURLsRequests.delete(AA)) : LOG$a.warn("fileURLsResponse received for nonexistent request, ignoring.");
  }
  getFormIdSet() {
    return new Set(this.formsWithPendingRequests.keys());
  }
  offsetPendingRequestCount(gA, AA) {
    if (AA === 0 || !isValidFormId(gA))
      return;
    const IA = this.formsWithPendingRequests.get(gA) ?? 0, BA = IA + AA;
    if (BA < 0)
      throw new Error(`Can't offset pendingRequestCount below 0 (formId=${gA}, curCount=${IA}, offset=${AA})`);
    const QA = this.getFormIdSet();
    BA === 0 ? this.formsWithPendingRequests.delete(gA) : this.formsWithPendingRequests.set(gA, BA);
    const EA = this.getFormIdSet();
    isEqual(EA, QA) || this.pendingFormUploadsChanged(EA);
  }
}
const HOST_COMM_VERSION = 1;
class HostCommunicationManager {
  constructor(gA) {
    this.isHostCommOpen = !1, this.openHostCommunication = () => {
      this.isHostCommOpen || (this.isHostCommOpen = !0, window.addEventListener("message", this.receiveHostMessage), this.sendMessageToHost({
        type: "GUEST_READY",
        streamlitExecutionStartedAt: this.props.streamlitExecutionStartedAt,
        guestReadyAt: Date.now()
      }));
    }, this.closeHostCommunication = () => {
      window.removeEventListener("message", this.receiveHostMessage), this.isHostCommOpen = !1;
    }, this.resetAuthToken = () => {
      this.deferredAuthToken = Promise.withResolvers();
    }, this.claimAuthToken = () => this.deferredAuthToken.promise, this.setAllowedOrigins = ({
      allowedOrigins: AA,
      useExternalAuthToken: IA
    }) => {
      IA || this.deferredAuthToken.resolve(void 0), AA?.length && (this.allowedOrigins = AA, this.openHostCommunication());
    }, this.sendMessageToSameOriginHost = (AA) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...AA
      }, window.location.origin);
    }, this.sendMessageToHost = (AA) => {
      window.parent.postMessage({
        stCommVersion: HOST_COMM_VERSION,
        ...AA
      }, "*");
    }, this.receiveHostMessage = (AA) => {
      const IA = AA.data;
      if (!(IA.stCommVersion !== HOST_COMM_VERSION || !this.allowedOrigins.find((BA) => isValidOrigin(BA, AA.origin)))) {
        if (IA.type === "CLOSE_MODAL" && this.props.closeModal(), IA.type === "STOP_SCRIPT" && this.props.stopScript(), IA.type === "RERUN_SCRIPT" && this.props.rerunScript(), IA.type === "CLEAR_CACHE" && this.props.clearCache(), IA.type === "REQUEST_PAGE_CHANGE" && this.props.pageChanged(IA.pageScriptHash), IA.type === "SEND_APP_HEARTBEAT") {
          const BA = IA.ackTimeoutMilliseconds, QA = typeof BA == "number" && Number.isFinite(BA) && BA > 0 ? BA : 0;
          this.props.sendAppHeartbeat(QA);
        }
        if (IA.type === "SET_INPUTS_DISABLED" && this.props.setInputsDisabled(IA.disabled), IA.type === "SET_AUTH_TOKEN" && this.deferredAuthToken.resolve(IA.authToken), IA.type === "SET_FILE_UPLOAD_CLIENT_CONFIG") {
          const {
            prefix: BA,
            headers: QA
          } = IA;
          this.props.fileUploadClientConfigChanged({
            prefix: BA,
            headers: QA
          });
        }
        IA.type === "SET_IS_OWNER" && this.props.isOwnerChanged(IA.isOwner), IA.type === "SET_MENU_ITEMS" && this.props.hostMenuItemsChanged(IA.items), IA.type === "SET_METADATA" && this.props.deployedAppMetadataChanged(IA.metadata), IA.type === "SET_PAGE_LINK_BASE_URL" && this.props.pageLinkBaseUrlChanged(IA.pageLinkBaseUrl), IA.type === "SET_SIDEBAR_CHEVRON_DOWNSHIFT" && this.props.sidebarChevronDownshiftChanged(IA.sidebarChevronDownshift), IA.type === "SET_SIDEBAR_NAV_VISIBILITY" && this.props.hostHideSidebarNavChanged(IA.hidden), IA.type === "SET_TOOLBAR_ITEMS" && this.props.hostToolbarItemsChanged(IA.items), IA.type === "UPDATE_FROM_QUERY_PARAMS" && (this.props.queryParamsChanged(IA.queryParams), this.props.sendRerunBackMsg()), IA.type === "UPDATE_HASH" && (window.location.hash = IA.hash), IA.type === "SET_CUSTOM_THEME_CONFIG" && this.props.themeChanged(IA.themeName, IA.themeInfo), IA.type === "RESTART_WEBSOCKET_CONNECTION" && this.props.restartWebsocketConnection(), IA.type === "TERMINATE_WEBSOCKET_CONNECTION" && this.props.terminateWebsocketConnection();
      }
    }, this.props = gA, this.allowedOrigins = [], this.deferredAuthToken = Promise.withResolvers();
  }
}
class SessionInfo {
  /** Return the current SessionInfo props. Throw an error if the props are undefined. */
  get current() {
    if (!this._current)
      throw new Error("Tried to use SessionInfo before it was initialized");
    return this._current;
  }
  /** Return the previous SessionInfo props. They may be undefined! */
  get last() {
    return this._last;
  }
  /**
   * Initialize `SessionInfo.current` with the given props and copy its
   * previous props to `SessionInfo.last`.
   */
  setCurrent(gA) {
    this._last = notNullOrUndefined(this._current) ? {
      ...this._current
    } : void 0, this._current = notNullOrUndefined(gA) ? {
      ...gA
    } : void 0;
  }
  /** Marks `SessionInfo.current` as not connected and copy its previous props to `SessionInfo.last`. */
  disconnect() {
    this._current && this.setCurrent({
      ...this._current,
      isConnected: !1
    });
  }
  /** True if `SessionInfo.current` exists. */
  get isSet() {
    return notNullOrUndefined(this._current);
  }
  /** True if `SessionInfo.current` refers to a "streamlit hello" session. */
  get isHello() {
    return notNullOrUndefined(this._current) && this._current.isHello;
  }
  /** Create SessionInfo Props from the relevant bits of an initialize message. */
  static propsFromNewSessionMessage(gA) {
    const AA = gA.initialize, IA = gA.config, BA = AA.userInfo, QA = AA.environmentInfo;
    return {
      appId: hashString(BA.installationIdV3 + gA.mainScriptPath),
      sessionId: AA.sessionId,
      streamlitVersion: QA.streamlitVersion,
      pythonVersion: QA.pythonVersion,
      serverOS: QA.serverOs,
      hasDisplay: QA.hasDisplay,
      installationId: BA.installationId,
      installationIdV3: BA.installationIdV3,
      installationIdV4: BA.installationIdV4,
      maxCachedMessageAge: IA.maxCachedMessageAge,
      isHello: AA.isHello,
      // We assume we are always connected because the message came directly from the server.
      isConnected: !0
    };
  }
}
const measure = (CA, gA, AA) => performance.measure(CA, gA, AA), mark = (CA) => performance.mark(CA);
var src = { exports: {} }, indexLight = { exports: {} }, types = {}, util = { exports: {} }, codegen_1, hasRequiredCodegen;
function requireCodegen() {
  if (hasRequiredCodegen) return codegen_1;
  hasRequiredCodegen = 1, codegen_1 = CA;
  function CA(gA, AA) {
    typeof gA == "string" && (AA = gA, gA = void 0);
    var IA = [];
    function BA(EA) {
      if (typeof EA != "string") {
        var iA = QA();
        if (CA.verbose && console.log("codegen: " + iA), iA = "return " + iA, EA) {
          for (var oA = Object.keys(EA), cA = new Array(oA.length + 1), tA = new Array(oA.length), eA = 0; eA < oA.length; )
            cA[eA] = oA[eA], tA[eA] = EA[oA[eA++]];
          return cA[eA] = iA, Function.apply(null, cA).apply(null, tA);
        }
        return Function(iA)();
      }
      for (var aA = new Array(arguments.length - 1), GA = 0; GA < aA.length; )
        aA[GA] = arguments[++GA];
      if (GA = 0, EA = EA.replace(/%([%dfijs])/g, function(nA, DA) {
        var hA = aA[GA++];
        switch (DA) {
          case "d":
          case "f":
            return String(Number(hA));
          case "i":
            return String(Math.floor(hA));
          case "j":
            return JSON.stringify(hA);
          case "s":
            return String(hA);
        }
        return "%";
      }), GA !== aA.length)
        throw Error("parameter count mismatch");
      return IA.push(EA), BA;
    }
    function QA(EA) {
      return "function " + (EA || AA || "") + "(" + (gA && gA.join(",") || "") + `){
  ` + IA.join(`
  `) + `
}`;
    }
    return BA.toString = QA, BA;
  }
  return CA.verbose = !1, codegen_1;
}
var fetch_1, hasRequiredFetch;
function requireFetch() {
  if (hasRequiredFetch) return fetch_1;
  hasRequiredFetch = 1, fetch_1 = IA;
  var CA = requireAspromise(), gA = requireInquire(), AA = gA("fs");
  function IA(BA, QA, EA) {
    return typeof QA == "function" ? (EA = QA, QA = {}) : QA || (QA = {}), EA ? !QA.xhr && AA && AA.readFile ? AA.readFile(BA, function(oA, cA) {
      return oA && typeof XMLHttpRequest < "u" ? IA.xhr(BA, QA, EA) : oA ? EA(oA) : EA(null, QA.binary ? cA : cA.toString("utf8"));
    }) : IA.xhr(BA, QA, EA) : CA(IA, this, BA, QA);
  }
  return IA.xhr = function(QA, EA, iA) {
    var oA = new XMLHttpRequest();
    oA.onreadystatechange = function() {
      if (oA.readyState === 4) {
        if (oA.status !== 0 && oA.status !== 200)
          return iA(Error("status " + oA.status));
        if (EA.binary) {
          var tA = oA.response;
          if (!tA) {
            tA = [];
            for (var eA = 0; eA < oA.responseText.length; ++eA)
              tA.push(oA.responseText.charCodeAt(eA) & 255);
          }
          return iA(null, typeof Uint8Array < "u" ? new Uint8Array(tA) : tA);
        }
        return iA(null, oA.responseText);
      }
    }, EA.binary && ("overrideMimeType" in oA && oA.overrideMimeType("text/plain; charset=x-user-defined"), oA.responseType = "arraybuffer"), oA.open("GET", QA), oA.send();
  }, fetch_1;
}
var path$1 = {}, hasRequiredPath$1;
function requirePath$1() {
  return hasRequiredPath$1 || (hasRequiredPath$1 = 1, (function(CA) {
    var gA = CA, AA = (
      /**
       * Tests if the specified path is absolute.
       * @param {string} path Path to test
       * @returns {boolean} `true` if path is absolute
       */
      gA.isAbsolute = function(QA) {
        return /^(?:\/|\w+:)/.test(QA);
      }
    ), IA = (
      /**
       * Normalizes the specified path.
       * @param {string} path Path to normalize
       * @returns {string} Normalized path
       */
      gA.normalize = function(QA) {
        QA = QA.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
        var EA = QA.split("/"), iA = AA(QA), oA = "";
        iA && (oA = EA.shift() + "/");
        for (var cA = 0; cA < EA.length; )
          EA[cA] === ".." ? cA > 0 && EA[cA - 1] !== ".." ? EA.splice(--cA, 2) : iA ? EA.splice(cA, 1) : ++cA : EA[cA] === "." ? EA.splice(cA, 1) : ++cA;
        return oA + EA.join("/");
      }
    );
    gA.resolve = function(QA, EA, iA) {
      return iA || (EA = IA(EA)), AA(EA) ? EA : (iA || (QA = IA(QA)), (QA = QA.replace(/(?:\/|^)[^/]+$/, "")).length ? IA(QA + "/" + EA) : EA);
    };
  })(path$1)), path$1;
}
var namespace, hasRequiredNamespace;
function requireNamespace() {
  if (hasRequiredNamespace) return namespace;
  hasRequiredNamespace = 1, namespace = oA;
  var CA = requireObject();
  ((oA.prototype = Object.create(CA.prototype)).constructor = oA).className = "Namespace";
  var gA = requireField(), AA = requireUtil(), IA = requireOneof(), BA, QA, EA;
  oA.fromJSON = function(eA, aA) {
    return new oA(eA, aA.options).addJSON(aA.nested);
  };
  function iA(tA, eA) {
    if (tA && tA.length) {
      for (var aA = {}, GA = 0; GA < tA.length; ++GA)
        aA[tA[GA].name] = tA[GA].toJSON(eA);
      return aA;
    }
  }
  oA.arrayToJSON = iA, oA.isReservedId = function(eA, aA) {
    if (eA) {
      for (var GA = 0; GA < eA.length; ++GA)
        if (typeof eA[GA] != "string" && eA[GA][0] <= aA && eA[GA][1] > aA)
          return !0;
    }
    return !1;
  }, oA.isReservedName = function(eA, aA) {
    if (eA) {
      for (var GA = 0; GA < eA.length; ++GA)
        if (eA[GA] === aA)
          return !0;
    }
    return !1;
  };
  function oA(tA, eA) {
    CA.call(this, tA, eA), this.nested = void 0, this._nestedArray = null, this._lookupCache = {}, this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
  }
  function cA(tA) {
    tA._nestedArray = null, tA._lookupCache = {};
    for (var eA = tA; eA = eA.parent; )
      eA._lookupCache = {};
    return tA;
  }
  return Object.defineProperty(oA.prototype, "nestedArray", {
    get: function() {
      return this._nestedArray || (this._nestedArray = AA.toArray(this.nested));
    }
  }), oA.prototype.toJSON = function(eA) {
    return AA.toObject([
      "options",
      this.options,
      "nested",
      iA(this.nestedArray, eA)
    ]);
  }, oA.prototype.addJSON = function(eA) {
    var aA = this;
    if (eA)
      for (var GA = Object.keys(eA), lA = 0, nA; lA < GA.length; ++lA)
        nA = eA[GA[lA]], aA.add(
          // most to least likely
          (nA.fields !== void 0 ? BA.fromJSON : nA.values !== void 0 ? EA.fromJSON : nA.methods !== void 0 ? QA.fromJSON : nA.id !== void 0 ? gA.fromJSON : oA.fromJSON)(GA[lA], nA)
        );
    return this;
  }, oA.prototype.get = function(eA) {
    return this.nested && this.nested[eA] || null;
  }, oA.prototype.getEnum = function(eA) {
    if (this.nested && this.nested[eA] instanceof EA)
      return this.nested[eA].values;
    throw Error("no such enum: " + eA);
  }, oA.prototype.add = function(eA) {
    if (!(eA instanceof gA && eA.extend !== void 0 || eA instanceof BA || eA instanceof IA || eA instanceof EA || eA instanceof QA || eA instanceof oA))
      throw TypeError("object must be a valid nested object");
    if (!this.nested)
      this.nested = {};
    else {
      var aA = this.get(eA.name);
      if (aA)
        if (aA instanceof oA && eA instanceof oA && !(aA instanceof BA || aA instanceof QA)) {
          for (var GA = aA.nestedArray, lA = 0; lA < GA.length; ++lA)
            eA.add(GA[lA]);
          this.remove(aA), this.nested || (this.nested = {}), eA.setOptions(aA.options, !0);
        } else
          throw Error("duplicate name '" + eA.name + "' in " + this);
    }
    this.nested[eA.name] = eA, this instanceof BA || this instanceof QA || this instanceof EA || this instanceof gA || eA._edition || (eA._edition = eA._defaultEdition), this._needsRecursiveFeatureResolution = !0, this._needsRecursiveResolve = !0;
    for (var nA = this; nA = nA.parent; )
      nA._needsRecursiveFeatureResolution = !0, nA._needsRecursiveResolve = !0;
    return eA.onAdd(this), cA(this);
  }, oA.prototype.remove = function(eA) {
    if (!(eA instanceof CA))
      throw TypeError("object must be a ReflectionObject");
    if (eA.parent !== this)
      throw Error(eA + " is not a member of " + this);
    return delete this.nested[eA.name], Object.keys(this.nested).length || (this.nested = void 0), eA.onRemove(this), cA(this);
  }, oA.prototype.define = function(eA, aA) {
    if (AA.isString(eA))
      eA = eA.split(".");
    else if (!Array.isArray(eA))
      throw TypeError("illegal path");
    if (eA && eA.length && eA[0] === "")
      throw Error("path must be relative");
    for (var GA = this; eA.length > 0; ) {
      var lA = eA.shift();
      if (GA.nested && GA.nested[lA]) {
        if (GA = GA.nested[lA], !(GA instanceof oA))
          throw Error("path conflicts with non-namespace objects");
      } else
        GA.add(GA = new oA(lA));
    }
    return aA && GA.addJSON(aA), GA;
  }, oA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    this._resolveFeaturesRecursive(this._edition);
    var eA = this.nestedArray, aA = 0;
    for (this.resolve(); aA < eA.length; )
      eA[aA] instanceof oA ? eA[aA++].resolveAll() : eA[aA++].resolve();
    return this._needsRecursiveResolve = !1, this;
  }, oA.prototype._resolveFeaturesRecursive = function(eA) {
    return this._needsRecursiveFeatureResolution ? (this._needsRecursiveFeatureResolution = !1, eA = this._edition || eA, CA.prototype._resolveFeaturesRecursive.call(this, eA), this.nestedArray.forEach((aA) => {
      aA._resolveFeaturesRecursive(eA);
    }), this) : this;
  }, oA.prototype.lookup = function(eA, aA, GA) {
    if (typeof aA == "boolean" ? (GA = aA, aA = void 0) : aA && !Array.isArray(aA) && (aA = [aA]), AA.isString(eA) && eA.length) {
      if (eA === ".")
        return this.root;
      eA = eA.split(".");
    } else if (!eA.length)
      return this;
    var lA = eA.join(".");
    if (eA[0] === "")
      return this.root.lookup(eA.slice(1), aA);
    var nA = this.root._fullyQualifiedObjects && this.root._fullyQualifiedObjects["." + lA];
    if (nA && (!aA || aA.indexOf(nA.constructor) > -1) || (nA = this._lookupImpl(eA, lA), nA && (!aA || aA.indexOf(nA.constructor) > -1)))
      return nA;
    if (GA)
      return null;
    for (var DA = this; DA.parent; ) {
      if (nA = DA.parent._lookupImpl(eA, lA), nA && (!aA || aA.indexOf(nA.constructor) > -1))
        return nA;
      DA = DA.parent;
    }
    return null;
  }, oA.prototype._lookupImpl = function(eA, aA) {
    if (Object.prototype.hasOwnProperty.call(this._lookupCache, aA))
      return this._lookupCache[aA];
    var GA = this.get(eA[0]), lA = null;
    if (GA)
      eA.length === 1 ? lA = GA : GA instanceof oA && (eA = eA.slice(1), lA = GA._lookupImpl(eA, eA.join(".")));
    else
      for (var nA = 0; nA < this.nestedArray.length; ++nA)
        this._nestedArray[nA] instanceof oA && (GA = this._nestedArray[nA]._lookupImpl(eA, aA)) && (lA = GA);
    return this._lookupCache[aA] = lA, lA;
  }, oA.prototype.lookupType = function(eA) {
    var aA = this.lookup(eA, [BA]);
    if (!aA)
      throw Error("no such type: " + eA);
    return aA;
  }, oA.prototype.lookupEnum = function(eA) {
    var aA = this.lookup(eA, [EA]);
    if (!aA)
      throw Error("no such Enum '" + eA + "' in " + this);
    return aA;
  }, oA.prototype.lookupTypeOrEnum = function(eA) {
    var aA = this.lookup(eA, [BA, EA]);
    if (!aA)
      throw Error("no such Type or Enum '" + eA + "' in " + this);
    return aA;
  }, oA.prototype.lookupService = function(eA) {
    var aA = this.lookup(eA, [QA]);
    if (!aA)
      throw Error("no such Service '" + eA + "' in " + this);
    return aA;
  }, oA._configure = function(tA, eA, aA) {
    BA = tA, QA = eA, EA = aA;
  }, namespace;
}
var mapfield, hasRequiredMapfield;
function requireMapfield() {
  if (hasRequiredMapfield) return mapfield;
  hasRequiredMapfield = 1, mapfield = IA;
  var CA = requireField();
  ((IA.prototype = Object.create(CA.prototype)).constructor = IA).className = "MapField";
  var gA = requireTypes(), AA = requireUtil();
  function IA(BA, QA, EA, iA, oA, cA) {
    if (CA.call(this, BA, QA, iA, void 0, void 0, oA, cA), !AA.isString(EA))
      throw TypeError("keyType must be a string");
    this.keyType = EA, this.resolvedKeyType = null, this.map = !0;
  }
  return IA.fromJSON = function(QA, EA) {
    return new IA(QA, EA.id, EA.keyType, EA.type, EA.options, EA.comment);
  }, IA.prototype.toJSON = function(QA) {
    var EA = QA ? !!QA.keepComments : !1;
    return AA.toObject([
      "keyType",
      this.keyType,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      EA ? this.comment : void 0
    ]);
  }, IA.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if (gA.mapKey[this.keyType] === void 0)
      throw Error("invalid key type: " + this.keyType);
    return CA.prototype.resolve.call(this);
  }, IA.d = function(QA, EA, iA) {
    return typeof iA == "function" ? iA = AA.decorateType(iA).name : iA && typeof iA == "object" && (iA = AA.decorateEnum(iA).name), function(cA, tA) {
      AA.decorateType(cA.constructor).add(new IA(tA, QA, EA, iA));
    };
  }, mapfield;
}
var method, hasRequiredMethod;
function requireMethod() {
  if (hasRequiredMethod) return method;
  hasRequiredMethod = 1, method = AA;
  var CA = requireObject();
  ((AA.prototype = Object.create(CA.prototype)).constructor = AA).className = "Method";
  var gA = requireUtil();
  function AA(IA, BA, QA, EA, iA, oA, cA, tA, eA) {
    if (gA.isObject(iA) ? (cA = iA, iA = oA = void 0) : gA.isObject(oA) && (cA = oA, oA = void 0), !(BA === void 0 || gA.isString(BA)))
      throw TypeError("type must be a string");
    if (!gA.isString(QA))
      throw TypeError("requestType must be a string");
    if (!gA.isString(EA))
      throw TypeError("responseType must be a string");
    CA.call(this, IA, cA), this.type = BA || "rpc", this.requestType = QA, this.requestStream = iA ? !0 : void 0, this.responseType = EA, this.responseStream = oA ? !0 : void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = tA, this.parsedOptions = eA;
  }
  return AA.fromJSON = function(BA, QA) {
    return new AA(BA, QA.type, QA.requestType, QA.responseType, QA.requestStream, QA.responseStream, QA.options, QA.comment, QA.parsedOptions);
  }, AA.prototype.toJSON = function(BA) {
    var QA = BA ? !!BA.keepComments : !1;
    return gA.toObject([
      "type",
      this.type !== "rpc" && /* istanbul ignore next */
      this.type || void 0,
      "requestType",
      this.requestType,
      "requestStream",
      this.requestStream,
      "responseType",
      this.responseType,
      "responseStream",
      this.responseStream,
      "options",
      this.options,
      "comment",
      QA ? this.comment : void 0,
      "parsedOptions",
      this.parsedOptions
    ]);
  }, AA.prototype.resolve = function() {
    return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), CA.prototype.resolve.call(this));
  }, method;
}
var service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = BA;
  var CA = requireNamespace();
  ((BA.prototype = Object.create(CA.prototype)).constructor = BA).className = "Service";
  var gA = requireMethod(), AA = requireUtil(), IA = requireRpc();
  function BA(EA, iA) {
    CA.call(this, EA, iA), this.methods = {}, this._methodsArray = null;
  }
  BA.fromJSON = function(iA, oA) {
    var cA = new BA(iA, oA.options);
    if (oA.methods)
      for (var tA = Object.keys(oA.methods), eA = 0; eA < tA.length; ++eA)
        cA.add(gA.fromJSON(tA[eA], oA.methods[tA[eA]]));
    return oA.nested && cA.addJSON(oA.nested), oA.edition && (cA._edition = oA.edition), cA.comment = oA.comment, cA._defaultEdition = "proto3", cA;
  }, BA.prototype.toJSON = function(iA) {
    var oA = CA.prototype.toJSON.call(this, iA), cA = iA ? !!iA.keepComments : !1;
    return AA.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      oA && oA.options || void 0,
      "methods",
      CA.arrayToJSON(this.methodsArray, iA) || /* istanbul ignore next */
      {},
      "nested",
      oA && oA.nested || void 0,
      "comment",
      cA ? this.comment : void 0
    ]);
  }, Object.defineProperty(BA.prototype, "methodsArray", {
    get: function() {
      return this._methodsArray || (this._methodsArray = AA.toArray(this.methods));
    }
  });
  function QA(EA) {
    return EA._methodsArray = null, EA;
  }
  return BA.prototype.get = function(iA) {
    return this.methods[iA] || CA.prototype.get.call(this, iA);
  }, BA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    CA.prototype.resolve.call(this);
    for (var iA = this.methodsArray, oA = 0; oA < iA.length; ++oA)
      iA[oA].resolve();
    return this;
  }, BA.prototype._resolveFeaturesRecursive = function(iA) {
    return this._needsRecursiveFeatureResolution ? (iA = this._edition || iA, CA.prototype._resolveFeaturesRecursive.call(this, iA), this.methodsArray.forEach((oA) => {
      oA._resolveFeaturesRecursive(iA);
    }), this) : this;
  }, BA.prototype.add = function(iA) {
    if (this.get(iA.name))
      throw Error("duplicate name '" + iA.name + "' in " + this);
    return iA instanceof gA ? (this.methods[iA.name] = iA, iA.parent = this, QA(this)) : CA.prototype.add.call(this, iA);
  }, BA.prototype.remove = function(iA) {
    if (iA instanceof gA) {
      if (this.methods[iA.name] !== iA)
        throw Error(iA + " is not a member of " + this);
      return delete this.methods[iA.name], iA.parent = null, QA(this);
    }
    return CA.prototype.remove.call(this, iA);
  }, BA.prototype.create = function(iA, oA, cA) {
    for (var tA = new IA.Service(iA, oA, cA), eA = 0, aA; eA < /* initializes */
    this.methodsArray.length; ++eA) {
      var GA = AA.lcFirst((aA = this._methodsArray[eA]).resolve().name).replace(/[^$\w_]/g, "");
      tA[GA] = AA.codegen(["r", "c"], AA.isReserved(GA) ? GA + "_" : GA)("return this.rpcCall(m,q,s,r,c)")({
        m: aA,
        q: aA.resolvedRequestType.ctor,
        s: aA.resolvedResponseType.ctor
      });
    }
    return tA;
  }, service;
}
var message, hasRequiredMessage;
function requireMessage() {
  if (hasRequiredMessage) return message;
  hasRequiredMessage = 1, message = gA;
  var CA = requireMinimal$1();
  function gA(AA) {
    if (AA)
      for (var IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA)
        this[IA[BA]] = AA[IA[BA]];
  }
  return gA.create = function(IA) {
    return this.$type.create(IA);
  }, gA.encode = function(IA, BA) {
    return this.$type.encode(IA, BA);
  }, gA.encodeDelimited = function(IA, BA) {
    return this.$type.encodeDelimited(IA, BA);
  }, gA.decode = function(IA) {
    return this.$type.decode(IA);
  }, gA.decodeDelimited = function(IA) {
    return this.$type.decodeDelimited(IA);
  }, gA.verify = function(IA) {
    return this.$type.verify(IA);
  }, gA.fromObject = function(IA) {
    return this.$type.fromObject(IA);
  }, gA.toObject = function(IA, BA) {
    return this.$type.toObject(IA, BA);
  }, gA.prototype.toJSON = function() {
    return this.$type.toObject(this, CA.toJSONOptions);
  }, message;
}
var decoder_1, hasRequiredDecoder;
function requireDecoder() {
  if (hasRequiredDecoder) return decoder_1;
  hasRequiredDecoder = 1, decoder_1 = BA;
  var CA = require_enum(), gA = requireTypes(), AA = requireUtil();
  function IA(QA) {
    return "missing required '" + QA.name + "'";
  }
  function BA(QA) {
    for (var EA = AA.codegen(["r", "l", "e"], QA.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (QA.fieldsArray.filter(function(aA) {
      return aA.map;
    }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()")("if(t===e)")("break")("switch(t>>>3){"), iA = 0; iA < /* initializes */
    QA.fieldsArray.length; ++iA) {
      var oA = QA._fieldsArray[iA].resolve(), cA = oA.resolvedType instanceof CA ? "int32" : oA.type, tA = "m" + AA.safeProp(oA.name);
      EA("case %i: {", oA.id), oA.map ? (EA("if(%s===util.emptyObject)", tA)("%s={}", tA)("var c2 = r.uint32()+r.pos"), gA.defaults[oA.keyType] !== void 0 ? EA("k=%j", gA.defaults[oA.keyType]) : EA("k=null"), gA.defaults[cA] !== void 0 ? EA("value=%j", gA.defaults[cA]) : EA("value=null"), EA("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", oA.keyType)("case 2:"), gA.basic[cA] === void 0 ? EA("value=types[%i].decode(r,r.uint32())", iA) : EA("value=r.%s()", cA), EA("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), gA.long[oA.keyType] !== void 0 ? EA('%s[typeof k==="object"?util.longToHash(k):k]=value', tA) : EA("%s[k]=value", tA)) : oA.repeated ? (EA("if(!(%s&&%s.length))", tA, tA)("%s=[]", tA), gA.packed[cA] !== void 0 && EA("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", tA, cA)("}else"), gA.basic[cA] === void 0 ? EA(oA.delimited ? "%s.push(types[%i].decode(r,undefined,((t&~7)|4)))" : "%s.push(types[%i].decode(r,r.uint32()))", tA, iA) : EA("%s.push(r.%s())", tA, cA)) : gA.basic[cA] === void 0 ? EA(oA.delimited ? "%s=types[%i].decode(r,undefined,((t&~7)|4))" : "%s=types[%i].decode(r,r.uint32())", tA, iA) : EA("%s=r.%s()", tA, cA), EA("break")("}");
    }
    for (EA("default:")("r.skipType(t&7)")("break")("}")("}"), iA = 0; iA < QA._fieldsArray.length; ++iA) {
      var eA = QA._fieldsArray[iA];
      eA.required && EA("if(!m.hasOwnProperty(%j))", eA.name)("throw util.ProtocolError(%j,{instance:m})", IA(eA));
    }
    return EA("return m");
  }
  return decoder_1;
}
var verifier_1, hasRequiredVerifier;
function requireVerifier() {
  if (hasRequiredVerifier) return verifier_1;
  hasRequiredVerifier = 1, verifier_1 = QA;
  var CA = require_enum(), gA = requireUtil();
  function AA(EA, iA) {
    return EA.name + ": " + iA + (EA.repeated && iA !== "array" ? "[]" : EA.map && iA !== "object" ? "{k:" + EA.keyType + "}" : "") + " expected";
  }
  function IA(EA, iA, oA, cA) {
    if (iA.resolvedType)
      if (iA.resolvedType instanceof CA) {
        EA("switch(%s){", cA)("default:")("return%j", AA(iA, "enum value"));
        for (var tA = Object.keys(iA.resolvedType.values), eA = 0; eA < tA.length; ++eA) EA("case %i:", iA.resolvedType.values[tA[eA]]);
        EA("break")("}");
      } else
        EA("{")("var e=types[%i].verify(%s);", oA, cA)("if(e)")("return%j+e", iA.name + ".")("}");
    else
      switch (iA.type) {
        case "int32":
        case "uint32":
        case "sint32":
        case "fixed32":
        case "sfixed32":
          EA("if(!util.isInteger(%s))", cA)("return%j", AA(iA, "integer"));
          break;
        case "int64":
        case "uint64":
        case "sint64":
        case "fixed64":
        case "sfixed64":
          EA("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", cA, cA, cA, cA)("return%j", AA(iA, "integer|Long"));
          break;
        case "float":
        case "double":
          EA('if(typeof %s!=="number")', cA)("return%j", AA(iA, "number"));
          break;
        case "bool":
          EA('if(typeof %s!=="boolean")', cA)("return%j", AA(iA, "boolean"));
          break;
        case "string":
          EA("if(!util.isString(%s))", cA)("return%j", AA(iA, "string"));
          break;
        case "bytes":
          EA('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', cA, cA, cA)("return%j", AA(iA, "buffer"));
          break;
      }
    return EA;
  }
  function BA(EA, iA, oA) {
    switch (iA.keyType) {
      case "int32":
      case "uint32":
      case "sint32":
      case "fixed32":
      case "sfixed32":
        EA("if(!util.key32Re.test(%s))", oA)("return%j", AA(iA, "integer key"));
        break;
      case "int64":
      case "uint64":
      case "sint64":
      case "fixed64":
      case "sfixed64":
        EA("if(!util.key64Re.test(%s))", oA)("return%j", AA(iA, "integer|Long key"));
        break;
      case "bool":
        EA("if(!util.key2Re.test(%s))", oA)("return%j", AA(iA, "boolean key"));
        break;
    }
    return EA;
  }
  function QA(EA) {
    var iA = gA.codegen(["m"], EA.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), oA = EA.oneofsArray, cA = {};
    oA.length && iA("var p={}");
    for (var tA = 0; tA < /* initializes */
    EA.fieldsArray.length; ++tA) {
      var eA = EA._fieldsArray[tA].resolve(), aA = "m" + gA.safeProp(eA.name);
      if (eA.optional && iA("if(%s!=null&&m.hasOwnProperty(%j)){", aA, eA.name), eA.map)
        iA("if(!util.isObject(%s))", aA)("return%j", AA(eA, "object"))("var k=Object.keys(%s)", aA)("for(var i=0;i<k.length;++i){"), BA(iA, eA, "k[i]"), IA(iA, eA, tA, aA + "[k[i]]")("}");
      else if (eA.repeated)
        iA("if(!Array.isArray(%s))", aA)("return%j", AA(eA, "array"))("for(var i=0;i<%s.length;++i){", aA), IA(iA, eA, tA, aA + "[i]")("}");
      else {
        if (eA.partOf) {
          var GA = gA.safeProp(eA.partOf.name);
          cA[eA.partOf.name] === 1 && iA("if(p%s===1)", GA)("return%j", eA.partOf.name + ": multiple values"), cA[eA.partOf.name] = 1, iA("p%s=1", GA);
        }
        IA(iA, eA, tA, aA);
      }
      eA.optional && iA("}");
    }
    return iA("return null");
  }
  return verifier_1;
}
var converter = {}, hasRequiredConverter;
function requireConverter() {
  return hasRequiredConverter || (hasRequiredConverter = 1, (function(CA) {
    var gA = CA, AA = require_enum(), IA = requireUtil();
    function BA(EA, iA, oA, cA) {
      var tA = !1;
      if (iA.resolvedType)
        if (iA.resolvedType instanceof AA) {
          EA("switch(d%s){", cA);
          for (var eA = iA.resolvedType.values, aA = Object.keys(eA), GA = 0; GA < aA.length; ++GA)
            eA[aA[GA]] === iA.typeDefault && !tA && (EA("default:")('if(typeof(d%s)==="number"){m%s=d%s;break}', cA, cA, cA), iA.repeated || EA("break"), tA = !0), EA("case%j:", aA[GA])("case %i:", eA[aA[GA]])("m%s=%j", cA, eA[aA[GA]])("break");
          EA("}");
        } else EA('if(typeof d%s!=="object")', cA)("throw TypeError(%j)", iA.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", cA, oA, cA);
      else {
        var lA = !1;
        switch (iA.type) {
          case "double":
          case "float":
            EA("m%s=Number(d%s)", cA, cA);
            break;
          case "uint32":
          case "fixed32":
            EA("m%s=d%s>>>0", cA, cA);
            break;
          case "int32":
          case "sint32":
          case "sfixed32":
            EA("m%s=d%s|0", cA, cA);
            break;
          case "uint64":
            lA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            EA("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", cA, cA, lA)('else if(typeof d%s==="string")', cA)("m%s=parseInt(d%s,10)", cA, cA)('else if(typeof d%s==="number")', cA)("m%s=d%s", cA, cA)('else if(typeof d%s==="object")', cA)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", cA, cA, cA, lA ? "true" : "");
            break;
          case "bytes":
            EA('if(typeof d%s==="string")', cA)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", cA, cA, cA)("else if(d%s.length >= 0)", cA)("m%s=d%s", cA, cA);
            break;
          case "string":
            EA("m%s=String(d%s)", cA, cA);
            break;
          case "bool":
            EA("m%s=Boolean(d%s)", cA, cA);
            break;
        }
      }
      return EA;
    }
    gA.fromObject = function(iA) {
      var oA = iA.fieldsArray, cA = IA.codegen(["d"], iA.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
      if (!oA.length) return cA("return new this.ctor");
      cA("var m=new this.ctor");
      for (var tA = 0; tA < oA.length; ++tA) {
        var eA = oA[tA].resolve(), aA = IA.safeProp(eA.name);
        eA.map ? (cA("if(d%s){", aA)('if(typeof d%s!=="object")', aA)("throw TypeError(%j)", eA.fullName + ": object expected")("m%s={}", aA)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", aA), BA(
          cA,
          eA,
          /* not sorted */
          tA,
          aA + "[ks[i]]"
        )("}")("}")) : eA.repeated ? (cA("if(d%s){", aA)("if(!Array.isArray(d%s))", aA)("throw TypeError(%j)", eA.fullName + ": array expected")("m%s=[]", aA)("for(var i=0;i<d%s.length;++i){", aA), BA(
          cA,
          eA,
          /* not sorted */
          tA,
          aA + "[i]"
        )("}")("}")) : (eA.resolvedType instanceof AA || cA("if(d%s!=null){", aA), BA(
          cA,
          eA,
          /* not sorted */
          tA,
          aA
        ), eA.resolvedType instanceof AA || cA("}"));
      }
      return cA("return m");
    };
    function QA(EA, iA, oA, cA) {
      if (iA.resolvedType)
        iA.resolvedType instanceof AA ? EA("d%s=o.enums===String?(types[%i].values[m%s]===undefined?m%s:types[%i].values[m%s]):m%s", cA, oA, cA, cA, oA, cA, cA) : EA("d%s=types[%i].toObject(m%s,o)", cA, oA, cA);
      else {
        var tA = !1;
        switch (iA.type) {
          case "double":
          case "float":
            EA("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", cA, cA, cA, cA);
            break;
          case "uint64":
            tA = !0;
          // eslint-disable-next-line no-fallthrough
          case "int64":
          case "sint64":
          case "fixed64":
          case "sfixed64":
            EA('if(typeof m%s==="number")', cA)("d%s=o.longs===String?String(m%s):m%s", cA, cA, cA)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", cA, cA, cA, cA, tA ? "true" : "", cA);
            break;
          case "bytes":
            EA("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", cA, cA, cA, cA, cA);
            break;
          default:
            EA("d%s=m%s", cA, cA);
            break;
        }
      }
      return EA;
    }
    gA.toObject = function(iA) {
      var oA = iA.fieldsArray.slice().sort(IA.compareFieldsById);
      if (!oA.length)
        return IA.codegen()("return {}");
      for (var cA = IA.codegen(["m", "o"], iA.name + "$toObject")("if(!o)")("o={}")("var d={}"), tA = [], eA = [], aA = [], GA = 0; GA < oA.length; ++GA)
        oA[GA].partOf || (oA[GA].resolve().repeated ? tA : oA[GA].map ? eA : aA).push(oA[GA]);
      if (tA.length) {
        for (cA("if(o.arrays||o.defaults){"), GA = 0; GA < tA.length; ++GA) cA("d%s=[]", IA.safeProp(tA[GA].name));
        cA("}");
      }
      if (eA.length) {
        for (cA("if(o.objects||o.defaults){"), GA = 0; GA < eA.length; ++GA) cA("d%s={}", IA.safeProp(eA[GA].name));
        cA("}");
      }
      if (aA.length) {
        for (cA("if(o.defaults){"), GA = 0; GA < aA.length; ++GA) {
          var lA = aA[GA], nA = IA.safeProp(lA.name);
          if (lA.resolvedType instanceof AA) cA("d%s=o.enums===String?%j:%j", nA, lA.resolvedType.valuesById[lA.typeDefault], lA.typeDefault);
          else if (lA.long) cA("if(util.Long){")("var n=new util.Long(%i,%i,%j)", lA.typeDefault.low, lA.typeDefault.high, lA.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", nA)("}else")("d%s=o.longs===String?%j:%i", nA, lA.typeDefault.toString(), lA.typeDefault.toNumber());
          else if (lA.bytes) {
            var DA = "[" + Array.prototype.slice.call(lA.typeDefault).join(",") + "]";
            cA("if(o.bytes===String)d%s=%j", nA, String.fromCharCode.apply(String, lA.typeDefault))("else{")("d%s=%s", nA, DA)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", nA, nA)("}");
          } else cA("d%s=%j", nA, lA.typeDefault);
        }
        cA("}");
      }
      var hA = !1;
      for (GA = 0; GA < oA.length; ++GA) {
        var lA = oA[GA], wA = iA._fieldsArray.indexOf(lA), nA = IA.safeProp(lA.name);
        lA.map ? (hA || (hA = !0, cA("var ks2")), cA("if(m%s&&(ks2=Object.keys(m%s)).length){", nA, nA)("d%s={}", nA)("for(var j=0;j<ks2.length;++j){"), QA(
          cA,
          lA,
          /* sorted */
          wA,
          nA + "[ks2[j]]"
        )("}")) : lA.repeated ? (cA("if(m%s&&m%s.length){", nA, nA)("d%s=[]", nA)("for(var j=0;j<m%s.length;++j){", nA), QA(
          cA,
          lA,
          /* sorted */
          wA,
          nA + "[j]"
        )("}")) : (cA("if(m%s!=null&&m.hasOwnProperty(%j)){", nA, lA.name), QA(
          cA,
          lA,
          /* sorted */
          wA,
          nA
        ), lA.partOf && cA("if(o.oneofs)")("d%s=%j", IA.safeProp(lA.partOf.name), lA.name)), cA("}");
      }
      return cA("return d");
    };
  })(converter)), converter;
}
var wrappers = {}, hasRequiredWrappers;
function requireWrappers() {
  return hasRequiredWrappers || (hasRequiredWrappers = 1, (function(CA) {
    var gA = CA, AA = requireMessage();
    gA[".google.protobuf.Any"] = {
      fromObject: function(IA) {
        if (IA && IA["@type"]) {
          var BA = IA["@type"].substring(IA["@type"].lastIndexOf("/") + 1), QA = this.lookup(BA);
          if (QA) {
            var EA = IA["@type"].charAt(0) === "." ? IA["@type"].slice(1) : IA["@type"];
            return EA.indexOf("/") === -1 && (EA = "/" + EA), this.create({
              type_url: EA,
              value: QA.encode(QA.fromObject(IA)).finish()
            });
          }
        }
        return this.fromObject(IA);
      },
      toObject: function(IA, BA) {
        var QA = "type.googleapis.com/", EA = "", iA = "";
        if (BA && BA.json && IA.type_url && IA.value) {
          iA = IA.type_url.substring(IA.type_url.lastIndexOf("/") + 1), EA = IA.type_url.substring(0, IA.type_url.lastIndexOf("/") + 1);
          var oA = this.lookup(iA);
          oA && (IA = oA.decode(IA.value));
        }
        if (!(IA instanceof this.ctor) && IA instanceof AA) {
          var cA = IA.$type.toObject(IA, BA), tA = IA.$type.fullName[0] === "." ? IA.$type.fullName.slice(1) : IA.$type.fullName;
          return EA === "" && (EA = QA), iA = EA + tA, cA["@type"] = iA, cA;
        }
        return this.toObject(IA, BA);
      }
    };
  })(wrappers)), wrappers;
}
var type, hasRequiredType;
function requireType() {
  if (hasRequiredType) return type;
  hasRequiredType = 1, type = nA;
  var CA = requireNamespace();
  ((nA.prototype = Object.create(CA.prototype)).constructor = nA).className = "Type";
  var gA = require_enum(), AA = requireOneof(), IA = requireField(), BA = requireMapfield(), QA = requireService(), EA = requireMessage(), iA = requireReader(), oA = requireWriter(), cA = requireUtil(), tA = requireEncoder(), eA = requireDecoder(), aA = requireVerifier(), GA = requireConverter(), lA = requireWrappers();
  function nA(hA, wA) {
    CA.call(this, hA, wA), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
  }
  Object.defineProperties(nA.prototype, {
    /**
     * Message fields by id.
     * @name Type#fieldsById
     * @type {Object.<number,Field>}
     * @readonly
     */
    fieldsById: {
      get: function() {
        if (this._fieldsById)
          return this._fieldsById;
        this._fieldsById = {};
        for (var hA = Object.keys(this.fields), wA = 0; wA < hA.length; ++wA) {
          var sA = this.fields[hA[wA]], NA = sA.id;
          if (this._fieldsById[NA])
            throw Error("duplicate id " + NA + " in " + this);
          this._fieldsById[NA] = sA;
        }
        return this._fieldsById;
      }
    },
    /**
     * Fields of this message as an array for iteration.
     * @name Type#fieldsArray
     * @type {Field[]}
     * @readonly
     */
    fieldsArray: {
      get: function() {
        return this._fieldsArray || (this._fieldsArray = cA.toArray(this.fields));
      }
    },
    /**
     * Oneofs of this message as an array for iteration.
     * @name Type#oneofsArray
     * @type {OneOf[]}
     * @readonly
     */
    oneofsArray: {
      get: function() {
        return this._oneofsArray || (this._oneofsArray = cA.toArray(this.oneofs));
      }
    },
    /**
     * The registered constructor, if any registered, otherwise a generic constructor.
     * Assigning a function replaces the internal constructor. If the function does not extend {@link Message} yet, its prototype will be setup accordingly and static methods will be populated. If it already extends {@link Message}, it will just replace the internal constructor.
     * @name Type#ctor
     * @type {Constructor<{}>}
     */
    ctor: {
      get: function() {
        return this._ctor || (this.ctor = nA.generateConstructor(this)());
      },
      set: function(hA) {
        var wA = hA.prototype;
        wA instanceof EA || ((hA.prototype = new EA()).constructor = hA, cA.merge(hA.prototype, wA)), hA.$type = hA.prototype.$type = this, cA.merge(hA, EA, !0), this._ctor = hA;
        for (var sA = 0; sA < /* initializes */
        this.fieldsArray.length; ++sA)
          this._fieldsArray[sA].resolve();
        var NA = {};
        for (sA = 0; sA < /* initializes */
        this.oneofsArray.length; ++sA)
          NA[this._oneofsArray[sA].resolve().name] = {
            get: cA.oneOfGetter(this._oneofsArray[sA].oneof),
            set: cA.oneOfSetter(this._oneofsArray[sA].oneof)
          };
        sA && Object.defineProperties(hA.prototype, NA);
      }
    }
  }), nA.generateConstructor = function(wA) {
    for (var sA = cA.codegen(["p"], wA.name), NA = 0, rA; NA < wA.fieldsArray.length; ++NA)
      (rA = wA._fieldsArray[NA]).map ? sA("this%s={}", cA.safeProp(rA.name)) : rA.repeated && sA("this%s=[]", cA.safeProp(rA.name));
    return sA("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
  };
  function DA(hA) {
    return hA._fieldsById = hA._fieldsArray = hA._oneofsArray = null, delete hA.encode, delete hA.decode, delete hA.verify, hA;
  }
  return nA.fromJSON = function(wA, sA) {
    var NA = new nA(wA, sA.options);
    NA.extensions = sA.extensions, NA.reserved = sA.reserved;
    for (var rA = Object.keys(sA.fields), yA = 0; yA < rA.length; ++yA)
      NA.add(
        (typeof sA.fields[rA[yA]].keyType < "u" ? BA.fromJSON : IA.fromJSON)(rA[yA], sA.fields[rA[yA]])
      );
    if (sA.oneofs)
      for (rA = Object.keys(sA.oneofs), yA = 0; yA < rA.length; ++yA)
        NA.add(AA.fromJSON(rA[yA], sA.oneofs[rA[yA]]));
    if (sA.nested)
      for (rA = Object.keys(sA.nested), yA = 0; yA < rA.length; ++yA) {
        var bA = sA.nested[rA[yA]];
        NA.add(
          // most to least likely
          (bA.id !== void 0 ? IA.fromJSON : bA.fields !== void 0 ? nA.fromJSON : bA.values !== void 0 ? gA.fromJSON : bA.methods !== void 0 ? QA.fromJSON : CA.fromJSON)(rA[yA], bA)
        );
      }
    return sA.extensions && sA.extensions.length && (NA.extensions = sA.extensions), sA.reserved && sA.reserved.length && (NA.reserved = sA.reserved), sA.group && (NA.group = !0), sA.comment && (NA.comment = sA.comment), sA.edition && (NA._edition = sA.edition), NA._defaultEdition = "proto3", NA;
  }, nA.prototype.toJSON = function(wA) {
    var sA = CA.prototype.toJSON.call(this, wA), NA = wA ? !!wA.keepComments : !1;
    return cA.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      sA && sA.options || void 0,
      "oneofs",
      CA.arrayToJSON(this.oneofsArray, wA),
      "fields",
      CA.arrayToJSON(this.fieldsArray.filter(function(rA) {
        return !rA.declaringField;
      }), wA) || {},
      "extensions",
      this.extensions && this.extensions.length ? this.extensions : void 0,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "group",
      this.group || void 0,
      "nested",
      sA && sA.nested || void 0,
      "comment",
      NA ? this.comment : void 0
    ]);
  }, nA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    CA.prototype.resolveAll.call(this);
    var wA = this.oneofsArray;
    for (NA = 0; NA < wA.length; )
      wA[NA++].resolve();
    for (var sA = this.fieldsArray, NA = 0; NA < sA.length; )
      sA[NA++].resolve();
    return this;
  }, nA.prototype._resolveFeaturesRecursive = function(wA) {
    return this._needsRecursiveFeatureResolution ? (wA = this._edition || wA, CA.prototype._resolveFeaturesRecursive.call(this, wA), this.oneofsArray.forEach((sA) => {
      sA._resolveFeatures(wA);
    }), this.fieldsArray.forEach((sA) => {
      sA._resolveFeatures(wA);
    }), this) : this;
  }, nA.prototype.get = function(wA) {
    return this.fields[wA] || this.oneofs && this.oneofs[wA] || this.nested && this.nested[wA] || null;
  }, nA.prototype.add = function(wA) {
    if (this.get(wA.name))
      throw Error("duplicate name '" + wA.name + "' in " + this);
    if (wA instanceof IA && wA.extend === void 0) {
      if (this._fieldsById ? (
        /* istanbul ignore next */
        this._fieldsById[wA.id]
      ) : this.fieldsById[wA.id])
        throw Error("duplicate id " + wA.id + " in " + this);
      if (this.isReservedId(wA.id))
        throw Error("id " + wA.id + " is reserved in " + this);
      if (this.isReservedName(wA.name))
        throw Error("name '" + wA.name + "' is reserved in " + this);
      return wA.parent && wA.parent.remove(wA), this.fields[wA.name] = wA, wA.message = this, wA.onAdd(this), DA(this);
    }
    return wA instanceof AA ? (this.oneofs || (this.oneofs = {}), this.oneofs[wA.name] = wA, wA.onAdd(this), DA(this)) : CA.prototype.add.call(this, wA);
  }, nA.prototype.remove = function(wA) {
    if (wA instanceof IA && wA.extend === void 0) {
      if (!this.fields || this.fields[wA.name] !== wA)
        throw Error(wA + " is not a member of " + this);
      return delete this.fields[wA.name], wA.parent = null, wA.onRemove(this), DA(this);
    }
    if (wA instanceof AA) {
      if (!this.oneofs || this.oneofs[wA.name] !== wA)
        throw Error(wA + " is not a member of " + this);
      return delete this.oneofs[wA.name], wA.parent = null, wA.onRemove(this), DA(this);
    }
    return CA.prototype.remove.call(this, wA);
  }, nA.prototype.isReservedId = function(wA) {
    return CA.isReservedId(this.reserved, wA);
  }, nA.prototype.isReservedName = function(wA) {
    return CA.isReservedName(this.reserved, wA);
  }, nA.prototype.create = function(wA) {
    return new this.ctor(wA);
  }, nA.prototype.setup = function() {
    for (var wA = this.fullName, sA = [], NA = 0; NA < /* initializes */
    this.fieldsArray.length; ++NA)
      sA.push(this._fieldsArray[NA].resolve().resolvedType);
    this.encode = tA(this)({
      Writer: oA,
      types: sA,
      util: cA
    }), this.decode = eA(this)({
      Reader: iA,
      types: sA,
      util: cA
    }), this.verify = aA(this)({
      types: sA,
      util: cA
    }), this.fromObject = GA.fromObject(this)({
      types: sA,
      util: cA
    }), this.toObject = GA.toObject(this)({
      types: sA,
      util: cA
    });
    var rA = lA[wA];
    if (rA) {
      var yA = Object.create(this);
      yA.fromObject = this.fromObject, this.fromObject = rA.fromObject.bind(yA), yA.toObject = this.toObject, this.toObject = rA.toObject.bind(yA);
    }
    return this;
  }, nA.prototype.encode = function(wA, sA) {
    return this.setup().encode(wA, sA);
  }, nA.prototype.encodeDelimited = function(wA, sA) {
    return this.encode(wA, sA && sA.len ? sA.fork() : sA).ldelim();
  }, nA.prototype.decode = function(wA, sA) {
    return this.setup().decode(wA, sA);
  }, nA.prototype.decodeDelimited = function(wA) {
    return wA instanceof iA || (wA = iA.create(wA)), this.decode(wA, wA.uint32());
  }, nA.prototype.verify = function(wA) {
    return this.setup().verify(wA);
  }, nA.prototype.fromObject = function(wA) {
    return this.setup().fromObject(wA);
  }, nA.prototype.toObject = function(wA, sA) {
    return this.setup().toObject(wA, sA);
  }, nA.d = function(wA) {
    return function(NA) {
      cA.decorateType(NA, wA);
    };
  }, type;
}
var root, hasRequiredRoot;
function requireRoot() {
  if (hasRequiredRoot) return root;
  hasRequiredRoot = 1, root = oA;
  var CA = requireNamespace();
  ((oA.prototype = Object.create(CA.prototype)).constructor = oA).className = "Root";
  var gA = requireField(), AA = require_enum(), IA = requireOneof(), BA = requireUtil(), QA, EA, iA;
  function oA(aA) {
    CA.call(this, "", aA), this.deferred = [], this.files = [], this._edition = "proto2", this._fullyQualifiedObjects = {};
  }
  oA.fromJSON = function(GA, lA) {
    return lA || (lA = new oA()), GA.options && lA.setOptions(GA.options), lA.addJSON(GA.nested).resolveAll();
  }, oA.prototype.resolvePath = BA.path.resolve, oA.prototype.fetch = BA.fetch;
  function cA() {
  }
  oA.prototype.load = function aA(GA, lA, nA) {
    typeof lA == "function" && (nA = lA, lA = void 0);
    var DA = this;
    if (!nA)
      return BA.asPromise(aA, DA, GA, lA);
    var hA = nA === cA;
    function wA(FA, dA) {
      if (nA) {
        if (hA)
          throw FA;
        dA && dA.resolveAll();
        var kA = nA;
        nA = null, kA(FA, dA);
      }
    }
    function sA(FA) {
      var dA = FA.lastIndexOf("google/protobuf/");
      if (dA > -1) {
        var kA = FA.substring(dA);
        if (kA in iA) return kA;
      }
      return null;
    }
    function NA(FA, dA) {
      try {
        if (BA.isString(dA) && dA.charAt(0) === "{" && (dA = JSON.parse(dA)), !BA.isString(dA))
          DA.setOptions(dA.options).addJSON(dA.nested);
        else {
          EA.filename = FA;
          var kA = EA(dA, DA, lA), pA, YA = 0;
          if (kA.imports)
            for (; YA < kA.imports.length; ++YA)
              (pA = sA(kA.imports[YA]) || DA.resolvePath(FA, kA.imports[YA])) && rA(pA);
          if (kA.weakImports)
            for (YA = 0; YA < kA.weakImports.length; ++YA)
              (pA = sA(kA.weakImports[YA]) || DA.resolvePath(FA, kA.weakImports[YA])) && rA(pA, !0);
        }
      } catch (SA) {
        wA(SA);
      }
      !hA && !yA && wA(null, DA);
    }
    function rA(FA, dA) {
      if (FA = sA(FA) || FA, !(DA.files.indexOf(FA) > -1)) {
        if (DA.files.push(FA), FA in iA) {
          hA ? NA(FA, iA[FA]) : (++yA, setTimeout(function() {
            --yA, NA(FA, iA[FA]);
          }));
          return;
        }
        if (hA) {
          var kA;
          try {
            kA = BA.fs.readFileSync(FA).toString("utf8");
          } catch (pA) {
            dA || wA(pA);
            return;
          }
          NA(FA, kA);
        } else
          ++yA, DA.fetch(FA, function(pA, YA) {
            if (--yA, !!nA) {
              if (pA) {
                dA ? yA || wA(null, DA) : wA(pA);
                return;
              }
              NA(FA, YA);
            }
          });
      }
    }
    var yA = 0;
    BA.isString(GA) && (GA = [GA]);
    for (var bA = 0, RA; bA < GA.length; ++bA)
      (RA = DA.resolvePath("", GA[bA])) && rA(RA);
    return hA ? (DA.resolveAll(), DA) : (yA || wA(null, DA), DA);
  }, oA.prototype.loadSync = function(GA, lA) {
    if (!BA.isNode)
      throw Error("not supported");
    return this.load(GA, lA, cA);
  }, oA.prototype.resolveAll = function() {
    if (!this._needsRecursiveResolve) return this;
    if (this.deferred.length)
      throw Error("unresolvable extensions: " + this.deferred.map(function(GA) {
        return "'extend " + GA.extend + "' in " + GA.parent.fullName;
      }).join(", "));
    return CA.prototype.resolveAll.call(this);
  };
  var tA = /^[A-Z]/;
  function eA(aA, GA) {
    var lA = GA.parent.lookup(GA.extend);
    if (lA) {
      var nA = new gA(GA.fullName, GA.id, GA.type, GA.rule, void 0, GA.options);
      return lA.get(nA.name) || (nA.declaringField = GA, GA.extensionField = nA, lA.add(nA)), !0;
    }
    return !1;
  }
  return oA.prototype._handleAdd = function(GA) {
    if (GA instanceof gA)
      /* an extension field (implies not part of a oneof) */
      GA.extend !== void 0 && /* not already handled */
      !GA.extensionField && (eA(this, GA) || this.deferred.push(GA));
    else if (GA instanceof AA)
      tA.test(GA.name) && (GA.parent[GA.name] = GA.values);
    else if (!(GA instanceof IA)) {
      if (GA instanceof QA)
        for (var lA = 0; lA < this.deferred.length; )
          eA(this, this.deferred[lA]) ? this.deferred.splice(lA, 1) : ++lA;
      for (var nA = 0; nA < /* initializes */
      GA.nestedArray.length; ++nA)
        this._handleAdd(GA._nestedArray[nA]);
      tA.test(GA.name) && (GA.parent[GA.name] = GA);
    }
    (GA instanceof QA || GA instanceof AA || GA instanceof gA) && (this._fullyQualifiedObjects[GA.fullName] = GA);
  }, oA.prototype._handleRemove = function(GA) {
    if (GA instanceof gA) {
      if (
        /* an extension field */
        GA.extend !== void 0
      )
        if (
          /* already handled */
          GA.extensionField
        )
          GA.extensionField.parent.remove(GA.extensionField), GA.extensionField = null;
        else {
          var lA = this.deferred.indexOf(GA);
          lA > -1 && this.deferred.splice(lA, 1);
        }
    } else if (GA instanceof AA)
      tA.test(GA.name) && delete GA.parent[GA.name];
    else if (GA instanceof CA) {
      for (var nA = 0; nA < /* initializes */
      GA.nestedArray.length; ++nA)
        this._handleRemove(GA._nestedArray[nA]);
      tA.test(GA.name) && delete GA.parent[GA.name];
    }
    delete this._fullyQualifiedObjects[GA.fullName];
  }, oA._configure = function(aA, GA, lA) {
    QA = aA, EA = GA, iA = lA;
  }, root;
}
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util.exports;
  hasRequiredUtil = 1;
  var CA = util.exports = requireMinimal$1(), gA = requireRoots(), AA, IA;
  CA.codegen = requireCodegen(), CA.fetch = requireFetch(), CA.path = requirePath$1(), CA.fs = CA.inquire("fs"), CA.toArray = function(cA) {
    if (cA) {
      for (var tA = Object.keys(cA), eA = new Array(tA.length), aA = 0; aA < tA.length; )
        eA[aA] = cA[tA[aA++]];
      return eA;
    }
    return [];
  }, CA.toObject = function(cA) {
    for (var tA = {}, eA = 0; eA < cA.length; ) {
      var aA = cA[eA++], GA = cA[eA++];
      GA !== void 0 && (tA[aA] = GA);
    }
    return tA;
  };
  var BA = /\\/g, QA = /"/g;
  CA.isReserved = function(cA) {
    return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(cA);
  }, CA.safeProp = function(cA) {
    return !/^[$\w_]+$/.test(cA) || CA.isReserved(cA) ? '["' + cA.replace(BA, "\\\\").replace(QA, '\\"') + '"]' : "." + cA;
  }, CA.ucFirst = function(cA) {
    return cA.charAt(0).toUpperCase() + cA.substring(1);
  };
  var EA = /_([a-z])/g;
  CA.camelCase = function(cA) {
    return cA.substring(0, 1) + cA.substring(1).replace(EA, function(tA, eA) {
      return eA.toUpperCase();
    });
  }, CA.compareFieldsById = function(cA, tA) {
    return cA.id - tA.id;
  }, CA.decorateType = function(cA, tA) {
    if (cA.$type)
      return tA && cA.$type.name !== tA && (CA.decorateRoot.remove(cA.$type), cA.$type.name = tA, CA.decorateRoot.add(cA.$type)), cA.$type;
    AA || (AA = requireType());
    var eA = new AA(tA || cA.name);
    return CA.decorateRoot.add(eA), eA.ctor = cA, Object.defineProperty(cA, "$type", { value: eA, enumerable: !1 }), Object.defineProperty(cA.prototype, "$type", { value: eA, enumerable: !1 }), eA;
  };
  var iA = 0;
  return CA.decorateEnum = function(cA) {
    if (cA.$type)
      return cA.$type;
    IA || (IA = require_enum());
    var tA = new IA("Enum" + iA++, cA);
    return CA.decorateRoot.add(tA), Object.defineProperty(cA, "$type", { value: tA, enumerable: !1 }), tA;
  }, CA.setProperty = function(cA, tA, eA, aA) {
    function GA(lA, nA, DA) {
      var hA = nA.shift();
      if (hA === "__proto__" || hA === "prototype")
        return lA;
      if (nA.length > 0)
        lA[hA] = GA(lA[hA] || {}, nA, DA);
      else {
        var wA = lA[hA];
        if (wA && aA)
          return lA;
        wA && (DA = [].concat(wA).concat(DA)), lA[hA] = DA;
      }
      return lA;
    }
    if (typeof cA != "object")
      throw TypeError("dst must be an object");
    if (!tA)
      throw TypeError("path must be specified");
    return tA = tA.split("."), GA(cA, tA, eA);
  }, Object.defineProperty(CA, "decorateRoot", {
    get: function() {
      return gA.decorated || (gA.decorated = new (requireRoot())());
    }
  }), util.exports;
}
var hasRequiredTypes;
function requireTypes() {
  return hasRequiredTypes || (hasRequiredTypes = 1, (function(CA) {
    var gA = CA, AA = requireUtil(), IA = [
      "double",
      // 0
      "float",
      // 1
      "int32",
      // 2
      "uint32",
      // 3
      "sint32",
      // 4
      "fixed32",
      // 5
      "sfixed32",
      // 6
      "int64",
      // 7
      "uint64",
      // 8
      "sint64",
      // 9
      "fixed64",
      // 10
      "sfixed64",
      // 11
      "bool",
      // 12
      "string",
      // 13
      "bytes"
      // 14
    ];
    function BA(QA, EA) {
      var iA = 0, oA = {};
      for (EA |= 0; iA < QA.length; ) oA[IA[iA + EA]] = QA[iA++];
      return oA;
    }
    gA.basic = BA([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2,
      /* bytes    */
      2
    ]), gA.defaults = BA([
      /* double   */
      0,
      /* float    */
      0,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      0,
      /* sfixed32 */
      0,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      0,
      /* sfixed64 */
      0,
      /* bool     */
      !1,
      /* string   */
      "",
      /* bytes    */
      AA.emptyArray,
      /* message  */
      null
    ]), gA.long = BA([
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1
    ], 7), gA.mapKey = BA([
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0,
      /* string   */
      2
    ], 2), gA.packed = BA([
      /* double   */
      1,
      /* float    */
      5,
      /* int32    */
      0,
      /* uint32   */
      0,
      /* sint32   */
      0,
      /* fixed32  */
      5,
      /* sfixed32 */
      5,
      /* int64    */
      0,
      /* uint64   */
      0,
      /* sint64   */
      0,
      /* fixed64  */
      1,
      /* sfixed64 */
      1,
      /* bool     */
      0
    ]);
  })(types)), types;
}
var field, hasRequiredField;
function requireField() {
  if (hasRequiredField) return field;
  hasRequiredField = 1, field = EA;
  var CA = requireObject();
  ((EA.prototype = Object.create(CA.prototype)).constructor = EA).className = "Field";
  var gA = require_enum(), AA = requireTypes(), IA = requireUtil(), BA, QA = /^required|optional|repeated$/;
  EA.fromJSON = function(oA, cA) {
    var tA = new EA(oA, cA.id, cA.type, cA.rule, cA.extend, cA.options, cA.comment);
    return cA.edition && (tA._edition = cA.edition), tA._defaultEdition = "proto3", tA;
  };
  function EA(iA, oA, cA, tA, eA, aA, GA) {
    if (IA.isObject(tA) ? (GA = eA, aA = tA, tA = eA = void 0) : IA.isObject(eA) && (GA = aA, aA = eA, eA = void 0), CA.call(this, iA, aA), !IA.isInteger(oA) || oA < 0)
      throw TypeError("id must be a non-negative integer");
    if (!IA.isString(cA))
      throw TypeError("type must be a string");
    if (tA !== void 0 && !QA.test(tA = tA.toString().toLowerCase()))
      throw TypeError("rule must be a string rule");
    if (eA !== void 0 && !IA.isString(eA))
      throw TypeError("extend must be a string");
    tA === "proto3_optional" && (tA = "optional"), this.rule = tA && tA !== "optional" ? tA : void 0, this.type = cA, this.id = oA, this.extend = eA || void 0, this.repeated = tA === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = IA.Long ? AA.long[cA] !== void 0 : (
      /* istanbul ignore next */
      !1
    ), this.bytes = cA === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this.comment = GA;
  }
  return Object.defineProperty(EA.prototype, "required", {
    get: function() {
      return this._features.field_presence === "LEGACY_REQUIRED";
    }
  }), Object.defineProperty(EA.prototype, "optional", {
    get: function() {
      return !this.required;
    }
  }), Object.defineProperty(EA.prototype, "delimited", {
    get: function() {
      return this.resolvedType instanceof BA && this._features.message_encoding === "DELIMITED";
    }
  }), Object.defineProperty(EA.prototype, "packed", {
    get: function() {
      return this._features.repeated_field_encoding === "PACKED";
    }
  }), Object.defineProperty(EA.prototype, "hasPresence", {
    get: function() {
      return this.repeated || this.map ? !1 : this.partOf || // oneofs
      this.declaringField || this.extensionField || // extensions
      this._features.field_presence !== "IMPLICIT";
    }
  }), EA.prototype.setOption = function(oA, cA, tA) {
    return CA.prototype.setOption.call(this, oA, cA, tA);
  }, EA.prototype.toJSON = function(oA) {
    var cA = oA ? !!oA.keepComments : !1;
    return IA.toObject([
      "edition",
      this._editionToJSON(),
      "rule",
      this.rule !== "optional" && this.rule || void 0,
      "type",
      this.type,
      "id",
      this.id,
      "extend",
      this.extend,
      "options",
      this.options,
      "comment",
      cA ? this.comment : void 0
    ]);
  }, EA.prototype.resolve = function() {
    if (this.resolved)
      return this;
    if ((this.typeDefault = AA.defaults[this.type]) === void 0 ? (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof BA ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]) : this.options && this.options.proto3_optional && (this.typeDefault = null), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof gA && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== void 0 && this.resolvedType && !(this.resolvedType instanceof gA) && delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long)
      this.typeDefault = IA.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
    else if (this.bytes && typeof this.typeDefault == "string") {
      var oA;
      IA.base64.test(this.typeDefault) ? IA.base64.decode(this.typeDefault, oA = IA.newBuffer(IA.base64.length(this.typeDefault)), 0) : IA.utf8.write(this.typeDefault, oA = IA.newBuffer(IA.utf8.length(this.typeDefault)), 0), this.typeDefault = oA;
    }
    return this.map ? this.defaultValue = IA.emptyObject : this.repeated ? this.defaultValue = IA.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof BA && (this.parent.ctor.prototype[this.name] = this.defaultValue), CA.prototype.resolve.call(this);
  }, EA.prototype._inferLegacyProtoFeatures = function(oA) {
    if (oA !== "proto2" && oA !== "proto3")
      return {};
    var cA = {};
    if (this.rule === "required" && (cA.field_presence = "LEGACY_REQUIRED"), this.parent && AA.defaults[this.type] === void 0) {
      var tA = this.parent.get(this.type.split(".").pop());
      tA && tA instanceof BA && tA.group && (cA.message_encoding = "DELIMITED");
    }
    return this.getOption("packed") === !0 ? cA.repeated_field_encoding = "PACKED" : this.getOption("packed") === !1 && (cA.repeated_field_encoding = "EXPANDED"), cA;
  }, EA.prototype._resolveFeatures = function(oA) {
    return CA.prototype._resolveFeatures.call(this, this._edition || oA);
  }, EA.d = function(oA, cA, tA, eA) {
    return typeof cA == "function" ? cA = IA.decorateType(cA).name : cA && typeof cA == "object" && (cA = IA.decorateEnum(cA).name), function(GA, lA) {
      IA.decorateType(GA.constructor).add(new EA(lA, oA, cA, tA, { default: eA }));
    };
  }, EA._configure = function(oA) {
    BA = oA;
  }, field;
}
var oneof, hasRequiredOneof;
function requireOneof() {
  if (hasRequiredOneof) return oneof;
  hasRequiredOneof = 1, oneof = IA;
  var CA = requireObject();
  ((IA.prototype = Object.create(CA.prototype)).constructor = IA).className = "OneOf";
  var gA = requireField(), AA = requireUtil();
  function IA(QA, EA, iA, oA) {
    if (Array.isArray(EA) || (iA = EA, EA = void 0), CA.call(this, QA, iA), !(EA === void 0 || Array.isArray(EA)))
      throw TypeError("fieldNames must be an Array");
    this.oneof = EA || [], this.fieldsArray = [], this.comment = oA;
  }
  IA.fromJSON = function(EA, iA) {
    return new IA(EA, iA.oneof, iA.options, iA.comment);
  }, IA.prototype.toJSON = function(EA) {
    var iA = EA ? !!EA.keepComments : !1;
    return AA.toObject([
      "options",
      this.options,
      "oneof",
      this.oneof,
      "comment",
      iA ? this.comment : void 0
    ]);
  };
  function BA(QA) {
    if (QA.parent)
      for (var EA = 0; EA < QA.fieldsArray.length; ++EA)
        QA.fieldsArray[EA].parent || QA.parent.add(QA.fieldsArray[EA]);
  }
  return IA.prototype.add = function(EA) {
    if (!(EA instanceof gA))
      throw TypeError("field must be a Field");
    return EA.parent && EA.parent !== this.parent && EA.parent.remove(EA), this.oneof.push(EA.name), this.fieldsArray.push(EA), EA.partOf = this, BA(this), this;
  }, IA.prototype.remove = function(EA) {
    if (!(EA instanceof gA))
      throw TypeError("field must be a Field");
    var iA = this.fieldsArray.indexOf(EA);
    if (iA < 0)
      throw Error(EA + " is not a member of " + this);
    return this.fieldsArray.splice(iA, 1), iA = this.oneof.indexOf(EA.name), iA > -1 && this.oneof.splice(iA, 1), EA.partOf = null, this;
  }, IA.prototype.onAdd = function(EA) {
    CA.prototype.onAdd.call(this, EA);
    for (var iA = this, oA = 0; oA < this.oneof.length; ++oA) {
      var cA = EA.get(this.oneof[oA]);
      cA && !cA.partOf && (cA.partOf = iA, iA.fieldsArray.push(cA));
    }
    BA(this);
  }, IA.prototype.onRemove = function(EA) {
    for (var iA = 0, oA; iA < this.fieldsArray.length; ++iA)
      (oA = this.fieldsArray[iA]).parent && oA.parent.remove(oA);
    CA.prototype.onRemove.call(this, EA);
  }, Object.defineProperty(IA.prototype, "isProto3Optional", {
    get: function() {
      if (this.fieldsArray == null || this.fieldsArray.length !== 1)
        return !1;
      var QA = this.fieldsArray[0];
      return QA.options != null && QA.options.proto3_optional === !0;
    }
  }), IA.d = function() {
    for (var EA = new Array(arguments.length), iA = 0; iA < arguments.length; )
      EA[iA] = arguments[iA++];
    return function(cA, tA) {
      AA.decorateType(cA.constructor).add(new IA(tA, EA)), Object.defineProperty(cA, tA, {
        get: AA.oneOfGetter(EA),
        set: AA.oneOfSetter(EA)
      });
    };
  }, oneof;
}
var object, hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1, object = iA, iA.className = "ReflectionObject";
  const CA = requireOneof();
  var gA = requireUtil(), AA, IA = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE2024", default_symbol_visibility: "EXPORT_TOP_LEVEL" }, BA = { enum_type: "OPEN", field_presence: "EXPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" }, QA = { enum_type: "CLOSED", field_presence: "EXPLICIT", json_format: "LEGACY_BEST_EFFORT", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "EXPANDED", utf8_validation: "NONE", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" }, EA = { enum_type: "OPEN", field_presence: "IMPLICIT", json_format: "ALLOW", message_encoding: "LENGTH_PREFIXED", repeated_field_encoding: "PACKED", utf8_validation: "VERIFY", enforce_naming_style: "STYLE_LEGACY", default_symbol_visibility: "EXPORT_ALL" };
  function iA(oA, cA) {
    if (!gA.isString(oA))
      throw TypeError("name must be a string");
    if (cA && !gA.isObject(cA))
      throw TypeError("options must be an object");
    this.options = cA, this.parsedOptions = null, this.name = oA, this._edition = null, this._defaultEdition = "proto2", this._features = {}, this._featuresResolved = !1, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
  }
  return Object.defineProperties(iA.prototype, {
    /**
     * Reference to the root namespace.
     * @name ReflectionObject#root
     * @type {Root}
     * @readonly
     */
    root: {
      get: function() {
        for (var oA = this; oA.parent !== null; )
          oA = oA.parent;
        return oA;
      }
    },
    /**
     * Full name including leading dot.
     * @name ReflectionObject#fullName
     * @type {string}
     * @readonly
     */
    fullName: {
      get: function() {
        for (var oA = [this.name], cA = this.parent; cA; )
          oA.unshift(cA.name), cA = cA.parent;
        return oA.join(".");
      }
    }
  }), iA.prototype.toJSON = /* istanbul ignore next */
  function() {
    throw Error();
  }, iA.prototype.onAdd = function(cA) {
    this.parent && this.parent !== cA && this.parent.remove(this), this.parent = cA, this.resolved = !1;
    var tA = cA.root;
    tA instanceof AA && tA._handleAdd(this);
  }, iA.prototype.onRemove = function(cA) {
    var tA = cA.root;
    tA instanceof AA && tA._handleRemove(this), this.parent = null, this.resolved = !1;
  }, iA.prototype.resolve = function() {
    return this.resolved ? this : (this.root instanceof AA && (this.resolved = !0), this);
  }, iA.prototype._resolveFeaturesRecursive = function(cA) {
    return this._resolveFeatures(this._edition || cA);
  }, iA.prototype._resolveFeatures = function(cA) {
    if (!this._featuresResolved) {
      var tA = {};
      if (!cA)
        throw new Error("Unknown edition for " + this.fullName);
      var eA = Object.assign(
        this.options ? Object.assign({}, this.options.features) : {},
        this._inferLegacyProtoFeatures(cA)
      );
      if (this._edition) {
        if (cA === "proto2")
          tA = Object.assign({}, QA);
        else if (cA === "proto3")
          tA = Object.assign({}, EA);
        else if (cA === "2023")
          tA = Object.assign({}, BA);
        else if (cA === "2024")
          tA = Object.assign({}, IA);
        else
          throw new Error("Unknown edition: " + cA);
        this._features = Object.assign(tA, eA || {}), this._featuresResolved = !0;
        return;
      }
      if (this.partOf instanceof CA) {
        var aA = Object.assign({}, this.partOf._features);
        this._features = Object.assign(aA, eA || {});
      } else if (!this.declaringField) if (this.parent) {
        var GA = Object.assign({}, this.parent._features);
        this._features = Object.assign(GA, eA || {});
      } else
        throw new Error("Unable to find a parent for " + this.fullName);
      this.extensionField && (this.extensionField._features = this._features), this._featuresResolved = !0;
    }
  }, iA.prototype._inferLegacyProtoFeatures = function() {
    return {};
  }, iA.prototype.getOption = function(cA) {
    if (this.options)
      return this.options[cA];
  }, iA.prototype.setOption = function(cA, tA, eA) {
    return this.options || (this.options = {}), /^features\./.test(cA) ? gA.setProperty(this.options, cA, tA, eA) : (!eA || this.options[cA] === void 0) && (this.getOption(cA) !== tA && (this.resolved = !1), this.options[cA] = tA), this;
  }, iA.prototype.setParsedOption = function(cA, tA, eA) {
    this.parsedOptions || (this.parsedOptions = []);
    var aA = this.parsedOptions;
    if (eA) {
      var GA = aA.find(function(DA) {
        return Object.prototype.hasOwnProperty.call(DA, cA);
      });
      if (GA) {
        var lA = GA[cA];
        gA.setProperty(lA, eA, tA);
      } else
        GA = {}, GA[cA] = gA.setProperty({}, eA, tA), aA.push(GA);
    } else {
      var nA = {};
      nA[cA] = tA, aA.push(nA);
    }
    return this;
  }, iA.prototype.setOptions = function(cA, tA) {
    if (cA)
      for (var eA = Object.keys(cA), aA = 0; aA < eA.length; ++aA)
        this.setOption(eA[aA], cA[eA[aA]], tA);
    return this;
  }, iA.prototype.toString = function() {
    var cA = this.constructor.className, tA = this.fullName;
    return tA.length ? cA + " " + tA : cA;
  }, iA.prototype._editionToJSON = function() {
    if (!(!this._edition || this._edition === "proto3"))
      return this._edition;
  }, iA._configure = function(oA) {
    AA = oA;
  }, object;
}
var _enum, hasRequired_enum;
function require_enum() {
  if (hasRequired_enum) return _enum;
  hasRequired_enum = 1, _enum = IA;
  var CA = requireObject();
  ((IA.prototype = Object.create(CA.prototype)).constructor = IA).className = "Enum";
  var gA = requireNamespace(), AA = requireUtil();
  function IA(BA, QA, EA, iA, oA, cA) {
    if (CA.call(this, BA, EA), QA && typeof QA != "object")
      throw TypeError("values must be an object");
    if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = iA, this.comments = oA || {}, this.valuesOptions = cA, this._valuesFeatures = {}, this.reserved = void 0, QA)
      for (var tA = Object.keys(QA), eA = 0; eA < tA.length; ++eA)
        typeof QA[tA[eA]] == "number" && (this.valuesById[this.values[tA[eA]] = QA[tA[eA]]] = tA[eA]);
  }
  return IA.prototype._resolveFeatures = function(QA) {
    return QA = this._edition || QA, CA.prototype._resolveFeatures.call(this, QA), Object.keys(this.values).forEach((EA) => {
      var iA = Object.assign({}, this._features);
      this._valuesFeatures[EA] = Object.assign(iA, this.valuesOptions && this.valuesOptions[EA] && this.valuesOptions[EA].features);
    }), this;
  }, IA.fromJSON = function(QA, EA) {
    var iA = new IA(QA, EA.values, EA.options, EA.comment, EA.comments);
    return iA.reserved = EA.reserved, EA.edition && (iA._edition = EA.edition), iA._defaultEdition = "proto3", iA;
  }, IA.prototype.toJSON = function(QA) {
    var EA = QA ? !!QA.keepComments : !1;
    return AA.toObject([
      "edition",
      this._editionToJSON(),
      "options",
      this.options,
      "valuesOptions",
      this.valuesOptions,
      "values",
      this.values,
      "reserved",
      this.reserved && this.reserved.length ? this.reserved : void 0,
      "comment",
      EA ? this.comment : void 0,
      "comments",
      EA ? this.comments : void 0
    ]);
  }, IA.prototype.add = function(QA, EA, iA, oA) {
    if (!AA.isString(QA))
      throw TypeError("name must be a string");
    if (!AA.isInteger(EA))
      throw TypeError("id must be an integer");
    if (this.values[QA] !== void 0)
      throw Error("duplicate name '" + QA + "' in " + this);
    if (this.isReservedId(EA))
      throw Error("id " + EA + " is reserved in " + this);
    if (this.isReservedName(QA))
      throw Error("name '" + QA + "' is reserved in " + this);
    if (this.valuesById[EA] !== void 0) {
      if (!(this.options && this.options.allow_alias))
        throw Error("duplicate id " + EA + " in " + this);
      this.values[QA] = EA;
    } else
      this.valuesById[this.values[QA] = EA] = QA;
    return oA && (this.valuesOptions === void 0 && (this.valuesOptions = {}), this.valuesOptions[QA] = oA || null), this.comments[QA] = iA || null, this;
  }, IA.prototype.remove = function(QA) {
    if (!AA.isString(QA))
      throw TypeError("name must be a string");
    var EA = this.values[QA];
    if (EA == null)
      throw Error("name '" + QA + "' does not exist in " + this);
    return delete this.valuesById[EA], delete this.values[QA], delete this.comments[QA], this.valuesOptions && delete this.valuesOptions[QA], this;
  }, IA.prototype.isReservedId = function(QA) {
    return gA.isReservedId(this.reserved, QA);
  }, IA.prototype.isReservedName = function(QA) {
    return gA.isReservedName(this.reserved, QA);
  }, _enum;
}
var encoder_1, hasRequiredEncoder;
function requireEncoder() {
  if (hasRequiredEncoder) return encoder_1;
  hasRequiredEncoder = 1, encoder_1 = BA;
  var CA = require_enum(), gA = requireTypes(), AA = requireUtil();
  function IA(QA, EA, iA, oA) {
    return EA.delimited ? QA("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", iA, oA, (EA.id << 3 | 3) >>> 0, (EA.id << 3 | 4) >>> 0) : QA("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", iA, oA, (EA.id << 3 | 2) >>> 0);
  }
  function BA(QA) {
    for (var EA = AA.codegen(["m", "w"], QA.name + "$encode")("if(!w)")("w=Writer.create()"), iA, oA, cA = (
      /* initializes */
      QA.fieldsArray.slice().sort(AA.compareFieldsById)
    ), iA = 0; iA < cA.length; ++iA) {
      var tA = cA[iA].resolve(), eA = QA._fieldsArray.indexOf(tA), aA = tA.resolvedType instanceof CA ? "int32" : tA.type, GA = gA.basic[aA];
      oA = "m" + AA.safeProp(tA.name), tA.map ? (EA("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", oA, tA.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", oA)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (tA.id << 3 | 2) >>> 0, 8 | gA.mapKey[tA.keyType], tA.keyType), GA === void 0 ? EA("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", eA, oA) : EA(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | GA, aA, oA), EA("}")("}")) : tA.repeated ? (EA("if(%s!=null&&%s.length){", oA, oA), tA.packed && gA.packed[aA] !== void 0 ? EA("w.uint32(%i).fork()", (tA.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", oA)("w.%s(%s[i])", aA, oA)("w.ldelim()") : (EA("for(var i=0;i<%s.length;++i)", oA), GA === void 0 ? IA(EA, tA, eA, oA + "[i]") : EA("w.uint32(%i).%s(%s[i])", (tA.id << 3 | GA) >>> 0, aA, oA)), EA("}")) : (tA.optional && EA("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", oA, tA.name), GA === void 0 ? IA(EA, tA, eA, oA) : EA("w.uint32(%i).%s(%s)", (tA.id << 3 | GA) >>> 0, aA, oA));
    }
    return EA("return w");
  }
  return encoder_1;
}
var hasRequiredIndexLight;
function requireIndexLight() {
  if (hasRequiredIndexLight) return indexLight.exports;
  hasRequiredIndexLight = 1;
  var CA = indexLight.exports = requireIndexMinimal();
  CA.build = "light";
  function gA(IA, BA, QA) {
    return typeof BA == "function" ? (QA = BA, BA = new CA.Root()) : BA || (BA = new CA.Root()), BA.load(IA, QA);
  }
  CA.load = gA;
  function AA(IA, BA) {
    return BA || (BA = new CA.Root()), BA.loadSync(IA);
  }
  return CA.loadSync = AA, CA.encoder = requireEncoder(), CA.decoder = requireDecoder(), CA.verifier = requireVerifier(), CA.converter = requireConverter(), CA.ReflectionObject = requireObject(), CA.Namespace = requireNamespace(), CA.Root = requireRoot(), CA.Enum = require_enum(), CA.Type = requireType(), CA.Field = requireField(), CA.OneOf = requireOneof(), CA.MapField = requireMapfield(), CA.Service = requireService(), CA.Method = requireMethod(), CA.Message = requireMessage(), CA.wrappers = requireWrappers(), CA.types = requireTypes(), CA.util = requireUtil(), CA.ReflectionObject._configure(CA.Root), CA.Namespace._configure(CA.Type, CA.Service, CA.Enum), CA.Root._configure(CA.Type), CA.Field._configure(CA.Type), indexLight.exports;
}
var tokenize_1, hasRequiredTokenize;
function requireTokenize() {
  if (hasRequiredTokenize) return tokenize_1;
  hasRequiredTokenize = 1, tokenize_1 = tA;
  var CA = /[\s{}=;:[\],'"()<>]/g, gA = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, AA = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, IA = /^ *[*/]+ */, BA = /^\s*\*?\/*/, QA = /\n/g, EA = /\s/, iA = /\\(.?)/g, oA = {
    0: "\0",
    r: "\r",
    n: `
`,
    t: "	"
  };
  function cA(eA) {
    return eA.replace(iA, function(aA, GA) {
      switch (GA) {
        case "\\":
        case "":
          return GA;
        default:
          return oA[GA] || "";
      }
    });
  }
  tA.unescape = cA;
  function tA(eA, aA) {
    eA = eA.toString();
    var GA = 0, lA = eA.length, nA = 1, DA = 0, hA = {}, wA = [], sA = null;
    function NA(JA) {
      return Error("illegal " + JA + " (line " + nA + ")");
    }
    function rA() {
      var JA = sA === "'" ? AA : gA;
      JA.lastIndex = GA - 1;
      var UA = JA.exec(eA);
      if (!UA)
        throw NA("string");
      return GA = JA.lastIndex, kA(sA), sA = null, cA(UA[1]);
    }
    function yA(JA) {
      return eA.charAt(JA);
    }
    function bA(JA, UA, fA) {
      var zA = {
        type: eA.charAt(JA++),
        lineEmpty: !1,
        leading: fA
      }, _A;
      aA ? _A = 2 : _A = 3;
      var uA = JA - _A, HA;
      do
        if (--uA < 0 || (HA = eA.charAt(uA)) === `
`) {
          zA.lineEmpty = !0;
          break;
        }
      while (HA === " " || HA === "	");
      for (var TA = eA.substring(JA, UA).split(QA), ZA = 0; ZA < TA.length; ++ZA)
        TA[ZA] = TA[ZA].replace(aA ? BA : IA, "").trim();
      zA.text = TA.join(`
`).trim(), hA[nA] = zA, DA = nA;
    }
    function RA(JA) {
      var UA = FA(JA), fA = eA.substring(JA, UA), zA = /^\s*\/\//.test(fA);
      return zA;
    }
    function FA(JA) {
      for (var UA = JA; UA < lA && yA(UA) !== `
`; )
        UA++;
      return UA;
    }
    function dA() {
      if (wA.length > 0)
        return wA.shift();
      if (sA)
        return rA();
      var JA, UA, fA, zA, _A, uA = GA === 0;
      do {
        if (GA === lA)
          return null;
        for (JA = !1; EA.test(fA = yA(GA)); )
          if (fA === `
` && (uA = !0, ++nA), ++GA === lA)
            return null;
        if (yA(GA) === "/") {
          if (++GA === lA)
            throw NA("comment");
          if (yA(GA) === "/")
            if (aA) {
              if (zA = GA, _A = !1, RA(GA - 1)) {
                _A = !0;
                do
                  if (GA = FA(GA), GA === lA || (GA++, !uA))
                    break;
                while (RA(GA));
              } else
                GA = Math.min(lA, FA(GA) + 1);
              _A && (bA(zA, GA, uA), uA = !0), nA++, JA = !0;
            } else {
              for (_A = yA(zA = GA + 1) === "/"; yA(++GA) !== `
`; )
                if (GA === lA)
                  return null;
              ++GA, _A && (bA(zA, GA - 1, uA), uA = !0), ++nA, JA = !0;
            }
          else if ((fA = yA(GA)) === "*") {
            zA = GA + 1, _A = aA || yA(zA) === "*";
            do {
              if (fA === `
` && ++nA, ++GA === lA)
                throw NA("comment");
              UA = fA, fA = yA(GA);
            } while (UA !== "*" || fA !== "/");
            ++GA, _A && (bA(zA, GA - 2, uA), uA = !0), JA = !0;
          } else
            return "/";
        }
      } while (JA);
      var HA = GA;
      CA.lastIndex = 0;
      var TA = CA.test(yA(HA++));
      if (!TA)
        for (; HA < lA && !CA.test(yA(HA)); )
          ++HA;
      var ZA = eA.substring(GA, GA = HA);
      return (ZA === '"' || ZA === "'") && (sA = ZA), ZA;
    }
    function kA(JA) {
      wA.push(JA);
    }
    function pA() {
      if (!wA.length) {
        var JA = dA();
        if (JA === null)
          return null;
        kA(JA);
      }
      return wA[0];
    }
    function YA(JA, UA) {
      var fA = pA(), zA = fA === JA;
      if (zA)
        return dA(), !0;
      if (!UA)
        throw NA("token '" + fA + "', '" + JA + "' expected");
      return !1;
    }
    function SA(JA) {
      var UA = null, fA;
      return JA === void 0 ? (fA = hA[nA - 1], delete hA[nA - 1], fA && (aA || fA.type === "*" || fA.lineEmpty) && (UA = fA.leading ? fA.text : null)) : (DA < JA && pA(), fA = hA[JA], delete hA[JA], fA && !fA.lineEmpty && (aA || fA.type === "/") && (UA = fA.leading ? null : fA.text)), UA;
    }
    return Object.defineProperty({
      next: dA,
      peek: pA,
      push: kA,
      skip: YA,
      cmnt: SA
    }, "line", {
      get: function() {
        return nA;
      }
    });
  }
  return tokenize_1;
}
var parse_1, hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1, parse_1 = rA, rA.filename = null, rA.defaults = { keepCase: !1 };
  var CA = requireTokenize(), gA = requireRoot(), AA = requireType(), IA = requireField(), BA = requireMapfield(), QA = requireOneof(), EA = require_enum(), iA = requireService(), oA = requireMethod(), cA = requireObject(), tA = requireTypes(), eA = requireUtil(), aA = /^[1-9][0-9]*$/, GA = /^-?[1-9][0-9]*$/, lA = /^0[x][0-9a-fA-F]+$/, nA = /^-?0[x][0-9a-fA-F]+$/, DA = /^0[0-7]+$/, hA = /^-?0[0-7]+$/, wA = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, sA = /^[a-zA-Z_][a-zA-Z_0-9]*$/, NA = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/;
  function rA(yA, bA, RA) {
    bA instanceof gA || (RA = bA, bA = new gA()), RA || (RA = rA.defaults);
    var FA = RA.preferTrailingComment || !1, dA = CA(yA, RA.alternateCommentMode || !1), kA = dA.next, pA = dA.push, YA = dA.peek, SA = dA.skip, JA = dA.cmnt, UA = !0, fA, zA, _A, uA = "proto2", HA = bA, TA = [], ZA = {}, AI = RA.keepCase ? function(mA) {
      return mA;
    } : eA.camelCase;
    function QI() {
      TA.forEach((mA) => {
        mA._edition = uA, Object.keys(ZA).forEach((WA) => {
          mA.getOption(WA) === void 0 && mA.setOption(WA, ZA[WA], !0);
        });
      });
    }
    function LA(mA, WA, xA) {
      var qA = rA.filename;
      return xA || (rA.filename = null), Error("illegal " + (WA || "token") + " '" + mA + "' (" + (qA ? qA + ", " : "") + "line " + dA.line + ")");
    }
    function PA() {
      var mA = [], WA;
      do {
        if ((WA = kA()) !== '"' && WA !== "'")
          throw LA(WA);
        mA.push(kA()), SA(WA), WA = YA();
      } while (WA === '"' || WA === "'");
      return mA.join("");
    }
    function XA(mA) {
      var WA = kA();
      switch (WA) {
        case "'":
        case '"':
          return pA(WA), PA();
        case "true":
        case "TRUE":
          return !0;
        case "false":
        case "FALSE":
          return !1;
      }
      try {
        return CI(
          WA,
          /* insideTryCatch */
          !0
        );
      } catch {
        if (NA.test(WA))
          return WA;
        throw LA(WA, "value");
      }
    }
    function EI(mA, WA) {
      var xA, qA;
      do
        if (WA && ((xA = YA()) === '"' || xA === "'")) {
          var VA = PA();
          if (mA.push(VA), uA >= 2023)
            throw LA(VA, "id");
        } else
          try {
            mA.push([qA = II(kA()), SA("to", !0) ? II(kA()) : qA]);
          } catch (DI) {
            if (WA && NA.test(xA) && uA >= 2023)
              mA.push(xA);
            else
              throw DI;
          }
      while (SA(",", !0));
      var cI = { options: void 0 };
      cI.setOption = function(DI, JI) {
        this.options === void 0 && (this.options = {}), this.options[DI] = JI;
      }, nI(
        cI,
        function(JI) {
          if (JI === "option")
            rI(cI, JI), SA(";");
          else
            throw LA(JI);
        },
        function() {
          tI(cI);
        }
      );
    }
    function CI(mA, WA) {
      var xA = 1;
      switch (mA.charAt(0) === "-" && (xA = -1, mA = mA.substring(1)), mA) {
        case "inf":
        case "INF":
        case "Inf":
          return xA * (1 / 0);
        case "nan":
        case "NAN":
        case "Nan":
        case "NaN":
          return NaN;
        case "0":
          return 0;
      }
      if (aA.test(mA))
        return xA * parseInt(mA, 10);
      if (lA.test(mA))
        return xA * parseInt(mA, 16);
      if (DA.test(mA))
        return xA * parseInt(mA, 8);
      if (wA.test(mA))
        return xA * parseFloat(mA);
      throw LA(mA, "number", WA);
    }
    function II(mA, WA) {
      switch (mA) {
        case "max":
        case "MAX":
        case "Max":
          return 536870911;
        case "0":
          return 0;
      }
      if (!WA && mA.charAt(0) === "-")
        throw LA(mA, "id");
      if (GA.test(mA))
        return parseInt(mA, 10);
      if (nA.test(mA))
        return parseInt(mA, 16);
      if (hA.test(mA))
        return parseInt(mA, 8);
      throw LA(mA, "id");
    }
    function vA() {
      if (fA !== void 0)
        throw LA("package");
      if (fA = kA(), !NA.test(fA))
        throw LA(fA, "name");
      HA = HA.define(fA), SA(";");
    }
    function wI() {
      var mA = YA(), WA;
      switch (mA) {
        case "option":
          if (uA < "2024")
            throw LA("option");
          kA(), PA(), SA(";");
          return;
        case "weak":
          WA = _A || (_A = []), kA();
          break;
        case "public":
          kA();
        // eslint-disable-next-line no-fallthrough
        default:
          WA = zA || (zA = []);
          break;
      }
      mA = PA(), SA(";"), WA.push(mA);
    }
    function $A() {
      if (SA("="), uA = PA(), uA < 2023)
        throw LA(uA, "syntax");
      SA(";");
    }
    function YI() {
      if (SA("="), uA = PA(), !["2023", "2024"].includes(uA))
        throw LA(uA, "edition");
      SA(";");
    }
    function FI(mA, WA) {
      switch (WA) {
        case "option":
          return rI(mA, WA), SA(";"), !0;
        case "message":
          return uI(mA, WA), !0;
        case "enum":
          return pI(mA, WA), !0;
        case "export":
        case "local":
          return uA < "2024" || (WA = kA(), WA === "export" || WA === "local") || WA !== "message" && WA !== "enum" ? !1 : FI(mA, WA);
        case "service":
          return GI(mA, WA), !0;
        case "extend":
          return eI(mA, WA), !0;
      }
      return !1;
    }
    function nI(mA, WA, xA) {
      var qA = dA.line;
      if (mA && (typeof mA.comment != "string" && (mA.comment = JA()), mA.filename = rA.filename), SA("{", !0)) {
        for (var VA; (VA = kA()) !== "}"; )
          WA(VA);
        SA(";", !0);
      } else
        xA && xA(), SA(";"), mA && (typeof mA.comment != "string" || FA) && (mA.comment = JA(qA) || mA.comment);
    }
    function uI(mA, WA) {
      if (!sA.test(WA = kA()))
        throw LA(WA, "type name");
      var xA = new AA(WA);
      nI(xA, function(VA) {
        if (!FI(xA, VA))
          switch (VA) {
            case "map":
              HI(xA);
              break;
            case "required":
              if (uA !== "proto2")
                throw LA(VA);
            /* eslint-disable no-fallthrough */
            case "repeated":
              hI(xA, VA);
              break;
            case "optional":
              if (uA === "proto3")
                hI(xA, "proto3_optional");
              else {
                if (uA !== "proto2")
                  throw LA(VA);
                hI(xA, "optional");
              }
              break;
            case "oneof":
              UI(xA, VA);
              break;
            case "extensions":
              EI(xA.extensions || (xA.extensions = []));
              break;
            case "reserved":
              EI(xA.reserved || (xA.reserved = []), !0);
              break;
            default:
              if (uA === "proto2" || !NA.test(VA))
                throw LA(VA);
              pA(VA), hI(xA, "optional");
              break;
          }
      }), mA.add(xA), mA === HA && TA.push(xA);
    }
    function hI(mA, WA, xA) {
      var qA = kA();
      if (qA === "group") {
        bI(mA, WA);
        return;
      }
      for (; qA.endsWith(".") || YA().startsWith("."); )
        qA += kA();
      if (!NA.test(qA))
        throw LA(qA, "type");
      var VA = kA();
      if (!sA.test(VA))
        throw LA(VA, "name");
      VA = AI(VA), SA("=");
      var cI = new IA(VA, II(kA()), qA, WA, xA);
      if (nI(cI, function(kI) {
        if (kI === "option")
          rI(cI, kI), SA(";");
        else
          throw LA(kI);
      }, function() {
        tI(cI);
      }), WA === "proto3_optional") {
        var DI = new QA("_" + VA);
        cI.setOption("proto3_optional", !0), DI.add(cI), mA.add(DI);
      } else
        mA.add(cI);
      mA === HA && TA.push(cI);
    }
    function bI(mA, WA) {
      if (uA >= 2023)
        throw LA("group");
      var xA = kA();
      if (!sA.test(xA))
        throw LA(xA, "name");
      var qA = eA.lcFirst(xA);
      xA === qA && (xA = eA.ucFirst(xA)), SA("=");
      var VA = II(kA()), cI = new AA(xA);
      cI.group = !0;
      var DI = new IA(qA, VA, xA, WA);
      DI.filename = rA.filename, nI(cI, function(kI) {
        switch (kI) {
          case "option":
            rI(cI, kI), SA(";");
            break;
          case "required":
          case "repeated":
            hI(cI, kI);
            break;
          case "optional":
            uA === "proto3" ? hI(cI, "proto3_optional") : hI(cI, "optional");
            break;
          case "message":
            uI(cI, kI);
            break;
          case "enum":
            pI(cI, kI);
            break;
          case "reserved":
            EI(cI.reserved || (cI.reserved = []), !0);
            break;
          case "export":
          case "local":
            if (uA < "2024")
              throw LA(kI);
            switch (kI = kA(), kI) {
              case "message":
                uI(cI, kI);
                break;
              case "enum":
                uI(cI, kI);
                break;
              default:
                throw LA(kI);
            }
            break;
          /* istanbul ignore next */
          default:
            throw LA(kI);
        }
      }), mA.add(cI).add(DI);
    }
    function HI(mA) {
      SA("<");
      var WA = kA();
      if (tA.mapKey[WA] === void 0)
        throw LA(WA, "type");
      SA(",");
      var xA = kA();
      if (!NA.test(xA))
        throw LA(xA, "type");
      SA(">");
      var qA = kA();
      if (!sA.test(qA))
        throw LA(qA, "name");
      SA("=");
      var VA = new BA(AI(qA), II(kA()), WA, xA);
      nI(VA, function(DI) {
        if (DI === "option")
          rI(VA, DI), SA(";");
        else
          throw LA(DI);
      }, function() {
        tI(VA);
      }), mA.add(VA);
    }
    function UI(mA, WA) {
      if (!sA.test(WA = kA()))
        throw LA(WA, "name");
      var xA = new QA(AI(WA));
      nI(xA, function(VA) {
        VA === "option" ? (rI(xA, VA), SA(";")) : (pA(VA), hI(xA, "optional"));
      }), mA.add(xA);
    }
    function pI(mA, WA) {
      if (!sA.test(WA = kA()))
        throw LA(WA, "name");
      var xA = new EA(WA);
      nI(xA, function(VA) {
        switch (VA) {
          case "option":
            rI(xA, VA), SA(";");
            break;
          case "reserved":
            EI(xA.reserved || (xA.reserved = []), !0), xA.reserved === void 0 && (xA.reserved = []);
            break;
          default:
            mI(xA, VA);
        }
      }), mA.add(xA), mA === HA && TA.push(xA);
    }
    function mI(mA, WA) {
      if (!sA.test(WA))
        throw LA(WA, "name");
      SA("=");
      var xA = II(kA(), !0), qA = {
        options: void 0
      };
      qA.getOption = function(VA) {
        return this.options[VA];
      }, qA.setOption = function(VA, cI) {
        cA.prototype.setOption.call(qA, VA, cI);
      }, qA.setParsedOption = function() {
      }, nI(qA, function(cI) {
        if (cI === "option")
          rI(qA, cI), SA(";");
        else
          throw LA(cI);
      }, function() {
        tI(qA);
      }), mA.add(WA, xA, qA.comment, qA.parsedOptions || qA.options);
    }
    function rI(mA, WA) {
      var xA, qA, VA = !0;
      for (WA === "option" && (WA = kA()); WA !== "="; ) {
        if (WA === "(") {
          var cI = kA();
          SA(")"), WA = "(" + cI + ")";
        }
        if (VA) {
          if (VA = !1, WA.includes(".") && !WA.includes("(")) {
            var DI = WA.split(".");
            xA = DI[0] + ".", WA = DI[1];
            continue;
          }
          xA = WA;
        } else
          qA = qA ? qA += WA : WA;
        WA = kA();
      }
      var JI = qA ? xA.concat(qA) : xA, kI = KA(mA, JI);
      qA = qA && qA[0] === "." ? qA.slice(1) : qA, xA = xA && xA[xA.length - 1] === "." ? xA.slice(0, -1) : xA, iI(mA, xA, kI, qA);
    }
    function KA(mA, WA) {
      if (SA("{", !0)) {
        for (var xA = {}; !SA("}", !0); ) {
          if (!sA.test(gI = kA()))
            throw LA(gI, "name");
          if (gI === null)
            throw LA(gI, "end of input");
          var qA, VA = gI;
          if (SA(":", !0), YA() === "{")
            qA = KA(mA, WA + "." + gI);
          else if (YA() === "[") {
            qA = [];
            var cI;
            if (SA("[", !0)) {
              do
                cI = XA(), qA.push(cI);
              while (SA(",", !0));
              SA("]"), typeof cI < "u" && OA(mA, WA + "." + gI, cI);
            }
          } else
            qA = XA(), OA(mA, WA + "." + gI, qA);
          var DI = xA[VA];
          DI && (qA = [].concat(DI).concat(qA)), xA[VA] = qA, SA(",", !0), SA(";", !0);
        }
        return xA;
      }
      var JI = XA();
      return OA(mA, WA, JI), JI;
    }
    function OA(mA, WA, xA) {
      if (HA === mA && /^features\./.test(WA)) {
        ZA[WA] = xA;
        return;
      }
      mA.setOption && mA.setOption(WA, xA);
    }
    function iI(mA, WA, xA, qA) {
      mA.setParsedOption && mA.setParsedOption(WA, xA, qA);
    }
    function tI(mA) {
      if (SA("[", !0)) {
        do
          rI(mA, "option");
        while (SA(",", !0));
        SA("]");
      }
      return mA;
    }
    function GI(mA, WA) {
      if (!sA.test(WA = kA()))
        throw LA(WA, "service name");
      var xA = new iA(WA);
      nI(xA, function(VA) {
        if (!FI(xA, VA))
          if (VA === "rpc")
            oI(xA, VA);
          else
            throw LA(VA);
      }), mA.add(xA), mA === HA && TA.push(xA);
    }
    function oI(mA, WA) {
      var xA = JA(), qA = WA;
      if (!sA.test(WA = kA()))
        throw LA(WA, "name");
      var VA = WA, cI, DI, JI, kI;
      if (SA("("), SA("stream", !0) && (DI = !0), !NA.test(WA = kA()) || (cI = WA, SA(")"), SA("returns"), SA("("), SA("stream", !0) && (kI = !0), !NA.test(WA = kA())))
        throw LA(WA);
      JI = WA, SA(")");
      var fI = new oA(VA, qA, cI, JI, DI, kI);
      fI.comment = xA, nI(fI, function(qI) {
        if (qI === "option")
          rI(fI, qI), SA(";");
        else
          throw LA(qI);
      }), mA.add(fI);
    }
    function eI(mA, WA) {
      if (!NA.test(WA = kA()))
        throw LA(WA, "reference");
      var xA = WA;
      nI(null, function(VA) {
        switch (VA) {
          case "required":
          case "repeated":
            hI(mA, VA, xA);
            break;
          case "optional":
            uA === "proto3" ? hI(mA, "proto3_optional", xA) : hI(mA, "optional", xA);
            break;
          default:
            if (uA === "proto2" || !NA.test(VA))
              throw LA(VA);
            pA(VA), hI(mA, "optional", xA);
            break;
        }
      });
    }
    for (var gI; (gI = kA()) !== null; )
      switch (gI) {
        case "package":
          if (!UA)
            throw LA(gI);
          vA();
          break;
        case "import":
          if (!UA)
            throw LA(gI);
          wI();
          break;
        case "syntax":
          if (!UA)
            throw LA(gI);
          $A();
          break;
        case "edition":
          if (!UA)
            throw LA(gI);
          YI();
          break;
        case "option":
          rI(HA, gI), SA(";", !0);
          break;
        default:
          if (FI(HA, gI)) {
            UA = !1;
            continue;
          }
          throw LA(gI);
      }
    return QI(), rA.filename = null, {
      package: fA,
      imports: zA,
      weakImports: _A,
      root: bA
    };
  }
  return parse_1;
}
var common_1, hasRequiredCommon;
function requireCommon() {
  if (hasRequiredCommon) return common_1;
  hasRequiredCommon = 1, common_1 = gA;
  var CA = /\/|\./;
  function gA(IA, BA) {
    CA.test(IA) || (IA = "google/protobuf/" + IA + ".proto", BA = { nested: { google: { nested: { protobuf: { nested: BA } } } } }), gA[IA] = BA;
  }
  gA("any", {
    /**
     * Properties of a google.protobuf.Any message.
     * @interface IAny
     * @type {Object}
     * @property {string} [typeUrl]
     * @property {Uint8Array} [bytes]
     * @memberof common
     */
    Any: {
      fields: {
        type_url: {
          type: "string",
          id: 1
        },
        value: {
          type: "bytes",
          id: 2
        }
      }
    }
  });
  var AA;
  return gA("duration", {
    /**
     * Properties of a google.protobuf.Duration message.
     * @interface IDuration
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Duration: AA = {
      fields: {
        seconds: {
          type: "int64",
          id: 1
        },
        nanos: {
          type: "int32",
          id: 2
        }
      }
    }
  }), gA("timestamp", {
    /**
     * Properties of a google.protobuf.Timestamp message.
     * @interface ITimestamp
     * @type {Object}
     * @property {number|Long} [seconds]
     * @property {number} [nanos]
     * @memberof common
     */
    Timestamp: AA
  }), gA("empty", {
    /**
     * Properties of a google.protobuf.Empty message.
     * @interface IEmpty
     * @memberof common
     */
    Empty: {
      fields: {}
    }
  }), gA("struct", {
    /**
     * Properties of a google.protobuf.Struct message.
     * @interface IStruct
     * @type {Object}
     * @property {Object.<string,IValue>} [fields]
     * @memberof common
     */
    Struct: {
      fields: {
        fields: {
          keyType: "string",
          type: "Value",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Value message.
     * @interface IValue
     * @type {Object}
     * @property {string} [kind]
     * @property {0} [nullValue]
     * @property {number} [numberValue]
     * @property {string} [stringValue]
     * @property {boolean} [boolValue]
     * @property {IStruct} [structValue]
     * @property {IListValue} [listValue]
     * @memberof common
     */
    Value: {
      oneofs: {
        kind: {
          oneof: [
            "nullValue",
            "numberValue",
            "stringValue",
            "boolValue",
            "structValue",
            "listValue"
          ]
        }
      },
      fields: {
        nullValue: {
          type: "NullValue",
          id: 1
        },
        numberValue: {
          type: "double",
          id: 2
        },
        stringValue: {
          type: "string",
          id: 3
        },
        boolValue: {
          type: "bool",
          id: 4
        },
        structValue: {
          type: "Struct",
          id: 5
        },
        listValue: {
          type: "ListValue",
          id: 6
        }
      }
    },
    NullValue: {
      values: {
        NULL_VALUE: 0
      }
    },
    /**
     * Properties of a google.protobuf.ListValue message.
     * @interface IListValue
     * @type {Object}
     * @property {Array.<IValue>} [values]
     * @memberof common
     */
    ListValue: {
      fields: {
        values: {
          rule: "repeated",
          type: "Value",
          id: 1
        }
      }
    }
  }), gA("wrappers", {
    /**
     * Properties of a google.protobuf.DoubleValue message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    DoubleValue: {
      fields: {
        value: {
          type: "double",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.FloatValue message.
     * @interface IFloatValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FloatValue: {
      fields: {
        value: {
          type: "float",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int64Value message.
     * @interface IInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    Int64Value: {
      fields: {
        value: {
          type: "int64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt64Value message.
     * @interface IUInt64Value
     * @type {Object}
     * @property {number|Long} [value]
     * @memberof common
     */
    UInt64Value: {
      fields: {
        value: {
          type: "uint64",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.Int32Value message.
     * @interface IInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    Int32Value: {
      fields: {
        value: {
          type: "int32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.UInt32Value message.
     * @interface IUInt32Value
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    UInt32Value: {
      fields: {
        value: {
          type: "uint32",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BoolValue message.
     * @interface IBoolValue
     * @type {Object}
     * @property {boolean} [value]
     * @memberof common
     */
    BoolValue: {
      fields: {
        value: {
          type: "bool",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.StringValue message.
     * @interface IStringValue
     * @type {Object}
     * @property {string} [value]
     * @memberof common
     */
    StringValue: {
      fields: {
        value: {
          type: "string",
          id: 1
        }
      }
    },
    /**
     * Properties of a google.protobuf.BytesValue message.
     * @interface IBytesValue
     * @type {Object}
     * @property {Uint8Array} [value]
     * @memberof common
     */
    BytesValue: {
      fields: {
        value: {
          type: "bytes",
          id: 1
        }
      }
    }
  }), gA("field_mask", {
    /**
     * Properties of a google.protobuf.FieldMask message.
     * @interface IDoubleValue
     * @type {Object}
     * @property {number} [value]
     * @memberof common
     */
    FieldMask: {
      fields: {
        paths: {
          rule: "repeated",
          type: "string",
          id: 1
        }
      }
    }
  }), gA.get = function(BA) {
    return gA[BA] || null;
  }, common_1;
}
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src.exports;
  hasRequiredSrc = 1;
  var CA = src.exports = requireIndexLight();
  return CA.build = "full", CA.tokenize = requireTokenize(), CA.parse = requireParse(), CA.common = requireCommon(), CA.Root._configure(CA.Type, CA.parse, CA.common), src.exports;
}
var protobufjs, hasRequiredProtobufjs;
function requireProtobufjs() {
  return hasRequiredProtobufjs || (hasRequiredProtobufjs = 1, protobufjs = requireSrc()), protobufjs;
}
var protobufjsExports = requireProtobufjs();
const token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(CA, gA) {
  try {
    return [decodeURIComponent(CA.join(""))];
  } catch {
  }
  if (CA.length === 1)
    return CA;
  gA = gA || 1;
  const AA = CA.slice(0, gA), IA = CA.slice(gA);
  return Array.prototype.concat.call([], decodeComponents(AA), decodeComponents(IA));
}
function decode$1(CA) {
  try {
    return decodeURIComponent(CA);
  } catch {
    let gA = CA.match(singleMatcher) || [];
    for (let AA = 1; AA < gA.length; AA++)
      CA = decodeComponents(gA, AA).join(""), gA = CA.match(singleMatcher) || [];
    return CA;
  }
}
function customDecodeURIComponent(CA) {
  const gA = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let AA = multiMatcher.exec(CA);
  for (; AA; ) {
    try {
      gA[AA[0]] = decodeURIComponent(AA[0]);
    } catch {
      const BA = decode$1(AA[0]);
      BA !== AA[0] && (gA[AA[0]] = BA);
    }
    AA = multiMatcher.exec(CA);
  }
  gA["%C2"] = "�";
  const IA = Object.keys(gA);
  for (const BA of IA)
    CA = CA.replace(new RegExp(BA, "g"), gA[BA]);
  return CA;
}
function decodeUriComponent(CA) {
  if (typeof CA != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof CA + "`");
  try {
    return decodeURIComponent(CA);
  } catch {
    return customDecodeURIComponent(CA);
  }
}
function includeKeys(CA, gA) {
  const AA = {};
  if (Array.isArray(gA))
    for (const IA of gA) {
      const BA = Object.getOwnPropertyDescriptor(CA, IA);
      BA?.enumerable && Object.defineProperty(AA, IA, BA);
    }
  else
    for (const IA of Reflect.ownKeys(CA)) {
      const BA = Object.getOwnPropertyDescriptor(CA, IA);
      if (BA.enumerable) {
        const QA = CA[IA];
        gA(IA, QA, CA) && Object.defineProperty(AA, IA, BA);
      }
    }
  return AA;
}
function splitOnFirst(CA, gA) {
  if (!(typeof CA == "string" && typeof gA == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (CA === "" || gA === "")
    return [];
  const AA = CA.indexOf(gA);
  return AA === -1 ? [] : [
    CA.slice(0, AA),
    CA.slice(AA + gA.length)
  ];
}
const isNullOrUndefined = (CA) => CA == null, strictUriEncode = (CA) => encodeURIComponent(CA).replaceAll(/[!'()*]/g, (gA) => `%${gA.charCodeAt(0).toString(16).toUpperCase()}`), encodeFragmentIdentifier = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(CA) {
  switch (CA.arrayFormat) {
    case "index":
      return (gA) => (AA, IA) => {
        const BA = AA.length;
        return IA === void 0 || CA.skipNull && IA === null || CA.skipEmptyString && IA === "" ? AA : IA === null ? [
          ...AA,
          [encode(gA, CA), "[", BA, "]"].join("")
        ] : [
          ...AA,
          [encode(gA, CA), "[", encode(BA, CA), "]=", encode(IA, CA)].join("")
        ];
      };
    case "bracket":
      return (gA) => (AA, IA) => IA === void 0 || CA.skipNull && IA === null || CA.skipEmptyString && IA === "" ? AA : IA === null ? [
        ...AA,
        [encode(gA, CA), "[]"].join("")
      ] : [
        ...AA,
        [encode(gA, CA), "[]=", encode(IA, CA)].join("")
      ];
    case "colon-list-separator":
      return (gA) => (AA, IA) => IA === void 0 || CA.skipNull && IA === null || CA.skipEmptyString && IA === "" ? AA : IA === null ? [
        ...AA,
        [encode(gA, CA), ":list="].join("")
      ] : [
        ...AA,
        [encode(gA, CA), ":list=", encode(IA, CA)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const gA = CA.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (AA) => (IA, BA) => BA === void 0 || CA.skipNull && BA === null || CA.skipEmptyString && BA === "" ? IA : (BA = BA === null ? "" : BA, IA.length === 0 ? [[encode(AA, CA), gA, encode(BA, CA)].join("")] : [[IA, encode(BA, CA)].join(CA.arrayFormatSeparator)]);
    }
    default:
      return (gA) => (AA, IA) => IA === void 0 || CA.skipNull && IA === null || CA.skipEmptyString && IA === "" ? AA : IA === null ? [
        ...AA,
        encode(gA, CA)
      ] : [
        ...AA,
        [encode(gA, CA), "=", encode(IA, CA)].join("")
      ];
  }
}
function parserForArrayFormat(CA) {
  let gA;
  switch (CA.arrayFormat) {
    case "index":
      return (AA, IA, BA) => {
        if (gA = /\[(\d*)]$/.exec(AA), AA = AA.replace(/\[\d*]$/, ""), !gA) {
          BA[AA] = IA;
          return;
        }
        BA[AA] === void 0 && (BA[AA] = {}), BA[AA][gA[1]] = IA;
      };
    case "bracket":
      return (AA, IA, BA) => {
        if (gA = /(\[])$/.exec(AA), AA = AA.replace(/\[]$/, ""), !gA) {
          BA[AA] = IA;
          return;
        }
        if (BA[AA] === void 0) {
          BA[AA] = [IA];
          return;
        }
        BA[AA] = [...BA[AA], IA];
      };
    case "colon-list-separator":
      return (AA, IA, BA) => {
        if (gA = /(:list)$/.exec(AA), AA = AA.replace(/:list$/, ""), !gA) {
          BA[AA] = IA;
          return;
        }
        if (BA[AA] === void 0) {
          BA[AA] = [IA];
          return;
        }
        BA[AA] = [...BA[AA], IA];
      };
    case "comma":
    case "separator":
      return (AA, IA, BA) => {
        const EA = typeof IA == "string" && IA.includes(CA.arrayFormatSeparator) ? IA.split(CA.arrayFormatSeparator).map((iA) => decode(iA, CA)) : IA === null ? IA : decode(IA, CA);
        BA[AA] = EA;
      };
    case "bracket-separator":
      return (AA, IA, BA) => {
        const QA = /(\[])$/.test(AA);
        if (AA = AA.replace(/\[]$/, ""), !QA) {
          BA[AA] = IA && decode(IA, CA);
          return;
        }
        const EA = IA === null ? [] : decode(IA, CA).split(CA.arrayFormatSeparator);
        if (BA[AA] === void 0) {
          BA[AA] = EA;
          return;
        }
        BA[AA] = [...BA[AA], ...EA];
      };
    default:
      return (AA, IA, BA) => {
        if (BA[AA] === void 0) {
          BA[AA] = IA;
          return;
        }
        BA[AA] = [...[BA[AA]].flat(), IA];
      };
  }
}
function validateArrayFormatSeparator(CA) {
  if (typeof CA != "string" || CA.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(CA, gA) {
  return gA.encode ? gA.strict ? strictUriEncode(CA) : encodeURIComponent(CA) : CA;
}
function decode(CA, gA) {
  return gA.decode ? decodeUriComponent(CA) : CA;
}
function keysSorter(CA) {
  return Array.isArray(CA) ? CA.sort() : typeof CA == "object" ? keysSorter(Object.keys(CA)).sort((gA, AA) => Number(gA) - Number(AA)).map((gA) => CA[gA]) : CA;
}
function removeHash(CA) {
  const gA = CA.indexOf("#");
  return gA !== -1 && (CA = CA.slice(0, gA)), CA;
}
function getHash(CA) {
  let gA = "";
  const AA = CA.indexOf("#");
  return AA !== -1 && (gA = CA.slice(AA)), gA;
}
function parseValue(CA, gA, AA) {
  return AA === "string" && typeof CA == "string" ? CA : typeof AA == "function" && typeof CA == "string" ? AA(CA) : AA === "boolean" && CA === null ? !0 : AA === "boolean" && CA !== null && (CA.toLowerCase() === "true" || CA.toLowerCase() === "false") ? CA.toLowerCase() === "true" : AA === "boolean" && CA !== null && (CA.toLowerCase() === "1" || CA.toLowerCase() === "0") ? CA.toLowerCase() === "1" : AA === "string[]" && gA.arrayFormat !== "none" && typeof CA == "string" ? [CA] : AA === "number[]" && gA.arrayFormat !== "none" && !Number.isNaN(Number(CA)) && typeof CA == "string" && CA.trim() !== "" ? [Number(CA)] : AA === "number" && !Number.isNaN(Number(CA)) && typeof CA == "string" && CA.trim() !== "" ? Number(CA) : gA.parseBooleans && CA !== null && (CA.toLowerCase() === "true" || CA.toLowerCase() === "false") ? CA.toLowerCase() === "true" : gA.parseNumbers && !Number.isNaN(Number(CA)) && typeof CA == "string" && CA.trim() !== "" ? Number(CA) : CA;
}
function extract(CA) {
  CA = removeHash(CA);
  const gA = CA.indexOf("?");
  return gA === -1 ? "" : CA.slice(gA + 1);
}
function parse(CA, gA) {
  gA = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...gA
  }, validateArrayFormatSeparator(gA.arrayFormatSeparator);
  const AA = parserForArrayFormat(gA), IA = /* @__PURE__ */ Object.create(null);
  if (typeof CA != "string" || (CA = CA.trim().replace(/^[?#&]/, ""), !CA))
    return IA;
  for (const BA of CA.split("&")) {
    if (BA === "")
      continue;
    const QA = gA.decode ? BA.replaceAll("+", " ") : BA;
    let [EA, iA] = splitOnFirst(QA, "=");
    EA === void 0 && (EA = QA), iA = iA === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(gA.arrayFormat) ? iA : decode(iA, gA), AA(decode(EA, gA), iA, IA);
  }
  for (const [BA, QA] of Object.entries(IA))
    if (typeof QA == "object" && QA !== null && gA.types[BA] !== "string")
      for (const [EA, iA] of Object.entries(QA)) {
        const oA = gA.types[BA], cA = typeof oA == "function" ? oA : oA ? oA.replace("[]", "") : void 0;
        QA[EA] = parseValue(iA, gA, cA);
      }
    else typeof QA == "object" && QA !== null && gA.types[BA] === "string" ? IA[BA] = Object.values(QA).join(gA.arrayFormatSeparator) : IA[BA] = parseValue(QA, gA, gA.types[BA]);
  return gA.sort === !1 ? IA : (gA.sort === !0 ? Object.keys(IA).sort() : Object.keys(IA).sort(gA.sort)).reduce((BA, QA) => {
    const EA = IA[QA];
    return BA[QA] = EA && typeof EA == "object" && !Array.isArray(EA) ? keysSorter(EA) : EA, BA;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify(CA, gA) {
  if (!CA)
    return "";
  gA = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...gA
  }, validateArrayFormatSeparator(gA.arrayFormatSeparator);
  const AA = (EA) => gA.skipNull && isNullOrUndefined(CA[EA]) || gA.skipEmptyString && CA[EA] === "", IA = encoderForArrayFormat(gA), BA = {};
  for (const [EA, iA] of Object.entries(CA))
    AA(EA) || (BA[EA] = iA);
  const QA = Object.keys(BA);
  return gA.sort !== !1 && QA.sort(gA.sort), QA.map((EA) => {
    let iA = CA[EA];
    if (gA.replacer && (iA = gA.replacer(EA, iA), iA === void 0) || iA === void 0)
      return "";
    if (iA === null)
      return encode(EA, gA);
    if (Array.isArray(iA)) {
      if (iA.length === 0 && gA.arrayFormat === "bracket-separator")
        return encode(EA, gA) + "[]";
      let oA = iA;
      return gA.replacer && (oA = iA.map(
        (cA, tA) => gA.replacer(`${EA}[${tA}]`, cA)
      ).filter((cA) => cA !== void 0)), oA.reduce(IA(EA), []).join("&");
    }
    return encode(EA, gA) + "=" + encode(iA, gA);
  }).filter((EA) => EA.length > 0).join("&");
}
function parseUrl(CA, gA) {
  gA = {
    decode: !0,
    ...gA
  };
  let [AA, IA] = splitOnFirst(CA, "#");
  return AA === void 0 && (AA = CA), {
    url: AA?.split("?")?.[0] ?? "",
    query: parse(extract(CA), gA),
    ...gA && gA.parseFragmentIdentifier && IA ? { fragmentIdentifier: decode(IA, gA) } : {}
  };
}
function stringifyUrl(CA, gA) {
  gA = {
    encode: !0,
    strict: !0,
    [encodeFragmentIdentifier]: !0,
    ...gA
  };
  const AA = removeHash(CA.url).split("?")[0] || "", IA = extract(CA.url), BA = {
    ...parse(IA, { sort: !1, ...gA }),
    ...CA.query
  };
  let QA = stringify(BA, gA);
  QA &&= `?${QA}`;
  let EA = getHash(CA.url);
  if (typeof CA.fragmentIdentifier == "string") {
    const iA = new URL(AA);
    iA.hash = CA.fragmentIdentifier, EA = gA[encodeFragmentIdentifier] ? iA.hash : `#${CA.fragmentIdentifier}`;
  }
  return `${AA}${QA}${EA}`;
}
function pick(CA, gA, AA) {
  AA = {
    parseFragmentIdentifier: !0,
    [encodeFragmentIdentifier]: !1,
    ...AA
  };
  const { url: IA, query: BA, fragmentIdentifier: QA } = parseUrl(CA, AA);
  return stringifyUrl({
    url: IA,
    query: includeKeys(BA, gA),
    fragmentIdentifier: QA
  }, AA);
}
function exclude(CA, gA, AA) {
  const IA = Array.isArray(gA) ? (BA) => !gA.includes(BA) : (BA, QA) => !gA(BA, QA);
  return pick(CA, IA, AA);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse,
  parseUrl,
  pick,
  stringify,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" }));
var dist$2 = {}, Collector = {}, hasRequiredCollector;
function requireCollector() {
  if (hasRequiredCollector) return Collector;
  hasRequiredCollector = 1, Object.defineProperty(Collector, "__esModule", { value: !0 }), Collector.Collector = void 0;
  let CA = class {
    /**
     * Create a new collector.
     *
     * @param signal The signal to emit.
     */
    constructor(AA) {
      this.emit = (...IA) => {
        AA.emitCollecting(this, IA);
      };
    }
  };
  return Collector.Collector = CA, Collector;
}
var CollectorArray = {}, hasRequiredCollectorArray;
function requireCollectorArray() {
  if (hasRequiredCollectorArray) return CollectorArray;
  hasRequiredCollectorArray = 1, Object.defineProperty(CollectorArray, "__esModule", { value: !0 }), CollectorArray.CollectorArray = void 0;
  const CA = requireCollector();
  let gA = class extends CA.Collector {
    constructor() {
      super(...arguments), this.result = [];
    }
    handleResult(IA) {
      return this.result.push(IA), !0;
    }
    /**
     * Get the list of results from the signal handlers.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result.length = 0;
    }
  };
  return CollectorArray.CollectorArray = gA, CollectorArray;
}
var CollectorLast = {}, hasRequiredCollectorLast;
function requireCollectorLast() {
  if (hasRequiredCollectorLast) return CollectorLast;
  hasRequiredCollectorLast = 1, Object.defineProperty(CollectorLast, "__esModule", { value: !0 }), CollectorLast.CollectorLast = void 0;
  const CA = requireCollector();
  let gA = class extends CA.Collector {
    handleResult(IA) {
      return this.result = IA, !0;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      delete this.result;
    }
  };
  return CollectorLast.CollectorLast = gA, CollectorLast;
}
var CollectorUntil0 = {}, hasRequiredCollectorUntil0;
function requireCollectorUntil0() {
  if (hasRequiredCollectorUntil0) return CollectorUntil0;
  hasRequiredCollectorUntil0 = 1, Object.defineProperty(CollectorUntil0, "__esModule", { value: !0 }), CollectorUntil0.CollectorUntil0 = void 0;
  const CA = requireCollector();
  let gA = class extends CA.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(IA) {
      return this.result = IA, this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorUntil0.CollectorUntil0 = gA, CollectorUntil0;
}
var CollectorWhile0 = {}, hasRequiredCollectorWhile0;
function requireCollectorWhile0() {
  if (hasRequiredCollectorWhile0) return CollectorWhile0;
  hasRequiredCollectorWhile0 = 1, Object.defineProperty(CollectorWhile0, "__esModule", { value: !0 }), CollectorWhile0.CollectorWhile0 = void 0;
  const CA = requireCollector();
  let gA = class extends CA.Collector {
    constructor() {
      super(...arguments), this.result = !1;
    }
    handleResult(IA) {
      return this.result = IA, !this.result;
    }
    /**
     * Get the result of the last signal handler.
     */
    getResult() {
      return this.result;
    }
    /**
     * Reset the result
     */
    reset() {
      this.result = !1;
    }
  };
  return CollectorWhile0.CollectorWhile0 = gA, CollectorWhile0;
}
var Signal$1 = {}, SignalConnection = {}, hasRequiredSignalConnection;
function requireSignalConnection() {
  if (hasRequiredSignalConnection) return SignalConnection;
  hasRequiredSignalConnection = 1, Object.defineProperty(SignalConnection, "__esModule", { value: !0 }), SignalConnection.SignalConnectionImpl = void 0;
  class CA {
    /**
     * @param link The actual link of the connection.
     */
    constructor(AA) {
      this.link = AA;
    }
    disconnect() {
      return this.link.unlink();
    }
    set enabled(AA) {
      this.link.setEnabled(AA);
    }
    get enabled() {
      return this.link.isEnabled();
    }
  }
  return SignalConnection.SignalConnectionImpl = CA, SignalConnection;
}
var SignalLink = {}, hasRequiredSignalLink;
function requireSignalLink() {
  if (hasRequiredSignalLink) return SignalLink;
  hasRequiredSignalLink = 1, Object.defineProperty(SignalLink, "__esModule", { value: !0 }), SignalLink.SignalLink = void 0;
  let CA = class pg {
    constructor(AA, IA, BA) {
      this.enabled = !0, this.newLink = !1, this.prev = AA ?? this, this.next = IA ?? this, this.order = BA.order, this.isPublic = BA.isPublic, this.callback = BA.callback, this.onUnlink = BA.onUnlink;
    }
    isEnabled() {
      return this.enabled && !this.newLink;
    }
    setEnabled(AA) {
      this.enabled = AA;
    }
    unlink() {
      return this.callback ? (delete this.callback, this.next.prev = this.prev, this.prev.next = this.next, this.onUnlink(), !0) : !1;
    }
    insert(AA) {
      const { order: IA } = AA;
      let BA = this.prev;
      for (; BA !== this && !(BA.order <= IA); )
        BA = BA.prev;
      const QA = new pg(BA, BA.next, AA);
      return BA.next = QA, QA.next.prev = QA, QA;
    }
  };
  return SignalLink.SignalLink = CA, SignalLink;
}
var hasRequiredSignal$1;
function requireSignal$1() {
  if (hasRequiredSignal$1) return Signal$1;
  hasRequiredSignal$1 = 1, Object.defineProperty(Signal$1, "__esModule", { value: !0 }), Signal$1.Signal = void 0;
  const CA = requireSignalConnection(), gA = requireSignalLink(), AA = { order: 0, isPublic: !0, onUnlink() {
  } };
  class IA {
    constructor() {
      this.head = new gA.SignalLink(null, null, AA), this.hasNewLinks = !1, this.emitDepth = 0, this.connectionsCount = 0, this.onUnlink = () => {
        this.connectionsCount--;
      };
    }
    /**
     * @returns The number of connections on this signal.
     */
    getConnectionsCount() {
      return this.connectionsCount;
    }
    /**
     * @returns true if this signal has connections.
     */
    hasConnections() {
      return this.connectionsCount > 0;
    }
    /**
     * Subscribe to this signal.
     *
     * @param callback This callback will be run when emit() is called.
     * @param options Configure options for the connection
     */
    connect(QA, { order: EA = 0, isPublic: iA = !0 } = {}) {
      this.connectionsCount++;
      const oA = this.head.insert({ callback: QA, order: EA, isPublic: iA, onUnlink: this.onUnlink });
      return this.emitDepth > 0 && (this.hasNewLinks = !0, oA.newLink = !0), new CA.SignalConnectionImpl(oA);
    }
    /**
     * Unsubscribe from this signal with the original callback instance.
     * While you can use this method, the SignalConnection returned by connect() will not be updated!
     *
     * @param callback The callback you passed to connect().
     */
    disconnect(QA) {
      for (let EA = this.head.next; EA !== this.head; EA = EA.next)
        if (EA.callback === QA)
          return EA.unlink(), !0;
      return !1;
    }
    /**
     * Disconnect all handlers from this signal event.
     */
    disconnectAll() {
      let { next: QA } = this.head;
      for (; QA !== this.head; )
        QA.isPublic && QA.unlink(), QA = QA.next;
    }
    /**
     * Publish this signal event (call all handlers).
     */
    emit(...QA) {
      this.emitDepth++;
      for (let EA = this.head.next; EA !== this.head; EA = EA.next)
        EA.isEnabled() && EA.callback && EA.callback.apply(null, QA);
      this.emitDepth--, this.unsetNewLink();
    }
    emitCollecting(QA, EA) {
      this.emitDepth++;
      for (let iA = this.head.next; iA !== this.head; iA = iA.next)
        if (iA.isEnabled() && iA.callback) {
          const oA = iA.callback.apply(null, EA);
          if (!QA.handleResult(oA))
            break;
        }
      this.emitDepth--, this.unsetNewLink();
    }
    unsetNewLink() {
      if (this.hasNewLinks && this.emitDepth === 0) {
        for (let QA = this.head.next; QA !== this.head; QA = QA.next)
          QA.newLink = !1;
        this.hasNewLinks = !1;
      }
    }
  }
  return Signal$1.Signal = IA, Signal$1;
}
var SignalConnections = {}, hasRequiredSignalConnections;
function requireSignalConnections() {
  if (hasRequiredSignalConnections) return SignalConnections;
  hasRequiredSignalConnections = 1, Object.defineProperty(SignalConnections, "__esModule", { value: !0 }), SignalConnections.SignalConnections = void 0;
  let CA = class {
    constructor() {
      this.list = [];
    }
    /**
     * Add a connection to the list.
     * @param connection
     */
    add(AA) {
      this.list.push(AA);
    }
    /**
     * Disconnect all connections in the list and empty the list.
     */
    disconnectAll() {
      for (const AA of this.list)
        AA.disconnect();
      this.list = [];
    }
    /**
     * @returns The number of connections in this list.
     */
    getCount() {
      return this.list.length;
    }
    /**
     * @returns true if this list is empty.
     */
    isEmpty() {
      return this.list.length === 0;
    }
  };
  return SignalConnections.SignalConnections = CA, SignalConnections;
}
var hasRequiredDist$1;
function requireDist$1() {
  return hasRequiredDist$1 || (hasRequiredDist$1 = 1, (function(CA) {
    Object.defineProperty(CA, "__esModule", { value: !0 }), CA.SignalConnections = CA.Signal = CA.CollectorWhile0 = CA.CollectorUntil0 = CA.CollectorLast = CA.CollectorArray = CA.Collector = void 0;
    var gA = requireCollector();
    Object.defineProperty(CA, "Collector", { enumerable: !0, get: function() {
      return gA.Collector;
    } });
    var AA = requireCollectorArray();
    Object.defineProperty(CA, "CollectorArray", { enumerable: !0, get: function() {
      return AA.CollectorArray;
    } });
    var IA = requireCollectorLast();
    Object.defineProperty(CA, "CollectorLast", { enumerable: !0, get: function() {
      return IA.CollectorLast;
    } });
    var BA = requireCollectorUntil0();
    Object.defineProperty(CA, "CollectorUntil0", { enumerable: !0, get: function() {
      return BA.CollectorUntil0;
    } });
    var QA = requireCollectorWhile0();
    Object.defineProperty(CA, "CollectorWhile0", { enumerable: !0, get: function() {
      return QA.CollectorWhile0;
    } });
    var EA = requireSignal$1();
    Object.defineProperty(CA, "Signal", { enumerable: !0, get: function() {
      return EA.Signal;
    } });
    var iA = requireSignalConnections();
    Object.defineProperty(CA, "SignalConnections", { enumerable: !0, get: function() {
      return iA.SignalConnections;
    } });
  })(dist$2)), dist$2;
}
var distExports = requireDist$1();
function createFormsData() {
  return {
    formsWithPendingChanges: /* @__PURE__ */ new Set(),
    formsWithUploads: /* @__PURE__ */ new Set(),
    submitButtons: /* @__PURE__ */ new Map()
  };
}
const LOG$9 = loglevelExports.getLogger("WidgetStateManager");
function microsToIsoString(CA, gA) {
  const AA = new Date(CA / 1e3).toISOString();
  switch (gA) {
    case "date":
      return AA.slice(0, 10);
    // "YYYY-MM-DD"
    case "time": {
      const IA = AA.slice(11, 19);
      return IA.endsWith(":00") ? IA.slice(0, 5) : IA;
    }
    case "datetime":
      return AA.slice(17, 19) === "00" ? AA.slice(0, 16) : AA.slice(0, 19);
  }
}
class WidgetStateDict {
  constructor() {
    this.widgetStates = /* @__PURE__ */ new Map();
  }
  /**
   * Create a new WidgetState proto for the widget with the given ID,
   * overwriting any that currently exists.
   */
  createState(gA) {
    const AA = new WidgetState({
      id: gA
    });
    return this.widgetStates.set(gA, AA), AA;
  }
  /** Return the WidgetState for the given widgetID if it exists. */
  getState(gA) {
    return this.widgetStates.get(gA);
  }
  /** Remove the WidgetState proto with the given id, if it exists. */
  deleteState(gA) {
    this.widgetStates.delete(gA);
  }
  /** Remove the state of widgets that are not contained in `activeIds`. */
  removeInactive(gA) {
    this.widgetStates.forEach((AA, IA) => {
      gA.has(IA) || this.widgetStates.delete(IA);
    });
  }
  /** Remove all widget states. */
  clear() {
    this.widgetStates.clear();
  }
  get isEmpty() {
    return this.widgetStates.size === 0;
  }
  createWidgetStatesMsg() {
    const gA = new WidgetStates();
    return this.widgetStates.forEach((AA) => gA.widgets.push(AA)), gA;
  }
  /**
   * Copy the contents of another WidgetStateDict into this one, overwriting
   * any values with duplicate keys.
   */
  copyFrom(gA) {
    gA.widgetStates.forEach((AA, IA) => {
      this.widgetStates.set(IA, AA);
    });
  }
  /** Call a function for each value in the dict. */
  forEach(gA) {
    this.widgetStates.forEach(gA);
  }
}
class FormState {
  constructor() {
    this.widgetStates = new WidgetStateDict(), this.clearOnSubmit = !1, this.enterToSubmit = !0, this.formCleared = new distExports.Signal();
  }
  /** True if the form has a non-empty WidgetStateDict. */
  get hasPendingChanges() {
    return !this.widgetStates.isEmpty;
  }
}
class WidgetStateManager {
  constructor(gA) {
    this.widgetStates = new WidgetStateDict(), this.forms = /* @__PURE__ */ new Map(), this.elementStates = /* @__PURE__ */ new Map(), this.pendingTriggerIds = /* @__PURE__ */ new Set(), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.hasFragmentIdConflict = !1, this.boundWidgets = /* @__PURE__ */ new Map(), this.paramKeyToWidgetId = /* @__PURE__ */ new Map(), this.props = gA, this.formsData = createFormsData();
  }
  /**
   * Register a function that will be called when the given form is cleared.
   * Returns an object that can be used to de-register the listener.
   */
  addFormClearedListener(gA, AA) {
    return this.getOrCreateFormState(gA).formCleared.connect(AA);
  }
  /**
   * Register a Form, and assign its clearOnSubmit & enterToSubmit values.
   * The `Form` element calls this when it's first mounted.
   */
  setFormSubmitBehaviors(gA, AA, IA = !0) {
    const BA = this.getOrCreateFormState(gA);
    BA.clearOnSubmit = AA, BA.enterToSubmit = IA;
  }
  /**
   * Commit pending changes for widgets that belong to the given form,
   * and send a rerunBackMsg to the server.
   */
  submitForm(gA, AA, IA) {
    if (!isValidFormId(gA))
      throw new Error(`invalid formID '${gA}'`);
    const BA = this.getOrCreateFormState(gA), QA = this.formsData.submitButtons.get(gA);
    let EA;
    IA !== void 0 ? EA = IA : QA !== void 0 && QA.length > 0 && (EA = QA[0]), EA && (this.createWidgetState(EA, {
      fromUi: !0
    }).triggerValue = !0), this.widgetStates.copyFrom(BA.widgetStates), BA.widgetStates.clear(), this.sendUpdateWidgetsMessage(AA), this.syncFormsWithPendingChanges(), EA && this.deleteWidgetState(EA.id), BA.clearOnSubmit && BA.formCleared.emit();
  }
  setChatInputValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).chatInputValue = new ChatInputValue(AA), this.pendingTriggerIds.add(gA.id), this.scheduleFlush(BA);
  }
  /**
   * Sets a string trigger value for a widget. String trigger values behave
   * like boolean triggers - they are sent to the backend once and then
   * auto-reset to null after each script run. Use this for trigger-based
   * widgets that need to return a string value (e.g., menu button selections).
   */
  setStringTriggerValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).stringTriggerValue = new StringTriggerValue({
      data: AA
    }), this.pendingTriggerIds.add(gA.id), this.scheduleFlush(BA);
  }
  /**
   * 1. Boolean trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId)
   *
   * 2. Payload (JSON-encoded) trigger
   *    setTriggerValue(widgetInfo, { fromUi: true }, fragmentId, payload)
   *
   *    `payload` can be any JSON-serialisable value. For Bidi Component v2
   *    we always transport payloads via the protobuf `json_trigger_value`
   *    field as a JSON-stringified array of payload objects. Multiple calls
   *    within the same macrotask are batched into that array. If `payload`
   *    is omitted (or `undefined`) we fall back to the boolean
   *    `trigger_value=true` behaviour.
   */
  setTriggerValue(gA, AA, IA, BA) {
    let QA = this.getWidgetState(gA);
    if (QA === void 0 && (QA = this.createWidgetState(gA, AA)), BA === void 0)
      QA.triggerValue = !0;
    else {
      const EA = BA;
      try {
        if (isNullOrUndefined$1(QA.jsonTriggerValue))
          QA.jsonTriggerValue = JSON.stringify([EA]);
        else {
          const iA = QA.jsonTriggerValue, oA = JSON.parse(iA), cA = Array.isArray(oA) ? oA : [oA];
          cA.push(EA), QA.jsonTriggerValue = JSON.stringify(cA);
        }
      } catch (iA) {
        LOG$9.error("Failed to parse or stringify widgetState.jsonTriggerValue:", iA), QA.jsonTriggerValue = JSON.stringify([QA.jsonTriggerValue, EA]);
      }
    }
    return this.pendingTriggerIds.add(gA.id), new Promise((EA) => {
      this.triggerFlushResolvers.push(EA), this.scheduleFlush(IA);
    });
  }
  getBoolValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "boolValue")
      return AA.boolValue;
  }
  setBoolValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).boolValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  getIntValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "intValue")
      return requireNumberInt(AA.intValue);
  }
  setIntValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).intValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  getDoubleValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "doubleValue")
      return AA.doubleValue;
  }
  setDoubleValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).doubleValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  getStringValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "stringValue")
      return AA.stringValue;
  }
  setStringValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).stringValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  setStringArrayValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).stringArrayValue = new StringArray({
      data: AA
    }), this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  getStringArrayValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "stringArrayValue" && notNullOrUndefined(AA.stringArrayValue) && notNullOrUndefined(AA.stringArrayValue.data))
      return AA.stringArrayValue.data;
  }
  getDoubleArrayValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "doubleArrayValue" && notNullOrUndefined(AA.doubleArrayValue) && notNullOrUndefined(AA.doubleArrayValue.data))
      return AA.doubleArrayValue.data;
  }
  setDoubleArrayValue(gA, AA, IA, BA) {
    const QA = AA.filter((EA) => EA != null && !Number.isNaN(EA));
    if (QA.length === 0) {
      LOG$9.warn(`setDoubleArrayValue: All values were invalid (NaN/null/undefined) for widget "${gA.id}". Preserving previous state.`), this.maybeSyncValueToUrl(gA.id, IA, []);
      return;
    }
    this.createWidgetState(gA, IA).doubleArrayValue = new DoubleArray({
      data: QA
    }), this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, QA);
  }
  getIntArrayValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "intArrayValue" && notNullOrUndefined(AA.intArrayValue) && notNullOrUndefined(AA.intArrayValue.data))
      return AA.intArrayValue.data.map(requireNumberInt);
  }
  setIntArrayValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).intArrayValue = new SInt64Array({
      data: AA
    }), this.onWidgetValueChanged(gA.formId, IA, BA), this.maybeSyncValueToUrl(gA.id, IA, AA);
  }
  getJsonValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "jsonValue")
      return AA.jsonValue;
  }
  setJsonValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).jsonValue = JSON.stringify(AA), this.onWidgetValueChanged(gA.formId, IA, BA);
  }
  setArrowValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).arrowValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA);
  }
  getArrowValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "arrowValue" && notNullOrUndefined(AA.arrowValue))
      return AA.arrowValue;
  }
  setBytesValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).bytesValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA);
  }
  getBytesValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "bytesValue")
      return AA.bytesValue;
  }
  setFileUploaderStateValue(gA, AA, IA, BA) {
    this.createWidgetState(gA, IA).fileUploaderStateValue = AA, this.onWidgetValueChanged(gA.formId, IA, BA);
  }
  getFileUploaderStateValue(gA) {
    const AA = this.getWidgetState(gA);
    if (notNullOrUndefined(AA) && AA.value === "fileUploaderStateValue")
      return AA.fileUploaderStateValue;
  }
  /**
   * Perform housekeeping every time a widget value changes.
   * - If the widget does not belong to a form, and the value update came from
   *   a user action, send the "updateWidgets" message
   * - If the widget belongs to a form, dispatch the "pendingFormsChanged"
   *   callback if needed.
   *
   * Called by every "setValue" function.
   */
  onWidgetValueChanged(gA, AA, IA) {
    isValidFormId(gA) ? this.syncFormsWithPendingChanges() : AA.fromUi && this.scheduleFlush(IA);
  }
  /**
   * Update FormsData.formsWithPendingChanges with the current set of forms
   * that have pending changes. This is called after widget values are updated.
   */
  syncFormsWithPendingChanges() {
    const gA = /* @__PURE__ */ new Set();
    this.forms.forEach((AA, IA) => {
      AA.hasPendingChanges && gA.add(IA);
    }), this.updateFormsData((AA) => {
      AA.formsWithPendingChanges = gA;
    });
  }
  sendUpdateWidgetsMessage(gA, AA = void 0) {
    this.props.sendRerunBackMsg(this.widgetStates.createWidgetStatesMsg(), gA, void 0, AA);
  }
  getActiveWidgetStates(gA) {
    const AA = new WidgetStates();
    return this.widgetStates.forEach((IA) => {
      gA.has(IA.id) && AA.widgets.push(IA);
    }), AA;
  }
  /**
   * Remove the state of widgets that are not contained in `activeIds`.
   * This is called when a script finishes running, so that we don't retain
   * data for widgets that have been removed from the app.
   */
  removeInactive(gA) {
    this.widgetStates.removeInactive(gA), this.forms.forEach((AA) => AA.widgetStates.removeInactive(gA)), this.elementStates.forEach((AA, IA) => {
      gA.has(IA) || this.deleteElementState(IA);
    });
  }
  /**
   * Create and return a new WidgetState proto for the given widget ID,
   * overwriting any that currently exists. If the widget belongs to a form,
   * the WidgetState will be created inside the form's WidgetStateDict.
   */
  createWidgetState(gA, AA) {
    return (isValidFormId(gA.formId) && AA.fromUi ? this.getOrCreateFormState(gA.formId).widgetStates : this.widgetStates).createState(gA.id);
  }
  /**
   * Get the WidgetState proto for the given widget ID, if it exists.
   */
  getWidgetState(gA) {
    if (isValidFormId(gA.formId)) {
      const AA = this.forms.get(gA.formId)?.widgetStates.getState(gA.id);
      if (notNullOrUndefined(AA))
        return AA;
    }
    return this.widgetStates.getState(gA.id);
  }
  /**
   * Remove the WidgetState proto with the given id, if it exists
   */
  deleteWidgetState(gA) {
    this.widgetStates.deleteState(gA);
  }
  /** Return the FormState for the given form. Create it if it doesn't exist. */
  getOrCreateFormState(gA) {
    let AA = this.forms.get(gA);
    return notNullOrUndefined(AA) || (AA = new FormState(), this.forms.set(gA, AA)), AA;
  }
  /** Store the IDs of all forms with in-progress uploads. */
  setFormsWithUploadsInProgress(gA) {
    this.updateFormsData((AA) => {
      AA.formsWithUploads = gA;
    });
  }
  /**
   * Helper function to determine whether a form allows enter to submit
   * for input elements (st.number_input, st.text_input, etc.)
   * If in form, checks form's enterToSubmit paramf first, otherwise default
   * behavior: Must have 1st submit button enabled to allow
   */
  allowFormEnterToSubmit(gA) {
    if (!isValidFormId(gA)) return !1;
    const AA = this.forms.get(gA);
    if (AA && !AA.enterToSubmit) return !1;
    const BA = this.formsData.submitButtons.get(gA)?.[0];
    return BA ? !BA.disabled : !1;
  }
  /**
   * Called by FormSubmitButton on creation. Add the SubmitButtonProto for
   * the given form and update FormsData.
   */
  addSubmitButton(gA, AA) {
    const IA = this.formsData.submitButtons.get(gA);
    if (IA === void 0)
      this.setSubmitButtons(gA, [AA]);
    else {
      const BA = Object.assign([], IA);
      BA.push(AA), this.setSubmitButtons(gA, BA);
    }
  }
  /**
   * Called by FormSubmitButton on creation. Remove the SubmitButtonProto for
   * the given form, and update FormsData.
   */
  removeSubmitButton(gA, AA) {
    const IA = this.formsData.submitButtons.get(gA);
    if (IA !== void 0) {
      const BA = Object.assign([], IA), QA = BA.indexOf(AA, 0);
      QA > -1 && BA.splice(QA, 1), this.setSubmitButtons(gA, BA);
    }
  }
  setSubmitButtons(gA, AA) {
    if (AA.length < 0)
      throw new Error(`Bad submitButtons length ${AA.length} (must be >= 0)`);
    this.updateFormsData((IA) => {
      IA.submitButtons.set(gA, AA);
    });
  }
  /**
   * Produce a new FormsData with the given recipe, and fire off the
   * formsDataChanged callback with that new data.
   */
  updateFormsData(gA) {
    const AA = produce(this.formsData, gA);
    this.formsData !== AA && (this.formsData = AA, this.props.formsDataChanged(this.formsData));
  }
  /**
   * Get the element state value for the given element ID and key, if it exists.
   * This is a frontend-only state that is never sent to the server.
   */
  getElementState(gA, AA) {
    return this.elementStates.get(gA)?.get(AA);
  }
  /**
   * Sets the state of an element identified by its ID and its key.
   * This is a frontend-only state that is never sent to the server.
   * It can be used to store element state to restore the state
   * of an element in situations where an element is removed and re-added.
   *
   * @param {string} elementId - The unique identifier of the element.
   * @param {string} key - The key to set
   * @param {unknown} value - The value to set for the element's state.
   * @returns {void}
   */
  setElementState(gA, AA, IA) {
    this.elementStates.has(gA) || this.elementStates.set(gA, /* @__PURE__ */ new Map());
    const BA = this.elementStates.get(gA);
    BA && BA.set(AA, IA);
  }
  /**
   * Deletes the state associated with a specific element by ID. If a key is provided,
   * only the state corresponding to that key is removed. If no key is specified, all states
   * associated with the element ID are removed.
   */
  deleteElementState(gA, AA) {
    notNullOrUndefined(AA) ? this.elementStates.get(gA)?.delete(AA) : this.elementStates.delete(gA);
  }
  /**
   * Schedule a macrotask-level flush of pending widget updates (triggers and
   * regular value changes). Multiple calls within the same macrotask will be
   * coalesced into a single `updateWidgets` message.
   */
  scheduleFlush(gA) {
    this.scheduledFragmentId === void 0 && (this.scheduledFragmentId = gA), this.scheduledFragmentId !== void 0 && gA !== void 0 && gA !== this.scheduledFragmentId && !this.hasFragmentIdConflict && (LOG$9.warn("Unexpected state: Multiple different fragmentIds detected in a single batch of widget updates. Proceeding with flushing updates using fragmentId '%s' for this batch.", this.scheduledFragmentId), this.hasFragmentIdConflict = !0), !this.flushScheduled && (this.flushScheduled = !0, setTimeout(() => {
      this.sendUpdateWidgetsMessage(this.scheduledFragmentId), this.pendingTriggerIds.forEach((AA) => this.deleteWidgetState(AA)), this.pendingTriggerIds.clear(), this.triggerFlushResolvers.forEach((AA) => AA()), this.triggerFlushResolvers = [], this.flushScheduled = !1, this.scheduledFragmentId = void 0, this.hasFragmentIdConflict = !1;
    }, 0));
  }
  // Query Param Binding Methods
  /**
   * Register a widget's binding to a URL query parameter.
   *
   * If another widget was previously bound to this paramKey, its binding is
   * replaced and the old widget's entry in boundWidgets is cleaned up. This
   * mirrors the backend behavior in QueryParams.bind_widget() which also
   * handles duplicate paramKey cleanup.
   *
   * @param clearable - Whether the widget allows clearing to empty state.
   *   Required - widget components must explicitly pass this based on their UI behavior.
   */
  registerQueryParamBinding(gA, AA, IA, BA, QA, EA, iA) {
    const oA = this.paramKeyToWidgetId.get(AA);
    oA && oA !== gA && this.boundWidgets.delete(oA);
    let cA = BA;
    iA && (Array.isArray(cA) ? cA = cA.map((tA) => typeof tA == "number" ? microsToIsoString(tA, iA) : String(tA)) : typeof cA == "number" && (cA = microsToIsoString(cA, iA))), this.boundWidgets.set(gA, {
      paramKey: AA,
      valueType: IA,
      defaultValue: cA,
      urlFormat: EA,
      clearable: QA,
      dateType: iA
    }), this.paramKeyToWidgetId.set(AA, gA);
  }
  /**
   * Unregister a widget's query param binding (called on unmount).
   *
   * Note: This does NOT clear the URL param - that cleanup is handled by the
   * backend via remove_stale_bindings().
   */
  unregisterQueryParamBinding(gA) {
    const AA = this.boundWidgets.get(gA);
    AA && (this.paramKeyToWidgetId.delete(AA.paramKey), this.boundWidgets.delete(gA));
  }
  /** Check if a widget has a query param binding. */
  hasQueryParamBinding(gA) {
    return this.boundWidgets.has(gA);
  }
  /**
   * Filter query params for page navigation.
   * Preserves embed params and params bound to widgets, clears all others.
   *
   * @param embedParams - The embed query params string (from preserveEmbedQueryParams)
   * @returns Filtered query string with embed + bound widget params
   */
  filterParamsForPageChange(gA) {
    if (this.paramKeyToWidgetId.size === 0)
      return gA;
    const AA = new URL(window.location.href), IA = {};
    this.paramKeyToWidgetId.forEach((QA, EA) => {
      const iA = AA.searchParams.getAll(EA);
      iA.length === 1 ? IA[EA] = iA[0] : iA.length > 1 && (IA[EA] = iA);
    });
    const BA = queryString.stringify(IA, {
      arrayFormat: "none"
    });
    return BA ? gA ? `${gA}&${BA}` : BA : gA;
  }
  /** Set callback for query param changes (used by App.tsx). */
  setQueryParamsChangeHandler(gA) {
    this.onQueryParamsChange = gA;
  }
  /** Notify listener of URL query param changes. */
  notifyQueryParamsChange() {
    if (this.onQueryParamsChange) {
      const gA = new URL(window.location.href);
      this.onQueryParamsChange(gA.searchParams.toString());
    }
  }
  /**
   * Convert widget value to URL-safe format based on binding type.
   * Returns null to indicate the param should be removed from URL.
   * Returns "" or [] to indicate an empty value that should be preserved as ?foo=
   */
  convertToUrlValue(gA, AA) {
    if (gA === null)
      return this.isEmptyValueValid(AA) ? "" : null;
    switch (AA.valueType) {
      case "bool_value":
        return String(gA);
      case "double_value":
        return String(gA);
      case "int_value":
        return String(gA);
      case "string_value":
        return gA;
      case "string_array_value":
        return gA.filter((IA) => IA !== "");
      case "int_array_value":
        return gA.map((IA) => String(IA));
      case "double_array_value": {
        const IA = gA;
        if (AA.dateType) {
          const BA = AA.dateType;
          return IA.map((QA) => microsToIsoString(QA, BA));
        }
        return IA.map((BA) => String(BA));
      }
      default:
        return assertNever(AA.valueType);
    }
  }
  /**
   * Check if empty/cleared is a valid state for this widget.
   * Used to determine whether to write ?foo= (empty value) or remove the param entirely.
   *
   * Returns binding.clearable, which is explicitly set by each widget component.
   */
  isEmptyValueValid(gA) {
    return gA.clearable;
  }
  /**
   * Check if value should clear the URL param (remove it from URL entirely).
   *
   * Returns true to indicate the param should be removed when:
   * - Empty value AND empty is not valid for this widget
   * - Empty value AND empty equals the widget's default (hide at default)
   * - Non-empty value matches the widget's default
   *
   * When empty IS valid AND differs from default (e.g., multiselect with
   * default=["Python"] cleared to []), we preserve ?foo= in the URL.
   */
  shouldClearUrlParam(gA, AA) {
    return (gA === null || Array.isArray(gA) && gA.length === 0 || gA === "") && !this.isEmptyValueValid(AA) ? !0 : Array.isArray(gA) ? this.isDefaultArrayValue(gA, AA) : this.isDefaultValue(gA, AA);
  }
  /**
   * Update a single URL parameter using query-string library.
   * Handles both scalar and array values, respecting urlFormat setting.
   */
  updateUrlParam(gA, AA, IA) {
    const BA = queryString.parse(window.location.search, {
      arrayFormat: "none"
    });
    AA === null ? delete BA[gA] : Array.isArray(AA) ? AA.length === 0 ? BA[gA] = "" : IA === "comma" ? BA[gA] = AA.join(",") : BA[gA] = AA : BA[gA] = AA;
    const QA = queryString.stringify(BA, {
      arrayFormat: "none",
      skipNull: !0,
      skipEmptyString: !1
    }), EA = window.location.search.replace(/^\?/, "");
    if (QA === EA)
      return;
    const iA = new URL(window.location.href);
    iA.search = QA, window.history.replaceState({}, "", iA.toString()), this.notifyQueryParamsChange();
  }
  /**
   * Sync widget value to URL if bound and change is from UI.
   * Orchestrates pure conversion and side-effect URL update.
   */
  maybeSyncValueToUrl(gA, AA, IA) {
    if (!AA.fromUi) return;
    const BA = this.boundWidgets.get(gA);
    if (!BA) return;
    const QA = this.convertToUrlValue(IA, BA), EA = this.shouldClearUrlParam(QA, BA);
    this.updateUrlParam(BA.paramKey, EA ? null : QA, BA.urlFormat);
  }
  /**
   * Convert a value to its URL-comparable string form.
   * Handles primitives (string, number, boolean) and Date objects.
   * Date is formatted as local-time ISO (YYYY-MM-DD) to match the wire
   * format used by date_input URL values.
   * @returns The string representation, or undefined for unsupported types.
   */
  toStringPrimitive(gA) {
    if (typeof gA == "string" || typeof gA == "number" || typeof gA == "boolean")
      return String(gA);
    if (gA instanceof Date) {
      const AA = gA.getFullYear(), IA = String(gA.getMonth() + 1).padStart(2, "0"), BA = String(gA.getDate()).padStart(2, "0");
      return `${AA}-${IA}-${BA}`;
    }
  }
  /**
   * Check if value equals the widget's default (with type coercion).
   *
   * Note: For clearable scalar widgets, convertToUrlValue(null) returns "".
   * If such a widget has an empty array default (unusual), "" should match [].
   */
  isDefaultValue(gA, AA) {
    const IA = AA.defaultValue;
    if (isNullOrUndefined$1(IA))
      return isNullOrUndefined$1(gA) || gA === "";
    if (gA === "" && Array.isArray(IA) && IA.length === 0)
      return !0;
    const BA = this.toStringPrimitive(gA), QA = this.toStringPrimitive(IA);
    return BA === void 0 || QA === void 0 ? !1 : BA === QA;
  }
  /**
   * Check if array equals the widget's default array (with type coercion).
   *
   * Handles edge cases where the widget's default may be a scalar but the
   * current value is an array (e.g., slider with value=[5] and defaultValue=5).
   *
   * Note: For widgets that allow clearing (clearable=true), empty arrays that
   * differ from default are handled by shouldClearUrlParam before this is called.
   */
  isDefaultArrayValue(gA, AA) {
    const IA = AA.defaultValue;
    if (!Array.isArray(IA)) {
      if (gA.length === 1 && IA !== null) {
        const BA = this.toStringPrimitive(IA);
        return BA !== void 0 && gA[0] === BA;
      }
      return !1;
    }
    return gA.length !== IA.length ? !1 : gA.every((BA, QA) => {
      const EA = this.toStringPrimitive(IA[QA]);
      return EA !== void 0 && BA === EA;
    });
  }
}
function requireNumberInt(CA) {
  if (typeof CA == "number")
    return CA;
  const gA = protobufjsExports.util.LongBits.from(CA).toNumber();
  if (Number.isSafeInteger(gA))
    return gA;
  throw new Error(
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions -- TODO: Fix this
    `value ${CA} cannot be converted to number without a loss of precision!`
  );
}
class ReactHotkeys extends React__default.Component {
  constructor(gA) {
    super(gA), this.isKeyDown = !1, this.handle = void 0, this.onKeyDown = this.onKeyDown.bind(this), this.onKeyUp = this.onKeyUp.bind(this), this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this), this.handle = {};
  }
  componentDidMount() {
    var {
      filter: gA,
      splitKey: AA
    } = this.props;
    gA && (hotkeys.filter = gA), hotkeys.unbind(this.props.keyName), hotkeys(this.props.keyName, {
      splitKey: AA
    }, this.onKeyDown), document && document.body.addEventListener("keyup", this.handleKeyUpEvent);
  }
  componentWillUnmount() {
    hotkeys.unbind(this.props.keyName), this.isKeyDown = !0, this.handle = {}, document && document.body.removeEventListener("keyup", this.handleKeyUpEvent);
  }
  onKeyUp(gA, AA) {
    var {
      onKeyUp: IA,
      disabled: BA
    } = this.props;
    !BA && IA && IA(AA.shortcut, gA, AA);
  }
  onKeyDown(gA, AA) {
    var {
      onKeyDown: IA,
      allowRepeat: BA,
      disabled: QA
    } = this.props;
    this.isKeyDown && !BA || (this.isKeyDown = !0, this.handle = AA, !QA && IA && IA(AA.shortcut, gA, AA));
  }
  handleKeyUpEvent(gA) {
    this.isKeyDown && (this.isKeyDown = !1, !(this.props.keyName && this.props.keyName.indexOf(this.handle.shortcut) < 0) && (this.onKeyUp(gA, this.handle), this.handle = {}));
  }
  render() {
    return this.props.children || null;
  }
}
ReactHotkeys.defaultProps = {
  filter(CA) {
    var gA = CA.target || CA.srcElement, AA = gA.tagName;
    return !(gA.isContentEditable || AA === "INPUT" || AA === "SELECT" || AA === "TEXTAREA");
  }
};
ReactHotkeys.propTypes = {
  keyName: propTypesExports.string,
  filter: propTypesExports.func,
  onKeyDown: propTypesExports.func,
  onKeyUp: propTypesExports.func,
  disabled: propTypesExports.bool,
  splitKey: propTypesExports.string
};
var e$1 = Object.create, t = Object.defineProperty, n$1 = Object.getOwnPropertyDescriptor, r$3 = Object.getOwnPropertyNames, i$2 = Object.getPrototypeOf, a$1 = Object.prototype.hasOwnProperty, o = (CA, gA) => () => (gA || CA((gA = {
  exports: {}
}).exports, gA), gA.exports), c$1 = (CA, gA, AA, IA) => {
  if (gA && typeof gA == "object" || typeof gA == "function") for (var BA = r$3(gA), QA = 0, EA = BA.length, iA; QA < EA; QA++) iA = BA[QA], !a$1.call(CA, iA) && iA !== AA && t(CA, iA, {
    get: ((oA) => gA[oA]).bind(null, iA),
    enumerable: !(IA = n$1(gA, iA)) || IA.enumerable
  });
  return CA;
}, l = (CA, gA, AA) => (AA = CA == null ? {} : e$1(i$2(CA)), c$1(t(AA, "default", {
  value: CA,
  enumerable: !0
}), CA)), require_loglevel = /* @__PURE__ */ o((CA, gA) => {
  (function(AA, IA) {
    typeof define == "function" && define.amd ? define(IA) : typeof gA == "object" && gA.exports ? gA.exports = IA() : AA.log = IA();
  })(CA, function() {
    var AA = function() {
    }, IA = "undefined", BA = typeof window !== IA && typeof window.navigator !== IA && /Trident\/|MSIE /.test(window.navigator.userAgent), QA = ["trace", "debug", "info", "warn", "error"], EA = {}, iA = null;
    function oA(DA, hA) {
      var wA = DA[hA];
      if (typeof wA.bind == "function") return wA.bind(DA);
      try {
        return Function.prototype.bind.call(wA, DA);
      } catch {
        return function() {
          return Function.prototype.apply.apply(wA, [DA, arguments]);
        };
      }
    }
    function cA() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function tA(DA) {
      return DA === "debug" && (DA = "log"), typeof console === IA ? !1 : DA === "trace" && BA ? cA : console[DA] === void 0 ? console.log === void 0 ? AA : oA(console, "log") : oA(console, DA);
    }
    function eA() {
      for (var DA = this.getLevel(), hA = 0; hA < QA.length; hA++) {
        var wA = QA[hA];
        this[wA] = hA < DA ? AA : this.methodFactory(wA, DA, this.name);
      }
      if (this.log = this.debug, typeof console === IA && DA < this.levels.SILENT) return "No console available for logging";
    }
    function aA(DA) {
      return function() {
        typeof console !== IA && (eA.call(this), this[DA].apply(this, arguments));
      };
    }
    function GA(DA, hA, wA) {
      return tA(DA) || aA.apply(this, arguments);
    }
    function lA(DA, hA) {
      var wA = this, sA, NA, rA, yA = "loglevel";
      typeof DA == "string" ? yA += ":" + DA : typeof DA == "symbol" && (yA = void 0);
      function bA(pA) {
        var YA = (QA[pA] || "silent").toUpperCase();
        if (!(typeof window === IA || !yA)) {
          try {
            window.localStorage[yA] = YA;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(yA) + "=" + YA + ";";
          } catch {
          }
        }
      }
      function RA() {
        var pA;
        if (!(typeof window === IA || !yA)) {
          try {
            pA = window.localStorage[yA];
          } catch {
          }
          if (typeof pA === IA) try {
            var YA = window.document.cookie, SA = encodeURIComponent(yA), JA = YA.indexOf(SA + "=");
            JA !== -1 && (pA = /^([^;]+)/.exec(YA.slice(JA + SA.length + 1))[1]);
          } catch {
          }
          return wA.levels[pA] === void 0 && (pA = void 0), pA;
        }
      }
      function FA() {
        if (!(typeof window === IA || !yA)) {
          try {
            window.localStorage.removeItem(yA);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(yA) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function dA(pA) {
        var YA = pA;
        if (typeof YA == "string" && wA.levels[YA.toUpperCase()] !== void 0 && (YA = wA.levels[YA.toUpperCase()]), typeof YA == "number" && YA >= 0 && YA <= wA.levels.SILENT) return YA;
        throw TypeError("log.setLevel() called with invalid level: " + pA);
      }
      wA.name = DA, wA.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, wA.methodFactory = hA || GA, wA.getLevel = function() {
        return rA ?? NA ?? sA;
      }, wA.setLevel = function(pA, YA) {
        return rA = dA(pA), YA !== !1 && bA(rA), eA.call(wA);
      }, wA.setDefaultLevel = function(pA) {
        NA = dA(pA), RA() || wA.setLevel(pA, !1);
      }, wA.resetLevel = function() {
        rA = null, FA(), eA.call(wA);
      }, wA.enableAll = function(pA) {
        wA.setLevel(wA.levels.TRACE, pA);
      }, wA.disableAll = function(pA) {
        wA.setLevel(wA.levels.SILENT, pA);
      }, wA.rebuild = function() {
        if (iA !== wA && (sA = dA(iA.getLevel())), eA.call(wA), iA === wA) for (var pA in EA) EA[pA].rebuild();
      }, sA = dA(iA ? iA.getLevel() : "WARN");
      var kA = RA();
      kA != null && (rA = dA(kA)), eA.call(wA);
    }
    iA = new lA(), iA.getLogger = function(DA) {
      if (typeof DA != "symbol" && typeof DA != "string" || DA === "") throw TypeError("You must supply a name when creating a logger.");
      var hA = EA[DA];
      return hA ||= EA[DA] = new lA(DA, iA.methodFactory), hA;
    };
    var nA = typeof window === IA ? void 0 : window.log;
    return iA.noConflict = function() {
      return typeof window !== IA && window.log === iA && (window.log = nA), iA;
    }, iA.getLoggers = function() {
      return EA;
    }, iA.default = iA, iA;
  });
}), import_loglevel = require_loglevel(), ConnectionState$1 = /* @__PURE__ */ (function(CA) {
  return CA.CONNECTED = "CONNECTED", CA.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", CA.INITIAL = "INITIAL", CA.PINGING_SERVER = "PINGING_SERVER", CA.CONNECTING = "CONNECTING", CA.STATIC_CONNECTING = "STATIC_CONNECTING", CA.STATIC_CONNECTED = "STATIC_CONNECTED", CA;
})({}), require_aspromise = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = AA;
  function AA(IA, BA) {
    for (var QA = Array(arguments.length - 1), EA = 0, iA = 2, oA = !0; iA < arguments.length; ) QA[EA++] = arguments[iA++];
    return new Promise(function(cA, tA) {
      QA[EA] = function(eA) {
        if (oA) if (oA = !1, eA) tA(eA);
        else {
          for (var aA = Array(arguments.length - 1), GA = 0; GA < aA.length; ) aA[GA++] = arguments[GA];
          cA.apply(null, aA);
        }
      };
      try {
        IA.apply(BA || null, QA);
      } catch (eA) {
        oA && (oA = !1, tA(eA));
      }
    });
  }
}), require_base64 = /* @__PURE__ */ o((CA) => {
  var gA = CA;
  gA.length = function(EA) {
    var iA = EA.length;
    if (!iA) return 0;
    for (var oA = 0; --iA % 4 > 1 && EA.charAt(iA) === "="; ) ++oA;
    return Math.ceil(EA.length * 3) / 4 - oA;
  };
  for (var AA = Array(64), IA = Array(123), BA = 0; BA < 64; ) IA[AA[BA] = BA < 26 ? BA + 65 : BA < 52 ? BA + 71 : BA < 62 ? BA - 4 : BA - 59 | 43] = BA++;
  gA.encode = function(EA, iA, oA) {
    for (var cA = null, tA = [], eA = 0, aA = 0, GA; iA < oA; ) {
      var lA = EA[iA++];
      switch (aA) {
        case 0:
          tA[eA++] = AA[lA >> 2], GA = (lA & 3) << 4, aA = 1;
          break;
        case 1:
          tA[eA++] = AA[GA | lA >> 4], GA = (lA & 15) << 2, aA = 2;
          break;
        case 2:
          tA[eA++] = AA[GA | lA >> 6], tA[eA++] = AA[lA & 63], aA = 0;
          break;
      }
      eA > 8191 && ((cA ||= []).push(String.fromCharCode.apply(String, tA)), eA = 0);
    }
    return aA && (tA[eA++] = AA[GA], tA[eA++] = 61, aA === 1 && (tA[eA++] = 61)), cA ? (eA && cA.push(String.fromCharCode.apply(String, tA.slice(0, eA))), cA.join("")) : String.fromCharCode.apply(String, tA.slice(0, eA));
  };
  var QA = "invalid encoding";
  gA.decode = function(EA, iA, oA) {
    for (var cA = oA, tA = 0, eA, aA = 0; aA < EA.length; ) {
      var GA = EA.charCodeAt(aA++);
      if (GA === 61 && tA > 1) break;
      if ((GA = IA[GA]) === void 0) throw Error(QA);
      switch (tA) {
        case 0:
          eA = GA, tA = 1;
          break;
        case 1:
          iA[oA++] = eA << 2 | (GA & 48) >> 4, eA = GA, tA = 2;
          break;
        case 2:
          iA[oA++] = (eA & 15) << 4 | (GA & 60) >> 2, eA = GA, tA = 3;
          break;
        case 3:
          iA[oA++] = (eA & 3) << 6 | GA, tA = 0;
          break;
      }
    }
    if (tA === 1) throw Error(QA);
    return oA - cA;
  }, gA.test = function(EA) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(EA);
  };
}), require_eventemitter = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = AA;
  function AA() {
    this._listeners = {};
  }
  AA.prototype.on = function(IA, BA, QA) {
    return (this._listeners[IA] || (this._listeners[IA] = [])).push({ fn: BA, ctx: QA || this }), this;
  }, AA.prototype.off = function(IA, BA) {
    if (IA === void 0) this._listeners = {};
    else if (BA === void 0) this._listeners[IA] = [];
    else for (var QA = this._listeners[IA], EA = 0; EA < QA.length; ) QA[EA].fn === BA ? QA.splice(EA, 1) : ++EA;
    return this;
  }, AA.prototype.emit = function(IA) {
    var BA = this._listeners[IA];
    if (BA) {
      for (var QA = [], EA = 1; EA < arguments.length; ) QA.push(arguments[EA++]);
      for (EA = 0; EA < BA.length; ) BA[EA].fn.apply(BA[EA++].ctx, QA);
    }
    return this;
  };
}), require_float = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = AA(AA);
  function AA(iA) {
    return typeof Float32Array < "u" ? (function() {
      var oA = new Float32Array([-0]), cA = new Uint8Array(oA.buffer), tA = cA[3] === 128;
      function eA(nA, DA, hA) {
        oA[0] = nA, DA[hA] = cA[0], DA[hA + 1] = cA[1], DA[hA + 2] = cA[2], DA[hA + 3] = cA[3];
      }
      function aA(nA, DA, hA) {
        oA[0] = nA, DA[hA] = cA[3], DA[hA + 1] = cA[2], DA[hA + 2] = cA[1], DA[hA + 3] = cA[0];
      }
      iA.writeFloatLE = tA ? eA : aA, iA.writeFloatBE = tA ? aA : eA;
      function GA(nA, DA) {
        return cA[0] = nA[DA], cA[1] = nA[DA + 1], cA[2] = nA[DA + 2], cA[3] = nA[DA + 3], oA[0];
      }
      function lA(nA, DA) {
        return cA[3] = nA[DA], cA[2] = nA[DA + 1], cA[1] = nA[DA + 2], cA[0] = nA[DA + 3], oA[0];
      }
      iA.readFloatLE = tA ? GA : lA, iA.readFloatBE = tA ? lA : GA;
    })() : (function() {
      function oA(tA, eA, aA, GA) {
        var lA = +(eA < 0);
        if (lA && (eA = -eA), eA === 0) tA(1 / eA > 0 ? 0 : 2147483648, aA, GA);
        else if (isNaN(eA)) tA(2143289344, aA, GA);
        else if (eA > 34028234663852886e22) tA((lA << 31 | 2139095040) >>> 0, aA, GA);
        else if (eA < 11754943508222875e-54) tA((lA << 31 | Math.round(eA / 1401298464324817e-60)) >>> 0, aA, GA);
        else {
          var nA = Math.floor(Math.log(eA) / Math.LN2), DA = Math.round(eA * 2 ** -nA * 8388608) & 8388607;
          tA((lA << 31 | nA + 127 << 23 | DA) >>> 0, aA, GA);
        }
      }
      iA.writeFloatLE = oA.bind(null, IA), iA.writeFloatBE = oA.bind(null, BA);
      function cA(tA, eA, aA) {
        var GA = tA(eA, aA), lA = (GA >> 31) * 2 + 1, nA = GA >>> 23 & 255, DA = GA & 8388607;
        return nA === 255 ? DA ? NaN : lA * (1 / 0) : nA === 0 ? lA * 1401298464324817e-60 * DA : lA * 2 ** (nA - 150) * (DA + 8388608);
      }
      iA.readFloatLE = cA.bind(null, QA), iA.readFloatBE = cA.bind(null, EA);
    })(), typeof Float64Array < "u" ? (function() {
      var oA = new Float64Array([-0]), cA = new Uint8Array(oA.buffer), tA = cA[7] === 128;
      function eA(nA, DA, hA) {
        oA[0] = nA, DA[hA] = cA[0], DA[hA + 1] = cA[1], DA[hA + 2] = cA[2], DA[hA + 3] = cA[3], DA[hA + 4] = cA[4], DA[hA + 5] = cA[5], DA[hA + 6] = cA[6], DA[hA + 7] = cA[7];
      }
      function aA(nA, DA, hA) {
        oA[0] = nA, DA[hA] = cA[7], DA[hA + 1] = cA[6], DA[hA + 2] = cA[5], DA[hA + 3] = cA[4], DA[hA + 4] = cA[3], DA[hA + 5] = cA[2], DA[hA + 6] = cA[1], DA[hA + 7] = cA[0];
      }
      iA.writeDoubleLE = tA ? eA : aA, iA.writeDoubleBE = tA ? aA : eA;
      function GA(nA, DA) {
        return cA[0] = nA[DA], cA[1] = nA[DA + 1], cA[2] = nA[DA + 2], cA[3] = nA[DA + 3], cA[4] = nA[DA + 4], cA[5] = nA[DA + 5], cA[6] = nA[DA + 6], cA[7] = nA[DA + 7], oA[0];
      }
      function lA(nA, DA) {
        return cA[7] = nA[DA], cA[6] = nA[DA + 1], cA[5] = nA[DA + 2], cA[4] = nA[DA + 3], cA[3] = nA[DA + 4], cA[2] = nA[DA + 5], cA[1] = nA[DA + 6], cA[0] = nA[DA + 7], oA[0];
      }
      iA.readDoubleLE = tA ? GA : lA, iA.readDoubleBE = tA ? lA : GA;
    })() : (function() {
      function oA(tA, eA, aA, GA, lA, nA) {
        var DA = +(GA < 0);
        if (DA && (GA = -GA), GA === 0) tA(0, lA, nA + eA), tA(1 / GA > 0 ? 0 : 2147483648, lA, nA + aA);
        else if (isNaN(GA)) tA(0, lA, nA + eA), tA(2146959360, lA, nA + aA);
        else if (GA > 17976931348623157e292) tA(0, lA, nA + eA), tA((DA << 31 | 2146435072) >>> 0, lA, nA + aA);
        else {
          var hA;
          if (GA < 22250738585072014e-324) hA = GA / 5e-324, tA(hA >>> 0, lA, nA + eA), tA((DA << 31 | hA / 4294967296) >>> 0, lA, nA + aA);
          else {
            var wA = Math.floor(Math.log(GA) / Math.LN2);
            wA === 1024 && (wA = 1023), hA = GA * 2 ** -wA, tA(hA * 4503599627370496 >>> 0, lA, nA + eA), tA((DA << 31 | wA + 1023 << 20 | hA * 1048576 & 1048575) >>> 0, lA, nA + aA);
          }
        }
      }
      iA.writeDoubleLE = oA.bind(null, IA, 0, 4), iA.writeDoubleBE = oA.bind(null, BA, 4, 0);
      function cA(tA, eA, aA, GA, lA) {
        var nA = tA(GA, lA + eA), DA = tA(GA, lA + aA), hA = (DA >> 31) * 2 + 1, wA = DA >>> 20 & 2047, sA = 4294967296 * (DA & 1048575) + nA;
        return wA === 2047 ? sA ? NaN : hA * (1 / 0) : wA === 0 ? hA * 5e-324 * sA : hA * 2 ** (wA - 1075) * (sA + 4503599627370496);
      }
      iA.readDoubleLE = cA.bind(null, QA, 0, 4), iA.readDoubleBE = cA.bind(null, EA, 4, 0);
    })(), iA;
  }
  function IA(iA, oA, cA) {
    oA[cA] = iA & 255, oA[cA + 1] = iA >>> 8 & 255, oA[cA + 2] = iA >>> 16 & 255, oA[cA + 3] = iA >>> 24;
  }
  function BA(iA, oA, cA) {
    oA[cA] = iA >>> 24, oA[cA + 1] = iA >>> 16 & 255, oA[cA + 2] = iA >>> 8 & 255, oA[cA + 3] = iA & 255;
  }
  function QA(iA, oA) {
    return (iA[oA] | iA[oA + 1] << 8 | iA[oA + 2] << 16 | iA[oA + 3] << 24) >>> 0;
  }
  function EA(iA, oA) {
    return (iA[oA] << 24 | iA[oA + 1] << 16 | iA[oA + 2] << 8 | iA[oA + 3]) >>> 0;
  }
}), require_inquire = /* @__PURE__ */ o((exports$1, module) => {
  module.exports = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch {
    }
    return null;
  }
}), require_utf8 = /* @__PURE__ */ o((CA) => {
  var gA = CA;
  gA.length = function(AA) {
    for (var IA = 0, BA = 0, QA = 0; QA < AA.length; ++QA) BA = AA.charCodeAt(QA), BA < 128 ? IA += 1 : BA < 2048 ? IA += 2 : (BA & 64512) == 55296 && (AA.charCodeAt(QA + 1) & 64512) == 56320 ? (++QA, IA += 4) : IA += 3;
    return IA;
  }, gA.read = function(AA, IA, BA) {
    if (BA - IA < 1) return "";
    for (var QA = null, EA = [], iA = 0, oA; IA < BA; ) oA = AA[IA++], oA < 128 ? EA[iA++] = oA : oA > 191 && oA < 224 ? EA[iA++] = (oA & 31) << 6 | AA[IA++] & 63 : oA > 239 && oA < 365 ? (oA = ((oA & 7) << 18 | (AA[IA++] & 63) << 12 | (AA[IA++] & 63) << 6 | AA[IA++] & 63) - 65536, EA[iA++] = 55296 + (oA >> 10), EA[iA++] = 56320 + (oA & 1023)) : EA[iA++] = (oA & 15) << 12 | (AA[IA++] & 63) << 6 | AA[IA++] & 63, iA > 8191 && ((QA ||= []).push(String.fromCharCode.apply(String, EA)), iA = 0);
    return QA ? (iA && QA.push(String.fromCharCode.apply(String, EA.slice(0, iA))), QA.join("")) : String.fromCharCode.apply(String, EA.slice(0, iA));
  }, gA.write = function(AA, IA, BA) {
    for (var QA = BA, EA, iA, oA = 0; oA < AA.length; ++oA) EA = AA.charCodeAt(oA), EA < 128 ? IA[BA++] = EA : EA < 2048 ? (IA[BA++] = EA >> 6 | 192, IA[BA++] = EA & 63 | 128) : (EA & 64512) == 55296 && ((iA = AA.charCodeAt(oA + 1)) & 64512) == 56320 ? (EA = 65536 + ((EA & 1023) << 10) + (iA & 1023), ++oA, IA[BA++] = EA >> 18 | 240, IA[BA++] = EA >> 12 & 63 | 128, IA[BA++] = EA >> 6 & 63 | 128, IA[BA++] = EA & 63 | 128) : (IA[BA++] = EA >> 12 | 224, IA[BA++] = EA >> 6 & 63 | 128, IA[BA++] = EA & 63 | 128);
    return BA - QA;
  };
}), require_pool = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = AA;
  function AA(IA, BA, QA) {
    var EA = QA || 8192, iA = EA >>> 1, oA = null, cA = EA;
    return function(tA) {
      if (tA < 1 || tA > iA) return IA(tA);
      cA + tA > EA && (oA = IA(EA), cA = 0);
      var eA = BA.call(oA, cA, cA += tA);
      return cA & 7 && (cA = (cA | 7) + 1), eA;
    };
  }
}), require_longbits = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = IA;
  var AA = require_minimal$1();
  function IA(iA, oA) {
    this.lo = iA >>> 0, this.hi = oA >>> 0;
  }
  var BA = IA.zero = new IA(0, 0);
  BA.toNumber = function() {
    return 0;
  }, BA.zzEncode = BA.zzDecode = function() {
    return this;
  }, BA.length = function() {
    return 1;
  };
  var QA = IA.zeroHash = "\0\0\0\0\0\0\0\0";
  IA.fromNumber = function(iA) {
    if (iA === 0) return BA;
    var oA = iA < 0;
    oA && (iA = -iA);
    var cA = iA >>> 0, tA = (iA - cA) / 4294967296 >>> 0;
    return oA && (tA = ~tA >>> 0, cA = ~cA >>> 0, ++cA > 4294967295 && (cA = 0, ++tA > 4294967295 && (tA = 0))), new IA(cA, tA);
  }, IA.from = function(iA) {
    if (typeof iA == "number") return IA.fromNumber(iA);
    if (AA.isString(iA)) if (AA.Long) iA = AA.Long.fromString(iA);
    else return IA.fromNumber(parseInt(iA, 10));
    return iA.low || iA.high ? new IA(iA.low >>> 0, iA.high >>> 0) : BA;
  }, IA.prototype.toNumber = function(iA) {
    if (!iA && this.hi >>> 31) {
      var oA = ~this.lo + 1 >>> 0, cA = ~this.hi >>> 0;
      return oA || (cA = cA + 1 >>> 0), -(oA + cA * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, IA.prototype.toLong = function(iA) {
    return AA.Long ? new AA.Long(this.lo | 0, this.hi | 0, !!iA) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!iA };
  };
  var EA = String.prototype.charCodeAt;
  IA.fromHash = function(iA) {
    return iA === QA ? BA : new IA((EA.call(iA, 0) | EA.call(iA, 1) << 8 | EA.call(iA, 2) << 16 | EA.call(iA, 3) << 24) >>> 0, (EA.call(iA, 4) | EA.call(iA, 5) << 8 | EA.call(iA, 6) << 16 | EA.call(iA, 7) << 24) >>> 0);
  }, IA.prototype.toHash = function() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  }, IA.prototype.zzEncode = function() {
    var iA = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ iA) >>> 0, this.lo = (this.lo << 1 ^ iA) >>> 0, this;
  }, IA.prototype.zzDecode = function() {
    var iA = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ iA) >>> 0, this.hi = (this.hi >>> 1 ^ iA) >>> 0, this;
  }, IA.prototype.length = function() {
    var iA = this.lo, oA = (this.lo >>> 28 | this.hi << 4) >>> 0, cA = this.hi >>> 24;
    return cA === 0 ? oA === 0 ? iA < 16384 ? iA < 128 ? 1 : 2 : iA < 2097152 ? 3 : 4 : oA < 16384 ? oA < 128 ? 5 : 6 : oA < 2097152 ? 7 : 8 : cA < 128 ? 9 : 10;
  };
}), require_minimal$1 = /* @__PURE__ */ o((CA) => {
  var gA = CA;
  gA.asPromise = require_aspromise(), gA.base64 = require_base64(), gA.EventEmitter = require_eventemitter(), gA.float = require_float(), gA.inquire = require_inquire(), gA.utf8 = require_utf8(), gA.pool = require_pool(), gA.LongBits = require_longbits(), gA.isNode = !!(typeof global < "u" && global && global.process && global.process.versions && global.process.versions.node), gA.global = gA.isNode && global || typeof window < "u" && window || typeof self < "u" && self || CA, gA.emptyArray = Object.freeze ? Object.freeze([]) : (
    /* istanbul ignore next */
    []
  ), gA.emptyObject = Object.freeze ? Object.freeze({}) : (
    /* istanbul ignore next */
    {}
  ), gA.isInteger = Number.isInteger || function(BA) {
    return typeof BA == "number" && isFinite(BA) && Math.floor(BA) === BA;
  }, gA.isString = function(BA) {
    return typeof BA == "string" || BA instanceof String;
  }, gA.isObject = function(BA) {
    return BA && typeof BA == "object";
  }, gA.isset = gA.isSet = function(BA, QA) {
    var EA = BA[QA];
    return EA != null && BA.hasOwnProperty(QA) ? typeof EA != "object" || (Array.isArray(EA) ? EA.length : Object.keys(EA).length) > 0 : !1;
  }, gA.Buffer = (function() {
    try {
      var BA = gA.inquire("buffer").Buffer;
      return BA.prototype.utf8Write ? BA : (
        /* istanbul ignore next */
        null
      );
    } catch {
      return null;
    }
  })(), gA._Buffer_from = null, gA._Buffer_allocUnsafe = null, gA.newBuffer = function(BA) {
    return typeof BA == "number" ? gA.Buffer ? gA._Buffer_allocUnsafe(BA) : new gA.Array(BA) : gA.Buffer ? gA._Buffer_from(BA) : typeof Uint8Array > "u" ? BA : new Uint8Array(BA);
  }, gA.Array = typeof Uint8Array < "u" ? Uint8Array : Array, gA.Long = gA.global.dcodeIO && gA.global.dcodeIO.Long || gA.global.Long || gA.inquire("long"), gA.key2Re = /^true|false|0|1$/, gA.key32Re = /^-?(?:0|[1-9][0-9]*)$/, gA.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, gA.longToHash = function(BA) {
    return BA ? gA.LongBits.from(BA).toHash() : gA.LongBits.zeroHash;
  }, gA.longFromHash = function(BA, QA) {
    var EA = gA.LongBits.fromHash(BA);
    return gA.Long ? gA.Long.fromBits(EA.lo, EA.hi, QA) : EA.toNumber(!!QA);
  };
  function AA(BA, QA, EA) {
    for (var iA = Object.keys(QA), oA = 0; oA < iA.length; ++oA) (BA[iA[oA]] === void 0 || !EA) && (BA[iA[oA]] = QA[iA[oA]]);
    return BA;
  }
  gA.merge = AA, gA.lcFirst = function(BA) {
    return BA.charAt(0).toLowerCase() + BA.substring(1);
  };
  function IA(BA) {
    function QA(EA, iA) {
      if (!(this instanceof QA)) return new QA(EA, iA);
      Object.defineProperty(this, "message", { get: function() {
        return EA;
      } }), Error.captureStackTrace ? Error.captureStackTrace(this, QA) : Object.defineProperty(this, "stack", { value: (/* @__PURE__ */ Error()).stack || "" }), iA && AA(this, iA);
    }
    return QA.prototype = Object.create(Error.prototype, { constructor: { value: QA, writable: !0, enumerable: !1, configurable: !0 }, name: { get: function() {
      return BA;
    }, set: void 0, enumerable: !1, configurable: !0 }, toString: { value: function() {
      return this.name + ": " + this.message;
    }, writable: !0, enumerable: !1, configurable: !0 } }), QA;
  }
  gA.newError = IA, gA.ProtocolError = IA("ProtocolError"), gA.oneOfGetter = function(BA) {
    for (var QA = {}, EA = 0; EA < BA.length; ++EA) QA[BA[EA]] = 1;
    return function() {
      for (var iA = Object.keys(this), oA = iA.length - 1; oA > -1; --oA) if (QA[iA[oA]] === 1 && this[iA[oA]] !== void 0 && this[iA[oA]] !== null) return iA[oA];
    };
  }, gA.oneOfSetter = function(BA) {
    return function(QA) {
      for (var EA = 0; EA < BA.length; ++EA) BA[EA] !== QA && delete this[BA[EA]];
    };
  }, gA.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, gA._configure = function() {
    var BA = gA.Buffer;
    if (!BA) {
      gA._Buffer_from = gA._Buffer_allocUnsafe = null;
      return;
    }
    gA._Buffer_from = BA.from !== Uint8Array.from && BA.from || function(QA, EA) {
      return new BA(QA, EA);
    }, gA._Buffer_allocUnsafe = BA.allocUnsafe || function(QA) {
      return new BA(QA);
    };
  };
}), require_writer = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = tA;
  var AA = require_minimal$1(), IA, BA = AA.LongBits, QA = AA.base64, EA = AA.utf8;
  function iA(wA, sA, NA) {
    this.fn = wA, this.len = sA, this.next = void 0, this.val = NA;
  }
  function oA() {
  }
  function cA(wA) {
    this.head = wA.head, this.tail = wA.tail, this.len = wA.len, this.next = wA.states;
  }
  function tA() {
    this.len = 0, this.head = new iA(oA, 0, 0), this.tail = this.head, this.states = null;
  }
  var eA = function() {
    return AA.Buffer ? function() {
      return (tA.create = function() {
        return new IA();
      })();
    } : function() {
      return new tA();
    };
  };
  tA.create = eA(), tA.alloc = function(wA) {
    return new AA.Array(wA);
  }, AA.Array !== Array && (tA.alloc = AA.pool(tA.alloc, AA.Array.prototype.subarray)), tA.prototype._push = function(wA, sA, NA) {
    return this.tail = this.tail.next = new iA(wA, sA, NA), this.len += sA, this;
  };
  function aA(wA, sA, NA) {
    sA[NA] = wA & 255;
  }
  function GA(wA, sA, NA) {
    for (; wA > 127; ) sA[NA++] = wA & 127 | 128, wA >>>= 7;
    sA[NA] = wA;
  }
  function lA(wA, sA) {
    this.len = wA, this.next = void 0, this.val = sA;
  }
  lA.prototype = Object.create(iA.prototype), lA.prototype.fn = GA, tA.prototype.uint32 = function(wA) {
    return this.len += (this.tail = this.tail.next = new lA((wA >>>= 0) < 128 ? 1 : wA < 16384 ? 2 : wA < 2097152 ? 3 : wA < 268435456 ? 4 : 5, wA)).len, this;
  }, tA.prototype.int32 = function(wA) {
    return wA < 0 ? this._push(nA, 10, BA.fromNumber(wA)) : this.uint32(wA);
  }, tA.prototype.sint32 = function(wA) {
    return this.uint32((wA << 1 ^ wA >> 31) >>> 0);
  };
  function nA(wA, sA, NA) {
    for (; wA.hi; ) sA[NA++] = wA.lo & 127 | 128, wA.lo = (wA.lo >>> 7 | wA.hi << 25) >>> 0, wA.hi >>>= 7;
    for (; wA.lo > 127; ) sA[NA++] = wA.lo & 127 | 128, wA.lo >>>= 7;
    sA[NA++] = wA.lo;
  }
  tA.prototype.uint64 = function(wA) {
    var sA = BA.from(wA);
    return this._push(nA, sA.length(), sA);
  }, tA.prototype.int64 = tA.prototype.uint64, tA.prototype.sint64 = function(wA) {
    var sA = BA.from(wA).zzEncode();
    return this._push(nA, sA.length(), sA);
  }, tA.prototype.bool = function(wA) {
    return this._push(aA, 1, +!!wA);
  };
  function DA(wA, sA, NA) {
    sA[NA] = wA & 255, sA[NA + 1] = wA >>> 8 & 255, sA[NA + 2] = wA >>> 16 & 255, sA[NA + 3] = wA >>> 24;
  }
  tA.prototype.fixed32 = function(wA) {
    return this._push(DA, 4, wA >>> 0);
  }, tA.prototype.sfixed32 = tA.prototype.fixed32, tA.prototype.fixed64 = function(wA) {
    var sA = BA.from(wA);
    return this._push(DA, 4, sA.lo)._push(DA, 4, sA.hi);
  }, tA.prototype.sfixed64 = tA.prototype.fixed64, tA.prototype.float = function(wA) {
    return this._push(AA.float.writeFloatLE, 4, wA);
  }, tA.prototype.double = function(wA) {
    return this._push(AA.float.writeDoubleLE, 8, wA);
  };
  var hA = AA.Array.prototype.set ? function(wA, sA, NA) {
    sA.set(wA, NA);
  } : function(wA, sA, NA) {
    for (var rA = 0; rA < wA.length; ++rA) sA[NA + rA] = wA[rA];
  };
  tA.prototype.bytes = function(wA) {
    var sA = wA.length >>> 0;
    if (!sA) return this._push(aA, 1, 0);
    if (AA.isString(wA)) {
      var NA = tA.alloc(sA = QA.length(wA));
      QA.decode(wA, NA, 0), wA = NA;
    }
    return this.uint32(sA)._push(hA, sA, wA);
  }, tA.prototype.string = function(wA) {
    var sA = EA.length(wA);
    return sA ? this.uint32(sA)._push(EA.write, sA, wA) : this._push(aA, 1, 0);
  }, tA.prototype.fork = function() {
    return this.states = new cA(this), this.head = this.tail = new iA(oA, 0, 0), this.len = 0, this;
  }, tA.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new iA(oA, 0, 0), this.len = 0), this;
  }, tA.prototype.ldelim = function() {
    var wA = this.head, sA = this.tail, NA = this.len;
    return this.reset().uint32(NA), NA && (this.tail.next = wA.next, this.tail = sA, this.len += NA), this;
  }, tA.prototype.finish = function() {
    for (var wA = this.head.next, sA = this.constructor.alloc(this.len), NA = 0; wA; ) wA.fn(wA.val, sA, NA), NA += wA.len, wA = wA.next;
    return sA;
  }, tA._configure = function(wA) {
    IA = wA, tA.create = eA(), IA._configure();
  };
}), require_writer_buffer = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = BA;
  var AA = require_writer();
  (BA.prototype = Object.create(AA.prototype)).constructor = BA;
  var IA = require_minimal$1();
  function BA() {
    AA.call(this);
  }
  BA._configure = function() {
    BA.alloc = IA._Buffer_allocUnsafe, BA.writeBytesBuffer = IA.Buffer && IA.Buffer.prototype instanceof Uint8Array && IA.Buffer.prototype.set.name === "set" ? function(EA, iA, oA) {
      iA.set(EA, oA);
    } : function(EA, iA, oA) {
      if (EA.copy) EA.copy(iA, oA, 0, EA.length);
      else for (var cA = 0; cA < EA.length; ) iA[oA++] = EA[cA++];
    };
  }, BA.prototype.bytes = function(EA) {
    IA.isString(EA) && (EA = IA._Buffer_from(EA, "base64"));
    var iA = EA.length >>> 0;
    return this.uint32(iA), iA && this._push(BA.writeBytesBuffer, iA, EA), this;
  };
  function QA(EA, iA, oA) {
    EA.length < 40 ? IA.utf8.write(EA, iA, oA) : iA.utf8Write ? iA.utf8Write(EA, oA) : iA.write(EA, oA);
  }
  BA.prototype.string = function(EA) {
    var iA = IA.Buffer.byteLength(EA);
    return this.uint32(iA), iA && this._push(QA, iA, EA), this;
  }, BA._configure();
}), require_reader = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = iA;
  var AA = require_minimal$1(), IA, BA = AA.LongBits, QA = AA.utf8;
  function EA(GA, lA) {
    return RangeError("index out of range: " + GA.pos + " + " + (lA || 1) + " > " + GA.len);
  }
  function iA(GA) {
    this.buf = GA, this.pos = 0, this.len = GA.length;
  }
  var oA = typeof Uint8Array < "u" ? function(GA) {
    if (GA instanceof Uint8Array || Array.isArray(GA)) return new iA(GA);
    throw Error("illegal buffer");
  } : function(GA) {
    if (Array.isArray(GA)) return new iA(GA);
    throw Error("illegal buffer");
  }, cA = function() {
    return AA.Buffer ? function(GA) {
      return (iA.create = function(lA) {
        return AA.Buffer.isBuffer(lA) ? new IA(lA) : oA(lA);
      })(GA);
    } : oA;
  };
  iA.create = cA(), iA.prototype._slice = AA.Array.prototype.subarray || AA.Array.prototype.slice, iA.prototype.uint32 = /* @__PURE__ */ (function() {
    var GA = 4294967295;
    return function() {
      if (GA = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (GA = (GA | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (GA = (GA | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (GA = (GA | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (GA = (GA | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return GA;
      if ((this.pos += 5) > this.len) throw this.pos = this.len, EA(this, 10);
      return GA;
    };
  })(), iA.prototype.int32 = function() {
    return this.uint32() | 0;
  }, iA.prototype.sint32 = function() {
    var GA = this.uint32();
    return GA >>> 1 ^ -(GA & 1) | 0;
  };
  function tA() {
    var GA = new BA(0, 0), lA = 0;
    if (this.len - this.pos > 4) {
      for (; lA < 4; ++lA) if (GA.lo = (GA.lo | (this.buf[this.pos] & 127) << lA * 7) >>> 0, this.buf[this.pos++] < 128) return GA;
      if (GA.lo = (GA.lo | (this.buf[this.pos] & 127) << 28) >>> 0, GA.hi = (GA.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return GA;
      lA = 0;
    } else {
      for (; lA < 3; ++lA) {
        if (this.pos >= this.len) throw EA(this);
        if (GA.lo = (GA.lo | (this.buf[this.pos] & 127) << lA * 7) >>> 0, this.buf[this.pos++] < 128) return GA;
      }
      return GA.lo = (GA.lo | (this.buf[this.pos++] & 127) << lA * 7) >>> 0, GA;
    }
    if (this.len - this.pos > 4) {
      for (; lA < 5; ++lA) if (GA.hi = (GA.hi | (this.buf[this.pos] & 127) << lA * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return GA;
    } else for (; lA < 5; ++lA) {
      if (this.pos >= this.len) throw EA(this);
      if (GA.hi = (GA.hi | (this.buf[this.pos] & 127) << lA * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return GA;
    }
    throw Error("invalid varint encoding");
  }
  iA.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function eA(GA, lA) {
    return (GA[lA - 4] | GA[lA - 3] << 8 | GA[lA - 2] << 16 | GA[lA - 1] << 24) >>> 0;
  }
  iA.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len) throw EA(this, 4);
    return eA(this.buf, this.pos += 4);
  }, iA.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len) throw EA(this, 4);
    return eA(this.buf, this.pos += 4) | 0;
  };
  function aA() {
    if (this.pos + 8 > this.len) throw EA(this, 8);
    return new BA(eA(this.buf, this.pos += 4), eA(this.buf, this.pos += 4));
  }
  iA.prototype.float = function() {
    if (this.pos + 4 > this.len) throw EA(this, 4);
    var GA = AA.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, GA;
  }, iA.prototype.double = function() {
    if (this.pos + 8 > this.len) throw EA(this, 4);
    var GA = AA.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, GA;
  }, iA.prototype.bytes = function() {
    var GA = this.uint32(), lA = this.pos, nA = this.pos + GA;
    if (nA > this.len) throw EA(this, GA);
    if (this.pos += GA, Array.isArray(this.buf)) return this.buf.slice(lA, nA);
    if (lA === nA) {
      var DA = AA.Buffer;
      return DA ? DA.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, lA, nA);
  }, iA.prototype.string = function() {
    var GA = this.bytes();
    return QA.read(GA, 0, GA.length);
  }, iA.prototype.skip = function(GA) {
    if (typeof GA == "number") {
      if (this.pos + GA > this.len) throw EA(this, GA);
      this.pos += GA;
    } else do
      if (this.pos >= this.len) throw EA(this);
    while (this.buf[this.pos++] & 128);
    return this;
  }, iA.prototype.skipType = function(GA) {
    switch (GA) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; (GA = this.uint32() & 7) != 4; ) this.skipType(GA);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + GA + " at offset " + this.pos);
    }
    return this;
  }, iA._configure = function(GA) {
    IA = GA, iA.create = cA(), IA._configure();
    var lA = AA.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    AA.merge(iA.prototype, { int64: function() {
      return tA.call(this)[lA](!1);
    }, uint64: function() {
      return tA.call(this)[lA](!0);
    }, sint64: function() {
      return tA.call(this).zzDecode()[lA](!1);
    }, fixed64: function() {
      return aA.call(this)[lA](!0);
    }, sfixed64: function() {
      return aA.call(this)[lA](!1);
    } });
  };
}), require_reader_buffer = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = BA;
  var AA = require_reader();
  (BA.prototype = Object.create(AA.prototype)).constructor = BA;
  var IA = require_minimal$1();
  function BA(QA) {
    AA.call(this, QA);
  }
  BA._configure = function() {
    IA.Buffer && (BA.prototype._slice = IA.Buffer.prototype.slice);
  }, BA.prototype.string = function() {
    var QA = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + QA, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + QA, this.len));
  }, BA._configure();
}), require_service = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = IA;
  var AA = require_minimal$1();
  (IA.prototype = Object.create(AA.EventEmitter.prototype)).constructor = IA;
  function IA(BA, QA, EA) {
    if (typeof BA != "function") throw TypeError("rpcImpl must be a function");
    AA.EventEmitter.call(this), this.rpcImpl = BA, this.requestDelimited = !!QA, this.responseDelimited = !!EA;
  }
  IA.prototype.rpcCall = function BA(QA, EA, iA, oA, cA) {
    if (!oA) throw TypeError("request must be specified");
    var tA = this;
    if (!cA) return AA.asPromise(BA, tA, QA, EA, iA, oA);
    if (!tA.rpcImpl) {
      setTimeout(function() {
        cA(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return tA.rpcImpl(QA, EA[tA.requestDelimited ? "encodeDelimited" : "encode"](oA).finish(), function(eA, aA) {
        if (eA) return tA.emit("error", eA, QA), cA(eA);
        if (aA === null) {
          tA.end(!0);
          return;
        }
        if (!(aA instanceof iA)) try {
          aA = iA[tA.responseDelimited ? "decodeDelimited" : "decode"](aA);
        } catch (GA) {
          return tA.emit("error", GA, QA), cA(GA);
        }
        return tA.emit("data", aA, QA), cA(null, aA);
      });
    } catch (eA) {
      tA.emit("error", eA, QA), setTimeout(function() {
        cA(eA);
      }, 0);
      return;
    }
  }, IA.prototype.end = function(BA) {
    return this.rpcImpl && (BA || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  };
}), require_rpc = /* @__PURE__ */ o((CA) => {
  var gA = CA;
  gA.Service = require_service();
}), require_roots = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = {};
}), require_index_minimal = /* @__PURE__ */ o((CA) => {
  var gA = CA;
  gA.build = "minimal", gA.Writer = require_writer(), gA.BufferWriter = require_writer_buffer(), gA.Reader = require_reader(), gA.BufferReader = require_reader_buffer(), gA.util = require_minimal$1(), gA.rpc = require_rpc(), gA.roots = require_roots(), gA.configure = AA;
  function AA() {
    gA.util._configure(), gA.Writer._configure(gA.BufferWriter), gA.Reader._configure(gA.BufferReader);
  }
  AA();
}), require_minimal = /* @__PURE__ */ o((CA, gA) => {
  gA.exports = require_index_minimal();
}), import_minimal = /* @__PURE__ */ l(require_minimal()), $Reader = import_minimal.Reader, $Writer = import_minimal.Writer, $util = import_minimal.util, $root = import_minimal.roots.default || (import_minimal.roots.default = {});
$root.Alert = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.format = 0, CA.prototype.icon = "", CA.prototype.widthConfig = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(10).string(gA.body), gA.format != null && Object.hasOwnProperty.call(gA, "format") && AA.uint32(16).int32(gA.format), gA.icon != null && Object.hasOwnProperty.call(gA, "icon") && AA.uint32(26).string(gA.icon), gA.widthConfig != null && Object.hasOwnProperty.call(gA, "widthConfig") && $root.streamlit.WidthConfig.encode(gA.widthConfig, AA.uint32(34).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Alert();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.body = gA.string();
          break;
        case 2:
          QA.format = gA.int32();
          break;
        case 3:
          QA.icon = gA.string();
          break;
        case 4:
          QA.widthConfig = $root.streamlit.WidthConfig.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Alert) return gA;
    let AA = new $root.Alert();
    switch (gA.body != null && (AA.body = String(gA.body)), gA.format) {
      default:
        if (typeof gA.format == "number") {
          AA.format = gA.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        AA.format = 0;
        break;
      case "ERROR":
      case 1:
        AA.format = 1;
        break;
      case "WARNING":
      case 2:
        AA.format = 2;
        break;
      case "INFO":
      case 3:
        AA.format = 3;
        break;
      case "SUCCESS":
      case 4:
        AA.format = 4;
        break;
    }
    if (gA.icon != null && (AA.icon = String(gA.icon)), gA.widthConfig != null) {
      if (typeof gA.widthConfig != "object") throw TypeError(".Alert.widthConfig: object expected");
      AA.widthConfig = $root.streamlit.WidthConfig.fromObject(gA.widthConfig);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.body = "", IA.format = AA.enums === String ? "UNUSED" : 0, IA.icon = "", IA.widthConfig = null), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.format != null && gA.hasOwnProperty("format") && (IA.format = AA.enums === String ? $root.Alert.Format[gA.format] === void 0 ? gA.format : $root.Alert.Format[gA.format] : gA.format), gA.icon != null && gA.hasOwnProperty("icon") && (IA.icon = gA.icon), gA.widthConfig != null && gA.hasOwnProperty("widthConfig") && (IA.widthConfig = $root.streamlit.WidthConfig.toObject(gA.widthConfig, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Alert";
  }, CA.Format = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNUSED"] = 0, AA[gA[1] = "ERROR"] = 1, AA[gA[2] = "WARNING"] = 2, AA[gA[3] = "INFO"] = 3, AA[gA[4] = "SUCCESS"] = 4, AA;
  })(), CA;
})();
$root.streamlit = (() => {
  let CA = {};
  return CA.WidthConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.useStretch = null, gA.prototype.useContent = null, gA.prototype.pixelWidth = null, gA.prototype.remWidth = null;
    let AA;
    return Object.defineProperty(gA.prototype, "widthSpec", { get: $util.oneOfGetter(AA = ["useStretch", "useContent", "pixelWidth", "remWidth"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.useStretch != null && Object.hasOwnProperty.call(IA, "useStretch") && BA.uint32(8).bool(IA.useStretch), IA.useContent != null && Object.hasOwnProperty.call(IA, "useContent") && BA.uint32(16).bool(IA.useContent), IA.pixelWidth != null && Object.hasOwnProperty.call(IA, "pixelWidth") && BA.uint32(24).uint32(IA.pixelWidth), IA.remWidth != null && Object.hasOwnProperty.call(IA, "remWidth") && BA.uint32(37).float(IA.remWidth), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.streamlit.WidthConfig();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.useStretch = IA.bool();
            break;
          case 2:
            iA.useContent = IA.bool();
            break;
          case 3:
            iA.pixelWidth = IA.uint32();
            break;
          case 4:
            iA.remWidth = IA.float();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.streamlit.WidthConfig) return IA;
      let BA = new $root.streamlit.WidthConfig();
      return IA.useStretch != null && (BA.useStretch = !!IA.useStretch), IA.useContent != null && (BA.useContent = !!IA.useContent), IA.pixelWidth != null && (BA.pixelWidth = IA.pixelWidth >>> 0), IA.remWidth != null && (BA.remWidth = Number(IA.remWidth)), BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return IA.useStretch != null && IA.hasOwnProperty("useStretch") && (QA.useStretch = IA.useStretch, BA.oneofs && (QA.widthSpec = "useStretch")), IA.useContent != null && IA.hasOwnProperty("useContent") && (QA.useContent = IA.useContent, BA.oneofs && (QA.widthSpec = "useContent")), IA.pixelWidth != null && IA.hasOwnProperty("pixelWidth") && (QA.pixelWidth = IA.pixelWidth, BA.oneofs && (QA.widthSpec = "pixelWidth")), IA.remWidth != null && IA.hasOwnProperty("remWidth") && (QA.remWidth = BA.json && !isFinite(IA.remWidth) ? String(IA.remWidth) : IA.remWidth, BA.oneofs && (QA.widthSpec = "remWidth")), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/streamlit.WidthConfig";
    }, gA;
  })(), CA.GapSize = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "GAP_UNDEFINED"] = 0, AA[gA[1] = "SMALL"] = 1, AA[gA[2] = "MEDIUM"] = 2, AA[gA[3] = "LARGE"] = 3, AA[gA[4] = "NONE"] = 4, AA[gA[5] = "XXSMALL"] = 5, AA[gA[6] = "XSMALL"] = 6, AA[gA[7] = "XLARGE"] = 7, AA[gA[8] = "XXLARGE"] = 8, AA;
  })(), CA.GapConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.gapSize = null;
    let AA;
    return Object.defineProperty(gA.prototype, "gapSpec", { get: $util.oneOfGetter(AA = ["gapSize"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.gapSize != null && Object.hasOwnProperty.call(IA, "gapSize") && BA.uint32(8).int32(IA.gapSize), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.streamlit.GapConfig();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? iA.gapSize = IA.int32() : IA.skipType(oA & 7);
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.streamlit.GapConfig) return IA;
      let BA = new $root.streamlit.GapConfig();
      switch (IA.gapSize) {
        default:
          if (typeof IA.gapSize == "number") {
            BA.gapSize = IA.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          BA.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          BA.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          BA.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          BA.gapSize = 3;
          break;
        case "NONE":
        case 4:
          BA.gapSize = 4;
          break;
        case "XXSMALL":
        case 5:
          BA.gapSize = 5;
          break;
        case "XSMALL":
        case 6:
          BA.gapSize = 6;
          break;
        case "XLARGE":
        case 7:
          BA.gapSize = 7;
          break;
        case "XXLARGE":
        case 8:
          BA.gapSize = 8;
          break;
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return IA.gapSize != null && IA.hasOwnProperty("gapSize") && (QA.gapSize = BA.enums === String ? $root.streamlit.GapSize[IA.gapSize] === void 0 ? IA.gapSize : $root.streamlit.GapSize[IA.gapSize] : IA.gapSize, BA.oneofs && (QA.gapSpec = "gapSize")), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/streamlit.GapConfig";
    }, gA;
  })(), CA.HeightConfig = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.useStretch = null, gA.prototype.useContent = null, gA.prototype.pixelHeight = null, gA.prototype.remHeight = null;
    let AA;
    return Object.defineProperty(gA.prototype, "heightSpec", { get: $util.oneOfGetter(AA = ["useStretch", "useContent", "pixelHeight", "remHeight"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.useStretch != null && Object.hasOwnProperty.call(IA, "useStretch") && BA.uint32(8).bool(IA.useStretch), IA.useContent != null && Object.hasOwnProperty.call(IA, "useContent") && BA.uint32(16).bool(IA.useContent), IA.pixelHeight != null && Object.hasOwnProperty.call(IA, "pixelHeight") && BA.uint32(24).uint32(IA.pixelHeight), IA.remHeight != null && Object.hasOwnProperty.call(IA, "remHeight") && BA.uint32(37).float(IA.remHeight), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.streamlit.HeightConfig();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.useStretch = IA.bool();
            break;
          case 2:
            iA.useContent = IA.bool();
            break;
          case 3:
            iA.pixelHeight = IA.uint32();
            break;
          case 4:
            iA.remHeight = IA.float();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.streamlit.HeightConfig) return IA;
      let BA = new $root.streamlit.HeightConfig();
      return IA.useStretch != null && (BA.useStretch = !!IA.useStretch), IA.useContent != null && (BA.useContent = !!IA.useContent), IA.pixelHeight != null && (BA.pixelHeight = IA.pixelHeight >>> 0), IA.remHeight != null && (BA.remHeight = Number(IA.remHeight)), BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return IA.useStretch != null && IA.hasOwnProperty("useStretch") && (QA.useStretch = IA.useStretch, BA.oneofs && (QA.heightSpec = "useStretch")), IA.useContent != null && IA.hasOwnProperty("useContent") && (QA.useContent = IA.useContent, BA.oneofs && (QA.heightSpec = "useContent")), IA.pixelHeight != null && IA.hasOwnProperty("pixelHeight") && (QA.pixelHeight = IA.pixelHeight, BA.oneofs && (QA.heightSpec = "pixelHeight")), IA.remHeight != null && IA.hasOwnProperty("remHeight") && (QA.remHeight = BA.json && !isFinite(IA.remHeight) ? String(IA.remHeight) : IA.remHeight, BA.oneofs && (QA.heightSpec = "remHeight")), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/streamlit.HeightConfig";
    }, gA;
  })(), CA.ButtonLikeIconPosition = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "LEFT"] = 0, AA[gA[1] = "RIGHT"] = 1, AA;
  })(), CA.SelectWidgetFilterMode = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "FILTER_MODE_FUZZY"] = 0, AA[gA[1] = "FILTER_MODE_CONTAINS"] = 1, AA[gA[2] = "FILTER_MODE_PREFIX"] = 2, AA[gA[3] = "FILTER_MODE_NONE"] = 3, AA;
  })(), CA.TextAlignmentConfig = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.alignment = 0, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      return IA ||= $Writer.create(), AA.alignment != null && Object.hasOwnProperty.call(AA, "alignment") && IA.uint32(8).int32(AA.alignment), IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.streamlit.TextAlignmentConfig();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        iA >>> 3 === 1 ? EA.alignment = AA.int32() : AA.skipType(iA & 7);
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.streamlit.TextAlignmentConfig) return AA;
      let IA = new $root.streamlit.TextAlignmentConfig();
      switch (AA.alignment) {
        default:
          if (typeof AA.alignment == "number") {
            IA.alignment = AA.alignment;
            break;
          }
          break;
        case "UNSPECIFIED":
        case 0:
          IA.alignment = 0;
          break;
        case "LEFT":
        case 1:
          IA.alignment = 1;
          break;
        case "CENTER":
        case 2:
          IA.alignment = 2;
          break;
        case "RIGHT":
        case 3:
          IA.alignment = 3;
          break;
        case "JUSTIFY":
        case 4:
          IA.alignment = 4;
          break;
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      return IA.defaults && (BA.alignment = IA.enums === String ? "UNSPECIFIED" : 0), AA.alignment != null && AA.hasOwnProperty("alignment") && (BA.alignment = IA.enums === String ? $root.streamlit.TextAlignmentConfig.Alignment[AA.alignment] === void 0 ? AA.alignment : $root.streamlit.TextAlignmentConfig.Alignment[AA.alignment] : AA.alignment), BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/streamlit.TextAlignmentConfig";
    }, gA.Alignment = (function() {
      let AA = {}, IA = Object.create(AA);
      return IA[AA[0] = "UNSPECIFIED"] = 0, IA[AA[1] = "LEFT"] = 1, IA[AA[2] = "CENTER"] = 2, IA[AA[3] = "RIGHT"] = 3, IA[AA[4] = "JUSTIFY"] = 4, IA;
    })(), gA;
  })(), CA;
})();
$root.AppPage = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.pageScriptHash = "", CA.prototype.pageName = "", CA.prototype.icon = "", CA.prototype.isDefault = !1, CA.prototype.sectionHeader = "", CA.prototype.urlPathname = "", CA.prototype.isHidden = !1, CA.prototype.externalUrl = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_externalUrl", { get: $util.oneOfGetter(gA = ["externalUrl"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(10).string(AA.pageScriptHash), AA.pageName != null && Object.hasOwnProperty.call(AA, "pageName") && IA.uint32(18).string(AA.pageName), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(26).string(AA.icon), AA.isDefault != null && Object.hasOwnProperty.call(AA, "isDefault") && IA.uint32(32).bool(AA.isDefault), AA.sectionHeader != null && Object.hasOwnProperty.call(AA, "sectionHeader") && IA.uint32(42).string(AA.sectionHeader), AA.urlPathname != null && Object.hasOwnProperty.call(AA, "urlPathname") && IA.uint32(50).string(AA.urlPathname), AA.isHidden != null && Object.hasOwnProperty.call(AA, "isHidden") && IA.uint32(56).bool(AA.isHidden), AA.externalUrl != null && Object.hasOwnProperty.call(AA, "externalUrl") && IA.uint32(66).string(AA.externalUrl), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.AppPage();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.pageScriptHash = AA.string();
          break;
        case 2:
          EA.pageName = AA.string();
          break;
        case 3:
          EA.icon = AA.string();
          break;
        case 4:
          EA.isDefault = AA.bool();
          break;
        case 5:
          EA.sectionHeader = AA.string();
          break;
        case 6:
          EA.urlPathname = AA.string();
          break;
        case 7:
          EA.isHidden = AA.bool();
          break;
        case 8:
          EA.externalUrl = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.AppPage) return AA;
    let IA = new $root.AppPage();
    return AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.pageName != null && (IA.pageName = String(AA.pageName)), AA.icon != null && (IA.icon = String(AA.icon)), AA.isDefault != null && (IA.isDefault = !!AA.isDefault), AA.sectionHeader != null && (IA.sectionHeader = String(AA.sectionHeader)), AA.urlPathname != null && (IA.urlPathname = String(AA.urlPathname)), AA.isHidden != null && (IA.isHidden = !!AA.isHidden), AA.externalUrl != null && (IA.externalUrl = String(AA.externalUrl)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.pageScriptHash = "", BA.pageName = "", BA.icon = "", BA.isDefault = !1, BA.sectionHeader = "", BA.urlPathname = "", BA.isHidden = !1), AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.pageName != null && AA.hasOwnProperty("pageName") && (BA.pageName = AA.pageName), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.isDefault != null && AA.hasOwnProperty("isDefault") && (BA.isDefault = AA.isDefault), AA.sectionHeader != null && AA.hasOwnProperty("sectionHeader") && (BA.sectionHeader = AA.sectionHeader), AA.urlPathname != null && AA.hasOwnProperty("urlPathname") && (BA.urlPathname = AA.urlPathname), AA.isHidden != null && AA.hasOwnProperty("isHidden") && (BA.isHidden = AA.isHidden), AA.externalUrl != null && AA.hasOwnProperty("externalUrl") && (BA.externalUrl = AA.externalUrl, IA.oneofs && (BA._externalUrl = "externalUrl")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/AppPage";
  }, CA;
})();
$root.ArrowData = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.newBuffer([]), CA.prototype.styler = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.data != null && Object.hasOwnProperty.call(gA, "data") && AA.uint32(10).bytes(gA.data), gA.styler != null && Object.hasOwnProperty.call(gA, "styler") && $root.ArrowData.PandasStyler.encode(gA.styler, AA.uint32(18).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ArrowData();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.data = gA.bytes();
          break;
        case 2:
          QA.styler = $root.ArrowData.PandasStyler.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ArrowData) return gA;
    let AA = new $root.ArrowData();
    if (gA.data != null && (typeof gA.data == "string" ? $util.base64.decode(gA.data, AA.data = $util.newBuffer($util.base64.length(gA.data)), 0) : gA.data.length >= 0 && (AA.data = gA.data)), gA.styler != null) {
      if (typeof gA.styler != "object") throw TypeError(".ArrowData.styler: object expected");
      AA.styler = $root.ArrowData.PandasStyler.fromObject(gA.styler);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (AA.bytes === String ? IA.data = "" : (IA.data = [], AA.bytes !== Array && (IA.data = $util.newBuffer(IA.data))), IA.styler = null), gA.data != null && gA.hasOwnProperty("data") && (IA.data = AA.bytes === String ? $util.base64.encode(gA.data, 0, gA.data.length) : AA.bytes === Array ? Array.prototype.slice.call(gA.data) : gA.data), gA.styler != null && gA.hasOwnProperty("styler") && (IA.styler = $root.ArrowData.PandasStyler.toObject(gA.styler, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ArrowData";
  }, CA.PandasStyler = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.uuid = "", gA.prototype.caption = "", gA.prototype.styles = "", gA.prototype.displayValues = $util.newBuffer([]), gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      return IA ||= $Writer.create(), AA.uuid != null && Object.hasOwnProperty.call(AA, "uuid") && IA.uint32(10).string(AA.uuid), AA.caption != null && Object.hasOwnProperty.call(AA, "caption") && IA.uint32(18).string(AA.caption), AA.styles != null && Object.hasOwnProperty.call(AA, "styles") && IA.uint32(26).string(AA.styles), AA.displayValues != null && Object.hasOwnProperty.call(AA, "displayValues") && IA.uint32(34).bytes(AA.displayValues), IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ArrowData.PandasStyler();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        switch (iA >>> 3) {
          case 1:
            EA.uuid = AA.string();
            break;
          case 2:
            EA.caption = AA.string();
            break;
          case 3:
            EA.styles = AA.string();
            break;
          case 4:
            EA.displayValues = AA.bytes();
            break;
          default:
            AA.skipType(iA & 7);
            break;
        }
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.ArrowData.PandasStyler) return AA;
      let IA = new $root.ArrowData.PandasStyler();
      return AA.uuid != null && (IA.uuid = String(AA.uuid)), AA.caption != null && (IA.caption = String(AA.caption)), AA.styles != null && (IA.styles = String(AA.styles)), AA.displayValues != null && (typeof AA.displayValues == "string" ? $util.base64.decode(AA.displayValues, IA.displayValues = $util.newBuffer($util.base64.length(AA.displayValues)), 0) : AA.displayValues.length >= 0 && (IA.displayValues = AA.displayValues)), IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      return IA.defaults && (BA.uuid = "", BA.caption = "", BA.styles = "", IA.bytes === String ? BA.displayValues = "" : (BA.displayValues = [], IA.bytes !== Array && (BA.displayValues = $util.newBuffer(BA.displayValues)))), AA.uuid != null && AA.hasOwnProperty("uuid") && (BA.uuid = AA.uuid), AA.caption != null && AA.hasOwnProperty("caption") && (BA.caption = AA.caption), AA.styles != null && AA.hasOwnProperty("styles") && (BA.styles = AA.styles), AA.displayValues != null && AA.hasOwnProperty("displayValues") && (BA.displayValues = IA.bytes === String ? $util.base64.encode(AA.displayValues, 0, AA.displayValues.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.displayValues) : AA.displayValues), BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ArrowData.PandasStyler";
    }, gA;
  })(), CA;
})();
$root.ArrowNamedDataSet = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.hasName = !1, CA.prototype.data = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.name != null && Object.hasOwnProperty.call(gA, "name") && AA.uint32(10).string(gA.name), gA.data != null && Object.hasOwnProperty.call(gA, "data") && $root.ArrowData.encode(gA.data, AA.uint32(18).fork()).ldelim(), gA.hasName != null && Object.hasOwnProperty.call(gA, "hasName") && AA.uint32(24).bool(gA.hasName), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ArrowNamedDataSet();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.name = gA.string();
          break;
        case 3:
          QA.hasName = gA.bool();
          break;
        case 2:
          QA.data = $root.ArrowData.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ArrowNamedDataSet) return gA;
    let AA = new $root.ArrowNamedDataSet();
    if (gA.name != null && (AA.name = String(gA.name)), gA.hasName != null && (AA.hasName = !!gA.hasName), gA.data != null) {
      if (typeof gA.data != "object") throw TypeError(".ArrowNamedDataSet.data: object expected");
      AA.data = $root.ArrowData.fromObject(gA.data);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.name = "", IA.data = null, IA.hasName = !1), gA.name != null && gA.hasOwnProperty("name") && (IA.name = gA.name), gA.data != null && gA.hasOwnProperty("data") && (IA.data = $root.ArrowData.toObject(gA.data, AA)), gA.hasName != null && gA.hasOwnProperty("hasName") && (IA.hasName = gA.hasName), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ArrowNamedDataSet";
  }, CA;
})();
$root.Audio = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.url = "", CA.prototype.startTime = 0, CA.prototype.endTime = 0, CA.prototype.loop = !1, CA.prototype.autoplay = !1, CA.prototype.id = "", CA.prototype.widthConfig = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_widthConfig", { get: $util.oneOfGetter(gA = ["widthConfig"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.startTime != null && Object.hasOwnProperty.call(AA, "startTime") && IA.uint32(24).int32(AA.startTime), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(42).string(AA.url), AA.endTime != null && Object.hasOwnProperty.call(AA, "endTime") && IA.uint32(48).int32(AA.endTime), AA.loop != null && Object.hasOwnProperty.call(AA, "loop") && IA.uint32(56).bool(AA.loop), AA.autoplay != null && Object.hasOwnProperty.call(AA, "autoplay") && IA.uint32(64).bool(AA.autoplay), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(74).string(AA.id), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(82).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Audio();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 5:
          EA.url = AA.string();
          break;
        case 3:
          EA.startTime = AA.int32();
          break;
        case 6:
          EA.endTime = AA.int32();
          break;
        case 7:
          EA.loop = AA.bool();
          break;
        case 8:
          EA.autoplay = AA.bool();
          break;
        case 9:
          EA.id = AA.string();
          break;
        case 10:
          EA.widthConfig = $root.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Audio) return AA;
    let IA = new $root.Audio();
    if (AA.url != null && (IA.url = String(AA.url)), AA.startTime != null && (IA.startTime = AA.startTime | 0), AA.endTime != null && (IA.endTime = AA.endTime | 0), AA.loop != null && (IA.loop = !!AA.loop), AA.autoplay != null && (IA.autoplay = !!AA.autoplay), AA.id != null && (IA.id = String(AA.id)), AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Audio.widthConfig: object expected");
      IA.widthConfig = $root.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.startTime = 0, BA.url = "", BA.endTime = 0, BA.loop = !1, BA.autoplay = !1, BA.id = ""), AA.startTime != null && AA.hasOwnProperty("startTime") && (BA.startTime = AA.startTime), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.endTime != null && AA.hasOwnProperty("endTime") && (BA.endTime = AA.endTime), AA.loop != null && AA.hasOwnProperty("loop") && (BA.loop = AA.loop), AA.autoplay != null && AA.hasOwnProperty("autoplay") && (BA.autoplay = AA.autoplay), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root.streamlit.WidthConfig.toObject(AA.widthConfig, IA), IA.oneofs && (BA._widthConfig = "widthConfig")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Audio";
  }, CA;
})();
$root.AudioInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.sampleRate = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_sampleRate", { get: $util.oneOfGetter(gA = ["sampleRate"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(26).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(34).string(AA.formId), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(40).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(50).fork()).ldelim(), AA.sampleRate != null && Object.hasOwnProperty.call(AA, "sampleRate") && IA.uint32(56).int32(AA.sampleRate), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.AudioInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.help = AA.string();
          break;
        case 4:
          EA.formId = AA.string();
          break;
        case 5:
          EA.disabled = AA.bool();
          break;
        case 6:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 7:
          EA.sampleRate = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.AudioInput) return AA;
    let IA = new $root.AudioInput();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".AudioInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.sampleRate != null && (IA.sampleRate = AA.sampleRate | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.disabled = !1, BA.labelVisibility = null), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.sampleRate != null && AA.hasOwnProperty("sampleRate") && (BA.sampleRate = AA.sampleRate, IA.oneofs && (BA._sampleRate = "sampleRate")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/AudioInput";
  }, CA;
})();
$root.LabelVisibility = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.value = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.value != null && Object.hasOwnProperty.call(gA, "value") && AA.uint32(8).int32(gA.value), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.LabelVisibility();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.value = gA.int32() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.LabelVisibility) return gA;
    let AA = new $root.LabelVisibility();
    switch (gA.value) {
      default:
        if (typeof gA.value == "number") {
          AA.value = gA.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        AA.value = 0;
        break;
      case "HIDDEN":
      case 1:
        AA.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        AA.value = 2;
        break;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.value = AA.enums === String ? "VISIBLE" : 0), gA.value != null && gA.hasOwnProperty("value") && (IA.value = AA.enums === String ? $root.LabelVisibility.LabelVisibilityOptions[gA.value] === void 0 ? gA.value : $root.LabelVisibility.LabelVisibilityOptions[gA.value] : gA.value), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/LabelVisibility";
  }, CA.LabelVisibilityOptions = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "VISIBLE"] = 0, AA[gA[1] = "HIDDEN"] = 1, AA[gA[2] = "COLLAPSED"] = 2, AA;
  })(), CA;
})();
$root.AuthRedirect = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(10).string(gA.url), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.AuthRedirect();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.url = gA.string() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.AuthRedirect) return gA;
    let AA = new $root.AuthRedirect();
    return gA.url != null && (AA.url = String(gA.url)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.url = ""), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/AuthRedirect";
  }, CA;
})();
$root.AutoRerun = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.interval = 0, CA.prototype.fragmentId = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.interval != null && Object.hasOwnProperty.call(gA, "interval") && AA.uint32(13).float(gA.interval), gA.fragmentId != null && Object.hasOwnProperty.call(gA, "fragmentId") && AA.uint32(18).string(gA.fragmentId), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.AutoRerun();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.interval = gA.float();
          break;
        case 2:
          QA.fragmentId = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.AutoRerun) return gA;
    let AA = new $root.AutoRerun();
    return gA.interval != null && (AA.interval = Number(gA.interval)), gA.fragmentId != null && (AA.fragmentId = String(gA.fragmentId)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.interval = 0, IA.fragmentId = ""), gA.interval != null && gA.hasOwnProperty("interval") && (IA.interval = AA.json && !isFinite(gA.interval) ? String(gA.interval) : gA.interval), gA.fragmentId != null && gA.hasOwnProperty("fragmentId") && (IA.fragmentId = gA.fragmentId), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/AutoRerun";
  }, CA;
})();
$root.BackMsg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.clearCache = null, CA.prototype.setRunOnSave = null, CA.prototype.stopScript = null, CA.prototype.rerunScript = null, CA.prototype.loadGitInfo = null, CA.prototype.debugDisconnectWebsocket = null, CA.prototype.debugShutdownRuntime = null, CA.prototype.fileUrlsRequest = null, CA.prototype.appHeartbeat = null, CA.prototype.deferredFileRequest = null, CA.prototype.debugLastBackmsgId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat", "deferredFileRequest"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.clearCache != null && Object.hasOwnProperty.call(AA, "clearCache") && IA.uint32(40).bool(AA.clearCache), AA.setRunOnSave != null && Object.hasOwnProperty.call(AA, "setRunOnSave") && IA.uint32(48).bool(AA.setRunOnSave), AA.stopScript != null && Object.hasOwnProperty.call(AA, "stopScript") && IA.uint32(56).bool(AA.stopScript), AA.rerunScript != null && Object.hasOwnProperty.call(AA, "rerunScript") && $root.ClientState.encode(AA.rerunScript, IA.uint32(90).fork()).ldelim(), AA.loadGitInfo != null && Object.hasOwnProperty.call(AA, "loadGitInfo") && IA.uint32(96).bool(AA.loadGitInfo), AA.debugLastBackmsgId != null && Object.hasOwnProperty.call(AA, "debugLastBackmsgId") && IA.uint32(106).string(AA.debugLastBackmsgId), AA.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(AA, "debugDisconnectWebsocket") && IA.uint32(112).bool(AA.debugDisconnectWebsocket), AA.debugShutdownRuntime != null && Object.hasOwnProperty.call(AA, "debugShutdownRuntime") && IA.uint32(120).bool(AA.debugShutdownRuntime), AA.fileUrlsRequest != null && Object.hasOwnProperty.call(AA, "fileUrlsRequest") && $root.FileURLsRequest.encode(AA.fileUrlsRequest, IA.uint32(130).fork()).ldelim(), AA.appHeartbeat != null && Object.hasOwnProperty.call(AA, "appHeartbeat") && IA.uint32(136).bool(AA.appHeartbeat), AA.deferredFileRequest != null && Object.hasOwnProperty.call(AA, "deferredFileRequest") && $root.DeferredFileRequest.encode(AA.deferredFileRequest, IA.uint32(146).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.BackMsg();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 5:
          EA.clearCache = AA.bool();
          break;
        case 6:
          EA.setRunOnSave = AA.bool();
          break;
        case 7:
          EA.stopScript = AA.bool();
          break;
        case 11:
          EA.rerunScript = $root.ClientState.decode(AA, AA.uint32());
          break;
        case 12:
          EA.loadGitInfo = AA.bool();
          break;
        case 14:
          EA.debugDisconnectWebsocket = AA.bool();
          break;
        case 15:
          EA.debugShutdownRuntime = AA.bool();
          break;
        case 16:
          EA.fileUrlsRequest = $root.FileURLsRequest.decode(AA, AA.uint32());
          break;
        case 17:
          EA.appHeartbeat = AA.bool();
          break;
        case 18:
          EA.deferredFileRequest = $root.DeferredFileRequest.decode(AA, AA.uint32());
          break;
        case 13:
          EA.debugLastBackmsgId = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.BackMsg) return AA;
    let IA = new $root.BackMsg();
    if (AA.clearCache != null && (IA.clearCache = !!AA.clearCache), AA.setRunOnSave != null && (IA.setRunOnSave = !!AA.setRunOnSave), AA.stopScript != null && (IA.stopScript = !!AA.stopScript), AA.rerunScript != null) {
      if (typeof AA.rerunScript != "object") throw TypeError(".BackMsg.rerunScript: object expected");
      IA.rerunScript = $root.ClientState.fromObject(AA.rerunScript);
    }
    if (AA.loadGitInfo != null && (IA.loadGitInfo = !!AA.loadGitInfo), AA.debugDisconnectWebsocket != null && (IA.debugDisconnectWebsocket = !!AA.debugDisconnectWebsocket), AA.debugShutdownRuntime != null && (IA.debugShutdownRuntime = !!AA.debugShutdownRuntime), AA.fileUrlsRequest != null) {
      if (typeof AA.fileUrlsRequest != "object") throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      IA.fileUrlsRequest = $root.FileURLsRequest.fromObject(AA.fileUrlsRequest);
    }
    if (AA.appHeartbeat != null && (IA.appHeartbeat = !!AA.appHeartbeat), AA.deferredFileRequest != null) {
      if (typeof AA.deferredFileRequest != "object") throw TypeError(".BackMsg.deferredFileRequest: object expected");
      IA.deferredFileRequest = $root.DeferredFileRequest.fromObject(AA.deferredFileRequest);
    }
    return AA.debugLastBackmsgId != null && (IA.debugLastBackmsgId = String(AA.debugLastBackmsgId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.debugLastBackmsgId = ""), AA.clearCache != null && AA.hasOwnProperty("clearCache") && (BA.clearCache = AA.clearCache, IA.oneofs && (BA.type = "clearCache")), AA.setRunOnSave != null && AA.hasOwnProperty("setRunOnSave") && (BA.setRunOnSave = AA.setRunOnSave, IA.oneofs && (BA.type = "setRunOnSave")), AA.stopScript != null && AA.hasOwnProperty("stopScript") && (BA.stopScript = AA.stopScript, IA.oneofs && (BA.type = "stopScript")), AA.rerunScript != null && AA.hasOwnProperty("rerunScript") && (BA.rerunScript = $root.ClientState.toObject(AA.rerunScript, IA), IA.oneofs && (BA.type = "rerunScript")), AA.loadGitInfo != null && AA.hasOwnProperty("loadGitInfo") && (BA.loadGitInfo = AA.loadGitInfo, IA.oneofs && (BA.type = "loadGitInfo")), AA.debugLastBackmsgId != null && AA.hasOwnProperty("debugLastBackmsgId") && (BA.debugLastBackmsgId = AA.debugLastBackmsgId), AA.debugDisconnectWebsocket != null && AA.hasOwnProperty("debugDisconnectWebsocket") && (BA.debugDisconnectWebsocket = AA.debugDisconnectWebsocket, IA.oneofs && (BA.type = "debugDisconnectWebsocket")), AA.debugShutdownRuntime != null && AA.hasOwnProperty("debugShutdownRuntime") && (BA.debugShutdownRuntime = AA.debugShutdownRuntime, IA.oneofs && (BA.type = "debugShutdownRuntime")), AA.fileUrlsRequest != null && AA.hasOwnProperty("fileUrlsRequest") && (BA.fileUrlsRequest = $root.FileURLsRequest.toObject(AA.fileUrlsRequest, IA), IA.oneofs && (BA.type = "fileUrlsRequest")), AA.appHeartbeat != null && AA.hasOwnProperty("appHeartbeat") && (BA.appHeartbeat = AA.appHeartbeat, IA.oneofs && (BA.type = "appHeartbeat")), AA.deferredFileRequest != null && AA.hasOwnProperty("deferredFileRequest") && (BA.deferredFileRequest = $root.DeferredFileRequest.toObject(AA.deferredFileRequest, IA), IA.oneofs && (BA.type = "deferredFileRequest")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/BackMsg";
  }, CA;
})();
$root.DeferredFileRequest = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.sessionId = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.fileId != null && Object.hasOwnProperty.call(gA, "fileId") && AA.uint32(10).string(gA.fileId), gA.sessionId != null && Object.hasOwnProperty.call(gA, "sessionId") && AA.uint32(18).string(gA.sessionId), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.DeferredFileRequest();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.fileId = gA.string();
          break;
        case 2:
          QA.sessionId = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.DeferredFileRequest) return gA;
    let AA = new $root.DeferredFileRequest();
    return gA.fileId != null && (AA.fileId = String(gA.fileId)), gA.sessionId != null && (AA.sessionId = String(gA.sessionId)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.fileId = "", IA.sessionId = ""), gA.fileId != null && gA.hasOwnProperty("fileId") && (IA.fileId = gA.fileId), gA.sessionId != null && gA.hasOwnProperty("sessionId") && (IA.sessionId = gA.sessionId), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/DeferredFileRequest";
  }, CA;
})();
$root.ContextInfo = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.timezone = null, CA.prototype.timezoneOffset = null, CA.prototype.locale = null, CA.prototype.url = null, CA.prototype.isEmbedded = null, CA.prototype.colorScheme = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_timezone", { get: $util.oneOfGetter(gA = ["timezone"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_timezoneOffset", { get: $util.oneOfGetter(gA = ["timezoneOffset"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_locale", { get: $util.oneOfGetter(gA = ["locale"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_url", { get: $util.oneOfGetter(gA = ["url"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_isEmbedded", { get: $util.oneOfGetter(gA = ["isEmbedded"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_colorScheme", { get: $util.oneOfGetter(gA = ["colorScheme"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.timezone != null && Object.hasOwnProperty.call(AA, "timezone") && IA.uint32(10).string(AA.timezone), AA.timezoneOffset != null && Object.hasOwnProperty.call(AA, "timezoneOffset") && IA.uint32(16).int32(AA.timezoneOffset), AA.locale != null && Object.hasOwnProperty.call(AA, "locale") && IA.uint32(26).string(AA.locale), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(34).string(AA.url), AA.isEmbedded != null && Object.hasOwnProperty.call(AA, "isEmbedded") && IA.uint32(40).bool(AA.isEmbedded), AA.colorScheme != null && Object.hasOwnProperty.call(AA, "colorScheme") && IA.uint32(50).string(AA.colorScheme), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ContextInfo();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.timezone = AA.string();
          break;
        case 2:
          EA.timezoneOffset = AA.int32();
          break;
        case 3:
          EA.locale = AA.string();
          break;
        case 4:
          EA.url = AA.string();
          break;
        case 5:
          EA.isEmbedded = AA.bool();
          break;
        case 6:
          EA.colorScheme = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ContextInfo) return AA;
    let IA = new $root.ContextInfo();
    return AA.timezone != null && (IA.timezone = String(AA.timezone)), AA.timezoneOffset != null && (IA.timezoneOffset = AA.timezoneOffset | 0), AA.locale != null && (IA.locale = String(AA.locale)), AA.url != null && (IA.url = String(AA.url)), AA.isEmbedded != null && (IA.isEmbedded = !!AA.isEmbedded), AA.colorScheme != null && (IA.colorScheme = String(AA.colorScheme)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return AA.timezone != null && AA.hasOwnProperty("timezone") && (BA.timezone = AA.timezone, IA.oneofs && (BA._timezone = "timezone")), AA.timezoneOffset != null && AA.hasOwnProperty("timezoneOffset") && (BA.timezoneOffset = AA.timezoneOffset, IA.oneofs && (BA._timezoneOffset = "timezoneOffset")), AA.locale != null && AA.hasOwnProperty("locale") && (BA.locale = AA.locale, IA.oneofs && (BA._locale = "locale")), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url, IA.oneofs && (BA._url = "url")), AA.isEmbedded != null && AA.hasOwnProperty("isEmbedded") && (BA.isEmbedded = AA.isEmbedded, IA.oneofs && (BA._isEmbedded = "isEmbedded")), AA.colorScheme != null && AA.hasOwnProperty("colorScheme") && (BA.colorScheme = AA.colorScheme, IA.oneofs && (BA._colorScheme = "colorScheme")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ContextInfo";
  }, CA;
})();
$root.ClientState = (() => {
  function CA(gA) {
    if (this.cachedMessageHashes = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.queryString = "", CA.prototype.widgetStates = null, CA.prototype.pageScriptHash = "", CA.prototype.pageName = "", CA.prototype.fragmentId = "", CA.prototype.isAutoRerun = !1, CA.prototype.cachedMessageHashes = $util.emptyArray, CA.prototype.contextInfo = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.queryString != null && Object.hasOwnProperty.call(gA, "queryString") && AA.uint32(10).string(gA.queryString), gA.widgetStates != null && Object.hasOwnProperty.call(gA, "widgetStates") && $root.WidgetStates.encode(gA.widgetStates, AA.uint32(18).fork()).ldelim(), gA.pageScriptHash != null && Object.hasOwnProperty.call(gA, "pageScriptHash") && AA.uint32(26).string(gA.pageScriptHash), gA.pageName != null && Object.hasOwnProperty.call(gA, "pageName") && AA.uint32(34).string(gA.pageName), gA.fragmentId != null && Object.hasOwnProperty.call(gA, "fragmentId") && AA.uint32(42).string(gA.fragmentId), gA.isAutoRerun != null && Object.hasOwnProperty.call(gA, "isAutoRerun") && AA.uint32(48).bool(gA.isAutoRerun), gA.cachedMessageHashes != null && gA.cachedMessageHashes.length) for (let IA = 0; IA < gA.cachedMessageHashes.length; ++IA) AA.uint32(58).string(gA.cachedMessageHashes[IA]);
    return gA.contextInfo != null && Object.hasOwnProperty.call(gA, "contextInfo") && $root.ContextInfo.encode(gA.contextInfo, AA.uint32(66).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ClientState();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.queryString = gA.string();
          break;
        case 2:
          QA.widgetStates = $root.WidgetStates.decode(gA, gA.uint32());
          break;
        case 3:
          QA.pageScriptHash = gA.string();
          break;
        case 4:
          QA.pageName = gA.string();
          break;
        case 5:
          QA.fragmentId = gA.string();
          break;
        case 6:
          QA.isAutoRerun = gA.bool();
          break;
        case 7:
          QA.cachedMessageHashes && QA.cachedMessageHashes.length || (QA.cachedMessageHashes = []), QA.cachedMessageHashes.push(gA.string());
          break;
        case 8:
          QA.contextInfo = $root.ContextInfo.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ClientState) return gA;
    let AA = new $root.ClientState();
    if (gA.queryString != null && (AA.queryString = String(gA.queryString)), gA.widgetStates != null) {
      if (typeof gA.widgetStates != "object") throw TypeError(".ClientState.widgetStates: object expected");
      AA.widgetStates = $root.WidgetStates.fromObject(gA.widgetStates);
    }
    if (gA.pageScriptHash != null && (AA.pageScriptHash = String(gA.pageScriptHash)), gA.pageName != null && (AA.pageName = String(gA.pageName)), gA.fragmentId != null && (AA.fragmentId = String(gA.fragmentId)), gA.isAutoRerun != null && (AA.isAutoRerun = !!gA.isAutoRerun), gA.cachedMessageHashes) {
      if (!Array.isArray(gA.cachedMessageHashes)) throw TypeError(".ClientState.cachedMessageHashes: array expected");
      AA.cachedMessageHashes = [];
      for (let IA = 0; IA < gA.cachedMessageHashes.length; ++IA) AA.cachedMessageHashes[IA] = String(gA.cachedMessageHashes[IA]);
    }
    if (gA.contextInfo != null) {
      if (typeof gA.contextInfo != "object") throw TypeError(".ClientState.contextInfo: object expected");
      AA.contextInfo = $root.ContextInfo.fromObject(gA.contextInfo);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.cachedMessageHashes = []), AA.defaults && (IA.queryString = "", IA.widgetStates = null, IA.pageScriptHash = "", IA.pageName = "", IA.fragmentId = "", IA.isAutoRerun = !1, IA.contextInfo = null), gA.queryString != null && gA.hasOwnProperty("queryString") && (IA.queryString = gA.queryString), gA.widgetStates != null && gA.hasOwnProperty("widgetStates") && (IA.widgetStates = $root.WidgetStates.toObject(gA.widgetStates, AA)), gA.pageScriptHash != null && gA.hasOwnProperty("pageScriptHash") && (IA.pageScriptHash = gA.pageScriptHash), gA.pageName != null && gA.hasOwnProperty("pageName") && (IA.pageName = gA.pageName), gA.fragmentId != null && gA.hasOwnProperty("fragmentId") && (IA.fragmentId = gA.fragmentId), gA.isAutoRerun != null && gA.hasOwnProperty("isAutoRerun") && (IA.isAutoRerun = gA.isAutoRerun), gA.cachedMessageHashes && gA.cachedMessageHashes.length) {
      IA.cachedMessageHashes = [];
      for (let BA = 0; BA < gA.cachedMessageHashes.length; ++BA) IA.cachedMessageHashes[BA] = gA.cachedMessageHashes[BA];
    }
    return gA.contextInfo != null && gA.hasOwnProperty("contextInfo") && (IA.contextInfo = $root.ContextInfo.toObject(gA.contextInfo, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ClientState";
  }, CA;
})();
$root.WidgetStates = (() => {
  function CA(gA) {
    if (this.widgets = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.widgets = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.widgets != null && gA.widgets.length) for (let IA = 0; IA < gA.widgets.length; ++IA) $root.WidgetState.encode(gA.widgets[IA], AA.uint32(10).fork()).ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.WidgetStates();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? (QA.widgets && QA.widgets.length || (QA.widgets = []), QA.widgets.push($root.WidgetState.decode(gA, gA.uint32()))) : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.WidgetStates) return gA;
    let AA = new $root.WidgetStates();
    if (gA.widgets) {
      if (!Array.isArray(gA.widgets)) throw TypeError(".WidgetStates.widgets: array expected");
      AA.widgets = [];
      for (let IA = 0; IA < gA.widgets.length; ++IA) {
        if (typeof gA.widgets[IA] != "object") throw TypeError(".WidgetStates.widgets: object expected");
        AA.widgets[IA] = $root.WidgetState.fromObject(gA.widgets[IA]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.widgets = []), gA.widgets && gA.widgets.length) {
      IA.widgets = [];
      for (let BA = 0; BA < gA.widgets.length; ++BA) IA.widgets[BA] = $root.WidgetState.toObject(gA.widgets[BA], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/WidgetStates";
  }, CA;
})();
$root.WidgetState = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.triggerValue = null, CA.prototype.boolValue = null, CA.prototype.doubleValue = null, CA.prototype.intValue = null, CA.prototype.stringValue = null, CA.prototype.doubleArrayValue = null, CA.prototype.intArrayValue = null, CA.prototype.stringArrayValue = null, CA.prototype.jsonValue = null, CA.prototype.arrowValue = null, CA.prototype.bytesValue = null, CA.prototype.fileUploaderStateValue = null, CA.prototype.stringTriggerValue = null, CA.prototype.chatInputValue = null, CA.prototype.jsonTriggerValue = null;
  let gA;
  return Object.defineProperty(CA.prototype, "value", { get: $util.oneOfGetter(gA = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue", "jsonTriggerValue"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.triggerValue != null && Object.hasOwnProperty.call(AA, "triggerValue") && IA.uint32(16).bool(AA.triggerValue), AA.boolValue != null && Object.hasOwnProperty.call(AA, "boolValue") && IA.uint32(24).bool(AA.boolValue), AA.doubleValue != null && Object.hasOwnProperty.call(AA, "doubleValue") && IA.uint32(33).double(AA.doubleValue), AA.intValue != null && Object.hasOwnProperty.call(AA, "intValue") && IA.uint32(40).sint64(AA.intValue), AA.stringValue != null && Object.hasOwnProperty.call(AA, "stringValue") && IA.uint32(50).string(AA.stringValue), AA.doubleArrayValue != null && Object.hasOwnProperty.call(AA, "doubleArrayValue") && $root.DoubleArray.encode(AA.doubleArrayValue, IA.uint32(58).fork()).ldelim(), AA.intArrayValue != null && Object.hasOwnProperty.call(AA, "intArrayValue") && $root.SInt64Array.encode(AA.intArrayValue, IA.uint32(66).fork()).ldelim(), AA.stringArrayValue != null && Object.hasOwnProperty.call(AA, "stringArrayValue") && $root.StringArray.encode(AA.stringArrayValue, IA.uint32(74).fork()).ldelim(), AA.jsonValue != null && Object.hasOwnProperty.call(AA, "jsonValue") && IA.uint32(82).string(AA.jsonValue), AA.arrowValue != null && Object.hasOwnProperty.call(AA, "arrowValue") && $root.ArrowTable.encode(AA.arrowValue, IA.uint32(90).fork()).ldelim(), AA.bytesValue != null && Object.hasOwnProperty.call(AA, "bytesValue") && IA.uint32(98).bytes(AA.bytesValue), AA.fileUploaderStateValue != null && Object.hasOwnProperty.call(AA, "fileUploaderStateValue") && $root.FileUploaderState.encode(AA.fileUploaderStateValue, IA.uint32(106).fork()).ldelim(), AA.stringTriggerValue != null && Object.hasOwnProperty.call(AA, "stringTriggerValue") && $root.StringTriggerValue.encode(AA.stringTriggerValue, IA.uint32(114).fork()).ldelim(), AA.chatInputValue != null && Object.hasOwnProperty.call(AA, "chatInputValue") && $root.ChatInputValue.encode(AA.chatInputValue, IA.uint32(122).fork()).ldelim(), AA.jsonTriggerValue != null && Object.hasOwnProperty.call(AA, "jsonTriggerValue") && IA.uint32(130).string(AA.jsonTriggerValue), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.WidgetState();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.triggerValue = AA.bool();
          break;
        case 3:
          EA.boolValue = AA.bool();
          break;
        case 4:
          EA.doubleValue = AA.double();
          break;
        case 5:
          EA.intValue = AA.sint64();
          break;
        case 6:
          EA.stringValue = AA.string();
          break;
        case 7:
          EA.doubleArrayValue = $root.DoubleArray.decode(AA, AA.uint32());
          break;
        case 8:
          EA.intArrayValue = $root.SInt64Array.decode(AA, AA.uint32());
          break;
        case 9:
          EA.stringArrayValue = $root.StringArray.decode(AA, AA.uint32());
          break;
        case 10:
          EA.jsonValue = AA.string();
          break;
        case 11:
          EA.arrowValue = $root.ArrowTable.decode(AA, AA.uint32());
          break;
        case 12:
          EA.bytesValue = AA.bytes();
          break;
        case 13:
          EA.fileUploaderStateValue = $root.FileUploaderState.decode(AA, AA.uint32());
          break;
        case 14:
          EA.stringTriggerValue = $root.StringTriggerValue.decode(AA, AA.uint32());
          break;
        case 15:
          EA.chatInputValue = $root.ChatInputValue.decode(AA, AA.uint32());
          break;
        case 16:
          EA.jsonTriggerValue = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.WidgetState) return AA;
    let IA = new $root.WidgetState();
    if (AA.id != null && (IA.id = String(AA.id)), AA.triggerValue != null && (IA.triggerValue = !!AA.triggerValue), AA.boolValue != null && (IA.boolValue = !!AA.boolValue), AA.doubleValue != null && (IA.doubleValue = Number(AA.doubleValue)), AA.intValue != null && ($util.Long ? (IA.intValue = $util.Long.fromValue(AA.intValue)).unsigned = !1 : typeof AA.intValue == "string" ? IA.intValue = parseInt(AA.intValue, 10) : typeof AA.intValue == "number" ? IA.intValue = AA.intValue : typeof AA.intValue == "object" && (IA.intValue = new $util.LongBits(AA.intValue.low >>> 0, AA.intValue.high >>> 0).toNumber())), AA.stringValue != null && (IA.stringValue = String(AA.stringValue)), AA.doubleArrayValue != null) {
      if (typeof AA.doubleArrayValue != "object") throw TypeError(".WidgetState.doubleArrayValue: object expected");
      IA.doubleArrayValue = $root.DoubleArray.fromObject(AA.doubleArrayValue);
    }
    if (AA.intArrayValue != null) {
      if (typeof AA.intArrayValue != "object") throw TypeError(".WidgetState.intArrayValue: object expected");
      IA.intArrayValue = $root.SInt64Array.fromObject(AA.intArrayValue);
    }
    if (AA.stringArrayValue != null) {
      if (typeof AA.stringArrayValue != "object") throw TypeError(".WidgetState.stringArrayValue: object expected");
      IA.stringArrayValue = $root.StringArray.fromObject(AA.stringArrayValue);
    }
    if (AA.jsonValue != null && (IA.jsonValue = String(AA.jsonValue)), AA.arrowValue != null) {
      if (typeof AA.arrowValue != "object") throw TypeError(".WidgetState.arrowValue: object expected");
      IA.arrowValue = $root.ArrowTable.fromObject(AA.arrowValue);
    }
    if (AA.bytesValue != null && (typeof AA.bytesValue == "string" ? $util.base64.decode(AA.bytesValue, IA.bytesValue = $util.newBuffer($util.base64.length(AA.bytesValue)), 0) : AA.bytesValue.length >= 0 && (IA.bytesValue = AA.bytesValue)), AA.fileUploaderStateValue != null) {
      if (typeof AA.fileUploaderStateValue != "object") throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      IA.fileUploaderStateValue = $root.FileUploaderState.fromObject(AA.fileUploaderStateValue);
    }
    if (AA.stringTriggerValue != null) {
      if (typeof AA.stringTriggerValue != "object") throw TypeError(".WidgetState.stringTriggerValue: object expected");
      IA.stringTriggerValue = $root.StringTriggerValue.fromObject(AA.stringTriggerValue);
    }
    if (AA.chatInputValue != null) {
      if (typeof AA.chatInputValue != "object") throw TypeError(".WidgetState.chatInputValue: object expected");
      IA.chatInputValue = $root.ChatInputValue.fromObject(AA.chatInputValue);
    }
    return AA.jsonTriggerValue != null && (IA.jsonTriggerValue = String(AA.jsonTriggerValue)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.triggerValue != null && AA.hasOwnProperty("triggerValue") && (BA.triggerValue = AA.triggerValue, IA.oneofs && (BA.value = "triggerValue")), AA.boolValue != null && AA.hasOwnProperty("boolValue") && (BA.boolValue = AA.boolValue, IA.oneofs && (BA.value = "boolValue")), AA.doubleValue != null && AA.hasOwnProperty("doubleValue") && (BA.doubleValue = IA.json && !isFinite(AA.doubleValue) ? String(AA.doubleValue) : AA.doubleValue, IA.oneofs && (BA.value = "doubleValue")), AA.intValue != null && AA.hasOwnProperty("intValue") && (typeof AA.intValue == "number" ? BA.intValue = IA.longs === String ? String(AA.intValue) : AA.intValue : BA.intValue = IA.longs === String ? $util.Long.prototype.toString.call(AA.intValue) : IA.longs === Number ? new $util.LongBits(AA.intValue.low >>> 0, AA.intValue.high >>> 0).toNumber() : AA.intValue, IA.oneofs && (BA.value = "intValue")), AA.stringValue != null && AA.hasOwnProperty("stringValue") && (BA.stringValue = AA.stringValue, IA.oneofs && (BA.value = "stringValue")), AA.doubleArrayValue != null && AA.hasOwnProperty("doubleArrayValue") && (BA.doubleArrayValue = $root.DoubleArray.toObject(AA.doubleArrayValue, IA), IA.oneofs && (BA.value = "doubleArrayValue")), AA.intArrayValue != null && AA.hasOwnProperty("intArrayValue") && (BA.intArrayValue = $root.SInt64Array.toObject(AA.intArrayValue, IA), IA.oneofs && (BA.value = "intArrayValue")), AA.stringArrayValue != null && AA.hasOwnProperty("stringArrayValue") && (BA.stringArrayValue = $root.StringArray.toObject(AA.stringArrayValue, IA), IA.oneofs && (BA.value = "stringArrayValue")), AA.jsonValue != null && AA.hasOwnProperty("jsonValue") && (BA.jsonValue = AA.jsonValue, IA.oneofs && (BA.value = "jsonValue")), AA.arrowValue != null && AA.hasOwnProperty("arrowValue") && (BA.arrowValue = $root.ArrowTable.toObject(AA.arrowValue, IA), IA.oneofs && (BA.value = "arrowValue")), AA.bytesValue != null && AA.hasOwnProperty("bytesValue") && (BA.bytesValue = IA.bytes === String ? $util.base64.encode(AA.bytesValue, 0, AA.bytesValue.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.bytesValue) : AA.bytesValue, IA.oneofs && (BA.value = "bytesValue")), AA.fileUploaderStateValue != null && AA.hasOwnProperty("fileUploaderStateValue") && (BA.fileUploaderStateValue = $root.FileUploaderState.toObject(AA.fileUploaderStateValue, IA), IA.oneofs && (BA.value = "fileUploaderStateValue")), AA.stringTriggerValue != null && AA.hasOwnProperty("stringTriggerValue") && (BA.stringTriggerValue = $root.StringTriggerValue.toObject(AA.stringTriggerValue, IA), IA.oneofs && (BA.value = "stringTriggerValue")), AA.chatInputValue != null && AA.hasOwnProperty("chatInputValue") && (BA.chatInputValue = $root.ChatInputValue.toObject(AA.chatInputValue, IA), IA.oneofs && (BA.value = "chatInputValue")), AA.jsonTriggerValue != null && AA.hasOwnProperty("jsonTriggerValue") && (BA.jsonTriggerValue = AA.jsonTriggerValue, IA.oneofs && (BA.value = "jsonTriggerValue")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/WidgetState";
  }, CA;
})();
$root.StringArray = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) for (let IA = 0; IA < gA.data.length; ++IA) AA.uint32(10).string(gA.data[IA]);
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.StringArray();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? (QA.data && QA.data.length || (QA.data = []), QA.data.push(gA.string())) : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.StringArray) return gA;
    let AA = new $root.StringArray();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".StringArray.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) AA.data[IA] = String(gA.data[IA]);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) IA.data[BA] = gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/StringArray";
  }, CA;
})();
$root.DoubleArray = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) {
      AA.uint32(10).fork();
      for (let IA = 0; IA < gA.data.length; ++IA) AA.double(gA.data[IA]);
      AA.ldelim();
    }
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.DoubleArray();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          if (QA.data && QA.data.length || (QA.data = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.data.push(gA.double());
          } else QA.data.push(gA.double());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.DoubleArray) return gA;
    let AA = new $root.DoubleArray();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".DoubleArray.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) AA.data[IA] = Number(gA.data[IA]);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) IA.data[BA] = AA.json && !isFinite(gA.data[BA]) ? String(gA.data[BA]) : gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/DoubleArray";
  }, CA;
})();
$root.Int32Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) {
      AA.uint32(10).fork();
      for (let IA = 0; IA < gA.data.length; ++IA) AA.int32(gA.data[IA]);
      AA.ldelim();
    }
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Int32Array();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          if (QA.data && QA.data.length || (QA.data = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.data.push(gA.int32());
          } else QA.data.push(gA.int32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Int32Array) return gA;
    let AA = new $root.Int32Array();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".Int32Array.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) AA.data[IA] = gA.data[IA] | 0;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) IA.data[BA] = gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Int32Array";
  }, CA;
})();
$root.Int64Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) {
      AA.uint32(10).fork();
      for (let IA = 0; IA < gA.data.length; ++IA) AA.int64(gA.data[IA]);
      AA.ldelim();
    }
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Int64Array();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          if (QA.data && QA.data.length || (QA.data = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.data.push(gA.int64());
          } else QA.data.push(gA.int64());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Int64Array) return gA;
    let AA = new $root.Int64Array();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".Int64Array.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) $util.Long ? (AA.data[IA] = $util.Long.fromValue(gA.data[IA])).unsigned = !1 : typeof gA.data[IA] == "string" ? AA.data[IA] = parseInt(gA.data[IA], 10) : typeof gA.data[IA] == "number" ? AA.data[IA] = gA.data[IA] : typeof gA.data[IA] == "object" && (AA.data[IA] = new $util.LongBits(gA.data[IA].low >>> 0, gA.data[IA].high >>> 0).toNumber());
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) typeof gA.data[BA] == "number" ? IA.data[BA] = AA.longs === String ? String(gA.data[BA]) : gA.data[BA] : IA.data[BA] = AA.longs === String ? $util.Long.prototype.toString.call(gA.data[BA]) : AA.longs === Number ? new $util.LongBits(gA.data[BA].low >>> 0, gA.data[BA].high >>> 0).toNumber() : gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Int64Array";
  }, CA;
})();
$root.SInt64Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) {
      AA.uint32(10).fork();
      for (let IA = 0; IA < gA.data.length; ++IA) AA.sint64(gA.data[IA]);
      AA.ldelim();
    }
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.SInt64Array();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          if (QA.data && QA.data.length || (QA.data = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.data.push(gA.sint64());
          } else QA.data.push(gA.sint64());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.SInt64Array) return gA;
    let AA = new $root.SInt64Array();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".SInt64Array.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) $util.Long ? (AA.data[IA] = $util.Long.fromValue(gA.data[IA])).unsigned = !1 : typeof gA.data[IA] == "string" ? AA.data[IA] = parseInt(gA.data[IA], 10) : typeof gA.data[IA] == "number" ? AA.data[IA] = gA.data[IA] : typeof gA.data[IA] == "object" && (AA.data[IA] = new $util.LongBits(gA.data[IA].low >>> 0, gA.data[IA].high >>> 0).toNumber());
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) typeof gA.data[BA] == "number" ? IA.data[BA] = AA.longs === String ? String(gA.data[BA]) : gA.data[BA] : IA.data[BA] = AA.longs === String ? $util.Long.prototype.toString.call(gA.data[BA]) : AA.longs === Number ? new $util.LongBits(gA.data[BA].low >>> 0, gA.data[BA].high >>> 0).toNumber() : gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/SInt64Array";
  }, CA;
})();
$root.UInt32Array = (() => {
  function CA(gA) {
    if (this.data = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.data != null && gA.data.length) {
      AA.uint32(10).fork();
      for (let IA = 0; IA < gA.data.length; ++IA) AA.uint32(gA.data[IA]);
      AA.ldelim();
    }
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.UInt32Array();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          if (QA.data && QA.data.length || (QA.data = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.data.push(gA.uint32());
          } else QA.data.push(gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.UInt32Array) return gA;
    let AA = new $root.UInt32Array();
    if (gA.data) {
      if (!Array.isArray(gA.data)) throw TypeError(".UInt32Array.data: array expected");
      AA.data = [];
      for (let IA = 0; IA < gA.data.length; ++IA) AA.data[IA] = gA.data[IA] >>> 0;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.data = []), gA.data && gA.data.length) {
      IA.data = [];
      for (let BA = 0; BA < gA.data.length; ++BA) IA.data[BA] = gA.data[BA];
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/UInt32Array";
  }, CA;
})();
$root.StringTriggerValue = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.data = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_data", { get: $util.oneOfGetter(gA = ["data"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.data != null && Object.hasOwnProperty.call(AA, "data") && IA.uint32(10).string(AA.data), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.StringTriggerValue();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      iA >>> 3 === 1 ? EA.data = AA.string() : AA.skipType(iA & 7);
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.StringTriggerValue) return AA;
    let IA = new $root.StringTriggerValue();
    return AA.data != null && (IA.data = String(AA.data)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return AA.data != null && AA.hasOwnProperty("data") && (BA.data = AA.data, IA.oneofs && (BA._data = "data")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/StringTriggerValue";
  }, CA;
})();
$root.FileURLsRequest = (() => {
  function CA(gA) {
    if (this.fileNames = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.requestId = "", CA.prototype.fileNames = $util.emptyArray, CA.prototype.sessionId = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.requestId != null && Object.hasOwnProperty.call(gA, "requestId") && AA.uint32(10).string(gA.requestId), gA.fileNames != null && gA.fileNames.length) for (let IA = 0; IA < gA.fileNames.length; ++IA) AA.uint32(18).string(gA.fileNames[IA]);
    return gA.sessionId != null && Object.hasOwnProperty.call(gA, "sessionId") && AA.uint32(26).string(gA.sessionId), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FileURLsRequest();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.requestId = gA.string();
          break;
        case 2:
          QA.fileNames && QA.fileNames.length || (QA.fileNames = []), QA.fileNames.push(gA.string());
          break;
        case 3:
          QA.sessionId = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FileURLsRequest) return gA;
    let AA = new $root.FileURLsRequest();
    if (gA.requestId != null && (AA.requestId = String(gA.requestId)), gA.fileNames) {
      if (!Array.isArray(gA.fileNames)) throw TypeError(".FileURLsRequest.fileNames: array expected");
      AA.fileNames = [];
      for (let IA = 0; IA < gA.fileNames.length; ++IA) AA.fileNames[IA] = String(gA.fileNames[IA]);
    }
    return gA.sessionId != null && (AA.sessionId = String(gA.sessionId)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.fileNames = []), AA.defaults && (IA.requestId = "", IA.sessionId = ""), gA.requestId != null && gA.hasOwnProperty("requestId") && (IA.requestId = gA.requestId), gA.fileNames && gA.fileNames.length) {
      IA.fileNames = [];
      for (let BA = 0; BA < gA.fileNames.length; ++BA) IA.fileNames[BA] = gA.fileNames[BA];
    }
    return gA.sessionId != null && gA.hasOwnProperty("sessionId") && (IA.sessionId = gA.sessionId), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FileURLsRequest";
  }, CA;
})();
$root.FileURLs = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.uploadUrl = "", CA.prototype.deleteUrl = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.fileId != null && Object.hasOwnProperty.call(gA, "fileId") && AA.uint32(10).string(gA.fileId), gA.uploadUrl != null && Object.hasOwnProperty.call(gA, "uploadUrl") && AA.uint32(18).string(gA.uploadUrl), gA.deleteUrl != null && Object.hasOwnProperty.call(gA, "deleteUrl") && AA.uint32(26).string(gA.deleteUrl), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FileURLs();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.fileId = gA.string();
          break;
        case 2:
          QA.uploadUrl = gA.string();
          break;
        case 3:
          QA.deleteUrl = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FileURLs) return gA;
    let AA = new $root.FileURLs();
    return gA.fileId != null && (AA.fileId = String(gA.fileId)), gA.uploadUrl != null && (AA.uploadUrl = String(gA.uploadUrl)), gA.deleteUrl != null && (AA.deleteUrl = String(gA.deleteUrl)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.fileId = "", IA.uploadUrl = "", IA.deleteUrl = ""), gA.fileId != null && gA.hasOwnProperty("fileId") && (IA.fileId = gA.fileId), gA.uploadUrl != null && gA.hasOwnProperty("uploadUrl") && (IA.uploadUrl = gA.uploadUrl), gA.deleteUrl != null && gA.hasOwnProperty("deleteUrl") && (IA.deleteUrl = gA.deleteUrl), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FileURLs";
  }, CA;
})();
$root.FileURLsResponse = (() => {
  function CA(gA) {
    if (this.fileUrls = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.responseId = "", CA.prototype.fileUrls = $util.emptyArray, CA.prototype.errorMsg = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.responseId != null && Object.hasOwnProperty.call(gA, "responseId") && AA.uint32(10).string(gA.responseId), gA.fileUrls != null && gA.fileUrls.length) for (let IA = 0; IA < gA.fileUrls.length; ++IA) $root.FileURLs.encode(gA.fileUrls[IA], AA.uint32(18).fork()).ldelim();
    return gA.errorMsg != null && Object.hasOwnProperty.call(gA, "errorMsg") && AA.uint32(26).string(gA.errorMsg), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FileURLsResponse();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.responseId = gA.string();
          break;
        case 2:
          QA.fileUrls && QA.fileUrls.length || (QA.fileUrls = []), QA.fileUrls.push($root.FileURLs.decode(gA, gA.uint32()));
          break;
        case 3:
          QA.errorMsg = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FileURLsResponse) return gA;
    let AA = new $root.FileURLsResponse();
    if (gA.responseId != null && (AA.responseId = String(gA.responseId)), gA.fileUrls) {
      if (!Array.isArray(gA.fileUrls)) throw TypeError(".FileURLsResponse.fileUrls: array expected");
      AA.fileUrls = [];
      for (let IA = 0; IA < gA.fileUrls.length; ++IA) {
        if (typeof gA.fileUrls[IA] != "object") throw TypeError(".FileURLsResponse.fileUrls: object expected");
        AA.fileUrls[IA] = $root.FileURLs.fromObject(gA.fileUrls[IA]);
      }
    }
    return gA.errorMsg != null && (AA.errorMsg = String(gA.errorMsg)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.fileUrls = []), AA.defaults && (IA.responseId = "", IA.errorMsg = ""), gA.responseId != null && gA.hasOwnProperty("responseId") && (IA.responseId = gA.responseId), gA.fileUrls && gA.fileUrls.length) {
      IA.fileUrls = [];
      for (let BA = 0; BA < gA.fileUrls.length; ++BA) IA.fileUrls[BA] = $root.FileURLs.toObject(gA.fileUrls[BA], AA);
    }
    return gA.errorMsg != null && gA.hasOwnProperty("errorMsg") && (IA.errorMsg = gA.errorMsg), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FileURLsResponse";
  }, CA;
})();
$root.UploadedFileInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, CA.prototype.fileId = "", CA.prototype.fileUrls = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.name != null && Object.hasOwnProperty.call(gA, "name") && AA.uint32(18).string(gA.name), gA.size != null && Object.hasOwnProperty.call(gA, "size") && AA.uint32(24).uint64(gA.size), gA.fileId != null && Object.hasOwnProperty.call(gA, "fileId") && AA.uint32(34).string(gA.fileId), gA.fileUrls != null && Object.hasOwnProperty.call(gA, "fileUrls") && $root.FileURLs.encode(gA.fileUrls, AA.uint32(42).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.UploadedFileInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 2:
          QA.name = gA.string();
          break;
        case 3:
          QA.size = gA.uint64();
          break;
        case 4:
          QA.fileId = gA.string();
          break;
        case 5:
          QA.fileUrls = $root.FileURLs.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.UploadedFileInfo) return gA;
    let AA = new $root.UploadedFileInfo();
    if (gA.name != null && (AA.name = String(gA.name)), gA.size != null && ($util.Long ? (AA.size = $util.Long.fromValue(gA.size)).unsigned = !0 : typeof gA.size == "string" ? AA.size = parseInt(gA.size, 10) : typeof gA.size == "number" ? AA.size = gA.size : typeof gA.size == "object" && (AA.size = new $util.LongBits(gA.size.low >>> 0, gA.size.high >>> 0).toNumber(!0))), gA.fileId != null && (AA.fileId = String(gA.fileId)), gA.fileUrls != null) {
      if (typeof gA.fileUrls != "object") throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      AA.fileUrls = $root.FileURLs.fromObject(gA.fileUrls);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if (AA.defaults) {
      if (IA.name = "", $util.Long) {
        let BA = new $util.Long(0, 0, !0);
        IA.size = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.size = AA.longs === String ? "0" : 0;
      IA.fileId = "", IA.fileUrls = null;
    }
    return gA.name != null && gA.hasOwnProperty("name") && (IA.name = gA.name), gA.size != null && gA.hasOwnProperty("size") && (typeof gA.size == "number" ? IA.size = AA.longs === String ? String(gA.size) : gA.size : IA.size = AA.longs === String ? $util.Long.prototype.toString.call(gA.size) : AA.longs === Number ? new $util.LongBits(gA.size.low >>> 0, gA.size.high >>> 0).toNumber(!0) : gA.size), gA.fileId != null && gA.hasOwnProperty("fileId") && (IA.fileId = gA.fileId), gA.fileUrls != null && gA.hasOwnProperty("fileUrls") && (IA.fileUrls = $root.FileURLs.toObject(gA.fileUrls, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/UploadedFileInfo";
  }, CA;
})();
$root.FileUploaderState = (() => {
  function CA(gA) {
    if (this.uploadedFileInfo = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.uploadedFileInfo = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.uploadedFileInfo != null && gA.uploadedFileInfo.length) for (let IA = 0; IA < gA.uploadedFileInfo.length; ++IA) $root.UploadedFileInfo.encode(gA.uploadedFileInfo[IA], AA.uint32(18).fork()).ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FileUploaderState();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 2 ? (QA.uploadedFileInfo && QA.uploadedFileInfo.length || (QA.uploadedFileInfo = []), QA.uploadedFileInfo.push($root.UploadedFileInfo.decode(gA, gA.uint32()))) : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FileUploaderState) return gA;
    let AA = new $root.FileUploaderState();
    if (gA.uploadedFileInfo) {
      if (!Array.isArray(gA.uploadedFileInfo)) throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      AA.uploadedFileInfo = [];
      for (let IA = 0; IA < gA.uploadedFileInfo.length; ++IA) {
        if (typeof gA.uploadedFileInfo[IA] != "object") throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        AA.uploadedFileInfo[IA] = $root.UploadedFileInfo.fromObject(gA.uploadedFileInfo[IA]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.uploadedFileInfo = []), gA.uploadedFileInfo && gA.uploadedFileInfo.length) {
      IA.uploadedFileInfo = [];
      for (let BA = 0; BA < gA.uploadedFileInfo.length; ++BA) IA.uploadedFileInfo[BA] = $root.UploadedFileInfo.toObject(gA.uploadedFileInfo[BA], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FileUploaderState";
  }, CA;
})();
$root.ChatInputValue = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.data = null, CA.prototype.fileUploaderState = null, CA.prototype.audioFileInfo = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_data", { get: $util.oneOfGetter(gA = ["data"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_fileUploaderState", { get: $util.oneOfGetter(gA = ["fileUploaderState"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_audioFileInfo", { get: $util.oneOfGetter(gA = ["audioFileInfo"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.data != null && Object.hasOwnProperty.call(AA, "data") && IA.uint32(10).string(AA.data), AA.fileUploaderState != null && Object.hasOwnProperty.call(AA, "fileUploaderState") && $root.FileUploaderState.encode(AA.fileUploaderState, IA.uint32(18).fork()).ldelim(), AA.audioFileInfo != null && Object.hasOwnProperty.call(AA, "audioFileInfo") && $root.UploadedFileInfo.encode(AA.audioFileInfo, IA.uint32(26).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ChatInputValue();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.data = AA.string();
          break;
        case 2:
          EA.fileUploaderState = $root.FileUploaderState.decode(AA, AA.uint32());
          break;
        case 3:
          EA.audioFileInfo = $root.UploadedFileInfo.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ChatInputValue) return AA;
    let IA = new $root.ChatInputValue();
    if (AA.data != null && (IA.data = String(AA.data)), AA.fileUploaderState != null) {
      if (typeof AA.fileUploaderState != "object") throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      IA.fileUploaderState = $root.FileUploaderState.fromObject(AA.fileUploaderState);
    }
    if (AA.audioFileInfo != null) {
      if (typeof AA.audioFileInfo != "object") throw TypeError(".ChatInputValue.audioFileInfo: object expected");
      IA.audioFileInfo = $root.UploadedFileInfo.fromObject(AA.audioFileInfo);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return AA.data != null && AA.hasOwnProperty("data") && (BA.data = AA.data, IA.oneofs && (BA._data = "data")), AA.fileUploaderState != null && AA.hasOwnProperty("fileUploaderState") && (BA.fileUploaderState = $root.FileUploaderState.toObject(AA.fileUploaderState, IA), IA.oneofs && (BA._fileUploaderState = "fileUploaderState")), AA.audioFileInfo != null && AA.hasOwnProperty("audioFileInfo") && (BA.audioFileInfo = $root.UploadedFileInfo.toObject(AA.audioFileInfo, IA), IA.oneofs && (BA._audioFileInfo = "audioFileInfo")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ChatInputValue";
  }, CA;
})();
$root.ComponentInstance = (() => {
  function CA(AA) {
    if (this.specialArgs = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.jsonArgs = "", CA.prototype.specialArgs = $util.emptyArray, CA.prototype.componentName = "", CA.prototype.url = "", CA.prototype.formId = "", CA.prototype.tabIndex = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_tabIndex", { get: $util.oneOfGetter(gA = ["tabIndex"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.jsonArgs != null && Object.hasOwnProperty.call(AA, "jsonArgs") && IA.uint32(18).string(AA.jsonArgs), AA.specialArgs != null && AA.specialArgs.length) for (let BA = 0; BA < AA.specialArgs.length; ++BA) $root.SpecialArg.encode(AA.specialArgs[BA], IA.uint32(26).fork()).ldelim();
    return AA.componentName != null && Object.hasOwnProperty.call(AA, "componentName") && IA.uint32(34).string(AA.componentName), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(42).string(AA.url), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.tabIndex != null && Object.hasOwnProperty.call(AA, "tabIndex") && IA.uint32(56).int32(AA.tabIndex), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ComponentInstance();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.jsonArgs = AA.string();
          break;
        case 3:
          EA.specialArgs && EA.specialArgs.length || (EA.specialArgs = []), EA.specialArgs.push($root.SpecialArg.decode(AA, AA.uint32()));
          break;
        case 4:
          EA.componentName = AA.string();
          break;
        case 5:
          EA.url = AA.string();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 7:
          EA.tabIndex = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ComponentInstance) return AA;
    let IA = new $root.ComponentInstance();
    if (AA.id != null && (IA.id = String(AA.id)), AA.jsonArgs != null && (IA.jsonArgs = String(AA.jsonArgs)), AA.specialArgs) {
      if (!Array.isArray(AA.specialArgs)) throw TypeError(".ComponentInstance.specialArgs: array expected");
      IA.specialArgs = [];
      for (let BA = 0; BA < AA.specialArgs.length; ++BA) {
        if (typeof AA.specialArgs[BA] != "object") throw TypeError(".ComponentInstance.specialArgs: object expected");
        IA.specialArgs[BA] = $root.SpecialArg.fromObject(AA.specialArgs[BA]);
      }
    }
    return AA.componentName != null && (IA.componentName = String(AA.componentName)), AA.url != null && (IA.url = String(AA.url)), AA.formId != null && (IA.formId = String(AA.formId)), AA.tabIndex != null && (IA.tabIndex = AA.tabIndex | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.specialArgs = []), IA.defaults && (BA.id = "", BA.jsonArgs = "", BA.componentName = "", BA.url = "", BA.formId = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.jsonArgs != null && AA.hasOwnProperty("jsonArgs") && (BA.jsonArgs = AA.jsonArgs), AA.specialArgs && AA.specialArgs.length) {
      BA.specialArgs = [];
      for (let QA = 0; QA < AA.specialArgs.length; ++QA) BA.specialArgs[QA] = $root.SpecialArg.toObject(AA.specialArgs[QA], IA);
    }
    return AA.componentName != null && AA.hasOwnProperty("componentName") && (BA.componentName = AA.componentName), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.tabIndex != null && AA.hasOwnProperty("tabIndex") && (BA.tabIndex = AA.tabIndex, IA.oneofs && (BA._tabIndex = "tabIndex")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ComponentInstance";
  }, CA;
})();
$root.SpecialArg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.key = "", CA.prototype.arrowDataframe = null, CA.prototype.bytes = null;
  let gA;
  return Object.defineProperty(CA.prototype, "value", { get: $util.oneOfGetter(gA = ["arrowDataframe", "bytes"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.key != null && Object.hasOwnProperty.call(AA, "key") && IA.uint32(10).string(AA.key), AA.arrowDataframe != null && Object.hasOwnProperty.call(AA, "arrowDataframe") && $root.ArrowDataframe.encode(AA.arrowDataframe, IA.uint32(18).fork()).ldelim(), AA.bytes != null && Object.hasOwnProperty.call(AA, "bytes") && IA.uint32(26).bytes(AA.bytes), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.SpecialArg();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.key = AA.string();
          break;
        case 2:
          EA.arrowDataframe = $root.ArrowDataframe.decode(AA, AA.uint32());
          break;
        case 3:
          EA.bytes = AA.bytes();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.SpecialArg) return AA;
    let IA = new $root.SpecialArg();
    if (AA.key != null && (IA.key = String(AA.key)), AA.arrowDataframe != null) {
      if (typeof AA.arrowDataframe != "object") throw TypeError(".SpecialArg.arrowDataframe: object expected");
      IA.arrowDataframe = $root.ArrowDataframe.fromObject(AA.arrowDataframe);
    }
    return AA.bytes != null && (typeof AA.bytes == "string" ? $util.base64.decode(AA.bytes, IA.bytes = $util.newBuffer($util.base64.length(AA.bytes)), 0) : AA.bytes.length >= 0 && (IA.bytes = AA.bytes)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.key = ""), AA.key != null && AA.hasOwnProperty("key") && (BA.key = AA.key), AA.arrowDataframe != null && AA.hasOwnProperty("arrowDataframe") && (BA.arrowDataframe = $root.ArrowDataframe.toObject(AA.arrowDataframe, IA), IA.oneofs && (BA.value = "arrowDataframe")), AA.bytes != null && AA.hasOwnProperty("bytes") && (BA.bytes = IA.bytes === String ? $util.base64.encode(AA.bytes, 0, AA.bytes.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.bytes) : AA.bytes, IA.oneofs && (BA.value = "bytes")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/SpecialArg";
  }, CA;
})();
$root.ArrowDataframe = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = null, CA.prototype.height = 0, CA.prototype.width = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.data != null && Object.hasOwnProperty.call(gA, "data") && $root.ArrowTable.encode(gA.data, AA.uint32(10).fork()).ldelim(), gA.height != null && Object.hasOwnProperty.call(gA, "height") && AA.uint32(16).uint32(gA.height), gA.width != null && Object.hasOwnProperty.call(gA, "width") && AA.uint32(24).uint32(gA.width), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ArrowDataframe();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.data = $root.ArrowTable.decode(gA, gA.uint32());
          break;
        case 2:
          QA.height = gA.uint32();
          break;
        case 3:
          QA.width = gA.uint32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ArrowDataframe) return gA;
    let AA = new $root.ArrowDataframe();
    if (gA.data != null) {
      if (typeof gA.data != "object") throw TypeError(".ArrowDataframe.data: object expected");
      AA.data = $root.ArrowTable.fromObject(gA.data);
    }
    return gA.height != null && (AA.height = gA.height >>> 0), gA.width != null && (AA.width = gA.width >>> 0), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.data = null, IA.height = 0, IA.width = 0), gA.data != null && gA.hasOwnProperty("data") && (IA.data = $root.ArrowTable.toObject(gA.data, AA)), gA.height != null && gA.hasOwnProperty("height") && (IA.height = gA.height), gA.width != null && gA.hasOwnProperty("width") && (IA.width = gA.width), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ArrowDataframe";
  }, CA;
})();
$root.ArrowTable = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.data = $util.newBuffer([]), CA.prototype.index = $util.newBuffer([]), CA.prototype.columns = $util.newBuffer([]), CA.prototype.styler = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.data != null && Object.hasOwnProperty.call(gA, "data") && AA.uint32(10).bytes(gA.data), gA.index != null && Object.hasOwnProperty.call(gA, "index") && AA.uint32(18).bytes(gA.index), gA.columns != null && Object.hasOwnProperty.call(gA, "columns") && AA.uint32(26).bytes(gA.columns), gA.styler != null && Object.hasOwnProperty.call(gA, "styler") && $root.ArrowTableStyler.encode(gA.styler, AA.uint32(42).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ArrowTable();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.data = gA.bytes();
          break;
        case 2:
          QA.index = gA.bytes();
          break;
        case 3:
          QA.columns = gA.bytes();
          break;
        case 5:
          QA.styler = $root.ArrowTableStyler.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ArrowTable) return gA;
    let AA = new $root.ArrowTable();
    if (gA.data != null && (typeof gA.data == "string" ? $util.base64.decode(gA.data, AA.data = $util.newBuffer($util.base64.length(gA.data)), 0) : gA.data.length >= 0 && (AA.data = gA.data)), gA.index != null && (typeof gA.index == "string" ? $util.base64.decode(gA.index, AA.index = $util.newBuffer($util.base64.length(gA.index)), 0) : gA.index.length >= 0 && (AA.index = gA.index)), gA.columns != null && (typeof gA.columns == "string" ? $util.base64.decode(gA.columns, AA.columns = $util.newBuffer($util.base64.length(gA.columns)), 0) : gA.columns.length >= 0 && (AA.columns = gA.columns)), gA.styler != null) {
      if (typeof gA.styler != "object") throw TypeError(".ArrowTable.styler: object expected");
      AA.styler = $root.ArrowTableStyler.fromObject(gA.styler);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (AA.bytes === String ? IA.data = "" : (IA.data = [], AA.bytes !== Array && (IA.data = $util.newBuffer(IA.data))), AA.bytes === String ? IA.index = "" : (IA.index = [], AA.bytes !== Array && (IA.index = $util.newBuffer(IA.index))), AA.bytes === String ? IA.columns = "" : (IA.columns = [], AA.bytes !== Array && (IA.columns = $util.newBuffer(IA.columns))), IA.styler = null), gA.data != null && gA.hasOwnProperty("data") && (IA.data = AA.bytes === String ? $util.base64.encode(gA.data, 0, gA.data.length) : AA.bytes === Array ? Array.prototype.slice.call(gA.data) : gA.data), gA.index != null && gA.hasOwnProperty("index") && (IA.index = AA.bytes === String ? $util.base64.encode(gA.index, 0, gA.index.length) : AA.bytes === Array ? Array.prototype.slice.call(gA.index) : gA.index), gA.columns != null && gA.hasOwnProperty("columns") && (IA.columns = AA.bytes === String ? $util.base64.encode(gA.columns, 0, gA.columns.length) : AA.bytes === Array ? Array.prototype.slice.call(gA.columns) : gA.columns), gA.styler != null && gA.hasOwnProperty("styler") && (IA.styler = $root.ArrowTableStyler.toObject(gA.styler, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ArrowTable";
  }, CA;
})();
$root.ArrowTableStyler = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.uuid = "", CA.prototype.caption = "", CA.prototype.styles = "", CA.prototype.displayValues = $util.newBuffer([]), CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.uuid != null && Object.hasOwnProperty.call(gA, "uuid") && AA.uint32(10).string(gA.uuid), gA.caption != null && Object.hasOwnProperty.call(gA, "caption") && AA.uint32(18).string(gA.caption), gA.styles != null && Object.hasOwnProperty.call(gA, "styles") && AA.uint32(26).string(gA.styles), gA.displayValues != null && Object.hasOwnProperty.call(gA, "displayValues") && AA.uint32(34).bytes(gA.displayValues), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ArrowTableStyler();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.uuid = gA.string();
          break;
        case 2:
          QA.caption = gA.string();
          break;
        case 3:
          QA.styles = gA.string();
          break;
        case 4:
          QA.displayValues = gA.bytes();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ArrowTableStyler) return gA;
    let AA = new $root.ArrowTableStyler();
    return gA.uuid != null && (AA.uuid = String(gA.uuid)), gA.caption != null && (AA.caption = String(gA.caption)), gA.styles != null && (AA.styles = String(gA.styles)), gA.displayValues != null && (typeof gA.displayValues == "string" ? $util.base64.decode(gA.displayValues, AA.displayValues = $util.newBuffer($util.base64.length(gA.displayValues)), 0) : gA.displayValues.length >= 0 && (AA.displayValues = gA.displayValues)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.uuid = "", IA.caption = "", IA.styles = "", AA.bytes === String ? IA.displayValues = "" : (IA.displayValues = [], AA.bytes !== Array && (IA.displayValues = $util.newBuffer(IA.displayValues)))), gA.uuid != null && gA.hasOwnProperty("uuid") && (IA.uuid = gA.uuid), gA.caption != null && gA.hasOwnProperty("caption") && (IA.caption = gA.caption), gA.styles != null && gA.hasOwnProperty("styles") && (IA.styles = gA.styles), gA.displayValues != null && gA.hasOwnProperty("displayValues") && (IA.displayValues = AA.bytes === String ? $util.base64.encode(gA.displayValues, 0, gA.displayValues.length) : AA.bytes === Array ? Array.prototype.slice.call(gA.displayValues) : gA.displayValues), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ArrowTableStyler";
  }, CA;
})();
$root.Balloons = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.show = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.show != null && Object.hasOwnProperty.call(gA, "show") && AA.uint32(24).bool(gA.show), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Balloons();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 3 ? QA.show = gA.bool() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Balloons) return gA;
    let AA = new $root.Balloons();
    return gA.show != null && (AA.show = !!gA.show), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.show = !1), gA.show != null && gA.hasOwnProperty("show") && (IA.show = gA.show), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Balloons";
  }, CA;
})();
$root.MixedData = (() => {
  function CA(gA) {
    if (this.arrowBlobs = {}, gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.json = "", CA.prototype.arrowBlobs = $util.emptyObject, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.json != null && Object.hasOwnProperty.call(gA, "json") && AA.uint32(10).string(gA.json), gA.arrowBlobs != null && Object.hasOwnProperty.call(gA, "arrowBlobs")) for (let IA = Object.keys(gA.arrowBlobs), BA = 0; BA < IA.length; ++BA) AA.uint32(18).fork().uint32(10).string(IA[BA]), $root.ArrowData.encode(gA.arrowBlobs[IA[BA]], AA.uint32(18).fork()).ldelim().ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.MixedData(), EA, iA;
    for (; gA.pos < BA; ) {
      let oA = gA.uint32();
      if (oA === IA) break;
      switch (oA >>> 3) {
        case 1:
          QA.json = gA.string();
          break;
        case 2: {
          QA.arrowBlobs === $util.emptyObject && (QA.arrowBlobs = {});
          let cA = gA.uint32() + gA.pos;
          for (EA = "", iA = null; gA.pos < cA; ) {
            let tA = gA.uint32();
            switch (tA >>> 3) {
              case 1:
                EA = gA.string();
                break;
              case 2:
                iA = $root.ArrowData.decode(gA, gA.uint32());
                break;
              default:
                gA.skipType(tA & 7);
                break;
            }
          }
          QA.arrowBlobs[EA] = iA;
          break;
        }
        default:
          gA.skipType(oA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.MixedData) return gA;
    let AA = new $root.MixedData();
    if (gA.json != null && (AA.json = String(gA.json)), gA.arrowBlobs) {
      if (typeof gA.arrowBlobs != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
      AA.arrowBlobs = {};
      for (let IA = Object.keys(gA.arrowBlobs), BA = 0; BA < IA.length; ++BA) {
        if (typeof gA.arrowBlobs[IA[BA]] != "object") throw TypeError(".MixedData.arrowBlobs: object expected");
        AA.arrowBlobs[IA[BA]] = $root.ArrowData.fromObject(gA.arrowBlobs[IA[BA]]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    (AA.objects || AA.defaults) && (IA.arrowBlobs = {}), AA.defaults && (IA.json = ""), gA.json != null && gA.hasOwnProperty("json") && (IA.json = gA.json);
    let BA;
    if (gA.arrowBlobs && (BA = Object.keys(gA.arrowBlobs)).length) {
      IA.arrowBlobs = {};
      for (let QA = 0; QA < BA.length; ++QA) IA.arrowBlobs[BA[QA]] = $root.ArrowData.toObject(gA.arrowBlobs[BA[QA]], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/MixedData";
  }, CA;
})();
$root.BidiComponent = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.componentName = "", CA.prototype.jsContent = null, CA.prototype.jsSourcePath = null, CA.prototype.formId = "", CA.prototype.htmlContent = null, CA.prototype.cssContent = null, CA.prototype.cssSourcePath = null, CA.prototype.isolateStyles = !1, CA.prototype.json = null, CA.prototype.arrowData = null, CA.prototype.bytes = null, CA.prototype.mixed = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_jsContent", { get: $util.oneOfGetter(gA = ["jsContent"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_jsSourcePath", { get: $util.oneOfGetter(gA = ["jsSourcePath"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_htmlContent", { get: $util.oneOfGetter(gA = ["htmlContent"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_cssContent", { get: $util.oneOfGetter(gA = ["cssContent"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_cssSourcePath", { get: $util.oneOfGetter(gA = ["cssSourcePath"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "data", { get: $util.oneOfGetter(gA = ["json", "arrowData", "bytes", "mixed"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.componentName != null && Object.hasOwnProperty.call(AA, "componentName") && IA.uint32(18).string(AA.componentName), AA.jsContent != null && Object.hasOwnProperty.call(AA, "jsContent") && IA.uint32(26).string(AA.jsContent), AA.jsSourcePath != null && Object.hasOwnProperty.call(AA, "jsSourcePath") && IA.uint32(34).string(AA.jsSourcePath), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.htmlContent != null && Object.hasOwnProperty.call(AA, "htmlContent") && IA.uint32(50).string(AA.htmlContent), AA.cssContent != null && Object.hasOwnProperty.call(AA, "cssContent") && IA.uint32(58).string(AA.cssContent), AA.cssSourcePath != null && Object.hasOwnProperty.call(AA, "cssSourcePath") && IA.uint32(66).string(AA.cssSourcePath), AA.isolateStyles != null && Object.hasOwnProperty.call(AA, "isolateStyles") && IA.uint32(72).bool(AA.isolateStyles), AA.json != null && Object.hasOwnProperty.call(AA, "json") && IA.uint32(82).string(AA.json), AA.arrowData != null && Object.hasOwnProperty.call(AA, "arrowData") && $root.ArrowData.encode(AA.arrowData, IA.uint32(90).fork()).ldelim(), AA.bytes != null && Object.hasOwnProperty.call(AA, "bytes") && IA.uint32(98).bytes(AA.bytes), AA.mixed != null && Object.hasOwnProperty.call(AA, "mixed") && $root.MixedData.encode(AA.mixed, IA.uint32(106).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.BidiComponent();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.componentName = AA.string();
          break;
        case 3:
          EA.jsContent = AA.string();
          break;
        case 4:
          EA.jsSourcePath = AA.string();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.htmlContent = AA.string();
          break;
        case 7:
          EA.cssContent = AA.string();
          break;
        case 8:
          EA.cssSourcePath = AA.string();
          break;
        case 9:
          EA.isolateStyles = AA.bool();
          break;
        case 10:
          EA.json = AA.string();
          break;
        case 11:
          EA.arrowData = $root.ArrowData.decode(AA, AA.uint32());
          break;
        case 12:
          EA.bytes = AA.bytes();
          break;
        case 13:
          EA.mixed = $root.MixedData.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.BidiComponent) return AA;
    let IA = new $root.BidiComponent();
    if (AA.id != null && (IA.id = String(AA.id)), AA.componentName != null && (IA.componentName = String(AA.componentName)), AA.jsContent != null && (IA.jsContent = String(AA.jsContent)), AA.jsSourcePath != null && (IA.jsSourcePath = String(AA.jsSourcePath)), AA.formId != null && (IA.formId = String(AA.formId)), AA.htmlContent != null && (IA.htmlContent = String(AA.htmlContent)), AA.cssContent != null && (IA.cssContent = String(AA.cssContent)), AA.cssSourcePath != null && (IA.cssSourcePath = String(AA.cssSourcePath)), AA.isolateStyles != null && (IA.isolateStyles = !!AA.isolateStyles), AA.json != null && (IA.json = String(AA.json)), AA.arrowData != null) {
      if (typeof AA.arrowData != "object") throw TypeError(".BidiComponent.arrowData: object expected");
      IA.arrowData = $root.ArrowData.fromObject(AA.arrowData);
    }
    if (AA.bytes != null && (typeof AA.bytes == "string" ? $util.base64.decode(AA.bytes, IA.bytes = $util.newBuffer($util.base64.length(AA.bytes)), 0) : AA.bytes.length >= 0 && (IA.bytes = AA.bytes)), AA.mixed != null) {
      if (typeof AA.mixed != "object") throw TypeError(".BidiComponent.mixed: object expected");
      IA.mixed = $root.MixedData.fromObject(AA.mixed);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.componentName = "", BA.formId = "", BA.isolateStyles = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.componentName != null && AA.hasOwnProperty("componentName") && (BA.componentName = AA.componentName), AA.jsContent != null && AA.hasOwnProperty("jsContent") && (BA.jsContent = AA.jsContent, IA.oneofs && (BA._jsContent = "jsContent")), AA.jsSourcePath != null && AA.hasOwnProperty("jsSourcePath") && (BA.jsSourcePath = AA.jsSourcePath, IA.oneofs && (BA._jsSourcePath = "jsSourcePath")), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.htmlContent != null && AA.hasOwnProperty("htmlContent") && (BA.htmlContent = AA.htmlContent, IA.oneofs && (BA._htmlContent = "htmlContent")), AA.cssContent != null && AA.hasOwnProperty("cssContent") && (BA.cssContent = AA.cssContent, IA.oneofs && (BA._cssContent = "cssContent")), AA.cssSourcePath != null && AA.hasOwnProperty("cssSourcePath") && (BA.cssSourcePath = AA.cssSourcePath, IA.oneofs && (BA._cssSourcePath = "cssSourcePath")), AA.isolateStyles != null && AA.hasOwnProperty("isolateStyles") && (BA.isolateStyles = AA.isolateStyles), AA.json != null && AA.hasOwnProperty("json") && (BA.json = AA.json, IA.oneofs && (BA.data = "json")), AA.arrowData != null && AA.hasOwnProperty("arrowData") && (BA.arrowData = $root.ArrowData.toObject(AA.arrowData, IA), IA.oneofs && (BA.data = "arrowData")), AA.bytes != null && AA.hasOwnProperty("bytes") && (BA.bytes = IA.bytes === String ? $util.base64.encode(AA.bytes, 0, AA.bytes.length) : IA.bytes === Array ? Array.prototype.slice.call(AA.bytes) : AA.bytes, IA.oneofs && (BA.data = "bytes")), AA.mixed != null && AA.hasOwnProperty("mixed") && (BA.mixed = $root.MixedData.toObject(AA.mixed, IA), IA.oneofs && (BA.data = "mixed")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/BidiComponent";
  }, CA;
})();
$root.Block = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.vertical = null, CA.prototype.horizontal = null, CA.prototype.column = null, CA.prototype.expandable = null, CA.prototype.form = null, CA.prototype.tabContainer = null, CA.prototype.tab = null, CA.prototype.chatMessage = null, CA.prototype.popover = null, CA.prototype.dialog = null, CA.prototype.flexContainer = null, CA.prototype.allowEmpty = !1, CA.prototype.id = null, CA.prototype.heightConfig = null, CA.prototype.widthConfig = null, CA.prototype.autoscroll = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_id", { get: $util.oneOfGetter(gA = ["id"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_heightConfig", { get: $util.oneOfGetter(gA = ["heightConfig"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_widthConfig", { get: $util.oneOfGetter(gA = ["widthConfig"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_autoscroll", { get: $util.oneOfGetter(gA = ["autoscroll"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.vertical != null && Object.hasOwnProperty.call(AA, "vertical") && $root.Block.Vertical.encode(AA.vertical, IA.uint32(10).fork()).ldelim(), AA.horizontal != null && Object.hasOwnProperty.call(AA, "horizontal") && $root.Block.Horizontal.encode(AA.horizontal, IA.uint32(18).fork()).ldelim(), AA.column != null && Object.hasOwnProperty.call(AA, "column") && $root.Block.Column.encode(AA.column, IA.uint32(26).fork()).ldelim(), AA.expandable != null && Object.hasOwnProperty.call(AA, "expandable") && $root.Block.Expandable.encode(AA.expandable, IA.uint32(34).fork()).ldelim(), AA.form != null && Object.hasOwnProperty.call(AA, "form") && $root.Block.Form.encode(AA.form, IA.uint32(42).fork()).ldelim(), AA.tabContainer != null && Object.hasOwnProperty.call(AA, "tabContainer") && $root.Block.TabContainer.encode(AA.tabContainer, IA.uint32(50).fork()).ldelim(), AA.tab != null && Object.hasOwnProperty.call(AA, "tab") && $root.Block.Tab.encode(AA.tab, IA.uint32(58).fork()).ldelim(), AA.allowEmpty != null && Object.hasOwnProperty.call(AA, "allowEmpty") && IA.uint32(64).bool(AA.allowEmpty), AA.chatMessage != null && Object.hasOwnProperty.call(AA, "chatMessage") && $root.Block.ChatMessage.encode(AA.chatMessage, IA.uint32(74).fork()).ldelim(), AA.popover != null && Object.hasOwnProperty.call(AA, "popover") && $root.Block.Popover.encode(AA.popover, IA.uint32(82).fork()).ldelim(), AA.dialog != null && Object.hasOwnProperty.call(AA, "dialog") && $root.Block.Dialog.encode(AA.dialog, IA.uint32(90).fork()).ldelim(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(98).string(AA.id), AA.flexContainer != null && Object.hasOwnProperty.call(AA, "flexContainer") && $root.Block.FlexContainer.encode(AA.flexContainer, IA.uint32(106).fork()).ldelim(), AA.heightConfig != null && Object.hasOwnProperty.call(AA, "heightConfig") && $root.streamlit.HeightConfig.encode(AA.heightConfig, IA.uint32(114).fork()).ldelim(), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(122).fork()).ldelim(), AA.autoscroll != null && Object.hasOwnProperty.call(AA, "autoscroll") && IA.uint32(128).bool(AA.autoscroll), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Block();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.vertical = $root.Block.Vertical.decode(AA, AA.uint32());
          break;
        case 2:
          EA.horizontal = $root.Block.Horizontal.decode(AA, AA.uint32());
          break;
        case 3:
          EA.column = $root.Block.Column.decode(AA, AA.uint32());
          break;
        case 4:
          EA.expandable = $root.Block.Expandable.decode(AA, AA.uint32());
          break;
        case 5:
          EA.form = $root.Block.Form.decode(AA, AA.uint32());
          break;
        case 6:
          EA.tabContainer = $root.Block.TabContainer.decode(AA, AA.uint32());
          break;
        case 7:
          EA.tab = $root.Block.Tab.decode(AA, AA.uint32());
          break;
        case 9:
          EA.chatMessage = $root.Block.ChatMessage.decode(AA, AA.uint32());
          break;
        case 10:
          EA.popover = $root.Block.Popover.decode(AA, AA.uint32());
          break;
        case 11:
          EA.dialog = $root.Block.Dialog.decode(AA, AA.uint32());
          break;
        case 13:
          EA.flexContainer = $root.Block.FlexContainer.decode(AA, AA.uint32());
          break;
        case 8:
          EA.allowEmpty = AA.bool();
          break;
        case 12:
          EA.id = AA.string();
          break;
        case 14:
          EA.heightConfig = $root.streamlit.HeightConfig.decode(AA, AA.uint32());
          break;
        case 15:
          EA.widthConfig = $root.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        case 16:
          EA.autoscroll = AA.bool();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Block) return AA;
    let IA = new $root.Block();
    if (AA.vertical != null) {
      if (typeof AA.vertical != "object") throw TypeError(".Block.vertical: object expected");
      IA.vertical = $root.Block.Vertical.fromObject(AA.vertical);
    }
    if (AA.horizontal != null) {
      if (typeof AA.horizontal != "object") throw TypeError(".Block.horizontal: object expected");
      IA.horizontal = $root.Block.Horizontal.fromObject(AA.horizontal);
    }
    if (AA.column != null) {
      if (typeof AA.column != "object") throw TypeError(".Block.column: object expected");
      IA.column = $root.Block.Column.fromObject(AA.column);
    }
    if (AA.expandable != null) {
      if (typeof AA.expandable != "object") throw TypeError(".Block.expandable: object expected");
      IA.expandable = $root.Block.Expandable.fromObject(AA.expandable);
    }
    if (AA.form != null) {
      if (typeof AA.form != "object") throw TypeError(".Block.form: object expected");
      IA.form = $root.Block.Form.fromObject(AA.form);
    }
    if (AA.tabContainer != null) {
      if (typeof AA.tabContainer != "object") throw TypeError(".Block.tabContainer: object expected");
      IA.tabContainer = $root.Block.TabContainer.fromObject(AA.tabContainer);
    }
    if (AA.tab != null) {
      if (typeof AA.tab != "object") throw TypeError(".Block.tab: object expected");
      IA.tab = $root.Block.Tab.fromObject(AA.tab);
    }
    if (AA.chatMessage != null) {
      if (typeof AA.chatMessage != "object") throw TypeError(".Block.chatMessage: object expected");
      IA.chatMessage = $root.Block.ChatMessage.fromObject(AA.chatMessage);
    }
    if (AA.popover != null) {
      if (typeof AA.popover != "object") throw TypeError(".Block.popover: object expected");
      IA.popover = $root.Block.Popover.fromObject(AA.popover);
    }
    if (AA.dialog != null) {
      if (typeof AA.dialog != "object") throw TypeError(".Block.dialog: object expected");
      IA.dialog = $root.Block.Dialog.fromObject(AA.dialog);
    }
    if (AA.flexContainer != null) {
      if (typeof AA.flexContainer != "object") throw TypeError(".Block.flexContainer: object expected");
      IA.flexContainer = $root.Block.FlexContainer.fromObject(AA.flexContainer);
    }
    if (AA.allowEmpty != null && (IA.allowEmpty = !!AA.allowEmpty), AA.id != null && (IA.id = String(AA.id)), AA.heightConfig != null) {
      if (typeof AA.heightConfig != "object") throw TypeError(".Block.heightConfig: object expected");
      IA.heightConfig = $root.streamlit.HeightConfig.fromObject(AA.heightConfig);
    }
    if (AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Block.widthConfig: object expected");
      IA.widthConfig = $root.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    return AA.autoscroll != null && (IA.autoscroll = !!AA.autoscroll), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.allowEmpty = !1), AA.vertical != null && AA.hasOwnProperty("vertical") && (BA.vertical = $root.Block.Vertical.toObject(AA.vertical, IA), IA.oneofs && (BA.type = "vertical")), AA.horizontal != null && AA.hasOwnProperty("horizontal") && (BA.horizontal = $root.Block.Horizontal.toObject(AA.horizontal, IA), IA.oneofs && (BA.type = "horizontal")), AA.column != null && AA.hasOwnProperty("column") && (BA.column = $root.Block.Column.toObject(AA.column, IA), IA.oneofs && (BA.type = "column")), AA.expandable != null && AA.hasOwnProperty("expandable") && (BA.expandable = $root.Block.Expandable.toObject(AA.expandable, IA), IA.oneofs && (BA.type = "expandable")), AA.form != null && AA.hasOwnProperty("form") && (BA.form = $root.Block.Form.toObject(AA.form, IA), IA.oneofs && (BA.type = "form")), AA.tabContainer != null && AA.hasOwnProperty("tabContainer") && (BA.tabContainer = $root.Block.TabContainer.toObject(AA.tabContainer, IA), IA.oneofs && (BA.type = "tabContainer")), AA.tab != null && AA.hasOwnProperty("tab") && (BA.tab = $root.Block.Tab.toObject(AA.tab, IA), IA.oneofs && (BA.type = "tab")), AA.allowEmpty != null && AA.hasOwnProperty("allowEmpty") && (BA.allowEmpty = AA.allowEmpty), AA.chatMessage != null && AA.hasOwnProperty("chatMessage") && (BA.chatMessage = $root.Block.ChatMessage.toObject(AA.chatMessage, IA), IA.oneofs && (BA.type = "chatMessage")), AA.popover != null && AA.hasOwnProperty("popover") && (BA.popover = $root.Block.Popover.toObject(AA.popover, IA), IA.oneofs && (BA.type = "popover")), AA.dialog != null && AA.hasOwnProperty("dialog") && (BA.dialog = $root.Block.Dialog.toObject(AA.dialog, IA), IA.oneofs && (BA.type = "dialog")), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id, IA.oneofs && (BA._id = "id")), AA.flexContainer != null && AA.hasOwnProperty("flexContainer") && (BA.flexContainer = $root.Block.FlexContainer.toObject(AA.flexContainer, IA), IA.oneofs && (BA.type = "flexContainer")), AA.heightConfig != null && AA.hasOwnProperty("heightConfig") && (BA.heightConfig = $root.streamlit.HeightConfig.toObject(AA.heightConfig, IA), IA.oneofs && (BA._heightConfig = "heightConfig")), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root.streamlit.WidthConfig.toObject(AA.widthConfig, IA), IA.oneofs && (BA._widthConfig = "widthConfig")), AA.autoscroll != null && AA.hasOwnProperty("autoscroll") && (BA.autoscroll = AA.autoscroll, IA.oneofs && (BA._autoscroll = "autoscroll")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Block";
  }, CA.Vertical = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.border = !1, AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.border != null && Object.hasOwnProperty.call(IA, "border") && BA.uint32(8).bool(IA.border), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.Vertical();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? iA.border = IA.bool() : IA.skipType(oA & 7);
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.Vertical) return IA;
      let BA = new $root.Block.Vertical();
      return IA.border != null && (BA.border = !!IA.border), BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.border = !1), IA.border != null && IA.hasOwnProperty("border") && (QA.border = IA.border), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.Vertical";
    }, AA;
  })(), CA.Horizontal = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.gap = "", AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.gap != null && Object.hasOwnProperty.call(IA, "gap") && BA.uint32(10).string(IA.gap), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.Horizontal();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? iA.gap = IA.string() : IA.skipType(oA & 7);
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.Horizontal) return IA;
      let BA = new $root.Block.Horizontal();
      return IA.gap != null && (BA.gap = String(IA.gap)), BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.gap = ""), IA.gap != null && IA.hasOwnProperty("gap") && (QA.gap = IA.gap), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.Horizontal";
    }, AA;
  })(), CA.FlexContainer = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.border = !1, AA.prototype.gapConfig = null, AA.prototype.scale = 0, AA.prototype.direction = 0, AA.prototype.wrap = !1, AA.prototype.justify = 0, AA.prototype.align = 0, AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.border != null && Object.hasOwnProperty.call(IA, "border") && BA.uint32(8).bool(IA.border), IA.gapConfig != null && Object.hasOwnProperty.call(IA, "gapConfig") && $root.streamlit.GapConfig.encode(IA.gapConfig, BA.uint32(18).fork()).ldelim(), IA.scale != null && Object.hasOwnProperty.call(IA, "scale") && BA.uint32(29).float(IA.scale), IA.direction != null && Object.hasOwnProperty.call(IA, "direction") && BA.uint32(32).int32(IA.direction), IA.wrap != null && Object.hasOwnProperty.call(IA, "wrap") && BA.uint32(40).bool(IA.wrap), IA.justify != null && Object.hasOwnProperty.call(IA, "justify") && BA.uint32(56).int32(IA.justify), IA.align != null && Object.hasOwnProperty.call(IA, "align") && BA.uint32(64).int32(IA.align), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.FlexContainer();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.border = IA.bool();
            break;
          case 2:
            iA.gapConfig = $root.streamlit.GapConfig.decode(IA, IA.uint32());
            break;
          case 3:
            iA.scale = IA.float();
            break;
          case 4:
            iA.direction = IA.int32();
            break;
          case 5:
            iA.wrap = IA.bool();
            break;
          case 7:
            iA.justify = IA.int32();
            break;
          case 8:
            iA.align = IA.int32();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.FlexContainer) return IA;
      let BA = new $root.Block.FlexContainer();
      if (IA.border != null && (BA.border = !!IA.border), IA.gapConfig != null) {
        if (typeof IA.gapConfig != "object") throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        BA.gapConfig = $root.streamlit.GapConfig.fromObject(IA.gapConfig);
      }
      switch (IA.scale != null && (BA.scale = Number(IA.scale)), IA.direction) {
        default:
          if (typeof IA.direction == "number") {
            BA.direction = IA.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          BA.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          BA.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          BA.direction = 2;
          break;
      }
      switch (IA.wrap != null && (BA.wrap = !!IA.wrap), IA.justify) {
        default:
          if (typeof IA.justify == "number") {
            BA.justify = IA.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          BA.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          BA.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          BA.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          BA.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          BA.justify = 4;
          break;
      }
      switch (IA.align) {
        default:
          if (typeof IA.align == "number") {
            BA.align = IA.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          BA.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          BA.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          BA.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          BA.align = 3;
          break;
        case "STRETCH":
        case 4:
          BA.align = 4;
          break;
      }
      return BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.border = !1, QA.gapConfig = null, QA.scale = 0, QA.direction = BA.enums === String ? "DIRECTION_UNDEFINED" : 0, QA.wrap = !1, QA.justify = BA.enums === String ? "JUSTIFY_UNDEFINED" : 0, QA.align = BA.enums === String ? "ALIGN_UNDEFINED" : 0), IA.border != null && IA.hasOwnProperty("border") && (QA.border = IA.border), IA.gapConfig != null && IA.hasOwnProperty("gapConfig") && (QA.gapConfig = $root.streamlit.GapConfig.toObject(IA.gapConfig, BA)), IA.scale != null && IA.hasOwnProperty("scale") && (QA.scale = BA.json && !isFinite(IA.scale) ? String(IA.scale) : IA.scale), IA.direction != null && IA.hasOwnProperty("direction") && (QA.direction = BA.enums === String ? $root.Block.FlexContainer.Direction[IA.direction] === void 0 ? IA.direction : $root.Block.FlexContainer.Direction[IA.direction] : IA.direction), IA.wrap != null && IA.hasOwnProperty("wrap") && (QA.wrap = IA.wrap), IA.justify != null && IA.hasOwnProperty("justify") && (QA.justify = BA.enums === String ? $root.Block.FlexContainer.Justify[IA.justify] === void 0 ? IA.justify : $root.Block.FlexContainer.Justify[IA.justify] : IA.justify), IA.align != null && IA.hasOwnProperty("align") && (QA.align = BA.enums === String ? $root.Block.FlexContainer.Align[IA.align] === void 0 ? IA.align : $root.Block.FlexContainer.Align[IA.align] : IA.align), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.FlexContainer";
    }, AA.Direction = (function() {
      let IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "DIRECTION_UNDEFINED"] = 0, BA[IA[1] = "VERTICAL"] = 1, BA[IA[2] = "HORIZONTAL"] = 2, BA;
    })(), AA.Justify = (function() {
      let IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "JUSTIFY_UNDEFINED"] = 0, BA[IA[1] = "JUSTIFY_START"] = 1, BA[IA[2] = "JUSTIFY_END"] = 2, BA[IA[3] = "JUSTIFY_CENTER"] = 3, BA[IA[4] = "SPACE_BETWEEN"] = 4, BA;
    })(), AA.Align = (function() {
      let IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "ALIGN_UNDEFINED"] = 0, BA[IA[1] = "ALIGN_START"] = 1, BA[IA[2] = "ALIGN_END"] = 2, BA[IA[3] = "ALIGN_CENTER"] = 3, BA[IA[4] = "STRETCH"] = 4, BA;
    })(), AA;
  })(), CA.Column = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.weight = 0, AA.prototype.verticalAlignment = 0, AA.prototype.showBorder = !1, AA.prototype.gapConfig = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_gapConfig", { get: $util.oneOfGetter(IA = ["gapConfig"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.weight != null && Object.hasOwnProperty.call(BA, "weight") && QA.uint32(9).double(BA.weight), BA.verticalAlignment != null && Object.hasOwnProperty.call(BA, "verticalAlignment") && QA.uint32(24).int32(BA.verticalAlignment), BA.showBorder != null && Object.hasOwnProperty.call(BA, "showBorder") && QA.uint32(32).bool(BA.showBorder), BA.gapConfig != null && Object.hasOwnProperty.call(BA, "gapConfig") && $root.streamlit.GapConfig.encode(BA.gapConfig, QA.uint32(42).fork()).ldelim(), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.Block.Column();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.weight = BA.double();
            break;
          case 3:
            oA.verticalAlignment = BA.int32();
            break;
          case 4:
            oA.showBorder = BA.bool();
            break;
          case 5:
            oA.gapConfig = $root.streamlit.GapConfig.decode(BA, BA.uint32());
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.Block.Column) return BA;
      let QA = new $root.Block.Column();
      switch (BA.weight != null && (QA.weight = Number(BA.weight)), BA.verticalAlignment) {
        default:
          if (typeof BA.verticalAlignment == "number") {
            QA.verticalAlignment = BA.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          QA.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          QA.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          QA.verticalAlignment = 2;
          break;
      }
      if (BA.showBorder != null && (QA.showBorder = !!BA.showBorder), BA.gapConfig != null) {
        if (typeof BA.gapConfig != "object") throw TypeError(".Block.Column.gapConfig: object expected");
        QA.gapConfig = $root.streamlit.GapConfig.fromObject(BA.gapConfig);
      }
      return QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.weight = 0, EA.verticalAlignment = QA.enums === String ? "TOP" : 0, EA.showBorder = !1), BA.weight != null && BA.hasOwnProperty("weight") && (EA.weight = QA.json && !isFinite(BA.weight) ? String(BA.weight) : BA.weight), BA.verticalAlignment != null && BA.hasOwnProperty("verticalAlignment") && (EA.verticalAlignment = QA.enums === String ? $root.Block.Column.VerticalAlignment[BA.verticalAlignment] === void 0 ? BA.verticalAlignment : $root.Block.Column.VerticalAlignment[BA.verticalAlignment] : BA.verticalAlignment), BA.showBorder != null && BA.hasOwnProperty("showBorder") && (EA.showBorder = BA.showBorder), BA.gapConfig != null && BA.hasOwnProperty("gapConfig") && (EA.gapConfig = $root.streamlit.GapConfig.toObject(BA.gapConfig, QA), QA.oneofs && (EA._gapConfig = "gapConfig")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Column";
    }, AA.VerticalAlignment = (function() {
      let BA = {}, QA = Object.create(BA);
      return QA[BA[0] = "TOP"] = 0, QA[BA[1] = "CENTER"] = 1, QA[BA[2] = "BOTTOM"] = 2, QA;
    })(), AA;
  })(), CA.Expandable = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.label = "", AA.prototype.expanded = null, AA.prototype.icon = "", AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_expanded", { get: $util.oneOfGetter(IA = ["expanded"]), set: $util.oneOfSetter(IA) }), Object.defineProperty(AA.prototype, "_id", { get: $util.oneOfGetter(IA = ["id"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.label != null && Object.hasOwnProperty.call(BA, "label") && QA.uint32(10).string(BA.label), BA.expanded != null && Object.hasOwnProperty.call(BA, "expanded") && QA.uint32(16).bool(BA.expanded), BA.icon != null && Object.hasOwnProperty.call(BA, "icon") && QA.uint32(26).string(BA.icon), BA.id != null && Object.hasOwnProperty.call(BA, "id") && QA.uint32(34).string(BA.id), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.Block.Expandable();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.label = BA.string();
            break;
          case 2:
            oA.expanded = BA.bool();
            break;
          case 3:
            oA.icon = BA.string();
            break;
          case 4:
            oA.id = BA.string();
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.Block.Expandable) return BA;
      let QA = new $root.Block.Expandable();
      return BA.label != null && (QA.label = String(BA.label)), BA.expanded != null && (QA.expanded = !!BA.expanded), BA.icon != null && (QA.icon = String(BA.icon)), BA.id != null && (QA.id = String(BA.id)), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.label = "", EA.icon = ""), BA.label != null && BA.hasOwnProperty("label") && (EA.label = BA.label), BA.expanded != null && BA.hasOwnProperty("expanded") && (EA.expanded = BA.expanded, QA.oneofs && (EA._expanded = "expanded")), BA.icon != null && BA.hasOwnProperty("icon") && (EA.icon = BA.icon), BA.id != null && BA.hasOwnProperty("id") && (EA.id = BA.id, QA.oneofs && (EA._id = "id")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Expandable";
    }, AA;
  })(), CA.Dialog = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.title = "", AA.prototype.dismissible = !1, AA.prototype.width = 0, AA.prototype.isOpen = null, AA.prototype.id = "", AA.prototype.icon = "";
    let IA;
    return Object.defineProperty(AA.prototype, "_isOpen", { get: $util.oneOfGetter(IA = ["isOpen"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.title != null && Object.hasOwnProperty.call(BA, "title") && QA.uint32(10).string(BA.title), BA.dismissible != null && Object.hasOwnProperty.call(BA, "dismissible") && QA.uint32(16).bool(BA.dismissible), BA.width != null && Object.hasOwnProperty.call(BA, "width") && QA.uint32(24).int32(BA.width), BA.isOpen != null && Object.hasOwnProperty.call(BA, "isOpen") && QA.uint32(32).bool(BA.isOpen), BA.id != null && Object.hasOwnProperty.call(BA, "id") && QA.uint32(42).string(BA.id), BA.icon != null && Object.hasOwnProperty.call(BA, "icon") && QA.uint32(50).string(BA.icon), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.Block.Dialog();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.title = BA.string();
            break;
          case 2:
            oA.dismissible = BA.bool();
            break;
          case 3:
            oA.width = BA.int32();
            break;
          case 4:
            oA.isOpen = BA.bool();
            break;
          case 5:
            oA.id = BA.string();
            break;
          case 6:
            oA.icon = BA.string();
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.Block.Dialog) return BA;
      let QA = new $root.Block.Dialog();
      switch (BA.title != null && (QA.title = String(BA.title)), BA.dismissible != null && (QA.dismissible = !!BA.dismissible), BA.width) {
        default:
          if (typeof BA.width == "number") {
            QA.width = BA.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          QA.width = 0;
          break;
        case "LARGE":
        case 1:
          QA.width = 1;
          break;
        case "MEDIUM":
        case 2:
          QA.width = 2;
          break;
      }
      return BA.isOpen != null && (QA.isOpen = !!BA.isOpen), BA.id != null && (QA.id = String(BA.id)), BA.icon != null && (QA.icon = String(BA.icon)), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.title = "", EA.dismissible = !1, EA.width = QA.enums === String ? "SMALL" : 0, EA.id = "", EA.icon = ""), BA.title != null && BA.hasOwnProperty("title") && (EA.title = BA.title), BA.dismissible != null && BA.hasOwnProperty("dismissible") && (EA.dismissible = BA.dismissible), BA.width != null && BA.hasOwnProperty("width") && (EA.width = QA.enums === String ? $root.Block.Dialog.DialogWidth[BA.width] === void 0 ? BA.width : $root.Block.Dialog.DialogWidth[BA.width] : BA.width), BA.isOpen != null && BA.hasOwnProperty("isOpen") && (EA.isOpen = BA.isOpen, QA.oneofs && (EA._isOpen = "isOpen")), BA.id != null && BA.hasOwnProperty("id") && (EA.id = BA.id), BA.icon != null && BA.hasOwnProperty("icon") && (EA.icon = BA.icon), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Dialog";
    }, AA.DialogWidth = (function() {
      let BA = {}, QA = Object.create(BA);
      return QA[BA[0] = "SMALL"] = 0, QA[BA[1] = "LARGE"] = 1, QA[BA[2] = "MEDIUM"] = 2, QA;
    })(), AA;
  })(), CA.Form = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.formId = "", AA.prototype.clearOnSubmit = !1, AA.prototype.border = !1, AA.prototype.enterToSubmit = !1, AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.formId != null && Object.hasOwnProperty.call(IA, "formId") && BA.uint32(10).string(IA.formId), IA.clearOnSubmit != null && Object.hasOwnProperty.call(IA, "clearOnSubmit") && BA.uint32(16).bool(IA.clearOnSubmit), IA.border != null && Object.hasOwnProperty.call(IA, "border") && BA.uint32(24).bool(IA.border), IA.enterToSubmit != null && Object.hasOwnProperty.call(IA, "enterToSubmit") && BA.uint32(32).bool(IA.enterToSubmit), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.Form();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.formId = IA.string();
            break;
          case 2:
            iA.clearOnSubmit = IA.bool();
            break;
          case 3:
            iA.border = IA.bool();
            break;
          case 4:
            iA.enterToSubmit = IA.bool();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.Form) return IA;
      let BA = new $root.Block.Form();
      return IA.formId != null && (BA.formId = String(IA.formId)), IA.clearOnSubmit != null && (BA.clearOnSubmit = !!IA.clearOnSubmit), IA.border != null && (BA.border = !!IA.border), IA.enterToSubmit != null && (BA.enterToSubmit = !!IA.enterToSubmit), BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.formId = "", QA.clearOnSubmit = !1, QA.border = !1, QA.enterToSubmit = !1), IA.formId != null && IA.hasOwnProperty("formId") && (QA.formId = IA.formId), IA.clearOnSubmit != null && IA.hasOwnProperty("clearOnSubmit") && (QA.clearOnSubmit = IA.clearOnSubmit), IA.border != null && IA.hasOwnProperty("border") && (QA.border = IA.border), IA.enterToSubmit != null && IA.hasOwnProperty("enterToSubmit") && (QA.enterToSubmit = IA.enterToSubmit), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.Form";
    }, AA;
  })(), CA.TabContainer = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.defaultTabIndex = 0, AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_id", { get: $util.oneOfGetter(IA = ["id"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.defaultTabIndex != null && Object.hasOwnProperty.call(BA, "defaultTabIndex") && QA.uint32(8).int32(BA.defaultTabIndex), BA.id != null && Object.hasOwnProperty.call(BA, "id") && QA.uint32(18).string(BA.id), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.Block.TabContainer();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.defaultTabIndex = BA.int32();
            break;
          case 2:
            oA.id = BA.string();
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.Block.TabContainer) return BA;
      let QA = new $root.Block.TabContainer();
      return BA.defaultTabIndex != null && (QA.defaultTabIndex = BA.defaultTabIndex | 0), BA.id != null && (QA.id = String(BA.id)), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.defaultTabIndex = 0), BA.defaultTabIndex != null && BA.hasOwnProperty("defaultTabIndex") && (EA.defaultTabIndex = BA.defaultTabIndex), BA.id != null && BA.hasOwnProperty("id") && (EA.id = BA.id, QA.oneofs && (EA._id = "id")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.TabContainer";
    }, AA;
  })(), CA.Tab = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.label = "", AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.label != null && Object.hasOwnProperty.call(IA, "label") && BA.uint32(10).string(IA.label), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.Tab();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        oA >>> 3 === 1 ? iA.label = IA.string() : IA.skipType(oA & 7);
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.Tab) return IA;
      let BA = new $root.Block.Tab();
      return IA.label != null && (BA.label = String(IA.label)), BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.label = ""), IA.label != null && IA.hasOwnProperty("label") && (QA.label = IA.label), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.Tab";
    }, AA;
  })(), CA.Popover = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.label = "", AA.prototype.help = "", AA.prototype.disabled = !1, AA.prototype.icon = "", AA.prototype.type = "", AA.prototype.open = null, AA.prototype.id = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_open", { get: $util.oneOfGetter(IA = ["open"]), set: $util.oneOfSetter(IA) }), Object.defineProperty(AA.prototype, "_id", { get: $util.oneOfGetter(IA = ["id"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.label != null && Object.hasOwnProperty.call(BA, "label") && QA.uint32(10).string(BA.label), BA.help != null && Object.hasOwnProperty.call(BA, "help") && QA.uint32(26).string(BA.help), BA.disabled != null && Object.hasOwnProperty.call(BA, "disabled") && QA.uint32(32).bool(BA.disabled), BA.icon != null && Object.hasOwnProperty.call(BA, "icon") && QA.uint32(42).string(BA.icon), BA.type != null && Object.hasOwnProperty.call(BA, "type") && QA.uint32(50).string(BA.type), BA.open != null && Object.hasOwnProperty.call(BA, "open") && QA.uint32(56).bool(BA.open), BA.id != null && Object.hasOwnProperty.call(BA, "id") && QA.uint32(66).string(BA.id), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.Block.Popover();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.label = BA.string();
            break;
          case 3:
            oA.help = BA.string();
            break;
          case 4:
            oA.disabled = BA.bool();
            break;
          case 5:
            oA.icon = BA.string();
            break;
          case 6:
            oA.type = BA.string();
            break;
          case 7:
            oA.open = BA.bool();
            break;
          case 8:
            oA.id = BA.string();
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.Block.Popover) return BA;
      let QA = new $root.Block.Popover();
      return BA.label != null && (QA.label = String(BA.label)), BA.help != null && (QA.help = String(BA.help)), BA.disabled != null && (QA.disabled = !!BA.disabled), BA.icon != null && (QA.icon = String(BA.icon)), BA.type != null && (QA.type = String(BA.type)), BA.open != null && (QA.open = !!BA.open), BA.id != null && (QA.id = String(BA.id)), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.label = "", EA.help = "", EA.disabled = !1, EA.icon = "", EA.type = ""), BA.label != null && BA.hasOwnProperty("label") && (EA.label = BA.label), BA.help != null && BA.hasOwnProperty("help") && (EA.help = BA.help), BA.disabled != null && BA.hasOwnProperty("disabled") && (EA.disabled = BA.disabled), BA.icon != null && BA.hasOwnProperty("icon") && (EA.icon = BA.icon), BA.type != null && BA.hasOwnProperty("type") && (EA.type = BA.type), BA.open != null && BA.hasOwnProperty("open") && (EA.open = BA.open, QA.oneofs && (EA._open = "open")), BA.id != null && BA.hasOwnProperty("id") && (EA.id = BA.id, QA.oneofs && (EA._id = "id")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/Block.Popover";
    }, AA;
  })(), CA.ChatMessage = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.name = "", AA.prototype.avatar = "", AA.prototype.avatarType = 0, AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.name != null && Object.hasOwnProperty.call(IA, "name") && BA.uint32(10).string(IA.name), IA.avatar != null && Object.hasOwnProperty.call(IA, "avatar") && BA.uint32(18).string(IA.avatar), IA.avatarType != null && Object.hasOwnProperty.call(IA, "avatarType") && BA.uint32(24).int32(IA.avatarType), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.Block.ChatMessage();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.name = IA.string();
            break;
          case 2:
            iA.avatar = IA.string();
            break;
          case 3:
            iA.avatarType = IA.int32();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.Block.ChatMessage) return IA;
      let BA = new $root.Block.ChatMessage();
      switch (IA.name != null && (BA.name = String(IA.name)), IA.avatar != null && (BA.avatar = String(IA.avatar)), IA.avatarType) {
        default:
          if (typeof IA.avatarType == "number") {
            BA.avatarType = IA.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          BA.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          BA.avatarType = 1;
          break;
        case "ICON":
        case 2:
          BA.avatarType = 2;
          break;
      }
      return BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.name = "", QA.avatar = "", QA.avatarType = BA.enums === String ? "IMAGE" : 0), IA.name != null && IA.hasOwnProperty("name") && (QA.name = IA.name), IA.avatar != null && IA.hasOwnProperty("avatar") && (QA.avatar = IA.avatar), IA.avatarType != null && IA.hasOwnProperty("avatarType") && (QA.avatarType = BA.enums === String ? $root.Block.ChatMessage.AvatarType[IA.avatarType] === void 0 ? IA.avatarType : $root.Block.ChatMessage.AvatarType[IA.avatarType] : IA.avatarType), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/Block.ChatMessage";
    }, AA.AvatarType = (function() {
      let IA = {}, BA = Object.create(IA);
      return BA[IA[0] = "IMAGE"] = 0, BA[IA[1] = "EMOJI"] = 1, BA[IA[2] = "ICON"] = 2, BA;
    })(), AA;
  })(), CA;
})();
$root.Button = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.isFormSubmitter = !1, CA.prototype.type = "", CA.prototype.disabled = !1, CA.prototype.icon = "", CA.prototype.shortcut = "", CA.prototype.iconPosition = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(10).string(gA.id), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(18).string(gA.label), gA.default != null && Object.hasOwnProperty.call(gA, "default") && AA.uint32(24).bool(gA.default), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(34).string(gA.help), gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(42).string(gA.formId), gA.isFormSubmitter != null && Object.hasOwnProperty.call(gA, "isFormSubmitter") && AA.uint32(48).bool(gA.isFormSubmitter), gA.type != null && Object.hasOwnProperty.call(gA, "type") && AA.uint32(58).string(gA.type), gA.disabled != null && Object.hasOwnProperty.call(gA, "disabled") && AA.uint32(64).bool(gA.disabled), gA.icon != null && Object.hasOwnProperty.call(gA, "icon") && AA.uint32(82).string(gA.icon), gA.shortcut != null && Object.hasOwnProperty.call(gA, "shortcut") && AA.uint32(90).string(gA.shortcut), gA.iconPosition != null && Object.hasOwnProperty.call(gA, "iconPosition") && AA.uint32(96).int32(gA.iconPosition), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Button();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.id = gA.string();
          break;
        case 2:
          QA.label = gA.string();
          break;
        case 3:
          QA.default = gA.bool();
          break;
        case 4:
          QA.help = gA.string();
          break;
        case 5:
          QA.formId = gA.string();
          break;
        case 6:
          QA.isFormSubmitter = gA.bool();
          break;
        case 7:
          QA.type = gA.string();
          break;
        case 8:
          QA.disabled = gA.bool();
          break;
        case 10:
          QA.icon = gA.string();
          break;
        case 11:
          QA.shortcut = gA.string();
          break;
        case 12:
          QA.iconPosition = gA.int32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Button) return gA;
    let AA = new $root.Button();
    switch (gA.id != null && (AA.id = String(gA.id)), gA.label != null && (AA.label = String(gA.label)), gA.default != null && (AA.default = !!gA.default), gA.help != null && (AA.help = String(gA.help)), gA.formId != null && (AA.formId = String(gA.formId)), gA.isFormSubmitter != null && (AA.isFormSubmitter = !!gA.isFormSubmitter), gA.type != null && (AA.type = String(gA.type)), gA.disabled != null && (AA.disabled = !!gA.disabled), gA.icon != null && (AA.icon = String(gA.icon)), gA.shortcut != null && (AA.shortcut = String(gA.shortcut)), gA.iconPosition) {
      default:
        if (typeof gA.iconPosition == "number") {
          AA.iconPosition = gA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        AA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        AA.iconPosition = 1;
        break;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.id = "", IA.label = "", IA.default = !1, IA.help = "", IA.formId = "", IA.isFormSubmitter = !1, IA.type = "", IA.disabled = !1, IA.icon = "", IA.shortcut = "", IA.iconPosition = AA.enums === String ? "LEFT" : 0), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.default != null && gA.hasOwnProperty("default") && (IA.default = gA.default), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), gA.isFormSubmitter != null && gA.hasOwnProperty("isFormSubmitter") && (IA.isFormSubmitter = gA.isFormSubmitter), gA.type != null && gA.hasOwnProperty("type") && (IA.type = gA.type), gA.disabled != null && gA.hasOwnProperty("disabled") && (IA.disabled = gA.disabled), gA.icon != null && gA.hasOwnProperty("icon") && (IA.icon = gA.icon), gA.shortcut != null && gA.hasOwnProperty("shortcut") && (IA.shortcut = gA.shortcut), gA.iconPosition != null && gA.hasOwnProperty("iconPosition") && (IA.iconPosition = AA.enums === String ? $root.streamlit.ButtonLikeIconPosition[gA.iconPosition] === void 0 ? gA.iconPosition : $root.streamlit.ButtonLikeIconPosition[gA.iconPosition] : gA.iconPosition), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Button";
  }, CA;
})();
$root.ButtonGroup = (() => {
  function CA(AA) {
    if (this.options = [], this.default = [], this.rawValues = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.options = $util.emptyArray, CA.prototype.default = $util.emptyArray, CA.prototype.disabled = !1, CA.prototype.clickMode = 0, CA.prototype.formId = "", CA.prototype.setValue = !1, CA.prototype.style = 0, CA.prototype.label = "", CA.prototype.labelVisibility = null, CA.prototype.help = null, CA.prototype.rawValues = $util.emptyArray, CA.prototype.queryParamKey = null, CA.prototype.required = !1;
  let gA;
  return Object.defineProperty(CA.prototype, "_help", { get: $util.oneOfGetter(gA = ["help"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) $root.ButtonGroup.Option.encode(AA.options[BA], IA.uint32(18).fork()).ldelim();
    if (AA.default != null && AA.default.length) {
      IA.uint32(26).fork();
      for (let BA = 0; BA < AA.default.length; ++BA) IA.uint32(AA.default[BA]);
      IA.ldelim();
    }
    if (AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(32).bool(AA.disabled), AA.clickMode != null && Object.hasOwnProperty.call(AA, "clickMode") && IA.uint32(40).int32(AA.clickMode), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(64).bool(AA.setValue), AA.style != null && Object.hasOwnProperty.call(AA, "style") && IA.uint32(80).int32(AA.style), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(90).string(AA.label), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(98).fork()).ldelim(), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(106).string(AA.help), AA.rawValues != null && AA.rawValues.length) for (let BA = 0; BA < AA.rawValues.length; ++BA) IA.uint32(114).string(AA.rawValues[BA]);
    return AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(122).string(AA.queryParamKey), AA.required != null && Object.hasOwnProperty.call(AA, "required") && IA.uint32(128).bool(AA.required), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ButtonGroup();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.options && EA.options.length || (EA.options = []), EA.options.push($root.ButtonGroup.Option.decode(AA, AA.uint32()));
          break;
        case 3:
          if (EA.default && EA.default.length || (EA.default = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.default.push(AA.uint32());
          } else EA.default.push(AA.uint32());
          break;
        case 4:
          EA.disabled = AA.bool();
          break;
        case 5:
          EA.clickMode = AA.int32();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 8:
          EA.setValue = AA.bool();
          break;
        case 10:
          EA.style = AA.int32();
          break;
        case 11:
          EA.label = AA.string();
          break;
        case 12:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 13:
          EA.help = AA.string();
          break;
        case 14:
          EA.rawValues && EA.rawValues.length || (EA.rawValues = []), EA.rawValues.push(AA.string());
          break;
        case 15:
          EA.queryParamKey = AA.string();
          break;
        case 16:
          EA.required = AA.bool();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ButtonGroup) return AA;
    let IA = new $root.ButtonGroup();
    if (AA.id != null && (IA.id = String(AA.id)), AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".ButtonGroup.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) {
        if (typeof AA.options[BA] != "object") throw TypeError(".ButtonGroup.options: object expected");
        IA.options[BA] = $root.ButtonGroup.Option.fromObject(AA.options[BA]);
      }
    }
    if (AA.default) {
      if (!Array.isArray(AA.default)) throw TypeError(".ButtonGroup.default: array expected");
      IA.default = [];
      for (let BA = 0; BA < AA.default.length; ++BA) IA.default[BA] = AA.default[BA] >>> 0;
    }
    switch (AA.disabled != null && (IA.disabled = !!AA.disabled), AA.clickMode) {
      default:
        if (typeof AA.clickMode == "number") {
          IA.clickMode = AA.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        IA.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        IA.clickMode = 1;
        break;
    }
    switch (AA.formId != null && (IA.formId = String(AA.formId)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.style) {
      default:
        if (typeof AA.style == "number") {
          IA.style = AA.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        IA.style = 0;
        break;
      case "PILLS":
      case 1:
        IA.style = 1;
        break;
    }
    if (AA.label != null && (IA.label = String(AA.label)), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".ButtonGroup.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.rawValues) {
      if (!Array.isArray(AA.rawValues)) throw TypeError(".ButtonGroup.rawValues: array expected");
      IA.rawValues = [];
      for (let BA = 0; BA < AA.rawValues.length; ++BA) IA.rawValues[BA] = String(AA.rawValues[BA]);
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), AA.required != null && (IA.required = !!AA.required), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.options = [], BA.default = [], BA.rawValues = []), IA.defaults && (BA.id = "", BA.disabled = !1, BA.clickMode = IA.enums === String ? "SINGLE_SELECT" : 0, BA.formId = "", BA.setValue = !1, BA.style = IA.enums === String ? "SEGMENTED_CONTROL" : 0, BA.label = "", BA.labelVisibility = null, BA.required = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = $root.ButtonGroup.Option.toObject(AA.options[QA], IA);
    }
    if (AA.default && AA.default.length) {
      BA.default = [];
      for (let QA = 0; QA < AA.default.length; ++QA) BA.default[QA] = AA.default[QA];
    }
    if (AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.clickMode != null && AA.hasOwnProperty("clickMode") && (BA.clickMode = IA.enums === String ? $root.ButtonGroup.ClickMode[AA.clickMode] === void 0 ? AA.clickMode : $root.ButtonGroup.ClickMode[AA.clickMode] : AA.clickMode), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.style != null && AA.hasOwnProperty("style") && (BA.style = IA.enums === String ? $root.ButtonGroup.Style[AA.style] === void 0 ? AA.style : $root.ButtonGroup.Style[AA.style] : AA.style), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help, IA.oneofs && (BA._help = "help")), AA.rawValues && AA.rawValues.length) {
      BA.rawValues = [];
      for (let QA = 0; QA < AA.rawValues.length; ++QA) BA.rawValues[QA] = AA.rawValues[QA];
    }
    return AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), AA.required != null && AA.hasOwnProperty("required") && (BA.required = AA.required), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ButtonGroup";
  }, CA.ClickMode = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SINGLE_SELECT"] = 0, IA[AA[1] = "MULTI_SELECT"] = 1, IA;
  })(), CA.Option = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.content = "", AA.prototype.contentIcon = null;
    let IA;
    return Object.defineProperty(AA.prototype, "_contentIcon", { get: $util.oneOfGetter(IA = ["contentIcon"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.content != null && Object.hasOwnProperty.call(BA, "content") && QA.uint32(10).string(BA.content), BA.contentIcon != null && Object.hasOwnProperty.call(BA, "contentIcon") && QA.uint32(26).string(BA.contentIcon), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.ButtonGroup.Option();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        switch (cA >>> 3) {
          case 1:
            oA.content = BA.string();
            break;
          case 3:
            oA.contentIcon = BA.string();
            break;
          default:
            BA.skipType(cA & 7);
            break;
        }
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.ButtonGroup.Option) return BA;
      let QA = new $root.ButtonGroup.Option();
      return BA.content != null && (QA.content = String(BA.content)), BA.contentIcon != null && (QA.contentIcon = String(BA.contentIcon)), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return QA.defaults && (EA.content = ""), BA.content != null && BA.hasOwnProperty("content") && (EA.content = BA.content), BA.contentIcon != null && BA.hasOwnProperty("contentIcon") && (EA.contentIcon = BA.contentIcon, QA.oneofs && (EA._contentIcon = "contentIcon")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/ButtonGroup.Option";
    }, AA;
  })(), CA.Style = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SEGMENTED_CONTROL"] = 0, IA[AA[1] = "PILLS"] = 1, IA;
  })(), CA;
})();
$root.CameraInput = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(10).string(gA.id), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(18).string(gA.label), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(26).string(gA.help), gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(34).string(gA.formId), gA.disabled != null && Object.hasOwnProperty.call(gA, "disabled") && AA.uint32(40).bool(gA.disabled), gA.labelVisibility != null && Object.hasOwnProperty.call(gA, "labelVisibility") && $root.LabelVisibility.encode(gA.labelVisibility, AA.uint32(50).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.CameraInput();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.id = gA.string();
          break;
        case 2:
          QA.label = gA.string();
          break;
        case 3:
          QA.help = gA.string();
          break;
        case 4:
          QA.formId = gA.string();
          break;
        case 5:
          QA.disabled = gA.bool();
          break;
        case 6:
          QA.labelVisibility = $root.LabelVisibility.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.CameraInput) return gA;
    let AA = new $root.CameraInput();
    if (gA.id != null && (AA.id = String(gA.id)), gA.label != null && (AA.label = String(gA.label)), gA.help != null && (AA.help = String(gA.help)), gA.formId != null && (AA.formId = String(gA.formId)), gA.disabled != null && (AA.disabled = !!gA.disabled), gA.labelVisibility != null) {
      if (typeof gA.labelVisibility != "object") throw TypeError(".CameraInput.labelVisibility: object expected");
      AA.labelVisibility = $root.LabelVisibility.fromObject(gA.labelVisibility);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.id = "", IA.label = "", IA.help = "", IA.formId = "", IA.disabled = !1, IA.labelVisibility = null), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), gA.disabled != null && gA.hasOwnProperty("disabled") && (IA.disabled = gA.disabled), gA.labelVisibility != null && gA.hasOwnProperty("labelVisibility") && (IA.labelVisibility = $root.LabelVisibility.toObject(gA.labelVisibility, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/CameraInput";
  }, CA;
})();
$root.ChatInput = (() => {
  function CA(AA) {
    if (this.fileType = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.placeholder = "", CA.prototype.maxChars = 0, CA.prototype.disabled = !1, CA.prototype.value = "", CA.prototype.setValue = !1, CA.prototype.default = "", CA.prototype.acceptFile = 0, CA.prototype.fileType = $util.emptyArray, CA.prototype.maxUploadSizeMb = 0, CA.prototype.acceptAudio = !1, CA.prototype.audioSampleRate = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_audioSampleRate", { get: $util.oneOfGetter(gA = ["audioSampleRate"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(18).string(AA.placeholder), AA.maxChars != null && Object.hasOwnProperty.call(AA, "maxChars") && IA.uint32(24).uint32(AA.maxChars), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(32).bool(AA.disabled), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(42).string(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(48).bool(AA.setValue), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(58).string(AA.default), AA.acceptFile != null && Object.hasOwnProperty.call(AA, "acceptFile") && IA.uint32(72).int32(AA.acceptFile), AA.fileType != null && AA.fileType.length) for (let BA = 0; BA < AA.fileType.length; ++BA) IA.uint32(82).string(AA.fileType[BA]);
    return AA.maxUploadSizeMb != null && Object.hasOwnProperty.call(AA, "maxUploadSizeMb") && IA.uint32(88).int32(AA.maxUploadSizeMb), AA.acceptAudio != null && Object.hasOwnProperty.call(AA, "acceptAudio") && IA.uint32(96).bool(AA.acceptAudio), AA.audioSampleRate != null && Object.hasOwnProperty.call(AA, "audioSampleRate") && IA.uint32(104).int32(AA.audioSampleRate), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ChatInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.placeholder = AA.string();
          break;
        case 3:
          EA.maxChars = AA.uint32();
          break;
        case 4:
          EA.disabled = AA.bool();
          break;
        case 5:
          EA.value = AA.string();
          break;
        case 6:
          EA.setValue = AA.bool();
          break;
        case 7:
          EA.default = AA.string();
          break;
        case 9:
          EA.acceptFile = AA.int32();
          break;
        case 10:
          EA.fileType && EA.fileType.length || (EA.fileType = []), EA.fileType.push(AA.string());
          break;
        case 11:
          EA.maxUploadSizeMb = AA.int32();
          break;
        case 12:
          EA.acceptAudio = AA.bool();
          break;
        case 13:
          EA.audioSampleRate = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ChatInput) return AA;
    let IA = new $root.ChatInput();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.maxChars != null && (IA.maxChars = AA.maxChars >>> 0), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.value != null && (IA.value = String(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.default != null && (IA.default = String(AA.default)), AA.acceptFile) {
      default:
        if (typeof AA.acceptFile == "number") {
          IA.acceptFile = AA.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        IA.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        IA.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        IA.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        IA.acceptFile = 3;
        break;
    }
    if (AA.fileType) {
      if (!Array.isArray(AA.fileType)) throw TypeError(".ChatInput.fileType: array expected");
      IA.fileType = [];
      for (let BA = 0; BA < AA.fileType.length; ++BA) IA.fileType[BA] = String(AA.fileType[BA]);
    }
    return AA.maxUploadSizeMb != null && (IA.maxUploadSizeMb = AA.maxUploadSizeMb | 0), AA.acceptAudio != null && (IA.acceptAudio = !!AA.acceptAudio), AA.audioSampleRate != null && (IA.audioSampleRate = AA.audioSampleRate | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.fileType = []), IA.defaults && (BA.id = "", BA.placeholder = "", BA.maxChars = 0, BA.disabled = !1, BA.value = "", BA.setValue = !1, BA.default = "", BA.acceptFile = IA.enums === String ? "NONE" : 0, BA.maxUploadSizeMb = 0, BA.acceptAudio = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.maxChars != null && AA.hasOwnProperty("maxChars") && (BA.maxChars = AA.maxChars), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default), AA.acceptFile != null && AA.hasOwnProperty("acceptFile") && (BA.acceptFile = IA.enums === String ? $root.ChatInput.AcceptFile[AA.acceptFile] === void 0 ? AA.acceptFile : $root.ChatInput.AcceptFile[AA.acceptFile] : AA.acceptFile), AA.fileType && AA.fileType.length) {
      BA.fileType = [];
      for (let QA = 0; QA < AA.fileType.length; ++QA) BA.fileType[QA] = AA.fileType[QA];
    }
    return AA.maxUploadSizeMb != null && AA.hasOwnProperty("maxUploadSizeMb") && (BA.maxUploadSizeMb = AA.maxUploadSizeMb), AA.acceptAudio != null && AA.hasOwnProperty("acceptAudio") && (BA.acceptAudio = AA.acceptAudio), AA.audioSampleRate != null && AA.hasOwnProperty("audioSampleRate") && (BA.audioSampleRate = AA.audioSampleRate, IA.oneofs && (BA._audioSampleRate = "audioSampleRate")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ChatInput";
  }, CA.AcceptFile = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "NONE"] = 0, IA[AA[1] = "SINGLE"] = 1, IA[AA[2] = "MULTIPLE"] = 2, IA[AA[3] = "DIRECTORY"] = 3, IA;
  })(), CA;
})();
$root.Checkbox = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = !1, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.type = 0, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(24).bool(AA.default), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(34).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(48).bool(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(56).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(64).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(74).fork()).ldelim(), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(80).int32(AA.type), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(90).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Checkbox();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.bool();
          break;
        case 4:
          EA.help = AA.string();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.value = AA.bool();
          break;
        case 7:
          EA.setValue = AA.bool();
          break;
        case 8:
          EA.disabled = AA.bool();
          break;
        case 9:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 10:
          EA.type = AA.int32();
          break;
        case 11:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Checkbox) return AA;
    let IA = new $root.Checkbox();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = !!AA.default), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = !!AA.value), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".Checkbox.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    switch (AA.type) {
      default:
        if (typeof AA.type == "number") {
          IA.type = AA.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        IA.type = 0;
        break;
      case "TOGGLE":
      case 1:
        IA.type = 1;
        break;
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.default = !1, BA.help = "", BA.formId = "", BA.value = !1, BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.type = IA.enums === String ? "DEFAULT" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.Checkbox.StyleType[AA.type] === void 0 ? AA.type : $root.Checkbox.StyleType[AA.type] : AA.type), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Checkbox";
  }, CA.StyleType = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "DEFAULT"] = 0, IA[AA[1] = "TOGGLE"] = 1, IA;
  })(), CA;
})();
$root.Code = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.codeText = "", CA.prototype.language = "", CA.prototype.showLineNumbers = !1, CA.prototype.wrapLines = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.codeText != null && Object.hasOwnProperty.call(gA, "codeText") && AA.uint32(10).string(gA.codeText), gA.language != null && Object.hasOwnProperty.call(gA, "language") && AA.uint32(18).string(gA.language), gA.showLineNumbers != null && Object.hasOwnProperty.call(gA, "showLineNumbers") && AA.uint32(24).bool(gA.showLineNumbers), gA.wrapLines != null && Object.hasOwnProperty.call(gA, "wrapLines") && AA.uint32(32).bool(gA.wrapLines), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Code();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.codeText = gA.string();
          break;
        case 2:
          QA.language = gA.string();
          break;
        case 3:
          QA.showLineNumbers = gA.bool();
          break;
        case 4:
          QA.wrapLines = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Code) return gA;
    let AA = new $root.Code();
    return gA.codeText != null && (AA.codeText = String(gA.codeText)), gA.language != null && (AA.language = String(gA.language)), gA.showLineNumbers != null && (AA.showLineNumbers = !!gA.showLineNumbers), gA.wrapLines != null && (AA.wrapLines = !!gA.wrapLines), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.codeText = "", IA.language = "", IA.showLineNumbers = !1, IA.wrapLines = !1), gA.codeText != null && gA.hasOwnProperty("codeText") && (IA.codeText = gA.codeText), gA.language != null && gA.hasOwnProperty("language") && (IA.language = gA.language), gA.showLineNumbers != null && gA.hasOwnProperty("showLineNumbers") && (IA.showLineNumbers = gA.showLineNumbers), gA.wrapLines != null && gA.hasOwnProperty("wrapLines") && (IA.wrapLines = gA.wrapLines), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Code";
  }, CA;
})();
$root.ColorPicker = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = "", CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(26).string(AA.default), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(34).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(50).string(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(56).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(64).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(74).fork()).ldelim(), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(82).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ColorPicker();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.string();
          break;
        case 4:
          EA.help = AA.string();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.value = AA.string();
          break;
        case 7:
          EA.setValue = AA.bool();
          break;
        case 8:
          EA.disabled = AA.bool();
          break;
        case 9:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 10:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ColorPicker) return AA;
    let IA = new $root.ColorPicker();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = String(AA.default)), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = String(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".ColorPicker.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.default = "", BA.help = "", BA.formId = "", BA.value = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ColorPicker";
  }, CA;
})();
$root.Dataframe = (() => {
  function CA(AA) {
    if (this.columnOrder = [], this.selectionMode = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.arrowData = null, CA.prototype.id = "", CA.prototype.columns = "", CA.prototype.editingMode = 0, CA.prototype.disabled = !1, CA.prototype.formId = "", CA.prototype.columnOrder = $util.emptyArray, CA.prototype.selectionMode = $util.emptyArray, CA.prototype.rowHeight = null, CA.prototype.placeholder = null, CA.prototype.selectionState = null, CA.prototype.selectionDefault = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_rowHeight", { get: $util.oneOfGetter(gA = ["rowHeight"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_placeholder", { get: $util.oneOfGetter(gA = ["placeholder"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_selectionState", { get: $util.oneOfGetter(gA = ["selectionState"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_selectionDefault", { get: $util.oneOfGetter(gA = ["selectionDefault"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.arrowData != null && Object.hasOwnProperty.call(AA, "arrowData") && $root.ArrowData.encode(AA.arrowData, IA.uint32(10).fork()).ldelim(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(18).string(AA.id), AA.columns != null && Object.hasOwnProperty.call(AA, "columns") && IA.uint32(26).string(AA.columns), AA.editingMode != null && Object.hasOwnProperty.call(AA, "editingMode") && IA.uint32(32).int32(AA.editingMode), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(40).bool(AA.disabled), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.columnOrder != null && AA.columnOrder.length) for (let BA = 0; BA < AA.columnOrder.length; ++BA) IA.uint32(58).string(AA.columnOrder[BA]);
    if (AA.selectionMode != null && AA.selectionMode.length) {
      IA.uint32(66).fork();
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) IA.int32(AA.selectionMode[BA]);
      IA.ldelim();
    }
    return AA.rowHeight != null && Object.hasOwnProperty.call(AA, "rowHeight") && IA.uint32(72).uint32(AA.rowHeight), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(82).string(AA.placeholder), AA.selectionState != null && Object.hasOwnProperty.call(AA, "selectionState") && IA.uint32(90).string(AA.selectionState), AA.selectionDefault != null && Object.hasOwnProperty.call(AA, "selectionDefault") && IA.uint32(98).string(AA.selectionDefault), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Dataframe();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.arrowData = $root.ArrowData.decode(AA, AA.uint32());
          break;
        case 2:
          EA.id = AA.string();
          break;
        case 3:
          EA.columns = AA.string();
          break;
        case 4:
          EA.editingMode = AA.int32();
          break;
        case 5:
          EA.disabled = AA.bool();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 7:
          EA.columnOrder && EA.columnOrder.length || (EA.columnOrder = []), EA.columnOrder.push(AA.string());
          break;
        case 8:
          if (EA.selectionMode && EA.selectionMode.length || (EA.selectionMode = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.selectionMode.push(AA.int32());
          } else EA.selectionMode.push(AA.int32());
          break;
        case 9:
          EA.rowHeight = AA.uint32();
          break;
        case 10:
          EA.placeholder = AA.string();
          break;
        case 11:
          EA.selectionState = AA.string();
          break;
        case 12:
          EA.selectionDefault = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Dataframe) return AA;
    let IA = new $root.Dataframe();
    if (AA.arrowData != null) {
      if (typeof AA.arrowData != "object") throw TypeError(".Dataframe.arrowData: object expected");
      IA.arrowData = $root.ArrowData.fromObject(AA.arrowData);
    }
    switch (AA.id != null && (IA.id = String(AA.id)), AA.columns != null && (IA.columns = String(AA.columns)), AA.editingMode) {
      default:
        if (typeof AA.editingMode == "number") {
          IA.editingMode = AA.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        IA.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        IA.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        IA.editingMode = 2;
        break;
      case "ADD_ONLY":
      case 3:
        IA.editingMode = 3;
        break;
      case "DELETE_ONLY":
      case 4:
        IA.editingMode = 4;
        break;
    }
    if (AA.disabled != null && (IA.disabled = !!AA.disabled), AA.formId != null && (IA.formId = String(AA.formId)), AA.columnOrder) {
      if (!Array.isArray(AA.columnOrder)) throw TypeError(".Dataframe.columnOrder: array expected");
      IA.columnOrder = [];
      for (let BA = 0; BA < AA.columnOrder.length; ++BA) IA.columnOrder[BA] = String(AA.columnOrder[BA]);
    }
    if (AA.selectionMode) {
      if (!Array.isArray(AA.selectionMode)) throw TypeError(".Dataframe.selectionMode: array expected");
      IA.selectionMode = [];
      for (let BA = 0; BA < AA.selectionMode.length; ++BA) switch (AA.selectionMode[BA]) {
        default:
          if (typeof AA.selectionMode[BA] == "number") {
            IA.selectionMode[BA] = AA.selectionMode[BA];
            break;
          }
        case "SINGLE_ROW":
        case 0:
          IA.selectionMode[BA] = 0;
          break;
        case "MULTI_ROW":
        case 1:
          IA.selectionMode[BA] = 1;
          break;
        case "SINGLE_COLUMN":
        case 2:
          IA.selectionMode[BA] = 2;
          break;
        case "MULTI_COLUMN":
        case 3:
          IA.selectionMode[BA] = 3;
          break;
        case "SINGLE_CELL":
        case 4:
          IA.selectionMode[BA] = 4;
          break;
        case "MULTI_CELL":
        case 5:
          IA.selectionMode[BA] = 5;
          break;
        case "SINGLE_ROW_REQUIRED":
        case 6:
          IA.selectionMode[BA] = 6;
          break;
      }
    }
    return AA.rowHeight != null && (IA.rowHeight = AA.rowHeight >>> 0), AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.selectionState != null && (IA.selectionState = String(AA.selectionState)), AA.selectionDefault != null && (IA.selectionDefault = String(AA.selectionDefault)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.columnOrder = [], BA.selectionMode = []), IA.defaults && (BA.arrowData = null, BA.id = "", BA.columns = "", BA.editingMode = IA.enums === String ? "READ_ONLY" : 0, BA.disabled = !1, BA.formId = ""), AA.arrowData != null && AA.hasOwnProperty("arrowData") && (BA.arrowData = $root.ArrowData.toObject(AA.arrowData, IA)), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.columns != null && AA.hasOwnProperty("columns") && (BA.columns = AA.columns), AA.editingMode != null && AA.hasOwnProperty("editingMode") && (BA.editingMode = IA.enums === String ? $root.Dataframe.EditingMode[AA.editingMode] === void 0 ? AA.editingMode : $root.Dataframe.EditingMode[AA.editingMode] : AA.editingMode), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.columnOrder && AA.columnOrder.length) {
      BA.columnOrder = [];
      for (let QA = 0; QA < AA.columnOrder.length; ++QA) BA.columnOrder[QA] = AA.columnOrder[QA];
    }
    if (AA.selectionMode && AA.selectionMode.length) {
      BA.selectionMode = [];
      for (let QA = 0; QA < AA.selectionMode.length; ++QA) BA.selectionMode[QA] = IA.enums === String ? $root.Dataframe.SelectionMode[AA.selectionMode[QA]] === void 0 ? AA.selectionMode[QA] : $root.Dataframe.SelectionMode[AA.selectionMode[QA]] : AA.selectionMode[QA];
    }
    return AA.rowHeight != null && AA.hasOwnProperty("rowHeight") && (BA.rowHeight = AA.rowHeight, IA.oneofs && (BA._rowHeight = "rowHeight")), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder, IA.oneofs && (BA._placeholder = "placeholder")), AA.selectionState != null && AA.hasOwnProperty("selectionState") && (BA.selectionState = AA.selectionState, IA.oneofs && (BA._selectionState = "selectionState")), AA.selectionDefault != null && AA.hasOwnProperty("selectionDefault") && (BA.selectionDefault = AA.selectionDefault, IA.oneofs && (BA._selectionDefault = "selectionDefault")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Dataframe";
  }, CA.EditingMode = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "READ_ONLY"] = 0, IA[AA[1] = "FIXED"] = 1, IA[AA[2] = "DYNAMIC"] = 2, IA[AA[3] = "ADD_ONLY"] = 3, IA[AA[4] = "DELETE_ONLY"] = 4, IA;
  })(), CA.SelectionMode = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "SINGLE_ROW"] = 0, IA[AA[1] = "MULTI_ROW"] = 1, IA[AA[2] = "SINGLE_COLUMN"] = 2, IA[AA[3] = "MULTI_COLUMN"] = 3, IA[AA[4] = "SINGLE_CELL"] = 4, IA[AA[5] = "MULTI_CELL"] = 5, IA[AA[6] = "SINGLE_ROW_REQUIRED"] = 6, IA;
  })(), CA;
})();
$root.DateInput = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util.emptyArray, CA.prototype.min = "", CA.prototype.max = "", CA.prototype.isRange = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = $util.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.format = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && AA.default.length) for (let BA = 0; BA < AA.default.length; ++BA) IA.uint32(26).string(AA.default[BA]);
    if (AA.min != null && Object.hasOwnProperty.call(AA, "min") && IA.uint32(34).string(AA.min), AA.max != null && Object.hasOwnProperty.call(AA, "max") && IA.uint32(42).string(AA.max), AA.isRange != null && Object.hasOwnProperty.call(AA, "isRange") && IA.uint32(48).bool(AA.isRange), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(58).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(66).string(AA.formId), AA.value != null && AA.value.length) for (let BA = 0; BA < AA.value.length; ++BA) IA.uint32(74).string(AA.value[BA]);
    return AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(80).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(88).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(98).fork()).ldelim(), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(106).string(AA.format), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(114).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.DateInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default && EA.default.length || (EA.default = []), EA.default.push(AA.string());
          break;
        case 4:
          EA.min = AA.string();
          break;
        case 5:
          EA.max = AA.string();
          break;
        case 6:
          EA.isRange = AA.bool();
          break;
        case 7:
          EA.help = AA.string();
          break;
        case 8:
          EA.formId = AA.string();
          break;
        case 9:
          EA.value && EA.value.length || (EA.value = []), EA.value.push(AA.string());
          break;
        case 10:
          EA.setValue = AA.bool();
          break;
        case 11:
          EA.disabled = AA.bool();
          break;
        case 12:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 13:
          EA.format = AA.string();
          break;
        case 14:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.DateInput) return AA;
    let IA = new $root.DateInput();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default) {
      if (!Array.isArray(AA.default)) throw TypeError(".DateInput.default: array expected");
      IA.default = [];
      for (let BA = 0; BA < AA.default.length; ++BA) IA.default[BA] = String(AA.default[BA]);
    }
    if (AA.min != null && (IA.min = String(AA.min)), AA.max != null && (IA.max = String(AA.max)), AA.isRange != null && (IA.isRange = !!AA.isRange), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value) {
      if (!Array.isArray(AA.value)) throw TypeError(".DateInput.value: array expected");
      IA.value = [];
      for (let BA = 0; BA < AA.value.length; ++BA) IA.value[BA] = String(AA.value[BA]);
    }
    if (AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".DateInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.format != null && (IA.format = String(AA.format)), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.default = [], BA.value = []), IA.defaults && (BA.id = "", BA.label = "", BA.min = "", BA.max = "", BA.isRange = !1, BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.format = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default && AA.default.length) {
      BA.default = [];
      for (let QA = 0; QA < AA.default.length; ++QA) BA.default[QA] = AA.default[QA];
    }
    if (AA.min != null && AA.hasOwnProperty("min") && (BA.min = AA.min), AA.max != null && AA.hasOwnProperty("max") && (BA.max = AA.max), AA.isRange != null && AA.hasOwnProperty("isRange") && (BA.isRange = AA.isRange), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value && AA.value.length) {
      BA.value = [];
      for (let QA = 0; QA < AA.value.length; ++QA) BA.value[QA] = AA.value[QA];
    }
    return AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.format != null && AA.hasOwnProperty("format") && (BA.format = AA.format), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DateInput";
  }, CA;
})();
$root.DateTimeInput = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util.emptyArray, CA.prototype.min = "", CA.prototype.max = "", CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = $util.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.format = "", CA.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.isRange = !1, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && AA.default.length) for (let BA = 0; BA < AA.default.length; ++BA) IA.uint32(26).string(AA.default[BA]);
    if (AA.min != null && Object.hasOwnProperty.call(AA, "min") && IA.uint32(34).string(AA.min), AA.max != null && Object.hasOwnProperty.call(AA, "max") && IA.uint32(42).string(AA.max), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(50).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(58).string(AA.formId), AA.value != null && AA.value.length) for (let BA = 0; BA < AA.value.length; ++BA) IA.uint32(66).string(AA.value[BA]);
    return AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(72).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(80).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(90).fork()).ldelim(), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(98).string(AA.format), AA.step != null && Object.hasOwnProperty.call(AA, "step") && IA.uint32(104).int64(AA.step), AA.isRange != null && Object.hasOwnProperty.call(AA, "isRange") && IA.uint32(112).bool(AA.isRange), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(122).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.DateTimeInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default && EA.default.length || (EA.default = []), EA.default.push(AA.string());
          break;
        case 4:
          EA.min = AA.string();
          break;
        case 5:
          EA.max = AA.string();
          break;
        case 6:
          EA.help = AA.string();
          break;
        case 7:
          EA.formId = AA.string();
          break;
        case 8:
          EA.value && EA.value.length || (EA.value = []), EA.value.push(AA.string());
          break;
        case 9:
          EA.setValue = AA.bool();
          break;
        case 10:
          EA.disabled = AA.bool();
          break;
        case 11:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 12:
          EA.format = AA.string();
          break;
        case 13:
          EA.step = AA.int64();
          break;
        case 14:
          EA.isRange = AA.bool();
          break;
        case 15:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.DateTimeInput) return AA;
    let IA = new $root.DateTimeInput();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default) {
      if (!Array.isArray(AA.default)) throw TypeError(".DateTimeInput.default: array expected");
      IA.default = [];
      for (let BA = 0; BA < AA.default.length; ++BA) IA.default[BA] = String(AA.default[BA]);
    }
    if (AA.min != null && (IA.min = String(AA.min)), AA.max != null && (IA.max = String(AA.max)), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value) {
      if (!Array.isArray(AA.value)) throw TypeError(".DateTimeInput.value: array expected");
      IA.value = [];
      for (let BA = 0; BA < AA.value.length; ++BA) IA.value[BA] = String(AA.value[BA]);
    }
    if (AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".DateTimeInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.format != null && (IA.format = String(AA.format)), AA.step != null && ($util.Long ? (IA.step = $util.Long.fromValue(AA.step)).unsigned = !1 : typeof AA.step == "string" ? IA.step = parseInt(AA.step, 10) : typeof AA.step == "number" ? IA.step = AA.step : typeof AA.step == "object" && (IA.step = new $util.LongBits(AA.step.low >>> 0, AA.step.high >>> 0).toNumber())), AA.isRange != null && (IA.isRange = !!AA.isRange), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.default = [], BA.value = []), IA.defaults) {
      if (BA.id = "", BA.label = "", BA.min = "", BA.max = "", BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.format = "", $util.Long) {
        let QA = new $util.Long(0, 0, !1);
        BA.step = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
      } else BA.step = IA.longs === String ? "0" : 0;
      BA.isRange = !1;
    }
    if (AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default && AA.default.length) {
      BA.default = [];
      for (let QA = 0; QA < AA.default.length; ++QA) BA.default[QA] = AA.default[QA];
    }
    if (AA.min != null && AA.hasOwnProperty("min") && (BA.min = AA.min), AA.max != null && AA.hasOwnProperty("max") && (BA.max = AA.max), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value && AA.value.length) {
      BA.value = [];
      for (let QA = 0; QA < AA.value.length; ++QA) BA.value[QA] = AA.value[QA];
    }
    return AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.format != null && AA.hasOwnProperty("format") && (BA.format = AA.format), AA.step != null && AA.hasOwnProperty("step") && (typeof AA.step == "number" ? BA.step = IA.longs === String ? String(AA.step) : AA.step : BA.step = IA.longs === String ? $util.Long.prototype.toString.call(AA.step) : IA.longs === Number ? new $util.LongBits(AA.step.low >>> 0, AA.step.high >>> 0).toNumber() : AA.step), AA.isRange != null && AA.hasOwnProperty("isRange") && (BA.isRange = AA.isRange), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DateTimeInput";
  }, CA;
})();
$root.DeckGlJsonChart = (() => {
  function CA(gA) {
    if (this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.json = "", CA.prototype.tooltip = "", CA.prototype.id = "", CA.prototype.mapboxToken = "", CA.prototype.selectionMode = $util.emptyArray, CA.prototype.formId = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.json != null && Object.hasOwnProperty.call(gA, "json") && AA.uint32(10).string(gA.json), gA.tooltip != null && Object.hasOwnProperty.call(gA, "tooltip") && AA.uint32(18).string(gA.tooltip), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(42).string(gA.id), gA.mapboxToken != null && Object.hasOwnProperty.call(gA, "mapboxToken") && AA.uint32(50).string(gA.mapboxToken), gA.selectionMode != null && gA.selectionMode.length) {
      AA.uint32(74).fork();
      for (let IA = 0; IA < gA.selectionMode.length; ++IA) AA.int32(gA.selectionMode[IA]);
      AA.ldelim();
    }
    return gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(82).string(gA.formId), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.DeckGlJsonChart();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.json = gA.string();
          break;
        case 2:
          QA.tooltip = gA.string();
          break;
        case 5:
          QA.id = gA.string();
          break;
        case 6:
          QA.mapboxToken = gA.string();
          break;
        case 9:
          if (QA.selectionMode && QA.selectionMode.length || (QA.selectionMode = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.selectionMode.push(gA.int32());
          } else QA.selectionMode.push(gA.int32());
          break;
        case 10:
          QA.formId = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.DeckGlJsonChart) return gA;
    let AA = new $root.DeckGlJsonChart();
    if (gA.json != null && (AA.json = String(gA.json)), gA.tooltip != null && (AA.tooltip = String(gA.tooltip)), gA.id != null && (AA.id = String(gA.id)), gA.mapboxToken != null && (AA.mapboxToken = String(gA.mapboxToken)), gA.selectionMode) {
      if (!Array.isArray(gA.selectionMode)) throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      AA.selectionMode = [];
      for (let IA = 0; IA < gA.selectionMode.length; ++IA) switch (gA.selectionMode[IA]) {
        default:
          if (typeof gA.selectionMode[IA] == "number") {
            AA.selectionMode[IA] = gA.selectionMode[IA];
            break;
          }
        case "SINGLE_OBJECT":
        case 0:
          AA.selectionMode[IA] = 0;
          break;
        case "MULTI_OBJECT":
        case 1:
          AA.selectionMode[IA] = 1;
          break;
      }
    }
    return gA.formId != null && (AA.formId = String(gA.formId)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.selectionMode = []), AA.defaults && (IA.json = "", IA.tooltip = "", IA.id = "", IA.mapboxToken = "", IA.formId = ""), gA.json != null && gA.hasOwnProperty("json") && (IA.json = gA.json), gA.tooltip != null && gA.hasOwnProperty("tooltip") && (IA.tooltip = gA.tooltip), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.mapboxToken != null && gA.hasOwnProperty("mapboxToken") && (IA.mapboxToken = gA.mapboxToken), gA.selectionMode && gA.selectionMode.length) {
      IA.selectionMode = [];
      for (let BA = 0; BA < gA.selectionMode.length; ++BA) IA.selectionMode[BA] = AA.enums === String ? $root.DeckGlJsonChart.SelectionMode[gA.selectionMode[BA]] === void 0 ? gA.selectionMode[BA] : $root.DeckGlJsonChart.SelectionMode[gA.selectionMode[BA]] : gA.selectionMode[BA];
    }
    return gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/DeckGlJsonChart";
  }, CA.SelectionMode = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "SINGLE_OBJECT"] = 0, AA[gA[1] = "MULTI_OBJECT"] = 1, AA;
  })(), CA;
})();
$root.Delta = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.newElement = null, CA.prototype.addBlock = null, CA.prototype.newTransient = null, CA.prototype.arrowAddRows = null, CA.prototype.fragmentId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["newElement", "addBlock", "newTransient", "arrowAddRows"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.newElement != null && Object.hasOwnProperty.call(AA, "newElement") && $root.Element.encode(AA.newElement, IA.uint32(26).fork()).ldelim(), AA.addBlock != null && Object.hasOwnProperty.call(AA, "addBlock") && $root.Block.encode(AA.addBlock, IA.uint32(50).fork()).ldelim(), AA.arrowAddRows != null && Object.hasOwnProperty.call(AA, "arrowAddRows") && $root.ArrowNamedDataSet.encode(AA.arrowAddRows, IA.uint32(58).fork()).ldelim(), AA.fragmentId != null && Object.hasOwnProperty.call(AA, "fragmentId") && IA.uint32(66).string(AA.fragmentId), AA.newTransient != null && Object.hasOwnProperty.call(AA, "newTransient") && $root.Transient.encode(AA.newTransient, IA.uint32(74).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Delta();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 3:
          EA.newElement = $root.Element.decode(AA, AA.uint32());
          break;
        case 6:
          EA.addBlock = $root.Block.decode(AA, AA.uint32());
          break;
        case 9:
          EA.newTransient = $root.Transient.decode(AA, AA.uint32());
          break;
        case 7:
          EA.arrowAddRows = $root.ArrowNamedDataSet.decode(AA, AA.uint32());
          break;
        case 8:
          EA.fragmentId = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Delta) return AA;
    let IA = new $root.Delta();
    if (AA.newElement != null) {
      if (typeof AA.newElement != "object") throw TypeError(".Delta.newElement: object expected");
      IA.newElement = $root.Element.fromObject(AA.newElement);
    }
    if (AA.addBlock != null) {
      if (typeof AA.addBlock != "object") throw TypeError(".Delta.addBlock: object expected");
      IA.addBlock = $root.Block.fromObject(AA.addBlock);
    }
    if (AA.newTransient != null) {
      if (typeof AA.newTransient != "object") throw TypeError(".Delta.newTransient: object expected");
      IA.newTransient = $root.Transient.fromObject(AA.newTransient);
    }
    if (AA.arrowAddRows != null) {
      if (typeof AA.arrowAddRows != "object") throw TypeError(".Delta.arrowAddRows: object expected");
      IA.arrowAddRows = $root.ArrowNamedDataSet.fromObject(AA.arrowAddRows);
    }
    return AA.fragmentId != null && (IA.fragmentId = String(AA.fragmentId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.fragmentId = ""), AA.newElement != null && AA.hasOwnProperty("newElement") && (BA.newElement = $root.Element.toObject(AA.newElement, IA), IA.oneofs && (BA.type = "newElement")), AA.addBlock != null && AA.hasOwnProperty("addBlock") && (BA.addBlock = $root.Block.toObject(AA.addBlock, IA), IA.oneofs && (BA.type = "addBlock")), AA.arrowAddRows != null && AA.hasOwnProperty("arrowAddRows") && (BA.arrowAddRows = $root.ArrowNamedDataSet.toObject(AA.arrowAddRows, IA), IA.oneofs && (BA.type = "arrowAddRows")), AA.fragmentId != null && AA.hasOwnProperty("fragmentId") && (BA.fragmentId = AA.fragmentId), AA.newTransient != null && AA.hasOwnProperty("newTransient") && (BA.newTransient = $root.Transient.toObject(AA.newTransient, IA), IA.oneofs && (BA.type = "newTransient")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Delta";
  }, CA;
})();
$root.Element = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.heightConfig = null, CA.prototype.widthConfig = null, CA.prototype.textAlignmentConfig = null, CA.prototype.alert = null, CA.prototype.dataframe = null, CA.prototype.table = null, CA.prototype.vegaLiteChart = null, CA.prototype.audio = null, CA.prototype.audioInput = null, CA.prototype.balloons = null, CA.prototype.bidiComponent = null, CA.prototype.button = null, CA.prototype.buttonGroup = null, CA.prototype.downloadButton = null, CA.prototype.cameraInput = null, CA.prototype.chatInput = null, CA.prototype.checkbox = null, CA.prototype.colorPicker = null, CA.prototype.componentInstance = null, CA.prototype.dateInput = null, CA.prototype.deckGlJsonChart = null, CA.prototype.helpInfo = null, CA.prototype.empty = null, CA.prototype.exception = null, CA.prototype.favicon = null, CA.prototype.feedback = null, CA.prototype.fileUploader = null, CA.prototype.graphvizChart = null, CA.prototype.html = null, CA.prototype.iframe = null, CA.prototype.imgs = null, CA.prototype.json = null, CA.prototype.linkButton = null, CA.prototype.markdown = null, CA.prototype.metric = null, CA.prototype.multiselect = null, CA.prototype.numberInput = null, CA.prototype.pageLink = null, CA.prototype.plotlyChart = null, CA.prototype.progress = null, CA.prototype.radio = null, CA.prototype.selectbox = null, CA.prototype.skeleton = null, CA.prototype.slider = null, CA.prototype.snow = null, CA.prototype.space = null, CA.prototype.spinner = null, CA.prototype.text = null, CA.prototype.textArea = null, CA.prototype.textInput = null, CA.prototype.timeInput = null, CA.prototype.dateTimeInput = null, CA.prototype.toast = null, CA.prototype.video = null, CA.prototype.heading = null, CA.prototype.code = null, CA.prototype.menuButton = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_heightConfig", { get: $util.oneOfGetter(gA = ["heightConfig"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_widthConfig", { get: $util.oneOfGetter(gA = ["widthConfig"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_textAlignmentConfig", { get: $util.oneOfGetter(gA = ["textAlignmentConfig"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = /* @__PURE__ */ "alert.dataframe.table.vegaLiteChart.audio.audioInput.balloons.bidiComponent.button.buttonGroup.downloadButton.cameraInput.chatInput.checkbox.colorPicker.componentInstance.dateInput.deckGlJsonChart.helpInfo.empty.exception.favicon.feedback.fileUploader.graphvizChart.html.iframe.imgs.json.linkButton.markdown.metric.multiselect.numberInput.pageLink.plotlyChart.progress.radio.selectbox.skeleton.slider.snow.space.spinner.text.textArea.textInput.timeInput.dateTimeInput.toast.video.heading.code.menuButton".split(".")), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.text != null && Object.hasOwnProperty.call(AA, "text") && $root.Text.encode(AA.text, IA.uint32(10).fork()).ldelim(), AA.empty != null && Object.hasOwnProperty.call(AA, "empty") && $root.Empty.encode(AA.empty, IA.uint32(18).fork()).ldelim(), AA.progress != null && Object.hasOwnProperty.call(AA, "progress") && $root.Progress.encode(AA.progress, IA.uint32(42).fork()).ldelim(), AA.imgs != null && Object.hasOwnProperty.call(AA, "imgs") && $root.ImageList.encode(AA.imgs, IA.uint32(50).fork()).ldelim(), AA.helpInfo != null && Object.hasOwnProperty.call(AA, "helpInfo") && $root.Help.encode(AA.helpInfo, IA.uint32(58).fork()).ldelim(), AA.exception != null && Object.hasOwnProperty.call(AA, "exception") && $root.Exception.encode(AA.exception, IA.uint32(66).fork()).ldelim(), AA.balloons != null && Object.hasOwnProperty.call(AA, "balloons") && $root.Balloons.encode(AA.balloons, IA.uint32(98).fork()).ldelim(), AA.audio != null && Object.hasOwnProperty.call(AA, "audio") && $root.Audio.encode(AA.audio, IA.uint32(106).fork()).ldelim(), AA.video != null && Object.hasOwnProperty.call(AA, "video") && $root.Video.encode(AA.video, IA.uint32(114).fork()).ldelim(), AA.plotlyChart != null && Object.hasOwnProperty.call(AA, "plotlyChart") && $root.PlotlyChart.encode(AA.plotlyChart, IA.uint32(130).fork()).ldelim(), AA.graphvizChart != null && Object.hasOwnProperty.call(AA, "graphvizChart") && $root.GraphVizChart.encode(AA.graphvizChart, IA.uint32(146).fork()).ldelim(), AA.button != null && Object.hasOwnProperty.call(AA, "button") && $root.Button.encode(AA.button, IA.uint32(154).fork()).ldelim(), AA.checkbox != null && Object.hasOwnProperty.call(AA, "checkbox") && $root.Checkbox.encode(AA.checkbox, IA.uint32(162).fork()).ldelim(), AA.slider != null && Object.hasOwnProperty.call(AA, "slider") && $root.Slider.encode(AA.slider, IA.uint32(170).fork()).ldelim(), AA.textArea != null && Object.hasOwnProperty.call(AA, "textArea") && $root.TextArea.encode(AA.textArea, IA.uint32(178).fork()).ldelim(), AA.radio != null && Object.hasOwnProperty.call(AA, "radio") && $root.Radio.encode(AA.radio, IA.uint32(186).fork()).ldelim(), AA.textInput != null && Object.hasOwnProperty.call(AA, "textInput") && $root.TextInput.encode(AA.textInput, IA.uint32(194).fork()).ldelim(), AA.selectbox != null && Object.hasOwnProperty.call(AA, "selectbox") && $root.Selectbox.encode(AA.selectbox, IA.uint32(202).fork()).ldelim(), AA.timeInput != null && Object.hasOwnProperty.call(AA, "timeInput") && $root.TimeInput.encode(AA.timeInput, IA.uint32(210).fork()).ldelim(), AA.dateInput != null && Object.hasOwnProperty.call(AA, "dateInput") && $root.DateInput.encode(AA.dateInput, IA.uint32(218).fork()).ldelim(), AA.multiselect != null && Object.hasOwnProperty.call(AA, "multiselect") && $root.MultiSelect.encode(AA.multiselect, IA.uint32(226).fork()).ldelim(), AA.markdown != null && Object.hasOwnProperty.call(AA, "markdown") && $root.Markdown.encode(AA.markdown, IA.uint32(234).fork()).ldelim(), AA.alert != null && Object.hasOwnProperty.call(AA, "alert") && $root.Alert.encode(AA.alert, IA.uint32(242).fork()).ldelim(), AA.json != null && Object.hasOwnProperty.call(AA, "json") && $root.Json.encode(AA.json, IA.uint32(250).fork()).ldelim(), AA.numberInput != null && Object.hasOwnProperty.call(AA, "numberInput") && $root.NumberInput.encode(AA.numberInput, IA.uint32(258).fork()).ldelim(), AA.fileUploader != null && Object.hasOwnProperty.call(AA, "fileUploader") && $root.FileUploader.encode(AA.fileUploader, IA.uint32(266).fork()).ldelim(), AA.deckGlJsonChart != null && Object.hasOwnProperty.call(AA, "deckGlJsonChart") && $root.DeckGlJsonChart.encode(AA.deckGlJsonChart, IA.uint32(274).fork()).ldelim(), AA.colorPicker != null && Object.hasOwnProperty.call(AA, "colorPicker") && $root.ColorPicker.encode(AA.colorPicker, IA.uint32(282).fork()).ldelim(), AA.favicon != null && Object.hasOwnProperty.call(AA, "favicon") && $root.Favicon.encode(AA.favicon, IA.uint32(290).fork()).ldelim(), AA.componentInstance != null && Object.hasOwnProperty.call(AA, "componentInstance") && $root.ComponentInstance.encode(AA.componentInstance, IA.uint32(298).fork()).ldelim(), AA.iframe != null && Object.hasOwnProperty.call(AA, "iframe") && $root.IFrame.encode(AA.iframe, IA.uint32(306).fork()).ldelim(), AA.table != null && Object.hasOwnProperty.call(AA, "table") && $root.Table.encode(AA.table, IA.uint32(314).fork()).ldelim(), AA.dataframe != null && Object.hasOwnProperty.call(AA, "dataframe") && $root.Dataframe.encode(AA.dataframe, IA.uint32(322).fork()).ldelim(), AA.vegaLiteChart != null && Object.hasOwnProperty.call(AA, "vegaLiteChart") && $root.VegaLiteChart.encode(AA.vegaLiteChart, IA.uint32(330).fork()).ldelim(), AA.metric != null && Object.hasOwnProperty.call(AA, "metric") && $root.Metric.encode(AA.metric, IA.uint32(338).fork()).ldelim(), AA.downloadButton != null && Object.hasOwnProperty.call(AA, "downloadButton") && $root.DownloadButton.encode(AA.downloadButton, IA.uint32(346).fork()).ldelim(), AA.spinner != null && Object.hasOwnProperty.call(AA, "spinner") && $root.Spinner.encode(AA.spinner, IA.uint32(354).fork()).ldelim(), AA.cameraInput != null && Object.hasOwnProperty.call(AA, "cameraInput") && $root.CameraInput.encode(AA.cameraInput, IA.uint32(362).fork()).ldelim(), AA.snow != null && Object.hasOwnProperty.call(AA, "snow") && $root.Snow.encode(AA.snow, IA.uint32(370).fork()).ldelim(), AA.heading != null && Object.hasOwnProperty.call(AA, "heading") && $root.Heading.encode(AA.heading, IA.uint32(378).fork()).ldelim(), AA.code != null && Object.hasOwnProperty.call(AA, "code") && $root.Code.encode(AA.code, IA.uint32(386).fork()).ldelim(), AA.chatInput != null && Object.hasOwnProperty.call(AA, "chatInput") && $root.ChatInput.encode(AA.chatInput, IA.uint32(394).fork()).ldelim(), AA.toast != null && Object.hasOwnProperty.call(AA, "toast") && $root.Toast.encode(AA.toast, IA.uint32(402).fork()).ldelim(), AA.linkButton != null && Object.hasOwnProperty.call(AA, "linkButton") && $root.LinkButton.encode(AA.linkButton, IA.uint32(410).fork()).ldelim(), AA.skeleton != null && Object.hasOwnProperty.call(AA, "skeleton") && $root.Skeleton.encode(AA.skeleton, IA.uint32(418).fork()).ldelim(), AA.pageLink != null && Object.hasOwnProperty.call(AA, "pageLink") && $root.PageLink.encode(AA.pageLink, IA.uint32(426).fork()).ldelim(), AA.html != null && Object.hasOwnProperty.call(AA, "html") && $root.Html.encode(AA.html, IA.uint32(434).fork()).ldelim(), AA.buttonGroup != null && Object.hasOwnProperty.call(AA, "buttonGroup") && $root.ButtonGroup.encode(AA.buttonGroup, IA.uint32(442).fork()).ldelim(), AA.audioInput != null && Object.hasOwnProperty.call(AA, "audioInput") && $root.AudioInput.encode(AA.audioInput, IA.uint32(450).fork()).ldelim(), AA.heightConfig != null && Object.hasOwnProperty.call(AA, "heightConfig") && $root.streamlit.HeightConfig.encode(AA.heightConfig, IA.uint32(458).fork()).ldelim(), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(466).fork()).ldelim(), AA.bidiComponent != null && Object.hasOwnProperty.call(AA, "bidiComponent") && $root.BidiComponent.encode(AA.bidiComponent, IA.uint32(474).fork()).ldelim(), AA.space != null && Object.hasOwnProperty.call(AA, "space") && $root.Space.encode(AA.space, IA.uint32(482).fork()).ldelim(), AA.textAlignmentConfig != null && Object.hasOwnProperty.call(AA, "textAlignmentConfig") && $root.streamlit.TextAlignmentConfig.encode(AA.textAlignmentConfig, IA.uint32(490).fork()).ldelim(), AA.dateTimeInput != null && Object.hasOwnProperty.call(AA, "dateTimeInput") && $root.DateTimeInput.encode(AA.dateTimeInput, IA.uint32(498).fork()).ldelim(), AA.feedback != null && Object.hasOwnProperty.call(AA, "feedback") && $root.Feedback.encode(AA.feedback, IA.uint32(506).fork()).ldelim(), AA.menuButton != null && Object.hasOwnProperty.call(AA, "menuButton") && $root.MenuButton.encode(AA.menuButton, IA.uint32(514).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Element();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 57:
          EA.heightConfig = $root.streamlit.HeightConfig.decode(AA, AA.uint32());
          break;
        case 58:
          EA.widthConfig = $root.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        case 61:
          EA.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.decode(AA, AA.uint32());
          break;
        case 30:
          EA.alert = $root.Alert.decode(AA, AA.uint32());
          break;
        case 40:
          EA.dataframe = $root.Dataframe.decode(AA, AA.uint32());
          break;
        case 39:
          EA.table = $root.Table.decode(AA, AA.uint32());
          break;
        case 41:
          EA.vegaLiteChart = $root.VegaLiteChart.decode(AA, AA.uint32());
          break;
        case 13:
          EA.audio = $root.Audio.decode(AA, AA.uint32());
          break;
        case 56:
          EA.audioInput = $root.AudioInput.decode(AA, AA.uint32());
          break;
        case 12:
          EA.balloons = $root.Balloons.decode(AA, AA.uint32());
          break;
        case 59:
          EA.bidiComponent = $root.BidiComponent.decode(AA, AA.uint32());
          break;
        case 19:
          EA.button = $root.Button.decode(AA, AA.uint32());
          break;
        case 55:
          EA.buttonGroup = $root.ButtonGroup.decode(AA, AA.uint32());
          break;
        case 43:
          EA.downloadButton = $root.DownloadButton.decode(AA, AA.uint32());
          break;
        case 45:
          EA.cameraInput = $root.CameraInput.decode(AA, AA.uint32());
          break;
        case 49:
          EA.chatInput = $root.ChatInput.decode(AA, AA.uint32());
          break;
        case 20:
          EA.checkbox = $root.Checkbox.decode(AA, AA.uint32());
          break;
        case 35:
          EA.colorPicker = $root.ColorPicker.decode(AA, AA.uint32());
          break;
        case 37:
          EA.componentInstance = $root.ComponentInstance.decode(AA, AA.uint32());
          break;
        case 27:
          EA.dateInput = $root.DateInput.decode(AA, AA.uint32());
          break;
        case 34:
          EA.deckGlJsonChart = $root.DeckGlJsonChart.decode(AA, AA.uint32());
          break;
        case 7:
          EA.helpInfo = $root.Help.decode(AA, AA.uint32());
          break;
        case 2:
          EA.empty = $root.Empty.decode(AA, AA.uint32());
          break;
        case 8:
          EA.exception = $root.Exception.decode(AA, AA.uint32());
          break;
        case 36:
          EA.favicon = $root.Favicon.decode(AA, AA.uint32());
          break;
        case 63:
          EA.feedback = $root.Feedback.decode(AA, AA.uint32());
          break;
        case 33:
          EA.fileUploader = $root.FileUploader.decode(AA, AA.uint32());
          break;
        case 18:
          EA.graphvizChart = $root.GraphVizChart.decode(AA, AA.uint32());
          break;
        case 54:
          EA.html = $root.Html.decode(AA, AA.uint32());
          break;
        case 38:
          EA.iframe = $root.IFrame.decode(AA, AA.uint32());
          break;
        case 6:
          EA.imgs = $root.ImageList.decode(AA, AA.uint32());
          break;
        case 31:
          EA.json = $root.Json.decode(AA, AA.uint32());
          break;
        case 51:
          EA.linkButton = $root.LinkButton.decode(AA, AA.uint32());
          break;
        case 29:
          EA.markdown = $root.Markdown.decode(AA, AA.uint32());
          break;
        case 42:
          EA.metric = $root.Metric.decode(AA, AA.uint32());
          break;
        case 28:
          EA.multiselect = $root.MultiSelect.decode(AA, AA.uint32());
          break;
        case 32:
          EA.numberInput = $root.NumberInput.decode(AA, AA.uint32());
          break;
        case 53:
          EA.pageLink = $root.PageLink.decode(AA, AA.uint32());
          break;
        case 16:
          EA.plotlyChart = $root.PlotlyChart.decode(AA, AA.uint32());
          break;
        case 5:
          EA.progress = $root.Progress.decode(AA, AA.uint32());
          break;
        case 23:
          EA.radio = $root.Radio.decode(AA, AA.uint32());
          break;
        case 25:
          EA.selectbox = $root.Selectbox.decode(AA, AA.uint32());
          break;
        case 52:
          EA.skeleton = $root.Skeleton.decode(AA, AA.uint32());
          break;
        case 21:
          EA.slider = $root.Slider.decode(AA, AA.uint32());
          break;
        case 46:
          EA.snow = $root.Snow.decode(AA, AA.uint32());
          break;
        case 60:
          EA.space = $root.Space.decode(AA, AA.uint32());
          break;
        case 44:
          EA.spinner = $root.Spinner.decode(AA, AA.uint32());
          break;
        case 1:
          EA.text = $root.Text.decode(AA, AA.uint32());
          break;
        case 22:
          EA.textArea = $root.TextArea.decode(AA, AA.uint32());
          break;
        case 24:
          EA.textInput = $root.TextInput.decode(AA, AA.uint32());
          break;
        case 26:
          EA.timeInput = $root.TimeInput.decode(AA, AA.uint32());
          break;
        case 62:
          EA.dateTimeInput = $root.DateTimeInput.decode(AA, AA.uint32());
          break;
        case 50:
          EA.toast = $root.Toast.decode(AA, AA.uint32());
          break;
        case 14:
          EA.video = $root.Video.decode(AA, AA.uint32());
          break;
        case 47:
          EA.heading = $root.Heading.decode(AA, AA.uint32());
          break;
        case 48:
          EA.code = $root.Code.decode(AA, AA.uint32());
          break;
        case 64:
          EA.menuButton = $root.MenuButton.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Element) return AA;
    let IA = new $root.Element();
    if (AA.heightConfig != null) {
      if (typeof AA.heightConfig != "object") throw TypeError(".Element.heightConfig: object expected");
      IA.heightConfig = $root.streamlit.HeightConfig.fromObject(AA.heightConfig);
    }
    if (AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Element.widthConfig: object expected");
      IA.widthConfig = $root.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    if (AA.textAlignmentConfig != null) {
      if (typeof AA.textAlignmentConfig != "object") throw TypeError(".Element.textAlignmentConfig: object expected");
      IA.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.fromObject(AA.textAlignmentConfig);
    }
    if (AA.alert != null) {
      if (typeof AA.alert != "object") throw TypeError(".Element.alert: object expected");
      IA.alert = $root.Alert.fromObject(AA.alert);
    }
    if (AA.dataframe != null) {
      if (typeof AA.dataframe != "object") throw TypeError(".Element.dataframe: object expected");
      IA.dataframe = $root.Dataframe.fromObject(AA.dataframe);
    }
    if (AA.table != null) {
      if (typeof AA.table != "object") throw TypeError(".Element.table: object expected");
      IA.table = $root.Table.fromObject(AA.table);
    }
    if (AA.vegaLiteChart != null) {
      if (typeof AA.vegaLiteChart != "object") throw TypeError(".Element.vegaLiteChart: object expected");
      IA.vegaLiteChart = $root.VegaLiteChart.fromObject(AA.vegaLiteChart);
    }
    if (AA.audio != null) {
      if (typeof AA.audio != "object") throw TypeError(".Element.audio: object expected");
      IA.audio = $root.Audio.fromObject(AA.audio);
    }
    if (AA.audioInput != null) {
      if (typeof AA.audioInput != "object") throw TypeError(".Element.audioInput: object expected");
      IA.audioInput = $root.AudioInput.fromObject(AA.audioInput);
    }
    if (AA.balloons != null) {
      if (typeof AA.balloons != "object") throw TypeError(".Element.balloons: object expected");
      IA.balloons = $root.Balloons.fromObject(AA.balloons);
    }
    if (AA.bidiComponent != null) {
      if (typeof AA.bidiComponent != "object") throw TypeError(".Element.bidiComponent: object expected");
      IA.bidiComponent = $root.BidiComponent.fromObject(AA.bidiComponent);
    }
    if (AA.button != null) {
      if (typeof AA.button != "object") throw TypeError(".Element.button: object expected");
      IA.button = $root.Button.fromObject(AA.button);
    }
    if (AA.buttonGroup != null) {
      if (typeof AA.buttonGroup != "object") throw TypeError(".Element.buttonGroup: object expected");
      IA.buttonGroup = $root.ButtonGroup.fromObject(AA.buttonGroup);
    }
    if (AA.downloadButton != null) {
      if (typeof AA.downloadButton != "object") throw TypeError(".Element.downloadButton: object expected");
      IA.downloadButton = $root.DownloadButton.fromObject(AA.downloadButton);
    }
    if (AA.cameraInput != null) {
      if (typeof AA.cameraInput != "object") throw TypeError(".Element.cameraInput: object expected");
      IA.cameraInput = $root.CameraInput.fromObject(AA.cameraInput);
    }
    if (AA.chatInput != null) {
      if (typeof AA.chatInput != "object") throw TypeError(".Element.chatInput: object expected");
      IA.chatInput = $root.ChatInput.fromObject(AA.chatInput);
    }
    if (AA.checkbox != null) {
      if (typeof AA.checkbox != "object") throw TypeError(".Element.checkbox: object expected");
      IA.checkbox = $root.Checkbox.fromObject(AA.checkbox);
    }
    if (AA.colorPicker != null) {
      if (typeof AA.colorPicker != "object") throw TypeError(".Element.colorPicker: object expected");
      IA.colorPicker = $root.ColorPicker.fromObject(AA.colorPicker);
    }
    if (AA.componentInstance != null) {
      if (typeof AA.componentInstance != "object") throw TypeError(".Element.componentInstance: object expected");
      IA.componentInstance = $root.ComponentInstance.fromObject(AA.componentInstance);
    }
    if (AA.dateInput != null) {
      if (typeof AA.dateInput != "object") throw TypeError(".Element.dateInput: object expected");
      IA.dateInput = $root.DateInput.fromObject(AA.dateInput);
    }
    if (AA.deckGlJsonChart != null) {
      if (typeof AA.deckGlJsonChart != "object") throw TypeError(".Element.deckGlJsonChart: object expected");
      IA.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(AA.deckGlJsonChart);
    }
    if (AA.helpInfo != null) {
      if (typeof AA.helpInfo != "object") throw TypeError(".Element.helpInfo: object expected");
      IA.helpInfo = $root.Help.fromObject(AA.helpInfo);
    }
    if (AA.empty != null) {
      if (typeof AA.empty != "object") throw TypeError(".Element.empty: object expected");
      IA.empty = $root.Empty.fromObject(AA.empty);
    }
    if (AA.exception != null) {
      if (typeof AA.exception != "object") throw TypeError(".Element.exception: object expected");
      IA.exception = $root.Exception.fromObject(AA.exception);
    }
    if (AA.favicon != null) {
      if (typeof AA.favicon != "object") throw TypeError(".Element.favicon: object expected");
      IA.favicon = $root.Favicon.fromObject(AA.favicon);
    }
    if (AA.feedback != null) {
      if (typeof AA.feedback != "object") throw TypeError(".Element.feedback: object expected");
      IA.feedback = $root.Feedback.fromObject(AA.feedback);
    }
    if (AA.fileUploader != null) {
      if (typeof AA.fileUploader != "object") throw TypeError(".Element.fileUploader: object expected");
      IA.fileUploader = $root.FileUploader.fromObject(AA.fileUploader);
    }
    if (AA.graphvizChart != null) {
      if (typeof AA.graphvizChart != "object") throw TypeError(".Element.graphvizChart: object expected");
      IA.graphvizChart = $root.GraphVizChart.fromObject(AA.graphvizChart);
    }
    if (AA.html != null) {
      if (typeof AA.html != "object") throw TypeError(".Element.html: object expected");
      IA.html = $root.Html.fromObject(AA.html);
    }
    if (AA.iframe != null) {
      if (typeof AA.iframe != "object") throw TypeError(".Element.iframe: object expected");
      IA.iframe = $root.IFrame.fromObject(AA.iframe);
    }
    if (AA.imgs != null) {
      if (typeof AA.imgs != "object") throw TypeError(".Element.imgs: object expected");
      IA.imgs = $root.ImageList.fromObject(AA.imgs);
    }
    if (AA.json != null) {
      if (typeof AA.json != "object") throw TypeError(".Element.json: object expected");
      IA.json = $root.Json.fromObject(AA.json);
    }
    if (AA.linkButton != null) {
      if (typeof AA.linkButton != "object") throw TypeError(".Element.linkButton: object expected");
      IA.linkButton = $root.LinkButton.fromObject(AA.linkButton);
    }
    if (AA.markdown != null) {
      if (typeof AA.markdown != "object") throw TypeError(".Element.markdown: object expected");
      IA.markdown = $root.Markdown.fromObject(AA.markdown);
    }
    if (AA.metric != null) {
      if (typeof AA.metric != "object") throw TypeError(".Element.metric: object expected");
      IA.metric = $root.Metric.fromObject(AA.metric);
    }
    if (AA.multiselect != null) {
      if (typeof AA.multiselect != "object") throw TypeError(".Element.multiselect: object expected");
      IA.multiselect = $root.MultiSelect.fromObject(AA.multiselect);
    }
    if (AA.numberInput != null) {
      if (typeof AA.numberInput != "object") throw TypeError(".Element.numberInput: object expected");
      IA.numberInput = $root.NumberInput.fromObject(AA.numberInput);
    }
    if (AA.pageLink != null) {
      if (typeof AA.pageLink != "object") throw TypeError(".Element.pageLink: object expected");
      IA.pageLink = $root.PageLink.fromObject(AA.pageLink);
    }
    if (AA.plotlyChart != null) {
      if (typeof AA.plotlyChart != "object") throw TypeError(".Element.plotlyChart: object expected");
      IA.plotlyChart = $root.PlotlyChart.fromObject(AA.plotlyChart);
    }
    if (AA.progress != null) {
      if (typeof AA.progress != "object") throw TypeError(".Element.progress: object expected");
      IA.progress = $root.Progress.fromObject(AA.progress);
    }
    if (AA.radio != null) {
      if (typeof AA.radio != "object") throw TypeError(".Element.radio: object expected");
      IA.radio = $root.Radio.fromObject(AA.radio);
    }
    if (AA.selectbox != null) {
      if (typeof AA.selectbox != "object") throw TypeError(".Element.selectbox: object expected");
      IA.selectbox = $root.Selectbox.fromObject(AA.selectbox);
    }
    if (AA.skeleton != null) {
      if (typeof AA.skeleton != "object") throw TypeError(".Element.skeleton: object expected");
      IA.skeleton = $root.Skeleton.fromObject(AA.skeleton);
    }
    if (AA.slider != null) {
      if (typeof AA.slider != "object") throw TypeError(".Element.slider: object expected");
      IA.slider = $root.Slider.fromObject(AA.slider);
    }
    if (AA.snow != null) {
      if (typeof AA.snow != "object") throw TypeError(".Element.snow: object expected");
      IA.snow = $root.Snow.fromObject(AA.snow);
    }
    if (AA.space != null) {
      if (typeof AA.space != "object") throw TypeError(".Element.space: object expected");
      IA.space = $root.Space.fromObject(AA.space);
    }
    if (AA.spinner != null) {
      if (typeof AA.spinner != "object") throw TypeError(".Element.spinner: object expected");
      IA.spinner = $root.Spinner.fromObject(AA.spinner);
    }
    if (AA.text != null) {
      if (typeof AA.text != "object") throw TypeError(".Element.text: object expected");
      IA.text = $root.Text.fromObject(AA.text);
    }
    if (AA.textArea != null) {
      if (typeof AA.textArea != "object") throw TypeError(".Element.textArea: object expected");
      IA.textArea = $root.TextArea.fromObject(AA.textArea);
    }
    if (AA.textInput != null) {
      if (typeof AA.textInput != "object") throw TypeError(".Element.textInput: object expected");
      IA.textInput = $root.TextInput.fromObject(AA.textInput);
    }
    if (AA.timeInput != null) {
      if (typeof AA.timeInput != "object") throw TypeError(".Element.timeInput: object expected");
      IA.timeInput = $root.TimeInput.fromObject(AA.timeInput);
    }
    if (AA.dateTimeInput != null) {
      if (typeof AA.dateTimeInput != "object") throw TypeError(".Element.dateTimeInput: object expected");
      IA.dateTimeInput = $root.DateTimeInput.fromObject(AA.dateTimeInput);
    }
    if (AA.toast != null) {
      if (typeof AA.toast != "object") throw TypeError(".Element.toast: object expected");
      IA.toast = $root.Toast.fromObject(AA.toast);
    }
    if (AA.video != null) {
      if (typeof AA.video != "object") throw TypeError(".Element.video: object expected");
      IA.video = $root.Video.fromObject(AA.video);
    }
    if (AA.heading != null) {
      if (typeof AA.heading != "object") throw TypeError(".Element.heading: object expected");
      IA.heading = $root.Heading.fromObject(AA.heading);
    }
    if (AA.code != null) {
      if (typeof AA.code != "object") throw TypeError(".Element.code: object expected");
      IA.code = $root.Code.fromObject(AA.code);
    }
    if (AA.menuButton != null) {
      if (typeof AA.menuButton != "object") throw TypeError(".Element.menuButton: object expected");
      IA.menuButton = $root.MenuButton.fromObject(AA.menuButton);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return AA.text != null && AA.hasOwnProperty("text") && (BA.text = $root.Text.toObject(AA.text, IA), IA.oneofs && (BA.type = "text")), AA.empty != null && AA.hasOwnProperty("empty") && (BA.empty = $root.Empty.toObject(AA.empty, IA), IA.oneofs && (BA.type = "empty")), AA.progress != null && AA.hasOwnProperty("progress") && (BA.progress = $root.Progress.toObject(AA.progress, IA), IA.oneofs && (BA.type = "progress")), AA.imgs != null && AA.hasOwnProperty("imgs") && (BA.imgs = $root.ImageList.toObject(AA.imgs, IA), IA.oneofs && (BA.type = "imgs")), AA.helpInfo != null && AA.hasOwnProperty("helpInfo") && (BA.helpInfo = $root.Help.toObject(AA.helpInfo, IA), IA.oneofs && (BA.type = "helpInfo")), AA.exception != null && AA.hasOwnProperty("exception") && (BA.exception = $root.Exception.toObject(AA.exception, IA), IA.oneofs && (BA.type = "exception")), AA.balloons != null && AA.hasOwnProperty("balloons") && (BA.balloons = $root.Balloons.toObject(AA.balloons, IA), IA.oneofs && (BA.type = "balloons")), AA.audio != null && AA.hasOwnProperty("audio") && (BA.audio = $root.Audio.toObject(AA.audio, IA), IA.oneofs && (BA.type = "audio")), AA.video != null && AA.hasOwnProperty("video") && (BA.video = $root.Video.toObject(AA.video, IA), IA.oneofs && (BA.type = "video")), AA.plotlyChart != null && AA.hasOwnProperty("plotlyChart") && (BA.plotlyChart = $root.PlotlyChart.toObject(AA.plotlyChart, IA), IA.oneofs && (BA.type = "plotlyChart")), AA.graphvizChart != null && AA.hasOwnProperty("graphvizChart") && (BA.graphvizChart = $root.GraphVizChart.toObject(AA.graphvizChart, IA), IA.oneofs && (BA.type = "graphvizChart")), AA.button != null && AA.hasOwnProperty("button") && (BA.button = $root.Button.toObject(AA.button, IA), IA.oneofs && (BA.type = "button")), AA.checkbox != null && AA.hasOwnProperty("checkbox") && (BA.checkbox = $root.Checkbox.toObject(AA.checkbox, IA), IA.oneofs && (BA.type = "checkbox")), AA.slider != null && AA.hasOwnProperty("slider") && (BA.slider = $root.Slider.toObject(AA.slider, IA), IA.oneofs && (BA.type = "slider")), AA.textArea != null && AA.hasOwnProperty("textArea") && (BA.textArea = $root.TextArea.toObject(AA.textArea, IA), IA.oneofs && (BA.type = "textArea")), AA.radio != null && AA.hasOwnProperty("radio") && (BA.radio = $root.Radio.toObject(AA.radio, IA), IA.oneofs && (BA.type = "radio")), AA.textInput != null && AA.hasOwnProperty("textInput") && (BA.textInput = $root.TextInput.toObject(AA.textInput, IA), IA.oneofs && (BA.type = "textInput")), AA.selectbox != null && AA.hasOwnProperty("selectbox") && (BA.selectbox = $root.Selectbox.toObject(AA.selectbox, IA), IA.oneofs && (BA.type = "selectbox")), AA.timeInput != null && AA.hasOwnProperty("timeInput") && (BA.timeInput = $root.TimeInput.toObject(AA.timeInput, IA), IA.oneofs && (BA.type = "timeInput")), AA.dateInput != null && AA.hasOwnProperty("dateInput") && (BA.dateInput = $root.DateInput.toObject(AA.dateInput, IA), IA.oneofs && (BA.type = "dateInput")), AA.multiselect != null && AA.hasOwnProperty("multiselect") && (BA.multiselect = $root.MultiSelect.toObject(AA.multiselect, IA), IA.oneofs && (BA.type = "multiselect")), AA.markdown != null && AA.hasOwnProperty("markdown") && (BA.markdown = $root.Markdown.toObject(AA.markdown, IA), IA.oneofs && (BA.type = "markdown")), AA.alert != null && AA.hasOwnProperty("alert") && (BA.alert = $root.Alert.toObject(AA.alert, IA), IA.oneofs && (BA.type = "alert")), AA.json != null && AA.hasOwnProperty("json") && (BA.json = $root.Json.toObject(AA.json, IA), IA.oneofs && (BA.type = "json")), AA.numberInput != null && AA.hasOwnProperty("numberInput") && (BA.numberInput = $root.NumberInput.toObject(AA.numberInput, IA), IA.oneofs && (BA.type = "numberInput")), AA.fileUploader != null && AA.hasOwnProperty("fileUploader") && (BA.fileUploader = $root.FileUploader.toObject(AA.fileUploader, IA), IA.oneofs && (BA.type = "fileUploader")), AA.deckGlJsonChart != null && AA.hasOwnProperty("deckGlJsonChart") && (BA.deckGlJsonChart = $root.DeckGlJsonChart.toObject(AA.deckGlJsonChart, IA), IA.oneofs && (BA.type = "deckGlJsonChart")), AA.colorPicker != null && AA.hasOwnProperty("colorPicker") && (BA.colorPicker = $root.ColorPicker.toObject(AA.colorPicker, IA), IA.oneofs && (BA.type = "colorPicker")), AA.favicon != null && AA.hasOwnProperty("favicon") && (BA.favicon = $root.Favicon.toObject(AA.favicon, IA), IA.oneofs && (BA.type = "favicon")), AA.componentInstance != null && AA.hasOwnProperty("componentInstance") && (BA.componentInstance = $root.ComponentInstance.toObject(AA.componentInstance, IA), IA.oneofs && (BA.type = "componentInstance")), AA.iframe != null && AA.hasOwnProperty("iframe") && (BA.iframe = $root.IFrame.toObject(AA.iframe, IA), IA.oneofs && (BA.type = "iframe")), AA.table != null && AA.hasOwnProperty("table") && (BA.table = $root.Table.toObject(AA.table, IA), IA.oneofs && (BA.type = "table")), AA.dataframe != null && AA.hasOwnProperty("dataframe") && (BA.dataframe = $root.Dataframe.toObject(AA.dataframe, IA), IA.oneofs && (BA.type = "dataframe")), AA.vegaLiteChart != null && AA.hasOwnProperty("vegaLiteChart") && (BA.vegaLiteChart = $root.VegaLiteChart.toObject(AA.vegaLiteChart, IA), IA.oneofs && (BA.type = "vegaLiteChart")), AA.metric != null && AA.hasOwnProperty("metric") && (BA.metric = $root.Metric.toObject(AA.metric, IA), IA.oneofs && (BA.type = "metric")), AA.downloadButton != null && AA.hasOwnProperty("downloadButton") && (BA.downloadButton = $root.DownloadButton.toObject(AA.downloadButton, IA), IA.oneofs && (BA.type = "downloadButton")), AA.spinner != null && AA.hasOwnProperty("spinner") && (BA.spinner = $root.Spinner.toObject(AA.spinner, IA), IA.oneofs && (BA.type = "spinner")), AA.cameraInput != null && AA.hasOwnProperty("cameraInput") && (BA.cameraInput = $root.CameraInput.toObject(AA.cameraInput, IA), IA.oneofs && (BA.type = "cameraInput")), AA.snow != null && AA.hasOwnProperty("snow") && (BA.snow = $root.Snow.toObject(AA.snow, IA), IA.oneofs && (BA.type = "snow")), AA.heading != null && AA.hasOwnProperty("heading") && (BA.heading = $root.Heading.toObject(AA.heading, IA), IA.oneofs && (BA.type = "heading")), AA.code != null && AA.hasOwnProperty("code") && (BA.code = $root.Code.toObject(AA.code, IA), IA.oneofs && (BA.type = "code")), AA.chatInput != null && AA.hasOwnProperty("chatInput") && (BA.chatInput = $root.ChatInput.toObject(AA.chatInput, IA), IA.oneofs && (BA.type = "chatInput")), AA.toast != null && AA.hasOwnProperty("toast") && (BA.toast = $root.Toast.toObject(AA.toast, IA), IA.oneofs && (BA.type = "toast")), AA.linkButton != null && AA.hasOwnProperty("linkButton") && (BA.linkButton = $root.LinkButton.toObject(AA.linkButton, IA), IA.oneofs && (BA.type = "linkButton")), AA.skeleton != null && AA.hasOwnProperty("skeleton") && (BA.skeleton = $root.Skeleton.toObject(AA.skeleton, IA), IA.oneofs && (BA.type = "skeleton")), AA.pageLink != null && AA.hasOwnProperty("pageLink") && (BA.pageLink = $root.PageLink.toObject(AA.pageLink, IA), IA.oneofs && (BA.type = "pageLink")), AA.html != null && AA.hasOwnProperty("html") && (BA.html = $root.Html.toObject(AA.html, IA), IA.oneofs && (BA.type = "html")), AA.buttonGroup != null && AA.hasOwnProperty("buttonGroup") && (BA.buttonGroup = $root.ButtonGroup.toObject(AA.buttonGroup, IA), IA.oneofs && (BA.type = "buttonGroup")), AA.audioInput != null && AA.hasOwnProperty("audioInput") && (BA.audioInput = $root.AudioInput.toObject(AA.audioInput, IA), IA.oneofs && (BA.type = "audioInput")), AA.heightConfig != null && AA.hasOwnProperty("heightConfig") && (BA.heightConfig = $root.streamlit.HeightConfig.toObject(AA.heightConfig, IA), IA.oneofs && (BA._heightConfig = "heightConfig")), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root.streamlit.WidthConfig.toObject(AA.widthConfig, IA), IA.oneofs && (BA._widthConfig = "widthConfig")), AA.bidiComponent != null && AA.hasOwnProperty("bidiComponent") && (BA.bidiComponent = $root.BidiComponent.toObject(AA.bidiComponent, IA), IA.oneofs && (BA.type = "bidiComponent")), AA.space != null && AA.hasOwnProperty("space") && (BA.space = $root.Space.toObject(AA.space, IA), IA.oneofs && (BA.type = "space")), AA.textAlignmentConfig != null && AA.hasOwnProperty("textAlignmentConfig") && (BA.textAlignmentConfig = $root.streamlit.TextAlignmentConfig.toObject(AA.textAlignmentConfig, IA), IA.oneofs && (BA._textAlignmentConfig = "textAlignmentConfig")), AA.dateTimeInput != null && AA.hasOwnProperty("dateTimeInput") && (BA.dateTimeInput = $root.DateTimeInput.toObject(AA.dateTimeInput, IA), IA.oneofs && (BA.type = "dateTimeInput")), AA.feedback != null && AA.hasOwnProperty("feedback") && (BA.feedback = $root.Feedback.toObject(AA.feedback, IA), IA.oneofs && (BA.type = "feedback")), AA.menuButton != null && AA.hasOwnProperty("menuButton") && (BA.menuButton = $root.MenuButton.toObject(AA.menuButton, IA), IA.oneofs && (BA.type = "menuButton")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Element";
  }, CA;
})();
$root.DownloadButton = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.url = "", CA.prototype.disabled = !1, CA.prototype.useContainerWidth = !1, CA.prototype.type = "", CA.prototype.icon = "", CA.prototype.ignoreRerun = !1, CA.prototype.deferredFileId = null, CA.prototype.shortcut = "", CA.prototype.iconPosition = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_deferredFileId", { get: $util.oneOfGetter(gA = ["deferredFileId"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(24).bool(AA.default), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(34).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(50).string(AA.url), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(56).bool(AA.disabled), AA.useContainerWidth != null && Object.hasOwnProperty.call(AA, "useContainerWidth") && IA.uint32(64).bool(AA.useContainerWidth), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(74).string(AA.type), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(82).string(AA.icon), AA.ignoreRerun != null && Object.hasOwnProperty.call(AA, "ignoreRerun") && IA.uint32(88).bool(AA.ignoreRerun), AA.deferredFileId != null && Object.hasOwnProperty.call(AA, "deferredFileId") && IA.uint32(98).string(AA.deferredFileId), AA.shortcut != null && Object.hasOwnProperty.call(AA, "shortcut") && IA.uint32(106).string(AA.shortcut), AA.iconPosition != null && Object.hasOwnProperty.call(AA, "iconPosition") && IA.uint32(112).int32(AA.iconPosition), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.DownloadButton();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.bool();
          break;
        case 4:
          EA.help = AA.string();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.url = AA.string();
          break;
        case 7:
          EA.disabled = AA.bool();
          break;
        case 8:
          EA.useContainerWidth = AA.bool();
          break;
        case 9:
          EA.type = AA.string();
          break;
        case 10:
          EA.icon = AA.string();
          break;
        case 11:
          EA.ignoreRerun = AA.bool();
          break;
        case 12:
          EA.deferredFileId = AA.string();
          break;
        case 13:
          EA.shortcut = AA.string();
          break;
        case 14:
          EA.iconPosition = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.DownloadButton) return AA;
    let IA = new $root.DownloadButton();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = !!AA.default), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.url != null && (IA.url = String(AA.url)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.useContainerWidth != null && (IA.useContainerWidth = !!AA.useContainerWidth), AA.type != null && (IA.type = String(AA.type)), AA.icon != null && (IA.icon = String(AA.icon)), AA.ignoreRerun != null && (IA.ignoreRerun = !!AA.ignoreRerun), AA.deferredFileId != null && (IA.deferredFileId = String(AA.deferredFileId)), AA.shortcut != null && (IA.shortcut = String(AA.shortcut)), AA.iconPosition) {
      default:
        if (typeof AA.iconPosition == "number") {
          IA.iconPosition = AA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        IA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        IA.iconPosition = 1;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.default = !1, BA.help = "", BA.formId = "", BA.url = "", BA.disabled = !1, BA.useContainerWidth = !1, BA.type = "", BA.icon = "", BA.ignoreRerun = !1, BA.shortcut = "", BA.iconPosition = IA.enums === String ? "LEFT" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.useContainerWidth != null && AA.hasOwnProperty("useContainerWidth") && (BA.useContainerWidth = AA.useContainerWidth), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.ignoreRerun != null && AA.hasOwnProperty("ignoreRerun") && (BA.ignoreRerun = AA.ignoreRerun), AA.deferredFileId != null && AA.hasOwnProperty("deferredFileId") && (BA.deferredFileId = AA.deferredFileId, IA.oneofs && (BA._deferredFileId = "deferredFileId")), AA.shortcut != null && AA.hasOwnProperty("shortcut") && (BA.shortcut = AA.shortcut), AA.iconPosition != null && AA.hasOwnProperty("iconPosition") && (BA.iconPosition = IA.enums === String ? $root.streamlit.ButtonLikeIconPosition[AA.iconPosition] === void 0 ? AA.iconPosition : $root.streamlit.ButtonLikeIconPosition[AA.iconPosition] : AA.iconPosition), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/DownloadButton";
  }, CA;
})();
$root.Empty = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Empty();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    return gA instanceof $root.Empty ? gA : new $root.Empty();
  }, CA.toObject = function() {
    return {};
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Empty";
  }, CA;
})();
$root.Exception = (() => {
  function CA(gA) {
    if (this.stackTrace = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.type = "", CA.prototype.message = "", CA.prototype.messageIsMarkdown = !1, CA.prototype.stackTrace = $util.emptyArray, CA.prototype.isWarning = !1, CA.prototype.widthConfig = null, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.type != null && Object.hasOwnProperty.call(gA, "type") && AA.uint32(10).string(gA.type), gA.message != null && Object.hasOwnProperty.call(gA, "message") && AA.uint32(18).string(gA.message), gA.stackTrace != null && gA.stackTrace.length) for (let IA = 0; IA < gA.stackTrace.length; ++IA) AA.uint32(26).string(gA.stackTrace[IA]);
    return gA.messageIsMarkdown != null && Object.hasOwnProperty.call(gA, "messageIsMarkdown") && AA.uint32(32).bool(gA.messageIsMarkdown), gA.isWarning != null && Object.hasOwnProperty.call(gA, "isWarning") && AA.uint32(40).bool(gA.isWarning), gA.widthConfig != null && Object.hasOwnProperty.call(gA, "widthConfig") && $root.streamlit.WidthConfig.encode(gA.widthConfig, AA.uint32(50).fork()).ldelim(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Exception();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.type = gA.string();
          break;
        case 2:
          QA.message = gA.string();
          break;
        case 4:
          QA.messageIsMarkdown = gA.bool();
          break;
        case 3:
          QA.stackTrace && QA.stackTrace.length || (QA.stackTrace = []), QA.stackTrace.push(gA.string());
          break;
        case 5:
          QA.isWarning = gA.bool();
          break;
        case 6:
          QA.widthConfig = $root.streamlit.WidthConfig.decode(gA, gA.uint32());
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Exception) return gA;
    let AA = new $root.Exception();
    if (gA.type != null && (AA.type = String(gA.type)), gA.message != null && (AA.message = String(gA.message)), gA.messageIsMarkdown != null && (AA.messageIsMarkdown = !!gA.messageIsMarkdown), gA.stackTrace) {
      if (!Array.isArray(gA.stackTrace)) throw TypeError(".Exception.stackTrace: array expected");
      AA.stackTrace = [];
      for (let IA = 0; IA < gA.stackTrace.length; ++IA) AA.stackTrace[IA] = String(gA.stackTrace[IA]);
    }
    if (gA.isWarning != null && (AA.isWarning = !!gA.isWarning), gA.widthConfig != null) {
      if (typeof gA.widthConfig != "object") throw TypeError(".Exception.widthConfig: object expected");
      AA.widthConfig = $root.streamlit.WidthConfig.fromObject(gA.widthConfig);
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.stackTrace = []), AA.defaults && (IA.type = "", IA.message = "", IA.messageIsMarkdown = !1, IA.isWarning = !1, IA.widthConfig = null), gA.type != null && gA.hasOwnProperty("type") && (IA.type = gA.type), gA.message != null && gA.hasOwnProperty("message") && (IA.message = gA.message), gA.stackTrace && gA.stackTrace.length) {
      IA.stackTrace = [];
      for (let BA = 0; BA < gA.stackTrace.length; ++BA) IA.stackTrace[BA] = gA.stackTrace[BA];
    }
    return gA.messageIsMarkdown != null && gA.hasOwnProperty("messageIsMarkdown") && (IA.messageIsMarkdown = gA.messageIsMarkdown), gA.isWarning != null && gA.hasOwnProperty("isWarning") && (IA.isWarning = gA.isWarning), gA.widthConfig != null && gA.hasOwnProperty("widthConfig") && (IA.widthConfig = $root.streamlit.WidthConfig.toObject(gA.widthConfig, AA)), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Exception";
  }, CA;
})();
$root.Favicon = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(10).string(gA.url), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Favicon();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.url = gA.string() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Favicon) return gA;
    let AA = new $root.Favicon();
    return gA.url != null && (AA.url = String(gA.url)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.url = ""), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Favicon";
  }, CA;
})();
$root.Feedback = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.type = 0, CA.prototype.default = null, CA.prototype.disabled = !1, CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util.oneOfGetter(gA = ["value"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(16).int32(AA.type), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(24).uint32(AA.default), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(32).bool(AA.disabled), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(48).uint32(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(56).bool(AA.setValue), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Feedback();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.type = AA.int32();
          break;
        case 3:
          EA.default = AA.uint32();
          break;
        case 4:
          EA.disabled = AA.bool();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.value = AA.uint32();
          break;
        case 7:
          EA.setValue = AA.bool();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Feedback) return AA;
    let IA = new $root.Feedback();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.type) {
      default:
        if (typeof AA.type == "number") {
          IA.type = AA.type;
          break;
        }
        break;
      case "THUMBS":
      case 0:
        IA.type = 0;
        break;
      case "FACES":
      case 1:
        IA.type = 1;
        break;
      case "STARS":
      case 2:
        IA.type = 2;
        break;
    }
    return AA.default != null && (IA.default = AA.default >>> 0), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = AA.value >>> 0), AA.setValue != null && (IA.setValue = !!AA.setValue), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.type = IA.enums === String ? "THUMBS" : 0, BA.disabled = !1, BA.formId = "", BA.setValue = !1), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.Feedback.FeedbackType[AA.type] === void 0 ? AA.type : $root.Feedback.FeedbackType[AA.type] : AA.type), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value, IA.oneofs && (BA._value = "value")), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Feedback";
  }, CA.FeedbackType = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "THUMBS"] = 0, IA[AA[1] = "FACES"] = 1, IA[AA[2] = "STARS"] = 2, IA;
  })(), CA;
})();
$root.FileUploader = (() => {
  function CA(gA) {
    if (this.type = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.type = $util.emptyArray, CA.prototype.maxUploadSizeMb = 0, CA.prototype.multipleFiles = !1, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.acceptDirectory = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(10).string(gA.id), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(18).string(gA.label), gA.type != null && gA.type.length) for (let IA = 0; IA < gA.type.length; ++IA) AA.uint32(26).string(gA.type[IA]);
    return gA.maxUploadSizeMb != null && Object.hasOwnProperty.call(gA, "maxUploadSizeMb") && AA.uint32(32).int32(gA.maxUploadSizeMb), gA.multipleFiles != null && Object.hasOwnProperty.call(gA, "multipleFiles") && AA.uint32(48).bool(gA.multipleFiles), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(58).string(gA.help), gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(66).string(gA.formId), gA.disabled != null && Object.hasOwnProperty.call(gA, "disabled") && AA.uint32(72).bool(gA.disabled), gA.labelVisibility != null && Object.hasOwnProperty.call(gA, "labelVisibility") && $root.LabelVisibility.encode(gA.labelVisibility, AA.uint32(82).fork()).ldelim(), gA.acceptDirectory != null && Object.hasOwnProperty.call(gA, "acceptDirectory") && AA.uint32(88).bool(gA.acceptDirectory), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FileUploader();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.id = gA.string();
          break;
        case 2:
          QA.label = gA.string();
          break;
        case 3:
          QA.type && QA.type.length || (QA.type = []), QA.type.push(gA.string());
          break;
        case 4:
          QA.maxUploadSizeMb = gA.int32();
          break;
        case 6:
          QA.multipleFiles = gA.bool();
          break;
        case 7:
          QA.help = gA.string();
          break;
        case 8:
          QA.formId = gA.string();
          break;
        case 9:
          QA.disabled = gA.bool();
          break;
        case 10:
          QA.labelVisibility = $root.LabelVisibility.decode(gA, gA.uint32());
          break;
        case 11:
          QA.acceptDirectory = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FileUploader) return gA;
    let AA = new $root.FileUploader();
    if (gA.id != null && (AA.id = String(gA.id)), gA.label != null && (AA.label = String(gA.label)), gA.type) {
      if (!Array.isArray(gA.type)) throw TypeError(".FileUploader.type: array expected");
      AA.type = [];
      for (let IA = 0; IA < gA.type.length; ++IA) AA.type[IA] = String(gA.type[IA]);
    }
    if (gA.maxUploadSizeMb != null && (AA.maxUploadSizeMb = gA.maxUploadSizeMb | 0), gA.multipleFiles != null && (AA.multipleFiles = !!gA.multipleFiles), gA.help != null && (AA.help = String(gA.help)), gA.formId != null && (AA.formId = String(gA.formId)), gA.disabled != null && (AA.disabled = !!gA.disabled), gA.labelVisibility != null) {
      if (typeof gA.labelVisibility != "object") throw TypeError(".FileUploader.labelVisibility: object expected");
      AA.labelVisibility = $root.LabelVisibility.fromObject(gA.labelVisibility);
    }
    return gA.acceptDirectory != null && (AA.acceptDirectory = !!gA.acceptDirectory), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.type = []), AA.defaults && (IA.id = "", IA.label = "", IA.maxUploadSizeMb = 0, IA.multipleFiles = !1, IA.help = "", IA.formId = "", IA.disabled = !1, IA.labelVisibility = null, IA.acceptDirectory = !1), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.type && gA.type.length) {
      IA.type = [];
      for (let BA = 0; BA < gA.type.length; ++BA) IA.type[BA] = gA.type[BA];
    }
    return gA.maxUploadSizeMb != null && gA.hasOwnProperty("maxUploadSizeMb") && (IA.maxUploadSizeMb = gA.maxUploadSizeMb), gA.multipleFiles != null && gA.hasOwnProperty("multipleFiles") && (IA.multipleFiles = gA.multipleFiles), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), gA.disabled != null && gA.hasOwnProperty("disabled") && (IA.disabled = gA.disabled), gA.labelVisibility != null && gA.hasOwnProperty("labelVisibility") && (IA.labelVisibility = $root.LabelVisibility.toObject(gA.labelVisibility, AA)), gA.acceptDirectory != null && gA.hasOwnProperty("acceptDirectory") && (IA.acceptDirectory = gA.acceptDirectory), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FileUploader";
  }, CA;
})();
$root.GraphVizChart = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.spec = "", CA.prototype.elementId = "", CA.prototype.engine = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.spec != null && Object.hasOwnProperty.call(gA, "spec") && AA.uint32(10).string(gA.spec), gA.elementId != null && Object.hasOwnProperty.call(gA, "elementId") && AA.uint32(42).string(gA.elementId), gA.engine != null && Object.hasOwnProperty.call(gA, "engine") && AA.uint32(50).string(gA.engine), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.GraphVizChart();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.spec = gA.string();
          break;
        case 5:
          QA.elementId = gA.string();
          break;
        case 6:
          QA.engine = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.GraphVizChart) return gA;
    let AA = new $root.GraphVizChart();
    return gA.spec != null && (AA.spec = String(gA.spec)), gA.elementId != null && (AA.elementId = String(gA.elementId)), gA.engine != null && (AA.engine = String(gA.engine)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.spec = "", IA.elementId = "", IA.engine = ""), gA.spec != null && gA.hasOwnProperty("spec") && (IA.spec = gA.spec), gA.elementId != null && gA.hasOwnProperty("elementId") && (IA.elementId = gA.elementId), gA.engine != null && gA.hasOwnProperty("engine") && (IA.engine = gA.engine), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/GraphVizChart";
  }, CA;
})();
$root.Heading = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.tag = "", CA.prototype.anchor = "", CA.prototype.body = "", CA.prototype.help = "", CA.prototype.hideAnchor = !1, CA.prototype.divider = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.tag != null && Object.hasOwnProperty.call(gA, "tag") && AA.uint32(10).string(gA.tag), gA.anchor != null && Object.hasOwnProperty.call(gA, "anchor") && AA.uint32(18).string(gA.anchor), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(26).string(gA.body), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(34).string(gA.help), gA.hideAnchor != null && Object.hasOwnProperty.call(gA, "hideAnchor") && AA.uint32(40).bool(gA.hideAnchor), gA.divider != null && Object.hasOwnProperty.call(gA, "divider") && AA.uint32(50).string(gA.divider), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Heading();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.tag = gA.string();
          break;
        case 2:
          QA.anchor = gA.string();
          break;
        case 3:
          QA.body = gA.string();
          break;
        case 4:
          QA.help = gA.string();
          break;
        case 5:
          QA.hideAnchor = gA.bool();
          break;
        case 6:
          QA.divider = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Heading) return gA;
    let AA = new $root.Heading();
    return gA.tag != null && (AA.tag = String(gA.tag)), gA.anchor != null && (AA.anchor = String(gA.anchor)), gA.body != null && (AA.body = String(gA.body)), gA.help != null && (AA.help = String(gA.help)), gA.hideAnchor != null && (AA.hideAnchor = !!gA.hideAnchor), gA.divider != null && (AA.divider = String(gA.divider)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.tag = "", IA.anchor = "", IA.body = "", IA.help = "", IA.hideAnchor = !1, IA.divider = ""), gA.tag != null && gA.hasOwnProperty("tag") && (IA.tag = gA.tag), gA.anchor != null && gA.hasOwnProperty("anchor") && (IA.anchor = gA.anchor), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.hideAnchor != null && gA.hasOwnProperty("hideAnchor") && (IA.hideAnchor = gA.hideAnchor), gA.divider != null && gA.hasOwnProperty("divider") && (IA.divider = gA.divider), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Heading";
  }, CA;
})();
$root.Help = (() => {
  function CA(gA) {
    if (this.members = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.docString = "", CA.prototype.type = "", CA.prototype.name = "", CA.prototype.value = "", CA.prototype.members = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.docString != null && Object.hasOwnProperty.call(gA, "docString") && AA.uint32(26).string(gA.docString), gA.type != null && Object.hasOwnProperty.call(gA, "type") && AA.uint32(34).string(gA.type), gA.name != null && Object.hasOwnProperty.call(gA, "name") && AA.uint32(50).string(gA.name), gA.value != null && Object.hasOwnProperty.call(gA, "value") && AA.uint32(58).string(gA.value), gA.members != null && gA.members.length) for (let IA = 0; IA < gA.members.length; ++IA) $root.Member.encode(gA.members[IA], AA.uint32(66).fork()).ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Help();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 3:
          QA.docString = gA.string();
          break;
        case 4:
          QA.type = gA.string();
          break;
        case 6:
          QA.name = gA.string();
          break;
        case 7:
          QA.value = gA.string();
          break;
        case 8:
          QA.members && QA.members.length || (QA.members = []), QA.members.push($root.Member.decode(gA, gA.uint32()));
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Help) return gA;
    let AA = new $root.Help();
    if (gA.docString != null && (AA.docString = String(gA.docString)), gA.type != null && (AA.type = String(gA.type)), gA.name != null && (AA.name = String(gA.name)), gA.value != null && (AA.value = String(gA.value)), gA.members) {
      if (!Array.isArray(gA.members)) throw TypeError(".Help.members: array expected");
      AA.members = [];
      for (let IA = 0; IA < gA.members.length; ++IA) {
        if (typeof gA.members[IA] != "object") throw TypeError(".Help.members: object expected");
        AA.members[IA] = $root.Member.fromObject(gA.members[IA]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.members = []), AA.defaults && (IA.docString = "", IA.type = "", IA.name = "", IA.value = ""), gA.docString != null && gA.hasOwnProperty("docString") && (IA.docString = gA.docString), gA.type != null && gA.hasOwnProperty("type") && (IA.type = gA.type), gA.name != null && gA.hasOwnProperty("name") && (IA.name = gA.name), gA.value != null && gA.hasOwnProperty("value") && (IA.value = gA.value), gA.members && gA.members.length) {
      IA.members = [];
      for (let BA = 0; BA < gA.members.length; ++BA) IA.members[BA] = $root.Member.toObject(gA.members[BA], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Help";
  }, CA;
})();
$root.Member = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.name = "", CA.prototype.type = "", CA.prototype.value = null, CA.prototype.docString = null;
  let gA;
  return Object.defineProperty(CA.prototype, "contents", { get: $util.oneOfGetter(gA = ["value", "docString"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(10).string(AA.name), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(18).string(AA.type), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(26).string(AA.value), AA.docString != null && Object.hasOwnProperty.call(AA, "docString") && IA.uint32(34).string(AA.docString), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Member();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.name = AA.string();
          break;
        case 2:
          EA.type = AA.string();
          break;
        case 3:
          EA.value = AA.string();
          break;
        case 4:
          EA.docString = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Member) return AA;
    let IA = new $root.Member();
    return AA.name != null && (IA.name = String(AA.name)), AA.type != null && (IA.type = String(AA.type)), AA.value != null && (IA.value = String(AA.value)), AA.docString != null && (IA.docString = String(AA.docString)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.name = "", BA.type = ""), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.type != null && AA.hasOwnProperty("type") && (BA.type = AA.type), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value, IA.oneofs && (BA.contents = "value")), AA.docString != null && AA.hasOwnProperty("docString") && (BA.docString = AA.docString, IA.oneofs && (BA.contents = "docString")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Member";
  }, CA;
})();
$root.Html = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.unsafeAllowJavascript = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(10).string(gA.body), gA.unsafeAllowJavascript != null && Object.hasOwnProperty.call(gA, "unsafeAllowJavascript") && AA.uint32(16).bool(gA.unsafeAllowJavascript), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Html();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.body = gA.string();
          break;
        case 2:
          QA.unsafeAllowJavascript = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Html) return gA;
    let AA = new $root.Html();
    return gA.body != null && (AA.body = String(gA.body)), gA.unsafeAllowJavascript != null && (AA.unsafeAllowJavascript = !!gA.unsafeAllowJavascript), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.body = "", IA.unsafeAllowJavascript = !1), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.unsafeAllowJavascript != null && gA.hasOwnProperty("unsafeAllowJavascript") && (IA.unsafeAllowJavascript = gA.unsafeAllowJavascript), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Html";
  }, CA;
})();
$root.IFrame = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.src = null, CA.prototype.srcdoc = null, CA.prototype.scrolling = !1, CA.prototype.tabIndex = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["src", "srcdoc"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_tabIndex", { get: $util.oneOfGetter(gA = ["tabIndex"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.src != null && Object.hasOwnProperty.call(AA, "src") && IA.uint32(10).string(AA.src), AA.srcdoc != null && Object.hasOwnProperty.call(AA, "srcdoc") && IA.uint32(18).string(AA.srcdoc), AA.scrolling != null && Object.hasOwnProperty.call(AA, "scrolling") && IA.uint32(56).bool(AA.scrolling), AA.tabIndex != null && Object.hasOwnProperty.call(AA, "tabIndex") && IA.uint32(64).int32(AA.tabIndex), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.IFrame();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.src = AA.string();
          break;
        case 2:
          EA.srcdoc = AA.string();
          break;
        case 7:
          EA.scrolling = AA.bool();
          break;
        case 8:
          EA.tabIndex = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.IFrame) return AA;
    let IA = new $root.IFrame();
    return AA.src != null && (IA.src = String(AA.src)), AA.srcdoc != null && (IA.srcdoc = String(AA.srcdoc)), AA.scrolling != null && (IA.scrolling = !!AA.scrolling), AA.tabIndex != null && (IA.tabIndex = AA.tabIndex | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.scrolling = !1), AA.src != null && AA.hasOwnProperty("src") && (BA.src = AA.src, IA.oneofs && (BA.type = "src")), AA.srcdoc != null && AA.hasOwnProperty("srcdoc") && (BA.srcdoc = AA.srcdoc, IA.oneofs && (BA.type = "srcdoc")), AA.scrolling != null && AA.hasOwnProperty("scrolling") && (BA.scrolling = AA.scrolling), AA.tabIndex != null && AA.hasOwnProperty("tabIndex") && (BA.tabIndex = AA.tabIndex, IA.oneofs && (BA._tabIndex = "tabIndex")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/IFrame";
  }, CA;
})();
$root.Image = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.prototype.caption = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.caption != null && Object.hasOwnProperty.call(gA, "caption") && AA.uint32(18).string(gA.caption), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(26).string(gA.url), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Image();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 3:
          QA.url = gA.string();
          break;
        case 2:
          QA.caption = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Image) return gA;
    let AA = new $root.Image();
    return gA.url != null && (AA.url = String(gA.url)), gA.caption != null && (AA.caption = String(gA.caption)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.caption = "", IA.url = ""), gA.caption != null && gA.hasOwnProperty("caption") && (IA.caption = gA.caption), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Image";
  }, CA;
})();
$root.ImageList = (() => {
  function CA(gA) {
    if (this.imgs = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.imgs = $util.emptyArray, CA.prototype.link = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.imgs != null && gA.imgs.length) for (let IA = 0; IA < gA.imgs.length; ++IA) $root.Image.encode(gA.imgs[IA], AA.uint32(10).fork()).ldelim();
    return gA.link != null && Object.hasOwnProperty.call(gA, "link") && AA.uint32(26).string(gA.link), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ImageList();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.imgs && QA.imgs.length || (QA.imgs = []), QA.imgs.push($root.Image.decode(gA, gA.uint32()));
          break;
        case 3:
          QA.link = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ImageList) return gA;
    let AA = new $root.ImageList();
    if (gA.imgs) {
      if (!Array.isArray(gA.imgs)) throw TypeError(".ImageList.imgs: array expected");
      AA.imgs = [];
      for (let IA = 0; IA < gA.imgs.length; ++IA) {
        if (typeof gA.imgs[IA] != "object") throw TypeError(".ImageList.imgs: object expected");
        AA.imgs[IA] = $root.Image.fromObject(gA.imgs[IA]);
      }
    }
    return gA.link != null && (AA.link = String(gA.link)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.imgs = []), AA.defaults && (IA.link = ""), gA.imgs && gA.imgs.length) {
      IA.imgs = [];
      for (let BA = 0; BA < gA.imgs.length; ++BA) IA.imgs[BA] = $root.Image.toObject(gA.imgs[BA], AA);
    }
    return gA.link != null && gA.hasOwnProperty("link") && (IA.link = gA.link), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ImageList";
  }, CA;
})();
$root.Json = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.body = "", CA.prototype.expanded = !1, CA.prototype.maxExpandDepth = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_maxExpandDepth", { get: $util.oneOfGetter(gA = ["maxExpandDepth"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(10).string(AA.body), AA.expanded != null && Object.hasOwnProperty.call(AA, "expanded") && IA.uint32(16).bool(AA.expanded), AA.maxExpandDepth != null && Object.hasOwnProperty.call(AA, "maxExpandDepth") && IA.uint32(24).int32(AA.maxExpandDepth), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Json();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.body = AA.string();
          break;
        case 2:
          EA.expanded = AA.bool();
          break;
        case 3:
          EA.maxExpandDepth = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Json) return AA;
    let IA = new $root.Json();
    return AA.body != null && (IA.body = String(AA.body)), AA.expanded != null && (IA.expanded = !!AA.expanded), AA.maxExpandDepth != null && (IA.maxExpandDepth = AA.maxExpandDepth | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.body = "", BA.expanded = !1), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.expanded != null && AA.hasOwnProperty("expanded") && (BA.expanded = AA.expanded), AA.maxExpandDepth != null && AA.hasOwnProperty("maxExpandDepth") && (BA.maxExpandDepth = AA.maxExpandDepth, IA.oneofs && (BA._maxExpandDepth = "maxExpandDepth")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Json";
  }, CA;
})();
$root.LinkButton = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.help = "", CA.prototype.url = "", CA.prototype.disabled = !1, CA.prototype.useContainerWidth = !1, CA.prototype.type = "", CA.prototype.icon = "", CA.prototype.shortcut = "", CA.prototype.iconPosition = 0, CA.prototype.ignoreRerun = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(10).string(gA.id), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(18).string(gA.label), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(34).string(gA.help), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(50).string(gA.url), gA.disabled != null && Object.hasOwnProperty.call(gA, "disabled") && AA.uint32(56).bool(gA.disabled), gA.useContainerWidth != null && Object.hasOwnProperty.call(gA, "useContainerWidth") && AA.uint32(64).bool(gA.useContainerWidth), gA.type != null && Object.hasOwnProperty.call(gA, "type") && AA.uint32(74).string(gA.type), gA.icon != null && Object.hasOwnProperty.call(gA, "icon") && AA.uint32(82).string(gA.icon), gA.shortcut != null && Object.hasOwnProperty.call(gA, "shortcut") && AA.uint32(90).string(gA.shortcut), gA.iconPosition != null && Object.hasOwnProperty.call(gA, "iconPosition") && AA.uint32(96).int32(gA.iconPosition), gA.ignoreRerun != null && Object.hasOwnProperty.call(gA, "ignoreRerun") && AA.uint32(104).bool(gA.ignoreRerun), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.LinkButton();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.id = gA.string();
          break;
        case 2:
          QA.label = gA.string();
          break;
        case 4:
          QA.help = gA.string();
          break;
        case 6:
          QA.url = gA.string();
          break;
        case 7:
          QA.disabled = gA.bool();
          break;
        case 8:
          QA.useContainerWidth = gA.bool();
          break;
        case 9:
          QA.type = gA.string();
          break;
        case 10:
          QA.icon = gA.string();
          break;
        case 11:
          QA.shortcut = gA.string();
          break;
        case 12:
          QA.iconPosition = gA.int32();
          break;
        case 13:
          QA.ignoreRerun = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.LinkButton) return gA;
    let AA = new $root.LinkButton();
    switch (gA.id != null && (AA.id = String(gA.id)), gA.label != null && (AA.label = String(gA.label)), gA.help != null && (AA.help = String(gA.help)), gA.url != null && (AA.url = String(gA.url)), gA.disabled != null && (AA.disabled = !!gA.disabled), gA.useContainerWidth != null && (AA.useContainerWidth = !!gA.useContainerWidth), gA.type != null && (AA.type = String(gA.type)), gA.icon != null && (AA.icon = String(gA.icon)), gA.shortcut != null && (AA.shortcut = String(gA.shortcut)), gA.iconPosition) {
      default:
        if (typeof gA.iconPosition == "number") {
          AA.iconPosition = gA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        AA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        AA.iconPosition = 1;
        break;
    }
    return gA.ignoreRerun != null && (AA.ignoreRerun = !!gA.ignoreRerun), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.id = "", IA.label = "", IA.help = "", IA.url = "", IA.disabled = !1, IA.useContainerWidth = !1, IA.type = "", IA.icon = "", IA.shortcut = "", IA.iconPosition = AA.enums === String ? "LEFT" : 0, IA.ignoreRerun = !1), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), gA.disabled != null && gA.hasOwnProperty("disabled") && (IA.disabled = gA.disabled), gA.useContainerWidth != null && gA.hasOwnProperty("useContainerWidth") && (IA.useContainerWidth = gA.useContainerWidth), gA.type != null && gA.hasOwnProperty("type") && (IA.type = gA.type), gA.icon != null && gA.hasOwnProperty("icon") && (IA.icon = gA.icon), gA.shortcut != null && gA.hasOwnProperty("shortcut") && (IA.shortcut = gA.shortcut), gA.iconPosition != null && gA.hasOwnProperty("iconPosition") && (IA.iconPosition = AA.enums === String ? $root.streamlit.ButtonLikeIconPosition[gA.iconPosition] === void 0 ? gA.iconPosition : $root.streamlit.ButtonLikeIconPosition[gA.iconPosition] : gA.iconPosition), gA.ignoreRerun != null && gA.hasOwnProperty("ignoreRerun") && (IA.ignoreRerun = gA.ignoreRerun), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/LinkButton";
  }, CA;
})();
$root.Markdown = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.allowHtml = !1, CA.prototype.elementType = 0, CA.prototype.help = "", CA.prototype.unterminatedParsing = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(10).string(gA.body), gA.allowHtml != null && Object.hasOwnProperty.call(gA, "allowHtml") && AA.uint32(16).bool(gA.allowHtml), gA.elementType != null && Object.hasOwnProperty.call(gA, "elementType") && AA.uint32(32).int32(gA.elementType), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(42).string(gA.help), gA.unterminatedParsing != null && Object.hasOwnProperty.call(gA, "unterminatedParsing") && AA.uint32(48).bool(gA.unterminatedParsing), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Markdown();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.body = gA.string();
          break;
        case 2:
          QA.allowHtml = gA.bool();
          break;
        case 4:
          QA.elementType = gA.int32();
          break;
        case 5:
          QA.help = gA.string();
          break;
        case 6:
          QA.unterminatedParsing = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Markdown) return gA;
    let AA = new $root.Markdown();
    switch (gA.body != null && (AA.body = String(gA.body)), gA.allowHtml != null && (AA.allowHtml = !!gA.allowHtml), gA.elementType) {
      default:
        if (typeof gA.elementType == "number") {
          AA.elementType = gA.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        AA.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        AA.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        AA.elementType = 2;
        break;
      case "CODE":
      case 3:
        AA.elementType = 3;
        break;
      case "LATEX":
      case 4:
        AA.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        AA.elementType = 5;
        break;
    }
    return gA.help != null && (AA.help = String(gA.help)), gA.unterminatedParsing != null && (AA.unterminatedParsing = !!gA.unterminatedParsing), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.body = "", IA.allowHtml = !1, IA.elementType = AA.enums === String ? "UNSPECIFIED" : 0, IA.help = "", IA.unterminatedParsing = !1), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.allowHtml != null && gA.hasOwnProperty("allowHtml") && (IA.allowHtml = gA.allowHtml), gA.elementType != null && gA.hasOwnProperty("elementType") && (IA.elementType = AA.enums === String ? $root.Markdown.Type[gA.elementType] === void 0 ? gA.elementType : $root.Markdown.Type[gA.elementType] : gA.elementType), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.unterminatedParsing != null && gA.hasOwnProperty("unterminatedParsing") && (IA.unterminatedParsing = gA.unterminatedParsing), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Markdown";
  }, CA.Type = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNSPECIFIED"] = 0, AA[gA[1] = "NATIVE"] = 1, AA[gA[2] = "CAPTION"] = 2, AA[gA[3] = "CODE"] = 3, AA[gA[4] = "LATEX"] = 4, AA[gA[5] = "DIVIDER"] = 5, AA;
  })(), CA;
})();
$root.MenuButton = (() => {
  function CA(gA) {
    if (this.options = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.id = "", CA.prototype.label = "", CA.prototype.options = $util.emptyArray, CA.prototype.help = "", CA.prototype.type = "", CA.prototype.disabled = !1, CA.prototype.icon = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(10).string(gA.id), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(18).string(gA.label), gA.options != null && gA.options.length) for (let IA = 0; IA < gA.options.length; ++IA) AA.uint32(26).string(gA.options[IA]);
    return gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(34).string(gA.help), gA.type != null && Object.hasOwnProperty.call(gA, "type") && AA.uint32(42).string(gA.type), gA.disabled != null && Object.hasOwnProperty.call(gA, "disabled") && AA.uint32(48).bool(gA.disabled), gA.icon != null && Object.hasOwnProperty.call(gA, "icon") && AA.uint32(58).string(gA.icon), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.MenuButton();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.id = gA.string();
          break;
        case 2:
          QA.label = gA.string();
          break;
        case 3:
          QA.options && QA.options.length || (QA.options = []), QA.options.push(gA.string());
          break;
        case 4:
          QA.help = gA.string();
          break;
        case 5:
          QA.type = gA.string();
          break;
        case 6:
          QA.disabled = gA.bool();
          break;
        case 7:
          QA.icon = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.MenuButton) return gA;
    let AA = new $root.MenuButton();
    if (gA.id != null && (AA.id = String(gA.id)), gA.label != null && (AA.label = String(gA.label)), gA.options) {
      if (!Array.isArray(gA.options)) throw TypeError(".MenuButton.options: array expected");
      AA.options = [];
      for (let IA = 0; IA < gA.options.length; ++IA) AA.options[IA] = String(gA.options[IA]);
    }
    return gA.help != null && (AA.help = String(gA.help)), gA.type != null && (AA.type = String(gA.type)), gA.disabled != null && (AA.disabled = !!gA.disabled), gA.icon != null && (AA.icon = String(gA.icon)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.options = []), AA.defaults && (IA.id = "", IA.label = "", IA.help = "", IA.type = "", IA.disabled = !1, IA.icon = ""), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.options && gA.options.length) {
      IA.options = [];
      for (let BA = 0; BA < gA.options.length; ++BA) IA.options[BA] = gA.options[BA];
    }
    return gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.type != null && gA.hasOwnProperty("type") && (IA.type = gA.type), gA.disabled != null && gA.hasOwnProperty("disabled") && (IA.disabled = gA.disabled), gA.icon != null && gA.hasOwnProperty("icon") && (IA.icon = gA.icon), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/MenuButton";
  }, CA;
})();
$root.Metric = (() => {
  function CA(gA) {
    if (this.chartData = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.label = "", CA.prototype.body = "", CA.prototype.delta = "", CA.prototype.direction = 0, CA.prototype.color = 0, CA.prototype.help = "", CA.prototype.labelVisibility = null, CA.prototype.showBorder = !1, CA.prototype.chartData = $util.emptyArray, CA.prototype.chartType = 0, CA.prototype.format = "", CA.prototype.deltaDescription = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(10).string(gA.label), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(18).string(gA.body), gA.delta != null && Object.hasOwnProperty.call(gA, "delta") && AA.uint32(26).string(gA.delta), gA.direction != null && Object.hasOwnProperty.call(gA, "direction") && AA.uint32(32).int32(gA.direction), gA.color != null && Object.hasOwnProperty.call(gA, "color") && AA.uint32(40).int32(gA.color), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(50).string(gA.help), gA.labelVisibility != null && Object.hasOwnProperty.call(gA, "labelVisibility") && $root.LabelVisibility.encode(gA.labelVisibility, AA.uint32(58).fork()).ldelim(), gA.showBorder != null && Object.hasOwnProperty.call(gA, "showBorder") && AA.uint32(64).bool(gA.showBorder), gA.chartData != null && gA.chartData.length) {
      AA.uint32(74).fork();
      for (let IA = 0; IA < gA.chartData.length; ++IA) AA.double(gA.chartData[IA]);
      AA.ldelim();
    }
    return gA.chartType != null && Object.hasOwnProperty.call(gA, "chartType") && AA.uint32(80).int32(gA.chartType), gA.format != null && Object.hasOwnProperty.call(gA, "format") && AA.uint32(90).string(gA.format), gA.deltaDescription != null && Object.hasOwnProperty.call(gA, "deltaDescription") && AA.uint32(98).string(gA.deltaDescription), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Metric();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.label = gA.string();
          break;
        case 2:
          QA.body = gA.string();
          break;
        case 3:
          QA.delta = gA.string();
          break;
        case 4:
          QA.direction = gA.int32();
          break;
        case 5:
          QA.color = gA.int32();
          break;
        case 6:
          QA.help = gA.string();
          break;
        case 7:
          QA.labelVisibility = $root.LabelVisibility.decode(gA, gA.uint32());
          break;
        case 8:
          QA.showBorder = gA.bool();
          break;
        case 9:
          if (QA.chartData && QA.chartData.length || (QA.chartData = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.chartData.push(gA.double());
          } else QA.chartData.push(gA.double());
          break;
        case 10:
          QA.chartType = gA.int32();
          break;
        case 11:
          QA.format = gA.string();
          break;
        case 12:
          QA.deltaDescription = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Metric) return gA;
    let AA = new $root.Metric();
    switch (gA.label != null && (AA.label = String(gA.label)), gA.body != null && (AA.body = String(gA.body)), gA.delta != null && (AA.delta = String(gA.delta)), gA.direction) {
      default:
        if (typeof gA.direction == "number") {
          AA.direction = gA.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        AA.direction = 0;
        break;
      case "UP":
      case 1:
        AA.direction = 1;
        break;
      case "NONE":
      case 2:
        AA.direction = 2;
        break;
    }
    switch (gA.color) {
      default:
        if (typeof gA.color == "number") {
          AA.color = gA.color;
          break;
        }
        break;
      case "RED":
      case 0:
        AA.color = 0;
        break;
      case "GREEN":
      case 1:
        AA.color = 1;
        break;
      case "GRAY":
      case 2:
        AA.color = 2;
        break;
      case "ORANGE":
      case 3:
        AA.color = 3;
        break;
      case "YELLOW":
      case 4:
        AA.color = 4;
        break;
      case "BLUE":
      case 5:
        AA.color = 5;
        break;
      case "VIOLET":
      case 6:
        AA.color = 6;
        break;
      case "PRIMARY":
      case 7:
        AA.color = 7;
        break;
    }
    if (gA.help != null && (AA.help = String(gA.help)), gA.labelVisibility != null) {
      if (typeof gA.labelVisibility != "object") throw TypeError(".Metric.labelVisibility: object expected");
      AA.labelVisibility = $root.LabelVisibility.fromObject(gA.labelVisibility);
    }
    if (gA.showBorder != null && (AA.showBorder = !!gA.showBorder), gA.chartData) {
      if (!Array.isArray(gA.chartData)) throw TypeError(".Metric.chartData: array expected");
      AA.chartData = [];
      for (let IA = 0; IA < gA.chartData.length; ++IA) AA.chartData[IA] = Number(gA.chartData[IA]);
    }
    switch (gA.chartType) {
      default:
        if (typeof gA.chartType == "number") {
          AA.chartType = gA.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        AA.chartType = 0;
        break;
      case "BAR":
      case 1:
        AA.chartType = 1;
        break;
      case "AREA":
      case 2:
        AA.chartType = 2;
        break;
    }
    return gA.format != null && (AA.format = String(gA.format)), gA.deltaDescription != null && (AA.deltaDescription = String(gA.deltaDescription)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.chartData = []), AA.defaults && (IA.label = "", IA.body = "", IA.delta = "", IA.direction = AA.enums === String ? "DOWN" : 0, IA.color = AA.enums === String ? "RED" : 0, IA.help = "", IA.labelVisibility = null, IA.showBorder = !1, IA.chartType = AA.enums === String ? "LINE" : 0, IA.format = "", IA.deltaDescription = ""), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.delta != null && gA.hasOwnProperty("delta") && (IA.delta = gA.delta), gA.direction != null && gA.hasOwnProperty("direction") && (IA.direction = AA.enums === String ? $root.Metric.MetricDirection[gA.direction] === void 0 ? gA.direction : $root.Metric.MetricDirection[gA.direction] : gA.direction), gA.color != null && gA.hasOwnProperty("color") && (IA.color = AA.enums === String ? $root.Metric.MetricColor[gA.color] === void 0 ? gA.color : $root.Metric.MetricColor[gA.color] : gA.color), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), gA.labelVisibility != null && gA.hasOwnProperty("labelVisibility") && (IA.labelVisibility = $root.LabelVisibility.toObject(gA.labelVisibility, AA)), gA.showBorder != null && gA.hasOwnProperty("showBorder") && (IA.showBorder = gA.showBorder), gA.chartData && gA.chartData.length) {
      IA.chartData = [];
      for (let BA = 0; BA < gA.chartData.length; ++BA) IA.chartData[BA] = AA.json && !isFinite(gA.chartData[BA]) ? String(gA.chartData[BA]) : gA.chartData[BA];
    }
    return gA.chartType != null && gA.hasOwnProperty("chartType") && (IA.chartType = AA.enums === String ? $root.Metric.ChartType[gA.chartType] === void 0 ? gA.chartType : $root.Metric.ChartType[gA.chartType] : gA.chartType), gA.format != null && gA.hasOwnProperty("format") && (IA.format = gA.format), gA.deltaDescription != null && gA.hasOwnProperty("deltaDescription") && (IA.deltaDescription = gA.deltaDescription), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Metric";
  }, CA.MetricDirection = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "DOWN"] = 0, AA[gA[1] = "UP"] = 1, AA[gA[2] = "NONE"] = 2, AA;
  })(), CA.MetricColor = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "RED"] = 0, AA[gA[1] = "GREEN"] = 1, AA[gA[2] = "GRAY"] = 2, AA[gA[3] = "ORANGE"] = 3, AA[gA[4] = "YELLOW"] = 4, AA[gA[5] = "BLUE"] = 5, AA[gA[6] = "VIOLET"] = 6, AA[gA[7] = "PRIMARY"] = 7, AA;
  })(), CA.ChartType = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "LINE"] = 0, AA[gA[1] = "BAR"] = 1, AA[gA[2] = "AREA"] = 2, AA;
  })(), CA;
})();
$root.MultiSelect = (() => {
  function CA(AA) {
    if (this.default = [], this.options = [], this.rawValues = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = $util.emptyArray, CA.prototype.options = $util.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValues = $util.emptyArray, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.maxSelections = 0, CA.prototype.placeholder = "", CA.prototype.acceptNewOptions = null, CA.prototype.queryParamKey = null, CA.prototype.filterMode = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(gA = ["acceptNewOptions"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && AA.default.length) {
      IA.uint32(26).fork();
      for (let BA = 0; BA < AA.default.length; ++BA) IA.int32(AA.default[BA]);
      IA.ldelim();
    }
    if (AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) IA.uint32(34).string(AA.options[BA]);
    if (AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(42).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(64).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(72).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(82).fork()).ldelim(), AA.maxSelections != null && Object.hasOwnProperty.call(AA, "maxSelections") && IA.uint32(88).int32(AA.maxSelections), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(98).string(AA.placeholder), AA.acceptNewOptions != null && Object.hasOwnProperty.call(AA, "acceptNewOptions") && IA.uint32(104).bool(AA.acceptNewOptions), AA.rawValues != null && AA.rawValues.length) for (let BA = 0; BA < AA.rawValues.length; ++BA) IA.uint32(114).string(AA.rawValues[BA]);
    return AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(122).string(AA.queryParamKey), AA.filterMode != null && Object.hasOwnProperty.call(AA, "filterMode") && IA.uint32(128).int32(AA.filterMode), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.MultiSelect();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          if (EA.default && EA.default.length || (EA.default = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.default.push(AA.int32());
          } else EA.default.push(AA.int32());
          break;
        case 4:
          EA.options && EA.options.length || (EA.options = []), EA.options.push(AA.string());
          break;
        case 5:
          EA.help = AA.string();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 14:
          EA.rawValues && EA.rawValues.length || (EA.rawValues = []), EA.rawValues.push(AA.string());
          break;
        case 8:
          EA.setValue = AA.bool();
          break;
        case 9:
          EA.disabled = AA.bool();
          break;
        case 10:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 11:
          EA.maxSelections = AA.int32();
          break;
        case 12:
          EA.placeholder = AA.string();
          break;
        case 13:
          EA.acceptNewOptions = AA.bool();
          break;
        case 15:
          EA.queryParamKey = AA.string();
          break;
        case 16:
          EA.filterMode = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.MultiSelect) return AA;
    let IA = new $root.MultiSelect();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default) {
      if (!Array.isArray(AA.default)) throw TypeError(".MultiSelect.default: array expected");
      IA.default = [];
      for (let BA = 0; BA < AA.default.length; ++BA) IA.default[BA] = AA.default[BA] | 0;
    }
    if (AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".MultiSelect.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) IA.options[BA] = String(AA.options[BA]);
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.rawValues) {
      if (!Array.isArray(AA.rawValues)) throw TypeError(".MultiSelect.rawValues: array expected");
      IA.rawValues = [];
      for (let BA = 0; BA < AA.rawValues.length; ++BA) IA.rawValues[BA] = String(AA.rawValues[BA]);
    }
    if (AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".MultiSelect.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    switch (AA.maxSelections != null && (IA.maxSelections = AA.maxSelections | 0), AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.acceptNewOptions != null && (IA.acceptNewOptions = !!AA.acceptNewOptions), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), AA.filterMode) {
      default:
        if (typeof AA.filterMode == "number") {
          IA.filterMode = AA.filterMode;
          break;
        }
        break;
      case "FILTER_MODE_FUZZY":
      case 0:
        IA.filterMode = 0;
        break;
      case "FILTER_MODE_CONTAINS":
      case 1:
        IA.filterMode = 1;
        break;
      case "FILTER_MODE_PREFIX":
      case 2:
        IA.filterMode = 2;
        break;
      case "FILTER_MODE_NONE":
      case 3:
        IA.filterMode = 3;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.default = [], BA.options = [], BA.rawValues = []), IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.maxSelections = 0, BA.placeholder = "", BA.filterMode = IA.enums === String ? "FILTER_MODE_FUZZY" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default && AA.default.length) {
      BA.default = [];
      for (let QA = 0; QA < AA.default.length; ++QA) BA.default[QA] = AA.default[QA];
    }
    if (AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = AA.options[QA];
    }
    if (AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.maxSelections != null && AA.hasOwnProperty("maxSelections") && (BA.maxSelections = AA.maxSelections), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.acceptNewOptions != null && AA.hasOwnProperty("acceptNewOptions") && (BA.acceptNewOptions = AA.acceptNewOptions, IA.oneofs && (BA._acceptNewOptions = "acceptNewOptions")), AA.rawValues && AA.rawValues.length) {
      BA.rawValues = [];
      for (let QA = 0; QA < AA.rawValues.length; ++QA) BA.rawValues[QA] = AA.rawValues[QA];
    }
    return AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), AA.filterMode != null && AA.hasOwnProperty("filterMode") && (BA.filterMode = IA.enums === String ? $root.streamlit.SelectWidgetFilterMode[AA.filterMode] === void 0 ? AA.filterMode : $root.streamlit.SelectWidgetFilterMode[AA.filterMode] : AA.filterMode), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/MultiSelect";
  }, CA;
})();
$root.NumberInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.formId = "", CA.prototype.format = "", CA.prototype.hasMin = !1, CA.prototype.hasMax = !1, CA.prototype.dataType = 0, CA.prototype.default = null, CA.prototype.step = 0, CA.prototype.min = 0, CA.prototype.max = 0, CA.prototype.help = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.placeholder = "", CA.prototype.icon = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util.oneOfGetter(gA = ["value"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(26).string(AA.formId), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(66).string(AA.format), AA.hasMin != null && Object.hasOwnProperty.call(AA, "hasMin") && IA.uint32(88).bool(AA.hasMin), AA.hasMax != null && Object.hasOwnProperty.call(AA, "hasMax") && IA.uint32(96).bool(AA.hasMax), AA.dataType != null && Object.hasOwnProperty.call(AA, "dataType") && IA.uint32(104).int32(AA.dataType), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(113).double(AA.default), AA.step != null && Object.hasOwnProperty.call(AA, "step") && IA.uint32(121).double(AA.step), AA.min != null && Object.hasOwnProperty.call(AA, "min") && IA.uint32(129).double(AA.min), AA.max != null && Object.hasOwnProperty.call(AA, "max") && IA.uint32(137).double(AA.max), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(146).string(AA.help), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(153).double(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(160).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(168).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(178).fork()).ldelim(), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(186).string(AA.placeholder), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(194).string(AA.icon), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(202).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.NumberInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.formId = AA.string();
          break;
        case 8:
          EA.format = AA.string();
          break;
        case 11:
          EA.hasMin = AA.bool();
          break;
        case 12:
          EA.hasMax = AA.bool();
          break;
        case 13:
          EA.dataType = AA.int32();
          break;
        case 14:
          EA.default = AA.double();
          break;
        case 15:
          EA.step = AA.double();
          break;
        case 16:
          EA.min = AA.double();
          break;
        case 17:
          EA.max = AA.double();
          break;
        case 18:
          EA.help = AA.string();
          break;
        case 19:
          EA.value = AA.double();
          break;
        case 20:
          EA.setValue = AA.bool();
          break;
        case 21:
          EA.disabled = AA.bool();
          break;
        case 22:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 23:
          EA.placeholder = AA.string();
          break;
        case 24:
          EA.icon = AA.string();
          break;
        case 25:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.NumberInput) return AA;
    let IA = new $root.NumberInput();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.formId != null && (IA.formId = String(AA.formId)), AA.format != null && (IA.format = String(AA.format)), AA.hasMin != null && (IA.hasMin = !!AA.hasMin), AA.hasMax != null && (IA.hasMax = !!AA.hasMax), AA.dataType) {
      default:
        if (typeof AA.dataType == "number") {
          IA.dataType = AA.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        IA.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        IA.dataType = 1;
        break;
    }
    if (AA.default != null && (IA.default = Number(AA.default)), AA.step != null && (IA.step = Number(AA.step)), AA.min != null && (IA.min = Number(AA.min)), AA.max != null && (IA.max = Number(AA.max)), AA.help != null && (IA.help = String(AA.help)), AA.value != null && (IA.value = Number(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".NumberInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.icon != null && (IA.icon = String(AA.icon)), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.formId = "", BA.format = "", BA.hasMin = !1, BA.hasMax = !1, BA.dataType = IA.enums === String ? "INT" : 0, BA.step = 0, BA.min = 0, BA.max = 0, BA.help = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.placeholder = "", BA.icon = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.format != null && AA.hasOwnProperty("format") && (BA.format = AA.format), AA.hasMin != null && AA.hasOwnProperty("hasMin") && (BA.hasMin = AA.hasMin), AA.hasMax != null && AA.hasOwnProperty("hasMax") && (BA.hasMax = AA.hasMax), AA.dataType != null && AA.hasOwnProperty("dataType") && (BA.dataType = IA.enums === String ? $root.NumberInput.DataType[AA.dataType] === void 0 ? AA.dataType : $root.NumberInput.DataType[AA.dataType] : AA.dataType), AA.default != null && AA.hasOwnProperty("default") && (BA.default = IA.json && !isFinite(AA.default) ? String(AA.default) : AA.default, IA.oneofs && (BA._default = "default")), AA.step != null && AA.hasOwnProperty("step") && (BA.step = IA.json && !isFinite(AA.step) ? String(AA.step) : AA.step), AA.min != null && AA.hasOwnProperty("min") && (BA.min = IA.json && !isFinite(AA.min) ? String(AA.min) : AA.min), AA.max != null && AA.hasOwnProperty("max") && (BA.max = IA.json && !isFinite(AA.max) ? String(AA.max) : AA.max), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.value != null && AA.hasOwnProperty("value") && (BA.value = IA.json && !isFinite(AA.value) ? String(AA.value) : AA.value, IA.oneofs && (BA._value = "value")), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/NumberInput";
  }, CA.DataType = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "INT"] = 0, IA[AA[1] = "FLOAT"] = 1, IA;
  })(), CA;
})();
$root.PageLink = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.page = "", CA.prototype.label = "", CA.prototype.icon = "", CA.prototype.pageScriptHash = "", CA.prototype.help = "", CA.prototype.useContainerWidth = null, CA.prototype.disabled = !1, CA.prototype.external = !1, CA.prototype.queryString = "", CA.prototype.iconPosition = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_useContainerWidth", { get: $util.oneOfGetter(gA = ["useContainerWidth"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.page != null && Object.hasOwnProperty.call(AA, "page") && IA.uint32(10).string(AA.page), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(26).string(AA.icon), AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(34).string(AA.pageScriptHash), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(42).string(AA.help), AA.useContainerWidth != null && Object.hasOwnProperty.call(AA, "useContainerWidth") && IA.uint32(48).bool(AA.useContainerWidth), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(56).bool(AA.disabled), AA.external != null && Object.hasOwnProperty.call(AA, "external") && IA.uint32(64).bool(AA.external), AA.queryString != null && Object.hasOwnProperty.call(AA, "queryString") && IA.uint32(74).string(AA.queryString), AA.iconPosition != null && Object.hasOwnProperty.call(AA, "iconPosition") && IA.uint32(80).int32(AA.iconPosition), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.PageLink();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.page = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.icon = AA.string();
          break;
        case 4:
          EA.pageScriptHash = AA.string();
          break;
        case 5:
          EA.help = AA.string();
          break;
        case 6:
          EA.useContainerWidth = AA.bool();
          break;
        case 7:
          EA.disabled = AA.bool();
          break;
        case 8:
          EA.external = AA.bool();
          break;
        case 9:
          EA.queryString = AA.string();
          break;
        case 10:
          EA.iconPosition = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.PageLink) return AA;
    let IA = new $root.PageLink();
    switch (AA.page != null && (IA.page = String(AA.page)), AA.label != null && (IA.label = String(AA.label)), AA.icon != null && (IA.icon = String(AA.icon)), AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.help != null && (IA.help = String(AA.help)), AA.useContainerWidth != null && (IA.useContainerWidth = !!AA.useContainerWidth), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.external != null && (IA.external = !!AA.external), AA.queryString != null && (IA.queryString = String(AA.queryString)), AA.iconPosition) {
      default:
        if (typeof AA.iconPosition == "number") {
          IA.iconPosition = AA.iconPosition;
          break;
        }
        break;
      case "LEFT":
      case 0:
        IA.iconPosition = 0;
        break;
      case "RIGHT":
      case 1:
        IA.iconPosition = 1;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.page = "", BA.label = "", BA.icon = "", BA.pageScriptHash = "", BA.help = "", BA.disabled = !1, BA.external = !1, BA.queryString = "", BA.iconPosition = IA.enums === String ? "LEFT" : 0), AA.page != null && AA.hasOwnProperty("page") && (BA.page = AA.page), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.useContainerWidth != null && AA.hasOwnProperty("useContainerWidth") && (BA.useContainerWidth = AA.useContainerWidth, IA.oneofs && (BA._useContainerWidth = "useContainerWidth")), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.external != null && AA.hasOwnProperty("external") && (BA.external = AA.external), AA.queryString != null && AA.hasOwnProperty("queryString") && (BA.queryString = AA.queryString), AA.iconPosition != null && AA.hasOwnProperty("iconPosition") && (BA.iconPosition = IA.enums === String ? $root.streamlit.ButtonLikeIconPosition[AA.iconPosition] === void 0 ? AA.iconPosition : $root.streamlit.ButtonLikeIconPosition[AA.iconPosition] : AA.iconPosition), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PageLink";
  }, CA;
})();
$root.PlotlyChart = (() => {
  function CA(gA) {
    if (this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.theme = "", CA.prototype.id = "", CA.prototype.selectionMode = $util.emptyArray, CA.prototype.formId = "", CA.prototype.spec = "", CA.prototype.config = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.theme != null && Object.hasOwnProperty.call(gA, "theme") && AA.uint32(50).string(gA.theme), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(58).string(gA.id), gA.selectionMode != null && gA.selectionMode.length) {
      AA.uint32(66).fork();
      for (let IA = 0; IA < gA.selectionMode.length; ++IA) AA.int32(gA.selectionMode[IA]);
      AA.ldelim();
    }
    return gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(74).string(gA.formId), gA.spec != null && Object.hasOwnProperty.call(gA, "spec") && AA.uint32(82).string(gA.spec), gA.config != null && Object.hasOwnProperty.call(gA, "config") && AA.uint32(90).string(gA.config), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.PlotlyChart();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 6:
          QA.theme = gA.string();
          break;
        case 7:
          QA.id = gA.string();
          break;
        case 8:
          if (QA.selectionMode && QA.selectionMode.length || (QA.selectionMode = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.selectionMode.push(gA.int32());
          } else QA.selectionMode.push(gA.int32());
          break;
        case 9:
          QA.formId = gA.string();
          break;
        case 10:
          QA.spec = gA.string();
          break;
        case 11:
          QA.config = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.PlotlyChart) return gA;
    let AA = new $root.PlotlyChart();
    if (gA.theme != null && (AA.theme = String(gA.theme)), gA.id != null && (AA.id = String(gA.id)), gA.selectionMode) {
      if (!Array.isArray(gA.selectionMode)) throw TypeError(".PlotlyChart.selectionMode: array expected");
      AA.selectionMode = [];
      for (let IA = 0; IA < gA.selectionMode.length; ++IA) switch (gA.selectionMode[IA]) {
        default:
          if (typeof gA.selectionMode[IA] == "number") {
            AA.selectionMode[IA] = gA.selectionMode[IA];
            break;
          }
        case "POINTS":
        case 0:
          AA.selectionMode[IA] = 0;
          break;
        case "BOX":
        case 1:
          AA.selectionMode[IA] = 1;
          break;
        case "LASSO":
        case 2:
          AA.selectionMode[IA] = 2;
          break;
      }
    }
    return gA.formId != null && (AA.formId = String(gA.formId)), gA.spec != null && (AA.spec = String(gA.spec)), gA.config != null && (AA.config = String(gA.config)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.selectionMode = []), AA.defaults && (IA.theme = "", IA.id = "", IA.formId = "", IA.spec = "", IA.config = ""), gA.theme != null && gA.hasOwnProperty("theme") && (IA.theme = gA.theme), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.selectionMode && gA.selectionMode.length) {
      IA.selectionMode = [];
      for (let BA = 0; BA < gA.selectionMode.length; ++BA) IA.selectionMode[BA] = AA.enums === String ? $root.PlotlyChart.SelectionMode[gA.selectionMode[BA]] === void 0 ? gA.selectionMode[BA] : $root.PlotlyChart.SelectionMode[gA.selectionMode[BA]] : gA.selectionMode[BA];
    }
    return gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), gA.spec != null && gA.hasOwnProperty("spec") && (IA.spec = gA.spec), gA.config != null && gA.hasOwnProperty("config") && (IA.config = gA.config), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/PlotlyChart";
  }, CA.SelectionMode = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "POINTS"] = 0, AA[gA[1] = "BOX"] = 1, AA[gA[2] = "LASSO"] = 2, AA;
  })(), CA;
})();
$root.Progress = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.value = 0, CA.prototype.text = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.value != null && Object.hasOwnProperty.call(gA, "value") && AA.uint32(8).uint32(gA.value), gA.text != null && Object.hasOwnProperty.call(gA, "text") && AA.uint32(18).string(gA.text), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Progress();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.value = gA.uint32();
          break;
        case 2:
          QA.text = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Progress) return gA;
    let AA = new $root.Progress();
    return gA.value != null && (AA.value = gA.value >>> 0), gA.text != null && (AA.text = String(gA.text)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.value = 0, IA.text = ""), gA.value != null && gA.hasOwnProperty("value") && (IA.value = gA.value), gA.text != null && gA.hasOwnProperty("text") && (IA.text = gA.text), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Progress";
  }, CA;
})();
$root.Radio = (() => {
  function CA(AA) {
    if (this.options = [], this.captions = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.options = $util.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValue = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.horizontal = !1, CA.prototype.labelVisibility = null, CA.prototype.captions = $util.emptyArray, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_rawValue", { get: $util.oneOfGetter(gA = ["rawValue"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(24).int32(AA.default), AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) IA.uint32(34).string(AA.options[BA]);
    if (AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(42).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(64).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(72).bool(AA.disabled), AA.horizontal != null && Object.hasOwnProperty.call(AA, "horizontal") && IA.uint32(80).bool(AA.horizontal), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(90).fork()).ldelim(), AA.captions != null && AA.captions.length) for (let BA = 0; BA < AA.captions.length; ++BA) IA.uint32(98).string(AA.captions[BA]);
    return AA.rawValue != null && Object.hasOwnProperty.call(AA, "rawValue") && IA.uint32(106).string(AA.rawValue), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(114).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Radio();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.int32();
          break;
        case 4:
          EA.options && EA.options.length || (EA.options = []), EA.options.push(AA.string());
          break;
        case 5:
          EA.help = AA.string();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 13:
          EA.rawValue = AA.string();
          break;
        case 8:
          EA.setValue = AA.bool();
          break;
        case 9:
          EA.disabled = AA.bool();
          break;
        case 10:
          EA.horizontal = AA.bool();
          break;
        case 11:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 12:
          EA.captions && EA.captions.length || (EA.captions = []), EA.captions.push(AA.string());
          break;
        case 14:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Radio) return AA;
    let IA = new $root.Radio();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = AA.default | 0), AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".Radio.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) IA.options[BA] = String(AA.options[BA]);
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.rawValue != null && (IA.rawValue = String(AA.rawValue)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.horizontal != null && (IA.horizontal = !!AA.horizontal), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".Radio.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    if (AA.captions) {
      if (!Array.isArray(AA.captions)) throw TypeError(".Radio.captions: array expected");
      IA.captions = [];
      for (let BA = 0; BA < AA.captions.length; ++BA) IA.captions[BA] = String(AA.captions[BA]);
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.options = [], BA.captions = []), IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.horizontal = !1, BA.labelVisibility = null), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = AA.options[QA];
    }
    if (AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.horizontal != null && AA.hasOwnProperty("horizontal") && (BA.horizontal = AA.horizontal), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.captions && AA.captions.length) {
      BA.captions = [];
      for (let QA = 0; QA < AA.captions.length; ++QA) BA.captions[QA] = AA.captions[QA];
    }
    return AA.rawValue != null && AA.hasOwnProperty("rawValue") && (BA.rawValue = AA.rawValue, IA.oneofs && (BA._rawValue = "rawValue")), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Radio";
  }, CA;
})();
$root.Selectbox = (() => {
  function CA(AA) {
    if (this.options = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.options = $util.emptyArray, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.rawValue = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.placeholder = "", CA.prototype.acceptNewOptions = null, CA.prototype.queryParamKey = null, CA.prototype.filterMode = 0;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_rawValue", { get: $util.oneOfGetter(gA = ["rawValue"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_acceptNewOptions", { get: $util.oneOfGetter(gA = ["acceptNewOptions"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(24).int32(AA.default), AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) IA.uint32(34).string(AA.options[BA]);
    return AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(42).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(50).string(AA.formId), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(64).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(72).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(82).fork()).ldelim(), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(90).string(AA.placeholder), AA.acceptNewOptions != null && Object.hasOwnProperty.call(AA, "acceptNewOptions") && IA.uint32(96).bool(AA.acceptNewOptions), AA.rawValue != null && Object.hasOwnProperty.call(AA, "rawValue") && IA.uint32(106).string(AA.rawValue), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(114).string(AA.queryParamKey), AA.filterMode != null && Object.hasOwnProperty.call(AA, "filterMode") && IA.uint32(120).int32(AA.filterMode), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Selectbox();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.int32();
          break;
        case 4:
          EA.options && EA.options.length || (EA.options = []), EA.options.push(AA.string());
          break;
        case 5:
          EA.help = AA.string();
          break;
        case 6:
          EA.formId = AA.string();
          break;
        case 13:
          EA.rawValue = AA.string();
          break;
        case 8:
          EA.setValue = AA.bool();
          break;
        case 9:
          EA.disabled = AA.bool();
          break;
        case 10:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 11:
          EA.placeholder = AA.string();
          break;
        case 12:
          EA.acceptNewOptions = AA.bool();
          break;
        case 14:
          EA.queryParamKey = AA.string();
          break;
        case 15:
          EA.filterMode = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Selectbox) return AA;
    let IA = new $root.Selectbox();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = AA.default | 0), AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".Selectbox.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) IA.options[BA] = String(AA.options[BA]);
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.rawValue != null && (IA.rawValue = String(AA.rawValue)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".Selectbox.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    switch (AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.acceptNewOptions != null && (IA.acceptNewOptions = !!AA.acceptNewOptions), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), AA.filterMode) {
      default:
        if (typeof AA.filterMode == "number") {
          IA.filterMode = AA.filterMode;
          break;
        }
        break;
      case "FILTER_MODE_FUZZY":
      case 0:
        IA.filterMode = 0;
        break;
      case "FILTER_MODE_CONTAINS":
      case 1:
        IA.filterMode = 1;
        break;
      case "FILTER_MODE_PREFIX":
      case 2:
        IA.filterMode = 2;
        break;
      case "FILTER_MODE_NONE":
      case 3:
        IA.filterMode = 3;
        break;
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.options = []), IA.defaults && (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, BA.placeholder = "", BA.filterMode = IA.enums === String ? "FILTER_MODE_FUZZY" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = AA.options[QA];
    }
    return AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.acceptNewOptions != null && AA.hasOwnProperty("acceptNewOptions") && (BA.acceptNewOptions = AA.acceptNewOptions, IA.oneofs && (BA._acceptNewOptions = "acceptNewOptions")), AA.rawValue != null && AA.hasOwnProperty("rawValue") && (BA.rawValue = AA.rawValue, IA.oneofs && (BA._rawValue = "rawValue")), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), AA.filterMode != null && AA.hasOwnProperty("filterMode") && (BA.filterMode = IA.enums === String ? $root.streamlit.SelectWidgetFilterMode[AA.filterMode] === void 0 ? AA.filterMode : $root.streamlit.SelectWidgetFilterMode[AA.filterMode] : AA.filterMode), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Selectbox";
  }, CA;
})();
$root.Skeleton = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.style = 0, CA.prototype.height = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_height", { get: $util.oneOfGetter(gA = ["height"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.style != null && Object.hasOwnProperty.call(AA, "style") && IA.uint32(8).int32(AA.style), AA.height != null && Object.hasOwnProperty.call(AA, "height") && IA.uint32(16).int32(AA.height), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Skeleton();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.style = AA.int32();
          break;
        case 2:
          EA.height = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Skeleton) return AA;
    let IA = new $root.Skeleton();
    switch (AA.style) {
      default:
        if (typeof AA.style == "number") {
          IA.style = AA.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        IA.style = 0;
        break;
      case "APP":
      case 1:
        IA.style = 1;
        break;
    }
    return AA.height != null && (IA.height = AA.height | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.style = IA.enums === String ? "ELEMENT" : 0), AA.style != null && AA.hasOwnProperty("style") && (BA.style = IA.enums === String ? $root.Skeleton.SkeletonStyle[AA.style] === void 0 ? AA.style : $root.Skeleton.SkeletonStyle[AA.style] : AA.style), AA.height != null && AA.hasOwnProperty("height") && (BA.height = AA.height, IA.oneofs && (BA._height = "height")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Skeleton";
  }, CA.SkeletonStyle = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "ELEMENT"] = 0, IA[AA[1] = "APP"] = 1, IA;
  })(), CA;
})();
$root.Slider = (() => {
  function CA(AA) {
    if (this.default = [], this.value = [], this.options = [], this.rawValue = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.formId = "", CA.prototype.label = "", CA.prototype.format = "", CA.prototype.dataType = 0, CA.prototype.default = $util.emptyArray, CA.prototype.min = 0, CA.prototype.max = 0, CA.prototype.step = 0, CA.prototype.value = $util.emptyArray, CA.prototype.setValue = !1, CA.prototype.options = $util.emptyArray, CA.prototype.help = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.type = 0, CA.prototype.rawValue = $util.emptyArray, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(18).string(AA.formId), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(26).string(AA.label), AA.format != null && Object.hasOwnProperty.call(AA, "format") && IA.uint32(34).string(AA.format), AA.dataType != null && Object.hasOwnProperty.call(AA, "dataType") && IA.uint32(40).int32(AA.dataType), AA.default != null && AA.default.length) {
      IA.uint32(50).fork();
      for (let BA = 0; BA < AA.default.length; ++BA) IA.double(AA.default[BA]);
      IA.ldelim();
    }
    if (AA.min != null && Object.hasOwnProperty.call(AA, "min") && IA.uint32(57).double(AA.min), AA.max != null && Object.hasOwnProperty.call(AA, "max") && IA.uint32(65).double(AA.max), AA.step != null && Object.hasOwnProperty.call(AA, "step") && IA.uint32(73).double(AA.step), AA.value != null && AA.value.length) {
      IA.uint32(82).fork();
      for (let BA = 0; BA < AA.value.length; ++BA) IA.double(AA.value[BA]);
      IA.ldelim();
    }
    if (AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(88).bool(AA.setValue), AA.options != null && AA.options.length) for (let BA = 0; BA < AA.options.length; ++BA) IA.uint32(106).string(AA.options[BA]);
    if (AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(114).string(AA.help), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(120).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(130).fork()).ldelim(), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(136).int32(AA.type), AA.rawValue != null && AA.rawValue.length) for (let BA = 0; BA < AA.rawValue.length; ++BA) IA.uint32(146).string(AA.rawValue[BA]);
    return AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(154).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Slider();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.formId = AA.string();
          break;
        case 3:
          EA.label = AA.string();
          break;
        case 4:
          EA.format = AA.string();
          break;
        case 5:
          EA.dataType = AA.int32();
          break;
        case 6:
          if (EA.default && EA.default.length || (EA.default = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.default.push(AA.double());
          } else EA.default.push(AA.double());
          break;
        case 7:
          EA.min = AA.double();
          break;
        case 8:
          EA.max = AA.double();
          break;
        case 9:
          EA.step = AA.double();
          break;
        case 10:
          if (EA.value && EA.value.length || (EA.value = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.value.push(AA.double());
          } else EA.value.push(AA.double());
          break;
        case 11:
          EA.setValue = AA.bool();
          break;
        case 13:
          EA.options && EA.options.length || (EA.options = []), EA.options.push(AA.string());
          break;
        case 14:
          EA.help = AA.string();
          break;
        case 15:
          EA.disabled = AA.bool();
          break;
        case 16:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 17:
          EA.type = AA.int32();
          break;
        case 18:
          EA.rawValue && EA.rawValue.length || (EA.rawValue = []), EA.rawValue.push(AA.string());
          break;
        case 19:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Slider) return AA;
    let IA = new $root.Slider();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.formId != null && (IA.formId = String(AA.formId)), AA.label != null && (IA.label = String(AA.label)), AA.format != null && (IA.format = String(AA.format)), AA.dataType) {
      default:
        if (typeof AA.dataType == "number") {
          IA.dataType = AA.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        IA.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        IA.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        IA.dataType = 2;
        break;
      case "DATE":
      case 3:
        IA.dataType = 3;
        break;
      case "TIME":
      case 4:
        IA.dataType = 4;
        break;
    }
    if (AA.default) {
      if (!Array.isArray(AA.default)) throw TypeError(".Slider.default: array expected");
      IA.default = [];
      for (let BA = 0; BA < AA.default.length; ++BA) IA.default[BA] = Number(AA.default[BA]);
    }
    if (AA.min != null && (IA.min = Number(AA.min)), AA.max != null && (IA.max = Number(AA.max)), AA.step != null && (IA.step = Number(AA.step)), AA.value) {
      if (!Array.isArray(AA.value)) throw TypeError(".Slider.value: array expected");
      IA.value = [];
      for (let BA = 0; BA < AA.value.length; ++BA) IA.value[BA] = Number(AA.value[BA]);
    }
    if (AA.setValue != null && (IA.setValue = !!AA.setValue), AA.options) {
      if (!Array.isArray(AA.options)) throw TypeError(".Slider.options: array expected");
      IA.options = [];
      for (let BA = 0; BA < AA.options.length; ++BA) IA.options[BA] = String(AA.options[BA]);
    }
    if (AA.help != null && (IA.help = String(AA.help)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".Slider.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    switch (AA.type) {
      default:
        if (typeof AA.type == "number") {
          IA.type = AA.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        IA.type = 0;
        break;
      case "SLIDER":
      case 1:
        IA.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        IA.type = 2;
        break;
    }
    if (AA.rawValue) {
      if (!Array.isArray(AA.rawValue)) throw TypeError(".Slider.rawValue: array expected");
      IA.rawValue = [];
      for (let BA = 0; BA < AA.rawValue.length; ++BA) IA.rawValue[BA] = String(AA.rawValue[BA]);
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.default = [], BA.value = [], BA.options = [], BA.rawValue = []), IA.defaults && (BA.id = "", BA.formId = "", BA.label = "", BA.format = "", BA.dataType = IA.enums === String ? "INT" : 0, BA.min = 0, BA.max = 0, BA.step = 0, BA.setValue = !1, BA.help = "", BA.disabled = !1, BA.labelVisibility = null, BA.type = IA.enums === String ? "UNSPECIFIED" : 0), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.format != null && AA.hasOwnProperty("format") && (BA.format = AA.format), AA.dataType != null && AA.hasOwnProperty("dataType") && (BA.dataType = IA.enums === String ? $root.Slider.DataType[AA.dataType] === void 0 ? AA.dataType : $root.Slider.DataType[AA.dataType] : AA.dataType), AA.default && AA.default.length) {
      BA.default = [];
      for (let QA = 0; QA < AA.default.length; ++QA) BA.default[QA] = IA.json && !isFinite(AA.default[QA]) ? String(AA.default[QA]) : AA.default[QA];
    }
    if (AA.min != null && AA.hasOwnProperty("min") && (BA.min = IA.json && !isFinite(AA.min) ? String(AA.min) : AA.min), AA.max != null && AA.hasOwnProperty("max") && (BA.max = IA.json && !isFinite(AA.max) ? String(AA.max) : AA.max), AA.step != null && AA.hasOwnProperty("step") && (BA.step = IA.json && !isFinite(AA.step) ? String(AA.step) : AA.step), AA.value && AA.value.length) {
      BA.value = [];
      for (let QA = 0; QA < AA.value.length; ++QA) BA.value[QA] = IA.json && !isFinite(AA.value[QA]) ? String(AA.value[QA]) : AA.value[QA];
    }
    if (AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.options && AA.options.length) {
      BA.options = [];
      for (let QA = 0; QA < AA.options.length; ++QA) BA.options[QA] = AA.options[QA];
    }
    if (AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.Slider.Type[AA.type] === void 0 ? AA.type : $root.Slider.Type[AA.type] : AA.type), AA.rawValue && AA.rawValue.length) {
      BA.rawValue = [];
      for (let QA = 0; QA < AA.rawValue.length; ++QA) BA.rawValue[QA] = AA.rawValue[QA];
    }
    return AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Slider";
  }, CA.DataType = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "INT"] = 0, IA[AA[1] = "FLOAT"] = 1, IA[AA[2] = "DATETIME"] = 2, IA[AA[3] = "DATE"] = 3, IA[AA[4] = "TIME"] = 4, IA;
  })(), CA.Type = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "UNSPECIFIED"] = 0, IA[AA[1] = "SLIDER"] = 1, IA[AA[2] = "SELECT_SLIDER"] = 2, IA;
  })(), CA;
})();
$root.Snow = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.show = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.show != null && Object.hasOwnProperty.call(gA, "show") && AA.uint32(8).bool(gA.show), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Snow();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.show = gA.bool() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Snow) return gA;
    let AA = new $root.Snow();
    return gA.show != null && (AA.show = !!gA.show), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.show = !1), gA.show != null && gA.hasOwnProperty("show") && (IA.show = gA.show), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Snow";
  }, CA;
})();
$root.Space = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Space();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    return gA instanceof $root.Space ? gA : new $root.Space();
  }, CA.toObject = function() {
    return {};
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Space";
  }, CA;
})();
$root.Spinner = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.text = "", CA.prototype.cache = !1, CA.prototype.showTime = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.text != null && Object.hasOwnProperty.call(gA, "text") && AA.uint32(10).string(gA.text), gA.cache != null && Object.hasOwnProperty.call(gA, "cache") && AA.uint32(16).bool(gA.cache), gA.showTime != null && Object.hasOwnProperty.call(gA, "showTime") && AA.uint32(24).bool(gA.showTime), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Spinner();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.text = gA.string();
          break;
        case 2:
          QA.cache = gA.bool();
          break;
        case 3:
          QA.showTime = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Spinner) return gA;
    let AA = new $root.Spinner();
    return gA.text != null && (AA.text = String(gA.text)), gA.cache != null && (AA.cache = !!gA.cache), gA.showTime != null && (AA.showTime = !!gA.showTime), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.text = "", IA.cache = !1, IA.showTime = !1), gA.text != null && gA.hasOwnProperty("text") && (IA.text = gA.text), gA.cache != null && gA.hasOwnProperty("cache") && (IA.cache = gA.cache), gA.showTime != null && gA.hasOwnProperty("showTime") && (IA.showTime = gA.showTime), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Spinner";
  }, CA;
})();
$root.Table = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.arrowData = null, CA.prototype.borderMode = 0, CA.prototype.hideIndex = !1, CA.prototype.hideHeader = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.arrowData != null && Object.hasOwnProperty.call(gA, "arrowData") && $root.ArrowData.encode(gA.arrowData, AA.uint32(10).fork()).ldelim(), gA.borderMode != null && Object.hasOwnProperty.call(gA, "borderMode") && AA.uint32(16).int32(gA.borderMode), gA.hideIndex != null && Object.hasOwnProperty.call(gA, "hideIndex") && AA.uint32(24).bool(gA.hideIndex), gA.hideHeader != null && Object.hasOwnProperty.call(gA, "hideHeader") && AA.uint32(32).bool(gA.hideHeader), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Table();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.arrowData = $root.ArrowData.decode(gA, gA.uint32());
          break;
        case 2:
          QA.borderMode = gA.int32();
          break;
        case 3:
          QA.hideIndex = gA.bool();
          break;
        case 4:
          QA.hideHeader = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Table) return gA;
    let AA = new $root.Table();
    if (gA.arrowData != null) {
      if (typeof gA.arrowData != "object") throw TypeError(".Table.arrowData: object expected");
      AA.arrowData = $root.ArrowData.fromObject(gA.arrowData);
    }
    switch (gA.borderMode) {
      default:
        if (typeof gA.borderMode == "number") {
          AA.borderMode = gA.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        AA.borderMode = 0;
        break;
      case "NONE":
      case 1:
        AA.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        AA.borderMode = 2;
        break;
    }
    return gA.hideIndex != null && (AA.hideIndex = !!gA.hideIndex), gA.hideHeader != null && (AA.hideHeader = !!gA.hideHeader), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.arrowData = null, IA.borderMode = AA.enums === String ? "ALL" : 0, IA.hideIndex = !1, IA.hideHeader = !1), gA.arrowData != null && gA.hasOwnProperty("arrowData") && (IA.arrowData = $root.ArrowData.toObject(gA.arrowData, AA)), gA.borderMode != null && gA.hasOwnProperty("borderMode") && (IA.borderMode = AA.enums === String ? $root.Table.BorderMode[gA.borderMode] === void 0 ? gA.borderMode : $root.Table.BorderMode[gA.borderMode] : gA.borderMode), gA.hideIndex != null && gA.hasOwnProperty("hideIndex") && (IA.hideIndex = gA.hideIndex), gA.hideHeader != null && gA.hasOwnProperty("hideHeader") && (IA.hideHeader = gA.hideHeader), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Table";
  }, CA.BorderMode = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "ALL"] = 0, AA[gA[1] = "NONE"] = 1, AA[gA[2] = "HORIZONTAL"] = 2, AA;
  })(), CA;
})();
$root.Text = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.body = "", CA.prototype.help = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.body != null && Object.hasOwnProperty.call(gA, "body") && AA.uint32(10).string(gA.body), gA.help != null && Object.hasOwnProperty.call(gA, "help") && AA.uint32(18).string(gA.help), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Text();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.body = gA.string();
          break;
        case 2:
          QA.help = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Text) return gA;
    let AA = new $root.Text();
    return gA.body != null && (AA.body = String(gA.body)), gA.help != null && (AA.help = String(gA.help)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.body = "", IA.help = ""), gA.body != null && gA.hasOwnProperty("body") && (IA.body = gA.body), gA.help != null && gA.hasOwnProperty("help") && (IA.help = gA.help), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Text";
  }, CA;
})();
$root.TextArea = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.maxChars = 0, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.placeholder = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util.oneOfGetter(gA = ["value"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(26).string(AA.default), AA.maxChars != null && Object.hasOwnProperty.call(AA, "maxChars") && IA.uint32(40).uint32(AA.maxChars), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(50).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(58).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(66).string(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(72).bool(AA.setValue), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(82).string(AA.placeholder), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(88).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(98).fork()).ldelim(), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(106).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.TextArea();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.string();
          break;
        case 5:
          EA.maxChars = AA.uint32();
          break;
        case 6:
          EA.help = AA.string();
          break;
        case 7:
          EA.formId = AA.string();
          break;
        case 8:
          EA.value = AA.string();
          break;
        case 9:
          EA.setValue = AA.bool();
          break;
        case 10:
          EA.placeholder = AA.string();
          break;
        case 11:
          EA.disabled = AA.bool();
          break;
        case 12:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 13:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.TextArea) return AA;
    let IA = new $root.TextArea();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = String(AA.default)), AA.maxChars != null && (IA.maxChars = AA.maxChars >>> 0), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = String(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".TextArea.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.maxChars = 0, BA.help = "", BA.formId = "", BA.setValue = !1, BA.placeholder = "", BA.disabled = !1, BA.labelVisibility = null), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.maxChars != null && AA.hasOwnProperty("maxChars") && (BA.maxChars = AA.maxChars), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value, IA.oneofs && (BA._value = "value")), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/TextArea";
  }, CA;
})();
$root.TextInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.type = 0, CA.prototype.maxChars = 0, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.autocomplete = "", CA.prototype.placeholder = "", CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.icon = "", CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util.oneOfGetter(gA = ["value"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(26).string(AA.default), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(32).int32(AA.type), AA.maxChars != null && Object.hasOwnProperty.call(AA, "maxChars") && IA.uint32(40).uint32(AA.maxChars), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(50).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(58).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(66).string(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(72).bool(AA.setValue), AA.autocomplete != null && Object.hasOwnProperty.call(AA, "autocomplete") && IA.uint32(82).string(AA.autocomplete), AA.placeholder != null && Object.hasOwnProperty.call(AA, "placeholder") && IA.uint32(90).string(AA.placeholder), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(96).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(106).fork()).ldelim(), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(114).string(AA.icon), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(122).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.TextInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.string();
          break;
        case 4:
          EA.type = AA.int32();
          break;
        case 5:
          EA.maxChars = AA.uint32();
          break;
        case 6:
          EA.help = AA.string();
          break;
        case 7:
          EA.formId = AA.string();
          break;
        case 8:
          EA.value = AA.string();
          break;
        case 9:
          EA.setValue = AA.bool();
          break;
        case 10:
          EA.autocomplete = AA.string();
          break;
        case 11:
          EA.placeholder = AA.string();
          break;
        case 12:
          EA.disabled = AA.bool();
          break;
        case 13:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 14:
          EA.icon = AA.string();
          break;
        case 15:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.TextInput) return AA;
    let IA = new $root.TextInput();
    switch (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = String(AA.default)), AA.type) {
      default:
        if (typeof AA.type == "number") {
          IA.type = AA.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        IA.type = 0;
        break;
      case "PASSWORD":
      case 1:
        IA.type = 1;
        break;
    }
    if (AA.maxChars != null && (IA.maxChars = AA.maxChars >>> 0), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = String(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.autocomplete != null && (IA.autocomplete = String(AA.autocomplete)), AA.placeholder != null && (IA.placeholder = String(AA.placeholder)), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".TextInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.icon != null && (IA.icon = String(AA.icon)), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.id = "", BA.label = "", BA.type = IA.enums === String ? "DEFAULT" : 0, BA.maxChars = 0, BA.help = "", BA.formId = "", BA.setValue = !1, BA.autocomplete = "", BA.placeholder = "", BA.disabled = !1, BA.labelVisibility = null, BA.icon = ""), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.TextInput.Type[AA.type] === void 0 ? AA.type : $root.TextInput.Type[AA.type] : AA.type), AA.maxChars != null && AA.hasOwnProperty("maxChars") && (BA.maxChars = AA.maxChars), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value, IA.oneofs && (BA._value = "value")), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.autocomplete != null && AA.hasOwnProperty("autocomplete") && (BA.autocomplete = AA.autocomplete), AA.placeholder != null && AA.hasOwnProperty("placeholder") && (BA.placeholder = AA.placeholder), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/TextInput";
  }, CA.Type = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "DEFAULT"] = 0, IA[AA[1] = "PASSWORD"] = 1, IA;
  })(), CA;
})();
$root.TimeInput = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.id = "", CA.prototype.label = "", CA.prototype.default = null, CA.prototype.help = "", CA.prototype.formId = "", CA.prototype.value = null, CA.prototype.setValue = !1, CA.prototype.disabled = !1, CA.prototype.labelVisibility = null, CA.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.queryParamKey = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_default", { get: $util.oneOfGetter(gA = ["default"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_value", { get: $util.oneOfGetter(gA = ["value"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_queryParamKey", { get: $util.oneOfGetter(gA = ["queryParamKey"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(10).string(AA.id), AA.label != null && Object.hasOwnProperty.call(AA, "label") && IA.uint32(18).string(AA.label), AA.default != null && Object.hasOwnProperty.call(AA, "default") && IA.uint32(26).string(AA.default), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(34).string(AA.help), AA.formId != null && Object.hasOwnProperty.call(AA, "formId") && IA.uint32(42).string(AA.formId), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(50).string(AA.value), AA.setValue != null && Object.hasOwnProperty.call(AA, "setValue") && IA.uint32(56).bool(AA.setValue), AA.disabled != null && Object.hasOwnProperty.call(AA, "disabled") && IA.uint32(64).bool(AA.disabled), AA.labelVisibility != null && Object.hasOwnProperty.call(AA, "labelVisibility") && $root.LabelVisibility.encode(AA.labelVisibility, IA.uint32(74).fork()).ldelim(), AA.step != null && Object.hasOwnProperty.call(AA, "step") && IA.uint32(80).int64(AA.step), AA.queryParamKey != null && Object.hasOwnProperty.call(AA, "queryParamKey") && IA.uint32(90).string(AA.queryParamKey), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.TimeInput();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.id = AA.string();
          break;
        case 2:
          EA.label = AA.string();
          break;
        case 3:
          EA.default = AA.string();
          break;
        case 4:
          EA.help = AA.string();
          break;
        case 5:
          EA.formId = AA.string();
          break;
        case 6:
          EA.value = AA.string();
          break;
        case 7:
          EA.setValue = AA.bool();
          break;
        case 8:
          EA.disabled = AA.bool();
          break;
        case 9:
          EA.labelVisibility = $root.LabelVisibility.decode(AA, AA.uint32());
          break;
        case 10:
          EA.step = AA.int64();
          break;
        case 11:
          EA.queryParamKey = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.TimeInput) return AA;
    let IA = new $root.TimeInput();
    if (AA.id != null && (IA.id = String(AA.id)), AA.label != null && (IA.label = String(AA.label)), AA.default != null && (IA.default = String(AA.default)), AA.help != null && (IA.help = String(AA.help)), AA.formId != null && (IA.formId = String(AA.formId)), AA.value != null && (IA.value = String(AA.value)), AA.setValue != null && (IA.setValue = !!AA.setValue), AA.disabled != null && (IA.disabled = !!AA.disabled), AA.labelVisibility != null) {
      if (typeof AA.labelVisibility != "object") throw TypeError(".TimeInput.labelVisibility: object expected");
      IA.labelVisibility = $root.LabelVisibility.fromObject(AA.labelVisibility);
    }
    return AA.step != null && ($util.Long ? (IA.step = $util.Long.fromValue(AA.step)).unsigned = !1 : typeof AA.step == "string" ? IA.step = parseInt(AA.step, 10) : typeof AA.step == "number" ? IA.step = AA.step : typeof AA.step == "object" && (IA.step = new $util.LongBits(AA.step.low >>> 0, AA.step.high >>> 0).toNumber())), AA.queryParamKey != null && (IA.queryParamKey = String(AA.queryParamKey)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if (IA.defaults) if (BA.id = "", BA.label = "", BA.help = "", BA.formId = "", BA.setValue = !1, BA.disabled = !1, BA.labelVisibility = null, $util.Long) {
      let QA = new $util.Long(0, 0, !1);
      BA.step = IA.longs === String ? QA.toString() : IA.longs === Number ? QA.toNumber() : QA;
    } else BA.step = IA.longs === String ? "0" : 0;
    return AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.label != null && AA.hasOwnProperty("label") && (BA.label = AA.label), AA.default != null && AA.hasOwnProperty("default") && (BA.default = AA.default, IA.oneofs && (BA._default = "default")), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.formId != null && AA.hasOwnProperty("formId") && (BA.formId = AA.formId), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value, IA.oneofs && (BA._value = "value")), AA.setValue != null && AA.hasOwnProperty("setValue") && (BA.setValue = AA.setValue), AA.disabled != null && AA.hasOwnProperty("disabled") && (BA.disabled = AA.disabled), AA.labelVisibility != null && AA.hasOwnProperty("labelVisibility") && (BA.labelVisibility = $root.LabelVisibility.toObject(AA.labelVisibility, IA)), AA.step != null && AA.hasOwnProperty("step") && (typeof AA.step == "number" ? BA.step = IA.longs === String ? String(AA.step) : AA.step : BA.step = IA.longs === String ? $util.Long.prototype.toString.call(AA.step) : IA.longs === Number ? new $util.LongBits(AA.step.low >>> 0, AA.step.high >>> 0).toNumber() : AA.step), AA.queryParamKey != null && AA.hasOwnProperty("queryParamKey") && (BA.queryParamKey = AA.queryParamKey, IA.oneofs && (BA._queryParamKey = "queryParamKey")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/TimeInput";
  }, CA;
})();
$root.Toast = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.body = "", CA.prototype.icon = "", CA.prototype.duration = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_duration", { get: $util.oneOfGetter(gA = ["duration"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.body != null && Object.hasOwnProperty.call(AA, "body") && IA.uint32(10).string(AA.body), AA.icon != null && Object.hasOwnProperty.call(AA, "icon") && IA.uint32(18).string(AA.icon), AA.duration != null && Object.hasOwnProperty.call(AA, "duration") && IA.uint32(24).int32(AA.duration), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Toast();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.body = AA.string();
          break;
        case 2:
          EA.icon = AA.string();
          break;
        case 3:
          EA.duration = AA.int32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Toast) return AA;
    let IA = new $root.Toast();
    return AA.body != null && (IA.body = String(AA.body)), AA.icon != null && (IA.icon = String(AA.icon)), AA.duration != null && (IA.duration = AA.duration | 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.body = "", BA.icon = ""), AA.body != null && AA.hasOwnProperty("body") && (BA.body = AA.body), AA.icon != null && AA.hasOwnProperty("icon") && (BA.icon = AA.icon), AA.duration != null && AA.hasOwnProperty("duration") && (BA.duration = AA.duration, IA.oneofs && (BA._duration = "duration")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Toast";
  }, CA;
})();
$root.VegaLiteChart = (() => {
  function CA(gA) {
    if (this.datasets = [], this.selectionMode = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.spec = "", CA.prototype.data = null, CA.prototype.datasets = $util.emptyArray, CA.prototype.useContainerWidth = !1, CA.prototype.theme = "", CA.prototype.id = "", CA.prototype.selectionMode = $util.emptyArray, CA.prototype.formId = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.spec != null && Object.hasOwnProperty.call(gA, "spec") && AA.uint32(10).string(gA.spec), gA.data != null && Object.hasOwnProperty.call(gA, "data") && $root.ArrowData.encode(gA.data, AA.uint32(18).fork()).ldelim(), gA.datasets != null && gA.datasets.length) for (let IA = 0; IA < gA.datasets.length; ++IA) $root.ArrowNamedDataSet.encode(gA.datasets[IA], AA.uint32(34).fork()).ldelim();
    if (gA.useContainerWidth != null && Object.hasOwnProperty.call(gA, "useContainerWidth") && AA.uint32(40).bool(gA.useContainerWidth), gA.theme != null && Object.hasOwnProperty.call(gA, "theme") && AA.uint32(50).string(gA.theme), gA.id != null && Object.hasOwnProperty.call(gA, "id") && AA.uint32(58).string(gA.id), gA.selectionMode != null && gA.selectionMode.length) for (let IA = 0; IA < gA.selectionMode.length; ++IA) AA.uint32(66).string(gA.selectionMode[IA]);
    return gA.formId != null && Object.hasOwnProperty.call(gA, "formId") && AA.uint32(74).string(gA.formId), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.VegaLiteChart();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.spec = gA.string();
          break;
        case 2:
          QA.data = $root.ArrowData.decode(gA, gA.uint32());
          break;
        case 4:
          QA.datasets && QA.datasets.length || (QA.datasets = []), QA.datasets.push($root.ArrowNamedDataSet.decode(gA, gA.uint32()));
          break;
        case 5:
          QA.useContainerWidth = gA.bool();
          break;
        case 6:
          QA.theme = gA.string();
          break;
        case 7:
          QA.id = gA.string();
          break;
        case 8:
          QA.selectionMode && QA.selectionMode.length || (QA.selectionMode = []), QA.selectionMode.push(gA.string());
          break;
        case 9:
          QA.formId = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.VegaLiteChart) return gA;
    let AA = new $root.VegaLiteChart();
    if (gA.spec != null && (AA.spec = String(gA.spec)), gA.data != null) {
      if (typeof gA.data != "object") throw TypeError(".VegaLiteChart.data: object expected");
      AA.data = $root.ArrowData.fromObject(gA.data);
    }
    if (gA.datasets) {
      if (!Array.isArray(gA.datasets)) throw TypeError(".VegaLiteChart.datasets: array expected");
      AA.datasets = [];
      for (let IA = 0; IA < gA.datasets.length; ++IA) {
        if (typeof gA.datasets[IA] != "object") throw TypeError(".VegaLiteChart.datasets: object expected");
        AA.datasets[IA] = $root.ArrowNamedDataSet.fromObject(gA.datasets[IA]);
      }
    }
    if (gA.useContainerWidth != null && (AA.useContainerWidth = !!gA.useContainerWidth), gA.theme != null && (AA.theme = String(gA.theme)), gA.id != null && (AA.id = String(gA.id)), gA.selectionMode) {
      if (!Array.isArray(gA.selectionMode)) throw TypeError(".VegaLiteChart.selectionMode: array expected");
      AA.selectionMode = [];
      for (let IA = 0; IA < gA.selectionMode.length; ++IA) AA.selectionMode[IA] = String(gA.selectionMode[IA]);
    }
    return gA.formId != null && (AA.formId = String(gA.formId)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.datasets = [], IA.selectionMode = []), AA.defaults && (IA.spec = "", IA.data = null, IA.useContainerWidth = !1, IA.theme = "", IA.id = "", IA.formId = ""), gA.spec != null && gA.hasOwnProperty("spec") && (IA.spec = gA.spec), gA.data != null && gA.hasOwnProperty("data") && (IA.data = $root.ArrowData.toObject(gA.data, AA)), gA.datasets && gA.datasets.length) {
      IA.datasets = [];
      for (let BA = 0; BA < gA.datasets.length; ++BA) IA.datasets[BA] = $root.ArrowNamedDataSet.toObject(gA.datasets[BA], AA);
    }
    if (gA.useContainerWidth != null && gA.hasOwnProperty("useContainerWidth") && (IA.useContainerWidth = gA.useContainerWidth), gA.theme != null && gA.hasOwnProperty("theme") && (IA.theme = gA.theme), gA.id != null && gA.hasOwnProperty("id") && (IA.id = gA.id), gA.selectionMode && gA.selectionMode.length) {
      IA.selectionMode = [];
      for (let BA = 0; BA < gA.selectionMode.length; ++BA) IA.selectionMode[BA] = gA.selectionMode[BA];
    }
    return gA.formId != null && gA.hasOwnProperty("formId") && (IA.formId = gA.formId), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/VegaLiteChart";
  }, CA;
})();
$root.SubtitleTrack = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.label = "", CA.prototype.url = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(10).string(gA.label), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(18).string(gA.url), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.SubtitleTrack();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.label = gA.string();
          break;
        case 2:
          QA.url = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.SubtitleTrack) return gA;
    let AA = new $root.SubtitleTrack();
    return gA.label != null && (AA.label = String(gA.label)), gA.url != null && (AA.url = String(gA.url)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.label = "", IA.url = ""), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/SubtitleTrack";
  }, CA;
})();
$root.Video = (() => {
  function CA(AA) {
    if (this.subtitles = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.url = "", CA.prototype.startTime = 0, CA.prototype.type = 0, CA.prototype.subtitles = $util.emptyArray, CA.prototype.endTime = 0, CA.prototype.loop = !1, CA.prototype.autoplay = !1, CA.prototype.muted = !1, CA.prototype.id = "", CA.prototype.widthConfig = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_widthConfig", { get: $util.oneOfGetter(gA = ["widthConfig"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.startTime != null && Object.hasOwnProperty.call(AA, "startTime") && IA.uint32(24).int32(AA.startTime), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(40).int32(AA.type), AA.url != null && Object.hasOwnProperty.call(AA, "url") && IA.uint32(50).string(AA.url), AA.subtitles != null && AA.subtitles.length) for (let BA = 0; BA < AA.subtitles.length; ++BA) $root.SubtitleTrack.encode(AA.subtitles[BA], IA.uint32(58).fork()).ldelim();
    return AA.endTime != null && Object.hasOwnProperty.call(AA, "endTime") && IA.uint32(64).int32(AA.endTime), AA.loop != null && Object.hasOwnProperty.call(AA, "loop") && IA.uint32(72).bool(AA.loop), AA.autoplay != null && Object.hasOwnProperty.call(AA, "autoplay") && IA.uint32(80).bool(AA.autoplay), AA.muted != null && Object.hasOwnProperty.call(AA, "muted") && IA.uint32(88).bool(AA.muted), AA.id != null && Object.hasOwnProperty.call(AA, "id") && IA.uint32(98).string(AA.id), AA.widthConfig != null && Object.hasOwnProperty.call(AA, "widthConfig") && $root.streamlit.WidthConfig.encode(AA.widthConfig, IA.uint32(106).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Video();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 6:
          EA.url = AA.string();
          break;
        case 3:
          EA.startTime = AA.int32();
          break;
        case 5:
          EA.type = AA.int32();
          break;
        case 7:
          EA.subtitles && EA.subtitles.length || (EA.subtitles = []), EA.subtitles.push($root.SubtitleTrack.decode(AA, AA.uint32()));
          break;
        case 8:
          EA.endTime = AA.int32();
          break;
        case 9:
          EA.loop = AA.bool();
          break;
        case 10:
          EA.autoplay = AA.bool();
          break;
        case 11:
          EA.muted = AA.bool();
          break;
        case 12:
          EA.id = AA.string();
          break;
        case 13:
          EA.widthConfig = $root.streamlit.WidthConfig.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Video) return AA;
    let IA = new $root.Video();
    switch (AA.url != null && (IA.url = String(AA.url)), AA.startTime != null && (IA.startTime = AA.startTime | 0), AA.type) {
      default:
        if (typeof AA.type == "number") {
          IA.type = AA.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        IA.type = 0;
        break;
      case "NATIVE":
      case 1:
        IA.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        IA.type = 2;
        break;
    }
    if (AA.subtitles) {
      if (!Array.isArray(AA.subtitles)) throw TypeError(".Video.subtitles: array expected");
      IA.subtitles = [];
      for (let BA = 0; BA < AA.subtitles.length; ++BA) {
        if (typeof AA.subtitles[BA] != "object") throw TypeError(".Video.subtitles: object expected");
        IA.subtitles[BA] = $root.SubtitleTrack.fromObject(AA.subtitles[BA]);
      }
    }
    if (AA.endTime != null && (IA.endTime = AA.endTime | 0), AA.loop != null && (IA.loop = !!AA.loop), AA.autoplay != null && (IA.autoplay = !!AA.autoplay), AA.muted != null && (IA.muted = !!AA.muted), AA.id != null && (IA.id = String(AA.id)), AA.widthConfig != null) {
      if (typeof AA.widthConfig != "object") throw TypeError(".Video.widthConfig: object expected");
      IA.widthConfig = $root.streamlit.WidthConfig.fromObject(AA.widthConfig);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.subtitles = []), IA.defaults && (BA.startTime = 0, BA.type = IA.enums === String ? "UNUSED" : 0, BA.url = "", BA.endTime = 0, BA.loop = !1, BA.autoplay = !1, BA.muted = !1, BA.id = ""), AA.startTime != null && AA.hasOwnProperty("startTime") && (BA.startTime = AA.startTime), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.Video.Type[AA.type] === void 0 ? AA.type : $root.Video.Type[AA.type] : AA.type), AA.url != null && AA.hasOwnProperty("url") && (BA.url = AA.url), AA.subtitles && AA.subtitles.length) {
      BA.subtitles = [];
      for (let QA = 0; QA < AA.subtitles.length; ++QA) BA.subtitles[QA] = $root.SubtitleTrack.toObject(AA.subtitles[QA], IA);
    }
    return AA.endTime != null && AA.hasOwnProperty("endTime") && (BA.endTime = AA.endTime), AA.loop != null && AA.hasOwnProperty("loop") && (BA.loop = AA.loop), AA.autoplay != null && AA.hasOwnProperty("autoplay") && (BA.autoplay = AA.autoplay), AA.muted != null && AA.hasOwnProperty("muted") && (BA.muted = AA.muted), AA.id != null && AA.hasOwnProperty("id") && (BA.id = AA.id), AA.widthConfig != null && AA.hasOwnProperty("widthConfig") && (BA.widthConfig = $root.streamlit.WidthConfig.toObject(AA.widthConfig, IA), IA.oneofs && (BA._widthConfig = "widthConfig")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Video";
  }, CA.Type = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "UNUSED"] = 0, IA[AA[1] = "NATIVE"] = 1, IA[AA[2] = "YOUTUBE_IFRAME"] = 2, IA;
  })(), CA;
})();
$root.Transient = (() => {
  function CA(gA) {
    if (this.elements = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.elements = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.elements != null && gA.elements.length) for (let IA = 0; IA < gA.elements.length; ++IA) $root.Element.encode(gA.elements[IA], AA.uint32(10).fork()).ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Transient();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? (QA.elements && QA.elements.length || (QA.elements = []), QA.elements.push($root.Element.decode(gA, gA.uint32()))) : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Transient) return gA;
    let AA = new $root.Transient();
    if (gA.elements) {
      if (!Array.isArray(gA.elements)) throw TypeError(".Transient.elements: array expected");
      AA.elements = [];
      for (let IA = 0; IA < gA.elements.length; ++IA) {
        if (typeof gA.elements[IA] != "object") throw TypeError(".Transient.elements: object expected");
        AA.elements[IA] = $root.Element.fromObject(gA.elements[IA]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.elements = []), gA.elements && gA.elements.length) {
      IA.elements = [];
      for (let BA = 0; BA < gA.elements.length; ++BA) IA.elements[BA] = $root.Element.toObject(gA.elements[BA], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Transient";
  }, CA;
})();
$root.ForwardMsg = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.hash = "", CA.prototype.metadata = null, CA.prototype.newSession = null, CA.prototype.delta = null, CA.prototype.pageInfoChanged = null, CA.prototype.pageConfigChanged = null, CA.prototype.scriptFinished = null, CA.prototype.gitInfoChanged = null, CA.prototype.pageProfile = null, CA.prototype.sessionStatusChanged = null, CA.prototype.sessionEvent = null, CA.prototype.navigation = null, CA.prototype.pageNotFound = null, CA.prototype.fileUrlsResponse = null, CA.prototype.autoRerun = null, CA.prototype.logo = null, CA.prototype.authRedirect = null, CA.prototype.parentMessage = null, CA.prototype.refHash = null, CA.prototype.deferredFileResponse = null, CA.prototype.heartbeatAck = null, CA.prototype.debugLastBackmsgId = "";
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash", "deferredFileResponse", "heartbeatAck"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.hash != null && Object.hasOwnProperty.call(AA, "hash") && IA.uint32(10).string(AA.hash), AA.metadata != null && Object.hasOwnProperty.call(AA, "metadata") && $root.ForwardMsgMetadata.encode(AA.metadata, IA.uint32(18).fork()).ldelim(), AA.newSession != null && Object.hasOwnProperty.call(AA, "newSession") && $root.NewSession.encode(AA.newSession, IA.uint32(34).fork()).ldelim(), AA.delta != null && Object.hasOwnProperty.call(AA, "delta") && $root.Delta.encode(AA.delta, IA.uint32(42).fork()).ldelim(), AA.scriptFinished != null && Object.hasOwnProperty.call(AA, "scriptFinished") && IA.uint32(48).int32(AA.scriptFinished), AA.sessionStatusChanged != null && Object.hasOwnProperty.call(AA, "sessionStatusChanged") && $root.SessionStatus.encode(AA.sessionStatusChanged, IA.uint32(74).fork()).ldelim(), AA.sessionEvent != null && Object.hasOwnProperty.call(AA, "sessionEvent") && $root.SessionEvent.encode(AA.sessionEvent, IA.uint32(82).fork()).ldelim(), AA.refHash != null && Object.hasOwnProperty.call(AA, "refHash") && IA.uint32(90).string(AA.refHash), AA.pageInfoChanged != null && Object.hasOwnProperty.call(AA, "pageInfoChanged") && $root.PageInfo.encode(AA.pageInfoChanged, IA.uint32(98).fork()).ldelim(), AA.pageConfigChanged != null && Object.hasOwnProperty.call(AA, "pageConfigChanged") && $root.PageConfig.encode(AA.pageConfigChanged, IA.uint32(106).fork()).ldelim(), AA.gitInfoChanged != null && Object.hasOwnProperty.call(AA, "gitInfoChanged") && $root.GitInfo.encode(AA.gitInfoChanged, IA.uint32(114).fork()).ldelim(), AA.pageNotFound != null && Object.hasOwnProperty.call(AA, "pageNotFound") && $root.PageNotFound.encode(AA.pageNotFound, IA.uint32(122).fork()).ldelim(), AA.debugLastBackmsgId != null && Object.hasOwnProperty.call(AA, "debugLastBackmsgId") && IA.uint32(138).string(AA.debugLastBackmsgId), AA.pageProfile != null && Object.hasOwnProperty.call(AA, "pageProfile") && $root.PageProfile.encode(AA.pageProfile, IA.uint32(146).fork()).ldelim(), AA.fileUrlsResponse != null && Object.hasOwnProperty.call(AA, "fileUrlsResponse") && $root.FileURLsResponse.encode(AA.fileUrlsResponse, IA.uint32(154).fork()).ldelim(), AA.parentMessage != null && Object.hasOwnProperty.call(AA, "parentMessage") && $root.ParentMessage.encode(AA.parentMessage, IA.uint32(162).fork()).ldelim(), AA.autoRerun != null && Object.hasOwnProperty.call(AA, "autoRerun") && $root.AutoRerun.encode(AA.autoRerun, IA.uint32(170).fork()).ldelim(), AA.logo != null && Object.hasOwnProperty.call(AA, "logo") && $root.Logo.encode(AA.logo, IA.uint32(178).fork()).ldelim(), AA.navigation != null && Object.hasOwnProperty.call(AA, "navigation") && $root.Navigation.encode(AA.navigation, IA.uint32(186).fork()).ldelim(), AA.authRedirect != null && Object.hasOwnProperty.call(AA, "authRedirect") && $root.AuthRedirect.encode(AA.authRedirect, IA.uint32(194).fork()).ldelim(), AA.deferredFileResponse != null && Object.hasOwnProperty.call(AA, "deferredFileResponse") && $root.DeferredFileResponse.encode(AA.deferredFileResponse, IA.uint32(202).fork()).ldelim(), AA.heartbeatAck != null && Object.hasOwnProperty.call(AA, "heartbeatAck") && IA.uint32(208).bool(AA.heartbeatAck), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.ForwardMsg();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.hash = AA.string();
          break;
        case 2:
          EA.metadata = $root.ForwardMsgMetadata.decode(AA, AA.uint32());
          break;
        case 4:
          EA.newSession = $root.NewSession.decode(AA, AA.uint32());
          break;
        case 5:
          EA.delta = $root.Delta.decode(AA, AA.uint32());
          break;
        case 12:
          EA.pageInfoChanged = $root.PageInfo.decode(AA, AA.uint32());
          break;
        case 13:
          EA.pageConfigChanged = $root.PageConfig.decode(AA, AA.uint32());
          break;
        case 6:
          EA.scriptFinished = AA.int32();
          break;
        case 14:
          EA.gitInfoChanged = $root.GitInfo.decode(AA, AA.uint32());
          break;
        case 18:
          EA.pageProfile = $root.PageProfile.decode(AA, AA.uint32());
          break;
        case 9:
          EA.sessionStatusChanged = $root.SessionStatus.decode(AA, AA.uint32());
          break;
        case 10:
          EA.sessionEvent = $root.SessionEvent.decode(AA, AA.uint32());
          break;
        case 23:
          EA.navigation = $root.Navigation.decode(AA, AA.uint32());
          break;
        case 15:
          EA.pageNotFound = $root.PageNotFound.decode(AA, AA.uint32());
          break;
        case 19:
          EA.fileUrlsResponse = $root.FileURLsResponse.decode(AA, AA.uint32());
          break;
        case 21:
          EA.autoRerun = $root.AutoRerun.decode(AA, AA.uint32());
          break;
        case 22:
          EA.logo = $root.Logo.decode(AA, AA.uint32());
          break;
        case 24:
          EA.authRedirect = $root.AuthRedirect.decode(AA, AA.uint32());
          break;
        case 20:
          EA.parentMessage = $root.ParentMessage.decode(AA, AA.uint32());
          break;
        case 11:
          EA.refHash = AA.string();
          break;
        case 25:
          EA.deferredFileResponse = $root.DeferredFileResponse.decode(AA, AA.uint32());
          break;
        case 26:
          EA.heartbeatAck = AA.bool();
          break;
        case 17:
          EA.debugLastBackmsgId = AA.string();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.ForwardMsg) return AA;
    let IA = new $root.ForwardMsg();
    if (AA.hash != null && (IA.hash = String(AA.hash)), AA.metadata != null) {
      if (typeof AA.metadata != "object") throw TypeError(".ForwardMsg.metadata: object expected");
      IA.metadata = $root.ForwardMsgMetadata.fromObject(AA.metadata);
    }
    if (AA.newSession != null) {
      if (typeof AA.newSession != "object") throw TypeError(".ForwardMsg.newSession: object expected");
      IA.newSession = $root.NewSession.fromObject(AA.newSession);
    }
    if (AA.delta != null) {
      if (typeof AA.delta != "object") throw TypeError(".ForwardMsg.delta: object expected");
      IA.delta = $root.Delta.fromObject(AA.delta);
    }
    if (AA.pageInfoChanged != null) {
      if (typeof AA.pageInfoChanged != "object") throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      IA.pageInfoChanged = $root.PageInfo.fromObject(AA.pageInfoChanged);
    }
    if (AA.pageConfigChanged != null) {
      if (typeof AA.pageConfigChanged != "object") throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      IA.pageConfigChanged = $root.PageConfig.fromObject(AA.pageConfigChanged);
    }
    switch (AA.scriptFinished) {
      default:
        if (typeof AA.scriptFinished == "number") {
          IA.scriptFinished = AA.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        IA.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        IA.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        IA.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        IA.scriptFinished = 3;
        break;
    }
    if (AA.gitInfoChanged != null) {
      if (typeof AA.gitInfoChanged != "object") throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      IA.gitInfoChanged = $root.GitInfo.fromObject(AA.gitInfoChanged);
    }
    if (AA.pageProfile != null) {
      if (typeof AA.pageProfile != "object") throw TypeError(".ForwardMsg.pageProfile: object expected");
      IA.pageProfile = $root.PageProfile.fromObject(AA.pageProfile);
    }
    if (AA.sessionStatusChanged != null) {
      if (typeof AA.sessionStatusChanged != "object") throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      IA.sessionStatusChanged = $root.SessionStatus.fromObject(AA.sessionStatusChanged);
    }
    if (AA.sessionEvent != null) {
      if (typeof AA.sessionEvent != "object") throw TypeError(".ForwardMsg.sessionEvent: object expected");
      IA.sessionEvent = $root.SessionEvent.fromObject(AA.sessionEvent);
    }
    if (AA.navigation != null) {
      if (typeof AA.navigation != "object") throw TypeError(".ForwardMsg.navigation: object expected");
      IA.navigation = $root.Navigation.fromObject(AA.navigation);
    }
    if (AA.pageNotFound != null) {
      if (typeof AA.pageNotFound != "object") throw TypeError(".ForwardMsg.pageNotFound: object expected");
      IA.pageNotFound = $root.PageNotFound.fromObject(AA.pageNotFound);
    }
    if (AA.fileUrlsResponse != null) {
      if (typeof AA.fileUrlsResponse != "object") throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      IA.fileUrlsResponse = $root.FileURLsResponse.fromObject(AA.fileUrlsResponse);
    }
    if (AA.autoRerun != null) {
      if (typeof AA.autoRerun != "object") throw TypeError(".ForwardMsg.autoRerun: object expected");
      IA.autoRerun = $root.AutoRerun.fromObject(AA.autoRerun);
    }
    if (AA.logo != null) {
      if (typeof AA.logo != "object") throw TypeError(".ForwardMsg.logo: object expected");
      IA.logo = $root.Logo.fromObject(AA.logo);
    }
    if (AA.authRedirect != null) {
      if (typeof AA.authRedirect != "object") throw TypeError(".ForwardMsg.authRedirect: object expected");
      IA.authRedirect = $root.AuthRedirect.fromObject(AA.authRedirect);
    }
    if (AA.parentMessage != null) {
      if (typeof AA.parentMessage != "object") throw TypeError(".ForwardMsg.parentMessage: object expected");
      IA.parentMessage = $root.ParentMessage.fromObject(AA.parentMessage);
    }
    if (AA.refHash != null && (IA.refHash = String(AA.refHash)), AA.deferredFileResponse != null) {
      if (typeof AA.deferredFileResponse != "object") throw TypeError(".ForwardMsg.deferredFileResponse: object expected");
      IA.deferredFileResponse = $root.DeferredFileResponse.fromObject(AA.deferredFileResponse);
    }
    return AA.heartbeatAck != null && (IA.heartbeatAck = !!AA.heartbeatAck), AA.debugLastBackmsgId != null && (IA.debugLastBackmsgId = String(AA.debugLastBackmsgId)), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.hash = "", BA.metadata = null, BA.debugLastBackmsgId = ""), AA.hash != null && AA.hasOwnProperty("hash") && (BA.hash = AA.hash), AA.metadata != null && AA.hasOwnProperty("metadata") && (BA.metadata = $root.ForwardMsgMetadata.toObject(AA.metadata, IA)), AA.newSession != null && AA.hasOwnProperty("newSession") && (BA.newSession = $root.NewSession.toObject(AA.newSession, IA), IA.oneofs && (BA.type = "newSession")), AA.delta != null && AA.hasOwnProperty("delta") && (BA.delta = $root.Delta.toObject(AA.delta, IA), IA.oneofs && (BA.type = "delta")), AA.scriptFinished != null && AA.hasOwnProperty("scriptFinished") && (BA.scriptFinished = IA.enums === String ? $root.ForwardMsg.ScriptFinishedStatus[AA.scriptFinished] === void 0 ? AA.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[AA.scriptFinished] : AA.scriptFinished, IA.oneofs && (BA.type = "scriptFinished")), AA.sessionStatusChanged != null && AA.hasOwnProperty("sessionStatusChanged") && (BA.sessionStatusChanged = $root.SessionStatus.toObject(AA.sessionStatusChanged, IA), IA.oneofs && (BA.type = "sessionStatusChanged")), AA.sessionEvent != null && AA.hasOwnProperty("sessionEvent") && (BA.sessionEvent = $root.SessionEvent.toObject(AA.sessionEvent, IA), IA.oneofs && (BA.type = "sessionEvent")), AA.refHash != null && AA.hasOwnProperty("refHash") && (BA.refHash = AA.refHash, IA.oneofs && (BA.type = "refHash")), AA.pageInfoChanged != null && AA.hasOwnProperty("pageInfoChanged") && (BA.pageInfoChanged = $root.PageInfo.toObject(AA.pageInfoChanged, IA), IA.oneofs && (BA.type = "pageInfoChanged")), AA.pageConfigChanged != null && AA.hasOwnProperty("pageConfigChanged") && (BA.pageConfigChanged = $root.PageConfig.toObject(AA.pageConfigChanged, IA), IA.oneofs && (BA.type = "pageConfigChanged")), AA.gitInfoChanged != null && AA.hasOwnProperty("gitInfoChanged") && (BA.gitInfoChanged = $root.GitInfo.toObject(AA.gitInfoChanged, IA), IA.oneofs && (BA.type = "gitInfoChanged")), AA.pageNotFound != null && AA.hasOwnProperty("pageNotFound") && (BA.pageNotFound = $root.PageNotFound.toObject(AA.pageNotFound, IA), IA.oneofs && (BA.type = "pageNotFound")), AA.debugLastBackmsgId != null && AA.hasOwnProperty("debugLastBackmsgId") && (BA.debugLastBackmsgId = AA.debugLastBackmsgId), AA.pageProfile != null && AA.hasOwnProperty("pageProfile") && (BA.pageProfile = $root.PageProfile.toObject(AA.pageProfile, IA), IA.oneofs && (BA.type = "pageProfile")), AA.fileUrlsResponse != null && AA.hasOwnProperty("fileUrlsResponse") && (BA.fileUrlsResponse = $root.FileURLsResponse.toObject(AA.fileUrlsResponse, IA), IA.oneofs && (BA.type = "fileUrlsResponse")), AA.parentMessage != null && AA.hasOwnProperty("parentMessage") && (BA.parentMessage = $root.ParentMessage.toObject(AA.parentMessage, IA), IA.oneofs && (BA.type = "parentMessage")), AA.autoRerun != null && AA.hasOwnProperty("autoRerun") && (BA.autoRerun = $root.AutoRerun.toObject(AA.autoRerun, IA), IA.oneofs && (BA.type = "autoRerun")), AA.logo != null && AA.hasOwnProperty("logo") && (BA.logo = $root.Logo.toObject(AA.logo, IA), IA.oneofs && (BA.type = "logo")), AA.navigation != null && AA.hasOwnProperty("navigation") && (BA.navigation = $root.Navigation.toObject(AA.navigation, IA), IA.oneofs && (BA.type = "navigation")), AA.authRedirect != null && AA.hasOwnProperty("authRedirect") && (BA.authRedirect = $root.AuthRedirect.toObject(AA.authRedirect, IA), IA.oneofs && (BA.type = "authRedirect")), AA.deferredFileResponse != null && AA.hasOwnProperty("deferredFileResponse") && (BA.deferredFileResponse = $root.DeferredFileResponse.toObject(AA.deferredFileResponse, IA), IA.oneofs && (BA.type = "deferredFileResponse")), AA.heartbeatAck != null && AA.hasOwnProperty("heartbeatAck") && (BA.heartbeatAck = AA.heartbeatAck, IA.oneofs && (BA.type = "heartbeatAck")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/ForwardMsg";
  }, CA.ScriptFinishedStatus = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "FINISHED_SUCCESSFULLY"] = 0, IA[AA[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, IA[AA[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, IA[AA[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, IA;
  })(), CA;
})();
$root.DeferredFileResponse = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.fileId = "", CA.prototype.url = "", CA.prototype.errorMsg = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.fileId != null && Object.hasOwnProperty.call(gA, "fileId") && AA.uint32(10).string(gA.fileId), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(18).string(gA.url), gA.errorMsg != null && Object.hasOwnProperty.call(gA, "errorMsg") && AA.uint32(26).string(gA.errorMsg), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.DeferredFileResponse();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.fileId = gA.string();
          break;
        case 2:
          QA.url = gA.string();
          break;
        case 3:
          QA.errorMsg = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.DeferredFileResponse) return gA;
    let AA = new $root.DeferredFileResponse();
    return gA.fileId != null && (AA.fileId = String(gA.fileId)), gA.url != null && (AA.url = String(gA.url)), gA.errorMsg != null && (AA.errorMsg = String(gA.errorMsg)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.fileId = "", IA.url = "", IA.errorMsg = ""), gA.fileId != null && gA.hasOwnProperty("fileId") && (IA.fileId = gA.fileId), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), gA.errorMsg != null && gA.hasOwnProperty("errorMsg") && (IA.errorMsg = gA.errorMsg), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/DeferredFileResponse";
  }, CA;
})();
$root.ForwardMsgMetadata = (() => {
  function CA(gA) {
    if (this.deltaPath = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.cacheable = !1, CA.prototype.deltaPath = $util.emptyArray, CA.prototype.activeScriptHash = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.cacheable != null && Object.hasOwnProperty.call(gA, "cacheable") && AA.uint32(8).bool(gA.cacheable), gA.deltaPath != null && gA.deltaPath.length) {
      AA.uint32(18).fork();
      for (let IA = 0; IA < gA.deltaPath.length; ++IA) AA.uint32(gA.deltaPath[IA]);
      AA.ldelim();
    }
    return gA.activeScriptHash != null && Object.hasOwnProperty.call(gA, "activeScriptHash") && AA.uint32(34).string(gA.activeScriptHash), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ForwardMsgMetadata();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.cacheable = gA.bool();
          break;
        case 2:
          if (QA.deltaPath && QA.deltaPath.length || (QA.deltaPath = []), (EA & 7) == 2) {
            let iA = gA.uint32() + gA.pos;
            for (; gA.pos < iA; ) QA.deltaPath.push(gA.uint32());
          } else QA.deltaPath.push(gA.uint32());
          break;
        case 4:
          QA.activeScriptHash = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ForwardMsgMetadata) return gA;
    let AA = new $root.ForwardMsgMetadata();
    if (gA.cacheable != null && (AA.cacheable = !!gA.cacheable), gA.deltaPath) {
      if (!Array.isArray(gA.deltaPath)) throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      AA.deltaPath = [];
      for (let IA = 0; IA < gA.deltaPath.length; ++IA) AA.deltaPath[IA] = gA.deltaPath[IA] >>> 0;
    }
    return gA.activeScriptHash != null && (AA.activeScriptHash = String(gA.activeScriptHash)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.deltaPath = []), AA.defaults && (IA.cacheable = !1, IA.activeScriptHash = ""), gA.cacheable != null && gA.hasOwnProperty("cacheable") && (IA.cacheable = gA.cacheable), gA.deltaPath && gA.deltaPath.length) {
      IA.deltaPath = [];
      for (let BA = 0; BA < gA.deltaPath.length; ++BA) IA.deltaPath[BA] = gA.deltaPath[BA];
    }
    return gA.activeScriptHash != null && gA.hasOwnProperty("activeScriptHash") && (IA.activeScriptHash = gA.activeScriptHash), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ForwardMsgMetadata";
  }, CA;
})();
$root.ForwardMsgList = (() => {
  function CA(gA) {
    if (this.messages = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.messages = $util.emptyArray, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.messages != null && gA.messages.length) for (let IA = 0; IA < gA.messages.length; ++IA) $root.ForwardMsg.encode(gA.messages[IA], AA.uint32(10).fork()).ldelim();
    return AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ForwardMsgList();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? (QA.messages && QA.messages.length || (QA.messages = []), QA.messages.push($root.ForwardMsg.decode(gA, gA.uint32()))) : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ForwardMsgList) return gA;
    let AA = new $root.ForwardMsgList();
    if (gA.messages) {
      if (!Array.isArray(gA.messages)) throw TypeError(".ForwardMsgList.messages: array expected");
      AA.messages = [];
      for (let IA = 0; IA < gA.messages.length; ++IA) {
        if (typeof gA.messages[IA] != "object") throw TypeError(".ForwardMsgList.messages: object expected");
        AA.messages[IA] = $root.ForwardMsg.fromObject(gA.messages[IA]);
      }
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.messages = []), gA.messages && gA.messages.length) {
      IA.messages = [];
      for (let BA = 0; BA < gA.messages.length; ++BA) IA.messages[BA] = $root.ForwardMsg.toObject(gA.messages[BA], AA);
    }
    return IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ForwardMsgList";
  }, CA;
})();
$root.GitInfo = (() => {
  function CA(gA) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.repository = "", CA.prototype.branch = "", CA.prototype.module = "", CA.prototype.untrackedFiles = $util.emptyArray, CA.prototype.uncommittedFiles = $util.emptyArray, CA.prototype.state = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.repository != null && Object.hasOwnProperty.call(gA, "repository") && AA.uint32(10).string(gA.repository), gA.branch != null && Object.hasOwnProperty.call(gA, "branch") && AA.uint32(18).string(gA.branch), gA.module != null && Object.hasOwnProperty.call(gA, "module") && AA.uint32(26).string(gA.module), gA.untrackedFiles != null && gA.untrackedFiles.length) for (let IA = 0; IA < gA.untrackedFiles.length; ++IA) AA.uint32(34).string(gA.untrackedFiles[IA]);
    if (gA.uncommittedFiles != null && gA.uncommittedFiles.length) for (let IA = 0; IA < gA.uncommittedFiles.length; ++IA) AA.uint32(42).string(gA.uncommittedFiles[IA]);
    return gA.state != null && Object.hasOwnProperty.call(gA, "state") && AA.uint32(48).int32(gA.state), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.GitInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.repository = gA.string();
          break;
        case 2:
          QA.branch = gA.string();
          break;
        case 3:
          QA.module = gA.string();
          break;
        case 4:
          QA.untrackedFiles && QA.untrackedFiles.length || (QA.untrackedFiles = []), QA.untrackedFiles.push(gA.string());
          break;
        case 5:
          QA.uncommittedFiles && QA.uncommittedFiles.length || (QA.uncommittedFiles = []), QA.uncommittedFiles.push(gA.string());
          break;
        case 6:
          QA.state = gA.int32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.GitInfo) return gA;
    let AA = new $root.GitInfo();
    if (gA.repository != null && (AA.repository = String(gA.repository)), gA.branch != null && (AA.branch = String(gA.branch)), gA.module != null && (AA.module = String(gA.module)), gA.untrackedFiles) {
      if (!Array.isArray(gA.untrackedFiles)) throw TypeError(".GitInfo.untrackedFiles: array expected");
      AA.untrackedFiles = [];
      for (let IA = 0; IA < gA.untrackedFiles.length; ++IA) AA.untrackedFiles[IA] = String(gA.untrackedFiles[IA]);
    }
    if (gA.uncommittedFiles) {
      if (!Array.isArray(gA.uncommittedFiles)) throw TypeError(".GitInfo.uncommittedFiles: array expected");
      AA.uncommittedFiles = [];
      for (let IA = 0; IA < gA.uncommittedFiles.length; ++IA) AA.uncommittedFiles[IA] = String(gA.uncommittedFiles[IA]);
    }
    switch (gA.state) {
      default:
        if (typeof gA.state == "number") {
          AA.state = gA.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        AA.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        AA.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        AA.state = 2;
        break;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.untrackedFiles = [], IA.uncommittedFiles = []), AA.defaults && (IA.repository = "", IA.branch = "", IA.module = "", IA.state = AA.enums === String ? "DEFAULT" : 0), gA.repository != null && gA.hasOwnProperty("repository") && (IA.repository = gA.repository), gA.branch != null && gA.hasOwnProperty("branch") && (IA.branch = gA.branch), gA.module != null && gA.hasOwnProperty("module") && (IA.module = gA.module), gA.untrackedFiles && gA.untrackedFiles.length) {
      IA.untrackedFiles = [];
      for (let BA = 0; BA < gA.untrackedFiles.length; ++BA) IA.untrackedFiles[BA] = gA.untrackedFiles[BA];
    }
    if (gA.uncommittedFiles && gA.uncommittedFiles.length) {
      IA.uncommittedFiles = [];
      for (let BA = 0; BA < gA.uncommittedFiles.length; ++BA) IA.uncommittedFiles[BA] = gA.uncommittedFiles[BA];
    }
    return gA.state != null && gA.hasOwnProperty("state") && (IA.state = AA.enums === String ? $root.GitInfo.GitStates[gA.state] === void 0 ? gA.state : $root.GitInfo.GitStates[gA.state] : gA.state), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/GitInfo";
  }, CA.GitStates = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "DEFAULT"] = 0, AA[gA[1] = "HEAD_DETACHED"] = 1, AA[gA[2] = "AHEAD_OF_REMOTE"] = 2, AA;
  })(), CA;
})();
$root.Logo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.image = "", CA.prototype.link = "", CA.prototype.iconImage = "", CA.prototype.size = "", CA.prototype.imageType = 0, CA.prototype.iconImageType = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.image != null && Object.hasOwnProperty.call(gA, "image") && AA.uint32(10).string(gA.image), gA.link != null && Object.hasOwnProperty.call(gA, "link") && AA.uint32(18).string(gA.link), gA.iconImage != null && Object.hasOwnProperty.call(gA, "iconImage") && AA.uint32(26).string(gA.iconImage), gA.size != null && Object.hasOwnProperty.call(gA, "size") && AA.uint32(34).string(gA.size), gA.imageType != null && Object.hasOwnProperty.call(gA, "imageType") && AA.uint32(40).int32(gA.imageType), gA.iconImageType != null && Object.hasOwnProperty.call(gA, "iconImageType") && AA.uint32(48).int32(gA.iconImageType), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Logo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.image = gA.string();
          break;
        case 2:
          QA.link = gA.string();
          break;
        case 3:
          QA.iconImage = gA.string();
          break;
        case 4:
          QA.size = gA.string();
          break;
        case 5:
          QA.imageType = gA.int32();
          break;
        case 6:
          QA.iconImageType = gA.int32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Logo) return gA;
    let AA = new $root.Logo();
    switch (gA.image != null && (AA.image = String(gA.image)), gA.link != null && (AA.link = String(gA.link)), gA.iconImage != null && (AA.iconImage = String(gA.iconImage)), gA.size != null && (AA.size = String(gA.size)), gA.imageType) {
      default:
        if (typeof gA.imageType == "number") {
          AA.imageType = gA.imageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        AA.imageType = 0;
        break;
      case "EMOJI":
      case 1:
        AA.imageType = 1;
        break;
      case "ICON":
      case 2:
        AA.imageType = 2;
        break;
    }
    switch (gA.iconImageType) {
      default:
        if (typeof gA.iconImageType == "number") {
          AA.iconImageType = gA.iconImageType;
          break;
        }
        break;
      case "IMAGE":
      case 0:
        AA.iconImageType = 0;
        break;
      case "EMOJI":
      case 1:
        AA.iconImageType = 1;
        break;
      case "ICON":
      case 2:
        AA.iconImageType = 2;
        break;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.image = "", IA.link = "", IA.iconImage = "", IA.size = "", IA.imageType = AA.enums === String ? "IMAGE" : 0, IA.iconImageType = AA.enums === String ? "IMAGE" : 0), gA.image != null && gA.hasOwnProperty("image") && (IA.image = gA.image), gA.link != null && gA.hasOwnProperty("link") && (IA.link = gA.link), gA.iconImage != null && gA.hasOwnProperty("iconImage") && (IA.iconImage = gA.iconImage), gA.size != null && gA.hasOwnProperty("size") && (IA.size = gA.size), gA.imageType != null && gA.hasOwnProperty("imageType") && (IA.imageType = AA.enums === String ? $root.Logo.ImageType[gA.imageType] === void 0 ? gA.imageType : $root.Logo.ImageType[gA.imageType] : gA.imageType), gA.iconImageType != null && gA.hasOwnProperty("iconImageType") && (IA.iconImageType = AA.enums === String ? $root.Logo.ImageType[gA.iconImageType] === void 0 ? gA.iconImageType : $root.Logo.ImageType[gA.iconImageType] : gA.iconImageType), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Logo";
  }, CA.ImageType = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "IMAGE"] = 0, AA[gA[1] = "EMOJI"] = 1, AA[gA[2] = "ICON"] = 2, AA;
  })(), CA;
})();
$root.Navigation = (() => {
  function CA(AA) {
    if (this.sections = [], this.appPages = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.sections = $util.emptyArray, CA.prototype.appPages = $util.emptyArray, CA.prototype.position = 0, CA.prototype.pageScriptHash = "", CA.prototype.expanded = !1, CA.prototype.visibleItems = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_visibleItems", { get: $util.oneOfGetter(gA = ["visibleItems"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.sections != null && AA.sections.length) for (let BA = 0; BA < AA.sections.length; ++BA) IA.uint32(10).string(AA.sections[BA]);
    if (AA.appPages != null && AA.appPages.length) for (let BA = 0; BA < AA.appPages.length; ++BA) $root.AppPage.encode(AA.appPages[BA], IA.uint32(18).fork()).ldelim();
    return AA.position != null && Object.hasOwnProperty.call(AA, "position") && IA.uint32(24).int32(AA.position), AA.pageScriptHash != null && Object.hasOwnProperty.call(AA, "pageScriptHash") && IA.uint32(34).string(AA.pageScriptHash), AA.expanded != null && Object.hasOwnProperty.call(AA, "expanded") && IA.uint32(40).bool(AA.expanded), AA.visibleItems != null && Object.hasOwnProperty.call(AA, "visibleItems") && IA.uint32(48).uint32(AA.visibleItems), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.Navigation();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.sections && EA.sections.length || (EA.sections = []), EA.sections.push(AA.string());
          break;
        case 2:
          EA.appPages && EA.appPages.length || (EA.appPages = []), EA.appPages.push($root.AppPage.decode(AA, AA.uint32()));
          break;
        case 3:
          EA.position = AA.int32();
          break;
        case 4:
          EA.pageScriptHash = AA.string();
          break;
        case 5:
          EA.expanded = AA.bool();
          break;
        case 6:
          EA.visibleItems = AA.uint32();
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.Navigation) return AA;
    let IA = new $root.Navigation();
    if (AA.sections) {
      if (!Array.isArray(AA.sections)) throw TypeError(".Navigation.sections: array expected");
      IA.sections = [];
      for (let BA = 0; BA < AA.sections.length; ++BA) IA.sections[BA] = String(AA.sections[BA]);
    }
    if (AA.appPages) {
      if (!Array.isArray(AA.appPages)) throw TypeError(".Navigation.appPages: array expected");
      IA.appPages = [];
      for (let BA = 0; BA < AA.appPages.length; ++BA) {
        if (typeof AA.appPages[BA] != "object") throw TypeError(".Navigation.appPages: object expected");
        IA.appPages[BA] = $root.AppPage.fromObject(AA.appPages[BA]);
      }
    }
    switch (AA.position) {
      default:
        if (typeof AA.position == "number") {
          IA.position = AA.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        IA.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        IA.position = 1;
        break;
      case "TOP":
      case 2:
        IA.position = 2;
        break;
    }
    return AA.pageScriptHash != null && (IA.pageScriptHash = String(AA.pageScriptHash)), AA.expanded != null && (IA.expanded = !!AA.expanded), AA.visibleItems != null && (IA.visibleItems = AA.visibleItems >>> 0), IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.sections = [], BA.appPages = []), IA.defaults && (BA.position = IA.enums === String ? "HIDDEN" : 0, BA.pageScriptHash = "", BA.expanded = !1), AA.sections && AA.sections.length) {
      BA.sections = [];
      for (let QA = 0; QA < AA.sections.length; ++QA) BA.sections[QA] = AA.sections[QA];
    }
    if (AA.appPages && AA.appPages.length) {
      BA.appPages = [];
      for (let QA = 0; QA < AA.appPages.length; ++QA) BA.appPages[QA] = $root.AppPage.toObject(AA.appPages[QA], IA);
    }
    return AA.position != null && AA.hasOwnProperty("position") && (BA.position = IA.enums === String ? $root.Navigation.Position[AA.position] === void 0 ? AA.position : $root.Navigation.Position[AA.position] : AA.position), AA.pageScriptHash != null && AA.hasOwnProperty("pageScriptHash") && (BA.pageScriptHash = AA.pageScriptHash), AA.expanded != null && AA.hasOwnProperty("expanded") && (BA.expanded = AA.expanded), AA.visibleItems != null && AA.hasOwnProperty("visibleItems") && (BA.visibleItems = AA.visibleItems, IA.oneofs && (BA._visibleItems = "visibleItems")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/Navigation";
  }, CA.Position = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "HIDDEN"] = 0, IA[AA[1] = "SIDEBAR"] = 1, IA[AA[2] = "TOP"] = 2, IA;
  })(), CA;
})();
$root.NewSession = (() => {
  function CA(gA) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.initialize = null, CA.prototype.scriptRunId = "", CA.prototype.name = "", CA.prototype.mainScriptPath = "", CA.prototype.config = null, CA.prototype.customTheme = null, CA.prototype.appPages = $util.emptyArray, CA.prototype.pageScriptHash = "", CA.prototype.fragmentIdsThisRun = $util.emptyArray, CA.prototype.mainScriptHash = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.initialize != null && Object.hasOwnProperty.call(gA, "initialize") && $root.Initialize.encode(gA.initialize, AA.uint32(10).fork()).ldelim(), gA.scriptRunId != null && Object.hasOwnProperty.call(gA, "scriptRunId") && AA.uint32(18).string(gA.scriptRunId), gA.name != null && Object.hasOwnProperty.call(gA, "name") && AA.uint32(26).string(gA.name), gA.mainScriptPath != null && Object.hasOwnProperty.call(gA, "mainScriptPath") && AA.uint32(34).string(gA.mainScriptPath), gA.config != null && Object.hasOwnProperty.call(gA, "config") && $root.Config.encode(gA.config, AA.uint32(50).fork()).ldelim(), gA.customTheme != null && Object.hasOwnProperty.call(gA, "customTheme") && $root.CustomThemeConfig.encode(gA.customTheme, AA.uint32(58).fork()).ldelim(), gA.appPages != null && gA.appPages.length) for (let IA = 0; IA < gA.appPages.length; ++IA) $root.AppPage.encode(gA.appPages[IA], AA.uint32(66).fork()).ldelim();
    if (gA.pageScriptHash != null && Object.hasOwnProperty.call(gA, "pageScriptHash") && AA.uint32(74).string(gA.pageScriptHash), gA.fragmentIdsThisRun != null && gA.fragmentIdsThisRun.length) for (let IA = 0; IA < gA.fragmentIdsThisRun.length; ++IA) AA.uint32(82).string(gA.fragmentIdsThisRun[IA]);
    return gA.mainScriptHash != null && Object.hasOwnProperty.call(gA, "mainScriptHash") && AA.uint32(90).string(gA.mainScriptHash), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.NewSession();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.initialize = $root.Initialize.decode(gA, gA.uint32());
          break;
        case 2:
          QA.scriptRunId = gA.string();
          break;
        case 3:
          QA.name = gA.string();
          break;
        case 4:
          QA.mainScriptPath = gA.string();
          break;
        case 6:
          QA.config = $root.Config.decode(gA, gA.uint32());
          break;
        case 7:
          QA.customTheme = $root.CustomThemeConfig.decode(gA, gA.uint32());
          break;
        case 8:
          QA.appPages && QA.appPages.length || (QA.appPages = []), QA.appPages.push($root.AppPage.decode(gA, gA.uint32()));
          break;
        case 9:
          QA.pageScriptHash = gA.string();
          break;
        case 10:
          QA.fragmentIdsThisRun && QA.fragmentIdsThisRun.length || (QA.fragmentIdsThisRun = []), QA.fragmentIdsThisRun.push(gA.string());
          break;
        case 11:
          QA.mainScriptHash = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.NewSession) return gA;
    let AA = new $root.NewSession();
    if (gA.initialize != null) {
      if (typeof gA.initialize != "object") throw TypeError(".NewSession.initialize: object expected");
      AA.initialize = $root.Initialize.fromObject(gA.initialize);
    }
    if (gA.scriptRunId != null && (AA.scriptRunId = String(gA.scriptRunId)), gA.name != null && (AA.name = String(gA.name)), gA.mainScriptPath != null && (AA.mainScriptPath = String(gA.mainScriptPath)), gA.config != null) {
      if (typeof gA.config != "object") throw TypeError(".NewSession.config: object expected");
      AA.config = $root.Config.fromObject(gA.config);
    }
    if (gA.customTheme != null) {
      if (typeof gA.customTheme != "object") throw TypeError(".NewSession.customTheme: object expected");
      AA.customTheme = $root.CustomThemeConfig.fromObject(gA.customTheme);
    }
    if (gA.appPages) {
      if (!Array.isArray(gA.appPages)) throw TypeError(".NewSession.appPages: array expected");
      AA.appPages = [];
      for (let IA = 0; IA < gA.appPages.length; ++IA) {
        if (typeof gA.appPages[IA] != "object") throw TypeError(".NewSession.appPages: object expected");
        AA.appPages[IA] = $root.AppPage.fromObject(gA.appPages[IA]);
      }
    }
    if (gA.pageScriptHash != null && (AA.pageScriptHash = String(gA.pageScriptHash)), gA.fragmentIdsThisRun) {
      if (!Array.isArray(gA.fragmentIdsThisRun)) throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      AA.fragmentIdsThisRun = [];
      for (let IA = 0; IA < gA.fragmentIdsThisRun.length; ++IA) AA.fragmentIdsThisRun[IA] = String(gA.fragmentIdsThisRun[IA]);
    }
    return gA.mainScriptHash != null && (AA.mainScriptHash = String(gA.mainScriptHash)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.appPages = [], IA.fragmentIdsThisRun = []), AA.defaults && (IA.initialize = null, IA.scriptRunId = "", IA.name = "", IA.mainScriptPath = "", IA.config = null, IA.customTheme = null, IA.pageScriptHash = "", IA.mainScriptHash = ""), gA.initialize != null && gA.hasOwnProperty("initialize") && (IA.initialize = $root.Initialize.toObject(gA.initialize, AA)), gA.scriptRunId != null && gA.hasOwnProperty("scriptRunId") && (IA.scriptRunId = gA.scriptRunId), gA.name != null && gA.hasOwnProperty("name") && (IA.name = gA.name), gA.mainScriptPath != null && gA.hasOwnProperty("mainScriptPath") && (IA.mainScriptPath = gA.mainScriptPath), gA.config != null && gA.hasOwnProperty("config") && (IA.config = $root.Config.toObject(gA.config, AA)), gA.customTheme != null && gA.hasOwnProperty("customTheme") && (IA.customTheme = $root.CustomThemeConfig.toObject(gA.customTheme, AA)), gA.appPages && gA.appPages.length) {
      IA.appPages = [];
      for (let BA = 0; BA < gA.appPages.length; ++BA) IA.appPages[BA] = $root.AppPage.toObject(gA.appPages[BA], AA);
    }
    if (gA.pageScriptHash != null && gA.hasOwnProperty("pageScriptHash") && (IA.pageScriptHash = gA.pageScriptHash), gA.fragmentIdsThisRun && gA.fragmentIdsThisRun.length) {
      IA.fragmentIdsThisRun = [];
      for (let BA = 0; BA < gA.fragmentIdsThisRun.length; ++BA) IA.fragmentIdsThisRun[BA] = gA.fragmentIdsThisRun[BA];
    }
    return gA.mainScriptHash != null && gA.hasOwnProperty("mainScriptHash") && (IA.mainScriptHash = gA.mainScriptHash), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/NewSession";
  }, CA;
})();
$root.Initialize = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.userInfo = null, CA.prototype.environmentInfo = null, CA.prototype.sessionStatus = null, CA.prototype.sessionId = "", CA.prototype.isHello = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.userInfo != null && Object.hasOwnProperty.call(gA, "userInfo") && $root.UserInfo.encode(gA.userInfo, AA.uint32(10).fork()).ldelim(), gA.environmentInfo != null && Object.hasOwnProperty.call(gA, "environmentInfo") && $root.EnvironmentInfo.encode(gA.environmentInfo, AA.uint32(26).fork()).ldelim(), gA.sessionStatus != null && Object.hasOwnProperty.call(gA, "sessionStatus") && $root.SessionStatus.encode(gA.sessionStatus, AA.uint32(34).fork()).ldelim(), gA.sessionId != null && Object.hasOwnProperty.call(gA, "sessionId") && AA.uint32(50).string(gA.sessionId), gA.isHello != null && Object.hasOwnProperty.call(gA, "isHello") && AA.uint32(56).bool(gA.isHello), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Initialize();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.userInfo = $root.UserInfo.decode(gA, gA.uint32());
          break;
        case 3:
          QA.environmentInfo = $root.EnvironmentInfo.decode(gA, gA.uint32());
          break;
        case 4:
          QA.sessionStatus = $root.SessionStatus.decode(gA, gA.uint32());
          break;
        case 6:
          QA.sessionId = gA.string();
          break;
        case 7:
          QA.isHello = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Initialize) return gA;
    let AA = new $root.Initialize();
    if (gA.userInfo != null) {
      if (typeof gA.userInfo != "object") throw TypeError(".Initialize.userInfo: object expected");
      AA.userInfo = $root.UserInfo.fromObject(gA.userInfo);
    }
    if (gA.environmentInfo != null) {
      if (typeof gA.environmentInfo != "object") throw TypeError(".Initialize.environmentInfo: object expected");
      AA.environmentInfo = $root.EnvironmentInfo.fromObject(gA.environmentInfo);
    }
    if (gA.sessionStatus != null) {
      if (typeof gA.sessionStatus != "object") throw TypeError(".Initialize.sessionStatus: object expected");
      AA.sessionStatus = $root.SessionStatus.fromObject(gA.sessionStatus);
    }
    return gA.sessionId != null && (AA.sessionId = String(gA.sessionId)), gA.isHello != null && (AA.isHello = !!gA.isHello), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.userInfo = null, IA.environmentInfo = null, IA.sessionStatus = null, IA.sessionId = "", IA.isHello = !1), gA.userInfo != null && gA.hasOwnProperty("userInfo") && (IA.userInfo = $root.UserInfo.toObject(gA.userInfo, AA)), gA.environmentInfo != null && gA.hasOwnProperty("environmentInfo") && (IA.environmentInfo = $root.EnvironmentInfo.toObject(gA.environmentInfo, AA)), gA.sessionStatus != null && gA.hasOwnProperty("sessionStatus") && (IA.sessionStatus = $root.SessionStatus.toObject(gA.sessionStatus, AA)), gA.sessionId != null && gA.hasOwnProperty("sessionId") && (IA.sessionId = gA.sessionId), gA.isHello != null && gA.hasOwnProperty("isHello") && (IA.isHello = gA.isHello), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Initialize";
  }, CA;
})();
$root.Config = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.gatherUsageStats = !1, CA.prototype.maxCachedMessageAge = 0, CA.prototype.allowRunOnSave = !1, CA.prototype.hideTopBar = !1, CA.prototype.hideSidebarNav = !1, CA.prototype.toolbarMode = 0, CA.prototype.showErrorLinks = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.gatherUsageStats != null && Object.hasOwnProperty.call(gA, "gatherUsageStats") && AA.uint32(16).bool(gA.gatherUsageStats), gA.maxCachedMessageAge != null && Object.hasOwnProperty.call(gA, "maxCachedMessageAge") && AA.uint32(24).int32(gA.maxCachedMessageAge), gA.allowRunOnSave != null && Object.hasOwnProperty.call(gA, "allowRunOnSave") && AA.uint32(40).bool(gA.allowRunOnSave), gA.hideTopBar != null && Object.hasOwnProperty.call(gA, "hideTopBar") && AA.uint32(48).bool(gA.hideTopBar), gA.hideSidebarNav != null && Object.hasOwnProperty.call(gA, "hideSidebarNav") && AA.uint32(56).bool(gA.hideSidebarNav), gA.toolbarMode != null && Object.hasOwnProperty.call(gA, "toolbarMode") && AA.uint32(64).int32(gA.toolbarMode), gA.showErrorLinks != null && Object.hasOwnProperty.call(gA, "showErrorLinks") && AA.uint32(72).int32(gA.showErrorLinks), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Config();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 2:
          QA.gatherUsageStats = gA.bool();
          break;
        case 3:
          QA.maxCachedMessageAge = gA.int32();
          break;
        case 5:
          QA.allowRunOnSave = gA.bool();
          break;
        case 6:
          QA.hideTopBar = gA.bool();
          break;
        case 7:
          QA.hideSidebarNav = gA.bool();
          break;
        case 8:
          QA.toolbarMode = gA.int32();
          break;
        case 9:
          QA.showErrorLinks = gA.int32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Config) return gA;
    let AA = new $root.Config();
    switch (gA.gatherUsageStats != null && (AA.gatherUsageStats = !!gA.gatherUsageStats), gA.maxCachedMessageAge != null && (AA.maxCachedMessageAge = gA.maxCachedMessageAge | 0), gA.allowRunOnSave != null && (AA.allowRunOnSave = !!gA.allowRunOnSave), gA.hideTopBar != null && (AA.hideTopBar = !!gA.hideTopBar), gA.hideSidebarNav != null && (AA.hideSidebarNav = !!gA.hideSidebarNav), gA.toolbarMode) {
      default:
        if (typeof gA.toolbarMode == "number") {
          AA.toolbarMode = gA.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        AA.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        AA.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        AA.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        AA.toolbarMode = 3;
        break;
    }
    switch (gA.showErrorLinks) {
      default:
        if (typeof gA.showErrorLinks == "number") {
          AA.showErrorLinks = gA.showErrorLinks;
          break;
        }
        break;
      case "SHOW_ERROR_LINKS_UNSPECIFIED":
      case 0:
        AA.showErrorLinks = 0;
        break;
      case "SHOW_ERROR_LINKS_AUTO":
      case 1:
        AA.showErrorLinks = 1;
        break;
      case "SHOW_ERROR_LINKS_TRUE":
      case 2:
        AA.showErrorLinks = 2;
        break;
      case "SHOW_ERROR_LINKS_FALSE":
      case 3:
        AA.showErrorLinks = 3;
        break;
    }
    return AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.gatherUsageStats = !1, IA.maxCachedMessageAge = 0, IA.allowRunOnSave = !1, IA.hideTopBar = !1, IA.hideSidebarNav = !1, IA.toolbarMode = AA.enums === String ? "AUTO" : 0, IA.showErrorLinks = AA.enums === String ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0), gA.gatherUsageStats != null && gA.hasOwnProperty("gatherUsageStats") && (IA.gatherUsageStats = gA.gatherUsageStats), gA.maxCachedMessageAge != null && gA.hasOwnProperty("maxCachedMessageAge") && (IA.maxCachedMessageAge = gA.maxCachedMessageAge), gA.allowRunOnSave != null && gA.hasOwnProperty("allowRunOnSave") && (IA.allowRunOnSave = gA.allowRunOnSave), gA.hideTopBar != null && gA.hasOwnProperty("hideTopBar") && (IA.hideTopBar = gA.hideTopBar), gA.hideSidebarNav != null && gA.hasOwnProperty("hideSidebarNav") && (IA.hideSidebarNav = gA.hideSidebarNav), gA.toolbarMode != null && gA.hasOwnProperty("toolbarMode") && (IA.toolbarMode = AA.enums === String ? $root.Config.ToolbarMode[gA.toolbarMode] === void 0 ? gA.toolbarMode : $root.Config.ToolbarMode[gA.toolbarMode] : gA.toolbarMode), gA.showErrorLinks != null && gA.hasOwnProperty("showErrorLinks") && (IA.showErrorLinks = AA.enums === String ? $root.Config.ShowErrorLinks[gA.showErrorLinks] === void 0 ? gA.showErrorLinks : $root.Config.ShowErrorLinks[gA.showErrorLinks] : gA.showErrorLinks), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Config";
  }, CA.ToolbarMode = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "AUTO"] = 0, AA[gA[1] = "DEVELOPER"] = 1, AA[gA[2] = "VIEWER"] = 2, AA[gA[3] = "MINIMAL"] = 3, AA;
  })(), CA.ShowErrorLinks = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, AA[gA[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, AA[gA[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, AA[gA[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, AA;
  })(), CA;
})();
$root.CustomThemeConfig = (() => {
  function CA(AA) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.primaryColor = "", CA.prototype.secondaryBackgroundColor = "", CA.prototype.backgroundColor = "", CA.prototype.textColor = "", CA.prototype.base = 0, CA.prototype.headingFont = "", CA.prototype.bodyFont = "", CA.prototype.codeFont = "", CA.prototype.fontFaces = $util.emptyArray, CA.prototype.fontSources = $util.emptyArray, CA.prototype.baseRadius = null, CA.prototype.buttonRadius = null, CA.prototype.borderColor = null, CA.prototype.dataframeBorderColor = null, CA.prototype.showWidgetBorder = null, CA.prototype.linkColor = null, CA.prototype.linkUnderline = null, CA.prototype.baseFontSize = null, CA.prototype.baseFontWeight = null, CA.prototype.codeFontWeight = null, CA.prototype.codeFontSize = null, CA.prototype.headingFontSizes = $util.emptyArray, CA.prototype.headingFontWeights = $util.emptyArray, CA.prototype.showSidebarBorder = null, CA.prototype.codeTextColor = null, CA.prototype.codeBackgroundColor = null, CA.prototype.dataframeHeaderBackgroundColor = null, CA.prototype.chartCategoricalColors = $util.emptyArray, CA.prototype.chartSequentialColors = $util.emptyArray, CA.prototype.chartDivergingColors = $util.emptyArray, CA.prototype.redColor = null, CA.prototype.orangeColor = null, CA.prototype.yellowColor = null, CA.prototype.blueColor = null, CA.prototype.greenColor = null, CA.prototype.violetColor = null, CA.prototype.grayColor = null, CA.prototype.redBackgroundColor = null, CA.prototype.orangeBackgroundColor = null, CA.prototype.yellowBackgroundColor = null, CA.prototype.blueBackgroundColor = null, CA.prototype.greenBackgroundColor = null, CA.prototype.violetBackgroundColor = null, CA.prototype.grayBackgroundColor = null, CA.prototype.redTextColor = null, CA.prototype.orangeTextColor = null, CA.prototype.yellowTextColor = null, CA.prototype.blueTextColor = null, CA.prototype.greenTextColor = null, CA.prototype.violetTextColor = null, CA.prototype.grayTextColor = null, CA.prototype.metricValueFontSize = null, CA.prototype.metricValueFontWeight = null, CA.prototype.sidebar = null, CA.prototype.light = null, CA.prototype.dark = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_baseRadius", { get: $util.oneOfGetter(gA = ["baseRadius"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_buttonRadius", { get: $util.oneOfGetter(gA = ["buttonRadius"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_borderColor", { get: $util.oneOfGetter(gA = ["borderColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dataframeBorderColor", { get: $util.oneOfGetter(gA = ["dataframeBorderColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_showWidgetBorder", { get: $util.oneOfGetter(gA = ["showWidgetBorder"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_linkColor", { get: $util.oneOfGetter(gA = ["linkColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_linkUnderline", { get: $util.oneOfGetter(gA = ["linkUnderline"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_baseFontSize", { get: $util.oneOfGetter(gA = ["baseFontSize"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_baseFontWeight", { get: $util.oneOfGetter(gA = ["baseFontWeight"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeFontWeight", { get: $util.oneOfGetter(gA = ["codeFontWeight"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeFontSize", { get: $util.oneOfGetter(gA = ["codeFontSize"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_showSidebarBorder", { get: $util.oneOfGetter(gA = ["showSidebarBorder"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeTextColor", { get: $util.oneOfGetter(gA = ["codeTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_codeBackgroundColor", { get: $util.oneOfGetter(gA = ["codeBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dataframeHeaderBackgroundColor", { get: $util.oneOfGetter(gA = ["dataframeHeaderBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redColor", { get: $util.oneOfGetter(gA = ["redColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeColor", { get: $util.oneOfGetter(gA = ["orangeColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowColor", { get: $util.oneOfGetter(gA = ["yellowColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueColor", { get: $util.oneOfGetter(gA = ["blueColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenColor", { get: $util.oneOfGetter(gA = ["greenColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetColor", { get: $util.oneOfGetter(gA = ["violetColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayColor", { get: $util.oneOfGetter(gA = ["grayColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redBackgroundColor", { get: $util.oneOfGetter(gA = ["redBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeBackgroundColor", { get: $util.oneOfGetter(gA = ["orangeBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowBackgroundColor", { get: $util.oneOfGetter(gA = ["yellowBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueBackgroundColor", { get: $util.oneOfGetter(gA = ["blueBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenBackgroundColor", { get: $util.oneOfGetter(gA = ["greenBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetBackgroundColor", { get: $util.oneOfGetter(gA = ["violetBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayBackgroundColor", { get: $util.oneOfGetter(gA = ["grayBackgroundColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_redTextColor", { get: $util.oneOfGetter(gA = ["redTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_orangeTextColor", { get: $util.oneOfGetter(gA = ["orangeTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_yellowTextColor", { get: $util.oneOfGetter(gA = ["yellowTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_blueTextColor", { get: $util.oneOfGetter(gA = ["blueTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_greenTextColor", { get: $util.oneOfGetter(gA = ["greenTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_violetTextColor", { get: $util.oneOfGetter(gA = ["violetTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_grayTextColor", { get: $util.oneOfGetter(gA = ["grayTextColor"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_metricValueFontSize", { get: $util.oneOfGetter(gA = ["metricValueFontSize"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_metricValueFontWeight", { get: $util.oneOfGetter(gA = ["metricValueFontWeight"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_sidebar", { get: $util.oneOfGetter(gA = ["sidebar"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_light", { get: $util.oneOfGetter(gA = ["light"]), set: $util.oneOfSetter(gA) }), Object.defineProperty(CA.prototype, "_dark", { get: $util.oneOfGetter(gA = ["dark"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    if (IA ||= $Writer.create(), AA.primaryColor != null && Object.hasOwnProperty.call(AA, "primaryColor") && IA.uint32(10).string(AA.primaryColor), AA.secondaryBackgroundColor != null && Object.hasOwnProperty.call(AA, "secondaryBackgroundColor") && IA.uint32(18).string(AA.secondaryBackgroundColor), AA.backgroundColor != null && Object.hasOwnProperty.call(AA, "backgroundColor") && IA.uint32(26).string(AA.backgroundColor), AA.textColor != null && Object.hasOwnProperty.call(AA, "textColor") && IA.uint32(34).string(AA.textColor), AA.base != null && Object.hasOwnProperty.call(AA, "base") && IA.uint32(48).int32(AA.base), AA.headingFont != null && Object.hasOwnProperty.call(AA, "headingFont") && IA.uint32(98).string(AA.headingFont), AA.bodyFont != null && Object.hasOwnProperty.call(AA, "bodyFont") && IA.uint32(106).string(AA.bodyFont), AA.codeFont != null && Object.hasOwnProperty.call(AA, "codeFont") && IA.uint32(114).string(AA.codeFont), AA.fontFaces != null && AA.fontFaces.length) for (let BA = 0; BA < AA.fontFaces.length; ++BA) $root.FontFace.encode(AA.fontFaces[BA], IA.uint32(122).fork()).ldelim();
    if (AA.baseRadius != null && Object.hasOwnProperty.call(AA, "baseRadius") && IA.uint32(146).string(AA.baseRadius), AA.borderColor != null && Object.hasOwnProperty.call(AA, "borderColor") && IA.uint32(154).string(AA.borderColor), AA.showWidgetBorder != null && Object.hasOwnProperty.call(AA, "showWidgetBorder") && IA.uint32(160).bool(AA.showWidgetBorder), AA.linkColor != null && Object.hasOwnProperty.call(AA, "linkColor") && IA.uint32(170).string(AA.linkColor), AA.baseFontSize != null && Object.hasOwnProperty.call(AA, "baseFontSize") && IA.uint32(176).int32(AA.baseFontSize), AA.showSidebarBorder != null && Object.hasOwnProperty.call(AA, "showSidebarBorder") && IA.uint32(184).bool(AA.showSidebarBorder), AA.sidebar != null && Object.hasOwnProperty.call(AA, "sidebar") && $root.CustomThemeConfig.encode(AA.sidebar, IA.uint32(194).fork()).ldelim(), AA.codeBackgroundColor != null && Object.hasOwnProperty.call(AA, "codeBackgroundColor") && IA.uint32(202).string(AA.codeBackgroundColor), AA.buttonRadius != null && Object.hasOwnProperty.call(AA, "buttonRadius") && IA.uint32(210).string(AA.buttonRadius), AA.dataframeBorderColor != null && Object.hasOwnProperty.call(AA, "dataframeBorderColor") && IA.uint32(218).string(AA.dataframeBorderColor), AA.codeFontSize != null && Object.hasOwnProperty.call(AA, "codeFontSize") && IA.uint32(226).string(AA.codeFontSize), AA.linkUnderline != null && Object.hasOwnProperty.call(AA, "linkUnderline") && IA.uint32(232).bool(AA.linkUnderline), AA.baseFontWeight != null && Object.hasOwnProperty.call(AA, "baseFontWeight") && IA.uint32(240).int32(AA.baseFontWeight), AA.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(AA, "dataframeHeaderBackgroundColor") && IA.uint32(250).string(AA.dataframeHeaderBackgroundColor), AA.codeFontWeight != null && Object.hasOwnProperty.call(AA, "codeFontWeight") && IA.uint32(256).int32(AA.codeFontWeight), AA.chartCategoricalColors != null && AA.chartCategoricalColors.length) for (let BA = 0; BA < AA.chartCategoricalColors.length; ++BA) IA.uint32(266).string(AA.chartCategoricalColors[BA]);
    if (AA.headingFontWeights != null && AA.headingFontWeights.length) {
      IA.uint32(274).fork();
      for (let BA = 0; BA < AA.headingFontWeights.length; ++BA) IA.int32(AA.headingFontWeights[BA]);
      IA.ldelim();
    }
    if (AA.headingFontSizes != null && AA.headingFontSizes.length) for (let BA = 0; BA < AA.headingFontSizes.length; ++BA) IA.uint32(282).string(AA.headingFontSizes[BA]);
    if (AA.chartSequentialColors != null && AA.chartSequentialColors.length) for (let BA = 0; BA < AA.chartSequentialColors.length; ++BA) IA.uint32(290).string(AA.chartSequentialColors[BA]);
    if (AA.fontSources != null && AA.fontSources.length) for (let BA = 0; BA < AA.fontSources.length; ++BA) $root.FontSource.encode(AA.fontSources[BA], IA.uint32(298).fork()).ldelim();
    if (AA.redColor != null && Object.hasOwnProperty.call(AA, "redColor") && IA.uint32(306).string(AA.redColor), AA.orangeColor != null && Object.hasOwnProperty.call(AA, "orangeColor") && IA.uint32(314).string(AA.orangeColor), AA.yellowColor != null && Object.hasOwnProperty.call(AA, "yellowColor") && IA.uint32(322).string(AA.yellowColor), AA.blueColor != null && Object.hasOwnProperty.call(AA, "blueColor") && IA.uint32(330).string(AA.blueColor), AA.greenColor != null && Object.hasOwnProperty.call(AA, "greenColor") && IA.uint32(338).string(AA.greenColor), AA.violetColor != null && Object.hasOwnProperty.call(AA, "violetColor") && IA.uint32(346).string(AA.violetColor), AA.grayColor != null && Object.hasOwnProperty.call(AA, "grayColor") && IA.uint32(354).string(AA.grayColor), AA.redBackgroundColor != null && Object.hasOwnProperty.call(AA, "redBackgroundColor") && IA.uint32(362).string(AA.redBackgroundColor), AA.orangeBackgroundColor != null && Object.hasOwnProperty.call(AA, "orangeBackgroundColor") && IA.uint32(370).string(AA.orangeBackgroundColor), AA.yellowBackgroundColor != null && Object.hasOwnProperty.call(AA, "yellowBackgroundColor") && IA.uint32(378).string(AA.yellowBackgroundColor), AA.blueBackgroundColor != null && Object.hasOwnProperty.call(AA, "blueBackgroundColor") && IA.uint32(386).string(AA.blueBackgroundColor), AA.greenBackgroundColor != null && Object.hasOwnProperty.call(AA, "greenBackgroundColor") && IA.uint32(394).string(AA.greenBackgroundColor), AA.violetBackgroundColor != null && Object.hasOwnProperty.call(AA, "violetBackgroundColor") && IA.uint32(402).string(AA.violetBackgroundColor), AA.grayBackgroundColor != null && Object.hasOwnProperty.call(AA, "grayBackgroundColor") && IA.uint32(410).string(AA.grayBackgroundColor), AA.redTextColor != null && Object.hasOwnProperty.call(AA, "redTextColor") && IA.uint32(418).string(AA.redTextColor), AA.orangeTextColor != null && Object.hasOwnProperty.call(AA, "orangeTextColor") && IA.uint32(426).string(AA.orangeTextColor), AA.yellowTextColor != null && Object.hasOwnProperty.call(AA, "yellowTextColor") && IA.uint32(434).string(AA.yellowTextColor), AA.blueTextColor != null && Object.hasOwnProperty.call(AA, "blueTextColor") && IA.uint32(442).string(AA.blueTextColor), AA.greenTextColor != null && Object.hasOwnProperty.call(AA, "greenTextColor") && IA.uint32(450).string(AA.greenTextColor), AA.violetTextColor != null && Object.hasOwnProperty.call(AA, "violetTextColor") && IA.uint32(458).string(AA.violetTextColor), AA.grayTextColor != null && Object.hasOwnProperty.call(AA, "grayTextColor") && IA.uint32(466).string(AA.grayTextColor), AA.codeTextColor != null && Object.hasOwnProperty.call(AA, "codeTextColor") && IA.uint32(474).string(AA.codeTextColor), AA.light != null && Object.hasOwnProperty.call(AA, "light") && $root.CustomThemeConfig.encode(AA.light, IA.uint32(482).fork()).ldelim(), AA.dark != null && Object.hasOwnProperty.call(AA, "dark") && $root.CustomThemeConfig.encode(AA.dark, IA.uint32(490).fork()).ldelim(), AA.chartDivergingColors != null && AA.chartDivergingColors.length) for (let BA = 0; BA < AA.chartDivergingColors.length; ++BA) IA.uint32(498).string(AA.chartDivergingColors[BA]);
    return AA.metricValueFontSize != null && Object.hasOwnProperty.call(AA, "metricValueFontSize") && IA.uint32(514).string(AA.metricValueFontSize), AA.metricValueFontWeight != null && Object.hasOwnProperty.call(AA, "metricValueFontWeight") && IA.uint32(520).int32(AA.metricValueFontWeight), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.CustomThemeConfig();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.primaryColor = AA.string();
          break;
        case 2:
          EA.secondaryBackgroundColor = AA.string();
          break;
        case 3:
          EA.backgroundColor = AA.string();
          break;
        case 4:
          EA.textColor = AA.string();
          break;
        case 6:
          EA.base = AA.int32();
          break;
        case 12:
          EA.headingFont = AA.string();
          break;
        case 13:
          EA.bodyFont = AA.string();
          break;
        case 14:
          EA.codeFont = AA.string();
          break;
        case 15:
          EA.fontFaces && EA.fontFaces.length || (EA.fontFaces = []), EA.fontFaces.push($root.FontFace.decode(AA, AA.uint32()));
          break;
        case 37:
          EA.fontSources && EA.fontSources.length || (EA.fontSources = []), EA.fontSources.push($root.FontSource.decode(AA, AA.uint32()));
          break;
        case 18:
          EA.baseRadius = AA.string();
          break;
        case 26:
          EA.buttonRadius = AA.string();
          break;
        case 19:
          EA.borderColor = AA.string();
          break;
        case 27:
          EA.dataframeBorderColor = AA.string();
          break;
        case 20:
          EA.showWidgetBorder = AA.bool();
          break;
        case 21:
          EA.linkColor = AA.string();
          break;
        case 29:
          EA.linkUnderline = AA.bool();
          break;
        case 22:
          EA.baseFontSize = AA.int32();
          break;
        case 30:
          EA.baseFontWeight = AA.int32();
          break;
        case 32:
          EA.codeFontWeight = AA.int32();
          break;
        case 28:
          EA.codeFontSize = AA.string();
          break;
        case 35:
          EA.headingFontSizes && EA.headingFontSizes.length || (EA.headingFontSizes = []), EA.headingFontSizes.push(AA.string());
          break;
        case 34:
          if (EA.headingFontWeights && EA.headingFontWeights.length || (EA.headingFontWeights = []), (iA & 7) == 2) {
            let oA = AA.uint32() + AA.pos;
            for (; AA.pos < oA; ) EA.headingFontWeights.push(AA.int32());
          } else EA.headingFontWeights.push(AA.int32());
          break;
        case 23:
          EA.showSidebarBorder = AA.bool();
          break;
        case 59:
          EA.codeTextColor = AA.string();
          break;
        case 25:
          EA.codeBackgroundColor = AA.string();
          break;
        case 31:
          EA.dataframeHeaderBackgroundColor = AA.string();
          break;
        case 33:
          EA.chartCategoricalColors && EA.chartCategoricalColors.length || (EA.chartCategoricalColors = []), EA.chartCategoricalColors.push(AA.string());
          break;
        case 36:
          EA.chartSequentialColors && EA.chartSequentialColors.length || (EA.chartSequentialColors = []), EA.chartSequentialColors.push(AA.string());
          break;
        case 62:
          EA.chartDivergingColors && EA.chartDivergingColors.length || (EA.chartDivergingColors = []), EA.chartDivergingColors.push(AA.string());
          break;
        case 38:
          EA.redColor = AA.string();
          break;
        case 39:
          EA.orangeColor = AA.string();
          break;
        case 40:
          EA.yellowColor = AA.string();
          break;
        case 41:
          EA.blueColor = AA.string();
          break;
        case 42:
          EA.greenColor = AA.string();
          break;
        case 43:
          EA.violetColor = AA.string();
          break;
        case 44:
          EA.grayColor = AA.string();
          break;
        case 45:
          EA.redBackgroundColor = AA.string();
          break;
        case 46:
          EA.orangeBackgroundColor = AA.string();
          break;
        case 47:
          EA.yellowBackgroundColor = AA.string();
          break;
        case 48:
          EA.blueBackgroundColor = AA.string();
          break;
        case 49:
          EA.greenBackgroundColor = AA.string();
          break;
        case 50:
          EA.violetBackgroundColor = AA.string();
          break;
        case 51:
          EA.grayBackgroundColor = AA.string();
          break;
        case 52:
          EA.redTextColor = AA.string();
          break;
        case 53:
          EA.orangeTextColor = AA.string();
          break;
        case 54:
          EA.yellowTextColor = AA.string();
          break;
        case 55:
          EA.blueTextColor = AA.string();
          break;
        case 56:
          EA.greenTextColor = AA.string();
          break;
        case 57:
          EA.violetTextColor = AA.string();
          break;
        case 58:
          EA.grayTextColor = AA.string();
          break;
        case 64:
          EA.metricValueFontSize = AA.string();
          break;
        case 65:
          EA.metricValueFontWeight = AA.int32();
          break;
        case 24:
          EA.sidebar = $root.CustomThemeConfig.decode(AA, AA.uint32());
          break;
        case 60:
          EA.light = $root.CustomThemeConfig.decode(AA, AA.uint32());
          break;
        case 61:
          EA.dark = $root.CustomThemeConfig.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.CustomThemeConfig) return AA;
    let IA = new $root.CustomThemeConfig();
    switch (AA.primaryColor != null && (IA.primaryColor = String(AA.primaryColor)), AA.secondaryBackgroundColor != null && (IA.secondaryBackgroundColor = String(AA.secondaryBackgroundColor)), AA.backgroundColor != null && (IA.backgroundColor = String(AA.backgroundColor)), AA.textColor != null && (IA.textColor = String(AA.textColor)), AA.base) {
      default:
        if (typeof AA.base == "number") {
          IA.base = AA.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        IA.base = 0;
        break;
      case "DARK":
      case 1:
        IA.base = 1;
        break;
    }
    if (AA.headingFont != null && (IA.headingFont = String(AA.headingFont)), AA.bodyFont != null && (IA.bodyFont = String(AA.bodyFont)), AA.codeFont != null && (IA.codeFont = String(AA.codeFont)), AA.fontFaces) {
      if (!Array.isArray(AA.fontFaces)) throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      IA.fontFaces = [];
      for (let BA = 0; BA < AA.fontFaces.length; ++BA) {
        if (typeof AA.fontFaces[BA] != "object") throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        IA.fontFaces[BA] = $root.FontFace.fromObject(AA.fontFaces[BA]);
      }
    }
    if (AA.fontSources) {
      if (!Array.isArray(AA.fontSources)) throw TypeError(".CustomThemeConfig.fontSources: array expected");
      IA.fontSources = [];
      for (let BA = 0; BA < AA.fontSources.length; ++BA) {
        if (typeof AA.fontSources[BA] != "object") throw TypeError(".CustomThemeConfig.fontSources: object expected");
        IA.fontSources[BA] = $root.FontSource.fromObject(AA.fontSources[BA]);
      }
    }
    if (AA.baseRadius != null && (IA.baseRadius = String(AA.baseRadius)), AA.buttonRadius != null && (IA.buttonRadius = String(AA.buttonRadius)), AA.borderColor != null && (IA.borderColor = String(AA.borderColor)), AA.dataframeBorderColor != null && (IA.dataframeBorderColor = String(AA.dataframeBorderColor)), AA.showWidgetBorder != null && (IA.showWidgetBorder = !!AA.showWidgetBorder), AA.linkColor != null && (IA.linkColor = String(AA.linkColor)), AA.linkUnderline != null && (IA.linkUnderline = !!AA.linkUnderline), AA.baseFontSize != null && (IA.baseFontSize = AA.baseFontSize | 0), AA.baseFontWeight != null && (IA.baseFontWeight = AA.baseFontWeight | 0), AA.codeFontWeight != null && (IA.codeFontWeight = AA.codeFontWeight | 0), AA.codeFontSize != null && (IA.codeFontSize = String(AA.codeFontSize)), AA.headingFontSizes) {
      if (!Array.isArray(AA.headingFontSizes)) throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      IA.headingFontSizes = [];
      for (let BA = 0; BA < AA.headingFontSizes.length; ++BA) IA.headingFontSizes[BA] = String(AA.headingFontSizes[BA]);
    }
    if (AA.headingFontWeights) {
      if (!Array.isArray(AA.headingFontWeights)) throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      IA.headingFontWeights = [];
      for (let BA = 0; BA < AA.headingFontWeights.length; ++BA) IA.headingFontWeights[BA] = AA.headingFontWeights[BA] | 0;
    }
    if (AA.showSidebarBorder != null && (IA.showSidebarBorder = !!AA.showSidebarBorder), AA.codeTextColor != null && (IA.codeTextColor = String(AA.codeTextColor)), AA.codeBackgroundColor != null && (IA.codeBackgroundColor = String(AA.codeBackgroundColor)), AA.dataframeHeaderBackgroundColor != null && (IA.dataframeHeaderBackgroundColor = String(AA.dataframeHeaderBackgroundColor)), AA.chartCategoricalColors) {
      if (!Array.isArray(AA.chartCategoricalColors)) throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      IA.chartCategoricalColors = [];
      for (let BA = 0; BA < AA.chartCategoricalColors.length; ++BA) IA.chartCategoricalColors[BA] = String(AA.chartCategoricalColors[BA]);
    }
    if (AA.chartSequentialColors) {
      if (!Array.isArray(AA.chartSequentialColors)) throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      IA.chartSequentialColors = [];
      for (let BA = 0; BA < AA.chartSequentialColors.length; ++BA) IA.chartSequentialColors[BA] = String(AA.chartSequentialColors[BA]);
    }
    if (AA.chartDivergingColors) {
      if (!Array.isArray(AA.chartDivergingColors)) throw TypeError(".CustomThemeConfig.chartDivergingColors: array expected");
      IA.chartDivergingColors = [];
      for (let BA = 0; BA < AA.chartDivergingColors.length; ++BA) IA.chartDivergingColors[BA] = String(AA.chartDivergingColors[BA]);
    }
    if (AA.redColor != null && (IA.redColor = String(AA.redColor)), AA.orangeColor != null && (IA.orangeColor = String(AA.orangeColor)), AA.yellowColor != null && (IA.yellowColor = String(AA.yellowColor)), AA.blueColor != null && (IA.blueColor = String(AA.blueColor)), AA.greenColor != null && (IA.greenColor = String(AA.greenColor)), AA.violetColor != null && (IA.violetColor = String(AA.violetColor)), AA.grayColor != null && (IA.grayColor = String(AA.grayColor)), AA.redBackgroundColor != null && (IA.redBackgroundColor = String(AA.redBackgroundColor)), AA.orangeBackgroundColor != null && (IA.orangeBackgroundColor = String(AA.orangeBackgroundColor)), AA.yellowBackgroundColor != null && (IA.yellowBackgroundColor = String(AA.yellowBackgroundColor)), AA.blueBackgroundColor != null && (IA.blueBackgroundColor = String(AA.blueBackgroundColor)), AA.greenBackgroundColor != null && (IA.greenBackgroundColor = String(AA.greenBackgroundColor)), AA.violetBackgroundColor != null && (IA.violetBackgroundColor = String(AA.violetBackgroundColor)), AA.grayBackgroundColor != null && (IA.grayBackgroundColor = String(AA.grayBackgroundColor)), AA.redTextColor != null && (IA.redTextColor = String(AA.redTextColor)), AA.orangeTextColor != null && (IA.orangeTextColor = String(AA.orangeTextColor)), AA.yellowTextColor != null && (IA.yellowTextColor = String(AA.yellowTextColor)), AA.blueTextColor != null && (IA.blueTextColor = String(AA.blueTextColor)), AA.greenTextColor != null && (IA.greenTextColor = String(AA.greenTextColor)), AA.violetTextColor != null && (IA.violetTextColor = String(AA.violetTextColor)), AA.grayTextColor != null && (IA.grayTextColor = String(AA.grayTextColor)), AA.metricValueFontSize != null && (IA.metricValueFontSize = String(AA.metricValueFontSize)), AA.metricValueFontWeight != null && (IA.metricValueFontWeight = AA.metricValueFontWeight | 0), AA.sidebar != null) {
      if (typeof AA.sidebar != "object") throw TypeError(".CustomThemeConfig.sidebar: object expected");
      IA.sidebar = $root.CustomThemeConfig.fromObject(AA.sidebar);
    }
    if (AA.light != null) {
      if (typeof AA.light != "object") throw TypeError(".CustomThemeConfig.light: object expected");
      IA.light = $root.CustomThemeConfig.fromObject(AA.light);
    }
    if (AA.dark != null) {
      if (typeof AA.dark != "object") throw TypeError(".CustomThemeConfig.dark: object expected");
      IA.dark = $root.CustomThemeConfig.fromObject(AA.dark);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    if ((IA.arrays || IA.defaults) && (BA.fontFaces = [], BA.chartCategoricalColors = [], BA.headingFontWeights = [], BA.headingFontSizes = [], BA.chartSequentialColors = [], BA.fontSources = [], BA.chartDivergingColors = []), IA.defaults && (BA.primaryColor = "", BA.secondaryBackgroundColor = "", BA.backgroundColor = "", BA.textColor = "", BA.base = IA.enums === String ? "LIGHT" : 0, BA.headingFont = "", BA.bodyFont = "", BA.codeFont = ""), AA.primaryColor != null && AA.hasOwnProperty("primaryColor") && (BA.primaryColor = AA.primaryColor), AA.secondaryBackgroundColor != null && AA.hasOwnProperty("secondaryBackgroundColor") && (BA.secondaryBackgroundColor = AA.secondaryBackgroundColor), AA.backgroundColor != null && AA.hasOwnProperty("backgroundColor") && (BA.backgroundColor = AA.backgroundColor), AA.textColor != null && AA.hasOwnProperty("textColor") && (BA.textColor = AA.textColor), AA.base != null && AA.hasOwnProperty("base") && (BA.base = IA.enums === String ? $root.CustomThemeConfig.BaseTheme[AA.base] === void 0 ? AA.base : $root.CustomThemeConfig.BaseTheme[AA.base] : AA.base), AA.headingFont != null && AA.hasOwnProperty("headingFont") && (BA.headingFont = AA.headingFont), AA.bodyFont != null && AA.hasOwnProperty("bodyFont") && (BA.bodyFont = AA.bodyFont), AA.codeFont != null && AA.hasOwnProperty("codeFont") && (BA.codeFont = AA.codeFont), AA.fontFaces && AA.fontFaces.length) {
      BA.fontFaces = [];
      for (let QA = 0; QA < AA.fontFaces.length; ++QA) BA.fontFaces[QA] = $root.FontFace.toObject(AA.fontFaces[QA], IA);
    }
    if (AA.baseRadius != null && AA.hasOwnProperty("baseRadius") && (BA.baseRadius = AA.baseRadius, IA.oneofs && (BA._baseRadius = "baseRadius")), AA.borderColor != null && AA.hasOwnProperty("borderColor") && (BA.borderColor = AA.borderColor, IA.oneofs && (BA._borderColor = "borderColor")), AA.showWidgetBorder != null && AA.hasOwnProperty("showWidgetBorder") && (BA.showWidgetBorder = AA.showWidgetBorder, IA.oneofs && (BA._showWidgetBorder = "showWidgetBorder")), AA.linkColor != null && AA.hasOwnProperty("linkColor") && (BA.linkColor = AA.linkColor, IA.oneofs && (BA._linkColor = "linkColor")), AA.baseFontSize != null && AA.hasOwnProperty("baseFontSize") && (BA.baseFontSize = AA.baseFontSize, IA.oneofs && (BA._baseFontSize = "baseFontSize")), AA.showSidebarBorder != null && AA.hasOwnProperty("showSidebarBorder") && (BA.showSidebarBorder = AA.showSidebarBorder, IA.oneofs && (BA._showSidebarBorder = "showSidebarBorder")), AA.sidebar != null && AA.hasOwnProperty("sidebar") && (BA.sidebar = $root.CustomThemeConfig.toObject(AA.sidebar, IA), IA.oneofs && (BA._sidebar = "sidebar")), AA.codeBackgroundColor != null && AA.hasOwnProperty("codeBackgroundColor") && (BA.codeBackgroundColor = AA.codeBackgroundColor, IA.oneofs && (BA._codeBackgroundColor = "codeBackgroundColor")), AA.buttonRadius != null && AA.hasOwnProperty("buttonRadius") && (BA.buttonRadius = AA.buttonRadius, IA.oneofs && (BA._buttonRadius = "buttonRadius")), AA.dataframeBorderColor != null && AA.hasOwnProperty("dataframeBorderColor") && (BA.dataframeBorderColor = AA.dataframeBorderColor, IA.oneofs && (BA._dataframeBorderColor = "dataframeBorderColor")), AA.codeFontSize != null && AA.hasOwnProperty("codeFontSize") && (BA.codeFontSize = AA.codeFontSize, IA.oneofs && (BA._codeFontSize = "codeFontSize")), AA.linkUnderline != null && AA.hasOwnProperty("linkUnderline") && (BA.linkUnderline = AA.linkUnderline, IA.oneofs && (BA._linkUnderline = "linkUnderline")), AA.baseFontWeight != null && AA.hasOwnProperty("baseFontWeight") && (BA.baseFontWeight = AA.baseFontWeight, IA.oneofs && (BA._baseFontWeight = "baseFontWeight")), AA.dataframeHeaderBackgroundColor != null && AA.hasOwnProperty("dataframeHeaderBackgroundColor") && (BA.dataframeHeaderBackgroundColor = AA.dataframeHeaderBackgroundColor, IA.oneofs && (BA._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), AA.codeFontWeight != null && AA.hasOwnProperty("codeFontWeight") && (BA.codeFontWeight = AA.codeFontWeight, IA.oneofs && (BA._codeFontWeight = "codeFontWeight")), AA.chartCategoricalColors && AA.chartCategoricalColors.length) {
      BA.chartCategoricalColors = [];
      for (let QA = 0; QA < AA.chartCategoricalColors.length; ++QA) BA.chartCategoricalColors[QA] = AA.chartCategoricalColors[QA];
    }
    if (AA.headingFontWeights && AA.headingFontWeights.length) {
      BA.headingFontWeights = [];
      for (let QA = 0; QA < AA.headingFontWeights.length; ++QA) BA.headingFontWeights[QA] = AA.headingFontWeights[QA];
    }
    if (AA.headingFontSizes && AA.headingFontSizes.length) {
      BA.headingFontSizes = [];
      for (let QA = 0; QA < AA.headingFontSizes.length; ++QA) BA.headingFontSizes[QA] = AA.headingFontSizes[QA];
    }
    if (AA.chartSequentialColors && AA.chartSequentialColors.length) {
      BA.chartSequentialColors = [];
      for (let QA = 0; QA < AA.chartSequentialColors.length; ++QA) BA.chartSequentialColors[QA] = AA.chartSequentialColors[QA];
    }
    if (AA.fontSources && AA.fontSources.length) {
      BA.fontSources = [];
      for (let QA = 0; QA < AA.fontSources.length; ++QA) BA.fontSources[QA] = $root.FontSource.toObject(AA.fontSources[QA], IA);
    }
    if (AA.redColor != null && AA.hasOwnProperty("redColor") && (BA.redColor = AA.redColor, IA.oneofs && (BA._redColor = "redColor")), AA.orangeColor != null && AA.hasOwnProperty("orangeColor") && (BA.orangeColor = AA.orangeColor, IA.oneofs && (BA._orangeColor = "orangeColor")), AA.yellowColor != null && AA.hasOwnProperty("yellowColor") && (BA.yellowColor = AA.yellowColor, IA.oneofs && (BA._yellowColor = "yellowColor")), AA.blueColor != null && AA.hasOwnProperty("blueColor") && (BA.blueColor = AA.blueColor, IA.oneofs && (BA._blueColor = "blueColor")), AA.greenColor != null && AA.hasOwnProperty("greenColor") && (BA.greenColor = AA.greenColor, IA.oneofs && (BA._greenColor = "greenColor")), AA.violetColor != null && AA.hasOwnProperty("violetColor") && (BA.violetColor = AA.violetColor, IA.oneofs && (BA._violetColor = "violetColor")), AA.grayColor != null && AA.hasOwnProperty("grayColor") && (BA.grayColor = AA.grayColor, IA.oneofs && (BA._grayColor = "grayColor")), AA.redBackgroundColor != null && AA.hasOwnProperty("redBackgroundColor") && (BA.redBackgroundColor = AA.redBackgroundColor, IA.oneofs && (BA._redBackgroundColor = "redBackgroundColor")), AA.orangeBackgroundColor != null && AA.hasOwnProperty("orangeBackgroundColor") && (BA.orangeBackgroundColor = AA.orangeBackgroundColor, IA.oneofs && (BA._orangeBackgroundColor = "orangeBackgroundColor")), AA.yellowBackgroundColor != null && AA.hasOwnProperty("yellowBackgroundColor") && (BA.yellowBackgroundColor = AA.yellowBackgroundColor, IA.oneofs && (BA._yellowBackgroundColor = "yellowBackgroundColor")), AA.blueBackgroundColor != null && AA.hasOwnProperty("blueBackgroundColor") && (BA.blueBackgroundColor = AA.blueBackgroundColor, IA.oneofs && (BA._blueBackgroundColor = "blueBackgroundColor")), AA.greenBackgroundColor != null && AA.hasOwnProperty("greenBackgroundColor") && (BA.greenBackgroundColor = AA.greenBackgroundColor, IA.oneofs && (BA._greenBackgroundColor = "greenBackgroundColor")), AA.violetBackgroundColor != null && AA.hasOwnProperty("violetBackgroundColor") && (BA.violetBackgroundColor = AA.violetBackgroundColor, IA.oneofs && (BA._violetBackgroundColor = "violetBackgroundColor")), AA.grayBackgroundColor != null && AA.hasOwnProperty("grayBackgroundColor") && (BA.grayBackgroundColor = AA.grayBackgroundColor, IA.oneofs && (BA._grayBackgroundColor = "grayBackgroundColor")), AA.redTextColor != null && AA.hasOwnProperty("redTextColor") && (BA.redTextColor = AA.redTextColor, IA.oneofs && (BA._redTextColor = "redTextColor")), AA.orangeTextColor != null && AA.hasOwnProperty("orangeTextColor") && (BA.orangeTextColor = AA.orangeTextColor, IA.oneofs && (BA._orangeTextColor = "orangeTextColor")), AA.yellowTextColor != null && AA.hasOwnProperty("yellowTextColor") && (BA.yellowTextColor = AA.yellowTextColor, IA.oneofs && (BA._yellowTextColor = "yellowTextColor")), AA.blueTextColor != null && AA.hasOwnProperty("blueTextColor") && (BA.blueTextColor = AA.blueTextColor, IA.oneofs && (BA._blueTextColor = "blueTextColor")), AA.greenTextColor != null && AA.hasOwnProperty("greenTextColor") && (BA.greenTextColor = AA.greenTextColor, IA.oneofs && (BA._greenTextColor = "greenTextColor")), AA.violetTextColor != null && AA.hasOwnProperty("violetTextColor") && (BA.violetTextColor = AA.violetTextColor, IA.oneofs && (BA._violetTextColor = "violetTextColor")), AA.grayTextColor != null && AA.hasOwnProperty("grayTextColor") && (BA.grayTextColor = AA.grayTextColor, IA.oneofs && (BA._grayTextColor = "grayTextColor")), AA.codeTextColor != null && AA.hasOwnProperty("codeTextColor") && (BA.codeTextColor = AA.codeTextColor, IA.oneofs && (BA._codeTextColor = "codeTextColor")), AA.light != null && AA.hasOwnProperty("light") && (BA.light = $root.CustomThemeConfig.toObject(AA.light, IA), IA.oneofs && (BA._light = "light")), AA.dark != null && AA.hasOwnProperty("dark") && (BA.dark = $root.CustomThemeConfig.toObject(AA.dark, IA), IA.oneofs && (BA._dark = "dark")), AA.chartDivergingColors && AA.chartDivergingColors.length) {
      BA.chartDivergingColors = [];
      for (let QA = 0; QA < AA.chartDivergingColors.length; ++QA) BA.chartDivergingColors[QA] = AA.chartDivergingColors[QA];
    }
    return AA.metricValueFontSize != null && AA.hasOwnProperty("metricValueFontSize") && (BA.metricValueFontSize = AA.metricValueFontSize, IA.oneofs && (BA._metricValueFontSize = "metricValueFontSize")), AA.metricValueFontWeight != null && AA.hasOwnProperty("metricValueFontWeight") && (BA.metricValueFontWeight = AA.metricValueFontWeight, IA.oneofs && (BA._metricValueFontWeight = "metricValueFontWeight")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/CustomThemeConfig";
  }, CA.BaseTheme = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "LIGHT"] = 0, IA[AA[1] = "DARK"] = 1, IA;
  })(), CA;
})();
$root.FontFace = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.url = "", CA.prototype.family = "", CA.prototype.weightRange = "", CA.prototype.style = "", CA.prototype.unicodeRange = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.url != null && Object.hasOwnProperty.call(gA, "url") && AA.uint32(10).string(gA.url), gA.family != null && Object.hasOwnProperty.call(gA, "family") && AA.uint32(18).string(gA.family), gA.style != null && Object.hasOwnProperty.call(gA, "style") && AA.uint32(34).string(gA.style), gA.weightRange != null && Object.hasOwnProperty.call(gA, "weightRange") && AA.uint32(42).string(gA.weightRange), gA.unicodeRange != null && Object.hasOwnProperty.call(gA, "unicodeRange") && AA.uint32(50).string(gA.unicodeRange), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FontFace();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.url = gA.string();
          break;
        case 2:
          QA.family = gA.string();
          break;
        case 5:
          QA.weightRange = gA.string();
          break;
        case 4:
          QA.style = gA.string();
          break;
        case 6:
          QA.unicodeRange = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FontFace) return gA;
    let AA = new $root.FontFace();
    return gA.url != null && (AA.url = String(gA.url)), gA.family != null && (AA.family = String(gA.family)), gA.weightRange != null && (AA.weightRange = String(gA.weightRange)), gA.style != null && (AA.style = String(gA.style)), gA.unicodeRange != null && (AA.unicodeRange = String(gA.unicodeRange)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.url = "", IA.family = "", IA.style = "", IA.weightRange = "", IA.unicodeRange = ""), gA.url != null && gA.hasOwnProperty("url") && (IA.url = gA.url), gA.family != null && gA.hasOwnProperty("family") && (IA.family = gA.family), gA.style != null && gA.hasOwnProperty("style") && (IA.style = gA.style), gA.weightRange != null && gA.hasOwnProperty("weightRange") && (IA.weightRange = gA.weightRange), gA.unicodeRange != null && gA.hasOwnProperty("unicodeRange") && (IA.unicodeRange = gA.unicodeRange), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FontFace";
  }, CA;
})();
$root.FontSource = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.configName = "", CA.prototype.sourceUrl = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.configName != null && Object.hasOwnProperty.call(gA, "configName") && AA.uint32(10).string(gA.configName), gA.sourceUrl != null && Object.hasOwnProperty.call(gA, "sourceUrl") && AA.uint32(18).string(gA.sourceUrl), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.FontSource();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.configName = gA.string();
          break;
        case 2:
          QA.sourceUrl = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.FontSource) return gA;
    let AA = new $root.FontSource();
    return gA.configName != null && (AA.configName = String(gA.configName)), gA.sourceUrl != null && (AA.sourceUrl = String(gA.sourceUrl)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.configName = "", IA.sourceUrl = ""), gA.configName != null && gA.hasOwnProperty("configName") && (IA.configName = gA.configName), gA.sourceUrl != null && gA.hasOwnProperty("sourceUrl") && (IA.sourceUrl = gA.sourceUrl), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/FontSource";
  }, CA;
})();
$root.UserInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.installationId = "", CA.prototype.installationIdV3 = "", CA.prototype.installationIdV4 = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.installationId != null && Object.hasOwnProperty.call(gA, "installationId") && AA.uint32(10).string(gA.installationId), gA.installationIdV3 != null && Object.hasOwnProperty.call(gA, "installationIdV3") && AA.uint32(42).string(gA.installationIdV3), gA.installationIdV4 != null && Object.hasOwnProperty.call(gA, "installationIdV4") && AA.uint32(50).string(gA.installationIdV4), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.UserInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.installationId = gA.string();
          break;
        case 5:
          QA.installationIdV3 = gA.string();
          break;
        case 6:
          QA.installationIdV4 = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.UserInfo) return gA;
    let AA = new $root.UserInfo();
    return gA.installationId != null && (AA.installationId = String(gA.installationId)), gA.installationIdV3 != null && (AA.installationIdV3 = String(gA.installationIdV3)), gA.installationIdV4 != null && (AA.installationIdV4 = String(gA.installationIdV4)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.installationId = "", IA.installationIdV3 = "", IA.installationIdV4 = ""), gA.installationId != null && gA.hasOwnProperty("installationId") && (IA.installationId = gA.installationId), gA.installationIdV3 != null && gA.hasOwnProperty("installationIdV3") && (IA.installationIdV3 = gA.installationIdV3), gA.installationIdV4 != null && gA.hasOwnProperty("installationIdV4") && (IA.installationIdV4 = gA.installationIdV4), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/UserInfo";
  }, CA;
})();
$root.EnvironmentInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.streamlitVersion = "", CA.prototype.pythonVersion = "", CA.prototype.serverOs = "", CA.prototype.hasDisplay = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.streamlitVersion != null && Object.hasOwnProperty.call(gA, "streamlitVersion") && AA.uint32(10).string(gA.streamlitVersion), gA.pythonVersion != null && Object.hasOwnProperty.call(gA, "pythonVersion") && AA.uint32(18).string(gA.pythonVersion), gA.serverOs != null && Object.hasOwnProperty.call(gA, "serverOs") && AA.uint32(26).string(gA.serverOs), gA.hasDisplay != null && Object.hasOwnProperty.call(gA, "hasDisplay") && AA.uint32(32).bool(gA.hasDisplay), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.EnvironmentInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.streamlitVersion = gA.string();
          break;
        case 2:
          QA.pythonVersion = gA.string();
          break;
        case 3:
          QA.serverOs = gA.string();
          break;
        case 4:
          QA.hasDisplay = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.EnvironmentInfo) return gA;
    let AA = new $root.EnvironmentInfo();
    return gA.streamlitVersion != null && (AA.streamlitVersion = String(gA.streamlitVersion)), gA.pythonVersion != null && (AA.pythonVersion = String(gA.pythonVersion)), gA.serverOs != null && (AA.serverOs = String(gA.serverOs)), gA.hasDisplay != null && (AA.hasDisplay = !!gA.hasDisplay), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.streamlitVersion = "", IA.pythonVersion = "", IA.serverOs = "", IA.hasDisplay = !1), gA.streamlitVersion != null && gA.hasOwnProperty("streamlitVersion") && (IA.streamlitVersion = gA.streamlitVersion), gA.pythonVersion != null && gA.hasOwnProperty("pythonVersion") && (IA.pythonVersion = gA.pythonVersion), gA.serverOs != null && gA.hasOwnProperty("serverOs") && (IA.serverOs = gA.serverOs), gA.hasDisplay != null && gA.hasOwnProperty("hasDisplay") && (IA.hasDisplay = gA.hasDisplay), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/EnvironmentInfo";
  }, CA;
})();
$root.SessionStatus = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.runOnSave = !1, CA.prototype.scriptIsRunning = !1, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.runOnSave != null && Object.hasOwnProperty.call(gA, "runOnSave") && AA.uint32(8).bool(gA.runOnSave), gA.scriptIsRunning != null && Object.hasOwnProperty.call(gA, "scriptIsRunning") && AA.uint32(16).bool(gA.scriptIsRunning), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.SessionStatus();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.runOnSave = gA.bool();
          break;
        case 2:
          QA.scriptIsRunning = gA.bool();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.SessionStatus) return gA;
    let AA = new $root.SessionStatus();
    return gA.runOnSave != null && (AA.runOnSave = !!gA.runOnSave), gA.scriptIsRunning != null && (AA.scriptIsRunning = !!gA.scriptIsRunning), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.runOnSave = !1, IA.scriptIsRunning = !1), gA.runOnSave != null && gA.hasOwnProperty("runOnSave") && (IA.runOnSave = gA.runOnSave), gA.scriptIsRunning != null && gA.hasOwnProperty("scriptIsRunning") && (IA.scriptIsRunning = gA.scriptIsRunning), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/SessionStatus";
  }, CA;
})();
$root.PageConfig = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.title = "", CA.prototype.favicon = "", CA.prototype.layout = 0, CA.prototype.initialSidebarState = 0, CA.prototype.menuItems = null, CA.prototype.initialSidebarWidth = null;
  let gA;
  return Object.defineProperty(CA.prototype, "_initialSidebarWidth", { get: $util.oneOfGetter(gA = ["initialSidebarWidth"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.title != null && Object.hasOwnProperty.call(AA, "title") && IA.uint32(10).string(AA.title), AA.favicon != null && Object.hasOwnProperty.call(AA, "favicon") && IA.uint32(18).string(AA.favicon), AA.layout != null && Object.hasOwnProperty.call(AA, "layout") && IA.uint32(24).int32(AA.layout), AA.initialSidebarState != null && Object.hasOwnProperty.call(AA, "initialSidebarState") && IA.uint32(32).int32(AA.initialSidebarState), AA.menuItems != null && Object.hasOwnProperty.call(AA, "menuItems") && $root.PageConfig.MenuItems.encode(AA.menuItems, IA.uint32(42).fork()).ldelim(), AA.initialSidebarWidth != null && Object.hasOwnProperty.call(AA, "initialSidebarWidth") && $root.PageConfig.SidebarWidthConfig.encode(AA.initialSidebarWidth, IA.uint32(50).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.PageConfig();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.title = AA.string();
          break;
        case 2:
          EA.favicon = AA.string();
          break;
        case 3:
          EA.layout = AA.int32();
          break;
        case 4:
          EA.initialSidebarState = AA.int32();
          break;
        case 5:
          EA.menuItems = $root.PageConfig.MenuItems.decode(AA, AA.uint32());
          break;
        case 6:
          EA.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.PageConfig) return AA;
    let IA = new $root.PageConfig();
    switch (AA.title != null && (IA.title = String(AA.title)), AA.favicon != null && (IA.favicon = String(AA.favicon)), AA.layout) {
      default:
        if (typeof AA.layout == "number") {
          IA.layout = AA.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        IA.layout = 0;
        break;
      case "WIDE":
      case 1:
        IA.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        IA.layout = 2;
        break;
    }
    switch (AA.initialSidebarState) {
      default:
        if (typeof AA.initialSidebarState == "number") {
          IA.initialSidebarState = AA.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        IA.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        IA.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        IA.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        IA.initialSidebarState = 3;
        break;
    }
    if (AA.menuItems != null) {
      if (typeof AA.menuItems != "object") throw TypeError(".PageConfig.menuItems: object expected");
      IA.menuItems = $root.PageConfig.MenuItems.fromObject(AA.menuItems);
    }
    if (AA.initialSidebarWidth != null) {
      if (typeof AA.initialSidebarWidth != "object") throw TypeError(".PageConfig.initialSidebarWidth: object expected");
      IA.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.fromObject(AA.initialSidebarWidth);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return IA.defaults && (BA.title = "", BA.favicon = "", BA.layout = IA.enums === String ? "CENTERED" : 0, BA.initialSidebarState = IA.enums === String ? "AUTO" : 0, BA.menuItems = null), AA.title != null && AA.hasOwnProperty("title") && (BA.title = AA.title), AA.favicon != null && AA.hasOwnProperty("favicon") && (BA.favicon = AA.favicon), AA.layout != null && AA.hasOwnProperty("layout") && (BA.layout = IA.enums === String ? $root.PageConfig.Layout[AA.layout] === void 0 ? AA.layout : $root.PageConfig.Layout[AA.layout] : AA.layout), AA.initialSidebarState != null && AA.hasOwnProperty("initialSidebarState") && (BA.initialSidebarState = IA.enums === String ? $root.PageConfig.SidebarState[AA.initialSidebarState] === void 0 ? AA.initialSidebarState : $root.PageConfig.SidebarState[AA.initialSidebarState] : AA.initialSidebarState), AA.menuItems != null && AA.hasOwnProperty("menuItems") && (BA.menuItems = $root.PageConfig.MenuItems.toObject(AA.menuItems, IA)), AA.initialSidebarWidth != null && AA.hasOwnProperty("initialSidebarWidth") && (BA.initialSidebarWidth = $root.PageConfig.SidebarWidthConfig.toObject(AA.initialSidebarWidth, IA), IA.oneofs && (BA._initialSidebarWidth = "initialSidebarWidth")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/PageConfig";
  }, CA.MenuItems = (function() {
    function AA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    return AA.prototype.getHelpUrl = "", AA.prototype.hideGetHelp = !1, AA.prototype.reportABugUrl = "", AA.prototype.hideReportABug = !1, AA.prototype.aboutSectionMd = "", AA.prototype.clearAboutMd = !1, AA.create = function(IA) {
      return new AA(IA);
    }, AA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.getHelpUrl != null && Object.hasOwnProperty.call(IA, "getHelpUrl") && BA.uint32(10).string(IA.getHelpUrl), IA.hideGetHelp != null && Object.hasOwnProperty.call(IA, "hideGetHelp") && BA.uint32(16).bool(IA.hideGetHelp), IA.reportABugUrl != null && Object.hasOwnProperty.call(IA, "reportABugUrl") && BA.uint32(26).string(IA.reportABugUrl), IA.hideReportABug != null && Object.hasOwnProperty.call(IA, "hideReportABug") && BA.uint32(32).bool(IA.hideReportABug), IA.aboutSectionMd != null && Object.hasOwnProperty.call(IA, "aboutSectionMd") && BA.uint32(42).string(IA.aboutSectionMd), IA.clearAboutMd != null && Object.hasOwnProperty.call(IA, "clearAboutMd") && BA.uint32(48).bool(IA.clearAboutMd), BA;
    }, AA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.PageConfig.MenuItems();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.getHelpUrl = IA.string();
            break;
          case 2:
            iA.hideGetHelp = IA.bool();
            break;
          case 3:
            iA.reportABugUrl = IA.string();
            break;
          case 4:
            iA.hideReportABug = IA.bool();
            break;
          case 5:
            iA.aboutSectionMd = IA.string();
            break;
          case 6:
            iA.clearAboutMd = IA.bool();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, AA.fromObject = function(IA) {
      if (IA instanceof $root.PageConfig.MenuItems) return IA;
      let BA = new $root.PageConfig.MenuItems();
      return IA.getHelpUrl != null && (BA.getHelpUrl = String(IA.getHelpUrl)), IA.hideGetHelp != null && (BA.hideGetHelp = !!IA.hideGetHelp), IA.reportABugUrl != null && (BA.reportABugUrl = String(IA.reportABugUrl)), IA.hideReportABug != null && (BA.hideReportABug = !!IA.hideReportABug), IA.aboutSectionMd != null && (BA.aboutSectionMd = String(IA.aboutSectionMd)), IA.clearAboutMd != null && (BA.clearAboutMd = !!IA.clearAboutMd), BA;
    }, AA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.getHelpUrl = "", QA.hideGetHelp = !1, QA.reportABugUrl = "", QA.hideReportABug = !1, QA.aboutSectionMd = "", QA.clearAboutMd = !1), IA.getHelpUrl != null && IA.hasOwnProperty("getHelpUrl") && (QA.getHelpUrl = IA.getHelpUrl), IA.hideGetHelp != null && IA.hasOwnProperty("hideGetHelp") && (QA.hideGetHelp = IA.hideGetHelp), IA.reportABugUrl != null && IA.hasOwnProperty("reportABugUrl") && (QA.reportABugUrl = IA.reportABugUrl), IA.hideReportABug != null && IA.hasOwnProperty("hideReportABug") && (QA.hideReportABug = IA.hideReportABug), IA.aboutSectionMd != null && IA.hasOwnProperty("aboutSectionMd") && (QA.aboutSectionMd = IA.aboutSectionMd), IA.clearAboutMd != null && IA.hasOwnProperty("clearAboutMd") && (QA.clearAboutMd = IA.clearAboutMd), QA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/PageConfig.MenuItems";
    }, AA;
  })(), CA.Layout = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "CENTERED"] = 0, IA[AA[1] = "WIDE"] = 1, IA[AA[2] = "LAYOUT_UNSET"] = 2, IA;
  })(), CA.SidebarState = (function() {
    let AA = {}, IA = Object.create(AA);
    return IA[AA[0] = "AUTO"] = 0, IA[AA[1] = "EXPANDED"] = 1, IA[AA[2] = "COLLAPSED"] = 2, IA[AA[3] = "SIDEBAR_UNSET"] = 3, IA;
  })(), CA.SidebarWidthConfig = (function() {
    function AA(BA) {
      if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
    }
    AA.prototype.pixelWidth = null;
    let IA;
    return Object.defineProperty(AA.prototype, "widthSpec", { get: $util.oneOfGetter(IA = ["pixelWidth"]), set: $util.oneOfSetter(IA) }), AA.create = function(BA) {
      return new AA(BA);
    }, AA.encode = function(BA, QA) {
      return QA ||= $Writer.create(), BA.pixelWidth != null && Object.hasOwnProperty.call(BA, "pixelWidth") && QA.uint32(8).uint32(BA.pixelWidth), QA;
    }, AA.decode = function(BA, QA, EA) {
      BA instanceof $Reader || (BA = $Reader.create(BA));
      let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.PageConfig.SidebarWidthConfig();
      for (; BA.pos < iA; ) {
        let cA = BA.uint32();
        if (cA === EA) break;
        cA >>> 3 === 1 ? oA.pixelWidth = BA.uint32() : BA.skipType(cA & 7);
      }
      return oA;
    }, AA.fromObject = function(BA) {
      if (BA instanceof $root.PageConfig.SidebarWidthConfig) return BA;
      let QA = new $root.PageConfig.SidebarWidthConfig();
      return BA.pixelWidth != null && (QA.pixelWidth = BA.pixelWidth >>> 0), QA;
    }, AA.toObject = function(BA, QA) {
      QA ||= {};
      let EA = {};
      return BA.pixelWidth != null && BA.hasOwnProperty("pixelWidth") && (EA.pixelWidth = BA.pixelWidth, QA.oneofs && (EA.widthSpec = "pixelWidth")), EA;
    }, AA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, AA.getTypeUrl = function(BA) {
      return BA === void 0 && (BA = "type.googleapis.com"), BA + "/PageConfig.SidebarWidthConfig";
    }, AA;
  })(), CA;
})();
$root.PageInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.queryString = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.queryString != null && Object.hasOwnProperty.call(gA, "queryString") && AA.uint32(10).string(gA.queryString), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.PageInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.queryString = gA.string() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.PageInfo) return gA;
    let AA = new $root.PageInfo();
    return gA.queryString != null && (AA.queryString = String(gA.queryString)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.queryString = ""), gA.queryString != null && gA.hasOwnProperty("queryString") && (IA.queryString = gA.queryString), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/PageInfo";
  }, CA;
})();
$root.PageNotFound = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.pageName = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.pageName != null && Object.hasOwnProperty.call(gA, "pageName") && AA.uint32(10).string(gA.pageName), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.PageNotFound();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.pageName = gA.string() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.PageNotFound) return gA;
    let AA = new $root.PageNotFound();
    return gA.pageName != null && (AA.pageName = String(gA.pageName)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.pageName = ""), gA.pageName != null && gA.hasOwnProperty("pageName") && (IA.pageName = gA.pageName), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/PageNotFound";
  }, CA;
})();
$root.PageProfile = (() => {
  function CA(gA) {
    if (this.commands = [], this.config = [], this.attributions = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.commands = $util.emptyArray, CA.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.config = $util.emptyArray, CA.prototype.uncaughtException = "", CA.prototype.attributions = $util.emptyArray, CA.prototype.os = "", CA.prototype.timezone = "", CA.prototype.headless = !1, CA.prototype.isFragmentRun = !1, CA.prototype.serverMode = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.commands != null && gA.commands.length) for (let IA = 0; IA < gA.commands.length; ++IA) $root.Command.encode(gA.commands[IA], AA.uint32(10).fork()).ldelim();
    if (gA.execTime != null && Object.hasOwnProperty.call(gA, "execTime") && AA.uint32(16).int64(gA.execTime), gA.prepTime != null && Object.hasOwnProperty.call(gA, "prepTime") && AA.uint32(24).int64(gA.prepTime), gA.config != null && gA.config.length) for (let IA = 0; IA < gA.config.length; ++IA) AA.uint32(42).string(gA.config[IA]);
    if (gA.uncaughtException != null && Object.hasOwnProperty.call(gA, "uncaughtException") && AA.uint32(50).string(gA.uncaughtException), gA.attributions != null && gA.attributions.length) for (let IA = 0; IA < gA.attributions.length; ++IA) AA.uint32(58).string(gA.attributions[IA]);
    return gA.os != null && Object.hasOwnProperty.call(gA, "os") && AA.uint32(66).string(gA.os), gA.timezone != null && Object.hasOwnProperty.call(gA, "timezone") && AA.uint32(74).string(gA.timezone), gA.headless != null && Object.hasOwnProperty.call(gA, "headless") && AA.uint32(80).bool(gA.headless), gA.isFragmentRun != null && Object.hasOwnProperty.call(gA, "isFragmentRun") && AA.uint32(88).bool(gA.isFragmentRun), gA.serverMode != null && Object.hasOwnProperty.call(gA, "serverMode") && AA.uint32(98).string(gA.serverMode), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.PageProfile();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.commands && QA.commands.length || (QA.commands = []), QA.commands.push($root.Command.decode(gA, gA.uint32()));
          break;
        case 2:
          QA.execTime = gA.int64();
          break;
        case 3:
          QA.prepTime = gA.int64();
          break;
        case 5:
          QA.config && QA.config.length || (QA.config = []), QA.config.push(gA.string());
          break;
        case 6:
          QA.uncaughtException = gA.string();
          break;
        case 7:
          QA.attributions && QA.attributions.length || (QA.attributions = []), QA.attributions.push(gA.string());
          break;
        case 8:
          QA.os = gA.string();
          break;
        case 9:
          QA.timezone = gA.string();
          break;
        case 10:
          QA.headless = gA.bool();
          break;
        case 11:
          QA.isFragmentRun = gA.bool();
          break;
        case 12:
          QA.serverMode = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.PageProfile) return gA;
    let AA = new $root.PageProfile();
    if (gA.commands) {
      if (!Array.isArray(gA.commands)) throw TypeError(".PageProfile.commands: array expected");
      AA.commands = [];
      for (let IA = 0; IA < gA.commands.length; ++IA) {
        if (typeof gA.commands[IA] != "object") throw TypeError(".PageProfile.commands: object expected");
        AA.commands[IA] = $root.Command.fromObject(gA.commands[IA]);
      }
    }
    if (gA.execTime != null && ($util.Long ? (AA.execTime = $util.Long.fromValue(gA.execTime)).unsigned = !1 : typeof gA.execTime == "string" ? AA.execTime = parseInt(gA.execTime, 10) : typeof gA.execTime == "number" ? AA.execTime = gA.execTime : typeof gA.execTime == "object" && (AA.execTime = new $util.LongBits(gA.execTime.low >>> 0, gA.execTime.high >>> 0).toNumber())), gA.prepTime != null && ($util.Long ? (AA.prepTime = $util.Long.fromValue(gA.prepTime)).unsigned = !1 : typeof gA.prepTime == "string" ? AA.prepTime = parseInt(gA.prepTime, 10) : typeof gA.prepTime == "number" ? AA.prepTime = gA.prepTime : typeof gA.prepTime == "object" && (AA.prepTime = new $util.LongBits(gA.prepTime.low >>> 0, gA.prepTime.high >>> 0).toNumber())), gA.config) {
      if (!Array.isArray(gA.config)) throw TypeError(".PageProfile.config: array expected");
      AA.config = [];
      for (let IA = 0; IA < gA.config.length; ++IA) AA.config[IA] = String(gA.config[IA]);
    }
    if (gA.uncaughtException != null && (AA.uncaughtException = String(gA.uncaughtException)), gA.attributions) {
      if (!Array.isArray(gA.attributions)) throw TypeError(".PageProfile.attributions: array expected");
      AA.attributions = [];
      for (let IA = 0; IA < gA.attributions.length; ++IA) AA.attributions[IA] = String(gA.attributions[IA]);
    }
    return gA.os != null && (AA.os = String(gA.os)), gA.timezone != null && (AA.timezone = String(gA.timezone)), gA.headless != null && (AA.headless = !!gA.headless), gA.isFragmentRun != null && (AA.isFragmentRun = !!gA.isFragmentRun), gA.serverMode != null && (AA.serverMode = String(gA.serverMode)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.commands = [], IA.config = [], IA.attributions = []), AA.defaults) {
      if ($util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.execTime = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.execTime = AA.longs === String ? "0" : 0;
      if ($util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.prepTime = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.prepTime = AA.longs === String ? "0" : 0;
      IA.uncaughtException = "", IA.os = "", IA.timezone = "", IA.headless = !1, IA.isFragmentRun = !1, IA.serverMode = "";
    }
    if (gA.commands && gA.commands.length) {
      IA.commands = [];
      for (let BA = 0; BA < gA.commands.length; ++BA) IA.commands[BA] = $root.Command.toObject(gA.commands[BA], AA);
    }
    if (gA.execTime != null && gA.hasOwnProperty("execTime") && (typeof gA.execTime == "number" ? IA.execTime = AA.longs === String ? String(gA.execTime) : gA.execTime : IA.execTime = AA.longs === String ? $util.Long.prototype.toString.call(gA.execTime) : AA.longs === Number ? new $util.LongBits(gA.execTime.low >>> 0, gA.execTime.high >>> 0).toNumber() : gA.execTime), gA.prepTime != null && gA.hasOwnProperty("prepTime") && (typeof gA.prepTime == "number" ? IA.prepTime = AA.longs === String ? String(gA.prepTime) : gA.prepTime : IA.prepTime = AA.longs === String ? $util.Long.prototype.toString.call(gA.prepTime) : AA.longs === Number ? new $util.LongBits(gA.prepTime.low >>> 0, gA.prepTime.high >>> 0).toNumber() : gA.prepTime), gA.config && gA.config.length) {
      IA.config = [];
      for (let BA = 0; BA < gA.config.length; ++BA) IA.config[BA] = gA.config[BA];
    }
    if (gA.uncaughtException != null && gA.hasOwnProperty("uncaughtException") && (IA.uncaughtException = gA.uncaughtException), gA.attributions && gA.attributions.length) {
      IA.attributions = [];
      for (let BA = 0; BA < gA.attributions.length; ++BA) IA.attributions[BA] = gA.attributions[BA];
    }
    return gA.os != null && gA.hasOwnProperty("os") && (IA.os = gA.os), gA.timezone != null && gA.hasOwnProperty("timezone") && (IA.timezone = gA.timezone), gA.headless != null && gA.hasOwnProperty("headless") && (IA.headless = gA.headless), gA.isFragmentRun != null && gA.hasOwnProperty("isFragmentRun") && (IA.isFragmentRun = gA.isFragmentRun), gA.serverMode != null && gA.hasOwnProperty("serverMode") && (IA.serverMode = gA.serverMode), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/PageProfile";
  }, CA;
})();
$root.Argument = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.k = "", CA.prototype.t = "", CA.prototype.m = "", CA.prototype.p = 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.k != null && Object.hasOwnProperty.call(gA, "k") && AA.uint32(10).string(gA.k), gA.t != null && Object.hasOwnProperty.call(gA, "t") && AA.uint32(18).string(gA.t), gA.m != null && Object.hasOwnProperty.call(gA, "m") && AA.uint32(26).string(gA.m), gA.p != null && Object.hasOwnProperty.call(gA, "p") && AA.uint32(40).int32(gA.p), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Argument();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.k = gA.string();
          break;
        case 2:
          QA.t = gA.string();
          break;
        case 3:
          QA.m = gA.string();
          break;
        case 5:
          QA.p = gA.int32();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Argument) return gA;
    let AA = new $root.Argument();
    return gA.k != null && (AA.k = String(gA.k)), gA.t != null && (AA.t = String(gA.t)), gA.m != null && (AA.m = String(gA.m)), gA.p != null && (AA.p = gA.p | 0), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.k = "", IA.t = "", IA.m = "", IA.p = 0), gA.k != null && gA.hasOwnProperty("k") && (IA.k = gA.k), gA.t != null && gA.hasOwnProperty("t") && (IA.t = gA.t), gA.m != null && gA.hasOwnProperty("m") && (IA.m = gA.m), gA.p != null && gA.hasOwnProperty("p") && (IA.p = gA.p), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Argument";
  }, CA;
})();
$root.Command = (() => {
  function CA(gA) {
    if (this.args = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.name = "", CA.prototype.args = $util.emptyArray, CA.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.name != null && Object.hasOwnProperty.call(gA, "name") && AA.uint32(10).string(gA.name), gA.args != null && gA.args.length) for (let IA = 0; IA < gA.args.length; ++IA) $root.Argument.encode(gA.args[IA], AA.uint32(18).fork()).ldelim();
    return gA.time != null && Object.hasOwnProperty.call(gA, "time") && AA.uint32(32).int64(gA.time), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.Command();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.name = gA.string();
          break;
        case 2:
          QA.args && QA.args.length || (QA.args = []), QA.args.push($root.Argument.decode(gA, gA.uint32()));
          break;
        case 4:
          QA.time = gA.int64();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.Command) return gA;
    let AA = new $root.Command();
    if (gA.name != null && (AA.name = String(gA.name)), gA.args) {
      if (!Array.isArray(gA.args)) throw TypeError(".Command.args: array expected");
      AA.args = [];
      for (let IA = 0; IA < gA.args.length; ++IA) {
        if (typeof gA.args[IA] != "object") throw TypeError(".Command.args: object expected");
        AA.args[IA] = $root.Argument.fromObject(gA.args[IA]);
      }
    }
    return gA.time != null && ($util.Long ? (AA.time = $util.Long.fromValue(gA.time)).unsigned = !1 : typeof gA.time == "string" ? AA.time = parseInt(gA.time, 10) : typeof gA.time == "number" ? AA.time = gA.time : typeof gA.time == "object" && (AA.time = new $util.LongBits(gA.time.low >>> 0, gA.time.high >>> 0).toNumber())), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.args = []), AA.defaults) if (IA.name = "", $util.Long) {
      let BA = new $util.Long(0, 0, !1);
      IA.time = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
    } else IA.time = AA.longs === String ? "0" : 0;
    if (gA.name != null && gA.hasOwnProperty("name") && (IA.name = gA.name), gA.args && gA.args.length) {
      IA.args = [];
      for (let BA = 0; BA < gA.args.length; ++BA) IA.args[BA] = $root.Argument.toObject(gA.args[BA], AA);
    }
    return gA.time != null && gA.hasOwnProperty("time") && (typeof gA.time == "number" ? IA.time = AA.longs === String ? String(gA.time) : gA.time : IA.time = AA.longs === String ? $util.Long.prototype.toString.call(gA.time) : AA.longs === Number ? new $util.LongBits(gA.time.low >>> 0, gA.time.high >>> 0).toNumber() : gA.time), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/Command";
  }, CA;
})();
$root.ParentMessage = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.message = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.message != null && Object.hasOwnProperty.call(gA, "message") && AA.uint32(10).string(gA.message), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.ParentMessage();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      EA >>> 3 === 1 ? QA.message = gA.string() : gA.skipType(EA & 7);
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.ParentMessage) return gA;
    let AA = new $root.ParentMessage();
    return gA.message != null && (AA.message = String(gA.message)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.message = ""), gA.message != null && gA.hasOwnProperty("message") && (IA.message = gA.message), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/ParentMessage";
  }, CA;
})();
$root.SessionEvent = (() => {
  function CA(AA) {
    if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
  }
  CA.prototype.scriptChangedOnDisk = null, CA.prototype.scriptWasManuallyStopped = null, CA.prototype.scriptCompilationException = null;
  let gA;
  return Object.defineProperty(CA.prototype, "type", { get: $util.oneOfGetter(gA = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]), set: $util.oneOfSetter(gA) }), CA.create = function(AA) {
    return new CA(AA);
  }, CA.encode = function(AA, IA) {
    return IA ||= $Writer.create(), AA.scriptChangedOnDisk != null && Object.hasOwnProperty.call(AA, "scriptChangedOnDisk") && IA.uint32(8).bool(AA.scriptChangedOnDisk), AA.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(AA, "scriptWasManuallyStopped") && IA.uint32(16).bool(AA.scriptWasManuallyStopped), AA.scriptCompilationException != null && Object.hasOwnProperty.call(AA, "scriptCompilationException") && $root.Exception.encode(AA.scriptCompilationException, IA.uint32(26).fork()).ldelim(), IA;
  }, CA.decode = function(AA, IA, BA) {
    AA instanceof $Reader || (AA = $Reader.create(AA));
    let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.SessionEvent();
    for (; AA.pos < QA; ) {
      let iA = AA.uint32();
      if (iA === BA) break;
      switch (iA >>> 3) {
        case 1:
          EA.scriptChangedOnDisk = AA.bool();
          break;
        case 2:
          EA.scriptWasManuallyStopped = AA.bool();
          break;
        case 3:
          EA.scriptCompilationException = $root.Exception.decode(AA, AA.uint32());
          break;
        default:
          AA.skipType(iA & 7);
          break;
      }
    }
    return EA;
  }, CA.fromObject = function(AA) {
    if (AA instanceof $root.SessionEvent) return AA;
    let IA = new $root.SessionEvent();
    if (AA.scriptChangedOnDisk != null && (IA.scriptChangedOnDisk = !!AA.scriptChangedOnDisk), AA.scriptWasManuallyStopped != null && (IA.scriptWasManuallyStopped = !!AA.scriptWasManuallyStopped), AA.scriptCompilationException != null) {
      if (typeof AA.scriptCompilationException != "object") throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      IA.scriptCompilationException = $root.Exception.fromObject(AA.scriptCompilationException);
    }
    return IA;
  }, CA.toObject = function(AA, IA) {
    IA ||= {};
    let BA = {};
    return AA.scriptChangedOnDisk != null && AA.hasOwnProperty("scriptChangedOnDisk") && (BA.scriptChangedOnDisk = AA.scriptChangedOnDisk, IA.oneofs && (BA.type = "scriptChangedOnDisk")), AA.scriptWasManuallyStopped != null && AA.hasOwnProperty("scriptWasManuallyStopped") && (BA.scriptWasManuallyStopped = AA.scriptWasManuallyStopped, IA.oneofs && (BA.type = "scriptWasManuallyStopped")), AA.scriptCompilationException != null && AA.hasOwnProperty("scriptCompilationException") && (BA.scriptCompilationException = $root.Exception.toObject(AA.scriptCompilationException, IA), IA.oneofs && (BA.type = "scriptCompilationException")), BA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(AA) {
    return AA === void 0 && (AA = "type.googleapis.com"), AA + "/SessionEvent";
  }, CA;
})();
$root.MetricsEvent = (() => {
  function CA(gA) {
    if (this.commands = [], this.config = [], this.attributions = [], gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.event = "", CA.prototype.anonymousId = "", CA.prototype.machineIdV3 = "", CA.prototype.machineIdV4 = "", CA.prototype.reportHash = "", CA.prototype.dev = !1, CA.prototype.source = "", CA.prototype.streamlitVersion = "", CA.prototype.isHello = !1, CA.prototype.appId = "", CA.prototype.sessionId = "", CA.prototype.pythonVersion = "", CA.prototype.serverOs = "", CA.prototype.hasDisplay = !1, CA.prototype.isWebdriver = !1, CA.prototype.hostedAt = "", CA.prototype.owner = "", CA.prototype.repo = "", CA.prototype.branch = "", CA.prototype.mainModule = "", CA.prototype.creatorId = "", CA.prototype.contextPageUrl = "", CA.prototype.contextPageTitle = "", CA.prototype.contextPagePath = "", CA.prototype.contextPageReferrer = "", CA.prototype.contextPageSearch = "", CA.prototype.contextLocale = "", CA.prototype.contextUserAgent = "", CA.prototype.label = "", CA.prototype.commands = $util.emptyArray, CA.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.config = $util.emptyArray, CA.prototype.uncaughtException = "", CA.prototype.attributions = $util.emptyArray, CA.prototype.os = "", CA.prototype.timezone = "", CA.prototype.headless = !1, CA.prototype.isFragmentRun = !1, CA.prototype.numPages = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.pageScriptHash = "", CA.prototype.activeTheme = "", CA.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, CA.prototype.browserInfo = null, CA.prototype.serverMode = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    if (AA ||= $Writer.create(), gA.event != null && Object.hasOwnProperty.call(gA, "event") && AA.uint32(10).string(gA.event), gA.anonymousId != null && Object.hasOwnProperty.call(gA, "anonymousId") && AA.uint32(18).string(gA.anonymousId), gA.machineIdV3 != null && Object.hasOwnProperty.call(gA, "machineIdV3") && AA.uint32(26).string(gA.machineIdV3), gA.reportHash != null && Object.hasOwnProperty.call(gA, "reportHash") && AA.uint32(34).string(gA.reportHash), gA.dev != null && Object.hasOwnProperty.call(gA, "dev") && AA.uint32(40).bool(gA.dev), gA.source != null && Object.hasOwnProperty.call(gA, "source") && AA.uint32(50).string(gA.source), gA.streamlitVersion != null && Object.hasOwnProperty.call(gA, "streamlitVersion") && AA.uint32(58).string(gA.streamlitVersion), gA.isHello != null && Object.hasOwnProperty.call(gA, "isHello") && AA.uint32(64).bool(gA.isHello), gA.hostedAt != null && Object.hasOwnProperty.call(gA, "hostedAt") && AA.uint32(74).string(gA.hostedAt), gA.owner != null && Object.hasOwnProperty.call(gA, "owner") && AA.uint32(82).string(gA.owner), gA.repo != null && Object.hasOwnProperty.call(gA, "repo") && AA.uint32(90).string(gA.repo), gA.branch != null && Object.hasOwnProperty.call(gA, "branch") && AA.uint32(98).string(gA.branch), gA.mainModule != null && Object.hasOwnProperty.call(gA, "mainModule") && AA.uint32(106).string(gA.mainModule), gA.creatorId != null && Object.hasOwnProperty.call(gA, "creatorId") && AA.uint32(114).string(gA.creatorId), gA.contextPageUrl != null && Object.hasOwnProperty.call(gA, "contextPageUrl") && AA.uint32(122).string(gA.contextPageUrl), gA.contextPageTitle != null && Object.hasOwnProperty.call(gA, "contextPageTitle") && AA.uint32(130).string(gA.contextPageTitle), gA.contextPagePath != null && Object.hasOwnProperty.call(gA, "contextPagePath") && AA.uint32(138).string(gA.contextPagePath), gA.contextPageReferrer != null && Object.hasOwnProperty.call(gA, "contextPageReferrer") && AA.uint32(146).string(gA.contextPageReferrer), gA.contextPageSearch != null && Object.hasOwnProperty.call(gA, "contextPageSearch") && AA.uint32(154).string(gA.contextPageSearch), gA.contextLocale != null && Object.hasOwnProperty.call(gA, "contextLocale") && AA.uint32(162).string(gA.contextLocale), gA.contextUserAgent != null && Object.hasOwnProperty.call(gA, "contextUserAgent") && AA.uint32(170).string(gA.contextUserAgent), gA.label != null && Object.hasOwnProperty.call(gA, "label") && AA.uint32(178).string(gA.label), gA.commands != null && gA.commands.length) for (let IA = 0; IA < gA.commands.length; ++IA) $root.Command.encode(gA.commands[IA], AA.uint32(186).fork()).ldelim();
    if (gA.execTime != null && Object.hasOwnProperty.call(gA, "execTime") && AA.uint32(192).int64(gA.execTime), gA.prepTime != null && Object.hasOwnProperty.call(gA, "prepTime") && AA.uint32(200).int64(gA.prepTime), gA.config != null && gA.config.length) for (let IA = 0; IA < gA.config.length; ++IA) AA.uint32(210).string(gA.config[IA]);
    if (gA.uncaughtException != null && Object.hasOwnProperty.call(gA, "uncaughtException") && AA.uint32(218).string(gA.uncaughtException), gA.attributions != null && gA.attributions.length) for (let IA = 0; IA < gA.attributions.length; ++IA) AA.uint32(226).string(gA.attributions[IA]);
    return gA.os != null && Object.hasOwnProperty.call(gA, "os") && AA.uint32(234).string(gA.os), gA.timezone != null && Object.hasOwnProperty.call(gA, "timezone") && AA.uint32(242).string(gA.timezone), gA.headless != null && Object.hasOwnProperty.call(gA, "headless") && AA.uint32(248).bool(gA.headless), gA.isFragmentRun != null && Object.hasOwnProperty.call(gA, "isFragmentRun") && AA.uint32(256).bool(gA.isFragmentRun), gA.appId != null && Object.hasOwnProperty.call(gA, "appId") && AA.uint32(266).string(gA.appId), gA.numPages != null && Object.hasOwnProperty.call(gA, "numPages") && AA.uint32(272).int64(gA.numPages), gA.sessionId != null && Object.hasOwnProperty.call(gA, "sessionId") && AA.uint32(282).string(gA.sessionId), gA.pythonVersion != null && Object.hasOwnProperty.call(gA, "pythonVersion") && AA.uint32(290).string(gA.pythonVersion), gA.pageScriptHash != null && Object.hasOwnProperty.call(gA, "pageScriptHash") && AA.uint32(298).string(gA.pageScriptHash), gA.activeTheme != null && Object.hasOwnProperty.call(gA, "activeTheme") && AA.uint32(306).string(gA.activeTheme), gA.totalLoadTime != null && Object.hasOwnProperty.call(gA, "totalLoadTime") && AA.uint32(312).int64(gA.totalLoadTime), gA.browserInfo != null && Object.hasOwnProperty.call(gA, "browserInfo") && $root.BrowserInfo.encode(gA.browserInfo, AA.uint32(322).fork()).ldelim(), gA.machineIdV4 != null && Object.hasOwnProperty.call(gA, "machineIdV4") && AA.uint32(330).string(gA.machineIdV4), gA.serverOs != null && Object.hasOwnProperty.call(gA, "serverOs") && AA.uint32(338).string(gA.serverOs), gA.hasDisplay != null && Object.hasOwnProperty.call(gA, "hasDisplay") && AA.uint32(344).bool(gA.hasDisplay), gA.isWebdriver != null && Object.hasOwnProperty.call(gA, "isWebdriver") && AA.uint32(352).bool(gA.isWebdriver), gA.serverMode != null && Object.hasOwnProperty.call(gA, "serverMode") && AA.uint32(362).string(gA.serverMode), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.MetricsEvent();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.event = gA.string();
          break;
        case 2:
          QA.anonymousId = gA.string();
          break;
        case 3:
          QA.machineIdV3 = gA.string();
          break;
        case 41:
          QA.machineIdV4 = gA.string();
          break;
        case 4:
          QA.reportHash = gA.string();
          break;
        case 5:
          QA.dev = gA.bool();
          break;
        case 6:
          QA.source = gA.string();
          break;
        case 7:
          QA.streamlitVersion = gA.string();
          break;
        case 8:
          QA.isHello = gA.bool();
          break;
        case 33:
          QA.appId = gA.string();
          break;
        case 35:
          QA.sessionId = gA.string();
          break;
        case 36:
          QA.pythonVersion = gA.string();
          break;
        case 42:
          QA.serverOs = gA.string();
          break;
        case 43:
          QA.hasDisplay = gA.bool();
          break;
        case 44:
          QA.isWebdriver = gA.bool();
          break;
        case 9:
          QA.hostedAt = gA.string();
          break;
        case 10:
          QA.owner = gA.string();
          break;
        case 11:
          QA.repo = gA.string();
          break;
        case 12:
          QA.branch = gA.string();
          break;
        case 13:
          QA.mainModule = gA.string();
          break;
        case 14:
          QA.creatorId = gA.string();
          break;
        case 15:
          QA.contextPageUrl = gA.string();
          break;
        case 16:
          QA.contextPageTitle = gA.string();
          break;
        case 17:
          QA.contextPagePath = gA.string();
          break;
        case 18:
          QA.contextPageReferrer = gA.string();
          break;
        case 19:
          QA.contextPageSearch = gA.string();
          break;
        case 20:
          QA.contextLocale = gA.string();
          break;
        case 21:
          QA.contextUserAgent = gA.string();
          break;
        case 22:
          QA.label = gA.string();
          break;
        case 23:
          QA.commands && QA.commands.length || (QA.commands = []), QA.commands.push($root.Command.decode(gA, gA.uint32()));
          break;
        case 24:
          QA.execTime = gA.int64();
          break;
        case 25:
          QA.prepTime = gA.int64();
          break;
        case 26:
          QA.config && QA.config.length || (QA.config = []), QA.config.push(gA.string());
          break;
        case 27:
          QA.uncaughtException = gA.string();
          break;
        case 28:
          QA.attributions && QA.attributions.length || (QA.attributions = []), QA.attributions.push(gA.string());
          break;
        case 29:
          QA.os = gA.string();
          break;
        case 30:
          QA.timezone = gA.string();
          break;
        case 31:
          QA.headless = gA.bool();
          break;
        case 32:
          QA.isFragmentRun = gA.bool();
          break;
        case 34:
          QA.numPages = gA.int64();
          break;
        case 37:
          QA.pageScriptHash = gA.string();
          break;
        case 38:
          QA.activeTheme = gA.string();
          break;
        case 39:
          QA.totalLoadTime = gA.int64();
          break;
        case 40:
          QA.browserInfo = $root.BrowserInfo.decode(gA, gA.uint32());
          break;
        case 45:
          QA.serverMode = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.MetricsEvent) return gA;
    let AA = new $root.MetricsEvent();
    if (gA.event != null && (AA.event = String(gA.event)), gA.anonymousId != null && (AA.anonymousId = String(gA.anonymousId)), gA.machineIdV3 != null && (AA.machineIdV3 = String(gA.machineIdV3)), gA.machineIdV4 != null && (AA.machineIdV4 = String(gA.machineIdV4)), gA.reportHash != null && (AA.reportHash = String(gA.reportHash)), gA.dev != null && (AA.dev = !!gA.dev), gA.source != null && (AA.source = String(gA.source)), gA.streamlitVersion != null && (AA.streamlitVersion = String(gA.streamlitVersion)), gA.isHello != null && (AA.isHello = !!gA.isHello), gA.appId != null && (AA.appId = String(gA.appId)), gA.sessionId != null && (AA.sessionId = String(gA.sessionId)), gA.pythonVersion != null && (AA.pythonVersion = String(gA.pythonVersion)), gA.serverOs != null && (AA.serverOs = String(gA.serverOs)), gA.hasDisplay != null && (AA.hasDisplay = !!gA.hasDisplay), gA.isWebdriver != null && (AA.isWebdriver = !!gA.isWebdriver), gA.hostedAt != null && (AA.hostedAt = String(gA.hostedAt)), gA.owner != null && (AA.owner = String(gA.owner)), gA.repo != null && (AA.repo = String(gA.repo)), gA.branch != null && (AA.branch = String(gA.branch)), gA.mainModule != null && (AA.mainModule = String(gA.mainModule)), gA.creatorId != null && (AA.creatorId = String(gA.creatorId)), gA.contextPageUrl != null && (AA.contextPageUrl = String(gA.contextPageUrl)), gA.contextPageTitle != null && (AA.contextPageTitle = String(gA.contextPageTitle)), gA.contextPagePath != null && (AA.contextPagePath = String(gA.contextPagePath)), gA.contextPageReferrer != null && (AA.contextPageReferrer = String(gA.contextPageReferrer)), gA.contextPageSearch != null && (AA.contextPageSearch = String(gA.contextPageSearch)), gA.contextLocale != null && (AA.contextLocale = String(gA.contextLocale)), gA.contextUserAgent != null && (AA.contextUserAgent = String(gA.contextUserAgent)), gA.label != null && (AA.label = String(gA.label)), gA.commands) {
      if (!Array.isArray(gA.commands)) throw TypeError(".MetricsEvent.commands: array expected");
      AA.commands = [];
      for (let IA = 0; IA < gA.commands.length; ++IA) {
        if (typeof gA.commands[IA] != "object") throw TypeError(".MetricsEvent.commands: object expected");
        AA.commands[IA] = $root.Command.fromObject(gA.commands[IA]);
      }
    }
    if (gA.execTime != null && ($util.Long ? (AA.execTime = $util.Long.fromValue(gA.execTime)).unsigned = !1 : typeof gA.execTime == "string" ? AA.execTime = parseInt(gA.execTime, 10) : typeof gA.execTime == "number" ? AA.execTime = gA.execTime : typeof gA.execTime == "object" && (AA.execTime = new $util.LongBits(gA.execTime.low >>> 0, gA.execTime.high >>> 0).toNumber())), gA.prepTime != null && ($util.Long ? (AA.prepTime = $util.Long.fromValue(gA.prepTime)).unsigned = !1 : typeof gA.prepTime == "string" ? AA.prepTime = parseInt(gA.prepTime, 10) : typeof gA.prepTime == "number" ? AA.prepTime = gA.prepTime : typeof gA.prepTime == "object" && (AA.prepTime = new $util.LongBits(gA.prepTime.low >>> 0, gA.prepTime.high >>> 0).toNumber())), gA.config) {
      if (!Array.isArray(gA.config)) throw TypeError(".MetricsEvent.config: array expected");
      AA.config = [];
      for (let IA = 0; IA < gA.config.length; ++IA) AA.config[IA] = String(gA.config[IA]);
    }
    if (gA.uncaughtException != null && (AA.uncaughtException = String(gA.uncaughtException)), gA.attributions) {
      if (!Array.isArray(gA.attributions)) throw TypeError(".MetricsEvent.attributions: array expected");
      AA.attributions = [];
      for (let IA = 0; IA < gA.attributions.length; ++IA) AA.attributions[IA] = String(gA.attributions[IA]);
    }
    if (gA.os != null && (AA.os = String(gA.os)), gA.timezone != null && (AA.timezone = String(gA.timezone)), gA.headless != null && (AA.headless = !!gA.headless), gA.isFragmentRun != null && (AA.isFragmentRun = !!gA.isFragmentRun), gA.numPages != null && ($util.Long ? (AA.numPages = $util.Long.fromValue(gA.numPages)).unsigned = !1 : typeof gA.numPages == "string" ? AA.numPages = parseInt(gA.numPages, 10) : typeof gA.numPages == "number" ? AA.numPages = gA.numPages : typeof gA.numPages == "object" && (AA.numPages = new $util.LongBits(gA.numPages.low >>> 0, gA.numPages.high >>> 0).toNumber())), gA.pageScriptHash != null && (AA.pageScriptHash = String(gA.pageScriptHash)), gA.activeTheme != null && (AA.activeTheme = String(gA.activeTheme)), gA.totalLoadTime != null && ($util.Long ? (AA.totalLoadTime = $util.Long.fromValue(gA.totalLoadTime)).unsigned = !1 : typeof gA.totalLoadTime == "string" ? AA.totalLoadTime = parseInt(gA.totalLoadTime, 10) : typeof gA.totalLoadTime == "number" ? AA.totalLoadTime = gA.totalLoadTime : typeof gA.totalLoadTime == "object" && (AA.totalLoadTime = new $util.LongBits(gA.totalLoadTime.low >>> 0, gA.totalLoadTime.high >>> 0).toNumber())), gA.browserInfo != null) {
      if (typeof gA.browserInfo != "object") throw TypeError(".MetricsEvent.browserInfo: object expected");
      AA.browserInfo = $root.BrowserInfo.fromObject(gA.browserInfo);
    }
    return gA.serverMode != null && (AA.serverMode = String(gA.serverMode)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    if ((AA.arrays || AA.defaults) && (IA.commands = [], IA.config = [], IA.attributions = []), AA.defaults) {
      if (IA.event = "", IA.anonymousId = "", IA.machineIdV3 = "", IA.reportHash = "", IA.dev = !1, IA.source = "", IA.streamlitVersion = "", IA.isHello = !1, IA.hostedAt = "", IA.owner = "", IA.repo = "", IA.branch = "", IA.mainModule = "", IA.creatorId = "", IA.contextPageUrl = "", IA.contextPageTitle = "", IA.contextPagePath = "", IA.contextPageReferrer = "", IA.contextPageSearch = "", IA.contextLocale = "", IA.contextUserAgent = "", IA.label = "", $util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.execTime = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.execTime = AA.longs === String ? "0" : 0;
      if ($util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.prepTime = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.prepTime = AA.longs === String ? "0" : 0;
      if (IA.uncaughtException = "", IA.os = "", IA.timezone = "", IA.headless = !1, IA.isFragmentRun = !1, IA.appId = "", $util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.numPages = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.numPages = AA.longs === String ? "0" : 0;
      if (IA.sessionId = "", IA.pythonVersion = "", IA.pageScriptHash = "", IA.activeTheme = "", $util.Long) {
        let BA = new $util.Long(0, 0, !1);
        IA.totalLoadTime = AA.longs === String ? BA.toString() : AA.longs === Number ? BA.toNumber() : BA;
      } else IA.totalLoadTime = AA.longs === String ? "0" : 0;
      IA.browserInfo = null, IA.machineIdV4 = "", IA.serverOs = "", IA.hasDisplay = !1, IA.isWebdriver = !1, IA.serverMode = "";
    }
    if (gA.event != null && gA.hasOwnProperty("event") && (IA.event = gA.event), gA.anonymousId != null && gA.hasOwnProperty("anonymousId") && (IA.anonymousId = gA.anonymousId), gA.machineIdV3 != null && gA.hasOwnProperty("machineIdV3") && (IA.machineIdV3 = gA.machineIdV3), gA.reportHash != null && gA.hasOwnProperty("reportHash") && (IA.reportHash = gA.reportHash), gA.dev != null && gA.hasOwnProperty("dev") && (IA.dev = gA.dev), gA.source != null && gA.hasOwnProperty("source") && (IA.source = gA.source), gA.streamlitVersion != null && gA.hasOwnProperty("streamlitVersion") && (IA.streamlitVersion = gA.streamlitVersion), gA.isHello != null && gA.hasOwnProperty("isHello") && (IA.isHello = gA.isHello), gA.hostedAt != null && gA.hasOwnProperty("hostedAt") && (IA.hostedAt = gA.hostedAt), gA.owner != null && gA.hasOwnProperty("owner") && (IA.owner = gA.owner), gA.repo != null && gA.hasOwnProperty("repo") && (IA.repo = gA.repo), gA.branch != null && gA.hasOwnProperty("branch") && (IA.branch = gA.branch), gA.mainModule != null && gA.hasOwnProperty("mainModule") && (IA.mainModule = gA.mainModule), gA.creatorId != null && gA.hasOwnProperty("creatorId") && (IA.creatorId = gA.creatorId), gA.contextPageUrl != null && gA.hasOwnProperty("contextPageUrl") && (IA.contextPageUrl = gA.contextPageUrl), gA.contextPageTitle != null && gA.hasOwnProperty("contextPageTitle") && (IA.contextPageTitle = gA.contextPageTitle), gA.contextPagePath != null && gA.hasOwnProperty("contextPagePath") && (IA.contextPagePath = gA.contextPagePath), gA.contextPageReferrer != null && gA.hasOwnProperty("contextPageReferrer") && (IA.contextPageReferrer = gA.contextPageReferrer), gA.contextPageSearch != null && gA.hasOwnProperty("contextPageSearch") && (IA.contextPageSearch = gA.contextPageSearch), gA.contextLocale != null && gA.hasOwnProperty("contextLocale") && (IA.contextLocale = gA.contextLocale), gA.contextUserAgent != null && gA.hasOwnProperty("contextUserAgent") && (IA.contextUserAgent = gA.contextUserAgent), gA.label != null && gA.hasOwnProperty("label") && (IA.label = gA.label), gA.commands && gA.commands.length) {
      IA.commands = [];
      for (let BA = 0; BA < gA.commands.length; ++BA) IA.commands[BA] = $root.Command.toObject(gA.commands[BA], AA);
    }
    if (gA.execTime != null && gA.hasOwnProperty("execTime") && (typeof gA.execTime == "number" ? IA.execTime = AA.longs === String ? String(gA.execTime) : gA.execTime : IA.execTime = AA.longs === String ? $util.Long.prototype.toString.call(gA.execTime) : AA.longs === Number ? new $util.LongBits(gA.execTime.low >>> 0, gA.execTime.high >>> 0).toNumber() : gA.execTime), gA.prepTime != null && gA.hasOwnProperty("prepTime") && (typeof gA.prepTime == "number" ? IA.prepTime = AA.longs === String ? String(gA.prepTime) : gA.prepTime : IA.prepTime = AA.longs === String ? $util.Long.prototype.toString.call(gA.prepTime) : AA.longs === Number ? new $util.LongBits(gA.prepTime.low >>> 0, gA.prepTime.high >>> 0).toNumber() : gA.prepTime), gA.config && gA.config.length) {
      IA.config = [];
      for (let BA = 0; BA < gA.config.length; ++BA) IA.config[BA] = gA.config[BA];
    }
    if (gA.uncaughtException != null && gA.hasOwnProperty("uncaughtException") && (IA.uncaughtException = gA.uncaughtException), gA.attributions && gA.attributions.length) {
      IA.attributions = [];
      for (let BA = 0; BA < gA.attributions.length; ++BA) IA.attributions[BA] = gA.attributions[BA];
    }
    return gA.os != null && gA.hasOwnProperty("os") && (IA.os = gA.os), gA.timezone != null && gA.hasOwnProperty("timezone") && (IA.timezone = gA.timezone), gA.headless != null && gA.hasOwnProperty("headless") && (IA.headless = gA.headless), gA.isFragmentRun != null && gA.hasOwnProperty("isFragmentRun") && (IA.isFragmentRun = gA.isFragmentRun), gA.appId != null && gA.hasOwnProperty("appId") && (IA.appId = gA.appId), gA.numPages != null && gA.hasOwnProperty("numPages") && (typeof gA.numPages == "number" ? IA.numPages = AA.longs === String ? String(gA.numPages) : gA.numPages : IA.numPages = AA.longs === String ? $util.Long.prototype.toString.call(gA.numPages) : AA.longs === Number ? new $util.LongBits(gA.numPages.low >>> 0, gA.numPages.high >>> 0).toNumber() : gA.numPages), gA.sessionId != null && gA.hasOwnProperty("sessionId") && (IA.sessionId = gA.sessionId), gA.pythonVersion != null && gA.hasOwnProperty("pythonVersion") && (IA.pythonVersion = gA.pythonVersion), gA.pageScriptHash != null && gA.hasOwnProperty("pageScriptHash") && (IA.pageScriptHash = gA.pageScriptHash), gA.activeTheme != null && gA.hasOwnProperty("activeTheme") && (IA.activeTheme = gA.activeTheme), gA.totalLoadTime != null && gA.hasOwnProperty("totalLoadTime") && (typeof gA.totalLoadTime == "number" ? IA.totalLoadTime = AA.longs === String ? String(gA.totalLoadTime) : gA.totalLoadTime : IA.totalLoadTime = AA.longs === String ? $util.Long.prototype.toString.call(gA.totalLoadTime) : AA.longs === Number ? new $util.LongBits(gA.totalLoadTime.low >>> 0, gA.totalLoadTime.high >>> 0).toNumber() : gA.totalLoadTime), gA.browserInfo != null && gA.hasOwnProperty("browserInfo") && (IA.browserInfo = $root.BrowserInfo.toObject(gA.browserInfo, AA)), gA.machineIdV4 != null && gA.hasOwnProperty("machineIdV4") && (IA.machineIdV4 = gA.machineIdV4), gA.serverOs != null && gA.hasOwnProperty("serverOs") && (IA.serverOs = gA.serverOs), gA.hasDisplay != null && gA.hasOwnProperty("hasDisplay") && (IA.hasDisplay = gA.hasDisplay), gA.isWebdriver != null && gA.hasOwnProperty("isWebdriver") && (IA.isWebdriver = gA.isWebdriver), gA.serverMode != null && gA.hasOwnProperty("serverMode") && (IA.serverMode = gA.serverMode), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/MetricsEvent";
  }, CA;
})();
$root.BrowserInfo = (() => {
  function CA(gA) {
    if (gA) for (let AA = Object.keys(gA), IA = 0; IA < AA.length; ++IA) gA[AA[IA]] != null && (this[AA[IA]] = gA[AA[IA]]);
  }
  return CA.prototype.browserName = "", CA.prototype.browserVersion = "", CA.prototype.deviceType = "", CA.prototype.os = "", CA.create = function(gA) {
    return new CA(gA);
  }, CA.encode = function(gA, AA) {
    return AA ||= $Writer.create(), gA.browserName != null && Object.hasOwnProperty.call(gA, "browserName") && AA.uint32(10).string(gA.browserName), gA.browserVersion != null && Object.hasOwnProperty.call(gA, "browserVersion") && AA.uint32(18).string(gA.browserVersion), gA.deviceType != null && Object.hasOwnProperty.call(gA, "deviceType") && AA.uint32(26).string(gA.deviceType), gA.os != null && Object.hasOwnProperty.call(gA, "os") && AA.uint32(34).string(gA.os), AA;
  }, CA.decode = function(gA, AA, IA) {
    gA instanceof $Reader || (gA = $Reader.create(gA));
    let BA = AA === void 0 ? gA.len : gA.pos + AA, QA = new $root.BrowserInfo();
    for (; gA.pos < BA; ) {
      let EA = gA.uint32();
      if (EA === IA) break;
      switch (EA >>> 3) {
        case 1:
          QA.browserName = gA.string();
          break;
        case 2:
          QA.browserVersion = gA.string();
          break;
        case 3:
          QA.deviceType = gA.string();
          break;
        case 4:
          QA.os = gA.string();
          break;
        default:
          gA.skipType(EA & 7);
          break;
      }
    }
    return QA;
  }, CA.fromObject = function(gA) {
    if (gA instanceof $root.BrowserInfo) return gA;
    let AA = new $root.BrowserInfo();
    return gA.browserName != null && (AA.browserName = String(gA.browserName)), gA.browserVersion != null && (AA.browserVersion = String(gA.browserVersion)), gA.deviceType != null && (AA.deviceType = String(gA.deviceType)), gA.os != null && (AA.os = String(gA.os)), AA;
  }, CA.toObject = function(gA, AA) {
    AA ||= {};
    let IA = {};
    return AA.defaults && (IA.browserName = "", IA.browserVersion = "", IA.deviceType = "", IA.os = ""), gA.browserName != null && gA.hasOwnProperty("browserName") && (IA.browserName = gA.browserName), gA.browserVersion != null && gA.hasOwnProperty("browserVersion") && (IA.browserVersion = gA.browserVersion), gA.deviceType != null && gA.hasOwnProperty("deviceType") && (IA.deviceType = gA.deviceType), gA.os != null && gA.hasOwnProperty("os") && (IA.os = gA.os), IA;
  }, CA.prototype.toJSON = function() {
    return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
  }, CA.getTypeUrl = function(gA) {
    return gA === void 0 && (gA = "type.googleapis.com"), gA + "/BrowserInfo";
  }, CA;
})();
$root.openmetrics = (() => {
  let CA = {};
  return CA.MetricSet = (function() {
    function gA(AA) {
      if (this.metricFamilies = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.metricFamilies = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.metricFamilies != null && AA.metricFamilies.length) for (let BA = 0; BA < AA.metricFamilies.length; ++BA) $root.openmetrics.MetricFamily.encode(AA.metricFamilies[BA], IA.uint32(10).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.MetricSet();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        iA >>> 3 === 1 ? (EA.metricFamilies && EA.metricFamilies.length || (EA.metricFamilies = []), EA.metricFamilies.push($root.openmetrics.MetricFamily.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.MetricSet) return AA;
      let IA = new $root.openmetrics.MetricSet();
      if (AA.metricFamilies) {
        if (!Array.isArray(AA.metricFamilies)) throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        IA.metricFamilies = [];
        for (let BA = 0; BA < AA.metricFamilies.length; ++BA) {
          if (typeof AA.metricFamilies[BA] != "object") throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          IA.metricFamilies[BA] = $root.openmetrics.MetricFamily.fromObject(AA.metricFamilies[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.metricFamilies = []), AA.metricFamilies && AA.metricFamilies.length) {
        BA.metricFamilies = [];
        for (let QA = 0; QA < AA.metricFamilies.length; ++QA) BA.metricFamilies[QA] = $root.openmetrics.MetricFamily.toObject(AA.metricFamilies[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.MetricSet";
    }, gA;
  })(), CA.MetricFamily = (function() {
    function gA(AA) {
      if (this.metrics = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.name = "", gA.prototype.type = 0, gA.prototype.unit = "", gA.prototype.help = "", gA.prototype.metrics = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(10).string(AA.name), AA.type != null && Object.hasOwnProperty.call(AA, "type") && IA.uint32(16).int32(AA.type), AA.unit != null && Object.hasOwnProperty.call(AA, "unit") && IA.uint32(26).string(AA.unit), AA.help != null && Object.hasOwnProperty.call(AA, "help") && IA.uint32(34).string(AA.help), AA.metrics != null && AA.metrics.length) for (let BA = 0; BA < AA.metrics.length; ++BA) $root.Metric.encode(AA.metrics[BA], IA.uint32(42).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.MetricFamily();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        switch (iA >>> 3) {
          case 1:
            EA.name = AA.string();
            break;
          case 2:
            EA.type = AA.int32();
            break;
          case 3:
            EA.unit = AA.string();
            break;
          case 4:
            EA.help = AA.string();
            break;
          case 5:
            EA.metrics && EA.metrics.length || (EA.metrics = []), EA.metrics.push($root.Metric.decode(AA, AA.uint32()));
            break;
          default:
            AA.skipType(iA & 7);
            break;
        }
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.MetricFamily) return AA;
      let IA = new $root.openmetrics.MetricFamily();
      switch (AA.name != null && (IA.name = String(AA.name)), AA.type) {
        default:
          if (typeof AA.type == "number") {
            IA.type = AA.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          IA.type = 0;
          break;
        case "GAUGE":
        case 1:
          IA.type = 1;
          break;
        case "COUNTER":
        case 2:
          IA.type = 2;
          break;
        case "STATE_SET":
        case 3:
          IA.type = 3;
          break;
        case "INFO":
        case 4:
          IA.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          IA.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          IA.type = 6;
          break;
        case "SUMMARY":
        case 7:
          IA.type = 7;
          break;
      }
      if (AA.unit != null && (IA.unit = String(AA.unit)), AA.help != null && (IA.help = String(AA.help)), AA.metrics) {
        if (!Array.isArray(AA.metrics)) throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        IA.metrics = [];
        for (let BA = 0; BA < AA.metrics.length; ++BA) {
          if (typeof AA.metrics[BA] != "object") throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          IA.metrics[BA] = $root.Metric.fromObject(AA.metrics[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.metrics = []), IA.defaults && (BA.name = "", BA.type = IA.enums === String ? "UNKNOWN" : 0, BA.unit = "", BA.help = ""), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.type != null && AA.hasOwnProperty("type") && (BA.type = IA.enums === String ? $root.openmetrics.MetricType[AA.type] === void 0 ? AA.type : $root.openmetrics.MetricType[AA.type] : AA.type), AA.unit != null && AA.hasOwnProperty("unit") && (BA.unit = AA.unit), AA.help != null && AA.hasOwnProperty("help") && (BA.help = AA.help), AA.metrics && AA.metrics.length) {
        BA.metrics = [];
        for (let QA = 0; QA < AA.metrics.length; ++QA) BA.metrics[QA] = $root.Metric.toObject(AA.metrics[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.MetricFamily";
    }, gA;
  })(), CA.MetricType = (function() {
    let gA = {}, AA = Object.create(gA);
    return AA[gA[0] = "UNKNOWN"] = 0, AA[gA[1] = "GAUGE"] = 1, AA[gA[2] = "COUNTER"] = 2, AA[gA[3] = "STATE_SET"] = 3, AA[gA[4] = "INFO"] = 4, AA[gA[5] = "HISTOGRAM"] = 5, AA[gA[6] = "GAUGE_HISTOGRAM"] = 6, AA[gA[7] = "SUMMARY"] = 7, AA;
  })(), CA.Metric = (function() {
    function gA(AA) {
      if (this.labels = [], this.metricPoints = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.labels = $util.emptyArray, gA.prototype.metricPoints = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.labels != null && AA.labels.length) for (let BA = 0; BA < AA.labels.length; ++BA) $root.openmetrics.Label.encode(AA.labels[BA], IA.uint32(10).fork()).ldelim();
      if (AA.metricPoints != null && AA.metricPoints.length) for (let BA = 0; BA < AA.metricPoints.length; ++BA) $root.openmetrics.MetricPoint.encode(AA.metricPoints[BA], IA.uint32(18).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.Metric();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        switch (iA >>> 3) {
          case 1:
            EA.labels && EA.labels.length || (EA.labels = []), EA.labels.push($root.openmetrics.Label.decode(AA, AA.uint32()));
            break;
          case 2:
            EA.metricPoints && EA.metricPoints.length || (EA.metricPoints = []), EA.metricPoints.push($root.openmetrics.MetricPoint.decode(AA, AA.uint32()));
            break;
          default:
            AA.skipType(iA & 7);
            break;
        }
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.Metric) return AA;
      let IA = new $root.openmetrics.Metric();
      if (AA.labels) {
        if (!Array.isArray(AA.labels)) throw TypeError(".openmetrics.Metric.labels: array expected");
        IA.labels = [];
        for (let BA = 0; BA < AA.labels.length; ++BA) {
          if (typeof AA.labels[BA] != "object") throw TypeError(".openmetrics.Metric.labels: object expected");
          IA.labels[BA] = $root.openmetrics.Label.fromObject(AA.labels[BA]);
        }
      }
      if (AA.metricPoints) {
        if (!Array.isArray(AA.metricPoints)) throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        IA.metricPoints = [];
        for (let BA = 0; BA < AA.metricPoints.length; ++BA) {
          if (typeof AA.metricPoints[BA] != "object") throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          IA.metricPoints[BA] = $root.openmetrics.MetricPoint.fromObject(AA.metricPoints[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.labels = [], BA.metricPoints = []), AA.labels && AA.labels.length) {
        BA.labels = [];
        for (let QA = 0; QA < AA.labels.length; ++QA) BA.labels[QA] = $root.openmetrics.Label.toObject(AA.labels[QA], IA);
      }
      if (AA.metricPoints && AA.metricPoints.length) {
        BA.metricPoints = [];
        for (let QA = 0; QA < AA.metricPoints.length; ++QA) BA.metricPoints[QA] = $root.openmetrics.MetricPoint.toObject(AA.metricPoints[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.Metric";
    }, gA;
  })(), CA.Label = (function() {
    function gA(AA) {
      if (AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.name = "", gA.prototype.value = "", gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      return IA ||= $Writer.create(), AA.name != null && Object.hasOwnProperty.call(AA, "name") && IA.uint32(10).string(AA.name), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(18).string(AA.value), IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.Label();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        switch (iA >>> 3) {
          case 1:
            EA.name = AA.string();
            break;
          case 2:
            EA.value = AA.string();
            break;
          default:
            AA.skipType(iA & 7);
            break;
        }
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.Label) return AA;
      let IA = new $root.openmetrics.Label();
      return AA.name != null && (IA.name = String(AA.name)), AA.value != null && (IA.value = String(AA.value)), IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      return IA.defaults && (BA.name = "", BA.value = ""), AA.name != null && AA.hasOwnProperty("name") && (BA.name = AA.name), AA.value != null && AA.hasOwnProperty("value") && (BA.value = AA.value), BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.Label";
    }, gA;
  })(), CA.MetricPoint = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.unknownValue = null, gA.prototype.gaugeValue = null, gA.prototype.counterValue = null, gA.prototype.histogramValue = null, gA.prototype.stateSetValue = null, gA.prototype.infoValue = null, gA.prototype.summaryValue = null, gA.prototype.timestamp = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util.oneOfGetter(AA = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.unknownValue != null && Object.hasOwnProperty.call(IA, "unknownValue") && $root.openmetrics.UnknownValue.encode(IA.unknownValue, BA.uint32(10).fork()).ldelim(), IA.gaugeValue != null && Object.hasOwnProperty.call(IA, "gaugeValue") && $root.openmetrics.GaugeValue.encode(IA.gaugeValue, BA.uint32(18).fork()).ldelim(), IA.counterValue != null && Object.hasOwnProperty.call(IA, "counterValue") && $root.openmetrics.CounterValue.encode(IA.counterValue, BA.uint32(26).fork()).ldelim(), IA.histogramValue != null && Object.hasOwnProperty.call(IA, "histogramValue") && $root.openmetrics.HistogramValue.encode(IA.histogramValue, BA.uint32(34).fork()).ldelim(), IA.stateSetValue != null && Object.hasOwnProperty.call(IA, "stateSetValue") && $root.openmetrics.StateSetValue.encode(IA.stateSetValue, BA.uint32(42).fork()).ldelim(), IA.infoValue != null && Object.hasOwnProperty.call(IA, "infoValue") && $root.openmetrics.InfoValue.encode(IA.infoValue, BA.uint32(50).fork()).ldelim(), IA.summaryValue != null && Object.hasOwnProperty.call(IA, "summaryValue") && $root.openmetrics.SummaryValue.encode(IA.summaryValue, BA.uint32(58).fork()).ldelim(), IA.timestamp != null && Object.hasOwnProperty.call(IA, "timestamp") && $root.google.protobuf.Timestamp.encode(IA.timestamp, BA.uint32(66).fork()).ldelim(), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.MetricPoint();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.unknownValue = $root.openmetrics.UnknownValue.decode(IA, IA.uint32());
            break;
          case 2:
            iA.gaugeValue = $root.openmetrics.GaugeValue.decode(IA, IA.uint32());
            break;
          case 3:
            iA.counterValue = $root.openmetrics.CounterValue.decode(IA, IA.uint32());
            break;
          case 4:
            iA.histogramValue = $root.openmetrics.HistogramValue.decode(IA, IA.uint32());
            break;
          case 5:
            iA.stateSetValue = $root.openmetrics.StateSetValue.decode(IA, IA.uint32());
            break;
          case 6:
            iA.infoValue = $root.openmetrics.InfoValue.decode(IA, IA.uint32());
            break;
          case 7:
            iA.summaryValue = $root.openmetrics.SummaryValue.decode(IA, IA.uint32());
            break;
          case 8:
            iA.timestamp = $root.google.protobuf.Timestamp.decode(IA, IA.uint32());
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.MetricPoint) return IA;
      let BA = new $root.openmetrics.MetricPoint();
      if (IA.unknownValue != null) {
        if (typeof IA.unknownValue != "object") throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        BA.unknownValue = $root.openmetrics.UnknownValue.fromObject(IA.unknownValue);
      }
      if (IA.gaugeValue != null) {
        if (typeof IA.gaugeValue != "object") throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        BA.gaugeValue = $root.openmetrics.GaugeValue.fromObject(IA.gaugeValue);
      }
      if (IA.counterValue != null) {
        if (typeof IA.counterValue != "object") throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        BA.counterValue = $root.openmetrics.CounterValue.fromObject(IA.counterValue);
      }
      if (IA.histogramValue != null) {
        if (typeof IA.histogramValue != "object") throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        BA.histogramValue = $root.openmetrics.HistogramValue.fromObject(IA.histogramValue);
      }
      if (IA.stateSetValue != null) {
        if (typeof IA.stateSetValue != "object") throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        BA.stateSetValue = $root.openmetrics.StateSetValue.fromObject(IA.stateSetValue);
      }
      if (IA.infoValue != null) {
        if (typeof IA.infoValue != "object") throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        BA.infoValue = $root.openmetrics.InfoValue.fromObject(IA.infoValue);
      }
      if (IA.summaryValue != null) {
        if (typeof IA.summaryValue != "object") throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        BA.summaryValue = $root.openmetrics.SummaryValue.fromObject(IA.summaryValue);
      }
      if (IA.timestamp != null) {
        if (typeof IA.timestamp != "object") throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        BA.timestamp = $root.google.protobuf.Timestamp.fromObject(IA.timestamp);
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.timestamp = null), IA.unknownValue != null && IA.hasOwnProperty("unknownValue") && (QA.unknownValue = $root.openmetrics.UnknownValue.toObject(IA.unknownValue, BA), BA.oneofs && (QA.value = "unknownValue")), IA.gaugeValue != null && IA.hasOwnProperty("gaugeValue") && (QA.gaugeValue = $root.openmetrics.GaugeValue.toObject(IA.gaugeValue, BA), BA.oneofs && (QA.value = "gaugeValue")), IA.counterValue != null && IA.hasOwnProperty("counterValue") && (QA.counterValue = $root.openmetrics.CounterValue.toObject(IA.counterValue, BA), BA.oneofs && (QA.value = "counterValue")), IA.histogramValue != null && IA.hasOwnProperty("histogramValue") && (QA.histogramValue = $root.openmetrics.HistogramValue.toObject(IA.histogramValue, BA), BA.oneofs && (QA.value = "histogramValue")), IA.stateSetValue != null && IA.hasOwnProperty("stateSetValue") && (QA.stateSetValue = $root.openmetrics.StateSetValue.toObject(IA.stateSetValue, BA), BA.oneofs && (QA.value = "stateSetValue")), IA.infoValue != null && IA.hasOwnProperty("infoValue") && (QA.infoValue = $root.openmetrics.InfoValue.toObject(IA.infoValue, BA), BA.oneofs && (QA.value = "infoValue")), IA.summaryValue != null && IA.hasOwnProperty("summaryValue") && (QA.summaryValue = $root.openmetrics.SummaryValue.toObject(IA.summaryValue, BA), BA.oneofs && (QA.value = "summaryValue")), IA.timestamp != null && IA.hasOwnProperty("timestamp") && (QA.timestamp = $root.google.protobuf.Timestamp.toObject(IA.timestamp, BA)), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.MetricPoint";
    }, gA;
  })(), CA.UnknownValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(9).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(16).int64(IA.intValue), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.UnknownValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.doubleValue = IA.double();
            break;
          case 2:
            iA.intValue = IA.int64();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.UnknownValue) return IA;
      let BA = new $root.openmetrics.UnknownValue();
      return IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util.Long ? (BA.intValue = $util.Long.fromValue(IA.intValue)).unsigned = !1 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber())), BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.value = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber() : IA.intValue, BA.oneofs && (QA.value = "intValue")), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.UnknownValue";
    }, gA;
  })(), CA.GaugeValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null;
    let AA;
    return Object.defineProperty(gA.prototype, "value", { get: $util.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(9).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(16).int64(IA.intValue), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.GaugeValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.doubleValue = IA.double();
            break;
          case 2:
            iA.intValue = IA.int64();
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.GaugeValue) return IA;
      let BA = new $root.openmetrics.GaugeValue();
      return IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util.Long ? (BA.intValue = $util.Long.fromValue(IA.intValue)).unsigned = !1 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber())), BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.value = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber() : IA.intValue, BA.oneofs && (QA.value = "intValue")), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.GaugeValue";
    }, gA;
  })(), CA.CounterValue = (function() {
    function gA(IA) {
      if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.created = null, gA.prototype.exemplar = null;
    let AA;
    return Object.defineProperty(gA.prototype, "total", { get: $util.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      return BA ||= $Writer.create(), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(9).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(16).uint64(IA.intValue), IA.created != null && Object.hasOwnProperty.call(IA, "created") && $root.google.protobuf.Timestamp.encode(IA.created, BA.uint32(26).fork()).ldelim(), IA.exemplar != null && Object.hasOwnProperty.call(IA, "exemplar") && $root.openmetrics.Exemplar.encode(IA.exemplar, BA.uint32(34).fork()).ldelim(), BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.CounterValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.doubleValue = IA.double();
            break;
          case 2:
            iA.intValue = IA.uint64();
            break;
          case 3:
            iA.created = $root.google.protobuf.Timestamp.decode(IA, IA.uint32());
            break;
          case 4:
            iA.exemplar = $root.openmetrics.Exemplar.decode(IA, IA.uint32());
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.CounterValue) return IA;
      let BA = new $root.openmetrics.CounterValue();
      if (IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util.Long ? (BA.intValue = $util.Long.fromValue(IA.intValue)).unsigned = !0 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber(!0))), IA.created != null) {
        if (typeof IA.created != "object") throw TypeError(".openmetrics.CounterValue.created: object expected");
        BA.created = $root.google.protobuf.Timestamp.fromObject(IA.created);
      }
      if (IA.exemplar != null) {
        if (typeof IA.exemplar != "object") throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        BA.exemplar = $root.openmetrics.Exemplar.fromObject(IA.exemplar);
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      return BA.defaults && (QA.created = null, QA.exemplar = null), IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.total = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber(!0) : IA.intValue, BA.oneofs && (QA.total = "intValue")), IA.created != null && IA.hasOwnProperty("created") && (QA.created = $root.google.protobuf.Timestamp.toObject(IA.created, BA)), IA.exemplar != null && IA.hasOwnProperty("exemplar") && (QA.exemplar = $root.openmetrics.Exemplar.toObject(IA.exemplar, BA)), QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.CounterValue";
    }, gA;
  })(), CA.HistogramValue = (function() {
    function gA(IA) {
      if (this.buckets = [], IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, gA.prototype.created = null, gA.prototype.buckets = $util.emptyArray;
    let AA;
    return Object.defineProperty(gA.prototype, "sum", { get: $util.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA ||= $Writer.create(), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(9).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(16).int64(IA.intValue), IA.count != null && Object.hasOwnProperty.call(IA, "count") && BA.uint32(24).uint64(IA.count), IA.created != null && Object.hasOwnProperty.call(IA, "created") && $root.google.protobuf.Timestamp.encode(IA.created, BA.uint32(34).fork()).ldelim(), IA.buckets != null && IA.buckets.length) for (let QA = 0; QA < IA.buckets.length; ++QA) $root.openmetrics.HistogramValue.Bucket.encode(IA.buckets[QA], BA.uint32(42).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.HistogramValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.doubleValue = IA.double();
            break;
          case 2:
            iA.intValue = IA.int64();
            break;
          case 3:
            iA.count = IA.uint64();
            break;
          case 4:
            iA.created = $root.google.protobuf.Timestamp.decode(IA, IA.uint32());
            break;
          case 5:
            iA.buckets && iA.buckets.length || (iA.buckets = []), iA.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(IA, IA.uint32()));
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.HistogramValue) return IA;
      let BA = new $root.openmetrics.HistogramValue();
      if (IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util.Long ? (BA.intValue = $util.Long.fromValue(IA.intValue)).unsigned = !1 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber())), IA.count != null && ($util.Long ? (BA.count = $util.Long.fromValue(IA.count)).unsigned = !0 : typeof IA.count == "string" ? BA.count = parseInt(IA.count, 10) : typeof IA.count == "number" ? BA.count = IA.count : typeof IA.count == "object" && (BA.count = new $util.LongBits(IA.count.low >>> 0, IA.count.high >>> 0).toNumber(!0))), IA.created != null) {
        if (typeof IA.created != "object") throw TypeError(".openmetrics.HistogramValue.created: object expected");
        BA.created = $root.google.protobuf.Timestamp.fromObject(IA.created);
      }
      if (IA.buckets) {
        if (!Array.isArray(IA.buckets)) throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        BA.buckets = [];
        for (let QA = 0; QA < IA.buckets.length; ++QA) {
          if (typeof IA.buckets[QA] != "object") throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          BA.buckets[QA] = $root.openmetrics.HistogramValue.Bucket.fromObject(IA.buckets[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.buckets = []), BA.defaults) {
        if ($util.Long) {
          let EA = new $util.Long(0, 0, !0);
          QA.count = BA.longs === String ? EA.toString() : BA.longs === Number ? EA.toNumber() : EA;
        } else QA.count = BA.longs === String ? "0" : 0;
        QA.created = null;
      }
      if (IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.sum = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber() : IA.intValue, BA.oneofs && (QA.sum = "intValue")), IA.count != null && IA.hasOwnProperty("count") && (typeof IA.count == "number" ? QA.count = BA.longs === String ? String(IA.count) : IA.count : QA.count = BA.longs === String ? $util.Long.prototype.toString.call(IA.count) : BA.longs === Number ? new $util.LongBits(IA.count.low >>> 0, IA.count.high >>> 0).toNumber(!0) : IA.count), IA.created != null && IA.hasOwnProperty("created") && (QA.created = $root.google.protobuf.Timestamp.toObject(IA.created, BA)), IA.buckets && IA.buckets.length) {
        QA.buckets = [];
        for (let EA = 0; EA < IA.buckets.length; ++EA) QA.buckets[EA] = $root.openmetrics.HistogramValue.Bucket.toObject(IA.buckets[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.HistogramValue";
    }, gA.Bucket = (function() {
      function IA(BA) {
        if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
      }
      return IA.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, IA.prototype.upperBound = 0, IA.prototype.exemplar = null, IA.create = function(BA) {
        return new IA(BA);
      }, IA.encode = function(BA, QA) {
        return QA ||= $Writer.create(), BA.count != null && Object.hasOwnProperty.call(BA, "count") && QA.uint32(8).uint64(BA.count), BA.upperBound != null && Object.hasOwnProperty.call(BA, "upperBound") && QA.uint32(17).double(BA.upperBound), BA.exemplar != null && Object.hasOwnProperty.call(BA, "exemplar") && $root.openmetrics.Exemplar.encode(BA.exemplar, QA.uint32(26).fork()).ldelim(), QA;
      }, IA.decode = function(BA, QA, EA) {
        BA instanceof $Reader || (BA = $Reader.create(BA));
        let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.openmetrics.HistogramValue.Bucket();
        for (; BA.pos < iA; ) {
          let cA = BA.uint32();
          if (cA === EA) break;
          switch (cA >>> 3) {
            case 1:
              oA.count = BA.uint64();
              break;
            case 2:
              oA.upperBound = BA.double();
              break;
            case 3:
              oA.exemplar = $root.openmetrics.Exemplar.decode(BA, BA.uint32());
              break;
            default:
              BA.skipType(cA & 7);
              break;
          }
        }
        return oA;
      }, IA.fromObject = function(BA) {
        if (BA instanceof $root.openmetrics.HistogramValue.Bucket) return BA;
        let QA = new $root.openmetrics.HistogramValue.Bucket();
        if (BA.count != null && ($util.Long ? (QA.count = $util.Long.fromValue(BA.count)).unsigned = !0 : typeof BA.count == "string" ? QA.count = parseInt(BA.count, 10) : typeof BA.count == "number" ? QA.count = BA.count : typeof BA.count == "object" && (QA.count = new $util.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0))), BA.upperBound != null && (QA.upperBound = Number(BA.upperBound)), BA.exemplar != null) {
          if (typeof BA.exemplar != "object") throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          QA.exemplar = $root.openmetrics.Exemplar.fromObject(BA.exemplar);
        }
        return QA;
      }, IA.toObject = function(BA, QA) {
        QA ||= {};
        let EA = {};
        if (QA.defaults) {
          if ($util.Long) {
            let iA = new $util.Long(0, 0, !0);
            EA.count = QA.longs === String ? iA.toString() : QA.longs === Number ? iA.toNumber() : iA;
          } else EA.count = QA.longs === String ? "0" : 0;
          EA.upperBound = 0, EA.exemplar = null;
        }
        return BA.count != null && BA.hasOwnProperty("count") && (typeof BA.count == "number" ? EA.count = QA.longs === String ? String(BA.count) : BA.count : EA.count = QA.longs === String ? $util.Long.prototype.toString.call(BA.count) : QA.longs === Number ? new $util.LongBits(BA.count.low >>> 0, BA.count.high >>> 0).toNumber(!0) : BA.count), BA.upperBound != null && BA.hasOwnProperty("upperBound") && (EA.upperBound = QA.json && !isFinite(BA.upperBound) ? String(BA.upperBound) : BA.upperBound), BA.exemplar != null && BA.hasOwnProperty("exemplar") && (EA.exemplar = $root.openmetrics.Exemplar.toObject(BA.exemplar, QA)), EA;
      }, IA.prototype.toJSON = function() {
        return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
      }, IA.getTypeUrl = function(BA) {
        return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.HistogramValue.Bucket";
      }, IA;
    })(), gA;
  })(), CA.Exemplar = (function() {
    function gA(AA) {
      if (this.label = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.value = 0, gA.prototype.timestamp = null, gA.prototype.label = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.value != null && Object.hasOwnProperty.call(AA, "value") && IA.uint32(9).double(AA.value), AA.timestamp != null && Object.hasOwnProperty.call(AA, "timestamp") && $root.google.protobuf.Timestamp.encode(AA.timestamp, IA.uint32(18).fork()).ldelim(), AA.label != null && AA.label.length) for (let BA = 0; BA < AA.label.length; ++BA) $root.openmetrics.Label.encode(AA.label[BA], IA.uint32(26).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.Exemplar();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        switch (iA >>> 3) {
          case 1:
            EA.value = AA.double();
            break;
          case 2:
            EA.timestamp = $root.google.protobuf.Timestamp.decode(AA, AA.uint32());
            break;
          case 3:
            EA.label && EA.label.length || (EA.label = []), EA.label.push($root.openmetrics.Label.decode(AA, AA.uint32()));
            break;
          default:
            AA.skipType(iA & 7);
            break;
        }
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.Exemplar) return AA;
      let IA = new $root.openmetrics.Exemplar();
      if (AA.value != null && (IA.value = Number(AA.value)), AA.timestamp != null) {
        if (typeof AA.timestamp != "object") throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        IA.timestamp = $root.google.protobuf.Timestamp.fromObject(AA.timestamp);
      }
      if (AA.label) {
        if (!Array.isArray(AA.label)) throw TypeError(".openmetrics.Exemplar.label: array expected");
        IA.label = [];
        for (let BA = 0; BA < AA.label.length; ++BA) {
          if (typeof AA.label[BA] != "object") throw TypeError(".openmetrics.Exemplar.label: object expected");
          IA.label[BA] = $root.openmetrics.Label.fromObject(AA.label[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.label = []), IA.defaults && (BA.value = 0, BA.timestamp = null), AA.value != null && AA.hasOwnProperty("value") && (BA.value = IA.json && !isFinite(AA.value) ? String(AA.value) : AA.value), AA.timestamp != null && AA.hasOwnProperty("timestamp") && (BA.timestamp = $root.google.protobuf.Timestamp.toObject(AA.timestamp, IA)), AA.label && AA.label.length) {
        BA.label = [];
        for (let QA = 0; QA < AA.label.length; ++QA) BA.label[QA] = $root.openmetrics.Label.toObject(AA.label[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.Exemplar";
    }, gA;
  })(), CA.StateSetValue = (function() {
    function gA(AA) {
      if (this.states = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.states = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.states != null && AA.states.length) for (let BA = 0; BA < AA.states.length; ++BA) $root.openmetrics.StateSetValue.State.encode(AA.states[BA], IA.uint32(10).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.StateSetValue();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        iA >>> 3 === 1 ? (EA.states && EA.states.length || (EA.states = []), EA.states.push($root.openmetrics.StateSetValue.State.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.StateSetValue) return AA;
      let IA = new $root.openmetrics.StateSetValue();
      if (AA.states) {
        if (!Array.isArray(AA.states)) throw TypeError(".openmetrics.StateSetValue.states: array expected");
        IA.states = [];
        for (let BA = 0; BA < AA.states.length; ++BA) {
          if (typeof AA.states[BA] != "object") throw TypeError(".openmetrics.StateSetValue.states: object expected");
          IA.states[BA] = $root.openmetrics.StateSetValue.State.fromObject(AA.states[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.states = []), AA.states && AA.states.length) {
        BA.states = [];
        for (let QA = 0; QA < AA.states.length; ++QA) BA.states[QA] = $root.openmetrics.StateSetValue.State.toObject(AA.states[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.StateSetValue";
    }, gA.State = (function() {
      function AA(IA) {
        if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
      }
      return AA.prototype.enabled = !1, AA.prototype.name = "", AA.create = function(IA) {
        return new AA(IA);
      }, AA.encode = function(IA, BA) {
        return BA ||= $Writer.create(), IA.enabled != null && Object.hasOwnProperty.call(IA, "enabled") && BA.uint32(8).bool(IA.enabled), IA.name != null && Object.hasOwnProperty.call(IA, "name") && BA.uint32(18).string(IA.name), BA;
      }, AA.decode = function(IA, BA, QA) {
        IA instanceof $Reader || (IA = $Reader.create(IA));
        let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.StateSetValue.State();
        for (; IA.pos < EA; ) {
          let oA = IA.uint32();
          if (oA === QA) break;
          switch (oA >>> 3) {
            case 1:
              iA.enabled = IA.bool();
              break;
            case 2:
              iA.name = IA.string();
              break;
            default:
              IA.skipType(oA & 7);
              break;
          }
        }
        return iA;
      }, AA.fromObject = function(IA) {
        if (IA instanceof $root.openmetrics.StateSetValue.State) return IA;
        let BA = new $root.openmetrics.StateSetValue.State();
        return IA.enabled != null && (BA.enabled = !!IA.enabled), IA.name != null && (BA.name = String(IA.name)), BA;
      }, AA.toObject = function(IA, BA) {
        BA ||= {};
        let QA = {};
        return BA.defaults && (QA.enabled = !1, QA.name = ""), IA.enabled != null && IA.hasOwnProperty("enabled") && (QA.enabled = IA.enabled), IA.name != null && IA.hasOwnProperty("name") && (QA.name = IA.name), QA;
      }, AA.prototype.toJSON = function() {
        return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
      }, AA.getTypeUrl = function(IA) {
        return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.StateSetValue.State";
      }, AA;
    })(), gA;
  })(), CA.InfoValue = (function() {
    function gA(AA) {
      if (this.info = [], AA) for (let IA = Object.keys(AA), BA = 0; BA < IA.length; ++BA) AA[IA[BA]] != null && (this[IA[BA]] = AA[IA[BA]]);
    }
    return gA.prototype.info = $util.emptyArray, gA.create = function(AA) {
      return new gA(AA);
    }, gA.encode = function(AA, IA) {
      if (IA ||= $Writer.create(), AA.info != null && AA.info.length) for (let BA = 0; BA < AA.info.length; ++BA) $root.openmetrics.Label.encode(AA.info[BA], IA.uint32(10).fork()).ldelim();
      return IA;
    }, gA.decode = function(AA, IA, BA) {
      AA instanceof $Reader || (AA = $Reader.create(AA));
      let QA = IA === void 0 ? AA.len : AA.pos + IA, EA = new $root.openmetrics.InfoValue();
      for (; AA.pos < QA; ) {
        let iA = AA.uint32();
        if (iA === BA) break;
        iA >>> 3 === 1 ? (EA.info && EA.info.length || (EA.info = []), EA.info.push($root.openmetrics.Label.decode(AA, AA.uint32()))) : AA.skipType(iA & 7);
      }
      return EA;
    }, gA.fromObject = function(AA) {
      if (AA instanceof $root.openmetrics.InfoValue) return AA;
      let IA = new $root.openmetrics.InfoValue();
      if (AA.info) {
        if (!Array.isArray(AA.info)) throw TypeError(".openmetrics.InfoValue.info: array expected");
        IA.info = [];
        for (let BA = 0; BA < AA.info.length; ++BA) {
          if (typeof AA.info[BA] != "object") throw TypeError(".openmetrics.InfoValue.info: object expected");
          IA.info[BA] = $root.openmetrics.Label.fromObject(AA.info[BA]);
        }
      }
      return IA;
    }, gA.toObject = function(AA, IA) {
      IA ||= {};
      let BA = {};
      if ((IA.arrays || IA.defaults) && (BA.info = []), AA.info && AA.info.length) {
        BA.info = [];
        for (let QA = 0; QA < AA.info.length; ++QA) BA.info[QA] = $root.openmetrics.Label.toObject(AA.info[QA], IA);
      }
      return BA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(AA) {
      return AA === void 0 && (AA = "type.googleapis.com"), AA + "/openmetrics.InfoValue";
    }, gA;
  })(), CA.SummaryValue = (function() {
    function gA(IA) {
      if (this.quantile = [], IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
    }
    gA.prototype.doubleValue = null, gA.prototype.intValue = null, gA.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, gA.prototype.created = null, gA.prototype.quantile = $util.emptyArray;
    let AA;
    return Object.defineProperty(gA.prototype, "sum", { get: $util.oneOfGetter(AA = ["doubleValue", "intValue"]), set: $util.oneOfSetter(AA) }), gA.create = function(IA) {
      return new gA(IA);
    }, gA.encode = function(IA, BA) {
      if (BA ||= $Writer.create(), IA.doubleValue != null && Object.hasOwnProperty.call(IA, "doubleValue") && BA.uint32(9).double(IA.doubleValue), IA.intValue != null && Object.hasOwnProperty.call(IA, "intValue") && BA.uint32(16).int64(IA.intValue), IA.count != null && Object.hasOwnProperty.call(IA, "count") && BA.uint32(24).uint64(IA.count), IA.created != null && Object.hasOwnProperty.call(IA, "created") && $root.google.protobuf.Timestamp.encode(IA.created, BA.uint32(34).fork()).ldelim(), IA.quantile != null && IA.quantile.length) for (let QA = 0; QA < IA.quantile.length; ++QA) $root.openmetrics.SummaryValue.Quantile.encode(IA.quantile[QA], BA.uint32(42).fork()).ldelim();
      return BA;
    }, gA.decode = function(IA, BA, QA) {
      IA instanceof $Reader || (IA = $Reader.create(IA));
      let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.openmetrics.SummaryValue();
      for (; IA.pos < EA; ) {
        let oA = IA.uint32();
        if (oA === QA) break;
        switch (oA >>> 3) {
          case 1:
            iA.doubleValue = IA.double();
            break;
          case 2:
            iA.intValue = IA.int64();
            break;
          case 3:
            iA.count = IA.uint64();
            break;
          case 4:
            iA.created = $root.google.protobuf.Timestamp.decode(IA, IA.uint32());
            break;
          case 5:
            iA.quantile && iA.quantile.length || (iA.quantile = []), iA.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(IA, IA.uint32()));
            break;
          default:
            IA.skipType(oA & 7);
            break;
        }
      }
      return iA;
    }, gA.fromObject = function(IA) {
      if (IA instanceof $root.openmetrics.SummaryValue) return IA;
      let BA = new $root.openmetrics.SummaryValue();
      if (IA.doubleValue != null && (BA.doubleValue = Number(IA.doubleValue)), IA.intValue != null && ($util.Long ? (BA.intValue = $util.Long.fromValue(IA.intValue)).unsigned = !1 : typeof IA.intValue == "string" ? BA.intValue = parseInt(IA.intValue, 10) : typeof IA.intValue == "number" ? BA.intValue = IA.intValue : typeof IA.intValue == "object" && (BA.intValue = new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber())), IA.count != null && ($util.Long ? (BA.count = $util.Long.fromValue(IA.count)).unsigned = !0 : typeof IA.count == "string" ? BA.count = parseInt(IA.count, 10) : typeof IA.count == "number" ? BA.count = IA.count : typeof IA.count == "object" && (BA.count = new $util.LongBits(IA.count.low >>> 0, IA.count.high >>> 0).toNumber(!0))), IA.created != null) {
        if (typeof IA.created != "object") throw TypeError(".openmetrics.SummaryValue.created: object expected");
        BA.created = $root.google.protobuf.Timestamp.fromObject(IA.created);
      }
      if (IA.quantile) {
        if (!Array.isArray(IA.quantile)) throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        BA.quantile = [];
        for (let QA = 0; QA < IA.quantile.length; ++QA) {
          if (typeof IA.quantile[QA] != "object") throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          BA.quantile[QA] = $root.openmetrics.SummaryValue.Quantile.fromObject(IA.quantile[QA]);
        }
      }
      return BA;
    }, gA.toObject = function(IA, BA) {
      BA ||= {};
      let QA = {};
      if ((BA.arrays || BA.defaults) && (QA.quantile = []), BA.defaults) {
        if ($util.Long) {
          let EA = new $util.Long(0, 0, !0);
          QA.count = BA.longs === String ? EA.toString() : BA.longs === Number ? EA.toNumber() : EA;
        } else QA.count = BA.longs === String ? "0" : 0;
        QA.created = null;
      }
      if (IA.doubleValue != null && IA.hasOwnProperty("doubleValue") && (QA.doubleValue = BA.json && !isFinite(IA.doubleValue) ? String(IA.doubleValue) : IA.doubleValue, BA.oneofs && (QA.sum = "doubleValue")), IA.intValue != null && IA.hasOwnProperty("intValue") && (typeof IA.intValue == "number" ? QA.intValue = BA.longs === String ? String(IA.intValue) : IA.intValue : QA.intValue = BA.longs === String ? $util.Long.prototype.toString.call(IA.intValue) : BA.longs === Number ? new $util.LongBits(IA.intValue.low >>> 0, IA.intValue.high >>> 0).toNumber() : IA.intValue, BA.oneofs && (QA.sum = "intValue")), IA.count != null && IA.hasOwnProperty("count") && (typeof IA.count == "number" ? QA.count = BA.longs === String ? String(IA.count) : IA.count : QA.count = BA.longs === String ? $util.Long.prototype.toString.call(IA.count) : BA.longs === Number ? new $util.LongBits(IA.count.low >>> 0, IA.count.high >>> 0).toNumber(!0) : IA.count), IA.created != null && IA.hasOwnProperty("created") && (QA.created = $root.google.protobuf.Timestamp.toObject(IA.created, BA)), IA.quantile && IA.quantile.length) {
        QA.quantile = [];
        for (let EA = 0; EA < IA.quantile.length; ++EA) QA.quantile[EA] = $root.openmetrics.SummaryValue.Quantile.toObject(IA.quantile[EA], BA);
      }
      return QA;
    }, gA.prototype.toJSON = function() {
      return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
    }, gA.getTypeUrl = function(IA) {
      return IA === void 0 && (IA = "type.googleapis.com"), IA + "/openmetrics.SummaryValue";
    }, gA.Quantile = (function() {
      function IA(BA) {
        if (BA) for (let QA = Object.keys(BA), EA = 0; EA < QA.length; ++EA) BA[QA[EA]] != null && (this[QA[EA]] = BA[QA[EA]]);
      }
      return IA.prototype.quantile = 0, IA.prototype.value = 0, IA.create = function(BA) {
        return new IA(BA);
      }, IA.encode = function(BA, QA) {
        return QA ||= $Writer.create(), BA.quantile != null && Object.hasOwnProperty.call(BA, "quantile") && QA.uint32(9).double(BA.quantile), BA.value != null && Object.hasOwnProperty.call(BA, "value") && QA.uint32(17).double(BA.value), QA;
      }, IA.decode = function(BA, QA, EA) {
        BA instanceof $Reader || (BA = $Reader.create(BA));
        let iA = QA === void 0 ? BA.len : BA.pos + QA, oA = new $root.openmetrics.SummaryValue.Quantile();
        for (; BA.pos < iA; ) {
          let cA = BA.uint32();
          if (cA === EA) break;
          switch (cA >>> 3) {
            case 1:
              oA.quantile = BA.double();
              break;
            case 2:
              oA.value = BA.double();
              break;
            default:
              BA.skipType(cA & 7);
              break;
          }
        }
        return oA;
      }, IA.fromObject = function(BA) {
        if (BA instanceof $root.openmetrics.SummaryValue.Quantile) return BA;
        let QA = new $root.openmetrics.SummaryValue.Quantile();
        return BA.quantile != null && (QA.quantile = Number(BA.quantile)), BA.value != null && (QA.value = Number(BA.value)), QA;
      }, IA.toObject = function(BA, QA) {
        QA ||= {};
        let EA = {};
        return QA.defaults && (EA.quantile = 0, EA.value = 0), BA.quantile != null && BA.hasOwnProperty("quantile") && (EA.quantile = QA.json && !isFinite(BA.quantile) ? String(BA.quantile) : BA.quantile), BA.value != null && BA.hasOwnProperty("value") && (EA.value = QA.json && !isFinite(BA.value) ? String(BA.value) : BA.value), EA;
      }, IA.prototype.toJSON = function() {
        return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
      }, IA.getTypeUrl = function(BA) {
        return BA === void 0 && (BA = "type.googleapis.com"), BA + "/openmetrics.SummaryValue.Quantile";
      }, IA;
    })(), gA;
  })(), CA;
})();
$root.google = (() => {
  let CA = {};
  return CA.protobuf = (function() {
    let gA = {};
    return gA.Timestamp = (function() {
      function AA(IA) {
        if (IA) for (let BA = Object.keys(IA), QA = 0; QA < BA.length; ++QA) IA[BA[QA]] != null && (this[BA[QA]] = IA[BA[QA]]);
      }
      return AA.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, AA.prototype.nanos = 0, AA.create = function(IA) {
        return new AA(IA);
      }, AA.encode = function(IA, BA) {
        return BA ||= $Writer.create(), IA.seconds != null && Object.hasOwnProperty.call(IA, "seconds") && BA.uint32(8).int64(IA.seconds), IA.nanos != null && Object.hasOwnProperty.call(IA, "nanos") && BA.uint32(16).int32(IA.nanos), BA;
      }, AA.decode = function(IA, BA, QA) {
        IA instanceof $Reader || (IA = $Reader.create(IA));
        let EA = BA === void 0 ? IA.len : IA.pos + BA, iA = new $root.google.protobuf.Timestamp();
        for (; IA.pos < EA; ) {
          let oA = IA.uint32();
          if (oA === QA) break;
          switch (oA >>> 3) {
            case 1:
              iA.seconds = IA.int64();
              break;
            case 2:
              iA.nanos = IA.int32();
              break;
            default:
              IA.skipType(oA & 7);
              break;
          }
        }
        return iA;
      }, AA.fromObject = function(IA) {
        if (IA instanceof $root.google.protobuf.Timestamp) return IA;
        let BA = new $root.google.protobuf.Timestamp();
        return IA.seconds != null && ($util.Long ? (BA.seconds = $util.Long.fromValue(IA.seconds)).unsigned = !1 : typeof IA.seconds == "string" ? BA.seconds = parseInt(IA.seconds, 10) : typeof IA.seconds == "number" ? BA.seconds = IA.seconds : typeof IA.seconds == "object" && (BA.seconds = new $util.LongBits(IA.seconds.low >>> 0, IA.seconds.high >>> 0).toNumber())), IA.nanos != null && (BA.nanos = IA.nanos | 0), BA;
      }, AA.toObject = function(IA, BA) {
        BA ||= {};
        let QA = {};
        if (BA.defaults) {
          if ($util.Long) {
            let EA = new $util.Long(0, 0, !1);
            QA.seconds = BA.longs === String ? EA.toString() : BA.longs === Number ? EA.toNumber() : EA;
          } else QA.seconds = BA.longs === String ? "0" : 0;
          QA.nanos = 0;
        }
        return IA.seconds != null && IA.hasOwnProperty("seconds") && (typeof IA.seconds == "number" ? QA.seconds = BA.longs === String ? String(IA.seconds) : IA.seconds : QA.seconds = BA.longs === String ? $util.Long.prototype.toString.call(IA.seconds) : BA.longs === Number ? new $util.LongBits(IA.seconds.low >>> 0, IA.seconds.high >>> 0).toNumber() : IA.seconds), IA.nanos != null && IA.hasOwnProperty("nanos") && (QA.nanos = IA.nanos), QA;
      }, AA.prototype.toJSON = function() {
        return this.constructor.toObject(this, import_minimal.util.toJSONOptions);
      }, AA.getTypeUrl = function(IA) {
        return IA === void 0 && (IA = "type.googleapis.com"), IA + "/google.protobuf.Timestamp";
      }, AA;
    })(), gA;
  })(), CA;
})();
$root.RootContainer = (() => {
  let CA = {}, gA = Object.create(CA);
  return gA[CA[0] = "MAIN"] = 0, gA[CA[1] = "SIDEBAR"] = 1, gA[CA[2] = "EVENT"] = 2, gA[CA[3] = "BOTTOM"] = 3, gA;
})();
Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
  let CA, gA, AA = new Promise((IA, BA) => {
    CA = IA, gA = BA;
  });
  return { resolve: CA, reject: gA, promise: AA };
});
function r$2(CA) {
  return typeof structuredClone == "function" ? structuredClone(CA) : JSON.parse(JSON.stringify(CA));
}
function i$1(CA) {
  return Object.freeze(CA), Array.isArray(CA) ? CA.forEach((gA) => {
    typeof gA == "object" && gA && !Object.isFrozen(gA) && i$1(gA);
  }) : Object.values(CA).forEach((gA) => {
    typeof gA == "object" && gA && !Object.isFrozen(gA) && i$1(gA);
  }), CA;
}
(() => {
  let CA = window.__streamlit;
  if (CA) return i$1(r$2(CA));
})();
(0, import_loglevel.getLogger)("StaticConnection");
(0, import_loglevel.getLogger)("DoInitPings");
(0, import_loglevel.getLogger)("ForwardMessageCache");
(0, import_loglevel.getLogger)("WebsocketConnection");
(0, import_loglevel.getLogger)("ConnectionManager");
(0, import_loglevel.getLogger)("DefaultStreamlitEndpoints");
const LOG$8 = loglevelExports.getLogger("ConnectionManager");
class ConnectionManager {
  props;
  connectionState = ConnectionState$1.INITIAL;
  constructor(gA) {
    this.props = gA, this.connect();
  }
  /**
   * Indicates whether we're connected to the server.
   */
  isConnected() {
    return this.connectionState === ConnectionState$1.CONNECTED;
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.connectionState === ConnectionState$1.CONNECTED) {
      const gA = new URL("https://stlite.invalid/");
      return gA.pathname = this.props.kernel.basePath, gA;
    }
  }
  sendMessage(gA) {
    if (this.isConnected()) {
      const AA = BackMsg.create(gA), IA = BackMsg.encode(AA).finish();
      this.props.kernel.sendWebSocketMessage(IA);
    } else
      LOG$8.error(`Cannot send message when server is disconnected: ${gA}`);
  }
  /**
   * Increment the runCount on our message cache, and clear entries
   * whose age is greater than the max.
   */
  incrementMessageCacheRunCount(gA, AA) {
  }
  getCachedMessageHashes() {
    return [];
  }
  /**
   * Establish either a WebsocketConnection or StaticConnection
   * based on query params.
   */
  async connect() {
    const gA = "_stcore/stream";
    try {
      this.props.kernel.onWebSocketMessage((AA) => {
        if (typeof AA == "string") {
          LOG$8.error("Unexpected payload type.");
          return;
        }
        this.handleMessage(AA);
      }), await this.props.kernel.loaded, console.debug("The kernel has been loaded. Start connecting."), this.props.onHostConfigResp(this.props.kernel.hostConfigProperties), await this.props.kernel.connectWebSocket("/" + gA), this.setConnectionState(ConnectionState$1.CONNECTED);
    } catch (AA) {
      const IA = AA instanceof Error ? AA : new Error(`${AA}`);
      LOG$8.error(`Client Error: Websocket connection - ${IA.message}`), this.props.sendClientError("Failed to establish websocket connection", IA.message, "Connection Manager"), this.setConnectionState(ConnectionState$1.DISCONNECTED_FOREVER, IA.message);
    }
  }
  disconnect() {
  }
  onHeartbeatSent(gA) {
  }
  onHeartbeatAckReceived() {
  }
  setConnectionState = (gA, AA) => {
    this.connectionState !== gA && (this.connectionState = gA, this.props.connectionStateChanged(gA)), AA && this.props.onConnectionError({
      message: AA
    });
  };
  // Stlite: the following properties and methods are copied from WebsocketConnection.tsx
  /**
   * To guarantee packet transmission order, this is the index of the last
   * dispatched incoming message.
   */
  lastDispatchedMessageIndex = -1;
  /**
   * And this is the index of the next message we receive.
   */
  nextMessageIndex = 0;
  /**
   * This dictionary stores received messages that we haven't sent out yet
   * (because we're still decoding previous messages)
   */
  messageQueue = {};
  async handleMessage(gA) {
    const AA = this.nextMessageIndex;
    this.nextMessageIndex += 1;
    const IA = new Uint8Array(gA), BA = ForwardMsg.decode(IA);
    if (BA.type === "refHash")
      throw new Error("Unexpected cache reference message.");
    for (this.messageQueue[AA] = BA; this.lastDispatchedMessageIndex + 1 in this.messageQueue; ) {
      const QA = this.lastDispatchedMessageIndex + 1;
      this.props.onMessage(this.messageQueue[QA]), delete this.messageQueue[QA], this.lastDispatchedMessageIndex = QA;
    }
  }
}
const MEDIA_ENDPOINT$1 = "/media";
function resolveStliteObjectUrl(CA, gA) {
  return CA.sendHttpRequest({
    method: "GET",
    path: gA,
    headers: {},
    body: ""
  }).then(({
    statusCode: AA,
    headers: IA,
    body: BA
  }) => {
    if (AA !== 200)
      throw new Error(`Failed to fetch media object: ${AA}`);
    const QA = IA.get("Content-Type"), EA = new Blob([BA], QA ? {
      type: QA
    } : void 0);
    return URL.createObjectURL(EA);
  });
}
function resolveStliteObjectUrlIfNeeded(CA, gA) {
  return gA.startsWith(MEDIA_ENDPOINT$1) ? resolveStliteObjectUrl(CA, gA) : Promise.resolve(gA);
}
function resolveLogo(CA, gA) {
  return Promise.all([resolveStliteObjectUrlIfNeeded(CA, gA.image), resolveStliteObjectUrlIfNeeded(CA, gA.iconImage)]).then(([AA, IA]) => ({
    ...gA,
    image: AA,
    iconImage: IA
  }));
}
function useStliteResolvedLogo(CA) {
  const gA = useStliteKernel(), [AA, IA] = useState(null);
  return useEffect(() => {
    if (CA == null)
      return;
    let BA = !1;
    const QA = [];
    return resolveLogo(gA, CA).then((EA) => {
      BA || (QA.push(EA.image), QA.push(EA.iconImage), IA(EA));
    }), () => {
      QA.forEach((EA) => {
        URL.revokeObjectURL(EA);
      }), BA = !0;
    };
  }, [gA, CA]), AA;
}
function useStliteMediaObjectUrl(CA) {
  const gA = useStliteKernel(), [AA, IA] = useState(CA);
  return useEffect(() => {
    if (gA == null || !CA.startsWith(MEDIA_ENDPOINT$1))
      return;
    let BA = !1;
    const QA = [];
    return resolveStliteObjectUrl(gA, CA).then((EA) => {
      BA || (QA.push(EA), IA(EA));
    }), () => {
      BA = !0, QA.forEach((EA) => {
        URL.revokeObjectURL(EA);
      });
    };
  }, [gA, CA]), AA;
}
function useStliteMediaObjects(CA) {
  const [gA, AA] = useState(CA.filter((BA) => BA.url == null || !BA.url.startsWith(MEDIA_ENDPOINT$1))), IA = useStliteKernel();
  return useEffect(() => {
    if (IA == null)
      return;
    let BA = !1;
    const QA = [], EA = CA.map((iA) => iA.url == null || !iA.url.startsWith(MEDIA_ENDPOINT$1) ? iA : resolveStliteObjectUrl(IA, iA.url).then((oA) => BA ? iA : (QA.push(oA), {
      ...iA,
      url: oA
    })));
    return Promise.all(EA).then((iA) => {
      BA || AA(iA);
    }), () => {
      BA = !0, QA.forEach((iA) => {
        URL.revokeObjectURL(iA);
      });
    };
  }, [IA, CA]), gA;
}
function extractCustomComponentPath(CA, gA) {
  const AA = new URL(gA), IA = new URL(CA, "https://stlite.invalid/");
  if (AA.hostname !== IA.hostname)
    return null;
  const BA = IA.pathname.replace(/\/$/, ""), QA = new RegExp(`^${BA}(/.*?$)`), EA = AA.pathname.match(QA);
  return EA == null ? null : EA[1] + AA.search + AA.hash;
}
function getParentPath(CA) {
  const gA = CA.split("/").slice(0, -1).join("/");
  return gA.startsWith("/") ? gA : "/" + gA;
}
function getRelativePath(CA, gA, AA) {
  const IA = getParentPath(gA);
  if (!(AA.host === CA && AA.pathname.startsWith(IA)))
    return null;
  const QA = AA.pathname.slice(IA.length);
  return QA.startsWith("/") ? QA.slice(1) : QA;
}
var lib = {}, activitymonitor = {}, ArrayExt;
(function(CA) {
  function gA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA === 0)
      return -1;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA;
    dA < FA ? pA = dA + 1 + (kA - FA) : pA = dA - FA + 1;
    for (let YA = 0; YA < pA; ++YA) {
      let SA = (FA + YA) % kA;
      if (bA[SA] === RA)
        return SA;
    }
    return -1;
  }
  CA.firstIndexOf = gA;
  function AA(bA, RA, FA = -1, dA = 0) {
    let kA = bA.length;
    if (kA === 0)
      return -1;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA;
    FA < dA ? pA = FA + 1 + (kA - dA) : pA = FA - dA + 1;
    for (let YA = 0; YA < pA; ++YA) {
      let SA = (FA - YA + kA) % kA;
      if (bA[SA] === RA)
        return SA;
    }
    return -1;
  }
  CA.lastIndexOf = AA;
  function IA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA === 0)
      return -1;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA;
    dA < FA ? pA = dA + 1 + (kA - FA) : pA = dA - FA + 1;
    for (let YA = 0; YA < pA; ++YA) {
      let SA = (FA + YA) % kA;
      if (RA(bA[SA], SA))
        return SA;
    }
    return -1;
  }
  CA.findFirstIndex = IA;
  function BA(bA, RA, FA = -1, dA = 0) {
    let kA = bA.length;
    if (kA === 0)
      return -1;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA;
    FA < dA ? pA = FA + 1 + (kA - dA) : pA = FA - dA + 1;
    for (let YA = 0; YA < pA; ++YA) {
      let SA = (FA - YA + kA) % kA;
      if (RA(bA[SA], SA))
        return SA;
    }
    return -1;
  }
  CA.findLastIndex = BA;
  function QA(bA, RA, FA = 0, dA = -1) {
    let kA = IA(bA, RA, FA, dA);
    return kA !== -1 ? bA[kA] : void 0;
  }
  CA.findFirstValue = QA;
  function EA(bA, RA, FA = -1, dA = 0) {
    let kA = BA(bA, RA, FA, dA);
    return kA !== -1 ? bA[kA] : void 0;
  }
  CA.findLastValue = EA;
  function iA(bA, RA, FA, dA = 0, kA = -1) {
    let pA = bA.length;
    if (pA === 0)
      return 0;
    dA < 0 ? dA = Math.max(0, dA + pA) : dA = Math.min(dA, pA - 1), kA < 0 ? kA = Math.max(0, kA + pA) : kA = Math.min(kA, pA - 1);
    let YA = dA, SA = kA - dA + 1;
    for (; SA > 0; ) {
      let JA = SA >> 1, UA = YA + JA;
      FA(bA[UA], RA) < 0 ? (YA = UA + 1, SA -= JA + 1) : SA = JA;
    }
    return YA;
  }
  CA.lowerBound = iA;
  function oA(bA, RA, FA, dA = 0, kA = -1) {
    let pA = bA.length;
    if (pA === 0)
      return 0;
    dA < 0 ? dA = Math.max(0, dA + pA) : dA = Math.min(dA, pA - 1), kA < 0 ? kA = Math.max(0, kA + pA) : kA = Math.min(kA, pA - 1);
    let YA = dA, SA = kA - dA + 1;
    for (; SA > 0; ) {
      let JA = SA >> 1, UA = YA + JA;
      FA(bA[UA], RA) > 0 ? SA = JA : (YA = UA + 1, SA -= JA + 1);
    }
    return YA;
  }
  CA.upperBound = oA;
  function cA(bA, RA, FA) {
    if (bA === RA)
      return !0;
    if (bA.length !== RA.length)
      return !1;
    for (let dA = 0, kA = bA.length; dA < kA; ++dA)
      if (FA ? !FA(bA[dA], RA[dA]) : bA[dA] !== RA[dA])
        return !1;
    return !0;
  }
  CA.shallowEqual = cA;
  function tA(bA, RA = {}) {
    let { start: FA, stop: dA, step: kA } = RA;
    if (kA === void 0 && (kA = 1), kA === 0)
      throw new Error("Slice `step` cannot be zero.");
    let pA = bA.length;
    FA === void 0 ? FA = kA < 0 ? pA - 1 : 0 : FA < 0 ? FA = Math.max(FA + pA, kA < 0 ? -1 : 0) : FA >= pA && (FA = kA < 0 ? pA - 1 : pA), dA === void 0 ? dA = kA < 0 ? -1 : pA : dA < 0 ? dA = Math.max(dA + pA, kA < 0 ? -1 : 0) : dA >= pA && (dA = kA < 0 ? pA - 1 : pA);
    let YA;
    kA < 0 && dA >= FA || kA > 0 && FA >= dA ? YA = 0 : kA < 0 ? YA = Math.floor((dA - FA + 1) / kA + 1) : YA = Math.floor((dA - FA - 1) / kA + 1);
    let SA = [];
    for (let JA = 0; JA < YA; ++JA)
      SA[JA] = bA[FA + JA * kA];
    return SA;
  }
  CA.slice = tA;
  function eA(bA, RA, FA) {
    let dA = bA.length;
    if (dA <= 1 || (RA < 0 ? RA = Math.max(0, RA + dA) : RA = Math.min(RA, dA - 1), FA < 0 ? FA = Math.max(0, FA + dA) : FA = Math.min(FA, dA - 1), RA === FA))
      return;
    let kA = bA[RA], pA = RA < FA ? 1 : -1;
    for (let YA = RA; YA !== FA; YA += pA)
      bA[YA] = bA[YA + pA];
    bA[FA] = kA;
  }
  CA.move = eA;
  function aA(bA, RA = 0, FA = -1) {
    let dA = bA.length;
    if (!(dA <= 1))
      for (RA < 0 ? RA = Math.max(0, RA + dA) : RA = Math.min(RA, dA - 1), FA < 0 ? FA = Math.max(0, FA + dA) : FA = Math.min(FA, dA - 1); RA < FA; ) {
        let kA = bA[RA], pA = bA[FA];
        bA[RA++] = pA, bA[FA--] = kA;
      }
  }
  CA.reverse = aA;
  function GA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA <= 1 || (FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1), FA >= dA))
      return;
    let pA = dA - FA + 1;
    if (RA > 0 ? RA = RA % pA : RA < 0 && (RA = (RA % pA + pA) % pA), RA === 0)
      return;
    let YA = FA + RA;
    aA(bA, FA, YA - 1), aA(bA, YA, dA), aA(bA, FA, dA);
  }
  CA.rotate = GA;
  function lA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA === 0)
      return;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA;
    dA < FA ? pA = dA + 1 + (kA - FA) : pA = dA - FA + 1;
    for (let YA = 0; YA < pA; ++YA)
      bA[(FA + YA) % kA] = RA;
  }
  CA.fill = lA;
  function nA(bA, RA, FA) {
    let dA = bA.length;
    RA < 0 ? RA = Math.max(0, RA + dA) : RA = Math.min(RA, dA);
    for (let kA = dA; kA > RA; --kA)
      bA[kA] = bA[kA - 1];
    bA[RA] = FA;
  }
  CA.insert = nA;
  function DA(bA, RA) {
    let FA = bA.length;
    if (RA < 0 && (RA += FA), RA < 0 || RA >= FA)
      return;
    let dA = bA[RA];
    for (let kA = RA + 1; kA < FA; ++kA)
      bA[kA - 1] = bA[kA];
    return bA.length = FA - 1, dA;
  }
  CA.removeAt = DA;
  function hA(bA, RA, FA = 0, dA = -1) {
    let kA = gA(bA, RA, FA, dA);
    return kA !== -1 && DA(bA, kA), kA;
  }
  CA.removeFirstOf = hA;
  function wA(bA, RA, FA = -1, dA = 0) {
    let kA = AA(bA, RA, FA, dA);
    return kA !== -1 && DA(bA, kA), kA;
  }
  CA.removeLastOf = wA;
  function sA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA === 0)
      return 0;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA = 0;
    for (let YA = 0; YA < kA; ++YA)
      FA <= dA && YA >= FA && YA <= dA && bA[YA] === RA || dA < FA && (YA <= dA || YA >= FA) && bA[YA] === RA ? pA++ : pA > 0 && (bA[YA - pA] = bA[YA]);
    return pA > 0 && (bA.length = kA - pA), pA;
  }
  CA.removeAllOf = sA;
  function NA(bA, RA, FA = 0, dA = -1) {
    let kA, pA = IA(bA, RA, FA, dA);
    return pA !== -1 && (kA = DA(bA, pA)), { index: pA, value: kA };
  }
  CA.removeFirstWhere = NA;
  function rA(bA, RA, FA = -1, dA = 0) {
    let kA, pA = BA(bA, RA, FA, dA);
    return pA !== -1 && (kA = DA(bA, pA)), { index: pA, value: kA };
  }
  CA.removeLastWhere = rA;
  function yA(bA, RA, FA = 0, dA = -1) {
    let kA = bA.length;
    if (kA === 0)
      return 0;
    FA < 0 ? FA = Math.max(0, FA + kA) : FA = Math.min(FA, kA - 1), dA < 0 ? dA = Math.max(0, dA + kA) : dA = Math.min(dA, kA - 1);
    let pA = 0;
    for (let YA = 0; YA < kA; ++YA)
      FA <= dA && YA >= FA && YA <= dA && RA(bA[YA], YA) || dA < FA && (YA <= dA || YA >= FA) && RA(bA[YA], YA) ? pA++ : pA > 0 && (bA[YA - pA] = bA[YA]);
    return pA > 0 && (bA.length = kA - pA), pA;
  }
  CA.removeAllWhere = yA;
})(ArrayExt || (ArrayExt = {}));
function* chain(...CA) {
  for (const gA of CA)
    yield* gA;
}
function* empty() {
}
function* enumerate(CA, gA = 0) {
  for (const AA of CA)
    yield [gA++, AA];
}
function* filter$1(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    gA(IA, AA++) && (yield IA);
}
function find(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    if (gA(IA, AA++))
      return IA;
}
function findIndex(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    if (gA(IA, AA++))
      return AA - 1;
  return -1;
}
function min(CA, gA) {
  let AA;
  for (const IA of CA) {
    if (AA === void 0) {
      AA = IA;
      continue;
    }
    gA(IA, AA) < 0 && (AA = IA);
  }
  return AA;
}
function max(CA, gA) {
  let AA;
  for (const IA of CA) {
    if (AA === void 0) {
      AA = IA;
      continue;
    }
    gA(IA, AA) > 0 && (AA = IA);
  }
  return AA;
}
function minmax(CA, gA) {
  let AA = !0, IA, BA;
  for (const QA of CA)
    AA ? (IA = QA, BA = QA, AA = !1) : gA(QA, IA) < 0 ? IA = QA : gA(QA, BA) > 0 && (BA = QA);
  return AA ? void 0 : [IA, BA];
}
function toArray$1(CA) {
  return Array.from(CA);
}
function toObject(CA) {
  const gA = {};
  for (const [AA, IA] of CA)
    gA[AA] = IA;
  return gA;
}
function each(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    if (gA(IA, AA++) === !1)
      return;
}
function every(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    if (gA(IA, AA++) === !1)
      return !1;
  return !0;
}
function some(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    if (gA(IA, AA++))
      return !0;
  return !1;
}
function* map(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    yield gA(IA, AA++);
}
function* range(CA, gA, AA) {
  gA === void 0 ? (gA = CA, CA = 0, AA = 1) : AA === void 0 && (AA = 1);
  const IA = Private$2.rangeLength(CA, gA, AA);
  for (let BA = 0; BA < IA; BA++)
    yield CA + AA * BA;
}
var Private$2;
(function(CA) {
  function gA(AA, IA, BA) {
    return BA === 0 ? 1 / 0 : AA > IA && BA > 0 || AA < IA && BA < 0 ? 0 : Math.ceil((IA - AA) / BA);
  }
  CA.rangeLength = gA;
})(Private$2 || (Private$2 = {}));
function reduce(CA, gA, AA) {
  const IA = CA[Symbol.iterator]();
  let BA = 0, QA = IA.next();
  if (QA.done && AA === void 0)
    throw new TypeError("Reduce of empty iterable with no initial value.");
  if (QA.done)
    return AA;
  let EA = IA.next();
  if (EA.done && AA === void 0)
    return QA.value;
  if (EA.done)
    return gA(AA, QA.value, BA++);
  let iA;
  AA === void 0 ? iA = gA(QA.value, EA.value, BA++) : iA = gA(gA(AA, QA.value, BA++), EA.value, BA++);
  let oA;
  for (; !(oA = IA.next()).done; )
    iA = gA(iA, oA.value, BA++);
  return iA;
}
function* repeat(CA, gA) {
  for (; 0 < gA--; )
    yield CA;
}
function* once(CA) {
  yield CA;
}
function* retro(CA) {
  if (typeof CA.retro == "function")
    yield* CA.retro();
  else
    for (let gA = CA.length - 1; gA > -1; gA--)
      yield CA[gA];
}
function topologicSort(CA) {
  let gA = [], AA = /* @__PURE__ */ new Set(), IA = /* @__PURE__ */ new Map();
  for (const EA of CA)
    BA(EA);
  for (const [EA] of IA)
    QA(EA);
  return gA;
  function BA(EA) {
    let [iA, oA] = EA, cA = IA.get(oA);
    cA ? cA.push(iA) : IA.set(oA, [iA]);
  }
  function QA(EA) {
    if (AA.has(EA))
      return;
    AA.add(EA);
    let iA = IA.get(EA);
    if (iA)
      for (const oA of iA)
        QA(oA);
    gA.push(EA);
  }
}
function* stride(CA, gA) {
  let AA = 0;
  for (const IA of CA)
    AA++ % gA === 0 && (yield IA);
}
var StringExt;
(function(CA) {
  function gA(EA, iA, oA = 0) {
    let cA = new Array(iA.length);
    for (let tA = 0, eA = oA, aA = iA.length; tA < aA; ++tA, ++eA) {
      if (eA = EA.indexOf(iA[tA], eA), eA === -1)
        return null;
      cA[tA] = eA;
    }
    return cA;
  }
  CA.findIndices = gA;
  function AA(EA, iA, oA = 0) {
    let cA = gA(EA, iA, oA);
    if (!cA)
      return null;
    let tA = 0;
    for (let eA = 0, aA = cA.length; eA < aA; ++eA) {
      let GA = cA[eA] - oA;
      tA += GA * GA;
    }
    return { score: tA, indices: cA };
  }
  CA.matchSumOfSquares = AA;
  function IA(EA, iA, oA = 0) {
    let cA = gA(EA, iA, oA);
    if (!cA)
      return null;
    let tA = 0, eA = oA - 1;
    for (let aA = 0, GA = cA.length; aA < GA; ++aA) {
      let lA = cA[aA];
      tA += lA - eA - 1, eA = lA;
    }
    return { score: tA, indices: cA };
  }
  CA.matchSumOfDeltas = IA;
  function BA(EA, iA, oA) {
    let cA = [], tA = 0, eA = 0, aA = iA.length;
    for (; tA < aA; ) {
      let GA = iA[tA], lA = iA[tA];
      for (; ++tA < aA && iA[tA] === lA + 1; )
        lA++;
      eA < GA && cA.push(EA.slice(eA, GA)), GA < lA + 1 && cA.push(oA(EA.slice(GA, lA + 1))), eA = lA + 1;
    }
    return eA < EA.length && cA.push(EA.slice(eA)), cA;
  }
  CA.highlight = BA;
  function QA(EA, iA) {
    return EA < iA ? -1 : EA > iA ? 1 : 0;
  }
  CA.cmp = QA;
})(StringExt || (StringExt = {}));
function* take(CA, gA) {
  if (gA < 1)
    return;
  const AA = CA[Symbol.iterator]();
  let IA;
  for (; 0 < gA-- && !(IA = AA.next()).done; )
    yield IA.value;
}
function* zip(...CA) {
  const gA = CA.map((IA) => IA[Symbol.iterator]());
  let AA = gA.map((IA) => IA.next());
  for (; every(AA, (IA) => !IA.done); AA = gA.map((IA) => IA.next()))
    yield AA.map((IA) => IA.value);
}
const index_es6$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get ArrayExt() {
    return ArrayExt;
  },
  get StringExt() {
    return StringExt;
  },
  chain,
  each,
  empty,
  enumerate,
  every,
  filter: filter$1,
  find,
  findIndex,
  map,
  max,
  min,
  minmax,
  once,
  range,
  reduce,
  repeat,
  retro,
  some,
  stride,
  take,
  toArray: toArray$1,
  toObject,
  topologicSort,
  zip
}, Symbol.toStringTag, { value: "Module" }));
var JSONExt;
(function(CA) {
  CA.emptyObject = Object.freeze({}), CA.emptyArray = Object.freeze([]);
  function gA(tA) {
    return tA === null || typeof tA == "boolean" || typeof tA == "number" || typeof tA == "string";
  }
  CA.isPrimitive = gA;
  function AA(tA) {
    return Array.isArray(tA);
  }
  CA.isArray = AA;
  function IA(tA) {
    return !gA(tA) && !AA(tA);
  }
  CA.isObject = IA;
  function BA(tA, eA) {
    if (tA === eA)
      return !0;
    if (gA(tA) || gA(eA))
      return !1;
    let aA = AA(tA), GA = AA(eA);
    return aA !== GA ? !1 : aA && GA ? EA(tA, eA) : iA(tA, eA);
  }
  CA.deepEqual = BA;
  function QA(tA) {
    return gA(tA) ? tA : AA(tA) ? oA(tA) : cA(tA);
  }
  CA.deepCopy = QA;
  function EA(tA, eA) {
    if (tA === eA)
      return !0;
    if (tA.length !== eA.length)
      return !1;
    for (let aA = 0, GA = tA.length; aA < GA; ++aA)
      if (!BA(tA[aA], eA[aA]))
        return !1;
    return !0;
  }
  function iA(tA, eA) {
    if (tA === eA)
      return !0;
    for (let aA in tA)
      if (tA[aA] !== void 0 && !(aA in eA))
        return !1;
    for (let aA in eA)
      if (eA[aA] !== void 0 && !(aA in tA))
        return !1;
    for (let aA in tA) {
      let GA = tA[aA], lA = eA[aA];
      if (!(GA === void 0 && lA === void 0) && (GA === void 0 || lA === void 0 || !BA(GA, lA)))
        return !1;
    }
    return !0;
  }
  function oA(tA) {
    let eA = new Array(tA.length);
    for (let aA = 0, GA = tA.length; aA < GA; ++aA)
      eA[aA] = QA(tA[aA]);
    return eA;
  }
  function cA(tA) {
    let eA = {};
    for (let aA in tA) {
      let GA = tA[aA];
      GA !== void 0 && (eA[aA] = QA(GA));
    }
    return eA;
  }
})(JSONExt || (JSONExt = {}));
var Private$1;
(function(CA) {
  class gA {
    constructor(iA) {
      var oA, cA, tA, eA;
      this._activated = !1, this._promise = null, this._service = null, this.id = iA.id, this.description = (oA = iA.description) !== null && oA !== void 0 ? oA : "", this.activate = iA.activate, this.deactivate = (cA = iA.deactivate) !== null && cA !== void 0 ? cA : null, this.provides = (tA = iA.provides) !== null && tA !== void 0 ? tA : null, this.autoStart = (eA = iA.autoStart) !== null && eA !== void 0 ? eA : !1, this.requires = iA.requires ? iA.requires.slice() : [], this.optional = iA.optional ? iA.optional.slice() : [];
    }
    /**
     * Whether the plugin has been activated.
     */
    get activated() {
      return this._activated;
    }
    set activated(iA) {
      this._activated = iA;
    }
    /**
     * The resolved service for the plugin, or `null`.
     */
    get service() {
      return this._service;
    }
    set service(iA) {
      this._service = iA;
    }
    /**
     * The pending resolver promise, or `null`.
     */
    get promise() {
      return this._promise;
    }
    set promise(iA) {
      this._promise = iA;
    }
  }
  function AA(EA) {
    return new gA(EA);
  }
  CA.createPluginData = AA;
  function IA(EA, iA, oA) {
    const cA = [...EA.requires, ...EA.optional], tA = (aA) => {
      if (aA === EA.provides)
        return !0;
      const GA = oA.get(aA);
      if (!GA)
        return !1;
      const lA = iA.get(GA), nA = [...lA.requires, ...lA.optional];
      return nA.length === 0 ? !1 : (eA.push(GA), nA.some(tA) ? !0 : (eA.pop(), !1));
    };
    if (!EA.provides || cA.length === 0)
      return;
    const eA = [EA.id];
    if (cA.some(tA))
      throw new ReferenceError(`Cycle detected: ${eA.join(" -> ")}.`);
  }
  CA.ensureNoCycle = IA;
  function BA(EA, iA, oA) {
    const cA = new Array(), tA = (nA) => {
      const DA = iA.get(nA), hA = [...DA.requires, ...DA.optional];
      cA.push(...hA.reduce((wA, sA) => {
        const NA = oA.get(sA);
        return NA && wA.push([nA, NA]), wA;
      }, []));
    };
    for (const nA of iA.keys())
      tA(nA);
    const eA = cA.filter((nA) => nA[1] === EA);
    let aA = 0;
    for (; eA.length > aA; ) {
      const nA = eA.length, DA = new Set(eA.map((hA) => hA[0]));
      for (const hA of DA)
        cA.filter((wA) => wA[1] === hA).forEach((wA) => {
          eA.includes(wA) || eA.push(wA);
        });
      aA = nA;
    }
    const GA = topologicSort(eA), lA = GA.findIndex((nA) => nA === EA);
    return lA === -1 ? [EA] : GA.slice(0, lA + 1);
  }
  CA.findDependents = BA;
  function QA(EA, iA) {
    const oA = /* @__PURE__ */ new Set();
    for (const cA of EA.keys())
      EA.get(cA).autoStart === !0 && oA.add(cA);
    if (iA.startPlugins)
      for (const cA of iA.startPlugins)
        oA.add(cA);
    if (iA.ignorePlugins)
      for (const cA of iA.ignorePlugins)
        oA.delete(cA);
    return Array.from(oA);
  }
  CA.collectStartupPlugins = QA;
})(Private$1 || (Private$1 = {}));
let PromiseDelegate$1 = class {
  /**
   * Construct a new promise delegate.
   */
  constructor() {
    this.promise = new Promise((gA, AA) => {
      this._resolve = gA, this._reject = AA;
    });
  }
  /**
   * Resolve the wrapped promise with the given value.
   *
   * @param value - The value to use for resolving the promise.
   */
  resolve(gA) {
    let AA = this._resolve;
    AA(gA);
  }
  /**
   * Reject the wrapped promise with the given value.
   *
   * @reason - The reason for rejecting the promise.
   */
  reject(gA) {
    let AA = this._reject;
    AA(gA);
  }
};
function fallbackRandomValues(CA) {
  let gA = 0;
  for (let AA = 0, IA = CA.length; AA < IA; ++AA)
    AA % 4 === 0 && (gA = Math.random() * 4294967295 >>> 0), CA[AA] = gA & 255, gA >>>= 8;
}
var Random;
(function(CA) {
  CA.getRandomValues = (() => {
    const gA = typeof window < "u" && (window.crypto || window.msCrypto) || null;
    return gA && typeof gA.getRandomValues == "function" ? function(IA) {
      return gA.getRandomValues(IA);
    } : fallbackRandomValues;
  })();
})(Random || (Random = {}));
function uuid4Factory(CA) {
  const gA = new Uint8Array(16), AA = new Array(256);
  for (let IA = 0; IA < 16; ++IA)
    AA[IA] = "0" + IA.toString(16);
  for (let IA = 16; IA < 256; ++IA)
    AA[IA] = IA.toString(16);
  return function() {
    return CA(gA), gA[6] = 64 | gA[6] & 15, gA[8] = 128 | gA[8] & 63, AA[gA[0]] + AA[gA[1]] + AA[gA[2]] + AA[gA[3]] + "-" + AA[gA[4]] + AA[gA[5]] + "-" + AA[gA[6]] + AA[gA[7]] + "-" + AA[gA[8]] + AA[gA[9]] + "-" + AA[gA[10]] + AA[gA[11]] + AA[gA[12]] + AA[gA[13]] + AA[gA[14]] + AA[gA[15]];
  };
}
var UUID;
(function(CA) {
  CA.uuid4 = uuid4Factory(Random.getRandomValues);
})(UUID || (UUID = {}));
class Signal {
  /**
   * Construct a new signal.
   *
   * @param sender - The sender which owns the signal.
   */
  constructor(gA) {
    this.sender = gA;
  }
  /**
   * Connect a slot to the signal.
   *
   * @param slot - The slot to invoke when the signal is emitted.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection succeeds, `false` otherwise.
   */
  connect(gA, AA) {
    return Private.connect(this, gA, AA);
  }
  /**
   * Disconnect a slot from the signal.
   *
   * @param slot - The slot to disconnect from the signal.
   *
   * @param thisArg - The `this` context for the slot. If provided,
   *   this must be a non-primitive object.
   *
   * @returns `true` if the connection is removed, `false` otherwise.
   */
  disconnect(gA, AA) {
    return Private.disconnect(this, gA, AA);
  }
  /**
   * Emit the signal and invoke the connected slots.
   *
   * @param args - The args to pass to the connected slots.
   *
   * #### Notes
   * Slots are invoked synchronously in connection order.
   *
   * Exceptions thrown by connected slots will be caught and logged.
   */
  emit(gA) {
    Private.emit(this, gA);
  }
}
(function(CA) {
  function gA(oA, cA) {
    Private.disconnectBetween(oA, cA);
  }
  CA.disconnectBetween = gA;
  function AA(oA) {
    Private.disconnectSender(oA);
  }
  CA.disconnectSender = AA;
  function IA(oA) {
    Private.disconnectReceiver(oA);
  }
  CA.disconnectReceiver = IA;
  function BA(oA) {
    Private.disconnectAll(oA);
  }
  CA.disconnectAll = BA;
  function QA(oA) {
    Private.disconnectAll(oA);
  }
  CA.clearData = QA;
  function EA() {
    return Private.exceptionHandler;
  }
  CA.getExceptionHandler = EA;
  function iA(oA) {
    let cA = Private.exceptionHandler;
    return Private.exceptionHandler = oA, cA;
  }
  CA.setExceptionHandler = iA;
})(Signal || (Signal = {}));
class Stream extends Signal {
  constructor() {
    super(...arguments), this._pending = new PromiseDelegate$1();
  }
  /**
   * Return an async iterator that yields every emission.
   */
  async *[Symbol.asyncIterator]() {
    let gA = this._pending;
    for (; ; )
      try {
        const { args: AA, next: IA } = await gA.promise;
        gA = IA, yield AA;
      } catch {
        return;
      }
  }
  /**
   * Emit the signal, invoke the connected slots, and yield the emission.
   *
   * @param args - The args to pass to the connected slots.
   */
  emit(gA) {
    const AA = this._pending, IA = this._pending = new PromiseDelegate$1();
    AA.resolve({ args: gA, next: IA }), super.emit(gA);
  }
  /**
   * Stop the stream's async iteration.
   */
  stop() {
    this._pending.promise.catch(() => {
    }), this._pending.reject("stop"), this._pending = new PromiseDelegate$1();
  }
}
var Private;
(function(CA) {
  CA.exceptionHandler = (wA) => {
    console.error(wA);
  };
  function gA(wA, sA, NA) {
    NA = NA || void 0;
    let rA = oA.get(wA.sender);
    if (rA || (rA = [], oA.set(wA.sender, rA)), aA(rA, wA, sA, NA))
      return !1;
    let yA = NA || sA, bA = cA.get(yA);
    bA || (bA = [], cA.set(yA, bA));
    let RA = { signal: wA, slot: sA, thisArg: NA };
    return rA.push(RA), bA.push(RA), !0;
  }
  CA.connect = gA;
  function AA(wA, sA, NA) {
    NA = NA || void 0;
    let rA = oA.get(wA.sender);
    if (!rA || rA.length === 0)
      return !1;
    let yA = aA(rA, wA, sA, NA);
    if (!yA)
      return !1;
    let bA = NA || sA, RA = cA.get(bA);
    return yA.signal = null, lA(rA), lA(RA), !0;
  }
  CA.disconnect = AA;
  function IA(wA, sA) {
    let NA = oA.get(wA);
    if (!NA || NA.length === 0)
      return;
    let rA = cA.get(sA);
    if (!(!rA || rA.length === 0)) {
      for (const yA of rA)
        yA.signal && yA.signal.sender === wA && (yA.signal = null);
      lA(NA), lA(rA);
    }
  }
  CA.disconnectBetween = IA;
  function BA(wA) {
    let sA = oA.get(wA);
    if (!(!sA || sA.length === 0)) {
      for (const NA of sA) {
        if (!NA.signal)
          continue;
        let rA = NA.thisArg || NA.slot;
        NA.signal = null, lA(cA.get(rA));
      }
      lA(sA);
    }
  }
  CA.disconnectSender = BA;
  function QA(wA) {
    let sA = cA.get(wA);
    if (!(!sA || sA.length === 0)) {
      for (const NA of sA) {
        if (!NA.signal)
          continue;
        let rA = NA.signal.sender;
        NA.signal = null, lA(oA.get(rA));
      }
      lA(sA);
    }
  }
  CA.disconnectReceiver = QA;
  function EA(wA) {
    BA(wA), QA(wA);
  }
  CA.disconnectAll = EA;
  function iA(wA, sA) {
    let NA = oA.get(wA.sender);
    if (!(!NA || NA.length === 0))
      for (let rA = 0, yA = NA.length; rA < yA; ++rA) {
        let bA = NA[rA];
        bA.signal === wA && GA(bA, sA);
      }
  }
  CA.emit = iA;
  const oA = /* @__PURE__ */ new WeakMap(), cA = /* @__PURE__ */ new WeakMap(), tA = /* @__PURE__ */ new Set(), eA = typeof requestAnimationFrame == "function" ? requestAnimationFrame : setImmediate;
  function aA(wA, sA, NA, rA) {
    return find(wA, (yA) => yA.signal === sA && yA.slot === NA && yA.thisArg === rA);
  }
  function GA(wA, sA) {
    let { signal: NA, slot: rA, thisArg: yA } = wA;
    try {
      rA.call(yA, NA.sender, sA);
    } catch (bA) {
      CA.exceptionHandler(bA);
    }
  }
  function lA(wA) {
    tA.size === 0 && eA(nA), tA.add(wA);
  }
  function nA() {
    tA.forEach(DA), tA.clear();
  }
  function DA(wA) {
    ArrayExt.removeAllWhere(wA, hA);
  }
  function hA(wA) {
    return wA.signal === null;
  }
})(Private || (Private = {}));
const index_es6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get Signal() {
    return Signal;
  },
  Stream
}, Symbol.toStringTag, { value: "Module" })), require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(index_es6);
var hasRequiredActivitymonitor;
function requireActivitymonitor() {
  if (hasRequiredActivitymonitor) return activitymonitor;
  hasRequiredActivitymonitor = 1, Object.defineProperty(activitymonitor, "__esModule", { value: !0 }), activitymonitor.ActivityMonitor = void 0;
  const CA = require$$0$2;
  class gA {
    /**
     * Construct a new activity monitor.
     */
    constructor(IA) {
      this._timer = -1, this._timeout = -1, this._isDisposed = !1, this._activityStopped = new CA.Signal(this), IA.signal.connect(this._onSignalFired, this), this._timeout = IA.timeout || 1e3;
    }
    /**
     * A signal emitted when activity has ceased.
     */
    get activityStopped() {
      return this._activityStopped;
    }
    /**
     * The timeout associated with the monitor, in milliseconds.
     */
    get timeout() {
      return this._timeout;
    }
    set timeout(IA) {
      this._timeout = IA;
    }
    /**
     * Test whether the monitor has been disposed.
     *
     * #### Notes
     * This is a read-only property.
     */
    get isDisposed() {
      return this._isDisposed;
    }
    /**
     * Dispose of the resources used by the activity monitor.
     */
    dispose() {
      this._isDisposed || (this._isDisposed = !0, CA.Signal.clearData(this));
    }
    /**
     * A signal handler for the monitored signal.
     */
    _onSignalFired(IA, BA) {
      clearTimeout(this._timer), this._sender = IA, this._args = BA, this._timer = setTimeout(() => {
        this._activityStopped.emit({
          sender: this._sender,
          args: this._args
        });
      }, this._timeout);
    }
  }
  return activitymonitor.ActivityMonitor = gA, activitymonitor;
}
var interfaces = {}, hasRequiredInterfaces;
function requireInterfaces() {
  return hasRequiredInterfaces || (hasRequiredInterfaces = 1, Object.defineProperty(interfaces, "__esModule", { value: !0 })), interfaces;
}
var lru = {}, hasRequiredLru;
function requireLru() {
  if (hasRequiredLru) return lru;
  hasRequiredLru = 1, Object.defineProperty(lru, "__esModule", { value: !0 }), lru.LruCache = void 0;
  const CA = 128;
  class gA {
    constructor(IA = {}) {
      this._map = /* @__PURE__ */ new Map(), this._maxSize = IA?.maxSize || CA;
    }
    /**
     * Return the current size of the cache.
     */
    get size() {
      return this._map.size;
    }
    /**
     * Clear the values in the cache.
     */
    clear() {
      this._map.clear();
    }
    /**
     * Get a value (or null) from the cache, pushing the item to the front of the cache.
     */
    get(IA) {
      const BA = this._map.get(IA) || null;
      return BA != null && (this._map.delete(IA), this._map.set(IA, BA)), BA;
    }
    /**
     * Set a value in the cache, potentially evicting an old item.
     */
    set(IA, BA) {
      this._map.size >= this._maxSize && this._map.delete(this._map.keys().next().value), this._map.set(IA, BA);
    }
  }
  return lru.LruCache = gA, lru;
}
var markdowncodeblocks = {}, hasRequiredMarkdowncodeblocks;
function requireMarkdowncodeblocks() {
  if (hasRequiredMarkdowncodeblocks) return markdowncodeblocks;
  hasRequiredMarkdowncodeblocks = 1, Object.defineProperty(markdowncodeblocks, "__esModule", { value: !0 }), markdowncodeblocks.MarkdownCodeBlocks = void 0;
  var CA;
  return (function(gA) {
    gA.CODE_BLOCK_MARKER = "```";
    const AA = [
      ".markdown",
      ".mdown",
      ".mkdn",
      ".md",
      ".mkd",
      ".mdwn",
      ".mdtxt",
      ".mdtext",
      ".text",
      ".txt",
      ".Rmd"
    ];
    class IA {
      constructor(iA) {
        this.startLine = iA, this.code = "", this.endLine = -1;
      }
    }
    gA.MarkdownCodeBlock = IA;
    function BA(EA) {
      return AA.indexOf(EA) > -1;
    }
    gA.isMarkdown = BA;
    function QA(EA) {
      if (!EA || EA === "")
        return [];
      const iA = EA.split(`
`), oA = [];
      let cA = null;
      for (let tA = 0; tA < iA.length; tA++) {
        const eA = iA[tA], aA = eA.indexOf(gA.CODE_BLOCK_MARKER) === 0, GA = cA != null;
        if (!(!aA && !GA))
          if (GA)
            cA && (aA ? (cA.endLine = tA - 1, oA.push(cA), cA = null) : cA.code += eA + `
`);
          else {
            cA = new IA(tA);
            const lA = eA.indexOf(gA.CODE_BLOCK_MARKER), nA = eA.lastIndexOf(gA.CODE_BLOCK_MARKER);
            lA !== nA && (cA.code = eA.substring(lA + gA.CODE_BLOCK_MARKER.length, nA), cA.endLine = tA, oA.push(cA), cA = null);
          }
      }
      return oA;
    }
    gA.findMarkdownCodeBlocks = QA;
  })(CA || (markdowncodeblocks.MarkdownCodeBlocks = CA = {})), markdowncodeblocks;
}
var pageconfig = {}, dist$1 = { exports: {} };
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(index_es6$1);
var dist = dist$1.exports, hasRequiredDist;
function requireDist() {
  return hasRequiredDist || (hasRequiredDist = 1, (function(CA, gA) {
    (function(AA, IA) {
      IA(gA, require$$0$1);
    })(dist, (function(AA, IA) {
      AA.JSONExt = void 0, (function(eA) {
        eA.emptyObject = Object.freeze({}), eA.emptyArray = Object.freeze([]);
        function aA(rA) {
          return rA === null || typeof rA == "boolean" || typeof rA == "number" || typeof rA == "string";
        }
        eA.isPrimitive = aA;
        function GA(rA) {
          return Array.isArray(rA);
        }
        eA.isArray = GA;
        function lA(rA) {
          return !aA(rA) && !GA(rA);
        }
        eA.isObject = lA;
        function nA(rA, yA) {
          if (rA === yA)
            return !0;
          if (aA(rA) || aA(yA))
            return !1;
          let bA = GA(rA), RA = GA(yA);
          return bA !== RA ? !1 : bA && RA ? hA(rA, yA) : wA(rA, yA);
        }
        eA.deepEqual = nA;
        function DA(rA) {
          return aA(rA) ? rA : GA(rA) ? sA(rA) : NA(rA);
        }
        eA.deepCopy = DA;
        function hA(rA, yA) {
          if (rA === yA)
            return !0;
          if (rA.length !== yA.length)
            return !1;
          for (let bA = 0, RA = rA.length; bA < RA; ++bA)
            if (!nA(rA[bA], yA[bA]))
              return !1;
          return !0;
        }
        function wA(rA, yA) {
          if (rA === yA)
            return !0;
          for (let bA in rA)
            if (rA[bA] !== void 0 && !(bA in yA))
              return !1;
          for (let bA in yA)
            if (yA[bA] !== void 0 && !(bA in rA))
              return !1;
          for (let bA in rA) {
            let RA = rA[bA], FA = yA[bA];
            if (!(RA === void 0 && FA === void 0) && (RA === void 0 || FA === void 0 || !nA(RA, FA)))
              return !1;
          }
          return !0;
        }
        function sA(rA) {
          let yA = new Array(rA.length);
          for (let bA = 0, RA = rA.length; bA < RA; ++bA)
            yA[bA] = DA(rA[bA]);
          return yA;
        }
        function NA(rA) {
          let yA = {};
          for (let bA in rA) {
            let RA = rA[bA];
            RA !== void 0 && (yA[bA] = DA(RA));
          }
          return yA;
        }
      })(AA.JSONExt || (AA.JSONExt = {}));
      class BA {
        constructor() {
          this._types = [], this._values = [];
        }
        /**
         * Get an array of the MIME types contained within the dataset.
         *
         * @returns A new array of the MIME types, in order of insertion.
         */
        types() {
          return this._types.slice();
        }
        /**
         * Test whether the dataset has an entry for the given type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns `true` if the dataset contains a value for the given
         *   MIME type, `false` otherwise.
         */
        hasData(aA) {
          return this._types.indexOf(aA) !== -1;
        }
        /**
         * Get the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @returns The value for the given MIME type, or `undefined` if
         *   the dataset does not contain a value for the type.
         */
        getData(aA) {
          let GA = this._types.indexOf(aA);
          return GA !== -1 ? this._values[GA] : void 0;
        }
        /**
         * Set the data value for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * @param data - The data value for the given MIME type.
         *
         * #### Notes
         * This will overwrite any previous entry for the MIME type.
         */
        setData(aA, GA) {
          this.clearData(aA), this._types.push(aA), this._values.push(GA);
        }
        /**
         * Remove the data entry for the given MIME type.
         *
         * @param mime - The MIME type of interest.
         *
         * #### Notes
         * This is a no-op if there is no entry for the given MIME type.
         */
        clearData(aA) {
          let GA = this._types.indexOf(aA);
          GA !== -1 && (this._types.splice(GA, 1), this._values.splice(GA, 1));
        }
        /**
         * Remove all data entries from the dataset.
         */
        clear() {
          this._types.length = 0, this._values.length = 0;
        }
      }
      class QA {
        constructor(aA = {}) {
          this._application = null, this._validatePlugin = () => !0, this._plugins = /* @__PURE__ */ new Map(), this._services = /* @__PURE__ */ new Map(), aA.validatePlugin && (console.info("Plugins may be rejected by the custom validation plugin method."), this._validatePlugin = aA.validatePlugin);
        }
        /**
         * The application object.
         *
         * It will be provided as first argument to the
         * plugins activation and deactivation functions.
         *
         * It can only be set once.
         *
         * By default, it is `null`.
         */
        get application() {
          return this._application;
        }
        set application(aA) {
          if (this._application !== null)
            throw Error("PluginRegistry.application is already set. It cannot be overridden.");
          this._application = aA;
        }
        /**
         * The list of all the deferred plugins.
         */
        get deferredPlugins() {
          return Array.from(this._plugins).filter(([aA, GA]) => GA.autoStart === "defer").map(([aA, GA]) => aA);
        }
        /**
         * Get a plugin description.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns The plugin description.
         */
        getPluginDescription(aA) {
          var GA, lA;
          return (lA = (GA = this._plugins.get(aA)) === null || GA === void 0 ? void 0 : GA.description) !== null && lA !== void 0 ? lA : "";
        }
        /**
         * Test whether a plugin is registered with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is registered, `false` otherwise.
         */
        hasPlugin(aA) {
          return this._plugins.has(aA);
        }
        /**
         * Test whether a plugin is activated with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns `true` if the plugin is activated, `false` otherwise.
         */
        isPluginActivated(aA) {
          var GA, lA;
          return (lA = (GA = this._plugins.get(aA)) === null || GA === void 0 ? void 0 : GA.activated) !== null && lA !== void 0 ? lA : !1;
        }
        /**
         * List the IDs of the plugins registered with the application.
         *
         * @returns A new array of the registered plugin IDs.
         */
        listPlugins() {
          return Array.from(this._plugins.keys());
        }
        /**
         * Register a plugin with the application.
         *
         * @param plugin - The plugin to register.
         *
         * #### Notes
         * An error will be thrown if a plugin with the same ID is already
         * registered, or if the plugin has a circular dependency.
         *
         * If the plugin provides a service which has already been provided
         * by another plugin, the new service will override the old service.
         */
        registerPlugin(aA) {
          if (this._plugins.has(aA.id))
            throw new TypeError(`Plugin '${aA.id}' is already registered.`);
          if (!this._validatePlugin(aA))
            throw new Error(`Plugin '${aA.id}' is not valid.`);
          const GA = EA.createPluginData(aA);
          EA.ensureNoCycle(GA, this._plugins, this._services), GA.provides && this._services.set(GA.provides, GA.id), this._plugins.set(GA.id, GA);
        }
        /**
         * Register multiple plugins with the application.
         *
         * @param plugins - The plugins to register.
         *
         * #### Notes
         * This calls `registerPlugin()` for each of the given plugins.
         */
        registerPlugins(aA) {
          for (const GA of aA)
            this.registerPlugin(GA);
        }
        /**
         * Deregister a plugin with the application.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @param force - Whether to deregister the plugin even if it is active.
         */
        deregisterPlugin(aA, GA) {
          const lA = this._plugins.get(aA);
          if (lA) {
            if (lA.activated && !GA)
              throw new Error(`Plugin '${aA}' is still active.`);
            this._plugins.delete(aA);
          }
        }
        /**
         * Activate the plugin with the given ID.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A promise which resolves when the plugin is activated
         *   or rejects with an error if it cannot be activated.
         */
        async activatePlugin(aA) {
          const GA = this._plugins.get(aA);
          if (!GA)
            throw new ReferenceError(`Plugin '${aA}' is not registered.`);
          if (GA.activated)
            return;
          if (GA.promise)
            return GA.promise;
          const lA = GA.requires.map((DA) => this.resolveRequiredService(DA)), nA = GA.optional.map((DA) => this.resolveOptionalService(DA));
          return GA.promise = Promise.all([...lA, ...nA]).then((DA) => GA.activate.apply(void 0, [this.application, ...DA])).then((DA) => {
            GA.service = DA, GA.activated = !0, GA.promise = null;
          }).catch((DA) => {
            throw GA.promise = null, DA;
          }), GA.promise;
        }
        /**
         * Activate all the deferred plugins.
         *
         * @returns A promise which will resolve when each plugin is activated
         * or rejects with an error if one cannot be activated.
         */
        async activatePlugins(aA, GA = {}) {
          switch (aA) {
            case "defer": {
              const lA = this.deferredPlugins.filter((nA) => this._plugins.get(nA).autoStart).map((nA) => this.activatePlugin(nA));
              await Promise.all(lA);
              break;
            }
            case "startUp": {
              const nA = EA.collectStartupPlugins(this._plugins, GA).map(async (DA) => {
                try {
                  return await this.activatePlugin(DA);
                } catch (hA) {
                  console.error(`Plugin '${DA}' failed to activate.`, hA);
                }
              });
              await Promise.all(nA);
              break;
            }
          }
        }
        /**
         * Deactivate the plugin and its downstream dependents if and only if the
         * plugin and its dependents all support `deactivate`.
         *
         * @param id - The ID of the plugin of interest.
         *
         * @returns A list of IDs of downstream plugins deactivated with this one.
         */
        async deactivatePlugin(aA) {
          const GA = this._plugins.get(aA);
          if (!GA)
            throw new ReferenceError(`Plugin '${aA}' is not registered.`);
          if (!GA.activated)
            return [];
          if (!GA.deactivate)
            throw new TypeError(`Plugin '${aA}'#deactivate() method missing`);
          const lA = EA.findDependents(aA, this._plugins, this._services), nA = lA.map((DA) => this._plugins.get(DA));
          for (const DA of nA)
            if (!DA.deactivate)
              throw new TypeError(`Plugin ${DA.id}#deactivate() method missing (depends on ${aA})`);
          for (const DA of nA) {
            const hA = [...DA.requires, ...DA.optional].map((wA) => {
              const sA = this._services.get(wA);
              return sA ? this._plugins.get(sA).service : null;
            });
            await DA.deactivate(this.application, ...hA), DA.service = null, DA.activated = !1;
          }
          return lA.pop(), lA;
        }
        /**
         * Resolve a required service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or rejects with an error if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the required services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveRequiredService(aA) {
          const GA = this._services.get(aA);
          if (!GA)
            throw new TypeError(`No provider for: ${aA.name}.`);
          const lA = this._plugins.get(GA);
          return lA.activated || await this.activatePlugin(GA), lA.service;
        }
        /**
         * Resolve an optional service of a given type.
         *
         * @param token - The token for the service type of interest.
         *
         * @returns A promise which resolves to an instance of the requested
         *   service, or `null` if it cannot be resolved.
         *
         * #### Notes
         * Services are singletons. The same instance will be returned each
         * time a given service token is resolved.
         *
         * If the plugin which provides the service has not been activated,
         * resolving the service will automatically activate the plugin.
         *
         * User code will not typically call this method directly. Instead,
         * the optional services for the user's plugins will be resolved
         * automatically when the plugin is activated.
         */
        async resolveOptionalService(aA) {
          const GA = this._services.get(aA);
          if (!GA)
            return null;
          const lA = this._plugins.get(GA);
          if (!lA.activated)
            try {
              await this.activatePlugin(GA);
            } catch (nA) {
              return console.error(nA), null;
            }
          return lA.service;
        }
      }
      var EA;
      (function(eA) {
        class aA {
          constructor(wA) {
            var sA, NA, rA, yA;
            this._activated = !1, this._promise = null, this._service = null, this.id = wA.id, this.description = (sA = wA.description) !== null && sA !== void 0 ? sA : "", this.activate = wA.activate, this.deactivate = (NA = wA.deactivate) !== null && NA !== void 0 ? NA : null, this.provides = (rA = wA.provides) !== null && rA !== void 0 ? rA : null, this.autoStart = (yA = wA.autoStart) !== null && yA !== void 0 ? yA : !1, this.requires = wA.requires ? wA.requires.slice() : [], this.optional = wA.optional ? wA.optional.slice() : [];
          }
          /**
           * Whether the plugin has been activated.
           */
          get activated() {
            return this._activated;
          }
          set activated(wA) {
            this._activated = wA;
          }
          /**
           * The resolved service for the plugin, or `null`.
           */
          get service() {
            return this._service;
          }
          set service(wA) {
            this._service = wA;
          }
          /**
           * The pending resolver promise, or `null`.
           */
          get promise() {
            return this._promise;
          }
          set promise(wA) {
            this._promise = wA;
          }
        }
        function GA(hA) {
          return new aA(hA);
        }
        eA.createPluginData = GA;
        function lA(hA, wA, sA) {
          const NA = [...hA.requires, ...hA.optional], rA = (bA) => {
            if (bA === hA.provides)
              return !0;
            const RA = sA.get(bA);
            if (!RA)
              return !1;
            const FA = wA.get(RA), dA = [...FA.requires, ...FA.optional];
            return dA.length === 0 ? !1 : (yA.push(RA), dA.some(rA) ? !0 : (yA.pop(), !1));
          };
          if (!hA.provides || NA.length === 0)
            return;
          const yA = [hA.id];
          if (NA.some(rA))
            throw new ReferenceError(`Cycle detected: ${yA.join(" -> ")}.`);
        }
        eA.ensureNoCycle = lA;
        function nA(hA, wA, sA) {
          const NA = new Array(), rA = (dA) => {
            const kA = wA.get(dA), pA = [...kA.requires, ...kA.optional];
            NA.push(...pA.reduce((YA, SA) => {
              const JA = sA.get(SA);
              return JA && YA.push([dA, JA]), YA;
            }, []));
          };
          for (const dA of wA.keys())
            rA(dA);
          const yA = NA.filter((dA) => dA[1] === hA);
          let bA = 0;
          for (; yA.length > bA; ) {
            const dA = yA.length, kA = new Set(yA.map((pA) => pA[0]));
            for (const pA of kA)
              NA.filter((YA) => YA[1] === pA).forEach((YA) => {
                yA.includes(YA) || yA.push(YA);
              });
            bA = dA;
          }
          const RA = IA.topologicSort(yA), FA = RA.findIndex((dA) => dA === hA);
          return FA === -1 ? [hA] : RA.slice(0, FA + 1);
        }
        eA.findDependents = nA;
        function DA(hA, wA) {
          const sA = /* @__PURE__ */ new Set();
          for (const NA of hA.keys())
            hA.get(NA).autoStart === !0 && sA.add(NA);
          if (wA.startPlugins)
            for (const NA of wA.startPlugins)
              sA.add(NA);
          if (wA.ignorePlugins)
            for (const NA of wA.ignorePlugins)
              sA.delete(NA);
          return Array.from(sA);
        }
        eA.collectStartupPlugins = DA;
      })(EA || (EA = {}));
      class iA {
        /**
         * Construct a new promise delegate.
         */
        constructor() {
          this.promise = new Promise((aA, GA) => {
            this._resolve = aA, this._reject = GA;
          });
        }
        /**
         * Resolve the wrapped promise with the given value.
         *
         * @param value - The value to use for resolving the promise.
         */
        resolve(aA) {
          let GA = this._resolve;
          GA(aA);
        }
        /**
         * Reject the wrapped promise with the given value.
         *
         * @reason - The reason for rejecting the promise.
         */
        reject(aA) {
          let GA = this._reject;
          GA(aA);
        }
      }
      class oA {
        /**
         * Construct a new token.
         *
         * @param name - A human readable name for the token.
         * @param description - Token purpose description for documentation.
         */
        constructor(aA, GA) {
          this.name = aA, this.description = GA ?? "", this._tokenStructuralPropertyT = null;
        }
      }
      function cA(eA) {
        let aA = 0;
        for (let GA = 0, lA = eA.length; GA < lA; ++GA)
          GA % 4 === 0 && (aA = Math.random() * 4294967295 >>> 0), eA[GA] = aA & 255, aA >>>= 8;
      }
      AA.Random = void 0, (function(eA) {
        eA.getRandomValues = (() => {
          const aA = typeof window < "u" && (window.crypto || window.msCrypto) || null;
          return aA && typeof aA.getRandomValues == "function" ? function(lA) {
            return aA.getRandomValues(lA);
          } : cA;
        })();
      })(AA.Random || (AA.Random = {}));
      function tA(eA) {
        const aA = new Uint8Array(16), GA = new Array(256);
        for (let lA = 0; lA < 16; ++lA)
          GA[lA] = "0" + lA.toString(16);
        for (let lA = 16; lA < 256; ++lA)
          GA[lA] = lA.toString(16);
        return function() {
          return eA(aA), aA[6] = 64 | aA[6] & 15, aA[8] = 128 | aA[8] & 63, GA[aA[0]] + GA[aA[1]] + GA[aA[2]] + GA[aA[3]] + "-" + GA[aA[4]] + GA[aA[5]] + "-" + GA[aA[6]] + GA[aA[7]] + "-" + GA[aA[8]] + GA[aA[9]] + "-" + GA[aA[10]] + GA[aA[11]] + GA[aA[12]] + GA[aA[13]] + GA[aA[14]] + GA[aA[15]];
        };
      }
      AA.UUID = void 0, (function(eA) {
        eA.uuid4 = tA(AA.Random.getRandomValues);
      })(AA.UUID || (AA.UUID = {})), AA.MimeData = BA, AA.PluginRegistry = QA, AA.PromiseDelegate = iA, AA.Token = oA;
    }));
  })(dist$1, dist$1.exports)), dist$1.exports;
}
var minimist, hasRequiredMinimist;
function requireMinimist() {
  if (hasRequiredMinimist) return minimist;
  hasRequiredMinimist = 1;
  function CA(IA, BA) {
    var QA = IA;
    BA.slice(0, -1).forEach(function(iA) {
      QA = QA[iA] || {};
    });
    var EA = BA[BA.length - 1];
    return EA in QA;
  }
  function gA(IA) {
    return typeof IA == "number" || /^0x[0-9a-f]+$/i.test(IA) ? !0 : /^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/.test(IA);
  }
  function AA(IA, BA) {
    return BA === "constructor" && typeof IA[BA] == "function" || BA === "__proto__";
  }
  return minimist = function(IA, BA) {
    BA || (BA = {});
    var QA = {
      bools: {},
      strings: {},
      unknownFn: null
    };
    typeof BA.unknown == "function" && (QA.unknownFn = BA.unknown), typeof BA.boolean == "boolean" && BA.boolean ? QA.allBools = !0 : [].concat(BA.boolean).filter(Boolean).forEach(function(bA) {
      QA.bools[bA] = !0;
    });
    var EA = {};
    function iA(bA) {
      return EA[bA].some(function(RA) {
        return QA.bools[RA];
      });
    }
    Object.keys(BA.alias || {}).forEach(function(bA) {
      EA[bA] = [].concat(BA.alias[bA]), EA[bA].forEach(function(RA) {
        EA[RA] = [bA].concat(EA[bA].filter(function(FA) {
          return RA !== FA;
        }));
      });
    }), [].concat(BA.string).filter(Boolean).forEach(function(bA) {
      QA.strings[bA] = !0, EA[bA] && [].concat(EA[bA]).forEach(function(RA) {
        QA.strings[RA] = !0;
      });
    });
    var oA = BA.default || {}, cA = { _: [] };
    function tA(bA, RA) {
      return QA.allBools && /^--[^=]+$/.test(RA) || QA.strings[bA] || QA.bools[bA] || EA[bA];
    }
    function eA(bA, RA, FA) {
      for (var dA = bA, kA = 0; kA < RA.length - 1; kA++) {
        var pA = RA[kA];
        if (AA(dA, pA))
          return;
        dA[pA] === void 0 && (dA[pA] = {}), (dA[pA] === Object.prototype || dA[pA] === Number.prototype || dA[pA] === String.prototype) && (dA[pA] = {}), dA[pA] === Array.prototype && (dA[pA] = []), dA = dA[pA];
      }
      var YA = RA[RA.length - 1];
      AA(dA, YA) || ((dA === Object.prototype || dA === Number.prototype || dA === String.prototype) && (dA = {}), dA === Array.prototype && (dA = []), dA[YA] === void 0 || QA.bools[YA] || typeof dA[YA] == "boolean" ? dA[YA] = FA : Array.isArray(dA[YA]) ? dA[YA].push(FA) : dA[YA] = [dA[YA], FA]);
    }
    function aA(bA, RA, FA) {
      if (!(FA && QA.unknownFn && !tA(bA, FA) && QA.unknownFn(FA) === !1)) {
        var dA = !QA.strings[bA] && gA(RA) ? Number(RA) : RA;
        eA(cA, bA.split("."), dA), (EA[bA] || []).forEach(function(kA) {
          eA(cA, kA.split("."), dA);
        });
      }
    }
    Object.keys(QA.bools).forEach(function(bA) {
      aA(bA, oA[bA] === void 0 ? !1 : oA[bA]);
    });
    var GA = [];
    IA.indexOf("--") !== -1 && (GA = IA.slice(IA.indexOf("--") + 1), IA = IA.slice(0, IA.indexOf("--")));
    for (var lA = 0; lA < IA.length; lA++) {
      var nA = IA[lA], DA, hA;
      if (/^--.+=/.test(nA)) {
        var wA = nA.match(/^--([^=]+)=([\s\S]*)$/);
        DA = wA[1];
        var sA = wA[2];
        QA.bools[DA] && (sA = sA !== "false"), aA(DA, sA, nA);
      } else if (/^--no-.+/.test(nA))
        DA = nA.match(/^--no-(.+)/)[1], aA(DA, !1, nA);
      else if (/^--.+/.test(nA))
        DA = nA.match(/^--(.+)/)[1], hA = IA[lA + 1], hA !== void 0 && !/^(-|--)[^-]/.test(hA) && !QA.bools[DA] && !QA.allBools && (!EA[DA] || !iA(DA)) ? (aA(DA, hA, nA), lA += 1) : /^(true|false)$/.test(hA) ? (aA(DA, hA === "true", nA), lA += 1) : aA(DA, QA.strings[DA] ? "" : !0, nA);
      else if (/^-[^-]+/.test(nA)) {
        for (var NA = nA.slice(1, -1).split(""), rA = !1, yA = 0; yA < NA.length; yA++) {
          if (hA = nA.slice(yA + 2), hA === "-") {
            aA(NA[yA], hA, nA);
            continue;
          }
          if (/[A-Za-z]/.test(NA[yA]) && hA[0] === "=") {
            aA(NA[yA], hA.slice(1), nA), rA = !0;
            break;
          }
          if (/[A-Za-z]/.test(NA[yA]) && /-?\d+(\.\d*)?(e-?\d+)?$/.test(hA)) {
            aA(NA[yA], hA, nA), rA = !0;
            break;
          }
          if (NA[yA + 1] && NA[yA + 1].match(/\W/)) {
            aA(NA[yA], nA.slice(yA + 2), nA), rA = !0;
            break;
          } else
            aA(NA[yA], QA.strings[NA[yA]] ? "" : !0, nA);
        }
        DA = nA.slice(-1)[0], !rA && DA !== "-" && (IA[lA + 1] && !/^(-|--)[^-]/.test(IA[lA + 1]) && !QA.bools[DA] && (!EA[DA] || !iA(DA)) ? (aA(DA, IA[lA + 1], nA), lA += 1) : IA[lA + 1] && /^(true|false)$/.test(IA[lA + 1]) ? (aA(DA, IA[lA + 1] === "true", nA), lA += 1) : aA(DA, QA.strings[DA] ? "" : !0, nA));
      } else if ((!QA.unknownFn || QA.unknownFn(nA) !== !1) && cA._.push(QA.strings._ || !gA(nA) ? nA : Number(nA)), BA.stopEarly) {
        cA._.push.apply(cA._, IA.slice(lA + 1));
        break;
      }
    }
    return Object.keys(oA).forEach(function(bA) {
      CA(cA, bA.split(".")) || (eA(cA, bA.split("."), oA[bA]), (EA[bA] || []).forEach(function(RA) {
        eA(cA, RA.split("."), oA[bA]);
      }));
    }), BA["--"] ? cA["--"] = GA.slice() : GA.forEach(function(bA) {
      cA._.push(bA);
    }), cA;
  }, minimist;
}
var url = {}, pathBrowserify, hasRequiredPathBrowserify;
function requirePathBrowserify() {
  if (hasRequiredPathBrowserify) return pathBrowserify;
  hasRequiredPathBrowserify = 1;
  function CA(BA) {
    if (typeof BA != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(BA));
  }
  function gA(BA, QA) {
    for (var EA = "", iA = 0, oA = -1, cA = 0, tA, eA = 0; eA <= BA.length; ++eA) {
      if (eA < BA.length)
        tA = BA.charCodeAt(eA);
      else {
        if (tA === 47)
          break;
        tA = 47;
      }
      if (tA === 47) {
        if (!(oA === eA - 1 || cA === 1)) if (oA !== eA - 1 && cA === 2) {
          if (EA.length < 2 || iA !== 2 || EA.charCodeAt(EA.length - 1) !== 46 || EA.charCodeAt(EA.length - 2) !== 46) {
            if (EA.length > 2) {
              var aA = EA.lastIndexOf("/");
              if (aA !== EA.length - 1) {
                aA === -1 ? (EA = "", iA = 0) : (EA = EA.slice(0, aA), iA = EA.length - 1 - EA.lastIndexOf("/")), oA = eA, cA = 0;
                continue;
              }
            } else if (EA.length === 2 || EA.length === 1) {
              EA = "", iA = 0, oA = eA, cA = 0;
              continue;
            }
          }
          QA && (EA.length > 0 ? EA += "/.." : EA = "..", iA = 2);
        } else
          EA.length > 0 ? EA += "/" + BA.slice(oA + 1, eA) : EA = BA.slice(oA + 1, eA), iA = eA - oA - 1;
        oA = eA, cA = 0;
      } else tA === 46 && cA !== -1 ? ++cA : cA = -1;
    }
    return EA;
  }
  function AA(BA, QA) {
    var EA = QA.dir || QA.root, iA = QA.base || (QA.name || "") + (QA.ext || "");
    return EA ? EA === QA.root ? EA + iA : EA + BA + iA : iA;
  }
  var IA = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var QA = "", EA = !1, iA, oA = arguments.length - 1; oA >= -1 && !EA; oA--) {
        var cA;
        oA >= 0 ? cA = arguments[oA] : (iA === void 0 && (iA = process.cwd()), cA = iA), CA(cA), cA.length !== 0 && (QA = cA + "/" + QA, EA = cA.charCodeAt(0) === 47);
      }
      return QA = gA(QA, !EA), EA ? QA.length > 0 ? "/" + QA : "/" : QA.length > 0 ? QA : ".";
    },
    normalize: function(QA) {
      if (CA(QA), QA.length === 0) return ".";
      var EA = QA.charCodeAt(0) === 47, iA = QA.charCodeAt(QA.length - 1) === 47;
      return QA = gA(QA, !EA), QA.length === 0 && !EA && (QA = "."), QA.length > 0 && iA && (QA += "/"), EA ? "/" + QA : QA;
    },
    isAbsolute: function(QA) {
      return CA(QA), QA.length > 0 && QA.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var QA, EA = 0; EA < arguments.length; ++EA) {
        var iA = arguments[EA];
        CA(iA), iA.length > 0 && (QA === void 0 ? QA = iA : QA += "/" + iA);
      }
      return QA === void 0 ? "." : IA.normalize(QA);
    },
    relative: function(QA, EA) {
      if (CA(QA), CA(EA), QA === EA || (QA = IA.resolve(QA), EA = IA.resolve(EA), QA === EA)) return "";
      for (var iA = 1; iA < QA.length && QA.charCodeAt(iA) === 47; ++iA)
        ;
      for (var oA = QA.length, cA = oA - iA, tA = 1; tA < EA.length && EA.charCodeAt(tA) === 47; ++tA)
        ;
      for (var eA = EA.length, aA = eA - tA, GA = cA < aA ? cA : aA, lA = -1, nA = 0; nA <= GA; ++nA) {
        if (nA === GA) {
          if (aA > GA) {
            if (EA.charCodeAt(tA + nA) === 47)
              return EA.slice(tA + nA + 1);
            if (nA === 0)
              return EA.slice(tA + nA);
          } else cA > GA && (QA.charCodeAt(iA + nA) === 47 ? lA = nA : nA === 0 && (lA = 0));
          break;
        }
        var DA = QA.charCodeAt(iA + nA), hA = EA.charCodeAt(tA + nA);
        if (DA !== hA)
          break;
        DA === 47 && (lA = nA);
      }
      var wA = "";
      for (nA = iA + lA + 1; nA <= oA; ++nA)
        (nA === oA || QA.charCodeAt(nA) === 47) && (wA.length === 0 ? wA += ".." : wA += "/..");
      return wA.length > 0 ? wA + EA.slice(tA + lA) : (tA += lA, EA.charCodeAt(tA) === 47 && ++tA, EA.slice(tA));
    },
    _makeLong: function(QA) {
      return QA;
    },
    dirname: function(QA) {
      if (CA(QA), QA.length === 0) return ".";
      for (var EA = QA.charCodeAt(0), iA = EA === 47, oA = -1, cA = !0, tA = QA.length - 1; tA >= 1; --tA)
        if (EA = QA.charCodeAt(tA), EA === 47) {
          if (!cA) {
            oA = tA;
            break;
          }
        } else
          cA = !1;
      return oA === -1 ? iA ? "/" : "." : iA && oA === 1 ? "//" : QA.slice(0, oA);
    },
    basename: function(QA, EA) {
      if (EA !== void 0 && typeof EA != "string") throw new TypeError('"ext" argument must be a string');
      CA(QA);
      var iA = 0, oA = -1, cA = !0, tA;
      if (EA !== void 0 && EA.length > 0 && EA.length <= QA.length) {
        if (EA.length === QA.length && EA === QA) return "";
        var eA = EA.length - 1, aA = -1;
        for (tA = QA.length - 1; tA >= 0; --tA) {
          var GA = QA.charCodeAt(tA);
          if (GA === 47) {
            if (!cA) {
              iA = tA + 1;
              break;
            }
          } else
            aA === -1 && (cA = !1, aA = tA + 1), eA >= 0 && (GA === EA.charCodeAt(eA) ? --eA === -1 && (oA = tA) : (eA = -1, oA = aA));
        }
        return iA === oA ? oA = aA : oA === -1 && (oA = QA.length), QA.slice(iA, oA);
      } else {
        for (tA = QA.length - 1; tA >= 0; --tA)
          if (QA.charCodeAt(tA) === 47) {
            if (!cA) {
              iA = tA + 1;
              break;
            }
          } else oA === -1 && (cA = !1, oA = tA + 1);
        return oA === -1 ? "" : QA.slice(iA, oA);
      }
    },
    extname: function(QA) {
      CA(QA);
      for (var EA = -1, iA = 0, oA = -1, cA = !0, tA = 0, eA = QA.length - 1; eA >= 0; --eA) {
        var aA = QA.charCodeAt(eA);
        if (aA === 47) {
          if (!cA) {
            iA = eA + 1;
            break;
          }
          continue;
        }
        oA === -1 && (cA = !1, oA = eA + 1), aA === 46 ? EA === -1 ? EA = eA : tA !== 1 && (tA = 1) : EA !== -1 && (tA = -1);
      }
      return EA === -1 || oA === -1 || // We saw a non-dot character immediately before the dot
      tA === 0 || // The (right-most) trimmed path component is exactly '..'
      tA === 1 && EA === oA - 1 && EA === iA + 1 ? "" : QA.slice(EA, oA);
    },
    format: function(QA) {
      if (QA === null || typeof QA != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof QA);
      return AA("/", QA);
    },
    parse: function(QA) {
      CA(QA);
      var EA = { root: "", dir: "", base: "", ext: "", name: "" };
      if (QA.length === 0) return EA;
      var iA = QA.charCodeAt(0), oA = iA === 47, cA;
      oA ? (EA.root = "/", cA = 1) : cA = 0;
      for (var tA = -1, eA = 0, aA = -1, GA = !0, lA = QA.length - 1, nA = 0; lA >= cA; --lA) {
        if (iA = QA.charCodeAt(lA), iA === 47) {
          if (!GA) {
            eA = lA + 1;
            break;
          }
          continue;
        }
        aA === -1 && (GA = !1, aA = lA + 1), iA === 46 ? tA === -1 ? tA = lA : nA !== 1 && (nA = 1) : tA !== -1 && (nA = -1);
      }
      return tA === -1 || aA === -1 || // We saw a non-dot character immediately before the dot
      nA === 0 || // The (right-most) trimmed path component is exactly '..'
      nA === 1 && tA === aA - 1 && tA === eA + 1 ? aA !== -1 && (eA === 0 && oA ? EA.base = EA.name = QA.slice(1, aA) : EA.base = EA.name = QA.slice(eA, aA)) : (eA === 0 && oA ? (EA.name = QA.slice(1, tA), EA.base = QA.slice(1, aA)) : (EA.name = QA.slice(eA, tA), EA.base = QA.slice(eA, aA)), EA.ext = QA.slice(tA, aA)), eA > 0 ? EA.dir = QA.slice(0, eA - 1) : oA && (EA.dir = "/"), EA;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return IA.posix = IA, pathBrowserify = IA, pathBrowserify;
}
var requiresPort, hasRequiredRequiresPort;
function requireRequiresPort() {
  return hasRequiredRequiresPort || (hasRequiredRequiresPort = 1, requiresPort = function(gA, AA) {
    if (AA = AA.split(":")[0], gA = +gA, !gA) return !1;
    switch (AA) {
      case "http":
      case "ws":
        return gA !== 80;
      case "https":
      case "wss":
        return gA !== 443;
      case "ftp":
        return gA !== 21;
      case "gopher":
        return gA !== 70;
      case "file":
        return !1;
    }
    return gA !== 0;
  }), requiresPort;
}
var querystringify = {}, hasRequiredQuerystringify;
function requireQuerystringify() {
  if (hasRequiredQuerystringify) return querystringify;
  hasRequiredQuerystringify = 1;
  var CA = Object.prototype.hasOwnProperty, gA;
  function AA(EA) {
    try {
      return decodeURIComponent(EA.replace(/\+/g, " "));
    } catch {
      return null;
    }
  }
  function IA(EA) {
    try {
      return encodeURIComponent(EA);
    } catch {
      return null;
    }
  }
  function BA(EA) {
    for (var iA = /([^=?#&]+)=?([^&]*)/g, oA = {}, cA; cA = iA.exec(EA); ) {
      var tA = AA(cA[1]), eA = AA(cA[2]);
      tA === null || eA === null || tA in oA || (oA[tA] = eA);
    }
    return oA;
  }
  function QA(EA, iA) {
    iA = iA || "";
    var oA = [], cA, tA;
    typeof iA != "string" && (iA = "?");
    for (tA in EA)
      if (CA.call(EA, tA)) {
        if (cA = EA[tA], !cA && (cA === null || cA === gA || isNaN(cA)) && (cA = ""), tA = IA(tA), cA = IA(cA), tA === null || cA === null) continue;
        oA.push(tA + "=" + cA);
      }
    return oA.length ? iA + oA.join("&") : "";
  }
  return querystringify.stringify = QA, querystringify.parse = BA, querystringify;
}
var urlParse, hasRequiredUrlParse;
function requireUrlParse() {
  if (hasRequiredUrlParse) return urlParse;
  hasRequiredUrlParse = 1;
  var CA = requireRequiresPort(), gA = requireQuerystringify(), AA = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, IA = /[\n\r\t]/g, BA = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, QA = /:\d+$/, EA = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, iA = /^[a-zA-Z]:/;
  function oA(wA) {
    return (wA || "").toString().replace(AA, "");
  }
  var cA = [
    ["#", "hash"],
    // Extract from the back.
    ["?", "query"],
    // Extract from the back.
    function(sA, NA) {
      return aA(NA.protocol) ? sA.replace(/\\/g, "/") : sA;
    },
    ["/", "pathname"],
    // Extract from the back.
    ["@", "auth", 1],
    // Extract from the front.
    [NaN, "host", void 0, 1, 1],
    // Set left over value.
    [/:(\d*)$/, "port", void 0, 1],
    // RegExp the back.
    [NaN, "hostname", void 0, 1, 1]
    // Set left over.
  ], tA = { hash: 1, query: 1 };
  function eA(wA) {
    var sA;
    typeof window < "u" ? sA = window : typeof commonjsGlobal < "u" ? sA = commonjsGlobal : typeof self < "u" ? sA = self : sA = {};
    var NA = sA.location || {};
    wA = wA || NA;
    var rA = {}, yA = typeof wA, bA;
    if (wA.protocol === "blob:")
      rA = new nA(unescape(wA.pathname), {});
    else if (yA === "string") {
      rA = new nA(wA, {});
      for (bA in tA) delete rA[bA];
    } else if (yA === "object") {
      for (bA in wA)
        bA in tA || (rA[bA] = wA[bA]);
      rA.slashes === void 0 && (rA.slashes = BA.test(wA.href));
    }
    return rA;
  }
  function aA(wA) {
    return wA === "file:" || wA === "ftp:" || wA === "http:" || wA === "https:" || wA === "ws:" || wA === "wss:";
  }
  function GA(wA, sA) {
    wA = oA(wA), wA = wA.replace(IA, ""), sA = sA || {};
    var NA = EA.exec(wA), rA = NA[1] ? NA[1].toLowerCase() : "", yA = !!NA[2], bA = !!NA[3], RA = 0, FA;
    return yA ? bA ? (FA = NA[2] + NA[3] + NA[4], RA = NA[2].length + NA[3].length) : (FA = NA[2] + NA[4], RA = NA[2].length) : bA ? (FA = NA[3] + NA[4], RA = NA[3].length) : FA = NA[4], rA === "file:" ? RA >= 2 && (FA = FA.slice(2)) : aA(rA) ? FA = NA[4] : rA ? yA && (FA = FA.slice(2)) : RA >= 2 && aA(sA.protocol) && (FA = NA[4]), {
      protocol: rA,
      slashes: yA || aA(rA),
      slashesCount: RA,
      rest: FA
    };
  }
  function lA(wA, sA) {
    if (wA === "") return sA;
    for (var NA = (sA || "/").split("/").slice(0, -1).concat(wA.split("/")), rA = NA.length, yA = NA[rA - 1], bA = !1, RA = 0; rA--; )
      NA[rA] === "." ? NA.splice(rA, 1) : NA[rA] === ".." ? (NA.splice(rA, 1), RA++) : RA && (rA === 0 && (bA = !0), NA.splice(rA, 1), RA--);
    return bA && NA.unshift(""), (yA === "." || yA === "..") && NA.push(""), NA.join("/");
  }
  function nA(wA, sA, NA) {
    if (wA = oA(wA), wA = wA.replace(IA, ""), !(this instanceof nA))
      return new nA(wA, sA, NA);
    var rA, yA, bA, RA, FA, dA, kA = cA.slice(), pA = typeof sA, YA = this, SA = 0;
    for (pA !== "object" && pA !== "string" && (NA = sA, sA = null), NA && typeof NA != "function" && (NA = gA.parse), sA = eA(sA), yA = GA(wA || "", sA), rA = !yA.protocol && !yA.slashes, YA.slashes = yA.slashes || rA && sA.slashes, YA.protocol = yA.protocol || sA.protocol || "", wA = yA.rest, (yA.protocol === "file:" && (yA.slashesCount !== 2 || iA.test(wA)) || !yA.slashes && (yA.protocol || yA.slashesCount < 2 || !aA(YA.protocol))) && (kA[3] = [/(.*)/, "pathname"]); SA < kA.length; SA++) {
      if (RA = kA[SA], typeof RA == "function") {
        wA = RA(wA, YA);
        continue;
      }
      bA = RA[0], dA = RA[1], bA !== bA ? YA[dA] = wA : typeof bA == "string" ? (FA = bA === "@" ? wA.lastIndexOf(bA) : wA.indexOf(bA), ~FA && (typeof RA[2] == "number" ? (YA[dA] = wA.slice(0, FA), wA = wA.slice(FA + RA[2])) : (YA[dA] = wA.slice(FA), wA = wA.slice(0, FA)))) : (FA = bA.exec(wA)) && (YA[dA] = FA[1], wA = wA.slice(0, FA.index)), YA[dA] = YA[dA] || rA && RA[3] && sA[dA] || "", RA[4] && (YA[dA] = YA[dA].toLowerCase());
    }
    NA && (YA.query = NA(YA.query)), rA && sA.slashes && YA.pathname.charAt(0) !== "/" && (YA.pathname !== "" || sA.pathname !== "") && (YA.pathname = lA(YA.pathname, sA.pathname)), YA.pathname.charAt(0) !== "/" && aA(YA.protocol) && (YA.pathname = "/" + YA.pathname), CA(YA.port, YA.protocol) || (YA.host = YA.hostname, YA.port = ""), YA.username = YA.password = "", YA.auth && (FA = YA.auth.indexOf(":"), ~FA ? (YA.username = YA.auth.slice(0, FA), YA.username = encodeURIComponent(decodeURIComponent(YA.username)), YA.password = YA.auth.slice(FA + 1), YA.password = encodeURIComponent(decodeURIComponent(YA.password))) : YA.username = encodeURIComponent(decodeURIComponent(YA.auth)), YA.auth = YA.password ? YA.username + ":" + YA.password : YA.username), YA.origin = YA.protocol !== "file:" && aA(YA.protocol) && YA.host ? YA.protocol + "//" + YA.host : "null", YA.href = YA.toString();
  }
  function DA(wA, sA, NA) {
    var rA = this;
    switch (wA) {
      case "query":
        typeof sA == "string" && sA.length && (sA = (NA || gA.parse)(sA)), rA[wA] = sA;
        break;
      case "port":
        rA[wA] = sA, CA(sA, rA.protocol) ? sA && (rA.host = rA.hostname + ":" + sA) : (rA.host = rA.hostname, rA[wA] = "");
        break;
      case "hostname":
        rA[wA] = sA, rA.port && (sA += ":" + rA.port), rA.host = sA;
        break;
      case "host":
        rA[wA] = sA, QA.test(sA) ? (sA = sA.split(":"), rA.port = sA.pop(), rA.hostname = sA.join(":")) : (rA.hostname = sA, rA.port = "");
        break;
      case "protocol":
        rA.protocol = sA.toLowerCase(), rA.slashes = !NA;
        break;
      case "pathname":
      case "hash":
        if (sA) {
          var yA = wA === "pathname" ? "/" : "#";
          rA[wA] = sA.charAt(0) !== yA ? yA + sA : sA;
        } else
          rA[wA] = sA;
        break;
      case "username":
      case "password":
        rA[wA] = encodeURIComponent(sA);
        break;
      case "auth":
        var bA = sA.indexOf(":");
        ~bA ? (rA.username = sA.slice(0, bA), rA.username = encodeURIComponent(decodeURIComponent(rA.username)), rA.password = sA.slice(bA + 1), rA.password = encodeURIComponent(decodeURIComponent(rA.password))) : rA.username = encodeURIComponent(decodeURIComponent(sA));
    }
    for (var RA = 0; RA < cA.length; RA++) {
      var FA = cA[RA];
      FA[4] && (rA[FA[1]] = rA[FA[1]].toLowerCase());
    }
    return rA.auth = rA.password ? rA.username + ":" + rA.password : rA.username, rA.origin = rA.protocol !== "file:" && aA(rA.protocol) && rA.host ? rA.protocol + "//" + rA.host : "null", rA.href = rA.toString(), rA;
  }
  function hA(wA) {
    (!wA || typeof wA != "function") && (wA = gA.stringify);
    var sA, NA = this, rA = NA.host, yA = NA.protocol;
    yA && yA.charAt(yA.length - 1) !== ":" && (yA += ":");
    var bA = yA + (NA.protocol && NA.slashes || aA(NA.protocol) ? "//" : "");
    return NA.username ? (bA += NA.username, NA.password && (bA += ":" + NA.password), bA += "@") : NA.password ? (bA += ":" + NA.password, bA += "@") : NA.protocol !== "file:" && aA(NA.protocol) && !rA && NA.pathname !== "/" && (bA += "@"), (rA[rA.length - 1] === ":" || QA.test(NA.hostname) && !NA.port) && (rA += ":"), bA += rA + NA.pathname, sA = typeof NA.query == "object" ? wA(NA.query) : NA.query, sA && (bA += sA.charAt(0) !== "?" ? "?" + sA : sA), NA.hash && (bA += NA.hash), bA;
  }
  return nA.prototype = { set: DA, toString: hA }, nA.extractProtocol = GA, nA.location = eA, nA.trimLeft = oA, nA.qs = gA, urlParse = nA, urlParse;
}
var hasRequiredUrl;
function requireUrl() {
  if (hasRequiredUrl) return url;
  hasRequiredUrl = 1;
  var CA = url && url.__importDefault || function(BA) {
    return BA && BA.__esModule ? BA : { default: BA };
  };
  Object.defineProperty(url, "__esModule", { value: !0 }), url.URLExt = void 0;
  const gA = requirePathBrowserify(), AA = CA(requireUrlParse());
  var IA;
  return (function(BA) {
    function QA(GA) {
      if (typeof document < "u" && document) {
        const lA = document.createElement("a");
        return lA.href = GA, lA;
      }
      return (0, AA.default)(GA);
    }
    BA.parse = QA;
    function EA(GA) {
      return (0, AA.default)(GA).hostname;
    }
    BA.getHostName = EA;
    function iA(GA) {
      return GA && QA(GA).toString();
    }
    BA.normalize = iA;
    function oA(...GA) {
      let lA = (0, AA.default)(GA[0], {});
      const nA = lA.protocol === "" && lA.slashes;
      nA && (lA = (0, AA.default)(GA[0], "https:" + GA[0]));
      const DA = `${nA ? "" : lA.protocol}${lA.slashes ? "//" : ""}${lA.auth}${lA.auth ? "@" : ""}${lA.host}`, hA = gA.posix.join(`${DA && lA.pathname[0] !== "/" ? "/" : ""}${lA.pathname}`, ...GA.slice(1));
      return `${DA}${hA === "." ? "" : hA}`;
    }
    BA.join = oA;
    function cA(GA) {
      return oA(...GA.split("/").map(encodeURIComponent));
    }
    BA.encodeParts = cA;
    function tA(GA) {
      const lA = Object.keys(GA).filter((nA) => nA.length > 0);
      return lA.length ? "?" + lA.map((nA) => {
        const DA = encodeURIComponent(String(GA[nA]));
        return nA + (DA ? "=" + DA : "");
      }).join("&") : "";
    }
    BA.objectToQueryString = tA;
    function eA(GA) {
      return GA.replace(/^\?/, "").split("&").reduce((lA, nA) => {
        const [DA, hA] = nA.split("=");
        return DA.length > 0 && (lA[DA] = decodeURIComponent(hA || "")), lA;
      }, {});
    }
    BA.queryStringToObject = eA;
    function aA(GA, lA = !1) {
      const { protocol: nA } = QA(GA);
      return (!nA || GA.toLowerCase().indexOf(nA) !== 0) && (lA ? GA.indexOf("//") !== 0 : GA.indexOf("/") !== 0);
    }
    BA.isLocal = aA;
  })(IA || (url.URLExt = IA = {})), url;
}
var hasRequiredPageconfig;
function requirePageconfig() {
  if (hasRequiredPageconfig) return pageconfig;
  hasRequiredPageconfig = 1;
  var __importDefault = pageconfig && pageconfig.__importDefault || function(CA) {
    return CA && CA.__esModule ? CA : { default: CA };
  };
  Object.defineProperty(pageconfig, "__esModule", { value: !0 }), pageconfig.PageConfig = void 0;
  const coreutils_1 = requireDist(), minimist_1 = __importDefault(requireMinimist()), url_1 = /* @__PURE__ */ requireUrl();
  var PageConfig;
  return (function(PageConfig) {
    function getOption(name) {
      if (configData)
        return configData[name] || getBodyData(name);
      configData = /* @__PURE__ */ Object.create(null);
      let found = !1;
      if (typeof document < "u" && document) {
        const CA = document.getElementById("jupyter-config-data");
        CA && (configData = JSON.parse(CA.textContent || ""), found = !0);
      }
      if (!found && typeof process < "u" && process.argv)
        try {
          const cli = (0, minimist_1.default)(process.argv.slice(2)), path = requirePathBrowserify();
          let fullPath = "";
          "jupyter-config-data" in cli ? fullPath = path.resolve(cli["jupyter-config-data"]) : "JUPYTER_CONFIG_DATA" in process.env && (fullPath = path.resolve(process.env.JUPYTER_CONFIG_DATA)), fullPath && (configData = eval("require")(fullPath));
        } catch (CA) {
          console.error(CA);
        }
      if (!coreutils_1.JSONExt.isObject(configData))
        configData = /* @__PURE__ */ Object.create(null);
      else
        for (const CA in configData)
          typeof configData[CA] != "string" && (configData[CA] = JSON.stringify(configData[CA]));
      return configData[name] || getBodyData(name);
    }
    PageConfig.getOption = getOption;
    function setOption(CA, gA) {
      const AA = getOption(CA);
      return configData[CA] = gA, AA;
    }
    PageConfig.setOption = setOption;
    function getBaseUrl() {
      return url_1.URLExt.normalize(getOption("baseUrl") || "/");
    }
    PageConfig.getBaseUrl = getBaseUrl;
    function getTreeUrl() {
      return url_1.URLExt.join(getBaseUrl(), getOption("treeUrl"));
    }
    PageConfig.getTreeUrl = getTreeUrl;
    function getShareUrl() {
      return url_1.URLExt.normalize(getOption("shareUrl") || getBaseUrl());
    }
    PageConfig.getShareUrl = getShareUrl;
    function getTreeShareUrl() {
      return url_1.URLExt.normalize(url_1.URLExt.join(getShareUrl(), getOption("treeUrl")));
    }
    PageConfig.getTreeShareUrl = getTreeShareUrl;
    function getUrl(CA) {
      var gA, AA, IA, BA;
      let QA = CA.toShare ? getShareUrl() : getBaseUrl();
      const EA = (gA = CA.mode) !== null && gA !== void 0 ? gA : getOption("mode"), iA = (AA = CA.workspace) !== null && AA !== void 0 ? AA : getOption("workspace"), oA = EA === "single-document" ? "doc" : "lab";
      QA = url_1.URLExt.join(QA, oA), iA !== PageConfig.defaultWorkspace && (QA = url_1.URLExt.join(QA, "workspaces", encodeURIComponent((IA = getOption("workspace")) !== null && IA !== void 0 ? IA : PageConfig.defaultWorkspace)));
      const cA = (BA = CA.treePath) !== null && BA !== void 0 ? BA : getOption("treePath");
      return cA && (QA = url_1.URLExt.join(QA, "tree", url_1.URLExt.encodeParts(cA))), QA;
    }
    PageConfig.getUrl = getUrl, PageConfig.defaultWorkspace = "default";
    function getWsUrl(CA) {
      let gA = getOption("wsUrl");
      if (!gA) {
        if (CA = CA ? url_1.URLExt.normalize(CA) : getBaseUrl(), CA.indexOf("http") !== 0)
          return "";
        gA = "ws" + CA.slice(4);
      }
      return url_1.URLExt.normalize(gA);
    }
    PageConfig.getWsUrl = getWsUrl;
    function getNBConvertURL({ path: CA, format: gA, download: AA }) {
      const IA = url_1.URLExt.encodeParts(CA), BA = url_1.URLExt.join(getBaseUrl(), "nbconvert", gA, IA);
      return AA ? BA + "?download=true" : BA;
    }
    PageConfig.getNBConvertURL = getNBConvertURL;
    function getToken() {
      return getOption("token") || getBodyData("jupyterApiToken");
    }
    PageConfig.getToken = getToken;
    function getNotebookVersion() {
      const CA = getOption("notebookVersion");
      return CA === "" ? [0, 0, 0] : JSON.parse(CA);
    }
    PageConfig.getNotebookVersion = getNotebookVersion;
    let configData = null;
    function getBodyData(CA) {
      if (typeof document > "u" || !document.body)
        return "";
      const gA = document.body.dataset[CA];
      return typeof gA > "u" ? "" : decodeURIComponent(gA);
    }
    (function(CA) {
      function gA(BA) {
        try {
          const QA = getOption(BA);
          if (QA)
            return JSON.parse(QA);
        } catch (QA) {
          console.warn(`Unable to parse ${BA}.`, QA);
        }
        return [];
      }
      CA.deferred = gA("deferredExtensions"), CA.disabled = gA("disabledExtensions");
      function AA(BA) {
        const QA = BA.indexOf(":");
        let EA = "";
        return QA !== -1 && (EA = BA.slice(0, QA)), CA.deferred.some((iA) => iA === BA || EA && iA === EA);
      }
      CA.isDeferred = AA;
      function IA(BA) {
        const QA = BA.indexOf(":");
        let EA = "";
        return QA !== -1 && (EA = BA.slice(0, QA)), CA.disabled.some((iA) => iA === BA || EA && iA === EA);
      }
      CA.isDisabled = IA;
    })(PageConfig.Extension || (PageConfig.Extension = {}));
  })(PageConfig || (pageconfig.PageConfig = PageConfig = {})), pageconfig;
}
var path = {}, hasRequiredPath;
function requirePath() {
  if (hasRequiredPath) return path;
  hasRequiredPath = 1, Object.defineProperty(path, "__esModule", { value: !0 }), path.PathExt = void 0;
  const CA = requirePathBrowserify();
  var gA;
  return (function(AA) {
    function IA(...GA) {
      const lA = CA.posix.join(...GA);
      return lA === "." ? "" : aA(lA);
    }
    AA.join = IA;
    function BA(...GA) {
      const lA = CA.posix.join(...GA);
      return lA === "." ? "" : lA;
    }
    AA.joinWithLeadingSlash = BA;
    function QA(GA, lA) {
      return CA.posix.basename(GA, lA);
    }
    AA.basename = QA;
    function EA(GA) {
      const lA = aA(CA.posix.dirname(GA));
      return lA === "." ? "" : lA;
    }
    AA.dirname = EA;
    function iA(GA) {
      return CA.posix.extname(GA);
    }
    AA.extname = iA;
    function oA(GA) {
      return GA === "" ? "" : aA(CA.posix.normalize(GA));
    }
    AA.normalize = oA;
    function cA(...GA) {
      return aA(CA.posix.resolve(...GA));
    }
    AA.resolve = cA;
    function tA(GA, lA) {
      return aA(CA.posix.relative(GA, lA));
    }
    AA.relative = tA;
    function eA(GA) {
      return GA.length > 0 && GA.indexOf(".") !== 0 && (GA = `.${GA}`), GA;
    }
    AA.normalizeExtension = eA;
    function aA(GA) {
      return GA.indexOf("/") === 0 && (GA = GA.slice(1)), GA;
    }
    AA.removeSlash = aA;
  })(gA || (path.PathExt = gA = {})), path;
}
var signal = {}, hasRequiredSignal;
function requireSignal() {
  if (hasRequiredSignal) return signal;
  hasRequiredSignal = 1, Object.defineProperty(signal, "__esModule", { value: !0 }), signal.signalToPromise = gA;
  const CA = requireDist();
  function gA(AA, IA) {
    const BA = new CA.PromiseDelegate();
    function QA() {
      AA.disconnect(EA);
    }
    function EA(iA, oA) {
      QA(), BA.resolve([iA, oA]);
    }
    return AA.connect(EA), (IA ?? 0) > 0 && setTimeout(() => {
      QA(), BA.reject(`Signal not emitted within ${IA} ms.`);
    }, IA), BA.promise;
  }
  return signal;
}
var text = {}, hasRequiredText;
function requireText() {
  if (hasRequiredText) return text;
  hasRequiredText = 1, Object.defineProperty(text, "__esModule", { value: !0 }), text.Text = void 0;
  var CA;
  return (function(gA) {
    function IA(iA, oA) {
      return iA;
    }
    gA.jsIndexToCharIndex = IA;
    function BA(iA, oA) {
      return iA;
    }
    gA.charIndexToJsIndex = BA;
    function QA(iA, oA = !1) {
      return iA.replace(/^(\w)|[\s-_:]+(\w)/g, function(cA, tA, eA) {
        return eA ? eA.toUpperCase() : oA ? tA.toUpperCase() : tA.toLowerCase();
      });
    }
    gA.camelCase = QA;
    function EA(iA) {
      return (iA || "").toLowerCase().split(" ").map((oA) => oA.charAt(0).toUpperCase() + oA.slice(1)).join(" ");
    }
    gA.titleCase = EA;
  })(CA || (text.Text = CA = {})), text;
}
var time = {}, hasRequiredTime;
function requireTime() {
  if (hasRequiredTime) return time;
  hasRequiredTime = 1, Object.defineProperty(time, "__esModule", { value: !0 }), time.Time = void 0;
  const CA = [
    { name: "years", milliseconds: 365 * 24 * 60 * 60 * 1e3 },
    { name: "months", milliseconds: 720 * 60 * 60 * 1e3 },
    { name: "days", milliseconds: 1440 * 60 * 1e3 },
    { name: "hours", milliseconds: 3600 * 1e3 },
    { name: "minutes", milliseconds: 60 * 1e3 },
    { name: "seconds", milliseconds: 1e3 }
  ];
  var gA;
  return (function(AA) {
    function IA(QA, EA = "long") {
      const iA = document.documentElement.lang || "en", oA = new Intl.RelativeTimeFormat(iA, {
        numeric: "auto",
        style: EA
      }), cA = new Date(QA).getTime() - Date.now();
      for (let tA of CA) {
        const eA = Math.ceil(cA / tA.milliseconds);
        if (eA !== 0)
          return oA.format(eA, tA.name);
      }
      return oA.format(0, "seconds");
    }
    AA.formatHuman = IA;
    function BA(QA) {
      const EA = document.documentElement.lang || "en";
      return new Intl.DateTimeFormat(EA, {
        dateStyle: "short",
        timeStyle: "short"
      }).format(new Date(QA));
    }
    AA.format = BA;
  })(gA || (time.Time = gA = {})), time;
}
var hasRequiredLib;
function requireLib() {
  return hasRequiredLib || (hasRequiredLib = 1, (function(CA) {
    var gA = lib && lib.__createBinding || (Object.create ? (function(IA, BA, QA, EA) {
      EA === void 0 && (EA = QA);
      var iA = Object.getOwnPropertyDescriptor(BA, QA);
      (!iA || ("get" in iA ? !BA.__esModule : iA.writable || iA.configurable)) && (iA = { enumerable: !0, get: function() {
        return BA[QA];
      } }), Object.defineProperty(IA, EA, iA);
    }) : (function(IA, BA, QA, EA) {
      EA === void 0 && (EA = QA), IA[EA] = BA[QA];
    })), AA = lib && lib.__exportStar || function(IA, BA) {
      for (var QA in IA) QA !== "default" && !Object.prototype.hasOwnProperty.call(BA, QA) && gA(BA, IA, QA);
    };
    Object.defineProperty(CA, "__esModule", { value: !0 }), AA(/* @__PURE__ */ requireActivitymonitor(), CA), AA(/* @__PURE__ */ requireInterfaces(), CA), AA(/* @__PURE__ */ requireLru(), CA), AA(/* @__PURE__ */ requireMarkdowncodeblocks(), CA), AA(/* @__PURE__ */ requirePageconfig(), CA), AA(/* @__PURE__ */ requirePath(), CA), AA(/* @__PURE__ */ requireSignal(), CA), AA(/* @__PURE__ */ requireText(), CA), AA(/* @__PURE__ */ requireTime(), CA), AA(/* @__PURE__ */ requireUrl(), CA);
  })(lib)), lib;
}
var libExports = /* @__PURE__ */ requireLib();
function manipulateIFrameDocument(CA, gA, AA) {
  const IA = [], BA = gA.getElementsByTagName("script");
  for (const EA of BA) {
    if (EA.src === "")
      continue;
    const iA = getRelativePath(window.location.host, window.location.pathname, new URL(EA.src));
    if (iA == null)
      continue;
    const oA = libExports.URLExt.join(AA, iA), cA = CA.sendHttpRequest({
      method: "GET",
      headers: {},
      path: oA,
      body: ""
    }).then(({
      statusCode: tA,
      headers: eA,
      body: aA
    }) => {
      if (tA !== 200)
        return;
      const GA = eA.get("Content-Type");
      return new Blob([aA], GA ? {
        type: GA
      } : void 0).text().then((nA) => {
        const DA = gA.createElement("script");
        DA.text = nA, DA.type = "text/javascript", DA.setAttribute("data-stlite", ""), EA.replaceWith(DA);
      });
    });
    IA.push(cA);
  }
  const QA = gA.querySelectorAll("link[rel=stylesheet]");
  for (const EA of QA) {
    const iA = getRelativePath(window.location.host, window.location.pathname, new URL(EA.href));
    if (iA == null)
      continue;
    const oA = libExports.URLExt.join(AA, iA), cA = CA.sendHttpRequest({
      method: "GET",
      headers: {},
      path: oA,
      body: ""
    }).then(({
      statusCode: tA,
      headers: eA,
      body: aA
    }) => {
      if (tA !== 200)
        return;
      const GA = eA.get("Content-Type");
      return new Blob([aA], GA ? {
        type: GA
      } : void 0).text().then((nA) => {
        const DA = gA.createElement("style");
        DA.innerHTML = nA, DA.setAttribute("data-stlite", ""), EA.replaceWith(DA);
      });
    });
    IA.push(cA);
  }
  return Promise.all(IA).then();
}
const InnerIFrame = React__default.forwardRef(({
  src: CA,
  IframeComponent: gA,
  ...AA
}, IA) => {
  const BA = useStliteKernel(), [QA, EA] = useState();
  useEffect(() => {
    if (BA == null || !CA.startsWith("/component"))
      return;
    let oA = !1;
    return BA.sendHttpRequest({
      method: "GET",
      path: CA,
      headers: {},
      body: ""
    }).then(({
      statusCode: cA,
      headers: tA,
      body: eA
    }) => {
      if (oA || cA !== 200)
        return;
      const aA = tA.get("Content-Type");
      new Blob([eA], aA ? {
        type: aA
      } : void 0).text().then((lA) => {
        oA || EA(lA);
      });
    }), () => {
      oA = !0;
    };
  }, [BA, CA]);
  const iA = useCallback((oA) => {
    const tA = oA.target.contentWindow?.document;
    if (tA == null) {
      console.warn("document not found in iframe");
      return;
    }
    manipulateIFrameDocument(BA, tA, getParentPath(CA));
  }, [BA, CA]);
  return jsxRuntimeExports.jsx(gA, {
    ...AA,
    srcDoc: QA,
    onLoad: iA,
    ref: IA
  });
});
InnerIFrame.displayName = "InnerIFrame";
const CustomComponentIFrame = React__default.forwardRef((CA, gA) => {
  const AA = useStliteKernel(), IA = useMemo$1(() => extractCustomComponentPath(AA.basePath, CA.src), [AA.basePath, CA.src]);
  return IA == null ? jsxRuntimeExports.jsx("iframe", {
    ...CA,
    ref: gA
  }) : jsxRuntimeExports.jsx(InnerIFrame, {
    ...CA,
    src: IA,
    ref: gA
  });
});
CustomComponentIFrame.displayName = "StliteCustomComponentIFrame";
function EventContainer({
  children: CA
}) {
  const gA = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ToasterContainer,
      {
        placement: PLACEMENT$1.topRight,
        autoHideDuration: 4 * 1e3,
        overrides: {
          Root: {
            style: {
              // Avoids blocking the header
              top: gA.sizes.headerHeight,
              zIndex: gA.zIndices.toast
            },
            props: {
              "data-testid": "stToastContainer",
              className: "stToastContainer"
            }
          }
        }
      }
    ),
    CA
  ] });
}
const StyledLogoContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby6"
} : {
  target: "ezrtsby6",
  label: "StyledLogoContainer"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeader$1 = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby5"
} : {
  target: "ezrtsby5",
  label: "StyledHeader"
})(({
  theme: CA,
  isTransparentBackground: gA
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  display: "flex",
  alignItems: "center",
  height: CA.sizes.headerHeight,
  minHeight: CA.sizes.headerHeight,
  width: "100%",
  background: gA ? "transparent" : CA.colors.bgColor,
  outline: "none",
  zIndex: CA.zIndices.header,
  pointerEvents: gA ? "none" : "auto",
  fontSize: CA.fontSizes.sm,
  "@media print": {
    position: "absolute",
    background: "transparent",
    // Hide all descendants by default
    "& *": {
      display: "none !important"
    },
    // Show the logo container and its parents/contents
    [`& ${StyledLogoContainer}, & ${StyledLogoContainer} *, & :has(${StyledLogoContainer})`]: {
      display: "flex !important"
    },
    [`& ${StyledLogoContainer} img`]: {
      display: "block !important"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderToolbar = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby4"
} : {
  target: "ezrtsby4",
  label: "StyledHeaderToolbar"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  height: "100%",
  width: "100%",
  padding: 0,
  pointerEvents: "auto",
  position: "relative",
  zIndex: CA.zIndices.header
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledOpenSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby3"
} : {
  target: "ezrtsby3",
  label: "StyledOpenSidebarButton"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: CA.spacing.lg,
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby2"
} : {
  target: "ezrtsby2",
  label: "StyledHeaderContent"
})(() => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  margin: 0,
  border: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderLeftSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby1"
} : {
  target: "ezrtsby1",
  label: "StyledHeaderLeftSection"
})(() => ({
  display: "flex",
  alignItems: "center",
  // Prevent the logo area from shrinking when TopNav's overflow container expands.
  // Without this, the logo would shrink due to its maxWidth: 100% style.
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledHeaderRightSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ezrtsby0"
} : {
  target: "ezrtsby0",
  label: "StyledHeaderRightSection"
})(({
  theme: CA
}) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginLeft: "auto",
  height: "100%",
  minWidth: CA.sizes.headerRightContentMaxWidth,
  marginRight: CA.spacing.lg
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Header = ({
  hasSidebar: CA,
  isSidebarOpen: gA,
  onToggleSidebar: AA,
  navigation: IA,
  rightContent: BA,
  logoComponent: QA,
  showToolbar: EA
}) => {
  const {
    activeTheme: iA
  } = useContext(ThemeContext), oA = QA && !gA, cA = CA && !gA, tA = EA && BA, eA = oA || cA || IA || tA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader$1, { className: "stAppHeader", "data-testid": "stHeader", isTransparentBackground: !eA, children: eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderToolbar, { className: "stAppToolbar", "data-testid": "stToolbar", theme: iA.emotion, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderLeftSection, { children: [
      oA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoContainer, { children: QA }) : null,
      cA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOpenSidebarButton, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: AA, "data-testid": "stExpandSidebarButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_right:", color: iA.emotion.colors.fadedText60 }) }) })
    ] }),
    IA,
    tA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeaderRightSection, { children: BA }) : null
  ] }) }) : null });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$9() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getSidebarHorizontalSpacing = (CA, gA) => `max(
    ${gA}px,
    calc(${CA.spacing.xl} - ${gA}px)
  )`, StyledSidebar = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "eczjsme10"
} : {
  target: "eczjsme10",
  label: "StyledSidebar"
})(({
  theme: CA,
  isCollapsed: gA,
  adjustTop: AA,
  sidebarWidth: IA,
  windowInnerWidth: BA
}) => {
  const QA = gA ? 0 : Math.min(200, BA), EA = gA ? 0 : Math.min(600, BA * 0.9);
  return {
    position: "relative",
    // Nudge the sidebar by 2px so the header decoration doesn't go below it
    top: AA ? CA.sizes.headerDecorationHeight : CA.spacing.none,
    backgroundColor: CA.colors.bgColor,
    // Since the sidebar can have a different theme (+ background)
    // we need to explicitly set the font color and color scheme
    // here again so that it is inherited correctly by all sidebar elements:
    color: CA.colors.bodyText,
    colorScheme: hasLightBackgroundColor(CA) ? "light" : "dark",
    zIndex: CA.zIndices.header + 1,
    minWidth: QA,
    maxWidth: EA,
    transform: gA ? `translateX(-${IA}px)` : "none",
    transition: "transform 300ms, min-width 300ms, max-width 300ms",
    "&:focus": {
      outline: "none"
    },
    [`@media (max-width: ${CA.breakpoints.md})`]: {
      boxShadow: gA ? "-2rem 0 2rem 2rem transparent" : CA.shadows.sidebar
    },
    "@media print": {
      display: gA ? "none" : "initial",
      // set to auto, otherwise the sidebar does not take up the whole page
      height: "auto !important",
      // set maxHeight to little bit less than 100%, otherwise the sidebar might start a mostly blank page
      maxHeight: "99%",
      // on Chrome, sth. adds a box-shadow in printing mode which looks weird
      boxShadow: "none"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarUserContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme9"
} : {
  target: "eczjsme9",
  label: "StyledSidebarUserContent"
})(({
  hasPageNavAbove: CA,
  theme: gA
}) => ({
  paddingTop: CA ? gA.spacing.twoXL : 0,
  paddingBottom: gA.sizes.sidebarTopSpace
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme8"
} : {
  target: "eczjsme8",
  label: "StyledSidebarContent"
})(({
  theme: CA,
  scrollbarGutterSize: gA
}) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "auto",
  /**
   * Ensure that space is reserved for scrollbars, even when they are not
   * visible. This is necessary to prevent layout shifts when the scrollbars
   * appear and disappear.
   *
   * We utilize both-edges so that things look visually centered and aligned.
   *
   * @see https://github.com/streamlit/streamlit/issues/10310
   */
  scrollbarGutter: "stable both-edges",
  paddingLeft: getSidebarHorizontalSpacing(CA, gA),
  paddingRight: getSidebarHorizontalSpacing(CA, gA)
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), RESIZE_HANDLE_WIDTH = "8px", StyledResizeHandle = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme7"
} : {
  target: "eczjsme7",
  label: "StyledResizeHandle"
})(({
  theme: CA
}) => ({
  position: "absolute",
  width: RESIZE_HANDLE_WIDTH,
  height: "100%",
  cursor: "col-resize",
  zIndex: CA.zIndices.sidebarMobile,
  backgroundImage: CA.showSidebarBorder ? `linear-gradient(to right, transparent 20%, ${CA.colors.borderColor} 28%, transparent 36%)` : "none",
  "&:hover": {
    backgroundImage: `linear-gradient(to right, transparent 20%, ${CA.colors.borderColor} 28%, transparent 44%)`
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarHeaderContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme6"
} : {
  target: "eczjsme6",
  label: "StyledSidebarHeaderContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: CA.spacing.lg,
  height: CA.sizes.headerHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TaWRlYmFyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtKNEMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL1NpZGViYXIvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lLCBoYXNMaWdodEJhY2tncm91bmRDb2xvciB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbi8qKlxuICogUmV0dXJucyB0aGUgaG9yaXpvbnRhbCBzcGFjaW5nIGZvciB0aGUgc2lkZWJhciwgdGFraW5nIGludG8gY29uc2lkZXJhdGlvblxuICogdGhlIHNjcm9sbGJhciBndXR0ZXJzIChvbmUgb24gZWFjaCBzaWRlKSB3aGljaCBhcmUgcHJlc2VudCB3aGVuIHRoZSBPU1xuICogZG9lc24ndCBzdXBwb3J0IG92ZXJsYXkgc2Nyb2xsYmFycy5cbiAqXG4gKiBAcGFyYW0gdGhlbWUgVGhlIHRoZW1lIHRvIHVzZS5cbiAqIEByZXR1cm5zIFRoZSBob3Jpem9udGFsIHNwYWNpbmcgZm9yIHRoZSBzaWRlYmFyLlxuICovXG5jb25zdCBnZXRTaWRlYmFySG9yaXpvbnRhbFNwYWNpbmcgPSAoXG4gIHRoZW1lOiBFbW90aW9uVGhlbWUsXG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxuKTogc3RyaW5nID0+IHtcbiAgLy8gVGhpcyBzaG91bGQgYmUgbWF4KDBweCwgLi4uKSwgYnV0IHRoZXJlJ3MgYSBDaHJvbWUgYnVnIHRoYXRcbiAgLy8gY2F1c2VzIGNvbnRlbnQgdG8gY2xpcCB3aGVuIHNjcm9sbGJhci1ndXR0ZXIgaXMgc2V0IHRvIFwic3RhYmxlIGJvdGgtZWRnZXNcIi5cbiAgLy8gU28gd2UgY2hhbmdlIHRoZSBtaW4gZnJvbSAwcHggdG8gc2Nyb2xsYmFyR3V0dGVyU2l6ZSB0byBhY2NvdW50IGZvciB0aGF0LlxuICAvLyBDaHJvbWUgYnVnOiBodHRwczovL2lzc3Vlcy5jaHJvbWl1bS5vcmcvaXNzdWVzLzQwMDY0ODc5XG4gIHJldHVybiBgbWF4KFxuICAgICR7c2Nyb2xsYmFyR3V0dGVyU2l6ZX1weCxcbiAgICBjYWxjKCR7dGhlbWUuc3BhY2luZy54bH0gLSAke3Njcm9sbGJhckd1dHRlclNpemV9cHgpXG4gIClgXG59XG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyUHJvcHMge1xuICBpc0NvbGxhcHNlZDogYm9vbGVhblxuICBhZGp1c3RUb3A6IGJvb2xlYW5cbiAgc2lkZWJhcldpZHRoOiBzdHJpbmdcbiAgd2luZG93SW5uZXJXaWR0aDogbnVtYmVyXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyID0gc3R5bGVkLnNlY3Rpb248U3R5bGVkU2lkZWJhclByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ29sbGFwc2VkLCBhZGp1c3RUb3AsIHNpZGViYXJXaWR0aCwgd2luZG93SW5uZXJXaWR0aCB9KSA9PiB7XG4gICAgY29uc3QgbWluV2lkdGggPSBpc0NvbGxhcHNlZCA/IDAgOiBNYXRoLm1pbigyMDAsIHdpbmRvd0lubmVyV2lkdGgpXG4gICAgY29uc3QgbWF4V2lkdGggPSBpc0NvbGxhcHNlZCA/IDAgOiBNYXRoLm1pbig2MDAsIHdpbmRvd0lubmVyV2lkdGggKiAwLjkpXG5cbiAgICByZXR1cm4ge1xuICAgICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICAgIC8vIE51ZGdlIHRoZSBzaWRlYmFyIGJ5IDJweCBzbyB0aGUgaGVhZGVyIGRlY29yYXRpb24gZG9lc24ndCBnbyBiZWxvdyBpdFxuICAgICAgdG9wOiBhZGp1c3RUb3AgPyB0aGVtZS5zaXplcy5oZWFkZXJEZWNvcmF0aW9uSGVpZ2h0IDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuYmdDb2xvcixcbiAgICAgIC8vIFNpbmNlIHRoZSBzaWRlYmFyIGNhbiBoYXZlIGEgZGlmZmVyZW50IHRoZW1lICgrIGJhY2tncm91bmQpXG4gICAgICAvLyB3ZSBuZWVkIHRvIGV4cGxpY2l0bHkgc2V0IHRoZSBmb250IGNvbG9yIGFuZCBjb2xvciBzY2hlbWVcbiAgICAgIC8vIGhlcmUgYWdhaW4gc28gdGhhdCBpdCBpcyBpbmhlcml0ZWQgY29ycmVjdGx5IGJ5IGFsbCBzaWRlYmFyIGVsZW1lbnRzOlxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgIGNvbG9yU2NoZW1lOiBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSkgPyBcImxpZ2h0XCIgOiBcImRhcmtcIixcbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyICsgMSxcblxuICAgICAgbWluV2lkdGgsXG4gICAgICBtYXhXaWR0aCxcbiAgICAgIHRyYW5zZm9ybTogaXNDb2xsYXBzZWQgPyBgdHJhbnNsYXRlWCgtJHtzaWRlYmFyV2lkdGh9cHgpYCA6IFwibm9uZVwiLFxuICAgICAgdHJhbnNpdGlvbjogXCJ0cmFuc2Zvcm0gMzAwbXMsIG1pbi13aWR0aCAzMDBtcywgbWF4LXdpZHRoIDMwMG1zXCIsXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICAgICAgYm94U2hhZG93OiBpc0NvbGxhcHNlZFxuICAgICAgICAgID8gXCItMnJlbSAwIDJyZW0gMnJlbSB0cmFuc3BhcmVudFwiXG4gICAgICAgICAgOiB0aGVtZS5zaGFkb3dzLnNpZGViYXIsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIGRpc3BsYXk6IGlzQ29sbGFwc2VkID8gXCJub25lXCIgOiBcImluaXRpYWxcIixcbiAgICAgICAgLy8gc2V0IHRvIGF1dG8sIG90aGVyd2lzZSB0aGUgc2lkZWJhciBkb2VzIG5vdCB0YWtlIHVwIHRoZSB3aG9sZSBwYWdlXG4gICAgICAgIGhlaWdodDogXCJhdXRvICFpbXBvcnRhbnRcIixcbiAgICAgICAgLy8gc2V0IG1heEhlaWdodCB0byBsaXR0bGUgYml0IGxlc3MgdGhhbiAxMDAlLCBvdGhlcndpc2UgdGhlIHNpZGViYXIgbWlnaHQgc3RhcnQgYSBtb3N0bHkgYmxhbmsgcGFnZVxuICAgICAgICBtYXhIZWlnaHQ6IFwiOTklXCIsXG4gICAgICAgIC8vIG9uIENocm9tZSwgc3RoLiBhZGRzIGEgYm94LXNoYWRvdyBpbiBwcmludGluZyBtb2RlIHdoaWNoIGxvb2tzIHdlaXJkXG4gICAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHMge1xuICBoYXNQYWdlTmF2QWJvdmU6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJVc2VyQ29udGVudCA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHM+KCh7IGhhc1BhZ2VOYXZBYm92ZSwgdGhlbWUgfSkgPT4gKHtcbiAgICBwYWRkaW5nVG9wOiBoYXNQYWdlTmF2QWJvdmUgPyB0aGVtZS5zcGFjaW5nLnR3b1hMIDogMCxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zaXplcy5zaWRlYmFyVG9wU3BhY2UsXG4gIH0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhckNvbnRlbnRQcm9wcyB7XG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckNvbnRlbnQgPSBzdHlsZWQuZGl2PFN0eWxlZFNpZGViYXJDb250ZW50UHJvcHM+KFxuICAoeyB0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSB9KSA9PiAoe1xuICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICAgIC8qKlxuICAgICAqIEVuc3VyZSB0aGF0IHNwYWNlIGlzIHJlc2VydmVkIGZvciBzY3JvbGxiYXJzLCBldmVuIHdoZW4gdGhleSBhcmUgbm90XG4gICAgICogdmlzaWJsZS4gVGhpcyBpcyBuZWNlc3NhcnkgdG8gcHJldmVudCBsYXlvdXQgc2hpZnRzIHdoZW4gdGhlIHNjcm9sbGJhcnNcbiAgICAgKiBhcHBlYXIgYW5kIGRpc2FwcGVhci5cbiAgICAgKlxuICAgICAqIFdlIHV0aWxpemUgYm90aC1lZGdlcyBzbyB0aGF0IHRoaW5ncyBsb29rIHZpc3VhbGx5IGNlbnRlcmVkIGFuZCBhbGlnbmVkLlxuICAgICAqXG4gICAgICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vc3RyZWFtbGl0L3N0cmVhbWxpdC9pc3N1ZXMvMTAzMTBcbiAgICAgKi9cbiAgICBzY3JvbGxiYXJHdXR0ZXI6IFwic3RhYmxlIGJvdGgtZWRnZXNcIixcbiAgICBwYWRkaW5nTGVmdDogZ2V0U2lkZWJhckhvcml6b250YWxTcGFjaW5nKHRoZW1lLCBzY3JvbGxiYXJHdXR0ZXJTaXplKSxcbiAgICBwYWRkaW5nUmlnaHQ6IGdldFNpZGViYXJIb3Jpem9udGFsU3BhY2luZyh0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBSRVNJWkVfSEFORExFX1dJRFRIID0gXCI4cHhcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVzaXplSGFuZGxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogUkVTSVpFX0hBTkRMRV9XSURUSCxcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgY3Vyc29yOiBcImNvbC1yZXNpemVcIixcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyTW9iaWxlLFxuICBiYWNrZ3JvdW5kSW1hZ2U6IHRoZW1lLnNob3dTaWRlYmFyQm9yZGVyXG4gICAgPyBgbGluZWFyLWdyYWRpZW50KHRvIHJpZ2h0LCB0cmFuc3BhcmVudCAyMCUsICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfSAyOCUsIHRyYW5zcGFyZW50IDM2JSlgXG4gICAgOiBcIm5vbmVcIixcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGJhY2tncm91bmRJbWFnZTogYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdHJhbnNwYXJlbnQgMjAlLCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn0gMjglLCB0cmFuc3BhcmVudCA0NCUpYCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckhlYWRlckNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcInNwYWNlLWJldHdlZW5cIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckhlaWdodCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTG9nb0xpbmsgPSBzdHlsZWQuYSh7XG4gIFwiJjpob3ZlclwiOiB7XG4gICAgb3BhY2l0eTogXCIwLjdcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvQnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIC8vIFJlc2V0IGJ1dHRvbiBzdHlsZXNcbiAgYmFja2dyb3VuZDogXCJub25lXCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIHBhZGRpbmc6IDAsXG4gIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gIFwiJjpob3ZlclwiOiB7XG4gICAgb3BhY2l0eTogXCIwLjdcIixcbiAgfSxcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRMb2dvUHJvcHMge1xuICBzaXplOiBzdHJpbmdcbiAgc2lkZWJhcldpZHRoPzogc3RyaW5nXG59XG5cbmZ1bmN0aW9uIHRyYW5zbGF0ZUxvZ29IZWlnaHQodGhlbWU6IEVtb3Rpb25UaGVtZSwgc2l6ZTogc3RyaW5nKTogc3RyaW5nIHtcbiAgaWYgKHNpemUgPT09IFwic21hbGxcIikge1xuICAgIHJldHVybiB0aGVtZS5zaXplcy5zbWFsbExvZ29IZWlnaHRcbiAgfSBlbHNlIGlmIChzaXplID09PSBcImxhcmdlXCIpIHtcbiAgICByZXR1cm4gdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0XG4gIH1cbiAgLy8gRGVmYXVsdCBsb2dvIHNpemVcbiAgcmV0dXJuIHRoZW1lLnNpemVzLmRlZmF1bHRMb2dvSGVpZ2h0XG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvID0gc3R5bGVkLmltZzxTdHlsZWRMb2dvUHJvcHM+KCh7IHRoZW1lLCBzaXplIH0pID0+ICh7XG4gIGhlaWdodDogdHJhbnNsYXRlTG9nb0hlaWdodCh0aGVtZSwgc2l6ZSksXG4gIC8vIEV4dHJhIG1hcmdpbiB0byBhbGlnbiBzbWFsbCBsb2dvIHdpdGggc2lkZWJhciBjb2xsYXBzZSBhcnJvd1xuICBtYXJnaW5Ub3A6IHNpemUgPT0gXCJzbWFsbFwiID8gdGhlbWUuc3BhY2luZy54cyA6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIG1hcmdpbkJvdHRvbTogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmhlYWRlcixcbiAgb2JqZWN0Rml0OiBcImNvbnRhaW5cIixcbiAgb2JqZWN0UG9zaXRpb246IFwibGVmdFwiLFxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICBtYXhXaWR0aDogYDEwMCVgLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJY29uTG9nbyA9IHN0eWxlZC5kaXY8U3R5bGVkTG9nb1Byb3BzPihcbiAgKHsgdGhlbWUsIHNpemUgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImZsZXgtc3RhcnRcIixcbiAgICBoZWlnaHQ6IHRyYW5zbGF0ZUxvZ29IZWlnaHQodGhlbWUsIHNpemUpLFxuICAgIG1hcmdpblRvcDogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBtYXJnaW5Cb3R0b206IHNpemUgPT0gXCJzbWFsbFwiID8gdGhlbWUuc3BhY2luZy54cyA6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyLFxuICAgIGZvbnRTaXplOiB0cmFuc2xhdGVMb2dvSGVpZ2h0KHRoZW1lLCBzaXplKSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROb0xvZ29TcGFjZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRDb2xsYXBzZVNpZGViYXJCdXR0b25Qcm9wcyB7XG4gIHNob3dTaWRlYmFyQ29sbGFwc2U6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvbGxhcHNlU2lkZWJhckJ1dHRvbiA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQ29sbGFwc2VTaWRlYmFyQnV0dG9uUHJvcHM+KFxuICAgICh7IHNob3dTaWRlYmFyQ29sbGFwc2UsIHRoZW1lIH0pID0+IHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIGRpc3BsYXk6IFwiaW5saW5lXCIsXG4gICAgICAgIHZpc2liaWxpdHk6IHNob3dTaWRlYmFyQ29sbGFwc2UgPyBcInZpc2libGVcIiA6IFwiaGlkZGVuXCIsXG4gICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIHRyYW5zaXRpb246IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICB0cmFuc2l0aW9uRGVsYXk6IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICBjb2xvcjogaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG4gICAgICAgICAgPyB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjBcbiAgICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgICAgbGluZUhlaWdodDogXCIwXCIsXG5cbiAgICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBoaWRlIHRoZSBjb2xsYXBzZSBidXR0b24gb24gcHJpbnQ6XG4gICAgICAgICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIixcbiAgICAgICAgfSxcblxuICAgICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBzaG93IHRoZSBjb2xsYXBzZSBidXR0b24gb24gc21hbGwgc2NyZWVuczpcbiAgICAgICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcbiJdfQ== */"), StyledLogoLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "eczjsme5"
} : {
  target: "eczjsme5",
  label: "StyledLogoLink"
})(process.env.NODE_ENV === "production" ? {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}"
} : {
  name: "t02jc9",
  styles: "&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TaWRlYmFyL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBKOEIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL1NpZGViYXIvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lLCBoYXNMaWdodEJhY2tncm91bmRDb2xvciB9IGZyb20gXCJAc3RyZWFtbGl0L2xpYlwiXG5cbi8qKlxuICogUmV0dXJucyB0aGUgaG9yaXpvbnRhbCBzcGFjaW5nIGZvciB0aGUgc2lkZWJhciwgdGFraW5nIGludG8gY29uc2lkZXJhdGlvblxuICogdGhlIHNjcm9sbGJhciBndXR0ZXJzIChvbmUgb24gZWFjaCBzaWRlKSB3aGljaCBhcmUgcHJlc2VudCB3aGVuIHRoZSBPU1xuICogZG9lc24ndCBzdXBwb3J0IG92ZXJsYXkgc2Nyb2xsYmFycy5cbiAqXG4gKiBAcGFyYW0gdGhlbWUgVGhlIHRoZW1lIHRvIHVzZS5cbiAqIEByZXR1cm5zIFRoZSBob3Jpem9udGFsIHNwYWNpbmcgZm9yIHRoZSBzaWRlYmFyLlxuICovXG5jb25zdCBnZXRTaWRlYmFySG9yaXpvbnRhbFNwYWNpbmcgPSAoXG4gIHRoZW1lOiBFbW90aW9uVGhlbWUsXG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxuKTogc3RyaW5nID0+IHtcbiAgLy8gVGhpcyBzaG91bGQgYmUgbWF4KDBweCwgLi4uKSwgYnV0IHRoZXJlJ3MgYSBDaHJvbWUgYnVnIHRoYXRcbiAgLy8gY2F1c2VzIGNvbnRlbnQgdG8gY2xpcCB3aGVuIHNjcm9sbGJhci1ndXR0ZXIgaXMgc2V0IHRvIFwic3RhYmxlIGJvdGgtZWRnZXNcIi5cbiAgLy8gU28gd2UgY2hhbmdlIHRoZSBtaW4gZnJvbSAwcHggdG8gc2Nyb2xsYmFyR3V0dGVyU2l6ZSB0byBhY2NvdW50IGZvciB0aGF0LlxuICAvLyBDaHJvbWUgYnVnOiBodHRwczovL2lzc3Vlcy5jaHJvbWl1bS5vcmcvaXNzdWVzLzQwMDY0ODc5XG4gIHJldHVybiBgbWF4KFxuICAgICR7c2Nyb2xsYmFyR3V0dGVyU2l6ZX1weCxcbiAgICBjYWxjKCR7dGhlbWUuc3BhY2luZy54bH0gLSAke3Njcm9sbGJhckd1dHRlclNpemV9cHgpXG4gIClgXG59XG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyUHJvcHMge1xuICBpc0NvbGxhcHNlZDogYm9vbGVhblxuICBhZGp1c3RUb3A6IGJvb2xlYW5cbiAgc2lkZWJhcldpZHRoOiBzdHJpbmdcbiAgd2luZG93SW5uZXJXaWR0aDogbnVtYmVyXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyID0gc3R5bGVkLnNlY3Rpb248U3R5bGVkU2lkZWJhclByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ29sbGFwc2VkLCBhZGp1c3RUb3AsIHNpZGViYXJXaWR0aCwgd2luZG93SW5uZXJXaWR0aCB9KSA9PiB7XG4gICAgY29uc3QgbWluV2lkdGggPSBpc0NvbGxhcHNlZCA/IDAgOiBNYXRoLm1pbigyMDAsIHdpbmRvd0lubmVyV2lkdGgpXG4gICAgY29uc3QgbWF4V2lkdGggPSBpc0NvbGxhcHNlZCA/IDAgOiBNYXRoLm1pbig2MDAsIHdpbmRvd0lubmVyV2lkdGggKiAwLjkpXG5cbiAgICByZXR1cm4ge1xuICAgICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICAgIC8vIE51ZGdlIHRoZSBzaWRlYmFyIGJ5IDJweCBzbyB0aGUgaGVhZGVyIGRlY29yYXRpb24gZG9lc24ndCBnbyBiZWxvdyBpdFxuICAgICAgdG9wOiBhZGp1c3RUb3AgPyB0aGVtZS5zaXplcy5oZWFkZXJEZWNvcmF0aW9uSGVpZ2h0IDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuYmdDb2xvcixcbiAgICAgIC8vIFNpbmNlIHRoZSBzaWRlYmFyIGNhbiBoYXZlIGEgZGlmZmVyZW50IHRoZW1lICgrIGJhY2tncm91bmQpXG4gICAgICAvLyB3ZSBuZWVkIHRvIGV4cGxpY2l0bHkgc2V0IHRoZSBmb250IGNvbG9yIGFuZCBjb2xvciBzY2hlbWVcbiAgICAgIC8vIGhlcmUgYWdhaW4gc28gdGhhdCBpdCBpcyBpbmhlcml0ZWQgY29ycmVjdGx5IGJ5IGFsbCBzaWRlYmFyIGVsZW1lbnRzOlxuICAgICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgIGNvbG9yU2NoZW1lOiBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSkgPyBcImxpZ2h0XCIgOiBcImRhcmtcIixcbiAgICAgIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyICsgMSxcblxuICAgICAgbWluV2lkdGgsXG4gICAgICBtYXhXaWR0aCxcbiAgICAgIHRyYW5zZm9ybTogaXNDb2xsYXBzZWQgPyBgdHJhbnNsYXRlWCgtJHtzaWRlYmFyV2lkdGh9cHgpYCA6IFwibm9uZVwiLFxuICAgICAgdHJhbnNpdGlvbjogXCJ0cmFuc2Zvcm0gMzAwbXMsIG1pbi13aWR0aCAzMDBtcywgbWF4LXdpZHRoIDMwMG1zXCIsXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICAgICAgYm94U2hhZG93OiBpc0NvbGxhcHNlZFxuICAgICAgICAgID8gXCItMnJlbSAwIDJyZW0gMnJlbSB0cmFuc3BhcmVudFwiXG4gICAgICAgICAgOiB0aGVtZS5zaGFkb3dzLnNpZGViYXIsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIGRpc3BsYXk6IGlzQ29sbGFwc2VkID8gXCJub25lXCIgOiBcImluaXRpYWxcIixcbiAgICAgICAgLy8gc2V0IHRvIGF1dG8sIG90aGVyd2lzZSB0aGUgc2lkZWJhciBkb2VzIG5vdCB0YWtlIHVwIHRoZSB3aG9sZSBwYWdlXG4gICAgICAgIGhlaWdodDogXCJhdXRvICFpbXBvcnRhbnRcIixcbiAgICAgICAgLy8gc2V0IG1heEhlaWdodCB0byBsaXR0bGUgYml0IGxlc3MgdGhhbiAxMDAlLCBvdGhlcndpc2UgdGhlIHNpZGViYXIgbWlnaHQgc3RhcnQgYSBtb3N0bHkgYmxhbmsgcGFnZVxuICAgICAgICBtYXhIZWlnaHQ6IFwiOTklXCIsXG4gICAgICAgIC8vIG9uIENocm9tZSwgc3RoLiBhZGRzIGEgYm94LXNoYWRvdyBpbiBwcmludGluZyBtb2RlIHdoaWNoIGxvb2tzIHdlaXJkXG4gICAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHMge1xuICBoYXNQYWdlTmF2QWJvdmU6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJVc2VyQ29udGVudCA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkU2lkZWJhclVzZXJDb250ZW50UHJvcHM+KCh7IGhhc1BhZ2VOYXZBYm92ZSwgdGhlbWUgfSkgPT4gKHtcbiAgICBwYWRkaW5nVG9wOiBoYXNQYWdlTmF2QWJvdmUgPyB0aGVtZS5zcGFjaW5nLnR3b1hMIDogMCxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zaXplcy5zaWRlYmFyVG9wU3BhY2UsXG4gIH0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhckNvbnRlbnRQcm9wcyB7XG4gIHNjcm9sbGJhckd1dHRlclNpemU6IG51bWJlclxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckNvbnRlbnQgPSBzdHlsZWQuZGl2PFN0eWxlZFNpZGViYXJDb250ZW50UHJvcHM+KFxuICAoeyB0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSB9KSA9PiAoe1xuICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgICB3aWR0aDogXCIxMDAlXCIsXG4gICAgb3ZlcmZsb3c6IFwiYXV0b1wiLFxuICAgIC8qKlxuICAgICAqIEVuc3VyZSB0aGF0IHNwYWNlIGlzIHJlc2VydmVkIGZvciBzY3JvbGxiYXJzLCBldmVuIHdoZW4gdGhleSBhcmUgbm90XG4gICAgICogdmlzaWJsZS4gVGhpcyBpcyBuZWNlc3NhcnkgdG8gcHJldmVudCBsYXlvdXQgc2hpZnRzIHdoZW4gdGhlIHNjcm9sbGJhcnNcbiAgICAgKiBhcHBlYXIgYW5kIGRpc2FwcGVhci5cbiAgICAgKlxuICAgICAqIFdlIHV0aWxpemUgYm90aC1lZGdlcyBzbyB0aGF0IHRoaW5ncyBsb29rIHZpc3VhbGx5IGNlbnRlcmVkIGFuZCBhbGlnbmVkLlxuICAgICAqXG4gICAgICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vc3RyZWFtbGl0L3N0cmVhbWxpdC9pc3N1ZXMvMTAzMTBcbiAgICAgKi9cbiAgICBzY3JvbGxiYXJHdXR0ZXI6IFwic3RhYmxlIGJvdGgtZWRnZXNcIixcbiAgICBwYWRkaW5nTGVmdDogZ2V0U2lkZWJhckhvcml6b250YWxTcGFjaW5nKHRoZW1lLCBzY3JvbGxiYXJHdXR0ZXJTaXplKSxcbiAgICBwYWRkaW5nUmlnaHQ6IGdldFNpZGViYXJIb3Jpem9udGFsU3BhY2luZyh0aGVtZSwgc2Nyb2xsYmFyR3V0dGVyU2l6ZSksXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBSRVNJWkVfSEFORExFX1dJRFRIID0gXCI4cHhcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUmVzaXplSGFuZGxlID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogUkVTSVpFX0hBTkRMRV9XSURUSCxcbiAgaGVpZ2h0OiBcIjEwMCVcIixcbiAgY3Vyc29yOiBcImNvbC1yZXNpemVcIixcbiAgekluZGV4OiB0aGVtZS56SW5kaWNlcy5zaWRlYmFyTW9iaWxlLFxuICBiYWNrZ3JvdW5kSW1hZ2U6IHRoZW1lLnNob3dTaWRlYmFyQm9yZGVyXG4gICAgPyBgbGluZWFyLWdyYWRpZW50KHRvIHJpZ2h0LCB0cmFuc3BhcmVudCAyMCUsICR7dGhlbWUuY29sb3JzLmJvcmRlckNvbG9yfSAyOCUsIHRyYW5zcGFyZW50IDM2JSlgXG4gICAgOiBcIm5vbmVcIixcblxuICBcIiY6aG92ZXJcIjoge1xuICAgIGJhY2tncm91bmRJbWFnZTogYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgdHJhbnNwYXJlbnQgMjAlLCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn0gMjglLCB0cmFuc3BhcmVudCA0NCUpYCxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckhlYWRlckNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcInNwYWNlLWJldHdlZW5cIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBoZWlnaHQ6IHRoZW1lLnNpemVzLmhlYWRlckhlaWdodCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkTG9nb0xpbmsgPSBzdHlsZWQuYSh7XG4gIFwiJjpob3ZlclwiOiB7XG4gICAgb3BhY2l0eTogXCIwLjdcIixcbiAgfSxcbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvQnV0dG9uID0gc3R5bGVkLmJ1dHRvbih7XG4gIC8vIFJlc2V0IGJ1dHRvbiBzdHlsZXNcbiAgYmFja2dyb3VuZDogXCJub25lXCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIHBhZGRpbmc6IDAsXG4gIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gIFwiJjpob3ZlclwiOiB7XG4gICAgb3BhY2l0eTogXCIwLjdcIixcbiAgfSxcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRMb2dvUHJvcHMge1xuICBzaXplOiBzdHJpbmdcbiAgc2lkZWJhcldpZHRoPzogc3RyaW5nXG59XG5cbmZ1bmN0aW9uIHRyYW5zbGF0ZUxvZ29IZWlnaHQodGhlbWU6IEVtb3Rpb25UaGVtZSwgc2l6ZTogc3RyaW5nKTogc3RyaW5nIHtcbiAgaWYgKHNpemUgPT09IFwic21hbGxcIikge1xuICAgIHJldHVybiB0aGVtZS5zaXplcy5zbWFsbExvZ29IZWlnaHRcbiAgfSBlbHNlIGlmIChzaXplID09PSBcImxhcmdlXCIpIHtcbiAgICByZXR1cm4gdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0XG4gIH1cbiAgLy8gRGVmYXVsdCBsb2dvIHNpemVcbiAgcmV0dXJuIHRoZW1lLnNpemVzLmRlZmF1bHRMb2dvSGVpZ2h0XG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRMb2dvID0gc3R5bGVkLmltZzxTdHlsZWRMb2dvUHJvcHM+KCh7IHRoZW1lLCBzaXplIH0pID0+ICh7XG4gIGhlaWdodDogdHJhbnNsYXRlTG9nb0hlaWdodCh0aGVtZSwgc2l6ZSksXG4gIC8vIEV4dHJhIG1hcmdpbiB0byBhbGlnbiBzbWFsbCBsb2dvIHdpdGggc2lkZWJhciBjb2xsYXBzZSBhcnJvd1xuICBtYXJnaW5Ub3A6IHNpemUgPT0gXCJzbWFsbFwiID8gdGhlbWUuc3BhY2luZy54cyA6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIG1hcmdpbkJvdHRvbTogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmhlYWRlcixcbiAgb2JqZWN0Rml0OiBcImNvbnRhaW5cIixcbiAgb2JqZWN0UG9zaXRpb246IFwibGVmdFwiLFxuICB2ZXJ0aWNhbEFsaWduOiBcIm1pZGRsZVwiLFxuICBtYXhXaWR0aDogYDEwMCVgLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRJY29uTG9nbyA9IHN0eWxlZC5kaXY8U3R5bGVkTG9nb1Byb3BzPihcbiAgKHsgdGhlbWUsIHNpemUgfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImZsZXgtc3RhcnRcIixcbiAgICBoZWlnaHQ6IHRyYW5zbGF0ZUxvZ29IZWlnaHQodGhlbWUsIHNpemUpLFxuICAgIG1hcmdpblRvcDogc2l6ZSA9PSBcInNtYWxsXCIgPyB0aGVtZS5zcGFjaW5nLnhzIDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBtYXJnaW5Cb3R0b206IHNpemUgPT0gXCJzbWFsbFwiID8gdGhlbWUuc3BhY2luZy54cyA6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHpJbmRleDogdGhlbWUuekluZGljZXMuaGVhZGVyLFxuICAgIGZvbnRTaXplOiB0cmFuc2xhdGVMb2dvSGVpZ2h0KHRoZW1lLCBzaXplKSxcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5ub25lLFxuICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuYm9keVRleHQsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROb0xvZ29TcGFjZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGhlaWdodDogdGhlbWUuc2l6ZXMubGFyZ2VMb2dvSGVpZ2h0LFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWRDb2xsYXBzZVNpZGViYXJCdXR0b25Qcm9wcyB7XG4gIHNob3dTaWRlYmFyQ29sbGFwc2U6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZENvbGxhcHNlU2lkZWJhckJ1dHRvbiA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQ29sbGFwc2VTaWRlYmFyQnV0dG9uUHJvcHM+KFxuICAgICh7IHNob3dTaWRlYmFyQ29sbGFwc2UsIHRoZW1lIH0pID0+IHtcbiAgICAgIHJldHVybiB7XG4gICAgICAgIGRpc3BsYXk6IFwiaW5saW5lXCIsXG4gICAgICAgIHZpc2liaWxpdHk6IHNob3dTaWRlYmFyQ29sbGFwc2UgPyBcInZpc2libGVcIiA6IFwiaGlkZGVuXCIsXG4gICAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgICAgIHRyYW5zaXRpb246IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICB0cmFuc2l0aW9uRGVsYXk6IFwibGVmdCAzMDBtc1wiLFxuICAgICAgICBjb2xvcjogaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG4gICAgICAgICAgPyB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjBcbiAgICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICAgICAgbGluZUhlaWdodDogXCIwXCIsXG5cbiAgICAgICAgW2BAbWVkaWEgcHJpbnRgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBoaWRlIHRoZSBjb2xsYXBzZSBidXR0b24gb24gcHJpbnQ6XG4gICAgICAgICAgdmlzaWJpbGl0eTogXCJoaWRkZW5cIixcbiAgICAgICAgfSxcblxuICAgICAgICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLnNtfSlgXToge1xuICAgICAgICAgIC8vIEFsd2F5cyBzaG93IHRoZSBjb2xsYXBzZSBidXR0b24gb24gc21hbGwgc2NyZWVuczpcbiAgICAgICAgICB2aXNpYmlsaXR5OiBcInZpc2libGVcIixcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
}), StyledLogoButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "eczjsme4"
} : {
  target: "eczjsme4",
  label: "StyledLogoButton"
})(process.env.NODE_ENV === "production" ? {
  name: "l7ug5t",
  styles: "background:none;border:none;padding:0;cursor:pointer;&:hover{opacity:0.7;}"
} : {
  name: "l7ug5t",
  styles: "background:none;border:none;padding:0;cursor:pointer;&:hover{opacity:0.7;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
function translateLogoHeight(CA, gA) {
  return gA === "small" ? CA.sizes.smallLogoHeight : gA === "large" ? CA.sizes.largeLogoHeight : CA.sizes.defaultLogoHeight;
}
const StyledLogo = /* @__PURE__ */ createStyled("img", process.env.NODE_ENV === "production" ? {
  target: "eczjsme3"
} : {
  target: "eczjsme3",
  label: "StyledLogo"
})(({
  theme: CA,
  size: gA
}) => ({
  height: translateLogoHeight(CA, gA),
  // Extra margin to align small logo with sidebar collapse arrow
  marginTop: gA == "small" ? CA.spacing.xs : CA.spacing.twoXS,
  marginBottom: gA == "small" ? CA.spacing.xs : CA.spacing.twoXS,
  marginLeft: CA.spacing.none,
  zIndex: CA.zIndices.header,
  objectFit: "contain",
  objectPosition: "left",
  verticalAlign: "middle",
  maxWidth: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconLogo = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme2"
} : {
  target: "eczjsme2",
  label: "StyledIconLogo"
})(({
  theme: CA,
  size: gA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  height: translateLogoHeight(CA, gA),
  marginTop: gA == "small" ? CA.spacing.xs : CA.spacing.twoXS,
  marginBottom: gA == "small" ? CA.spacing.xs : CA.spacing.twoXS,
  marginLeft: CA.spacing.none,
  zIndex: CA.zIndices.header,
  fontSize: translateLogoHeight(CA, gA),
  lineHeight: CA.lineHeights.none,
  color: CA.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNoLogoSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme1"
} : {
  target: "eczjsme1",
  label: "StyledNoLogoSpacer"
})(({
  theme: CA
}) => ({
  height: CA.sizes.largeLogoHeight
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCollapseSidebarButton = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "eczjsme0"
} : {
  target: "eczjsme0",
  label: "StyledCollapseSidebarButton"
})(({
  showSidebarCollapse: CA,
  theme: gA
}) => ({
  display: "inline",
  visibility: CA ? "visible" : "hidden",
  marginLeft: gA.spacing.sm,
  transition: "left 300ms",
  transitionDelay: "left 300ms",
  color: hasLightBackgroundColor(gA) ? gA.colors.fadedText60 : gA.colors.bodyText,
  lineHeight: "0",
  "@media print": {
    // Always hide the collapse button on print:
    visibility: "hidden"
  },
  [`@media (max-width: ${gA.breakpoints.sm})`]: {
    // Always show the collapse button on small screens:
    visibility: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), LOG$7 = loglevelExports.getLogger("LogoComponent"), LOGO_SIZE_TO_ICON_SIZE = {
  small: "lg",
  // 1.25rem
  medium: "xl",
  // 1.5rem
  large: "twoXL"
  // 1.8rem
}, LogoComponent = ({
  appLogo: CA,
  endpoints: gA,
  collapsed: AA = !1,
  componentName: IA = "Logo",
  dataTestId: BA = "stLogo"
}) => {
  const {
    resourceCrossOriginMode: QA
  } = useContext(LibConfigContext), {
    appPages: EA,
    onPageChange: iA,
    currentPageScriptHash: oA
  } = useContext(NavigationContext), cA = useMemo$1(() => EA.find((rA) => rA.isDefault), [EA]), tA = EA.length > 1, eA = cA?.pageScriptHash === oA, aA = useCallback(() => {
    cA?.pageScriptHash && !eA && iA(cA.pageScriptHash);
  }, [cA, iA, eA]);
  if (CA = useStliteResolvedLogo(CA), !CA)
    return null;
  const GA = (rA) => {
    LOG$7.error(`Client Error: ${IA} source error - ${rA}`), gA.sendClientErrorToHost(IA, "Logo source failed to load", "onerror triggered", rA);
  }, lA = AA && CA.iconImage ? CA.iconImage : CA.image, nA = AA && CA.iconImage ? CA.iconImageType : CA.imageType, DA = gA.buildMediaURL(lA), hA = getCrossOriginAttribute(QA, lA), wA = nA === Logo.ImageType.ICON || nA === Logo.ImageType.EMOJI, sA = LOGO_SIZE_TO_ICON_SIZE[CA.size] || "xl", NA = wA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconLogo, { size: CA.size, className: "stLogo", "data-testid": BA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: lA, size: sA }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogo,
    {
      src: DA,
      size: CA.size,
      alt: "Logo",
      className: "stLogo",
      "data-testid": BA,
      onError: (rA) => GA(DA),
      crossOrigin: hA
    }
  );
  return CA.link ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledLogoLink,
    {
      href: CA.link,
      target: "_blank",
      rel: "noreferrer",
      "data-testid": "stLogoLink",
      "aria-label": wA ? "App Logo" : void 0,
      children: NA
    }
  ) : tA && cA && !eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLogoButton, { onClick: aA, "data-testid": "stLogoLink", "aria-label": "Navigate to home page", children: NA }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: NA });
};
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA) ({}).hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$2.apply(null, arguments);
}
function _typeof$1(CA) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof$1(CA);
}
function toPrimitive$1(CA, gA) {
  if (_typeof$1(CA) != "object" || !CA) return CA;
  var AA = CA[Symbol.toPrimitive];
  if (AA !== void 0) {
    var IA = AA.call(CA, gA);
    if (_typeof$1(IA) != "object") return IA;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (gA === "string" ? String : Number)(CA);
}
function toPropertyKey$1(CA) {
  var gA = toPrimitive$1(CA, "string");
  return _typeof$1(gA) == "symbol" ? gA : gA + "";
}
function _defineProperty$2(CA, gA, AA) {
  return (gA = toPropertyKey$1(gA)) in CA ? Object.defineProperty(CA, gA, {
    value: AA,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : CA[gA] = AA, CA;
}
function ownKeys$2(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread2$1(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$2(Object(AA), !0).forEach(function(IA) {
      _defineProperty$2(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$2(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _arrayWithHoles(CA) {
  if (Array.isArray(CA)) return CA;
}
function _iterableToArrayLimit(CA, gA) {
  var AA = CA == null ? null : typeof Symbol < "u" && CA[Symbol.iterator] || CA["@@iterator"];
  if (AA != null) {
    var IA, BA, QA, EA, iA = [], oA = !0, cA = !1;
    try {
      if (QA = (AA = AA.call(CA)).next, gA !== 0) for (; !(oA = (IA = QA.call(AA)).done) && (iA.push(IA.value), iA.length !== gA); oA = !0) ;
    } catch (tA) {
      cA = !0, BA = tA;
    } finally {
      try {
        if (!oA && AA.return != null && (EA = AA.return(), Object(EA) !== EA)) return;
      } finally {
        if (cA) throw BA;
      }
    }
    return iA;
  }
}
function _arrayLikeToArray(CA, gA) {
  (gA == null || gA > CA.length) && (gA = CA.length);
  for (var AA = 0, IA = Array(gA); AA < gA; AA++) IA[AA] = CA[AA];
  return IA;
}
function _unsupportedIterableToArray(CA, gA) {
  if (CA) {
    if (typeof CA == "string") return _arrayLikeToArray(CA, gA);
    var AA = {}.toString.call(CA).slice(8, -1);
    return AA === "Object" && CA.constructor && (AA = CA.constructor.name), AA === "Map" || AA === "Set" ? Array.from(CA) : AA === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(AA) ? _arrayLikeToArray(CA, gA) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _slicedToArray$1(CA, gA) {
  return _arrayWithHoles(CA) || _iterableToArrayLimit(CA, gA) || _unsupportedIterableToArray(CA, gA) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose$1(CA, gA) {
  if (CA == null) return {};
  var AA = {};
  for (var IA in CA) if ({}.hasOwnProperty.call(CA, IA)) {
    if (gA.indexOf(IA) !== -1) continue;
    AA[IA] = CA[IA];
  }
  return AA;
}
function _objectWithoutProperties$1(CA, gA) {
  if (CA == null) return {};
  var AA, IA, BA = _objectWithoutPropertiesLoose$1(CA, gA);
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (IA = 0; IA < QA.length; IA++) AA = QA[IA], gA.indexOf(AA) === -1 && {}.propertyIsEnumerable.call(CA, AA) && (BA[AA] = CA[AA]);
  }
  return BA;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA) ({}).hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends$1.apply(null, arguments);
}
var REACT_ELEMENT_TYPE_18 = /* @__PURE__ */ Symbol.for("react.element"), REACT_ELEMENT_TYPE_19 = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
function isFragment(CA) {
  return (
    // Base object type
    CA && _typeof$a(CA) === "object" && // React Element type
    (CA.$$typeof === REACT_ELEMENT_TYPE_18 || CA.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    CA.type === REACT_FRAGMENT_TYPE
  );
}
function toArray(CA) {
  var gA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, AA = [];
  return React__default.Children.forEach(CA, function(IA) {
    IA == null && !gA.keepEmpty || (Array.isArray(IA) ? AA = AA.concat(toArray(IA)) : isFragment(IA) && IA.props ? AA = AA.concat(toArray(IA.props.children, gA)) : AA.push(IA));
  }), AA;
}
var preWarningFns = [];
function warning(CA, gA) {
  if (process.env.NODE_ENV !== "production" && console !== void 0) {
    var AA = preWarningFns.reduce(function(IA, BA) {
      return BA(IA ?? "", "warning");
    }, gA);
    AA && console.error("Warning: ".concat(AA));
  }
}
function _typeof(CA) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(gA) {
    return typeof gA;
  } : function(gA) {
    return gA && typeof Symbol == "function" && gA.constructor === Symbol && gA !== Symbol.prototype ? "symbol" : typeof gA;
  }, _typeof(CA);
}
function toPrimitive(CA, gA) {
  if (_typeof(CA) != "object" || !CA) return CA;
  var AA = CA[Symbol.toPrimitive];
  if (AA !== void 0) {
    var IA = AA.call(CA, gA);
    if (_typeof(IA) != "object") return IA;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (gA === "string" ? String : Number)(CA);
}
function toPropertyKey(CA) {
  var gA = toPrimitive(CA, "string");
  return _typeof(gA) == "symbol" ? gA : gA + "";
}
function _defineProperty$1(CA, gA, AA) {
  return (gA = toPropertyKey(gA)) in CA ? Object.defineProperty(CA, gA, {
    value: AA,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : CA[gA] = AA, CA;
}
function ownKeys$1(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread2(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys$1(Object(AA), !0).forEach(function(IA) {
      _defineProperty$1(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys$1(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function isDOM(CA) {
  return CA instanceof HTMLElement || CA instanceof SVGElement;
}
function getDOM(CA) {
  return CA && _typeof$a(CA) === "object" && isDOM(CA.nativeElement) ? CA.nativeElement : isDOM(CA) ? CA : null;
}
function findDOMNode(CA) {
  var gA = getDOM(CA);
  if (gA)
    return gA;
  if (CA instanceof React__default.Component) {
    var AA;
    return (AA = ReactDOM.findDOMNode) === null || AA === void 0 ? void 0 : AA.call(ReactDOM, CA);
  }
  return null;
}
var reactIs = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var CA = /* @__PURE__ */ Symbol.for("react.element"), gA = /* @__PURE__ */ Symbol.for("react.portal"), AA = /* @__PURE__ */ Symbol.for("react.fragment"), IA = /* @__PURE__ */ Symbol.for("react.strict_mode"), BA = /* @__PURE__ */ Symbol.for("react.profiler"), QA = /* @__PURE__ */ Symbol.for("react.provider"), EA = /* @__PURE__ */ Symbol.for("react.context"), iA = /* @__PURE__ */ Symbol.for("react.server_context"), oA = /* @__PURE__ */ Symbol.for("react.forward_ref"), cA = /* @__PURE__ */ Symbol.for("react.suspense"), tA = /* @__PURE__ */ Symbol.for("react.suspense_list"), eA = /* @__PURE__ */ Symbol.for("react.memo"), aA = /* @__PURE__ */ Symbol.for("react.lazy"), GA = /* @__PURE__ */ Symbol.for("react.offscreen"), lA;
  lA = /* @__PURE__ */ Symbol.for("react.module.reference");
  function nA(DA) {
    if (typeof DA == "object" && DA !== null) {
      var hA = DA.$$typeof;
      switch (hA) {
        case CA:
          switch (DA = DA.type, DA) {
            case AA:
            case BA:
            case IA:
            case cA:
            case tA:
              return DA;
            default:
              switch (DA = DA && DA.$$typeof, DA) {
                case iA:
                case EA:
                case oA:
                case aA:
                case eA:
                case QA:
                  return DA;
                default:
                  return hA;
              }
          }
        case gA:
          return hA;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = EA, reactIs_production_min.ContextProvider = QA, reactIs_production_min.Element = CA, reactIs_production_min.ForwardRef = oA, reactIs_production_min.Fragment = AA, reactIs_production_min.Lazy = aA, reactIs_production_min.Memo = eA, reactIs_production_min.Portal = gA, reactIs_production_min.Profiler = BA, reactIs_production_min.StrictMode = IA, reactIs_production_min.Suspense = cA, reactIs_production_min.SuspenseList = tA, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(DA) {
    return nA(DA) === EA;
  }, reactIs_production_min.isContextProvider = function(DA) {
    return nA(DA) === QA;
  }, reactIs_production_min.isElement = function(DA) {
    return typeof DA == "object" && DA !== null && DA.$$typeof === CA;
  }, reactIs_production_min.isForwardRef = function(DA) {
    return nA(DA) === oA;
  }, reactIs_production_min.isFragment = function(DA) {
    return nA(DA) === AA;
  }, reactIs_production_min.isLazy = function(DA) {
    return nA(DA) === aA;
  }, reactIs_production_min.isMemo = function(DA) {
    return nA(DA) === eA;
  }, reactIs_production_min.isPortal = function(DA) {
    return nA(DA) === gA;
  }, reactIs_production_min.isProfiler = function(DA) {
    return nA(DA) === BA;
  }, reactIs_production_min.isStrictMode = function(DA) {
    return nA(DA) === IA;
  }, reactIs_production_min.isSuspense = function(DA) {
    return nA(DA) === cA;
  }, reactIs_production_min.isSuspenseList = function(DA) {
    return nA(DA) === tA;
  }, reactIs_production_min.isValidElementType = function(DA) {
    return typeof DA == "string" || typeof DA == "function" || DA === AA || DA === BA || DA === IA || DA === cA || DA === tA || DA === GA || typeof DA == "object" && DA !== null && (DA.$$typeof === aA || DA.$$typeof === eA || DA.$$typeof === QA || DA.$$typeof === EA || DA.$$typeof === oA || DA.$$typeof === lA || DA.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = nA, reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    var CA = /* @__PURE__ */ Symbol.for("react.element"), gA = /* @__PURE__ */ Symbol.for("react.portal"), AA = /* @__PURE__ */ Symbol.for("react.fragment"), IA = /* @__PURE__ */ Symbol.for("react.strict_mode"), BA = /* @__PURE__ */ Symbol.for("react.profiler"), QA = /* @__PURE__ */ Symbol.for("react.provider"), EA = /* @__PURE__ */ Symbol.for("react.context"), iA = /* @__PURE__ */ Symbol.for("react.server_context"), oA = /* @__PURE__ */ Symbol.for("react.forward_ref"), cA = /* @__PURE__ */ Symbol.for("react.suspense"), tA = /* @__PURE__ */ Symbol.for("react.suspense_list"), eA = /* @__PURE__ */ Symbol.for("react.memo"), aA = /* @__PURE__ */ Symbol.for("react.lazy"), GA = /* @__PURE__ */ Symbol.for("react.offscreen"), lA = !1, nA = !1, DA = !1, hA = !1, wA = !1, sA;
    sA = /* @__PURE__ */ Symbol.for("react.module.reference");
    function NA($A) {
      return !!(typeof $A == "string" || typeof $A == "function" || $A === AA || $A === BA || wA || $A === IA || $A === cA || $A === tA || hA || $A === GA || lA || nA || DA || typeof $A == "object" && $A !== null && ($A.$$typeof === aA || $A.$$typeof === eA || $A.$$typeof === QA || $A.$$typeof === EA || $A.$$typeof === oA || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      $A.$$typeof === sA || $A.getModuleId !== void 0));
    }
    function rA($A) {
      if (typeof $A == "object" && $A !== null) {
        var YI = $A.$$typeof;
        switch (YI) {
          case CA:
            var FI = $A.type;
            switch (FI) {
              case AA:
              case BA:
              case IA:
              case cA:
              case tA:
                return FI;
              default:
                var nI = FI && FI.$$typeof;
                switch (nI) {
                  case iA:
                  case EA:
                  case oA:
                  case aA:
                  case eA:
                  case QA:
                    return nI;
                  default:
                    return YI;
                }
            }
          case gA:
            return YI;
        }
      }
    }
    var yA = EA, bA = QA, RA = CA, FA = oA, dA = AA, kA = aA, pA = eA, YA = gA, SA = BA, JA = IA, UA = cA, fA = tA, zA = !1, _A = !1;
    function uA($A) {
      return zA || (zA = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function HA($A) {
      return _A || (_A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function TA($A) {
      return rA($A) === EA;
    }
    function ZA($A) {
      return rA($A) === QA;
    }
    function AI($A) {
      return typeof $A == "object" && $A !== null && $A.$$typeof === CA;
    }
    function QI($A) {
      return rA($A) === oA;
    }
    function LA($A) {
      return rA($A) === AA;
    }
    function PA($A) {
      return rA($A) === aA;
    }
    function XA($A) {
      return rA($A) === eA;
    }
    function EI($A) {
      return rA($A) === gA;
    }
    function CI($A) {
      return rA($A) === BA;
    }
    function II($A) {
      return rA($A) === IA;
    }
    function vA($A) {
      return rA($A) === cA;
    }
    function wI($A) {
      return rA($A) === tA;
    }
    reactIs_development.ContextConsumer = yA, reactIs_development.ContextProvider = bA, reactIs_development.Element = RA, reactIs_development.ForwardRef = FA, reactIs_development.Fragment = dA, reactIs_development.Lazy = kA, reactIs_development.Memo = pA, reactIs_development.Portal = YA, reactIs_development.Profiler = SA, reactIs_development.StrictMode = JA, reactIs_development.Suspense = UA, reactIs_development.SuspenseList = fA, reactIs_development.isAsyncMode = uA, reactIs_development.isConcurrentMode = HA, reactIs_development.isContextConsumer = TA, reactIs_development.isContextProvider = ZA, reactIs_development.isElement = AI, reactIs_development.isForwardRef = QI, reactIs_development.isFragment = LA, reactIs_development.isLazy = PA, reactIs_development.isMemo = XA, reactIs_development.isPortal = EI, reactIs_development.isProfiler = CI, reactIs_development.isStrictMode = II, reactIs_development.isSuspense = vA, reactIs_development.isSuspenseList = wI, reactIs_development.isValidElementType = NA, reactIs_development.typeOf = rA;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development()), reactIs.exports;
}
var reactIsExports = requireReactIs();
function useMemo(CA, gA, AA) {
  var IA = React.useRef({});
  return (!("value" in IA.current) || AA(IA.current.condition, gA)) && (IA.current.value = CA(), IA.current.condition = gA), IA.current.value;
}
var ReactMajorVersion = Number(version.split(".")[0]), fillRef = function CA(gA, AA) {
  typeof gA == "function" ? gA(AA) : _typeof$a(gA) === "object" && gA && "current" in gA && (gA.current = AA);
}, composeRef = function CA() {
  for (var gA = arguments.length, AA = new Array(gA), IA = 0; IA < gA; IA++)
    AA[IA] = arguments[IA];
  var BA = AA.filter(Boolean);
  return BA.length <= 1 ? BA[0] : function(QA) {
    AA.forEach(function(EA) {
      fillRef(EA, QA);
    });
  };
}, useComposeRef = function CA() {
  for (var gA = arguments.length, AA = new Array(gA), IA = 0; IA < gA; IA++)
    AA[IA] = arguments[IA];
  return useMemo(function() {
    return composeRef.apply(void 0, AA);
  }, AA, function(BA, QA) {
    return BA.length !== QA.length || BA.every(function(EA, iA) {
      return EA !== QA[iA];
    });
  });
}, supportRef = function CA(gA) {
  var AA, IA;
  if (!gA)
    return !1;
  if (isReactElement(gA) && ReactMajorVersion >= 19)
    return !0;
  var BA = reactIsExports.isMemo(gA) ? gA.type.type : gA.type;
  return !(typeof BA == "function" && !((AA = BA.prototype) !== null && AA !== void 0 && AA.render) && BA.$$typeof !== reactIsExports.ForwardRef || typeof gA == "function" && !((IA = gA.prototype) !== null && IA !== void 0 && IA.render) && gA.$$typeof !== reactIsExports.ForwardRef);
};
function isReactElement(CA) {
  return /* @__PURE__ */ isValidElement(CA) && !isFragment(CA);
}
var getNodeRef = function CA(gA) {
  if (gA && isReactElement(gA)) {
    var AA = gA;
    return AA.props.propertyIsEnumerable("ref") ? AA.props.ref : AA.ref;
  }
  return null;
}, CollectionContext = /* @__PURE__ */ React.createContext(null);
function Collection(CA) {
  var gA = CA.children, AA = CA.onBatchResize, IA = React.useRef(0), BA = React.useRef([]), QA = React.useContext(CollectionContext), EA = React.useCallback(function(iA, oA, cA) {
    IA.current += 1;
    var tA = IA.current;
    BA.current.push({
      size: iA,
      element: oA,
      data: cA
    }), Promise.resolve().then(function() {
      tA === IA.current && (AA?.(BA.current), BA.current = []);
    }), QA?.(iA, oA, cA);
  }, [AA, QA]);
  return /* @__PURE__ */ React.createElement(CollectionContext.Provider, {
    value: EA
  }, gA);
}
var MapShim = (function() {
  if (typeof Map < "u")
    return Map;
  function CA(gA, AA) {
    var IA = -1;
    return gA.some(function(BA, QA) {
      return BA[0] === AA ? (IA = QA, !0) : !1;
    }), IA;
  }
  return (
    /** @class */
    (function() {
      function gA() {
        this.__entries__ = [];
      }
      return Object.defineProperty(gA.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), gA.prototype.get = function(AA) {
        var IA = CA(this.__entries__, AA), BA = this.__entries__[IA];
        return BA && BA[1];
      }, gA.prototype.set = function(AA, IA) {
        var BA = CA(this.__entries__, AA);
        ~BA ? this.__entries__[BA][1] = IA : this.__entries__.push([AA, IA]);
      }, gA.prototype.delete = function(AA) {
        var IA = this.__entries__, BA = CA(IA, AA);
        ~BA && IA.splice(BA, 1);
      }, gA.prototype.has = function(AA) {
        return !!~CA(this.__entries__, AA);
      }, gA.prototype.clear = function() {
        this.__entries__.splice(0);
      }, gA.prototype.forEach = function(AA, IA) {
        IA === void 0 && (IA = null);
        for (var BA = 0, QA = this.__entries__; BA < QA.length; BA++) {
          var EA = QA[BA];
          AA.call(IA, EA[1], EA[0]);
        }
      }, gA;
    })()
  );
})(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), requestAnimationFrame$1 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(CA) {
    return setTimeout(function() {
      return CA(Date.now());
    }, 1e3 / 60);
  };
})(), trailingTimeout = 2;
function throttle(CA, gA) {
  var AA = !1, IA = !1, BA = 0;
  function QA() {
    AA && (AA = !1, CA()), IA && iA();
  }
  function EA() {
    requestAnimationFrame$1(QA);
  }
  function iA() {
    var oA = Date.now();
    if (AA) {
      if (oA - BA < trailingTimeout)
        return;
      IA = !0;
    } else
      AA = !0, IA = !1, setTimeout(EA, gA);
    BA = oA;
  }
  return iA;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  (function() {
    function CA() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    return CA.prototype.addObserver = function(gA) {
      ~this.observers_.indexOf(gA) || this.observers_.push(gA), this.connected_ || this.connect_();
    }, CA.prototype.removeObserver = function(gA) {
      var AA = this.observers_, IA = AA.indexOf(gA);
      ~IA && AA.splice(IA, 1), !AA.length && this.connected_ && this.disconnect_();
    }, CA.prototype.refresh = function() {
      var gA = this.updateObservers_();
      gA && this.refresh();
    }, CA.prototype.updateObservers_ = function() {
      var gA = this.observers_.filter(function(AA) {
        return AA.gatherActive(), AA.hasActive();
      });
      return gA.forEach(function(AA) {
        return AA.broadcastActive();
      }), gA.length > 0;
    }, CA.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, CA.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, CA.prototype.onTransitionEnd_ = function(gA) {
      var AA = gA.propertyName, IA = AA === void 0 ? "" : AA, BA = transitionKeys.some(function(QA) {
        return !!~IA.indexOf(QA);
      });
      BA && this.refresh();
    }, CA.getInstance = function() {
      return this.instance_ || (this.instance_ = new CA()), this.instance_;
    }, CA.instance_ = null, CA;
  })()
), defineConfigurable = (function(CA, gA) {
  for (var AA = 0, IA = Object.keys(gA); AA < IA.length; AA++) {
    var BA = IA[AA];
    Object.defineProperty(CA, BA, {
      value: gA[BA],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return CA;
}), getWindowOf = (function(CA) {
  var gA = CA && CA.ownerDocument && CA.ownerDocument.defaultView;
  return gA || global$1;
}), emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(CA) {
  return parseFloat(CA) || 0;
}
function getBordersSize(CA) {
  for (var gA = [], AA = 1; AA < arguments.length; AA++)
    gA[AA - 1] = arguments[AA];
  return gA.reduce(function(IA, BA) {
    var QA = CA["border-" + BA + "-width"];
    return IA + toFloat(QA);
  }, 0);
}
function getPaddings(CA) {
  for (var gA = ["top", "right", "bottom", "left"], AA = {}, IA = 0, BA = gA; IA < BA.length; IA++) {
    var QA = BA[IA], EA = CA["padding-" + QA];
    AA[QA] = toFloat(EA);
  }
  return AA;
}
function getSVGContentRect(CA) {
  var gA = CA.getBBox();
  return createRectInit(0, 0, gA.width, gA.height);
}
function getHTMLElementContentRect(CA) {
  var gA = CA.clientWidth, AA = CA.clientHeight;
  if (!gA && !AA)
    return emptyRect;
  var IA = getWindowOf(CA).getComputedStyle(CA), BA = getPaddings(IA), QA = BA.left + BA.right, EA = BA.top + BA.bottom, iA = toFloat(IA.width), oA = toFloat(IA.height);
  if (IA.boxSizing === "border-box" && (Math.round(iA + QA) !== gA && (iA -= getBordersSize(IA, "left", "right") + QA), Math.round(oA + EA) !== AA && (oA -= getBordersSize(IA, "top", "bottom") + EA)), !isDocumentElement(CA)) {
    var cA = Math.round(iA + QA) - gA, tA = Math.round(oA + EA) - AA;
    Math.abs(cA) !== 1 && (iA -= cA), Math.abs(tA) !== 1 && (oA -= tA);
  }
  return createRectInit(BA.left, BA.top, iA, oA);
}
var isSVGGraphicsElement = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(CA) {
    return CA instanceof getWindowOf(CA).SVGGraphicsElement;
  } : function(CA) {
    return CA instanceof getWindowOf(CA).SVGElement && typeof CA.getBBox == "function";
  };
})();
function isDocumentElement(CA) {
  return CA === getWindowOf(CA).document.documentElement;
}
function getContentRect(CA) {
  return isBrowser ? isSVGGraphicsElement(CA) ? getSVGContentRect(CA) : getHTMLElementContentRect(CA) : emptyRect;
}
function createReadOnlyRect(CA) {
  var gA = CA.x, AA = CA.y, IA = CA.width, BA = CA.height, QA = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, EA = Object.create(QA.prototype);
  return defineConfigurable(EA, {
    x: gA,
    y: AA,
    width: IA,
    height: BA,
    top: AA,
    right: gA + IA,
    bottom: BA + AA,
    left: gA
  }), EA;
}
function createRectInit(CA, gA, AA, IA) {
  return { x: CA, y: gA, width: AA, height: IA };
}
var ResizeObservation = (
  /** @class */
  (function() {
    function CA(gA) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = gA;
    }
    return CA.prototype.isActive = function() {
      var gA = getContentRect(this.target);
      return this.contentRect_ = gA, gA.width !== this.broadcastWidth || gA.height !== this.broadcastHeight;
    }, CA.prototype.broadcastRect = function() {
      var gA = this.contentRect_;
      return this.broadcastWidth = gA.width, this.broadcastHeight = gA.height, gA;
    }, CA;
  })()
), ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ (function() {
    function CA(gA, AA) {
      var IA = createReadOnlyRect(AA);
      defineConfigurable(this, { target: gA, contentRect: IA });
    }
    return CA;
  })()
), ResizeObserverSPI = (
  /** @class */
  (function() {
    function CA(gA, AA, IA) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof gA != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = gA, this.controller_ = AA, this.callbackCtx_ = IA;
    }
    return CA.prototype.observe = function(gA) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(gA instanceof getWindowOf(gA).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var AA = this.observations_;
        AA.has(gA) || (AA.set(gA, new ResizeObservation(gA)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, CA.prototype.unobserve = function(gA) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(gA instanceof getWindowOf(gA).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var AA = this.observations_;
        AA.has(gA) && (AA.delete(gA), AA.size || this.controller_.removeObserver(this));
      }
    }, CA.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, CA.prototype.gatherActive = function() {
      var gA = this;
      this.clearActive(), this.observations_.forEach(function(AA) {
        AA.isActive() && gA.activeObservations_.push(AA);
      });
    }, CA.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var gA = this.callbackCtx_, AA = this.activeObservations_.map(function(IA) {
          return new ResizeObserverEntry(IA.target, IA.broadcastRect());
        });
        this.callback_.call(gA, AA, gA), this.clearActive();
      }
    }, CA.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, CA.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, CA;
  })()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function CA(gA) {
      if (!(this instanceof CA))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var AA = ResizeObserverController.getInstance(), IA = new ResizeObserverSPI(gA, AA, this);
      observers.set(this, IA);
    }
    return CA;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(CA) {
  ResizeObserver$2.prototype[CA] = function() {
    var gA;
    return (gA = observers.get(this))[CA].apply(gA, arguments);
  };
});
var index = (function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
})(), elementListeners = /* @__PURE__ */ new Map();
function onResize(CA) {
  CA.forEach(function(gA) {
    var AA, IA = gA.target;
    (AA = elementListeners.get(IA)) === null || AA === void 0 || AA.forEach(function(BA) {
      return BA(IA);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(CA, gA) {
  elementListeners.has(CA) || (elementListeners.set(CA, /* @__PURE__ */ new Set()), resizeObserver.observe(CA)), elementListeners.get(CA).add(gA);
}
function unobserve(CA, gA) {
  elementListeners.has(CA) && (elementListeners.get(CA).delete(gA), elementListeners.get(CA).size || (resizeObserver.unobserve(CA), elementListeners.delete(CA)));
}
function _classCallCheck(CA, gA) {
  if (!(CA instanceof gA)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(CA, gA) {
  for (var AA = 0; AA < gA.length; AA++) {
    var IA = gA[AA];
    IA.enumerable = IA.enumerable || !1, IA.configurable = !0, "value" in IA && (IA.writable = !0), Object.defineProperty(CA, toPropertyKey(IA.key), IA);
  }
}
function _createClass(CA, gA, AA) {
  return gA && _defineProperties(CA.prototype, gA), Object.defineProperty(CA, "prototype", {
    writable: !1
  }), CA;
}
function _setPrototypeOf(CA, gA) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(AA, IA) {
    return AA.__proto__ = IA, AA;
  }, _setPrototypeOf(CA, gA);
}
function _inherits(CA, gA) {
  if (typeof gA != "function" && gA !== null) throw new TypeError("Super expression must either be null or a function");
  CA.prototype = Object.create(gA && gA.prototype, {
    constructor: {
      value: CA,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(CA, "prototype", {
    writable: !1
  }), gA && _setPrototypeOf(CA, gA);
}
function _getPrototypeOf(CA) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(gA) {
    return gA.__proto__ || Object.getPrototypeOf(gA);
  }, _getPrototypeOf(CA);
}
function _isNativeReflectConstruct() {
  try {
    var CA = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!CA;
  })();
}
function _assertThisInitialized(CA) {
  if (CA === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return CA;
}
function _possibleConstructorReturn(CA, gA) {
  if (gA && (_typeof(gA) == "object" || typeof gA == "function")) return gA;
  if (gA !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(CA);
}
function _createSuper(CA) {
  var gA = _isNativeReflectConstruct();
  return function() {
    var AA, IA = _getPrototypeOf(CA);
    if (gA) {
      var BA = _getPrototypeOf(this).constructor;
      AA = Reflect.construct(IA, arguments, BA);
    } else AA = IA.apply(this, arguments);
    return _possibleConstructorReturn(this, AA);
  };
}
var DomWrapper = /* @__PURE__ */ (function(CA) {
  _inherits(AA, CA);
  var gA = _createSuper(AA);
  function AA() {
    return _classCallCheck(this, AA), gA.apply(this, arguments);
  }
  return _createClass(AA, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), AA;
})(React.Component);
function SingleObserver(CA, gA) {
  var AA = CA.children, IA = CA.disabled, BA = React.useRef(null), QA = React.useRef(null), EA = React.useContext(CollectionContext), iA = typeof AA == "function", oA = iA ? AA(BA) : AA, cA = React.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), tA = !iA && /* @__PURE__ */ React.isValidElement(oA) && supportRef(oA), eA = tA ? getNodeRef(oA) : null, aA = useComposeRef(eA, BA), GA = function() {
    var hA;
    return findDOMNode(BA.current) || // Support `nativeElement` format
    (BA.current && _typeof(BA.current) === "object" ? findDOMNode((hA = BA.current) === null || hA === void 0 ? void 0 : hA.nativeElement) : null) || findDOMNode(QA.current);
  };
  React.useImperativeHandle(gA, function() {
    return GA();
  });
  var lA = React.useRef(CA);
  lA.current = CA;
  var nA = React.useCallback(function(DA) {
    var hA = lA.current, wA = hA.onResize, sA = hA.data, NA = DA.getBoundingClientRect(), rA = NA.width, yA = NA.height, bA = DA.offsetWidth, RA = DA.offsetHeight, FA = Math.floor(rA), dA = Math.floor(yA);
    if (cA.current.width !== FA || cA.current.height !== dA || cA.current.offsetWidth !== bA || cA.current.offsetHeight !== RA) {
      var kA = {
        width: FA,
        height: dA,
        offsetWidth: bA,
        offsetHeight: RA
      };
      cA.current = kA;
      var pA = bA === Math.round(rA) ? rA : bA, YA = RA === Math.round(yA) ? yA : RA, SA = _objectSpread2(_objectSpread2({}, kA), {}, {
        offsetWidth: pA,
        offsetHeight: YA
      });
      EA?.(SA, DA, sA), wA && Promise.resolve().then(function() {
        wA(SA, DA);
      });
    }
  }, []);
  return React.useEffect(function() {
    var DA = GA();
    return DA && !IA && observe(DA, nA), function() {
      return unobserve(DA, nA);
    };
  }, [BA.current, IA]), /* @__PURE__ */ React.createElement(DomWrapper, {
    ref: QA
  }, tA ? /* @__PURE__ */ React.cloneElement(oA, {
    ref: aA
  }) : oA);
}
var RefSingleObserver = /* @__PURE__ */ React.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(CA, gA) {
  var AA = CA.children, IA = typeof AA == "function" ? [AA] : toArray(AA);
  return process.env.NODE_ENV !== "production" && (IA.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : IA.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), IA.map(function(BA, QA) {
    var EA = BA?.key || "".concat(INTERNAL_PREFIX_KEY, "-").concat(QA);
    return /* @__PURE__ */ React.createElement(RefSingleObserver, _extends$1({}, CA, {
      key: EA,
      ref: QA === 0 ? gA : void 0
    }), BA);
  });
}
var RefResizeObserver = /* @__PURE__ */ React.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function canUseDom() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React.useLayoutEffect : React.useEffect, useLayoutEffect = function CA(gA, AA) {
  var IA = React.useRef(!0);
  useInternalLayoutEffect(function() {
    return gA(IA.current);
  }, AA), useInternalLayoutEffect(function() {
    return IA.current = !1, function() {
      IA.current = !0;
    };
  }, []);
}, _excluded$3 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], UNDEFINED = void 0;
function InternalItem(CA, gA) {
  var AA = CA.prefixCls, IA = CA.invalidate, BA = CA.item, QA = CA.renderItem, EA = CA.responsive, iA = CA.responsiveDisabled, oA = CA.registerSize, cA = CA.itemKey, tA = CA.className, eA = CA.style, aA = CA.children, GA = CA.display, lA = CA.order, nA = CA.component, DA = nA === void 0 ? "div" : nA, hA = _objectWithoutProperties$1(CA, _excluded$3), wA = EA && !GA;
  function sA(RA) {
    oA(cA, RA);
  }
  React.useEffect(function() {
    return function() {
      sA(null);
    };
  }, []);
  var NA = QA && BA !== UNDEFINED ? QA(BA, {
    index: lA
  }) : aA, rA;
  IA || (rA = {
    opacity: wA ? 0 : 1,
    height: wA ? 0 : UNDEFINED,
    overflowY: wA ? "hidden" : UNDEFINED,
    order: EA ? lA : UNDEFINED,
    pointerEvents: wA ? "none" : UNDEFINED,
    position: wA ? "absolute" : UNDEFINED
  });
  var yA = {};
  wA && (yA["aria-hidden"] = !0);
  var bA = /* @__PURE__ */ React.createElement(DA, _extends$2({
    className: classNames(!IA && AA, tA),
    style: _objectSpread2$1(_objectSpread2$1({}, rA), eA)
  }, yA, hA, {
    ref: gA
  }), NA);
  return EA && (bA = /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: function(FA) {
      var dA = FA.offsetWidth;
      sA(dA);
    },
    disabled: iA
  }, bA)), bA;
}
var Item = /* @__PURE__ */ React.forwardRef(InternalItem);
Item.displayName = "Item";
function useEvent(CA) {
  var gA = React.useRef();
  gA.current = CA;
  var AA = React.useCallback(function() {
    for (var IA, BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return (IA = gA.current) === null || IA === void 0 ? void 0 : IA.call.apply(IA, [gA].concat(QA));
  }, []);
  return AA;
}
var raf = function CA(gA) {
  return +setTimeout(gA, 16);
}, caf = function CA(gA) {
  return clearTimeout(gA);
};
typeof window < "u" && "requestAnimationFrame" in window && (raf = function(gA) {
  return window.requestAnimationFrame(gA);
}, caf = function(gA) {
  return window.cancelAnimationFrame(gA);
});
var rafUUID = 0, rafIds = /* @__PURE__ */ new Map();
function cleanup(CA) {
  rafIds.delete(CA);
}
var wrapperRaf = function CA(gA) {
  var AA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var IA = rafUUID;
  function BA(QA) {
    if (QA === 0)
      cleanup(IA), gA();
    else {
      var EA = raf(function() {
        BA(QA - 1);
      });
      rafIds.set(IA, EA);
    }
  }
  return BA(AA), IA;
};
wrapperRaf.cancel = function(CA) {
  var gA = rafIds.get(CA);
  return cleanup(CA), caf(gA);
};
process.env.NODE_ENV !== "production" && (wrapperRaf.ids = function() {
  return rafIds;
});
function channelUpdate(CA) {
  if (typeof MessageChannel > "u")
    wrapperRaf(CA);
  else {
    var gA = new MessageChannel();
    gA.port1.onmessage = function() {
      return CA();
    }, gA.port2.postMessage(void 0);
  }
}
function useBatcher() {
  var CA = React.useRef(null), gA = function(IA) {
    CA.current || (CA.current = [], channelUpdate(function() {
      unstable_batchedUpdates(function() {
        CA.current.forEach(function(BA) {
          BA();
        }), CA.current = null;
      });
    })), CA.current.push(IA);
  };
  return gA;
}
function useEffectState(CA, gA) {
  var AA = React.useState(gA), IA = _slicedToArray$1(AA, 2), BA = IA[0], QA = IA[1], EA = useEvent(function(iA) {
    CA(function() {
      QA(iA);
    });
  });
  return [BA, EA];
}
var OverflowContext = /* @__PURE__ */ React__default.createContext(null), _excluded$2 = ["component"], _excluded2$1 = ["className"], _excluded3 = ["className"], InternalRawItem = function CA(gA, AA) {
  var IA = React.useContext(OverflowContext);
  if (!IA) {
    var BA = gA.component, QA = BA === void 0 ? "div" : BA, EA = _objectWithoutProperties$1(gA, _excluded$2);
    return /* @__PURE__ */ React.createElement(QA, _extends$2({}, EA, {
      ref: AA
    }));
  }
  var iA = IA.className, oA = _objectWithoutProperties$1(IA, _excluded2$1), cA = gA.className, tA = _objectWithoutProperties$1(gA, _excluded3);
  return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React.createElement(Item, _extends$2({
    ref: AA,
    className: classNames(iA, cA)
  }, oA, tA)));
}, RawItem = /* @__PURE__ */ React.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var _excluded$1 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "prefix", "suffix", "component", "itemComponent", "onVisibleChange"], RESPONSIVE = "responsive", INVALIDATE = "invalidate";
function defaultRenderRest(CA) {
  return "+ ".concat(CA.length, " ...");
}
function Overflow(CA, gA) {
  var AA = CA.prefixCls, IA = AA === void 0 ? "rc-overflow" : AA, BA = CA.data, QA = BA === void 0 ? [] : BA, EA = CA.renderItem, iA = CA.renderRawItem, oA = CA.itemKey, cA = CA.itemWidth, tA = cA === void 0 ? 10 : cA, eA = CA.ssr, aA = CA.style, GA = CA.className, lA = CA.maxCount, nA = CA.renderRest, DA = CA.renderRawRest, hA = CA.prefix, wA = CA.suffix, sA = CA.component, NA = sA === void 0 ? "div" : sA, rA = CA.itemComponent, yA = CA.onVisibleChange, bA = _objectWithoutProperties$1(CA, _excluded$1), RA = eA === "full", FA = useBatcher(), dA = useEffectState(FA, null), kA = _slicedToArray$1(dA, 2), pA = kA[0], YA = kA[1], SA = pA || 0, JA = useEffectState(FA, /* @__PURE__ */ new Map()), UA = _slicedToArray$1(JA, 2), fA = UA[0], zA = UA[1], _A = useEffectState(FA, 0), uA = _slicedToArray$1(_A, 2), HA = uA[0], TA = uA[1], ZA = useEffectState(FA, 0), AI = _slicedToArray$1(ZA, 2), QI = AI[0], LA = AI[1], PA = useEffectState(FA, 0), XA = _slicedToArray$1(PA, 2), EI = XA[0], CI = XA[1], II = useEffectState(FA, 0), vA = _slicedToArray$1(II, 2), wI = vA[0], $A = vA[1], YI = useState(null), FI = _slicedToArray$1(YI, 2), nI = FI[0], uI = FI[1], hI = useState(null), bI = _slicedToArray$1(hI, 2), HI = bI[0], UI = bI[1], pI = React.useMemo(function() {
    return HI === null && RA ? Number.MAX_SAFE_INTEGER : HI || 0;
  }, [HI, pA]), mI = useState(!1), rI = _slicedToArray$1(mI, 2), KA = rI[0], OA = rI[1], iI = "".concat(IA, "-item"), tI = Math.max(HA, QI), GI = lA === RESPONSIVE, oI = QA.length && GI, eI = lA === INVALIDATE, gI = oI || typeof lA == "number" && QA.length > lA, mA = useMemo$1(function() {
    var lI = QA;
    return oI ? pA === null && RA ? lI = QA : lI = QA.slice(0, Math.min(QA.length, SA / tA)) : typeof lA == "number" && (lI = QA.slice(0, lA)), lI;
  }, [QA, tA, pA, lA, oI]), WA = useMemo$1(function() {
    return oI ? QA.slice(pI + 1) : QA.slice(mA.length);
  }, [QA, mA, oI, pI]), xA = useCallback(function(lI, yI) {
    var SI;
    return typeof oA == "function" ? oA(lI) : (SI = oA && lI?.[oA]) !== null && SI !== void 0 ? SI : yI;
  }, [oA]), qA = useCallback(EA || function(lI) {
    return lI;
  }, [EA]);
  function VA(lI, yI, SI) {
    HI === lI && (yI === void 0 || yI === nI) || (UI(lI), SI || (OA(lI < QA.length - 1), yA?.(lI)), yI !== void 0 && uI(yI));
  }
  function cI(lI, yI) {
    YA(yI.clientWidth);
  }
  function DI(lI, yI) {
    zA(function(SI) {
      var xI = new Map(SI);
      return yI === null ? xI.delete(lI) : xI.set(lI, yI), xI;
    });
  }
  function JI(lI, yI) {
    LA(yI), TA(QI);
  }
  function kI(lI, yI) {
    CI(yI);
  }
  function fI(lI, yI) {
    $A(yI);
  }
  function _I(lI) {
    return fA.get(xA(mA[lI], lI));
  }
  useLayoutEffect(function() {
    if (SA && typeof tI == "number" && mA) {
      var lI = EI + wI, yI = mA.length, SI = yI - 1;
      if (!yI) {
        VA(0, null);
        return;
      }
      for (var xI = 0; xI < yI; xI += 1) {
        var MA = _I(xI);
        if (RA && (MA = MA || 0), MA === void 0) {
          VA(xI - 1, void 0, !0);
          break;
        }
        if (lI += MA, // Only one means `totalWidth` is the final width
        SI === 0 && lI <= SA || // Last two width will be the final width
        xI === SI - 1 && lI + _I(SI) <= SA) {
          VA(SI, null);
          break;
        } else if (lI + tI > SA) {
          VA(xI - 1, lI - MA - wI + QI);
          break;
        }
      }
      wA && _I(0) + wI > SA && uI(null);
    }
  }, [SA, fA, QI, EI, wI, xA, mA]);
  var qI = KA && !!WA.length, Dg = {};
  nI !== null && oI && (Dg = {
    position: "absolute",
    left: nI,
    top: 0
  });
  var vI = {
    prefixCls: iI,
    responsive: oI,
    component: rA,
    invalidate: eI
  }, wg = iA ? function(lI, yI) {
    var SI = xA(lI, yI);
    return /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
      key: SI,
      value: _objectSpread2$1(_objectSpread2$1({}, vI), {}, {
        order: yI,
        item: lI,
        itemKey: SI,
        registerSize: DI,
        display: yI <= pI
      })
    }, iA(lI, yI));
  } : function(lI, yI) {
    var SI = xA(lI, yI);
    return /* @__PURE__ */ React.createElement(Item, _extends$2({}, vI, {
      order: yI,
      key: SI,
      item: lI,
      renderItem: qA,
      itemKey: SI,
      registerSize: DI,
      display: yI <= pI
    }));
  }, sg = {
    order: qI ? pI : Number.MAX_SAFE_INTEGER,
    className: "".concat(iI, "-rest"),
    registerSize: JI,
    display: qI
  }, Eg = nA || defaultRenderRest, hg = DA ? /* @__PURE__ */ React.createElement(OverflowContext.Provider, {
    value: _objectSpread2$1(_objectSpread2$1({}, vI), sg)
  }, DA(WA)) : /* @__PURE__ */ React.createElement(Item, _extends$2({}, vI, sg), typeof Eg == "function" ? Eg(WA) : Eg), ig = /* @__PURE__ */ React.createElement(NA, _extends$2({
    className: classNames(!eI && IA, GA),
    style: aA,
    ref: gA
  }, bA), hA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, vI, {
    responsive: GI,
    responsiveDisabled: !oI,
    order: -1,
    className: "".concat(iI, "-prefix"),
    registerSize: kI,
    display: !0
  }), hA), mA.map(wg), gI ? hg : null, wA && /* @__PURE__ */ React.createElement(Item, _extends$2({}, vI, {
    responsive: GI,
    responsiveDisabled: !oI,
    order: pI,
    className: "".concat(iI, "-suffix"),
    registerSize: fI,
    display: !0,
    style: Dg
  }), wA));
  return GI ? /* @__PURE__ */ React.createElement(RefResizeObserver, {
    onResize: cI,
    disabled: !oI
  }, ig) : ig;
}
var ForwardOverflow = /* @__PURE__ */ React.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
function _EMOTION_STRINGIFIED_CSS_ERROR__$8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const getNavTextColor = (CA, gA, AA = !1, IA) => {
  if (AA)
    return CA.colors.fadedText40;
  if (IA)
    return CA.colors.bodyText;
  const BA = hasLightBackgroundColor(CA);
  return gA ? CA.colors.bodyText : BA ? transparentize(CA.colors.bodyText, 0.2) : transparentize(CA.colors.bodyText, 0.25);
}, StyledSidebarNavContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl921"
} : {
  target: "e10lwvl921",
  label: "StyledSidebarNavContainer"
})(({
  theme: CA
}) => ({
  position: "relative",
  fontFamily: CA.genericFonts.bodyFont
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavItems = /* @__PURE__ */ createStyled("ul", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl920"
} : {
  target: "e10lwvl920",
  label: "StyledSidebarNavItems"
})(({
  theme: CA
}) => ({
  listStyle: "none",
  margin: CA.spacing.none,
  paddingBottom: CA.spacing.threeXS,
  paddingTop: CA.spacing.none,
  paddingRight: CA.spacing.none,
  paddingLeft: CA.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl919"
} : {
  target: "e10lwvl919",
  label: "StyledSidebarNavLinkContainer"
})(({
  disabled: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  cursor: CA ? "not-allowed" : "pointer"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl918"
} : {
  target: "e10lwvl918",
  label: "StyledSidebarNavIcon"
})(({
  theme: CA,
  isActive: gA
}) => ({
  display: "inline-flex",
  // Apply a different font weight to the icon if it is active
  // The icon is in a span element.
  span: {
    fontWeight: gA ? CA.fontWeights.bold : CA.fontWeights.normal
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1Gb0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL05hdmlnYXRpb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjb2xvciBvZiB0aGUgdGV4dCBpbiB0aGUgc2lkZWJhciBuYXYuXG4gKlxuICogQHBhcmFtIHRoZW1lIFRoZSB0aGVtZSB0byB1c2UuXG4gKiBAcGFyYW0gaXNBY3RpdmUgV2hldGhlciB0aGUgbmF2IHRleHQgc2hvdWxkIHNob3cgYXMgYWN0aXZlLlxuICogQHJldHVybnMgVGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqL1xuY29uc3QgZ2V0TmF2VGV4dENvbG9yID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBpc0FjdGl2ZTogYm9vbGVhbixcbiAgZGlzYWJsZWQ6IGJvb2xlYW4gPSBmYWxzZSxcbiAgaXNUb3BOYXY/OiBib29sZWFuXG4pOiBzdHJpbmcgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwXG4gIH1cblxuICBpZiAoaXNUb3BOYXYpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cblxuICBjb25zdCBpc0xpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcblxuICBpZiAoaXNBY3RpdmUpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cbiAgcmV0dXJuIGlzTGlnaHRUaGVtZVxuICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjIpXG4gICAgOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYm9keVRleHQsIDAuMjUpXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZJdGVtcyA9IHN0eWxlZC51bCgoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgbGlzdFN0eWxlOiBcIm5vbmVcIixcbiAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIH1cbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzIHtcbiAgZGlzYWJsZWQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzPigoeyBkaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgY3Vyc29yOiBkaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICB9KSlcblxuaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2SWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgLy8gQXBwbHkgYSBkaWZmZXJlbnQgZm9udCB3ZWlnaHQgdG8gdGhlIGljb24gaWYgaXQgaXMgYWN0aXZlXG4gICAgICAvLyBUaGUgaWNvbiBpcyBpbiBhIHNwYW4gZWxlbWVudC5cbiAgICAgIHNwYW46IHtcbiAgICAgICAgZm9udFdlaWdodDogaXNBY3RpdmVcbiAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0xpc3RJdGVtID0gc3R5bGVkLmxpKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuICBsYWJlbD86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmsgPSBzdHlsZWQuYTxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCB9KSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdFBhZ2VMaW5rU3R5bGVzID0ge1xuICAgICAgdGV4dERlY29yYXRpb246IFwibm9uZVwiLFxuICAgICAgZm9udFdlaWdodDogaXNBY3RpdmUgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZDIsXG4gICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcblxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm1lbnVJdGVtLFxuXG4gICAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBpc0FjdGl2ZSksXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQWN0aXZlID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSA6IFwidHJhbnNwYXJlbnRcIixcblxuICAgICAgLi4uKGRpc2FibGVkICYmIHtcbiAgICAgICAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG4gICAgICB9KSxcblxuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcblxuICAgICAgXCImOmFjdGl2ZSwmOnZpc2l0ZWQsJjpob3ZlclwiOiB7XG4gICAgICAgIC4uLmRlZmF1bHRQYWdlTGlua1N0eWxlcyxcbiAgICAgIH0sXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckxpbmtUZXh0ID0gc3R5bGVkLnNwYW48U3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcz4oXG4gICh7IGlzQWN0aXZlLCB0aGVtZSwgZGlzYWJsZWQsIGlzVG9wTmF2LCBsYWJlbCB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCwgaXNUb3BOYXYpLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgZGlzcGxheTogXCJ0YWJsZS1jZWxsXCIsXG4gICAgICAvKiBQc2V1ZG8tZWxlbWVudCB0byByZXNlcnZlIGJvbGQgd2lkdGggKi9cbiAgICAgIFwiJjo6YWZ0ZXJcIjoge1xuICAgICAgICBjb250ZW50OiBgXCIke2xhYmVsfVwiYCAvKiBkdXBsaWNhdGUgdGV4dCAqLyxcbiAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCAvKiBib2xkIHZlcnNpb24gKi8sXG4gICAgICAgIHZpc2liaWxpdHk6IFwiaGlkZGVuXCIgLyogb2NjdXBpZXMgc3BhY2UsIG5vdCB2aXNpYmxlICovLFxuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgIGhlaWdodDogMCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDaGV2cm9uQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGlzRXhwYW5kZWQ6IGJvb2xlYW4gfT4oXG4gICh7IGlzRXhwYW5kZWQgfSkgPT4gKHtcbiAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgdHJhbnNmb3JtOiBpc0V4cGFuZGVkID8gXCJyb3RhdGUoMGRlZylcIiA6IFwicm90YXRlKC05MGRlZylcIixcbiAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAyMDBtcyBlYXNlXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25IZWFkZXJUZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICBtaW5XaWR0aDogMCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdlNlY3Rpb25IZWFkZXIgPSBzdHlsZWQuaGVhZGVyPHtcbiAgaXNFeHBhbmRlZDogYm9vbGVhblxufT4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuc2VtaUJvbGQsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgZmFsc2UpLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnNtYWxsLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgW2AmID4gJHtTdHlsZWRDaGV2cm9uQ29udGFpbmVyfWBdOiB7XG4gICAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlld0J1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCB0cnVlKSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBcIiY6aG92ZXIsICY6YWN0aXZlLCAmOmZvY3VzXCI6IHtcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2U2VwYXJhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiY6bm90KDpmaXJzdC1jaGlsZClcIjoge1xuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgfSxcbn0pKVxuXG4vLyBUb3BOYXYgc3R5bGVkIGNvbXBvbmVudHNcbmV4cG9ydCBjb25zdCBTdHlsZWRPdmVyZmxvd0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZmxleFNocmluazogMSxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWROYXZTZWN0aW9uUHJvcHMge1xuICBpc09wZW46IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb24gPSBzdHlsZWQuZGl2PFN0eWxlZE5hdlNlY3Rpb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpc09wZW4gfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGZhbHNlLCBmYWxzZSwgdHJ1ZSksXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFwiJjpub3QoOmZpcnN0LW9mLXR5cGUpXCI6IHtcbiAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgfSxcbiAgICAuLi4oaXNPcGVuID8geyBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUgfSA6IHt9KSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb3BOYXZMaW5rQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgXCImOm5vdCg6Zmlyc3Qtb2YtdHlwZSlcIjoge1xuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIH0sXG59KSlcblxuLy8gVGhpcyBpcyBzcGVjaWZpY2FsbHkgZm9yIHVzZSBpbiBUb3BOYXZTZWN0aW9uJ3MgcG9wb3ZlciBtZW51XG5leHBvcnQgY29uc3QgU3R5bGVkVG9wTmF2U2lkZWJhck5hdkxpbmtDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIGl0ZW0gbWFyZ2lucyAoeHMgZnJvbSBlZGdlKVxuICBtYXJnaW46IGAke3RoZW1lLnNwYWNpbmcubm9uZX0gJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25UZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VjdGlvbk5hbWUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIHZlcnRpY2FsIHBhZGRpbmcgKHR3b1hTIHRvcC9ib3R0b20pXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5ub25lfWAsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEljb25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuLyogZXNsaW50LWRpc2FibGUgc3RyZWFtbGl0LWN1c3RvbS9uby1oYXJkY29kZWQtdGhlbWUtdmFsdWVzICovXG4vLyBWaXN1YWxseSBoaWRkZW4gYnV0IGFjY2Vzc2libGUgdG8gc2NyZWVuIHJlYWRlcnNcbi8vIFVzZXMgc3RhbmRhcmQgQ1NTIHZpc3VhbGx5LWhpZGRlbiBwYXR0ZXJuIChoYXJkY29kZWQgdmFsdWVzIHJlcXVpcmVkKVxuZXhwb3J0IGNvbnN0IFN0eWxlZFZpc3VhbGx5SGlkZGVuID0gc3R5bGVkLnNwYW4oe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogXCIxcHhcIixcbiAgaGVpZ2h0OiBcIjFweFwiLFxuICBwYWRkaW5nOiAwLFxuICBtYXJnaW46IFwiLTFweFwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgY2xpcDogXCJyZWN0KDAsIDAsIDAsIDApXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGJvcmRlcjogMCxcbn0pXG4vKiBlc2xpbnQtZW5hYmxlIHN0cmVhbWxpdC1jdXN0b20vbm8taGFyZGNvZGVkLXRoZW1lLXZhbHVlcyAqL1xuIl19 */"), StyledSidebarNavLinkListItem = /* @__PURE__ */ createStyled("li", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl917"
} : {
  target: "e10lwvl917",
  label: "StyledSidebarNavLinkListItem"
})(({
  theme: CA
}) => ({
  marginTop: CA.spacing.threeXS,
  marginBottom: CA.spacing.threeXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavLink = /* @__PURE__ */ createStyled("a", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl916"
} : {
  target: "e10lwvl916",
  label: "StyledSidebarNavLink"
})(({
  theme: CA,
  isActive: gA,
  disabled: AA
}) => {
  const IA = {
    textDecoration: "none",
    fontWeight: gA ? CA.fontWeights.bold : CA.fontWeights.normal
  };
  return {
    ...IA,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: CA.spacing.sm,
    borderRadius: CA.radii.md2,
    paddingLeft: CA.spacing.sm,
    paddingRight: CA.spacing.sm,
    marginTop: CA.spacing.threeXS,
    marginBottom: CA.spacing.threeXS,
    lineHeight: CA.lineHeights.menuItem,
    color: getNavTextColor(CA, gA),
    backgroundColor: gA ? CA.colors.darkenedBgMix25 : "transparent",
    ...AA && {
      pointerEvents: "none"
    },
    "&:hover": {
      backgroundColor: CA.colors.darkenedBgMix15
    },
    "&:active,&:visited,&:hover": {
      ...IA
    },
    "&:focus": {
      outline: "none"
    },
    "&:focus-visible": {
      backgroundColor: CA.colors.darkenedBgMix15
    },
    "@media print": {
      paddingLeft: CA.spacing.none
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarLinkText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl915"
} : {
  target: "e10lwvl915",
  label: "StyledSidebarLinkText"
})(({
  isActive: CA,
  theme: gA,
  disabled: AA,
  isTopNav: IA,
  label: BA
}) => ({
  color: getNavTextColor(gA, CA, AA, IA),
  fontSize: gA.fontSizes.sm,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  display: "table-cell",
  /* Pseudo-element to reserve bold width */
  "&::after": {
    content: `"${BA}"`,
    fontWeight: gA.fontWeights.bold,
    visibility: "hidden",
    display: "block",
    width: "fit-content",
    height: 0
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledChevronContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl914"
} : {
  target: "e10lwvl914",
  label: "StyledChevronContainer"
})(({
  isExpanded: CA
}) => ({
  visibility: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transform: CA ? "rotate(0deg)" : "rotate(-90deg)",
  transition: "transform 200ms ease",
  flexShrink: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionHeaderText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl913"
} : {
  target: "e10lwvl913",
  label: "StyledNavSectionHeaderText"
})(() => ({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSectionHeader = /* @__PURE__ */ createStyled("header", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl912"
} : {
  target: "e10lwvl912",
  label: "StyledSidebarNavSectionHeader"
})(({
  theme: CA
}) => ({
  fontSize: CA.fontSizes.sm,
  fontWeight: CA.fontWeights.semiBold,
  color: getNavTextColor(CA, !1),
  lineHeight: CA.lineHeights.small,
  paddingRight: CA.spacing.sm,
  marginTop: CA.spacing.sm,
  marginBottom: CA.spacing.twoXS,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: CA.spacing.sm,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    [`& > ${StyledChevronContainer}`]: {
      visibility: "visible"
    }
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledViewButton = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl911"
} : {
  target: "e10lwvl911",
  label: "StyledViewButton"
})(({
  theme: CA
}) => ({
  fontSize: CA.fontSizes.sm,
  fontFamily: "inherit",
  lineHeight: CA.lineHeights.base,
  color: getNavTextColor(CA, !0),
  backgroundColor: CA.colors.transparent,
  border: "none",
  borderRadius: CA.radii.default,
  marginTop: CA.spacing.twoXS,
  marginLeft: CA.spacing.none,
  marginBottom: CA.spacing.none,
  marginRight: CA.spacing.none,
  padding: `${CA.spacing.threeXS} ${CA.spacing.sm}`,
  "&:hover, &:active, &:focus": {
    border: "none",
    outline: "none",
    boxShadow: "none"
  },
  "&:hover": {
    backgroundColor: CA.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarNavSeparator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl910"
} : {
  target: "e10lwvl910",
  label: "StyledSidebarNavSeparator"
})(({
  theme: CA
}) => ({
  paddingTop: CA.spacing.lg,
  borderBottom: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl99"
} : {
  target: "e10lwvl99",
  label: "StyledNavSectionContainer"
})(({
  theme: CA
}) => ({
  "&:not(:first-child)": {
    marginTop: CA.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlReUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL05hdmlnYXRpb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjb2xvciBvZiB0aGUgdGV4dCBpbiB0aGUgc2lkZWJhciBuYXYuXG4gKlxuICogQHBhcmFtIHRoZW1lIFRoZSB0aGVtZSB0byB1c2UuXG4gKiBAcGFyYW0gaXNBY3RpdmUgV2hldGhlciB0aGUgbmF2IHRleHQgc2hvdWxkIHNob3cgYXMgYWN0aXZlLlxuICogQHJldHVybnMgVGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqL1xuY29uc3QgZ2V0TmF2VGV4dENvbG9yID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBpc0FjdGl2ZTogYm9vbGVhbixcbiAgZGlzYWJsZWQ6IGJvb2xlYW4gPSBmYWxzZSxcbiAgaXNUb3BOYXY/OiBib29sZWFuXG4pOiBzdHJpbmcgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwXG4gIH1cblxuICBpZiAoaXNUb3BOYXYpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cblxuICBjb25zdCBpc0xpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcblxuICBpZiAoaXNBY3RpdmUpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cbiAgcmV0dXJuIGlzTGlnaHRUaGVtZVxuICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjIpXG4gICAgOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYm9keVRleHQsIDAuMjUpXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZJdGVtcyA9IHN0eWxlZC51bCgoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgbGlzdFN0eWxlOiBcIm5vbmVcIixcbiAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIH1cbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzIHtcbiAgZGlzYWJsZWQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzPigoeyBkaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgY3Vyc29yOiBkaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICB9KSlcblxuaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2SWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgLy8gQXBwbHkgYSBkaWZmZXJlbnQgZm9udCB3ZWlnaHQgdG8gdGhlIGljb24gaWYgaXQgaXMgYWN0aXZlXG4gICAgICAvLyBUaGUgaWNvbiBpcyBpbiBhIHNwYW4gZWxlbWVudC5cbiAgICAgIHNwYW46IHtcbiAgICAgICAgZm9udFdlaWdodDogaXNBY3RpdmVcbiAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0xpc3RJdGVtID0gc3R5bGVkLmxpKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuICBsYWJlbD86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmsgPSBzdHlsZWQuYTxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCB9KSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdFBhZ2VMaW5rU3R5bGVzID0ge1xuICAgICAgdGV4dERlY29yYXRpb246IFwibm9uZVwiLFxuICAgICAgZm9udFdlaWdodDogaXNBY3RpdmUgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZDIsXG4gICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcblxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm1lbnVJdGVtLFxuXG4gICAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBpc0FjdGl2ZSksXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQWN0aXZlID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSA6IFwidHJhbnNwYXJlbnRcIixcblxuICAgICAgLi4uKGRpc2FibGVkICYmIHtcbiAgICAgICAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG4gICAgICB9KSxcblxuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcblxuICAgICAgXCImOmFjdGl2ZSwmOnZpc2l0ZWQsJjpob3ZlclwiOiB7XG4gICAgICAgIC4uLmRlZmF1bHRQYWdlTGlua1N0eWxlcyxcbiAgICAgIH0sXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckxpbmtUZXh0ID0gc3R5bGVkLnNwYW48U3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcz4oXG4gICh7IGlzQWN0aXZlLCB0aGVtZSwgZGlzYWJsZWQsIGlzVG9wTmF2LCBsYWJlbCB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCwgaXNUb3BOYXYpLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgZGlzcGxheTogXCJ0YWJsZS1jZWxsXCIsXG4gICAgICAvKiBQc2V1ZG8tZWxlbWVudCB0byByZXNlcnZlIGJvbGQgd2lkdGggKi9cbiAgICAgIFwiJjo6YWZ0ZXJcIjoge1xuICAgICAgICBjb250ZW50OiBgXCIke2xhYmVsfVwiYCAvKiBkdXBsaWNhdGUgdGV4dCAqLyxcbiAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCAvKiBib2xkIHZlcnNpb24gKi8sXG4gICAgICAgIHZpc2liaWxpdHk6IFwiaGlkZGVuXCIgLyogb2NjdXBpZXMgc3BhY2UsIG5vdCB2aXNpYmxlICovLFxuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgIGhlaWdodDogMCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDaGV2cm9uQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGlzRXhwYW5kZWQ6IGJvb2xlYW4gfT4oXG4gICh7IGlzRXhwYW5kZWQgfSkgPT4gKHtcbiAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgdHJhbnNmb3JtOiBpc0V4cGFuZGVkID8gXCJyb3RhdGUoMGRlZylcIiA6IFwicm90YXRlKC05MGRlZylcIixcbiAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAyMDBtcyBlYXNlXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25IZWFkZXJUZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICBtaW5XaWR0aDogMCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdlNlY3Rpb25IZWFkZXIgPSBzdHlsZWQuaGVhZGVyPHtcbiAgaXNFeHBhbmRlZDogYm9vbGVhblxufT4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuc2VtaUJvbGQsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgZmFsc2UpLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnNtYWxsLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgW2AmID4gJHtTdHlsZWRDaGV2cm9uQ29udGFpbmVyfWBdOiB7XG4gICAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlld0J1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCB0cnVlKSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBcIiY6aG92ZXIsICY6YWN0aXZlLCAmOmZvY3VzXCI6IHtcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2U2VwYXJhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiY6bm90KDpmaXJzdC1jaGlsZClcIjoge1xuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgfSxcbn0pKVxuXG4vLyBUb3BOYXYgc3R5bGVkIGNvbXBvbmVudHNcbmV4cG9ydCBjb25zdCBTdHlsZWRPdmVyZmxvd0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZmxleFNocmluazogMSxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWROYXZTZWN0aW9uUHJvcHMge1xuICBpc09wZW46IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb24gPSBzdHlsZWQuZGl2PFN0eWxlZE5hdlNlY3Rpb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpc09wZW4gfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGZhbHNlLCBmYWxzZSwgdHJ1ZSksXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFwiJjpub3QoOmZpcnN0LW9mLXR5cGUpXCI6IHtcbiAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgfSxcbiAgICAuLi4oaXNPcGVuID8geyBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUgfSA6IHt9KSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb3BOYXZMaW5rQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgXCImOm5vdCg6Zmlyc3Qtb2YtdHlwZSlcIjoge1xuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIH0sXG59KSlcblxuLy8gVGhpcyBpcyBzcGVjaWZpY2FsbHkgZm9yIHVzZSBpbiBUb3BOYXZTZWN0aW9uJ3MgcG9wb3ZlciBtZW51XG5leHBvcnQgY29uc3QgU3R5bGVkVG9wTmF2U2lkZWJhck5hdkxpbmtDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIGl0ZW0gbWFyZ2lucyAoeHMgZnJvbSBlZGdlKVxuICBtYXJnaW46IGAke3RoZW1lLnNwYWNpbmcubm9uZX0gJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25UZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VjdGlvbk5hbWUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIHZlcnRpY2FsIHBhZGRpbmcgKHR3b1hTIHRvcC9ib3R0b20pXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5ub25lfWAsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEljb25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuLyogZXNsaW50LWRpc2FibGUgc3RyZWFtbGl0LWN1c3RvbS9uby1oYXJkY29kZWQtdGhlbWUtdmFsdWVzICovXG4vLyBWaXN1YWxseSBoaWRkZW4gYnV0IGFjY2Vzc2libGUgdG8gc2NyZWVuIHJlYWRlcnNcbi8vIFVzZXMgc3RhbmRhcmQgQ1NTIHZpc3VhbGx5LWhpZGRlbiBwYXR0ZXJuIChoYXJkY29kZWQgdmFsdWVzIHJlcXVpcmVkKVxuZXhwb3J0IGNvbnN0IFN0eWxlZFZpc3VhbGx5SGlkZGVuID0gc3R5bGVkLnNwYW4oe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogXCIxcHhcIixcbiAgaGVpZ2h0OiBcIjFweFwiLFxuICBwYWRkaW5nOiAwLFxuICBtYXJnaW46IFwiLTFweFwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgY2xpcDogXCJyZWN0KDAsIDAsIDAsIDApXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGJvcmRlcjogMCxcbn0pXG4vKiBlc2xpbnQtZW5hYmxlIHN0cmVhbWxpdC1jdXN0b20vbm8taGFyZGNvZGVkLXRoZW1lLXZhbHVlcyAqL1xuIl19 */"), StyledOverflowContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl98"
} : {
  target: "e10lwvl98",
  label: "StyledOverflowContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexShrink: 1,
  overflow: "hidden",
  padding: `0 ${CA.spacing.lg}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSection = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl97"
} : {
  target: "e10lwvl97",
  label: "StyledNavSection"
})(({
  theme: CA,
  isOpen: gA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  lineHeight: CA.lineHeights.menuItem,
  fontSize: CA.fontSizes.sm,
  padding: `0 ${CA.spacing.sm}`,
  color: getNavTextColor(CA, !1, !1, !0),
  borderRadius: CA.radii.default,
  marginRight: CA.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: CA.spacing.twoXS
  },
  ...gA ? {
    backgroundColor: CA.colors.darkenedBgMix25
  } : {},
  "&:hover": {
    backgroundColor: CA.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl96"
} : {
  target: "e10lwvl96",
  label: "StyledTopNavLinkContainer"
})(({
  theme: CA
}) => ({
  marginRight: CA.spacing.twoXS,
  "&:not(:first-of-type)": {
    marginLeft: CA.spacing.twoXS
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledTopNavSidebarNavLinkContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl95"
} : {
  target: "e10lwvl95",
  label: "StyledTopNavSidebarNavLinkContainer"
})(({
  theme: CA
}) => ({
  // Match dropdown item margins (xs from edge)
  margin: `${CA.spacing.none} ${CA.spacing.xs}`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledNavSectionText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl94"
} : {
  target: "e10lwvl94",
  label: "StyledNavSectionText"
})(() => ({
  whiteSpace: "nowrap"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlUb0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL05hdmlnYXRpb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjb2xvciBvZiB0aGUgdGV4dCBpbiB0aGUgc2lkZWJhciBuYXYuXG4gKlxuICogQHBhcmFtIHRoZW1lIFRoZSB0aGVtZSB0byB1c2UuXG4gKiBAcGFyYW0gaXNBY3RpdmUgV2hldGhlciB0aGUgbmF2IHRleHQgc2hvdWxkIHNob3cgYXMgYWN0aXZlLlxuICogQHJldHVybnMgVGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqL1xuY29uc3QgZ2V0TmF2VGV4dENvbG9yID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBpc0FjdGl2ZTogYm9vbGVhbixcbiAgZGlzYWJsZWQ6IGJvb2xlYW4gPSBmYWxzZSxcbiAgaXNUb3BOYXY/OiBib29sZWFuXG4pOiBzdHJpbmcgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwXG4gIH1cblxuICBpZiAoaXNUb3BOYXYpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cblxuICBjb25zdCBpc0xpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcblxuICBpZiAoaXNBY3RpdmUpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cbiAgcmV0dXJuIGlzTGlnaHRUaGVtZVxuICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjIpXG4gICAgOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYm9keVRleHQsIDAuMjUpXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZJdGVtcyA9IHN0eWxlZC51bCgoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgbGlzdFN0eWxlOiBcIm5vbmVcIixcbiAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIH1cbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzIHtcbiAgZGlzYWJsZWQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzPigoeyBkaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgY3Vyc29yOiBkaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICB9KSlcblxuaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2SWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgLy8gQXBwbHkgYSBkaWZmZXJlbnQgZm9udCB3ZWlnaHQgdG8gdGhlIGljb24gaWYgaXQgaXMgYWN0aXZlXG4gICAgICAvLyBUaGUgaWNvbiBpcyBpbiBhIHNwYW4gZWxlbWVudC5cbiAgICAgIHNwYW46IHtcbiAgICAgICAgZm9udFdlaWdodDogaXNBY3RpdmVcbiAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0xpc3RJdGVtID0gc3R5bGVkLmxpKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuICBsYWJlbD86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmsgPSBzdHlsZWQuYTxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCB9KSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdFBhZ2VMaW5rU3R5bGVzID0ge1xuICAgICAgdGV4dERlY29yYXRpb246IFwibm9uZVwiLFxuICAgICAgZm9udFdlaWdodDogaXNBY3RpdmUgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZDIsXG4gICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcblxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm1lbnVJdGVtLFxuXG4gICAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBpc0FjdGl2ZSksXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQWN0aXZlID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSA6IFwidHJhbnNwYXJlbnRcIixcblxuICAgICAgLi4uKGRpc2FibGVkICYmIHtcbiAgICAgICAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG4gICAgICB9KSxcblxuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcblxuICAgICAgXCImOmFjdGl2ZSwmOnZpc2l0ZWQsJjpob3ZlclwiOiB7XG4gICAgICAgIC4uLmRlZmF1bHRQYWdlTGlua1N0eWxlcyxcbiAgICAgIH0sXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckxpbmtUZXh0ID0gc3R5bGVkLnNwYW48U3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcz4oXG4gICh7IGlzQWN0aXZlLCB0aGVtZSwgZGlzYWJsZWQsIGlzVG9wTmF2LCBsYWJlbCB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCwgaXNUb3BOYXYpLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgZGlzcGxheTogXCJ0YWJsZS1jZWxsXCIsXG4gICAgICAvKiBQc2V1ZG8tZWxlbWVudCB0byByZXNlcnZlIGJvbGQgd2lkdGggKi9cbiAgICAgIFwiJjo6YWZ0ZXJcIjoge1xuICAgICAgICBjb250ZW50OiBgXCIke2xhYmVsfVwiYCAvKiBkdXBsaWNhdGUgdGV4dCAqLyxcbiAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCAvKiBib2xkIHZlcnNpb24gKi8sXG4gICAgICAgIHZpc2liaWxpdHk6IFwiaGlkZGVuXCIgLyogb2NjdXBpZXMgc3BhY2UsIG5vdCB2aXNpYmxlICovLFxuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgIGhlaWdodDogMCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDaGV2cm9uQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGlzRXhwYW5kZWQ6IGJvb2xlYW4gfT4oXG4gICh7IGlzRXhwYW5kZWQgfSkgPT4gKHtcbiAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgdHJhbnNmb3JtOiBpc0V4cGFuZGVkID8gXCJyb3RhdGUoMGRlZylcIiA6IFwicm90YXRlKC05MGRlZylcIixcbiAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAyMDBtcyBlYXNlXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25IZWFkZXJUZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICBtaW5XaWR0aDogMCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdlNlY3Rpb25IZWFkZXIgPSBzdHlsZWQuaGVhZGVyPHtcbiAgaXNFeHBhbmRlZDogYm9vbGVhblxufT4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuc2VtaUJvbGQsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgZmFsc2UpLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnNtYWxsLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgW2AmID4gJHtTdHlsZWRDaGV2cm9uQ29udGFpbmVyfWBdOiB7XG4gICAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlld0J1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCB0cnVlKSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBcIiY6aG92ZXIsICY6YWN0aXZlLCAmOmZvY3VzXCI6IHtcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2U2VwYXJhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiY6bm90KDpmaXJzdC1jaGlsZClcIjoge1xuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgfSxcbn0pKVxuXG4vLyBUb3BOYXYgc3R5bGVkIGNvbXBvbmVudHNcbmV4cG9ydCBjb25zdCBTdHlsZWRPdmVyZmxvd0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZmxleFNocmluazogMSxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWROYXZTZWN0aW9uUHJvcHMge1xuICBpc09wZW46IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb24gPSBzdHlsZWQuZGl2PFN0eWxlZE5hdlNlY3Rpb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpc09wZW4gfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGZhbHNlLCBmYWxzZSwgdHJ1ZSksXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFwiJjpub3QoOmZpcnN0LW9mLXR5cGUpXCI6IHtcbiAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgfSxcbiAgICAuLi4oaXNPcGVuID8geyBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUgfSA6IHt9KSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb3BOYXZMaW5rQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgXCImOm5vdCg6Zmlyc3Qtb2YtdHlwZSlcIjoge1xuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIH0sXG59KSlcblxuLy8gVGhpcyBpcyBzcGVjaWZpY2FsbHkgZm9yIHVzZSBpbiBUb3BOYXZTZWN0aW9uJ3MgcG9wb3ZlciBtZW51XG5leHBvcnQgY29uc3QgU3R5bGVkVG9wTmF2U2lkZWJhck5hdkxpbmtDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIGl0ZW0gbWFyZ2lucyAoeHMgZnJvbSBlZGdlKVxuICBtYXJnaW46IGAke3RoZW1lLnNwYWNpbmcubm9uZX0gJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25UZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VjdGlvbk5hbWUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIHZlcnRpY2FsIHBhZGRpbmcgKHR3b1hTIHRvcC9ib3R0b20pXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5ub25lfWAsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEljb25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuLyogZXNsaW50LWRpc2FibGUgc3RyZWFtbGl0LWN1c3RvbS9uby1oYXJkY29kZWQtdGhlbWUtdmFsdWVzICovXG4vLyBWaXN1YWxseSBoaWRkZW4gYnV0IGFjY2Vzc2libGUgdG8gc2NyZWVuIHJlYWRlcnNcbi8vIFVzZXMgc3RhbmRhcmQgQ1NTIHZpc3VhbGx5LWhpZGRlbiBwYXR0ZXJuIChoYXJkY29kZWQgdmFsdWVzIHJlcXVpcmVkKVxuZXhwb3J0IGNvbnN0IFN0eWxlZFZpc3VhbGx5SGlkZGVuID0gc3R5bGVkLnNwYW4oe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogXCIxcHhcIixcbiAgaGVpZ2h0OiBcIjFweFwiLFxuICBwYWRkaW5nOiAwLFxuICBtYXJnaW46IFwiLTFweFwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgY2xpcDogXCJyZWN0KDAsIDAsIDAsIDApXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGJvcmRlcjogMCxcbn0pXG4vKiBlc2xpbnQtZW5hYmxlIHN0cmVhbWxpdC1jdXN0b20vbm8taGFyZGNvZGVkLXRoZW1lLXZhbHVlcyAqL1xuIl19 */"), StyledSectionName = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl93"
} : {
  target: "e10lwvl93",
  label: "StyledSectionName"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.sm,
  marginTop: CA.spacing.sm,
  marginBottom: CA.spacing.sm,
  lineHeight: CA.lineHeights.menuItem
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledPopoverContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl92"
} : {
  target: "e10lwvl92",
  label: "StyledPopoverContent"
})(({
  theme: CA
}) => ({
  // Match dropdown vertical padding (twoXS top/bottom)
  padding: `${CA.spacing.twoXS} ${CA.spacing.none}`,
  fontSize: CA.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIconContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl91"
} : {
  target: "e10lwvl91",
  label: "StyledIconContainer"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBVbUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL05hdmlnYXRpb24vc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSBcImNvbG9yMmtcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuLyoqXG4gKiBSZXR1cm5zIHRoZSBjb2xvciBvZiB0aGUgdGV4dCBpbiB0aGUgc2lkZWJhciBuYXYuXG4gKlxuICogQHBhcmFtIHRoZW1lIFRoZSB0aGVtZSB0byB1c2UuXG4gKiBAcGFyYW0gaXNBY3RpdmUgV2hldGhlciB0aGUgbmF2IHRleHQgc2hvdWxkIHNob3cgYXMgYWN0aXZlLlxuICogQHJldHVybnMgVGhlIGNvbG9yIG9mIHRoZSB0ZXh0IGluIHRoZSBzaWRlYmFyIG5hdi5cbiAqL1xuY29uc3QgZ2V0TmF2VGV4dENvbG9yID0gKFxuICB0aGVtZTogRW1vdGlvblRoZW1lLFxuICBpc0FjdGl2ZTogYm9vbGVhbixcbiAgZGlzYWJsZWQ6IGJvb2xlYW4gPSBmYWxzZSxcbiAgaXNUb3BOYXY/OiBib29sZWFuXG4pOiBzdHJpbmcgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwXG4gIH1cblxuICBpZiAoaXNUb3BOYXYpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cblxuICBjb25zdCBpc0xpZ2h0VGhlbWUgPSBoYXNMaWdodEJhY2tncm91bmRDb2xvcih0aGVtZSlcblxuICBpZiAoaXNBY3RpdmUpIHtcbiAgICByZXR1cm4gdGhlbWUuY29sb3JzLmJvZHlUZXh0XG4gIH1cbiAgcmV0dXJuIGlzTGlnaHRUaGVtZVxuICAgID8gdHJhbnNwYXJlbnRpemUodGhlbWUuY29sb3JzLmJvZHlUZXh0LCAwLjIpXG4gICAgOiB0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYm9keVRleHQsIDAuMjUpXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2Q29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBmb250RmFtaWx5OiB0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnQsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZJdGVtcyA9IHN0eWxlZC51bCgoeyB0aGVtZSB9KSA9PiB7XG4gIHJldHVybiB7XG4gICAgbGlzdFN0eWxlOiBcIm5vbmVcIixcbiAgICBtYXJnaW46IHRoZW1lLnNwYWNpbmcubm9uZSxcbiAgICBwYWRkaW5nQm90dG9tOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gIH1cbn0pXG5cbmludGVyZmFjZSBTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzIHtcbiAgZGlzYWJsZWQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJOYXZMaW5rQ29udGFpbmVyID1cbiAgc3R5bGVkLmRpdjxTdHlsZWRTaWRlYmFyTmF2TGlua0NvbnRhaW5lclByb3BzPigoeyBkaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgY3Vyc29yOiBkaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICB9KSlcblxuaW50ZXJmYWNlIFN0eWxlZFNpZGViYXJOYXZJY29uUHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkljb24gPSBzdHlsZWQuc3BhbjxTdHlsZWRTaWRlYmFyTmF2SWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlIH0pID0+IHtcbiAgICByZXR1cm4ge1xuICAgICAgZGlzcGxheTogXCJpbmxpbmUtZmxleFwiLFxuICAgICAgLy8gQXBwbHkgYSBkaWZmZXJlbnQgZm9udCB3ZWlnaHQgdG8gdGhlIGljb24gaWYgaXQgaXMgYWN0aXZlXG4gICAgICAvLyBUaGUgaWNvbiBpcyBpbiBhIHNwYW4gZWxlbWVudC5cbiAgICAgIHNwYW46IHtcbiAgICAgICAgZm9udFdlaWdodDogaXNBY3RpdmVcbiAgICAgICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgICAgICA6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2TGlua0xpc3RJdGVtID0gc3R5bGVkLmxpKCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcyB7XG4gIGlzQWN0aXZlOiBib29sZWFuXG4gIGRpc2FibGVkOiBib29sZWFuXG4gIGlzVG9wTmF2PzogYm9vbGVhblxuICBsYWJlbD86IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdkxpbmsgPSBzdHlsZWQuYTxTdHlsZWRTaWRlYmFyTmF2TGlua1Byb3BzPihcbiAgKHsgdGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCB9KSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdFBhZ2VMaW5rU3R5bGVzID0ge1xuICAgICAgdGV4dERlY29yYXRpb246IFwibm9uZVwiLFxuICAgICAgZm9udFdlaWdodDogaXNBY3RpdmUgPyB0aGVtZS5mb250V2VpZ2h0cy5ib2xkIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIH1cblxuICAgIHJldHVybiB7XG4gICAgICAuLi5kZWZhdWx0UGFnZUxpbmtTdHlsZXMsXG4gICAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgICAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5tZDIsXG4gICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcblxuICAgICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnRocmVlWFMsXG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudGhyZWVYUyxcbiAgICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLm1lbnVJdGVtLFxuXG4gICAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCBpc0FjdGl2ZSksXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQWN0aXZlID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNSA6IFwidHJhbnNwYXJlbnRcIixcblxuICAgICAgLi4uKGRpc2FibGVkICYmIHtcbiAgICAgICAgcG9pbnRlckV2ZW50czogXCJub25lXCIsXG4gICAgICB9KSxcblxuICAgICAgXCImOmhvdmVyXCI6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgfSxcblxuICAgICAgXCImOmFjdGl2ZSwmOnZpc2l0ZWQsJjpob3ZlclwiOiB7XG4gICAgICAgIC4uLmRlZmF1bHRQYWdlTGlua1N0eWxlcyxcbiAgICAgIH0sXG5cbiAgICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgICAgfSxcblxuICAgICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgICB9LFxuXG4gICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgIHBhZGRpbmdMZWZ0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICB9LFxuICAgIH1cbiAgfVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhckxpbmtUZXh0ID0gc3R5bGVkLnNwYW48U3R5bGVkU2lkZWJhck5hdkxpbmtQcm9wcz4oXG4gICh7IGlzQWN0aXZlLCB0aGVtZSwgZGlzYWJsZWQsIGlzVG9wTmF2LCBsYWJlbCB9KSA9PiB7XG4gICAgcmV0dXJuIHtcbiAgICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGlzQWN0aXZlLCBkaXNhYmxlZCwgaXNUb3BOYXYpLFxuICAgICAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5zbSxcbiAgICAgIG92ZXJmbG93OiBcImhpZGRlblwiLFxuICAgICAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbiAgICAgIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICAgICAgZGlzcGxheTogXCJ0YWJsZS1jZWxsXCIsXG4gICAgICAvKiBQc2V1ZG8tZWxlbWVudCB0byByZXNlcnZlIGJvbGQgd2lkdGggKi9cbiAgICAgIFwiJjo6YWZ0ZXJcIjoge1xuICAgICAgICBjb250ZW50OiBgXCIke2xhYmVsfVwiYCAvKiBkdXBsaWNhdGUgdGV4dCAqLyxcbiAgICAgICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCAvKiBib2xkIHZlcnNpb24gKi8sXG4gICAgICAgIHZpc2liaWxpdHk6IFwiaGlkZGVuXCIgLyogb2NjdXBpZXMgc3BhY2UsIG5vdCB2aXNpYmxlICovLFxuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICAgIHdpZHRoOiBcImZpdC1jb250ZW50XCIsXG4gICAgICAgIGhlaWdodDogMCxcbiAgICAgIH0sXG4gICAgfVxuICB9XG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRDaGV2cm9uQ29udGFpbmVyID0gc3R5bGVkLmRpdjx7IGlzRXhwYW5kZWQ6IGJvb2xlYW4gfT4oXG4gICh7IGlzRXhwYW5kZWQgfSkgPT4gKHtcbiAgICB2aXNpYmlsaXR5OiBcImhpZGRlblwiLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gICAgdHJhbnNmb3JtOiBpc0V4cGFuZGVkID8gXCJyb3RhdGUoMGRlZylcIiA6IFwicm90YXRlKC05MGRlZylcIixcbiAgICB0cmFuc2l0aW9uOiBcInRyYW5zZm9ybSAyMDBtcyBlYXNlXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25IZWFkZXJUZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIHRleHRPdmVyZmxvdzogXCJlbGxpcHNpc1wiLFxuICBtaW5XaWR0aDogMCxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2lkZWJhck5hdlNlY3Rpb25IZWFkZXIgPSBzdHlsZWQuaGVhZGVyPHtcbiAgaXNFeHBhbmRlZDogYm9vbGVhblxufT4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuc2VtaUJvbGQsXG4gICAgY29sb3I6IGdldE5hdlRleHRDb2xvcih0aGVtZSwgZmFsc2UpLFxuICAgIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnNtYWxsLFxuICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5zbSxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBnYXA6IHRoZW1lLnNwYWNpbmcuc20sXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICB1c2VyU2VsZWN0OiBcIm5vbmVcIixcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgW2AmID4gJHtTdHlsZWRDaGV2cm9uQ29udGFpbmVyfWBdOiB7XG4gICAgICAgIHZpc2liaWxpdHk6IFwidmlzaWJsZVwiLFxuICAgICAgfSxcbiAgICB9LFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVmlld0J1dHRvbiA9IHN0eWxlZC5idXR0b24oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMuYmFzZSxcbiAgICBjb2xvcjogZ2V0TmF2VGV4dENvbG9yKHRoZW1lLCB0cnVlKSxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpbkJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBcIiY6aG92ZXIsICY6YWN0aXZlLCAmOmZvY3VzXCI6IHtcbiAgICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCIsXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH1cbn0pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRTaWRlYmFyTmF2U2VwYXJhdG9yID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLmxnLFxuICBib3JkZXJCb3R0b206IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWROYXZTZWN0aW9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBcIiY6bm90KDpmaXJzdC1jaGlsZClcIjoge1xuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgfSxcbn0pKVxuXG4vLyBUb3BOYXYgc3R5bGVkIGNvbXBvbmVudHNcbmV4cG9ydCBjb25zdCBTdHlsZWRPdmVyZmxvd0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZmxleFNocmluazogMSxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5sZ31gLFxufSkpXG5cbmludGVyZmFjZSBTdHlsZWROYXZTZWN0aW9uUHJvcHMge1xuICBpc09wZW46IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb24gPSBzdHlsZWQuZGl2PFN0eWxlZE5hdlNlY3Rpb25Qcm9wcz4oXG4gICh7IHRoZW1lLCBpc09wZW4gfSkgPT4gKHtcbiAgICBkaXNwbGF5OiBcImZsZXhcIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnNtLFxuICAgIHBhZGRpbmc6IGAwICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGNvbG9yOiBnZXROYXZUZXh0Q29sb3IodGhlbWUsIGZhbHNlLCBmYWxzZSwgdHJ1ZSksXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICAgIFwiJjpub3QoOmZpcnN0LW9mLXR5cGUpXCI6IHtcbiAgICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gICAgfSxcbiAgICAuLi4oaXNPcGVuID8geyBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MjUgfSA6IHt9KSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgIH0sXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb3BOYXZMaW5rQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBtYXJnaW5SaWdodDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgXCImOm5vdCg6Zmlyc3Qtb2YtdHlwZSlcIjoge1xuICAgIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG4gIH0sXG59KSlcblxuLy8gVGhpcyBpcyBzcGVjaWZpY2FsbHkgZm9yIHVzZSBpbiBUb3BOYXZTZWN0aW9uJ3MgcG9wb3ZlciBtZW51XG5leHBvcnQgY29uc3QgU3R5bGVkVG9wTmF2U2lkZWJhck5hdkxpbmtDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIGl0ZW0gbWFyZ2lucyAoeHMgZnJvbSBlZGdlKVxuICBtYXJnaW46IGAke3RoZW1lLnNwYWNpbmcubm9uZX0gJHt0aGVtZS5zcGFjaW5nLnhzfWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE5hdlNlY3Rpb25UZXh0ID0gc3R5bGVkLnNwYW4oKCkgPT4gKHtcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkU2VjdGlvbk5hbWUgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luQm90dG9tOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkUG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIC8vIE1hdGNoIGRyb3Bkb3duIHZlcnRpY2FsIHBhZGRpbmcgKHR3b1hTIHRvcC9ib3R0b20pXG4gIHBhZGRpbmc6IGAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuc3BhY2luZy5ub25lfWAsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEljb25Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIG1hcmdpbkxlZnQ6IHRoZW1lLnNwYWNpbmcudHdvWFMsXG59KSlcblxuLyogZXNsaW50LWRpc2FibGUgc3RyZWFtbGl0LWN1c3RvbS9uby1oYXJkY29kZWQtdGhlbWUtdmFsdWVzICovXG4vLyBWaXN1YWxseSBoaWRkZW4gYnV0IGFjY2Vzc2libGUgdG8gc2NyZWVuIHJlYWRlcnNcbi8vIFVzZXMgc3RhbmRhcmQgQ1NTIHZpc3VhbGx5LWhpZGRlbiBwYXR0ZXJuIChoYXJkY29kZWQgdmFsdWVzIHJlcXVpcmVkKVxuZXhwb3J0IGNvbnN0IFN0eWxlZFZpc3VhbGx5SGlkZGVuID0gc3R5bGVkLnNwYW4oe1xuICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICB3aWR0aDogXCIxcHhcIixcbiAgaGVpZ2h0OiBcIjFweFwiLFxuICBwYWRkaW5nOiAwLFxuICBtYXJnaW46IFwiLTFweFwiLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgY2xpcDogXCJyZWN0KDAsIDAsIDAsIDApXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGJvcmRlcjogMCxcbn0pXG4vKiBlc2xpbnQtZW5hYmxlIHN0cmVhbWxpdC1jdXN0b20vbm8taGFyZGNvZGVkLXRoZW1lLXZhbHVlcyAqL1xuIl19 */"), StyledVisuallyHidden = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e10lwvl90"
} : {
  target: "e10lwvl90",
  label: "StyledVisuallyHidden"
})(process.env.NODE_ENV === "production" ? {
  name: "1dja9su",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0"
} : {
  name: "1dja9su",
  styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
}), SidebarNavLink = ({
  isActive: CA,
  pageUrl: gA,
  icon: AA,
  onClick: IA,
  isTopNav: BA,
  isInDropdown: QA,
  children: EA,
  widgetsDisabled: iA,
  isExternal: oA,
  externalUrl: cA
}) => {
  const tA = useEmotionTheme(), eA = iA;
  let aA;
  BA && QA ? aA = "stTopNavDropdownLink" : BA ? aA = "stTopNavLink" : aA = "stSidebarNavLink";
  const GA = BA ? "stTopNavLinkContainer" : "stSidebarNavLinkContainer", lA = oA ? !1 : CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkContainer, { disabled: eA, "data-testid": GA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavLink, { "data-testid": aA, isActive: lA, disabled: eA, href: oA ? cA ?? gA : gA, onClick: IA, "aria-current": lA ? "page" : void 0, target: oA ? "_blank" : void 0, rel: oA ? "noopener noreferrer" : void 0, children: [
    AA?.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavIcon, { isActive: lA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "base", iconValue: AA, color: !lA && isMaterialIcon(AA) ? (
      // Apply color with opacity on material icons
      // But we don't want to apply opacity on emoji icons
      tA.colors.fadedText60
    ) : tA.colors.bodyText }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarLinkText, { isActive: lA, disabled: eA, isTopNav: BA, label: EA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: EA, allowHTML: !1, isLabel: !0, disableLinks: !0, truncate: !0, inheritFont: !0 }) }),
    oA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledVisuallyHidden, { children: "(opens in new tab)" })
  ] }) });
};
function getExternalPageUrl(CA) {
  return CA.externalUrl ?? void 0;
}
function isExternalPage(CA) {
  return !isNullOrUndefined$1(CA.externalUrl);
}
function shouldShowNavigation(CA) {
  return filterVisiblePages(CA).length > 1;
}
function groupPagesBySection(CA) {
  return groupBy(CA, (gA) => gA.sectionHeader || "");
}
function hasNonEmptySections(CA) {
  return Object.keys(CA).some((gA) => gA !== "");
}
function processNavigationStructure(CA) {
  if (!hasNonEmptySections(CA))
    return {
      individualPages: Object.values(CA).flat(),
      sections: {}
    };
  const AA = CA[""] || [], IA = {};
  return Object.entries(CA).forEach(([BA, QA]) => {
    BA && (IA[BA] = QA);
  }), {
    individualPages: AA,
    sections: IA
  };
}
function filterVisiblePages(CA) {
  return CA.filter((gA) => !gA.isHidden);
}
const TopNavSection = ({
  title: CA,
  sections: gA,
  handlePageChange: AA,
  endpoints: IA,
  pageLinkBaseUrl: BA,
  currentPageScriptHash: QA,
  hideChevron: EA = !1,
  widgetsDisabled: iA
}) => {
  const [oA, cA] = useState(!1), tA = useEmotionTheme(), eA = gA.length > 1;
  return isNullOrUndefined$1(gA) || gA.length === 0 || gA[0].length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    Popover$2,
    {
      triggerType: TRIGGER_TYPE.click,
      placement: PLACEMENT.bottomLeft,
      content: () => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPopoverContent, { "data-testid": "stTopNavPopover", children: gA.map((aA, GA) => {
        const lA = aA[0].sectionHeader;
        return aA.map((nA, DA) => {
          const hA = isExternalPage(nA), wA = (NA) => {
            if (hA) {
              cA(!1);
              return;
            }
            NA.preventDefault(), nA.pageScriptHash && AA(nA.pageScriptHash), cA(!1);
          }, sA = String(nA.pageName || "");
          return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
            DA === 0 && eA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSectionName, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: lA || "", allowHTML: !1, isLabel: !0, disableLinks: !0, truncate: !0, inheritFont: !0 }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavSidebarNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { icon: nA.icon || null, isTopNav: !0, isInDropdown: !0, isActive: QA === nA.pageScriptHash, onClick: wA, pageUrl: IA.buildAppPageURL(BA, nA), widgetsDisabled: iA, isExternal: hA, externalUrl: getExternalPageUrl(nA), children: sA }) })
          ] }, `${nA.pageScriptHash}-${sA}`);
        });
      }) }),
      isOpen: oA,
      onClickOutside: () => cA(!1),
      onClick: () => oA ? cA(!1) : void 0,
      onEsc: () => cA(!1),
      renderAll: !0,
      popoverMargin: convertRemToPx(tA.spacing.twoXS),
      overrides: {
        Body: {
          style: () => ({
            ...getPopoverContainerStyle(tA),
            marginRight: tA.spacing.lg,
            marginBottom: tA.spacing.lg,
            maxHeight: "70vh",
            minWidth: "8rem",
            overflow: "auto",
            maxWidth: `calc(${tA.sizes.contentMaxWidth} - 2*${tA.spacing.lg})`,
            [`@media (max-width: ${tA.breakpoints.sm})`]: {
              maxWidth: `calc(100% - ${tA.spacing.threeXL})`
            }
          })
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSection, { tabIndex: 0, onClick: () => cA(!oA), isOpen: oA, "data-testid": "stTopNavSection", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: CA, allowHTML: !1, isLabel: !0, disableLinks: !0, truncate: !0, inheritFont: !0 }) }),
        !EA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: oA ? KeyboardArrowUp : KeyboardArrowDown, size: "lg" }) })
      ] }) })
    }
  );
}, TopNav = ({
  endpoints: CA,
  widgetsDisabled: gA
}) => {
  const {
    pageLinkBaseUrl: AA,
    currentPageScriptHash: IA,
    appPages: BA,
    onPageChange: QA
  } = useContext(NavigationContext), EA = useMemo$1(() => filterVisiblePages(BA), [BA]), {
    data: iA,
    itemKey: oA
  } = useMemo$1(() => {
    const eA = groupPagesBySection(EA), aA = processNavigationStructure(eA);
    return {
      data: [...aA.individualPages, ...Object.values(aA.sections)],
      itemKey: (nA) => Array.isArray(nA) ? nA[0]?.sectionHeader ?? "" : nA.pageScriptHash ?? ""
    };
  }, [EA]), cA = useCallback((eA, aA) => {
    if (Array.isArray(eA))
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { sections: [eA], title: eA[0].sectionHeader || "", handlePageChange: QA, endpoints: CA, pageLinkBaseUrl: AA, currentPageScriptHash: IA, widgetsDisabled: gA });
    const GA = isExternalPage(eA);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTopNavLinkContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isTopNav: !0, isInDropdown: !1, isActive: IA === eA.pageScriptHash, icon: eA.icon, pageUrl: CA.buildAppPageURL(AA, eA), onClick: (lA) => {
      GA || (lA.preventDefault(), eA.pageScriptHash && QA(eA.pageScriptHash));
    }, widgetsDisabled: gA, isExternal: GA, externalUrl: getExternalPageUrl(eA), children: String(eA.pageName) }) });
  }, [QA, CA, AA, IA, gA]), tA = useCallback((eA) => {
    if (isNullOrUndefined$1(eA))
      return null;
    const GA = `${eA.flat().length} more`, lA = eA.map((nA) => Array.isArray(nA) ? nA : [nA]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(TopNavSection, { hideChevron: !0, sections: lA, title: GA, handlePageChange: QA, endpoints: CA, pageLinkBaseUrl: AA, currentPageScriptHash: IA, widgetsDisabled: gA });
  }, [QA, CA, AA, IA, gA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ForwardOverflow, { component: StyledOverflowContainer, itemKey: oA, data: iA, maxCount: "responsive", renderItem: cA, renderRest: tA });
};
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(CA) {
    for (var gA, AA = 1, IA = arguments.length; AA < IA; AA++) {
      gA = arguments[AA];
      for (var BA in gA) Object.prototype.hasOwnProperty.call(gA, BA) && (CA[BA] = gA[BA]);
    }
    return CA;
  }, __assign$1.apply(this, arguments);
}, rowSizeBase = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, colSizeBase = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, edgeBase = {
  width: "20px",
  height: "20px",
  position: "absolute",
  zIndex: 1
}, styles = {
  top: __assign$1(__assign$1({}, rowSizeBase), { top: "-5px" }),
  right: __assign$1(__assign$1({}, colSizeBase), { left: void 0, right: "-5px" }),
  bottom: __assign$1(__assign$1({}, rowSizeBase), { top: void 0, bottom: "-5px" }),
  left: __assign$1(__assign$1({}, colSizeBase), { left: "-5px" }),
  topRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: __assign$1(__assign$1({}, edgeBase), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: __assign$1(__assign$1({}, edgeBase), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, Resizer = memo(function(CA) {
  var gA = CA.onResizeStart, AA = CA.direction, IA = CA.children, BA = CA.replaceStyles, QA = CA.className, EA = useCallback(function(cA) {
    gA(cA, AA);
  }, [gA, AA]), iA = useCallback(function(cA) {
    gA(cA, AA);
  }, [gA, AA]), oA = useMemo$1(function() {
    return __assign$1(__assign$1({ position: "absolute", userSelect: "none" }, styles[AA]), BA ?? {});
  }, [BA, AA]);
  return jsxRuntimeExports.jsx("div", { className: QA || void 0, style: oA, onMouseDown: EA, onTouchStart: iA, children: IA });
}), __extends = /* @__PURE__ */ (function() {
  var CA = function(gA, AA) {
    return CA = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(IA, BA) {
      IA.__proto__ = BA;
    } || function(IA, BA) {
      for (var QA in BA) Object.prototype.hasOwnProperty.call(BA, QA) && (IA[QA] = BA[QA]);
    }, CA(gA, AA);
  };
  return function(gA, AA) {
    if (typeof AA != "function" && AA !== null)
      throw new TypeError("Class extends value " + String(AA) + " is not a constructor or null");
    CA(gA, AA);
    function IA() {
      this.constructor = gA;
    }
    gA.prototype = AA === null ? Object.create(AA) : (IA.prototype = AA.prototype, new IA());
  };
})(), __assign = function() {
  return __assign = Object.assign || function(CA) {
    for (var gA, AA = 1, IA = arguments.length; AA < IA; AA++) {
      gA = arguments[AA];
      for (var BA in gA) Object.prototype.hasOwnProperty.call(gA, BA) && (CA[BA] = gA[BA]);
    }
    return CA;
  }, __assign.apply(this, arguments);
}, DEFAULT_SIZE = {
  width: "auto",
  height: "auto"
}, clamp = function(CA, gA, AA) {
  return Math.max(Math.min(CA, AA), gA);
}, snap = function(CA, gA, AA) {
  var IA = Math.round(CA / gA);
  return IA * gA + AA * (IA - 1);
}, hasDirection = function(CA, gA) {
  return new RegExp(CA, "i").test(gA);
}, isTouchEvent = function(CA) {
  return !!(CA.touches && CA.touches.length);
}, isMouseEvent = function(CA) {
  return !!((CA.clientX || CA.clientX === 0) && (CA.clientY || CA.clientY === 0));
}, findClosestSnap = function(CA, gA, AA) {
  AA === void 0 && (AA = 0);
  var IA = gA.reduce(function(QA, EA, iA) {
    return Math.abs(EA - CA) < Math.abs(gA[QA] - CA) ? iA : QA;
  }, 0), BA = Math.abs(gA[IA] - CA);
  return AA === 0 || BA < AA ? gA[IA] : CA;
}, getStringSize = function(CA) {
  return CA = CA.toString(), CA === "auto" || CA.endsWith("px") || CA.endsWith("%") || CA.endsWith("vh") || CA.endsWith("vw") || CA.endsWith("vmax") || CA.endsWith("vmin") ? CA : "".concat(CA, "px");
}, getPixelSize = function(CA, gA, AA, IA) {
  if (CA && typeof CA == "string") {
    if (CA.endsWith("px"))
      return Number(CA.replace("px", ""));
    if (CA.endsWith("%")) {
      var BA = Number(CA.replace("%", "")) / 100;
      return gA * BA;
    }
    if (CA.endsWith("vw")) {
      var BA = Number(CA.replace("vw", "")) / 100;
      return AA * BA;
    }
    if (CA.endsWith("vh")) {
      var BA = Number(CA.replace("vh", "")) / 100;
      return IA * BA;
    }
  }
  return CA;
}, calculateNewMax = function(CA, gA, AA, IA, BA, QA, EA) {
  return IA = getPixelSize(IA, CA.width, gA, AA), BA = getPixelSize(BA, CA.height, gA, AA), QA = getPixelSize(QA, CA.width, gA, AA), EA = getPixelSize(EA, CA.height, gA, AA), {
    maxWidth: typeof IA > "u" ? void 0 : Number(IA),
    maxHeight: typeof BA > "u" ? void 0 : Number(BA),
    minWidth: typeof QA > "u" ? void 0 : Number(QA),
    minHeight: typeof EA > "u" ? void 0 : Number(EA)
  };
}, normalizeToPair = function(CA) {
  return Array.isArray(CA) ? CA : [CA, CA];
}, definedProps = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], baseClassName = "__resizable_base__", Resizable = (
  /** @class */
  (function(CA) {
    __extends(gA, CA);
    function gA(AA) {
      var IA, BA, QA, EA, iA = CA.call(this, AA) || this;
      return iA.ratio = 1, iA.resizable = null, iA.parentLeft = 0, iA.parentTop = 0, iA.resizableLeft = 0, iA.resizableRight = 0, iA.resizableTop = 0, iA.resizableBottom = 0, iA.targetLeft = 0, iA.targetTop = 0, iA.delta = {
        width: 0,
        height: 0
      }, iA.appendBase = function() {
        if (!iA.resizable || !iA.window)
          return null;
        var oA = iA.parentNode;
        if (!oA)
          return null;
        var cA = iA.window.document.createElement("div");
        return cA.style.width = "100%", cA.style.height = "100%", cA.style.position = "absolute", cA.style.transform = "scale(0, 0)", cA.style.left = "0", cA.style.flex = "0 0 100%", cA.classList ? cA.classList.add(baseClassName) : cA.className += baseClassName, oA.appendChild(cA), cA;
      }, iA.removeBase = function(oA) {
        var cA = iA.parentNode;
        cA && cA.removeChild(oA);
      }, iA.state = {
        isResizing: !1,
        width: (BA = (IA = iA.propsSize) === null || IA === void 0 ? void 0 : IA.width) !== null && BA !== void 0 ? BA : "auto",
        height: (EA = (QA = iA.propsSize) === null || QA === void 0 ? void 0 : QA.height) !== null && EA !== void 0 ? EA : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, iA.onResizeStart = iA.onResizeStart.bind(iA), iA.onMouseMove = iA.onMouseMove.bind(iA), iA.onMouseUp = iA.onMouseUp.bind(iA), iA;
    }
    return Object.defineProperty(gA.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(gA.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(gA.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(gA.prototype, "size", {
      get: function() {
        var AA = 0, IA = 0;
        if (this.resizable && this.window) {
          var BA = this.resizable.offsetWidth, QA = this.resizable.offsetHeight, EA = this.resizable.style.position;
          EA !== "relative" && (this.resizable.style.position = "relative"), AA = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : BA, IA = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : QA, this.resizable.style.position = EA;
        }
        return { width: AA, height: IA };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(gA.prototype, "sizeStyle", {
      get: function() {
        var AA = this, IA = this.props.size, BA = function(iA) {
          var oA;
          if (typeof AA.state[iA] > "u" || AA.state[iA] === "auto")
            return "auto";
          if (AA.propsSize && AA.propsSize[iA] && (!((oA = AA.propsSize[iA]) === null || oA === void 0) && oA.toString().endsWith("%"))) {
            if (AA.state[iA].toString().endsWith("%"))
              return AA.state[iA].toString();
            var cA = AA.getParentSize(), tA = Number(AA.state[iA].toString().replace("px", "")), eA = tA / cA[iA] * 100;
            return "".concat(eA, "%");
          }
          return getStringSize(AA.state[iA]);
        }, QA = IA && typeof IA.width < "u" && !this.state.isResizing ? getStringSize(IA.width) : BA("width"), EA = IA && typeof IA.height < "u" && !this.state.isResizing ? getStringSize(IA.height) : BA("height");
        return { width: QA, height: EA };
      },
      enumerable: !1,
      configurable: !0
    }), gA.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var AA = this.appendBase();
      if (!AA)
        return { width: 0, height: 0 };
      var IA = !1, BA = this.parentNode.style.flexWrap;
      BA !== "wrap" && (IA = !0, this.parentNode.style.flexWrap = "wrap"), AA.style.position = "relative", AA.style.minWidth = "100%", AA.style.minHeight = "100%";
      var QA = {
        width: AA.offsetWidth,
        height: AA.offsetHeight
      };
      return IA && (this.parentNode.style.flexWrap = BA), this.removeBase(AA), QA;
    }, gA.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, gA.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, gA.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var AA = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: AA.flexBasis !== "auto" ? AA.flexBasis : void 0
        });
      }
    }, gA.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, gA.prototype.createSizeForCssProperty = function(AA, IA) {
      var BA = this.propsSize && this.propsSize[IA];
      return this.state[IA] === "auto" && this.state.original[IA] === AA && (typeof BA > "u" || BA === "auto") ? "auto" : AA;
    }, gA.prototype.calculateNewMaxFromBoundary = function(AA, IA) {
      var BA = this.props.boundsByDirection, QA = this.state.direction, EA = BA && hasDirection("left", QA), iA = BA && hasDirection("top", QA), oA, cA;
      if (this.props.bounds === "parent") {
        var tA = this.parentNode;
        tA && (oA = EA ? this.resizableRight - this.parentLeft : tA.offsetWidth + (this.parentLeft - this.resizableLeft), cA = iA ? this.resizableBottom - this.parentTop : tA.offsetHeight + (this.parentTop - this.resizableTop));
      } else this.props.bounds === "window" ? this.window && (oA = EA ? this.resizableRight : this.window.innerWidth - this.resizableLeft, cA = iA ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (oA = EA ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), cA = iA ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return oA && Number.isFinite(oA) && (AA = AA && AA < oA ? AA : oA), cA && Number.isFinite(cA) && (IA = IA && IA < cA ? IA : cA), { maxWidth: AA, maxHeight: IA };
    }, gA.prototype.calculateNewSizeFromDirection = function(AA, IA) {
      var BA = this.props.scale || 1, QA = normalizeToPair(this.props.resizeRatio || 1), EA = QA[0], iA = QA[1], oA = this.state, cA = oA.direction, tA = oA.original, eA = this.props, aA = eA.lockAspectRatio, GA = eA.lockAspectRatioExtraHeight, lA = eA.lockAspectRatioExtraWidth, nA = tA.width, DA = tA.height, hA = GA || 0, wA = lA || 0;
      return hasDirection("right", cA) && (nA = tA.width + (AA - tA.x) * EA / BA, aA && (DA = (nA - wA) / this.ratio + hA)), hasDirection("left", cA) && (nA = tA.width - (AA - tA.x) * EA / BA, aA && (DA = (nA - wA) / this.ratio + hA)), hasDirection("bottom", cA) && (DA = tA.height + (IA - tA.y) * iA / BA, aA && (nA = (DA - hA) * this.ratio + wA)), hasDirection("top", cA) && (DA = tA.height - (IA - tA.y) * iA / BA, aA && (nA = (DA - hA) * this.ratio + wA)), { newWidth: nA, newHeight: DA };
    }, gA.prototype.calculateNewSizeFromAspectRatio = function(AA, IA, BA, QA) {
      var EA = this.props, iA = EA.lockAspectRatio, oA = EA.lockAspectRatioExtraHeight, cA = EA.lockAspectRatioExtraWidth, tA = typeof QA.width > "u" ? 10 : QA.width, eA = typeof BA.width > "u" || BA.width < 0 ? AA : BA.width, aA = typeof QA.height > "u" ? 10 : QA.height, GA = typeof BA.height > "u" || BA.height < 0 ? IA : BA.height, lA = oA || 0, nA = cA || 0;
      if (iA) {
        var DA = (aA - lA) * this.ratio + nA, hA = (GA - lA) * this.ratio + nA, wA = (tA - nA) / this.ratio + lA, sA = (eA - nA) / this.ratio + lA, NA = Math.max(tA, DA), rA = Math.min(eA, hA), yA = Math.max(aA, wA), bA = Math.min(GA, sA);
        AA = clamp(AA, NA, rA), IA = clamp(IA, yA, bA);
      } else
        AA = clamp(AA, tA, eA), IA = clamp(IA, aA, GA);
      return { newWidth: AA, newHeight: IA };
    }, gA.prototype.setBoundingClientRect = function() {
      var AA = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var IA = this.parentNode;
        if (IA) {
          var BA = IA.getBoundingClientRect();
          this.parentLeft = BA.left * AA, this.parentTop = BA.top * AA;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var QA = this.props.bounds.getBoundingClientRect();
        this.targetLeft = QA.left * AA, this.targetTop = QA.top * AA;
      }
      if (this.resizable) {
        var EA = this.resizable.getBoundingClientRect(), iA = EA.left, oA = EA.top, cA = EA.right, tA = EA.bottom;
        this.resizableLeft = iA * AA, this.resizableRight = cA * AA, this.resizableTop = oA * AA, this.resizableBottom = tA * AA;
      }
    }, gA.prototype.onResizeStart = function(AA, IA) {
      if (!(!this.resizable || !this.window)) {
        var BA = 0, QA = 0;
        if (AA.nativeEvent && isMouseEvent(AA.nativeEvent) ? (BA = AA.nativeEvent.clientX, QA = AA.nativeEvent.clientY) : AA.nativeEvent && isTouchEvent(AA.nativeEvent) && (BA = AA.nativeEvent.touches[0].clientX, QA = AA.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var EA = this.props.onResizeStart(AA, IA, this.resizable);
          if (EA === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var iA, oA = this.window.getComputedStyle(this.resizable);
        if (oA.flexBasis !== "auto") {
          var cA = this.parentNode;
          if (cA) {
            var tA = this.window.getComputedStyle(cA).flexDirection;
            this.flexDir = tA.startsWith("row") ? "row" : "column", iA = oA.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var eA = {
          original: {
            x: BA,
            y: QA,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(AA.target).cursor || "auto" }),
          direction: IA,
          flexBasis: iA
        };
        this.setState(eA);
      }
    }, gA.prototype.onMouseMove = function(AA) {
      var IA = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && isTouchEvent(AA))
          try {
            AA.preventDefault(), AA.stopPropagation();
          } catch {
          }
        var BA = this.props, QA = BA.maxWidth, EA = BA.maxHeight, iA = BA.minWidth, oA = BA.minHeight, cA = isTouchEvent(AA) ? AA.touches[0].clientX : AA.clientX, tA = isTouchEvent(AA) ? AA.touches[0].clientY : AA.clientY, eA = this.state, aA = eA.direction, GA = eA.original, lA = eA.width, nA = eA.height, DA = this.getParentSize(), hA = calculateNewMax(DA, this.window.innerWidth, this.window.innerHeight, QA, EA, iA, oA);
        QA = hA.maxWidth, EA = hA.maxHeight, iA = hA.minWidth, oA = hA.minHeight;
        var wA = this.calculateNewSizeFromDirection(cA, tA), sA = wA.newHeight, NA = wA.newWidth, rA = this.calculateNewMaxFromBoundary(QA, EA);
        this.props.snap && this.props.snap.x && (NA = findClosestSnap(NA, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (sA = findClosestSnap(sA, this.props.snap.y, this.props.snapGap));
        var yA = this.calculateNewSizeFromAspectRatio(NA, sA, { width: rA.maxWidth, height: rA.maxHeight }, { width: iA, height: oA });
        if (NA = yA.newWidth, sA = yA.newHeight, this.props.grid) {
          var bA = snap(NA, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), RA = snap(sA, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), FA = this.props.snapGap || 0, dA = FA === 0 || Math.abs(bA - NA) <= FA ? bA : NA, kA = FA === 0 || Math.abs(RA - sA) <= FA ? RA : sA;
          NA = dA, sA = kA;
        }
        var pA = {
          width: NA - GA.width,
          height: sA - GA.height
        };
        if (this.delta = pA, lA && typeof lA == "string") {
          if (lA.endsWith("%")) {
            var YA = NA / DA.width * 100;
            NA = "".concat(YA, "%");
          } else if (lA.endsWith("vw")) {
            var SA = NA / this.window.innerWidth * 100;
            NA = "".concat(SA, "vw");
          } else if (lA.endsWith("vh")) {
            var JA = NA / this.window.innerHeight * 100;
            NA = "".concat(JA, "vh");
          }
        }
        if (nA && typeof nA == "string") {
          if (nA.endsWith("%")) {
            var YA = sA / DA.height * 100;
            sA = "".concat(YA, "%");
          } else if (nA.endsWith("vw")) {
            var SA = sA / this.window.innerWidth * 100;
            sA = "".concat(SA, "vw");
          } else if (nA.endsWith("vh")) {
            var JA = sA / this.window.innerHeight * 100;
            sA = "".concat(JA, "vh");
          }
        }
        var UA = {
          width: this.createSizeForCssProperty(NA, "width"),
          height: this.createSizeForCssProperty(sA, "height")
        };
        this.flexDir === "row" ? UA.flexBasis = UA.width : this.flexDir === "column" && (UA.flexBasis = UA.height);
        var fA = this.state.width !== UA.width, zA = this.state.height !== UA.height, _A = this.state.flexBasis !== UA.flexBasis, uA = fA || zA || _A;
        uA && flushSync(function() {
          IA.setState(UA);
        }), this.props.onResize && uA && this.props.onResize(AA, aA, this.resizable, pA);
      }
    }, gA.prototype.onMouseUp = function(AA) {
      var IA, BA, QA = this.state, EA = QA.isResizing, iA = QA.direction;
      QA.original, !(!EA || !this.resizable) && (this.props.onResizeStop && this.props.onResizeStop(AA, iA, this.resizable, this.delta), this.props.size && this.setState({ width: (IA = this.props.size.width) !== null && IA !== void 0 ? IA : "auto", height: (BA = this.props.size.height) !== null && BA !== void 0 ? BA : "auto" }), this.unbindEvents(), this.setState({
        isResizing: !1,
        backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: "auto" })
      }));
    }, gA.prototype.updateSize = function(AA) {
      var IA, BA;
      this.setState({ width: (IA = AA.width) !== null && IA !== void 0 ? IA : "auto", height: (BA = AA.height) !== null && BA !== void 0 ? BA : "auto" });
    }, gA.prototype.renderResizer = function() {
      var AA = this, IA = this.props, BA = IA.enable, QA = IA.handleStyles, EA = IA.handleClasses, iA = IA.handleWrapperStyle, oA = IA.handleWrapperClass, cA = IA.handleComponent;
      if (!BA)
        return null;
      var tA = Object.keys(BA).map(function(eA) {
        return BA[eA] !== !1 ? jsxRuntimeExports.jsx(Resizer, { direction: eA, onResizeStart: AA.onResizeStart, replaceStyles: QA && QA[eA], className: EA && EA[eA], children: cA && cA[eA] ? cA[eA] : null }, eA) : null;
      });
      return jsxRuntimeExports.jsx("div", { className: oA, style: iA, children: tA });
    }, gA.prototype.render = function() {
      var AA = this, IA = Object.keys(this.props).reduce(function(EA, iA) {
        return definedProps.indexOf(iA) !== -1 || (EA[iA] = AA.props[iA]), EA;
      }, {}), BA = __assign(__assign(__assign({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (BA.flexBasis = this.state.flexBasis);
      var QA = this.props.as || "div";
      return jsxRuntimeExports.jsxs(QA, __assign({ style: BA, className: this.props.className }, IA, {
        // `ref` is after `extendsProps` to ensure this one wins over a version
        // passed in
        ref: function(EA) {
          EA && (AA.resizable = EA);
        },
        children: [this.state.isResizing && jsxRuntimeExports.jsx("div", { style: this.state.backgroundStyle }), this.props.children, this.renderResizer()]
      }));
    }, gA.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, gA;
  })(PureComponent)
);
const NavSection = ({
  header: CA = "",
  children: gA,
  isExpanded: AA,
  onToggle: IA
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledNavSectionContainer, { children: [
  CA && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavSectionHeader, { "data-testid": "stNavSectionHeader", onClick: IA, isExpanded: AA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNavSectionHeaderText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: CA, allowHTML: !1, isLabel: !0, disableLinks: !0, truncate: !0, inheritFont: !0 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledChevronContainer, { isExpanded: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: ":material/expand_more:", size: "lg" }) })
  ] }),
  AA && gA
] }), NUM_PAGES_TO_SHOW_WHEN_COLLAPSED = 10, LOG$6 = loglevelExports.getLogger("SidebarNav");
function NavLink({
  pageUrl: CA,
  page: gA,
  isActive: AA,
  onClick: IA,
  widgetsDisabled: BA
}) {
  const QA = gA.pageName;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavLinkListItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNavLink, { isActive: AA, pageUrl: CA, icon: gA.icon, onClick: IA, widgetsDisabled: BA, isExternal: isExternalPage(gA), externalUrl: getExternalPageUrl(gA), children: QA }) });
}
function generateNavSections(CA, gA, AA, IA, BA, QA, EA) {
  const iA = [];
  let oA = QA;
  return Object.entries(CA).forEach(([cA, tA]) => {
    const eA = [...tA];
    let aA = eA;
    const GA = IA[cA];
    if (gA) {
      const lA = EA - oA;
      lA <= 0 ? aA = [] : eA.length > lA && (aA = eA.slice(0, lA));
    }
    GA && (oA += aA.length), aA.length > 0 && iA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(NavSection, { header: cA, isExpanded: GA, onToggle: () => BA(cA), children: aA.map(AA) }, cA));
  }), {
    sections: iA,
    updatedPageCount: oA
  };
}
const SidebarNav = ({
  endpoints: CA,
  collapseSidebar: gA,
  hasSidebarElements: AA,
  widgetsDisabled: IA
}) => {
  const [BA, QA] = useState(!1), {
    expandSidebarNav: EA,
    sidebarNavVisibleItems: iA
  } = useContext(SidebarConfigContext), {
    pageLinkBaseUrl: oA,
    appPages: cA,
    onPageChange: tA,
    currentPageScriptHash: eA
  } = useContext(NavigationContext), aA = notNullOrUndefined(iA) && iA > 0 ? iA : NUM_PAGES_TO_SHOW_WHEN_COLLAPSED, GA = aA + 2, lA = `stSidebarSectionsState-${oA}`, [nA, DA] = useState(null), hA = useMemo$1(() => filterVisiblePages(cA), [cA]), wA = useMemo$1(() => processNavigationStructure(groupPagesBySection(hA)), [hA]), sA = useMemo$1(() => {
    if (!(Object.keys(wA.sections).length > 0))
      return hA.length;
    let pA = wA.individualPages.length;
    return Object.entries(wA.sections).forEach(([YA, SA]) => {
      nA?.[YA] && (pA += SA.length);
    }), pA;
  }, [hA.length, nA, wA]);
  useEffect(() => {
    const kA = localStorageAvailable() && window.localStorage.getItem("sidebarNavState") === "expanded";
    !BA && (EA || kA) && QA(!0);
  }, [BA, EA]), useEffect(() => {
    let kA = {};
    if (localStorageAvailable()) {
      const YA = window.localStorage.getItem(lA);
      if (YA)
        try {
          kA = JSON.parse(YA);
        } catch (SA) {
          LOG$6.warn("Could not parse sidebar nav state from localStorage", SA);
        }
    }
    const pA = Object.keys(wA.sections).reduce((YA, SA) => (YA[SA] = kA[SA] ?? !0, YA), {});
    DA(pA);
  }, [wA.sections, lA]), useEffect(() => {
    localStorageAvailable() && nA && window.localStorage.setItem(lA, JSON.stringify(nA));
  }, [nA, lA]);
  const NA = useCallback((kA) => {
    DA((pA) => pA ? {
      ...pA,
      [kA]: !pA[kA]
    } : null);
  }, []), rA = useCallback(() => {
    const kA = !BA;
    localStorageAvailable() && (kA ? window.localStorage.setItem("sidebarNavState", "expanded") : window.localStorage.removeItem("sidebarNavState")), QA(kA);
  }, [BA]), yA = useCallback((kA, pA) => {
    const YA = CA.buildAppPageURL(oA, kA), SA = kA.pageScriptHash === eA, JA = isExternalPage(kA);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(NavLink, { pageUrl: YA, page: kA, isActive: SA, onClick: (UA) => {
      if (JA) {
        isMobile() && gA();
        return;
      }
      UA.preventDefault(), tA(kA.pageScriptHash), isMobile() && gA();
    }, widgetsDisabled: IA }, `${kA.pageName}-${pA}`);
  }, [gA, eA, CA, tA, oA, IA]);
  if (!nA)
    return null;
  const bA = [], RA = AA && sA > GA && !EA, FA = RA && !BA;
  let dA = 0;
  if (wA.individualPages.length > 0) {
    const kA = FA ? wA.individualPages.slice(0, aA) : wA.individualPages;
    bA.push(...kA.map(yA)), dA += kA.length;
  }
  if (Object.keys(wA.sections).length > 0) {
    const kA = generateNavSections(wA.sections, FA, yA, nA, NA, dA, aA);
    bA.push(...kA.sections);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarNavContainer, { "data-testid": "stSidebarNav", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavItems, { "data-testid": "stSidebarNavItems", children: bA }),
    RA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledViewButton, { onClick: rA, "data-testid": "stSidebarNavViewButton", children: BA ? "View less" : `View ${sA - aA} more` }),
    AA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarNavSeparator, { "data-testid": "stSidebarNavSeparator" })
  ] });
}, DEFAULT_WIDTH = "300";
function shouldCollapse(CA, gA, AA) {
  switch (CA) {
    case PageConfig.SidebarState.EXPANDED:
      return !1;
    case PageConfig.SidebarState.COLLAPSED:
      return !0;
    case PageConfig.SidebarState.AUTO:
    default:
      return AA <= gA;
  }
}
const getSidebarCollapsedKey = (CA) => `stSidebarCollapsed-${CA}`, getSavedSidebarState = (CA) => {
  if (!localStorageAvailable())
    return null;
  const gA = window.localStorage.getItem(getSidebarCollapsedKey(CA));
  return gA === null ? null : gA === "true";
}, saveSidebarState = (CA, gA) => {
  localStorageAvailable() && window.localStorage.setItem(getSidebarCollapsedKey(CA), gA.toString());
};
function clampSidebarWidth(CA) {
  return Number.isNaN(CA) ? Number.parseInt(DEFAULT_WIDTH, 10) : Math.min(600, Math.max(200, CA));
}
function calculateMaxBreakpoint(CA) {
  return parseInt(CA, 10) - 0.02;
}
const Sidebar = ({
  endpoints: CA,
  children: gA,
  hasElements: AA,
  isCollapsed: IA,
  onToggleCollapse: BA,
  widgetsDisabled: QA
}) => {
  const EA = useEmotionTheme(), iA = calculateMaxBreakpoint(EA.breakpoints.md), {
    innerWidth: oA
  } = useWindowDimensionsContext(), {
    appPages: cA
  } = useContext(NavigationContext), {
    hideSidebarNav: tA,
    appLogo: eA,
    initialSidebarWidth: aA,
    appRootRef: GA
  } = useContext(SidebarConfigContext), lA = useScrollbarGutterSize(), nA = useRef(null), DA = localStorageAvailable() ? window.localStorage.getItem("sidebarWidth") : void 0, [hA, wA] = useState(() => {
    const UA = (() => {
      if (DA) {
        const fA = Number.parseInt(DA, 10);
        return Number.isNaN(fA) ? null : clampSidebarWidth(fA).toString();
      }
      return null;
    })();
    return UA || (notNullOrUndefined(aA) ? clampSidebarWidth(aA).toString() : DEFAULT_WIDTH);
  }), [sA, NA] = useState(oA ?? 1 / 0), [rA, yA] = useState(!1), bA = useCallback(() => {
    yA(!0);
  }, []), RA = useCallback(() => {
    yA(!1);
  }, []), FA = useCallback((JA) => {
    const fA = clampSidebarWidth(JA).toString();
    wA(fA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", fA);
  }, []), dA = useCallback((JA, UA, fA, zA) => {
    if (fA) {
      const _A = fA.clientWidth || fA.offsetWidth;
      FA(_A);
    }
  }, [FA]);
  useExecuteWhenChanged(() => {
    oA < sA && oA <= iA && !IA && BA(!0, !1), NA(oA);
  }, [oA]), useEffect(() => {
    const JA = (UA) => {
      const fA = nA.current, zA = GA?.current, _A = UA.target;
      if (!fA || !_A)
        return;
      const uA = fA.contains(_A), HA = zA?.contains(_A) ?? !1, TA = oA <= iA;
      !uA && HA && TA && !IA && BA(!0);
    };
    return document.addEventListener("mousedown", JA), () => {
      document.removeEventListener("mousedown", JA);
    };
  }, [iA, IA, BA, oA, GA]);
  function kA() {
    const JA = notNullOrUndefined(aA) ? clampSidebarWidth(aA).toString() : DEFAULT_WIDTH;
    wA(JA), localStorageAvailable() && window.localStorage.setItem("sidebarWidth", JA);
  }
  const pA = useCallback(() => {
    BA(!IA);
  }, [IA, BA]), YA = () => eA ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: eA, endpoints: CA, collapsed: IA, componentName: "Sidebar Logo", dataTestId: "stSidebarLogo" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledNoLogoSpacer, { "data-testid": "stLogoSpacer" }), SA = shouldShowNavigation(cA) && !tA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Resizable,
    {
      className: "stSidebar",
      "data-testid": "stSidebar",
      "aria-expanded": !IA,
      enable: {
        top: !1,
        right: !0,
        bottom: !1,
        left: !1
      },
      handleStyles: {
        right: {
          width: RESIZE_HANDLE_WIDTH,
          right: "-6px"
        }
      },
      handleComponent: {
        right: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledResizeHandle, { onDoubleClick: kA })
      },
      size: {
        width: hA,
        height: "auto"
      },
      as: StyledSidebar,
      onResizeStop: dA,
      isCollapsed: IA,
      sidebarWidth: hA,
      windowInnerWidth: oA,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarContent, { "data-testid": "stSidebarContent", ref: nA, onMouseOver: bA, onMouseOut: RA, scrollbarGutterSize: lA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSidebarHeaderContainer, { "data-testid": "stSidebarHeader", children: [
          YA(),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCollapseSidebarButton, { showSidebarCollapse: rA, "data-testid": "stSidebarCollapseButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_NO_PADDING, onClick: pA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "xl", iconValue: ":material/keyboard_double_arrow_left:", color: EA.colors.fadedText60 }) }) })
        ] }),
        SA && /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarNav, { endpoints: CA, collapseSidebar: pA, hasSidebarElements: AA, widgetsDisabled: QA }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarUserContent, { hasPageNavAbove: SA, "data-testid": "stSidebarUserContent", children: gA })
      ] })
    }
  );
};
function SidebarWithProvider(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IsSidebarContext.Provider, { value: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Sidebar, { ...CA }) });
}
const ThemedSidebar = ({
  children: CA,
  ...gA
}) => {
  const {
    activeTheme: AA
  } = useContext(ThemeContext), IA = createSidebarTheme(AA);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: IA.emotion, baseuiTheme: IA.basewebTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarWithProvider, { ...gA, children: CA }) });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledAppViewContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi10"
} : {
  target: "ea3mdgi10",
  label: "StyledAppViewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}"
} : {
  name: "1yiq2ps",
  styles: "display:flex;flex-direction:row;justify-content:flex-start;align-items:stretch;align-content:flex-start;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden;@media print{overflow:visible;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledAppViewMain = /* @__PURE__ */ createStyled("section", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi9"
} : {
  target: "ea3mdgi9",
  label: "StyledAppViewMain"
})(({
  disableScrolling: CA,
  theme: gA
}) => ({
  display: "flex",
  flexDirection: "column",
  width: gA.sizes.full,
  overflow: CA ? "hidden" : "auto",
  alignItems: "center",
  height: "100dvh",
  "&:focus": {
    outline: "none"
  },
  // Added so sidebar overlays main app content on
  // smaller screen sizes, except when printing
  "@media not print": {
    [`@media (max-width: ${gA.breakpoints.md})`]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: "100dvh"
    }
  },
  "@media print": {
    // print multiple pages if app is scrollable in Safari
    overflow: "visible"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStickyBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi8"
} : {
  target: "ea3mdgi8",
  label: "StyledStickyBottomContainer"
})(({
  theme: CA
}) => ({
  position: "sticky",
  left: 0,
  bottom: 0,
  width: "100%",
  zIndex: CA.zIndices.bottom,
  // move the bottom container to the end of pages in print-mode so that nothing
  // (e.g. a floating chat-input) overlays the actual app content
  "@media print": {
    position: "static"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledInnerBottomContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi7"
} : {
  target: "ea3mdgi7",
  label: "StyledInnerBottomContainer"
})(({
  theme: CA
}) => ({
  position: "relative",
  bottom: 0,
  width: "100%",
  minWidth: "100%",
  backgroundColor: CA.colors.bgColor,
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9BcHBWaWV3L3N0eWxlZC1jb21wb25lbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJGMEMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0FwcFZpZXcvc3R5bGVkLWNvbXBvbmVudHMudHMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCwgeyBDU1NPYmplY3QgfSBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuaW1wb3J0IHsgRW1vdGlvblRoZW1lIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFZpZXdDb250YWluZXIgPSBzdHlsZWQuZGl2KHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImZsZXgtc3RhcnRcIixcbiAgYWxpZ25JdGVtczogXCJzdHJldGNoXCIsXG4gIGFsaWduQ29udGVudDogXCJmbGV4LXN0YXJ0XCIsXG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIHRvcDogMCxcbiAgbGVmdDogMCxcbiAgcmlnaHQ6IDAsXG4gIGJvdHRvbTogMCxcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG5cbiAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgIC8vIHByaW50IG11bHRpcGxlIHBhZ2VzIGlmIGFwcCBpcyBzY3JvbGxhYmxlIGluIFNhZmFyaVxuICAgIG92ZXJmbG93OiBcInZpc2libGVcIixcbiAgfSxcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRBcHBWaWV3TWFpblByb3BzIHtcbiAgaXNFbWJlZGRlZDogYm9vbGVhblxuICBkaXNhYmxlU2Nyb2xsaW5nOiBib29sZWFuXG59XG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBWaWV3TWFpbiA9IHN0eWxlZC5zZWN0aW9uPFN0eWxlZEFwcFZpZXdNYWluUHJvcHM+KFxuICAoeyBkaXNhYmxlU2Nyb2xsaW5nLCB0aGVtZSB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXhEaXJlY3Rpb246IFwiY29sdW1uXCIsXG4gICAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gICAgb3ZlcmZsb3c6IGRpc2FibGVTY3JvbGxpbmcgPyBcImhpZGRlblwiIDogXCJhdXRvXCIsXG4gICAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgICBoZWlnaHQ6IGAxMDBkdmhgLFxuXG4gICAgXCImOmZvY3VzXCI6IHtcbiAgICAgIG91dGxpbmU6IFwibm9uZVwiLFxuICAgIH0sXG5cbiAgICAvLyBBZGRlZCBzbyBzaWRlYmFyIG92ZXJsYXlzIG1haW4gYXBwIGNvbnRlbnQgb25cbiAgICAvLyBzbWFsbGVyIHNjcmVlbiBzaXplcywgZXhjZXB0IHdoZW4gcHJpbnRpbmdcbiAgICBcIkBtZWRpYSBub3QgcHJpbnRcIjoge1xuICAgICAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICAgICAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgICAgICAgdG9wOiAwLFxuICAgICAgICBsZWZ0OiAwLFxuICAgICAgICByaWdodDogMCxcbiAgICAgICAgYm90dG9tOiAwLFxuICAgICAgICBoZWlnaHQ6IGAxMDBkdmhgLFxuICAgICAgfSxcbiAgICB9LFxuXG4gICAgXCJAbWVkaWEgcHJpbnRcIjoge1xuICAgICAgLy8gcHJpbnQgbXVsdGlwbGUgcGFnZXMgaWYgYXBwIGlzIHNjcm9sbGFibGUgaW4gU2FmYXJpXG4gICAgICBvdmVyZmxvdzogXCJ2aXNpYmxlXCIsXG4gICAgfSxcbiAgfSlcbilcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN0aWNreUJvdHRvbUNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgcG9zaXRpb246IFwic3RpY2t5XCIsXG4gIGxlZnQ6IDAsXG4gIGJvdHRvbTogMCxcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICB6SW5kZXg6IHRoZW1lLnpJbmRpY2VzLmJvdHRvbSxcblxuICAvLyBtb3ZlIHRoZSBib3R0b20gY29udGFpbmVyIHRvIHRoZSBlbmQgb2YgcGFnZXMgaW4gcHJpbnQtbW9kZSBzbyB0aGF0IG5vdGhpbmdcbiAgLy8gKGUuZy4gYSBmbG9hdGluZyBjaGF0LWlucHV0KSBvdmVybGF5cyB0aGUgYWN0dWFsIGFwcCBjb250ZW50XG4gIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICBwb3NpdGlvbjogXCJzdGF0aWNcIixcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkSW5uZXJCb3R0b21Db250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGJvdHRvbTogMCxcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBtaW5XaWR0aDogXCIxMDAlXCIsXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLmJnQ29sb3IsXG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxufSkpXG5cbi8qKlxuICogQWRkcyB0aGUgQ1NTIHF1ZXJ5IGZvciB3aWRlIG1vZGUuXG4gKi9cbmNvbnN0IGFwcGx5V2lkZU1vZGVQYWRkaW5nID0gKHRoZW1lOiBFbW90aW9uVGhlbWUpOiBDU1NPYmplY3QgPT4ge1xuICByZXR1cm4ge1xuICAgIC8vIEluY3JlYXNlIHNpZGUgcGFkZGluZywgaWYgbGF5b3V0ID0gd2lkZSBhbmQgdGhlIHNjcmVlbiBpcyB3aWRlIGVub3VnaFxuICAgIC8vIFRoZSBjYWxjdWxhdGlvbiBpcyB1c2VkIHRvIG1ha2Ugc3VyZSB0aGF0IHdpZGUgbW9kZSBhbHdheXMgaGFzIHRoZSBzYW1lIG9yIGxhcmdlclxuICAgIC8vIGNvbnRlbnQgY29tcGFyZWQgdG8gY2VudGVyZWQgbW9kZS5cbiAgICBbYEBtZWRpYSAobWluLXdpZHRoOiBjYWxjKCR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSArIDIgKiAoJHt0aGVtZS5zaXplcy53aWRlU2lkZVBhZGRpbmd9IC0gJHt0aGVtZS5zcGFjaW5nLmxnfSkpKWBdOlxuICAgICAge1xuICAgICAgICBwYWRkaW5nTGVmdDogdGhlbWUuc2l6ZXMud2lkZVNpZGVQYWRkaW5nLFxuICAgICAgICBwYWRkaW5nUmlnaHQ6IHRoZW1lLnNpemVzLndpZGVTaWRlUGFkZGluZyxcbiAgICAgIH0sXG4gICAgbWluV2lkdGg6IFwiYXV0b1wiLFxuICAgIG1heFdpZHRoOiBcImluaXRpYWxcIixcbiAgfVxufVxuXG5pbnRlcmZhY2UgU3R5bGVkQXBwVmlld0Jsb2NrQ29udGFpbmVyUHJvcHMge1xuICBpc1dpZGVNb2RlOiBib29sZWFuXG4gIGhhc0JvdHRvbTogYm9vbGVhblxuICBzaG93UGFkZGluZzogYm9vbGVhblxuICBoYXNIZWFkZXI6IGJvb2xlYW5cbiAgc2hvd1Rvb2xiYXI6IGJvb2xlYW5cbiAgaGFzVG9wTmF2OiBib29sZWFuXG4gIGhhc1NpZGViYXI6IGJvb2xlYW5cbiAgZW1iZWRkZWQ6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEFwcFZpZXdCbG9ja0NvbnRhaW5lciA9XG4gIHN0eWxlZC5kaXY8U3R5bGVkQXBwVmlld0Jsb2NrQ29udGFpbmVyUHJvcHM+KFxuICAgICh7XG4gICAgICBoYXNCb3R0b20sXG4gICAgICBpc1dpZGVNb2RlLFxuICAgICAgc2hvd1BhZGRpbmcsXG4gICAgICBoYXNIZWFkZXIsXG4gICAgICBzaG93VG9vbGJhcixcbiAgICAgIGhhc1RvcE5hdixcbiAgICAgIGhhc1NpZGViYXIsXG4gICAgICBlbWJlZGRlZCxcbiAgICAgIHRoZW1lLFxuICAgIH0pID0+IHtcbiAgICAgIGNvbnN0IGxpdHRsZVBhZGRpbmcgPSBcIjIuMjVyZW1cIlxuXG4gICAgICAvLyBUb3AgcGFkZGluZyBsb2dpYyBwZXIgc3BlY2lmaWNhdGlvbjpcbiAgICAgIGxldCB0b3BQYWRkaW5nID0gbGl0dGxlUGFkZGluZyAvLyBEZWZhdWx0OiAyLjI1cmVtXG5cbiAgICAgIGlmICghZW1iZWRkZWQpIHtcbiAgICAgICAgLy8gTm9uLWVtYmVkZGVkIGFwcHMgYWx3YXlzIGdldCA2cmVtIG9yIDhyZW1cbiAgICAgICAgdG9wUGFkZGluZyA9IGhhc1RvcE5hdiA/IFwiOHJlbVwiIDogXCI2cmVtXCJcbiAgICAgIH0gZWxzZSBpZiAoc2hvd1BhZGRpbmcgfHwgc2hvd1Rvb2xiYXIpIHtcbiAgICAgICAgLy8gNnJlbSBpZiBlbWJlZGRlZCB3aXRoIHNob3dfcGFkZGluZyBvciBzaG93X3Rvb2xiYXJcbiAgICAgICAgdG9wUGFkZGluZyA9IFwiNnJlbVwiXG4gICAgICB9IGVsc2UgaWYgKGhhc0hlYWRlciB8fCBoYXNTaWRlYmFyKSB7XG4gICAgICAgIC8vIDQuNXJlbSBpZiBlbWJlZGRlZCB3aXRoIGhlYWRlciBidXQgbm8gcGFkZGluZy90b29sYmFyXG4gICAgICAgIHRvcFBhZGRpbmcgPSBcIjQuNXJlbVwiXG4gICAgICB9XG4gICAgICAvLyBPdGhlcndpc2UgdXNlIGRlZmF1bHQ6IDIuMjVyZW0gaWYgZW1iZWRkZWQgd2l0aCBubyBoZWFkZXIgYW5kIG5vIHBhZGRpbmcvdG9vbGJhclxuXG4gICAgICBjb25zdCBib3R0b21FbWJlZFBhZGRpbmcgPVxuICAgICAgICBzaG93UGFkZGluZyAmJiAhaGFzQm90dG9tID8gXCIxMHJlbVwiIDogdGhlbWUuc3BhY2luZy5sZ1xuXG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1RvcDogdG9wUGFkZGluZyxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogYm90dG9tRW1iZWRQYWRkaW5nLFxuICAgICAgICBtYXhXaWR0aDogdGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRoLFxuICAgICAgICAuLi4oaXNXaWRlTW9kZSAmJiBhcHBseVdpZGVNb2RlUGFkZGluZyh0aGVtZSkpLFxuICAgICAgICBbYEBtZWRpYSBwcmludGBdOiB7XG4gICAgICAgICAgcGFkZGluZ1RvcDogbGl0dGxlUGFkZGluZyxcbiAgICAgICAgfSxcbiAgICAgIH1cbiAgICB9XG4gIClcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFNpZGViYXJCbG9ja0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIHdpZHRoOiB0aGVtZS5zaXplcy5mdWxsLFxuICB9XG59KVxuXG5leHBvcnQgY29uc3QgU3R5bGVkRXZlbnRCbG9ja0NvbnRhaW5lciA9IHN0eWxlZC5kaXYoe1xuICBkaXNwbGF5OiBcIm5vbmVcIixcbn0pXG5cbmludGVyZmFjZSBTdHlsZWRCb3R0b21CbG9ja0NvbnRhaW5lclByb3BzIHtcbiAgaXNXaWRlTW9kZTogYm9vbGVhblxuICBzaG93UGFkZGluZzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQm90dG9tQmxvY2tDb250YWluZXIgPVxuICBzdHlsZWQuZGl2PFN0eWxlZEJvdHRvbUJsb2NrQ29udGFpbmVyUHJvcHM+KFxuICAgICh7IGlzV2lkZU1vZGUsIHNob3dQYWRkaW5nLCB0aGVtZSB9KSA9PiB7XG4gICAgICByZXR1cm4ge1xuICAgICAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICAgICAgcGFkZGluZ0xlZnQ6IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ1RvcDogdGhlbWUuc3BhY2luZy5sZyxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogc2hvd1BhZGRpbmdcbiAgICAgICAgICA/IHRoZW1lLnNpemVzLmFwcERlZmF1bHRCb3R0b21QYWRkaW5nXG4gICAgICAgICAgOiB0aGVtZS5zcGFjaW5nLnRocmVlWEwsXG4gICAgICAgIG1heFdpZHRoOiB0aGVtZS5zaXplcy5jb250ZW50TWF4V2lkdGgsXG4gICAgICAgIC4uLihpc1dpZGVNb2RlICYmIGFwcGx5V2lkZU1vZGVQYWRkaW5nKHRoZW1lKSksXG4gICAgICAgIFtgQG1lZGlhIHByaW50YF06IHtcbiAgICAgICAgICBwYWRkaW5nVG9wOiB0aGVtZS5zcGFjaW5nLm5vbmUsXG4gICAgICAgIH0sXG4gICAgICB9XG4gICAgfVxuICApXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRBcHBWaWV3QmxvY2tTcGFjZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICB3aWR0aDogdGhlbWUuc2l6ZXMuZnVsbCxcbiAgICBmbGV4R3JvdzogMSxcbiAgfVxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZElGcmFtZVJlc2l6ZXJBbmNob3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5ub25lLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluQ29udGVudCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgd2lkdGg6IHRoZW1lLnNpemVzLmZ1bGwsXG4gIG1pbldpZHRoOiAwLFxuICBoZWlnaHQ6IGAxMDBkdmhgLFxuXG4gIC8vIEFwcGx5IHJlbGF0aXZlIHBvc2l0aW9uaW5nIG9ubHkgb24gZGVza3RvcCB0byBmaXggaGVhZGVyIHBvc2l0aW9uaW5nIHdoZW4gc2lkZWJhciBvcGVucy5cbiAgLy8gT24gbW9iaWxlLCByZWxhdGl2ZSBwb3NpdGlvbmluZyBpcyBvbWl0dGVkIHRvIGFsbG93IHRoZSBzaWRlYmFyIHRvIHByb3Blcmx5IG92ZXJsYXlcbiAgLy8gdGhlIGFwcCBjb250ZW50IGZvciBzdC5uYXZpZ2F0aW9uKHBvc2l0aW9uPSd0b3AnKSBmdW5jdGlvbmFsaXR5ICgjMTEzNDkpLlxuICAvLyBXaXRob3V0IHRoaXMgY29uZGl0aW9uYWwgcG9zaXRpb25pbmcsIHRoZSBzaWRlYmFyIHdvdWxkIG92ZXJsYXAgdGhlIHRvcCBuYXZpZ2F0aW9uXG4gIC8vIHdoZW4gb3BlbmVkIG9uIGRlc2t0b3AgZGV2aWNlcy5cbiAgW2BAbWVkaWEgKG1pbi13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICB9LFxufSkpXG4iXX0= */"), applyWideModePadding = (CA) => ({
  // Increase side padding, if layout = wide and the screen is wide enough
  // The calculation is used to make sure that wide mode always has the same or larger
  // content compared to centered mode.
  [`@media (min-width: calc(${CA.sizes.contentMaxWidth} + 2 * (${CA.sizes.wideSidePadding} - ${CA.spacing.lg})))`]: {
    paddingLeft: CA.sizes.wideSidePadding,
    paddingRight: CA.sizes.wideSidePadding
  },
  minWidth: "auto",
  maxWidth: "initial"
}), StyledAppViewBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi6"
} : {
  target: "ea3mdgi6",
  label: "StyledAppViewBlockContainer"
})(({
  hasBottom: CA,
  isWideMode: gA,
  showPadding: AA,
  hasHeader: IA,
  showToolbar: BA,
  hasTopNav: QA,
  hasSidebar: EA,
  embedded: iA,
  theme: oA
}) => {
  const cA = "2.25rem";
  let tA = cA;
  iA ? AA || BA ? tA = "6rem" : (IA || EA) && (tA = "4.5rem") : tA = QA ? "8rem" : "6rem";
  const eA = AA && !CA ? "10rem" : oA.spacing.lg;
  return {
    width: oA.sizes.full,
    paddingLeft: oA.spacing.lg,
    paddingRight: oA.spacing.lg,
    paddingTop: tA,
    paddingBottom: eA,
    maxWidth: oA.sizes.contentMaxWidth,
    ...gA && applyWideModePadding(oA),
    "@media print": {
      paddingTop: cA
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSidebarBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi5"
} : {
  target: "ea3mdgi5",
  label: "StyledSidebarBlockContainer"
})(({
  theme: CA
}) => ({
  width: CA.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledEventBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi4"
} : {
  target: "ea3mdgi4",
  label: "StyledEventBlockContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
}), StyledBottomBlockContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi3"
} : {
  target: "ea3mdgi3",
  label: "StyledBottomBlockContainer"
})(({
  isWideMode: CA,
  showPadding: gA,
  theme: AA
}) => ({
  width: AA.sizes.full,
  paddingLeft: AA.spacing.lg,
  paddingRight: AA.spacing.lg,
  paddingTop: AA.spacing.lg,
  paddingBottom: gA ? AA.sizes.appDefaultBottomPadding : AA.spacing.threeXL,
  maxWidth: AA.sizes.contentMaxWidth,
  ...CA && applyWideModePadding(AA),
  "@media print": {
    paddingTop: AA.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppViewBlockSpacer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi2"
} : {
  target: "ea3mdgi2",
  label: "StyledAppViewBlockSpacer"
})(({
  theme: CA
}) => ({
  width: CA.sizes.full,
  flexGrow: 1
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledIFrameResizerAnchor = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi1"
} : {
  target: "ea3mdgi1",
  label: "StyledIFrameResizerAnchor"
})(({
  theme: CA
}) => ({
  position: "relative",
  bottom: CA.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMainContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ea3mdgi0"
} : {
  target: "ea3mdgi0",
  label: "StyledMainContent"
})(({
  theme: CA
}) => ({
  width: CA.sizes.full,
  minWidth: 0,
  height: "100dvh",
  // Apply relative positioning only on desktop to fix header positioning when sidebar opens.
  // On mobile, relative positioning is omitted to allow the sidebar to properly overlay
  // the app content for st.navigation(position='top') functionality (#11349).
  // Without this conditional positioning, the sidebar would overlap the top navigation
  // when opened on desktop devices.
  [`@media (min-width: ${CA.breakpoints.md})`]: {
    position: "relative"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function ScrollToBottomContainer(CA) {
  const {
    className: gA,
    tabIndex: AA,
    children: IA,
    isEmbedded: BA,
    disableScrolling: QA
  } = CA, EA = useScrollToBottom(!0);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewMain, { tabIndex: AA, className: gA, isEmbedded: BA, disableScrolling: QA, ref: EA, "data-testid": "stAppScrollToBottomContainer", children: IA });
}
function AppView(CA) {
  const {
    elements: gA,
    widgetMgr: AA,
    uploadClient: IA,
    sendMessageToHost: BA,
    endpoints: QA,
    navigationPosition: EA,
    topRightContent: iA,
    wideMode: oA,
    embedded: cA,
    showPadding: tA,
    disableScrolling: eA,
    addScriptFinishedHandler: aA,
    removeScriptFinishedHandler: GA,
    widgetsDisabled: lA,
    showToolbar: nA,
    disableFullscreenMode: DA,
    componentRegistry: hA
  } = CA;
  useEffect(() => {
    const XA = () => {
      BA({
        type: "UPDATE_HASH",
        hash: window.location.hash
      });
    };
    return window.addEventListener("hashchange", XA, !1), () => window.removeEventListener("hashchange", XA, !1);
  }, [BA]);
  const {
    activeTheme: wA
  } = useContext(ThemeContext), {
    appPages: sA,
    pageLinkBaseUrl: NA
  } = useContext(NavigationContext), {
    initialSidebarState: rA,
    appLogo: yA,
    hideSidebarNav: bA
  } = useContext(SidebarConfigContext), {
    innerWidth: RA
  } = useWindowDimensionsContext(), FA = oA ? "wide" : "narrow", dA = !gA.sidebar.isEmpty, kA = !gA.event.isEmpty, pA = !gA.bottom.isEmpty, [YA, SA] = useState(!1), JA = RA > 0 && (dA || EA === Navigation.Position.SIDEBAR && !bA && shouldShowNavigation(sA) || YA);
  useEffect(() => {
    JA && bA && !YA && SA(!0);
  }, [JA, bA, YA]);
  const UA = useCallback(() => {
    !dA && YA && SA(!1);
  }, [dA, YA]);
  useEffect(() => (aA(UA), () => {
    GA(UA);
  }), [UA, aA, GA]);
  const fA = pA ? ScrollToBottomContainer : StyledAppViewMain, zA = (XA) => /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerContentsWrapper, { node: XA, endpoints: QA, widgetMgr: AA, widgetsDisabled: lA, uploadClient: IA, disableFullscreenMode: DA, componentRegistry: hA, height: "auto", isRoot: !0 }), [_A, uA] = useState(() => {
    const XA = getSavedSidebarState(NA);
    return XA !== null ? XA : shouldCollapse(rA, parseInt(wA.emotion.breakpoints.md, 10), RA);
  });
  useExecuteWhenChanged(() => {
    if (RA > 0 && JA) {
      const XA = getSavedSidebarState(NA);
      uA(XA !== null ? XA : shouldCollapse(rA, parseInt(wA.emotion.breakpoints.md, 10), RA));
    }
  }, [RA, JA, rA, wA.emotion.breakpoints.md, NA]);
  const HA = useCallback((XA, EI = !0) => {
    uA(XA), EI && saveSidebarState(NA, XA);
  }, [NA]), TA = useCallback(() => {
    HA(!_A, !0);
  }, [HA, _A]), ZA = yA ? /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { appLogo: yA, endpoints: QA, collapsed: _A || !JA, componentName: "Header Logo", dataTestId: "stHeaderLogo" }) : null, AI = ZA && (!JA || _A), QI = JA && _A, LA = EA === Navigation.Position.TOP && shouldShowNavigation(sA), PA = AI || QI || LA || nA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppViewContainer, { className: "stAppViewContainer appview-container", "data-testid": "stAppViewContainer", "data-layout": FA, children: [
    JA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Sidebar", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedSidebar, { endpoints: QA, hasElements: dA, isCollapsed: _A, onToggleCollapse: HA, widgetsDisabled: lA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSidebarBlockContainer, { children: zA(gA.sidebar) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Header, { hasSidebar: JA, isSidebarOpen: JA && !_A, onToggleSidebar: TA, navigation: EA === Navigation.Position.TOP && shouldShowNavigation(sA) ? /* @__PURE__ */ jsxRuntimeExports.jsx(TopNav, { endpoints: QA, widgetsDisabled: lA }) : null, rightContent: iA, logoComponent: ZA, showToolbar: nA }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(fA, { tabIndex: 0, isEmbedded: cA, disableScrolling: eA, className: "stMain", "data-testid": "stMain", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Main", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockContainer, { className: "stMainBlockContainer block-container", "data-testid": "stMainBlockContainer", isWideMode: oA, showPadding: tA, hasBottom: pA, hasHeader: PA, hasSidebar: JA, showToolbar: nA, hasTopNav: LA, embedded: cA, children: zA(gA.main) }) }),
        !pA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIFrameResizerAnchor, { "data-testid": "stAppIframeResizerAnchor", "data-iframe-height": !0 }),
        pA && /* @__PURE__ */ jsxRuntimeExports.jsxs(Profiler, { id: "Bottom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppViewBlockSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStickyBottomContainer, { className: "stBottom", "data-testid": "stBottom", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInnerBottomContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBottomBlockContainer, { "data-testid": "stBottomBlockContainer", isWideMode: oA, showPadding: tA, children: zA(gA.bottom) }) }) })
        ] })
      ] })
    ] }),
    kA && /* @__PURE__ */ jsxRuntimeExports.jsx(Profiler, { id: "Event", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EventContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEventBlockContainer, { className: "stEvent", "data-testid": "stEvent", children: zA(gA.event) }) }) })
  ] });
}
const DeployButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e17vllj40"
} : {
  target: "e17vllj40",
  label: "DeployButtonContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  gap: CA.spacing.sm,
  alignItems: "center",
  lineHeight: CA.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9EZXBsb3lCdXR0b24vc3R5bGVkLWNvbXBvbmVudHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCcUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9zdHJlYW1saXQvZnJvbnRlbmQvYXBwL3NyYy9jb21wb25lbnRzL0RlcGxveUJ1dHRvbi9zdHlsZWQtY29tcG9uZW50cy50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvcHlyaWdodCAoYykgU3RyZWFtbGl0IEluYy4gKDIwMTgtMjAyMikgU25vd2ZsYWtlIEluYy4gKDIwMjItMjAyNilcbiAqXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuICogeW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuICogWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4gKlxuICogICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICpcbiAqIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbiAqIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbiAqIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuICogU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuICogbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG4gKi9cblxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCJcblxuZXhwb3J0IGNvbnN0IERlcGxveUJ1dHRvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgbGluZUhlaWdodDogdGhlbWUuaWNvblNpemVzLm1kLFxufSkpXG4iXX0= */"), DeployButton = ({
  onClick: CA
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stAppDeployButton", "data-testid": "stAppDeployButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, onClick: CA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: "Deploy" }) }) }) });
var MoreVert = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
});
MoreVert.displayName = "MoreVert";
const BLOB_TYPE = "video/webm", LOG$5 = loglevelExports.getLogger("ScreenCastRecorder");
class ScreenCastRecorder {
  /** True if the current browser likely supports screencasts. */
  static isSupportedBrowser() {
    try {
      return notNullOrUndefined(navigator.mediaDevices) && notNullOrUndefined(navigator.mediaDevices.getUserMedia) && notNullOrUndefined(navigator.mediaDevices.getDisplayMedia) && MediaRecorder.isTypeSupported(BLOB_TYPE);
    } catch {
      return !1;
    }
  }
  constructor({
    recordAudio: gA,
    onErrorOrStop: AA
  }) {
    this.recordAudio = gA, this.onErrorOrStopCallback = AA, this.inputStream = null, this.recordedChunks = [], this.mediaRecorder = null;
  }
  /**
   * This asynchronous method will initialize the screen recording object asking
   * for permissions to the user which are needed to start recording.
   */
  async initialize() {
    let AA = (await navigator.mediaDevices.getDisplayMedia({
      video: !0
    })).getTracks();
    if (this.recordAudio) {
      const IA = await navigator.mediaDevices.getUserMedia({
        video: !1,
        audio: !0
      });
      AA = AA.concat(IA.getAudioTracks());
    }
    this.recordedChunks = [], this.inputStream = new MediaStream(AA), this.mediaRecorder = new MediaRecorder(this.inputStream, {
      mimeType: BLOB_TYPE
    }), this.mediaRecorder.ondataavailable = (IA) => this.recordedChunks.push(IA.data);
  }
  getState() {
    return this.mediaRecorder ? this.mediaRecorder.state : "inactive";
  }
  /**
   * This method will start the screen recording if the user has granted permissions
   * and the mediaRecorder has been initialized
   *
   * @returns {boolean}
   */
  start() {
    if (!this.mediaRecorder)
      return LOG$5.warn("ScreenCastRecorder.start: mediaRecorder is null"), !1;
    const gA = (AA) => {
      LOG$5.warn(`mediaRecorder.start threw an error: ${String(AA)}`);
    };
    this.mediaRecorder.onerror = (AA) => {
      gA(AA), this.onErrorOrStopCallback();
    }, this.mediaRecorder.onstop = () => this.onErrorOrStopCallback();
    try {
      this.mediaRecorder.start();
    } catch (AA) {
      return gA(AA), !1;
    }
    return !0;
  }
  /**
   * This method will stop recording and then return the generated Blob
   *
   * @returns {(Promise|undefined)}
   *  A Promise which will return the generated Blob
   *  Undefined if the MediaRecorder could not initialize
   */
  stop() {
    if (!this.mediaRecorder)
      return;
    let gA;
    const AA = new Promise((IA) => {
      gA = IA;
    });
    return this.mediaRecorder.onstop = () => gA(), this.mediaRecorder.stop(), this.inputStream && (this.inputStream.getTracks().forEach((IA) => IA.stop()), this.inputStream = null), AA.then(() => this.buildOutputBlob());
  }
  buildOutputBlob() {
    return new Blob(this.recordedChunks, {
      type: BLOB_TYPE
    });
  }
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$6() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const recordingIndicatorPulse = (CA) => keyframes`
0% {
  box-shadow: 0 0 ${CA.spacing.twoXS} ${CA.colors.redTextColor};
}
50% {
  box-shadow: 0 0 ${CA.spacing.sm} ${CA.spacing.twoXS} ${CA.colors.redTextColor};
}
100% {
  box-shadow: 0 0 ${CA.spacing.twoXS} ${CA.colors.redTextColor};
}`, StyledRecordingIndicator = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8017"
} : {
  target: "e16jpq8017",
  label: "StyledRecordingIndicator"
})(({
  theme: CA
}) => ({
  position: "absolute",
  bottom: CA.spacing.lg,
  right: CA.spacing.sm,
  width: CA.spacing.sm,
  height: CA.spacing.sm,
  backgroundColor: CA.colors.redTextColor,
  borderRadius: CA.radii.full,
  boxShadow: `0 0 ${CA.spacing.twoXS} ${CA.colors.redTextColor}`,
  animation: `${recordingIndicatorPulse(CA)} 2s linear infinite`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuDivider = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8016"
} : {
  target: "e16jpq8016",
  label: "StyledMenuDivider"
})(({
  theme: CA
}) => ({
  borderTop: `${CA.sizes.borderWidth} solid ${CA.colors.borderColor}`,
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuPopoverContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8015"
} : {
  target: "e16jpq8015",
  label: "StyledMenuPopoverContent"
})(({
  theme: CA
}) => ({
  padding: CA.spacing.sm,
  minWidth: CA.sizes.appMainMenu,
  "@media print": {
    display: "none"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8014"
} : {
  target: "e16jpq8014",
  label: "StyledMenuContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: CA.spacing.xs
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpRW1DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuY29uc3QgcmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UgPSAodGhlbWU6IEVtb3Rpb25UaGVtZSk6IEtleWZyYW1lcyA9PiBrZXlmcmFtZXNgXG4wJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG41MCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG4xMDAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfTtcbn1gXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRpbmdJbmRpY2F0b3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgcmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIHdpZHRoOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBoZWlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICBib3hTaGFkb3c6IGAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9YCxcbiAgYW5pbWF0aW9uOiBgJHtyZWNvcmRpbmdJbmRpY2F0b3JQdWxzZSh0aGVtZSl9IDJzIGxpbmVhciBpbmZpbml0ZWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVEaXZpZGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBib3JkZXJUb3A6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuLyoqXG4gKiBPdXRlcm1vc3Qgd3JhcHBlciBmb3IgdGhlIHBvcG92ZXIgYm9keSAobWVudSArIG9wdGlvbmFsIGZvb3RlcikuXG4gKiBPd25zIG91dGVyIHBhZGRpbmc7IHRoZSBmb290ZXIgYWRkcyBpdHMgb3duIGhvcml6b250YWwgcGFkZGluZ1xuICogc28gaXRzIGNvbnRlbnQgd2lkdGggY29udHJpYnV0ZXMgdG8gdGhlIHBvcG92ZXIncyBpbnRyaW5zaWMgd2lkdGhcbiAqIChtYXRjaGluZyB0aGUgZGV2ZWxvcC1icmFuY2ggbGF5b3V0IHdoZXJlIGl0IHdhcyBpbnNpZGUgdGhlIGNvbnRhaW5lcikuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51UG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1pbldpZHRoOiB0aGVtZS5zaXplcy5hcHBNYWluTWVudSxcblxuICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgZGlzcGxheTogXCJub25lXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBhbGlnbkl0ZW1zOiBcInN0cmV0Y2hcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluTWVudUNvbnRhaW5lciA9IHN0eWxlZC5zcGFuKHtcbiAgbGluZUhlaWdodDogXCJpbml0aWFsXCIsXG59KVxuXG5pbnRlcmZhY2UgU3R5bGVkTWVudUl0ZW1Sb3dQcm9wcyB7XG4gIGlzUmVjb3JkaW5nPzogYm9vbGVhblxufVxuXG4vKipcbiAqIE1lbnUgaXRlbSBidXR0b24gd2l0aCBob3ZlciBoaWdobGlnaHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkTWVudUl0ZW1Sb3dQcm9wcz4oXG4gICh7IHRoZW1lLCBpc1JlY29yZGluZyB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgLy8gTmVlZCB0byBleHBsaWNpdGx5IHNldCB1bml0IHRvIHJlbSB0byBnZXQgMjRweCBsaW5lIGhlaWdodFxuICAgIGxpbmVIZWlnaHQ6IGAke3RoZW1lLmxpbmVIZWlnaHRzLnNtYWxsfXJlbWAsXG4gICAgdGV4dEFsaWduOiBcImxlZnRcIixcbiAgICBjb2xvcjogaXNSZWNvcmRpbmcgPyB0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRXZWlnaHQ6IGlzUmVjb3JkaW5nXG4gICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIHRyYW5zaXRpb246IFwiYmFja2dyb3VuZC1jb2xvciAxMDBtcyBlYXNlXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG5cbiAgICAnJlthcmlhLWRpc2FibGVkPVwidHJ1ZVwiXSc6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgJyZbYXJpYS1kaXNhYmxlZD1cInRydWVcIl06aG92ZXInOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIENvbnRhaW5lciBmb3IgbWVudSBpdGVtIGNvbnRlbnQgKGxhYmVsICsgc2hvcnRjdXQpLlxuICovXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1Db250ZW50ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogTWVudSBpdGVtIGxhYmVsIHRleHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIG1pbldpZHRoOiAwLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG59KVxuXG4vKipcbiAqIEtleWJvYXJkIHNob3J0Y3V0IGluZGljYXRvciBmb3IgbWVudSBpdGVtcy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtU2hvcnRjdXQgPSBzdHlsZWQua2JkKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIG9wYWNpdHk6IDAuNixcbiAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnRpZ2h0LFxuICBsZXR0ZXJTcGFjaW5nOiBcIjAuMDFlbVwiLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgY29udGFpbmVyIGZvciB0aGVtZSByYWRpbyBidXR0b25zLlxuICogVXNlcyB0aGUgZnVsbCBtZW51IHdpZHRoIHdpdGggZXF1YWwgc3BhY2luZy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9Hcm91cCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuaW50ZXJmYWNlIFN0eWxlZFRoZW1lUmFkaW9JdGVtUHJvcHMge1xuICBpc0NoZWNrZWQ6IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBJbmRpdmlkdWFsIHRoZW1lIHJhZGlvIGJ1dHRvbiB3aXRoIGljb24gKyBsYWJlbCwgZmxleCBjb2x1bW4gbGF5b3V0LlxuICogQWN0aXZlIHN0YXRlIHVzZXMgZGFya2VuZWRCZ01peDI1OyBob3ZlciB1c2VzIGRhcmtlbmVkQmdNaXgxNS5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JdGVtID0gc3R5bGVkLmJ1dHRvbjxTdHlsZWRUaGVtZVJhZGlvSXRlbVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXg6IDEsXG4gICAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQ2hlY2tlZFxuICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICA6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMudGlnaHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNDaGVja2VkXG4gICAgICAgID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0NoZWNrZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICAgIDogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIFdyYXBwZXIgZm9yIER5bmFtaWNJY29uIHNpemluZyBpbnNpZGUgdGhlbWUgcmFkaW8gYnV0dG9ucy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JY29uID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxufSlcblxuaW50ZXJmYWNlIFN0eWxlZFRvZ2dsZVJvd1Byb3BzIHtcbiAgaXNEaXNhYmxlZD86IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBSb3cgY29udGFpbmVyIGZvciBhIHRvZ2dsZSBzd2l0Y2ggaW5zaWRlIHRoZSBtZW51LlxuICogT3ducyBmb2N1cywgY2xpY2sgaGFuZGxpbmcsIGFuZCBob3Zlci9mb2N1cy12aXNpYmxlIHN0eWxpbmdcbiAqIGNvbnNpc3RlbnQgd2l0aCBTdHlsZWRNZW51SXRlbVJvdy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRvZ2dsZVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkVG9nZ2xlUm93UHJvcHM+KFxuICAoeyB0aGVtZSwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLFxuICAgIHdpZHRoOiBcIjEwMCVcIixcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGN1cnNvcjogaXNEaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICAgIGNvbG9yOiBpc0Rpc2FibGVkID8gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogYCR7dGhlbWUubGluZUhlaWdodHMuc21hbGx9cmVtYCxcbiAgICB0ZXh0QWxpZ246IFwibGVmdFwiLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNEaXNhYmxlZFxuICAgICAgICA/IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudFxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG4gIH0pXG4pXG5cbmludGVyZmFjZSBTdHlsZWRUb2dnbGVQcm9wcyB7XG4gIGlzQ2hlY2tlZDogYm9vbGVhblxuICBpc0Rpc2FibGVkPzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlVHJhY2sgPSBzdHlsZWQuZGl2PFN0eWxlZFRvZ2dsZVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgICB3aWR0aDogYGNhbGMoMiAqICR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAsXG4gICAgbWluV2lkdGg6IGBjYWxjKDIgKiAke3RoZW1lLnNpemVzLmNoZWNrYm94fSlgLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuY2hlY2tib3gsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5jaGVja2JveCxcbiAgICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcudGhyZWVYU31gLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6XG4gICAgICBpc0NoZWNrZWQgJiYgIWlzRGlzYWJsZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMucHJpbWFyeVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlS25vYiA9IHN0eWxlZC5kaXY8U3R5bGVkVG9nZ2xlUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNDaGVja2VkLCBpc0Rpc2FibGVkIH0pID0+IHtcbiAgICBjb25zdCBsaWdodFRoZW1lID0gaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG5cbiAgICBsZXQgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZVxuICAgICAgPyB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgICAgOiB0aGVtZS5jb2xvcnMuYm9keVRleHRcbiAgICBpZiAoaXNEaXNhYmxlZCkge1xuICAgICAgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy5ncmF5NzAgOiB0aGVtZS5jb2xvcnMuZ3JheTkwXG4gICAgfVxuXG4gICAgcmV0dXJuIHtcbiAgICAgIHdpZHRoOiBgY2FsYygke3RoZW1lLnNpemVzLmNoZWNrYm94fSAtICR7dGhlbWUuc3BhY2luZy50d29YU30pYCxcbiAgICAgIGhlaWdodDogYGNhbGMoJHt0aGVtZS5zaXplcy5jaGVja2JveH0gLSAke3RoZW1lLnNwYWNpbmcudHdvWFN9KWAsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICB0cmFuc2Zvcm06IGlzQ2hlY2tlZCA/IGB0cmFuc2xhdGVYKCR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAgOiBcIm5vbmVcIixcbiAgICAgIHRyYW5zaXRpb246IFwidHJhbnNmb3JtIDEwMG1zIGVhc2UsIGJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICAgIH1cbiAgfVxuKVxuXG4vKipcbiAqIEZvb3RlciBjb250YWluZXIgZm9yIHRoZSB2ZXJzaW9uIHN0cmluZy5cbiAqIExpdmVzIG91dHNpZGUgdGhlIHJvbGU9XCJtZW51XCIgY29udGFpbmVyIChhcyBhIHNpYmxpbmcgd2l0aGluIHRoZVxuICogcG9wb3Zlcikgc28gdGhlIENvcHlCdXR0b24gaXMgbm90IGFuIGludmFsaWQgY2hpbGQgb2Ygcm9sZT1cIm1lbnVcIi5cbiAqIEtleWJvYXJkIHVzZXJzIHJlYWNoIHRoZSBDb3B5QnV0dG9uIHZpYSBUYWI7IGZvY3VzLWxvY2sga2VlcHNcbiAqIGZvY3VzIHdpdGhpbiB0aGUgcG9wb3Zlci5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uRm9vdGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgZm9yIHZlcnNpb24gdGV4dCArIGNvcHkgYnV0dG9uLlxuICogVGhlIGNvcHkgYnV0dG9uIGlzIGhpZGRlbiB1bnRpbCBob3Zlci9mb2N1cy13aXRoaW4uXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51VmVyc2lvblJvdyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnhzLFxuXG4gIFwiLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6IHtcbiAgICBvcGFjaXR5OiAwLFxuICAgIHBvaW50ZXJFdmVudHM6IFwibm9uZVwiLFxuICAgIHRyYW5zaXRpb246IFwib3BhY2l0eSAxMjBtcyBlYXNlXCIsXG4gIH0sXG5cbiAgXCImOmhvdmVyIC5zdE1lbnVWZXJzaW9uQ29weUJ1dHRvbiwgJjpmb2N1cy13aXRoaW4gLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6XG4gICAge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICAgIHBvaW50ZXJFdmVudHM6IFwiYXV0b1wiLFxuICAgIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uVGV4dCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgb3BhY2l0eTogMC42LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuIl19 */"), StyledMainMenuContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8013"
} : {
  target: "e16jpq8013",
  label: "StyledMainMenuContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "hwawmg",
  styles: "line-height:initial"
} : {
  name: "hwawmg",
  styles: "line-height:initial/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), StyledMenuItemRow = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8012"
} : {
  target: "e16jpq8012",
  label: "StyledMenuItemRow"
})(({
  theme: CA,
  isRecording: gA
}) => ({
  display: "flex",
  alignItems: "center",
  padding: `${CA.spacing.threeXS} ${CA.spacing.sm}`,
  border: "none",
  borderRadius: CA.radii.default,
  backgroundColor: CA.colors.transparent,
  cursor: "pointer",
  fontSize: CA.fontSizes.sm,
  // Need to explicitly set unit to rem to get 24px line height
  lineHeight: `${CA.lineHeights.small}rem`,
  textAlign: "left",
  color: gA ? CA.colors.redTextColor : CA.colors.bodyText,
  fontWeight: gA ? CA.fontWeights.bold : CA.fontWeights.normal,
  transition: "background-color 100ms ease",
  "&:hover, &:focus-visible": {
    backgroundColor: CA.colors.darkenedBgMix15
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRingMuted
  },
  '&[aria-disabled="true"]': {
    color: CA.colors.fadedText60,
    cursor: "not-allowed"
  },
  '&[aria-disabled="true"]:hover': {
    backgroundColor: CA.colors.transparent
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemContent = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8011"
} : {
  target: "e16jpq8011",
  label: "StyledMenuItemContent"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: CA.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuItemLabel = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq8010"
} : {
  target: "e16jpq8010",
  label: "StyledMenuItemLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "zrodnv",
  styles: "display:inline-flex;align-items:center;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : {
  name: "zrodnv",
  styles: "display:inline-flex;align-items:center;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), StyledMenuItemShortcut = /* @__PURE__ */ createStyled("kbd", process.env.NODE_ENV === "production" ? {
  target: "e16jpq809"
} : {
  target: "e16jpq809",
  label: "StyledMenuItemShortcut"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  whiteSpace: "nowrap",
  fontSize: CA.fontSizes.sm,
  opacity: 0.6,
  fontFamily: "inherit",
  lineHeight: CA.lineHeights.tight,
  letterSpacing: "0.01em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzSnNDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuY29uc3QgcmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UgPSAodGhlbWU6IEVtb3Rpb25UaGVtZSk6IEtleWZyYW1lcyA9PiBrZXlmcmFtZXNgXG4wJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG41MCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG4xMDAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfTtcbn1gXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRpbmdJbmRpY2F0b3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgcmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIHdpZHRoOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBoZWlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICBib3hTaGFkb3c6IGAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9YCxcbiAgYW5pbWF0aW9uOiBgJHtyZWNvcmRpbmdJbmRpY2F0b3JQdWxzZSh0aGVtZSl9IDJzIGxpbmVhciBpbmZpbml0ZWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVEaXZpZGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBib3JkZXJUb3A6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuLyoqXG4gKiBPdXRlcm1vc3Qgd3JhcHBlciBmb3IgdGhlIHBvcG92ZXIgYm9keSAobWVudSArIG9wdGlvbmFsIGZvb3RlcikuXG4gKiBPd25zIG91dGVyIHBhZGRpbmc7IHRoZSBmb290ZXIgYWRkcyBpdHMgb3duIGhvcml6b250YWwgcGFkZGluZ1xuICogc28gaXRzIGNvbnRlbnQgd2lkdGggY29udHJpYnV0ZXMgdG8gdGhlIHBvcG92ZXIncyBpbnRyaW5zaWMgd2lkdGhcbiAqIChtYXRjaGluZyB0aGUgZGV2ZWxvcC1icmFuY2ggbGF5b3V0IHdoZXJlIGl0IHdhcyBpbnNpZGUgdGhlIGNvbnRhaW5lcikuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51UG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1pbldpZHRoOiB0aGVtZS5zaXplcy5hcHBNYWluTWVudSxcblxuICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgZGlzcGxheTogXCJub25lXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBhbGlnbkl0ZW1zOiBcInN0cmV0Y2hcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluTWVudUNvbnRhaW5lciA9IHN0eWxlZC5zcGFuKHtcbiAgbGluZUhlaWdodDogXCJpbml0aWFsXCIsXG59KVxuXG5pbnRlcmZhY2UgU3R5bGVkTWVudUl0ZW1Sb3dQcm9wcyB7XG4gIGlzUmVjb3JkaW5nPzogYm9vbGVhblxufVxuXG4vKipcbiAqIE1lbnUgaXRlbSBidXR0b24gd2l0aCBob3ZlciBoaWdobGlnaHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkTWVudUl0ZW1Sb3dQcm9wcz4oXG4gICh7IHRoZW1lLCBpc1JlY29yZGluZyB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgLy8gTmVlZCB0byBleHBsaWNpdGx5IHNldCB1bml0IHRvIHJlbSB0byBnZXQgMjRweCBsaW5lIGhlaWdodFxuICAgIGxpbmVIZWlnaHQ6IGAke3RoZW1lLmxpbmVIZWlnaHRzLnNtYWxsfXJlbWAsXG4gICAgdGV4dEFsaWduOiBcImxlZnRcIixcbiAgICBjb2xvcjogaXNSZWNvcmRpbmcgPyB0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRXZWlnaHQ6IGlzUmVjb3JkaW5nXG4gICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIHRyYW5zaXRpb246IFwiYmFja2dyb3VuZC1jb2xvciAxMDBtcyBlYXNlXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG5cbiAgICAnJlthcmlhLWRpc2FibGVkPVwidHJ1ZVwiXSc6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgJyZbYXJpYS1kaXNhYmxlZD1cInRydWVcIl06aG92ZXInOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIENvbnRhaW5lciBmb3IgbWVudSBpdGVtIGNvbnRlbnQgKGxhYmVsICsgc2hvcnRjdXQpLlxuICovXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1Db250ZW50ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogTWVudSBpdGVtIGxhYmVsIHRleHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIG1pbldpZHRoOiAwLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG59KVxuXG4vKipcbiAqIEtleWJvYXJkIHNob3J0Y3V0IGluZGljYXRvciBmb3IgbWVudSBpdGVtcy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtU2hvcnRjdXQgPSBzdHlsZWQua2JkKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIG9wYWNpdHk6IDAuNixcbiAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnRpZ2h0LFxuICBsZXR0ZXJTcGFjaW5nOiBcIjAuMDFlbVwiLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgY29udGFpbmVyIGZvciB0aGVtZSByYWRpbyBidXR0b25zLlxuICogVXNlcyB0aGUgZnVsbCBtZW51IHdpZHRoIHdpdGggZXF1YWwgc3BhY2luZy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9Hcm91cCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuaW50ZXJmYWNlIFN0eWxlZFRoZW1lUmFkaW9JdGVtUHJvcHMge1xuICBpc0NoZWNrZWQ6IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBJbmRpdmlkdWFsIHRoZW1lIHJhZGlvIGJ1dHRvbiB3aXRoIGljb24gKyBsYWJlbCwgZmxleCBjb2x1bW4gbGF5b3V0LlxuICogQWN0aXZlIHN0YXRlIHVzZXMgZGFya2VuZWRCZ01peDI1OyBob3ZlciB1c2VzIGRhcmtlbmVkQmdNaXgxNS5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JdGVtID0gc3R5bGVkLmJ1dHRvbjxTdHlsZWRUaGVtZVJhZGlvSXRlbVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXg6IDEsXG4gICAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQ2hlY2tlZFxuICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICA6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMudGlnaHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNDaGVja2VkXG4gICAgICAgID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0NoZWNrZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICAgIDogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIFdyYXBwZXIgZm9yIER5bmFtaWNJY29uIHNpemluZyBpbnNpZGUgdGhlbWUgcmFkaW8gYnV0dG9ucy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JY29uID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxufSlcblxuaW50ZXJmYWNlIFN0eWxlZFRvZ2dsZVJvd1Byb3BzIHtcbiAgaXNEaXNhYmxlZD86IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBSb3cgY29udGFpbmVyIGZvciBhIHRvZ2dsZSBzd2l0Y2ggaW5zaWRlIHRoZSBtZW51LlxuICogT3ducyBmb2N1cywgY2xpY2sgaGFuZGxpbmcsIGFuZCBob3Zlci9mb2N1cy12aXNpYmxlIHN0eWxpbmdcbiAqIGNvbnNpc3RlbnQgd2l0aCBTdHlsZWRNZW51SXRlbVJvdy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRvZ2dsZVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkVG9nZ2xlUm93UHJvcHM+KFxuICAoeyB0aGVtZSwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLFxuICAgIHdpZHRoOiBcIjEwMCVcIixcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGN1cnNvcjogaXNEaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICAgIGNvbG9yOiBpc0Rpc2FibGVkID8gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogYCR7dGhlbWUubGluZUhlaWdodHMuc21hbGx9cmVtYCxcbiAgICB0ZXh0QWxpZ246IFwibGVmdFwiLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNEaXNhYmxlZFxuICAgICAgICA/IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudFxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG4gIH0pXG4pXG5cbmludGVyZmFjZSBTdHlsZWRUb2dnbGVQcm9wcyB7XG4gIGlzQ2hlY2tlZDogYm9vbGVhblxuICBpc0Rpc2FibGVkPzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlVHJhY2sgPSBzdHlsZWQuZGl2PFN0eWxlZFRvZ2dsZVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgICB3aWR0aDogYGNhbGMoMiAqICR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAsXG4gICAgbWluV2lkdGg6IGBjYWxjKDIgKiAke3RoZW1lLnNpemVzLmNoZWNrYm94fSlgLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuY2hlY2tib3gsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5jaGVja2JveCxcbiAgICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcudGhyZWVYU31gLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6XG4gICAgICBpc0NoZWNrZWQgJiYgIWlzRGlzYWJsZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMucHJpbWFyeVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlS25vYiA9IHN0eWxlZC5kaXY8U3R5bGVkVG9nZ2xlUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNDaGVja2VkLCBpc0Rpc2FibGVkIH0pID0+IHtcbiAgICBjb25zdCBsaWdodFRoZW1lID0gaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG5cbiAgICBsZXQgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZVxuICAgICAgPyB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgICAgOiB0aGVtZS5jb2xvcnMuYm9keVRleHRcbiAgICBpZiAoaXNEaXNhYmxlZCkge1xuICAgICAgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy5ncmF5NzAgOiB0aGVtZS5jb2xvcnMuZ3JheTkwXG4gICAgfVxuXG4gICAgcmV0dXJuIHtcbiAgICAgIHdpZHRoOiBgY2FsYygke3RoZW1lLnNpemVzLmNoZWNrYm94fSAtICR7dGhlbWUuc3BhY2luZy50d29YU30pYCxcbiAgICAgIGhlaWdodDogYGNhbGMoJHt0aGVtZS5zaXplcy5jaGVja2JveH0gLSAke3RoZW1lLnNwYWNpbmcudHdvWFN9KWAsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICB0cmFuc2Zvcm06IGlzQ2hlY2tlZCA/IGB0cmFuc2xhdGVYKCR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAgOiBcIm5vbmVcIixcbiAgICAgIHRyYW5zaXRpb246IFwidHJhbnNmb3JtIDEwMG1zIGVhc2UsIGJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICAgIH1cbiAgfVxuKVxuXG4vKipcbiAqIEZvb3RlciBjb250YWluZXIgZm9yIHRoZSB2ZXJzaW9uIHN0cmluZy5cbiAqIExpdmVzIG91dHNpZGUgdGhlIHJvbGU9XCJtZW51XCIgY29udGFpbmVyIChhcyBhIHNpYmxpbmcgd2l0aGluIHRoZVxuICogcG9wb3Zlcikgc28gdGhlIENvcHlCdXR0b24gaXMgbm90IGFuIGludmFsaWQgY2hpbGQgb2Ygcm9sZT1cIm1lbnVcIi5cbiAqIEtleWJvYXJkIHVzZXJzIHJlYWNoIHRoZSBDb3B5QnV0dG9uIHZpYSBUYWI7IGZvY3VzLWxvY2sga2VlcHNcbiAqIGZvY3VzIHdpdGhpbiB0aGUgcG9wb3Zlci5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uRm9vdGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgZm9yIHZlcnNpb24gdGV4dCArIGNvcHkgYnV0dG9uLlxuICogVGhlIGNvcHkgYnV0dG9uIGlzIGhpZGRlbiB1bnRpbCBob3Zlci9mb2N1cy13aXRoaW4uXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51VmVyc2lvblJvdyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnhzLFxuXG4gIFwiLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6IHtcbiAgICBvcGFjaXR5OiAwLFxuICAgIHBvaW50ZXJFdmVudHM6IFwibm9uZVwiLFxuICAgIHRyYW5zaXRpb246IFwib3BhY2l0eSAxMjBtcyBlYXNlXCIsXG4gIH0sXG5cbiAgXCImOmhvdmVyIC5zdE1lbnVWZXJzaW9uQ29weUJ1dHRvbiwgJjpmb2N1cy13aXRoaW4gLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6XG4gICAge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICAgIHBvaW50ZXJFdmVudHM6IFwiYXV0b1wiLFxuICAgIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uVGV4dCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgb3BhY2l0eTogMC42LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuIl19 */"), StyledThemeRadioGroup = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq808"
} : {
  target: "e16jpq808",
  label: "StyledThemeRadioGroup"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "row",
  gap: CA.spacing.threeXS,
  width: "100%"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledThemeRadioItem = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e16jpq807"
} : {
  target: "e16jpq807",
  label: "StyledThemeRadioItem"
})(({
  theme: CA,
  isChecked: gA
}) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: CA.spacing.twoXS,
  padding: `${CA.spacing.xs} ${CA.spacing.sm}`,
  border: "none",
  borderRadius: CA.radii.default,
  backgroundColor: gA ? CA.colors.darkenedBgMix25 : CA.colors.transparent,
  cursor: "pointer",
  fontSize: CA.fontSizes.sm,
  lineHeight: CA.lineHeights.tight,
  color: CA.colors.bodyText,
  transition: "background-color 100ms ease",
  "&:hover": {
    backgroundColor: gA ? CA.colors.darkenedBgMix25 : CA.colors.darkenedBgMix15
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    boxShadow: CA.shadows.focusRingMuted,
    backgroundColor: gA ? CA.colors.darkenedBgMix25 : CA.colors.darkenedBgMix15
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledThemeRadioIcon = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq806"
} : {
  target: "e16jpq806",
  label: "StyledThemeRadioIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "pl708y",
  styles: "display:inline-flex;align-items:center;justify-content:center"
} : {
  name: "pl708y",
  styles: "display:inline-flex;align-items:center;justify-content:center/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
}), StyledToggleRow = /* @__PURE__ */ createStyled("button", process.env.NODE_ENV === "production" ? {
  target: "e16jpq805"
} : {
  target: "e16jpq805",
  label: "StyledToggleRow"
})(({
  theme: CA,
  isDisabled: gA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: `${CA.spacing.threeXS} ${CA.spacing.sm}`,
  border: "none",
  borderRadius: CA.radii.default,
  backgroundColor: CA.colors.transparent,
  cursor: gA ? "not-allowed" : "pointer",
  color: gA ? CA.colors.fadedText60 : CA.colors.bodyText,
  fontSize: CA.fontSizes.sm,
  lineHeight: `${CA.lineHeights.small}rem`,
  textAlign: "left",
  fontWeight: CA.fontWeights.normal,
  transition: "background-color 100ms ease",
  "&:hover": {
    backgroundColor: gA ? CA.colors.transparent : CA.colors.darkenedBgMix15
  },
  "&:focus": {
    outline: "none"
  },
  "&:focus-visible": {
    backgroundColor: CA.colors.darkenedBgMix15,
    boxShadow: CA.shadows.focusRingMuted
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToggleTrack = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq804"
} : {
  target: "e16jpq804",
  label: "StyledToggleTrack"
})(({
  theme: CA,
  isChecked: gA,
  isDisabled: AA
}) => ({
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  width: `calc(2 * ${CA.sizes.checkbox})`,
  minWidth: `calc(2 * ${CA.sizes.checkbox})`,
  height: CA.sizes.checkbox,
  minHeight: CA.sizes.checkbox,
  padding: `0 ${CA.spacing.threeXS}`,
  borderRadius: CA.radii.full,
  backgroundColor: gA && !AA ? CA.colors.primary : CA.colors.borderColor,
  transition: "background-color 100ms ease"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToggleKnob = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq803"
} : {
  target: "e16jpq803",
  label: "StyledToggleKnob"
})(({
  theme: CA,
  isChecked: gA,
  isDisabled: AA
}) => {
  const IA = hasLightBackgroundColor(CA);
  let BA = IA ? CA.colors.bgColor : CA.colors.bodyText;
  return AA && (BA = IA ? CA.colors.gray70 : CA.colors.gray90), {
    width: `calc(${CA.sizes.checkbox} - ${CA.spacing.twoXS})`,
    height: `calc(${CA.sizes.checkbox} - ${CA.spacing.twoXS})`,
    borderRadius: CA.radii.full,
    backgroundColor: BA,
    transform: gA ? `translateX(${CA.sizes.checkbox})` : "none",
    transition: "transform 100ms ease, background-color 100ms ease"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuVersionFooter = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq802"
} : {
  target: "e16jpq802",
  label: "StyledMenuVersionFooter"
})(({
  theme: CA
}) => ({
  paddingLeft: CA.spacing.sm,
  paddingRight: CA.spacing.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledMenuVersionRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16jpq801"
} : {
  target: "e16jpq801",
  label: "StyledMenuVersionRow"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  gap: CA.spacing.sm,
  marginTop: CA.spacing.xs,
  ".stMenuVersionCopyButton": {
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 120ms ease"
  },
  "&:hover .stMenuVersionCopyButton, &:focus-within .stMenuVersionCopyButton": {
    opacity: 1,
    pointerEvents: "auto"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErVW9DIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9NYWluTWVudS9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgeyBrZXlmcmFtZXMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3RcIlxuaW1wb3J0IHsgS2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3NlcmlhbGl6ZVwiXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5pbXBvcnQgeyBFbW90aW9uVGhlbWUsIGhhc0xpZ2h0QmFja2dyb3VuZENvbG9yIH0gZnJvbSBcIkBzdHJlYW1saXQvbGliXCJcblxuY29uc3QgcmVjb3JkaW5nSW5kaWNhdG9yUHVsc2UgPSAodGhlbWU6IEVtb3Rpb25UaGVtZSk6IEtleWZyYW1lcyA9PiBrZXlmcmFtZXNgXG4wJSB7XG4gIGJveC1zaGFkb3c6IDAgMCAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG41MCUge1xuICBib3gtc2hhZG93OiAwIDAgJHt0aGVtZS5zcGFjaW5nLnNtfSAke3RoZW1lLnNwYWNpbmcudHdvWFN9ICR7dGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcn07XG59XG4xMDAlIHtcbiAgYm94LXNoYWRvdzogMCAwICR7dGhlbWUuc3BhY2luZy50d29YU30gJHt0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yfTtcbn1gXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRpbmdJbmRpY2F0b3IgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBvc2l0aW9uOiBcImFic29sdXRlXCIsXG4gIGJvdHRvbTogdGhlbWUuc3BhY2luZy5sZyxcbiAgcmlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIHdpZHRoOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBoZWlnaHQ6IHRoZW1lLnNwYWNpbmcuc20sXG4gIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnJlZFRleHRDb2xvcixcbiAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5mdWxsLFxuICBib3hTaGFkb3c6IGAwIDAgJHt0aGVtZS5zcGFjaW5nLnR3b1hTfSAke3RoZW1lLmNvbG9ycy5yZWRUZXh0Q29sb3J9YCxcbiAgYW5pbWF0aW9uOiBgJHtyZWNvcmRpbmdJbmRpY2F0b3JQdWxzZSh0aGVtZSl9IDJzIGxpbmVhciBpbmZpbml0ZWAsXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVEaXZpZGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBib3JkZXJUb3A6IGAke3RoZW1lLnNpemVzLmJvcmRlcldpZHRofSBzb2xpZCAke3RoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcn1gLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuLyoqXG4gKiBPdXRlcm1vc3Qgd3JhcHBlciBmb3IgdGhlIHBvcG92ZXIgYm9keSAobWVudSArIG9wdGlvbmFsIGZvb3RlcikuXG4gKiBPd25zIG91dGVyIHBhZGRpbmc7IHRoZSBmb290ZXIgYWRkcyBpdHMgb3duIGhvcml6b250YWwgcGFkZGluZ1xuICogc28gaXRzIGNvbnRlbnQgd2lkdGggY29udHJpYnV0ZXMgdG8gdGhlIHBvcG92ZXIncyBpbnRyaW5zaWMgd2lkdGhcbiAqIChtYXRjaGluZyB0aGUgZGV2ZWxvcC1icmFuY2ggbGF5b3V0IHdoZXJlIGl0IHdhcyBpbnNpZGUgdGhlIGNvbnRhaW5lcikuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51UG9wb3ZlckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIHBhZGRpbmc6IHRoZW1lLnNwYWNpbmcuc20sXG4gIG1pbldpZHRoOiB0aGVtZS5zaXplcy5hcHBNYWluTWVudSxcblxuICBcIkBtZWRpYSBwcmludFwiOiB7XG4gICAgZGlzcGxheTogXCJub25lXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBmbGV4RGlyZWN0aW9uOiBcImNvbHVtblwiLFxuICBhbGlnbkl0ZW1zOiBcInN0cmV0Y2hcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnhzLFxufSkpXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNYWluTWVudUNvbnRhaW5lciA9IHN0eWxlZC5zcGFuKHtcbiAgbGluZUhlaWdodDogXCJpbml0aWFsXCIsXG59KVxuXG5pbnRlcmZhY2UgU3R5bGVkTWVudUl0ZW1Sb3dQcm9wcyB7XG4gIGlzUmVjb3JkaW5nPzogYm9vbGVhblxufVxuXG4vKipcbiAqIE1lbnUgaXRlbSBidXR0b24gd2l0aCBob3ZlciBoaWdobGlnaHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkTWVudUl0ZW1Sb3dQcm9wcz4oXG4gICh7IHRoZW1lLCBpc1JlY29yZGluZyB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgcGFkZGluZzogYCR7dGhlbWUuc3BhY2luZy50aHJlZVhTfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgLy8gTmVlZCB0byBleHBsaWNpdGx5IHNldCB1bml0IHRvIHJlbSB0byBnZXQgMjRweCBsaW5lIGhlaWdodFxuICAgIGxpbmVIZWlnaHQ6IGAke3RoZW1lLmxpbmVIZWlnaHRzLnNtYWxsfXJlbWAsXG4gICAgdGV4dEFsaWduOiBcImxlZnRcIixcbiAgICBjb2xvcjogaXNSZWNvcmRpbmcgPyB0aGVtZS5jb2xvcnMucmVkVGV4dENvbG9yIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRXZWlnaHQ6IGlzUmVjb3JkaW5nXG4gICAgICA/IHRoZW1lLmZvbnRXZWlnaHRzLmJvbGRcbiAgICAgIDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIHRyYW5zaXRpb246IFwiYmFja2dyb3VuZC1jb2xvciAxMDBtcyBlYXNlXCIsXG5cbiAgICBcIiY6aG92ZXIsICY6Zm9jdXMtdmlzaWJsZVwiOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG5cbiAgICAnJlthcmlhLWRpc2FibGVkPVwidHJ1ZVwiXSc6IHtcbiAgICAgIGNvbG9yOiB0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NjAsXG4gICAgICBjdXJzb3I6IFwibm90LWFsbG93ZWRcIixcbiAgICB9LFxuXG4gICAgJyZbYXJpYS1kaXNhYmxlZD1cInRydWVcIl06aG92ZXInOiB7XG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIENvbnRhaW5lciBmb3IgbWVudSBpdGVtIGNvbnRlbnQgKGxhYmVsICsgc2hvcnRjdXQpLlxuICovXG5leHBvcnQgY29uc3QgU3R5bGVkTWVudUl0ZW1Db250ZW50ID0gc3R5bGVkLnNwYW4oKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIHdpZHRoOiBcIjEwMCVcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogTWVudSBpdGVtIGxhYmVsIHRleHQuXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51SXRlbUxhYmVsID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIG1pbldpZHRoOiAwLFxuICBvdmVyZmxvdzogXCJoaWRkZW5cIixcbiAgdGV4dE92ZXJmbG93OiBcImVsbGlwc2lzXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG59KVxuXG4vKipcbiAqIEtleWJvYXJkIHNob3J0Y3V0IGluZGljYXRvciBmb3IgbWVudSBpdGVtcy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVJdGVtU2hvcnRjdXQgPSBzdHlsZWQua2JkKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAganVzdGlmeUNvbnRlbnQ6IFwiY2VudGVyXCIsXG4gIHdoaXRlU3BhY2U6IFwibm93cmFwXCIsXG4gIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gIG9wYWNpdHk6IDAuNixcbiAgZm9udEZhbWlseTogXCJpbmhlcml0XCIsXG4gIGxpbmVIZWlnaHQ6IHRoZW1lLmxpbmVIZWlnaHRzLnRpZ2h0LFxuICBsZXR0ZXJTcGFjaW5nOiBcIjAuMDFlbVwiLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgY29udGFpbmVyIGZvciB0aGVtZSByYWRpbyBidXR0b25zLlxuICogVXNlcyB0aGUgZnVsbCBtZW51IHdpZHRoIHdpdGggZXF1YWwgc3BhY2luZy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9Hcm91cCA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGZsZXhEaXJlY3Rpb246IFwicm93XCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy50aHJlZVhTLFxuICB3aWR0aDogXCIxMDAlXCIsXG59KSlcblxuaW50ZXJmYWNlIFN0eWxlZFRoZW1lUmFkaW9JdGVtUHJvcHMge1xuICBpc0NoZWNrZWQ6IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBJbmRpdmlkdWFsIHRoZW1lIHJhZGlvIGJ1dHRvbiB3aXRoIGljb24gKyBsYWJlbCwgZmxleCBjb2x1bW4gbGF5b3V0LlxuICogQWN0aXZlIHN0YXRlIHVzZXMgZGFya2VuZWRCZ01peDI1OyBob3ZlciB1c2VzIGRhcmtlbmVkQmdNaXgxNS5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JdGVtID0gc3R5bGVkLmJ1dHRvbjxTdHlsZWRUaGVtZVJhZGlvSXRlbVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGZsZXg6IDEsXG4gICAgZmxleERpcmVjdGlvbjogXCJjb2x1bW5cIixcbiAgICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAgIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxuICAgIGdhcDogdGhlbWUuc3BhY2luZy50d29YUyxcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnhzfSAke3RoZW1lLnNwYWNpbmcuc219YCxcbiAgICBib3JkZXI6IFwibm9uZVwiLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZGVmYXVsdCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGlzQ2hlY2tlZFxuICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICA6IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBjdXJzb3I6IFwicG9pbnRlclwiLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogdGhlbWUubGluZUhlaWdodHMudGlnaHQsXG4gICAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNDaGVja2VkXG4gICAgICAgID8gdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgyNVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0NoZWNrZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDI1XG4gICAgICAgIDogdGhlbWUuY29sb3JzLmRhcmtlbmVkQmdNaXgxNSxcbiAgICB9LFxuICB9KVxuKVxuXG4vKipcbiAqIFdyYXBwZXIgZm9yIER5bmFtaWNJY29uIHNpemluZyBpbnNpZGUgdGhlbWUgcmFkaW8gYnV0dG9ucy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRoZW1lUmFkaW9JY29uID0gc3R5bGVkLnNwYW4oe1xuICBkaXNwbGF5OiBcImlubGluZS1mbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGp1c3RpZnlDb250ZW50OiBcImNlbnRlclwiLFxufSlcblxuaW50ZXJmYWNlIFN0eWxlZFRvZ2dsZVJvd1Byb3BzIHtcbiAgaXNEaXNhYmxlZD86IGJvb2xlYW5cbn1cblxuLyoqXG4gKiBSb3cgY29udGFpbmVyIGZvciBhIHRvZ2dsZSBzd2l0Y2ggaW5zaWRlIHRoZSBtZW51LlxuICogT3ducyBmb2N1cywgY2xpY2sgaGFuZGxpbmcsIGFuZCBob3Zlci9mb2N1cy12aXNpYmxlIHN0eWxpbmdcbiAqIGNvbnNpc3RlbnQgd2l0aCBTdHlsZWRNZW51SXRlbVJvdy5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZFRvZ2dsZVJvdyA9IHN0eWxlZC5idXR0b248U3R5bGVkVG9nZ2xlUm93UHJvcHM+KFxuICAoeyB0aGVtZSwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAganVzdGlmeUNvbnRlbnQ6IFwic3BhY2UtYmV0d2VlblwiLFxuICAgIHdpZHRoOiBcIjEwMCVcIixcbiAgICBwYWRkaW5nOiBgJHt0aGVtZS5zcGFjaW5nLnRocmVlWFN9ICR7dGhlbWUuc3BhY2luZy5zbX1gLFxuICAgIGJvcmRlcjogXCJub25lXCIsXG4gICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5yYWRpaS5kZWZhdWx0LFxuICAgIGJhY2tncm91bmRDb2xvcjogdGhlbWUuY29sb3JzLnRyYW5zcGFyZW50LFxuICAgIGN1cnNvcjogaXNEaXNhYmxlZCA/IFwibm90LWFsbG93ZWRcIiA6IFwicG9pbnRlclwiLFxuICAgIGNvbG9yOiBpc0Rpc2FibGVkID8gdGhlbWUuY29sb3JzLmZhZGVkVGV4dDYwIDogdGhlbWUuY29sb3JzLmJvZHlUZXh0LFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMuc20sXG4gICAgbGluZUhlaWdodDogYCR7dGhlbWUubGluZUhlaWdodHMuc21hbGx9cmVtYCxcbiAgICB0ZXh0QWxpZ246IFwibGVmdFwiLFxuICAgIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogaXNEaXNhYmxlZFxuICAgICAgICA/IHRoZW1lLmNvbG9ycy50cmFuc3BhcmVudFxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5kYXJrZW5lZEJnTWl4MTUsXG4gICAgfSxcblxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICB9LFxuXG4gICAgXCImOmZvY3VzLXZpc2libGVcIjoge1xuICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5jb2xvcnMuZGFya2VuZWRCZ01peDE1LFxuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3dzLmZvY3VzUmluZ011dGVkLFxuICAgIH0sXG4gIH0pXG4pXG5cbmludGVyZmFjZSBTdHlsZWRUb2dnbGVQcm9wcyB7XG4gIGlzQ2hlY2tlZDogYm9vbGVhblxuICBpc0Rpc2FibGVkPzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlVHJhY2sgPSBzdHlsZWQuZGl2PFN0eWxlZFRvZ2dsZVByb3BzPihcbiAgKHsgdGhlbWUsIGlzQ2hlY2tlZCwgaXNEaXNhYmxlZCB9KSA9PiAoe1xuICAgIGRpc3BsYXk6IFwiZmxleFwiLFxuICAgIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gICAgZmxleFNocmluazogMCxcbiAgICB3aWR0aDogYGNhbGMoMiAqICR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAsXG4gICAgbWluV2lkdGg6IGBjYWxjKDIgKiAke3RoZW1lLnNpemVzLmNoZWNrYm94fSlgLFxuICAgIGhlaWdodDogdGhlbWUuc2l6ZXMuY2hlY2tib3gsXG4gICAgbWluSGVpZ2h0OiB0aGVtZS5zaXplcy5jaGVja2JveCxcbiAgICBwYWRkaW5nOiBgMCAke3RoZW1lLnNwYWNpbmcudGhyZWVYU31gLFxuICAgIGJvcmRlclJhZGl1czogdGhlbWUucmFkaWkuZnVsbCxcbiAgICBiYWNrZ3JvdW5kQ29sb3I6XG4gICAgICBpc0NoZWNrZWQgJiYgIWlzRGlzYWJsZWRcbiAgICAgICAgPyB0aGVtZS5jb2xvcnMucHJpbWFyeVxuICAgICAgICA6IHRoZW1lLmNvbG9ycy5ib3JkZXJDb2xvcixcbiAgICB0cmFuc2l0aW9uOiBcImJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICB9KVxuKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkVG9nZ2xlS25vYiA9IHN0eWxlZC5kaXY8U3R5bGVkVG9nZ2xlUHJvcHM+KFxuICAoeyB0aGVtZSwgaXNDaGVja2VkLCBpc0Rpc2FibGVkIH0pID0+IHtcbiAgICBjb25zdCBsaWdodFRoZW1lID0gaGFzTGlnaHRCYWNrZ3JvdW5kQ29sb3IodGhlbWUpXG5cbiAgICBsZXQgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZVxuICAgICAgPyB0aGVtZS5jb2xvcnMuYmdDb2xvclxuICAgICAgOiB0aGVtZS5jb2xvcnMuYm9keVRleHRcbiAgICBpZiAoaXNEaXNhYmxlZCkge1xuICAgICAgYmFja2dyb3VuZENvbG9yID0gbGlnaHRUaGVtZSA/IHRoZW1lLmNvbG9ycy5ncmF5NzAgOiB0aGVtZS5jb2xvcnMuZ3JheTkwXG4gICAgfVxuXG4gICAgcmV0dXJuIHtcbiAgICAgIHdpZHRoOiBgY2FsYygke3RoZW1lLnNpemVzLmNoZWNrYm94fSAtICR7dGhlbWUuc3BhY2luZy50d29YU30pYCxcbiAgICAgIGhlaWdodDogYGNhbGMoJHt0aGVtZS5zaXplcy5jaGVja2JveH0gLSAke3RoZW1lLnNwYWNpbmcudHdvWFN9KWAsXG4gICAgICBib3JkZXJSYWRpdXM6IHRoZW1lLnJhZGlpLmZ1bGwsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3IsXG4gICAgICB0cmFuc2Zvcm06IGlzQ2hlY2tlZCA/IGB0cmFuc2xhdGVYKCR7dGhlbWUuc2l6ZXMuY2hlY2tib3h9KWAgOiBcIm5vbmVcIixcbiAgICAgIHRyYW5zaXRpb246IFwidHJhbnNmb3JtIDEwMG1zIGVhc2UsIGJhY2tncm91bmQtY29sb3IgMTAwbXMgZWFzZVwiLFxuICAgIH1cbiAgfVxuKVxuXG4vKipcbiAqIEZvb3RlciBjb250YWluZXIgZm9yIHRoZSB2ZXJzaW9uIHN0cmluZy5cbiAqIExpdmVzIG91dHNpZGUgdGhlIHJvbGU9XCJtZW51XCIgY29udGFpbmVyIChhcyBhIHNpYmxpbmcgd2l0aGluIHRoZVxuICogcG9wb3Zlcikgc28gdGhlIENvcHlCdXR0b24gaXMgbm90IGFuIGludmFsaWQgY2hpbGQgb2Ygcm9sZT1cIm1lbnVcIi5cbiAqIEtleWJvYXJkIHVzZXJzIHJlYWNoIHRoZSBDb3B5QnV0dG9uIHZpYSBUYWI7IGZvY3VzLWxvY2sga2VlcHNcbiAqIGZvY3VzIHdpdGhpbiB0aGUgcG9wb3Zlci5cbiAqL1xuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uRm9vdGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy5zbSxcbiAgcGFkZGluZ1JpZ2h0OiB0aGVtZS5zcGFjaW5nLnNtLFxufSkpXG5cbi8qKlxuICogRmxleCByb3cgZm9yIHZlcnNpb24gdGV4dCArIGNvcHkgYnV0dG9uLlxuICogVGhlIGNvcHkgYnV0dG9uIGlzIGhpZGRlbiB1bnRpbCBob3Zlci9mb2N1cy13aXRoaW4uXG4gKi9cbmV4cG9ydCBjb25zdCBTdHlsZWRNZW51VmVyc2lvblJvdyA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsXG4gIGdhcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnhzLFxuXG4gIFwiLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6IHtcbiAgICBvcGFjaXR5OiAwLFxuICAgIHBvaW50ZXJFdmVudHM6IFwibm9uZVwiLFxuICAgIHRyYW5zaXRpb246IFwib3BhY2l0eSAxMjBtcyBlYXNlXCIsXG4gIH0sXG5cbiAgXCImOmhvdmVyIC5zdE1lbnVWZXJzaW9uQ29weUJ1dHRvbiwgJjpmb2N1cy13aXRoaW4gLnN0TWVudVZlcnNpb25Db3B5QnV0dG9uXCI6XG4gICAge1xuICAgICAgb3BhY2l0eTogMSxcbiAgICAgIHBvaW50ZXJFdmVudHM6IFwiYXV0b1wiLFxuICAgIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZE1lbnVWZXJzaW9uVGV4dCA9IHN0eWxlZC5zcGFuKCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgb3BhY2l0eTogMC42LFxuICBmb250U2l6ZTogdGhlbWUuZm9udFNpemVzLnR3b1NtLFxuICBsaW5lSGVpZ2h0OiB0aGVtZS5saW5lSGVpZ2h0cy5tZW51SXRlbSxcbiAgY29sb3I6IHRoZW1lLmNvbG9ycy5ib2R5VGV4dCxcbiAgd2hpdGVTcGFjZTogXCJub3dyYXBcIixcbn0pKVxuIl19 */"), StyledMenuVersionText = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "e16jpq800"
} : {
  target: "e16jpq800",
  label: "StyledMenuVersionText"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  alignItems: "center",
  opacity: 0.6,
  fontSize: CA.fontSizes.twoSm,
  lineHeight: CA.lineHeights.menuItem,
  color: CA.colors.bodyText,
  whiteSpace: "nowrap"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), THEME_OPTIONS = [{
  label: "System",
  icon: ":material/contrast:"
}, {
  label: "Light",
  icon: ":material/light_mode:"
}, {
  label: "Dark",
  icon: ":material/dark_mode:"
}];
function findThemeForSelection(CA, gA) {
  switch (CA) {
    case "System":
      return gA.find((AA) => AA.name === CUSTOM_THEME_AUTO_NAME || AA.name === AUTO_THEME_NAME);
    case "Light":
      return gA.find((AA) => AA.name === CUSTOM_THEME_LIGHT_NAME || AA.name === lightTheme.name);
    case "Dark":
      return gA.find((AA) => AA.name === CUSTOM_THEME_DARK_NAME || AA.name === darkTheme.name);
  }
}
function buildThemeSection(CA, gA, AA, IA) {
  if (gA.length <= 1)
    return [];
  const BA = getThemeSelectionFromThemeConfig(CA);
  return THEME_OPTIONS.map((QA) => ({
    type: "radio",
    key: `theme-${QA.label}`,
    label: QA.label,
    icon: QA.icon,
    checked: BA === QA.label,
    onSelect: () => {
      const EA = findThemeForSelection(QA.label, gA);
      EA && (IA.enqueue("menuClick", {
        label: "changeTheme"
      }), AA(EA));
    }
  }));
}
const ToggleItemRow = memo(function CA({
  item: gA,
  tabIndex: AA,
  itemIndex: IA,
  setItemRef: BA
}) {
  const {
    key: QA,
    label: EA,
    checked: iA,
    disabled: oA,
    onToggle: cA
  } = gA, tA = useCallback((aA) => {
    BA(IA, aA);
  }, [BA, IA]), eA = useCallback(() => {
    oA || cA();
  }, [oA, cA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledToggleRow, { ref: tA, type: "button", isDisabled: oA, role: "menuitemcheckbox", "aria-checked": iA, "aria-disabled": oA || void 0, tabIndex: AA, onClick: eA, "data-testid": `stMainMenuItem-${QA}`, children: [
    EA,
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToggleTrack, { isChecked: iA, isDisabled: oA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToggleKnob, { isChecked: iA, isDisabled: oA }) })
  ] });
}), LOG$4 = loglevelExports.getLogger("MainMenu"), SCREENCAST_LABEL = {
  COUNTDOWN: "Cancel recording",
  RECORDING: "Stop recording"
}, MENU_OPEN_KEYS = /* @__PURE__ */ new Set(["Enter", " ", "Space", "Spacebar"]);
function formatDisplayVersion(CA) {
  return CA.replace(/\.dev\d+/, ".dev");
}
function openInNewTab(CA, gA) {
  window.open(CA, "_blank") || LOG$4.warn(`Failed to open "${gA}" link. This may be due to a popup blocker. URL: ${CA}`);
}
function isRadioItem(CA) {
  return CA.type === "radio";
}
function isToggleItem(CA) {
  return CA.type === "toggle";
}
function buildMenuData({
  isServerConnected: CA,
  developmentMode: gA,
  screenCastState: AA,
  menuItems: IA,
  hostMenuItems: BA,
  quickRerunCallback: QA,
  clearCacheCallback: EA,
  printCallback: iA,
  screencastCallback: oA,
  aboutCallback: cA,
  sendMessageToHost: tA,
  isMinimalMode: eA,
  themeSection: aA,
  runOnSave: GA,
  onRunOnSaveChange: lA,
  allowRunOnSave: nA,
  metricsMgr: DA
}) {
  const hA = !CA, wA = buildCommonItems(IA, BA, tA), sA = buildAboutItem(IA, cA);
  if (eA)
    return [aA, [...wA, ...sA]];
  const NA = buildStandardItems(AA, iA, oA);
  return [aA, buildDevItems(gA, QA, hA, GA, lA, nA, DA), buildClearCacheItem(gA, EA, hA), [...NA, ...sA], wA];
}
function buildDevItems(CA, gA, AA, IA, BA, QA, EA) {
  if (!CA)
    return [];
  const iA = [{
    type: "action",
    key: "rerun",
    label: "Rerun",
    onClick: gA,
    disabled: AA,
    shortcut: "R"
  }];
  return QA && iA.push({
    type: "toggle",
    key: "autoRerun",
    label: "Auto rerun",
    checked: IA,
    disabled: AA,
    onToggle: () => {
      EA.enqueue("menuClick", {
        label: "autoRerun"
      }), BA(!IA);
    }
  }), iA;
}
function buildClearCacheItem(CA, gA, AA) {
  return CA ? [{
    type: "action",
    key: "clearCache",
    label: "Clear cache",
    onClick: gA,
    disabled: AA,
    shortcut: "C"
  }] : [];
}
function buildStandardItems(CA, gA, AA) {
  const IA = [{
    type: "action",
    key: "print",
    label: "Print",
    onClick: gA
  }];
  if (ScreenCastRecorder.isSupportedBrowser()) {
    const BA = SCREENCAST_LABEL[CA] || "Record screen";
    IA.push({
      type: "action",
      key: "recordScreencast",
      label: BA,
      onClick: AA,
      isRecording: !!SCREENCAST_LABEL[CA],
      shortcut: SCREENCAST_LABEL[CA] ? "ESC" : void 0
    });
  }
  return IA;
}
function buildCommonItems(CA, gA, AA) {
  const IA = [], BA = CA?.reportABugUrl;
  BA && !CA?.hideReportABug && IA.push({
    type: "action",
    key: "report",
    label: "Report a bug",
    onClick: () => openInNewTab(BA, "Report a bug")
  });
  const QA = CA?.getHelpUrl;
  QA && !CA?.hideGetHelp && IA.push({
    type: "action",
    key: "community",
    label: "Get help",
    onClick: () => openInNewTab(QA, "Get help")
  });
  for (const EA of gA)
    EA.type !== "separator" && (EA.key === "reportBug" && CA?.hideGetHelp || EA.key === "about" && CA?.aboutSectionMd || IA.push({
      type: "action",
      key: `host-${EA.key}`,
      label: EA.label,
      onClick: () => AA({
        type: "MENU_ITEM_CALLBACK",
        key: EA.key
      })
    }));
  return IA;
}
function buildAboutItem(CA, gA) {
  return CA?.aboutSectionMd ? [{
    type: "action",
    key: "about",
    label: "About",
    onClick: gA
  }] : [];
}
const MenuItemRow = memo(function CA({
  item: gA,
  onItemClick: AA,
  tabIndex: IA,
  itemIndex: BA,
  setItemRef: QA
}) {
  const EA = () => {
    gA.disabled || AA(gA);
  }, iA = useCallback((oA) => {
    QA(BA, oA);
  }, [QA, BA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemRow, { type: "button", ref: iA, onClick: EA, role: "menuitem", "aria-disabled": gA.disabled || void 0, tabIndex: IA, isRecording: gA.isRecording, "data-testid": `stMainMenuItem-${gA.key}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuItemContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemLabel, { "data-testid": "stMainMenuItemLabel", children: gA.label }),
    gA.shortcut && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuItemShortcut, { children: gA.shortcut })
  ] }) });
}), ThemeRadioItemRow = memo(function CA({
  item: gA,
  onRadioSelect: AA,
  tabIndex: IA,
  itemIndex: BA,
  setItemRef: QA
}) {
  const EA = () => {
    AA(gA);
  }, iA = useCallback((oA) => {
    QA(BA, oA);
  }, [QA, BA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledThemeRadioItem, { type: "button", ref: iA, onClick: EA, role: "menuitemradio", "aria-checked": gA.checked, tabIndex: IA, isChecked: gA.checked, "data-testid": `stMainMenuItem-${gA.key}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledThemeRadioIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { iconValue: gA.icon, size: "lg" }) }),
    gA.label
  ] });
});
function MenuContent({
  sections: CA,
  closeMenu: gA,
  metricsMgr: AA,
  streamlitVersion: IA
}) {
  const BA = useEmotionTheme(), QA = useRef([]), EA = useMemo$1(() => CA.flat(), [CA]), [iA, oA] = useState(0), cA = Math.max(0, EA.length - 1), tA = EA.length === 0 ? -1 : Math.min(iA, cA), eA = (yA) => {
    oA(yA), QA.current[yA]?.focus();
  }, aA = useCallback((yA) => {
    yA && QA.current[0]?.focus();
  }, []), GA = useCallback((yA, bA) => {
    QA.current[yA] = bA;
  }, []), lA = (yA) => {
    const bA = yA.target, RA = QA.current.findIndex((FA) => FA === bA);
    RA !== -1 && oA(RA);
  }, nA = (yA) => {
    AA.enqueue("menuClick", {
      label: yA.label
    }), yA.onClick(), gA();
  }, DA = (yA) => {
    yA.onSelect();
  }, hA = (yA) => {
    if (EA.length !== 0)
      switch (yA.key) {
        case "ArrowDown": {
          yA.preventDefault(), eA(tA >= cA ? 0 : tA + 1);
          break;
        }
        case "ArrowUp": {
          yA.preventDefault(), eA(tA <= 0 ? cA : tA - 1);
          break;
        }
        case "Home": {
          yA.preventDefault(), eA(0);
          break;
        }
        case "End": {
          yA.preventDefault(), eA(cA);
          break;
        }
        case "Escape": {
          yA.preventDefault(), gA("escape");
          break;
        }
        case "Tab": {
          if (IA)
            break;
          yA.preventDefault(), gA(yA.shiftKey ? "shift-tab" : "tab");
          break;
        }
      }
  }, wA = (yA) => {
    switch (yA.key) {
      case "Tab": {
        yA.shiftKey || (yA.preventDefault(), gA("tab"));
        break;
      }
      case "Escape": {
        yA.preventDefault(), gA("escape");
        break;
      }
    }
  }, sA = [];
  let NA = 0, rA = 0;
  for (const yA of CA) {
    if (yA.length === 0) continue;
    if (sA.length > 0 && (sA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuDivider, { role: "separator", "aria-hidden": "true", "data-testid": "stMainMenuDivider" }, `divider-${NA}`)), NA += 1), isRadioItem(yA[0])) {
      const RA = rA;
      sA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(StyledThemeRadioGroup, { role: "group", "aria-label": "Theme", "data-testid": "stThemeSwitcher", children: yA.map((FA, dA) => {
        const kA = RA + dA;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeRadioItemRow, { item: FA, onRadioSelect: DA, tabIndex: tA === kA ? 0 : -1, itemIndex: kA, setItemRef: GA }, FA.key);
      }) }, "theme-radio-group")), rA += yA.length;
    } else
      for (const RA of yA)
        isToggleItem(RA) ? sA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(ToggleItemRow, { item: RA, tabIndex: tA === rA ? 0 : -1, itemIndex: rA, setItemRef: GA }, RA.key)) : sA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRow, { item: RA, onItemClick: nA, tabIndex: tA === rA ? 0 : -1, itemIndex: rA, setItemRef: GA }, RA.key)), rA += 1;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuPopoverContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuContainer, { ref: aA, "data-testid": "stMainMenuList", "aria-label": "Main menu", role: "menu", onFocus: lA, onKeyDown: hA, children: sA }),
    IA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuVersionFooter, { onKeyDown: wA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuVersionRow, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMenuVersionText, { children: [
        "Made with Streamlit v",
        formatDisplayVersion(IA)
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CopyButton$1, { text: IA, buttonSize: BA.iconSizes.md, iconSize: BA.iconSizes.sm, className: "stMenuVersionCopyButton", copyLabel: "Copy version to clipboard", copiedLabel: "Copied" })
    ] }) })
  ] });
}
function MainMenu(CA) {
  const {
    isServerConnected: gA,
    developmentMode: AA,
    screenCastState: IA,
    menuItems: BA,
    hostMenuItems: QA,
    toolbarMode: EA,
    metricsMgr: iA,
    quickRerunCallback: oA,
    clearCacheCallback: cA,
    printCallback: tA,
    screencastCallback: eA,
    aboutCallback: aA,
    sendMessageToHost: GA,
    runOnSave: lA,
    onRunOnSaveChange: nA,
    allowRunOnSave: DA,
    streamlitVersion: hA
  } = CA, wA = useEmotionTheme(), sA = EA === Config.ToolbarMode.MINIMAL, {
    activeTheme: NA,
    availableThemes: rA,
    setTheme: yA
  } = useContext(ThemeContext), bA = useMemo$1(() => buildThemeSection(NA, rA, yA, iA), [NA, rA, yA, iA]), RA = useMemo$1(() => buildMenuData({
    isServerConnected: gA,
    developmentMode: AA,
    screenCastState: IA,
    menuItems: BA,
    hostMenuItems: QA,
    quickRerunCallback: oA,
    clearCacheCallback: cA,
    printCallback: tA,
    screencastCallback: eA,
    aboutCallback: aA,
    sendMessageToHost: GA,
    isMinimalMode: sA,
    themeSection: bA,
    runOnSave: lA,
    onRunOnSaveChange: nA,
    allowRunOnSave: DA,
    metricsMgr: iA
  }), [gA, AA, IA, BA, QA, oA, cA, tA, eA, aA, GA, sA, bA, lA, nA, DA, iA]), [FA, dA] = useState(!1), kA = useRef(null), pA = useRef("other"), YA = useCallback(() => {
    dA(!0);
  }, []), SA = useCallback(() => {
    dA(!1);
  }, []), JA = useCallback((zA) => {
    const _A = pA.current;
    pA.current = "other";
    const uA = kA.current;
    return uA && (_A === "tab" ? focusNextElement(uA) : _A === "shift-tab" ? focusPrevElement(uA) : uA.focus()), !1;
  }, []), UA = useCallback((zA) => {
    MENU_OPEN_KEYS.has(zA.key) && (zA.preventDefault(), zA.currentTarget.click());
  }, []), fA = RA.some((zA) => zA.length > 0);
  return sA && !fA ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(
    StatefulPopover,
    {
      focusLock: !0,
      returnFocus: JA,
      accessibilityType: ACCESSIBILITY_TYPE.none,
      onOpen: YA,
      onClose: SA,
      placement: PLACEMENT.bottomRight,
      content: ({
        close: zA
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContent, { sections: RA, closeMenu: (_A) => {
        pA.current = _A ?? "other", zA();
      }, metricsMgr: iA, streamlitVersion: hA }),
      overrides: {
        Body: {
          props: {
            "data-testid": "stMainMenuPopover",
            className: "stMainMenuPopover"
          },
          style: {
            ...getPopoverContainerStyle(wA)
          }
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledMainMenuContainer, { id: "MainMenu", className: "stMainMenu", "data-testid": "stMainMenu", onKeyDown: UA, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ref: kA, kind: BaseButtonKind.HEADER_NO_PADDING, "data-testid": "stMainMenuButton", "aria-label": "Main menu", "aria-haspopup": "menu", "aria-expanded": FA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { content: MoreVert, size: "lg" }) }),
        IA === "RECORDING" && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRecordingIndicator, { "data-testid": "stMainMenuRecordingIndicator" })
      ] })
    }
  );
}
const MainMenu$1 = memo(MainMenu);
function hasClass(CA, gA) {
  return CA.classList ? !!gA && CA.classList.contains(gA) : (" " + (CA.className.baseVal || CA.className) + " ").indexOf(" " + gA + " ") !== -1;
}
function addClass(CA, gA) {
  CA.classList ? CA.classList.add(gA) : hasClass(CA, gA) || (typeof CA.className == "string" ? CA.className = CA.className + " " + gA : CA.setAttribute("class", (CA.className && CA.className.baseVal || "") + " " + gA));
}
function replaceClassName(CA, gA) {
  return CA.replace(new RegExp("(^|\\s)" + gA + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(CA, gA) {
  CA.classList ? CA.classList.remove(gA) : typeof CA.className == "string" ? CA.className = replaceClassName(CA.className, gA) : CA.setAttribute("class", replaceClassName(CA.className && CA.className.baseVal || "", gA));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function CA(gA) {
  return gA.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(CA) {
  _inheritsLoose(gA, CA);
  function gA(IA, BA) {
    var QA;
    QA = CA.call(this, IA, BA) || this;
    var EA = BA, iA = EA && !EA.isMounting ? IA.enter : IA.appear, oA;
    return QA.appearStatus = null, IA.in ? iA ? (oA = EXITED, QA.appearStatus = ENTERING) : oA = ENTERED : IA.unmountOnExit || IA.mountOnEnter ? oA = UNMOUNTED : oA = EXITED, QA.state = {
      status: oA
    }, QA.nextCallback = null, QA;
  }
  gA.getDerivedStateFromProps = function(BA, QA) {
    var EA = BA.in;
    return EA && QA.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var AA = gA.prototype;
  return AA.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, AA.componentDidUpdate = function(BA) {
    var QA = null;
    if (BA !== this.props) {
      var EA = this.state.status;
      this.props.in ? EA !== ENTERING && EA !== ENTERED && (QA = ENTERING) : (EA === ENTERING || EA === ENTERED) && (QA = EXITING);
    }
    this.updateStatus(!1, QA);
  }, AA.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, AA.getTimeouts = function() {
    var BA = this.props.timeout, QA, EA, iA;
    return QA = EA = iA = BA, BA != null && typeof BA != "number" && (QA = BA.exit, EA = BA.enter, iA = BA.appear !== void 0 ? BA.appear : EA), {
      exit: QA,
      enter: EA,
      appear: iA
    };
  }, AA.updateStatus = function(BA, QA) {
    if (BA === void 0 && (BA = !1), QA !== null)
      if (this.cancelNextCallback(), QA === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var EA = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          EA && forceReflow(EA);
        }
        this.performEnter(BA);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, AA.performEnter = function(BA) {
    var QA = this, EA = this.props.enter, iA = this.context ? this.context.isMounting : BA, oA = this.props.nodeRef ? [iA] : [ReactDOM.findDOMNode(this), iA], cA = oA[0], tA = oA[1], eA = this.getTimeouts(), aA = iA ? eA.appear : eA.enter;
    if (!BA && !EA || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        QA.props.onEntered(cA);
      });
      return;
    }
    this.props.onEnter(cA, tA), this.safeSetState({
      status: ENTERING
    }, function() {
      QA.props.onEntering(cA, tA), QA.onTransitionEnd(aA, function() {
        QA.safeSetState({
          status: ENTERED
        }, function() {
          QA.props.onEntered(cA, tA);
        });
      });
    });
  }, AA.performExit = function() {
    var BA = this, QA = this.props.exit, EA = this.getTimeouts(), iA = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!QA || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        BA.props.onExited(iA);
      });
      return;
    }
    this.props.onExit(iA), this.safeSetState({
      status: EXITING
    }, function() {
      BA.props.onExiting(iA), BA.onTransitionEnd(EA.exit, function() {
        BA.safeSetState({
          status: EXITED
        }, function() {
          BA.props.onExited(iA);
        });
      });
    });
  }, AA.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, AA.safeSetState = function(BA, QA) {
    QA = this.setNextCallback(QA), this.setState(BA, QA);
  }, AA.setNextCallback = function(BA) {
    var QA = this, EA = !0;
    return this.nextCallback = function(iA) {
      EA && (EA = !1, QA.nextCallback = null, BA(iA));
    }, this.nextCallback.cancel = function() {
      EA = !1;
    }, this.nextCallback;
  }, AA.onTransitionEnd = function(BA, QA) {
    this.setNextCallback(QA);
    var EA = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this), iA = BA == null && !this.props.addEndListener;
    if (!EA || iA) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var oA = this.props.nodeRef ? [this.nextCallback] : [EA, this.nextCallback], cA = oA[0], tA = oA[1];
      this.props.addEndListener(cA, tA);
    }
    BA != null && setTimeout(this.nextCallback, BA);
  }, AA.render = function() {
    var BA = this.state.status;
    if (BA === UNMOUNTED)
      return null;
    var QA = this.props, EA = QA.children;
    QA.in, QA.mountOnEnter, QA.unmountOnExit, QA.appear, QA.enter, QA.exit, QA.timeout, QA.addEndListener, QA.onEnter, QA.onEntering, QA.onEntered, QA.onExit, QA.onExiting, QA.onExited, QA.nodeRef;
    var iA = _objectWithoutPropertiesLoose$c(QA, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof EA == "function" ? EA(BA, iA) : React__default.cloneElement(React__default.Children.only(EA), iA))
    );
  }, gA;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(CA, gA, AA, IA, BA, QA) {
      var EA = CA[gA];
      return PropTypes.instanceOf(EA && "ownerDocument" in EA ? EA.ownerDocument.defaultView.Element : Element)(CA, gA, AA, IA, BA, QA);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function CA(gA) {
    var AA = timeoutsShape;
    gA.addEndListener || (AA = AA.isRequired);
    for (var IA = arguments.length, BA = new Array(IA > 1 ? IA - 1 : 0), QA = 1; QA < IA; QA++)
      BA[QA - 1] = arguments[QA];
    return AA.apply(void 0, [gA].concat(BA));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function CA(gA, AA) {
  return gA && AA && AA.split(" ").forEach(function(IA) {
    return addClass(gA, IA);
  });
}, removeClass = function CA(gA, AA) {
  return gA && AA && AA.split(" ").forEach(function(IA) {
    return removeClass$1(gA, IA);
  });
}, CSSTransition = /* @__PURE__ */ (function(CA) {
  _inheritsLoose(gA, CA);
  function gA() {
    for (var IA, BA = arguments.length, QA = new Array(BA), EA = 0; EA < BA; EA++)
      QA[EA] = arguments[EA];
    return IA = CA.call.apply(CA, [this].concat(QA)) || this, IA.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, IA.onEnter = function(iA, oA) {
      var cA = IA.resolveArguments(iA, oA), tA = cA[0], eA = cA[1];
      IA.removeClasses(tA, "exit"), IA.addClass(tA, eA ? "appear" : "enter", "base"), IA.props.onEnter && IA.props.onEnter(iA, oA);
    }, IA.onEntering = function(iA, oA) {
      var cA = IA.resolveArguments(iA, oA), tA = cA[0], eA = cA[1], aA = eA ? "appear" : "enter";
      IA.addClass(tA, aA, "active"), IA.props.onEntering && IA.props.onEntering(iA, oA);
    }, IA.onEntered = function(iA, oA) {
      var cA = IA.resolveArguments(iA, oA), tA = cA[0], eA = cA[1], aA = eA ? "appear" : "enter";
      IA.removeClasses(tA, aA), IA.addClass(tA, aA, "done"), IA.props.onEntered && IA.props.onEntered(iA, oA);
    }, IA.onExit = function(iA) {
      var oA = IA.resolveArguments(iA), cA = oA[0];
      IA.removeClasses(cA, "appear"), IA.removeClasses(cA, "enter"), IA.addClass(cA, "exit", "base"), IA.props.onExit && IA.props.onExit(iA);
    }, IA.onExiting = function(iA) {
      var oA = IA.resolveArguments(iA), cA = oA[0];
      IA.addClass(cA, "exit", "active"), IA.props.onExiting && IA.props.onExiting(iA);
    }, IA.onExited = function(iA) {
      var oA = IA.resolveArguments(iA), cA = oA[0];
      IA.removeClasses(cA, "exit"), IA.addClass(cA, "exit", "done"), IA.props.onExited && IA.props.onExited(iA);
    }, IA.resolveArguments = function(iA, oA) {
      return IA.props.nodeRef ? [IA.props.nodeRef.current, iA] : [iA, oA];
    }, IA.getClassNames = function(iA) {
      var oA = IA.props.classNames, cA = typeof oA == "string", tA = cA && oA ? oA + "-" : "", eA = cA ? "" + tA + iA : oA[iA], aA = cA ? eA + "-active" : oA[iA + "Active"], GA = cA ? eA + "-done" : oA[iA + "Done"];
      return {
        baseClassName: eA,
        activeClassName: aA,
        doneClassName: GA
      };
    }, IA;
  }
  var AA = gA.prototype;
  return AA.addClass = function(BA, QA, EA) {
    var iA = this.getClassNames(QA)[EA + "ClassName"], oA = this.getClassNames("enter"), cA = oA.doneClassName;
    QA === "appear" && EA === "done" && cA && (iA += " " + cA), EA === "active" && BA && forceReflow(BA), iA && (this.appliedClasses[QA][EA] = iA, _addClass(BA, iA));
  }, AA.removeClasses = function(BA, QA) {
    var EA = this.appliedClasses[QA], iA = EA.base, oA = EA.active, cA = EA.done;
    this.appliedClasses[QA] = {}, iA && removeClass(BA, iA), oA && removeClass(BA, oA), cA && removeClass(BA, cA);
  }, AA.render = function() {
    var BA = this.props;
    BA.classNames;
    var QA = _objectWithoutPropertiesLoose$c(BA, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$m({}, QA, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, gA;
})(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$m({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var ConnectionState = /* @__PURE__ */ ((CA) => (CA.CONNECTED = "CONNECTED", CA.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", CA.INITIAL = "INITIAL", CA.PINGING_SERVER = "PINGING_SERVER", CA.CONNECTING = "CONNECTING", CA.STATIC_CONNECTING = "STATIC_CONNECTING", CA.STATIC_CONNECTED = "STATIC_CONNECTED", CA))(ConnectionState || {});
const IS_DEV_ENV = !1;
Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
  let CA, gA, AA = new Promise((IA, BA) => {
    CA = IA, gA = BA;
  });
  return {
    resolve: CA,
    reject: gA,
    promise: AA
  };
});
function e(CA) {
  let gA = document.cookie.match(`\\b${CA}=([^;]*)\\b`);
  return gA ? gA[1] : void 0;
}
function n(CA) {
  return Array.isArray(CA) && CA.length > 0 && CA.every((gA) => typeof gA == "string" && gA.trim().length > 0);
}
function r$1(CA) {
  return typeof structuredClone == "function" ? structuredClone(CA) : JSON.parse(JSON.stringify(CA));
}
function i(CA) {
  return Object.freeze(CA), Array.isArray(CA) ? CA.forEach((gA) => {
    typeof gA == "object" && gA && !Object.isFrozen(gA) && i(gA);
  }) : Object.values(CA).forEach((gA) => {
    typeof gA == "object" && gA && !Object.isFrozen(gA) && i(gA);
  }), CA;
}
var a = (() => {
  let CA = window.__streamlit;
  if (CA) return i(r$1(CA));
})(), s = {
  get BACKEND_BASE_URL() {
    return a?.BACKEND_BASE_URL;
  },
  get DOWNLOAD_ASSETS_BASE_URL() {
    return a?.DOWNLOAD_ASSETS_BASE_URL;
  },
  get HOST_CONFIG() {
    return a?.HOST_CONFIG;
  }
};
function c(CA) {
  return CA != null;
}
var u = /\/+$/, d = /^\/+/;
function f({
  hostname: CA,
  port: gA,
  pathname: AA,
  protocol: IA
}, BA) {
  let QA = p(AA, BA);
  return `${IA}//${CA}${gA ? `:${gA}` : ""}/${QA}`;
}
function p(CA, gA) {
  return CA = CA.replace(u, "").replace(d, ""), gA = gA.replace(u, "").replace(d, ""), CA.length === 0 ? gA : `${CA}/${gA}`;
}
loglevelExports.getLogger("StaticConnection");
const FINAL_SLASH_RE = /\/+$/, INITIAL_SLASH_RE = /^\/+/;
function isHostConfigBypassEnabled() {
  const CA = s.HOST_CONFIG;
  if (!CA)
    return !1;
  const {
    allowedOrigins: gA,
    useExternalAuthToken: AA
  } = CA, IA = !!s.BACKEND_BASE_URL, BA = n(gA);
  return IA && BA && typeof AA == "boolean";
}
function parseUriIntoBaseParts(CA) {
  const gA = new URL(window.location.href === "about:blank" ? "" : window.location.href);
  return gA.pathname = gA.pathname.replace(FINAL_SLASH_RE, "").replace(INITIAL_SLASH_RE, ""), gA;
}
loglevelExports.getLogger("DoInitPings");
loglevelExports.getLogger("ForwardMessageCache");
loglevelExports.getLogger("WebsocketConnection");
loglevelExports.getLogger("ConnectionManager");
const LOG$3 = loglevelExports.getLogger("DefaultStreamlitEndpoints"), MEDIA_ENDPOINT = "/media", STATIC_SERVING_ENDPOINT = "/app/static/", UPLOAD_FILE_ENDPOINT = "/_stcore/upload_file", COMPONENT_ENDPOINT_BASE = "/component", BIDI_COMPONENT_ENDPOINT_BASE = "/_stcore/bidi-components";
class DefaultStreamlitEndpoints {
  constructor(gA) {
    this.getServerUri = gA.getServerUri, this.csrfEnabled = gA.csrfEnabled, this.sendClientError = gA.sendClientError, this.staticConfigUrl = null;
  }
  setStaticConfigUrl(gA) {
    this.staticConfigUrl = gA;
  }
  sendClientErrorToHost(gA, AA, IA, BA, QA) {
    this.sendClientError(gA, AA, IA, BA, QA);
  }
  /**
   * Check the source of a component for successful response (for those without onerror event)
   * If the response is not ok, or fetch otherwise fails, send an error to the host.
   */
  async checkSourceUrlResponse(gA, AA, IA) {
    const BA = IA ? `${AA} ${IA}` : AA;
    try {
      const QA = await fetch(gA);
      QA.ok || (LOG$3.error(`Client Error: ${BA} source error - ${QA.status}`), this.sendClientErrorToHost(AA, QA.status, QA.statusText, gA, IA));
    } catch (QA) {
      const EA = QA instanceof Error ? QA.message : "Unknown Error";
      LOG$3.error(`Client Error: ${BA} fetch error - ${EA}`), this.sendClientErrorToHost(AA, "Error fetching source", EA, gA, IA);
    }
  }
  buildComponentURL(gA, AA) {
    return f(this.requireServerUri(), `${COMPONENT_ENDPOINT_BASE}/${gA}/${AA}`);
  }
  buildBidiComponentURL(gA, AA) {
    return f(this.requireServerUri(), `${BIDI_COMPONENT_ENDPOINT_BASE}/${gA}/${AA}`);
  }
  setFileUploadClientConfig({
    prefix: gA,
    headers: AA
  }) {
    this.fileUploadClientConfig = {
      prefix: gA,
      headers: AA
    };
  }
  /**
   * If we are using a static connection, return S3 URL for that file. Otherwise, return null.
   */
  buildStaticUrl(gA) {
    const IA = new URLSearchParams(document.location.search).get("staticAppId");
    return `${this.staticConfigUrl}/${IA}${gA}`;
  }
  /**
   * Construct a URL for a media file. If the `staticConfigUrl` is set, we have a static app
   * and will serve media from S3. If the url is relative and starts with "/media" or
   * "/app/static/", assume it's being served from Streamlit and construct it appropriately.
   * Otherwise leave it alone.
   */
  buildMediaURL(gA) {
    return this.staticConfigUrl && (gA.startsWith(MEDIA_ENDPOINT) || gA.startsWith(STATIC_SERVING_ENDPOINT)) ? this.buildStaticUrl(gA) : gA.startsWith(MEDIA_ENDPOINT) || gA.startsWith(STATIC_SERVING_ENDPOINT) ? f(this.requireServerUri(), gA) : gA;
  }
  /**
   * Construct a URL for a download file.
   * @param url a relative or absolute URL. If `url` is absolute, it will be
   * returned unchanged. Otherwise, the return value will be a URL for fetching
   * the media file from the connected Streamlit instance. The target server can
   * be changed by setting StreamlitConfig.DOWNLOAD_ASSETS_BASE_URL.
   */
  buildDownloadUrl(gA) {
    if (!gA.startsWith(MEDIA_ENDPOINT))
      return gA;
    const AA = s.DOWNLOAD_ASSETS_BASE_URL;
    return f(AA ? parseUriIntoBaseParts() : this.requireServerUri(), gA);
  }
  /**
   * Construct a URL for uploading a file. If the `fileUploadClientConfig`
   * exists, we build URL by prefixing URL with prefix from the config,
   * otherwise if the `fileUploadClientConfig` is not present, if URL is
   * relative and starts with "/_stcore/upload_file", assume we're uploading
   * the file to the Streamlit Tornado server and construct the URL
   * appropriately. Otherwise, we're probably uploading the file to some
   * external service, so we leave the URL alone.
   */
  buildFileUploadURL(gA) {
    return this.fileUploadClientConfig ? p(this.fileUploadClientConfig.prefix, gA) : gA.startsWith(UPLOAD_FILE_ENDPOINT) ? f(this.requireServerUri(), gA) : gA;
  }
  /** Construct a URL for an app page in a multi-page app. */
  buildAppPageURL(gA, AA) {
    const IA = AA.urlPathname, BA = AA.isDefault ? "" : IA;
    if (typeof gA == "string" && gA.length > 0)
      return `${gA}/${BA}`;
    const {
      port: QA,
      protocol: EA
    } = window.location, {
      pathname: iA,
      hostname: oA
    } = this.requireServerUri(), cA = QA ? `:${QA}` : "", tA = iA === "/" ? "/" : `${iA}/`;
    return `${EA}//${oA}${cA}${tA}${BA}`;
  }
  async uploadFileUploaderFile(gA, AA, IA, BA, QA) {
    const EA = new FormData(), {
      name: iA,
      webkitRelativePath: oA
    } = AA, cA = oA || iA;
    EA.append(iA, AA, cA);
    const tA = this.getAdditionalHeaders(), eA = this.buildFileUploadURL(gA);
    try {
      await this.csrfRequest(eA, {
        signal: QA,
        method: "PUT",
        data: EA,
        responseType: "text",
        headers: tA,
        onUploadProgress: BA
      });
    } catch (aA) {
      LOG$3.error(`Client Error: File uploader error on file upload - ${aA}`);
      const GA = aA instanceof Error ? aA.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error uploading file", GA, eA), aA;
    }
  }
  getAdditionalHeaders() {
    let gA = {};
    return this.fileUploadClientConfig && (gA = {
      ...gA,
      ...this.fileUploadClientConfig.headers
    }), gA;
  }
  /**
   * Send an HTTP DELETE request to the given URL.
   */
  async deleteFileAtURL(gA, AA) {
    const IA = this.getAdditionalHeaders(), BA = this.buildFileUploadURL(gA);
    try {
      await this.csrfRequest(BA, {
        method: "DELETE",
        data: {
          sessionId: AA
        },
        headers: IA
      });
    } catch (QA) {
      LOG$3.error(`Client Error: File uploader error on file delete - ${QA}`);
      const EA = QA instanceof Error ? QA.message : "Unknown Error";
      throw this.sendClientErrorToHost("File Uploader", "Error deleting file", EA, BA), QA;
    }
  }
  /**
   * Fetch the server URI. If our server is disconnected, default to the most
   * recent cached value of the URI. If we're disconnected and have no cached
   * value, throw an Error.
   */
  requireServerUri() {
    const gA = this.getServerUri();
    if (c(gA))
      return this.cachedServerUri = gA, gA;
    if (c(this.cachedServerUri))
      return this.cachedServerUri;
    throw new Error("not connected to a server!");
  }
  /**
   * Wrapper around axios.request to update the request config with
   * CSRF headers if client has CSRF protection enabled.
   * Uses dynamic import to load axios only when needed (file upload/delete operations).
   */
  async csrfRequest(gA, AA) {
    if (AA.url = gA, this.csrfEnabled) {
      const BA = e("_streamlit_xsrf");
      c(BA) && (AA.headers = {
        "X-Xsrftoken": BA,
        ...AA.headers
      }, AA.withCredentials = !0);
    }
    const {
      default: IA
    } = await import("./index-BKiUojFK.js");
    return IA.request(AA);
  }
}
var Ellipses = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M0 3v2h2V3H0zm3 0v2h2V3H3zm3 0v2h2V3H6z"
  }));
});
Ellipses.displayName = "Ellipses";
var Warning = /* @__PURE__ */ React.forwardRef(function(CA, gA) {
  var AA = {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  };
  return /* @__PURE__ */ React.createElement(EmotionIconBase, _extends$m({
    iconAttrs: AA,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 8 8"
  }, CA, {
    ref: gA
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M3.09 0c-.06 0-.1.04-.13.09L.02 6.9c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19L4.01.09A.142.142 0 003.88 0h-.81zM3 3h1v2H3V3zm0 3h1v1H3V6z"
  }));
});
Warning.displayName = "Warning";
const CONNECTING_LABEL = "Connecting", CONNECTING_TOOLTIP_TEXT = "Connecting to Streamlit server", CONNECTING_STATIC_TOOLTIP_TEXT = "Connecting to static app", ERROR_LABEL = "Error", ERROR_TOOLTIP_TEXT = "Unable to connect to Streamlit server";
function getConnectionStateUI(CA) {
  switch (CA) {
    case ConnectionState.INITIAL:
    case ConnectionState.PINGING_SERVER:
    case ConnectionState.CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_TOOLTIP_TEXT
      };
    case ConnectionState.CONNECTED:
      return;
    case ConnectionState.STATIC_CONNECTING:
      return {
        icon: Ellipses,
        label: CONNECTING_LABEL,
        tooltip: CONNECTING_STATIC_TOOLTIP_TEXT
      };
    case ConnectionState.STATIC_CONNECTED:
      return;
    case ConnectionState.DISCONNECTED_FOREVER:
    default:
      return {
        icon: Warning,
        label: ERROR_LABEL,
        tooltip: ERROR_TOOLTIP_TEXT
      };
  }
}
const newYearsRunning = "data:image/gif;base64,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";
function _EMOTION_STRINGIFIED_CSS_ERROR__$5() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledConnectionStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib67"
} : {
  target: "en6cib67",
  label: "StyledConnectionStatus"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: CA.colors.gray60
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledConnectionStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib66"
} : {
  target: "en6cib66",
  label: "StyledConnectionStatusLabel"
})(({
  theme: CA
}) => ({
  fontSize: CA.fontSizes.sm,
  color: CA.colors.gray60,
  textTransform: "uppercase",
  marginTop: CA.spacing.none,
  marginRight: CA.spacing.lg,
  marginBottom: CA.spacing.none,
  marginLeft: CA.spacing.sm,
  whiteSpace: "nowrap",
  maxWidth: CA.sizes.appStatusMaxWidth,
  lineHeight: CA.lineHeights.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatus = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib65"
} : {
  target: "en6cib65",
  label: "StyledAppStatus"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: CA.radii.sm,
  margin: `0 ${CA.spacing.sm} 0 0`,
  paddingLeft: CA.spacing.sm,
  height: CA.sizes.appRunningMen
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppStatusLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "en6cib64"
} : {
  target: "en6cib64",
  label: "StyledAppStatusLabel"
})(({
  isPrompt: CA,
  theme: gA
}) => ({
  fontSize: gA.fontSizes.sm,
  color: CA ? gA.colors.bodyText : gA.colors.gray60,
  textTransform: CA ? "none" : "uppercase",
  margin: `0 0 0 ${gA.spacing.sm}`,
  whiteSpace: "nowrap",
  maxWidth: gA.sizes.appStatusMaxWidth,
  borderRadius: CA ? gA.radii.sm : void 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppButtonContainer = /* @__PURE__ */ createStyled("span", process.env.NODE_ENV === "production" ? {
  target: "en6cib63"
} : {
  target: "en6cib63",
  label: "StyledAppButtonContainer"
})(({
  theme: CA
}) => ({
  marginLeft: CA.spacing.md,
  whiteSpace: "nowrap",
  color: CA.colors.bodyText
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledAppRunningIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib62"
} : {
  target: "en6cib62",
  label: "StyledAppRunningIcon"
})(({
  isNewYears: CA,
  theme: gA
}) => ({
  width: CA ? "2.2rem" : gA.sizes.appRunningMen,
  height: CA ? "2.2rem" : gA.sizes.appRunningMen,
  marginRight: `-${gA.spacing.sm}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "opacity 0.3s ease-in-out",
  cursor: "wait"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledStatusWidget = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib61"
} : {
  target: "en6cib61",
  label: "StyledStatusWidget"
})(process.env.NODE_ENV === "production" ? {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}"
} : {
  name: "19or5k2",
  styles: "&.StatusWidget-appear{opacity:0;}&.StatusWidget-appear-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-enter{opacity:0;}&.StatusWidget-enter-active{opacity:1;transition:opacity 200ms ease-out;}&.StatusWidget-exit{opacity:1;}&.StatusWidget-exit-active{opacity:0;transition:opacity 200ms ease-out;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), StyledShortcutLabel = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "en6cib60"
} : {
  target: "en6cib60",
  label: "StyledShortcutLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}"
} : {
  name: "jdyw56",
  styles: "&::first-letter{text-decoration:underline;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
}), icons = [{
  component: AccessibleForward,
  name: "accessible-forward"
}, {
  component: AccessibilityNew,
  name: "accessibility-new"
}, {
  component: DirectionsBike,
  name: "directions-bike"
}, {
  component: DirectionsRun,
  name: "directions-run"
}, {
  component: Pool,
  name: "pool"
}, {
  component: Rowing,
  name: "rowing"
}], isNewYears = () => {
  const CA = /* @__PURE__ */ new Date(), gA = CA.getMonth(), AA = CA.getDate();
  return gA === 11 && AA === 31 || gA === 0 && AA <= 6;
}, DEFAULT_SPEED = 200, IconRunning = () => {
  const [CA, gA] = useState(0), AA = useEmotionTheme(), IA = useMemo$1(() => isNewYears(), []);
  useEffect(() => {
    if (IA) return;
    const EA = setInterval(() => {
      gA((iA) => (iA + 1) % icons.length);
    }, DEFAULT_SPEED);
    return () => clearInterval(EA);
  }, [IA]);
  const QA = icons[CA].component;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppRunningIcon, { isNewYears: IA, "aria-label": "Running...", role: "img", "data-testid": "stStatusWidgetRunningIcon", children: IA ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: newYearsRunning, alt: "New Year's Celebration", style: {
    width: "100%",
    height: "100%",
    objectFit: "contain"
  }, "data-testid": "stStatusWidgetNewYearsIcon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(QA, { color: AA.colors.fadedText60, "aria-hidden": "true", "data-testid": "stStatusWidgetRunningManIcon", style: {
    width: AA.sizes.appRunningMen,
    height: AA.sizes.appRunningMen
  } }) });
}, RUNNING_MAN_DISPLAY_DELAY_TIME_MS = 500, PromptButton = (CA) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.HEADER_BUTTON, disabled: CA.disabled, containerWidth: !0, onClick: CA.onClick, children: CA.title }) }), StatusWidget = ({
  connectionState: CA,
  scriptRunState: gA,
  rerunScript: AA,
  stopScript: IA,
  allowRunOnSave: BA,
  showScriptChangedActions: QA
}) => {
  const [EA, iA] = useState(!1), oA = useEmotionTheme(), {
    clear: cA,
    restart: tA
  } = useTimeout(() => {
    iA(!0);
  }, RUNNING_MAN_DISPLAY_DELAY_TIME_MS, {
    autoStart: !1
  }), eA = () => {
    BA && AA(!0);
  }, aA = (FA, dA) => {
    FA === "a" && !isKeyboardEventFromEditableTarget(dA) && eA();
  }, GA = CA === ConnectionState.CONNECTED, lA = () => {
    IA();
  }, nA = () => {
    AA(!1);
  };
  useEffect(() => {
    GA && (gA === ScriptRunState.RUNNING || gA === ScriptRunState.RERUN_REQUESTED) ? tA() : cA(), gA === ScriptRunState.NOT_RUNNING && iA(!1);
  }, [cA, GA, tA, gA]);
  const DA = () => {
    const FA = gA === ScriptRunState.STOP_REQUESTED;
    return EA ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(IconRunning, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: FA ? "Stopping..." : "Stop", disabled: FA, onClick: lA })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  }, hA = () => {
    const FA = gA === ScriptRunState.RERUN_REQUESTED;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "a", onKeyDown: aA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledAppStatus, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicIcon, { size: "lg", iconValue: ":material/info:", color: oA.colors.fadedText60 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAppStatusLabel, { isPrompt: !0, children: "File change." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Rerun" }), disabled: FA, onClick: nA }),
      BA && /* @__PURE__ */ jsxRuntimeExports.jsx(PromptButton, { title: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledShortcutLabel, { children: "Always rerun" }), disabled: FA, onClick: eA })
    ] }) });
  }, wA = () => {
    const FA = getConnectionStateUI(CA);
    return FA === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: FA.tooltip, placement: Placement.BOTTOM, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledConnectionStatus, { className: "stConnectionStatus", "data-testid": "stConnectionStatus", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$2, { size: "sm", content: FA.icon }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledConnectionStatusLabel, { children: FA.label })
    ] }) });
  }, sA = () => {
    if (GA) {
      if (gA === ScriptRunState.RUNNING || gA === ScriptRunState.RERUN_REQUESTED)
        return DA();
      if (QA)
        return hA();
    }
    return wA();
  }, NA = useRef(), rA = useRef(null), yA = NA.current;
  if (NA.current = sA(), isNullOrUndefined$1(NA.current) && isNullOrUndefined$1(yA))
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
  let bA, RA;
  return notNullOrUndefined(NA.current) ? (bA = !0, RA = NA.current) : (bA = !1, RA = yA), /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { appear: !0, in: bA, timeout: 200, unmountOnExit: !0, classNames: "StatusWidget", nodeRef: rA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStatusWidget, { ref: rA, className: "stStatusWidget", "data-testid": "stStatusWidget", children: RA }, "StatusWidget") });
}, StreamlitContextProvider = ({
  // ViewStateContext
  isFullScreen: CA,
  setFullScreen: gA,
  // LibConfigContext
  locale: AA,
  mapboxToken: IA,
  enforceDownloadInNewTab: BA,
  resourceCrossOriginMode: QA,
  showErrorLinks: EA,
  // NavigationContext
  pageLinkBaseUrl: iA,
  currentPageScriptHash: oA,
  onPageChange: cA,
  navSections: tA,
  appPages: eA,
  // SidebarConfigContext
  initialSidebarState: aA,
  initialSidebarWidth: GA,
  appLogo: lA,
  sidebarChevronDownshift: nA,
  expandSidebarNav: DA,
  sidebarNavVisibleItems: hA,
  hideSidebarNav: wA,
  appRootRef: sA,
  // ThemeContext
  activeTheme: NA,
  setTheme: rA,
  availableThemes: yA,
  // ScriptRunContext
  scriptRunState: bA,
  scriptRunId: RA,
  fragmentIdsThisRun: FA,
  // FormsContext
  formsData: dA,
  // DownloadContext
  requestDeferredFile: kA,
  // Children passed through
  children: pA
}) => {
  const YA = useMemo$1(() => ({
    locale: AA,
    mapboxToken: IA,
    enforceDownloadInNewTab: BA,
    resourceCrossOriginMode: QA,
    showErrorLinks: EA
  }), [AA, IA, BA, QA, EA]), SA = useMemo$1(() => ({
    initialSidebarState: aA,
    initialSidebarWidth: GA,
    appLogo: lA,
    sidebarChevronDownshift: nA,
    expandSidebarNav: DA,
    sidebarNavVisibleItems: hA,
    hideSidebarNav: wA,
    appRootRef: sA
  }), [aA, GA, lA, nA, DA, hA, wA, sA]), JA = useMemo$1(() => ({
    activeTheme: NA,
    setTheme: rA,
    availableThemes: yA
  }), [NA, rA, yA]), UA = useMemo$1(() => ({
    pageLinkBaseUrl: iA,
    currentPageScriptHash: oA,
    onPageChange: cA,
    navSections: tA,
    appPages: eA
  }), [iA, oA, cA, tA, eA]), fA = useMemo$1(() => ({
    isFullScreen: CA,
    setFullScreen: gA
  }), [CA, gA]), zA = useMemo$1(() => ({
    scriptRunState: bA,
    scriptRunId: RA,
    fragmentIdsThisRun: FA
  }), [bA, RA, FA]), _A = useMemo$1(() => ({
    formsData: dA
  }), [dA]), uA = useMemo$1(() => ({
    requestDeferredFile: kA
  }), [kA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LibConfigContext.Provider, { value: YA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SidebarConfigContext.Provider, { value: SA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, { value: JA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavigationContext.Provider, { value: UA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadContext.Provider, { value: uA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ViewStateContext.Provider, { value: fA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptRunContext.Provider, { value: zA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormsContext.Provider, { value: _A, children: pA }) }) }) }) }) }) }) });
}, StreamlitContextProvider$1 = memo(StreamlitContextProvider);
var DialogType = /* @__PURE__ */ ((CA) => (CA.ABOUT = "about", CA.CLEAR_CACHE = "clearCache", CA.CONNECTION_ERROR = "connectionError", CA.SCRIPT_COMPILE_ERROR = "scriptCompileError", CA.WARNING = "warning", CA.DEPLOY_ERROR = "deployError", CA.DEPLOY_DIALOG = "deployDialog", CA))(DialogType || {});
const StyledDeployErrorContent = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc1"
} : {
  target: "e1x90zqc1",
  label: "StyledDeployErrorContent"
})(({
  theme: CA
}) => ({
  "& > ul": {
    paddingLeft: CA.spacing.twoXL
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0J3QyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RyZWFtbGl0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREZXBsb3lFcnJvckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJiA+IHVsXCI6IHtcbiAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy50d29YTCxcbiAgfSxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkRXJyb3JUZXh0UHJvcHMge1xuICBoYXNDb2RlQmVsb3c6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVycm9yVGV4dCA9IHN0eWxlZC5kaXY8U3R5bGVkRXJyb3JUZXh0UHJvcHM+KFxuICAoeyB0aGVtZSwgaGFzQ29kZUJlbG93IH0pID0+ICh7XG4gICAgLi4uKGhhc0NvZGVCZWxvdyAmJiB7XG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgfSksXG4gIH0pXG4pXG4iXX0= */"), StyledErrorText = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x90zqc0"
} : {
  target: "e1x90zqc0",
  label: "StyledErrorText"
})(({
  theme: CA,
  hasCodeBelow: gA
}) => ({
  ...gA && {
    marginBottom: CA.spacing.lg
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEIrQiIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2NvbXBvbmVudHMvU3RyZWFtbGl0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWREZXBsb3lFcnJvckNvbnRlbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIFwiJiA+IHVsXCI6IHtcbiAgICBwYWRkaW5nTGVmdDogdGhlbWUuc3BhY2luZy50d29YTCxcbiAgfSxcbn0pKVxuXG5pbnRlcmZhY2UgU3R5bGVkRXJyb3JUZXh0UHJvcHMge1xuICBoYXNDb2RlQmVsb3c6IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVycm9yVGV4dCA9IHN0eWxlZC5kaXY8U3R5bGVkRXJyb3JUZXh0UHJvcHM+KFxuICAoeyB0aGVtZSwgaGFzQ29kZUJlbG93IH0pID0+ICh7XG4gICAgLi4uKGhhc0NvZGVCZWxvdyAmJiB7XG4gICAgICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubGcsXG4gICAgfSksXG4gIH0pXG4pXG4iXX0= */");
function parseLinks(CA) {
  const gA = [];
  let AA = 0, IA = 0;
  const BA = /\[([^\]]+)\]\(([^)]+)\)/g;
  let QA;
  for (; (QA = BA.exec(CA)) !== null; )
    QA.index > AA && gA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: CA.substring(AA, QA.index) }, IA++)), gA.push(/* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: QA[2], target: "_blank", rel: "noopener noreferrer", children: QA[1] }, IA++)), AA = QA.index + QA[0].length;
  return AA < CA.length && gA.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: CA.substring(AA) }, IA++)), gA;
}
function DialogErrorMessage({
  message: CA,
  codeBlock: gA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledErrorText, { hasCodeBelow: !!gA, children: parseLinks(CA) }),
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: gA })
  ] });
}
const DialogErrorMessage$1 = memo(DialogErrorMessage);
var LevelContext = /* @__PURE__ */ React.createContext(0);
function ownKeys(CA, gA) {
  var AA = Object.keys(CA);
  if (Object.getOwnPropertySymbols) {
    var IA = Object.getOwnPropertySymbols(CA);
    gA && (IA = IA.filter(function(BA) {
      return Object.getOwnPropertyDescriptor(CA, BA).enumerable;
    })), AA.push.apply(AA, IA);
  }
  return AA;
}
function _objectSpread(CA) {
  for (var gA = 1; gA < arguments.length; gA++) {
    var AA = arguments[gA] != null ? arguments[gA] : {};
    gA % 2 ? ownKeys(Object(AA), !0).forEach(function(IA) {
      _defineProperty(CA, IA, AA[IA]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(CA, Object.getOwnPropertyDescriptors(AA)) : ownKeys(Object(AA)).forEach(function(IA) {
      Object.defineProperty(CA, IA, Object.getOwnPropertyDescriptor(AA, IA));
    });
  }
  return CA;
}
function _defineProperty(CA, gA, AA) {
  return gA in CA ? Object.defineProperty(CA, gA, { value: AA, enumerable: !0, configurable: !0, writable: !0 }) : CA[gA] = AA, CA;
}
var Action = styled("div", function(CA) {
  var gA = CA.$theme;
  return _objectSpread({}, gA.typography.LabelMedium);
});
Action.displayName = "Action";
Action.displayName = "Action";
var Body = styled("div", function(CA) {
  var gA = CA.$theme;
  return _objectSpread({
    marginBottom: gA.sizing.scale600,
    color: gA.colors.contentPrimary
  }, gA.typography.ParagraphMedium);
});
Body.displayName = "Body";
Body.displayName = "Body";
var Contents = styled("div", function(CA) {
  var gA = CA.$theme;
  return {
    marginLeft: gA.sizing.scale600,
    marginTop: gA.sizing.scale600,
    marginRight: gA.sizing.scale600,
    marginBottom: gA.sizing.scale600
  };
});
Contents.displayName = "Contents";
Contents.displayName = "Contents";
var HeaderImage = styled("img", function(CA) {
  var gA = CA.$theme;
  return {
    borderTopLeftRadius: gA.borders.surfaceBorderRadius,
    borderTopRightRadius: gA.borders.surfaceBorderRadius,
    objectFit: "contain",
    maxWidth: "100%"
  };
});
HeaderImage.displayName = "HeaderImage";
HeaderImage.displayName = "HeaderImage";
var Root = styled("section", function(CA) {
  var gA = CA.$theme;
  return {
    borderLeftWidth: "2px",
    borderTopWidth: "2px",
    borderRightWidth: "2px",
    borderBottomWidth: "2px",
    borderLeftStyle: "solid",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftColor: gA.colors.borderOpaque,
    borderRightColor: gA.colors.borderOpaque,
    borderTopColor: gA.colors.borderOpaque,
    borderBottomColor: gA.colors.borderOpaque,
    borderTopLeftRadius: gA.borders.radius400,
    borderTopRightRadius: gA.borders.radius400,
    borderBottomLeftRadius: gA.borders.radius400,
    borderBottomRightRadius: gA.borders.radius400,
    backgroundColor: gA.colors.backgroundPrimary,
    overflow: "hidden"
  };
});
Root.displayName = "Root";
Root.displayName = "Root";
var Thumbnail = styled("img", function(CA) {
  var gA = CA.$theme;
  return _objectSpread(_objectSpread({
    float: "right",
    height: gA.sizing.scale2400,
    width: gA.sizing.scale2400,
    objectFit: "cover",
    borderTopLeftRadius: gA.borders.surfaceBorderRadius,
    borderTopRightRadius: gA.borders.surfaceBorderRadius,
    borderBottomLeftRadius: gA.borders.surfaceBorderRadius,
    borderBottomRightRadius: gA.borders.surfaceBorderRadius
  }, expandBorderStyles(gA.borders.border200)), {}, {
    margin: "0 0 ".concat(gA.sizing.scale500, " ").concat(gA.sizing.scale500)
  });
});
Thumbnail.displayName = "Thumbnail";
Thumbnail.displayName = "Thumbnail";
var Title = styled("h1", function(CA) {
  var gA = CA.$theme;
  return _objectSpread(_objectSpread({}, gA.typography.HeadingSmall), {}, {
    color: gA.colors.contentPrimary,
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: gA.sizing.scale500,
    paddingLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0
  });
});
Title.displayName = "Title";
Title.displayName = "Title";
var _excluded = ["children"], _excluded2 = ["action", "children", "hasThumbnail", "headerImage", "thumbnail", "title", "overrides"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(CA) {
    for (var gA = 1; gA < arguments.length; gA++) {
      var AA = arguments[gA];
      for (var IA in AA)
        Object.prototype.hasOwnProperty.call(AA, IA) && (CA[IA] = AA[IA]);
    }
    return CA;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(CA, gA) {
  if (CA == null) return {};
  var AA = _objectWithoutPropertiesLoose(CA, gA), IA, BA;
  if (Object.getOwnPropertySymbols) {
    var QA = Object.getOwnPropertySymbols(CA);
    for (BA = 0; BA < QA.length; BA++)
      IA = QA[BA], !(gA.indexOf(IA) >= 0) && Object.prototype.propertyIsEnumerable.call(CA, IA) && (AA[IA] = CA[IA]);
  }
  return AA;
}
function _objectWithoutPropertiesLoose(CA, gA) {
  if (CA == null) return {};
  var AA = {}, IA = Object.keys(CA), BA, QA;
  for (QA = 0; QA < IA.length; QA++)
    BA = IA[QA], !(gA.indexOf(BA) >= 0) && (AA[BA] = CA[BA]);
  return AA;
}
function hasThumbnail(CA) {
  return !!CA.thumbnail;
}
var SemanticTitle = function CA(gA) {
  var AA = gA.children, IA = _objectWithoutProperties(gA, _excluded), BA = ["", "h1", "h2", "h3", "h4", "h5", "h6"];
  return /* @__PURE__ */ React.createElement(LevelContext.Consumer, null, function(QA) {
    return (
      // @ts-expect-error
      /* @__PURE__ */ React.createElement(Title, _extends({
        $as: BA[QA]
      }, IA), AA)
    );
  });
};
function Card(CA) {
  var gA = CA.action, AA = CA.children, IA = CA.hasThumbnail, BA = CA.headerImage, QA = CA.thumbnail, EA = CA.title, iA = CA.overrides, oA = _objectWithoutProperties(CA, _excluded2), cA = iA.Action, tA = iA.Body, eA = iA.Contents, aA = iA.HeaderImage, GA = iA.Root, lA = iA.Thumbnail, nA = iA.Title, DA = getOverride(cA) || Action, hA = getOverride(tA) || Body, wA = getOverride(eA) || Contents, sA = getOverride(aA) || HeaderImage, NA = getOverride(GA) || Root, rA = getOverride(lA) || Thumbnail, yA = getOverride(nA) || SemanticTitle, bA = typeof BA == "string" ? {
    src: BA
  } : BA, RA = IA(CA);
  return /* @__PURE__ */ React.createElement(NA, _extends({
    "data-baseweb": "card"
  }, oA, getOverrideProps(GA)), BA && /* @__PURE__ */ React.createElement(sA, _extends({}, bA, getOverrideProps(aA))), /* @__PURE__ */ React.createElement(wA, getOverrideProps(eA), QA && /* @__PURE__ */ React.createElement(rA, _extends({
    src: QA
  }, getOverrideProps(lA))), EA && /* @__PURE__ */ React.createElement(yA, _extends({
    $hasThumbnail: RA
  }, getOverrideProps(nA)), EA), /* @__PURE__ */ React.createElement(hA, getOverrideProps(tA), AA), gA && /* @__PURE__ */ React.createElement(DA, getOverrideProps(cA), gA)));
}
Card.defaultProps = {
  action: null,
  children: null,
  hasThumbnail,
  overrides: {}
};
const StreamlitLogo = "data:image/svg+xml,%3csvg%20width='32'%20height='19'%20viewBox='0%200%2032%2019'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group%202'%3e%3cpath%20id='path3858'%20d='M15.998%2011.078L10.3882%208.04522L0.650371%202.78157C0.641482%202.77247%200.623705%202.77248%200.614816%202.77248C0.259259%202.59975%20-0.105186%202.96338%200.0281476%203.32702L4.98994%2016.2698L4.99083%2016.2725C4.99616%2016.2852%205.00061%2016.298%205.00594%2016.3107C5.2095%2016.7934%205.65394%2017.0916%206.1375%2017.2089C6.17839%2017.218%206.20764%2017.2262%206.25673%2017.2362C6.30559%2017.2473%206.37394%2017.2625%206.43261%2017.2671C6.44239%2017.268%206.45128%2017.268%206.46106%2017.2689H6.46817C6.47528%2017.2698%206.48239%2017.2698%206.4895%2017.2707H6.49928C6.5055%2017.2716%206.51261%2017.2716%206.51883%2017.2716H6.53039C6.5375%2017.2725%206.54461%2017.2725%206.55172%2017.2725C12.8348%2017.9731%2019.1763%2017.9731%2025.4593%2017.2725C25.5349%2017.2725%2025.6087%2017.2689%2025.6798%2017.2616C25.7029%2017.2589%2025.7251%2017.2562%2025.7473%2017.2534C25.75%2017.2525%2025.7536%2017.2525%2025.7562%2017.2516C25.7713%2017.2498%2025.7864%2017.2471%2025.8016%2017.2443C25.8238%2017.2416%2025.846%2017.2371%2025.8682%2017.2325C25.9127%2017.2225%2025.9329%2017.2152%2025.9932%2017.194C26.0535%2017.1729%2026.1536%2017.1358%2026.2163%2017.1049C26.279%2017.074%2026.3224%2017.0443%2026.3749%2017.0107C26.4398%2016.9689%2026.5015%2016.9261%2026.5641%2016.8781C26.5911%2016.8569%2026.6096%2016.8434%2026.6291%2016.8243L26.6184%2016.818L15.998%2011.078Z'%20fill='%23FF2B2B'/%3e%3cpath%20id='path5063'%20d='M31.3616%202.78158H31.3527L21.6113%208.04524L27.0265%2016.2935L31.9758%203.32704V3.30886C32.1003%202.92704%2031.7181%202.58158%2031.3616%202.78158Z'%20fill='%237D353B'/%3e%3cpath%20id='path5101'%20d='M16.5171%200.278788C16.2682%20-0.0930318%2015.726%20-0.0930318%2015.486%200.278788L10.3882%208.04518L15.998%2011.0779L26.6291%2016.8242C26.6959%2016.7574%2026.7494%2016.6922%2026.806%2016.6234C26.886%2016.5225%2026.9607%2016.4143%2027.0265%2016.2934L21.6113%208.04518L16.5171%200.278788Z'%20fill='%23BD4043'/%3e%3c/g%3e%3c/svg%3e", Rocket = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Frame'%3e%3cpath%20id='Vector'%20d='M5.95077%2010.7642L8.09076%2011.6685C8.34683%2011.157%208.61204%2010.6637%208.8864%2010.1887C9.16076%209.71374%209.46256%209.23875%209.79179%208.76376L8.25538%208.46232L5.95077%2010.7642ZM9.84666%2013.0387L12.9743%2016.1352C13.7426%2015.8429%2014.5656%2015.3954%2015.4436%2014.7925C16.3215%2014.1896%2017.1446%2013.5045%2017.9128%2012.7372C19.1931%2011.4584%2020.1946%2010.038%2020.917%208.47602C21.6395%206.91403%2021.955%205.47536%2021.8636%204.16C20.5466%204.06866%2019.1017%204.38379%2017.5287%205.10541C15.9557%205.82703%2014.529%206.82726%2013.2487%208.10608C12.4805%208.87337%2011.7946%209.69547%2011.191%2010.5724C10.5874%2011.4493%2010.1393%2012.2714%209.84666%2013.0387ZM14.7302%2011.2575C14.3096%2010.8373%2014.0992%2010.3212%2014.0992%209.70917C14.0992%209.09716%2014.3096%208.58107%2014.7302%208.16088C15.1509%207.7407%2015.6722%207.53061%2016.2941%207.53061C16.916%207.53061%2017.4373%207.7407%2017.8579%208.16088C18.2786%208.58107%2018.489%209.09716%2018.489%209.70917C18.489%2010.3212%2018.2786%2010.8373%2017.8579%2011.2575C17.4373%2011.6776%2016.916%2011.8877%2016.2941%2011.8877C15.6722%2011.8877%2015.1509%2011.6776%2014.7302%2011.2575ZM15.2515%2020.0539L17.5561%2017.752L17.2543%2016.2175C16.7788%2016.5463%2016.3032%2016.8432%2015.8277%2017.1081C15.3521%2017.373%2014.8583%2017.6333%2014.3461%2017.8891L15.2515%2020.0539ZM23.839%202.15956C24.1865%204.37009%2023.9716%206.52125%2023.1942%208.61304C22.4169%2010.7048%2021.0771%2012.7007%2019.1749%2014.6007L19.7236%2017.3136C19.7967%2017.679%2019.7784%2018.0352%2019.6687%2018.3823C19.559%2018.7294%2019.3761%2019.0309%2019.12%2019.2866L14.5108%2023.8904L12.2061%2018.4919L7.51461%2013.806L2.10974%2011.5041L6.69153%206.90033C6.9476%206.64457%207.25397%206.46188%207.61064%206.35227C7.9673%206.24265%208.32854%206.22438%208.69435%206.29746L11.4105%206.84553C13.3127%204.94556%2015.3064%203.6028%2017.3915%202.81724C19.4767%202.03168%2021.6258%201.81245%2023.839%202.15956ZM4.05769%2017.2862C4.69786%2016.6468%205.47978%2016.3225%206.40346%2016.3134C7.32713%2016.3042%208.10905%2016.6194%208.74922%2017.2588C9.38939%2017.8982%209.70491%2018.6792%209.69576%2019.6018C9.68662%2020.5243%209.36196%2021.3053%208.72179%2021.9448C8.26452%2022.4015%207.50089%2022.7943%206.43089%2023.1231C5.36089%2023.4519%203.88393%2023.7442%202%2024C2.25607%2022.1183%202.54872%2020.6431%202.87795%2019.5744C3.20718%2018.5056%203.60043%2017.7429%204.05769%2017.2862ZM5.62154%2018.8208C5.43863%2019.0035%205.25572%2019.3369%205.07282%2019.821C4.88991%2020.3051%204.76188%2020.7938%204.68872%2021.2871C5.18256%2021.214%205.67183%2021.0907%206.15653%2020.9171C6.64123%2020.7436%206.97504%2020.5655%207.15794%2020.3828C7.37743%2020.1635%207.49632%2019.8986%207.51461%2019.5881C7.5329%2019.2775%207.4323%2019.0126%207.21282%2018.7934C6.99333%2018.5741%206.72812%2018.4691%206.41718%2018.4782C6.10624%2018.4874%205.84102%2018.6015%205.62154%2018.8208Z'%20fill='%23A3A8B8'/%3e%3c/g%3e%3c/svg%3e", Snowflake = "data:image/svg+xml,%3csvg%20width='25'%20height='24'%20viewBox='0%200%2025%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo-solid'%3e%3cpath%20id='inside'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.5357%2012.1774L12.801%2012.912C12.7029%2013.0101%2012.5439%2013.0101%2012.4458%2012.912L11.7112%2012.1774C11.6131%2012.0794%2011.6131%2011.9203%2011.7112%2011.8223L12.4458%2011.0876C12.5439%2010.9894%2012.703%2010.9894%2012.8011%2011.0876L13.5357%2011.8222C13.6337%2011.9203%2013.6337%2012.0793%2013.5357%2012.1774ZM15.0724%2011.2524L13.3708%209.55073C12.9581%209.13804%2012.2889%209.13804%2011.8761%209.55073L10.1744%2011.2525C9.76154%2011.6653%209.76154%2012.3345%2010.1744%2012.7473L11.876%2014.4489C12.2887%2014.8616%2012.9579%2014.8616%2013.3707%2014.4489L15.0724%2012.7471C15.4852%2012.3343%2015.4852%2011.6651%2015.0724%2011.2524Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%206'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%200C8.95801%200%208.2787%200.679312%208.2787%201.51724V4.65891L5.53731%203.07614C4.81165%202.65718%203.88372%202.9058%203.46476%203.63153C3.04579%204.35718%203.29441%205.28512%204.02007%205.70408L8.83304%208.48285C9.09497%208.69823%209.43036%208.82761%209.79594%208.82761C10.6339%208.82761%2011.3132%208.14829%2011.3132%207.31036V1.51724C11.3132%200.679312%2010.6339%200%209.79594%200Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%205'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.60315%2012.5758C8.61253%2012.553%208.62177%2012.5303%208.62997%2012.5071C8.63915%2012.4812%208.64722%2012.4552%208.65494%2012.429C8.66087%2012.4088%208.66673%2012.3888%208.67184%2012.3685C8.67887%2012.3405%208.6848%2012.3124%208.69018%2012.2841C8.69397%2012.2642%208.69756%2012.2443%208.7006%2012.2243C8.70473%2012.1967%208.70791%2012.1692%208.71046%2012.1414C8.71253%2012.1194%208.71425%2012.0975%208.71542%2012.0754C8.71666%2012.0503%208.71708%2012.0252%208.71708%2012C8.71708%2011.9748%208.71666%2011.9498%208.71542%2011.9246C8.71425%2011.9025%208.71253%2011.8805%208.71046%2011.8586C8.70791%2011.8309%208.70473%2011.8034%208.7006%2011.7756C8.69756%2011.7556%208.69397%2011.7358%208.69018%2011.7158C8.6848%2011.6876%208.67887%2011.6596%208.67184%2011.6315C8.66673%2011.6112%208.66087%2011.5912%208.65494%2011.5711C8.64722%2011.5449%208.63915%2011.5188%208.62997%2011.4929C8.62177%2011.4697%208.61253%2011.4469%208.60315%2011.4242C8.59418%2011.4023%208.58528%2011.3805%208.57522%2011.3589C8.56246%2011.3316%208.54825%2011.3049%208.53391%2011.2784C8.52722%2011.2661%208.52198%2011.2535%208.51501%2011.2414C8.51232%2011.2367%208.50901%2011.2325%208.50625%2011.2279C8.48956%2011.1996%208.47122%2011.1722%208.45259%2011.1449C8.44266%2011.1303%208.43308%2011.1152%208.42266%2011.1009C8.40466%2011.0765%208.38515%2011.0532%208.3657%2011.0298C8.35253%2011.014%208.3399%2010.9978%208.32625%2010.9826C8.30922%2010.9638%208.29087%2010.9462%208.27287%2010.9281C8.2548%2010.9101%208.23715%2010.8917%208.21839%2010.8747C8.20322%2010.8612%208.18701%2010.8485%208.17122%2010.8354C8.14777%2010.8158%208.12453%2010.7963%208.10004%2010.7784C8.08584%2010.7679%208.07073%2010.7583%208.05604%2010.7484C8.0288%2010.7298%208.00142%2010.7115%207.97308%2010.6947C7.96846%2010.6921%207.96432%2010.6887%207.95963%2010.6861L2.94265%207.78949C2.21693%207.37046%201.28899%207.61915%200.870026%208.3448C0.45106%209.07053%200.699681%209.99846%201.42541%2010.4174L4.16652%2012L1.42541%2013.5826C0.699681%2014.0016%200.45106%2014.9295%200.870026%2015.6552C1.28899%2016.3809%202.21693%2016.6295%202.94265%2016.2105L7.95963%2013.314C7.96432%2013.3112%207.96846%2013.308%207.97308%2013.3052C8.00142%2013.2885%208.0288%2013.2702%208.05604%2013.2516C8.07073%2013.2416%208.08584%2013.2321%208.10004%2013.2216C8.12453%2013.2036%208.14777%2013.1841%208.17122%2013.1646C8.18701%2013.1516%208.20322%2013.1389%208.21839%2013.1252C8.23708%2013.1083%208.2548%2013.0899%208.2728%2013.0719C8.29087%2013.0539%208.30922%2013.0361%208.32625%2013.0173C8.3399%2013.0023%208.35246%2012.986%208.36563%2012.9703C8.38515%2012.9469%208.40466%2012.9235%208.42266%2012.899C8.43308%2012.8848%208.4426%2012.8698%208.45253%2012.8551C8.47122%2012.8278%208.48956%2012.8004%208.50632%2012.7721C8.50908%2012.7674%208.51232%2012.7633%208.51501%2012.7586C8.52198%2012.7465%208.52722%2012.7339%208.53384%2012.7217C8.54825%2012.695%208.56246%2012.6684%208.57522%2012.641C8.58528%2012.6194%208.59418%2012.5976%208.60315%2012.5758Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%204'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.79594%2015.1724C9.43036%2015.1724%209.09504%2015.3017%208.83304%2015.5171L4.02007%2018.2958C3.29441%2018.7148%203.04579%2019.6427%203.46476%2020.3684C3.88372%2021.0941%204.81165%2021.3428%205.53731%2020.9238L8.2787%2019.3411V22.4827C8.2787%2023.3207%208.95801%2024%209.79594%2024C10.6339%2024%2011.3132%2023.3207%2011.3132%2022.4827V16.6896C11.3132%2015.8517%2010.6339%2015.1724%209.79594%2015.1724Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%203'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.2272%2018.2958L16.4142%2015.5171C16.1522%2015.3017%2015.8169%2015.1724%2015.4513%2015.1724C14.6134%2015.1724%2013.9341%2015.8517%2013.9341%2016.6896V22.4827C13.9341%2023.3207%2014.6134%2024%2015.4513%2024C16.2893%2024%2016.9686%2023.3207%2016.9686%2022.4827V19.3411L19.71%2020.9238C20.4356%2021.3428%2021.3636%2021.0941%2021.7826%2020.3684C22.2015%2019.6427%2021.9529%2018.7148%2021.2272%2018.2958Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%202'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M23.8219%2013.5826L21.0808%2012L23.8219%2010.4174C24.5476%209.99843%2024.7963%209.0705%2024.3773%208.34484C23.9584%207.61911%2023.0304%207.37049%2022.3047%207.78946L17.2877%2010.686C17.283%2010.6887%2017.2789%2010.692%2017.2743%2010.6947C17.2459%2010.7115%2017.2186%2010.7298%2017.1912%2010.7484C17.1766%2010.7584%2017.1615%2010.7679%2017.1473%2010.7784C17.1228%2010.7964%2017.0995%2010.8159%2017.0761%2010.8353C17.0603%2010.8484%2017.0441%2010.8611%2017.029%2010.8747C17.0101%2010.8917%2016.9926%2010.9101%2016.9745%2010.9282C16.9565%2010.9462%2016.9381%2010.9638%2016.921%2010.9826C16.9074%2010.9978%2016.8948%2011.014%2016.8817%2011.0297C16.8622%2011.0532%2016.8427%2011.0765%2016.8247%2011.101C16.8143%2011.1152%2016.8048%2011.1302%2016.7947%2011.1449C16.7761%2011.1722%2016.7578%2011.1995%2016.7411%2011.2279C16.7383%2011.2326%2016.735%2011.2366%2016.7323%2011.2414C16.7254%2011.2535%2016.7201%2011.2661%2016.7134%2011.2784C16.6991%2011.305%2016.6849%2011.3316%2016.6721%2011.359C16.6621%2011.3805%2016.6532%2011.4024%2016.6442%2011.4242C16.6348%2011.4469%2016.6256%2011.4697%2016.6174%2011.4928C16.6081%2011.5188%2016.6001%2011.5448%2016.5924%2011.5711C16.5865%2011.5911%2016.5806%2011.6112%2016.5756%2011.6315C16.5685%2011.6595%2016.5625%2011.6876%2016.5572%2011.7159C16.5534%2011.7358%2016.5498%2011.7557%2016.5468%2011.7757C16.5426%2011.8033%2016.5394%2011.8309%2016.5369%2011.8586C16.5348%2011.8805%2016.5331%2011.9025%2016.5319%2011.9246C16.5307%2011.9497%2016.5303%2011.9748%2016.5303%2012C16.5303%2012.0251%2016.5307%2012.0502%2016.5319%2012.0754C16.5331%2012.0975%2016.5348%2012.1194%2016.5369%2012.1415C16.5394%2012.1691%2016.5426%2012.1966%2016.5468%2012.2243C16.5498%2012.2444%2016.5534%2012.2642%2016.5572%2012.2841C16.5625%2012.3124%2016.5685%2012.3404%2016.5756%2012.3685C16.5806%2012.3888%2016.5865%2012.4088%2016.5924%2012.4289C16.6001%2012.4551%2016.6081%2012.4811%2016.6174%2012.5071C16.6256%2012.5303%2016.6348%2012.553%2016.6442%2012.5757C16.6532%2012.5976%2016.6621%2012.6194%2016.6721%2012.641C16.6849%2012.6684%2016.6991%2012.6951%2016.7135%2012.7217C16.7201%2012.7339%2016.7254%2012.7465%2016.7323%2012.7586C16.735%2012.7633%2016.7383%2012.7675%2016.741%2012.7721C16.7578%2012.8004%2016.7761%2012.8278%2016.7948%2012.8551C16.8048%2012.8697%2016.8143%2012.8849%2016.8247%2012.899C16.8427%2012.9235%2016.8622%2012.9469%2016.8818%2012.9703C16.8949%2012.986%2016.9074%2013.0022%2016.921%2013.0173C16.9381%2013.0361%2016.9565%2013.0538%2016.9746%2013.0719C16.9926%2013.0899%2017.0102%2013.1082%2017.029%2013.1252C17.0441%2013.1389%2017.0603%2013.1515%2017.0761%2013.1646C17.0995%2013.1842%2017.1228%2013.2037%2017.1473%2013.2216C17.1615%2013.2321%2017.1766%2013.2416%2017.1912%2013.2516C17.2186%2013.2702%2017.2459%2013.2885%2017.2743%2013.3053C17.2789%2013.308%2017.283%2013.3112%2017.2877%2013.314L22.3047%2016.2105C23.0304%2016.6295%2023.9584%2016.3809%2024.3773%2015.6552C24.7963%2014.9295%2024.5476%2014.0015%2023.8219%2013.5826Z'%20fill='%2329B5E8'/%3e%3cpath%20id='petal%201'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M21.7826%203.63153C21.3636%202.90587%2020.4357%202.65718%2019.71%203.07614L16.9686%204.65891V1.51724C16.9686%200.679312%2016.2893%200%2015.4513%200C14.6134%200%2013.9341%200.679312%2013.9341%201.51724V7.31036C13.9341%208.14836%2014.6134%208.82761%2015.4513%208.82761C15.8169%208.82761%2016.1523%208.69823%2016.4142%208.48285L21.2272%205.70408C21.9529%205.28518%2022.2015%204.35718%2021.7826%203.63153Z'%20fill='%2329B5E8'/%3e%3c/g%3e%3c/svg%3e";
function DetachedHead() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This Git tree is in a detached HEAD state." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Please commit the latest changes and push to GitHub to continue." })
    ] })
  };
}
function ModuleIsNotAdded(CA) {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: `
The app's main file \`${CA}\` has
not been pushed to GitHub. Please add it to continue.
`, allowHTML: !1 })
  };
}
const DEPLOY_URL = "https://share.streamlit.io/deploy", STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud", STREAMLIT_COMMUNITY_CLOUD_DOCS_URL = "https://share.streamlit.io/cloud-getting-started", STREAMLIT_DEPLOY_TUTORIAL_URL = "https://share.streamlit.io/deployment-tutorial", SNOWFLAKE_LEARN_MORE_URL = "https://share.streamlit.io/sis-about", SNOWFLAKE_TRIAL_URL = "https://share.streamlit.io/snowflake-trial";
function _EMOTION_STRINGIFIED_CSS_ERROR__$4() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledParagraph = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "epbg7au0"
} : {
  target: "epbg7au0",
  label: "StyledParagraph"
})(process.env.NODE_ENV === "production" ? {
  name: "1aujq9w",
  styles: "text-align:justify"
} : {
  name: "1aujq9w",
  styles: "text-align:justify/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQitCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RXJyb3JEaWFsb2dzL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkUGFyYWdyYXBoID0gc3R5bGVkLnAoe1xuICB0ZXh0QWxpZ246IFwianVzdGlmeVwiLFxufSlcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
function NoRepositoryDetected() {
  return {
    title: "Unable to deploy",
    body: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledParagraph, { children: [
      "The app’s code is not connected to a remote GitHub repository. To deploy on Streamlit Community Cloud, please put your code in a GitHub repository and publish the current branch. Read more in",
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: STREAMLIT_COMMUNITY_CLOUD_DOCS_URL, rel: "noopener noreferrer", target: "_blank", children: "our documentation" }),
      "."
    ] })
  };
}
function DeployCard(CA) {
  const {
    colors: gA,
    spacing: AA,
    radii: IA,
    breakpoints: BA,
    sizes: QA
  } = useEmotionTheme(), {
    children: EA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { overrides: {
    Root: {
      style: {
        borderTopWidth: QA.borderWidth,
        borderBottomWidth: QA.borderWidth,
        borderLeftWidth: QA.borderWidth,
        borderRightWidth: QA.borderWidth,
        borderTopStyle: "solid",
        borderBottomStyle: "none",
        borderLeftStyle: "none",
        borderRightStyle: "solid",
        borderTopColor: gA.borderColor,
        borderBottomColor: gA.borderColor,
        borderLeftColor: gA.borderColor,
        borderRightColor: gA.borderColor,
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none",
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        ":last-child": {
          borderRightStyle: "none",
          borderBottomRightRadius: IA.xl
        },
        ":first-child": {
          borderBottomLeftRadius: IA.xl
        },
        [`@media (max-width: ${BA.md})`]: {
          ":last-child": {
            borderBottomLeftRadius: IA.xl
          }
        }
      }
    },
    Contents: {
      style: {
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%"
      }
    },
    Body: {
      style: {
        padding: AA.twoXL,
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        [`@media (max-width: ${BA.md})`]: {
          padding: AA.xl
        }
      }
    }
  }, children: EA });
}
const Checkmark = "data:image/svg+xml,%3csvg%20width='12'%20height='9'%20viewBox='0%200%2012%209'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.00009%206.78L1.68676%204.46667C1.42676%204.20667%201.00676%204.20667%200.746758%204.46667C0.486758%204.72667%200.486758%205.14667%200.746758%205.40667L3.53342%208.19334C3.79342%208.45334%204.21342%208.45334%204.47342%208.19334L11.5268%201.14C11.7868%200.880005%2011.7868%200.460005%2011.5268%200.200005C11.2668%20-0.0599951%2010.8468%20-0.0599951%2010.5868%200.200005L4.00009%206.78Z'%20fill='%23808495'/%3e%3c/svg%3e", StyledHeader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve4"
} : {
  target: "e97l2ve4",
  label: "StyledHeader"
})(({
  theme: CA
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: CA.fonts.sansSerif,
  fontWeight: CA.fontWeights.bold,
  fontSize: CA.fontSizes.lg,
  marginTop: CA.spacing.twoXL,
  marginBottom: CA.spacing.twoXS,
  [`@media (max-width: ${CA.breakpoints.md})`]: {
    marginTop: CA.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSubheader = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve3"
} : {
  target: "e97l2ve3",
  label: "StyledSubheader"
})(({
  theme: CA
}) => ({
  // We do not want to change the font for this based on theme.
  fontFamily: CA.fonts.sansSerif,
  fontWeight: CA.fontWeights.normal,
  fontSize: CA.fontSizes.md,
  marginTop: CA.spacing.twoXS,
  marginBottom: CA.spacing.md,
  [`@media (max-width: ${CA.breakpoints.md})`]: {
    marginTop: CA.spacing.md
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledCardContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve2"
} : {
  target: "e97l2ve2",
  label: "StyledCardContainer"
})(({
  theme: CA
}) => ({
  display: "grid",
  maxWidth: `calc(1.25 * ${CA.sizes.contentMaxWidth})`,
  gridTemplateColumns: "1fr 1fr 1fr",
  gridGap: CA.spacing.none,
  [`@media (max-width: ${CA.breakpoints.md})`]: {
    gridTemplateColumns: "1fr"
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledElement = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve1"
} : {
  target: "e97l2ve1",
  label: "StyledElement"
})(({
  theme: CA
}) => ({
  display: "inline-flex",
  marginTop: CA.spacing.sm,
  "& > span": {
    // We do not want to change the font for this based on theme.
    fontFamily: CA.fonts.sansSerif,
    fontWeight: CA.fontWeights.normal,
    fontSize: CA.fontSizes.md,
    marginLeft: CA.spacing.twoXL,
    color: CA.colors.gray70
  },
  "& > img": {
    position: "absolute",
    marginTop: CA.spacing.sm
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1RDZCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9TdHJlYW1saXREaWFsb2cvRGVwbG95RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICAvLyBXZSBkbyBub3Qgd2FudCB0byBjaGFuZ2UgdGhlIGZvbnQgZm9yIHRoaXMgYmFzZWQgb24gdGhlbWUuXG4gIGZvbnRGYW1pbHk6IHRoZW1lLmZvbnRzLnNhbnNTZXJpZixcbiAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMuYm9sZCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5sZyxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcudHdvWFMsXG5cbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZFN1YmhlYWRlciA9IHN0eWxlZC5kaXYoKHsgdGhlbWUgfSkgPT4gKHtcbiAgLy8gV2UgZG8gbm90IHdhbnQgdG8gY2hhbmdlIHRoZSBmb250IGZvciB0aGlzIGJhc2VkIG9uIHRoZW1lLlxuICBmb250RmFtaWx5OiB0aGVtZS5mb250cy5zYW5zU2VyaWYsXG4gIGZvbnRXZWlnaHQ6IHRoZW1lLmZvbnRXZWlnaHRzLm5vcm1hbCxcbiAgZm9udFNpemU6IHRoZW1lLmZvbnRTaXplcy5tZCxcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnR3b1hTLFxuICBtYXJnaW5Cb3R0b206IHRoZW1lLnNwYWNpbmcubWQsXG5cbiAgW2BAbWVkaWEgKG1heC13aWR0aDogJHt0aGVtZS5icmVha3BvaW50cy5tZH0pYF06IHtcbiAgICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcubWQsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZENhcmRDb250YWluZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZ3JpZFwiLFxuICBtYXhXaWR0aDogYGNhbGMoMS4yNSAqICR7dGhlbWUuc2l6ZXMuY29udGVudE1heFdpZHRofSlgLFxuICBncmlkVGVtcGxhdGVDb2x1bW5zOiBcIjFmciAxZnIgMWZyXCIsXG4gIGdyaWRHYXA6IHRoZW1lLnNwYWNpbmcubm9uZSxcblxuICBbYEBtZWRpYSAobWF4LXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzLm1kfSlgXToge1xuICAgIGdyaWRUZW1wbGF0ZUNvbHVtbnM6IFwiMWZyXCIsXG4gIH0sXG59KSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEVsZW1lbnQgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiaW5saW5lLWZsZXhcIixcbiAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnNtLFxuXG4gIFwiJiA+IHNwYW5cIjoge1xuICAgIC8vIFdlIGRvIG5vdCB3YW50IHRvIGNoYW5nZSB0aGUgZm9udCBmb3IgdGhpcyBiYXNlZCBvbiB0aGVtZS5cbiAgICBmb250RmFtaWx5OiB0aGVtZS5mb250cy5zYW5zU2VyaWYsXG4gICAgZm9udFdlaWdodDogdGhlbWUuZm9udFdlaWdodHMubm9ybWFsLFxuICAgIGZvbnRTaXplOiB0aGVtZS5mb250U2l6ZXMubWQsXG4gICAgbWFyZ2luTGVmdDogdGhlbWUuc3BhY2luZy50d29YTCxcbiAgICBjb2xvcjogdGhlbWUuY29sb3JzLmdyYXk3MCxcbiAgfSxcbiAgXCImID4gaW1nXCI6IHtcbiAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgIG1hcmdpblRvcDogdGhlbWUuc3BhY2luZy5zbSxcbiAgfSxcbn0pKVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uc1dyYXBwZXIgPSBzdHlsZWQuZGl2KCh7IHRoZW1lIH0pID0+ICh7XG4gIGRpc3BsYXk6IFwiZmxleFwiLFxuICBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmcudGhyZWVYTCxcblxuICBcIiYgPiBidXR0b25cIjoge1xuICAgIG1hcmdpblJpZ2h0OiB0aGVtZS5zcGFjaW5nLnR3b1hMLFxuICB9LFxuXG4gIFtgQG1lZGlhIChtYXgtd2lkdGg6ICR7dGhlbWUuYnJlYWtwb2ludHMubWR9KWBdOiB7XG4gICAgbWFyZ2luVG9wOiB0aGVtZS5zcGFjaW5nLnhsLFxuICB9LFxufSkpXG4iXX0= */"), StyledActionsWrapper = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e97l2ve0"
} : {
  target: "e97l2ve0",
  label: "StyledActionsWrapper"
})(({
  theme: CA
}) => ({
  display: "flex",
  marginTop: CA.spacing.threeXL,
  "& > button": {
    marginRight: CA.spacing.twoXL
  },
  [`@media (max-width: ${CA.breakpoints.md})`]: {
    marginTop: CA.spacing.xl
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function DeployListElement(CA) {
  const {
    children: gA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledElement, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Checkmark, alt: "Checkmark" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: gA })
  ] });
}
function ModalBody({
  children: CA
}) {
  const {
    colors: gA,
    fontSizes: AA,
    spacing: IA
  } = useEmotionTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$2, { style: {
    marginTop: IA.none,
    marginLeft: IA.none,
    marginRight: IA.none,
    marginBottom: IA.none,
    paddingTop: IA.md,
    paddingRight: IA.none,
    paddingBottom: IA.none,
    paddingLeft: IA.none,
    color: gA.bodyText,
    fontSize: AA.md,
    overflowY: "auto"
  }, children: CA });
}
function DeployModal(CA) {
  const {
    children: gA,
    onClose: AA
  } = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, closeable: !0, onClose: AA, size: "auto", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Deploy this app using..." }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { children: gA })
  ] });
}
const {
  GitStates
} = GitInfo, openUrl = (CA) => {
  window.open(CA, "_blank");
}, getDeployAppUrl = (CA) => {
  if (CA) {
    const gA = new URL(DEPLOY_URL);
    return gA.searchParams.set("repository", CA.repository ?? ""), gA.searchParams.set("branch", CA.branch ?? ""), gA.searchParams.set("mainModule", CA.module ?? ""), gA.toString();
  }
  return STREAMLIT_CLOUD_URL;
};
function DeployDialog(CA) {
  const {
    gitInfo: gA,
    onClose: AA,
    metricsMgr: IA,
    showDeployError: BA,
    isDeployErrorModalOpen: QA
  } = CA, EA = useCallback(() => {
    if (IA.enqueue("menuClick", {
      label: "deployButtonInDialog"
    }), !gA) {
      const GA = NoRepositoryDetected();
      BA(GA.title, GA.body);
      return;
    }
    const {
      repository: iA,
      branch: oA,
      module: cA,
      untrackedFiles: tA,
      state: eA
    } = gA;
    if ((!iA || !oA || !cA) && eA === GitStates.DEFAULT) {
      const GA = NoRepositoryDetected();
      BA(GA.title, GA.body);
      return;
    }
    if (eA === GitStates.HEAD_DETACHED) {
      const GA = DetachedHead();
      BA(GA.title, GA.body);
      return;
    }
    if (cA && tA?.includes(cA)) {
      const GA = ModuleIsNotAdded(cA);
      BA(GA.title, GA.body);
      return;
    }
    QA && AA(), openUrl(getDeployAppUrl(gA));
  }, [IA, gA, QA, BA, AA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployModal, { onClose: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCardContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: StreamlitLogo, alt: "Streamlit Logo", "data-testid": "stDeployDialogCommunityCloudIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Streamlit Community Cloud" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For community, always free" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "For personal hobbies and learning" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited public apps" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Explore and learn from Streamlit’s community and popular apps" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.PRIMARY, onClick: EA, children: "Deploy now" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          IA.enqueue("menuClick", {
            label: "readMoreCommunityCloudInDeployDialog"
          }), openUrl(STREAMLIT_COMMUNITY_CLOUD_DOCS_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Snowflake, alt: "Snowflake", "data-testid": "stDeployDialogSnowflakeDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Snowflake" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For enterprise" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Enterprise-level security, support, and fully managed infrastructure" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy unlimited private apps with role-based sharing" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Integrate with Snowflake’s full data stack" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionsWrapper, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: () => {
          IA.enqueue("menuClick", {
            label: "startTrialInDeployDialog"
          }), openUrl(SNOWFLAKE_TRIAL_URL);
        }, children: "Start trial" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
          IA.enqueue("menuClick", {
            label: "learnMoreSnowflakeInDeployDialog"
          }), openUrl(SNOWFLAKE_LEARN_MORE_URL);
        }, kind: BaseButtonKind.MINIMAL, children: "Learn more" })
      ] }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DeployCard, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Body, { style: {
        flexGrow: 2
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: Rocket, alt: "Rocket", "data-testid": "stDeployDialogCustomDeploymentIcon" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHeader, { children: "Other platforms" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSubheader, { children: "For custom deployment " }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Deploy on your own hardware or cloud service" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DeployListElement, { children: "Set up and maintain your own authentication, resources, and costs" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Action, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionsWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: () => {
        IA.enqueue("menuClick", {
          label: "readMoreDeployTutorialInDeployDialog"
        }), openUrl(STREAMLIT_DEPLOY_TUTORIAL_URL);
      }, kind: BaseButtonKind.MINIMAL, children: "Learn more" }) }) })
    ] })
  ] }) });
}
function StreamlitDialog(CA) {
  switch (CA.type) {
    case DialogType.ABOUT:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AboutDialog, { ...CA });
    case DialogType.CLEAR_CACHE:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ClearCacheDialog, { ...CA });
    case DialogType.SCRIPT_COMPILE_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ScriptCompileErrorDialog, { ...CA });
    case DialogType.WARNING:
    case DialogType.CONNECTION_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WarningDialog, { ...CA });
    case DialogType.DEPLOY_DIALOG:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployDialog, { ...CA });
    case DialogType.DEPLOY_ERROR:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DeployErrorDialog, { ...CA });
    case void 0:
      return noDialog(CA);
    default:
      return typeNotRecognizedDialog(CA);
  }
}
function AboutDialog(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "About" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: CA.aboutSectionMd && /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: CA.aboutSectionMd, allowHTML: !1 }) })
  ] });
}
function ClearCacheDialog(CA) {
  const AA = ["**Are you sure you want to clear the app's function caches?**", "This will remove all cached entries from functions using", "`@st.cache_data` and `@st.cache_resource`."].join(`  
`);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "stClearCacheDialog", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Clear caches" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: AA, allowHTML: !1 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { autoFocus: !0, kind: BaseButtonKind.GHOST, onClick: CA.onClose, children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: CA.confirmCallback, children: "Clear caches" })
    ] })
  ] }) });
}
function ScriptCompileErrorDialog(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA.onClose, size: "auto", autoFocus: !1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Script execution error" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitErrorCodeBlock$1, { children: CA.exception?.message ? CA.exception.message : "No message" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: CA.onClose, children: "Close" }) })
  ] });
}
function WarningDialog(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA.onClose, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: CA.title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: CA.msg })
  ] });
}
function DeployErrorDialog({
  title: CA,
  msg: gA,
  onClose: AA,
  onContinue: IA,
  onTryAgain: BA
}) {
  const QA = () => {
    AA(), IA && IA();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: AA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: CA }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDeployErrorContent, { children: gA }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.GHOST, onClick: BA, children: "Try again" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: QA, children: IA ? "Continue anyway" : "Close" })
    ] })
  ] });
}
function noDialog({
  onClose: CA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !1, onClose: CA });
}
function typeNotRecognizedDialog(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { isOpen: !0, onClose: CA.onClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: `Dialog type "${CA.type}" not recognized.` }) });
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledActionButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar2"
} : {
  target: "e3g6aar2",
  label: "StyledActionButtonContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  gap: CA.spacing.sm,
  alignItems: "center",
  // line height should be the same as the icon size
  lineHeight: CA.iconSizes.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQjJDIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvY29tcG9uZW50cy9Ub29sYmFyQWN0aW9ucy9zdHlsZWQtY29tcG9uZW50cy50cyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQ29weXJpZ2h0IChjKSBTdHJlYW1saXQgSW5jLiAoMjAxOC0yMDIyKSBTbm93Zmxha2UgSW5jLiAoMjAyMi0yMDI2KVxuICpcbiAqIExpY2Vuc2VkIHVuZGVyIHRoZSBBcGFjaGUgTGljZW5zZSwgVmVyc2lvbiAyLjAgKHRoZSBcIkxpY2Vuc2VcIik7XG4gKiB5b3UgbWF5IG5vdCB1c2UgdGhpcyBmaWxlIGV4Y2VwdCBpbiBjb21wbGlhbmNlIHdpdGggdGhlIExpY2Vuc2UuXG4gKiBZb3UgbWF5IG9idGFpbiBhIGNvcHkgb2YgdGhlIExpY2Vuc2UgYXRcbiAqXG4gKiAgICAgaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKlxuICogVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUgbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZVxuICogZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UgaXMgZGlzdHJpYnV0ZWQgb24gYW4gXCJBUyBJU1wiIEJBU0lTLFxuICogV0lUSE9VVCBXQVJSQU5USUVTIE9SIENPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuXG4gKiBTZWUgdGhlIExpY2Vuc2UgZm9yIHRoZSBzcGVjaWZpYyBsYW5ndWFnZSBnb3Zlcm5pbmcgcGVybWlzc2lvbnMgYW5kXG4gKiBsaW1pdGF0aW9ucyB1bmRlciB0aGUgTGljZW5zZS5cbiAqL1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWRcIlxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uQnV0dG9uQ29udGFpbmVyID0gc3R5bGVkLmRpdigoeyB0aGVtZSB9KSA9PiAoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiB0aGVtZS5zcGFjaW5nLnNtLFxuICBhbGlnbkl0ZW1zOiBcImNlbnRlclwiLFxuICAvLyBsaW5lIGhlaWdodCBzaG91bGQgYmUgdGhlIHNhbWUgYXMgdGhlIGljb24gc2l6ZVxuICBsaW5lSGVpZ2h0OiB0aGVtZS5pY29uU2l6ZXMubWQsXG59KSlcblxuaW50ZXJmYWNlIFN0eWxlZEFjdGlvbkJ1dHRvbkljb25Qcm9wcyB7XG4gIGljb246IHN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgU3R5bGVkQWN0aW9uQnV0dG9uSWNvbiA9IHN0eWxlZC5kaXY8U3R5bGVkQWN0aW9uQnV0dG9uSWNvblByb3BzPihcbiAgKHsgdGhlbWUsIGljb24gfSkgPT4gKHtcbiAgICBiYWNrZ3JvdW5kOiBgdXJsKFwiJHtpY29ufVwiKSBuby1yZXBlYXQgY2VudGVyIC8gY29udGFpbmAsXG4gICAgd2lkdGg6IHRoZW1lLmljb25TaXplcy5iYXNlLFxuICAgIGhlaWdodDogdGhlbWUuaWNvblNpemVzLmJhc2UsXG4gIH0pXG4pXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRUb29sYmFyQWN0aW9ucyA9IHN0eWxlZC5kaXYoe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbiAgZmxleERpcmVjdGlvbjogXCJyb3dcIixcbn0pXG4iXX0= */"), StyledActionButtonIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar1"
} : {
  target: "e3g6aar1",
  label: "StyledActionButtonIcon"
})(({
  theme: CA,
  icon: gA
}) => ({
  background: `url("${gA}") no-repeat center / contain`,
  width: CA.iconSizes.base,
  height: CA.iconSizes.base
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledToolbarActions = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e3g6aar0"
} : {
  target: "e3g6aar0",
  label: "StyledToolbarActions"
})(process.env.NODE_ENV === "production" ? {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row"
} : {
  name: "ye2gio",
  styles: "display:flex;align-items:center;flex-direction:row/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
function ActionButton({
  label: CA,
  icon: gA,
  onClick: AA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "stToolbarActionButton", "data-testid": "stToolbarActionButton", children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { onClick: AA, kind: BaseButtonKind.HEADER_BUTTON, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledActionButtonContainer, { children: [
    gA && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledActionButtonIcon, { "data-testid": "stToolbarActionButtonIcon", icon: gA }),
    CA && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "stToolbarActionButtonLabel", children: CA })
  ] }) }) });
}
function ToolbarActions({
  sendMessageToHost: CA,
  hostToolbarItems: gA,
  metricsMgr: AA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToolbarActions, { className: "stToolbarActions", "data-testid": "stToolbarActions", children: gA.map(({
    key: IA,
    label: BA,
    icon: QA
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton, { label: BA, icon: QA, onClick: () => {
    AA.enqueue("menuClick", {
      label: IA
    }), CA({
      type: "TOOLBAR_ITEM_CALLBACK",
      key: IA
    });
  } }, IA)) });
}
const screencastCounterAnimation = keyframes`
0% {
  opacity: 0;
}
25% {
  opacity: 1;
}
100% {
  opacity: 0;
}`, StyledCountdown = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e7qru6u0"
} : {
  target: "e7qru6u0",
  label: "StyledCountdown"
})(({
  theme: CA
}) => ({
  position: "fixed",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  top: 0,
  left: 0,
  width: CA.sizes.full,
  height: CA.sizes.full,
  fontSize: "40vh",
  color: CA.colors.redTextColor,
  fontWeight: CA.fontWeights.bold,
  opacity: "0.8",
  textShadow: `1px 1px 10px ${CA.colors.grayTextColor}`,
  transition: "opacity 0.3s ease-in-out",
  animation: `${screencastCounterAnimation} 1s`
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Countdown = ({
  countdown: CA,
  endCallback: gA
}) => {
  const [AA, IA] = useState(CA), BA = () => {
    const QA = AA - 1;
    QA >= 0 && IA(QA), QA === 0 && gA();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCountdown, { "data-testid": "stCountdown", onAnimationEnd: BA, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: AA }) }, `frame${AA}`);
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledRecordAudioLabel = /* @__PURE__ */ createStyled("label", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr1"
} : {
  target: "emfz9mr1",
  label: "StyledRecordAudioLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JzQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLmRpdih7XG4gIG1hcmdpbjogMCxcbn0pXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), StyledInstruction = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "emfz9mr0"
} : {
  target: "emfz9mr0",
  label: "StyledInstruction"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvc3RyZWFtbGl0L2Zyb250ZW5kL2FwcC9zcmMvaG9jcy93aXRoU2NyZWVuY2FzdC9jb21wb25lbnRzL1NjcmVlbmNhc3REaWFsb2cvc3R5bGVkLWNvbXBvbmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0JpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3N0cmVhbWxpdC9mcm9udGVuZC9hcHAvc3JjL2hvY3Mvd2l0aFNjcmVlbmNhc3QvY29tcG9uZW50cy9TY3JlZW5jYXN0RGlhbG9nL3N0eWxlZC1jb21wb25lbnRzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBDb3B5cmlnaHQgKGMpIFN0cmVhbWxpdCBJbmMuICgyMDE4LTIwMjIpIFNub3dmbGFrZSBJbmMuICgyMDIyLTIwMjYpXG4gKlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAodGhlIFwiTGljZW5zZVwiKTtcbiAqIHlvdSBtYXkgbm90IHVzZSB0aGlzIGZpbGUgZXhjZXB0IGluIGNvbXBsaWFuY2Ugd2l0aCB0aGUgTGljZW5zZS5cbiAqIFlvdSBtYXkgb2J0YWluIGEgY29weSBvZiB0aGUgTGljZW5zZSBhdFxuICpcbiAqICAgICBodHRwOi8vd3d3LmFwYWNoZS5vcmcvbGljZW5zZXMvTElDRU5TRS0yLjBcbiAqXG4gKiBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZSBsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlXG4gKiBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZSBpcyBkaXN0cmlidXRlZCBvbiBhbiBcIkFTIElTXCIgQkFTSVMsXG4gKiBXSVRIT1VUIFdBUlJBTlRJRVMgT1IgQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC5cbiAqIFNlZSB0aGUgTGljZW5zZSBmb3IgdGhlIHNwZWNpZmljIGxhbmd1YWdlIGdvdmVybmluZyBwZXJtaXNzaW9ucyBhbmRcbiAqIGxpbWl0YXRpb25zIHVuZGVyIHRoZSBMaWNlbnNlLlxuICovXG5cbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRSZWNvcmRBdWRpb0xhYmVsID0gc3R5bGVkLmxhYmVsKHtcbiAgbWFyZ2luOiAwLFxufSlcblxuZXhwb3J0IGNvbnN0IFN0eWxlZEluc3RydWN0aW9uID0gc3R5bGVkLmRpdih7XG4gIG1hcmdpbjogMCxcbn0pXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}), ScreencastDialog = ({
  onClose: CA,
  toggleRecordAudio: gA,
  recordAudio: AA,
  startRecording: IA
}) => {
  const [BA, QA] = useState(AA), EA = useCallback((oA) => {
    const {
      checked: cA
    } = oA.target;
    cA !== BA && (QA(cA), gA());
  }, [BA, gA]), iA = useCallback(() => {
    IA(), CA();
  }, [IA, CA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBody$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "This will record a video with the contents of your screen, so you can easily share what you're seeing with others." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRecordAudioLabel, { "data-testid": "stScreencastAudioCheckbox", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "checkbox", name: "recordAudio", "aria-label": "Also record audio", checked: BA, onChange: EA }),
        " ",
        "Also record audio"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInstruction, { "data-testid": "stScreencastInstruction", children: /* @__PURE__ */ jsxRuntimeExports.jsx(StreamlitMarkdown$1, { source: "Press `Esc` any time to stop recording.", allowHTML: !1 }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalButton, { kind: BaseButtonKind.SECONDARY, onClick: iA, children: "Start recording!" }) })
  ] });
};
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const StyledScreenCastWarningDialog = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly2"
} : {
  target: "e16i1uly2",
  label: "StyledScreenCastWarningDialog"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
}), StyledUnsupportedScreenCastIcon = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly1"
} : {
  target: "e16i1uly1",
  label: "StyledUnsupportedScreenCastIcon"
})(({
  theme: CA
}) => ({
  display: "flex",
  alignItems: "center",
  justifyItems: "center",
  marginRight: CA.spacing.twoXL,
  marginLeft: CA.spacing.sm,
  fontSize: CA.fontSizes.fourXL
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledUnsupportedScreenCastExplanation = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "e16i1uly0"
} : {
  target: "e16i1uly0",
  label: "StyledUnsupportedScreenCastExplanation"
})(({
  theme: CA
}) => ({
  margin: CA.spacing.none
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), UnsupportedBrowserDialog = ({
  onClose: CA
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Record a screencast" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledScreenCastWarningDialog, { "data-testid": "stUnsupportedBrowserDialog", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastIcon, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Alien Monster", children: "👾" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledUnsupportedScreenCastExplanation, { children: "Due to limitations with some browsers, this feature is only supported on recent desktop versions of Chrome, Firefox, and Edge." })
  ] }) })
] }), UnsupportedBrowserDialog$1 = memo(UnsupportedBrowserDialog), StyledVideo = /* @__PURE__ */ createStyled("video", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r6"
} : {
  target: "ecutw1r6",
  label: "StyledVideo"
})(({
  theme: CA
}) => ({
  width: CA.sizes.full,
  borderRadius: CA.radii.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDialogContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r5"
} : {
  target: "ecutw1r5",
  label: "StyledDialogContainer"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "column",
  width: CA.sizes.full
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledRow = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r4"
} : {
  target: "ecutw1r4",
  label: "StyledRow"
})(({
  theme: CA
}) => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: CA.spacing.md,
  paddingBottom: CA.spacing.md
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledFirstColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r3"
} : {
  target: "ecutw1r3",
  label: "StyledFirstColumn"
})(({
  theme: CA
}) => ({
  paddingRight: CA.spacing.lg,
  textAlign: "right",
  color: CA.colors.grayTextColor,
  fontWeight: CA.fontWeights.bold,
  width: "6em"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledSecondColumn = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r2"
} : {
  target: "ecutw1r2",
  label: "StyledSecondColumn"
})(({
  theme: CA
}) => ({
  flex: 1,
  paddingRight: CA.spacing.lg,
  marginRight: "6em",
  [`@media (max-width: ${CA.breakpoints.sm})`]: {
    marginRight: CA.spacing.none
  }
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledVideoFormatInstructions = /* @__PURE__ */ createStyled("p", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r1"
} : {
  target: "ecutw1r1",
  label: "StyledVideoFormatInstructions"
})(({
  theme: CA
}) => ({
  marginTop: CA.spacing.sm,
  marginBottom: CA.spacing.none,
  fontSize: CA.fontSizes.sm
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), StyledDownloadButtonContainer = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "ecutw1r0"
} : {
  target: "ecutw1r0",
  label: "StyledDownloadButtonContainer"
})(({
  theme: CA
}) => ({
  marginTop: CA.spacing.twoXS
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), VideoRecordedDialog = ({
  onClose: CA,
  videoBlob: gA,
  fileName: AA
}) => {
  const IA = URL.createObjectURL(gA), BA = () => {
    const QA = document.createElement("a");
    QA.setAttribute("href", IA), QA.setAttribute("download", `${AA}.webm`), QA.click(), CA();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { isOpen: !0, onClose: CA, overrides: {
    Dialog: {
      style: {
        width: "80vw"
      }
    }
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeader, { children: "Next steps" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDialogContainer, { "data-testid": "stVideoRecordedDialog", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 1" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Preview your video below:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledVideo, { src: IA, controls: !0 })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 2" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDownloadButtonContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { kind: BaseButtonKind.SECONDARY, onClick: BA, children: "Save video to disk" }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledVideoFormatInstructions, { children: [
            "This video is encoded in the",
            " ",
            /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: "https://www.webmproject.org/", children: "WebM format" }),
            ", which is only supported by newer video players. You can also play it by dragging the file directly into your browser."
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFirstColumn, { children: "Step 3" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSecondColumn, { children: [
          "Share your video with the world on Twitter, LinkedIn, YouTube, or just plain email!",
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { role: "img", "aria-label": "Happy", children: "😀" })
        ] })
      ] })
    ] }) })
  ] });
}, LOG$2 = loglevelExports.getLogger("withScreencast");
function withScreencast(CA) {
  const gA = (AA) => {
    const {
      testOverride: IA
    } = AA, BA = useRef(null), [QA, EA] = useState("streamlit-screencast"), [iA, oA] = useState(!1), [cA, tA] = useState(void 0), [eA, aA] = useState(IA || "OFF"), GA = useCallback(() => {
      oA((NA) => !NA);
    }, []), lA = useCallback(async () => {
      if (!(eA === "OFF" || isNullOrUndefined$1(BA.current))) {
        if (eA === "COUNTDOWN") {
          aA("OFF");
          return;
        }
        if (eA === "RECORDING") {
          const NA = BA.current;
          if (!NA || NA.getState() === "inactive")
            aA("OFF");
          else {
            const rA = await NA.stop();
            tA(rA), aA("PREVIEW_FILE");
          }
        }
      }
    }, [eA]), nA = useCallback(async () => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        aA("UNSUPPORTED");
        return;
      }
      BA.current = new ScreenCastRecorder({
        recordAudio: iA,
        onErrorOrStop: () => {
          lA().catch((NA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${NA}`));
        }
      });
      try {
        await BA.current.initialize();
      } catch (NA) {
        LOG$2.warn(`ScreenCastRecorder.initialize error: ${NA}`), aA("UNSUPPORTED");
        return;
      }
      aA("COUNTDOWN");
    }, [iA, lA]), DA = useCallback((NA) => {
      if (!ScreenCastRecorder.isSupportedBrowser()) {
        aA("UNSUPPORTED");
        return;
      }
      if (eA === "OFF") {
        EA(NA), aA("SETUP");
        return;
      }
      lA().catch((rA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${rA}`));
    }, [eA, lA]), hA = useCallback(() => {
      if (isNullOrUndefined$1(BA.current))
        throw new Error("Countdown finished but recorder is null");
      BA.current.start() ? aA("RECORDING") : lA().catch((rA) => LOG$2.warn(`withScreencast.stopRecording threw an error: ${rA}`));
    }, [lA]), wA = useCallback(() => {
      aA("OFF");
    }, []), sA = {
      currentState: eA,
      toggleRecordAudio: GA,
      startRecording: DA,
      // triggers the setup/showDialog process
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      stopRecording: lA
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "withScreencast", "data-testid": "stScreencast", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CA, { ...AA, screenCast: sA }),
      eA === "UNSUPPORTED" && /* @__PURE__ */ jsxRuntimeExports.jsx(UnsupportedBrowserDialog$1, { onClose: wA }),
      eA === "SETUP" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ScreencastDialog,
        {
          recordAudio: iA,
          onClose: wA,
          startRecording: nA,
          toggleRecordAudio: GA
        }
      ),
      eA === "COUNTDOWN" && /* @__PURE__ */ jsxRuntimeExports.jsx(Countdown, { countdown: 3, endCallback: hA }),
      eA === "PREVIEW_FILE" && cA && /* @__PURE__ */ jsxRuntimeExports.jsx(VideoRecordedDialog, { onClose: wA, videoBlob: cA, fileName: QA })
    ] });
  };
  return gA.displayName = `withScreencast(${CA.displayName || CA.name || "Component"})`, hoistNonReactStatics(gA, CA);
}
const useViewportSize = () => {
  const {
    activeTheme: CA
  } = useContext(ThemeContext), {
    innerWidth: gA
  } = useWindowDimensionsContext(), AA = parseInt(CA.emotion.breakpoints.md, 10);
  return {
    isMobile: gA < AA
  };
}, DEFAULT_METRICS_CONFIG = "https://data.streamlit.io/metrics.json", LOG$1 = loglevelExports.getLogger("MetricsManager");
class MetricsManager {
  constructor(gA) {
    this.initialized = !1, this.actuallySendMetrics = !1, this.metricsUrl = void 0, this.sendMessageToHost = () => {
    }, this.anonymousId = "", this.pendingEvents = [], this.appHash = "Not initialized", this.metadata = {}, this.setAppHash = (AA) => {
      this.appHash = AA;
    }, this.setMetricsConfig = (AA = "") => {
      this.metricsUrl = AA;
    }, this.sessionInfo = gA;
  }
  async initialize({
    gatherUsageStats: gA,
    sendMessageToHost: AA
  }) {
    this.sendMessageToHost = AA, this.actuallySendMetrics = gA && this.metricsUrl !== "off", this.getAnonymousId(), this.actuallySendMetrics && !this.metricsUrl && (await this.requestDefaultMetricsConfig(), this.metricsUrl || (LOG$1.error("Undefined metrics config - deactivating metrics tracking."), this.actuallySendMetrics = !1)), this.actuallySendMetrics && this.sendPendingEvents(), LOG$1.info("Gather usage stats: ", this.actuallySendMetrics), this.initialized = !0;
  }
  enqueue(gA, AA = {}) {
    if (!this.initialized || !this.sessionInfo.isSet) {
      this.pendingEvents.push([gA, AA]);
      return;
    }
    this.actuallySendMetrics && (this.pendingEvents.length && this.sendPendingEvents(), this.send(gA, AA));
  }
  setMetadata(gA) {
    this.metadata = gA;
  }
  // Fallback - Checks if cached in localStorage, otherwise fetches the config from a default URL
  async requestDefaultMetricsConfig() {
    const gA = localStorageAvailable();
    if (gA) {
      const AA = window.localStorage.getItem("stMetricsConfig");
      if (AA) {
        this.metricsUrl = AA;
        return;
      }
    }
    try {
      const AA = await fetch(DEFAULT_METRICS_CONFIG, {
        signal: AbortSignal.timeout(5e3)
      });
      if (!AA.ok)
        this.metricsUrl = void 0, LOG$1.error("Failed to fetch metrics config: ", AA.status);
      else {
        const IA = await AA.json();
        this.metricsUrl = IA.url ?? void 0, gA && this.metricsUrl && window.localStorage.setItem("stMetricsConfig", this.metricsUrl);
      }
    } catch (AA) {
      LOG$1.error("Failed to fetch metrics config:", AA);
    }
  }
  // The schema of metrics events (including key names and value types) should
  // only be changed when requested by the data team. This is why `reportHash`
  // retains its old name.
  send(gA, AA = {}) {
    const IA = this.buildEventProto(gA, AA);
    this.metricsUrl === "postMessage" ? this.postMessageEvent(gA, IA) : this.track(IA);
  }
  sendPendingEvents() {
    this.pendingEvents.forEach(([gA, AA]) => {
      this.send(gA, AA);
    }), this.pendingEvents = [];
  }
  async track(gA) {
    const AA = new Request(this.metricsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(gA.toJSON())
    });
    await fetch(AA);
  }
  // Helper to send metrics events to host
  postMessageEvent(gA, AA) {
    this.sendMessageToHost({
      type: "METRICS_EVENT",
      eventName: gA,
      data: AA
    });
  }
  // Helper to build the event proto
  buildEventProto(gA, AA) {
    const IA = new MetricsEvent({
      event: gA,
      anonymousId: this.anonymousId,
      ...this.getHostTrackingData(),
      ...this.getInstallationData(),
      reportHash: this.appHash,
      dev: IS_DEV_ENV,
      source: "browser",
      streamlitVersion: this.sessionInfo.current.streamlitVersion,
      isHello: this.sessionInfo.isHello,
      appId: this.sessionInfo.current.appId,
      sessionId: this.sessionInfo.current.sessionId,
      pythonVersion: this.sessionInfo.current.pythonVersion,
      serverOs: this.sessionInfo.current.serverOS,
      hasDisplay: this.sessionInfo.current.hasDisplay,
      isWebdriver: isWebdriver(),
      ...this.getContextData()
    });
    if (gA === "menuClick")
      IA.label = AA.label;
    else if (gA === "pageProfile")
      return new MetricsEvent({
        ...IA,
        ...AA
      });
    return IA;
  }
  // Get the installation IDs from the session
  getInstallationData() {
    return {
      machineIdV3: this.sessionInfo.current.installationIdV3,
      machineIdV4: this.sessionInfo.current.installationIdV4
    };
  }
  // Use the tracking data injected by the host of the app if included.
  getHostTrackingData() {
    return this.metadata ? pick$1(this.metadata, ["hostedAt", "owner", "repo", "branch", "mainModule", "creatorId"]) : {};
  }
  // Get context data for events
  getContextData() {
    return {
      contextPageUrl: window.location.href,
      contextPageTitle: document.title,
      contextPagePath: window.location.pathname,
      contextPageReferrer: document.referrer,
      contextPageSearch: window.location.search,
      contextLocale: window.navigator.language,
      contextUserAgent: window.navigator.userAgent
    };
  }
  /**
   * Get/Create user's anonymous ID
   * Checks if existing in cookie or localStorage, otherwise generates
   * a new UUID and stores it in both.
   */
  getAnonymousId() {
    if (!this.actuallySendMetrics) return;
    const gA = "ajs_anonymous_id", AA = localStorageAvailable(), IA = getCookie(gA), BA = AA ? window.localStorage.getItem(gA) : null, QA = /* @__PURE__ */ new Date();
    if (QA.setFullYear((/* @__PURE__ */ new Date()).getFullYear() + 1), IA)
      this.anonymousId = IA, AA && window.localStorage.setItem(gA, IA);
    else if (BA) {
      try {
        this.anonymousId = JSON.parse(BA);
      } catch {
        this.anonymousId = BA;
      }
      setCookie(gA, this.anonymousId, QA);
    } else
      this.anonymousId = v4(), setCookie(gA, this.anonymousId, QA), AA && window.localStorage.setItem(gA, this.anonymousId);
  }
}
function isWebdriver() {
  return window.navigator?.webdriver ?? !1;
}
class SessionEventDispatcher {
  constructor() {
    this.onSessionEvent = new distExports.Signal();
  }
  /** Redispatches a ForwardMsg.SessionEvent via a signal. */
  handleSessionEventMsg(gA) {
    this.onSessionEvent.emit(gA);
  }
}
const StyledApp = /* @__PURE__ */ createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "erw9t6i0"
} : {
  target: "erw9t6i0",
  label: "StyledApp"
})(({
  theme: CA
}) => {
  const gA = hasLightBackgroundColor(CA);
  return {
    position: "absolute",
    background: CA.colors.bgColor,
    color: CA.colors.bodyText,
    top: CA.spacing.none,
    left: CA.spacing.none,
    right: CA.spacing.none,
    bottom: CA.spacing.none,
    colorScheme: gA ? "light" : "dark",
    overflow: "hidden",
    "@media print": {
      float: "none",
      height: CA.sizes.full,
      position: "static",
      overflow: "visible"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function getBrowserInfo() {
  const gA = new UAParser().getResult();
  return {
    browserName: gA.browser.name || "Unknown",
    browserVersion: gA.browser.version || "Unknown",
    /**
     * 'desktop' is not a valid value for device.type in ua-parser-js.
     * We default to 'desktop' if the value is not present.
     * Possible options from ua-parser-js are:
     * 'mobile', 'tablet', 'smarttv', 'wearable', 'embedded', 'console'
     */
    deviceType: gA.device.type || "desktop",
    os: gA.os.name || "Unknown"
  };
}
const showDevelopmentOptions = (CA, gA) => gA == Config.ToolbarMode.DEVELOPER ? !0 : Config.ToolbarMode.VIEWER == gA || Config.ToolbarMode.MINIMAL == gA ? !1 : CA || isLocalhost();
function getTitle(CA) {
  return CA || "Streamlit";
}
class AppNavigation {
  constructor(gA, AA, IA, BA) {
    this.hostCommunicationMgr = gA, this.onUpdatePageUrl = AA, this.onPageNotFound = IA, this.onPageIconChange = BA, this.isPageIconSet = !1, this.isPageTitleSet = !1, this.hasSetDefaultFavicon = !1, this.mainScriptHash = null, this.appPages = [], this.mainPage = null, this.hideSidebarNav = null;
  }
  handleNewSession(gA) {
    return this.mainScriptHash !== gA.mainScriptHash && (this.isPageTitleSet = !1, this.isPageIconSet = !1, this.hasSetDefaultFavicon = !1), this.mainScriptHash = gA.mainScriptHash, this.hideSidebarNav === null && (this.hideSidebarNav = gA.config?.hideSidebarNav ?? null), document.title = getTitle(""), [{
      // Set current page script hash to handle SPA case
      currentPageScriptHash: gA.pageScriptHash,
      hideSidebarNav: this.hideSidebarNav ?? !1
    }, () => {
    }];
  }
  handleNavigation(gA) {
    const {
      sections: AA,
      position: IA,
      appPages: BA
    } = gA;
    this.appPages = BA, this.hideSidebarNav = IA === Navigation.Position.HIDDEN;
    const QA = gA.pageScriptHash, EA = BA.find((cA) => cA.pageScriptHash === QA), iA = BA.find((cA) => cA.isDefault);
    this.mainPage = iA;
    const oA = EA.urlPathname;
    if (!this.isPageTitleSet) {
      const cA = getTitle(EA.pageName);
      document.title = cA, this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: EA.pageName ?? ""
      });
    }
    return !this.isPageIconSet && EA.icon && this.onPageIconChange(EA.icon), [{
      appPages: BA,
      navSections: AA,
      hideSidebarNav: this.hideSidebarNav,
      expandSidebarNav: gA.expanded,
      sidebarNavVisibleItems: gA.visibleItems ?? void 0,
      currentPageScriptHash: QA
    }, () => {
      this.onUpdatePageUrl(iA.urlPathname ?? "", oA, EA.isDefault ?? !1), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_APP_PAGES",
        appPages: BA
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        // Make sure we don't send the official page name for the main page
        // This command is used to update the URL in the url bar, so the main page
        // should not have a page name in the URL.
        currentPageName: EA.isDefault ? "" : oA,
        currentPageScriptHash: QA
      });
    }];
  }
  handlePageNotFound(gA) {
    return this.onPageNotFound(gA), [{
      currentPageScriptHash: this.mainScriptHash ?? ""
    }, () => {
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_CURRENT_PAGE_NAME",
        currentPageName: "",
        currentPageScriptHash: this.mainScriptHash ?? ""
      });
    }];
  }
  findPageByUrlPath(gA) {
    return this.appPages.find((AA) => (
      // The page name is embedded at the end of the URL path, and if not, we are in the main page.
      // See https://github.com/streamlit/streamlit/blob/1.19.0/frontend/src/App.tsx#L740
      gA.endsWith("/" + AA.urlPathname)
    )) ?? this.mainPage;
  }
  handlePageConfigChanged(gA) {
    gA.favicon && (this.isPageIconSet = !0), gA.title && (this.isPageTitleSet = !0);
  }
  clearPageElements(gA, AA) {
    return gA.filterMainScriptElements(AA);
  }
}
function includeIfDefined(CA) {
  return Object.entries(CA).reduce((gA, [AA, IA]) => (IA !== void 0 && (gA[AA] = IA), gA), {});
}
function preferWindowValue(CA, gA) {
  return CA ?? gA;
}
function reconcileHostConfigValues(CA, gA) {
  if (!CA)
    return gA;
  const AA = isValidAllowedOrigins(CA.allowedOrigins) ? CA.allowedOrigins : void 0;
  return {
    ...gA,
    // AppConfig fields
    allowedOrigins: preferWindowValue(AA, gA.allowedOrigins),
    useExternalAuthToken: preferWindowValue(CA.useExternalAuthToken, gA.useExternalAuthToken),
    enableCustomParentMessages: preferWindowValue(CA.enableCustomParentMessages, gA.enableCustomParentMessages),
    blockErrorDialogs: preferWindowValue(CA.blockErrorDialogs, gA.blockErrorDialogs),
    // LibConfig fields
    mapboxToken: preferWindowValue(CA.mapboxToken, gA.mapboxToken),
    disableFullscreenMode: preferWindowValue(CA.disableFullscreenMode, gA.disableFullscreenMode),
    enforceDownloadInNewTab: preferWindowValue(CA.enforceDownloadInNewTab, gA.enforceDownloadInNewTab),
    resourceCrossOriginMode: preferWindowValue(CA.resourceCrossOriginMode, gA.resourceCrossOriginMode),
    // Deprecated field - preserve from endpoint (not overridable via window)
    // This is used as a fallback for resourceCrossOriginMode in App.tsx
    setAnonymousCrossOriginPropertyOnMediaElements: gA.setAnonymousCrossOriginPropertyOnMediaElements,
    // MetricsConfig fields
    metricsUrl: preferWindowValue(CA.metricsUrl, gA.metricsUrl)
  };
}
const INITIAL_SCRIPT_RUN_ID = "<null>", LOG = loglevelExports.getLogger("App"), Rg = class Rg extends PureComponent {
  constructor(gA) {
    super(gA), this.sessionInfo = new SessionInfo(), this.metricsMgr = new MetricsManager(this.sessionInfo), this.sessionEventDispatcher = new SessionEventDispatcher(), this.embeddingId = generateUID$2(), this.appRootRef = createRef(), this.deferredFileListeners = /* @__PURE__ */ new Map(), this.isInitializingConnectionManager = !0, this.hasReceivedNewSession = !1, this.showDeployError = (AA, IA, BA) => {
      const QA = {
        type: DialogType.DEPLOY_ERROR,
        title: AA,
        msg: IA,
        onContinue: BA,
        onClose: () => {
        },
        onTryAgain: this.sendLoadGitInfoBackMsg
      };
      this.openDialog(QA);
    }, this.handleThemeMessage = (AA, IA) => {
      const [, BA, QA] = createPresetThemes(), EA = isPresetTheme(this.props.theme.activeTheme);
      AA === BA.name && EA ? this.props.theme.setTheme(BA) : AA === QA.name && EA ? this.props.theme.setTheme(QA) : IA && this.props.theme.setImportedTheme(IA);
    }, this.handleConnectionStateChanged = (AA) => {
      if (LOG.info(`Connection state changed from ${this.state.connectionState} to ${AA}`), AA === ConnectionState.CONNECTED) {
        LOG.info("Reconnected to server."), this.state.connectionErrorDismissed && this.setState({
          connectionErrorDismissed: !1
        });
        const IA = this.state.scriptRunState === ScriptRunState.RUNNING, BA = this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED;
        !this.sessionInfo.last || IA || BA || // Script is using fragments (fragments in last run or
        // fragment auto-reruns configured):
        this.state.fragmentIdsThisRun.length > 0 || this.state.autoReruns.length > 0 ? (LOG.info("Requesting a script run."), this.widgetMgr.sendUpdateWidgetsMessage(void 0), this.setState({
          dialog: null
        })) : this.state.dialog?.type === DialogType.CONNECTION_ERROR && this.setState({
          dialog: null
        }), this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_CONNECTED"
        });
      } else
        this.state.connectionState === ConnectionState.CONNECTED && this.hostCommunicationMgr.sendMessageToHost({
          type: "WEBSOCKET_DISCONNECTED",
          attemptingToReconnect: AA !== ConnectionState.DISCONNECTED_FOREVER
        }), this.sessionInfo.isSet && this.sessionInfo.disconnect();
      this.isInitializingConnectionManager ? this.setState({
        connectionState: AA
      }) : flushSync(() => {
        this.setState({
          connectionState: AA
        });
      });
    }, this.handleGitInfoChanged = (AA) => {
      this.setState({
        gitInfo: AA
      });
    }, this.handleCustomParentMessage = (AA) => {
      this.state.appConfig.enableCustomParentMessages ? this.hostCommunicationMgr.sendMessageToHost({
        type: "CUSTOM_PARENT_MESSAGE",
        message: AA.message
      }) : LOG.error("Sending messages to the host is disabled in line with the platform policy.");
    }, this.handleMessage = (AA) => {
      const IA = (BA, QA, EA) => {
        const iA = BA[QA];
        if (iA in EA)
          return EA[iA](BA[iA]);
        throw new Error(`Cannot handle ${QA} "${iA}".`);
      };
      try {
        IA(AA, "type", {
          newSession: (BA) => this.handleNewSession(BA),
          sessionStatusChanged: (BA) => this.handleSessionStatusChanged(BA),
          sessionEvent: (BA) => this.handleSessionEvent(BA),
          delta: (BA) => this.handleDeltaMsg(BA, AA.metadata),
          pageConfigChanged: (BA) => this.handlePageConfigChanged(BA),
          pageInfoChanged: (BA) => this.handlePageInfoChanged(BA),
          pageNotFound: (BA) => this.handlePageNotFound(BA),
          gitInfoChanged: (BA) => this.handleGitInfoChanged(BA),
          scriptFinished: (BA) => this.handleScriptFinished(BA),
          pageProfile: (BA) => this.handlePageProfileMsg(BA),
          autoRerun: (BA) => this.handleAutoRerun(BA),
          fileUrlsResponse: (BA) => this.uploadClient.onFileURLsResponse(BA),
          deferredFileResponse: (BA) => this.handleDeferredFileResponse(BA),
          parentMessage: (BA) => this.handleCustomParentMessage(BA),
          logo: (BA) => this.handleLogo(BA, AA.metadata),
          navigation: (BA) => this.handleNavigation(BA),
          authRedirect: (BA) => {
            isInChildFrame() ? this.hostCommunicationMgr.sendMessageToSameOriginHost({
              type: "REDIRECT_TO_URL",
              url: BA.url
            }) : window.location.href = BA.url;
          },
          heartbeatAck: () => this.handleHeartbeatAck()
        });
      } catch (BA) {
        const QA = ensureError(BA);
        LOG.error(QA), this.showError("Bad message format", {
          message: QA.message
        });
      }
    }, this.handleLogo = (AA, IA) => {
      this.setState((BA) => ({
        elements: BA.elements.appRootWithLogo(AA, {
          // Pass the current page & run ID for cleanup
          activeScriptHash: IA.activeScriptHash,
          scriptRunId: BA.scriptRunId
        })
      }));
    }, this.handlePageConfigChanged = (AA) => {
      const {
        title: IA,
        favicon: BA,
        layout: QA,
        initialSidebarState: EA,
        initialSidebarWidth: iA,
        menuItems: oA
      } = AA;
      this.appNavigation.handlePageConfigChanged(AA), IA && (this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_PAGE_TITLE",
        title: IA
      }), document.title = IA), BA && this.onPageIconChanged(BA), QA !== this.state.layout && QA !== PageConfig.Layout.LAYOUT_UNSET && this.setState((tA) => ({
        layout: QA,
        userSettings: {
          ...tA.userSettings,
          wideMode: QA === PageConfig.Layout.WIDE
        }
      })), EA !== this.state.initialSidebarState && EA !== PageConfig.SidebarState.SIDEBAR_UNSET && this.setState(() => ({
        initialSidebarState: EA
      }));
      const cA = iA?.pixelWidth !== void 0 ? iA.pixelWidth : void 0;
      notNullOrUndefined(cA) && cA !== this.state.initialSidebarWidth && this.setState(() => ({
        initialSidebarWidth: cA
      })), oA && this.setState((tA) => (oA.clearAboutMd && (oA.aboutSectionMd = ""), {
        menuItems: {
          ...tA.menuItems,
          ...oA
        }
      }));
    }, this.handleQueryParamsFromWidget = (AA) => {
      this.setState({
        queryParams: AA
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_QUERY_PARAM",
        queryParams: AA ? `?${AA}` : ""
      });
    }, this.handlePageInfoChanged = (AA) => {
      const {
        queryString: IA
      } = AA, BA = document.location.pathname + (IA ? `?${IA}` : "");
      window.history.pushState({}, "", BA), this.setState({
        queryParams: IA
      }), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_QUERY_PARAM",
        queryParams: IA ? `?${IA}` : ""
      });
    }, this.onPageNotFound = (AA) => {
      const IA = AA ? `You have requested page /${AA}, but no corresponding file was found in the app's pages/ directory` : "The page that you have requested does not seem to exist";
      this.showError("Page not found", {
        message: `${IA}. Running the app's main page.`
      });
    }, this.handlePageNotFound = (AA) => {
      const {
        pageName: IA
      } = AA;
      this.maybeSetState(this.appNavigation.handlePageNotFound(IA));
    }, this.onPageIconChanged = (AA) => {
      handleFavicon(AA, this.hostCommunicationMgr.sendMessageToHost, this.endpoints);
    }, this.handleNavigation = (AA) => {
      this.setState({
        navigationPosition: AA.position
      }), this.maybeSetState(this.appNavigation.handleNavigation(AA));
    }, this.handlePageProfileMsg = (AA) => {
      const IA = PageProfile.toObject(AA), BA = getBrowserInfo();
      this.metricsMgr.enqueue("pageProfile", {
        ...IA,
        isFragmentRun: !!IA.isFragmentRun,
        numPages: this.state.appPages?.length,
        pageScriptHash: this.state.currentPageScriptHash,
        activeTheme: this.props.theme?.activeTheme?.name,
        totalLoadTime: Math.round((performance.now() - this.state.latestRunTime) * 1e3),
        browserInfo: BA
      });
    }, this.handleAutoRerun = (AA) => {
      const IA = setInterval(() => {
        this.widgetMgr.sendUpdateWidgetsMessage(AA.fragmentId, !0);
      }, AA.interval * 1e3);
      this.setState((BA) => ({
        autoReruns: [...BA.autoReruns, IA]
      }));
    }, this.handleSessionStatusChanged = (AA) => {
      this.setState((IA) => {
        let {
          scriptRunState: BA
        } = IA, {
          dialog: QA
        } = IA;
        return AA.scriptIsRunning && IA.scriptRunState !== ScriptRunState.STOP_REQUESTED ? (BA = ScriptRunState.RUNNING, notNullOrUndefined(QA) && QA.type === DialogType.SCRIPT_COMPILE_ERROR && (QA = void 0)) : !AA.scriptIsRunning && IA.scriptRunState !== ScriptRunState.RERUN_REQUESTED && IA.scriptRunState !== ScriptRunState.COMPILATION_ERROR && (BA = ScriptRunState.NOT_RUNNING), {
          userSettings: {
            ...IA.userSettings,
            runOnSave: !!AA.runOnSave
          },
          dialog: QA,
          scriptRunState: BA,
          // Reset scriptChangedOnDisk when script starts running
          scriptChangedOnDisk: AA.scriptIsRunning ? !1 : IA.scriptChangedOnDisk
        };
      });
    }, this.handleSessionEvent = (AA) => {
      if (this.sessionEventDispatcher.handleSessionEventMsg(AA), AA.type === "scriptCompilationException") {
        this.setState({
          scriptRunState: ScriptRunState.COMPILATION_ERROR
        });
        const IA = {
          type: DialogType.SCRIPT_COMPILE_ERROR,
          exception: AA.scriptCompilationException,
          onClose: () => {
          }
        };
        this.maybeShowErrorDialog(IA, AA.scriptCompilationException?.message ?? "No message");
      } else AA.type === "scriptChangedOnDisk" && this.setState({
        scriptChangedOnDisk: !0
      });
    }, this.maybeUpdatePageUrl = (AA, IA, BA) => {
      const QA = this.getBaseUriParts();
      if (QA) {
        let EA;
        StreamlitConfig.MAIN_PAGE_BASE_URL ? EA = parseUriIntoBaseParts(StreamlitConfig.MAIN_PAGE_BASE_URL).pathname : EA = QA.pathname;
        const iA = extractPageNameFromPathName(document.location.pathname, EA);
        if ((iA === "" ? AA : iA) !== IA) {
          const cA = BA ? "" : IA, tA = this.state.queryParams || preserveEmbedQueryParams(), eA = tA ? `?${tA}` : "", GA = `${EA === "/" ? "" : EA}/${cA}${eA}`;
          if (window.location.protocol === "file:") {
            console.warn("Skipping history.pushState() due to file: protocol.");
            return;
          }
          const lA = GA.endsWith("/") && GA !== "/" ? GA.slice(0, -1) : GA;
          window.history.pushState({}, "", lA);
        }
      }
    }, this.handleNewSession = (AA) => {
      const IA = AA.initialize;
      if (this.hasStreamlitVersionChanged(IA)) {
        window.location.reload();
        return;
      }
      this.hasReceivedNewSession = !0, (!this.sessionInfo.isSet || !this.sessionInfo.current.isConnected) && this.handleInitialization(AA);
      const {
        appHash: BA,
        currentPageScriptHash: QA
      } = this.state, {
        scriptRunId: EA,
        name: iA,
        mainScriptPath: oA,
        fragmentIdsThisRun: cA,
        pageScriptHash: tA,
        mainScriptHash: eA
      } = AA;
      if (cA.length)
        this.setState({
          fragmentIdsThisRun: cA,
          latestRunTime: performance.now()
        });
      else {
        this.cleanupAutoReruns();
        const GA = AA.config, lA = AA.customTheme;
        this.processThemeInput(lA), this.setState({
          allowRunOnSave: GA.allowRunOnSave,
          hideTopBar: GA.hideTopBar,
          toolbarMode: GA.toolbarMode,
          showErrorLinks: GA.showErrorLinks,
          latestRunTime: performance.now(),
          mainScriptHash: eA,
          // If we're here, the fragmentIdsThisRun variable is always the
          // empty array.
          fragmentIdsThisRun: cA
        }), this.maybeSetState(this.appNavigation.handleNewSession(AA)), !this.appNavigation.hasSetDefaultFavicon && !this.appNavigation.isPageIconSet && (this.appNavigation.hasSetDefaultFavicon = !0, this.onPageIconChanged("./favicon.png"));
      }
      const aA = hashString(this.sessionInfo.current.installationId + oA);
      this.metricsMgr.setMetadata(this.state.deployedAppMetadata), this.metricsMgr.setAppHash(aA), this.metricsMgr.enqueue("updateReport"), BA === aA && QA === tA ? this.setState((GA) => ({
        // Clear the transient nodes before executing everything else.
        elements: GA.elements.clearTransientNodes(cA),
        scriptRunId: EA
      })) : this.clearAppState(aA, EA, iA, eA);
    }, this.handleInitialization = (AA) => {
      const IA = AA.initialize, BA = AA.config;
      this.sessionInfo.setCurrent(SessionInfo.propsFromNewSessionMessage(AA)), this.metricsMgr.initialize({
        gatherUsageStats: BA.gatherUsageStats,
        sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost
      }), this.handleSessionStatusChanged(IA.sessionStatus);
    }, this.onHistoryChange = () => {
      const {
        currentPageScriptHash: AA
      } = this.state, IA = this.appNavigation.findPageByUrlPath(document.location.pathname), BA = document.location.toString().includes("#"), QA = IA?.pageScriptHash === AA;
      isNullOrUndefined$1(IA) || BA && QA || this.onPageChange(IA.pageScriptHash, void 0, !0);
    }, this.setAndSendTheme = (AA) => {
      this.props.theme.setTheme(AA), this.hostCommunicationMgr.sendMessageToHost({
        type: "SET_THEME_CONFIG",
        themeInfo: toExportedTheme(AA.emotion)
      });
    }, this.createThemeHash = (AA) => {
      if (!AA)
        return "hash_for_undefined_custom_theme";
      const IA = JSON.parse(JSON.stringify(AA)), BA = sortThemeInputKeys(IA);
      return hashString(JSON.stringify(BA));
    }, this.closeDialog = () => {
      this.state.dialog?.type === DialogType.CONNECTION_ERROR ? this.setState({
        dialog: void 0,
        connectionErrorDismissed: !0
      }) : this.setState({
        dialog: void 0
      });
    }, this.saveSettings = (AA) => {
      const {
        runOnSave: IA
      } = this.state.userSettings, {
        runOnSave: BA
      } = AA;
      if (this.setState({
        userSettings: AA
      }), IA !== BA && this.isServerConnected()) {
        const QA = new BackMsg({
          setRunOnSave: BA
        });
        QA.type = "setRunOnSave", this.sendBackMsg(QA);
      }
    }, this.handleRunOnSaveChange = (AA) => {
      this.saveSettings({
        ...this.state.userSettings,
        runOnSave: AA
      });
    }, this.handleDeltaMsg = (AA, IA) => {
      this.setState((BA) => ({
        elements: BA.elements.applyDelta(BA.scriptRunId, AA, IA)
      }));
    }, this.debugShutdownRuntime = () => {
      if (this.isServerConnected()) {
        const AA = new BackMsg({
          debugShutdownRuntime: !0
        });
        AA.type = "debugShutdownRuntime", this.sendBackMsg(AA);
      }
    }, this.debugDisconnectWebsocket = () => {
      if (this.isServerConnected()) {
        const AA = new BackMsg({
          debugDisconnectWebsocket: !0
        });
        AA.type = "debugDisconnectWebsocket", this.sendBackMsg(AA);
      }
    }, this.debugClearForwardMsgCache = () => {
      isLocalhost() && this.connectionManager?.websocketConnection?.cache.messages.clear();
    }, this.cleanupAutoReruns = () => {
      this.state.autoReruns.forEach((AA) => {
        clearInterval(AA);
      }), this.setState({
        autoReruns: []
      });
    }, this.rerunScript = (AA = !1) => {
      if (this.closeDialog(), !this.isServerConnected()) {
        LOG.error("Cannot rerun script when disconnected from server.");
        return;
      }
      this.state.scriptRunState === ScriptRunState.RUNNING || this.state.scriptRunState === ScriptRunState.RERUN_REQUESTED || (this.setState({
        scriptRunState: ScriptRunState.RERUN_REQUESTED
      }), AA === !0 && this.saveSettings({
        ...this.state.userSettings,
        runOnSave: !0
      }), this.widgetMgr.sendUpdateWidgetsMessage(void 0));
    }, this.sendLoadGitInfoBackMsg = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot load git information when disconnected from server.");
        return;
      }
      this.sendBackMsg(new BackMsg({
        loadGitInfo: !0
      }));
    }, this.onPageChange = (AA, IA, BA) => {
      const {
        elements: QA,
        mainScriptHash: EA
      } = this.state;
      this.cleanupAutoReruns();
      const iA = this.appNavigation.clearPageElements(QA, EA), oA = new Set(Array.from(iA.getElements()).map((cA) => getElementId(cA)).filter(notUndefined));
      this.sendRerunBackMsg(this.widgetMgr.getActiveWidgetStates(oA), void 0, AA, void 0, IA, BA);
    }, this.isAppInReadyState = (AA) => this.state.connectionState === ConnectionState.CONNECTED && this.state.scriptRunState === ScriptRunState.NOT_RUNNING && AA.scriptRunState === ScriptRunState.RUNNING && AA.connectionState === ConnectionState.CONNECTED, this.sendRerunBackMsg = (AA, IA, BA, QA, EA, iA) => {
      const oA = this.getBaseUriParts();
      if (!oA) {
        LOG.error("Cannot send rerun backMessage when disconnected from server.");
        return;
      }
      const {
        currentPageScriptHash: cA
      } = this.state;
      let tA = EA ?? this.getQueryString(), eA = "";
      const aA = {
        timezone: getTimezone$1(),
        timezoneOffset: getTimezoneOffset(),
        locale: getLocaleLanguage(),
        url: getUrl(),
        isEmbedded: isEmbed(),
        colorScheme: this.getThemeColorScheme()
      };
      if (BA) {
        if (BA !== cA && !iA) {
          const lA = this.widgetMgr.filterParamsForPageChange(preserveEmbedQueryParams());
          tA = getQueryString(EA, lA), this.setState({
            queryParams: tA
          }), this.hostCommunicationMgr.sendMessageToHost({
            type: "SET_QUERY_PARAM",
            queryParams: tA ? `?${tA}` : ""
          });
        }
      } else if (cA)
        BA = cA;
      else {
        let lA;
        StreamlitConfig.MAIN_PAGE_BASE_URL ? lA = parseUriIntoBaseParts(StreamlitConfig.MAIN_PAGE_BASE_URL).pathname : lA = oA.pathname, eA = extractPageNameFromPathName(document.location.pathname, lA), BA = "";
      }
      const GA = this.connectionManager?.getCachedMessageHashes() ?? [];
      this.sendBackMsg(new BackMsg({
        rerunScript: {
          queryString: tA,
          widgetStates: AA,
          pageScriptHash: BA,
          pageName: eA,
          fragmentId: IA,
          isAutoRerun: QA,
          cachedMessageHashes: GA,
          contextInfo: aA
        }
      })), this.hasReceivedNewSession = !1;
    }, this.stopScript = () => {
      if (!this.isServerConnected()) {
        LOG.error("Cannot stop app when disconnected from server.");
        return;
      }
      if (this.state.scriptRunState === ScriptRunState.NOT_RUNNING || this.state.scriptRunState === ScriptRunState.STOP_REQUESTED)
        return;
      const AA = new BackMsg({
        stopScript: !0
      });
      AA.type = "stopScript", this.sendBackMsg(AA), this.setState({
        scriptRunState: ScriptRunState.STOP_REQUESTED
      });
    }, this.openClearCacheDialog = () => {
      if (this.isServerConnected()) {
        const AA = {
          type: DialogType.CLEAR_CACHE,
          confirmCallback: this.clearCache,
          onClose: () => {
          }
        };
        this.openDialog(AA);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.openDeployDialog = () => {
      const AA = {
        type: DialogType.DEPLOY_DIALOG,
        onClose: this.closeDialog,
        showDeployError: this.showDeployError,
        isDeployErrorModalOpen: this.state.dialog?.type === DialogType.DEPLOY_ERROR,
        metricsMgr: this.metricsMgr,
        gitInfo: this.state.gitInfo
      };
      this.openDialog(AA);
    }, this.clearCache = () => {
      if (this.closeDialog(), this.isServerConnected()) {
        const AA = new BackMsg({
          clearCache: !0
        });
        AA.type = "clearCache", this.sendBackMsg(AA);
      } else
        LOG.error("Cannot clear cache: disconnected from server");
    }, this.sendAppHeartbeat = (AA) => {
      if (this.isServerConnected()) {
        const IA = new BackMsg({
          appHeartbeat: !0
        });
        IA.type = "appHeartbeat", this.sendBackMsg(IA), this.connectionManager?.onHeartbeatSent(AA);
      } else
        LOG.error("Cannot send app heartbeat: disconnected from server");
    }, this.handleHeartbeatAck = () => {
      this.connectionManager?.onHeartbeatAckReceived();
    }, this.sendBackMsg = (AA) => {
      this.connectionManager ? (LOG.info(AA), this.connectionManager.sendMessage(AA)) : LOG.error(`Not connected. Cannot send back message: ${AA}`);
    }, this.handleConnectionError = (AA) => {
      this.state.connectionErrorDismissed || this.showError("Connection error", AA, DialogType.CONNECTION_ERROR);
    }, this.isServerConnected = () => this.connectionManager ? this.connectionManager.isConnected() : !1, this.aboutCallback = () => {
      const {
        menuItems: AA
      } = this.state, IA = {
        type: DialogType.ABOUT,
        onClose: this.closeDialog,
        aboutSectionMd: AA?.aboutSectionMd
      };
      this.openDialog(IA);
    }, this.printCallback = () => {
      const {
        scriptRunState: AA
      } = this.state;
      if (AA !== ScriptRunState.NOT_RUNNING) {
        setTimeout(this.printCallback, 500);
        return;
      }
      let IA;
      try {
        const BA = getIFrameEnclosingApp(this.embeddingId);
        BA?.contentWindow ? IA = BA.contentWindow.window : IA = window;
      } catch {
        IA = window;
      } finally {
        IA || (IA = window), IA.print();
      }
    }, this.screencastCallback = () => {
      const {
        scriptName: AA
      } = this.state, {
        startRecording: IA
      } = this.props.screenCast, BA = getScreencastTimestamp();
      IA(`streamlit-${AA}-${BA}`);
    }, this.handleFullScreen = (AA) => {
      this.setState({
        isFullScreen: AA
      });
    }, this.setLibConfig = (AA) => {
      this.setState({
        libConfig: AA
      });
    }, this.setAppConfig = (AA) => {
      this.setState({
        appConfig: AA
      });
    }, this.addScriptFinishedHandler = (AA) => {
      this.setState((IA, BA) => ({
        scriptFinishedHandlers: IA.scriptFinishedHandlers.concat(AA)
      }));
    }, this.removeScriptFinishedHandler = (AA) => {
      this.setState((IA, BA) => ({
        scriptFinishedHandlers: IA.scriptFinishedHandlers.filter((QA) => QA !== AA)
      }));
    }, this.getBaseUriParts = () => this.connectionManager ? this.connectionManager.getBaseUriParts() : void 0, this.getQueryString = () => {
      const {
        queryParams: AA
      } = this.state, IA = AA && AA.length > 0 ? AA : document.location.search;
      return IA.startsWith("?") ? IA.substring(1) : IA;
    }, this.getThemeColorScheme = () => {
      const {
        activeTheme: AA
      } = this.props.theme;
      return hasLightBackgroundColor(AA.emotion) ? "light" : "dark";
    }, this.showDeployButton = () => isLocalhost() && showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && this.sessionInfo.isSet && !this.sessionInfo.isHello, this.deployButtonClicked = () => {
      this.metricsMgr.enqueue("menuClick", {
        label: "deployButtonInApp"
      }), this.sendLoadGitInfoBackMsg(), this.openDeployDialog();
    }, this.requestFileURLs = (AA, IA) => {
      const BA = this.isServerConnected(), QA = this.sessionInfo.isSet;
      if (BA && QA) {
        const EA = new BackMsg({
          fileUrlsRequest: {
            requestId: AA,
            fileNames: IA.map((iA) => iA.name),
            sessionId: this.sessionInfo.current.sessionId
          }
        });
        EA.type = "fileUrlsRequest", this.sendBackMsg(EA);
      } else
        LOG.warn(`Cannot request file URLs (isServerConnected: ${BA}, isSessionInfoSet: ${QA})`), this.uploadClient.onFileURLsResponse({
          responseId: AA,
          errorMsg: "Connection lost. Please wait for the app to reconnect, then try again."
        });
    }, this.requestDeferredFile = (AA) => {
      const IA = this.isServerConnected(), BA = this.sessionInfo.isSet;
      if (!IA || !BA)
        return Promise.reject(new Error("Not connected to server or session not initialized"));
      const QA = Promise.withResolvers(), EA = this.deferredFileListeners.get(AA) ?? /* @__PURE__ */ new Set(), iA = (cA) => {
        EA.delete(iA), QA.resolve(cA);
      };
      EA.add(iA), this.deferredFileListeners.set(AA, EA);
      const oA = new BackMsg({
        deferredFileRequest: {
          fileId: AA,
          sessionId: this.sessionInfo.current.sessionId
        }
      });
      return oA.type = "deferredFileRequest", this.sendBackMsg(oA), QA.promise;
    }, this.handleDeferredFileResponse = (AA) => {
      const IA = this.deferredFileListeners.get(AA.fileId);
      if (!(!IA || IA.size === 0)) {
        for (const BA of Array.from(IA))
          try {
            BA(AA);
          } catch {
          }
        this.deferredFileListeners.delete(AA.fileId);
      }
    }, this.handleKeyDown = (AA, IA) => {
      if (!((AA === "c" || AA === "r") && isKeyboardEventFromEditableTarget(IA)))
        switch (AA) {
          case "c":
            showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode) && this.openClearCacheDialog();
            break;
          case "r":
            this.rerunScript();
            break;
        }
    }, this.handleKeyUp = (AA) => {
      AA === "esc" && this.props.screenCast.stopRecording();
    }, this.hasAppDefinedMenuItems = () => {
      const {
        menuItems: AA
      } = this.state;
      return !!(AA?.aboutSectionMd || AA?.getHelpUrl && !AA?.hideGetHelp || AA?.reportABugUrl && !AA?.hideReportABug);
    }, this.shouldShowToolbar = (AA, IA) => {
      const BA = !isEmbed() || isToolbarDisplayed();
      let QA;
      return this.state.toolbarMode === Config.ToolbarMode.MINIMAL ? QA = AA.length > 0 || IA.length > 0 || this.hasAppDefinedMenuItems() : QA = !0, BA && QA;
    }, ensureHotkeysFilterConfigured(), enablePatches(), enableMapSet(), this.state = {
      connectionState: ConnectionState.INITIAL,
      elements: AppRoot.empty("", !0),
      // Blank Main Script Hash for initial render
      isFullScreen: !1,
      scriptName: "",
      scriptRunId: INITIAL_SCRIPT_RUN_ID,
      appHash: null,
      scriptRunState: ScriptRunState.NOT_RUNNING,
      userSettings: {
        wideMode: !1,
        runOnSave: !1
      },
      connectionErrorDismissed: !1,
      layout: PageConfig.Layout.CENTERED,
      initialSidebarState: PageConfig.SidebarState.AUTO,
      initialSidebarWidth: void 0,
      menuItems: void 0,
      allowRunOnSave: !0,
      scriptFinishedHandlers: [],
      showErrorLinks: Config.ShowErrorLinks.SHOW_ERROR_LINKS_AUTO,
      // Initialize themeHash to empty string to ensure the first processThemeInput
      // call always processes the theme (whether null or custom theme from server).
      // This prevents the bug where a cached custom theme isn't cleared when the
      // server sends null, because null and undefined both hash to the same value.
      themeHash: "",
      gitInfo: null,
      formsData: createFormsData(),
      appPages: [],
      navSections: [],
      currentPageScriptHash: "",
      mainScriptHash: "",
      // We set hideTopBar to true by default because this information isn't
      // available on page load (we get it when the script begins to run), so
      // the user would see top bar elements for a few ms if this defaulted to
      // false. hideSidebarNav doesn't have this issue (app pages and the value
      // of the config option are received simultaneously), but we set it to
      // true as well for consistency.
      hideTopBar: !0,
      hideSidebarNav: !0,
      expandSidebarNav: !1,
      toolbarMode: Config.ToolbarMode.MINIMAL,
      latestRunTime: performance.now(),
      fragmentIdsThisRun: [],
      // Information sent from the host
      isOwner: !1,
      hostMenuItems: [],
      hostToolbarItems: [],
      hostHideSidebarNav: !1,
      sidebarChevronDownshift: 0,
      pageLinkBaseUrl: "",
      // Initialize from URL so bound widget params from shared links are
      // preserved on first page navigation (before handlePageInfoChanged fires).
      queryParams: window.location?.search?.replace(/^\?/, "") ?? "",
      deployedAppMetadata: {},
      libConfig: {},
      appConfig: {},
      autoReruns: [],
      inputsDisabled: !1,
      navigationPosition: Navigation.Position.SIDEBAR,
      scriptChangedOnDisk: !1
    }, this.connectionManager = null, this.widgetMgr = new WidgetStateManager({
      sendRerunBackMsg: this.sendRerunBackMsg,
      formsDataChanged: (AA) => this.setState({
        formsData: AA
      })
    }), this.widgetMgr.setQueryParamsChangeHandler(this.handleQueryParamsFromWidget), this.hostCommunicationMgr = new HostCommunicationManager({
      streamlitExecutionStartedAt: gA.streamlitExecutionStartedAt,
      sendRerunBackMsg: this.sendRerunBackMsg,
      closeModal: this.closeDialog,
      stopScript: this.stopScript,
      rerunScript: this.rerunScript,
      clearCache: this.clearCache,
      sendAppHeartbeat: this.sendAppHeartbeat,
      setInputsDisabled: (AA) => {
        this.setState({
          inputsDisabled: AA
        });
      },
      themeChanged: this.handleThemeMessage,
      pageChanged: (AA) => this.onPageChange(AA),
      isOwnerChanged: (AA) => this.setState({
        isOwner: AA
      }),
      fileUploadClientConfigChanged: (AA) => {
        this.endpoints.setFileUploadClientConfig !== void 0 && this.endpoints.setFileUploadClientConfig(AA);
      },
      hostMenuItemsChanged: (AA) => {
        this.setState({
          hostMenuItems: AA
        });
      },
      hostToolbarItemsChanged: (AA) => {
        this.setState({
          hostToolbarItems: AA
        });
      },
      hostHideSidebarNavChanged: (AA) => {
        this.setState({
          hostHideSidebarNav: AA
        });
      },
      sidebarChevronDownshiftChanged: (AA) => {
        this.setState({
          sidebarChevronDownshift: AA
        });
      },
      pageLinkBaseUrlChanged: (AA) => {
        this.setState({
          pageLinkBaseUrl: AA
        });
      },
      queryParamsChanged: (AA) => {
        this.setState({
          queryParams: AA
        });
      },
      deployedAppMetadataChanged: (AA) => {
        this.setState({
          deployedAppMetadata: AA
        });
      },
      restartWebsocketConnection: () => {
        this.connectionManager || (this.setState({
          scriptRunState: ScriptRunState.RERUN_REQUESTED
        }), this.initializeConnectionManager());
      },
      terminateWebsocketConnection: () => {
        this.connectionManager?.disconnect(), this.connectionManager = null;
      }
    }), this.endpoints = new DefaultStreamlitEndpoints({
      getServerUri: this.getBaseUriParts,
      csrfEnabled: !0,
      sendClientError: (AA, IA, BA, QA, EA) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: AA,
          error: IA,
          message: BA,
          source: QA,
          customComponentName: EA
        });
      }
    }), this.uploadClient = new FileUploadClient({
      sessionInfo: this.sessionInfo,
      endpoints: this.endpoints,
      // A form cannot be submitted if it contains a FileUploader widget
      // that's currently uploading. We write that state here, in response
      // to a FileUploadClient callback. The FormSubmitButton element
      // reads the state.
      formsWithPendingRequestsChanged: (AA) => this.widgetMgr.setFormsWithUploadsInProgress(AA),
      requestFileURLs: this.requestFileURLs
    }), this.componentRegistry = new ComponentRegistry(this.endpoints), this.appNavigation = new AppNavigation(this.hostCommunicationMgr, this.maybeUpdatePageUrl, this.onPageNotFound, this.onPageIconChanged), window.streamlitDebug = {
      clearForwardMsgCache: this.debugClearForwardMsgCache,
      disconnectWebsocket: this.debugDisconnectWebsocket,
      shutdownRuntime: this.debugShutdownRuntime
    };
  }
  applyInitialHostConfig() {
    if (!isHostConfigBypassEnabled())
      return;
    const gA = StreamlitConfig.HOST_CONFIG, AA = includeIfDefined({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      allowedOrigins: gA.allowedOrigins,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      useExternalAuthToken: gA.useExternalAuthToken,
      enableCustomParentMessages: gA.enableCustomParentMessages,
      blockErrorDialogs: gA.blockErrorDialogs
    });
    this.hostCommunicationMgr.setAllowedOrigins(AA), this.setAppConfig(AA);
    const IA = includeIfDefined({
      mapboxToken: gA.mapboxToken,
      disableFullscreenMode: gA.disableFullscreenMode,
      enforceDownloadInNewTab: gA.enforceDownloadInNewTab,
      resourceCrossOriginMode: gA.resourceCrossOriginMode
    });
    Object.keys(IA).length > 0 && this.setLibConfig(IA), gA.metricsUrl !== void 0 && this.metricsMgr.setMetricsConfig(gA.metricsUrl);
  }
  initializeConnectionManager() {
    this.isInitializingConnectionManager = !0, this.applyInitialHostConfig();
    const gA = this.context?.kernel;
    if (gA == null)
      throw new Error("Kernel is not set in the context.");
    this.connectionManager = new ConnectionManager({
      kernel: gA,
      getLastSessionId: () => this.sessionInfo.last?.sessionId,
      endpoints: this.endpoints,
      onMessage: this.handleMessage,
      onConnectionError: this.handleConnectionError,
      connectionStateChanged: this.handleConnectionStateChanged,
      claimHostAuthToken: this.hostCommunicationMgr.claimAuthToken,
      resetHostAuthToken: this.hostCommunicationMgr.resetAuthToken,
      sendClientError: (AA, IA, BA) => {
        this.hostCommunicationMgr.sendMessageToHost({
          type: "CLIENT_ERROR",
          component: "Websocket Connection",
          error: AA,
          message: IA,
          source: BA
        });
      },
      onHostConfigResp: (AA) => {
        const IA = reconcileHostConfigValues(StreamlitConfig.HOST_CONFIG, AA), {
          allowedOrigins: BA,
          useExternalAuthToken: QA,
          disableFullscreenMode: EA,
          enableCustomParentMessages: iA,
          mapboxToken: oA,
          enforceDownloadInNewTab: cA,
          metricsUrl: tA,
          blockErrorDialogs: eA,
          setAnonymousCrossOriginPropertyOnMediaElements: aA,
          resourceCrossOriginMode: GA
        } = IA, lA = {
          allowedOrigins: BA,
          useExternalAuthToken: QA,
          enableCustomParentMessages: iA,
          blockErrorDialogs: eA
        }, nA = {
          mapboxToken: oA,
          disableFullscreenMode: EA,
          enforceDownloadInNewTab: cA,
          // Use resourceCrossOriginMode if provided, otherwise fall back to
          // deprecated setAnonymousCrossOriginPropertyOnMediaElements (if true, use "anonymous")
          resourceCrossOriginMode: GA ?? (aA ? "anonymous" : void 0)
        };
        this.metricsMgr.setMetricsConfig(tA), this.hostCommunicationMgr.setAllowedOrigins(lA), this.setAppConfig(lA), this.setLibConfig(nA);
      }
    }), this.isInitializingConnectionManager = !1;
  }
  componentDidMount() {
    const gA = this.context?.kernel;
    if (gA == null)
      throw new Error("Kernel is not set in the context.");
    this.initializeConnectionManager(), mark(this.state.scriptRunState), this.hostCommunicationMgr.sendMessageToHost({
      type: "SCRIPT_RUN_STATE_CHANGED",
      scriptRunState: this.state.scriptRunState
    }), this.uploadClient.setKernel(gA), isScrollingHidden() && document.body.classList.add("embedded"), isInChildFrame() && (window.iFrameResizer = {
      heightCalculationMethod: () => {
        const AA = document.querySelectorAll("[data-iframe-height]"), IA = Array.from(AA).map((BA) => (
          // eslint-disable-next-line streamlit-custom/no-force-reflow-access -- Existing usage
          Math.ceil(BA.getBoundingClientRect().bottom)
        ));
        return Math.max(0, ...IA);
      }
    }, import("./iframeResizer.contentWindow-bVTYWYos.js").then((AA) => AA.i)), this.hostCommunicationMgr.sendMessageToHost({
      type: "SET_THEME_CONFIG",
      themeInfo: toExportedTheme(this.props.theme.activeTheme.emotion)
    }), this.metricsMgr.enqueue("viewReport"), window.addEventListener("popstate", this.onHistoryChange, !1);
  }
  componentDidUpdate(gA, AA) {
    if (window.prerenderReady === !1 && this.isAppInReadyState(AA) && (window.prerenderReady = !0), this.state.scriptRunState !== AA.scriptRunState) {
      if (mark(this.state.scriptRunState), this.state.scriptRunState === ScriptRunState.NOT_RUNNING)
        try {
          measure("script-run-cycle", ScriptRunState.RUNNING, ScriptRunState.NOT_RUNNING);
        } catch {
        }
      this.hostCommunicationMgr.sendMessageToHost({
        type: "SCRIPT_RUN_STATE_CHANGED",
        scriptRunState: this.state.scriptRunState
      });
    }
  }
  componentWillUnmount() {
    this.connectionManager?.disconnect(), this.hostCommunicationMgr.closeHostCommunication(), window.removeEventListener("popstate", this.onHistoryChange, !1);
  }
  /**
   * Checks whether to show error dialog or send error info
   * to be handled by the host.
   */
  maybeShowErrorDialog(gA, AA) {
    const {
      blockErrorDialogs: IA
    } = this.state.appConfig;
    IA || this.openDialog(gA);
    const QA = gA.type === DialogType.SCRIPT_COMPILE_ERROR ? gA.type : gA.title;
    this.hostCommunicationMgr.sendMessageToHost({
      type: "CLIENT_ERROR_DIALOG",
      error: QA,
      message: AA
    });
  }
  showError(gA, AA, IA = DialogType.WARNING) {
    LOG.error(AA.message);
    const BA = {
      type: IA,
      title: gA,
      msg: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogErrorMessage$1, { message: AA.message, codeBlock: AA.codeBlock }),
      onClose: () => {
      }
    };
    this.maybeShowErrorDialog(BA, AA.message);
  }
  /**
   * Checks if the code version from the backend is different than the frontend
   */
  hasStreamlitVersionChanged(gA) {
    let AA;
    if (StreamlitConfig.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION === !0 ? AA = PACKAGE_METADATA.version : this.sessionInfo.isSet && (AA = this.sessionInfo.current.streamlitVersion), AA) {
      const {
        environmentInfo: IA
      } = gA;
      if (notNullOrUndefined(IA) && notNullOrUndefined(IA.streamlitVersion))
        return AA != IA.streamlitVersion;
    }
    return !1;
  }
  maybeSetState(gA) {
    if (gA) {
      const [AA, IA] = gA;
      this.setState(AA, IA);
    }
  }
  processThemeInput(gA) {
    const AA = this.createThemeHash(gA);
    if (AA === this.state.themeHash)
      return;
    this.setState({
      themeHash: AA
    });
    const IA = !isPresetTheme(this.props.theme.activeTheme);
    if (gA) {
      const BA = createCustomThemes(gA);
      this.props.theme.addThemes(BA, {
        keepPresetThemes: !1
      });
      const QA = getPreferredTheme(BA);
      if (QA)
        this.setAndSendTheme(QA);
      else if (BA.length > 1) {
        const EA = BA.findIndex((iA) => iA.name === CUSTOM_THEME_AUTO_NAME);
        this.setAndSendTheme(BA[EA]);
      } else
        this.setAndSendTheme(BA[0]);
    } else if (this.props.theme.addThemes([]), IA) {
      const QA = getPreferredTheme([lightTheme, darkTheme]);
      QA ? this.setAndSendTheme(QA) : this.setAndSendTheme(createAutoTheme());
    }
    (gA?.fontFaces && gA.fontFaces.length > 0 || gA?.fontSources && gA.fontSources.length > 0) && this.props.theme.setFonts(gA);
  }
  /**
   * Handler for ForwardMsg.scriptFinished messages
   * @param status the ScriptFinishedStatus that the script finished with
   */
  handleScriptFinished(gA) {
    (gA === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || gA === ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN || gA === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && (Promise.resolve().then(() => {
      this.state.scriptFinishedHandlers.forEach((AA) => AA());
    }), (gA === ForwardMsg.ScriptFinishedStatus.FINISHED_SUCCESSFULLY || gA === ForwardMsg.ScriptFinishedStatus.FINISHED_FRAGMENT_RUN_SUCCESSFULLY) && this.setState(({
      scriptRunId: AA,
      fragmentIdsThisRun: IA,
      elements: BA
    }) => ({
      // Apply any pending elements that haven't been applied.
      elements: BA.clearStaleNodes(AA, IA)
    }), () => {
      this.removeInactiveWidgetState();
    }), this.connectionManager !== null && gA !== ForwardMsg.ScriptFinishedStatus.FINISHED_EARLY_FOR_RERUN && this.sessionInfo.isSet && // We only increment the message cache run count if we have received
    // a NewSession message after the latest rerun request. This is done
    // to ignore finished messages from previous script runs, which would
    // cause issues with deleting cached messages that are needed for the
    // current script run.
    this.hasReceivedNewSession && this.connectionManager.incrementMessageCacheRunCount(this.sessionInfo.current.maxCachedMessageAge, this.state.fragmentIdsThisRun));
  }
  /*
   * Clear all elements from the state.
   */
  clearAppState(gA, AA, IA, BA) {
    this.setState((QA) => {
      const EA = this.appNavigation.clearPageElements(QA.elements, BA);
      return {
        scriptRunId: AA,
        scriptName: IA,
        appHash: gA,
        elements: EA
      };
    }, () => {
      this.removeInactiveWidgetState();
    });
  }
  /**
   * Remove widget and element state for items no longer present in the
   * current render tree. Called from setState callbacks where this.state
   * access is a false positive (the callback runs after the update is
   * committed). Converting App to a functional component would let us
   * use useEffect and remove this suppress entirely.
   */
  removeInactiveWidgetState() {
    const {
      elements: gA,
      blockIds: AA
    } = this.state.elements.getActiveIds(), IA = /* @__PURE__ */ new Set([...Array.from(gA).map((BA) => getElementId(BA)).filter(notUndefined), ...AA]);
    this.widgetMgr.removeInactive(IA);
  }
  /**
   * Opens a dialog with the specified state.
   */
  openDialog(gA) {
    this.setState({
      dialog: gA
    });
  }
  render() {
    const {
      allowRunOnSave: gA,
      connectionState: AA,
      dialog: IA,
      elements: BA,
      initialSidebarState: QA,
      menuItems: EA,
      isFullScreen: iA,
      scriptRunId: oA,
      scriptRunState: cA,
      userSettings: tA,
      hideTopBar: eA,
      hideSidebarNav: aA,
      expandSidebarNav: GA,
      sidebarNavVisibleItems: lA,
      currentPageScriptHash: nA,
      hostHideSidebarNav: DA,
      pageLinkBaseUrl: hA,
      sidebarChevronDownshift: wA,
      hostMenuItems: sA,
      hostToolbarItems: NA,
      libConfig: rA,
      inputsDisabled: yA,
      appPages: bA,
      navSections: RA,
      navigationPosition: FA,
      scriptChangedOnDisk: dA
    } = this.state, kA = this.props.isMobileViewport ? Navigation.Position.SIDEBAR : FA, pA = showDevelopmentOptions(this.state.isOwner, this.state.toolbarMode), YA = classNames("stApp", getEmbeddingIdClassName(this.embeddingId), {
      "streamlit-embedded": isEmbed(),
      "streamlit-wide": tA.wideMode
    }), SA = IA ? StreamlitDialog({
      ...IA,
      onClose: this.closeDialog
    }) : null, JA = this.shouldShowToolbar(sA, NA), UA = !isEmbed() || isPaddingDisplayed(), fA = isScrollingHidden();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      StreamlitContextProvider$1,
      {
        initialSidebarState: QA,
        initialSidebarWidth: this.state.initialSidebarWidth,
        appRootRef: this.appRootRef,
        pageLinkBaseUrl: hA,
        currentPageScriptHash: nA,
        onPageChange: this.onPageChange,
        navSections: RA,
        appPages: bA,
        appLogo: BA.logo,
        sidebarChevronDownshift: wA,
        expandSidebarNav: GA,
        sidebarNavVisibleItems: lA,
        hideSidebarNav: aA || DA || kA === Navigation.Position.TOP,
        isFullScreen: iA,
        setFullScreen: this.handleFullScreen,
        activeTheme: this.props.theme.activeTheme,
        setTheme: this.setAndSendTheme,
        availableThemes: this.props.theme.availableThemes,
        fragmentIdsThisRun: this.state.fragmentIdsThisRun,
        locale: window.navigator.language,
        formsData: this.state.formsData,
        scriptRunState: cA,
        scriptRunId: oA,
        mapboxToken: rA.mapboxToken,
        enforceDownloadInNewTab: rA.enforceDownloadInNewTab,
        resourceCrossOriginMode: rA.resourceCrossOriginMode,
        showErrorLinks: this.state.showErrorLinks,
        requestDeferredFile: this.requestDeferredFile,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactHotkeys, { keyName: "r,c,esc", onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledApp, { ref: this.appRootRef, className: YA, "data-testid": "stApp", "data-test-script-state": oA == INITIAL_SCRIPT_RUN_ID ? "initial" : cA, "data-test-connection-state": AA, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AppView, { endpoints: this.endpoints, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, elements: BA, widgetMgr: this.widgetMgr, uploadClient: this.uploadClient, navigationPosition: kA, wideMode: tA.wideMode, embedded: isEmbed(), showPadding: UA, disableScrolling: fA, addScriptFinishedHandler: this.addScriptFinishedHandler, removeScriptFinishedHandler: this.removeScriptFinishedHandler, widgetsDisabled: yA || AA !== ConnectionState.CONNECTED, showToolbar: JA, disableFullscreenMode: rA.disableFullscreenMode, componentRegistry: this.componentRegistry, topRightContent: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(StatusWidget, { connectionState: AA, scriptRunState: cA, rerunScript: this.rerunScript, stopScript: this.stopScript, allowRunOnSave: gA, showScriptChangedActions: dA }),
            !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarActions, { hostToolbarItems: NA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, metricsMgr: this.metricsMgr }),
            this.showDeployButton() && !dA && /* @__PURE__ */ jsxRuntimeExports.jsx(DeployButton, { onClick: this.deployButtonClicked }),
            !eA && /* @__PURE__ */ jsxRuntimeExports.jsx(MainMenu$1, { isServerConnected: this.isServerConnected(), quickRerunCallback: this.rerunScript, clearCacheCallback: this.openClearCacheDialog, aboutCallback: this.aboutCallback, printCallback: this.printCallback, screencastCallback: this.screencastCallback, screenCastState: this.props.screenCast.currentState, hostMenuItems: sA, developmentMode: pA, sendMessageToHost: this.hostCommunicationMgr.sendMessageToHost, menuItems: EA, metricsMgr: this.metricsMgr, toolbarMode: this.state.toolbarMode, runOnSave: this.state.userSettings.runOnSave, onRunOnSaveChange: this.handleRunOnSaveChange, allowRunOnSave: gA && pA, streamlitVersion: this.sessionInfo.isSet ? this.sessionInfo.current.streamlitVersion : void 0 })
          ] }) }),
          SA
        ] }) })
      }
    );
  }
};
Rg.contextType = StliteKernelContext;
let App = Rg;
const AppWithScreenCast = withScreencast(App), AppWrapper = (CA) => {
  const {
    isMobile: gA
  } = useViewportSize();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppWithScreenCast, { ...CA, isMobileViewport: gA });
}, getSystemCustomTheme = (CA) => CA.find((gA) => gA.name === (getSystemThemePreference() === "dark" ? CUSTOM_THEME_DARK_NAME : CUSTOM_THEME_LIGHT_NAME)), createAutoCustomTheme = (CA) => ({
  ...CA,
  name: CUSTOM_THEME_AUTO_NAME,
  displayName: AUTO_THEME_NAME
});
function useThemeManager() {
  const CA = getDefaultTheme(), [gA, AA] = useState(CA), [IA, BA] = useState(CA.themeInput?.fontFaces ?? []), [QA, EA] = useState(null), [iA, oA] = useState(() => [...createPresetThemes(), ...isPresetTheme(CA) ? [] : [CA]]), cA = useRef(iA);
  useEffect(() => {
    cA.current = iA;
  }, [iA]);
  const tA = useCallback((DA, hA = {}) => {
    const {
      keepPresetThemes: wA = !0
    } = hA, sA = [...wA ? createPresetThemes() : [], ...DA];
    cA.current = sA, oA(sA);
  }, []), eA = useCallback((DA, hA = {}) => {
    const {
      persist: wA = !0
    } = hA;
    AA((sA) => DA !== sA ? (wA && setCachedThemeSelection(DA), DA) : sA);
  }, []), aA = useCallback((DA) => {
    if (DA.name === AUTO_THEME_NAME) {
      eA(getHostSpecifiedTheme());
      return;
    }
    if (DA.name === CUSTOM_THEME_AUTO_NAME) {
      const hA = getSystemCustomTheme(cA.current);
      if (hA) {
        eA(createAutoCustomTheme(hA));
        return;
      }
    }
    eA(DA);
  }, [eA]), GA = useCallback(() => {
    const DA = getHostSpecifiedTheme();
    gA.name === AUTO_THEME_NAME && eA(DA, {
      persist: !1
    });
    const hA = iA.filter((sA) => sA.name !== AUTO_THEME_NAME), wA = hA.some((sA) => sA.name === CUSTOM_THEME_AUTO_NAME);
    if (wA && gA.name === CUSTOM_THEME_AUTO_NAME) {
      const sA = getSystemCustomTheme(hA);
      sA && eA(createAutoCustomTheme(sA), {
        persist: !1
      });
    }
    oA(wA ? hA : [createAutoTheme(), ...hA]);
  }, [gA.name, iA, eA]), lA = useCallback((DA) => {
    DA.fontFaces && BA(DA.fontFaces);
    const hA = [...DA.fontSources || [], ...DA.sidebar?.fontSources || []], wA = {};
    hA.forEach((sA) => {
      sA.sourceUrl && sA.configName && (wA[sA.configName] = sA.sourceUrl);
    }), EA(Object.keys(wA).length > 0 ? wA : null);
  }, []), nA = useCallback((DA) => {
    lA(DA);
    const hA = new CustomThemeConfig(DA), wA = createTheme(CUSTOM_THEME_NAME, hA);
    aA(wA);
  }, [lA, aA]);
  return useEffect(() => {
    const DA = window.matchMedia("(prefers-color-scheme: dark)");
    return DA.addEventListener("change", GA), window.addEventListener("afterprint", GA), () => {
      window.removeEventListener("afterprint", GA), DA.removeEventListener("change", GA);
    };
  }, [GA]), [{
    setTheme: aA,
    activeTheme: gA,
    addThemes: tA,
    availableThemes: iA,
    setFonts: lA,
    setImportedTheme: nA
  }, IA, QA];
}
const appStyles = (CA) => /* @__PURE__ */ css("font-size:", CA.fontSizes.baseFontSize, "px;*,*::before,*::after{box-sizing:border-box;}margin:0;font-family:", CA.genericFonts.bodyFont, ";font-weight:", CA.fontWeights.normal, ";line-height:", CA.lineHeights.base, ";color:", CA.colors.bodyText, ";background-color:", CA.colors.bgColor, ";-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:", transparentize(CA.colors.black, 1), ';-webkit-font-smoothing:auto;[tabindex="-1"]:focus:not(:focus-visible){outline:0!important;}p,ol,ul,dl{margin:0 0 1rem 0;padding:0;font-size:1rem;font-weight:', CA.fontWeights.normal, ';}ol ol,ul ul,ol ul,ul ol{margin-bottom:0;}a:not([href]):not([class]){&,&:hover{color:inherit;text-decoration:none;}}img,svg{vertical-align:middle;}input,button,select,optgroup,textarea{margin:0;font-family:inherit;line-height:inherit;font-size:inherit;}button,input{overflow:visible;}button,[role="button"]{&:not(:disabled){cursor:pointer;}}button,[type="button"],[type="reset"],[type="submit"]{-webkit-appearance:button;}[hidden]{display:none!important;}@supports (scrollbar-color: transparent transparent){*{scrollbar-width:thin;scrollbar-color:transparent transparent;}*:hover{scrollbar-color:', CA.colors.fadedText40, " transparent;}}@supports not (scrollbar-color: transparent transparent){::-webkit-scrollbar{background:transparent;border-radius:", CA.radii.full, ";height:6px;width:6px;}::-webkit-scrollbar:active{background:", CA.colors.fadedText10, ";}:hover::-webkit-scrollbar-thumb:vertical,:hover::-webkit-scrollbar-thumb:horizontal{background:", CA.colors.fadedText40, ";border-radius:", CA.radii.full, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:appStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvcGFja2FnZXMvcmVhY3Qvc3JjL2FwcFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZdUUiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc3RsaXRlL3N0bGl0ZS9wYWNrYWdlcy9yZWFjdC9zcmMvYXBwU3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQmFzZWQgb24gc3RyZWFtbGl0L2Zyb250ZW5kL2xpYi9zcmMvdGhlbWUvZ2xvYmFsU3R5bGVzLnRzXG5cbmltcG9ydCB7IGNzcywgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tIFwiY29sb3Iya1wiO1xuaW1wb3J0IHR5cGUgeyBFbW90aW9uVGhlbWUgfSBmcm9tIFwiQHN0cmVhbWxpdC9saWJcIjtcblxuLyoqXG4gKiBDb250YWlucyB2YXJpb3VzIHN0eWxlcyB0aGF0IGFyZSBhcHBsaWVkIHRvIHRoZSBhcHAuXG4gKlxuICogUGxlYXNlIG9ubHkgYWRkIHN0eWxlcyBoZXJlIGlmIHRoZXkgYXJlIHRydWx5IGFwcC13aWRlLiBQdXR0aW5nIHN0eWxlcyB0byB0aGVcbiAqIGluZGl2aWR1YWwgY29tcG9uZW50cyBzaG91bGQgYmUgc3Ryb25nbHkgcHJlZmVycmVkLlxuICovXG5leHBvcnQgY29uc3QgYXBwU3R5bGVzID0gKHRoZW1lOiBFbW90aW9uVGhlbWUpOiBTZXJpYWxpemVkU3R5bGVzID0+IGNzc2BcbiAgLy8gT3ZlcnJpZGUgdGhlIGJhc2UgZm9udC1zaXplIHZhbHVlIGhlcmUuXG4gIGZvbnQtc2l6ZTogJHt0aGVtZS5mb250U2l6ZXMuYmFzZUZvbnRTaXplfXB4O1xuXG4gICosXG4gICo6OmJlZm9yZSxcbiAgKjo6YWZ0ZXIge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIH1cblxuICAvLyBCb2R5XG4gIC8vXG4gIC8vIDEuIFJlbW92ZSB0aGUgbWFyZ2luIGluIGFsbCBicm93c2Vycy5cbiAgLy8gMi4gQXMgYSBiZXN0IHByYWN0aWNlLCBhcHBseSBhIGRlZmF1bHQgYmFja2dyb3VuZC1jb2xvci5cbiAgLy8gMy4gUHJldmVudCBhZGp1c3RtZW50cyBvZiBmb250IHNpemUgYWZ0ZXIgb3JpZW50YXRpb24gY2hhbmdlcyBpbiBpT1MuXG4gIC8vIDQuIENoYW5nZSB0aGUgZGVmYXVsdCB0YXAgaGlnaGxpZ2h0IHRvIGJlIGNvbXBsZXRlbHkgdHJhbnNwYXJlbnQgaW4gaU9TLlxuXG4gIG1hcmdpbjogMDsgLy8gMVxuICBmb250LWZhbWlseTogJHt0aGVtZS5nZW5lcmljRm9udHMuYm9keUZvbnR9O1xuICBmb250LXdlaWdodDogJHt0aGVtZS5mb250V2VpZ2h0cy5ub3JtYWx9O1xuICBsaW5lLWhlaWdodDogJHt0aGVtZS5saW5lSGVpZ2h0cy5iYXNlfTtcbiAgY29sb3I6ICR7dGhlbWUuY29sb3JzLmJvZHlUZXh0fTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHt0aGVtZS5jb2xvcnMuYmdDb2xvcn07IC8vIDJcbiAgLXdlYmtpdC10ZXh0LXNpemUtYWRqdXN0OiAxMDAlOyAvLyAzXG4gIC13ZWJraXQtdGFwLWhpZ2hsaWdodC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSh0aGVtZS5jb2xvcnMuYmxhY2ssIDEpfTsgLy8gNFxuICAtd2Via2l0LWZvbnQtc21vb3RoaW5nOiBhdXRvO1xuXG4gIC8vIEZ1dHVyZS1wcm9vZiBydWxlOiBpbiBicm93c2VycyB0aGF0IHN1cHBvcnQgOmZvY3VzLXZpc2libGUsIHN1cHByZXNzIHRoZSBmb2N1cyBvdXRsaW5lXG4gIC8vIG9uIGVsZW1lbnRzIHRoYXQgcHJvZ3JhbW1hdGljYWxseSByZWNlaXZlIGZvY3VzIGJ1dCB3b3VsZG4ndCBub3JtYWxseSBzaG93IGEgdmlzaWJsZVxuICAvLyBmb2N1cyBvdXRsaW5lLiBJbiBnZW5lcmFsLCB0aGlzIHdvdWxkIG1lYW4gdGhhdCB0aGUgb3V0bGluZSBpcyBvbmx5IGFwcGxpZWQgaWYgdGhlXG4gIC8vIGludGVyYWN0aW9uIHRoYXQgbGVkIHRvIHRoZSBlbGVtZW50IHJlY2VpdmluZyBwcm9ncmFtbWF0aWMgZm9jdXMgd2FzIGEga2V5Ym9hcmQgaW50ZXJhY3Rpb24sXG4gIC8vIG9yIHRoZSBicm93c2VyIGhhcyBzb21laG93IGRldGVybWluZWQgdGhhdCB0aGUgdXNlciBpcyBwcmltYXJpbHkgYSBrZXlib2FyZCB1c2VyIGFuZC9vclxuICAvLyB3YW50cyBmb2N1cyBvdXRsaW5lcyB0byBhbHdheXMgYmUgcHJlc2VudGVkLlxuICAvLyBTZWUgaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvQ1NTLzpmb2N1cy12aXNpYmxlXG4gIC8vIGFuZCBodHRwczovL2RldmVsb3Blci5wYWNpZWxsb2dyb3VwLmNvbS9ibG9nLzIwMTgvMDMvZm9jdXMtdmlzaWJsZS1hbmQtYmFja3dhcmRzLWNvbXBhdGliaWxpdHkvXG5cbiAgW3RhYmluZGV4PVwiLTFcIl06Zm9jdXM6bm90KDpmb2N1cy12aXNpYmxlKSB7XG4gICAgb3V0bGluZTogMCAhaW1wb3J0YW50O1xuICB9XG5cbiAgLy8gTGlzdHNcbiAgLy8gUmVzZXQgbWFyZ2lucyBvbiBwYXJhZ3JhcGhzXG4gIC8vXG4gIC8vIFNpbWlsYXJseSwgdGhlIHRvcCBtYXJnaW4gb24gPHA+cyBnZXQgcmVzZXQuIEhvd2V2ZXIsIHdlIGFsc28gcmVzZXQgdGhlXG4gIC8vIGJvdHRvbSBtYXJnaW4gdG8gdXNlIHJlbSB1bml0cyBpbnN0ZWFkIG9mIGVtLlxuICBwLFxuICBvbCxcbiAgdWwsXG4gIGRsIHtcbiAgICBtYXJnaW46IDAgMCAxcmVtIDA7XG4gICAgcGFkZGluZzogMDtcbiAgICBmb250LXNpemU6IDFyZW07XG4gICAgZm9udC13ZWlnaHQ6ICR7dGhlbWUuZm9udFdlaWdodHMubm9ybWFsfTtcbiAgfVxuXG4gIG9sIG9sLFxuICB1bCB1bCxcbiAgb2wgdWwsXG4gIHVsIG9sIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5cbiAgLy8gQW5kIHVuZG8gdGhlc2Ugc3R5bGVzIGZvciBwbGFjZWhvbGRlciBsaW5rcy9uYW1lZCBhbmNob3JzICh3aXRob3V0IGhyZWYpLlxuICAvLyBJdCB3b3VsZCBiZSBtb3JlIHN0cmFpZ2h0Zm9yd2FyZCB0byBqdXN0IHVzZSBhW2hyZWZdIGluIHByZXZpb3VzIGJsb2NrLCBidXQgdGhhdFxuICAvLyBjYXVzZXMgc3BlY2lmaWNpdHkgaXNzdWVzIGluIG1hbnkgb3RoZXIgc3R5bGVzIHRoYXQgYXJlIHRvbyBjb21wbGV4IHRvIGZpeC5cbiAgLy8gU2VlIGh0dHBzOi8vZ2l0aHViLmNvbS90d2JzL2Jvb3RzdHJhcC9pc3N1ZXMvMTk0MDJcblxuICBhOm5vdChbaHJlZl0pOm5vdChbY2xhc3NdKSB7XG4gICAgJixcbiAgICAmOmhvdmVyIHtcbiAgICAgIGNvbG9yOiBpbmhlcml0O1xuICAgICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgIH1cbiAgfVxuXG4gIC8vIEltYWdlcyBhbmQgY29udGVudFxuXG4gIGltZyxcbiAgc3ZnIHtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB9XG5cbiAgLy8gMS4gUmVtb3ZlIHRoZSBtYXJnaW4gaW4gRmlyZWZveCBhbmQgU2FmYXJpXG5cbiAgaW5wdXQsXG4gIGJ1dHRvbixcbiAgc2VsZWN0LFxuICBvcHRncm91cCxcbiAgdGV4dGFyZWEge1xuICAgIG1hcmdpbjogMDsgLy8gMVxuICAgIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICAgIGxpbmUtaGVpZ2h0OiBpbmhlcml0O1xuICAgIGZvbnQtc2l6ZTogaW5oZXJpdDtcbiAgfVxuXG4gIC8vIFNob3cgdGhlIG92ZXJmbG93IGluIEVkZ2VcblxuICBidXR0b24sXG4gIGlucHV0IHtcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbiAgfVxuXG4gIC8vIFNldCB0aGUgY3Vyc29yIGZvciBhbGwgYnV0dG9ucyBvciBidXR0b24tbGlrZSBlbGVtZW50c1xuICBidXR0b24sXG4gIFtyb2xlPVwiYnV0dG9uXCJdIHtcbiAgICAmOm5vdCg6ZGlzYWJsZWQpIHtcbiAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICB9XG4gIH1cblxuICAvLyAxLiBQcmV2ZW50IGEgV2ViS2l0IGJ1ZyB3aGVyZSAoMikgZGVzdHJveXMgbmF0aXZlIGF1ZGlvIGFuZCB2aWRlb1xuICAvLyAgICBjb250cm9scyBpbiBBbmRyb2lkIDQuXG4gIC8vIDIuIENvcnJlY3QgdGhlIGluYWJpbGl0eSB0byBzdHlsZSBjbGlja2FibGUgdHlwZXMgaW4gaU9TIGFuZCBTYWZhcmkuXG4gIC8vIDMuIE9waW5pb25hdGVkOiBhZGQgXCJoYW5kXCIgY3Vyc29yIHRvIG5vbi1kaXNhYmxlZCBidXR0b24gZWxlbWVudHMuXG5cbiAgYnV0dG9uLFxuICBbdHlwZT1cImJ1dHRvblwiXSwgLy8gMVxuICBbdHlwZT1cInJlc2V0XCJdLFxuICBbdHlwZT1cInN1Ym1pdFwiXSB7XG4gICAgLXdlYmtpdC1hcHBlYXJhbmNlOiBidXR0b247IC8vIDJcbiAgfVxuXG4gIC8vIEhpZGRlbiBhdHRyaWJ1dGVcbiAgLy9cbiAgLy8gQWx3YXlzIGhpZGUgYW4gZWxlbWVudCB3aXRoIHRoZSBoaWRkZW4gSFRNTCBhdHRyaWJ1dGUuXG5cbiAgW2hpZGRlbl0ge1xuICAgIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbiAgfVxuXG4gIC8vIFRlbGwgYnJvd3NlciB0byByZW5kZXIgYSB0aGluIHNjcm9sbGJhciB0aGF0IG9ubHkgYXBwZWFycyB3aGVuIHRoZVxuICAvLyBjb250YWluZXIgaXMgaG92ZXJlZC4gKFRoaXMgaXMgaWdub3JlZCBpbiBPU2VzIHRoYXQgcmVuZGVyIG92ZXJsYXlcbiAgLy8gc2Nyb2xsYmFycywgd2hpY2ggaXMgZXhhY3RseSB3aGF0IHdlIHdhbnQuKVxuICBAc3VwcG9ydHMgKHNjcm9sbGJhci1jb2xvcjogdHJhbnNwYXJlbnQgdHJhbnNwYXJlbnQpIHtcbiAgICAqIHtcbiAgICAgIHNjcm9sbGJhci13aWR0aDogdGhpbjtcbiAgICAgIHNjcm9sbGJhci1jb2xvcjogdHJhbnNwYXJlbnQgdHJhbnNwYXJlbnQ7XG4gICAgfVxuXG4gICAgKjpob3ZlciB7XG4gICAgICBzY3JvbGxiYXItY29sb3I6ICR7dGhlbWUuY29sb3JzLmZhZGVkVGV4dDQwfSB0cmFuc3BhcmVudDtcbiAgICB9XG4gIH1cblxuICAvLyBTYWZhcmkgZG9lc24ndCBzdXBwb3J0IHNjcm9sbGJhciBjb2xvcnMgc28gd2Ugc3R5bGUgdGhlIHNjcm9sbGJhclxuICAvLyB1c2luZyB0aGUgb2xkIHdlYmtpdC1vbmx5IHByb3BlcnRpZXMuXG4gIEBzdXBwb3J0cyBub3QgKHNjcm9sbGJhci1jb2xvcjogdHJhbnNwYXJlbnQgdHJhbnNwYXJlbnQpIHtcbiAgICA6Oi13ZWJraXQtc2Nyb2xsYmFyIHtcbiAgICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xuICAgICAgYm9yZGVyLXJhZGl1czogJHt0aGVtZS5yYWRpaS5mdWxsfTtcbiAgICAgIGhlaWdodDogNnB4O1xuICAgICAgd2lkdGg6IDZweDtcbiAgICB9XG5cbiAgICA6Oi13ZWJraXQtc2Nyb2xsYmFyOmFjdGl2ZSB7XG4gICAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmNvbG9ycy5mYWRlZFRleHQxMH07XG4gICAgfVxuXG4gICAgOmhvdmVyOjotd2Via2l0LXNjcm9sbGJhci10aHVtYjp2ZXJ0aWNhbCxcbiAgICA6aG92ZXI6Oi13ZWJraXQtc2Nyb2xsYmFyLXRodW1iOmhvcml6b250YWwge1xuICAgICAgYmFja2dyb3VuZDogJHt0aGVtZS5jb2xvcnMuZmFkZWRUZXh0NDB9O1xuICAgICAgYm9yZGVyLXJhZGl1czogJHt0aGVtZS5yYWRpaS5mdWxsfTtcbiAgICB9XG4gIH1cbmA7XG4iXX0= */");
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const documentStyles = process.env.NODE_ENV === "production" ? {
  name: "cqykvy",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}}"
} : {
  name: "vld0b3-documentStyles",
  styles: "html,body{height:100%;margin:0;}@media print{html{height:100%;print-color-adjust:exact;-webkit-print-color-adjust:exact;}};label:documentStyles;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3N0bGl0ZS9zdGxpdGUvcGFja2FnZXMvcmVhY3Qvc3JjL2RvY3VtZW50U3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9zdGxpdGUvc3RsaXRlL3BhY2thZ2VzL3JlYWN0L3NyYy9kb2N1bWVudFN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgZG9jdW1lbnRTdHlsZXMgPSBjc3NgXG4gIGh0bWwsXG4gIGJvZHkge1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBtYXJnaW46IDA7XG4gIH1cblxuICBAbWVkaWEgcHJpbnQge1xuICAgIGh0bWwge1xuICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgLyogbWFrZSBiYWNrZ3JvdW5kLWNvbG9ycyBhcHBlYXIgYnkgZGVmYXVsdCAoZS5nLiB0aGUgc2lkZWJhciBiYWNrZ3JvdW5kLFxuICAgICAgICogd2lkZ2V0IGJhY2tncm91bmQsIG11bHRpLXNlbGVjdCBlbGVtZW50IGJhY2tncm91bmQsIC4uLikgKi9cbiAgICAgIHByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgICAtd2Via2l0LXByaW50LWNvbG9yLWFkanVzdDogZXhhY3Q7XG4gICAgfVxuICB9XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}, ALPHABET = "abcdefghijklmnopqrstuvwxyz";
let idCounter = 0;
function randomChars(CA) {
  const {
    crypto: gA
  } = globalThis;
  if (gA?.getRandomValues) {
    const AA = new Uint32Array(CA);
    return gA.getRandomValues(AA), Array.from(AA, (IA) => ALPHABET[IA % ALPHABET.length]).join("");
  }
  return Array.from({
    length: CA
  }, () => ALPHABET[Math.floor(Math.random() * ALPHABET.length)]).join("");
}
function toAlphabeticString(CA) {
  if (CA === 0) return "a";
  const gA = [];
  let AA = CA;
  for (; AA > 0; )
    gA.unshift(ALPHABET[AA % ALPHABET.length]), AA = Math.floor(AA / ALPHABET.length);
  return gA.join("");
}
function generateUniqueId(CA = 8) {
  if (CA <= 0) return "";
  const gA = toAlphabeticString(idCounter++), AA = toAlphabeticString(Date.now()), IA = `${gA}${AA}${randomChars(CA)}`;
  return IA.length >= CA ? IA.slice(0, CA) : `${IA}${randomChars(CA - IA.length)}`;
}
function useUniqueId(CA = 8) {
  return useMemo$1(() => generateUniqueId(CA), [CA]);
}
function RootStyleProvider(CA) {
  const {
    children: gA,
    theme: AA,
    styleNonce: IA,
    disableDocumentStyles: BA
  } = CA, QA = useUniqueId(), EA = useMemo$1(() => createCache({
    key: `st-${QA}`,
    ...IA && {
      nonce: IA
    }
  }), [QA, IA]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseProvider,
    {
      theme: AA.basewebTheme,
      zIndex: AA.emotion.zIndices.popup,
      overrides: {
        // BaseUI's LayersManager renders portal content (popovers, modals,
        // tooltips) into a LayersContainer that is a sibling of the app
        // content, not a descendant. In standard Streamlit, text styles
        // (font-family, font-size, etc.) are set on `body` so portals
        // inherit them. In stlite, these styles are scoped to the
        // stlite-root div (via appStyles) to avoid polluting the host page,
        // so the LayersContainer needs them explicitly.
        // Keep these in sync with the inheritable text styles in appStyles.ts.
        LayersContainer: {
          style: {
            fontFamily: AA.emotion.genericFonts.bodyFont,
            fontSize: `${AA.emotion.fontSizes.baseFontSize}px`,
            fontWeight: AA.emotion.fontWeights.normal,
            lineHeight: AA.emotion.lineHeights.base,
            color: AA.emotion.colors.bodyText
          }
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, { value: EA, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$2, { theme: AA.emotion, children: [
        !BA && /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: documentStyles }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ClassNames, { children: ({
          css: iA,
          cx: oA
        }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: oA(iA(
          // "appStyles" contains the styles that are applied to the app root.
          // In the original Streamlit, these were "globalStyles" applied to the body,
          // but in Stlite they are scoped to this root element to allow embedding.
          appStyles(AA.emotion)
        ), "stlite-root"), children: gA }) })
      ] }) })
    }
  );
}
const ThemedApp = ({
  styleNonce: CA,
  streamlitExecutionStartedAt: gA,
  disableDocumentStyles: AA
}) => {
  const [IA, BA, QA] = useThemeManager(), {
    activeTheme: EA
  } = IA;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RootStyleProvider, { theme: EA, styleNonce: CA, disableDocumentStyles: AA, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WindowDimensionsProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PortalProvider, { children: [
    BA.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(FontFaceDeclaration, { fontFaces: BA }),
    QA && /* @__PURE__ */ jsxRuntimeExports.jsx(FontSources, { fontSources: QA }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppWrapper, { theme: IA, streamlitExecutionStartedAt: gA })
  ] }) }) });
};
class SequentialIDGenerator {
  constructor(gA = "") {
    this.prefix = gA, this.count = 0, this.offset = 374, this.msb = 1295, this.power = 2;
  }
  next() {
    const gA = this.increment().toString(36);
    return this.prefix ? `${this.prefix}${gA}` : gA;
  }
  increment() {
    const gA = this.count + this.offset;
    return gA === this.msb && (this.offset += (this.msb + 1) * 9, this.msb = Math.pow(36, ++this.power) - 1), this.count++, gA;
  }
}
const minMaxWidth = /(!?\(\s*min(-device-)?-width).+\(\s*max(-device)?-width/i, minWidth = /\(\s*min(-device)?-width/i, maxMinWidth = /(!?\(\s*max(-device)?-width).+\(\s*min(-device)?-width/i, maxWidth = /\(\s*max(-device)?-width/i, isMinWidth = _testQuery(minMaxWidth, maxMinWidth, minWidth), isMaxWidth = _testQuery(maxMinWidth, minMaxWidth, maxWidth), minMaxHeight = /(!?\(\s*min(-device)?-height).+\(\s*max(-device)?-height/i, minHeight = /\(\s*min(-device)?-height/i, maxMinHeight = /(!?\(\s*max(-device)?-height).+\(\s*min(-device)?-height/i, maxHeight = /\(\s*max(-device)?-height/i, isMinHeight = _testQuery(minMaxHeight, maxMinHeight, minHeight), isMaxHeight = _testQuery(maxMinHeight, minMaxHeight, maxHeight), isPrint = /print/i, isPrintOnly = /^print$/i, maxValue = Number.MAX_VALUE;
function _getQueryLength(CA) {
  const gA = /(-?\d*\.?\d+)(ch|em|ex|px|rem)/.exec(CA);
  if (gA === null)
    return maxValue;
  let AA = gA[1];
  switch (gA[2]) {
    case "ch":
      AA = parseFloat(AA) * 8.8984375;
      break;
    case "em":
    case "rem":
      AA = parseFloat(AA) * 16;
      break;
    case "ex":
      AA = parseFloat(AA) * 8.296875;
      break;
    case "px":
      AA = parseFloat(AA);
      break;
  }
  return +AA;
}
function _testQuery(CA, gA, AA) {
  return function(IA) {
    return CA.test(IA) ? !0 : gA.test(IA) ? !1 : AA.test(IA);
  };
}
function _testIsPrint(CA, gA) {
  const AA = isPrint.test(CA), IA = isPrintOnly.test(CA), BA = isPrint.test(gA), QA = isPrintOnly.test(gA);
  return AA && BA ? !IA && QA ? 1 : IA && !QA ? -1 : CA.localeCompare(gA) : AA ? 1 : BA ? -1 : null;
}
function sortCSSmq(CA, gA) {
  if (CA === "")
    return -1;
  if (gA === "")
    return 1;
  const AA = _testIsPrint(CA, gA);
  if (AA !== null)
    return AA;
  const IA = isMinWidth(CA) || isMinHeight(CA), BA = isMaxWidth(CA) || isMaxHeight(CA), QA = isMinWidth(gA) || isMinHeight(gA), EA = isMaxWidth(gA) || isMaxHeight(gA);
  if (IA && EA)
    return -1;
  if (BA && QA)
    return 1;
  const iA = _getQueryLength(CA), oA = _getQueryLength(gA);
  return iA === maxValue && oA === maxValue ? CA.localeCompare(gA) : iA === maxValue ? 1 : oA === maxValue ? -1 : iA > oA ? BA ? -1 : 1 : iA < oA ? BA ? 1 : -1 : CA.localeCompare(gA);
}
class MultiCache {
  constructor(gA, AA, IA) {
    this.idGenerator = gA, this.onNewCache = AA, this.onNewValue = IA, this.sortedCacheKeys = [], this.caches = {};
  }
  getCache(gA) {
    if (!this.caches[gA]) {
      const AA = new Cache(this.idGenerator, this.onNewValue);
      AA.key = gA, this.sortedCacheKeys.push(gA), this.sortedCacheKeys.sort(sortCSSmq);
      const IA = this.sortedCacheKeys.indexOf(gA), BA = IA < this.sortedCacheKeys.length - 1 ? this.sortedCacheKeys[IA + 1] : void 0;
      this.caches[gA] = AA, this.onNewCache(gA, AA, BA);
    }
    return this.caches[gA];
  }
  getSortedCacheKeys() {
    return this.sortedCacheKeys;
  }
}
class Cache {
  constructor(gA, AA) {
    this.cache = {}, this.idGenerator = gA, this.onNewValue = AA;
  }
  addValue(gA, AA) {
    const IA = this.cache[gA];
    if (IA)
      return IA;
    const BA = this.idGenerator.next();
    return this.cache[gA] = BA, this.onNewValue(this, BA, AA), BA;
  }
}
const uppercasePattern$1 = /[A-Z]/g, msPattern$1 = /^ms-/, cache$1 = {};
function hyphenateStyleName$2(CA) {
  return CA in cache$1 ? cache$1[CA] : cache$1[CA] = CA.replace(uppercasePattern$1, "-$&").toLowerCase().replace(msPattern$1, "-ms-");
}
const shorthandMap = {
  // CSS 2.1: https://www.w3.org/TR/CSS2/propidx.html
  "list-style": ["list-style-type", "list-style-position", "list-style-image"],
  margin: ["margin-top", "margin-right", "margin-bottom", "margin-left"],
  outline: ["outline-width", "outline-style", "outline-color"],
  padding: ["padding-top", "padding-right", "padding-bottom", "padding-left"],
  // CSS Backgrounds and Borders Module Level 3: https://www.w3.org/TR/css3-background/
  background: ["background-image", "background-position", "background-size", "background-repeat", "background-origin", "background-clip", "background-attachment", "background-color"],
  border: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width", "border-width", "border-top-style", "border-right-style", "border-bottom-style", "border-left-style", "border-style", "border-top-color", "border-right-color", "border-bottom-color", "border-left-color", "border-color"],
  "border-color": ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"],
  "border-style": ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"],
  "border-width": ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"],
  "border-top": ["border-top-width", "border-top-style", "border-top-color"],
  "border-right": ["border-right-width", "border-right-style", "border-right-color"],
  "border-bottom": ["border-bottom-width", "border-bottom-style", "border-bottom-color"],
  "border-left": ["border-left-width", "border-left-style", "border-left-color"],
  "border-radius": ["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"],
  "border-image": ["border-image-source", "border-image-slice", "border-image-width", "border-image-outset", "border-image-repeat"],
  // CSS Fonts Module Level 3: https://www.w3.org/TR/css3-fonts/
  font: ["font-style", "font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian", "font-variant", "font-weight", "font-stretch", "font-size", "line-height", "font-family"],
  "font-variant": ["font-variant-ligatures", "font-variant-alternates", "font-variant-caps", "font-variant-numeric", "font-variant-east-asian"],
  // CSS Flexible Box Layout Module Level 1: https://www.w3.org/TR/css3-flexbox-1/
  flex: ["flex-grow", "flex-shrink", "flex-basis"],
  "flex-flow": ["flex-direction", "flex-wrap"],
  // CSS Grid Layout Module Level 1: https://www.w3.org/TR/css-grid-1/
  grid: ["grid-template-rows", "grid-template-columns", "grid-template-areas", "grid-auto-rows", "grid-auto-columns", "grid-auto-flow"],
  "grid-template": ["grid-template-rows", "grid-template-columns", "grid-template-areas"],
  "grid-row": ["grid-row-start", "grid-row-end"],
  "grid-column": ["grid-column-start", "grid-column-end"],
  "grid-area": ["grid-row-start", "grid-column-start", "grid-row-end", "grid-column-end"],
  "grid-gap": ["grid-row-gap", "grid-column-gap"],
  // CSS Masking Module Level 1: https://www.w3.org/TR/css-masking/
  mask: ["mask-image", "mask-mode", "mask-position", "mask-size", "mask-repeat", "mask-origin", "mask-clip"],
  "mask-border": ["mask-border-source", "mask-border-slice", "mask-border-width", "mask-border-outset", "mask-border-repeat", "mask-border-mode"],
  // CSS Multi-column Layout Module: https://www.w3.org/TR/css3-multicol/
  columns: ["column-width", "column-count"],
  "column-rule": ["column-rule-width", "column-rule-style", "column-rule-color"],
  // CSS Scroll Snap Module Level 1: https://www.w3.org/TR/css-scroll-snap-1/
  "scroll-padding": ["scroll-padding-top", "scroll-padding-right", "scroll-padding-bottom", "scroll-padding-left"],
  "scroll-padding-block": ["scroll-padding-block-start", "scroll-padding-block-end"],
  "scroll-padding-inline": ["scroll-padding-inline-start", "scroll-padding-inline-end"],
  "scroll-snap-margin": ["scroll-snap-margin-top", "scroll-snap-margin-right", "scroll-snap-margin-bottom", "scroll-snap-margin-left"],
  "scroll-snap-margin-block": ["scroll-snap-margin-block-start", "scroll-snap-margin-block-end"],
  "scroll-snap-margin-inline": ["scroll-snap-margin-inline-start", "scroll-snap-margin-inline-end"],
  // CSS Speech Module: https://www.w3.org/TR/css3-speech/
  cue: ["cue-before", "cue-after"],
  pause: ["pause-before", "pause-after"],
  rest: ["rest-before", "rest-after"],
  // CSS Text Decoration Module Level 3: https://www.w3.org/TR/css-text-decor-3/
  "text-decoration": ["text-decoration-line", "text-decoration-style", "text-decoration-color"],
  "text-emphasis": ["text-emphasis-style", "text-emphasis-color"],
  // CSS Animations (WD): https://www.w3.org/TR/css3-animations
  animation: ["animation-name", "animation-duration", "animation-timing-function", "animation-delay", "animation-iteration-count", "animation-direction", "animation-fill-mode", "animation-play-state"],
  // CSS Transitions (WD): https://www.w3.org/TR/css3-transitions/
  transition: ["transition-property", "transition-duration", "transition-timing-function", "transition-delay"]
};
function validateNoMixedHand(CA) {
  const gA = Object.keys(CA).reduce((IA, BA) => (IA[hyphenateStyleName$2(BA)] = BA, IA), {}), AA = [];
  for (const IA in gA)
    if (IA in shorthandMap) {
      for (const BA of shorthandMap[IA])
        if (BA in gA) {
          const QA = gA[BA], EA = gA[IA];
          AA.push({
            shorthand: {
              property: EA,
              value: CA[EA]
            },
            longhand: {
              property: QA,
              value: CA[QA]
            }
          });
        }
    }
  return AA;
}
function capitalizeString(CA) {
  return CA.charAt(0).toUpperCase() + CA.slice(1);
}
function prefixProperty(CA, gA, AA) {
  if (CA.hasOwnProperty(gA)) {
    for (var IA = {}, BA = CA[gA], QA = capitalizeString(gA), EA = Object.keys(AA), iA = 0; iA < EA.length; iA++) {
      var oA = EA[iA];
      if (oA === gA)
        for (var cA = 0; cA < BA.length; cA++)
          IA[BA[cA] + QA] = AA[gA];
      IA[oA] = AA[oA];
    }
    return IA;
  }
  return AA;
}
function prefixValue$1(CA, gA, AA, IA, BA) {
  for (var QA = 0, EA = CA.length; QA < EA; ++QA) {
    var iA = CA[QA](gA, AA, IA, BA);
    if (iA)
      return iA;
  }
}
function addIfNew(CA, gA) {
  CA.indexOf(gA) === -1 && CA.push(gA);
}
function addNewValuesOnly(CA, gA) {
  if (Array.isArray(gA))
    for (var AA = 0, IA = gA.length; AA < IA; ++AA)
      addIfNew(CA, gA[AA]);
  else
    addIfNew(CA, gA);
}
function isObject(CA) {
  return CA instanceof Object && !Array.isArray(CA);
}
function createPrefixer(CA) {
  var gA = CA.prefixMap, AA = CA.plugins;
  return function IA(BA) {
    for (var QA in BA) {
      var EA = BA[QA];
      if (isObject(EA))
        BA[QA] = IA(EA);
      else if (Array.isArray(EA)) {
        for (var iA = [], oA = 0, cA = EA.length; oA < cA; ++oA) {
          var tA = prefixValue$1(AA, QA, EA[oA], BA, gA);
          addNewValuesOnly(iA, tA || EA[oA]);
        }
        iA.length > 0 && (BA[QA] = iA);
      } else {
        var eA = prefixValue$1(AA, QA, EA, BA, gA);
        eA && (BA[QA] = eA), BA = prefixProperty(gA, QA, BA);
      }
    }
    return BA;
  };
}
var w = ["Webkit"], m = ["Moz"], ms = ["ms"], wm = ["Webkit", "Moz"], wms = ["Webkit", "ms"], wmms = ["Webkit", "Moz", "ms"];
const data = {
  prefixMap: { appearance: wm, textEmphasisPosition: w, textEmphasis: w, textEmphasisStyle: w, textEmphasisColor: w, boxDecorationBreak: w, maskImage: w, maskMode: w, maskRepeat: w, maskPosition: w, maskClip: w, maskOrigin: w, maskSize: w, maskComposite: w, mask: w, maskBorderSource: w, maskBorderMode: w, maskBorderSlice: w, maskBorderWidth: w, maskBorderOutset: w, maskBorderRepeat: w, maskBorder: w, maskType: w, textDecorationStyle: w, textDecorationSkip: w, textDecorationLine: w, textDecorationColor: w, userSelect: wmms, backdropFilter: w, fontKerning: w, scrollSnapType: wms, scrollSnapPointsX: wms, scrollSnapPointsY: wms, scrollSnapDestination: wms, scrollSnapCoordinate: wms, clipPath: w, shapeImageThreshold: w, shapeImageMargin: w, shapeImageOutside: w, filter: w, hyphens: wms, flowInto: wms, flowFrom: wms, breakBefore: wms, breakAfter: wms, breakInside: wms, regionFragment: wms, writingMode: wms, textOrientation: w, tabSize: m, fontFeatureSettings: w, columnCount: w, columnFill: w, columnGap: w, columnRule: w, columnRuleColor: w, columnRuleStyle: w, columnRuleWidth: w, columns: w, columnSpan: w, columnWidth: w, wrapFlow: ms, wrapThrough: ms, wrapMargin: ms, textSizeAdjust: wms }
};
function backgroundClip(CA, gA) {
  if (typeof gA == "string" && gA === "text")
    return ["-webkit-text", "text"];
}
var prefixes$5 = ["-webkit-", "-moz-", ""], values$3 = {
  "zoom-in": !0,
  "zoom-out": !0,
  grab: !0,
  grabbing: !0
};
function cursor(CA, gA) {
  if (CA === "cursor" && values$3.hasOwnProperty(gA))
    return prefixes$5.map(function(AA) {
      return AA + gA;
    });
}
var isPrefixedValue$1 = { exports: {} }, hasRequiredIsPrefixedValue;
function requireIsPrefixedValue() {
  return hasRequiredIsPrefixedValue || (hasRequiredIsPrefixedValue = 1, (function(CA, gA) {
    Object.defineProperty(gA, "__esModule", {
      value: !0
    }), gA.default = IA;
    var AA = /-webkit-|-moz-|-ms-/;
    function IA(BA) {
      return typeof BA == "string" && AA.test(BA);
    }
    CA.exports = gA.default;
  })(isPrefixedValue$1, isPrefixedValue$1.exports)), isPrefixedValue$1.exports;
}
var isPrefixedValueExports = requireIsPrefixedValue();
const isPrefixedValue = /* @__PURE__ */ getDefaultExportFromCjs(isPrefixedValueExports);
var prefixes$4 = ["-webkit-", ""];
function crossFade(CA, gA) {
  if (typeof gA == "string" && !isPrefixedValue(gA) && gA.indexOf("cross-fade(") > -1)
    return prefixes$4.map(function(AA) {
      return gA.replace(/cross-fade\(/g, AA + "cross-fade(");
    });
}
var prefixes$3 = ["-webkit-", ""];
function filter(CA, gA) {
  if (typeof gA == "string" && !isPrefixedValue(gA) && gA.indexOf("filter(") > -1)
    return prefixes$3.map(function(AA) {
      return gA.replace(/filter\(/g, AA + "filter(");
    });
}
var values$2 = {
  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
};
function flex(CA, gA) {
  if (CA === "display" && values$2.hasOwnProperty(gA))
    return values$2[gA];
}
var alternativeValues = {
  "space-around": "justify",
  "space-between": "justify",
  "flex-start": "start",
  "flex-end": "end",
  "wrap-reverse": "multiple",
  wrap: "multiple"
}, alternativeProps$1 = {
  alignItems: "WebkitBoxAlign",
  justifyContent: "WebkitBoxPack",
  flexWrap: "WebkitBoxLines",
  flexGrow: "WebkitBoxFlex"
};
function flexboxOld(CA, gA, AA) {
  CA === "flexDirection" && typeof gA == "string" && (gA.indexOf("column") > -1 ? AA.WebkitBoxOrient = "vertical" : AA.WebkitBoxOrient = "horizontal", gA.indexOf("reverse") > -1 ? AA.WebkitBoxDirection = "reverse" : AA.WebkitBoxDirection = "normal"), alternativeProps$1.hasOwnProperty(CA) && (AA[alternativeProps$1[CA]] = alternativeValues[gA] || gA);
}
var prefixes$2 = ["-webkit-", "-moz-", ""], values$1 = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
function gradient(CA, gA) {
  if (typeof gA == "string" && !isPrefixedValue(gA) && values$1.test(gA))
    return prefixes$2.map(function(AA) {
      return gA.replace(values$1, function(IA) {
        return AA + IA;
      });
    });
}
var _slicedToArray = /* @__PURE__ */ (function() {
  function CA(gA, AA) {
    var IA = [], BA = !0, QA = !1, EA = void 0;
    try {
      for (var iA = gA[Symbol.iterator](), oA; !(BA = (oA = iA.next()).done) && (IA.push(oA.value), !(AA && IA.length === AA)); BA = !0)
        ;
    } catch (cA) {
      QA = !0, EA = cA;
    } finally {
      try {
        !BA && iA.return && iA.return();
      } finally {
        if (QA) throw EA;
      }
    }
    return IA;
  }
  return function(gA, AA) {
    if (Array.isArray(gA))
      return gA;
    if (Symbol.iterator in Object(gA))
      return CA(gA, AA);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();
function isSimplePositionValue(CA) {
  return typeof CA == "number" && !isNaN(CA);
}
function isComplexSpanValue(CA) {
  return typeof CA == "string" && CA.includes("/");
}
var alignmentValues = ["center", "end", "start", "stretch"], displayValues = {
  "inline-grid": ["-ms-inline-grid", "inline-grid"],
  grid: ["-ms-grid", "grid"]
}, propertyConverters = {
  alignSelf: function CA(gA, AA) {
    alignmentValues.indexOf(gA) > -1 && (AA.msGridRowAlign = gA);
  },
  gridColumn: function CA(gA, AA) {
    if (isSimplePositionValue(gA))
      AA.msGridColumn = gA;
    else if (isComplexSpanValue(gA)) {
      var IA = gA.split("/"), BA = _slicedToArray(IA, 2), QA = BA[0], EA = BA[1];
      propertyConverters.gridColumnStart(+QA, AA);
      var iA = EA.split(/ ?span /), oA = _slicedToArray(iA, 2), cA = oA[0], tA = oA[1];
      cA === "" ? propertyConverters.gridColumnEnd(+QA + +tA, AA) : propertyConverters.gridColumnEnd(+EA, AA);
    } else
      propertyConverters.gridColumnStart(gA, AA);
  },
  gridColumnEnd: function CA(gA, AA) {
    var IA = AA.msGridColumn;
    isSimplePositionValue(gA) && isSimplePositionValue(IA) && (AA.msGridColumnSpan = gA - IA);
  },
  gridColumnStart: function CA(gA, AA) {
    isSimplePositionValue(gA) && (AA.msGridColumn = gA);
  },
  gridRow: function CA(gA, AA) {
    if (isSimplePositionValue(gA))
      AA.msGridRow = gA;
    else if (isComplexSpanValue(gA)) {
      var IA = gA.split("/"), BA = _slicedToArray(IA, 2), QA = BA[0], EA = BA[1];
      propertyConverters.gridRowStart(+QA, AA);
      var iA = EA.split(/ ?span /), oA = _slicedToArray(iA, 2), cA = oA[0], tA = oA[1];
      cA === "" ? propertyConverters.gridRowEnd(+QA + +tA, AA) : propertyConverters.gridRowEnd(+EA, AA);
    } else
      propertyConverters.gridRowStart(gA, AA);
  },
  gridRowEnd: function CA(gA, AA) {
    var IA = AA.msGridRow;
    isSimplePositionValue(gA) && isSimplePositionValue(IA) && (AA.msGridRowSpan = gA - IA);
  },
  gridRowStart: function CA(gA, AA) {
    isSimplePositionValue(gA) && (AA.msGridRow = gA);
  },
  gridTemplateColumns: function CA(gA, AA) {
    AA.msGridColumns = gA;
  },
  gridTemplateRows: function CA(gA, AA) {
    AA.msGridRows = gA;
  },
  justifySelf: function CA(gA, AA) {
    alignmentValues.indexOf(gA) > -1 && (AA.msGridColumnAlign = gA);
  }
};
function grid(CA, gA, AA) {
  if (CA === "display" && gA in displayValues)
    return displayValues[gA];
  if (CA in propertyConverters) {
    var IA = propertyConverters[CA];
    IA(gA, AA);
  }
}
var prefixes$1 = ["-webkit-", ""];
function imageSet(CA, gA) {
  if (typeof gA == "string" && !isPrefixedValue(gA) && gA.indexOf("image-set(") > -1)
    return prefixes$1.map(function(AA) {
      return gA.replace(/image-set\(/g, AA + "image-set(");
    });
}
var alternativeProps = {
  marginBlockStart: ["WebkitMarginBefore"],
  marginBlockEnd: ["WebkitMarginAfter"],
  marginInlineStart: ["WebkitMarginStart", "MozMarginStart"],
  marginInlineEnd: ["WebkitMarginEnd", "MozMarginEnd"],
  paddingBlockStart: ["WebkitPaddingBefore"],
  paddingBlockEnd: ["WebkitPaddingAfter"],
  paddingInlineStart: ["WebkitPaddingStart", "MozPaddingStart"],
  paddingInlineEnd: ["WebkitPaddingEnd", "MozPaddingEnd"],
  borderBlockStart: ["WebkitBorderBefore"],
  borderBlockStartColor: ["WebkitBorderBeforeColor"],
  borderBlockStartStyle: ["WebkitBorderBeforeStyle"],
  borderBlockStartWidth: ["WebkitBorderBeforeWidth"],
  borderBlockEnd: ["WebkitBorderAfter"],
  borderBlockEndColor: ["WebkitBorderAfterColor"],
  borderBlockEndStyle: ["WebkitBorderAfterStyle"],
  borderBlockEndWidth: ["WebkitBorderAfterWidth"],
  borderInlineStart: ["WebkitBorderStart", "MozBorderStart"],
  borderInlineStartColor: ["WebkitBorderStartColor", "MozBorderStartColor"],
  borderInlineStartStyle: ["WebkitBorderStartStyle", "MozBorderStartStyle"],
  borderInlineStartWidth: ["WebkitBorderStartWidth", "MozBorderStartWidth"],
  borderInlineEnd: ["WebkitBorderEnd", "MozBorderEnd"],
  borderInlineEndColor: ["WebkitBorderEndColor", "MozBorderEndColor"],
  borderInlineEndStyle: ["WebkitBorderEndStyle", "MozBorderEndStyle"],
  borderInlineEndWidth: ["WebkitBorderEndWidth", "MozBorderEndWidth"]
};
function logical(CA, gA, AA) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, CA))
    for (var IA = alternativeProps[CA], BA = 0, QA = IA.length; BA < QA; ++BA)
      AA[IA[BA]] = gA;
}
function position(CA, gA) {
  if (CA === "position" && gA === "sticky")
    return ["-webkit-sticky", "sticky"];
}
var prefixes = ["-webkit-", "-moz-", ""], properties$1 = {
  maxHeight: !0,
  maxWidth: !0,
  width: !0,
  height: !0,
  columnWidth: !0,
  minWidth: !0,
  minHeight: !0
}, values = {
  "min-content": !0,
  "max-content": !0,
  "fill-available": !0,
  "fit-content": !0,
  "contain-floats": !0
};
function sizing(CA, gA) {
  if (properties$1.hasOwnProperty(CA) && values.hasOwnProperty(gA))
    return prefixes.map(function(AA) {
      return AA + gA;
    });
}
var hyphenateProperty$1 = { exports: {} }, uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
function toHyphenLower(CA) {
  return "-" + CA.toLowerCase();
}
function hyphenateStyleName(CA) {
  if (cache.hasOwnProperty(CA))
    return cache[CA];
  var gA = CA.replace(uppercasePattern, toHyphenLower);
  return cache[CA] = msPattern.test(gA) ? "-" + gA : gA;
}
const hyphenateStyleName$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hyphenateStyleName
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(hyphenateStyleName$1);
var hasRequiredHyphenateProperty;
function requireHyphenateProperty() {
  return hasRequiredHyphenateProperty || (hasRequiredHyphenateProperty = 1, (function(CA, gA) {
    Object.defineProperty(gA, "__esModule", {
      value: !0
    }), gA.default = QA;
    var AA = require$$0, IA = BA(AA);
    function BA(EA) {
      return EA && EA.__esModule ? EA : { default: EA };
    }
    function QA(EA) {
      return (0, IA.default)(EA);
    }
    CA.exports = gA.default;
  })(hyphenateProperty$1, hyphenateProperty$1.exports)), hyphenateProperty$1.exports;
}
var hyphenatePropertyExports = requireHyphenateProperty();
const hyphenateProperty = /* @__PURE__ */ getDefaultExportFromCjs(hyphenatePropertyExports);
var properties = {
  transition: !0,
  transitionProperty: !0,
  WebkitTransition: !0,
  WebkitTransitionProperty: !0,
  MozTransition: !0,
  MozTransitionProperty: !0
}, prefixMapping = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-"
};
function prefixValue(CA, gA) {
  if (isPrefixedValue(CA))
    return CA;
  for (var AA = CA.split(/,(?![^()]*(?:\([^()]*\))?\))/g), IA = 0, BA = AA.length; IA < BA; ++IA) {
    var QA = AA[IA], EA = [QA];
    for (var iA in gA) {
      var oA = hyphenateProperty(iA);
      if (QA.indexOf(oA) > -1 && oA !== "order")
        for (var cA = gA[iA], tA = 0, eA = cA.length; tA < eA; ++tA)
          EA.unshift(QA.replace(oA, prefixMapping[cA[tA]] + oA));
    }
    AA[IA] = EA.join(",");
  }
  return AA.join(",");
}
function transition(CA, gA, AA, IA) {
  if (typeof gA == "string" && properties.hasOwnProperty(CA)) {
    var BA = prefixValue(gA, IA), QA = BA.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(iA) {
      return !/-moz-|-ms-/.test(iA);
    }).join(",");
    if (CA.indexOf("Webkit") > -1)
      return QA;
    var EA = BA.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function(iA) {
      return !/-webkit-|-ms-/.test(iA);
    }).join(",");
    return CA.indexOf("Moz") > -1 ? EA : (AA["Webkit" + capitalizeString(CA)] = QA, AA["Moz" + capitalizeString(CA)] = EA, BA);
  }
}
var plugins = [backgroundClip, crossFade, cursor, filter, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition, flex], prefix = createPrefixer({
  prefixMap: data.prefixMap,
  plugins
});
function injectStylePrefixed(CA, gA, AA, IA) {
  const BA = CA.getCache(AA);
  let QA = "";
  for (const EA in gA) {
    const iA = gA[EA];
    if (iA != null)
      if (typeof iA != "object") {
        process.env.NODE_ENV !== "production" && validateValueType(iA, EA);
        const oA = `${hyphenateStyleName$2(EA)}:${iA}`, cA = `${IA}${oA}`, tA = BA.cache[cA];
        if (tA !== void 0) {
          QA += " " + tA;
          continue;
        } else {
          let eA = "";
          const aA = prefix({
            [EA]: iA
          });
          for (const lA in aA) {
            const nA = aA[lA], DA = typeof nA;
            if (DA === "string" || DA === "number") {
              const hA = `${hyphenateStyleName$2(lA)}:${nA}`;
              hA !== oA && (eA += `${hA};`);
            } else if (Array.isArray(nA)) {
              const hA = hyphenateStyleName$2(lA);
              for (let wA = 0; wA < nA.length; wA++) {
                const sA = `${hA}:${nA[wA]}`;
                sA !== oA && (eA += `${sA};`);
              }
            }
          }
          eA += oA;
          const GA = BA.addValue(cA, {
            pseudo: IA,
            block: eA
          });
          QA += " " + GA;
        }
      } else
        EA[0] === ":" ? QA += " " + injectStylePrefixed(CA, iA, AA, IA + EA) : EA.substring(0, 6) === "@media" && (QA += " " + injectStylePrefixed(CA, iA, EA.substr(7), IA));
  }
  if (process.env.NODE_ENV !== "production") {
    const EA = validateNoMixedHand(gA);
    EA.length && EA.forEach(({
      shorthand: iA,
      longhand: oA
    }) => {
      const cA = JSON.stringify({
        [iA.property]: iA.value
      }), tA = JSON.stringify({
        [oA.property]: oA.value
      });
      console.warn(`Styles \`${cA}\` and \`${tA}\` in object yielding class "${QA.slice(1)}" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering.`);
    });
  }
  return QA.slice(1);
}
function validateValueType(CA, gA) {
  if (CA === null || Array.isArray(CA) || typeof CA != "number" && typeof CA != "string")
    throw new Error(`Unsupported style value: ${JSON.stringify(CA)} used in property ${JSON.stringify(gA)}`);
}
const validAnimationState = /^(from|to|\+?(\d*\.)?\d+%)(\s*,\s*(from|to|\+?(\d*\.)?\d+%))*$/;
function validateKeyframesObject(CA) {
  let gA = !0;
  for (const AA in CA) {
    const IA = CA[AA];
    validAnimationState.test(AA) || (gA = !1, console.warn(`Warning: property "${AA}" in keyframes object ${JSON.stringify(CA)} is not a valid. Must be "from", "to", or a percentage.`)), typeof IA != "object" && (gA = !1, console.warn(`Warning: value for "${AA}" property in keyframes object ${JSON.stringify(CA)} must be an object. Instead it was a ${typeof IA}.`)), gA || console.warn('Warning: object used as value for "animationName" style is invalid:', CA);
  }
}
function atomicSelector(CA, gA) {
  let AA = `.${CA}`;
  return gA && (AA += gA), AA;
}
function keyframesToBlock(CA) {
  process.env.NODE_ENV !== "production" && validateKeyframesObject(CA), process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(CA) < "u" && Object.getPrototypeOf(CA) !== Object.getPrototypeOf({}) && console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", CA);
  let gA = "";
  for (const AA in CA)
    gA += `${AA}{${declarationsToBlock(CA[AA])}}`;
  return gA;
}
function declarationsToBlock(CA) {
  let gA = "";
  for (const AA in CA) {
    const IA = CA[AA];
    (typeof IA == "string" || typeof IA == "number") && (gA += `${hyphenateStyleName$2(AA)}:${IA};`);
  }
  return gA.slice(0, -1);
}
function keyframesBlockToRule(CA, gA) {
  return `@keyframes ${CA}{${gA}}`;
}
function fontFaceBlockToRule(CA, gA) {
  return `@font-face{font-family:${CA};${gA}}`;
}
function styleBlockToRule(CA, gA) {
  return `${CA}{${gA}}`;
}
const insertRuleIntoDevtools = (CA, gA) => {
  const AA = CA.substring(1, CA.indexOf(":") !== -1 ? CA.indexOf(":") : CA.length), IA = {};
  for (const BA of gA.split(";"))
    BA.trim() !== "" && !window.__STYLETRON_DEVTOOLS__.atomicMap[AA] && (IA[BA.substring(0, BA.indexOf(":"))] = BA.substring(BA.indexOf(":") + 1, BA.length));
  window.__STYLETRON_DEVTOOLS__.atomicMap[AA] = IA;
}, hydrateDevtoolsRule = (CA) => {
  const gA = CA.substring(0, 3), AA = CA.substring(4, CA.length - 1);
  insertRuleIntoDevtools(gA, AA);
}, STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g, KEYFRAMES_HYRDATOR = /@keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g, FONT_FACE_HYDRATOR = /@font-face\{font-family:([^;]+);([^}]*)\}/g;
function hydrateStyles(CA, gA, AA) {
  let IA;
  for (; IA = gA.exec(AA); ) {
    const [, BA, QA, EA] = IA;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(IA[0]);
    const iA = QA ? `${QA}${EA}` : EA;
    CA.cache[iA] = BA, CA.idGenerator.increment();
  }
}
function hydrate(CA, gA, AA) {
  let IA;
  for (; IA = gA.exec(AA); ) {
    const [, BA, QA] = IA;
    process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && hydrateDevtoolsRule(IA[0]), CA.cache[QA] = BA, CA.idGenerator.increment();
  }
}
class StyletronClient {
  constructor(gA = {}) {
    this.styleElements = {};
    const AA = new SequentialIDGenerator(gA.prefix), IA = (BA, QA, EA) => {
      const {
        pseudo: iA,
        block: oA
      } = EA, cA = this.styleElements[BA.key].sheet, tA = atomicSelector(QA, iA), eA = styleBlockToRule(tA, oA);
      try {
        cA.insertRule(eA, cA.cssRules.length), process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__ && insertRuleIntoDevtools(tA, oA);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${eA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    };
    if (this.styleCache = new MultiCache(AA, (BA, QA, EA) => {
      const iA = document.createElement("style");
      if (iA.media = BA, EA === void 0)
        this.container.appendChild(iA);
      else {
        const oA = findSheetIndexWithMedia(this.container.children, EA);
        this.container.insertBefore(iA, this.container.children[oA]);
      }
      this.styleElements[BA] = iA;
    }, IA), this.keyframesCache = new Cache(new SequentialIDGenerator(gA.prefix), (BA, QA, EA) => {
      this.styleCache.getCache("");
      const iA = this.styleElements[""].sheet, oA = keyframesBlockToRule(QA, keyframesToBlock(EA));
      try {
        iA.insertRule(oA, iA.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${oA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), this.fontFaceCache = new Cache(new SequentialIDGenerator(gA.prefix), (BA, QA, EA) => {
      this.styleCache.getCache("");
      const iA = this.styleElements[""].sheet, oA = fontFaceBlockToRule(QA, declarationsToBlock(EA));
      try {
        iA.insertRule(oA, iA.cssRules.length);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn(`Failed to inject CSS: "${oA}". Perhaps this has invalid or un-prefixed properties?`);
      }
    }), gA.container && (this.container = gA.container), gA.hydrate && gA.hydrate.length > 0) {
      if (!this.container) {
        const BA = gA.hydrate[0].parentElement;
        BA != null && (this.container = BA);
      }
      for (let BA = 0; BA < gA.hydrate.length; BA++) {
        const QA = gA.hydrate[BA], EA = QA.getAttribute("data-hydrate");
        if (EA === "font-face") {
          hydrate(this.fontFaceCache, FONT_FACE_HYDRATOR, QA.textContent);
          continue;
        }
        if (EA === "keyframes") {
          hydrate(this.keyframesCache, KEYFRAMES_HYRDATOR, QA.textContent);
          continue;
        }
        const iA = QA.media ? QA.media : "";
        this.styleElements[iA] = QA;
        const oA = new Cache(AA, IA);
        oA.key = iA, hydrateStyles(oA, STYLES_HYDRATOR, QA.textContent), this.styleCache.sortedCacheKeys.push(iA), this.styleCache.caches[iA] = oA;
      }
    }
    if (!this.container) {
      if (document.head === null)
        throw new Error("No container provided and `document.head` was null");
      this.container = document.head;
    }
  }
  renderStyle(gA) {
    return injectStylePrefixed(this.styleCache, gA, "", "");
  }
  renderFontFace(gA) {
    const AA = declarationsToBlock(gA);
    return this.fontFaceCache.addValue(AA, gA);
  }
  renderKeyframes(gA) {
    const AA = keyframesToBlock(gA);
    return this.keyframesCache.addValue(AA, gA);
  }
}
function findSheetIndexWithMedia(CA, gA) {
  let AA = 0;
  for (; AA < CA.length; AA++) {
    const IA = CA[AA];
    if (IA.tagName === "STYLE" && IA.media === gA)
      return AA;
  }
  return -1;
}
const engine = new StyletronClient({
  prefix: "st-"
});
process.env.NODE_ENV === "development" && log.setLevel(log.levels.DEBUG);
const streamlitExecutionStartedAt = Date.now();
function StliteApp(CA) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StliteKernelProvider, { kernel: CA.kernel, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { value: engine, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemedApp, { styleNonce: CA.styleNonce, streamlitExecutionStartedAt, disableDocumentStyles: CA.disableDocumentStyles }) }) });
}
function r(CA) {
  var gA, AA, IA = "";
  if (typeof CA == "string" || typeof CA == "number") IA += CA;
  else if (typeof CA == "object") if (Array.isArray(CA)) {
    var BA = CA.length;
    for (gA = 0; gA < BA; gA++) CA[gA] && (AA = r(CA[gA])) && (IA && (IA += " "), IA += AA);
  } else for (AA in CA) CA[AA] && (IA && (IA += " "), IA += AA);
  return IA;
}
function clsx() {
  for (var CA, gA, AA = 0, IA = "", BA = arguments.length; AA < BA; AA++) (CA = arguments[AA]) && (gA = r(CA)) && (IA && (IA += " "), IA += gA);
  return IA;
}
function Mt(CA) {
  if (typeof document > "u") return;
  let gA = document.head || document.getElementsByTagName("head")[0], AA = document.createElement("style");
  AA.type = "text/css", gA.firstChild ? gA.insertBefore(AA, gA.firstChild) : gA.appendChild(AA), AA.styleSheet ? AA.styleSheet.cssText = CA : AA.appendChild(document.createTextNode(CA));
}
Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var L = (CA) => typeof CA == "number" && !isNaN(CA), N = (CA) => typeof CA == "string", P = (CA) => typeof CA == "function", mt = (CA) => N(CA) || L(CA), B = (CA) => N(CA) || P(CA) ? CA : null, pt = (CA, gA) => CA === !1 || L(CA) && CA > 0 ? CA : gA, z = (CA) => isValidElement(CA) || N(CA) || P(CA) || L(CA);
function Z(CA, gA, AA = 300) {
  let { scrollHeight: IA, style: BA } = CA;
  requestAnimationFrame(() => {
    BA.minHeight = "initial", BA.height = IA + "px", BA.transition = `all ${AA}ms`, requestAnimationFrame(() => {
      BA.height = "0", BA.padding = "0", BA.margin = "0", setTimeout(gA, AA);
    });
  });
}
function $({ enter: CA, exit: gA, appendPosition: AA = !1, collapse: IA = !0, collapseDuration: BA = 300 }) {
  return function({ children: QA, position: EA, preventExitTransition: iA, done: oA, nodeRef: cA, isIn: tA, playToast: eA }) {
    let aA = AA ? `${CA}--${EA}` : CA, GA = AA ? `${gA}--${EA}` : gA, lA = useRef(0);
    return useLayoutEffect$1(() => {
      let nA = cA.current, DA = aA.split(" "), hA = (wA) => {
        wA.target === cA.current && (eA(), nA.removeEventListener("animationend", hA), nA.removeEventListener("animationcancel", hA), lA.current === 0 && wA.type !== "animationcancel" && nA.classList.remove(...DA));
      };
      nA.classList.add(...DA), nA.addEventListener("animationend", hA), nA.addEventListener("animationcancel", hA);
    }, []), useEffect(() => {
      let nA = cA.current, DA = () => {
        nA.removeEventListener("animationend", DA), IA ? Z(nA, oA, BA) : oA();
      };
      tA || (iA ? DA() : (lA.current = 1, nA.className += ` ${GA}`, nA.addEventListener("animationend", DA)));
    }, [tA]), React__default.createElement(React__default.Fragment, null, QA);
  };
}
function J(CA, gA) {
  return { content: tt(CA.content, CA.props), containerId: CA.props.containerId, id: CA.props.toastId, theme: CA.props.theme, type: CA.props.type, data: CA.props.data || {}, isLoading: CA.props.isLoading, icon: CA.props.icon, reason: CA.removalReason, status: gA };
}
function tt(CA, gA, AA = !1) {
  return isValidElement(CA) && !N(CA.type) ? cloneElement(CA, { closeToast: gA.closeToast, toastProps: gA, data: gA.data, isPaused: AA }) : P(CA) ? CA({ closeToast: gA.closeToast, toastProps: gA, data: gA.data, isPaused: AA }) : CA;
}
function yt({ closeToast: CA, theme: gA, ariaLabel: AA = "close" }) {
  return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${gA}`, type: "button", onClick: (IA) => {
    IA.stopPropagation(), CA(!0);
  }, "aria-label": AA }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function gt({ delay: CA, isRunning: gA, closeToast: AA, type: IA = "default", hide: BA, className: QA, controlledProgress: EA, progress: iA, rtl: oA, isIn: cA, theme: tA }) {
  let eA = BA || EA && iA === 0, aA = { animationDuration: `${CA}ms`, animationPlayState: gA ? "running" : "paused" };
  EA && (aA.transform = `scaleX(${iA})`);
  let GA = clsx("Toastify__progress-bar", EA ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${tA}`, `Toastify__progress-bar--${IA}`, { "Toastify__progress-bar--rtl": oA }), lA = P(QA) ? QA({ rtl: oA, type: IA, defaultClassName: GA }) : clsx(GA, QA), nA = { [EA && iA >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: EA && iA < 1 ? null : () => {
    cA && AA();
  } };
  return React__default.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": eA }, React__default.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${tA} Toastify__progress-bar--${IA}` }), React__default.createElement("div", { role: "progressbar", "aria-hidden": eA ? "true" : "false", "aria-label": "notification timer", className: lA, style: aA, ...nA }));
}
var Xt = 1, at = () => `${Xt++}`;
function _t(CA, gA, AA) {
  let IA = 1, BA = 0, QA = [], EA = [], iA = gA, oA = /* @__PURE__ */ new Map(), cA = /* @__PURE__ */ new Set(), tA = (wA) => (cA.add(wA), () => cA.delete(wA)), eA = () => {
    EA = Array.from(oA.values()), cA.forEach((wA) => wA());
  }, aA = ({ containerId: wA, toastId: sA, updateId: NA }) => {
    let rA = wA ? wA !== CA : CA !== 1, yA = oA.has(sA) && NA == null;
    return rA || yA;
  }, GA = (wA, sA) => {
    oA.forEach((NA) => {
      var rA;
      (sA == null || sA === NA.props.toastId) && ((rA = NA.toggle) == null || rA.call(NA, wA));
    });
  }, lA = (wA) => {
    var sA, NA;
    (NA = (sA = wA.props) == null ? void 0 : sA.onClose) == null || NA.call(sA, wA.removalReason), wA.isActive = !1;
  }, nA = (wA) => {
    if (wA == null) oA.forEach(lA);
    else {
      let sA = oA.get(wA);
      sA && lA(sA);
    }
    eA();
  }, DA = () => {
    BA -= QA.length, QA = [];
  }, hA = (wA) => {
    var sA, NA;
    let { toastId: rA, updateId: yA } = wA.props, bA = yA == null;
    wA.staleId && oA.delete(wA.staleId), wA.isActive = !0, oA.set(rA, wA), eA(), AA(J(wA, bA ? "added" : "updated")), bA && ((NA = (sA = wA.props).onOpen) == null || NA.call(sA));
  };
  return { id: CA, props: iA, observe: tA, toggle: GA, removeToast: nA, toasts: oA, clearQueue: DA, buildToast: (wA, sA) => {
    if (aA(sA)) return;
    let { toastId: NA, updateId: rA, data: yA, staleId: bA, delay: RA } = sA, FA = rA == null;
    FA && BA++;
    let dA = { ...iA, style: iA.toastStyle, key: IA++, ...Object.fromEntries(Object.entries(sA).filter(([pA, YA]) => YA != null)), toastId: NA, updateId: rA, data: yA, isIn: !1, className: B(sA.className || iA.toastClassName), progressClassName: B(sA.progressClassName || iA.progressClassName), autoClose: sA.isLoading ? !1 : pt(sA.autoClose, iA.autoClose), closeToast(pA) {
      oA.get(NA).removalReason = pA, nA(NA);
    }, deleteToast() {
      let pA = oA.get(NA);
      if (pA != null) {
        if (AA(J(pA, "removed")), oA.delete(NA), BA--, BA < 0 && (BA = 0), QA.length > 0) {
          hA(QA.shift());
          return;
        }
        eA();
      }
    } };
    dA.closeButton = iA.closeButton, sA.closeButton === !1 || z(sA.closeButton) ? dA.closeButton = sA.closeButton : sA.closeButton === !0 && (dA.closeButton = z(iA.closeButton) ? iA.closeButton : !0);
    let kA = { content: wA, props: dA, staleId: bA };
    iA.limit && iA.limit > 0 && BA > iA.limit && FA ? QA.push(kA) : L(RA) ? setTimeout(() => {
      hA(kA);
    }, RA) : hA(kA);
  }, setProps(wA) {
    iA = wA;
  }, setToggle: (wA, sA) => {
    let NA = oA.get(wA);
    NA && (NA.toggle = sA);
  }, isToastActive: (wA) => {
    var sA;
    return (sA = oA.get(wA)) == null ? void 0 : sA.isActive;
  }, getSnapshot: () => EA };
}
var I = /* @__PURE__ */ new Map(), F = [], st = /* @__PURE__ */ new Set(), Vt = (CA) => st.forEach((gA) => gA(CA)), bt = () => I.size > 0;
function Qt() {
  F.forEach((CA) => nt(CA.content, CA.options)), F = [];
}
var vt = (CA, { containerId: gA }) => {
  var AA;
  return (AA = I.get(gA || 1)) == null ? void 0 : AA.toasts.get(CA);
};
function X(CA, gA) {
  var AA;
  if (gA) return !!((AA = I.get(gA)) != null && AA.isToastActive(CA));
  let IA = !1;
  return I.forEach((BA) => {
    BA.isToastActive(CA) && (IA = !0);
  }), IA;
}
function ht(CA) {
  if (!bt()) {
    F = F.filter((gA) => CA != null && gA.options.toastId !== CA);
    return;
  }
  if (CA == null || mt(CA)) I.forEach((gA) => {
    gA.removeToast(CA);
  });
  else if (CA && ("containerId" in CA || "id" in CA)) {
    let gA = I.get(CA.containerId);
    gA ? gA.removeToast(CA.id) : I.forEach((AA) => {
      AA.removeToast(CA.id);
    });
  }
}
var Ct = (CA = {}) => {
  I.forEach((gA) => {
    gA.props.limit && (!CA.containerId || gA.id === CA.containerId) && gA.clearQueue();
  });
};
function nt(CA, gA) {
  z(CA) && (bt() || F.push({ content: CA, options: gA }), I.forEach((AA) => {
    AA.buildToast(CA, gA);
  }));
}
function xt(CA) {
  var gA;
  (gA = I.get(CA.containerId || 1)) == null || gA.setToggle(CA.id, CA.fn);
}
function rt(CA, gA) {
  I.forEach((AA) => {
    (gA == null || !(gA != null && gA.containerId) || gA?.containerId === AA.id) && AA.toggle(CA, gA?.id);
  });
}
function Et(CA) {
  let gA = CA.containerId || 1;
  return { subscribe(AA) {
    let IA = _t(gA, CA, Vt);
    I.set(gA, IA);
    let BA = IA.observe(AA);
    return Qt(), () => {
      BA(), I.delete(gA);
    };
  }, setProps(AA) {
    var IA;
    (IA = I.get(gA)) == null || IA.setProps(AA);
  }, getSnapshot() {
    var AA;
    return (AA = I.get(gA)) == null ? void 0 : AA.getSnapshot();
  } };
}
function Pt(CA) {
  return st.add(CA), () => {
    st.delete(CA);
  };
}
function Wt(CA) {
  return CA && (N(CA.toastId) || L(CA.toastId)) ? CA.toastId : at();
}
function U(CA, gA) {
  return nt(CA, gA), gA.toastId;
}
function V(CA, gA) {
  return { ...gA, type: gA && gA.type || CA, toastId: Wt(gA) };
}
function Q(CA) {
  return (gA, AA) => U(gA, V(CA, AA));
}
function y(CA, gA) {
  return U(CA, V("default", gA));
}
y.loading = (CA, gA) => U(CA, V("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...gA }));
function Gt(CA, { pending: gA, error: AA, success: IA }, BA) {
  let QA;
  gA && (QA = N(gA) ? y.loading(gA, BA) : y.loading(gA.render, { ...BA, ...gA }));
  let EA = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, iA = (cA, tA, eA) => {
    if (tA == null) {
      y.dismiss(QA);
      return;
    }
    let aA = { type: cA, ...EA, ...BA, data: eA }, GA = N(tA) ? { render: tA } : tA;
    return QA ? y.update(QA, { ...aA, ...GA }) : y(GA.render, { ...aA, ...GA }), eA;
  }, oA = P(CA) ? CA() : CA;
  return oA.then((cA) => iA("success", IA, cA)).catch((cA) => iA("error", AA, cA)), oA;
}
y.promise = Gt;
y.success = Q("success");
y.info = Q("info");
y.error = Q("error");
y.warning = Q("warning");
y.warn = y.warning;
y.dark = (CA, gA) => U(CA, V("default", { theme: "dark", ...gA }));
function qt(CA) {
  ht(CA);
}
y.dismiss = qt;
y.clearWaitingQueue = Ct;
y.isActive = X;
y.update = (CA, gA = {}) => {
  let AA = vt(CA, gA);
  if (AA) {
    let { props: IA, content: BA } = AA, QA = { delay: 100, ...IA, ...gA, toastId: gA.toastId || CA, updateId: at() };
    QA.toastId !== CA && (QA.staleId = CA);
    let EA = QA.render || BA;
    delete QA.render, U(EA, QA);
  }
};
y.done = (CA) => {
  y.update(CA, { progress: 1 });
};
y.onChange = Pt;
y.play = (CA) => rt(!0, CA);
y.pause = (CA) => rt(!1, CA);
function It(CA) {
  var gA;
  let { subscribe: AA, getSnapshot: IA, setProps: BA } = useRef(Et(CA)).current;
  BA(CA);
  let QA = (gA = useSyncExternalStore(AA, IA, IA)) == null ? void 0 : gA.slice();
  function EA(iA) {
    if (!QA) return [];
    let oA = /* @__PURE__ */ new Map();
    return CA.newestOnTop && QA.reverse(), QA.forEach((cA) => {
      let { position: tA } = cA.props;
      oA.has(tA) || oA.set(tA, []), oA.get(tA).push(cA);
    }), Array.from(oA, (cA) => iA(cA[0], cA[1]));
  }
  return { getToastToRender: EA, isToastActive: X, count: QA?.length };
}
function At(CA) {
  let [gA, AA] = useState(!1), [IA, BA] = useState(!1), QA = useRef(null), EA = useRef({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: iA, pauseOnHover: oA, closeToast: cA, onClick: tA, closeOnClick: eA } = CA;
  xt({ id: CA.toastId, containerId: CA.containerId, fn: AA }), useEffect(() => {
    if (CA.pauseOnFocusLoss) return aA(), () => {
      GA();
    };
  }, [CA.pauseOnFocusLoss]);
  function aA() {
    document.hasFocus() || hA(), window.addEventListener("focus", DA), window.addEventListener("blur", hA);
  }
  function GA() {
    window.removeEventListener("focus", DA), window.removeEventListener("blur", hA);
  }
  function lA(bA) {
    if (CA.draggable === !0 || CA.draggable === bA.pointerType) {
      wA();
      let RA = QA.current;
      EA.canCloseOnClick = !0, EA.canDrag = !0, RA.style.transition = "none", CA.draggableDirection === "x" ? (EA.start = bA.clientX, EA.removalDistance = RA.offsetWidth * (CA.draggablePercent / 100)) : (EA.start = bA.clientY, EA.removalDistance = RA.offsetHeight * (CA.draggablePercent === 80 ? CA.draggablePercent * 1.5 : CA.draggablePercent) / 100);
    }
  }
  function nA(bA) {
    let { top: RA, bottom: FA, left: dA, right: kA } = QA.current.getBoundingClientRect();
    bA.nativeEvent.type !== "touchend" && CA.pauseOnHover && bA.clientX >= dA && bA.clientX <= kA && bA.clientY >= RA && bA.clientY <= FA ? hA() : DA();
  }
  function DA() {
    AA(!0);
  }
  function hA() {
    AA(!1);
  }
  function wA() {
    EA.didMove = !1, document.addEventListener("pointermove", NA), document.addEventListener("pointerup", rA);
  }
  function sA() {
    document.removeEventListener("pointermove", NA), document.removeEventListener("pointerup", rA);
  }
  function NA(bA) {
    let RA = QA.current;
    if (EA.canDrag && RA) {
      EA.didMove = !0, gA && hA(), CA.draggableDirection === "x" ? EA.delta = bA.clientX - EA.start : EA.delta = bA.clientY - EA.start, EA.start !== bA.clientX && (EA.canCloseOnClick = !1);
      let FA = CA.draggableDirection === "x" ? `${EA.delta}px, var(--y)` : `0, calc(${EA.delta}px + var(--y))`;
      RA.style.transform = `translate3d(${FA},0)`, RA.style.opacity = `${1 - Math.abs(EA.delta / EA.removalDistance)}`;
    }
  }
  function rA() {
    sA();
    let bA = QA.current;
    if (EA.canDrag && EA.didMove && bA) {
      if (EA.canDrag = !1, Math.abs(EA.delta) > EA.removalDistance) {
        BA(!0), CA.closeToast(!0), CA.collapseAll();
        return;
      }
      bA.style.transition = "transform 0.2s, opacity 0.2s", bA.style.removeProperty("transform"), bA.style.removeProperty("opacity");
    }
  }
  let yA = { onPointerDown: lA, onPointerUp: nA };
  return iA && oA && (yA.onMouseEnter = hA, CA.stacked || (yA.onMouseLeave = DA)), eA && (yA.onClick = (bA) => {
    tA && tA(bA), EA.canCloseOnClick && cA(!0);
  }), { playToast: DA, pauseToast: hA, isRunning: gA, preventExitTransition: IA, toastRef: QA, eventHandlers: yA };
}
var Ot = typeof window < "u" ? useLayoutEffect$1 : useEffect, G = ({ theme: CA, type: gA, isLoading: AA, ...IA }) => React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: CA === "colored" ? "currentColor" : `var(--toastify-icon-color-${gA})`, ...IA });
function ao(CA) {
  return React__default.createElement(G, { ...CA }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function so(CA) {
  return React__default.createElement(G, { ...CA }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function no(CA) {
  return React__default.createElement(G, { ...CA }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function ro(CA) {
  return React__default.createElement(G, { ...CA }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function io() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
}
var W = { info: so, warning: ao, success: no, error: ro, spinner: io }, lo = (CA) => CA in W;
function Nt({ theme: CA, type: gA, isLoading: AA, icon: IA }) {
  let BA = null, QA = { theme: CA, type: gA };
  return IA === !1 || (P(IA) ? BA = IA({ ...QA, isLoading: AA }) : isValidElement(IA) ? BA = cloneElement(IA, QA) : AA ? BA = W.spinner() : lo(gA) && (BA = W[gA](QA))), BA;
}
var wt = (CA) => {
  let { isRunning: gA, preventExitTransition: AA, toastRef: IA, eventHandlers: BA, playToast: QA } = At(CA), { closeButton: EA, children: iA, autoClose: oA, onClick: cA, type: tA, hideProgressBar: eA, closeToast: aA, transition: GA, position: lA, className: nA, style: DA, progressClassName: hA, updateId: wA, role: sA, progress: NA, rtl: rA, toastId: yA, deleteToast: bA, isIn: RA, isLoading: FA, closeOnClick: dA, theme: kA, ariaLabel: pA } = CA, YA = clsx("Toastify__toast", `Toastify__toast-theme--${kA}`, `Toastify__toast--${tA}`, { "Toastify__toast--rtl": rA }, { "Toastify__toast--close-on-click": dA }), SA = P(nA) ? nA({ rtl: rA, position: lA, type: tA, defaultClassName: YA }) : clsx(YA, nA), JA = Nt(CA), UA = !!NA || !oA, fA = { closeToast: aA, type: tA, theme: kA }, zA = null;
  return EA === !1 || (P(EA) ? zA = EA(fA) : isValidElement(EA) ? zA = cloneElement(EA, fA) : zA = yt(fA)), React__default.createElement(GA, { isIn: RA, done: bA, position: lA, preventExitTransition: AA, nodeRef: IA, playToast: QA }, React__default.createElement("div", { id: yA, tabIndex: 0, onClick: cA, "data-in": RA, className: SA, ...BA, style: DA, ref: IA, ...RA && { role: sA, "aria-label": pA } }, JA != null && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !FA }) }, JA), tt(iA, CA, !gA), zA, !CA.customProgressBar && React__default.createElement(gt, { ...wA && !UA ? { key: `p-${wA}` } : {}, rtl: rA, theme: kA, delay: oA, isRunning: gA, isIn: RA, closeToast: aA, hide: eA, type: tA, className: hA, controlledProgress: UA, progress: NA || 0 })));
}, K = (CA, gA = !1) => ({ enter: `Toastify--animate Toastify__${CA}-enter`, exit: `Toastify--animate Toastify__${CA}-exit`, appendPosition: gA }), lt = $(K("bounce", !0)), mo = $(K("slide", !0)), _o = { position: "top-right", transition: lt, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (CA) => CA.altKey && CA.code === "KeyT" };
function Lt(CA) {
  let gA = { ..._o, ...CA }, AA = CA.stacked, [IA, BA] = useState(!0), QA = useRef(null), { getToastToRender: EA, isToastActive: iA, count: oA } = It(gA), { className: cA, style: tA, rtl: eA, containerId: aA, hotKeys: GA } = gA;
  function lA(DA) {
    let hA = clsx("Toastify__toast-container", `Toastify__toast-container--${DA}`, { "Toastify__toast-container--rtl": eA });
    return P(cA) ? cA({ position: DA, rtl: eA, defaultClassName: hA }) : clsx(hA, B(cA));
  }
  function nA() {
    AA && (BA(!0), y.play());
  }
  return Ot(() => {
    var DA;
    if (AA) {
      let hA = QA.current.querySelectorAll('[data-in="true"]'), wA = 12, sA = (DA = gA.position) == null ? void 0 : DA.includes("top"), NA = 0, rA = 0;
      Array.from(hA).reverse().forEach((yA, bA) => {
        let RA = yA;
        RA.classList.add("Toastify__toast--stacked"), bA > 0 && (RA.dataset.collapsed = `${IA}`), RA.dataset.pos || (RA.dataset.pos = sA ? "top" : "bot");
        let FA = NA * (IA ? 0.2 : 1) + (IA ? 0 : wA * bA);
        RA.style.setProperty("--y", `${sA ? FA : FA * -1}px`), RA.style.setProperty("--g", `${wA}`), RA.style.setProperty("--s", `${1 - (IA ? rA : 0)}`), NA += RA.offsetHeight, rA += 0.025;
      });
    }
  }, [IA, oA, AA]), useEffect(() => {
    function DA(hA) {
      var wA;
      let sA = QA.current;
      GA(hA) && ((wA = sA.querySelector('[tabIndex="0"]')) == null || wA.focus(), BA(!1), y.pause()), hA.key === "Escape" && (document.activeElement === sA || sA != null && sA.contains(document.activeElement)) && (BA(!0), y.play());
    }
    return document.addEventListener("keydown", DA), () => {
      document.removeEventListener("keydown", DA);
    };
  }, [GA]), React__default.createElement("section", { ref: QA, className: "Toastify", id: aA, onMouseEnter: () => {
    AA && (BA(!1), y.pause());
  }, onMouseLeave: nA, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": gA["aria-label"] }, EA((DA, hA) => {
    let wA = hA.length ? { ...tA } : { ...tA, pointerEvents: "none" };
    return React__default.createElement("div", { tabIndex: -1, className: lA(DA), "data-stacked": AA, style: wA, key: `c-${DA}` }, hA.map(({ content: sA, props: NA }) => React__default.createElement(wt, { ...NA, stacked: AA, collapseAll: nA, isIn: iA(NA.toastId, NA.containerId), key: `t-${NA.key}` }, sA)));
  }));
}
function ErrorToastContent(CA) {
  const gA = CA;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: gA.message }),
    gA.error && /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: {
      width: "100%",
      padding: 0,
      overflow: "scroll",
      maxHeight: 300
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("code", { style: {
      padding: "16px"
    }, children: gA.error.message }) })
  ] });
}
function stliteStyledPromiseToast(CA, gA, AA) {
  const IA = gA.error;
  return y.promise(CA, {
    pending: gA.pending,
    success: gA.success,
    error: typeof IA == "string" ? {
      render({
        data: BA
      }) {
        return BA ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: IA, error: BA }) : IA;
      },
      autoClose: !1,
      closeOnClick: !1
    } : IA
  }, {
    hideProgressBar: !0,
    position: "bottom-right",
    ...AA
  });
}
function makeToastKernelEventListeners(CA) {
  let gA = null;
  const AA = [];
  return {
    onLoadProgress: (GA) => {
      const lA = y(GA.detail, {
        position: "bottom-right",
        transition: mo,
        isLoading: !0,
        hideProgressBar: !0,
        closeButton: !1,
        containerId: CA
      });
      AA.push(lA), gA && y.update(gA, {
        isLoading: !1,
        autoClose: 3e3
      }), gA = lA;
    },
    onLoadFinished: () => {
      AA.forEach((GA) => y.dismiss(GA));
    },
    onLoadError: (GA) => {
      y(/* @__PURE__ */ jsxRuntimeExports.jsx(ErrorToastContent, { message: "Error during booting up", error: GA.detail }), {
        position: "bottom-right",
        type: "error",
        autoClose: !1,
        closeOnClick: !1,
        containerId: CA
      });
    },
    onModuleAutoLoad: (GA) => {
      const {
        promise: lA
      } = GA.detail;
      stliteStyledPromiseToast(lA, {
        success: {
          render({
            data: nA
          }) {
            return `Auto-loaded${nA ? ": " + nA.map((DA) => DA.name).join(", ") : " packages"}`;
          }
        },
        error: "Failed to auto-load packages",
        pending: "Auto-loading packages"
      }, {
        containerId: CA
      });
    },
    onInstall: (GA) => {
      const {
        requirements: lA,
        promise: nA
      } = GA.detail;
      stliteStyledPromiseToast(nA, {
        pending: "Installing",
        success: `Successfully installed: ${lA.join(", ")}`,
        error: `Failed to install: ${lA.join(", ")}`
      }, {
        containerId: CA
      });
    },
    onWriteFile: (GA) => {
      const {
        path: lA,
        promise: nA
      } = GA.detail;
      stliteStyledPromiseToast(nA, {
        error: `Failed to write file: ${lA}`
      }, {
        containerId: CA
      });
    },
    onRenameFile: (GA) => {
      const {
        oldPath: lA,
        newPath: nA,
        promise: DA
      } = GA.detail;
      stliteStyledPromiseToast(DA, {
        error: `Failed to rename file from ${lA} to ${nA}`
      }, {
        containerId: CA
      });
    },
    onUnlink: (GA) => {
      const {
        path: lA,
        promise: nA
      } = GA.detail;
      stliteStyledPromiseToast(nA, {
        error: `Failed to unlink: ${lA}`
      }, {
        containerId: CA
      });
    },
    onReadFile: (GA) => {
      const {
        path: lA,
        promise: nA
      } = GA.detail;
      stliteStyledPromiseToast(nA, {
        error: `Failed to read file: ${lA}`
      }, {
        containerId: CA
      });
    },
    onReboot: (GA) => {
      const {
        promise: lA
      } = GA.detail;
      stliteStyledPromiseToast(lA, {
        pending: "Rebooting",
        success: "Successfully rebooted",
        error: "Failed to reboot"
      }, {
        containerId: CA
      });
    }
  };
}
function isDarkTheme() {
  const CA = getDefaultTheme().name;
  return CA === AUTO_THEME_NAME ? window.matchMedia("(prefers-color-scheme: dark)").matches : CA === darkTheme.name;
}
function ToastContainer({
  toastContainerId: CA
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Lt, { containerId: CA, style: {
    zIndex: 999999,
    position: "absolute",
    overflow: "hidden"
  }, theme: isDarkTheme() ? "dark" : "light" });
}
function StliteAppWithToast(CA) {
  const {
    kernel: gA,
    disableProgressToasts: AA,
    disableErrorToasts: IA,
    disableModuleAutoLoadToasts: BA
  } = CA, QA = useId(), {
    onLoadProgress: EA,
    onLoadFinished: iA,
    onLoadError: oA,
    onModuleAutoLoad: cA,
    onInstall: tA,
    onWriteFile: eA,
    onRenameFile: aA,
    onUnlink: GA,
    onReadFile: lA,
    onReboot: nA
  } = useMemo$1(() => makeToastKernelEventListeners(QA), [QA]);
  return useEffect(() => {
    if (!AA)
      return gA.addEventListener("loadProgress", EA), gA.addEventListener("loadFinished", iA), () => {
        gA.removeEventListener("loadProgress", EA), gA.removeEventListener("loadFinished", iA);
      };
  }, [gA, AA, EA, iA]), useEffect(() => {
    if (!IA)
      return gA.addEventListener("loadError", oA), () => {
        gA.removeEventListener("loadError", oA);
      };
  }, [gA, IA, oA]), useEffect(() => {
    if (!BA)
      return gA.addEventListener("moduleAutoLoad", cA), () => {
        gA.removeEventListener("moduleAutoLoad", cA);
      };
  }, [gA, BA, cA]), useEffect(() => (gA.addEventListener("install", tA), gA.addEventListener("writeFile", eA), gA.addEventListener("renameFile", aA), gA.addEventListener("unlink", GA), gA.addEventListener("readFile", lA), gA.addEventListener("reboot", nA), () => {
    gA.removeEventListener("install", tA), gA.removeEventListener("writeFile", eA), gA.removeEventListener("renameFile", aA), gA.removeEventListener("unlink", GA), gA.removeEventListener("readFile", lA), gA.removeEventListener("reboot", nA);
  }), [gA, tA, eA, aA, GA, lA, nA]), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StliteApp, { kernel: gA, styleNonce: CA.styleNonce, disableDocumentStyles: CA.disableDocumentStyles }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, { toastContainerId: QA })
  ] });
}
class PromiseDelegate {
  promise;
  resolveInternal;
  rejectInternal;
  constructor() {
    this.promise = new Promise((gA, AA) => {
      this.resolveInternal = gA, this.rejectInternal = AA;
    });
  }
  resolve(gA) {
    this.resolveInternal(gA);
  }
  reject(gA) {
    this.rejectInternal(gA);
  }
}
const workerBlobUrlCache = /* @__PURE__ */ new Map();
function getWorkerBlobUrl(CA, gA = !1) {
  const AA = CA.toString(), IA = `${gA ? "module" : "classic"}:${AA}`, BA = workerBlobUrlCache.get(IA);
  if (BA)
    return console.debug(`Using a cached worker blob URL for ${AA}`), BA;
  const QA = gA ? `import "${AA}";` : `importScripts("${AA}");`, EA = new Blob([QA], {
    type: gA ? "text/javascript;type=module" : "text/javascript"
  }), iA = URL.createObjectURL(EA);
  return workerBlobUrlCache.set(IA, iA), iA;
}
function isOpaqueOrigin() {
  return window.location.protocol === "file:" || window.location.origin === "null";
}
function isSameOrigin(CA) {
  return isOpaqueOrigin() ? !1 : CA.origin === window.location.origin;
}
function createWorker(CA, gA, AA) {
  return gA ? isOpaqueOrigin() ? (console.warn("SharedWorker is not supported on opaque origins (e.g. file:// protocol). Falling back to a regular Worker."), new Worker(CA, AA)) : typeof window.SharedWorker < "u" ? (console.debug("Using SharedWorker. Visit chrome://inspect/#workers (Chrome) or about:debugging#/runtime/this-firefox (Firefox) to see the console output of the worker."), new SharedWorker(CA, AA)) : (console.warn("SharedWorker is not supported in this browser. Falling back to a regular Worker."), new Worker(CA, AA)) : new Worker(CA, AA);
}
class CrossOriginWorkerMaker {
  worker;
  constructor(gA, {
    shared: AA,
    ...IA
  }) {
    if (isSameOrigin(gA))
      console.debug(`Loading a worker script from the same origin: ${gA}`), this.worker = createWorker(gA, AA, IA);
    else {
      console.debug(`Loading a worker script via blob URL wrapper: ${gA.protocol === "data:" ? "data: URL" : gA}`);
      const QA = getWorkerBlobUrl(gA, IA.type === "module");
      this.worker = createWorker(QA, AA, IA);
    }
  }
}
const LEADING_AND_TRAILING_SLASH_RE = new RegExp("^\\/+|(?<!\\/)\\/+$", "g");
function normalizeBasePath(CA) {
  return CA.replace(LEADING_AND_TRAILING_SLASH_RE, "");
}
function isPyodideConvertiblePrimitive(CA) {
  return typeof CA == "string" || typeof CA == "number" || typeof CA == "boolean" || CA === null || CA === void 0;
}
function isStreamlitConfig(CA) {
  return typeof CA == "object" && CA != null && Object.entries(CA).every(([gA, AA]) => typeof gA == "string" && isPyodideConvertiblePrimitive(AA));
}
function assertStreamlitConfig(CA) {
  if (!isStreamlitConfig(CA))
    throw new Error(`Invalid streamlitConfig: ${CA}`);
}
const validateEnvKey = (CA) => /^[A-Za-z_][A-Za-z0-9_]*$/.test(CA);
function isSharedWorker(CA) {
  return typeof window.SharedWorker < "u" && CA instanceof SharedWorker;
}
class StliteKernel extends EventTarget {
  /**
   * Made public for advanced use cases as an unstable API.
   * You can use it but there is no stability guarantee for future releases.
   */
  _worker;
  _isDisposed = !1;
  _postMessageTarget;
  _loaded = new PromiseDelegate();
  _workerInitData;
  basePath;
  // TODO: Move this prop to outside this class. This is not a member of the kernel business logic, but just a globally referred value.
  hostConfigProperties;
  // Will be passed to ConnectionManager to call `onHostConfigResp` from it.
  addEventListener(gA, AA, IA) {
    super.addEventListener(gA, AA, IA);
  }
  removeEventListener(gA, AA, IA) {
    super.removeEventListener(gA, AA, IA);
  }
  dispatchEvent(gA) {
    return super.dispatchEvent(gA);
  }
  constructor(gA) {
    if (super(), this.basePath = normalizeBasePath(gA.basePath ?? window.location.pathname), this.hostConfigProperties = gA.hostConfigProperties ?? {}, gA.worker)
      this._worker = gA.worker;
    else {
      const AA = new CrossOriginWorkerMaker(new URL(
        /* @vite-ignore */
        "" + new URL("assets/worker-DSGzx9v2.js", import.meta.url).href,
        import.meta.url
      ), {
        /* @vite-ignore */
        // To avoid the Vite error: "[vite:worker-import-meta-url] Vite is unable to parse the worker options as the value is not static.To ignore this error, please use /* @vite-ignore */ in the worker options."
        type: gA.workerType,
        shared: gA.sharedWorker ?? !1
      });
      this._worker = AA.worker;
    }
    isSharedWorker(this._worker) ? (this._worker.port.start(), this._postMessageTarget = this._worker.port) : this._postMessageTarget = this._worker, this._postMessageTarget.onmessage = (AA) => {
      this._processWorkerMessage(AA.data, AA.ports[0]);
    }, gA.streamlitConfig != null && assertStreamlitConfig(gA.streamlitConfig), this._workerInitData = {
      entrypoint: gA.entrypoint,
      files: gA.files,
      archives: gA.archives,
      requirements: gA.requirements,
      prebuiltPackageNames: gA.prebuiltPackageNames,
      pyodideUrl: gA.pyodideUrl,
      wheels: gA.wheelUrls,
      streamlitConfig: gA.streamlitConfig,
      idbfsMountpoints: gA.idbfsMountpoints,
      moduleAutoLoad: gA.moduleAutoLoad ?? !1,
      env: gA.env,
      languageServer: gA.languageServer ?? !1
    };
  }
  get loaded() {
    return this._loaded.promise;
  }
  connectWebSocket(gA) {
    return this._asyncPostMessage({
      type: "websocket:connect",
      data: {
        path: gA
      }
    }).then();
  }
  sendWebSocketMessage(gA) {
    return this._asyncPostMessage({
      type: "websocket:send",
      data: {
        payload: gA
      }
    }).then();
  }
  handleWebSocketMessage = null;
  onWebSocketMessage(gA) {
    this.handleWebSocketMessage = gA;
  }
  sendHttpRequest(gA, AA) {
    return this._asyncPostMessage({
      type: "http:request",
      data: {
        request: gA
      }
    }, "http:response", AA).then((IA) => ({
      ...IA.response,
      headers: new Headers(Object.fromEntries(IA.response.headers))
    }));
  }
  async writeFile(gA, AA, IA) {
    await this.loaded;
    const BA = this._asyncPostMessage({
      type: "file:write",
      data: {
        path: gA,
        data: AA,
        opts: IA
      }
    });
    this.dispatchEvent(new CustomEvent("writeFile", {
      detail: {
        path: gA,
        promise: BA
      }
    })), await BA;
  }
  async renameFile(gA, AA) {
    await this.loaded;
    const IA = this._asyncPostMessage({
      type: "file:rename",
      data: {
        oldPath: gA,
        newPath: AA
      }
    });
    this.dispatchEvent(new CustomEvent("renameFile", {
      detail: {
        oldPath: gA,
        newPath: AA,
        promise: IA
      }
    })), await IA;
  }
  async readFile(gA, AA) {
    await this.loaded;
    const IA = this._asyncPostMessage({
      type: "file:read",
      data: {
        path: gA,
        opts: AA
      }
    }, "reply:file:read").then((BA) => BA.content);
    return this.dispatchEvent(new CustomEvent("readFile", {
      detail: {
        path: gA,
        promise: IA
      }
    })), IA;
  }
  async unlink(gA) {
    await this.loaded, await this._asyncPostMessage({
      type: "file:unlink",
      data: {
        path: gA
      }
    });
  }
  async install(gA, AA) {
    await this.loaded;
    const IA = this._asyncPostMessage({
      type: "install",
      data: {
        requirements: gA,
        options: AA
      }
    });
    this.dispatchEvent(new CustomEvent("install", {
      detail: {
        requirements: gA,
        promise: IA
      }
    })), await IA;
  }
  async addMockPackage(gA, AA, IA, BA) {
    await this.loaded, await this._asyncPostMessage({
      type: "add_mock_package",
      data: {
        name: gA,
        version: AA,
        modules: IA,
        persistent: BA
      }
    });
  }
  async setEnv(gA) {
    Object.keys(gA).forEach((AA) => {
      if (!validateEnvKey(AA))
        throw new Error(`Invalid environment variable name: "${AA}"`);
    }), await this.loaded, await this._asyncPostMessage({
      type: "setEnv",
      data: {
        env: gA
      }
    });
  }
  async getCodeCompletion(gA, AA) {
    if (!this._workerInitData.languageServer)
      throw new Error("Language server not loaded, please set languageServer=true to use this method");
    return await this.loaded, this._asyncPostMessage({
      type: "code_completion",
      data: {
        code: gA,
        line: AA.line,
        column: AA.column
      }
    }, "reply:code_completion").then((IA) => IA.codeCompletions);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async runPython(gA) {
    return await this.loaded, this.loaded.then(() => this._asyncPostMessage({
      type: "run_python",
      data: {
        code: gA
      }
    }, "reply:run_python")).then((AA) => AA.result);
  }
  /**
   * Reboot the Streamlit server.
   * Note that we also need to refresh (rerender) the frontend app after calling this method
   * to reflect the changes on the user-facing side.
   */
  async reboot(gA) {
    await this.loaded, await this._asyncPostMessage({
      type: "reboot",
      data: {
        entrypoint: gA
      }
    });
  }
  _asyncPostMessage(gA, AA, IA) {
    let BA = "reply", QA;
    return typeof AA == "string" ? (BA = AA, QA = IA) : AA && (QA = AA), QA && QA.aborted ? Promise.reject(new DOMException("Aborted", "AbortError")) : new Promise((EA, iA) => {
      const oA = new MessageChannel(), cA = () => {
        oA.port1.close(), iA(new DOMException("Aborted", "AbortError"));
      };
      QA && QA.addEventListener("abort", cA, {
        once: !0
      }), oA.port1.onmessage = (tA) => {
        QA && QA.removeEventListener("abort", cA), oA.port1.close();
        const eA = tA.data;
        if (eA.error)
          iA(eA.error);
        else {
          if (eA.type !== BA)
            throw new Error(`Unexpected reply type "${eA.type}"`);
          EA(eA.data);
        }
      }, this._postMessageTarget.postMessage(gA, [oA.port2]);
    });
  }
  /**
   * Process a message coming from the pyodide web worker.
   *
   * @param msg The worker message to process.
   */
  _processWorkerMessage(gA, AA) {
    switch (gA.type) {
      case "event:envSetup": {
        this._postMessageTarget.postMessage({
          type: "initData",
          data: this._workerInitData
        });
        break;
      }
      case "event:loadProgress": {
        this.dispatchEvent(new CustomEvent("loadProgress", {
          detail: gA.data.message
        }));
        break;
      }
      case "event:loadError": {
        this.dispatchEvent(new CustomEvent("loadError", {
          detail: gA.data.error
        }));
        break;
      }
      case "event:loadFinished": {
        this._loaded.resolve(), this.dispatchEvent(new Event("loadFinished"));
        break;
      }
      case "websocket:message": {
        const {
          payload: IA
        } = gA.data;
        this.handleWebSocketMessage?.(IA);
        break;
      }
      case "event:moduleAutoLoad": {
        if (AA == null)
          throw new Error("Port is required for moduleAutoLoad event");
        const IA = new Promise((BA, QA) => {
          AA.onmessage = (EA) => {
            const iA = EA.data;
            iA.type === "moduleAutoLoad:success" ? BA(iA.data.loadedPackages) : QA(iA.error), AA.close();
          };
        });
        this.dispatchEvent(new CustomEvent("moduleAutoLoad", {
          detail: {
            packagesToLoad: gA.data.packagesToLoad,
            promise: IA
          }
        }));
        break;
      }
    }
  }
  /**
   * Return whether the kernel is disposed.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose the kernel.
   */
  dispose() {
    this.isDisposed || (isSharedWorker(this._worker) ? this._worker.port.close() : this._worker.terminate(), this._isDisposed = !0);
  }
}
function createKernel(CA) {
  return new StliteKernel({
    ...CA,
    workerType: CA.workerType ?? "module"
    // Default value is "module" because Vite loads the worker scripts as ES modules without bundling at dev time, so we need to specify the type as "module" for the "import" statements in the worker script to work.
  });
}
function useKernel(CA) {
  const [gA, AA] = useState(null);
  return useEffect(() => {
    const IA = createKernel(CA);
    return AA(IA), () => {
      IA.dispose();
    };
  }, []), gA;
}
export {
  Global as $,
  StreamlitMarkdown$1 as A,
  streamlit as B,
  CodeBlockCopyToolbar$1 as C,
  DataFrameCellType as D,
  EmotionIconBase as E,
  Dataframe as F,
  isNamedColor as G,
  resolveNamedColor as H,
  useEmotionTheme as I,
  isDatetimeType as J,
  isDateType as K,
  getTimezone as L,
  debounce$1 as M,
  notNullOrUndefined as N,
  isEqual as O,
  loglevelExports as P,
  useFormClearHelper as Q,
  useRequiredContext as R,
  StyledCodeBlock as S,
  Table$3 as T,
  useCalculatedDimensions as U,
  shouldWidthStretch as V,
  shouldHeightStretch as W,
  ToolbarAction as X,
  StyledToolbarElementContainer as Y,
  Toolbar as Z,
  _extends$m as _,
  StyledPre as a,
  isArguments as a$,
  useStliteMediaObjectUrl as a0,
  useCrossOriginAttribute as a1,
  keyframes as a2,
  getCrossOriginAttribute as a3,
  _defineProperty$j as a4,
  propTypesExports as a5,
  index as a6,
  hasLightBackgroundColor as a7,
  useExecuteWhenChanged as a8,
  parseToRgba as a9,
  mergeWith as aA,
  merge$1 as aB,
  NavigationContext as aC,
  requirePropTypes as aD,
  getIncreasingGreen as aE,
  getDecreasingRed as aF,
  getBlue80 as aG,
  getGray90 as aH,
  keysToSnakeCase as aI,
  PlotlyChart$1 as aJ,
  useTimeout as aK,
  FormClearHelper as aL,
  PortalContext as aM,
  classNames as aN,
  toaster as aO,
  AlertElement$1 as aP,
  Kind as aQ,
  Video$1 as aR,
  zip$1 as aS,
  FileUploaderState as aT,
  UploadedFileInfo as aU,
  BaseButton as aV,
  useWidgetManagerElementState as aW,
  isArrayLike as aX,
  isArray$1 as aY,
  isBuffer as aZ,
  isTypedArray as a_,
  LibConfigContext as aa,
  assertNever as ab,
  DeckGlJsonChart$1 as ac,
  useStliteMediaObjects as ad,
  useCopyToClipboard as ae,
  Popover$2 as af,
  ACCESSIBILITY_TYPE as ag,
  PLACEMENT as ah,
  DynamicIcon as ai,
  ErrorElement as aj,
  ensureError as ak,
  darken as al,
  BaseButtonSize as am,
  BaseButtonKind as an,
  useRegisterShortcut as ao,
  Box as ap,
  BaseButtonTooltip as aq,
  DynamicButtonLabel as ar,
  Metric$1 as as,
  transparentize as at,
  LabelVisibilityOptions as au,
  Placement as av,
  labelVisibilityProtoValueToEnum as aw,
  Icon$2 as ax,
  getGray70 as ay,
  getGray30 as az,
  SKIP as b,
  isListType as b$,
  getTag as b0,
  isPrototype as b1,
  baseKeys as b2,
  isPropValid as b3,
  requireClassnames as b4,
  toString$3 as b5,
  Vector as b6,
  getLuminance as b7,
  genericFonts as b8,
  _objectWithoutProperties$3 as b9,
  slice as bA,
  position$3 as bB,
  compile as bC,
  getRegisteredStyles as bD,
  serializeStyles as bE,
  registerStyles as bF,
  insertStyles as bG,
  _typeof$a as bH,
  isMaterialIcon as bI,
  parseIconPackEntry as bJ,
  resolveNamedBackgroundColor as bK,
  blend as bL,
  isUnsignedIntegerType as bM,
  isIntegerType as bN,
  isDurationType as bO,
  isPeriodType as bP,
  isBooleanType as bQ,
  Field as bR,
  Null as bS,
  isTimeType as bT,
  isDecimalType as bU,
  isRangeIndexType as bV,
  isStringType as bW,
  isEmptyType as bX,
  isObjectType as bY,
  isBytesType as bZ,
  isCategoricalType as b_,
  stringify$3 as ba,
  COMMENT as bb,
  rulesheet as bc,
  middleware as bd,
  RULESET as be,
  combine as bf,
  KEYFRAMES as bg,
  serialize$2 as bh,
  copy as bi,
  replace$1 as bj,
  DECLARATION as bk,
  dealloc as bl,
  alloc as bm,
  hash$1 as bn,
  charat as bo,
  WEBKIT as bp,
  MS as bq,
  strlen as br,
  indexof as bs,
  MOZ as bt,
  match as bu,
  next as bv,
  token$1 as bw,
  from as bx,
  peek$1 as by,
  delimit as bz,
  convert as c,
  isFromMac as c$,
  fontSizes as c0,
  lighten as c1,
  mix as c2,
  TRIGGER_TYPE as c3,
  getPopoverContainerStyle as c4,
  useScrollbarGutterSize as c5,
  StyledTooltipContentWrapper as c6,
  FlexContext as c7,
  Resizable as c8,
  baseSlice as c9,
  getOverrideProps as cA,
  toPropertyKey$2 as cB,
  _setPrototypeOf$9 as cC,
  TooltipIcon as cD,
  getHelpTooltipAriaLabel as cE,
  hexToRgb as cF,
  withWrapper as cG,
  getOverrides as cH,
  mergeOverrides as cI,
  LocaleContext as cJ,
  StyledButtonGroup as cK,
  LabelVisibility as cL,
  ButtonGroup$1 as cM,
  toExportedTheme as cN,
  ArrowDataframe as cO,
  Skeleton as cP,
  Skeleton$1 as cQ,
  CustomComponentIFrame as cR,
  queryString as cS,
  Tooltip$1 as cT,
  themeColors as cU,
  isMobile as cV,
  AcceptFileValue as cW,
  chatInputAcceptFileProtoValueToEnum as cX,
  __awaiter as cY,
  PropTypes as cZ,
  isFromWindows as c_,
  baseToString as ca,
  trimmedEndIndex as cb,
  util_bn_ as cc,
  util_int_ as cd,
  util_bit_ as ce,
  util_math_ as cf,
  util_buffer_ as cg,
  util_vector_ as ch,
  util_pretty_ as ci,
  util_interval_ as cj,
  compareTypes as ck,
  compareFields as cl,
  compareSchemas as cm,
  getAugmentedNamespace as cn,
  isIntervalType as co,
  isFloatType as cp,
  TimeUnit as cq,
  Struct as cr,
  commonjsGlobal as cs,
  ViewStateContext as ct,
  useWindowDimensionsContext as cu,
  hoistNonReactStatics as cv,
  StreamlitConfig as cw,
  styled as cx,
  isFocusVisible as cy,
  getOverride as cz,
  stringify$2 as d,
  useStyletron as d0,
  mergeOverride as d1,
  toObjectOverride as d2,
  Icon$1 as d3,
  forkBlur as d4,
  forkFocus as d5,
  StyledCheckbox as d6,
  StyledContent as d7,
  Checkbox$1 as d8,
  StatefulPopover as d9,
  identity as dA,
  baseUnary as dB,
  baseIteratee as dC,
  isIterateeCall as dD,
  baseFlatten as dE,
  _inheritsLoose as dF,
  StyledWrapper as dG,
  StyledEllipsizedDiv as dH,
  getSelectPlaceholder as dI,
  extractLeadingMaterialIcon as dJ,
  NumberInput$1 as dK,
  isInForm as dL,
  addCssUnit as dM,
  arrayComparator as dN,
  pick$1 as dO,
  Slider$1 as dP,
  TextInput$1 as dQ,
  require$$0$3 as dR,
  requireOverrides as dS,
  tableFromIPC as dT,
  v4 as dU,
  StliteApp as dV,
  StliteAppWithToast as dW,
  createKernel as dX,
  useKernel as dY,
  IsSidebarContext as da,
  getBorderColor as db,
  requireBrowser as dc,
  UIDConsumer as dd,
  ThemeContext$1 as de,
  ellipsisText as df,
  withStyle as dg,
  StyledSpinner as dh,
  colors$3 as di,
  DeleteIcon as dj,
  useUIDSeed as dk,
  useStliteKernel as dl,
  DownloadContext as dm,
  StyledErrorMessage as dn,
  Feedback$1 as dp,
  FormsContext as dq,
  StyledFormSubmitContent as dr,
  SetCache as ds,
  cacheHas as dt,
  baseRest as du,
  isArrayLikeObject as dv,
  baseEach as dw,
  isSymbol as dx,
  arrayMap as dy,
  baseGet as dz,
  stringify$1 as e,
  find$1 as f,
  getDefaultExportFromCjs as g,
  html$2 as h,
  isNullOrUndefined$1 as i,
  jsxRuntimeExports as j,
  pointStart as k,
  pointEnd as l,
  structuredClone$1 as m,
  parse$2 as n,
  ok as o,
  parseEntities as p,
  parse$3 as q,
  normalize$1 as r,
  svg as s,
  findAndReplace as t,
  createStyled as u,
  visitParents as v,
  StyledStreamlitMarkdown as w,
  range$1 as x,
  convertRemToPx as y,
  isNumericType as z
};
//# sourceMappingURL=index-DQq-Ft_o.js.map
